var $parcel$global =
typeof globalThis !== 'undefined'
  ? globalThis
  : typeof self !== 'undefined'
  ? self
  : typeof window !== 'undefined'
  ? window
  : typeof global !== 'undefined'
  ? global
  : {};
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequirefade"];
if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequirefade"] = parcelRequire;
}
parcelRequire.register("5LCsG", function(module, exports) {
(function() {
    /** Used as a safe reference for `undefined` in pre-ES5 environments. */ var undefined;
    /** Used as the semantic version number. */ var VERSION = "4.17.21";
    /** Used as the size to enable large array optimizations. */ var LARGE_ARRAY_SIZE = 200;
    /** Error message constants. */ var CORE_ERROR_TEXT = "Unsupported core-js use. Try https://npms.io/search?q=ponyfill.", FUNC_ERROR_TEXT = "Expected a function", INVALID_TEMPL_VAR_ERROR_TEXT = "Invalid `variable` option passed into `_.template`";
    /** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = "__lodash_hash_undefined__";
    /** Used as the maximum memoize cache size. */ var MAX_MEMOIZE_SIZE = 500;
    /** Used as the internal argument placeholder. */ var PLACEHOLDER = "__lodash_placeholder__";
    /** Used to compose bitmasks for cloning. */ var CLONE_DEEP_FLAG = 1, CLONE_FLAT_FLAG = 2, CLONE_SYMBOLS_FLAG = 4;
    /** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
    /** Used to compose bitmasks for function metadata. */ var WRAP_BIND_FLAG = 1, WRAP_BIND_KEY_FLAG = 2, WRAP_CURRY_BOUND_FLAG = 4, WRAP_CURRY_FLAG = 8, WRAP_CURRY_RIGHT_FLAG = 16, WRAP_PARTIAL_FLAG = 32, WRAP_PARTIAL_RIGHT_FLAG = 64, WRAP_ARY_FLAG = 128, WRAP_REARG_FLAG = 256, WRAP_FLIP_FLAG = 512;
    /** Used as default options for `_.truncate`. */ var DEFAULT_TRUNC_LENGTH = 30, DEFAULT_TRUNC_OMISSION = "...";
    /** Used to detect hot functions by number of calls within a span of milliseconds. */ var HOT_COUNT = 800, HOT_SPAN = 16;
    /** Used to indicate the type of lazy iteratees. */ var LAZY_FILTER_FLAG = 1, LAZY_MAP_FLAG = 2, LAZY_WHILE_FLAG = 3;
    /** Used as references for various `Number` constants. */ var INFINITY = 1 / 0, MAX_SAFE_INTEGER = 9007199254740991, MAX_INTEGER = 1.7976931348623157e+308, NAN = 0 / 0;
    /** Used as references for the maximum length and index of an array. */ var MAX_ARRAY_LENGTH = 4294967295, MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1, HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;
    /** Used to associate wrap methods with their bit flags. */ var wrapFlags = [
        [
            "ary",
            WRAP_ARY_FLAG
        ],
        [
            "bind",
            WRAP_BIND_FLAG
        ],
        [
            "bindKey",
            WRAP_BIND_KEY_FLAG
        ],
        [
            "curry",
            WRAP_CURRY_FLAG
        ],
        [
            "curryRight",
            WRAP_CURRY_RIGHT_FLAG
        ],
        [
            "flip",
            WRAP_FLIP_FLAG
        ],
        [
            "partial",
            WRAP_PARTIAL_FLAG
        ],
        [
            "partialRight",
            WRAP_PARTIAL_RIGHT_FLAG
        ],
        [
            "rearg",
            WRAP_REARG_FLAG
        ]
    ];
    /** `Object#toString` result references. */ var argsTag = "[object Arguments]", arrayTag = "[object Array]", asyncTag = "[object AsyncFunction]", boolTag = "[object Boolean]", dateTag = "[object Date]", domExcTag = "[object DOMException]", errorTag = "[object Error]", funcTag = "[object Function]", genTag = "[object GeneratorFunction]", mapTag = "[object Map]", numberTag = "[object Number]", nullTag = "[object Null]", objectTag = "[object Object]", promiseTag = "[object Promise]", proxyTag = "[object Proxy]", regexpTag = "[object RegExp]", setTag = "[object Set]", stringTag = "[object String]", symbolTag = "[object Symbol]", undefinedTag = "[object Undefined]", weakMapTag = "[object WeakMap]", weakSetTag = "[object WeakSet]";
    var arrayBufferTag = "[object ArrayBuffer]", dataViewTag = "[object DataView]", float32Tag = "[object Float32Array]", float64Tag = "[object Float64Array]", int8Tag = "[object Int8Array]", int16Tag = "[object Int16Array]", int32Tag = "[object Int32Array]", uint8Tag = "[object Uint8Array]", uint8ClampedTag = "[object Uint8ClampedArray]", uint16Tag = "[object Uint16Array]", uint32Tag = "[object Uint32Array]";
    /** Used to match empty string literals in compiled template source. */ var reEmptyStringLeading = /\b__p \+= '';/g, reEmptyStringMiddle = /\b(__p \+=) '' \+/g, reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;
    /** Used to match HTML entities and HTML characters. */ var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g, reUnescapedHtml = /[&<>"']/g, reHasEscapedHtml = RegExp(reEscapedHtml.source), reHasUnescapedHtml = RegExp(reUnescapedHtml.source);
    /** Used to match template delimiters. */ var reEscape = /<%-([\s\S]+?)%>/g, reEvaluate = /<%([\s\S]+?)%>/g, reInterpolate = /<%=([\s\S]+?)%>/g;
    /** Used to match property names within property paths. */ var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, reIsPlainProp = /^\w*$/, rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
    /**
   * Used to match `RegExp`
   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
   */ var reRegExpChar = /[\\^$.*+?()[\]{}|]/g, reHasRegExpChar = RegExp(reRegExpChar.source);
    /** Used to match leading whitespace. */ var reTrimStart = /^\s+/;
    /** Used to match a single whitespace character. */ var reWhitespace = /\s/;
    /** Used to match wrap detail comments. */ var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/, reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/, reSplitDetails = /,? & /;
    /** Used to match words composed of alphanumeric characters. */ var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
    /**
   * Used to validate the `validate` option in `_.template` variable.
   *
   * Forbids characters which could potentially change the meaning of the function argument definition:
   * - "()," (modification of function parameters)
   * - "=" (default value)
   * - "[]{}" (destructuring of function parameters)
   * - "/" (beginning of a comment)
   * - whitespace
   */ var reForbiddenIdentifierChars = /[()=,{}\[\]\/\s]/;
    /** Used to match backslashes in property paths. */ var reEscapeChar = /\\(\\)?/g;
    /**
   * Used to match
   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
   */ var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;
    /** Used to match `RegExp` flags from their coerced string values. */ var reFlags = /\w*$/;
    /** Used to detect bad signed hexadecimal string values. */ var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
    /** Used to detect binary string values. */ var reIsBinary = /^0b[01]+$/i;
    /** Used to detect host constructors (Safari). */ var reIsHostCtor = /^\[object .+?Constructor\]$/;
    /** Used to detect octal string values. */ var reIsOctal = /^0o[0-7]+$/i;
    /** Used to detect unsigned integer values. */ var reIsUint = /^(?:0|[1-9]\d*)$/;
    /** Used to match Latin Unicode letters (excluding mathematical operators). */ var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
    /** Used to ensure capturing order of template delimiters. */ var reNoMatch = /($^)/;
    /** Used to match unescaped characters in compiled string literals. */ var reUnescapedString = /['\n\r\u2028\u2029\\]/g;
    /** Used to compose unicode character classes. */ var rsAstralRange = "\ud800-\udfff", rsComboMarksRange = "\\u0300-\\u036f", reComboHalfMarksRange = "\\ufe20-\\ufe2f", rsComboSymbolsRange = "\\u20d0-\\u20ff", rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange, rsDingbatRange = "\\u2700-\\u27bf", rsLowerRange = "a-z\\xdf-\\xf6\\xf8-\\xff", rsMathOpRange = "\\xac\\xb1\\xd7\\xf7", rsNonCharRange = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf", rsPunctuationRange = "\\u2000-\\u206f", rsSpaceRange = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000", rsUpperRange = "A-Z\\xc0-\\xd6\\xd8-\\xde", rsVarRange = "\\ufe0e\\ufe0f", rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;
    /** Used to compose unicode capture groups. */ var rsApos = "['’]", rsAstral = "[" + rsAstralRange + "]", rsBreak = "[" + rsBreakRange + "]", rsCombo = "[" + rsComboRange + "]", rsDigits = "\\d+", rsDingbat = "[" + rsDingbatRange + "]", rsLower = "[" + rsLowerRange + "]", rsMisc = "[^" + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + "]", rsFitz = "\ud83c[\udffb-\udfff]", rsModifier = "(?:" + rsCombo + "|" + rsFitz + ")", rsNonAstral = "[^" + rsAstralRange + "]", rsRegional = "(?:\ud83c[\udde6-\uddff]){2}", rsSurrPair = "[\ud800-\udbff][\udc00-\udfff]", rsUpper = "[" + rsUpperRange + "]", rsZWJ = "\\u200d";
    /** Used to compose unicode regexes. */ var rsMiscLower = "(?:" + rsLower + "|" + rsMisc + ")", rsMiscUpper = "(?:" + rsUpper + "|" + rsMisc + ")", rsOptContrLower = "(?:" + rsApos + "(?:d|ll|m|re|s|t|ve))?", rsOptContrUpper = "(?:" + rsApos + "(?:D|LL|M|RE|S|T|VE))?", reOptMod = rsModifier + "?", rsOptVar = "[" + rsVarRange + "]?", rsOptJoin = "(?:" + rsZWJ + "(?:" + [
        rsNonAstral,
        rsRegional,
        rsSurrPair
    ].join("|") + ")" + rsOptVar + reOptMod + ")*", rsOrdLower = "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", rsOrdUpper = "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", rsSeq = rsOptVar + reOptMod + rsOptJoin, rsEmoji = "(?:" + [
        rsDingbat,
        rsRegional,
        rsSurrPair
    ].join("|") + ")" + rsSeq, rsSymbol = "(?:" + [
        rsNonAstral + rsCombo + "?",
        rsCombo,
        rsRegional,
        rsSurrPair,
        rsAstral
    ].join("|") + ")";
    /** Used to match apostrophes. */ var reApos = RegExp(rsApos, "g");
    /**
   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
   */ var reComboMark = RegExp(rsCombo, "g");
    /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */ var reUnicode = RegExp(rsFitz + "(?=" + rsFitz + ")|" + rsSymbol + rsSeq, "g");
    /** Used to match complex or compound words. */ var reUnicodeWord = RegExp([
        rsUpper + "?" + rsLower + "+" + rsOptContrLower + "(?=" + [
            rsBreak,
            rsUpper,
            "$"
        ].join("|") + ")",
        rsMiscUpper + "+" + rsOptContrUpper + "(?=" + [
            rsBreak,
            rsUpper + rsMiscLower,
            "$"
        ].join("|") + ")",
        rsUpper + "?" + rsMiscLower + "+" + rsOptContrLower,
        rsUpper + "+" + rsOptContrUpper,
        rsOrdUpper,
        rsOrdLower,
        rsDigits,
        rsEmoji
    ].join("|"), "g");
    /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */ var reHasUnicode = RegExp("[" + rsZWJ + rsAstralRange + rsComboRange + rsVarRange + "]");
    /** Used to detect strings that need a more robust regexp to match words. */ var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
    /** Used to assign default `context` object properties. */ var contextProps = [
        "Array",
        "Buffer",
        "DataView",
        "Date",
        "Error",
        "Float32Array",
        "Float64Array",
        "Function",
        "Int8Array",
        "Int16Array",
        "Int32Array",
        "Map",
        "Math",
        "Object",
        "Promise",
        "RegExp",
        "Set",
        "String",
        "Symbol",
        "TypeError",
        "Uint8Array",
        "Uint8ClampedArray",
        "Uint16Array",
        "Uint32Array",
        "WeakMap",
        "_",
        "clearTimeout",
        "isFinite",
        "parseInt",
        "setTimeout"
    ];
    /** Used to make template sourceURLs easier to identify. */ var templateCounter = -1;
    /** Used to identify `toStringTag` values of typed arrays. */ var typedArrayTags = {};
    typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
    typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
    /** Used to identify `toStringTag` values supported by `_.clone`. */ var cloneableTags = {};
    cloneableTags[argsTag] = cloneableTags[arrayTag] = cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] = cloneableTags[boolTag] = cloneableTags[dateTag] = cloneableTags[float32Tag] = cloneableTags[float64Tag] = cloneableTags[int8Tag] = cloneableTags[int16Tag] = cloneableTags[int32Tag] = cloneableTags[mapTag] = cloneableTags[numberTag] = cloneableTags[objectTag] = cloneableTags[regexpTag] = cloneableTags[setTag] = cloneableTags[stringTag] = cloneableTags[symbolTag] = cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] = cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
    cloneableTags[errorTag] = cloneableTags[funcTag] = cloneableTags[weakMapTag] = false;
    /** Used to map Latin Unicode letters to basic Latin letters. */ var deburredLetters = {
        // Latin-1 Supplement block.
        "\xc0": "A",
        "\xc1": "A",
        "\xc2": "A",
        "\xc3": "A",
        "\xc4": "A",
        "\xc5": "A",
        "\xe0": "a",
        "\xe1": "a",
        "\xe2": "a",
        "\xe3": "a",
        "\xe4": "a",
        "\xe5": "a",
        "\xc7": "C",
        "\xe7": "c",
        "\xd0": "D",
        "\xf0": "d",
        "\xc8": "E",
        "\xc9": "E",
        "\xca": "E",
        "\xcb": "E",
        "\xe8": "e",
        "\xe9": "e",
        "\xea": "e",
        "\xeb": "e",
        "\xcc": "I",
        "\xcd": "I",
        "\xce": "I",
        "\xcf": "I",
        "\xec": "i",
        "\xed": "i",
        "\xee": "i",
        "\xef": "i",
        "\xd1": "N",
        "\xf1": "n",
        "\xd2": "O",
        "\xd3": "O",
        "\xd4": "O",
        "\xd5": "O",
        "\xd6": "O",
        "\xd8": "O",
        "\xf2": "o",
        "\xf3": "o",
        "\xf4": "o",
        "\xf5": "o",
        "\xf6": "o",
        "\xf8": "o",
        "\xd9": "U",
        "\xda": "U",
        "\xdb": "U",
        "\xdc": "U",
        "\xf9": "u",
        "\xfa": "u",
        "\xfb": "u",
        "\xfc": "u",
        "\xdd": "Y",
        "\xfd": "y",
        "\xff": "y",
        "\xc6": "Ae",
        "\xe6": "ae",
        "\xde": "Th",
        "\xfe": "th",
        "\xdf": "ss",
        // Latin Extended-A block.
        "Ā": "A",
        "Ă": "A",
        "Ą": "A",
        "ā": "a",
        "ă": "a",
        "ą": "a",
        "Ć": "C",
        "Ĉ": "C",
        "Ċ": "C",
        "Č": "C",
        "ć": "c",
        "ĉ": "c",
        "ċ": "c",
        "č": "c",
        "Ď": "D",
        "Đ": "D",
        "ď": "d",
        "đ": "d",
        "Ē": "E",
        "Ĕ": "E",
        "Ė": "E",
        "Ę": "E",
        "Ě": "E",
        "ē": "e",
        "ĕ": "e",
        "ė": "e",
        "ę": "e",
        "ě": "e",
        "Ĝ": "G",
        "Ğ": "G",
        "Ġ": "G",
        "Ģ": "G",
        "ĝ": "g",
        "ğ": "g",
        "ġ": "g",
        "ģ": "g",
        "Ĥ": "H",
        "Ħ": "H",
        "ĥ": "h",
        "ħ": "h",
        "Ĩ": "I",
        "Ī": "I",
        "Ĭ": "I",
        "Į": "I",
        "İ": "I",
        "ĩ": "i",
        "ī": "i",
        "ĭ": "i",
        "į": "i",
        "ı": "i",
        "Ĵ": "J",
        "ĵ": "j",
        "Ķ": "K",
        "ķ": "k",
        "ĸ": "k",
        "Ĺ": "L",
        "Ļ": "L",
        "Ľ": "L",
        "Ŀ": "L",
        "Ł": "L",
        "ĺ": "l",
        "ļ": "l",
        "ľ": "l",
        "ŀ": "l",
        "ł": "l",
        "Ń": "N",
        "Ņ": "N",
        "Ň": "N",
        "Ŋ": "N",
        "ń": "n",
        "ņ": "n",
        "ň": "n",
        "ŋ": "n",
        "Ō": "O",
        "Ŏ": "O",
        "Ő": "O",
        "ō": "o",
        "ŏ": "o",
        "ő": "o",
        "Ŕ": "R",
        "Ŗ": "R",
        "Ř": "R",
        "ŕ": "r",
        "ŗ": "r",
        "ř": "r",
        "Ś": "S",
        "Ŝ": "S",
        "Ş": "S",
        "Š": "S",
        "ś": "s",
        "ŝ": "s",
        "ş": "s",
        "š": "s",
        "Ţ": "T",
        "Ť": "T",
        "Ŧ": "T",
        "ţ": "t",
        "ť": "t",
        "ŧ": "t",
        "Ũ": "U",
        "Ū": "U",
        "Ŭ": "U",
        "Ů": "U",
        "Ű": "U",
        "Ų": "U",
        "ũ": "u",
        "ū": "u",
        "ŭ": "u",
        "ů": "u",
        "ű": "u",
        "ų": "u",
        "Ŵ": "W",
        "ŵ": "w",
        "Ŷ": "Y",
        "ŷ": "y",
        "Ÿ": "Y",
        "Ź": "Z",
        "Ż": "Z",
        "Ž": "Z",
        "ź": "z",
        "ż": "z",
        "ž": "z",
        "Ĳ": "IJ",
        "ĳ": "ij",
        "Œ": "Oe",
        "œ": "oe",
        "ŉ": "'n",
        "ſ": "s"
    };
    /** Used to map characters to HTML entities. */ var htmlEscapes = {
        "&": "&amp;",
        "<": "&lt;",
        ">": "&gt;",
        '"': "&quot;",
        "'": "&#39;"
    };
    /** Used to map HTML entities to characters. */ var htmlUnescapes = {
        "&amp;": "&",
        "&lt;": "<",
        "&gt;": ">",
        "&quot;": '"',
        "&#39;": "'"
    };
    /** Used to escape characters for inclusion in compiled string literals. */ var stringEscapes = {
        "\\": "\\",
        "'": "'",
        "\n": "n",
        "\r": "r",
        "\u2028": "u2028",
        "\u2029": "u2029"
    };
    /** Built-in method references without a dependency on `root`. */ var freeParseFloat = parseFloat, freeParseInt = parseInt;
    /** Detect free variable `global` from Node.js. */ var freeGlobal = typeof $parcel$global == "object" && $parcel$global && $parcel$global.Object === Object && $parcel$global;
    /** Detect free variable `self`. */ var freeSelf = typeof self == "object" && self && self.Object === Object && self;
    /** Used as a reference to the global object. */ var root = freeGlobal || freeSelf || Function("return this")();
    /** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
    /** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
    /** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
    /** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && freeGlobal.process;
    /** Used to access faster Node.js helpers. */ var nodeUtil = function() {
        try {
            // Use `util.types` for Node.js 10+.
            var types = freeModule && freeModule.require && freeModule.require("util").types;
            if (types) return types;
            // Legacy `process.binding('util')` for Node.js < 10.
            return freeProcess && freeProcess.binding && freeProcess.binding("util");
        } catch (e) {}
    }();
    /* Node.js helper references. */ var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer, nodeIsDate = nodeUtil && nodeUtil.isDate, nodeIsMap = nodeUtil && nodeUtil.isMap, nodeIsRegExp = nodeUtil && nodeUtil.isRegExp, nodeIsSet = nodeUtil && nodeUtil.isSet, nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
    /*--------------------------------------------------------------------------*/ /**
   * A faster alternative to `Function#apply`, this function invokes `func`
   * with the `this` binding of `thisArg` and the arguments of `args`.
   *
   * @private
   * @param {Function} func The function to invoke.
   * @param {*} thisArg The `this` binding of `func`.
   * @param {Array} args The arguments to invoke `func` with.
   * @returns {*} Returns the result of `func`.
   */ function apply(func, thisArg, args) {
        switch(args.length){
            case 0:
                return func.call(thisArg);
            case 1:
                return func.call(thisArg, args[0]);
            case 2:
                return func.call(thisArg, args[0], args[1]);
            case 3:
                return func.call(thisArg, args[0], args[1], args[2]);
        }
        return func.apply(thisArg, args);
    }
    /**
   * A specialized version of `baseAggregator` for arrays.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} setter The function to set `accumulator` values.
   * @param {Function} iteratee The iteratee to transform keys.
   * @param {Object} accumulator The initial aggregated object.
   * @returns {Function} Returns `accumulator`.
   */ function arrayAggregator(array, setter, iteratee, accumulator) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            var value = array[index];
            setter(accumulator, value, iteratee(value), array);
        }
        return accumulator;
    }
    /**
   * A specialized version of `_.forEach` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */ function arrayEach(array, iteratee) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (iteratee(array[index], index, array) === false) break;
        }
        return array;
    }
    /**
   * A specialized version of `_.forEachRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */ function arrayEachRight(array, iteratee) {
        var length = array == null ? 0 : array.length;
        while(length--){
            if (iteratee(array[length], length, array) === false) break;
        }
        return array;
    }
    /**
   * A specialized version of `_.every` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if all elements pass the predicate check,
   *  else `false`.
   */ function arrayEvery(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (!predicate(array[index], index, array)) return false;
        }
        return true;
    }
    /**
   * A specialized version of `_.filter` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {Array} Returns the new filtered array.
   */ function arrayFilter(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
        while(++index < length){
            var value = array[index];
            if (predicate(value, index, array)) result[resIndex++] = value;
        }
        return result;
    }
    /**
   * A specialized version of `_.includes` for arrays without support for
   * specifying an index to search from.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */ function arrayIncludes(array, value) {
        var length = array == null ? 0 : array.length;
        return !!length && baseIndexOf(array, value, 0) > -1;
    }
    /**
   * This function is like `arrayIncludes` except that it accepts a comparator.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */ function arrayIncludesWith(array, value, comparator) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (comparator(value, array[index])) return true;
        }
        return false;
    }
    /**
   * A specialized version of `_.map` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the new mapped array.
   */ function arrayMap(array, iteratee) {
        var index = -1, length = array == null ? 0 : array.length, result = Array(length);
        while(++index < length)result[index] = iteratee(array[index], index, array);
        return result;
    }
    /**
   * Appends the elements of `values` to `array`.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {Array} values The values to append.
   * @returns {Array} Returns `array`.
   */ function arrayPush(array, values) {
        var index = -1, length = values.length, offset = array.length;
        while(++index < length)array[offset + index] = values[index];
        return array;
    }
    /**
   * A specialized version of `_.reduce` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the first element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */ function arrayReduce(array, iteratee, accumulator, initAccum) {
        var index = -1, length = array == null ? 0 : array.length;
        if (initAccum && length) accumulator = array[++index];
        while(++index < length)accumulator = iteratee(accumulator, array[index], index, array);
        return accumulator;
    }
    /**
   * A specialized version of `_.reduceRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the last element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */ function arrayReduceRight(array, iteratee, accumulator, initAccum) {
        var length = array == null ? 0 : array.length;
        if (initAccum && length) accumulator = array[--length];
        while(length--)accumulator = iteratee(accumulator, array[length], length, array);
        return accumulator;
    }
    /**
   * A specialized version of `_.some` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if any element passes the predicate check,
   *  else `false`.
   */ function arraySome(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (predicate(array[index], index, array)) return true;
        }
        return false;
    }
    /**
   * Gets the size of an ASCII `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */ var asciiSize = baseProperty("length");
    /**
   * Converts an ASCII `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function asciiToArray(string) {
        return string.split("");
    }
    /**
   * Splits an ASCII `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */ function asciiWords(string) {
        return string.match(reAsciiWord) || [];
    }
    /**
   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
   * without support for iteratee shorthands, which iterates over `collection`
   * using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the found element or its key, else `undefined`.
   */ function baseFindKey(collection, predicate, eachFunc) {
        var result;
        eachFunc(collection, function(value, key, collection) {
            if (predicate(value, key, collection)) {
                result = key;
                return false;
            }
        });
        return result;
    }
    /**
   * The base implementation of `_.findIndex` and `_.findLastIndex` without
   * support for iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {number} fromIndex The index to search from.
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseFindIndex(array, predicate, fromIndex, fromRight) {
        var length = array.length, index = fromIndex + (fromRight ? 1 : -1);
        while(fromRight ? index-- : ++index < length){
            if (predicate(array[index], index, array)) return index;
        }
        return -1;
    }
    /**
   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseIndexOf(array, value, fromIndex) {
        return value === value ? strictIndexOf(array, value, fromIndex) : baseFindIndex(array, baseIsNaN, fromIndex);
    }
    /**
   * This function is like `baseIndexOf` except that it accepts a comparator.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseIndexOfWith(array, value, fromIndex, comparator) {
        var index = fromIndex - 1, length = array.length;
        while(++index < length){
            if (comparator(array[index], value)) return index;
        }
        return -1;
    }
    /**
   * The base implementation of `_.isNaN` without support for number objects.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
   */ function baseIsNaN(value) {
        return value !== value;
    }
    /**
   * The base implementation of `_.mean` and `_.meanBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the mean.
   */ function baseMean(array, iteratee) {
        var length = array == null ? 0 : array.length;
        return length ? baseSum(array, iteratee) / length : NAN;
    }
    /**
   * The base implementation of `_.property` without support for deep paths.
   *
   * @private
   * @param {string} key The key of the property to get.
   * @returns {Function} Returns the new accessor function.
   */ function baseProperty(key) {
        return function(object) {
            return object == null ? undefined : object[key];
        };
    }
    /**
   * The base implementation of `_.propertyOf` without support for deep paths.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Function} Returns the new accessor function.
   */ function basePropertyOf(object) {
        return function(key) {
            return object == null ? undefined : object[key];
        };
    }
    /**
   * The base implementation of `_.reduce` and `_.reduceRight`, without support
   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} accumulator The initial value.
   * @param {boolean} initAccum Specify using the first or last element of
   *  `collection` as the initial value.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the accumulated value.
   */ function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
        eachFunc(collection, function(value, index, collection) {
            accumulator = initAccum ? (initAccum = false, value) : iteratee(accumulator, value, index, collection);
        });
        return accumulator;
    }
    /**
   * The base implementation of `_.sortBy` which uses `comparer` to define the
   * sort order of `array` and replaces criteria objects with their corresponding
   * values.
   *
   * @private
   * @param {Array} array The array to sort.
   * @param {Function} comparer The function to define sort order.
   * @returns {Array} Returns `array`.
   */ function baseSortBy(array, comparer) {
        var length = array.length;
        array.sort(comparer);
        while(length--)array[length] = array[length].value;
        return array;
    }
    /**
   * The base implementation of `_.sum` and `_.sumBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the sum.
   */ function baseSum(array, iteratee) {
        var result, index = -1, length = array.length;
        while(++index < length){
            var current = iteratee(array[index]);
            if (current !== undefined) result = result === undefined ? current : result + current;
        }
        return result;
    }
    /**
   * The base implementation of `_.times` without support for iteratee shorthands
   * or max array length checks.
   *
   * @private
   * @param {number} n The number of times to invoke `iteratee`.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the array of results.
   */ function baseTimes(n, iteratee) {
        var index = -1, result = Array(n);
        while(++index < n)result[index] = iteratee(index);
        return result;
    }
    /**
   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
   * of key-value pairs for `object` corresponding to the property names of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the key-value pairs.
   */ function baseToPairs(object, props) {
        return arrayMap(props, function(key) {
            return [
                key,
                object[key]
            ];
        });
    }
    /**
   * The base implementation of `_.trim`.
   *
   * @private
   * @param {string} string The string to trim.
   * @returns {string} Returns the trimmed string.
   */ function baseTrim(string) {
        return string ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, "") : string;
    }
    /**
   * The base implementation of `_.unary` without support for storing metadata.
   *
   * @private
   * @param {Function} func The function to cap arguments for.
   * @returns {Function} Returns the new capped function.
   */ function baseUnary(func) {
        return function(value) {
            return func(value);
        };
    }
    /**
   * The base implementation of `_.values` and `_.valuesIn` which creates an
   * array of `object` property values corresponding to the property names
   * of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the array of property values.
   */ function baseValues(object, props) {
        return arrayMap(props, function(key) {
            return object[key];
        });
    }
    /**
   * Checks if a `cache` value for `key` exists.
   *
   * @private
   * @param {Object} cache The cache to query.
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */ function cacheHas(cache, key) {
        return cache.has(key);
    }
    /**
   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the first unmatched string symbol.
   */ function charsStartIndex(strSymbols, chrSymbols) {
        var index = -1, length = strSymbols.length;
        while(++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1);
        return index;
    }
    /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the last unmatched string symbol.
   */ function charsEndIndex(strSymbols, chrSymbols) {
        var index = strSymbols.length;
        while(index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1);
        return index;
    }
    /**
   * Gets the number of `placeholder` occurrences in `array`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} placeholder The placeholder to search for.
   * @returns {number} Returns the placeholder count.
   */ function countHolders(array, placeholder) {
        var length = array.length, result = 0;
        while(length--)if (array[length] === placeholder) ++result;
        return result;
    }
    /**
   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
   * letters to basic Latin letters.
   *
   * @private
   * @param {string} letter The matched letter to deburr.
   * @returns {string} Returns the deburred letter.
   */ var deburrLetter = basePropertyOf(deburredLetters);
    /**
   * Used by `_.escape` to convert characters to HTML entities.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */ var escapeHtmlChar = basePropertyOf(htmlEscapes);
    /**
   * Used by `_.template` to escape characters for inclusion in compiled string literals.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */ function escapeStringChar(chr) {
        return "\\" + stringEscapes[chr];
    }
    /**
   * Gets the value at `key` of `object`.
   *
   * @private
   * @param {Object} [object] The object to query.
   * @param {string} key The key of the property to get.
   * @returns {*} Returns the property value.
   */ function getValue(object, key) {
        return object == null ? undefined : object[key];
    }
    /**
   * Checks if `string` contains Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
   */ function hasUnicode(string) {
        return reHasUnicode.test(string);
    }
    /**
   * Checks if `string` contains a word composed of Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a word is found, else `false`.
   */ function hasUnicodeWord(string) {
        return reHasUnicodeWord.test(string);
    }
    /**
   * Converts `iterator` to an array.
   *
   * @private
   * @param {Object} iterator The iterator to convert.
   * @returns {Array} Returns the converted array.
   */ function iteratorToArray(iterator) {
        var data, result = [];
        while(!(data = iterator.next()).done)result.push(data.value);
        return result;
    }
    /**
   * Converts `map` to its key-value pairs.
   *
   * @private
   * @param {Object} map The map to convert.
   * @returns {Array} Returns the key-value pairs.
   */ function mapToArray(map) {
        var index = -1, result = Array(map.size);
        map.forEach(function(value, key) {
            result[++index] = [
                key,
                value
            ];
        });
        return result;
    }
    /**
   * Creates a unary function that invokes `func` with its argument transformed.
   *
   * @private
   * @param {Function} func The function to wrap.
   * @param {Function} transform The argument transform.
   * @returns {Function} Returns the new function.
   */ function overArg(func, transform) {
        return function(arg) {
            return func(transform(arg));
        };
    }
    /**
   * Replaces all `placeholder` elements in `array` with an internal placeholder
   * and returns an array of their indexes.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {*} placeholder The placeholder to replace.
   * @returns {Array} Returns the new array of placeholder indexes.
   */ function replaceHolders(array, placeholder) {
        var index = -1, length = array.length, resIndex = 0, result = [];
        while(++index < length){
            var value = array[index];
            if (value === placeholder || value === PLACEHOLDER) {
                array[index] = PLACEHOLDER;
                result[resIndex++] = index;
            }
        }
        return result;
    }
    /**
   * Converts `set` to an array of its values.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the values.
   */ function setToArray(set) {
        var index = -1, result = Array(set.size);
        set.forEach(function(value) {
            result[++index] = value;
        });
        return result;
    }
    /**
   * Converts `set` to its value-value pairs.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the value-value pairs.
   */ function setToPairs(set) {
        var index = -1, result = Array(set.size);
        set.forEach(function(value) {
            result[++index] = [
                value,
                value
            ];
        });
        return result;
    }
    /**
   * A specialized version of `_.indexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function strictIndexOf(array, value, fromIndex) {
        var index = fromIndex - 1, length = array.length;
        while(++index < length){
            if (array[index] === value) return index;
        }
        return -1;
    }
    /**
   * A specialized version of `_.lastIndexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function strictLastIndexOf(array, value, fromIndex) {
        var index = fromIndex + 1;
        while(index--){
            if (array[index] === value) return index;
        }
        return index;
    }
    /**
   * Gets the number of symbols in `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the string size.
   */ function stringSize(string) {
        return hasUnicode(string) ? unicodeSize(string) : asciiSize(string);
    }
    /**
   * Converts `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function stringToArray(string) {
        return hasUnicode(string) ? unicodeToArray(string) : asciiToArray(string);
    }
    /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
   * character of `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the index of the last non-whitespace character.
   */ function trimmedEndIndex(string) {
        var index = string.length;
        while(index-- && reWhitespace.test(string.charAt(index)));
        return index;
    }
    /**
   * Used by `_.unescape` to convert HTML entities to characters.
   *
   * @private
   * @param {string} chr The matched character to unescape.
   * @returns {string} Returns the unescaped character.
   */ var unescapeHtmlChar = basePropertyOf(htmlUnescapes);
    /**
   * Gets the size of a Unicode `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */ function unicodeSize(string) {
        var result = reUnicode.lastIndex = 0;
        while(reUnicode.test(string))++result;
        return result;
    }
    /**
   * Converts a Unicode `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function unicodeToArray(string) {
        return string.match(reUnicode) || [];
    }
    /**
   * Splits a Unicode `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */ function unicodeWords(string) {
        return string.match(reUnicodeWord) || [];
    }
    /*--------------------------------------------------------------------------*/ /**
   * Create a new pristine `lodash` function using the `context` object.
   *
   * @static
   * @memberOf _
   * @since 1.1.0
   * @category Util
   * @param {Object} [context=root] The context object.
   * @returns {Function} Returns a new `lodash` function.
   * @example
   *
   * _.mixin({ 'foo': _.constant('foo') });
   *
   * var lodash = _.runInContext();
   * lodash.mixin({ 'bar': lodash.constant('bar') });
   *
   * _.isFunction(_.foo);
   * // => true
   * _.isFunction(_.bar);
   * // => false
   *
   * lodash.isFunction(lodash.foo);
   * // => false
   * lodash.isFunction(lodash.bar);
   * // => true
   *
   * // Create a suped-up `defer` in Node.js.
   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
   */ var runInContext = function runInContext(context) {
        context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));
        /** Built-in constructor references. */ var Array1 = context.Array, Date = context.Date, Error = context.Error, Function1 = context.Function, Math = context.Math, Object1 = context.Object, RegExp1 = context.RegExp, String = context.String, TypeError = context.TypeError;
        /** Used for built-in method references. */ var arrayProto = Array1.prototype, funcProto = Function1.prototype, objectProto = Object1.prototype;
        /** Used to detect overreaching core-js shims. */ var coreJsData = context["__core-js_shared__"];
        /** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
        /** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
        /** Used to generate unique IDs. */ var idCounter = 0;
        /** Used to detect methods masquerading as native. */ var maskSrcKey = function() {
            var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || "");
            return uid ? "Symbol(src)_1." + uid : "";
        }();
        /**
     * Used to resolve the
     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
     * of values.
     */ var nativeObjectToString = objectProto.toString;
        /** Used to infer the `Object` constructor. */ var objectCtorString = funcToString.call(Object1);
        /** Used to restore the original `_` reference in `_.noConflict`. */ var oldDash = root._;
        /** Used to detect if a method is native. */ var reIsNative = RegExp1("^" + funcToString.call(hasOwnProperty).replace(reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
        /** Built-in value references. */ var Buffer = moduleExports ? context.Buffer : undefined, Symbol = context.Symbol, Uint8Array = context.Uint8Array, allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined, getPrototype = overArg(Object1.getPrototypeOf, Object1), objectCreate = Object1.create, propertyIsEnumerable = objectProto.propertyIsEnumerable, splice = arrayProto.splice, spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined, symIterator = Symbol ? Symbol.iterator : undefined, symToStringTag = Symbol ? Symbol.toStringTag : undefined;
        var defineProperty = function() {
            try {
                var func = getNative(Object1, "defineProperty");
                func({}, "", {});
                return func;
            } catch (e) {}
        }();
        /** Mocked built-ins. */ var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout, ctxNow = Date && Date.now !== root.Date.now && Date.now, ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;
        /* Built-in method references for those with the same name as other `lodash` methods. */ var nativeCeil = Math.ceil, nativeFloor = Math.floor, nativeGetSymbols = Object1.getOwnPropertySymbols, nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined, nativeIsFinite = context.isFinite, nativeJoin = arrayProto.join, nativeKeys = overArg(Object1.keys, Object1), nativeMax = Math.max, nativeMin = Math.min, nativeNow = Date.now, nativeParseInt = context.parseInt, nativeRandom = Math.random, nativeReverse = arrayProto.reverse;
        /* Built-in method references that are verified to be native. */ var DataView = getNative(context, "DataView"), Map = getNative(context, "Map"), Promise = getNative(context, "Promise"), Set = getNative(context, "Set"), WeakMap = getNative(context, "WeakMap"), nativeCreate = getNative(Object1, "create");
        /** Used to store function metadata. */ var metaMap = WeakMap && new WeakMap;
        /** Used to lookup unminified function names. */ var realNames = {};
        /** Used to detect maps, sets, and weakmaps. */ var dataViewCtorString = toSource(DataView), mapCtorString = toSource(Map), promiseCtorString = toSource(Promise), setCtorString = toSource(Set), weakMapCtorString = toSource(WeakMap);
        /** Used to convert symbols to primitives and strings. */ var symbolProto = Symbol ? Symbol.prototype : undefined, symbolValueOf = symbolProto ? symbolProto.valueOf : undefined, symbolToString = symbolProto ? symbolProto.toString : undefined;
        /*------------------------------------------------------------------------*/ /**
     * Creates a `lodash` object which wraps `value` to enable implicit method
     * chain sequences. Methods that operate on and return arrays, collections,
     * and functions can be chained together. Methods that retrieve a single value
     * or may return a primitive value will automatically end the chain sequence
     * and return the unwrapped value. Otherwise, the value must be unwrapped
     * with `_#value`.
     *
     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
     * enabled using `_.chain`.
     *
     * The execution of chained methods is lazy, that is, it's deferred until
     * `_#value` is implicitly or explicitly called.
     *
     * Lazy evaluation allows several methods to support shortcut fusion.
     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
     * the creation of intermediate arrays and can greatly reduce the number of
     * iteratee executions. Sections of a chain sequence qualify for shortcut
     * fusion if the section is applied to an array and iteratees accept only
     * one argument. The heuristic for whether a section qualifies for shortcut
     * fusion is subject to change.
     *
     * Chaining is supported in custom builds as long as the `_#value` method is
     * directly or indirectly included in the build.
     *
     * In addition to lodash methods, wrappers have `Array` and `String` methods.
     *
     * The wrapper `Array` methods are:
     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
     *
     * The wrapper `String` methods are:
     * `replace` and `split`
     *
     * The wrapper methods that support shortcut fusion are:
     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
     *
     * The chainable wrapper methods are:
     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
     * `zipObject`, `zipObjectDeep`, and `zipWith`
     *
     * The wrapper methods that are **not** chainable by default are:
     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
     * `upperFirst`, `value`, and `words`
     *
     * @name _
     * @constructor
     * @category Seq
     * @param {*} value The value to wrap in a `lodash` instance.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2, 3]);
     *
     * // Returns an unwrapped value.
     * wrapped.reduce(_.add);
     * // => 6
     *
     * // Returns a wrapped value.
     * var squares = wrapped.map(square);
     *
     * _.isArray(squares);
     * // => false
     *
     * _.isArray(squares.value());
     * // => true
     */ function lodash(value) {
            if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
                if (value instanceof LodashWrapper) return value;
                if (hasOwnProperty.call(value, "__wrapped__")) return wrapperClone(value);
            }
            return new LodashWrapper(value);
        }
        /**
     * The base implementation of `_.create` without support for assigning
     * properties to the created object.
     *
     * @private
     * @param {Object} proto The object to inherit from.
     * @returns {Object} Returns the new object.
     */ var baseCreate = function() {
            function object() {}
            return function(proto) {
                if (!isObject(proto)) return {};
                if (objectCreate) return objectCreate(proto);
                object.prototype = proto;
                var result = new object;
                object.prototype = undefined;
                return result;
            };
        }();
        /**
     * The function whose prototype chain sequence wrappers inherit from.
     *
     * @private
     */ function baseLodash() {
        // No operation performed.
        }
        /**
     * The base constructor for creating `lodash` wrapper objects.
     *
     * @private
     * @param {*} value The value to wrap.
     * @param {boolean} [chainAll] Enable explicit method chain sequences.
     */ function LodashWrapper(value, chainAll) {
            this.__wrapped__ = value;
            this.__actions__ = [];
            this.__chain__ = !!chainAll;
            this.__index__ = 0;
            this.__values__ = undefined;
        }
        /**
     * By default, the template delimiters used by lodash are like those in
     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
     * following template settings to use alternative delimiters.
     *
     * @static
     * @memberOf _
     * @type {Object}
     */ lodash.templateSettings = {
            /**
       * Used to detect `data` property values to be HTML-escaped.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ "escape": reEscape,
            /**
       * Used to detect code to be evaluated.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ "evaluate": reEvaluate,
            /**
       * Used to detect `data` property values to inject.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ "interpolate": reInterpolate,
            /**
       * Used to reference the data object in the template text.
       *
       * @memberOf _.templateSettings
       * @type {string}
       */ "variable": "",
            /**
       * Used to import variables into the compiled template.
       *
       * @memberOf _.templateSettings
       * @type {Object}
       */ "imports": {
                /**
         * A reference to the `lodash` function.
         *
         * @memberOf _.templateSettings.imports
         * @type {Function}
         */ "_": lodash
            }
        };
        // Ensure wrappers are instances of `baseLodash`.
        lodash.prototype = baseLodash.prototype;
        lodash.prototype.constructor = lodash;
        LodashWrapper.prototype = baseCreate(baseLodash.prototype);
        LodashWrapper.prototype.constructor = LodashWrapper;
        /*------------------------------------------------------------------------*/ /**
     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
     *
     * @private
     * @constructor
     * @param {*} value The value to wrap.
     */ function LazyWrapper(value) {
            this.__wrapped__ = value;
            this.__actions__ = [];
            this.__dir__ = 1;
            this.__filtered__ = false;
            this.__iteratees__ = [];
            this.__takeCount__ = MAX_ARRAY_LENGTH;
            this.__views__ = [];
        }
        /**
     * Creates a clone of the lazy wrapper object.
     *
     * @private
     * @name clone
     * @memberOf LazyWrapper
     * @returns {Object} Returns the cloned `LazyWrapper` object.
     */ function lazyClone() {
            var result = new LazyWrapper(this.__wrapped__);
            result.__actions__ = copyArray(this.__actions__);
            result.__dir__ = this.__dir__;
            result.__filtered__ = this.__filtered__;
            result.__iteratees__ = copyArray(this.__iteratees__);
            result.__takeCount__ = this.__takeCount__;
            result.__views__ = copyArray(this.__views__);
            return result;
        }
        /**
     * Reverses the direction of lazy iteration.
     *
     * @private
     * @name reverse
     * @memberOf LazyWrapper
     * @returns {Object} Returns the new reversed `LazyWrapper` object.
     */ function lazyReverse() {
            if (this.__filtered__) {
                var result = new LazyWrapper(this);
                result.__dir__ = -1;
                result.__filtered__ = true;
            } else {
                result = this.clone();
                result.__dir__ *= -1;
            }
            return result;
        }
        /**
     * Extracts the unwrapped value from its lazy wrapper.
     *
     * @private
     * @name value
     * @memberOf LazyWrapper
     * @returns {*} Returns the unwrapped value.
     */ function lazyValue() {
            var array = this.__wrapped__.value(), dir = this.__dir__, isArr = isArray(array), isRight = dir < 0, arrLength = isArr ? array.length : 0, view = getView(0, arrLength, this.__views__), start = view.start, end = view.end, length = end - start, index = isRight ? end : start - 1, iteratees = this.__iteratees__, iterLength = iteratees.length, resIndex = 0, takeCount = nativeMin(length, this.__takeCount__);
            if (!isArr || !isRight && arrLength == length && takeCount == length) return baseWrapperValue(array, this.__actions__);
            var result = [];
            outer: while(length-- && resIndex < takeCount){
                index += dir;
                var iterIndex = -1, value = array[index];
                while(++iterIndex < iterLength){
                    var data = iteratees[iterIndex], iteratee = data.iteratee, type = data.type, computed = iteratee(value);
                    if (type == LAZY_MAP_FLAG) value = computed;
                    else if (!computed) {
                        if (type == LAZY_FILTER_FLAG) continue outer;
                        else break outer;
                    }
                }
                result[resIndex++] = value;
            }
            return result;
        }
        // Ensure `LazyWrapper` is an instance of `baseLodash`.
        LazyWrapper.prototype = baseCreate(baseLodash.prototype);
        LazyWrapper.prototype.constructor = LazyWrapper;
        /*------------------------------------------------------------------------*/ /**
     * Creates a hash object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function Hash(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the hash.
     *
     * @private
     * @name clear
     * @memberOf Hash
     */ function hashClear() {
            this.__data__ = nativeCreate ? nativeCreate(null) : {};
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the hash.
     *
     * @private
     * @name delete
     * @memberOf Hash
     * @param {Object} hash The hash to modify.
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function hashDelete(key) {
            var result = this.has(key) && delete this.__data__[key];
            this.size -= result ? 1 : 0;
            return result;
        }
        /**
     * Gets the hash value for `key`.
     *
     * @private
     * @name get
     * @memberOf Hash
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function hashGet(key) {
            var data = this.__data__;
            if (nativeCreate) {
                var result = data[key];
                return result === HASH_UNDEFINED ? undefined : result;
            }
            return hasOwnProperty.call(data, key) ? data[key] : undefined;
        }
        /**
     * Checks if a hash value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Hash
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function hashHas(key) {
            var data = this.__data__;
            return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
        }
        /**
     * Sets the hash `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Hash
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the hash instance.
     */ function hashSet(key, value) {
            var data = this.__data__;
            this.size += this.has(key) ? 0 : 1;
            data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED : value;
            return this;
        }
        // Add methods to `Hash`.
        Hash.prototype.clear = hashClear;
        Hash.prototype["delete"] = hashDelete;
        Hash.prototype.get = hashGet;
        Hash.prototype.has = hashHas;
        Hash.prototype.set = hashSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates an list cache object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function ListCache(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the list cache.
     *
     * @private
     * @name clear
     * @memberOf ListCache
     */ function listCacheClear() {
            this.__data__ = [];
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the list cache.
     *
     * @private
     * @name delete
     * @memberOf ListCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function listCacheDelete(key) {
            var data = this.__data__, index = assocIndexOf(data, key);
            if (index < 0) return false;
            var lastIndex = data.length - 1;
            if (index == lastIndex) data.pop();
            else splice.call(data, index, 1);
            --this.size;
            return true;
        }
        /**
     * Gets the list cache value for `key`.
     *
     * @private
     * @name get
     * @memberOf ListCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function listCacheGet(key) {
            var data = this.__data__, index = assocIndexOf(data, key);
            return index < 0 ? undefined : data[index][1];
        }
        /**
     * Checks if a list cache value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf ListCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function listCacheHas(key) {
            return assocIndexOf(this.__data__, key) > -1;
        }
        /**
     * Sets the list cache `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf ListCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the list cache instance.
     */ function listCacheSet(key, value) {
            var data = this.__data__, index = assocIndexOf(data, key);
            if (index < 0) {
                ++this.size;
                data.push([
                    key,
                    value
                ]);
            } else data[index][1] = value;
            return this;
        }
        // Add methods to `ListCache`.
        ListCache.prototype.clear = listCacheClear;
        ListCache.prototype["delete"] = listCacheDelete;
        ListCache.prototype.get = listCacheGet;
        ListCache.prototype.has = listCacheHas;
        ListCache.prototype.set = listCacheSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates a map cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function MapCache(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the map.
     *
     * @private
     * @name clear
     * @memberOf MapCache
     */ function mapCacheClear() {
            this.size = 0;
            this.__data__ = {
                "hash": new Hash,
                "map": new (Map || ListCache),
                "string": new Hash
            };
        }
        /**
     * Removes `key` and its value from the map.
     *
     * @private
     * @name delete
     * @memberOf MapCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function mapCacheDelete(key) {
            var result = getMapData(this, key)["delete"](key);
            this.size -= result ? 1 : 0;
            return result;
        }
        /**
     * Gets the map value for `key`.
     *
     * @private
     * @name get
     * @memberOf MapCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function mapCacheGet(key) {
            return getMapData(this, key).get(key);
        }
        /**
     * Checks if a map value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf MapCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function mapCacheHas(key) {
            return getMapData(this, key).has(key);
        }
        /**
     * Sets the map `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf MapCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the map cache instance.
     */ function mapCacheSet(key, value) {
            var data = getMapData(this, key), size = data.size;
            data.set(key, value);
            this.size += data.size == size ? 0 : 1;
            return this;
        }
        // Add methods to `MapCache`.
        MapCache.prototype.clear = mapCacheClear;
        MapCache.prototype["delete"] = mapCacheDelete;
        MapCache.prototype.get = mapCacheGet;
        MapCache.prototype.has = mapCacheHas;
        MapCache.prototype.set = mapCacheSet;
        /*------------------------------------------------------------------------*/ /**
     *
     * Creates an array cache object to store unique values.
     *
     * @private
     * @constructor
     * @param {Array} [values] The values to cache.
     */ function SetCache(values) {
            var index = -1, length = values == null ? 0 : values.length;
            this.__data__ = new MapCache;
            while(++index < length)this.add(values[index]);
        }
        /**
     * Adds `value` to the array cache.
     *
     * @private
     * @name add
     * @memberOf SetCache
     * @alias push
     * @param {*} value The value to cache.
     * @returns {Object} Returns the cache instance.
     */ function setCacheAdd(value) {
            this.__data__.set(value, HASH_UNDEFINED);
            return this;
        }
        /**
     * Checks if `value` is in the array cache.
     *
     * @private
     * @name has
     * @memberOf SetCache
     * @param {*} value The value to search for.
     * @returns {number} Returns `true` if `value` is found, else `false`.
     */ function setCacheHas(value) {
            return this.__data__.has(value);
        }
        // Add methods to `SetCache`.
        SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
        SetCache.prototype.has = setCacheHas;
        /*------------------------------------------------------------------------*/ /**
     * Creates a stack cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function Stack(entries) {
            var data = this.__data__ = new ListCache(entries);
            this.size = data.size;
        }
        /**
     * Removes all key-value entries from the stack.
     *
     * @private
     * @name clear
     * @memberOf Stack
     */ function stackClear() {
            this.__data__ = new ListCache;
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the stack.
     *
     * @private
     * @name delete
     * @memberOf Stack
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function stackDelete(key) {
            var data = this.__data__, result = data["delete"](key);
            this.size = data.size;
            return result;
        }
        /**
     * Gets the stack value for `key`.
     *
     * @private
     * @name get
     * @memberOf Stack
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function stackGet(key) {
            return this.__data__.get(key);
        }
        /**
     * Checks if a stack value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Stack
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function stackHas(key) {
            return this.__data__.has(key);
        }
        /**
     * Sets the stack `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Stack
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the stack cache instance.
     */ function stackSet(key, value) {
            var data = this.__data__;
            if (data instanceof ListCache) {
                var pairs = data.__data__;
                if (!Map || pairs.length < LARGE_ARRAY_SIZE - 1) {
                    pairs.push([
                        key,
                        value
                    ]);
                    this.size = ++data.size;
                    return this;
                }
                data = this.__data__ = new MapCache(pairs);
            }
            data.set(key, value);
            this.size = data.size;
            return this;
        }
        // Add methods to `Stack`.
        Stack.prototype.clear = stackClear;
        Stack.prototype["delete"] = stackDelete;
        Stack.prototype.get = stackGet;
        Stack.prototype.has = stackHas;
        Stack.prototype.set = stackSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates an array of the enumerable property names of the array-like `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @param {boolean} inherited Specify returning inherited property names.
     * @returns {Array} Returns the array of property names.
     */ function arrayLikeKeys(value, inherited) {
            var isArr = isArray(value), isArg = !isArr && isArguments(value), isBuff = !isArr && !isArg && isBuffer(value), isType = !isArr && !isArg && !isBuff && isTypedArray(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? baseTimes(value.length, String) : [], length = result.length;
            for(var key in value)if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
            (key == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
            isBuff && (key == "offset" || key == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
            isType && (key == "buffer" || key == "byteLength" || key == "byteOffset") || // Skip index properties.
            isIndex(key, length)))) result.push(key);
            return result;
        }
        /**
     * A specialized version of `_.sample` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @returns {*} Returns the random element.
     */ function arraySample(array) {
            var length = array.length;
            return length ? array[baseRandom(0, length - 1)] : undefined;
        }
        /**
     * A specialized version of `_.sampleSize` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */ function arraySampleSize(array, n) {
            return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
        }
        /**
     * A specialized version of `_.shuffle` for arrays.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */ function arrayShuffle(array) {
            return shuffleSelf(copyArray(array));
        }
        /**
     * This function is like `assignValue` except that it doesn't assign
     * `undefined` values.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function assignMergeValue(object, key, value) {
            if (value !== undefined && !eq(object[key], value) || value === undefined && !(key in object)) baseAssignValue(object, key, value);
        }
        /**
     * Assigns `value` to `key` of `object` if the existing value is not equivalent
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function assignValue(object, key, value) {
            var objValue = object[key];
            if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) || value === undefined && !(key in object)) baseAssignValue(object, key, value);
        }
        /**
     * Gets the index at which the `key` is found in `array` of key-value pairs.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {*} key The key to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     */ function assocIndexOf(array, key) {
            var length = array.length;
            while(length--){
                if (eq(array[length][0], key)) return length;
            }
            return -1;
        }
        /**
     * Aggregates elements of `collection` on `accumulator` with keys transformed
     * by `iteratee` and values set by `setter`.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform keys.
     * @param {Object} accumulator The initial aggregated object.
     * @returns {Function} Returns `accumulator`.
     */ function baseAggregator(collection, setter, iteratee, accumulator) {
            baseEach(collection, function(value, key, collection) {
                setter(accumulator, value, iteratee(value), collection);
            });
            return accumulator;
        }
        /**
     * The base implementation of `_.assign` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */ function baseAssign(object, source) {
            return object && copyObject(source, keys(source), object);
        }
        /**
     * The base implementation of `_.assignIn` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */ function baseAssignIn(object, source) {
            return object && copyObject(source, keysIn(source), object);
        }
        /**
     * The base implementation of `assignValue` and `assignMergeValue` without
     * value checks.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function baseAssignValue(object, key, value) {
            if (key == "__proto__" && defineProperty) defineProperty(object, key, {
                "configurable": true,
                "enumerable": true,
                "value": value,
                "writable": true
            });
            else object[key] = value;
        }
        /**
     * The base implementation of `_.at` without support for individual paths.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {string[]} paths The property paths to pick.
     * @returns {Array} Returns the picked elements.
     */ function baseAt(object, paths) {
            var index = -1, length = paths.length, result = Array1(length), skip = object == null;
            while(++index < length)result[index] = skip ? undefined : get(object, paths[index]);
            return result;
        }
        /**
     * The base implementation of `_.clamp` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     */ function baseClamp(number, lower, upper) {
            if (number === number) {
                if (upper !== undefined) number = number <= upper ? number : upper;
                if (lower !== undefined) number = number >= lower ? number : lower;
            }
            return number;
        }
        /**
     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
     * traversed objects.
     *
     * @private
     * @param {*} value The value to clone.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Deep clone
     *  2 - Flatten inherited properties
     *  4 - Clone symbols
     * @param {Function} [customizer] The function to customize cloning.
     * @param {string} [key] The key of `value`.
     * @param {Object} [object] The parent object of `value`.
     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
     * @returns {*} Returns the cloned value.
     */ function baseClone(value, bitmask, customizer, key, object, stack) {
            var result, isDeep = bitmask & CLONE_DEEP_FLAG, isFlat = bitmask & CLONE_FLAT_FLAG, isFull = bitmask & CLONE_SYMBOLS_FLAG;
            if (customizer) result = object ? customizer(value, key, object, stack) : customizer(value);
            if (result !== undefined) return result;
            if (!isObject(value)) return value;
            var isArr = isArray(value);
            if (isArr) {
                result = initCloneArray(value);
                if (!isDeep) return copyArray(value, result);
            } else {
                var tag = getTag(value), isFunc = tag == funcTag || tag == genTag;
                if (isBuffer(value)) return cloneBuffer(value, isDeep);
                if (tag == objectTag || tag == argsTag || isFunc && !object) {
                    result = isFlat || isFunc ? {} : initCloneObject(value);
                    if (!isDeep) return isFlat ? copySymbolsIn(value, baseAssignIn(result, value)) : copySymbols(value, baseAssign(result, value));
                } else {
                    if (!cloneableTags[tag]) return object ? value : {};
                    result = initCloneByTag(value, tag, isDeep);
                }
            }
            // Check for circular references and return its corresponding clone.
            stack || (stack = new Stack);
            var stacked = stack.get(value);
            if (stacked) return stacked;
            stack.set(value, result);
            if (isSet(value)) value.forEach(function(subValue) {
                result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
            });
            else if (isMap(value)) value.forEach(function(subValue, key) {
                result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
            });
            var keysFunc = isFull ? isFlat ? getAllKeysIn : getAllKeys : isFlat ? keysIn : keys;
            var props = isArr ? undefined : keysFunc(value);
            arrayEach(props || value, function(subValue, key) {
                if (props) {
                    key = subValue;
                    subValue = value[key];
                }
                // Recursively populate clone (susceptible to call stack limits).
                assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
            });
            return result;
        }
        /**
     * The base implementation of `_.conforms` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     */ function baseConforms(source) {
            var props = keys(source);
            return function(object) {
                return baseConformsTo(object, source, props);
            };
        }
        /**
     * The base implementation of `_.conformsTo` which accepts `props` to check.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     */ function baseConformsTo(object, source, props) {
            var length = props.length;
            if (object == null) return !length;
            object = Object1(object);
            while(length--){
                var key = props[length], predicate = source[key], value = object[key];
                if (value === undefined && !(key in object) || !predicate(value)) return false;
            }
            return true;
        }
        /**
     * The base implementation of `_.delay` and `_.defer` which accepts `args`
     * to provide to `func`.
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {Array} args The arguments to provide to `func`.
     * @returns {number|Object} Returns the timer id or timeout object.
     */ function baseDelay(func, wait, args) {
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            return setTimeout(function() {
                func.apply(undefined, args);
            }, wait);
        }
        /**
     * The base implementation of methods like `_.difference` without support
     * for excluding multiple arrays or iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Array} values The values to exclude.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     */ function baseDifference(array, values, iteratee, comparator) {
            var index = -1, includes = arrayIncludes, isCommon = true, length = array.length, result = [], valuesLength = values.length;
            if (!length) return result;
            if (iteratee) values = arrayMap(values, baseUnary(iteratee));
            if (comparator) {
                includes = arrayIncludesWith;
                isCommon = false;
            } else if (values.length >= LARGE_ARRAY_SIZE) {
                includes = cacheHas;
                isCommon = false;
                values = new SetCache(values);
            }
            outer: while(++index < length){
                var value = array[index], computed = iteratee == null ? value : iteratee(value);
                value = comparator || value !== 0 ? value : 0;
                if (isCommon && computed === computed) {
                    var valuesIndex = valuesLength;
                    while(valuesIndex--){
                        if (values[valuesIndex] === computed) continue outer;
                    }
                    result.push(value);
                } else if (!includes(values, computed, comparator)) result.push(value);
            }
            return result;
        }
        /**
     * The base implementation of `_.forEach` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */ var baseEach = createBaseEach(baseForOwn);
        /**
     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */ var baseEachRight = createBaseEach(baseForOwnRight, true);
        /**
     * The base implementation of `_.every` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`
     */ function baseEvery(collection, predicate) {
            var result = true;
            baseEach(collection, function(value, index, collection) {
                result = !!predicate(value, index, collection);
                return result;
            });
            return result;
        }
        /**
     * The base implementation of methods like `_.max` and `_.min` which accepts a
     * `comparator` to determine the extremum value.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The iteratee invoked per iteration.
     * @param {Function} comparator The comparator used to compare values.
     * @returns {*} Returns the extremum value.
     */ function baseExtremum(array, iteratee, comparator) {
            var index = -1, length = array.length;
            while(++index < length){
                var value = array[index], current = iteratee(value);
                if (current != null && (computed === undefined ? current === current && !isSymbol(current) : comparator(current, computed))) var computed = current, result = value;
            }
            return result;
        }
        /**
     * The base implementation of `_.fill` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     */ function baseFill(array, value, start, end) {
            var length = array.length;
            start = toInteger(start);
            if (start < 0) start = -start > length ? 0 : length + start;
            end = end === undefined || end > length ? length : toInteger(end);
            if (end < 0) end += length;
            end = start > end ? 0 : toLength(end);
            while(start < end)array[start++] = value;
            return array;
        }
        /**
     * The base implementation of `_.filter` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     */ function baseFilter(collection, predicate) {
            var result = [];
            baseEach(collection, function(value, index, collection) {
                if (predicate(value, index, collection)) result.push(value);
            });
            return result;
        }
        /**
     * The base implementation of `_.flatten` with support for restricting flattening.
     *
     * @private
     * @param {Array} array The array to flatten.
     * @param {number} depth The maximum recursion depth.
     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
     * @param {Array} [result=[]] The initial result value.
     * @returns {Array} Returns the new flattened array.
     */ function baseFlatten(array, depth, predicate, isStrict, result) {
            var index = -1, length = array.length;
            predicate || (predicate = isFlattenable);
            result || (result = []);
            while(++index < length){
                var value = array[index];
                if (depth > 0 && predicate(value)) {
                    if (depth > 1) // Recursively flatten arrays (susceptible to call stack limits).
                    baseFlatten(value, depth - 1, predicate, isStrict, result);
                    else arrayPush(result, value);
                } else if (!isStrict) result[result.length] = value;
            }
            return result;
        }
        /**
     * The base implementation of `baseForOwn` which iterates over `object`
     * properties returned by `keysFunc` and invokes `iteratee` for each property.
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */ var baseFor = createBaseFor();
        /**
     * This function is like `baseFor` except that it iterates over properties
     * in the opposite order.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */ var baseForRight = createBaseFor(true);
        /**
     * The base implementation of `_.forOwn` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */ function baseForOwn(object, iteratee) {
            return object && baseFor(object, iteratee, keys);
        }
        /**
     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */ function baseForOwnRight(object, iteratee) {
            return object && baseForRight(object, iteratee, keys);
        }
        /**
     * The base implementation of `_.functions` which creates an array of
     * `object` function property names filtered from `props`.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Array} props The property names to filter.
     * @returns {Array} Returns the function names.
     */ function baseFunctions(object, props) {
            return arrayFilter(props, function(key) {
                return isFunction(object[key]);
            });
        }
        /**
     * The base implementation of `_.get` without support for default values.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @returns {*} Returns the resolved value.
     */ function baseGet(object, path) {
            path = castPath(path, object);
            var index = 0, length = path.length;
            while(object != null && index < length)object = object[toKey(path[index++])];
            return index && index == length ? object : undefined;
        }
        /**
     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @param {Function} symbolsFunc The function to get the symbols of `object`.
     * @returns {Array} Returns the array of property names and symbols.
     */ function baseGetAllKeys(object, keysFunc, symbolsFunc) {
            var result = keysFunc(object);
            return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
        }
        /**
     * The base implementation of `getTag` without fallbacks for buggy environments.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */ function baseGetTag(value) {
            if (value == null) return value === undefined ? undefinedTag : nullTag;
            return symToStringTag && symToStringTag in Object1(value) ? getRawTag(value) : objectToString(value);
        }
        /**
     * The base implementation of `_.gt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     */ function baseGt(value, other) {
            return value > other;
        }
        /**
     * The base implementation of `_.has` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */ function baseHas(object, key) {
            return object != null && hasOwnProperty.call(object, key);
        }
        /**
     * The base implementation of `_.hasIn` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */ function baseHasIn(object, key) {
            return object != null && key in Object1(object);
        }
        /**
     * The base implementation of `_.inRange` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to check.
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     */ function baseInRange(number, start, end) {
            return number >= nativeMin(start, end) && number < nativeMax(start, end);
        }
        /**
     * The base implementation of methods like `_.intersection`, without support
     * for iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of shared values.
     */ function baseIntersection(arrays, iteratee, comparator) {
            var includes = comparator ? arrayIncludesWith : arrayIncludes, length = arrays[0].length, othLength = arrays.length, othIndex = othLength, caches = Array1(othLength), maxLength = Infinity, result = [];
            while(othIndex--){
                var array = arrays[othIndex];
                if (othIndex && iteratee) array = arrayMap(array, baseUnary(iteratee));
                maxLength = nativeMin(array.length, maxLength);
                caches[othIndex] = !comparator && (iteratee || length >= 120 && array.length >= 120) ? new SetCache(othIndex && array) : undefined;
            }
            array = arrays[0];
            var index = -1, seen = caches[0];
            outer: while(++index < length && result.length < maxLength){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                value = comparator || value !== 0 ? value : 0;
                if (!(seen ? cacheHas(seen, computed) : includes(result, computed, comparator))) {
                    othIndex = othLength;
                    while(--othIndex){
                        var cache = caches[othIndex];
                        if (!(cache ? cacheHas(cache, computed) : includes(arrays[othIndex], computed, comparator))) continue outer;
                    }
                    if (seen) seen.push(computed);
                    result.push(value);
                }
            }
            return result;
        }
        /**
     * The base implementation of `_.invert` and `_.invertBy` which inverts
     * `object` with values transformed by `iteratee` and set by `setter`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform values.
     * @param {Object} accumulator The initial inverted object.
     * @returns {Function} Returns `accumulator`.
     */ function baseInverter(object, setter, iteratee, accumulator) {
            baseForOwn(object, function(value, key, object) {
                setter(accumulator, iteratee(value), key, object);
            });
            return accumulator;
        }
        /**
     * The base implementation of `_.invoke` without support for individual
     * method arguments.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {Array} args The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     */ function baseInvoke(object, path, args) {
            path = castPath(path, object);
            object = parent(object, path);
            var func = object == null ? object : object[toKey(last(path))];
            return func == null ? undefined : apply(func, object, args);
        }
        /**
     * The base implementation of `_.isArguments`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     */ function baseIsArguments(value) {
            return isObjectLike(value) && baseGetTag(value) == argsTag;
        }
        /**
     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     */ function baseIsArrayBuffer(value) {
            return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
        }
        /**
     * The base implementation of `_.isDate` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     */ function baseIsDate(value) {
            return isObjectLike(value) && baseGetTag(value) == dateTag;
        }
        /**
     * The base implementation of `_.isEqual` which supports partial comparisons
     * and tracks traversed objects.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Unordered comparison
     *  2 - Partial comparison
     * @param {Function} [customizer] The function to customize comparisons.
     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     */ function baseIsEqual(value, other, bitmask, customizer, stack) {
            if (value === other) return true;
            if (value == null || other == null || !isObjectLike(value) && !isObjectLike(other)) return value !== value && other !== other;
            return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
        }
        /**
     * A specialized version of `baseIsEqual` for arrays and objects which performs
     * deep comparisons and tracks traversed objects enabling objects with circular
     * references to be compared.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
            var objIsArr = isArray(object), othIsArr = isArray(other), objTag = objIsArr ? arrayTag : getTag(object), othTag = othIsArr ? arrayTag : getTag(other);
            objTag = objTag == argsTag ? objectTag : objTag;
            othTag = othTag == argsTag ? objectTag : othTag;
            var objIsObj = objTag == objectTag, othIsObj = othTag == objectTag, isSameTag = objTag == othTag;
            if (isSameTag && isBuffer(object)) {
                if (!isBuffer(other)) return false;
                objIsArr = true;
                objIsObj = false;
            }
            if (isSameTag && !objIsObj) {
                stack || (stack = new Stack);
                return objIsArr || isTypedArray(object) ? equalArrays(object, other, bitmask, customizer, equalFunc, stack) : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
            }
            if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
                var objIsWrapped = objIsObj && hasOwnProperty.call(object, "__wrapped__"), othIsWrapped = othIsObj && hasOwnProperty.call(other, "__wrapped__");
                if (objIsWrapped || othIsWrapped) {
                    var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
                    stack || (stack = new Stack);
                    return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
                }
            }
            if (!isSameTag) return false;
            stack || (stack = new Stack);
            return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
        }
        /**
     * The base implementation of `_.isMap` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     */ function baseIsMap(value) {
            return isObjectLike(value) && getTag(value) == mapTag;
        }
        /**
     * The base implementation of `_.isMatch` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Array} matchData The property names, values, and compare flags to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     */ function baseIsMatch(object, source, matchData, customizer) {
            var index = matchData.length, length = index, noCustomizer = !customizer;
            if (object == null) return !length;
            object = Object1(object);
            while(index--){
                var data = matchData[index];
                if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) return false;
            }
            while(++index < length){
                data = matchData[index];
                var key = data[0], objValue = object[key], srcValue = data[1];
                if (noCustomizer && data[2]) {
                    if (objValue === undefined && !(key in object)) return false;
                } else {
                    var stack = new Stack;
                    if (customizer) var result = customizer(objValue, srcValue, key, object, source, stack);
                    if (!(result === undefined ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack) : result)) return false;
                }
            }
            return true;
        }
        /**
     * The base implementation of `_.isNative` without bad shim checks.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     */ function baseIsNative(value) {
            if (!isObject(value) || isMasked(value)) return false;
            var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
            return pattern.test(toSource(value));
        }
        /**
     * The base implementation of `_.isRegExp` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     */ function baseIsRegExp(value) {
            return isObjectLike(value) && baseGetTag(value) == regexpTag;
        }
        /**
     * The base implementation of `_.isSet` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     */ function baseIsSet(value) {
            return isObjectLike(value) && getTag(value) == setTag;
        }
        /**
     * The base implementation of `_.isTypedArray` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     */ function baseIsTypedArray(value) {
            return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
        }
        /**
     * The base implementation of `_.iteratee`.
     *
     * @private
     * @param {*} [value=_.identity] The value to convert to an iteratee.
     * @returns {Function} Returns the iteratee.
     */ function baseIteratee(value) {
            // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
            // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
            if (typeof value == "function") return value;
            if (value == null) return identity;
            if (typeof value == "object") return isArray(value) ? baseMatchesProperty(value[0], value[1]) : baseMatches(value);
            return property(value);
        }
        /**
     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function baseKeys(object) {
            if (!isPrototype(object)) return nativeKeys(object);
            var result = [];
            for(var key in Object1(object))if (hasOwnProperty.call(object, key) && key != "constructor") result.push(key);
            return result;
        }
        /**
     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function baseKeysIn(object) {
            if (!isObject(object)) return nativeKeysIn(object);
            var isProto = isPrototype(object), result = [];
            for(var key in object)if (!(key == "constructor" && (isProto || !hasOwnProperty.call(object, key)))) result.push(key);
            return result;
        }
        /**
     * The base implementation of `_.lt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     */ function baseLt(value, other) {
            return value < other;
        }
        /**
     * The base implementation of `_.map` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     */ function baseMap(collection, iteratee) {
            var index = -1, result = isArrayLike(collection) ? Array1(collection.length) : [];
            baseEach(collection, function(value, key, collection) {
                result[++index] = iteratee(value, key, collection);
            });
            return result;
        }
        /**
     * The base implementation of `_.matches` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     */ function baseMatches(source) {
            var matchData = getMatchData(source);
            if (matchData.length == 1 && matchData[0][2]) return matchesStrictComparable(matchData[0][0], matchData[0][1]);
            return function(object) {
                return object === source || baseIsMatch(object, source, matchData);
            };
        }
        /**
     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
     *
     * @private
     * @param {string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */ function baseMatchesProperty(path, srcValue) {
            if (isKey(path) && isStrictComparable(srcValue)) return matchesStrictComparable(toKey(path), srcValue);
            return function(object) {
                var objValue = get(object, path);
                return objValue === undefined && objValue === srcValue ? hasIn(object, path) : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
            };
        }
        /**
     * The base implementation of `_.merge` without support for multiple sources.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} [customizer] The function to customize merged values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */ function baseMerge(object, source, srcIndex, customizer, stack) {
            if (object === source) return;
            baseFor(source, function(srcValue, key) {
                stack || (stack = new Stack);
                if (isObject(srcValue)) baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
                else {
                    var newValue = customizer ? customizer(safeGet(object, key), srcValue, key + "", object, source, stack) : undefined;
                    if (newValue === undefined) newValue = srcValue;
                    assignMergeValue(object, key, newValue);
                }
            }, keysIn);
        }
        /**
     * A specialized version of `baseMerge` for arrays and objects which performs
     * deep merges and tracks traversed objects enabling objects with circular
     * references to be merged.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {string} key The key of the value to merge.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} mergeFunc The function to merge values.
     * @param {Function} [customizer] The function to customize assigned values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */ function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
            var objValue = safeGet(object, key), srcValue = safeGet(source, key), stacked = stack.get(srcValue);
            if (stacked) {
                assignMergeValue(object, key, stacked);
                return;
            }
            var newValue = customizer ? customizer(objValue, srcValue, key + "", object, source, stack) : undefined;
            var isCommon = newValue === undefined;
            if (isCommon) {
                var isArr = isArray(srcValue), isBuff = !isArr && isBuffer(srcValue), isTyped = !isArr && !isBuff && isTypedArray(srcValue);
                newValue = srcValue;
                if (isArr || isBuff || isTyped) {
                    if (isArray(objValue)) newValue = objValue;
                    else if (isArrayLikeObject(objValue)) newValue = copyArray(objValue);
                    else if (isBuff) {
                        isCommon = false;
                        newValue = cloneBuffer(srcValue, true);
                    } else if (isTyped) {
                        isCommon = false;
                        newValue = cloneTypedArray(srcValue, true);
                    } else newValue = [];
                } else if (isPlainObject(srcValue) || isArguments(srcValue)) {
                    newValue = objValue;
                    if (isArguments(objValue)) newValue = toPlainObject(objValue);
                    else if (!isObject(objValue) || isFunction(objValue)) newValue = initCloneObject(srcValue);
                } else isCommon = false;
            }
            if (isCommon) {
                // Recursively merge objects and arrays (susceptible to call stack limits).
                stack.set(srcValue, newValue);
                mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
                stack["delete"](srcValue);
            }
            assignMergeValue(object, key, newValue);
        }
        /**
     * The base implementation of `_.nth` which doesn't coerce arguments.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {number} n The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     */ function baseNth(array, n) {
            var length = array.length;
            if (!length) return;
            n += n < 0 ? length : 0;
            return isIndex(n, length) ? array[n] : undefined;
        }
        /**
     * The base implementation of `_.orderBy` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
     * @param {string[]} orders The sort orders of `iteratees`.
     * @returns {Array} Returns the new sorted array.
     */ function baseOrderBy(collection, iteratees, orders) {
            if (iteratees.length) iteratees = arrayMap(iteratees, function(iteratee) {
                if (isArray(iteratee)) return function(value) {
                    return baseGet(value, iteratee.length === 1 ? iteratee[0] : iteratee);
                };
                return iteratee;
            });
            else iteratees = [
                identity
            ];
            var index = -1;
            iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
            var result = baseMap(collection, function(value, key, collection) {
                var criteria = arrayMap(iteratees, function(iteratee) {
                    return iteratee(value);
                });
                return {
                    "criteria": criteria,
                    "index": ++index,
                    "value": value
                };
            });
            return baseSortBy(result, function(object, other) {
                return compareMultiple(object, other, orders);
            });
        }
        /**
     * The base implementation of `_.pick` without support for individual
     * property identifiers.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @returns {Object} Returns the new object.
     */ function basePick(object, paths) {
            return basePickBy(object, paths, function(value, path) {
                return hasIn(object, path);
            });
        }
        /**
     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @param {Function} predicate The function invoked per property.
     * @returns {Object} Returns the new object.
     */ function basePickBy(object, paths, predicate) {
            var index = -1, length = paths.length, result = {};
            while(++index < length){
                var path = paths[index], value = baseGet(object, path);
                if (predicate(value, path)) baseSet(result, castPath(path, object), value);
            }
            return result;
        }
        /**
     * A specialized version of `baseProperty` which supports deep paths.
     *
     * @private
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     */ function basePropertyDeep(path) {
            return function(object) {
                return baseGet(object, path);
            };
        }
        /**
     * The base implementation of `_.pullAllBy` without support for iteratee
     * shorthands.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     */ function basePullAll(array, values, iteratee, comparator) {
            var indexOf = comparator ? baseIndexOfWith : baseIndexOf, index = -1, length = values.length, seen = array;
            if (array === values) values = copyArray(values);
            if (iteratee) seen = arrayMap(array, baseUnary(iteratee));
            while(++index < length){
                var fromIndex = 0, value = values[index], computed = iteratee ? iteratee(value) : value;
                while((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1){
                    if (seen !== array) splice.call(seen, fromIndex, 1);
                    splice.call(array, fromIndex, 1);
                }
            }
            return array;
        }
        /**
     * The base implementation of `_.pullAt` without support for individual
     * indexes or capturing the removed elements.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {number[]} indexes The indexes of elements to remove.
     * @returns {Array} Returns `array`.
     */ function basePullAt(array, indexes) {
            var length = array ? indexes.length : 0, lastIndex = length - 1;
            while(length--){
                var index = indexes[length];
                if (length == lastIndex || index !== previous) {
                    var previous = index;
                    if (isIndex(index)) splice.call(array, index, 1);
                    else baseUnset(array, index);
                }
            }
            return array;
        }
        /**
     * The base implementation of `_.random` without support for returning
     * floating-point numbers.
     *
     * @private
     * @param {number} lower The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the random number.
     */ function baseRandom(lower, upper) {
            return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
        }
        /**
     * The base implementation of `_.range` and `_.rangeRight` which doesn't
     * coerce arguments.
     *
     * @private
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @param {number} step The value to increment or decrement by.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the range of numbers.
     */ function baseRange(start, end, step, fromRight) {
            var index = -1, length = nativeMax(nativeCeil((end - start) / (step || 1)), 0), result = Array1(length);
            while(length--){
                result[fromRight ? length : ++index] = start;
                start += step;
            }
            return result;
        }
        /**
     * The base implementation of `_.repeat` which doesn't coerce arguments.
     *
     * @private
     * @param {string} string The string to repeat.
     * @param {number} n The number of times to repeat the string.
     * @returns {string} Returns the repeated string.
     */ function baseRepeat(string, n) {
            var result = "";
            if (!string || n < 1 || n > MAX_SAFE_INTEGER) return result;
            // Leverage the exponentiation by squaring algorithm for a faster repeat.
            // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
            do {
                if (n % 2) result += string;
                n = nativeFloor(n / 2);
                if (n) string += string;
            }while (n);
            return result;
        }
        /**
     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     */ function baseRest(func, start) {
            return setToString(overRest(func, start, identity), func + "");
        }
        /**
     * The base implementation of `_.sample`.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     */ function baseSample(collection) {
            return arraySample(values(collection));
        }
        /**
     * The base implementation of `_.sampleSize` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */ function baseSampleSize(collection, n) {
            var array = values(collection);
            return shuffleSelf(array, baseClamp(n, 0, array.length));
        }
        /**
     * The base implementation of `_.set`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */ function baseSet(object, path, value, customizer) {
            if (!isObject(object)) return object;
            path = castPath(path, object);
            var index = -1, length = path.length, lastIndex = length - 1, nested = object;
            while(nested != null && ++index < length){
                var key = toKey(path[index]), newValue = value;
                if (key === "__proto__" || key === "constructor" || key === "prototype") return object;
                if (index != lastIndex) {
                    var objValue = nested[key];
                    newValue = customizer ? customizer(objValue, key, nested) : undefined;
                    if (newValue === undefined) newValue = isObject(objValue) ? objValue : isIndex(path[index + 1]) ? [] : {};
                }
                assignValue(nested, key, newValue);
                nested = nested[key];
            }
            return object;
        }
        /**
     * The base implementation of `setData` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */ var baseSetData = !metaMap ? identity : function(func, data) {
            metaMap.set(func, data);
            return func;
        };
        /**
     * The base implementation of `setToString` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */ var baseSetToString = !defineProperty ? identity : function(func, string) {
            return defineProperty(func, "toString", {
                "configurable": true,
                "enumerable": false,
                "value": constant(string),
                "writable": true
            });
        };
        /**
     * The base implementation of `_.shuffle`.
     *
     * @private
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */ function baseShuffle(collection) {
            return shuffleSelf(values(collection));
        }
        /**
     * The base implementation of `_.slice` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */ function baseSlice(array, start, end) {
            var index = -1, length = array.length;
            if (start < 0) start = -start > length ? 0 : length + start;
            end = end > length ? length : end;
            if (end < 0) end += length;
            length = start > end ? 0 : end - start >>> 0;
            start >>>= 0;
            var result = Array1(length);
            while(++index < length)result[index] = array[index + start];
            return result;
        }
        /**
     * The base implementation of `_.some` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     */ function baseSome(collection, predicate) {
            var result;
            baseEach(collection, function(value, index, collection) {
                result = predicate(value, index, collection);
                return !result;
            });
            return !!result;
        }
        /**
     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
     * performs a binary search of `array` to determine the index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */ function baseSortedIndex(array, value, retHighest) {
            var low = 0, high = array == null ? low : array.length;
            if (typeof value == "number" && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
                while(low < high){
                    var mid = low + high >>> 1, computed = array[mid];
                    if (computed !== null && !isSymbol(computed) && (retHighest ? computed <= value : computed < value)) low = mid + 1;
                    else high = mid;
                }
                return high;
            }
            return baseSortedIndexBy(array, value, identity, retHighest);
        }
        /**
     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
     * which invokes `iteratee` for `value` and each element of `array` to compute
     * their sort ranking. The iteratee is invoked with one argument; (value).
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} iteratee The iteratee invoked per element.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */ function baseSortedIndexBy(array, value, iteratee, retHighest) {
            var low = 0, high = array == null ? 0 : array.length;
            if (high === 0) return 0;
            value = iteratee(value);
            var valIsNaN = value !== value, valIsNull = value === null, valIsSymbol = isSymbol(value), valIsUndefined = value === undefined;
            while(low < high){
                var mid = nativeFloor((low + high) / 2), computed = iteratee(array[mid]), othIsDefined = computed !== undefined, othIsNull = computed === null, othIsReflexive = computed === computed, othIsSymbol = isSymbol(computed);
                if (valIsNaN) var setLow = retHighest || othIsReflexive;
                else if (valIsUndefined) setLow = othIsReflexive && (retHighest || othIsDefined);
                else if (valIsNull) setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
                else if (valIsSymbol) setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
                else if (othIsNull || othIsSymbol) setLow = false;
                else setLow = retHighest ? computed <= value : computed < value;
                if (setLow) low = mid + 1;
                else high = mid;
            }
            return nativeMin(high, MAX_ARRAY_INDEX);
        }
        /**
     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
     * support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */ function baseSortedUniq(array, iteratee) {
            var index = -1, length = array.length, resIndex = 0, result = [];
            while(++index < length){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                if (!index || !eq(computed, seen)) {
                    var seen = computed;
                    result[resIndex++] = value === 0 ? 0 : value;
                }
            }
            return result;
        }
        /**
     * The base implementation of `_.toNumber` which doesn't ensure correct
     * conversions of binary, hexadecimal, or octal string values.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     */ function baseToNumber(value) {
            if (typeof value == "number") return value;
            if (isSymbol(value)) return NAN;
            return +value;
        }
        /**
     * The base implementation of `_.toString` which doesn't convert nullish
     * values to empty strings.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {string} Returns the string.
     */ function baseToString(value) {
            // Exit early for strings to avoid a performance hit in some environments.
            if (typeof value == "string") return value;
            if (isArray(value)) // Recursively convert values (susceptible to call stack limits).
            return arrayMap(value, baseToString) + "";
            if (isSymbol(value)) return symbolToString ? symbolToString.call(value) : "";
            var result = value + "";
            return result == "0" && 1 / value == -INFINITY ? "-0" : result;
        }
        /**
     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */ function baseUniq(array, iteratee, comparator) {
            var index = -1, includes = arrayIncludes, length = array.length, isCommon = true, result = [], seen = result;
            if (comparator) {
                isCommon = false;
                includes = arrayIncludesWith;
            } else if (length >= LARGE_ARRAY_SIZE) {
                var set = iteratee ? null : createSet(array);
                if (set) return setToArray(set);
                isCommon = false;
                includes = cacheHas;
                seen = new SetCache;
            } else seen = iteratee ? [] : result;
            outer: while(++index < length){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                value = comparator || value !== 0 ? value : 0;
                if (isCommon && computed === computed) {
                    var seenIndex = seen.length;
                    while(seenIndex--){
                        if (seen[seenIndex] === computed) continue outer;
                    }
                    if (iteratee) seen.push(computed);
                    result.push(value);
                } else if (!includes(seen, computed, comparator)) {
                    if (seen !== result) seen.push(computed);
                    result.push(value);
                }
            }
            return result;
        }
        /**
     * The base implementation of `_.unset`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The property path to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     */ function baseUnset(object, path) {
            path = castPath(path, object);
            object = parent(object, path);
            return object == null || delete object[toKey(last(path))];
        }
        /**
     * The base implementation of `_.update`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to update.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */ function baseUpdate(object, path, updater, customizer) {
            return baseSet(object, path, updater(baseGet(object, path)), customizer);
        }
        /**
     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
     * without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {Function} predicate The function invoked per iteration.
     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the slice of `array`.
     */ function baseWhile(array, predicate, isDrop, fromRight) {
            var length = array.length, index = fromRight ? length : -1;
            while((fromRight ? index-- : ++index < length) && predicate(array[index], index, array));
            return isDrop ? baseSlice(array, fromRight ? 0 : index, fromRight ? index + 1 : length) : baseSlice(array, fromRight ? index + 1 : 0, fromRight ? length : index);
        }
        /**
     * The base implementation of `wrapperValue` which returns the result of
     * performing a sequence of actions on the unwrapped `value`, where each
     * successive action is supplied the return value of the previous.
     *
     * @private
     * @param {*} value The unwrapped value.
     * @param {Array} actions Actions to perform to resolve the unwrapped value.
     * @returns {*} Returns the resolved value.
     */ function baseWrapperValue(value, actions) {
            var result = value;
            if (result instanceof LazyWrapper) result = result.value();
            return arrayReduce(actions, function(result, action) {
                return action.func.apply(action.thisArg, arrayPush([
                    result
                ], action.args));
            }, result);
        }
        /**
     * The base implementation of methods like `_.xor`, without support for
     * iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of values.
     */ function baseXor(arrays, iteratee, comparator) {
            var length = arrays.length;
            if (length < 2) return length ? baseUniq(arrays[0]) : [];
            var index = -1, result = Array1(length);
            while(++index < length){
                var array = arrays[index], othIndex = -1;
                while(++othIndex < length)if (othIndex != index) result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
            }
            return baseUniq(baseFlatten(result, 1), iteratee, comparator);
        }
        /**
     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
     *
     * @private
     * @param {Array} props The property identifiers.
     * @param {Array} values The property values.
     * @param {Function} assignFunc The function to assign values.
     * @returns {Object} Returns the new object.
     */ function baseZipObject(props, values, assignFunc) {
            var index = -1, length = props.length, valsLength = values.length, result = {};
            while(++index < length){
                var value = index < valsLength ? values[index] : undefined;
                assignFunc(result, props[index], value);
            }
            return result;
        }
        /**
     * Casts `value` to an empty array if it's not an array like object.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Array|Object} Returns the cast array-like object.
     */ function castArrayLikeObject(value) {
            return isArrayLikeObject(value) ? value : [];
        }
        /**
     * Casts `value` to `identity` if it's not a function.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Function} Returns cast function.
     */ function castFunction(value) {
            return typeof value == "function" ? value : identity;
        }
        /**
     * Casts `value` to a path array if it's not one.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {Object} [object] The object to query keys on.
     * @returns {Array} Returns the cast property path array.
     */ function castPath(value, object) {
            if (isArray(value)) return value;
            return isKey(value, object) ? [
                value
            ] : stringToPath(toString(value));
        }
        /**
     * A `baseRest` alias which can be replaced with `identity` by module
     * replacement plugins.
     *
     * @private
     * @type {Function}
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */ var castRest = baseRest;
        /**
     * Casts `array` to a slice if it's needed.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {number} start The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the cast slice.
     */ function castSlice(array, start, end) {
            var length = array.length;
            end = end === undefined ? length : end;
            return !start && end >= length ? array : baseSlice(array, start, end);
        }
        /**
     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
     *
     * @private
     * @param {number|Object} id The timer id or timeout object of the timer to clear.
     */ var clearTimeout = ctxClearTimeout || function(id) {
            return root.clearTimeout(id);
        };
        /**
     * Creates a clone of  `buffer`.
     *
     * @private
     * @param {Buffer} buffer The buffer to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Buffer} Returns the cloned buffer.
     */ function cloneBuffer(buffer, isDeep) {
            if (isDeep) return buffer.slice();
            var length = buffer.length, result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
            buffer.copy(result);
            return result;
        }
        /**
     * Creates a clone of `arrayBuffer`.
     *
     * @private
     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
     * @returns {ArrayBuffer} Returns the cloned array buffer.
     */ function cloneArrayBuffer(arrayBuffer) {
            var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
            new Uint8Array(result).set(new Uint8Array(arrayBuffer));
            return result;
        }
        /**
     * Creates a clone of `dataView`.
     *
     * @private
     * @param {Object} dataView The data view to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned data view.
     */ function cloneDataView(dataView, isDeep) {
            var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
            return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
        }
        /**
     * Creates a clone of `regexp`.
     *
     * @private
     * @param {Object} regexp The regexp to clone.
     * @returns {Object} Returns the cloned regexp.
     */ function cloneRegExp(regexp) {
            var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
            result.lastIndex = regexp.lastIndex;
            return result;
        }
        /**
     * Creates a clone of the `symbol` object.
     *
     * @private
     * @param {Object} symbol The symbol object to clone.
     * @returns {Object} Returns the cloned symbol object.
     */ function cloneSymbol(symbol) {
            return symbolValueOf ? Object1(symbolValueOf.call(symbol)) : {};
        }
        /**
     * Creates a clone of `typedArray`.
     *
     * @private
     * @param {Object} typedArray The typed array to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned typed array.
     */ function cloneTypedArray(typedArray, isDeep) {
            var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
            return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
        }
        /**
     * Compares values to sort them in ascending order.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {number} Returns the sort order indicator for `value`.
     */ function compareAscending(value, other) {
            if (value !== other) {
                var valIsDefined = value !== undefined, valIsNull = value === null, valIsReflexive = value === value, valIsSymbol = isSymbol(value);
                var othIsDefined = other !== undefined, othIsNull = other === null, othIsReflexive = other === other, othIsSymbol = isSymbol(other);
                if (!othIsNull && !othIsSymbol && !valIsSymbol && value > other || valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol || valIsNull && othIsDefined && othIsReflexive || !valIsDefined && othIsReflexive || !valIsReflexive) return 1;
                if (!valIsNull && !valIsSymbol && !othIsSymbol && value < other || othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol || othIsNull && valIsDefined && valIsReflexive || !othIsDefined && valIsReflexive || !othIsReflexive) return -1;
            }
            return 0;
        }
        /**
     * Used by `_.orderBy` to compare multiple properties of a value to another
     * and stable sort them.
     *
     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
     * specify an order of "desc" for descending or "asc" for ascending sort order
     * of corresponding values.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {boolean[]|string[]} orders The order to sort by for each property.
     * @returns {number} Returns the sort order indicator for `object`.
     */ function compareMultiple(object, other, orders) {
            var index = -1, objCriteria = object.criteria, othCriteria = other.criteria, length = objCriteria.length, ordersLength = orders.length;
            while(++index < length){
                var result = compareAscending(objCriteria[index], othCriteria[index]);
                if (result) {
                    if (index >= ordersLength) return result;
                    var order = orders[index];
                    return result * (order == "desc" ? -1 : 1);
                }
            }
            // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
            // that causes it, under certain circumstances, to provide the same value for
            // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
            // for more details.
            //
            // This also ensures a stable sort in V8 and other engines.
            // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
            return object.index - other.index;
        }
        /**
     * Creates an array that is the composition of partially applied arguments,
     * placeholders, and provided arguments into a single array of arguments.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to prepend to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */ function composeArgs(args, partials, holders, isCurried) {
            var argsIndex = -1, argsLength = args.length, holdersLength = holders.length, leftIndex = -1, leftLength = partials.length, rangeLength = nativeMax(argsLength - holdersLength, 0), result = Array1(leftLength + rangeLength), isUncurried = !isCurried;
            while(++leftIndex < leftLength)result[leftIndex] = partials[leftIndex];
            while(++argsIndex < holdersLength)if (isUncurried || argsIndex < argsLength) result[holders[argsIndex]] = args[argsIndex];
            while(rangeLength--)result[leftIndex++] = args[argsIndex++];
            return result;
        }
        /**
     * This function is like `composeArgs` except that the arguments composition
     * is tailored for `_.partialRight`.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to append to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */ function composeArgsRight(args, partials, holders, isCurried) {
            var argsIndex = -1, argsLength = args.length, holdersIndex = -1, holdersLength = holders.length, rightIndex = -1, rightLength = partials.length, rangeLength = nativeMax(argsLength - holdersLength, 0), result = Array1(rangeLength + rightLength), isUncurried = !isCurried;
            while(++argsIndex < rangeLength)result[argsIndex] = args[argsIndex];
            var offset = argsIndex;
            while(++rightIndex < rightLength)result[offset + rightIndex] = partials[rightIndex];
            while(++holdersIndex < holdersLength)if (isUncurried || argsIndex < argsLength) result[offset + holders[holdersIndex]] = args[argsIndex++];
            return result;
        }
        /**
     * Copies the values of `source` to `array`.
     *
     * @private
     * @param {Array} source The array to copy values from.
     * @param {Array} [array=[]] The array to copy values to.
     * @returns {Array} Returns `array`.
     */ function copyArray(source, array) {
            var index = -1, length = source.length;
            array || (array = Array1(length));
            while(++index < length)array[index] = source[index];
            return array;
        }
        /**
     * Copies properties of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy properties from.
     * @param {Array} props The property identifiers to copy.
     * @param {Object} [object={}] The object to copy properties to.
     * @param {Function} [customizer] The function to customize copied values.
     * @returns {Object} Returns `object`.
     */ function copyObject(source, props, object, customizer) {
            var isNew = !object;
            object || (object = {});
            var index = -1, length = props.length;
            while(++index < length){
                var key = props[index];
                var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;
                if (newValue === undefined) newValue = source[key];
                if (isNew) baseAssignValue(object, key, newValue);
                else assignValue(object, key, newValue);
            }
            return object;
        }
        /**
     * Copies own symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */ function copySymbols(source, object) {
            return copyObject(source, getSymbols(source), object);
        }
        /**
     * Copies own and inherited symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */ function copySymbolsIn(source, object) {
            return copyObject(source, getSymbolsIn(source), object);
        }
        /**
     * Creates a function like `_.groupBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} [initializer] The accumulator object initializer.
     * @returns {Function} Returns the new aggregator function.
     */ function createAggregator(setter, initializer) {
            return function(collection, iteratee) {
                var func = isArray(collection) ? arrayAggregator : baseAggregator, accumulator = initializer ? initializer() : {};
                return func(collection, setter, getIteratee(iteratee, 2), accumulator);
            };
        }
        /**
     * Creates a function like `_.assign`.
     *
     * @private
     * @param {Function} assigner The function to assign values.
     * @returns {Function} Returns the new assigner function.
     */ function createAssigner(assigner) {
            return baseRest(function(object, sources) {
                var index = -1, length = sources.length, customizer = length > 1 ? sources[length - 1] : undefined, guard = length > 2 ? sources[2] : undefined;
                customizer = assigner.length > 3 && typeof customizer == "function" ? (length--, customizer) : undefined;
                if (guard && isIterateeCall(sources[0], sources[1], guard)) {
                    customizer = length < 3 ? undefined : customizer;
                    length = 1;
                }
                object = Object1(object);
                while(++index < length){
                    var source = sources[index];
                    if (source) assigner(object, source, index, customizer);
                }
                return object;
            });
        }
        /**
     * Creates a `baseEach` or `baseEachRight` function.
     *
     * @private
     * @param {Function} eachFunc The function to iterate over a collection.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */ function createBaseEach(eachFunc, fromRight) {
            return function(collection, iteratee) {
                if (collection == null) return collection;
                if (!isArrayLike(collection)) return eachFunc(collection, iteratee);
                var length = collection.length, index = fromRight ? length : -1, iterable = Object1(collection);
                while(fromRight ? index-- : ++index < length){
                    if (iteratee(iterable[index], index, iterable) === false) break;
                }
                return collection;
            };
        }
        /**
     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */ function createBaseFor(fromRight) {
            return function(object, iteratee, keysFunc) {
                var index = -1, iterable = Object1(object), props = keysFunc(object), length = props.length;
                while(length--){
                    var key = props[fromRight ? length : ++index];
                    if (iteratee(iterable[key], key, iterable) === false) break;
                }
                return object;
            };
        }
        /**
     * Creates a function that wraps `func` to invoke it with the optional `this`
     * binding of `thisArg`.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createBind(func, bitmask, thisArg) {
            var isBind = bitmask & WRAP_BIND_FLAG, Ctor = createCtor(func);
            function wrapper() {
                var fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                return fn.apply(isBind ? thisArg : this, arguments);
            }
            return wrapper;
        }
        /**
     * Creates a function like `_.lowerFirst`.
     *
     * @private
     * @param {string} methodName The name of the `String` case method to use.
     * @returns {Function} Returns the new case function.
     */ function createCaseFirst(methodName) {
            return function(string) {
                string = toString(string);
                var strSymbols = hasUnicode(string) ? stringToArray(string) : undefined;
                var chr = strSymbols ? strSymbols[0] : string.charAt(0);
                var trailing = strSymbols ? castSlice(strSymbols, 1).join("") : string.slice(1);
                return chr[methodName]() + trailing;
            };
        }
        /**
     * Creates a function like `_.camelCase`.
     *
     * @private
     * @param {Function} callback The function to combine each word.
     * @returns {Function} Returns the new compounder function.
     */ function createCompounder(callback) {
            return function(string) {
                return arrayReduce(words(deburr(string).replace(reApos, "")), callback, "");
            };
        }
        /**
     * Creates a function that produces an instance of `Ctor` regardless of
     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
     *
     * @private
     * @param {Function} Ctor The constructor to wrap.
     * @returns {Function} Returns the new wrapped function.
     */ function createCtor(Ctor) {
            return function() {
                // Use a `switch` statement to work with class constructors. See
                // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
                // for more details.
                var args = arguments;
                switch(args.length){
                    case 0:
                        return new Ctor;
                    case 1:
                        return new Ctor(args[0]);
                    case 2:
                        return new Ctor(args[0], args[1]);
                    case 3:
                        return new Ctor(args[0], args[1], args[2]);
                    case 4:
                        return new Ctor(args[0], args[1], args[2], args[3]);
                    case 5:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4]);
                    case 6:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
                    case 7:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
                }
                var thisBinding = baseCreate(Ctor.prototype), result = Ctor.apply(thisBinding, args);
                // Mimic the constructor's `return` behavior.
                // See https://es5.github.io/#x13.2.2 for more details.
                return isObject(result) ? result : thisBinding;
            };
        }
        /**
     * Creates a function that wraps `func` to enable currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {number} arity The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createCurry(func, bitmask, arity) {
            var Ctor = createCtor(func);
            function wrapper() {
                var length = arguments.length, args = Array1(length), index = length, placeholder = getHolder(wrapper);
                while(index--)args[index] = arguments[index];
                var holders = length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder ? [] : replaceHolders(args, placeholder);
                length -= holders.length;
                if (length < arity) return createRecurry(func, bitmask, createHybrid, wrapper.placeholder, undefined, args, holders, undefined, undefined, arity - length);
                var fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                return apply(fn, this, args);
            }
            return wrapper;
        }
        /**
     * Creates a `_.find` or `_.findLast` function.
     *
     * @private
     * @param {Function} findIndexFunc The function to find the collection index.
     * @returns {Function} Returns the new find function.
     */ function createFind(findIndexFunc) {
            return function(collection, predicate, fromIndex) {
                var iterable = Object1(collection);
                if (!isArrayLike(collection)) {
                    var iteratee = getIteratee(predicate, 3);
                    collection = keys(collection);
                    predicate = function(key) {
                        return iteratee(iterable[key], key, iterable);
                    };
                }
                var index = findIndexFunc(collection, predicate, fromIndex);
                return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
            };
        }
        /**
     * Creates a `_.flow` or `_.flowRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new flow function.
     */ function createFlow(fromRight) {
            return flatRest(function(funcs) {
                var length = funcs.length, index = length, prereq = LodashWrapper.prototype.thru;
                if (fromRight) funcs.reverse();
                while(index--){
                    var func = funcs[index];
                    if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
                    if (prereq && !wrapper && getFuncName(func) == "wrapper") var wrapper = new LodashWrapper([], true);
                }
                index = wrapper ? index : length;
                while(++index < length){
                    func = funcs[index];
                    var funcName = getFuncName(func), data = funcName == "wrapper" ? getData(func) : undefined;
                    if (data && isLaziable(data[0]) && data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) && !data[4].length && data[9] == 1) wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
                    else wrapper = func.length == 1 && isLaziable(func) ? wrapper[funcName]() : wrapper.thru(func);
                }
                return function() {
                    var args = arguments, value = args[0];
                    if (wrapper && args.length == 1 && isArray(value)) return wrapper.plant(value).value();
                    var index = 0, result = length ? funcs[index].apply(this, args) : value;
                    while(++index < length)result = funcs[index].call(this, result);
                    return result;
                };
            });
        }
        /**
     * Creates a function that wraps `func` to invoke it with optional `this`
     * binding of `thisArg`, partial application, and currying.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [partialsRight] The arguments to append to those provided
     *  to the new function.
     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
            var isAry = bitmask & WRAP_ARY_FLAG, isBind = bitmask & WRAP_BIND_FLAG, isBindKey = bitmask & WRAP_BIND_KEY_FLAG, isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG), isFlip = bitmask & WRAP_FLIP_FLAG, Ctor = isBindKey ? undefined : createCtor(func);
            function wrapper() {
                var length = arguments.length, args = Array1(length), index = length;
                while(index--)args[index] = arguments[index];
                if (isCurried) var placeholder = getHolder(wrapper), holdersCount = countHolders(args, placeholder);
                if (partials) args = composeArgs(args, partials, holders, isCurried);
                if (partialsRight) args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
                length -= holdersCount;
                if (isCurried && length < arity) {
                    var newHolders = replaceHolders(args, placeholder);
                    return createRecurry(func, bitmask, createHybrid, wrapper.placeholder, thisArg, args, newHolders, argPos, ary, arity - length);
                }
                var thisBinding = isBind ? thisArg : this, fn = isBindKey ? thisBinding[func] : func;
                length = args.length;
                if (argPos) args = reorder(args, argPos);
                else if (isFlip && length > 1) args.reverse();
                if (isAry && ary < length) args.length = ary;
                if (this && this !== root && this instanceof wrapper) fn = Ctor || createCtor(fn);
                return fn.apply(thisBinding, args);
            }
            return wrapper;
        }
        /**
     * Creates a function like `_.invertBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} toIteratee The function to resolve iteratees.
     * @returns {Function} Returns the new inverter function.
     */ function createInverter(setter, toIteratee) {
            return function(object, iteratee) {
                return baseInverter(object, setter, toIteratee(iteratee), {});
            };
        }
        /**
     * Creates a function that performs a mathematical operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @param {number} [defaultValue] The value used for `undefined` arguments.
     * @returns {Function} Returns the new mathematical operation function.
     */ function createMathOperation(operator, defaultValue) {
            return function(value, other) {
                var result;
                if (value === undefined && other === undefined) return defaultValue;
                if (value !== undefined) result = value;
                if (other !== undefined) {
                    if (result === undefined) return other;
                    if (typeof value == "string" || typeof other == "string") {
                        value = baseToString(value);
                        other = baseToString(other);
                    } else {
                        value = baseToNumber(value);
                        other = baseToNumber(other);
                    }
                    result = operator(value, other);
                }
                return result;
            };
        }
        /**
     * Creates a function like `_.over`.
     *
     * @private
     * @param {Function} arrayFunc The function to iterate over iteratees.
     * @returns {Function} Returns the new over function.
     */ function createOver(arrayFunc) {
            return flatRest(function(iteratees) {
                iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
                return baseRest(function(args) {
                    var thisArg = this;
                    return arrayFunc(iteratees, function(iteratee) {
                        return apply(iteratee, thisArg, args);
                    });
                });
            });
        }
        /**
     * Creates the padding for `string` based on `length`. The `chars` string
     * is truncated if the number of characters exceeds `length`.
     *
     * @private
     * @param {number} length The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padding for `string`.
     */ function createPadding(length, chars) {
            chars = chars === undefined ? " " : baseToString(chars);
            var charsLength = chars.length;
            if (charsLength < 2) return charsLength ? baseRepeat(chars, length) : chars;
            var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
            return hasUnicode(chars) ? castSlice(stringToArray(result), 0, length).join("") : result.slice(0, length);
        }
        /**
     * Creates a function that wraps `func` to invoke it with the `this` binding
     * of `thisArg` and `partials` prepended to the arguments it receives.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {Array} partials The arguments to prepend to those provided to
     *  the new function.
     * @returns {Function} Returns the new wrapped function.
     */ function createPartial(func, bitmask, thisArg, partials) {
            var isBind = bitmask & WRAP_BIND_FLAG, Ctor = createCtor(func);
            function wrapper() {
                var argsIndex = -1, argsLength = arguments.length, leftIndex = -1, leftLength = partials.length, args = Array1(leftLength + argsLength), fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                while(++leftIndex < leftLength)args[leftIndex] = partials[leftIndex];
                while(argsLength--)args[leftIndex++] = arguments[++argsIndex];
                return apply(fn, isBind ? thisArg : this, args);
            }
            return wrapper;
        }
        /**
     * Creates a `_.range` or `_.rangeRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new range function.
     */ function createRange(fromRight) {
            return function(start, end, step) {
                if (step && typeof step != "number" && isIterateeCall(start, end, step)) end = step = undefined;
                // Ensure the sign of `-0` is preserved.
                start = toFinite(start);
                if (end === undefined) {
                    end = start;
                    start = 0;
                } else end = toFinite(end);
                step = step === undefined ? start < end ? 1 : -1 : toFinite(step);
                return baseRange(start, end, step, fromRight);
            };
        }
        /**
     * Creates a function that performs a relational operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @returns {Function} Returns the new relational operation function.
     */ function createRelationalOperation(operator) {
            return function(value, other) {
                if (!(typeof value == "string" && typeof other == "string")) {
                    value = toNumber(value);
                    other = toNumber(other);
                }
                return operator(value, other);
            };
        }
        /**
     * Creates a function that wraps `func` to continue currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {Function} wrapFunc The function to create the `func` wrapper.
     * @param {*} placeholder The placeholder value.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
            var isCurry = bitmask & WRAP_CURRY_FLAG, newHolders = isCurry ? holders : undefined, newHoldersRight = isCurry ? undefined : holders, newPartials = isCurry ? partials : undefined, newPartialsRight = isCurry ? undefined : partials;
            bitmask |= isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG;
            bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);
            if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
            var newData = [
                func,
                bitmask,
                thisArg,
                newPartials,
                newHolders,
                newPartialsRight,
                newHoldersRight,
                argPos,
                ary,
                arity
            ];
            var result = wrapFunc.apply(undefined, newData);
            if (isLaziable(func)) setData(result, newData);
            result.placeholder = placeholder;
            return setWrapToString(result, func, bitmask);
        }
        /**
     * Creates a function like `_.round`.
     *
     * @private
     * @param {string} methodName The name of the `Math` method to use when rounding.
     * @returns {Function} Returns the new round function.
     */ function createRound(methodName) {
            var func = Math[methodName];
            return function(number, precision) {
                number = toNumber(number);
                precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
                if (precision && nativeIsFinite(number)) {
                    // Shift with exponential notation to avoid floating-point issues.
                    // See [MDN](https://mdn.io/round#Examples) for more details.
                    var pair = (toString(number) + "e").split("e"), value = func(pair[0] + "e" + (+pair[1] + precision));
                    pair = (toString(value) + "e").split("e");
                    return +(pair[0] + "e" + (+pair[1] - precision));
                }
                return func(number);
            };
        }
        /**
     * Creates a set object of `values`.
     *
     * @private
     * @param {Array} values The values to add to the set.
     * @returns {Object} Returns the new set.
     */ var createSet = !(Set && 1 / setToArray(new Set([
            ,
            -0
        ]))[1] == INFINITY) ? noop : function(values) {
            return new Set(values);
        };
        /**
     * Creates a `_.toPairs` or `_.toPairsIn` function.
     *
     * @private
     * @param {Function} keysFunc The function to get the keys of a given object.
     * @returns {Function} Returns the new pairs function.
     */ function createToPairs(keysFunc) {
            return function(object) {
                var tag = getTag(object);
                if (tag == mapTag) return mapToArray(object);
                if (tag == setTag) return setToPairs(object);
                return baseToPairs(object, keysFunc(object));
            };
        }
        /**
     * Creates a function that either curries or invokes `func` with optional
     * `this` binding and partially applied arguments.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags.
     *    1 - `_.bind`
     *    2 - `_.bindKey`
     *    4 - `_.curry` or `_.curryRight` of a bound function
     *    8 - `_.curry`
     *   16 - `_.curryRight`
     *   32 - `_.partial`
     *   64 - `_.partialRight`
     *  128 - `_.rearg`
     *  256 - `_.ary`
     *  512 - `_.flip`
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to be partially applied.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
            var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
            if (!isBindKey && typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            var length = partials ? partials.length : 0;
            if (!length) {
                bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
                partials = holders = undefined;
            }
            ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
            arity = arity === undefined ? arity : toInteger(arity);
            length -= holders ? holders.length : 0;
            if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
                var partialsRight = partials, holdersRight = holders;
                partials = holders = undefined;
            }
            var data = isBindKey ? undefined : getData(func);
            var newData = [
                func,
                bitmask,
                thisArg,
                partials,
                holders,
                partialsRight,
                holdersRight,
                argPos,
                ary,
                arity
            ];
            if (data) mergeData(newData, data);
            func = newData[0];
            bitmask = newData[1];
            thisArg = newData[2];
            partials = newData[3];
            holders = newData[4];
            arity = newData[9] = newData[9] === undefined ? isBindKey ? 0 : func.length : nativeMax(newData[9] - length, 0);
            if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
            if (!bitmask || bitmask == WRAP_BIND_FLAG) var result = createBind(func, bitmask, thisArg);
            else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) result = createCurry(func, bitmask, arity);
            else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) result = createPartial(func, bitmask, thisArg, partials);
            else result = createHybrid.apply(undefined, newData);
            var setter = data ? baseSetData : setData;
            return setWrapToString(setter(result, newData), func, bitmask);
        }
        /**
     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
     * of source objects to the destination object for all destination properties
     * that resolve to `undefined`.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to assign.
     * @param {Object} object The parent object of `objValue`.
     * @returns {*} Returns the value to assign.
     */ function customDefaultsAssignIn(objValue, srcValue, key, object) {
            if (objValue === undefined || eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key)) return srcValue;
            return objValue;
        }
        /**
     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
     * objects into destination objects that are passed thru.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to merge.
     * @param {Object} object The parent object of `objValue`.
     * @param {Object} source The parent object of `srcValue`.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     * @returns {*} Returns the value to assign.
     */ function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
            if (isObject(objValue) && isObject(srcValue)) {
                // Recursively merge objects and arrays (susceptible to call stack limits).
                stack.set(srcValue, objValue);
                baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
                stack["delete"](srcValue);
            }
            return objValue;
        }
        /**
     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
     * objects.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {string} key The key of the property to inspect.
     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
     */ function customOmitClone(value) {
            return isPlainObject(value) ? undefined : value;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for arrays with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Array} array The array to compare.
     * @param {Array} other The other array to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `array` and `other` objects.
     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
     */ function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
            if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
            // Check that cyclic values are equal.
            var arrStacked = stack.get(array);
            var othStacked = stack.get(other);
            if (arrStacked && othStacked) return arrStacked == other && othStacked == array;
            var index = -1, result = true, seen = bitmask & COMPARE_UNORDERED_FLAG ? new SetCache : undefined;
            stack.set(array, other);
            stack.set(other, array);
            // Ignore non-index properties.
            while(++index < arrLength){
                var arrValue = array[index], othValue = other[index];
                if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
                if (compared !== undefined) {
                    if (compared) continue;
                    result = false;
                    break;
                }
                // Recursively compare arrays (susceptible to call stack limits).
                if (seen) {
                    if (!arraySome(other, function(othValue, othIndex) {
                        if (!cacheHas(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) return seen.push(othIndex);
                    })) {
                        result = false;
                        break;
                    }
                } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
                    result = false;
                    break;
                }
            }
            stack["delete"](array);
            stack["delete"](other);
            return result;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for comparing objects of
     * the same `toStringTag`.
     *
     * **Note:** This function only supports comparing values with tags of
     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {string} tag The `toStringTag` of the objects to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
            switch(tag){
                case dataViewTag:
                    if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
                    object = object.buffer;
                    other = other.buffer;
                case arrayBufferTag:
                    if (object.byteLength != other.byteLength || !equalFunc(new Uint8Array(object), new Uint8Array(other))) return false;
                    return true;
                case boolTag:
                case dateTag:
                case numberTag:
                    // Coerce booleans to `1` or `0` and dates to milliseconds.
                    // Invalid dates are coerced to `NaN`.
                    return eq(+object, +other);
                case errorTag:
                    return object.name == other.name && object.message == other.message;
                case regexpTag:
                case stringTag:
                    // Coerce regexes to strings and treat strings, primitives and objects,
                    // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
                    // for more details.
                    return object == other + "";
                case mapTag:
                    var convert = mapToArray;
                case setTag:
                    var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
                    convert || (convert = setToArray);
                    if (object.size != other.size && !isPartial) return false;
                    // Assume cyclic values are equal.
                    var stacked = stack.get(object);
                    if (stacked) return stacked == other;
                    bitmask |= COMPARE_UNORDERED_FLAG;
                    // Recursively compare objects (susceptible to call stack limits).
                    stack.set(object, other);
                    var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
                    stack["delete"](object);
                    return result;
                case symbolTag:
                    if (symbolValueOf) return symbolValueOf.call(object) == symbolValueOf.call(other);
            }
            return false;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for objects with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG, objProps = getAllKeys(object), objLength = objProps.length, othProps = getAllKeys(other), othLength = othProps.length;
            if (objLength != othLength && !isPartial) return false;
            var index = objLength;
            while(index--){
                var key = objProps[index];
                if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) return false;
            }
            // Check that cyclic values are equal.
            var objStacked = stack.get(object);
            var othStacked = stack.get(other);
            if (objStacked && othStacked) return objStacked == other && othStacked == object;
            var result = true;
            stack.set(object, other);
            stack.set(other, object);
            var skipCtor = isPartial;
            while(++index < objLength){
                key = objProps[index];
                var objValue = object[key], othValue = other[key];
                if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
                // Recursively compare objects (susceptible to call stack limits).
                if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
                    result = false;
                    break;
                }
                skipCtor || (skipCtor = key == "constructor");
            }
            if (result && !skipCtor) {
                var objCtor = object.constructor, othCtor = other.constructor;
                // Non `Object` object instances with different constructors are not equal.
                if (objCtor != othCtor && "constructor" in object && "constructor" in other && !(typeof objCtor == "function" && objCtor instanceof objCtor && typeof othCtor == "function" && othCtor instanceof othCtor)) result = false;
            }
            stack["delete"](object);
            stack["delete"](other);
            return result;
        }
        /**
     * A specialized version of `baseRest` which flattens the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */ function flatRest(func) {
            return setToString(overRest(func, undefined, flatten), func + "");
        }
        /**
     * Creates an array of own enumerable property names and symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */ function getAllKeys(object) {
            return baseGetAllKeys(object, keys, getSymbols);
        }
        /**
     * Creates an array of own and inherited enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */ function getAllKeysIn(object) {
            return baseGetAllKeys(object, keysIn, getSymbolsIn);
        }
        /**
     * Gets metadata for `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {*} Returns the metadata for `func`.
     */ var getData = !metaMap ? noop : function(func) {
            return metaMap.get(func);
        };
        /**
     * Gets the name of `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {string} Returns the function name.
     */ function getFuncName(func) {
            var result = func.name + "", array = realNames[result], length = hasOwnProperty.call(realNames, result) ? array.length : 0;
            while(length--){
                var data = array[length], otherFunc = data.func;
                if (otherFunc == null || otherFunc == func) return data.name;
            }
            return result;
        }
        /**
     * Gets the argument placeholder value for `func`.
     *
     * @private
     * @param {Function} func The function to inspect.
     * @returns {*} Returns the placeholder value.
     */ function getHolder(func) {
            var object = hasOwnProperty.call(lodash, "placeholder") ? lodash : func;
            return object.placeholder;
        }
        /**
     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
     * this function returns the custom method, otherwise it returns `baseIteratee`.
     * If arguments are provided, the chosen function is invoked with them and
     * its result is returned.
     *
     * @private
     * @param {*} [value] The value to convert to an iteratee.
     * @param {number} [arity] The arity of the created iteratee.
     * @returns {Function} Returns the chosen function or its result.
     */ function getIteratee() {
            var result = lodash.iteratee || iteratee;
            result = result === iteratee ? baseIteratee : result;
            return arguments.length ? result(arguments[0], arguments[1]) : result;
        }
        /**
     * Gets the data for `map`.
     *
     * @private
     * @param {Object} map The map to query.
     * @param {string} key The reference key.
     * @returns {*} Returns the map data.
     */ function getMapData(map, key) {
            var data = map.__data__;
            return isKeyable(key) ? data[typeof key == "string" ? "string" : "hash"] : data.map;
        }
        /**
     * Gets the property names, values, and compare flags of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the match data of `object`.
     */ function getMatchData(object) {
            var result = keys(object), length = result.length;
            while(length--){
                var key = result[length], value = object[key];
                result[length] = [
                    key,
                    value,
                    isStrictComparable(value)
                ];
            }
            return result;
        }
        /**
     * Gets the native function at `key` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the method to get.
     * @returns {*} Returns the function if it's native, else `undefined`.
     */ function getNative(object, key) {
            var value = getValue(object, key);
            return baseIsNative(value) ? value : undefined;
        }
        /**
     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the raw `toStringTag`.
     */ function getRawTag(value) {
            var isOwn = hasOwnProperty.call(value, symToStringTag), tag = value[symToStringTag];
            try {
                value[symToStringTag] = undefined;
                var unmasked = true;
            } catch (e) {}
            var result = nativeObjectToString.call(value);
            if (unmasked) {
                if (isOwn) value[symToStringTag] = tag;
                else delete value[symToStringTag];
            }
            return result;
        }
        /**
     * Creates an array of the own enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */ var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
            if (object == null) return [];
            object = Object1(object);
            return arrayFilter(nativeGetSymbols(object), function(symbol) {
                return propertyIsEnumerable.call(object, symbol);
            });
        };
        /**
     * Creates an array of the own and inherited enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */ var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
            var result = [];
            while(object){
                arrayPush(result, getSymbols(object));
                object = getPrototype(object);
            }
            return result;
        };
        /**
     * Gets the `toStringTag` of `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */ var getTag = baseGetTag;
        // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
        if (DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag || Map && getTag(new Map) != mapTag || Promise && getTag(Promise.resolve()) != promiseTag || Set && getTag(new Set) != setTag || WeakMap && getTag(new WeakMap) != weakMapTag) getTag = function(value) {
            var result = baseGetTag(value), Ctor = result == objectTag ? value.constructor : undefined, ctorString = Ctor ? toSource(Ctor) : "";
            if (ctorString) switch(ctorString){
                case dataViewCtorString:
                    return dataViewTag;
                case mapCtorString:
                    return mapTag;
                case promiseCtorString:
                    return promiseTag;
                case setCtorString:
                    return setTag;
                case weakMapCtorString:
                    return weakMapTag;
            }
            return result;
        };
        /**
     * Gets the view, applying any `transforms` to the `start` and `end` positions.
     *
     * @private
     * @param {number} start The start of the view.
     * @param {number} end The end of the view.
     * @param {Array} transforms The transformations to apply to the view.
     * @returns {Object} Returns an object containing the `start` and `end`
     *  positions of the view.
     */ function getView(start, end, transforms) {
            var index = -1, length = transforms.length;
            while(++index < length){
                var data = transforms[index], size = data.size;
                switch(data.type){
                    case "drop":
                        start += size;
                        break;
                    case "dropRight":
                        end -= size;
                        break;
                    case "take":
                        end = nativeMin(end, start + size);
                        break;
                    case "takeRight":
                        start = nativeMax(start, end - size);
                        break;
                }
            }
            return {
                "start": start,
                "end": end
            };
        }
        /**
     * Extracts wrapper details from the `source` body comment.
     *
     * @private
     * @param {string} source The source to inspect.
     * @returns {Array} Returns the wrapper details.
     */ function getWrapDetails(source) {
            var match = source.match(reWrapDetails);
            return match ? match[1].split(reSplitDetails) : [];
        }
        /**
     * Checks if `path` exists on `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @param {Function} hasFunc The function to check properties.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     */ function hasPath(object, path, hasFunc) {
            path = castPath(path, object);
            var index = -1, length = path.length, result = false;
            while(++index < length){
                var key = toKey(path[index]);
                if (!(result = object != null && hasFunc(object, key))) break;
                object = object[key];
            }
            if (result || ++index != length) return result;
            length = object == null ? 0 : object.length;
            return !!length && isLength(length) && isIndex(key, length) && (isArray(object) || isArguments(object));
        }
        /**
     * Initializes an array clone.
     *
     * @private
     * @param {Array} array The array to clone.
     * @returns {Array} Returns the initialized clone.
     */ function initCloneArray(array) {
            var length = array.length, result = new array.constructor(length);
            // Add properties assigned by `RegExp#exec`.
            if (length && typeof array[0] == "string" && hasOwnProperty.call(array, "index")) {
                result.index = array.index;
                result.input = array.input;
            }
            return result;
        }
        /**
     * Initializes an object clone.
     *
     * @private
     * @param {Object} object The object to clone.
     * @returns {Object} Returns the initialized clone.
     */ function initCloneObject(object) {
            return typeof object.constructor == "function" && !isPrototype(object) ? baseCreate(getPrototype(object)) : {};
        }
        /**
     * Initializes an object clone based on its `toStringTag`.
     *
     * **Note:** This function only supports cloning values with tags of
     * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
     *
     * @private
     * @param {Object} object The object to clone.
     * @param {string} tag The `toStringTag` of the object to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the initialized clone.
     */ function initCloneByTag(object, tag, isDeep) {
            var Ctor = object.constructor;
            switch(tag){
                case arrayBufferTag:
                    return cloneArrayBuffer(object);
                case boolTag:
                case dateTag:
                    return new Ctor(+object);
                case dataViewTag:
                    return cloneDataView(object, isDeep);
                case float32Tag:
                case float64Tag:
                case int8Tag:
                case int16Tag:
                case int32Tag:
                case uint8Tag:
                case uint8ClampedTag:
                case uint16Tag:
                case uint32Tag:
                    return cloneTypedArray(object, isDeep);
                case mapTag:
                    return new Ctor;
                case numberTag:
                case stringTag:
                    return new Ctor(object);
                case regexpTag:
                    return cloneRegExp(object);
                case setTag:
                    return new Ctor;
                case symbolTag:
                    return cloneSymbol(object);
            }
        }
        /**
     * Inserts wrapper `details` in a comment at the top of the `source` body.
     *
     * @private
     * @param {string} source The source to modify.
     * @returns {Array} details The details to insert.
     * @returns {string} Returns the modified source.
     */ function insertWrapDetails(source, details) {
            var length = details.length;
            if (!length) return source;
            var lastIndex = length - 1;
            details[lastIndex] = (length > 1 ? "& " : "") + details[lastIndex];
            details = details.join(length > 2 ? ", " : " ");
            return source.replace(reWrapComment, "{\n/* [wrapped with " + details + "] */\n");
        }
        /**
     * Checks if `value` is a flattenable `arguments` object or array.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
     */ function isFlattenable(value) {
            return isArray(value) || isArguments(value) || !!(spreadableSymbol && value && value[spreadableSymbol]);
        }
        /**
     * Checks if `value` is a valid array-like index.
     *
     * @private
     * @param {*} value The value to check.
     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
     */ function isIndex(value, length) {
            var type = typeof value;
            length = length == null ? MAX_SAFE_INTEGER : length;
            return !!length && (type == "number" || type != "symbol" && reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
        }
        /**
     * Checks if the given arguments are from an iteratee call.
     *
     * @private
     * @param {*} value The potential iteratee value argument.
     * @param {*} index The potential iteratee index or key argument.
     * @param {*} object The potential iteratee object argument.
     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
     *  else `false`.
     */ function isIterateeCall(value, index, object) {
            if (!isObject(object)) return false;
            var type = typeof index;
            if (type == "number" ? isArrayLike(object) && isIndex(index, object.length) : type == "string" && index in object) return eq(object[index], value);
            return false;
        }
        /**
     * Checks if `value` is a property name and not a property path.
     *
     * @private
     * @param {*} value The value to check.
     * @param {Object} [object] The object to query keys on.
     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
     */ function isKey(value, object) {
            if (isArray(value)) return false;
            var type = typeof value;
            if (type == "number" || type == "symbol" || type == "boolean" || value == null || isSymbol(value)) return true;
            return reIsPlainProp.test(value) || !reIsDeepProp.test(value) || object != null && value in Object1(object);
        }
        /**
     * Checks if `value` is suitable for use as unique object key.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
     */ function isKeyable(value) {
            var type = typeof value;
            return type == "string" || type == "number" || type == "symbol" || type == "boolean" ? value !== "__proto__" : value === null;
        }
        /**
     * Checks if `func` has a lazy counterpart.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
     *  else `false`.
     */ function isLaziable(func) {
            var funcName = getFuncName(func), other = lodash[funcName];
            if (typeof other != "function" || !(funcName in LazyWrapper.prototype)) return false;
            if (func === other) return true;
            var data = getData(other);
            return !!data && func === data[0];
        }
        /**
     * Checks if `func` has its source masked.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
     */ function isMasked(func) {
            return !!maskSrcKey && maskSrcKey in func;
        }
        /**
     * Checks if `func` is capable of being masked.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
     */ var isMaskable = coreJsData ? isFunction : stubFalse;
        /**
     * Checks if `value` is likely a prototype object.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
     */ function isPrototype(value) {
            var Ctor = value && value.constructor, proto = typeof Ctor == "function" && Ctor.prototype || objectProto;
            return value === proto;
        }
        /**
     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` if suitable for strict
     *  equality comparisons, else `false`.
     */ function isStrictComparable(value) {
            return value === value && !isObject(value);
        }
        /**
     * A specialized version of `matchesProperty` for source values suitable
     * for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {string} key The key of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */ function matchesStrictComparable(key, srcValue) {
            return function(object) {
                if (object == null) return false;
                return object[key] === srcValue && (srcValue !== undefined || key in Object1(object));
            };
        }
        /**
     * A specialized version of `_.memoize` which clears the memoized function's
     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
     *
     * @private
     * @param {Function} func The function to have its output memoized.
     * @returns {Function} Returns the new memoized function.
     */ function memoizeCapped(func) {
            var result = memoize(func, function(key) {
                if (cache.size === MAX_MEMOIZE_SIZE) cache.clear();
                return key;
            });
            var cache = result.cache;
            return result;
        }
        /**
     * Merges the function metadata of `source` into `data`.
     *
     * Merging metadata reduces the number of wrappers used to invoke a function.
     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
     * may be applied regardless of execution order. Methods like `_.ary` and
     * `_.rearg` modify function arguments, making the order in which they are
     * executed important, preventing the merging of metadata. However, we make
     * an exception for a safe combined case where curried functions have `_.ary`
     * and or `_.rearg` applied.
     *
     * @private
     * @param {Array} data The destination metadata.
     * @param {Array} source The source metadata.
     * @returns {Array} Returns `data`.
     */ function mergeData(data, source) {
            var bitmask = data[1], srcBitmask = source[1], newBitmask = bitmask | srcBitmask, isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);
            var isCombo = srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_CURRY_FLAG || srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_REARG_FLAG && data[7].length <= source[8] || srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG) && source[7].length <= source[8] && bitmask == WRAP_CURRY_FLAG;
            // Exit early if metadata can't be merged.
            if (!(isCommon || isCombo)) return data;
            // Use source `thisArg` if available.
            if (srcBitmask & WRAP_BIND_FLAG) {
                data[2] = source[2];
                // Set when currying a bound function.
                newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
            }
            // Compose partial arguments.
            var value = source[3];
            if (value) {
                var partials = data[3];
                data[3] = partials ? composeArgs(partials, value, source[4]) : value;
                data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
            }
            // Compose partial right arguments.
            value = source[5];
            if (value) {
                partials = data[5];
                data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
                data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
            }
            // Use source `argPos` if available.
            value = source[7];
            if (value) data[7] = value;
            // Use source `ary` if it's smaller.
            if (srcBitmask & WRAP_ARY_FLAG) data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
            // Use source `arity` if one is not provided.
            if (data[9] == null) data[9] = source[9];
            // Use source `func` and merge bitmasks.
            data[0] = source[0];
            data[1] = newBitmask;
            return data;
        }
        /**
     * This function is like
     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * except that it includes inherited enumerable properties.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function nativeKeysIn(object) {
            var result = [];
            if (object != null) for(var key in Object1(object))result.push(key);
            return result;
        }
        /**
     * Converts `value` to a string using `Object.prototype.toString`.
     *
     * @private
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     */ function objectToString(value) {
            return nativeObjectToString.call(value);
        }
        /**
     * A specialized version of `baseRest` which transforms the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @param {Function} transform The rest array transform.
     * @returns {Function} Returns the new function.
     */ function overRest(func, start, transform) {
            start = nativeMax(start === undefined ? func.length - 1 : start, 0);
            return function() {
                var args = arguments, index = -1, length = nativeMax(args.length - start, 0), array = Array1(length);
                while(++index < length)array[index] = args[start + index];
                index = -1;
                var otherArgs = Array1(start + 1);
                while(++index < start)otherArgs[index] = args[index];
                otherArgs[start] = transform(array);
                return apply(func, this, otherArgs);
            };
        }
        /**
     * Gets the parent value at `path` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array} path The path to get the parent value of.
     * @returns {*} Returns the parent value.
     */ function parent(object, path) {
            return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
        }
        /**
     * Reorder `array` according to the specified indexes where the element at
     * the first index is assigned as the first element, the element at
     * the second index is assigned as the second element, and so on.
     *
     * @private
     * @param {Array} array The array to reorder.
     * @param {Array} indexes The arranged array indexes.
     * @returns {Array} Returns `array`.
     */ function reorder(array, indexes) {
            var arrLength = array.length, length = nativeMin(indexes.length, arrLength), oldArray = copyArray(array);
            while(length--){
                var index = indexes[length];
                array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
            }
            return array;
        }
        /**
     * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the property to get.
     * @returns {*} Returns the property value.
     */ function safeGet(object, key) {
            if (key === "constructor" && typeof object[key] === "function") return;
            if (key == "__proto__") return;
            return object[key];
        }
        /**
     * Sets metadata for `func`.
     *
     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
     * period of time, it will trip its breaker and transition to an identity
     * function to avoid garbage collection pauses in V8. See
     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
     * for more details.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */ var setData = shortOut(baseSetData);
        /**
     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @returns {number|Object} Returns the timer id or timeout object.
     */ var setTimeout = ctxSetTimeout || function(func, wait) {
            return root.setTimeout(func, wait);
        };
        /**
     * Sets the `toString` method of `func` to return `string`.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */ var setToString = shortOut(baseSetToString);
        /**
     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
     * with wrapper details in a comment at the top of the source body.
     *
     * @private
     * @param {Function} wrapper The function to modify.
     * @param {Function} reference The reference function.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Function} Returns `wrapper`.
     */ function setWrapToString(wrapper, reference, bitmask) {
            var source = reference + "";
            return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
        }
        /**
     * Creates a function that'll short out and invoke `identity` instead
     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
     * milliseconds.
     *
     * @private
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new shortable function.
     */ function shortOut(func) {
            var count = 0, lastCalled = 0;
            return function() {
                var stamp = nativeNow(), remaining = HOT_SPAN - (stamp - lastCalled);
                lastCalled = stamp;
                if (remaining > 0) {
                    if (++count >= HOT_COUNT) return arguments[0];
                } else count = 0;
                return func.apply(undefined, arguments);
            };
        }
        /**
     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @param {number} [size=array.length] The size of `array`.
     * @returns {Array} Returns `array`.
     */ function shuffleSelf(array, size) {
            var index = -1, length = array.length, lastIndex = length - 1;
            size = size === undefined ? length : size;
            while(++index < size){
                var rand = baseRandom(index, lastIndex), value = array[rand];
                array[rand] = array[index];
                array[index] = value;
            }
            array.length = size;
            return array;
        }
        /**
     * Converts `string` to a property path array.
     *
     * @private
     * @param {string} string The string to convert.
     * @returns {Array} Returns the property path array.
     */ var stringToPath = memoizeCapped(function(string) {
            var result = [];
            if (string.charCodeAt(0) === 46 /* . */ ) result.push("");
            string.replace(rePropName, function(match, number, quote, subString) {
                result.push(quote ? subString.replace(reEscapeChar, "$1") : number || match);
            });
            return result;
        });
        /**
     * Converts `value` to a string key if it's not a string or symbol.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {string|symbol} Returns the key.
     */ function toKey(value) {
            if (typeof value == "string" || isSymbol(value)) return value;
            var result = value + "";
            return result == "0" && 1 / value == -INFINITY ? "-0" : result;
        }
        /**
     * Converts `func` to its source code.
     *
     * @private
     * @param {Function} func The function to convert.
     * @returns {string} Returns the source code.
     */ function toSource(func) {
            if (func != null) {
                try {
                    return funcToString.call(func);
                } catch (e) {}
                try {
                    return func + "";
                } catch (e) {}
            }
            return "";
        }
        /**
     * Updates wrapper `details` based on `bitmask` flags.
     *
     * @private
     * @returns {Array} details The details to modify.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Array} Returns `details`.
     */ function updateWrapDetails(details, bitmask) {
            arrayEach(wrapFlags, function(pair) {
                var value = "_." + pair[0];
                if (bitmask & pair[1] && !arrayIncludes(details, value)) details.push(value);
            });
            return details.sort();
        }
        /**
     * Creates a clone of `wrapper`.
     *
     * @private
     * @param {Object} wrapper The wrapper to clone.
     * @returns {Object} Returns the cloned wrapper.
     */ function wrapperClone(wrapper) {
            if (wrapper instanceof LazyWrapper) return wrapper.clone();
            var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
            result.__actions__ = copyArray(wrapper.__actions__);
            result.__index__ = wrapper.__index__;
            result.__values__ = wrapper.__values__;
            return result;
        }
        /*------------------------------------------------------------------------*/ /**
     * Creates an array of elements split into groups the length of `size`.
     * If `array` can't be split evenly, the final chunk will be the remaining
     * elements.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to process.
     * @param {number} [size=1] The length of each chunk
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the new array of chunks.
     * @example
     *
     * _.chunk(['a', 'b', 'c', 'd'], 2);
     * // => [['a', 'b'], ['c', 'd']]
     *
     * _.chunk(['a', 'b', 'c', 'd'], 3);
     * // => [['a', 'b', 'c'], ['d']]
     */ function chunk(array, size, guard) {
            if (guard ? isIterateeCall(array, size, guard) : size === undefined) size = 1;
            else size = nativeMax(toInteger(size), 0);
            var length = array == null ? 0 : array.length;
            if (!length || size < 1) return [];
            var index = 0, resIndex = 0, result = Array1(nativeCeil(length / size));
            while(index < length)result[resIndex++] = baseSlice(array, index, index += size);
            return result;
        }
        /**
     * Creates an array with all falsey values removed. The values `false`, `null`,
     * `0`, `""`, `undefined`, and `NaN` are falsey.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to compact.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.compact([0, 1, false, 2, '', 3]);
     * // => [1, 2, 3]
     */ function compact(array) {
            var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
            while(++index < length){
                var value = array[index];
                if (value) result[resIndex++] = value;
            }
            return result;
        }
        /**
     * Creates a new array concatenating `array` with any additional arrays
     * and/or values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to concatenate.
     * @param {...*} [values] The values to concatenate.
     * @returns {Array} Returns the new concatenated array.
     * @example
     *
     * var array = [1];
     * var other = _.concat(array, 2, [3], [[4]]);
     *
     * console.log(other);
     * // => [1, 2, 3, [4]]
     *
     * console.log(array);
     * // => [1]
     */ function concat() {
            var length = arguments.length;
            if (!length) return [];
            var args = Array1(length - 1), array = arguments[0], index = length;
            while(index--)args[index - 1] = arguments[index];
            return arrayPush(isArray(array) ? copyArray(array) : [
                array
            ], baseFlatten(args, 1));
        }
        /**
     * Creates an array of `array` values not included in the other given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * **Note:** Unlike `_.pullAll`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.without, _.xor
     * @example
     *
     * _.difference([2, 1], [2, 3]);
     * // => [1]
     */ var difference = baseRest(function(array, values) {
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true)) : [];
        });
        /**
     * This method is like `_.difference` except that it accepts `iteratee` which
     * is invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */ var differenceBy = baseRest(function(array, values) {
            var iteratee = last(values);
            if (isArrayLikeObject(iteratee)) iteratee = undefined;
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2)) : [];
        });
        /**
     * This method is like `_.difference` except that it accepts `comparator`
     * which is invoked to compare elements of `array` to `values`. The order and
     * references of result values are determined by the first array. The comparator
     * is invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     *
     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }]
     */ var differenceWith = baseRest(function(array, values) {
            var comparator = last(values);
            if (isArrayLikeObject(comparator)) comparator = undefined;
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator) : [];
        });
        /**
     * Creates a slice of `array` with `n` elements dropped from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.drop([1, 2, 3]);
     * // => [2, 3]
     *
     * _.drop([1, 2, 3], 2);
     * // => [3]
     *
     * _.drop([1, 2, 3], 5);
     * // => []
     *
     * _.drop([1, 2, 3], 0);
     * // => [1, 2, 3]
     */ function drop(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            return baseSlice(array, n < 0 ? 0 : n, length);
        }
        /**
     * Creates a slice of `array` with `n` elements dropped from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.dropRight([1, 2, 3]);
     * // => [1, 2]
     *
     * _.dropRight([1, 2, 3], 2);
     * // => [1]
     *
     * _.dropRight([1, 2, 3], 5);
     * // => []
     *
     * _.dropRight([1, 2, 3], 0);
     * // => [1, 2, 3]
     */ function dropRight(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            n = length - n;
            return baseSlice(array, 0, n < 0 ? 0 : n);
        }
        /**
     * Creates a slice of `array` excluding elements dropped from the end.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.dropRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropRightWhile(users, ['active', false]);
     * // => objects for ['barney']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropRightWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */ function dropRightWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), true, true) : [];
        }
        /**
     * Creates a slice of `array` excluding elements dropped from the beginning.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.dropWhile(users, function(o) { return !o.active; });
     * // => objects for ['pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropWhile(users, ['active', false]);
     * // => objects for ['pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */ function dropWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), true) : [];
        }
        /**
     * Fills elements of `array` with `value` from `start` up to, but not
     * including, `end`.
     *
     * **Note:** This method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Array
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.fill(array, 'a');
     * console.log(array);
     * // => ['a', 'a', 'a']
     *
     * _.fill(Array(3), 2);
     * // => [2, 2, 2]
     *
     * _.fill([4, 6, 8, 10], '*', 1, 3);
     * // => [4, '*', '*', 10]
     */ function fill(array, value, start, end) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            if (start && typeof start != "number" && isIterateeCall(array, value, start)) {
                start = 0;
                end = length;
            }
            return baseFill(array, value, start, end);
        }
        /**
     * This method is like `_.find` except that it returns the index of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.findIndex(users, function(o) { return o.user == 'barney'; });
     * // => 0
     *
     * // The `_.matches` iteratee shorthand.
     * _.findIndex(users, { 'user': 'fred', 'active': false });
     * // => 1
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findIndex(users, ['active', false]);
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.findIndex(users, 'active');
     * // => 2
     */ function findIndex(array, predicate, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = fromIndex == null ? 0 : toInteger(fromIndex);
            if (index < 0) index = nativeMax(length + index, 0);
            return baseFindIndex(array, getIteratee(predicate, 3), index);
        }
        /**
     * This method is like `_.findIndex` except that it iterates over elements
     * of `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
     * // => 2
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
     * // => 0
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastIndex(users, ['active', false]);
     * // => 2
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastIndex(users, 'active');
     * // => 0
     */ function findLastIndex(array, predicate, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = length - 1;
            if (fromIndex !== undefined) {
                index = toInteger(fromIndex);
                index = fromIndex < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
            }
            return baseFindIndex(array, getIteratee(predicate, 3), index, true);
        }
        /**
     * Flattens `array` a single level deep.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flatten([1, [2, [3, [4]], 5]]);
     * // => [1, 2, [3, [4]], 5]
     */ function flatten(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseFlatten(array, 1) : [];
        }
        /**
     * Recursively flattens `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flattenDeep([1, [2, [3, [4]], 5]]);
     * // => [1, 2, 3, 4, 5]
     */ function flattenDeep(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseFlatten(array, INFINITY) : [];
        }
        /**
     * Recursively flatten `array` up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * var array = [1, [2, [3, [4]], 5]];
     *
     * _.flattenDepth(array, 1);
     * // => [1, 2, [3, [4]], 5]
     *
     * _.flattenDepth(array, 2);
     * // => [1, 2, 3, [4], 5]
     */ function flattenDepth(array, depth) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            depth = depth === undefined ? 1 : toInteger(depth);
            return baseFlatten(array, depth);
        }
        /**
     * The inverse of `_.toPairs`; this method returns an object composed
     * from key-value `pairs`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} pairs The key-value pairs.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.fromPairs([['a', 1], ['b', 2]]);
     * // => { 'a': 1, 'b': 2 }
     */ function fromPairs(pairs) {
            var index = -1, length = pairs == null ? 0 : pairs.length, result = {};
            while(++index < length){
                var pair = pairs[index];
                result[pair[0]] = pair[1];
            }
            return result;
        }
        /**
     * Gets the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias first
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the first element of `array`.
     * @example
     *
     * _.head([1, 2, 3]);
     * // => 1
     *
     * _.head([]);
     * // => undefined
     */ function head(array) {
            return array && array.length ? array[0] : undefined;
        }
        /**
     * Gets the index at which the first occurrence of `value` is found in `array`
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. If `fromIndex` is negative, it's used as the
     * offset from the end of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.indexOf([1, 2, 1, 2], 2);
     * // => 1
     *
     * // Search from the `fromIndex`.
     * _.indexOf([1, 2, 1, 2], 2, 2);
     * // => 3
     */ function indexOf(array, value, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = fromIndex == null ? 0 : toInteger(fromIndex);
            if (index < 0) index = nativeMax(length + index, 0);
            return baseIndexOf(array, value, index);
        }
        /**
     * Gets all but the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.initial([1, 2, 3]);
     * // => [1, 2]
     */ function initial(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseSlice(array, 0, -1) : [];
        }
        /**
     * Creates an array of unique values that are included in all given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersection([2, 1], [2, 3]);
     * // => [2]
     */ var intersection = baseRest(function(arrays) {
            var mapped = arrayMap(arrays, castArrayLikeObject);
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped) : [];
        });
        /**
     * This method is like `_.intersection` except that it accepts `iteratee`
     * which is invoked for each element of each `arrays` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [2.1]
     *
     * // The `_.property` iteratee shorthand.
     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }]
     */ var intersectionBy = baseRest(function(arrays) {
            var iteratee = last(arrays), mapped = arrayMap(arrays, castArrayLikeObject);
            if (iteratee === last(mapped)) iteratee = undefined;
            else mapped.pop();
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, getIteratee(iteratee, 2)) : [];
        });
        /**
     * This method is like `_.intersection` except that it accepts `comparator`
     * which is invoked to compare elements of `arrays`. The order and references
     * of result values are determined by the first array. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.intersectionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }]
     */ var intersectionWith = baseRest(function(arrays) {
            var comparator = last(arrays), mapped = arrayMap(arrays, castArrayLikeObject);
            comparator = typeof comparator == "function" ? comparator : undefined;
            if (comparator) mapped.pop();
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, undefined, comparator) : [];
        });
        /**
     * Converts all elements in `array` into a string separated by `separator`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to convert.
     * @param {string} [separator=','] The element separator.
     * @returns {string} Returns the joined string.
     * @example
     *
     * _.join(['a', 'b', 'c'], '~');
     * // => 'a~b~c'
     */ function join(array, separator) {
            return array == null ? "" : nativeJoin.call(array, separator);
        }
        /**
     * Gets the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the last element of `array`.
     * @example
     *
     * _.last([1, 2, 3]);
     * // => 3
     */ function last(array) {
            var length = array == null ? 0 : array.length;
            return length ? array[length - 1] : undefined;
        }
        /**
     * This method is like `_.indexOf` except that it iterates over elements of
     * `array` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.lastIndexOf([1, 2, 1, 2], 2);
     * // => 3
     *
     * // Search from the `fromIndex`.
     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
     * // => 1
     */ function lastIndexOf(array, value, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = length;
            if (fromIndex !== undefined) {
                index = toInteger(fromIndex);
                index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
            }
            return value === value ? strictLastIndexOf(array, value, index) : baseFindIndex(array, baseIsNaN, index, true);
        }
        /**
     * Gets the element at index `n` of `array`. If `n` is negative, the nth
     * element from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.11.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=0] The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     *
     * _.nth(array, 1);
     * // => 'b'
     *
     * _.nth(array, -2);
     * // => 'c';
     */ function nth(array, n) {
            return array && array.length ? baseNth(array, toInteger(n)) : undefined;
        }
        /**
     * Removes all given values from `array` using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
     * to remove elements from an array by predicate.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...*} [values] The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pull(array, 'a', 'c');
     * console.log(array);
     * // => ['b', 'b']
     */ var pull = baseRest(pullAll);
        /**
     * This method is like `_.pull` except that it accepts an array of values to remove.
     *
     * **Note:** Unlike `_.difference`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pullAll(array, ['a', 'c']);
     * console.log(array);
     * // => ['b', 'b']
     */ function pullAll(array, values) {
            return array && array.length && values && values.length ? basePullAll(array, values) : array;
        }
        /**
     * This method is like `_.pullAll` except that it accepts `iteratee` which is
     * invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The iteratee is invoked with one argument: (value).
     *
     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
     *
     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
     * console.log(array);
     * // => [{ 'x': 2 }]
     */ function pullAllBy(array, values, iteratee) {
            return array && array.length && values && values.length ? basePullAll(array, values, getIteratee(iteratee, 2)) : array;
        }
        /**
     * This method is like `_.pullAll` except that it accepts `comparator` which
     * is invoked to compare elements of `array` to `values`. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
     *
     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
     * console.log(array);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
     */ function pullAllWith(array, values, comparator) {
            return array && array.length && values && values.length ? basePullAll(array, values, undefined, comparator) : array;
        }
        /**
     * Removes elements from `array` corresponding to `indexes` and returns an
     * array of removed elements.
     *
     * **Note:** Unlike `_.at`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     * var pulled = _.pullAt(array, [1, 3]);
     *
     * console.log(array);
     * // => ['a', 'c']
     *
     * console.log(pulled);
     * // => ['b', 'd']
     */ var pullAt = flatRest(function(array, indexes) {
            var length = array == null ? 0 : array.length, result = baseAt(array, indexes);
            basePullAt(array, arrayMap(indexes, function(index) {
                return isIndex(index, length) ? +index : index;
            }).sort(compareAscending));
            return result;
        });
        /**
     * Removes all elements from `array` that `predicate` returns truthy for
     * and returns an array of the removed elements. The predicate is invoked
     * with three arguments: (value, index, array).
     *
     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
     * to pull elements from an array by value.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = [1, 2, 3, 4];
     * var evens = _.remove(array, function(n) {
     *   return n % 2 == 0;
     * });
     *
     * console.log(array);
     * // => [1, 3]
     *
     * console.log(evens);
     * // => [2, 4]
     */ function remove(array, predicate) {
            var result = [];
            if (!(array && array.length)) return result;
            var index = -1, indexes = [], length = array.length;
            predicate = getIteratee(predicate, 3);
            while(++index < length){
                var value = array[index];
                if (predicate(value, index, array)) {
                    result.push(value);
                    indexes.push(index);
                }
            }
            basePullAt(array, indexes);
            return result;
        }
        /**
     * Reverses `array` so that the first element becomes the last, the second
     * element becomes the second to last, and so on.
     *
     * **Note:** This method mutates `array` and is based on
     * [`Array#reverse`](https://mdn.io/Array/reverse).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.reverse(array);
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */ function reverse(array) {
            return array == null ? array : nativeReverse.call(array);
        }
        /**
     * Creates a slice of `array` from `start` up to, but not including, `end`.
     *
     * **Note:** This method is used instead of
     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
     * returned.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */ function slice(array, start, end) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            if (end && typeof end != "number" && isIterateeCall(array, start, end)) {
                start = 0;
                end = length;
            } else {
                start = start == null ? 0 : toInteger(start);
                end = end === undefined ? length : toInteger(end);
            }
            return baseSlice(array, start, end);
        }
        /**
     * Uses a binary search to determine the lowest index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedIndex([30, 50], 40);
     * // => 1
     */ function sortedIndex(array, value) {
            return baseSortedIndex(array, value);
        }
        /**
     * This method is like `_.sortedIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
     * // => 0
     */ function sortedIndexBy(array, value, iteratee) {
            return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
        }
        /**
     * This method is like `_.indexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
     * // => 1
     */ function sortedIndexOf(array, value) {
            var length = array == null ? 0 : array.length;
            if (length) {
                var index = baseSortedIndex(array, value);
                if (index < length && eq(array[index], value)) return index;
            }
            return -1;
        }
        /**
     * This method is like `_.sortedIndex` except that it returns the highest
     * index at which `value` should be inserted into `array` in order to
     * maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
     * // => 4
     */ function sortedLastIndex(array, value) {
            return baseSortedIndex(array, value, true);
        }
        /**
     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 1
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
     * // => 1
     */ function sortedLastIndexBy(array, value, iteratee) {
            return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
        }
        /**
     * This method is like `_.lastIndexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
     * // => 3
     */ function sortedLastIndexOf(array, value) {
            var length = array == null ? 0 : array.length;
            if (length) {
                var index = baseSortedIndex(array, value, true) - 1;
                if (eq(array[index], value)) return index;
            }
            return -1;
        }
        /**
     * This method is like `_.uniq` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniq([1, 1, 2]);
     * // => [1, 2]
     */ function sortedUniq(array) {
            return array && array.length ? baseSortedUniq(array) : [];
        }
        /**
     * This method is like `_.uniqBy` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
     * // => [1.1, 2.3]
     */ function sortedUniqBy(array, iteratee) {
            return array && array.length ? baseSortedUniq(array, getIteratee(iteratee, 2)) : [];
        }
        /**
     * Gets all but the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.tail([1, 2, 3]);
     * // => [2, 3]
     */ function tail(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseSlice(array, 1, length) : [];
        }
        /**
     * Creates a slice of `array` with `n` elements taken from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.take([1, 2, 3]);
     * // => [1]
     *
     * _.take([1, 2, 3], 2);
     * // => [1, 2]
     *
     * _.take([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.take([1, 2, 3], 0);
     * // => []
     */ function take(array, n, guard) {
            if (!(array && array.length)) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            return baseSlice(array, 0, n < 0 ? 0 : n);
        }
        /**
     * Creates a slice of `array` with `n` elements taken from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.takeRight([1, 2, 3]);
     * // => [3]
     *
     * _.takeRight([1, 2, 3], 2);
     * // => [2, 3]
     *
     * _.takeRight([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.takeRight([1, 2, 3], 0);
     * // => []
     */ function takeRight(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            n = length - n;
            return baseSlice(array, n < 0 ? 0 : n, length);
        }
        /**
     * Creates a slice of `array` with elements taken from the end. Elements are
     * taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.takeRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeRightWhile(users, ['active', false]);
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeRightWhile(users, 'active');
     * // => []
     */ function takeRightWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), false, true) : [];
        }
        /**
     * Creates a slice of `array` with elements taken from the beginning. Elements
     * are taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.takeWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeWhile(users, ['active', false]);
     * // => objects for ['barney', 'fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeWhile(users, 'active');
     * // => []
     */ function takeWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3)) : [];
        }
        /**
     * Creates an array of unique values, in order, from all given arrays using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.union([2], [1, 2]);
     * // => [2, 1]
     */ var union = baseRest(function(arrays) {
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
        });
        /**
     * This method is like `_.union` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which uniqueness is computed. Result values are chosen from the first
     * array in which the value occurs. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */ var unionBy = baseRest(function(arrays) {
            var iteratee = last(arrays);
            if (isArrayLikeObject(iteratee)) iteratee = undefined;
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
        });
        /**
     * This method is like `_.union` except that it accepts `comparator` which
     * is invoked to compare elements of `arrays`. Result values are chosen from
     * the first array in which the value occurs. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.unionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */ var unionWith = baseRest(function(arrays) {
            var comparator = last(arrays);
            comparator = typeof comparator == "function" ? comparator : undefined;
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
        });
        /**
     * Creates a duplicate-free version of an array, using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons, in which only the first occurrence of each element
     * is kept. The order of result values is determined by the order they occur
     * in the array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniq([2, 1, 2]);
     * // => [2, 1]
     */ function uniq(array) {
            return array && array.length ? baseUniq(array) : [];
        }
        /**
     * This method is like `_.uniq` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * uniqueness is computed. The order of result values is determined by the
     * order they occur in the array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */ function uniqBy(array, iteratee) {
            return array && array.length ? baseUniq(array, getIteratee(iteratee, 2)) : [];
        }
        /**
     * This method is like `_.uniq` except that it accepts `comparator` which
     * is invoked to compare elements of `array`. The order of result values is
     * determined by the order they occur in the array.The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.uniqWith(objects, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
     */ function uniqWith(array, comparator) {
            comparator = typeof comparator == "function" ? comparator : undefined;
            return array && array.length ? baseUniq(array, undefined, comparator) : [];
        }
        /**
     * This method is like `_.zip` except that it accepts an array of grouped
     * elements and creates an array regrouping the elements to their pre-zip
     * configuration.
     *
     * @static
     * @memberOf _
     * @since 1.2.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     *
     * _.unzip(zipped);
     * // => [['a', 'b'], [1, 2], [true, false]]
     */ function unzip(array) {
            if (!(array && array.length)) return [];
            var length = 0;
            array = arrayFilter(array, function(group) {
                if (isArrayLikeObject(group)) {
                    length = nativeMax(group.length, length);
                    return true;
                }
            });
            return baseTimes(length, function(index) {
                return arrayMap(array, baseProperty(index));
            });
        }
        /**
     * This method is like `_.unzip` except that it accepts `iteratee` to specify
     * how regrouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  regrouped values.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
     * // => [[1, 10, 100], [2, 20, 200]]
     *
     * _.unzipWith(zipped, _.add);
     * // => [3, 30, 300]
     */ function unzipWith(array, iteratee) {
            if (!(array && array.length)) return [];
            var result = unzip(array);
            if (iteratee == null) return result;
            return arrayMap(result, function(group) {
                return apply(iteratee, undefined, group);
            });
        }
        /**
     * Creates an array excluding all given values using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.pull`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...*} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.xor
     * @example
     *
     * _.without([2, 1, 2, 3], 1, 2);
     * // => [3]
     */ var without = baseRest(function(array, values) {
            return isArrayLikeObject(array) ? baseDifference(array, values) : [];
        });
        /**
     * Creates an array of unique values that is the
     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
     * of the given arrays. The order of result values is determined by the order
     * they occur in the arrays.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.without
     * @example
     *
     * _.xor([2, 1], [2, 3]);
     * // => [1, 3]
     */ var xor = baseRest(function(arrays) {
            return baseXor(arrayFilter(arrays, isArrayLikeObject));
        });
        /**
     * This method is like `_.xor` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which by which they're compared. The order of result values is determined
     * by the order they occur in the arrays. The iteratee is invoked with one
     * argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2, 3.4]
     *
     * // The `_.property` iteratee shorthand.
     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */ var xorBy = baseRest(function(arrays) {
            var iteratee = last(arrays);
            if (isArrayLikeObject(iteratee)) iteratee = undefined;
            return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
        });
        /**
     * This method is like `_.xor` except that it accepts `comparator` which is
     * invoked to compare elements of `arrays`. The order of result values is
     * determined by the order they occur in the arrays. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.xorWith(objects, others, _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */ var xorWith = baseRest(function(arrays) {
            var comparator = last(arrays);
            comparator = typeof comparator == "function" ? comparator : undefined;
            return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
        });
        /**
     * Creates an array of grouped elements, the first of which contains the
     * first elements of the given arrays, the second of which contains the
     * second elements of the given arrays, and so on.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     */ var zip = baseRest(unzip);
        /**
     * This method is like `_.fromPairs` except that it accepts two arrays,
     * one of property identifiers and one of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 0.4.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObject(['a', 'b'], [1, 2]);
     * // => { 'a': 1, 'b': 2 }
     */ function zipObject(props, values) {
            return baseZipObject(props || [], values || [], assignValue);
        }
        /**
     * This method is like `_.zipObject` except that it supports property paths.
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
     */ function zipObjectDeep(props, values) {
            return baseZipObject(props || [], values || [], baseSet);
        }
        /**
     * This method is like `_.zip` except that it accepts `iteratee` to specify
     * how grouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  grouped values.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
     *   return a + b + c;
     * });
     * // => [111, 222]
     */ var zipWith = baseRest(function(arrays) {
            var length = arrays.length, iteratee = length > 1 ? arrays[length - 1] : undefined;
            iteratee = typeof iteratee == "function" ? (arrays.pop(), iteratee) : undefined;
            return unzipWith(arrays, iteratee);
        });
        /*------------------------------------------------------------------------*/ /**
     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
     * chain sequences enabled. The result of such sequences must be unwrapped
     * with `_#value`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Seq
     * @param {*} value The value to wrap.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36 },
     *   { 'user': 'fred',    'age': 40 },
     *   { 'user': 'pebbles', 'age': 1 }
     * ];
     *
     * var youngest = _
     *   .chain(users)
     *   .sortBy('age')
     *   .map(function(o) {
     *     return o.user + ' is ' + o.age;
     *   })
     *   .head()
     *   .value();
     * // => 'pebbles is 1'
     */ function chain(value) {
            var result = lodash(value);
            result.__chain__ = true;
            return result;
        }
        /**
     * This method invokes `interceptor` and returns `value`. The interceptor
     * is invoked with one argument; (value). The purpose of this method is to
     * "tap into" a method chain sequence in order to modify intermediate results.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns `value`.
     * @example
     *
     * _([1, 2, 3])
     *  .tap(function(array) {
     *    // Mutate input array.
     *    array.pop();
     *  })
     *  .reverse()
     *  .value();
     * // => [2, 1]
     */ function tap(value, interceptor) {
            interceptor(value);
            return value;
        }
        /**
     * This method is like `_.tap` except that it returns the result of `interceptor`.
     * The purpose of this method is to "pass thru" values replacing intermediate
     * results in a method chain sequence.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns the result of `interceptor`.
     * @example
     *
     * _('  abc  ')
     *  .chain()
     *  .trim()
     *  .thru(function(value) {
     *    return [value];
     *  })
     *  .value();
     * // => ['abc']
     */ function thru(value, interceptor) {
            return interceptor(value);
        }
        /**
     * This method is the wrapper version of `_.at`.
     *
     * @name at
     * @memberOf _
     * @since 1.0.0
     * @category Seq
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _(object).at(['a[0].b.c', 'a[1]']).value();
     * // => [3, 4]
     */ var wrapperAt = flatRest(function(paths) {
            var length = paths.length, start = length ? paths[0] : 0, value = this.__wrapped__, interceptor = function(object) {
                return baseAt(object, paths);
            };
            if (length > 1 || this.__actions__.length || !(value instanceof LazyWrapper) || !isIndex(start)) return this.thru(interceptor);
            value = value.slice(start, +start + (length ? 1 : 0));
            value.__actions__.push({
                "func": thru,
                "args": [
                    interceptor
                ],
                "thisArg": undefined
            });
            return new LodashWrapper(value, this.__chain__).thru(function(array) {
                if (length && !array.length) array.push(undefined);
                return array;
            });
        });
        /**
     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
     *
     * @name chain
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * // A sequence without explicit chaining.
     * _(users).head();
     * // => { 'user': 'barney', 'age': 36 }
     *
     * // A sequence with explicit chaining.
     * _(users)
     *   .chain()
     *   .head()
     *   .pick('user')
     *   .value();
     * // => { 'user': 'barney' }
     */ function wrapperChain() {
            return chain(this);
        }
        /**
     * Executes the chain sequence and returns the wrapped result.
     *
     * @name commit
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2];
     * var wrapped = _(array).push(3);
     *
     * console.log(array);
     * // => [1, 2]
     *
     * wrapped = wrapped.commit();
     * console.log(array);
     * // => [1, 2, 3]
     *
     * wrapped.last();
     * // => 3
     *
     * console.log(array);
     * // => [1, 2, 3]
     */ function wrapperCommit() {
            return new LodashWrapper(this.value(), this.__chain__);
        }
        /**
     * Gets the next value on a wrapped object following the
     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
     *
     * @name next
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the next iterator value.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 1 }
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 2 }
     *
     * wrapped.next();
     * // => { 'done': true, 'value': undefined }
     */ function wrapperNext() {
            if (this.__values__ === undefined) this.__values__ = toArray(this.value());
            var done = this.__index__ >= this.__values__.length, value = done ? undefined : this.__values__[this.__index__++];
            return {
                "done": done,
                "value": value
            };
        }
        /**
     * Enables the wrapper to be iterable.
     *
     * @name Symbol.iterator
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the wrapper object.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped[Symbol.iterator]() === wrapped;
     * // => true
     *
     * Array.from(wrapped);
     * // => [1, 2]
     */ function wrapperToIterator() {
            return this;
        }
        /**
     * Creates a clone of the chain sequence planting `value` as the wrapped value.
     *
     * @name plant
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @param {*} value The value to plant.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2]).map(square);
     * var other = wrapped.plant([3, 4]);
     *
     * other.value();
     * // => [9, 16]
     *
     * wrapped.value();
     * // => [1, 4]
     */ function wrapperPlant(value) {
            var result, parent = this;
            while(parent instanceof baseLodash){
                var clone = wrapperClone(parent);
                clone.__index__ = 0;
                clone.__values__ = undefined;
                if (result) previous.__wrapped__ = clone;
                else result = clone;
                var previous = clone;
                parent = parent.__wrapped__;
            }
            previous.__wrapped__ = value;
            return result;
        }
        /**
     * This method is the wrapper version of `_.reverse`.
     *
     * **Note:** This method mutates the wrapped array.
     *
     * @name reverse
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _(array).reverse().value()
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */ function wrapperReverse() {
            var value = this.__wrapped__;
            if (value instanceof LazyWrapper) {
                var wrapped = value;
                if (this.__actions__.length) wrapped = new LazyWrapper(this);
                wrapped = wrapped.reverse();
                wrapped.__actions__.push({
                    "func": thru,
                    "args": [
                        reverse
                    ],
                    "thisArg": undefined
                });
                return new LodashWrapper(wrapped, this.__chain__);
            }
            return this.thru(reverse);
        }
        /**
     * Executes the chain sequence to resolve the unwrapped value.
     *
     * @name value
     * @memberOf _
     * @since 0.1.0
     * @alias toJSON, valueOf
     * @category Seq
     * @returns {*} Returns the resolved unwrapped value.
     * @example
     *
     * _([1, 2, 3]).value();
     * // => [1, 2, 3]
     */ function wrapperValue() {
            return baseWrapperValue(this.__wrapped__, this.__actions__);
        }
        /*------------------------------------------------------------------------*/ /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the number of times the key was returned by `iteratee`. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.countBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': 1, '6': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.countBy(['one', 'two', 'three'], 'length');
     * // => { '3': 2, '5': 1 }
     */ var countBy = createAggregator(function(result, value, key) {
            if (hasOwnProperty.call(result, key)) ++result[key];
            else baseAssignValue(result, key, 1);
        });
        /**
     * Checks if `predicate` returns truthy for **all** elements of `collection`.
     * Iteration is stopped once `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * **Note:** This method returns `true` for
     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
     * elements of empty collections.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`.
     * @example
     *
     * _.every([true, 1, null, 'yes'], Boolean);
     * // => false
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.every(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.every(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.every(users, 'active');
     * // => false
     */ function every(collection, predicate, guard) {
            var func = isArray(collection) ? arrayEvery : baseEvery;
            if (guard && isIterateeCall(collection, predicate, guard)) predicate = undefined;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Iterates over elements of `collection`, returning an array of all elements
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * **Note:** Unlike `_.remove`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.reject
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * _.filter(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, { 'age': 36, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.filter(users, 'active');
     * // => objects for ['barney']
     *
     * // Combining several predicates using `_.overEvery` or `_.overSome`.
     * _.filter(users, _.overSome([{ 'age': 36 }, ['age', 40]]));
     * // => objects for ['fred', 'barney']
     */ function filter(collection, predicate) {
            var func = isArray(collection) ? arrayFilter : baseFilter;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Iterates over elements of `collection`, returning the first element
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': true },
     *   { 'user': 'fred',    'age': 40, 'active': false },
     *   { 'user': 'pebbles', 'age': 1,  'active': true }
     * ];
     *
     * _.find(users, function(o) { return o.age < 40; });
     * // => object for 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.find(users, { 'age': 1, 'active': true });
     * // => object for 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.find(users, ['active', false]);
     * // => object for 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.find(users, 'active');
     * // => object for 'barney'
     */ var find = createFind(findIndex);
        /**
     * This method is like `_.find` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=collection.length-1] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * _.findLast([1, 2, 3, 4], function(n) {
     *   return n % 2 == 1;
     * });
     * // => 3
     */ var findLast = createFind(findLastIndex);
        /**
     * Creates a flattened array of values by running each element in `collection`
     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
     * with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [n, n];
     * }
     *
     * _.flatMap([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */ function flatMap(collection, iteratee) {
            return baseFlatten(map(collection, iteratee), 1);
        }
        /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDeep([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */ function flatMapDeep(collection, iteratee) {
            return baseFlatten(map(collection, iteratee), INFINITY);
        }
        /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDepth([1, 2], duplicate, 2);
     * // => [[1, 1], [2, 2]]
     */ function flatMapDepth(collection, iteratee, depth) {
            depth = depth === undefined ? 1 : toInteger(depth);
            return baseFlatten(map(collection, iteratee), depth);
        }
        /**
     * Iterates over elements of `collection` and invokes `iteratee` for each element.
     * The iteratee is invoked with three arguments: (value, index|key, collection).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * **Note:** As with other "Collections" methods, objects with a "length"
     * property are iterated like arrays. To avoid this behavior use `_.forIn`
     * or `_.forOwn` for object iteration.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias each
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEachRight
     * @example
     *
     * _.forEach([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `1` then `2`.
     *
     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */ function forEach(collection, iteratee) {
            var func = isArray(collection) ? arrayEach : baseEach;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.forEach` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @alias eachRight
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEach
     * @example
     *
     * _.forEachRight([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `2` then `1`.
     */ function forEachRight(collection, iteratee) {
            var func = isArray(collection) ? arrayEachRight : baseEachRight;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The order of grouped values
     * is determined by the order they occur in `collection`. The corresponding
     * value of each key is an array of elements responsible for generating the
     * key. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': [4.2], '6': [6.1, 6.3] }
     *
     * // The `_.property` iteratee shorthand.
     * _.groupBy(['one', 'two', 'three'], 'length');
     * // => { '3': ['one', 'two'], '5': ['three'] }
     */ var groupBy = createAggregator(function(result, value, key) {
            if (hasOwnProperty.call(result, key)) result[key].push(value);
            else baseAssignValue(result, key, [
                value
            ]);
        });
        /**
     * Checks if `value` is in `collection`. If `collection` is a string, it's
     * checked for a substring of `value`, otherwise
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * is used for equality comparisons. If `fromIndex` is negative, it's used as
     * the offset from the end of `collection`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {boolean} Returns `true` if `value` is found, else `false`.
     * @example
     *
     * _.includes([1, 2, 3], 1);
     * // => true
     *
     * _.includes([1, 2, 3], 1, 2);
     * // => false
     *
     * _.includes({ 'a': 1, 'b': 2 }, 1);
     * // => true
     *
     * _.includes('abcd', 'bc');
     * // => true
     */ function includes(collection, value, fromIndex, guard) {
            collection = isArrayLike(collection) ? collection : values(collection);
            fromIndex = fromIndex && !guard ? toInteger(fromIndex) : 0;
            var length = collection.length;
            if (fromIndex < 0) fromIndex = nativeMax(length + fromIndex, 0);
            return isString(collection) ? fromIndex <= length && collection.indexOf(value, fromIndex) > -1 : !!length && baseIndexOf(collection, value, fromIndex) > -1;
        }
        /**
     * Invokes the method at `path` of each element in `collection`, returning
     * an array of the results of each invoked method. Any additional arguments
     * are provided to each invoked method. If `path` is a function, it's invoked
     * for, and `this` bound to, each element in `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array|Function|string} path The path of the method to invoke or
     *  the function invoked per iteration.
     * @param {...*} [args] The arguments to invoke each method with.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
     * // => [[1, 5, 7], [1, 2, 3]]
     *
     * _.invokeMap([123, 456], String.prototype.split, '');
     * // => [['1', '2', '3'], ['4', '5', '6']]
     */ var invokeMap = baseRest(function(collection, path, args) {
            var index = -1, isFunc = typeof path == "function", result = isArrayLike(collection) ? Array1(collection.length) : [];
            baseEach(collection, function(value) {
                result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
            });
            return result;
        });
        /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the last element responsible for generating the key. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * var array = [
     *   { 'dir': 'left', 'code': 97 },
     *   { 'dir': 'right', 'code': 100 }
     * ];
     *
     * _.keyBy(array, function(o) {
     *   return String.fromCharCode(o.code);
     * });
     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
     *
     * _.keyBy(array, 'dir');
     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
     */ var keyBy = createAggregator(function(result, value, key) {
            baseAssignValue(result, key, value);
        });
        /**
     * Creates an array of values by running each element in `collection` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
     *
     * The guarded methods are:
     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * _.map([4, 8], square);
     * // => [16, 64]
     *
     * _.map({ 'a': 4, 'b': 8 }, square);
     * // => [16, 64] (iteration order is not guaranteed)
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, 'user');
     * // => ['barney', 'fred']
     */ function map(collection, iteratee) {
            var func = isArray(collection) ? arrayMap : baseMap;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.sortBy` except that it allows specifying the sort
     * orders of the iteratees to sort by. If `orders` is unspecified, all values
     * are sorted in ascending order. Otherwise, specify an order of "desc" for
     * descending or "asc" for ascending sort order of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @param {string[]} [orders] The sort orders of `iteratees`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 34 },
     *   { 'user': 'fred',   'age': 40 },
     *   { 'user': 'barney', 'age': 36 }
     * ];
     *
     * // Sort by `user` in ascending order and by `age` in descending order.
     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
     */ function orderBy(collection, iteratees, orders, guard) {
            if (collection == null) return [];
            if (!isArray(iteratees)) iteratees = iteratees == null ? [] : [
                iteratees
            ];
            orders = guard ? undefined : orders;
            if (!isArray(orders)) orders = orders == null ? [] : [
                orders
            ];
            return baseOrderBy(collection, iteratees, orders);
        }
        /**
     * Creates an array of elements split into two groups, the first of which
     * contains elements `predicate` returns truthy for, the second of which
     * contains elements `predicate` returns falsey for. The predicate is
     * invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of grouped elements.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': false },
     *   { 'user': 'fred',    'age': 40, 'active': true },
     *   { 'user': 'pebbles', 'age': 1,  'active': false }
     * ];
     *
     * _.partition(users, function(o) { return o.active; });
     * // => objects for [['fred'], ['barney', 'pebbles']]
     *
     * // The `_.matches` iteratee shorthand.
     * _.partition(users, { 'age': 1, 'active': false });
     * // => objects for [['pebbles'], ['barney', 'fred']]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.partition(users, ['active', false]);
     * // => objects for [['barney', 'pebbles'], ['fred']]
     *
     * // The `_.property` iteratee shorthand.
     * _.partition(users, 'active');
     * // => objects for [['fred'], ['barney', 'pebbles']]
     */ var partition = createAggregator(function(result, value, key) {
            result[key ? 0 : 1].push(value);
        }, function() {
            return [
                [],
                []
            ];
        });
        /**
     * Reduces `collection` to a value which is the accumulated result of running
     * each element in `collection` thru `iteratee`, where each successive
     * invocation is supplied the return value of the previous. If `accumulator`
     * is not given, the first element of `collection` is used as the initial
     * value. The iteratee is invoked with four arguments:
     * (accumulator, value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.reduce`, `_.reduceRight`, and `_.transform`.
     *
     * The guarded methods are:
     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
     * and `sortBy`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduceRight
     * @example
     *
     * _.reduce([1, 2], function(sum, n) {
     *   return sum + n;
     * }, 0);
     * // => 3
     *
     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     *   return result;
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
     */ function reduce(collection, iteratee, accumulator) {
            var func = isArray(collection) ? arrayReduce : baseReduce, initAccum = arguments.length < 3;
            return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
        }
        /**
     * This method is like `_.reduce` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduce
     * @example
     *
     * var array = [[0, 1], [2, 3], [4, 5]];
     *
     * _.reduceRight(array, function(flattened, other) {
     *   return flattened.concat(other);
     * }, []);
     * // => [4, 5, 2, 3, 0, 1]
     */ function reduceRight(collection, iteratee, accumulator) {
            var func = isArray(collection) ? arrayReduceRight : baseReduce, initAccum = arguments.length < 3;
            return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
        }
        /**
     * The opposite of `_.filter`; this method returns the elements of `collection`
     * that `predicate` does **not** return truthy for.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.filter
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': true }
     * ];
     *
     * _.reject(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.reject(users, { 'age': 40, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.reject(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.reject(users, 'active');
     * // => objects for ['barney']
     */ function reject(collection, predicate) {
            var func = isArray(collection) ? arrayFilter : baseFilter;
            return func(collection, negate(getIteratee(predicate, 3)));
        }
        /**
     * Gets a random element from `collection`.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     * @example
     *
     * _.sample([1, 2, 3, 4]);
     * // => 2
     */ function sample(collection) {
            var func = isArray(collection) ? arraySample : baseSample;
            return func(collection);
        }
        /**
     * Gets `n` random elements at unique keys from `collection` up to the
     * size of `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @param {number} [n=1] The number of elements to sample.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the random elements.
     * @example
     *
     * _.sampleSize([1, 2, 3], 2);
     * // => [3, 1]
     *
     * _.sampleSize([1, 2, 3], 4);
     * // => [2, 3, 1]
     */ function sampleSize(collection, n, guard) {
            if (guard ? isIterateeCall(collection, n, guard) : n === undefined) n = 1;
            else n = toInteger(n);
            var func = isArray(collection) ? arraySampleSize : baseSampleSize;
            return func(collection, n);
        }
        /**
     * Creates an array of shuffled values, using a version of the
     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     * @example
     *
     * _.shuffle([1, 2, 3, 4]);
     * // => [4, 1, 3, 2]
     */ function shuffle(collection) {
            var func = isArray(collection) ? arrayShuffle : baseShuffle;
            return func(collection);
        }
        /**
     * Gets the size of `collection` by returning its length for array-like
     * values or the number of own enumerable string keyed properties for objects.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @returns {number} Returns the collection size.
     * @example
     *
     * _.size([1, 2, 3]);
     * // => 3
     *
     * _.size({ 'a': 1, 'b': 2 });
     * // => 2
     *
     * _.size('pebbles');
     * // => 7
     */ function size(collection) {
            if (collection == null) return 0;
            if (isArrayLike(collection)) return isString(collection) ? stringSize(collection) : collection.length;
            var tag = getTag(collection);
            if (tag == mapTag || tag == setTag) return collection.size;
            return baseKeys(collection).length;
        }
        /**
     * Checks if `predicate` returns truthy for **any** element of `collection`.
     * Iteration is stopped once `predicate` returns truthy. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     * @example
     *
     * _.some([null, 0, 'yes', false], Boolean);
     * // => true
     *
     * var users = [
     *   { 'user': 'barney', 'active': true },
     *   { 'user': 'fred',   'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.some(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.some(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.some(users, 'active');
     * // => true
     */ function some(collection, predicate, guard) {
            var func = isArray(collection) ? arraySome : baseSome;
            if (guard && isIterateeCall(collection, predicate, guard)) predicate = undefined;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Creates an array of elements, sorted in ascending order by the results of
     * running each element in a collection thru each iteratee. This method
     * performs a stable sort, that is, it preserves the original sort order of
     * equal elements. The iteratees are invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 30 },
     *   { 'user': 'barney', 'age': 34 }
     * ];
     *
     * _.sortBy(users, [function(o) { return o.user; }]);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
     *
     * _.sortBy(users, ['user', 'age']);
     * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
     */ var sortBy = baseRest(function(collection, iteratees) {
            if (collection == null) return [];
            var length = iteratees.length;
            if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) iteratees = [];
            else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) iteratees = [
                iteratees[0]
            ];
            return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
        });
        /*------------------------------------------------------------------------*/ /**
     * Gets the timestamp of the number of milliseconds that have elapsed since
     * the Unix epoch (1 January 1970 00:00:00 UTC).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Date
     * @returns {number} Returns the timestamp.
     * @example
     *
     * _.defer(function(stamp) {
     *   console.log(_.now() - stamp);
     * }, _.now());
     * // => Logs the number of milliseconds it took for the deferred invocation.
     */ var now = ctxNow || function() {
            return root.Date.now();
        };
        /*------------------------------------------------------------------------*/ /**
     * The opposite of `_.before`; this method creates a function that invokes
     * `func` once it's called `n` or more times.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {number} n The number of calls before `func` is invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var saves = ['profile', 'settings'];
     *
     * var done = _.after(saves.length, function() {
     *   console.log('done saving!');
     * });
     *
     * _.forEach(saves, function(type) {
     *   asyncSave({ 'type': type, 'complete': done });
     * });
     * // => Logs 'done saving!' after the two async saves have completed.
     */ function after(n, func) {
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            n = toInteger(n);
            return function() {
                if (--n < 1) return func.apply(this, arguments);
            };
        }
        /**
     * Creates a function that invokes `func`, with up to `n` arguments,
     * ignoring any additional arguments.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @param {number} [n=func.length] The arity cap.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
     * // => [6, 8, 10]
     */ function ary(func, n, guard) {
            n = guard ? undefined : n;
            n = func && n == null ? func.length : n;
            return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
        }
        /**
     * Creates a function that invokes `func`, with the `this` binding and arguments
     * of the created function, while it's called less than `n` times. Subsequent
     * calls to the created function return the result of the last `func` invocation.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {number} n The number of calls at which `func` is no longer invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * jQuery(element).on('click', _.before(5, addContactToList));
     * // => Allows adding up to 4 contacts to the list.
     */ function before(n, func) {
            var result;
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            n = toInteger(n);
            return function() {
                if (--n > 0) result = func.apply(this, arguments);
                if (n <= 1) func = undefined;
                return result;
            };
        }
        /**
     * Creates a function that invokes `func` with the `this` binding of `thisArg`
     * and `partials` prepended to the arguments it receives.
     *
     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for partially applied arguments.
     *
     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
     * property of bound functions.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to bind.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * function greet(greeting, punctuation) {
     *   return greeting + ' ' + this.user + punctuation;
     * }
     *
     * var object = { 'user': 'fred' };
     *
     * var bound = _.bind(greet, object, 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bind(greet, object, _, '!');
     * bound('hi');
     * // => 'hi fred!'
     */ var bind = baseRest(function(func, thisArg, partials) {
            var bitmask = WRAP_BIND_FLAG;
            if (partials.length) {
                var holders = replaceHolders(partials, getHolder(bind));
                bitmask |= WRAP_PARTIAL_FLAG;
            }
            return createWrap(func, bitmask, thisArg, partials, holders);
        });
        /**
     * Creates a function that invokes the method at `object[key]` with `partials`
     * prepended to the arguments it receives.
     *
     * This method differs from `_.bind` by allowing bound functions to reference
     * methods that may be redefined or don't yet exist. See
     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
     * for more details.
     *
     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Function
     * @param {Object} object The object to invoke the method on.
     * @param {string} key The key of the method.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * var object = {
     *   'user': 'fred',
     *   'greet': function(greeting, punctuation) {
     *     return greeting + ' ' + this.user + punctuation;
     *   }
     * };
     *
     * var bound = _.bindKey(object, 'greet', 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * object.greet = function(greeting, punctuation) {
     *   return greeting + 'ya ' + this.user + punctuation;
     * };
     *
     * bound('!');
     * // => 'hiya fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bindKey(object, 'greet', _, '!');
     * bound('hi');
     * // => 'hiya fred!'
     */ var bindKey = baseRest(function(object, key, partials) {
            var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
            if (partials.length) {
                var holders = replaceHolders(partials, getHolder(bindKey));
                bitmask |= WRAP_PARTIAL_FLAG;
            }
            return createWrap(key, bitmask, object, partials, holders);
        });
        /**
     * Creates a function that accepts arguments of `func` and either invokes
     * `func` returning its result, if at least `arity` number of arguments have
     * been provided, or returns a function that accepts the remaining `func`
     * arguments, and so on. The arity of `func` may be specified if `func.length`
     * is not sufficient.
     *
     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curry(abc);
     *
     * curried(1)(2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(1)(_, 3)(2);
     * // => [1, 2, 3]
     */ function curry(func, arity, guard) {
            arity = guard ? undefined : arity;
            var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
            result.placeholder = curry.placeholder;
            return result;
        }
        /**
     * This method is like `_.curry` except that arguments are applied to `func`
     * in the manner of `_.partialRight` instead of `_.partial`.
     *
     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curryRight(abc);
     *
     * curried(3)(2)(1);
     * // => [1, 2, 3]
     *
     * curried(2, 3)(1);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(3)(1, _)(2);
     * // => [1, 2, 3]
     */ function curryRight(func, arity, guard) {
            arity = guard ? undefined : arity;
            var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
            result.placeholder = curryRight.placeholder;
            return result;
        }
        /**
     * Creates a debounced function that delays invoking `func` until after `wait`
     * milliseconds have elapsed since the last time the debounced function was
     * invoked. The debounced function comes with a `cancel` method to cancel
     * delayed `func` invocations and a `flush` method to immediately invoke them.
     * Provide `options` to indicate whether `func` should be invoked on the
     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
     * with the last arguments provided to the debounced function. Subsequent
     * calls to the debounced function return the result of the last `func`
     * invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the debounced function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.debounce` and `_.throttle`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to debounce.
     * @param {number} [wait=0] The number of milliseconds to delay.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=false]
     *  Specify invoking on the leading edge of the timeout.
     * @param {number} [options.maxWait]
     *  The maximum time `func` is allowed to be delayed before it's invoked.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new debounced function.
     * @example
     *
     * // Avoid costly calculations while the window size is in flux.
     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
     *
     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
     * jQuery(element).on('click', _.debounce(sendMail, 300, {
     *   'leading': true,
     *   'trailing': false
     * }));
     *
     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
     * var source = new EventSource('/stream');
     * jQuery(source).on('message', debounced);
     *
     * // Cancel the trailing debounced invocation.
     * jQuery(window).on('popstate', debounced.cancel);
     */ function debounce(func, wait, options) {
            var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            wait = toNumber(wait) || 0;
            if (isObject(options)) {
                leading = !!options.leading;
                maxing = "maxWait" in options;
                maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
                trailing = "trailing" in options ? !!options.trailing : trailing;
            }
            function invokeFunc(time) {
                var args = lastArgs, thisArg = lastThis;
                lastArgs = lastThis = undefined;
                lastInvokeTime = time;
                result = func.apply(thisArg, args);
                return result;
            }
            function leadingEdge(time) {
                // Reset any `maxWait` timer.
                lastInvokeTime = time;
                // Start the timer for the trailing edge.
                timerId = setTimeout(timerExpired, wait);
                // Invoke the leading edge.
                return leading ? invokeFunc(time) : result;
            }
            function remainingWait(time) {
                var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, timeWaiting = wait - timeSinceLastCall;
                return maxing ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
            }
            function shouldInvoke(time) {
                var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
                // Either this is the first call, activity has stopped and we're at the
                // trailing edge, the system time has gone backwards and we're treating
                // it as the trailing edge, or we've hit the `maxWait` limit.
                return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
            }
            function timerExpired() {
                var time = now();
                if (shouldInvoke(time)) return trailingEdge(time);
                // Restart the timer.
                timerId = setTimeout(timerExpired, remainingWait(time));
            }
            function trailingEdge(time) {
                timerId = undefined;
                // Only invoke if we have `lastArgs` which means `func` has been
                // debounced at least once.
                if (trailing && lastArgs) return invokeFunc(time);
                lastArgs = lastThis = undefined;
                return result;
            }
            function cancel() {
                if (timerId !== undefined) clearTimeout(timerId);
                lastInvokeTime = 0;
                lastArgs = lastCallTime = lastThis = timerId = undefined;
            }
            function flush() {
                return timerId === undefined ? result : trailingEdge(now());
            }
            function debounced() {
                var time = now(), isInvoking = shouldInvoke(time);
                lastArgs = arguments;
                lastThis = this;
                lastCallTime = time;
                if (isInvoking) {
                    if (timerId === undefined) return leadingEdge(lastCallTime);
                    if (maxing) {
                        // Handle invocations in a tight loop.
                        clearTimeout(timerId);
                        timerId = setTimeout(timerExpired, wait);
                        return invokeFunc(lastCallTime);
                    }
                }
                if (timerId === undefined) timerId = setTimeout(timerExpired, wait);
                return result;
            }
            debounced.cancel = cancel;
            debounced.flush = flush;
            return debounced;
        }
        /**
     * Defers invoking the `func` until the current call stack has cleared. Any
     * additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to defer.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.defer(function(text) {
     *   console.log(text);
     * }, 'deferred');
     * // => Logs 'deferred' after one millisecond.
     */ var defer = baseRest(function(func, args) {
            return baseDelay(func, 1, args);
        });
        /**
     * Invokes `func` after `wait` milliseconds. Any additional arguments are
     * provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.delay(function(text) {
     *   console.log(text);
     * }, 1000, 'later');
     * // => Logs 'later' after one second.
     */ var delay = baseRest(function(func, wait, args) {
            return baseDelay(func, toNumber(wait) || 0, args);
        });
        /**
     * Creates a function that invokes `func` with arguments reversed.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to flip arguments for.
     * @returns {Function} Returns the new flipped function.
     * @example
     *
     * var flipped = _.flip(function() {
     *   return _.toArray(arguments);
     * });
     *
     * flipped('a', 'b', 'c', 'd');
     * // => ['d', 'c', 'b', 'a']
     */ function flip(func) {
            return createWrap(func, WRAP_FLIP_FLAG);
        }
        /**
     * Creates a function that memoizes the result of `func`. If `resolver` is
     * provided, it determines the cache key for storing the result based on the
     * arguments provided to the memoized function. By default, the first argument
     * provided to the memoized function is used as the map cache key. The `func`
     * is invoked with the `this` binding of the memoized function.
     *
     * **Note:** The cache is exposed as the `cache` property on the memoized
     * function. Its creation may be customized by replacing the `_.memoize.Cache`
     * constructor with one whose instances implement the
     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to have its output memoized.
     * @param {Function} [resolver] The function to resolve the cache key.
     * @returns {Function} Returns the new memoized function.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     * var other = { 'c': 3, 'd': 4 };
     *
     * var values = _.memoize(_.values);
     * values(object);
     * // => [1, 2]
     *
     * values(other);
     * // => [3, 4]
     *
     * object.a = 2;
     * values(object);
     * // => [1, 2]
     *
     * // Modify the result cache.
     * values.cache.set(object, ['a', 'b']);
     * values(object);
     * // => ['a', 'b']
     *
     * // Replace `_.memoize.Cache`.
     * _.memoize.Cache = WeakMap;
     */ function memoize(func, resolver) {
            if (typeof func != "function" || resolver != null && typeof resolver != "function") throw new TypeError(FUNC_ERROR_TEXT);
            var memoized = function() {
                var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
                if (cache.has(key)) return cache.get(key);
                var result = func.apply(this, args);
                memoized.cache = cache.set(key, result) || cache;
                return result;
            };
            memoized.cache = new (memoize.Cache || MapCache);
            return memoized;
        }
        // Expose `MapCache`.
        memoize.Cache = MapCache;
        /**
     * Creates a function that negates the result of the predicate `func`. The
     * `func` predicate is invoked with the `this` binding and arguments of the
     * created function.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} predicate The predicate to negate.
     * @returns {Function} Returns the new negated function.
     * @example
     *
     * function isEven(n) {
     *   return n % 2 == 0;
     * }
     *
     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
     * // => [1, 3, 5]
     */ function negate(predicate) {
            if (typeof predicate != "function") throw new TypeError(FUNC_ERROR_TEXT);
            return function() {
                var args = arguments;
                switch(args.length){
                    case 0:
                        return !predicate.call(this);
                    case 1:
                        return !predicate.call(this, args[0]);
                    case 2:
                        return !predicate.call(this, args[0], args[1]);
                    case 3:
                        return !predicate.call(this, args[0], args[1], args[2]);
                }
                return !predicate.apply(this, args);
            };
        }
        /**
     * Creates a function that is restricted to invoking `func` once. Repeat calls
     * to the function return the value of the first invocation. The `func` is
     * invoked with the `this` binding and arguments of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var initialize = _.once(createApplication);
     * initialize();
     * initialize();
     * // => `createApplication` is invoked once
     */ function once(func) {
            return before(2, func);
        }
        /**
     * Creates a function that invokes `func` with its arguments transformed.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Function
     * @param {Function} func The function to wrap.
     * @param {...(Function|Function[])} [transforms=[_.identity]]
     *  The argument transforms.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function doubled(n) {
     *   return n * 2;
     * }
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var func = _.overArgs(function(x, y) {
     *   return [x, y];
     * }, [square, doubled]);
     *
     * func(9, 3);
     * // => [81, 6]
     *
     * func(10, 5);
     * // => [100, 10]
     */ var overArgs = castRest(function(func, transforms) {
            transforms = transforms.length == 1 && isArray(transforms[0]) ? arrayMap(transforms[0], baseUnary(getIteratee())) : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));
            var funcsLength = transforms.length;
            return baseRest(function(args) {
                var index = -1, length = nativeMin(args.length, funcsLength);
                while(++index < length)args[index] = transforms[index].call(this, args[index]);
                return apply(func, this, args);
            });
        });
        /**
     * Creates a function that invokes `func` with `partials` prepended to the
     * arguments it receives. This method is like `_.bind` except it does **not**
     * alter the `this` binding.
     *
     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 0.2.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var sayHelloTo = _.partial(greet, 'hello');
     * sayHelloTo('fred');
     * // => 'hello fred'
     *
     * // Partially applied with placeholders.
     * var greetFred = _.partial(greet, _, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     */ var partial = baseRest(function(func, partials) {
            var holders = replaceHolders(partials, getHolder(partial));
            return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
        });
        /**
     * This method is like `_.partial` except that partially applied arguments
     * are appended to the arguments it receives.
     *
     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var greetFred = _.partialRight(greet, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     *
     * // Partially applied with placeholders.
     * var sayHelloTo = _.partialRight(greet, 'hello', _);
     * sayHelloTo('fred');
     * // => 'hello fred'
     */ var partialRight = baseRest(function(func, partials) {
            var holders = replaceHolders(partials, getHolder(partialRight));
            return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
        });
        /**
     * Creates a function that invokes `func` with arguments arranged according
     * to the specified `indexes` where the argument value at the first index is
     * provided as the first argument, the argument value at the second index is
     * provided as the second argument, and so on.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to rearrange arguments for.
     * @param {...(number|number[])} indexes The arranged argument indexes.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var rearged = _.rearg(function(a, b, c) {
     *   return [a, b, c];
     * }, [2, 0, 1]);
     *
     * rearged('b', 'c', 'a')
     * // => ['a', 'b', 'c']
     */ var rearg = flatRest(function(func, indexes) {
            return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
        });
        /**
     * Creates a function that invokes `func` with the `this` binding of the
     * created function and arguments from `start` and beyond provided as
     * an array.
     *
     * **Note:** This method is based on the
     * [rest parameter](https://mdn.io/rest_parameters).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.rest(function(what, names) {
     *   return what + ' ' + _.initial(names).join(', ') +
     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
     * });
     *
     * say('hello', 'fred', 'barney', 'pebbles');
     * // => 'hello fred, barney, & pebbles'
     */ function rest(func, start) {
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            start = start === undefined ? start : toInteger(start);
            return baseRest(func, start);
        }
        /**
     * Creates a function that invokes `func` with the `this` binding of the
     * create function and an array of arguments much like
     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
     *
     * **Note:** This method is based on the
     * [spread operator](https://mdn.io/spread_operator).
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Function
     * @param {Function} func The function to spread arguments over.
     * @param {number} [start=0] The start position of the spread.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.spread(function(who, what) {
     *   return who + ' says ' + what;
     * });
     *
     * say(['fred', 'hello']);
     * // => 'fred says hello'
     *
     * var numbers = Promise.all([
     *   Promise.resolve(40),
     *   Promise.resolve(36)
     * ]);
     *
     * numbers.then(_.spread(function(x, y) {
     *   return x + y;
     * }));
     * // => a Promise of 76
     */ function spread(func, start) {
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            start = start == null ? 0 : nativeMax(toInteger(start), 0);
            return baseRest(function(args) {
                var array = args[start], otherArgs = castSlice(args, 0, start);
                if (array) arrayPush(otherArgs, array);
                return apply(func, this, otherArgs);
            });
        }
        /**
     * Creates a throttled function that only invokes `func` at most once per
     * every `wait` milliseconds. The throttled function comes with a `cancel`
     * method to cancel delayed `func` invocations and a `flush` method to
     * immediately invoke them. Provide `options` to indicate whether `func`
     * should be invoked on the leading and/or trailing edge of the `wait`
     * timeout. The `func` is invoked with the last arguments provided to the
     * throttled function. Subsequent calls to the throttled function return the
     * result of the last `func` invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the throttled function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.throttle` and `_.debounce`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to throttle.
     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=true]
     *  Specify invoking on the leading edge of the timeout.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new throttled function.
     * @example
     *
     * // Avoid excessively updating the position while scrolling.
     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
     *
     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
     * jQuery(element).on('click', throttled);
     *
     * // Cancel the trailing throttled invocation.
     * jQuery(window).on('popstate', throttled.cancel);
     */ function throttle(func, wait, options) {
            var leading = true, trailing = true;
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            if (isObject(options)) {
                leading = "leading" in options ? !!options.leading : leading;
                trailing = "trailing" in options ? !!options.trailing : trailing;
            }
            return debounce(func, wait, {
                "leading": leading,
                "maxWait": wait,
                "trailing": trailing
            });
        }
        /**
     * Creates a function that accepts up to one argument, ignoring any
     * additional arguments.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.unary(parseInt));
     * // => [6, 8, 10]
     */ function unary(func) {
            return ary(func, 1);
        }
        /**
     * Creates a function that provides `value` to `wrapper` as its first
     * argument. Any additional arguments provided to the function are appended
     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
     * binding of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {*} value The value to wrap.
     * @param {Function} [wrapper=identity] The wrapper function.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var p = _.wrap(_.escape, function(func, text) {
     *   return '<p>' + func(text) + '</p>';
     * });
     *
     * p('fred, barney, & pebbles');
     * // => '<p>fred, barney, &amp; pebbles</p>'
     */ function wrap(value, wrapper) {
            return partial(castFunction(wrapper), value);
        }
        /*------------------------------------------------------------------------*/ /**
     * Casts `value` as an array if it's not one.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Lang
     * @param {*} value The value to inspect.
     * @returns {Array} Returns the cast array.
     * @example
     *
     * _.castArray(1);
     * // => [1]
     *
     * _.castArray({ 'a': 1 });
     * // => [{ 'a': 1 }]
     *
     * _.castArray('abc');
     * // => ['abc']
     *
     * _.castArray(null);
     * // => [null]
     *
     * _.castArray(undefined);
     * // => [undefined]
     *
     * _.castArray();
     * // => []
     *
     * var array = [1, 2, 3];
     * console.log(_.castArray(array) === array);
     * // => true
     */ function castArray() {
            if (!arguments.length) return [];
            var value = arguments[0];
            return isArray(value) ? value : [
                value
            ];
        }
        /**
     * Creates a shallow clone of `value`.
     *
     * **Note:** This method is loosely based on the
     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
     * and supports cloning arrays, array buffers, booleans, date objects, maps,
     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
     * arrays. The own enumerable properties of `arguments` objects are cloned
     * as plain objects. An empty object is returned for uncloneable values such
     * as error objects, functions, DOM nodes, and WeakMaps.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to clone.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeep
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var shallow = _.clone(objects);
     * console.log(shallow[0] === objects[0]);
     * // => true
     */ function clone(value) {
            return baseClone(value, CLONE_SYMBOLS_FLAG);
        }
        /**
     * This method is like `_.clone` except that it accepts `customizer` which
     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
     * cloning is handled by the method instead. The `customizer` is invoked with
     * up to four arguments; (value [, index|key, object, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeepWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(false);
     *   }
     * }
     *
     * var el = _.cloneWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 0
     */ function cloneWith(value, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined;
            return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
        }
        /**
     * This method is like `_.clone` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @returns {*} Returns the deep cloned value.
     * @see _.clone
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var deep = _.cloneDeep(objects);
     * console.log(deep[0] === objects[0]);
     * // => false
     */ function cloneDeep(value) {
            return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
        }
        /**
     * This method is like `_.cloneWith` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the deep cloned value.
     * @see _.cloneWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(true);
     *   }
     * }
     *
     * var el = _.cloneDeepWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 20
     */ function cloneDeepWith(value, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined;
            return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
        }
        /**
     * Checks if `object` conforms to `source` by invoking the predicate
     * properties of `source` with the corresponding property values of `object`.
     *
     * **Note:** This method is equivalent to `_.conforms` when `source` is
     * partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
     * // => true
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
     * // => false
     */ function conformsTo(object, source) {
            return source == null || baseConformsTo(object, source, keys(source));
        }
        /**
     * Performs a
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * comparison between two values to determine if they are equivalent.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.eq(object, object);
     * // => true
     *
     * _.eq(object, other);
     * // => false
     *
     * _.eq('a', 'a');
     * // => true
     *
     * _.eq('a', Object('a'));
     * // => false
     *
     * _.eq(NaN, NaN);
     * // => true
     */ function eq(value, other) {
            return value === other || value !== value && other !== other;
        }
        /**
     * Checks if `value` is greater than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     * @see _.lt
     * @example
     *
     * _.gt(3, 1);
     * // => true
     *
     * _.gt(3, 3);
     * // => false
     *
     * _.gt(1, 3);
     * // => false
     */ var gt = createRelationalOperation(baseGt);
        /**
     * Checks if `value` is greater than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than or equal to
     *  `other`, else `false`.
     * @see _.lte
     * @example
     *
     * _.gte(3, 1);
     * // => true
     *
     * _.gte(3, 3);
     * // => true
     *
     * _.gte(1, 3);
     * // => false
     */ var gte = createRelationalOperation(function(value, other) {
            return value >= other;
        });
        /**
     * Checks if `value` is likely an `arguments` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     *  else `false`.
     * @example
     *
     * _.isArguments(function() { return arguments; }());
     * // => true
     *
     * _.isArguments([1, 2, 3]);
     * // => false
     */ var isArguments = baseIsArguments(function() {
            return arguments;
        }()) ? baseIsArguments : function(value) {
            return isObjectLike(value) && hasOwnProperty.call(value, "callee") && !propertyIsEnumerable.call(value, "callee");
        };
        /**
     * Checks if `value` is classified as an `Array` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
     * @example
     *
     * _.isArray([1, 2, 3]);
     * // => true
     *
     * _.isArray(document.body.children);
     * // => false
     *
     * _.isArray('abc');
     * // => false
     *
     * _.isArray(_.noop);
     * // => false
     */ var isArray = Array1.isArray;
        /**
     * Checks if `value` is classified as an `ArrayBuffer` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     * @example
     *
     * _.isArrayBuffer(new ArrayBuffer(2));
     * // => true
     *
     * _.isArrayBuffer(new Array(2));
     * // => false
     */ var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;
        /**
     * Checks if `value` is array-like. A value is considered array-like if it's
     * not a function and has a `value.length` that's an integer greater than or
     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
     * @example
     *
     * _.isArrayLike([1, 2, 3]);
     * // => true
     *
     * _.isArrayLike(document.body.children);
     * // => true
     *
     * _.isArrayLike('abc');
     * // => true
     *
     * _.isArrayLike(_.noop);
     * // => false
     */ function isArrayLike(value) {
            return value != null && isLength(value.length) && !isFunction(value);
        }
        /**
     * This method is like `_.isArrayLike` except that it also checks if `value`
     * is an object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array-like object,
     *  else `false`.
     * @example
     *
     * _.isArrayLikeObject([1, 2, 3]);
     * // => true
     *
     * _.isArrayLikeObject(document.body.children);
     * // => true
     *
     * _.isArrayLikeObject('abc');
     * // => false
     *
     * _.isArrayLikeObject(_.noop);
     * // => false
     */ function isArrayLikeObject(value) {
            return isObjectLike(value) && isArrayLike(value);
        }
        /**
     * Checks if `value` is classified as a boolean primitive or object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
     * @example
     *
     * _.isBoolean(false);
     * // => true
     *
     * _.isBoolean(null);
     * // => false
     */ function isBoolean(value) {
            return value === true || value === false || isObjectLike(value) && baseGetTag(value) == boolTag;
        }
        /**
     * Checks if `value` is a buffer.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
     * @example
     *
     * _.isBuffer(new Buffer(2));
     * // => true
     *
     * _.isBuffer(new Uint8Array(2));
     * // => false
     */ var isBuffer = nativeIsBuffer || stubFalse;
        /**
     * Checks if `value` is classified as a `Date` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     * @example
     *
     * _.isDate(new Date);
     * // => true
     *
     * _.isDate('Mon April 23 2012');
     * // => false
     */ var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;
        /**
     * Checks if `value` is likely a DOM element.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
     * @example
     *
     * _.isElement(document.body);
     * // => true
     *
     * _.isElement('<body>');
     * // => false
     */ function isElement(value) {
            return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
        }
        /**
     * Checks if `value` is an empty object, collection, map, or set.
     *
     * Objects are considered empty if they have no own enumerable string keyed
     * properties.
     *
     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
     * jQuery-like collections are considered empty if they have a `length` of `0`.
     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
     * @example
     *
     * _.isEmpty(null);
     * // => true
     *
     * _.isEmpty(true);
     * // => true
     *
     * _.isEmpty(1);
     * // => true
     *
     * _.isEmpty([1, 2, 3]);
     * // => false
     *
     * _.isEmpty({ 'a': 1 });
     * // => false
     */ function isEmpty(value) {
            if (value == null) return true;
            if (isArrayLike(value) && (isArray(value) || typeof value == "string" || typeof value.splice == "function" || isBuffer(value) || isTypedArray(value) || isArguments(value))) return !value.length;
            var tag = getTag(value);
            if (tag == mapTag || tag == setTag) return !value.size;
            if (isPrototype(value)) return !baseKeys(value).length;
            for(var key in value){
                if (hasOwnProperty.call(value, key)) return false;
            }
            return true;
        }
        /**
     * Performs a deep comparison between two values to determine if they are
     * equivalent.
     *
     * **Note:** This method supports comparing arrays, array buffers, booleans,
     * date objects, error objects, maps, numbers, `Object` objects, regexes,
     * sets, strings, symbols, and typed arrays. `Object` objects are compared
     * by their own, not inherited, enumerable properties. Functions and DOM
     * nodes are compared by strict equality, i.e. `===`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.isEqual(object, other);
     * // => true
     *
     * object === other;
     * // => false
     */ function isEqual(value, other) {
            return baseIsEqual(value, other);
        }
        /**
     * This method is like `_.isEqual` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with up to
     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, othValue) {
     *   if (isGreeting(objValue) && isGreeting(othValue)) {
     *     return true;
     *   }
     * }
     *
     * var array = ['hello', 'goodbye'];
     * var other = ['hi', 'goodbye'];
     *
     * _.isEqualWith(array, other, customizer);
     * // => true
     */ function isEqualWith(value, other, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined;
            var result = customizer ? customizer(value, other) : undefined;
            return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
        }
        /**
     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
     * `SyntaxError`, `TypeError`, or `URIError` object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
     * @example
     *
     * _.isError(new Error);
     * // => true
     *
     * _.isError(Error);
     * // => false
     */ function isError(value) {
            if (!isObjectLike(value)) return false;
            var tag = baseGetTag(value);
            return tag == errorTag || tag == domExcTag || typeof value.message == "string" && typeof value.name == "string" && !isPlainObject(value);
        }
        /**
     * Checks if `value` is a finite primitive number.
     *
     * **Note:** This method is based on
     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
     * @example
     *
     * _.isFinite(3);
     * // => true
     *
     * _.isFinite(Number.MIN_VALUE);
     * // => true
     *
     * _.isFinite(Infinity);
     * // => false
     *
     * _.isFinite('3');
     * // => false
     */ function isFinite(value) {
            return typeof value == "number" && nativeIsFinite(value);
        }
        /**
     * Checks if `value` is classified as a `Function` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
     * @example
     *
     * _.isFunction(_);
     * // => true
     *
     * _.isFunction(/abc/);
     * // => false
     */ function isFunction(value) {
            if (!isObject(value)) return false;
            // The use of `Object#toString` avoids issues with the `typeof` operator
            // in Safari 9 which returns 'object' for typed arrays and other constructors.
            var tag = baseGetTag(value);
            return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
        }
        /**
     * Checks if `value` is an integer.
     *
     * **Note:** This method is based on
     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
     * @example
     *
     * _.isInteger(3);
     * // => true
     *
     * _.isInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isInteger(Infinity);
     * // => false
     *
     * _.isInteger('3');
     * // => false
     */ function isInteger(value) {
            return typeof value == "number" && value == toInteger(value);
        }
        /**
     * Checks if `value` is a valid array-like length.
     *
     * **Note:** This method is loosely based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
     * @example
     *
     * _.isLength(3);
     * // => true
     *
     * _.isLength(Number.MIN_VALUE);
     * // => false
     *
     * _.isLength(Infinity);
     * // => false
     *
     * _.isLength('3');
     * // => false
     */ function isLength(value) {
            return typeof value == "number" && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
        }
        /**
     * Checks if `value` is the
     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
     * @example
     *
     * _.isObject({});
     * // => true
     *
     * _.isObject([1, 2, 3]);
     * // => true
     *
     * _.isObject(_.noop);
     * // => true
     *
     * _.isObject(null);
     * // => false
     */ function isObject(value) {
            var type = typeof value;
            return value != null && (type == "object" || type == "function");
        }
        /**
     * Checks if `value` is object-like. A value is object-like if it's not `null`
     * and has a `typeof` result of "object".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
     * @example
     *
     * _.isObjectLike({});
     * // => true
     *
     * _.isObjectLike([1, 2, 3]);
     * // => true
     *
     * _.isObjectLike(_.noop);
     * // => false
     *
     * _.isObjectLike(null);
     * // => false
     */ function isObjectLike(value) {
            return value != null && typeof value == "object";
        }
        /**
     * Checks if `value` is classified as a `Map` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     * @example
     *
     * _.isMap(new Map);
     * // => true
     *
     * _.isMap(new WeakMap);
     * // => false
     */ var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;
        /**
     * Performs a partial deep comparison between `object` and `source` to
     * determine if `object` contains equivalent property values.
     *
     * **Note:** This method is equivalent to `_.matches` when `source` is
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.isMatch(object, { 'b': 2 });
     * // => true
     *
     * _.isMatch(object, { 'b': 1 });
     * // => false
     */ function isMatch(object, source) {
            return object === source || baseIsMatch(object, source, getMatchData(source));
        }
        /**
     * This method is like `_.isMatch` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with five
     * arguments: (objValue, srcValue, index|key, object, source).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, srcValue) {
     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
     *     return true;
     *   }
     * }
     *
     * var object = { 'greeting': 'hello' };
     * var source = { 'greeting': 'hi' };
     *
     * _.isMatchWith(object, source, customizer);
     * // => true
     */ function isMatchWith(object, source, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined;
            return baseIsMatch(object, source, getMatchData(source), customizer);
        }
        /**
     * Checks if `value` is `NaN`.
     *
     * **Note:** This method is based on
     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
     * `undefined` and other non-number values.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
     * @example
     *
     * _.isNaN(NaN);
     * // => true
     *
     * _.isNaN(new Number(NaN));
     * // => true
     *
     * isNaN(undefined);
     * // => true
     *
     * _.isNaN(undefined);
     * // => false
     */ function isNaN(value) {
            // An `NaN` primitive is the only value that is not equal to itself.
            // Perform the `toStringTag` check first to avoid errors with some
            // ActiveX objects in IE.
            return isNumber(value) && value != +value;
        }
        /**
     * Checks if `value` is a pristine native function.
     *
     * **Note:** This method can't reliably detect native functions in the presence
     * of the core-js package because core-js circumvents this kind of detection.
     * Despite multiple requests, the core-js maintainer has made it clear: any
     * attempt to fix the detection will be obstructed. As a result, we're left
     * with little choice but to throw an error. Unfortunately, this also affects
     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
     * which rely on core-js.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     * @example
     *
     * _.isNative(Array.prototype.push);
     * // => true
     *
     * _.isNative(_);
     * // => false
     */ function isNative(value) {
            if (isMaskable(value)) throw new Error(CORE_ERROR_TEXT);
            return baseIsNative(value);
        }
        /**
     * Checks if `value` is `null`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
     * @example
     *
     * _.isNull(null);
     * // => true
     *
     * _.isNull(void 0);
     * // => false
     */ function isNull(value) {
            return value === null;
        }
        /**
     * Checks if `value` is `null` or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
     * @example
     *
     * _.isNil(null);
     * // => true
     *
     * _.isNil(void 0);
     * // => true
     *
     * _.isNil(NaN);
     * // => false
     */ function isNil(value) {
            return value == null;
        }
        /**
     * Checks if `value` is classified as a `Number` primitive or object.
     *
     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
     * classified as numbers, use the `_.isFinite` method.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
     * @example
     *
     * _.isNumber(3);
     * // => true
     *
     * _.isNumber(Number.MIN_VALUE);
     * // => true
     *
     * _.isNumber(Infinity);
     * // => true
     *
     * _.isNumber('3');
     * // => false
     */ function isNumber(value) {
            return typeof value == "number" || isObjectLike(value) && baseGetTag(value) == numberTag;
        }
        /**
     * Checks if `value` is a plain object, that is, an object created by the
     * `Object` constructor or one with a `[[Prototype]]` of `null`.
     *
     * @static
     * @memberOf _
     * @since 0.8.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * _.isPlainObject(new Foo);
     * // => false
     *
     * _.isPlainObject([1, 2, 3]);
     * // => false
     *
     * _.isPlainObject({ 'x': 0, 'y': 0 });
     * // => true
     *
     * _.isPlainObject(Object.create(null));
     * // => true
     */ function isPlainObject(value) {
            if (!isObjectLike(value) || baseGetTag(value) != objectTag) return false;
            var proto = getPrototype(value);
            if (proto === null) return true;
            var Ctor = hasOwnProperty.call(proto, "constructor") && proto.constructor;
            return typeof Ctor == "function" && Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString;
        }
        /**
     * Checks if `value` is classified as a `RegExp` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     * @example
     *
     * _.isRegExp(/abc/);
     * // => true
     *
     * _.isRegExp('/abc/');
     * // => false
     */ var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;
        /**
     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
     * double precision number which isn't the result of a rounded unsafe integer.
     *
     * **Note:** This method is based on
     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
     * @example
     *
     * _.isSafeInteger(3);
     * // => true
     *
     * _.isSafeInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isSafeInteger(Infinity);
     * // => false
     *
     * _.isSafeInteger('3');
     * // => false
     */ function isSafeInteger(value) {
            return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
        }
        /**
     * Checks if `value` is classified as a `Set` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     * @example
     *
     * _.isSet(new Set);
     * // => true
     *
     * _.isSet(new WeakSet);
     * // => false
     */ var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;
        /**
     * Checks if `value` is classified as a `String` primitive or object.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
     * @example
     *
     * _.isString('abc');
     * // => true
     *
     * _.isString(1);
     * // => false
     */ function isString(value) {
            return typeof value == "string" || !isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag;
        }
        /**
     * Checks if `value` is classified as a `Symbol` primitive or object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
     * @example
     *
     * _.isSymbol(Symbol.iterator);
     * // => true
     *
     * _.isSymbol('abc');
     * // => false
     */ function isSymbol(value) {
            return typeof value == "symbol" || isObjectLike(value) && baseGetTag(value) == symbolTag;
        }
        /**
     * Checks if `value` is classified as a typed array.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     * @example
     *
     * _.isTypedArray(new Uint8Array);
     * // => true
     *
     * _.isTypedArray([]);
     * // => false
     */ var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
        /**
     * Checks if `value` is `undefined`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
     * @example
     *
     * _.isUndefined(void 0);
     * // => true
     *
     * _.isUndefined(null);
     * // => false
     */ function isUndefined(value) {
            return value === undefined;
        }
        /**
     * Checks if `value` is classified as a `WeakMap` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
     * @example
     *
     * _.isWeakMap(new WeakMap);
     * // => true
     *
     * _.isWeakMap(new Map);
     * // => false
     */ function isWeakMap(value) {
            return isObjectLike(value) && getTag(value) == weakMapTag;
        }
        /**
     * Checks if `value` is classified as a `WeakSet` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
     * @example
     *
     * _.isWeakSet(new WeakSet);
     * // => true
     *
     * _.isWeakSet(new Set);
     * // => false
     */ function isWeakSet(value) {
            return isObjectLike(value) && baseGetTag(value) == weakSetTag;
        }
        /**
     * Checks if `value` is less than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     * @see _.gt
     * @example
     *
     * _.lt(1, 3);
     * // => true
     *
     * _.lt(3, 3);
     * // => false
     *
     * _.lt(3, 1);
     * // => false
     */ var lt = createRelationalOperation(baseLt);
        /**
     * Checks if `value` is less than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than or equal to
     *  `other`, else `false`.
     * @see _.gte
     * @example
     *
     * _.lte(1, 3);
     * // => true
     *
     * _.lte(3, 3);
     * // => true
     *
     * _.lte(3, 1);
     * // => false
     */ var lte = createRelationalOperation(function(value, other) {
            return value <= other;
        });
        /**
     * Converts `value` to an array.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Array} Returns the converted array.
     * @example
     *
     * _.toArray({ 'a': 1, 'b': 2 });
     * // => [1, 2]
     *
     * _.toArray('abc');
     * // => ['a', 'b', 'c']
     *
     * _.toArray(1);
     * // => []
     *
     * _.toArray(null);
     * // => []
     */ function toArray(value) {
            if (!value) return [];
            if (isArrayLike(value)) return isString(value) ? stringToArray(value) : copyArray(value);
            if (symIterator && value[symIterator]) return iteratorToArray(value[symIterator]());
            var tag = getTag(value), func = tag == mapTag ? mapToArray : tag == setTag ? setToArray : values;
            return func(value);
        }
        /**
     * Converts `value` to a finite number.
     *
     * @static
     * @memberOf _
     * @since 4.12.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted number.
     * @example
     *
     * _.toFinite(3.2);
     * // => 3.2
     *
     * _.toFinite(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toFinite(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toFinite('3.2');
     * // => 3.2
     */ function toFinite(value) {
            if (!value) return value === 0 ? value : 0;
            value = toNumber(value);
            if (value === INFINITY || value === -INFINITY) {
                var sign = value < 0 ? -1 : 1;
                return sign * MAX_INTEGER;
            }
            return value === value ? value : 0;
        }
        /**
     * Converts `value` to an integer.
     *
     * **Note:** This method is loosely based on
     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toInteger(3.2);
     * // => 3
     *
     * _.toInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toInteger(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toInteger('3.2');
     * // => 3
     */ function toInteger(value) {
            var result = toFinite(value), remainder = result % 1;
            return result === result ? remainder ? result - remainder : result : 0;
        }
        /**
     * Converts `value` to an integer suitable for use as the length of an
     * array-like object.
     *
     * **Note:** This method is based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toLength(3.2);
     * // => 3
     *
     * _.toLength(Number.MIN_VALUE);
     * // => 0
     *
     * _.toLength(Infinity);
     * // => 4294967295
     *
     * _.toLength('3.2');
     * // => 3
     */ function toLength(value) {
            return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
        }
        /**
     * Converts `value` to a number.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     * @example
     *
     * _.toNumber(3.2);
     * // => 3.2
     *
     * _.toNumber(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toNumber(Infinity);
     * // => Infinity
     *
     * _.toNumber('3.2');
     * // => 3.2
     */ function toNumber(value) {
            if (typeof value == "number") return value;
            if (isSymbol(value)) return NAN;
            if (isObject(value)) {
                var other = typeof value.valueOf == "function" ? value.valueOf() : value;
                value = isObject(other) ? other + "" : other;
            }
            if (typeof value != "string") return value === 0 ? value : +value;
            value = baseTrim(value);
            var isBinary = reIsBinary.test(value);
            return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
        }
        /**
     * Converts `value` to a plain object flattening inherited enumerable string
     * keyed properties of `value` to own properties of the plain object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Object} Returns the converted plain object.
     * @example
     *
     * function Foo() {
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.assign({ 'a': 1 }, new Foo);
     * // => { 'a': 1, 'b': 2 }
     *
     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
     * // => { 'a': 1, 'b': 2, 'c': 3 }
     */ function toPlainObject(value) {
            return copyObject(value, keysIn(value));
        }
        /**
     * Converts `value` to a safe integer. A safe integer can be compared and
     * represented correctly.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toSafeInteger(3.2);
     * // => 3
     *
     * _.toSafeInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toSafeInteger(Infinity);
     * // => 9007199254740991
     *
     * _.toSafeInteger('3.2');
     * // => 3
     */ function toSafeInteger(value) {
            return value ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER) : value === 0 ? value : 0;
        }
        /**
     * Converts `value` to a string. An empty string is returned for `null`
     * and `undefined` values. The sign of `-0` is preserved.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.toString(null);
     * // => ''
     *
     * _.toString(-0);
     * // => '-0'
     *
     * _.toString([1, 2, 3]);
     * // => '1,2,3'
     */ function toString(value) {
            return value == null ? "" : baseToString(value);
        }
        /*------------------------------------------------------------------------*/ /**
     * Assigns own enumerable string keyed properties of source objects to the
     * destination object. Source objects are applied from left to right.
     * Subsequent sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object` and is loosely based on
     * [`Object.assign`](https://mdn.io/Object/assign).
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assignIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assign({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'c': 3 }
     */ var assign = createAssigner(function(object, source) {
            if (isPrototype(source) || isArrayLike(source)) {
                copyObject(source, keys(source), object);
                return;
            }
            for(var key in source)if (hasOwnProperty.call(source, key)) assignValue(object, key, source[key]);
        });
        /**
     * This method is like `_.assign` except that it iterates over own and
     * inherited source properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extend
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assign
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
     */ var assignIn = createAssigner(function(object, source) {
            copyObject(source, keysIn(source), object);
        });
        /**
     * This method is like `_.assignIn` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extendWith
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignInWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
            copyObject(source, keysIn(source), object, customizer);
        });
        /**
     * This method is like `_.assign` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignInWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
            copyObject(source, keys(source), object, customizer);
        });
        /**
     * Creates an array of values corresponding to `paths` of `object`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Array} Returns the picked values.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _.at(object, ['a[0].b.c', 'a[1]']);
     * // => [3, 4]
     */ var at = flatRest(baseAt);
        /**
     * Creates an object that inherits from the `prototype` object. If a
     * `properties` object is given, its own enumerable string keyed properties
     * are assigned to the created object.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Object
     * @param {Object} prototype The object to inherit from.
     * @param {Object} [properties] The properties to assign to the object.
     * @returns {Object} Returns the new object.
     * @example
     *
     * function Shape() {
     *   this.x = 0;
     *   this.y = 0;
     * }
     *
     * function Circle() {
     *   Shape.call(this);
     * }
     *
     * Circle.prototype = _.create(Shape.prototype, {
     *   'constructor': Circle
     * });
     *
     * var circle = new Circle;
     * circle instanceof Circle;
     * // => true
     *
     * circle instanceof Shape;
     * // => true
     */ function create(prototype, properties) {
            var result = baseCreate(prototype);
            return properties == null ? result : baseAssign(result, properties);
        }
        /**
     * Assigns own and inherited enumerable string keyed properties of source
     * objects to the destination object for all destination properties that
     * resolve to `undefined`. Source objects are applied from left to right.
     * Once a property is set, additional values of the same property are ignored.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaultsDeep
     * @example
     *
     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var defaults = baseRest(function(object, sources) {
            object = Object1(object);
            var index = -1;
            var length = sources.length;
            var guard = length > 2 ? sources[2] : undefined;
            if (guard && isIterateeCall(sources[0], sources[1], guard)) length = 1;
            while(++index < length){
                var source = sources[index];
                var props = keysIn(source);
                var propsIndex = -1;
                var propsLength = props.length;
                while(++propsIndex < propsLength){
                    var key = props[propsIndex];
                    var value = object[key];
                    if (value === undefined || eq(value, objectProto[key]) && !hasOwnProperty.call(object, key)) object[key] = source[key];
                }
            }
            return object;
        });
        /**
     * This method is like `_.defaults` except that it recursively assigns
     * default properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaults
     * @example
     *
     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
     * // => { 'a': { 'b': 2, 'c': 3 } }
     */ var defaultsDeep = baseRest(function(args) {
            args.push(undefined, customDefaultsMerge);
            return apply(mergeWith, undefined, args);
        });
        /**
     * This method is like `_.find` except that it returns the key of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findKey(users, function(o) { return o.age < 40; });
     * // => 'barney' (iteration order is not guaranteed)
     *
     * // The `_.matches` iteratee shorthand.
     * _.findKey(users, { 'age': 1, 'active': true });
     * // => 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findKey(users, 'active');
     * // => 'barney'
     */ function findKey(object, predicate) {
            return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
        }
        /**
     * This method is like `_.findKey` except that it iterates over elements of
     * a collection in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findLastKey(users, function(o) { return o.age < 40; });
     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastKey(users, { 'age': 36, 'active': true });
     * // => 'barney'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastKey(users, 'active');
     * // => 'pebbles'
     */ function findLastKey(object, predicate) {
            return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
        }
        /**
     * Iterates over own and inherited enumerable string keyed properties of an
     * object and invokes `iteratee` for each property. The iteratee is invoked
     * with three arguments: (value, key, object). Iteratee functions may exit
     * iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forInRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forIn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
     */ function forIn(object, iteratee) {
            return object == null ? object : baseFor(object, getIteratee(iteratee, 3), keysIn);
        }
        /**
     * This method is like `_.forIn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forInRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
     */ function forInRight(object, iteratee) {
            return object == null ? object : baseForRight(object, getIteratee(iteratee, 3), keysIn);
        }
        /**
     * Iterates over own enumerable string keyed properties of an object and
     * invokes `iteratee` for each property. The iteratee is invoked with three
     * arguments: (value, key, object). Iteratee functions may exit iteration
     * early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwnRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */ function forOwn(object, iteratee) {
            return object && baseForOwn(object, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.forOwn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwnRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
     */ function forOwnRight(object, iteratee) {
            return object && baseForOwnRight(object, getIteratee(iteratee, 3));
        }
        /**
     * Creates an array of function property names from own enumerable properties
     * of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functionsIn
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functions(new Foo);
     * // => ['a', 'b']
     */ function functions(object) {
            return object == null ? [] : baseFunctions(object, keys(object));
        }
        /**
     * Creates an array of function property names from own and inherited
     * enumerable properties of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functions
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functionsIn(new Foo);
     * // => ['a', 'b', 'c']
     */ function functionsIn(object) {
            return object == null ? [] : baseFunctions(object, keysIn(object));
        }
        /**
     * Gets the value at `path` of `object`. If the resolved value is
     * `undefined`, the `defaultValue` is returned in its place.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.get(object, 'a[0].b.c');
     * // => 3
     *
     * _.get(object, ['a', '0', 'b', 'c']);
     * // => 3
     *
     * _.get(object, 'a.b.c', 'default');
     * // => 'default'
     */ function get(object, path, defaultValue) {
            var result = object == null ? undefined : baseGet(object, path);
            return result === undefined ? defaultValue : result;
        }
        /**
     * Checks if `path` is a direct property of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = { 'a': { 'b': 2 } };
     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.has(object, 'a');
     * // => true
     *
     * _.has(object, 'a.b');
     * // => true
     *
     * _.has(object, ['a', 'b']);
     * // => true
     *
     * _.has(other, 'a');
     * // => false
     */ function has(object, path) {
            return object != null && hasPath(object, path, baseHas);
        }
        /**
     * Checks if `path` is a direct or inherited property of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.hasIn(object, 'a');
     * // => true
     *
     * _.hasIn(object, 'a.b');
     * // => true
     *
     * _.hasIn(object, ['a', 'b']);
     * // => true
     *
     * _.hasIn(object, 'b');
     * // => false
     */ function hasIn(object, path) {
            return object != null && hasPath(object, path, baseHasIn);
        }
        /**
     * Creates an object composed of the inverted keys and values of `object`.
     * If `object` contains duplicate values, subsequent values overwrite
     * property assignments of previous values.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Object
     * @param {Object} object The object to invert.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invert(object);
     * // => { '1': 'c', '2': 'b' }
     */ var invert = createInverter(function(result, value, key) {
            if (value != null && typeof value.toString != "function") value = nativeObjectToString.call(value);
            result[value] = key;
        }, constant(identity));
        /**
     * This method is like `_.invert` except that the inverted object is generated
     * from the results of running each element of `object` thru `iteratee`. The
     * corresponding inverted value of each inverted key is an array of keys
     * responsible for generating the inverted value. The iteratee is invoked
     * with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Object
     * @param {Object} object The object to invert.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invertBy(object);
     * // => { '1': ['a', 'c'], '2': ['b'] }
     *
     * _.invertBy(object, function(value) {
     *   return 'group' + value;
     * });
     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
     */ var invertBy = createInverter(function(result, value, key) {
            if (value != null && typeof value.toString != "function") value = nativeObjectToString.call(value);
            if (hasOwnProperty.call(result, value)) result[value].push(key);
            else result[value] = [
                key
            ];
        }, getIteratee);
        /**
     * Invokes the method at `path` of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
     *
     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
     * // => [2, 3]
     */ var invoke = baseRest(baseInvoke);
        /**
     * Creates an array of the own enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects. See the
     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * for more details.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keys(new Foo);
     * // => ['a', 'b'] (iteration order is not guaranteed)
     *
     * _.keys('hi');
     * // => ['0', '1']
     */ function keys(object) {
            return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
        }
        /**
     * Creates an array of the own and inherited enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keysIn(new Foo);
     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
     */ function keysIn(object) {
            return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
        }
        /**
     * The opposite of `_.mapValues`; this method creates an object with the
     * same values as `object` and keys generated by running each own enumerable
     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
     * with three arguments: (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapValues
     * @example
     *
     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
     *   return key + value;
     * });
     * // => { 'a1': 1, 'b2': 2 }
     */ function mapKeys(object, iteratee) {
            var result = {};
            iteratee = getIteratee(iteratee, 3);
            baseForOwn(object, function(value, key, object) {
                baseAssignValue(result, iteratee(value, key, object), value);
            });
            return result;
        }
        /**
     * Creates an object with the same keys as `object` and values generated
     * by running each own enumerable string keyed property of `object` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapKeys
     * @example
     *
     * var users = {
     *   'fred':    { 'user': 'fred',    'age': 40 },
     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
     * };
     *
     * _.mapValues(users, function(o) { return o.age; });
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     *
     * // The `_.property` iteratee shorthand.
     * _.mapValues(users, 'age');
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     */ function mapValues(object, iteratee) {
            var result = {};
            iteratee = getIteratee(iteratee, 3);
            baseForOwn(object, function(value, key, object) {
                baseAssignValue(result, key, iteratee(value, key, object));
            });
            return result;
        }
        /**
     * This method is like `_.assign` except that it recursively merges own and
     * inherited enumerable string keyed properties of source objects into the
     * destination object. Source properties that resolve to `undefined` are
     * skipped if a destination value exists. Array and plain object properties
     * are merged recursively. Other objects and value types are overridden by
     * assignment. Source objects are applied from left to right. Subsequent
     * sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {
     *   'a': [{ 'b': 2 }, { 'd': 4 }]
     * };
     *
     * var other = {
     *   'a': [{ 'c': 3 }, { 'e': 5 }]
     * };
     *
     * _.merge(object, other);
     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
     */ var merge = createAssigner(function(object, source, srcIndex) {
            baseMerge(object, source, srcIndex);
        });
        /**
     * This method is like `_.merge` except that it accepts `customizer` which
     * is invoked to produce the merged values of the destination and source
     * properties. If `customizer` returns `undefined`, merging is handled by the
     * method instead. The `customizer` is invoked with six arguments:
     * (objValue, srcValue, key, object, source, stack).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} customizer The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   if (_.isArray(objValue)) {
     *     return objValue.concat(srcValue);
     *   }
     * }
     *
     * var object = { 'a': [1], 'b': [2] };
     * var other = { 'a': [3], 'b': [4] };
     *
     * _.mergeWith(object, other, customizer);
     * // => { 'a': [1, 3], 'b': [2, 4] }
     */ var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
            baseMerge(object, source, srcIndex, customizer);
        });
        /**
     * The opposite of `_.pick`; this method creates an object composed of the
     * own and inherited enumerable property paths of `object` that are not omitted.
     *
     * **Note:** This method is considerably slower than `_.pick`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to omit.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omit(object, ['a', 'c']);
     * // => { 'b': '2' }
     */ var omit = flatRest(function(object, paths) {
            var result = {};
            if (object == null) return result;
            var isDeep = false;
            paths = arrayMap(paths, function(path) {
                path = castPath(path, object);
                isDeep || (isDeep = path.length > 1);
                return path;
            });
            copyObject(object, getAllKeysIn(object), result);
            if (isDeep) result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
            var length = paths.length;
            while(length--)baseUnset(result, paths[length]);
            return result;
        });
        /**
     * The opposite of `_.pickBy`; this method creates an object composed of
     * the own and inherited enumerable string keyed properties of `object` that
     * `predicate` doesn't return truthy for. The predicate is invoked with two
     * arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omitBy(object, _.isNumber);
     * // => { 'b': '2' }
     */ function omitBy(object, predicate) {
            return pickBy(object, negate(getIteratee(predicate)));
        }
        /**
     * Creates an object composed of the picked `object` properties.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pick(object, ['a', 'c']);
     * // => { 'a': 1, 'c': 3 }
     */ var pick = flatRest(function(object, paths) {
            return object == null ? {} : basePick(object, paths);
        });
        /**
     * Creates an object composed of the `object` properties `predicate` returns
     * truthy for. The predicate is invoked with two arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pickBy(object, _.isNumber);
     * // => { 'a': 1, 'c': 3 }
     */ function pickBy(object, predicate) {
            if (object == null) return {};
            var props = arrayMap(getAllKeysIn(object), function(prop) {
                return [
                    prop
                ];
            });
            predicate = getIteratee(predicate);
            return basePickBy(object, props, function(value, path) {
                return predicate(value, path[0]);
            });
        }
        /**
     * This method is like `_.get` except that if the resolved value is a
     * function it's invoked with the `this` binding of its parent object and
     * its result is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to resolve.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
     *
     * _.result(object, 'a[0].b.c1');
     * // => 3
     *
     * _.result(object, 'a[0].b.c2');
     * // => 4
     *
     * _.result(object, 'a[0].b.c3', 'default');
     * // => 'default'
     *
     * _.result(object, 'a[0].b.c3', _.constant('default'));
     * // => 'default'
     */ function result(object, path, defaultValue) {
            path = castPath(path, object);
            var index = -1, length = path.length;
            // Ensure the loop is entered when path is empty.
            if (!length) {
                length = 1;
                object = undefined;
            }
            while(++index < length){
                var value = object == null ? undefined : object[toKey(path[index])];
                if (value === undefined) {
                    index = length;
                    value = defaultValue;
                }
                object = isFunction(value) ? value.call(object) : value;
            }
            return object;
        }
        /**
     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
     * it's created. Arrays are created for missing index properties while objects
     * are created for all other missing properties. Use `_.setWith` to customize
     * `path` creation.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.set(object, 'a[0].b.c', 4);
     * console.log(object.a[0].b.c);
     * // => 4
     *
     * _.set(object, ['x', '0', 'y', 'z'], 5);
     * console.log(object.x[0].y.z);
     * // => 5
     */ function set(object, path, value) {
            return object == null ? object : baseSet(object, path, value);
        }
        /**
     * This method is like `_.set` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.setWith(object, '[0][1]', 'a', Object);
     * // => { '0': { '1': 'a' } }
     */ function setWith(object, path, value, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined;
            return object == null ? object : baseSet(object, path, value, customizer);
        }
        /**
     * Creates an array of own enumerable string keyed-value pairs for `object`
     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
     * entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entries
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairs(new Foo);
     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
     */ var toPairs = createToPairs(keys);
        /**
     * Creates an array of own and inherited enumerable string keyed-value pairs
     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
     * or set, its entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entriesIn
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairsIn(new Foo);
     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
     */ var toPairsIn = createToPairs(keysIn);
        /**
     * An alternative to `_.reduce`; this method transforms `object` to a new
     * `accumulator` object which is the result of running each of its own
     * enumerable string keyed properties thru `iteratee`, with each invocation
     * potentially mutating the `accumulator` object. If `accumulator` is not
     * provided, a new object with the same `[[Prototype]]` will be used. The
     * iteratee is invoked with four arguments: (accumulator, value, key, object).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The custom accumulator value.
     * @returns {*} Returns the accumulated value.
     * @example
     *
     * _.transform([2, 3, 4], function(result, n) {
     *   result.push(n *= n);
     *   return n % 2 == 0;
     * }, []);
     * // => [4, 9]
     *
     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] }
     */ function transform(object, iteratee, accumulator) {
            var isArr = isArray(object), isArrLike = isArr || isBuffer(object) || isTypedArray(object);
            iteratee = getIteratee(iteratee, 4);
            if (accumulator == null) {
                var Ctor = object && object.constructor;
                if (isArrLike) accumulator = isArr ? new Ctor : [];
                else if (isObject(object)) accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
                else accumulator = {};
            }
            (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
                return iteratee(accumulator, value, index, object);
            });
            return accumulator;
        }
        /**
     * Removes the property at `path` of `object`.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
     * _.unset(object, 'a[0].b.c');
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     *
     * _.unset(object, ['a', '0', 'b', 'c']);
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     */ function unset(object, path) {
            return object == null ? true : baseUnset(object, path);
        }
        /**
     * This method is like `_.set` except that accepts `updater` to produce the
     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
     * is invoked with one argument: (value).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
     * console.log(object.a[0].b.c);
     * // => 9
     *
     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
     * console.log(object.x[0].y.z);
     * // => 0
     */ function update(object, path, updater) {
            return object == null ? object : baseUpdate(object, path, castFunction(updater));
        }
        /**
     * This method is like `_.update` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
     * // => { '0': { '1': 'a' } }
     */ function updateWith(object, path, updater, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined;
            return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
        }
        /**
     * Creates an array of the own enumerable string keyed property values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.values(new Foo);
     * // => [1, 2] (iteration order is not guaranteed)
     *
     * _.values('hi');
     * // => ['h', 'i']
     */ function values(object) {
            return object == null ? [] : baseValues(object, keys(object));
        }
        /**
     * Creates an array of the own and inherited enumerable string keyed property
     * values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.valuesIn(new Foo);
     * // => [1, 2, 3] (iteration order is not guaranteed)
     */ function valuesIn(object) {
            return object == null ? [] : baseValues(object, keysIn(object));
        }
        /*------------------------------------------------------------------------*/ /**
     * Clamps `number` within the inclusive `lower` and `upper` bounds.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Number
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     * @example
     *
     * _.clamp(-10, -5, 5);
     * // => -5
     *
     * _.clamp(10, -5, 5);
     * // => 5
     */ function clamp(number, lower, upper) {
            if (upper === undefined) {
                upper = lower;
                lower = undefined;
            }
            if (upper !== undefined) {
                upper = toNumber(upper);
                upper = upper === upper ? upper : 0;
            }
            if (lower !== undefined) {
                lower = toNumber(lower);
                lower = lower === lower ? lower : 0;
            }
            return baseClamp(toNumber(number), lower, upper);
        }
        /**
     * Checks if `n` is between `start` and up to, but not including, `end`. If
     * `end` is not specified, it's set to `start` with `start` then set to `0`.
     * If `start` is greater than `end` the params are swapped to support
     * negative ranges.
     *
     * @static
     * @memberOf _
     * @since 3.3.0
     * @category Number
     * @param {number} number The number to check.
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     * @see _.range, _.rangeRight
     * @example
     *
     * _.inRange(3, 2, 4);
     * // => true
     *
     * _.inRange(4, 8);
     * // => true
     *
     * _.inRange(4, 2);
     * // => false
     *
     * _.inRange(2, 2);
     * // => false
     *
     * _.inRange(1.2, 2);
     * // => true
     *
     * _.inRange(5.2, 4);
     * // => false
     *
     * _.inRange(-3, -2, -6);
     * // => true
     */ function inRange(number, start, end) {
            start = toFinite(start);
            if (end === undefined) {
                end = start;
                start = 0;
            } else end = toFinite(end);
            number = toNumber(number);
            return baseInRange(number, start, end);
        }
        /**
     * Produces a random number between the inclusive `lower` and `upper` bounds.
     * If only one argument is provided a number between `0` and the given number
     * is returned. If `floating` is `true`, or either `lower` or `upper` are
     * floats, a floating-point number is returned instead of an integer.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Number
     * @param {number} [lower=0] The lower bound.
     * @param {number} [upper=1] The upper bound.
     * @param {boolean} [floating] Specify returning a floating-point number.
     * @returns {number} Returns the random number.
     * @example
     *
     * _.random(0, 5);
     * // => an integer between 0 and 5
     *
     * _.random(5);
     * // => also an integer between 0 and 5
     *
     * _.random(5, true);
     * // => a floating-point number between 0 and 5
     *
     * _.random(1.2, 5.2);
     * // => a floating-point number between 1.2 and 5.2
     */ function random(lower, upper, floating) {
            if (floating && typeof floating != "boolean" && isIterateeCall(lower, upper, floating)) upper = floating = undefined;
            if (floating === undefined) {
                if (typeof upper == "boolean") {
                    floating = upper;
                    upper = undefined;
                } else if (typeof lower == "boolean") {
                    floating = lower;
                    lower = undefined;
                }
            }
            if (lower === undefined && upper === undefined) {
                lower = 0;
                upper = 1;
            } else {
                lower = toFinite(lower);
                if (upper === undefined) {
                    upper = lower;
                    lower = 0;
                } else upper = toFinite(upper);
            }
            if (lower > upper) {
                var temp = lower;
                lower = upper;
                upper = temp;
            }
            if (floating || lower % 1 || upper % 1) {
                var rand = nativeRandom();
                return nativeMin(lower + rand * (upper - lower + freeParseFloat("1e-" + ((rand + "").length - 1))), upper);
            }
            return baseRandom(lower, upper);
        }
        /*------------------------------------------------------------------------*/ /**
     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the camel cased string.
     * @example
     *
     * _.camelCase('Foo Bar');
     * // => 'fooBar'
     *
     * _.camelCase('--foo-bar--');
     * // => 'fooBar'
     *
     * _.camelCase('__FOO_BAR__');
     * // => 'fooBar'
     */ var camelCase = createCompounder(function(result, word, index) {
            word = word.toLowerCase();
            return result + (index ? capitalize(word) : word);
        });
        /**
     * Converts the first character of `string` to upper case and the remaining
     * to lower case.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to capitalize.
     * @returns {string} Returns the capitalized string.
     * @example
     *
     * _.capitalize('FRED');
     * // => 'Fred'
     */ function capitalize(string) {
            return upperFirst(toString(string).toLowerCase());
        }
        /**
     * Deburrs `string` by converting
     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
     * letters to basic Latin letters and removing
     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to deburr.
     * @returns {string} Returns the deburred string.
     * @example
     *
     * _.deburr('déjà vu');
     * // => 'deja vu'
     */ function deburr(string) {
            string = toString(string);
            return string && string.replace(reLatin, deburrLetter).replace(reComboMark, "");
        }
        /**
     * Checks if `string` ends with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=string.length] The position to search up to.
     * @returns {boolean} Returns `true` if `string` ends with `target`,
     *  else `false`.
     * @example
     *
     * _.endsWith('abc', 'c');
     * // => true
     *
     * _.endsWith('abc', 'b');
     * // => false
     *
     * _.endsWith('abc', 'b', 2);
     * // => true
     */ function endsWith(string, target, position) {
            string = toString(string);
            target = baseToString(target);
            var length = string.length;
            position = position === undefined ? length : baseClamp(toInteger(position), 0, length);
            var end = position;
            position -= target.length;
            return position >= 0 && string.slice(position, end) == target;
        }
        /**
     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
     * corresponding HTML entities.
     *
     * **Note:** No other characters are escaped. To escape additional
     * characters use a third-party library like [_he_](https://mths.be/he).
     *
     * Though the ">" character is escaped for symmetry, characters like
     * ">" and "/" don't need escaping in HTML and have no special meaning
     * unless they're part of a tag or unquoted attribute value. See
     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
     * (under "semi-related fun fact") for more details.
     *
     * When working with HTML you should always
     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
     * XSS vectors.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escape('fred, barney, & pebbles');
     * // => 'fred, barney, &amp; pebbles'
     */ function escape(string) {
            string = toString(string);
            return string && reHasUnescapedHtml.test(string) ? string.replace(reUnescapedHtml, escapeHtmlChar) : string;
        }
        /**
     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escapeRegExp('[lodash](https://lodash.com/)');
     * // => '\[lodash\]\(https://lodash\.com/\)'
     */ function escapeRegExp(string) {
            string = toString(string);
            return string && reHasRegExpChar.test(string) ? string.replace(reRegExpChar, "\\$&") : string;
        }
        /**
     * Converts `string` to
     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the kebab cased string.
     * @example
     *
     * _.kebabCase('Foo Bar');
     * // => 'foo-bar'
     *
     * _.kebabCase('fooBar');
     * // => 'foo-bar'
     *
     * _.kebabCase('__FOO_BAR__');
     * // => 'foo-bar'
     */ var kebabCase = createCompounder(function(result, word, index) {
            return result + (index ? "-" : "") + word.toLowerCase();
        });
        /**
     * Converts `string`, as space separated words, to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.lowerCase('--Foo-Bar--');
     * // => 'foo bar'
     *
     * _.lowerCase('fooBar');
     * // => 'foo bar'
     *
     * _.lowerCase('__FOO_BAR__');
     * // => 'foo bar'
     */ var lowerCase = createCompounder(function(result, word, index) {
            return result + (index ? " " : "") + word.toLowerCase();
        });
        /**
     * Converts the first character of `string` to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.lowerFirst('Fred');
     * // => 'fred'
     *
     * _.lowerFirst('FRED');
     * // => 'fRED'
     */ var lowerFirst = createCaseFirst("toLowerCase");
        /**
     * Pads `string` on the left and right sides if it's shorter than `length`.
     * Padding characters are truncated if they can't be evenly divided by `length`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.pad('abc', 8);
     * // => '  abc   '
     *
     * _.pad('abc', 8, '_-');
     * // => '_-abc_-_'
     *
     * _.pad('abc', 3);
     * // => 'abc'
     */ function pad(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            if (!length || strLength >= length) return string;
            var mid = (length - strLength) / 2;
            return createPadding(nativeFloor(mid), chars) + string + createPadding(nativeCeil(mid), chars);
        }
        /**
     * Pads `string` on the right side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padEnd('abc', 6);
     * // => 'abc   '
     *
     * _.padEnd('abc', 6, '_-');
     * // => 'abc_-_'
     *
     * _.padEnd('abc', 3);
     * // => 'abc'
     */ function padEnd(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            return length && strLength < length ? string + createPadding(length - strLength, chars) : string;
        }
        /**
     * Pads `string` on the left side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padStart('abc', 6);
     * // => '   abc'
     *
     * _.padStart('abc', 6, '_-');
     * // => '_-_abc'
     *
     * _.padStart('abc', 3);
     * // => 'abc'
     */ function padStart(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            return length && strLength < length ? createPadding(length - strLength, chars) + string : string;
        }
        /**
     * Converts `string` to an integer of the specified radix. If `radix` is
     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
     * hexadecimal, in which case a `radix` of `16` is used.
     *
     * **Note:** This method aligns with the
     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category String
     * @param {string} string The string to convert.
     * @param {number} [radix=10] The radix to interpret `value` by.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.parseInt('08');
     * // => 8
     *
     * _.map(['6', '08', '10'], _.parseInt);
     * // => [6, 8, 10]
     */ function parseInt1(string, radix, guard) {
            if (guard || radix == null) radix = 0;
            else if (radix) radix = +radix;
            return nativeParseInt(toString(string).replace(reTrimStart, ""), radix || 0);
        }
        /**
     * Repeats the given string `n` times.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to repeat.
     * @param {number} [n=1] The number of times to repeat the string.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the repeated string.
     * @example
     *
     * _.repeat('*', 3);
     * // => '***'
     *
     * _.repeat('abc', 2);
     * // => 'abcabc'
     *
     * _.repeat('abc', 0);
     * // => ''
     */ function repeat(string, n, guard) {
            if (guard ? isIterateeCall(string, n, guard) : n === undefined) n = 1;
            else n = toInteger(n);
            return baseRepeat(toString(string), n);
        }
        /**
     * Replaces matches for `pattern` in `string` with `replacement`.
     *
     * **Note:** This method is based on
     * [`String#replace`](https://mdn.io/String/replace).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to modify.
     * @param {RegExp|string} pattern The pattern to replace.
     * @param {Function|string} replacement The match replacement.
     * @returns {string} Returns the modified string.
     * @example
     *
     * _.replace('Hi Fred', 'Fred', 'Barney');
     * // => 'Hi Barney'
     */ function replace() {
            var args = arguments, string = toString(args[0]);
            return args.length < 3 ? string : string.replace(args[1], args[2]);
        }
        /**
     * Converts `string` to
     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the snake cased string.
     * @example
     *
     * _.snakeCase('Foo Bar');
     * // => 'foo_bar'
     *
     * _.snakeCase('fooBar');
     * // => 'foo_bar'
     *
     * _.snakeCase('--FOO-BAR--');
     * // => 'foo_bar'
     */ var snakeCase = createCompounder(function(result, word, index) {
            return result + (index ? "_" : "") + word.toLowerCase();
        });
        /**
     * Splits `string` by `separator`.
     *
     * **Note:** This method is based on
     * [`String#split`](https://mdn.io/String/split).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to split.
     * @param {RegExp|string} separator The separator pattern to split by.
     * @param {number} [limit] The length to truncate results to.
     * @returns {Array} Returns the string segments.
     * @example
     *
     * _.split('a-b-c', '-', 2);
     * // => ['a', 'b']
     */ function split(string, separator, limit) {
            if (limit && typeof limit != "number" && isIterateeCall(string, separator, limit)) separator = limit = undefined;
            limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
            if (!limit) return [];
            string = toString(string);
            if (string && (typeof separator == "string" || separator != null && !isRegExp(separator))) {
                separator = baseToString(separator);
                if (!separator && hasUnicode(string)) return castSlice(stringToArray(string), 0, limit);
            }
            return string.split(separator, limit);
        }
        /**
     * Converts `string` to
     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
     *
     * @static
     * @memberOf _
     * @since 3.1.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the start cased string.
     * @example
     *
     * _.startCase('--foo-bar--');
     * // => 'Foo Bar'
     *
     * _.startCase('fooBar');
     * // => 'Foo Bar'
     *
     * _.startCase('__FOO_BAR__');
     * // => 'FOO BAR'
     */ var startCase = createCompounder(function(result, word, index) {
            return result + (index ? " " : "") + upperFirst(word);
        });
        /**
     * Checks if `string` starts with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=0] The position to search from.
     * @returns {boolean} Returns `true` if `string` starts with `target`,
     *  else `false`.
     * @example
     *
     * _.startsWith('abc', 'a');
     * // => true
     *
     * _.startsWith('abc', 'b');
     * // => false
     *
     * _.startsWith('abc', 'b', 1);
     * // => true
     */ function startsWith(string, target, position) {
            string = toString(string);
            position = position == null ? 0 : baseClamp(toInteger(position), 0, string.length);
            target = baseToString(target);
            return string.slice(position, position + target.length) == target;
        }
        /**
     * Creates a compiled template function that can interpolate data properties
     * in "interpolate" delimiters, HTML-escape interpolated data properties in
     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
     * properties may be accessed as free variables in the template. If a setting
     * object is given, it takes precedence over `_.templateSettings` values.
     *
     * **Note:** In the development build `_.template` utilizes
     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
     * for easier debugging.
     *
     * For more information on precompiling templates see
     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
     *
     * For more information on Chrome extension sandboxes see
     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The template string.
     * @param {Object} [options={}] The options object.
     * @param {RegExp} [options.escape=_.templateSettings.escape]
     *  The HTML "escape" delimiter.
     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
     *  The "evaluate" delimiter.
     * @param {Object} [options.imports=_.templateSettings.imports]
     *  An object to import into the template as free variables.
     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
     *  The "interpolate" delimiter.
     * @param {string} [options.sourceURL='lodash.templateSources[n]']
     *  The sourceURL of the compiled template.
     * @param {string} [options.variable='obj']
     *  The data object variable name.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the compiled template function.
     * @example
     *
     * // Use the "interpolate" delimiter to create a compiled template.
     * var compiled = _.template('hello <%= user %>!');
     * compiled({ 'user': 'fred' });
     * // => 'hello fred!'
     *
     * // Use the HTML "escape" delimiter to escape data property values.
     * var compiled = _.template('<b><%- value %></b>');
     * compiled({ 'value': '<script>' });
     * // => '<b>&lt;script&gt;</b>'
     *
     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the internal `print` function in "evaluate" delimiters.
     * var compiled = _.template('<% print("hello " + user); %>!');
     * compiled({ 'user': 'barney' });
     * // => 'hello barney!'
     *
     * // Use the ES template literal delimiter as an "interpolate" delimiter.
     * // Disable support by replacing the "interpolate" delimiter.
     * var compiled = _.template('hello ${ user }!');
     * compiled({ 'user': 'pebbles' });
     * // => 'hello pebbles!'
     *
     * // Use backslashes to treat delimiters as plain text.
     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
     * compiled({ 'value': 'ignored' });
     * // => '<%- value %>'
     *
     * // Use the `imports` option to import `jQuery` as `jq`.
     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
     * compiled(data);
     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
     *
     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
     * compiled.source;
     * // => function(data) {
     * //   var __t, __p = '';
     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
     * //   return __p;
     * // }
     *
     * // Use custom template delimiters.
     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
     * var compiled = _.template('hello {{ user }}!');
     * compiled({ 'user': 'mustache' });
     * // => 'hello mustache!'
     *
     * // Use the `source` property to inline compiled templates for meaningful
     * // line numbers in error messages and stack traces.
     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
     *   var JST = {\
     *     "main": ' + _.template(mainText).source + '\
     *   };\
     * ');
     */ function template(string, options, guard) {
            // Based on John Resig's `tmpl` implementation
            // (http://ejohn.org/blog/javascript-micro-templating/)
            // and Laura Doktorova's doT.js (https://github.com/olado/doT).
            var settings = lodash.templateSettings;
            if (guard && isIterateeCall(string, options, guard)) options = undefined;
            string = toString(string);
            options = assignInWith({}, options, settings, customDefaultsAssignIn);
            var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn), importsKeys = keys(imports), importsValues = baseValues(imports, importsKeys);
            var isEscaping, isEvaluating, index = 0, interpolate = options.interpolate || reNoMatch, source = "__p += '";
            // Compile the regexp to match each delimiter.
            var reDelimiters = RegExp1((options.escape || reNoMatch).source + "|" + interpolate.source + "|" + (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + "|" + (options.evaluate || reNoMatch).source + "|$", "g");
            // Use a sourceURL for easier debugging.
            // The sourceURL gets injected into the source that's eval-ed, so be careful
            // to normalize all kinds of whitespace, so e.g. newlines (and unicode versions of it) can't sneak in
            // and escape the comment, thus injecting code that gets evaled.
            var sourceURL = "//# sourceURL=" + (hasOwnProperty.call(options, "sourceURL") ? (options.sourceURL + "").replace(/\s/g, " ") : "lodash.templateSources[" + ++templateCounter + "]") + "\n";
            string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
                interpolateValue || (interpolateValue = esTemplateValue);
                // Escape characters that can't be included in string literals.
                source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);
                // Replace delimiters with snippets.
                if (escapeValue) {
                    isEscaping = true;
                    source += "' +\n__e(" + escapeValue + ") +\n'";
                }
                if (evaluateValue) {
                    isEvaluating = true;
                    source += "';\n" + evaluateValue + ";\n__p += '";
                }
                if (interpolateValue) source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
                index = offset + match.length;
                // The JS engine embedded in Adobe products needs `match` returned in
                // order to produce the correct `offset` value.
                return match;
            });
            source += "';\n";
            // If `variable` is not specified wrap a with-statement around the generated
            // code to add the data object to the top of the scope chain.
            var variable = hasOwnProperty.call(options, "variable") && options.variable;
            if (!variable) source = "with (obj) {\n" + source + "\n}\n";
            else if (reForbiddenIdentifierChars.test(variable)) throw new Error(INVALID_TEMPL_VAR_ERROR_TEXT);
            // Cleanup code by stripping empty strings.
            source = (isEvaluating ? source.replace(reEmptyStringLeading, "") : source).replace(reEmptyStringMiddle, "$1").replace(reEmptyStringTrailing, "$1;");
            // Frame code as the function body.
            source = "function(" + (variable || "obj") + ") {\n" + (variable ? "" : "obj || (obj = {});\n") + "var __t, __p = ''" + (isEscaping ? ", __e = _.escape" : "") + (isEvaluating ? ", __j = Array.prototype.join;\nfunction print() { __p += __j.call(arguments, '') }\n" : ";\n") + source + "return __p\n}";
            var result = attempt(function() {
                return Function1(importsKeys, sourceURL + "return " + source).apply(undefined, importsValues);
            });
            // Provide the compiled function's source by its `toString` method or
            // the `source` property as a convenience for inlining compiled templates.
            result.source = source;
            if (isError(result)) throw result;
            return result;
        }
        /**
     * Converts `string`, as a whole, to lower case just like
     * [String#toLowerCase](https://mdn.io/toLowerCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.toLower('--Foo-Bar--');
     * // => '--foo-bar--'
     *
     * _.toLower('fooBar');
     * // => 'foobar'
     *
     * _.toLower('__FOO_BAR__');
     * // => '__foo_bar__'
     */ function toLower(value) {
            return toString(value).toLowerCase();
        }
        /**
     * Converts `string`, as a whole, to upper case just like
     * [String#toUpperCase](https://mdn.io/toUpperCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.toUpper('--foo-bar--');
     * // => '--FOO-BAR--'
     *
     * _.toUpper('fooBar');
     * // => 'FOOBAR'
     *
     * _.toUpper('__foo_bar__');
     * // => '__FOO_BAR__'
     */ function toUpper(value) {
            return toString(value).toUpperCase();
        }
        /**
     * Removes leading and trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trim('  abc  ');
     * // => 'abc'
     *
     * _.trim('-_-abc-_-', '_-');
     * // => 'abc'
     *
     * _.map(['  foo  ', '  bar  '], _.trim);
     * // => ['foo', 'bar']
     */ function trim(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) return baseTrim(string);
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), chrSymbols = stringToArray(chars), start = charsStartIndex(strSymbols, chrSymbols), end = charsEndIndex(strSymbols, chrSymbols) + 1;
            return castSlice(strSymbols, start, end).join("");
        }
        /**
     * Removes trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimEnd('  abc  ');
     * // => '  abc'
     *
     * _.trimEnd('-_-abc-_-', '_-');
     * // => '-_-abc'
     */ function trimEnd(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) return string.slice(0, trimmedEndIndex(string) + 1);
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;
            return castSlice(strSymbols, 0, end).join("");
        }
        /**
     * Removes leading whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimStart('  abc  ');
     * // => 'abc  '
     *
     * _.trimStart('-_-abc-_-', '_-');
     * // => 'abc-_-'
     */ function trimStart(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) return string.replace(reTrimStart, "");
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), start = charsStartIndex(strSymbols, stringToArray(chars));
            return castSlice(strSymbols, start).join("");
        }
        /**
     * Truncates `string` if it's longer than the given maximum string length.
     * The last characters of the truncated string are replaced with the omission
     * string which defaults to "...".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to truncate.
     * @param {Object} [options={}] The options object.
     * @param {number} [options.length=30] The maximum string length.
     * @param {string} [options.omission='...'] The string to indicate text is omitted.
     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
     * @returns {string} Returns the truncated string.
     * @example
     *
     * _.truncate('hi-diddly-ho there, neighborino');
     * // => 'hi-diddly-ho there, neighbo...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': ' '
     * });
     * // => 'hi-diddly-ho there,...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': /,? +/
     * });
     * // => 'hi-diddly-ho there...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'omission': ' [...]'
     * });
     * // => 'hi-diddly-ho there, neig [...]'
     */ function truncate(string, options) {
            var length = DEFAULT_TRUNC_LENGTH, omission = DEFAULT_TRUNC_OMISSION;
            if (isObject(options)) {
                var separator = "separator" in options ? options.separator : separator;
                length = "length" in options ? toInteger(options.length) : length;
                omission = "omission" in options ? baseToString(options.omission) : omission;
            }
            string = toString(string);
            var strLength = string.length;
            if (hasUnicode(string)) {
                var strSymbols = stringToArray(string);
                strLength = strSymbols.length;
            }
            if (length >= strLength) return string;
            var end = length - stringSize(omission);
            if (end < 1) return omission;
            var result = strSymbols ? castSlice(strSymbols, 0, end).join("") : string.slice(0, end);
            if (separator === undefined) return result + omission;
            if (strSymbols) end += result.length - end;
            if (isRegExp(separator)) {
                if (string.slice(end).search(separator)) {
                    var match, substring = result;
                    if (!separator.global) separator = RegExp1(separator.source, toString(reFlags.exec(separator)) + "g");
                    separator.lastIndex = 0;
                    while(match = separator.exec(substring))var newEnd = match.index;
                    result = result.slice(0, newEnd === undefined ? end : newEnd);
                }
            } else if (string.indexOf(baseToString(separator), end) != end) {
                var index = result.lastIndexOf(separator);
                if (index > -1) result = result.slice(0, index);
            }
            return result + omission;
        }
        /**
     * The inverse of `_.escape`; this method converts the HTML entities
     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
     * their corresponding characters.
     *
     * **Note:** No other HTML entities are unescaped. To unescape additional
     * HTML entities use a third-party library like [_he_](https://mths.be/he).
     *
     * @static
     * @memberOf _
     * @since 0.6.0
     * @category String
     * @param {string} [string=''] The string to unescape.
     * @returns {string} Returns the unescaped string.
     * @example
     *
     * _.unescape('fred, barney, &amp; pebbles');
     * // => 'fred, barney, & pebbles'
     */ function unescape(string) {
            string = toString(string);
            return string && reHasEscapedHtml.test(string) ? string.replace(reEscapedHtml, unescapeHtmlChar) : string;
        }
        /**
     * Converts `string`, as space separated words, to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.upperCase('--foo-bar');
     * // => 'FOO BAR'
     *
     * _.upperCase('fooBar');
     * // => 'FOO BAR'
     *
     * _.upperCase('__foo_bar__');
     * // => 'FOO BAR'
     */ var upperCase = createCompounder(function(result, word, index) {
            return result + (index ? " " : "") + word.toUpperCase();
        });
        /**
     * Converts the first character of `string` to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.upperFirst('fred');
     * // => 'Fred'
     *
     * _.upperFirst('FRED');
     * // => 'FRED'
     */ var upperFirst = createCaseFirst("toUpperCase");
        /**
     * Splits `string` into an array of its words.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {RegExp|string} [pattern] The pattern to match words.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the words of `string`.
     * @example
     *
     * _.words('fred, barney, & pebbles');
     * // => ['fred', 'barney', 'pebbles']
     *
     * _.words('fred, barney, & pebbles', /[^, ]+/g);
     * // => ['fred', 'barney', '&', 'pebbles']
     */ function words(string, pattern, guard) {
            string = toString(string);
            pattern = guard ? undefined : pattern;
            if (pattern === undefined) return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
            return string.match(pattern) || [];
        }
        /*------------------------------------------------------------------------*/ /**
     * Attempts to invoke `func`, returning either the result or the caught error
     * object. Any additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Function} func The function to attempt.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {*} Returns the `func` result or error object.
     * @example
     *
     * // Avoid throwing errors for invalid selectors.
     * var elements = _.attempt(function(selector) {
     *   return document.querySelectorAll(selector);
     * }, '>_>');
     *
     * if (_.isError(elements)) {
     *   elements = [];
     * }
     */ var attempt = baseRest(function(func, args) {
            try {
                return apply(func, undefined, args);
            } catch (e) {
                return isError(e) ? e : new Error(e);
            }
        });
        /**
     * Binds methods of an object to the object itself, overwriting the existing
     * method.
     *
     * **Note:** This method doesn't set the "length" property of bound functions.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Object} object The object to bind and assign the bound methods to.
     * @param {...(string|string[])} methodNames The object method names to bind.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var view = {
     *   'label': 'docs',
     *   'click': function() {
     *     console.log('clicked ' + this.label);
     *   }
     * };
     *
     * _.bindAll(view, ['click']);
     * jQuery(element).on('click', view.click);
     * // => Logs 'clicked docs' when clicked.
     */ var bindAll = flatRest(function(object, methodNames) {
            arrayEach(methodNames, function(key) {
                key = toKey(key);
                baseAssignValue(object, key, bind(object[key], object));
            });
            return object;
        });
        /**
     * Creates a function that iterates over `pairs` and invokes the corresponding
     * function of the first predicate to return truthy. The predicate-function
     * pairs are invoked with the `this` binding and arguments of the created
     * function.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Array} pairs The predicate-function pairs.
     * @returns {Function} Returns the new composite function.
     * @example
     *
     * var func = _.cond([
     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
     *   [_.stubTrue,                      _.constant('no match')]
     * ]);
     *
     * func({ 'a': 1, 'b': 2 });
     * // => 'matches A'
     *
     * func({ 'a': 0, 'b': 1 });
     * // => 'matches B'
     *
     * func({ 'a': '1', 'b': '2' });
     * // => 'no match'
     */ function cond(pairs) {
            var length = pairs == null ? 0 : pairs.length, toIteratee = getIteratee();
            pairs = !length ? [] : arrayMap(pairs, function(pair) {
                if (typeof pair[1] != "function") throw new TypeError(FUNC_ERROR_TEXT);
                return [
                    toIteratee(pair[0]),
                    pair[1]
                ];
            });
            return baseRest(function(args) {
                var index = -1;
                while(++index < length){
                    var pair = pairs[index];
                    if (apply(pair[0], this, args)) return apply(pair[1], this, args);
                }
            });
        }
        /**
     * Creates a function that invokes the predicate properties of `source` with
     * the corresponding property values of a given object, returning `true` if
     * all predicates return truthy, else `false`.
     *
     * **Note:** The created function is equivalent to `_.conformsTo` with
     * `source` partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 2, 'b': 1 },
     *   { 'a': 1, 'b': 2 }
     * ];
     *
     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
     * // => [{ 'a': 1, 'b': 2 }]
     */ function conforms(source) {
            return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that returns `value`.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {*} value The value to return from the new function.
     * @returns {Function} Returns the new constant function.
     * @example
     *
     * var objects = _.times(2, _.constant({ 'a': 1 }));
     *
     * console.log(objects);
     * // => [{ 'a': 1 }, { 'a': 1 }]
     *
     * console.log(objects[0] === objects[1]);
     * // => true
     */ function constant(value) {
            return function() {
                return value;
            };
        }
        /**
     * Checks `value` to determine whether a default value should be returned in
     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
     * or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Util
     * @param {*} value The value to check.
     * @param {*} defaultValue The default value.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * _.defaultTo(1, 10);
     * // => 1
     *
     * _.defaultTo(undefined, 10);
     * // => 10
     */ function defaultTo(value, defaultValue) {
            return value == null || value !== value ? defaultValue : value;
        }
        /**
     * Creates a function that returns the result of invoking the given functions
     * with the `this` binding of the created function, where each successive
     * invocation is supplied the return value of the previous.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flowRight
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flow([_.add, square]);
     * addSquare(1, 2);
     * // => 9
     */ var flow = createFlow();
        /**
     * This method is like `_.flow` except that it creates a function that
     * invokes the given functions from right to left.
     *
     * @static
     * @since 3.0.0
     * @memberOf _
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flow
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flowRight([square, _.add]);
     * addSquare(1, 2);
     * // => 9
     */ var flowRight = createFlow(true);
        /**
     * This method returns the first argument it receives.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {*} value Any value.
     * @returns {*} Returns `value`.
     * @example
     *
     * var object = { 'a': 1 };
     *
     * console.log(_.identity(object) === object);
     * // => true
     */ function identity(value) {
            return value;
        }
        /**
     * Creates a function that invokes `func` with the arguments of the created
     * function. If `func` is a property name, the created function returns the
     * property value for a given element. If `func` is an array or object, the
     * created function returns `true` for elements that contain the equivalent
     * source properties, otherwise it returns `false`.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Util
     * @param {*} [func=_.identity] The value to convert to a callback.
     * @returns {Function} Returns the callback.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, _.iteratee(['user', 'fred']));
     * // => [{ 'user': 'fred', 'age': 40 }]
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, _.iteratee('user'));
     * // => ['barney', 'fred']
     *
     * // Create custom iteratee shorthands.
     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
     *     return func.test(string);
     *   };
     * });
     *
     * _.filter(['abc', 'def'], /ef/);
     * // => ['def']
     */ function iteratee(func) {
            return baseIteratee(typeof func == "function" ? func : baseClone(func, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that performs a partial deep comparison between a given
     * object and `source`, returning `true` if the given object has equivalent
     * property values, else `false`.
     *
     * **Note:** The created function is equivalent to `_.isMatch` with `source`
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matches({ 'a': 1 }), _.matches({ 'a': 4 })]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */ function matches(source) {
            return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that performs a partial deep comparison between the
     * value at `path` of a given object to `srcValue`, returning `true` if the
     * object value is equivalent, else `false`.
     *
     * **Note:** Partial comparisons will match empty array and empty object
     * `srcValue` values against any array or object value, respectively. See
     * `_.isEqual` for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.find(objects, _.matchesProperty('a', 4));
     * // => { 'a': 4, 'b': 5, 'c': 6 }
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matchesProperty('a', 1), _.matchesProperty('a', 4)]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */ function matchesProperty(path, srcValue) {
            return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that invokes the method at `path` of a given object.
     * Any additional arguments are provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': _.constant(2) } },
     *   { 'a': { 'b': _.constant(1) } }
     * ];
     *
     * _.map(objects, _.method('a.b'));
     * // => [2, 1]
     *
     * _.map(objects, _.method(['a', 'b']));
     * // => [2, 1]
     */ var method = baseRest(function(path, args) {
            return function(object) {
                return baseInvoke(object, path, args);
            };
        });
        /**
     * The opposite of `_.method`; this method creates a function that invokes
     * the method at a given path of `object`. Any additional arguments are
     * provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Object} object The object to query.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var array = _.times(3, _.constant),
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
     * // => [2, 0]
     */ var methodOf = baseRest(function(object, args) {
            return function(path) {
                return baseInvoke(object, path, args);
            };
        });
        /**
     * Adds all own enumerable string keyed function properties of a source
     * object to the destination object. If `object` is a function, then methods
     * are added to its prototype as well.
     *
     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
     * avoid conflicts caused by modifying the original.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Function|Object} [object=lodash] The destination object.
     * @param {Object} source The object of functions to add.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
     * @returns {Function|Object} Returns `object`.
     * @example
     *
     * function vowels(string) {
     *   return _.filter(string, function(v) {
     *     return /[aeiou]/i.test(v);
     *   });
     * }
     *
     * _.mixin({ 'vowels': vowels });
     * _.vowels('fred');
     * // => ['e']
     *
     * _('fred').vowels().value();
     * // => ['e']
     *
     * _.mixin({ 'vowels': vowels }, { 'chain': false });
     * _('fred').vowels();
     * // => ['e']
     */ function mixin(object, source, options) {
            var props = keys(source), methodNames = baseFunctions(source, props);
            if (options == null && !(isObject(source) && (methodNames.length || !props.length))) {
                options = source;
                source = object;
                object = this;
                methodNames = baseFunctions(source, keys(source));
            }
            var chain = !(isObject(options) && "chain" in options) || !!options.chain, isFunc = isFunction(object);
            arrayEach(methodNames, function(methodName) {
                var func = source[methodName];
                object[methodName] = func;
                if (isFunc) object.prototype[methodName] = function() {
                    var chainAll = this.__chain__;
                    if (chain || chainAll) {
                        var result = object(this.__wrapped__), actions = result.__actions__ = copyArray(this.__actions__);
                        actions.push({
                            "func": func,
                            "args": arguments,
                            "thisArg": object
                        });
                        result.__chain__ = chainAll;
                        return result;
                    }
                    return func.apply(object, arrayPush([
                        this.value()
                    ], arguments));
                };
            });
            return object;
        }
        /**
     * Reverts the `_` variable to its previous value and returns a reference to
     * the `lodash` function.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @returns {Function} Returns the `lodash` function.
     * @example
     *
     * var lodash = _.noConflict();
     */ function noConflict() {
            if (root._ === this) root._ = oldDash;
            return this;
        }
        /**
     * This method returns `undefined`.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Util
     * @example
     *
     * _.times(2, _.noop);
     * // => [undefined, undefined]
     */ function noop() {
        // No operation performed.
        }
        /**
     * Creates a function that gets the argument at index `n`. If `n` is negative,
     * the nth argument from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [n=0] The index of the argument to return.
     * @returns {Function} Returns the new pass-thru function.
     * @example
     *
     * var func = _.nthArg(1);
     * func('a', 'b', 'c', 'd');
     * // => 'b'
     *
     * var func = _.nthArg(-2);
     * func('a', 'b', 'c', 'd');
     * // => 'c'
     */ function nthArg(n) {
            n = toInteger(n);
            return baseRest(function(args) {
                return baseNth(args, n);
            });
        }
        /**
     * Creates a function that invokes `iteratees` with the arguments it receives
     * and returns their results.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to invoke.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.over([Math.max, Math.min]);
     *
     * func(1, 2, 3, 4);
     * // => [4, 1]
     */ var over = createOver(arrayMap);
        /**
     * Creates a function that checks if **all** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overEvery([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => false
     *
     * func(NaN);
     * // => false
     */ var overEvery = createOver(arrayEvery);
        /**
     * Creates a function that checks if **any** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overSome([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => true
     *
     * func(NaN);
     * // => false
     *
     * var matchesFunc = _.overSome([{ 'a': 1 }, { 'a': 2 }])
     * var matchesPropertyFunc = _.overSome([['a', 1], ['a', 2]])
     */ var overSome = createOver(arraySome);
        /**
     * Creates a function that returns the value at `path` of a given object.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': 2 } },
     *   { 'a': { 'b': 1 } }
     * ];
     *
     * _.map(objects, _.property('a.b'));
     * // => [2, 1]
     *
     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
     * // => [1, 2]
     */ function property(path) {
            return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
        }
        /**
     * The opposite of `_.property`; this method creates a function that returns
     * the value at a given path of `object`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} object The object to query.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var array = [0, 1, 2],
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
     * // => [2, 0]
     */ function propertyOf(object) {
            return function(path) {
                return object == null ? undefined : baseGet(object, path);
            };
        }
        /**
     * Creates an array of numbers (positive and/or negative) progressing from
     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
     * `start` is specified without an `end` or `step`. If `end` is not specified,
     * it's set to `start` with `start` then set to `0`.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.rangeRight
     * @example
     *
     * _.range(4);
     * // => [0, 1, 2, 3]
     *
     * _.range(-4);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 5);
     * // => [1, 2, 3, 4]
     *
     * _.range(0, 20, 5);
     * // => [0, 5, 10, 15]
     *
     * _.range(0, -4, -1);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.range(0);
     * // => []
     */ var range = createRange();
        /**
     * This method is like `_.range` except that it populates values in
     * descending order.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.range
     * @example
     *
     * _.rangeRight(4);
     * // => [3, 2, 1, 0]
     *
     * _.rangeRight(-4);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 5);
     * // => [4, 3, 2, 1]
     *
     * _.rangeRight(0, 20, 5);
     * // => [15, 10, 5, 0]
     *
     * _.rangeRight(0, -4, -1);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.rangeRight(0);
     * // => []
     */ var rangeRight = createRange(true);
        /**
     * This method returns a new empty array.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Array} Returns the new empty array.
     * @example
     *
     * var arrays = _.times(2, _.stubArray);
     *
     * console.log(arrays);
     * // => [[], []]
     *
     * console.log(arrays[0] === arrays[1]);
     * // => false
     */ function stubArray() {
            return [];
        }
        /**
     * This method returns `false`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `false`.
     * @example
     *
     * _.times(2, _.stubFalse);
     * // => [false, false]
     */ function stubFalse() {
            return false;
        }
        /**
     * This method returns a new empty object.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Object} Returns the new empty object.
     * @example
     *
     * var objects = _.times(2, _.stubObject);
     *
     * console.log(objects);
     * // => [{}, {}]
     *
     * console.log(objects[0] === objects[1]);
     * // => false
     */ function stubObject() {
            return {};
        }
        /**
     * This method returns an empty string.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {string} Returns the empty string.
     * @example
     *
     * _.times(2, _.stubString);
     * // => ['', '']
     */ function stubString() {
            return "";
        }
        /**
     * This method returns `true`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `true`.
     * @example
     *
     * _.times(2, _.stubTrue);
     * // => [true, true]
     */ function stubTrue() {
            return true;
        }
        /**
     * Invokes the iteratee `n` times, returning an array of the results of
     * each invocation. The iteratee is invoked with one argument; (index).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} n The number of times to invoke `iteratee`.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.times(3, String);
     * // => ['0', '1', '2']
     *
     *  _.times(4, _.constant(0));
     * // => [0, 0, 0, 0]
     */ function times(n, iteratee) {
            n = toInteger(n);
            if (n < 1 || n > MAX_SAFE_INTEGER) return [];
            var index = MAX_ARRAY_LENGTH, length = nativeMin(n, MAX_ARRAY_LENGTH);
            iteratee = getIteratee(iteratee);
            n -= MAX_ARRAY_LENGTH;
            var result = baseTimes(length, iteratee);
            while(++index < n)iteratee(index);
            return result;
        }
        /**
     * Converts `value` to a property path array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {*} value The value to convert.
     * @returns {Array} Returns the new property path array.
     * @example
     *
     * _.toPath('a.b.c');
     * // => ['a', 'b', 'c']
     *
     * _.toPath('a[0].b.c');
     * // => ['a', '0', 'b', 'c']
     */ function toPath(value) {
            if (isArray(value)) return arrayMap(value, toKey);
            return isSymbol(value) ? [
                value
            ] : copyArray(stringToPath(toString(value)));
        }
        /**
     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {string} [prefix=''] The value to prefix the ID with.
     * @returns {string} Returns the unique ID.
     * @example
     *
     * _.uniqueId('contact_');
     * // => 'contact_104'
     *
     * _.uniqueId();
     * // => '105'
     */ function uniqueId(prefix) {
            var id = ++idCounter;
            return toString(prefix) + id;
        }
        /*------------------------------------------------------------------------*/ /**
     * Adds two numbers.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {number} augend The first number in an addition.
     * @param {number} addend The second number in an addition.
     * @returns {number} Returns the total.
     * @example
     *
     * _.add(6, 4);
     * // => 10
     */ var add = createMathOperation(function(augend, addend) {
            return augend + addend;
        }, 0);
        /**
     * Computes `number` rounded up to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round up.
     * @param {number} [precision=0] The precision to round up to.
     * @returns {number} Returns the rounded up number.
     * @example
     *
     * _.ceil(4.006);
     * // => 5
     *
     * _.ceil(6.004, 2);
     * // => 6.01
     *
     * _.ceil(6040, -2);
     * // => 6100
     */ var ceil = createRound("ceil");
        /**
     * Divide two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} dividend The first number in a division.
     * @param {number} divisor The second number in a division.
     * @returns {number} Returns the quotient.
     * @example
     *
     * _.divide(6, 4);
     * // => 1.5
     */ var divide = createMathOperation(function(dividend, divisor) {
            return dividend / divisor;
        }, 1);
        /**
     * Computes `number` rounded down to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round down.
     * @param {number} [precision=0] The precision to round down to.
     * @returns {number} Returns the rounded down number.
     * @example
     *
     * _.floor(4.006);
     * // => 4
     *
     * _.floor(0.046, 2);
     * // => 0.04
     *
     * _.floor(4060, -2);
     * // => 4000
     */ var floor = createRound("floor");
        /**
     * Computes the maximum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * _.max([4, 2, 8, 6]);
     * // => 8
     *
     * _.max([]);
     * // => undefined
     */ function max(array) {
            return array && array.length ? baseExtremum(array, identity, baseGt) : undefined;
        }
        /**
     * This method is like `_.max` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.maxBy(objects, function(o) { return o.n; });
     * // => { 'n': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.maxBy(objects, 'n');
     * // => { 'n': 2 }
     */ function maxBy(array, iteratee) {
            return array && array.length ? baseExtremum(array, getIteratee(iteratee, 2), baseGt) : undefined;
        }
        /**
     * Computes the mean of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the mean.
     * @example
     *
     * _.mean([4, 2, 8, 6]);
     * // => 5
     */ function mean(array) {
            return baseMean(array, identity);
        }
        /**
     * This method is like `_.mean` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be averaged.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the mean.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.meanBy(objects, function(o) { return o.n; });
     * // => 5
     *
     * // The `_.property` iteratee shorthand.
     * _.meanBy(objects, 'n');
     * // => 5
     */ function meanBy(array, iteratee) {
            return baseMean(array, getIteratee(iteratee, 2));
        }
        /**
     * Computes the minimum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * _.min([4, 2, 8, 6]);
     * // => 2
     *
     * _.min([]);
     * // => undefined
     */ function min(array) {
            return array && array.length ? baseExtremum(array, identity, baseLt) : undefined;
        }
        /**
     * This method is like `_.min` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.minBy(objects, function(o) { return o.n; });
     * // => { 'n': 1 }
     *
     * // The `_.property` iteratee shorthand.
     * _.minBy(objects, 'n');
     * // => { 'n': 1 }
     */ function minBy(array, iteratee) {
            return array && array.length ? baseExtremum(array, getIteratee(iteratee, 2), baseLt) : undefined;
        }
        /**
     * Multiply two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} multiplier The first number in a multiplication.
     * @param {number} multiplicand The second number in a multiplication.
     * @returns {number} Returns the product.
     * @example
     *
     * _.multiply(6, 4);
     * // => 24
     */ var multiply = createMathOperation(function(multiplier, multiplicand) {
            return multiplier * multiplicand;
        }, 1);
        /**
     * Computes `number` rounded to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round.
     * @param {number} [precision=0] The precision to round to.
     * @returns {number} Returns the rounded number.
     * @example
     *
     * _.round(4.006);
     * // => 4
     *
     * _.round(4.006, 2);
     * // => 4.01
     *
     * _.round(4060, -2);
     * // => 4100
     */ var round = createRound("round");
        /**
     * Subtract two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {number} minuend The first number in a subtraction.
     * @param {number} subtrahend The second number in a subtraction.
     * @returns {number} Returns the difference.
     * @example
     *
     * _.subtract(6, 4);
     * // => 2
     */ var subtract = createMathOperation(function(minuend, subtrahend) {
            return minuend - subtrahend;
        }, 0);
        /**
     * Computes the sum of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the sum.
     * @example
     *
     * _.sum([4, 2, 8, 6]);
     * // => 20
     */ function sum(array) {
            return array && array.length ? baseSum(array, identity) : 0;
        }
        /**
     * This method is like `_.sum` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be summed.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the sum.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.sumBy(objects, function(o) { return o.n; });
     * // => 20
     *
     * // The `_.property` iteratee shorthand.
     * _.sumBy(objects, 'n');
     * // => 20
     */ function sumBy(array, iteratee) {
            return array && array.length ? baseSum(array, getIteratee(iteratee, 2)) : 0;
        }
        /*------------------------------------------------------------------------*/ // Add methods that return wrapped values in chain sequences.
        lodash.after = after;
        lodash.ary = ary;
        lodash.assign = assign;
        lodash.assignIn = assignIn;
        lodash.assignInWith = assignInWith;
        lodash.assignWith = assignWith;
        lodash.at = at;
        lodash.before = before;
        lodash.bind = bind;
        lodash.bindAll = bindAll;
        lodash.bindKey = bindKey;
        lodash.castArray = castArray;
        lodash.chain = chain;
        lodash.chunk = chunk;
        lodash.compact = compact;
        lodash.concat = concat;
        lodash.cond = cond;
        lodash.conforms = conforms;
        lodash.constant = constant;
        lodash.countBy = countBy;
        lodash.create = create;
        lodash.curry = curry;
        lodash.curryRight = curryRight;
        lodash.debounce = debounce;
        lodash.defaults = defaults;
        lodash.defaultsDeep = defaultsDeep;
        lodash.defer = defer;
        lodash.delay = delay;
        lodash.difference = difference;
        lodash.differenceBy = differenceBy;
        lodash.differenceWith = differenceWith;
        lodash.drop = drop;
        lodash.dropRight = dropRight;
        lodash.dropRightWhile = dropRightWhile;
        lodash.dropWhile = dropWhile;
        lodash.fill = fill;
        lodash.filter = filter;
        lodash.flatMap = flatMap;
        lodash.flatMapDeep = flatMapDeep;
        lodash.flatMapDepth = flatMapDepth;
        lodash.flatten = flatten;
        lodash.flattenDeep = flattenDeep;
        lodash.flattenDepth = flattenDepth;
        lodash.flip = flip;
        lodash.flow = flow;
        lodash.flowRight = flowRight;
        lodash.fromPairs = fromPairs;
        lodash.functions = functions;
        lodash.functionsIn = functionsIn;
        lodash.groupBy = groupBy;
        lodash.initial = initial;
        lodash.intersection = intersection;
        lodash.intersectionBy = intersectionBy;
        lodash.intersectionWith = intersectionWith;
        lodash.invert = invert;
        lodash.invertBy = invertBy;
        lodash.invokeMap = invokeMap;
        lodash.iteratee = iteratee;
        lodash.keyBy = keyBy;
        lodash.keys = keys;
        lodash.keysIn = keysIn;
        lodash.map = map;
        lodash.mapKeys = mapKeys;
        lodash.mapValues = mapValues;
        lodash.matches = matches;
        lodash.matchesProperty = matchesProperty;
        lodash.memoize = memoize;
        lodash.merge = merge;
        lodash.mergeWith = mergeWith;
        lodash.method = method;
        lodash.methodOf = methodOf;
        lodash.mixin = mixin;
        lodash.negate = negate;
        lodash.nthArg = nthArg;
        lodash.omit = omit;
        lodash.omitBy = omitBy;
        lodash.once = once;
        lodash.orderBy = orderBy;
        lodash.over = over;
        lodash.overArgs = overArgs;
        lodash.overEvery = overEvery;
        lodash.overSome = overSome;
        lodash.partial = partial;
        lodash.partialRight = partialRight;
        lodash.partition = partition;
        lodash.pick = pick;
        lodash.pickBy = pickBy;
        lodash.property = property;
        lodash.propertyOf = propertyOf;
        lodash.pull = pull;
        lodash.pullAll = pullAll;
        lodash.pullAllBy = pullAllBy;
        lodash.pullAllWith = pullAllWith;
        lodash.pullAt = pullAt;
        lodash.range = range;
        lodash.rangeRight = rangeRight;
        lodash.rearg = rearg;
        lodash.reject = reject;
        lodash.remove = remove;
        lodash.rest = rest;
        lodash.reverse = reverse;
        lodash.sampleSize = sampleSize;
        lodash.set = set;
        lodash.setWith = setWith;
        lodash.shuffle = shuffle;
        lodash.slice = slice;
        lodash.sortBy = sortBy;
        lodash.sortedUniq = sortedUniq;
        lodash.sortedUniqBy = sortedUniqBy;
        lodash.split = split;
        lodash.spread = spread;
        lodash.tail = tail;
        lodash.take = take;
        lodash.takeRight = takeRight;
        lodash.takeRightWhile = takeRightWhile;
        lodash.takeWhile = takeWhile;
        lodash.tap = tap;
        lodash.throttle = throttle;
        lodash.thru = thru;
        lodash.toArray = toArray;
        lodash.toPairs = toPairs;
        lodash.toPairsIn = toPairsIn;
        lodash.toPath = toPath;
        lodash.toPlainObject = toPlainObject;
        lodash.transform = transform;
        lodash.unary = unary;
        lodash.union = union;
        lodash.unionBy = unionBy;
        lodash.unionWith = unionWith;
        lodash.uniq = uniq;
        lodash.uniqBy = uniqBy;
        lodash.uniqWith = uniqWith;
        lodash.unset = unset;
        lodash.unzip = unzip;
        lodash.unzipWith = unzipWith;
        lodash.update = update;
        lodash.updateWith = updateWith;
        lodash.values = values;
        lodash.valuesIn = valuesIn;
        lodash.without = without;
        lodash.words = words;
        lodash.wrap = wrap;
        lodash.xor = xor;
        lodash.xorBy = xorBy;
        lodash.xorWith = xorWith;
        lodash.zip = zip;
        lodash.zipObject = zipObject;
        lodash.zipObjectDeep = zipObjectDeep;
        lodash.zipWith = zipWith;
        // Add aliases.
        lodash.entries = toPairs;
        lodash.entriesIn = toPairsIn;
        lodash.extend = assignIn;
        lodash.extendWith = assignInWith;
        // Add methods to `lodash.prototype`.
        mixin(lodash, lodash);
        /*------------------------------------------------------------------------*/ // Add methods that return unwrapped values in chain sequences.
        lodash.add = add;
        lodash.attempt = attempt;
        lodash.camelCase = camelCase;
        lodash.capitalize = capitalize;
        lodash.ceil = ceil;
        lodash.clamp = clamp;
        lodash.clone = clone;
        lodash.cloneDeep = cloneDeep;
        lodash.cloneDeepWith = cloneDeepWith;
        lodash.cloneWith = cloneWith;
        lodash.conformsTo = conformsTo;
        lodash.deburr = deburr;
        lodash.defaultTo = defaultTo;
        lodash.divide = divide;
        lodash.endsWith = endsWith;
        lodash.eq = eq;
        lodash.escape = escape;
        lodash.escapeRegExp = escapeRegExp;
        lodash.every = every;
        lodash.find = find;
        lodash.findIndex = findIndex;
        lodash.findKey = findKey;
        lodash.findLast = findLast;
        lodash.findLastIndex = findLastIndex;
        lodash.findLastKey = findLastKey;
        lodash.floor = floor;
        lodash.forEach = forEach;
        lodash.forEachRight = forEachRight;
        lodash.forIn = forIn;
        lodash.forInRight = forInRight;
        lodash.forOwn = forOwn;
        lodash.forOwnRight = forOwnRight;
        lodash.get = get;
        lodash.gt = gt;
        lodash.gte = gte;
        lodash.has = has;
        lodash.hasIn = hasIn;
        lodash.head = head;
        lodash.identity = identity;
        lodash.includes = includes;
        lodash.indexOf = indexOf;
        lodash.inRange = inRange;
        lodash.invoke = invoke;
        lodash.isArguments = isArguments;
        lodash.isArray = isArray;
        lodash.isArrayBuffer = isArrayBuffer;
        lodash.isArrayLike = isArrayLike;
        lodash.isArrayLikeObject = isArrayLikeObject;
        lodash.isBoolean = isBoolean;
        lodash.isBuffer = isBuffer;
        lodash.isDate = isDate;
        lodash.isElement = isElement;
        lodash.isEmpty = isEmpty;
        lodash.isEqual = isEqual;
        lodash.isEqualWith = isEqualWith;
        lodash.isError = isError;
        lodash.isFinite = isFinite;
        lodash.isFunction = isFunction;
        lodash.isInteger = isInteger;
        lodash.isLength = isLength;
        lodash.isMap = isMap;
        lodash.isMatch = isMatch;
        lodash.isMatchWith = isMatchWith;
        lodash.isNaN = isNaN;
        lodash.isNative = isNative;
        lodash.isNil = isNil;
        lodash.isNull = isNull;
        lodash.isNumber = isNumber;
        lodash.isObject = isObject;
        lodash.isObjectLike = isObjectLike;
        lodash.isPlainObject = isPlainObject;
        lodash.isRegExp = isRegExp;
        lodash.isSafeInteger = isSafeInteger;
        lodash.isSet = isSet;
        lodash.isString = isString;
        lodash.isSymbol = isSymbol;
        lodash.isTypedArray = isTypedArray;
        lodash.isUndefined = isUndefined;
        lodash.isWeakMap = isWeakMap;
        lodash.isWeakSet = isWeakSet;
        lodash.join = join;
        lodash.kebabCase = kebabCase;
        lodash.last = last;
        lodash.lastIndexOf = lastIndexOf;
        lodash.lowerCase = lowerCase;
        lodash.lowerFirst = lowerFirst;
        lodash.lt = lt;
        lodash.lte = lte;
        lodash.max = max;
        lodash.maxBy = maxBy;
        lodash.mean = mean;
        lodash.meanBy = meanBy;
        lodash.min = min;
        lodash.minBy = minBy;
        lodash.stubArray = stubArray;
        lodash.stubFalse = stubFalse;
        lodash.stubObject = stubObject;
        lodash.stubString = stubString;
        lodash.stubTrue = stubTrue;
        lodash.multiply = multiply;
        lodash.nth = nth;
        lodash.noConflict = noConflict;
        lodash.noop = noop;
        lodash.now = now;
        lodash.pad = pad;
        lodash.padEnd = padEnd;
        lodash.padStart = padStart;
        lodash.parseInt = parseInt1;
        lodash.random = random;
        lodash.reduce = reduce;
        lodash.reduceRight = reduceRight;
        lodash.repeat = repeat;
        lodash.replace = replace;
        lodash.result = result;
        lodash.round = round;
        lodash.runInContext = runInContext;
        lodash.sample = sample;
        lodash.size = size;
        lodash.snakeCase = snakeCase;
        lodash.some = some;
        lodash.sortedIndex = sortedIndex;
        lodash.sortedIndexBy = sortedIndexBy;
        lodash.sortedIndexOf = sortedIndexOf;
        lodash.sortedLastIndex = sortedLastIndex;
        lodash.sortedLastIndexBy = sortedLastIndexBy;
        lodash.sortedLastIndexOf = sortedLastIndexOf;
        lodash.startCase = startCase;
        lodash.startsWith = startsWith;
        lodash.subtract = subtract;
        lodash.sum = sum;
        lodash.sumBy = sumBy;
        lodash.template = template;
        lodash.times = times;
        lodash.toFinite = toFinite;
        lodash.toInteger = toInteger;
        lodash.toLength = toLength;
        lodash.toLower = toLower;
        lodash.toNumber = toNumber;
        lodash.toSafeInteger = toSafeInteger;
        lodash.toString = toString;
        lodash.toUpper = toUpper;
        lodash.trim = trim;
        lodash.trimEnd = trimEnd;
        lodash.trimStart = trimStart;
        lodash.truncate = truncate;
        lodash.unescape = unescape;
        lodash.uniqueId = uniqueId;
        lodash.upperCase = upperCase;
        lodash.upperFirst = upperFirst;
        // Add aliases.
        lodash.each = forEach;
        lodash.eachRight = forEachRight;
        lodash.first = head;
        mixin(lodash, function() {
            var source = {};
            baseForOwn(lodash, function(func, methodName) {
                if (!hasOwnProperty.call(lodash.prototype, methodName)) source[methodName] = func;
            });
            return source;
        }(), {
            "chain": false
        });
        /*------------------------------------------------------------------------*/ /**
     * The semantic version number.
     *
     * @static
     * @memberOf _
     * @type {string}
     */ lodash.VERSION = VERSION;
        // Assign default placeholders.
        arrayEach([
            "bind",
            "bindKey",
            "curry",
            "curryRight",
            "partial",
            "partialRight"
        ], function(methodName) {
            lodash[methodName].placeholder = lodash;
        });
        // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
        arrayEach([
            "drop",
            "take"
        ], function(methodName, index) {
            LazyWrapper.prototype[methodName] = function(n) {
                n = n === undefined ? 1 : nativeMax(toInteger(n), 0);
                var result = this.__filtered__ && !index ? new LazyWrapper(this) : this.clone();
                if (result.__filtered__) result.__takeCount__ = nativeMin(n, result.__takeCount__);
                else result.__views__.push({
                    "size": nativeMin(n, MAX_ARRAY_LENGTH),
                    "type": methodName + (result.__dir__ < 0 ? "Right" : "")
                });
                return result;
            };
            LazyWrapper.prototype[methodName + "Right"] = function(n) {
                return this.reverse()[methodName](n).reverse();
            };
        });
        // Add `LazyWrapper` methods that accept an `iteratee` value.
        arrayEach([
            "filter",
            "map",
            "takeWhile"
        ], function(methodName, index) {
            var type = index + 1, isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;
            LazyWrapper.prototype[methodName] = function(iteratee) {
                var result = this.clone();
                result.__iteratees__.push({
                    "iteratee": getIteratee(iteratee, 3),
                    "type": type
                });
                result.__filtered__ = result.__filtered__ || isFilter;
                return result;
            };
        });
        // Add `LazyWrapper` methods for `_.head` and `_.last`.
        arrayEach([
            "head",
            "last"
        ], function(methodName, index) {
            var takeName = "take" + (index ? "Right" : "");
            LazyWrapper.prototype[methodName] = function() {
                return this[takeName](1).value()[0];
            };
        });
        // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
        arrayEach([
            "initial",
            "tail"
        ], function(methodName, index) {
            var dropName = "drop" + (index ? "" : "Right");
            LazyWrapper.prototype[methodName] = function() {
                return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
            };
        });
        LazyWrapper.prototype.compact = function() {
            return this.filter(identity);
        };
        LazyWrapper.prototype.find = function(predicate) {
            return this.filter(predicate).head();
        };
        LazyWrapper.prototype.findLast = function(predicate) {
            return this.reverse().find(predicate);
        };
        LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
            if (typeof path == "function") return new LazyWrapper(this);
            return this.map(function(value) {
                return baseInvoke(value, path, args);
            });
        });
        LazyWrapper.prototype.reject = function(predicate) {
            return this.filter(negate(getIteratee(predicate)));
        };
        LazyWrapper.prototype.slice = function(start, end) {
            start = toInteger(start);
            var result = this;
            if (result.__filtered__ && (start > 0 || end < 0)) return new LazyWrapper(result);
            if (start < 0) result = result.takeRight(-start);
            else if (start) result = result.drop(start);
            if (end !== undefined) {
                end = toInteger(end);
                result = end < 0 ? result.dropRight(-end) : result.take(end - start);
            }
            return result;
        };
        LazyWrapper.prototype.takeRightWhile = function(predicate) {
            return this.reverse().takeWhile(predicate).reverse();
        };
        LazyWrapper.prototype.toArray = function() {
            return this.take(MAX_ARRAY_LENGTH);
        };
        // Add `LazyWrapper` methods to `lodash.prototype`.
        baseForOwn(LazyWrapper.prototype, function(func, methodName) {
            var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName), isTaker = /^(?:head|last)$/.test(methodName), lodashFunc = lodash[isTaker ? "take" + (methodName == "last" ? "Right" : "") : methodName], retUnwrapped = isTaker || /^find/.test(methodName);
            if (!lodashFunc) return;
            lodash.prototype[methodName] = function() {
                var value = this.__wrapped__, args = isTaker ? [
                    1
                ] : arguments, isLazy = value instanceof LazyWrapper, iteratee = args[0], useLazy = isLazy || isArray(value);
                var interceptor = function(value) {
                    var result = lodashFunc.apply(lodash, arrayPush([
                        value
                    ], args));
                    return isTaker && chainAll ? result[0] : result;
                };
                if (useLazy && checkIteratee && typeof iteratee == "function" && iteratee.length != 1) // Avoid lazy use if the iteratee has a "length" value other than `1`.
                isLazy = useLazy = false;
                var chainAll = this.__chain__, isHybrid = !!this.__actions__.length, isUnwrapped = retUnwrapped && !chainAll, onlyLazy = isLazy && !isHybrid;
                if (!retUnwrapped && useLazy) {
                    value = onlyLazy ? value : new LazyWrapper(this);
                    var result = func.apply(value, args);
                    result.__actions__.push({
                        "func": thru,
                        "args": [
                            interceptor
                        ],
                        "thisArg": undefined
                    });
                    return new LodashWrapper(result, chainAll);
                }
                if (isUnwrapped && onlyLazy) return func.apply(this, args);
                result = this.thru(interceptor);
                return isUnwrapped ? isTaker ? result.value()[0] : result.value() : result;
            };
        });
        // Add `Array` methods to `lodash.prototype`.
        arrayEach([
            "pop",
            "push",
            "shift",
            "sort",
            "splice",
            "unshift"
        ], function(methodName) {
            var func = arrayProto[methodName], chainName = /^(?:push|sort|unshift)$/.test(methodName) ? "tap" : "thru", retUnwrapped = /^(?:pop|shift)$/.test(methodName);
            lodash.prototype[methodName] = function() {
                var args = arguments;
                if (retUnwrapped && !this.__chain__) {
                    var value = this.value();
                    return func.apply(isArray(value) ? value : [], args);
                }
                return this[chainName](function(value) {
                    return func.apply(isArray(value) ? value : [], args);
                });
            };
        });
        // Map minified method names to their real names.
        baseForOwn(LazyWrapper.prototype, function(func, methodName) {
            var lodashFunc = lodash[methodName];
            if (lodashFunc) {
                var key = lodashFunc.name + "";
                if (!hasOwnProperty.call(realNames, key)) realNames[key] = [];
                realNames[key].push({
                    "name": methodName,
                    "func": lodashFunc
                });
            }
        });
        realNames[createHybrid(undefined, WRAP_BIND_KEY_FLAG).name] = [
            {
                "name": "wrapper",
                "func": undefined
            }
        ];
        // Add methods to `LazyWrapper`.
        LazyWrapper.prototype.clone = lazyClone;
        LazyWrapper.prototype.reverse = lazyReverse;
        LazyWrapper.prototype.value = lazyValue;
        // Add chain sequence methods to the `lodash` wrapper.
        lodash.prototype.at = wrapperAt;
        lodash.prototype.chain = wrapperChain;
        lodash.prototype.commit = wrapperCommit;
        lodash.prototype.next = wrapperNext;
        lodash.prototype.plant = wrapperPlant;
        lodash.prototype.reverse = wrapperReverse;
        lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;
        // Add lazy aliases.
        lodash.prototype.first = lodash.prototype.head;
        if (symIterator) lodash.prototype[symIterator] = wrapperToIterator;
        return lodash;
    };
    /*--------------------------------------------------------------------------*/ // Export lodash.
    var _ = runInContext();
    // Some AMD build optimizers, like r.js, check for condition patterns like:
    if (typeof define == "function" && typeof define.amd == "object" && define.amd) {
        // Expose Lodash on the global object to prevent errors when Lodash is
        // loaded by a script tag in the presence of an AMD loader.
        // See http://requirejs.org/docs/errors.html#mismatch for more details.
        // Use `_.noConflict` to remove Lodash from the global object.
        root._ = _;
        // Define as an anonymous module so, through path mapping, it can be
        // referenced as the "underscore" module.
        define(function() {
            return _;
        });
    } else if (freeModule) {
        // Export for Node.js.
        (freeModule.exports = _)._ = _;
        // Export for CommonJS support.
        freeExports._ = _;
    } else // Export to the global object.
    root._ = _;
}).call(this);

});

parcelRequire.register("b1GcV", function(module, exports) {
"use strict";
var $80708739d68a1228$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Instance = void 0;

var $6GCv3 = parcelRequire("6GCv3");

var $9Of2n = parcelRequire("9Of2n");

var $aEL5o = parcelRequire("aEL5o");

const $80708739d68a1228$var$createSnapshotBufferRefactor_1 = $80708739d68a1228$var$__importDefault((parcelRequire("3wY3y")));

var $jekUI = parcelRequire("jekUI");

var $2k8R2 = parcelRequire("2k8R2");

var $9OrNZ = parcelRequire("9OrNZ");
class $80708739d68a1228$var$Instance {
    attachEntity(parentNid, child) {
        this.localState.addChild(parentNid, child);
    }
    detachEntity(parentNid, child) {
        this.localState.removeChild(parentNid, child);
    }
    respond(endpoint, callback) {
        this.responseEndPoints.set(endpoint, callback);
    }
    registerChannel(channel) {
        const channelId = this.channelIdPool.nextId();
        channel.id = channelId;
        this.channels.add(channel);
        return channelId;
    }
    step() {
        const timestamp = Date.now();
        const timeSyncEngineMessage = {
            ntype: $9OrNZ.EngineMessage.TimeSync,
            timestamp: timestamp
        };
        this.tick++;
        this.cache.createCachesForTick(this.tick);
        this.users.forEach((user)=>{
            if (user.lastSentInstanceTick === 0) // this is the first frame connected!
            user.queueEngineMessage(timeSyncEngineMessage);
            else // send timeSyncs every 20 ticks
            if (user.lastSentInstanceTick % 20 === 0) user.queueEngineMessage(timeSyncEngineMessage);
            if (user.lastSentPingTimestamp < timestamp - this.pingIntervalMs) {
                user.queueEngineMessage({
                    ntype: $9OrNZ.EngineMessage.Ping,
                    latency: user.latency
                });
                user.lastSentPingTimestamp = timestamp;
            }
            user.queueEngineMessage({
                ntype: $9OrNZ.EngineMessage.ClientTick,
                tick: user.lastReceivedClientTick
            });
            const buffer = (0, $80708739d68a1228$var$createSnapshotBufferRefactor_1.default)(user, this);
            user.send(buffer);
            user.lastSentInstanceTick = this.tick;
        });
        this.cache.deleteCachesForTick(this.tick);
    }
    constructor(context){
        this.context = context;
        this.localState = new $6GCv3.LocalState();
        this.channelIdPool = new $2k8R2.IdPool(65535);
        this.channels = new Set();
        this.users = new Map();
        this.queue = new $jekUI.NQueue();
        this.incrementalUserId = 0;
        this.cache = new $aEL5o.EntityCache();
        this.tick = 1;
        this.pingIntervalMs = 10000;
        this.responseEndPoints = new Map();
        this.onConnect = (handshake)=>{
            return new Promise((resolve, reject)=>{
                console.log(`Please define an instance.onConnect handler that returns a Promise<boolean>. Connection denied. Received handshake ${handshake}`);
                resolve(false);
            });
        };
        this.network = new $9Of2n.InstanceNetwork(this);
    }
}
module.exports.Instance = $80708739d68a1228$var$Instance;

});
parcelRequire.register("6GCv3", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LocalState = void 0;

var $lyGu1 = parcelRequire("lyGu1");

var $2k8R2 = parcelRequire("2k8R2");
class $4de4879eaa05b1ea$var$LocalState {
    addChild(parentNid, child) {
        const cnid = this.registerEntity(child, parentNid);
        if (!this.parents.get(parentNid)) this.parents.set(parentNid, new Set());
        this.parents.get(parentNid).add(cnid);
    }
    removeChild(parentNid, child) {
        var _a;
        const cnid = child.nid;
        (_a = this.parents.get(parentNid)) === null || _a === void 0 || _a.delete(cnid);
        this.unregisterEntity(child, parentNid);
    }
    registerEntity(entity, sourceId) {
        let nid = entity.nid;
        if (!this.sources.has(nid)) {
            nid = this.entityIdPool.nextId();
            entity.nid = nid;
            this.sources.set(nid, new Set());
            this._entities.add(entity);
        }
        const entitySources = this.sources.get(nid);
        entitySources.add(sourceId);
        return nid;
    }
    unregisterEntity(entity, sourceId) {
        const nid = entity.nid;
        const entitySources = this.sources.get(nid);
        entitySources.delete(sourceId);
        if (entitySources.size === 0) {
            this.sources.delete(nid);
            this._entities.remove(entity);
            this.entityIdPool.returnId(nid);
            entity.nid = 0;
        }
    }
    getByNid(nid) {
        return this._entities.get(nid);
    }
    constructor(){
        this.entityIdPool = new $2k8R2.IdPool(65535); // TODO pick a real pool size
        this.sources = new Map();
        this.parents = new Map();
        this._entities = new $lyGu1.EDictionary();
    }
}
module.exports.LocalState = $4de4879eaa05b1ea$var$LocalState;

});
parcelRequire.register("lyGu1", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.EDictionary = void 0;
class $fb1dba3b8cc2f021$var$EDictionary {
    get size() {
        return this.array.length;
    }
    get(nid) {
        const obj = this.object[nid];
        if (typeof obj !== "undefined") return this.object[nid];
        return null;
    }
    /**
     * invokes the provided function each entity in the dictionary, passing the entity and index to the function
     * unsafe if used to remove entities from the dictionary as this will modify the index incorrectly
     * @param fn
     */ forEach(fn) {
        for(let i = 0; i < this.array.length; i++)fn(this.array[i], i);
    }
    /**
     * invokes the provided function each entity in the dictionary, passing the entity and index to the function
     * navigates in reverse, thus is safe for removing entities
     * @param fn
     */ forEachReverse(fn) {
        for(let i = this.array.length - 1; i >= 0; i--)fn(this.array[i], i);
    }
    toArray() {
        return this.array;
    }
    add(obj) {
        if (typeof obj === "object" && typeof obj.nid !== "undefined") {
            this.object[obj.nid] = obj;
            this.array.push(obj);
        } else throw new Error("EDictionary could not add object, invalid object or object.id.");
    }
    remove(obj) {
        if (typeof obj === "object" && typeof obj.nid !== "undefined") return this.removeById(obj.nid);
    }
    removeById(id) {
        if (typeof id !== "undefined") {
            let index = -1;
            for(let i = 0; i < this.array.length; i++)if (this.array[i].nid === id) {
                index = i;
                break;
            }
            if (index !== -1) this.array.splice(index, 1);
            const temp = this.object[id];
            delete this.object[id];
            return temp;
        }
    }
    bulkRemove(entitiesOrIds) {
        const idsToRemove = new Set();
        // Gather all entity IDs
        for (const item of entitiesOrIds){
            if (typeof item === "number") idsToRemove.add(item);
            else if (item && typeof item.nid !== "undefined") idsToRemove.add(item.nid);
        }
        // Filter out entities that should be removed
        this.array = this.array.filter((entity)=>!idsToRemove.has(entity.nid));
        // Remove entities from object storage
        for (const id of idsToRemove)delete this.object[id];
    }
    constructor(){
        this.object = {};
        this.array = [];
    }
}
module.exports.EDictionary = $fb1dba3b8cc2f021$var$EDictionary;

});

parcelRequire.register("2k8R2", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.IdPool = void 0;
class $1b14515844b829d2$var$IdPool {
    nextId() {
        if (this.ids.size >= this.max) throw new Error("IdPool overflow");
        this.current++;
        if (this.current > this.max) this.current = this.min;
        if (!this.ids.has(this.current)) {
            this.ids.add(this.current);
            return this.current;
        } else return this.nextId();
    }
    returnId(id) {
        this.ids.delete(id);
    }
    constructor(max){
        this.min = 1;
        this.max = max;
        this.ids = new Set();
        this.current = this.min - 1;
    }
}
module.exports.IdPool = $1b14515844b829d2$var$IdPool;

});


parcelRequire.register("9Of2n", function(module, exports) {

var $c0lTq = parcelRequire("c0lTq");
var $724472b1f934510e$require$Buffer = $c0lTq.Buffer;
"use strict";
var $724472b1f934510e$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $724472b1f934510e$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.InstanceNetwork = void 0;

var $fDA8S = parcelRequire("fDA8S");

var $9E0Iw = parcelRequire("9E0Iw");

var $3tshL = parcelRequire("3tshL");

var $9OrNZ = parcelRequire("9OrNZ");

const $724472b1f934510e$var$readEngineMessage_1 = $724472b1f934510e$var$__importDefault((parcelRequire("glVlD")));

const $724472b1f934510e$var$readMessage_1 = $724472b1f934510e$var$__importDefault((parcelRequire("4WUmv")));
class $724472b1f934510e$var$InstanceNetwork {
    onRequest() {
    // TODO
    }
    onOpen(user) {
        user.connectionState = $9E0Iw.UserConnectionState.OpenPreHandshake;
        user.network = this;
    }
    onHandshake(user, handshake) {
        return $724472b1f934510e$var$__awaiter(this, void 0, void 0, function*() {
            try {
                user.connectionState = $9E0Iw.UserConnectionState.OpenAwaitingHandshake;
                const connectionAccepted = yield this.instance.onConnect(handshake);
                // @ts-ignore typescript is wrong that connectionState does not change, it changes during the await
                if (user.connectionState === $9E0Iw.UserConnectionState.Closed) throw new Error("Connection closed before handshake completed.");
                user.connectionState = $9E0Iw.UserConnectionState.Open;
                // allow
                const bw = user.networkAdapter.createBufferWriter(3);
                bw.writeUInt8($3tshL.BinarySection.EngineMessages);
                bw.writeUInt8(1);
                bw.writeUInt8($9OrNZ.EngineMessage.ConnectionAccepted);
                user.send(bw.buffer);
                user.instance = this.instance;
                this.onConnectionAccepted(user, connectionAccepted);
            } catch (err) {
                this.onConnectionDenied(user, err);
                // NOTE: we are keeping the code between these cases duplicated
                // if these do turn out to be identical in production we will clean it up
                // but for now I am suspicious that there will be different logic
                // in each of these later
                if (user.connectionState === $9E0Iw.UserConnectionState.OpenAwaitingHandshake) {
                    // developer's code decided to reject this connection (rejected promise)
                    const jsonErr = JSON.stringify(err);
                    const denyReasonByteLength = $724472b1f934510e$require$Buffer.byteLength(jsonErr, "utf8");
                    // deny and send reason
                    const bw = user.networkAdapter.createBufferWriter(7 /* string length 32 bits */  + denyReasonByteLength /* length of actual string*/ );
                    //binaryWriterCtor.create(3 + 4 /* string length 32 bits */ + denyReasonByteLength /* length of actual string*/)
                    bw.writeUInt8($3tshL.BinarySection.EngineMessages);
                    bw.writeUInt8(1);
                    bw.writeUInt8($9OrNZ.EngineMessage.ConnectionDenied);
                    bw.writeString(jsonErr);
                    user.send(bw.buffer);
                }
                if (user.connectionState === $9E0Iw.UserConnectionState.Open) {
                    // a loss of connection after handshake is complete
                    const jsonErr = JSON.stringify(err);
                    const denyReasonByteLength = $724472b1f934510e$require$Buffer.byteLength(jsonErr, "utf8");
                    // deny and send reason
                    const bw = user.networkAdapter.createBufferWriter(7 /* string length 32 bits */  + denyReasonByteLength /* length of actual string*/ );
                    bw.writeUInt8($3tshL.BinarySection.EngineMessages);
                    bw.writeUInt8(1);
                    bw.writeUInt8($9OrNZ.EngineMessage.ConnectionDenied);
                    bw.writeString(jsonErr);
                    user.send(bw.buffer);
                }
            }
        });
    }
    onMessage(user, buffer) {
        try {
            const binaryReader = user.networkAdapter.createBufferReader(buffer);
            const commands = [];
            const commandSet = {
                type: $fDA8S.NetworkEvent.CommandSet,
                user: user,
                commands: commands,
                clientTick: -1
            };
            while(binaryReader.offset < binaryReader.byteLength){
                const section = binaryReader.readUInt8();
                switch(section){
                    case $3tshL.BinarySection.EngineMessages:
                        {
                            const count = binaryReader.readUInt8();
                            for(let i = 0; i < count; i++){
                                const msg = (0, $724472b1f934510e$var$readEngineMessage_1.default)(binaryReader, this.instance.context);
                                if (msg.ntype === $9OrNZ.EngineMessage.ConnectionAttempt) {
                                    const handshake = JSON.parse(msg.handshake);
                                    this.onHandshake(user, handshake);
                                }
                                if (msg.ntype === $9OrNZ.EngineMessage.ClientTick) {
                                    const clientTick = msg.tick;
                                    user.lastReceivedClientTick = clientTick;
                                    commandSet.clientTick = clientTick;
                                }
                                if (msg.ntype === $9OrNZ.EngineMessage.Pong) user.calculateLatency();
                            }
                            break;
                        }
                    case $3tshL.BinarySection.Commands:
                        {
                            const count = binaryReader.readUInt8();
                            for(let i = 0; i < count; i++){
                                const msg = (0, $724472b1f934510e$var$readMessage_1.default)(binaryReader, this.instance.context);
                                commands.push(msg);
                            }
                            break;
                        }
                    case $3tshL.BinarySection.Requests:
                        {
                            const count = binaryReader.readUInt8();
                            for(let i = 0; i < count; i++){
                                const requestId = binaryReader.readUInt32();
                                const endpoint = binaryReader.readUInt32();
                                const str = binaryReader.readString();
                                const body = JSON.parse(str);
                                const cb = this.instance.responseEndPoints.get(endpoint);
                                if (cb) cb({
                                    user: user,
                                    body: body
                                }, (response)=>{
                                    user.responseQueue.push({
                                        requestId: requestId,
                                        response: JSON.stringify(response)
                                    });
                                });
                            }
                            break;
                        }
                    default:
                        console.log("network hit default case while reading");
                        break;
                }
            }
            this.instance.queue.enqueue(commandSet);
        } catch (err) {
            // TODO there should be a way for a user to capture this error, perhaps a handler
            //console.log('on message err triggered', err)
            try {
                user.networkAdapter.disconnect(user, {});
            } catch (err2) {
            // TODO this is only in the case of an error while disconnecting
            // can these really occur?
            }
        }
    }
    onConnectionAccepted(user, payload) {
        user.network = this;
        user.id = ++this.instance.incrementalUserId;
        this.instance.users.set(user.id, user);
        this.instance.queue.enqueue({
            type: $fDA8S.NetworkEvent.UserConnected,
            user: user,
            payload: payload
        });
    }
    onConnectionDenied(user, payload) {
        this.instance.queue.enqueue({
            type: $fDA8S.NetworkEvent.UserConnectionDenied,
            user: user,
            payload: payload
        });
    }
    onClose(user) {
        if (user.connectionState === $9E0Iw.UserConnectionState.Open) {
            this.instance.queue.enqueue({
                type: $fDA8S.NetworkEvent.UserDisconnected,
                user: user
            });
            this.instance.users.delete(user.id);
        }
        user.connectionState = $9E0Iw.UserConnectionState.Closed;
    }
    constructor(instance){
        this.instance = instance;
    }
}
module.exports.InstanceNetwork = $724472b1f934510e$var$InstanceNetwork;

});
parcelRequire.register("c0lTq", function(module, exports) {

$parcel$export(module.exports, "Buffer", function () { return $8bd6779aeeb3bf6d$export$a143d493d941bafc; }, function (v) { return $8bd6779aeeb3bf6d$export$a143d493d941bafc = v; });
$parcel$export(module.exports, "INSPECT_MAX_BYTES", function () { return $8bd6779aeeb3bf6d$export$f99ded8fe4b79145; }, function (v) { return $8bd6779aeeb3bf6d$export$f99ded8fe4b79145 = v; });
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $8bd6779aeeb3bf6d$export$a143d493d941bafc;
var $8bd6779aeeb3bf6d$export$e4cf37d7f6fb9e0a;
var $8bd6779aeeb3bf6d$export$f99ded8fe4b79145;
var $8bd6779aeeb3bf6d$export$599f31c3813fae4d;
"use strict";

var $lgKUt = parcelRequire("lgKUt");

var $kEUQo = parcelRequire("kEUQo");
var $8bd6779aeeb3bf6d$var$customInspectSymbol = typeof Symbol === "function" && typeof Symbol["for"] === "function" // eslint-disable-line dot-notation
 ? Symbol["for"]("nodejs.util.inspect.custom") // eslint-disable-line dot-notation
 : null;
$8bd6779aeeb3bf6d$export$a143d493d941bafc = $8bd6779aeeb3bf6d$var$Buffer;
$8bd6779aeeb3bf6d$export$e4cf37d7f6fb9e0a = $8bd6779aeeb3bf6d$var$SlowBuffer;
$8bd6779aeeb3bf6d$export$f99ded8fe4b79145 = 50;
var $8bd6779aeeb3bf6d$var$K_MAX_LENGTH = 0x7fffffff;
$8bd6779aeeb3bf6d$export$599f31c3813fae4d = $8bd6779aeeb3bf6d$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $8bd6779aeeb3bf6d$var$Buffer.TYPED_ARRAY_SUPPORT = $8bd6779aeeb3bf6d$var$typedArraySupport();
if (!$8bd6779aeeb3bf6d$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== "undefined" && typeof console.error === "function") console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $8bd6779aeeb3bf6d$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        var arr = new Uint8Array(1);
        var proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($8bd6779aeeb3bf6d$var$Buffer.prototype, "parent", {
    enumerable: true,
    get: function() {
        if (!$8bd6779aeeb3bf6d$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($8bd6779aeeb3bf6d$var$Buffer.prototype, "offset", {
    enumerable: true,
    get: function() {
        if (!$8bd6779aeeb3bf6d$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $8bd6779aeeb3bf6d$var$createBuffer(length) {
    if (length > $8bd6779aeeb3bf6d$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    var buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $8bd6779aeeb3bf6d$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $8bd6779aeeb3bf6d$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === "number") {
        if (typeof encodingOrOffset === "string") throw new TypeError('The "string" argument must be of type string. Received type number');
        return $8bd6779aeeb3bf6d$var$allocUnsafe(arg);
    }
    return $8bd6779aeeb3bf6d$var$from(arg, encodingOrOffset, length);
}
$8bd6779aeeb3bf6d$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $8bd6779aeeb3bf6d$var$from(value, encodingOrOffset, length) {
    if (typeof value === "string") return $8bd6779aeeb3bf6d$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $8bd6779aeeb3bf6d$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($8bd6779aeeb3bf6d$var$isInstance(value, ArrayBuffer) || value && $8bd6779aeeb3bf6d$var$isInstance(value.buffer, ArrayBuffer)) return $8bd6779aeeb3bf6d$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== "undefined" && ($8bd6779aeeb3bf6d$var$isInstance(value, SharedArrayBuffer) || value && $8bd6779aeeb3bf6d$var$isInstance(value.buffer, SharedArrayBuffer))) return $8bd6779aeeb3bf6d$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === "number") throw new TypeError('The "value" argument must not be of type number. Received type number');
    var valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $8bd6779aeeb3bf6d$var$Buffer.from(valueOf, encodingOrOffset, length);
    var b = $8bd6779aeeb3bf6d$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== "undefined" && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === "function") return $8bd6779aeeb3bf6d$var$Buffer.from(value[Symbol.toPrimitive]("string"), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $8bd6779aeeb3bf6d$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $8bd6779aeeb3bf6d$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($8bd6779aeeb3bf6d$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($8bd6779aeeb3bf6d$var$Buffer, Uint8Array);
function $8bd6779aeeb3bf6d$var$assertSize(size) {
    if (typeof size !== "number") throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $8bd6779aeeb3bf6d$var$alloc(size, fill, encoding) {
    $8bd6779aeeb3bf6d$var$assertSize(size);
    if (size <= 0) return $8bd6779aeeb3bf6d$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === "string" ? $8bd6779aeeb3bf6d$var$createBuffer(size).fill(fill, encoding) : $8bd6779aeeb3bf6d$var$createBuffer(size).fill(fill);
    return $8bd6779aeeb3bf6d$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $8bd6779aeeb3bf6d$var$Buffer.alloc = function(size, fill, encoding) {
    return $8bd6779aeeb3bf6d$var$alloc(size, fill, encoding);
};
function $8bd6779aeeb3bf6d$var$allocUnsafe(size) {
    $8bd6779aeeb3bf6d$var$assertSize(size);
    return $8bd6779aeeb3bf6d$var$createBuffer(size < 0 ? 0 : $8bd6779aeeb3bf6d$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $8bd6779aeeb3bf6d$var$Buffer.allocUnsafe = function(size) {
    return $8bd6779aeeb3bf6d$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $8bd6779aeeb3bf6d$var$Buffer.allocUnsafeSlow = function(size) {
    return $8bd6779aeeb3bf6d$var$allocUnsafe(size);
};
function $8bd6779aeeb3bf6d$var$fromString(string, encoding) {
    if (typeof encoding !== "string" || encoding === "") encoding = "utf8";
    if (!$8bd6779aeeb3bf6d$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
    var length = $8bd6779aeeb3bf6d$var$byteLength(string, encoding) | 0;
    var buf = $8bd6779aeeb3bf6d$var$createBuffer(length);
    var actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $8bd6779aeeb3bf6d$var$fromArrayLike(array) {
    var length = array.length < 0 ? 0 : $8bd6779aeeb3bf6d$var$checked(array.length) | 0;
    var buf = $8bd6779aeeb3bf6d$var$createBuffer(length);
    for(var i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $8bd6779aeeb3bf6d$var$fromArrayView(arrayView) {
    if ($8bd6779aeeb3bf6d$var$isInstance(arrayView, Uint8Array)) {
        var copy = new Uint8Array(arrayView);
        return $8bd6779aeeb3bf6d$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $8bd6779aeeb3bf6d$var$fromArrayLike(arrayView);
}
function $8bd6779aeeb3bf6d$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    var buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $8bd6779aeeb3bf6d$var$Buffer.prototype);
    return buf;
}
function $8bd6779aeeb3bf6d$var$fromObject(obj) {
    if ($8bd6779aeeb3bf6d$var$Buffer.isBuffer(obj)) {
        var len = $8bd6779aeeb3bf6d$var$checked(obj.length) | 0;
        var buf = $8bd6779aeeb3bf6d$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== "number" || $8bd6779aeeb3bf6d$var$numberIsNaN(obj.length)) return $8bd6779aeeb3bf6d$var$createBuffer(0);
        return $8bd6779aeeb3bf6d$var$fromArrayLike(obj);
    }
    if (obj.type === "Buffer" && Array.isArray(obj.data)) return $8bd6779aeeb3bf6d$var$fromArrayLike(obj.data);
}
function $8bd6779aeeb3bf6d$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $8bd6779aeeb3bf6d$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $8bd6779aeeb3bf6d$var$K_MAX_LENGTH.toString(16) + " bytes");
    return length | 0;
}
function $8bd6779aeeb3bf6d$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $8bd6779aeeb3bf6d$var$Buffer.alloc(+length);
}
$8bd6779aeeb3bf6d$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $8bd6779aeeb3bf6d$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$8bd6779aeeb3bf6d$var$Buffer.compare = function compare(a, b) {
    if ($8bd6779aeeb3bf6d$var$isInstance(a, Uint8Array)) a = $8bd6779aeeb3bf6d$var$Buffer.from(a, a.offset, a.byteLength);
    if ($8bd6779aeeb3bf6d$var$isInstance(b, Uint8Array)) b = $8bd6779aeeb3bf6d$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$8bd6779aeeb3bf6d$var$Buffer.isBuffer(a) || !$8bd6779aeeb3bf6d$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    var x = a.length;
    var y = b.length;
    for(var i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$8bd6779aeeb3bf6d$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case "hex":
        case "utf8":
        case "utf-8":
        case "ascii":
        case "latin1":
        case "binary":
        case "base64":
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return true;
        default:
            return false;
    }
};
$8bd6779aeeb3bf6d$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $8bd6779aeeb3bf6d$var$Buffer.alloc(0);
    var i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    var buffer = $8bd6779aeeb3bf6d$var$Buffer.allocUnsafe(length);
    var pos = 0;
    for(i = 0; i < list.length; ++i){
        var buf = list[i];
        if ($8bd6779aeeb3bf6d$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) $8bd6779aeeb3bf6d$var$Buffer.from(buf).copy(buffer, pos);
            else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$8bd6779aeeb3bf6d$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $8bd6779aeeb3bf6d$var$byteLength(string, encoding) {
    if ($8bd6779aeeb3bf6d$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $8bd6779aeeb3bf6d$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== "string") throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    var len = string.length;
    var mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    var loweredCase = false;
    for(;;)switch(encoding){
        case "ascii":
        case "latin1":
        case "binary":
            return len;
        case "utf8":
        case "utf-8":
            return $8bd6779aeeb3bf6d$var$utf8ToBytes(string).length;
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return len * 2;
        case "hex":
            return len >>> 1;
        case "base64":
            return $8bd6779aeeb3bf6d$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $8bd6779aeeb3bf6d$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
}
$8bd6779aeeb3bf6d$var$Buffer.byteLength = $8bd6779aeeb3bf6d$var$byteLength;
function $8bd6779aeeb3bf6d$var$slowToString(encoding, start, end) {
    var loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return "";
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return "";
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return "";
    if (!encoding) encoding = "utf8";
    while(true)switch(encoding){
        case "hex":
            return $8bd6779aeeb3bf6d$var$hexSlice(this, start, end);
        case "utf8":
        case "utf-8":
            return $8bd6779aeeb3bf6d$var$utf8Slice(this, start, end);
        case "ascii":
            return $8bd6779aeeb3bf6d$var$asciiSlice(this, start, end);
        case "latin1":
        case "binary":
            return $8bd6779aeeb3bf6d$var$latin1Slice(this, start, end);
        case "base64":
            return $8bd6779aeeb3bf6d$var$base64Slice(this, start, end);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $8bd6779aeeb3bf6d$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = (encoding + "").toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$8bd6779aeeb3bf6d$var$Buffer.prototype._isBuffer = true;
function $8bd6779aeeb3bf6d$var$swap(b, n, m) {
    var i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$8bd6779aeeb3bf6d$var$Buffer.prototype.swap16 = function swap16() {
    var len = this.length;
    if (len % 2 !== 0) throw new RangeError("Buffer size must be a multiple of 16-bits");
    for(var i = 0; i < len; i += 2)$8bd6779aeeb3bf6d$var$swap(this, i, i + 1);
    return this;
};
$8bd6779aeeb3bf6d$var$Buffer.prototype.swap32 = function swap32() {
    var len = this.length;
    if (len % 4 !== 0) throw new RangeError("Buffer size must be a multiple of 32-bits");
    for(var i = 0; i < len; i += 4){
        $8bd6779aeeb3bf6d$var$swap(this, i, i + 3);
        $8bd6779aeeb3bf6d$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$8bd6779aeeb3bf6d$var$Buffer.prototype.swap64 = function swap64() {
    var len = this.length;
    if (len % 8 !== 0) throw new RangeError("Buffer size must be a multiple of 64-bits");
    for(var i = 0; i < len; i += 8){
        $8bd6779aeeb3bf6d$var$swap(this, i, i + 7);
        $8bd6779aeeb3bf6d$var$swap(this, i + 1, i + 6);
        $8bd6779aeeb3bf6d$var$swap(this, i + 2, i + 5);
        $8bd6779aeeb3bf6d$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$8bd6779aeeb3bf6d$var$Buffer.prototype.toString = function toString() {
    var length = this.length;
    if (length === 0) return "";
    if (arguments.length === 0) return $8bd6779aeeb3bf6d$var$utf8Slice(this, 0, length);
    return $8bd6779aeeb3bf6d$var$slowToString.apply(this, arguments);
};
$8bd6779aeeb3bf6d$var$Buffer.prototype.toLocaleString = $8bd6779aeeb3bf6d$var$Buffer.prototype.toString;
$8bd6779aeeb3bf6d$var$Buffer.prototype.equals = function equals(b) {
    if (!$8bd6779aeeb3bf6d$var$Buffer.isBuffer(b)) throw new TypeError("Argument must be a Buffer");
    if (this === b) return true;
    return $8bd6779aeeb3bf6d$var$Buffer.compare(this, b) === 0;
};
$8bd6779aeeb3bf6d$var$Buffer.prototype.inspect = function inspect() {
    var str = "";
    var max = $8bd6779aeeb3bf6d$export$f99ded8fe4b79145;
    str = this.toString("hex", 0, max).replace(/(.{2})/g, "$1 ").trim();
    if (this.length > max) str += " ... ";
    return "<Buffer " + str + ">";
};
if ($8bd6779aeeb3bf6d$var$customInspectSymbol) $8bd6779aeeb3bf6d$var$Buffer.prototype[$8bd6779aeeb3bf6d$var$customInspectSymbol] = $8bd6779aeeb3bf6d$var$Buffer.prototype.inspect;
$8bd6779aeeb3bf6d$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($8bd6779aeeb3bf6d$var$isInstance(target, Uint8Array)) target = $8bd6779aeeb3bf6d$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$8bd6779aeeb3bf6d$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError("out of range index");
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    var x = thisEnd - thisStart;
    var y = end - start;
    var len = Math.min(x, y);
    var thisCopy = this.slice(thisStart, thisEnd);
    var targetCopy = target.slice(start, end);
    for(var i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $8bd6779aeeb3bf6d$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === "string") {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($8bd6779aeeb3bf6d$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === "string") val = $8bd6779aeeb3bf6d$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($8bd6779aeeb3bf6d$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $8bd6779aeeb3bf6d$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === "number") {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === "function") {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $8bd6779aeeb3bf6d$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError("val must be string, number or Buffer");
}
function $8bd6779aeeb3bf6d$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    var indexSize = 1;
    var arrLength = arr.length;
    var valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === "ucs2" || encoding === "ucs-2" || encoding === "utf16le" || encoding === "utf-16le") {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    var i;
    if (dir) {
        var foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            var found = true;
            for(var j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$8bd6779aeeb3bf6d$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$8bd6779aeeb3bf6d$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $8bd6779aeeb3bf6d$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$8bd6779aeeb3bf6d$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $8bd6779aeeb3bf6d$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $8bd6779aeeb3bf6d$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    var remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    var strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    for(var i = 0; i < length; ++i){
        var parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($8bd6779aeeb3bf6d$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $8bd6779aeeb3bf6d$var$utf8Write(buf, string, offset, length) {
    return $8bd6779aeeb3bf6d$var$blitBuffer($8bd6779aeeb3bf6d$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $8bd6779aeeb3bf6d$var$asciiWrite(buf, string, offset, length) {
    return $8bd6779aeeb3bf6d$var$blitBuffer($8bd6779aeeb3bf6d$var$asciiToBytes(string), buf, offset, length);
}
function $8bd6779aeeb3bf6d$var$base64Write(buf, string, offset, length) {
    return $8bd6779aeeb3bf6d$var$blitBuffer($8bd6779aeeb3bf6d$var$base64ToBytes(string), buf, offset, length);
}
function $8bd6779aeeb3bf6d$var$ucs2Write(buf, string, offset, length) {
    return $8bd6779aeeb3bf6d$var$blitBuffer($8bd6779aeeb3bf6d$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$8bd6779aeeb3bf6d$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = "utf8";
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === "string") {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = "utf8";
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
    var remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError("Attempt to write outside buffer bounds");
    if (!encoding) encoding = "utf8";
    var loweredCase = false;
    for(;;)switch(encoding){
        case "hex":
            return $8bd6779aeeb3bf6d$var$hexWrite(this, string, offset, length);
        case "utf8":
        case "utf-8":
            return $8bd6779aeeb3bf6d$var$utf8Write(this, string, offset, length);
        case "ascii":
        case "latin1":
        case "binary":
            return $8bd6779aeeb3bf6d$var$asciiWrite(this, string, offset, length);
        case "base64":
            // Warning: maxLength not taken into account in base64Write
            return $8bd6779aeeb3bf6d$var$base64Write(this, string, offset, length);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $8bd6779aeeb3bf6d$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
};
$8bd6779aeeb3bf6d$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: "Buffer",
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $8bd6779aeeb3bf6d$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $lgKUt.fromByteArray(buf);
    else return $lgKUt.fromByteArray(buf.slice(start, end));
}
function $8bd6779aeeb3bf6d$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    var res = [];
    var i = start;
    while(i < end){
        var firstByte = buf[i];
        var codePoint = null;
        var bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            var secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $8bd6779aeeb3bf6d$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var $8bd6779aeeb3bf6d$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $8bd6779aeeb3bf6d$var$decodeCodePointsArray(codePoints) {
    var len = codePoints.length;
    if (len <= $8bd6779aeeb3bf6d$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    var res = "";
    var i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $8bd6779aeeb3bf6d$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $8bd6779aeeb3bf6d$var$asciiSlice(buf, start, end) {
    var ret = "";
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $8bd6779aeeb3bf6d$var$latin1Slice(buf, start, end) {
    var ret = "";
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $8bd6779aeeb3bf6d$var$hexSlice(buf, start, end) {
    var len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    var out = "";
    for(var i = start; i < end; ++i)out += $8bd6779aeeb3bf6d$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $8bd6779aeeb3bf6d$var$utf16leSlice(buf, start, end) {
    var bytes = buf.slice(start, end);
    var res = "";
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(var i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$8bd6779aeeb3bf6d$var$Buffer.prototype.slice = function slice(start, end) {
    var len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    var newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $8bd6779aeeb3bf6d$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $8bd6779aeeb3bf6d$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError("offset is not uint");
    if (offset + ext > length) throw new RangeError("Trying to access beyond buffer length");
}
$8bd6779aeeb3bf6d$var$Buffer.prototype.readUintLE = $8bd6779aeeb3bf6d$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $8bd6779aeeb3bf6d$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$8bd6779aeeb3bf6d$var$Buffer.prototype.readUintBE = $8bd6779aeeb3bf6d$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $8bd6779aeeb3bf6d$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset + --byteLength];
    var mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$8bd6779aeeb3bf6d$var$Buffer.prototype.readUint8 = $8bd6779aeeb3bf6d$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $8bd6779aeeb3bf6d$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$8bd6779aeeb3bf6d$var$Buffer.prototype.readUint16LE = $8bd6779aeeb3bf6d$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $8bd6779aeeb3bf6d$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$8bd6779aeeb3bf6d$var$Buffer.prototype.readUint16BE = $8bd6779aeeb3bf6d$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $8bd6779aeeb3bf6d$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$8bd6779aeeb3bf6d$var$Buffer.prototype.readUint32LE = $8bd6779aeeb3bf6d$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $8bd6779aeeb3bf6d$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$8bd6779aeeb3bf6d$var$Buffer.prototype.readUint32BE = $8bd6779aeeb3bf6d$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $8bd6779aeeb3bf6d$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$8bd6779aeeb3bf6d$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $8bd6779aeeb3bf6d$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$8bd6779aeeb3bf6d$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $8bd6779aeeb3bf6d$var$checkOffset(offset, byteLength, this.length);
    var i = byteLength;
    var mul = 1;
    var val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$8bd6779aeeb3bf6d$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $8bd6779aeeb3bf6d$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$8bd6779aeeb3bf6d$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $8bd6779aeeb3bf6d$var$checkOffset(offset, 2, this.length);
    var val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$8bd6779aeeb3bf6d$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $8bd6779aeeb3bf6d$var$checkOffset(offset, 2, this.length);
    var val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$8bd6779aeeb3bf6d$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $8bd6779aeeb3bf6d$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$8bd6779aeeb3bf6d$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $8bd6779aeeb3bf6d$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$8bd6779aeeb3bf6d$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $8bd6779aeeb3bf6d$var$checkOffset(offset, 4, this.length);
    return $kEUQo.read(this, offset, true, 23, 4);
};
$8bd6779aeeb3bf6d$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $8bd6779aeeb3bf6d$var$checkOffset(offset, 4, this.length);
    return $kEUQo.read(this, offset, false, 23, 4);
};
$8bd6779aeeb3bf6d$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $8bd6779aeeb3bf6d$var$checkOffset(offset, 8, this.length);
    return $kEUQo.read(this, offset, true, 52, 8);
};
$8bd6779aeeb3bf6d$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $8bd6779aeeb3bf6d$var$checkOffset(offset, 8, this.length);
    return $kEUQo.read(this, offset, false, 52, 8);
};
function $8bd6779aeeb3bf6d$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$8bd6779aeeb3bf6d$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
}
$8bd6779aeeb3bf6d$var$Buffer.prototype.writeUintLE = $8bd6779aeeb3bf6d$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $8bd6779aeeb3bf6d$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var mul = 1;
    var i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$8bd6779aeeb3bf6d$var$Buffer.prototype.writeUintBE = $8bd6779aeeb3bf6d$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $8bd6779aeeb3bf6d$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var i = byteLength - 1;
    var mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$8bd6779aeeb3bf6d$var$Buffer.prototype.writeUint8 = $8bd6779aeeb3bf6d$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $8bd6779aeeb3bf6d$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$8bd6779aeeb3bf6d$var$Buffer.prototype.writeUint16LE = $8bd6779aeeb3bf6d$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $8bd6779aeeb3bf6d$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$8bd6779aeeb3bf6d$var$Buffer.prototype.writeUint16BE = $8bd6779aeeb3bf6d$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $8bd6779aeeb3bf6d$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$8bd6779aeeb3bf6d$var$Buffer.prototype.writeUint32LE = $8bd6779aeeb3bf6d$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $8bd6779aeeb3bf6d$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$8bd6779aeeb3bf6d$var$Buffer.prototype.writeUint32BE = $8bd6779aeeb3bf6d$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $8bd6779aeeb3bf6d$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$8bd6779aeeb3bf6d$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $8bd6779aeeb3bf6d$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = 0;
    var mul = 1;
    var sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$8bd6779aeeb3bf6d$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $8bd6779aeeb3bf6d$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = byteLength - 1;
    var mul = 1;
    var sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$8bd6779aeeb3bf6d$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $8bd6779aeeb3bf6d$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$8bd6779aeeb3bf6d$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $8bd6779aeeb3bf6d$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$8bd6779aeeb3bf6d$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $8bd6779aeeb3bf6d$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$8bd6779aeeb3bf6d$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $8bd6779aeeb3bf6d$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$8bd6779aeeb3bf6d$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $8bd6779aeeb3bf6d$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $8bd6779aeeb3bf6d$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
    if (offset < 0) throw new RangeError("Index out of range");
}
function $8bd6779aeeb3bf6d$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $8bd6779aeeb3bf6d$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $kEUQo.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$8bd6779aeeb3bf6d$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $8bd6779aeeb3bf6d$var$writeFloat(this, value, offset, true, noAssert);
};
$8bd6779aeeb3bf6d$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $8bd6779aeeb3bf6d$var$writeFloat(this, value, offset, false, noAssert);
};
function $8bd6779aeeb3bf6d$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $8bd6779aeeb3bf6d$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $kEUQo.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$8bd6779aeeb3bf6d$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $8bd6779aeeb3bf6d$var$writeDouble(this, value, offset, true, noAssert);
};
$8bd6779aeeb3bf6d$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $8bd6779aeeb3bf6d$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$8bd6779aeeb3bf6d$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$8bd6779aeeb3bf6d$var$Buffer.isBuffer(target)) throw new TypeError("argument should be a Buffer");
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError("targetStart out of bounds");
    if (start < 0 || start >= this.length) throw new RangeError("Index out of range");
    if (end < 0) throw new RangeError("sourceEnd out of bounds");
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    var len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === "function") // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$8bd6779aeeb3bf6d$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === "string") {
        if (typeof start === "string") {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === "string") {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== "string") throw new TypeError("encoding must be a string");
        if (typeof encoding === "string" && !$8bd6779aeeb3bf6d$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
        if (val.length === 1) {
            var code = val.charCodeAt(0);
            if (encoding === "utf8" && code < 128 || encoding === "latin1") // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === "number") val = val & 255;
    else if (typeof val === "boolean") val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError("Out of range index");
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    var i;
    if (typeof val === "number") for(i = start; i < end; ++i)this[i] = val;
    else {
        var bytes = $8bd6779aeeb3bf6d$var$Buffer.isBuffer(val) ? val : $8bd6779aeeb3bf6d$var$Buffer.from(val, encoding);
        var len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// HELPER FUNCTIONS
// ================
var $8bd6779aeeb3bf6d$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $8bd6779aeeb3bf6d$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split("=")[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($8bd6779aeeb3bf6d$var$INVALID_BASE64_RE, "");
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return "";
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + "=";
    return str;
}
function $8bd6779aeeb3bf6d$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    var codePoint;
    var length = string.length;
    var leadSurrogate = null;
    var bytes = [];
    for(var i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error("Invalid code point");
    }
    return bytes;
}
function $8bd6779aeeb3bf6d$var$asciiToBytes(str) {
    var byteArray = [];
    for(var i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $8bd6779aeeb3bf6d$var$utf16leToBytes(str, units) {
    var c, hi, lo;
    var byteArray = [];
    for(var i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $8bd6779aeeb3bf6d$var$base64ToBytes(str) {
    return $lgKUt.toByteArray($8bd6779aeeb3bf6d$var$base64clean(str));
}
function $8bd6779aeeb3bf6d$var$blitBuffer(src, dst, offset, length) {
    for(var i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $8bd6779aeeb3bf6d$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $8bd6779aeeb3bf6d$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
var $8bd6779aeeb3bf6d$var$hexSliceLookupTable = function() {
    var alphabet = "0123456789abcdef";
    var table = new Array(256);
    for(var i = 0; i < 16; ++i){
        var i16 = i * 16;
        for(var j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();

});
parcelRequire.register("lgKUt", function(module, exports) {

$parcel$export(module.exports, "toByteArray", function () { return $f7bf7aea8672d249$export$d622b2ad8d90c771; }, function (v) { return $f7bf7aea8672d249$export$d622b2ad8d90c771 = v; });
$parcel$export(module.exports, "fromByteArray", function () { return $f7bf7aea8672d249$export$6100ba28696e12de; }, function (v) { return $f7bf7aea8672d249$export$6100ba28696e12de = v; });
var $f7bf7aea8672d249$export$a48f0734ac7c2329;
var $f7bf7aea8672d249$export$d622b2ad8d90c771;
var $f7bf7aea8672d249$export$6100ba28696e12de;
"use strict";
$f7bf7aea8672d249$export$a48f0734ac7c2329 = $f7bf7aea8672d249$var$byteLength;
$f7bf7aea8672d249$export$d622b2ad8d90c771 = $f7bf7aea8672d249$var$toByteArray;
$f7bf7aea8672d249$export$6100ba28696e12de = $f7bf7aea8672d249$var$fromByteArray;
var $f7bf7aea8672d249$var$lookup = [];
var $f7bf7aea8672d249$var$revLookup = [];
var $f7bf7aea8672d249$var$Arr = typeof Uint8Array !== "undefined" ? Uint8Array : Array;
var $f7bf7aea8672d249$var$code = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
for(var $f7bf7aea8672d249$var$i = 0, $f7bf7aea8672d249$var$len = $f7bf7aea8672d249$var$code.length; $f7bf7aea8672d249$var$i < $f7bf7aea8672d249$var$len; ++$f7bf7aea8672d249$var$i){
    $f7bf7aea8672d249$var$lookup[$f7bf7aea8672d249$var$i] = $f7bf7aea8672d249$var$code[$f7bf7aea8672d249$var$i];
    $f7bf7aea8672d249$var$revLookup[$f7bf7aea8672d249$var$code.charCodeAt($f7bf7aea8672d249$var$i)] = $f7bf7aea8672d249$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$f7bf7aea8672d249$var$revLookup["-".charCodeAt(0)] = 62;
$f7bf7aea8672d249$var$revLookup["_".charCodeAt(0)] = 63;
function $f7bf7aea8672d249$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error("Invalid string. Length must be a multiple of 4");
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf("=");
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $f7bf7aea8672d249$var$byteLength(b64) {
    var lens = $f7bf7aea8672d249$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $f7bf7aea8672d249$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $f7bf7aea8672d249$var$toByteArray(b64) {
    var tmp;
    var lens = $f7bf7aea8672d249$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $f7bf7aea8672d249$var$Arr($f7bf7aea8672d249$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $f7bf7aea8672d249$var$revLookup[b64.charCodeAt(i)] << 18 | $f7bf7aea8672d249$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $f7bf7aea8672d249$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $f7bf7aea8672d249$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $f7bf7aea8672d249$var$revLookup[b64.charCodeAt(i)] << 2 | $f7bf7aea8672d249$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $f7bf7aea8672d249$var$revLookup[b64.charCodeAt(i)] << 10 | $f7bf7aea8672d249$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $f7bf7aea8672d249$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $f7bf7aea8672d249$var$tripletToBase64(num) {
    return $f7bf7aea8672d249$var$lookup[num >> 18 & 0x3F] + $f7bf7aea8672d249$var$lookup[num >> 12 & 0x3F] + $f7bf7aea8672d249$var$lookup[num >> 6 & 0x3F] + $f7bf7aea8672d249$var$lookup[num & 0x3F];
}
function $f7bf7aea8672d249$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($f7bf7aea8672d249$var$tripletToBase64(tmp));
    }
    return output.join("");
}
function $f7bf7aea8672d249$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($f7bf7aea8672d249$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($f7bf7aea8672d249$var$lookup[tmp >> 2] + $f7bf7aea8672d249$var$lookup[tmp << 4 & 0x3F] + "==");
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($f7bf7aea8672d249$var$lookup[tmp >> 10] + $f7bf7aea8672d249$var$lookup[tmp >> 4 & 0x3F] + $f7bf7aea8672d249$var$lookup[tmp << 2 & 0x3F] + "=");
    }
    return parts.join("");
}

});

parcelRequire.register("kEUQo", function(module, exports) {

$parcel$export(module.exports, "read", function () { return $f0a3a31e46b69a18$export$aafa59e2e03f2942; }, function (v) { return $f0a3a31e46b69a18$export$aafa59e2e03f2942 = v; });
$parcel$export(module.exports, "write", function () { return $f0a3a31e46b69a18$export$68d8715fc104d294; }, function (v) { return $f0a3a31e46b69a18$export$68d8715fc104d294 = v; });
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $f0a3a31e46b69a18$export$aafa59e2e03f2942;
var $f0a3a31e46b69a18$export$68d8715fc104d294;
$f0a3a31e46b69a18$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$f0a3a31e46b69a18$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};

});


parcelRequire.register("fDA8S", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.NetworkEvent = void 0;
var $b6268899ac61336b$var$NetworkEvent;
(function(NetworkEvent) {
    NetworkEvent[NetworkEvent["Null"] = 0] = "Null";
    NetworkEvent[NetworkEvent["UserConnected"] = 1] = "UserConnected";
    NetworkEvent[NetworkEvent["Command"] = 2] = "Command";
    NetworkEvent[NetworkEvent["CommandSet"] = 3] = "CommandSet";
    NetworkEvent[NetworkEvent["UserDisconnected"] = 4] = "UserDisconnected";
    NetworkEvent[NetworkEvent["UserConnectionDenied"] = 5] = "UserConnectionDenied";
})($b6268899ac61336b$var$NetworkEvent || (module.exports.NetworkEvent = $b6268899ac61336b$var$NetworkEvent = {}));

});

parcelRequire.register("9E0Iw", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.User = module.exports.UserConnectionState = void 0;
var $705867e72154c7ef$var$UserConnectionState;
(function(UserConnectionState) {
    UserConnectionState[UserConnectionState["NULL"] = 0] = "NULL";
    UserConnectionState[UserConnectionState["OpenPreHandshake"] = 1] = "OpenPreHandshake";
    UserConnectionState[UserConnectionState["OpenAwaitingHandshake"] = 2] = "OpenAwaitingHandshake";
    UserConnectionState[UserConnectionState["Open"] = 3] = "Open";
    UserConnectionState[UserConnectionState["Closed"] = 4] = "Closed"; // closed, network.send would crash if invoked
})($705867e72154c7ef$var$UserConnectionState || (module.exports.UserConnectionState = $705867e72154c7ef$var$UserConnectionState = {}));
class $705867e72154c7ef$var$User {
    calculateLatency() {
        const deltaMs = Date.now() - this.lastSentPingTimestamp;
        this.recentLatencies.push(deltaMs);
        if (this.recentLatencies.length > 0) {
            let curr = 0;
            for(let i = 0; i < this.recentLatencies.length; i++)curr += this.recentLatencies[i];
            this.latency = curr / this.recentLatencies.length;
        }
        while(this.recentLatencies.length > this.latencySamples)this.recentLatencies.shift();
    }
    subscribe(channel) {
        this.subscriptions.set(channel.id, channel);
    }
    unsubscribe(channel) {
        this.subscriptions.delete(channel.id);
    }
    queueEngineMessage(engineMessage) {
        this.engineMessageQueue.push(engineMessage);
    }
    queueMessage(message) {
        this.messageQueue.push(message);
    }
    createOrUpdate(id, tick, toCreate, toUpdate) {
        if (!this.cache[id]) {
            //console.log('create push', id)
            toCreate.push(id);
            this.cache[id] = tick;
            this.cacheArr.push(id);
        } else {
            this.cache[id] = tick;
            toUpdate.push(id);
        }
        const children = this.instance.localState.parents.get(id);
        if (children) children.forEach((id)=>this.createOrUpdate(id, tick, toCreate, toUpdate));
    }
    send(buffer) {
        this.networkAdapter.send(this, buffer);
    }
    disconnect(reason) {
        this.networkAdapter.disconnect(this, reason);
    }
    checkVisibility(tick) {
        const toCreate = [];
        const toUpdate = [];
        const toDelete = [];
        this.subscriptions.forEach((channel)=>{
            channel.getVisibileEntities(this.id).forEach((nid)=>{
                this.createOrUpdate(nid, tick, toCreate, toUpdate);
            });
        });
        for(let i = this.cacheArr.length - 1; i > -1; i--){
            const id = this.cacheArr[i];
            if (this.cache[id] !== tick) {
                //console.log('delete', id)
                toDelete.push(id);
                this.cache[id] = 0;
                //delete this.cache[id]
                this.cacheArr.splice(i, 1);
            }
        }
        return {
            //events: nearby.events,
            noLongerVisible: toDelete,
            stillVisible: toUpdate,
            newlyVisible: toCreate //diffs.bOnly
        };
    }
    constructor(socket, networkAdapter){
        this.id = 0;
        this.instance = null;
        this.network = null;
        this.remoteAddress = null;
        this.connectionState = $705867e72154c7ef$var$UserConnectionState.NULL;
        this.subscriptions = new Map();
        this.engineMessageQueue = [];
        this.messageQueue = [];
        this.responseQueue = [];
        this.cache = {};
        this.cacheArr = [];
        this.lastSentInstanceTick = 0;
        this.lastReceivedClientTick = 0;
        this.latency = 0;
        this.lastSentPingTimestamp = 0;
        this.recentLatencies = [];
        this.latencySamples = 3;
        this.socket = socket;
        this.networkAdapter = networkAdapter;
    }
}
module.exports.User = $705867e72154c7ef$var$User;

});

parcelRequire.register("3tshL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.BinarySection = void 0;
var $287a057129885982$var$BinarySection;
(function(BinarySection) {
    BinarySection[BinarySection["Null"] = 0] = "Null";
    BinarySection[BinarySection["EngineMessages"] = 1] = "EngineMessages";
    BinarySection[BinarySection["CreateEntities"] = 2] = "CreateEntities";
    BinarySection[BinarySection["UpdateEntities"] = 3] = "UpdateEntities";
    BinarySection[BinarySection["DeleteEntities"] = 4] = "DeleteEntities";
    BinarySection[BinarySection["Messages"] = 5] = "Messages";
    BinarySection[BinarySection["Commands"] = 6] = "Commands";
    BinarySection[BinarySection["Requests"] = 7] = "Requests";
    BinarySection[BinarySection["Responses"] = 8] = "Responses";
    BinarySection[BinarySection["ClientTick"] = 9] = "ClientTick";
})($287a057129885982$var$BinarySection || (module.exports.BinarySection = $287a057129885982$var$BinarySection = {}));

});

parcelRequire.register("9OrNZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.EngineMessage = void 0;
var $724e5a24746593f8$var$EngineMessage;
(function(EngineMessage) {
    EngineMessage[EngineMessage["Null"] = 0] = "Null";
    EngineMessage[EngineMessage["ConnectionAccepted"] = 1] = "ConnectionAccepted";
    EngineMessage[EngineMessage["ConnectionDenied"] = 2] = "ConnectionDenied";
    EngineMessage[EngineMessage["ConnectionAttempt"] = 3] = "ConnectionAttempt";
    EngineMessage[EngineMessage["ChannelJoin"] = 4] = "ChannelJoin";
    EngineMessage[EngineMessage["ChannelLeave"] = 5] = "ChannelLeave";
    EngineMessage[EngineMessage["ChannelAddEntity"] = 6] = "ChannelAddEntity";
    EngineMessage[EngineMessage["ChannelRemoveEntity"] = 7] = "ChannelRemoveEntity";
    EngineMessage[EngineMessage["ConnectionTerminated"] = 8] = "ConnectionTerminated";
    EngineMessage[EngineMessage["TimeSync"] = 9] = "TimeSync";
    EngineMessage[EngineMessage["Ping"] = 10] = "Ping";
    EngineMessage[EngineMessage["Pong"] = 11] = "Pong";
    EngineMessage[EngineMessage["ClientTick"] = 12] = "ClientTick";
})($724e5a24746593f8$var$EngineMessage || (module.exports.EngineMessage = $724e5a24746593f8$var$EngineMessage = {}));

});

parcelRequire.register("glVlD", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $7wMIx = parcelRequire("7wMIx");
function $be7b179ee96d81da$var$readEngineMessage(reader, context) {
    //console.log('entered readMEssage')
    const ntype = reader.readUInt8();
    const nschema = context.getEngineSchema(ntype);
    const obj = {
        ntype: ntype
    };
    for(let i = 1; i < nschema.keys.length; i++){
        const propData = nschema.keys[i];
        const binaryUtil = (0, $7wMIx.binaryGet)(propData.type);
        // @ts-ignore
        obj[propData.prop] = binaryUtil.read(reader);
    }
    return obj;
}
module.exports.default = $be7b179ee96d81da$var$readEngineMessage;

});
parcelRequire.register("7wMIx", function(module, exports) {

var $c0lTq = parcelRequire("c0lTq");
var $57b14fd439a7e437$require$Buffer = $c0lTq.Buffer;
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.declareBinaryType = module.exports.binaryGet = void 0;

var $ge3xl = parcelRequire("ge3xl");
function $57b14fd439a7e437$var$countByteArray(value) {
    return value.length + 4;
}
function $57b14fd439a7e437$var$count2ByteArray(value) {
    return value.length * 2 + 4;
}
function $57b14fd439a7e437$var$count4ByteArray(value) {
    return value.length * 4 + 4;
}
function $57b14fd439a7e437$var$count8ByteArray(value) {
    return value.length * 8 + 4;
}
function $57b14fd439a7e437$var$stringByteLength(str) {
    if (typeof $57b14fd439a7e437$require$Buffer !== "undefined") return $57b14fd439a7e437$require$Buffer.byteLength(str, "utf8");
    else return new Blob([
        str
    ]).size;
}
function $57b14fd439a7e437$var$countString(value) {
    const length = $57b14fd439a7e437$var$stringByteLength(value);
    return length + 4;
}
const $57b14fd439a7e437$var$data = new Map();
const $57b14fd439a7e437$var$lerp = function(a, b, t) {
    return a + (b - a) * t;
};
const $57b14fd439a7e437$var$lerpRot = function(a, b, t) {
    const s = (1 - t) * Math.sin(a) + t * Math.sin(b);
    const c = (1 - t) * Math.cos(a) + t * Math.cos(b);
    return Math.atan2(s, c);
};
function $57b14fd439a7e437$var$declareBinaryType(binaryIndex, spec) {
    const { write: write, read: read, byteSize: byteSize, compare: compare, pre: pre, post: post, interp: interp, clone: clone } = spec;
    if (!write) throw new Error("A custom binary type was declared with no write function. Please declare a function write(value: T, bw: IBinaryWirter) => void that writes your custom binary type to an IBinaryWriter.");
    if (!read) throw new Error("A custom binary type was declared with no read function. Please declare a function (readbr: IBinaryReader) => T that reads your custom binary tpe from an IBinaryReader.");
    if (!byteSize) throw new Error("A custom binary type was declared with no byteSize function. Please declare a function byteSize(a: T) => number that returns the byte size of your value.");
    if (!compare) throw new Error("A custom binary type was declared with no compare function. Please declare a function compare(a: T, b: T) => boolean that can compare two values of your binary type.");
    $57b14fd439a7e437$var$data.set(binaryIndex, {
        write: write,
        read: read,
        byteSize: byteSize,
        compare: compare,
        // use the pre function or create a function that returns the value unchanged
        pre: pre ? pre : (value)=>{
            return value;
        },
        // use the post function or create a function that returns the value unchanged
        post: post ? post : (value)=>{
            return value;
        },
        // use the interp function or create a function that returns the most recent value uninterpolated
        interp: interp ? interp : (a, b, t)=>{
            return b;
        },
        clone: clone ? clone : (value)=>{
            return value;
        }
    });
}
module.exports.declareBinaryType = $57b14fd439a7e437$var$declareBinaryType;
$57b14fd439a7e437$var$declareBinaryType($ge3xl.Binary.UInt8, {
    write: (value, bw)=>{
        bw.writeUInt8(value);
    },
    read: (br)=>{
        return br.readUInt8();
    },
    byteSize: ()=>{
        return 1;
    },
    compare: (a, b)=>{
        return a === b;
    },
    interp: $57b14fd439a7e437$var$lerp
});
$57b14fd439a7e437$var$declareBinaryType($ge3xl.Binary.Int8, {
    write: (value, bw)=>{
        bw.writeInt8(value);
    },
    read: (br)=>{
        return br.readInt8();
    },
    byteSize: ()=>{
        return 1;
    },
    compare: (a, b)=>{
        return a === b;
    },
    interp: $57b14fd439a7e437$var$lerp
});
$57b14fd439a7e437$var$declareBinaryType($ge3xl.Binary.UInt16, {
    write: (value, bw)=>{
        bw.writeUInt16(value);
    },
    read: (br)=>{
        return br.readUInt16();
    },
    byteSize: ()=>{
        return 2;
    },
    compare: (a, b)=>{
        return a === b;
    },
    interp: $57b14fd439a7e437$var$lerp
});
$57b14fd439a7e437$var$declareBinaryType($ge3xl.Binary.Int16, {
    write: (value, bw)=>{
        bw.writeInt16(value);
    },
    read: (br)=>{
        return br.readInt16();
    },
    byteSize: ()=>{
        return 2;
    },
    compare: (a, b)=>{
        return a === b;
    },
    interp: $57b14fd439a7e437$var$lerp
});
$57b14fd439a7e437$var$declareBinaryType($ge3xl.Binary.UInt32, {
    write: (value, bw)=>{
        bw.writeUInt32(value);
    },
    read: (br)=>{
        return br.readUInt32();
    },
    byteSize: ()=>{
        return 4;
    },
    compare: (a, b)=>{
        return a === b;
    },
    interp: $57b14fd439a7e437$var$lerp
});
$57b14fd439a7e437$var$declareBinaryType($ge3xl.Binary.Int32, {
    write: (value, bw)=>{
        bw.writeInt32(value);
    },
    read: (br)=>{
        return br.readInt32();
    },
    byteSize: ()=>{
        return 4;
    },
    compare: (a, b)=>{
        return a === b;
    },
    interp: $57b14fd439a7e437$var$lerp
});
$57b14fd439a7e437$var$declareBinaryType($ge3xl.Binary.Float32, {
    write: (value, bw)=>{
        bw.writeFloat32(value);
    },
    read: (br)=>{
        return br.readFloat32();
    },
    byteSize: ()=>{
        return 4;
    },
    compare: (a, b)=>{
        return a === b;
    },
    interp: $57b14fd439a7e437$var$lerp
});
$57b14fd439a7e437$var$declareBinaryType($ge3xl.Binary.Float64, {
    write: (value, bw)=>{
        bw.writeFloat64(value);
    },
    read: (br)=>{
        return br.readFloat64();
    },
    byteSize: ()=>{
        return 8;
    },
    compare: (a, b)=>{
        return a === b;
    },
    interp: $57b14fd439a7e437$var$lerp
});
$57b14fd439a7e437$var$declareBinaryType($ge3xl.Binary.Rotation, {
    write: (value, bw)=>{
        bw.writeFloat64(value);
    },
    read: (br)=>{
        return br.readFloat64();
    },
    byteSize: ()=>{
        return 8;
    },
    compare: (a, b)=>{
        return a === b;
    },
    interp: $57b14fd439a7e437$var$lerpRot
});
$57b14fd439a7e437$var$declareBinaryType($ge3xl.Binary.Rotation32, {
    write: (value, bw)=>{
        bw.writeFloat32(value);
    },
    read: (br)=>{
        return br.readFloat32();
    },
    byteSize: ()=>{
        return 4;
    },
    compare: (a, b)=>{
        return a === b;
    },
    interp: $57b14fd439a7e437$var$lerpRot
});
$57b14fd439a7e437$var$declareBinaryType($ge3xl.Binary.String, {
    write: (value, bw)=>{
        bw.writeString(value);
    },
    read: (br)=>{
        return br.readString();
    },
    byteSize: $57b14fd439a7e437$var$countString,
    compare: (a, b)=>{
        return a === b;
    }
});
function $57b14fd439a7e437$var$compareTypedArray(a, b) {
    if (a.length !== b.length) return false;
    for(let i = a.length; -1 < i; i -= 1){
        if (a[i] !== b[i]) return false;
    }
    return true;
}
$57b14fd439a7e437$var$declareBinaryType($ge3xl.Binary.UInt8Array, {
    write: (value, bw)=>{
        bw.writeUInt8Array(value);
    },
    read: (br)=>{
        return br.readUInt8Array();
    },
    byteSize: $57b14fd439a7e437$var$countByteArray,
    compare: $57b14fd439a7e437$var$compareTypedArray
});
$57b14fd439a7e437$var$declareBinaryType($ge3xl.Binary.Int8Array, {
    write: (value, bw)=>{
        bw.writeInt8Array(value);
    },
    read: (br)=>{
        return br.readInt8Array();
    },
    byteSize: $57b14fd439a7e437$var$countByteArray,
    compare: $57b14fd439a7e437$var$compareTypedArray
});
$57b14fd439a7e437$var$declareBinaryType($ge3xl.Binary.UInt16Array, {
    write: (value, bw)=>{
        bw.writeUInt16Array(value);
    },
    read: (br)=>{
        return br.readUInt16Array();
    },
    byteSize: $57b14fd439a7e437$var$count2ByteArray,
    compare: $57b14fd439a7e437$var$compareTypedArray
});
$57b14fd439a7e437$var$declareBinaryType($ge3xl.Binary.Int16Array, {
    write: (value, bw)=>{
        bw.writeInt16Array(value);
    },
    read: (br)=>{
        return br.readInt16Array();
    },
    byteSize: $57b14fd439a7e437$var$count2ByteArray,
    compare: $57b14fd439a7e437$var$compareTypedArray
});
$57b14fd439a7e437$var$declareBinaryType($ge3xl.Binary.UInt32Array, {
    write: (value, bw)=>{
        bw.writeUInt32Array(value);
    },
    read: (br)=>{
        return br.readUInt32Array();
    },
    byteSize: $57b14fd439a7e437$var$count4ByteArray,
    compare: $57b14fd439a7e437$var$compareTypedArray
});
$57b14fd439a7e437$var$declareBinaryType($ge3xl.Binary.Int32Array, {
    write: (value, bw)=>{
        bw.writeInt32Array(value);
    },
    read: (br)=>{
        return br.readInt32Array();
    },
    byteSize: $57b14fd439a7e437$var$count4ByteArray,
    compare: $57b14fd439a7e437$var$compareTypedArray
});
$57b14fd439a7e437$var$declareBinaryType($ge3xl.Binary.Float32Array, {
    write: (value, bw)=>{
        bw.writeFloat32Array(value);
    },
    read: (br)=>{
        return br.readFloat32Array();
    },
    byteSize: $57b14fd439a7e437$var$count4ByteArray,
    compare: $57b14fd439a7e437$var$compareTypedArray
});
$57b14fd439a7e437$var$declareBinaryType($ge3xl.Binary.Float64Array, {
    write: (value, bw)=>{
        bw.writeFloat64Array(value);
    },
    read: (br)=>{
        return br.readFloat64Array();
    },
    byteSize: $57b14fd439a7e437$var$count8ByteArray,
    compare: $57b14fd439a7e437$var$compareTypedArray
});
$57b14fd439a7e437$var$declareBinaryType($ge3xl.Binary.Boolean, {
    write: (value, bw)=>{
        bw.writeUInt8(value);
    },
    read: (br)=>{
        return 1 === br.readUInt8();
    },
    byteSize: ()=>{
        return 1;
    },
    compare: (a, b)=>{
        return a === b;
    }
});
$57b14fd439a7e437$var$declareBinaryType($ge3xl.Binary.Vector2, {
    write: (value, bw)=>{
        const { x: x, y: y } = value;
        bw.writeFloat64(x);
        bw.writeFloat64(y);
    },
    read: (br)=>{
        const x = br.readFloat64();
        const y = br.readFloat64();
        return {
            x: x,
            y: y
        };
    },
    byteSize: (value)=>{
        return 16; // that's 2 float64s worth of bytes
    },
    compare (a, b) {
        return a.x === b.x && a.y === b.y;
    },
    interp: (a, b, t)=>{
        return {
            x: $57b14fd439a7e437$var$lerp(a.x, b.x, t),
            y: $57b14fd439a7e437$var$lerp(a.y, b.y, t)
        };
    },
    clone: (value)=>{
        const { x: x, y: y } = value;
        return {
            x: x,
            y: y
        };
    }
});
$57b14fd439a7e437$var$declareBinaryType($ge3xl.Binary.Vector3, {
    write: (value, bw)=>{
        const { x: x, y: y, z: z } = value;
        bw.writeFloat64(x);
        bw.writeFloat64(y);
        bw.writeFloat64(z);
    },
    read: (br)=>{
        const x = br.readFloat64();
        const y = br.readFloat64();
        const z = br.readFloat64();
        return {
            x: x,
            y: y,
            z: z
        };
    },
    byteSize: (value)=>{
        return 24; // that's 3 float64s worth of bytes
    },
    compare (a, b) {
        return a.x === b.x && a.y === b.y && a.z === b.z;
    },
    interp: (a, b, t)=>{
        return {
            x: $57b14fd439a7e437$var$lerp(a.x, b.x, t),
            y: $57b14fd439a7e437$var$lerp(a.y, b.y, t),
            z: $57b14fd439a7e437$var$lerp(a.z, b.z, t)
        };
    },
    clone: (value)=>{
        const { x: x, y: y, z: z } = value;
        return {
            x: x,
            y: y,
            z: z
        };
    }
});
$57b14fd439a7e437$var$declareBinaryType($ge3xl.Binary.Vector4, {
    write: (value, bw)=>{
        const { x: x, y: y, z: z, w: w } = value;
        bw.writeFloat64(x);
        bw.writeFloat64(y);
        bw.writeFloat64(z);
        bw.writeFloat64(w);
    },
    read: (br)=>{
        const x = br.readFloat64();
        const y = br.readFloat64();
        const z = br.readFloat64();
        const w = br.readFloat64();
        return {
            x: x,
            y: y,
            z: z,
            w: w
        };
    },
    byteSize: (value)=>{
        return 32; // that's 4 float64s worth of bytes
    },
    compare (a, b) {
        return a.x === b.x && a.y === b.y && a.z === b.z && a.w === b.w;
    },
    interp: (a, b, t)=>{
        return {
            x: $57b14fd439a7e437$var$lerp(a.x, b.x, t),
            y: $57b14fd439a7e437$var$lerp(a.y, b.y, t),
            z: $57b14fd439a7e437$var$lerp(a.z, b.z, t),
            w: $57b14fd439a7e437$var$lerp(a.w, b.w, t)
        };
    },
    clone: (value)=>{
        const { x: x, y: y, z: z, w: w } = value;
        return {
            x: x,
            y: y,
            z: z,
            w: w
        };
    }
});
function $57b14fd439a7e437$var$normalizeQuat(a) {
    let l = Math.sqrt(a.x * a.x + a.y * a.y + a.z * a.z + a.w * a.w);
    if (l === 0) {
        a.x = 0;
        a.y = 0;
        a.z = 0;
        a.w = 1;
    } else {
        l = 1 / l;
        a.x = a.x * l;
        a.y = a.y * l;
        a.z = a.z * l;
        a.w = a.w * l;
    }
}
function $57b14fd439a7e437$var$quatSlerp(a, b, t) {
    const out = {
        x: 0,
        y: 0,
        z: 0,
        w: 0
    };
    if (t === 0) {
        Object.assign(out, a);
        return out;
    }
    if (t === 0) {
        Object.assign(out, b);
        return out;
    }
    const { x: x, y: y, z: z, w: w } = a;
    // based off three.js quat slerp which cites this:
    // http://www.euclideanspace.com/maths/algebra/realNormedAlgebra/quaternions/slerp/
    let cosHalfTheta = w * b.w + x * b.x + y * b.y + z * b.z;
    if (cosHalfTheta < 0) {
        out.w = -b.w;
        out.x = -b.x;
        out.y = -b.y;
        out.z = -b.z;
        cosHalfTheta = -cosHalfTheta;
    } else return {
        x: b.x,
        y: b.y,
        z: b.z,
        w: b.w
    };
    if (cosHalfTheta >= 1.0) {
        out.w = w;
        out.x = x;
        out.y = y;
        out.z = z;
        return out;
    }
    const sqrSinHalfTheta = 1.0 - cosHalfTheta * cosHalfTheta;
    if (sqrSinHalfTheta <= Number.EPSILON) {
        const s = 1 - t;
        out.w = s * w + t * a.w;
        out.x = s * x + t * a.x;
        out.y = s * y + t * a.y;
        out.z = s * z + t * a.z;
        $57b14fd439a7e437$var$normalizeQuat(out);
        return out;
    }
    const sinHalfTheta = Math.sqrt(sqrSinHalfTheta);
    const halfTheta = Math.atan2(sinHalfTheta, cosHalfTheta);
    const ratioA = Math.sin((1 - t) * halfTheta) / sinHalfTheta;
    const ratioB = Math.sin(t * halfTheta) / sinHalfTheta;
    out.w = w * ratioA + a.w * ratioB;
    out.x = x * ratioA + a.x * ratioB;
    out.y = y * ratioA + a.y * ratioB;
    out.z = z * ratioA + a.z * ratioB;
    return out;
}
$57b14fd439a7e437$var$declareBinaryType($ge3xl.Binary.Quaternion, {
    write: (value, bw)=>{
        const { x: x, y: y, z: z, w: w } = value;
        bw.writeFloat64(x);
        bw.writeFloat64(y);
        bw.writeFloat64(z);
        bw.writeFloat64(w);
    },
    read: (br)=>{
        const x = br.readFloat64();
        const y = br.readFloat64();
        const z = br.readFloat64();
        const w = br.readFloat64();
        return {
            x: x,
            y: y,
            z: z,
            w: w
        };
    },
    byteSize: (value)=>{
        return 32; // that's 4 float64s worth of bytes
    },
    compare (a, b) {
        return a.x === b.x && a.y === b.y && a.z === b.z && a.w === b.w;
    },
    interp: $57b14fd439a7e437$var$quatSlerp,
    clone: (value)=>{
        const { x: x, y: y, z: z, w: w } = value;
        return {
            x: x,
            y: y,
            z: z,
            w: w
        };
    }
});
const $57b14fd439a7e437$var$binaryGet = function(binaryType) {
    const b = $57b14fd439a7e437$var$data.get(binaryType);
    if (!b) throw new Error("Unknown binaryType used.");
    return b;
};
module.exports.binaryGet = $57b14fd439a7e437$var$binaryGet;

});
parcelRequire.register("ge3xl", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Binary = void 0;
var $bd00b27c24b38408$var$Binary;
(function(Binary) {
    Binary[Binary["UInt8"] = 1] = "UInt8";
    Binary[Binary["Int8"] = 2] = "Int8";
    Binary[Binary["UInt16"] = 3] = "UInt16";
    Binary[Binary["Int16"] = 4] = "Int16";
    Binary[Binary["UInt32"] = 5] = "UInt32";
    Binary[Binary["Int32"] = 6] = "Int32";
    Binary[Binary["Float32"] = 7] = "Float32";
    Binary[Binary["Float64"] = 8] = "Float64";
    Binary[Binary["Boolean"] = 9] = "Boolean";
    Binary[Binary["String"] = 10] = "String";
    Binary[Binary["UInt8Array"] = 11] = "UInt8Array";
    Binary[Binary["Int8Array"] = 12] = "Int8Array";
    Binary[Binary["UInt16Array"] = 13] = "UInt16Array";
    Binary[Binary["Int16Array"] = 14] = "Int16Array";
    Binary[Binary["UInt32Array"] = 15] = "UInt32Array";
    Binary[Binary["Int32Array"] = 16] = "Int32Array";
    Binary[Binary["Float32Array"] = 17] = "Float32Array";
    Binary[Binary["Float64Array"] = 18] = "Float64Array";
    Binary[Binary["Vector2"] = 19] = "Vector2";
    Binary[Binary["Vector3"] = 20] = "Vector3";
    Binary[Binary["Vector4"] = 21] = "Vector4";
    Binary[Binary["Quaternion"] = 22] = "Quaternion";
    Binary[Binary["Rotation"] = 23] = "Rotation";
    //Rotation8,
    Binary[Binary["Rotation32"] = 24] = "Rotation32";
    Binary[Binary["LAST_INDEX"] = 25] = "LAST_INDEX";
})($bd00b27c24b38408$var$Binary || (module.exports.Binary = $bd00b27c24b38408$var$Binary = {}));

});



parcelRequire.register("4WUmv", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $7wMIx = parcelRequire("7wMIx");
function $39a84c83fc2a8e53$var$readMessage(reader, context) {
    const ntype = reader.readUInt8();
    const nschema = context.getSchema(ntype);
    const obj = {
        ntype: ntype
    };
    for(let i = 1; i < nschema.keys.length; i++){
        const propData = nschema.keys[i];
        const binaryUtil = (0, $7wMIx.binaryGet)(propData.type);
        // @ts-ignore
        obj[propData.prop] = binaryUtil.post(binaryUtil.read(reader));
    }
    return obj;
}
module.exports.default = $39a84c83fc2a8e53$var$readMessage;

});


parcelRequire.register("aEL5o", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.EntityCache = void 0;

var $7wMIx = parcelRequire("7wMIx");
function $7c222a2014ee7f71$var$diff(entity, cache, nschema) {
    if (!cache) {
        console.log("no cache");
        return [];
    }
    const diffs = [];
    for(let i = 0; i < nschema.keys.length; i++){
        const { prop: prop, type: type } = nschema.keys[i];
        const oldValue = cache[prop];
        const value = entity[prop];
        const binaryUtil = (0, $7wMIx.binaryGet)(type);
        if (!binaryUtil.compare(oldValue, value)) {
            diffs.push({
                nid: entity.nid,
                nschema: nschema,
                prop: prop,
                value: value
            });
            cache[prop] = binaryUtil.clone(value);
        }
    }
    return diffs;
}
class $7c222a2014ee7f71$var$EntityCache {
    cacheContains(nid) {
        return !!this.cache[nid];
    }
    createCachesForTick(tick) {
        //this.cache[tick] = {}
        this.diffCache[tick] = {};
        this.binaryDiffCache[tick] = {};
    }
    deleteCachesForTick(tick) {
        //delete this.cache[tick]
        delete this.diffCache[tick];
        delete this.binaryDiffCache[tick];
    }
    getAndDiff(tick, entity, nschema) {
        if (this.diffCache[tick][entity.nid]) return this.diffCache[tick][entity.nid];
        else {
            const cacheObject = this.cache[entity.nid];
            const diffs = $7c222a2014ee7f71$var$diff(entity, cacheObject, nschema);
            this.diffCache[tick][entity.nid] = diffs;
            return diffs;
        }
    }
    cacheify(tick, entity, schema) {
        const cacheObject = {};
        for(let i = 0; i < schema.keys.length; i++){
            const propData = schema.keys[i];
            const value = entity[propData.prop];
            const binaryUtil = (0, $7wMIx.binaryGet)(propData.type);
            // @ts-ignore
            cacheObject[propData.prop] = binaryUtil.clone(value);
        }
        this.cache[entity.nid] = cacheObject;
    }
    updateCache(tick, entity, schema) {
        const cacheObject = this.cache[entity.nid];
        for(let i = 0; i < schema.keys.length; i++){
            const propData = schema.keys[i];
            const value = entity[propData.prop];
            const binaryUtil = (0, $7wMIx.binaryGet)(propData.type);
            // @ts-ignore
            cacheObject[propData.prop] = binaryUtil.clone(value);
        }
    }
    constructor(){
        this.cache = {};
        this.diffCache = {};
        this.binaryDiffCache = {};
    }
}
module.exports.EntityCache = $7c222a2014ee7f71$var$EntityCache;

});

parcelRequire.register("3wY3y", function(module, exports) {
"use strict";
var $2922f22cf148a65f$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

const $2922f22cf148a65f$var$count_1 = $2922f22cf148a65f$var$__importDefault((parcelRequire("3ZGQ8")));

const $2922f22cf148a65f$var$countDiff_1 = $2922f22cf148a65f$var$__importDefault((parcelRequire("gDnWD")));

var $3tshL = parcelRequire("3tshL");

var $iWOZU = parcelRequire("iWOZU");

const $2922f22cf148a65f$var$writeDiff_1 = $2922f22cf148a65f$var$__importDefault((parcelRequire("8cOIh")));

var $7wMIx = parcelRequire("7wMIx");

var $ge3xl = parcelRequire("ge3xl");
const $2922f22cf148a65f$var$getVisibleState = (user, instance)=>{
    const vis = user.checkVisibility(instance.tick);
    const createEntities = [];
    for(let i = 0; i < vis.newlyVisible.length; i++){
        const nid = vis.newlyVisible[i];
        const entity = instance.localState.getByNid(nid);
        const nschema = instance.context.getSchema(entity.ntype);
        if (nschema) {
            if (!instance.cache.cacheContains(nid)) instance.cache.cacheify(instance.tick, entity, nschema);
            createEntities.push(entity);
        } else throw new Error(`Entity [nid ${nid}] [ntype ${entity.ntype}] is missing a network schema.`);
    }
    const engineMessages = user.engineMessageQueue;
    user.engineMessageQueue = [];
    const messages = user.messageQueue;
    // empty the queue
    user.messageQueue = [];
    const deleteEntities = vis.noLongerVisible;
    const updateEntities = [];
    for(let i = 0; i < vis.stillVisible.length; i++){
        const nid = vis.stillVisible[i];
        const entity = instance.localState.getByNid(nid);
        const nschema = instance.context.getSchema(entity.ntype);
        if (nschema) {
            const diffs = instance.cache.getAndDiff(instance.tick, entity, nschema);
            diffs.forEach((diff)=>{
                updateEntities.push(diff);
            });
        }
    }
    return {
        createEntities: createEntities,
        updateEntities: updateEntities,
        deleteEntities: deleteEntities,
        messages: messages,
        engineMessages: engineMessages
    };
};
const $2922f22cf148a65f$var$createSnapshotBufferRefactor = (user, instance)=>{
    let bytes = 0;
    const { createEntities: createEntities, updateEntities: updateEntities, deleteEntities: deleteEntities, messages: messages, engineMessages: engineMessages } = $2922f22cf148a65f$var$getVisibleState(user, instance);
    if (engineMessages.length > 0) {
        bytes += 1; // section BinarySection.EngineMessages
        bytes += 1; // quantity of engine messages
        for(let i = 0; i < engineMessages.length; i++){
            const engineMessage = engineMessages[i];
            const nschema = instance.context.getEngineSchema(engineMessage.ntype);
            bytes += (0, $2922f22cf148a65f$var$count_1.default)(nschema, engineMessage);
        }
    }
    if (messages.length > 0) {
        bytes += 1; // section BinarySection.Messages
        bytes += 4; // quantity of messages
        for(let i = 0; i < messages.length; i++){
            const message = messages[i];
            const nschema = instance.context.getSchema(message.ntype);
            bytes += (0, $2922f22cf148a65f$var$count_1.default)(nschema, message);
        }
    }
    if (user.responseQueue.length > 0) {
        bytes += 1;
        bytes += 4;
        for(let i = 0; i < user.responseQueue.length; i++){
            bytes += 4; // requestId
            // @ts-ignore
            bytes += (0, $7wMIx.binaryGet)($ge3xl.Binary.String).byteSize(user.responseQueue[i].response);
        }
    }
    if (createEntities.length > 0) {
        // section create
        bytes += 1;
        bytes += 4;
        for(let i = 0; i < createEntities.length; i++){
            const nid = createEntities[i].nid;
            const entity = instance.localState.getByNid(nid);
            const nschema = instance.context.getSchema(entity.ntype);
            bytes += (0, $2922f22cf148a65f$var$count_1.default)(nschema, entity);
        }
    }
    if (updateEntities.length > 0) {
        // section update
        bytes += 1;
        bytes += 4;
        for(let i = 0; i < updateEntities.length; i++){
            const diff = updateEntities[i];
            bytes += (0, $2922f22cf148a65f$var$countDiff_1.default)(diff, diff.nschema);
        }
    }
    if (deleteEntities.length > 0) {
        bytes += 1; // delete entities
        bytes += 4; // quantity of entities to delete
        for(let i = 0; i < deleteEntities.length; i++)bytes += 4;
    }
    const bw = user.networkAdapter.createBufferWriter(bytes);
    if (engineMessages.length > 0) {
        bw.writeUInt8($3tshL.BinarySection.EngineMessages);
        bw.writeUInt8(engineMessages.length);
        for(let i = 0; i < engineMessages.length; i++){
            const engineMessage = engineMessages[i];
            const nschema = instance.context.getEngineSchema(engineMessage.ntype);
            (0, $iWOZU.writeMessage)(engineMessage, nschema, bw);
        }
    }
    if (messages.length > 0) {
        bw.writeUInt8($3tshL.BinarySection.Messages);
        bw.writeUInt32(messages.length);
        for(let i = 0; i < messages.length; i++){
            const message = messages[i];
            const nschema = instance.context.getSchema(message.ntype);
            (0, $iWOZU.writeMessage)(message, nschema, bw);
        }
    }
    if (user.responseQueue.length > 0) {
        bw.writeUInt8($3tshL.BinarySection.Responses);
        bw.writeUInt32(user.responseQueue.length);
        for(let i = 0; i < user.responseQueue.length; i++){
            bw.writeUInt32(user.responseQueue[i].requestId);
            bw.writeString(user.responseQueue[i].response);
        }
    }
    if (createEntities.length > 0) {
        bw.writeUInt8($3tshL.BinarySection.CreateEntities);
        bw.writeUInt32(createEntities.length);
        for(let i = 0; i < createEntities.length; i++){
            const entity = createEntities[i];
            const nschema = instance.context.getSchema(entity.ntype);
            (0, $iWOZU.writeMessage)(entity, nschema, bw);
        }
    }
    if (updateEntities.length > 0) {
        bw.writeUInt8($3tshL.BinarySection.UpdateEntities);
        bw.writeUInt32(updateEntities.length);
        for(let i = 0; i < updateEntities.length; i++){
            const diff = updateEntities[i];
            (0, $2922f22cf148a65f$var$writeDiff_1.default)(diff.nid, diff, diff.nschema, bw);
        }
    }
    if (deleteEntities.length > 0) {
        bw.writeUInt8($3tshL.BinarySection.DeleteEntities);
        bw.writeUInt32(deleteEntities.length);
        for(let i = 0; i < deleteEntities.length; i++)bw.writeUInt32(deleteEntities[i]);
    }
    user.responseQueue = [];
    return bw.buffer;
};
module.exports.default = $2922f22cf148a65f$var$createSnapshotBufferRefactor;

});
parcelRequire.register("3ZGQ8", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $7wMIx = parcelRequire("7wMIx");
function $2e884cb2f32dd9aa$var$count(schema, entity) {
    let bytes = 0;
    schema.keys.forEach((propData)=>{
        const spec = (0, $7wMIx.binaryGet)(propData.type);
        // @ts-ignore
        bytes += spec.byteSize(entity[propData.prop]);
    });
    return bytes;
}
module.exports.default = $2e884cb2f32dd9aa$var$count;

});

parcelRequire.register("gDnWD", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $7wMIx = parcelRequire("7wMIx");
function $c1c2dcc890384a34$var$countDiff(diff, nschema) {
    let bytes = 0;
    // add id, prop, value
    bytes += 5;
    const prop = diff.prop;
    const propData = nschema.props[prop];
    bytes += (0, $7wMIx.binaryGet)(propData.type).byteSize(diff.value);
    return bytes;
}
module.exports.default = $c1c2dcc890384a34$var$countDiff;

});

parcelRequire.register("iWOZU", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.writeMessage = void 0;

var $7wMIx = parcelRequire("7wMIx");
function $dcb533d2022c4820$var$writeMessage(obj, nschema, bufferWriter) {
    for(let i = 0; i < nschema.keys.length; i++){
        const propData = nschema.keys[i];
        const binaryUtil = (0, $7wMIx.binaryGet)(propData.type);
        const value = obj[propData.prop];
        binaryUtil.write(value, bufferWriter);
    }
}
module.exports.writeMessage = $dcb533d2022c4820$var$writeMessage;

});

parcelRequire.register("8cOIh", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $7wMIx = parcelRequire("7wMIx");
function $5f96c84c112fbd3a$var$writeDiff(nid, diff, nschema, bufferWriter) {
    const propData = nschema.props[diff.prop];
    const binaryUtil = (0, $7wMIx.binaryGet)(propData.type);
    bufferWriter.writeUInt32(nid);
    bufferWriter.writeUInt8(propData.key);
    binaryUtil.write(diff.value, bufferWriter);
}
module.exports.default = $5f96c84c112fbd3a$var$writeDiff;

});


parcelRequire.register("jekUI", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.NQueue = void 0;
class $dfff8c264e998055$var$NQueue {
    isEmpty() {
        return this.arr.length === 0;
    }
    enqueue(item) {
        this.arr.unshift(item);
    }
    dequeue() {
        return this.arr.pop();
    }
    peekNext() {
        return this.arr[this.arr.length - 1];
    }
    get length() {
        return this.arr.length;
    }
    next() {
        return this.dequeue();
    }
    constructor(){
        this.arr = [];
    }
}
module.exports.NQueue = $dfff8c264e998055$var$NQueue;

});


parcelRequire.register("fbAZ5", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRequire.register("9hiqW", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRequire.register("72WIA", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.AABB2D = void 0;
class $5216448074c758a1$var$AABB2D {
    constructor(x, y, halfWidth, halfHeight){
        this.x = x;
        this.y = y;
        this.halfWidth = halfWidth;
        this.halfHeight = halfHeight;
    }
}
module.exports.AABB2D = $5216448074c758a1$var$AABB2D;

});

parcelRequire.register("5gKD3", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.AABB3D = void 0;
class $3d629de6c514201b$var$AABB3D {
    constructor(x, y, z, halfWidth, halfHeight, halfDepth){
        this.x = x;
        this.y = y;
        this.z = z;
        this.halfWidth = halfWidth;
        this.halfHeight = halfHeight;
        this.halfDepth = halfDepth;
    }
}
module.exports.AABB3D = $3d629de6c514201b$var$AABB3D;

});

parcelRequire.register("e5VTd", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Channel = void 0;

var $lyGu1 = parcelRequire("lyGu1");
class $a42e6ff921b6d92d$var$Channel {
    addEntity(entity) {
        this.localState.registerEntity(entity, this.id);
        this.entities.add(entity);
        return entity;
    }
    removeEntity(entity) {
        this.entities.remove(entity);
        this.localState.unregisterEntity(entity, this.id);
    }
    addMessage(message) {
        this.users.forEach((user)=>user.queueMessage(message));
    }
    subscribe(user) {
        this.users.set(user.id, user);
        user.subscribe(this);
        this.onSubscribe(user, this);
    }
    unsubscribe(user) {
        this.onUnsubscribe(user, this);
        this.users.delete(user.id);
        user.unsubscribe(this);
    }
    getVisibileEntities(userId) {
        const visibleNids = [];
        this.entities.forEach((entity)=>{
            visibleNids.push(entity.nid);
        });
        return visibleNids;
    }
    destroy() {
        this.users.forEach((user)=>this.unsubscribe(user));
        this.entities.forEachReverse((entity)=>this.removeEntity(entity));
    }
    constructor(localState){
        this.id = 0;
        this.localState = localState;
        this.entities = new $lyGu1.EDictionary();
        this.users = new Map();
        this.onSubscribe = (user, channel)=>{};
        this.onUnsubscribe = (user, channel)=>{};
    }
}
module.exports.Channel = $a42e6ff921b6d92d$var$Channel;

});

parcelRequire.register("9j9Dt", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ChannelAABB2D = void 0;

var $7O0yc = parcelRequire("7O0yc");
const $6c6d5cd6f07d6553$var$pointInAABB2D = (p, view)=>{
    const startX = view.x - view.halfWidth;
    const startY = view.y - view.halfHeight;
    const endX = view.x + view.halfWidth;
    const endY = view.y + view.halfHeight;
    return p.x >= startX && p.x < endX && p.y >= startY && p.y < endY;
};
class $6c6d5cd6f07d6553$var$ChannelAABB2D extends $7O0yc.CulledChannel {
    constructor(localState){
        super(localState);
        this.visibilityResolver = $6c6d5cd6f07d6553$var$pointInAABB2D;
    }
}
module.exports.ChannelAABB2D = $6c6d5cd6f07d6553$var$ChannelAABB2D;

});
parcelRequire.register("7O0yc", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CulledChannel = void 0;

var $lyGu1 = parcelRequire("lyGu1");
class $5aeda1410a0cb348$var$CulledChannel {
    addEntity(entity) {
        this.localState.registerEntity(entity, this.id);
        this.entities.add(entity);
        return entity;
    }
    removeEntity(entity) {
        this.entities.remove(entity);
        this.localState.unregisterEntity(entity, this.id);
    }
    addMessage(message) {
        this.users.forEach((user)=>{
            if (this.visibilityResolver(message, this.views.get(user.id))) user.queueMessage(message);
        });
    }
    subscribe(user, view) {
        this.users.set(user.id, user);
        this.views.set(user.id, view);
        user.subscribe(this);
        this.onSubscribe(user, this);
    }
    unsubscribe(user) {
        this.onUnsubscribe(user, this);
        this.users.delete(user.id);
        this.views.delete(user.id);
        user.unsubscribe(this);
    }
    getVisibileEntities(userId) {
        const view = this.views.get(userId);
        const visibleNids = [];
        this.entities.forEach((entity)=>{
            if (this.visibilityResolver(entity, view)) visibleNids.push(entity.nid);
        });
        return visibleNids;
    }
    destroy() {
        this.users.forEach((user)=>this.unsubscribe(user));
        this.entities.forEach((entity)=>this.removeEntity(entity));
    }
    constructor(localState){
        this.id = 0;
        this.localState = localState;
        this.entities = new $lyGu1.EDictionary();
        this.users = new Map();
        this.views = new Map();
        this.onSubscribe = (user, channel)=>{};
        this.onUnsubscribe = (user, channel)=>{};
        this.visibilityResolver = (object, view)=>{
            return true;
        };
    }
}
module.exports.CulledChannel = $5aeda1410a0cb348$var$CulledChannel;

});


parcelRequire.register("6J9tY", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ChannelAABB3D = void 0;

var $7O0yc = parcelRequire("7O0yc");
const $4e5e4d11b6c96407$var$pointInAABB3D = (p, view)=>{
    const startX = view.x - view.halfWidth;
    const startY = view.y - view.halfHeight;
    const startZ = view.z - view.halfDepth;
    const endX = view.x + view.halfWidth;
    const endY = view.y + view.halfHeight;
    const endZ = view.z + view.halfDepth;
    return p.x >= startX && p.x < endX && p.y >= startY && p.y < endY && p.z >= startZ && p.z < endZ;
};
class $4e5e4d11b6c96407$var$ChannelAABB3D extends $7O0yc.CulledChannel {
    constructor(localState){
        super(localState);
        this.visibilityResolver = $4e5e4d11b6c96407$var$pointInAABB3D;
    }
}
module.exports.ChannelAABB3D = $4e5e4d11b6c96407$var$ChannelAABB3D;

});

parcelRequire.register("blYCD", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.MockServerSocket = module.exports.MockClientSocket = module.exports.MockClientAdapter = module.exports.MockInstanceAdapter = void 0;

var $9E0Iw = parcelRequire("9E0Iw");

var $jekUI = parcelRequire("jekUI");
/**
 * Not a real network adapter, data is passed without using a real socket.
 * Used for mixing a server and client together in one application
 * such as for a single player mode or automated testing
 */ class $8440ae2f38ec9ea9$var$MockInstanceAdapter {
    listen(port, ready) {
        console.log("MockAdapter listen is fake! No need to invoke it.");
    }
    createMockConnect() {
        const socket = new $8440ae2f38ec9ea9$var$MockServerSocket(this.network);
        this.open(socket);
        return socket;
    }
    open(socket) {
        const user = new $9E0Iw.User(socket, this);
        socket.user = user;
        this.network.onOpen(user);
    }
    message(socket, message) {
        socket.user;
    }
    close(socket) {
        if (socket.user) this.network.onClose(socket.user);
    }
    disconnect(user, reason) {
        user.socket.end(1000, JSON.stringify(reason));
    }
    send(user, buffer) {
        user.socket.send(buffer, true);
    }
    createBuffer(lengthInBytes) {
        return new this.bufferCtor(lengthInBytes);
    }
    createBufferWriter(lengthInBytes) {
        return new this.binaryWriterCtor(this.createBuffer(lengthInBytes));
    }
    createBufferReader(buffer) {
        return new this.binaryReaderCtor(buffer);
    }
    constructor(network, config){
        this.network = network;
        this.serverSockets = [];
        if (!config || !config.bufferCtor || !config.binaryWriterCtor) throw new Error("MockAdapter requires a config.bufferCtor and config.binaryWriterCtor to be created.");
        this.bufferCtor = config.bufferCtor;
        this.binaryWriterCtor = config.binaryWriterCtor;
        this.binaryReaderCtor = config.binaryReaderCtor;
    }
}
module.exports.MockInstanceAdapter = $8440ae2f38ec9ea9$var$MockInstanceAdapter;
class $8440ae2f38ec9ea9$var$MockClientAdapter {
    createBuffer(lengthInBytes) {
        return new this.bufferCtor(lengthInBytes);
    }
    createBufferWriter(lengthInBytes) {
        return new this.binaryWriterCtor(this.createBuffer(lengthInBytes));
    }
    createBufferReader(buffer) {
        return new this.binaryReaderCtor(buffer);
    }
    onMessage(buffer) {
        const br = this.createBufferReader(buffer);
        this.network.readSnapshot(br);
    }
    connect(wsUrl, handshake) {
        return new Promise((resolve, reject)=>{
            resolve(true);
        });
    }
    flush() {}
    constructor(network, config){
        this.network = network;
        this.bufferCtor = config.bufferCtor;
        this.binaryWriterCtor = config.binaryWriterCtor;
        this.binaryReaderCtor = config.binaryReaderCtor;
    }
}
module.exports.MockClientAdapter = $8440ae2f38ec9ea9$var$MockClientAdapter;
var $8440ae2f38ec9ea9$var$MockSocketReadyState;
(function(MockSocketReadyState) {
    MockSocketReadyState[MockSocketReadyState["CONNECTING"] = 0] = "CONNECTING";
    MockSocketReadyState[MockSocketReadyState["OPEN"] = 1] = "OPEN";
    MockSocketReadyState[MockSocketReadyState["CLOSING"] = 2] = "CLOSING";
    MockSocketReadyState[MockSocketReadyState["CLOSED"] = 3] = "CLOSED";
})($8440ae2f38ec9ea9$var$MockSocketReadyState || ($8440ae2f38ec9ea9$var$MockSocketReadyState = {}));
class $8440ae2f38ec9ea9$var$MockServerSocket {
    end() {}
    receive(buffer) {
        //this.inboundQueue.enqueue(buffer)
        this.network.onMessage(this.user, buffer);
    }
    send(buffer) {
        if (this.clientSocket) this.clientSocket.receive(buffer);
    }
    constructor(network){
        this.inboundQueue = new $jekUI.NQueue();
        this.readyState = $8440ae2f38ec9ea9$var$MockSocketReadyState.CONNECTING;
        this.clientSocket = new $8440ae2f38ec9ea9$var$MockClientSocket(this);
        this.user = null;
        this.network = network;
        this.readyState = $8440ae2f38ec9ea9$var$MockSocketReadyState.OPEN;
    }
}
module.exports.MockServerSocket = $8440ae2f38ec9ea9$var$MockServerSocket;
class $8440ae2f38ec9ea9$var$MockClientSocket {
    close() {
        this.readyState = $8440ae2f38ec9ea9$var$MockSocketReadyState.CLOSED;
    }
    send(buffer) {
        this.serverSocket.receive(buffer);
    }
    receive(buffer) {
        this.inboundQueue.enqueue(buffer);
    }
    constructor(serverSocket){
        this.inboundQueue = new $jekUI.NQueue();
        this.readyState = $8440ae2f38ec9ea9$var$MockSocketReadyState.CONNECTING;
        this.serverSocket = serverSocket;
        this.readyState = $8440ae2f38ec9ea9$var$MockSocketReadyState.OPEN;
    }
}
module.exports.MockClientSocket = $8440ae2f38ec9ea9$var$MockClientSocket;

});

parcelRequire.register("2vKxR", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Client = void 0;

var $lsI87 = parcelRequire("lsI87");

var $fXcSp = parcelRequire("fXcSp");
class $1d4294e5bc40cb32$var$Client {
    connect(wsUrl, handshake) {
        return this.adapter.connect(wsUrl, handshake);
    }
    setDisconnectHandler(handler) {
        this.disconnectHandler = handler;
    }
    setWebsocketErrorHandler(handler) {
        this.websocketErrorHandler = handler;
    }
    flush() {
        this.adapter.flush();
        this.network.flush();
    }
    addCommand(command) {
        this.network.addCommand(command);
    }
    constructor(context, adapterCtor, serverTickRate){
        this.context = context;
        this.network = new $lsI87.ClientNetwork(this);
        this.adapter = new adapterCtor(this.network);
        this.serverTickRate = serverTickRate;
        this.predictor = new $fXcSp.Predictor();
        this.disconnectHandler = (reason, event)=>{
            console.log("Disconnected!", reason, event);
        };
        this.websocketErrorHandler = (event)=>{
            console.log("Websocket Error", event);
        };
    }
}
module.exports.Client = $1d4294e5bc40cb32$var$Client;

});
parcelRequire.register("lsI87", function(module, exports) {
"use strict";
var $f9fe71c69e0d42bb$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ClientNetwork = void 0;

var $jekUI = parcelRequire("jekUI");

var $iWOZU = parcelRequire("iWOZU");

var $3kxln = parcelRequire("3kxln");

const $f9fe71c69e0d42bb$var$readMessage_1 = $f9fe71c69e0d42bb$var$__importDefault((parcelRequire("4WUmv")));

const $f9fe71c69e0d42bb$var$readDiff_1 = $f9fe71c69e0d42bb$var$__importDefault((parcelRequire("7vJH1")));

var $9OrNZ = parcelRequire("9OrNZ");

var $3tshL = parcelRequire("3tshL");

const $f9fe71c69e0d42bb$var$count_1 = $f9fe71c69e0d42bb$var$__importDefault((parcelRequire("3ZGQ8")));

const $f9fe71c69e0d42bb$var$readEngineMessage_1 = $f9fe71c69e0d42bb$var$__importDefault((parcelRequire("glVlD")));

var $dgHMh = parcelRequire("dgHMh");

var $2ggFm = parcelRequire("2ggFm");

var $drDkt = parcelRequire("drDkt");
class $f9fe71c69e0d42bb$var$ClientNetwork {
    incrementClientTick() {
        this.clientTick++;
        if (this.clientTick > 65535) this.clientTick = 1;
    }
    addEngineCommand(command) {
        this.outbound.addEngineCommand(command);
    }
    addCommand(command) {
        this.outbound.addCommand(command);
    }
    flush() {
        this.outbound.flush();
    }
    request(endpoint, payload, callback) {
        const obj = {
            endpoint: endpoint,
            requestId: this.requestId++,
            body: JSON.stringify(payload),
            callback: callback
        };
        this.requestQueue.enqueue(obj);
        this.requests.set(obj.requestId, obj);
    }
    createHandshakeBuffer(handshake, binaryWriterCtor) {
        const handshakeMessage = {
            ntype: $9OrNZ.EngineMessage.ConnectionAttempt,
            handshake: JSON.stringify(handshake)
        };
        const handshakeByteLength = (0, $f9fe71c69e0d42bb$var$count_1.default)($3kxln.connectionAttemptSchema, handshakeMessage);
        // @ts-ignore
        const dw = binaryWriterCtor.create(handshakeByteLength + 2);
        dw.writeUInt8($3tshL.BinarySection.EngineMessages);
        dw.writeUInt8(1);
        (0, $iWOZU.writeMessage)(handshakeMessage, $3kxln.connectionAttemptSchema, dw);
        return dw.buffer;
    }
    createOutboundBuffer(binaryWriterCtor) {
        const tick = this.clientTick;
        this.addEngineCommand({
            ntype: $9OrNZ.EngineMessage.ClientTick,
            tick: tick
        });
        let bytes = 0;
        const isDebug = false;
        const debug = {};
        const { outboundEngineCommands: outboundEngineCommands, outboundCommands: outboundCommands } = this.outbound.getCurrentFrame();
        // count ENGINE COMMANDS
        if (outboundEngineCommands.length > 0) {
            bytes += 1; // commands!
            bytes += 1; // number of commands
            outboundEngineCommands.forEach((command)=>{
                bytes += (0, $f9fe71c69e0d42bb$var$count_1.default)(this.client.context.getEngineSchema(command.ntype), command);
            });
        }
        // count COMMANDS
        if (outboundCommands.length > 0) {
            bytes += 1; // commands!
            bytes += 1; // number of commands
            outboundCommands.forEach((command)=>{
                bytes += (0, $f9fe71c69e0d42bb$var$count_1.default)(this.client.context.getSchema(command.ntype), command);
            });
        }
        // count REQUESTS
        if (this.requestQueue.length > 0) {
            bytes += 1; // requests
            bytes += 1; // number of requests
            this.requestQueue.arr.forEach((request)=>{
                bytes += 12 + request.body.length;
            });
        }
        // @ts-ignore
        const dw = binaryWriterCtor.create(bytes);
        // write ENGINE COMMANDs
        if (outboundEngineCommands.length > 0) {
            dw.writeUInt8($3tshL.BinarySection.EngineMessages);
            dw.writeUInt8(outboundEngineCommands.length);
            outboundEngineCommands.forEach((command)=>{
                (0, $iWOZU.writeMessage)(command, this.client.context.getEngineSchema(command.ntype), dw);
            });
        }
        if (isDebug) {
            debug.engineCommands = [];
            outboundEngineCommands.forEach((command)=>{
                debug.engineCommands.push(command);
            });
        }
        // write COMMANDS
        if (outboundCommands.length > 0) {
            dw.writeUInt8($3tshL.BinarySection.Commands);
            dw.writeUInt8(outboundCommands.length);
            outboundCommands.forEach((command)=>{
                (0, $iWOZU.writeMessage)(command, this.client.context.getSchema(command.ntype), dw);
            });
        }
        if (isDebug) {
            debug.commands = [];
            outboundCommands.forEach((command)=>{
                debug.commands.push(command);
            });
        }
        // write REQUESTS
        if (this.requestQueue.length > 0) {
            dw.writeUInt8($3tshL.BinarySection.Requests);
            dw.writeUInt8(this.requestQueue.arr.length);
            this.requestQueue.arr.forEach((request)=>{
                dw.writeUInt32(request.requestId);
                dw.writeUInt32(request.endpoint);
                dw.writeString(request.body);
            });
            this.requestQueue.arr = [];
        }
        if (isDebug) {
            debug.tick = tick;
            console.log({
                debug: debug
            });
        }
        this.outbound.tick = tick;
        this.incrementClientTick();
        return dw.buffer;
    }
    readSnapshot(dr) {
        const snapshot = {
            timestamp: -1,
            confirmedClientTick: -1,
            messages: [],
            createEntities: [],
            updateEntities: [],
            deleteEntities: []
        };
        while(dr.offset < dr.byteLength){
            const section = dr.readUInt8();
            switch(section){
                case $3tshL.BinarySection.EngineMessages:
                    {
                        const count = dr.readUInt8();
                        for(let i = 0; i < count; i++){
                            const engineMessage = (0, $f9fe71c69e0d42bb$var$readEngineMessage_1.default)(dr, this.client.context);
                            if (engineMessage.ntype === $9OrNZ.EngineMessage.ConnectionTerminated) // @ts-ignore
                            this.onDisconnect(engineMessage.reason);
                            if (engineMessage.ntype === $9OrNZ.EngineMessage.TimeSync) // @ts-ignore
                            snapshot.timestamp = engineMessage.timestamp;
                            if (engineMessage.ntype === $9OrNZ.EngineMessage.ClientTick) // @ts-ignore
                            snapshot.confirmedClientTick = engineMessage.tick;
                            if (engineMessage.ntype === $9OrNZ.EngineMessage.Ping) {
                                this.addEngineCommand({
                                    ntype: $9OrNZ.EngineMessage.Pong
                                });
                                // @ts-ignore
                                this.latency = engineMessage.latency;
                            }
                        }
                        break;
                    }
                case $3tshL.BinarySection.Messages:
                    {
                        const count = dr.readUInt32();
                        for(let i = 0; i < count; i++){
                            const message = (0, $f9fe71c69e0d42bb$var$readMessage_1.default)(dr, this.client.context);
                            this.messages.push(message);
                        }
                        break;
                    }
                case $3tshL.BinarySection.Responses:
                    {
                        const count = dr.readUInt32();
                        for(let i = 0; i < count; i++){
                            const requestId = dr.readUInt32();
                            const response = dr.readString();
                            const request = this.requests.get(requestId);
                            if (request) {
                                request.callback(JSON.parse(response));
                                this.requests.delete(requestId);
                            }
                        }
                        break;
                    }
                case $3tshL.BinarySection.CreateEntities:
                    {
                        const count = dr.readUInt32();
                        for(let i = 0; i < count; i++){
                            //const entity = readEntity(dr, this.client.context)
                            const entity = (0, $f9fe71c69e0d42bb$var$readMessage_1.default)(dr, this.client.context);
                            this.entityNTypes.set(entity.nid, entity.ntype);
                            snapshot.createEntities.push(entity);
                        }
                        break;
                    }
                case $3tshL.BinarySection.UpdateEntities:
                    {
                        const count = dr.readUInt32();
                        for(let i = 0; i < count; i++){
                            const diff = (0, $f9fe71c69e0d42bb$var$readDiff_1.default)(dr, this.client.context, this.entityNTypes);
                            snapshot.updateEntities.push(diff);
                        }
                        break;
                    }
                case $3tshL.BinarySection.DeleteEntities:
                    {
                        const count = dr.readUInt32();
                        for(let i = 0; i < count; i++){
                            const nid = dr.readUInt32();
                            snapshot.deleteEntities.push(nid);
                            this.entityNTypes.delete(nid);
                        }
                        break;
                    }
                default:
                    console.log("hit unknown section while readding binary");
                    break;
            }
        }
        // client engine level state
        // timing
        if (snapshot.timestamp !== -1) this.client.network.chronus.register(snapshot.timestamp);
        else if (this.previousSnapshot) snapshot.timestamp = this.previousSnapshot.timestamp + 1000 / this.client.serverTickRate;
        // frame creation from snapshot and prediction
        const frame = new $drDkt.Frame(this.frameTick, snapshot, this.latestFrame);
        this.frameTick++;
        this.frames.push(frame);
        this.latestFrame = frame;
        const predictionErrorFrame = this.client.predictor.getErrors(frame);
        if (predictionErrorFrame.entities.size > 0) this.client.network.predictionErrorFrames.push(predictionErrorFrame);
        this.client.predictor.cleanUp(frame.confirmedClientTick);
        // commands/prediction
        this.outbound.confirmCommands(snapshot.confirmedClientTick);
        this.previousSnapshot = snapshot;
    }
    constructor(client){
        this.entityNTypes = new Map();
        this.frames = [];
        this.latestFrame = null;
        this.messages = [];
        this.predictionErrorFrames = [];
        this.outbound = new $2ggFm.Outbound();
        this.socket = null;
        this.requestId = 1;
        this.requestQueue = new $jekUI.NQueue();
        this.requests = new Map();
        this.clientTick = 1; // incremented each flush to the server
        this.previousSnapshot = null;
        this.chronus = new $dgHMh.Chronus();
        this.frameTick = 1; // incremented each frame that comes from server
        this.latency = 0;
        this.onDisconnect = (reason, event)=>{
            this.client.disconnectHandler(reason, event);
        };
        this.onSocketError = (event)=>{
            this.client.websocketErrorHandler(event);
        };
        this.client = client;
    }
}
module.exports.ClientNetwork = $f9fe71c69e0d42bb$var$ClientNetwork;

});
parcelRequire.register("3kxln", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.connectionAttemptSchema = void 0;

var $f1HWk = parcelRequire("f1HWk");

var $ge3xl = parcelRequire("ge3xl");
module.exports.connectionAttemptSchema = (0, $f1HWk.defineSchema)({
    handshake: $ge3xl.Binary.String
});

});
parcelRequire.register("f1HWk", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.defineSchema = void 0;

var $ge3xl = parcelRequire("ge3xl");

var $4yNKp = parcelRequire("4yNKp");
function $af09088a53f46eba$var$defineSchema(schema) {
    //console.log('parsing', schema)
    const compiled = new $4yNKp.Schema();
    let index = 0;
    {
        const prop = "ntype";
        const entry = {
            key: index,
            prop: prop,
            type: $ge3xl.Binary.UInt8,
            interp: false
        };
        compiled.keys.push(entry);
        compiled.props[prop] = entry;
        index++;
    }
    {
        const prop = "nid";
        const entry = {
            key: index,
            prop: prop,
            type: $ge3xl.Binary.UInt16,
            interp: false
        };
        compiled.keys.push(entry);
        compiled.props[prop] = entry;
        index++;
    }
    for(const prop in schema){
        if (prop === "nid") throw new Error("No need to define `nid` in a schema, this is added by default.");
        if (prop === "ntype") throw new Error("No need to define `ntype` in a schema, this is added by default.");
        // @ts-ignore
        if (schema[prop].type) {
            // probably the syntax x: { type: Binary.Float32, interp: true }
            // @ts-ignore
            const entry = {
                key: index,
                prop: prop,
                type: schema[prop].type,
                interp: schema[prop].interp
            };
            compiled.keys.push(entry);
            compiled.props[prop] = entry;
            index++;
        } else {
            // probably the syntax x: Binary.Float32
            const entry = {
                key: index,
                prop: prop,
                type: schema[prop],
                interp: false
            };
            compiled.keys.push(entry);
            compiled.props[prop] = entry;
            index++;
        }
    }
    return compiled;
}
module.exports.defineSchema = $af09088a53f46eba$var$defineSchema;

});
parcelRequire.register("4yNKp", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Schema = void 0;
class $3520ed330ca68ad5$var$Schema {
    constructor(){
        this.keys = [];
        this.props = {};
    }
}
module.exports.Schema = $3520ed330ca68ad5$var$Schema;

});



parcelRequire.register("7vJH1", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $7wMIx = parcelRequire("7wMIx");
function $577edf567dba8f40$var$readDiff(reader, context, ntypes /* <nid, ntype> */ ) {
    const nid = reader.readUInt32();
    const propKey = reader.readUInt8();
    const ntype = ntypes.get(nid);
    const nschema = context.getSchema(ntype);
    const propData = nschema.keys[propKey];
    const binaryUtil = (0, $7wMIx.binaryGet)(propData.type);
    const value = binaryUtil.read(reader);
    return {
        nid: nid,
        prop: propData.prop,
        value: value
    };
}
module.exports.default = $577edf567dba8f40$var$readDiff;

});

parcelRequire.register("dgHMh", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Chronus = void 0;
class $9a8eba50722d29e7$var$Chronus {
    register(timestamp) {
        this.timeDifferences.push(Date.now() - timestamp);
        while(this.timeDifferences.length > 20)this.timeDifferences.shift();
        let total = 0;
        for(let i = 0; i < this.timeDifferences.length; i++)total += this.timeDifferences[i];
        this.averageTimeDifference = total / this.timeDifferences.length;
    }
    constructor(){
        this.timeDifferences = [];
        this.averageTimeDifference = 0;
    }
}
module.exports.Chronus = $9a8eba50722d29e7$var$Chronus;

});

parcelRequire.register("2ggFm", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Outbound = void 0;
// used for the first frames, never has anything in it
const $1a5a00efe3944c71$var$emptyArr = [];
class $1a5a00efe3944c71$var$Outbound {
    getCurrentFrame() {
        const outboundEngineCommands = this.outboundEngineCommands.get(this.tick);
        const outboundCommands = this.outboundCommands.get(this.tick);
        return {
            outboundEngineCommands: outboundEngineCommands ? outboundEngineCommands : $1a5a00efe3944c71$var$emptyArr,
            outboundCommands: outboundCommands ? outboundCommands : $1a5a00efe3944c71$var$emptyArr
        };
    }
    addEngineCommand(command) {
        const tick = this.tick;
        if (this.outboundEngineCommands.has(tick)) this.outboundEngineCommands.get(tick).push(command);
        else this.outboundEngineCommands.set(tick, [
            command
        ]);
    }
    addCommand(command) {
        const tick = this.tick;
        if (this.outboundCommands.has(tick)) this.outboundCommands.get(tick).push(command);
        else this.outboundCommands.set(tick, [
            command
        ]);
        if (!this.unconfirmedCommands.has(tick)) this.unconfirmedCommands.set(tick, [
            command
        ]);
        else this.unconfirmedCommands.get(tick).push(command);
    }
    getEngineCommands(tick) {
        if (this.outboundEngineCommands.has(tick)) return this.outboundEngineCommands.get(tick);
        else return $1a5a00efe3944c71$var$emptyArr;
    }
    getCommands(tick) {
        if (this.outboundCommands.has(tick)) return this.outboundCommands.get(tick);
        else return $1a5a00efe3944c71$var$emptyArr;
    }
    confirmCommands(confirmedTick) {
        this.unconfirmedCommands.forEach((commandQueue, tick)=>{
            if (tick <= confirmedTick) this.unconfirmedCommands.delete(tick);
        });
        this.confirmedTick = confirmedTick;
    }
    getUnconfirmedCommands() {
        return this.unconfirmedCommands;
    }
    flush() {
        this.outboundEngineCommands.clear();
        this.outboundCommands.clear();
    }
    constructor(){
        this.unconfirmedCommands = new Map();
        this.outboundEngineCommands = new Map();
        this.outboundCommands = new Map();
        this.tick = 0;
        this.currentFrame = null;
        this.confirmedTick = -1;
        this.lastSentTick = -1;
    }
}
module.exports.Outbound = $1a5a00efe3944c71$var$Outbound;

});

parcelRequire.register("drDkt", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Frame = void 0;
class $9c9c4df1027d9869$var$Frame {
    constructor(tick, snapshot, previousFrame){
        this.processed = false; // whether create/deletes have been processed
        this.once = false; // whether this frame has been used for interpolation once
        this.entities = new Map();
        this.createEntities = [];
        this.updateEntities = [];
        this.deleteEntities = [];
        this.tick = tick;
        this.confirmedClientTick = snapshot.confirmedClientTick;
        this.timestamp = snapshot.timestamp;
        if (previousFrame) previousFrame.entities.forEach((entity)=>{
            const clone = Object.assign({}, entity);
            this.entities.set(clone.nid, clone);
        });
        snapshot.createEntities.forEach((entity)=>{
            const clone = Object.assign({}, entity);
            this.entities.set(clone.nid, clone);
            this.createEntities.push(clone);
        });
        snapshot.updateEntities.forEach((update)=>{
            const entity = this.entities.get(update.nid);
            entity[update.prop] = update.value;
            const clone = Object.assign({}, update);
            this.updateEntities.push(clone);
        });
        snapshot.deleteEntities.forEach((nid)=>{
            this.entities.delete(nid);
            this.deleteEntities.push(nid);
        });
    }
}
module.exports.Frame = $9c9c4df1027d9869$var$Frame;

});


parcelRequire.register("fXcSp", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Predictor = void 0;

var $kuD7j = parcelRequire("kuD7j");

var $cFZQu = parcelRequire("cFZQu");

var $7HJJW = parcelRequire("7HJJW");

var $3ax6T = parcelRequire("3ax6T");
const $b9d65abd43c55fd6$var$EPS = 0.0001;
const $b9d65abd43c55fd6$var$closeEnough = (value, EPSILON)=>{
    return value < EPSILON && value > -EPSILON;
};
class $b9d65abd43c55fd6$var$Predictor {
    cleanUp(tick) {
        this.predictionFrames.forEach((predictionFrame)=>{
            if (predictionFrame.tick < tick - 50) this.predictionFrames.delete(predictionFrame.tick);
        });
    }
    addCustom(tick, entity, props, nschema) {
        let predictionFrame = this.predictionFrames.get(tick);
        if (!predictionFrame) {
            predictionFrame = new $7HJJW.PredictionFrame(tick);
            this.predictionFrames.set(tick, predictionFrame);
        }
        const proxy = Object.assign({}, entity);
        predictionFrame.add(entity.nid, proxy, props, nschema);
    }
    add(tick, entity, props, nschema) {
        let predictionFrame = this.predictionFrames.get(tick);
        if (!predictionFrame) {
            predictionFrame = new $7HJJW.PredictionFrame(tick);
            this.predictionFrames.set(tick, predictionFrame);
        }
        const proxy = (0, $3ax6T.clone)(entity, nschema);
        predictionFrame.add(entity.nid, proxy, props, entity.protocol);
    }
    has(tick, nid, prop) {
        const predictionFrame = this.predictionFrames.get(tick);
        if (predictionFrame) {
            const entityPrediction = predictionFrame.entityPredictions.get(nid);
            if (entityPrediction) return entityPrediction.props.indexOf(prop) !== -1;
        }
        return false;
    }
    getErrors(frame) {
        const predictionErrorFrame = new $kuD7j.PredictionErrorFrame(frame.confirmedClientTick);
        if (frame) {
            // predictions for this frame
            const predictionFrame = this.predictionFrames.get(frame.confirmedClientTick);
            if (predictionFrame) predictionFrame.entityPredictions.forEach((entityPrediction)=>{
                // predictions for this entity
                const nid = entityPrediction.nid;
                const authoritative = frame.entities.get(nid);
                if (authoritative) entityPrediction.props.forEach((prop)=>{
                    const authValue = authoritative[prop];
                    const predValue = entityPrediction.proxy[prop];
                    const diff = authValue - predValue;
                    if (!$b9d65abd43c55fd6$var$closeEnough(diff, $b9d65abd43c55fd6$var$EPS)) predictionErrorFrame.add(nid, entityPrediction.proxy, new $cFZQu.PredictionErrorProperty(nid, prop, predValue, authValue));
                });
            });
        }
        this.latestTick = frame.confirmedClientTick;
        return predictionErrorFrame;
    }
    constructor(){
        this.predictionFrames = new Map();
        this.latestTick = -1;
    }
}
module.exports.Predictor = $b9d65abd43c55fd6$var$Predictor;

});
parcelRequire.register("kuD7j", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PredictionErrorFrame = void 0;

var $8Z8n9 = parcelRequire("8Z8n9");
class $eeb4f3cf6f5e6501$var$PredictionErrorFrame {
    add(nid, entity, predictionError) {
        let entityPredictionError = this.entities.get(nid);
        if (!entityPredictionError) {
            entityPredictionError = new $8Z8n9.PredictionErrorEntity(nid, entity);
            this.entities.set(nid, entityPredictionError);
        }
        entityPredictionError.add(predictionError);
    }
    constructor(tick){
        this.tick = tick;
        this.entities = new Map();
    }
}
module.exports.PredictionErrorFrame = $eeb4f3cf6f5e6501$var$PredictionErrorFrame;

});
parcelRequire.register("8Z8n9", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PredictionErrorEntity = void 0;
class $68aa83d23b4abf24$var$PredictionErrorEntity {
    add(predictionError) {
        this.errors.push(predictionError);
    }
    constructor(nid, entity){
        this.nid = nid;
        this.proxy = entity;
        this.errors = [];
    }
}
module.exports.PredictionErrorEntity = $68aa83d23b4abf24$var$PredictionErrorEntity;

});


parcelRequire.register("cFZQu", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PredictionErrorProperty = void 0;
class $93a9499af82d2281$var$PredictionErrorProperty {
    constructor(nid, prop, predictedValue, actualValue){
        this.nid = nid;
        this.prop = prop;
        this.predictedValue = predictedValue;
        this.actualValue = actualValue;
    }
}
module.exports.PredictionErrorProperty = $93a9499af82d2281$var$PredictionErrorProperty;

});

parcelRequire.register("7HJJW", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PredictionFrame = void 0;

var $5YfME = parcelRequire("5YfME");
class $017294c454ad9828$var$PredictionFrame {
    add(nid, entity, props, nschema) {
        //console.log('prediction created', this.tick, nid, entity, props)
        let entityPrediction = this.entityPredictions.get(nid);
        if (!entityPrediction) {
            entityPrediction = new $5YfME.PredictionEntity(nid, entity, props, nschema);
            this.entityPredictions.set(nid, entityPrediction);
        } else {
            entityPrediction.proxy = entity;
            entityPrediction.props = props;
        }
    }
    constructor(tick){
        this.tick = tick;
        this.entityPredictions = new Map();
    }
}
module.exports.PredictionFrame = $017294c454ad9828$var$PredictionFrame;

});
parcelRequire.register("5YfME", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PredictionEntity = void 0;
class $458eccae35a03beb$var$PredictionEntity {
    constructor(nid, entity, props, nschema){
        this.nid = nid;
        this.proxy = entity;
        this.props = props;
        this.nschema = nschema;
    }
}
module.exports.PredictionEntity = $458eccae35a03beb$var$PredictionEntity;

});


parcelRequire.register("3ax6T", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.clone = void 0;

var $7wMIx = parcelRequire("7wMIx");
const $24ebfd469103529c$var$clone = (entity, nschema)=>{
    const clonedObj = {};
    for(let i = 0; i < nschema.keys.length; i++){
        const propData = nschema.keys[i];
        const value = entity[propData.prop];
        const binaryUtil = (0, $7wMIx.binaryGet)(propData.type);
        // @ts-ignore
        clonedObj[propData.prop] = binaryUtil.clone(value);
    }
    return clonedObj;
};
module.exports.clone = $24ebfd469103529c$var$clone;

});



parcelRequire.register("Vm5ZV", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Interpolator = module.exports.findSubsequentFrame = module.exports.findInitialFrame = void 0;

var $7wMIx = parcelRequire("7wMIx");
const $0ac676bd3bdf2e21$var$findInitialFrame = (frames, renderTime)=>{
    for(let i = frames.length - 1; i >= 0; i--){
        const frame = frames[i];
        if (frame.timestamp < renderTime) return frame;
    }
    return null;
};
module.exports.findInitialFrame = $0ac676bd3bdf2e21$var$findInitialFrame;
const $0ac676bd3bdf2e21$var$findSubsequentFrame = (frames, previousTick)=>{
    for(let i = 0; i < frames.length; i++){
        if (frames[i].tick === previousTick + 1) return frames[i];
    }
    return null;
};
module.exports.findSubsequentFrame = $0ac676bd3bdf2e21$var$findSubsequentFrame;
class $0ac676bd3bdf2e21$var$Interpolator {
    getInterpolatedState(interpDelay) {
        const now = Date.now();
        const renderTime = now - interpDelay - this.client.network.chronus.averageTimeDifference;
        const frameA = (0, module.exports.findInitialFrame)(this.client.network.frames, renderTime);
        const frames = [];
        const tframes = this.client.network.frames;
        if (frameA) {
            const frameB = (0, module.exports.findSubsequentFrame)(tframes, frameA.tick);
            for(let i = tframes.length - 1; i > -1; i--){
                const lateFrame = tframes[i];
                if (lateFrame.tick < frameA.tick) {
                    if (!lateFrame.processed) {
                        frames.push(lateFrame);
                        lateFrame.processed = true;
                        tframes.splice(i, 1);
                        this.client.predictor.cleanUp(lateFrame.confirmedClientTick - 1);
                    } else tframes.splice(i, 1);
                }
            }
            frames.reverse();
            if (frameB && !frameB.processed) {
                const total = frameB.timestamp - frameA.timestamp;
                const portion = renderTime - frameA.timestamp;
                const interpAmount = portion / total;
                const interpState = {
                    createEntities: [],
                    updateEntities: [],
                    deleteEntities: []
                };
                if (!frameA.processed) {
                    interpState.createEntities = frameA.createEntities.slice();
                    interpState.deleteEntities = frameA.deleteEntities.slice();
                    frameA.processed = true;
                    this.client.predictor.cleanUp(frameA.confirmedClientTick - 1);
                }
                for(let i = 0; i < frameA.updateEntities.length; i++){
                    const { nid: nid, prop: prop, value: value } = frameA.updateEntities[i];
                    // if no update in frameB, then entity's correct state is update.value
                    // this represents the final state of interpolation, the frame after there is no longer a change
                    // and is how state arrives at the exact correct value
                    if (frameB.updateEntities.findIndex((x)=>x.nid === nid && x.prop === prop) === -1) {
                        const entityA = frameA.entities.get(nid);
                        const nschema = this.client.context.getSchema(entityA.ntype);
                        const binarySpec = nschema.props[prop];
                        if (binarySpec.interp) interpState.updateEntities.push({
                            nid: nid,
                            prop: prop,
                            value: value
                        });
                        else // we skip this final state of interpolation for non-interpolated values if they have
                        // already been emitted
                        if (!frameA.once) // does this ever actually happen...?
                        interpState.updateEntities.push({
                            nid: nid,
                            prop: prop,
                            value: value
                        });
                    }
                }
                for(let i = 0; i < frameB.updateEntities.length; i++){
                    const { nid: nid, prop: prop } = frameB.updateEntities[i];
                    const entityA = frameA.entities.get(nid);
                    const entityB = frameB.entities.get(nid);
                    if (entityA && entityB) {
                        const nschema = this.client.context.getSchema(entityA.ntype);
                        const binarySpec = nschema.props[prop];
                        const binaryUtil = (0, $7wMIx.binaryGet)(binarySpec.type);
                        if (binarySpec.interp) {
                            // interpolated
                            const valueA = entityA[prop];
                            const valueB = entityB[prop];
                            const value = binaryUtil.interp(valueA, valueB, interpAmount);
                            interpState.updateEntities.push({
                                nid: nid,
                                prop: prop,
                                value: value
                            });
                        } else if (!frameB.once) // not interpolated, !once prevents redundantly emission of the value which isn't going to change
                        // more than once between frameA to frameB
                        interpState.updateEntities.push({
                            nid: nid,
                            prop: prop,
                            value: entityB[prop]
                        });
                    }
                }
                frameB.once = true;
                frames.push(interpState);
            }
        }
        return frames;
    }
    constructor(client){
        this.client = client;
    }
}
module.exports.Interpolator = $0ac676bd3bdf2e21$var$Interpolator;

});

parcelRequire.register("gmcT5", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Context = void 0;

var $3kxln = parcelRequire("3kxln");

var $9OrNZ = parcelRequire("9OrNZ");

var $6UBpL = parcelRequire("6UBpL");

var $2zgnH = parcelRequire("2zgnH");

var $cBfwz = parcelRequire("cBfwz");

var $7Iwoa = parcelRequire("7Iwoa");

var $dHqVG = parcelRequire("dHqVG");

var $5Iji8 = parcelRequire("5Iji8");

var $2jI7j = parcelRequire("2jI7j");
class $be88b29acb98828c$var$Context {
    register(ntype, schema) {
        this.schemas.set(ntype, schema);
    }
    getSchema(ntype) {
        return this.schemas.get(ntype);
    }
    getEngineSchema(ntype) {
        return this.engineSchemas.get(ntype);
    }
    constructor(){
        this.schemas = new Map();
        this.engineSchemas = new Map();
        // setup the engine schemas
        this.engineSchemas.set($9OrNZ.EngineMessage.ConnectionAttempt, $3kxln.connectionAttemptSchema);
        this.engineSchemas.set($9OrNZ.EngineMessage.ConnectionAccepted, $6UBpL.connectionAcceptedSchema);
        this.engineSchemas.set($9OrNZ.EngineMessage.ConnectionDenied, $2zgnH.connectionDeniedSchema);
        this.engineSchemas.set($9OrNZ.EngineMessage.ConnectionTerminated, $cBfwz.connectionTerminatedSchema);
        this.engineSchemas.set($9OrNZ.EngineMessage.ClientTick, $7Iwoa.clientTickSchema);
        this.engineSchemas.set($9OrNZ.EngineMessage.TimeSync, $dHqVG.timeSyncSchema);
        this.engineSchemas.set($9OrNZ.EngineMessage.Ping, $5Iji8.pingSchema);
        this.engineSchemas.set($9OrNZ.EngineMessage.Pong, $2jI7j.pongSchema);
    }
}
module.exports.Context = $be88b29acb98828c$var$Context;

});
parcelRequire.register("6UBpL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.connectionAcceptedSchema = void 0;

var $f1HWk = parcelRequire("f1HWk");
module.exports.connectionAcceptedSchema = (0, $f1HWk.defineSchema)({
});

});

parcelRequire.register("2zgnH", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.connectionDeniedSchema = void 0;

var $f1HWk = parcelRequire("f1HWk");
module.exports.connectionDeniedSchema = (0, $f1HWk.defineSchema)({
});

});

parcelRequire.register("cBfwz", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.connectionTerminatedSchema = void 0;

var $f1HWk = parcelRequire("f1HWk");

var $ge3xl = parcelRequire("ge3xl");
module.exports.connectionTerminatedSchema = (0, $f1HWk.defineSchema)({
    reason: $ge3xl.Binary.String
});

});

parcelRequire.register("7Iwoa", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.clientTickSchema = void 0;

var $f1HWk = parcelRequire("f1HWk");

var $ge3xl = parcelRequire("ge3xl");
module.exports.clientTickSchema = (0, $f1HWk.defineSchema)({
    tick: $ge3xl.Binary.UInt16
});

});

parcelRequire.register("dHqVG", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.timeSyncSchema = void 0;

var $f1HWk = parcelRequire("f1HWk");

var $ge3xl = parcelRequire("ge3xl");
module.exports.timeSyncSchema = (0, $f1HWk.defineSchema)({
    timestamp: $ge3xl.Binary.Float64
});

});

parcelRequire.register("5Iji8", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.pingSchema = void 0;

var $f1HWk = parcelRequire("f1HWk");

var $ge3xl = parcelRequire("ge3xl");
module.exports.pingSchema = (0, $f1HWk.defineSchema)({
    latency: $ge3xl.Binary.UInt16
});

});

parcelRequire.register("2jI7j", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.pongSchema = void 0;

var $f1HWk = parcelRequire("f1HWk");
module.exports.pongSchema = (0, $f1HWk.defineSchema)({});

});


parcelRequire.register("GQZAf", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRequire.register("l99iw", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRequire.register("bEGTI", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRequire.register("h5KJq", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRequire.register("jbsAw", function(module, exports) {

var $eIyuj = parcelRequire("eIyuj");

var $6ZJKU = parcelRequire("6ZJKU");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */ var Buffer = moduleExports ? $eIyuj.Buffer : undefined;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;
/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */ var isBuffer = nativeIsBuffer || $6ZJKU;
module.exports = isBuffer;

});
parcelRequire.register("eIyuj", function(module, exports) {

var $8dSfE = parcelRequire("8dSfE");
/** Detect free variable `self`. */ var $ab6fed56429d18f0$var$freeSelf = typeof self == "object" && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $ab6fed56429d18f0$var$root = $8dSfE || $ab6fed56429d18f0$var$freeSelf || Function("return this")();
module.exports = $ab6fed56429d18f0$var$root;

});
parcelRequire.register("8dSfE", function(module, exports) {
/** Detect free variable `global` from Node.js. */ var $5fc99ed55a98eb8d$var$freeGlobal = typeof $parcel$global == "object" && $parcel$global && $parcel$global.Object === Object && $parcel$global;
module.exports = $5fc99ed55a98eb8d$var$freeGlobal;

});


parcelRequire.register("6ZJKU", function(module, exports) {
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */ function $517beeae29980602$var$stubFalse() {
    return false;
}
module.exports = $517beeae29980602$var$stubFalse;

});


parcelRequire.register("eWlaq", function(module, exports) {

var $8dSfE = parcelRequire("8dSfE");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && $8dSfE.process;
/** Used to access faster Node.js helpers. */ var nodeUtil = function() {
    try {
        // Use `util.types` for Node.js 10+.
        var types = freeModule && freeModule.require && freeModule.require("util").types;
        if (types) return types;
        // Legacy `process.binding('util')` for Node.js < 10.
        return freeProcess && freeProcess.binding && freeProcess.binding("util");
    } catch (e) {}
}();
module.exports = nodeUtil;

});

parcelRequire.register("dKAmY", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DataViewReader = void 0;
class $a02bc875cb171bb8$var$DataViewReader {
    get byteLength() {
        return this.view.buffer.byteLength;
    }
    readUInt8() {
        const value = this.view.getUint8(this.offset);
        this.offset += 1;
        return value;
    }
    readInt8() {
        const value = this.view.getInt8(this.offset);
        this.offset += 1;
        return value;
    }
    readUInt16() {
        const value = this.view.getUint16(this.offset);
        this.offset += 2;
        return value;
    }
    readInt16() {
        const value = this.view.getInt16(this.offset);
        this.offset += 2;
        return value;
    }
    readUInt32() {
        const value = this.view.getUint32(this.offset);
        this.offset += 4;
        return value;
    }
    readInt32() {
        const value = this.view.getInt32(this.offset);
        this.offset += 4;
        return value;
    }
    readFloat32() {
        const value = this.view.getFloat32(this.offset);
        this.offset += 4;
        return value;
    }
    readFloat64() {
        const value = this.view.getFloat64(this.offset);
        this.offset += 8;
        return value;
    }
    readString() {
        const length = this.readUInt32();
        const value = new TextDecoder().decode(this.view.buffer.slice(this.offset, this.offset + length));
        //const value = this.buffer.toString('utf8', this.offset, this.offset + length)
        this.offset += length;
        return value;
    }
    readUInt8Array() {
        const length = this.readUInt32();
        const arr = new Uint8Array(length);
        for(let i = 0; i < length; i++)arr[i] = this.readUInt8();
        return arr;
    }
    readInt8Array() {
        const length = this.readUInt32();
        const arr = new Int8Array(length);
        for(let i = 0; i < length; i++)arr[i] = this.readInt8();
        return arr;
    }
    readUInt16Array() {
        const length = this.readUInt32();
        const arr = new Uint16Array(length);
        for(let i = 0; i < length; i++)arr[i] = this.readUInt16();
        return arr;
    }
    readInt16Array() {
        const length = this.readUInt32();
        const arr = new Int16Array(length);
        for(let i = 0; i < length; i++)arr[i] = this.readInt16();
        return arr;
    }
    readUInt32Array() {
        const length = this.readUInt32();
        const arr = new Uint32Array(length);
        for(let i = 0; i < length; i++)arr[i] = this.readUInt32();
        return arr;
    }
    readInt32Array() {
        const length = this.readUInt32();
        const arr = new Int32Array(length);
        for(let i = 0; i < length; i++)arr[i] = this.readInt32();
        return arr;
    }
    readFloat32Array() {
        const length = this.readUInt32();
        const arr = new Float32Array(length);
        for(let i = 0; i < length; i++)arr[i] = this.readFloat32();
        return arr;
    }
    readFloat64Array() {
        const length = this.readUInt32();
        const arr = new Float64Array(length);
        for(let i = 0; i < length; i++)arr[i] = this.readFloat64();
        return arr;
    }
    constructor(arrayBuffer, offset){
        this.view = new DataView(arrayBuffer);
        this.offset = offset;
    }
}
module.exports.DataViewReader = $a02bc875cb171bb8$var$DataViewReader;

});

parcelRequire.register("4qPfg", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DataViewWriter = void 0;
class $33a15761961897a2$var$DataViewWriter {
    get buffer() {
        return this.view.buffer;
    }
    static create(byteLength) {
        return new $33a15761961897a2$var$DataViewWriter(new ArrayBuffer(byteLength));
    }
    writeUInt8(value) {
        this.view.setUint8(this.offset, value);
        this.offset += 1;
    }
    writeInt8(value) {
        this.view.setInt8(this.offset, value);
        this.offset += 1;
    }
    writeUInt16(value) {
        this.view.setUint16(this.offset, value);
        this.offset += 2;
    }
    writeInt16(value) {
        this.view.setInt16(this.offset, value);
        this.offset += 2;
    }
    writeUInt32(value) {
        this.view.setUint32(this.offset, value);
        this.offset += 4;
    }
    writeInt32(value) {
        this.view.setInt32(this.offset, value);
        this.offset += 4;
    }
    writeFloat32(value) {
        this.view.setFloat32(this.offset, value);
        this.offset += 4;
    }
    writeFloat64(value) {
        this.view.setFloat64(this.offset, value);
        this.offset += 8;
    }
    writeString(value) {
        const uint8arr = new TextEncoder().encode(value);
        this.writeUInt32(uint8arr.byteLength);
        uint8arr.forEach((byte)=>{
            this.writeUInt8(byte);
        });
    }
    writeUInt8Array(value) {
        const length = value.byteLength;
        this.writeUInt32(length);
        for(let i = 0; i < value.length; i++)this.writeUInt8(value[i]);
    }
    writeInt8Array(value) {
        const length = value.length;
        this.writeUInt32(length);
        for(let i = 0; i < value.length; i++)this.writeInt8(value[i]);
    }
    writeUInt16Array(value) {
        const length = value.length;
        this.writeUInt32(length);
        for(let i = 0; i < value.length; i++)this.writeUInt16(value[i]);
    }
    writeInt16Array(value) {
        const length = value.length;
        this.writeUInt32(length);
        for(let i = 0; i < value.length; i++)this.writeInt16(value[i]);
    }
    writeUInt32Array(value) {
        const length = value.length;
        this.writeUInt32(length);
        for(let i = 0; i < value.length; i++)this.writeUInt32(value[i]);
    }
    writeInt32Array(value) {
        const length = value.length;
        this.writeUInt32(length);
        for(let i = 0; i < value.length; i++)this.writeInt32(value[i]);
    }
    writeFloat32Array(value) {
        const length = value.length;
        this.writeUInt32(length);
        for(let i = 0; i < value.length; i++)this.writeFloat32(value[i]);
    }
    writeFloat64Array(value) {
        const length = value.length;
        this.writeUInt32(length);
        for(let i = 0; i < value.length; i++)this.writeFloat64(value[i]);
    }
    constructor(arrayBuffer, offset){
        this.view = new DataView(arrayBuffer);
        this.offset = offset || 0;
    }
}
module.exports.DataViewWriter = $33a15761961897a2$var$DataViewWriter;

});

const $b80b6e4c153785d9$var$GAME_VERSION = "2.0.0";
const $b80b6e4c153785d9$export$29cd7b75162a9425 = {
    Game: {
        GAME_VERSION: $b80b6e4c153785d9$var$GAME_VERSION,
        MAJOR_GAME_VERSION: $b80b6e4c153785d9$var$GAME_VERSION.substring(0, 1),
        MAX_PLAYERS: 50,
        GAME_NAME: "UpTogether.io"
    },
    Rendering: {
        ENABLE_STATS: false
    },
    Camera: {
        FOV: 90,
        NEAR_PLANE: 0.1,
        FAR_PLANE: 10000.0,
        OFFSET_VERTICAL: 6,
        MOUSE_SENSITIVITY: 0.0035,
        MOBILE_CAMERA_ROTATION_SENSITIVITY: {
            VERTICAL: 1.5,
            HORIZONTAL: 2
        },
        PER_FRAME_MOVEMENT_CAP: 20 * (Math.PI / 180),
        DRAW_CAMERA_TARGET_CUBE: false,
        RAYCAST_CAMERA: false,
        STARTING_DISTANCE: 6,
        STARTING_ANGLE: 40,
        ZOOM_SENSITIVITY: 0.005,
        MIN_DISTANCE: 2.5,
        MAX_DISTANCE: 10,
        MAX_HEIGHT_WHEN_CLOSE: -6,
        MIN_HEIGHT_WHEN_CLOSE: -6,
        MAX_HEIGHT_WHEN_FAR: 3.5,
        MIN_HEIGHT_WHEN_FAR: -6,
        FOV_SPEED_ADJUST_FACTOR: 1.1,
        FOV_SPEED_ADJUST_LERP_SPEED: 5
    },
    Server: {
        TARGET_DELTA_IN_SECONDS: 0.05,
        TARGET_DELTA_IN_MS: 50
    },
    Collision: {
        DRAW_COLLISION_BOXES: false
    },
    Logging: {
        ALWAYS_LOG_LONG_FRAMES: true,
        LOG_TICK_METADATA_EVERY_SERVER_FRAME: false,
        ONLY_DISPLAY_ONE_FRAME_LOG_AT_A_TIME: false
    },
    Rewards: {
        SKIP_ADS: false
    },
    World: {
        GRAVITY: 5.1,
        DEBUG_TELEPORT_LOCATION: {
            X: 87.22,
            Y: 1400,
            Z: 388.34
        }
    },
    Player: {
        ENABLE_PREDICTION: true,
        JUMP_VELOCITY: 2.25,
        SPEED_PER_SECOND: 10,
        DEATH_FALL_TIMER: 2.5,
        DEATH_FALL_TIMER_AFTER_RUN_COMPLETE: 35,
        RESPAWN_MOVEMENT_DELAY: 0.25,
        DRAW_SERVERSIDE_SELF_DURING_PREDICTION: false,
        DEBUG_SPAWN_POSITION: {
            ENABLED: false,
            X: 101,
            Y: 1,
            Z: -25
        },
        DRAW_COLLIDER: false
    },
    UI: {}
};


var $9460eef1b2ed143f$export$f1f74d609516c940;
(function(HostPortals) {
    HostPortals[HostPortals["DIRECT"] = 0] = "DIRECT";
    HostPortals[HostPortals["Poki"] = 1] = "Poki";
})($9460eef1b2ed143f$export$f1f74d609516c940 || ($9460eef1b2ed143f$export$f1f74d609516c940 = {}));


var $9973d40890095cce$exports = {};
"use strict";
var $9973d40890095cce$var$has = Object.prototype.hasOwnProperty, $9973d40890095cce$var$prefix = "~";
/**
 * Constructor to create a storage for our `EE` objects.
 * An `Events` instance is a plain object whose properties are event names.
 *
 * @constructor
 * @private
 */ function $9973d40890095cce$var$Events() {}
//
// We try to not inherit from `Object.prototype`. In some engines creating an
// instance in this way is faster than calling `Object.create(null)` directly.
// If `Object.create(null)` is not supported we prefix the event names with a
// character to make sure that the built-in object properties are not
// overridden or used as an attack vector.
//
if (Object.create) {
    $9973d40890095cce$var$Events.prototype = Object.create(null);
    //
    // This hack is needed because the `__proto__` property is still inherited in
    // some old browsers like Android 4, iPhone 5.1, Opera 11 and Safari 5.
    //
    if (!new $9973d40890095cce$var$Events().__proto__) $9973d40890095cce$var$prefix = false;
}
/**
 * Representation of a single event listener.
 *
 * @param {Function} fn The listener function.
 * @param {*} context The context to invoke the listener with.
 * @param {Boolean} [once=false] Specify if the listener is a one-time listener.
 * @constructor
 * @private
 */ function $9973d40890095cce$var$EE(fn, context, once) {
    this.fn = fn;
    this.context = context;
    this.once = once || false;
}
/**
 * Add a listener for a given event.
 *
 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} context The context to invoke the listener with.
 * @param {Boolean} once Specify if the listener is a one-time listener.
 * @returns {EventEmitter}
 * @private
 */ function $9973d40890095cce$var$addListener(emitter, event, fn, context, once) {
    if (typeof fn !== "function") throw new TypeError("The listener must be a function");
    var listener = new $9973d40890095cce$var$EE(fn, context || emitter, once), evt = $9973d40890095cce$var$prefix ? $9973d40890095cce$var$prefix + event : event;
    if (!emitter._events[evt]) emitter._events[evt] = listener, emitter._eventsCount++;
    else if (!emitter._events[evt].fn) emitter._events[evt].push(listener);
    else emitter._events[evt] = [
        emitter._events[evt],
        listener
    ];
    return emitter;
}
/**
 * Clear event by name.
 *
 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
 * @param {(String|Symbol)} evt The Event name.
 * @private
 */ function $9973d40890095cce$var$clearEvent(emitter, evt) {
    if (--emitter._eventsCount === 0) emitter._events = new $9973d40890095cce$var$Events();
    else delete emitter._events[evt];
}
/**
 * Minimal `EventEmitter` interface that is molded against the Node.js
 * `EventEmitter` interface.
 *
 * @constructor
 * @public
 */ function $9973d40890095cce$var$EventEmitter() {
    this._events = new $9973d40890095cce$var$Events();
    this._eventsCount = 0;
}
/**
 * Return an array listing the events for which the emitter has registered
 * listeners.
 *
 * @returns {Array}
 * @public
 */ $9973d40890095cce$var$EventEmitter.prototype.eventNames = function eventNames() {
    var names = [], events, name;
    if (this._eventsCount === 0) return names;
    for(name in events = this._events)if ($9973d40890095cce$var$has.call(events, name)) names.push($9973d40890095cce$var$prefix ? name.slice(1) : name);
    if (Object.getOwnPropertySymbols) return names.concat(Object.getOwnPropertySymbols(events));
    return names;
};
/**
 * Return the listeners registered for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Array} The registered listeners.
 * @public
 */ $9973d40890095cce$var$EventEmitter.prototype.listeners = function listeners(event) {
    var evt = $9973d40890095cce$var$prefix ? $9973d40890095cce$var$prefix + event : event, handlers = this._events[evt];
    if (!handlers) return [];
    if (handlers.fn) return [
        handlers.fn
    ];
    for(var i = 0, l = handlers.length, ee = new Array(l); i < l; i++)ee[i] = handlers[i].fn;
    return ee;
};
/**
 * Return the number of listeners listening to a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Number} The number of listeners.
 * @public
 */ $9973d40890095cce$var$EventEmitter.prototype.listenerCount = function listenerCount(event) {
    var evt = $9973d40890095cce$var$prefix ? $9973d40890095cce$var$prefix + event : event, listeners = this._events[evt];
    if (!listeners) return 0;
    if (listeners.fn) return 1;
    return listeners.length;
};
/**
 * Calls each of the listeners registered for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Boolean} `true` if the event had listeners, else `false`.
 * @public
 */ $9973d40890095cce$var$EventEmitter.prototype.emit = function emit(event, a1, a2, a3, a4, a5) {
    var evt = $9973d40890095cce$var$prefix ? $9973d40890095cce$var$prefix + event : event;
    if (!this._events[evt]) return false;
    var listeners = this._events[evt], len = arguments.length, args, i;
    if (listeners.fn) {
        if (listeners.once) this.removeListener(event, listeners.fn, undefined, true);
        switch(len){
            case 1:
                return listeners.fn.call(listeners.context), true;
            case 2:
                return listeners.fn.call(listeners.context, a1), true;
            case 3:
                return listeners.fn.call(listeners.context, a1, a2), true;
            case 4:
                return listeners.fn.call(listeners.context, a1, a2, a3), true;
            case 5:
                return listeners.fn.call(listeners.context, a1, a2, a3, a4), true;
            case 6:
                return listeners.fn.call(listeners.context, a1, a2, a3, a4, a5), true;
        }
        for(i = 1, args = new Array(len - 1); i < len; i++)args[i - 1] = arguments[i];
        listeners.fn.apply(listeners.context, args);
    } else {
        var length = listeners.length, j;
        for(i = 0; i < length; i++){
            if (listeners[i].once) this.removeListener(event, listeners[i].fn, undefined, true);
            switch(len){
                case 1:
                    listeners[i].fn.call(listeners[i].context);
                    break;
                case 2:
                    listeners[i].fn.call(listeners[i].context, a1);
                    break;
                case 3:
                    listeners[i].fn.call(listeners[i].context, a1, a2);
                    break;
                case 4:
                    listeners[i].fn.call(listeners[i].context, a1, a2, a3);
                    break;
                default:
                    if (!args) for(j = 1, args = new Array(len - 1); j < len; j++)args[j - 1] = arguments[j];
                    listeners[i].fn.apply(listeners[i].context, args);
            }
        }
    }
    return true;
};
/**
 * Add a listener for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @public
 */ $9973d40890095cce$var$EventEmitter.prototype.on = function on(event, fn, context) {
    return $9973d40890095cce$var$addListener(this, event, fn, context, false);
};
/**
 * Add a one-time listener for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @public
 */ $9973d40890095cce$var$EventEmitter.prototype.once = function once(event, fn, context) {
    return $9973d40890095cce$var$addListener(this, event, fn, context, true);
};
/**
 * Remove the listeners of a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn Only remove the listeners that match this function.
 * @param {*} context Only remove the listeners that have this context.
 * @param {Boolean} once Only remove one-time listeners.
 * @returns {EventEmitter} `this`.
 * @public
 */ $9973d40890095cce$var$EventEmitter.prototype.removeListener = function removeListener(event, fn, context, once) {
    var evt = $9973d40890095cce$var$prefix ? $9973d40890095cce$var$prefix + event : event;
    if (!this._events[evt]) return this;
    if (!fn) {
        $9973d40890095cce$var$clearEvent(this, evt);
        return this;
    }
    var listeners = this._events[evt];
    if (listeners.fn) {
        if (listeners.fn === fn && (!once || listeners.once) && (!context || listeners.context === context)) $9973d40890095cce$var$clearEvent(this, evt);
    } else {
        for(var i = 0, events = [], length = listeners.length; i < length; i++)if (listeners[i].fn !== fn || once && !listeners[i].once || context && listeners[i].context !== context) events.push(listeners[i]);
        //
        // Reset the array, or remove it completely if we have no more listeners.
        //
        if (events.length) this._events[evt] = events.length === 1 ? events[0] : events;
        else $9973d40890095cce$var$clearEvent(this, evt);
    }
    return this;
};
/**
 * Remove all listeners, or those of the specified event.
 *
 * @param {(String|Symbol)} [event] The event name.
 * @returns {EventEmitter} `this`.
 * @public
 */ $9973d40890095cce$var$EventEmitter.prototype.removeAllListeners = function removeAllListeners(event) {
    var evt;
    if (event) {
        evt = $9973d40890095cce$var$prefix ? $9973d40890095cce$var$prefix + event : event;
        if (this._events[evt]) $9973d40890095cce$var$clearEvent(this, evt);
    } else {
        this._events = new $9973d40890095cce$var$Events();
        this._eventsCount = 0;
    }
    return this;
};
//
// Alias methods names because people roll like that.
//
$9973d40890095cce$var$EventEmitter.prototype.off = $9973d40890095cce$var$EventEmitter.prototype.removeListener;
$9973d40890095cce$var$EventEmitter.prototype.addListener = $9973d40890095cce$var$EventEmitter.prototype.on;
//
// Expose the prefix.
//
$9973d40890095cce$var$EventEmitter.prefixed = $9973d40890095cce$var$prefix;
//
// Allow `EventEmitter` to be imported as module namespace.
//
$9973d40890095cce$var$EventEmitter.EventEmitter = $9973d40890095cce$var$EventEmitter;
$9973d40890095cce$exports = $9973d40890095cce$var$EventEmitter;



/* eslint-disable @typescript-eslint/no-explicit-any */ 
var $5LCsG = parcelRequire("5LCsG");
var $a24315420cf48455$exports = {};
// shim for using process in browser
var $a24315420cf48455$var$process = $a24315420cf48455$exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $a24315420cf48455$var$cachedSetTimeout;
var $a24315420cf48455$var$cachedClearTimeout;
function $a24315420cf48455$var$defaultSetTimout() {
    throw new Error("setTimeout has not been defined");
}
function $a24315420cf48455$var$defaultClearTimeout() {
    throw new Error("clearTimeout has not been defined");
}
(function() {
    try {
        if (typeof setTimeout === "function") $a24315420cf48455$var$cachedSetTimeout = setTimeout;
        else $a24315420cf48455$var$cachedSetTimeout = $a24315420cf48455$var$defaultSetTimout;
    } catch (e) {
        $a24315420cf48455$var$cachedSetTimeout = $a24315420cf48455$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === "function") $a24315420cf48455$var$cachedClearTimeout = clearTimeout;
        else $a24315420cf48455$var$cachedClearTimeout = $a24315420cf48455$var$defaultClearTimeout;
    } catch (e) {
        $a24315420cf48455$var$cachedClearTimeout = $a24315420cf48455$var$defaultClearTimeout;
    }
})();
function $a24315420cf48455$var$runTimeout(fun) {
    if ($a24315420cf48455$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($a24315420cf48455$var$cachedSetTimeout === $a24315420cf48455$var$defaultSetTimout || !$a24315420cf48455$var$cachedSetTimeout) && setTimeout) {
        $a24315420cf48455$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $a24315420cf48455$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $a24315420cf48455$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $a24315420cf48455$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $a24315420cf48455$var$runClearTimeout(marker) {
    if ($a24315420cf48455$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($a24315420cf48455$var$cachedClearTimeout === $a24315420cf48455$var$defaultClearTimeout || !$a24315420cf48455$var$cachedClearTimeout) && clearTimeout) {
        $a24315420cf48455$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $a24315420cf48455$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $a24315420cf48455$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $a24315420cf48455$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $a24315420cf48455$var$queue = [];
var $a24315420cf48455$var$draining = false;
var $a24315420cf48455$var$currentQueue;
var $a24315420cf48455$var$queueIndex = -1;
function $a24315420cf48455$var$cleanUpNextTick() {
    if (!$a24315420cf48455$var$draining || !$a24315420cf48455$var$currentQueue) return;
    $a24315420cf48455$var$draining = false;
    if ($a24315420cf48455$var$currentQueue.length) $a24315420cf48455$var$queue = $a24315420cf48455$var$currentQueue.concat($a24315420cf48455$var$queue);
    else $a24315420cf48455$var$queueIndex = -1;
    if ($a24315420cf48455$var$queue.length) $a24315420cf48455$var$drainQueue();
}
function $a24315420cf48455$var$drainQueue() {
    if ($a24315420cf48455$var$draining) return;
    var timeout = $a24315420cf48455$var$runTimeout($a24315420cf48455$var$cleanUpNextTick);
    $a24315420cf48455$var$draining = true;
    var len = $a24315420cf48455$var$queue.length;
    while(len){
        $a24315420cf48455$var$currentQueue = $a24315420cf48455$var$queue;
        $a24315420cf48455$var$queue = [];
        while(++$a24315420cf48455$var$queueIndex < len)if ($a24315420cf48455$var$currentQueue) $a24315420cf48455$var$currentQueue[$a24315420cf48455$var$queueIndex].run();
        $a24315420cf48455$var$queueIndex = -1;
        len = $a24315420cf48455$var$queue.length;
    }
    $a24315420cf48455$var$currentQueue = null;
    $a24315420cf48455$var$draining = false;
    $a24315420cf48455$var$runClearTimeout(timeout);
}
$a24315420cf48455$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $a24315420cf48455$var$queue.push(new $a24315420cf48455$var$Item(fun, args));
    if ($a24315420cf48455$var$queue.length === 1 && !$a24315420cf48455$var$draining) $a24315420cf48455$var$runTimeout($a24315420cf48455$var$drainQueue);
};
// v8 likes predictible objects
function $a24315420cf48455$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$a24315420cf48455$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$a24315420cf48455$var$process.title = "browser";
$a24315420cf48455$var$process.browser = true;
$a24315420cf48455$var$process.env = {};
$a24315420cf48455$var$process.argv = [];
$a24315420cf48455$var$process.version = ""; // empty string to avoid regexp issues
$a24315420cf48455$var$process.versions = {};
function $a24315420cf48455$var$noop() {}
$a24315420cf48455$var$process.on = $a24315420cf48455$var$noop;
$a24315420cf48455$var$process.addListener = $a24315420cf48455$var$noop;
$a24315420cf48455$var$process.once = $a24315420cf48455$var$noop;
$a24315420cf48455$var$process.off = $a24315420cf48455$var$noop;
$a24315420cf48455$var$process.removeListener = $a24315420cf48455$var$noop;
$a24315420cf48455$var$process.removeAllListeners = $a24315420cf48455$var$noop;
$a24315420cf48455$var$process.emit = $a24315420cf48455$var$noop;
$a24315420cf48455$var$process.prependListener = $a24315420cf48455$var$noop;
$a24315420cf48455$var$process.prependOnceListener = $a24315420cf48455$var$noop;
$a24315420cf48455$var$process.listeners = function(name) {
    return [];
};
$a24315420cf48455$var$process.binding = function(name) {
    throw new Error("process.binding is not supported");
};
$a24315420cf48455$var$process.cwd = function() {
    return "/";
};
$a24315420cf48455$var$process.chdir = function(dir) {
    throw new Error("process.chdir is not supported");
};
$a24315420cf48455$var$process.umask = function() {
    return 0;
};


const $9f2918ccbc980d31$export$bc0290abd606d45b = ()=>{
    const time = $a24315420cf48455$exports.hrtime.bigint();
    return Number(time) / 1e6;
};
const $9f2918ccbc980d31$export$7c99b80db23920e1 = typeof BigInt !== "undefined" ? typeof $a24315420cf48455$exports !== "undefined" && typeof $a24315420cf48455$exports.hrtime !== "undefined" && typeof $a24315420cf48455$exports.hrtime.bigint === "function" ? ()=>$a24315420cf48455$exports.hrtime.bigint() : ()=>BigInt(Date.now() * 1e6) : ()=>Date.now() * 1e6;
const $9f2918ccbc980d31$export$976c37132e9c6a10 = new RegExp("([!#-'*+/-9=?A-Z^-~-]+(.[!#-'*+/-9=?A-Z^-~-]+)*|\"([]!#-[^-~ 	]|(\\[	 -~]))+\")@([!#-'*+/-9=?A-Z^-~-]+(.[!#-'*+/-9=?A-Z^-~-]+)*|[[	 -Z^-~]*])");
const $9f2918ccbc980d31$export$b646210dbab6d1e3 = ()=>Date.now();
const $9f2918ccbc980d31$export$2e015b6955893291 = (arr)=>{
    return arr[Math.floor(Math.random() * arr.length)];
};
const $9f2918ccbc980d31$export$acf2935d58de9402 = ()=>{
    try {
        return window.self !== window.top;
    } catch (e) {
        return true;
    }
};
const $9f2918ccbc980d31$export$307b18b61172f7ed = (caller)=>{
    const proto = Object.getPrototypeOf(caller);
    if (proto.constructor && proto.constructor.name) return proto.constructor.name;
    return "";
};
const $9f2918ccbc980d31$export$6888749eed104596 = (v)=>{
    return (0, $5LCsG.isNil)(v) || v === "";
};
const $9f2918ccbc980d31$export$a14e8754c327dfd0 = (seconds)=>{
    const hours = Math.floor(seconds / 3600);
    const minutes = Math.floor(seconds % 3600 / 60);
    const remainingSeconds = seconds % 60;
    const timeSegments = [];
    if (hours > 0) {
        const formattedHours = hours.toString().padStart(2, "0");
        timeSegments.push(formattedHours);
    }
    const formattedMinutes = minutes.toString().padStart(2, "0");
    const formattedSeconds = remainingSeconds.toString().padStart(2, "0");
    timeSegments.push(formattedMinutes, formattedSeconds);
    return timeSegments.join(":");
};
const $9f2918ccbc980d31$export$7d15b64cf5a3a4c4 = (val, min = 0, max = 1)=>Math.max(min, Math.min(max, val));
const $9f2918ccbc980d31$export$ec7b30d06d4fb38 = (rads)=>{
    return rads > Math.PI / 2 || rads < -Math.PI / 2;
};
const $9f2918ccbc980d31$export$b59117efbc9c7af = (x1, y1, x2, y2)=>{
    const xDiff = x1 - x2;
    const yDiff = y1 - y2;
    return Math.sqrt(xDiff * xDiff + yDiff * yDiff);
};
const $9f2918ccbc980d31$export$e772c8ff12451969 = (ms)=>new Promise((resolve)=>setTimeout(resolve, ms));
function $9f2918ccbc980d31$export$cba01ba138429a1d(degrees) {
    return degrees * (Math.PI / 180);
}
function $9f2918ccbc980d31$export$56cb859c01fa134d(radians) {
    return radians * (180 / Math.PI);
}
function $9f2918ccbc980d31$export$5c945887f38dcb4b(angleInRadians, percentage) {
    const range = Math.PI * 2 * percentage;
    const offset = Math.random() * range - range / 2;
    let newAngle = angleInRadians + offset;
    if (newAngle < -Math.PI) newAngle += 2 * Math.PI;
    else if (newAngle > Math.PI) newAngle -= 2 * Math.PI;
    return newAngle;
}
const $9f2918ccbc980d31$export$8568ce53486579b5 = (chance)=>Math.random() < chance;
const $9f2918ccbc980d31$export$f4cddbd81b5f2a5c = ()=>Math.random() >= 0.5;
const $9f2918ccbc980d31$export$d65d87575fa7ad6c = ()=>Math.random() * 2 * Math.PI;
const $9f2918ccbc980d31$export$3acfa4651e1e404d = (seconds, shorterFormat)=>{
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = Math.floor(seconds % 60);
    if (shorterFormat) {
        const paddedMinutes = minutes.toString().padStart(2, "0");
        const paddedSeconds = remainingSeconds.toString().padStart(2, "0");
        return `${paddedMinutes}:${paddedSeconds}`;
    } else return `${minutes < 1 ? "" : `${minutes}m`}${remainingSeconds}${remainingSeconds > 1 ? "s" : ""}`;
};
const $9f2918ccbc980d31$export$67128de51a301bf0 = (seconds)=>{
    const hours = Math.floor(seconds / 3600);
    const minutes = Math.floor(seconds % 3600 / 60);
    const paddedMinutes = minutes.toString().padStart(2, "0");
    return `${hours}h ${paddedMinutes}m`;
};


var $c89b2bdea0027ac9$export$243e62d78d3b544d;
(function(LogLevel) {
    LogLevel[LogLevel["VERBOSE"] = 0] = "VERBOSE";
    LogLevel[LogLevel["INFO"] = 1] = "INFO";
    LogLevel[LogLevel["WARNING"] = 2] = "WARNING";
    LogLevel[LogLevel["ERROR"] = 3] = "ERROR";
})($c89b2bdea0027ac9$export$243e62d78d3b544d || ($c89b2bdea0027ac9$export$243e62d78d3b544d = {}));
const $c89b2bdea0027ac9$export$7e24a29324041c48 = (str, length)=>{
    if (str.length >= length) return str;
    const spacesToAdd = length - str.length;
    return str + " ".repeat(spacesToAdd);
};
const $c89b2bdea0027ac9$export$bc3bea8325045070 = (str, len)=>{
    if (str.length >= len) return str;
    return " ".repeat(len - str.length) + str;
};
const $c89b2bdea0027ac9$export$7fd96f818dd6e623 = (str, length)=>{
    const diff = length - str.length;
    if (diff <= 0) return str;
    const leftPadding = Math.floor(diff / 2);
    const rightPadding = diff - leftPadding;
    const paddedStr = " ".repeat(leftPadding) + str + " ".repeat(rightPadding);
    return paddedStr;
};



const { Logging: $c4dbdc9acd823594$var$Logging } = (0, $b80b6e4c153785d9$export$29cd7b75162a9425);
class $c4dbdc9acd823594$export$20d83fe2bd9e0e3d {
    setLogLevel(newLogLevel) {
        this.level = newLogLevel;
    }
    getSystemName() {
        return (0, $9f2918ccbc980d31$export$307b18b61172f7ed)(this);
    }
    log(level, message, data) {
        if (level >= this.level) {
            let logFn;
            const frameNumberSegment = "[" + (0, $c89b2bdea0027ac9$export$7fd96f818dd6e623)(globalThis.currentFrameNumber.toString(), 7) + "]";
            const systemSegment = "[" + (0, $c89b2bdea0027ac9$export$7fd96f818dd6e623)(this.getSystemName(), 13) + "]";
            const logLevelSegment = "[" + (0, $c89b2bdea0027ac9$export$7fd96f818dd6e623)((0, $c89b2bdea0027ac9$export$243e62d78d3b544d)[level], 9) + "]";
            const fullString = `%c ${frameNumberSegment} ${logLevelSegment} ${systemSegment} ${message}`;
            if (level === (0, $c89b2bdea0027ac9$export$243e62d78d3b544d).ERROR) logFn = console.error.bind(console, fullString, "color: red");
            else if (level === (0, $c89b2bdea0027ac9$export$243e62d78d3b544d).WARNING) logFn = console.warn.bind(console, fullString, "color: orange");
            else if (level === (0, $c89b2bdea0027ac9$export$243e62d78d3b544d).VERBOSE) logFn = console.debug.bind(console, fullString, "color: gray");
            else logFn = console.log.bind(console, fullString, "color: white");
            if (data !== undefined) logFn(data); // Log the data alongside the message
            else logFn(); // Log the message without data
        }
    }
    ConditionallyLogTickMsg(msg, level = (0, $c89b2bdea0027ac9$export$243e62d78d3b544d).INFO, data) {
        if ($c4dbdc9acd823594$var$Logging.LOG_TICK_METADATA_EVERY_SERVER_FRAME === true) this.log(level, msg, data);
    }
    LogVerbose(message, data) {
        this.log((0, $c89b2bdea0027ac9$export$243e62d78d3b544d).VERBOSE, message, data);
    }
    LogInfo(message, data) {
        this.log((0, $c89b2bdea0027ac9$export$243e62d78d3b544d).INFO, message, data);
    }
    LogWarning(message, data) {
        this.log((0, $c89b2bdea0027ac9$export$243e62d78d3b544d).WARNING, message, data);
    }
    LogError(message, data) {
        this.log((0, $c89b2bdea0027ac9$export$243e62d78d3b544d).ERROR, message, data);
    }
    constructor(level = (0, $c89b2bdea0027ac9$export$243e62d78d3b544d).INFO){
        this.level = level;
    }
}


class $fc7b18e354612676$export$5d53140180d567a1 extends (0, $c4dbdc9acd823594$export$20d83fe2bd9e0e3d) {
}


var $9014d97cd777be10$exports = {};

$parcel$export($9014d97cd777be10$exports, "REVISION", function () { return $9014d97cd777be10$export$3545e07a80636437; });
$parcel$export($9014d97cd777be10$exports, "MOUSE", function () { return $9014d97cd777be10$export$7177b3e430c2d7ca; });
$parcel$export($9014d97cd777be10$exports, "TOUCH", function () { return $9014d97cd777be10$export$d46bd3ead7cc759b; });
$parcel$export($9014d97cd777be10$exports, "CullFaceNone", function () { return $9014d97cd777be10$export$3237e1f2c1ea1f44; });
$parcel$export($9014d97cd777be10$exports, "CullFaceBack", function () { return $9014d97cd777be10$export$b9a7b4fc5cb15f9b; });
$parcel$export($9014d97cd777be10$exports, "CullFaceFront", function () { return $9014d97cd777be10$export$b8058bcc7037d3f3; });
$parcel$export($9014d97cd777be10$exports, "CullFaceFrontBack", function () { return $9014d97cd777be10$export$f24be24dcddeac0d; });
$parcel$export($9014d97cd777be10$exports, "BasicShadowMap", function () { return $9014d97cd777be10$export$346307dbae2b7447; });
$parcel$export($9014d97cd777be10$exports, "PCFShadowMap", function () { return $9014d97cd777be10$export$5813f879eee7cd88; });
$parcel$export($9014d97cd777be10$exports, "PCFSoftShadowMap", function () { return $9014d97cd777be10$export$a47c4b43a1be34f0; });
$parcel$export($9014d97cd777be10$exports, "VSMShadowMap", function () { return $9014d97cd777be10$export$896ae1ade6c829c4; });
$parcel$export($9014d97cd777be10$exports, "FrontSide", function () { return $9014d97cd777be10$export$2ede184fc2998901; });
$parcel$export($9014d97cd777be10$exports, "BackSide", function () { return $9014d97cd777be10$export$d9f0486e75b5ace; });
$parcel$export($9014d97cd777be10$exports, "DoubleSide", function () { return $9014d97cd777be10$export$3b296b6f144d5b03; });
$parcel$export($9014d97cd777be10$exports, "TwoPassDoubleSide", function () { return $9014d97cd777be10$export$211211c00f97204d; });
$parcel$export($9014d97cd777be10$exports, "NoBlending", function () { return $9014d97cd777be10$export$63b8d6b580fc65ba; });
$parcel$export($9014d97cd777be10$exports, "NormalBlending", function () { return $9014d97cd777be10$export$5b29a26d96ee6af0; });
$parcel$export($9014d97cd777be10$exports, "AdditiveBlending", function () { return $9014d97cd777be10$export$777d8f9551c2216b; });
$parcel$export($9014d97cd777be10$exports, "SubtractiveBlending", function () { return $9014d97cd777be10$export$cdfa06f868e2e467; });
$parcel$export($9014d97cd777be10$exports, "MultiplyBlending", function () { return $9014d97cd777be10$export$4138e1c684b46a20; });
$parcel$export($9014d97cd777be10$exports, "CustomBlending", function () { return $9014d97cd777be10$export$eda4864c68df1fa2; });
$parcel$export($9014d97cd777be10$exports, "AddEquation", function () { return $9014d97cd777be10$export$20183a0484ce21a0; });
$parcel$export($9014d97cd777be10$exports, "SubtractEquation", function () { return $9014d97cd777be10$export$73e0df5177988548; });
$parcel$export($9014d97cd777be10$exports, "ReverseSubtractEquation", function () { return $9014d97cd777be10$export$28e582859cbec660; });
$parcel$export($9014d97cd777be10$exports, "MinEquation", function () { return $9014d97cd777be10$export$c8c1508da8d0600c; });
$parcel$export($9014d97cd777be10$exports, "MaxEquation", function () { return $9014d97cd777be10$export$99948c02fb51055f; });
$parcel$export($9014d97cd777be10$exports, "ZeroFactor", function () { return $9014d97cd777be10$export$2110f05edf778d3d; });
$parcel$export($9014d97cd777be10$exports, "OneFactor", function () { return $9014d97cd777be10$export$8805bad65e24940e; });
$parcel$export($9014d97cd777be10$exports, "SrcColorFactor", function () { return $9014d97cd777be10$export$7fbe15b28d28cf52; });
$parcel$export($9014d97cd777be10$exports, "OneMinusSrcColorFactor", function () { return $9014d97cd777be10$export$947829af9f2c17f6; });
$parcel$export($9014d97cd777be10$exports, "SrcAlphaFactor", function () { return $9014d97cd777be10$export$d5773124e86cf28c; });
$parcel$export($9014d97cd777be10$exports, "OneMinusSrcAlphaFactor", function () { return $9014d97cd777be10$export$11d468cc7f19e971; });
$parcel$export($9014d97cd777be10$exports, "DstAlphaFactor", function () { return $9014d97cd777be10$export$a78aed1ca2a87192; });
$parcel$export($9014d97cd777be10$exports, "OneMinusDstAlphaFactor", function () { return $9014d97cd777be10$export$5d0fe17fd8773bac; });
$parcel$export($9014d97cd777be10$exports, "DstColorFactor", function () { return $9014d97cd777be10$export$ef5f2dd8ffac5574; });
$parcel$export($9014d97cd777be10$exports, "OneMinusDstColorFactor", function () { return $9014d97cd777be10$export$56b85b2686ab16; });
$parcel$export($9014d97cd777be10$exports, "SrcAlphaSaturateFactor", function () { return $9014d97cd777be10$export$c05e2a1fc8609506; });
$parcel$export($9014d97cd777be10$exports, "NeverDepth", function () { return $9014d97cd777be10$export$69025ce147cee220; });
$parcel$export($9014d97cd777be10$exports, "AlwaysDepth", function () { return $9014d97cd777be10$export$7182eb52ea3b3f04; });
$parcel$export($9014d97cd777be10$exports, "LessDepth", function () { return $9014d97cd777be10$export$eedccec66ab7ebe; });
$parcel$export($9014d97cd777be10$exports, "LessEqualDepth", function () { return $9014d97cd777be10$export$296f78a0b892f81a; });
$parcel$export($9014d97cd777be10$exports, "EqualDepth", function () { return $9014d97cd777be10$export$a60d398fc7b7590e; });
$parcel$export($9014d97cd777be10$exports, "GreaterEqualDepth", function () { return $9014d97cd777be10$export$7d7234c1240a1fc4; });
$parcel$export($9014d97cd777be10$exports, "GreaterDepth", function () { return $9014d97cd777be10$export$c5e2c52991f30937; });
$parcel$export($9014d97cd777be10$exports, "NotEqualDepth", function () { return $9014d97cd777be10$export$2f843afa843d8916; });
$parcel$export($9014d97cd777be10$exports, "MultiplyOperation", function () { return $9014d97cd777be10$export$e50ac29801f1774d; });
$parcel$export($9014d97cd777be10$exports, "MixOperation", function () { return $9014d97cd777be10$export$9f9d94f963c85479; });
$parcel$export($9014d97cd777be10$exports, "AddOperation", function () { return $9014d97cd777be10$export$e641dc52bc3494aa; });
$parcel$export($9014d97cd777be10$exports, "NoToneMapping", function () { return $9014d97cd777be10$export$9fcb6b4294603b2; });
$parcel$export($9014d97cd777be10$exports, "LinearToneMapping", function () { return $9014d97cd777be10$export$98f52c2a46c598ca; });
$parcel$export($9014d97cd777be10$exports, "ReinhardToneMapping", function () { return $9014d97cd777be10$export$74b25e54b3bcd548; });
$parcel$export($9014d97cd777be10$exports, "CineonToneMapping", function () { return $9014d97cd777be10$export$932b3dd283d4a366; });
$parcel$export($9014d97cd777be10$exports, "ACESFilmicToneMapping", function () { return $9014d97cd777be10$export$a0d98fe6d7e4af64; });
$parcel$export($9014d97cd777be10$exports, "CustomToneMapping", function () { return $9014d97cd777be10$export$2c7b09c1e9abfb5e; });
$parcel$export($9014d97cd777be10$exports, "UVMapping", function () { return $9014d97cd777be10$export$1beec6768cbb3d2d; });
$parcel$export($9014d97cd777be10$exports, "CubeReflectionMapping", function () { return $9014d97cd777be10$export$8759762a6477f2c4; });
$parcel$export($9014d97cd777be10$exports, "CubeRefractionMapping", function () { return $9014d97cd777be10$export$dc59f8aed047f61d; });
$parcel$export($9014d97cd777be10$exports, "EquirectangularReflectionMapping", function () { return $9014d97cd777be10$export$d64030b316d3b087; });
$parcel$export($9014d97cd777be10$exports, "EquirectangularRefractionMapping", function () { return $9014d97cd777be10$export$ee99d97d46898098; });
$parcel$export($9014d97cd777be10$exports, "CubeUVReflectionMapping", function () { return $9014d97cd777be10$export$dbf3e70ff37af79; });
$parcel$export($9014d97cd777be10$exports, "RepeatWrapping", function () { return $9014d97cd777be10$export$533346c8e8dac0f5; });
$parcel$export($9014d97cd777be10$exports, "ClampToEdgeWrapping", function () { return $9014d97cd777be10$export$9d9334239a5a5e06; });
$parcel$export($9014d97cd777be10$exports, "MirroredRepeatWrapping", function () { return $9014d97cd777be10$export$c7e7c00b14f51a4f; });
$parcel$export($9014d97cd777be10$exports, "NearestFilter", function () { return $9014d97cd777be10$export$727aa5ec3fe39bf0; });
$parcel$export($9014d97cd777be10$exports, "NearestMipmapNearestFilter", function () { return $9014d97cd777be10$export$d129e38cf6feaa8c; });
$parcel$export($9014d97cd777be10$exports, "NearestMipMapNearestFilter", function () { return $9014d97cd777be10$export$14a4936464a36496; });
$parcel$export($9014d97cd777be10$exports, "NearestMipmapLinearFilter", function () { return $9014d97cd777be10$export$d2327c1afe5bfdf2; });
$parcel$export($9014d97cd777be10$exports, "NearestMipMapLinearFilter", function () { return $9014d97cd777be10$export$cbc5b7f5647595d8; });
$parcel$export($9014d97cd777be10$exports, "LinearFilter", function () { return $9014d97cd777be10$export$8a72f490b25c56c8; });
$parcel$export($9014d97cd777be10$exports, "LinearMipmapNearestFilter", function () { return $9014d97cd777be10$export$19a719f377145a13; });
$parcel$export($9014d97cd777be10$exports, "LinearMipMapNearestFilter", function () { return $9014d97cd777be10$export$dbe96bee3fe9dbf0; });
$parcel$export($9014d97cd777be10$exports, "LinearMipmapLinearFilter", function () { return $9014d97cd777be10$export$5d8599b6a933fb1b; });
$parcel$export($9014d97cd777be10$exports, "LinearMipMapLinearFilter", function () { return $9014d97cd777be10$export$90d80f1e3506775f; });
$parcel$export($9014d97cd777be10$exports, "UnsignedByteType", function () { return $9014d97cd777be10$export$2e8ce08d3f6f5e10; });
$parcel$export($9014d97cd777be10$exports, "ByteType", function () { return $9014d97cd777be10$export$545fce0311a9796a; });
$parcel$export($9014d97cd777be10$exports, "ShortType", function () { return $9014d97cd777be10$export$88572337f312435f; });
$parcel$export($9014d97cd777be10$exports, "UnsignedShortType", function () { return $9014d97cd777be10$export$c63dc51868b06a9d; });
$parcel$export($9014d97cd777be10$exports, "IntType", function () { return $9014d97cd777be10$export$5c612977753abe2; });
$parcel$export($9014d97cd777be10$exports, "UnsignedIntType", function () { return $9014d97cd777be10$export$c3c7fc4518ebba96; });
$parcel$export($9014d97cd777be10$exports, "FloatType", function () { return $9014d97cd777be10$export$f6d331659b644596; });
$parcel$export($9014d97cd777be10$exports, "HalfFloatType", function () { return $9014d97cd777be10$export$2697304443f382bc; });
$parcel$export($9014d97cd777be10$exports, "UnsignedShort4444Type", function () { return $9014d97cd777be10$export$b3969b01faf587f2; });
$parcel$export($9014d97cd777be10$exports, "UnsignedShort5551Type", function () { return $9014d97cd777be10$export$18886f8ae33e90de; });
$parcel$export($9014d97cd777be10$exports, "UnsignedInt248Type", function () { return $9014d97cd777be10$export$6c8ea339bfab1301; });
$parcel$export($9014d97cd777be10$exports, "AlphaFormat", function () { return $9014d97cd777be10$export$988473390501ed4b; });
$parcel$export($9014d97cd777be10$exports, "RGBAFormat", function () { return $9014d97cd777be10$export$3f8bb04b555a363c; });
$parcel$export($9014d97cd777be10$exports, "LuminanceFormat", function () { return $9014d97cd777be10$export$cc09ccbf6d1ed449; });
$parcel$export($9014d97cd777be10$exports, "LuminanceAlphaFormat", function () { return $9014d97cd777be10$export$9053a81c4a69c289; });
$parcel$export($9014d97cd777be10$exports, "DepthFormat", function () { return $9014d97cd777be10$export$c1b6b5136be58045; });
$parcel$export($9014d97cd777be10$exports, "DepthStencilFormat", function () { return $9014d97cd777be10$export$1e113ac2d0905829; });
$parcel$export($9014d97cd777be10$exports, "RedFormat", function () { return $9014d97cd777be10$export$4e041a7967d15c4b; });
$parcel$export($9014d97cd777be10$exports, "RedIntegerFormat", function () { return $9014d97cd777be10$export$aa92e870a709d190; });
$parcel$export($9014d97cd777be10$exports, "RGFormat", function () { return $9014d97cd777be10$export$6cdf0b461c7ce8a0; });
$parcel$export($9014d97cd777be10$exports, "RGIntegerFormat", function () { return $9014d97cd777be10$export$1ba1c45f9f77d4d7; });
$parcel$export($9014d97cd777be10$exports, "RGBAIntegerFormat", function () { return $9014d97cd777be10$export$c200e7d26f592f21; });
$parcel$export($9014d97cd777be10$exports, "RGB_S3TC_DXT1_Format", function () { return $9014d97cd777be10$export$21d1799c6d552fc0; });
$parcel$export($9014d97cd777be10$exports, "RGBA_S3TC_DXT1_Format", function () { return $9014d97cd777be10$export$afa304c3e981b668; });
$parcel$export($9014d97cd777be10$exports, "RGBA_S3TC_DXT3_Format", function () { return $9014d97cd777be10$export$d2a1a68024a3e56c; });
$parcel$export($9014d97cd777be10$exports, "RGBA_S3TC_DXT5_Format", function () { return $9014d97cd777be10$export$9a79c424327dacf9; });
$parcel$export($9014d97cd777be10$exports, "RGB_PVRTC_4BPPV1_Format", function () { return $9014d97cd777be10$export$19ada9bbb1af3573; });
$parcel$export($9014d97cd777be10$exports, "RGB_PVRTC_2BPPV1_Format", function () { return $9014d97cd777be10$export$d0f0355bb3d948e4; });
$parcel$export($9014d97cd777be10$exports, "RGBA_PVRTC_4BPPV1_Format", function () { return $9014d97cd777be10$export$b82296714358084c; });
$parcel$export($9014d97cd777be10$exports, "RGBA_PVRTC_2BPPV1_Format", function () { return $9014d97cd777be10$export$b71692456c47b6c3; });
$parcel$export($9014d97cd777be10$exports, "RGB_ETC1_Format", function () { return $9014d97cd777be10$export$6ab91af2d757aee7; });
$parcel$export($9014d97cd777be10$exports, "RGB_ETC2_Format", function () { return $9014d97cd777be10$export$7800993ef8106a6a; });
$parcel$export($9014d97cd777be10$exports, "RGBA_ETC2_EAC_Format", function () { return $9014d97cd777be10$export$23ed8300a860e7d8; });
$parcel$export($9014d97cd777be10$exports, "RGBA_ASTC_4x4_Format", function () { return $9014d97cd777be10$export$dc5570b4a2b92d48; });
$parcel$export($9014d97cd777be10$exports, "RGBA_ASTC_5x4_Format", function () { return $9014d97cd777be10$export$68880cd325f8b2fb; });
$parcel$export($9014d97cd777be10$exports, "RGBA_ASTC_5x5_Format", function () { return $9014d97cd777be10$export$7d2c0be323373d95; });
$parcel$export($9014d97cd777be10$exports, "RGBA_ASTC_6x5_Format", function () { return $9014d97cd777be10$export$22b52da301fc3a3e; });
$parcel$export($9014d97cd777be10$exports, "RGBA_ASTC_6x6_Format", function () { return $9014d97cd777be10$export$c009e2cb4a66485e; });
$parcel$export($9014d97cd777be10$exports, "RGBA_ASTC_8x5_Format", function () { return $9014d97cd777be10$export$118fff5afa255b63; });
$parcel$export($9014d97cd777be10$exports, "RGBA_ASTC_8x6_Format", function () { return $9014d97cd777be10$export$120713c829ae0667; });
$parcel$export($9014d97cd777be10$exports, "RGBA_ASTC_8x8_Format", function () { return $9014d97cd777be10$export$c79eeabbf53313e9; });
$parcel$export($9014d97cd777be10$exports, "RGBA_ASTC_10x5_Format", function () { return $9014d97cd777be10$export$443cf6567cdd6424; });
$parcel$export($9014d97cd777be10$exports, "RGBA_ASTC_10x6_Format", function () { return $9014d97cd777be10$export$6573984fc9840780; });
$parcel$export($9014d97cd777be10$exports, "RGBA_ASTC_10x8_Format", function () { return $9014d97cd777be10$export$e7aee563f30091de; });
$parcel$export($9014d97cd777be10$exports, "RGBA_ASTC_10x10_Format", function () { return $9014d97cd777be10$export$2eb8634622ddeab7; });
$parcel$export($9014d97cd777be10$exports, "RGBA_ASTC_12x10_Format", function () { return $9014d97cd777be10$export$202b1ce7b5d25742; });
$parcel$export($9014d97cd777be10$exports, "RGBA_ASTC_12x12_Format", function () { return $9014d97cd777be10$export$18ab77abd087e467; });
$parcel$export($9014d97cd777be10$exports, "RGBA_BPTC_Format", function () { return $9014d97cd777be10$export$ce40b115e188bc81; });
$parcel$export($9014d97cd777be10$exports, "RED_RGTC1_Format", function () { return $9014d97cd777be10$export$b1688df4c4c21670; });
$parcel$export($9014d97cd777be10$exports, "SIGNED_RED_RGTC1_Format", function () { return $9014d97cd777be10$export$fc15e5d8261eed58; });
$parcel$export($9014d97cd777be10$exports, "RED_GREEN_RGTC2_Format", function () { return $9014d97cd777be10$export$d220f6ade8463a0f; });
$parcel$export($9014d97cd777be10$exports, "SIGNED_RED_GREEN_RGTC2_Format", function () { return $9014d97cd777be10$export$768646d09dc1b6ef; });
$parcel$export($9014d97cd777be10$exports, "LoopOnce", function () { return $9014d97cd777be10$export$d62fdc9d1b1cccad; });
$parcel$export($9014d97cd777be10$exports, "LoopRepeat", function () { return $9014d97cd777be10$export$dfaf4422ce096e29; });
$parcel$export($9014d97cd777be10$exports, "LoopPingPong", function () { return $9014d97cd777be10$export$f8f6f2041b78e210; });
$parcel$export($9014d97cd777be10$exports, "InterpolateDiscrete", function () { return $9014d97cd777be10$export$995b32462a65e855; });
$parcel$export($9014d97cd777be10$exports, "InterpolateLinear", function () { return $9014d97cd777be10$export$30fac1aace31cf4d; });
$parcel$export($9014d97cd777be10$exports, "InterpolateSmooth", function () { return $9014d97cd777be10$export$198b11ff4c72bb30; });
$parcel$export($9014d97cd777be10$exports, "ZeroCurvatureEnding", function () { return $9014d97cd777be10$export$7f795934b84ab523; });
$parcel$export($9014d97cd777be10$exports, "ZeroSlopeEnding", function () { return $9014d97cd777be10$export$24a4ccb5099273b5; });
$parcel$export($9014d97cd777be10$exports, "WrapAroundEnding", function () { return $9014d97cd777be10$export$8e8c3ecdcd8e1fee; });
$parcel$export($9014d97cd777be10$exports, "NormalAnimationBlendMode", function () { return $9014d97cd777be10$export$bcfbbdcf8de7f8cd; });
$parcel$export($9014d97cd777be10$exports, "AdditiveAnimationBlendMode", function () { return $9014d97cd777be10$export$d875e029ef558d3; });
$parcel$export($9014d97cd777be10$exports, "TrianglesDrawMode", function () { return $9014d97cd777be10$export$4c28c87c2dc84758; });
$parcel$export($9014d97cd777be10$exports, "TriangleStripDrawMode", function () { return $9014d97cd777be10$export$b23a071aa286eb29; });
$parcel$export($9014d97cd777be10$exports, "TriangleFanDrawMode", function () { return $9014d97cd777be10$export$f0d8293634f88842; });
$parcel$export($9014d97cd777be10$exports, "LinearEncoding", function () { return $9014d97cd777be10$export$7207336e4151a112; });
$parcel$export($9014d97cd777be10$exports, "sRGBEncoding", function () { return $9014d97cd777be10$export$f32388edbb32674; });
$parcel$export($9014d97cd777be10$exports, "BasicDepthPacking", function () { return $9014d97cd777be10$export$deeb383078690b50; });
$parcel$export($9014d97cd777be10$exports, "RGBADepthPacking", function () { return $9014d97cd777be10$export$8f910f4c4f73df11; });
$parcel$export($9014d97cd777be10$exports, "TangentSpaceNormalMap", function () { return $9014d97cd777be10$export$2852a58ebdac27b8; });
$parcel$export($9014d97cd777be10$exports, "ObjectSpaceNormalMap", function () { return $9014d97cd777be10$export$9990ad26f9db5b2c; });
$parcel$export($9014d97cd777be10$exports, "NoColorSpace", function () { return $9014d97cd777be10$export$bfcb490c2dd3db51; });
$parcel$export($9014d97cd777be10$exports, "SRGBColorSpace", function () { return $9014d97cd777be10$export$561f394b24edfcaa; });
$parcel$export($9014d97cd777be10$exports, "LinearSRGBColorSpace", function () { return $9014d97cd777be10$export$42429b3acfb233a4; });
$parcel$export($9014d97cd777be10$exports, "DisplayP3ColorSpace", function () { return $9014d97cd777be10$export$626af19ae879bdf6; });
$parcel$export($9014d97cd777be10$exports, "ZeroStencilOp", function () { return $9014d97cd777be10$export$69433f11f42d5527; });
$parcel$export($9014d97cd777be10$exports, "KeepStencilOp", function () { return $9014d97cd777be10$export$9f542ae4b5baca34; });
$parcel$export($9014d97cd777be10$exports, "ReplaceStencilOp", function () { return $9014d97cd777be10$export$8a4f28336ef203d3; });
$parcel$export($9014d97cd777be10$exports, "IncrementStencilOp", function () { return $9014d97cd777be10$export$2928c0231297c036; });
$parcel$export($9014d97cd777be10$exports, "DecrementStencilOp", function () { return $9014d97cd777be10$export$c0e9611c8a15f9a8; });
$parcel$export($9014d97cd777be10$exports, "IncrementWrapStencilOp", function () { return $9014d97cd777be10$export$9c2c08927385dcc4; });
$parcel$export($9014d97cd777be10$exports, "DecrementWrapStencilOp", function () { return $9014d97cd777be10$export$7c74ea00fa1315e6; });
$parcel$export($9014d97cd777be10$exports, "InvertStencilOp", function () { return $9014d97cd777be10$export$22e2e5726612443; });
$parcel$export($9014d97cd777be10$exports, "NeverStencilFunc", function () { return $9014d97cd777be10$export$1343870698229224; });
$parcel$export($9014d97cd777be10$exports, "LessStencilFunc", function () { return $9014d97cd777be10$export$8e1d8ed281997fa6; });
$parcel$export($9014d97cd777be10$exports, "EqualStencilFunc", function () { return $9014d97cd777be10$export$55648a1cde8329a7; });
$parcel$export($9014d97cd777be10$exports, "LessEqualStencilFunc", function () { return $9014d97cd777be10$export$2dff107857e6aca2; });
$parcel$export($9014d97cd777be10$exports, "GreaterStencilFunc", function () { return $9014d97cd777be10$export$6f93765ab2f451a2; });
$parcel$export($9014d97cd777be10$exports, "NotEqualStencilFunc", function () { return $9014d97cd777be10$export$6f3fb2d2440f2b76; });
$parcel$export($9014d97cd777be10$exports, "GreaterEqualStencilFunc", function () { return $9014d97cd777be10$export$4119cf7b4c98fd5a; });
$parcel$export($9014d97cd777be10$exports, "AlwaysStencilFunc", function () { return $9014d97cd777be10$export$14cf96713ddd97a8; });
$parcel$export($9014d97cd777be10$exports, "NeverCompare", function () { return $9014d97cd777be10$export$d9e2d19a747baaab; });
$parcel$export($9014d97cd777be10$exports, "LessCompare", function () { return $9014d97cd777be10$export$36bcf49c713b3eb7; });
$parcel$export($9014d97cd777be10$exports, "EqualCompare", function () { return $9014d97cd777be10$export$66f28d946fc6a0d5; });
$parcel$export($9014d97cd777be10$exports, "LessEqualCompare", function () { return $9014d97cd777be10$export$64eea11eb407ddf1; });
$parcel$export($9014d97cd777be10$exports, "GreaterCompare", function () { return $9014d97cd777be10$export$155af022118f3a38; });
$parcel$export($9014d97cd777be10$exports, "NotEqualCompare", function () { return $9014d97cd777be10$export$67ab95dde6bed156; });
$parcel$export($9014d97cd777be10$exports, "GreaterEqualCompare", function () { return $9014d97cd777be10$export$1cdcb70d53d65f61; });
$parcel$export($9014d97cd777be10$exports, "AlwaysCompare", function () { return $9014d97cd777be10$export$187b73a3e352c145; });
$parcel$export($9014d97cd777be10$exports, "StaticDrawUsage", function () { return $9014d97cd777be10$export$763e8360f4d7f77d; });
$parcel$export($9014d97cd777be10$exports, "DynamicDrawUsage", function () { return $9014d97cd777be10$export$8505d14ac8546ca; });
$parcel$export($9014d97cd777be10$exports, "StreamDrawUsage", function () { return $9014d97cd777be10$export$721e63549e51d81e; });
$parcel$export($9014d97cd777be10$exports, "StaticReadUsage", function () { return $9014d97cd777be10$export$415731dc4f48e299; });
$parcel$export($9014d97cd777be10$exports, "DynamicReadUsage", function () { return $9014d97cd777be10$export$9e809946455f13bc; });
$parcel$export($9014d97cd777be10$exports, "StreamReadUsage", function () { return $9014d97cd777be10$export$2ed9499a35b5f832; });
$parcel$export($9014d97cd777be10$exports, "StaticCopyUsage", function () { return $9014d97cd777be10$export$32ab2503ea19469a; });
$parcel$export($9014d97cd777be10$exports, "DynamicCopyUsage", function () { return $9014d97cd777be10$export$ab4022c2c3f86315; });
$parcel$export($9014d97cd777be10$exports, "StreamCopyUsage", function () { return $9014d97cd777be10$export$ba7f1db36a76a970; });
$parcel$export($9014d97cd777be10$exports, "GLSL1", function () { return $9014d97cd777be10$export$43600cc67fabd9f; });
$parcel$export($9014d97cd777be10$exports, "GLSL3", function () { return $9014d97cd777be10$export$f63012db5506e7dd; });
$parcel$export($9014d97cd777be10$exports, "_SRGBAFormat", function () { return $9014d97cd777be10$export$ca1dce8b5e1de74d; });
$parcel$export($9014d97cd777be10$exports, "WebGLCoordinateSystem", function () { return $9014d97cd777be10$export$5a0e9190d10875d3; });
$parcel$export($9014d97cd777be10$exports, "WebGPUCoordinateSystem", function () { return $9014d97cd777be10$export$cc83beedcb9be9ac; });
$parcel$export($9014d97cd777be10$exports, "EventDispatcher", function () { return $9014d97cd777be10$export$ec8b666c5fe2c75a; });
$parcel$export($9014d97cd777be10$exports, "MathUtils", function () { return $9014d97cd777be10$export$6a7ef315a0d1ef07; });
$parcel$export($9014d97cd777be10$exports, "Vector2", function () { return $9014d97cd777be10$export$c977b3e384af9ae1; });
$parcel$export($9014d97cd777be10$exports, "Matrix3", function () { return $9014d97cd777be10$export$8ff26dafa08918; });
$parcel$export($9014d97cd777be10$exports, "ColorManagement", function () { return $9014d97cd777be10$export$5e6fd513f44698c; });
$parcel$export($9014d97cd777be10$exports, "ImageUtils", function () { return $9014d97cd777be10$export$698882cf06df44aa; });
$parcel$export($9014d97cd777be10$exports, "Source", function () { return $9014d97cd777be10$export$1d2df86270c81ecb; });
$parcel$export($9014d97cd777be10$exports, "Texture", function () { return $9014d97cd777be10$export$5431306cf43de24a; });
$parcel$export($9014d97cd777be10$exports, "Vector4", function () { return $9014d97cd777be10$export$fa7daccca11cdbe3; });
$parcel$export($9014d97cd777be10$exports, "RenderTarget", function () { return $9014d97cd777be10$export$efcb1f8bf367cbfb; });
$parcel$export($9014d97cd777be10$exports, "WebGLRenderTarget", function () { return $9014d97cd777be10$export$3c052beb2e51e23f; });
$parcel$export($9014d97cd777be10$exports, "DataArrayTexture", function () { return $9014d97cd777be10$export$dfac6c8e811406a3; });
$parcel$export($9014d97cd777be10$exports, "WebGLArrayRenderTarget", function () { return $9014d97cd777be10$export$c77a02c11ed180c7; });
$parcel$export($9014d97cd777be10$exports, "Data3DTexture", function () { return $9014d97cd777be10$export$d7a3086320f856db; });
$parcel$export($9014d97cd777be10$exports, "WebGL3DRenderTarget", function () { return $9014d97cd777be10$export$7ee06591009639df; });
$parcel$export($9014d97cd777be10$exports, "WebGLMultipleRenderTargets", function () { return $9014d97cd777be10$export$bd934554fb721730; });
$parcel$export($9014d97cd777be10$exports, "Quaternion", function () { return $9014d97cd777be10$export$23d6a54f0bbc85a3; });
$parcel$export($9014d97cd777be10$exports, "Vector3", function () { return $9014d97cd777be10$export$64b5c384219d3699; });
$parcel$export($9014d97cd777be10$exports, "Box3", function () { return $9014d97cd777be10$export$6f7d5a9418ab2aa3; });
$parcel$export($9014d97cd777be10$exports, "Sphere", function () { return $9014d97cd777be10$export$805e8b72413ccaba; });
$parcel$export($9014d97cd777be10$exports, "Ray", function () { return $9014d97cd777be10$export$a186db52eed6d40e; });
$parcel$export($9014d97cd777be10$exports, "Matrix4", function () { return $9014d97cd777be10$export$2ae72fc923e5eb5; });
$parcel$export($9014d97cd777be10$exports, "Euler", function () { return $9014d97cd777be10$export$d93cc409a0768c5f; });
$parcel$export($9014d97cd777be10$exports, "Layers", function () { return $9014d97cd777be10$export$89312ce47c0ca777; });
$parcel$export($9014d97cd777be10$exports, "Object3D", function () { return $9014d97cd777be10$export$e4dd07dff30cc924; });
$parcel$export($9014d97cd777be10$exports, "Triangle", function () { return $9014d97cd777be10$export$5a465592bfe74b48; });
$parcel$export($9014d97cd777be10$exports, "Material", function () { return $9014d97cd777be10$export$a2d8b23205c25948; });
$parcel$export($9014d97cd777be10$exports, "Color", function () { return $9014d97cd777be10$export$892596cec99bc70e; });
$parcel$export($9014d97cd777be10$exports, "MeshBasicMaterial", function () { return $9014d97cd777be10$export$55cbcc9b622fe1f5; });
$parcel$export($9014d97cd777be10$exports, "DataUtils", function () { return $9014d97cd777be10$export$11ce8b759162cc80; });
$parcel$export($9014d97cd777be10$exports, "BufferAttribute", function () { return $9014d97cd777be10$export$8dea267bd6bde117; });
$parcel$export($9014d97cd777be10$exports, "Int8BufferAttribute", function () { return $9014d97cd777be10$export$f9ff2d6a20248cbf; });
$parcel$export($9014d97cd777be10$exports, "Uint8BufferAttribute", function () { return $9014d97cd777be10$export$cacc90cf35d11cdd; });
$parcel$export($9014d97cd777be10$exports, "Uint8ClampedBufferAttribute", function () { return $9014d97cd777be10$export$baaa85a1a812c157; });
$parcel$export($9014d97cd777be10$exports, "Int16BufferAttribute", function () { return $9014d97cd777be10$export$2b755a102ccdcefe; });
$parcel$export($9014d97cd777be10$exports, "Uint16BufferAttribute", function () { return $9014d97cd777be10$export$640a853f68025f2e; });
$parcel$export($9014d97cd777be10$exports, "Int32BufferAttribute", function () { return $9014d97cd777be10$export$46b369aed2968a0a; });
$parcel$export($9014d97cd777be10$exports, "Uint32BufferAttribute", function () { return $9014d97cd777be10$export$7eb8c9fa25cd5bd6; });
$parcel$export($9014d97cd777be10$exports, "Float16BufferAttribute", function () { return $9014d97cd777be10$export$dbd3698c64958d69; });
$parcel$export($9014d97cd777be10$exports, "Float32BufferAttribute", function () { return $9014d97cd777be10$export$cbe7a62641830ebd; });
$parcel$export($9014d97cd777be10$exports, "Float64BufferAttribute", function () { return $9014d97cd777be10$export$9e0ade74842adbb8; });
$parcel$export($9014d97cd777be10$exports, "BufferGeometry", function () { return $9014d97cd777be10$export$b7be63a67df8959; });
$parcel$export($9014d97cd777be10$exports, "Mesh", function () { return $9014d97cd777be10$export$e176487c05830cc5; });
$parcel$export($9014d97cd777be10$exports, "BoxGeometry", function () { return $9014d97cd777be10$export$33e43285f7406bd5; });
$parcel$export($9014d97cd777be10$exports, "UniformsUtils", function () { return $9014d97cd777be10$export$d8ecdf8615bfea69; });
$parcel$export($9014d97cd777be10$exports, "ShaderMaterial", function () { return $9014d97cd777be10$export$83c7d75d550a8b0d; });
$parcel$export($9014d97cd777be10$exports, "Camera", function () { return $9014d97cd777be10$export$79f141de891a5fed; });
$parcel$export($9014d97cd777be10$exports, "PerspectiveCamera", function () { return $9014d97cd777be10$export$74e4ae24825f68d7; });
$parcel$export($9014d97cd777be10$exports, "CubeCamera", function () { return $9014d97cd777be10$export$d0cdd0bd804995de; });
$parcel$export($9014d97cd777be10$exports, "CubeTexture", function () { return $9014d97cd777be10$export$ee2e5a18258a4049; });
$parcel$export($9014d97cd777be10$exports, "WebGLCubeRenderTarget", function () { return $9014d97cd777be10$export$ac386671d651941e; });
$parcel$export($9014d97cd777be10$exports, "Plane", function () { return $9014d97cd777be10$export$7ff5ac152ef991b0; });
$parcel$export($9014d97cd777be10$exports, "Frustum", function () { return $9014d97cd777be10$export$35efe6f4c85463d2; });
$parcel$export($9014d97cd777be10$exports, "PlaneGeometry", function () { return $9014d97cd777be10$export$967d831af31f69ce; });
$parcel$export($9014d97cd777be10$exports, "ShaderChunk", function () { return $9014d97cd777be10$export$955f9f2e84c43c8b; });
$parcel$export($9014d97cd777be10$exports, "UniformsLib", function () { return $9014d97cd777be10$export$6643083551874bf5; });
$parcel$export($9014d97cd777be10$exports, "ShaderLib", function () { return $9014d97cd777be10$export$bee4a7d47f8f5014; });
$parcel$export($9014d97cd777be10$exports, "OrthographicCamera", function () { return $9014d97cd777be10$export$9ebf355ee4ed261b; });
$parcel$export($9014d97cd777be10$exports, "PMREMGenerator", function () { return $9014d97cd777be10$export$6add42717753e221; });
$parcel$export($9014d97cd777be10$exports, "MeshDepthMaterial", function () { return $9014d97cd777be10$export$2698c22ec13825db; });
$parcel$export($9014d97cd777be10$exports, "MeshDistanceMaterial", function () { return $9014d97cd777be10$export$33e187ed002f2a19; });
$parcel$export($9014d97cd777be10$exports, "WebGLUtils", function () { return $9014d97cd777be10$export$ddaebcad857649a8; });
$parcel$export($9014d97cd777be10$exports, "ArrayCamera", function () { return $9014d97cd777be10$export$56b937d9e5581166; });
$parcel$export($9014d97cd777be10$exports, "Group", function () { return $9014d97cd777be10$export$eb2fcfdbd7ba97d4; });
$parcel$export($9014d97cd777be10$exports, "DepthTexture", function () { return $9014d97cd777be10$export$fc830aa069cc8c2f; });
$parcel$export($9014d97cd777be10$exports, "WebGLRenderer", function () { return $9014d97cd777be10$export$f6cc00ef28d7cf97; });
$parcel$export($9014d97cd777be10$exports, "WebGL1Renderer", function () { return $9014d97cd777be10$export$a2f65229194348f9; });
$parcel$export($9014d97cd777be10$exports, "FogExp2", function () { return $9014d97cd777be10$export$6f1519f023b8d0f6; });
$parcel$export($9014d97cd777be10$exports, "Fog", function () { return $9014d97cd777be10$export$3c890837b09508d4; });
$parcel$export($9014d97cd777be10$exports, "Scene", function () { return $9014d97cd777be10$export$38af1803e3442a7f; });
$parcel$export($9014d97cd777be10$exports, "InterleavedBuffer", function () { return $9014d97cd777be10$export$3d5cd879f108f53f; });
$parcel$export($9014d97cd777be10$exports, "InterleavedBufferAttribute", function () { return $9014d97cd777be10$export$920b6d07334599c7; });
$parcel$export($9014d97cd777be10$exports, "SpriteMaterial", function () { return $9014d97cd777be10$export$5ec7dd1c6994bf8e; });
$parcel$export($9014d97cd777be10$exports, "Sprite", function () { return $9014d97cd777be10$export$3075603db8e6204c; });
$parcel$export($9014d97cd777be10$exports, "LOD", function () { return $9014d97cd777be10$export$112e7237be0c5f30; });
$parcel$export($9014d97cd777be10$exports, "SkinnedMesh", function () { return $9014d97cd777be10$export$b303577035157ecf; });
$parcel$export($9014d97cd777be10$exports, "Bone", function () { return $9014d97cd777be10$export$b127726e56765aa4; });
$parcel$export($9014d97cd777be10$exports, "DataTexture", function () { return $9014d97cd777be10$export$b691f601014eabe1; });
$parcel$export($9014d97cd777be10$exports, "Skeleton", function () { return $9014d97cd777be10$export$8f31e4c4a37b8e9c; });
$parcel$export($9014d97cd777be10$exports, "InstancedBufferAttribute", function () { return $9014d97cd777be10$export$32ea87a8b54d744a; });
$parcel$export($9014d97cd777be10$exports, "InstancedMesh", function () { return $9014d97cd777be10$export$f3c979c331175ad7; });
$parcel$export($9014d97cd777be10$exports, "LineBasicMaterial", function () { return $9014d97cd777be10$export$fbaaa33907730a0c; });
$parcel$export($9014d97cd777be10$exports, "Line", function () { return $9014d97cd777be10$export$17d680238e50603e; });
$parcel$export($9014d97cd777be10$exports, "LineSegments", function () { return $9014d97cd777be10$export$ff1ed10fedfdd604; });
$parcel$export($9014d97cd777be10$exports, "LineLoop", function () { return $9014d97cd777be10$export$f85a24d745e4f17d; });
$parcel$export($9014d97cd777be10$exports, "PointsMaterial", function () { return $9014d97cd777be10$export$a178c45366ce5d6b; });
$parcel$export($9014d97cd777be10$exports, "Points", function () { return $9014d97cd777be10$export$1c787534cb11aa3e; });
$parcel$export($9014d97cd777be10$exports, "VideoTexture", function () { return $9014d97cd777be10$export$6e09d1edf8d5a25c; });
$parcel$export($9014d97cd777be10$exports, "FramebufferTexture", function () { return $9014d97cd777be10$export$9270d786f73ce6fe; });
$parcel$export($9014d97cd777be10$exports, "CompressedTexture", function () { return $9014d97cd777be10$export$3466bac9141a5cc4; });
$parcel$export($9014d97cd777be10$exports, "CompressedArrayTexture", function () { return $9014d97cd777be10$export$5fe6b8e34b274fcb; });
$parcel$export($9014d97cd777be10$exports, "CompressedCubeTexture", function () { return $9014d97cd777be10$export$d80173634de65bff; });
$parcel$export($9014d97cd777be10$exports, "CanvasTexture", function () { return $9014d97cd777be10$export$f7189e49152d1c13; });
$parcel$export($9014d97cd777be10$exports, "Curve", function () { return $9014d97cd777be10$export$b0e83c3ef8d2db1; });
$parcel$export($9014d97cd777be10$exports, "EllipseCurve", function () { return $9014d97cd777be10$export$3f87a931616cde04; });
$parcel$export($9014d97cd777be10$exports, "ArcCurve", function () { return $9014d97cd777be10$export$b1eedc9aab6300e8; });
$parcel$export($9014d97cd777be10$exports, "CatmullRomCurve3", function () { return $9014d97cd777be10$export$b9146b27c24b744c; });
$parcel$export($9014d97cd777be10$exports, "CubicBezierCurve", function () { return $9014d97cd777be10$export$e36650d36468bb39; });
$parcel$export($9014d97cd777be10$exports, "CubicBezierCurve3", function () { return $9014d97cd777be10$export$13d5f1c9525f246c; });
$parcel$export($9014d97cd777be10$exports, "LineCurve", function () { return $9014d97cd777be10$export$ab2e07e76531a47e; });
$parcel$export($9014d97cd777be10$exports, "LineCurve3", function () { return $9014d97cd777be10$export$1fdfd9d9cf487600; });
$parcel$export($9014d97cd777be10$exports, "QuadraticBezierCurve", function () { return $9014d97cd777be10$export$5938c4ee491a43ad; });
$parcel$export($9014d97cd777be10$exports, "QuadraticBezierCurve3", function () { return $9014d97cd777be10$export$bf3f4c7e459f90fc; });
$parcel$export($9014d97cd777be10$exports, "SplineCurve", function () { return $9014d97cd777be10$export$d3bdd77da77afc1b; });
$parcel$export($9014d97cd777be10$exports, "CurvePath", function () { return $9014d97cd777be10$export$4aaf9b66af1bbf2c; });
$parcel$export($9014d97cd777be10$exports, "Path", function () { return $9014d97cd777be10$export$4b2950bdac9b6ee9; });
$parcel$export($9014d97cd777be10$exports, "LatheGeometry", function () { return $9014d97cd777be10$export$6d839803fcd1882c; });
$parcel$export($9014d97cd777be10$exports, "CapsuleGeometry", function () { return $9014d97cd777be10$export$41680e8551036033; });
$parcel$export($9014d97cd777be10$exports, "CircleGeometry", function () { return $9014d97cd777be10$export$d5c0e8d607467193; });
$parcel$export($9014d97cd777be10$exports, "CylinderGeometry", function () { return $9014d97cd777be10$export$68f745719dbe5198; });
$parcel$export($9014d97cd777be10$exports, "ConeGeometry", function () { return $9014d97cd777be10$export$a7a48974f285c9b3; });
$parcel$export($9014d97cd777be10$exports, "PolyhedronGeometry", function () { return $9014d97cd777be10$export$60e57a7d3f20ff65; });
$parcel$export($9014d97cd777be10$exports, "DodecahedronGeometry", function () { return $9014d97cd777be10$export$c0babfeb8708fc9c; });
$parcel$export($9014d97cd777be10$exports, "EdgesGeometry", function () { return $9014d97cd777be10$export$4730b1542707547f; });
$parcel$export($9014d97cd777be10$exports, "Shape", function () { return $9014d97cd777be10$export$6428a7f2611ef1fa; });
$parcel$export($9014d97cd777be10$exports, "ShapeUtils", function () { return $9014d97cd777be10$export$96bdf6d9c66d7ba8; });
$parcel$export($9014d97cd777be10$exports, "ExtrudeGeometry", function () { return $9014d97cd777be10$export$598697a1efa63ca7; });
$parcel$export($9014d97cd777be10$exports, "IcosahedronGeometry", function () { return $9014d97cd777be10$export$9567cc828c9535da; });
$parcel$export($9014d97cd777be10$exports, "OctahedronGeometry", function () { return $9014d97cd777be10$export$1954e2b809fe361e; });
$parcel$export($9014d97cd777be10$exports, "RingGeometry", function () { return $9014d97cd777be10$export$68cb731f50f614af; });
$parcel$export($9014d97cd777be10$exports, "ShapeGeometry", function () { return $9014d97cd777be10$export$57a29a1c803e9065; });
$parcel$export($9014d97cd777be10$exports, "SphereGeometry", function () { return $9014d97cd777be10$export$1b417fc3b307a251; });
$parcel$export($9014d97cd777be10$exports, "TetrahedronGeometry", function () { return $9014d97cd777be10$export$fb3f7adc68bd6e02; });
$parcel$export($9014d97cd777be10$exports, "TorusGeometry", function () { return $9014d97cd777be10$export$a2312a2a1fa56495; });
$parcel$export($9014d97cd777be10$exports, "TorusKnotGeometry", function () { return $9014d97cd777be10$export$77e9bfadfb9ab8c8; });
$parcel$export($9014d97cd777be10$exports, "TubeGeometry", function () { return $9014d97cd777be10$export$7897d9d48904490c; });
$parcel$export($9014d97cd777be10$exports, "WireframeGeometry", function () { return $9014d97cd777be10$export$4b739da06d24892b; });
$parcel$export($9014d97cd777be10$exports, "ShadowMaterial", function () { return $9014d97cd777be10$export$e8564da406055a3; });
$parcel$export($9014d97cd777be10$exports, "RawShaderMaterial", function () { return $9014d97cd777be10$export$21c421a2e1df9d22; });
$parcel$export($9014d97cd777be10$exports, "MeshStandardMaterial", function () { return $9014d97cd777be10$export$f2980790215acccd; });
$parcel$export($9014d97cd777be10$exports, "MeshPhysicalMaterial", function () { return $9014d97cd777be10$export$28d04986c4269c9f; });
$parcel$export($9014d97cd777be10$exports, "MeshPhongMaterial", function () { return $9014d97cd777be10$export$24c72f71cbaf0678; });
$parcel$export($9014d97cd777be10$exports, "MeshToonMaterial", function () { return $9014d97cd777be10$export$df893cf97e765622; });
$parcel$export($9014d97cd777be10$exports, "MeshNormalMaterial", function () { return $9014d97cd777be10$export$bfe8c0a091f41ae7; });
$parcel$export($9014d97cd777be10$exports, "MeshLambertMaterial", function () { return $9014d97cd777be10$export$5023a9a8114806b8; });
$parcel$export($9014d97cd777be10$exports, "MeshMatcapMaterial", function () { return $9014d97cd777be10$export$6f5fef6235ec12ee; });
$parcel$export($9014d97cd777be10$exports, "LineDashedMaterial", function () { return $9014d97cd777be10$export$327886a3efaeaebe; });
$parcel$export($9014d97cd777be10$exports, "AnimationUtils", function () { return $9014d97cd777be10$export$7ee8caa573e71ad1; });
$parcel$export($9014d97cd777be10$exports, "Interpolant", function () { return $9014d97cd777be10$export$b558baee9c0f72d3; });
$parcel$export($9014d97cd777be10$exports, "CubicInterpolant", function () { return $9014d97cd777be10$export$3646682e7a3959; });
$parcel$export($9014d97cd777be10$exports, "LinearInterpolant", function () { return $9014d97cd777be10$export$a8e6009059f51e1a; });
$parcel$export($9014d97cd777be10$exports, "DiscreteInterpolant", function () { return $9014d97cd777be10$export$fb9758ef7ef8d5cc; });
$parcel$export($9014d97cd777be10$exports, "KeyframeTrack", function () { return $9014d97cd777be10$export$b0e479f45b7006d6; });
$parcel$export($9014d97cd777be10$exports, "BooleanKeyframeTrack", function () { return $9014d97cd777be10$export$d3a344b98cf0b775; });
$parcel$export($9014d97cd777be10$exports, "ColorKeyframeTrack", function () { return $9014d97cd777be10$export$83444c5d885347d8; });
$parcel$export($9014d97cd777be10$exports, "NumberKeyframeTrack", function () { return $9014d97cd777be10$export$d45f0d1a4d9a9314; });
$parcel$export($9014d97cd777be10$exports, "QuaternionLinearInterpolant", function () { return $9014d97cd777be10$export$2db1cfb7923d931e; });
$parcel$export($9014d97cd777be10$exports, "QuaternionKeyframeTrack", function () { return $9014d97cd777be10$export$b8043f12b5aafbd7; });
$parcel$export($9014d97cd777be10$exports, "StringKeyframeTrack", function () { return $9014d97cd777be10$export$6ce41d4f3a8df9cd; });
$parcel$export($9014d97cd777be10$exports, "VectorKeyframeTrack", function () { return $9014d97cd777be10$export$5ce2dcb4cc9f2bff; });
$parcel$export($9014d97cd777be10$exports, "AnimationClip", function () { return $9014d97cd777be10$export$d942c706bf23829c; });
$parcel$export($9014d97cd777be10$exports, "Cache", function () { return $9014d97cd777be10$export$94affb487e701bf2; });
$parcel$export($9014d97cd777be10$exports, "LoadingManager", function () { return $9014d97cd777be10$export$99cc795e99919eed; });
$parcel$export($9014d97cd777be10$exports, "DefaultLoadingManager", function () { return $9014d97cd777be10$export$b033c3f9a95c6a16; });
$parcel$export($9014d97cd777be10$exports, "Loader", function () { return $9014d97cd777be10$export$3b0d6d7590275603; });
$parcel$export($9014d97cd777be10$exports, "FileLoader", function () { return $9014d97cd777be10$export$98435a25b5cf7b2b; });
$parcel$export($9014d97cd777be10$exports, "AnimationLoader", function () { return $9014d97cd777be10$export$29711c7e14f61db; });
$parcel$export($9014d97cd777be10$exports, "CompressedTextureLoader", function () { return $9014d97cd777be10$export$bd73ce947a280350; });
$parcel$export($9014d97cd777be10$exports, "ImageLoader", function () { return $9014d97cd777be10$export$8905ce1c7a2464a1; });
$parcel$export($9014d97cd777be10$exports, "CubeTextureLoader", function () { return $9014d97cd777be10$export$2ec114afc2cf6308; });
$parcel$export($9014d97cd777be10$exports, "DataTextureLoader", function () { return $9014d97cd777be10$export$792d8a18f2c55855; });
$parcel$export($9014d97cd777be10$exports, "TextureLoader", function () { return $9014d97cd777be10$export$fd1bfc71f64c538c; });
$parcel$export($9014d97cd777be10$exports, "Light", function () { return $9014d97cd777be10$export$6ecadb6ed240d696; });
$parcel$export($9014d97cd777be10$exports, "HemisphereLight", function () { return $9014d97cd777be10$export$8d474f55edbb9624; });
$parcel$export($9014d97cd777be10$exports, "SpotLight", function () { return $9014d97cd777be10$export$81495cbb73897362; });
$parcel$export($9014d97cd777be10$exports, "PointLight", function () { return $9014d97cd777be10$export$4c9c1cb3f0b6f455; });
$parcel$export($9014d97cd777be10$exports, "DirectionalLight", function () { return $9014d97cd777be10$export$3fea33cc9972c868; });
$parcel$export($9014d97cd777be10$exports, "AmbientLight", function () { return $9014d97cd777be10$export$af279bfef9ec2c96; });
$parcel$export($9014d97cd777be10$exports, "RectAreaLight", function () { return $9014d97cd777be10$export$61db2d908bbd2429; });
$parcel$export($9014d97cd777be10$exports, "SphericalHarmonics3", function () { return $9014d97cd777be10$export$ba61ce607e1f405a; });
$parcel$export($9014d97cd777be10$exports, "LightProbe", function () { return $9014d97cd777be10$export$e7ef036e309b38d2; });
$parcel$export($9014d97cd777be10$exports, "MaterialLoader", function () { return $9014d97cd777be10$export$3bd6d323353dcf96; });
$parcel$export($9014d97cd777be10$exports, "LoaderUtils", function () { return $9014d97cd777be10$export$b5d2dc08d867e41a; });
$parcel$export($9014d97cd777be10$exports, "InstancedBufferGeometry", function () { return $9014d97cd777be10$export$231f009cbe414146; });
$parcel$export($9014d97cd777be10$exports, "BufferGeometryLoader", function () { return $9014d97cd777be10$export$dc275bb96327833a; });
$parcel$export($9014d97cd777be10$exports, "ObjectLoader", function () { return $9014d97cd777be10$export$40110c8505c5ad19; });
$parcel$export($9014d97cd777be10$exports, "ImageBitmapLoader", function () { return $9014d97cd777be10$export$52286b55c4a9b51f; });
$parcel$export($9014d97cd777be10$exports, "AudioContext", function () { return $9014d97cd777be10$export$fcbc63750ec2a81f; });
$parcel$export($9014d97cd777be10$exports, "AudioLoader", function () { return $9014d97cd777be10$export$d8d5fccfbf47714e; });
$parcel$export($9014d97cd777be10$exports, "HemisphereLightProbe", function () { return $9014d97cd777be10$export$2f22dadc8bc42820; });
$parcel$export($9014d97cd777be10$exports, "AmbientLightProbe", function () { return $9014d97cd777be10$export$afe310a21c86023d; });
$parcel$export($9014d97cd777be10$exports, "StereoCamera", function () { return $9014d97cd777be10$export$bc7f73a1065bee0c; });
$parcel$export($9014d97cd777be10$exports, "Clock", function () { return $9014d97cd777be10$export$9735c82c4bae3302; });
$parcel$export($9014d97cd777be10$exports, "AudioListener", function () { return $9014d97cd777be10$export$8a1b810c6fde8951; });
$parcel$export($9014d97cd777be10$exports, "Audio", function () { return $9014d97cd777be10$export$153755f98d9861de; });
$parcel$export($9014d97cd777be10$exports, "PositionalAudio", function () { return $9014d97cd777be10$export$4b3e397ef1832507; });
$parcel$export($9014d97cd777be10$exports, "AudioAnalyser", function () { return $9014d97cd777be10$export$d47da1ef3d382827; });
$parcel$export($9014d97cd777be10$exports, "PropertyMixer", function () { return $9014d97cd777be10$export$dfe0af1ca1acb78a; });
$parcel$export($9014d97cd777be10$exports, "PropertyBinding", function () { return $9014d97cd777be10$export$7bf70fcf9f891893; });
$parcel$export($9014d97cd777be10$exports, "AnimationObjectGroup", function () { return $9014d97cd777be10$export$30619c2afd3f34db; });
$parcel$export($9014d97cd777be10$exports, "AnimationAction", function () { return $9014d97cd777be10$export$6946940a69e799e; });
$parcel$export($9014d97cd777be10$exports, "AnimationMixer", function () { return $9014d97cd777be10$export$fbd77e5aefaa0102; });
$parcel$export($9014d97cd777be10$exports, "Uniform", function () { return $9014d97cd777be10$export$2947cebfe91c02f8; });
$parcel$export($9014d97cd777be10$exports, "UniformsGroup", function () { return $9014d97cd777be10$export$c412d5ffe1f79209; });
$parcel$export($9014d97cd777be10$exports, "InstancedInterleavedBuffer", function () { return $9014d97cd777be10$export$25ec0e1af1389358; });
$parcel$export($9014d97cd777be10$exports, "GLBufferAttribute", function () { return $9014d97cd777be10$export$6b7339ae8dbddf73; });
$parcel$export($9014d97cd777be10$exports, "Raycaster", function () { return $9014d97cd777be10$export$8b7aaceff00bd2f; });
$parcel$export($9014d97cd777be10$exports, "Spherical", function () { return $9014d97cd777be10$export$d712cd887b4a00f7; });
$parcel$export($9014d97cd777be10$exports, "Cylindrical", function () { return $9014d97cd777be10$export$287165bb2177f4fd; });
$parcel$export($9014d97cd777be10$exports, "Box2", function () { return $9014d97cd777be10$export$60f553fa130f08b0; });
$parcel$export($9014d97cd777be10$exports, "Line3", function () { return $9014d97cd777be10$export$e0ba6359f1954fd3; });
$parcel$export($9014d97cd777be10$exports, "SpotLightHelper", function () { return $9014d97cd777be10$export$4b14638ffdd81e68; });
$parcel$export($9014d97cd777be10$exports, "SkeletonHelper", function () { return $9014d97cd777be10$export$5277df3c9e732259; });
$parcel$export($9014d97cd777be10$exports, "PointLightHelper", function () { return $9014d97cd777be10$export$9a9291685b9e4023; });
$parcel$export($9014d97cd777be10$exports, "HemisphereLightHelper", function () { return $9014d97cd777be10$export$8dca15f13f4f8172; });
$parcel$export($9014d97cd777be10$exports, "GridHelper", function () { return $9014d97cd777be10$export$3875d39926561055; });
$parcel$export($9014d97cd777be10$exports, "PolarGridHelper", function () { return $9014d97cd777be10$export$361430a10f533cd3; });
$parcel$export($9014d97cd777be10$exports, "DirectionalLightHelper", function () { return $9014d97cd777be10$export$f8e434dc14203e7d; });
$parcel$export($9014d97cd777be10$exports, "CameraHelper", function () { return $9014d97cd777be10$export$ed8e93f853cd795; });
$parcel$export($9014d97cd777be10$exports, "BoxHelper", function () { return $9014d97cd777be10$export$38a664cc862a6a9d; });
$parcel$export($9014d97cd777be10$exports, "Box3Helper", function () { return $9014d97cd777be10$export$ce39f4bb96c9a290; });
$parcel$export($9014d97cd777be10$exports, "PlaneHelper", function () { return $9014d97cd777be10$export$a34fe8156c66e5d7; });
$parcel$export($9014d97cd777be10$exports, "ArrowHelper", function () { return $9014d97cd777be10$export$a3008e7bd8d2cbe7; });
$parcel$export($9014d97cd777be10$exports, "AxesHelper", function () { return $9014d97cd777be10$export$6c8303f35b8578fd; });
$parcel$export($9014d97cd777be10$exports, "ShapePath", function () { return $9014d97cd777be10$export$148534a3c727230b; });
/**
 * @license
 * Copyright 2010-2023 Three.js Authors
 * SPDX-License-Identifier: MIT
 */ const $9014d97cd777be10$export$3545e07a80636437 = "155";
const $9014d97cd777be10$export$7177b3e430c2d7ca = {
    LEFT: 0,
    MIDDLE: 1,
    RIGHT: 2,
    ROTATE: 0,
    DOLLY: 1,
    PAN: 2
};
const $9014d97cd777be10$export$d46bd3ead7cc759b = {
    ROTATE: 0,
    PAN: 1,
    DOLLY_PAN: 2,
    DOLLY_ROTATE: 3
};
const $9014d97cd777be10$export$3237e1f2c1ea1f44 = 0;
const $9014d97cd777be10$export$b9a7b4fc5cb15f9b = 1;
const $9014d97cd777be10$export$b8058bcc7037d3f3 = 2;
const $9014d97cd777be10$export$f24be24dcddeac0d = 3;
const $9014d97cd777be10$export$346307dbae2b7447 = 0;
const $9014d97cd777be10$export$5813f879eee7cd88 = 1;
const $9014d97cd777be10$export$a47c4b43a1be34f0 = 2;
const $9014d97cd777be10$export$896ae1ade6c829c4 = 3;
const $9014d97cd777be10$export$2ede184fc2998901 = 0;
const $9014d97cd777be10$export$d9f0486e75b5ace = 1;
const $9014d97cd777be10$export$3b296b6f144d5b03 = 2;
const $9014d97cd777be10$export$211211c00f97204d = 2; // r149
const $9014d97cd777be10$export$63b8d6b580fc65ba = 0;
const $9014d97cd777be10$export$5b29a26d96ee6af0 = 1;
const $9014d97cd777be10$export$777d8f9551c2216b = 2;
const $9014d97cd777be10$export$cdfa06f868e2e467 = 3;
const $9014d97cd777be10$export$4138e1c684b46a20 = 4;
const $9014d97cd777be10$export$eda4864c68df1fa2 = 5;
const $9014d97cd777be10$export$20183a0484ce21a0 = 100;
const $9014d97cd777be10$export$73e0df5177988548 = 101;
const $9014d97cd777be10$export$28e582859cbec660 = 102;
const $9014d97cd777be10$export$c8c1508da8d0600c = 103;
const $9014d97cd777be10$export$99948c02fb51055f = 104;
const $9014d97cd777be10$export$2110f05edf778d3d = 200;
const $9014d97cd777be10$export$8805bad65e24940e = 201;
const $9014d97cd777be10$export$7fbe15b28d28cf52 = 202;
const $9014d97cd777be10$export$947829af9f2c17f6 = 203;
const $9014d97cd777be10$export$d5773124e86cf28c = 204;
const $9014d97cd777be10$export$11d468cc7f19e971 = 205;
const $9014d97cd777be10$export$a78aed1ca2a87192 = 206;
const $9014d97cd777be10$export$5d0fe17fd8773bac = 207;
const $9014d97cd777be10$export$ef5f2dd8ffac5574 = 208;
const $9014d97cd777be10$export$56b85b2686ab16 = 209;
const $9014d97cd777be10$export$c05e2a1fc8609506 = 210;
const $9014d97cd777be10$export$69025ce147cee220 = 0;
const $9014d97cd777be10$export$7182eb52ea3b3f04 = 1;
const $9014d97cd777be10$export$eedccec66ab7ebe = 2;
const $9014d97cd777be10$export$296f78a0b892f81a = 3;
const $9014d97cd777be10$export$a60d398fc7b7590e = 4;
const $9014d97cd777be10$export$7d7234c1240a1fc4 = 5;
const $9014d97cd777be10$export$c5e2c52991f30937 = 6;
const $9014d97cd777be10$export$2f843afa843d8916 = 7;
const $9014d97cd777be10$export$e50ac29801f1774d = 0;
const $9014d97cd777be10$export$9f9d94f963c85479 = 1;
const $9014d97cd777be10$export$e641dc52bc3494aa = 2;
const $9014d97cd777be10$export$9fcb6b4294603b2 = 0;
const $9014d97cd777be10$export$98f52c2a46c598ca = 1;
const $9014d97cd777be10$export$74b25e54b3bcd548 = 2;
const $9014d97cd777be10$export$932b3dd283d4a366 = 3;
const $9014d97cd777be10$export$a0d98fe6d7e4af64 = 4;
const $9014d97cd777be10$export$2c7b09c1e9abfb5e = 5;
const $9014d97cd777be10$export$1beec6768cbb3d2d = 300;
const $9014d97cd777be10$export$8759762a6477f2c4 = 301;
const $9014d97cd777be10$export$dc59f8aed047f61d = 302;
const $9014d97cd777be10$export$d64030b316d3b087 = 303;
const $9014d97cd777be10$export$ee99d97d46898098 = 304;
const $9014d97cd777be10$export$dbf3e70ff37af79 = 306;
const $9014d97cd777be10$export$533346c8e8dac0f5 = 1000;
const $9014d97cd777be10$export$9d9334239a5a5e06 = 1001;
const $9014d97cd777be10$export$c7e7c00b14f51a4f = 1002;
const $9014d97cd777be10$export$727aa5ec3fe39bf0 = 1003;
const $9014d97cd777be10$export$d129e38cf6feaa8c = 1004;
const $9014d97cd777be10$export$14a4936464a36496 = 1004;
const $9014d97cd777be10$export$d2327c1afe5bfdf2 = 1005;
const $9014d97cd777be10$export$cbc5b7f5647595d8 = 1005;
const $9014d97cd777be10$export$8a72f490b25c56c8 = 1006;
const $9014d97cd777be10$export$19a719f377145a13 = 1007;
const $9014d97cd777be10$export$dbe96bee3fe9dbf0 = 1007;
const $9014d97cd777be10$export$5d8599b6a933fb1b = 1008;
const $9014d97cd777be10$export$90d80f1e3506775f = 1008;
const $9014d97cd777be10$export$2e8ce08d3f6f5e10 = 1009;
const $9014d97cd777be10$export$545fce0311a9796a = 1010;
const $9014d97cd777be10$export$88572337f312435f = 1011;
const $9014d97cd777be10$export$c63dc51868b06a9d = 1012;
const $9014d97cd777be10$export$5c612977753abe2 = 1013;
const $9014d97cd777be10$export$c3c7fc4518ebba96 = 1014;
const $9014d97cd777be10$export$f6d331659b644596 = 1015;
const $9014d97cd777be10$export$2697304443f382bc = 1016;
const $9014d97cd777be10$export$b3969b01faf587f2 = 1017;
const $9014d97cd777be10$export$18886f8ae33e90de = 1018;
const $9014d97cd777be10$export$6c8ea339bfab1301 = 1020;
const $9014d97cd777be10$export$988473390501ed4b = 1021;
const $9014d97cd777be10$export$3f8bb04b555a363c = 1023;
const $9014d97cd777be10$export$cc09ccbf6d1ed449 = 1024;
const $9014d97cd777be10$export$9053a81c4a69c289 = 1025;
const $9014d97cd777be10$export$c1b6b5136be58045 = 1026;
const $9014d97cd777be10$export$1e113ac2d0905829 = 1027;
const $9014d97cd777be10$export$4e041a7967d15c4b = 1028;
const $9014d97cd777be10$export$aa92e870a709d190 = 1029;
const $9014d97cd777be10$export$6cdf0b461c7ce8a0 = 1030;
const $9014d97cd777be10$export$1ba1c45f9f77d4d7 = 1031;
const $9014d97cd777be10$export$c200e7d26f592f21 = 1033;
const $9014d97cd777be10$export$21d1799c6d552fc0 = 33776;
const $9014d97cd777be10$export$afa304c3e981b668 = 33777;
const $9014d97cd777be10$export$d2a1a68024a3e56c = 33778;
const $9014d97cd777be10$export$9a79c424327dacf9 = 33779;
const $9014d97cd777be10$export$19ada9bbb1af3573 = 35840;
const $9014d97cd777be10$export$d0f0355bb3d948e4 = 35841;
const $9014d97cd777be10$export$b82296714358084c = 35842;
const $9014d97cd777be10$export$b71692456c47b6c3 = 35843;
const $9014d97cd777be10$export$6ab91af2d757aee7 = 36196;
const $9014d97cd777be10$export$7800993ef8106a6a = 37492;
const $9014d97cd777be10$export$23ed8300a860e7d8 = 37496;
const $9014d97cd777be10$export$dc5570b4a2b92d48 = 37808;
const $9014d97cd777be10$export$68880cd325f8b2fb = 37809;
const $9014d97cd777be10$export$7d2c0be323373d95 = 37810;
const $9014d97cd777be10$export$22b52da301fc3a3e = 37811;
const $9014d97cd777be10$export$c009e2cb4a66485e = 37812;
const $9014d97cd777be10$export$118fff5afa255b63 = 37813;
const $9014d97cd777be10$export$120713c829ae0667 = 37814;
const $9014d97cd777be10$export$c79eeabbf53313e9 = 37815;
const $9014d97cd777be10$export$443cf6567cdd6424 = 37816;
const $9014d97cd777be10$export$6573984fc9840780 = 37817;
const $9014d97cd777be10$export$e7aee563f30091de = 37818;
const $9014d97cd777be10$export$2eb8634622ddeab7 = 37819;
const $9014d97cd777be10$export$202b1ce7b5d25742 = 37820;
const $9014d97cd777be10$export$18ab77abd087e467 = 37821;
const $9014d97cd777be10$export$ce40b115e188bc81 = 36492;
const $9014d97cd777be10$export$b1688df4c4c21670 = 36283;
const $9014d97cd777be10$export$fc15e5d8261eed58 = 36284;
const $9014d97cd777be10$export$d220f6ade8463a0f = 36285;
const $9014d97cd777be10$export$768646d09dc1b6ef = 36286;
const $9014d97cd777be10$export$d62fdc9d1b1cccad = 2200;
const $9014d97cd777be10$export$dfaf4422ce096e29 = 2201;
const $9014d97cd777be10$export$f8f6f2041b78e210 = 2202;
const $9014d97cd777be10$export$995b32462a65e855 = 2300;
const $9014d97cd777be10$export$30fac1aace31cf4d = 2301;
const $9014d97cd777be10$export$198b11ff4c72bb30 = 2302;
const $9014d97cd777be10$export$7f795934b84ab523 = 2400;
const $9014d97cd777be10$export$24a4ccb5099273b5 = 2401;
const $9014d97cd777be10$export$8e8c3ecdcd8e1fee = 2402;
const $9014d97cd777be10$export$bcfbbdcf8de7f8cd = 2500;
const $9014d97cd777be10$export$d875e029ef558d3 = 2501;
const $9014d97cd777be10$export$4c28c87c2dc84758 = 0;
const $9014d97cd777be10$export$b23a071aa286eb29 = 1;
const $9014d97cd777be10$export$f0d8293634f88842 = 2;
/** @deprecated Use LinearSRGBColorSpace or NoColorSpace in three.js r152+. */ const $9014d97cd777be10$export$7207336e4151a112 = 3000;
/** @deprecated Use SRGBColorSpace in three.js r152+. */ const $9014d97cd777be10$export$f32388edbb32674 = 3001;
const $9014d97cd777be10$export$deeb383078690b50 = 3200;
const $9014d97cd777be10$export$8f910f4c4f73df11 = 3201;
const $9014d97cd777be10$export$2852a58ebdac27b8 = 0;
const $9014d97cd777be10$export$9990ad26f9db5b2c = 1;
// Color space string identifiers, matching CSS Color Module Level 4 and WebGPU names where available.
const $9014d97cd777be10$export$bfcb490c2dd3db51 = "";
const $9014d97cd777be10$export$561f394b24edfcaa = "srgb";
const $9014d97cd777be10$export$42429b3acfb233a4 = "srgb-linear";
const $9014d97cd777be10$export$626af19ae879bdf6 = "display-p3";
const $9014d97cd777be10$export$69433f11f42d5527 = 0;
const $9014d97cd777be10$export$9f542ae4b5baca34 = 7680;
const $9014d97cd777be10$export$8a4f28336ef203d3 = 7681;
const $9014d97cd777be10$export$2928c0231297c036 = 7682;
const $9014d97cd777be10$export$c0e9611c8a15f9a8 = 7683;
const $9014d97cd777be10$export$9c2c08927385dcc4 = 34055;
const $9014d97cd777be10$export$7c74ea00fa1315e6 = 34056;
const $9014d97cd777be10$export$22e2e5726612443 = 5386;
const $9014d97cd777be10$export$1343870698229224 = 512;
const $9014d97cd777be10$export$8e1d8ed281997fa6 = 513;
const $9014d97cd777be10$export$55648a1cde8329a7 = 514;
const $9014d97cd777be10$export$2dff107857e6aca2 = 515;
const $9014d97cd777be10$export$6f93765ab2f451a2 = 516;
const $9014d97cd777be10$export$6f3fb2d2440f2b76 = 517;
const $9014d97cd777be10$export$4119cf7b4c98fd5a = 518;
const $9014d97cd777be10$export$14cf96713ddd97a8 = 519;
const $9014d97cd777be10$export$d9e2d19a747baaab = 512;
const $9014d97cd777be10$export$36bcf49c713b3eb7 = 513;
const $9014d97cd777be10$export$66f28d946fc6a0d5 = 514;
const $9014d97cd777be10$export$64eea11eb407ddf1 = 515;
const $9014d97cd777be10$export$155af022118f3a38 = 516;
const $9014d97cd777be10$export$67ab95dde6bed156 = 517;
const $9014d97cd777be10$export$1cdcb70d53d65f61 = 518;
const $9014d97cd777be10$export$187b73a3e352c145 = 519;
const $9014d97cd777be10$export$763e8360f4d7f77d = 35044;
const $9014d97cd777be10$export$8505d14ac8546ca = 35048;
const $9014d97cd777be10$export$721e63549e51d81e = 35040;
const $9014d97cd777be10$export$415731dc4f48e299 = 35045;
const $9014d97cd777be10$export$9e809946455f13bc = 35049;
const $9014d97cd777be10$export$2ed9499a35b5f832 = 35041;
const $9014d97cd777be10$export$32ab2503ea19469a = 35046;
const $9014d97cd777be10$export$ab4022c2c3f86315 = 35050;
const $9014d97cd777be10$export$ba7f1db36a76a970 = 35042;
const $9014d97cd777be10$export$43600cc67fabd9f = "100";
const $9014d97cd777be10$export$f63012db5506e7dd = "300 es";
const $9014d97cd777be10$export$ca1dce8b5e1de74d = 1035; // fallback for WebGL 1
const $9014d97cd777be10$export$5a0e9190d10875d3 = 2000;
const $9014d97cd777be10$export$cc83beedcb9be9ac = 2001;
/**
 * https://github.com/mrdoob/eventdispatcher.js/
 */ class $9014d97cd777be10$export$ec8b666c5fe2c75a {
    addEventListener(type, listener) {
        if (this._listeners === undefined) this._listeners = {};
        const listeners = this._listeners;
        if (listeners[type] === undefined) listeners[type] = [];
        if (listeners[type].indexOf(listener) === -1) listeners[type].push(listener);
    }
    hasEventListener(type, listener) {
        if (this._listeners === undefined) return false;
        const listeners = this._listeners;
        return listeners[type] !== undefined && listeners[type].indexOf(listener) !== -1;
    }
    removeEventListener(type, listener) {
        if (this._listeners === undefined) return;
        const listeners = this._listeners;
        const listenerArray = listeners[type];
        if (listenerArray !== undefined) {
            const index = listenerArray.indexOf(listener);
            if (index !== -1) listenerArray.splice(index, 1);
        }
    }
    dispatchEvent(event) {
        if (this._listeners === undefined) return;
        const listeners = this._listeners;
        const listenerArray = listeners[event.type];
        if (listenerArray !== undefined) {
            event.target = this;
            // Make a copy, in case listeners are removed while iterating.
            const array = listenerArray.slice(0);
            for(let i = 0, l = array.length; i < l; i++)array[i].call(this, event);
            event.target = null;
        }
    }
}
const $9014d97cd777be10$var$_lut = [
    "00",
    "01",
    "02",
    "03",
    "04",
    "05",
    "06",
    "07",
    "08",
    "09",
    "0a",
    "0b",
    "0c",
    "0d",
    "0e",
    "0f",
    "10",
    "11",
    "12",
    "13",
    "14",
    "15",
    "16",
    "17",
    "18",
    "19",
    "1a",
    "1b",
    "1c",
    "1d",
    "1e",
    "1f",
    "20",
    "21",
    "22",
    "23",
    "24",
    "25",
    "26",
    "27",
    "28",
    "29",
    "2a",
    "2b",
    "2c",
    "2d",
    "2e",
    "2f",
    "30",
    "31",
    "32",
    "33",
    "34",
    "35",
    "36",
    "37",
    "38",
    "39",
    "3a",
    "3b",
    "3c",
    "3d",
    "3e",
    "3f",
    "40",
    "41",
    "42",
    "43",
    "44",
    "45",
    "46",
    "47",
    "48",
    "49",
    "4a",
    "4b",
    "4c",
    "4d",
    "4e",
    "4f",
    "50",
    "51",
    "52",
    "53",
    "54",
    "55",
    "56",
    "57",
    "58",
    "59",
    "5a",
    "5b",
    "5c",
    "5d",
    "5e",
    "5f",
    "60",
    "61",
    "62",
    "63",
    "64",
    "65",
    "66",
    "67",
    "68",
    "69",
    "6a",
    "6b",
    "6c",
    "6d",
    "6e",
    "6f",
    "70",
    "71",
    "72",
    "73",
    "74",
    "75",
    "76",
    "77",
    "78",
    "79",
    "7a",
    "7b",
    "7c",
    "7d",
    "7e",
    "7f",
    "80",
    "81",
    "82",
    "83",
    "84",
    "85",
    "86",
    "87",
    "88",
    "89",
    "8a",
    "8b",
    "8c",
    "8d",
    "8e",
    "8f",
    "90",
    "91",
    "92",
    "93",
    "94",
    "95",
    "96",
    "97",
    "98",
    "99",
    "9a",
    "9b",
    "9c",
    "9d",
    "9e",
    "9f",
    "a0",
    "a1",
    "a2",
    "a3",
    "a4",
    "a5",
    "a6",
    "a7",
    "a8",
    "a9",
    "aa",
    "ab",
    "ac",
    "ad",
    "ae",
    "af",
    "b0",
    "b1",
    "b2",
    "b3",
    "b4",
    "b5",
    "b6",
    "b7",
    "b8",
    "b9",
    "ba",
    "bb",
    "bc",
    "bd",
    "be",
    "bf",
    "c0",
    "c1",
    "c2",
    "c3",
    "c4",
    "c5",
    "c6",
    "c7",
    "c8",
    "c9",
    "ca",
    "cb",
    "cc",
    "cd",
    "ce",
    "cf",
    "d0",
    "d1",
    "d2",
    "d3",
    "d4",
    "d5",
    "d6",
    "d7",
    "d8",
    "d9",
    "da",
    "db",
    "dc",
    "dd",
    "de",
    "df",
    "e0",
    "e1",
    "e2",
    "e3",
    "e4",
    "e5",
    "e6",
    "e7",
    "e8",
    "e9",
    "ea",
    "eb",
    "ec",
    "ed",
    "ee",
    "ef",
    "f0",
    "f1",
    "f2",
    "f3",
    "f4",
    "f5",
    "f6",
    "f7",
    "f8",
    "f9",
    "fa",
    "fb",
    "fc",
    "fd",
    "fe",
    "ff"
];
let $9014d97cd777be10$var$_seed = 1234567;
const $9014d97cd777be10$var$DEG2RAD = Math.PI / 180;
const $9014d97cd777be10$var$RAD2DEG = 180 / Math.PI;
// http://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid-in-javascript/21963136#21963136
function $9014d97cd777be10$var$generateUUID() {
    const d0 = Math.random() * 0xffffffff | 0;
    const d1 = Math.random() * 0xffffffff | 0;
    const d2 = Math.random() * 0xffffffff | 0;
    const d3 = Math.random() * 0xffffffff | 0;
    const uuid = $9014d97cd777be10$var$_lut[d0 & 0xff] + $9014d97cd777be10$var$_lut[d0 >> 8 & 0xff] + $9014d97cd777be10$var$_lut[d0 >> 16 & 0xff] + $9014d97cd777be10$var$_lut[d0 >> 24 & 0xff] + "-" + $9014d97cd777be10$var$_lut[d1 & 0xff] + $9014d97cd777be10$var$_lut[d1 >> 8 & 0xff] + "-" + $9014d97cd777be10$var$_lut[d1 >> 16 & 0x0f | 0x40] + $9014d97cd777be10$var$_lut[d1 >> 24 & 0xff] + "-" + $9014d97cd777be10$var$_lut[d2 & 0x3f | 0x80] + $9014d97cd777be10$var$_lut[d2 >> 8 & 0xff] + "-" + $9014d97cd777be10$var$_lut[d2 >> 16 & 0xff] + $9014d97cd777be10$var$_lut[d2 >> 24 & 0xff] + $9014d97cd777be10$var$_lut[d3 & 0xff] + $9014d97cd777be10$var$_lut[d3 >> 8 & 0xff] + $9014d97cd777be10$var$_lut[d3 >> 16 & 0xff] + $9014d97cd777be10$var$_lut[d3 >> 24 & 0xff];
    // .toLowerCase() here flattens concatenated strings to save heap memory space.
    return uuid.toLowerCase();
}
function $9014d97cd777be10$var$clamp(value, min, max) {
    return Math.max(min, Math.min(max, value));
}
// compute euclidean modulo of m % n
// https://en.wikipedia.org/wiki/Modulo_operation
function $9014d97cd777be10$var$euclideanModulo(n, m) {
    return (n % m + m) % m;
}
// Linear mapping from range <a1, a2> to range <b1, b2>
function $9014d97cd777be10$var$mapLinear(x, a1, a2, b1, b2) {
    return b1 + (x - a1) * (b2 - b1) / (a2 - a1);
}
// https://www.gamedev.net/tutorials/programming/general-and-gameplay-programming/inverse-lerp-a-super-useful-yet-often-overlooked-function-r5230/
function $9014d97cd777be10$var$inverseLerp(x, y, value) {
    if (x !== y) return (value - x) / (y - x);
    else return 0;
}
// https://en.wikipedia.org/wiki/Linear_interpolation
function $9014d97cd777be10$var$lerp(x, y, t) {
    return (1 - t) * x + t * y;
}
// http://www.rorydriscoll.com/2016/03/07/frame-rate-independent-damping-using-lerp/
function $9014d97cd777be10$var$damp(x, y, lambda, dt) {
    return $9014d97cd777be10$var$lerp(x, y, 1 - Math.exp(-lambda * dt));
}
// https://www.desmos.com/calculator/vcsjnyz7x4
function $9014d97cd777be10$var$pingpong(x, length = 1) {
    return length - Math.abs($9014d97cd777be10$var$euclideanModulo(x, length * 2) - length);
}
// http://en.wikipedia.org/wiki/Smoothstep
function $9014d97cd777be10$var$smoothstep(x, min, max) {
    if (x <= min) return 0;
    if (x >= max) return 1;
    x = (x - min) / (max - min);
    return x * x * (3 - 2 * x);
}
function $9014d97cd777be10$var$smootherstep(x, min, max) {
    if (x <= min) return 0;
    if (x >= max) return 1;
    x = (x - min) / (max - min);
    return x * x * x * (x * (x * 6 - 15) + 10);
}
// Random integer from <low, high> interval
function $9014d97cd777be10$var$randInt(low, high) {
    return low + Math.floor(Math.random() * (high - low + 1));
}
// Random float from <low, high> interval
function $9014d97cd777be10$var$randFloat(low, high) {
    return low + Math.random() * (high - low);
}
// Random float from <-range/2, range/2> interval
function $9014d97cd777be10$var$randFloatSpread(range) {
    return range * (0.5 - Math.random());
}
// Deterministic pseudo-random float in the interval [ 0, 1 ]
function $9014d97cd777be10$var$seededRandom(s) {
    if (s !== undefined) $9014d97cd777be10$var$_seed = s;
    // Mulberry32 generator
    let t = $9014d97cd777be10$var$_seed += 0x6D2B79F5;
    t = Math.imul(t ^ t >>> 15, t | 1);
    t ^= t + Math.imul(t ^ t >>> 7, t | 61);
    return ((t ^ t >>> 14) >>> 0) / 4294967296;
}
function $9014d97cd777be10$var$degToRad(degrees) {
    return degrees * $9014d97cd777be10$var$DEG2RAD;
}
function $9014d97cd777be10$var$radToDeg(radians) {
    return radians * $9014d97cd777be10$var$RAD2DEG;
}
function $9014d97cd777be10$var$isPowerOfTwo(value) {
    return (value & value - 1) === 0 && value !== 0;
}
function $9014d97cd777be10$var$ceilPowerOfTwo(value) {
    return Math.pow(2, Math.ceil(Math.log(value) / Math.LN2));
}
function $9014d97cd777be10$var$floorPowerOfTwo(value) {
    return Math.pow(2, Math.floor(Math.log(value) / Math.LN2));
}
function $9014d97cd777be10$var$setQuaternionFromProperEuler(q, a, b, c, order) {
    // Intrinsic Proper Euler Angles - see https://en.wikipedia.org/wiki/Euler_angles
    // rotations are applied to the axes in the order specified by 'order'
    // rotation by angle 'a' is applied first, then by angle 'b', then by angle 'c'
    // angles are in radians
    const cos = Math.cos;
    const sin = Math.sin;
    const c2 = cos(b / 2);
    const s2 = sin(b / 2);
    const c13 = cos((a + c) / 2);
    const s13 = sin((a + c) / 2);
    const c1_3 = cos((a - c) / 2);
    const s1_3 = sin((a - c) / 2);
    const c3_1 = cos((c - a) / 2);
    const s3_1 = sin((c - a) / 2);
    switch(order){
        case "XYX":
            q.set(c2 * s13, s2 * c1_3, s2 * s1_3, c2 * c13);
            break;
        case "YZY":
            q.set(s2 * s1_3, c2 * s13, s2 * c1_3, c2 * c13);
            break;
        case "ZXZ":
            q.set(s2 * c1_3, s2 * s1_3, c2 * s13, c2 * c13);
            break;
        case "XZX":
            q.set(c2 * s13, s2 * s3_1, s2 * c3_1, c2 * c13);
            break;
        case "YXY":
            q.set(s2 * c3_1, c2 * s13, s2 * s3_1, c2 * c13);
            break;
        case "ZYZ":
            q.set(s2 * s3_1, s2 * c3_1, c2 * s13, c2 * c13);
            break;
        default:
            console.warn("THREE.MathUtils: .setQuaternionFromProperEuler() encountered an unknown order: " + order);
    }
}
function $9014d97cd777be10$var$denormalize(value, array) {
    switch(array.constructor){
        case Float32Array:
            return value;
        case Uint32Array:
            return value / 4294967295.0;
        case Uint16Array:
            return value / 65535.0;
        case Uint8Array:
            return value / 255.0;
        case Int32Array:
            return Math.max(value / 2147483647.0, -1);
        case Int16Array:
            return Math.max(value / 32767.0, -1);
        case Int8Array:
            return Math.max(value / 127.0, -1);
        default:
            throw new Error("Invalid component type.");
    }
}
function $9014d97cd777be10$var$normalize(value, array) {
    switch(array.constructor){
        case Float32Array:
            return value;
        case Uint32Array:
            return Math.round(value * 4294967295.0);
        case Uint16Array:
            return Math.round(value * 65535.0);
        case Uint8Array:
            return Math.round(value * 255.0);
        case Int32Array:
            return Math.round(value * 2147483647.0);
        case Int16Array:
            return Math.round(value * 32767.0);
        case Int8Array:
            return Math.round(value * 127.0);
        default:
            throw new Error("Invalid component type.");
    }
}
const $9014d97cd777be10$export$6a7ef315a0d1ef07 = {
    DEG2RAD: $9014d97cd777be10$var$DEG2RAD,
    RAD2DEG: $9014d97cd777be10$var$RAD2DEG,
    generateUUID: $9014d97cd777be10$var$generateUUID,
    clamp: $9014d97cd777be10$var$clamp,
    euclideanModulo: $9014d97cd777be10$var$euclideanModulo,
    mapLinear: $9014d97cd777be10$var$mapLinear,
    inverseLerp: $9014d97cd777be10$var$inverseLerp,
    lerp: $9014d97cd777be10$var$lerp,
    damp: $9014d97cd777be10$var$damp,
    pingpong: $9014d97cd777be10$var$pingpong,
    smoothstep: $9014d97cd777be10$var$smoothstep,
    smootherstep: $9014d97cd777be10$var$smootherstep,
    randInt: $9014d97cd777be10$var$randInt,
    randFloat: $9014d97cd777be10$var$randFloat,
    randFloatSpread: $9014d97cd777be10$var$randFloatSpread,
    seededRandom: $9014d97cd777be10$var$seededRandom,
    degToRad: $9014d97cd777be10$var$degToRad,
    radToDeg: $9014d97cd777be10$var$radToDeg,
    isPowerOfTwo: $9014d97cd777be10$var$isPowerOfTwo,
    ceilPowerOfTwo: $9014d97cd777be10$var$ceilPowerOfTwo,
    floorPowerOfTwo: $9014d97cd777be10$var$floorPowerOfTwo,
    setQuaternionFromProperEuler: $9014d97cd777be10$var$setQuaternionFromProperEuler,
    normalize: $9014d97cd777be10$var$normalize,
    denormalize: $9014d97cd777be10$var$denormalize
};
class $9014d97cd777be10$export$c977b3e384af9ae1 {
    get width() {
        return this.x;
    }
    set width(value) {
        this.x = value;
    }
    get height() {
        return this.y;
    }
    set height(value) {
        this.y = value;
    }
    set(x, y) {
        this.x = x;
        this.y = y;
        return this;
    }
    setScalar(scalar) {
        this.x = scalar;
        this.y = scalar;
        return this;
    }
    setX(x) {
        this.x = x;
        return this;
    }
    setY(y) {
        this.y = y;
        return this;
    }
    setComponent(index, value) {
        switch(index){
            case 0:
                this.x = value;
                break;
            case 1:
                this.y = value;
                break;
            default:
                throw new Error("index is out of range: " + index);
        }
        return this;
    }
    getComponent(index) {
        switch(index){
            case 0:
                return this.x;
            case 1:
                return this.y;
            default:
                throw new Error("index is out of range: " + index);
        }
    }
    clone() {
        return new this.constructor(this.x, this.y);
    }
    copy(v) {
        this.x = v.x;
        this.y = v.y;
        return this;
    }
    add(v) {
        this.x += v.x;
        this.y += v.y;
        return this;
    }
    addScalar(s) {
        this.x += s;
        this.y += s;
        return this;
    }
    addVectors(a, b) {
        this.x = a.x + b.x;
        this.y = a.y + b.y;
        return this;
    }
    addScaledVector(v, s) {
        this.x += v.x * s;
        this.y += v.y * s;
        return this;
    }
    sub(v) {
        this.x -= v.x;
        this.y -= v.y;
        return this;
    }
    subScalar(s) {
        this.x -= s;
        this.y -= s;
        return this;
    }
    subVectors(a, b) {
        this.x = a.x - b.x;
        this.y = a.y - b.y;
        return this;
    }
    multiply(v) {
        this.x *= v.x;
        this.y *= v.y;
        return this;
    }
    multiplyScalar(scalar) {
        this.x *= scalar;
        this.y *= scalar;
        return this;
    }
    divide(v) {
        this.x /= v.x;
        this.y /= v.y;
        return this;
    }
    divideScalar(scalar) {
        return this.multiplyScalar(1 / scalar);
    }
    applyMatrix3(m) {
        const x = this.x, y = this.y;
        const e = m.elements;
        this.x = e[0] * x + e[3] * y + e[6];
        this.y = e[1] * x + e[4] * y + e[7];
        return this;
    }
    min(v) {
        this.x = Math.min(this.x, v.x);
        this.y = Math.min(this.y, v.y);
        return this;
    }
    max(v) {
        this.x = Math.max(this.x, v.x);
        this.y = Math.max(this.y, v.y);
        return this;
    }
    clamp(min, max) {
        // assumes min < max, componentwise
        this.x = Math.max(min.x, Math.min(max.x, this.x));
        this.y = Math.max(min.y, Math.min(max.y, this.y));
        return this;
    }
    clampScalar(minVal, maxVal) {
        this.x = Math.max(minVal, Math.min(maxVal, this.x));
        this.y = Math.max(minVal, Math.min(maxVal, this.y));
        return this;
    }
    clampLength(min, max) {
        const length = this.length();
        return this.divideScalar(length || 1).multiplyScalar(Math.max(min, Math.min(max, length)));
    }
    floor() {
        this.x = Math.floor(this.x);
        this.y = Math.floor(this.y);
        return this;
    }
    ceil() {
        this.x = Math.ceil(this.x);
        this.y = Math.ceil(this.y);
        return this;
    }
    round() {
        this.x = Math.round(this.x);
        this.y = Math.round(this.y);
        return this;
    }
    roundToZero() {
        this.x = this.x < 0 ? Math.ceil(this.x) : Math.floor(this.x);
        this.y = this.y < 0 ? Math.ceil(this.y) : Math.floor(this.y);
        return this;
    }
    negate() {
        this.x = -this.x;
        this.y = -this.y;
        return this;
    }
    dot(v) {
        return this.x * v.x + this.y * v.y;
    }
    cross(v) {
        return this.x * v.y - this.y * v.x;
    }
    lengthSq() {
        return this.x * this.x + this.y * this.y;
    }
    length() {
        return Math.sqrt(this.x * this.x + this.y * this.y);
    }
    manhattanLength() {
        return Math.abs(this.x) + Math.abs(this.y);
    }
    normalize() {
        return this.divideScalar(this.length() || 1);
    }
    angle() {
        // computes the angle in radians with respect to the positive x-axis
        const angle = Math.atan2(-this.y, -this.x) + Math.PI;
        return angle;
    }
    angleTo(v) {
        const denominator = Math.sqrt(this.lengthSq() * v.lengthSq());
        if (denominator === 0) return Math.PI / 2;
        const theta = this.dot(v) / denominator;
        // clamp, to handle numerical problems
        return Math.acos($9014d97cd777be10$var$clamp(theta, -1, 1));
    }
    distanceTo(v) {
        return Math.sqrt(this.distanceToSquared(v));
    }
    distanceToSquared(v) {
        const dx = this.x - v.x, dy = this.y - v.y;
        return dx * dx + dy * dy;
    }
    manhattanDistanceTo(v) {
        return Math.abs(this.x - v.x) + Math.abs(this.y - v.y);
    }
    setLength(length) {
        return this.normalize().multiplyScalar(length);
    }
    lerp(v, alpha) {
        this.x += (v.x - this.x) * alpha;
        this.y += (v.y - this.y) * alpha;
        return this;
    }
    lerpVectors(v1, v2, alpha) {
        this.x = v1.x + (v2.x - v1.x) * alpha;
        this.y = v1.y + (v2.y - v1.y) * alpha;
        return this;
    }
    equals(v) {
        return v.x === this.x && v.y === this.y;
    }
    fromArray(array, offset = 0) {
        this.x = array[offset];
        this.y = array[offset + 1];
        return this;
    }
    toArray(array = [], offset = 0) {
        array[offset] = this.x;
        array[offset + 1] = this.y;
        return array;
    }
    fromBufferAttribute(attribute, index) {
        this.x = attribute.getX(index);
        this.y = attribute.getY(index);
        return this;
    }
    rotateAround(center, angle) {
        const c = Math.cos(angle), s = Math.sin(angle);
        const x = this.x - center.x;
        const y = this.y - center.y;
        this.x = x * c - y * s + center.x;
        this.y = x * s + y * c + center.y;
        return this;
    }
    random() {
        this.x = Math.random();
        this.y = Math.random();
        return this;
    }
    *[Symbol.iterator]() {
        yield this.x;
        yield this.y;
    }
    constructor(x = 0, y = 0){
        $9014d97cd777be10$export$c977b3e384af9ae1.prototype.isVector2 = true;
        this.x = x;
        this.y = y;
    }
}
class $9014d97cd777be10$export$8ff26dafa08918 {
    set(n11, n12, n13, n21, n22, n23, n31, n32, n33) {
        const te = this.elements;
        te[0] = n11;
        te[1] = n21;
        te[2] = n31;
        te[3] = n12;
        te[4] = n22;
        te[5] = n32;
        te[6] = n13;
        te[7] = n23;
        te[8] = n33;
        return this;
    }
    identity() {
        this.set(1, 0, 0, 0, 1, 0, 0, 0, 1);
        return this;
    }
    copy(m) {
        const te = this.elements;
        const me = m.elements;
        te[0] = me[0];
        te[1] = me[1];
        te[2] = me[2];
        te[3] = me[3];
        te[4] = me[4];
        te[5] = me[5];
        te[6] = me[6];
        te[7] = me[7];
        te[8] = me[8];
        return this;
    }
    extractBasis(xAxis, yAxis, zAxis) {
        xAxis.setFromMatrix3Column(this, 0);
        yAxis.setFromMatrix3Column(this, 1);
        zAxis.setFromMatrix3Column(this, 2);
        return this;
    }
    setFromMatrix4(m) {
        const me = m.elements;
        this.set(me[0], me[4], me[8], me[1], me[5], me[9], me[2], me[6], me[10]);
        return this;
    }
    multiply(m) {
        return this.multiplyMatrices(this, m);
    }
    premultiply(m) {
        return this.multiplyMatrices(m, this);
    }
    multiplyMatrices(a, b) {
        const ae = a.elements;
        const be = b.elements;
        const te = this.elements;
        const a11 = ae[0], a12 = ae[3], a13 = ae[6];
        const a21 = ae[1], a22 = ae[4], a23 = ae[7];
        const a31 = ae[2], a32 = ae[5], a33 = ae[8];
        const b11 = be[0], b12 = be[3], b13 = be[6];
        const b21 = be[1], b22 = be[4], b23 = be[7];
        const b31 = be[2], b32 = be[5], b33 = be[8];
        te[0] = a11 * b11 + a12 * b21 + a13 * b31;
        te[3] = a11 * b12 + a12 * b22 + a13 * b32;
        te[6] = a11 * b13 + a12 * b23 + a13 * b33;
        te[1] = a21 * b11 + a22 * b21 + a23 * b31;
        te[4] = a21 * b12 + a22 * b22 + a23 * b32;
        te[7] = a21 * b13 + a22 * b23 + a23 * b33;
        te[2] = a31 * b11 + a32 * b21 + a33 * b31;
        te[5] = a31 * b12 + a32 * b22 + a33 * b32;
        te[8] = a31 * b13 + a32 * b23 + a33 * b33;
        return this;
    }
    multiplyScalar(s) {
        const te = this.elements;
        te[0] *= s;
        te[3] *= s;
        te[6] *= s;
        te[1] *= s;
        te[4] *= s;
        te[7] *= s;
        te[2] *= s;
        te[5] *= s;
        te[8] *= s;
        return this;
    }
    determinant() {
        const te = this.elements;
        const a = te[0], b = te[1], c = te[2], d = te[3], e = te[4], f = te[5], g = te[6], h = te[7], i = te[8];
        return a * e * i - a * f * h - b * d * i + b * f * g + c * d * h - c * e * g;
    }
    invert() {
        const te = this.elements, n11 = te[0], n21 = te[1], n31 = te[2], n12 = te[3], n22 = te[4], n32 = te[5], n13 = te[6], n23 = te[7], n33 = te[8], t11 = n33 * n22 - n32 * n23, t12 = n32 * n13 - n33 * n12, t13 = n23 * n12 - n22 * n13, det = n11 * t11 + n21 * t12 + n31 * t13;
        if (det === 0) return this.set(0, 0, 0, 0, 0, 0, 0, 0, 0);
        const detInv = 1 / det;
        te[0] = t11 * detInv;
        te[1] = (n31 * n23 - n33 * n21) * detInv;
        te[2] = (n32 * n21 - n31 * n22) * detInv;
        te[3] = t12 * detInv;
        te[4] = (n33 * n11 - n31 * n13) * detInv;
        te[5] = (n31 * n12 - n32 * n11) * detInv;
        te[6] = t13 * detInv;
        te[7] = (n21 * n13 - n23 * n11) * detInv;
        te[8] = (n22 * n11 - n21 * n12) * detInv;
        return this;
    }
    transpose() {
        let tmp;
        const m = this.elements;
        tmp = m[1];
        m[1] = m[3];
        m[3] = tmp;
        tmp = m[2];
        m[2] = m[6];
        m[6] = tmp;
        tmp = m[5];
        m[5] = m[7];
        m[7] = tmp;
        return this;
    }
    getNormalMatrix(matrix4) {
        return this.setFromMatrix4(matrix4).invert().transpose();
    }
    transposeIntoArray(r) {
        const m = this.elements;
        r[0] = m[0];
        r[1] = m[3];
        r[2] = m[6];
        r[3] = m[1];
        r[4] = m[4];
        r[5] = m[7];
        r[6] = m[2];
        r[7] = m[5];
        r[8] = m[8];
        return this;
    }
    setUvTransform(tx, ty, sx, sy, rotation, cx, cy) {
        const c = Math.cos(rotation);
        const s = Math.sin(rotation);
        this.set(sx * c, sx * s, -sx * (c * cx + s * cy) + cx + tx, -sy * s, sy * c, -sy * (-s * cx + c * cy) + cy + ty, 0, 0, 1);
        return this;
    }
    //
    scale(sx, sy) {
        this.premultiply($9014d97cd777be10$var$_m3.makeScale(sx, sy));
        return this;
    }
    rotate(theta) {
        this.premultiply($9014d97cd777be10$var$_m3.makeRotation(-theta));
        return this;
    }
    translate(tx, ty) {
        this.premultiply($9014d97cd777be10$var$_m3.makeTranslation(tx, ty));
        return this;
    }
    // for 2D Transforms
    makeTranslation(x, y) {
        if (x.isVector2) this.set(1, 0, x.x, 0, 1, x.y, 0, 0, 1);
        else this.set(1, 0, x, 0, 1, y, 0, 0, 1);
        return this;
    }
    makeRotation(theta) {
        // counterclockwise
        const c = Math.cos(theta);
        const s = Math.sin(theta);
        this.set(c, -s, 0, s, c, 0, 0, 0, 1);
        return this;
    }
    makeScale(x, y) {
        this.set(x, 0, 0, 0, y, 0, 0, 0, 1);
        return this;
    }
    //
    equals(matrix) {
        const te = this.elements;
        const me = matrix.elements;
        for(let i = 0; i < 9; i++){
            if (te[i] !== me[i]) return false;
        }
        return true;
    }
    fromArray(array, offset = 0) {
        for(let i = 0; i < 9; i++)this.elements[i] = array[i + offset];
        return this;
    }
    toArray(array = [], offset = 0) {
        const te = this.elements;
        array[offset] = te[0];
        array[offset + 1] = te[1];
        array[offset + 2] = te[2];
        array[offset + 3] = te[3];
        array[offset + 4] = te[4];
        array[offset + 5] = te[5];
        array[offset + 6] = te[6];
        array[offset + 7] = te[7];
        array[offset + 8] = te[8];
        return array;
    }
    clone() {
        return new this.constructor().fromArray(this.elements);
    }
    constructor(n11, n12, n13, n21, n22, n23, n31, n32, n33){
        $9014d97cd777be10$export$8ff26dafa08918.prototype.isMatrix3 = true;
        this.elements = [
            1,
            0,
            0,
            0,
            1,
            0,
            0,
            0,
            1
        ];
        if (n11 !== undefined) this.set(n11, n12, n13, n21, n22, n23, n31, n32, n33);
    }
}
const $9014d97cd777be10$var$_m3 = /*@__PURE__*/ new $9014d97cd777be10$export$8ff26dafa08918();
function $9014d97cd777be10$var$arrayNeedsUint32(array) {
    // assumes larger values usually on last
    for(let i = array.length - 1; i >= 0; --i){
        if (array[i] >= 65535) return true; // account for PRIMITIVE_RESTART_FIXED_INDEX, #24565
    }
    return false;
}
const $9014d97cd777be10$var$TYPED_ARRAYS = {
    Int8Array: Int8Array,
    Uint8Array: Uint8Array,
    Uint8ClampedArray: Uint8ClampedArray,
    Int16Array: Int16Array,
    Uint16Array: Uint16Array,
    Int32Array: Int32Array,
    Uint32Array: Uint32Array,
    Float32Array: Float32Array,
    Float64Array: Float64Array
};
function $9014d97cd777be10$var$getTypedArray(type, buffer) {
    return new $9014d97cd777be10$var$TYPED_ARRAYS[type](buffer);
}
function $9014d97cd777be10$var$createElementNS(name) {
    return document.createElementNS("http://www.w3.org/1999/xhtml", name);
}
const $9014d97cd777be10$var$_cache = {};
function $9014d97cd777be10$var$warnOnce(message) {
    if (message in $9014d97cd777be10$var$_cache) return;
    $9014d97cd777be10$var$_cache[message] = true;
    console.warn(message);
}
function $9014d97cd777be10$var$SRGBToLinear(c) {
    return c < 0.04045 ? c * 0.0773993808 : Math.pow(c * 0.9478672986 + 0.0521327014, 2.4);
}
function $9014d97cd777be10$var$LinearToSRGB(c) {
    return c < 0.0031308 ? c * 12.92 : 1.055 * Math.pow(c, 0.41666) - 0.055;
}
/**
 * Matrices converting P3 <-> Rec. 709 primaries, without gamut mapping
 * or clipping. Based on W3C specifications for sRGB and Display P3,
 * and ICC specifications for the D50 connection space. Values in/out
 * are _linear_ sRGB and _linear_ Display P3.
 *
 * Note that both sRGB and Display P3 use the sRGB transfer functions.
 *
 * Reference:
 * - http://www.russellcottrell.com/photo/matrixCalculator.htm
 */ const $9014d97cd777be10$var$LINEAR_SRGB_TO_LINEAR_DISPLAY_P3 = /*@__PURE__*/ new $9014d97cd777be10$export$8ff26dafa08918().fromArray([
    0.8224621,
    0.0331941,
    0.0170827,
    0.1775380,
    0.9668058,
    0.0723974,
    -0.0000001,
    0.0000001,
    0.9105199
]);
const $9014d97cd777be10$var$LINEAR_DISPLAY_P3_TO_LINEAR_SRGB = /*@__PURE__*/ new $9014d97cd777be10$export$8ff26dafa08918().fromArray([
    1.2249401,
    -0.0420569,
    -0.0196376,
    -0.2249404,
    1.0420571,
    -0.0786361,
    0.0000001,
    0.0000000,
    1.0982735
]);
function $9014d97cd777be10$var$DisplayP3ToLinearSRGB(color) {
    // Display P3 uses the sRGB transfer functions
    return color.convertSRGBToLinear().applyMatrix3($9014d97cd777be10$var$LINEAR_DISPLAY_P3_TO_LINEAR_SRGB);
}
function $9014d97cd777be10$var$LinearSRGBToDisplayP3(color) {
    // Display P3 uses the sRGB transfer functions
    return color.applyMatrix3($9014d97cd777be10$var$LINEAR_SRGB_TO_LINEAR_DISPLAY_P3).convertLinearToSRGB();
}
// Conversions from <source> to Linear-sRGB reference space.
const $9014d97cd777be10$var$TO_LINEAR = {
    [$9014d97cd777be10$export$42429b3acfb233a4]: (color)=>color,
    [$9014d97cd777be10$export$561f394b24edfcaa]: (color)=>color.convertSRGBToLinear(),
    [$9014d97cd777be10$export$626af19ae879bdf6]: $9014d97cd777be10$var$DisplayP3ToLinearSRGB
};
// Conversions to <target> from Linear-sRGB reference space.
const $9014d97cd777be10$var$FROM_LINEAR = {
    [$9014d97cd777be10$export$42429b3acfb233a4]: (color)=>color,
    [$9014d97cd777be10$export$561f394b24edfcaa]: (color)=>color.convertLinearToSRGB(),
    [$9014d97cd777be10$export$626af19ae879bdf6]: $9014d97cd777be10$var$LinearSRGBToDisplayP3
};
const $9014d97cd777be10$export$5e6fd513f44698c = {
    enabled: true,
    get legacyMode () {
        console.warn("THREE.ColorManagement: .legacyMode=false renamed to .enabled=true in r150.");
        return !this.enabled;
    },
    set legacyMode (legacyMode){
        console.warn("THREE.ColorManagement: .legacyMode=false renamed to .enabled=true in r150.");
        this.enabled = !legacyMode;
    },
    get workingColorSpace () {
        return $9014d97cd777be10$export$42429b3acfb233a4;
    },
    set workingColorSpace (colorSpace){
        console.warn("THREE.ColorManagement: .workingColorSpace is readonly.");
    },
    convert: function(color, sourceColorSpace, targetColorSpace) {
        if (this.enabled === false || sourceColorSpace === targetColorSpace || !sourceColorSpace || !targetColorSpace) return color;
        const sourceToLinear = $9014d97cd777be10$var$TO_LINEAR[sourceColorSpace];
        const targetFromLinear = $9014d97cd777be10$var$FROM_LINEAR[targetColorSpace];
        if (sourceToLinear === undefined || targetFromLinear === undefined) throw new Error(`Unsupported color space conversion, "${sourceColorSpace}" to "${targetColorSpace}".`);
        return targetFromLinear(sourceToLinear(color));
    },
    fromWorkingColorSpace: function(color, targetColorSpace) {
        return this.convert(color, this.workingColorSpace, targetColorSpace);
    },
    toWorkingColorSpace: function(color, sourceColorSpace) {
        return this.convert(color, sourceColorSpace, this.workingColorSpace);
    }
};
let $9014d97cd777be10$var$_canvas;
class $9014d97cd777be10$export$698882cf06df44aa {
    static getDataURL(image) {
        if (/^data:/i.test(image.src)) return image.src;
        if (typeof HTMLCanvasElement === "undefined") return image.src;
        let canvas;
        if (image instanceof HTMLCanvasElement) canvas = image;
        else {
            if ($9014d97cd777be10$var$_canvas === undefined) $9014d97cd777be10$var$_canvas = $9014d97cd777be10$var$createElementNS("canvas");
            $9014d97cd777be10$var$_canvas.width = image.width;
            $9014d97cd777be10$var$_canvas.height = image.height;
            const context = $9014d97cd777be10$var$_canvas.getContext("2d");
            if (image instanceof ImageData) context.putImageData(image, 0, 0);
            else context.drawImage(image, 0, 0, image.width, image.height);
            canvas = $9014d97cd777be10$var$_canvas;
        }
        if (canvas.width > 2048 || canvas.height > 2048) {
            console.warn("THREE.ImageUtils.getDataURL: Image converted to jpg for performance reasons", image);
            return canvas.toDataURL("image/jpeg", 0.6);
        } else return canvas.toDataURL("image/png");
    }
    static sRGBToLinear(image) {
        if (typeof HTMLImageElement !== "undefined" && image instanceof HTMLImageElement || typeof HTMLCanvasElement !== "undefined" && image instanceof HTMLCanvasElement || typeof ImageBitmap !== "undefined" && image instanceof ImageBitmap) {
            const canvas = $9014d97cd777be10$var$createElementNS("canvas");
            canvas.width = image.width;
            canvas.height = image.height;
            const context = canvas.getContext("2d");
            context.drawImage(image, 0, 0, image.width, image.height);
            const imageData = context.getImageData(0, 0, image.width, image.height);
            const data = imageData.data;
            for(let i = 0; i < data.length; i++)data[i] = $9014d97cd777be10$var$SRGBToLinear(data[i] / 255) * 255;
            context.putImageData(imageData, 0, 0);
            return canvas;
        } else if (image.data) {
            const data = image.data.slice(0);
            for(let i = 0; i < data.length; i++)if (data instanceof Uint8Array || data instanceof Uint8ClampedArray) data[i] = Math.floor($9014d97cd777be10$var$SRGBToLinear(data[i] / 255) * 255);
            else // assuming float
            data[i] = $9014d97cd777be10$var$SRGBToLinear(data[i]);
            return {
                data: data,
                width: image.width,
                height: image.height
            };
        } else {
            console.warn("THREE.ImageUtils.sRGBToLinear(): Unsupported image type. No color space conversion applied.");
            return image;
        }
    }
}
let $9014d97cd777be10$var$sourceId = 0;
class $9014d97cd777be10$export$1d2df86270c81ecb {
    set needsUpdate(value) {
        if (value === true) this.version++;
    }
    toJSON(meta) {
        const isRootObject = meta === undefined || typeof meta === "string";
        if (!isRootObject && meta.images[this.uuid] !== undefined) return meta.images[this.uuid];
        const output = {
            uuid: this.uuid,
            url: ""
        };
        const data = this.data;
        if (data !== null) {
            let url;
            if (Array.isArray(data)) {
                // cube texture
                url = [];
                for(let i = 0, l = data.length; i < l; i++)if (data[i].isDataTexture) url.push($9014d97cd777be10$var$serializeImage(data[i].image));
                else url.push($9014d97cd777be10$var$serializeImage(data[i]));
            } else // texture
            url = $9014d97cd777be10$var$serializeImage(data);
            output.url = url;
        }
        if (!isRootObject) meta.images[this.uuid] = output;
        return output;
    }
    constructor(data = null){
        this.isSource = true;
        Object.defineProperty(this, "id", {
            value: $9014d97cd777be10$var$sourceId++
        });
        this.uuid = $9014d97cd777be10$var$generateUUID();
        this.data = data;
        this.version = 0;
    }
}
function $9014d97cd777be10$var$serializeImage(image) {
    if (typeof HTMLImageElement !== "undefined" && image instanceof HTMLImageElement || typeof HTMLCanvasElement !== "undefined" && image instanceof HTMLCanvasElement || typeof ImageBitmap !== "undefined" && image instanceof ImageBitmap) // default images
    return $9014d97cd777be10$export$698882cf06df44aa.getDataURL(image);
    else {
        if (image.data) // images of DataTexture
        return {
            data: Array.from(image.data),
            width: image.width,
            height: image.height,
            type: image.data.constructor.name
        };
        else {
            console.warn("THREE.Texture: Unable to serialize Texture.");
            return {};
        }
    }
}
let $9014d97cd777be10$var$textureId = 0;
class $9014d97cd777be10$export$5431306cf43de24a extends $9014d97cd777be10$export$ec8b666c5fe2c75a {
    get image() {
        return this.source.data;
    }
    set image(value = null) {
        this.source.data = value;
    }
    updateMatrix() {
        this.matrix.setUvTransform(this.offset.x, this.offset.y, this.repeat.x, this.repeat.y, this.rotation, this.center.x, this.center.y);
    }
    clone() {
        return new this.constructor().copy(this);
    }
    copy(source) {
        this.name = source.name;
        this.source = source.source;
        this.mipmaps = source.mipmaps.slice(0);
        this.mapping = source.mapping;
        this.channel = source.channel;
        this.wrapS = source.wrapS;
        this.wrapT = source.wrapT;
        this.magFilter = source.magFilter;
        this.minFilter = source.minFilter;
        this.anisotropy = source.anisotropy;
        this.format = source.format;
        this.internalFormat = source.internalFormat;
        this.type = source.type;
        this.offset.copy(source.offset);
        this.repeat.copy(source.repeat);
        this.center.copy(source.center);
        this.rotation = source.rotation;
        this.matrixAutoUpdate = source.matrixAutoUpdate;
        this.matrix.copy(source.matrix);
        this.generateMipmaps = source.generateMipmaps;
        this.premultiplyAlpha = source.premultiplyAlpha;
        this.flipY = source.flipY;
        this.unpackAlignment = source.unpackAlignment;
        this.colorSpace = source.colorSpace;
        this.userData = JSON.parse(JSON.stringify(source.userData));
        this.needsUpdate = true;
        return this;
    }
    toJSON(meta) {
        const isRootObject = meta === undefined || typeof meta === "string";
        if (!isRootObject && meta.textures[this.uuid] !== undefined) return meta.textures[this.uuid];
        const output = {
            metadata: {
                version: 4.6,
                type: "Texture",
                generator: "Texture.toJSON"
            },
            uuid: this.uuid,
            name: this.name,
            image: this.source.toJSON(meta).uuid,
            mapping: this.mapping,
            channel: this.channel,
            repeat: [
                this.repeat.x,
                this.repeat.y
            ],
            offset: [
                this.offset.x,
                this.offset.y
            ],
            center: [
                this.center.x,
                this.center.y
            ],
            rotation: this.rotation,
            wrap: [
                this.wrapS,
                this.wrapT
            ],
            format: this.format,
            internalFormat: this.internalFormat,
            type: this.type,
            colorSpace: this.colorSpace,
            minFilter: this.minFilter,
            magFilter: this.magFilter,
            anisotropy: this.anisotropy,
            flipY: this.flipY,
            generateMipmaps: this.generateMipmaps,
            premultiplyAlpha: this.premultiplyAlpha,
            unpackAlignment: this.unpackAlignment
        };
        if (Object.keys(this.userData).length > 0) output.userData = this.userData;
        if (!isRootObject) meta.textures[this.uuid] = output;
        return output;
    }
    dispose() {
        this.dispatchEvent({
            type: "dispose"
        });
    }
    transformUv(uv) {
        if (this.mapping !== $9014d97cd777be10$export$1beec6768cbb3d2d) return uv;
        uv.applyMatrix3(this.matrix);
        if (uv.x < 0 || uv.x > 1) switch(this.wrapS){
            case $9014d97cd777be10$export$533346c8e8dac0f5:
                uv.x = uv.x - Math.floor(uv.x);
                break;
            case $9014d97cd777be10$export$9d9334239a5a5e06:
                uv.x = uv.x < 0 ? 0 : 1;
                break;
            case $9014d97cd777be10$export$c7e7c00b14f51a4f:
                if (Math.abs(Math.floor(uv.x) % 2) === 1) uv.x = Math.ceil(uv.x) - uv.x;
                else uv.x = uv.x - Math.floor(uv.x);
                break;
        }
        if (uv.y < 0 || uv.y > 1) switch(this.wrapT){
            case $9014d97cd777be10$export$533346c8e8dac0f5:
                uv.y = uv.y - Math.floor(uv.y);
                break;
            case $9014d97cd777be10$export$9d9334239a5a5e06:
                uv.y = uv.y < 0 ? 0 : 1;
                break;
            case $9014d97cd777be10$export$c7e7c00b14f51a4f:
                if (Math.abs(Math.floor(uv.y) % 2) === 1) uv.y = Math.ceil(uv.y) - uv.y;
                else uv.y = uv.y - Math.floor(uv.y);
                break;
        }
        if (this.flipY) uv.y = 1 - uv.y;
        return uv;
    }
    set needsUpdate(value) {
        if (value === true) {
            this.version++;
            this.source.needsUpdate = true;
        }
    }
    get encoding() {
        $9014d97cd777be10$var$warnOnce("THREE.Texture: Property .encoding has been replaced by .colorSpace.");
        return this.colorSpace === $9014d97cd777be10$export$561f394b24edfcaa ? $9014d97cd777be10$export$f32388edbb32674 : $9014d97cd777be10$export$7207336e4151a112;
    }
    set encoding(encoding) {
        $9014d97cd777be10$var$warnOnce("THREE.Texture: Property .encoding has been replaced by .colorSpace.");
        this.colorSpace = encoding === $9014d97cd777be10$export$f32388edbb32674 ? $9014d97cd777be10$export$561f394b24edfcaa : $9014d97cd777be10$export$bfcb490c2dd3db51;
    }
    constructor(image = $9014d97cd777be10$export$5431306cf43de24a.DEFAULT_IMAGE, mapping = $9014d97cd777be10$export$5431306cf43de24a.DEFAULT_MAPPING, wrapS = $9014d97cd777be10$export$9d9334239a5a5e06, wrapT = $9014d97cd777be10$export$9d9334239a5a5e06, magFilter = $9014d97cd777be10$export$8a72f490b25c56c8, minFilter = $9014d97cd777be10$export$5d8599b6a933fb1b, format = $9014d97cd777be10$export$3f8bb04b555a363c, type = $9014d97cd777be10$export$2e8ce08d3f6f5e10, anisotropy = $9014d97cd777be10$export$5431306cf43de24a.DEFAULT_ANISOTROPY, colorSpace1 = $9014d97cd777be10$export$bfcb490c2dd3db51){
        super();
        this.isTexture = true;
        Object.defineProperty(this, "id", {
            value: $9014d97cd777be10$var$textureId++
        });
        this.uuid = $9014d97cd777be10$var$generateUUID();
        this.name = "";
        this.source = new $9014d97cd777be10$export$1d2df86270c81ecb(image);
        this.mipmaps = [];
        this.mapping = mapping;
        this.channel = 0;
        this.wrapS = wrapS;
        this.wrapT = wrapT;
        this.magFilter = magFilter;
        this.minFilter = minFilter;
        this.anisotropy = anisotropy;
        this.format = format;
        this.internalFormat = null;
        this.type = type;
        this.offset = new $9014d97cd777be10$export$c977b3e384af9ae1(0, 0);
        this.repeat = new $9014d97cd777be10$export$c977b3e384af9ae1(1, 1);
        this.center = new $9014d97cd777be10$export$c977b3e384af9ae1(0, 0);
        this.rotation = 0;
        this.matrixAutoUpdate = true;
        this.matrix = new $9014d97cd777be10$export$8ff26dafa08918();
        this.generateMipmaps = true;
        this.premultiplyAlpha = false;
        this.flipY = true;
        this.unpackAlignment = 4; // valid values: 1, 2, 4, 8 (see http://www.khronos.org/opengles/sdk/docs/man/xhtml/glPixelStorei.xml)
        if (typeof colorSpace1 === "string") this.colorSpace = colorSpace1;
        else {
            $9014d97cd777be10$var$warnOnce("THREE.Texture: Property .encoding has been replaced by .colorSpace.");
            this.colorSpace = colorSpace1 === $9014d97cd777be10$export$f32388edbb32674 ? $9014d97cd777be10$export$561f394b24edfcaa : $9014d97cd777be10$export$bfcb490c2dd3db51;
        }
        this.userData = {};
        this.version = 0;
        this.onUpdate = null;
        this.isRenderTargetTexture = false; // indicates whether a texture belongs to a render target or not
        this.needsPMREMUpdate = false; // indicates whether this texture should be processed by PMREMGenerator or not (only relevant for render target textures)
    }
}
$9014d97cd777be10$export$5431306cf43de24a.DEFAULT_IMAGE = null;
$9014d97cd777be10$export$5431306cf43de24a.DEFAULT_MAPPING = $9014d97cd777be10$export$1beec6768cbb3d2d;
$9014d97cd777be10$export$5431306cf43de24a.DEFAULT_ANISOTROPY = 1;
class $9014d97cd777be10$export$fa7daccca11cdbe3 {
    get width() {
        return this.z;
    }
    set width(value) {
        this.z = value;
    }
    get height() {
        return this.w;
    }
    set height(value) {
        this.w = value;
    }
    set(x, y, z, w) {
        this.x = x;
        this.y = y;
        this.z = z;
        this.w = w;
        return this;
    }
    setScalar(scalar) {
        this.x = scalar;
        this.y = scalar;
        this.z = scalar;
        this.w = scalar;
        return this;
    }
    setX(x) {
        this.x = x;
        return this;
    }
    setY(y) {
        this.y = y;
        return this;
    }
    setZ(z) {
        this.z = z;
        return this;
    }
    setW(w) {
        this.w = w;
        return this;
    }
    setComponent(index, value) {
        switch(index){
            case 0:
                this.x = value;
                break;
            case 1:
                this.y = value;
                break;
            case 2:
                this.z = value;
                break;
            case 3:
                this.w = value;
                break;
            default:
                throw new Error("index is out of range: " + index);
        }
        return this;
    }
    getComponent(index) {
        switch(index){
            case 0:
                return this.x;
            case 1:
                return this.y;
            case 2:
                return this.z;
            case 3:
                return this.w;
            default:
                throw new Error("index is out of range: " + index);
        }
    }
    clone() {
        return new this.constructor(this.x, this.y, this.z, this.w);
    }
    copy(v) {
        this.x = v.x;
        this.y = v.y;
        this.z = v.z;
        this.w = v.w !== undefined ? v.w : 1;
        return this;
    }
    add(v) {
        this.x += v.x;
        this.y += v.y;
        this.z += v.z;
        this.w += v.w;
        return this;
    }
    addScalar(s) {
        this.x += s;
        this.y += s;
        this.z += s;
        this.w += s;
        return this;
    }
    addVectors(a, b) {
        this.x = a.x + b.x;
        this.y = a.y + b.y;
        this.z = a.z + b.z;
        this.w = a.w + b.w;
        return this;
    }
    addScaledVector(v, s) {
        this.x += v.x * s;
        this.y += v.y * s;
        this.z += v.z * s;
        this.w += v.w * s;
        return this;
    }
    sub(v) {
        this.x -= v.x;
        this.y -= v.y;
        this.z -= v.z;
        this.w -= v.w;
        return this;
    }
    subScalar(s) {
        this.x -= s;
        this.y -= s;
        this.z -= s;
        this.w -= s;
        return this;
    }
    subVectors(a, b) {
        this.x = a.x - b.x;
        this.y = a.y - b.y;
        this.z = a.z - b.z;
        this.w = a.w - b.w;
        return this;
    }
    multiply(v) {
        this.x *= v.x;
        this.y *= v.y;
        this.z *= v.z;
        this.w *= v.w;
        return this;
    }
    multiplyScalar(scalar) {
        this.x *= scalar;
        this.y *= scalar;
        this.z *= scalar;
        this.w *= scalar;
        return this;
    }
    applyMatrix4(m) {
        const x = this.x, y = this.y, z = this.z, w = this.w;
        const e = m.elements;
        this.x = e[0] * x + e[4] * y + e[8] * z + e[12] * w;
        this.y = e[1] * x + e[5] * y + e[9] * z + e[13] * w;
        this.z = e[2] * x + e[6] * y + e[10] * z + e[14] * w;
        this.w = e[3] * x + e[7] * y + e[11] * z + e[15] * w;
        return this;
    }
    divideScalar(scalar) {
        return this.multiplyScalar(1 / scalar);
    }
    setAxisAngleFromQuaternion(q) {
        // http://www.euclideanspace.com/maths/geometry/rotations/conversions/quaternionToAngle/index.htm
        // q is assumed to be normalized
        this.w = 2 * Math.acos(q.w);
        const s = Math.sqrt(1 - q.w * q.w);
        if (s < 0.0001) {
            this.x = 1;
            this.y = 0;
            this.z = 0;
        } else {
            this.x = q.x / s;
            this.y = q.y / s;
            this.z = q.z / s;
        }
        return this;
    }
    setAxisAngleFromRotationMatrix(m) {
        // http://www.euclideanspace.com/maths/geometry/rotations/conversions/matrixToAngle/index.htm
        // assumes the upper 3x3 of m is a pure rotation matrix (i.e, unscaled)
        let angle, x, y, z; // variables for result
        const epsilon = 0.01, epsilon2 = 0.1, te = m.elements, m11 = te[0], m12 = te[4], m13 = te[8], m21 = te[1], m22 = te[5], m23 = te[9], m31 = te[2], m32 = te[6], m33 = te[10];
        if (Math.abs(m12 - m21) < epsilon && Math.abs(m13 - m31) < epsilon && Math.abs(m23 - m32) < epsilon) {
            // singularity found
            // first check for identity matrix which must have +1 for all terms
            // in leading diagonal and zero in other terms
            if (Math.abs(m12 + m21) < epsilon2 && Math.abs(m13 + m31) < epsilon2 && Math.abs(m23 + m32) < epsilon2 && Math.abs(m11 + m22 + m33 - 3) < epsilon2) {
                // this singularity is identity matrix so angle = 0
                this.set(1, 0, 0, 0);
                return this; // zero angle, arbitrary axis
            }
            // otherwise this singularity is angle = 180
            angle = Math.PI;
            const xx = (m11 + 1) / 2;
            const yy = (m22 + 1) / 2;
            const zz = (m33 + 1) / 2;
            const xy = (m12 + m21) / 4;
            const xz = (m13 + m31) / 4;
            const yz = (m23 + m32) / 4;
            if (xx > yy && xx > zz) {
                // m11 is the largest diagonal term
                if (xx < epsilon) {
                    x = 0;
                    y = 0.707106781;
                    z = 0.707106781;
                } else {
                    x = Math.sqrt(xx);
                    y = xy / x;
                    z = xz / x;
                }
            } else if (yy > zz) {
                // m22 is the largest diagonal term
                if (yy < epsilon) {
                    x = 0.707106781;
                    y = 0;
                    z = 0.707106781;
                } else {
                    y = Math.sqrt(yy);
                    x = xy / y;
                    z = yz / y;
                }
            } else // m33 is the largest diagonal term so base result on this
            if (zz < epsilon) {
                x = 0.707106781;
                y = 0.707106781;
                z = 0;
            } else {
                z = Math.sqrt(zz);
                x = xz / z;
                y = yz / z;
            }
            this.set(x, y, z, angle);
            return this; // return 180 deg rotation
        }
        // as we have reached here there are no singularities so we can handle normally
        let s = Math.sqrt((m32 - m23) * (m32 - m23) + (m13 - m31) * (m13 - m31) + (m21 - m12) * (m21 - m12)); // used to normalize
        if (Math.abs(s) < 0.001) s = 1;
        // prevent divide by zero, should not happen if matrix is orthogonal and should be
        // caught by singularity test above, but I've left it in just in case
        this.x = (m32 - m23) / s;
        this.y = (m13 - m31) / s;
        this.z = (m21 - m12) / s;
        this.w = Math.acos((m11 + m22 + m33 - 1) / 2);
        return this;
    }
    min(v) {
        this.x = Math.min(this.x, v.x);
        this.y = Math.min(this.y, v.y);
        this.z = Math.min(this.z, v.z);
        this.w = Math.min(this.w, v.w);
        return this;
    }
    max(v) {
        this.x = Math.max(this.x, v.x);
        this.y = Math.max(this.y, v.y);
        this.z = Math.max(this.z, v.z);
        this.w = Math.max(this.w, v.w);
        return this;
    }
    clamp(min, max) {
        // assumes min < max, componentwise
        this.x = Math.max(min.x, Math.min(max.x, this.x));
        this.y = Math.max(min.y, Math.min(max.y, this.y));
        this.z = Math.max(min.z, Math.min(max.z, this.z));
        this.w = Math.max(min.w, Math.min(max.w, this.w));
        return this;
    }
    clampScalar(minVal, maxVal) {
        this.x = Math.max(minVal, Math.min(maxVal, this.x));
        this.y = Math.max(minVal, Math.min(maxVal, this.y));
        this.z = Math.max(minVal, Math.min(maxVal, this.z));
        this.w = Math.max(minVal, Math.min(maxVal, this.w));
        return this;
    }
    clampLength(min, max) {
        const length = this.length();
        return this.divideScalar(length || 1).multiplyScalar(Math.max(min, Math.min(max, length)));
    }
    floor() {
        this.x = Math.floor(this.x);
        this.y = Math.floor(this.y);
        this.z = Math.floor(this.z);
        this.w = Math.floor(this.w);
        return this;
    }
    ceil() {
        this.x = Math.ceil(this.x);
        this.y = Math.ceil(this.y);
        this.z = Math.ceil(this.z);
        this.w = Math.ceil(this.w);
        return this;
    }
    round() {
        this.x = Math.round(this.x);
        this.y = Math.round(this.y);
        this.z = Math.round(this.z);
        this.w = Math.round(this.w);
        return this;
    }
    roundToZero() {
        this.x = this.x < 0 ? Math.ceil(this.x) : Math.floor(this.x);
        this.y = this.y < 0 ? Math.ceil(this.y) : Math.floor(this.y);
        this.z = this.z < 0 ? Math.ceil(this.z) : Math.floor(this.z);
        this.w = this.w < 0 ? Math.ceil(this.w) : Math.floor(this.w);
        return this;
    }
    negate() {
        this.x = -this.x;
        this.y = -this.y;
        this.z = -this.z;
        this.w = -this.w;
        return this;
    }
    dot(v) {
        return this.x * v.x + this.y * v.y + this.z * v.z + this.w * v.w;
    }
    lengthSq() {
        return this.x * this.x + this.y * this.y + this.z * this.z + this.w * this.w;
    }
    length() {
        return Math.sqrt(this.x * this.x + this.y * this.y + this.z * this.z + this.w * this.w);
    }
    manhattanLength() {
        return Math.abs(this.x) + Math.abs(this.y) + Math.abs(this.z) + Math.abs(this.w);
    }
    normalize() {
        return this.divideScalar(this.length() || 1);
    }
    setLength(length) {
        return this.normalize().multiplyScalar(length);
    }
    lerp(v, alpha) {
        this.x += (v.x - this.x) * alpha;
        this.y += (v.y - this.y) * alpha;
        this.z += (v.z - this.z) * alpha;
        this.w += (v.w - this.w) * alpha;
        return this;
    }
    lerpVectors(v1, v2, alpha) {
        this.x = v1.x + (v2.x - v1.x) * alpha;
        this.y = v1.y + (v2.y - v1.y) * alpha;
        this.z = v1.z + (v2.z - v1.z) * alpha;
        this.w = v1.w + (v2.w - v1.w) * alpha;
        return this;
    }
    equals(v) {
        return v.x === this.x && v.y === this.y && v.z === this.z && v.w === this.w;
    }
    fromArray(array, offset = 0) {
        this.x = array[offset];
        this.y = array[offset + 1];
        this.z = array[offset + 2];
        this.w = array[offset + 3];
        return this;
    }
    toArray(array = [], offset = 0) {
        array[offset] = this.x;
        array[offset + 1] = this.y;
        array[offset + 2] = this.z;
        array[offset + 3] = this.w;
        return array;
    }
    fromBufferAttribute(attribute, index) {
        this.x = attribute.getX(index);
        this.y = attribute.getY(index);
        this.z = attribute.getZ(index);
        this.w = attribute.getW(index);
        return this;
    }
    random() {
        this.x = Math.random();
        this.y = Math.random();
        this.z = Math.random();
        this.w = Math.random();
        return this;
    }
    *[Symbol.iterator]() {
        yield this.x;
        yield this.y;
        yield this.z;
        yield this.w;
    }
    constructor(x = 0, y = 0, z = 0, w = 1){
        $9014d97cd777be10$export$fa7daccca11cdbe3.prototype.isVector4 = true;
        this.x = x;
        this.y = y;
        this.z = z;
        this.w = w;
    }
}
/*
 In options, we can specify:
 * Texture parameters for an auto-generated target texture
 * depthBuffer/stencilBuffer: Booleans to indicate if we should generate these buffers
*/ class $9014d97cd777be10$export$efcb1f8bf367cbfb extends $9014d97cd777be10$export$ec8b666c5fe2c75a {
    setSize(width, height, depth = 1) {
        if (this.width !== width || this.height !== height || this.depth !== depth) {
            this.width = width;
            this.height = height;
            this.depth = depth;
            this.texture.image.width = width;
            this.texture.image.height = height;
            this.texture.image.depth = depth;
            this.dispose();
        }
        this.viewport.set(0, 0, width, height);
        this.scissor.set(0, 0, width, height);
    }
    clone() {
        return new this.constructor().copy(this);
    }
    copy(source) {
        this.width = source.width;
        this.height = source.height;
        this.depth = source.depth;
        this.scissor.copy(source.scissor);
        this.scissorTest = source.scissorTest;
        this.viewport.copy(source.viewport);
        this.texture = source.texture.clone();
        this.texture.isRenderTargetTexture = true;
        // ensure image object is not shared, see #20328
        const image = Object.assign({}, source.texture.image);
        this.texture.source = new $9014d97cd777be10$export$1d2df86270c81ecb(image);
        this.depthBuffer = source.depthBuffer;
        this.stencilBuffer = source.stencilBuffer;
        if (source.depthTexture !== null) this.depthTexture = source.depthTexture.clone();
        this.samples = source.samples;
        return this;
    }
    dispose() {
        this.dispatchEvent({
            type: "dispose"
        });
    }
    constructor(width = 1, height = 1, options = {}){
        super();
        this.isRenderTarget = true;
        this.width = width;
        this.height = height;
        this.depth = 1;
        this.scissor = new $9014d97cd777be10$export$fa7daccca11cdbe3(0, 0, width, height);
        this.scissorTest = false;
        this.viewport = new $9014d97cd777be10$export$fa7daccca11cdbe3(0, 0, width, height);
        const image = {
            width: width,
            height: height,
            depth: 1
        };
        if (options.encoding !== undefined) {
            // @deprecated, r152
            $9014d97cd777be10$var$warnOnce("THREE.WebGLRenderTarget: option.encoding has been replaced by option.colorSpace.");
            options.colorSpace = options.encoding === $9014d97cd777be10$export$f32388edbb32674 ? $9014d97cd777be10$export$561f394b24edfcaa : $9014d97cd777be10$export$bfcb490c2dd3db51;
        }
        this.texture = new $9014d97cd777be10$export$5431306cf43de24a(image, options.mapping, options.wrapS, options.wrapT, options.magFilter, options.minFilter, options.format, options.type, options.anisotropy, options.colorSpace);
        this.texture.isRenderTargetTexture = true;
        this.texture.flipY = false;
        this.texture.generateMipmaps = options.generateMipmaps !== undefined ? options.generateMipmaps : false;
        this.texture.internalFormat = options.internalFormat !== undefined ? options.internalFormat : null;
        this.texture.minFilter = options.minFilter !== undefined ? options.minFilter : $9014d97cd777be10$export$8a72f490b25c56c8;
        this.depthBuffer = options.depthBuffer !== undefined ? options.depthBuffer : true;
        this.stencilBuffer = options.stencilBuffer !== undefined ? options.stencilBuffer : false;
        this.depthTexture = options.depthTexture !== undefined ? options.depthTexture : null;
        this.samples = options.samples !== undefined ? options.samples : 0;
    }
}
class $9014d97cd777be10$export$3c052beb2e51e23f extends $9014d97cd777be10$export$efcb1f8bf367cbfb {
    constructor(width = 1, height = 1, options = {}){
        super(width, height, options);
        this.isWebGLRenderTarget = true;
    }
}
class $9014d97cd777be10$export$dfac6c8e811406a3 extends $9014d97cd777be10$export$5431306cf43de24a {
    constructor(data = null, width = 1, height = 1, depth = 1){
        super(null);
        this.isDataArrayTexture = true;
        this.image = {
            data: data,
            width: width,
            height: height,
            depth: depth
        };
        this.magFilter = $9014d97cd777be10$export$727aa5ec3fe39bf0;
        this.minFilter = $9014d97cd777be10$export$727aa5ec3fe39bf0;
        this.wrapR = $9014d97cd777be10$export$9d9334239a5a5e06;
        this.generateMipmaps = false;
        this.flipY = false;
        this.unpackAlignment = 1;
    }
}
class $9014d97cd777be10$export$c77a02c11ed180c7 extends $9014d97cd777be10$export$3c052beb2e51e23f {
    constructor(width = 1, height = 1, depth = 1){
        super(width, height);
        this.isWebGLArrayRenderTarget = true;
        this.depth = depth;
        this.texture = new $9014d97cd777be10$export$dfac6c8e811406a3(null, width, height, depth);
        this.texture.isRenderTargetTexture = true;
    }
}
class $9014d97cd777be10$export$d7a3086320f856db extends $9014d97cd777be10$export$5431306cf43de24a {
    constructor(data = null, width = 1, height = 1, depth = 1){
        // We're going to add .setXXX() methods for setting properties later.
        // Users can still set in DataTexture3D directly.
        //
        //	const texture = new THREE.DataTexture3D( data, width, height, depth );
        // 	texture.anisotropy = 16;
        //
        // See #14839
        super(null);
        this.isData3DTexture = true;
        this.image = {
            data: data,
            width: width,
            height: height,
            depth: depth
        };
        this.magFilter = $9014d97cd777be10$export$727aa5ec3fe39bf0;
        this.minFilter = $9014d97cd777be10$export$727aa5ec3fe39bf0;
        this.wrapR = $9014d97cd777be10$export$9d9334239a5a5e06;
        this.generateMipmaps = false;
        this.flipY = false;
        this.unpackAlignment = 1;
    }
}
class $9014d97cd777be10$export$7ee06591009639df extends $9014d97cd777be10$export$3c052beb2e51e23f {
    constructor(width = 1, height = 1, depth = 1){
        super(width, height);
        this.isWebGL3DRenderTarget = true;
        this.depth = depth;
        this.texture = new $9014d97cd777be10$export$d7a3086320f856db(null, width, height, depth);
        this.texture.isRenderTargetTexture = true;
    }
}
class $9014d97cd777be10$export$bd934554fb721730 extends $9014d97cd777be10$export$3c052beb2e51e23f {
    setSize(width, height, depth = 1) {
        if (this.width !== width || this.height !== height || this.depth !== depth) {
            this.width = width;
            this.height = height;
            this.depth = depth;
            for(let i = 0, il = this.texture.length; i < il; i++){
                this.texture[i].image.width = width;
                this.texture[i].image.height = height;
                this.texture[i].image.depth = depth;
            }
            this.dispose();
        }
        this.viewport.set(0, 0, width, height);
        this.scissor.set(0, 0, width, height);
    }
    copy(source) {
        this.dispose();
        this.width = source.width;
        this.height = source.height;
        this.depth = source.depth;
        this.scissor.copy(source.scissor);
        this.scissorTest = source.scissorTest;
        this.viewport.copy(source.viewport);
        this.depthBuffer = source.depthBuffer;
        this.stencilBuffer = source.stencilBuffer;
        if (source.depthTexture !== null) this.depthTexture = source.depthTexture.clone();
        this.texture.length = 0;
        for(let i = 0, il = source.texture.length; i < il; i++){
            this.texture[i] = source.texture[i].clone();
            this.texture[i].isRenderTargetTexture = true;
        }
        return this;
    }
    constructor(width = 1, height = 1, count = 1, options = {}){
        super(width, height, options);
        this.isWebGLMultipleRenderTargets = true;
        const texture = this.texture;
        this.texture = [];
        for(let i = 0; i < count; i++){
            this.texture[i] = texture.clone();
            this.texture[i].isRenderTargetTexture = true;
        }
    }
}
class $9014d97cd777be10$export$23d6a54f0bbc85a3 {
    static slerpFlat(dst, dstOffset, src0, srcOffset0, src1, srcOffset1, t) {
        // fuzz-free, array-based Quaternion SLERP operation
        let x0 = src0[srcOffset0 + 0], y0 = src0[srcOffset0 + 1], z0 = src0[srcOffset0 + 2], w0 = src0[srcOffset0 + 3];
        const x1 = src1[srcOffset1 + 0], y1 = src1[srcOffset1 + 1], z1 = src1[srcOffset1 + 2], w1 = src1[srcOffset1 + 3];
        if (t === 0) {
            dst[dstOffset + 0] = x0;
            dst[dstOffset + 1] = y0;
            dst[dstOffset + 2] = z0;
            dst[dstOffset + 3] = w0;
            return;
        }
        if (t === 1) {
            dst[dstOffset + 0] = x1;
            dst[dstOffset + 1] = y1;
            dst[dstOffset + 2] = z1;
            dst[dstOffset + 3] = w1;
            return;
        }
        if (w0 !== w1 || x0 !== x1 || y0 !== y1 || z0 !== z1) {
            let s = 1 - t;
            const cos = x0 * x1 + y0 * y1 + z0 * z1 + w0 * w1, dir = cos >= 0 ? 1 : -1, sqrSin = 1 - cos * cos;
            // Skip the Slerp for tiny steps to avoid numeric problems:
            if (sqrSin > Number.EPSILON) {
                const sin = Math.sqrt(sqrSin), len = Math.atan2(sin, cos * dir);
                s = Math.sin(s * len) / sin;
                t = Math.sin(t * len) / sin;
            }
            const tDir = t * dir;
            x0 = x0 * s + x1 * tDir;
            y0 = y0 * s + y1 * tDir;
            z0 = z0 * s + z1 * tDir;
            w0 = w0 * s + w1 * tDir;
            // Normalize in case we just did a lerp:
            if (s === 1 - t) {
                const f = 1 / Math.sqrt(x0 * x0 + y0 * y0 + z0 * z0 + w0 * w0);
                x0 *= f;
                y0 *= f;
                z0 *= f;
                w0 *= f;
            }
        }
        dst[dstOffset] = x0;
        dst[dstOffset + 1] = y0;
        dst[dstOffset + 2] = z0;
        dst[dstOffset + 3] = w0;
    }
    static multiplyQuaternionsFlat(dst, dstOffset, src0, srcOffset0, src1, srcOffset1) {
        const x0 = src0[srcOffset0];
        const y0 = src0[srcOffset0 + 1];
        const z0 = src0[srcOffset0 + 2];
        const w0 = src0[srcOffset0 + 3];
        const x1 = src1[srcOffset1];
        const y1 = src1[srcOffset1 + 1];
        const z1 = src1[srcOffset1 + 2];
        const w1 = src1[srcOffset1 + 3];
        dst[dstOffset] = x0 * w1 + w0 * x1 + y0 * z1 - z0 * y1;
        dst[dstOffset + 1] = y0 * w1 + w0 * y1 + z0 * x1 - x0 * z1;
        dst[dstOffset + 2] = z0 * w1 + w0 * z1 + x0 * y1 - y0 * x1;
        dst[dstOffset + 3] = w0 * w1 - x0 * x1 - y0 * y1 - z0 * z1;
        return dst;
    }
    get x() {
        return this._x;
    }
    set x(value) {
        this._x = value;
        this._onChangeCallback();
    }
    get y() {
        return this._y;
    }
    set y(value) {
        this._y = value;
        this._onChangeCallback();
    }
    get z() {
        return this._z;
    }
    set z(value) {
        this._z = value;
        this._onChangeCallback();
    }
    get w() {
        return this._w;
    }
    set w(value) {
        this._w = value;
        this._onChangeCallback();
    }
    set(x, y, z, w) {
        this._x = x;
        this._y = y;
        this._z = z;
        this._w = w;
        this._onChangeCallback();
        return this;
    }
    clone() {
        return new this.constructor(this._x, this._y, this._z, this._w);
    }
    copy(quaternion) {
        this._x = quaternion.x;
        this._y = quaternion.y;
        this._z = quaternion.z;
        this._w = quaternion.w;
        this._onChangeCallback();
        return this;
    }
    setFromEuler(euler, update) {
        const x = euler._x, y = euler._y, z = euler._z, order = euler._order;
        // http://www.mathworks.com/matlabcentral/fileexchange/
        // 	20696-function-to-convert-between-dcm-euler-angles-quaternions-and-euler-vectors/
        //	content/SpinCalc.m
        const cos = Math.cos;
        const sin = Math.sin;
        const c1 = cos(x / 2);
        const c2 = cos(y / 2);
        const c3 = cos(z / 2);
        const s1 = sin(x / 2);
        const s2 = sin(y / 2);
        const s3 = sin(z / 2);
        switch(order){
            case "XYZ":
                this._x = s1 * c2 * c3 + c1 * s2 * s3;
                this._y = c1 * s2 * c3 - s1 * c2 * s3;
                this._z = c1 * c2 * s3 + s1 * s2 * c3;
                this._w = c1 * c2 * c3 - s1 * s2 * s3;
                break;
            case "YXZ":
                this._x = s1 * c2 * c3 + c1 * s2 * s3;
                this._y = c1 * s2 * c3 - s1 * c2 * s3;
                this._z = c1 * c2 * s3 - s1 * s2 * c3;
                this._w = c1 * c2 * c3 + s1 * s2 * s3;
                break;
            case "ZXY":
                this._x = s1 * c2 * c3 - c1 * s2 * s3;
                this._y = c1 * s2 * c3 + s1 * c2 * s3;
                this._z = c1 * c2 * s3 + s1 * s2 * c3;
                this._w = c1 * c2 * c3 - s1 * s2 * s3;
                break;
            case "ZYX":
                this._x = s1 * c2 * c3 - c1 * s2 * s3;
                this._y = c1 * s2 * c3 + s1 * c2 * s3;
                this._z = c1 * c2 * s3 - s1 * s2 * c3;
                this._w = c1 * c2 * c3 + s1 * s2 * s3;
                break;
            case "YZX":
                this._x = s1 * c2 * c3 + c1 * s2 * s3;
                this._y = c1 * s2 * c3 + s1 * c2 * s3;
                this._z = c1 * c2 * s3 - s1 * s2 * c3;
                this._w = c1 * c2 * c3 - s1 * s2 * s3;
                break;
            case "XZY":
                this._x = s1 * c2 * c3 - c1 * s2 * s3;
                this._y = c1 * s2 * c3 - s1 * c2 * s3;
                this._z = c1 * c2 * s3 + s1 * s2 * c3;
                this._w = c1 * c2 * c3 + s1 * s2 * s3;
                break;
            default:
                console.warn("THREE.Quaternion: .setFromEuler() encountered an unknown order: " + order);
        }
        if (update !== false) this._onChangeCallback();
        return this;
    }
    setFromAxisAngle(axis, angle) {
        // http://www.euclideanspace.com/maths/geometry/rotations/conversions/angleToQuaternion/index.htm
        // assumes axis is normalized
        const halfAngle = angle / 2, s = Math.sin(halfAngle);
        this._x = axis.x * s;
        this._y = axis.y * s;
        this._z = axis.z * s;
        this._w = Math.cos(halfAngle);
        this._onChangeCallback();
        return this;
    }
    setFromRotationMatrix(m) {
        // http://www.euclideanspace.com/maths/geometry/rotations/conversions/matrixToQuaternion/index.htm
        // assumes the upper 3x3 of m is a pure rotation matrix (i.e, unscaled)
        const te = m.elements, m11 = te[0], m12 = te[4], m13 = te[8], m21 = te[1], m22 = te[5], m23 = te[9], m31 = te[2], m32 = te[6], m33 = te[10], trace = m11 + m22 + m33;
        if (trace > 0) {
            const s = 0.5 / Math.sqrt(trace + 1.0);
            this._w = 0.25 / s;
            this._x = (m32 - m23) * s;
            this._y = (m13 - m31) * s;
            this._z = (m21 - m12) * s;
        } else if (m11 > m22 && m11 > m33) {
            const s = 2.0 * Math.sqrt(1.0 + m11 - m22 - m33);
            this._w = (m32 - m23) / s;
            this._x = 0.25 * s;
            this._y = (m12 + m21) / s;
            this._z = (m13 + m31) / s;
        } else if (m22 > m33) {
            const s = 2.0 * Math.sqrt(1.0 + m22 - m11 - m33);
            this._w = (m13 - m31) / s;
            this._x = (m12 + m21) / s;
            this._y = 0.25 * s;
            this._z = (m23 + m32) / s;
        } else {
            const s = 2.0 * Math.sqrt(1.0 + m33 - m11 - m22);
            this._w = (m21 - m12) / s;
            this._x = (m13 + m31) / s;
            this._y = (m23 + m32) / s;
            this._z = 0.25 * s;
        }
        this._onChangeCallback();
        return this;
    }
    setFromUnitVectors(vFrom, vTo) {
        // assumes direction vectors vFrom and vTo are normalized
        let r = vFrom.dot(vTo) + 1;
        if (r < Number.EPSILON) {
            // vFrom and vTo point in opposite directions
            r = 0;
            if (Math.abs(vFrom.x) > Math.abs(vFrom.z)) {
                this._x = -vFrom.y;
                this._y = vFrom.x;
                this._z = 0;
                this._w = r;
            } else {
                this._x = 0;
                this._y = -vFrom.z;
                this._z = vFrom.y;
                this._w = r;
            }
        } else {
            // crossVectors( vFrom, vTo ); // inlined to avoid cyclic dependency on Vector3
            this._x = vFrom.y * vTo.z - vFrom.z * vTo.y;
            this._y = vFrom.z * vTo.x - vFrom.x * vTo.z;
            this._z = vFrom.x * vTo.y - vFrom.y * vTo.x;
            this._w = r;
        }
        return this.normalize();
    }
    angleTo(q) {
        return 2 * Math.acos(Math.abs($9014d97cd777be10$var$clamp(this.dot(q), -1, 1)));
    }
    rotateTowards(q, step) {
        const angle = this.angleTo(q);
        if (angle === 0) return this;
        const t = Math.min(1, step / angle);
        this.slerp(q, t);
        return this;
    }
    identity() {
        return this.set(0, 0, 0, 1);
    }
    invert() {
        // quaternion is assumed to have unit length
        return this.conjugate();
    }
    conjugate() {
        this._x *= -1;
        this._y *= -1;
        this._z *= -1;
        this._onChangeCallback();
        return this;
    }
    dot(v) {
        return this._x * v._x + this._y * v._y + this._z * v._z + this._w * v._w;
    }
    lengthSq() {
        return this._x * this._x + this._y * this._y + this._z * this._z + this._w * this._w;
    }
    length() {
        return Math.sqrt(this._x * this._x + this._y * this._y + this._z * this._z + this._w * this._w);
    }
    normalize() {
        let l = this.length();
        if (l === 0) {
            this._x = 0;
            this._y = 0;
            this._z = 0;
            this._w = 1;
        } else {
            l = 1 / l;
            this._x = this._x * l;
            this._y = this._y * l;
            this._z = this._z * l;
            this._w = this._w * l;
        }
        this._onChangeCallback();
        return this;
    }
    multiply(q) {
        return this.multiplyQuaternions(this, q);
    }
    premultiply(q) {
        return this.multiplyQuaternions(q, this);
    }
    multiplyQuaternions(a, b) {
        // from http://www.euclideanspace.com/maths/algebra/realNormedAlgebra/quaternions/code/index.htm
        const qax = a._x, qay = a._y, qaz = a._z, qaw = a._w;
        const qbx = b._x, qby = b._y, qbz = b._z, qbw = b._w;
        this._x = qax * qbw + qaw * qbx + qay * qbz - qaz * qby;
        this._y = qay * qbw + qaw * qby + qaz * qbx - qax * qbz;
        this._z = qaz * qbw + qaw * qbz + qax * qby - qay * qbx;
        this._w = qaw * qbw - qax * qbx - qay * qby - qaz * qbz;
        this._onChangeCallback();
        return this;
    }
    slerp(qb, t) {
        if (t === 0) return this;
        if (t === 1) return this.copy(qb);
        const x = this._x, y = this._y, z = this._z, w = this._w;
        // http://www.euclideanspace.com/maths/algebra/realNormedAlgebra/quaternions/slerp/
        let cosHalfTheta = w * qb._w + x * qb._x + y * qb._y + z * qb._z;
        if (cosHalfTheta < 0) {
            this._w = -qb._w;
            this._x = -qb._x;
            this._y = -qb._y;
            this._z = -qb._z;
            cosHalfTheta = -cosHalfTheta;
        } else this.copy(qb);
        if (cosHalfTheta >= 1.0) {
            this._w = w;
            this._x = x;
            this._y = y;
            this._z = z;
            return this;
        }
        const sqrSinHalfTheta = 1.0 - cosHalfTheta * cosHalfTheta;
        if (sqrSinHalfTheta <= Number.EPSILON) {
            const s = 1 - t;
            this._w = s * w + t * this._w;
            this._x = s * x + t * this._x;
            this._y = s * y + t * this._y;
            this._z = s * z + t * this._z;
            this.normalize();
            this._onChangeCallback();
            return this;
        }
        const sinHalfTheta = Math.sqrt(sqrSinHalfTheta);
        const halfTheta = Math.atan2(sinHalfTheta, cosHalfTheta);
        const ratioA = Math.sin((1 - t) * halfTheta) / sinHalfTheta, ratioB = Math.sin(t * halfTheta) / sinHalfTheta;
        this._w = w * ratioA + this._w * ratioB;
        this._x = x * ratioA + this._x * ratioB;
        this._y = y * ratioA + this._y * ratioB;
        this._z = z * ratioA + this._z * ratioB;
        this._onChangeCallback();
        return this;
    }
    slerpQuaternions(qa, qb, t) {
        return this.copy(qa).slerp(qb, t);
    }
    random() {
        // Derived from http://planning.cs.uiuc.edu/node198.html
        // Note, this source uses w, x, y, z ordering,
        // so we swap the order below.
        const u1 = Math.random();
        const sqrt1u1 = Math.sqrt(1 - u1);
        const sqrtu1 = Math.sqrt(u1);
        const u2 = 2 * Math.PI * Math.random();
        const u3 = 2 * Math.PI * Math.random();
        return this.set(sqrt1u1 * Math.cos(u2), sqrtu1 * Math.sin(u3), sqrtu1 * Math.cos(u3), sqrt1u1 * Math.sin(u2));
    }
    equals(quaternion) {
        return quaternion._x === this._x && quaternion._y === this._y && quaternion._z === this._z && quaternion._w === this._w;
    }
    fromArray(array, offset = 0) {
        this._x = array[offset];
        this._y = array[offset + 1];
        this._z = array[offset + 2];
        this._w = array[offset + 3];
        this._onChangeCallback();
        return this;
    }
    toArray(array = [], offset = 0) {
        array[offset] = this._x;
        array[offset + 1] = this._y;
        array[offset + 2] = this._z;
        array[offset + 3] = this._w;
        return array;
    }
    fromBufferAttribute(attribute, index) {
        this._x = attribute.getX(index);
        this._y = attribute.getY(index);
        this._z = attribute.getZ(index);
        this._w = attribute.getW(index);
        return this;
    }
    toJSON() {
        return this.toArray();
    }
    _onChange(callback) {
        this._onChangeCallback = callback;
        return this;
    }
    _onChangeCallback() {}
    *[Symbol.iterator]() {
        yield this._x;
        yield this._y;
        yield this._z;
        yield this._w;
    }
    constructor(x = 0, y = 0, z = 0, w = 1){
        this.isQuaternion = true;
        this._x = x;
        this._y = y;
        this._z = z;
        this._w = w;
    }
}
class $9014d97cd777be10$export$64b5c384219d3699 {
    set(x, y, z) {
        if (z === undefined) z = this.z; // sprite.scale.set(x,y)
        this.x = x;
        this.y = y;
        this.z = z;
        return this;
    }
    setScalar(scalar) {
        this.x = scalar;
        this.y = scalar;
        this.z = scalar;
        return this;
    }
    setX(x) {
        this.x = x;
        return this;
    }
    setY(y) {
        this.y = y;
        return this;
    }
    setZ(z) {
        this.z = z;
        return this;
    }
    setComponent(index, value) {
        switch(index){
            case 0:
                this.x = value;
                break;
            case 1:
                this.y = value;
                break;
            case 2:
                this.z = value;
                break;
            default:
                throw new Error("index is out of range: " + index);
        }
        return this;
    }
    getComponent(index) {
        switch(index){
            case 0:
                return this.x;
            case 1:
                return this.y;
            case 2:
                return this.z;
            default:
                throw new Error("index is out of range: " + index);
        }
    }
    clone() {
        return new this.constructor(this.x, this.y, this.z);
    }
    copy(v) {
        this.x = v.x;
        this.y = v.y;
        this.z = v.z;
        return this;
    }
    add(v) {
        this.x += v.x;
        this.y += v.y;
        this.z += v.z;
        return this;
    }
    addScalar(s) {
        this.x += s;
        this.y += s;
        this.z += s;
        return this;
    }
    addVectors(a, b) {
        this.x = a.x + b.x;
        this.y = a.y + b.y;
        this.z = a.z + b.z;
        return this;
    }
    addScaledVector(v, s) {
        this.x += v.x * s;
        this.y += v.y * s;
        this.z += v.z * s;
        return this;
    }
    sub(v) {
        this.x -= v.x;
        this.y -= v.y;
        this.z -= v.z;
        return this;
    }
    subScalar(s) {
        this.x -= s;
        this.y -= s;
        this.z -= s;
        return this;
    }
    subVectors(a, b) {
        this.x = a.x - b.x;
        this.y = a.y - b.y;
        this.z = a.z - b.z;
        return this;
    }
    multiply(v) {
        this.x *= v.x;
        this.y *= v.y;
        this.z *= v.z;
        return this;
    }
    multiplyScalar(scalar) {
        this.x *= scalar;
        this.y *= scalar;
        this.z *= scalar;
        return this;
    }
    multiplyVectors(a, b) {
        this.x = a.x * b.x;
        this.y = a.y * b.y;
        this.z = a.z * b.z;
        return this;
    }
    applyEuler(euler) {
        return this.applyQuaternion($9014d97cd777be10$var$_quaternion$4.setFromEuler(euler));
    }
    applyAxisAngle(axis, angle) {
        return this.applyQuaternion($9014d97cd777be10$var$_quaternion$4.setFromAxisAngle(axis, angle));
    }
    applyMatrix3(m) {
        const x = this.x, y = this.y, z = this.z;
        const e = m.elements;
        this.x = e[0] * x + e[3] * y + e[6] * z;
        this.y = e[1] * x + e[4] * y + e[7] * z;
        this.z = e[2] * x + e[5] * y + e[8] * z;
        return this;
    }
    applyNormalMatrix(m) {
        return this.applyMatrix3(m).normalize();
    }
    applyMatrix4(m) {
        const x = this.x, y = this.y, z = this.z;
        const e = m.elements;
        const w = 1 / (e[3] * x + e[7] * y + e[11] * z + e[15]);
        this.x = (e[0] * x + e[4] * y + e[8] * z + e[12]) * w;
        this.y = (e[1] * x + e[5] * y + e[9] * z + e[13]) * w;
        this.z = (e[2] * x + e[6] * y + e[10] * z + e[14]) * w;
        return this;
    }
    applyQuaternion(q) {
        const x = this.x, y = this.y, z = this.z;
        const qx = q.x, qy = q.y, qz = q.z, qw = q.w;
        // calculate quat * vector
        const ix = qw * x + qy * z - qz * y;
        const iy = qw * y + qz * x - qx * z;
        const iz = qw * z + qx * y - qy * x;
        const iw = -qx * x - qy * y - qz * z;
        // calculate result * inverse quat
        this.x = ix * qw + iw * -qx + iy * -qz - iz * -qy;
        this.y = iy * qw + iw * -qy + iz * -qx - ix * -qz;
        this.z = iz * qw + iw * -qz + ix * -qy - iy * -qx;
        return this;
    }
    project(camera) {
        return this.applyMatrix4(camera.matrixWorldInverse).applyMatrix4(camera.projectionMatrix);
    }
    unproject(camera) {
        return this.applyMatrix4(camera.projectionMatrixInverse).applyMatrix4(camera.matrixWorld);
    }
    transformDirection(m) {
        // input: THREE.Matrix4 affine matrix
        // vector interpreted as a direction
        const x = this.x, y = this.y, z = this.z;
        const e = m.elements;
        this.x = e[0] * x + e[4] * y + e[8] * z;
        this.y = e[1] * x + e[5] * y + e[9] * z;
        this.z = e[2] * x + e[6] * y + e[10] * z;
        return this.normalize();
    }
    divide(v) {
        this.x /= v.x;
        this.y /= v.y;
        this.z /= v.z;
        return this;
    }
    divideScalar(scalar) {
        return this.multiplyScalar(1 / scalar);
    }
    min(v) {
        this.x = Math.min(this.x, v.x);
        this.y = Math.min(this.y, v.y);
        this.z = Math.min(this.z, v.z);
        return this;
    }
    max(v) {
        this.x = Math.max(this.x, v.x);
        this.y = Math.max(this.y, v.y);
        this.z = Math.max(this.z, v.z);
        return this;
    }
    clamp(min, max) {
        // assumes min < max, componentwise
        this.x = Math.max(min.x, Math.min(max.x, this.x));
        this.y = Math.max(min.y, Math.min(max.y, this.y));
        this.z = Math.max(min.z, Math.min(max.z, this.z));
        return this;
    }
    clampScalar(minVal, maxVal) {
        this.x = Math.max(minVal, Math.min(maxVal, this.x));
        this.y = Math.max(minVal, Math.min(maxVal, this.y));
        this.z = Math.max(minVal, Math.min(maxVal, this.z));
        return this;
    }
    clampLength(min, max) {
        const length = this.length();
        return this.divideScalar(length || 1).multiplyScalar(Math.max(min, Math.min(max, length)));
    }
    floor() {
        this.x = Math.floor(this.x);
        this.y = Math.floor(this.y);
        this.z = Math.floor(this.z);
        return this;
    }
    ceil() {
        this.x = Math.ceil(this.x);
        this.y = Math.ceil(this.y);
        this.z = Math.ceil(this.z);
        return this;
    }
    round() {
        this.x = Math.round(this.x);
        this.y = Math.round(this.y);
        this.z = Math.round(this.z);
        return this;
    }
    roundToZero() {
        this.x = this.x < 0 ? Math.ceil(this.x) : Math.floor(this.x);
        this.y = this.y < 0 ? Math.ceil(this.y) : Math.floor(this.y);
        this.z = this.z < 0 ? Math.ceil(this.z) : Math.floor(this.z);
        return this;
    }
    negate() {
        this.x = -this.x;
        this.y = -this.y;
        this.z = -this.z;
        return this;
    }
    dot(v) {
        return this.x * v.x + this.y * v.y + this.z * v.z;
    }
    // TODO lengthSquared?
    lengthSq() {
        return this.x * this.x + this.y * this.y + this.z * this.z;
    }
    length() {
        return Math.sqrt(this.x * this.x + this.y * this.y + this.z * this.z);
    }
    manhattanLength() {
        return Math.abs(this.x) + Math.abs(this.y) + Math.abs(this.z);
    }
    normalize() {
        return this.divideScalar(this.length() || 1);
    }
    setLength(length) {
        return this.normalize().multiplyScalar(length);
    }
    lerp(v, alpha) {
        this.x += (v.x - this.x) * alpha;
        this.y += (v.y - this.y) * alpha;
        this.z += (v.z - this.z) * alpha;
        return this;
    }
    lerpVectors(v1, v2, alpha) {
        this.x = v1.x + (v2.x - v1.x) * alpha;
        this.y = v1.y + (v2.y - v1.y) * alpha;
        this.z = v1.z + (v2.z - v1.z) * alpha;
        return this;
    }
    cross(v) {
        return this.crossVectors(this, v);
    }
    crossVectors(a, b) {
        const ax = a.x, ay = a.y, az = a.z;
        const bx = b.x, by = b.y, bz = b.z;
        this.x = ay * bz - az * by;
        this.y = az * bx - ax * bz;
        this.z = ax * by - ay * bx;
        return this;
    }
    projectOnVector(v) {
        const denominator = v.lengthSq();
        if (denominator === 0) return this.set(0, 0, 0);
        const scalar = v.dot(this) / denominator;
        return this.copy(v).multiplyScalar(scalar);
    }
    projectOnPlane(planeNormal) {
        $9014d97cd777be10$var$_vector$b.copy(this).projectOnVector(planeNormal);
        return this.sub($9014d97cd777be10$var$_vector$b);
    }
    reflect(normal) {
        // reflect incident vector off plane orthogonal to normal
        // normal is assumed to have unit length
        return this.sub($9014d97cd777be10$var$_vector$b.copy(normal).multiplyScalar(2 * this.dot(normal)));
    }
    angleTo(v) {
        const denominator = Math.sqrt(this.lengthSq() * v.lengthSq());
        if (denominator === 0) return Math.PI / 2;
        const theta = this.dot(v) / denominator;
        // clamp, to handle numerical problems
        return Math.acos($9014d97cd777be10$var$clamp(theta, -1, 1));
    }
    distanceTo(v) {
        return Math.sqrt(this.distanceToSquared(v));
    }
    distanceToSquared(v) {
        const dx = this.x - v.x, dy = this.y - v.y, dz = this.z - v.z;
        return dx * dx + dy * dy + dz * dz;
    }
    manhattanDistanceTo(v) {
        return Math.abs(this.x - v.x) + Math.abs(this.y - v.y) + Math.abs(this.z - v.z);
    }
    setFromSpherical(s) {
        return this.setFromSphericalCoords(s.radius, s.phi, s.theta);
    }
    setFromSphericalCoords(radius, phi, theta) {
        const sinPhiRadius = Math.sin(phi) * radius;
        this.x = sinPhiRadius * Math.sin(theta);
        this.y = Math.cos(phi) * radius;
        this.z = sinPhiRadius * Math.cos(theta);
        return this;
    }
    setFromCylindrical(c) {
        return this.setFromCylindricalCoords(c.radius, c.theta, c.y);
    }
    setFromCylindricalCoords(radius, theta, y) {
        this.x = radius * Math.sin(theta);
        this.y = y;
        this.z = radius * Math.cos(theta);
        return this;
    }
    setFromMatrixPosition(m) {
        const e = m.elements;
        this.x = e[12];
        this.y = e[13];
        this.z = e[14];
        return this;
    }
    setFromMatrixScale(m) {
        const sx = this.setFromMatrixColumn(m, 0).length();
        const sy = this.setFromMatrixColumn(m, 1).length();
        const sz = this.setFromMatrixColumn(m, 2).length();
        this.x = sx;
        this.y = sy;
        this.z = sz;
        return this;
    }
    setFromMatrixColumn(m, index) {
        return this.fromArray(m.elements, index * 4);
    }
    setFromMatrix3Column(m, index) {
        return this.fromArray(m.elements, index * 3);
    }
    setFromEuler(e) {
        this.x = e._x;
        this.y = e._y;
        this.z = e._z;
        return this;
    }
    setFromColor(c) {
        this.x = c.r;
        this.y = c.g;
        this.z = c.b;
        return this;
    }
    equals(v) {
        return v.x === this.x && v.y === this.y && v.z === this.z;
    }
    fromArray(array, offset = 0) {
        this.x = array[offset];
        this.y = array[offset + 1];
        this.z = array[offset + 2];
        return this;
    }
    toArray(array = [], offset = 0) {
        array[offset] = this.x;
        array[offset + 1] = this.y;
        array[offset + 2] = this.z;
        return array;
    }
    fromBufferAttribute(attribute, index) {
        this.x = attribute.getX(index);
        this.y = attribute.getY(index);
        this.z = attribute.getZ(index);
        return this;
    }
    random() {
        this.x = Math.random();
        this.y = Math.random();
        this.z = Math.random();
        return this;
    }
    randomDirection() {
        // Derived from https://mathworld.wolfram.com/SpherePointPicking.html
        const u = (Math.random() - 0.5) * 2;
        const t = Math.random() * Math.PI * 2;
        const f = Math.sqrt(1 - u ** 2);
        this.x = f * Math.cos(t);
        this.y = f * Math.sin(t);
        this.z = u;
        return this;
    }
    *[Symbol.iterator]() {
        yield this.x;
        yield this.y;
        yield this.z;
    }
    constructor(x = 0, y = 0, z = 0){
        $9014d97cd777be10$export$64b5c384219d3699.prototype.isVector3 = true;
        this.x = x;
        this.y = y;
        this.z = z;
    }
}
const $9014d97cd777be10$var$_vector$b = /*@__PURE__*/ new $9014d97cd777be10$export$64b5c384219d3699();
const $9014d97cd777be10$var$_quaternion$4 = /*@__PURE__*/ new $9014d97cd777be10$export$23d6a54f0bbc85a3();
class $9014d97cd777be10$export$6f7d5a9418ab2aa3 {
    set(min, max) {
        this.min.copy(min);
        this.max.copy(max);
        return this;
    }
    setFromArray(array) {
        this.makeEmpty();
        for(let i = 0, il = array.length; i < il; i += 3)this.expandByPoint($9014d97cd777be10$var$_vector$a.fromArray(array, i));
        return this;
    }
    setFromBufferAttribute(attribute) {
        this.makeEmpty();
        for(let i = 0, il = attribute.count; i < il; i++)this.expandByPoint($9014d97cd777be10$var$_vector$a.fromBufferAttribute(attribute, i));
        return this;
    }
    setFromPoints(points) {
        this.makeEmpty();
        for(let i = 0, il = points.length; i < il; i++)this.expandByPoint(points[i]);
        return this;
    }
    setFromCenterAndSize(center, size) {
        const halfSize = $9014d97cd777be10$var$_vector$a.copy(size).multiplyScalar(0.5);
        this.min.copy(center).sub(halfSize);
        this.max.copy(center).add(halfSize);
        return this;
    }
    setFromObject(object, precise = false) {
        this.makeEmpty();
        return this.expandByObject(object, precise);
    }
    clone() {
        return new this.constructor().copy(this);
    }
    copy(box) {
        this.min.copy(box.min);
        this.max.copy(box.max);
        return this;
    }
    makeEmpty() {
        this.min.x = this.min.y = this.min.z = Infinity;
        this.max.x = this.max.y = this.max.z = -Infinity;
        return this;
    }
    isEmpty() {
        // this is a more robust check for empty than ( volume <= 0 ) because volume can get positive with two negative axes
        return this.max.x < this.min.x || this.max.y < this.min.y || this.max.z < this.min.z;
    }
    getCenter(target) {
        return this.isEmpty() ? target.set(0, 0, 0) : target.addVectors(this.min, this.max).multiplyScalar(0.5);
    }
    getSize(target) {
        return this.isEmpty() ? target.set(0, 0, 0) : target.subVectors(this.max, this.min);
    }
    expandByPoint(point) {
        this.min.min(point);
        this.max.max(point);
        return this;
    }
    expandByVector(vector) {
        this.min.sub(vector);
        this.max.add(vector);
        return this;
    }
    expandByScalar(scalar) {
        this.min.addScalar(-scalar);
        this.max.addScalar(scalar);
        return this;
    }
    expandByObject(object, precise = false) {
        // Computes the world-axis-aligned bounding box of an object (including its children),
        // accounting for both the object's, and children's, world transforms
        object.updateWorldMatrix(false, false);
        if (object.boundingBox !== undefined) {
            if (object.boundingBox === null) object.computeBoundingBox();
            $9014d97cd777be10$var$_box$3.copy(object.boundingBox);
            $9014d97cd777be10$var$_box$3.applyMatrix4(object.matrixWorld);
            this.union($9014d97cd777be10$var$_box$3);
        } else {
            const geometry = object.geometry;
            if (geometry !== undefined) {
                if (precise && geometry.attributes !== undefined && geometry.attributes.position !== undefined) {
                    const position = geometry.attributes.position;
                    for(let i = 0, l = position.count; i < l; i++){
                        $9014d97cd777be10$var$_vector$a.fromBufferAttribute(position, i).applyMatrix4(object.matrixWorld);
                        this.expandByPoint($9014d97cd777be10$var$_vector$a);
                    }
                } else {
                    if (geometry.boundingBox === null) geometry.computeBoundingBox();
                    $9014d97cd777be10$var$_box$3.copy(geometry.boundingBox);
                    $9014d97cd777be10$var$_box$3.applyMatrix4(object.matrixWorld);
                    this.union($9014d97cd777be10$var$_box$3);
                }
            }
        }
        const children = object.children;
        for(let i = 0, l = children.length; i < l; i++)this.expandByObject(children[i], precise);
        return this;
    }
    containsPoint(point) {
        return point.x < this.min.x || point.x > this.max.x || point.y < this.min.y || point.y > this.max.y || point.z < this.min.z || point.z > this.max.z ? false : true;
    }
    containsBox(box) {
        return this.min.x <= box.min.x && box.max.x <= this.max.x && this.min.y <= box.min.y && box.max.y <= this.max.y && this.min.z <= box.min.z && box.max.z <= this.max.z;
    }
    getParameter(point, target) {
        // This can potentially have a divide by zero if the box
        // has a size dimension of 0.
        return target.set((point.x - this.min.x) / (this.max.x - this.min.x), (point.y - this.min.y) / (this.max.y - this.min.y), (point.z - this.min.z) / (this.max.z - this.min.z));
    }
    intersectsBox(box) {
        // using 6 splitting planes to rule out intersections.
        return box.max.x < this.min.x || box.min.x > this.max.x || box.max.y < this.min.y || box.min.y > this.max.y || box.max.z < this.min.z || box.min.z > this.max.z ? false : true;
    }
    intersectsSphere(sphere) {
        // Find the point on the AABB closest to the sphere center.
        this.clampPoint(sphere.center, $9014d97cd777be10$var$_vector$a);
        // If that point is inside the sphere, the AABB and sphere intersect.
        return $9014d97cd777be10$var$_vector$a.distanceToSquared(sphere.center) <= sphere.radius * sphere.radius;
    }
    intersectsPlane(plane) {
        // We compute the minimum and maximum dot product values. If those values
        // are on the same side (back or front) of the plane, then there is no intersection.
        let min, max;
        if (plane.normal.x > 0) {
            min = plane.normal.x * this.min.x;
            max = plane.normal.x * this.max.x;
        } else {
            min = plane.normal.x * this.max.x;
            max = plane.normal.x * this.min.x;
        }
        if (plane.normal.y > 0) {
            min += plane.normal.y * this.min.y;
            max += plane.normal.y * this.max.y;
        } else {
            min += plane.normal.y * this.max.y;
            max += plane.normal.y * this.min.y;
        }
        if (plane.normal.z > 0) {
            min += plane.normal.z * this.min.z;
            max += plane.normal.z * this.max.z;
        } else {
            min += plane.normal.z * this.max.z;
            max += plane.normal.z * this.min.z;
        }
        return min <= -plane.constant && max >= -plane.constant;
    }
    intersectsTriangle(triangle) {
        if (this.isEmpty()) return false;
        // compute box center and extents
        this.getCenter($9014d97cd777be10$var$_center);
        $9014d97cd777be10$var$_extents.subVectors(this.max, $9014d97cd777be10$var$_center);
        // translate triangle to aabb origin
        $9014d97cd777be10$var$_v0$2.subVectors(triangle.a, $9014d97cd777be10$var$_center);
        $9014d97cd777be10$var$_v1$7.subVectors(triangle.b, $9014d97cd777be10$var$_center);
        $9014d97cd777be10$var$_v2$4.subVectors(triangle.c, $9014d97cd777be10$var$_center);
        // compute edge vectors for triangle
        $9014d97cd777be10$var$_f0.subVectors($9014d97cd777be10$var$_v1$7, $9014d97cd777be10$var$_v0$2);
        $9014d97cd777be10$var$_f1.subVectors($9014d97cd777be10$var$_v2$4, $9014d97cd777be10$var$_v1$7);
        $9014d97cd777be10$var$_f2.subVectors($9014d97cd777be10$var$_v0$2, $9014d97cd777be10$var$_v2$4);
        // test against axes that are given by cross product combinations of the edges of the triangle and the edges of the aabb
        // make an axis testing of each of the 3 sides of the aabb against each of the 3 sides of the triangle = 9 axis of separation
        // axis_ij = u_i x f_j (u0, u1, u2 = face normals of aabb = x,y,z axes vectors since aabb is axis aligned)
        let axes = [
            0,
            -$9014d97cd777be10$var$_f0.z,
            $9014d97cd777be10$var$_f0.y,
            0,
            -$9014d97cd777be10$var$_f1.z,
            $9014d97cd777be10$var$_f1.y,
            0,
            -$9014d97cd777be10$var$_f2.z,
            $9014d97cd777be10$var$_f2.y,
            $9014d97cd777be10$var$_f0.z,
            0,
            -$9014d97cd777be10$var$_f0.x,
            $9014d97cd777be10$var$_f1.z,
            0,
            -$9014d97cd777be10$var$_f1.x,
            $9014d97cd777be10$var$_f2.z,
            0,
            -$9014d97cd777be10$var$_f2.x,
            -$9014d97cd777be10$var$_f0.y,
            $9014d97cd777be10$var$_f0.x,
            0,
            -$9014d97cd777be10$var$_f1.y,
            $9014d97cd777be10$var$_f1.x,
            0,
            -$9014d97cd777be10$var$_f2.y,
            $9014d97cd777be10$var$_f2.x,
            0
        ];
        if (!$9014d97cd777be10$var$satForAxes(axes, $9014d97cd777be10$var$_v0$2, $9014d97cd777be10$var$_v1$7, $9014d97cd777be10$var$_v2$4, $9014d97cd777be10$var$_extents)) return false;
        // test 3 face normals from the aabb
        axes = [
            1,
            0,
            0,
            0,
            1,
            0,
            0,
            0,
            1
        ];
        if (!$9014d97cd777be10$var$satForAxes(axes, $9014d97cd777be10$var$_v0$2, $9014d97cd777be10$var$_v1$7, $9014d97cd777be10$var$_v2$4, $9014d97cd777be10$var$_extents)) return false;
        // finally testing the face normal of the triangle
        // use already existing triangle edge vectors here
        $9014d97cd777be10$var$_triangleNormal.crossVectors($9014d97cd777be10$var$_f0, $9014d97cd777be10$var$_f1);
        axes = [
            $9014d97cd777be10$var$_triangleNormal.x,
            $9014d97cd777be10$var$_triangleNormal.y,
            $9014d97cd777be10$var$_triangleNormal.z
        ];
        return $9014d97cd777be10$var$satForAxes(axes, $9014d97cd777be10$var$_v0$2, $9014d97cd777be10$var$_v1$7, $9014d97cd777be10$var$_v2$4, $9014d97cd777be10$var$_extents);
    }
    clampPoint(point, target) {
        return target.copy(point).clamp(this.min, this.max);
    }
    distanceToPoint(point) {
        return this.clampPoint(point, $9014d97cd777be10$var$_vector$a).distanceTo(point);
    }
    getBoundingSphere(target) {
        if (this.isEmpty()) target.makeEmpty();
        else {
            this.getCenter(target.center);
            target.radius = this.getSize($9014d97cd777be10$var$_vector$a).length() * 0.5;
        }
        return target;
    }
    intersect(box) {
        this.min.max(box.min);
        this.max.min(box.max);
        // ensure that if there is no overlap, the result is fully empty, not slightly empty with non-inf/+inf values that will cause subsequence intersects to erroneously return valid values.
        if (this.isEmpty()) this.makeEmpty();
        return this;
    }
    union(box) {
        this.min.min(box.min);
        this.max.max(box.max);
        return this;
    }
    applyMatrix4(matrix) {
        // transform of empty box is an empty box.
        if (this.isEmpty()) return this;
        // NOTE: I am using a binary pattern to specify all 2^3 combinations below
        $9014d97cd777be10$var$_points[0].set(this.min.x, this.min.y, this.min.z).applyMatrix4(matrix); // 000
        $9014d97cd777be10$var$_points[1].set(this.min.x, this.min.y, this.max.z).applyMatrix4(matrix); // 001
        $9014d97cd777be10$var$_points[2].set(this.min.x, this.max.y, this.min.z).applyMatrix4(matrix); // 010
        $9014d97cd777be10$var$_points[3].set(this.min.x, this.max.y, this.max.z).applyMatrix4(matrix); // 011
        $9014d97cd777be10$var$_points[4].set(this.max.x, this.min.y, this.min.z).applyMatrix4(matrix); // 100
        $9014d97cd777be10$var$_points[5].set(this.max.x, this.min.y, this.max.z).applyMatrix4(matrix); // 101
        $9014d97cd777be10$var$_points[6].set(this.max.x, this.max.y, this.min.z).applyMatrix4(matrix); // 110
        $9014d97cd777be10$var$_points[7].set(this.max.x, this.max.y, this.max.z).applyMatrix4(matrix); // 111
        this.setFromPoints($9014d97cd777be10$var$_points);
        return this;
    }
    translate(offset) {
        this.min.add(offset);
        this.max.add(offset);
        return this;
    }
    equals(box) {
        return box.min.equals(this.min) && box.max.equals(this.max);
    }
    constructor(min = new $9014d97cd777be10$export$64b5c384219d3699(Infinity, Infinity, Infinity), max = new $9014d97cd777be10$export$64b5c384219d3699(-Infinity, -Infinity, -Infinity)){
        this.isBox3 = true;
        this.min = min;
        this.max = max;
    }
}
const $9014d97cd777be10$var$_points = [
    /*@__PURE__*/ new $9014d97cd777be10$export$64b5c384219d3699(),
    /*@__PURE__*/ new $9014d97cd777be10$export$64b5c384219d3699(),
    /*@__PURE__*/ new $9014d97cd777be10$export$64b5c384219d3699(),
    /*@__PURE__*/ new $9014d97cd777be10$export$64b5c384219d3699(),
    /*@__PURE__*/ new $9014d97cd777be10$export$64b5c384219d3699(),
    /*@__PURE__*/ new $9014d97cd777be10$export$64b5c384219d3699(),
    /*@__PURE__*/ new $9014d97cd777be10$export$64b5c384219d3699(),
    /*@__PURE__*/ new $9014d97cd777be10$export$64b5c384219d3699()
];
const $9014d97cd777be10$var$_vector$a = /*@__PURE__*/ new $9014d97cd777be10$export$64b5c384219d3699();
const $9014d97cd777be10$var$_box$3 = /*@__PURE__*/ new $9014d97cd777be10$export$6f7d5a9418ab2aa3();
// triangle centered vertices
const $9014d97cd777be10$var$_v0$2 = /*@__PURE__*/ new $9014d97cd777be10$export$64b5c384219d3699();
const $9014d97cd777be10$var$_v1$7 = /*@__PURE__*/ new $9014d97cd777be10$export$64b5c384219d3699();
const $9014d97cd777be10$var$_v2$4 = /*@__PURE__*/ new $9014d97cd777be10$export$64b5c384219d3699();
// triangle edge vectors
const $9014d97cd777be10$var$_f0 = /*@__PURE__*/ new $9014d97cd777be10$export$64b5c384219d3699();
const $9014d97cd777be10$var$_f1 = /*@__PURE__*/ new $9014d97cd777be10$export$64b5c384219d3699();
const $9014d97cd777be10$var$_f2 = /*@__PURE__*/ new $9014d97cd777be10$export$64b5c384219d3699();
const $9014d97cd777be10$var$_center = /*@__PURE__*/ new $9014d97cd777be10$export$64b5c384219d3699();
const $9014d97cd777be10$var$_extents = /*@__PURE__*/ new $9014d97cd777be10$export$64b5c384219d3699();
const $9014d97cd777be10$var$_triangleNormal = /*@__PURE__*/ new $9014d97cd777be10$export$64b5c384219d3699();
const $9014d97cd777be10$var$_testAxis = /*@__PURE__*/ new $9014d97cd777be10$export$64b5c384219d3699();
function $9014d97cd777be10$var$satForAxes(axes, v0, v1, v2, extents) {
    for(let i = 0, j = axes.length - 3; i <= j; i += 3){
        $9014d97cd777be10$var$_testAxis.fromArray(axes, i);
        // project the aabb onto the separating axis
        const r = extents.x * Math.abs($9014d97cd777be10$var$_testAxis.x) + extents.y * Math.abs($9014d97cd777be10$var$_testAxis.y) + extents.z * Math.abs($9014d97cd777be10$var$_testAxis.z);
        // project all 3 vertices of the triangle onto the separating axis
        const p0 = v0.dot($9014d97cd777be10$var$_testAxis);
        const p1 = v1.dot($9014d97cd777be10$var$_testAxis);
        const p2 = v2.dot($9014d97cd777be10$var$_testAxis);
        // actual test, basically see if either of the most extreme of the triangle points intersects r
        if (Math.max(-Math.max(p0, p1, p2), Math.min(p0, p1, p2)) > r) // points of the projected triangle are outside the projected half-length of the aabb
        // the axis is separating and we can exit
        return false;
    }
    return true;
}
const $9014d97cd777be10$var$_box$2 = /*@__PURE__*/ new $9014d97cd777be10$export$6f7d5a9418ab2aa3();
const $9014d97cd777be10$var$_v1$6 = /*@__PURE__*/ new $9014d97cd777be10$export$64b5c384219d3699();
const $9014d97cd777be10$var$_v2$3 = /*@__PURE__*/ new $9014d97cd777be10$export$64b5c384219d3699();
class $9014d97cd777be10$export$805e8b72413ccaba {
    set(center, radius) {
        this.center.copy(center);
        this.radius = radius;
        return this;
    }
    setFromPoints(points, optionalCenter) {
        const center = this.center;
        if (optionalCenter !== undefined) center.copy(optionalCenter);
        else $9014d97cd777be10$var$_box$2.setFromPoints(points).getCenter(center);
        let maxRadiusSq = 0;
        for(let i = 0, il = points.length; i < il; i++)maxRadiusSq = Math.max(maxRadiusSq, center.distanceToSquared(points[i]));
        this.radius = Math.sqrt(maxRadiusSq);
        return this;
    }
    copy(sphere) {
        this.center.copy(sphere.center);
        this.radius = sphere.radius;
        return this;
    }
    isEmpty() {
        return this.radius < 0;
    }
    makeEmpty() {
        this.center.set(0, 0, 0);
        this.radius = -1;
        return this;
    }
    containsPoint(point) {
        return point.distanceToSquared(this.center) <= this.radius * this.radius;
    }
    distanceToPoint(point) {
        return point.distanceTo(this.center) - this.radius;
    }
    intersectsSphere(sphere) {
        const radiusSum = this.radius + sphere.radius;
        return sphere.center.distanceToSquared(this.center) <= radiusSum * radiusSum;
    }
    intersectsBox(box) {
        return box.intersectsSphere(this);
    }
    intersectsPlane(plane) {
        return Math.abs(plane.distanceToPoint(this.center)) <= this.radius;
    }
    clampPoint(point, target) {
        const deltaLengthSq = this.center.distanceToSquared(point);
        target.copy(point);
        if (deltaLengthSq > this.radius * this.radius) {
            target.sub(this.center).normalize();
            target.multiplyScalar(this.radius).add(this.center);
        }
        return target;
    }
    getBoundingBox(target) {
        if (this.isEmpty()) {
            // Empty sphere produces empty bounding box
            target.makeEmpty();
            return target;
        }
        target.set(this.center, this.center);
        target.expandByScalar(this.radius);
        return target;
    }
    applyMatrix4(matrix) {
        this.center.applyMatrix4(matrix);
        this.radius = this.radius * matrix.getMaxScaleOnAxis();
        return this;
    }
    translate(offset) {
        this.center.add(offset);
        return this;
    }
    expandByPoint(point) {
        if (this.isEmpty()) {
            this.center.copy(point);
            this.radius = 0;
            return this;
        }
        $9014d97cd777be10$var$_v1$6.subVectors(point, this.center);
        const lengthSq = $9014d97cd777be10$var$_v1$6.lengthSq();
        if (lengthSq > this.radius * this.radius) {
            // calculate the minimal sphere
            const length = Math.sqrt(lengthSq);
            const delta = (length - this.radius) * 0.5;
            this.center.addScaledVector($9014d97cd777be10$var$_v1$6, delta / length);
            this.radius += delta;
        }
        return this;
    }
    union(sphere) {
        if (sphere.isEmpty()) return this;
        if (this.isEmpty()) {
            this.copy(sphere);
            return this;
        }
        if (this.center.equals(sphere.center) === true) this.radius = Math.max(this.radius, sphere.radius);
        else {
            $9014d97cd777be10$var$_v2$3.subVectors(sphere.center, this.center).setLength(sphere.radius);
            this.expandByPoint($9014d97cd777be10$var$_v1$6.copy(sphere.center).add($9014d97cd777be10$var$_v2$3));
            this.expandByPoint($9014d97cd777be10$var$_v1$6.copy(sphere.center).sub($9014d97cd777be10$var$_v2$3));
        }
        return this;
    }
    equals(sphere) {
        return sphere.center.equals(this.center) && sphere.radius === this.radius;
    }
    clone() {
        return new this.constructor().copy(this);
    }
    constructor(center = new $9014d97cd777be10$export$64b5c384219d3699(), radius = -1){
        this.center = center;
        this.radius = radius;
    }
}
const $9014d97cd777be10$var$_vector$9 = /*@__PURE__*/ new $9014d97cd777be10$export$64b5c384219d3699();
const $9014d97cd777be10$var$_segCenter = /*@__PURE__*/ new $9014d97cd777be10$export$64b5c384219d3699();
const $9014d97cd777be10$var$_segDir = /*@__PURE__*/ new $9014d97cd777be10$export$64b5c384219d3699();
const $9014d97cd777be10$var$_diff = /*@__PURE__*/ new $9014d97cd777be10$export$64b5c384219d3699();
const $9014d97cd777be10$var$_edge1 = /*@__PURE__*/ new $9014d97cd777be10$export$64b5c384219d3699();
const $9014d97cd777be10$var$_edge2 = /*@__PURE__*/ new $9014d97cd777be10$export$64b5c384219d3699();
const $9014d97cd777be10$var$_normal$1 = /*@__PURE__*/ new $9014d97cd777be10$export$64b5c384219d3699();
class $9014d97cd777be10$export$a186db52eed6d40e {
    set(origin, direction) {
        this.origin.copy(origin);
        this.direction.copy(direction);
        return this;
    }
    copy(ray) {
        this.origin.copy(ray.origin);
        this.direction.copy(ray.direction);
        return this;
    }
    at(t, target) {
        return target.copy(this.origin).addScaledVector(this.direction, t);
    }
    lookAt(v) {
        this.direction.copy(v).sub(this.origin).normalize();
        return this;
    }
    recast(t) {
        this.origin.copy(this.at(t, $9014d97cd777be10$var$_vector$9));
        return this;
    }
    closestPointToPoint(point, target) {
        target.subVectors(point, this.origin);
        const directionDistance = target.dot(this.direction);
        if (directionDistance < 0) return target.copy(this.origin);
        return target.copy(this.origin).addScaledVector(this.direction, directionDistance);
    }
    distanceToPoint(point) {
        return Math.sqrt(this.distanceSqToPoint(point));
    }
    distanceSqToPoint(point) {
        const directionDistance = $9014d97cd777be10$var$_vector$9.subVectors(point, this.origin).dot(this.direction);
        // point behind the ray
        if (directionDistance < 0) return this.origin.distanceToSquared(point);
        $9014d97cd777be10$var$_vector$9.copy(this.origin).addScaledVector(this.direction, directionDistance);
        return $9014d97cd777be10$var$_vector$9.distanceToSquared(point);
    }
    distanceSqToSegment(v0, v1, optionalPointOnRay, optionalPointOnSegment) {
        // from https://github.com/pmjoniak/GeometricTools/blob/master/GTEngine/Include/Mathematics/GteDistRaySegment.h
        // It returns the min distance between the ray and the segment
        // defined by v0 and v1
        // It can also set two optional targets :
        // - The closest point on the ray
        // - The closest point on the segment
        $9014d97cd777be10$var$_segCenter.copy(v0).add(v1).multiplyScalar(0.5);
        $9014d97cd777be10$var$_segDir.copy(v1).sub(v0).normalize();
        $9014d97cd777be10$var$_diff.copy(this.origin).sub($9014d97cd777be10$var$_segCenter);
        const segExtent = v0.distanceTo(v1) * 0.5;
        const a01 = -this.direction.dot($9014d97cd777be10$var$_segDir);
        const b0 = $9014d97cd777be10$var$_diff.dot(this.direction);
        const b1 = -$9014d97cd777be10$var$_diff.dot($9014d97cd777be10$var$_segDir);
        const c = $9014d97cd777be10$var$_diff.lengthSq();
        const det = Math.abs(1 - a01 * a01);
        let s0, s1, sqrDist, extDet;
        if (det > 0) {
            // The ray and segment are not parallel.
            s0 = a01 * b1 - b0;
            s1 = a01 * b0 - b1;
            extDet = segExtent * det;
            if (s0 >= 0) {
                if (s1 >= -extDet) {
                    if (s1 <= extDet) {
                        // region 0
                        // Minimum at interior points of ray and segment.
                        const invDet = 1 / det;
                        s0 *= invDet;
                        s1 *= invDet;
                        sqrDist = s0 * (s0 + a01 * s1 + 2 * b0) + s1 * (a01 * s0 + s1 + 2 * b1) + c;
                    } else {
                        // region 1
                        s1 = segExtent;
                        s0 = Math.max(0, -(a01 * s1 + b0));
                        sqrDist = -s0 * s0 + s1 * (s1 + 2 * b1) + c;
                    }
                } else {
                    // region 5
                    s1 = -segExtent;
                    s0 = Math.max(0, -(a01 * s1 + b0));
                    sqrDist = -s0 * s0 + s1 * (s1 + 2 * b1) + c;
                }
            } else {
                if (s1 <= -extDet) {
                    // region 4
                    s0 = Math.max(0, -(-a01 * segExtent + b0));
                    s1 = s0 > 0 ? -segExtent : Math.min(Math.max(-segExtent, -b1), segExtent);
                    sqrDist = -s0 * s0 + s1 * (s1 + 2 * b1) + c;
                } else if (s1 <= extDet) {
                    // region 3
                    s0 = 0;
                    s1 = Math.min(Math.max(-segExtent, -b1), segExtent);
                    sqrDist = s1 * (s1 + 2 * b1) + c;
                } else {
                    // region 2
                    s0 = Math.max(0, -(a01 * segExtent + b0));
                    s1 = s0 > 0 ? segExtent : Math.min(Math.max(-segExtent, -b1), segExtent);
                    sqrDist = -s0 * s0 + s1 * (s1 + 2 * b1) + c;
                }
            }
        } else {
            // Ray and segment are parallel.
            s1 = a01 > 0 ? -segExtent : segExtent;
            s0 = Math.max(0, -(a01 * s1 + b0));
            sqrDist = -s0 * s0 + s1 * (s1 + 2 * b1) + c;
        }
        if (optionalPointOnRay) optionalPointOnRay.copy(this.origin).addScaledVector(this.direction, s0);
        if (optionalPointOnSegment) optionalPointOnSegment.copy($9014d97cd777be10$var$_segCenter).addScaledVector($9014d97cd777be10$var$_segDir, s1);
        return sqrDist;
    }
    intersectSphere(sphere, target) {
        $9014d97cd777be10$var$_vector$9.subVectors(sphere.center, this.origin);
        const tca = $9014d97cd777be10$var$_vector$9.dot(this.direction);
        const d2 = $9014d97cd777be10$var$_vector$9.dot($9014d97cd777be10$var$_vector$9) - tca * tca;
        const radius2 = sphere.radius * sphere.radius;
        if (d2 > radius2) return null;
        const thc = Math.sqrt(radius2 - d2);
        // t0 = first intersect point - entrance on front of sphere
        const t0 = tca - thc;
        // t1 = second intersect point - exit point on back of sphere
        const t1 = tca + thc;
        // test to see if t1 is behind the ray - if so, return null
        if (t1 < 0) return null;
        // test to see if t0 is behind the ray:
        // if it is, the ray is inside the sphere, so return the second exit point scaled by t1,
        // in order to always return an intersect point that is in front of the ray.
        if (t0 < 0) return this.at(t1, target);
        // else t0 is in front of the ray, so return the first collision point scaled by t0
        return this.at(t0, target);
    }
    intersectsSphere(sphere) {
        return this.distanceSqToPoint(sphere.center) <= sphere.radius * sphere.radius;
    }
    distanceToPlane(plane) {
        const denominator = plane.normal.dot(this.direction);
        if (denominator === 0) {
            // line is coplanar, return origin
            if (plane.distanceToPoint(this.origin) === 0) return 0;
            // Null is preferable to undefined since undefined means.... it is undefined
            return null;
        }
        const t = -(this.origin.dot(plane.normal) + plane.constant) / denominator;
        // Return if the ray never intersects the plane
        return t >= 0 ? t : null;
    }
    intersectPlane(plane, target) {
        const t = this.distanceToPlane(plane);
        if (t === null) return null;
        return this.at(t, target);
    }
    intersectsPlane(plane) {
        // check if the ray lies on the plane first
        const distToPoint = plane.distanceToPoint(this.origin);
        if (distToPoint === 0) return true;
        const denominator = plane.normal.dot(this.direction);
        if (denominator * distToPoint < 0) return true;
        // ray origin is behind the plane (and is pointing behind it)
        return false;
    }
    intersectBox(box, target) {
        let tmin, tmax, tymin, tymax, tzmin, tzmax;
        const invdirx = 1 / this.direction.x, invdiry = 1 / this.direction.y, invdirz = 1 / this.direction.z;
        const origin = this.origin;
        if (invdirx >= 0) {
            tmin = (box.min.x - origin.x) * invdirx;
            tmax = (box.max.x - origin.x) * invdirx;
        } else {
            tmin = (box.max.x - origin.x) * invdirx;
            tmax = (box.min.x - origin.x) * invdirx;
        }
        if (invdiry >= 0) {
            tymin = (box.min.y - origin.y) * invdiry;
            tymax = (box.max.y - origin.y) * invdiry;
        } else {
            tymin = (box.max.y - origin.y) * invdiry;
            tymax = (box.min.y - origin.y) * invdiry;
        }
        if (tmin > tymax || tymin > tmax) return null;
        if (tymin > tmin || isNaN(tmin)) tmin = tymin;
        if (tymax < tmax || isNaN(tmax)) tmax = tymax;
        if (invdirz >= 0) {
            tzmin = (box.min.z - origin.z) * invdirz;
            tzmax = (box.max.z - origin.z) * invdirz;
        } else {
            tzmin = (box.max.z - origin.z) * invdirz;
            tzmax = (box.min.z - origin.z) * invdirz;
        }
        if (tmin > tzmax || tzmin > tmax) return null;
        if (tzmin > tmin || tmin !== tmin) tmin = tzmin;
        if (tzmax < tmax || tmax !== tmax) tmax = tzmax;
        //return point closest to the ray (positive side)
        if (tmax < 0) return null;
        return this.at(tmin >= 0 ? tmin : tmax, target);
    }
    intersectsBox(box) {
        return this.intersectBox(box, $9014d97cd777be10$var$_vector$9) !== null;
    }
    intersectTriangle(a, b, c, backfaceCulling, target) {
        // Compute the offset origin, edges, and normal.
        // from https://github.com/pmjoniak/GeometricTools/blob/master/GTEngine/Include/Mathematics/GteIntrRay3Triangle3.h
        $9014d97cd777be10$var$_edge1.subVectors(b, a);
        $9014d97cd777be10$var$_edge2.subVectors(c, a);
        $9014d97cd777be10$var$_normal$1.crossVectors($9014d97cd777be10$var$_edge1, $9014d97cd777be10$var$_edge2);
        // Solve Q + t*D = b1*E1 + b2*E2 (Q = kDiff, D = ray direction,
        // E1 = kEdge1, E2 = kEdge2, N = Cross(E1,E2)) by
        //   |Dot(D,N)|*b1 = sign(Dot(D,N))*Dot(D,Cross(Q,E2))
        //   |Dot(D,N)|*b2 = sign(Dot(D,N))*Dot(D,Cross(E1,Q))
        //   |Dot(D,N)|*t = -sign(Dot(D,N))*Dot(Q,N)
        let DdN = this.direction.dot($9014d97cd777be10$var$_normal$1);
        let sign;
        if (DdN > 0) {
            if (backfaceCulling) return null;
            sign = 1;
        } else if (DdN < 0) {
            sign = -1;
            DdN = -DdN;
        } else return null;
        $9014d97cd777be10$var$_diff.subVectors(this.origin, a);
        const DdQxE2 = sign * this.direction.dot($9014d97cd777be10$var$_edge2.crossVectors($9014d97cd777be10$var$_diff, $9014d97cd777be10$var$_edge2));
        // b1 < 0, no intersection
        if (DdQxE2 < 0) return null;
        const DdE1xQ = sign * this.direction.dot($9014d97cd777be10$var$_edge1.cross($9014d97cd777be10$var$_diff));
        // b2 < 0, no intersection
        if (DdE1xQ < 0) return null;
        // b1+b2 > 1, no intersection
        if (DdQxE2 + DdE1xQ > DdN) return null;
        // Line intersects triangle, check if ray does.
        const QdN = -sign * $9014d97cd777be10$var$_diff.dot($9014d97cd777be10$var$_normal$1);
        // t < 0, no intersection
        if (QdN < 0) return null;
        // Ray intersects triangle.
        return this.at(QdN / DdN, target);
    }
    applyMatrix4(matrix4) {
        this.origin.applyMatrix4(matrix4);
        this.direction.transformDirection(matrix4);
        return this;
    }
    equals(ray) {
        return ray.origin.equals(this.origin) && ray.direction.equals(this.direction);
    }
    clone() {
        return new this.constructor().copy(this);
    }
    constructor(origin = new $9014d97cd777be10$export$64b5c384219d3699(), direction = new $9014d97cd777be10$export$64b5c384219d3699(0, 0, -1)){
        this.origin = origin;
        this.direction = direction;
    }
}
class $9014d97cd777be10$export$2ae72fc923e5eb5 {
    set(n11, n12, n13, n14, n21, n22, n23, n24, n31, n32, n33, n34, n41, n42, n43, n44) {
        const te = this.elements;
        te[0] = n11;
        te[4] = n12;
        te[8] = n13;
        te[12] = n14;
        te[1] = n21;
        te[5] = n22;
        te[9] = n23;
        te[13] = n24;
        te[2] = n31;
        te[6] = n32;
        te[10] = n33;
        te[14] = n34;
        te[3] = n41;
        te[7] = n42;
        te[11] = n43;
        te[15] = n44;
        return this;
    }
    identity() {
        this.set(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
        return this;
    }
    clone() {
        return new $9014d97cd777be10$export$2ae72fc923e5eb5().fromArray(this.elements);
    }
    copy(m) {
        const te = this.elements;
        const me = m.elements;
        te[0] = me[0];
        te[1] = me[1];
        te[2] = me[2];
        te[3] = me[3];
        te[4] = me[4];
        te[5] = me[5];
        te[6] = me[6];
        te[7] = me[7];
        te[8] = me[8];
        te[9] = me[9];
        te[10] = me[10];
        te[11] = me[11];
        te[12] = me[12];
        te[13] = me[13];
        te[14] = me[14];
        te[15] = me[15];
        return this;
    }
    copyPosition(m) {
        const te = this.elements, me = m.elements;
        te[12] = me[12];
        te[13] = me[13];
        te[14] = me[14];
        return this;
    }
    setFromMatrix3(m) {
        const me = m.elements;
        this.set(me[0], me[3], me[6], 0, me[1], me[4], me[7], 0, me[2], me[5], me[8], 0, 0, 0, 0, 1);
        return this;
    }
    extractBasis(xAxis, yAxis, zAxis) {
        xAxis.setFromMatrixColumn(this, 0);
        yAxis.setFromMatrixColumn(this, 1);
        zAxis.setFromMatrixColumn(this, 2);
        return this;
    }
    makeBasis(xAxis, yAxis, zAxis) {
        this.set(xAxis.x, yAxis.x, zAxis.x, 0, xAxis.y, yAxis.y, zAxis.y, 0, xAxis.z, yAxis.z, zAxis.z, 0, 0, 0, 0, 1);
        return this;
    }
    extractRotation(m) {
        // this method does not support reflection matrices
        const te = this.elements;
        const me = m.elements;
        const scaleX = 1 / $9014d97cd777be10$var$_v1$5.setFromMatrixColumn(m, 0).length();
        const scaleY = 1 / $9014d97cd777be10$var$_v1$5.setFromMatrixColumn(m, 1).length();
        const scaleZ = 1 / $9014d97cd777be10$var$_v1$5.setFromMatrixColumn(m, 2).length();
        te[0] = me[0] * scaleX;
        te[1] = me[1] * scaleX;
        te[2] = me[2] * scaleX;
        te[3] = 0;
        te[4] = me[4] * scaleY;
        te[5] = me[5] * scaleY;
        te[6] = me[6] * scaleY;
        te[7] = 0;
        te[8] = me[8] * scaleZ;
        te[9] = me[9] * scaleZ;
        te[10] = me[10] * scaleZ;
        te[11] = 0;
        te[12] = 0;
        te[13] = 0;
        te[14] = 0;
        te[15] = 1;
        return this;
    }
    makeRotationFromEuler(euler) {
        const te = this.elements;
        const x = euler.x, y = euler.y, z = euler.z;
        const a = Math.cos(x), b = Math.sin(x);
        const c = Math.cos(y), d = Math.sin(y);
        const e = Math.cos(z), f = Math.sin(z);
        if (euler.order === "XYZ") {
            const ae = a * e, af = a * f, be = b * e, bf = b * f;
            te[0] = c * e;
            te[4] = -c * f;
            te[8] = d;
            te[1] = af + be * d;
            te[5] = ae - bf * d;
            te[9] = -b * c;
            te[2] = bf - ae * d;
            te[6] = be + af * d;
            te[10] = a * c;
        } else if (euler.order === "YXZ") {
            const ce = c * e, cf = c * f, de = d * e, df = d * f;
            te[0] = ce + df * b;
            te[4] = de * b - cf;
            te[8] = a * d;
            te[1] = a * f;
            te[5] = a * e;
            te[9] = -b;
            te[2] = cf * b - de;
            te[6] = df + ce * b;
            te[10] = a * c;
        } else if (euler.order === "ZXY") {
            const ce = c * e, cf = c * f, de = d * e, df = d * f;
            te[0] = ce - df * b;
            te[4] = -a * f;
            te[8] = de + cf * b;
            te[1] = cf + de * b;
            te[5] = a * e;
            te[9] = df - ce * b;
            te[2] = -a * d;
            te[6] = b;
            te[10] = a * c;
        } else if (euler.order === "ZYX") {
            const ae = a * e, af = a * f, be = b * e, bf = b * f;
            te[0] = c * e;
            te[4] = be * d - af;
            te[8] = ae * d + bf;
            te[1] = c * f;
            te[5] = bf * d + ae;
            te[9] = af * d - be;
            te[2] = -d;
            te[6] = b * c;
            te[10] = a * c;
        } else if (euler.order === "YZX") {
            const ac = a * c, ad = a * d, bc = b * c, bd = b * d;
            te[0] = c * e;
            te[4] = bd - ac * f;
            te[8] = bc * f + ad;
            te[1] = f;
            te[5] = a * e;
            te[9] = -b * e;
            te[2] = -d * e;
            te[6] = ad * f + bc;
            te[10] = ac - bd * f;
        } else if (euler.order === "XZY") {
            const ac = a * c, ad = a * d, bc = b * c, bd = b * d;
            te[0] = c * e;
            te[4] = -f;
            te[8] = d * e;
            te[1] = ac * f + bd;
            te[5] = a * e;
            te[9] = ad * f - bc;
            te[2] = bc * f - ad;
            te[6] = b * e;
            te[10] = bd * f + ac;
        }
        // bottom row
        te[3] = 0;
        te[7] = 0;
        te[11] = 0;
        // last column
        te[12] = 0;
        te[13] = 0;
        te[14] = 0;
        te[15] = 1;
        return this;
    }
    makeRotationFromQuaternion(q) {
        return this.compose($9014d97cd777be10$var$_zero, q, $9014d97cd777be10$var$_one);
    }
    lookAt(eye, target, up) {
        const te = this.elements;
        $9014d97cd777be10$var$_z.subVectors(eye, target);
        if ($9014d97cd777be10$var$_z.lengthSq() === 0) // eye and target are in the same position
        $9014d97cd777be10$var$_z.z = 1;
        $9014d97cd777be10$var$_z.normalize();
        $9014d97cd777be10$var$_x.crossVectors(up, $9014d97cd777be10$var$_z);
        if ($9014d97cd777be10$var$_x.lengthSq() === 0) {
            // up and z are parallel
            if (Math.abs(up.z) === 1) $9014d97cd777be10$var$_z.x += 0.0001;
            else $9014d97cd777be10$var$_z.z += 0.0001;
            $9014d97cd777be10$var$_z.normalize();
            $9014d97cd777be10$var$_x.crossVectors(up, $9014d97cd777be10$var$_z);
        }
        $9014d97cd777be10$var$_x.normalize();
        $9014d97cd777be10$var$_y.crossVectors($9014d97cd777be10$var$_z, $9014d97cd777be10$var$_x);
        te[0] = $9014d97cd777be10$var$_x.x;
        te[4] = $9014d97cd777be10$var$_y.x;
        te[8] = $9014d97cd777be10$var$_z.x;
        te[1] = $9014d97cd777be10$var$_x.y;
        te[5] = $9014d97cd777be10$var$_y.y;
        te[9] = $9014d97cd777be10$var$_z.y;
        te[2] = $9014d97cd777be10$var$_x.z;
        te[6] = $9014d97cd777be10$var$_y.z;
        te[10] = $9014d97cd777be10$var$_z.z;
        return this;
    }
    multiply(m) {
        return this.multiplyMatrices(this, m);
    }
    premultiply(m) {
        return this.multiplyMatrices(m, this);
    }
    multiplyMatrices(a, b) {
        const ae = a.elements;
        const be = b.elements;
        const te = this.elements;
        const a11 = ae[0], a12 = ae[4], a13 = ae[8], a14 = ae[12];
        const a21 = ae[1], a22 = ae[5], a23 = ae[9], a24 = ae[13];
        const a31 = ae[2], a32 = ae[6], a33 = ae[10], a34 = ae[14];
        const a41 = ae[3], a42 = ae[7], a43 = ae[11], a44 = ae[15];
        const b11 = be[0], b12 = be[4], b13 = be[8], b14 = be[12];
        const b21 = be[1], b22 = be[5], b23 = be[9], b24 = be[13];
        const b31 = be[2], b32 = be[6], b33 = be[10], b34 = be[14];
        const b41 = be[3], b42 = be[7], b43 = be[11], b44 = be[15];
        te[0] = a11 * b11 + a12 * b21 + a13 * b31 + a14 * b41;
        te[4] = a11 * b12 + a12 * b22 + a13 * b32 + a14 * b42;
        te[8] = a11 * b13 + a12 * b23 + a13 * b33 + a14 * b43;
        te[12] = a11 * b14 + a12 * b24 + a13 * b34 + a14 * b44;
        te[1] = a21 * b11 + a22 * b21 + a23 * b31 + a24 * b41;
        te[5] = a21 * b12 + a22 * b22 + a23 * b32 + a24 * b42;
        te[9] = a21 * b13 + a22 * b23 + a23 * b33 + a24 * b43;
        te[13] = a21 * b14 + a22 * b24 + a23 * b34 + a24 * b44;
        te[2] = a31 * b11 + a32 * b21 + a33 * b31 + a34 * b41;
        te[6] = a31 * b12 + a32 * b22 + a33 * b32 + a34 * b42;
        te[10] = a31 * b13 + a32 * b23 + a33 * b33 + a34 * b43;
        te[14] = a31 * b14 + a32 * b24 + a33 * b34 + a34 * b44;
        te[3] = a41 * b11 + a42 * b21 + a43 * b31 + a44 * b41;
        te[7] = a41 * b12 + a42 * b22 + a43 * b32 + a44 * b42;
        te[11] = a41 * b13 + a42 * b23 + a43 * b33 + a44 * b43;
        te[15] = a41 * b14 + a42 * b24 + a43 * b34 + a44 * b44;
        return this;
    }
    multiplyScalar(s) {
        const te = this.elements;
        te[0] *= s;
        te[4] *= s;
        te[8] *= s;
        te[12] *= s;
        te[1] *= s;
        te[5] *= s;
        te[9] *= s;
        te[13] *= s;
        te[2] *= s;
        te[6] *= s;
        te[10] *= s;
        te[14] *= s;
        te[3] *= s;
        te[7] *= s;
        te[11] *= s;
        te[15] *= s;
        return this;
    }
    determinant() {
        const te = this.elements;
        const n11 = te[0], n12 = te[4], n13 = te[8], n14 = te[12];
        const n21 = te[1], n22 = te[5], n23 = te[9], n24 = te[13];
        const n31 = te[2], n32 = te[6], n33 = te[10], n34 = te[14];
        const n41 = te[3], n42 = te[7], n43 = te[11], n44 = te[15];
        //TODO: make this more efficient
        //( based on http://www.euclideanspace.com/maths/algebra/matrix/functions/inverse/fourD/index.htm )
        return n41 * (+n14 * n23 * n32 - n13 * n24 * n32 - n14 * n22 * n33 + n12 * n24 * n33 + n13 * n22 * n34 - n12 * n23 * n34) + n42 * (+n11 * n23 * n34 - n11 * n24 * n33 + n14 * n21 * n33 - n13 * n21 * n34 + n13 * n24 * n31 - n14 * n23 * n31) + n43 * (+n11 * n24 * n32 - n11 * n22 * n34 - n14 * n21 * n32 + n12 * n21 * n34 + n14 * n22 * n31 - n12 * n24 * n31) + n44 * (-n13 * n22 * n31 - n11 * n23 * n32 + n11 * n22 * n33 + n13 * n21 * n32 - n12 * n21 * n33 + n12 * n23 * n31);
    }
    transpose() {
        const te = this.elements;
        let tmp;
        tmp = te[1];
        te[1] = te[4];
        te[4] = tmp;
        tmp = te[2];
        te[2] = te[8];
        te[8] = tmp;
        tmp = te[6];
        te[6] = te[9];
        te[9] = tmp;
        tmp = te[3];
        te[3] = te[12];
        te[12] = tmp;
        tmp = te[7];
        te[7] = te[13];
        te[13] = tmp;
        tmp = te[11];
        te[11] = te[14];
        te[14] = tmp;
        return this;
    }
    setPosition(x, y, z) {
        const te = this.elements;
        if (x.isVector3) {
            te[12] = x.x;
            te[13] = x.y;
            te[14] = x.z;
        } else {
            te[12] = x;
            te[13] = y;
            te[14] = z;
        }
        return this;
    }
    invert() {
        // based on http://www.euclideanspace.com/maths/algebra/matrix/functions/inverse/fourD/index.htm
        const te = this.elements, n11 = te[0], n21 = te[1], n31 = te[2], n41 = te[3], n12 = te[4], n22 = te[5], n32 = te[6], n42 = te[7], n13 = te[8], n23 = te[9], n33 = te[10], n43 = te[11], n14 = te[12], n24 = te[13], n34 = te[14], n44 = te[15], t11 = n23 * n34 * n42 - n24 * n33 * n42 + n24 * n32 * n43 - n22 * n34 * n43 - n23 * n32 * n44 + n22 * n33 * n44, t12 = n14 * n33 * n42 - n13 * n34 * n42 - n14 * n32 * n43 + n12 * n34 * n43 + n13 * n32 * n44 - n12 * n33 * n44, t13 = n13 * n24 * n42 - n14 * n23 * n42 + n14 * n22 * n43 - n12 * n24 * n43 - n13 * n22 * n44 + n12 * n23 * n44, t14 = n14 * n23 * n32 - n13 * n24 * n32 - n14 * n22 * n33 + n12 * n24 * n33 + n13 * n22 * n34 - n12 * n23 * n34;
        const det = n11 * t11 + n21 * t12 + n31 * t13 + n41 * t14;
        if (det === 0) return this.set(0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0);
        const detInv = 1 / det;
        te[0] = t11 * detInv;
        te[1] = (n24 * n33 * n41 - n23 * n34 * n41 - n24 * n31 * n43 + n21 * n34 * n43 + n23 * n31 * n44 - n21 * n33 * n44) * detInv;
        te[2] = (n22 * n34 * n41 - n24 * n32 * n41 + n24 * n31 * n42 - n21 * n34 * n42 - n22 * n31 * n44 + n21 * n32 * n44) * detInv;
        te[3] = (n23 * n32 * n41 - n22 * n33 * n41 - n23 * n31 * n42 + n21 * n33 * n42 + n22 * n31 * n43 - n21 * n32 * n43) * detInv;
        te[4] = t12 * detInv;
        te[5] = (n13 * n34 * n41 - n14 * n33 * n41 + n14 * n31 * n43 - n11 * n34 * n43 - n13 * n31 * n44 + n11 * n33 * n44) * detInv;
        te[6] = (n14 * n32 * n41 - n12 * n34 * n41 - n14 * n31 * n42 + n11 * n34 * n42 + n12 * n31 * n44 - n11 * n32 * n44) * detInv;
        te[7] = (n12 * n33 * n41 - n13 * n32 * n41 + n13 * n31 * n42 - n11 * n33 * n42 - n12 * n31 * n43 + n11 * n32 * n43) * detInv;
        te[8] = t13 * detInv;
        te[9] = (n14 * n23 * n41 - n13 * n24 * n41 - n14 * n21 * n43 + n11 * n24 * n43 + n13 * n21 * n44 - n11 * n23 * n44) * detInv;
        te[10] = (n12 * n24 * n41 - n14 * n22 * n41 + n14 * n21 * n42 - n11 * n24 * n42 - n12 * n21 * n44 + n11 * n22 * n44) * detInv;
        te[11] = (n13 * n22 * n41 - n12 * n23 * n41 - n13 * n21 * n42 + n11 * n23 * n42 + n12 * n21 * n43 - n11 * n22 * n43) * detInv;
        te[12] = t14 * detInv;
        te[13] = (n13 * n24 * n31 - n14 * n23 * n31 + n14 * n21 * n33 - n11 * n24 * n33 - n13 * n21 * n34 + n11 * n23 * n34) * detInv;
        te[14] = (n14 * n22 * n31 - n12 * n24 * n31 - n14 * n21 * n32 + n11 * n24 * n32 + n12 * n21 * n34 - n11 * n22 * n34) * detInv;
        te[15] = (n12 * n23 * n31 - n13 * n22 * n31 + n13 * n21 * n32 - n11 * n23 * n32 - n12 * n21 * n33 + n11 * n22 * n33) * detInv;
        return this;
    }
    scale(v) {
        const te = this.elements;
        const x = v.x, y = v.y, z = v.z;
        te[0] *= x;
        te[4] *= y;
        te[8] *= z;
        te[1] *= x;
        te[5] *= y;
        te[9] *= z;
        te[2] *= x;
        te[6] *= y;
        te[10] *= z;
        te[3] *= x;
        te[7] *= y;
        te[11] *= z;
        return this;
    }
    getMaxScaleOnAxis() {
        const te = this.elements;
        const scaleXSq = te[0] * te[0] + te[1] * te[1] + te[2] * te[2];
        const scaleYSq = te[4] * te[4] + te[5] * te[5] + te[6] * te[6];
        const scaleZSq = te[8] * te[8] + te[9] * te[9] + te[10] * te[10];
        return Math.sqrt(Math.max(scaleXSq, scaleYSq, scaleZSq));
    }
    makeTranslation(x, y, z) {
        if (x.isVector3) this.set(1, 0, 0, x.x, 0, 1, 0, x.y, 0, 0, 1, x.z, 0, 0, 0, 1);
        else this.set(1, 0, 0, x, 0, 1, 0, y, 0, 0, 1, z, 0, 0, 0, 1);
        return this;
    }
    makeRotationX(theta) {
        const c = Math.cos(theta), s = Math.sin(theta);
        this.set(1, 0, 0, 0, 0, c, -s, 0, 0, s, c, 0, 0, 0, 0, 1);
        return this;
    }
    makeRotationY(theta) {
        const c = Math.cos(theta), s = Math.sin(theta);
        this.set(c, 0, s, 0, 0, 1, 0, 0, -s, 0, c, 0, 0, 0, 0, 1);
        return this;
    }
    makeRotationZ(theta) {
        const c = Math.cos(theta), s = Math.sin(theta);
        this.set(c, -s, 0, 0, s, c, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
        return this;
    }
    makeRotationAxis(axis, angle) {
        // Based on http://www.gamedev.net/reference/articles/article1199.asp
        const c = Math.cos(angle);
        const s = Math.sin(angle);
        const t = 1 - c;
        const x = axis.x, y = axis.y, z = axis.z;
        const tx = t * x, ty = t * y;
        this.set(tx * x + c, tx * y - s * z, tx * z + s * y, 0, tx * y + s * z, ty * y + c, ty * z - s * x, 0, tx * z - s * y, ty * z + s * x, t * z * z + c, 0, 0, 0, 0, 1);
        return this;
    }
    makeScale(x, y, z) {
        this.set(x, 0, 0, 0, 0, y, 0, 0, 0, 0, z, 0, 0, 0, 0, 1);
        return this;
    }
    makeShear(xy, xz, yx, yz, zx, zy) {
        this.set(1, yx, zx, 0, xy, 1, zy, 0, xz, yz, 1, 0, 0, 0, 0, 1);
        return this;
    }
    compose(position, quaternion, scale) {
        const te = this.elements;
        const x = quaternion._x, y = quaternion._y, z = quaternion._z, w = quaternion._w;
        const x2 = x + x, y2 = y + y, z2 = z + z;
        const xx = x * x2, xy = x * y2, xz = x * z2;
        const yy = y * y2, yz = y * z2, zz = z * z2;
        const wx = w * x2, wy = w * y2, wz = w * z2;
        const sx = scale.x, sy = scale.y, sz = scale.z;
        te[0] = (1 - (yy + zz)) * sx;
        te[1] = (xy + wz) * sx;
        te[2] = (xz - wy) * sx;
        te[3] = 0;
        te[4] = (xy - wz) * sy;
        te[5] = (1 - (xx + zz)) * sy;
        te[6] = (yz + wx) * sy;
        te[7] = 0;
        te[8] = (xz + wy) * sz;
        te[9] = (yz - wx) * sz;
        te[10] = (1 - (xx + yy)) * sz;
        te[11] = 0;
        te[12] = position.x;
        te[13] = position.y;
        te[14] = position.z;
        te[15] = 1;
        return this;
    }
    decompose(position, quaternion, scale) {
        const te = this.elements;
        let sx = $9014d97cd777be10$var$_v1$5.set(te[0], te[1], te[2]).length();
        const sy = $9014d97cd777be10$var$_v1$5.set(te[4], te[5], te[6]).length();
        const sz = $9014d97cd777be10$var$_v1$5.set(te[8], te[9], te[10]).length();
        // if determine is negative, we need to invert one scale
        const det = this.determinant();
        if (det < 0) sx = -sx;
        position.x = te[12];
        position.y = te[13];
        position.z = te[14];
        // scale the rotation part
        $9014d97cd777be10$var$_m1$2.copy(this);
        const invSX = 1 / sx;
        const invSY = 1 / sy;
        const invSZ = 1 / sz;
        $9014d97cd777be10$var$_m1$2.elements[0] *= invSX;
        $9014d97cd777be10$var$_m1$2.elements[1] *= invSX;
        $9014d97cd777be10$var$_m1$2.elements[2] *= invSX;
        $9014d97cd777be10$var$_m1$2.elements[4] *= invSY;
        $9014d97cd777be10$var$_m1$2.elements[5] *= invSY;
        $9014d97cd777be10$var$_m1$2.elements[6] *= invSY;
        $9014d97cd777be10$var$_m1$2.elements[8] *= invSZ;
        $9014d97cd777be10$var$_m1$2.elements[9] *= invSZ;
        $9014d97cd777be10$var$_m1$2.elements[10] *= invSZ;
        quaternion.setFromRotationMatrix($9014d97cd777be10$var$_m1$2);
        scale.x = sx;
        scale.y = sy;
        scale.z = sz;
        return this;
    }
    makePerspective(left, right, top, bottom, near, far, coordinateSystem = $9014d97cd777be10$export$5a0e9190d10875d3) {
        const te = this.elements;
        const x = 2 * near / (right - left);
        const y = 2 * near / (top - bottom);
        const a = (right + left) / (right - left);
        const b = (top + bottom) / (top - bottom);
        let c, d;
        if (coordinateSystem === $9014d97cd777be10$export$5a0e9190d10875d3) {
            c = -(far + near) / (far - near);
            d = -2 * far * near / (far - near);
        } else if (coordinateSystem === $9014d97cd777be10$export$cc83beedcb9be9ac) {
            c = -far / (far - near);
            d = -far * near / (far - near);
        } else throw new Error("THREE.Matrix4.makePerspective(): Invalid coordinate system: " + coordinateSystem);
        te[0] = x;
        te[4] = 0;
        te[8] = a;
        te[12] = 0;
        te[1] = 0;
        te[5] = y;
        te[9] = b;
        te[13] = 0;
        te[2] = 0;
        te[6] = 0;
        te[10] = c;
        te[14] = d;
        te[3] = 0;
        te[7] = 0;
        te[11] = -1;
        te[15] = 0;
        return this;
    }
    makeOrthographic(left, right, top, bottom, near, far, coordinateSystem = $9014d97cd777be10$export$5a0e9190d10875d3) {
        const te = this.elements;
        const w = 1.0 / (right - left);
        const h = 1.0 / (top - bottom);
        const p = 1.0 / (far - near);
        const x = (right + left) * w;
        const y = (top + bottom) * h;
        let z, zInv;
        if (coordinateSystem === $9014d97cd777be10$export$5a0e9190d10875d3) {
            z = (far + near) * p;
            zInv = -2 * p;
        } else if (coordinateSystem === $9014d97cd777be10$export$cc83beedcb9be9ac) {
            z = near * p;
            zInv = -1 * p;
        } else throw new Error("THREE.Matrix4.makeOrthographic(): Invalid coordinate system: " + coordinateSystem);
        te[0] = 2 * w;
        te[4] = 0;
        te[8] = 0;
        te[12] = -x;
        te[1] = 0;
        te[5] = 2 * h;
        te[9] = 0;
        te[13] = -y;
        te[2] = 0;
        te[6] = 0;
        te[10] = zInv;
        te[14] = -z;
        te[3] = 0;
        te[7] = 0;
        te[11] = 0;
        te[15] = 1;
        return this;
    }
    equals(matrix) {
        const te = this.elements;
        const me = matrix.elements;
        for(let i = 0; i < 16; i++){
            if (te[i] !== me[i]) return false;
        }
        return true;
    }
    fromArray(array, offset = 0) {
        for(let i = 0; i < 16; i++)this.elements[i] = array[i + offset];
        return this;
    }
    toArray(array = [], offset = 0) {
        const te = this.elements;
        array[offset] = te[0];
        array[offset + 1] = te[1];
        array[offset + 2] = te[2];
        array[offset + 3] = te[3];
        array[offset + 4] = te[4];
        array[offset + 5] = te[5];
        array[offset + 6] = te[6];
        array[offset + 7] = te[7];
        array[offset + 8] = te[8];
        array[offset + 9] = te[9];
        array[offset + 10] = te[10];
        array[offset + 11] = te[11];
        array[offset + 12] = te[12];
        array[offset + 13] = te[13];
        array[offset + 14] = te[14];
        array[offset + 15] = te[15];
        return array;
    }
    constructor(n11, n12, n13, n14, n21, n22, n23, n24, n31, n32, n33, n34, n41, n42, n43, n44){
        $9014d97cd777be10$export$2ae72fc923e5eb5.prototype.isMatrix4 = true;
        this.elements = [
            1,
            0,
            0,
            0,
            0,
            1,
            0,
            0,
            0,
            0,
            1,
            0,
            0,
            0,
            0,
            1
        ];
        if (n11 !== undefined) this.set(n11, n12, n13, n14, n21, n22, n23, n24, n31, n32, n33, n34, n41, n42, n43, n44);
    }
}
const $9014d97cd777be10$var$_v1$5 = /*@__PURE__*/ new $9014d97cd777be10$export$64b5c384219d3699();
const $9014d97cd777be10$var$_m1$2 = /*@__PURE__*/ new $9014d97cd777be10$export$2ae72fc923e5eb5();
const $9014d97cd777be10$var$_zero = /*@__PURE__*/ new $9014d97cd777be10$export$64b5c384219d3699(0, 0, 0);
const $9014d97cd777be10$var$_one = /*@__PURE__*/ new $9014d97cd777be10$export$64b5c384219d3699(1, 1, 1);
const $9014d97cd777be10$var$_x = /*@__PURE__*/ new $9014d97cd777be10$export$64b5c384219d3699();
const $9014d97cd777be10$var$_y = /*@__PURE__*/ new $9014d97cd777be10$export$64b5c384219d3699();
const $9014d97cd777be10$var$_z = /*@__PURE__*/ new $9014d97cd777be10$export$64b5c384219d3699();
const $9014d97cd777be10$var$_matrix = /*@__PURE__*/ new $9014d97cd777be10$export$2ae72fc923e5eb5();
const $9014d97cd777be10$var$_quaternion$3 = /*@__PURE__*/ new $9014d97cd777be10$export$23d6a54f0bbc85a3();
class $9014d97cd777be10$export$d93cc409a0768c5f {
    get x() {
        return this._x;
    }
    set x(value) {
        this._x = value;
        this._onChangeCallback();
    }
    get y() {
        return this._y;
    }
    set y(value) {
        this._y = value;
        this._onChangeCallback();
    }
    get z() {
        return this._z;
    }
    set z(value) {
        this._z = value;
        this._onChangeCallback();
    }
    get order() {
        return this._order;
    }
    set order(value) {
        this._order = value;
        this._onChangeCallback();
    }
    set(x, y, z, order = this._order) {
        this._x = x;
        this._y = y;
        this._z = z;
        this._order = order;
        this._onChangeCallback();
        return this;
    }
    clone() {
        return new this.constructor(this._x, this._y, this._z, this._order);
    }
    copy(euler) {
        this._x = euler._x;
        this._y = euler._y;
        this._z = euler._z;
        this._order = euler._order;
        this._onChangeCallback();
        return this;
    }
    setFromRotationMatrix(m, order = this._order, update = true) {
        // assumes the upper 3x3 of m is a pure rotation matrix (i.e, unscaled)
        const te = m.elements;
        const m11 = te[0], m12 = te[4], m13 = te[8];
        const m21 = te[1], m22 = te[5], m23 = te[9];
        const m31 = te[2], m32 = te[6], m33 = te[10];
        switch(order){
            case "XYZ":
                this._y = Math.asin($9014d97cd777be10$var$clamp(m13, -1, 1));
                if (Math.abs(m13) < 0.9999999) {
                    this._x = Math.atan2(-m23, m33);
                    this._z = Math.atan2(-m12, m11);
                } else {
                    this._x = Math.atan2(m32, m22);
                    this._z = 0;
                }
                break;
            case "YXZ":
                this._x = Math.asin(-$9014d97cd777be10$var$clamp(m23, -1, 1));
                if (Math.abs(m23) < 0.9999999) {
                    this._y = Math.atan2(m13, m33);
                    this._z = Math.atan2(m21, m22);
                } else {
                    this._y = Math.atan2(-m31, m11);
                    this._z = 0;
                }
                break;
            case "ZXY":
                this._x = Math.asin($9014d97cd777be10$var$clamp(m32, -1, 1));
                if (Math.abs(m32) < 0.9999999) {
                    this._y = Math.atan2(-m31, m33);
                    this._z = Math.atan2(-m12, m22);
                } else {
                    this._y = 0;
                    this._z = Math.atan2(m21, m11);
                }
                break;
            case "ZYX":
                this._y = Math.asin(-$9014d97cd777be10$var$clamp(m31, -1, 1));
                if (Math.abs(m31) < 0.9999999) {
                    this._x = Math.atan2(m32, m33);
                    this._z = Math.atan2(m21, m11);
                } else {
                    this._x = 0;
                    this._z = Math.atan2(-m12, m22);
                }
                break;
            case "YZX":
                this._z = Math.asin($9014d97cd777be10$var$clamp(m21, -1, 1));
                if (Math.abs(m21) < 0.9999999) {
                    this._x = Math.atan2(-m23, m22);
                    this._y = Math.atan2(-m31, m11);
                } else {
                    this._x = 0;
                    this._y = Math.atan2(m13, m33);
                }
                break;
            case "XZY":
                this._z = Math.asin(-$9014d97cd777be10$var$clamp(m12, -1, 1));
                if (Math.abs(m12) < 0.9999999) {
                    this._x = Math.atan2(m32, m22);
                    this._y = Math.atan2(m13, m11);
                } else {
                    this._x = Math.atan2(-m23, m33);
                    this._y = 0;
                }
                break;
            default:
                console.warn("THREE.Euler: .setFromRotationMatrix() encountered an unknown order: " + order);
        }
        this._order = order;
        if (update === true) this._onChangeCallback();
        return this;
    }
    setFromQuaternion(q, order, update) {
        $9014d97cd777be10$var$_matrix.makeRotationFromQuaternion(q);
        return this.setFromRotationMatrix($9014d97cd777be10$var$_matrix, order, update);
    }
    setFromVector3(v, order = this._order) {
        return this.set(v.x, v.y, v.z, order);
    }
    reorder(newOrder) {
        // WARNING: this discards revolution information -bhouston
        $9014d97cd777be10$var$_quaternion$3.setFromEuler(this);
        return this.setFromQuaternion($9014d97cd777be10$var$_quaternion$3, newOrder);
    }
    equals(euler) {
        return euler._x === this._x && euler._y === this._y && euler._z === this._z && euler._order === this._order;
    }
    fromArray(array) {
        this._x = array[0];
        this._y = array[1];
        this._z = array[2];
        if (array[3] !== undefined) this._order = array[3];
        this._onChangeCallback();
        return this;
    }
    toArray(array = [], offset = 0) {
        array[offset] = this._x;
        array[offset + 1] = this._y;
        array[offset + 2] = this._z;
        array[offset + 3] = this._order;
        return array;
    }
    _onChange(callback) {
        this._onChangeCallback = callback;
        return this;
    }
    _onChangeCallback() {}
    *[Symbol.iterator]() {
        yield this._x;
        yield this._y;
        yield this._z;
        yield this._order;
    }
    constructor(x = 0, y = 0, z = 0, order = $9014d97cd777be10$export$d93cc409a0768c5f.DEFAULT_ORDER){
        this.isEuler = true;
        this._x = x;
        this._y = y;
        this._z = z;
        this._order = order;
    }
}
$9014d97cd777be10$export$d93cc409a0768c5f.DEFAULT_ORDER = "XYZ";
class $9014d97cd777be10$export$89312ce47c0ca777 {
    set(channel) {
        this.mask = (1 << channel | 0) >>> 0;
    }
    enable(channel) {
        this.mask |= 1 << channel | 0;
    }
    enableAll() {
        this.mask = -1;
    }
    toggle(channel) {
        this.mask ^= 1 << channel | 0;
    }
    disable(channel) {
        this.mask &= ~(1 << channel | 0);
    }
    disableAll() {
        this.mask = 0;
    }
    test(layers) {
        return (this.mask & layers.mask) !== 0;
    }
    isEnabled(channel) {
        return (this.mask & (1 << channel | 0)) !== 0;
    }
    constructor(){
        this.mask = 1;
    }
}
let $9014d97cd777be10$var$_object3DId = 0;
const $9014d97cd777be10$var$_v1$4 = /*@__PURE__*/ new $9014d97cd777be10$export$64b5c384219d3699();
const $9014d97cd777be10$var$_q1 = /*@__PURE__*/ new $9014d97cd777be10$export$23d6a54f0bbc85a3();
const $9014d97cd777be10$var$_m1$1 = /*@__PURE__*/ new $9014d97cd777be10$export$2ae72fc923e5eb5();
const $9014d97cd777be10$var$_target = /*@__PURE__*/ new $9014d97cd777be10$export$64b5c384219d3699();
const $9014d97cd777be10$var$_position$3 = /*@__PURE__*/ new $9014d97cd777be10$export$64b5c384219d3699();
const $9014d97cd777be10$var$_scale$2 = /*@__PURE__*/ new $9014d97cd777be10$export$64b5c384219d3699();
const $9014d97cd777be10$var$_quaternion$2 = /*@__PURE__*/ new $9014d97cd777be10$export$23d6a54f0bbc85a3();
const $9014d97cd777be10$var$_xAxis = /*@__PURE__*/ new $9014d97cd777be10$export$64b5c384219d3699(1, 0, 0);
const $9014d97cd777be10$var$_yAxis = /*@__PURE__*/ new $9014d97cd777be10$export$64b5c384219d3699(0, 1, 0);
const $9014d97cd777be10$var$_zAxis = /*@__PURE__*/ new $9014d97cd777be10$export$64b5c384219d3699(0, 0, 1);
const $9014d97cd777be10$var$_addedEvent = {
    type: "added"
};
const $9014d97cd777be10$var$_removedEvent = {
    type: "removed"
};
class $9014d97cd777be10$export$e4dd07dff30cc924 extends $9014d97cd777be10$export$ec8b666c5fe2c75a {
    onBeforeRender() {}
    onAfterRender() {}
    applyMatrix4(matrix) {
        if (this.matrixAutoUpdate) this.updateMatrix();
        this.matrix.premultiply(matrix);
        this.matrix.decompose(this.position, this.quaternion, this.scale);
    }
    applyQuaternion(q) {
        this.quaternion.premultiply(q);
        return this;
    }
    setRotationFromAxisAngle(axis, angle) {
        // assumes axis is normalized
        this.quaternion.setFromAxisAngle(axis, angle);
    }
    setRotationFromEuler(euler) {
        this.quaternion.setFromEuler(euler, true);
    }
    setRotationFromMatrix(m) {
        // assumes the upper 3x3 of m is a pure rotation matrix (i.e, unscaled)
        this.quaternion.setFromRotationMatrix(m);
    }
    setRotationFromQuaternion(q) {
        // assumes q is normalized
        this.quaternion.copy(q);
    }
    rotateOnAxis(axis, angle) {
        // rotate object on axis in object space
        // axis is assumed to be normalized
        $9014d97cd777be10$var$_q1.setFromAxisAngle(axis, angle);
        this.quaternion.multiply($9014d97cd777be10$var$_q1);
        return this;
    }
    rotateOnWorldAxis(axis, angle) {
        // rotate object on axis in world space
        // axis is assumed to be normalized
        // method assumes no rotated parent
        $9014d97cd777be10$var$_q1.setFromAxisAngle(axis, angle);
        this.quaternion.premultiply($9014d97cd777be10$var$_q1);
        return this;
    }
    rotateX(angle) {
        return this.rotateOnAxis($9014d97cd777be10$var$_xAxis, angle);
    }
    rotateY(angle) {
        return this.rotateOnAxis($9014d97cd777be10$var$_yAxis, angle);
    }
    rotateZ(angle) {
        return this.rotateOnAxis($9014d97cd777be10$var$_zAxis, angle);
    }
    translateOnAxis(axis, distance) {
        // translate object by distance along axis in object space
        // axis is assumed to be normalized
        $9014d97cd777be10$var$_v1$4.copy(axis).applyQuaternion(this.quaternion);
        this.position.add($9014d97cd777be10$var$_v1$4.multiplyScalar(distance));
        return this;
    }
    translateX(distance) {
        return this.translateOnAxis($9014d97cd777be10$var$_xAxis, distance);
    }
    translateY(distance) {
        return this.translateOnAxis($9014d97cd777be10$var$_yAxis, distance);
    }
    translateZ(distance) {
        return this.translateOnAxis($9014d97cd777be10$var$_zAxis, distance);
    }
    localToWorld(vector) {
        this.updateWorldMatrix(true, false);
        return vector.applyMatrix4(this.matrixWorld);
    }
    worldToLocal(vector) {
        this.updateWorldMatrix(true, false);
        return vector.applyMatrix4($9014d97cd777be10$var$_m1$1.copy(this.matrixWorld).invert());
    }
    lookAt(x, y, z) {
        // This method does not support objects having non-uniformly-scaled parent(s)
        if (x.isVector3) $9014d97cd777be10$var$_target.copy(x);
        else $9014d97cd777be10$var$_target.set(x, y, z);
        const parent = this.parent;
        this.updateWorldMatrix(true, false);
        $9014d97cd777be10$var$_position$3.setFromMatrixPosition(this.matrixWorld);
        if (this.isCamera || this.isLight) $9014d97cd777be10$var$_m1$1.lookAt($9014d97cd777be10$var$_position$3, $9014d97cd777be10$var$_target, this.up);
        else $9014d97cd777be10$var$_m1$1.lookAt($9014d97cd777be10$var$_target, $9014d97cd777be10$var$_position$3, this.up);
        this.quaternion.setFromRotationMatrix($9014d97cd777be10$var$_m1$1);
        if (parent) {
            $9014d97cd777be10$var$_m1$1.extractRotation(parent.matrixWorld);
            $9014d97cd777be10$var$_q1.setFromRotationMatrix($9014d97cd777be10$var$_m1$1);
            this.quaternion.premultiply($9014d97cd777be10$var$_q1.invert());
        }
    }
    add(object) {
        if (arguments.length > 1) {
            for(let i = 0; i < arguments.length; i++)this.add(arguments[i]);
            return this;
        }
        if (object === this) {
            console.error("THREE.Object3D.add: object can't be added as a child of itself.", object);
            return this;
        }
        if (object && object.isObject3D) {
            if (object.parent !== null) object.parent.remove(object);
            object.parent = this;
            this.children.push(object);
            object.dispatchEvent($9014d97cd777be10$var$_addedEvent);
        } else console.error("THREE.Object3D.add: object not an instance of THREE.Object3D.", object);
        return this;
    }
    remove(object) {
        if (arguments.length > 1) {
            for(let i = 0; i < arguments.length; i++)this.remove(arguments[i]);
            return this;
        }
        const index = this.children.indexOf(object);
        if (index !== -1) {
            object.parent = null;
            this.children.splice(index, 1);
            object.dispatchEvent($9014d97cd777be10$var$_removedEvent);
        }
        return this;
    }
    removeFromParent() {
        const parent = this.parent;
        if (parent !== null) parent.remove(this);
        return this;
    }
    clear() {
        for(let i = 0; i < this.children.length; i++){
            const object = this.children[i];
            object.parent = null;
            object.dispatchEvent($9014d97cd777be10$var$_removedEvent);
        }
        this.children.length = 0;
        return this;
    }
    attach(object) {
        // adds object as a child of this, while maintaining the object's world transform
        // Note: This method does not support scene graphs having non-uniformly-scaled nodes(s)
        this.updateWorldMatrix(true, false);
        $9014d97cd777be10$var$_m1$1.copy(this.matrixWorld).invert();
        if (object.parent !== null) {
            object.parent.updateWorldMatrix(true, false);
            $9014d97cd777be10$var$_m1$1.multiply(object.parent.matrixWorld);
        }
        object.applyMatrix4($9014d97cd777be10$var$_m1$1);
        this.add(object);
        object.updateWorldMatrix(false, true);
        return this;
    }
    getObjectById(id) {
        return this.getObjectByProperty("id", id);
    }
    getObjectByName(name) {
        return this.getObjectByProperty("name", name);
    }
    getObjectByProperty(name, value) {
        if (this[name] === value) return this;
        for(let i = 0, l = this.children.length; i < l; i++){
            const child = this.children[i];
            const object = child.getObjectByProperty(name, value);
            if (object !== undefined) return object;
        }
        return undefined;
    }
    getObjectsByProperty(name, value) {
        let result = [];
        if (this[name] === value) result.push(this);
        for(let i = 0, l = this.children.length; i < l; i++){
            const childResult = this.children[i].getObjectsByProperty(name, value);
            if (childResult.length > 0) result = result.concat(childResult);
        }
        return result;
    }
    getWorldPosition(target) {
        this.updateWorldMatrix(true, false);
        return target.setFromMatrixPosition(this.matrixWorld);
    }
    getWorldQuaternion(target) {
        this.updateWorldMatrix(true, false);
        this.matrixWorld.decompose($9014d97cd777be10$var$_position$3, target, $9014d97cd777be10$var$_scale$2);
        return target;
    }
    getWorldScale(target) {
        this.updateWorldMatrix(true, false);
        this.matrixWorld.decompose($9014d97cd777be10$var$_position$3, $9014d97cd777be10$var$_quaternion$2, target);
        return target;
    }
    getWorldDirection(target) {
        this.updateWorldMatrix(true, false);
        const e = this.matrixWorld.elements;
        return target.set(e[8], e[9], e[10]).normalize();
    }
    raycast() {}
    traverse(callback) {
        callback(this);
        const children = this.children;
        for(let i = 0, l = children.length; i < l; i++)children[i].traverse(callback);
    }
    traverseVisible(callback) {
        if (this.visible === false) return;
        callback(this);
        const children = this.children;
        for(let i = 0, l = children.length; i < l; i++)children[i].traverseVisible(callback);
    }
    traverseAncestors(callback) {
        const parent = this.parent;
        if (parent !== null) {
            callback(parent);
            parent.traverseAncestors(callback);
        }
    }
    updateMatrix() {
        this.matrix.compose(this.position, this.quaternion, this.scale);
        this.matrixWorldNeedsUpdate = true;
    }
    updateMatrixWorld(force) {
        if (this.matrixAutoUpdate) this.updateMatrix();
        if (this.matrixWorldNeedsUpdate || force) {
            if (this.parent === null) this.matrixWorld.copy(this.matrix);
            else this.matrixWorld.multiplyMatrices(this.parent.matrixWorld, this.matrix);
            this.matrixWorldNeedsUpdate = false;
            force = true;
        }
        // update children
        const children = this.children;
        for(let i = 0, l = children.length; i < l; i++){
            const child = children[i];
            if (child.matrixWorldAutoUpdate === true || force === true) child.updateMatrixWorld(force);
        }
    }
    updateWorldMatrix(updateParents, updateChildren) {
        const parent = this.parent;
        if (updateParents === true && parent !== null && parent.matrixWorldAutoUpdate === true) parent.updateWorldMatrix(true, false);
        if (this.matrixAutoUpdate) this.updateMatrix();
        if (this.parent === null) this.matrixWorld.copy(this.matrix);
        else this.matrixWorld.multiplyMatrices(this.parent.matrixWorld, this.matrix);
        // update children
        if (updateChildren === true) {
            const children = this.children;
            for(let i = 0, l = children.length; i < l; i++){
                const child = children[i];
                if (child.matrixWorldAutoUpdate === true) child.updateWorldMatrix(false, true);
            }
        }
    }
    toJSON(meta) {
        // meta is a string when called from JSON.stringify
        const isRootObject = meta === undefined || typeof meta === "string";
        const output = {};
        // meta is a hash used to collect geometries, materials.
        // not providing it implies that this is the root object
        // being serialized.
        if (isRootObject) {
            // initialize meta obj
            meta = {
                geometries: {},
                materials: {},
                textures: {},
                images: {},
                shapes: {},
                skeletons: {},
                animations: {},
                nodes: {}
            };
            output.metadata = {
                version: 4.6,
                type: "Object",
                generator: "Object3D.toJSON"
            };
        }
        // standard Object3D serialization
        const object = {};
        object.uuid = this.uuid;
        object.type = this.type;
        if (this.name !== "") object.name = this.name;
        if (this.castShadow === true) object.castShadow = true;
        if (this.receiveShadow === true) object.receiveShadow = true;
        if (this.visible === false) object.visible = false;
        if (this.frustumCulled === false) object.frustumCulled = false;
        if (this.renderOrder !== 0) object.renderOrder = this.renderOrder;
        if (Object.keys(this.userData).length > 0) object.userData = this.userData;
        object.layers = this.layers.mask;
        object.matrix = this.matrix.toArray();
        object.up = this.up.toArray();
        if (this.matrixAutoUpdate === false) object.matrixAutoUpdate = false;
        // object specific properties
        if (this.isInstancedMesh) {
            object.type = "InstancedMesh";
            object.count = this.count;
            object.instanceMatrix = this.instanceMatrix.toJSON();
            if (this.instanceColor !== null) object.instanceColor = this.instanceColor.toJSON();
        }
        //
        function serialize(library, element) {
            if (library[element.uuid] === undefined) library[element.uuid] = element.toJSON(meta);
            return element.uuid;
        }
        if (this.isScene) {
            if (this.background) {
                if (this.background.isColor) object.background = this.background.toJSON();
                else if (this.background.isTexture) object.background = this.background.toJSON(meta).uuid;
            }
            if (this.environment && this.environment.isTexture && this.environment.isRenderTargetTexture !== true) object.environment = this.environment.toJSON(meta).uuid;
        } else if (this.isMesh || this.isLine || this.isPoints) {
            object.geometry = serialize(meta.geometries, this.geometry);
            const parameters = this.geometry.parameters;
            if (parameters !== undefined && parameters.shapes !== undefined) {
                const shapes = parameters.shapes;
                if (Array.isArray(shapes)) for(let i = 0, l = shapes.length; i < l; i++){
                    const shape = shapes[i];
                    serialize(meta.shapes, shape);
                }
                else serialize(meta.shapes, shapes);
            }
        }
        if (this.isSkinnedMesh) {
            object.bindMode = this.bindMode;
            object.bindMatrix = this.bindMatrix.toArray();
            if (this.skeleton !== undefined) {
                serialize(meta.skeletons, this.skeleton);
                object.skeleton = this.skeleton.uuid;
            }
        }
        if (this.material !== undefined) {
            if (Array.isArray(this.material)) {
                const uuids = [];
                for(let i = 0, l = this.material.length; i < l; i++)uuids.push(serialize(meta.materials, this.material[i]));
                object.material = uuids;
            } else object.material = serialize(meta.materials, this.material);
        }
        //
        if (this.children.length > 0) {
            object.children = [];
            for(let i = 0; i < this.children.length; i++)object.children.push(this.children[i].toJSON(meta).object);
        }
        //
        if (this.animations.length > 0) {
            object.animations = [];
            for(let i = 0; i < this.animations.length; i++){
                const animation = this.animations[i];
                object.animations.push(serialize(meta.animations, animation));
            }
        }
        if (isRootObject) {
            const geometries = extractFromCache(meta.geometries);
            const materials = extractFromCache(meta.materials);
            const textures = extractFromCache(meta.textures);
            const images = extractFromCache(meta.images);
            const shapes = extractFromCache(meta.shapes);
            const skeletons = extractFromCache(meta.skeletons);
            const animations = extractFromCache(meta.animations);
            const nodes = extractFromCache(meta.nodes);
            if (geometries.length > 0) output.geometries = geometries;
            if (materials.length > 0) output.materials = materials;
            if (textures.length > 0) output.textures = textures;
            if (images.length > 0) output.images = images;
            if (shapes.length > 0) output.shapes = shapes;
            if (skeletons.length > 0) output.skeletons = skeletons;
            if (animations.length > 0) output.animations = animations;
            if (nodes.length > 0) output.nodes = nodes;
        }
        output.object = object;
        return output;
        // extract data from the cache hash
        // remove metadata on each item
        // and return as array
        function extractFromCache(cache) {
            const values = [];
            for(const key in cache){
                const data = cache[key];
                delete data.metadata;
                values.push(data);
            }
            return values;
        }
    }
    clone(recursive) {
        return new this.constructor().copy(this, recursive);
    }
    copy(source, recursive = true) {
        this.name = source.name;
        this.up.copy(source.up);
        this.position.copy(source.position);
        this.rotation.order = source.rotation.order;
        this.quaternion.copy(source.quaternion);
        this.scale.copy(source.scale);
        this.matrix.copy(source.matrix);
        this.matrixWorld.copy(source.matrixWorld);
        this.matrixAutoUpdate = source.matrixAutoUpdate;
        this.matrixWorldNeedsUpdate = source.matrixWorldNeedsUpdate;
        this.matrixWorldAutoUpdate = source.matrixWorldAutoUpdate;
        this.layers.mask = source.layers.mask;
        this.visible = source.visible;
        this.castShadow = source.castShadow;
        this.receiveShadow = source.receiveShadow;
        this.frustumCulled = source.frustumCulled;
        this.renderOrder = source.renderOrder;
        this.animations = source.animations.slice();
        this.userData = JSON.parse(JSON.stringify(source.userData));
        if (recursive === true) for(let i = 0; i < source.children.length; i++){
            const child = source.children[i];
            this.add(child.clone());
        }
        return this;
    }
    constructor(){
        super();
        this.isObject3D = true;
        Object.defineProperty(this, "id", {
            value: $9014d97cd777be10$var$_object3DId++
        });
        this.uuid = $9014d97cd777be10$var$generateUUID();
        this.name = "";
        this.type = "Object3D";
        this.parent = null;
        this.children = [];
        this.up = $9014d97cd777be10$export$e4dd07dff30cc924.DEFAULT_UP.clone();
        const position = new $9014d97cd777be10$export$64b5c384219d3699();
        const rotation = new $9014d97cd777be10$export$d93cc409a0768c5f();
        const quaternion = new $9014d97cd777be10$export$23d6a54f0bbc85a3();
        const scale = new $9014d97cd777be10$export$64b5c384219d3699(1, 1, 1);
        function onRotationChange() {
            quaternion.setFromEuler(rotation, false);
        }
        function onQuaternionChange() {
            rotation.setFromQuaternion(quaternion, undefined, false);
        }
        rotation._onChange(onRotationChange);
        quaternion._onChange(onQuaternionChange);
        Object.defineProperties(this, {
            position: {
                configurable: true,
                enumerable: true,
                value: position
            },
            rotation: {
                configurable: true,
                enumerable: true,
                value: rotation
            },
            quaternion: {
                configurable: true,
                enumerable: true,
                value: quaternion
            },
            scale: {
                configurable: true,
                enumerable: true,
                value: scale
            },
            modelViewMatrix: {
                value: new $9014d97cd777be10$export$2ae72fc923e5eb5()
            },
            normalMatrix: {
                value: new $9014d97cd777be10$export$8ff26dafa08918()
            }
        });
        this.matrix = new $9014d97cd777be10$export$2ae72fc923e5eb5();
        this.matrixWorld = new $9014d97cd777be10$export$2ae72fc923e5eb5();
        this.matrixAutoUpdate = $9014d97cd777be10$export$e4dd07dff30cc924.DEFAULT_MATRIX_AUTO_UPDATE;
        this.matrixWorldNeedsUpdate = false;
        this.matrixWorldAutoUpdate = $9014d97cd777be10$export$e4dd07dff30cc924.DEFAULT_MATRIX_WORLD_AUTO_UPDATE; // checked by the renderer
        this.layers = new $9014d97cd777be10$export$89312ce47c0ca777();
        this.visible = true;
        this.castShadow = false;
        this.receiveShadow = false;
        this.frustumCulled = true;
        this.renderOrder = 0;
        this.animations = [];
        this.userData = {};
    }
}
$9014d97cd777be10$export$e4dd07dff30cc924.DEFAULT_UP = /*@__PURE__*/ new $9014d97cd777be10$export$64b5c384219d3699(0, 1, 0);
$9014d97cd777be10$export$e4dd07dff30cc924.DEFAULT_MATRIX_AUTO_UPDATE = true;
$9014d97cd777be10$export$e4dd07dff30cc924.DEFAULT_MATRIX_WORLD_AUTO_UPDATE = true;
const $9014d97cd777be10$var$_v0$1 = /*@__PURE__*/ new $9014d97cd777be10$export$64b5c384219d3699();
const $9014d97cd777be10$var$_v1$3 = /*@__PURE__*/ new $9014d97cd777be10$export$64b5c384219d3699();
const $9014d97cd777be10$var$_v2$2 = /*@__PURE__*/ new $9014d97cd777be10$export$64b5c384219d3699();
const $9014d97cd777be10$var$_v3$1 = /*@__PURE__*/ new $9014d97cd777be10$export$64b5c384219d3699();
const $9014d97cd777be10$var$_vab = /*@__PURE__*/ new $9014d97cd777be10$export$64b5c384219d3699();
const $9014d97cd777be10$var$_vac = /*@__PURE__*/ new $9014d97cd777be10$export$64b5c384219d3699();
const $9014d97cd777be10$var$_vbc = /*@__PURE__*/ new $9014d97cd777be10$export$64b5c384219d3699();
const $9014d97cd777be10$var$_vap = /*@__PURE__*/ new $9014d97cd777be10$export$64b5c384219d3699();
const $9014d97cd777be10$var$_vbp = /*@__PURE__*/ new $9014d97cd777be10$export$64b5c384219d3699();
const $9014d97cd777be10$var$_vcp = /*@__PURE__*/ new $9014d97cd777be10$export$64b5c384219d3699();
let $9014d97cd777be10$var$warnedGetUV = false;
class $9014d97cd777be10$export$5a465592bfe74b48 {
    static getNormal(a, b, c, target) {
        target.subVectors(c, b);
        $9014d97cd777be10$var$_v0$1.subVectors(a, b);
        target.cross($9014d97cd777be10$var$_v0$1);
        const targetLengthSq = target.lengthSq();
        if (targetLengthSq > 0) return target.multiplyScalar(1 / Math.sqrt(targetLengthSq));
        return target.set(0, 0, 0);
    }
    // static/instance method to calculate barycentric coordinates
    // based on: http://www.blackpawn.com/texts/pointinpoly/default.html
    static getBarycoord(point, a, b, c, target) {
        $9014d97cd777be10$var$_v0$1.subVectors(c, a);
        $9014d97cd777be10$var$_v1$3.subVectors(b, a);
        $9014d97cd777be10$var$_v2$2.subVectors(point, a);
        const dot00 = $9014d97cd777be10$var$_v0$1.dot($9014d97cd777be10$var$_v0$1);
        const dot01 = $9014d97cd777be10$var$_v0$1.dot($9014d97cd777be10$var$_v1$3);
        const dot02 = $9014d97cd777be10$var$_v0$1.dot($9014d97cd777be10$var$_v2$2);
        const dot11 = $9014d97cd777be10$var$_v1$3.dot($9014d97cd777be10$var$_v1$3);
        const dot12 = $9014d97cd777be10$var$_v1$3.dot($9014d97cd777be10$var$_v2$2);
        const denom = dot00 * dot11 - dot01 * dot01;
        // collinear or singular triangle
        if (denom === 0) // arbitrary location outside of triangle?
        // not sure if this is the best idea, maybe should be returning undefined
        return target.set(-2, -1, -1);
        const invDenom = 1 / denom;
        const u = (dot11 * dot02 - dot01 * dot12) * invDenom;
        const v = (dot00 * dot12 - dot01 * dot02) * invDenom;
        // barycentric coordinates must always sum to 1
        return target.set(1 - u - v, v, u);
    }
    static containsPoint(point, a, b, c) {
        this.getBarycoord(point, a, b, c, $9014d97cd777be10$var$_v3$1);
        return $9014d97cd777be10$var$_v3$1.x >= 0 && $9014d97cd777be10$var$_v3$1.y >= 0 && $9014d97cd777be10$var$_v3$1.x + $9014d97cd777be10$var$_v3$1.y <= 1;
    }
    static getUV(point, p1, p2, p3, uv1, uv2, uv3, target) {
        if ($9014d97cd777be10$var$warnedGetUV === false) {
            console.warn("THREE.Triangle.getUV() has been renamed to THREE.Triangle.getInterpolation().");
            $9014d97cd777be10$var$warnedGetUV = true;
        }
        return this.getInterpolation(point, p1, p2, p3, uv1, uv2, uv3, target);
    }
    static getInterpolation(point, p1, p2, p3, v1, v2, v3, target) {
        this.getBarycoord(point, p1, p2, p3, $9014d97cd777be10$var$_v3$1);
        target.setScalar(0);
        target.addScaledVector(v1, $9014d97cd777be10$var$_v3$1.x);
        target.addScaledVector(v2, $9014d97cd777be10$var$_v3$1.y);
        target.addScaledVector(v3, $9014d97cd777be10$var$_v3$1.z);
        return target;
    }
    static isFrontFacing(a, b, c, direction) {
        $9014d97cd777be10$var$_v0$1.subVectors(c, b);
        $9014d97cd777be10$var$_v1$3.subVectors(a, b);
        // strictly front facing
        return $9014d97cd777be10$var$_v0$1.cross($9014d97cd777be10$var$_v1$3).dot(direction) < 0 ? true : false;
    }
    set(a, b, c) {
        this.a.copy(a);
        this.b.copy(b);
        this.c.copy(c);
        return this;
    }
    setFromPointsAndIndices(points, i0, i1, i2) {
        this.a.copy(points[i0]);
        this.b.copy(points[i1]);
        this.c.copy(points[i2]);
        return this;
    }
    setFromAttributeAndIndices(attribute, i0, i1, i2) {
        this.a.fromBufferAttribute(attribute, i0);
        this.b.fromBufferAttribute(attribute, i1);
        this.c.fromBufferAttribute(attribute, i2);
        return this;
    }
    clone() {
        return new this.constructor().copy(this);
    }
    copy(triangle) {
        this.a.copy(triangle.a);
        this.b.copy(triangle.b);
        this.c.copy(triangle.c);
        return this;
    }
    getArea() {
        $9014d97cd777be10$var$_v0$1.subVectors(this.c, this.b);
        $9014d97cd777be10$var$_v1$3.subVectors(this.a, this.b);
        return $9014d97cd777be10$var$_v0$1.cross($9014d97cd777be10$var$_v1$3).length() * 0.5;
    }
    getMidpoint(target) {
        return target.addVectors(this.a, this.b).add(this.c).multiplyScalar(1 / 3);
    }
    getNormal(target) {
        return $9014d97cd777be10$export$5a465592bfe74b48.getNormal(this.a, this.b, this.c, target);
    }
    getPlane(target) {
        return target.setFromCoplanarPoints(this.a, this.b, this.c);
    }
    getBarycoord(point, target) {
        return $9014d97cd777be10$export$5a465592bfe74b48.getBarycoord(point, this.a, this.b, this.c, target);
    }
    getUV(point, uv1, uv2, uv3, target) {
        if ($9014d97cd777be10$var$warnedGetUV === false) {
            console.warn("THREE.Triangle.getUV() has been renamed to THREE.Triangle.getInterpolation().");
            $9014d97cd777be10$var$warnedGetUV = true;
        }
        return $9014d97cd777be10$export$5a465592bfe74b48.getInterpolation(point, this.a, this.b, this.c, uv1, uv2, uv3, target);
    }
    getInterpolation(point, v1, v2, v3, target) {
        return $9014d97cd777be10$export$5a465592bfe74b48.getInterpolation(point, this.a, this.b, this.c, v1, v2, v3, target);
    }
    containsPoint(point) {
        return $9014d97cd777be10$export$5a465592bfe74b48.containsPoint(point, this.a, this.b, this.c);
    }
    isFrontFacing(direction) {
        return $9014d97cd777be10$export$5a465592bfe74b48.isFrontFacing(this.a, this.b, this.c, direction);
    }
    intersectsBox(box) {
        return box.intersectsTriangle(this);
    }
    closestPointToPoint(p, target) {
        const a = this.a, b = this.b, c = this.c;
        let v, w;
        // algorithm thanks to Real-Time Collision Detection by Christer Ericson,
        // published by Morgan Kaufmann Publishers, (c) 2005 Elsevier Inc.,
        // under the accompanying license; see chapter 5.1.5 for detailed explanation.
        // basically, we're distinguishing which of the voronoi regions of the triangle
        // the point lies in with the minimum amount of redundant computation.
        $9014d97cd777be10$var$_vab.subVectors(b, a);
        $9014d97cd777be10$var$_vac.subVectors(c, a);
        $9014d97cd777be10$var$_vap.subVectors(p, a);
        const d1 = $9014d97cd777be10$var$_vab.dot($9014d97cd777be10$var$_vap);
        const d2 = $9014d97cd777be10$var$_vac.dot($9014d97cd777be10$var$_vap);
        if (d1 <= 0 && d2 <= 0) // vertex region of A; barycentric coords (1, 0, 0)
        return target.copy(a);
        $9014d97cd777be10$var$_vbp.subVectors(p, b);
        const d3 = $9014d97cd777be10$var$_vab.dot($9014d97cd777be10$var$_vbp);
        const d4 = $9014d97cd777be10$var$_vac.dot($9014d97cd777be10$var$_vbp);
        if (d3 >= 0 && d4 <= d3) // vertex region of B; barycentric coords (0, 1, 0)
        return target.copy(b);
        const vc = d1 * d4 - d3 * d2;
        if (vc <= 0 && d1 >= 0 && d3 <= 0) {
            v = d1 / (d1 - d3);
            // edge region of AB; barycentric coords (1-v, v, 0)
            return target.copy(a).addScaledVector($9014d97cd777be10$var$_vab, v);
        }
        $9014d97cd777be10$var$_vcp.subVectors(p, c);
        const d5 = $9014d97cd777be10$var$_vab.dot($9014d97cd777be10$var$_vcp);
        const d6 = $9014d97cd777be10$var$_vac.dot($9014d97cd777be10$var$_vcp);
        if (d6 >= 0 && d5 <= d6) // vertex region of C; barycentric coords (0, 0, 1)
        return target.copy(c);
        const vb = d5 * d2 - d1 * d6;
        if (vb <= 0 && d2 >= 0 && d6 <= 0) {
            w = d2 / (d2 - d6);
            // edge region of AC; barycentric coords (1-w, 0, w)
            return target.copy(a).addScaledVector($9014d97cd777be10$var$_vac, w);
        }
        const va = d3 * d6 - d5 * d4;
        if (va <= 0 && d4 - d3 >= 0 && d5 - d6 >= 0) {
            $9014d97cd777be10$var$_vbc.subVectors(c, b);
            w = (d4 - d3) / (d4 - d3 + (d5 - d6));
            // edge region of BC; barycentric coords (0, 1-w, w)
            return target.copy(b).addScaledVector($9014d97cd777be10$var$_vbc, w); // edge region of BC
        }
        // face region
        const denom = 1 / (va + vb + vc);
        // u = va * denom
        v = vb * denom;
        w = vc * denom;
        return target.copy(a).addScaledVector($9014d97cd777be10$var$_vab, v).addScaledVector($9014d97cd777be10$var$_vac, w);
    }
    equals(triangle) {
        return triangle.a.equals(this.a) && triangle.b.equals(this.b) && triangle.c.equals(this.c);
    }
    constructor(a = new $9014d97cd777be10$export$64b5c384219d3699(), b = new $9014d97cd777be10$export$64b5c384219d3699(), c = new $9014d97cd777be10$export$64b5c384219d3699()){
        this.a = a;
        this.b = b;
        this.c = c;
    }
}
let $9014d97cd777be10$var$materialId = 0;
class $9014d97cd777be10$export$a2d8b23205c25948 extends $9014d97cd777be10$export$ec8b666c5fe2c75a {
    get alphaTest() {
        return this._alphaTest;
    }
    set alphaTest(value) {
        if (this._alphaTest > 0 !== value > 0) this.version++;
        this._alphaTest = value;
    }
    onBuild() {}
    onBeforeRender() {}
    onBeforeCompile() {}
    customProgramCacheKey() {
        return this.onBeforeCompile.toString();
    }
    setValues(values) {
        if (values === undefined) return;
        for(const key in values){
            const newValue = values[key];
            if (newValue === undefined) {
                console.warn(`THREE.Material: parameter '${key}' has value of undefined.`);
                continue;
            }
            const currentValue = this[key];
            if (currentValue === undefined) {
                console.warn(`THREE.Material: '${key}' is not a property of THREE.${this.type}.`);
                continue;
            }
            if (currentValue && currentValue.isColor) currentValue.set(newValue);
            else if (currentValue && currentValue.isVector3 && newValue && newValue.isVector3) currentValue.copy(newValue);
            else this[key] = newValue;
        }
    }
    toJSON(meta) {
        const isRootObject = meta === undefined || typeof meta === "string";
        if (isRootObject) meta = {
            textures: {},
            images: {}
        };
        const data = {
            metadata: {
                version: 4.6,
                type: "Material",
                generator: "Material.toJSON"
            }
        };
        // standard Material serialization
        data.uuid = this.uuid;
        data.type = this.type;
        if (this.name !== "") data.name = this.name;
        if (this.color && this.color.isColor) data.color = this.color.getHex();
        if (this.roughness !== undefined) data.roughness = this.roughness;
        if (this.metalness !== undefined) data.metalness = this.metalness;
        if (this.sheen !== undefined) data.sheen = this.sheen;
        if (this.sheenColor && this.sheenColor.isColor) data.sheenColor = this.sheenColor.getHex();
        if (this.sheenRoughness !== undefined) data.sheenRoughness = this.sheenRoughness;
        if (this.emissive && this.emissive.isColor) data.emissive = this.emissive.getHex();
        if (this.emissiveIntensity && this.emissiveIntensity !== 1) data.emissiveIntensity = this.emissiveIntensity;
        if (this.specular && this.specular.isColor) data.specular = this.specular.getHex();
        if (this.specularIntensity !== undefined) data.specularIntensity = this.specularIntensity;
        if (this.specularColor && this.specularColor.isColor) data.specularColor = this.specularColor.getHex();
        if (this.shininess !== undefined) data.shininess = this.shininess;
        if (this.clearcoat !== undefined) data.clearcoat = this.clearcoat;
        if (this.clearcoatRoughness !== undefined) data.clearcoatRoughness = this.clearcoatRoughness;
        if (this.clearcoatMap && this.clearcoatMap.isTexture) data.clearcoatMap = this.clearcoatMap.toJSON(meta).uuid;
        if (this.clearcoatRoughnessMap && this.clearcoatRoughnessMap.isTexture) data.clearcoatRoughnessMap = this.clearcoatRoughnessMap.toJSON(meta).uuid;
        if (this.clearcoatNormalMap && this.clearcoatNormalMap.isTexture) {
            data.clearcoatNormalMap = this.clearcoatNormalMap.toJSON(meta).uuid;
            data.clearcoatNormalScale = this.clearcoatNormalScale.toArray();
        }
        if (this.iridescence !== undefined) data.iridescence = this.iridescence;
        if (this.iridescenceIOR !== undefined) data.iridescenceIOR = this.iridescenceIOR;
        if (this.iridescenceThicknessRange !== undefined) data.iridescenceThicknessRange = this.iridescenceThicknessRange;
        if (this.iridescenceMap && this.iridescenceMap.isTexture) data.iridescenceMap = this.iridescenceMap.toJSON(meta).uuid;
        if (this.iridescenceThicknessMap && this.iridescenceThicknessMap.isTexture) data.iridescenceThicknessMap = this.iridescenceThicknessMap.toJSON(meta).uuid;
        if (this.anisotropy !== undefined) data.anisotropy = this.anisotropy;
        if (this.anisotropyRotation !== undefined) data.anisotropyRotation = this.anisotropyRotation;
        if (this.anisotropyMap && this.anisotropyMap.isTexture) data.anisotropyMap = this.anisotropyMap.toJSON(meta).uuid;
        if (this.map && this.map.isTexture) data.map = this.map.toJSON(meta).uuid;
        if (this.matcap && this.matcap.isTexture) data.matcap = this.matcap.toJSON(meta).uuid;
        if (this.alphaMap && this.alphaMap.isTexture) data.alphaMap = this.alphaMap.toJSON(meta).uuid;
        if (this.lightMap && this.lightMap.isTexture) {
            data.lightMap = this.lightMap.toJSON(meta).uuid;
            data.lightMapIntensity = this.lightMapIntensity;
        }
        if (this.aoMap && this.aoMap.isTexture) {
            data.aoMap = this.aoMap.toJSON(meta).uuid;
            data.aoMapIntensity = this.aoMapIntensity;
        }
        if (this.bumpMap && this.bumpMap.isTexture) {
            data.bumpMap = this.bumpMap.toJSON(meta).uuid;
            data.bumpScale = this.bumpScale;
        }
        if (this.normalMap && this.normalMap.isTexture) {
            data.normalMap = this.normalMap.toJSON(meta).uuid;
            data.normalMapType = this.normalMapType;
            data.normalScale = this.normalScale.toArray();
        }
        if (this.displacementMap && this.displacementMap.isTexture) {
            data.displacementMap = this.displacementMap.toJSON(meta).uuid;
            data.displacementScale = this.displacementScale;
            data.displacementBias = this.displacementBias;
        }
        if (this.roughnessMap && this.roughnessMap.isTexture) data.roughnessMap = this.roughnessMap.toJSON(meta).uuid;
        if (this.metalnessMap && this.metalnessMap.isTexture) data.metalnessMap = this.metalnessMap.toJSON(meta).uuid;
        if (this.emissiveMap && this.emissiveMap.isTexture) data.emissiveMap = this.emissiveMap.toJSON(meta).uuid;
        if (this.specularMap && this.specularMap.isTexture) data.specularMap = this.specularMap.toJSON(meta).uuid;
        if (this.specularIntensityMap && this.specularIntensityMap.isTexture) data.specularIntensityMap = this.specularIntensityMap.toJSON(meta).uuid;
        if (this.specularColorMap && this.specularColorMap.isTexture) data.specularColorMap = this.specularColorMap.toJSON(meta).uuid;
        if (this.envMap && this.envMap.isTexture) {
            data.envMap = this.envMap.toJSON(meta).uuid;
            if (this.combine !== undefined) data.combine = this.combine;
        }
        if (this.envMapIntensity !== undefined) data.envMapIntensity = this.envMapIntensity;
        if (this.reflectivity !== undefined) data.reflectivity = this.reflectivity;
        if (this.refractionRatio !== undefined) data.refractionRatio = this.refractionRatio;
        if (this.gradientMap && this.gradientMap.isTexture) data.gradientMap = this.gradientMap.toJSON(meta).uuid;
        if (this.transmission !== undefined) data.transmission = this.transmission;
        if (this.transmissionMap && this.transmissionMap.isTexture) data.transmissionMap = this.transmissionMap.toJSON(meta).uuid;
        if (this.thickness !== undefined) data.thickness = this.thickness;
        if (this.thicknessMap && this.thicknessMap.isTexture) data.thicknessMap = this.thicknessMap.toJSON(meta).uuid;
        if (this.attenuationDistance !== undefined && this.attenuationDistance !== Infinity) data.attenuationDistance = this.attenuationDistance;
        if (this.attenuationColor !== undefined) data.attenuationColor = this.attenuationColor.getHex();
        if (this.size !== undefined) data.size = this.size;
        if (this.shadowSide !== null) data.shadowSide = this.shadowSide;
        if (this.sizeAttenuation !== undefined) data.sizeAttenuation = this.sizeAttenuation;
        if (this.blending !== $9014d97cd777be10$export$5b29a26d96ee6af0) data.blending = this.blending;
        if (this.side !== $9014d97cd777be10$export$2ede184fc2998901) data.side = this.side;
        if (this.vertexColors) data.vertexColors = true;
        if (this.opacity < 1) data.opacity = this.opacity;
        if (this.transparent === true) data.transparent = this.transparent;
        data.depthFunc = this.depthFunc;
        data.depthTest = this.depthTest;
        data.depthWrite = this.depthWrite;
        data.colorWrite = this.colorWrite;
        data.stencilWrite = this.stencilWrite;
        data.stencilWriteMask = this.stencilWriteMask;
        data.stencilFunc = this.stencilFunc;
        data.stencilRef = this.stencilRef;
        data.stencilFuncMask = this.stencilFuncMask;
        data.stencilFail = this.stencilFail;
        data.stencilZFail = this.stencilZFail;
        data.stencilZPass = this.stencilZPass;
        // rotation (SpriteMaterial)
        if (this.rotation !== undefined && this.rotation !== 0) data.rotation = this.rotation;
        if (this.polygonOffset === true) data.polygonOffset = true;
        if (this.polygonOffsetFactor !== 0) data.polygonOffsetFactor = this.polygonOffsetFactor;
        if (this.polygonOffsetUnits !== 0) data.polygonOffsetUnits = this.polygonOffsetUnits;
        if (this.linewidth !== undefined && this.linewidth !== 1) data.linewidth = this.linewidth;
        if (this.dashSize !== undefined) data.dashSize = this.dashSize;
        if (this.gapSize !== undefined) data.gapSize = this.gapSize;
        if (this.scale !== undefined) data.scale = this.scale;
        if (this.dithering === true) data.dithering = true;
        if (this.alphaTest > 0) data.alphaTest = this.alphaTest;
        if (this.alphaHash === true) data.alphaHash = this.alphaHash;
        if (this.alphaToCoverage === true) data.alphaToCoverage = this.alphaToCoverage;
        if (this.premultipliedAlpha === true) data.premultipliedAlpha = this.premultipliedAlpha;
        if (this.forceSinglePass === true) data.forceSinglePass = this.forceSinglePass;
        if (this.wireframe === true) data.wireframe = this.wireframe;
        if (this.wireframeLinewidth > 1) data.wireframeLinewidth = this.wireframeLinewidth;
        if (this.wireframeLinecap !== "round") data.wireframeLinecap = this.wireframeLinecap;
        if (this.wireframeLinejoin !== "round") data.wireframeLinejoin = this.wireframeLinejoin;
        if (this.flatShading === true) data.flatShading = this.flatShading;
        if (this.visible === false) data.visible = false;
        if (this.toneMapped === false) data.toneMapped = false;
        if (this.fog === false) data.fog = false;
        if (Object.keys(this.userData).length > 0) data.userData = this.userData;
        // TODO: Copied from Object3D.toJSON
        function extractFromCache(cache) {
            const values = [];
            for(const key in cache){
                const data = cache[key];
                delete data.metadata;
                values.push(data);
            }
            return values;
        }
        if (isRootObject) {
            const textures = extractFromCache(meta.textures);
            const images = extractFromCache(meta.images);
            if (textures.length > 0) data.textures = textures;
            if (images.length > 0) data.images = images;
        }
        return data;
    }
    clone() {
        return new this.constructor().copy(this);
    }
    copy(source) {
        this.name = source.name;
        this.blending = source.blending;
        this.side = source.side;
        this.vertexColors = source.vertexColors;
        this.opacity = source.opacity;
        this.transparent = source.transparent;
        this.blendSrc = source.blendSrc;
        this.blendDst = source.blendDst;
        this.blendEquation = source.blendEquation;
        this.blendSrcAlpha = source.blendSrcAlpha;
        this.blendDstAlpha = source.blendDstAlpha;
        this.blendEquationAlpha = source.blendEquationAlpha;
        this.depthFunc = source.depthFunc;
        this.depthTest = source.depthTest;
        this.depthWrite = source.depthWrite;
        this.stencilWriteMask = source.stencilWriteMask;
        this.stencilFunc = source.stencilFunc;
        this.stencilRef = source.stencilRef;
        this.stencilFuncMask = source.stencilFuncMask;
        this.stencilFail = source.stencilFail;
        this.stencilZFail = source.stencilZFail;
        this.stencilZPass = source.stencilZPass;
        this.stencilWrite = source.stencilWrite;
        const srcPlanes = source.clippingPlanes;
        let dstPlanes = null;
        if (srcPlanes !== null) {
            const n = srcPlanes.length;
            dstPlanes = new Array(n);
            for(let i = 0; i !== n; ++i)dstPlanes[i] = srcPlanes[i].clone();
        }
        this.clippingPlanes = dstPlanes;
        this.clipIntersection = source.clipIntersection;
        this.clipShadows = source.clipShadows;
        this.shadowSide = source.shadowSide;
        this.colorWrite = source.colorWrite;
        this.precision = source.precision;
        this.polygonOffset = source.polygonOffset;
        this.polygonOffsetFactor = source.polygonOffsetFactor;
        this.polygonOffsetUnits = source.polygonOffsetUnits;
        this.dithering = source.dithering;
        this.alphaTest = source.alphaTest;
        this.alphaHash = source.alphaHash;
        this.alphaToCoverage = source.alphaToCoverage;
        this.premultipliedAlpha = source.premultipliedAlpha;
        this.forceSinglePass = source.forceSinglePass;
        this.visible = source.visible;
        this.toneMapped = source.toneMapped;
        this.userData = JSON.parse(JSON.stringify(source.userData));
        return this;
    }
    dispose() {
        this.dispatchEvent({
            type: "dispose"
        });
    }
    set needsUpdate(value) {
        if (value === true) this.version++;
    }
    constructor(){
        super();
        this.isMaterial = true;
        Object.defineProperty(this, "id", {
            value: $9014d97cd777be10$var$materialId++
        });
        this.uuid = $9014d97cd777be10$var$generateUUID();
        this.name = "";
        this.type = "Material";
        this.blending = $9014d97cd777be10$export$5b29a26d96ee6af0;
        this.side = $9014d97cd777be10$export$2ede184fc2998901;
        this.vertexColors = false;
        this.opacity = 1;
        this.transparent = false;
        this.alphaHash = false;
        this.blendSrc = $9014d97cd777be10$export$d5773124e86cf28c;
        this.blendDst = $9014d97cd777be10$export$11d468cc7f19e971;
        this.blendEquation = $9014d97cd777be10$export$20183a0484ce21a0;
        this.blendSrcAlpha = null;
        this.blendDstAlpha = null;
        this.blendEquationAlpha = null;
        this.depthFunc = $9014d97cd777be10$export$296f78a0b892f81a;
        this.depthTest = true;
        this.depthWrite = true;
        this.stencilWriteMask = 0xff;
        this.stencilFunc = $9014d97cd777be10$export$14cf96713ddd97a8;
        this.stencilRef = 0;
        this.stencilFuncMask = 0xff;
        this.stencilFail = $9014d97cd777be10$export$9f542ae4b5baca34;
        this.stencilZFail = $9014d97cd777be10$export$9f542ae4b5baca34;
        this.stencilZPass = $9014d97cd777be10$export$9f542ae4b5baca34;
        this.stencilWrite = false;
        this.clippingPlanes = null;
        this.clipIntersection = false;
        this.clipShadows = false;
        this.shadowSide = null;
        this.colorWrite = true;
        this.precision = null; // override the renderer's default precision for this material
        this.polygonOffset = false;
        this.polygonOffsetFactor = 0;
        this.polygonOffsetUnits = 0;
        this.dithering = false;
        this.alphaToCoverage = false;
        this.premultipliedAlpha = false;
        this.forceSinglePass = false;
        this.visible = true;
        this.toneMapped = true;
        this.userData = {};
        this.version = 0;
        this._alphaTest = 0;
    }
}
const $9014d97cd777be10$var$_colorKeywords = {
    "aliceblue": 0xF0F8FF,
    "antiquewhite": 0xFAEBD7,
    "aqua": 0x00FFFF,
    "aquamarine": 0x7FFFD4,
    "azure": 0xF0FFFF,
    "beige": 0xF5F5DC,
    "bisque": 0xFFE4C4,
    "black": 0x000000,
    "blanchedalmond": 0xFFEBCD,
    "blue": 0x0000FF,
    "blueviolet": 0x8A2BE2,
    "brown": 0xA52A2A,
    "burlywood": 0xDEB887,
    "cadetblue": 0x5F9EA0,
    "chartreuse": 0x7FFF00,
    "chocolate": 0xD2691E,
    "coral": 0xFF7F50,
    "cornflowerblue": 0x6495ED,
    "cornsilk": 0xFFF8DC,
    "crimson": 0xDC143C,
    "cyan": 0x00FFFF,
    "darkblue": 0x00008B,
    "darkcyan": 0x008B8B,
    "darkgoldenrod": 0xB8860B,
    "darkgray": 0xA9A9A9,
    "darkgreen": 0x006400,
    "darkgrey": 0xA9A9A9,
    "darkkhaki": 0xBDB76B,
    "darkmagenta": 0x8B008B,
    "darkolivegreen": 0x556B2F,
    "darkorange": 0xFF8C00,
    "darkorchid": 0x9932CC,
    "darkred": 0x8B0000,
    "darksalmon": 0xE9967A,
    "darkseagreen": 0x8FBC8F,
    "darkslateblue": 0x483D8B,
    "darkslategray": 0x2F4F4F,
    "darkslategrey": 0x2F4F4F,
    "darkturquoise": 0x00CED1,
    "darkviolet": 0x9400D3,
    "deeppink": 0xFF1493,
    "deepskyblue": 0x00BFFF,
    "dimgray": 0x696969,
    "dimgrey": 0x696969,
    "dodgerblue": 0x1E90FF,
    "firebrick": 0xB22222,
    "floralwhite": 0xFFFAF0,
    "forestgreen": 0x228B22,
    "fuchsia": 0xFF00FF,
    "gainsboro": 0xDCDCDC,
    "ghostwhite": 0xF8F8FF,
    "gold": 0xFFD700,
    "goldenrod": 0xDAA520,
    "gray": 0x808080,
    "green": 0x008000,
    "greenyellow": 0xADFF2F,
    "grey": 0x808080,
    "honeydew": 0xF0FFF0,
    "hotpink": 0xFF69B4,
    "indianred": 0xCD5C5C,
    "indigo": 0x4B0082,
    "ivory": 0xFFFFF0,
    "khaki": 0xF0E68C,
    "lavender": 0xE6E6FA,
    "lavenderblush": 0xFFF0F5,
    "lawngreen": 0x7CFC00,
    "lemonchiffon": 0xFFFACD,
    "lightblue": 0xADD8E6,
    "lightcoral": 0xF08080,
    "lightcyan": 0xE0FFFF,
    "lightgoldenrodyellow": 0xFAFAD2,
    "lightgray": 0xD3D3D3,
    "lightgreen": 0x90EE90,
    "lightgrey": 0xD3D3D3,
    "lightpink": 0xFFB6C1,
    "lightsalmon": 0xFFA07A,
    "lightseagreen": 0x20B2AA,
    "lightskyblue": 0x87CEFA,
    "lightslategray": 0x778899,
    "lightslategrey": 0x778899,
    "lightsteelblue": 0xB0C4DE,
    "lightyellow": 0xFFFFE0,
    "lime": 0x00FF00,
    "limegreen": 0x32CD32,
    "linen": 0xFAF0E6,
    "magenta": 0xFF00FF,
    "maroon": 0x800000,
    "mediumaquamarine": 0x66CDAA,
    "mediumblue": 0x0000CD,
    "mediumorchid": 0xBA55D3,
    "mediumpurple": 0x9370DB,
    "mediumseagreen": 0x3CB371,
    "mediumslateblue": 0x7B68EE,
    "mediumspringgreen": 0x00FA9A,
    "mediumturquoise": 0x48D1CC,
    "mediumvioletred": 0xC71585,
    "midnightblue": 0x191970,
    "mintcream": 0xF5FFFA,
    "mistyrose": 0xFFE4E1,
    "moccasin": 0xFFE4B5,
    "navajowhite": 0xFFDEAD,
    "navy": 0x000080,
    "oldlace": 0xFDF5E6,
    "olive": 0x808000,
    "olivedrab": 0x6B8E23,
    "orange": 0xFFA500,
    "orangered": 0xFF4500,
    "orchid": 0xDA70D6,
    "palegoldenrod": 0xEEE8AA,
    "palegreen": 0x98FB98,
    "paleturquoise": 0xAFEEEE,
    "palevioletred": 0xDB7093,
    "papayawhip": 0xFFEFD5,
    "peachpuff": 0xFFDAB9,
    "peru": 0xCD853F,
    "pink": 0xFFC0CB,
    "plum": 0xDDA0DD,
    "powderblue": 0xB0E0E6,
    "purple": 0x800080,
    "rebeccapurple": 0x663399,
    "red": 0xFF0000,
    "rosybrown": 0xBC8F8F,
    "royalblue": 0x4169E1,
    "saddlebrown": 0x8B4513,
    "salmon": 0xFA8072,
    "sandybrown": 0xF4A460,
    "seagreen": 0x2E8B57,
    "seashell": 0xFFF5EE,
    "sienna": 0xA0522D,
    "silver": 0xC0C0C0,
    "skyblue": 0x87CEEB,
    "slateblue": 0x6A5ACD,
    "slategray": 0x708090,
    "slategrey": 0x708090,
    "snow": 0xFFFAFA,
    "springgreen": 0x00FF7F,
    "steelblue": 0x4682B4,
    "tan": 0xD2B48C,
    "teal": 0x008080,
    "thistle": 0xD8BFD8,
    "tomato": 0xFF6347,
    "turquoise": 0x40E0D0,
    "violet": 0xEE82EE,
    "wheat": 0xF5DEB3,
    "white": 0xFFFFFF,
    "whitesmoke": 0xF5F5F5,
    "yellow": 0xFFFF00,
    "yellowgreen": 0x9ACD32
};
const $9014d97cd777be10$var$_hslA = {
    h: 0,
    s: 0,
    l: 0
};
const $9014d97cd777be10$var$_hslB = {
    h: 0,
    s: 0,
    l: 0
};
function $9014d97cd777be10$var$hue2rgb(p, q, t) {
    if (t < 0) t += 1;
    if (t > 1) t -= 1;
    if (t < 1 / 6) return p + (q - p) * 6 * t;
    if (t < 0.5) return q;
    if (t < 2 / 3) return p + (q - p) * 6 * (2 / 3 - t);
    return p;
}
class $9014d97cd777be10$export$892596cec99bc70e {
    set(r, g, b) {
        if (g === undefined && b === undefined) {
            // r is THREE.Color, hex or string
            const value = r;
            if (value && value.isColor) this.copy(value);
            else if (typeof value === "number") this.setHex(value);
            else if (typeof value === "string") this.setStyle(value);
        } else this.setRGB(r, g, b);
        return this;
    }
    setScalar(scalar) {
        this.r = scalar;
        this.g = scalar;
        this.b = scalar;
        return this;
    }
    setHex(hex, colorSpace1 = $9014d97cd777be10$export$561f394b24edfcaa) {
        hex = Math.floor(hex);
        this.r = (hex >> 16 & 255) / 255;
        this.g = (hex >> 8 & 255) / 255;
        this.b = (hex & 255) / 255;
        $9014d97cd777be10$export$5e6fd513f44698c.toWorkingColorSpace(this, colorSpace1);
        return this;
    }
    setRGB(r, g, b, colorSpace1 = $9014d97cd777be10$export$5e6fd513f44698c.workingColorSpace) {
        this.r = r;
        this.g = g;
        this.b = b;
        $9014d97cd777be10$export$5e6fd513f44698c.toWorkingColorSpace(this, colorSpace1);
        return this;
    }
    setHSL(h, s, l, colorSpace1 = $9014d97cd777be10$export$5e6fd513f44698c.workingColorSpace) {
        // h,s,l ranges are in 0.0 - 1.0
        h = $9014d97cd777be10$var$euclideanModulo(h, 1);
        s = $9014d97cd777be10$var$clamp(s, 0, 1);
        l = $9014d97cd777be10$var$clamp(l, 0, 1);
        if (s === 0) this.r = this.g = this.b = l;
        else {
            const p = l <= 0.5 ? l * (1 + s) : l + s - l * s;
            const q = 2 * l - p;
            this.r = $9014d97cd777be10$var$hue2rgb(q, p, h + 1 / 3);
            this.g = $9014d97cd777be10$var$hue2rgb(q, p, h);
            this.b = $9014d97cd777be10$var$hue2rgb(q, p, h - 1 / 3);
        }
        $9014d97cd777be10$export$5e6fd513f44698c.toWorkingColorSpace(this, colorSpace1);
        return this;
    }
    setStyle(style, colorSpace1 = $9014d97cd777be10$export$561f394b24edfcaa) {
        function handleAlpha(string) {
            if (string === undefined) return;
            if (parseFloat(string) < 1) console.warn("THREE.Color: Alpha component of " + style + " will be ignored.");
        }
        let m;
        if (m = /^(\w+)\(([^\)]*)\)/.exec(style)) {
            // rgb / hsl
            let color;
            const name = m[1];
            const components = m[2];
            switch(name){
                case "rgb":
                case "rgba":
                    if (color = /^\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*(?:,\s*(\d*\.?\d+)\s*)?$/.exec(components)) {
                        // rgb(255,0,0) rgba(255,0,0,0.5)
                        handleAlpha(color[4]);
                        return this.setRGB(Math.min(255, parseInt(color[1], 10)) / 255, Math.min(255, parseInt(color[2], 10)) / 255, Math.min(255, parseInt(color[3], 10)) / 255, colorSpace1);
                    }
                    if (color = /^\s*(\d+)\%\s*,\s*(\d+)\%\s*,\s*(\d+)\%\s*(?:,\s*(\d*\.?\d+)\s*)?$/.exec(components)) {
                        // rgb(100%,0%,0%) rgba(100%,0%,0%,0.5)
                        handleAlpha(color[4]);
                        return this.setRGB(Math.min(100, parseInt(color[1], 10)) / 100, Math.min(100, parseInt(color[2], 10)) / 100, Math.min(100, parseInt(color[3], 10)) / 100, colorSpace1);
                    }
                    break;
                case "hsl":
                case "hsla":
                    if (color = /^\s*(\d*\.?\d+)\s*,\s*(\d*\.?\d+)\%\s*,\s*(\d*\.?\d+)\%\s*(?:,\s*(\d*\.?\d+)\s*)?$/.exec(components)) {
                        // hsl(120,50%,50%) hsla(120,50%,50%,0.5)
                        handleAlpha(color[4]);
                        return this.setHSL(parseFloat(color[1]) / 360, parseFloat(color[2]) / 100, parseFloat(color[3]) / 100, colorSpace1);
                    }
                    break;
                default:
                    console.warn("THREE.Color: Unknown color model " + style);
            }
        } else if (m = /^\#([A-Fa-f\d]+)$/.exec(style)) {
            // hex color
            const hex = m[1];
            const size = hex.length;
            if (size === 3) // #ff0
            return this.setRGB(parseInt(hex.charAt(0), 16) / 15, parseInt(hex.charAt(1), 16) / 15, parseInt(hex.charAt(2), 16) / 15, colorSpace1);
            else if (size === 6) // #ff0000
            return this.setHex(parseInt(hex, 16), colorSpace1);
            else console.warn("THREE.Color: Invalid hex color " + style);
        } else if (style && style.length > 0) return this.setColorName(style, colorSpace1);
        return this;
    }
    setColorName(style, colorSpace1 = $9014d97cd777be10$export$561f394b24edfcaa) {
        // color keywords
        const hex = $9014d97cd777be10$var$_colorKeywords[style.toLowerCase()];
        if (hex !== undefined) // red
        this.setHex(hex, colorSpace1);
        else // unknown color
        console.warn("THREE.Color: Unknown color " + style);
        return this;
    }
    clone() {
        return new this.constructor(this.r, this.g, this.b);
    }
    copy(color) {
        this.r = color.r;
        this.g = color.g;
        this.b = color.b;
        return this;
    }
    copySRGBToLinear(color) {
        this.r = $9014d97cd777be10$var$SRGBToLinear(color.r);
        this.g = $9014d97cd777be10$var$SRGBToLinear(color.g);
        this.b = $9014d97cd777be10$var$SRGBToLinear(color.b);
        return this;
    }
    copyLinearToSRGB(color) {
        this.r = $9014d97cd777be10$var$LinearToSRGB(color.r);
        this.g = $9014d97cd777be10$var$LinearToSRGB(color.g);
        this.b = $9014d97cd777be10$var$LinearToSRGB(color.b);
        return this;
    }
    convertSRGBToLinear() {
        this.copySRGBToLinear(this);
        return this;
    }
    convertLinearToSRGB() {
        this.copyLinearToSRGB(this);
        return this;
    }
    getHex(colorSpace1 = $9014d97cd777be10$export$561f394b24edfcaa) {
        $9014d97cd777be10$export$5e6fd513f44698c.fromWorkingColorSpace($9014d97cd777be10$var$_color.copy(this), colorSpace1);
        return Math.round($9014d97cd777be10$var$clamp($9014d97cd777be10$var$_color.r * 255, 0, 255)) * 65536 + Math.round($9014d97cd777be10$var$clamp($9014d97cd777be10$var$_color.g * 255, 0, 255)) * 256 + Math.round($9014d97cd777be10$var$clamp($9014d97cd777be10$var$_color.b * 255, 0, 255));
    }
    getHexString(colorSpace1 = $9014d97cd777be10$export$561f394b24edfcaa) {
        return ("000000" + this.getHex(colorSpace1).toString(16)).slice(-6);
    }
    getHSL(target, colorSpace1 = $9014d97cd777be10$export$5e6fd513f44698c.workingColorSpace) {
        // h,s,l ranges are in 0.0 - 1.0
        $9014d97cd777be10$export$5e6fd513f44698c.fromWorkingColorSpace($9014d97cd777be10$var$_color.copy(this), colorSpace1);
        const r = $9014d97cd777be10$var$_color.r, g = $9014d97cd777be10$var$_color.g, b = $9014d97cd777be10$var$_color.b;
        const max = Math.max(r, g, b);
        const min = Math.min(r, g, b);
        let hue, saturation;
        const lightness = (min + max) / 2.0;
        if (min === max) {
            hue = 0;
            saturation = 0;
        } else {
            const delta = max - min;
            saturation = lightness <= 0.5 ? delta / (max + min) : delta / (2 - max - min);
            switch(max){
                case r:
                    hue = (g - b) / delta + (g < b ? 6 : 0);
                    break;
                case g:
                    hue = (b - r) / delta + 2;
                    break;
                case b:
                    hue = (r - g) / delta + 4;
                    break;
            }
            hue /= 6;
        }
        target.h = hue;
        target.s = saturation;
        target.l = lightness;
        return target;
    }
    getRGB(target, colorSpace1 = $9014d97cd777be10$export$5e6fd513f44698c.workingColorSpace) {
        $9014d97cd777be10$export$5e6fd513f44698c.fromWorkingColorSpace($9014d97cd777be10$var$_color.copy(this), colorSpace1);
        target.r = $9014d97cd777be10$var$_color.r;
        target.g = $9014d97cd777be10$var$_color.g;
        target.b = $9014d97cd777be10$var$_color.b;
        return target;
    }
    getStyle(colorSpace1 = $9014d97cd777be10$export$561f394b24edfcaa) {
        $9014d97cd777be10$export$5e6fd513f44698c.fromWorkingColorSpace($9014d97cd777be10$var$_color.copy(this), colorSpace1);
        const r = $9014d97cd777be10$var$_color.r, g = $9014d97cd777be10$var$_color.g, b = $9014d97cd777be10$var$_color.b;
        if (colorSpace1 !== $9014d97cd777be10$export$561f394b24edfcaa) // Requires CSS Color Module Level 4 (https://www.w3.org/TR/css-color-4/).
        return `color(${colorSpace1} ${r.toFixed(3)} ${g.toFixed(3)} ${b.toFixed(3)})`;
        return `rgb(${Math.round(r * 255)},${Math.round(g * 255)},${Math.round(b * 255)})`;
    }
    offsetHSL(h, s, l) {
        this.getHSL($9014d97cd777be10$var$_hslA);
        $9014d97cd777be10$var$_hslA.h += h;
        $9014d97cd777be10$var$_hslA.s += s;
        $9014d97cd777be10$var$_hslA.l += l;
        this.setHSL($9014d97cd777be10$var$_hslA.h, $9014d97cd777be10$var$_hslA.s, $9014d97cd777be10$var$_hslA.l);
        return this;
    }
    add(color) {
        this.r += color.r;
        this.g += color.g;
        this.b += color.b;
        return this;
    }
    addColors(color1, color2) {
        this.r = color1.r + color2.r;
        this.g = color1.g + color2.g;
        this.b = color1.b + color2.b;
        return this;
    }
    addScalar(s) {
        this.r += s;
        this.g += s;
        this.b += s;
        return this;
    }
    sub(color) {
        this.r = Math.max(0, this.r - color.r);
        this.g = Math.max(0, this.g - color.g);
        this.b = Math.max(0, this.b - color.b);
        return this;
    }
    multiply(color) {
        this.r *= color.r;
        this.g *= color.g;
        this.b *= color.b;
        return this;
    }
    multiplyScalar(s) {
        this.r *= s;
        this.g *= s;
        this.b *= s;
        return this;
    }
    lerp(color, alpha) {
        this.r += (color.r - this.r) * alpha;
        this.g += (color.g - this.g) * alpha;
        this.b += (color.b - this.b) * alpha;
        return this;
    }
    lerpColors(color1, color2, alpha) {
        this.r = color1.r + (color2.r - color1.r) * alpha;
        this.g = color1.g + (color2.g - color1.g) * alpha;
        this.b = color1.b + (color2.b - color1.b) * alpha;
        return this;
    }
    lerpHSL(color, alpha) {
        this.getHSL($9014d97cd777be10$var$_hslA);
        color.getHSL($9014d97cd777be10$var$_hslB);
        const h = $9014d97cd777be10$var$lerp($9014d97cd777be10$var$_hslA.h, $9014d97cd777be10$var$_hslB.h, alpha);
        const s = $9014d97cd777be10$var$lerp($9014d97cd777be10$var$_hslA.s, $9014d97cd777be10$var$_hslB.s, alpha);
        const l = $9014d97cd777be10$var$lerp($9014d97cd777be10$var$_hslA.l, $9014d97cd777be10$var$_hslB.l, alpha);
        this.setHSL(h, s, l);
        return this;
    }
    setFromVector3(v) {
        this.r = v.x;
        this.g = v.y;
        this.b = v.z;
        return this;
    }
    applyMatrix3(m) {
        const r = this.r, g = this.g, b = this.b;
        const e = m.elements;
        this.r = e[0] * r + e[3] * g + e[6] * b;
        this.g = e[1] * r + e[4] * g + e[7] * b;
        this.b = e[2] * r + e[5] * g + e[8] * b;
        return this;
    }
    equals(c) {
        return c.r === this.r && c.g === this.g && c.b === this.b;
    }
    fromArray(array, offset = 0) {
        this.r = array[offset];
        this.g = array[offset + 1];
        this.b = array[offset + 2];
        return this;
    }
    toArray(array = [], offset = 0) {
        array[offset] = this.r;
        array[offset + 1] = this.g;
        array[offset + 2] = this.b;
        return array;
    }
    fromBufferAttribute(attribute, index) {
        this.r = attribute.getX(index);
        this.g = attribute.getY(index);
        this.b = attribute.getZ(index);
        return this;
    }
    toJSON() {
        return this.getHex();
    }
    *[Symbol.iterator]() {
        yield this.r;
        yield this.g;
        yield this.b;
    }
    constructor(r, g, b){
        this.isColor = true;
        this.r = 1;
        this.g = 1;
        this.b = 1;
        return this.set(r, g, b);
    }
}
const $9014d97cd777be10$var$_color = /*@__PURE__*/ new $9014d97cd777be10$export$892596cec99bc70e();
$9014d97cd777be10$export$892596cec99bc70e.NAMES = $9014d97cd777be10$var$_colorKeywords;
class $9014d97cd777be10$export$55cbcc9b622fe1f5 extends $9014d97cd777be10$export$a2d8b23205c25948 {
    copy(source) {
        super.copy(source);
        this.color.copy(source.color);
        this.map = source.map;
        this.lightMap = source.lightMap;
        this.lightMapIntensity = source.lightMapIntensity;
        this.aoMap = source.aoMap;
        this.aoMapIntensity = source.aoMapIntensity;
        this.specularMap = source.specularMap;
        this.alphaMap = source.alphaMap;
        this.envMap = source.envMap;
        this.combine = source.combine;
        this.reflectivity = source.reflectivity;
        this.refractionRatio = source.refractionRatio;
        this.wireframe = source.wireframe;
        this.wireframeLinewidth = source.wireframeLinewidth;
        this.wireframeLinecap = source.wireframeLinecap;
        this.wireframeLinejoin = source.wireframeLinejoin;
        this.fog = source.fog;
        return this;
    }
    constructor(parameters){
        super();
        this.isMeshBasicMaterial = true;
        this.type = "MeshBasicMaterial";
        this.color = new $9014d97cd777be10$export$892596cec99bc70e(0xffffff); // emissive
        this.map = null;
        this.lightMap = null;
        this.lightMapIntensity = 1.0;
        this.aoMap = null;
        this.aoMapIntensity = 1.0;
        this.specularMap = null;
        this.alphaMap = null;
        this.envMap = null;
        this.combine = $9014d97cd777be10$export$e50ac29801f1774d;
        this.reflectivity = 1;
        this.refractionRatio = 0.98;
        this.wireframe = false;
        this.wireframeLinewidth = 1;
        this.wireframeLinecap = "round";
        this.wireframeLinejoin = "round";
        this.fog = true;
        this.setValues(parameters);
    }
}
// Fast Half Float Conversions, http://www.fox-toolkit.org/ftp/fasthalffloatconversion.pdf
const $9014d97cd777be10$var$_tables = /*@__PURE__*/ $9014d97cd777be10$var$_generateTables();
function $9014d97cd777be10$var$_generateTables() {
    // float32 to float16 helpers
    const buffer = new ArrayBuffer(4);
    const floatView = new Float32Array(buffer);
    const uint32View = new Uint32Array(buffer);
    const baseTable = new Uint32Array(512);
    const shiftTable = new Uint32Array(512);
    for(let i = 0; i < 256; ++i){
        const e = i - 127;
        // very small number (0, -0)
        if (e < -27) {
            baseTable[i] = 0x0000;
            baseTable[i | 0x100] = 0x8000;
            shiftTable[i] = 24;
            shiftTable[i | 0x100] = 24;
        // small number (denorm)
        } else if (e < -14) {
            baseTable[i] = 0x0400 >> -e - 14;
            baseTable[i | 0x100] = 0x0400 >> -e - 14 | 0x8000;
            shiftTable[i] = -e - 1;
            shiftTable[i | 0x100] = -e - 1;
        // normal number
        } else if (e <= 15) {
            baseTable[i] = e + 15 << 10;
            baseTable[i | 0x100] = e + 15 << 10 | 0x8000;
            shiftTable[i] = 13;
            shiftTable[i | 0x100] = 13;
        // large number (Infinity, -Infinity)
        } else if (e < 128) {
            baseTable[i] = 0x7c00;
            baseTable[i | 0x100] = 0xfc00;
            shiftTable[i] = 24;
            shiftTable[i | 0x100] = 24;
        // stay (NaN, Infinity, -Infinity)
        } else {
            baseTable[i] = 0x7c00;
            baseTable[i | 0x100] = 0xfc00;
            shiftTable[i] = 13;
            shiftTable[i | 0x100] = 13;
        }
    }
    // float16 to float32 helpers
    const mantissaTable = new Uint32Array(2048);
    const exponentTable = new Uint32Array(64);
    const offsetTable = new Uint32Array(64);
    for(let i = 1; i < 1024; ++i){
        let m = i << 13; // zero pad mantissa bits
        let e = 0; // zero exponent
        // normalized
        while((m & 0x00800000) === 0){
            m <<= 1;
            e -= 0x00800000; // decrement exponent
        }
        m &= -8388609; // clear leading 1 bit
        e += 0x38800000; // adjust bias
        mantissaTable[i] = m | e;
    }
    for(let i = 1024; i < 2048; ++i)mantissaTable[i] = 0x38000000 + (i - 1024 << 13);
    for(let i = 1; i < 31; ++i)exponentTable[i] = i << 23;
    exponentTable[31] = 0x47800000;
    exponentTable[32] = 0x80000000;
    for(let i = 33; i < 63; ++i)exponentTable[i] = 0x80000000 + (i - 32 << 23);
    exponentTable[63] = 0xc7800000;
    for(let i = 1; i < 64; ++i)if (i !== 32) offsetTable[i] = 1024;
    return {
        floatView: floatView,
        uint32View: uint32View,
        baseTable: baseTable,
        shiftTable: shiftTable,
        mantissaTable: mantissaTable,
        exponentTable: exponentTable,
        offsetTable: offsetTable
    };
}
// float32 to float16
function $9014d97cd777be10$var$toHalfFloat(val) {
    if (Math.abs(val) > 65504) console.warn("THREE.DataUtils.toHalfFloat(): Value out of range.");
    val = $9014d97cd777be10$var$clamp(val, -65504, 65504);
    $9014d97cd777be10$var$_tables.floatView[0] = val;
    const f = $9014d97cd777be10$var$_tables.uint32View[0];
    const e = f >> 23 & 0x1ff;
    return $9014d97cd777be10$var$_tables.baseTable[e] + ((f & 0x007fffff) >> $9014d97cd777be10$var$_tables.shiftTable[e]);
}
// float16 to float32
function $9014d97cd777be10$var$fromHalfFloat(val) {
    const m = val >> 10;
    $9014d97cd777be10$var$_tables.uint32View[0] = $9014d97cd777be10$var$_tables.mantissaTable[$9014d97cd777be10$var$_tables.offsetTable[m] + (val & 0x3ff)] + $9014d97cd777be10$var$_tables.exponentTable[m];
    return $9014d97cd777be10$var$_tables.floatView[0];
}
const $9014d97cd777be10$export$11ce8b759162cc80 = {
    toHalfFloat: $9014d97cd777be10$var$toHalfFloat,
    fromHalfFloat: $9014d97cd777be10$var$fromHalfFloat
};
const $9014d97cd777be10$var$_vector$8 = /*@__PURE__*/ new $9014d97cd777be10$export$64b5c384219d3699();
const $9014d97cd777be10$var$_vector2$1 = /*@__PURE__*/ new $9014d97cd777be10$export$c977b3e384af9ae1();
class $9014d97cd777be10$export$8dea267bd6bde117 {
    onUploadCallback() {}
    set needsUpdate(value) {
        if (value === true) this.version++;
    }
    setUsage(value) {
        this.usage = value;
        return this;
    }
    copy(source) {
        this.name = source.name;
        this.array = new source.array.constructor(source.array);
        this.itemSize = source.itemSize;
        this.count = source.count;
        this.normalized = source.normalized;
        this.usage = source.usage;
        this.gpuType = source.gpuType;
        return this;
    }
    copyAt(index1, attribute, index2) {
        index1 *= this.itemSize;
        index2 *= attribute.itemSize;
        for(let i = 0, l = this.itemSize; i < l; i++)this.array[index1 + i] = attribute.array[index2 + i];
        return this;
    }
    copyArray(array) {
        this.array.set(array);
        return this;
    }
    applyMatrix3(m) {
        if (this.itemSize === 2) for(let i = 0, l = this.count; i < l; i++){
            $9014d97cd777be10$var$_vector2$1.fromBufferAttribute(this, i);
            $9014d97cd777be10$var$_vector2$1.applyMatrix3(m);
            this.setXY(i, $9014d97cd777be10$var$_vector2$1.x, $9014d97cd777be10$var$_vector2$1.y);
        }
        else if (this.itemSize === 3) for(let i = 0, l = this.count; i < l; i++){
            $9014d97cd777be10$var$_vector$8.fromBufferAttribute(this, i);
            $9014d97cd777be10$var$_vector$8.applyMatrix3(m);
            this.setXYZ(i, $9014d97cd777be10$var$_vector$8.x, $9014d97cd777be10$var$_vector$8.y, $9014d97cd777be10$var$_vector$8.z);
        }
        return this;
    }
    applyMatrix4(m) {
        for(let i = 0, l = this.count; i < l; i++){
            $9014d97cd777be10$var$_vector$8.fromBufferAttribute(this, i);
            $9014d97cd777be10$var$_vector$8.applyMatrix4(m);
            this.setXYZ(i, $9014d97cd777be10$var$_vector$8.x, $9014d97cd777be10$var$_vector$8.y, $9014d97cd777be10$var$_vector$8.z);
        }
        return this;
    }
    applyNormalMatrix(m) {
        for(let i = 0, l = this.count; i < l; i++){
            $9014d97cd777be10$var$_vector$8.fromBufferAttribute(this, i);
            $9014d97cd777be10$var$_vector$8.applyNormalMatrix(m);
            this.setXYZ(i, $9014d97cd777be10$var$_vector$8.x, $9014d97cd777be10$var$_vector$8.y, $9014d97cd777be10$var$_vector$8.z);
        }
        return this;
    }
    transformDirection(m) {
        for(let i = 0, l = this.count; i < l; i++){
            $9014d97cd777be10$var$_vector$8.fromBufferAttribute(this, i);
            $9014d97cd777be10$var$_vector$8.transformDirection(m);
            this.setXYZ(i, $9014d97cd777be10$var$_vector$8.x, $9014d97cd777be10$var$_vector$8.y, $9014d97cd777be10$var$_vector$8.z);
        }
        return this;
    }
    set(value, offset = 0) {
        // Matching BufferAttribute constructor, do not normalize the array.
        this.array.set(value, offset);
        return this;
    }
    getComponent(index, component) {
        let value = this.array[index * this.itemSize + component];
        if (this.normalized) value = $9014d97cd777be10$var$denormalize(value, this.array);
        return value;
    }
    setComponent(index, component, value) {
        if (this.normalized) value = $9014d97cd777be10$var$normalize(value, this.array);
        this.array[index * this.itemSize + component] = value;
        return this;
    }
    getX(index) {
        let x = this.array[index * this.itemSize];
        if (this.normalized) x = $9014d97cd777be10$var$denormalize(x, this.array);
        return x;
    }
    setX(index, x) {
        if (this.normalized) x = $9014d97cd777be10$var$normalize(x, this.array);
        this.array[index * this.itemSize] = x;
        return this;
    }
    getY(index) {
        let y = this.array[index * this.itemSize + 1];
        if (this.normalized) y = $9014d97cd777be10$var$denormalize(y, this.array);
        return y;
    }
    setY(index, y) {
        if (this.normalized) y = $9014d97cd777be10$var$normalize(y, this.array);
        this.array[index * this.itemSize + 1] = y;
        return this;
    }
    getZ(index) {
        let z = this.array[index * this.itemSize + 2];
        if (this.normalized) z = $9014d97cd777be10$var$denormalize(z, this.array);
        return z;
    }
    setZ(index, z) {
        if (this.normalized) z = $9014d97cd777be10$var$normalize(z, this.array);
        this.array[index * this.itemSize + 2] = z;
        return this;
    }
    getW(index) {
        let w = this.array[index * this.itemSize + 3];
        if (this.normalized) w = $9014d97cd777be10$var$denormalize(w, this.array);
        return w;
    }
    setW(index, w) {
        if (this.normalized) w = $9014d97cd777be10$var$normalize(w, this.array);
        this.array[index * this.itemSize + 3] = w;
        return this;
    }
    setXY(index, x, y) {
        index *= this.itemSize;
        if (this.normalized) {
            x = $9014d97cd777be10$var$normalize(x, this.array);
            y = $9014d97cd777be10$var$normalize(y, this.array);
        }
        this.array[index + 0] = x;
        this.array[index + 1] = y;
        return this;
    }
    setXYZ(index, x, y, z) {
        index *= this.itemSize;
        if (this.normalized) {
            x = $9014d97cd777be10$var$normalize(x, this.array);
            y = $9014d97cd777be10$var$normalize(y, this.array);
            z = $9014d97cd777be10$var$normalize(z, this.array);
        }
        this.array[index + 0] = x;
        this.array[index + 1] = y;
        this.array[index + 2] = z;
        return this;
    }
    setXYZW(index, x, y, z, w) {
        index *= this.itemSize;
        if (this.normalized) {
            x = $9014d97cd777be10$var$normalize(x, this.array);
            y = $9014d97cd777be10$var$normalize(y, this.array);
            z = $9014d97cd777be10$var$normalize(z, this.array);
            w = $9014d97cd777be10$var$normalize(w, this.array);
        }
        this.array[index + 0] = x;
        this.array[index + 1] = y;
        this.array[index + 2] = z;
        this.array[index + 3] = w;
        return this;
    }
    onUpload(callback) {
        this.onUploadCallback = callback;
        return this;
    }
    clone() {
        return new this.constructor(this.array, this.itemSize).copy(this);
    }
    toJSON() {
        const data = {
            itemSize: this.itemSize,
            type: this.array.constructor.name,
            array: Array.from(this.array),
            normalized: this.normalized
        };
        if (this.name !== "") data.name = this.name;
        if (this.usage !== $9014d97cd777be10$export$763e8360f4d7f77d) data.usage = this.usage;
        if (this.updateRange.offset !== 0 || this.updateRange.count !== -1) data.updateRange = this.updateRange;
        return data;
    }
    constructor(array, itemSize, normalized = false){
        if (Array.isArray(array)) throw new TypeError("THREE.BufferAttribute: array should be a Typed Array.");
        this.isBufferAttribute = true;
        this.name = "";
        this.array = array;
        this.itemSize = itemSize;
        this.count = array !== undefined ? array.length / itemSize : 0;
        this.normalized = normalized;
        this.usage = $9014d97cd777be10$export$763e8360f4d7f77d;
        this.updateRange = {
            offset: 0,
            count: -1
        };
        this.gpuType = $9014d97cd777be10$export$f6d331659b644596;
        this.version = 0;
    }
}
//
class $9014d97cd777be10$export$f9ff2d6a20248cbf extends $9014d97cd777be10$export$8dea267bd6bde117 {
    constructor(array, itemSize, normalized){
        super(new Int8Array(array), itemSize, normalized);
    }
}
class $9014d97cd777be10$export$cacc90cf35d11cdd extends $9014d97cd777be10$export$8dea267bd6bde117 {
    constructor(array, itemSize, normalized){
        super(new Uint8Array(array), itemSize, normalized);
    }
}
class $9014d97cd777be10$export$baaa85a1a812c157 extends $9014d97cd777be10$export$8dea267bd6bde117 {
    constructor(array, itemSize, normalized){
        super(new Uint8ClampedArray(array), itemSize, normalized);
    }
}
class $9014d97cd777be10$export$2b755a102ccdcefe extends $9014d97cd777be10$export$8dea267bd6bde117 {
    constructor(array, itemSize, normalized){
        super(new Int16Array(array), itemSize, normalized);
    }
}
class $9014d97cd777be10$export$640a853f68025f2e extends $9014d97cd777be10$export$8dea267bd6bde117 {
    constructor(array, itemSize, normalized){
        super(new Uint16Array(array), itemSize, normalized);
    }
}
class $9014d97cd777be10$export$46b369aed2968a0a extends $9014d97cd777be10$export$8dea267bd6bde117 {
    constructor(array, itemSize, normalized){
        super(new Int32Array(array), itemSize, normalized);
    }
}
class $9014d97cd777be10$export$7eb8c9fa25cd5bd6 extends $9014d97cd777be10$export$8dea267bd6bde117 {
    constructor(array, itemSize, normalized){
        super(new Uint32Array(array), itemSize, normalized);
    }
}
class $9014d97cd777be10$export$dbd3698c64958d69 extends $9014d97cd777be10$export$8dea267bd6bde117 {
    getX(index) {
        let x = $9014d97cd777be10$var$fromHalfFloat(this.array[index * this.itemSize]);
        if (this.normalized) x = $9014d97cd777be10$var$denormalize(x, this.array);
        return x;
    }
    setX(index, x) {
        if (this.normalized) x = $9014d97cd777be10$var$normalize(x, this.array);
        this.array[index * this.itemSize] = $9014d97cd777be10$var$toHalfFloat(x);
        return this;
    }
    getY(index) {
        let y = $9014d97cd777be10$var$fromHalfFloat(this.array[index * this.itemSize + 1]);
        if (this.normalized) y = $9014d97cd777be10$var$denormalize(y, this.array);
        return y;
    }
    setY(index, y) {
        if (this.normalized) y = $9014d97cd777be10$var$normalize(y, this.array);
        this.array[index * this.itemSize + 1] = $9014d97cd777be10$var$toHalfFloat(y);
        return this;
    }
    getZ(index) {
        let z = $9014d97cd777be10$var$fromHalfFloat(this.array[index * this.itemSize + 2]);
        if (this.normalized) z = $9014d97cd777be10$var$denormalize(z, this.array);
        return z;
    }
    setZ(index, z) {
        if (this.normalized) z = $9014d97cd777be10$var$normalize(z, this.array);
        this.array[index * this.itemSize + 2] = $9014d97cd777be10$var$toHalfFloat(z);
        return this;
    }
    getW(index) {
        let w = $9014d97cd777be10$var$fromHalfFloat(this.array[index * this.itemSize + 3]);
        if (this.normalized) w = $9014d97cd777be10$var$denormalize(w, this.array);
        return w;
    }
    setW(index, w) {
        if (this.normalized) w = $9014d97cd777be10$var$normalize(w, this.array);
        this.array[index * this.itemSize + 3] = $9014d97cd777be10$var$toHalfFloat(w);
        return this;
    }
    setXY(index, x, y) {
        index *= this.itemSize;
        if (this.normalized) {
            x = $9014d97cd777be10$var$normalize(x, this.array);
            y = $9014d97cd777be10$var$normalize(y, this.array);
        }
        this.array[index + 0] = $9014d97cd777be10$var$toHalfFloat(x);
        this.array[index + 1] = $9014d97cd777be10$var$toHalfFloat(y);
        return this;
    }
    setXYZ(index, x, y, z) {
        index *= this.itemSize;
        if (this.normalized) {
            x = $9014d97cd777be10$var$normalize(x, this.array);
            y = $9014d97cd777be10$var$normalize(y, this.array);
            z = $9014d97cd777be10$var$normalize(z, this.array);
        }
        this.array[index + 0] = $9014d97cd777be10$var$toHalfFloat(x);
        this.array[index + 1] = $9014d97cd777be10$var$toHalfFloat(y);
        this.array[index + 2] = $9014d97cd777be10$var$toHalfFloat(z);
        return this;
    }
    setXYZW(index, x, y, z, w) {
        index *= this.itemSize;
        if (this.normalized) {
            x = $9014d97cd777be10$var$normalize(x, this.array);
            y = $9014d97cd777be10$var$normalize(y, this.array);
            z = $9014d97cd777be10$var$normalize(z, this.array);
            w = $9014d97cd777be10$var$normalize(w, this.array);
        }
        this.array[index + 0] = $9014d97cd777be10$var$toHalfFloat(x);
        this.array[index + 1] = $9014d97cd777be10$var$toHalfFloat(y);
        this.array[index + 2] = $9014d97cd777be10$var$toHalfFloat(z);
        this.array[index + 3] = $9014d97cd777be10$var$toHalfFloat(w);
        return this;
    }
    constructor(array, itemSize, normalized){
        super(new Uint16Array(array), itemSize, normalized);
        this.isFloat16BufferAttribute = true;
    }
}
class $9014d97cd777be10$export$cbe7a62641830ebd extends $9014d97cd777be10$export$8dea267bd6bde117 {
    constructor(array, itemSize, normalized){
        super(new Float32Array(array), itemSize, normalized);
    }
}
class $9014d97cd777be10$export$9e0ade74842adbb8 extends $9014d97cd777be10$export$8dea267bd6bde117 {
    constructor(array, itemSize, normalized){
        super(new Float64Array(array), itemSize, normalized);
    }
}
let $9014d97cd777be10$var$_id$1 = 0;
const $9014d97cd777be10$var$_m1 = /*@__PURE__*/ new $9014d97cd777be10$export$2ae72fc923e5eb5();
const $9014d97cd777be10$var$_obj = /*@__PURE__*/ new $9014d97cd777be10$export$e4dd07dff30cc924();
const $9014d97cd777be10$var$_offset = /*@__PURE__*/ new $9014d97cd777be10$export$64b5c384219d3699();
const $9014d97cd777be10$var$_box$1 = /*@__PURE__*/ new $9014d97cd777be10$export$6f7d5a9418ab2aa3();
const $9014d97cd777be10$var$_boxMorphTargets = /*@__PURE__*/ new $9014d97cd777be10$export$6f7d5a9418ab2aa3();
const $9014d97cd777be10$var$_vector$7 = /*@__PURE__*/ new $9014d97cd777be10$export$64b5c384219d3699();
class $9014d97cd777be10$export$b7be63a67df8959 extends $9014d97cd777be10$export$ec8b666c5fe2c75a {
    getIndex() {
        return this.index;
    }
    setIndex(index) {
        if (Array.isArray(index)) this.index = new ($9014d97cd777be10$var$arrayNeedsUint32(index) ? $9014d97cd777be10$export$7eb8c9fa25cd5bd6 : $9014d97cd777be10$export$640a853f68025f2e)(index, 1);
        else this.index = index;
        return this;
    }
    getAttribute(name) {
        return this.attributes[name];
    }
    setAttribute(name, attribute) {
        this.attributes[name] = attribute;
        return this;
    }
    deleteAttribute(name) {
        delete this.attributes[name];
        return this;
    }
    hasAttribute(name) {
        return this.attributes[name] !== undefined;
    }
    addGroup(start, count, materialIndex = 0) {
        this.groups.push({
            start: start,
            count: count,
            materialIndex: materialIndex
        });
    }
    clearGroups() {
        this.groups = [];
    }
    setDrawRange(start, count) {
        this.drawRange.start = start;
        this.drawRange.count = count;
    }
    applyMatrix4(matrix) {
        const position = this.attributes.position;
        if (position !== undefined) {
            position.applyMatrix4(matrix);
            position.needsUpdate = true;
        }
        const normal = this.attributes.normal;
        if (normal !== undefined) {
            const normalMatrix = new $9014d97cd777be10$export$8ff26dafa08918().getNormalMatrix(matrix);
            normal.applyNormalMatrix(normalMatrix);
            normal.needsUpdate = true;
        }
        const tangent = this.attributes.tangent;
        if (tangent !== undefined) {
            tangent.transformDirection(matrix);
            tangent.needsUpdate = true;
        }
        if (this.boundingBox !== null) this.computeBoundingBox();
        if (this.boundingSphere !== null) this.computeBoundingSphere();
        return this;
    }
    applyQuaternion(q) {
        $9014d97cd777be10$var$_m1.makeRotationFromQuaternion(q);
        this.applyMatrix4($9014d97cd777be10$var$_m1);
        return this;
    }
    rotateX(angle) {
        // rotate geometry around world x-axis
        $9014d97cd777be10$var$_m1.makeRotationX(angle);
        this.applyMatrix4($9014d97cd777be10$var$_m1);
        return this;
    }
    rotateY(angle) {
        // rotate geometry around world y-axis
        $9014d97cd777be10$var$_m1.makeRotationY(angle);
        this.applyMatrix4($9014d97cd777be10$var$_m1);
        return this;
    }
    rotateZ(angle) {
        // rotate geometry around world z-axis
        $9014d97cd777be10$var$_m1.makeRotationZ(angle);
        this.applyMatrix4($9014d97cd777be10$var$_m1);
        return this;
    }
    translate(x, y, z) {
        // translate geometry
        $9014d97cd777be10$var$_m1.makeTranslation(x, y, z);
        this.applyMatrix4($9014d97cd777be10$var$_m1);
        return this;
    }
    scale(x, y, z) {
        // scale geometry
        $9014d97cd777be10$var$_m1.makeScale(x, y, z);
        this.applyMatrix4($9014d97cd777be10$var$_m1);
        return this;
    }
    lookAt(vector) {
        $9014d97cd777be10$var$_obj.lookAt(vector);
        $9014d97cd777be10$var$_obj.updateMatrix();
        this.applyMatrix4($9014d97cd777be10$var$_obj.matrix);
        return this;
    }
    center() {
        this.computeBoundingBox();
        this.boundingBox.getCenter($9014d97cd777be10$var$_offset).negate();
        this.translate($9014d97cd777be10$var$_offset.x, $9014d97cd777be10$var$_offset.y, $9014d97cd777be10$var$_offset.z);
        return this;
    }
    setFromPoints(points) {
        const position = [];
        for(let i = 0, l = points.length; i < l; i++){
            const point = points[i];
            position.push(point.x, point.y, point.z || 0);
        }
        this.setAttribute("position", new $9014d97cd777be10$export$cbe7a62641830ebd(position, 3));
        return this;
    }
    computeBoundingBox() {
        if (this.boundingBox === null) this.boundingBox = new $9014d97cd777be10$export$6f7d5a9418ab2aa3();
        const position = this.attributes.position;
        const morphAttributesPosition = this.morphAttributes.position;
        if (position && position.isGLBufferAttribute) {
            console.error('THREE.BufferGeometry.computeBoundingBox(): GLBufferAttribute requires a manual bounding box. Alternatively set "mesh.frustumCulled" to "false".', this);
            this.boundingBox.set(new $9014d97cd777be10$export$64b5c384219d3699(-Infinity, -Infinity, -Infinity), new $9014d97cd777be10$export$64b5c384219d3699(Infinity, Infinity, Infinity));
            return;
        }
        if (position !== undefined) {
            this.boundingBox.setFromBufferAttribute(position);
            // process morph attributes if present
            if (morphAttributesPosition) for(let i = 0, il = morphAttributesPosition.length; i < il; i++){
                const morphAttribute = morphAttributesPosition[i];
                $9014d97cd777be10$var$_box$1.setFromBufferAttribute(morphAttribute);
                if (this.morphTargetsRelative) {
                    $9014d97cd777be10$var$_vector$7.addVectors(this.boundingBox.min, $9014d97cd777be10$var$_box$1.min);
                    this.boundingBox.expandByPoint($9014d97cd777be10$var$_vector$7);
                    $9014d97cd777be10$var$_vector$7.addVectors(this.boundingBox.max, $9014d97cd777be10$var$_box$1.max);
                    this.boundingBox.expandByPoint($9014d97cd777be10$var$_vector$7);
                } else {
                    this.boundingBox.expandByPoint($9014d97cd777be10$var$_box$1.min);
                    this.boundingBox.expandByPoint($9014d97cd777be10$var$_box$1.max);
                }
            }
        } else this.boundingBox.makeEmpty();
        if (isNaN(this.boundingBox.min.x) || isNaN(this.boundingBox.min.y) || isNaN(this.boundingBox.min.z)) console.error('THREE.BufferGeometry.computeBoundingBox(): Computed min/max have NaN values. The "position" attribute is likely to have NaN values.', this);
    }
    computeBoundingSphere() {
        if (this.boundingSphere === null) this.boundingSphere = new $9014d97cd777be10$export$805e8b72413ccaba();
        const position = this.attributes.position;
        const morphAttributesPosition = this.morphAttributes.position;
        if (position && position.isGLBufferAttribute) {
            console.error('THREE.BufferGeometry.computeBoundingSphere(): GLBufferAttribute requires a manual bounding sphere. Alternatively set "mesh.frustumCulled" to "false".', this);
            this.boundingSphere.set(new $9014d97cd777be10$export$64b5c384219d3699(), Infinity);
            return;
        }
        if (position) {
            // first, find the center of the bounding sphere
            const center = this.boundingSphere.center;
            $9014d97cd777be10$var$_box$1.setFromBufferAttribute(position);
            // process morph attributes if present
            if (morphAttributesPosition) for(let i = 0, il = morphAttributesPosition.length; i < il; i++){
                const morphAttribute = morphAttributesPosition[i];
                $9014d97cd777be10$var$_boxMorphTargets.setFromBufferAttribute(morphAttribute);
                if (this.morphTargetsRelative) {
                    $9014d97cd777be10$var$_vector$7.addVectors($9014d97cd777be10$var$_box$1.min, $9014d97cd777be10$var$_boxMorphTargets.min);
                    $9014d97cd777be10$var$_box$1.expandByPoint($9014d97cd777be10$var$_vector$7);
                    $9014d97cd777be10$var$_vector$7.addVectors($9014d97cd777be10$var$_box$1.max, $9014d97cd777be10$var$_boxMorphTargets.max);
                    $9014d97cd777be10$var$_box$1.expandByPoint($9014d97cd777be10$var$_vector$7);
                } else {
                    $9014d97cd777be10$var$_box$1.expandByPoint($9014d97cd777be10$var$_boxMorphTargets.min);
                    $9014d97cd777be10$var$_box$1.expandByPoint($9014d97cd777be10$var$_boxMorphTargets.max);
                }
            }
            $9014d97cd777be10$var$_box$1.getCenter(center);
            // second, try to find a boundingSphere with a radius smaller than the
            // boundingSphere of the boundingBox: sqrt(3) smaller in the best case
            let maxRadiusSq = 0;
            for(let i = 0, il = position.count; i < il; i++){
                $9014d97cd777be10$var$_vector$7.fromBufferAttribute(position, i);
                maxRadiusSq = Math.max(maxRadiusSq, center.distanceToSquared($9014d97cd777be10$var$_vector$7));
            }
            // process morph attributes if present
            if (morphAttributesPosition) for(let i = 0, il = morphAttributesPosition.length; i < il; i++){
                const morphAttribute = morphAttributesPosition[i];
                const morphTargetsRelative = this.morphTargetsRelative;
                for(let j = 0, jl = morphAttribute.count; j < jl; j++){
                    $9014d97cd777be10$var$_vector$7.fromBufferAttribute(morphAttribute, j);
                    if (morphTargetsRelative) {
                        $9014d97cd777be10$var$_offset.fromBufferAttribute(position, j);
                        $9014d97cd777be10$var$_vector$7.add($9014d97cd777be10$var$_offset);
                    }
                    maxRadiusSq = Math.max(maxRadiusSq, center.distanceToSquared($9014d97cd777be10$var$_vector$7));
                }
            }
            this.boundingSphere.radius = Math.sqrt(maxRadiusSq);
            if (isNaN(this.boundingSphere.radius)) console.error('THREE.BufferGeometry.computeBoundingSphere(): Computed radius is NaN. The "position" attribute is likely to have NaN values.', this);
        }
    }
    computeTangents() {
        const index = this.index;
        const attributes = this.attributes;
        // based on http://www.terathon.com/code/tangent.html
        // (per vertex tangents)
        if (index === null || attributes.position === undefined || attributes.normal === undefined || attributes.uv === undefined) {
            console.error("THREE.BufferGeometry: .computeTangents() failed. Missing required attributes (index, position, normal or uv)");
            return;
        }
        const indices = index.array;
        const positions = attributes.position.array;
        const normals = attributes.normal.array;
        const uvs = attributes.uv.array;
        const nVertices = positions.length / 3;
        if (this.hasAttribute("tangent") === false) this.setAttribute("tangent", new $9014d97cd777be10$export$8dea267bd6bde117(new Float32Array(4 * nVertices), 4));
        const tangents = this.getAttribute("tangent").array;
        const tan1 = [], tan2 = [];
        for(let i = 0; i < nVertices; i++){
            tan1[i] = new $9014d97cd777be10$export$64b5c384219d3699();
            tan2[i] = new $9014d97cd777be10$export$64b5c384219d3699();
        }
        const vA = new $9014d97cd777be10$export$64b5c384219d3699(), vB = new $9014d97cd777be10$export$64b5c384219d3699(), vC = new $9014d97cd777be10$export$64b5c384219d3699(), uvA = new $9014d97cd777be10$export$c977b3e384af9ae1(), uvB = new $9014d97cd777be10$export$c977b3e384af9ae1(), uvC = new $9014d97cd777be10$export$c977b3e384af9ae1(), sdir = new $9014d97cd777be10$export$64b5c384219d3699(), tdir = new $9014d97cd777be10$export$64b5c384219d3699();
        function handleTriangle(a, b, c) {
            vA.fromArray(positions, a * 3);
            vB.fromArray(positions, b * 3);
            vC.fromArray(positions, c * 3);
            uvA.fromArray(uvs, a * 2);
            uvB.fromArray(uvs, b * 2);
            uvC.fromArray(uvs, c * 2);
            vB.sub(vA);
            vC.sub(vA);
            uvB.sub(uvA);
            uvC.sub(uvA);
            const r = 1.0 / (uvB.x * uvC.y - uvC.x * uvB.y);
            // silently ignore degenerate uv triangles having coincident or colinear vertices
            if (!isFinite(r)) return;
            sdir.copy(vB).multiplyScalar(uvC.y).addScaledVector(vC, -uvB.y).multiplyScalar(r);
            tdir.copy(vC).multiplyScalar(uvB.x).addScaledVector(vB, -uvC.x).multiplyScalar(r);
            tan1[a].add(sdir);
            tan1[b].add(sdir);
            tan1[c].add(sdir);
            tan2[a].add(tdir);
            tan2[b].add(tdir);
            tan2[c].add(tdir);
        }
        let groups = this.groups;
        if (groups.length === 0) groups = [
            {
                start: 0,
                count: indices.length
            }
        ];
        for(let i = 0, il = groups.length; i < il; ++i){
            const group = groups[i];
            const start = group.start;
            const count = group.count;
            for(let j = start, jl = start + count; j < jl; j += 3)handleTriangle(indices[j + 0], indices[j + 1], indices[j + 2]);
        }
        const tmp = new $9014d97cd777be10$export$64b5c384219d3699(), tmp2 = new $9014d97cd777be10$export$64b5c384219d3699();
        const n = new $9014d97cd777be10$export$64b5c384219d3699(), n2 = new $9014d97cd777be10$export$64b5c384219d3699();
        function handleVertex(v) {
            n.fromArray(normals, v * 3);
            n2.copy(n);
            const t = tan1[v];
            // Gram-Schmidt orthogonalize
            tmp.copy(t);
            tmp.sub(n.multiplyScalar(n.dot(t))).normalize();
            // Calculate handedness
            tmp2.crossVectors(n2, t);
            const test = tmp2.dot(tan2[v]);
            const w = test < 0.0 ? -1 : 1.0;
            tangents[v * 4] = tmp.x;
            tangents[v * 4 + 1] = tmp.y;
            tangents[v * 4 + 2] = tmp.z;
            tangents[v * 4 + 3] = w;
        }
        for(let i = 0, il = groups.length; i < il; ++i){
            const group = groups[i];
            const start = group.start;
            const count = group.count;
            for(let j = start, jl = start + count; j < jl; j += 3){
                handleVertex(indices[j + 0]);
                handleVertex(indices[j + 1]);
                handleVertex(indices[j + 2]);
            }
        }
    }
    computeVertexNormals() {
        const index = this.index;
        const positionAttribute = this.getAttribute("position");
        if (positionAttribute !== undefined) {
            let normalAttribute = this.getAttribute("normal");
            if (normalAttribute === undefined) {
                normalAttribute = new $9014d97cd777be10$export$8dea267bd6bde117(new Float32Array(positionAttribute.count * 3), 3);
                this.setAttribute("normal", normalAttribute);
            } else // reset existing normals to zero
            for(let i = 0, il = normalAttribute.count; i < il; i++)normalAttribute.setXYZ(i, 0, 0, 0);
            const pA = new $9014d97cd777be10$export$64b5c384219d3699(), pB = new $9014d97cd777be10$export$64b5c384219d3699(), pC = new $9014d97cd777be10$export$64b5c384219d3699();
            const nA = new $9014d97cd777be10$export$64b5c384219d3699(), nB = new $9014d97cd777be10$export$64b5c384219d3699(), nC = new $9014d97cd777be10$export$64b5c384219d3699();
            const cb = new $9014d97cd777be10$export$64b5c384219d3699(), ab = new $9014d97cd777be10$export$64b5c384219d3699();
            // indexed elements
            if (index) for(let i = 0, il = index.count; i < il; i += 3){
                const vA = index.getX(i + 0);
                const vB = index.getX(i + 1);
                const vC = index.getX(i + 2);
                pA.fromBufferAttribute(positionAttribute, vA);
                pB.fromBufferAttribute(positionAttribute, vB);
                pC.fromBufferAttribute(positionAttribute, vC);
                cb.subVectors(pC, pB);
                ab.subVectors(pA, pB);
                cb.cross(ab);
                nA.fromBufferAttribute(normalAttribute, vA);
                nB.fromBufferAttribute(normalAttribute, vB);
                nC.fromBufferAttribute(normalAttribute, vC);
                nA.add(cb);
                nB.add(cb);
                nC.add(cb);
                normalAttribute.setXYZ(vA, nA.x, nA.y, nA.z);
                normalAttribute.setXYZ(vB, nB.x, nB.y, nB.z);
                normalAttribute.setXYZ(vC, nC.x, nC.y, nC.z);
            }
            else // non-indexed elements (unconnected triangle soup)
            for(let i = 0, il = positionAttribute.count; i < il; i += 3){
                pA.fromBufferAttribute(positionAttribute, i + 0);
                pB.fromBufferAttribute(positionAttribute, i + 1);
                pC.fromBufferAttribute(positionAttribute, i + 2);
                cb.subVectors(pC, pB);
                ab.subVectors(pA, pB);
                cb.cross(ab);
                normalAttribute.setXYZ(i + 0, cb.x, cb.y, cb.z);
                normalAttribute.setXYZ(i + 1, cb.x, cb.y, cb.z);
                normalAttribute.setXYZ(i + 2, cb.x, cb.y, cb.z);
            }
            this.normalizeNormals();
            normalAttribute.needsUpdate = true;
        }
    }
    normalizeNormals() {
        const normals = this.attributes.normal;
        for(let i = 0, il = normals.count; i < il; i++){
            $9014d97cd777be10$var$_vector$7.fromBufferAttribute(normals, i);
            $9014d97cd777be10$var$_vector$7.normalize();
            normals.setXYZ(i, $9014d97cd777be10$var$_vector$7.x, $9014d97cd777be10$var$_vector$7.y, $9014d97cd777be10$var$_vector$7.z);
        }
    }
    toNonIndexed() {
        function convertBufferAttribute(attribute, indices) {
            const array = attribute.array;
            const itemSize = attribute.itemSize;
            const normalized = attribute.normalized;
            const array2 = new array.constructor(indices.length * itemSize);
            let index = 0, index2 = 0;
            for(let i = 0, l = indices.length; i < l; i++){
                if (attribute.isInterleavedBufferAttribute) index = indices[i] * attribute.data.stride + attribute.offset;
                else index = indices[i] * itemSize;
                for(let j = 0; j < itemSize; j++)array2[index2++] = array[index++];
            }
            return new $9014d97cd777be10$export$8dea267bd6bde117(array2, itemSize, normalized);
        }
        //
        if (this.index === null) {
            console.warn("THREE.BufferGeometry.toNonIndexed(): BufferGeometry is already non-indexed.");
            return this;
        }
        const geometry2 = new $9014d97cd777be10$export$b7be63a67df8959();
        const indices = this.index.array;
        const attributes = this.attributes;
        // attributes
        for(const name in attributes){
            const attribute = attributes[name];
            const newAttribute = convertBufferAttribute(attribute, indices);
            geometry2.setAttribute(name, newAttribute);
        }
        // morph attributes
        const morphAttributes = this.morphAttributes;
        for(const name in morphAttributes){
            const morphArray = [];
            const morphAttribute = morphAttributes[name]; // morphAttribute: array of Float32BufferAttributes
            for(let i = 0, il = morphAttribute.length; i < il; i++){
                const attribute = morphAttribute[i];
                const newAttribute = convertBufferAttribute(attribute, indices);
                morphArray.push(newAttribute);
            }
            geometry2.morphAttributes[name] = morphArray;
        }
        geometry2.morphTargetsRelative = this.morphTargetsRelative;
        // groups
        const groups = this.groups;
        for(let i = 0, l = groups.length; i < l; i++){
            const group = groups[i];
            geometry2.addGroup(group.start, group.count, group.materialIndex);
        }
        return geometry2;
    }
    toJSON() {
        const data = {
            metadata: {
                version: 4.6,
                type: "BufferGeometry",
                generator: "BufferGeometry.toJSON"
            }
        };
        // standard BufferGeometry serialization
        data.uuid = this.uuid;
        data.type = this.type;
        if (this.name !== "") data.name = this.name;
        if (Object.keys(this.userData).length > 0) data.userData = this.userData;
        if (this.parameters !== undefined) {
            const parameters = this.parameters;
            for(const key in parameters)if (parameters[key] !== undefined) data[key] = parameters[key];
            return data;
        }
        // for simplicity the code assumes attributes are not shared across geometries, see #15811
        data.data = {
            attributes: {}
        };
        const index = this.index;
        if (index !== null) data.data.index = {
            type: index.array.constructor.name,
            array: Array.prototype.slice.call(index.array)
        };
        const attributes = this.attributes;
        for(const key in attributes){
            const attribute = attributes[key];
            data.data.attributes[key] = attribute.toJSON(data.data);
        }
        const morphAttributes = {};
        let hasMorphAttributes = false;
        for(const key in this.morphAttributes){
            const attributeArray = this.morphAttributes[key];
            const array = [];
            for(let i = 0, il = attributeArray.length; i < il; i++){
                const attribute = attributeArray[i];
                array.push(attribute.toJSON(data.data));
            }
            if (array.length > 0) {
                morphAttributes[key] = array;
                hasMorphAttributes = true;
            }
        }
        if (hasMorphAttributes) {
            data.data.morphAttributes = morphAttributes;
            data.data.morphTargetsRelative = this.morphTargetsRelative;
        }
        const groups = this.groups;
        if (groups.length > 0) data.data.groups = JSON.parse(JSON.stringify(groups));
        const boundingSphere = this.boundingSphere;
        if (boundingSphere !== null) data.data.boundingSphere = {
            center: boundingSphere.center.toArray(),
            radius: boundingSphere.radius
        };
        return data;
    }
    clone() {
        return new this.constructor().copy(this);
    }
    copy(source) {
        // reset
        this.index = null;
        this.attributes = {};
        this.morphAttributes = {};
        this.groups = [];
        this.boundingBox = null;
        this.boundingSphere = null;
        // used for storing cloned, shared data
        const data = {};
        // name
        this.name = source.name;
        // index
        const index = source.index;
        if (index !== null) this.setIndex(index.clone(data));
        // attributes
        const attributes = source.attributes;
        for(const name in attributes){
            const attribute = attributes[name];
            this.setAttribute(name, attribute.clone(data));
        }
        // morph attributes
        const morphAttributes = source.morphAttributes;
        for(const name in morphAttributes){
            const array = [];
            const morphAttribute = morphAttributes[name]; // morphAttribute: array of Float32BufferAttributes
            for(let i = 0, l = morphAttribute.length; i < l; i++)array.push(morphAttribute[i].clone(data));
            this.morphAttributes[name] = array;
        }
        this.morphTargetsRelative = source.morphTargetsRelative;
        // groups
        const groups = source.groups;
        for(let i = 0, l = groups.length; i < l; i++){
            const group = groups[i];
            this.addGroup(group.start, group.count, group.materialIndex);
        }
        // bounding box
        const boundingBox = source.boundingBox;
        if (boundingBox !== null) this.boundingBox = boundingBox.clone();
        // bounding sphere
        const boundingSphere = source.boundingSphere;
        if (boundingSphere !== null) this.boundingSphere = boundingSphere.clone();
        // draw range
        this.drawRange.start = source.drawRange.start;
        this.drawRange.count = source.drawRange.count;
        // user data
        this.userData = source.userData;
        return this;
    }
    dispose() {
        this.dispatchEvent({
            type: "dispose"
        });
    }
    constructor(){
        super();
        this.isBufferGeometry = true;
        Object.defineProperty(this, "id", {
            value: $9014d97cd777be10$var$_id$1++
        });
        this.uuid = $9014d97cd777be10$var$generateUUID();
        this.name = "";
        this.type = "BufferGeometry";
        this.index = null;
        this.attributes = {};
        this.morphAttributes = {};
        this.morphTargetsRelative = false;
        this.groups = [];
        this.boundingBox = null;
        this.boundingSphere = null;
        this.drawRange = {
            start: 0,
            count: Infinity
        };
        this.userData = {};
    }
}
const $9014d97cd777be10$var$_inverseMatrix$3 = /*@__PURE__*/ new $9014d97cd777be10$export$2ae72fc923e5eb5();
const $9014d97cd777be10$var$_ray$3 = /*@__PURE__*/ new $9014d97cd777be10$export$a186db52eed6d40e();
const $9014d97cd777be10$var$_sphere$5 = /*@__PURE__*/ new $9014d97cd777be10$export$805e8b72413ccaba();
const $9014d97cd777be10$var$_sphereHitAt = /*@__PURE__*/ new $9014d97cd777be10$export$64b5c384219d3699();
const $9014d97cd777be10$var$_vA$1 = /*@__PURE__*/ new $9014d97cd777be10$export$64b5c384219d3699();
const $9014d97cd777be10$var$_vB$1 = /*@__PURE__*/ new $9014d97cd777be10$export$64b5c384219d3699();
const $9014d97cd777be10$var$_vC$1 = /*@__PURE__*/ new $9014d97cd777be10$export$64b5c384219d3699();
const $9014d97cd777be10$var$_tempA = /*@__PURE__*/ new $9014d97cd777be10$export$64b5c384219d3699();
const $9014d97cd777be10$var$_morphA = /*@__PURE__*/ new $9014d97cd777be10$export$64b5c384219d3699();
const $9014d97cd777be10$var$_uvA$1 = /*@__PURE__*/ new $9014d97cd777be10$export$c977b3e384af9ae1();
const $9014d97cd777be10$var$_uvB$1 = /*@__PURE__*/ new $9014d97cd777be10$export$c977b3e384af9ae1();
const $9014d97cd777be10$var$_uvC$1 = /*@__PURE__*/ new $9014d97cd777be10$export$c977b3e384af9ae1();
const $9014d97cd777be10$var$_normalA = /*@__PURE__*/ new $9014d97cd777be10$export$64b5c384219d3699();
const $9014d97cd777be10$var$_normalB = /*@__PURE__*/ new $9014d97cd777be10$export$64b5c384219d3699();
const $9014d97cd777be10$var$_normalC = /*@__PURE__*/ new $9014d97cd777be10$export$64b5c384219d3699();
const $9014d97cd777be10$var$_intersectionPoint = /*@__PURE__*/ new $9014d97cd777be10$export$64b5c384219d3699();
const $9014d97cd777be10$var$_intersectionPointWorld = /*@__PURE__*/ new $9014d97cd777be10$export$64b5c384219d3699();
class $9014d97cd777be10$export$e176487c05830cc5 extends $9014d97cd777be10$export$e4dd07dff30cc924 {
    copy(source, recursive) {
        super.copy(source, recursive);
        if (source.morphTargetInfluences !== undefined) this.morphTargetInfluences = source.morphTargetInfluences.slice();
        if (source.morphTargetDictionary !== undefined) this.morphTargetDictionary = Object.assign({}, source.morphTargetDictionary);
        this.material = source.material;
        this.geometry = source.geometry;
        return this;
    }
    updateMorphTargets() {
        const geometry = this.geometry;
        const morphAttributes = geometry.morphAttributes;
        const keys = Object.keys(morphAttributes);
        if (keys.length > 0) {
            const morphAttribute = morphAttributes[keys[0]];
            if (morphAttribute !== undefined) {
                this.morphTargetInfluences = [];
                this.morphTargetDictionary = {};
                for(let m = 0, ml = morphAttribute.length; m < ml; m++){
                    const name = morphAttribute[m].name || String(m);
                    this.morphTargetInfluences.push(0);
                    this.morphTargetDictionary[name] = m;
                }
            }
        }
    }
    getVertexPosition(index, target) {
        const geometry = this.geometry;
        const position = geometry.attributes.position;
        const morphPosition = geometry.morphAttributes.position;
        const morphTargetsRelative = geometry.morphTargetsRelative;
        target.fromBufferAttribute(position, index);
        const morphInfluences = this.morphTargetInfluences;
        if (morphPosition && morphInfluences) {
            $9014d97cd777be10$var$_morphA.set(0, 0, 0);
            for(let i = 0, il = morphPosition.length; i < il; i++){
                const influence = morphInfluences[i];
                const morphAttribute = morphPosition[i];
                if (influence === 0) continue;
                $9014d97cd777be10$var$_tempA.fromBufferAttribute(morphAttribute, index);
                if (morphTargetsRelative) $9014d97cd777be10$var$_morphA.addScaledVector($9014d97cd777be10$var$_tempA, influence);
                else $9014d97cd777be10$var$_morphA.addScaledVector($9014d97cd777be10$var$_tempA.sub(target), influence);
            }
            target.add($9014d97cd777be10$var$_morphA);
        }
        return target;
    }
    raycast(raycaster, intersects) {
        const geometry = this.geometry;
        const material = this.material;
        const matrixWorld = this.matrixWorld;
        if (material === undefined) return;
        // test with bounding sphere in world space
        if (geometry.boundingSphere === null) geometry.computeBoundingSphere();
        $9014d97cd777be10$var$_sphere$5.copy(geometry.boundingSphere);
        $9014d97cd777be10$var$_sphere$5.applyMatrix4(matrixWorld);
        // check distance from ray origin to bounding sphere
        $9014d97cd777be10$var$_ray$3.copy(raycaster.ray).recast(raycaster.near);
        if ($9014d97cd777be10$var$_sphere$5.containsPoint($9014d97cd777be10$var$_ray$3.origin) === false) {
            if ($9014d97cd777be10$var$_ray$3.intersectSphere($9014d97cd777be10$var$_sphere$5, $9014d97cd777be10$var$_sphereHitAt) === null) return;
            if ($9014d97cd777be10$var$_ray$3.origin.distanceToSquared($9014d97cd777be10$var$_sphereHitAt) > (raycaster.far - raycaster.near) ** 2) return;
        }
        // convert ray to local space of mesh
        $9014d97cd777be10$var$_inverseMatrix$3.copy(matrixWorld).invert();
        $9014d97cd777be10$var$_ray$3.copy(raycaster.ray).applyMatrix4($9014d97cd777be10$var$_inverseMatrix$3);
        // test with bounding box in local space
        if (geometry.boundingBox !== null) {
            if ($9014d97cd777be10$var$_ray$3.intersectsBox(geometry.boundingBox) === false) return;
        }
        // test for intersections with geometry
        this._computeIntersections(raycaster, intersects, $9014d97cd777be10$var$_ray$3);
    }
    _computeIntersections(raycaster, intersects, rayLocalSpace) {
        let intersection;
        const geometry = this.geometry;
        const material = this.material;
        const index = geometry.index;
        const position = geometry.attributes.position;
        const uv = geometry.attributes.uv;
        const uv1 = geometry.attributes.uv1;
        const normal = geometry.attributes.normal;
        const groups = geometry.groups;
        const drawRange = geometry.drawRange;
        if (index !== null) {
            // indexed buffer geometry
            if (Array.isArray(material)) for(let i = 0, il = groups.length; i < il; i++){
                const group = groups[i];
                const groupMaterial = material[group.materialIndex];
                const start = Math.max(group.start, drawRange.start);
                const end = Math.min(index.count, Math.min(group.start + group.count, drawRange.start + drawRange.count));
                for(let j = start, jl = end; j < jl; j += 3){
                    const a = index.getX(j);
                    const b = index.getX(j + 1);
                    const c = index.getX(j + 2);
                    intersection = $9014d97cd777be10$var$checkGeometryIntersection(this, groupMaterial, raycaster, rayLocalSpace, uv, uv1, normal, a, b, c);
                    if (intersection) {
                        intersection.faceIndex = Math.floor(j / 3); // triangle number in indexed buffer semantics
                        intersection.face.materialIndex = group.materialIndex;
                        intersects.push(intersection);
                    }
                }
            }
            else {
                const start = Math.max(0, drawRange.start);
                const end = Math.min(index.count, drawRange.start + drawRange.count);
                for(let i = start, il = end; i < il; i += 3){
                    const a = index.getX(i);
                    const b = index.getX(i + 1);
                    const c = index.getX(i + 2);
                    intersection = $9014d97cd777be10$var$checkGeometryIntersection(this, material, raycaster, rayLocalSpace, uv, uv1, normal, a, b, c);
                    if (intersection) {
                        intersection.faceIndex = Math.floor(i / 3); // triangle number in indexed buffer semantics
                        intersects.push(intersection);
                    }
                }
            }
        } else if (position !== undefined) {
            // non-indexed buffer geometry
            if (Array.isArray(material)) for(let i = 0, il = groups.length; i < il; i++){
                const group = groups[i];
                const groupMaterial = material[group.materialIndex];
                const start = Math.max(group.start, drawRange.start);
                const end = Math.min(position.count, Math.min(group.start + group.count, drawRange.start + drawRange.count));
                for(let j = start, jl = end; j < jl; j += 3){
                    const a = j;
                    const b = j + 1;
                    const c = j + 2;
                    intersection = $9014d97cd777be10$var$checkGeometryIntersection(this, groupMaterial, raycaster, rayLocalSpace, uv, uv1, normal, a, b, c);
                    if (intersection) {
                        intersection.faceIndex = Math.floor(j / 3); // triangle number in non-indexed buffer semantics
                        intersection.face.materialIndex = group.materialIndex;
                        intersects.push(intersection);
                    }
                }
            }
            else {
                const start = Math.max(0, drawRange.start);
                const end = Math.min(position.count, drawRange.start + drawRange.count);
                for(let i = start, il = end; i < il; i += 3){
                    const a = i;
                    const b = i + 1;
                    const c = i + 2;
                    intersection = $9014d97cd777be10$var$checkGeometryIntersection(this, material, raycaster, rayLocalSpace, uv, uv1, normal, a, b, c);
                    if (intersection) {
                        intersection.faceIndex = Math.floor(i / 3); // triangle number in non-indexed buffer semantics
                        intersects.push(intersection);
                    }
                }
            }
        }
    }
    constructor(geometry = new $9014d97cd777be10$export$b7be63a67df8959(), material = new $9014d97cd777be10$export$55cbcc9b622fe1f5()){
        super();
        this.isMesh = true;
        this.type = "Mesh";
        this.geometry = geometry;
        this.material = material;
        this.updateMorphTargets();
    }
}
function $9014d97cd777be10$var$checkIntersection(object, material, raycaster, ray, pA, pB, pC, point) {
    let intersect;
    if (material.side === $9014d97cd777be10$export$d9f0486e75b5ace) intersect = ray.intersectTriangle(pC, pB, pA, true, point);
    else intersect = ray.intersectTriangle(pA, pB, pC, material.side === $9014d97cd777be10$export$2ede184fc2998901, point);
    if (intersect === null) return null;
    $9014d97cd777be10$var$_intersectionPointWorld.copy(point);
    $9014d97cd777be10$var$_intersectionPointWorld.applyMatrix4(object.matrixWorld);
    const distance = raycaster.ray.origin.distanceTo($9014d97cd777be10$var$_intersectionPointWorld);
    if (distance < raycaster.near || distance > raycaster.far) return null;
    return {
        distance: distance,
        point: $9014d97cd777be10$var$_intersectionPointWorld.clone(),
        object: object
    };
}
function $9014d97cd777be10$var$checkGeometryIntersection(object, material, raycaster, ray, uv, uv1, normal, a, b, c) {
    object.getVertexPosition(a, $9014d97cd777be10$var$_vA$1);
    object.getVertexPosition(b, $9014d97cd777be10$var$_vB$1);
    object.getVertexPosition(c, $9014d97cd777be10$var$_vC$1);
    const intersection = $9014d97cd777be10$var$checkIntersection(object, material, raycaster, ray, $9014d97cd777be10$var$_vA$1, $9014d97cd777be10$var$_vB$1, $9014d97cd777be10$var$_vC$1, $9014d97cd777be10$var$_intersectionPoint);
    if (intersection) {
        if (uv) {
            $9014d97cd777be10$var$_uvA$1.fromBufferAttribute(uv, a);
            $9014d97cd777be10$var$_uvB$1.fromBufferAttribute(uv, b);
            $9014d97cd777be10$var$_uvC$1.fromBufferAttribute(uv, c);
            intersection.uv = $9014d97cd777be10$export$5a465592bfe74b48.getInterpolation($9014d97cd777be10$var$_intersectionPoint, $9014d97cd777be10$var$_vA$1, $9014d97cd777be10$var$_vB$1, $9014d97cd777be10$var$_vC$1, $9014d97cd777be10$var$_uvA$1, $9014d97cd777be10$var$_uvB$1, $9014d97cd777be10$var$_uvC$1, new $9014d97cd777be10$export$c977b3e384af9ae1());
        }
        if (uv1) {
            $9014d97cd777be10$var$_uvA$1.fromBufferAttribute(uv1, a);
            $9014d97cd777be10$var$_uvB$1.fromBufferAttribute(uv1, b);
            $9014d97cd777be10$var$_uvC$1.fromBufferAttribute(uv1, c);
            intersection.uv1 = $9014d97cd777be10$export$5a465592bfe74b48.getInterpolation($9014d97cd777be10$var$_intersectionPoint, $9014d97cd777be10$var$_vA$1, $9014d97cd777be10$var$_vB$1, $9014d97cd777be10$var$_vC$1, $9014d97cd777be10$var$_uvA$1, $9014d97cd777be10$var$_uvB$1, $9014d97cd777be10$var$_uvC$1, new $9014d97cd777be10$export$c977b3e384af9ae1());
            intersection.uv2 = intersection.uv1; // @deprecated, r152
        }
        if (normal) {
            $9014d97cd777be10$var$_normalA.fromBufferAttribute(normal, a);
            $9014d97cd777be10$var$_normalB.fromBufferAttribute(normal, b);
            $9014d97cd777be10$var$_normalC.fromBufferAttribute(normal, c);
            intersection.normal = $9014d97cd777be10$export$5a465592bfe74b48.getInterpolation($9014d97cd777be10$var$_intersectionPoint, $9014d97cd777be10$var$_vA$1, $9014d97cd777be10$var$_vB$1, $9014d97cd777be10$var$_vC$1, $9014d97cd777be10$var$_normalA, $9014d97cd777be10$var$_normalB, $9014d97cd777be10$var$_normalC, new $9014d97cd777be10$export$64b5c384219d3699());
            if (intersection.normal.dot(ray.direction) > 0) intersection.normal.multiplyScalar(-1);
        }
        const face = {
            a: a,
            b: b,
            c: c,
            normal: new $9014d97cd777be10$export$64b5c384219d3699(),
            materialIndex: 0
        };
        $9014d97cd777be10$export$5a465592bfe74b48.getNormal($9014d97cd777be10$var$_vA$1, $9014d97cd777be10$var$_vB$1, $9014d97cd777be10$var$_vC$1, face.normal);
        intersection.face = face;
    }
    return intersection;
}
class $9014d97cd777be10$export$33e43285f7406bd5 extends $9014d97cd777be10$export$b7be63a67df8959 {
    copy(source) {
        super.copy(source);
        this.parameters = Object.assign({}, source.parameters);
        return this;
    }
    static fromJSON(data) {
        return new $9014d97cd777be10$export$33e43285f7406bd5(data.width, data.height, data.depth, data.widthSegments, data.heightSegments, data.depthSegments);
    }
    constructor(width = 1, height = 1, depth = 1, widthSegments = 1, heightSegments = 1, depthSegments = 1){
        super();
        this.type = "BoxGeometry";
        this.parameters = {
            width: width,
            height: height,
            depth: depth,
            widthSegments: widthSegments,
            heightSegments: heightSegments,
            depthSegments: depthSegments
        };
        const scope = this;
        // segments
        widthSegments = Math.floor(widthSegments);
        heightSegments = Math.floor(heightSegments);
        depthSegments = Math.floor(depthSegments);
        // buffers
        const indices = [];
        const vertices = [];
        const normals = [];
        const uvs = [];
        // helper variables
        let numberOfVertices = 0;
        let groupStart = 0;
        // build each side of the box geometry
        buildPlane("z", "y", "x", -1, -1, depth, height, width, depthSegments, heightSegments, 0); // px
        buildPlane("z", "y", "x", 1, -1, depth, height, -width, depthSegments, heightSegments, 1); // nx
        buildPlane("x", "z", "y", 1, 1, width, depth, height, widthSegments, depthSegments, 2); // py
        buildPlane("x", "z", "y", 1, -1, width, depth, -height, widthSegments, depthSegments, 3); // ny
        buildPlane("x", "y", "z", 1, -1, width, height, depth, widthSegments, heightSegments, 4); // pz
        buildPlane("x", "y", "z", -1, -1, width, height, -depth, widthSegments, heightSegments, 5); // nz
        // build geometry
        this.setIndex(indices);
        this.setAttribute("position", new $9014d97cd777be10$export$cbe7a62641830ebd(vertices, 3));
        this.setAttribute("normal", new $9014d97cd777be10$export$cbe7a62641830ebd(normals, 3));
        this.setAttribute("uv", new $9014d97cd777be10$export$cbe7a62641830ebd(uvs, 2));
        function buildPlane(u, v, w, udir, vdir, width, height, depth, gridX, gridY, materialIndex) {
            const segmentWidth = width / gridX;
            const segmentHeight = height / gridY;
            const widthHalf = width / 2;
            const heightHalf = height / 2;
            const depthHalf = depth / 2;
            const gridX1 = gridX + 1;
            const gridY1 = gridY + 1;
            let vertexCounter = 0;
            let groupCount = 0;
            const vector = new $9014d97cd777be10$export$64b5c384219d3699();
            // generate vertices, normals and uvs
            for(let iy = 0; iy < gridY1; iy++){
                const y = iy * segmentHeight - heightHalf;
                for(let ix = 0; ix < gridX1; ix++){
                    const x = ix * segmentWidth - widthHalf;
                    // set values to correct vector component
                    vector[u] = x * udir;
                    vector[v] = y * vdir;
                    vector[w] = depthHalf;
                    // now apply vector to vertex buffer
                    vertices.push(vector.x, vector.y, vector.z);
                    // set values to correct vector component
                    vector[u] = 0;
                    vector[v] = 0;
                    vector[w] = depth > 0 ? 1 : -1;
                    // now apply vector to normal buffer
                    normals.push(vector.x, vector.y, vector.z);
                    // uvs
                    uvs.push(ix / gridX);
                    uvs.push(1 - iy / gridY);
                    // counters
                    vertexCounter += 1;
                }
            }
            // indices
            // 1. you need three indices to draw a single face
            // 2. a single segment consists of two faces
            // 3. so we need to generate six (2*3) indices per segment
            for(let iy = 0; iy < gridY; iy++)for(let ix = 0; ix < gridX; ix++){
                const a = numberOfVertices + ix + gridX1 * iy;
                const b = numberOfVertices + ix + gridX1 * (iy + 1);
                const c = numberOfVertices + (ix + 1) + gridX1 * (iy + 1);
                const d = numberOfVertices + (ix + 1) + gridX1 * iy;
                // faces
                indices.push(a, b, d);
                indices.push(b, c, d);
                // increase counter
                groupCount += 6;
            }
            // add a group to the geometry. this will ensure multi material support
            scope.addGroup(groupStart, groupCount, materialIndex);
            // calculate new start value for groups
            groupStart += groupCount;
            // update total number of vertices
            numberOfVertices += vertexCounter;
        }
    }
}
/**
 * Uniform Utilities
 */ function $9014d97cd777be10$var$cloneUniforms(src) {
    const dst = {};
    for(const u in src){
        dst[u] = {};
        for(const p in src[u]){
            const property = src[u][p];
            if (property && (property.isColor || property.isMatrix3 || property.isMatrix4 || property.isVector2 || property.isVector3 || property.isVector4 || property.isTexture || property.isQuaternion)) {
                if (property.isRenderTargetTexture) {
                    console.warn("UniformsUtils: Textures of render targets cannot be cloned via cloneUniforms() or mergeUniforms().");
                    dst[u][p] = null;
                } else dst[u][p] = property.clone();
            } else if (Array.isArray(property)) dst[u][p] = property.slice();
            else dst[u][p] = property;
        }
    }
    return dst;
}
function $9014d97cd777be10$var$mergeUniforms(uniforms) {
    const merged = {};
    for(let u = 0; u < uniforms.length; u++){
        const tmp = $9014d97cd777be10$var$cloneUniforms(uniforms[u]);
        for(const p in tmp)merged[p] = tmp[p];
    }
    return merged;
}
function $9014d97cd777be10$var$cloneUniformsGroups(src) {
    const dst = [];
    for(let u = 0; u < src.length; u++)dst.push(src[u].clone());
    return dst;
}
function $9014d97cd777be10$var$getUnlitUniformColorSpace(renderer) {
    if (renderer.getRenderTarget() === null) // https://github.com/mrdoob/three.js/pull/23937#issuecomment-1111067398
    return renderer.outputColorSpace;
    return $9014d97cd777be10$export$42429b3acfb233a4;
}
// Legacy
const $9014d97cd777be10$export$d8ecdf8615bfea69 = {
    clone: $9014d97cd777be10$var$cloneUniforms,
    merge: $9014d97cd777be10$var$mergeUniforms
};
var $9014d97cd777be10$var$default_vertex = "void main() {\n	gl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );\n}";
var $9014d97cd777be10$var$default_fragment = "void main() {\n	gl_FragColor = vec4( 1.0, 0.0, 0.0, 1.0 );\n}";
class $9014d97cd777be10$export$83c7d75d550a8b0d extends $9014d97cd777be10$export$a2d8b23205c25948 {
    copy(source) {
        super.copy(source);
        this.fragmentShader = source.fragmentShader;
        this.vertexShader = source.vertexShader;
        this.uniforms = $9014d97cd777be10$var$cloneUniforms(source.uniforms);
        this.uniformsGroups = $9014d97cd777be10$var$cloneUniformsGroups(source.uniformsGroups);
        this.defines = Object.assign({}, source.defines);
        this.wireframe = source.wireframe;
        this.wireframeLinewidth = source.wireframeLinewidth;
        this.fog = source.fog;
        this.lights = source.lights;
        this.clipping = source.clipping;
        this.extensions = Object.assign({}, source.extensions);
        this.glslVersion = source.glslVersion;
        return this;
    }
    toJSON(meta) {
        const data = super.toJSON(meta);
        data.glslVersion = this.glslVersion;
        data.uniforms = {};
        for(const name in this.uniforms){
            const uniform = this.uniforms[name];
            const value = uniform.value;
            if (value && value.isTexture) data.uniforms[name] = {
                type: "t",
                value: value.toJSON(meta).uuid
            };
            else if (value && value.isColor) data.uniforms[name] = {
                type: "c",
                value: value.getHex()
            };
            else if (value && value.isVector2) data.uniforms[name] = {
                type: "v2",
                value: value.toArray()
            };
            else if (value && value.isVector3) data.uniforms[name] = {
                type: "v3",
                value: value.toArray()
            };
            else if (value && value.isVector4) data.uniforms[name] = {
                type: "v4",
                value: value.toArray()
            };
            else if (value && value.isMatrix3) data.uniforms[name] = {
                type: "m3",
                value: value.toArray()
            };
            else if (value && value.isMatrix4) data.uniforms[name] = {
                type: "m4",
                value: value.toArray()
            };
            else data.uniforms[name] = {
                value: value
            };
        }
        if (Object.keys(this.defines).length > 0) data.defines = this.defines;
        data.vertexShader = this.vertexShader;
        data.fragmentShader = this.fragmentShader;
        data.lights = this.lights;
        data.clipping = this.clipping;
        const extensions = {};
        for(const key in this.extensions)if (this.extensions[key] === true) extensions[key] = true;
        if (Object.keys(extensions).length > 0) data.extensions = extensions;
        return data;
    }
    constructor(parameters){
        super();
        this.isShaderMaterial = true;
        this.type = "ShaderMaterial";
        this.defines = {};
        this.uniforms = {};
        this.uniformsGroups = [];
        this.vertexShader = $9014d97cd777be10$var$default_vertex;
        this.fragmentShader = $9014d97cd777be10$var$default_fragment;
        this.linewidth = 1;
        this.wireframe = false;
        this.wireframeLinewidth = 1;
        this.fog = false; // set to use scene fog
        this.lights = false; // set to use scene lights
        this.clipping = false; // set to use user-defined clipping planes
        this.forceSinglePass = true;
        this.extensions = {
            derivatives: false,
            fragDepth: false,
            drawBuffers: false,
            shaderTextureLOD: false // set to use shader texture LOD
        };
        // When rendered geometry doesn't include these attributes but the material does,
        // use these default values in WebGL. This avoids errors when buffer data is missing.
        this.defaultAttributeValues = {
            "color": [
                1,
                1,
                1
            ],
            "uv": [
                0,
                0
            ],
            "uv1": [
                0,
                0
            ]
        };
        this.index0AttributeName = undefined;
        this.uniformsNeedUpdate = false;
        this.glslVersion = null;
        if (parameters !== undefined) this.setValues(parameters);
    }
}
class $9014d97cd777be10$export$79f141de891a5fed extends $9014d97cd777be10$export$e4dd07dff30cc924 {
    copy(source, recursive) {
        super.copy(source, recursive);
        this.matrixWorldInverse.copy(source.matrixWorldInverse);
        this.projectionMatrix.copy(source.projectionMatrix);
        this.projectionMatrixInverse.copy(source.projectionMatrixInverse);
        this.coordinateSystem = source.coordinateSystem;
        return this;
    }
    getWorldDirection(target) {
        this.updateWorldMatrix(true, false);
        const e = this.matrixWorld.elements;
        return target.set(-e[8], -e[9], -e[10]).normalize();
    }
    updateMatrixWorld(force) {
        super.updateMatrixWorld(force);
        this.matrixWorldInverse.copy(this.matrixWorld).invert();
    }
    updateWorldMatrix(updateParents, updateChildren) {
        super.updateWorldMatrix(updateParents, updateChildren);
        this.matrixWorldInverse.copy(this.matrixWorld).invert();
    }
    clone() {
        return new this.constructor().copy(this);
    }
    constructor(){
        super();
        this.isCamera = true;
        this.type = "Camera";
        this.matrixWorldInverse = new $9014d97cd777be10$export$2ae72fc923e5eb5();
        this.projectionMatrix = new $9014d97cd777be10$export$2ae72fc923e5eb5();
        this.projectionMatrixInverse = new $9014d97cd777be10$export$2ae72fc923e5eb5();
        this.coordinateSystem = $9014d97cd777be10$export$5a0e9190d10875d3;
    }
}
class $9014d97cd777be10$export$74e4ae24825f68d7 extends $9014d97cd777be10$export$79f141de891a5fed {
    copy(source, recursive) {
        super.copy(source, recursive);
        this.fov = source.fov;
        this.zoom = source.zoom;
        this.near = source.near;
        this.far = source.far;
        this.focus = source.focus;
        this.aspect = source.aspect;
        this.view = source.view === null ? null : Object.assign({}, source.view);
        this.filmGauge = source.filmGauge;
        this.filmOffset = source.filmOffset;
        return this;
    }
    /**
	 * Sets the FOV by focal length in respect to the current .filmGauge.
	 *
	 * The default film gauge is 35, so that the focal length can be specified for
	 * a 35mm (full frame) camera.
	 *
	 * Values for focal length and film gauge must have the same unit.
	 */ setFocalLength(focalLength) {
        /** see {@link http://www.bobatkins.com/photography/technical/field_of_view.html} */ const vExtentSlope = 0.5 * this.getFilmHeight() / focalLength;
        this.fov = $9014d97cd777be10$var$RAD2DEG * 2 * Math.atan(vExtentSlope);
        this.updateProjectionMatrix();
    }
    /**
	 * Calculates the focal length from the current .fov and .filmGauge.
	 */ getFocalLength() {
        const vExtentSlope = Math.tan($9014d97cd777be10$var$DEG2RAD * 0.5 * this.fov);
        return 0.5 * this.getFilmHeight() / vExtentSlope;
    }
    getEffectiveFOV() {
        return $9014d97cd777be10$var$RAD2DEG * 2 * Math.atan(Math.tan($9014d97cd777be10$var$DEG2RAD * 0.5 * this.fov) / this.zoom);
    }
    getFilmWidth() {
        // film not completely covered in portrait format (aspect < 1)
        return this.filmGauge * Math.min(this.aspect, 1);
    }
    getFilmHeight() {
        // film not completely covered in landscape format (aspect > 1)
        return this.filmGauge / Math.max(this.aspect, 1);
    }
    /**
	 * Sets an offset in a larger frustum. This is useful for multi-window or
	 * multi-monitor/multi-machine setups.
	 *
	 * For example, if you have 3x2 monitors and each monitor is 1920x1080 and
	 * the monitors are in grid like this
	 *
	 *   +---+---+---+
	 *   | A | B | C |
	 *   +---+---+---+
	 *   | D | E | F |
	 *   +---+---+---+
	 *
	 * then for each monitor you would call it like this
	 *
	 *   const w = 1920;
	 *   const h = 1080;
	 *   const fullWidth = w * 3;
	 *   const fullHeight = h * 2;
	 *
	 *   --A--
	 *   camera.setViewOffset( fullWidth, fullHeight, w * 0, h * 0, w, h );
	 *   --B--
	 *   camera.setViewOffset( fullWidth, fullHeight, w * 1, h * 0, w, h );
	 *   --C--
	 *   camera.setViewOffset( fullWidth, fullHeight, w * 2, h * 0, w, h );
	 *   --D--
	 *   camera.setViewOffset( fullWidth, fullHeight, w * 0, h * 1, w, h );
	 *   --E--
	 *   camera.setViewOffset( fullWidth, fullHeight, w * 1, h * 1, w, h );
	 *   --F--
	 *   camera.setViewOffset( fullWidth, fullHeight, w * 2, h * 1, w, h );
	 *
	 *   Note there is no reason monitors have to be the same size or in a grid.
	 */ setViewOffset(fullWidth, fullHeight, x, y, width, height) {
        this.aspect = fullWidth / fullHeight;
        if (this.view === null) this.view = {
            enabled: true,
            fullWidth: 1,
            fullHeight: 1,
            offsetX: 0,
            offsetY: 0,
            width: 1,
            height: 1
        };
        this.view.enabled = true;
        this.view.fullWidth = fullWidth;
        this.view.fullHeight = fullHeight;
        this.view.offsetX = x;
        this.view.offsetY = y;
        this.view.width = width;
        this.view.height = height;
        this.updateProjectionMatrix();
    }
    clearViewOffset() {
        if (this.view !== null) this.view.enabled = false;
        this.updateProjectionMatrix();
    }
    updateProjectionMatrix() {
        const near = this.near;
        let top = near * Math.tan($9014d97cd777be10$var$DEG2RAD * 0.5 * this.fov) / this.zoom;
        let height = 2 * top;
        let width = this.aspect * height;
        let left = -0.5 * width;
        const view = this.view;
        if (this.view !== null && this.view.enabled) {
            const fullWidth = view.fullWidth, fullHeight = view.fullHeight;
            left += view.offsetX * width / fullWidth;
            top -= view.offsetY * height / fullHeight;
            width *= view.width / fullWidth;
            height *= view.height / fullHeight;
        }
        const skew = this.filmOffset;
        if (skew !== 0) left += near * skew / this.getFilmWidth();
        this.projectionMatrix.makePerspective(left, left + width, top, top - height, near, this.far, this.coordinateSystem);
        this.projectionMatrixInverse.copy(this.projectionMatrix).invert();
    }
    toJSON(meta) {
        const data = super.toJSON(meta);
        data.object.fov = this.fov;
        data.object.zoom = this.zoom;
        data.object.near = this.near;
        data.object.far = this.far;
        data.object.focus = this.focus;
        data.object.aspect = this.aspect;
        if (this.view !== null) data.object.view = Object.assign({}, this.view);
        data.object.filmGauge = this.filmGauge;
        data.object.filmOffset = this.filmOffset;
        return data;
    }
    constructor(fov = 50, aspect = 1, near = 0.1, far = 2000){
        super();
        this.isPerspectiveCamera = true;
        this.type = "PerspectiveCamera";
        this.fov = fov;
        this.zoom = 1;
        this.near = near;
        this.far = far;
        this.focus = 10;
        this.aspect = aspect;
        this.view = null;
        this.filmGauge = 35; // width of the film (default in millimeters)
        this.filmOffset = 0; // horizontal film offset (same unit as gauge)
        this.updateProjectionMatrix();
    }
}
const $9014d97cd777be10$var$fov = -90; // negative fov is not an error
const $9014d97cd777be10$var$aspect = 1;
class $9014d97cd777be10$export$d0cdd0bd804995de extends $9014d97cd777be10$export$e4dd07dff30cc924 {
    updateCoordinateSystem() {
        const coordinateSystem = this.coordinateSystem;
        const cameras = this.children.concat();
        const [cameraPX, cameraNX, cameraPY, cameraNY, cameraPZ, cameraNZ] = cameras;
        for (const camera of cameras)this.remove(camera);
        if (coordinateSystem === $9014d97cd777be10$export$5a0e9190d10875d3) {
            cameraPX.up.set(0, 1, 0);
            cameraPX.lookAt(1, 0, 0);
            cameraNX.up.set(0, 1, 0);
            cameraNX.lookAt(-1, 0, 0);
            cameraPY.up.set(0, 0, -1);
            cameraPY.lookAt(0, 1, 0);
            cameraNY.up.set(0, 0, 1);
            cameraNY.lookAt(0, -1, 0);
            cameraPZ.up.set(0, 1, 0);
            cameraPZ.lookAt(0, 0, 1);
            cameraNZ.up.set(0, 1, 0);
            cameraNZ.lookAt(0, 0, -1);
        } else if (coordinateSystem === $9014d97cd777be10$export$cc83beedcb9be9ac) {
            cameraPX.up.set(0, -1, 0);
            cameraPX.lookAt(-1, 0, 0);
            cameraNX.up.set(0, -1, 0);
            cameraNX.lookAt(1, 0, 0);
            cameraPY.up.set(0, 0, 1);
            cameraPY.lookAt(0, 1, 0);
            cameraNY.up.set(0, 0, -1);
            cameraNY.lookAt(0, -1, 0);
            cameraPZ.up.set(0, -1, 0);
            cameraPZ.lookAt(0, 0, 1);
            cameraNZ.up.set(0, -1, 0);
            cameraNZ.lookAt(0, 0, -1);
        } else throw new Error("THREE.CubeCamera.updateCoordinateSystem(): Invalid coordinate system: " + coordinateSystem);
        for (const camera of cameras){
            this.add(camera);
            camera.updateMatrixWorld();
        }
    }
    update(renderer, scene) {
        if (this.parent === null) this.updateMatrixWorld();
        const renderTarget = this.renderTarget;
        if (this.coordinateSystem !== renderer.coordinateSystem) {
            this.coordinateSystem = renderer.coordinateSystem;
            this.updateCoordinateSystem();
        }
        const [cameraPX, cameraNX, cameraPY, cameraNY, cameraPZ, cameraNZ] = this.children;
        const currentRenderTarget = renderer.getRenderTarget();
        const currentXrEnabled = renderer.xr.enabled;
        renderer.xr.enabled = false;
        const generateMipmaps = renderTarget.texture.generateMipmaps;
        renderTarget.texture.generateMipmaps = false;
        renderer.setRenderTarget(renderTarget, 0);
        renderer.render(scene, cameraPX);
        renderer.setRenderTarget(renderTarget, 1);
        renderer.render(scene, cameraNX);
        renderer.setRenderTarget(renderTarget, 2);
        renderer.render(scene, cameraPY);
        renderer.setRenderTarget(renderTarget, 3);
        renderer.render(scene, cameraNY);
        renderer.setRenderTarget(renderTarget, 4);
        renderer.render(scene, cameraPZ);
        renderTarget.texture.generateMipmaps = generateMipmaps;
        renderer.setRenderTarget(renderTarget, 5);
        renderer.render(scene, cameraNZ);
        renderer.setRenderTarget(currentRenderTarget);
        renderer.xr.enabled = currentXrEnabled;
        renderTarget.texture.needsPMREMUpdate = true;
    }
    constructor(near, far, renderTarget){
        super();
        this.type = "CubeCamera";
        this.renderTarget = renderTarget;
        this.coordinateSystem = null;
        const cameraPX = new $9014d97cd777be10$export$74e4ae24825f68d7($9014d97cd777be10$var$fov, $9014d97cd777be10$var$aspect, near, far);
        cameraPX.layers = this.layers;
        this.add(cameraPX);
        const cameraNX = new $9014d97cd777be10$export$74e4ae24825f68d7($9014d97cd777be10$var$fov, $9014d97cd777be10$var$aspect, near, far);
        cameraNX.layers = this.layers;
        this.add(cameraNX);
        const cameraPY = new $9014d97cd777be10$export$74e4ae24825f68d7($9014d97cd777be10$var$fov, $9014d97cd777be10$var$aspect, near, far);
        cameraPY.layers = this.layers;
        this.add(cameraPY);
        const cameraNY = new $9014d97cd777be10$export$74e4ae24825f68d7($9014d97cd777be10$var$fov, $9014d97cd777be10$var$aspect, near, far);
        cameraNY.layers = this.layers;
        this.add(cameraNY);
        const cameraPZ = new $9014d97cd777be10$export$74e4ae24825f68d7($9014d97cd777be10$var$fov, $9014d97cd777be10$var$aspect, near, far);
        cameraPZ.layers = this.layers;
        this.add(cameraPZ);
        const cameraNZ = new $9014d97cd777be10$export$74e4ae24825f68d7($9014d97cd777be10$var$fov, $9014d97cd777be10$var$aspect, near, far);
        cameraNZ.layers = this.layers;
        this.add(cameraNZ);
    }
}
class $9014d97cd777be10$export$ee2e5a18258a4049 extends $9014d97cd777be10$export$5431306cf43de24a {
    get images() {
        return this.image;
    }
    set images(value) {
        this.image = value;
    }
    constructor(images, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy, colorSpace1){
        images = images !== undefined ? images : [];
        mapping = mapping !== undefined ? mapping : $9014d97cd777be10$export$8759762a6477f2c4;
        super(images, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy, colorSpace1);
        this.isCubeTexture = true;
        this.flipY = false;
    }
}
class $9014d97cd777be10$export$ac386671d651941e extends $9014d97cd777be10$export$3c052beb2e51e23f {
    fromEquirectangularTexture(renderer, texture) {
        this.texture.type = texture.type;
        this.texture.colorSpace = texture.colorSpace;
        this.texture.generateMipmaps = texture.generateMipmaps;
        this.texture.minFilter = texture.minFilter;
        this.texture.magFilter = texture.magFilter;
        const shader = {
            uniforms: {
                tEquirect: {
                    value: null
                }
            },
            vertexShader: /* glsl */ `

				varying vec3 vWorldDirection;

				vec3 transformDirection( in vec3 dir, in mat4 matrix ) {

					return normalize( ( matrix * vec4( dir, 0.0 ) ).xyz );

				}

				void main() {

					vWorldDirection = transformDirection( position, modelMatrix );

					#include <begin_vertex>
					#include <project_vertex>

				}
			`,
            fragmentShader: /* glsl */ `

				uniform sampler2D tEquirect;

				varying vec3 vWorldDirection;

				#include <common>

				void main() {

					vec3 direction = normalize( vWorldDirection );

					vec2 sampleUV = equirectUv( direction );

					gl_FragColor = texture2D( tEquirect, sampleUV );

				}
			`
        };
        const geometry = new $9014d97cd777be10$export$33e43285f7406bd5(5, 5, 5);
        const material = new $9014d97cd777be10$export$83c7d75d550a8b0d({
            name: "CubemapFromEquirect",
            uniforms: $9014d97cd777be10$var$cloneUniforms(shader.uniforms),
            vertexShader: shader.vertexShader,
            fragmentShader: shader.fragmentShader,
            side: $9014d97cd777be10$export$d9f0486e75b5ace,
            blending: $9014d97cd777be10$export$63b8d6b580fc65ba
        });
        material.uniforms.tEquirect.value = texture;
        const mesh = new $9014d97cd777be10$export$e176487c05830cc5(geometry, material);
        const currentMinFilter = texture.minFilter;
        // Avoid blurred poles
        if (texture.minFilter === $9014d97cd777be10$export$5d8599b6a933fb1b) texture.minFilter = $9014d97cd777be10$export$8a72f490b25c56c8;
        const camera = new $9014d97cd777be10$export$d0cdd0bd804995de(1, 10, this);
        camera.update(renderer, mesh);
        texture.minFilter = currentMinFilter;
        mesh.geometry.dispose();
        mesh.material.dispose();
        return this;
    }
    clear(renderer, color, depth, stencil) {
        const currentRenderTarget = renderer.getRenderTarget();
        for(let i = 0; i < 6; i++){
            renderer.setRenderTarget(this, i);
            renderer.clear(color, depth, stencil);
        }
        renderer.setRenderTarget(currentRenderTarget);
    }
    constructor(size = 1, options = {}){
        super(size, size, options);
        this.isWebGLCubeRenderTarget = true;
        const image = {
            width: size,
            height: size,
            depth: 1
        };
        const images = [
            image,
            image,
            image,
            image,
            image,
            image
        ];
        if (options.encoding !== undefined) {
            // @deprecated, r152
            $9014d97cd777be10$var$warnOnce("THREE.WebGLCubeRenderTarget: option.encoding has been replaced by option.colorSpace.");
            options.colorSpace = options.encoding === $9014d97cd777be10$export$f32388edbb32674 ? $9014d97cd777be10$export$561f394b24edfcaa : $9014d97cd777be10$export$bfcb490c2dd3db51;
        }
        this.texture = new $9014d97cd777be10$export$ee2e5a18258a4049(images, options.mapping, options.wrapS, options.wrapT, options.magFilter, options.minFilter, options.format, options.type, options.anisotropy, options.colorSpace);
        // By convention -- likely based on the RenderMan spec from the 1990's -- cube maps are specified by WebGL (and three.js)
        // in a coordinate system in which positive-x is to the right when looking up the positive-z axis -- in other words,
        // in a left-handed coordinate system. By continuing this convention, preexisting cube maps continued to render correctly.
        // three.js uses a right-handed coordinate system. So environment maps used in three.js appear to have px and nx swapped
        // and the flag isRenderTargetTexture controls this conversion. The flip is not required when using WebGLCubeRenderTarget.texture
        // as a cube texture (this is detected when isRenderTargetTexture is set to true for cube textures).
        this.texture.isRenderTargetTexture = true;
        this.texture.generateMipmaps = options.generateMipmaps !== undefined ? options.generateMipmaps : false;
        this.texture.minFilter = options.minFilter !== undefined ? options.minFilter : $9014d97cd777be10$export$8a72f490b25c56c8;
    }
}
const $9014d97cd777be10$var$_vector1 = /*@__PURE__*/ new $9014d97cd777be10$export$64b5c384219d3699();
const $9014d97cd777be10$var$_vector2 = /*@__PURE__*/ new $9014d97cd777be10$export$64b5c384219d3699();
const $9014d97cd777be10$var$_normalMatrix = /*@__PURE__*/ new $9014d97cd777be10$export$8ff26dafa08918();
class $9014d97cd777be10$export$7ff5ac152ef991b0 {
    set(normal, constant) {
        this.normal.copy(normal);
        this.constant = constant;
        return this;
    }
    setComponents(x, y, z, w) {
        this.normal.set(x, y, z);
        this.constant = w;
        return this;
    }
    setFromNormalAndCoplanarPoint(normal, point) {
        this.normal.copy(normal);
        this.constant = -point.dot(this.normal);
        return this;
    }
    setFromCoplanarPoints(a, b, c) {
        const normal = $9014d97cd777be10$var$_vector1.subVectors(c, b).cross($9014d97cd777be10$var$_vector2.subVectors(a, b)).normalize();
        // Q: should an error be thrown if normal is zero (e.g. degenerate plane)?
        this.setFromNormalAndCoplanarPoint(normal, a);
        return this;
    }
    copy(plane) {
        this.normal.copy(plane.normal);
        this.constant = plane.constant;
        return this;
    }
    normalize() {
        // Note: will lead to a divide by zero if the plane is invalid.
        const inverseNormalLength = 1.0 / this.normal.length();
        this.normal.multiplyScalar(inverseNormalLength);
        this.constant *= inverseNormalLength;
        return this;
    }
    negate() {
        this.constant *= -1;
        this.normal.negate();
        return this;
    }
    distanceToPoint(point) {
        return this.normal.dot(point) + this.constant;
    }
    distanceToSphere(sphere) {
        return this.distanceToPoint(sphere.center) - sphere.radius;
    }
    projectPoint(point, target) {
        return target.copy(point).addScaledVector(this.normal, -this.distanceToPoint(point));
    }
    intersectLine(line, target) {
        const direction = line.delta($9014d97cd777be10$var$_vector1);
        const denominator = this.normal.dot(direction);
        if (denominator === 0) {
            // line is coplanar, return origin
            if (this.distanceToPoint(line.start) === 0) return target.copy(line.start);
            // Unsure if this is the correct method to handle this case.
            return null;
        }
        const t = -(line.start.dot(this.normal) + this.constant) / denominator;
        if (t < 0 || t > 1) return null;
        return target.copy(line.start).addScaledVector(direction, t);
    }
    intersectsLine(line) {
        // Note: this tests if a line intersects the plane, not whether it (or its end-points) are coplanar with it.
        const startSign = this.distanceToPoint(line.start);
        const endSign = this.distanceToPoint(line.end);
        return startSign < 0 && endSign > 0 || endSign < 0 && startSign > 0;
    }
    intersectsBox(box) {
        return box.intersectsPlane(this);
    }
    intersectsSphere(sphere) {
        return sphere.intersectsPlane(this);
    }
    coplanarPoint(target) {
        return target.copy(this.normal).multiplyScalar(-this.constant);
    }
    applyMatrix4(matrix, optionalNormalMatrix) {
        const normalMatrix = optionalNormalMatrix || $9014d97cd777be10$var$_normalMatrix.getNormalMatrix(matrix);
        const referencePoint = this.coplanarPoint($9014d97cd777be10$var$_vector1).applyMatrix4(matrix);
        const normal = this.normal.applyMatrix3(normalMatrix).normalize();
        this.constant = -referencePoint.dot(normal);
        return this;
    }
    translate(offset) {
        this.constant -= offset.dot(this.normal);
        return this;
    }
    equals(plane) {
        return plane.normal.equals(this.normal) && plane.constant === this.constant;
    }
    clone() {
        return new this.constructor().copy(this);
    }
    constructor(normal = new $9014d97cd777be10$export$64b5c384219d3699(1, 0, 0), constant = 0){
        this.isPlane = true;
        // normal is assumed to be normalized
        this.normal = normal;
        this.constant = constant;
    }
}
const $9014d97cd777be10$var$_sphere$4 = /*@__PURE__*/ new $9014d97cd777be10$export$805e8b72413ccaba();
const $9014d97cd777be10$var$_vector$6 = /*@__PURE__*/ new $9014d97cd777be10$export$64b5c384219d3699();
class $9014d97cd777be10$export$35efe6f4c85463d2 {
    set(p0, p1, p2, p3, p4, p5) {
        const planes = this.planes;
        planes[0].copy(p0);
        planes[1].copy(p1);
        planes[2].copy(p2);
        planes[3].copy(p3);
        planes[4].copy(p4);
        planes[5].copy(p5);
        return this;
    }
    copy(frustum) {
        const planes = this.planes;
        for(let i = 0; i < 6; i++)planes[i].copy(frustum.planes[i]);
        return this;
    }
    setFromProjectionMatrix(m, coordinateSystem = $9014d97cd777be10$export$5a0e9190d10875d3) {
        const planes = this.planes;
        const me = m.elements;
        const me0 = me[0], me1 = me[1], me2 = me[2], me3 = me[3];
        const me4 = me[4], me5 = me[5], me6 = me[6], me7 = me[7];
        const me8 = me[8], me9 = me[9], me10 = me[10], me11 = me[11];
        const me12 = me[12], me13 = me[13], me14 = me[14], me15 = me[15];
        planes[0].setComponents(me3 - me0, me7 - me4, me11 - me8, me15 - me12).normalize();
        planes[1].setComponents(me3 + me0, me7 + me4, me11 + me8, me15 + me12).normalize();
        planes[2].setComponents(me3 + me1, me7 + me5, me11 + me9, me15 + me13).normalize();
        planes[3].setComponents(me3 - me1, me7 - me5, me11 - me9, me15 - me13).normalize();
        planes[4].setComponents(me3 - me2, me7 - me6, me11 - me10, me15 - me14).normalize();
        if (coordinateSystem === $9014d97cd777be10$export$5a0e9190d10875d3) planes[5].setComponents(me3 + me2, me7 + me6, me11 + me10, me15 + me14).normalize();
        else if (coordinateSystem === $9014d97cd777be10$export$cc83beedcb9be9ac) planes[5].setComponents(me2, me6, me10, me14).normalize();
        else throw new Error("THREE.Frustum.setFromProjectionMatrix(): Invalid coordinate system: " + coordinateSystem);
        return this;
    }
    intersectsObject(object) {
        if (object.boundingSphere !== undefined) {
            if (object.boundingSphere === null) object.computeBoundingSphere();
            $9014d97cd777be10$var$_sphere$4.copy(object.boundingSphere).applyMatrix4(object.matrixWorld);
        } else {
            const geometry = object.geometry;
            if (geometry.boundingSphere === null) geometry.computeBoundingSphere();
            $9014d97cd777be10$var$_sphere$4.copy(geometry.boundingSphere).applyMatrix4(object.matrixWorld);
        }
        return this.intersectsSphere($9014d97cd777be10$var$_sphere$4);
    }
    intersectsSprite(sprite) {
        $9014d97cd777be10$var$_sphere$4.center.set(0, 0, 0);
        $9014d97cd777be10$var$_sphere$4.radius = 0.7071067811865476;
        $9014d97cd777be10$var$_sphere$4.applyMatrix4(sprite.matrixWorld);
        return this.intersectsSphere($9014d97cd777be10$var$_sphere$4);
    }
    intersectsSphere(sphere) {
        const planes = this.planes;
        const center = sphere.center;
        const negRadius = -sphere.radius;
        for(let i = 0; i < 6; i++){
            const distance = planes[i].distanceToPoint(center);
            if (distance < negRadius) return false;
        }
        return true;
    }
    intersectsBox(box) {
        const planes = this.planes;
        for(let i = 0; i < 6; i++){
            const plane = planes[i];
            // corner at max distance
            $9014d97cd777be10$var$_vector$6.x = plane.normal.x > 0 ? box.max.x : box.min.x;
            $9014d97cd777be10$var$_vector$6.y = plane.normal.y > 0 ? box.max.y : box.min.y;
            $9014d97cd777be10$var$_vector$6.z = plane.normal.z > 0 ? box.max.z : box.min.z;
            if (plane.distanceToPoint($9014d97cd777be10$var$_vector$6) < 0) return false;
        }
        return true;
    }
    containsPoint(point) {
        const planes = this.planes;
        for(let i = 0; i < 6; i++){
            if (planes[i].distanceToPoint(point) < 0) return false;
        }
        return true;
    }
    clone() {
        return new this.constructor().copy(this);
    }
    constructor(p0 = new $9014d97cd777be10$export$7ff5ac152ef991b0(), p1 = new $9014d97cd777be10$export$7ff5ac152ef991b0(), p2 = new $9014d97cd777be10$export$7ff5ac152ef991b0(), p3 = new $9014d97cd777be10$export$7ff5ac152ef991b0(), p4 = new $9014d97cd777be10$export$7ff5ac152ef991b0(), p5 = new $9014d97cd777be10$export$7ff5ac152ef991b0()){
        this.planes = [
            p0,
            p1,
            p2,
            p3,
            p4,
            p5
        ];
    }
}
function $9014d97cd777be10$var$WebGLAnimation() {
    let context = null;
    let isAnimating = false;
    let animationLoop = null;
    let requestId = null;
    function onAnimationFrame(time, frame) {
        animationLoop(time, frame);
        requestId = context.requestAnimationFrame(onAnimationFrame);
    }
    return {
        start: function() {
            if (isAnimating === true) return;
            if (animationLoop === null) return;
            requestId = context.requestAnimationFrame(onAnimationFrame);
            isAnimating = true;
        },
        stop: function() {
            context.cancelAnimationFrame(requestId);
            isAnimating = false;
        },
        setAnimationLoop: function(callback) {
            animationLoop = callback;
        },
        setContext: function(value) {
            context = value;
        }
    };
}
function $9014d97cd777be10$var$WebGLAttributes(gl, capabilities) {
    const isWebGL2 = capabilities.isWebGL2;
    const buffers = new WeakMap();
    function createBuffer(attribute, bufferType) {
        const array = attribute.array;
        const usage = attribute.usage;
        const buffer = gl.createBuffer();
        gl.bindBuffer(bufferType, buffer);
        gl.bufferData(bufferType, array, usage);
        attribute.onUploadCallback();
        let type;
        if (array instanceof Float32Array) type = gl.FLOAT;
        else if (array instanceof Uint16Array) {
            if (attribute.isFloat16BufferAttribute) {
                if (isWebGL2) type = gl.HALF_FLOAT;
                else throw new Error("THREE.WebGLAttributes: Usage of Float16BufferAttribute requires WebGL2.");
            } else type = gl.UNSIGNED_SHORT;
        } else if (array instanceof Int16Array) type = gl.SHORT;
        else if (array instanceof Uint32Array) type = gl.UNSIGNED_INT;
        else if (array instanceof Int32Array) type = gl.INT;
        else if (array instanceof Int8Array) type = gl.BYTE;
        else if (array instanceof Uint8Array) type = gl.UNSIGNED_BYTE;
        else if (array instanceof Uint8ClampedArray) type = gl.UNSIGNED_BYTE;
        else throw new Error("THREE.WebGLAttributes: Unsupported buffer data format: " + array);
        return {
            buffer: buffer,
            type: type,
            bytesPerElement: array.BYTES_PER_ELEMENT,
            version: attribute.version
        };
    }
    function updateBuffer(buffer, attribute, bufferType) {
        const array = attribute.array;
        const updateRange = attribute.updateRange;
        gl.bindBuffer(bufferType, buffer);
        if (updateRange.count === -1) // Not using update ranges
        gl.bufferSubData(bufferType, 0, array);
        else {
            if (isWebGL2) gl.bufferSubData(bufferType, updateRange.offset * array.BYTES_PER_ELEMENT, array, updateRange.offset, updateRange.count);
            else gl.bufferSubData(bufferType, updateRange.offset * array.BYTES_PER_ELEMENT, array.subarray(updateRange.offset, updateRange.offset + updateRange.count));
            updateRange.count = -1; // reset range
        }
        attribute.onUploadCallback();
    }
    //
    function get(attribute) {
        if (attribute.isInterleavedBufferAttribute) attribute = attribute.data;
        return buffers.get(attribute);
    }
    function remove(attribute) {
        if (attribute.isInterleavedBufferAttribute) attribute = attribute.data;
        const data = buffers.get(attribute);
        if (data) {
            gl.deleteBuffer(data.buffer);
            buffers.delete(attribute);
        }
    }
    function update(attribute, bufferType) {
        if (attribute.isGLBufferAttribute) {
            const cached = buffers.get(attribute);
            if (!cached || cached.version < attribute.version) buffers.set(attribute, {
                buffer: attribute.buffer,
                type: attribute.type,
                bytesPerElement: attribute.elementSize,
                version: attribute.version
            });
            return;
        }
        if (attribute.isInterleavedBufferAttribute) attribute = attribute.data;
        const data = buffers.get(attribute);
        if (data === undefined) buffers.set(attribute, createBuffer(attribute, bufferType));
        else if (data.version < attribute.version) {
            updateBuffer(data.buffer, attribute, bufferType);
            data.version = attribute.version;
        }
    }
    return {
        get: get,
        remove: remove,
        update: update
    };
}
class $9014d97cd777be10$export$967d831af31f69ce extends $9014d97cd777be10$export$b7be63a67df8959 {
    copy(source) {
        super.copy(source);
        this.parameters = Object.assign({}, source.parameters);
        return this;
    }
    static fromJSON(data) {
        return new $9014d97cd777be10$export$967d831af31f69ce(data.width, data.height, data.widthSegments, data.heightSegments);
    }
    constructor(width = 1, height = 1, widthSegments = 1, heightSegments = 1){
        super();
        this.type = "PlaneGeometry";
        this.parameters = {
            width: width,
            height: height,
            widthSegments: widthSegments,
            heightSegments: heightSegments
        };
        const width_half = width / 2;
        const height_half = height / 2;
        const gridX = Math.floor(widthSegments);
        const gridY = Math.floor(heightSegments);
        const gridX1 = gridX + 1;
        const gridY1 = gridY + 1;
        const segment_width = width / gridX;
        const segment_height = height / gridY;
        //
        const indices = [];
        const vertices = [];
        const normals = [];
        const uvs = [];
        for(let iy = 0; iy < gridY1; iy++){
            const y = iy * segment_height - height_half;
            for(let ix = 0; ix < gridX1; ix++){
                const x = ix * segment_width - width_half;
                vertices.push(x, -y, 0);
                normals.push(0, 0, 1);
                uvs.push(ix / gridX);
                uvs.push(1 - iy / gridY);
            }
        }
        for(let iy = 0; iy < gridY; iy++)for(let ix = 0; ix < gridX; ix++){
            const a = ix + gridX1 * iy;
            const b = ix + gridX1 * (iy + 1);
            const c = ix + 1 + gridX1 * (iy + 1);
            const d = ix + 1 + gridX1 * iy;
            indices.push(a, b, d);
            indices.push(b, c, d);
        }
        this.setIndex(indices);
        this.setAttribute("position", new $9014d97cd777be10$export$cbe7a62641830ebd(vertices, 3));
        this.setAttribute("normal", new $9014d97cd777be10$export$cbe7a62641830ebd(normals, 3));
        this.setAttribute("uv", new $9014d97cd777be10$export$cbe7a62641830ebd(uvs, 2));
    }
}
var $9014d97cd777be10$var$alphahash_fragment = "#ifdef USE_ALPHAHASH\n	if ( diffuseColor.a < getAlphaHashThreshold( vPosition ) ) discard;\n#endif";
var $9014d97cd777be10$var$alphahash_pars_fragment = "#ifdef USE_ALPHAHASH\n	const float ALPHA_HASH_SCALE = 0.05;\n	float hash2D( vec2 value ) {\n		return fract( 1.0e4 * sin( 17.0 * value.x + 0.1 * value.y ) * ( 0.1 + abs( sin( 13.0 * value.y + value.x ) ) ) );\n	}\n	float hash3D( vec3 value ) {\n		return hash2D( vec2( hash2D( value.xy ), value.z ) );\n	}\n	float getAlphaHashThreshold( vec3 position ) {\n		float maxDeriv = max(\n			length( dFdx( position.xyz ) ),\n			length( dFdy( position.xyz ) )\n		);\n		float pixScale = 1.0 / ( ALPHA_HASH_SCALE * maxDeriv );\n		vec2 pixScales = vec2(\n			exp2( floor( log2( pixScale ) ) ),\n			exp2( ceil( log2( pixScale ) ) )\n		);\n		vec2 alpha = vec2(\n			hash3D( floor( pixScales.x * position.xyz ) ),\n			hash3D( floor( pixScales.y * position.xyz ) )\n		);\n		float lerpFactor = fract( log2( pixScale ) );\n		float x = ( 1.0 - lerpFactor ) * alpha.x + lerpFactor * alpha.y;\n		float a = min( lerpFactor, 1.0 - lerpFactor );\n		vec3 cases = vec3(\n			x * x / ( 2.0 * a * ( 1.0 - a ) ),\n			( x - 0.5 * a ) / ( 1.0 - a ),\n			1.0 - ( ( 1.0 - x ) * ( 1.0 - x ) / ( 2.0 * a * ( 1.0 - a ) ) )\n		);\n		float threshold = ( x < ( 1.0 - a ) )\n			? ( ( x < a ) ? cases.x : cases.y )\n			: cases.z;\n		return clamp( threshold , 1.0e-6, 1.0 );\n	}\n#endif";
var $9014d97cd777be10$var$alphamap_fragment = "#ifdef USE_ALPHAMAP\n	diffuseColor.a *= texture2D( alphaMap, vAlphaMapUv ).g;\n#endif";
var $9014d97cd777be10$var$alphamap_pars_fragment = "#ifdef USE_ALPHAMAP\n	uniform sampler2D alphaMap;\n#endif";
var $9014d97cd777be10$var$alphatest_fragment = "#ifdef USE_ALPHATEST\n	if ( diffuseColor.a < alphaTest ) discard;\n#endif";
var $9014d97cd777be10$var$alphatest_pars_fragment = "#ifdef USE_ALPHATEST\n	uniform float alphaTest;\n#endif";
var $9014d97cd777be10$var$aomap_fragment = "#ifdef USE_AOMAP\n	float ambientOcclusion = ( texture2D( aoMap, vAoMapUv ).r - 1.0 ) * aoMapIntensity + 1.0;\n	reflectedLight.indirectDiffuse *= ambientOcclusion;\n	#if defined( USE_ENVMAP ) && defined( STANDARD )\n		float dotNV = saturate( dot( geometry.normal, geometry.viewDir ) );\n		reflectedLight.indirectSpecular *= computeSpecularOcclusion( dotNV, ambientOcclusion, material.roughness );\n	#endif\n#endif";
var $9014d97cd777be10$var$aomap_pars_fragment = "#ifdef USE_AOMAP\n	uniform sampler2D aoMap;\n	uniform float aoMapIntensity;\n#endif";
var $9014d97cd777be10$var$begin_vertex = "vec3 transformed = vec3( position );\n#ifdef USE_ALPHAHASH\n	vPosition = vec3( position );\n#endif";
var $9014d97cd777be10$var$beginnormal_vertex = "vec3 objectNormal = vec3( normal );\n#ifdef USE_TANGENT\n	vec3 objectTangent = vec3( tangent.xyz );\n#endif";
var $9014d97cd777be10$var$bsdfs = "float G_BlinnPhong_Implicit( ) {\n	return 0.25;\n}\nfloat D_BlinnPhong( const in float shininess, const in float dotNH ) {\n	return RECIPROCAL_PI * ( shininess * 0.5 + 1.0 ) * pow( dotNH, shininess );\n}\nvec3 BRDF_BlinnPhong( const in vec3 lightDir, const in vec3 viewDir, const in vec3 normal, const in vec3 specularColor, const in float shininess ) {\n	vec3 halfDir = normalize( lightDir + viewDir );\n	float dotNH = saturate( dot( normal, halfDir ) );\n	float dotVH = saturate( dot( viewDir, halfDir ) );\n	vec3 F = F_Schlick( specularColor, 1.0, dotVH );\n	float G = G_BlinnPhong_Implicit( );\n	float D = D_BlinnPhong( shininess, dotNH );\n	return F * ( G * D );\n} // validated";
var $9014d97cd777be10$var$iridescence_fragment = "#ifdef USE_IRIDESCENCE\n	const mat3 XYZ_TO_REC709 = mat3(\n		 3.2404542, -0.9692660,  0.0556434,\n		-1.5371385,  1.8760108, -0.2040259,\n		-0.4985314,  0.0415560,  1.0572252\n	);\n	vec3 Fresnel0ToIor( vec3 fresnel0 ) {\n		vec3 sqrtF0 = sqrt( fresnel0 );\n		return ( vec3( 1.0 ) + sqrtF0 ) / ( vec3( 1.0 ) - sqrtF0 );\n	}\n	vec3 IorToFresnel0( vec3 transmittedIor, float incidentIor ) {\n		return pow2( ( transmittedIor - vec3( incidentIor ) ) / ( transmittedIor + vec3( incidentIor ) ) );\n	}\n	float IorToFresnel0( float transmittedIor, float incidentIor ) {\n		return pow2( ( transmittedIor - incidentIor ) / ( transmittedIor + incidentIor ));\n	}\n	vec3 evalSensitivity( float OPD, vec3 shift ) {\n		float phase = 2.0 * PI * OPD * 1.0e-9;\n		vec3 val = vec3( 5.4856e-13, 4.4201e-13, 5.2481e-13 );\n		vec3 pos = vec3( 1.6810e+06, 1.7953e+06, 2.2084e+06 );\n		vec3 var = vec3( 4.3278e+09, 9.3046e+09, 6.6121e+09 );\n		vec3 xyz = val * sqrt( 2.0 * PI * var ) * cos( pos * phase + shift ) * exp( - pow2( phase ) * var );\n		xyz.x += 9.7470e-14 * sqrt( 2.0 * PI * 4.5282e+09 ) * cos( 2.2399e+06 * phase + shift[ 0 ] ) * exp( - 4.5282e+09 * pow2( phase ) );\n		xyz /= 1.0685e-7;\n		vec3 rgb = XYZ_TO_REC709 * xyz;\n		return rgb;\n	}\n	vec3 evalIridescence( float outsideIOR, float eta2, float cosTheta1, float thinFilmThickness, vec3 baseF0 ) {\n		vec3 I;\n		float iridescenceIOR = mix( outsideIOR, eta2, smoothstep( 0.0, 0.03, thinFilmThickness ) );\n		float sinTheta2Sq = pow2( outsideIOR / iridescenceIOR ) * ( 1.0 - pow2( cosTheta1 ) );\n		float cosTheta2Sq = 1.0 - sinTheta2Sq;\n		if ( cosTheta2Sq < 0.0 ) {\n			return vec3( 1.0 );\n		}\n		float cosTheta2 = sqrt( cosTheta2Sq );\n		float R0 = IorToFresnel0( iridescenceIOR, outsideIOR );\n		float R12 = F_Schlick( R0, 1.0, cosTheta1 );\n		float T121 = 1.0 - R12;\n		float phi12 = 0.0;\n		if ( iridescenceIOR < outsideIOR ) phi12 = PI;\n		float phi21 = PI - phi12;\n		vec3 baseIOR = Fresnel0ToIor( clamp( baseF0, 0.0, 0.9999 ) );		vec3 R1 = IorToFresnel0( baseIOR, iridescenceIOR );\n		vec3 R23 = F_Schlick( R1, 1.0, cosTheta2 );\n		vec3 phi23 = vec3( 0.0 );\n		if ( baseIOR[ 0 ] < iridescenceIOR ) phi23[ 0 ] = PI;\n		if ( baseIOR[ 1 ] < iridescenceIOR ) phi23[ 1 ] = PI;\n		if ( baseIOR[ 2 ] < iridescenceIOR ) phi23[ 2 ] = PI;\n		float OPD = 2.0 * iridescenceIOR * thinFilmThickness * cosTheta2;\n		vec3 phi = vec3( phi21 ) + phi23;\n		vec3 R123 = clamp( R12 * R23, 1e-5, 0.9999 );\n		vec3 r123 = sqrt( R123 );\n		vec3 Rs = pow2( T121 ) * R23 / ( vec3( 1.0 ) - R123 );\n		vec3 C0 = R12 + Rs;\n		I = C0;\n		vec3 Cm = Rs - T121;\n		for ( int m = 1; m <= 2; ++ m ) {\n			Cm *= r123;\n			vec3 Sm = 2.0 * evalSensitivity( float( m ) * OPD, float( m ) * phi );\n			I += Cm * Sm;\n		}\n		return max( I, vec3( 0.0 ) );\n	}\n#endif";
var $9014d97cd777be10$var$bumpmap_pars_fragment = "#ifdef USE_BUMPMAP\n	uniform sampler2D bumpMap;\n	uniform float bumpScale;\n	vec2 dHdxy_fwd() {\n		vec2 dSTdx = dFdx( vBumpMapUv );\n		vec2 dSTdy = dFdy( vBumpMapUv );\n		float Hll = bumpScale * texture2D( bumpMap, vBumpMapUv ).x;\n		float dBx = bumpScale * texture2D( bumpMap, vBumpMapUv + dSTdx ).x - Hll;\n		float dBy = bumpScale * texture2D( bumpMap, vBumpMapUv + dSTdy ).x - Hll;\n		return vec2( dBx, dBy );\n	}\n	vec3 perturbNormalArb( vec3 surf_pos, vec3 surf_norm, vec2 dHdxy, float faceDirection ) {\n		vec3 vSigmaX = dFdx( surf_pos.xyz );\n		vec3 vSigmaY = dFdy( surf_pos.xyz );\n		vec3 vN = surf_norm;\n		vec3 R1 = cross( vSigmaY, vN );\n		vec3 R2 = cross( vN, vSigmaX );\n		float fDet = dot( vSigmaX, R1 ) * faceDirection;\n		vec3 vGrad = sign( fDet ) * ( dHdxy.x * R1 + dHdxy.y * R2 );\n		return normalize( abs( fDet ) * surf_norm - vGrad );\n	}\n#endif";
var $9014d97cd777be10$var$clipping_planes_fragment = "#if NUM_CLIPPING_PLANES > 0\n	vec4 plane;\n	#pragma unroll_loop_start\n	for ( int i = 0; i < UNION_CLIPPING_PLANES; i ++ ) {\n		plane = clippingPlanes[ i ];\n		if ( dot( vClipPosition, plane.xyz ) > plane.w ) discard;\n	}\n	#pragma unroll_loop_end\n	#if UNION_CLIPPING_PLANES < NUM_CLIPPING_PLANES\n		bool clipped = true;\n		#pragma unroll_loop_start\n		for ( int i = UNION_CLIPPING_PLANES; i < NUM_CLIPPING_PLANES; i ++ ) {\n			plane = clippingPlanes[ i ];\n			clipped = ( dot( vClipPosition, plane.xyz ) > plane.w ) && clipped;\n		}\n		#pragma unroll_loop_end\n		if ( clipped ) discard;\n	#endif\n#endif";
var $9014d97cd777be10$var$clipping_planes_pars_fragment = "#if NUM_CLIPPING_PLANES > 0\n	varying vec3 vClipPosition;\n	uniform vec4 clippingPlanes[ NUM_CLIPPING_PLANES ];\n#endif";
var $9014d97cd777be10$var$clipping_planes_pars_vertex = "#if NUM_CLIPPING_PLANES > 0\n	varying vec3 vClipPosition;\n#endif";
var $9014d97cd777be10$var$clipping_planes_vertex = "#if NUM_CLIPPING_PLANES > 0\n	vClipPosition = - mvPosition.xyz;\n#endif";
var $9014d97cd777be10$var$color_fragment = "#if defined( USE_COLOR_ALPHA )\n	diffuseColor *= vColor;\n#elif defined( USE_COLOR )\n	diffuseColor.rgb *= vColor;\n#endif";
var $9014d97cd777be10$var$color_pars_fragment = "#if defined( USE_COLOR_ALPHA )\n	varying vec4 vColor;\n#elif defined( USE_COLOR )\n	varying vec3 vColor;\n#endif";
var $9014d97cd777be10$var$color_pars_vertex = "#if defined( USE_COLOR_ALPHA )\n	varying vec4 vColor;\n#elif defined( USE_COLOR ) || defined( USE_INSTANCING_COLOR )\n	varying vec3 vColor;\n#endif";
var $9014d97cd777be10$var$color_vertex = "#if defined( USE_COLOR_ALPHA )\n	vColor = vec4( 1.0 );\n#elif defined( USE_COLOR ) || defined( USE_INSTANCING_COLOR )\n	vColor = vec3( 1.0 );\n#endif\n#ifdef USE_COLOR\n	vColor *= color;\n#endif\n#ifdef USE_INSTANCING_COLOR\n	vColor.xyz *= instanceColor.xyz;\n#endif";
var $9014d97cd777be10$var$common = "#define PI 3.141592653589793\n#define PI2 6.283185307179586\n#define PI_HALF 1.5707963267948966\n#define RECIPROCAL_PI 0.3183098861837907\n#define RECIPROCAL_PI2 0.15915494309189535\n#define EPSILON 1e-6\n#ifndef saturate\n#define saturate( a ) clamp( a, 0.0, 1.0 )\n#endif\n#define whiteComplement( a ) ( 1.0 - saturate( a ) )\nfloat pow2( const in float x ) { return x*x; }\nvec3 pow2( const in vec3 x ) { return x*x; }\nfloat pow3( const in float x ) { return x*x*x; }\nfloat pow4( const in float x ) { float x2 = x*x; return x2*x2; }\nfloat max3( const in vec3 v ) { return max( max( v.x, v.y ), v.z ); }\nfloat average( const in vec3 v ) { return dot( v, vec3( 0.3333333 ) ); }\nhighp float rand( const in vec2 uv ) {\n	const highp float a = 12.9898, b = 78.233, c = 43758.5453;\n	highp float dt = dot( uv.xy, vec2( a,b ) ), sn = mod( dt, PI );\n	return fract( sin( sn ) * c );\n}\n#ifdef HIGH_PRECISION\n	float precisionSafeLength( vec3 v ) { return length( v ); }\n#else\n	float precisionSafeLength( vec3 v ) {\n		float maxComponent = max3( abs( v ) );\n		return length( v / maxComponent ) * maxComponent;\n	}\n#endif\nstruct IncidentLight {\n	vec3 color;\n	vec3 direction;\n	bool visible;\n};\nstruct ReflectedLight {\n	vec3 directDiffuse;\n	vec3 directSpecular;\n	vec3 indirectDiffuse;\n	vec3 indirectSpecular;\n};\nstruct GeometricContext {\n	vec3 position;\n	vec3 normal;\n	vec3 viewDir;\n#ifdef USE_CLEARCOAT\n	vec3 clearcoatNormal;\n#endif\n};\n#ifdef USE_ALPHAHASH\n	varying vec3 vPosition;\n#endif\nvec3 transformDirection( in vec3 dir, in mat4 matrix ) {\n	return normalize( ( matrix * vec4( dir, 0.0 ) ).xyz );\n}\nvec3 inverseTransformDirection( in vec3 dir, in mat4 matrix ) {\n	return normalize( ( vec4( dir, 0.0 ) * matrix ).xyz );\n}\nmat3 transposeMat3( const in mat3 m ) {\n	mat3 tmp;\n	tmp[ 0 ] = vec3( m[ 0 ].x, m[ 1 ].x, m[ 2 ].x );\n	tmp[ 1 ] = vec3( m[ 0 ].y, m[ 1 ].y, m[ 2 ].y );\n	tmp[ 2 ] = vec3( m[ 0 ].z, m[ 1 ].z, m[ 2 ].z );\n	return tmp;\n}\nfloat luminance( const in vec3 rgb ) {\n	const vec3 weights = vec3( 0.2126729, 0.7151522, 0.0721750 );\n	return dot( weights, rgb );\n}\nbool isPerspectiveMatrix( mat4 m ) {\n	return m[ 2 ][ 3 ] == - 1.0;\n}\nvec2 equirectUv( in vec3 dir ) {\n	float u = atan( dir.z, dir.x ) * RECIPROCAL_PI2 + 0.5;\n	float v = asin( clamp( dir.y, - 1.0, 1.0 ) ) * RECIPROCAL_PI + 0.5;\n	return vec2( u, v );\n}\nvec3 BRDF_Lambert( const in vec3 diffuseColor ) {\n	return RECIPROCAL_PI * diffuseColor;\n}\nvec3 F_Schlick( const in vec3 f0, const in float f90, const in float dotVH ) {\n	float fresnel = exp2( ( - 5.55473 * dotVH - 6.98316 ) * dotVH );\n	return f0 * ( 1.0 - fresnel ) + ( f90 * fresnel );\n}\nfloat F_Schlick( const in float f0, const in float f90, const in float dotVH ) {\n	float fresnel = exp2( ( - 5.55473 * dotVH - 6.98316 ) * dotVH );\n	return f0 * ( 1.0 - fresnel ) + ( f90 * fresnel );\n} // validated";
var $9014d97cd777be10$var$cube_uv_reflection_fragment = "#ifdef ENVMAP_TYPE_CUBE_UV\n	#define cubeUV_minMipLevel 4.0\n	#define cubeUV_minTileSize 16.0\n	float getFace( vec3 direction ) {\n		vec3 absDirection = abs( direction );\n		float face = - 1.0;\n		if ( absDirection.x > absDirection.z ) {\n			if ( absDirection.x > absDirection.y )\n				face = direction.x > 0.0 ? 0.0 : 3.0;\n			else\n				face = direction.y > 0.0 ? 1.0 : 4.0;\n		} else {\n			if ( absDirection.z > absDirection.y )\n				face = direction.z > 0.0 ? 2.0 : 5.0;\n			else\n				face = direction.y > 0.0 ? 1.0 : 4.0;\n		}\n		return face;\n	}\n	vec2 getUV( vec3 direction, float face ) {\n		vec2 uv;\n		if ( face == 0.0 ) {\n			uv = vec2( direction.z, direction.y ) / abs( direction.x );\n		} else if ( face == 1.0 ) {\n			uv = vec2( - direction.x, - direction.z ) / abs( direction.y );\n		} else if ( face == 2.0 ) {\n			uv = vec2( - direction.x, direction.y ) / abs( direction.z );\n		} else if ( face == 3.0 ) {\n			uv = vec2( - direction.z, direction.y ) / abs( direction.x );\n		} else if ( face == 4.0 ) {\n			uv = vec2( - direction.x, direction.z ) / abs( direction.y );\n		} else {\n			uv = vec2( direction.x, direction.y ) / abs( direction.z );\n		}\n		return 0.5 * ( uv + 1.0 );\n	}\n	vec3 bilinearCubeUV( sampler2D envMap, vec3 direction, float mipInt ) {\n		float face = getFace( direction );\n		float filterInt = max( cubeUV_minMipLevel - mipInt, 0.0 );\n		mipInt = max( mipInt, cubeUV_minMipLevel );\n		float faceSize = exp2( mipInt );\n		highp vec2 uv = getUV( direction, face ) * ( faceSize - 2.0 ) + 1.0;\n		if ( face > 2.0 ) {\n			uv.y += faceSize;\n			face -= 3.0;\n		}\n		uv.x += face * faceSize;\n		uv.x += filterInt * 3.0 * cubeUV_minTileSize;\n		uv.y += 4.0 * ( exp2( CUBEUV_MAX_MIP ) - faceSize );\n		uv.x *= CUBEUV_TEXEL_WIDTH;\n		uv.y *= CUBEUV_TEXEL_HEIGHT;\n		#ifdef texture2DGradEXT\n			return texture2DGradEXT( envMap, uv, vec2( 0.0 ), vec2( 0.0 ) ).rgb;\n		#else\n			return texture2D( envMap, uv ).rgb;\n		#endif\n	}\n	#define cubeUV_r0 1.0\n	#define cubeUV_v0 0.339\n	#define cubeUV_m0 - 2.0\n	#define cubeUV_r1 0.8\n	#define cubeUV_v1 0.276\n	#define cubeUV_m1 - 1.0\n	#define cubeUV_r4 0.4\n	#define cubeUV_v4 0.046\n	#define cubeUV_m4 2.0\n	#define cubeUV_r5 0.305\n	#define cubeUV_v5 0.016\n	#define cubeUV_m5 3.0\n	#define cubeUV_r6 0.21\n	#define cubeUV_v6 0.0038\n	#define cubeUV_m6 4.0\n	float roughnessToMip( float roughness ) {\n		float mip = 0.0;\n		if ( roughness >= cubeUV_r1 ) {\n			mip = ( cubeUV_r0 - roughness ) * ( cubeUV_m1 - cubeUV_m0 ) / ( cubeUV_r0 - cubeUV_r1 ) + cubeUV_m0;\n		} else if ( roughness >= cubeUV_r4 ) {\n			mip = ( cubeUV_r1 - roughness ) * ( cubeUV_m4 - cubeUV_m1 ) / ( cubeUV_r1 - cubeUV_r4 ) + cubeUV_m1;\n		} else if ( roughness >= cubeUV_r5 ) {\n			mip = ( cubeUV_r4 - roughness ) * ( cubeUV_m5 - cubeUV_m4 ) / ( cubeUV_r4 - cubeUV_r5 ) + cubeUV_m4;\n		} else if ( roughness >= cubeUV_r6 ) {\n			mip = ( cubeUV_r5 - roughness ) * ( cubeUV_m6 - cubeUV_m5 ) / ( cubeUV_r5 - cubeUV_r6 ) + cubeUV_m5;\n		} else {\n			mip = - 2.0 * log2( 1.16 * roughness );		}\n		return mip;\n	}\n	vec4 textureCubeUV( sampler2D envMap, vec3 sampleDir, float roughness ) {\n		float mip = clamp( roughnessToMip( roughness ), cubeUV_m0, CUBEUV_MAX_MIP );\n		float mipF = fract( mip );\n		float mipInt = floor( mip );\n		vec3 color0 = bilinearCubeUV( envMap, sampleDir, mipInt );\n		if ( mipF == 0.0 ) {\n			return vec4( color0, 1.0 );\n		} else {\n			vec3 color1 = bilinearCubeUV( envMap, sampleDir, mipInt + 1.0 );\n			return vec4( mix( color0, color1, mipF ), 1.0 );\n		}\n	}\n#endif";
var $9014d97cd777be10$var$defaultnormal_vertex = "vec3 transformedNormal = objectNormal;\n#ifdef USE_INSTANCING\n	mat3 m = mat3( instanceMatrix );\n	transformedNormal /= vec3( dot( m[ 0 ], m[ 0 ] ), dot( m[ 1 ], m[ 1 ] ), dot( m[ 2 ], m[ 2 ] ) );\n	transformedNormal = m * transformedNormal;\n#endif\ntransformedNormal = normalMatrix * transformedNormal;\n#ifdef FLIP_SIDED\n	transformedNormal = - transformedNormal;\n#endif\n#ifdef USE_TANGENT\n	vec3 transformedTangent = ( modelViewMatrix * vec4( objectTangent, 0.0 ) ).xyz;\n	#ifdef FLIP_SIDED\n		transformedTangent = - transformedTangent;\n	#endif\n#endif";
var $9014d97cd777be10$var$displacementmap_pars_vertex = "#ifdef USE_DISPLACEMENTMAP\n	uniform sampler2D displacementMap;\n	uniform float displacementScale;\n	uniform float displacementBias;\n#endif";
var $9014d97cd777be10$var$displacementmap_vertex = "#ifdef USE_DISPLACEMENTMAP\n	transformed += normalize( objectNormal ) * ( texture2D( displacementMap, vDisplacementMapUv ).x * displacementScale + displacementBias );\n#endif";
var $9014d97cd777be10$var$emissivemap_fragment = "#ifdef USE_EMISSIVEMAP\n	vec4 emissiveColor = texture2D( emissiveMap, vEmissiveMapUv );\n	totalEmissiveRadiance *= emissiveColor.rgb;\n#endif";
var $9014d97cd777be10$var$emissivemap_pars_fragment = "#ifdef USE_EMISSIVEMAP\n	uniform sampler2D emissiveMap;\n#endif";
var $9014d97cd777be10$var$colorspace_fragment = "gl_FragColor = linearToOutputTexel( gl_FragColor );";
var $9014d97cd777be10$var$colorspace_pars_fragment = "vec4 LinearToLinear( in vec4 value ) {\n	return value;\n}\nvec4 LinearTosRGB( in vec4 value ) {\n	return vec4( mix( pow( value.rgb, vec3( 0.41666 ) ) * 1.055 - vec3( 0.055 ), value.rgb * 12.92, vec3( lessThanEqual( value.rgb, vec3( 0.0031308 ) ) ) ), value.a );\n}";
var $9014d97cd777be10$var$envmap_fragment = "#ifdef USE_ENVMAP\n	#ifdef ENV_WORLDPOS\n		vec3 cameraToFrag;\n		if ( isOrthographic ) {\n			cameraToFrag = normalize( vec3( - viewMatrix[ 0 ][ 2 ], - viewMatrix[ 1 ][ 2 ], - viewMatrix[ 2 ][ 2 ] ) );\n		} else {\n			cameraToFrag = normalize( vWorldPosition - cameraPosition );\n		}\n		vec3 worldNormal = inverseTransformDirection( normal, viewMatrix );\n		#ifdef ENVMAP_MODE_REFLECTION\n			vec3 reflectVec = reflect( cameraToFrag, worldNormal );\n		#else\n			vec3 reflectVec = refract( cameraToFrag, worldNormal, refractionRatio );\n		#endif\n	#else\n		vec3 reflectVec = vReflect;\n	#endif\n	#ifdef ENVMAP_TYPE_CUBE\n		vec4 envColor = textureCube( envMap, vec3( flipEnvMap * reflectVec.x, reflectVec.yz ) );\n	#else\n		vec4 envColor = vec4( 0.0 );\n	#endif\n	#ifdef ENVMAP_BLENDING_MULTIPLY\n		outgoingLight = mix( outgoingLight, outgoingLight * envColor.xyz, specularStrength * reflectivity );\n	#elif defined( ENVMAP_BLENDING_MIX )\n		outgoingLight = mix( outgoingLight, envColor.xyz, specularStrength * reflectivity );\n	#elif defined( ENVMAP_BLENDING_ADD )\n		outgoingLight += envColor.xyz * specularStrength * reflectivity;\n	#endif\n#endif";
var $9014d97cd777be10$var$envmap_common_pars_fragment = "#ifdef USE_ENVMAP\n	uniform float envMapIntensity;\n	uniform float flipEnvMap;\n	#ifdef ENVMAP_TYPE_CUBE\n		uniform samplerCube envMap;\n	#else\n		uniform sampler2D envMap;\n	#endif\n	\n#endif";
var $9014d97cd777be10$var$envmap_pars_fragment = "#ifdef USE_ENVMAP\n	uniform float reflectivity;\n	#if defined( USE_BUMPMAP ) || defined( USE_NORMALMAP ) || defined( PHONG ) || defined( LAMBERT )\n		#define ENV_WORLDPOS\n	#endif\n	#ifdef ENV_WORLDPOS\n		varying vec3 vWorldPosition;\n		uniform float refractionRatio;\n	#else\n		varying vec3 vReflect;\n	#endif\n#endif";
var $9014d97cd777be10$var$envmap_pars_vertex = "#ifdef USE_ENVMAP\n	#if defined( USE_BUMPMAP ) || defined( USE_NORMALMAP ) || defined( PHONG ) || defined( LAMBERT )\n		#define ENV_WORLDPOS\n	#endif\n	#ifdef ENV_WORLDPOS\n		\n		varying vec3 vWorldPosition;\n	#else\n		varying vec3 vReflect;\n		uniform float refractionRatio;\n	#endif\n#endif";
var $9014d97cd777be10$var$envmap_vertex = "#ifdef USE_ENVMAP\n	#ifdef ENV_WORLDPOS\n		vWorldPosition = worldPosition.xyz;\n	#else\n		vec3 cameraToVertex;\n		if ( isOrthographic ) {\n			cameraToVertex = normalize( vec3( - viewMatrix[ 0 ][ 2 ], - viewMatrix[ 1 ][ 2 ], - viewMatrix[ 2 ][ 2 ] ) );\n		} else {\n			cameraToVertex = normalize( worldPosition.xyz - cameraPosition );\n		}\n		vec3 worldNormal = inverseTransformDirection( transformedNormal, viewMatrix );\n		#ifdef ENVMAP_MODE_REFLECTION\n			vReflect = reflect( cameraToVertex, worldNormal );\n		#else\n			vReflect = refract( cameraToVertex, worldNormal, refractionRatio );\n		#endif\n	#endif\n#endif";
var $9014d97cd777be10$var$fog_vertex = "#ifdef USE_FOG\n	vFogDepth = - mvPosition.z;\n#endif";
var $9014d97cd777be10$var$fog_pars_vertex = "#ifdef USE_FOG\n	varying float vFogDepth;\n#endif";
var $9014d97cd777be10$var$fog_fragment = "#ifdef USE_FOG\n	#ifdef FOG_EXP2\n		float fogFactor = 1.0 - exp( - fogDensity * fogDensity * vFogDepth * vFogDepth );\n	#else\n		float fogFactor = smoothstep( fogNear, fogFar, vFogDepth );\n	#endif\n	gl_FragColor.rgb = mix( gl_FragColor.rgb, fogColor, fogFactor );\n#endif";
var $9014d97cd777be10$var$fog_pars_fragment = "#ifdef USE_FOG\n	uniform vec3 fogColor;\n	varying float vFogDepth;\n	#ifdef FOG_EXP2\n		uniform float fogDensity;\n	#else\n		uniform float fogNear;\n		uniform float fogFar;\n	#endif\n#endif";
var $9014d97cd777be10$var$gradientmap_pars_fragment = "#ifdef USE_GRADIENTMAP\n	uniform sampler2D gradientMap;\n#endif\nvec3 getGradientIrradiance( vec3 normal, vec3 lightDirection ) {\n	float dotNL = dot( normal, lightDirection );\n	vec2 coord = vec2( dotNL * 0.5 + 0.5, 0.0 );\n	#ifdef USE_GRADIENTMAP\n		return vec3( texture2D( gradientMap, coord ).r );\n	#else\n		vec2 fw = fwidth( coord ) * 0.5;\n		return mix( vec3( 0.7 ), vec3( 1.0 ), smoothstep( 0.7 - fw.x, 0.7 + fw.x, coord.x ) );\n	#endif\n}";
var $9014d97cd777be10$var$lightmap_fragment = "#ifdef USE_LIGHTMAP\n	vec4 lightMapTexel = texture2D( lightMap, vLightMapUv );\n	vec3 lightMapIrradiance = lightMapTexel.rgb * lightMapIntensity;\n	reflectedLight.indirectDiffuse += lightMapIrradiance;\n#endif";
var $9014d97cd777be10$var$lightmap_pars_fragment = "#ifdef USE_LIGHTMAP\n	uniform sampler2D lightMap;\n	uniform float lightMapIntensity;\n#endif";
var $9014d97cd777be10$var$lights_lambert_fragment = "LambertMaterial material;\nmaterial.diffuseColor = diffuseColor.rgb;\nmaterial.specularStrength = specularStrength;";
var $9014d97cd777be10$var$lights_lambert_pars_fragment = "varying vec3 vViewPosition;\nstruct LambertMaterial {\n	vec3 diffuseColor;\n	float specularStrength;\n};\nvoid RE_Direct_Lambert( const in IncidentLight directLight, const in GeometricContext geometry, const in LambertMaterial material, inout ReflectedLight reflectedLight ) {\n	float dotNL = saturate( dot( geometry.normal, directLight.direction ) );\n	vec3 irradiance = dotNL * directLight.color;\n	reflectedLight.directDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\nvoid RE_IndirectDiffuse_Lambert( const in vec3 irradiance, const in GeometricContext geometry, const in LambertMaterial material, inout ReflectedLight reflectedLight ) {\n	reflectedLight.indirectDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\n#define RE_Direct				RE_Direct_Lambert\n#define RE_IndirectDiffuse		RE_IndirectDiffuse_Lambert";
var $9014d97cd777be10$var$lights_pars_begin = "uniform bool receiveShadow;\nuniform vec3 ambientLightColor;\nuniform vec3 lightProbe[ 9 ];\nvec3 shGetIrradianceAt( in vec3 normal, in vec3 shCoefficients[ 9 ] ) {\n	float x = normal.x, y = normal.y, z = normal.z;\n	vec3 result = shCoefficients[ 0 ] * 0.886227;\n	result += shCoefficients[ 1 ] * 2.0 * 0.511664 * y;\n	result += shCoefficients[ 2 ] * 2.0 * 0.511664 * z;\n	result += shCoefficients[ 3 ] * 2.0 * 0.511664 * x;\n	result += shCoefficients[ 4 ] * 2.0 * 0.429043 * x * y;\n	result += shCoefficients[ 5 ] * 2.0 * 0.429043 * y * z;\n	result += shCoefficients[ 6 ] * ( 0.743125 * z * z - 0.247708 );\n	result += shCoefficients[ 7 ] * 2.0 * 0.429043 * x * z;\n	result += shCoefficients[ 8 ] * 0.429043 * ( x * x - y * y );\n	return result;\n}\nvec3 getLightProbeIrradiance( const in vec3 lightProbe[ 9 ], const in vec3 normal ) {\n	vec3 worldNormal = inverseTransformDirection( normal, viewMatrix );\n	vec3 irradiance = shGetIrradianceAt( worldNormal, lightProbe );\n	return irradiance;\n}\nvec3 getAmbientLightIrradiance( const in vec3 ambientLightColor ) {\n	vec3 irradiance = ambientLightColor;\n	return irradiance;\n}\nfloat getDistanceAttenuation( const in float lightDistance, const in float cutoffDistance, const in float decayExponent ) {\n	#if defined ( LEGACY_LIGHTS )\n		if ( cutoffDistance > 0.0 && decayExponent > 0.0 ) {\n			return pow( saturate( - lightDistance / cutoffDistance + 1.0 ), decayExponent );\n		}\n		return 1.0;\n	#else\n		float distanceFalloff = 1.0 / max( pow( lightDistance, decayExponent ), 0.01 );\n		if ( cutoffDistance > 0.0 ) {\n			distanceFalloff *= pow2( saturate( 1.0 - pow4( lightDistance / cutoffDistance ) ) );\n		}\n		return distanceFalloff;\n	#endif\n}\nfloat getSpotAttenuation( const in float coneCosine, const in float penumbraCosine, const in float angleCosine ) {\n	return smoothstep( coneCosine, penumbraCosine, angleCosine );\n}\n#if NUM_DIR_LIGHTS > 0\n	struct DirectionalLight {\n		vec3 direction;\n		vec3 color;\n	};\n	uniform DirectionalLight directionalLights[ NUM_DIR_LIGHTS ];\n	void getDirectionalLightInfo( const in DirectionalLight directionalLight, const in GeometricContext geometry, out IncidentLight light ) {\n		light.color = directionalLight.color;\n		light.direction = directionalLight.direction;\n		light.visible = true;\n	}\n#endif\n#if NUM_POINT_LIGHTS > 0\n	struct PointLight {\n		vec3 position;\n		vec3 color;\n		float distance;\n		float decay;\n	};\n	uniform PointLight pointLights[ NUM_POINT_LIGHTS ];\n	void getPointLightInfo( const in PointLight pointLight, const in GeometricContext geometry, out IncidentLight light ) {\n		vec3 lVector = pointLight.position - geometry.position;\n		light.direction = normalize( lVector );\n		float lightDistance = length( lVector );\n		light.color = pointLight.color;\n		light.color *= getDistanceAttenuation( lightDistance, pointLight.distance, pointLight.decay );\n		light.visible = ( light.color != vec3( 0.0 ) );\n	}\n#endif\n#if NUM_SPOT_LIGHTS > 0\n	struct SpotLight {\n		vec3 position;\n		vec3 direction;\n		vec3 color;\n		float distance;\n		float decay;\n		float coneCos;\n		float penumbraCos;\n	};\n	uniform SpotLight spotLights[ NUM_SPOT_LIGHTS ];\n	void getSpotLightInfo( const in SpotLight spotLight, const in GeometricContext geometry, out IncidentLight light ) {\n		vec3 lVector = spotLight.position - geometry.position;\n		light.direction = normalize( lVector );\n		float angleCos = dot( light.direction, spotLight.direction );\n		float spotAttenuation = getSpotAttenuation( spotLight.coneCos, spotLight.penumbraCos, angleCos );\n		if ( spotAttenuation > 0.0 ) {\n			float lightDistance = length( lVector );\n			light.color = spotLight.color * spotAttenuation;\n			light.color *= getDistanceAttenuation( lightDistance, spotLight.distance, spotLight.decay );\n			light.visible = ( light.color != vec3( 0.0 ) );\n		} else {\n			light.color = vec3( 0.0 );\n			light.visible = false;\n		}\n	}\n#endif\n#if NUM_RECT_AREA_LIGHTS > 0\n	struct RectAreaLight {\n		vec3 color;\n		vec3 position;\n		vec3 halfWidth;\n		vec3 halfHeight;\n	};\n	uniform sampler2D ltc_1;	uniform sampler2D ltc_2;\n	uniform RectAreaLight rectAreaLights[ NUM_RECT_AREA_LIGHTS ];\n#endif\n#if NUM_HEMI_LIGHTS > 0\n	struct HemisphereLight {\n		vec3 direction;\n		vec3 skyColor;\n		vec3 groundColor;\n	};\n	uniform HemisphereLight hemisphereLights[ NUM_HEMI_LIGHTS ];\n	vec3 getHemisphereLightIrradiance( const in HemisphereLight hemiLight, const in vec3 normal ) {\n		float dotNL = dot( normal, hemiLight.direction );\n		float hemiDiffuseWeight = 0.5 * dotNL + 0.5;\n		vec3 irradiance = mix( hemiLight.groundColor, hemiLight.skyColor, hemiDiffuseWeight );\n		return irradiance;\n	}\n#endif";
var $9014d97cd777be10$var$envmap_physical_pars_fragment = "#ifdef USE_ENVMAP\n	vec3 getIBLIrradiance( const in vec3 normal ) {\n		#ifdef ENVMAP_TYPE_CUBE_UV\n			vec3 worldNormal = inverseTransformDirection( normal, viewMatrix );\n			vec4 envMapColor = textureCubeUV( envMap, worldNormal, 1.0 );\n			return PI * envMapColor.rgb * envMapIntensity;\n		#else\n			return vec3( 0.0 );\n		#endif\n	}\n	vec3 getIBLRadiance( const in vec3 viewDir, const in vec3 normal, const in float roughness ) {\n		#ifdef ENVMAP_TYPE_CUBE_UV\n			vec3 reflectVec = reflect( - viewDir, normal );\n			reflectVec = normalize( mix( reflectVec, normal, roughness * roughness) );\n			reflectVec = inverseTransformDirection( reflectVec, viewMatrix );\n			vec4 envMapColor = textureCubeUV( envMap, reflectVec, roughness );\n			return envMapColor.rgb * envMapIntensity;\n		#else\n			return vec3( 0.0 );\n		#endif\n	}\n	#ifdef USE_ANISOTROPY\n		vec3 getIBLAnisotropyRadiance( const in vec3 viewDir, const in vec3 normal, const in float roughness, const in vec3 bitangent, const in float anisotropy ) {\n			#ifdef ENVMAP_TYPE_CUBE_UV\n				vec3 bentNormal = cross( bitangent, viewDir );\n				bentNormal = normalize( cross( bentNormal, bitangent ) );\n				bentNormal = normalize( mix( bentNormal, normal, pow2( pow2( 1.0 - anisotropy * ( 1.0 - roughness ) ) ) ) );\n				return getIBLRadiance( viewDir, bentNormal, roughness );\n			#else\n				return vec3( 0.0 );\n			#endif\n		}\n	#endif\n#endif";
var $9014d97cd777be10$var$lights_toon_fragment = "ToonMaterial material;\nmaterial.diffuseColor = diffuseColor.rgb;";
var $9014d97cd777be10$var$lights_toon_pars_fragment = "varying vec3 vViewPosition;\nstruct ToonMaterial {\n	vec3 diffuseColor;\n};\nvoid RE_Direct_Toon( const in IncidentLight directLight, const in GeometricContext geometry, const in ToonMaterial material, inout ReflectedLight reflectedLight ) {\n	vec3 irradiance = getGradientIrradiance( geometry.normal, directLight.direction ) * directLight.color;\n	reflectedLight.directDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\nvoid RE_IndirectDiffuse_Toon( const in vec3 irradiance, const in GeometricContext geometry, const in ToonMaterial material, inout ReflectedLight reflectedLight ) {\n	reflectedLight.indirectDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\n#define RE_Direct				RE_Direct_Toon\n#define RE_IndirectDiffuse		RE_IndirectDiffuse_Toon";
var $9014d97cd777be10$var$lights_phong_fragment = "BlinnPhongMaterial material;\nmaterial.diffuseColor = diffuseColor.rgb;\nmaterial.specularColor = specular;\nmaterial.specularShininess = shininess;\nmaterial.specularStrength = specularStrength;";
var $9014d97cd777be10$var$lights_phong_pars_fragment = "varying vec3 vViewPosition;\nstruct BlinnPhongMaterial {\n	vec3 diffuseColor;\n	vec3 specularColor;\n	float specularShininess;\n	float specularStrength;\n};\nvoid RE_Direct_BlinnPhong( const in IncidentLight directLight, const in GeometricContext geometry, const in BlinnPhongMaterial material, inout ReflectedLight reflectedLight ) {\n	float dotNL = saturate( dot( geometry.normal, directLight.direction ) );\n	vec3 irradiance = dotNL * directLight.color;\n	reflectedLight.directDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n	reflectedLight.directSpecular += irradiance * BRDF_BlinnPhong( directLight.direction, geometry.viewDir, geometry.normal, material.specularColor, material.specularShininess ) * material.specularStrength;\n}\nvoid RE_IndirectDiffuse_BlinnPhong( const in vec3 irradiance, const in GeometricContext geometry, const in BlinnPhongMaterial material, inout ReflectedLight reflectedLight ) {\n	reflectedLight.indirectDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\n#define RE_Direct				RE_Direct_BlinnPhong\n#define RE_IndirectDiffuse		RE_IndirectDiffuse_BlinnPhong";
var $9014d97cd777be10$var$lights_physical_fragment = "PhysicalMaterial material;\nmaterial.diffuseColor = diffuseColor.rgb * ( 1.0 - metalnessFactor );\nvec3 dxy = max( abs( dFdx( geometryNormal ) ), abs( dFdy( geometryNormal ) ) );\nfloat geometryRoughness = max( max( dxy.x, dxy.y ), dxy.z );\nmaterial.roughness = max( roughnessFactor, 0.0525 );material.roughness += geometryRoughness;\nmaterial.roughness = min( material.roughness, 1.0 );\n#ifdef IOR\n	material.ior = ior;\n	#ifdef USE_SPECULAR\n		float specularIntensityFactor = specularIntensity;\n		vec3 specularColorFactor = specularColor;\n		#ifdef USE_SPECULAR_COLORMAP\n			specularColorFactor *= texture2D( specularColorMap, vSpecularColorMapUv ).rgb;\n		#endif\n		#ifdef USE_SPECULAR_INTENSITYMAP\n			specularIntensityFactor *= texture2D( specularIntensityMap, vSpecularIntensityMapUv ).a;\n		#endif\n		material.specularF90 = mix( specularIntensityFactor, 1.0, metalnessFactor );\n	#else\n		float specularIntensityFactor = 1.0;\n		vec3 specularColorFactor = vec3( 1.0 );\n		material.specularF90 = 1.0;\n	#endif\n	material.specularColor = mix( min( pow2( ( material.ior - 1.0 ) / ( material.ior + 1.0 ) ) * specularColorFactor, vec3( 1.0 ) ) * specularIntensityFactor, diffuseColor.rgb, metalnessFactor );\n#else\n	material.specularColor = mix( vec3( 0.04 ), diffuseColor.rgb, metalnessFactor );\n	material.specularF90 = 1.0;\n#endif\n#ifdef USE_CLEARCOAT\n	material.clearcoat = clearcoat;\n	material.clearcoatRoughness = clearcoatRoughness;\n	material.clearcoatF0 = vec3( 0.04 );\n	material.clearcoatF90 = 1.0;\n	#ifdef USE_CLEARCOATMAP\n		material.clearcoat *= texture2D( clearcoatMap, vClearcoatMapUv ).x;\n	#endif\n	#ifdef USE_CLEARCOAT_ROUGHNESSMAP\n		material.clearcoatRoughness *= texture2D( clearcoatRoughnessMap, vClearcoatRoughnessMapUv ).y;\n	#endif\n	material.clearcoat = saturate( material.clearcoat );	material.clearcoatRoughness = max( material.clearcoatRoughness, 0.0525 );\n	material.clearcoatRoughness += geometryRoughness;\n	material.clearcoatRoughness = min( material.clearcoatRoughness, 1.0 );\n#endif\n#ifdef USE_IRIDESCENCE\n	material.iridescence = iridescence;\n	material.iridescenceIOR = iridescenceIOR;\n	#ifdef USE_IRIDESCENCEMAP\n		material.iridescence *= texture2D( iridescenceMap, vIridescenceMapUv ).r;\n	#endif\n	#ifdef USE_IRIDESCENCE_THICKNESSMAP\n		material.iridescenceThickness = (iridescenceThicknessMaximum - iridescenceThicknessMinimum) * texture2D( iridescenceThicknessMap, vIridescenceThicknessMapUv ).g + iridescenceThicknessMinimum;\n	#else\n		material.iridescenceThickness = iridescenceThicknessMaximum;\n	#endif\n#endif\n#ifdef USE_SHEEN\n	material.sheenColor = sheenColor;\n	#ifdef USE_SHEEN_COLORMAP\n		material.sheenColor *= texture2D( sheenColorMap, vSheenColorMapUv ).rgb;\n	#endif\n	material.sheenRoughness = clamp( sheenRoughness, 0.07, 1.0 );\n	#ifdef USE_SHEEN_ROUGHNESSMAP\n		material.sheenRoughness *= texture2D( sheenRoughnessMap, vSheenRoughnessMapUv ).a;\n	#endif\n#endif\n#ifdef USE_ANISOTROPY\n	#ifdef USE_ANISOTROPYMAP\n		mat2 anisotropyMat = mat2( anisotropyVector.x, anisotropyVector.y, - anisotropyVector.y, anisotropyVector.x );\n		vec3 anisotropyPolar = texture2D( anisotropyMap, vAnisotropyMapUv ).rgb;\n		vec2 anisotropyV = anisotropyMat * normalize( 2.0 * anisotropyPolar.rg - vec2( 1.0 ) ) * anisotropyPolar.b;\n	#else\n		vec2 anisotropyV = anisotropyVector;\n	#endif\n	material.anisotropy = length( anisotropyV );\n	anisotropyV /= material.anisotropy;\n	material.anisotropy = saturate( material.anisotropy );\n	material.alphaT = mix( pow2( material.roughness ), 1.0, pow2( material.anisotropy ) );\n	material.anisotropyT = tbn[ 0 ] * anisotropyV.x - tbn[ 1 ] * anisotropyV.y;\n	material.anisotropyB = tbn[ 1 ] * anisotropyV.x + tbn[ 0 ] * anisotropyV.y;\n#endif";
var $9014d97cd777be10$var$lights_physical_pars_fragment = "struct PhysicalMaterial {\n	vec3 diffuseColor;\n	float roughness;\n	vec3 specularColor;\n	float specularF90;\n	#ifdef USE_CLEARCOAT\n		float clearcoat;\n		float clearcoatRoughness;\n		vec3 clearcoatF0;\n		float clearcoatF90;\n	#endif\n	#ifdef USE_IRIDESCENCE\n		float iridescence;\n		float iridescenceIOR;\n		float iridescenceThickness;\n		vec3 iridescenceFresnel;\n		vec3 iridescenceF0;\n	#endif\n	#ifdef USE_SHEEN\n		vec3 sheenColor;\n		float sheenRoughness;\n	#endif\n	#ifdef IOR\n		float ior;\n	#endif\n	#ifdef USE_TRANSMISSION\n		float transmission;\n		float transmissionAlpha;\n		float thickness;\n		float attenuationDistance;\n		vec3 attenuationColor;\n	#endif\n	#ifdef USE_ANISOTROPY\n		float anisotropy;\n		float alphaT;\n		vec3 anisotropyT;\n		vec3 anisotropyB;\n	#endif\n};\nvec3 clearcoatSpecular = vec3( 0.0 );\nvec3 sheenSpecular = vec3( 0.0 );\nvec3 Schlick_to_F0( const in vec3 f, const in float f90, const in float dotVH ) {\n    float x = clamp( 1.0 - dotVH, 0.0, 1.0 );\n    float x2 = x * x;\n    float x5 = clamp( x * x2 * x2, 0.0, 0.9999 );\n    return ( f - vec3( f90 ) * x5 ) / ( 1.0 - x5 );\n}\nfloat V_GGX_SmithCorrelated( const in float alpha, const in float dotNL, const in float dotNV ) {\n	float a2 = pow2( alpha );\n	float gv = dotNL * sqrt( a2 + ( 1.0 - a2 ) * pow2( dotNV ) );\n	float gl = dotNV * sqrt( a2 + ( 1.0 - a2 ) * pow2( dotNL ) );\n	return 0.5 / max( gv + gl, EPSILON );\n}\nfloat D_GGX( const in float alpha, const in float dotNH ) {\n	float a2 = pow2( alpha );\n	float denom = pow2( dotNH ) * ( a2 - 1.0 ) + 1.0;\n	return RECIPROCAL_PI * a2 / pow2( denom );\n}\n#ifdef USE_ANISOTROPY\n	float V_GGX_SmithCorrelated_Anisotropic( const in float alphaT, const in float alphaB, const in float dotTV, const in float dotBV, const in float dotTL, const in float dotBL, const in float dotNV, const in float dotNL ) {\n		float gv = dotNL * length( vec3( alphaT * dotTV, alphaB * dotBV, dotNV ) );\n		float gl = dotNV * length( vec3( alphaT * dotTL, alphaB * dotBL, dotNL ) );\n		float v = 0.5 / ( gv + gl );\n		return saturate(v);\n	}\n	float D_GGX_Anisotropic( const in float alphaT, const in float alphaB, const in float dotNH, const in float dotTH, const in float dotBH ) {\n		float a2 = alphaT * alphaB;\n		highp vec3 v = vec3( alphaB * dotTH, alphaT * dotBH, a2 * dotNH );\n		highp float v2 = dot( v, v );\n		float w2 = a2 / v2;\n		return RECIPROCAL_PI * a2 * pow2 ( w2 );\n	}\n#endif\n#ifdef USE_CLEARCOAT\n	vec3 BRDF_GGX_Clearcoat( const in vec3 lightDir, const in vec3 viewDir, const in vec3 normal, const in PhysicalMaterial material) {\n		vec3 f0 = material.clearcoatF0;\n		float f90 = material.clearcoatF90;\n		float roughness = material.clearcoatRoughness;\n		float alpha = pow2( roughness );\n		vec3 halfDir = normalize( lightDir + viewDir );\n		float dotNL = saturate( dot( normal, lightDir ) );\n		float dotNV = saturate( dot( normal, viewDir ) );\n		float dotNH = saturate( dot( normal, halfDir ) );\n		float dotVH = saturate( dot( viewDir, halfDir ) );\n		vec3 F = F_Schlick( f0, f90, dotVH );\n		float V = V_GGX_SmithCorrelated( alpha, dotNL, dotNV );\n		float D = D_GGX( alpha, dotNH );\n		return F * ( V * D );\n	}\n#endif\nvec3 BRDF_GGX( const in vec3 lightDir, const in vec3 viewDir, const in vec3 normal, const in PhysicalMaterial material ) {\n	vec3 f0 = material.specularColor;\n	float f90 = material.specularF90;\n	float roughness = material.roughness;\n	float alpha = pow2( roughness );\n	vec3 halfDir = normalize( lightDir + viewDir );\n	float dotNL = saturate( dot( normal, lightDir ) );\n	float dotNV = saturate( dot( normal, viewDir ) );\n	float dotNH = saturate( dot( normal, halfDir ) );\n	float dotVH = saturate( dot( viewDir, halfDir ) );\n	vec3 F = F_Schlick( f0, f90, dotVH );\n	#ifdef USE_IRIDESCENCE\n		F = mix( F, material.iridescenceFresnel, material.iridescence );\n	#endif\n	#ifdef USE_ANISOTROPY\n		float dotTL = dot( material.anisotropyT, lightDir );\n		float dotTV = dot( material.anisotropyT, viewDir );\n		float dotTH = dot( material.anisotropyT, halfDir );\n		float dotBL = dot( material.anisotropyB, lightDir );\n		float dotBV = dot( material.anisotropyB, viewDir );\n		float dotBH = dot( material.anisotropyB, halfDir );\n		float V = V_GGX_SmithCorrelated_Anisotropic( material.alphaT, alpha, dotTV, dotBV, dotTL, dotBL, dotNV, dotNL );\n		float D = D_GGX_Anisotropic( material.alphaT, alpha, dotNH, dotTH, dotBH );\n	#else\n		float V = V_GGX_SmithCorrelated( alpha, dotNL, dotNV );\n		float D = D_GGX( alpha, dotNH );\n	#endif\n	return F * ( V * D );\n}\nvec2 LTC_Uv( const in vec3 N, const in vec3 V, const in float roughness ) {\n	const float LUT_SIZE = 64.0;\n	const float LUT_SCALE = ( LUT_SIZE - 1.0 ) / LUT_SIZE;\n	const float LUT_BIAS = 0.5 / LUT_SIZE;\n	float dotNV = saturate( dot( N, V ) );\n	vec2 uv = vec2( roughness, sqrt( 1.0 - dotNV ) );\n	uv = uv * LUT_SCALE + LUT_BIAS;\n	return uv;\n}\nfloat LTC_ClippedSphereFormFactor( const in vec3 f ) {\n	float l = length( f );\n	return max( ( l * l + f.z ) / ( l + 1.0 ), 0.0 );\n}\nvec3 LTC_EdgeVectorFormFactor( const in vec3 v1, const in vec3 v2 ) {\n	float x = dot( v1, v2 );\n	float y = abs( x );\n	float a = 0.8543985 + ( 0.4965155 + 0.0145206 * y ) * y;\n	float b = 3.4175940 + ( 4.1616724 + y ) * y;\n	float v = a / b;\n	float theta_sintheta = ( x > 0.0 ) ? v : 0.5 * inversesqrt( max( 1.0 - x * x, 1e-7 ) ) - v;\n	return cross( v1, v2 ) * theta_sintheta;\n}\nvec3 LTC_Evaluate( const in vec3 N, const in vec3 V, const in vec3 P, const in mat3 mInv, const in vec3 rectCoords[ 4 ] ) {\n	vec3 v1 = rectCoords[ 1 ] - rectCoords[ 0 ];\n	vec3 v2 = rectCoords[ 3 ] - rectCoords[ 0 ];\n	vec3 lightNormal = cross( v1, v2 );\n	if( dot( lightNormal, P - rectCoords[ 0 ] ) < 0.0 ) return vec3( 0.0 );\n	vec3 T1, T2;\n	T1 = normalize( V - N * dot( V, N ) );\n	T2 = - cross( N, T1 );\n	mat3 mat = mInv * transposeMat3( mat3( T1, T2, N ) );\n	vec3 coords[ 4 ];\n	coords[ 0 ] = mat * ( rectCoords[ 0 ] - P );\n	coords[ 1 ] = mat * ( rectCoords[ 1 ] - P );\n	coords[ 2 ] = mat * ( rectCoords[ 2 ] - P );\n	coords[ 3 ] = mat * ( rectCoords[ 3 ] - P );\n	coords[ 0 ] = normalize( coords[ 0 ] );\n	coords[ 1 ] = normalize( coords[ 1 ] );\n	coords[ 2 ] = normalize( coords[ 2 ] );\n	coords[ 3 ] = normalize( coords[ 3 ] );\n	vec3 vectorFormFactor = vec3( 0.0 );\n	vectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 0 ], coords[ 1 ] );\n	vectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 1 ], coords[ 2 ] );\n	vectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 2 ], coords[ 3 ] );\n	vectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 3 ], coords[ 0 ] );\n	float result = LTC_ClippedSphereFormFactor( vectorFormFactor );\n	return vec3( result );\n}\n#if defined( USE_SHEEN )\nfloat D_Charlie( float roughness, float dotNH ) {\n	float alpha = pow2( roughness );\n	float invAlpha = 1.0 / alpha;\n	float cos2h = dotNH * dotNH;\n	float sin2h = max( 1.0 - cos2h, 0.0078125 );\n	return ( 2.0 + invAlpha ) * pow( sin2h, invAlpha * 0.5 ) / ( 2.0 * PI );\n}\nfloat V_Neubelt( float dotNV, float dotNL ) {\n	return saturate( 1.0 / ( 4.0 * ( dotNL + dotNV - dotNL * dotNV ) ) );\n}\nvec3 BRDF_Sheen( const in vec3 lightDir, const in vec3 viewDir, const in vec3 normal, vec3 sheenColor, const in float sheenRoughness ) {\n	vec3 halfDir = normalize( lightDir + viewDir );\n	float dotNL = saturate( dot( normal, lightDir ) );\n	float dotNV = saturate( dot( normal, viewDir ) );\n	float dotNH = saturate( dot( normal, halfDir ) );\n	float D = D_Charlie( sheenRoughness, dotNH );\n	float V = V_Neubelt( dotNV, dotNL );\n	return sheenColor * ( D * V );\n}\n#endif\nfloat IBLSheenBRDF( const in vec3 normal, const in vec3 viewDir, const in float roughness ) {\n	float dotNV = saturate( dot( normal, viewDir ) );\n	float r2 = roughness * roughness;\n	float a = roughness < 0.25 ? -339.2 * r2 + 161.4 * roughness - 25.9 : -8.48 * r2 + 14.3 * roughness - 9.95;\n	float b = roughness < 0.25 ? 44.0 * r2 - 23.7 * roughness + 3.26 : 1.97 * r2 - 3.27 * roughness + 0.72;\n	float DG = exp( a * dotNV + b ) + ( roughness < 0.25 ? 0.0 : 0.1 * ( roughness - 0.25 ) );\n	return saturate( DG * RECIPROCAL_PI );\n}\nvec2 DFGApprox( const in vec3 normal, const in vec3 viewDir, const in float roughness ) {\n	float dotNV = saturate( dot( normal, viewDir ) );\n	const vec4 c0 = vec4( - 1, - 0.0275, - 0.572, 0.022 );\n	const vec4 c1 = vec4( 1, 0.0425, 1.04, - 0.04 );\n	vec4 r = roughness * c0 + c1;\n	float a004 = min( r.x * r.x, exp2( - 9.28 * dotNV ) ) * r.x + r.y;\n	vec2 fab = vec2( - 1.04, 1.04 ) * a004 + r.zw;\n	return fab;\n}\nvec3 EnvironmentBRDF( const in vec3 normal, const in vec3 viewDir, const in vec3 specularColor, const in float specularF90, const in float roughness ) {\n	vec2 fab = DFGApprox( normal, viewDir, roughness );\n	return specularColor * fab.x + specularF90 * fab.y;\n}\n#ifdef USE_IRIDESCENCE\nvoid computeMultiscatteringIridescence( const in vec3 normal, const in vec3 viewDir, const in vec3 specularColor, const in float specularF90, const in float iridescence, const in vec3 iridescenceF0, const in float roughness, inout vec3 singleScatter, inout vec3 multiScatter ) {\n#else\nvoid computeMultiscattering( const in vec3 normal, const in vec3 viewDir, const in vec3 specularColor, const in float specularF90, const in float roughness, inout vec3 singleScatter, inout vec3 multiScatter ) {\n#endif\n	vec2 fab = DFGApprox( normal, viewDir, roughness );\n	#ifdef USE_IRIDESCENCE\n		vec3 Fr = mix( specularColor, iridescenceF0, iridescence );\n	#else\n		vec3 Fr = specularColor;\n	#endif\n	vec3 FssEss = Fr * fab.x + specularF90 * fab.y;\n	float Ess = fab.x + fab.y;\n	float Ems = 1.0 - Ess;\n	vec3 Favg = Fr + ( 1.0 - Fr ) * 0.047619;	vec3 Fms = FssEss * Favg / ( 1.0 - Ems * Favg );\n	singleScatter += FssEss;\n	multiScatter += Fms * Ems;\n}\n#if NUM_RECT_AREA_LIGHTS > 0\n	void RE_Direct_RectArea_Physical( const in RectAreaLight rectAreaLight, const in GeometricContext geometry, const in PhysicalMaterial material, inout ReflectedLight reflectedLight ) {\n		vec3 normal = geometry.normal;\n		vec3 viewDir = geometry.viewDir;\n		vec3 position = geometry.position;\n		vec3 lightPos = rectAreaLight.position;\n		vec3 halfWidth = rectAreaLight.halfWidth;\n		vec3 halfHeight = rectAreaLight.halfHeight;\n		vec3 lightColor = rectAreaLight.color;\n		float roughness = material.roughness;\n		vec3 rectCoords[ 4 ];\n		rectCoords[ 0 ] = lightPos + halfWidth - halfHeight;		rectCoords[ 1 ] = lightPos - halfWidth - halfHeight;\n		rectCoords[ 2 ] = lightPos - halfWidth + halfHeight;\n		rectCoords[ 3 ] = lightPos + halfWidth + halfHeight;\n		vec2 uv = LTC_Uv( normal, viewDir, roughness );\n		vec4 t1 = texture2D( ltc_1, uv );\n		vec4 t2 = texture2D( ltc_2, uv );\n		mat3 mInv = mat3(\n			vec3( t1.x, 0, t1.y ),\n			vec3(    0, 1,    0 ),\n			vec3( t1.z, 0, t1.w )\n		);\n		vec3 fresnel = ( material.specularColor * t2.x + ( vec3( 1.0 ) - material.specularColor ) * t2.y );\n		reflectedLight.directSpecular += lightColor * fresnel * LTC_Evaluate( normal, viewDir, position, mInv, rectCoords );\n		reflectedLight.directDiffuse += lightColor * material.diffuseColor * LTC_Evaluate( normal, viewDir, position, mat3( 1.0 ), rectCoords );\n	}\n#endif\nvoid RE_Direct_Physical( const in IncidentLight directLight, const in GeometricContext geometry, const in PhysicalMaterial material, inout ReflectedLight reflectedLight ) {\n	float dotNL = saturate( dot( geometry.normal, directLight.direction ) );\n	vec3 irradiance = dotNL * directLight.color;\n	#ifdef USE_CLEARCOAT\n		float dotNLcc = saturate( dot( geometry.clearcoatNormal, directLight.direction ) );\n		vec3 ccIrradiance = dotNLcc * directLight.color;\n		clearcoatSpecular += ccIrradiance * BRDF_GGX_Clearcoat( directLight.direction, geometry.viewDir, geometry.clearcoatNormal, material );\n	#endif\n	#ifdef USE_SHEEN\n		sheenSpecular += irradiance * BRDF_Sheen( directLight.direction, geometry.viewDir, geometry.normal, material.sheenColor, material.sheenRoughness );\n	#endif\n	reflectedLight.directSpecular += irradiance * BRDF_GGX( directLight.direction, geometry.viewDir, geometry.normal, material );\n	reflectedLight.directDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\nvoid RE_IndirectDiffuse_Physical( const in vec3 irradiance, const in GeometricContext geometry, const in PhysicalMaterial material, inout ReflectedLight reflectedLight ) {\n	reflectedLight.indirectDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\nvoid RE_IndirectSpecular_Physical( const in vec3 radiance, const in vec3 irradiance, const in vec3 clearcoatRadiance, const in GeometricContext geometry, const in PhysicalMaterial material, inout ReflectedLight reflectedLight) {\n	#ifdef USE_CLEARCOAT\n		clearcoatSpecular += clearcoatRadiance * EnvironmentBRDF( geometry.clearcoatNormal, geometry.viewDir, material.clearcoatF0, material.clearcoatF90, material.clearcoatRoughness );\n	#endif\n	#ifdef USE_SHEEN\n		sheenSpecular += irradiance * material.sheenColor * IBLSheenBRDF( geometry.normal, geometry.viewDir, material.sheenRoughness );\n	#endif\n	vec3 singleScattering = vec3( 0.0 );\n	vec3 multiScattering = vec3( 0.0 );\n	vec3 cosineWeightedIrradiance = irradiance * RECIPROCAL_PI;\n	#ifdef USE_IRIDESCENCE\n		computeMultiscatteringIridescence( geometry.normal, geometry.viewDir, material.specularColor, material.specularF90, material.iridescence, material.iridescenceFresnel, material.roughness, singleScattering, multiScattering );\n	#else\n		computeMultiscattering( geometry.normal, geometry.viewDir, material.specularColor, material.specularF90, material.roughness, singleScattering, multiScattering );\n	#endif\n	vec3 totalScattering = singleScattering + multiScattering;\n	vec3 diffuse = material.diffuseColor * ( 1.0 - max( max( totalScattering.r, totalScattering.g ), totalScattering.b ) );\n	reflectedLight.indirectSpecular += radiance * singleScattering;\n	reflectedLight.indirectSpecular += multiScattering * cosineWeightedIrradiance;\n	reflectedLight.indirectDiffuse += diffuse * cosineWeightedIrradiance;\n}\n#define RE_Direct				RE_Direct_Physical\n#define RE_Direct_RectArea		RE_Direct_RectArea_Physical\n#define RE_IndirectDiffuse		RE_IndirectDiffuse_Physical\n#define RE_IndirectSpecular		RE_IndirectSpecular_Physical\nfloat computeSpecularOcclusion( const in float dotNV, const in float ambientOcclusion, const in float roughness ) {\n	return saturate( pow( dotNV + ambientOcclusion, exp2( - 16.0 * roughness - 1.0 ) ) - 1.0 + ambientOcclusion );\n}";
var $9014d97cd777be10$var$lights_fragment_begin = "\nGeometricContext geometry;\ngeometry.position = - vViewPosition;\ngeometry.normal = normal;\ngeometry.viewDir = ( isOrthographic ) ? vec3( 0, 0, 1 ) : normalize( vViewPosition );\n#ifdef USE_CLEARCOAT\n	geometry.clearcoatNormal = clearcoatNormal;\n#endif\n#ifdef USE_IRIDESCENCE\n	float dotNVi = saturate( dot( normal, geometry.viewDir ) );\n	if ( material.iridescenceThickness == 0.0 ) {\n		material.iridescence = 0.0;\n	} else {\n		material.iridescence = saturate( material.iridescence );\n	}\n	if ( material.iridescence > 0.0 ) {\n		material.iridescenceFresnel = evalIridescence( 1.0, material.iridescenceIOR, dotNVi, material.iridescenceThickness, material.specularColor );\n		material.iridescenceF0 = Schlick_to_F0( material.iridescenceFresnel, 1.0, dotNVi );\n	}\n#endif\nIncidentLight directLight;\n#if ( NUM_POINT_LIGHTS > 0 ) && defined( RE_Direct )\n	PointLight pointLight;\n	#if defined( USE_SHADOWMAP ) && NUM_POINT_LIGHT_SHADOWS > 0\n	PointLightShadow pointLightShadow;\n	#endif\n	#pragma unroll_loop_start\n	for ( int i = 0; i < NUM_POINT_LIGHTS; i ++ ) {\n		pointLight = pointLights[ i ];\n		getPointLightInfo( pointLight, geometry, directLight );\n		#if defined( USE_SHADOWMAP ) && ( UNROLLED_LOOP_INDEX < NUM_POINT_LIGHT_SHADOWS )\n		pointLightShadow = pointLightShadows[ i ];\n		directLight.color *= ( directLight.visible && receiveShadow ) ? getPointShadow( pointShadowMap[ i ], pointLightShadow.shadowMapSize, pointLightShadow.shadowBias, pointLightShadow.shadowRadius, vPointShadowCoord[ i ], pointLightShadow.shadowCameraNear, pointLightShadow.shadowCameraFar ) : 1.0;\n		#endif\n		RE_Direct( directLight, geometry, material, reflectedLight );\n	}\n	#pragma unroll_loop_end\n#endif\n#if ( NUM_SPOT_LIGHTS > 0 ) && defined( RE_Direct )\n	SpotLight spotLight;\n	vec4 spotColor;\n	vec3 spotLightCoord;\n	bool inSpotLightMap;\n	#if defined( USE_SHADOWMAP ) && NUM_SPOT_LIGHT_SHADOWS > 0\n	SpotLightShadow spotLightShadow;\n	#endif\n	#pragma unroll_loop_start\n	for ( int i = 0; i < NUM_SPOT_LIGHTS; i ++ ) {\n		spotLight = spotLights[ i ];\n		getSpotLightInfo( spotLight, geometry, directLight );\n		#if ( UNROLLED_LOOP_INDEX < NUM_SPOT_LIGHT_SHADOWS_WITH_MAPS )\n		#define SPOT_LIGHT_MAP_INDEX UNROLLED_LOOP_INDEX\n		#elif ( UNROLLED_LOOP_INDEX < NUM_SPOT_LIGHT_SHADOWS )\n		#define SPOT_LIGHT_MAP_INDEX NUM_SPOT_LIGHT_MAPS\n		#else\n		#define SPOT_LIGHT_MAP_INDEX ( UNROLLED_LOOP_INDEX - NUM_SPOT_LIGHT_SHADOWS + NUM_SPOT_LIGHT_SHADOWS_WITH_MAPS )\n		#endif\n		#if ( SPOT_LIGHT_MAP_INDEX < NUM_SPOT_LIGHT_MAPS )\n			spotLightCoord = vSpotLightCoord[ i ].xyz / vSpotLightCoord[ i ].w;\n			inSpotLightMap = all( lessThan( abs( spotLightCoord * 2. - 1. ), vec3( 1.0 ) ) );\n			spotColor = texture2D( spotLightMap[ SPOT_LIGHT_MAP_INDEX ], spotLightCoord.xy );\n			directLight.color = inSpotLightMap ? directLight.color * spotColor.rgb : directLight.color;\n		#endif\n		#undef SPOT_LIGHT_MAP_INDEX\n		#if defined( USE_SHADOWMAP ) && ( UNROLLED_LOOP_INDEX < NUM_SPOT_LIGHT_SHADOWS )\n		spotLightShadow = spotLightShadows[ i ];\n		directLight.color *= ( directLight.visible && receiveShadow ) ? getShadow( spotShadowMap[ i ], spotLightShadow.shadowMapSize, spotLightShadow.shadowBias, spotLightShadow.shadowRadius, vSpotLightCoord[ i ] ) : 1.0;\n		#endif\n		RE_Direct( directLight, geometry, material, reflectedLight );\n	}\n	#pragma unroll_loop_end\n#endif\n#if ( NUM_DIR_LIGHTS > 0 ) && defined( RE_Direct )\n	DirectionalLight directionalLight;\n	#if defined( USE_SHADOWMAP ) && NUM_DIR_LIGHT_SHADOWS > 0\n	DirectionalLightShadow directionalLightShadow;\n	#endif\n	#pragma unroll_loop_start\n	for ( int i = 0; i < NUM_DIR_LIGHTS; i ++ ) {\n		directionalLight = directionalLights[ i ];\n		getDirectionalLightInfo( directionalLight, geometry, directLight );\n		#if defined( USE_SHADOWMAP ) && ( UNROLLED_LOOP_INDEX < NUM_DIR_LIGHT_SHADOWS )\n		directionalLightShadow = directionalLightShadows[ i ];\n		directLight.color *= ( directLight.visible && receiveShadow ) ? getShadow( directionalShadowMap[ i ], directionalLightShadow.shadowMapSize, directionalLightShadow.shadowBias, directionalLightShadow.shadowRadius, vDirectionalShadowCoord[ i ] ) : 1.0;\n		#endif\n		RE_Direct( directLight, geometry, material, reflectedLight );\n	}\n	#pragma unroll_loop_end\n#endif\n#if ( NUM_RECT_AREA_LIGHTS > 0 ) && defined( RE_Direct_RectArea )\n	RectAreaLight rectAreaLight;\n	#pragma unroll_loop_start\n	for ( int i = 0; i < NUM_RECT_AREA_LIGHTS; i ++ ) {\n		rectAreaLight = rectAreaLights[ i ];\n		RE_Direct_RectArea( rectAreaLight, geometry, material, reflectedLight );\n	}\n	#pragma unroll_loop_end\n#endif\n#if defined( RE_IndirectDiffuse )\n	vec3 iblIrradiance = vec3( 0.0 );\n	vec3 irradiance = getAmbientLightIrradiance( ambientLightColor );\n	irradiance += getLightProbeIrradiance( lightProbe, geometry.normal );\n	#if ( NUM_HEMI_LIGHTS > 0 )\n		#pragma unroll_loop_start\n		for ( int i = 0; i < NUM_HEMI_LIGHTS; i ++ ) {\n			irradiance += getHemisphereLightIrradiance( hemisphereLights[ i ], geometry.normal );\n		}\n		#pragma unroll_loop_end\n	#endif\n#endif\n#if defined( RE_IndirectSpecular )\n	vec3 radiance = vec3( 0.0 );\n	vec3 clearcoatRadiance = vec3( 0.0 );\n#endif";
var $9014d97cd777be10$var$lights_fragment_maps = "#if defined( RE_IndirectDiffuse )\n	#ifdef USE_LIGHTMAP\n		vec4 lightMapTexel = texture2D( lightMap, vLightMapUv );\n		vec3 lightMapIrradiance = lightMapTexel.rgb * lightMapIntensity;\n		irradiance += lightMapIrradiance;\n	#endif\n	#if defined( USE_ENVMAP ) && defined( STANDARD ) && defined( ENVMAP_TYPE_CUBE_UV )\n		iblIrradiance += getIBLIrradiance( geometry.normal );\n	#endif\n#endif\n#if defined( USE_ENVMAP ) && defined( RE_IndirectSpecular )\n	#ifdef USE_ANISOTROPY\n		radiance += getIBLAnisotropyRadiance( geometry.viewDir, geometry.normal, material.roughness, material.anisotropyB, material.anisotropy );\n	#else\n		radiance += getIBLRadiance( geometry.viewDir, geometry.normal, material.roughness );\n	#endif\n	#ifdef USE_CLEARCOAT\n		clearcoatRadiance += getIBLRadiance( geometry.viewDir, geometry.clearcoatNormal, material.clearcoatRoughness );\n	#endif\n#endif";
var $9014d97cd777be10$var$lights_fragment_end = "#if defined( RE_IndirectDiffuse )\n	RE_IndirectDiffuse( irradiance, geometry, material, reflectedLight );\n#endif\n#if defined( RE_IndirectSpecular )\n	RE_IndirectSpecular( radiance, iblIrradiance, clearcoatRadiance, geometry, material, reflectedLight );\n#endif";
var $9014d97cd777be10$var$logdepthbuf_fragment = "#if defined( USE_LOGDEPTHBUF ) && defined( USE_LOGDEPTHBUF_EXT )\n	gl_FragDepthEXT = vIsPerspective == 0.0 ? gl_FragCoord.z : log2( vFragDepth ) * logDepthBufFC * 0.5;\n#endif";
var $9014d97cd777be10$var$logdepthbuf_pars_fragment = "#if defined( USE_LOGDEPTHBUF ) && defined( USE_LOGDEPTHBUF_EXT )\n	uniform float logDepthBufFC;\n	varying float vFragDepth;\n	varying float vIsPerspective;\n#endif";
var $9014d97cd777be10$var$logdepthbuf_pars_vertex = "#ifdef USE_LOGDEPTHBUF\n	#ifdef USE_LOGDEPTHBUF_EXT\n		varying float vFragDepth;\n		varying float vIsPerspective;\n	#else\n		uniform float logDepthBufFC;\n	#endif\n#endif";
var $9014d97cd777be10$var$logdepthbuf_vertex = "#ifdef USE_LOGDEPTHBUF\n	#ifdef USE_LOGDEPTHBUF_EXT\n		vFragDepth = 1.0 + gl_Position.w;\n		vIsPerspective = float( isPerspectiveMatrix( projectionMatrix ) );\n	#else\n		if ( isPerspectiveMatrix( projectionMatrix ) ) {\n			gl_Position.z = log2( max( EPSILON, gl_Position.w + 1.0 ) ) * logDepthBufFC - 1.0;\n			gl_Position.z *= gl_Position.w;\n		}\n	#endif\n#endif";
var $9014d97cd777be10$var$map_fragment = "#ifdef USE_MAP\n	diffuseColor *= texture2D( map, vMapUv );\n#endif";
var $9014d97cd777be10$var$map_pars_fragment = "#ifdef USE_MAP\n	uniform sampler2D map;\n#endif";
var $9014d97cd777be10$var$map_particle_fragment = "#if defined( USE_MAP ) || defined( USE_ALPHAMAP )\n	#if defined( USE_POINTS_UV )\n		vec2 uv = vUv;\n	#else\n		vec2 uv = ( uvTransform * vec3( gl_PointCoord.x, 1.0 - gl_PointCoord.y, 1 ) ).xy;\n	#endif\n#endif\n#ifdef USE_MAP\n	diffuseColor *= texture2D( map, uv );\n#endif\n#ifdef USE_ALPHAMAP\n	diffuseColor.a *= texture2D( alphaMap, uv ).g;\n#endif";
var $9014d97cd777be10$var$map_particle_pars_fragment = "#if defined( USE_POINTS_UV )\n	varying vec2 vUv;\n#else\n	#if defined( USE_MAP ) || defined( USE_ALPHAMAP )\n		uniform mat3 uvTransform;\n	#endif\n#endif\n#ifdef USE_MAP\n	uniform sampler2D map;\n#endif\n#ifdef USE_ALPHAMAP\n	uniform sampler2D alphaMap;\n#endif";
var $9014d97cd777be10$var$metalnessmap_fragment = "float metalnessFactor = metalness;\n#ifdef USE_METALNESSMAP\n	vec4 texelMetalness = texture2D( metalnessMap, vMetalnessMapUv );\n	metalnessFactor *= texelMetalness.b;\n#endif";
var $9014d97cd777be10$var$metalnessmap_pars_fragment = "#ifdef USE_METALNESSMAP\n	uniform sampler2D metalnessMap;\n#endif";
var $9014d97cd777be10$var$morphcolor_vertex = "#if defined( USE_MORPHCOLORS ) && defined( MORPHTARGETS_TEXTURE )\n	vColor *= morphTargetBaseInfluence;\n	for ( int i = 0; i < MORPHTARGETS_COUNT; i ++ ) {\n		#if defined( USE_COLOR_ALPHA )\n			if ( morphTargetInfluences[ i ] != 0.0 ) vColor += getMorph( gl_VertexID, i, 2 ) * morphTargetInfluences[ i ];\n		#elif defined( USE_COLOR )\n			if ( morphTargetInfluences[ i ] != 0.0 ) vColor += getMorph( gl_VertexID, i, 2 ).rgb * morphTargetInfluences[ i ];\n		#endif\n	}\n#endif";
var $9014d97cd777be10$var$morphnormal_vertex = "#ifdef USE_MORPHNORMALS\n	objectNormal *= morphTargetBaseInfluence;\n	#ifdef MORPHTARGETS_TEXTURE\n		for ( int i = 0; i < MORPHTARGETS_COUNT; i ++ ) {\n			if ( morphTargetInfluences[ i ] != 0.0 ) objectNormal += getMorph( gl_VertexID, i, 1 ).xyz * morphTargetInfluences[ i ];\n		}\n	#else\n		objectNormal += morphNormal0 * morphTargetInfluences[ 0 ];\n		objectNormal += morphNormal1 * morphTargetInfluences[ 1 ];\n		objectNormal += morphNormal2 * morphTargetInfluences[ 2 ];\n		objectNormal += morphNormal3 * morphTargetInfluences[ 3 ];\n	#endif\n#endif";
var $9014d97cd777be10$var$morphtarget_pars_vertex = "#ifdef USE_MORPHTARGETS\n	uniform float morphTargetBaseInfluence;\n	#ifdef MORPHTARGETS_TEXTURE\n		uniform float morphTargetInfluences[ MORPHTARGETS_COUNT ];\n		uniform sampler2DArray morphTargetsTexture;\n		uniform ivec2 morphTargetsTextureSize;\n		vec4 getMorph( const in int vertexIndex, const in int morphTargetIndex, const in int offset ) {\n			int texelIndex = vertexIndex * MORPHTARGETS_TEXTURE_STRIDE + offset;\n			int y = texelIndex / morphTargetsTextureSize.x;\n			int x = texelIndex - y * morphTargetsTextureSize.x;\n			ivec3 morphUV = ivec3( x, y, morphTargetIndex );\n			return texelFetch( morphTargetsTexture, morphUV, 0 );\n		}\n	#else\n		#ifndef USE_MORPHNORMALS\n			uniform float morphTargetInfluences[ 8 ];\n		#else\n			uniform float morphTargetInfluences[ 4 ];\n		#endif\n	#endif\n#endif";
var $9014d97cd777be10$var$morphtarget_vertex = "#ifdef USE_MORPHTARGETS\n	transformed *= morphTargetBaseInfluence;\n	#ifdef MORPHTARGETS_TEXTURE\n		for ( int i = 0; i < MORPHTARGETS_COUNT; i ++ ) {\n			if ( morphTargetInfluences[ i ] != 0.0 ) transformed += getMorph( gl_VertexID, i, 0 ).xyz * morphTargetInfluences[ i ];\n		}\n	#else\n		transformed += morphTarget0 * morphTargetInfluences[ 0 ];\n		transformed += morphTarget1 * morphTargetInfluences[ 1 ];\n		transformed += morphTarget2 * morphTargetInfluences[ 2 ];\n		transformed += morphTarget3 * morphTargetInfluences[ 3 ];\n		#ifndef USE_MORPHNORMALS\n			transformed += morphTarget4 * morphTargetInfluences[ 4 ];\n			transformed += morphTarget5 * morphTargetInfluences[ 5 ];\n			transformed += morphTarget6 * morphTargetInfluences[ 6 ];\n			transformed += morphTarget7 * morphTargetInfluences[ 7 ];\n		#endif\n	#endif\n#endif";
var $9014d97cd777be10$var$normal_fragment_begin = "float faceDirection = gl_FrontFacing ? 1.0 : - 1.0;\n#ifdef FLAT_SHADED\n	vec3 fdx = dFdx( vViewPosition );\n	vec3 fdy = dFdy( vViewPosition );\n	vec3 normal = normalize( cross( fdx, fdy ) );\n#else\n	vec3 normal = normalize( vNormal );\n	#ifdef DOUBLE_SIDED\n		normal *= faceDirection;\n	#endif\n#endif\n#if defined( USE_NORMALMAP_TANGENTSPACE ) || defined( USE_CLEARCOAT_NORMALMAP ) || defined( USE_ANISOTROPY )\n	#ifdef USE_TANGENT\n		mat3 tbn = mat3( normalize( vTangent ), normalize( vBitangent ), normal );\n	#else\n		mat3 tbn = getTangentFrame( - vViewPosition, normal,\n		#if defined( USE_NORMALMAP )\n			vNormalMapUv\n		#elif defined( USE_CLEARCOAT_NORMALMAP )\n			vClearcoatNormalMapUv\n		#else\n			vUv\n		#endif\n		);\n	#endif\n	#if defined( DOUBLE_SIDED ) && ! defined( FLAT_SHADED )\n		tbn[0] *= faceDirection;\n		tbn[1] *= faceDirection;\n	#endif\n#endif\n#ifdef USE_CLEARCOAT_NORMALMAP\n	#ifdef USE_TANGENT\n		mat3 tbn2 = mat3( normalize( vTangent ), normalize( vBitangent ), normal );\n	#else\n		mat3 tbn2 = getTangentFrame( - vViewPosition, normal, vClearcoatNormalMapUv );\n	#endif\n	#if defined( DOUBLE_SIDED ) && ! defined( FLAT_SHADED )\n		tbn2[0] *= faceDirection;\n		tbn2[1] *= faceDirection;\n	#endif\n#endif\nvec3 geometryNormal = normal;";
var $9014d97cd777be10$var$normal_fragment_maps = "#ifdef USE_NORMALMAP_OBJECTSPACE\n	normal = texture2D( normalMap, vNormalMapUv ).xyz * 2.0 - 1.0;\n	#ifdef FLIP_SIDED\n		normal = - normal;\n	#endif\n	#ifdef DOUBLE_SIDED\n		normal = normal * faceDirection;\n	#endif\n	normal = normalize( normalMatrix * normal );\n#elif defined( USE_NORMALMAP_TANGENTSPACE )\n	vec3 mapN = texture2D( normalMap, vNormalMapUv ).xyz * 2.0 - 1.0;\n	mapN.xy *= normalScale;\n	normal = normalize( tbn * mapN );\n#elif defined( USE_BUMPMAP )\n	normal = perturbNormalArb( - vViewPosition, normal, dHdxy_fwd(), faceDirection );\n#endif";
var $9014d97cd777be10$var$normal_pars_fragment = "#ifndef FLAT_SHADED\n	varying vec3 vNormal;\n	#ifdef USE_TANGENT\n		varying vec3 vTangent;\n		varying vec3 vBitangent;\n	#endif\n#endif";
var $9014d97cd777be10$var$normal_pars_vertex = "#ifndef FLAT_SHADED\n	varying vec3 vNormal;\n	#ifdef USE_TANGENT\n		varying vec3 vTangent;\n		varying vec3 vBitangent;\n	#endif\n#endif";
var $9014d97cd777be10$var$normal_vertex = "#ifndef FLAT_SHADED\n	vNormal = normalize( transformedNormal );\n	#ifdef USE_TANGENT\n		vTangent = normalize( transformedTangent );\n		vBitangent = normalize( cross( vNormal, vTangent ) * tangent.w );\n	#endif\n#endif";
var $9014d97cd777be10$var$normalmap_pars_fragment = "#ifdef USE_NORMALMAP\n	uniform sampler2D normalMap;\n	uniform vec2 normalScale;\n#endif\n#ifdef USE_NORMALMAP_OBJECTSPACE\n	uniform mat3 normalMatrix;\n#endif\n#if ! defined ( USE_TANGENT ) && ( defined ( USE_NORMALMAP_TANGENTSPACE ) || defined ( USE_CLEARCOAT_NORMALMAP ) || defined( USE_ANISOTROPY ) )\n	mat3 getTangentFrame( vec3 eye_pos, vec3 surf_norm, vec2 uv ) {\n		vec3 q0 = dFdx( eye_pos.xyz );\n		vec3 q1 = dFdy( eye_pos.xyz );\n		vec2 st0 = dFdx( uv.st );\n		vec2 st1 = dFdy( uv.st );\n		vec3 N = surf_norm;\n		vec3 q1perp = cross( q1, N );\n		vec3 q0perp = cross( N, q0 );\n		vec3 T = q1perp * st0.x + q0perp * st1.x;\n		vec3 B = q1perp * st0.y + q0perp * st1.y;\n		float det = max( dot( T, T ), dot( B, B ) );\n		float scale = ( det == 0.0 ) ? 0.0 : inversesqrt( det );\n		return mat3( T * scale, B * scale, N );\n	}\n#endif";
var $9014d97cd777be10$var$clearcoat_normal_fragment_begin = "#ifdef USE_CLEARCOAT\n	vec3 clearcoatNormal = geometryNormal;\n#endif";
var $9014d97cd777be10$var$clearcoat_normal_fragment_maps = "#ifdef USE_CLEARCOAT_NORMALMAP\n	vec3 clearcoatMapN = texture2D( clearcoatNormalMap, vClearcoatNormalMapUv ).xyz * 2.0 - 1.0;\n	clearcoatMapN.xy *= clearcoatNormalScale;\n	clearcoatNormal = normalize( tbn2 * clearcoatMapN );\n#endif";
var $9014d97cd777be10$var$clearcoat_pars_fragment = "#ifdef USE_CLEARCOATMAP\n	uniform sampler2D clearcoatMap;\n#endif\n#ifdef USE_CLEARCOAT_NORMALMAP\n	uniform sampler2D clearcoatNormalMap;\n	uniform vec2 clearcoatNormalScale;\n#endif\n#ifdef USE_CLEARCOAT_ROUGHNESSMAP\n	uniform sampler2D clearcoatRoughnessMap;\n#endif";
var $9014d97cd777be10$var$iridescence_pars_fragment = "#ifdef USE_IRIDESCENCEMAP\n	uniform sampler2D iridescenceMap;\n#endif\n#ifdef USE_IRIDESCENCE_THICKNESSMAP\n	uniform sampler2D iridescenceThicknessMap;\n#endif";
var $9014d97cd777be10$var$opaque_fragment = "#ifdef OPAQUE\ndiffuseColor.a = 1.0;\n#endif\n#ifdef USE_TRANSMISSION\ndiffuseColor.a *= material.transmissionAlpha;\n#endif\ngl_FragColor = vec4( outgoingLight, diffuseColor.a );";
var $9014d97cd777be10$var$packing = "vec3 packNormalToRGB( const in vec3 normal ) {\n	return normalize( normal ) * 0.5 + 0.5;\n}\nvec3 unpackRGBToNormal( const in vec3 rgb ) {\n	return 2.0 * rgb.xyz - 1.0;\n}\nconst float PackUpscale = 256. / 255.;const float UnpackDownscale = 255. / 256.;\nconst vec3 PackFactors = vec3( 256. * 256. * 256., 256. * 256., 256. );\nconst vec4 UnpackFactors = UnpackDownscale / vec4( PackFactors, 1. );\nconst float ShiftRight8 = 1. / 256.;\nvec4 packDepthToRGBA( const in float v ) {\n	vec4 r = vec4( fract( v * PackFactors ), v );\n	r.yzw -= r.xyz * ShiftRight8;	return r * PackUpscale;\n}\nfloat unpackRGBAToDepth( const in vec4 v ) {\n	return dot( v, UnpackFactors );\n}\nvec2 packDepthToRG( in highp float v ) {\n	return packDepthToRGBA( v ).yx;\n}\nfloat unpackRGToDepth( const in highp vec2 v ) {\n	return unpackRGBAToDepth( vec4( v.xy, 0.0, 0.0 ) );\n}\nvec4 pack2HalfToRGBA( vec2 v ) {\n	vec4 r = vec4( v.x, fract( v.x * 255.0 ), v.y, fract( v.y * 255.0 ) );\n	return vec4( r.x - r.y / 255.0, r.y, r.z - r.w / 255.0, r.w );\n}\nvec2 unpackRGBATo2Half( vec4 v ) {\n	return vec2( v.x + ( v.y / 255.0 ), v.z + ( v.w / 255.0 ) );\n}\nfloat viewZToOrthographicDepth( const in float viewZ, const in float near, const in float far ) {\n	return ( viewZ + near ) / ( near - far );\n}\nfloat orthographicDepthToViewZ( const in float depth, const in float near, const in float far ) {\n	return depth * ( near - far ) - near;\n}\nfloat viewZToPerspectiveDepth( const in float viewZ, const in float near, const in float far ) {\n	return ( ( near + viewZ ) * far ) / ( ( far - near ) * viewZ );\n}\nfloat perspectiveDepthToViewZ( const in float depth, const in float near, const in float far ) {\n	return ( near * far ) / ( ( far - near ) * depth - far );\n}";
var $9014d97cd777be10$var$premultiplied_alpha_fragment = "#ifdef PREMULTIPLIED_ALPHA\n	gl_FragColor.rgb *= gl_FragColor.a;\n#endif";
var $9014d97cd777be10$var$project_vertex = "vec4 mvPosition = vec4( transformed, 1.0 );\n#ifdef USE_INSTANCING\n	mvPosition = instanceMatrix * mvPosition;\n#endif\nmvPosition = modelViewMatrix * mvPosition;\ngl_Position = projectionMatrix * mvPosition;";
var $9014d97cd777be10$var$dithering_fragment = "#ifdef DITHERING\n	gl_FragColor.rgb = dithering( gl_FragColor.rgb );\n#endif";
var $9014d97cd777be10$var$dithering_pars_fragment = "#ifdef DITHERING\n	vec3 dithering( vec3 color ) {\n		float grid_position = rand( gl_FragCoord.xy );\n		vec3 dither_shift_RGB = vec3( 0.25 / 255.0, -0.25 / 255.0, 0.25 / 255.0 );\n		dither_shift_RGB = mix( 2.0 * dither_shift_RGB, -2.0 * dither_shift_RGB, grid_position );\n		return color + dither_shift_RGB;\n	}\n#endif";
var $9014d97cd777be10$var$roughnessmap_fragment = "float roughnessFactor = roughness;\n#ifdef USE_ROUGHNESSMAP\n	vec4 texelRoughness = texture2D( roughnessMap, vRoughnessMapUv );\n	roughnessFactor *= texelRoughness.g;\n#endif";
var $9014d97cd777be10$var$roughnessmap_pars_fragment = "#ifdef USE_ROUGHNESSMAP\n	uniform sampler2D roughnessMap;\n#endif";
var $9014d97cd777be10$var$shadowmap_pars_fragment = "#if NUM_SPOT_LIGHT_COORDS > 0\n	varying vec4 vSpotLightCoord[ NUM_SPOT_LIGHT_COORDS ];\n#endif\n#if NUM_SPOT_LIGHT_MAPS > 0\n	uniform sampler2D spotLightMap[ NUM_SPOT_LIGHT_MAPS ];\n#endif\n#ifdef USE_SHADOWMAP\n	#if NUM_DIR_LIGHT_SHADOWS > 0\n		uniform sampler2D directionalShadowMap[ NUM_DIR_LIGHT_SHADOWS ];\n		varying vec4 vDirectionalShadowCoord[ NUM_DIR_LIGHT_SHADOWS ];\n		struct DirectionalLightShadow {\n			float shadowBias;\n			float shadowNormalBias;\n			float shadowRadius;\n			vec2 shadowMapSize;\n		};\n		uniform DirectionalLightShadow directionalLightShadows[ NUM_DIR_LIGHT_SHADOWS ];\n	#endif\n	#if NUM_SPOT_LIGHT_SHADOWS > 0\n		uniform sampler2D spotShadowMap[ NUM_SPOT_LIGHT_SHADOWS ];\n		struct SpotLightShadow {\n			float shadowBias;\n			float shadowNormalBias;\n			float shadowRadius;\n			vec2 shadowMapSize;\n		};\n		uniform SpotLightShadow spotLightShadows[ NUM_SPOT_LIGHT_SHADOWS ];\n	#endif\n	#if NUM_POINT_LIGHT_SHADOWS > 0\n		uniform sampler2D pointShadowMap[ NUM_POINT_LIGHT_SHADOWS ];\n		varying vec4 vPointShadowCoord[ NUM_POINT_LIGHT_SHADOWS ];\n		struct PointLightShadow {\n			float shadowBias;\n			float shadowNormalBias;\n			float shadowRadius;\n			vec2 shadowMapSize;\n			float shadowCameraNear;\n			float shadowCameraFar;\n		};\n		uniform PointLightShadow pointLightShadows[ NUM_POINT_LIGHT_SHADOWS ];\n	#endif\n	float texture2DCompare( sampler2D depths, vec2 uv, float compare ) {\n		return step( compare, unpackRGBAToDepth( texture2D( depths, uv ) ) );\n	}\n	vec2 texture2DDistribution( sampler2D shadow, vec2 uv ) {\n		return unpackRGBATo2Half( texture2D( shadow, uv ) );\n	}\n	float VSMShadow (sampler2D shadow, vec2 uv, float compare ){\n		float occlusion = 1.0;\n		vec2 distribution = texture2DDistribution( shadow, uv );\n		float hard_shadow = step( compare , distribution.x );\n		if (hard_shadow != 1.0 ) {\n			float distance = compare - distribution.x ;\n			float variance = max( 0.00000, distribution.y * distribution.y );\n			float softness_probability = variance / (variance + distance * distance );			softness_probability = clamp( ( softness_probability - 0.3 ) / ( 0.95 - 0.3 ), 0.0, 1.0 );			occlusion = clamp( max( hard_shadow, softness_probability ), 0.0, 1.0 );\n		}\n		return occlusion;\n	}\n	float getShadow( sampler2D shadowMap, vec2 shadowMapSize, float shadowBias, float shadowRadius, vec4 shadowCoord ) {\n		float shadow = 1.0;\n		shadowCoord.xyz /= shadowCoord.w;\n		shadowCoord.z += shadowBias;\n		bool inFrustum = shadowCoord.x >= 0.0 && shadowCoord.x <= 1.0 && shadowCoord.y >= 0.0 && shadowCoord.y <= 1.0;\n		bool frustumTest = inFrustum && shadowCoord.z <= 1.0;\n		if ( frustumTest ) {\n		#if defined( SHADOWMAP_TYPE_PCF )\n			vec2 texelSize = vec2( 1.0 ) / shadowMapSize;\n			float dx0 = - texelSize.x * shadowRadius;\n			float dy0 = - texelSize.y * shadowRadius;\n			float dx1 = + texelSize.x * shadowRadius;\n			float dy1 = + texelSize.y * shadowRadius;\n			float dx2 = dx0 / 2.0;\n			float dy2 = dy0 / 2.0;\n			float dx3 = dx1 / 2.0;\n			float dy3 = dy1 / 2.0;\n			shadow = (\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx0, dy0 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( 0.0, dy0 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx1, dy0 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx2, dy2 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( 0.0, dy2 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx3, dy2 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx0, 0.0 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx2, 0.0 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy, shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx3, 0.0 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx1, 0.0 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx2, dy3 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( 0.0, dy3 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx3, dy3 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx0, dy1 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( 0.0, dy1 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx1, dy1 ), shadowCoord.z )\n			) * ( 1.0 / 17.0 );\n		#elif defined( SHADOWMAP_TYPE_PCF_SOFT )\n			vec2 texelSize = vec2( 1.0 ) / shadowMapSize;\n			float dx = texelSize.x;\n			float dy = texelSize.y;\n			vec2 uv = shadowCoord.xy;\n			vec2 f = fract( uv * shadowMapSize + 0.5 );\n			uv -= f * texelSize;\n			shadow = (\n				texture2DCompare( shadowMap, uv, shadowCoord.z ) +\n				texture2DCompare( shadowMap, uv + vec2( dx, 0.0 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, uv + vec2( 0.0, dy ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, uv + texelSize, shadowCoord.z ) +\n				mix( texture2DCompare( shadowMap, uv + vec2( -dx, 0.0 ), shadowCoord.z ),\n					 texture2DCompare( shadowMap, uv + vec2( 2.0 * dx, 0.0 ), shadowCoord.z ),\n					 f.x ) +\n				mix( texture2DCompare( shadowMap, uv + vec2( -dx, dy ), shadowCoord.z ),\n					 texture2DCompare( shadowMap, uv + vec2( 2.0 * dx, dy ), shadowCoord.z ),\n					 f.x ) +\n				mix( texture2DCompare( shadowMap, uv + vec2( 0.0, -dy ), shadowCoord.z ),\n					 texture2DCompare( shadowMap, uv + vec2( 0.0, 2.0 * dy ), shadowCoord.z ),\n					 f.y ) +\n				mix( texture2DCompare( shadowMap, uv + vec2( dx, -dy ), shadowCoord.z ),\n					 texture2DCompare( shadowMap, uv + vec2( dx, 2.0 * dy ), shadowCoord.z ),\n					 f.y ) +\n				mix( mix( texture2DCompare( shadowMap, uv + vec2( -dx, -dy ), shadowCoord.z ),\n						  texture2DCompare( shadowMap, uv + vec2( 2.0 * dx, -dy ), shadowCoord.z ),\n						  f.x ),\n					 mix( texture2DCompare( shadowMap, uv + vec2( -dx, 2.0 * dy ), shadowCoord.z ),\n						  texture2DCompare( shadowMap, uv + vec2( 2.0 * dx, 2.0 * dy ), shadowCoord.z ),\n						  f.x ),\n					 f.y )\n			) * ( 1.0 / 9.0 );\n		#elif defined( SHADOWMAP_TYPE_VSM )\n			shadow = VSMShadow( shadowMap, shadowCoord.xy, shadowCoord.z );\n		#else\n			shadow = texture2DCompare( shadowMap, shadowCoord.xy, shadowCoord.z );\n		#endif\n		}\n		return shadow;\n	}\n	vec2 cubeToUV( vec3 v, float texelSizeY ) {\n		vec3 absV = abs( v );\n		float scaleToCube = 1.0 / max( absV.x, max( absV.y, absV.z ) );\n		absV *= scaleToCube;\n		v *= scaleToCube * ( 1.0 - 2.0 * texelSizeY );\n		vec2 planar = v.xy;\n		float almostATexel = 1.5 * texelSizeY;\n		float almostOne = 1.0 - almostATexel;\n		if ( absV.z >= almostOne ) {\n			if ( v.z > 0.0 )\n				planar.x = 4.0 - v.x;\n		} else if ( absV.x >= almostOne ) {\n			float signX = sign( v.x );\n			planar.x = v.z * signX + 2.0 * signX;\n		} else if ( absV.y >= almostOne ) {\n			float signY = sign( v.y );\n			planar.x = v.x + 2.0 * signY + 2.0;\n			planar.y = v.z * signY - 2.0;\n		}\n		return vec2( 0.125, 0.25 ) * planar + vec2( 0.375, 0.75 );\n	}\n	float getPointShadow( sampler2D shadowMap, vec2 shadowMapSize, float shadowBias, float shadowRadius, vec4 shadowCoord, float shadowCameraNear, float shadowCameraFar ) {\n		vec2 texelSize = vec2( 1.0 ) / ( shadowMapSize * vec2( 4.0, 2.0 ) );\n		vec3 lightToPosition = shadowCoord.xyz;\n		float dp = ( length( lightToPosition ) - shadowCameraNear ) / ( shadowCameraFar - shadowCameraNear );		dp += shadowBias;\n		vec3 bd3D = normalize( lightToPosition );\n		#if defined( SHADOWMAP_TYPE_PCF ) || defined( SHADOWMAP_TYPE_PCF_SOFT ) || defined( SHADOWMAP_TYPE_VSM )\n			vec2 offset = vec2( - 1, 1 ) * shadowRadius * texelSize.y;\n			return (\n				texture2DCompare( shadowMap, cubeToUV( bd3D + offset.xyy, texelSize.y ), dp ) +\n				texture2DCompare( shadowMap, cubeToUV( bd3D + offset.yyy, texelSize.y ), dp ) +\n				texture2DCompare( shadowMap, cubeToUV( bd3D + offset.xyx, texelSize.y ), dp ) +\n				texture2DCompare( shadowMap, cubeToUV( bd3D + offset.yyx, texelSize.y ), dp ) +\n				texture2DCompare( shadowMap, cubeToUV( bd3D, texelSize.y ), dp ) +\n				texture2DCompare( shadowMap, cubeToUV( bd3D + offset.xxy, texelSize.y ), dp ) +\n				texture2DCompare( shadowMap, cubeToUV( bd3D + offset.yxy, texelSize.y ), dp ) +\n				texture2DCompare( shadowMap, cubeToUV( bd3D + offset.xxx, texelSize.y ), dp ) +\n				texture2DCompare( shadowMap, cubeToUV( bd3D + offset.yxx, texelSize.y ), dp )\n			) * ( 1.0 / 9.0 );\n		#else\n			return texture2DCompare( shadowMap, cubeToUV( bd3D, texelSize.y ), dp );\n		#endif\n	}\n#endif";
var $9014d97cd777be10$var$shadowmap_pars_vertex = "#if NUM_SPOT_LIGHT_COORDS > 0\n	uniform mat4 spotLightMatrix[ NUM_SPOT_LIGHT_COORDS ];\n	varying vec4 vSpotLightCoord[ NUM_SPOT_LIGHT_COORDS ];\n#endif\n#ifdef USE_SHADOWMAP\n	#if NUM_DIR_LIGHT_SHADOWS > 0\n		uniform mat4 directionalShadowMatrix[ NUM_DIR_LIGHT_SHADOWS ];\n		varying vec4 vDirectionalShadowCoord[ NUM_DIR_LIGHT_SHADOWS ];\n		struct DirectionalLightShadow {\n			float shadowBias;\n			float shadowNormalBias;\n			float shadowRadius;\n			vec2 shadowMapSize;\n		};\n		uniform DirectionalLightShadow directionalLightShadows[ NUM_DIR_LIGHT_SHADOWS ];\n	#endif\n	#if NUM_SPOT_LIGHT_SHADOWS > 0\n		struct SpotLightShadow {\n			float shadowBias;\n			float shadowNormalBias;\n			float shadowRadius;\n			vec2 shadowMapSize;\n		};\n		uniform SpotLightShadow spotLightShadows[ NUM_SPOT_LIGHT_SHADOWS ];\n	#endif\n	#if NUM_POINT_LIGHT_SHADOWS > 0\n		uniform mat4 pointShadowMatrix[ NUM_POINT_LIGHT_SHADOWS ];\n		varying vec4 vPointShadowCoord[ NUM_POINT_LIGHT_SHADOWS ];\n		struct PointLightShadow {\n			float shadowBias;\n			float shadowNormalBias;\n			float shadowRadius;\n			vec2 shadowMapSize;\n			float shadowCameraNear;\n			float shadowCameraFar;\n		};\n		uniform PointLightShadow pointLightShadows[ NUM_POINT_LIGHT_SHADOWS ];\n	#endif\n#endif";
var $9014d97cd777be10$var$shadowmap_vertex = "#if ( defined( USE_SHADOWMAP ) && ( NUM_DIR_LIGHT_SHADOWS > 0 || NUM_POINT_LIGHT_SHADOWS > 0 ) ) || ( NUM_SPOT_LIGHT_COORDS > 0 )\n	vec3 shadowWorldNormal = inverseTransformDirection( transformedNormal, viewMatrix );\n	vec4 shadowWorldPosition;\n#endif\n#if defined( USE_SHADOWMAP )\n	#if NUM_DIR_LIGHT_SHADOWS > 0\n		#pragma unroll_loop_start\n		for ( int i = 0; i < NUM_DIR_LIGHT_SHADOWS; i ++ ) {\n			shadowWorldPosition = worldPosition + vec4( shadowWorldNormal * directionalLightShadows[ i ].shadowNormalBias, 0 );\n			vDirectionalShadowCoord[ i ] = directionalShadowMatrix[ i ] * shadowWorldPosition;\n		}\n		#pragma unroll_loop_end\n	#endif\n	#if NUM_POINT_LIGHT_SHADOWS > 0\n		#pragma unroll_loop_start\n		for ( int i = 0; i < NUM_POINT_LIGHT_SHADOWS; i ++ ) {\n			shadowWorldPosition = worldPosition + vec4( shadowWorldNormal * pointLightShadows[ i ].shadowNormalBias, 0 );\n			vPointShadowCoord[ i ] = pointShadowMatrix[ i ] * shadowWorldPosition;\n		}\n		#pragma unroll_loop_end\n	#endif\n#endif\n#if NUM_SPOT_LIGHT_COORDS > 0\n	#pragma unroll_loop_start\n	for ( int i = 0; i < NUM_SPOT_LIGHT_COORDS; i ++ ) {\n		shadowWorldPosition = worldPosition;\n		#if ( defined( USE_SHADOWMAP ) && UNROLLED_LOOP_INDEX < NUM_SPOT_LIGHT_SHADOWS )\n			shadowWorldPosition.xyz += shadowWorldNormal * spotLightShadows[ i ].shadowNormalBias;\n		#endif\n		vSpotLightCoord[ i ] = spotLightMatrix[ i ] * shadowWorldPosition;\n	}\n	#pragma unroll_loop_end\n#endif";
var $9014d97cd777be10$var$shadowmask_pars_fragment = "float getShadowMask() {\n	float shadow = 1.0;\n	#ifdef USE_SHADOWMAP\n	#if NUM_DIR_LIGHT_SHADOWS > 0\n	DirectionalLightShadow directionalLight;\n	#pragma unroll_loop_start\n	for ( int i = 0; i < NUM_DIR_LIGHT_SHADOWS; i ++ ) {\n		directionalLight = directionalLightShadows[ i ];\n		shadow *= receiveShadow ? getShadow( directionalShadowMap[ i ], directionalLight.shadowMapSize, directionalLight.shadowBias, directionalLight.shadowRadius, vDirectionalShadowCoord[ i ] ) : 1.0;\n	}\n	#pragma unroll_loop_end\n	#endif\n	#if NUM_SPOT_LIGHT_SHADOWS > 0\n	SpotLightShadow spotLight;\n	#pragma unroll_loop_start\n	for ( int i = 0; i < NUM_SPOT_LIGHT_SHADOWS; i ++ ) {\n		spotLight = spotLightShadows[ i ];\n		shadow *= receiveShadow ? getShadow( spotShadowMap[ i ], spotLight.shadowMapSize, spotLight.shadowBias, spotLight.shadowRadius, vSpotLightCoord[ i ] ) : 1.0;\n	}\n	#pragma unroll_loop_end\n	#endif\n	#if NUM_POINT_LIGHT_SHADOWS > 0\n	PointLightShadow pointLight;\n	#pragma unroll_loop_start\n	for ( int i = 0; i < NUM_POINT_LIGHT_SHADOWS; i ++ ) {\n		pointLight = pointLightShadows[ i ];\n		shadow *= receiveShadow ? getPointShadow( pointShadowMap[ i ], pointLight.shadowMapSize, pointLight.shadowBias, pointLight.shadowRadius, vPointShadowCoord[ i ], pointLight.shadowCameraNear, pointLight.shadowCameraFar ) : 1.0;\n	}\n	#pragma unroll_loop_end\n	#endif\n	#endif\n	return shadow;\n}";
var $9014d97cd777be10$var$skinbase_vertex = "#ifdef USE_SKINNING\n	mat4 boneMatX = getBoneMatrix( skinIndex.x );\n	mat4 boneMatY = getBoneMatrix( skinIndex.y );\n	mat4 boneMatZ = getBoneMatrix( skinIndex.z );\n	mat4 boneMatW = getBoneMatrix( skinIndex.w );\n#endif";
var $9014d97cd777be10$var$skinning_pars_vertex = "#ifdef USE_SKINNING\n	uniform mat4 bindMatrix;\n	uniform mat4 bindMatrixInverse;\n	uniform highp sampler2D boneTexture;\n	uniform int boneTextureSize;\n	mat4 getBoneMatrix( const in float i ) {\n		float j = i * 4.0;\n		float x = mod( j, float( boneTextureSize ) );\n		float y = floor( j / float( boneTextureSize ) );\n		float dx = 1.0 / float( boneTextureSize );\n		float dy = 1.0 / float( boneTextureSize );\n		y = dy * ( y + 0.5 );\n		vec4 v1 = texture2D( boneTexture, vec2( dx * ( x + 0.5 ), y ) );\n		vec4 v2 = texture2D( boneTexture, vec2( dx * ( x + 1.5 ), y ) );\n		vec4 v3 = texture2D( boneTexture, vec2( dx * ( x + 2.5 ), y ) );\n		vec4 v4 = texture2D( boneTexture, vec2( dx * ( x + 3.5 ), y ) );\n		mat4 bone = mat4( v1, v2, v3, v4 );\n		return bone;\n	}\n#endif";
var $9014d97cd777be10$var$skinning_vertex = "#ifdef USE_SKINNING\n	vec4 skinVertex = bindMatrix * vec4( transformed, 1.0 );\n	vec4 skinned = vec4( 0.0 );\n	skinned += boneMatX * skinVertex * skinWeight.x;\n	skinned += boneMatY * skinVertex * skinWeight.y;\n	skinned += boneMatZ * skinVertex * skinWeight.z;\n	skinned += boneMatW * skinVertex * skinWeight.w;\n	transformed = ( bindMatrixInverse * skinned ).xyz;\n#endif";
var $9014d97cd777be10$var$skinnormal_vertex = "#ifdef USE_SKINNING\n	mat4 skinMatrix = mat4( 0.0 );\n	skinMatrix += skinWeight.x * boneMatX;\n	skinMatrix += skinWeight.y * boneMatY;\n	skinMatrix += skinWeight.z * boneMatZ;\n	skinMatrix += skinWeight.w * boneMatW;\n	skinMatrix = bindMatrixInverse * skinMatrix * bindMatrix;\n	objectNormal = vec4( skinMatrix * vec4( objectNormal, 0.0 ) ).xyz;\n	#ifdef USE_TANGENT\n		objectTangent = vec4( skinMatrix * vec4( objectTangent, 0.0 ) ).xyz;\n	#endif\n#endif";
var $9014d97cd777be10$var$specularmap_fragment = "float specularStrength;\n#ifdef USE_SPECULARMAP\n	vec4 texelSpecular = texture2D( specularMap, vSpecularMapUv );\n	specularStrength = texelSpecular.r;\n#else\n	specularStrength = 1.0;\n#endif";
var $9014d97cd777be10$var$specularmap_pars_fragment = "#ifdef USE_SPECULARMAP\n	uniform sampler2D specularMap;\n#endif";
var $9014d97cd777be10$var$tonemapping_fragment = "#if defined( TONE_MAPPING )\n	gl_FragColor.rgb = toneMapping( gl_FragColor.rgb );\n#endif";
var $9014d97cd777be10$var$tonemapping_pars_fragment = "#ifndef saturate\n#define saturate( a ) clamp( a, 0.0, 1.0 )\n#endif\nuniform float toneMappingExposure;\nvec3 LinearToneMapping( vec3 color ) {\n	return saturate( toneMappingExposure * color );\n}\nvec3 ReinhardToneMapping( vec3 color ) {\n	color *= toneMappingExposure;\n	return saturate( color / ( vec3( 1.0 ) + color ) );\n}\nvec3 OptimizedCineonToneMapping( vec3 color ) {\n	color *= toneMappingExposure;\n	color = max( vec3( 0.0 ), color - 0.004 );\n	return pow( ( color * ( 6.2 * color + 0.5 ) ) / ( color * ( 6.2 * color + 1.7 ) + 0.06 ), vec3( 2.2 ) );\n}\nvec3 RRTAndODTFit( vec3 v ) {\n	vec3 a = v * ( v + 0.0245786 ) - 0.000090537;\n	vec3 b = v * ( 0.983729 * v + 0.4329510 ) + 0.238081;\n	return a / b;\n}\nvec3 ACESFilmicToneMapping( vec3 color ) {\n	const mat3 ACESInputMat = mat3(\n		vec3( 0.59719, 0.07600, 0.02840 ),		vec3( 0.35458, 0.90834, 0.13383 ),\n		vec3( 0.04823, 0.01566, 0.83777 )\n	);\n	const mat3 ACESOutputMat = mat3(\n		vec3(  1.60475, -0.10208, -0.00327 ),		vec3( -0.53108,  1.10813, -0.07276 ),\n		vec3( -0.07367, -0.00605,  1.07602 )\n	);\n	color *= toneMappingExposure / 0.6;\n	color = ACESInputMat * color;\n	color = RRTAndODTFit( color );\n	color = ACESOutputMat * color;\n	return saturate( color );\n}\nvec3 CustomToneMapping( vec3 color ) { return color; }";
var $9014d97cd777be10$var$transmission_fragment = "#ifdef USE_TRANSMISSION\n	material.transmission = transmission;\n	material.transmissionAlpha = 1.0;\n	material.thickness = thickness;\n	material.attenuationDistance = attenuationDistance;\n	material.attenuationColor = attenuationColor;\n	#ifdef USE_TRANSMISSIONMAP\n		material.transmission *= texture2D( transmissionMap, vTransmissionMapUv ).r;\n	#endif\n	#ifdef USE_THICKNESSMAP\n		material.thickness *= texture2D( thicknessMap, vThicknessMapUv ).g;\n	#endif\n	vec3 pos = vWorldPosition;\n	vec3 v = normalize( cameraPosition - pos );\n	vec3 n = inverseTransformDirection( normal, viewMatrix );\n	vec4 transmitted = getIBLVolumeRefraction(\n		n, v, material.roughness, material.diffuseColor, material.specularColor, material.specularF90,\n		pos, modelMatrix, viewMatrix, projectionMatrix, material.ior, material.thickness,\n		material.attenuationColor, material.attenuationDistance );\n	material.transmissionAlpha = mix( material.transmissionAlpha, transmitted.a, material.transmission );\n	totalDiffuse = mix( totalDiffuse, transmitted.rgb, material.transmission );\n#endif";
var $9014d97cd777be10$var$transmission_pars_fragment = "#ifdef USE_TRANSMISSION\n	uniform float transmission;\n	uniform float thickness;\n	uniform float attenuationDistance;\n	uniform vec3 attenuationColor;\n	#ifdef USE_TRANSMISSIONMAP\n		uniform sampler2D transmissionMap;\n	#endif\n	#ifdef USE_THICKNESSMAP\n		uniform sampler2D thicknessMap;\n	#endif\n	uniform vec2 transmissionSamplerSize;\n	uniform sampler2D transmissionSamplerMap;\n	uniform mat4 modelMatrix;\n	uniform mat4 projectionMatrix;\n	varying vec3 vWorldPosition;\n	float w0( float a ) {\n		return ( 1.0 / 6.0 ) * ( a * ( a * ( - a + 3.0 ) - 3.0 ) + 1.0 );\n	}\n	float w1( float a ) {\n		return ( 1.0 / 6.0 ) * ( a *  a * ( 3.0 * a - 6.0 ) + 4.0 );\n	}\n	float w2( float a ){\n		return ( 1.0 / 6.0 ) * ( a * ( a * ( - 3.0 * a + 3.0 ) + 3.0 ) + 1.0 );\n	}\n	float w3( float a ) {\n		return ( 1.0 / 6.0 ) * ( a * a * a );\n	}\n	float g0( float a ) {\n		return w0( a ) + w1( a );\n	}\n	float g1( float a ) {\n		return w2( a ) + w3( a );\n	}\n	float h0( float a ) {\n		return - 1.0 + w1( a ) / ( w0( a ) + w1( a ) );\n	}\n	float h1( float a ) {\n		return 1.0 + w3( a ) / ( w2( a ) + w3( a ) );\n	}\n	vec4 bicubic( sampler2D tex, vec2 uv, vec4 texelSize, float lod ) {\n		uv = uv * texelSize.zw + 0.5;\n		vec2 iuv = floor( uv );\n		vec2 fuv = fract( uv );\n		float g0x = g0( fuv.x );\n		float g1x = g1( fuv.x );\n		float h0x = h0( fuv.x );\n		float h1x = h1( fuv.x );\n		float h0y = h0( fuv.y );\n		float h1y = h1( fuv.y );\n		vec2 p0 = ( vec2( iuv.x + h0x, iuv.y + h0y ) - 0.5 ) * texelSize.xy;\n		vec2 p1 = ( vec2( iuv.x + h1x, iuv.y + h0y ) - 0.5 ) * texelSize.xy;\n		vec2 p2 = ( vec2( iuv.x + h0x, iuv.y + h1y ) - 0.5 ) * texelSize.xy;\n		vec2 p3 = ( vec2( iuv.x + h1x, iuv.y + h1y ) - 0.5 ) * texelSize.xy;\n		return g0( fuv.y ) * ( g0x * textureLod( tex, p0, lod ) + g1x * textureLod( tex, p1, lod ) ) +\n			g1( fuv.y ) * ( g0x * textureLod( tex, p2, lod ) + g1x * textureLod( tex, p3, lod ) );\n	}\n	vec4 textureBicubic( sampler2D sampler, vec2 uv, float lod ) {\n		vec2 fLodSize = vec2( textureSize( sampler, int( lod ) ) );\n		vec2 cLodSize = vec2( textureSize( sampler, int( lod + 1.0 ) ) );\n		vec2 fLodSizeInv = 1.0 / fLodSize;\n		vec2 cLodSizeInv = 1.0 / cLodSize;\n		vec4 fSample = bicubic( sampler, uv, vec4( fLodSizeInv, fLodSize ), floor( lod ) );\n		vec4 cSample = bicubic( sampler, uv, vec4( cLodSizeInv, cLodSize ), ceil( lod ) );\n		return mix( fSample, cSample, fract( lod ) );\n	}\n	vec3 getVolumeTransmissionRay( const in vec3 n, const in vec3 v, const in float thickness, const in float ior, const in mat4 modelMatrix ) {\n		vec3 refractionVector = refract( - v, normalize( n ), 1.0 / ior );\n		vec3 modelScale;\n		modelScale.x = length( vec3( modelMatrix[ 0 ].xyz ) );\n		modelScale.y = length( vec3( modelMatrix[ 1 ].xyz ) );\n		modelScale.z = length( vec3( modelMatrix[ 2 ].xyz ) );\n		return normalize( refractionVector ) * thickness * modelScale;\n	}\n	float applyIorToRoughness( const in float roughness, const in float ior ) {\n		return roughness * clamp( ior * 2.0 - 2.0, 0.0, 1.0 );\n	}\n	vec4 getTransmissionSample( const in vec2 fragCoord, const in float roughness, const in float ior ) {\n		float lod = log2( transmissionSamplerSize.x ) * applyIorToRoughness( roughness, ior );\n		return textureBicubic( transmissionSamplerMap, fragCoord.xy, lod );\n	}\n	vec3 volumeAttenuation( const in float transmissionDistance, const in vec3 attenuationColor, const in float attenuationDistance ) {\n		if ( isinf( attenuationDistance ) ) {\n			return vec3( 1.0 );\n		} else {\n			vec3 attenuationCoefficient = -log( attenuationColor ) / attenuationDistance;\n			vec3 transmittance = exp( - attenuationCoefficient * transmissionDistance );			return transmittance;\n		}\n	}\n	vec4 getIBLVolumeRefraction( const in vec3 n, const in vec3 v, const in float roughness, const in vec3 diffuseColor,\n		const in vec3 specularColor, const in float specularF90, const in vec3 position, const in mat4 modelMatrix,\n		const in mat4 viewMatrix, const in mat4 projMatrix, const in float ior, const in float thickness,\n		const in vec3 attenuationColor, const in float attenuationDistance ) {\n		vec3 transmissionRay = getVolumeTransmissionRay( n, v, thickness, ior, modelMatrix );\n		vec3 refractedRayExit = position + transmissionRay;\n		vec4 ndcPos = projMatrix * viewMatrix * vec4( refractedRayExit, 1.0 );\n		vec2 refractionCoords = ndcPos.xy / ndcPos.w;\n		refractionCoords += 1.0;\n		refractionCoords /= 2.0;\n		vec4 transmittedLight = getTransmissionSample( refractionCoords, roughness, ior );\n		vec3 transmittance = diffuseColor * volumeAttenuation( length( transmissionRay ), attenuationColor, attenuationDistance );\n		vec3 attenuatedColor = transmittance * transmittedLight.rgb;\n		vec3 F = EnvironmentBRDF( n, v, specularColor, specularF90, roughness );\n		float transmittanceFactor = ( transmittance.r + transmittance.g + transmittance.b ) / 3.0;\n		return vec4( ( 1.0 - F ) * attenuatedColor, 1.0 - ( 1.0 - transmittedLight.a ) * transmittanceFactor );\n	}\n#endif";
var $9014d97cd777be10$var$uv_pars_fragment = "#if defined( USE_UV ) || defined( USE_ANISOTROPY )\n	varying vec2 vUv;\n#endif\n#ifdef USE_MAP\n	varying vec2 vMapUv;\n#endif\n#ifdef USE_ALPHAMAP\n	varying vec2 vAlphaMapUv;\n#endif\n#ifdef USE_LIGHTMAP\n	varying vec2 vLightMapUv;\n#endif\n#ifdef USE_AOMAP\n	varying vec2 vAoMapUv;\n#endif\n#ifdef USE_BUMPMAP\n	varying vec2 vBumpMapUv;\n#endif\n#ifdef USE_NORMALMAP\n	varying vec2 vNormalMapUv;\n#endif\n#ifdef USE_EMISSIVEMAP\n	varying vec2 vEmissiveMapUv;\n#endif\n#ifdef USE_METALNESSMAP\n	varying vec2 vMetalnessMapUv;\n#endif\n#ifdef USE_ROUGHNESSMAP\n	varying vec2 vRoughnessMapUv;\n#endif\n#ifdef USE_ANISOTROPYMAP\n	varying vec2 vAnisotropyMapUv;\n#endif\n#ifdef USE_CLEARCOATMAP\n	varying vec2 vClearcoatMapUv;\n#endif\n#ifdef USE_CLEARCOAT_NORMALMAP\n	varying vec2 vClearcoatNormalMapUv;\n#endif\n#ifdef USE_CLEARCOAT_ROUGHNESSMAP\n	varying vec2 vClearcoatRoughnessMapUv;\n#endif\n#ifdef USE_IRIDESCENCEMAP\n	varying vec2 vIridescenceMapUv;\n#endif\n#ifdef USE_IRIDESCENCE_THICKNESSMAP\n	varying vec2 vIridescenceThicknessMapUv;\n#endif\n#ifdef USE_SHEEN_COLORMAP\n	varying vec2 vSheenColorMapUv;\n#endif\n#ifdef USE_SHEEN_ROUGHNESSMAP\n	varying vec2 vSheenRoughnessMapUv;\n#endif\n#ifdef USE_SPECULARMAP\n	varying vec2 vSpecularMapUv;\n#endif\n#ifdef USE_SPECULAR_COLORMAP\n	varying vec2 vSpecularColorMapUv;\n#endif\n#ifdef USE_SPECULAR_INTENSITYMAP\n	varying vec2 vSpecularIntensityMapUv;\n#endif\n#ifdef USE_TRANSMISSIONMAP\n	uniform mat3 transmissionMapTransform;\n	varying vec2 vTransmissionMapUv;\n#endif\n#ifdef USE_THICKNESSMAP\n	uniform mat3 thicknessMapTransform;\n	varying vec2 vThicknessMapUv;\n#endif";
var $9014d97cd777be10$var$uv_pars_vertex = "#if defined( USE_UV ) || defined( USE_ANISOTROPY )\n	varying vec2 vUv;\n#endif\n#ifdef USE_MAP\n	uniform mat3 mapTransform;\n	varying vec2 vMapUv;\n#endif\n#ifdef USE_ALPHAMAP\n	uniform mat3 alphaMapTransform;\n	varying vec2 vAlphaMapUv;\n#endif\n#ifdef USE_LIGHTMAP\n	uniform mat3 lightMapTransform;\n	varying vec2 vLightMapUv;\n#endif\n#ifdef USE_AOMAP\n	uniform mat3 aoMapTransform;\n	varying vec2 vAoMapUv;\n#endif\n#ifdef USE_BUMPMAP\n	uniform mat3 bumpMapTransform;\n	varying vec2 vBumpMapUv;\n#endif\n#ifdef USE_NORMALMAP\n	uniform mat3 normalMapTransform;\n	varying vec2 vNormalMapUv;\n#endif\n#ifdef USE_DISPLACEMENTMAP\n	uniform mat3 displacementMapTransform;\n	varying vec2 vDisplacementMapUv;\n#endif\n#ifdef USE_EMISSIVEMAP\n	uniform mat3 emissiveMapTransform;\n	varying vec2 vEmissiveMapUv;\n#endif\n#ifdef USE_METALNESSMAP\n	uniform mat3 metalnessMapTransform;\n	varying vec2 vMetalnessMapUv;\n#endif\n#ifdef USE_ROUGHNESSMAP\n	uniform mat3 roughnessMapTransform;\n	varying vec2 vRoughnessMapUv;\n#endif\n#ifdef USE_ANISOTROPYMAP\n	uniform mat3 anisotropyMapTransform;\n	varying vec2 vAnisotropyMapUv;\n#endif\n#ifdef USE_CLEARCOATMAP\n	uniform mat3 clearcoatMapTransform;\n	varying vec2 vClearcoatMapUv;\n#endif\n#ifdef USE_CLEARCOAT_NORMALMAP\n	uniform mat3 clearcoatNormalMapTransform;\n	varying vec2 vClearcoatNormalMapUv;\n#endif\n#ifdef USE_CLEARCOAT_ROUGHNESSMAP\n	uniform mat3 clearcoatRoughnessMapTransform;\n	varying vec2 vClearcoatRoughnessMapUv;\n#endif\n#ifdef USE_SHEEN_COLORMAP\n	uniform mat3 sheenColorMapTransform;\n	varying vec2 vSheenColorMapUv;\n#endif\n#ifdef USE_SHEEN_ROUGHNESSMAP\n	uniform mat3 sheenRoughnessMapTransform;\n	varying vec2 vSheenRoughnessMapUv;\n#endif\n#ifdef USE_IRIDESCENCEMAP\n	uniform mat3 iridescenceMapTransform;\n	varying vec2 vIridescenceMapUv;\n#endif\n#ifdef USE_IRIDESCENCE_THICKNESSMAP\n	uniform mat3 iridescenceThicknessMapTransform;\n	varying vec2 vIridescenceThicknessMapUv;\n#endif\n#ifdef USE_SPECULARMAP\n	uniform mat3 specularMapTransform;\n	varying vec2 vSpecularMapUv;\n#endif\n#ifdef USE_SPECULAR_COLORMAP\n	uniform mat3 specularColorMapTransform;\n	varying vec2 vSpecularColorMapUv;\n#endif\n#ifdef USE_SPECULAR_INTENSITYMAP\n	uniform mat3 specularIntensityMapTransform;\n	varying vec2 vSpecularIntensityMapUv;\n#endif\n#ifdef USE_TRANSMISSIONMAP\n	uniform mat3 transmissionMapTransform;\n	varying vec2 vTransmissionMapUv;\n#endif\n#ifdef USE_THICKNESSMAP\n	uniform mat3 thicknessMapTransform;\n	varying vec2 vThicknessMapUv;\n#endif";
var $9014d97cd777be10$var$uv_vertex = "#if defined( USE_UV ) || defined( USE_ANISOTROPY )\n	vUv = vec3( uv, 1 ).xy;\n#endif\n#ifdef USE_MAP\n	vMapUv = ( mapTransform * vec3( MAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_ALPHAMAP\n	vAlphaMapUv = ( alphaMapTransform * vec3( ALPHAMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_LIGHTMAP\n	vLightMapUv = ( lightMapTransform * vec3( LIGHTMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_AOMAP\n	vAoMapUv = ( aoMapTransform * vec3( AOMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_BUMPMAP\n	vBumpMapUv = ( bumpMapTransform * vec3( BUMPMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_NORMALMAP\n	vNormalMapUv = ( normalMapTransform * vec3( NORMALMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_DISPLACEMENTMAP\n	vDisplacementMapUv = ( displacementMapTransform * vec3( DISPLACEMENTMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_EMISSIVEMAP\n	vEmissiveMapUv = ( emissiveMapTransform * vec3( EMISSIVEMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_METALNESSMAP\n	vMetalnessMapUv = ( metalnessMapTransform * vec3( METALNESSMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_ROUGHNESSMAP\n	vRoughnessMapUv = ( roughnessMapTransform * vec3( ROUGHNESSMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_ANISOTROPYMAP\n	vAnisotropyMapUv = ( anisotropyMapTransform * vec3( ANISOTROPYMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_CLEARCOATMAP\n	vClearcoatMapUv = ( clearcoatMapTransform * vec3( CLEARCOATMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_CLEARCOAT_NORMALMAP\n	vClearcoatNormalMapUv = ( clearcoatNormalMapTransform * vec3( CLEARCOAT_NORMALMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_CLEARCOAT_ROUGHNESSMAP\n	vClearcoatRoughnessMapUv = ( clearcoatRoughnessMapTransform * vec3( CLEARCOAT_ROUGHNESSMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_IRIDESCENCEMAP\n	vIridescenceMapUv = ( iridescenceMapTransform * vec3( IRIDESCENCEMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_IRIDESCENCE_THICKNESSMAP\n	vIridescenceThicknessMapUv = ( iridescenceThicknessMapTransform * vec3( IRIDESCENCE_THICKNESSMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_SHEEN_COLORMAP\n	vSheenColorMapUv = ( sheenColorMapTransform * vec3( SHEEN_COLORMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_SHEEN_ROUGHNESSMAP\n	vSheenRoughnessMapUv = ( sheenRoughnessMapTransform * vec3( SHEEN_ROUGHNESSMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_SPECULARMAP\n	vSpecularMapUv = ( specularMapTransform * vec3( SPECULARMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_SPECULAR_COLORMAP\n	vSpecularColorMapUv = ( specularColorMapTransform * vec3( SPECULAR_COLORMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_SPECULAR_INTENSITYMAP\n	vSpecularIntensityMapUv = ( specularIntensityMapTransform * vec3( SPECULAR_INTENSITYMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_TRANSMISSIONMAP\n	vTransmissionMapUv = ( transmissionMapTransform * vec3( TRANSMISSIONMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_THICKNESSMAP\n	vThicknessMapUv = ( thicknessMapTransform * vec3( THICKNESSMAP_UV, 1 ) ).xy;\n#endif";
var $9014d97cd777be10$var$worldpos_vertex = "#if defined( USE_ENVMAP ) || defined( DISTANCE ) || defined ( USE_SHADOWMAP ) || defined ( USE_TRANSMISSION ) || NUM_SPOT_LIGHT_COORDS > 0\n	vec4 worldPosition = vec4( transformed, 1.0 );\n	#ifdef USE_INSTANCING\n		worldPosition = instanceMatrix * worldPosition;\n	#endif\n	worldPosition = modelMatrix * worldPosition;\n#endif";
const $9014d97cd777be10$var$vertex$h = "varying vec2 vUv;\nuniform mat3 uvTransform;\nvoid main() {\n	vUv = ( uvTransform * vec3( uv, 1 ) ).xy;\n	gl_Position = vec4( position.xy, 1.0, 1.0 );\n}";
const $9014d97cd777be10$var$fragment$h = "uniform sampler2D t2D;\nuniform float backgroundIntensity;\nvarying vec2 vUv;\nvoid main() {\n	vec4 texColor = texture2D( t2D, vUv );\n	texColor.rgb *= backgroundIntensity;\n	gl_FragColor = texColor;\n	#include <tonemapping_fragment>\n	#include <colorspace_fragment>\n}";
const $9014d97cd777be10$var$vertex$g = "varying vec3 vWorldDirection;\n#include <common>\nvoid main() {\n	vWorldDirection = transformDirection( position, modelMatrix );\n	#include <begin_vertex>\n	#include <project_vertex>\n	gl_Position.z = gl_Position.w;\n}";
const $9014d97cd777be10$var$fragment$g = "#ifdef ENVMAP_TYPE_CUBE\n	uniform samplerCube envMap;\n#elif defined( ENVMAP_TYPE_CUBE_UV )\n	uniform sampler2D envMap;\n#endif\nuniform float flipEnvMap;\nuniform float backgroundBlurriness;\nuniform float backgroundIntensity;\nvarying vec3 vWorldDirection;\n#include <cube_uv_reflection_fragment>\nvoid main() {\n	#ifdef ENVMAP_TYPE_CUBE\n		vec4 texColor = textureCube( envMap, vec3( flipEnvMap * vWorldDirection.x, vWorldDirection.yz ) );\n	#elif defined( ENVMAP_TYPE_CUBE_UV )\n		vec4 texColor = textureCubeUV( envMap, vWorldDirection, backgroundBlurriness );\n	#else\n		vec4 texColor = vec4( 0.0, 0.0, 0.0, 1.0 );\n	#endif\n	texColor.rgb *= backgroundIntensity;\n	gl_FragColor = texColor;\n	#include <tonemapping_fragment>\n	#include <colorspace_fragment>\n}";
const $9014d97cd777be10$var$vertex$f = "varying vec3 vWorldDirection;\n#include <common>\nvoid main() {\n	vWorldDirection = transformDirection( position, modelMatrix );\n	#include <begin_vertex>\n	#include <project_vertex>\n	gl_Position.z = gl_Position.w;\n}";
const $9014d97cd777be10$var$fragment$f = "uniform samplerCube tCube;\nuniform float tFlip;\nuniform float opacity;\nvarying vec3 vWorldDirection;\nvoid main() {\n	vec4 texColor = textureCube( tCube, vec3( tFlip * vWorldDirection.x, vWorldDirection.yz ) );\n	gl_FragColor = texColor;\n	gl_FragColor.a *= opacity;\n	#include <tonemapping_fragment>\n	#include <colorspace_fragment>\n}";
const $9014d97cd777be10$var$vertex$e = "#include <common>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvarying vec2 vHighPrecisionZW;\nvoid main() {\n	#include <uv_vertex>\n	#include <skinbase_vertex>\n	#ifdef USE_DISPLACEMENTMAP\n		#include <beginnormal_vertex>\n		#include <morphnormal_vertex>\n		#include <skinnormal_vertex>\n	#endif\n	#include <begin_vertex>\n	#include <morphtarget_vertex>\n	#include <skinning_vertex>\n	#include <displacementmap_vertex>\n	#include <project_vertex>\n	#include <logdepthbuf_vertex>\n	#include <clipping_planes_vertex>\n	vHighPrecisionZW = gl_Position.zw;\n}";
const $9014d97cd777be10$var$fragment$e = "#if DEPTH_PACKING == 3200\n	uniform float opacity;\n#endif\n#include <common>\n#include <packing>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvarying vec2 vHighPrecisionZW;\nvoid main() {\n	#include <clipping_planes_fragment>\n	vec4 diffuseColor = vec4( 1.0 );\n	#if DEPTH_PACKING == 3200\n		diffuseColor.a = opacity;\n	#endif\n	#include <map_fragment>\n	#include <alphamap_fragment>\n	#include <alphatest_fragment>\n	#include <alphahash_fragment>\n	#include <logdepthbuf_fragment>\n	float fragCoordZ = 0.5 * vHighPrecisionZW[0] / vHighPrecisionZW[1] + 0.5;\n	#if DEPTH_PACKING == 3200\n		gl_FragColor = vec4( vec3( 1.0 - fragCoordZ ), opacity );\n	#elif DEPTH_PACKING == 3201\n		gl_FragColor = packDepthToRGBA( fragCoordZ );\n	#endif\n}";
const $9014d97cd777be10$var$vertex$d = "#define DISTANCE\nvarying vec3 vWorldPosition;\n#include <common>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n	#include <uv_vertex>\n	#include <skinbase_vertex>\n	#ifdef USE_DISPLACEMENTMAP\n		#include <beginnormal_vertex>\n		#include <morphnormal_vertex>\n		#include <skinnormal_vertex>\n	#endif\n	#include <begin_vertex>\n	#include <morphtarget_vertex>\n	#include <skinning_vertex>\n	#include <displacementmap_vertex>\n	#include <project_vertex>\n	#include <worldpos_vertex>\n	#include <clipping_planes_vertex>\n	vWorldPosition = worldPosition.xyz;\n}";
const $9014d97cd777be10$var$fragment$d = "#define DISTANCE\nuniform vec3 referencePosition;\nuniform float nearDistance;\nuniform float farDistance;\nvarying vec3 vWorldPosition;\n#include <common>\n#include <packing>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main () {\n	#include <clipping_planes_fragment>\n	vec4 diffuseColor = vec4( 1.0 );\n	#include <map_fragment>\n	#include <alphamap_fragment>\n	#include <alphatest_fragment>\n	#include <alphahash_fragment>\n	float dist = length( vWorldPosition - referencePosition );\n	dist = ( dist - nearDistance ) / ( farDistance - nearDistance );\n	dist = saturate( dist );\n	gl_FragColor = packDepthToRGBA( dist );\n}";
const $9014d97cd777be10$var$vertex$c = "varying vec3 vWorldDirection;\n#include <common>\nvoid main() {\n	vWorldDirection = transformDirection( position, modelMatrix );\n	#include <begin_vertex>\n	#include <project_vertex>\n}";
const $9014d97cd777be10$var$fragment$c = "uniform sampler2D tEquirect;\nvarying vec3 vWorldDirection;\n#include <common>\nvoid main() {\n	vec3 direction = normalize( vWorldDirection );\n	vec2 sampleUV = equirectUv( direction );\n	gl_FragColor = texture2D( tEquirect, sampleUV );\n	#include <tonemapping_fragment>\n	#include <colorspace_fragment>\n}";
const $9014d97cd777be10$var$vertex$b = "uniform float scale;\nattribute float lineDistance;\nvarying float vLineDistance;\n#include <common>\n#include <uv_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n	vLineDistance = scale * lineDistance;\n	#include <uv_vertex>\n	#include <color_vertex>\n	#include <morphcolor_vertex>\n	#include <begin_vertex>\n	#include <morphtarget_vertex>\n	#include <project_vertex>\n	#include <logdepthbuf_vertex>\n	#include <clipping_planes_vertex>\n	#include <fog_vertex>\n}";
const $9014d97cd777be10$var$fragment$b = "uniform vec3 diffuse;\nuniform float opacity;\nuniform float dashSize;\nuniform float totalSize;\nvarying float vLineDistance;\n#include <common>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <fog_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n	#include <clipping_planes_fragment>\n	if ( mod( vLineDistance, totalSize ) > dashSize ) {\n		discard;\n	}\n	vec3 outgoingLight = vec3( 0.0 );\n	vec4 diffuseColor = vec4( diffuse, opacity );\n	#include <logdepthbuf_fragment>\n	#include <map_fragment>\n	#include <color_fragment>\n	outgoingLight = diffuseColor.rgb;\n	#include <opaque_fragment>\n	#include <tonemapping_fragment>\n	#include <colorspace_fragment>\n	#include <fog_fragment>\n	#include <premultiplied_alpha_fragment>\n}";
const $9014d97cd777be10$var$vertex$a = "#include <common>\n#include <uv_pars_vertex>\n#include <envmap_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n	#include <uv_vertex>\n	#include <color_vertex>\n	#include <morphcolor_vertex>\n	#if defined ( USE_ENVMAP ) || defined ( USE_SKINNING )\n		#include <beginnormal_vertex>\n		#include <morphnormal_vertex>\n		#include <skinbase_vertex>\n		#include <skinnormal_vertex>\n		#include <defaultnormal_vertex>\n	#endif\n	#include <begin_vertex>\n	#include <morphtarget_vertex>\n	#include <skinning_vertex>\n	#include <project_vertex>\n	#include <logdepthbuf_vertex>\n	#include <clipping_planes_vertex>\n	#include <worldpos_vertex>\n	#include <envmap_vertex>\n	#include <fog_vertex>\n}";
const $9014d97cd777be10$var$fragment$a = "uniform vec3 diffuse;\nuniform float opacity;\n#ifndef FLAT_SHADED\n	varying vec3 vNormal;\n#endif\n#include <common>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <envmap_common_pars_fragment>\n#include <envmap_pars_fragment>\n#include <fog_pars_fragment>\n#include <specularmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n	#include <clipping_planes_fragment>\n	vec4 diffuseColor = vec4( diffuse, opacity );\n	#include <logdepthbuf_fragment>\n	#include <map_fragment>\n	#include <color_fragment>\n	#include <alphamap_fragment>\n	#include <alphatest_fragment>\n	#include <alphahash_fragment>\n	#include <specularmap_fragment>\n	ReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n	#ifdef USE_LIGHTMAP\n		vec4 lightMapTexel = texture2D( lightMap, vLightMapUv );\n		reflectedLight.indirectDiffuse += lightMapTexel.rgb * lightMapIntensity * RECIPROCAL_PI;\n	#else\n		reflectedLight.indirectDiffuse += vec3( 1.0 );\n	#endif\n	#include <aomap_fragment>\n	reflectedLight.indirectDiffuse *= diffuseColor.rgb;\n	vec3 outgoingLight = reflectedLight.indirectDiffuse;\n	#include <envmap_fragment>\n	#include <opaque_fragment>\n	#include <tonemapping_fragment>\n	#include <colorspace_fragment>\n	#include <fog_fragment>\n	#include <premultiplied_alpha_fragment>\n	#include <dithering_fragment>\n}";
const $9014d97cd777be10$var$vertex$9 = "#define LAMBERT\nvarying vec3 vViewPosition;\n#include <common>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <envmap_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <normal_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <shadowmap_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n	#include <uv_vertex>\n	#include <color_vertex>\n	#include <morphcolor_vertex>\n	#include <beginnormal_vertex>\n	#include <morphnormal_vertex>\n	#include <skinbase_vertex>\n	#include <skinnormal_vertex>\n	#include <defaultnormal_vertex>\n	#include <normal_vertex>\n	#include <begin_vertex>\n	#include <morphtarget_vertex>\n	#include <skinning_vertex>\n	#include <displacementmap_vertex>\n	#include <project_vertex>\n	#include <logdepthbuf_vertex>\n	#include <clipping_planes_vertex>\n	vViewPosition = - mvPosition.xyz;\n	#include <worldpos_vertex>\n	#include <envmap_vertex>\n	#include <shadowmap_vertex>\n	#include <fog_vertex>\n}";
const $9014d97cd777be10$var$fragment$9 = "#define LAMBERT\nuniform vec3 diffuse;\nuniform vec3 emissive;\nuniform float opacity;\n#include <common>\n#include <packing>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <emissivemap_pars_fragment>\n#include <envmap_common_pars_fragment>\n#include <envmap_pars_fragment>\n#include <fog_pars_fragment>\n#include <bsdfs>\n#include <lights_pars_begin>\n#include <normal_pars_fragment>\n#include <lights_lambert_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <specularmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n	#include <clipping_planes_fragment>\n	vec4 diffuseColor = vec4( diffuse, opacity );\n	ReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n	vec3 totalEmissiveRadiance = emissive;\n	#include <logdepthbuf_fragment>\n	#include <map_fragment>\n	#include <color_fragment>\n	#include <alphamap_fragment>\n	#include <alphatest_fragment>\n	#include <alphahash_fragment>\n	#include <specularmap_fragment>\n	#include <normal_fragment_begin>\n	#include <normal_fragment_maps>\n	#include <emissivemap_fragment>\n	#include <lights_lambert_fragment>\n	#include <lights_fragment_begin>\n	#include <lights_fragment_maps>\n	#include <lights_fragment_end>\n	#include <aomap_fragment>\n	vec3 outgoingLight = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse + totalEmissiveRadiance;\n	#include <envmap_fragment>\n	#include <opaque_fragment>\n	#include <tonemapping_fragment>\n	#include <colorspace_fragment>\n	#include <fog_fragment>\n	#include <premultiplied_alpha_fragment>\n	#include <dithering_fragment>\n}";
const $9014d97cd777be10$var$vertex$8 = "#define MATCAP\nvarying vec3 vViewPosition;\n#include <common>\n#include <uv_pars_vertex>\n#include <color_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <fog_pars_vertex>\n#include <normal_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n	#include <uv_vertex>\n	#include <color_vertex>\n	#include <morphcolor_vertex>\n	#include <beginnormal_vertex>\n	#include <morphnormal_vertex>\n	#include <skinbase_vertex>\n	#include <skinnormal_vertex>\n	#include <defaultnormal_vertex>\n	#include <normal_vertex>\n	#include <begin_vertex>\n	#include <morphtarget_vertex>\n	#include <skinning_vertex>\n	#include <displacementmap_vertex>\n	#include <project_vertex>\n	#include <logdepthbuf_vertex>\n	#include <clipping_planes_vertex>\n	#include <fog_vertex>\n	vViewPosition = - mvPosition.xyz;\n}";
const $9014d97cd777be10$var$fragment$8 = "#define MATCAP\nuniform vec3 diffuse;\nuniform float opacity;\nuniform sampler2D matcap;\nvarying vec3 vViewPosition;\n#include <common>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <fog_pars_fragment>\n#include <normal_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n	#include <clipping_planes_fragment>\n	vec4 diffuseColor = vec4( diffuse, opacity );\n	#include <logdepthbuf_fragment>\n	#include <map_fragment>\n	#include <color_fragment>\n	#include <alphamap_fragment>\n	#include <alphatest_fragment>\n	#include <alphahash_fragment>\n	#include <normal_fragment_begin>\n	#include <normal_fragment_maps>\n	vec3 viewDir = normalize( vViewPosition );\n	vec3 x = normalize( vec3( viewDir.z, 0.0, - viewDir.x ) );\n	vec3 y = cross( viewDir, x );\n	vec2 uv = vec2( dot( x, normal ), dot( y, normal ) ) * 0.495 + 0.5;\n	#ifdef USE_MATCAP\n		vec4 matcapColor = texture2D( matcap, uv );\n	#else\n		vec4 matcapColor = vec4( vec3( mix( 0.2, 0.8, uv.y ) ), 1.0 );\n	#endif\n	vec3 outgoingLight = diffuseColor.rgb * matcapColor.rgb;\n	#include <opaque_fragment>\n	#include <tonemapping_fragment>\n	#include <colorspace_fragment>\n	#include <fog_fragment>\n	#include <premultiplied_alpha_fragment>\n	#include <dithering_fragment>\n}";
const $9014d97cd777be10$var$vertex$7 = "#define NORMAL\n#if defined( FLAT_SHADED ) || defined( USE_BUMPMAP ) || defined( USE_NORMALMAP_TANGENTSPACE )\n	varying vec3 vViewPosition;\n#endif\n#include <common>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <normal_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n	#include <uv_vertex>\n	#include <beginnormal_vertex>\n	#include <morphnormal_vertex>\n	#include <skinbase_vertex>\n	#include <skinnormal_vertex>\n	#include <defaultnormal_vertex>\n	#include <normal_vertex>\n	#include <begin_vertex>\n	#include <morphtarget_vertex>\n	#include <skinning_vertex>\n	#include <displacementmap_vertex>\n	#include <project_vertex>\n	#include <logdepthbuf_vertex>\n	#include <clipping_planes_vertex>\n#if defined( FLAT_SHADED ) || defined( USE_BUMPMAP ) || defined( USE_NORMALMAP_TANGENTSPACE )\n	vViewPosition = - mvPosition.xyz;\n#endif\n}";
const $9014d97cd777be10$var$fragment$7 = "#define NORMAL\nuniform float opacity;\n#if defined( FLAT_SHADED ) || defined( USE_BUMPMAP ) || defined( USE_NORMALMAP_TANGENTSPACE )\n	varying vec3 vViewPosition;\n#endif\n#include <packing>\n#include <uv_pars_fragment>\n#include <normal_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n	#include <clipping_planes_fragment>\n	#include <logdepthbuf_fragment>\n	#include <normal_fragment_begin>\n	#include <normal_fragment_maps>\n	gl_FragColor = vec4( packNormalToRGB( normal ), opacity );\n	#ifdef OPAQUE\n		gl_FragColor.a = 1.0;\n	#endif\n}";
const $9014d97cd777be10$var$vertex$6 = "#define PHONG\nvarying vec3 vViewPosition;\n#include <common>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <envmap_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <normal_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <shadowmap_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n	#include <uv_vertex>\n	#include <color_vertex>\n	#include <morphcolor_vertex>\n	#include <beginnormal_vertex>\n	#include <morphnormal_vertex>\n	#include <skinbase_vertex>\n	#include <skinnormal_vertex>\n	#include <defaultnormal_vertex>\n	#include <normal_vertex>\n	#include <begin_vertex>\n	#include <morphtarget_vertex>\n	#include <skinning_vertex>\n	#include <displacementmap_vertex>\n	#include <project_vertex>\n	#include <logdepthbuf_vertex>\n	#include <clipping_planes_vertex>\n	vViewPosition = - mvPosition.xyz;\n	#include <worldpos_vertex>\n	#include <envmap_vertex>\n	#include <shadowmap_vertex>\n	#include <fog_vertex>\n}";
const $9014d97cd777be10$var$fragment$6 = "#define PHONG\nuniform vec3 diffuse;\nuniform vec3 emissive;\nuniform vec3 specular;\nuniform float shininess;\nuniform float opacity;\n#include <common>\n#include <packing>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <emissivemap_pars_fragment>\n#include <envmap_common_pars_fragment>\n#include <envmap_pars_fragment>\n#include <fog_pars_fragment>\n#include <bsdfs>\n#include <lights_pars_begin>\n#include <normal_pars_fragment>\n#include <lights_phong_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <specularmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n	#include <clipping_planes_fragment>\n	vec4 diffuseColor = vec4( diffuse, opacity );\n	ReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n	vec3 totalEmissiveRadiance = emissive;\n	#include <logdepthbuf_fragment>\n	#include <map_fragment>\n	#include <color_fragment>\n	#include <alphamap_fragment>\n	#include <alphatest_fragment>\n	#include <alphahash_fragment>\n	#include <specularmap_fragment>\n	#include <normal_fragment_begin>\n	#include <normal_fragment_maps>\n	#include <emissivemap_fragment>\n	#include <lights_phong_fragment>\n	#include <lights_fragment_begin>\n	#include <lights_fragment_maps>\n	#include <lights_fragment_end>\n	#include <aomap_fragment>\n	vec3 outgoingLight = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse + reflectedLight.directSpecular + reflectedLight.indirectSpecular + totalEmissiveRadiance;\n	#include <envmap_fragment>\n	#include <opaque_fragment>\n	#include <tonemapping_fragment>\n	#include <colorspace_fragment>\n	#include <fog_fragment>\n	#include <premultiplied_alpha_fragment>\n	#include <dithering_fragment>\n}";
const $9014d97cd777be10$var$vertex$5 = "#define STANDARD\nvarying vec3 vViewPosition;\n#ifdef USE_TRANSMISSION\n	varying vec3 vWorldPosition;\n#endif\n#include <common>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <normal_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <shadowmap_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n	#include <uv_vertex>\n	#include <color_vertex>\n	#include <morphcolor_vertex>\n	#include <beginnormal_vertex>\n	#include <morphnormal_vertex>\n	#include <skinbase_vertex>\n	#include <skinnormal_vertex>\n	#include <defaultnormal_vertex>\n	#include <normal_vertex>\n	#include <begin_vertex>\n	#include <morphtarget_vertex>\n	#include <skinning_vertex>\n	#include <displacementmap_vertex>\n	#include <project_vertex>\n	#include <logdepthbuf_vertex>\n	#include <clipping_planes_vertex>\n	vViewPosition = - mvPosition.xyz;\n	#include <worldpos_vertex>\n	#include <shadowmap_vertex>\n	#include <fog_vertex>\n#ifdef USE_TRANSMISSION\n	vWorldPosition = worldPosition.xyz;\n#endif\n}";
const $9014d97cd777be10$var$fragment$5 = "#define STANDARD\n#ifdef PHYSICAL\n	#define IOR\n	#define USE_SPECULAR\n#endif\nuniform vec3 diffuse;\nuniform vec3 emissive;\nuniform float roughness;\nuniform float metalness;\nuniform float opacity;\n#ifdef IOR\n	uniform float ior;\n#endif\n#ifdef USE_SPECULAR\n	uniform float specularIntensity;\n	uniform vec3 specularColor;\n	#ifdef USE_SPECULAR_COLORMAP\n		uniform sampler2D specularColorMap;\n	#endif\n	#ifdef USE_SPECULAR_INTENSITYMAP\n		uniform sampler2D specularIntensityMap;\n	#endif\n#endif\n#ifdef USE_CLEARCOAT\n	uniform float clearcoat;\n	uniform float clearcoatRoughness;\n#endif\n#ifdef USE_IRIDESCENCE\n	uniform float iridescence;\n	uniform float iridescenceIOR;\n	uniform float iridescenceThicknessMinimum;\n	uniform float iridescenceThicknessMaximum;\n#endif\n#ifdef USE_SHEEN\n	uniform vec3 sheenColor;\n	uniform float sheenRoughness;\n	#ifdef USE_SHEEN_COLORMAP\n		uniform sampler2D sheenColorMap;\n	#endif\n	#ifdef USE_SHEEN_ROUGHNESSMAP\n		uniform sampler2D sheenRoughnessMap;\n	#endif\n#endif\n#ifdef USE_ANISOTROPY\n	uniform vec2 anisotropyVector;\n	#ifdef USE_ANISOTROPYMAP\n		uniform sampler2D anisotropyMap;\n	#endif\n#endif\nvarying vec3 vViewPosition;\n#include <common>\n#include <packing>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <emissivemap_pars_fragment>\n#include <iridescence_fragment>\n#include <cube_uv_reflection_fragment>\n#include <envmap_common_pars_fragment>\n#include <envmap_physical_pars_fragment>\n#include <fog_pars_fragment>\n#include <lights_pars_begin>\n#include <normal_pars_fragment>\n#include <lights_physical_pars_fragment>\n#include <transmission_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <clearcoat_pars_fragment>\n#include <iridescence_pars_fragment>\n#include <roughnessmap_pars_fragment>\n#include <metalnessmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n	#include <clipping_planes_fragment>\n	vec4 diffuseColor = vec4( diffuse, opacity );\n	ReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n	vec3 totalEmissiveRadiance = emissive;\n	#include <logdepthbuf_fragment>\n	#include <map_fragment>\n	#include <color_fragment>\n	#include <alphamap_fragment>\n	#include <alphatest_fragment>\n	#include <alphahash_fragment>\n	#include <roughnessmap_fragment>\n	#include <metalnessmap_fragment>\n	#include <normal_fragment_begin>\n	#include <normal_fragment_maps>\n	#include <clearcoat_normal_fragment_begin>\n	#include <clearcoat_normal_fragment_maps>\n	#include <emissivemap_fragment>\n	#include <lights_physical_fragment>\n	#include <lights_fragment_begin>\n	#include <lights_fragment_maps>\n	#include <lights_fragment_end>\n	#include <aomap_fragment>\n	vec3 totalDiffuse = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse;\n	vec3 totalSpecular = reflectedLight.directSpecular + reflectedLight.indirectSpecular;\n	#include <transmission_fragment>\n	vec3 outgoingLight = totalDiffuse + totalSpecular + totalEmissiveRadiance;\n	#ifdef USE_SHEEN\n		float sheenEnergyComp = 1.0 - 0.157 * max3( material.sheenColor );\n		outgoingLight = outgoingLight * sheenEnergyComp + sheenSpecular;\n	#endif\n	#ifdef USE_CLEARCOAT\n		float dotNVcc = saturate( dot( geometry.clearcoatNormal, geometry.viewDir ) );\n		vec3 Fcc = F_Schlick( material.clearcoatF0, material.clearcoatF90, dotNVcc );\n		outgoingLight = outgoingLight * ( 1.0 - material.clearcoat * Fcc ) + clearcoatSpecular * material.clearcoat;\n	#endif\n	#include <opaque_fragment>\n	#include <tonemapping_fragment>\n	#include <colorspace_fragment>\n	#include <fog_fragment>\n	#include <premultiplied_alpha_fragment>\n	#include <dithering_fragment>\n}";
const $9014d97cd777be10$var$vertex$4 = "#define TOON\nvarying vec3 vViewPosition;\n#include <common>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <normal_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <shadowmap_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n	#include <uv_vertex>\n	#include <color_vertex>\n	#include <morphcolor_vertex>\n	#include <beginnormal_vertex>\n	#include <morphnormal_vertex>\n	#include <skinbase_vertex>\n	#include <skinnormal_vertex>\n	#include <defaultnormal_vertex>\n	#include <normal_vertex>\n	#include <begin_vertex>\n	#include <morphtarget_vertex>\n	#include <skinning_vertex>\n	#include <displacementmap_vertex>\n	#include <project_vertex>\n	#include <logdepthbuf_vertex>\n	#include <clipping_planes_vertex>\n	vViewPosition = - mvPosition.xyz;\n	#include <worldpos_vertex>\n	#include <shadowmap_vertex>\n	#include <fog_vertex>\n}";
const $9014d97cd777be10$var$fragment$4 = "#define TOON\nuniform vec3 diffuse;\nuniform vec3 emissive;\nuniform float opacity;\n#include <common>\n#include <packing>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <emissivemap_pars_fragment>\n#include <gradientmap_pars_fragment>\n#include <fog_pars_fragment>\n#include <bsdfs>\n#include <lights_pars_begin>\n#include <normal_pars_fragment>\n#include <lights_toon_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n	#include <clipping_planes_fragment>\n	vec4 diffuseColor = vec4( diffuse, opacity );\n	ReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n	vec3 totalEmissiveRadiance = emissive;\n	#include <logdepthbuf_fragment>\n	#include <map_fragment>\n	#include <color_fragment>\n	#include <alphamap_fragment>\n	#include <alphatest_fragment>\n	#include <alphahash_fragment>\n	#include <normal_fragment_begin>\n	#include <normal_fragment_maps>\n	#include <emissivemap_fragment>\n	#include <lights_toon_fragment>\n	#include <lights_fragment_begin>\n	#include <lights_fragment_maps>\n	#include <lights_fragment_end>\n	#include <aomap_fragment>\n	vec3 outgoingLight = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse + totalEmissiveRadiance;\n	#include <opaque_fragment>\n	#include <tonemapping_fragment>\n	#include <colorspace_fragment>\n	#include <fog_fragment>\n	#include <premultiplied_alpha_fragment>\n	#include <dithering_fragment>\n}";
const $9014d97cd777be10$var$vertex$3 = "uniform float size;\nuniform float scale;\n#include <common>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\n#ifdef USE_POINTS_UV\n	varying vec2 vUv;\n	uniform mat3 uvTransform;\n#endif\nvoid main() {\n	#ifdef USE_POINTS_UV\n		vUv = ( uvTransform * vec3( uv, 1 ) ).xy;\n	#endif\n	#include <color_vertex>\n	#include <morphcolor_vertex>\n	#include <begin_vertex>\n	#include <morphtarget_vertex>\n	#include <project_vertex>\n	gl_PointSize = size;\n	#ifdef USE_SIZEATTENUATION\n		bool isPerspective = isPerspectiveMatrix( projectionMatrix );\n		if ( isPerspective ) gl_PointSize *= ( scale / - mvPosition.z );\n	#endif\n	#include <logdepthbuf_vertex>\n	#include <clipping_planes_vertex>\n	#include <worldpos_vertex>\n	#include <fog_vertex>\n}";
const $9014d97cd777be10$var$fragment$3 = "uniform vec3 diffuse;\nuniform float opacity;\n#include <common>\n#include <color_pars_fragment>\n#include <map_particle_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <fog_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n	#include <clipping_planes_fragment>\n	vec3 outgoingLight = vec3( 0.0 );\n	vec4 diffuseColor = vec4( diffuse, opacity );\n	#include <logdepthbuf_fragment>\n	#include <map_particle_fragment>\n	#include <color_fragment>\n	#include <alphatest_fragment>\n	#include <alphahash_fragment>\n	outgoingLight = diffuseColor.rgb;\n	#include <opaque_fragment>\n	#include <tonemapping_fragment>\n	#include <colorspace_fragment>\n	#include <fog_fragment>\n	#include <premultiplied_alpha_fragment>\n}";
const $9014d97cd777be10$var$vertex$2 = "#include <common>\n#include <fog_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <shadowmap_pars_vertex>\nvoid main() {\n	#include <beginnormal_vertex>\n	#include <morphnormal_vertex>\n	#include <skinbase_vertex>\n	#include <skinnormal_vertex>\n	#include <defaultnormal_vertex>\n	#include <begin_vertex>\n	#include <morphtarget_vertex>\n	#include <skinning_vertex>\n	#include <project_vertex>\n	#include <logdepthbuf_vertex>\n	#include <worldpos_vertex>\n	#include <shadowmap_vertex>\n	#include <fog_vertex>\n}";
const $9014d97cd777be10$var$fragment$2 = "uniform vec3 color;\nuniform float opacity;\n#include <common>\n#include <packing>\n#include <fog_pars_fragment>\n#include <bsdfs>\n#include <lights_pars_begin>\n#include <logdepthbuf_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <shadowmask_pars_fragment>\nvoid main() {\n	#include <logdepthbuf_fragment>\n	gl_FragColor = vec4( color, opacity * ( 1.0 - getShadowMask() ) );\n	#include <tonemapping_fragment>\n	#include <colorspace_fragment>\n	#include <fog_fragment>\n}";
const $9014d97cd777be10$var$vertex$1 = "uniform float rotation;\nuniform vec2 center;\n#include <common>\n#include <uv_pars_vertex>\n#include <fog_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n	#include <uv_vertex>\n	vec4 mvPosition = modelViewMatrix * vec4( 0.0, 0.0, 0.0, 1.0 );\n	vec2 scale;\n	scale.x = length( vec3( modelMatrix[ 0 ].x, modelMatrix[ 0 ].y, modelMatrix[ 0 ].z ) );\n	scale.y = length( vec3( modelMatrix[ 1 ].x, modelMatrix[ 1 ].y, modelMatrix[ 1 ].z ) );\n	#ifndef USE_SIZEATTENUATION\n		bool isPerspective = isPerspectiveMatrix( projectionMatrix );\n		if ( isPerspective ) scale *= - mvPosition.z;\n	#endif\n	vec2 alignedPosition = ( position.xy - ( center - vec2( 0.5 ) ) ) * scale;\n	vec2 rotatedPosition;\n	rotatedPosition.x = cos( rotation ) * alignedPosition.x - sin( rotation ) * alignedPosition.y;\n	rotatedPosition.y = sin( rotation ) * alignedPosition.x + cos( rotation ) * alignedPosition.y;\n	mvPosition.xy += rotatedPosition;\n	gl_Position = projectionMatrix * mvPosition;\n	#include <logdepthbuf_vertex>\n	#include <clipping_planes_vertex>\n	#include <fog_vertex>\n}";
const $9014d97cd777be10$var$fragment$1 = "uniform vec3 diffuse;\nuniform float opacity;\n#include <common>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <fog_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n	#include <clipping_planes_fragment>\n	vec3 outgoingLight = vec3( 0.0 );\n	vec4 diffuseColor = vec4( diffuse, opacity );\n	#include <logdepthbuf_fragment>\n	#include <map_fragment>\n	#include <alphamap_fragment>\n	#include <alphatest_fragment>\n	#include <alphahash_fragment>\n	outgoingLight = diffuseColor.rgb;\n	#include <opaque_fragment>\n	#include <tonemapping_fragment>\n	#include <colorspace_fragment>\n	#include <fog_fragment>\n}";
const $9014d97cd777be10$export$955f9f2e84c43c8b = {
    alphahash_fragment: $9014d97cd777be10$var$alphahash_fragment,
    alphahash_pars_fragment: $9014d97cd777be10$var$alphahash_pars_fragment,
    alphamap_fragment: $9014d97cd777be10$var$alphamap_fragment,
    alphamap_pars_fragment: $9014d97cd777be10$var$alphamap_pars_fragment,
    alphatest_fragment: $9014d97cd777be10$var$alphatest_fragment,
    alphatest_pars_fragment: $9014d97cd777be10$var$alphatest_pars_fragment,
    aomap_fragment: $9014d97cd777be10$var$aomap_fragment,
    aomap_pars_fragment: $9014d97cd777be10$var$aomap_pars_fragment,
    begin_vertex: $9014d97cd777be10$var$begin_vertex,
    beginnormal_vertex: $9014d97cd777be10$var$beginnormal_vertex,
    bsdfs: $9014d97cd777be10$var$bsdfs,
    iridescence_fragment: $9014d97cd777be10$var$iridescence_fragment,
    bumpmap_pars_fragment: $9014d97cd777be10$var$bumpmap_pars_fragment,
    clipping_planes_fragment: $9014d97cd777be10$var$clipping_planes_fragment,
    clipping_planes_pars_fragment: $9014d97cd777be10$var$clipping_planes_pars_fragment,
    clipping_planes_pars_vertex: $9014d97cd777be10$var$clipping_planes_pars_vertex,
    clipping_planes_vertex: $9014d97cd777be10$var$clipping_planes_vertex,
    color_fragment: $9014d97cd777be10$var$color_fragment,
    color_pars_fragment: $9014d97cd777be10$var$color_pars_fragment,
    color_pars_vertex: $9014d97cd777be10$var$color_pars_vertex,
    color_vertex: $9014d97cd777be10$var$color_vertex,
    common: $9014d97cd777be10$var$common,
    cube_uv_reflection_fragment: $9014d97cd777be10$var$cube_uv_reflection_fragment,
    defaultnormal_vertex: $9014d97cd777be10$var$defaultnormal_vertex,
    displacementmap_pars_vertex: $9014d97cd777be10$var$displacementmap_pars_vertex,
    displacementmap_vertex: $9014d97cd777be10$var$displacementmap_vertex,
    emissivemap_fragment: $9014d97cd777be10$var$emissivemap_fragment,
    emissivemap_pars_fragment: $9014d97cd777be10$var$emissivemap_pars_fragment,
    colorspace_fragment: $9014d97cd777be10$var$colorspace_fragment,
    colorspace_pars_fragment: $9014d97cd777be10$var$colorspace_pars_fragment,
    envmap_fragment: $9014d97cd777be10$var$envmap_fragment,
    envmap_common_pars_fragment: $9014d97cd777be10$var$envmap_common_pars_fragment,
    envmap_pars_fragment: $9014d97cd777be10$var$envmap_pars_fragment,
    envmap_pars_vertex: $9014d97cd777be10$var$envmap_pars_vertex,
    envmap_physical_pars_fragment: $9014d97cd777be10$var$envmap_physical_pars_fragment,
    envmap_vertex: $9014d97cd777be10$var$envmap_vertex,
    fog_vertex: $9014d97cd777be10$var$fog_vertex,
    fog_pars_vertex: $9014d97cd777be10$var$fog_pars_vertex,
    fog_fragment: $9014d97cd777be10$var$fog_fragment,
    fog_pars_fragment: $9014d97cd777be10$var$fog_pars_fragment,
    gradientmap_pars_fragment: $9014d97cd777be10$var$gradientmap_pars_fragment,
    lightmap_fragment: $9014d97cd777be10$var$lightmap_fragment,
    lightmap_pars_fragment: $9014d97cd777be10$var$lightmap_pars_fragment,
    lights_lambert_fragment: $9014d97cd777be10$var$lights_lambert_fragment,
    lights_lambert_pars_fragment: $9014d97cd777be10$var$lights_lambert_pars_fragment,
    lights_pars_begin: $9014d97cd777be10$var$lights_pars_begin,
    lights_toon_fragment: $9014d97cd777be10$var$lights_toon_fragment,
    lights_toon_pars_fragment: $9014d97cd777be10$var$lights_toon_pars_fragment,
    lights_phong_fragment: $9014d97cd777be10$var$lights_phong_fragment,
    lights_phong_pars_fragment: $9014d97cd777be10$var$lights_phong_pars_fragment,
    lights_physical_fragment: $9014d97cd777be10$var$lights_physical_fragment,
    lights_physical_pars_fragment: $9014d97cd777be10$var$lights_physical_pars_fragment,
    lights_fragment_begin: $9014d97cd777be10$var$lights_fragment_begin,
    lights_fragment_maps: $9014d97cd777be10$var$lights_fragment_maps,
    lights_fragment_end: $9014d97cd777be10$var$lights_fragment_end,
    logdepthbuf_fragment: $9014d97cd777be10$var$logdepthbuf_fragment,
    logdepthbuf_pars_fragment: $9014d97cd777be10$var$logdepthbuf_pars_fragment,
    logdepthbuf_pars_vertex: $9014d97cd777be10$var$logdepthbuf_pars_vertex,
    logdepthbuf_vertex: $9014d97cd777be10$var$logdepthbuf_vertex,
    map_fragment: $9014d97cd777be10$var$map_fragment,
    map_pars_fragment: $9014d97cd777be10$var$map_pars_fragment,
    map_particle_fragment: $9014d97cd777be10$var$map_particle_fragment,
    map_particle_pars_fragment: $9014d97cd777be10$var$map_particle_pars_fragment,
    metalnessmap_fragment: $9014d97cd777be10$var$metalnessmap_fragment,
    metalnessmap_pars_fragment: $9014d97cd777be10$var$metalnessmap_pars_fragment,
    morphcolor_vertex: $9014d97cd777be10$var$morphcolor_vertex,
    morphnormal_vertex: $9014d97cd777be10$var$morphnormal_vertex,
    morphtarget_pars_vertex: $9014d97cd777be10$var$morphtarget_pars_vertex,
    morphtarget_vertex: $9014d97cd777be10$var$morphtarget_vertex,
    normal_fragment_begin: $9014d97cd777be10$var$normal_fragment_begin,
    normal_fragment_maps: $9014d97cd777be10$var$normal_fragment_maps,
    normal_pars_fragment: $9014d97cd777be10$var$normal_pars_fragment,
    normal_pars_vertex: $9014d97cd777be10$var$normal_pars_vertex,
    normal_vertex: $9014d97cd777be10$var$normal_vertex,
    normalmap_pars_fragment: $9014d97cd777be10$var$normalmap_pars_fragment,
    clearcoat_normal_fragment_begin: $9014d97cd777be10$var$clearcoat_normal_fragment_begin,
    clearcoat_normal_fragment_maps: $9014d97cd777be10$var$clearcoat_normal_fragment_maps,
    clearcoat_pars_fragment: $9014d97cd777be10$var$clearcoat_pars_fragment,
    iridescence_pars_fragment: $9014d97cd777be10$var$iridescence_pars_fragment,
    opaque_fragment: $9014d97cd777be10$var$opaque_fragment,
    packing: $9014d97cd777be10$var$packing,
    premultiplied_alpha_fragment: $9014d97cd777be10$var$premultiplied_alpha_fragment,
    project_vertex: $9014d97cd777be10$var$project_vertex,
    dithering_fragment: $9014d97cd777be10$var$dithering_fragment,
    dithering_pars_fragment: $9014d97cd777be10$var$dithering_pars_fragment,
    roughnessmap_fragment: $9014d97cd777be10$var$roughnessmap_fragment,
    roughnessmap_pars_fragment: $9014d97cd777be10$var$roughnessmap_pars_fragment,
    shadowmap_pars_fragment: $9014d97cd777be10$var$shadowmap_pars_fragment,
    shadowmap_pars_vertex: $9014d97cd777be10$var$shadowmap_pars_vertex,
    shadowmap_vertex: $9014d97cd777be10$var$shadowmap_vertex,
    shadowmask_pars_fragment: $9014d97cd777be10$var$shadowmask_pars_fragment,
    skinbase_vertex: $9014d97cd777be10$var$skinbase_vertex,
    skinning_pars_vertex: $9014d97cd777be10$var$skinning_pars_vertex,
    skinning_vertex: $9014d97cd777be10$var$skinning_vertex,
    skinnormal_vertex: $9014d97cd777be10$var$skinnormal_vertex,
    specularmap_fragment: $9014d97cd777be10$var$specularmap_fragment,
    specularmap_pars_fragment: $9014d97cd777be10$var$specularmap_pars_fragment,
    tonemapping_fragment: $9014d97cd777be10$var$tonemapping_fragment,
    tonemapping_pars_fragment: $9014d97cd777be10$var$tonemapping_pars_fragment,
    transmission_fragment: $9014d97cd777be10$var$transmission_fragment,
    transmission_pars_fragment: $9014d97cd777be10$var$transmission_pars_fragment,
    uv_pars_fragment: $9014d97cd777be10$var$uv_pars_fragment,
    uv_pars_vertex: $9014d97cd777be10$var$uv_pars_vertex,
    uv_vertex: $9014d97cd777be10$var$uv_vertex,
    worldpos_vertex: $9014d97cd777be10$var$worldpos_vertex,
    background_vert: $9014d97cd777be10$var$vertex$h,
    background_frag: $9014d97cd777be10$var$fragment$h,
    backgroundCube_vert: $9014d97cd777be10$var$vertex$g,
    backgroundCube_frag: $9014d97cd777be10$var$fragment$g,
    cube_vert: $9014d97cd777be10$var$vertex$f,
    cube_frag: $9014d97cd777be10$var$fragment$f,
    depth_vert: $9014d97cd777be10$var$vertex$e,
    depth_frag: $9014d97cd777be10$var$fragment$e,
    distanceRGBA_vert: $9014d97cd777be10$var$vertex$d,
    distanceRGBA_frag: $9014d97cd777be10$var$fragment$d,
    equirect_vert: $9014d97cd777be10$var$vertex$c,
    equirect_frag: $9014d97cd777be10$var$fragment$c,
    linedashed_vert: $9014d97cd777be10$var$vertex$b,
    linedashed_frag: $9014d97cd777be10$var$fragment$b,
    meshbasic_vert: $9014d97cd777be10$var$vertex$a,
    meshbasic_frag: $9014d97cd777be10$var$fragment$a,
    meshlambert_vert: $9014d97cd777be10$var$vertex$9,
    meshlambert_frag: $9014d97cd777be10$var$fragment$9,
    meshmatcap_vert: $9014d97cd777be10$var$vertex$8,
    meshmatcap_frag: $9014d97cd777be10$var$fragment$8,
    meshnormal_vert: $9014d97cd777be10$var$vertex$7,
    meshnormal_frag: $9014d97cd777be10$var$fragment$7,
    meshphong_vert: $9014d97cd777be10$var$vertex$6,
    meshphong_frag: $9014d97cd777be10$var$fragment$6,
    meshphysical_vert: $9014d97cd777be10$var$vertex$5,
    meshphysical_frag: $9014d97cd777be10$var$fragment$5,
    meshtoon_vert: $9014d97cd777be10$var$vertex$4,
    meshtoon_frag: $9014d97cd777be10$var$fragment$4,
    points_vert: $9014d97cd777be10$var$vertex$3,
    points_frag: $9014d97cd777be10$var$fragment$3,
    shadow_vert: $9014d97cd777be10$var$vertex$2,
    shadow_frag: $9014d97cd777be10$var$fragment$2,
    sprite_vert: $9014d97cd777be10$var$vertex$1,
    sprite_frag: $9014d97cd777be10$var$fragment$1
};
/**
 * Uniforms library for shared webgl shaders
 */ const $9014d97cd777be10$export$6643083551874bf5 = {
    common: {
        diffuse: {
            value: /*@__PURE__*/ new $9014d97cd777be10$export$892596cec99bc70e(0xffffff)
        },
        opacity: {
            value: 1.0
        },
        map: {
            value: null
        },
        mapTransform: {
            value: /*@__PURE__*/ new $9014d97cd777be10$export$8ff26dafa08918()
        },
        alphaMap: {
            value: null
        },
        alphaMapTransform: {
            value: /*@__PURE__*/ new $9014d97cd777be10$export$8ff26dafa08918()
        },
        alphaTest: {
            value: 0
        }
    },
    specularmap: {
        specularMap: {
            value: null
        },
        specularMapTransform: {
            value: /*@__PURE__*/ new $9014d97cd777be10$export$8ff26dafa08918()
        }
    },
    envmap: {
        envMap: {
            value: null
        },
        flipEnvMap: {
            value: -1
        },
        reflectivity: {
            value: 1.0
        },
        ior: {
            value: 1.5
        },
        refractionRatio: {
            value: 0.98
        }
    },
    aomap: {
        aoMap: {
            value: null
        },
        aoMapIntensity: {
            value: 1
        },
        aoMapTransform: {
            value: /*@__PURE__*/ new $9014d97cd777be10$export$8ff26dafa08918()
        }
    },
    lightmap: {
        lightMap: {
            value: null
        },
        lightMapIntensity: {
            value: 1
        },
        lightMapTransform: {
            value: /*@__PURE__*/ new $9014d97cd777be10$export$8ff26dafa08918()
        }
    },
    bumpmap: {
        bumpMap: {
            value: null
        },
        bumpMapTransform: {
            value: /*@__PURE__*/ new $9014d97cd777be10$export$8ff26dafa08918()
        },
        bumpScale: {
            value: 1
        }
    },
    normalmap: {
        normalMap: {
            value: null
        },
        normalMapTransform: {
            value: /*@__PURE__*/ new $9014d97cd777be10$export$8ff26dafa08918()
        },
        normalScale: {
            value: /*@__PURE__*/ new $9014d97cd777be10$export$c977b3e384af9ae1(1, 1)
        }
    },
    displacementmap: {
        displacementMap: {
            value: null
        },
        displacementMapTransform: {
            value: /*@__PURE__*/ new $9014d97cd777be10$export$8ff26dafa08918()
        },
        displacementScale: {
            value: 1
        },
        displacementBias: {
            value: 0
        }
    },
    emissivemap: {
        emissiveMap: {
            value: null
        },
        emissiveMapTransform: {
            value: /*@__PURE__*/ new $9014d97cd777be10$export$8ff26dafa08918()
        }
    },
    metalnessmap: {
        metalnessMap: {
            value: null
        },
        metalnessMapTransform: {
            value: /*@__PURE__*/ new $9014d97cd777be10$export$8ff26dafa08918()
        }
    },
    roughnessmap: {
        roughnessMap: {
            value: null
        },
        roughnessMapTransform: {
            value: /*@__PURE__*/ new $9014d97cd777be10$export$8ff26dafa08918()
        }
    },
    gradientmap: {
        gradientMap: {
            value: null
        }
    },
    fog: {
        fogDensity: {
            value: 0.00025
        },
        fogNear: {
            value: 1
        },
        fogFar: {
            value: 2000
        },
        fogColor: {
            value: /*@__PURE__*/ new $9014d97cd777be10$export$892596cec99bc70e(0xffffff)
        }
    },
    lights: {
        ambientLightColor: {
            value: []
        },
        lightProbe: {
            value: []
        },
        directionalLights: {
            value: [],
            properties: {
                direction: {},
                color: {}
            }
        },
        directionalLightShadows: {
            value: [],
            properties: {
                shadowBias: {},
                shadowNormalBias: {},
                shadowRadius: {},
                shadowMapSize: {}
            }
        },
        directionalShadowMap: {
            value: []
        },
        directionalShadowMatrix: {
            value: []
        },
        spotLights: {
            value: [],
            properties: {
                color: {},
                position: {},
                direction: {},
                distance: {},
                coneCos: {},
                penumbraCos: {},
                decay: {}
            }
        },
        spotLightShadows: {
            value: [],
            properties: {
                shadowBias: {},
                shadowNormalBias: {},
                shadowRadius: {},
                shadowMapSize: {}
            }
        },
        spotLightMap: {
            value: []
        },
        spotShadowMap: {
            value: []
        },
        spotLightMatrix: {
            value: []
        },
        pointLights: {
            value: [],
            properties: {
                color: {},
                position: {},
                decay: {},
                distance: {}
            }
        },
        pointLightShadows: {
            value: [],
            properties: {
                shadowBias: {},
                shadowNormalBias: {},
                shadowRadius: {},
                shadowMapSize: {},
                shadowCameraNear: {},
                shadowCameraFar: {}
            }
        },
        pointShadowMap: {
            value: []
        },
        pointShadowMatrix: {
            value: []
        },
        hemisphereLights: {
            value: [],
            properties: {
                direction: {},
                skyColor: {},
                groundColor: {}
            }
        },
        // TODO (abelnation): RectAreaLight BRDF data needs to be moved from example to main src
        rectAreaLights: {
            value: [],
            properties: {
                color: {},
                position: {},
                width: {},
                height: {}
            }
        },
        ltc_1: {
            value: null
        },
        ltc_2: {
            value: null
        }
    },
    points: {
        diffuse: {
            value: /*@__PURE__*/ new $9014d97cd777be10$export$892596cec99bc70e(0xffffff)
        },
        opacity: {
            value: 1.0
        },
        size: {
            value: 1.0
        },
        scale: {
            value: 1.0
        },
        map: {
            value: null
        },
        alphaMap: {
            value: null
        },
        alphaMapTransform: {
            value: /*@__PURE__*/ new $9014d97cd777be10$export$8ff26dafa08918()
        },
        alphaTest: {
            value: 0
        },
        uvTransform: {
            value: /*@__PURE__*/ new $9014d97cd777be10$export$8ff26dafa08918()
        }
    },
    sprite: {
        diffuse: {
            value: /*@__PURE__*/ new $9014d97cd777be10$export$892596cec99bc70e(0xffffff)
        },
        opacity: {
            value: 1.0
        },
        center: {
            value: /*@__PURE__*/ new $9014d97cd777be10$export$c977b3e384af9ae1(0.5, 0.5)
        },
        rotation: {
            value: 0.0
        },
        map: {
            value: null
        },
        mapTransform: {
            value: /*@__PURE__*/ new $9014d97cd777be10$export$8ff26dafa08918()
        },
        alphaMap: {
            value: null
        },
        alphaMapTransform: {
            value: /*@__PURE__*/ new $9014d97cd777be10$export$8ff26dafa08918()
        },
        alphaTest: {
            value: 0
        }
    }
};
const $9014d97cd777be10$export$bee4a7d47f8f5014 = {
    basic: {
        uniforms: /*@__PURE__*/ $9014d97cd777be10$var$mergeUniforms([
            $9014d97cd777be10$export$6643083551874bf5.common,
            $9014d97cd777be10$export$6643083551874bf5.specularmap,
            $9014d97cd777be10$export$6643083551874bf5.envmap,
            $9014d97cd777be10$export$6643083551874bf5.aomap,
            $9014d97cd777be10$export$6643083551874bf5.lightmap,
            $9014d97cd777be10$export$6643083551874bf5.fog
        ]),
        vertexShader: $9014d97cd777be10$export$955f9f2e84c43c8b.meshbasic_vert,
        fragmentShader: $9014d97cd777be10$export$955f9f2e84c43c8b.meshbasic_frag
    },
    lambert: {
        uniforms: /*@__PURE__*/ $9014d97cd777be10$var$mergeUniforms([
            $9014d97cd777be10$export$6643083551874bf5.common,
            $9014d97cd777be10$export$6643083551874bf5.specularmap,
            $9014d97cd777be10$export$6643083551874bf5.envmap,
            $9014d97cd777be10$export$6643083551874bf5.aomap,
            $9014d97cd777be10$export$6643083551874bf5.lightmap,
            $9014d97cd777be10$export$6643083551874bf5.emissivemap,
            $9014d97cd777be10$export$6643083551874bf5.bumpmap,
            $9014d97cd777be10$export$6643083551874bf5.normalmap,
            $9014d97cd777be10$export$6643083551874bf5.displacementmap,
            $9014d97cd777be10$export$6643083551874bf5.fog,
            $9014d97cd777be10$export$6643083551874bf5.lights,
            {
                emissive: {
                    value: /*@__PURE__*/ new $9014d97cd777be10$export$892596cec99bc70e(0x000000)
                }
            }
        ]),
        vertexShader: $9014d97cd777be10$export$955f9f2e84c43c8b.meshlambert_vert,
        fragmentShader: $9014d97cd777be10$export$955f9f2e84c43c8b.meshlambert_frag
    },
    phong: {
        uniforms: /*@__PURE__*/ $9014d97cd777be10$var$mergeUniforms([
            $9014d97cd777be10$export$6643083551874bf5.common,
            $9014d97cd777be10$export$6643083551874bf5.specularmap,
            $9014d97cd777be10$export$6643083551874bf5.envmap,
            $9014d97cd777be10$export$6643083551874bf5.aomap,
            $9014d97cd777be10$export$6643083551874bf5.lightmap,
            $9014d97cd777be10$export$6643083551874bf5.emissivemap,
            $9014d97cd777be10$export$6643083551874bf5.bumpmap,
            $9014d97cd777be10$export$6643083551874bf5.normalmap,
            $9014d97cd777be10$export$6643083551874bf5.displacementmap,
            $9014d97cd777be10$export$6643083551874bf5.fog,
            $9014d97cd777be10$export$6643083551874bf5.lights,
            {
                emissive: {
                    value: /*@__PURE__*/ new $9014d97cd777be10$export$892596cec99bc70e(0x000000)
                },
                specular: {
                    value: /*@__PURE__*/ new $9014d97cd777be10$export$892596cec99bc70e(0x111111)
                },
                shininess: {
                    value: 30
                }
            }
        ]),
        vertexShader: $9014d97cd777be10$export$955f9f2e84c43c8b.meshphong_vert,
        fragmentShader: $9014d97cd777be10$export$955f9f2e84c43c8b.meshphong_frag
    },
    standard: {
        uniforms: /*@__PURE__*/ $9014d97cd777be10$var$mergeUniforms([
            $9014d97cd777be10$export$6643083551874bf5.common,
            $9014d97cd777be10$export$6643083551874bf5.envmap,
            $9014d97cd777be10$export$6643083551874bf5.aomap,
            $9014d97cd777be10$export$6643083551874bf5.lightmap,
            $9014d97cd777be10$export$6643083551874bf5.emissivemap,
            $9014d97cd777be10$export$6643083551874bf5.bumpmap,
            $9014d97cd777be10$export$6643083551874bf5.normalmap,
            $9014d97cd777be10$export$6643083551874bf5.displacementmap,
            $9014d97cd777be10$export$6643083551874bf5.roughnessmap,
            $9014d97cd777be10$export$6643083551874bf5.metalnessmap,
            $9014d97cd777be10$export$6643083551874bf5.fog,
            $9014d97cd777be10$export$6643083551874bf5.lights,
            {
                emissive: {
                    value: /*@__PURE__*/ new $9014d97cd777be10$export$892596cec99bc70e(0x000000)
                },
                roughness: {
                    value: 1.0
                },
                metalness: {
                    value: 0.0
                },
                envMapIntensity: {
                    value: 1
                } // temporary
            }
        ]),
        vertexShader: $9014d97cd777be10$export$955f9f2e84c43c8b.meshphysical_vert,
        fragmentShader: $9014d97cd777be10$export$955f9f2e84c43c8b.meshphysical_frag
    },
    toon: {
        uniforms: /*@__PURE__*/ $9014d97cd777be10$var$mergeUniforms([
            $9014d97cd777be10$export$6643083551874bf5.common,
            $9014d97cd777be10$export$6643083551874bf5.aomap,
            $9014d97cd777be10$export$6643083551874bf5.lightmap,
            $9014d97cd777be10$export$6643083551874bf5.emissivemap,
            $9014d97cd777be10$export$6643083551874bf5.bumpmap,
            $9014d97cd777be10$export$6643083551874bf5.normalmap,
            $9014d97cd777be10$export$6643083551874bf5.displacementmap,
            $9014d97cd777be10$export$6643083551874bf5.gradientmap,
            $9014d97cd777be10$export$6643083551874bf5.fog,
            $9014d97cd777be10$export$6643083551874bf5.lights,
            {
                emissive: {
                    value: /*@__PURE__*/ new $9014d97cd777be10$export$892596cec99bc70e(0x000000)
                }
            }
        ]),
        vertexShader: $9014d97cd777be10$export$955f9f2e84c43c8b.meshtoon_vert,
        fragmentShader: $9014d97cd777be10$export$955f9f2e84c43c8b.meshtoon_frag
    },
    matcap: {
        uniforms: /*@__PURE__*/ $9014d97cd777be10$var$mergeUniforms([
            $9014d97cd777be10$export$6643083551874bf5.common,
            $9014d97cd777be10$export$6643083551874bf5.bumpmap,
            $9014d97cd777be10$export$6643083551874bf5.normalmap,
            $9014d97cd777be10$export$6643083551874bf5.displacementmap,
            $9014d97cd777be10$export$6643083551874bf5.fog,
            {
                matcap: {
                    value: null
                }
            }
        ]),
        vertexShader: $9014d97cd777be10$export$955f9f2e84c43c8b.meshmatcap_vert,
        fragmentShader: $9014d97cd777be10$export$955f9f2e84c43c8b.meshmatcap_frag
    },
    points: {
        uniforms: /*@__PURE__*/ $9014d97cd777be10$var$mergeUniforms([
            $9014d97cd777be10$export$6643083551874bf5.points,
            $9014d97cd777be10$export$6643083551874bf5.fog
        ]),
        vertexShader: $9014d97cd777be10$export$955f9f2e84c43c8b.points_vert,
        fragmentShader: $9014d97cd777be10$export$955f9f2e84c43c8b.points_frag
    },
    dashed: {
        uniforms: /*@__PURE__*/ $9014d97cd777be10$var$mergeUniforms([
            $9014d97cd777be10$export$6643083551874bf5.common,
            $9014d97cd777be10$export$6643083551874bf5.fog,
            {
                scale: {
                    value: 1
                },
                dashSize: {
                    value: 1
                },
                totalSize: {
                    value: 2
                }
            }
        ]),
        vertexShader: $9014d97cd777be10$export$955f9f2e84c43c8b.linedashed_vert,
        fragmentShader: $9014d97cd777be10$export$955f9f2e84c43c8b.linedashed_frag
    },
    depth: {
        uniforms: /*@__PURE__*/ $9014d97cd777be10$var$mergeUniforms([
            $9014d97cd777be10$export$6643083551874bf5.common,
            $9014d97cd777be10$export$6643083551874bf5.displacementmap
        ]),
        vertexShader: $9014d97cd777be10$export$955f9f2e84c43c8b.depth_vert,
        fragmentShader: $9014d97cd777be10$export$955f9f2e84c43c8b.depth_frag
    },
    normal: {
        uniforms: /*@__PURE__*/ $9014d97cd777be10$var$mergeUniforms([
            $9014d97cd777be10$export$6643083551874bf5.common,
            $9014d97cd777be10$export$6643083551874bf5.bumpmap,
            $9014d97cd777be10$export$6643083551874bf5.normalmap,
            $9014d97cd777be10$export$6643083551874bf5.displacementmap,
            {
                opacity: {
                    value: 1.0
                }
            }
        ]),
        vertexShader: $9014d97cd777be10$export$955f9f2e84c43c8b.meshnormal_vert,
        fragmentShader: $9014d97cd777be10$export$955f9f2e84c43c8b.meshnormal_frag
    },
    sprite: {
        uniforms: /*@__PURE__*/ $9014d97cd777be10$var$mergeUniforms([
            $9014d97cd777be10$export$6643083551874bf5.sprite,
            $9014d97cd777be10$export$6643083551874bf5.fog
        ]),
        vertexShader: $9014d97cd777be10$export$955f9f2e84c43c8b.sprite_vert,
        fragmentShader: $9014d97cd777be10$export$955f9f2e84c43c8b.sprite_frag
    },
    background: {
        uniforms: {
            uvTransform: {
                value: /*@__PURE__*/ new $9014d97cd777be10$export$8ff26dafa08918()
            },
            t2D: {
                value: null
            },
            backgroundIntensity: {
                value: 1
            }
        },
        vertexShader: $9014d97cd777be10$export$955f9f2e84c43c8b.background_vert,
        fragmentShader: $9014d97cd777be10$export$955f9f2e84c43c8b.background_frag
    },
    backgroundCube: {
        uniforms: {
            envMap: {
                value: null
            },
            flipEnvMap: {
                value: -1
            },
            backgroundBlurriness: {
                value: 0
            },
            backgroundIntensity: {
                value: 1
            }
        },
        vertexShader: $9014d97cd777be10$export$955f9f2e84c43c8b.backgroundCube_vert,
        fragmentShader: $9014d97cd777be10$export$955f9f2e84c43c8b.backgroundCube_frag
    },
    cube: {
        uniforms: {
            tCube: {
                value: null
            },
            tFlip: {
                value: -1
            },
            opacity: {
                value: 1.0
            }
        },
        vertexShader: $9014d97cd777be10$export$955f9f2e84c43c8b.cube_vert,
        fragmentShader: $9014d97cd777be10$export$955f9f2e84c43c8b.cube_frag
    },
    equirect: {
        uniforms: {
            tEquirect: {
                value: null
            }
        },
        vertexShader: $9014d97cd777be10$export$955f9f2e84c43c8b.equirect_vert,
        fragmentShader: $9014d97cd777be10$export$955f9f2e84c43c8b.equirect_frag
    },
    distanceRGBA: {
        uniforms: /*@__PURE__*/ $9014d97cd777be10$var$mergeUniforms([
            $9014d97cd777be10$export$6643083551874bf5.common,
            $9014d97cd777be10$export$6643083551874bf5.displacementmap,
            {
                referencePosition: {
                    value: /*@__PURE__*/ new $9014d97cd777be10$export$64b5c384219d3699()
                },
                nearDistance: {
                    value: 1
                },
                farDistance: {
                    value: 1000
                }
            }
        ]),
        vertexShader: $9014d97cd777be10$export$955f9f2e84c43c8b.distanceRGBA_vert,
        fragmentShader: $9014d97cd777be10$export$955f9f2e84c43c8b.distanceRGBA_frag
    },
    shadow: {
        uniforms: /*@__PURE__*/ $9014d97cd777be10$var$mergeUniforms([
            $9014d97cd777be10$export$6643083551874bf5.lights,
            $9014d97cd777be10$export$6643083551874bf5.fog,
            {
                color: {
                    value: /*@__PURE__*/ new $9014d97cd777be10$export$892596cec99bc70e(0x00000)
                },
                opacity: {
                    value: 1.0
                }
            }
        ]),
        vertexShader: $9014d97cd777be10$export$955f9f2e84c43c8b.shadow_vert,
        fragmentShader: $9014d97cd777be10$export$955f9f2e84c43c8b.shadow_frag
    }
};
$9014d97cd777be10$export$bee4a7d47f8f5014.physical = {
    uniforms: /*@__PURE__*/ $9014d97cd777be10$var$mergeUniforms([
        $9014d97cd777be10$export$bee4a7d47f8f5014.standard.uniforms,
        {
            clearcoat: {
                value: 0
            },
            clearcoatMap: {
                value: null
            },
            clearcoatMapTransform: {
                value: /*@__PURE__*/ new $9014d97cd777be10$export$8ff26dafa08918()
            },
            clearcoatNormalMap: {
                value: null
            },
            clearcoatNormalMapTransform: {
                value: /*@__PURE__*/ new $9014d97cd777be10$export$8ff26dafa08918()
            },
            clearcoatNormalScale: {
                value: /*@__PURE__*/ new $9014d97cd777be10$export$c977b3e384af9ae1(1, 1)
            },
            clearcoatRoughness: {
                value: 0
            },
            clearcoatRoughnessMap: {
                value: null
            },
            clearcoatRoughnessMapTransform: {
                value: /*@__PURE__*/ new $9014d97cd777be10$export$8ff26dafa08918()
            },
            iridescence: {
                value: 0
            },
            iridescenceMap: {
                value: null
            },
            iridescenceMapTransform: {
                value: /*@__PURE__*/ new $9014d97cd777be10$export$8ff26dafa08918()
            },
            iridescenceIOR: {
                value: 1.3
            },
            iridescenceThicknessMinimum: {
                value: 100
            },
            iridescenceThicknessMaximum: {
                value: 400
            },
            iridescenceThicknessMap: {
                value: null
            },
            iridescenceThicknessMapTransform: {
                value: /*@__PURE__*/ new $9014d97cd777be10$export$8ff26dafa08918()
            },
            sheen: {
                value: 0
            },
            sheenColor: {
                value: /*@__PURE__*/ new $9014d97cd777be10$export$892596cec99bc70e(0x000000)
            },
            sheenColorMap: {
                value: null
            },
            sheenColorMapTransform: {
                value: /*@__PURE__*/ new $9014d97cd777be10$export$8ff26dafa08918()
            },
            sheenRoughness: {
                value: 1
            },
            sheenRoughnessMap: {
                value: null
            },
            sheenRoughnessMapTransform: {
                value: /*@__PURE__*/ new $9014d97cd777be10$export$8ff26dafa08918()
            },
            transmission: {
                value: 0
            },
            transmissionMap: {
                value: null
            },
            transmissionMapTransform: {
                value: /*@__PURE__*/ new $9014d97cd777be10$export$8ff26dafa08918()
            },
            transmissionSamplerSize: {
                value: /*@__PURE__*/ new $9014d97cd777be10$export$c977b3e384af9ae1()
            },
            transmissionSamplerMap: {
                value: null
            },
            thickness: {
                value: 0
            },
            thicknessMap: {
                value: null
            },
            thicknessMapTransform: {
                value: /*@__PURE__*/ new $9014d97cd777be10$export$8ff26dafa08918()
            },
            attenuationDistance: {
                value: 0
            },
            attenuationColor: {
                value: /*@__PURE__*/ new $9014d97cd777be10$export$892596cec99bc70e(0x000000)
            },
            specularColor: {
                value: /*@__PURE__*/ new $9014d97cd777be10$export$892596cec99bc70e(1, 1, 1)
            },
            specularColorMap: {
                value: null
            },
            specularColorMapTransform: {
                value: /*@__PURE__*/ new $9014d97cd777be10$export$8ff26dafa08918()
            },
            specularIntensity: {
                value: 1
            },
            specularIntensityMap: {
                value: null
            },
            specularIntensityMapTransform: {
                value: /*@__PURE__*/ new $9014d97cd777be10$export$8ff26dafa08918()
            },
            anisotropyVector: {
                value: /*@__PURE__*/ new $9014d97cd777be10$export$c977b3e384af9ae1()
            },
            anisotropyMap: {
                value: null
            },
            anisotropyMapTransform: {
                value: /*@__PURE__*/ new $9014d97cd777be10$export$8ff26dafa08918()
            }
        }
    ]),
    vertexShader: $9014d97cd777be10$export$955f9f2e84c43c8b.meshphysical_vert,
    fragmentShader: $9014d97cd777be10$export$955f9f2e84c43c8b.meshphysical_frag
};
const $9014d97cd777be10$var$_rgb = {
    r: 0,
    b: 0,
    g: 0
};
function $9014d97cd777be10$var$WebGLBackground(renderer, cubemaps, cubeuvmaps, state, objects, alpha, premultipliedAlpha) {
    const clearColor = new $9014d97cd777be10$export$892596cec99bc70e(0x000000);
    let clearAlpha = alpha === true ? 0 : 1;
    let planeMesh;
    let boxMesh;
    let currentBackground = null;
    let currentBackgroundVersion = 0;
    let currentTonemapping = null;
    function render(renderList, scene) {
        let forceClear = false;
        let background = scene.isScene === true ? scene.background : null;
        if (background && background.isTexture) {
            const usePMREM = scene.backgroundBlurriness > 0; // use PMREM if the user wants to blur the background
            background = (usePMREM ? cubeuvmaps : cubemaps).get(background);
        }
        if (background === null) setClear(clearColor, clearAlpha);
        else if (background && background.isColor) {
            setClear(background, 1);
            forceClear = true;
        }
        const xr = renderer.xr;
        const environmentBlendMode = xr.getEnvironmentBlendMode();
        switch(environmentBlendMode){
            case "opaque":
                forceClear = true;
                break;
            case "additive":
                state.buffers.color.setClear(0, 0, 0, 1, premultipliedAlpha);
                forceClear = true;
                break;
            case "alpha-blend":
                state.buffers.color.setClear(0, 0, 0, 0, premultipliedAlpha);
                forceClear = true;
                break;
        }
        if (renderer.autoClear || forceClear) renderer.clear(renderer.autoClearColor, renderer.autoClearDepth, renderer.autoClearStencil);
        if (background && (background.isCubeTexture || background.mapping === $9014d97cd777be10$export$dbf3e70ff37af79)) {
            if (boxMesh === undefined) {
                boxMesh = new $9014d97cd777be10$export$e176487c05830cc5(new $9014d97cd777be10$export$33e43285f7406bd5(1, 1, 1), new $9014d97cd777be10$export$83c7d75d550a8b0d({
                    name: "BackgroundCubeMaterial",
                    uniforms: $9014d97cd777be10$var$cloneUniforms($9014d97cd777be10$export$bee4a7d47f8f5014.backgroundCube.uniforms),
                    vertexShader: $9014d97cd777be10$export$bee4a7d47f8f5014.backgroundCube.vertexShader,
                    fragmentShader: $9014d97cd777be10$export$bee4a7d47f8f5014.backgroundCube.fragmentShader,
                    side: $9014d97cd777be10$export$d9f0486e75b5ace,
                    depthTest: false,
                    depthWrite: false,
                    fog: false
                }));
                boxMesh.geometry.deleteAttribute("normal");
                boxMesh.geometry.deleteAttribute("uv");
                boxMesh.onBeforeRender = function(renderer, scene, camera) {
                    this.matrixWorld.copyPosition(camera.matrixWorld);
                };
                // add "envMap" material property so the renderer can evaluate it like for built-in materials
                Object.defineProperty(boxMesh.material, "envMap", {
                    get: function() {
                        return this.uniforms.envMap.value;
                    }
                });
                objects.update(boxMesh);
            }
            boxMesh.material.uniforms.envMap.value = background;
            boxMesh.material.uniforms.flipEnvMap.value = background.isCubeTexture && background.isRenderTargetTexture === false ? -1 : 1;
            boxMesh.material.uniforms.backgroundBlurriness.value = scene.backgroundBlurriness;
            boxMesh.material.uniforms.backgroundIntensity.value = scene.backgroundIntensity;
            boxMesh.material.toneMapped = background.colorSpace === $9014d97cd777be10$export$561f394b24edfcaa ? false : true;
            if (currentBackground !== background || currentBackgroundVersion !== background.version || currentTonemapping !== renderer.toneMapping) {
                boxMesh.material.needsUpdate = true;
                currentBackground = background;
                currentBackgroundVersion = background.version;
                currentTonemapping = renderer.toneMapping;
            }
            boxMesh.layers.enableAll();
            // push to the pre-sorted opaque render list
            renderList.unshift(boxMesh, boxMesh.geometry, boxMesh.material, 0, 0, null);
        } else if (background && background.isTexture) {
            if (planeMesh === undefined) {
                planeMesh = new $9014d97cd777be10$export$e176487c05830cc5(new $9014d97cd777be10$export$967d831af31f69ce(2, 2), new $9014d97cd777be10$export$83c7d75d550a8b0d({
                    name: "BackgroundMaterial",
                    uniforms: $9014d97cd777be10$var$cloneUniforms($9014d97cd777be10$export$bee4a7d47f8f5014.background.uniforms),
                    vertexShader: $9014d97cd777be10$export$bee4a7d47f8f5014.background.vertexShader,
                    fragmentShader: $9014d97cd777be10$export$bee4a7d47f8f5014.background.fragmentShader,
                    side: $9014d97cd777be10$export$2ede184fc2998901,
                    depthTest: false,
                    depthWrite: false,
                    fog: false
                }));
                planeMesh.geometry.deleteAttribute("normal");
                // add "map" material property so the renderer can evaluate it like for built-in materials
                Object.defineProperty(planeMesh.material, "map", {
                    get: function() {
                        return this.uniforms.t2D.value;
                    }
                });
                objects.update(planeMesh);
            }
            planeMesh.material.uniforms.t2D.value = background;
            planeMesh.material.uniforms.backgroundIntensity.value = scene.backgroundIntensity;
            planeMesh.material.toneMapped = background.colorSpace === $9014d97cd777be10$export$561f394b24edfcaa ? false : true;
            if (background.matrixAutoUpdate === true) background.updateMatrix();
            planeMesh.material.uniforms.uvTransform.value.copy(background.matrix);
            if (currentBackground !== background || currentBackgroundVersion !== background.version || currentTonemapping !== renderer.toneMapping) {
                planeMesh.material.needsUpdate = true;
                currentBackground = background;
                currentBackgroundVersion = background.version;
                currentTonemapping = renderer.toneMapping;
            }
            planeMesh.layers.enableAll();
            // push to the pre-sorted opaque render list
            renderList.unshift(planeMesh, planeMesh.geometry, planeMesh.material, 0, 0, null);
        }
    }
    function setClear(color, alpha) {
        color.getRGB($9014d97cd777be10$var$_rgb, $9014d97cd777be10$var$getUnlitUniformColorSpace(renderer));
        state.buffers.color.setClear($9014d97cd777be10$var$_rgb.r, $9014d97cd777be10$var$_rgb.g, $9014d97cd777be10$var$_rgb.b, alpha, premultipliedAlpha);
    }
    return {
        getClearColor: function() {
            return clearColor;
        },
        setClearColor: function(color, alpha = 1) {
            clearColor.set(color);
            clearAlpha = alpha;
            setClear(clearColor, clearAlpha);
        },
        getClearAlpha: function() {
            return clearAlpha;
        },
        setClearAlpha: function(alpha) {
            clearAlpha = alpha;
            setClear(clearColor, clearAlpha);
        },
        render: render
    };
}
function $9014d97cd777be10$var$WebGLBindingStates(gl, extensions, attributes, capabilities) {
    const maxVertexAttributes = gl.getParameter(gl.MAX_VERTEX_ATTRIBS);
    const extension = capabilities.isWebGL2 ? null : extensions.get("OES_vertex_array_object");
    const vaoAvailable = capabilities.isWebGL2 || extension !== null;
    const bindingStates = {};
    const defaultState = createBindingState(null);
    let currentState = defaultState;
    let forceUpdate = false;
    function setup(object, material, program, geometry, index) {
        let updateBuffers = false;
        if (vaoAvailable) {
            const state = getBindingState(geometry, program, material);
            if (currentState !== state) {
                currentState = state;
                bindVertexArrayObject(currentState.object);
            }
            updateBuffers = needsUpdate(object, geometry, program, index);
            if (updateBuffers) saveCache(object, geometry, program, index);
        } else {
            const wireframe = material.wireframe === true;
            if (currentState.geometry !== geometry.id || currentState.program !== program.id || currentState.wireframe !== wireframe) {
                currentState.geometry = geometry.id;
                currentState.program = program.id;
                currentState.wireframe = wireframe;
                updateBuffers = true;
            }
        }
        if (index !== null) attributes.update(index, gl.ELEMENT_ARRAY_BUFFER);
        if (updateBuffers || forceUpdate) {
            forceUpdate = false;
            setupVertexAttributes(object, material, program, geometry);
            if (index !== null) gl.bindBuffer(gl.ELEMENT_ARRAY_BUFFER, attributes.get(index).buffer);
        }
    }
    function createVertexArrayObject() {
        if (capabilities.isWebGL2) return gl.createVertexArray();
        return extension.createVertexArrayOES();
    }
    function bindVertexArrayObject(vao) {
        if (capabilities.isWebGL2) return gl.bindVertexArray(vao);
        return extension.bindVertexArrayOES(vao);
    }
    function deleteVertexArrayObject(vao) {
        if (capabilities.isWebGL2) return gl.deleteVertexArray(vao);
        return extension.deleteVertexArrayOES(vao);
    }
    function getBindingState(geometry, program, material) {
        const wireframe = material.wireframe === true;
        let programMap = bindingStates[geometry.id];
        if (programMap === undefined) {
            programMap = {};
            bindingStates[geometry.id] = programMap;
        }
        let stateMap = programMap[program.id];
        if (stateMap === undefined) {
            stateMap = {};
            programMap[program.id] = stateMap;
        }
        let state = stateMap[wireframe];
        if (state === undefined) {
            state = createBindingState(createVertexArrayObject());
            stateMap[wireframe] = state;
        }
        return state;
    }
    function createBindingState(vao) {
        const newAttributes = [];
        const enabledAttributes = [];
        const attributeDivisors = [];
        for(let i = 0; i < maxVertexAttributes; i++){
            newAttributes[i] = 0;
            enabledAttributes[i] = 0;
            attributeDivisors[i] = 0;
        }
        return {
            // for backward compatibility on non-VAO support browser
            geometry: null,
            program: null,
            wireframe: false,
            newAttributes: newAttributes,
            enabledAttributes: enabledAttributes,
            attributeDivisors: attributeDivisors,
            object: vao,
            attributes: {},
            index: null
        };
    }
    function needsUpdate(object, geometry, program, index) {
        const cachedAttributes = currentState.attributes;
        const geometryAttributes = geometry.attributes;
        let attributesNum = 0;
        const programAttributes = program.getAttributes();
        for(const name in programAttributes){
            const programAttribute = programAttributes[name];
            if (programAttribute.location >= 0) {
                const cachedAttribute = cachedAttributes[name];
                let geometryAttribute = geometryAttributes[name];
                if (geometryAttribute === undefined) {
                    if (name === "instanceMatrix" && object.instanceMatrix) geometryAttribute = object.instanceMatrix;
                    if (name === "instanceColor" && object.instanceColor) geometryAttribute = object.instanceColor;
                }
                if (cachedAttribute === undefined) return true;
                if (cachedAttribute.attribute !== geometryAttribute) return true;
                if (geometryAttribute && cachedAttribute.data !== geometryAttribute.data) return true;
                attributesNum++;
            }
        }
        if (currentState.attributesNum !== attributesNum) return true;
        if (currentState.index !== index) return true;
        return false;
    }
    function saveCache(object, geometry, program, index) {
        const cache = {};
        const attributes = geometry.attributes;
        let attributesNum = 0;
        const programAttributes = program.getAttributes();
        for(const name in programAttributes){
            const programAttribute = programAttributes[name];
            if (programAttribute.location >= 0) {
                let attribute = attributes[name];
                if (attribute === undefined) {
                    if (name === "instanceMatrix" && object.instanceMatrix) attribute = object.instanceMatrix;
                    if (name === "instanceColor" && object.instanceColor) attribute = object.instanceColor;
                }
                const data = {};
                data.attribute = attribute;
                if (attribute && attribute.data) data.data = attribute.data;
                cache[name] = data;
                attributesNum++;
            }
        }
        currentState.attributes = cache;
        currentState.attributesNum = attributesNum;
        currentState.index = index;
    }
    function initAttributes() {
        const newAttributes = currentState.newAttributes;
        for(let i = 0, il = newAttributes.length; i < il; i++)newAttributes[i] = 0;
    }
    function enableAttribute(attribute) {
        enableAttributeAndDivisor(attribute, 0);
    }
    function enableAttributeAndDivisor(attribute, meshPerAttribute) {
        const newAttributes = currentState.newAttributes;
        const enabledAttributes = currentState.enabledAttributes;
        const attributeDivisors = currentState.attributeDivisors;
        newAttributes[attribute] = 1;
        if (enabledAttributes[attribute] === 0) {
            gl.enableVertexAttribArray(attribute);
            enabledAttributes[attribute] = 1;
        }
        if (attributeDivisors[attribute] !== meshPerAttribute) {
            const extension = capabilities.isWebGL2 ? gl : extensions.get("ANGLE_instanced_arrays");
            extension[capabilities.isWebGL2 ? "vertexAttribDivisor" : "vertexAttribDivisorANGLE"](attribute, meshPerAttribute);
            attributeDivisors[attribute] = meshPerAttribute;
        }
    }
    function disableUnusedAttributes() {
        const newAttributes = currentState.newAttributes;
        const enabledAttributes = currentState.enabledAttributes;
        for(let i = 0, il = enabledAttributes.length; i < il; i++)if (enabledAttributes[i] !== newAttributes[i]) {
            gl.disableVertexAttribArray(i);
            enabledAttributes[i] = 0;
        }
    }
    function vertexAttribPointer(index, size, type, normalized, stride, offset, integer) {
        if (integer === true) gl.vertexAttribIPointer(index, size, type, stride, offset);
        else gl.vertexAttribPointer(index, size, type, normalized, stride, offset);
    }
    function setupVertexAttributes(object, material, program, geometry) {
        if (capabilities.isWebGL2 === false && (object.isInstancedMesh || geometry.isInstancedBufferGeometry)) {
            if (extensions.get("ANGLE_instanced_arrays") === null) return;
        }
        initAttributes();
        const geometryAttributes = geometry.attributes;
        const programAttributes = program.getAttributes();
        const materialDefaultAttributeValues = material.defaultAttributeValues;
        for(const name in programAttributes){
            const programAttribute = programAttributes[name];
            if (programAttribute.location >= 0) {
                let geometryAttribute = geometryAttributes[name];
                if (geometryAttribute === undefined) {
                    if (name === "instanceMatrix" && object.instanceMatrix) geometryAttribute = object.instanceMatrix;
                    if (name === "instanceColor" && object.instanceColor) geometryAttribute = object.instanceColor;
                }
                if (geometryAttribute !== undefined) {
                    const normalized = geometryAttribute.normalized;
                    const size = geometryAttribute.itemSize;
                    const attribute = attributes.get(geometryAttribute);
                    // TODO Attribute may not be available on context restore
                    if (attribute === undefined) continue;
                    const buffer = attribute.buffer;
                    const type = attribute.type;
                    const bytesPerElement = attribute.bytesPerElement;
                    // check for integer attributes (WebGL 2 only)
                    const integer = capabilities.isWebGL2 === true && (type === gl.INT || type === gl.UNSIGNED_INT || geometryAttribute.gpuType === $9014d97cd777be10$export$5c612977753abe2);
                    if (geometryAttribute.isInterleavedBufferAttribute) {
                        const data = geometryAttribute.data;
                        const stride = data.stride;
                        const offset = geometryAttribute.offset;
                        if (data.isInstancedInterleavedBuffer) {
                            for(let i = 0; i < programAttribute.locationSize; i++)enableAttributeAndDivisor(programAttribute.location + i, data.meshPerAttribute);
                            if (object.isInstancedMesh !== true && geometry._maxInstanceCount === undefined) geometry._maxInstanceCount = data.meshPerAttribute * data.count;
                        } else for(let i = 0; i < programAttribute.locationSize; i++)enableAttribute(programAttribute.location + i);
                        gl.bindBuffer(gl.ARRAY_BUFFER, buffer);
                        for(let i = 0; i < programAttribute.locationSize; i++)vertexAttribPointer(programAttribute.location + i, size / programAttribute.locationSize, type, normalized, stride * bytesPerElement, (offset + size / programAttribute.locationSize * i) * bytesPerElement, integer);
                    } else {
                        if (geometryAttribute.isInstancedBufferAttribute) {
                            for(let i = 0; i < programAttribute.locationSize; i++)enableAttributeAndDivisor(programAttribute.location + i, geometryAttribute.meshPerAttribute);
                            if (object.isInstancedMesh !== true && geometry._maxInstanceCount === undefined) geometry._maxInstanceCount = geometryAttribute.meshPerAttribute * geometryAttribute.count;
                        } else for(let i = 0; i < programAttribute.locationSize; i++)enableAttribute(programAttribute.location + i);
                        gl.bindBuffer(gl.ARRAY_BUFFER, buffer);
                        for(let i = 0; i < programAttribute.locationSize; i++)vertexAttribPointer(programAttribute.location + i, size / programAttribute.locationSize, type, normalized, size * bytesPerElement, size / programAttribute.locationSize * i * bytesPerElement, integer);
                    }
                } else if (materialDefaultAttributeValues !== undefined) {
                    const value = materialDefaultAttributeValues[name];
                    if (value !== undefined) switch(value.length){
                        case 2:
                            gl.vertexAttrib2fv(programAttribute.location, value);
                            break;
                        case 3:
                            gl.vertexAttrib3fv(programAttribute.location, value);
                            break;
                        case 4:
                            gl.vertexAttrib4fv(programAttribute.location, value);
                            break;
                        default:
                            gl.vertexAttrib1fv(programAttribute.location, value);
                    }
                }
            }
        }
        disableUnusedAttributes();
    }
    function dispose() {
        reset();
        for(const geometryId in bindingStates){
            const programMap = bindingStates[geometryId];
            for(const programId in programMap){
                const stateMap = programMap[programId];
                for(const wireframe in stateMap){
                    deleteVertexArrayObject(stateMap[wireframe].object);
                    delete stateMap[wireframe];
                }
                delete programMap[programId];
            }
            delete bindingStates[geometryId];
        }
    }
    function releaseStatesOfGeometry(geometry) {
        if (bindingStates[geometry.id] === undefined) return;
        const programMap = bindingStates[geometry.id];
        for(const programId in programMap){
            const stateMap = programMap[programId];
            for(const wireframe in stateMap){
                deleteVertexArrayObject(stateMap[wireframe].object);
                delete stateMap[wireframe];
            }
            delete programMap[programId];
        }
        delete bindingStates[geometry.id];
    }
    function releaseStatesOfProgram(program) {
        for(const geometryId in bindingStates){
            const programMap = bindingStates[geometryId];
            if (programMap[program.id] === undefined) continue;
            const stateMap = programMap[program.id];
            for(const wireframe in stateMap){
                deleteVertexArrayObject(stateMap[wireframe].object);
                delete stateMap[wireframe];
            }
            delete programMap[program.id];
        }
    }
    function reset() {
        resetDefaultState();
        forceUpdate = true;
        if (currentState === defaultState) return;
        currentState = defaultState;
        bindVertexArrayObject(currentState.object);
    }
    // for backward-compatibility
    function resetDefaultState() {
        defaultState.geometry = null;
        defaultState.program = null;
        defaultState.wireframe = false;
    }
    return {
        setup: setup,
        reset: reset,
        resetDefaultState: resetDefaultState,
        dispose: dispose,
        releaseStatesOfGeometry: releaseStatesOfGeometry,
        releaseStatesOfProgram: releaseStatesOfProgram,
        initAttributes: initAttributes,
        enableAttribute: enableAttribute,
        disableUnusedAttributes: disableUnusedAttributes
    };
}
function $9014d97cd777be10$var$WebGLBufferRenderer(gl, extensions, info, capabilities) {
    const isWebGL2 = capabilities.isWebGL2;
    let mode;
    function setMode(value) {
        mode = value;
    }
    function render(start, count) {
        gl.drawArrays(mode, start, count);
        info.update(count, mode, 1);
    }
    function renderInstances(start, count, primcount) {
        if (primcount === 0) return;
        let extension, methodName;
        if (isWebGL2) {
            extension = gl;
            methodName = "drawArraysInstanced";
        } else {
            extension = extensions.get("ANGLE_instanced_arrays");
            methodName = "drawArraysInstancedANGLE";
            if (extension === null) {
                console.error("THREE.WebGLBufferRenderer: using THREE.InstancedBufferGeometry but hardware does not support extension ANGLE_instanced_arrays.");
                return;
            }
        }
        extension[methodName](mode, start, count, primcount);
        info.update(count, mode, primcount);
    }
    //
    this.setMode = setMode;
    this.render = render;
    this.renderInstances = renderInstances;
}
function $9014d97cd777be10$var$WebGLCapabilities(gl, extensions, parameters) {
    let maxAnisotropy;
    function getMaxAnisotropy() {
        if (maxAnisotropy !== undefined) return maxAnisotropy;
        if (extensions.has("EXT_texture_filter_anisotropic") === true) {
            const extension = extensions.get("EXT_texture_filter_anisotropic");
            maxAnisotropy = gl.getParameter(extension.MAX_TEXTURE_MAX_ANISOTROPY_EXT);
        } else maxAnisotropy = 0;
        return maxAnisotropy;
    }
    function getMaxPrecision(precision) {
        if (precision === "highp") {
            if (gl.getShaderPrecisionFormat(gl.VERTEX_SHADER, gl.HIGH_FLOAT).precision > 0 && gl.getShaderPrecisionFormat(gl.FRAGMENT_SHADER, gl.HIGH_FLOAT).precision > 0) return "highp";
            precision = "mediump";
        }
        if (precision === "mediump") {
            if (gl.getShaderPrecisionFormat(gl.VERTEX_SHADER, gl.MEDIUM_FLOAT).precision > 0 && gl.getShaderPrecisionFormat(gl.FRAGMENT_SHADER, gl.MEDIUM_FLOAT).precision > 0) return "mediump";
        }
        return "lowp";
    }
    const isWebGL2 = typeof WebGL2RenderingContext !== "undefined" && gl.constructor.name === "WebGL2RenderingContext";
    let precision = parameters.precision !== undefined ? parameters.precision : "highp";
    const maxPrecision = getMaxPrecision(precision);
    if (maxPrecision !== precision) {
        console.warn("THREE.WebGLRenderer:", precision, "not supported, using", maxPrecision, "instead.");
        precision = maxPrecision;
    }
    const drawBuffers = isWebGL2 || extensions.has("WEBGL_draw_buffers");
    const logarithmicDepthBuffer = parameters.logarithmicDepthBuffer === true;
    const maxTextures = gl.getParameter(gl.MAX_TEXTURE_IMAGE_UNITS);
    const maxVertexTextures = gl.getParameter(gl.MAX_VERTEX_TEXTURE_IMAGE_UNITS);
    const maxTextureSize = gl.getParameter(gl.MAX_TEXTURE_SIZE);
    const maxCubemapSize = gl.getParameter(gl.MAX_CUBE_MAP_TEXTURE_SIZE);
    const maxAttributes = gl.getParameter(gl.MAX_VERTEX_ATTRIBS);
    const maxVertexUniforms = gl.getParameter(gl.MAX_VERTEX_UNIFORM_VECTORS);
    const maxVaryings = gl.getParameter(gl.MAX_VARYING_VECTORS);
    const maxFragmentUniforms = gl.getParameter(gl.MAX_FRAGMENT_UNIFORM_VECTORS);
    const vertexTextures = maxVertexTextures > 0;
    const floatFragmentTextures = isWebGL2 || extensions.has("OES_texture_float");
    const floatVertexTextures = vertexTextures && floatFragmentTextures;
    const maxSamples = isWebGL2 ? gl.getParameter(gl.MAX_SAMPLES) : 0;
    return {
        isWebGL2: isWebGL2,
        drawBuffers: drawBuffers,
        getMaxAnisotropy: getMaxAnisotropy,
        getMaxPrecision: getMaxPrecision,
        precision: precision,
        logarithmicDepthBuffer: logarithmicDepthBuffer,
        maxTextures: maxTextures,
        maxVertexTextures: maxVertexTextures,
        maxTextureSize: maxTextureSize,
        maxCubemapSize: maxCubemapSize,
        maxAttributes: maxAttributes,
        maxVertexUniforms: maxVertexUniforms,
        maxVaryings: maxVaryings,
        maxFragmentUniforms: maxFragmentUniforms,
        vertexTextures: vertexTextures,
        floatFragmentTextures: floatFragmentTextures,
        floatVertexTextures: floatVertexTextures,
        maxSamples: maxSamples
    };
}
function $9014d97cd777be10$var$WebGLClipping(properties) {
    const scope = this;
    let globalState = null, numGlobalPlanes = 0, localClippingEnabled = false, renderingShadows = false;
    const plane = new $9014d97cd777be10$export$7ff5ac152ef991b0(), viewNormalMatrix = new $9014d97cd777be10$export$8ff26dafa08918(), uniform = {
        value: null,
        needsUpdate: false
    };
    this.uniform = uniform;
    this.numPlanes = 0;
    this.numIntersection = 0;
    this.init = function(planes, enableLocalClipping) {
        const enabled = planes.length !== 0 || enableLocalClipping || // enable state of previous frame - the clipping code has to
        // run another frame in order to reset the state:
        numGlobalPlanes !== 0 || localClippingEnabled;
        localClippingEnabled = enableLocalClipping;
        numGlobalPlanes = planes.length;
        return enabled;
    };
    this.beginShadows = function() {
        renderingShadows = true;
        projectPlanes(null);
    };
    this.endShadows = function() {
        renderingShadows = false;
    };
    this.setGlobalState = function(planes, camera) {
        globalState = projectPlanes(planes, camera, 0);
    };
    this.setState = function(material, camera, useCache) {
        const planes = material.clippingPlanes, clipIntersection = material.clipIntersection, clipShadows = material.clipShadows;
        const materialProperties = properties.get(material);
        if (!localClippingEnabled || planes === null || planes.length === 0 || renderingShadows && !clipShadows) {
            // there's no local clipping
            if (renderingShadows) // there's no global clipping
            projectPlanes(null);
            else resetGlobalState();
        } else {
            const nGlobal = renderingShadows ? 0 : numGlobalPlanes, lGlobal = nGlobal * 4;
            let dstArray = materialProperties.clippingState || null;
            uniform.value = dstArray; // ensure unique state
            dstArray = projectPlanes(planes, camera, lGlobal, useCache);
            for(let i = 0; i !== lGlobal; ++i)dstArray[i] = globalState[i];
            materialProperties.clippingState = dstArray;
            this.numIntersection = clipIntersection ? this.numPlanes : 0;
            this.numPlanes += nGlobal;
        }
    };
    function resetGlobalState() {
        if (uniform.value !== globalState) {
            uniform.value = globalState;
            uniform.needsUpdate = numGlobalPlanes > 0;
        }
        scope.numPlanes = numGlobalPlanes;
        scope.numIntersection = 0;
    }
    function projectPlanes(planes, camera, dstOffset, skipTransform) {
        const nPlanes = planes !== null ? planes.length : 0;
        let dstArray = null;
        if (nPlanes !== 0) {
            dstArray = uniform.value;
            if (skipTransform !== true || dstArray === null) {
                const flatSize = dstOffset + nPlanes * 4, viewMatrix = camera.matrixWorldInverse;
                viewNormalMatrix.getNormalMatrix(viewMatrix);
                if (dstArray === null || dstArray.length < flatSize) dstArray = new Float32Array(flatSize);
                for(let i = 0, i4 = dstOffset; i !== nPlanes; ++i, i4 += 4){
                    plane.copy(planes[i]).applyMatrix4(viewMatrix, viewNormalMatrix);
                    plane.normal.toArray(dstArray, i4);
                    dstArray[i4 + 3] = plane.constant;
                }
            }
            uniform.value = dstArray;
            uniform.needsUpdate = true;
        }
        scope.numPlanes = nPlanes;
        scope.numIntersection = 0;
        return dstArray;
    }
}
function $9014d97cd777be10$var$WebGLCubeMaps(renderer) {
    let cubemaps = new WeakMap();
    function mapTextureMapping(texture, mapping) {
        if (mapping === $9014d97cd777be10$export$d64030b316d3b087) texture.mapping = $9014d97cd777be10$export$8759762a6477f2c4;
        else if (mapping === $9014d97cd777be10$export$ee99d97d46898098) texture.mapping = $9014d97cd777be10$export$dc59f8aed047f61d;
        return texture;
    }
    function get(texture) {
        if (texture && texture.isTexture && texture.isRenderTargetTexture === false) {
            const mapping = texture.mapping;
            if (mapping === $9014d97cd777be10$export$d64030b316d3b087 || mapping === $9014d97cd777be10$export$ee99d97d46898098) {
                if (cubemaps.has(texture)) {
                    const cubemap = cubemaps.get(texture).texture;
                    return mapTextureMapping(cubemap, texture.mapping);
                } else {
                    const image = texture.image;
                    if (image && image.height > 0) {
                        const renderTarget = new $9014d97cd777be10$export$ac386671d651941e(image.height / 2);
                        renderTarget.fromEquirectangularTexture(renderer, texture);
                        cubemaps.set(texture, renderTarget);
                        texture.addEventListener("dispose", onTextureDispose);
                        return mapTextureMapping(renderTarget.texture, texture.mapping);
                    } else // image not yet ready. try the conversion next frame
                    return null;
                }
            }
        }
        return texture;
    }
    function onTextureDispose(event) {
        const texture = event.target;
        texture.removeEventListener("dispose", onTextureDispose);
        const cubemap = cubemaps.get(texture);
        if (cubemap !== undefined) {
            cubemaps.delete(texture);
            cubemap.dispose();
        }
    }
    function dispose() {
        cubemaps = new WeakMap();
    }
    return {
        get: get,
        dispose: dispose
    };
}
class $9014d97cd777be10$export$9ebf355ee4ed261b extends $9014d97cd777be10$export$79f141de891a5fed {
    copy(source, recursive) {
        super.copy(source, recursive);
        this.left = source.left;
        this.right = source.right;
        this.top = source.top;
        this.bottom = source.bottom;
        this.near = source.near;
        this.far = source.far;
        this.zoom = source.zoom;
        this.view = source.view === null ? null : Object.assign({}, source.view);
        return this;
    }
    setViewOffset(fullWidth, fullHeight, x, y, width, height) {
        if (this.view === null) this.view = {
            enabled: true,
            fullWidth: 1,
            fullHeight: 1,
            offsetX: 0,
            offsetY: 0,
            width: 1,
            height: 1
        };
        this.view.enabled = true;
        this.view.fullWidth = fullWidth;
        this.view.fullHeight = fullHeight;
        this.view.offsetX = x;
        this.view.offsetY = y;
        this.view.width = width;
        this.view.height = height;
        this.updateProjectionMatrix();
    }
    clearViewOffset() {
        if (this.view !== null) this.view.enabled = false;
        this.updateProjectionMatrix();
    }
    updateProjectionMatrix() {
        const dx = (this.right - this.left) / (2 * this.zoom);
        const dy = (this.top - this.bottom) / (2 * this.zoom);
        const cx = (this.right + this.left) / 2;
        const cy = (this.top + this.bottom) / 2;
        let left = cx - dx;
        let right = cx + dx;
        let top = cy + dy;
        let bottom = cy - dy;
        if (this.view !== null && this.view.enabled) {
            const scaleW = (this.right - this.left) / this.view.fullWidth / this.zoom;
            const scaleH = (this.top - this.bottom) / this.view.fullHeight / this.zoom;
            left += scaleW * this.view.offsetX;
            right = left + scaleW * this.view.width;
            top -= scaleH * this.view.offsetY;
            bottom = top - scaleH * this.view.height;
        }
        this.projectionMatrix.makeOrthographic(left, right, top, bottom, this.near, this.far, this.coordinateSystem);
        this.projectionMatrixInverse.copy(this.projectionMatrix).invert();
    }
    toJSON(meta) {
        const data = super.toJSON(meta);
        data.object.zoom = this.zoom;
        data.object.left = this.left;
        data.object.right = this.right;
        data.object.top = this.top;
        data.object.bottom = this.bottom;
        data.object.near = this.near;
        data.object.far = this.far;
        if (this.view !== null) data.object.view = Object.assign({}, this.view);
        return data;
    }
    constructor(left = -1, right = 1, top = 1, bottom = -1, near = 0.1, far = 2000){
        super();
        this.isOrthographicCamera = true;
        this.type = "OrthographicCamera";
        this.zoom = 1;
        this.view = null;
        this.left = left;
        this.right = right;
        this.top = top;
        this.bottom = bottom;
        this.near = near;
        this.far = far;
        this.updateProjectionMatrix();
    }
}
const $9014d97cd777be10$var$LOD_MIN = 4;
// The standard deviations (radians) associated with the extra mips. These are
// chosen to approximate a Trowbridge-Reitz distribution function times the
// geometric shadowing function. These sigma values squared must match the
// variance #defines in cube_uv_reflection_fragment.glsl.js.
const $9014d97cd777be10$var$EXTRA_LOD_SIGMA = [
    0.125,
    0.215,
    0.35,
    0.446,
    0.526,
    0.582
];
// The maximum length of the blur for loop. Smaller sigmas will use fewer
// samples and exit early, but not recompile the shader.
const $9014d97cd777be10$var$MAX_SAMPLES = 20;
const $9014d97cd777be10$var$_flatCamera = /*@__PURE__*/ new $9014d97cd777be10$export$9ebf355ee4ed261b();
const $9014d97cd777be10$var$_clearColor = /*@__PURE__*/ new $9014d97cd777be10$export$892596cec99bc70e();
let $9014d97cd777be10$var$_oldTarget = null;
// Golden Ratio
const $9014d97cd777be10$var$PHI = (1 + Math.sqrt(5)) / 2;
const $9014d97cd777be10$var$INV_PHI = 1 / $9014d97cd777be10$var$PHI;
// Vertices of a dodecahedron (except the opposites, which represent the
// same axis), used as axis directions evenly spread on a sphere.
const $9014d97cd777be10$var$_axisDirections = [
    /*@__PURE__*/ new $9014d97cd777be10$export$64b5c384219d3699(1, 1, 1),
    /*@__PURE__*/ new $9014d97cd777be10$export$64b5c384219d3699(-1, 1, 1),
    /*@__PURE__*/ new $9014d97cd777be10$export$64b5c384219d3699(1, 1, -1),
    /*@__PURE__*/ new $9014d97cd777be10$export$64b5c384219d3699(-1, 1, -1),
    /*@__PURE__*/ new $9014d97cd777be10$export$64b5c384219d3699(0, $9014d97cd777be10$var$PHI, $9014d97cd777be10$var$INV_PHI),
    /*@__PURE__*/ new $9014d97cd777be10$export$64b5c384219d3699(0, $9014d97cd777be10$var$PHI, -$9014d97cd777be10$var$INV_PHI),
    /*@__PURE__*/ new $9014d97cd777be10$export$64b5c384219d3699($9014d97cd777be10$var$INV_PHI, 0, $9014d97cd777be10$var$PHI),
    /*@__PURE__*/ new $9014d97cd777be10$export$64b5c384219d3699(-$9014d97cd777be10$var$INV_PHI, 0, $9014d97cd777be10$var$PHI),
    /*@__PURE__*/ new $9014d97cd777be10$export$64b5c384219d3699($9014d97cd777be10$var$PHI, $9014d97cd777be10$var$INV_PHI, 0),
    /*@__PURE__*/ new $9014d97cd777be10$export$64b5c384219d3699(-$9014d97cd777be10$var$PHI, $9014d97cd777be10$var$INV_PHI, 0)
];
/**
 * This class generates a Prefiltered, Mipmapped Radiance Environment Map
 * (PMREM) from a cubeMap environment texture. This allows different levels of
 * blur to be quickly accessed based on material roughness. It is packed into a
 * special CubeUV format that allows us to perform custom interpolation so that
 * we can support nonlinear formats such as RGBE. Unlike a traditional mipmap
 * chain, it only goes down to the LOD_MIN level (above), and then creates extra
 * even more filtered 'mips' at the same LOD_MIN resolution, associated with
 * higher roughness levels. In this way we maintain resolution to smoothly
 * interpolate diffuse lighting while limiting sampling computation.
 *
 * Paper: Fast, Accurate Image-Based Lighting
 * https://drive.google.com/file/d/15y8r_UpKlU9SvV4ILb0C3qCPecS8pvLz/view
*/ class $9014d97cd777be10$export$6add42717753e221 {
    /**
	 * Generates a PMREM from a supplied Scene, which can be faster than using an
	 * image if networking bandwidth is low. Optional sigma specifies a blur radius
	 * in radians to be applied to the scene before PMREM generation. Optional near
	 * and far planes ensure the scene is rendered in its entirety (the cubeCamera
	 * is placed at the origin).
	 */ fromScene(scene, sigma = 0, near = 0.1, far = 100) {
        $9014d97cd777be10$var$_oldTarget = this._renderer.getRenderTarget();
        this._setSize(256);
        const cubeUVRenderTarget = this._allocateTargets();
        cubeUVRenderTarget.depthBuffer = true;
        this._sceneToCubeUV(scene, near, far, cubeUVRenderTarget);
        if (sigma > 0) this._blur(cubeUVRenderTarget, 0, 0, sigma);
        this._applyPMREM(cubeUVRenderTarget);
        this._cleanup(cubeUVRenderTarget);
        return cubeUVRenderTarget;
    }
    /**
	 * Generates a PMREM from an equirectangular texture, which can be either LDR
	 * or HDR. The ideal input image size is 1k (1024 x 512),
	 * as this matches best with the 256 x 256 cubemap output.
	 */ fromEquirectangular(equirectangular, renderTarget = null) {
        return this._fromTexture(equirectangular, renderTarget);
    }
    /**
	 * Generates a PMREM from an cubemap texture, which can be either LDR
	 * or HDR. The ideal input cube size is 256 x 256,
	 * as this matches best with the 256 x 256 cubemap output.
	 */ fromCubemap(cubemap, renderTarget = null) {
        return this._fromTexture(cubemap, renderTarget);
    }
    /**
	 * Pre-compiles the cubemap shader. You can get faster start-up by invoking this method during
	 * your texture's network fetch for increased concurrency.
	 */ compileCubemapShader() {
        if (this._cubemapMaterial === null) {
            this._cubemapMaterial = $9014d97cd777be10$var$_getCubemapMaterial();
            this._compileMaterial(this._cubemapMaterial);
        }
    }
    /**
	 * Pre-compiles the equirectangular shader. You can get faster start-up by invoking this method during
	 * your texture's network fetch for increased concurrency.
	 */ compileEquirectangularShader() {
        if (this._equirectMaterial === null) {
            this._equirectMaterial = $9014d97cd777be10$var$_getEquirectMaterial();
            this._compileMaterial(this._equirectMaterial);
        }
    }
    /**
	 * Disposes of the PMREMGenerator's internal memory. Note that PMREMGenerator is a static class,
	 * so you should not need more than one PMREMGenerator object. If you do, calling dispose() on
	 * one of them will cause any others to also become unusable.
	 */ dispose() {
        this._dispose();
        if (this._cubemapMaterial !== null) this._cubemapMaterial.dispose();
        if (this._equirectMaterial !== null) this._equirectMaterial.dispose();
    }
    // private interface
    _setSize(cubeSize) {
        this._lodMax = Math.floor(Math.log2(cubeSize));
        this._cubeSize = Math.pow(2, this._lodMax);
    }
    _dispose() {
        if (this._blurMaterial !== null) this._blurMaterial.dispose();
        if (this._pingPongRenderTarget !== null) this._pingPongRenderTarget.dispose();
        for(let i = 0; i < this._lodPlanes.length; i++)this._lodPlanes[i].dispose();
    }
    _cleanup(outputTarget) {
        this._renderer.setRenderTarget($9014d97cd777be10$var$_oldTarget);
        outputTarget.scissorTest = false;
        $9014d97cd777be10$var$_setViewport(outputTarget, 0, 0, outputTarget.width, outputTarget.height);
    }
    _fromTexture(texture, renderTarget) {
        if (texture.mapping === $9014d97cd777be10$export$8759762a6477f2c4 || texture.mapping === $9014d97cd777be10$export$dc59f8aed047f61d) this._setSize(texture.image.length === 0 ? 16 : texture.image[0].width || texture.image[0].image.width);
        else this._setSize(texture.image.width / 4);
        $9014d97cd777be10$var$_oldTarget = this._renderer.getRenderTarget();
        const cubeUVRenderTarget = renderTarget || this._allocateTargets();
        this._textureToCubeUV(texture, cubeUVRenderTarget);
        this._applyPMREM(cubeUVRenderTarget);
        this._cleanup(cubeUVRenderTarget);
        return cubeUVRenderTarget;
    }
    _allocateTargets() {
        const width = 3 * Math.max(this._cubeSize, 112);
        const height = 4 * this._cubeSize;
        const params = {
            magFilter: $9014d97cd777be10$export$8a72f490b25c56c8,
            minFilter: $9014d97cd777be10$export$8a72f490b25c56c8,
            generateMipmaps: false,
            type: $9014d97cd777be10$export$2697304443f382bc,
            format: $9014d97cd777be10$export$3f8bb04b555a363c,
            colorSpace: $9014d97cd777be10$export$42429b3acfb233a4,
            depthBuffer: false
        };
        const cubeUVRenderTarget = $9014d97cd777be10$var$_createRenderTarget(width, height, params);
        if (this._pingPongRenderTarget === null || this._pingPongRenderTarget.width !== width || this._pingPongRenderTarget.height !== height) {
            if (this._pingPongRenderTarget !== null) this._dispose();
            this._pingPongRenderTarget = $9014d97cd777be10$var$_createRenderTarget(width, height, params);
            const { _lodMax: _lodMax } = this;
            ({ sizeLods: this._sizeLods, lodPlanes: this._lodPlanes, sigmas: this._sigmas } = $9014d97cd777be10$var$_createPlanes(_lodMax));
            this._blurMaterial = $9014d97cd777be10$var$_getBlurShader(_lodMax, width, height);
        }
        return cubeUVRenderTarget;
    }
    _compileMaterial(material) {
        const tmpMesh = new $9014d97cd777be10$export$e176487c05830cc5(this._lodPlanes[0], material);
        this._renderer.compile(tmpMesh, $9014d97cd777be10$var$_flatCamera);
    }
    _sceneToCubeUV(scene, near, far, cubeUVRenderTarget) {
        const fov = 90;
        const aspect = 1;
        const cubeCamera = new $9014d97cd777be10$export$74e4ae24825f68d7(fov, aspect, near, far);
        const upSign = [
            1,
            -1,
            1,
            1,
            1,
            1
        ];
        const forwardSign = [
            1,
            1,
            1,
            -1,
            -1,
            -1
        ];
        const renderer = this._renderer;
        const originalAutoClear = renderer.autoClear;
        const toneMapping = renderer.toneMapping;
        renderer.getClearColor($9014d97cd777be10$var$_clearColor);
        renderer.toneMapping = $9014d97cd777be10$export$9fcb6b4294603b2;
        renderer.autoClear = false;
        const backgroundMaterial = new $9014d97cd777be10$export$55cbcc9b622fe1f5({
            name: "PMREM.Background",
            side: $9014d97cd777be10$export$d9f0486e75b5ace,
            depthWrite: false,
            depthTest: false
        });
        const backgroundBox = new $9014d97cd777be10$export$e176487c05830cc5(new $9014d97cd777be10$export$33e43285f7406bd5(), backgroundMaterial);
        let useSolidColor = false;
        const background = scene.background;
        if (background) {
            if (background.isColor) {
                backgroundMaterial.color.copy(background);
                scene.background = null;
                useSolidColor = true;
            }
        } else {
            backgroundMaterial.color.copy($9014d97cd777be10$var$_clearColor);
            useSolidColor = true;
        }
        for(let i = 0; i < 6; i++){
            const col = i % 3;
            if (col === 0) {
                cubeCamera.up.set(0, upSign[i], 0);
                cubeCamera.lookAt(forwardSign[i], 0, 0);
            } else if (col === 1) {
                cubeCamera.up.set(0, 0, upSign[i]);
                cubeCamera.lookAt(0, forwardSign[i], 0);
            } else {
                cubeCamera.up.set(0, upSign[i], 0);
                cubeCamera.lookAt(0, 0, forwardSign[i]);
            }
            const size = this._cubeSize;
            $9014d97cd777be10$var$_setViewport(cubeUVRenderTarget, col * size, i > 2 ? size : 0, size, size);
            renderer.setRenderTarget(cubeUVRenderTarget);
            if (useSolidColor) renderer.render(backgroundBox, cubeCamera);
            renderer.render(scene, cubeCamera);
        }
        backgroundBox.geometry.dispose();
        backgroundBox.material.dispose();
        renderer.toneMapping = toneMapping;
        renderer.autoClear = originalAutoClear;
        scene.background = background;
    }
    _textureToCubeUV(texture, cubeUVRenderTarget) {
        const renderer = this._renderer;
        const isCubeTexture = texture.mapping === $9014d97cd777be10$export$8759762a6477f2c4 || texture.mapping === $9014d97cd777be10$export$dc59f8aed047f61d;
        if (isCubeTexture) {
            if (this._cubemapMaterial === null) this._cubemapMaterial = $9014d97cd777be10$var$_getCubemapMaterial();
            this._cubemapMaterial.uniforms.flipEnvMap.value = texture.isRenderTargetTexture === false ? -1 : 1;
        } else if (this._equirectMaterial === null) this._equirectMaterial = $9014d97cd777be10$var$_getEquirectMaterial();
        const material = isCubeTexture ? this._cubemapMaterial : this._equirectMaterial;
        const mesh = new $9014d97cd777be10$export$e176487c05830cc5(this._lodPlanes[0], material);
        const uniforms = material.uniforms;
        uniforms["envMap"].value = texture;
        const size = this._cubeSize;
        $9014d97cd777be10$var$_setViewport(cubeUVRenderTarget, 0, 0, 3 * size, 2 * size);
        renderer.setRenderTarget(cubeUVRenderTarget);
        renderer.render(mesh, $9014d97cd777be10$var$_flatCamera);
    }
    _applyPMREM(cubeUVRenderTarget) {
        const renderer = this._renderer;
        const autoClear = renderer.autoClear;
        renderer.autoClear = false;
        for(let i = 1; i < this._lodPlanes.length; i++){
            const sigma = Math.sqrt(this._sigmas[i] * this._sigmas[i] - this._sigmas[i - 1] * this._sigmas[i - 1]);
            const poleAxis = $9014d97cd777be10$var$_axisDirections[(i - 1) % $9014d97cd777be10$var$_axisDirections.length];
            this._blur(cubeUVRenderTarget, i - 1, i, sigma, poleAxis);
        }
        renderer.autoClear = autoClear;
    }
    /**
	 * This is a two-pass Gaussian blur for a cubemap. Normally this is done
	 * vertically and horizontally, but this breaks down on a cube. Here we apply
	 * the blur latitudinally (around the poles), and then longitudinally (towards
	 * the poles) to approximate the orthogonally-separable blur. It is least
	 * accurate at the poles, but still does a decent job.
	 */ _blur(cubeUVRenderTarget, lodIn, lodOut, sigma, poleAxis) {
        const pingPongRenderTarget = this._pingPongRenderTarget;
        this._halfBlur(cubeUVRenderTarget, pingPongRenderTarget, lodIn, lodOut, sigma, "latitudinal", poleAxis);
        this._halfBlur(pingPongRenderTarget, cubeUVRenderTarget, lodOut, lodOut, sigma, "longitudinal", poleAxis);
    }
    _halfBlur(targetIn, targetOut, lodIn, lodOut, sigmaRadians, direction, poleAxis) {
        const renderer = this._renderer;
        const blurMaterial = this._blurMaterial;
        if (direction !== "latitudinal" && direction !== "longitudinal") console.error("blur direction must be either latitudinal or longitudinal!");
        // Number of standard deviations at which to cut off the discrete approximation.
        const STANDARD_DEVIATIONS = 3;
        const blurMesh = new $9014d97cd777be10$export$e176487c05830cc5(this._lodPlanes[lodOut], blurMaterial);
        const blurUniforms = blurMaterial.uniforms;
        const pixels = this._sizeLods[lodIn] - 1;
        const radiansPerPixel = isFinite(sigmaRadians) ? Math.PI / (2 * pixels) : 2 * Math.PI / (2 * $9014d97cd777be10$var$MAX_SAMPLES - 1);
        const sigmaPixels = sigmaRadians / radiansPerPixel;
        const samples = isFinite(sigmaRadians) ? 1 + Math.floor(STANDARD_DEVIATIONS * sigmaPixels) : $9014d97cd777be10$var$MAX_SAMPLES;
        if (samples > $9014d97cd777be10$var$MAX_SAMPLES) console.warn(`sigmaRadians, ${sigmaRadians}, is too large and will clip, as it requested ${samples} samples when the maximum is set to ${$9014d97cd777be10$var$MAX_SAMPLES}`);
        const weights = [];
        let sum = 0;
        for(let i = 0; i < $9014d97cd777be10$var$MAX_SAMPLES; ++i){
            const x = i / sigmaPixels;
            const weight = Math.exp(-x * x / 2);
            weights.push(weight);
            if (i === 0) sum += weight;
            else if (i < samples) sum += 2 * weight;
        }
        for(let i = 0; i < weights.length; i++)weights[i] = weights[i] / sum;
        blurUniforms["envMap"].value = targetIn.texture;
        blurUniforms["samples"].value = samples;
        blurUniforms["weights"].value = weights;
        blurUniforms["latitudinal"].value = direction === "latitudinal";
        if (poleAxis) blurUniforms["poleAxis"].value = poleAxis;
        const { _lodMax: _lodMax } = this;
        blurUniforms["dTheta"].value = radiansPerPixel;
        blurUniforms["mipInt"].value = _lodMax - lodIn;
        const outputSize = this._sizeLods[lodOut];
        const x = 3 * outputSize * (lodOut > _lodMax - $9014d97cd777be10$var$LOD_MIN ? lodOut - _lodMax + $9014d97cd777be10$var$LOD_MIN : 0);
        const y = 4 * (this._cubeSize - outputSize);
        $9014d97cd777be10$var$_setViewport(targetOut, x, y, 3 * outputSize, 2 * outputSize);
        renderer.setRenderTarget(targetOut);
        renderer.render(blurMesh, $9014d97cd777be10$var$_flatCamera);
    }
    constructor(renderer){
        this._renderer = renderer;
        this._pingPongRenderTarget = null;
        this._lodMax = 0;
        this._cubeSize = 0;
        this._lodPlanes = [];
        this._sizeLods = [];
        this._sigmas = [];
        this._blurMaterial = null;
        this._cubemapMaterial = null;
        this._equirectMaterial = null;
        this._compileMaterial(this._blurMaterial);
    }
}
function $9014d97cd777be10$var$_createPlanes(lodMax) {
    const lodPlanes = [];
    const sizeLods = [];
    const sigmas = [];
    let lod = lodMax;
    const totalLods = lodMax - $9014d97cd777be10$var$LOD_MIN + 1 + $9014d97cd777be10$var$EXTRA_LOD_SIGMA.length;
    for(let i = 0; i < totalLods; i++){
        const sizeLod = Math.pow(2, lod);
        sizeLods.push(sizeLod);
        let sigma = 1.0 / sizeLod;
        if (i > lodMax - $9014d97cd777be10$var$LOD_MIN) sigma = $9014d97cd777be10$var$EXTRA_LOD_SIGMA[i - lodMax + $9014d97cd777be10$var$LOD_MIN - 1];
        else if (i === 0) sigma = 0;
        sigmas.push(sigma);
        const texelSize = 1.0 / (sizeLod - 2);
        const min = -texelSize;
        const max = 1 + texelSize;
        const uv1 = [
            min,
            min,
            max,
            min,
            max,
            max,
            min,
            min,
            max,
            max,
            min,
            max
        ];
        const cubeFaces = 6;
        const vertices = 6;
        const positionSize = 3;
        const uvSize = 2;
        const faceIndexSize = 1;
        const position = new Float32Array(positionSize * vertices * cubeFaces);
        const uv = new Float32Array(uvSize * vertices * cubeFaces);
        const faceIndex = new Float32Array(faceIndexSize * vertices * cubeFaces);
        for(let face = 0; face < cubeFaces; face++){
            const x = face % 3 * 2 / 3 - 1;
            const y = face > 2 ? 0 : -1;
            const coordinates = [
                x,
                y,
                0,
                x + 2 / 3,
                y,
                0,
                x + 2 / 3,
                y + 1,
                0,
                x,
                y,
                0,
                x + 2 / 3,
                y + 1,
                0,
                x,
                y + 1,
                0
            ];
            position.set(coordinates, positionSize * vertices * face);
            uv.set(uv1, uvSize * vertices * face);
            const fill = [
                face,
                face,
                face,
                face,
                face,
                face
            ];
            faceIndex.set(fill, faceIndexSize * vertices * face);
        }
        const planes = new $9014d97cd777be10$export$b7be63a67df8959();
        planes.setAttribute("position", new $9014d97cd777be10$export$8dea267bd6bde117(position, positionSize));
        planes.setAttribute("uv", new $9014d97cd777be10$export$8dea267bd6bde117(uv, uvSize));
        planes.setAttribute("faceIndex", new $9014d97cd777be10$export$8dea267bd6bde117(faceIndex, faceIndexSize));
        lodPlanes.push(planes);
        if (lod > $9014d97cd777be10$var$LOD_MIN) lod--;
    }
    return {
        lodPlanes: lodPlanes,
        sizeLods: sizeLods,
        sigmas: sigmas
    };
}
function $9014d97cd777be10$var$_createRenderTarget(width, height, params) {
    const cubeUVRenderTarget = new $9014d97cd777be10$export$3c052beb2e51e23f(width, height, params);
    cubeUVRenderTarget.texture.mapping = $9014d97cd777be10$export$dbf3e70ff37af79;
    cubeUVRenderTarget.texture.name = "PMREM.cubeUv";
    cubeUVRenderTarget.scissorTest = true;
    return cubeUVRenderTarget;
}
function $9014d97cd777be10$var$_setViewport(target, x, y, width, height) {
    target.viewport.set(x, y, width, height);
    target.scissor.set(x, y, width, height);
}
function $9014d97cd777be10$var$_getBlurShader(lodMax, width, height) {
    const weights = new Float32Array($9014d97cd777be10$var$MAX_SAMPLES);
    const poleAxis = new $9014d97cd777be10$export$64b5c384219d3699(0, 1, 0);
    const shaderMaterial = new $9014d97cd777be10$export$83c7d75d550a8b0d({
        name: "SphericalGaussianBlur",
        defines: {
            "n": $9014d97cd777be10$var$MAX_SAMPLES,
            "CUBEUV_TEXEL_WIDTH": 1.0 / width,
            "CUBEUV_TEXEL_HEIGHT": 1.0 / height,
            "CUBEUV_MAX_MIP": `${lodMax}.0`
        },
        uniforms: {
            "envMap": {
                value: null
            },
            "samples": {
                value: 1
            },
            "weights": {
                value: weights
            },
            "latitudinal": {
                value: false
            },
            "dTheta": {
                value: 0
            },
            "mipInt": {
                value: 0
            },
            "poleAxis": {
                value: poleAxis
            }
        },
        vertexShader: $9014d97cd777be10$var$_getCommonVertexShader(),
        fragmentShader: /* glsl */ `

			precision mediump float;
			precision mediump int;

			varying vec3 vOutputDirection;

			uniform sampler2D envMap;
			uniform int samples;
			uniform float weights[ n ];
			uniform bool latitudinal;
			uniform float dTheta;
			uniform float mipInt;
			uniform vec3 poleAxis;

			#define ENVMAP_TYPE_CUBE_UV
			#include <cube_uv_reflection_fragment>

			vec3 getSample( float theta, vec3 axis ) {

				float cosTheta = cos( theta );
				// Rodrigues' axis-angle rotation
				vec3 sampleDirection = vOutputDirection * cosTheta
					+ cross( axis, vOutputDirection ) * sin( theta )
					+ axis * dot( axis, vOutputDirection ) * ( 1.0 - cosTheta );

				return bilinearCubeUV( envMap, sampleDirection, mipInt );

			}

			void main() {

				vec3 axis = latitudinal ? poleAxis : cross( poleAxis, vOutputDirection );

				if ( all( equal( axis, vec3( 0.0 ) ) ) ) {

					axis = vec3( vOutputDirection.z, 0.0, - vOutputDirection.x );

				}

				axis = normalize( axis );

				gl_FragColor = vec4( 0.0, 0.0, 0.0, 1.0 );
				gl_FragColor.rgb += weights[ 0 ] * getSample( 0.0, axis );

				for ( int i = 1; i < n; i++ ) {

					if ( i >= samples ) {

						break;

					}

					float theta = dTheta * float( i );
					gl_FragColor.rgb += weights[ i ] * getSample( -1.0 * theta, axis );
					gl_FragColor.rgb += weights[ i ] * getSample( theta, axis );

				}

			}
		`,
        blending: $9014d97cd777be10$export$63b8d6b580fc65ba,
        depthTest: false,
        depthWrite: false
    });
    return shaderMaterial;
}
function $9014d97cd777be10$var$_getEquirectMaterial() {
    return new $9014d97cd777be10$export$83c7d75d550a8b0d({
        name: "EquirectangularToCubeUV",
        uniforms: {
            "envMap": {
                value: null
            }
        },
        vertexShader: $9014d97cd777be10$var$_getCommonVertexShader(),
        fragmentShader: /* glsl */ `

			precision mediump float;
			precision mediump int;

			varying vec3 vOutputDirection;

			uniform sampler2D envMap;

			#include <common>

			void main() {

				vec3 outputDirection = normalize( vOutputDirection );
				vec2 uv = equirectUv( outputDirection );

				gl_FragColor = vec4( texture2D ( envMap, uv ).rgb, 1.0 );

			}
		`,
        blending: $9014d97cd777be10$export$63b8d6b580fc65ba,
        depthTest: false,
        depthWrite: false
    });
}
function $9014d97cd777be10$var$_getCubemapMaterial() {
    return new $9014d97cd777be10$export$83c7d75d550a8b0d({
        name: "CubemapToCubeUV",
        uniforms: {
            "envMap": {
                value: null
            },
            "flipEnvMap": {
                value: -1
            }
        },
        vertexShader: $9014d97cd777be10$var$_getCommonVertexShader(),
        fragmentShader: /* glsl */ `

			precision mediump float;
			precision mediump int;

			uniform float flipEnvMap;

			varying vec3 vOutputDirection;

			uniform samplerCube envMap;

			void main() {

				gl_FragColor = textureCube( envMap, vec3( flipEnvMap * vOutputDirection.x, vOutputDirection.yz ) );

			}
		`,
        blending: $9014d97cd777be10$export$63b8d6b580fc65ba,
        depthTest: false,
        depthWrite: false
    });
}
function $9014d97cd777be10$var$_getCommonVertexShader() {
    return /* glsl */ `

		precision mediump float;
		precision mediump int;

		attribute float faceIndex;

		varying vec3 vOutputDirection;

		// RH coordinate system; PMREM face-indexing convention
		vec3 getDirection( vec2 uv, float face ) {

			uv = 2.0 * uv - 1.0;

			vec3 direction = vec3( uv, 1.0 );

			if ( face == 0.0 ) {

				direction = direction.zyx; // ( 1, v, u ) pos x

			} else if ( face == 1.0 ) {

				direction = direction.xzy;
				direction.xz *= -1.0; // ( -u, 1, -v ) pos y

			} else if ( face == 2.0 ) {

				direction.x *= -1.0; // ( -u, v, 1 ) pos z

			} else if ( face == 3.0 ) {

				direction = direction.zyx;
				direction.xz *= -1.0; // ( -1, v, -u ) neg x

			} else if ( face == 4.0 ) {

				direction = direction.xzy;
				direction.xy *= -1.0; // ( -u, -1, v ) neg y

			} else if ( face == 5.0 ) {

				direction.z *= -1.0; // ( u, v, -1 ) neg z

			}

			return direction;

		}

		void main() {

			vOutputDirection = getDirection( uv, faceIndex );
			gl_Position = vec4( position, 1.0 );

		}
	`;
}
function $9014d97cd777be10$var$WebGLCubeUVMaps(renderer) {
    let cubeUVmaps = new WeakMap();
    let pmremGenerator = null;
    function get(texture) {
        if (texture && texture.isTexture) {
            const mapping = texture.mapping;
            const isEquirectMap = mapping === $9014d97cd777be10$export$d64030b316d3b087 || mapping === $9014d97cd777be10$export$ee99d97d46898098;
            const isCubeMap = mapping === $9014d97cd777be10$export$8759762a6477f2c4 || mapping === $9014d97cd777be10$export$dc59f8aed047f61d;
            // equirect/cube map to cubeUV conversion
            if (isEquirectMap || isCubeMap) {
                if (texture.isRenderTargetTexture && texture.needsPMREMUpdate === true) {
                    texture.needsPMREMUpdate = false;
                    let renderTarget = cubeUVmaps.get(texture);
                    if (pmremGenerator === null) pmremGenerator = new $9014d97cd777be10$export$6add42717753e221(renderer);
                    renderTarget = isEquirectMap ? pmremGenerator.fromEquirectangular(texture, renderTarget) : pmremGenerator.fromCubemap(texture, renderTarget);
                    cubeUVmaps.set(texture, renderTarget);
                    return renderTarget.texture;
                } else {
                    if (cubeUVmaps.has(texture)) return cubeUVmaps.get(texture).texture;
                    else {
                        const image = texture.image;
                        if (isEquirectMap && image && image.height > 0 || isCubeMap && image && isCubeTextureComplete(image)) {
                            if (pmremGenerator === null) pmremGenerator = new $9014d97cd777be10$export$6add42717753e221(renderer);
                            const renderTarget = isEquirectMap ? pmremGenerator.fromEquirectangular(texture) : pmremGenerator.fromCubemap(texture);
                            cubeUVmaps.set(texture, renderTarget);
                            texture.addEventListener("dispose", onTextureDispose);
                            return renderTarget.texture;
                        } else // image not yet ready. try the conversion next frame
                        return null;
                    }
                }
            }
        }
        return texture;
    }
    function isCubeTextureComplete(image) {
        let count = 0;
        const length = 6;
        for(let i = 0; i < length; i++)if (image[i] !== undefined) count++;
        return count === length;
    }
    function onTextureDispose(event) {
        const texture = event.target;
        texture.removeEventListener("dispose", onTextureDispose);
        const cubemapUV = cubeUVmaps.get(texture);
        if (cubemapUV !== undefined) {
            cubeUVmaps.delete(texture);
            cubemapUV.dispose();
        }
    }
    function dispose() {
        cubeUVmaps = new WeakMap();
        if (pmremGenerator !== null) {
            pmremGenerator.dispose();
            pmremGenerator = null;
        }
    }
    return {
        get: get,
        dispose: dispose
    };
}
function $9014d97cd777be10$var$WebGLExtensions(gl) {
    const extensions = {};
    function getExtension(name) {
        if (extensions[name] !== undefined) return extensions[name];
        let extension;
        switch(name){
            case "WEBGL_depth_texture":
                extension = gl.getExtension("WEBGL_depth_texture") || gl.getExtension("MOZ_WEBGL_depth_texture") || gl.getExtension("WEBKIT_WEBGL_depth_texture");
                break;
            case "EXT_texture_filter_anisotropic":
                extension = gl.getExtension("EXT_texture_filter_anisotropic") || gl.getExtension("MOZ_EXT_texture_filter_anisotropic") || gl.getExtension("WEBKIT_EXT_texture_filter_anisotropic");
                break;
            case "WEBGL_compressed_texture_s3tc":
                extension = gl.getExtension("WEBGL_compressed_texture_s3tc") || gl.getExtension("MOZ_WEBGL_compressed_texture_s3tc") || gl.getExtension("WEBKIT_WEBGL_compressed_texture_s3tc");
                break;
            case "WEBGL_compressed_texture_pvrtc":
                extension = gl.getExtension("WEBGL_compressed_texture_pvrtc") || gl.getExtension("WEBKIT_WEBGL_compressed_texture_pvrtc");
                break;
            default:
                extension = gl.getExtension(name);
        }
        extensions[name] = extension;
        return extension;
    }
    return {
        has: function(name) {
            return getExtension(name) !== null;
        },
        init: function(capabilities) {
            if (capabilities.isWebGL2) getExtension("EXT_color_buffer_float");
            else {
                getExtension("WEBGL_depth_texture");
                getExtension("OES_texture_float");
                getExtension("OES_texture_half_float");
                getExtension("OES_texture_half_float_linear");
                getExtension("OES_standard_derivatives");
                getExtension("OES_element_index_uint");
                getExtension("OES_vertex_array_object");
                getExtension("ANGLE_instanced_arrays");
            }
            getExtension("OES_texture_float_linear");
            getExtension("EXT_color_buffer_half_float");
            getExtension("WEBGL_multisampled_render_to_texture");
        },
        get: function(name) {
            const extension = getExtension(name);
            if (extension === null) console.warn("THREE.WebGLRenderer: " + name + " extension not supported.");
            return extension;
        }
    };
}
function $9014d97cd777be10$var$WebGLGeometries(gl, attributes, info, bindingStates) {
    const geometries = {};
    const wireframeAttributes = new WeakMap();
    function onGeometryDispose(event) {
        const geometry = event.target;
        if (geometry.index !== null) attributes.remove(geometry.index);
        for(const name in geometry.attributes)attributes.remove(geometry.attributes[name]);
        for(const name in geometry.morphAttributes){
            const array = geometry.morphAttributes[name];
            for(let i = 0, l = array.length; i < l; i++)attributes.remove(array[i]);
        }
        geometry.removeEventListener("dispose", onGeometryDispose);
        delete geometries[geometry.id];
        const attribute = wireframeAttributes.get(geometry);
        if (attribute) {
            attributes.remove(attribute);
            wireframeAttributes.delete(geometry);
        }
        bindingStates.releaseStatesOfGeometry(geometry);
        if (geometry.isInstancedBufferGeometry === true) delete geometry._maxInstanceCount;
        //
        info.memory.geometries--;
    }
    function get(object, geometry) {
        if (geometries[geometry.id] === true) return geometry;
        geometry.addEventListener("dispose", onGeometryDispose);
        geometries[geometry.id] = true;
        info.memory.geometries++;
        return geometry;
    }
    function update(geometry) {
        const geometryAttributes = geometry.attributes;
        // Updating index buffer in VAO now. See WebGLBindingStates.
        for(const name in geometryAttributes)attributes.update(geometryAttributes[name], gl.ARRAY_BUFFER);
        // morph targets
        const morphAttributes = geometry.morphAttributes;
        for(const name in morphAttributes){
            const array = morphAttributes[name];
            for(let i = 0, l = array.length; i < l; i++)attributes.update(array[i], gl.ARRAY_BUFFER);
        }
    }
    function updateWireframeAttribute(geometry) {
        const indices = [];
        const geometryIndex = geometry.index;
        const geometryPosition = geometry.attributes.position;
        let version = 0;
        if (geometryIndex !== null) {
            const array = geometryIndex.array;
            version = geometryIndex.version;
            for(let i = 0, l = array.length; i < l; i += 3){
                const a = array[i + 0];
                const b = array[i + 1];
                const c = array[i + 2];
                indices.push(a, b, b, c, c, a);
            }
        } else if (geometryPosition !== undefined) {
            const array = geometryPosition.array;
            version = geometryPosition.version;
            for(let i = 0, l = array.length / 3 - 1; i < l; i += 3){
                const a = i + 0;
                const b = i + 1;
                const c = i + 2;
                indices.push(a, b, b, c, c, a);
            }
        } else return;
        const attribute = new ($9014d97cd777be10$var$arrayNeedsUint32(indices) ? $9014d97cd777be10$export$7eb8c9fa25cd5bd6 : $9014d97cd777be10$export$640a853f68025f2e)(indices, 1);
        attribute.version = version;
        // Updating index buffer in VAO now. See WebGLBindingStates
        //
        const previousAttribute = wireframeAttributes.get(geometry);
        if (previousAttribute) attributes.remove(previousAttribute);
        //
        wireframeAttributes.set(geometry, attribute);
    }
    function getWireframeAttribute(geometry) {
        const currentAttribute = wireframeAttributes.get(geometry);
        if (currentAttribute) {
            const geometryIndex = geometry.index;
            if (geometryIndex !== null) // if the attribute is obsolete, create a new one
            {
                if (currentAttribute.version < geometryIndex.version) updateWireframeAttribute(geometry);
            }
        } else updateWireframeAttribute(geometry);
        return wireframeAttributes.get(geometry);
    }
    return {
        get: get,
        update: update,
        getWireframeAttribute: getWireframeAttribute
    };
}
function $9014d97cd777be10$var$WebGLIndexedBufferRenderer(gl, extensions, info, capabilities) {
    const isWebGL2 = capabilities.isWebGL2;
    let mode;
    function setMode(value) {
        mode = value;
    }
    let type, bytesPerElement;
    function setIndex(value) {
        type = value.type;
        bytesPerElement = value.bytesPerElement;
    }
    function render(start, count) {
        gl.drawElements(mode, count, type, start * bytesPerElement);
        info.update(count, mode, 1);
    }
    function renderInstances(start, count, primcount) {
        if (primcount === 0) return;
        let extension, methodName;
        if (isWebGL2) {
            extension = gl;
            methodName = "drawElementsInstanced";
        } else {
            extension = extensions.get("ANGLE_instanced_arrays");
            methodName = "drawElementsInstancedANGLE";
            if (extension === null) {
                console.error("THREE.WebGLIndexedBufferRenderer: using THREE.InstancedBufferGeometry but hardware does not support extension ANGLE_instanced_arrays.");
                return;
            }
        }
        extension[methodName](mode, count, type, start * bytesPerElement, primcount);
        info.update(count, mode, primcount);
    }
    //
    this.setMode = setMode;
    this.setIndex = setIndex;
    this.render = render;
    this.renderInstances = renderInstances;
}
function $9014d97cd777be10$var$WebGLInfo(gl) {
    const memory = {
        geometries: 0,
        textures: 0
    };
    const render = {
        frame: 0,
        calls: 0,
        triangles: 0,
        points: 0,
        lines: 0
    };
    function update(count, mode, instanceCount) {
        render.calls++;
        switch(mode){
            case gl.TRIANGLES:
                render.triangles += instanceCount * (count / 3);
                break;
            case gl.LINES:
                render.lines += instanceCount * (count / 2);
                break;
            case gl.LINE_STRIP:
                render.lines += instanceCount * (count - 1);
                break;
            case gl.LINE_LOOP:
                render.lines += instanceCount * count;
                break;
            case gl.POINTS:
                render.points += instanceCount * count;
                break;
            default:
                console.error("THREE.WebGLInfo: Unknown draw mode:", mode);
                break;
        }
    }
    function reset() {
        render.calls = 0;
        render.triangles = 0;
        render.points = 0;
        render.lines = 0;
    }
    return {
        memory: memory,
        render: render,
        programs: null,
        autoReset: true,
        reset: reset,
        update: update
    };
}
function $9014d97cd777be10$var$numericalSort(a, b) {
    return a[0] - b[0];
}
function $9014d97cd777be10$var$absNumericalSort(a, b) {
    return Math.abs(b[1]) - Math.abs(a[1]);
}
function $9014d97cd777be10$var$WebGLMorphtargets(gl, capabilities, textures) {
    const influencesList = {};
    const morphInfluences = new Float32Array(8);
    const morphTextures = new WeakMap();
    const morph = new $9014d97cd777be10$export$fa7daccca11cdbe3();
    const workInfluences = [];
    for(let i = 0; i < 8; i++)workInfluences[i] = [
        i,
        0
    ];
    function update(object, geometry, program) {
        const objectInfluences = object.morphTargetInfluences;
        if (capabilities.isWebGL2 === true) {
            // instead of using attributes, the WebGL 2 code path encodes morph targets
            // into an array of data textures. Each layer represents a single morph target.
            const morphAttribute = geometry.morphAttributes.position || geometry.morphAttributes.normal || geometry.morphAttributes.color;
            const morphTargetsCount = morphAttribute !== undefined ? morphAttribute.length : 0;
            let entry = morphTextures.get(geometry);
            if (entry === undefined || entry.count !== morphTargetsCount) {
                if (entry !== undefined) entry.texture.dispose();
                const hasMorphPosition = geometry.morphAttributes.position !== undefined;
                const hasMorphNormals = geometry.morphAttributes.normal !== undefined;
                const hasMorphColors = geometry.morphAttributes.color !== undefined;
                const morphTargets = geometry.morphAttributes.position || [];
                const morphNormals = geometry.morphAttributes.normal || [];
                const morphColors = geometry.morphAttributes.color || [];
                let vertexDataCount = 0;
                if (hasMorphPosition === true) vertexDataCount = 1;
                if (hasMorphNormals === true) vertexDataCount = 2;
                if (hasMorphColors === true) vertexDataCount = 3;
                let width = geometry.attributes.position.count * vertexDataCount;
                let height = 1;
                if (width > capabilities.maxTextureSize) {
                    height = Math.ceil(width / capabilities.maxTextureSize);
                    width = capabilities.maxTextureSize;
                }
                const buffer = new Float32Array(width * height * 4 * morphTargetsCount);
                const texture = new $9014d97cd777be10$export$dfac6c8e811406a3(buffer, width, height, morphTargetsCount);
                texture.type = $9014d97cd777be10$export$f6d331659b644596;
                texture.needsUpdate = true;
                // fill buffer
                const vertexDataStride = vertexDataCount * 4;
                for(let i = 0; i < morphTargetsCount; i++){
                    const morphTarget = morphTargets[i];
                    const morphNormal = morphNormals[i];
                    const morphColor = morphColors[i];
                    const offset = width * height * 4 * i;
                    for(let j = 0; j < morphTarget.count; j++){
                        const stride = j * vertexDataStride;
                        if (hasMorphPosition === true) {
                            morph.fromBufferAttribute(morphTarget, j);
                            buffer[offset + stride + 0] = morph.x;
                            buffer[offset + stride + 1] = morph.y;
                            buffer[offset + stride + 2] = morph.z;
                            buffer[offset + stride + 3] = 0;
                        }
                        if (hasMorphNormals === true) {
                            morph.fromBufferAttribute(morphNormal, j);
                            buffer[offset + stride + 4] = morph.x;
                            buffer[offset + stride + 5] = morph.y;
                            buffer[offset + stride + 6] = morph.z;
                            buffer[offset + stride + 7] = 0;
                        }
                        if (hasMorphColors === true) {
                            morph.fromBufferAttribute(morphColor, j);
                            buffer[offset + stride + 8] = morph.x;
                            buffer[offset + stride + 9] = morph.y;
                            buffer[offset + stride + 10] = morph.z;
                            buffer[offset + stride + 11] = morphColor.itemSize === 4 ? morph.w : 1;
                        }
                    }
                }
                entry = {
                    count: morphTargetsCount,
                    texture: texture,
                    size: new $9014d97cd777be10$export$c977b3e384af9ae1(width, height)
                };
                morphTextures.set(geometry, entry);
                function disposeTexture() {
                    texture.dispose();
                    morphTextures.delete(geometry);
                    geometry.removeEventListener("dispose", disposeTexture);
                }
                geometry.addEventListener("dispose", disposeTexture);
            }
            //
            let morphInfluencesSum = 0;
            for(let i = 0; i < objectInfluences.length; i++)morphInfluencesSum += objectInfluences[i];
            const morphBaseInfluence = geometry.morphTargetsRelative ? 1 : 1 - morphInfluencesSum;
            program.getUniforms().setValue(gl, "morphTargetBaseInfluence", morphBaseInfluence);
            program.getUniforms().setValue(gl, "morphTargetInfluences", objectInfluences);
            program.getUniforms().setValue(gl, "morphTargetsTexture", entry.texture, textures);
            program.getUniforms().setValue(gl, "morphTargetsTextureSize", entry.size);
        } else {
            // When object doesn't have morph target influences defined, we treat it as a 0-length array
            // This is important to make sure we set up morphTargetBaseInfluence / morphTargetInfluences
            const length = objectInfluences === undefined ? 0 : objectInfluences.length;
            let influences = influencesList[geometry.id];
            if (influences === undefined || influences.length !== length) {
                // initialise list
                influences = [];
                for(let i = 0; i < length; i++)influences[i] = [
                    i,
                    0
                ];
                influencesList[geometry.id] = influences;
            }
            // Collect influences
            for(let i = 0; i < length; i++){
                const influence = influences[i];
                influence[0] = i;
                influence[1] = objectInfluences[i];
            }
            influences.sort($9014d97cd777be10$var$absNumericalSort);
            for(let i = 0; i < 8; i++)if (i < length && influences[i][1]) {
                workInfluences[i][0] = influences[i][0];
                workInfluences[i][1] = influences[i][1];
            } else {
                workInfluences[i][0] = Number.MAX_SAFE_INTEGER;
                workInfluences[i][1] = 0;
            }
            workInfluences.sort($9014d97cd777be10$var$numericalSort);
            const morphTargets = geometry.morphAttributes.position;
            const morphNormals = geometry.morphAttributes.normal;
            let morphInfluencesSum = 0;
            for(let i = 0; i < 8; i++){
                const influence = workInfluences[i];
                const index = influence[0];
                const value = influence[1];
                if (index !== Number.MAX_SAFE_INTEGER && value) {
                    if (morphTargets && geometry.getAttribute("morphTarget" + i) !== morphTargets[index]) geometry.setAttribute("morphTarget" + i, morphTargets[index]);
                    if (morphNormals && geometry.getAttribute("morphNormal" + i) !== morphNormals[index]) geometry.setAttribute("morphNormal" + i, morphNormals[index]);
                    morphInfluences[i] = value;
                    morphInfluencesSum += value;
                } else {
                    if (morphTargets && geometry.hasAttribute("morphTarget" + i) === true) geometry.deleteAttribute("morphTarget" + i);
                    if (morphNormals && geometry.hasAttribute("morphNormal" + i) === true) geometry.deleteAttribute("morphNormal" + i);
                    morphInfluences[i] = 0;
                }
            }
            // GLSL shader uses formula baseinfluence * base + sum(target * influence)
            // This allows us to switch between absolute morphs and relative morphs without changing shader code
            // When baseinfluence = 1 - sum(influence), the above is equivalent to sum((target - base) * influence)
            const morphBaseInfluence = geometry.morphTargetsRelative ? 1 : 1 - morphInfluencesSum;
            program.getUniforms().setValue(gl, "morphTargetBaseInfluence", morphBaseInfluence);
            program.getUniforms().setValue(gl, "morphTargetInfluences", morphInfluences);
        }
    }
    return {
        update: update
    };
}
function $9014d97cd777be10$var$WebGLObjects(gl, geometries, attributes, info) {
    let updateMap = new WeakMap();
    function update(object) {
        const frame = info.render.frame;
        const geometry = object.geometry;
        const buffergeometry = geometries.get(object, geometry);
        // Update once per frame
        if (updateMap.get(buffergeometry) !== frame) {
            geometries.update(buffergeometry);
            updateMap.set(buffergeometry, frame);
        }
        if (object.isInstancedMesh) {
            if (object.hasEventListener("dispose", onInstancedMeshDispose) === false) object.addEventListener("dispose", onInstancedMeshDispose);
            if (updateMap.get(object) !== frame) {
                attributes.update(object.instanceMatrix, gl.ARRAY_BUFFER);
                if (object.instanceColor !== null) attributes.update(object.instanceColor, gl.ARRAY_BUFFER);
                updateMap.set(object, frame);
            }
        }
        if (object.isSkinnedMesh) {
            const skeleton = object.skeleton;
            if (updateMap.get(skeleton) !== frame) {
                skeleton.update();
                updateMap.set(skeleton, frame);
            }
        }
        return buffergeometry;
    }
    function dispose() {
        updateMap = new WeakMap();
    }
    function onInstancedMeshDispose(event) {
        const instancedMesh = event.target;
        instancedMesh.removeEventListener("dispose", onInstancedMeshDispose);
        attributes.remove(instancedMesh.instanceMatrix);
        if (instancedMesh.instanceColor !== null) attributes.remove(instancedMesh.instanceColor);
    }
    return {
        update: update,
        dispose: dispose
    };
}
/**
 * Uniforms of a program.
 * Those form a tree structure with a special top-level container for the root,
 * which you get by calling 'new WebGLUniforms( gl, program )'.
 *
 *
 * Properties of inner nodes including the top-level container:
 *
 * .seq - array of nested uniforms
 * .map - nested uniforms by name
 *
 *
 * Methods of all nodes except the top-level container:
 *
 * .setValue( gl, value, [textures] )
 *
 * 		uploads a uniform value(s)
 *  	the 'textures' parameter is needed for sampler uniforms
 *
 *
 * Static methods of the top-level container (textures factorizations):
 *
 * .upload( gl, seq, values, textures )
 *
 * 		sets uniforms in 'seq' to 'values[id].value'
 *
 * .seqWithValue( seq, values ) : filteredSeq
 *
 * 		filters 'seq' entries with corresponding entry in values
 *
 *
 * Methods of the top-level container (textures factorizations):
 *
 * .setValue( gl, name, value, textures )
 *
 * 		sets uniform with  name 'name' to 'value'
 *
 * .setOptional( gl, obj, prop )
 *
 * 		like .set for an optional property of the object
 *
 */ const $9014d97cd777be10$var$emptyTexture = /*@__PURE__*/ new $9014d97cd777be10$export$5431306cf43de24a();
const $9014d97cd777be10$var$emptyArrayTexture = /*@__PURE__*/ new $9014d97cd777be10$export$dfac6c8e811406a3();
const $9014d97cd777be10$var$empty3dTexture = /*@__PURE__*/ new $9014d97cd777be10$export$d7a3086320f856db();
const $9014d97cd777be10$var$emptyCubeTexture = /*@__PURE__*/ new $9014d97cd777be10$export$ee2e5a18258a4049();
// --- Utilities ---
// Array Caches (provide typed arrays for temporary by size)
const $9014d97cd777be10$var$arrayCacheF32 = [];
const $9014d97cd777be10$var$arrayCacheI32 = [];
// Float32Array caches used for uploading Matrix uniforms
const $9014d97cd777be10$var$mat4array = new Float32Array(16);
const $9014d97cd777be10$var$mat3array = new Float32Array(9);
const $9014d97cd777be10$var$mat2array = new Float32Array(4);
// Flattening for arrays of vectors and matrices
function $9014d97cd777be10$var$flatten(array, nBlocks, blockSize) {
    const firstElem = array[0];
    if (firstElem <= 0 || firstElem > 0) return array;
    // unoptimized: ! isNaN( firstElem )
    // see http://jacksondunstan.com/articles/983
    const n = nBlocks * blockSize;
    let r = $9014d97cd777be10$var$arrayCacheF32[n];
    if (r === undefined) {
        r = new Float32Array(n);
        $9014d97cd777be10$var$arrayCacheF32[n] = r;
    }
    if (nBlocks !== 0) {
        firstElem.toArray(r, 0);
        for(let i = 1, offset = 0; i !== nBlocks; ++i){
            offset += blockSize;
            array[i].toArray(r, offset);
        }
    }
    return r;
}
function $9014d97cd777be10$var$arraysEqual(a, b) {
    if (a.length !== b.length) return false;
    for(let i = 0, l = a.length; i < l; i++){
        if (a[i] !== b[i]) return false;
    }
    return true;
}
function $9014d97cd777be10$var$copyArray(a, b) {
    for(let i = 0, l = b.length; i < l; i++)a[i] = b[i];
}
// Texture unit allocation
function $9014d97cd777be10$var$allocTexUnits(textures, n) {
    let r = $9014d97cd777be10$var$arrayCacheI32[n];
    if (r === undefined) {
        r = new Int32Array(n);
        $9014d97cd777be10$var$arrayCacheI32[n] = r;
    }
    for(let i = 0; i !== n; ++i)r[i] = textures.allocateTextureUnit();
    return r;
}
// --- Setters ---
// Note: Defining these methods externally, because they come in a bunch
// and this way their names minify.
// Single scalar
function $9014d97cd777be10$var$setValueV1f(gl, v) {
    const cache = this.cache;
    if (cache[0] === v) return;
    gl.uniform1f(this.addr, v);
    cache[0] = v;
}
// Single float vector (from flat array or THREE.VectorN)
function $9014d97cd777be10$var$setValueV2f(gl, v) {
    const cache = this.cache;
    if (v.x !== undefined) {
        if (cache[0] !== v.x || cache[1] !== v.y) {
            gl.uniform2f(this.addr, v.x, v.y);
            cache[0] = v.x;
            cache[1] = v.y;
        }
    } else {
        if ($9014d97cd777be10$var$arraysEqual(cache, v)) return;
        gl.uniform2fv(this.addr, v);
        $9014d97cd777be10$var$copyArray(cache, v);
    }
}
function $9014d97cd777be10$var$setValueV3f(gl, v) {
    const cache = this.cache;
    if (v.x !== undefined) {
        if (cache[0] !== v.x || cache[1] !== v.y || cache[2] !== v.z) {
            gl.uniform3f(this.addr, v.x, v.y, v.z);
            cache[0] = v.x;
            cache[1] = v.y;
            cache[2] = v.z;
        }
    } else if (v.r !== undefined) {
        if (cache[0] !== v.r || cache[1] !== v.g || cache[2] !== v.b) {
            gl.uniform3f(this.addr, v.r, v.g, v.b);
            cache[0] = v.r;
            cache[1] = v.g;
            cache[2] = v.b;
        }
    } else {
        if ($9014d97cd777be10$var$arraysEqual(cache, v)) return;
        gl.uniform3fv(this.addr, v);
        $9014d97cd777be10$var$copyArray(cache, v);
    }
}
function $9014d97cd777be10$var$setValueV4f(gl, v) {
    const cache = this.cache;
    if (v.x !== undefined) {
        if (cache[0] !== v.x || cache[1] !== v.y || cache[2] !== v.z || cache[3] !== v.w) {
            gl.uniform4f(this.addr, v.x, v.y, v.z, v.w);
            cache[0] = v.x;
            cache[1] = v.y;
            cache[2] = v.z;
            cache[3] = v.w;
        }
    } else {
        if ($9014d97cd777be10$var$arraysEqual(cache, v)) return;
        gl.uniform4fv(this.addr, v);
        $9014d97cd777be10$var$copyArray(cache, v);
    }
}
// Single matrix (from flat array or THREE.MatrixN)
function $9014d97cd777be10$var$setValueM2(gl, v) {
    const cache = this.cache;
    const elements = v.elements;
    if (elements === undefined) {
        if ($9014d97cd777be10$var$arraysEqual(cache, v)) return;
        gl.uniformMatrix2fv(this.addr, false, v);
        $9014d97cd777be10$var$copyArray(cache, v);
    } else {
        if ($9014d97cd777be10$var$arraysEqual(cache, elements)) return;
        $9014d97cd777be10$var$mat2array.set(elements);
        gl.uniformMatrix2fv(this.addr, false, $9014d97cd777be10$var$mat2array);
        $9014d97cd777be10$var$copyArray(cache, elements);
    }
}
function $9014d97cd777be10$var$setValueM3(gl, v) {
    const cache = this.cache;
    const elements = v.elements;
    if (elements === undefined) {
        if ($9014d97cd777be10$var$arraysEqual(cache, v)) return;
        gl.uniformMatrix3fv(this.addr, false, v);
        $9014d97cd777be10$var$copyArray(cache, v);
    } else {
        if ($9014d97cd777be10$var$arraysEqual(cache, elements)) return;
        $9014d97cd777be10$var$mat3array.set(elements);
        gl.uniformMatrix3fv(this.addr, false, $9014d97cd777be10$var$mat3array);
        $9014d97cd777be10$var$copyArray(cache, elements);
    }
}
function $9014d97cd777be10$var$setValueM4(gl, v) {
    const cache = this.cache;
    const elements = v.elements;
    if (elements === undefined) {
        if ($9014d97cd777be10$var$arraysEqual(cache, v)) return;
        gl.uniformMatrix4fv(this.addr, false, v);
        $9014d97cd777be10$var$copyArray(cache, v);
    } else {
        if ($9014d97cd777be10$var$arraysEqual(cache, elements)) return;
        $9014d97cd777be10$var$mat4array.set(elements);
        gl.uniformMatrix4fv(this.addr, false, $9014d97cd777be10$var$mat4array);
        $9014d97cd777be10$var$copyArray(cache, elements);
    }
}
// Single integer / boolean
function $9014d97cd777be10$var$setValueV1i(gl, v) {
    const cache = this.cache;
    if (cache[0] === v) return;
    gl.uniform1i(this.addr, v);
    cache[0] = v;
}
// Single integer / boolean vector (from flat array or THREE.VectorN)
function $9014d97cd777be10$var$setValueV2i(gl, v) {
    const cache = this.cache;
    if (v.x !== undefined) {
        if (cache[0] !== v.x || cache[1] !== v.y) {
            gl.uniform2i(this.addr, v.x, v.y);
            cache[0] = v.x;
            cache[1] = v.y;
        }
    } else {
        if ($9014d97cd777be10$var$arraysEqual(cache, v)) return;
        gl.uniform2iv(this.addr, v);
        $9014d97cd777be10$var$copyArray(cache, v);
    }
}
function $9014d97cd777be10$var$setValueV3i(gl, v) {
    const cache = this.cache;
    if (v.x !== undefined) {
        if (cache[0] !== v.x || cache[1] !== v.y || cache[2] !== v.z) {
            gl.uniform3i(this.addr, v.x, v.y, v.z);
            cache[0] = v.x;
            cache[1] = v.y;
            cache[2] = v.z;
        }
    } else {
        if ($9014d97cd777be10$var$arraysEqual(cache, v)) return;
        gl.uniform3iv(this.addr, v);
        $9014d97cd777be10$var$copyArray(cache, v);
    }
}
function $9014d97cd777be10$var$setValueV4i(gl, v) {
    const cache = this.cache;
    if (v.x !== undefined) {
        if (cache[0] !== v.x || cache[1] !== v.y || cache[2] !== v.z || cache[3] !== v.w) {
            gl.uniform4i(this.addr, v.x, v.y, v.z, v.w);
            cache[0] = v.x;
            cache[1] = v.y;
            cache[2] = v.z;
            cache[3] = v.w;
        }
    } else {
        if ($9014d97cd777be10$var$arraysEqual(cache, v)) return;
        gl.uniform4iv(this.addr, v);
        $9014d97cd777be10$var$copyArray(cache, v);
    }
}
// Single unsigned integer
function $9014d97cd777be10$var$setValueV1ui(gl, v) {
    const cache = this.cache;
    if (cache[0] === v) return;
    gl.uniform1ui(this.addr, v);
    cache[0] = v;
}
// Single unsigned integer vector (from flat array or THREE.VectorN)
function $9014d97cd777be10$var$setValueV2ui(gl, v) {
    const cache = this.cache;
    if (v.x !== undefined) {
        if (cache[0] !== v.x || cache[1] !== v.y) {
            gl.uniform2ui(this.addr, v.x, v.y);
            cache[0] = v.x;
            cache[1] = v.y;
        }
    } else {
        if ($9014d97cd777be10$var$arraysEqual(cache, v)) return;
        gl.uniform2uiv(this.addr, v);
        $9014d97cd777be10$var$copyArray(cache, v);
    }
}
function $9014d97cd777be10$var$setValueV3ui(gl, v) {
    const cache = this.cache;
    if (v.x !== undefined) {
        if (cache[0] !== v.x || cache[1] !== v.y || cache[2] !== v.z) {
            gl.uniform3ui(this.addr, v.x, v.y, v.z);
            cache[0] = v.x;
            cache[1] = v.y;
            cache[2] = v.z;
        }
    } else {
        if ($9014d97cd777be10$var$arraysEqual(cache, v)) return;
        gl.uniform3uiv(this.addr, v);
        $9014d97cd777be10$var$copyArray(cache, v);
    }
}
function $9014d97cd777be10$var$setValueV4ui(gl, v) {
    const cache = this.cache;
    if (v.x !== undefined) {
        if (cache[0] !== v.x || cache[1] !== v.y || cache[2] !== v.z || cache[3] !== v.w) {
            gl.uniform4ui(this.addr, v.x, v.y, v.z, v.w);
            cache[0] = v.x;
            cache[1] = v.y;
            cache[2] = v.z;
            cache[3] = v.w;
        }
    } else {
        if ($9014d97cd777be10$var$arraysEqual(cache, v)) return;
        gl.uniform4uiv(this.addr, v);
        $9014d97cd777be10$var$copyArray(cache, v);
    }
}
// Single texture (2D / Cube)
function $9014d97cd777be10$var$setValueT1(gl, v, textures) {
    const cache = this.cache;
    const unit = textures.allocateTextureUnit();
    if (cache[0] !== unit) {
        gl.uniform1i(this.addr, unit);
        cache[0] = unit;
    }
    textures.setTexture2D(v || $9014d97cd777be10$var$emptyTexture, unit);
}
function $9014d97cd777be10$var$setValueT3D1(gl, v, textures) {
    const cache = this.cache;
    const unit = textures.allocateTextureUnit();
    if (cache[0] !== unit) {
        gl.uniform1i(this.addr, unit);
        cache[0] = unit;
    }
    textures.setTexture3D(v || $9014d97cd777be10$var$empty3dTexture, unit);
}
function $9014d97cd777be10$var$setValueT6(gl, v, textures) {
    const cache = this.cache;
    const unit = textures.allocateTextureUnit();
    if (cache[0] !== unit) {
        gl.uniform1i(this.addr, unit);
        cache[0] = unit;
    }
    textures.setTextureCube(v || $9014d97cd777be10$var$emptyCubeTexture, unit);
}
function $9014d97cd777be10$var$setValueT2DArray1(gl, v, textures) {
    const cache = this.cache;
    const unit = textures.allocateTextureUnit();
    if (cache[0] !== unit) {
        gl.uniform1i(this.addr, unit);
        cache[0] = unit;
    }
    textures.setTexture2DArray(v || $9014d97cd777be10$var$emptyArrayTexture, unit);
}
// Helper to pick the right setter for the singular case
function $9014d97cd777be10$var$getSingularSetter(type) {
    switch(type){
        case 0x1406:
            return $9014d97cd777be10$var$setValueV1f; // FLOAT
        case 0x8b50:
            return $9014d97cd777be10$var$setValueV2f; // _VEC2
        case 0x8b51:
            return $9014d97cd777be10$var$setValueV3f; // _VEC3
        case 0x8b52:
            return $9014d97cd777be10$var$setValueV4f; // _VEC4
        case 0x8b5a:
            return $9014d97cd777be10$var$setValueM2; // _MAT2
        case 0x8b5b:
            return $9014d97cd777be10$var$setValueM3; // _MAT3
        case 0x8b5c:
            return $9014d97cd777be10$var$setValueM4; // _MAT4
        case 0x1404:
        case 0x8b56:
            return $9014d97cd777be10$var$setValueV1i; // INT, BOOL
        case 0x8b53:
        case 0x8b57:
            return $9014d97cd777be10$var$setValueV2i; // _VEC2
        case 0x8b54:
        case 0x8b58:
            return $9014d97cd777be10$var$setValueV3i; // _VEC3
        case 0x8b55:
        case 0x8b59:
            return $9014d97cd777be10$var$setValueV4i; // _VEC4
        case 0x1405:
            return $9014d97cd777be10$var$setValueV1ui; // UINT
        case 0x8dc6:
            return $9014d97cd777be10$var$setValueV2ui; // _VEC2
        case 0x8dc7:
            return $9014d97cd777be10$var$setValueV3ui; // _VEC3
        case 0x8dc8:
            return $9014d97cd777be10$var$setValueV4ui; // _VEC4
        case 0x8b5e:
        case 0x8d66:
        case 0x8dca:
        case 0x8dd2:
        case 0x8b62:
            return $9014d97cd777be10$var$setValueT1;
        case 0x8b5f:
        case 0x8dcb:
        case 0x8dd3:
            return $9014d97cd777be10$var$setValueT3D1;
        case 0x8b60:
        case 0x8dcc:
        case 0x8dd4:
        case 0x8dc5:
            return $9014d97cd777be10$var$setValueT6;
        case 0x8dc1:
        case 0x8dcf:
        case 0x8dd7:
        case 0x8dc4:
            return $9014d97cd777be10$var$setValueT2DArray1;
    }
}
// Array of scalars
function $9014d97cd777be10$var$setValueV1fArray(gl, v) {
    gl.uniform1fv(this.addr, v);
}
// Array of vectors (from flat array or array of THREE.VectorN)
function $9014d97cd777be10$var$setValueV2fArray(gl, v) {
    const data = $9014d97cd777be10$var$flatten(v, this.size, 2);
    gl.uniform2fv(this.addr, data);
}
function $9014d97cd777be10$var$setValueV3fArray(gl, v) {
    const data = $9014d97cd777be10$var$flatten(v, this.size, 3);
    gl.uniform3fv(this.addr, data);
}
function $9014d97cd777be10$var$setValueV4fArray(gl, v) {
    const data = $9014d97cd777be10$var$flatten(v, this.size, 4);
    gl.uniform4fv(this.addr, data);
}
// Array of matrices (from flat array or array of THREE.MatrixN)
function $9014d97cd777be10$var$setValueM2Array(gl, v) {
    const data = $9014d97cd777be10$var$flatten(v, this.size, 4);
    gl.uniformMatrix2fv(this.addr, false, data);
}
function $9014d97cd777be10$var$setValueM3Array(gl, v) {
    const data = $9014d97cd777be10$var$flatten(v, this.size, 9);
    gl.uniformMatrix3fv(this.addr, false, data);
}
function $9014d97cd777be10$var$setValueM4Array(gl, v) {
    const data = $9014d97cd777be10$var$flatten(v, this.size, 16);
    gl.uniformMatrix4fv(this.addr, false, data);
}
// Array of integer / boolean
function $9014d97cd777be10$var$setValueV1iArray(gl, v) {
    gl.uniform1iv(this.addr, v);
}
// Array of integer / boolean vectors (from flat array)
function $9014d97cd777be10$var$setValueV2iArray(gl, v) {
    gl.uniform2iv(this.addr, v);
}
function $9014d97cd777be10$var$setValueV3iArray(gl, v) {
    gl.uniform3iv(this.addr, v);
}
function $9014d97cd777be10$var$setValueV4iArray(gl, v) {
    gl.uniform4iv(this.addr, v);
}
// Array of unsigned integer
function $9014d97cd777be10$var$setValueV1uiArray(gl, v) {
    gl.uniform1uiv(this.addr, v);
}
// Array of unsigned integer vectors (from flat array)
function $9014d97cd777be10$var$setValueV2uiArray(gl, v) {
    gl.uniform2uiv(this.addr, v);
}
function $9014d97cd777be10$var$setValueV3uiArray(gl, v) {
    gl.uniform3uiv(this.addr, v);
}
function $9014d97cd777be10$var$setValueV4uiArray(gl, v) {
    gl.uniform4uiv(this.addr, v);
}
// Array of textures (2D / 3D / Cube / 2DArray)
function $9014d97cd777be10$var$setValueT1Array(gl, v, textures) {
    const cache = this.cache;
    const n = v.length;
    const units = $9014d97cd777be10$var$allocTexUnits(textures, n);
    if (!$9014d97cd777be10$var$arraysEqual(cache, units)) {
        gl.uniform1iv(this.addr, units);
        $9014d97cd777be10$var$copyArray(cache, units);
    }
    for(let i = 0; i !== n; ++i)textures.setTexture2D(v[i] || $9014d97cd777be10$var$emptyTexture, units[i]);
}
function $9014d97cd777be10$var$setValueT3DArray(gl, v, textures) {
    const cache = this.cache;
    const n = v.length;
    const units = $9014d97cd777be10$var$allocTexUnits(textures, n);
    if (!$9014d97cd777be10$var$arraysEqual(cache, units)) {
        gl.uniform1iv(this.addr, units);
        $9014d97cd777be10$var$copyArray(cache, units);
    }
    for(let i = 0; i !== n; ++i)textures.setTexture3D(v[i] || $9014d97cd777be10$var$empty3dTexture, units[i]);
}
function $9014d97cd777be10$var$setValueT6Array(gl, v, textures) {
    const cache = this.cache;
    const n = v.length;
    const units = $9014d97cd777be10$var$allocTexUnits(textures, n);
    if (!$9014d97cd777be10$var$arraysEqual(cache, units)) {
        gl.uniform1iv(this.addr, units);
        $9014d97cd777be10$var$copyArray(cache, units);
    }
    for(let i = 0; i !== n; ++i)textures.setTextureCube(v[i] || $9014d97cd777be10$var$emptyCubeTexture, units[i]);
}
function $9014d97cd777be10$var$setValueT2DArrayArray(gl, v, textures) {
    const cache = this.cache;
    const n = v.length;
    const units = $9014d97cd777be10$var$allocTexUnits(textures, n);
    if (!$9014d97cd777be10$var$arraysEqual(cache, units)) {
        gl.uniform1iv(this.addr, units);
        $9014d97cd777be10$var$copyArray(cache, units);
    }
    for(let i = 0; i !== n; ++i)textures.setTexture2DArray(v[i] || $9014d97cd777be10$var$emptyArrayTexture, units[i]);
}
// Helper to pick the right setter for a pure (bottom-level) array
function $9014d97cd777be10$var$getPureArraySetter(type) {
    switch(type){
        case 0x1406:
            return $9014d97cd777be10$var$setValueV1fArray; // FLOAT
        case 0x8b50:
            return $9014d97cd777be10$var$setValueV2fArray; // _VEC2
        case 0x8b51:
            return $9014d97cd777be10$var$setValueV3fArray; // _VEC3
        case 0x8b52:
            return $9014d97cd777be10$var$setValueV4fArray; // _VEC4
        case 0x8b5a:
            return $9014d97cd777be10$var$setValueM2Array; // _MAT2
        case 0x8b5b:
            return $9014d97cd777be10$var$setValueM3Array; // _MAT3
        case 0x8b5c:
            return $9014d97cd777be10$var$setValueM4Array; // _MAT4
        case 0x1404:
        case 0x8b56:
            return $9014d97cd777be10$var$setValueV1iArray; // INT, BOOL
        case 0x8b53:
        case 0x8b57:
            return $9014d97cd777be10$var$setValueV2iArray; // _VEC2
        case 0x8b54:
        case 0x8b58:
            return $9014d97cd777be10$var$setValueV3iArray; // _VEC3
        case 0x8b55:
        case 0x8b59:
            return $9014d97cd777be10$var$setValueV4iArray; // _VEC4
        case 0x1405:
            return $9014d97cd777be10$var$setValueV1uiArray; // UINT
        case 0x8dc6:
            return $9014d97cd777be10$var$setValueV2uiArray; // _VEC2
        case 0x8dc7:
            return $9014d97cd777be10$var$setValueV3uiArray; // _VEC3
        case 0x8dc8:
            return $9014d97cd777be10$var$setValueV4uiArray; // _VEC4
        case 0x8b5e:
        case 0x8d66:
        case 0x8dca:
        case 0x8dd2:
        case 0x8b62:
            return $9014d97cd777be10$var$setValueT1Array;
        case 0x8b5f:
        case 0x8dcb:
        case 0x8dd3:
            return $9014d97cd777be10$var$setValueT3DArray;
        case 0x8b60:
        case 0x8dcc:
        case 0x8dd4:
        case 0x8dc5:
            return $9014d97cd777be10$var$setValueT6Array;
        case 0x8dc1:
        case 0x8dcf:
        case 0x8dd7:
        case 0x8dc4:
            return $9014d97cd777be10$var$setValueT2DArrayArray;
    }
}
// --- Uniform Classes ---
class $9014d97cd777be10$var$SingleUniform {
    constructor(id, activeInfo, addr){
        this.id = id;
        this.addr = addr;
        this.cache = [];
        this.setValue = $9014d97cd777be10$var$getSingularSetter(activeInfo.type);
    // this.path = activeInfo.name; // DEBUG
    }
}
class $9014d97cd777be10$var$PureArrayUniform {
    constructor(id, activeInfo, addr){
        this.id = id;
        this.addr = addr;
        this.cache = [];
        this.size = activeInfo.size;
        this.setValue = $9014d97cd777be10$var$getPureArraySetter(activeInfo.type);
    // this.path = activeInfo.name; // DEBUG
    }
}
class $9014d97cd777be10$var$StructuredUniform {
    setValue(gl, value, textures) {
        const seq = this.seq;
        for(let i = 0, n = seq.length; i !== n; ++i){
            const u = seq[i];
            u.setValue(gl, value[u.id], textures);
        }
    }
    constructor(id){
        this.id = id;
        this.seq = [];
        this.map = {};
    }
}
// --- Top-level ---
// Parser - builds up the property tree from the path strings
const $9014d97cd777be10$var$RePathPart = /(\w+)(\])?(\[|\.)?/g;
// extracts
// 	- the identifier (member name or array index)
//  - followed by an optional right bracket (found when array index)
//  - followed by an optional left bracket or dot (type of subscript)
//
// Note: These portions can be read in a non-overlapping fashion and
// allow straightforward parsing of the hierarchy that WebGL encodes
// in the uniform names.
function $9014d97cd777be10$var$addUniform(container, uniformObject) {
    container.seq.push(uniformObject);
    container.map[uniformObject.id] = uniformObject;
}
function $9014d97cd777be10$var$parseUniform(activeInfo, addr, container) {
    const path = activeInfo.name, pathLength = path.length;
    // reset RegExp object, because of the early exit of a previous run
    $9014d97cd777be10$var$RePathPart.lastIndex = 0;
    while(true){
        const match = $9014d97cd777be10$var$RePathPart.exec(path), matchEnd = $9014d97cd777be10$var$RePathPart.lastIndex;
        let id = match[1];
        const idIsIndex = match[2] === "]", subscript = match[3];
        if (idIsIndex) id = id | 0; // convert to integer
        if (subscript === undefined || subscript === "[" && matchEnd + 2 === pathLength) {
            // bare name or "pure" bottom-level array "[0]" suffix
            $9014d97cd777be10$var$addUniform(container, subscript === undefined ? new $9014d97cd777be10$var$SingleUniform(id, activeInfo, addr) : new $9014d97cd777be10$var$PureArrayUniform(id, activeInfo, addr));
            break;
        } else {
            // step into inner node / create it in case it doesn't exist
            const map = container.map;
            let next = map[id];
            if (next === undefined) {
                next = new $9014d97cd777be10$var$StructuredUniform(id);
                $9014d97cd777be10$var$addUniform(container, next);
            }
            container = next;
        }
    }
}
// Root Container
class $9014d97cd777be10$var$WebGLUniforms {
    setValue(gl, name, value, textures) {
        const u = this.map[name];
        if (u !== undefined) u.setValue(gl, value, textures);
    }
    setOptional(gl, object, name) {
        const v = object[name];
        if (v !== undefined) this.setValue(gl, name, v);
    }
    static upload(gl, seq, values, textures) {
        for(let i = 0, n = seq.length; i !== n; ++i){
            const u = seq[i], v = values[u.id];
            if (v.needsUpdate !== false) // note: always updating when .needsUpdate is undefined
            u.setValue(gl, v.value, textures);
        }
    }
    static seqWithValue(seq, values) {
        const r = [];
        for(let i = 0, n = seq.length; i !== n; ++i){
            const u = seq[i];
            if (u.id in values) r.push(u);
        }
        return r;
    }
    constructor(gl, program){
        this.seq = [];
        this.map = {};
        const n = gl.getProgramParameter(program, gl.ACTIVE_UNIFORMS);
        for(let i = 0; i < n; ++i){
            const info = gl.getActiveUniform(program, i), addr = gl.getUniformLocation(program, info.name);
            $9014d97cd777be10$var$parseUniform(info, addr, this);
        }
    }
}
function $9014d97cd777be10$var$WebGLShader(gl, type, string) {
    const shader = gl.createShader(type);
    gl.shaderSource(shader, string);
    gl.compileShader(shader);
    return shader;
}
let $9014d97cd777be10$var$programIdCount = 0;
function $9014d97cd777be10$var$handleSource(string, errorLine) {
    const lines = string.split("\n");
    const lines2 = [];
    const from = Math.max(errorLine - 6, 0);
    const to = Math.min(errorLine + 6, lines.length);
    for(let i = from; i < to; i++){
        const line = i + 1;
        lines2.push(`${line === errorLine ? ">" : " "} ${line}: ${lines[i]}`);
    }
    return lines2.join("\n");
}
function $9014d97cd777be10$var$getEncodingComponents(colorSpace1) {
    switch(colorSpace1){
        case $9014d97cd777be10$export$42429b3acfb233a4:
            return [
                "Linear",
                "( value )"
            ];
        case $9014d97cd777be10$export$561f394b24edfcaa:
            return [
                "sRGB",
                "( value )"
            ];
        default:
            console.warn("THREE.WebGLProgram: Unsupported color space:", colorSpace1);
            return [
                "Linear",
                "( value )"
            ];
    }
}
function $9014d97cd777be10$var$getShaderErrors(gl, shader, type) {
    const status = gl.getShaderParameter(shader, gl.COMPILE_STATUS);
    const errors = gl.getShaderInfoLog(shader).trim();
    if (status && errors === "") return "";
    const errorMatches = /ERROR: 0:(\d+)/.exec(errors);
    if (errorMatches) {
        // --enable-privileged-webgl-extension
        // console.log( '**' + type + '**', gl.getExtension( 'WEBGL_debug_shaders' ).getTranslatedShaderSource( shader ) );
        const errorLine = parseInt(errorMatches[1]);
        return type.toUpperCase() + "\n\n" + errors + "\n\n" + $9014d97cd777be10$var$handleSource(gl.getShaderSource(shader), errorLine);
    } else return errors;
}
function $9014d97cd777be10$var$getTexelEncodingFunction(functionName, colorSpace1) {
    const components = $9014d97cd777be10$var$getEncodingComponents(colorSpace1);
    return "vec4 " + functionName + "( vec4 value ) { return LinearTo" + components[0] + components[1] + "; }";
}
function $9014d97cd777be10$var$getToneMappingFunction(functionName, toneMapping) {
    let toneMappingName;
    switch(toneMapping){
        case $9014d97cd777be10$export$98f52c2a46c598ca:
            toneMappingName = "Linear";
            break;
        case $9014d97cd777be10$export$74b25e54b3bcd548:
            toneMappingName = "Reinhard";
            break;
        case $9014d97cd777be10$export$932b3dd283d4a366:
            toneMappingName = "OptimizedCineon";
            break;
        case $9014d97cd777be10$export$a0d98fe6d7e4af64:
            toneMappingName = "ACESFilmic";
            break;
        case $9014d97cd777be10$export$2c7b09c1e9abfb5e:
            toneMappingName = "Custom";
            break;
        default:
            console.warn("THREE.WebGLProgram: Unsupported toneMapping:", toneMapping);
            toneMappingName = "Linear";
    }
    return "vec3 " + functionName + "( vec3 color ) { return " + toneMappingName + "ToneMapping( color ); }";
}
function $9014d97cd777be10$var$generateExtensions(parameters) {
    const chunks = [
        parameters.extensionDerivatives || !!parameters.envMapCubeUVHeight || parameters.bumpMap || parameters.normalMapTangentSpace || parameters.clearcoatNormalMap || parameters.flatShading || parameters.shaderID === "physical" ? "#extension GL_OES_standard_derivatives : enable" : "",
        (parameters.extensionFragDepth || parameters.logarithmicDepthBuffer) && parameters.rendererExtensionFragDepth ? "#extension GL_EXT_frag_depth : enable" : "",
        parameters.extensionDrawBuffers && parameters.rendererExtensionDrawBuffers ? "#extension GL_EXT_draw_buffers : require" : "",
        (parameters.extensionShaderTextureLOD || parameters.envMap || parameters.transmission) && parameters.rendererExtensionShaderTextureLod ? "#extension GL_EXT_shader_texture_lod : enable" : ""
    ];
    return chunks.filter($9014d97cd777be10$var$filterEmptyLine).join("\n");
}
function $9014d97cd777be10$var$generateDefines(defines) {
    const chunks = [];
    for(const name in defines){
        const value = defines[name];
        if (value === false) continue;
        chunks.push("#define " + name + " " + value);
    }
    return chunks.join("\n");
}
function $9014d97cd777be10$var$fetchAttributeLocations(gl, program) {
    const attributes = {};
    const n = gl.getProgramParameter(program, gl.ACTIVE_ATTRIBUTES);
    for(let i = 0; i < n; i++){
        const info = gl.getActiveAttrib(program, i);
        const name = info.name;
        let locationSize = 1;
        if (info.type === gl.FLOAT_MAT2) locationSize = 2;
        if (info.type === gl.FLOAT_MAT3) locationSize = 3;
        if (info.type === gl.FLOAT_MAT4) locationSize = 4;
        // console.log( 'THREE.WebGLProgram: ACTIVE VERTEX ATTRIBUTE:', name, i );
        attributes[name] = {
            type: info.type,
            location: gl.getAttribLocation(program, name),
            locationSize: locationSize
        };
    }
    return attributes;
}
function $9014d97cd777be10$var$filterEmptyLine(string) {
    return string !== "";
}
function $9014d97cd777be10$var$replaceLightNums(string, parameters) {
    const numSpotLightCoords = parameters.numSpotLightShadows + parameters.numSpotLightMaps - parameters.numSpotLightShadowsWithMaps;
    return string.replace(/NUM_DIR_LIGHTS/g, parameters.numDirLights).replace(/NUM_SPOT_LIGHTS/g, parameters.numSpotLights).replace(/NUM_SPOT_LIGHT_MAPS/g, parameters.numSpotLightMaps).replace(/NUM_SPOT_LIGHT_COORDS/g, numSpotLightCoords).replace(/NUM_RECT_AREA_LIGHTS/g, parameters.numRectAreaLights).replace(/NUM_POINT_LIGHTS/g, parameters.numPointLights).replace(/NUM_HEMI_LIGHTS/g, parameters.numHemiLights).replace(/NUM_DIR_LIGHT_SHADOWS/g, parameters.numDirLightShadows).replace(/NUM_SPOT_LIGHT_SHADOWS_WITH_MAPS/g, parameters.numSpotLightShadowsWithMaps).replace(/NUM_SPOT_LIGHT_SHADOWS/g, parameters.numSpotLightShadows).replace(/NUM_POINT_LIGHT_SHADOWS/g, parameters.numPointLightShadows);
}
function $9014d97cd777be10$var$replaceClippingPlaneNums(string, parameters) {
    return string.replace(/NUM_CLIPPING_PLANES/g, parameters.numClippingPlanes).replace(/UNION_CLIPPING_PLANES/g, parameters.numClippingPlanes - parameters.numClipIntersection);
}
// Resolve Includes
const $9014d97cd777be10$var$includePattern = /^[ \t]*#include +<([\w\d./]+)>/gm;
function $9014d97cd777be10$var$resolveIncludes(string) {
    return string.replace($9014d97cd777be10$var$includePattern, $9014d97cd777be10$var$includeReplacer);
}
const $9014d97cd777be10$var$shaderChunkMap = new Map([
    [
        "encodings_fragment",
        "colorspace_fragment"
    ],
    [
        "encodings_pars_fragment",
        "colorspace_pars_fragment"
    ],
    [
        "output_fragment",
        "opaque_fragment"
    ]
]);
function $9014d97cd777be10$var$includeReplacer(match, include) {
    let string = $9014d97cd777be10$export$955f9f2e84c43c8b[include];
    if (string === undefined) {
        const newInclude = $9014d97cd777be10$var$shaderChunkMap.get(include);
        if (newInclude !== undefined) {
            string = $9014d97cd777be10$export$955f9f2e84c43c8b[newInclude];
            console.warn('THREE.WebGLRenderer: Shader chunk "%s" has been deprecated. Use "%s" instead.', include, newInclude);
        } else throw new Error("Can not resolve #include <" + include + ">");
    }
    return $9014d97cd777be10$var$resolveIncludes(string);
}
// Unroll Loops
const $9014d97cd777be10$var$unrollLoopPattern = /#pragma unroll_loop_start\s+for\s*\(\s*int\s+i\s*=\s*(\d+)\s*;\s*i\s*<\s*(\d+)\s*;\s*i\s*\+\+\s*\)\s*{([\s\S]+?)}\s+#pragma unroll_loop_end/g;
function $9014d97cd777be10$var$unrollLoops(string) {
    return string.replace($9014d97cd777be10$var$unrollLoopPattern, $9014d97cd777be10$var$loopReplacer);
}
function $9014d97cd777be10$var$loopReplacer(match, start, end, snippet) {
    let string = "";
    for(let i = parseInt(start); i < parseInt(end); i++)string += snippet.replace(/\[\s*i\s*\]/g, "[ " + i + " ]").replace(/UNROLLED_LOOP_INDEX/g, i);
    return string;
}
//
function $9014d97cd777be10$var$generatePrecision(parameters) {
    let precisionstring = "precision " + parameters.precision + " float;\nprecision " + parameters.precision + " int;";
    if (parameters.precision === "highp") precisionstring += "\n#define HIGH_PRECISION";
    else if (parameters.precision === "mediump") precisionstring += "\n#define MEDIUM_PRECISION";
    else if (parameters.precision === "lowp") precisionstring += "\n#define LOW_PRECISION";
    return precisionstring;
}
function $9014d97cd777be10$var$generateShadowMapTypeDefine(parameters) {
    let shadowMapTypeDefine = "SHADOWMAP_TYPE_BASIC";
    if (parameters.shadowMapType === $9014d97cd777be10$export$5813f879eee7cd88) shadowMapTypeDefine = "SHADOWMAP_TYPE_PCF";
    else if (parameters.shadowMapType === $9014d97cd777be10$export$a47c4b43a1be34f0) shadowMapTypeDefine = "SHADOWMAP_TYPE_PCF_SOFT";
    else if (parameters.shadowMapType === $9014d97cd777be10$export$896ae1ade6c829c4) shadowMapTypeDefine = "SHADOWMAP_TYPE_VSM";
    return shadowMapTypeDefine;
}
function $9014d97cd777be10$var$generateEnvMapTypeDefine(parameters) {
    let envMapTypeDefine = "ENVMAP_TYPE_CUBE";
    if (parameters.envMap) switch(parameters.envMapMode){
        case $9014d97cd777be10$export$8759762a6477f2c4:
        case $9014d97cd777be10$export$dc59f8aed047f61d:
            envMapTypeDefine = "ENVMAP_TYPE_CUBE";
            break;
        case $9014d97cd777be10$export$dbf3e70ff37af79:
            envMapTypeDefine = "ENVMAP_TYPE_CUBE_UV";
            break;
    }
    return envMapTypeDefine;
}
function $9014d97cd777be10$var$generateEnvMapModeDefine(parameters) {
    let envMapModeDefine = "ENVMAP_MODE_REFLECTION";
    if (parameters.envMap) switch(parameters.envMapMode){
        case $9014d97cd777be10$export$dc59f8aed047f61d:
            envMapModeDefine = "ENVMAP_MODE_REFRACTION";
            break;
    }
    return envMapModeDefine;
}
function $9014d97cd777be10$var$generateEnvMapBlendingDefine(parameters) {
    let envMapBlendingDefine = "ENVMAP_BLENDING_NONE";
    if (parameters.envMap) switch(parameters.combine){
        case $9014d97cd777be10$export$e50ac29801f1774d:
            envMapBlendingDefine = "ENVMAP_BLENDING_MULTIPLY";
            break;
        case $9014d97cd777be10$export$9f9d94f963c85479:
            envMapBlendingDefine = "ENVMAP_BLENDING_MIX";
            break;
        case $9014d97cd777be10$export$e641dc52bc3494aa:
            envMapBlendingDefine = "ENVMAP_BLENDING_ADD";
            break;
    }
    return envMapBlendingDefine;
}
function $9014d97cd777be10$var$generateCubeUVSize(parameters) {
    const imageHeight = parameters.envMapCubeUVHeight;
    if (imageHeight === null) return null;
    const maxMip = Math.log2(imageHeight) - 2;
    const texelHeight = 1.0 / imageHeight;
    const texelWidth = 1.0 / (3 * Math.max(Math.pow(2, maxMip), 112));
    return {
        texelWidth: texelWidth,
        texelHeight: texelHeight,
        maxMip: maxMip
    };
}
function $9014d97cd777be10$var$WebGLProgram(renderer, cacheKey, parameters, bindingStates) {
    // TODO Send this event to Three.js DevTools
    // console.log( 'WebGLProgram', cacheKey );
    const gl = renderer.getContext();
    const defines = parameters.defines;
    let vertexShader = parameters.vertexShader;
    let fragmentShader = parameters.fragmentShader;
    const shadowMapTypeDefine = $9014d97cd777be10$var$generateShadowMapTypeDefine(parameters);
    const envMapTypeDefine = $9014d97cd777be10$var$generateEnvMapTypeDefine(parameters);
    const envMapModeDefine = $9014d97cd777be10$var$generateEnvMapModeDefine(parameters);
    const envMapBlendingDefine = $9014d97cd777be10$var$generateEnvMapBlendingDefine(parameters);
    const envMapCubeUVSize = $9014d97cd777be10$var$generateCubeUVSize(parameters);
    const customExtensions = parameters.isWebGL2 ? "" : $9014d97cd777be10$var$generateExtensions(parameters);
    const customDefines = $9014d97cd777be10$var$generateDefines(defines);
    const program = gl.createProgram();
    let prefixVertex, prefixFragment;
    let versionString = parameters.glslVersion ? "#version " + parameters.glslVersion + "\n" : "";
    if (parameters.isRawShaderMaterial) {
        prefixVertex = [
            "#define SHADER_TYPE " + parameters.shaderType,
            "#define SHADER_NAME " + parameters.shaderName,
            customDefines
        ].filter($9014d97cd777be10$var$filterEmptyLine).join("\n");
        if (prefixVertex.length > 0) prefixVertex += "\n";
        prefixFragment = [
            customExtensions,
            "#define SHADER_TYPE " + parameters.shaderType,
            "#define SHADER_NAME " + parameters.shaderName,
            customDefines
        ].filter($9014d97cd777be10$var$filterEmptyLine).join("\n");
        if (prefixFragment.length > 0) prefixFragment += "\n";
    } else {
        prefixVertex = [
            $9014d97cd777be10$var$generatePrecision(parameters),
            "#define SHADER_TYPE " + parameters.shaderType,
            "#define SHADER_NAME " + parameters.shaderName,
            customDefines,
            parameters.instancing ? "#define USE_INSTANCING" : "",
            parameters.instancingColor ? "#define USE_INSTANCING_COLOR" : "",
            parameters.useFog && parameters.fog ? "#define USE_FOG" : "",
            parameters.useFog && parameters.fogExp2 ? "#define FOG_EXP2" : "",
            parameters.map ? "#define USE_MAP" : "",
            parameters.envMap ? "#define USE_ENVMAP" : "",
            parameters.envMap ? "#define " + envMapModeDefine : "",
            parameters.lightMap ? "#define USE_LIGHTMAP" : "",
            parameters.aoMap ? "#define USE_AOMAP" : "",
            parameters.bumpMap ? "#define USE_BUMPMAP" : "",
            parameters.normalMap ? "#define USE_NORMALMAP" : "",
            parameters.normalMapObjectSpace ? "#define USE_NORMALMAP_OBJECTSPACE" : "",
            parameters.normalMapTangentSpace ? "#define USE_NORMALMAP_TANGENTSPACE" : "",
            parameters.displacementMap ? "#define USE_DISPLACEMENTMAP" : "",
            parameters.emissiveMap ? "#define USE_EMISSIVEMAP" : "",
            parameters.anisotropyMap ? "#define USE_ANISOTROPYMAP" : "",
            parameters.clearcoatMap ? "#define USE_CLEARCOATMAP" : "",
            parameters.clearcoatRoughnessMap ? "#define USE_CLEARCOAT_ROUGHNESSMAP" : "",
            parameters.clearcoatNormalMap ? "#define USE_CLEARCOAT_NORMALMAP" : "",
            parameters.iridescenceMap ? "#define USE_IRIDESCENCEMAP" : "",
            parameters.iridescenceThicknessMap ? "#define USE_IRIDESCENCE_THICKNESSMAP" : "",
            parameters.specularMap ? "#define USE_SPECULARMAP" : "",
            parameters.specularColorMap ? "#define USE_SPECULAR_COLORMAP" : "",
            parameters.specularIntensityMap ? "#define USE_SPECULAR_INTENSITYMAP" : "",
            parameters.roughnessMap ? "#define USE_ROUGHNESSMAP" : "",
            parameters.metalnessMap ? "#define USE_METALNESSMAP" : "",
            parameters.alphaMap ? "#define USE_ALPHAMAP" : "",
            parameters.alphaHash ? "#define USE_ALPHAHASH" : "",
            parameters.transmission ? "#define USE_TRANSMISSION" : "",
            parameters.transmissionMap ? "#define USE_TRANSMISSIONMAP" : "",
            parameters.thicknessMap ? "#define USE_THICKNESSMAP" : "",
            parameters.sheenColorMap ? "#define USE_SHEEN_COLORMAP" : "",
            parameters.sheenRoughnessMap ? "#define USE_SHEEN_ROUGHNESSMAP" : "",
            //
            parameters.mapUv ? "#define MAP_UV " + parameters.mapUv : "",
            parameters.alphaMapUv ? "#define ALPHAMAP_UV " + parameters.alphaMapUv : "",
            parameters.lightMapUv ? "#define LIGHTMAP_UV " + parameters.lightMapUv : "",
            parameters.aoMapUv ? "#define AOMAP_UV " + parameters.aoMapUv : "",
            parameters.emissiveMapUv ? "#define EMISSIVEMAP_UV " + parameters.emissiveMapUv : "",
            parameters.bumpMapUv ? "#define BUMPMAP_UV " + parameters.bumpMapUv : "",
            parameters.normalMapUv ? "#define NORMALMAP_UV " + parameters.normalMapUv : "",
            parameters.displacementMapUv ? "#define DISPLACEMENTMAP_UV " + parameters.displacementMapUv : "",
            parameters.metalnessMapUv ? "#define METALNESSMAP_UV " + parameters.metalnessMapUv : "",
            parameters.roughnessMapUv ? "#define ROUGHNESSMAP_UV " + parameters.roughnessMapUv : "",
            parameters.anisotropyMapUv ? "#define ANISOTROPYMAP_UV " + parameters.anisotropyMapUv : "",
            parameters.clearcoatMapUv ? "#define CLEARCOATMAP_UV " + parameters.clearcoatMapUv : "",
            parameters.clearcoatNormalMapUv ? "#define CLEARCOAT_NORMALMAP_UV " + parameters.clearcoatNormalMapUv : "",
            parameters.clearcoatRoughnessMapUv ? "#define CLEARCOAT_ROUGHNESSMAP_UV " + parameters.clearcoatRoughnessMapUv : "",
            parameters.iridescenceMapUv ? "#define IRIDESCENCEMAP_UV " + parameters.iridescenceMapUv : "",
            parameters.iridescenceThicknessMapUv ? "#define IRIDESCENCE_THICKNESSMAP_UV " + parameters.iridescenceThicknessMapUv : "",
            parameters.sheenColorMapUv ? "#define SHEEN_COLORMAP_UV " + parameters.sheenColorMapUv : "",
            parameters.sheenRoughnessMapUv ? "#define SHEEN_ROUGHNESSMAP_UV " + parameters.sheenRoughnessMapUv : "",
            parameters.specularMapUv ? "#define SPECULARMAP_UV " + parameters.specularMapUv : "",
            parameters.specularColorMapUv ? "#define SPECULAR_COLORMAP_UV " + parameters.specularColorMapUv : "",
            parameters.specularIntensityMapUv ? "#define SPECULAR_INTENSITYMAP_UV " + parameters.specularIntensityMapUv : "",
            parameters.transmissionMapUv ? "#define TRANSMISSIONMAP_UV " + parameters.transmissionMapUv : "",
            parameters.thicknessMapUv ? "#define THICKNESSMAP_UV " + parameters.thicknessMapUv : "",
            //
            parameters.vertexTangents && parameters.flatShading === false ? "#define USE_TANGENT" : "",
            parameters.vertexColors ? "#define USE_COLOR" : "",
            parameters.vertexAlphas ? "#define USE_COLOR_ALPHA" : "",
            parameters.vertexUv1s ? "#define USE_UV1" : "",
            parameters.vertexUv2s ? "#define USE_UV2" : "",
            parameters.vertexUv3s ? "#define USE_UV3" : "",
            parameters.pointsUvs ? "#define USE_POINTS_UV" : "",
            parameters.flatShading ? "#define FLAT_SHADED" : "",
            parameters.skinning ? "#define USE_SKINNING" : "",
            parameters.morphTargets ? "#define USE_MORPHTARGETS" : "",
            parameters.morphNormals && parameters.flatShading === false ? "#define USE_MORPHNORMALS" : "",
            parameters.morphColors && parameters.isWebGL2 ? "#define USE_MORPHCOLORS" : "",
            parameters.morphTargetsCount > 0 && parameters.isWebGL2 ? "#define MORPHTARGETS_TEXTURE" : "",
            parameters.morphTargetsCount > 0 && parameters.isWebGL2 ? "#define MORPHTARGETS_TEXTURE_STRIDE " + parameters.morphTextureStride : "",
            parameters.morphTargetsCount > 0 && parameters.isWebGL2 ? "#define MORPHTARGETS_COUNT " + parameters.morphTargetsCount : "",
            parameters.doubleSided ? "#define DOUBLE_SIDED" : "",
            parameters.flipSided ? "#define FLIP_SIDED" : "",
            parameters.shadowMapEnabled ? "#define USE_SHADOWMAP" : "",
            parameters.shadowMapEnabled ? "#define " + shadowMapTypeDefine : "",
            parameters.sizeAttenuation ? "#define USE_SIZEATTENUATION" : "",
            parameters.useLegacyLights ? "#define LEGACY_LIGHTS" : "",
            parameters.logarithmicDepthBuffer ? "#define USE_LOGDEPTHBUF" : "",
            parameters.logarithmicDepthBuffer && parameters.rendererExtensionFragDepth ? "#define USE_LOGDEPTHBUF_EXT" : "",
            "uniform mat4 modelMatrix;",
            "uniform mat4 modelViewMatrix;",
            "uniform mat4 projectionMatrix;",
            "uniform mat4 viewMatrix;",
            "uniform mat3 normalMatrix;",
            "uniform vec3 cameraPosition;",
            "uniform bool isOrthographic;",
            "#ifdef USE_INSTANCING",
            "	attribute mat4 instanceMatrix;",
            "#endif",
            "#ifdef USE_INSTANCING_COLOR",
            "	attribute vec3 instanceColor;",
            "#endif",
            "attribute vec3 position;",
            "attribute vec3 normal;",
            "attribute vec2 uv;",
            "#ifdef USE_UV1",
            "	attribute vec2 uv1;",
            "#endif",
            "#ifdef USE_UV2",
            "	attribute vec2 uv2;",
            "#endif",
            "#ifdef USE_UV3",
            "	attribute vec2 uv3;",
            "#endif",
            "#ifdef USE_TANGENT",
            "	attribute vec4 tangent;",
            "#endif",
            "#if defined( USE_COLOR_ALPHA )",
            "	attribute vec4 color;",
            "#elif defined( USE_COLOR )",
            "	attribute vec3 color;",
            "#endif",
            "#if ( defined( USE_MORPHTARGETS ) && ! defined( MORPHTARGETS_TEXTURE ) )",
            "	attribute vec3 morphTarget0;",
            "	attribute vec3 morphTarget1;",
            "	attribute vec3 morphTarget2;",
            "	attribute vec3 morphTarget3;",
            "	#ifdef USE_MORPHNORMALS",
            "		attribute vec3 morphNormal0;",
            "		attribute vec3 morphNormal1;",
            "		attribute vec3 morphNormal2;",
            "		attribute vec3 morphNormal3;",
            "	#else",
            "		attribute vec3 morphTarget4;",
            "		attribute vec3 morphTarget5;",
            "		attribute vec3 morphTarget6;",
            "		attribute vec3 morphTarget7;",
            "	#endif",
            "#endif",
            "#ifdef USE_SKINNING",
            "	attribute vec4 skinIndex;",
            "	attribute vec4 skinWeight;",
            "#endif",
            "\n"
        ].filter($9014d97cd777be10$var$filterEmptyLine).join("\n");
        prefixFragment = [
            customExtensions,
            $9014d97cd777be10$var$generatePrecision(parameters),
            "#define SHADER_TYPE " + parameters.shaderType,
            "#define SHADER_NAME " + parameters.shaderName,
            customDefines,
            parameters.useFog && parameters.fog ? "#define USE_FOG" : "",
            parameters.useFog && parameters.fogExp2 ? "#define FOG_EXP2" : "",
            parameters.map ? "#define USE_MAP" : "",
            parameters.matcap ? "#define USE_MATCAP" : "",
            parameters.envMap ? "#define USE_ENVMAP" : "",
            parameters.envMap ? "#define " + envMapTypeDefine : "",
            parameters.envMap ? "#define " + envMapModeDefine : "",
            parameters.envMap ? "#define " + envMapBlendingDefine : "",
            envMapCubeUVSize ? "#define CUBEUV_TEXEL_WIDTH " + envMapCubeUVSize.texelWidth : "",
            envMapCubeUVSize ? "#define CUBEUV_TEXEL_HEIGHT " + envMapCubeUVSize.texelHeight : "",
            envMapCubeUVSize ? "#define CUBEUV_MAX_MIP " + envMapCubeUVSize.maxMip + ".0" : "",
            parameters.lightMap ? "#define USE_LIGHTMAP" : "",
            parameters.aoMap ? "#define USE_AOMAP" : "",
            parameters.bumpMap ? "#define USE_BUMPMAP" : "",
            parameters.normalMap ? "#define USE_NORMALMAP" : "",
            parameters.normalMapObjectSpace ? "#define USE_NORMALMAP_OBJECTSPACE" : "",
            parameters.normalMapTangentSpace ? "#define USE_NORMALMAP_TANGENTSPACE" : "",
            parameters.emissiveMap ? "#define USE_EMISSIVEMAP" : "",
            parameters.anisotropy ? "#define USE_ANISOTROPY" : "",
            parameters.anisotropyMap ? "#define USE_ANISOTROPYMAP" : "",
            parameters.clearcoat ? "#define USE_CLEARCOAT" : "",
            parameters.clearcoatMap ? "#define USE_CLEARCOATMAP" : "",
            parameters.clearcoatRoughnessMap ? "#define USE_CLEARCOAT_ROUGHNESSMAP" : "",
            parameters.clearcoatNormalMap ? "#define USE_CLEARCOAT_NORMALMAP" : "",
            parameters.iridescence ? "#define USE_IRIDESCENCE" : "",
            parameters.iridescenceMap ? "#define USE_IRIDESCENCEMAP" : "",
            parameters.iridescenceThicknessMap ? "#define USE_IRIDESCENCE_THICKNESSMAP" : "",
            parameters.specularMap ? "#define USE_SPECULARMAP" : "",
            parameters.specularColorMap ? "#define USE_SPECULAR_COLORMAP" : "",
            parameters.specularIntensityMap ? "#define USE_SPECULAR_INTENSITYMAP" : "",
            parameters.roughnessMap ? "#define USE_ROUGHNESSMAP" : "",
            parameters.metalnessMap ? "#define USE_METALNESSMAP" : "",
            parameters.alphaMap ? "#define USE_ALPHAMAP" : "",
            parameters.alphaTest ? "#define USE_ALPHATEST" : "",
            parameters.alphaHash ? "#define USE_ALPHAHASH" : "",
            parameters.sheen ? "#define USE_SHEEN" : "",
            parameters.sheenColorMap ? "#define USE_SHEEN_COLORMAP" : "",
            parameters.sheenRoughnessMap ? "#define USE_SHEEN_ROUGHNESSMAP" : "",
            parameters.transmission ? "#define USE_TRANSMISSION" : "",
            parameters.transmissionMap ? "#define USE_TRANSMISSIONMAP" : "",
            parameters.thicknessMap ? "#define USE_THICKNESSMAP" : "",
            parameters.vertexTangents && parameters.flatShading === false ? "#define USE_TANGENT" : "",
            parameters.vertexColors || parameters.instancingColor ? "#define USE_COLOR" : "",
            parameters.vertexAlphas ? "#define USE_COLOR_ALPHA" : "",
            parameters.vertexUv1s ? "#define USE_UV1" : "",
            parameters.vertexUv2s ? "#define USE_UV2" : "",
            parameters.vertexUv3s ? "#define USE_UV3" : "",
            parameters.pointsUvs ? "#define USE_POINTS_UV" : "",
            parameters.gradientMap ? "#define USE_GRADIENTMAP" : "",
            parameters.flatShading ? "#define FLAT_SHADED" : "",
            parameters.doubleSided ? "#define DOUBLE_SIDED" : "",
            parameters.flipSided ? "#define FLIP_SIDED" : "",
            parameters.shadowMapEnabled ? "#define USE_SHADOWMAP" : "",
            parameters.shadowMapEnabled ? "#define " + shadowMapTypeDefine : "",
            parameters.premultipliedAlpha ? "#define PREMULTIPLIED_ALPHA" : "",
            parameters.useLegacyLights ? "#define LEGACY_LIGHTS" : "",
            parameters.logarithmicDepthBuffer ? "#define USE_LOGDEPTHBUF" : "",
            parameters.logarithmicDepthBuffer && parameters.rendererExtensionFragDepth ? "#define USE_LOGDEPTHBUF_EXT" : "",
            "uniform mat4 viewMatrix;",
            "uniform vec3 cameraPosition;",
            "uniform bool isOrthographic;",
            parameters.toneMapping !== $9014d97cd777be10$export$9fcb6b4294603b2 ? "#define TONE_MAPPING" : "",
            parameters.toneMapping !== $9014d97cd777be10$export$9fcb6b4294603b2 ? $9014d97cd777be10$export$955f9f2e84c43c8b["tonemapping_pars_fragment"] : "",
            parameters.toneMapping !== $9014d97cd777be10$export$9fcb6b4294603b2 ? $9014d97cd777be10$var$getToneMappingFunction("toneMapping", parameters.toneMapping) : "",
            parameters.dithering ? "#define DITHERING" : "",
            parameters.opaque ? "#define OPAQUE" : "",
            $9014d97cd777be10$export$955f9f2e84c43c8b["colorspace_pars_fragment"],
            $9014d97cd777be10$var$getTexelEncodingFunction("linearToOutputTexel", parameters.outputColorSpace),
            parameters.useDepthPacking ? "#define DEPTH_PACKING " + parameters.depthPacking : "",
            "\n"
        ].filter($9014d97cd777be10$var$filterEmptyLine).join("\n");
    }
    vertexShader = $9014d97cd777be10$var$resolveIncludes(vertexShader);
    vertexShader = $9014d97cd777be10$var$replaceLightNums(vertexShader, parameters);
    vertexShader = $9014d97cd777be10$var$replaceClippingPlaneNums(vertexShader, parameters);
    fragmentShader = $9014d97cd777be10$var$resolveIncludes(fragmentShader);
    fragmentShader = $9014d97cd777be10$var$replaceLightNums(fragmentShader, parameters);
    fragmentShader = $9014d97cd777be10$var$replaceClippingPlaneNums(fragmentShader, parameters);
    vertexShader = $9014d97cd777be10$var$unrollLoops(vertexShader);
    fragmentShader = $9014d97cd777be10$var$unrollLoops(fragmentShader);
    if (parameters.isWebGL2 && parameters.isRawShaderMaterial !== true) {
        // GLSL 3.0 conversion for built-in materials and ShaderMaterial
        versionString = "#version 300 es\n";
        prefixVertex = [
            "precision mediump sampler2DArray;",
            "#define attribute in",
            "#define varying out",
            "#define texture2D texture"
        ].join("\n") + "\n" + prefixVertex;
        prefixFragment = [
            "#define varying in",
            parameters.glslVersion === $9014d97cd777be10$export$f63012db5506e7dd ? "" : "layout(location = 0) out highp vec4 pc_fragColor;",
            parameters.glslVersion === $9014d97cd777be10$export$f63012db5506e7dd ? "" : "#define gl_FragColor pc_fragColor",
            "#define gl_FragDepthEXT gl_FragDepth",
            "#define texture2D texture",
            "#define textureCube texture",
            "#define texture2DProj textureProj",
            "#define texture2DLodEXT textureLod",
            "#define texture2DProjLodEXT textureProjLod",
            "#define textureCubeLodEXT textureLod",
            "#define texture2DGradEXT textureGrad",
            "#define texture2DProjGradEXT textureProjGrad",
            "#define textureCubeGradEXT textureGrad"
        ].join("\n") + "\n" + prefixFragment;
    }
    const vertexGlsl = versionString + prefixVertex + vertexShader;
    const fragmentGlsl = versionString + prefixFragment + fragmentShader;
    // console.log( '*VERTEX*', vertexGlsl );
    // console.log( '*FRAGMENT*', fragmentGlsl );
    const glVertexShader = $9014d97cd777be10$var$WebGLShader(gl, gl.VERTEX_SHADER, vertexGlsl);
    const glFragmentShader = $9014d97cd777be10$var$WebGLShader(gl, gl.FRAGMENT_SHADER, fragmentGlsl);
    gl.attachShader(program, glVertexShader);
    gl.attachShader(program, glFragmentShader);
    // Force a particular attribute to index 0.
    if (parameters.index0AttributeName !== undefined) gl.bindAttribLocation(program, 0, parameters.index0AttributeName);
    else if (parameters.morphTargets === true) // programs with morphTargets displace position out of attribute 0
    gl.bindAttribLocation(program, 0, "position");
    gl.linkProgram(program);
    // check for link errors
    if (renderer.debug.checkShaderErrors) {
        const programLog = gl.getProgramInfoLog(program).trim();
        const vertexLog = gl.getShaderInfoLog(glVertexShader).trim();
        const fragmentLog = gl.getShaderInfoLog(glFragmentShader).trim();
        let runnable = true;
        let haveDiagnostics = true;
        if (gl.getProgramParameter(program, gl.LINK_STATUS) === false) {
            runnable = false;
            if (typeof renderer.debug.onShaderError === "function") renderer.debug.onShaderError(gl, program, glVertexShader, glFragmentShader);
            else {
                // default error reporting
                const vertexErrors = $9014d97cd777be10$var$getShaderErrors(gl, glVertexShader, "vertex");
                const fragmentErrors = $9014d97cd777be10$var$getShaderErrors(gl, glFragmentShader, "fragment");
                console.error("THREE.WebGLProgram: Shader Error " + gl.getError() + " - " + "VALIDATE_STATUS " + gl.getProgramParameter(program, gl.VALIDATE_STATUS) + "\n\n" + "Program Info Log: " + programLog + "\n" + vertexErrors + "\n" + fragmentErrors);
            }
        } else if (programLog !== "") console.warn("THREE.WebGLProgram: Program Info Log:", programLog);
        else if (vertexLog === "" || fragmentLog === "") haveDiagnostics = false;
        if (haveDiagnostics) this.diagnostics = {
            runnable: runnable,
            programLog: programLog,
            vertexShader: {
                log: vertexLog,
                prefix: prefixVertex
            },
            fragmentShader: {
                log: fragmentLog,
                prefix: prefixFragment
            }
        };
    }
    // Clean up
    // Crashes in iOS9 and iOS10. #18402
    // gl.detachShader( program, glVertexShader );
    // gl.detachShader( program, glFragmentShader );
    gl.deleteShader(glVertexShader);
    gl.deleteShader(glFragmentShader);
    // set up caching for uniform locations
    let cachedUniforms;
    this.getUniforms = function() {
        if (cachedUniforms === undefined) cachedUniforms = new $9014d97cd777be10$var$WebGLUniforms(gl, program);
        return cachedUniforms;
    };
    // set up caching for attribute locations
    let cachedAttributes;
    this.getAttributes = function() {
        if (cachedAttributes === undefined) cachedAttributes = $9014d97cd777be10$var$fetchAttributeLocations(gl, program);
        return cachedAttributes;
    };
    // free resource
    this.destroy = function() {
        bindingStates.releaseStatesOfProgram(this);
        gl.deleteProgram(program);
        this.program = undefined;
    };
    //
    this.type = parameters.shaderType;
    this.name = parameters.shaderName;
    this.id = $9014d97cd777be10$var$programIdCount++;
    this.cacheKey = cacheKey;
    this.usedTimes = 1;
    this.program = program;
    this.vertexShader = glVertexShader;
    this.fragmentShader = glFragmentShader;
    return this;
}
let $9014d97cd777be10$var$_id = 0;
class $9014d97cd777be10$var$WebGLShaderCache {
    update(material) {
        const vertexShader = material.vertexShader;
        const fragmentShader = material.fragmentShader;
        const vertexShaderStage = this._getShaderStage(vertexShader);
        const fragmentShaderStage = this._getShaderStage(fragmentShader);
        const materialShaders = this._getShaderCacheForMaterial(material);
        if (materialShaders.has(vertexShaderStage) === false) {
            materialShaders.add(vertexShaderStage);
            vertexShaderStage.usedTimes++;
        }
        if (materialShaders.has(fragmentShaderStage) === false) {
            materialShaders.add(fragmentShaderStage);
            fragmentShaderStage.usedTimes++;
        }
        return this;
    }
    remove(material) {
        const materialShaders = this.materialCache.get(material);
        for (const shaderStage of materialShaders){
            shaderStage.usedTimes--;
            if (shaderStage.usedTimes === 0) this.shaderCache.delete(shaderStage.code);
        }
        this.materialCache.delete(material);
        return this;
    }
    getVertexShaderID(material) {
        return this._getShaderStage(material.vertexShader).id;
    }
    getFragmentShaderID(material) {
        return this._getShaderStage(material.fragmentShader).id;
    }
    dispose() {
        this.shaderCache.clear();
        this.materialCache.clear();
    }
    _getShaderCacheForMaterial(material) {
        const cache = this.materialCache;
        let set = cache.get(material);
        if (set === undefined) {
            set = new Set();
            cache.set(material, set);
        }
        return set;
    }
    _getShaderStage(code) {
        const cache = this.shaderCache;
        let stage = cache.get(code);
        if (stage === undefined) {
            stage = new $9014d97cd777be10$var$WebGLShaderStage(code);
            cache.set(code, stage);
        }
        return stage;
    }
    constructor(){
        this.shaderCache = new Map();
        this.materialCache = new Map();
    }
}
class $9014d97cd777be10$var$WebGLShaderStage {
    constructor(code){
        this.id = $9014d97cd777be10$var$_id++;
        this.code = code;
        this.usedTimes = 0;
    }
}
function $9014d97cd777be10$var$WebGLPrograms(renderer, cubemaps, cubeuvmaps, extensions, capabilities, bindingStates, clipping) {
    const _programLayers = new $9014d97cd777be10$export$89312ce47c0ca777();
    const _customShaders = new $9014d97cd777be10$var$WebGLShaderCache();
    const programs = [];
    const IS_WEBGL2 = capabilities.isWebGL2;
    const logarithmicDepthBuffer = capabilities.logarithmicDepthBuffer;
    const SUPPORTS_VERTEX_TEXTURES = capabilities.vertexTextures;
    let precision = capabilities.precision;
    const shaderIDs = {
        MeshDepthMaterial: "depth",
        MeshDistanceMaterial: "distanceRGBA",
        MeshNormalMaterial: "normal",
        MeshBasicMaterial: "basic",
        MeshLambertMaterial: "lambert",
        MeshPhongMaterial: "phong",
        MeshToonMaterial: "toon",
        MeshStandardMaterial: "physical",
        MeshPhysicalMaterial: "physical",
        MeshMatcapMaterial: "matcap",
        LineBasicMaterial: "basic",
        LineDashedMaterial: "dashed",
        PointsMaterial: "points",
        ShadowMaterial: "shadow",
        SpriteMaterial: "sprite"
    };
    function getChannel(value) {
        if (value === 0) return "uv";
        return `uv${value}`;
    }
    function getParameters(material, lights, shadows, scene, object) {
        const fog = scene.fog;
        const geometry = object.geometry;
        const environment = material.isMeshStandardMaterial ? scene.environment : null;
        const envMap = (material.isMeshStandardMaterial ? cubeuvmaps : cubemaps).get(material.envMap || environment);
        const envMapCubeUVHeight = !!envMap && envMap.mapping === $9014d97cd777be10$export$dbf3e70ff37af79 ? envMap.image.height : null;
        const shaderID = shaderIDs[material.type];
        // heuristics to create shader parameters according to lights in the scene
        // (not to blow over maxLights budget)
        if (material.precision !== null) {
            precision = capabilities.getMaxPrecision(material.precision);
            if (precision !== material.precision) console.warn("THREE.WebGLProgram.getParameters:", material.precision, "not supported, using", precision, "instead.");
        }
        //
        const morphAttribute = geometry.morphAttributes.position || geometry.morphAttributes.normal || geometry.morphAttributes.color;
        const morphTargetsCount = morphAttribute !== undefined ? morphAttribute.length : 0;
        let morphTextureStride = 0;
        if (geometry.morphAttributes.position !== undefined) morphTextureStride = 1;
        if (geometry.morphAttributes.normal !== undefined) morphTextureStride = 2;
        if (geometry.morphAttributes.color !== undefined) morphTextureStride = 3;
        //
        let vertexShader, fragmentShader;
        let customVertexShaderID, customFragmentShaderID;
        if (shaderID) {
            const shader = $9014d97cd777be10$export$bee4a7d47f8f5014[shaderID];
            vertexShader = shader.vertexShader;
            fragmentShader = shader.fragmentShader;
        } else {
            vertexShader = material.vertexShader;
            fragmentShader = material.fragmentShader;
            _customShaders.update(material);
            customVertexShaderID = _customShaders.getVertexShaderID(material);
            customFragmentShaderID = _customShaders.getFragmentShaderID(material);
        }
        const currentRenderTarget = renderer.getRenderTarget();
        const IS_INSTANCEDMESH = object.isInstancedMesh === true;
        const HAS_MAP = !!material.map;
        const HAS_MATCAP = !!material.matcap;
        const HAS_ENVMAP = !!envMap;
        const HAS_AOMAP = !!material.aoMap;
        const HAS_LIGHTMAP = !!material.lightMap;
        const HAS_BUMPMAP = !!material.bumpMap;
        const HAS_NORMALMAP = !!material.normalMap;
        const HAS_DISPLACEMENTMAP = !!material.displacementMap;
        const HAS_EMISSIVEMAP = !!material.emissiveMap;
        const HAS_METALNESSMAP = !!material.metalnessMap;
        const HAS_ROUGHNESSMAP = !!material.roughnessMap;
        const HAS_ANISOTROPY = material.anisotropy > 0;
        const HAS_CLEARCOAT = material.clearcoat > 0;
        const HAS_IRIDESCENCE = material.iridescence > 0;
        const HAS_SHEEN = material.sheen > 0;
        const HAS_TRANSMISSION = material.transmission > 0;
        const HAS_ANISOTROPYMAP = HAS_ANISOTROPY && !!material.anisotropyMap;
        const HAS_CLEARCOATMAP = HAS_CLEARCOAT && !!material.clearcoatMap;
        const HAS_CLEARCOAT_NORMALMAP = HAS_CLEARCOAT && !!material.clearcoatNormalMap;
        const HAS_CLEARCOAT_ROUGHNESSMAP = HAS_CLEARCOAT && !!material.clearcoatRoughnessMap;
        const HAS_IRIDESCENCEMAP = HAS_IRIDESCENCE && !!material.iridescenceMap;
        const HAS_IRIDESCENCE_THICKNESSMAP = HAS_IRIDESCENCE && !!material.iridescenceThicknessMap;
        const HAS_SHEEN_COLORMAP = HAS_SHEEN && !!material.sheenColorMap;
        const HAS_SHEEN_ROUGHNESSMAP = HAS_SHEEN && !!material.sheenRoughnessMap;
        const HAS_SPECULARMAP = !!material.specularMap;
        const HAS_SPECULAR_COLORMAP = !!material.specularColorMap;
        const HAS_SPECULAR_INTENSITYMAP = !!material.specularIntensityMap;
        const HAS_TRANSMISSIONMAP = HAS_TRANSMISSION && !!material.transmissionMap;
        const HAS_THICKNESSMAP = HAS_TRANSMISSION && !!material.thicknessMap;
        const HAS_GRADIENTMAP = !!material.gradientMap;
        const HAS_ALPHAMAP = !!material.alphaMap;
        const HAS_ALPHATEST = material.alphaTest > 0;
        const HAS_ALPHAHASH = !!material.alphaHash;
        const HAS_EXTENSIONS = !!material.extensions;
        const HAS_ATTRIBUTE_UV1 = !!geometry.attributes.uv1;
        const HAS_ATTRIBUTE_UV2 = !!geometry.attributes.uv2;
        const HAS_ATTRIBUTE_UV3 = !!geometry.attributes.uv3;
        let toneMapping = $9014d97cd777be10$export$9fcb6b4294603b2;
        if (material.toneMapped) {
            if (currentRenderTarget === null || currentRenderTarget.isXRRenderTarget === true) toneMapping = renderer.toneMapping;
        }
        const parameters = {
            isWebGL2: IS_WEBGL2,
            shaderID: shaderID,
            shaderType: material.type,
            shaderName: material.name,
            vertexShader: vertexShader,
            fragmentShader: fragmentShader,
            defines: material.defines,
            customVertexShaderID: customVertexShaderID,
            customFragmentShaderID: customFragmentShaderID,
            isRawShaderMaterial: material.isRawShaderMaterial === true,
            glslVersion: material.glslVersion,
            precision: precision,
            instancing: IS_INSTANCEDMESH,
            instancingColor: IS_INSTANCEDMESH && object.instanceColor !== null,
            supportsVertexTextures: SUPPORTS_VERTEX_TEXTURES,
            outputColorSpace: currentRenderTarget === null ? renderer.outputColorSpace : currentRenderTarget.isXRRenderTarget === true ? currentRenderTarget.texture.colorSpace : $9014d97cd777be10$export$42429b3acfb233a4,
            map: HAS_MAP,
            matcap: HAS_MATCAP,
            envMap: HAS_ENVMAP,
            envMapMode: HAS_ENVMAP && envMap.mapping,
            envMapCubeUVHeight: envMapCubeUVHeight,
            aoMap: HAS_AOMAP,
            lightMap: HAS_LIGHTMAP,
            bumpMap: HAS_BUMPMAP,
            normalMap: HAS_NORMALMAP,
            displacementMap: SUPPORTS_VERTEX_TEXTURES && HAS_DISPLACEMENTMAP,
            emissiveMap: HAS_EMISSIVEMAP,
            normalMapObjectSpace: HAS_NORMALMAP && material.normalMapType === $9014d97cd777be10$export$9990ad26f9db5b2c,
            normalMapTangentSpace: HAS_NORMALMAP && material.normalMapType === $9014d97cd777be10$export$2852a58ebdac27b8,
            metalnessMap: HAS_METALNESSMAP,
            roughnessMap: HAS_ROUGHNESSMAP,
            anisotropy: HAS_ANISOTROPY,
            anisotropyMap: HAS_ANISOTROPYMAP,
            clearcoat: HAS_CLEARCOAT,
            clearcoatMap: HAS_CLEARCOATMAP,
            clearcoatNormalMap: HAS_CLEARCOAT_NORMALMAP,
            clearcoatRoughnessMap: HAS_CLEARCOAT_ROUGHNESSMAP,
            iridescence: HAS_IRIDESCENCE,
            iridescenceMap: HAS_IRIDESCENCEMAP,
            iridescenceThicknessMap: HAS_IRIDESCENCE_THICKNESSMAP,
            sheen: HAS_SHEEN,
            sheenColorMap: HAS_SHEEN_COLORMAP,
            sheenRoughnessMap: HAS_SHEEN_ROUGHNESSMAP,
            specularMap: HAS_SPECULARMAP,
            specularColorMap: HAS_SPECULAR_COLORMAP,
            specularIntensityMap: HAS_SPECULAR_INTENSITYMAP,
            transmission: HAS_TRANSMISSION,
            transmissionMap: HAS_TRANSMISSIONMAP,
            thicknessMap: HAS_THICKNESSMAP,
            gradientMap: HAS_GRADIENTMAP,
            opaque: material.transparent === false && material.blending === $9014d97cd777be10$export$5b29a26d96ee6af0,
            alphaMap: HAS_ALPHAMAP,
            alphaTest: HAS_ALPHATEST,
            alphaHash: HAS_ALPHAHASH,
            combine: material.combine,
            //
            mapUv: HAS_MAP && getChannel(material.map.channel),
            aoMapUv: HAS_AOMAP && getChannel(material.aoMap.channel),
            lightMapUv: HAS_LIGHTMAP && getChannel(material.lightMap.channel),
            bumpMapUv: HAS_BUMPMAP && getChannel(material.bumpMap.channel),
            normalMapUv: HAS_NORMALMAP && getChannel(material.normalMap.channel),
            displacementMapUv: HAS_DISPLACEMENTMAP && getChannel(material.displacementMap.channel),
            emissiveMapUv: HAS_EMISSIVEMAP && getChannel(material.emissiveMap.channel),
            metalnessMapUv: HAS_METALNESSMAP && getChannel(material.metalnessMap.channel),
            roughnessMapUv: HAS_ROUGHNESSMAP && getChannel(material.roughnessMap.channel),
            anisotropyMapUv: HAS_ANISOTROPYMAP && getChannel(material.anisotropyMap.channel),
            clearcoatMapUv: HAS_CLEARCOATMAP && getChannel(material.clearcoatMap.channel),
            clearcoatNormalMapUv: HAS_CLEARCOAT_NORMALMAP && getChannel(material.clearcoatNormalMap.channel),
            clearcoatRoughnessMapUv: HAS_CLEARCOAT_ROUGHNESSMAP && getChannel(material.clearcoatRoughnessMap.channel),
            iridescenceMapUv: HAS_IRIDESCENCEMAP && getChannel(material.iridescenceMap.channel),
            iridescenceThicknessMapUv: HAS_IRIDESCENCE_THICKNESSMAP && getChannel(material.iridescenceThicknessMap.channel),
            sheenColorMapUv: HAS_SHEEN_COLORMAP && getChannel(material.sheenColorMap.channel),
            sheenRoughnessMapUv: HAS_SHEEN_ROUGHNESSMAP && getChannel(material.sheenRoughnessMap.channel),
            specularMapUv: HAS_SPECULARMAP && getChannel(material.specularMap.channel),
            specularColorMapUv: HAS_SPECULAR_COLORMAP && getChannel(material.specularColorMap.channel),
            specularIntensityMapUv: HAS_SPECULAR_INTENSITYMAP && getChannel(material.specularIntensityMap.channel),
            transmissionMapUv: HAS_TRANSMISSIONMAP && getChannel(material.transmissionMap.channel),
            thicknessMapUv: HAS_THICKNESSMAP && getChannel(material.thicknessMap.channel),
            alphaMapUv: HAS_ALPHAMAP && getChannel(material.alphaMap.channel),
            //
            vertexTangents: !!geometry.attributes.tangent && (HAS_NORMALMAP || HAS_ANISOTROPY),
            vertexColors: material.vertexColors,
            vertexAlphas: material.vertexColors === true && !!geometry.attributes.color && geometry.attributes.color.itemSize === 4,
            vertexUv1s: HAS_ATTRIBUTE_UV1,
            vertexUv2s: HAS_ATTRIBUTE_UV2,
            vertexUv3s: HAS_ATTRIBUTE_UV3,
            pointsUvs: object.isPoints === true && !!geometry.attributes.uv && (HAS_MAP || HAS_ALPHAMAP),
            fog: !!fog,
            useFog: material.fog === true,
            fogExp2: fog && fog.isFogExp2,
            flatShading: material.flatShading === true,
            sizeAttenuation: material.sizeAttenuation === true,
            logarithmicDepthBuffer: logarithmicDepthBuffer,
            skinning: object.isSkinnedMesh === true,
            morphTargets: geometry.morphAttributes.position !== undefined,
            morphNormals: geometry.morphAttributes.normal !== undefined,
            morphColors: geometry.morphAttributes.color !== undefined,
            morphTargetsCount: morphTargetsCount,
            morphTextureStride: morphTextureStride,
            numDirLights: lights.directional.length,
            numPointLights: lights.point.length,
            numSpotLights: lights.spot.length,
            numSpotLightMaps: lights.spotLightMap.length,
            numRectAreaLights: lights.rectArea.length,
            numHemiLights: lights.hemi.length,
            numDirLightShadows: lights.directionalShadowMap.length,
            numPointLightShadows: lights.pointShadowMap.length,
            numSpotLightShadows: lights.spotShadowMap.length,
            numSpotLightShadowsWithMaps: lights.numSpotLightShadowsWithMaps,
            numClippingPlanes: clipping.numPlanes,
            numClipIntersection: clipping.numIntersection,
            dithering: material.dithering,
            shadowMapEnabled: renderer.shadowMap.enabled && shadows.length > 0,
            shadowMapType: renderer.shadowMap.type,
            toneMapping: toneMapping,
            useLegacyLights: renderer._useLegacyLights,
            premultipliedAlpha: material.premultipliedAlpha,
            doubleSided: material.side === $9014d97cd777be10$export$3b296b6f144d5b03,
            flipSided: material.side === $9014d97cd777be10$export$d9f0486e75b5ace,
            useDepthPacking: material.depthPacking >= 0,
            depthPacking: material.depthPacking || 0,
            index0AttributeName: material.index0AttributeName,
            extensionDerivatives: HAS_EXTENSIONS && material.extensions.derivatives === true,
            extensionFragDepth: HAS_EXTENSIONS && material.extensions.fragDepth === true,
            extensionDrawBuffers: HAS_EXTENSIONS && material.extensions.drawBuffers === true,
            extensionShaderTextureLOD: HAS_EXTENSIONS && material.extensions.shaderTextureLOD === true,
            rendererExtensionFragDepth: IS_WEBGL2 || extensions.has("EXT_frag_depth"),
            rendererExtensionDrawBuffers: IS_WEBGL2 || extensions.has("WEBGL_draw_buffers"),
            rendererExtensionShaderTextureLod: IS_WEBGL2 || extensions.has("EXT_shader_texture_lod"),
            customProgramCacheKey: material.customProgramCacheKey()
        };
        return parameters;
    }
    function getProgramCacheKey(parameters) {
        const array = [];
        if (parameters.shaderID) array.push(parameters.shaderID);
        else {
            array.push(parameters.customVertexShaderID);
            array.push(parameters.customFragmentShaderID);
        }
        if (parameters.defines !== undefined) for(const name in parameters.defines){
            array.push(name);
            array.push(parameters.defines[name]);
        }
        if (parameters.isRawShaderMaterial === false) {
            getProgramCacheKeyParameters(array, parameters);
            getProgramCacheKeyBooleans(array, parameters);
            array.push(renderer.outputColorSpace);
        }
        array.push(parameters.customProgramCacheKey);
        return array.join();
    }
    function getProgramCacheKeyParameters(array, parameters) {
        array.push(parameters.precision);
        array.push(parameters.outputColorSpace);
        array.push(parameters.envMapMode);
        array.push(parameters.envMapCubeUVHeight);
        array.push(parameters.mapUv);
        array.push(parameters.alphaMapUv);
        array.push(parameters.lightMapUv);
        array.push(parameters.aoMapUv);
        array.push(parameters.bumpMapUv);
        array.push(parameters.normalMapUv);
        array.push(parameters.displacementMapUv);
        array.push(parameters.emissiveMapUv);
        array.push(parameters.metalnessMapUv);
        array.push(parameters.roughnessMapUv);
        array.push(parameters.anisotropyMapUv);
        array.push(parameters.clearcoatMapUv);
        array.push(parameters.clearcoatNormalMapUv);
        array.push(parameters.clearcoatRoughnessMapUv);
        array.push(parameters.iridescenceMapUv);
        array.push(parameters.iridescenceThicknessMapUv);
        array.push(parameters.sheenColorMapUv);
        array.push(parameters.sheenRoughnessMapUv);
        array.push(parameters.specularMapUv);
        array.push(parameters.specularColorMapUv);
        array.push(parameters.specularIntensityMapUv);
        array.push(parameters.transmissionMapUv);
        array.push(parameters.thicknessMapUv);
        array.push(parameters.combine);
        array.push(parameters.fogExp2);
        array.push(parameters.sizeAttenuation);
        array.push(parameters.morphTargetsCount);
        array.push(parameters.morphAttributeCount);
        array.push(parameters.numDirLights);
        array.push(parameters.numPointLights);
        array.push(parameters.numSpotLights);
        array.push(parameters.numSpotLightMaps);
        array.push(parameters.numHemiLights);
        array.push(parameters.numRectAreaLights);
        array.push(parameters.numDirLightShadows);
        array.push(parameters.numPointLightShadows);
        array.push(parameters.numSpotLightShadows);
        array.push(parameters.numSpotLightShadowsWithMaps);
        array.push(parameters.shadowMapType);
        array.push(parameters.toneMapping);
        array.push(parameters.numClippingPlanes);
        array.push(parameters.numClipIntersection);
        array.push(parameters.depthPacking);
    }
    function getProgramCacheKeyBooleans(array, parameters) {
        _programLayers.disableAll();
        if (parameters.isWebGL2) _programLayers.enable(0);
        if (parameters.supportsVertexTextures) _programLayers.enable(1);
        if (parameters.instancing) _programLayers.enable(2);
        if (parameters.instancingColor) _programLayers.enable(3);
        if (parameters.matcap) _programLayers.enable(4);
        if (parameters.envMap) _programLayers.enable(5);
        if (parameters.normalMapObjectSpace) _programLayers.enable(6);
        if (parameters.normalMapTangentSpace) _programLayers.enable(7);
        if (parameters.clearcoat) _programLayers.enable(8);
        if (parameters.iridescence) _programLayers.enable(9);
        if (parameters.alphaTest) _programLayers.enable(10);
        if (parameters.vertexColors) _programLayers.enable(11);
        if (parameters.vertexAlphas) _programLayers.enable(12);
        if (parameters.vertexUv1s) _programLayers.enable(13);
        if (parameters.vertexUv2s) _programLayers.enable(14);
        if (parameters.vertexUv3s) _programLayers.enable(15);
        if (parameters.vertexTangents) _programLayers.enable(16);
        if (parameters.anisotropy) _programLayers.enable(17);
        array.push(_programLayers.mask);
        _programLayers.disableAll();
        if (parameters.fog) _programLayers.enable(0);
        if (parameters.useFog) _programLayers.enable(1);
        if (parameters.flatShading) _programLayers.enable(2);
        if (parameters.logarithmicDepthBuffer) _programLayers.enable(3);
        if (parameters.skinning) _programLayers.enable(4);
        if (parameters.morphTargets) _programLayers.enable(5);
        if (parameters.morphNormals) _programLayers.enable(6);
        if (parameters.morphColors) _programLayers.enable(7);
        if (parameters.premultipliedAlpha) _programLayers.enable(8);
        if (parameters.shadowMapEnabled) _programLayers.enable(9);
        if (parameters.useLegacyLights) _programLayers.enable(10);
        if (parameters.doubleSided) _programLayers.enable(11);
        if (parameters.flipSided) _programLayers.enable(12);
        if (parameters.useDepthPacking) _programLayers.enable(13);
        if (parameters.dithering) _programLayers.enable(14);
        if (parameters.transmission) _programLayers.enable(15);
        if (parameters.sheen) _programLayers.enable(16);
        if (parameters.opaque) _programLayers.enable(17);
        if (parameters.pointsUvs) _programLayers.enable(18);
        array.push(_programLayers.mask);
    }
    function getUniforms(material) {
        const shaderID = shaderIDs[material.type];
        let uniforms;
        if (shaderID) {
            const shader = $9014d97cd777be10$export$bee4a7d47f8f5014[shaderID];
            uniforms = $9014d97cd777be10$export$d8ecdf8615bfea69.clone(shader.uniforms);
        } else uniforms = material.uniforms;
        return uniforms;
    }
    function acquireProgram(parameters, cacheKey) {
        let program;
        // Check if code has been already compiled
        for(let p = 0, pl = programs.length; p < pl; p++){
            const preexistingProgram = programs[p];
            if (preexistingProgram.cacheKey === cacheKey) {
                program = preexistingProgram;
                ++program.usedTimes;
                break;
            }
        }
        if (program === undefined) {
            program = new $9014d97cd777be10$var$WebGLProgram(renderer, cacheKey, parameters, bindingStates);
            programs.push(program);
        }
        return program;
    }
    function releaseProgram(program) {
        if (--program.usedTimes === 0) {
            // Remove from unordered set
            const i = programs.indexOf(program);
            programs[i] = programs[programs.length - 1];
            programs.pop();
            // Free WebGL resources
            program.destroy();
        }
    }
    function releaseShaderCache(material) {
        _customShaders.remove(material);
    }
    function dispose() {
        _customShaders.dispose();
    }
    return {
        getParameters: getParameters,
        getProgramCacheKey: getProgramCacheKey,
        getUniforms: getUniforms,
        acquireProgram: acquireProgram,
        releaseProgram: releaseProgram,
        releaseShaderCache: releaseShaderCache,
        // Exposed for resource monitoring & error feedback via renderer.info:
        programs: programs,
        dispose: dispose
    };
}
function $9014d97cd777be10$var$WebGLProperties() {
    let properties = new WeakMap();
    function get(object) {
        let map = properties.get(object);
        if (map === undefined) {
            map = {};
            properties.set(object, map);
        }
        return map;
    }
    function remove(object) {
        properties.delete(object);
    }
    function update(object, key, value) {
        properties.get(object)[key] = value;
    }
    function dispose() {
        properties = new WeakMap();
    }
    return {
        get: get,
        remove: remove,
        update: update,
        dispose: dispose
    };
}
function $9014d97cd777be10$var$painterSortStable(a, b) {
    if (a.groupOrder !== b.groupOrder) return a.groupOrder - b.groupOrder;
    else if (a.renderOrder !== b.renderOrder) return a.renderOrder - b.renderOrder;
    else if (a.material.id !== b.material.id) return a.material.id - b.material.id;
    else if (a.z !== b.z) return a.z - b.z;
    else return a.id - b.id;
}
function $9014d97cd777be10$var$reversePainterSortStable(a, b) {
    if (a.groupOrder !== b.groupOrder) return a.groupOrder - b.groupOrder;
    else if (a.renderOrder !== b.renderOrder) return a.renderOrder - b.renderOrder;
    else if (a.z !== b.z) return b.z - a.z;
    else return a.id - b.id;
}
function $9014d97cd777be10$var$WebGLRenderList() {
    const renderItems = [];
    let renderItemsIndex = 0;
    const opaque = [];
    const transmissive = [];
    const transparent = [];
    function init() {
        renderItemsIndex = 0;
        opaque.length = 0;
        transmissive.length = 0;
        transparent.length = 0;
    }
    function getNextRenderItem(object, geometry, material, groupOrder, z, group) {
        let renderItem = renderItems[renderItemsIndex];
        if (renderItem === undefined) {
            renderItem = {
                id: object.id,
                object: object,
                geometry: geometry,
                material: material,
                groupOrder: groupOrder,
                renderOrder: object.renderOrder,
                z: z,
                group: group
            };
            renderItems[renderItemsIndex] = renderItem;
        } else {
            renderItem.id = object.id;
            renderItem.object = object;
            renderItem.geometry = geometry;
            renderItem.material = material;
            renderItem.groupOrder = groupOrder;
            renderItem.renderOrder = object.renderOrder;
            renderItem.z = z;
            renderItem.group = group;
        }
        renderItemsIndex++;
        return renderItem;
    }
    function push(object, geometry, material, groupOrder, z, group) {
        const renderItem = getNextRenderItem(object, geometry, material, groupOrder, z, group);
        if (material.transmission > 0.0) transmissive.push(renderItem);
        else if (material.transparent === true) transparent.push(renderItem);
        else opaque.push(renderItem);
    }
    function unshift(object, geometry, material, groupOrder, z, group) {
        const renderItem = getNextRenderItem(object, geometry, material, groupOrder, z, group);
        if (material.transmission > 0.0) transmissive.unshift(renderItem);
        else if (material.transparent === true) transparent.unshift(renderItem);
        else opaque.unshift(renderItem);
    }
    function sort(customOpaqueSort, customTransparentSort) {
        if (opaque.length > 1) opaque.sort(customOpaqueSort || $9014d97cd777be10$var$painterSortStable);
        if (transmissive.length > 1) transmissive.sort(customTransparentSort || $9014d97cd777be10$var$reversePainterSortStable);
        if (transparent.length > 1) transparent.sort(customTransparentSort || $9014d97cd777be10$var$reversePainterSortStable);
    }
    function finish() {
        // Clear references from inactive renderItems in the list
        for(let i = renderItemsIndex, il = renderItems.length; i < il; i++){
            const renderItem = renderItems[i];
            if (renderItem.id === null) break;
            renderItem.id = null;
            renderItem.object = null;
            renderItem.geometry = null;
            renderItem.material = null;
            renderItem.group = null;
        }
    }
    return {
        opaque: opaque,
        transmissive: transmissive,
        transparent: transparent,
        init: init,
        push: push,
        unshift: unshift,
        finish: finish,
        sort: sort
    };
}
function $9014d97cd777be10$var$WebGLRenderLists() {
    let lists = new WeakMap();
    function get(scene, renderCallDepth) {
        const listArray = lists.get(scene);
        let list;
        if (listArray === undefined) {
            list = new $9014d97cd777be10$var$WebGLRenderList();
            lists.set(scene, [
                list
            ]);
        } else if (renderCallDepth >= listArray.length) {
            list = new $9014d97cd777be10$var$WebGLRenderList();
            listArray.push(list);
        } else list = listArray[renderCallDepth];
        return list;
    }
    function dispose() {
        lists = new WeakMap();
    }
    return {
        get: get,
        dispose: dispose
    };
}
function $9014d97cd777be10$var$UniformsCache() {
    const lights = {};
    return {
        get: function(light) {
            if (lights[light.id] !== undefined) return lights[light.id];
            let uniforms;
            switch(light.type){
                case "DirectionalLight":
                    uniforms = {
                        direction: new $9014d97cd777be10$export$64b5c384219d3699(),
                        color: new $9014d97cd777be10$export$892596cec99bc70e()
                    };
                    break;
                case "SpotLight":
                    uniforms = {
                        position: new $9014d97cd777be10$export$64b5c384219d3699(),
                        direction: new $9014d97cd777be10$export$64b5c384219d3699(),
                        color: new $9014d97cd777be10$export$892596cec99bc70e(),
                        distance: 0,
                        coneCos: 0,
                        penumbraCos: 0,
                        decay: 0
                    };
                    break;
                case "PointLight":
                    uniforms = {
                        position: new $9014d97cd777be10$export$64b5c384219d3699(),
                        color: new $9014d97cd777be10$export$892596cec99bc70e(),
                        distance: 0,
                        decay: 0
                    };
                    break;
                case "HemisphereLight":
                    uniforms = {
                        direction: new $9014d97cd777be10$export$64b5c384219d3699(),
                        skyColor: new $9014d97cd777be10$export$892596cec99bc70e(),
                        groundColor: new $9014d97cd777be10$export$892596cec99bc70e()
                    };
                    break;
                case "RectAreaLight":
                    uniforms = {
                        color: new $9014d97cd777be10$export$892596cec99bc70e(),
                        position: new $9014d97cd777be10$export$64b5c384219d3699(),
                        halfWidth: new $9014d97cd777be10$export$64b5c384219d3699(),
                        halfHeight: new $9014d97cd777be10$export$64b5c384219d3699()
                    };
                    break;
            }
            lights[light.id] = uniforms;
            return uniforms;
        }
    };
}
function $9014d97cd777be10$var$ShadowUniformsCache() {
    const lights = {};
    return {
        get: function(light) {
            if (lights[light.id] !== undefined) return lights[light.id];
            let uniforms;
            switch(light.type){
                case "DirectionalLight":
                    uniforms = {
                        shadowBias: 0,
                        shadowNormalBias: 0,
                        shadowRadius: 1,
                        shadowMapSize: new $9014d97cd777be10$export$c977b3e384af9ae1()
                    };
                    break;
                case "SpotLight":
                    uniforms = {
                        shadowBias: 0,
                        shadowNormalBias: 0,
                        shadowRadius: 1,
                        shadowMapSize: new $9014d97cd777be10$export$c977b3e384af9ae1()
                    };
                    break;
                case "PointLight":
                    uniforms = {
                        shadowBias: 0,
                        shadowNormalBias: 0,
                        shadowRadius: 1,
                        shadowMapSize: new $9014d97cd777be10$export$c977b3e384af9ae1(),
                        shadowCameraNear: 1,
                        shadowCameraFar: 1000
                    };
                    break;
            }
            lights[light.id] = uniforms;
            return uniforms;
        }
    };
}
let $9014d97cd777be10$var$nextVersion = 0;
function $9014d97cd777be10$var$shadowCastingAndTexturingLightsFirst(lightA, lightB) {
    return (lightB.castShadow ? 2 : 0) - (lightA.castShadow ? 2 : 0) + (lightB.map ? 1 : 0) - (lightA.map ? 1 : 0);
}
function $9014d97cd777be10$var$WebGLLights(extensions, capabilities) {
    const cache = new $9014d97cd777be10$var$UniformsCache();
    const shadowCache = $9014d97cd777be10$var$ShadowUniformsCache();
    const state = {
        version: 0,
        hash: {
            directionalLength: -1,
            pointLength: -1,
            spotLength: -1,
            rectAreaLength: -1,
            hemiLength: -1,
            numDirectionalShadows: -1,
            numPointShadows: -1,
            numSpotShadows: -1,
            numSpotMaps: -1
        },
        ambient: [
            0,
            0,
            0
        ],
        probe: [],
        directional: [],
        directionalShadow: [],
        directionalShadowMap: [],
        directionalShadowMatrix: [],
        spot: [],
        spotLightMap: [],
        spotShadow: [],
        spotShadowMap: [],
        spotLightMatrix: [],
        rectArea: [],
        rectAreaLTC1: null,
        rectAreaLTC2: null,
        point: [],
        pointShadow: [],
        pointShadowMap: [],
        pointShadowMatrix: [],
        hemi: [],
        numSpotLightShadowsWithMaps: 0
    };
    for(let i = 0; i < 9; i++)state.probe.push(new $9014d97cd777be10$export$64b5c384219d3699());
    const vector3 = new $9014d97cd777be10$export$64b5c384219d3699();
    const matrix4 = new $9014d97cd777be10$export$2ae72fc923e5eb5();
    const matrix42 = new $9014d97cd777be10$export$2ae72fc923e5eb5();
    function setup(lights, useLegacyLights) {
        let r = 0, g = 0, b = 0;
        for(let i = 0; i < 9; i++)state.probe[i].set(0, 0, 0);
        let directionalLength = 0;
        let pointLength = 0;
        let spotLength = 0;
        let rectAreaLength = 0;
        let hemiLength = 0;
        let numDirectionalShadows = 0;
        let numPointShadows = 0;
        let numSpotShadows = 0;
        let numSpotMaps = 0;
        let numSpotShadowsWithMaps = 0;
        // ordering : [shadow casting + map texturing, map texturing, shadow casting, none ]
        lights.sort($9014d97cd777be10$var$shadowCastingAndTexturingLightsFirst);
        // artist-friendly light intensity scaling factor
        const scaleFactor = useLegacyLights === true ? Math.PI : 1;
        for(let i = 0, l = lights.length; i < l; i++){
            const light = lights[i];
            const color = light.color;
            const intensity = light.intensity;
            const distance = light.distance;
            const shadowMap = light.shadow && light.shadow.map ? light.shadow.map.texture : null;
            if (light.isAmbientLight) {
                r += color.r * intensity * scaleFactor;
                g += color.g * intensity * scaleFactor;
                b += color.b * intensity * scaleFactor;
            } else if (light.isLightProbe) for(let j = 0; j < 9; j++)state.probe[j].addScaledVector(light.sh.coefficients[j], intensity);
            else if (light.isDirectionalLight) {
                const uniforms = cache.get(light);
                uniforms.color.copy(light.color).multiplyScalar(light.intensity * scaleFactor);
                if (light.castShadow) {
                    const shadow = light.shadow;
                    const shadowUniforms = shadowCache.get(light);
                    shadowUniforms.shadowBias = shadow.bias;
                    shadowUniforms.shadowNormalBias = shadow.normalBias;
                    shadowUniforms.shadowRadius = shadow.radius;
                    shadowUniforms.shadowMapSize = shadow.mapSize;
                    state.directionalShadow[directionalLength] = shadowUniforms;
                    state.directionalShadowMap[directionalLength] = shadowMap;
                    state.directionalShadowMatrix[directionalLength] = light.shadow.matrix;
                    numDirectionalShadows++;
                }
                state.directional[directionalLength] = uniforms;
                directionalLength++;
            } else if (light.isSpotLight) {
                const uniforms = cache.get(light);
                uniforms.position.setFromMatrixPosition(light.matrixWorld);
                uniforms.color.copy(color).multiplyScalar(intensity * scaleFactor);
                uniforms.distance = distance;
                uniforms.coneCos = Math.cos(light.angle);
                uniforms.penumbraCos = Math.cos(light.angle * (1 - light.penumbra));
                uniforms.decay = light.decay;
                state.spot[spotLength] = uniforms;
                const shadow = light.shadow;
                if (light.map) {
                    state.spotLightMap[numSpotMaps] = light.map;
                    numSpotMaps++;
                    // make sure the lightMatrix is up to date
                    // TODO : do it if required only
                    shadow.updateMatrices(light);
                    if (light.castShadow) numSpotShadowsWithMaps++;
                }
                state.spotLightMatrix[spotLength] = shadow.matrix;
                if (light.castShadow) {
                    const shadowUniforms = shadowCache.get(light);
                    shadowUniforms.shadowBias = shadow.bias;
                    shadowUniforms.shadowNormalBias = shadow.normalBias;
                    shadowUniforms.shadowRadius = shadow.radius;
                    shadowUniforms.shadowMapSize = shadow.mapSize;
                    state.spotShadow[spotLength] = shadowUniforms;
                    state.spotShadowMap[spotLength] = shadowMap;
                    numSpotShadows++;
                }
                spotLength++;
            } else if (light.isRectAreaLight) {
                const uniforms = cache.get(light);
                uniforms.color.copy(color).multiplyScalar(intensity);
                uniforms.halfWidth.set(light.width * 0.5, 0.0, 0.0);
                uniforms.halfHeight.set(0.0, light.height * 0.5, 0.0);
                state.rectArea[rectAreaLength] = uniforms;
                rectAreaLength++;
            } else if (light.isPointLight) {
                const uniforms = cache.get(light);
                uniforms.color.copy(light.color).multiplyScalar(light.intensity * scaleFactor);
                uniforms.distance = light.distance;
                uniforms.decay = light.decay;
                if (light.castShadow) {
                    const shadow = light.shadow;
                    const shadowUniforms = shadowCache.get(light);
                    shadowUniforms.shadowBias = shadow.bias;
                    shadowUniforms.shadowNormalBias = shadow.normalBias;
                    shadowUniforms.shadowRadius = shadow.radius;
                    shadowUniforms.shadowMapSize = shadow.mapSize;
                    shadowUniforms.shadowCameraNear = shadow.camera.near;
                    shadowUniforms.shadowCameraFar = shadow.camera.far;
                    state.pointShadow[pointLength] = shadowUniforms;
                    state.pointShadowMap[pointLength] = shadowMap;
                    state.pointShadowMatrix[pointLength] = light.shadow.matrix;
                    numPointShadows++;
                }
                state.point[pointLength] = uniforms;
                pointLength++;
            } else if (light.isHemisphereLight) {
                const uniforms = cache.get(light);
                uniforms.skyColor.copy(light.color).multiplyScalar(intensity * scaleFactor);
                uniforms.groundColor.copy(light.groundColor).multiplyScalar(intensity * scaleFactor);
                state.hemi[hemiLength] = uniforms;
                hemiLength++;
            }
        }
        if (rectAreaLength > 0) {
            if (capabilities.isWebGL2) {
                // WebGL 2
                state.rectAreaLTC1 = $9014d97cd777be10$export$6643083551874bf5.LTC_FLOAT_1;
                state.rectAreaLTC2 = $9014d97cd777be10$export$6643083551874bf5.LTC_FLOAT_2;
            } else {
                // WebGL 1
                if (extensions.has("OES_texture_float_linear") === true) {
                    state.rectAreaLTC1 = $9014d97cd777be10$export$6643083551874bf5.LTC_FLOAT_1;
                    state.rectAreaLTC2 = $9014d97cd777be10$export$6643083551874bf5.LTC_FLOAT_2;
                } else if (extensions.has("OES_texture_half_float_linear") === true) {
                    state.rectAreaLTC1 = $9014d97cd777be10$export$6643083551874bf5.LTC_HALF_1;
                    state.rectAreaLTC2 = $9014d97cd777be10$export$6643083551874bf5.LTC_HALF_2;
                } else console.error("THREE.WebGLRenderer: Unable to use RectAreaLight. Missing WebGL extensions.");
            }
        }
        state.ambient[0] = r;
        state.ambient[1] = g;
        state.ambient[2] = b;
        const hash = state.hash;
        if (hash.directionalLength !== directionalLength || hash.pointLength !== pointLength || hash.spotLength !== spotLength || hash.rectAreaLength !== rectAreaLength || hash.hemiLength !== hemiLength || hash.numDirectionalShadows !== numDirectionalShadows || hash.numPointShadows !== numPointShadows || hash.numSpotShadows !== numSpotShadows || hash.numSpotMaps !== numSpotMaps) {
            state.directional.length = directionalLength;
            state.spot.length = spotLength;
            state.rectArea.length = rectAreaLength;
            state.point.length = pointLength;
            state.hemi.length = hemiLength;
            state.directionalShadow.length = numDirectionalShadows;
            state.directionalShadowMap.length = numDirectionalShadows;
            state.pointShadow.length = numPointShadows;
            state.pointShadowMap.length = numPointShadows;
            state.spotShadow.length = numSpotShadows;
            state.spotShadowMap.length = numSpotShadows;
            state.directionalShadowMatrix.length = numDirectionalShadows;
            state.pointShadowMatrix.length = numPointShadows;
            state.spotLightMatrix.length = numSpotShadows + numSpotMaps - numSpotShadowsWithMaps;
            state.spotLightMap.length = numSpotMaps;
            state.numSpotLightShadowsWithMaps = numSpotShadowsWithMaps;
            hash.directionalLength = directionalLength;
            hash.pointLength = pointLength;
            hash.spotLength = spotLength;
            hash.rectAreaLength = rectAreaLength;
            hash.hemiLength = hemiLength;
            hash.numDirectionalShadows = numDirectionalShadows;
            hash.numPointShadows = numPointShadows;
            hash.numSpotShadows = numSpotShadows;
            hash.numSpotMaps = numSpotMaps;
            state.version = $9014d97cd777be10$var$nextVersion++;
        }
    }
    function setupView(lights, camera) {
        let directionalLength = 0;
        let pointLength = 0;
        let spotLength = 0;
        let rectAreaLength = 0;
        let hemiLength = 0;
        const viewMatrix = camera.matrixWorldInverse;
        for(let i = 0, l = lights.length; i < l; i++){
            const light = lights[i];
            if (light.isDirectionalLight) {
                const uniforms = state.directional[directionalLength];
                uniforms.direction.setFromMatrixPosition(light.matrixWorld);
                vector3.setFromMatrixPosition(light.target.matrixWorld);
                uniforms.direction.sub(vector3);
                uniforms.direction.transformDirection(viewMatrix);
                directionalLength++;
            } else if (light.isSpotLight) {
                const uniforms = state.spot[spotLength];
                uniforms.position.setFromMatrixPosition(light.matrixWorld);
                uniforms.position.applyMatrix4(viewMatrix);
                uniforms.direction.setFromMatrixPosition(light.matrixWorld);
                vector3.setFromMatrixPosition(light.target.matrixWorld);
                uniforms.direction.sub(vector3);
                uniforms.direction.transformDirection(viewMatrix);
                spotLength++;
            } else if (light.isRectAreaLight) {
                const uniforms = state.rectArea[rectAreaLength];
                uniforms.position.setFromMatrixPosition(light.matrixWorld);
                uniforms.position.applyMatrix4(viewMatrix);
                // extract local rotation of light to derive width/height half vectors
                matrix42.identity();
                matrix4.copy(light.matrixWorld);
                matrix4.premultiply(viewMatrix);
                matrix42.extractRotation(matrix4);
                uniforms.halfWidth.set(light.width * 0.5, 0.0, 0.0);
                uniforms.halfHeight.set(0.0, light.height * 0.5, 0.0);
                uniforms.halfWidth.applyMatrix4(matrix42);
                uniforms.halfHeight.applyMatrix4(matrix42);
                rectAreaLength++;
            } else if (light.isPointLight) {
                const uniforms = state.point[pointLength];
                uniforms.position.setFromMatrixPosition(light.matrixWorld);
                uniforms.position.applyMatrix4(viewMatrix);
                pointLength++;
            } else if (light.isHemisphereLight) {
                const uniforms = state.hemi[hemiLength];
                uniforms.direction.setFromMatrixPosition(light.matrixWorld);
                uniforms.direction.transformDirection(viewMatrix);
                hemiLength++;
            }
        }
    }
    return {
        setup: setup,
        setupView: setupView,
        state: state
    };
}
function $9014d97cd777be10$var$WebGLRenderState(extensions, capabilities) {
    const lights = new $9014d97cd777be10$var$WebGLLights(extensions, capabilities);
    const lightsArray = [];
    const shadowsArray = [];
    function init() {
        lightsArray.length = 0;
        shadowsArray.length = 0;
    }
    function pushLight(light) {
        lightsArray.push(light);
    }
    function pushShadow(shadowLight) {
        shadowsArray.push(shadowLight);
    }
    function setupLights(useLegacyLights) {
        lights.setup(lightsArray, useLegacyLights);
    }
    function setupLightsView(camera) {
        lights.setupView(lightsArray, camera);
    }
    const state = {
        lightsArray: lightsArray,
        shadowsArray: shadowsArray,
        lights: lights
    };
    return {
        init: init,
        state: state,
        setupLights: setupLights,
        setupLightsView: setupLightsView,
        pushLight: pushLight,
        pushShadow: pushShadow
    };
}
function $9014d97cd777be10$var$WebGLRenderStates(extensions, capabilities) {
    let renderStates = new WeakMap();
    function get(scene, renderCallDepth = 0) {
        const renderStateArray = renderStates.get(scene);
        let renderState;
        if (renderStateArray === undefined) {
            renderState = new $9014d97cd777be10$var$WebGLRenderState(extensions, capabilities);
            renderStates.set(scene, [
                renderState
            ]);
        } else if (renderCallDepth >= renderStateArray.length) {
            renderState = new $9014d97cd777be10$var$WebGLRenderState(extensions, capabilities);
            renderStateArray.push(renderState);
        } else renderState = renderStateArray[renderCallDepth];
        return renderState;
    }
    function dispose() {
        renderStates = new WeakMap();
    }
    return {
        get: get,
        dispose: dispose
    };
}
class $9014d97cd777be10$export$2698c22ec13825db extends $9014d97cd777be10$export$a2d8b23205c25948 {
    copy(source) {
        super.copy(source);
        this.depthPacking = source.depthPacking;
        this.map = source.map;
        this.alphaMap = source.alphaMap;
        this.displacementMap = source.displacementMap;
        this.displacementScale = source.displacementScale;
        this.displacementBias = source.displacementBias;
        this.wireframe = source.wireframe;
        this.wireframeLinewidth = source.wireframeLinewidth;
        return this;
    }
    constructor(parameters){
        super();
        this.isMeshDepthMaterial = true;
        this.type = "MeshDepthMaterial";
        this.depthPacking = $9014d97cd777be10$export$deeb383078690b50;
        this.map = null;
        this.alphaMap = null;
        this.displacementMap = null;
        this.displacementScale = 1;
        this.displacementBias = 0;
        this.wireframe = false;
        this.wireframeLinewidth = 1;
        this.setValues(parameters);
    }
}
class $9014d97cd777be10$export$33e187ed002f2a19 extends $9014d97cd777be10$export$a2d8b23205c25948 {
    copy(source) {
        super.copy(source);
        this.map = source.map;
        this.alphaMap = source.alphaMap;
        this.displacementMap = source.displacementMap;
        this.displacementScale = source.displacementScale;
        this.displacementBias = source.displacementBias;
        return this;
    }
    constructor(parameters){
        super();
        this.isMeshDistanceMaterial = true;
        this.type = "MeshDistanceMaterial";
        this.map = null;
        this.alphaMap = null;
        this.displacementMap = null;
        this.displacementScale = 1;
        this.displacementBias = 0;
        this.setValues(parameters);
    }
}
const $9014d97cd777be10$var$vertex = "void main() {\n	gl_Position = vec4( position, 1.0 );\n}";
const $9014d97cd777be10$var$fragment = "uniform sampler2D shadow_pass;\nuniform vec2 resolution;\nuniform float radius;\n#include <packing>\nvoid main() {\n	const float samples = float( VSM_SAMPLES );\n	float mean = 0.0;\n	float squared_mean = 0.0;\n	float uvStride = samples <= 1.0 ? 0.0 : 2.0 / ( samples - 1.0 );\n	float uvStart = samples <= 1.0 ? 0.0 : - 1.0;\n	for ( float i = 0.0; i < samples; i ++ ) {\n		float uvOffset = uvStart + i * uvStride;\n		#ifdef HORIZONTAL_PASS\n			vec2 distribution = unpackRGBATo2Half( texture2D( shadow_pass, ( gl_FragCoord.xy + vec2( uvOffset, 0.0 ) * radius ) / resolution ) );\n			mean += distribution.x;\n			squared_mean += distribution.y * distribution.y + distribution.x * distribution.x;\n		#else\n			float depth = unpackRGBAToDepth( texture2D( shadow_pass, ( gl_FragCoord.xy + vec2( 0.0, uvOffset ) * radius ) / resolution ) );\n			mean += depth;\n			squared_mean += depth * depth;\n		#endif\n	}\n	mean = mean / samples;\n	squared_mean = squared_mean / samples;\n	float std_dev = sqrt( squared_mean - mean * mean );\n	gl_FragColor = pack2HalfToRGBA( vec2( mean, std_dev ) );\n}";
function $9014d97cd777be10$var$WebGLShadowMap(_renderer, _objects, _capabilities) {
    let _frustum = new $9014d97cd777be10$export$35efe6f4c85463d2();
    const _shadowMapSize = new $9014d97cd777be10$export$c977b3e384af9ae1(), _viewportSize = new $9014d97cd777be10$export$c977b3e384af9ae1(), _viewport = new $9014d97cd777be10$export$fa7daccca11cdbe3(), _depthMaterial = new $9014d97cd777be10$export$2698c22ec13825db({
        depthPacking: $9014d97cd777be10$export$8f910f4c4f73df11
    }), _distanceMaterial = new $9014d97cd777be10$export$33e187ed002f2a19(), _materialCache = {}, _maxTextureSize = _capabilities.maxTextureSize;
    const shadowSide = {
        [$9014d97cd777be10$export$2ede184fc2998901]: $9014d97cd777be10$export$d9f0486e75b5ace,
        [$9014d97cd777be10$export$d9f0486e75b5ace]: $9014d97cd777be10$export$2ede184fc2998901,
        [$9014d97cd777be10$export$3b296b6f144d5b03]: $9014d97cd777be10$export$3b296b6f144d5b03
    };
    const shadowMaterialVertical = new $9014d97cd777be10$export$83c7d75d550a8b0d({
        defines: {
            VSM_SAMPLES: 8
        },
        uniforms: {
            shadow_pass: {
                value: null
            },
            resolution: {
                value: new $9014d97cd777be10$export$c977b3e384af9ae1()
            },
            radius: {
                value: 4.0
            }
        },
        vertexShader: $9014d97cd777be10$var$vertex,
        fragmentShader: $9014d97cd777be10$var$fragment
    });
    const shadowMaterialHorizontal = shadowMaterialVertical.clone();
    shadowMaterialHorizontal.defines.HORIZONTAL_PASS = 1;
    const fullScreenTri = new $9014d97cd777be10$export$b7be63a67df8959();
    fullScreenTri.setAttribute("position", new $9014d97cd777be10$export$8dea267bd6bde117(new Float32Array([
        -1,
        -1,
        0.5,
        3,
        -1,
        0.5,
        -1,
        3,
        0.5
    ]), 3));
    const fullScreenMesh = new $9014d97cd777be10$export$e176487c05830cc5(fullScreenTri, shadowMaterialVertical);
    const scope = this;
    this.enabled = false;
    this.autoUpdate = true;
    this.needsUpdate = false;
    this.type = $9014d97cd777be10$export$5813f879eee7cd88;
    let _previousType = this.type;
    this.render = function(lights, scene, camera) {
        if (scope.enabled === false) return;
        if (scope.autoUpdate === false && scope.needsUpdate === false) return;
        if (lights.length === 0) return;
        const currentRenderTarget = _renderer.getRenderTarget();
        const activeCubeFace = _renderer.getActiveCubeFace();
        const activeMipmapLevel = _renderer.getActiveMipmapLevel();
        const _state = _renderer.state;
        // Set GL state for depth map.
        _state.setBlending($9014d97cd777be10$export$63b8d6b580fc65ba);
        _state.buffers.color.setClear(1, 1, 1, 1);
        _state.buffers.depth.setTest(true);
        _state.setScissorTest(false);
        // check for shadow map type changes
        const toVSM = _previousType !== $9014d97cd777be10$export$896ae1ade6c829c4 && this.type === $9014d97cd777be10$export$896ae1ade6c829c4;
        const fromVSM = _previousType === $9014d97cd777be10$export$896ae1ade6c829c4 && this.type !== $9014d97cd777be10$export$896ae1ade6c829c4;
        // render depth map
        for(let i = 0, il = lights.length; i < il; i++){
            const light = lights[i];
            const shadow = light.shadow;
            if (shadow === undefined) {
                console.warn("THREE.WebGLShadowMap:", light, "has no shadow.");
                continue;
            }
            if (shadow.autoUpdate === false && shadow.needsUpdate === false) continue;
            _shadowMapSize.copy(shadow.mapSize);
            const shadowFrameExtents = shadow.getFrameExtents();
            _shadowMapSize.multiply(shadowFrameExtents);
            _viewportSize.copy(shadow.mapSize);
            if (_shadowMapSize.x > _maxTextureSize || _shadowMapSize.y > _maxTextureSize) {
                if (_shadowMapSize.x > _maxTextureSize) {
                    _viewportSize.x = Math.floor(_maxTextureSize / shadowFrameExtents.x);
                    _shadowMapSize.x = _viewportSize.x * shadowFrameExtents.x;
                    shadow.mapSize.x = _viewportSize.x;
                }
                if (_shadowMapSize.y > _maxTextureSize) {
                    _viewportSize.y = Math.floor(_maxTextureSize / shadowFrameExtents.y);
                    _shadowMapSize.y = _viewportSize.y * shadowFrameExtents.y;
                    shadow.mapSize.y = _viewportSize.y;
                }
            }
            if (shadow.map === null || toVSM === true || fromVSM === true) {
                const pars = this.type !== $9014d97cd777be10$export$896ae1ade6c829c4 ? {
                    minFilter: $9014d97cd777be10$export$727aa5ec3fe39bf0,
                    magFilter: $9014d97cd777be10$export$727aa5ec3fe39bf0
                } : {};
                if (shadow.map !== null) shadow.map.dispose();
                shadow.map = new $9014d97cd777be10$export$3c052beb2e51e23f(_shadowMapSize.x, _shadowMapSize.y, pars);
                shadow.map.texture.name = light.name + ".shadowMap";
                shadow.camera.updateProjectionMatrix();
            }
            _renderer.setRenderTarget(shadow.map);
            _renderer.clear();
            const viewportCount = shadow.getViewportCount();
            for(let vp = 0; vp < viewportCount; vp++){
                const viewport = shadow.getViewport(vp);
                _viewport.set(_viewportSize.x * viewport.x, _viewportSize.y * viewport.y, _viewportSize.x * viewport.z, _viewportSize.y * viewport.w);
                _state.viewport(_viewport);
                shadow.updateMatrices(light, vp);
                _frustum = shadow.getFrustum();
                renderObject(scene, camera, shadow.camera, light, this.type);
            }
            // do blur pass for VSM
            if (shadow.isPointLightShadow !== true && this.type === $9014d97cd777be10$export$896ae1ade6c829c4) VSMPass(shadow, camera);
            shadow.needsUpdate = false;
        }
        _previousType = this.type;
        scope.needsUpdate = false;
        _renderer.setRenderTarget(currentRenderTarget, activeCubeFace, activeMipmapLevel);
    };
    function VSMPass(shadow, camera) {
        const geometry = _objects.update(fullScreenMesh);
        if (shadowMaterialVertical.defines.VSM_SAMPLES !== shadow.blurSamples) {
            shadowMaterialVertical.defines.VSM_SAMPLES = shadow.blurSamples;
            shadowMaterialHorizontal.defines.VSM_SAMPLES = shadow.blurSamples;
            shadowMaterialVertical.needsUpdate = true;
            shadowMaterialHorizontal.needsUpdate = true;
        }
        if (shadow.mapPass === null) shadow.mapPass = new $9014d97cd777be10$export$3c052beb2e51e23f(_shadowMapSize.x, _shadowMapSize.y);
        // vertical pass
        shadowMaterialVertical.uniforms.shadow_pass.value = shadow.map.texture;
        shadowMaterialVertical.uniforms.resolution.value = shadow.mapSize;
        shadowMaterialVertical.uniforms.radius.value = shadow.radius;
        _renderer.setRenderTarget(shadow.mapPass);
        _renderer.clear();
        _renderer.renderBufferDirect(camera, null, geometry, shadowMaterialVertical, fullScreenMesh, null);
        // horizontal pass
        shadowMaterialHorizontal.uniforms.shadow_pass.value = shadow.mapPass.texture;
        shadowMaterialHorizontal.uniforms.resolution.value = shadow.mapSize;
        shadowMaterialHorizontal.uniforms.radius.value = shadow.radius;
        _renderer.setRenderTarget(shadow.map);
        _renderer.clear();
        _renderer.renderBufferDirect(camera, null, geometry, shadowMaterialHorizontal, fullScreenMesh, null);
    }
    function getDepthMaterial(object, material, light, type) {
        let result = null;
        const customMaterial = light.isPointLight === true ? object.customDistanceMaterial : object.customDepthMaterial;
        if (customMaterial !== undefined) result = customMaterial;
        else {
            result = light.isPointLight === true ? _distanceMaterial : _depthMaterial;
            if (_renderer.localClippingEnabled && material.clipShadows === true && Array.isArray(material.clippingPlanes) && material.clippingPlanes.length !== 0 || material.displacementMap && material.displacementScale !== 0 || material.alphaMap && material.alphaTest > 0 || material.map && material.alphaTest > 0) {
                // in this case we need a unique material instance reflecting the
                // appropriate state
                const keyA = result.uuid, keyB = material.uuid;
                let materialsForVariant = _materialCache[keyA];
                if (materialsForVariant === undefined) {
                    materialsForVariant = {};
                    _materialCache[keyA] = materialsForVariant;
                }
                let cachedMaterial = materialsForVariant[keyB];
                if (cachedMaterial === undefined) {
                    cachedMaterial = result.clone();
                    materialsForVariant[keyB] = cachedMaterial;
                }
                result = cachedMaterial;
            }
        }
        result.visible = material.visible;
        result.wireframe = material.wireframe;
        if (type === $9014d97cd777be10$export$896ae1ade6c829c4) result.side = material.shadowSide !== null ? material.shadowSide : material.side;
        else result.side = material.shadowSide !== null ? material.shadowSide : shadowSide[material.side];
        result.alphaMap = material.alphaMap;
        result.alphaTest = material.alphaTest;
        result.map = material.map;
        result.clipShadows = material.clipShadows;
        result.clippingPlanes = material.clippingPlanes;
        result.clipIntersection = material.clipIntersection;
        result.displacementMap = material.displacementMap;
        result.displacementScale = material.displacementScale;
        result.displacementBias = material.displacementBias;
        result.wireframeLinewidth = material.wireframeLinewidth;
        result.linewidth = material.linewidth;
        if (light.isPointLight === true && result.isMeshDistanceMaterial === true) {
            const materialProperties = _renderer.properties.get(result);
            materialProperties.light = light;
        }
        return result;
    }
    function renderObject(object, camera, shadowCamera, light, type) {
        if (object.visible === false) return;
        const visible = object.layers.test(camera.layers);
        if (visible && (object.isMesh || object.isLine || object.isPoints)) {
            if ((object.castShadow || object.receiveShadow && type === $9014d97cd777be10$export$896ae1ade6c829c4) && (!object.frustumCulled || _frustum.intersectsObject(object))) {
                object.modelViewMatrix.multiplyMatrices(shadowCamera.matrixWorldInverse, object.matrixWorld);
                const geometry = _objects.update(object);
                const material = object.material;
                if (Array.isArray(material)) {
                    const groups = geometry.groups;
                    for(let k = 0, kl = groups.length; k < kl; k++){
                        const group = groups[k];
                        const groupMaterial = material[group.materialIndex];
                        if (groupMaterial && groupMaterial.visible) {
                            const depthMaterial = getDepthMaterial(object, groupMaterial, light, type);
                            _renderer.renderBufferDirect(shadowCamera, null, geometry, depthMaterial, object, group);
                        }
                    }
                } else if (material.visible) {
                    const depthMaterial = getDepthMaterial(object, material, light, type);
                    _renderer.renderBufferDirect(shadowCamera, null, geometry, depthMaterial, object, null);
                }
            }
        }
        const children = object.children;
        for(let i = 0, l = children.length; i < l; i++)renderObject(children[i], camera, shadowCamera, light, type);
    }
}
function $9014d97cd777be10$var$WebGLState(gl, extensions, capabilities) {
    const isWebGL2 = capabilities.isWebGL2;
    function ColorBuffer() {
        let locked = false;
        const color = new $9014d97cd777be10$export$fa7daccca11cdbe3();
        let currentColorMask = null;
        const currentColorClear = new $9014d97cd777be10$export$fa7daccca11cdbe3(0, 0, 0, 0);
        return {
            setMask: function(colorMask) {
                if (currentColorMask !== colorMask && !locked) {
                    gl.colorMask(colorMask, colorMask, colorMask, colorMask);
                    currentColorMask = colorMask;
                }
            },
            setLocked: function(lock) {
                locked = lock;
            },
            setClear: function(r, g, b, a, premultipliedAlpha) {
                if (premultipliedAlpha === true) {
                    r *= a;
                    g *= a;
                    b *= a;
                }
                color.set(r, g, b, a);
                if (currentColorClear.equals(color) === false) {
                    gl.clearColor(r, g, b, a);
                    currentColorClear.copy(color);
                }
            },
            reset: function() {
                locked = false;
                currentColorMask = null;
                currentColorClear.set(-1, 0, 0, 0); // set to invalid state
            }
        };
    }
    function DepthBuffer() {
        let locked = false;
        let currentDepthMask = null;
        let currentDepthFunc = null;
        let currentDepthClear = null;
        return {
            setTest: function(depthTest) {
                if (depthTest) enable(gl.DEPTH_TEST);
                else disable(gl.DEPTH_TEST);
            },
            setMask: function(depthMask) {
                if (currentDepthMask !== depthMask && !locked) {
                    gl.depthMask(depthMask);
                    currentDepthMask = depthMask;
                }
            },
            setFunc: function(depthFunc) {
                if (currentDepthFunc !== depthFunc) {
                    switch(depthFunc){
                        case $9014d97cd777be10$export$69025ce147cee220:
                            gl.depthFunc(gl.NEVER);
                            break;
                        case $9014d97cd777be10$export$7182eb52ea3b3f04:
                            gl.depthFunc(gl.ALWAYS);
                            break;
                        case $9014d97cd777be10$export$eedccec66ab7ebe:
                            gl.depthFunc(gl.LESS);
                            break;
                        case $9014d97cd777be10$export$296f78a0b892f81a:
                            gl.depthFunc(gl.LEQUAL);
                            break;
                        case $9014d97cd777be10$export$a60d398fc7b7590e:
                            gl.depthFunc(gl.EQUAL);
                            break;
                        case $9014d97cd777be10$export$7d7234c1240a1fc4:
                            gl.depthFunc(gl.GEQUAL);
                            break;
                        case $9014d97cd777be10$export$c5e2c52991f30937:
                            gl.depthFunc(gl.GREATER);
                            break;
                        case $9014d97cd777be10$export$2f843afa843d8916:
                            gl.depthFunc(gl.NOTEQUAL);
                            break;
                        default:
                            gl.depthFunc(gl.LEQUAL);
                    }
                    currentDepthFunc = depthFunc;
                }
            },
            setLocked: function(lock) {
                locked = lock;
            },
            setClear: function(depth) {
                if (currentDepthClear !== depth) {
                    gl.clearDepth(depth);
                    currentDepthClear = depth;
                }
            },
            reset: function() {
                locked = false;
                currentDepthMask = null;
                currentDepthFunc = null;
                currentDepthClear = null;
            }
        };
    }
    function StencilBuffer() {
        let locked = false;
        let currentStencilMask = null;
        let currentStencilFunc = null;
        let currentStencilRef = null;
        let currentStencilFuncMask = null;
        let currentStencilFail = null;
        let currentStencilZFail = null;
        let currentStencilZPass = null;
        let currentStencilClear = null;
        return {
            setTest: function(stencilTest) {
                if (!locked) {
                    if (stencilTest) enable(gl.STENCIL_TEST);
                    else disable(gl.STENCIL_TEST);
                }
            },
            setMask: function(stencilMask) {
                if (currentStencilMask !== stencilMask && !locked) {
                    gl.stencilMask(stencilMask);
                    currentStencilMask = stencilMask;
                }
            },
            setFunc: function(stencilFunc, stencilRef, stencilMask) {
                if (currentStencilFunc !== stencilFunc || currentStencilRef !== stencilRef || currentStencilFuncMask !== stencilMask) {
                    gl.stencilFunc(stencilFunc, stencilRef, stencilMask);
                    currentStencilFunc = stencilFunc;
                    currentStencilRef = stencilRef;
                    currentStencilFuncMask = stencilMask;
                }
            },
            setOp: function(stencilFail, stencilZFail, stencilZPass) {
                if (currentStencilFail !== stencilFail || currentStencilZFail !== stencilZFail || currentStencilZPass !== stencilZPass) {
                    gl.stencilOp(stencilFail, stencilZFail, stencilZPass);
                    currentStencilFail = stencilFail;
                    currentStencilZFail = stencilZFail;
                    currentStencilZPass = stencilZPass;
                }
            },
            setLocked: function(lock) {
                locked = lock;
            },
            setClear: function(stencil) {
                if (currentStencilClear !== stencil) {
                    gl.clearStencil(stencil);
                    currentStencilClear = stencil;
                }
            },
            reset: function() {
                locked = false;
                currentStencilMask = null;
                currentStencilFunc = null;
                currentStencilRef = null;
                currentStencilFuncMask = null;
                currentStencilFail = null;
                currentStencilZFail = null;
                currentStencilZPass = null;
                currentStencilClear = null;
            }
        };
    }
    //
    const colorBuffer = new ColorBuffer();
    const depthBuffer = new DepthBuffer();
    const stencilBuffer = new StencilBuffer();
    const uboBindings = new WeakMap();
    const uboProgramMap = new WeakMap();
    let enabledCapabilities = {};
    let currentBoundFramebuffers = {};
    let currentDrawbuffers = new WeakMap();
    let defaultDrawbuffers = [];
    let currentProgram = null;
    let currentBlendingEnabled = false;
    let currentBlending = null;
    let currentBlendEquation = null;
    let currentBlendSrc = null;
    let currentBlendDst = null;
    let currentBlendEquationAlpha = null;
    let currentBlendSrcAlpha = null;
    let currentBlendDstAlpha = null;
    let currentPremultipledAlpha = false;
    let currentFlipSided = null;
    let currentCullFace = null;
    let currentLineWidth = null;
    let currentPolygonOffsetFactor = null;
    let currentPolygonOffsetUnits = null;
    const maxTextures = gl.getParameter(gl.MAX_COMBINED_TEXTURE_IMAGE_UNITS);
    let lineWidthAvailable = false;
    let version = 0;
    const glVersion = gl.getParameter(gl.VERSION);
    if (glVersion.indexOf("WebGL") !== -1) {
        version = parseFloat(/^WebGL (\d)/.exec(glVersion)[1]);
        lineWidthAvailable = version >= 1.0;
    } else if (glVersion.indexOf("OpenGL ES") !== -1) {
        version = parseFloat(/^OpenGL ES (\d)/.exec(glVersion)[1]);
        lineWidthAvailable = version >= 2.0;
    }
    let currentTextureSlot = null;
    let currentBoundTextures = {};
    const scissorParam = gl.getParameter(gl.SCISSOR_BOX);
    const viewportParam = gl.getParameter(gl.VIEWPORT);
    const currentScissor = new $9014d97cd777be10$export$fa7daccca11cdbe3().fromArray(scissorParam);
    const currentViewport = new $9014d97cd777be10$export$fa7daccca11cdbe3().fromArray(viewportParam);
    function createTexture(type, target, count, dimensions) {
        const data = new Uint8Array(4); // 4 is required to match default unpack alignment of 4.
        const texture = gl.createTexture();
        gl.bindTexture(type, texture);
        gl.texParameteri(type, gl.TEXTURE_MIN_FILTER, gl.NEAREST);
        gl.texParameteri(type, gl.TEXTURE_MAG_FILTER, gl.NEAREST);
        for(let i = 0; i < count; i++)if (isWebGL2 && (type === gl.TEXTURE_3D || type === gl.TEXTURE_2D_ARRAY)) gl.texImage3D(target, 0, gl.RGBA, 1, 1, dimensions, 0, gl.RGBA, gl.UNSIGNED_BYTE, data);
        else gl.texImage2D(target + i, 0, gl.RGBA, 1, 1, 0, gl.RGBA, gl.UNSIGNED_BYTE, data);
        return texture;
    }
    const emptyTextures = {};
    emptyTextures[gl.TEXTURE_2D] = createTexture(gl.TEXTURE_2D, gl.TEXTURE_2D, 1);
    emptyTextures[gl.TEXTURE_CUBE_MAP] = createTexture(gl.TEXTURE_CUBE_MAP, gl.TEXTURE_CUBE_MAP_POSITIVE_X, 6);
    if (isWebGL2) {
        emptyTextures[gl.TEXTURE_2D_ARRAY] = createTexture(gl.TEXTURE_2D_ARRAY, gl.TEXTURE_2D_ARRAY, 1, 1);
        emptyTextures[gl.TEXTURE_3D] = createTexture(gl.TEXTURE_3D, gl.TEXTURE_3D, 1, 1);
    }
    // init
    colorBuffer.setClear(0, 0, 0, 1);
    depthBuffer.setClear(1);
    stencilBuffer.setClear(0);
    enable(gl.DEPTH_TEST);
    depthBuffer.setFunc($9014d97cd777be10$export$296f78a0b892f81a);
    setFlipSided(false);
    setCullFace($9014d97cd777be10$export$b9a7b4fc5cb15f9b);
    enable(gl.CULL_FACE);
    setBlending($9014d97cd777be10$export$63b8d6b580fc65ba);
    //
    function enable(id) {
        if (enabledCapabilities[id] !== true) {
            gl.enable(id);
            enabledCapabilities[id] = true;
        }
    }
    function disable(id) {
        if (enabledCapabilities[id] !== false) {
            gl.disable(id);
            enabledCapabilities[id] = false;
        }
    }
    function bindFramebuffer(target, framebuffer) {
        if (currentBoundFramebuffers[target] !== framebuffer) {
            gl.bindFramebuffer(target, framebuffer);
            currentBoundFramebuffers[target] = framebuffer;
            if (isWebGL2) {
                // gl.DRAW_FRAMEBUFFER is equivalent to gl.FRAMEBUFFER
                if (target === gl.DRAW_FRAMEBUFFER) currentBoundFramebuffers[gl.FRAMEBUFFER] = framebuffer;
                if (target === gl.FRAMEBUFFER) currentBoundFramebuffers[gl.DRAW_FRAMEBUFFER] = framebuffer;
            }
            return true;
        }
        return false;
    }
    function drawBuffers(renderTarget, framebuffer) {
        let drawBuffers = defaultDrawbuffers;
        let needsUpdate = false;
        if (renderTarget) {
            drawBuffers = currentDrawbuffers.get(framebuffer);
            if (drawBuffers === undefined) {
                drawBuffers = [];
                currentDrawbuffers.set(framebuffer, drawBuffers);
            }
            if (renderTarget.isWebGLMultipleRenderTargets) {
                const textures = renderTarget.texture;
                if (drawBuffers.length !== textures.length || drawBuffers[0] !== gl.COLOR_ATTACHMENT0) {
                    for(let i = 0, il = textures.length; i < il; i++)drawBuffers[i] = gl.COLOR_ATTACHMENT0 + i;
                    drawBuffers.length = textures.length;
                    needsUpdate = true;
                }
            } else if (drawBuffers[0] !== gl.COLOR_ATTACHMENT0) {
                drawBuffers[0] = gl.COLOR_ATTACHMENT0;
                needsUpdate = true;
            }
        } else if (drawBuffers[0] !== gl.BACK) {
            drawBuffers[0] = gl.BACK;
            needsUpdate = true;
        }
        if (needsUpdate) {
            if (capabilities.isWebGL2) gl.drawBuffers(drawBuffers);
            else extensions.get("WEBGL_draw_buffers").drawBuffersWEBGL(drawBuffers);
        }
    }
    function useProgram(program) {
        if (currentProgram !== program) {
            gl.useProgram(program);
            currentProgram = program;
            return true;
        }
        return false;
    }
    const equationToGL = {
        [$9014d97cd777be10$export$20183a0484ce21a0]: gl.FUNC_ADD,
        [$9014d97cd777be10$export$73e0df5177988548]: gl.FUNC_SUBTRACT,
        [$9014d97cd777be10$export$28e582859cbec660]: gl.FUNC_REVERSE_SUBTRACT
    };
    if (isWebGL2) {
        equationToGL[$9014d97cd777be10$export$c8c1508da8d0600c] = gl.MIN;
        equationToGL[$9014d97cd777be10$export$99948c02fb51055f] = gl.MAX;
    } else {
        const extension = extensions.get("EXT_blend_minmax");
        if (extension !== null) {
            equationToGL[$9014d97cd777be10$export$c8c1508da8d0600c] = extension.MIN_EXT;
            equationToGL[$9014d97cd777be10$export$99948c02fb51055f] = extension.MAX_EXT;
        }
    }
    const factorToGL = {
        [$9014d97cd777be10$export$2110f05edf778d3d]: gl.ZERO,
        [$9014d97cd777be10$export$8805bad65e24940e]: gl.ONE,
        [$9014d97cd777be10$export$7fbe15b28d28cf52]: gl.SRC_COLOR,
        [$9014d97cd777be10$export$d5773124e86cf28c]: gl.SRC_ALPHA,
        [$9014d97cd777be10$export$c05e2a1fc8609506]: gl.SRC_ALPHA_SATURATE,
        [$9014d97cd777be10$export$ef5f2dd8ffac5574]: gl.DST_COLOR,
        [$9014d97cd777be10$export$a78aed1ca2a87192]: gl.DST_ALPHA,
        [$9014d97cd777be10$export$947829af9f2c17f6]: gl.ONE_MINUS_SRC_COLOR,
        [$9014d97cd777be10$export$11d468cc7f19e971]: gl.ONE_MINUS_SRC_ALPHA,
        [$9014d97cd777be10$export$56b85b2686ab16]: gl.ONE_MINUS_DST_COLOR,
        [$9014d97cd777be10$export$5d0fe17fd8773bac]: gl.ONE_MINUS_DST_ALPHA
    };
    function setBlending(blending, blendEquation, blendSrc, blendDst, blendEquationAlpha, blendSrcAlpha, blendDstAlpha, premultipliedAlpha) {
        if (blending === $9014d97cd777be10$export$63b8d6b580fc65ba) {
            if (currentBlendingEnabled === true) {
                disable(gl.BLEND);
                currentBlendingEnabled = false;
            }
            return;
        }
        if (currentBlendingEnabled === false) {
            enable(gl.BLEND);
            currentBlendingEnabled = true;
        }
        if (blending !== $9014d97cd777be10$export$eda4864c68df1fa2) {
            if (blending !== currentBlending || premultipliedAlpha !== currentPremultipledAlpha) {
                if (currentBlendEquation !== $9014d97cd777be10$export$20183a0484ce21a0 || currentBlendEquationAlpha !== $9014d97cd777be10$export$20183a0484ce21a0) {
                    gl.blendEquation(gl.FUNC_ADD);
                    currentBlendEquation = $9014d97cd777be10$export$20183a0484ce21a0;
                    currentBlendEquationAlpha = $9014d97cd777be10$export$20183a0484ce21a0;
                }
                if (premultipliedAlpha) switch(blending){
                    case $9014d97cd777be10$export$5b29a26d96ee6af0:
                        gl.blendFuncSeparate(gl.ONE, gl.ONE_MINUS_SRC_ALPHA, gl.ONE, gl.ONE_MINUS_SRC_ALPHA);
                        break;
                    case $9014d97cd777be10$export$777d8f9551c2216b:
                        gl.blendFunc(gl.ONE, gl.ONE);
                        break;
                    case $9014d97cd777be10$export$cdfa06f868e2e467:
                        gl.blendFuncSeparate(gl.ZERO, gl.ONE_MINUS_SRC_COLOR, gl.ZERO, gl.ONE);
                        break;
                    case $9014d97cd777be10$export$4138e1c684b46a20:
                        gl.blendFuncSeparate(gl.ZERO, gl.SRC_COLOR, gl.ZERO, gl.SRC_ALPHA);
                        break;
                    default:
                        console.error("THREE.WebGLState: Invalid blending: ", blending);
                        break;
                }
                else switch(blending){
                    case $9014d97cd777be10$export$5b29a26d96ee6af0:
                        gl.blendFuncSeparate(gl.SRC_ALPHA, gl.ONE_MINUS_SRC_ALPHA, gl.ONE, gl.ONE_MINUS_SRC_ALPHA);
                        break;
                    case $9014d97cd777be10$export$777d8f9551c2216b:
                        gl.blendFunc(gl.SRC_ALPHA, gl.ONE);
                        break;
                    case $9014d97cd777be10$export$cdfa06f868e2e467:
                        gl.blendFuncSeparate(gl.ZERO, gl.ONE_MINUS_SRC_COLOR, gl.ZERO, gl.ONE);
                        break;
                    case $9014d97cd777be10$export$4138e1c684b46a20:
                        gl.blendFunc(gl.ZERO, gl.SRC_COLOR);
                        break;
                    default:
                        console.error("THREE.WebGLState: Invalid blending: ", blending);
                        break;
                }
                currentBlendSrc = null;
                currentBlendDst = null;
                currentBlendSrcAlpha = null;
                currentBlendDstAlpha = null;
                currentBlending = blending;
                currentPremultipledAlpha = premultipliedAlpha;
            }
            return;
        }
        // custom blending
        blendEquationAlpha = blendEquationAlpha || blendEquation;
        blendSrcAlpha = blendSrcAlpha || blendSrc;
        blendDstAlpha = blendDstAlpha || blendDst;
        if (blendEquation !== currentBlendEquation || blendEquationAlpha !== currentBlendEquationAlpha) {
            gl.blendEquationSeparate(equationToGL[blendEquation], equationToGL[blendEquationAlpha]);
            currentBlendEquation = blendEquation;
            currentBlendEquationAlpha = blendEquationAlpha;
        }
        if (blendSrc !== currentBlendSrc || blendDst !== currentBlendDst || blendSrcAlpha !== currentBlendSrcAlpha || blendDstAlpha !== currentBlendDstAlpha) {
            gl.blendFuncSeparate(factorToGL[blendSrc], factorToGL[blendDst], factorToGL[blendSrcAlpha], factorToGL[blendDstAlpha]);
            currentBlendSrc = blendSrc;
            currentBlendDst = blendDst;
            currentBlendSrcAlpha = blendSrcAlpha;
            currentBlendDstAlpha = blendDstAlpha;
        }
        currentBlending = blending;
        currentPremultipledAlpha = false;
    }
    function setMaterial(material, frontFaceCW) {
        material.side === $9014d97cd777be10$export$3b296b6f144d5b03 ? disable(gl.CULL_FACE) : enable(gl.CULL_FACE);
        let flipSided = material.side === $9014d97cd777be10$export$d9f0486e75b5ace;
        if (frontFaceCW) flipSided = !flipSided;
        setFlipSided(flipSided);
        material.blending === $9014d97cd777be10$export$5b29a26d96ee6af0 && material.transparent === false ? setBlending($9014d97cd777be10$export$63b8d6b580fc65ba) : setBlending(material.blending, material.blendEquation, material.blendSrc, material.blendDst, material.blendEquationAlpha, material.blendSrcAlpha, material.blendDstAlpha, material.premultipliedAlpha);
        depthBuffer.setFunc(material.depthFunc);
        depthBuffer.setTest(material.depthTest);
        depthBuffer.setMask(material.depthWrite);
        colorBuffer.setMask(material.colorWrite);
        const stencilWrite = material.stencilWrite;
        stencilBuffer.setTest(stencilWrite);
        if (stencilWrite) {
            stencilBuffer.setMask(material.stencilWriteMask);
            stencilBuffer.setFunc(material.stencilFunc, material.stencilRef, material.stencilFuncMask);
            stencilBuffer.setOp(material.stencilFail, material.stencilZFail, material.stencilZPass);
        }
        setPolygonOffset(material.polygonOffset, material.polygonOffsetFactor, material.polygonOffsetUnits);
        material.alphaToCoverage === true ? enable(gl.SAMPLE_ALPHA_TO_COVERAGE) : disable(gl.SAMPLE_ALPHA_TO_COVERAGE);
    }
    //
    function setFlipSided(flipSided) {
        if (currentFlipSided !== flipSided) {
            if (flipSided) gl.frontFace(gl.CW);
            else gl.frontFace(gl.CCW);
            currentFlipSided = flipSided;
        }
    }
    function setCullFace(cullFace) {
        if (cullFace !== $9014d97cd777be10$export$3237e1f2c1ea1f44) {
            enable(gl.CULL_FACE);
            if (cullFace !== currentCullFace) {
                if (cullFace === $9014d97cd777be10$export$b9a7b4fc5cb15f9b) gl.cullFace(gl.BACK);
                else if (cullFace === $9014d97cd777be10$export$b8058bcc7037d3f3) gl.cullFace(gl.FRONT);
                else gl.cullFace(gl.FRONT_AND_BACK);
            }
        } else disable(gl.CULL_FACE);
        currentCullFace = cullFace;
    }
    function setLineWidth(width) {
        if (width !== currentLineWidth) {
            if (lineWidthAvailable) gl.lineWidth(width);
            currentLineWidth = width;
        }
    }
    function setPolygonOffset(polygonOffset, factor, units) {
        if (polygonOffset) {
            enable(gl.POLYGON_OFFSET_FILL);
            if (currentPolygonOffsetFactor !== factor || currentPolygonOffsetUnits !== units) {
                gl.polygonOffset(factor, units);
                currentPolygonOffsetFactor = factor;
                currentPolygonOffsetUnits = units;
            }
        } else disable(gl.POLYGON_OFFSET_FILL);
    }
    function setScissorTest(scissorTest) {
        if (scissorTest) enable(gl.SCISSOR_TEST);
        else disable(gl.SCISSOR_TEST);
    }
    // texture
    function activeTexture(webglSlot) {
        if (webglSlot === undefined) webglSlot = gl.TEXTURE0 + maxTextures - 1;
        if (currentTextureSlot !== webglSlot) {
            gl.activeTexture(webglSlot);
            currentTextureSlot = webglSlot;
        }
    }
    function bindTexture(webglType, webglTexture, webglSlot) {
        if (webglSlot === undefined) {
            if (currentTextureSlot === null) webglSlot = gl.TEXTURE0 + maxTextures - 1;
            else webglSlot = currentTextureSlot;
        }
        let boundTexture = currentBoundTextures[webglSlot];
        if (boundTexture === undefined) {
            boundTexture = {
                type: undefined,
                texture: undefined
            };
            currentBoundTextures[webglSlot] = boundTexture;
        }
        if (boundTexture.type !== webglType || boundTexture.texture !== webglTexture) {
            if (currentTextureSlot !== webglSlot) {
                gl.activeTexture(webglSlot);
                currentTextureSlot = webglSlot;
            }
            gl.bindTexture(webglType, webglTexture || emptyTextures[webglType]);
            boundTexture.type = webglType;
            boundTexture.texture = webglTexture;
        }
    }
    function unbindTexture() {
        const boundTexture = currentBoundTextures[currentTextureSlot];
        if (boundTexture !== undefined && boundTexture.type !== undefined) {
            gl.bindTexture(boundTexture.type, null);
            boundTexture.type = undefined;
            boundTexture.texture = undefined;
        }
    }
    function compressedTexImage2D() {
        try {
            gl.compressedTexImage2D.apply(gl, arguments);
        } catch (error) {
            console.error("THREE.WebGLState:", error);
        }
    }
    function compressedTexImage3D() {
        try {
            gl.compressedTexImage3D.apply(gl, arguments);
        } catch (error) {
            console.error("THREE.WebGLState:", error);
        }
    }
    function texSubImage2D() {
        try {
            gl.texSubImage2D.apply(gl, arguments);
        } catch (error) {
            console.error("THREE.WebGLState:", error);
        }
    }
    function texSubImage3D() {
        try {
            gl.texSubImage3D.apply(gl, arguments);
        } catch (error) {
            console.error("THREE.WebGLState:", error);
        }
    }
    function compressedTexSubImage2D() {
        try {
            gl.compressedTexSubImage2D.apply(gl, arguments);
        } catch (error) {
            console.error("THREE.WebGLState:", error);
        }
    }
    function compressedTexSubImage3D() {
        try {
            gl.compressedTexSubImage3D.apply(gl, arguments);
        } catch (error) {
            console.error("THREE.WebGLState:", error);
        }
    }
    function texStorage2D() {
        try {
            gl.texStorage2D.apply(gl, arguments);
        } catch (error) {
            console.error("THREE.WebGLState:", error);
        }
    }
    function texStorage3D() {
        try {
            gl.texStorage3D.apply(gl, arguments);
        } catch (error) {
            console.error("THREE.WebGLState:", error);
        }
    }
    function texImage2D() {
        try {
            gl.texImage2D.apply(gl, arguments);
        } catch (error) {
            console.error("THREE.WebGLState:", error);
        }
    }
    function texImage3D() {
        try {
            gl.texImage3D.apply(gl, arguments);
        } catch (error) {
            console.error("THREE.WebGLState:", error);
        }
    }
    //
    function scissor(scissor) {
        if (currentScissor.equals(scissor) === false) {
            gl.scissor(scissor.x, scissor.y, scissor.z, scissor.w);
            currentScissor.copy(scissor);
        }
    }
    function viewport(viewport) {
        if (currentViewport.equals(viewport) === false) {
            gl.viewport(viewport.x, viewport.y, viewport.z, viewport.w);
            currentViewport.copy(viewport);
        }
    }
    function updateUBOMapping(uniformsGroup, program) {
        let mapping = uboProgramMap.get(program);
        if (mapping === undefined) {
            mapping = new WeakMap();
            uboProgramMap.set(program, mapping);
        }
        let blockIndex = mapping.get(uniformsGroup);
        if (blockIndex === undefined) {
            blockIndex = gl.getUniformBlockIndex(program, uniformsGroup.name);
            mapping.set(uniformsGroup, blockIndex);
        }
    }
    function uniformBlockBinding(uniformsGroup, program) {
        const mapping = uboProgramMap.get(program);
        const blockIndex = mapping.get(uniformsGroup);
        if (uboBindings.get(program) !== blockIndex) {
            // bind shader specific block index to global block point
            gl.uniformBlockBinding(program, blockIndex, uniformsGroup.__bindingPointIndex);
            uboBindings.set(program, blockIndex);
        }
    }
    //
    function reset() {
        // reset state
        gl.disable(gl.BLEND);
        gl.disable(gl.CULL_FACE);
        gl.disable(gl.DEPTH_TEST);
        gl.disable(gl.POLYGON_OFFSET_FILL);
        gl.disable(gl.SCISSOR_TEST);
        gl.disable(gl.STENCIL_TEST);
        gl.disable(gl.SAMPLE_ALPHA_TO_COVERAGE);
        gl.blendEquation(gl.FUNC_ADD);
        gl.blendFunc(gl.ONE, gl.ZERO);
        gl.blendFuncSeparate(gl.ONE, gl.ZERO, gl.ONE, gl.ZERO);
        gl.colorMask(true, true, true, true);
        gl.clearColor(0, 0, 0, 0);
        gl.depthMask(true);
        gl.depthFunc(gl.LESS);
        gl.clearDepth(1);
        gl.stencilMask(0xffffffff);
        gl.stencilFunc(gl.ALWAYS, 0, 0xffffffff);
        gl.stencilOp(gl.KEEP, gl.KEEP, gl.KEEP);
        gl.clearStencil(0);
        gl.cullFace(gl.BACK);
        gl.frontFace(gl.CCW);
        gl.polygonOffset(0, 0);
        gl.activeTexture(gl.TEXTURE0);
        gl.bindFramebuffer(gl.FRAMEBUFFER, null);
        if (isWebGL2 === true) {
            gl.bindFramebuffer(gl.DRAW_FRAMEBUFFER, null);
            gl.bindFramebuffer(gl.READ_FRAMEBUFFER, null);
        }
        gl.useProgram(null);
        gl.lineWidth(1);
        gl.scissor(0, 0, gl.canvas.width, gl.canvas.height);
        gl.viewport(0, 0, gl.canvas.width, gl.canvas.height);
        // reset internals
        enabledCapabilities = {};
        currentTextureSlot = null;
        currentBoundTextures = {};
        currentBoundFramebuffers = {};
        currentDrawbuffers = new WeakMap();
        defaultDrawbuffers = [];
        currentProgram = null;
        currentBlendingEnabled = false;
        currentBlending = null;
        currentBlendEquation = null;
        currentBlendSrc = null;
        currentBlendDst = null;
        currentBlendEquationAlpha = null;
        currentBlendSrcAlpha = null;
        currentBlendDstAlpha = null;
        currentPremultipledAlpha = false;
        currentFlipSided = null;
        currentCullFace = null;
        currentLineWidth = null;
        currentPolygonOffsetFactor = null;
        currentPolygonOffsetUnits = null;
        currentScissor.set(0, 0, gl.canvas.width, gl.canvas.height);
        currentViewport.set(0, 0, gl.canvas.width, gl.canvas.height);
        colorBuffer.reset();
        depthBuffer.reset();
        stencilBuffer.reset();
    }
    return {
        buffers: {
            color: colorBuffer,
            depth: depthBuffer,
            stencil: stencilBuffer
        },
        enable: enable,
        disable: disable,
        bindFramebuffer: bindFramebuffer,
        drawBuffers: drawBuffers,
        useProgram: useProgram,
        setBlending: setBlending,
        setMaterial: setMaterial,
        setFlipSided: setFlipSided,
        setCullFace: setCullFace,
        setLineWidth: setLineWidth,
        setPolygonOffset: setPolygonOffset,
        setScissorTest: setScissorTest,
        activeTexture: activeTexture,
        bindTexture: bindTexture,
        unbindTexture: unbindTexture,
        compressedTexImage2D: compressedTexImage2D,
        compressedTexImage3D: compressedTexImage3D,
        texImage2D: texImage2D,
        texImage3D: texImage3D,
        updateUBOMapping: updateUBOMapping,
        uniformBlockBinding: uniformBlockBinding,
        texStorage2D: texStorage2D,
        texStorage3D: texStorage3D,
        texSubImage2D: texSubImage2D,
        texSubImage3D: texSubImage3D,
        compressedTexSubImage2D: compressedTexSubImage2D,
        compressedTexSubImage3D: compressedTexSubImage3D,
        scissor: scissor,
        viewport: viewport,
        reset: reset
    };
}
function $9014d97cd777be10$var$WebGLTextures(_gl, extensions, state, properties, capabilities, utils, info) {
    const isWebGL2 = capabilities.isWebGL2;
    const maxTextures = capabilities.maxTextures;
    const maxCubemapSize = capabilities.maxCubemapSize;
    const maxTextureSize = capabilities.maxTextureSize;
    const maxSamples = capabilities.maxSamples;
    const multisampledRTTExt = extensions.has("WEBGL_multisampled_render_to_texture") ? extensions.get("WEBGL_multisampled_render_to_texture") : null;
    const supportsInvalidateFramebuffer = typeof navigator === "undefined" ? false : /OculusBrowser/g.test(navigator.userAgent);
    const _videoTextures = new WeakMap();
    let _canvas;
    const _sources = new WeakMap(); // maps WebglTexture objects to instances of Source
    // cordova iOS (as of 5.0) still uses UIWebView, which provides OffscreenCanvas,
    // also OffscreenCanvas.getContext("webgl"), but not OffscreenCanvas.getContext("2d")!
    // Some implementations may only implement OffscreenCanvas partially (e.g. lacking 2d).
    let useOffscreenCanvas = false;
    try {
        useOffscreenCanvas = typeof OffscreenCanvas !== "undefined" && new OffscreenCanvas(1, 1).getContext("2d") !== null;
    } catch (err) {
    // Ignore any errors
    }
    function createCanvas(width, height) {
        // Use OffscreenCanvas when available. Specially needed in web workers
        return useOffscreenCanvas ? // eslint-disable-next-line compat/compat
        new OffscreenCanvas(width, height) : $9014d97cd777be10$var$createElementNS("canvas");
    }
    function resizeImage(image, needsPowerOfTwo, needsNewCanvas, maxSize) {
        let scale = 1;
        // handle case if texture exceeds max size
        if (image.width > maxSize || image.height > maxSize) scale = maxSize / Math.max(image.width, image.height);
        // only perform resize if necessary
        if (scale < 1 || needsPowerOfTwo === true) {
            // only perform resize for certain image types
            if (typeof HTMLImageElement !== "undefined" && image instanceof HTMLImageElement || typeof HTMLCanvasElement !== "undefined" && image instanceof HTMLCanvasElement || typeof ImageBitmap !== "undefined" && image instanceof ImageBitmap) {
                const floor = needsPowerOfTwo ? $9014d97cd777be10$var$floorPowerOfTwo : Math.floor;
                const width = floor(scale * image.width);
                const height = floor(scale * image.height);
                if (_canvas === undefined) _canvas = createCanvas(width, height);
                // cube textures can't reuse the same canvas
                const canvas = needsNewCanvas ? createCanvas(width, height) : _canvas;
                canvas.width = width;
                canvas.height = height;
                const context = canvas.getContext("2d");
                context.drawImage(image, 0, 0, width, height);
                console.warn("THREE.WebGLRenderer: Texture has been resized from (" + image.width + "x" + image.height + ") to (" + width + "x" + height + ").");
                return canvas;
            } else {
                if ("data" in image) console.warn("THREE.WebGLRenderer: Image in DataTexture is too big (" + image.width + "x" + image.height + ").");
                return image;
            }
        }
        return image;
    }
    function isPowerOfTwo$1(image) {
        return $9014d97cd777be10$var$isPowerOfTwo(image.width) && $9014d97cd777be10$var$isPowerOfTwo(image.height);
    }
    function textureNeedsPowerOfTwo(texture) {
        if (isWebGL2) return false;
        return texture.wrapS !== $9014d97cd777be10$export$9d9334239a5a5e06 || texture.wrapT !== $9014d97cd777be10$export$9d9334239a5a5e06 || texture.minFilter !== $9014d97cd777be10$export$727aa5ec3fe39bf0 && texture.minFilter !== $9014d97cd777be10$export$8a72f490b25c56c8;
    }
    function textureNeedsGenerateMipmaps(texture, supportsMips) {
        return texture.generateMipmaps && supportsMips && texture.minFilter !== $9014d97cd777be10$export$727aa5ec3fe39bf0 && texture.minFilter !== $9014d97cd777be10$export$8a72f490b25c56c8;
    }
    function generateMipmap(target) {
        _gl.generateMipmap(target);
    }
    function getInternalFormat(internalFormatName, glFormat, glType, colorSpace1, forceLinearTransfer = false) {
        if (isWebGL2 === false) return glFormat;
        if (internalFormatName !== null) {
            if (_gl[internalFormatName] !== undefined) return _gl[internalFormatName];
            console.warn("THREE.WebGLRenderer: Attempt to use non-existing WebGL internal format '" + internalFormatName + "'");
        }
        let internalFormat = glFormat;
        if (glFormat === _gl.RED) {
            if (glType === _gl.FLOAT) internalFormat = _gl.R32F;
            if (glType === _gl.HALF_FLOAT) internalFormat = _gl.R16F;
            if (glType === _gl.UNSIGNED_BYTE) internalFormat = _gl.R8;
        }
        if (glFormat === _gl.RED_INTEGER) {
            if (glType === _gl.UNSIGNED_BYTE) internalFormat = _gl.R8UI;
            if (glType === _gl.UNSIGNED_SHORT) internalFormat = _gl.R16UI;
            if (glType === _gl.UNSIGNED_INT) internalFormat = _gl.R32UI;
            if (glType === _gl.BYTE) internalFormat = _gl.R8I;
            if (glType === _gl.SHORT) internalFormat = _gl.R16I;
            if (glType === _gl.INT) internalFormat = _gl.R32I;
        }
        if (glFormat === _gl.RG) {
            if (glType === _gl.FLOAT) internalFormat = _gl.RG32F;
            if (glType === _gl.HALF_FLOAT) internalFormat = _gl.RG16F;
            if (glType === _gl.UNSIGNED_BYTE) internalFormat = _gl.RG8;
        }
        if (glFormat === _gl.RGBA) {
            if (glType === _gl.FLOAT) internalFormat = _gl.RGBA32F;
            if (glType === _gl.HALF_FLOAT) internalFormat = _gl.RGBA16F;
            if (glType === _gl.UNSIGNED_BYTE) internalFormat = colorSpace1 === $9014d97cd777be10$export$561f394b24edfcaa && forceLinearTransfer === false ? _gl.SRGB8_ALPHA8 : _gl.RGBA8;
            if (glType === _gl.UNSIGNED_SHORT_4_4_4_4) internalFormat = _gl.RGBA4;
            if (glType === _gl.UNSIGNED_SHORT_5_5_5_1) internalFormat = _gl.RGB5_A1;
        }
        if (internalFormat === _gl.R16F || internalFormat === _gl.R32F || internalFormat === _gl.RG16F || internalFormat === _gl.RG32F || internalFormat === _gl.RGBA16F || internalFormat === _gl.RGBA32F) extensions.get("EXT_color_buffer_float");
        return internalFormat;
    }
    function getMipLevels(texture, image, supportsMips) {
        if (textureNeedsGenerateMipmaps(texture, supportsMips) === true || texture.isFramebufferTexture && texture.minFilter !== $9014d97cd777be10$export$727aa5ec3fe39bf0 && texture.minFilter !== $9014d97cd777be10$export$8a72f490b25c56c8) return Math.log2(Math.max(image.width, image.height)) + 1;
        else if (texture.mipmaps !== undefined && texture.mipmaps.length > 0) // user-defined mipmaps
        return texture.mipmaps.length;
        else if (texture.isCompressedTexture && Array.isArray(texture.image)) return image.mipmaps.length;
        else // texture without mipmaps (only base level)
        return 1;
    }
    // Fallback filters for non-power-of-2 textures
    function filterFallback(f) {
        if (f === $9014d97cd777be10$export$727aa5ec3fe39bf0 || f === $9014d97cd777be10$export$d129e38cf6feaa8c || f === $9014d97cd777be10$export$d2327c1afe5bfdf2) return _gl.NEAREST;
        return _gl.LINEAR;
    }
    //
    function onTextureDispose(event) {
        const texture = event.target;
        texture.removeEventListener("dispose", onTextureDispose);
        deallocateTexture(texture);
        if (texture.isVideoTexture) _videoTextures.delete(texture);
    }
    function onRenderTargetDispose(event) {
        const renderTarget = event.target;
        renderTarget.removeEventListener("dispose", onRenderTargetDispose);
        deallocateRenderTarget(renderTarget);
    }
    //
    function deallocateTexture(texture) {
        const textureProperties = properties.get(texture);
        if (textureProperties.__webglInit === undefined) return;
        // check if it's necessary to remove the WebGLTexture object
        const source = texture.source;
        const webglTextures = _sources.get(source);
        if (webglTextures) {
            const webglTexture = webglTextures[textureProperties.__cacheKey];
            webglTexture.usedTimes--;
            // the WebGLTexture object is not used anymore, remove it
            if (webglTexture.usedTimes === 0) deleteTexture(texture);
            // remove the weak map entry if no WebGLTexture uses the source anymore
            if (Object.keys(webglTextures).length === 0) _sources.delete(source);
        }
        properties.remove(texture);
    }
    function deleteTexture(texture) {
        const textureProperties = properties.get(texture);
        _gl.deleteTexture(textureProperties.__webglTexture);
        const source = texture.source;
        const webglTextures = _sources.get(source);
        delete webglTextures[textureProperties.__cacheKey];
        info.memory.textures--;
    }
    function deallocateRenderTarget(renderTarget) {
        const texture = renderTarget.texture;
        const renderTargetProperties = properties.get(renderTarget);
        const textureProperties = properties.get(texture);
        if (textureProperties.__webglTexture !== undefined) {
            _gl.deleteTexture(textureProperties.__webglTexture);
            info.memory.textures--;
        }
        if (renderTarget.depthTexture) renderTarget.depthTexture.dispose();
        if (renderTarget.isWebGLCubeRenderTarget) for(let i = 0; i < 6; i++){
            if (Array.isArray(renderTargetProperties.__webglFramebuffer[i])) for(let level = 0; level < renderTargetProperties.__webglFramebuffer[i].length; level++)_gl.deleteFramebuffer(renderTargetProperties.__webglFramebuffer[i][level]);
            else _gl.deleteFramebuffer(renderTargetProperties.__webglFramebuffer[i]);
            if (renderTargetProperties.__webglDepthbuffer) _gl.deleteRenderbuffer(renderTargetProperties.__webglDepthbuffer[i]);
        }
        else {
            if (Array.isArray(renderTargetProperties.__webglFramebuffer)) for(let level = 0; level < renderTargetProperties.__webglFramebuffer.length; level++)_gl.deleteFramebuffer(renderTargetProperties.__webglFramebuffer[level]);
            else _gl.deleteFramebuffer(renderTargetProperties.__webglFramebuffer);
            if (renderTargetProperties.__webglDepthbuffer) _gl.deleteRenderbuffer(renderTargetProperties.__webglDepthbuffer);
            if (renderTargetProperties.__webglMultisampledFramebuffer) _gl.deleteFramebuffer(renderTargetProperties.__webglMultisampledFramebuffer);
            if (renderTargetProperties.__webglColorRenderbuffer) {
                for(let i = 0; i < renderTargetProperties.__webglColorRenderbuffer.length; i++)if (renderTargetProperties.__webglColorRenderbuffer[i]) _gl.deleteRenderbuffer(renderTargetProperties.__webglColorRenderbuffer[i]);
            }
            if (renderTargetProperties.__webglDepthRenderbuffer) _gl.deleteRenderbuffer(renderTargetProperties.__webglDepthRenderbuffer);
        }
        if (renderTarget.isWebGLMultipleRenderTargets) for(let i = 0, il = texture.length; i < il; i++){
            const attachmentProperties = properties.get(texture[i]);
            if (attachmentProperties.__webglTexture) {
                _gl.deleteTexture(attachmentProperties.__webglTexture);
                info.memory.textures--;
            }
            properties.remove(texture[i]);
        }
        properties.remove(texture);
        properties.remove(renderTarget);
    }
    //
    let textureUnits = 0;
    function resetTextureUnits() {
        textureUnits = 0;
    }
    function allocateTextureUnit() {
        const textureUnit = textureUnits;
        if (textureUnit >= maxTextures) console.warn("THREE.WebGLTextures: Trying to use " + textureUnit + " texture units while this GPU supports only " + maxTextures);
        textureUnits += 1;
        return textureUnit;
    }
    function getTextureCacheKey(texture) {
        const array = [];
        array.push(texture.wrapS);
        array.push(texture.wrapT);
        array.push(texture.wrapR || 0);
        array.push(texture.magFilter);
        array.push(texture.minFilter);
        array.push(texture.anisotropy);
        array.push(texture.internalFormat);
        array.push(texture.format);
        array.push(texture.type);
        array.push(texture.generateMipmaps);
        array.push(texture.premultiplyAlpha);
        array.push(texture.flipY);
        array.push(texture.unpackAlignment);
        array.push(texture.colorSpace);
        return array.join();
    }
    //
    function setTexture2D(texture, slot) {
        const textureProperties = properties.get(texture);
        if (texture.isVideoTexture) updateVideoTexture(texture);
        if (texture.isRenderTargetTexture === false && texture.version > 0 && textureProperties.__version !== texture.version) {
            const image = texture.image;
            if (image === null) console.warn("THREE.WebGLRenderer: Texture marked for update but no image data found.");
            else if (image.complete === false) console.warn("THREE.WebGLRenderer: Texture marked for update but image is incomplete");
            else {
                uploadTexture(textureProperties, texture, slot);
                return;
            }
        }
        state.bindTexture(_gl.TEXTURE_2D, textureProperties.__webglTexture, _gl.TEXTURE0 + slot);
    }
    function setTexture2DArray(texture, slot) {
        const textureProperties = properties.get(texture);
        if (texture.version > 0 && textureProperties.__version !== texture.version) {
            uploadTexture(textureProperties, texture, slot);
            return;
        }
        state.bindTexture(_gl.TEXTURE_2D_ARRAY, textureProperties.__webglTexture, _gl.TEXTURE0 + slot);
    }
    function setTexture3D(texture, slot) {
        const textureProperties = properties.get(texture);
        if (texture.version > 0 && textureProperties.__version !== texture.version) {
            uploadTexture(textureProperties, texture, slot);
            return;
        }
        state.bindTexture(_gl.TEXTURE_3D, textureProperties.__webglTexture, _gl.TEXTURE0 + slot);
    }
    function setTextureCube(texture, slot) {
        const textureProperties = properties.get(texture);
        if (texture.version > 0 && textureProperties.__version !== texture.version) {
            uploadCubeTexture(textureProperties, texture, slot);
            return;
        }
        state.bindTexture(_gl.TEXTURE_CUBE_MAP, textureProperties.__webglTexture, _gl.TEXTURE0 + slot);
    }
    const wrappingToGL = {
        [$9014d97cd777be10$export$533346c8e8dac0f5]: _gl.REPEAT,
        [$9014d97cd777be10$export$9d9334239a5a5e06]: _gl.CLAMP_TO_EDGE,
        [$9014d97cd777be10$export$c7e7c00b14f51a4f]: _gl.MIRRORED_REPEAT
    };
    const filterToGL = {
        [$9014d97cd777be10$export$727aa5ec3fe39bf0]: _gl.NEAREST,
        [$9014d97cd777be10$export$d129e38cf6feaa8c]: _gl.NEAREST_MIPMAP_NEAREST,
        [$9014d97cd777be10$export$d2327c1afe5bfdf2]: _gl.NEAREST_MIPMAP_LINEAR,
        [$9014d97cd777be10$export$8a72f490b25c56c8]: _gl.LINEAR,
        [$9014d97cd777be10$export$19a719f377145a13]: _gl.LINEAR_MIPMAP_NEAREST,
        [$9014d97cd777be10$export$5d8599b6a933fb1b]: _gl.LINEAR_MIPMAP_LINEAR
    };
    const compareToGL = {
        [$9014d97cd777be10$export$d9e2d19a747baaab]: _gl.NEVER,
        [$9014d97cd777be10$export$187b73a3e352c145]: _gl.ALWAYS,
        [$9014d97cd777be10$export$36bcf49c713b3eb7]: _gl.LESS,
        [$9014d97cd777be10$export$64eea11eb407ddf1]: _gl.LEQUAL,
        [$9014d97cd777be10$export$66f28d946fc6a0d5]: _gl.EQUAL,
        [$9014d97cd777be10$export$1cdcb70d53d65f61]: _gl.GEQUAL,
        [$9014d97cd777be10$export$155af022118f3a38]: _gl.GREATER,
        [$9014d97cd777be10$export$67ab95dde6bed156]: _gl.NOTEQUAL
    };
    function setTextureParameters(textureType, texture, supportsMips) {
        if (supportsMips) {
            _gl.texParameteri(textureType, _gl.TEXTURE_WRAP_S, wrappingToGL[texture.wrapS]);
            _gl.texParameteri(textureType, _gl.TEXTURE_WRAP_T, wrappingToGL[texture.wrapT]);
            if (textureType === _gl.TEXTURE_3D || textureType === _gl.TEXTURE_2D_ARRAY) _gl.texParameteri(textureType, _gl.TEXTURE_WRAP_R, wrappingToGL[texture.wrapR]);
            _gl.texParameteri(textureType, _gl.TEXTURE_MAG_FILTER, filterToGL[texture.magFilter]);
            _gl.texParameteri(textureType, _gl.TEXTURE_MIN_FILTER, filterToGL[texture.minFilter]);
        } else {
            _gl.texParameteri(textureType, _gl.TEXTURE_WRAP_S, _gl.CLAMP_TO_EDGE);
            _gl.texParameteri(textureType, _gl.TEXTURE_WRAP_T, _gl.CLAMP_TO_EDGE);
            if (textureType === _gl.TEXTURE_3D || textureType === _gl.TEXTURE_2D_ARRAY) _gl.texParameteri(textureType, _gl.TEXTURE_WRAP_R, _gl.CLAMP_TO_EDGE);
            if (texture.wrapS !== $9014d97cd777be10$export$9d9334239a5a5e06 || texture.wrapT !== $9014d97cd777be10$export$9d9334239a5a5e06) console.warn("THREE.WebGLRenderer: Texture is not power of two. Texture.wrapS and Texture.wrapT should be set to THREE.ClampToEdgeWrapping.");
            _gl.texParameteri(textureType, _gl.TEXTURE_MAG_FILTER, filterFallback(texture.magFilter));
            _gl.texParameteri(textureType, _gl.TEXTURE_MIN_FILTER, filterFallback(texture.minFilter));
            if (texture.minFilter !== $9014d97cd777be10$export$727aa5ec3fe39bf0 && texture.minFilter !== $9014d97cd777be10$export$8a72f490b25c56c8) console.warn("THREE.WebGLRenderer: Texture is not power of two. Texture.minFilter should be set to THREE.NearestFilter or THREE.LinearFilter.");
        }
        if (texture.compareFunction) {
            _gl.texParameteri(textureType, _gl.TEXTURE_COMPARE_MODE, _gl.COMPARE_REF_TO_TEXTURE);
            _gl.texParameteri(textureType, _gl.TEXTURE_COMPARE_FUNC, compareToGL[texture.compareFunction]);
        }
        if (extensions.has("EXT_texture_filter_anisotropic") === true) {
            const extension = extensions.get("EXT_texture_filter_anisotropic");
            if (texture.magFilter === $9014d97cd777be10$export$727aa5ec3fe39bf0) return;
            if (texture.minFilter !== $9014d97cd777be10$export$d2327c1afe5bfdf2 && texture.minFilter !== $9014d97cd777be10$export$5d8599b6a933fb1b) return;
            if (texture.type === $9014d97cd777be10$export$f6d331659b644596 && extensions.has("OES_texture_float_linear") === false) return; // verify extension for WebGL 1 and WebGL 2
            if (isWebGL2 === false && texture.type === $9014d97cd777be10$export$2697304443f382bc && extensions.has("OES_texture_half_float_linear") === false) return; // verify extension for WebGL 1 only
            if (texture.anisotropy > 1 || properties.get(texture).__currentAnisotropy) {
                _gl.texParameterf(textureType, extension.TEXTURE_MAX_ANISOTROPY_EXT, Math.min(texture.anisotropy, capabilities.getMaxAnisotropy()));
                properties.get(texture).__currentAnisotropy = texture.anisotropy;
            }
        }
    }
    function initTexture(textureProperties, texture) {
        let forceUpload = false;
        if (textureProperties.__webglInit === undefined) {
            textureProperties.__webglInit = true;
            texture.addEventListener("dispose", onTextureDispose);
        }
        // create Source <-> WebGLTextures mapping if necessary
        const source = texture.source;
        let webglTextures = _sources.get(source);
        if (webglTextures === undefined) {
            webglTextures = {};
            _sources.set(source, webglTextures);
        }
        // check if there is already a WebGLTexture object for the given texture parameters
        const textureCacheKey = getTextureCacheKey(texture);
        if (textureCacheKey !== textureProperties.__cacheKey) {
            // if not, create a new instance of WebGLTexture
            if (webglTextures[textureCacheKey] === undefined) {
                // create new entry
                webglTextures[textureCacheKey] = {
                    texture: _gl.createTexture(),
                    usedTimes: 0
                };
                info.memory.textures++;
                // when a new instance of WebGLTexture was created, a texture upload is required
                // even if the image contents are identical
                forceUpload = true;
            }
            webglTextures[textureCacheKey].usedTimes++;
            // every time the texture cache key changes, it's necessary to check if an instance of
            // WebGLTexture can be deleted in order to avoid a memory leak.
            const webglTexture = webglTextures[textureProperties.__cacheKey];
            if (webglTexture !== undefined) {
                webglTextures[textureProperties.__cacheKey].usedTimes--;
                if (webglTexture.usedTimes === 0) deleteTexture(texture);
            }
            // store references to cache key and WebGLTexture object
            textureProperties.__cacheKey = textureCacheKey;
            textureProperties.__webglTexture = webglTextures[textureCacheKey].texture;
        }
        return forceUpload;
    }
    function uploadTexture(textureProperties, texture, slot) {
        let textureType = _gl.TEXTURE_2D;
        if (texture.isDataArrayTexture || texture.isCompressedArrayTexture) textureType = _gl.TEXTURE_2D_ARRAY;
        if (texture.isData3DTexture) textureType = _gl.TEXTURE_3D;
        const forceUpload = initTexture(textureProperties, texture);
        const source = texture.source;
        state.bindTexture(textureType, textureProperties.__webglTexture, _gl.TEXTURE0 + slot);
        const sourceProperties = properties.get(source);
        if (source.version !== sourceProperties.__version || forceUpload === true) {
            state.activeTexture(_gl.TEXTURE0 + slot);
            _gl.pixelStorei(_gl.UNPACK_FLIP_Y_WEBGL, texture.flipY);
            _gl.pixelStorei(_gl.UNPACK_PREMULTIPLY_ALPHA_WEBGL, texture.premultiplyAlpha);
            _gl.pixelStorei(_gl.UNPACK_ALIGNMENT, texture.unpackAlignment);
            _gl.pixelStorei(_gl.UNPACK_COLORSPACE_CONVERSION_WEBGL, _gl.NONE);
            const needsPowerOfTwo = textureNeedsPowerOfTwo(texture) && isPowerOfTwo$1(texture.image) === false;
            let image = resizeImage(texture.image, needsPowerOfTwo, false, maxTextureSize);
            image = verifyColorSpace(texture, image);
            const supportsMips = isPowerOfTwo$1(image) || isWebGL2, glFormat = utils.convert(texture.format, texture.colorSpace);
            let glType = utils.convert(texture.type), glInternalFormat = getInternalFormat(texture.internalFormat, glFormat, glType, texture.colorSpace);
            setTextureParameters(textureType, texture, supportsMips);
            let mipmap;
            const mipmaps = texture.mipmaps;
            const useTexStorage = isWebGL2 && texture.isVideoTexture !== true;
            const allocateMemory = sourceProperties.__version === undefined || forceUpload === true;
            const levels = getMipLevels(texture, image, supportsMips);
            if (texture.isDepthTexture) {
                // populate depth texture with dummy data
                glInternalFormat = _gl.DEPTH_COMPONENT;
                if (isWebGL2) {
                    if (texture.type === $9014d97cd777be10$export$f6d331659b644596) glInternalFormat = _gl.DEPTH_COMPONENT32F;
                    else if (texture.type === $9014d97cd777be10$export$c3c7fc4518ebba96) glInternalFormat = _gl.DEPTH_COMPONENT24;
                    else if (texture.type === $9014d97cd777be10$export$6c8ea339bfab1301) glInternalFormat = _gl.DEPTH24_STENCIL8;
                    else glInternalFormat = _gl.DEPTH_COMPONENT16; // WebGL2 requires sized internalformat for glTexImage2D
                } else if (texture.type === $9014d97cd777be10$export$f6d331659b644596) console.error("WebGLRenderer: Floating point depth texture requires WebGL2.");
                // validation checks for WebGL 1
                if (texture.format === $9014d97cd777be10$export$c1b6b5136be58045 && glInternalFormat === _gl.DEPTH_COMPONENT) // The error INVALID_OPERATION is generated by texImage2D if format and internalformat are
                // DEPTH_COMPONENT and type is not UNSIGNED_SHORT or UNSIGNED_INT
                // (https://www.khronos.org/registry/webgl/extensions/WEBGL_depth_texture/)
                {
                    if (texture.type !== $9014d97cd777be10$export$c63dc51868b06a9d && texture.type !== $9014d97cd777be10$export$c3c7fc4518ebba96) {
                        console.warn("THREE.WebGLRenderer: Use UnsignedShortType or UnsignedIntType for DepthFormat DepthTexture.");
                        texture.type = $9014d97cd777be10$export$c3c7fc4518ebba96;
                        glType = utils.convert(texture.type);
                    }
                }
                if (texture.format === $9014d97cd777be10$export$1e113ac2d0905829 && glInternalFormat === _gl.DEPTH_COMPONENT) {
                    // Depth stencil textures need the DEPTH_STENCIL internal format
                    // (https://www.khronos.org/registry/webgl/extensions/WEBGL_depth_texture/)
                    glInternalFormat = _gl.DEPTH_STENCIL;
                    // The error INVALID_OPERATION is generated by texImage2D if format and internalformat are
                    // DEPTH_STENCIL and type is not UNSIGNED_INT_24_8_WEBGL.
                    // (https://www.khronos.org/registry/webgl/extensions/WEBGL_depth_texture/)
                    if (texture.type !== $9014d97cd777be10$export$6c8ea339bfab1301) {
                        console.warn("THREE.WebGLRenderer: Use UnsignedInt248Type for DepthStencilFormat DepthTexture.");
                        texture.type = $9014d97cd777be10$export$6c8ea339bfab1301;
                        glType = utils.convert(texture.type);
                    }
                }
                //
                if (allocateMemory) {
                    if (useTexStorage) state.texStorage2D(_gl.TEXTURE_2D, 1, glInternalFormat, image.width, image.height);
                    else state.texImage2D(_gl.TEXTURE_2D, 0, glInternalFormat, image.width, image.height, 0, glFormat, glType, null);
                }
            } else if (texture.isDataTexture) {
                // use manually created mipmaps if available
                // if there are no manual mipmaps
                // set 0 level mipmap and then use GL to generate other mipmap levels
                if (mipmaps.length > 0 && supportsMips) {
                    if (useTexStorage && allocateMemory) state.texStorage2D(_gl.TEXTURE_2D, levels, glInternalFormat, mipmaps[0].width, mipmaps[0].height);
                    for(let i = 0, il = mipmaps.length; i < il; i++){
                        mipmap = mipmaps[i];
                        if (useTexStorage) state.texSubImage2D(_gl.TEXTURE_2D, i, 0, 0, mipmap.width, mipmap.height, glFormat, glType, mipmap.data);
                        else state.texImage2D(_gl.TEXTURE_2D, i, glInternalFormat, mipmap.width, mipmap.height, 0, glFormat, glType, mipmap.data);
                    }
                    texture.generateMipmaps = false;
                } else if (useTexStorage) {
                    if (allocateMemory) state.texStorage2D(_gl.TEXTURE_2D, levels, glInternalFormat, image.width, image.height);
                    state.texSubImage2D(_gl.TEXTURE_2D, 0, 0, 0, image.width, image.height, glFormat, glType, image.data);
                } else state.texImage2D(_gl.TEXTURE_2D, 0, glInternalFormat, image.width, image.height, 0, glFormat, glType, image.data);
            } else if (texture.isCompressedTexture) {
                if (texture.isCompressedArrayTexture) {
                    if (useTexStorage && allocateMemory) state.texStorage3D(_gl.TEXTURE_2D_ARRAY, levels, glInternalFormat, mipmaps[0].width, mipmaps[0].height, image.depth);
                    for(let i = 0, il = mipmaps.length; i < il; i++){
                        mipmap = mipmaps[i];
                        if (texture.format !== $9014d97cd777be10$export$3f8bb04b555a363c) {
                            if (glFormat !== null) {
                                if (useTexStorage) state.compressedTexSubImage3D(_gl.TEXTURE_2D_ARRAY, i, 0, 0, 0, mipmap.width, mipmap.height, image.depth, glFormat, mipmap.data, 0, 0);
                                else state.compressedTexImage3D(_gl.TEXTURE_2D_ARRAY, i, glInternalFormat, mipmap.width, mipmap.height, image.depth, 0, mipmap.data, 0, 0);
                            } else console.warn("THREE.WebGLRenderer: Attempt to load unsupported compressed texture format in .uploadTexture()");
                        } else if (useTexStorage) state.texSubImage3D(_gl.TEXTURE_2D_ARRAY, i, 0, 0, 0, mipmap.width, mipmap.height, image.depth, glFormat, glType, mipmap.data);
                        else state.texImage3D(_gl.TEXTURE_2D_ARRAY, i, glInternalFormat, mipmap.width, mipmap.height, image.depth, 0, glFormat, glType, mipmap.data);
                    }
                } else {
                    if (useTexStorage && allocateMemory) state.texStorage2D(_gl.TEXTURE_2D, levels, glInternalFormat, mipmaps[0].width, mipmaps[0].height);
                    for(let i = 0, il = mipmaps.length; i < il; i++){
                        mipmap = mipmaps[i];
                        if (texture.format !== $9014d97cd777be10$export$3f8bb04b555a363c) {
                            if (glFormat !== null) {
                                if (useTexStorage) state.compressedTexSubImage2D(_gl.TEXTURE_2D, i, 0, 0, mipmap.width, mipmap.height, glFormat, mipmap.data);
                                else state.compressedTexImage2D(_gl.TEXTURE_2D, i, glInternalFormat, mipmap.width, mipmap.height, 0, mipmap.data);
                            } else console.warn("THREE.WebGLRenderer: Attempt to load unsupported compressed texture format in .uploadTexture()");
                        } else if (useTexStorage) state.texSubImage2D(_gl.TEXTURE_2D, i, 0, 0, mipmap.width, mipmap.height, glFormat, glType, mipmap.data);
                        else state.texImage2D(_gl.TEXTURE_2D, i, glInternalFormat, mipmap.width, mipmap.height, 0, glFormat, glType, mipmap.data);
                    }
                }
            } else if (texture.isDataArrayTexture) {
                if (useTexStorage) {
                    if (allocateMemory) state.texStorage3D(_gl.TEXTURE_2D_ARRAY, levels, glInternalFormat, image.width, image.height, image.depth);
                    state.texSubImage3D(_gl.TEXTURE_2D_ARRAY, 0, 0, 0, 0, image.width, image.height, image.depth, glFormat, glType, image.data);
                } else state.texImage3D(_gl.TEXTURE_2D_ARRAY, 0, glInternalFormat, image.width, image.height, image.depth, 0, glFormat, glType, image.data);
            } else if (texture.isData3DTexture) {
                if (useTexStorage) {
                    if (allocateMemory) state.texStorage3D(_gl.TEXTURE_3D, levels, glInternalFormat, image.width, image.height, image.depth);
                    state.texSubImage3D(_gl.TEXTURE_3D, 0, 0, 0, 0, image.width, image.height, image.depth, glFormat, glType, image.data);
                } else state.texImage3D(_gl.TEXTURE_3D, 0, glInternalFormat, image.width, image.height, image.depth, 0, glFormat, glType, image.data);
            } else if (texture.isFramebufferTexture) {
                if (allocateMemory) {
                    if (useTexStorage) state.texStorage2D(_gl.TEXTURE_2D, levels, glInternalFormat, image.width, image.height);
                    else {
                        let width = image.width, height = image.height;
                        for(let i = 0; i < levels; i++){
                            state.texImage2D(_gl.TEXTURE_2D, i, glInternalFormat, width, height, 0, glFormat, glType, null);
                            width >>= 1;
                            height >>= 1;
                        }
                    }
                }
            } else {
                // regular Texture (image, video, canvas)
                // use manually created mipmaps if available
                // if there are no manual mipmaps
                // set 0 level mipmap and then use GL to generate other mipmap levels
                if (mipmaps.length > 0 && supportsMips) {
                    if (useTexStorage && allocateMemory) state.texStorage2D(_gl.TEXTURE_2D, levels, glInternalFormat, mipmaps[0].width, mipmaps[0].height);
                    for(let i = 0, il = mipmaps.length; i < il; i++){
                        mipmap = mipmaps[i];
                        if (useTexStorage) state.texSubImage2D(_gl.TEXTURE_2D, i, 0, 0, glFormat, glType, mipmap);
                        else state.texImage2D(_gl.TEXTURE_2D, i, glInternalFormat, glFormat, glType, mipmap);
                    }
                    texture.generateMipmaps = false;
                } else if (useTexStorage) {
                    if (allocateMemory) state.texStorage2D(_gl.TEXTURE_2D, levels, glInternalFormat, image.width, image.height);
                    state.texSubImage2D(_gl.TEXTURE_2D, 0, 0, 0, glFormat, glType, image);
                } else state.texImage2D(_gl.TEXTURE_2D, 0, glInternalFormat, glFormat, glType, image);
            }
            if (textureNeedsGenerateMipmaps(texture, supportsMips)) generateMipmap(textureType);
            sourceProperties.__version = source.version;
            if (texture.onUpdate) texture.onUpdate(texture);
        }
        textureProperties.__version = texture.version;
    }
    function uploadCubeTexture(textureProperties, texture, slot) {
        if (texture.image.length !== 6) return;
        const forceUpload = initTexture(textureProperties, texture);
        const source = texture.source;
        state.bindTexture(_gl.TEXTURE_CUBE_MAP, textureProperties.__webglTexture, _gl.TEXTURE0 + slot);
        const sourceProperties = properties.get(source);
        if (source.version !== sourceProperties.__version || forceUpload === true) {
            state.activeTexture(_gl.TEXTURE0 + slot);
            _gl.pixelStorei(_gl.UNPACK_FLIP_Y_WEBGL, texture.flipY);
            _gl.pixelStorei(_gl.UNPACK_PREMULTIPLY_ALPHA_WEBGL, texture.premultiplyAlpha);
            _gl.pixelStorei(_gl.UNPACK_ALIGNMENT, texture.unpackAlignment);
            _gl.pixelStorei(_gl.UNPACK_COLORSPACE_CONVERSION_WEBGL, _gl.NONE);
            const isCompressed = texture.isCompressedTexture || texture.image[0].isCompressedTexture;
            const isDataTexture = texture.image[0] && texture.image[0].isDataTexture;
            const cubeImage = [];
            for(let i = 0; i < 6; i++){
                if (!isCompressed && !isDataTexture) cubeImage[i] = resizeImage(texture.image[i], false, true, maxCubemapSize);
                else cubeImage[i] = isDataTexture ? texture.image[i].image : texture.image[i];
                cubeImage[i] = verifyColorSpace(texture, cubeImage[i]);
            }
            const image = cubeImage[0], supportsMips = isPowerOfTwo$1(image) || isWebGL2, glFormat = utils.convert(texture.format, texture.colorSpace), glType = utils.convert(texture.type), glInternalFormat = getInternalFormat(texture.internalFormat, glFormat, glType, texture.colorSpace);
            const useTexStorage = isWebGL2 && texture.isVideoTexture !== true;
            const allocateMemory = sourceProperties.__version === undefined || forceUpload === true;
            let levels = getMipLevels(texture, image, supportsMips);
            setTextureParameters(_gl.TEXTURE_CUBE_MAP, texture, supportsMips);
            let mipmaps;
            if (isCompressed) {
                if (useTexStorage && allocateMemory) state.texStorage2D(_gl.TEXTURE_CUBE_MAP, levels, glInternalFormat, image.width, image.height);
                for(let i = 0; i < 6; i++){
                    mipmaps = cubeImage[i].mipmaps;
                    for(let j = 0; j < mipmaps.length; j++){
                        const mipmap = mipmaps[j];
                        if (texture.format !== $9014d97cd777be10$export$3f8bb04b555a363c) {
                            if (glFormat !== null) {
                                if (useTexStorage) state.compressedTexSubImage2D(_gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, j, 0, 0, mipmap.width, mipmap.height, glFormat, mipmap.data);
                                else state.compressedTexImage2D(_gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, j, glInternalFormat, mipmap.width, mipmap.height, 0, mipmap.data);
                            } else console.warn("THREE.WebGLRenderer: Attempt to load unsupported compressed texture format in .setTextureCube()");
                        } else if (useTexStorage) state.texSubImage2D(_gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, j, 0, 0, mipmap.width, mipmap.height, glFormat, glType, mipmap.data);
                        else state.texImage2D(_gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, j, glInternalFormat, mipmap.width, mipmap.height, 0, glFormat, glType, mipmap.data);
                    }
                }
            } else {
                mipmaps = texture.mipmaps;
                if (useTexStorage && allocateMemory) {
                    // TODO: Uniformly handle mipmap definitions
                    // Normal textures and compressed cube textures define base level + mips with their mipmap array
                    // Uncompressed cube textures use their mipmap array only for mips (no base level)
                    if (mipmaps.length > 0) levels++;
                    state.texStorage2D(_gl.TEXTURE_CUBE_MAP, levels, glInternalFormat, cubeImage[0].width, cubeImage[0].height);
                }
                for(let i = 0; i < 6; i++)if (isDataTexture) {
                    if (useTexStorage) state.texSubImage2D(_gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, 0, 0, 0, cubeImage[i].width, cubeImage[i].height, glFormat, glType, cubeImage[i].data);
                    else state.texImage2D(_gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, 0, glInternalFormat, cubeImage[i].width, cubeImage[i].height, 0, glFormat, glType, cubeImage[i].data);
                    for(let j = 0; j < mipmaps.length; j++){
                        const mipmap = mipmaps[j];
                        const mipmapImage = mipmap.image[i].image;
                        if (useTexStorage) state.texSubImage2D(_gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, j + 1, 0, 0, mipmapImage.width, mipmapImage.height, glFormat, glType, mipmapImage.data);
                        else state.texImage2D(_gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, j + 1, glInternalFormat, mipmapImage.width, mipmapImage.height, 0, glFormat, glType, mipmapImage.data);
                    }
                } else {
                    if (useTexStorage) state.texSubImage2D(_gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, 0, 0, 0, glFormat, glType, cubeImage[i]);
                    else state.texImage2D(_gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, 0, glInternalFormat, glFormat, glType, cubeImage[i]);
                    for(let j = 0; j < mipmaps.length; j++){
                        const mipmap = mipmaps[j];
                        if (useTexStorage) state.texSubImage2D(_gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, j + 1, 0, 0, glFormat, glType, mipmap.image[i]);
                        else state.texImage2D(_gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, j + 1, glInternalFormat, glFormat, glType, mipmap.image[i]);
                    }
                }
            }
            if (textureNeedsGenerateMipmaps(texture, supportsMips)) // We assume images for cube map have the same size.
            generateMipmap(_gl.TEXTURE_CUBE_MAP);
            sourceProperties.__version = source.version;
            if (texture.onUpdate) texture.onUpdate(texture);
        }
        textureProperties.__version = texture.version;
    }
    // Render targets
    // Setup storage for target texture and bind it to correct framebuffer
    function setupFrameBufferTexture(framebuffer, renderTarget, texture, attachment, textureTarget, level) {
        const glFormat = utils.convert(texture.format, texture.colorSpace);
        const glType = utils.convert(texture.type);
        const glInternalFormat = getInternalFormat(texture.internalFormat, glFormat, glType, texture.colorSpace);
        const renderTargetProperties = properties.get(renderTarget);
        if (!renderTargetProperties.__hasExternalTextures) {
            const width = Math.max(1, renderTarget.width >> level);
            const height = Math.max(1, renderTarget.height >> level);
            if (textureTarget === _gl.TEXTURE_3D || textureTarget === _gl.TEXTURE_2D_ARRAY) state.texImage3D(textureTarget, level, glInternalFormat, width, height, renderTarget.depth, 0, glFormat, glType, null);
            else state.texImage2D(textureTarget, level, glInternalFormat, width, height, 0, glFormat, glType, null);
        }
        state.bindFramebuffer(_gl.FRAMEBUFFER, framebuffer);
        if (useMultisampledRTT(renderTarget)) multisampledRTTExt.framebufferTexture2DMultisampleEXT(_gl.FRAMEBUFFER, attachment, textureTarget, properties.get(texture).__webglTexture, 0, getRenderTargetSamples(renderTarget));
        else if (textureTarget === _gl.TEXTURE_2D || textureTarget >= _gl.TEXTURE_CUBE_MAP_POSITIVE_X && textureTarget <= _gl.TEXTURE_CUBE_MAP_NEGATIVE_Z) _gl.framebufferTexture2D(_gl.FRAMEBUFFER, attachment, textureTarget, properties.get(texture).__webglTexture, level);
        state.bindFramebuffer(_gl.FRAMEBUFFER, null);
    }
    // Setup storage for internal depth/stencil buffers and bind to correct framebuffer
    function setupRenderBufferStorage(renderbuffer, renderTarget, isMultisample) {
        _gl.bindRenderbuffer(_gl.RENDERBUFFER, renderbuffer);
        if (renderTarget.depthBuffer && !renderTarget.stencilBuffer) {
            let glInternalFormat = _gl.DEPTH_COMPONENT16;
            if (isMultisample || useMultisampledRTT(renderTarget)) {
                const depthTexture = renderTarget.depthTexture;
                if (depthTexture && depthTexture.isDepthTexture) {
                    if (depthTexture.type === $9014d97cd777be10$export$f6d331659b644596) glInternalFormat = _gl.DEPTH_COMPONENT32F;
                    else if (depthTexture.type === $9014d97cd777be10$export$c3c7fc4518ebba96) glInternalFormat = _gl.DEPTH_COMPONENT24;
                }
                const samples = getRenderTargetSamples(renderTarget);
                if (useMultisampledRTT(renderTarget)) multisampledRTTExt.renderbufferStorageMultisampleEXT(_gl.RENDERBUFFER, samples, glInternalFormat, renderTarget.width, renderTarget.height);
                else _gl.renderbufferStorageMultisample(_gl.RENDERBUFFER, samples, glInternalFormat, renderTarget.width, renderTarget.height);
            } else _gl.renderbufferStorage(_gl.RENDERBUFFER, glInternalFormat, renderTarget.width, renderTarget.height);
            _gl.framebufferRenderbuffer(_gl.FRAMEBUFFER, _gl.DEPTH_ATTACHMENT, _gl.RENDERBUFFER, renderbuffer);
        } else if (renderTarget.depthBuffer && renderTarget.stencilBuffer) {
            const samples = getRenderTargetSamples(renderTarget);
            if (isMultisample && useMultisampledRTT(renderTarget) === false) _gl.renderbufferStorageMultisample(_gl.RENDERBUFFER, samples, _gl.DEPTH24_STENCIL8, renderTarget.width, renderTarget.height);
            else if (useMultisampledRTT(renderTarget)) multisampledRTTExt.renderbufferStorageMultisampleEXT(_gl.RENDERBUFFER, samples, _gl.DEPTH24_STENCIL8, renderTarget.width, renderTarget.height);
            else _gl.renderbufferStorage(_gl.RENDERBUFFER, _gl.DEPTH_STENCIL, renderTarget.width, renderTarget.height);
            _gl.framebufferRenderbuffer(_gl.FRAMEBUFFER, _gl.DEPTH_STENCIL_ATTACHMENT, _gl.RENDERBUFFER, renderbuffer);
        } else {
            const textures = renderTarget.isWebGLMultipleRenderTargets === true ? renderTarget.texture : [
                renderTarget.texture
            ];
            for(let i = 0; i < textures.length; i++){
                const texture = textures[i];
                const glFormat = utils.convert(texture.format, texture.colorSpace);
                const glType = utils.convert(texture.type);
                const glInternalFormat = getInternalFormat(texture.internalFormat, glFormat, glType, texture.colorSpace);
                const samples = getRenderTargetSamples(renderTarget);
                if (isMultisample && useMultisampledRTT(renderTarget) === false) _gl.renderbufferStorageMultisample(_gl.RENDERBUFFER, samples, glInternalFormat, renderTarget.width, renderTarget.height);
                else if (useMultisampledRTT(renderTarget)) multisampledRTTExt.renderbufferStorageMultisampleEXT(_gl.RENDERBUFFER, samples, glInternalFormat, renderTarget.width, renderTarget.height);
                else _gl.renderbufferStorage(_gl.RENDERBUFFER, glInternalFormat, renderTarget.width, renderTarget.height);
            }
        }
        _gl.bindRenderbuffer(_gl.RENDERBUFFER, null);
    }
    // Setup resources for a Depth Texture for a FBO (needs an extension)
    function setupDepthTexture(framebuffer, renderTarget) {
        const isCube = renderTarget && renderTarget.isWebGLCubeRenderTarget;
        if (isCube) throw new Error("Depth Texture with cube render targets is not supported");
        state.bindFramebuffer(_gl.FRAMEBUFFER, framebuffer);
        if (!(renderTarget.depthTexture && renderTarget.depthTexture.isDepthTexture)) throw new Error("renderTarget.depthTexture must be an instance of THREE.DepthTexture");
        // upload an empty depth texture with framebuffer size
        if (!properties.get(renderTarget.depthTexture).__webglTexture || renderTarget.depthTexture.image.width !== renderTarget.width || renderTarget.depthTexture.image.height !== renderTarget.height) {
            renderTarget.depthTexture.image.width = renderTarget.width;
            renderTarget.depthTexture.image.height = renderTarget.height;
            renderTarget.depthTexture.needsUpdate = true;
        }
        setTexture2D(renderTarget.depthTexture, 0);
        const webglDepthTexture = properties.get(renderTarget.depthTexture).__webglTexture;
        const samples = getRenderTargetSamples(renderTarget);
        if (renderTarget.depthTexture.format === $9014d97cd777be10$export$c1b6b5136be58045) {
            if (useMultisampledRTT(renderTarget)) multisampledRTTExt.framebufferTexture2DMultisampleEXT(_gl.FRAMEBUFFER, _gl.DEPTH_ATTACHMENT, _gl.TEXTURE_2D, webglDepthTexture, 0, samples);
            else _gl.framebufferTexture2D(_gl.FRAMEBUFFER, _gl.DEPTH_ATTACHMENT, _gl.TEXTURE_2D, webglDepthTexture, 0);
        } else if (renderTarget.depthTexture.format === $9014d97cd777be10$export$1e113ac2d0905829) {
            if (useMultisampledRTT(renderTarget)) multisampledRTTExt.framebufferTexture2DMultisampleEXT(_gl.FRAMEBUFFER, _gl.DEPTH_STENCIL_ATTACHMENT, _gl.TEXTURE_2D, webglDepthTexture, 0, samples);
            else _gl.framebufferTexture2D(_gl.FRAMEBUFFER, _gl.DEPTH_STENCIL_ATTACHMENT, _gl.TEXTURE_2D, webglDepthTexture, 0);
        } else throw new Error("Unknown depthTexture format");
    }
    // Setup GL resources for a non-texture depth buffer
    function setupDepthRenderbuffer(renderTarget) {
        const renderTargetProperties = properties.get(renderTarget);
        const isCube = renderTarget.isWebGLCubeRenderTarget === true;
        if (renderTarget.depthTexture && !renderTargetProperties.__autoAllocateDepthBuffer) {
            if (isCube) throw new Error("target.depthTexture not supported in Cube render targets");
            setupDepthTexture(renderTargetProperties.__webglFramebuffer, renderTarget);
        } else if (isCube) {
            renderTargetProperties.__webglDepthbuffer = [];
            for(let i = 0; i < 6; i++){
                state.bindFramebuffer(_gl.FRAMEBUFFER, renderTargetProperties.__webglFramebuffer[i]);
                renderTargetProperties.__webglDepthbuffer[i] = _gl.createRenderbuffer();
                setupRenderBufferStorage(renderTargetProperties.__webglDepthbuffer[i], renderTarget, false);
            }
        } else {
            state.bindFramebuffer(_gl.FRAMEBUFFER, renderTargetProperties.__webglFramebuffer);
            renderTargetProperties.__webglDepthbuffer = _gl.createRenderbuffer();
            setupRenderBufferStorage(renderTargetProperties.__webglDepthbuffer, renderTarget, false);
        }
        state.bindFramebuffer(_gl.FRAMEBUFFER, null);
    }
    // rebind framebuffer with external textures
    function rebindTextures(renderTarget, colorTexture, depthTexture) {
        const renderTargetProperties = properties.get(renderTarget);
        if (colorTexture !== undefined) setupFrameBufferTexture(renderTargetProperties.__webglFramebuffer, renderTarget, renderTarget.texture, _gl.COLOR_ATTACHMENT0, _gl.TEXTURE_2D, 0);
        if (depthTexture !== undefined) setupDepthRenderbuffer(renderTarget);
    }
    // Set up GL resources for the render target
    function setupRenderTarget(renderTarget) {
        const texture = renderTarget.texture;
        const renderTargetProperties = properties.get(renderTarget);
        const textureProperties = properties.get(texture);
        renderTarget.addEventListener("dispose", onRenderTargetDispose);
        if (renderTarget.isWebGLMultipleRenderTargets !== true) {
            if (textureProperties.__webglTexture === undefined) textureProperties.__webglTexture = _gl.createTexture();
            textureProperties.__version = texture.version;
            info.memory.textures++;
        }
        const isCube = renderTarget.isWebGLCubeRenderTarget === true;
        const isMultipleRenderTargets = renderTarget.isWebGLMultipleRenderTargets === true;
        const supportsMips = isPowerOfTwo$1(renderTarget) || isWebGL2;
        // Setup framebuffer
        if (isCube) {
            renderTargetProperties.__webglFramebuffer = [];
            for(let i = 0; i < 6; i++)if (isWebGL2 && texture.mipmaps && texture.mipmaps.length > 0) {
                renderTargetProperties.__webglFramebuffer[i] = [];
                for(let level = 0; level < texture.mipmaps.length; level++)renderTargetProperties.__webglFramebuffer[i][level] = _gl.createFramebuffer();
            } else renderTargetProperties.__webglFramebuffer[i] = _gl.createFramebuffer();
        } else {
            if (isWebGL2 && texture.mipmaps && texture.mipmaps.length > 0) {
                renderTargetProperties.__webglFramebuffer = [];
                for(let level = 0; level < texture.mipmaps.length; level++)renderTargetProperties.__webglFramebuffer[level] = _gl.createFramebuffer();
            } else renderTargetProperties.__webglFramebuffer = _gl.createFramebuffer();
            if (isMultipleRenderTargets) {
                if (capabilities.drawBuffers) {
                    const textures = renderTarget.texture;
                    for(let i = 0, il = textures.length; i < il; i++){
                        const attachmentProperties = properties.get(textures[i]);
                        if (attachmentProperties.__webglTexture === undefined) {
                            attachmentProperties.__webglTexture = _gl.createTexture();
                            info.memory.textures++;
                        }
                    }
                } else console.warn("THREE.WebGLRenderer: WebGLMultipleRenderTargets can only be used with WebGL2 or WEBGL_draw_buffers extension.");
            }
            if (isWebGL2 && renderTarget.samples > 0 && useMultisampledRTT(renderTarget) === false) {
                const textures = isMultipleRenderTargets ? texture : [
                    texture
                ];
                renderTargetProperties.__webglMultisampledFramebuffer = _gl.createFramebuffer();
                renderTargetProperties.__webglColorRenderbuffer = [];
                state.bindFramebuffer(_gl.FRAMEBUFFER, renderTargetProperties.__webglMultisampledFramebuffer);
                for(let i = 0; i < textures.length; i++){
                    const texture = textures[i];
                    renderTargetProperties.__webglColorRenderbuffer[i] = _gl.createRenderbuffer();
                    _gl.bindRenderbuffer(_gl.RENDERBUFFER, renderTargetProperties.__webglColorRenderbuffer[i]);
                    const glFormat = utils.convert(texture.format, texture.colorSpace);
                    const glType = utils.convert(texture.type);
                    const glInternalFormat = getInternalFormat(texture.internalFormat, glFormat, glType, texture.colorSpace, renderTarget.isXRRenderTarget === true);
                    const samples = getRenderTargetSamples(renderTarget);
                    _gl.renderbufferStorageMultisample(_gl.RENDERBUFFER, samples, glInternalFormat, renderTarget.width, renderTarget.height);
                    _gl.framebufferRenderbuffer(_gl.FRAMEBUFFER, _gl.COLOR_ATTACHMENT0 + i, _gl.RENDERBUFFER, renderTargetProperties.__webglColorRenderbuffer[i]);
                }
                _gl.bindRenderbuffer(_gl.RENDERBUFFER, null);
                if (renderTarget.depthBuffer) {
                    renderTargetProperties.__webglDepthRenderbuffer = _gl.createRenderbuffer();
                    setupRenderBufferStorage(renderTargetProperties.__webglDepthRenderbuffer, renderTarget, true);
                }
                state.bindFramebuffer(_gl.FRAMEBUFFER, null);
            }
        }
        // Setup color buffer
        if (isCube) {
            state.bindTexture(_gl.TEXTURE_CUBE_MAP, textureProperties.__webglTexture);
            setTextureParameters(_gl.TEXTURE_CUBE_MAP, texture, supportsMips);
            for(let i = 0; i < 6; i++){
                if (isWebGL2 && texture.mipmaps && texture.mipmaps.length > 0) for(let level = 0; level < texture.mipmaps.length; level++)setupFrameBufferTexture(renderTargetProperties.__webglFramebuffer[i][level], renderTarget, texture, _gl.COLOR_ATTACHMENT0, _gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, level);
                else setupFrameBufferTexture(renderTargetProperties.__webglFramebuffer[i], renderTarget, texture, _gl.COLOR_ATTACHMENT0, _gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, 0);
            }
            if (textureNeedsGenerateMipmaps(texture, supportsMips)) generateMipmap(_gl.TEXTURE_CUBE_MAP);
            state.unbindTexture();
        } else if (isMultipleRenderTargets) {
            const textures = renderTarget.texture;
            for(let i = 0, il = textures.length; i < il; i++){
                const attachment = textures[i];
                const attachmentProperties = properties.get(attachment);
                state.bindTexture(_gl.TEXTURE_2D, attachmentProperties.__webglTexture);
                setTextureParameters(_gl.TEXTURE_2D, attachment, supportsMips);
                setupFrameBufferTexture(renderTargetProperties.__webglFramebuffer, renderTarget, attachment, _gl.COLOR_ATTACHMENT0 + i, _gl.TEXTURE_2D, 0);
                if (textureNeedsGenerateMipmaps(attachment, supportsMips)) generateMipmap(_gl.TEXTURE_2D);
            }
            state.unbindTexture();
        } else {
            let glTextureType = _gl.TEXTURE_2D;
            if (renderTarget.isWebGL3DRenderTarget || renderTarget.isWebGLArrayRenderTarget) {
                if (isWebGL2) glTextureType = renderTarget.isWebGL3DRenderTarget ? _gl.TEXTURE_3D : _gl.TEXTURE_2D_ARRAY;
                else console.error("THREE.WebGLTextures: THREE.Data3DTexture and THREE.DataArrayTexture only supported with WebGL2.");
            }
            state.bindTexture(glTextureType, textureProperties.__webglTexture);
            setTextureParameters(glTextureType, texture, supportsMips);
            if (isWebGL2 && texture.mipmaps && texture.mipmaps.length > 0) for(let level = 0; level < texture.mipmaps.length; level++)setupFrameBufferTexture(renderTargetProperties.__webglFramebuffer[level], renderTarget, texture, _gl.COLOR_ATTACHMENT0, glTextureType, level);
            else setupFrameBufferTexture(renderTargetProperties.__webglFramebuffer, renderTarget, texture, _gl.COLOR_ATTACHMENT0, glTextureType, 0);
            if (textureNeedsGenerateMipmaps(texture, supportsMips)) generateMipmap(glTextureType);
            state.unbindTexture();
        }
        // Setup depth and stencil buffers
        if (renderTarget.depthBuffer) setupDepthRenderbuffer(renderTarget);
    }
    function updateRenderTargetMipmap(renderTarget) {
        const supportsMips = isPowerOfTwo$1(renderTarget) || isWebGL2;
        const textures = renderTarget.isWebGLMultipleRenderTargets === true ? renderTarget.texture : [
            renderTarget.texture
        ];
        for(let i = 0, il = textures.length; i < il; i++){
            const texture = textures[i];
            if (textureNeedsGenerateMipmaps(texture, supportsMips)) {
                const target = renderTarget.isWebGLCubeRenderTarget ? _gl.TEXTURE_CUBE_MAP : _gl.TEXTURE_2D;
                const webglTexture = properties.get(texture).__webglTexture;
                state.bindTexture(target, webglTexture);
                generateMipmap(target);
                state.unbindTexture();
            }
        }
    }
    function updateMultisampleRenderTarget(renderTarget) {
        if (isWebGL2 && renderTarget.samples > 0 && useMultisampledRTT(renderTarget) === false) {
            const textures = renderTarget.isWebGLMultipleRenderTargets ? renderTarget.texture : [
                renderTarget.texture
            ];
            const width = renderTarget.width;
            const height = renderTarget.height;
            let mask = _gl.COLOR_BUFFER_BIT;
            const invalidationArray = [];
            const depthStyle = renderTarget.stencilBuffer ? _gl.DEPTH_STENCIL_ATTACHMENT : _gl.DEPTH_ATTACHMENT;
            const renderTargetProperties = properties.get(renderTarget);
            const isMultipleRenderTargets = renderTarget.isWebGLMultipleRenderTargets === true;
            // If MRT we need to remove FBO attachments
            if (isMultipleRenderTargets) for(let i = 0; i < textures.length; i++){
                state.bindFramebuffer(_gl.FRAMEBUFFER, renderTargetProperties.__webglMultisampledFramebuffer);
                _gl.framebufferRenderbuffer(_gl.FRAMEBUFFER, _gl.COLOR_ATTACHMENT0 + i, _gl.RENDERBUFFER, null);
                state.bindFramebuffer(_gl.FRAMEBUFFER, renderTargetProperties.__webglFramebuffer);
                _gl.framebufferTexture2D(_gl.DRAW_FRAMEBUFFER, _gl.COLOR_ATTACHMENT0 + i, _gl.TEXTURE_2D, null, 0);
            }
            state.bindFramebuffer(_gl.READ_FRAMEBUFFER, renderTargetProperties.__webglMultisampledFramebuffer);
            state.bindFramebuffer(_gl.DRAW_FRAMEBUFFER, renderTargetProperties.__webglFramebuffer);
            for(let i = 0; i < textures.length; i++){
                invalidationArray.push(_gl.COLOR_ATTACHMENT0 + i);
                if (renderTarget.depthBuffer) invalidationArray.push(depthStyle);
                const ignoreDepthValues = renderTargetProperties.__ignoreDepthValues !== undefined ? renderTargetProperties.__ignoreDepthValues : false;
                if (ignoreDepthValues === false) {
                    if (renderTarget.depthBuffer) mask |= _gl.DEPTH_BUFFER_BIT;
                    if (renderTarget.stencilBuffer) mask |= _gl.STENCIL_BUFFER_BIT;
                }
                if (isMultipleRenderTargets) _gl.framebufferRenderbuffer(_gl.READ_FRAMEBUFFER, _gl.COLOR_ATTACHMENT0, _gl.RENDERBUFFER, renderTargetProperties.__webglColorRenderbuffer[i]);
                if (ignoreDepthValues === true) {
                    _gl.invalidateFramebuffer(_gl.READ_FRAMEBUFFER, [
                        depthStyle
                    ]);
                    _gl.invalidateFramebuffer(_gl.DRAW_FRAMEBUFFER, [
                        depthStyle
                    ]);
                }
                if (isMultipleRenderTargets) {
                    const webglTexture = properties.get(textures[i]).__webglTexture;
                    _gl.framebufferTexture2D(_gl.DRAW_FRAMEBUFFER, _gl.COLOR_ATTACHMENT0, _gl.TEXTURE_2D, webglTexture, 0);
                }
                _gl.blitFramebuffer(0, 0, width, height, 0, 0, width, height, mask, _gl.NEAREST);
                if (supportsInvalidateFramebuffer) _gl.invalidateFramebuffer(_gl.READ_FRAMEBUFFER, invalidationArray);
            }
            state.bindFramebuffer(_gl.READ_FRAMEBUFFER, null);
            state.bindFramebuffer(_gl.DRAW_FRAMEBUFFER, null);
            // If MRT since pre-blit we removed the FBO we need to reconstruct the attachments
            if (isMultipleRenderTargets) for(let i = 0; i < textures.length; i++){
                state.bindFramebuffer(_gl.FRAMEBUFFER, renderTargetProperties.__webglMultisampledFramebuffer);
                _gl.framebufferRenderbuffer(_gl.FRAMEBUFFER, _gl.COLOR_ATTACHMENT0 + i, _gl.RENDERBUFFER, renderTargetProperties.__webglColorRenderbuffer[i]);
                const webglTexture = properties.get(textures[i]).__webglTexture;
                state.bindFramebuffer(_gl.FRAMEBUFFER, renderTargetProperties.__webglFramebuffer);
                _gl.framebufferTexture2D(_gl.DRAW_FRAMEBUFFER, _gl.COLOR_ATTACHMENT0 + i, _gl.TEXTURE_2D, webglTexture, 0);
            }
            state.bindFramebuffer(_gl.DRAW_FRAMEBUFFER, renderTargetProperties.__webglMultisampledFramebuffer);
        }
    }
    function getRenderTargetSamples(renderTarget) {
        return Math.min(maxSamples, renderTarget.samples);
    }
    function useMultisampledRTT(renderTarget) {
        const renderTargetProperties = properties.get(renderTarget);
        return isWebGL2 && renderTarget.samples > 0 && extensions.has("WEBGL_multisampled_render_to_texture") === true && renderTargetProperties.__useRenderToTexture !== false;
    }
    function updateVideoTexture(texture) {
        const frame = info.render.frame;
        // Check the last frame we updated the VideoTexture
        if (_videoTextures.get(texture) !== frame) {
            _videoTextures.set(texture, frame);
            texture.update();
        }
    }
    function verifyColorSpace(texture, image) {
        const colorSpace1 = texture.colorSpace;
        const format = texture.format;
        const type = texture.type;
        if (texture.isCompressedTexture === true || texture.format === $9014d97cd777be10$export$ca1dce8b5e1de74d) return image;
        if (colorSpace1 !== $9014d97cd777be10$export$42429b3acfb233a4 && colorSpace1 !== $9014d97cd777be10$export$bfcb490c2dd3db51) {
            // sRGB
            if (colorSpace1 === $9014d97cd777be10$export$561f394b24edfcaa) {
                if (isWebGL2 === false) {
                    // in WebGL 1, try to use EXT_sRGB extension and unsized formats
                    if (extensions.has("EXT_sRGB") === true && format === $9014d97cd777be10$export$3f8bb04b555a363c) {
                        texture.format = $9014d97cd777be10$export$ca1dce8b5e1de74d;
                        // it's not possible to generate mips in WebGL 1 with this extension
                        texture.minFilter = $9014d97cd777be10$export$8a72f490b25c56c8;
                        texture.generateMipmaps = false;
                    } else // slow fallback (CPU decode)
                    image = $9014d97cd777be10$export$698882cf06df44aa.sRGBToLinear(image);
                } else // in WebGL 2 uncompressed textures can only be sRGB encoded if they have the RGBA8 format
                if (format !== $9014d97cd777be10$export$3f8bb04b555a363c || type !== $9014d97cd777be10$export$2e8ce08d3f6f5e10) console.warn("THREE.WebGLTextures: sRGB encoded textures have to use RGBAFormat and UnsignedByteType.");
            } else console.error("THREE.WebGLTextures: Unsupported texture color space:", colorSpace1);
        }
        return image;
    }
    //
    this.allocateTextureUnit = allocateTextureUnit;
    this.resetTextureUnits = resetTextureUnits;
    this.setTexture2D = setTexture2D;
    this.setTexture2DArray = setTexture2DArray;
    this.setTexture3D = setTexture3D;
    this.setTextureCube = setTextureCube;
    this.rebindTextures = rebindTextures;
    this.setupRenderTarget = setupRenderTarget;
    this.updateRenderTargetMipmap = updateRenderTargetMipmap;
    this.updateMultisampleRenderTarget = updateMultisampleRenderTarget;
    this.setupDepthRenderbuffer = setupDepthRenderbuffer;
    this.setupFrameBufferTexture = setupFrameBufferTexture;
    this.useMultisampledRTT = useMultisampledRTT;
}
function $9014d97cd777be10$export$ddaebcad857649a8(gl, extensions, capabilities) {
    const isWebGL2 = capabilities.isWebGL2;
    function convert(p, colorSpace1 = $9014d97cd777be10$export$bfcb490c2dd3db51) {
        let extension;
        if (p === $9014d97cd777be10$export$2e8ce08d3f6f5e10) return gl.UNSIGNED_BYTE;
        if (p === $9014d97cd777be10$export$b3969b01faf587f2) return gl.UNSIGNED_SHORT_4_4_4_4;
        if (p === $9014d97cd777be10$export$18886f8ae33e90de) return gl.UNSIGNED_SHORT_5_5_5_1;
        if (p === $9014d97cd777be10$export$545fce0311a9796a) return gl.BYTE;
        if (p === $9014d97cd777be10$export$88572337f312435f) return gl.SHORT;
        if (p === $9014d97cd777be10$export$c63dc51868b06a9d) return gl.UNSIGNED_SHORT;
        if (p === $9014d97cd777be10$export$5c612977753abe2) return gl.INT;
        if (p === $9014d97cd777be10$export$c3c7fc4518ebba96) return gl.UNSIGNED_INT;
        if (p === $9014d97cd777be10$export$f6d331659b644596) return gl.FLOAT;
        if (p === $9014d97cd777be10$export$2697304443f382bc) {
            if (isWebGL2) return gl.HALF_FLOAT;
            extension = extensions.get("OES_texture_half_float");
            if (extension !== null) return extension.HALF_FLOAT_OES;
            else return null;
        }
        if (p === $9014d97cd777be10$export$988473390501ed4b) return gl.ALPHA;
        if (p === $9014d97cd777be10$export$3f8bb04b555a363c) return gl.RGBA;
        if (p === $9014d97cd777be10$export$cc09ccbf6d1ed449) return gl.LUMINANCE;
        if (p === $9014d97cd777be10$export$9053a81c4a69c289) return gl.LUMINANCE_ALPHA;
        if (p === $9014d97cd777be10$export$c1b6b5136be58045) return gl.DEPTH_COMPONENT;
        if (p === $9014d97cd777be10$export$1e113ac2d0905829) return gl.DEPTH_STENCIL;
        // WebGL 1 sRGB fallback
        if (p === $9014d97cd777be10$export$ca1dce8b5e1de74d) {
            extension = extensions.get("EXT_sRGB");
            if (extension !== null) return extension.SRGB_ALPHA_EXT;
            else return null;
        }
        // WebGL2 formats.
        if (p === $9014d97cd777be10$export$4e041a7967d15c4b) return gl.RED;
        if (p === $9014d97cd777be10$export$aa92e870a709d190) return gl.RED_INTEGER;
        if (p === $9014d97cd777be10$export$6cdf0b461c7ce8a0) return gl.RG;
        if (p === $9014d97cd777be10$export$1ba1c45f9f77d4d7) return gl.RG_INTEGER;
        if (p === $9014d97cd777be10$export$c200e7d26f592f21) return gl.RGBA_INTEGER;
        // S3TC
        if (p === $9014d97cd777be10$export$21d1799c6d552fc0 || p === $9014d97cd777be10$export$afa304c3e981b668 || p === $9014d97cd777be10$export$d2a1a68024a3e56c || p === $9014d97cd777be10$export$9a79c424327dacf9) {
            if (colorSpace1 === $9014d97cd777be10$export$561f394b24edfcaa) {
                extension = extensions.get("WEBGL_compressed_texture_s3tc_srgb");
                if (extension !== null) {
                    if (p === $9014d97cd777be10$export$21d1799c6d552fc0) return extension.COMPRESSED_SRGB_S3TC_DXT1_EXT;
                    if (p === $9014d97cd777be10$export$afa304c3e981b668) return extension.COMPRESSED_SRGB_ALPHA_S3TC_DXT1_EXT;
                    if (p === $9014d97cd777be10$export$d2a1a68024a3e56c) return extension.COMPRESSED_SRGB_ALPHA_S3TC_DXT3_EXT;
                    if (p === $9014d97cd777be10$export$9a79c424327dacf9) return extension.COMPRESSED_SRGB_ALPHA_S3TC_DXT5_EXT;
                } else return null;
            } else {
                extension = extensions.get("WEBGL_compressed_texture_s3tc");
                if (extension !== null) {
                    if (p === $9014d97cd777be10$export$21d1799c6d552fc0) return extension.COMPRESSED_RGB_S3TC_DXT1_EXT;
                    if (p === $9014d97cd777be10$export$afa304c3e981b668) return extension.COMPRESSED_RGBA_S3TC_DXT1_EXT;
                    if (p === $9014d97cd777be10$export$d2a1a68024a3e56c) return extension.COMPRESSED_RGBA_S3TC_DXT3_EXT;
                    if (p === $9014d97cd777be10$export$9a79c424327dacf9) return extension.COMPRESSED_RGBA_S3TC_DXT5_EXT;
                } else return null;
            }
        }
        // PVRTC
        if (p === $9014d97cd777be10$export$19ada9bbb1af3573 || p === $9014d97cd777be10$export$d0f0355bb3d948e4 || p === $9014d97cd777be10$export$b82296714358084c || p === $9014d97cd777be10$export$b71692456c47b6c3) {
            extension = extensions.get("WEBGL_compressed_texture_pvrtc");
            if (extension !== null) {
                if (p === $9014d97cd777be10$export$19ada9bbb1af3573) return extension.COMPRESSED_RGB_PVRTC_4BPPV1_IMG;
                if (p === $9014d97cd777be10$export$d0f0355bb3d948e4) return extension.COMPRESSED_RGB_PVRTC_2BPPV1_IMG;
                if (p === $9014d97cd777be10$export$b82296714358084c) return extension.COMPRESSED_RGBA_PVRTC_4BPPV1_IMG;
                if (p === $9014d97cd777be10$export$b71692456c47b6c3) return extension.COMPRESSED_RGBA_PVRTC_2BPPV1_IMG;
            } else return null;
        }
        // ETC1
        if (p === $9014d97cd777be10$export$6ab91af2d757aee7) {
            extension = extensions.get("WEBGL_compressed_texture_etc1");
            if (extension !== null) return extension.COMPRESSED_RGB_ETC1_WEBGL;
            else return null;
        }
        // ETC2
        if (p === $9014d97cd777be10$export$7800993ef8106a6a || p === $9014d97cd777be10$export$23ed8300a860e7d8) {
            extension = extensions.get("WEBGL_compressed_texture_etc");
            if (extension !== null) {
                if (p === $9014d97cd777be10$export$7800993ef8106a6a) return colorSpace1 === $9014d97cd777be10$export$561f394b24edfcaa ? extension.COMPRESSED_SRGB8_ETC2 : extension.COMPRESSED_RGB8_ETC2;
                if (p === $9014d97cd777be10$export$23ed8300a860e7d8) return colorSpace1 === $9014d97cd777be10$export$561f394b24edfcaa ? extension.COMPRESSED_SRGB8_ALPHA8_ETC2_EAC : extension.COMPRESSED_RGBA8_ETC2_EAC;
            } else return null;
        }
        // ASTC
        if (p === $9014d97cd777be10$export$dc5570b4a2b92d48 || p === $9014d97cd777be10$export$68880cd325f8b2fb || p === $9014d97cd777be10$export$7d2c0be323373d95 || p === $9014d97cd777be10$export$22b52da301fc3a3e || p === $9014d97cd777be10$export$c009e2cb4a66485e || p === $9014d97cd777be10$export$118fff5afa255b63 || p === $9014d97cd777be10$export$120713c829ae0667 || p === $9014d97cd777be10$export$c79eeabbf53313e9 || p === $9014d97cd777be10$export$443cf6567cdd6424 || p === $9014d97cd777be10$export$6573984fc9840780 || p === $9014d97cd777be10$export$e7aee563f30091de || p === $9014d97cd777be10$export$2eb8634622ddeab7 || p === $9014d97cd777be10$export$202b1ce7b5d25742 || p === $9014d97cd777be10$export$18ab77abd087e467) {
            extension = extensions.get("WEBGL_compressed_texture_astc");
            if (extension !== null) {
                if (p === $9014d97cd777be10$export$dc5570b4a2b92d48) return colorSpace1 === $9014d97cd777be10$export$561f394b24edfcaa ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_4x4_KHR : extension.COMPRESSED_RGBA_ASTC_4x4_KHR;
                if (p === $9014d97cd777be10$export$68880cd325f8b2fb) return colorSpace1 === $9014d97cd777be10$export$561f394b24edfcaa ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_5x4_KHR : extension.COMPRESSED_RGBA_ASTC_5x4_KHR;
                if (p === $9014d97cd777be10$export$7d2c0be323373d95) return colorSpace1 === $9014d97cd777be10$export$561f394b24edfcaa ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_5x5_KHR : extension.COMPRESSED_RGBA_ASTC_5x5_KHR;
                if (p === $9014d97cd777be10$export$22b52da301fc3a3e) return colorSpace1 === $9014d97cd777be10$export$561f394b24edfcaa ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_6x5_KHR : extension.COMPRESSED_RGBA_ASTC_6x5_KHR;
                if (p === $9014d97cd777be10$export$c009e2cb4a66485e) return colorSpace1 === $9014d97cd777be10$export$561f394b24edfcaa ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_6x6_KHR : extension.COMPRESSED_RGBA_ASTC_6x6_KHR;
                if (p === $9014d97cd777be10$export$118fff5afa255b63) return colorSpace1 === $9014d97cd777be10$export$561f394b24edfcaa ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_8x5_KHR : extension.COMPRESSED_RGBA_ASTC_8x5_KHR;
                if (p === $9014d97cd777be10$export$120713c829ae0667) return colorSpace1 === $9014d97cd777be10$export$561f394b24edfcaa ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_8x6_KHR : extension.COMPRESSED_RGBA_ASTC_8x6_KHR;
                if (p === $9014d97cd777be10$export$c79eeabbf53313e9) return colorSpace1 === $9014d97cd777be10$export$561f394b24edfcaa ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_8x8_KHR : extension.COMPRESSED_RGBA_ASTC_8x8_KHR;
                if (p === $9014d97cd777be10$export$443cf6567cdd6424) return colorSpace1 === $9014d97cd777be10$export$561f394b24edfcaa ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_10x5_KHR : extension.COMPRESSED_RGBA_ASTC_10x5_KHR;
                if (p === $9014d97cd777be10$export$6573984fc9840780) return colorSpace1 === $9014d97cd777be10$export$561f394b24edfcaa ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_10x6_KHR : extension.COMPRESSED_RGBA_ASTC_10x6_KHR;
                if (p === $9014d97cd777be10$export$e7aee563f30091de) return colorSpace1 === $9014d97cd777be10$export$561f394b24edfcaa ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_10x8_KHR : extension.COMPRESSED_RGBA_ASTC_10x8_KHR;
                if (p === $9014d97cd777be10$export$2eb8634622ddeab7) return colorSpace1 === $9014d97cd777be10$export$561f394b24edfcaa ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_10x10_KHR : extension.COMPRESSED_RGBA_ASTC_10x10_KHR;
                if (p === $9014d97cd777be10$export$202b1ce7b5d25742) return colorSpace1 === $9014d97cd777be10$export$561f394b24edfcaa ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_12x10_KHR : extension.COMPRESSED_RGBA_ASTC_12x10_KHR;
                if (p === $9014d97cd777be10$export$18ab77abd087e467) return colorSpace1 === $9014d97cd777be10$export$561f394b24edfcaa ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_12x12_KHR : extension.COMPRESSED_RGBA_ASTC_12x12_KHR;
            } else return null;
        }
        // BPTC
        if (p === $9014d97cd777be10$export$ce40b115e188bc81) {
            extension = extensions.get("EXT_texture_compression_bptc");
            if (extension !== null) {
                if (p === $9014d97cd777be10$export$ce40b115e188bc81) return colorSpace1 === $9014d97cd777be10$export$561f394b24edfcaa ? extension.COMPRESSED_SRGB_ALPHA_BPTC_UNORM_EXT : extension.COMPRESSED_RGBA_BPTC_UNORM_EXT;
            } else return null;
        }
        // RGTC
        if (p === $9014d97cd777be10$export$b1688df4c4c21670 || p === $9014d97cd777be10$export$fc15e5d8261eed58 || p === $9014d97cd777be10$export$d220f6ade8463a0f || p === $9014d97cd777be10$export$768646d09dc1b6ef) {
            extension = extensions.get("EXT_texture_compression_rgtc");
            if (extension !== null) {
                if (p === $9014d97cd777be10$export$ce40b115e188bc81) return extension.COMPRESSED_RED_RGTC1_EXT;
                if (p === $9014d97cd777be10$export$fc15e5d8261eed58) return extension.COMPRESSED_SIGNED_RED_RGTC1_EXT;
                if (p === $9014d97cd777be10$export$d220f6ade8463a0f) return extension.COMPRESSED_RED_GREEN_RGTC2_EXT;
                if (p === $9014d97cd777be10$export$768646d09dc1b6ef) return extension.COMPRESSED_SIGNED_RED_GREEN_RGTC2_EXT;
            } else return null;
        }
        //
        if (p === $9014d97cd777be10$export$6c8ea339bfab1301) {
            if (isWebGL2) return gl.UNSIGNED_INT_24_8;
            extension = extensions.get("WEBGL_depth_texture");
            if (extension !== null) return extension.UNSIGNED_INT_24_8_WEBGL;
            else return null;
        }
        // if "p" can't be resolved, assume the user defines a WebGL constant as a string (fallback/workaround for packed RGB formats)
        return gl[p] !== undefined ? gl[p] : null;
    }
    return {
        convert: convert
    };
}
class $9014d97cd777be10$export$56b937d9e5581166 extends $9014d97cd777be10$export$74e4ae24825f68d7 {
    constructor(array = []){
        super();
        this.isArrayCamera = true;
        this.cameras = array;
    }
}
class $9014d97cd777be10$export$eb2fcfdbd7ba97d4 extends $9014d97cd777be10$export$e4dd07dff30cc924 {
    constructor(){
        super();
        this.isGroup = true;
        this.type = "Group";
    }
}
const $9014d97cd777be10$var$_moveEvent = {
    type: "move"
};
class $9014d97cd777be10$var$WebXRController {
    getHandSpace() {
        if (this._hand === null) {
            this._hand = new $9014d97cd777be10$export$eb2fcfdbd7ba97d4();
            this._hand.matrixAutoUpdate = false;
            this._hand.visible = false;
            this._hand.joints = {};
            this._hand.inputState = {
                pinching: false
            };
        }
        return this._hand;
    }
    getTargetRaySpace() {
        if (this._targetRay === null) {
            this._targetRay = new $9014d97cd777be10$export$eb2fcfdbd7ba97d4();
            this._targetRay.matrixAutoUpdate = false;
            this._targetRay.visible = false;
            this._targetRay.hasLinearVelocity = false;
            this._targetRay.linearVelocity = new $9014d97cd777be10$export$64b5c384219d3699();
            this._targetRay.hasAngularVelocity = false;
            this._targetRay.angularVelocity = new $9014d97cd777be10$export$64b5c384219d3699();
        }
        return this._targetRay;
    }
    getGripSpace() {
        if (this._grip === null) {
            this._grip = new $9014d97cd777be10$export$eb2fcfdbd7ba97d4();
            this._grip.matrixAutoUpdate = false;
            this._grip.visible = false;
            this._grip.hasLinearVelocity = false;
            this._grip.linearVelocity = new $9014d97cd777be10$export$64b5c384219d3699();
            this._grip.hasAngularVelocity = false;
            this._grip.angularVelocity = new $9014d97cd777be10$export$64b5c384219d3699();
        }
        return this._grip;
    }
    dispatchEvent(event) {
        if (this._targetRay !== null) this._targetRay.dispatchEvent(event);
        if (this._grip !== null) this._grip.dispatchEvent(event);
        if (this._hand !== null) this._hand.dispatchEvent(event);
        return this;
    }
    connect(inputSource) {
        if (inputSource && inputSource.hand) {
            const hand = this._hand;
            if (hand) for (const inputjoint of inputSource.hand.values())// Initialize hand with joints when connected
            this._getHandJoint(hand, inputjoint);
        }
        this.dispatchEvent({
            type: "connected",
            data: inputSource
        });
        return this;
    }
    disconnect(inputSource) {
        this.dispatchEvent({
            type: "disconnected",
            data: inputSource
        });
        if (this._targetRay !== null) this._targetRay.visible = false;
        if (this._grip !== null) this._grip.visible = false;
        if (this._hand !== null) this._hand.visible = false;
        return this;
    }
    update(inputSource, frame, referenceSpace) {
        let inputPose = null;
        let gripPose = null;
        let handPose = null;
        const targetRay = this._targetRay;
        const grip = this._grip;
        const hand = this._hand;
        if (inputSource && frame.session.visibilityState !== "visible-blurred") {
            if (hand && inputSource.hand) {
                handPose = true;
                for (const inputjoint of inputSource.hand.values()){
                    // Update the joints groups with the XRJoint poses
                    const jointPose = frame.getJointPose(inputjoint, referenceSpace);
                    // The transform of this joint will be updated with the joint pose on each frame
                    const joint = this._getHandJoint(hand, inputjoint);
                    if (jointPose !== null) {
                        joint.matrix.fromArray(jointPose.transform.matrix);
                        joint.matrix.decompose(joint.position, joint.rotation, joint.scale);
                        joint.matrixWorldNeedsUpdate = true;
                        joint.jointRadius = jointPose.radius;
                    }
                    joint.visible = jointPose !== null;
                }
                // Custom events
                // Check pinchz
                const indexTip = hand.joints["index-finger-tip"];
                const thumbTip = hand.joints["thumb-tip"];
                const distance = indexTip.position.distanceTo(thumbTip.position);
                const distanceToPinch = 0.02;
                const threshold = 0.005;
                if (hand.inputState.pinching && distance > distanceToPinch + threshold) {
                    hand.inputState.pinching = false;
                    this.dispatchEvent({
                        type: "pinchend",
                        handedness: inputSource.handedness,
                        target: this
                    });
                } else if (!hand.inputState.pinching && distance <= distanceToPinch - threshold) {
                    hand.inputState.pinching = true;
                    this.dispatchEvent({
                        type: "pinchstart",
                        handedness: inputSource.handedness,
                        target: this
                    });
                }
            } else if (grip !== null && inputSource.gripSpace) {
                gripPose = frame.getPose(inputSource.gripSpace, referenceSpace);
                if (gripPose !== null) {
                    grip.matrix.fromArray(gripPose.transform.matrix);
                    grip.matrix.decompose(grip.position, grip.rotation, grip.scale);
                    grip.matrixWorldNeedsUpdate = true;
                    if (gripPose.linearVelocity) {
                        grip.hasLinearVelocity = true;
                        grip.linearVelocity.copy(gripPose.linearVelocity);
                    } else grip.hasLinearVelocity = false;
                    if (gripPose.angularVelocity) {
                        grip.hasAngularVelocity = true;
                        grip.angularVelocity.copy(gripPose.angularVelocity);
                    } else grip.hasAngularVelocity = false;
                }
            }
            if (targetRay !== null) {
                inputPose = frame.getPose(inputSource.targetRaySpace, referenceSpace);
                // Some runtimes (namely Vive Cosmos with Vive OpenXR Runtime) have only grip space and ray space is equal to it
                if (inputPose === null && gripPose !== null) inputPose = gripPose;
                if (inputPose !== null) {
                    targetRay.matrix.fromArray(inputPose.transform.matrix);
                    targetRay.matrix.decompose(targetRay.position, targetRay.rotation, targetRay.scale);
                    targetRay.matrixWorldNeedsUpdate = true;
                    if (inputPose.linearVelocity) {
                        targetRay.hasLinearVelocity = true;
                        targetRay.linearVelocity.copy(inputPose.linearVelocity);
                    } else targetRay.hasLinearVelocity = false;
                    if (inputPose.angularVelocity) {
                        targetRay.hasAngularVelocity = true;
                        targetRay.angularVelocity.copy(inputPose.angularVelocity);
                    } else targetRay.hasAngularVelocity = false;
                    this.dispatchEvent($9014d97cd777be10$var$_moveEvent);
                }
            }
        }
        if (targetRay !== null) targetRay.visible = inputPose !== null;
        if (grip !== null) grip.visible = gripPose !== null;
        if (hand !== null) hand.visible = handPose !== null;
        return this;
    }
    // private method
    _getHandJoint(hand, inputjoint) {
        if (hand.joints[inputjoint.jointName] === undefined) {
            const joint = new $9014d97cd777be10$export$eb2fcfdbd7ba97d4();
            joint.matrixAutoUpdate = false;
            joint.visible = false;
            hand.joints[inputjoint.jointName] = joint;
            hand.add(joint);
        }
        return hand.joints[inputjoint.jointName];
    }
    constructor(){
        this._targetRay = null;
        this._grip = null;
        this._hand = null;
    }
}
class $9014d97cd777be10$export$fc830aa069cc8c2f extends $9014d97cd777be10$export$5431306cf43de24a {
    copy(source) {
        super.copy(source);
        this.compareFunction = source.compareFunction;
        return this;
    }
    toJSON(meta) {
        const data = super.toJSON(meta);
        if (this.compareFunction !== null) data.compareFunction = this.compareFunction;
        return data;
    }
    constructor(width, height, type, mapping, wrapS, wrapT, magFilter, minFilter, anisotropy, format){
        format = format !== undefined ? format : $9014d97cd777be10$export$c1b6b5136be58045;
        if (format !== $9014d97cd777be10$export$c1b6b5136be58045 && format !== $9014d97cd777be10$export$1e113ac2d0905829) throw new Error("DepthTexture format must be either THREE.DepthFormat or THREE.DepthStencilFormat");
        if (type === undefined && format === $9014d97cd777be10$export$c1b6b5136be58045) type = $9014d97cd777be10$export$c3c7fc4518ebba96;
        if (type === undefined && format === $9014d97cd777be10$export$1e113ac2d0905829) type = $9014d97cd777be10$export$6c8ea339bfab1301;
        super(null, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy);
        this.isDepthTexture = true;
        this.image = {
            width: width,
            height: height
        };
        this.magFilter = magFilter !== undefined ? magFilter : $9014d97cd777be10$export$727aa5ec3fe39bf0;
        this.minFilter = minFilter !== undefined ? minFilter : $9014d97cd777be10$export$727aa5ec3fe39bf0;
        this.flipY = false;
        this.generateMipmaps = false;
        this.compareFunction = null;
    }
}
class $9014d97cd777be10$var$WebXRManager extends $9014d97cd777be10$export$ec8b666c5fe2c75a {
    constructor(renderer, gl){
        super();
        const scope = this;
        let session = null;
        let framebufferScaleFactor = 1.0;
        let referenceSpace = null;
        let referenceSpaceType = "local-floor";
        // Set default foveation to maximum.
        let foveation = 1.0;
        let customReferenceSpace = null;
        let pose = null;
        let glBinding = null;
        let glProjLayer = null;
        let glBaseLayer = null;
        let xrFrame = null;
        const attributes = gl.getContextAttributes();
        let initialRenderTarget = null;
        let newRenderTarget = null;
        const controllers = [];
        const controllerInputSources = [];
        //
        const cameraL = new $9014d97cd777be10$export$74e4ae24825f68d7();
        cameraL.layers.enable(1);
        cameraL.viewport = new $9014d97cd777be10$export$fa7daccca11cdbe3();
        const cameraR = new $9014d97cd777be10$export$74e4ae24825f68d7();
        cameraR.layers.enable(2);
        cameraR.viewport = new $9014d97cd777be10$export$fa7daccca11cdbe3();
        const cameras = [
            cameraL,
            cameraR
        ];
        const cameraXR = new $9014d97cd777be10$export$56b937d9e5581166();
        cameraXR.layers.enable(1);
        cameraXR.layers.enable(2);
        let _currentDepthNear = null;
        let _currentDepthFar = null;
        //
        this.cameraAutoUpdate = true;
        this.enabled = false;
        this.isPresenting = false;
        this.getController = function(index) {
            let controller = controllers[index];
            if (controller === undefined) {
                controller = new $9014d97cd777be10$var$WebXRController();
                controllers[index] = controller;
            }
            return controller.getTargetRaySpace();
        };
        this.getControllerGrip = function(index) {
            let controller = controllers[index];
            if (controller === undefined) {
                controller = new $9014d97cd777be10$var$WebXRController();
                controllers[index] = controller;
            }
            return controller.getGripSpace();
        };
        this.getHand = function(index) {
            let controller = controllers[index];
            if (controller === undefined) {
                controller = new $9014d97cd777be10$var$WebXRController();
                controllers[index] = controller;
            }
            return controller.getHandSpace();
        };
        //
        function onSessionEvent(event) {
            const controllerIndex = controllerInputSources.indexOf(event.inputSource);
            if (controllerIndex === -1) return;
            const controller = controllers[controllerIndex];
            if (controller !== undefined) {
                controller.update(event.inputSource, event.frame, customReferenceSpace || referenceSpace);
                controller.dispatchEvent({
                    type: event.type,
                    data: event.inputSource
                });
            }
        }
        function onSessionEnd() {
            session.removeEventListener("select", onSessionEvent);
            session.removeEventListener("selectstart", onSessionEvent);
            session.removeEventListener("selectend", onSessionEvent);
            session.removeEventListener("squeeze", onSessionEvent);
            session.removeEventListener("squeezestart", onSessionEvent);
            session.removeEventListener("squeezeend", onSessionEvent);
            session.removeEventListener("end", onSessionEnd);
            session.removeEventListener("inputsourceschange", onInputSourcesChange);
            for(let i = 0; i < controllers.length; i++){
                const inputSource = controllerInputSources[i];
                if (inputSource === null) continue;
                controllerInputSources[i] = null;
                controllers[i].disconnect(inputSource);
            }
            _currentDepthNear = null;
            _currentDepthFar = null;
            // restore framebuffer/rendering state
            renderer.setRenderTarget(initialRenderTarget);
            glBaseLayer = null;
            glProjLayer = null;
            glBinding = null;
            session = null;
            newRenderTarget = null;
            //
            animation.stop();
            scope.isPresenting = false;
            scope.dispatchEvent({
                type: "sessionend"
            });
        }
        this.setFramebufferScaleFactor = function(value) {
            framebufferScaleFactor = value;
            if (scope.isPresenting === true) console.warn("THREE.WebXRManager: Cannot change framebuffer scale while presenting.");
        };
        this.setReferenceSpaceType = function(value) {
            referenceSpaceType = value;
            if (scope.isPresenting === true) console.warn("THREE.WebXRManager: Cannot change reference space type while presenting.");
        };
        this.getReferenceSpace = function() {
            return customReferenceSpace || referenceSpace;
        };
        this.setReferenceSpace = function(space) {
            customReferenceSpace = space;
        };
        this.getBaseLayer = function() {
            return glProjLayer !== null ? glProjLayer : glBaseLayer;
        };
        this.getBinding = function() {
            return glBinding;
        };
        this.getFrame = function() {
            return xrFrame;
        };
        this.getSession = function() {
            return session;
        };
        this.setSession = async function(value) {
            session = value;
            if (session !== null) {
                initialRenderTarget = renderer.getRenderTarget();
                session.addEventListener("select", onSessionEvent);
                session.addEventListener("selectstart", onSessionEvent);
                session.addEventListener("selectend", onSessionEvent);
                session.addEventListener("squeeze", onSessionEvent);
                session.addEventListener("squeezestart", onSessionEvent);
                session.addEventListener("squeezeend", onSessionEvent);
                session.addEventListener("end", onSessionEnd);
                session.addEventListener("inputsourceschange", onInputSourcesChange);
                if (attributes.xrCompatible !== true) await gl.makeXRCompatible();
                if (session.renderState.layers === undefined || renderer.capabilities.isWebGL2 === false) {
                    const layerInit = {
                        antialias: session.renderState.layers === undefined ? attributes.antialias : true,
                        alpha: true,
                        depth: attributes.depth,
                        stencil: attributes.stencil,
                        framebufferScaleFactor: framebufferScaleFactor
                    };
                    glBaseLayer = new XRWebGLLayer(session, gl, layerInit);
                    session.updateRenderState({
                        baseLayer: glBaseLayer
                    });
                    newRenderTarget = new $9014d97cd777be10$export$3c052beb2e51e23f(glBaseLayer.framebufferWidth, glBaseLayer.framebufferHeight, {
                        format: $9014d97cd777be10$export$3f8bb04b555a363c,
                        type: $9014d97cd777be10$export$2e8ce08d3f6f5e10,
                        colorSpace: renderer.outputColorSpace,
                        stencilBuffer: attributes.stencil
                    });
                } else {
                    let depthFormat = null;
                    let depthType = null;
                    let glDepthFormat = null;
                    if (attributes.depth) {
                        glDepthFormat = attributes.stencil ? gl.DEPTH24_STENCIL8 : gl.DEPTH_COMPONENT24;
                        depthFormat = attributes.stencil ? $9014d97cd777be10$export$1e113ac2d0905829 : $9014d97cd777be10$export$c1b6b5136be58045;
                        depthType = attributes.stencil ? $9014d97cd777be10$export$6c8ea339bfab1301 : $9014d97cd777be10$export$c3c7fc4518ebba96;
                    }
                    const projectionlayerInit = {
                        colorFormat: gl.RGBA8,
                        depthFormat: glDepthFormat,
                        scaleFactor: framebufferScaleFactor
                    };
                    glBinding = new XRWebGLBinding(session, gl);
                    glProjLayer = glBinding.createProjectionLayer(projectionlayerInit);
                    session.updateRenderState({
                        layers: [
                            glProjLayer
                        ]
                    });
                    newRenderTarget = new $9014d97cd777be10$export$3c052beb2e51e23f(glProjLayer.textureWidth, glProjLayer.textureHeight, {
                        format: $9014d97cd777be10$export$3f8bb04b555a363c,
                        type: $9014d97cd777be10$export$2e8ce08d3f6f5e10,
                        depthTexture: new $9014d97cd777be10$export$fc830aa069cc8c2f(glProjLayer.textureWidth, glProjLayer.textureHeight, depthType, undefined, undefined, undefined, undefined, undefined, undefined, depthFormat),
                        stencilBuffer: attributes.stencil,
                        colorSpace: renderer.outputColorSpace,
                        samples: attributes.antialias ? 4 : 0
                    });
                    const renderTargetProperties = renderer.properties.get(newRenderTarget);
                    renderTargetProperties.__ignoreDepthValues = glProjLayer.ignoreDepthValues;
                }
                newRenderTarget.isXRRenderTarget = true; // TODO Remove this when possible, see #23278
                this.setFoveation(foveation);
                customReferenceSpace = null;
                referenceSpace = await session.requestReferenceSpace(referenceSpaceType);
                animation.setContext(session);
                animation.start();
                scope.isPresenting = true;
                scope.dispatchEvent({
                    type: "sessionstart"
                });
            }
        };
        this.getEnvironmentBlendMode = function() {
            if (session !== null) return session.environmentBlendMode;
        };
        function onInputSourcesChange(event) {
            // Notify disconnected
            for(let i = 0; i < event.removed.length; i++){
                const inputSource = event.removed[i];
                const index = controllerInputSources.indexOf(inputSource);
                if (index >= 0) {
                    controllerInputSources[index] = null;
                    controllers[index].disconnect(inputSource);
                }
            }
            // Notify connected
            for(let i = 0; i < event.added.length; i++){
                const inputSource = event.added[i];
                let controllerIndex = controllerInputSources.indexOf(inputSource);
                if (controllerIndex === -1) {
                    // Assign input source a controller that currently has no input source
                    for(let i = 0; i < controllers.length; i++){
                        if (i >= controllerInputSources.length) {
                            controllerInputSources.push(inputSource);
                            controllerIndex = i;
                            break;
                        } else if (controllerInputSources[i] === null) {
                            controllerInputSources[i] = inputSource;
                            controllerIndex = i;
                            break;
                        }
                    }
                    // If all controllers do currently receive input we ignore new ones
                    if (controllerIndex === -1) break;
                }
                const controller = controllers[controllerIndex];
                if (controller) controller.connect(inputSource);
            }
        }
        //
        const cameraLPos = new $9014d97cd777be10$export$64b5c384219d3699();
        const cameraRPos = new $9014d97cd777be10$export$64b5c384219d3699();
        /**
		 * Assumes 2 cameras that are parallel and share an X-axis, and that
		 * the cameras' projection and world matrices have already been set.
		 * And that near and far planes are identical for both cameras.
		 * Visualization of this technique: https://computergraphics.stackexchange.com/a/4765
		 */ function setProjectionFromUnion(camera, cameraL, cameraR) {
            cameraLPos.setFromMatrixPosition(cameraL.matrixWorld);
            cameraRPos.setFromMatrixPosition(cameraR.matrixWorld);
            const ipd = cameraLPos.distanceTo(cameraRPos);
            const projL = cameraL.projectionMatrix.elements;
            const projR = cameraR.projectionMatrix.elements;
            // VR systems will have identical far and near planes, and
            // most likely identical top and bottom frustum extents.
            // Use the left camera for these values.
            const near = projL[14] / (projL[10] - 1);
            const far = projL[14] / (projL[10] + 1);
            const topFov = (projL[9] + 1) / projL[5];
            const bottomFov = (projL[9] - 1) / projL[5];
            const leftFov = (projL[8] - 1) / projL[0];
            const rightFov = (projR[8] + 1) / projR[0];
            const left = near * leftFov;
            const right = near * rightFov;
            // Calculate the new camera's position offset from the
            // left camera. xOffset should be roughly half `ipd`.
            const zOffset = ipd / (-leftFov + rightFov);
            const xOffset = zOffset * -leftFov;
            // TODO: Better way to apply this offset?
            cameraL.matrixWorld.decompose(camera.position, camera.quaternion, camera.scale);
            camera.translateX(xOffset);
            camera.translateZ(zOffset);
            camera.matrixWorld.compose(camera.position, camera.quaternion, camera.scale);
            camera.matrixWorldInverse.copy(camera.matrixWorld).invert();
            // Find the union of the frustum values of the cameras and scale
            // the values so that the near plane's position does not change in world space,
            // although must now be relative to the new union camera.
            const near2 = near + zOffset;
            const far2 = far + zOffset;
            const left2 = left - xOffset;
            const right2 = right + (ipd - xOffset);
            const top2 = topFov * far / far2 * near2;
            const bottom2 = bottomFov * far / far2 * near2;
            camera.projectionMatrix.makePerspective(left2, right2, top2, bottom2, near2, far2);
            camera.projectionMatrixInverse.copy(camera.projectionMatrix).invert();
        }
        function updateCamera(camera, parent) {
            if (parent === null) camera.matrixWorld.copy(camera.matrix);
            else camera.matrixWorld.multiplyMatrices(parent.matrixWorld, camera.matrix);
            camera.matrixWorldInverse.copy(camera.matrixWorld).invert();
        }
        this.updateCamera = function(camera) {
            if (session === null) return;
            cameraXR.near = cameraR.near = cameraL.near = camera.near;
            cameraXR.far = cameraR.far = cameraL.far = camera.far;
            if (_currentDepthNear !== cameraXR.near || _currentDepthFar !== cameraXR.far) {
                // Note that the new renderState won't apply until the next frame. See #18320
                session.updateRenderState({
                    depthNear: cameraXR.near,
                    depthFar: cameraXR.far
                });
                _currentDepthNear = cameraXR.near;
                _currentDepthFar = cameraXR.far;
            }
            const parent = camera.parent;
            const cameras = cameraXR.cameras;
            updateCamera(cameraXR, parent);
            for(let i = 0; i < cameras.length; i++)updateCamera(cameras[i], parent);
            // update projection matrix for proper view frustum culling
            if (cameras.length === 2) setProjectionFromUnion(cameraXR, cameraL, cameraR);
            else // assume single camera setup (AR)
            cameraXR.projectionMatrix.copy(cameraL.projectionMatrix);
            // update user camera and its children
            updateUserCamera(camera, cameraXR, parent);
        };
        function updateUserCamera(camera, cameraXR, parent) {
            if (parent === null) camera.matrix.copy(cameraXR.matrixWorld);
            else {
                camera.matrix.copy(parent.matrixWorld);
                camera.matrix.invert();
                camera.matrix.multiply(cameraXR.matrixWorld);
            }
            camera.matrix.decompose(camera.position, camera.quaternion, camera.scale);
            camera.updateMatrixWorld(true);
            const children = camera.children;
            for(let i = 0, l = children.length; i < l; i++)children[i].updateMatrixWorld(true);
            camera.projectionMatrix.copy(cameraXR.projectionMatrix);
            camera.projectionMatrixInverse.copy(cameraXR.projectionMatrixInverse);
            if (camera.isPerspectiveCamera) {
                camera.fov = $9014d97cd777be10$var$RAD2DEG * 2 * Math.atan(1 / camera.projectionMatrix.elements[5]);
                camera.zoom = 1;
            }
        }
        this.getCamera = function() {
            return cameraXR;
        };
        this.getFoveation = function() {
            if (glProjLayer === null && glBaseLayer === null) return undefined;
            return foveation;
        };
        this.setFoveation = function(value) {
            // 0 = no foveation = full resolution
            // 1 = maximum foveation = the edges render at lower resolution
            foveation = value;
            if (glProjLayer !== null) glProjLayer.fixedFoveation = value;
            if (glBaseLayer !== null && glBaseLayer.fixedFoveation !== undefined) glBaseLayer.fixedFoveation = value;
        };
        // Animation Loop
        let onAnimationFrameCallback = null;
        function onAnimationFrame(time, frame) {
            pose = frame.getViewerPose(customReferenceSpace || referenceSpace);
            xrFrame = frame;
            if (pose !== null) {
                const views = pose.views;
                if (glBaseLayer !== null) {
                    renderer.setRenderTargetFramebuffer(newRenderTarget, glBaseLayer.framebuffer);
                    renderer.setRenderTarget(newRenderTarget);
                }
                let cameraXRNeedsUpdate = false;
                // check if it's necessary to rebuild cameraXR's camera list
                if (views.length !== cameraXR.cameras.length) {
                    cameraXR.cameras.length = 0;
                    cameraXRNeedsUpdate = true;
                }
                for(let i = 0; i < views.length; i++){
                    const view = views[i];
                    let viewport = null;
                    if (glBaseLayer !== null) viewport = glBaseLayer.getViewport(view);
                    else {
                        const glSubImage = glBinding.getViewSubImage(glProjLayer, view);
                        viewport = glSubImage.viewport;
                        // For side-by-side projection, we only produce a single texture for both eyes.
                        if (i === 0) {
                            renderer.setRenderTargetTextures(newRenderTarget, glSubImage.colorTexture, glProjLayer.ignoreDepthValues ? undefined : glSubImage.depthStencilTexture);
                            renderer.setRenderTarget(newRenderTarget);
                        }
                    }
                    let camera = cameras[i];
                    if (camera === undefined) {
                        camera = new $9014d97cd777be10$export$74e4ae24825f68d7();
                        camera.layers.enable(i);
                        camera.viewport = new $9014d97cd777be10$export$fa7daccca11cdbe3();
                        cameras[i] = camera;
                    }
                    camera.matrix.fromArray(view.transform.matrix);
                    camera.matrix.decompose(camera.position, camera.quaternion, camera.scale);
                    camera.projectionMatrix.fromArray(view.projectionMatrix);
                    camera.projectionMatrixInverse.copy(camera.projectionMatrix).invert();
                    camera.viewport.set(viewport.x, viewport.y, viewport.width, viewport.height);
                    if (i === 0) {
                        cameraXR.matrix.copy(camera.matrix);
                        cameraXR.matrix.decompose(cameraXR.position, cameraXR.quaternion, cameraXR.scale);
                    }
                    if (cameraXRNeedsUpdate === true) cameraXR.cameras.push(camera);
                }
            }
            //
            for(let i = 0; i < controllers.length; i++){
                const inputSource = controllerInputSources[i];
                const controller = controllers[i];
                if (inputSource !== null && controller !== undefined) controller.update(inputSource, frame, customReferenceSpace || referenceSpace);
            }
            if (onAnimationFrameCallback) onAnimationFrameCallback(time, frame);
            if (frame.detectedPlanes) scope.dispatchEvent({
                type: "planesdetected",
                data: frame
            });
            xrFrame = null;
        }
        const animation = new $9014d97cd777be10$var$WebGLAnimation();
        animation.setAnimationLoop(onAnimationFrame);
        this.setAnimationLoop = function(callback) {
            onAnimationFrameCallback = callback;
        };
        this.dispose = function() {};
    }
}
function $9014d97cd777be10$var$WebGLMaterials(renderer, properties) {
    function refreshTransformUniform(map, uniform) {
        if (map.matrixAutoUpdate === true) map.updateMatrix();
        uniform.value.copy(map.matrix);
    }
    function refreshFogUniforms(uniforms, fog) {
        fog.color.getRGB(uniforms.fogColor.value, $9014d97cd777be10$var$getUnlitUniformColorSpace(renderer));
        if (fog.isFog) {
            uniforms.fogNear.value = fog.near;
            uniforms.fogFar.value = fog.far;
        } else if (fog.isFogExp2) uniforms.fogDensity.value = fog.density;
    }
    function refreshMaterialUniforms(uniforms, material, pixelRatio, height, transmissionRenderTarget) {
        if (material.isMeshBasicMaterial) refreshUniformsCommon(uniforms, material);
        else if (material.isMeshLambertMaterial) refreshUniformsCommon(uniforms, material);
        else if (material.isMeshToonMaterial) {
            refreshUniformsCommon(uniforms, material);
            refreshUniformsToon(uniforms, material);
        } else if (material.isMeshPhongMaterial) {
            refreshUniformsCommon(uniforms, material);
            refreshUniformsPhong(uniforms, material);
        } else if (material.isMeshStandardMaterial) {
            refreshUniformsCommon(uniforms, material);
            refreshUniformsStandard(uniforms, material);
            if (material.isMeshPhysicalMaterial) refreshUniformsPhysical(uniforms, material, transmissionRenderTarget);
        } else if (material.isMeshMatcapMaterial) {
            refreshUniformsCommon(uniforms, material);
            refreshUniformsMatcap(uniforms, material);
        } else if (material.isMeshDepthMaterial) refreshUniformsCommon(uniforms, material);
        else if (material.isMeshDistanceMaterial) {
            refreshUniformsCommon(uniforms, material);
            refreshUniformsDistance(uniforms, material);
        } else if (material.isMeshNormalMaterial) refreshUniformsCommon(uniforms, material);
        else if (material.isLineBasicMaterial) {
            refreshUniformsLine(uniforms, material);
            if (material.isLineDashedMaterial) refreshUniformsDash(uniforms, material);
        } else if (material.isPointsMaterial) refreshUniformsPoints(uniforms, material, pixelRatio, height);
        else if (material.isSpriteMaterial) refreshUniformsSprites(uniforms, material);
        else if (material.isShadowMaterial) {
            uniforms.color.value.copy(material.color);
            uniforms.opacity.value = material.opacity;
        } else if (material.isShaderMaterial) material.uniformsNeedUpdate = false; // #15581
    }
    function refreshUniformsCommon(uniforms, material) {
        uniforms.opacity.value = material.opacity;
        if (material.color) uniforms.diffuse.value.copy(material.color);
        if (material.emissive) uniforms.emissive.value.copy(material.emissive).multiplyScalar(material.emissiveIntensity);
        if (material.map) {
            uniforms.map.value = material.map;
            refreshTransformUniform(material.map, uniforms.mapTransform);
        }
        if (material.alphaMap) {
            uniforms.alphaMap.value = material.alphaMap;
            refreshTransformUniform(material.alphaMap, uniforms.alphaMapTransform);
        }
        if (material.bumpMap) {
            uniforms.bumpMap.value = material.bumpMap;
            refreshTransformUniform(material.bumpMap, uniforms.bumpMapTransform);
            uniforms.bumpScale.value = material.bumpScale;
            if (material.side === $9014d97cd777be10$export$d9f0486e75b5ace) uniforms.bumpScale.value *= -1;
        }
        if (material.normalMap) {
            uniforms.normalMap.value = material.normalMap;
            refreshTransformUniform(material.normalMap, uniforms.normalMapTransform);
            uniforms.normalScale.value.copy(material.normalScale);
            if (material.side === $9014d97cd777be10$export$d9f0486e75b5ace) uniforms.normalScale.value.negate();
        }
        if (material.displacementMap) {
            uniforms.displacementMap.value = material.displacementMap;
            refreshTransformUniform(material.displacementMap, uniforms.displacementMapTransform);
            uniforms.displacementScale.value = material.displacementScale;
            uniforms.displacementBias.value = material.displacementBias;
        }
        if (material.emissiveMap) {
            uniforms.emissiveMap.value = material.emissiveMap;
            refreshTransformUniform(material.emissiveMap, uniforms.emissiveMapTransform);
        }
        if (material.specularMap) {
            uniforms.specularMap.value = material.specularMap;
            refreshTransformUniform(material.specularMap, uniforms.specularMapTransform);
        }
        if (material.alphaTest > 0) uniforms.alphaTest.value = material.alphaTest;
        const envMap = properties.get(material).envMap;
        if (envMap) {
            uniforms.envMap.value = envMap;
            uniforms.flipEnvMap.value = envMap.isCubeTexture && envMap.isRenderTargetTexture === false ? -1 : 1;
            uniforms.reflectivity.value = material.reflectivity;
            uniforms.ior.value = material.ior;
            uniforms.refractionRatio.value = material.refractionRatio;
        }
        if (material.lightMap) {
            uniforms.lightMap.value = material.lightMap;
            // artist-friendly light intensity scaling factor
            const scaleFactor = renderer._useLegacyLights === true ? Math.PI : 1;
            uniforms.lightMapIntensity.value = material.lightMapIntensity * scaleFactor;
            refreshTransformUniform(material.lightMap, uniforms.lightMapTransform);
        }
        if (material.aoMap) {
            uniforms.aoMap.value = material.aoMap;
            uniforms.aoMapIntensity.value = material.aoMapIntensity;
            refreshTransformUniform(material.aoMap, uniforms.aoMapTransform);
        }
    }
    function refreshUniformsLine(uniforms, material) {
        uniforms.diffuse.value.copy(material.color);
        uniforms.opacity.value = material.opacity;
        if (material.map) {
            uniforms.map.value = material.map;
            refreshTransformUniform(material.map, uniforms.mapTransform);
        }
    }
    function refreshUniformsDash(uniforms, material) {
        uniforms.dashSize.value = material.dashSize;
        uniforms.totalSize.value = material.dashSize + material.gapSize;
        uniforms.scale.value = material.scale;
    }
    function refreshUniformsPoints(uniforms, material, pixelRatio, height) {
        uniforms.diffuse.value.copy(material.color);
        uniforms.opacity.value = material.opacity;
        uniforms.size.value = material.size * pixelRatio;
        uniforms.scale.value = height * 0.5;
        if (material.map) {
            uniforms.map.value = material.map;
            refreshTransformUniform(material.map, uniforms.uvTransform);
        }
        if (material.alphaMap) {
            uniforms.alphaMap.value = material.alphaMap;
            refreshTransformUniform(material.alphaMap, uniforms.alphaMapTransform);
        }
        if (material.alphaTest > 0) uniforms.alphaTest.value = material.alphaTest;
    }
    function refreshUniformsSprites(uniforms, material) {
        uniforms.diffuse.value.copy(material.color);
        uniforms.opacity.value = material.opacity;
        uniforms.rotation.value = material.rotation;
        if (material.map) {
            uniforms.map.value = material.map;
            refreshTransformUniform(material.map, uniforms.mapTransform);
        }
        if (material.alphaMap) {
            uniforms.alphaMap.value = material.alphaMap;
            refreshTransformUniform(material.alphaMap, uniforms.alphaMapTransform);
        }
        if (material.alphaTest > 0) uniforms.alphaTest.value = material.alphaTest;
    }
    function refreshUniformsPhong(uniforms, material) {
        uniforms.specular.value.copy(material.specular);
        uniforms.shininess.value = Math.max(material.shininess, 1e-4); // to prevent pow( 0.0, 0.0 )
    }
    function refreshUniformsToon(uniforms, material) {
        if (material.gradientMap) uniforms.gradientMap.value = material.gradientMap;
    }
    function refreshUniformsStandard(uniforms, material) {
        uniforms.metalness.value = material.metalness;
        if (material.metalnessMap) {
            uniforms.metalnessMap.value = material.metalnessMap;
            refreshTransformUniform(material.metalnessMap, uniforms.metalnessMapTransform);
        }
        uniforms.roughness.value = material.roughness;
        if (material.roughnessMap) {
            uniforms.roughnessMap.value = material.roughnessMap;
            refreshTransformUniform(material.roughnessMap, uniforms.roughnessMapTransform);
        }
        const envMap = properties.get(material).envMap;
        if (envMap) //uniforms.envMap.value = material.envMap; // part of uniforms common
        uniforms.envMapIntensity.value = material.envMapIntensity;
    }
    function refreshUniformsPhysical(uniforms, material, transmissionRenderTarget) {
        uniforms.ior.value = material.ior; // also part of uniforms common
        if (material.sheen > 0) {
            uniforms.sheenColor.value.copy(material.sheenColor).multiplyScalar(material.sheen);
            uniforms.sheenRoughness.value = material.sheenRoughness;
            if (material.sheenColorMap) {
                uniforms.sheenColorMap.value = material.sheenColorMap;
                refreshTransformUniform(material.sheenColorMap, uniforms.sheenColorMapTransform);
            }
            if (material.sheenRoughnessMap) {
                uniforms.sheenRoughnessMap.value = material.sheenRoughnessMap;
                refreshTransformUniform(material.sheenRoughnessMap, uniforms.sheenRoughnessMapTransform);
            }
        }
        if (material.clearcoat > 0) {
            uniforms.clearcoat.value = material.clearcoat;
            uniforms.clearcoatRoughness.value = material.clearcoatRoughness;
            if (material.clearcoatMap) {
                uniforms.clearcoatMap.value = material.clearcoatMap;
                refreshTransformUniform(material.clearcoatMap, uniforms.clearcoatMapTransform);
            }
            if (material.clearcoatRoughnessMap) {
                uniforms.clearcoatRoughnessMap.value = material.clearcoatRoughnessMap;
                refreshTransformUniform(material.clearcoatRoughnessMap, uniforms.clearcoatRoughnessMapTransform);
            }
            if (material.clearcoatNormalMap) {
                uniforms.clearcoatNormalMap.value = material.clearcoatNormalMap;
                refreshTransformUniform(material.clearcoatNormalMap, uniforms.clearcoatNormalMapTransform);
                uniforms.clearcoatNormalScale.value.copy(material.clearcoatNormalScale);
                if (material.side === $9014d97cd777be10$export$d9f0486e75b5ace) uniforms.clearcoatNormalScale.value.negate();
            }
        }
        if (material.iridescence > 0) {
            uniforms.iridescence.value = material.iridescence;
            uniforms.iridescenceIOR.value = material.iridescenceIOR;
            uniforms.iridescenceThicknessMinimum.value = material.iridescenceThicknessRange[0];
            uniforms.iridescenceThicknessMaximum.value = material.iridescenceThicknessRange[1];
            if (material.iridescenceMap) {
                uniforms.iridescenceMap.value = material.iridescenceMap;
                refreshTransformUniform(material.iridescenceMap, uniforms.iridescenceMapTransform);
            }
            if (material.iridescenceThicknessMap) {
                uniforms.iridescenceThicknessMap.value = material.iridescenceThicknessMap;
                refreshTransformUniform(material.iridescenceThicknessMap, uniforms.iridescenceThicknessMapTransform);
            }
        }
        if (material.transmission > 0) {
            uniforms.transmission.value = material.transmission;
            uniforms.transmissionSamplerMap.value = transmissionRenderTarget.texture;
            uniforms.transmissionSamplerSize.value.set(transmissionRenderTarget.width, transmissionRenderTarget.height);
            if (material.transmissionMap) {
                uniforms.transmissionMap.value = material.transmissionMap;
                refreshTransformUniform(material.transmissionMap, uniforms.transmissionMapTransform);
            }
            uniforms.thickness.value = material.thickness;
            if (material.thicknessMap) {
                uniforms.thicknessMap.value = material.thicknessMap;
                refreshTransformUniform(material.thicknessMap, uniforms.thicknessMapTransform);
            }
            uniforms.attenuationDistance.value = material.attenuationDistance;
            uniforms.attenuationColor.value.copy(material.attenuationColor);
        }
        if (material.anisotropy > 0) {
            uniforms.anisotropyVector.value.set(material.anisotropy * Math.cos(material.anisotropyRotation), material.anisotropy * Math.sin(material.anisotropyRotation));
            if (material.anisotropyMap) {
                uniforms.anisotropyMap.value = material.anisotropyMap;
                refreshTransformUniform(material.anisotropyMap, uniforms.anisotropyMapTransform);
            }
        }
        uniforms.specularIntensity.value = material.specularIntensity;
        uniforms.specularColor.value.copy(material.specularColor);
        if (material.specularColorMap) {
            uniforms.specularColorMap.value = material.specularColorMap;
            refreshTransformUniform(material.specularColorMap, uniforms.specularColorMapTransform);
        }
        if (material.specularIntensityMap) {
            uniforms.specularIntensityMap.value = material.specularIntensityMap;
            refreshTransformUniform(material.specularIntensityMap, uniforms.specularIntensityMapTransform);
        }
    }
    function refreshUniformsMatcap(uniforms, material) {
        if (material.matcap) uniforms.matcap.value = material.matcap;
    }
    function refreshUniformsDistance(uniforms, material) {
        const light = properties.get(material).light;
        uniforms.referencePosition.value.setFromMatrixPosition(light.matrixWorld);
        uniforms.nearDistance.value = light.shadow.camera.near;
        uniforms.farDistance.value = light.shadow.camera.far;
    }
    return {
        refreshFogUniforms: refreshFogUniforms,
        refreshMaterialUniforms: refreshMaterialUniforms
    };
}
function $9014d97cd777be10$var$WebGLUniformsGroups(gl, info, capabilities, state) {
    let buffers = {};
    let updateList = {};
    let allocatedBindingPoints = [];
    const maxBindingPoints = capabilities.isWebGL2 ? gl.getParameter(gl.MAX_UNIFORM_BUFFER_BINDINGS) : 0; // binding points are global whereas block indices are per shader program
    function bind(uniformsGroup, program) {
        const webglProgram = program.program;
        state.uniformBlockBinding(uniformsGroup, webglProgram);
    }
    function update(uniformsGroup, program) {
        let buffer = buffers[uniformsGroup.id];
        if (buffer === undefined) {
            prepareUniformsGroup(uniformsGroup);
            buffer = createBuffer(uniformsGroup);
            buffers[uniformsGroup.id] = buffer;
            uniformsGroup.addEventListener("dispose", onUniformsGroupsDispose);
        }
        // ensure to update the binding points/block indices mapping for this program
        const webglProgram = program.program;
        state.updateUBOMapping(uniformsGroup, webglProgram);
        // update UBO once per frame
        const frame = info.render.frame;
        if (updateList[uniformsGroup.id] !== frame) {
            updateBufferData(uniformsGroup);
            updateList[uniformsGroup.id] = frame;
        }
    }
    function createBuffer(uniformsGroup) {
        // the setup of an UBO is independent of a particular shader program but global
        const bindingPointIndex = allocateBindingPointIndex();
        uniformsGroup.__bindingPointIndex = bindingPointIndex;
        const buffer = gl.createBuffer();
        const size = uniformsGroup.__size;
        const usage = uniformsGroup.usage;
        gl.bindBuffer(gl.UNIFORM_BUFFER, buffer);
        gl.bufferData(gl.UNIFORM_BUFFER, size, usage);
        gl.bindBuffer(gl.UNIFORM_BUFFER, null);
        gl.bindBufferBase(gl.UNIFORM_BUFFER, bindingPointIndex, buffer);
        return buffer;
    }
    function allocateBindingPointIndex() {
        for(let i = 0; i < maxBindingPoints; i++)if (allocatedBindingPoints.indexOf(i) === -1) {
            allocatedBindingPoints.push(i);
            return i;
        }
        console.error("THREE.WebGLRenderer: Maximum number of simultaneously usable uniforms groups reached.");
        return 0;
    }
    function updateBufferData(uniformsGroup) {
        const buffer = buffers[uniformsGroup.id];
        const uniforms = uniformsGroup.uniforms;
        const cache = uniformsGroup.__cache;
        gl.bindBuffer(gl.UNIFORM_BUFFER, buffer);
        for(let i = 0, il = uniforms.length; i < il; i++){
            const uniform = uniforms[i];
            // partly update the buffer if necessary
            if (hasUniformChanged(uniform, i, cache) === true) {
                const offset = uniform.__offset;
                const values = Array.isArray(uniform.value) ? uniform.value : [
                    uniform.value
                ];
                let arrayOffset = 0;
                for(let i = 0; i < values.length; i++){
                    const value = values[i];
                    const info = getUniformSize(value);
                    if (typeof value === "number") {
                        uniform.__data[0] = value;
                        gl.bufferSubData(gl.UNIFORM_BUFFER, offset + arrayOffset, uniform.__data);
                    } else if (value.isMatrix3) {
                        // manually converting 3x3 to 3x4
                        uniform.__data[0] = value.elements[0];
                        uniform.__data[1] = value.elements[1];
                        uniform.__data[2] = value.elements[2];
                        uniform.__data[3] = value.elements[0];
                        uniform.__data[4] = value.elements[3];
                        uniform.__data[5] = value.elements[4];
                        uniform.__data[6] = value.elements[5];
                        uniform.__data[7] = value.elements[0];
                        uniform.__data[8] = value.elements[6];
                        uniform.__data[9] = value.elements[7];
                        uniform.__data[10] = value.elements[8];
                        uniform.__data[11] = value.elements[0];
                    } else {
                        value.toArray(uniform.__data, arrayOffset);
                        arrayOffset += info.storage / Float32Array.BYTES_PER_ELEMENT;
                    }
                }
                gl.bufferSubData(gl.UNIFORM_BUFFER, offset, uniform.__data);
            }
        }
        gl.bindBuffer(gl.UNIFORM_BUFFER, null);
    }
    function hasUniformChanged(uniform, index, cache) {
        const value = uniform.value;
        if (cache[index] === undefined) {
            // cache entry does not exist so far
            if (typeof value === "number") cache[index] = value;
            else {
                const values = Array.isArray(value) ? value : [
                    value
                ];
                const tempValues = [];
                for(let i = 0; i < values.length; i++)tempValues.push(values[i].clone());
                cache[index] = tempValues;
            }
            return true;
        } else {
            // compare current value with cached entry
            if (typeof value === "number") {
                if (cache[index] !== value) {
                    cache[index] = value;
                    return true;
                }
            } else {
                const cachedObjects = Array.isArray(cache[index]) ? cache[index] : [
                    cache[index]
                ];
                const values = Array.isArray(value) ? value : [
                    value
                ];
                for(let i = 0; i < cachedObjects.length; i++){
                    const cachedObject = cachedObjects[i];
                    if (cachedObject.equals(values[i]) === false) {
                        cachedObject.copy(values[i]);
                        return true;
                    }
                }
            }
        }
        return false;
    }
    function prepareUniformsGroup(uniformsGroup) {
        // determine total buffer size according to the STD140 layout
        // Hint: STD140 is the only supported layout in WebGL 2
        const uniforms = uniformsGroup.uniforms;
        let offset = 0; // global buffer offset in bytes
        const chunkSize = 16; // size of a chunk in bytes
        let chunkOffset = 0; // offset within a single chunk in bytes
        for(let i = 0, l = uniforms.length; i < l; i++){
            const uniform = uniforms[i];
            const infos = {
                boundary: 0,
                storage: 0 // bytes
            };
            const values = Array.isArray(uniform.value) ? uniform.value : [
                uniform.value
            ];
            for(let j = 0, jl = values.length; j < jl; j++){
                const value = values[j];
                const info = getUniformSize(value);
                infos.boundary += info.boundary;
                infos.storage += info.storage;
            }
            // the following two properties will be used for partial buffer updates
            uniform.__data = new Float32Array(infos.storage / Float32Array.BYTES_PER_ELEMENT);
            uniform.__offset = offset;
            //
            if (i > 0) {
                chunkOffset = offset % chunkSize;
                const remainingSizeInChunk = chunkSize - chunkOffset;
                // check for chunk overflow
                if (chunkOffset !== 0 && remainingSizeInChunk - infos.boundary < 0) {
                    // add padding and adjust offset
                    offset += chunkSize - chunkOffset;
                    uniform.__offset = offset;
                }
            }
            offset += infos.storage;
        }
        // ensure correct final padding
        chunkOffset = offset % chunkSize;
        if (chunkOffset > 0) offset += chunkSize - chunkOffset;
        //
        uniformsGroup.__size = offset;
        uniformsGroup.__cache = {};
        return this;
    }
    function getUniformSize(value) {
        const info = {
            boundary: 0,
            storage: 0 // bytes
        };
        // determine sizes according to STD140
        if (typeof value === "number") {
            // float/int
            info.boundary = 4;
            info.storage = 4;
        } else if (value.isVector2) {
            // vec2
            info.boundary = 8;
            info.storage = 8;
        } else if (value.isVector3 || value.isColor) {
            // vec3
            info.boundary = 16;
            info.storage = 12; // evil: vec3 must start on a 16-byte boundary but it only consumes 12 bytes
        } else if (value.isVector4) {
            // vec4
            info.boundary = 16;
            info.storage = 16;
        } else if (value.isMatrix3) {
            // mat3 (in STD140 a 3x3 matrix is represented as 3x4)
            info.boundary = 48;
            info.storage = 48;
        } else if (value.isMatrix4) {
            // mat4
            info.boundary = 64;
            info.storage = 64;
        } else if (value.isTexture) console.warn("THREE.WebGLRenderer: Texture samplers can not be part of an uniforms group.");
        else console.warn("THREE.WebGLRenderer: Unsupported uniform value type.", value);
        return info;
    }
    function onUniformsGroupsDispose(event) {
        const uniformsGroup = event.target;
        uniformsGroup.removeEventListener("dispose", onUniformsGroupsDispose);
        const index = allocatedBindingPoints.indexOf(uniformsGroup.__bindingPointIndex);
        allocatedBindingPoints.splice(index, 1);
        gl.deleteBuffer(buffers[uniformsGroup.id]);
        delete buffers[uniformsGroup.id];
        delete updateList[uniformsGroup.id];
    }
    function dispose() {
        for(const id in buffers)gl.deleteBuffer(buffers[id]);
        allocatedBindingPoints = [];
        buffers = {};
        updateList = {};
    }
    return {
        bind: bind,
        update: update,
        dispose: dispose
    };
}
function $9014d97cd777be10$var$createCanvasElement() {
    const canvas = $9014d97cd777be10$var$createElementNS("canvas");
    canvas.style.display = "block";
    return canvas;
}
class $9014d97cd777be10$export$f6cc00ef28d7cf97 {
    get coordinateSystem() {
        return $9014d97cd777be10$export$5a0e9190d10875d3;
    }
    get physicallyCorrectLights() {
        console.warn("THREE.WebGLRenderer: The property .physicallyCorrectLights has been removed. Set renderer.useLegacyLights instead.");
        return !this.useLegacyLights;
    }
    set physicallyCorrectLights(value) {
        console.warn("THREE.WebGLRenderer: The property .physicallyCorrectLights has been removed. Set renderer.useLegacyLights instead.");
        this.useLegacyLights = !value;
    }
    get outputEncoding() {
        console.warn("THREE.WebGLRenderer: Property .outputEncoding has been removed. Use .outputColorSpace instead.");
        return this.outputColorSpace === $9014d97cd777be10$export$561f394b24edfcaa ? $9014d97cd777be10$export$f32388edbb32674 : $9014d97cd777be10$export$7207336e4151a112;
    }
    set outputEncoding(encoding) {
        console.warn("THREE.WebGLRenderer: Property .outputEncoding has been removed. Use .outputColorSpace instead.");
        this.outputColorSpace = encoding === $9014d97cd777be10$export$f32388edbb32674 ? $9014d97cd777be10$export$561f394b24edfcaa : $9014d97cd777be10$export$42429b3acfb233a4;
    }
    get useLegacyLights() {
        console.warn("THREE.WebGLRenderer: The property .useLegacyLights has been deprecated. Migrate your lighting according to the following guide: https://discourse.threejs.org/t/updates-to-lighting-in-three-js-r155/53733.");
        return this._useLegacyLights;
    }
    set useLegacyLights(value) {
        console.warn("THREE.WebGLRenderer: The property .useLegacyLights has been deprecated. Migrate your lighting according to the following guide: https://discourse.threejs.org/t/updates-to-lighting-in-three-js-r155/53733.");
        this._useLegacyLights = value;
    }
    constructor(parameters = {}){
        const { canvas: canvas = $9014d97cd777be10$var$createCanvasElement(), context: context = null, depth: depth = true, stencil: stencil = true, alpha: alpha = false, antialias: antialias = false, premultipliedAlpha: premultipliedAlpha = true, preserveDrawingBuffer: preserveDrawingBuffer = false, powerPreference: powerPreference = "default", failIfMajorPerformanceCaveat: failIfMajorPerformanceCaveat = false } = parameters;
        this.isWebGLRenderer = true;
        let _alpha;
        if (context !== null) _alpha = context.getContextAttributes().alpha;
        else _alpha = alpha;
        const uintClearColor = new Uint32Array(4);
        const intClearColor = new Int32Array(4);
        let currentRenderList = null;
        let currentRenderState = null;
        // render() can be called from within a callback triggered by another render.
        // We track this so that the nested render call gets its list and state isolated from the parent render call.
        const renderListStack = [];
        const renderStateStack = [];
        // public properties
        this.domElement = canvas;
        // Debug configuration container
        this.debug = {
            /**
			 * Enables error checking and reporting when shader programs are being compiled
			 * @type {boolean}
			 */ checkShaderErrors: true,
            /**
			 * Callback for custom error reporting.
			 * @type {?Function}
			 */ onShaderError: null
        };
        // clearing
        this.autoClear = true;
        this.autoClearColor = true;
        this.autoClearDepth = true;
        this.autoClearStencil = true;
        // scene graph
        this.sortObjects = true;
        // user-defined clipping
        this.clippingPlanes = [];
        this.localClippingEnabled = false;
        // physically based shading
        this.outputColorSpace = $9014d97cd777be10$export$561f394b24edfcaa;
        // physical lights
        this._useLegacyLights = false;
        // tone mapping
        this.toneMapping = $9014d97cd777be10$export$9fcb6b4294603b2;
        this.toneMappingExposure = 1.0;
        // internal properties
        const _this = this;
        let _isContextLost = false;
        // internal state cache
        let _currentActiveCubeFace = 0;
        let _currentActiveMipmapLevel = 0;
        let _currentRenderTarget = null;
        let _currentMaterialId = -1;
        let _currentCamera = null;
        const _currentViewport = new $9014d97cd777be10$export$fa7daccca11cdbe3();
        const _currentScissor = new $9014d97cd777be10$export$fa7daccca11cdbe3();
        let _currentScissorTest = null;
        const _currentClearColor = new $9014d97cd777be10$export$892596cec99bc70e(0x000000);
        let _currentClearAlpha = 0;
        //
        let _width = canvas.width;
        let _height = canvas.height;
        let _pixelRatio = 1;
        let _opaqueSort = null;
        let _transparentSort = null;
        const _viewport = new $9014d97cd777be10$export$fa7daccca11cdbe3(0, 0, _width, _height);
        const _scissor = new $9014d97cd777be10$export$fa7daccca11cdbe3(0, 0, _width, _height);
        let _scissorTest = false;
        // frustum
        const _frustum = new $9014d97cd777be10$export$35efe6f4c85463d2();
        // clipping
        let _clippingEnabled = false;
        let _localClippingEnabled = false;
        // transmission
        let _transmissionRenderTarget = null;
        // camera matrices cache
        const _projScreenMatrix = new $9014d97cd777be10$export$2ae72fc923e5eb5();
        const _vector2 = new $9014d97cd777be10$export$c977b3e384af9ae1();
        const _vector3 = new $9014d97cd777be10$export$64b5c384219d3699();
        const _emptyScene = {
            background: null,
            fog: null,
            environment: null,
            overrideMaterial: null,
            isScene: true
        };
        function getTargetPixelRatio() {
            return _currentRenderTarget === null ? _pixelRatio : 1;
        }
        // initialize
        let _gl = context;
        function getContext(contextNames, contextAttributes) {
            for(let i = 0; i < contextNames.length; i++){
                const contextName = contextNames[i];
                const context = canvas.getContext(contextName, contextAttributes);
                if (context !== null) return context;
            }
            return null;
        }
        try {
            const contextAttributes = {
                alpha: true,
                depth: depth,
                stencil: stencil,
                antialias: antialias,
                premultipliedAlpha: premultipliedAlpha,
                preserveDrawingBuffer: preserveDrawingBuffer,
                powerPreference: powerPreference,
                failIfMajorPerformanceCaveat: failIfMajorPerformanceCaveat
            };
            // OffscreenCanvas does not have setAttribute, see #22811
            if ("setAttribute" in canvas) canvas.setAttribute("data-engine", `three.js r${$9014d97cd777be10$export$3545e07a80636437}`);
            // event listeners must be registered before WebGL context is created, see #12753
            canvas.addEventListener("webglcontextlost", onContextLost, false);
            canvas.addEventListener("webglcontextrestored", onContextRestore, false);
            canvas.addEventListener("webglcontextcreationerror", onContextCreationError, false);
            if (_gl === null) {
                const contextNames = [
                    "webgl2",
                    "webgl",
                    "experimental-webgl"
                ];
                if (_this.isWebGL1Renderer === true) contextNames.shift();
                _gl = getContext(contextNames, contextAttributes);
                if (_gl === null) {
                    if (getContext(contextNames)) throw new Error("Error creating WebGL context with your selected attributes.");
                    else throw new Error("Error creating WebGL context.");
                }
            }
            if (typeof WebGLRenderingContext !== "undefined" && _gl instanceof WebGLRenderingContext) console.warn("THREE.WebGLRenderer: WebGL 1 support was deprecated in r153 and will be removed in r163.");
            // Some experimental-webgl implementations do not have getShaderPrecisionFormat
            if (_gl.getShaderPrecisionFormat === undefined) _gl.getShaderPrecisionFormat = function() {
                return {
                    "rangeMin": 1,
                    "rangeMax": 1,
                    "precision": 1
                };
            };
        } catch (error) {
            console.error("THREE.WebGLRenderer: " + error.message);
            throw error;
        }
        let extensions, capabilities, state, info;
        let properties, textures, cubemaps, cubeuvmaps, attributes, geometries, objects;
        let programCache, materials, renderLists, renderStates, clipping, shadowMap;
        let background, morphtargets, bufferRenderer, indexedBufferRenderer;
        let utils, bindingStates, uniformsGroups;
        function initGLContext() {
            extensions = new $9014d97cd777be10$var$WebGLExtensions(_gl);
            capabilities = new $9014d97cd777be10$var$WebGLCapabilities(_gl, extensions, parameters);
            extensions.init(capabilities);
            utils = new $9014d97cd777be10$export$ddaebcad857649a8(_gl, extensions, capabilities);
            state = new $9014d97cd777be10$var$WebGLState(_gl, extensions, capabilities);
            info = new $9014d97cd777be10$var$WebGLInfo(_gl);
            properties = new $9014d97cd777be10$var$WebGLProperties();
            textures = new $9014d97cd777be10$var$WebGLTextures(_gl, extensions, state, properties, capabilities, utils, info);
            cubemaps = new $9014d97cd777be10$var$WebGLCubeMaps(_this);
            cubeuvmaps = new $9014d97cd777be10$var$WebGLCubeUVMaps(_this);
            attributes = new $9014d97cd777be10$var$WebGLAttributes(_gl, capabilities);
            bindingStates = new $9014d97cd777be10$var$WebGLBindingStates(_gl, extensions, attributes, capabilities);
            geometries = new $9014d97cd777be10$var$WebGLGeometries(_gl, attributes, info, bindingStates);
            objects = new $9014d97cd777be10$var$WebGLObjects(_gl, geometries, attributes, info);
            morphtargets = new $9014d97cd777be10$var$WebGLMorphtargets(_gl, capabilities, textures);
            clipping = new $9014d97cd777be10$var$WebGLClipping(properties);
            programCache = new $9014d97cd777be10$var$WebGLPrograms(_this, cubemaps, cubeuvmaps, extensions, capabilities, bindingStates, clipping);
            materials = new $9014d97cd777be10$var$WebGLMaterials(_this, properties);
            renderLists = new $9014d97cd777be10$var$WebGLRenderLists();
            renderStates = new $9014d97cd777be10$var$WebGLRenderStates(extensions, capabilities);
            background = new $9014d97cd777be10$var$WebGLBackground(_this, cubemaps, cubeuvmaps, state, objects, _alpha, premultipliedAlpha);
            shadowMap = new $9014d97cd777be10$var$WebGLShadowMap(_this, objects, capabilities);
            uniformsGroups = new $9014d97cd777be10$var$WebGLUniformsGroups(_gl, info, capabilities, state);
            bufferRenderer = new $9014d97cd777be10$var$WebGLBufferRenderer(_gl, extensions, info, capabilities);
            indexedBufferRenderer = new $9014d97cd777be10$var$WebGLIndexedBufferRenderer(_gl, extensions, info, capabilities);
            info.programs = programCache.programs;
            _this.capabilities = capabilities;
            _this.extensions = extensions;
            _this.properties = properties;
            _this.renderLists = renderLists;
            _this.shadowMap = shadowMap;
            _this.state = state;
            _this.info = info;
        }
        initGLContext();
        // xr
        const xr = new $9014d97cd777be10$var$WebXRManager(_this, _gl);
        this.xr = xr;
        // API
        this.getContext = function() {
            return _gl;
        };
        this.getContextAttributes = function() {
            return _gl.getContextAttributes();
        };
        this.forceContextLoss = function() {
            const extension = extensions.get("WEBGL_lose_context");
            if (extension) extension.loseContext();
        };
        this.forceContextRestore = function() {
            const extension = extensions.get("WEBGL_lose_context");
            if (extension) extension.restoreContext();
        };
        this.getPixelRatio = function() {
            return _pixelRatio;
        };
        this.setPixelRatio = function(value) {
            if (value === undefined) return;
            _pixelRatio = value;
            this.setSize(_width, _height, false);
        };
        this.getSize = function(target) {
            return target.set(_width, _height);
        };
        this.setSize = function(width, height, updateStyle = true) {
            if (xr.isPresenting) {
                console.warn("THREE.WebGLRenderer: Can't change size while VR device is presenting.");
                return;
            }
            _width = width;
            _height = height;
            canvas.width = Math.floor(width * _pixelRatio);
            canvas.height = Math.floor(height * _pixelRatio);
            if (updateStyle === true) {
                canvas.style.width = width + "px";
                canvas.style.height = height + "px";
            }
            this.setViewport(0, 0, width, height);
        };
        this.getDrawingBufferSize = function(target) {
            return target.set(_width * _pixelRatio, _height * _pixelRatio).floor();
        };
        this.setDrawingBufferSize = function(width, height, pixelRatio) {
            _width = width;
            _height = height;
            _pixelRatio = pixelRatio;
            canvas.width = Math.floor(width * pixelRatio);
            canvas.height = Math.floor(height * pixelRatio);
            this.setViewport(0, 0, width, height);
        };
        this.getCurrentViewport = function(target) {
            return target.copy(_currentViewport);
        };
        this.getViewport = function(target) {
            return target.copy(_viewport);
        };
        this.setViewport = function(x, y, width, height) {
            if (x.isVector4) _viewport.set(x.x, x.y, x.z, x.w);
            else _viewport.set(x, y, width, height);
            state.viewport(_currentViewport.copy(_viewport).multiplyScalar(_pixelRatio).floor());
        };
        this.getScissor = function(target) {
            return target.copy(_scissor);
        };
        this.setScissor = function(x, y, width, height) {
            if (x.isVector4) _scissor.set(x.x, x.y, x.z, x.w);
            else _scissor.set(x, y, width, height);
            state.scissor(_currentScissor.copy(_scissor).multiplyScalar(_pixelRatio).floor());
        };
        this.getScissorTest = function() {
            return _scissorTest;
        };
        this.setScissorTest = function(boolean) {
            state.setScissorTest(_scissorTest = boolean);
        };
        this.setOpaqueSort = function(method) {
            _opaqueSort = method;
        };
        this.setTransparentSort = function(method) {
            _transparentSort = method;
        };
        // Clearing
        this.getClearColor = function(target) {
            return target.copy(background.getClearColor());
        };
        this.setClearColor = function() {
            background.setClearColor.apply(background, arguments);
        };
        this.getClearAlpha = function() {
            return background.getClearAlpha();
        };
        this.setClearAlpha = function() {
            background.setClearAlpha.apply(background, arguments);
        };
        this.clear = function(color = true, depth = true, stencil = true) {
            let bits = 0;
            if (color) {
                // check if we're trying to clear an integer target
                let isIntegerFormat = false;
                if (_currentRenderTarget !== null) {
                    const targetFormat = _currentRenderTarget.texture.format;
                    isIntegerFormat = targetFormat === $9014d97cd777be10$export$c200e7d26f592f21 || targetFormat === $9014d97cd777be10$export$1ba1c45f9f77d4d7 || targetFormat === $9014d97cd777be10$export$aa92e870a709d190;
                }
                // use the appropriate clear functions to clear the target if it's a signed
                // or unsigned integer target
                if (isIntegerFormat) {
                    const targetType = _currentRenderTarget.texture.type;
                    const isUnsignedType = targetType === $9014d97cd777be10$export$2e8ce08d3f6f5e10 || targetType === $9014d97cd777be10$export$c3c7fc4518ebba96 || targetType === $9014d97cd777be10$export$c63dc51868b06a9d || targetType === $9014d97cd777be10$export$6c8ea339bfab1301 || targetType === $9014d97cd777be10$export$b3969b01faf587f2 || targetType === $9014d97cd777be10$export$18886f8ae33e90de;
                    const clearColor = background.getClearColor();
                    const a = background.getClearAlpha();
                    const r = clearColor.r;
                    const g = clearColor.g;
                    const b = clearColor.b;
                    if (isUnsignedType) {
                        uintClearColor[0] = r;
                        uintClearColor[1] = g;
                        uintClearColor[2] = b;
                        uintClearColor[3] = a;
                        _gl.clearBufferuiv(_gl.COLOR, 0, uintClearColor);
                    } else {
                        intClearColor[0] = r;
                        intClearColor[1] = g;
                        intClearColor[2] = b;
                        intClearColor[3] = a;
                        _gl.clearBufferiv(_gl.COLOR, 0, intClearColor);
                    }
                } else bits |= _gl.COLOR_BUFFER_BIT;
            }
            if (depth) bits |= _gl.DEPTH_BUFFER_BIT;
            if (stencil) bits |= _gl.STENCIL_BUFFER_BIT;
            _gl.clear(bits);
        };
        this.clearColor = function() {
            this.clear(true, false, false);
        };
        this.clearDepth = function() {
            this.clear(false, true, false);
        };
        this.clearStencil = function() {
            this.clear(false, false, true);
        };
        //
        this.dispose = function() {
            canvas.removeEventListener("webglcontextlost", onContextLost, false);
            canvas.removeEventListener("webglcontextrestored", onContextRestore, false);
            canvas.removeEventListener("webglcontextcreationerror", onContextCreationError, false);
            renderLists.dispose();
            renderStates.dispose();
            properties.dispose();
            cubemaps.dispose();
            cubeuvmaps.dispose();
            objects.dispose();
            bindingStates.dispose();
            uniformsGroups.dispose();
            programCache.dispose();
            xr.dispose();
            xr.removeEventListener("sessionstart", onXRSessionStart);
            xr.removeEventListener("sessionend", onXRSessionEnd);
            if (_transmissionRenderTarget) {
                _transmissionRenderTarget.dispose();
                _transmissionRenderTarget = null;
            }
            animation.stop();
        };
        // Events
        function onContextLost(event) {
            event.preventDefault();
            console.log("THREE.WebGLRenderer: Context Lost.");
            _isContextLost = true;
        }
        function onContextRestore() {
            console.log("THREE.WebGLRenderer: Context Restored.");
            _isContextLost = false;
            const infoAutoReset = info.autoReset;
            const shadowMapEnabled = shadowMap.enabled;
            const shadowMapAutoUpdate = shadowMap.autoUpdate;
            const shadowMapNeedsUpdate = shadowMap.needsUpdate;
            const shadowMapType = shadowMap.type;
            initGLContext();
            info.autoReset = infoAutoReset;
            shadowMap.enabled = shadowMapEnabled;
            shadowMap.autoUpdate = shadowMapAutoUpdate;
            shadowMap.needsUpdate = shadowMapNeedsUpdate;
            shadowMap.type = shadowMapType;
        }
        function onContextCreationError(event) {
            console.error("THREE.WebGLRenderer: A WebGL context could not be created. Reason: ", event.statusMessage);
        }
        function onMaterialDispose(event) {
            const material = event.target;
            material.removeEventListener("dispose", onMaterialDispose);
            deallocateMaterial(material);
        }
        // Buffer deallocation
        function deallocateMaterial(material) {
            releaseMaterialProgramReferences(material);
            properties.remove(material);
        }
        function releaseMaterialProgramReferences(material) {
            const programs = properties.get(material).programs;
            if (programs !== undefined) {
                programs.forEach(function(program) {
                    programCache.releaseProgram(program);
                });
                if (material.isShaderMaterial) programCache.releaseShaderCache(material);
            }
        }
        // Buffer rendering
        this.renderBufferDirect = function(camera, scene, geometry, material, object, group) {
            if (scene === null) scene = _emptyScene; // renderBufferDirect second parameter used to be fog (could be null)
            const frontFaceCW = object.isMesh && object.matrixWorld.determinant() < 0;
            const program = setProgram(camera, scene, geometry, material, object);
            state.setMaterial(material, frontFaceCW);
            //
            let index = geometry.index;
            let rangeFactor = 1;
            if (material.wireframe === true) {
                index = geometries.getWireframeAttribute(geometry);
                if (index === undefined) return;
                rangeFactor = 2;
            }
            //
            const drawRange = geometry.drawRange;
            const position = geometry.attributes.position;
            let drawStart = drawRange.start * rangeFactor;
            let drawEnd = (drawRange.start + drawRange.count) * rangeFactor;
            if (group !== null) {
                drawStart = Math.max(drawStart, group.start * rangeFactor);
                drawEnd = Math.min(drawEnd, (group.start + group.count) * rangeFactor);
            }
            if (index !== null) {
                drawStart = Math.max(drawStart, 0);
                drawEnd = Math.min(drawEnd, index.count);
            } else if (position !== undefined && position !== null) {
                drawStart = Math.max(drawStart, 0);
                drawEnd = Math.min(drawEnd, position.count);
            }
            const drawCount = drawEnd - drawStart;
            if (drawCount < 0 || drawCount === Infinity) return;
            //
            bindingStates.setup(object, material, program, geometry, index);
            let attribute;
            let renderer = bufferRenderer;
            if (index !== null) {
                attribute = attributes.get(index);
                renderer = indexedBufferRenderer;
                renderer.setIndex(attribute);
            }
            //
            if (object.isMesh) {
                if (material.wireframe === true) {
                    state.setLineWidth(material.wireframeLinewidth * getTargetPixelRatio());
                    renderer.setMode(_gl.LINES);
                } else renderer.setMode(_gl.TRIANGLES);
            } else if (object.isLine) {
                let lineWidth = material.linewidth;
                if (lineWidth === undefined) lineWidth = 1; // Not using Line*Material
                state.setLineWidth(lineWidth * getTargetPixelRatio());
                if (object.isLineSegments) renderer.setMode(_gl.LINES);
                else if (object.isLineLoop) renderer.setMode(_gl.LINE_LOOP);
                else renderer.setMode(_gl.LINE_STRIP);
            } else if (object.isPoints) renderer.setMode(_gl.POINTS);
            else if (object.isSprite) renderer.setMode(_gl.TRIANGLES);
            if (object.isInstancedMesh) renderer.renderInstances(drawStart, drawCount, object.count);
            else if (geometry.isInstancedBufferGeometry) {
                const maxInstanceCount = geometry._maxInstanceCount !== undefined ? geometry._maxInstanceCount : Infinity;
                const instanceCount = Math.min(geometry.instanceCount, maxInstanceCount);
                renderer.renderInstances(drawStart, drawCount, instanceCount);
            } else renderer.render(drawStart, drawCount);
        };
        // Compile
        this.compile = function(scene, camera) {
            function prepare(material, scene, object) {
                if (material.transparent === true && material.side === $9014d97cd777be10$export$3b296b6f144d5b03 && material.forceSinglePass === false) {
                    material.side = $9014d97cd777be10$export$d9f0486e75b5ace;
                    material.needsUpdate = true;
                    getProgram(material, scene, object);
                    material.side = $9014d97cd777be10$export$2ede184fc2998901;
                    material.needsUpdate = true;
                    getProgram(material, scene, object);
                    material.side = $9014d97cd777be10$export$3b296b6f144d5b03;
                } else getProgram(material, scene, object);
            }
            currentRenderState = renderStates.get(scene);
            currentRenderState.init();
            renderStateStack.push(currentRenderState);
            scene.traverseVisible(function(object) {
                if (object.isLight && object.layers.test(camera.layers)) {
                    currentRenderState.pushLight(object);
                    if (object.castShadow) currentRenderState.pushShadow(object);
                }
            });
            currentRenderState.setupLights(_this._useLegacyLights);
            scene.traverse(function(object) {
                const material = object.material;
                if (material) {
                    if (Array.isArray(material)) for(let i = 0; i < material.length; i++){
                        const material2 = material[i];
                        prepare(material2, scene, object);
                    }
                    else prepare(material, scene, object);
                }
            });
            renderStateStack.pop();
            currentRenderState = null;
        };
        // Animation Loop
        let onAnimationFrameCallback = null;
        function onAnimationFrame(time) {
            if (onAnimationFrameCallback) onAnimationFrameCallback(time);
        }
        function onXRSessionStart() {
            animation.stop();
        }
        function onXRSessionEnd() {
            animation.start();
        }
        const animation = new $9014d97cd777be10$var$WebGLAnimation();
        animation.setAnimationLoop(onAnimationFrame);
        if (typeof self !== "undefined") animation.setContext(self);
        this.setAnimationLoop = function(callback) {
            onAnimationFrameCallback = callback;
            xr.setAnimationLoop(callback);
            callback === null ? animation.stop() : animation.start();
        };
        xr.addEventListener("sessionstart", onXRSessionStart);
        xr.addEventListener("sessionend", onXRSessionEnd);
        // Rendering
        this.render = function(scene, camera) {
            if (camera !== undefined && camera.isCamera !== true) {
                console.error("THREE.WebGLRenderer.render: camera is not an instance of THREE.Camera.");
                return;
            }
            if (_isContextLost === true) return;
            // update scene graph
            if (scene.matrixWorldAutoUpdate === true) scene.updateMatrixWorld();
            // update camera matrices and frustum
            if (camera.parent === null && camera.matrixWorldAutoUpdate === true) camera.updateMatrixWorld();
            if (xr.enabled === true && xr.isPresenting === true) {
                if (xr.cameraAutoUpdate === true) xr.updateCamera(camera);
                camera = xr.getCamera(); // use XR camera for rendering
            }
            //
            if (scene.isScene === true) scene.onBeforeRender(_this, scene, camera, _currentRenderTarget);
            currentRenderState = renderStates.get(scene, renderStateStack.length);
            currentRenderState.init();
            renderStateStack.push(currentRenderState);
            _projScreenMatrix.multiplyMatrices(camera.projectionMatrix, camera.matrixWorldInverse);
            _frustum.setFromProjectionMatrix(_projScreenMatrix);
            _localClippingEnabled = this.localClippingEnabled;
            _clippingEnabled = clipping.init(this.clippingPlanes, _localClippingEnabled);
            currentRenderList = renderLists.get(scene, renderListStack.length);
            currentRenderList.init();
            renderListStack.push(currentRenderList);
            projectObject(scene, camera, 0, _this.sortObjects);
            currentRenderList.finish();
            if (_this.sortObjects === true) currentRenderList.sort(_opaqueSort, _transparentSort);
            //
            this.info.render.frame++;
            if (_clippingEnabled === true) clipping.beginShadows();
            const shadowsArray = currentRenderState.state.shadowsArray;
            shadowMap.render(shadowsArray, scene, camera);
            if (_clippingEnabled === true) clipping.endShadows();
            //
            if (this.info.autoReset === true) this.info.reset();
            //
            background.render(currentRenderList, scene);
            // render scene
            currentRenderState.setupLights(_this._useLegacyLights);
            if (camera.isArrayCamera) {
                const cameras = camera.cameras;
                for(let i = 0, l = cameras.length; i < l; i++){
                    const camera2 = cameras[i];
                    renderScene(currentRenderList, scene, camera2, camera2.viewport);
                }
            } else renderScene(currentRenderList, scene, camera);
            //
            if (_currentRenderTarget !== null) {
                // resolve multisample renderbuffers to a single-sample texture if necessary
                textures.updateMultisampleRenderTarget(_currentRenderTarget);
                // Generate mipmap if we're using any kind of mipmap filtering
                textures.updateRenderTargetMipmap(_currentRenderTarget);
            }
            //
            if (scene.isScene === true) scene.onAfterRender(_this, scene, camera);
            // _gl.finish();
            bindingStates.resetDefaultState();
            _currentMaterialId = -1;
            _currentCamera = null;
            renderStateStack.pop();
            if (renderStateStack.length > 0) currentRenderState = renderStateStack[renderStateStack.length - 1];
            else currentRenderState = null;
            renderListStack.pop();
            if (renderListStack.length > 0) currentRenderList = renderListStack[renderListStack.length - 1];
            else currentRenderList = null;
        };
        function projectObject(object, camera, groupOrder, sortObjects) {
            if (object.visible === false) return;
            const visible = object.layers.test(camera.layers);
            if (visible) {
                if (object.isGroup) groupOrder = object.renderOrder;
                else if (object.isLOD) {
                    if (object.autoUpdate === true) object.update(camera);
                } else if (object.isLight) {
                    currentRenderState.pushLight(object);
                    if (object.castShadow) currentRenderState.pushShadow(object);
                } else if (object.isSprite) {
                    if (!object.frustumCulled || _frustum.intersectsSprite(object)) {
                        if (sortObjects) _vector3.setFromMatrixPosition(object.matrixWorld).applyMatrix4(_projScreenMatrix);
                        const geometry = objects.update(object);
                        const material = object.material;
                        if (material.visible) currentRenderList.push(object, geometry, material, groupOrder, _vector3.z, null);
                    }
                } else if (object.isMesh || object.isLine || object.isPoints) {
                    if (!object.frustumCulled || _frustum.intersectsObject(object)) {
                        const geometry = objects.update(object);
                        const material = object.material;
                        if (sortObjects) {
                            if (object.boundingSphere !== undefined) {
                                if (object.boundingSphere === null) object.computeBoundingSphere();
                                _vector3.copy(object.boundingSphere.center);
                            } else {
                                if (geometry.boundingSphere === null) geometry.computeBoundingSphere();
                                _vector3.copy(geometry.boundingSphere.center);
                            }
                            _vector3.applyMatrix4(object.matrixWorld).applyMatrix4(_projScreenMatrix);
                        }
                        if (Array.isArray(material)) {
                            const groups = geometry.groups;
                            for(let i = 0, l = groups.length; i < l; i++){
                                const group = groups[i];
                                const groupMaterial = material[group.materialIndex];
                                if (groupMaterial && groupMaterial.visible) currentRenderList.push(object, geometry, groupMaterial, groupOrder, _vector3.z, group);
                            }
                        } else if (material.visible) currentRenderList.push(object, geometry, material, groupOrder, _vector3.z, null);
                    }
                }
            }
            const children = object.children;
            for(let i = 0, l = children.length; i < l; i++)projectObject(children[i], camera, groupOrder, sortObjects);
        }
        function renderScene(currentRenderList, scene, camera, viewport) {
            const opaqueObjects = currentRenderList.opaque;
            const transmissiveObjects = currentRenderList.transmissive;
            const transparentObjects = currentRenderList.transparent;
            currentRenderState.setupLightsView(camera);
            if (_clippingEnabled === true) clipping.setGlobalState(_this.clippingPlanes, camera);
            if (transmissiveObjects.length > 0) renderTransmissionPass(opaqueObjects, transmissiveObjects, scene, camera);
            if (viewport) state.viewport(_currentViewport.copy(viewport));
            if (opaqueObjects.length > 0) renderObjects(opaqueObjects, scene, camera);
            if (transmissiveObjects.length > 0) renderObjects(transmissiveObjects, scene, camera);
            if (transparentObjects.length > 0) renderObjects(transparentObjects, scene, camera);
            // Ensure depth buffer writing is enabled so it can be cleared on next render
            state.buffers.depth.setTest(true);
            state.buffers.depth.setMask(true);
            state.buffers.color.setMask(true);
            state.setPolygonOffset(false);
        }
        function renderTransmissionPass(opaqueObjects, transmissiveObjects, scene, camera) {
            const isWebGL2 = capabilities.isWebGL2;
            if (_transmissionRenderTarget === null) _transmissionRenderTarget = new $9014d97cd777be10$export$3c052beb2e51e23f(1, 1, {
                generateMipmaps: true,
                type: extensions.has("EXT_color_buffer_half_float") ? $9014d97cd777be10$export$2697304443f382bc : $9014d97cd777be10$export$2e8ce08d3f6f5e10,
                minFilter: $9014d97cd777be10$export$5d8599b6a933fb1b,
                samples: isWebGL2 ? 4 : 0
            });
            _this.getDrawingBufferSize(_vector2);
            if (isWebGL2) _transmissionRenderTarget.setSize(_vector2.x, _vector2.y);
            else _transmissionRenderTarget.setSize($9014d97cd777be10$var$floorPowerOfTwo(_vector2.x), $9014d97cd777be10$var$floorPowerOfTwo(_vector2.y));
            //
            const currentRenderTarget = _this.getRenderTarget();
            _this.setRenderTarget(_transmissionRenderTarget);
            _this.getClearColor(_currentClearColor);
            _currentClearAlpha = _this.getClearAlpha();
            if (_currentClearAlpha < 1) _this.setClearColor(0xffffff, 0.5);
            _this.clear();
            // Turn off the features which can affect the frag color for opaque objects pass.
            // Otherwise they are applied twice in opaque objects pass and transmission objects pass.
            const currentToneMapping = _this.toneMapping;
            _this.toneMapping = $9014d97cd777be10$export$9fcb6b4294603b2;
            renderObjects(opaqueObjects, scene, camera);
            textures.updateMultisampleRenderTarget(_transmissionRenderTarget);
            textures.updateRenderTargetMipmap(_transmissionRenderTarget);
            let renderTargetNeedsUpdate = false;
            for(let i = 0, l = transmissiveObjects.length; i < l; i++){
                const renderItem = transmissiveObjects[i];
                const object = renderItem.object;
                const geometry = renderItem.geometry;
                const material = renderItem.material;
                const group = renderItem.group;
                if (material.side === $9014d97cd777be10$export$3b296b6f144d5b03 && object.layers.test(camera.layers)) {
                    const currentSide = material.side;
                    material.side = $9014d97cd777be10$export$d9f0486e75b5ace;
                    material.needsUpdate = true;
                    renderObject(object, scene, camera, geometry, material, group);
                    material.side = currentSide;
                    material.needsUpdate = true;
                    renderTargetNeedsUpdate = true;
                }
            }
            if (renderTargetNeedsUpdate === true) {
                textures.updateMultisampleRenderTarget(_transmissionRenderTarget);
                textures.updateRenderTargetMipmap(_transmissionRenderTarget);
            }
            _this.setRenderTarget(currentRenderTarget);
            _this.setClearColor(_currentClearColor, _currentClearAlpha);
            _this.toneMapping = currentToneMapping;
        }
        function renderObjects(renderList, scene, camera) {
            const overrideMaterial = scene.isScene === true ? scene.overrideMaterial : null;
            for(let i = 0, l = renderList.length; i < l; i++){
                const renderItem = renderList[i];
                const object = renderItem.object;
                const geometry = renderItem.geometry;
                const material = overrideMaterial === null ? renderItem.material : overrideMaterial;
                const group = renderItem.group;
                if (object.layers.test(camera.layers)) renderObject(object, scene, camera, geometry, material, group);
            }
        }
        function renderObject(object, scene, camera, geometry, material, group) {
            object.onBeforeRender(_this, scene, camera, geometry, material, group);
            object.modelViewMatrix.multiplyMatrices(camera.matrixWorldInverse, object.matrixWorld);
            object.normalMatrix.getNormalMatrix(object.modelViewMatrix);
            material.onBeforeRender(_this, scene, camera, geometry, object, group);
            if (material.transparent === true && material.side === $9014d97cd777be10$export$3b296b6f144d5b03 && material.forceSinglePass === false) {
                material.side = $9014d97cd777be10$export$d9f0486e75b5ace;
                material.needsUpdate = true;
                _this.renderBufferDirect(camera, scene, geometry, material, object, group);
                material.side = $9014d97cd777be10$export$2ede184fc2998901;
                material.needsUpdate = true;
                _this.renderBufferDirect(camera, scene, geometry, material, object, group);
                material.side = $9014d97cd777be10$export$3b296b6f144d5b03;
            } else _this.renderBufferDirect(camera, scene, geometry, material, object, group);
            object.onAfterRender(_this, scene, camera, geometry, material, group);
        }
        function getProgram(material, scene, object) {
            if (scene.isScene !== true) scene = _emptyScene; // scene could be a Mesh, Line, Points, ...
            const materialProperties = properties.get(material);
            const lights = currentRenderState.state.lights;
            const shadowsArray = currentRenderState.state.shadowsArray;
            const lightsStateVersion = lights.state.version;
            const parameters = programCache.getParameters(material, lights.state, shadowsArray, scene, object);
            const programCacheKey = programCache.getProgramCacheKey(parameters);
            let programs = materialProperties.programs;
            // always update environment and fog - changing these trigger an getProgram call, but it's possible that the program doesn't change
            materialProperties.environment = material.isMeshStandardMaterial ? scene.environment : null;
            materialProperties.fog = scene.fog;
            materialProperties.envMap = (material.isMeshStandardMaterial ? cubeuvmaps : cubemaps).get(material.envMap || materialProperties.environment);
            if (programs === undefined) {
                // new material
                material.addEventListener("dispose", onMaterialDispose);
                programs = new Map();
                materialProperties.programs = programs;
            }
            let program = programs.get(programCacheKey);
            if (program !== undefined) // early out if program and light state is identical
            {
                if (materialProperties.currentProgram === program && materialProperties.lightsStateVersion === lightsStateVersion) {
                    updateCommonMaterialProperties(material, parameters);
                    return program;
                }
            } else {
                parameters.uniforms = programCache.getUniforms(material);
                material.onBuild(object, parameters, _this);
                material.onBeforeCompile(parameters, _this);
                program = programCache.acquireProgram(parameters, programCacheKey);
                programs.set(programCacheKey, program);
                materialProperties.uniforms = parameters.uniforms;
            }
            const uniforms = materialProperties.uniforms;
            if (!material.isShaderMaterial && !material.isRawShaderMaterial || material.clipping === true) uniforms.clippingPlanes = clipping.uniform;
            updateCommonMaterialProperties(material, parameters);
            // store the light setup it was created for
            materialProperties.needsLights = materialNeedsLights(material);
            materialProperties.lightsStateVersion = lightsStateVersion;
            if (materialProperties.needsLights) {
                // wire up the material to this renderer's lighting state
                uniforms.ambientLightColor.value = lights.state.ambient;
                uniforms.lightProbe.value = lights.state.probe;
                uniforms.directionalLights.value = lights.state.directional;
                uniforms.directionalLightShadows.value = lights.state.directionalShadow;
                uniforms.spotLights.value = lights.state.spot;
                uniforms.spotLightShadows.value = lights.state.spotShadow;
                uniforms.rectAreaLights.value = lights.state.rectArea;
                uniforms.ltc_1.value = lights.state.rectAreaLTC1;
                uniforms.ltc_2.value = lights.state.rectAreaLTC2;
                uniforms.pointLights.value = lights.state.point;
                uniforms.pointLightShadows.value = lights.state.pointShadow;
                uniforms.hemisphereLights.value = lights.state.hemi;
                uniforms.directionalShadowMap.value = lights.state.directionalShadowMap;
                uniforms.directionalShadowMatrix.value = lights.state.directionalShadowMatrix;
                uniforms.spotShadowMap.value = lights.state.spotShadowMap;
                uniforms.spotLightMatrix.value = lights.state.spotLightMatrix;
                uniforms.spotLightMap.value = lights.state.spotLightMap;
                uniforms.pointShadowMap.value = lights.state.pointShadowMap;
                uniforms.pointShadowMatrix.value = lights.state.pointShadowMatrix;
            // TODO (abelnation): add area lights shadow info to uniforms
            }
            const progUniforms = program.getUniforms();
            const uniformsList = $9014d97cd777be10$var$WebGLUniforms.seqWithValue(progUniforms.seq, uniforms);
            materialProperties.currentProgram = program;
            materialProperties.uniformsList = uniformsList;
            return program;
        }
        function updateCommonMaterialProperties(material, parameters) {
            const materialProperties = properties.get(material);
            materialProperties.outputColorSpace = parameters.outputColorSpace;
            materialProperties.instancing = parameters.instancing;
            materialProperties.instancingColor = parameters.instancingColor;
            materialProperties.skinning = parameters.skinning;
            materialProperties.morphTargets = parameters.morphTargets;
            materialProperties.morphNormals = parameters.morphNormals;
            materialProperties.morphColors = parameters.morphColors;
            materialProperties.morphTargetsCount = parameters.morphTargetsCount;
            materialProperties.numClippingPlanes = parameters.numClippingPlanes;
            materialProperties.numIntersection = parameters.numClipIntersection;
            materialProperties.vertexAlphas = parameters.vertexAlphas;
            materialProperties.vertexTangents = parameters.vertexTangents;
            materialProperties.toneMapping = parameters.toneMapping;
        }
        function setProgram(camera, scene, geometry, material, object) {
            if (scene.isScene !== true) scene = _emptyScene; // scene could be a Mesh, Line, Points, ...
            textures.resetTextureUnits();
            const fog = scene.fog;
            const environment = material.isMeshStandardMaterial ? scene.environment : null;
            const colorSpace1 = _currentRenderTarget === null ? _this.outputColorSpace : _currentRenderTarget.isXRRenderTarget === true ? _currentRenderTarget.texture.colorSpace : $9014d97cd777be10$export$42429b3acfb233a4;
            const envMap = (material.isMeshStandardMaterial ? cubeuvmaps : cubemaps).get(material.envMap || environment);
            const vertexAlphas = material.vertexColors === true && !!geometry.attributes.color && geometry.attributes.color.itemSize === 4;
            const vertexTangents = !!geometry.attributes.tangent && (!!material.normalMap || material.anisotropy > 0);
            const morphTargets = !!geometry.morphAttributes.position;
            const morphNormals = !!geometry.morphAttributes.normal;
            const morphColors = !!geometry.morphAttributes.color;
            let toneMapping = $9014d97cd777be10$export$9fcb6b4294603b2;
            if (material.toneMapped) {
                if (_currentRenderTarget === null || _currentRenderTarget.isXRRenderTarget === true) toneMapping = _this.toneMapping;
            }
            const morphAttribute = geometry.morphAttributes.position || geometry.morphAttributes.normal || geometry.morphAttributes.color;
            const morphTargetsCount = morphAttribute !== undefined ? morphAttribute.length : 0;
            const materialProperties = properties.get(material);
            const lights = currentRenderState.state.lights;
            if (_clippingEnabled === true) {
                if (_localClippingEnabled === true || camera !== _currentCamera) {
                    const useCache = camera === _currentCamera && material.id === _currentMaterialId;
                    // we might want to call this function with some ClippingGroup
                    // object instead of the material, once it becomes feasible
                    // (#8465, #8379)
                    clipping.setState(material, camera, useCache);
                }
            }
            //
            let needsProgramChange = false;
            if (material.version === materialProperties.__version) {
                if (materialProperties.needsLights && materialProperties.lightsStateVersion !== lights.state.version) needsProgramChange = true;
                else if (materialProperties.outputColorSpace !== colorSpace1) needsProgramChange = true;
                else if (object.isInstancedMesh && materialProperties.instancing === false) needsProgramChange = true;
                else if (!object.isInstancedMesh && materialProperties.instancing === true) needsProgramChange = true;
                else if (object.isSkinnedMesh && materialProperties.skinning === false) needsProgramChange = true;
                else if (!object.isSkinnedMesh && materialProperties.skinning === true) needsProgramChange = true;
                else if (object.isInstancedMesh && materialProperties.instancingColor === true && object.instanceColor === null) needsProgramChange = true;
                else if (object.isInstancedMesh && materialProperties.instancingColor === false && object.instanceColor !== null) needsProgramChange = true;
                else if (materialProperties.envMap !== envMap) needsProgramChange = true;
                else if (material.fog === true && materialProperties.fog !== fog) needsProgramChange = true;
                else if (materialProperties.numClippingPlanes !== undefined && (materialProperties.numClippingPlanes !== clipping.numPlanes || materialProperties.numIntersection !== clipping.numIntersection)) needsProgramChange = true;
                else if (materialProperties.vertexAlphas !== vertexAlphas) needsProgramChange = true;
                else if (materialProperties.vertexTangents !== vertexTangents) needsProgramChange = true;
                else if (materialProperties.morphTargets !== morphTargets) needsProgramChange = true;
                else if (materialProperties.morphNormals !== morphNormals) needsProgramChange = true;
                else if (materialProperties.morphColors !== morphColors) needsProgramChange = true;
                else if (materialProperties.toneMapping !== toneMapping) needsProgramChange = true;
                else if (capabilities.isWebGL2 === true && materialProperties.morphTargetsCount !== morphTargetsCount) needsProgramChange = true;
            } else {
                needsProgramChange = true;
                materialProperties.__version = material.version;
            }
            //
            let program = materialProperties.currentProgram;
            if (needsProgramChange === true) program = getProgram(material, scene, object);
            let refreshProgram = false;
            let refreshMaterial = false;
            let refreshLights = false;
            const p_uniforms = program.getUniforms(), m_uniforms = materialProperties.uniforms;
            if (state.useProgram(program.program)) {
                refreshProgram = true;
                refreshMaterial = true;
                refreshLights = true;
            }
            if (material.id !== _currentMaterialId) {
                _currentMaterialId = material.id;
                refreshMaterial = true;
            }
            if (refreshProgram || _currentCamera !== camera) {
                p_uniforms.setValue(_gl, "projectionMatrix", camera.projectionMatrix);
                if (capabilities.logarithmicDepthBuffer) p_uniforms.setValue(_gl, "logDepthBufFC", 2.0 / (Math.log(camera.far + 1.0) / Math.LN2));
                if (_currentCamera !== camera) {
                    _currentCamera = camera;
                    // lighting uniforms depend on the camera so enforce an update
                    // now, in case this material supports lights - or later, when
                    // the next material that does gets activated:
                    refreshMaterial = true; // set to true on material change
                    refreshLights = true; // remains set until update done
                }
                // load material specific uniforms
                // (shader material also gets them for the sake of genericity)
                if (material.isShaderMaterial || material.isMeshPhongMaterial || material.isMeshToonMaterial || material.isMeshStandardMaterial || material.envMap) {
                    const uCamPos = p_uniforms.map.cameraPosition;
                    if (uCamPos !== undefined) uCamPos.setValue(_gl, _vector3.setFromMatrixPosition(camera.matrixWorld));
                }
                if (material.isMeshPhongMaterial || material.isMeshToonMaterial || material.isMeshLambertMaterial || material.isMeshBasicMaterial || material.isMeshStandardMaterial || material.isShaderMaterial) p_uniforms.setValue(_gl, "isOrthographic", camera.isOrthographicCamera === true);
                if (material.isMeshPhongMaterial || material.isMeshToonMaterial || material.isMeshLambertMaterial || material.isMeshBasicMaterial || material.isMeshStandardMaterial || material.isShaderMaterial || material.isShadowMaterial || object.isSkinnedMesh) p_uniforms.setValue(_gl, "viewMatrix", camera.matrixWorldInverse);
            }
            // skinning and morph target uniforms must be set even if material didn't change
            // auto-setting of texture unit for bone and morph texture must go before other textures
            // otherwise textures used for skinning and morphing can take over texture units reserved for other material textures
            if (object.isSkinnedMesh) {
                p_uniforms.setOptional(_gl, object, "bindMatrix");
                p_uniforms.setOptional(_gl, object, "bindMatrixInverse");
                const skeleton = object.skeleton;
                if (skeleton) {
                    if (capabilities.floatVertexTextures) {
                        if (skeleton.boneTexture === null) skeleton.computeBoneTexture();
                        p_uniforms.setValue(_gl, "boneTexture", skeleton.boneTexture, textures);
                        p_uniforms.setValue(_gl, "boneTextureSize", skeleton.boneTextureSize);
                    } else console.warn("THREE.WebGLRenderer: SkinnedMesh can only be used with WebGL 2. With WebGL 1 OES_texture_float and vertex textures support is required.");
                }
            }
            const morphAttributes = geometry.morphAttributes;
            if (morphAttributes.position !== undefined || morphAttributes.normal !== undefined || morphAttributes.color !== undefined && capabilities.isWebGL2 === true) morphtargets.update(object, geometry, program);
            if (refreshMaterial || materialProperties.receiveShadow !== object.receiveShadow) {
                materialProperties.receiveShadow = object.receiveShadow;
                p_uniforms.setValue(_gl, "receiveShadow", object.receiveShadow);
            }
            // https://github.com/mrdoob/three.js/pull/24467#issuecomment-1209031512
            if (material.isMeshGouraudMaterial && material.envMap !== null) {
                m_uniforms.envMap.value = envMap;
                m_uniforms.flipEnvMap.value = envMap.isCubeTexture && envMap.isRenderTargetTexture === false ? -1 : 1;
            }
            if (refreshMaterial) {
                p_uniforms.setValue(_gl, "toneMappingExposure", _this.toneMappingExposure);
                if (materialProperties.needsLights) // the current material requires lighting info
                // note: all lighting uniforms are always set correctly
                // they simply reference the renderer's state for their
                // values
                //
                // use the current material's .needsUpdate flags to set
                // the GL state when required
                markUniformsLightsNeedsUpdate(m_uniforms, refreshLights);
                // refresh uniforms common to several materials
                if (fog && material.fog === true) materials.refreshFogUniforms(m_uniforms, fog);
                materials.refreshMaterialUniforms(m_uniforms, material, _pixelRatio, _height, _transmissionRenderTarget);
                $9014d97cd777be10$var$WebGLUniforms.upload(_gl, materialProperties.uniformsList, m_uniforms, textures);
            }
            if (material.isShaderMaterial && material.uniformsNeedUpdate === true) {
                $9014d97cd777be10$var$WebGLUniforms.upload(_gl, materialProperties.uniformsList, m_uniforms, textures);
                material.uniformsNeedUpdate = false;
            }
            if (material.isSpriteMaterial) p_uniforms.setValue(_gl, "center", object.center);
            // common matrices
            p_uniforms.setValue(_gl, "modelViewMatrix", object.modelViewMatrix);
            p_uniforms.setValue(_gl, "normalMatrix", object.normalMatrix);
            p_uniforms.setValue(_gl, "modelMatrix", object.matrixWorld);
            // UBOs
            if (material.isShaderMaterial || material.isRawShaderMaterial) {
                const groups = material.uniformsGroups;
                for(let i = 0, l = groups.length; i < l; i++)if (capabilities.isWebGL2) {
                    const group = groups[i];
                    uniformsGroups.update(group, program);
                    uniformsGroups.bind(group, program);
                } else console.warn("THREE.WebGLRenderer: Uniform Buffer Objects can only be used with WebGL 2.");
            }
            return program;
        }
        // If uniforms are marked as clean, they don't need to be loaded to the GPU.
        function markUniformsLightsNeedsUpdate(uniforms, value) {
            uniforms.ambientLightColor.needsUpdate = value;
            uniforms.lightProbe.needsUpdate = value;
            uniforms.directionalLights.needsUpdate = value;
            uniforms.directionalLightShadows.needsUpdate = value;
            uniforms.pointLights.needsUpdate = value;
            uniforms.pointLightShadows.needsUpdate = value;
            uniforms.spotLights.needsUpdate = value;
            uniforms.spotLightShadows.needsUpdate = value;
            uniforms.rectAreaLights.needsUpdate = value;
            uniforms.hemisphereLights.needsUpdate = value;
        }
        function materialNeedsLights(material) {
            return material.isMeshLambertMaterial || material.isMeshToonMaterial || material.isMeshPhongMaterial || material.isMeshStandardMaterial || material.isShadowMaterial || material.isShaderMaterial && material.lights === true;
        }
        this.getActiveCubeFace = function() {
            return _currentActiveCubeFace;
        };
        this.getActiveMipmapLevel = function() {
            return _currentActiveMipmapLevel;
        };
        this.getRenderTarget = function() {
            return _currentRenderTarget;
        };
        this.setRenderTargetTextures = function(renderTarget, colorTexture, depthTexture) {
            properties.get(renderTarget.texture).__webglTexture = colorTexture;
            properties.get(renderTarget.depthTexture).__webglTexture = depthTexture;
            const renderTargetProperties = properties.get(renderTarget);
            renderTargetProperties.__hasExternalTextures = true;
            if (renderTargetProperties.__hasExternalTextures) {
                renderTargetProperties.__autoAllocateDepthBuffer = depthTexture === undefined;
                if (!renderTargetProperties.__autoAllocateDepthBuffer) // The multisample_render_to_texture extension doesn't work properly if there
                // are midframe flushes and an external depth buffer. Disable use of the extension.
                {
                    if (extensions.has("WEBGL_multisampled_render_to_texture") === true) {
                        console.warn("THREE.WebGLRenderer: Render-to-texture extension was disabled because an external texture was provided");
                        renderTargetProperties.__useRenderToTexture = false;
                    }
                }
            }
        };
        this.setRenderTargetFramebuffer = function(renderTarget, defaultFramebuffer) {
            const renderTargetProperties = properties.get(renderTarget);
            renderTargetProperties.__webglFramebuffer = defaultFramebuffer;
            renderTargetProperties.__useDefaultFramebuffer = defaultFramebuffer === undefined;
        };
        this.setRenderTarget = function(renderTarget, activeCubeFace = 0, activeMipmapLevel = 0) {
            _currentRenderTarget = renderTarget;
            _currentActiveCubeFace = activeCubeFace;
            _currentActiveMipmapLevel = activeMipmapLevel;
            let useDefaultFramebuffer = true;
            let framebuffer = null;
            let isCube = false;
            let isRenderTarget3D = false;
            if (renderTarget) {
                const renderTargetProperties = properties.get(renderTarget);
                if (renderTargetProperties.__useDefaultFramebuffer !== undefined) {
                    // We need to make sure to rebind the framebuffer.
                    state.bindFramebuffer(_gl.FRAMEBUFFER, null);
                    useDefaultFramebuffer = false;
                } else if (renderTargetProperties.__webglFramebuffer === undefined) textures.setupRenderTarget(renderTarget);
                else if (renderTargetProperties.__hasExternalTextures) // Color and depth texture must be rebound in order for the swapchain to update.
                textures.rebindTextures(renderTarget, properties.get(renderTarget.texture).__webglTexture, properties.get(renderTarget.depthTexture).__webglTexture);
                const texture = renderTarget.texture;
                if (texture.isData3DTexture || texture.isDataArrayTexture || texture.isCompressedArrayTexture) isRenderTarget3D = true;
                const __webglFramebuffer = properties.get(renderTarget).__webglFramebuffer;
                if (renderTarget.isWebGLCubeRenderTarget) {
                    if (Array.isArray(__webglFramebuffer[activeCubeFace])) framebuffer = __webglFramebuffer[activeCubeFace][activeMipmapLevel];
                    else framebuffer = __webglFramebuffer[activeCubeFace];
                    isCube = true;
                } else if (capabilities.isWebGL2 && renderTarget.samples > 0 && textures.useMultisampledRTT(renderTarget) === false) framebuffer = properties.get(renderTarget).__webglMultisampledFramebuffer;
                else if (Array.isArray(__webglFramebuffer)) framebuffer = __webglFramebuffer[activeMipmapLevel];
                else framebuffer = __webglFramebuffer;
                _currentViewport.copy(renderTarget.viewport);
                _currentScissor.copy(renderTarget.scissor);
                _currentScissorTest = renderTarget.scissorTest;
            } else {
                _currentViewport.copy(_viewport).multiplyScalar(_pixelRatio).floor();
                _currentScissor.copy(_scissor).multiplyScalar(_pixelRatio).floor();
                _currentScissorTest = _scissorTest;
            }
            const framebufferBound = state.bindFramebuffer(_gl.FRAMEBUFFER, framebuffer);
            if (framebufferBound && capabilities.drawBuffers && useDefaultFramebuffer) state.drawBuffers(renderTarget, framebuffer);
            state.viewport(_currentViewport);
            state.scissor(_currentScissor);
            state.setScissorTest(_currentScissorTest);
            if (isCube) {
                const textureProperties = properties.get(renderTarget.texture);
                _gl.framebufferTexture2D(_gl.FRAMEBUFFER, _gl.COLOR_ATTACHMENT0, _gl.TEXTURE_CUBE_MAP_POSITIVE_X + activeCubeFace, textureProperties.__webglTexture, activeMipmapLevel);
            } else if (isRenderTarget3D) {
                const textureProperties = properties.get(renderTarget.texture);
                const layer = activeCubeFace || 0;
                _gl.framebufferTextureLayer(_gl.FRAMEBUFFER, _gl.COLOR_ATTACHMENT0, textureProperties.__webglTexture, activeMipmapLevel || 0, layer);
            }
            _currentMaterialId = -1; // reset current material to ensure correct uniform bindings
        };
        this.readRenderTargetPixels = function(renderTarget, x, y, width, height, buffer, activeCubeFaceIndex) {
            if (!(renderTarget && renderTarget.isWebGLRenderTarget)) {
                console.error("THREE.WebGLRenderer.readRenderTargetPixels: renderTarget is not THREE.WebGLRenderTarget.");
                return;
            }
            let framebuffer = properties.get(renderTarget).__webglFramebuffer;
            if (renderTarget.isWebGLCubeRenderTarget && activeCubeFaceIndex !== undefined) framebuffer = framebuffer[activeCubeFaceIndex];
            if (framebuffer) {
                state.bindFramebuffer(_gl.FRAMEBUFFER, framebuffer);
                try {
                    const texture = renderTarget.texture;
                    const textureFormat = texture.format;
                    const textureType = texture.type;
                    if (textureFormat !== $9014d97cd777be10$export$3f8bb04b555a363c && utils.convert(textureFormat) !== _gl.getParameter(_gl.IMPLEMENTATION_COLOR_READ_FORMAT)) {
                        console.error("THREE.WebGLRenderer.readRenderTargetPixels: renderTarget is not in RGBA or implementation defined format.");
                        return;
                    }
                    const halfFloatSupportedByExt = textureType === $9014d97cd777be10$export$2697304443f382bc && (extensions.has("EXT_color_buffer_half_float") || capabilities.isWebGL2 && extensions.has("EXT_color_buffer_float"));
                    if (textureType !== $9014d97cd777be10$export$2e8ce08d3f6f5e10 && utils.convert(textureType) !== _gl.getParameter(_gl.IMPLEMENTATION_COLOR_READ_TYPE) && // Edge and Chrome Mac < 52 (#9513)
                    !(textureType === $9014d97cd777be10$export$f6d331659b644596 && (capabilities.isWebGL2 || extensions.has("OES_texture_float") || extensions.has("WEBGL_color_buffer_float"))) && // Chrome Mac >= 52 and Firefox
                    !halfFloatSupportedByExt) {
                        console.error("THREE.WebGLRenderer.readRenderTargetPixels: renderTarget is not in UnsignedByteType or implementation defined type.");
                        return;
                    }
                    // the following if statement ensures valid read requests (no out-of-bounds pixels, see #8604)
                    if (x >= 0 && x <= renderTarget.width - width && y >= 0 && y <= renderTarget.height - height) _gl.readPixels(x, y, width, height, utils.convert(textureFormat), utils.convert(textureType), buffer);
                } finally{
                    // restore framebuffer of current render target if necessary
                    const framebuffer = _currentRenderTarget !== null ? properties.get(_currentRenderTarget).__webglFramebuffer : null;
                    state.bindFramebuffer(_gl.FRAMEBUFFER, framebuffer);
                }
            }
        };
        this.copyFramebufferToTexture = function(position, texture, level = 0) {
            const levelScale = Math.pow(2, -level);
            const width = Math.floor(texture.image.width * levelScale);
            const height = Math.floor(texture.image.height * levelScale);
            textures.setTexture2D(texture, 0);
            _gl.copyTexSubImage2D(_gl.TEXTURE_2D, level, 0, 0, position.x, position.y, width, height);
            state.unbindTexture();
        };
        this.copyTextureToTexture = function(position, srcTexture, dstTexture, level = 0) {
            const width = srcTexture.image.width;
            const height = srcTexture.image.height;
            const glFormat = utils.convert(dstTexture.format);
            const glType = utils.convert(dstTexture.type);
            textures.setTexture2D(dstTexture, 0);
            // As another texture upload may have changed pixelStorei
            // parameters, make sure they are correct for the dstTexture
            _gl.pixelStorei(_gl.UNPACK_FLIP_Y_WEBGL, dstTexture.flipY);
            _gl.pixelStorei(_gl.UNPACK_PREMULTIPLY_ALPHA_WEBGL, dstTexture.premultiplyAlpha);
            _gl.pixelStorei(_gl.UNPACK_ALIGNMENT, dstTexture.unpackAlignment);
            if (srcTexture.isDataTexture) _gl.texSubImage2D(_gl.TEXTURE_2D, level, position.x, position.y, width, height, glFormat, glType, srcTexture.image.data);
            else if (srcTexture.isCompressedTexture) _gl.compressedTexSubImage2D(_gl.TEXTURE_2D, level, position.x, position.y, srcTexture.mipmaps[0].width, srcTexture.mipmaps[0].height, glFormat, srcTexture.mipmaps[0].data);
            else _gl.texSubImage2D(_gl.TEXTURE_2D, level, position.x, position.y, glFormat, glType, srcTexture.image);
            // Generate mipmaps only when copying level 0
            if (level === 0 && dstTexture.generateMipmaps) _gl.generateMipmap(_gl.TEXTURE_2D);
            state.unbindTexture();
        };
        this.copyTextureToTexture3D = function(sourceBox, position, srcTexture, dstTexture, level = 0) {
            if (_this.isWebGL1Renderer) {
                console.warn("THREE.WebGLRenderer.copyTextureToTexture3D: can only be used with WebGL2.");
                return;
            }
            const width = sourceBox.max.x - sourceBox.min.x + 1;
            const height = sourceBox.max.y - sourceBox.min.y + 1;
            const depth = sourceBox.max.z - sourceBox.min.z + 1;
            const glFormat = utils.convert(dstTexture.format);
            const glType = utils.convert(dstTexture.type);
            let glTarget;
            if (dstTexture.isData3DTexture) {
                textures.setTexture3D(dstTexture, 0);
                glTarget = _gl.TEXTURE_3D;
            } else if (dstTexture.isDataArrayTexture) {
                textures.setTexture2DArray(dstTexture, 0);
                glTarget = _gl.TEXTURE_2D_ARRAY;
            } else {
                console.warn("THREE.WebGLRenderer.copyTextureToTexture3D: only supports THREE.DataTexture3D and THREE.DataTexture2DArray.");
                return;
            }
            _gl.pixelStorei(_gl.UNPACK_FLIP_Y_WEBGL, dstTexture.flipY);
            _gl.pixelStorei(_gl.UNPACK_PREMULTIPLY_ALPHA_WEBGL, dstTexture.premultiplyAlpha);
            _gl.pixelStorei(_gl.UNPACK_ALIGNMENT, dstTexture.unpackAlignment);
            const unpackRowLen = _gl.getParameter(_gl.UNPACK_ROW_LENGTH);
            const unpackImageHeight = _gl.getParameter(_gl.UNPACK_IMAGE_HEIGHT);
            const unpackSkipPixels = _gl.getParameter(_gl.UNPACK_SKIP_PIXELS);
            const unpackSkipRows = _gl.getParameter(_gl.UNPACK_SKIP_ROWS);
            const unpackSkipImages = _gl.getParameter(_gl.UNPACK_SKIP_IMAGES);
            const image = srcTexture.isCompressedTexture ? srcTexture.mipmaps[0] : srcTexture.image;
            _gl.pixelStorei(_gl.UNPACK_ROW_LENGTH, image.width);
            _gl.pixelStorei(_gl.UNPACK_IMAGE_HEIGHT, image.height);
            _gl.pixelStorei(_gl.UNPACK_SKIP_PIXELS, sourceBox.min.x);
            _gl.pixelStorei(_gl.UNPACK_SKIP_ROWS, sourceBox.min.y);
            _gl.pixelStorei(_gl.UNPACK_SKIP_IMAGES, sourceBox.min.z);
            if (srcTexture.isDataTexture || srcTexture.isData3DTexture) _gl.texSubImage3D(glTarget, level, position.x, position.y, position.z, width, height, depth, glFormat, glType, image.data);
            else if (srcTexture.isCompressedArrayTexture) {
                console.warn("THREE.WebGLRenderer.copyTextureToTexture3D: untested support for compressed srcTexture.");
                _gl.compressedTexSubImage3D(glTarget, level, position.x, position.y, position.z, width, height, depth, glFormat, image.data);
            } else _gl.texSubImage3D(glTarget, level, position.x, position.y, position.z, width, height, depth, glFormat, glType, image);
            _gl.pixelStorei(_gl.UNPACK_ROW_LENGTH, unpackRowLen);
            _gl.pixelStorei(_gl.UNPACK_IMAGE_HEIGHT, unpackImageHeight);
            _gl.pixelStorei(_gl.UNPACK_SKIP_PIXELS, unpackSkipPixels);
            _gl.pixelStorei(_gl.UNPACK_SKIP_ROWS, unpackSkipRows);
            _gl.pixelStorei(_gl.UNPACK_SKIP_IMAGES, unpackSkipImages);
            // Generate mipmaps only when copying level 0
            if (level === 0 && dstTexture.generateMipmaps) _gl.generateMipmap(glTarget);
            state.unbindTexture();
        };
        this.initTexture = function(texture) {
            if (texture.isCubeTexture) textures.setTextureCube(texture, 0);
            else if (texture.isData3DTexture) textures.setTexture3D(texture, 0);
            else if (texture.isDataArrayTexture || texture.isCompressedArrayTexture) textures.setTexture2DArray(texture, 0);
            else textures.setTexture2D(texture, 0);
            state.unbindTexture();
        };
        this.resetState = function() {
            _currentActiveCubeFace = 0;
            _currentActiveMipmapLevel = 0;
            _currentRenderTarget = null;
            state.reset();
            bindingStates.reset();
        };
        if (typeof __THREE_DEVTOOLS__ !== "undefined") __THREE_DEVTOOLS__.dispatchEvent(new CustomEvent("observe", {
            detail: this
        }));
    }
}
class $9014d97cd777be10$export$a2f65229194348f9 extends $9014d97cd777be10$export$f6cc00ef28d7cf97 {
}
$9014d97cd777be10$export$a2f65229194348f9.prototype.isWebGL1Renderer = true;
class $9014d97cd777be10$export$6f1519f023b8d0f6 {
    clone() {
        return new $9014d97cd777be10$export$6f1519f023b8d0f6(this.color, this.density);
    }
    toJSON() {
        return {
            type: "FogExp2",
            color: this.color.getHex(),
            density: this.density
        };
    }
    constructor(color, density = 0.00025){
        this.isFogExp2 = true;
        this.name = "";
        this.color = new $9014d97cd777be10$export$892596cec99bc70e(color);
        this.density = density;
    }
}
class $9014d97cd777be10$export$3c890837b09508d4 {
    clone() {
        return new $9014d97cd777be10$export$3c890837b09508d4(this.color, this.near, this.far);
    }
    toJSON() {
        return {
            type: "Fog",
            color: this.color.getHex(),
            near: this.near,
            far: this.far
        };
    }
    constructor(color, near = 1, far = 1000){
        this.isFog = true;
        this.name = "";
        this.color = new $9014d97cd777be10$export$892596cec99bc70e(color);
        this.near = near;
        this.far = far;
    }
}
class $9014d97cd777be10$export$38af1803e3442a7f extends $9014d97cd777be10$export$e4dd07dff30cc924 {
    copy(source, recursive) {
        super.copy(source, recursive);
        if (source.background !== null) this.background = source.background.clone();
        if (source.environment !== null) this.environment = source.environment.clone();
        if (source.fog !== null) this.fog = source.fog.clone();
        this.backgroundBlurriness = source.backgroundBlurriness;
        this.backgroundIntensity = source.backgroundIntensity;
        if (source.overrideMaterial !== null) this.overrideMaterial = source.overrideMaterial.clone();
        this.matrixAutoUpdate = source.matrixAutoUpdate;
        return this;
    }
    toJSON(meta) {
        const data = super.toJSON(meta);
        if (this.fog !== null) data.object.fog = this.fog.toJSON();
        if (this.backgroundBlurriness > 0) data.object.backgroundBlurriness = this.backgroundBlurriness;
        if (this.backgroundIntensity !== 1) data.object.backgroundIntensity = this.backgroundIntensity;
        return data;
    }
    constructor(){
        super();
        this.isScene = true;
        this.type = "Scene";
        this.background = null;
        this.environment = null;
        this.fog = null;
        this.backgroundBlurriness = 0;
        this.backgroundIntensity = 1;
        this.overrideMaterial = null;
        if (typeof __THREE_DEVTOOLS__ !== "undefined") __THREE_DEVTOOLS__.dispatchEvent(new CustomEvent("observe", {
            detail: this
        }));
    }
}
class $9014d97cd777be10$export$3d5cd879f108f53f {
    onUploadCallback() {}
    set needsUpdate(value) {
        if (value === true) this.version++;
    }
    setUsage(value) {
        this.usage = value;
        return this;
    }
    copy(source) {
        this.array = new source.array.constructor(source.array);
        this.count = source.count;
        this.stride = source.stride;
        this.usage = source.usage;
        return this;
    }
    copyAt(index1, attribute, index2) {
        index1 *= this.stride;
        index2 *= attribute.stride;
        for(let i = 0, l = this.stride; i < l; i++)this.array[index1 + i] = attribute.array[index2 + i];
        return this;
    }
    set(value, offset = 0) {
        this.array.set(value, offset);
        return this;
    }
    clone(data) {
        if (data.arrayBuffers === undefined) data.arrayBuffers = {};
        if (this.array.buffer._uuid === undefined) this.array.buffer._uuid = $9014d97cd777be10$var$generateUUID();
        if (data.arrayBuffers[this.array.buffer._uuid] === undefined) data.arrayBuffers[this.array.buffer._uuid] = this.array.slice(0).buffer;
        const array = new this.array.constructor(data.arrayBuffers[this.array.buffer._uuid]);
        const ib = new this.constructor(array, this.stride);
        ib.setUsage(this.usage);
        return ib;
    }
    onUpload(callback) {
        this.onUploadCallback = callback;
        return this;
    }
    toJSON(data) {
        if (data.arrayBuffers === undefined) data.arrayBuffers = {};
        // generate UUID for array buffer if necessary
        if (this.array.buffer._uuid === undefined) this.array.buffer._uuid = $9014d97cd777be10$var$generateUUID();
        if (data.arrayBuffers[this.array.buffer._uuid] === undefined) data.arrayBuffers[this.array.buffer._uuid] = Array.from(new Uint32Array(this.array.buffer));
        //
        return {
            uuid: this.uuid,
            buffer: this.array.buffer._uuid,
            type: this.array.constructor.name,
            stride: this.stride
        };
    }
    constructor(array, stride){
        this.isInterleavedBuffer = true;
        this.array = array;
        this.stride = stride;
        this.count = array !== undefined ? array.length / stride : 0;
        this.usage = $9014d97cd777be10$export$763e8360f4d7f77d;
        this.updateRange = {
            offset: 0,
            count: -1
        };
        this.version = 0;
        this.uuid = $9014d97cd777be10$var$generateUUID();
    }
}
const $9014d97cd777be10$var$_vector$5 = /*@__PURE__*/ new $9014d97cd777be10$export$64b5c384219d3699();
class $9014d97cd777be10$export$920b6d07334599c7 {
    get count() {
        return this.data.count;
    }
    get array() {
        return this.data.array;
    }
    set needsUpdate(value) {
        this.data.needsUpdate = value;
    }
    applyMatrix4(m) {
        for(let i = 0, l = this.data.count; i < l; i++){
            $9014d97cd777be10$var$_vector$5.fromBufferAttribute(this, i);
            $9014d97cd777be10$var$_vector$5.applyMatrix4(m);
            this.setXYZ(i, $9014d97cd777be10$var$_vector$5.x, $9014d97cd777be10$var$_vector$5.y, $9014d97cd777be10$var$_vector$5.z);
        }
        return this;
    }
    applyNormalMatrix(m) {
        for(let i = 0, l = this.count; i < l; i++){
            $9014d97cd777be10$var$_vector$5.fromBufferAttribute(this, i);
            $9014d97cd777be10$var$_vector$5.applyNormalMatrix(m);
            this.setXYZ(i, $9014d97cd777be10$var$_vector$5.x, $9014d97cd777be10$var$_vector$5.y, $9014d97cd777be10$var$_vector$5.z);
        }
        return this;
    }
    transformDirection(m) {
        for(let i = 0, l = this.count; i < l; i++){
            $9014d97cd777be10$var$_vector$5.fromBufferAttribute(this, i);
            $9014d97cd777be10$var$_vector$5.transformDirection(m);
            this.setXYZ(i, $9014d97cd777be10$var$_vector$5.x, $9014d97cd777be10$var$_vector$5.y, $9014d97cd777be10$var$_vector$5.z);
        }
        return this;
    }
    setX(index, x) {
        if (this.normalized) x = $9014d97cd777be10$var$normalize(x, this.array);
        this.data.array[index * this.data.stride + this.offset] = x;
        return this;
    }
    setY(index, y) {
        if (this.normalized) y = $9014d97cd777be10$var$normalize(y, this.array);
        this.data.array[index * this.data.stride + this.offset + 1] = y;
        return this;
    }
    setZ(index, z) {
        if (this.normalized) z = $9014d97cd777be10$var$normalize(z, this.array);
        this.data.array[index * this.data.stride + this.offset + 2] = z;
        return this;
    }
    setW(index, w) {
        if (this.normalized) w = $9014d97cd777be10$var$normalize(w, this.array);
        this.data.array[index * this.data.stride + this.offset + 3] = w;
        return this;
    }
    getX(index) {
        let x = this.data.array[index * this.data.stride + this.offset];
        if (this.normalized) x = $9014d97cd777be10$var$denormalize(x, this.array);
        return x;
    }
    getY(index) {
        let y = this.data.array[index * this.data.stride + this.offset + 1];
        if (this.normalized) y = $9014d97cd777be10$var$denormalize(y, this.array);
        return y;
    }
    getZ(index) {
        let z = this.data.array[index * this.data.stride + this.offset + 2];
        if (this.normalized) z = $9014d97cd777be10$var$denormalize(z, this.array);
        return z;
    }
    getW(index) {
        let w = this.data.array[index * this.data.stride + this.offset + 3];
        if (this.normalized) w = $9014d97cd777be10$var$denormalize(w, this.array);
        return w;
    }
    setXY(index, x, y) {
        index = index * this.data.stride + this.offset;
        if (this.normalized) {
            x = $9014d97cd777be10$var$normalize(x, this.array);
            y = $9014d97cd777be10$var$normalize(y, this.array);
        }
        this.data.array[index + 0] = x;
        this.data.array[index + 1] = y;
        return this;
    }
    setXYZ(index, x, y, z) {
        index = index * this.data.stride + this.offset;
        if (this.normalized) {
            x = $9014d97cd777be10$var$normalize(x, this.array);
            y = $9014d97cd777be10$var$normalize(y, this.array);
            z = $9014d97cd777be10$var$normalize(z, this.array);
        }
        this.data.array[index + 0] = x;
        this.data.array[index + 1] = y;
        this.data.array[index + 2] = z;
        return this;
    }
    setXYZW(index, x, y, z, w) {
        index = index * this.data.stride + this.offset;
        if (this.normalized) {
            x = $9014d97cd777be10$var$normalize(x, this.array);
            y = $9014d97cd777be10$var$normalize(y, this.array);
            z = $9014d97cd777be10$var$normalize(z, this.array);
            w = $9014d97cd777be10$var$normalize(w, this.array);
        }
        this.data.array[index + 0] = x;
        this.data.array[index + 1] = y;
        this.data.array[index + 2] = z;
        this.data.array[index + 3] = w;
        return this;
    }
    clone(data) {
        if (data === undefined) {
            console.log("THREE.InterleavedBufferAttribute.clone(): Cloning an interleaved buffer attribute will de-interleave buffer data.");
            const array = [];
            for(let i = 0; i < this.count; i++){
                const index = i * this.data.stride + this.offset;
                for(let j = 0; j < this.itemSize; j++)array.push(this.data.array[index + j]);
            }
            return new $9014d97cd777be10$export$8dea267bd6bde117(new this.array.constructor(array), this.itemSize, this.normalized);
        } else {
            if (data.interleavedBuffers === undefined) data.interleavedBuffers = {};
            if (data.interleavedBuffers[this.data.uuid] === undefined) data.interleavedBuffers[this.data.uuid] = this.data.clone(data);
            return new $9014d97cd777be10$export$920b6d07334599c7(data.interleavedBuffers[this.data.uuid], this.itemSize, this.offset, this.normalized);
        }
    }
    toJSON(data) {
        if (data === undefined) {
            console.log("THREE.InterleavedBufferAttribute.toJSON(): Serializing an interleaved buffer attribute will de-interleave buffer data.");
            const array = [];
            for(let i = 0; i < this.count; i++){
                const index = i * this.data.stride + this.offset;
                for(let j = 0; j < this.itemSize; j++)array.push(this.data.array[index + j]);
            }
            // de-interleave data and save it as an ordinary buffer attribute for now
            return {
                itemSize: this.itemSize,
                type: this.array.constructor.name,
                array: array,
                normalized: this.normalized
            };
        } else {
            // save as true interleaved attribute
            if (data.interleavedBuffers === undefined) data.interleavedBuffers = {};
            if (data.interleavedBuffers[this.data.uuid] === undefined) data.interleavedBuffers[this.data.uuid] = this.data.toJSON(data);
            return {
                isInterleavedBufferAttribute: true,
                itemSize: this.itemSize,
                data: this.data.uuid,
                offset: this.offset,
                normalized: this.normalized
            };
        }
    }
    constructor(interleavedBuffer, itemSize, offset, normalized = false){
        this.isInterleavedBufferAttribute = true;
        this.name = "";
        this.data = interleavedBuffer;
        this.itemSize = itemSize;
        this.offset = offset;
        this.normalized = normalized;
    }
}
class $9014d97cd777be10$export$5ec7dd1c6994bf8e extends $9014d97cd777be10$export$a2d8b23205c25948 {
    copy(source) {
        super.copy(source);
        this.color.copy(source.color);
        this.map = source.map;
        this.alphaMap = source.alphaMap;
        this.rotation = source.rotation;
        this.sizeAttenuation = source.sizeAttenuation;
        this.fog = source.fog;
        return this;
    }
    constructor(parameters){
        super();
        this.isSpriteMaterial = true;
        this.type = "SpriteMaterial";
        this.color = new $9014d97cd777be10$export$892596cec99bc70e(0xffffff);
        this.map = null;
        this.alphaMap = null;
        this.rotation = 0;
        this.sizeAttenuation = true;
        this.transparent = true;
        this.fog = true;
        this.setValues(parameters);
    }
}
let $9014d97cd777be10$var$_geometry;
const $9014d97cd777be10$var$_intersectPoint = /*@__PURE__*/ new $9014d97cd777be10$export$64b5c384219d3699();
const $9014d97cd777be10$var$_worldScale = /*@__PURE__*/ new $9014d97cd777be10$export$64b5c384219d3699();
const $9014d97cd777be10$var$_mvPosition = /*@__PURE__*/ new $9014d97cd777be10$export$64b5c384219d3699();
const $9014d97cd777be10$var$_alignedPosition = /*@__PURE__*/ new $9014d97cd777be10$export$c977b3e384af9ae1();
const $9014d97cd777be10$var$_rotatedPosition = /*@__PURE__*/ new $9014d97cd777be10$export$c977b3e384af9ae1();
const $9014d97cd777be10$var$_viewWorldMatrix = /*@__PURE__*/ new $9014d97cd777be10$export$2ae72fc923e5eb5();
const $9014d97cd777be10$var$_vA = /*@__PURE__*/ new $9014d97cd777be10$export$64b5c384219d3699();
const $9014d97cd777be10$var$_vB = /*@__PURE__*/ new $9014d97cd777be10$export$64b5c384219d3699();
const $9014d97cd777be10$var$_vC = /*@__PURE__*/ new $9014d97cd777be10$export$64b5c384219d3699();
const $9014d97cd777be10$var$_uvA = /*@__PURE__*/ new $9014d97cd777be10$export$c977b3e384af9ae1();
const $9014d97cd777be10$var$_uvB = /*@__PURE__*/ new $9014d97cd777be10$export$c977b3e384af9ae1();
const $9014d97cd777be10$var$_uvC = /*@__PURE__*/ new $9014d97cd777be10$export$c977b3e384af9ae1();
class $9014d97cd777be10$export$3075603db8e6204c extends $9014d97cd777be10$export$e4dd07dff30cc924 {
    raycast(raycaster, intersects) {
        if (raycaster.camera === null) console.error('THREE.Sprite: "Raycaster.camera" needs to be set in order to raycast against sprites.');
        $9014d97cd777be10$var$_worldScale.setFromMatrixScale(this.matrixWorld);
        $9014d97cd777be10$var$_viewWorldMatrix.copy(raycaster.camera.matrixWorld);
        this.modelViewMatrix.multiplyMatrices(raycaster.camera.matrixWorldInverse, this.matrixWorld);
        $9014d97cd777be10$var$_mvPosition.setFromMatrixPosition(this.modelViewMatrix);
        if (raycaster.camera.isPerspectiveCamera && this.material.sizeAttenuation === false) $9014d97cd777be10$var$_worldScale.multiplyScalar(-$9014d97cd777be10$var$_mvPosition.z);
        const rotation = this.material.rotation;
        let sin, cos;
        if (rotation !== 0) {
            cos = Math.cos(rotation);
            sin = Math.sin(rotation);
        }
        const center = this.center;
        $9014d97cd777be10$var$transformVertex($9014d97cd777be10$var$_vA.set(-0.5, -0.5, 0), $9014d97cd777be10$var$_mvPosition, center, $9014d97cd777be10$var$_worldScale, sin, cos);
        $9014d97cd777be10$var$transformVertex($9014d97cd777be10$var$_vB.set(0.5, -0.5, 0), $9014d97cd777be10$var$_mvPosition, center, $9014d97cd777be10$var$_worldScale, sin, cos);
        $9014d97cd777be10$var$transformVertex($9014d97cd777be10$var$_vC.set(0.5, 0.5, 0), $9014d97cd777be10$var$_mvPosition, center, $9014d97cd777be10$var$_worldScale, sin, cos);
        $9014d97cd777be10$var$_uvA.set(0, 0);
        $9014d97cd777be10$var$_uvB.set(1, 0);
        $9014d97cd777be10$var$_uvC.set(1, 1);
        // check first triangle
        let intersect = raycaster.ray.intersectTriangle($9014d97cd777be10$var$_vA, $9014d97cd777be10$var$_vB, $9014d97cd777be10$var$_vC, false, $9014d97cd777be10$var$_intersectPoint);
        if (intersect === null) {
            // check second triangle
            $9014d97cd777be10$var$transformVertex($9014d97cd777be10$var$_vB.set(-0.5, 0.5, 0), $9014d97cd777be10$var$_mvPosition, center, $9014d97cd777be10$var$_worldScale, sin, cos);
            $9014d97cd777be10$var$_uvB.set(0, 1);
            intersect = raycaster.ray.intersectTriangle($9014d97cd777be10$var$_vA, $9014d97cd777be10$var$_vC, $9014d97cd777be10$var$_vB, false, $9014d97cd777be10$var$_intersectPoint);
            if (intersect === null) return;
        }
        const distance = raycaster.ray.origin.distanceTo($9014d97cd777be10$var$_intersectPoint);
        if (distance < raycaster.near || distance > raycaster.far) return;
        intersects.push({
            distance: distance,
            point: $9014d97cd777be10$var$_intersectPoint.clone(),
            uv: $9014d97cd777be10$export$5a465592bfe74b48.getInterpolation($9014d97cd777be10$var$_intersectPoint, $9014d97cd777be10$var$_vA, $9014d97cd777be10$var$_vB, $9014d97cd777be10$var$_vC, $9014d97cd777be10$var$_uvA, $9014d97cd777be10$var$_uvB, $9014d97cd777be10$var$_uvC, new $9014d97cd777be10$export$c977b3e384af9ae1()),
            face: null,
            object: this
        });
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        if (source.center !== undefined) this.center.copy(source.center);
        this.material = source.material;
        return this;
    }
    constructor(material){
        super();
        this.isSprite = true;
        this.type = "Sprite";
        if ($9014d97cd777be10$var$_geometry === undefined) {
            $9014d97cd777be10$var$_geometry = new $9014d97cd777be10$export$b7be63a67df8959();
            const float32Array = new Float32Array([
                -0.5,
                -0.5,
                0,
                0,
                0,
                0.5,
                -0.5,
                0,
                1,
                0,
                0.5,
                0.5,
                0,
                1,
                1,
                -0.5,
                0.5,
                0,
                0,
                1
            ]);
            const interleavedBuffer = new $9014d97cd777be10$export$3d5cd879f108f53f(float32Array, 5);
            $9014d97cd777be10$var$_geometry.setIndex([
                0,
                1,
                2,
                0,
                2,
                3
            ]);
            $9014d97cd777be10$var$_geometry.setAttribute("position", new $9014d97cd777be10$export$920b6d07334599c7(interleavedBuffer, 3, 0, false));
            $9014d97cd777be10$var$_geometry.setAttribute("uv", new $9014d97cd777be10$export$920b6d07334599c7(interleavedBuffer, 2, 3, false));
        }
        this.geometry = $9014d97cd777be10$var$_geometry;
        this.material = material !== undefined ? material : new $9014d97cd777be10$export$5ec7dd1c6994bf8e();
        this.center = new $9014d97cd777be10$export$c977b3e384af9ae1(0.5, 0.5);
    }
}
function $9014d97cd777be10$var$transformVertex(vertexPosition, mvPosition, center, scale, sin, cos) {
    // compute position in camera space
    $9014d97cd777be10$var$_alignedPosition.subVectors(vertexPosition, center).addScalar(0.5).multiply(scale);
    // to check if rotation is not zero
    if (sin !== undefined) {
        $9014d97cd777be10$var$_rotatedPosition.x = cos * $9014d97cd777be10$var$_alignedPosition.x - sin * $9014d97cd777be10$var$_alignedPosition.y;
        $9014d97cd777be10$var$_rotatedPosition.y = sin * $9014d97cd777be10$var$_alignedPosition.x + cos * $9014d97cd777be10$var$_alignedPosition.y;
    } else $9014d97cd777be10$var$_rotatedPosition.copy($9014d97cd777be10$var$_alignedPosition);
    vertexPosition.copy(mvPosition);
    vertexPosition.x += $9014d97cd777be10$var$_rotatedPosition.x;
    vertexPosition.y += $9014d97cd777be10$var$_rotatedPosition.y;
    // transform to world space
    vertexPosition.applyMatrix4($9014d97cd777be10$var$_viewWorldMatrix);
}
const $9014d97cd777be10$var$_v1$2 = /*@__PURE__*/ new $9014d97cd777be10$export$64b5c384219d3699();
const $9014d97cd777be10$var$_v2$1 = /*@__PURE__*/ new $9014d97cd777be10$export$64b5c384219d3699();
class $9014d97cd777be10$export$112e7237be0c5f30 extends $9014d97cd777be10$export$e4dd07dff30cc924 {
    copy(source) {
        super.copy(source, false);
        const levels = source.levels;
        for(let i = 0, l = levels.length; i < l; i++){
            const level = levels[i];
            this.addLevel(level.object.clone(), level.distance, level.hysteresis);
        }
        this.autoUpdate = source.autoUpdate;
        return this;
    }
    addLevel(object, distance = 0, hysteresis = 0) {
        distance = Math.abs(distance);
        const levels = this.levels;
        let l;
        for(l = 0; l < levels.length; l++){
            if (distance < levels[l].distance) break;
        }
        levels.splice(l, 0, {
            distance: distance,
            hysteresis: hysteresis,
            object: object
        });
        this.add(object);
        return this;
    }
    getCurrentLevel() {
        return this._currentLevel;
    }
    getObjectForDistance(distance) {
        const levels = this.levels;
        if (levels.length > 0) {
            let i, l;
            for(i = 1, l = levels.length; i < l; i++){
                let levelDistance = levels[i].distance;
                if (levels[i].object.visible) levelDistance -= levelDistance * levels[i].hysteresis;
                if (distance < levelDistance) break;
            }
            return levels[i - 1].object;
        }
        return null;
    }
    raycast(raycaster, intersects) {
        const levels = this.levels;
        if (levels.length > 0) {
            $9014d97cd777be10$var$_v1$2.setFromMatrixPosition(this.matrixWorld);
            const distance = raycaster.ray.origin.distanceTo($9014d97cd777be10$var$_v1$2);
            this.getObjectForDistance(distance).raycast(raycaster, intersects);
        }
    }
    update(camera) {
        const levels = this.levels;
        if (levels.length > 1) {
            $9014d97cd777be10$var$_v1$2.setFromMatrixPosition(camera.matrixWorld);
            $9014d97cd777be10$var$_v2$1.setFromMatrixPosition(this.matrixWorld);
            const distance = $9014d97cd777be10$var$_v1$2.distanceTo($9014d97cd777be10$var$_v2$1) / camera.zoom;
            levels[0].object.visible = true;
            let i, l;
            for(i = 1, l = levels.length; i < l; i++){
                let levelDistance = levels[i].distance;
                if (levels[i].object.visible) levelDistance -= levelDistance * levels[i].hysteresis;
                if (distance >= levelDistance) {
                    levels[i - 1].object.visible = false;
                    levels[i].object.visible = true;
                } else break;
            }
            this._currentLevel = i - 1;
            for(; i < l; i++)levels[i].object.visible = false;
        }
    }
    toJSON(meta) {
        const data = super.toJSON(meta);
        if (this.autoUpdate === false) data.object.autoUpdate = false;
        data.object.levels = [];
        const levels = this.levels;
        for(let i = 0, l = levels.length; i < l; i++){
            const level = levels[i];
            data.object.levels.push({
                object: level.object.uuid,
                distance: level.distance,
                hysteresis: level.hysteresis
            });
        }
        return data;
    }
    constructor(){
        super();
        this._currentLevel = 0;
        this.type = "LOD";
        Object.defineProperties(this, {
            levels: {
                enumerable: true,
                value: []
            },
            isLOD: {
                value: true
            }
        });
        this.autoUpdate = true;
    }
}
const $9014d97cd777be10$var$_basePosition = /*@__PURE__*/ new $9014d97cd777be10$export$64b5c384219d3699();
const $9014d97cd777be10$var$_skinIndex = /*@__PURE__*/ new $9014d97cd777be10$export$fa7daccca11cdbe3();
const $9014d97cd777be10$var$_skinWeight = /*@__PURE__*/ new $9014d97cd777be10$export$fa7daccca11cdbe3();
const $9014d97cd777be10$var$_vector3 = /*@__PURE__*/ new $9014d97cd777be10$export$64b5c384219d3699();
const $9014d97cd777be10$var$_matrix4 = /*@__PURE__*/ new $9014d97cd777be10$export$2ae72fc923e5eb5();
const $9014d97cd777be10$var$_vertex = /*@__PURE__*/ new $9014d97cd777be10$export$64b5c384219d3699();
const $9014d97cd777be10$var$_sphere$3 = /*@__PURE__*/ new $9014d97cd777be10$export$805e8b72413ccaba();
const $9014d97cd777be10$var$_inverseMatrix$2 = /*@__PURE__*/ new $9014d97cd777be10$export$2ae72fc923e5eb5();
const $9014d97cd777be10$var$_ray$2 = /*@__PURE__*/ new $9014d97cd777be10$export$a186db52eed6d40e();
class $9014d97cd777be10$export$b303577035157ecf extends $9014d97cd777be10$export$e176487c05830cc5 {
    computeBoundingBox() {
        const geometry = this.geometry;
        if (this.boundingBox === null) this.boundingBox = new $9014d97cd777be10$export$6f7d5a9418ab2aa3();
        this.boundingBox.makeEmpty();
        const positionAttribute = geometry.getAttribute("position");
        for(let i = 0; i < positionAttribute.count; i++){
            $9014d97cd777be10$var$_vertex.fromBufferAttribute(positionAttribute, i);
            this.applyBoneTransform(i, $9014d97cd777be10$var$_vertex);
            this.boundingBox.expandByPoint($9014d97cd777be10$var$_vertex);
        }
    }
    computeBoundingSphere() {
        const geometry = this.geometry;
        if (this.boundingSphere === null) this.boundingSphere = new $9014d97cd777be10$export$805e8b72413ccaba();
        this.boundingSphere.makeEmpty();
        const positionAttribute = geometry.getAttribute("position");
        for(let i = 0; i < positionAttribute.count; i++){
            $9014d97cd777be10$var$_vertex.fromBufferAttribute(positionAttribute, i);
            this.applyBoneTransform(i, $9014d97cd777be10$var$_vertex);
            this.boundingSphere.expandByPoint($9014d97cd777be10$var$_vertex);
        }
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        this.bindMode = source.bindMode;
        this.bindMatrix.copy(source.bindMatrix);
        this.bindMatrixInverse.copy(source.bindMatrixInverse);
        this.skeleton = source.skeleton;
        if (source.boundingBox !== null) this.boundingBox = source.boundingBox.clone();
        if (source.boundingSphere !== null) this.boundingSphere = source.boundingSphere.clone();
        return this;
    }
    raycast(raycaster, intersects) {
        const material = this.material;
        const matrixWorld = this.matrixWorld;
        if (material === undefined) return;
        // test with bounding sphere in world space
        if (this.boundingSphere === null) this.computeBoundingSphere();
        $9014d97cd777be10$var$_sphere$3.copy(this.boundingSphere);
        $9014d97cd777be10$var$_sphere$3.applyMatrix4(matrixWorld);
        if (raycaster.ray.intersectsSphere($9014d97cd777be10$var$_sphere$3) === false) return;
        // convert ray to local space of skinned mesh
        $9014d97cd777be10$var$_inverseMatrix$2.copy(matrixWorld).invert();
        $9014d97cd777be10$var$_ray$2.copy(raycaster.ray).applyMatrix4($9014d97cd777be10$var$_inverseMatrix$2);
        // test with bounding box in local space
        if (this.boundingBox !== null) {
            if ($9014d97cd777be10$var$_ray$2.intersectsBox(this.boundingBox) === false) return;
        }
        // test for intersections with geometry
        this._computeIntersections(raycaster, intersects, $9014d97cd777be10$var$_ray$2);
    }
    getVertexPosition(index, target) {
        super.getVertexPosition(index, target);
        this.applyBoneTransform(index, target);
        return target;
    }
    bind(skeleton, bindMatrix) {
        this.skeleton = skeleton;
        if (bindMatrix === undefined) {
            this.updateMatrixWorld(true);
            this.skeleton.calculateInverses();
            bindMatrix = this.matrixWorld;
        }
        this.bindMatrix.copy(bindMatrix);
        this.bindMatrixInverse.copy(bindMatrix).invert();
    }
    pose() {
        this.skeleton.pose();
    }
    normalizeSkinWeights() {
        const vector = new $9014d97cd777be10$export$fa7daccca11cdbe3();
        const skinWeight = this.geometry.attributes.skinWeight;
        for(let i = 0, l = skinWeight.count; i < l; i++){
            vector.fromBufferAttribute(skinWeight, i);
            const scale = 1.0 / vector.manhattanLength();
            if (scale !== Infinity) vector.multiplyScalar(scale);
            else vector.set(1, 0, 0, 0); // do something reasonable
            skinWeight.setXYZW(i, vector.x, vector.y, vector.z, vector.w);
        }
    }
    updateMatrixWorld(force) {
        super.updateMatrixWorld(force);
        if (this.bindMode === "attached") this.bindMatrixInverse.copy(this.matrixWorld).invert();
        else if (this.bindMode === "detached") this.bindMatrixInverse.copy(this.bindMatrix).invert();
        else console.warn("THREE.SkinnedMesh: Unrecognized bindMode: " + this.bindMode);
    }
    applyBoneTransform(index, vector) {
        const skeleton = this.skeleton;
        const geometry = this.geometry;
        $9014d97cd777be10$var$_skinIndex.fromBufferAttribute(geometry.attributes.skinIndex, index);
        $9014d97cd777be10$var$_skinWeight.fromBufferAttribute(geometry.attributes.skinWeight, index);
        $9014d97cd777be10$var$_basePosition.copy(vector).applyMatrix4(this.bindMatrix);
        vector.set(0, 0, 0);
        for(let i = 0; i < 4; i++){
            const weight = $9014d97cd777be10$var$_skinWeight.getComponent(i);
            if (weight !== 0) {
                const boneIndex = $9014d97cd777be10$var$_skinIndex.getComponent(i);
                $9014d97cd777be10$var$_matrix4.multiplyMatrices(skeleton.bones[boneIndex].matrixWorld, skeleton.boneInverses[boneIndex]);
                vector.addScaledVector($9014d97cd777be10$var$_vector3.copy($9014d97cd777be10$var$_basePosition).applyMatrix4($9014d97cd777be10$var$_matrix4), weight);
            }
        }
        return vector.applyMatrix4(this.bindMatrixInverse);
    }
    boneTransform(index, vector) {
        console.warn("THREE.SkinnedMesh: .boneTransform() was renamed to .applyBoneTransform() in r151.");
        return this.applyBoneTransform(index, vector);
    }
    constructor(geometry, material){
        super(geometry, material);
        this.isSkinnedMesh = true;
        this.type = "SkinnedMesh";
        this.bindMode = "attached";
        this.bindMatrix = new $9014d97cd777be10$export$2ae72fc923e5eb5();
        this.bindMatrixInverse = new $9014d97cd777be10$export$2ae72fc923e5eb5();
        this.boundingBox = null;
        this.boundingSphere = null;
    }
}
class $9014d97cd777be10$export$b127726e56765aa4 extends $9014d97cd777be10$export$e4dd07dff30cc924 {
    constructor(){
        super();
        this.isBone = true;
        this.type = "Bone";
    }
}
class $9014d97cd777be10$export$b691f601014eabe1 extends $9014d97cd777be10$export$5431306cf43de24a {
    constructor(data = null, width = 1, height = 1, format, type, mapping, wrapS, wrapT, magFilter = $9014d97cd777be10$export$727aa5ec3fe39bf0, minFilter = $9014d97cd777be10$export$727aa5ec3fe39bf0, anisotropy, colorSpace1){
        super(null, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy, colorSpace1);
        this.isDataTexture = true;
        this.image = {
            data: data,
            width: width,
            height: height
        };
        this.generateMipmaps = false;
        this.flipY = false;
        this.unpackAlignment = 1;
    }
}
const $9014d97cd777be10$var$_offsetMatrix = /*@__PURE__*/ new $9014d97cd777be10$export$2ae72fc923e5eb5();
const $9014d97cd777be10$var$_identityMatrix = /*@__PURE__*/ new $9014d97cd777be10$export$2ae72fc923e5eb5();
class $9014d97cd777be10$export$8f31e4c4a37b8e9c {
    init() {
        const bones = this.bones;
        const boneInverses = this.boneInverses;
        this.boneMatrices = new Float32Array(bones.length * 16);
        // calculate inverse bone matrices if necessary
        if (boneInverses.length === 0) this.calculateInverses();
        else // handle special case
        if (bones.length !== boneInverses.length) {
            console.warn("THREE.Skeleton: Number of inverse bone matrices does not match amount of bones.");
            this.boneInverses = [];
            for(let i = 0, il = this.bones.length; i < il; i++)this.boneInverses.push(new $9014d97cd777be10$export$2ae72fc923e5eb5());
        }
    }
    calculateInverses() {
        this.boneInverses.length = 0;
        for(let i = 0, il = this.bones.length; i < il; i++){
            const inverse = new $9014d97cd777be10$export$2ae72fc923e5eb5();
            if (this.bones[i]) inverse.copy(this.bones[i].matrixWorld).invert();
            this.boneInverses.push(inverse);
        }
    }
    pose() {
        // recover the bind-time world matrices
        for(let i = 0, il = this.bones.length; i < il; i++){
            const bone = this.bones[i];
            if (bone) bone.matrixWorld.copy(this.boneInverses[i]).invert();
        }
        // compute the local matrices, positions, rotations and scales
        for(let i = 0, il = this.bones.length; i < il; i++){
            const bone = this.bones[i];
            if (bone) {
                if (bone.parent && bone.parent.isBone) {
                    bone.matrix.copy(bone.parent.matrixWorld).invert();
                    bone.matrix.multiply(bone.matrixWorld);
                } else bone.matrix.copy(bone.matrixWorld);
                bone.matrix.decompose(bone.position, bone.quaternion, bone.scale);
            }
        }
    }
    update() {
        const bones = this.bones;
        const boneInverses = this.boneInverses;
        const boneMatrices = this.boneMatrices;
        const boneTexture = this.boneTexture;
        // flatten bone matrices to array
        for(let i = 0, il = bones.length; i < il; i++){
            // compute the offset between the current and the original transform
            const matrix = bones[i] ? bones[i].matrixWorld : $9014d97cd777be10$var$_identityMatrix;
            $9014d97cd777be10$var$_offsetMatrix.multiplyMatrices(matrix, boneInverses[i]);
            $9014d97cd777be10$var$_offsetMatrix.toArray(boneMatrices, i * 16);
        }
        if (boneTexture !== null) boneTexture.needsUpdate = true;
    }
    clone() {
        return new $9014d97cd777be10$export$8f31e4c4a37b8e9c(this.bones, this.boneInverses);
    }
    computeBoneTexture() {
        // layout (1 matrix = 4 pixels)
        //      RGBA RGBA RGBA RGBA (=> column1, column2, column3, column4)
        //  with  8x8  pixel texture max   16 bones * 4 pixels =  (8 * 8)
        //       16x16 pixel texture max   64 bones * 4 pixels = (16 * 16)
        //       32x32 pixel texture max  256 bones * 4 pixels = (32 * 32)
        //       64x64 pixel texture max 1024 bones * 4 pixels = (64 * 64)
        let size = Math.sqrt(this.bones.length * 4); // 4 pixels needed for 1 matrix
        size = $9014d97cd777be10$var$ceilPowerOfTwo(size);
        size = Math.max(size, 4);
        const boneMatrices = new Float32Array(size * size * 4); // 4 floats per RGBA pixel
        boneMatrices.set(this.boneMatrices); // copy current values
        const boneTexture = new $9014d97cd777be10$export$b691f601014eabe1(boneMatrices, size, size, $9014d97cd777be10$export$3f8bb04b555a363c, $9014d97cd777be10$export$f6d331659b644596);
        boneTexture.needsUpdate = true;
        this.boneMatrices = boneMatrices;
        this.boneTexture = boneTexture;
        this.boneTextureSize = size;
        return this;
    }
    getBoneByName(name) {
        for(let i = 0, il = this.bones.length; i < il; i++){
            const bone = this.bones[i];
            if (bone.name === name) return bone;
        }
        return undefined;
    }
    dispose() {
        if (this.boneTexture !== null) {
            this.boneTexture.dispose();
            this.boneTexture = null;
        }
    }
    fromJSON(json, bones) {
        this.uuid = json.uuid;
        for(let i = 0, l = json.bones.length; i < l; i++){
            const uuid = json.bones[i];
            let bone = bones[uuid];
            if (bone === undefined) {
                console.warn("THREE.Skeleton: No bone found with UUID:", uuid);
                bone = new $9014d97cd777be10$export$b127726e56765aa4();
            }
            this.bones.push(bone);
            this.boneInverses.push(new $9014d97cd777be10$export$2ae72fc923e5eb5().fromArray(json.boneInverses[i]));
        }
        this.init();
        return this;
    }
    toJSON() {
        const data = {
            metadata: {
                version: 4.6,
                type: "Skeleton",
                generator: "Skeleton.toJSON"
            },
            bones: [],
            boneInverses: []
        };
        data.uuid = this.uuid;
        const bones = this.bones;
        const boneInverses = this.boneInverses;
        for(let i = 0, l = bones.length; i < l; i++){
            const bone = bones[i];
            data.bones.push(bone.uuid);
            const boneInverse = boneInverses[i];
            data.boneInverses.push(boneInverse.toArray());
        }
        return data;
    }
    constructor(bones = [], boneInverses = []){
        this.uuid = $9014d97cd777be10$var$generateUUID();
        this.bones = bones.slice(0);
        this.boneInverses = boneInverses;
        this.boneMatrices = null;
        this.boneTexture = null;
        this.boneTextureSize = 0;
        this.init();
    }
}
class $9014d97cd777be10$export$32ea87a8b54d744a extends $9014d97cd777be10$export$8dea267bd6bde117 {
    copy(source) {
        super.copy(source);
        this.meshPerAttribute = source.meshPerAttribute;
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.meshPerAttribute = this.meshPerAttribute;
        data.isInstancedBufferAttribute = true;
        return data;
    }
    constructor(array, itemSize, normalized, meshPerAttribute = 1){
        super(array, itemSize, normalized);
        this.isInstancedBufferAttribute = true;
        this.meshPerAttribute = meshPerAttribute;
    }
}
const $9014d97cd777be10$var$_instanceLocalMatrix = /*@__PURE__*/ new $9014d97cd777be10$export$2ae72fc923e5eb5();
const $9014d97cd777be10$var$_instanceWorldMatrix = /*@__PURE__*/ new $9014d97cd777be10$export$2ae72fc923e5eb5();
const $9014d97cd777be10$var$_instanceIntersects = [];
const $9014d97cd777be10$var$_box3 = /*@__PURE__*/ new $9014d97cd777be10$export$6f7d5a9418ab2aa3();
const $9014d97cd777be10$var$_identity = /*@__PURE__*/ new $9014d97cd777be10$export$2ae72fc923e5eb5();
const $9014d97cd777be10$var$_mesh = /*@__PURE__*/ new $9014d97cd777be10$export$e176487c05830cc5();
const $9014d97cd777be10$var$_sphere$2 = /*@__PURE__*/ new $9014d97cd777be10$export$805e8b72413ccaba();
class $9014d97cd777be10$export$f3c979c331175ad7 extends $9014d97cd777be10$export$e176487c05830cc5 {
    computeBoundingBox() {
        const geometry = this.geometry;
        const count = this.count;
        if (this.boundingBox === null) this.boundingBox = new $9014d97cd777be10$export$6f7d5a9418ab2aa3();
        if (geometry.boundingBox === null) geometry.computeBoundingBox();
        this.boundingBox.makeEmpty();
        for(let i = 0; i < count; i++){
            this.getMatrixAt(i, $9014d97cd777be10$var$_instanceLocalMatrix);
            $9014d97cd777be10$var$_box3.copy(geometry.boundingBox).applyMatrix4($9014d97cd777be10$var$_instanceLocalMatrix);
            this.boundingBox.union($9014d97cd777be10$var$_box3);
        }
    }
    computeBoundingSphere() {
        const geometry = this.geometry;
        const count = this.count;
        if (this.boundingSphere === null) this.boundingSphere = new $9014d97cd777be10$export$805e8b72413ccaba();
        if (geometry.boundingSphere === null) geometry.computeBoundingSphere();
        this.boundingSphere.makeEmpty();
        for(let i = 0; i < count; i++){
            this.getMatrixAt(i, $9014d97cd777be10$var$_instanceLocalMatrix);
            $9014d97cd777be10$var$_sphere$2.copy(geometry.boundingSphere).applyMatrix4($9014d97cd777be10$var$_instanceLocalMatrix);
            this.boundingSphere.union($9014d97cd777be10$var$_sphere$2);
        }
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        this.instanceMatrix.copy(source.instanceMatrix);
        if (source.instanceColor !== null) this.instanceColor = source.instanceColor.clone();
        this.count = source.count;
        if (source.boundingBox !== null) this.boundingBox = source.boundingBox.clone();
        if (source.boundingSphere !== null) this.boundingSphere = source.boundingSphere.clone();
        return this;
    }
    getColorAt(index, color) {
        color.fromArray(this.instanceColor.array, index * 3);
    }
    getMatrixAt(index, matrix) {
        matrix.fromArray(this.instanceMatrix.array, index * 16);
    }
    raycast(raycaster, intersects) {
        const matrixWorld = this.matrixWorld;
        const raycastTimes = this.count;
        $9014d97cd777be10$var$_mesh.geometry = this.geometry;
        $9014d97cd777be10$var$_mesh.material = this.material;
        if ($9014d97cd777be10$var$_mesh.material === undefined) return;
        // test with bounding sphere first
        if (this.boundingSphere === null) this.computeBoundingSphere();
        $9014d97cd777be10$var$_sphere$2.copy(this.boundingSphere);
        $9014d97cd777be10$var$_sphere$2.applyMatrix4(matrixWorld);
        if (raycaster.ray.intersectsSphere($9014d97cd777be10$var$_sphere$2) === false) return;
        // now test each instance
        for(let instanceId = 0; instanceId < raycastTimes; instanceId++){
            // calculate the world matrix for each instance
            this.getMatrixAt(instanceId, $9014d97cd777be10$var$_instanceLocalMatrix);
            $9014d97cd777be10$var$_instanceWorldMatrix.multiplyMatrices(matrixWorld, $9014d97cd777be10$var$_instanceLocalMatrix);
            // the mesh represents this single instance
            $9014d97cd777be10$var$_mesh.matrixWorld = $9014d97cd777be10$var$_instanceWorldMatrix;
            $9014d97cd777be10$var$_mesh.raycast(raycaster, $9014d97cd777be10$var$_instanceIntersects);
            // process the result of raycast
            for(let i = 0, l = $9014d97cd777be10$var$_instanceIntersects.length; i < l; i++){
                const intersect = $9014d97cd777be10$var$_instanceIntersects[i];
                intersect.instanceId = instanceId;
                intersect.object = this;
                intersects.push(intersect);
            }
            $9014d97cd777be10$var$_instanceIntersects.length = 0;
        }
    }
    setColorAt(index, color) {
        if (this.instanceColor === null) this.instanceColor = new $9014d97cd777be10$export$32ea87a8b54d744a(new Float32Array(this.instanceMatrix.count * 3), 3);
        color.toArray(this.instanceColor.array, index * 3);
    }
    setMatrixAt(index, matrix) {
        matrix.toArray(this.instanceMatrix.array, index * 16);
    }
    updateMorphTargets() {}
    dispose() {
        this.dispatchEvent({
            type: "dispose"
        });
    }
    constructor(geometry, material, count){
        super(geometry, material);
        this.isInstancedMesh = true;
        this.instanceMatrix = new $9014d97cd777be10$export$32ea87a8b54d744a(new Float32Array(count * 16), 16);
        this.instanceColor = null;
        this.count = count;
        this.boundingBox = null;
        this.boundingSphere = null;
        for(let i = 0; i < count; i++)this.setMatrixAt(i, $9014d97cd777be10$var$_identity);
    }
}
class $9014d97cd777be10$export$fbaaa33907730a0c extends $9014d97cd777be10$export$a2d8b23205c25948 {
    copy(source) {
        super.copy(source);
        this.color.copy(source.color);
        this.map = source.map;
        this.linewidth = source.linewidth;
        this.linecap = source.linecap;
        this.linejoin = source.linejoin;
        this.fog = source.fog;
        return this;
    }
    constructor(parameters){
        super();
        this.isLineBasicMaterial = true;
        this.type = "LineBasicMaterial";
        this.color = new $9014d97cd777be10$export$892596cec99bc70e(0xffffff);
        this.map = null;
        this.linewidth = 1;
        this.linecap = "round";
        this.linejoin = "round";
        this.fog = true;
        this.setValues(parameters);
    }
}
const $9014d97cd777be10$var$_start$1 = /*@__PURE__*/ new $9014d97cd777be10$export$64b5c384219d3699();
const $9014d97cd777be10$var$_end$1 = /*@__PURE__*/ new $9014d97cd777be10$export$64b5c384219d3699();
const $9014d97cd777be10$var$_inverseMatrix$1 = /*@__PURE__*/ new $9014d97cd777be10$export$2ae72fc923e5eb5();
const $9014d97cd777be10$var$_ray$1 = /*@__PURE__*/ new $9014d97cd777be10$export$a186db52eed6d40e();
const $9014d97cd777be10$var$_sphere$1 = /*@__PURE__*/ new $9014d97cd777be10$export$805e8b72413ccaba();
class $9014d97cd777be10$export$17d680238e50603e extends $9014d97cd777be10$export$e4dd07dff30cc924 {
    copy(source, recursive) {
        super.copy(source, recursive);
        this.material = source.material;
        this.geometry = source.geometry;
        return this;
    }
    computeLineDistances() {
        const geometry = this.geometry;
        // we assume non-indexed geometry
        if (geometry.index === null) {
            const positionAttribute = geometry.attributes.position;
            const lineDistances = [
                0
            ];
            for(let i = 1, l = positionAttribute.count; i < l; i++){
                $9014d97cd777be10$var$_start$1.fromBufferAttribute(positionAttribute, i - 1);
                $9014d97cd777be10$var$_end$1.fromBufferAttribute(positionAttribute, i);
                lineDistances[i] = lineDistances[i - 1];
                lineDistances[i] += $9014d97cd777be10$var$_start$1.distanceTo($9014d97cd777be10$var$_end$1);
            }
            geometry.setAttribute("lineDistance", new $9014d97cd777be10$export$cbe7a62641830ebd(lineDistances, 1));
        } else console.warn("THREE.Line.computeLineDistances(): Computation only possible with non-indexed BufferGeometry.");
        return this;
    }
    raycast(raycaster, intersects) {
        const geometry = this.geometry;
        const matrixWorld = this.matrixWorld;
        const threshold = raycaster.params.Line.threshold;
        const drawRange = geometry.drawRange;
        // Checking boundingSphere distance to ray
        if (geometry.boundingSphere === null) geometry.computeBoundingSphere();
        $9014d97cd777be10$var$_sphere$1.copy(geometry.boundingSphere);
        $9014d97cd777be10$var$_sphere$1.applyMatrix4(matrixWorld);
        $9014d97cd777be10$var$_sphere$1.radius += threshold;
        if (raycaster.ray.intersectsSphere($9014d97cd777be10$var$_sphere$1) === false) return;
        //
        $9014d97cd777be10$var$_inverseMatrix$1.copy(matrixWorld).invert();
        $9014d97cd777be10$var$_ray$1.copy(raycaster.ray).applyMatrix4($9014d97cd777be10$var$_inverseMatrix$1);
        const localThreshold = threshold / ((this.scale.x + this.scale.y + this.scale.z) / 3);
        const localThresholdSq = localThreshold * localThreshold;
        const vStart = new $9014d97cd777be10$export$64b5c384219d3699();
        const vEnd = new $9014d97cd777be10$export$64b5c384219d3699();
        const interSegment = new $9014d97cd777be10$export$64b5c384219d3699();
        const interRay = new $9014d97cd777be10$export$64b5c384219d3699();
        const step = this.isLineSegments ? 2 : 1;
        const index = geometry.index;
        const attributes = geometry.attributes;
        const positionAttribute = attributes.position;
        if (index !== null) {
            const start = Math.max(0, drawRange.start);
            const end = Math.min(index.count, drawRange.start + drawRange.count);
            for(let i = start, l = end - 1; i < l; i += step){
                const a = index.getX(i);
                const b = index.getX(i + 1);
                vStart.fromBufferAttribute(positionAttribute, a);
                vEnd.fromBufferAttribute(positionAttribute, b);
                const distSq = $9014d97cd777be10$var$_ray$1.distanceSqToSegment(vStart, vEnd, interRay, interSegment);
                if (distSq > localThresholdSq) continue;
                interRay.applyMatrix4(this.matrixWorld); //Move back to world space for distance calculation
                const distance = raycaster.ray.origin.distanceTo(interRay);
                if (distance < raycaster.near || distance > raycaster.far) continue;
                intersects.push({
                    distance: distance,
                    // What do we want? intersection point on the ray or on the segment??
                    // point: raycaster.ray.at( distance ),
                    point: interSegment.clone().applyMatrix4(this.matrixWorld),
                    index: i,
                    face: null,
                    faceIndex: null,
                    object: this
                });
            }
        } else {
            const start = Math.max(0, drawRange.start);
            const end = Math.min(positionAttribute.count, drawRange.start + drawRange.count);
            for(let i = start, l = end - 1; i < l; i += step){
                vStart.fromBufferAttribute(positionAttribute, i);
                vEnd.fromBufferAttribute(positionAttribute, i + 1);
                const distSq = $9014d97cd777be10$var$_ray$1.distanceSqToSegment(vStart, vEnd, interRay, interSegment);
                if (distSq > localThresholdSq) continue;
                interRay.applyMatrix4(this.matrixWorld); //Move back to world space for distance calculation
                const distance = raycaster.ray.origin.distanceTo(interRay);
                if (distance < raycaster.near || distance > raycaster.far) continue;
                intersects.push({
                    distance: distance,
                    // What do we want? intersection point on the ray or on the segment??
                    // point: raycaster.ray.at( distance ),
                    point: interSegment.clone().applyMatrix4(this.matrixWorld),
                    index: i,
                    face: null,
                    faceIndex: null,
                    object: this
                });
            }
        }
    }
    updateMorphTargets() {
        const geometry = this.geometry;
        const morphAttributes = geometry.morphAttributes;
        const keys = Object.keys(morphAttributes);
        if (keys.length > 0) {
            const morphAttribute = morphAttributes[keys[0]];
            if (morphAttribute !== undefined) {
                this.morphTargetInfluences = [];
                this.morphTargetDictionary = {};
                for(let m = 0, ml = morphAttribute.length; m < ml; m++){
                    const name = morphAttribute[m].name || String(m);
                    this.morphTargetInfluences.push(0);
                    this.morphTargetDictionary[name] = m;
                }
            }
        }
    }
    constructor(geometry = new $9014d97cd777be10$export$b7be63a67df8959(), material = new $9014d97cd777be10$export$fbaaa33907730a0c()){
        super();
        this.isLine = true;
        this.type = "Line";
        this.geometry = geometry;
        this.material = material;
        this.updateMorphTargets();
    }
}
const $9014d97cd777be10$var$_start = /*@__PURE__*/ new $9014d97cd777be10$export$64b5c384219d3699();
const $9014d97cd777be10$var$_end = /*@__PURE__*/ new $9014d97cd777be10$export$64b5c384219d3699();
class $9014d97cd777be10$export$ff1ed10fedfdd604 extends $9014d97cd777be10$export$17d680238e50603e {
    computeLineDistances() {
        const geometry = this.geometry;
        // we assume non-indexed geometry
        if (geometry.index === null) {
            const positionAttribute = geometry.attributes.position;
            const lineDistances = [];
            for(let i = 0, l = positionAttribute.count; i < l; i += 2){
                $9014d97cd777be10$var$_start.fromBufferAttribute(positionAttribute, i);
                $9014d97cd777be10$var$_end.fromBufferAttribute(positionAttribute, i + 1);
                lineDistances[i] = i === 0 ? 0 : lineDistances[i - 1];
                lineDistances[i + 1] = lineDistances[i] + $9014d97cd777be10$var$_start.distanceTo($9014d97cd777be10$var$_end);
            }
            geometry.setAttribute("lineDistance", new $9014d97cd777be10$export$cbe7a62641830ebd(lineDistances, 1));
        } else console.warn("THREE.LineSegments.computeLineDistances(): Computation only possible with non-indexed BufferGeometry.");
        return this;
    }
    constructor(geometry, material){
        super(geometry, material);
        this.isLineSegments = true;
        this.type = "LineSegments";
    }
}
class $9014d97cd777be10$export$f85a24d745e4f17d extends $9014d97cd777be10$export$17d680238e50603e {
    constructor(geometry, material){
        super(geometry, material);
        this.isLineLoop = true;
        this.type = "LineLoop";
    }
}
class $9014d97cd777be10$export$a178c45366ce5d6b extends $9014d97cd777be10$export$a2d8b23205c25948 {
    copy(source) {
        super.copy(source);
        this.color.copy(source.color);
        this.map = source.map;
        this.alphaMap = source.alphaMap;
        this.size = source.size;
        this.sizeAttenuation = source.sizeAttenuation;
        this.fog = source.fog;
        return this;
    }
    constructor(parameters){
        super();
        this.isPointsMaterial = true;
        this.type = "PointsMaterial";
        this.color = new $9014d97cd777be10$export$892596cec99bc70e(0xffffff);
        this.map = null;
        this.alphaMap = null;
        this.size = 1;
        this.sizeAttenuation = true;
        this.fog = true;
        this.setValues(parameters);
    }
}
const $9014d97cd777be10$var$_inverseMatrix = /*@__PURE__*/ new $9014d97cd777be10$export$2ae72fc923e5eb5();
const $9014d97cd777be10$var$_ray = /*@__PURE__*/ new $9014d97cd777be10$export$a186db52eed6d40e();
const $9014d97cd777be10$var$_sphere = /*@__PURE__*/ new $9014d97cd777be10$export$805e8b72413ccaba();
const $9014d97cd777be10$var$_position$2 = /*@__PURE__*/ new $9014d97cd777be10$export$64b5c384219d3699();
class $9014d97cd777be10$export$1c787534cb11aa3e extends $9014d97cd777be10$export$e4dd07dff30cc924 {
    copy(source, recursive) {
        super.copy(source, recursive);
        this.material = source.material;
        this.geometry = source.geometry;
        return this;
    }
    raycast(raycaster, intersects) {
        const geometry = this.geometry;
        const matrixWorld = this.matrixWorld;
        const threshold = raycaster.params.Points.threshold;
        const drawRange = geometry.drawRange;
        // Checking boundingSphere distance to ray
        if (geometry.boundingSphere === null) geometry.computeBoundingSphere();
        $9014d97cd777be10$var$_sphere.copy(geometry.boundingSphere);
        $9014d97cd777be10$var$_sphere.applyMatrix4(matrixWorld);
        $9014d97cd777be10$var$_sphere.radius += threshold;
        if (raycaster.ray.intersectsSphere($9014d97cd777be10$var$_sphere) === false) return;
        //
        $9014d97cd777be10$var$_inverseMatrix.copy(matrixWorld).invert();
        $9014d97cd777be10$var$_ray.copy(raycaster.ray).applyMatrix4($9014d97cd777be10$var$_inverseMatrix);
        const localThreshold = threshold / ((this.scale.x + this.scale.y + this.scale.z) / 3);
        const localThresholdSq = localThreshold * localThreshold;
        const index = geometry.index;
        const attributes = geometry.attributes;
        const positionAttribute = attributes.position;
        if (index !== null) {
            const start = Math.max(0, drawRange.start);
            const end = Math.min(index.count, drawRange.start + drawRange.count);
            for(let i = start, il = end; i < il; i++){
                const a = index.getX(i);
                $9014d97cd777be10$var$_position$2.fromBufferAttribute(positionAttribute, a);
                $9014d97cd777be10$var$testPoint($9014d97cd777be10$var$_position$2, a, localThresholdSq, matrixWorld, raycaster, intersects, this);
            }
        } else {
            const start = Math.max(0, drawRange.start);
            const end = Math.min(positionAttribute.count, drawRange.start + drawRange.count);
            for(let i = start, l = end; i < l; i++){
                $9014d97cd777be10$var$_position$2.fromBufferAttribute(positionAttribute, i);
                $9014d97cd777be10$var$testPoint($9014d97cd777be10$var$_position$2, i, localThresholdSq, matrixWorld, raycaster, intersects, this);
            }
        }
    }
    updateMorphTargets() {
        const geometry = this.geometry;
        const morphAttributes = geometry.morphAttributes;
        const keys = Object.keys(morphAttributes);
        if (keys.length > 0) {
            const morphAttribute = morphAttributes[keys[0]];
            if (morphAttribute !== undefined) {
                this.morphTargetInfluences = [];
                this.morphTargetDictionary = {};
                for(let m = 0, ml = morphAttribute.length; m < ml; m++){
                    const name = morphAttribute[m].name || String(m);
                    this.morphTargetInfluences.push(0);
                    this.morphTargetDictionary[name] = m;
                }
            }
        }
    }
    constructor(geometry = new $9014d97cd777be10$export$b7be63a67df8959(), material = new $9014d97cd777be10$export$a178c45366ce5d6b()){
        super();
        this.isPoints = true;
        this.type = "Points";
        this.geometry = geometry;
        this.material = material;
        this.updateMorphTargets();
    }
}
function $9014d97cd777be10$var$testPoint(point, index, localThresholdSq, matrixWorld, raycaster, intersects, object) {
    const rayPointDistanceSq = $9014d97cd777be10$var$_ray.distanceSqToPoint(point);
    if (rayPointDistanceSq < localThresholdSq) {
        const intersectPoint = new $9014d97cd777be10$export$64b5c384219d3699();
        $9014d97cd777be10$var$_ray.closestPointToPoint(point, intersectPoint);
        intersectPoint.applyMatrix4(matrixWorld);
        const distance = raycaster.ray.origin.distanceTo(intersectPoint);
        if (distance < raycaster.near || distance > raycaster.far) return;
        intersects.push({
            distance: distance,
            distanceToRay: Math.sqrt(rayPointDistanceSq),
            point: intersectPoint,
            index: index,
            face: null,
            object: object
        });
    }
}
class $9014d97cd777be10$export$6e09d1edf8d5a25c extends $9014d97cd777be10$export$5431306cf43de24a {
    clone() {
        return new this.constructor(this.image).copy(this);
    }
    update() {
        const video = this.image;
        const hasVideoFrameCallback = "requestVideoFrameCallback" in video;
        if (hasVideoFrameCallback === false && video.readyState >= video.HAVE_CURRENT_DATA) this.needsUpdate = true;
    }
    constructor(video, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy){
        super(video, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy);
        this.isVideoTexture = true;
        this.minFilter = minFilter !== undefined ? minFilter : $9014d97cd777be10$export$8a72f490b25c56c8;
        this.magFilter = magFilter !== undefined ? magFilter : $9014d97cd777be10$export$8a72f490b25c56c8;
        this.generateMipmaps = false;
        const scope = this;
        function updateVideo() {
            scope.needsUpdate = true;
            video.requestVideoFrameCallback(updateVideo);
        }
        if ("requestVideoFrameCallback" in video) video.requestVideoFrameCallback(updateVideo);
    }
}
class $9014d97cd777be10$export$9270d786f73ce6fe extends $9014d97cd777be10$export$5431306cf43de24a {
    constructor(width, height){
        super({
            width: width,
            height: height
        });
        this.isFramebufferTexture = true;
        this.magFilter = $9014d97cd777be10$export$727aa5ec3fe39bf0;
        this.minFilter = $9014d97cd777be10$export$727aa5ec3fe39bf0;
        this.generateMipmaps = false;
        this.needsUpdate = true;
    }
}
class $9014d97cd777be10$export$3466bac9141a5cc4 extends $9014d97cd777be10$export$5431306cf43de24a {
    constructor(mipmaps, width, height, format, type, mapping, wrapS, wrapT, magFilter, minFilter, anisotropy, colorSpace1){
        super(null, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy, colorSpace1);
        this.isCompressedTexture = true;
        this.image = {
            width: width,
            height: height
        };
        this.mipmaps = mipmaps;
        // no flipping for cube textures
        // (also flipping doesn't work for compressed textures )
        this.flipY = false;
        // can't generate mipmaps for compressed textures
        // mips must be embedded in DDS files
        this.generateMipmaps = false;
    }
}
class $9014d97cd777be10$export$5fe6b8e34b274fcb extends $9014d97cd777be10$export$3466bac9141a5cc4 {
    constructor(mipmaps, width, height, depth, format, type){
        super(mipmaps, width, height, format, type);
        this.isCompressedArrayTexture = true;
        this.image.depth = depth;
        this.wrapR = $9014d97cd777be10$export$9d9334239a5a5e06;
    }
}
class $9014d97cd777be10$export$d80173634de65bff extends $9014d97cd777be10$export$3466bac9141a5cc4 {
    constructor(images, format, type){
        super(undefined, images[0].width, images[0].height, format, type, $9014d97cd777be10$export$8759762a6477f2c4);
        this.isCompressedCubeTexture = true;
        this.isCubeTexture = true;
        this.image = images;
    }
}
class $9014d97cd777be10$export$f7189e49152d1c13 extends $9014d97cd777be10$export$5431306cf43de24a {
    constructor(canvas, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy){
        super(canvas, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy);
        this.isCanvasTexture = true;
        this.needsUpdate = true;
    }
}
/**
 * Extensible curve object.
 *
 * Some common of curve methods:
 * .getPoint( t, optionalTarget ), .getTangent( t, optionalTarget )
 * .getPointAt( u, optionalTarget ), .getTangentAt( u, optionalTarget )
 * .getPoints(), .getSpacedPoints()
 * .getLength()
 * .updateArcLengths()
 *
 * This following curves inherit from THREE.Curve:
 *
 * -- 2D curves --
 * THREE.ArcCurve
 * THREE.CubicBezierCurve
 * THREE.EllipseCurve
 * THREE.LineCurve
 * THREE.QuadraticBezierCurve
 * THREE.SplineCurve
 *
 * -- 3D curves --
 * THREE.CatmullRomCurve3
 * THREE.CubicBezierCurve3
 * THREE.LineCurve3
 * THREE.QuadraticBezierCurve3
 *
 * A series of curves can be represented as a THREE.CurvePath.
 *
 **/ class $9014d97cd777be10$export$b0e83c3ef8d2db1 {
    // Virtual base class method to overwrite and implement in subclasses
    //	- t [0 .. 1]
    getPoint() {
        console.warn("THREE.Curve: .getPoint() not implemented.");
        return null;
    }
    // Get point at relative position in curve according to arc length
    // - u [0 .. 1]
    getPointAt(u, optionalTarget) {
        const t = this.getUtoTmapping(u);
        return this.getPoint(t, optionalTarget);
    }
    // Get sequence of points using getPoint( t )
    getPoints(divisions = 5) {
        const points = [];
        for(let d = 0; d <= divisions; d++)points.push(this.getPoint(d / divisions));
        return points;
    }
    // Get sequence of points using getPointAt( u )
    getSpacedPoints(divisions = 5) {
        const points = [];
        for(let d = 0; d <= divisions; d++)points.push(this.getPointAt(d / divisions));
        return points;
    }
    // Get total curve arc length
    getLength() {
        const lengths = this.getLengths();
        return lengths[lengths.length - 1];
    }
    // Get list of cumulative segment lengths
    getLengths(divisions = this.arcLengthDivisions) {
        if (this.cacheArcLengths && this.cacheArcLengths.length === divisions + 1 && !this.needsUpdate) return this.cacheArcLengths;
        this.needsUpdate = false;
        const cache = [];
        let current, last = this.getPoint(0);
        let sum = 0;
        cache.push(0);
        for(let p = 1; p <= divisions; p++){
            current = this.getPoint(p / divisions);
            sum += current.distanceTo(last);
            cache.push(sum);
            last = current;
        }
        this.cacheArcLengths = cache;
        return cache; // { sums: cache, sum: sum }; Sum is in the last element.
    }
    updateArcLengths() {
        this.needsUpdate = true;
        this.getLengths();
    }
    // Given u ( 0 .. 1 ), get a t to find p. This gives you points which are equidistant
    getUtoTmapping(u, distance) {
        const arcLengths = this.getLengths();
        let i = 0;
        const il = arcLengths.length;
        let targetArcLength; // The targeted u distance value to get
        if (distance) targetArcLength = distance;
        else targetArcLength = u * arcLengths[il - 1];
        // binary search for the index with largest value smaller than target u distance
        let low = 0, high = il - 1, comparison;
        while(low <= high){
            i = Math.floor(low + (high - low) / 2); // less likely to overflow, though probably not issue here, JS doesn't really have integers, all numbers are floats
            comparison = arcLengths[i] - targetArcLength;
            if (comparison < 0) low = i + 1;
            else if (comparison > 0) high = i - 1;
            else {
                high = i;
                break;
            // DONE
            }
        }
        i = high;
        if (arcLengths[i] === targetArcLength) return i / (il - 1);
        // we could get finer grain at lengths, or use simple interpolation between two points
        const lengthBefore = arcLengths[i];
        const lengthAfter = arcLengths[i + 1];
        const segmentLength = lengthAfter - lengthBefore;
        // determine where we are between the 'before' and 'after' points
        const segmentFraction = (targetArcLength - lengthBefore) / segmentLength;
        // add that fractional amount to t
        const t = (i + segmentFraction) / (il - 1);
        return t;
    }
    // Returns a unit vector tangent at t
    // In case any sub curve does not implement its tangent derivation,
    // 2 points a small delta apart will be used to find its gradient
    // which seems to give a reasonable approximation
    getTangent(t, optionalTarget) {
        const delta = 0.0001;
        let t1 = t - delta;
        let t2 = t + delta;
        // Capping in case of danger
        if (t1 < 0) t1 = 0;
        if (t2 > 1) t2 = 1;
        const pt1 = this.getPoint(t1);
        const pt2 = this.getPoint(t2);
        const tangent = optionalTarget || (pt1.isVector2 ? new $9014d97cd777be10$export$c977b3e384af9ae1() : new $9014d97cd777be10$export$64b5c384219d3699());
        tangent.copy(pt2).sub(pt1).normalize();
        return tangent;
    }
    getTangentAt(u, optionalTarget) {
        const t = this.getUtoTmapping(u);
        return this.getTangent(t, optionalTarget);
    }
    computeFrenetFrames(segments, closed) {
        // see http://www.cs.indiana.edu/pub/techreports/TR425.pdf
        const normal = new $9014d97cd777be10$export$64b5c384219d3699();
        const tangents = [];
        const normals = [];
        const binormals = [];
        const vec = new $9014d97cd777be10$export$64b5c384219d3699();
        const mat = new $9014d97cd777be10$export$2ae72fc923e5eb5();
        // compute the tangent vectors for each segment on the curve
        for(let i = 0; i <= segments; i++){
            const u = i / segments;
            tangents[i] = this.getTangentAt(u, new $9014d97cd777be10$export$64b5c384219d3699());
        }
        // select an initial normal vector perpendicular to the first tangent vector,
        // and in the direction of the minimum tangent xyz component
        normals[0] = new $9014d97cd777be10$export$64b5c384219d3699();
        binormals[0] = new $9014d97cd777be10$export$64b5c384219d3699();
        let min = Number.MAX_VALUE;
        const tx = Math.abs(tangents[0].x);
        const ty = Math.abs(tangents[0].y);
        const tz = Math.abs(tangents[0].z);
        if (tx <= min) {
            min = tx;
            normal.set(1, 0, 0);
        }
        if (ty <= min) {
            min = ty;
            normal.set(0, 1, 0);
        }
        if (tz <= min) normal.set(0, 0, 1);
        vec.crossVectors(tangents[0], normal).normalize();
        normals[0].crossVectors(tangents[0], vec);
        binormals[0].crossVectors(tangents[0], normals[0]);
        // compute the slowly-varying normal and binormal vectors for each segment on the curve
        for(let i = 1; i <= segments; i++){
            normals[i] = normals[i - 1].clone();
            binormals[i] = binormals[i - 1].clone();
            vec.crossVectors(tangents[i - 1], tangents[i]);
            if (vec.length() > Number.EPSILON) {
                vec.normalize();
                const theta = Math.acos($9014d97cd777be10$var$clamp(tangents[i - 1].dot(tangents[i]), -1, 1)); // clamp for floating pt errors
                normals[i].applyMatrix4(mat.makeRotationAxis(vec, theta));
            }
            binormals[i].crossVectors(tangents[i], normals[i]);
        }
        // if the curve is closed, postprocess the vectors so the first and last normal vectors are the same
        if (closed === true) {
            let theta = Math.acos($9014d97cd777be10$var$clamp(normals[0].dot(normals[segments]), -1, 1));
            theta /= segments;
            if (tangents[0].dot(vec.crossVectors(normals[0], normals[segments])) > 0) theta = -theta;
            for(let i = 1; i <= segments; i++){
                // twist a little...
                normals[i].applyMatrix4(mat.makeRotationAxis(tangents[i], theta * i));
                binormals[i].crossVectors(tangents[i], normals[i]);
            }
        }
        return {
            tangents: tangents,
            normals: normals,
            binormals: binormals
        };
    }
    clone() {
        return new this.constructor().copy(this);
    }
    copy(source) {
        this.arcLengthDivisions = source.arcLengthDivisions;
        return this;
    }
    toJSON() {
        const data = {
            metadata: {
                version: 4.6,
                type: "Curve",
                generator: "Curve.toJSON"
            }
        };
        data.arcLengthDivisions = this.arcLengthDivisions;
        data.type = this.type;
        return data;
    }
    fromJSON(json) {
        this.arcLengthDivisions = json.arcLengthDivisions;
        return this;
    }
    constructor(){
        this.type = "Curve";
        this.arcLengthDivisions = 200;
    }
}
class $9014d97cd777be10$export$3f87a931616cde04 extends $9014d97cd777be10$export$b0e83c3ef8d2db1 {
    getPoint(t, optionalTarget) {
        const point = optionalTarget || new $9014d97cd777be10$export$c977b3e384af9ae1();
        const twoPi = Math.PI * 2;
        let deltaAngle = this.aEndAngle - this.aStartAngle;
        const samePoints = Math.abs(deltaAngle) < Number.EPSILON;
        // ensures that deltaAngle is 0 .. 2 PI
        while(deltaAngle < 0)deltaAngle += twoPi;
        while(deltaAngle > twoPi)deltaAngle -= twoPi;
        if (deltaAngle < Number.EPSILON) {
            if (samePoints) deltaAngle = 0;
            else deltaAngle = twoPi;
        }
        if (this.aClockwise === true && !samePoints) {
            if (deltaAngle === twoPi) deltaAngle = -twoPi;
            else deltaAngle = deltaAngle - twoPi;
        }
        const angle = this.aStartAngle + t * deltaAngle;
        let x = this.aX + this.xRadius * Math.cos(angle);
        let y = this.aY + this.yRadius * Math.sin(angle);
        if (this.aRotation !== 0) {
            const cos = Math.cos(this.aRotation);
            const sin = Math.sin(this.aRotation);
            const tx = x - this.aX;
            const ty = y - this.aY;
            // Rotate the point about the center of the ellipse.
            x = tx * cos - ty * sin + this.aX;
            y = tx * sin + ty * cos + this.aY;
        }
        return point.set(x, y);
    }
    copy(source) {
        super.copy(source);
        this.aX = source.aX;
        this.aY = source.aY;
        this.xRadius = source.xRadius;
        this.yRadius = source.yRadius;
        this.aStartAngle = source.aStartAngle;
        this.aEndAngle = source.aEndAngle;
        this.aClockwise = source.aClockwise;
        this.aRotation = source.aRotation;
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.aX = this.aX;
        data.aY = this.aY;
        data.xRadius = this.xRadius;
        data.yRadius = this.yRadius;
        data.aStartAngle = this.aStartAngle;
        data.aEndAngle = this.aEndAngle;
        data.aClockwise = this.aClockwise;
        data.aRotation = this.aRotation;
        return data;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.aX = json.aX;
        this.aY = json.aY;
        this.xRadius = json.xRadius;
        this.yRadius = json.yRadius;
        this.aStartAngle = json.aStartAngle;
        this.aEndAngle = json.aEndAngle;
        this.aClockwise = json.aClockwise;
        this.aRotation = json.aRotation;
        return this;
    }
    constructor(aX = 0, aY = 0, xRadius = 1, yRadius = 1, aStartAngle = 0, aEndAngle = Math.PI * 2, aClockwise = false, aRotation = 0){
        super();
        this.isEllipseCurve = true;
        this.type = "EllipseCurve";
        this.aX = aX;
        this.aY = aY;
        this.xRadius = xRadius;
        this.yRadius = yRadius;
        this.aStartAngle = aStartAngle;
        this.aEndAngle = aEndAngle;
        this.aClockwise = aClockwise;
        this.aRotation = aRotation;
    }
}
class $9014d97cd777be10$export$b1eedc9aab6300e8 extends $9014d97cd777be10$export$3f87a931616cde04 {
    constructor(aX, aY, aRadius, aStartAngle, aEndAngle, aClockwise){
        super(aX, aY, aRadius, aRadius, aStartAngle, aEndAngle, aClockwise);
        this.isArcCurve = true;
        this.type = "ArcCurve";
    }
}
/**
 * Centripetal CatmullRom Curve - which is useful for avoiding
 * cusps and self-intersections in non-uniform catmull rom curves.
 * http://www.cemyuksel.com/research/catmullrom_param/catmullrom.pdf
 *
 * curve.type accepts centripetal(default), chordal and catmullrom
 * curve.tension is used for catmullrom which defaults to 0.5
 */ /*
Based on an optimized c++ solution in
 - http://stackoverflow.com/questions/9489736/catmull-rom-curve-with-no-cusps-and-no-self-intersections/
 - http://ideone.com/NoEbVM

This CubicPoly class could be used for reusing some variables and calculations,
but for three.js curve use, it could be possible inlined and flatten into a single function call
which can be placed in CurveUtils.
*/ function $9014d97cd777be10$var$CubicPoly() {
    let c0 = 0, c1 = 0, c2 = 0, c3 = 0;
    /*
	 * Compute coefficients for a cubic polynomial
	 *   p(s) = c0 + c1*s + c2*s^2 + c3*s^3
	 * such that
	 *   p(0) = x0, p(1) = x1
	 *  and
	 *   p'(0) = t0, p'(1) = t1.
	 */ function init(x0, x1, t0, t1) {
        c0 = x0;
        c1 = t0;
        c2 = -3 * x0 + 3 * x1 - 2 * t0 - t1;
        c3 = 2 * x0 - 2 * x1 + t0 + t1;
    }
    return {
        initCatmullRom: function(x0, x1, x2, x3, tension) {
            init(x1, x2, tension * (x2 - x0), tension * (x3 - x1));
        },
        initNonuniformCatmullRom: function(x0, x1, x2, x3, dt0, dt1, dt2) {
            // compute tangents when parameterized in [t1,t2]
            let t1 = (x1 - x0) / dt0 - (x2 - x0) / (dt0 + dt1) + (x2 - x1) / dt1;
            let t2 = (x2 - x1) / dt1 - (x3 - x1) / (dt1 + dt2) + (x3 - x2) / dt2;
            // rescale tangents for parametrization in [0,1]
            t1 *= dt1;
            t2 *= dt1;
            init(x1, x2, t1, t2);
        },
        calc: function(t) {
            const t2 = t * t;
            const t3 = t2 * t;
            return c0 + c1 * t + c2 * t2 + c3 * t3;
        }
    };
}
//
const $9014d97cd777be10$var$tmp = /*@__PURE__*/ new $9014d97cd777be10$export$64b5c384219d3699();
const $9014d97cd777be10$var$px = /*@__PURE__*/ new $9014d97cd777be10$var$CubicPoly();
const $9014d97cd777be10$var$py = /*@__PURE__*/ new $9014d97cd777be10$var$CubicPoly();
const $9014d97cd777be10$var$pz = /*@__PURE__*/ new $9014d97cd777be10$var$CubicPoly();
class $9014d97cd777be10$export$b9146b27c24b744c extends $9014d97cd777be10$export$b0e83c3ef8d2db1 {
    getPoint(t, optionalTarget = new $9014d97cd777be10$export$64b5c384219d3699()) {
        const point = optionalTarget;
        const points = this.points;
        const l = points.length;
        const p = (l - (this.closed ? 0 : 1)) * t;
        let intPoint = Math.floor(p);
        let weight = p - intPoint;
        if (this.closed) intPoint += intPoint > 0 ? 0 : (Math.floor(Math.abs(intPoint) / l) + 1) * l;
        else if (weight === 0 && intPoint === l - 1) {
            intPoint = l - 2;
            weight = 1;
        }
        let p0, p3; // 4 points (p1 & p2 defined below)
        if (this.closed || intPoint > 0) p0 = points[(intPoint - 1) % l];
        else {
            // extrapolate first point
            $9014d97cd777be10$var$tmp.subVectors(points[0], points[1]).add(points[0]);
            p0 = $9014d97cd777be10$var$tmp;
        }
        const p1 = points[intPoint % l];
        const p2 = points[(intPoint + 1) % l];
        if (this.closed || intPoint + 2 < l) p3 = points[(intPoint + 2) % l];
        else {
            // extrapolate last point
            $9014d97cd777be10$var$tmp.subVectors(points[l - 1], points[l - 2]).add(points[l - 1]);
            p3 = $9014d97cd777be10$var$tmp;
        }
        if (this.curveType === "centripetal" || this.curveType === "chordal") {
            // init Centripetal / Chordal Catmull-Rom
            const pow = this.curveType === "chordal" ? 0.5 : 0.25;
            let dt0 = Math.pow(p0.distanceToSquared(p1), pow);
            let dt1 = Math.pow(p1.distanceToSquared(p2), pow);
            let dt2 = Math.pow(p2.distanceToSquared(p3), pow);
            // safety check for repeated points
            if (dt1 < 1e-4) dt1 = 1.0;
            if (dt0 < 1e-4) dt0 = dt1;
            if (dt2 < 1e-4) dt2 = dt1;
            $9014d97cd777be10$var$px.initNonuniformCatmullRom(p0.x, p1.x, p2.x, p3.x, dt0, dt1, dt2);
            $9014d97cd777be10$var$py.initNonuniformCatmullRom(p0.y, p1.y, p2.y, p3.y, dt0, dt1, dt2);
            $9014d97cd777be10$var$pz.initNonuniformCatmullRom(p0.z, p1.z, p2.z, p3.z, dt0, dt1, dt2);
        } else if (this.curveType === "catmullrom") {
            $9014d97cd777be10$var$px.initCatmullRom(p0.x, p1.x, p2.x, p3.x, this.tension);
            $9014d97cd777be10$var$py.initCatmullRom(p0.y, p1.y, p2.y, p3.y, this.tension);
            $9014d97cd777be10$var$pz.initCatmullRom(p0.z, p1.z, p2.z, p3.z, this.tension);
        }
        point.set($9014d97cd777be10$var$px.calc(weight), $9014d97cd777be10$var$py.calc(weight), $9014d97cd777be10$var$pz.calc(weight));
        return point;
    }
    copy(source) {
        super.copy(source);
        this.points = [];
        for(let i = 0, l = source.points.length; i < l; i++){
            const point = source.points[i];
            this.points.push(point.clone());
        }
        this.closed = source.closed;
        this.curveType = source.curveType;
        this.tension = source.tension;
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.points = [];
        for(let i = 0, l = this.points.length; i < l; i++){
            const point = this.points[i];
            data.points.push(point.toArray());
        }
        data.closed = this.closed;
        data.curveType = this.curveType;
        data.tension = this.tension;
        return data;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.points = [];
        for(let i = 0, l = json.points.length; i < l; i++){
            const point = json.points[i];
            this.points.push(new $9014d97cd777be10$export$64b5c384219d3699().fromArray(point));
        }
        this.closed = json.closed;
        this.curveType = json.curveType;
        this.tension = json.tension;
        return this;
    }
    constructor(points = [], closed = false, curveType = "centripetal", tension = 0.5){
        super();
        this.isCatmullRomCurve3 = true;
        this.type = "CatmullRomCurve3";
        this.points = points;
        this.closed = closed;
        this.curveType = curveType;
        this.tension = tension;
    }
}
/**
 * Bezier Curves formulas obtained from
 * https://en.wikipedia.org/wiki/B%C3%A9zier_curve
 */ function $9014d97cd777be10$var$CatmullRom(t, p0, p1, p2, p3) {
    const v0 = (p2 - p0) * 0.5;
    const v1 = (p3 - p1) * 0.5;
    const t2 = t * t;
    const t3 = t * t2;
    return (2 * p1 - 2 * p2 + v0 + v1) * t3 + (-3 * p1 + 3 * p2 - 2 * v0 - v1) * t2 + v0 * t + p1;
}
//
function $9014d97cd777be10$var$QuadraticBezierP0(t, p) {
    const k = 1 - t;
    return k * k * p;
}
function $9014d97cd777be10$var$QuadraticBezierP1(t, p) {
    return 2 * (1 - t) * t * p;
}
function $9014d97cd777be10$var$QuadraticBezierP2(t, p) {
    return t * t * p;
}
function $9014d97cd777be10$var$QuadraticBezier(t, p0, p1, p2) {
    return $9014d97cd777be10$var$QuadraticBezierP0(t, p0) + $9014d97cd777be10$var$QuadraticBezierP1(t, p1) + $9014d97cd777be10$var$QuadraticBezierP2(t, p2);
}
//
function $9014d97cd777be10$var$CubicBezierP0(t, p) {
    const k = 1 - t;
    return k * k * k * p;
}
function $9014d97cd777be10$var$CubicBezierP1(t, p) {
    const k = 1 - t;
    return 3 * k * k * t * p;
}
function $9014d97cd777be10$var$CubicBezierP2(t, p) {
    return 3 * (1 - t) * t * t * p;
}
function $9014d97cd777be10$var$CubicBezierP3(t, p) {
    return t * t * t * p;
}
function $9014d97cd777be10$var$CubicBezier(t, p0, p1, p2, p3) {
    return $9014d97cd777be10$var$CubicBezierP0(t, p0) + $9014d97cd777be10$var$CubicBezierP1(t, p1) + $9014d97cd777be10$var$CubicBezierP2(t, p2) + $9014d97cd777be10$var$CubicBezierP3(t, p3);
}
class $9014d97cd777be10$export$e36650d36468bb39 extends $9014d97cd777be10$export$b0e83c3ef8d2db1 {
    getPoint(t, optionalTarget = new $9014d97cd777be10$export$c977b3e384af9ae1()) {
        const point = optionalTarget;
        const v0 = this.v0, v1 = this.v1, v2 = this.v2, v3 = this.v3;
        point.set($9014d97cd777be10$var$CubicBezier(t, v0.x, v1.x, v2.x, v3.x), $9014d97cd777be10$var$CubicBezier(t, v0.y, v1.y, v2.y, v3.y));
        return point;
    }
    copy(source) {
        super.copy(source);
        this.v0.copy(source.v0);
        this.v1.copy(source.v1);
        this.v2.copy(source.v2);
        this.v3.copy(source.v3);
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.v0 = this.v0.toArray();
        data.v1 = this.v1.toArray();
        data.v2 = this.v2.toArray();
        data.v3 = this.v3.toArray();
        return data;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.v0.fromArray(json.v0);
        this.v1.fromArray(json.v1);
        this.v2.fromArray(json.v2);
        this.v3.fromArray(json.v3);
        return this;
    }
    constructor(v0 = new $9014d97cd777be10$export$c977b3e384af9ae1(), v1 = new $9014d97cd777be10$export$c977b3e384af9ae1(), v2 = new $9014d97cd777be10$export$c977b3e384af9ae1(), v3 = new $9014d97cd777be10$export$c977b3e384af9ae1()){
        super();
        this.isCubicBezierCurve = true;
        this.type = "CubicBezierCurve";
        this.v0 = v0;
        this.v1 = v1;
        this.v2 = v2;
        this.v3 = v3;
    }
}
class $9014d97cd777be10$export$13d5f1c9525f246c extends $9014d97cd777be10$export$b0e83c3ef8d2db1 {
    getPoint(t, optionalTarget = new $9014d97cd777be10$export$64b5c384219d3699()) {
        const point = optionalTarget;
        const v0 = this.v0, v1 = this.v1, v2 = this.v2, v3 = this.v3;
        point.set($9014d97cd777be10$var$CubicBezier(t, v0.x, v1.x, v2.x, v3.x), $9014d97cd777be10$var$CubicBezier(t, v0.y, v1.y, v2.y, v3.y), $9014d97cd777be10$var$CubicBezier(t, v0.z, v1.z, v2.z, v3.z));
        return point;
    }
    copy(source) {
        super.copy(source);
        this.v0.copy(source.v0);
        this.v1.copy(source.v1);
        this.v2.copy(source.v2);
        this.v3.copy(source.v3);
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.v0 = this.v0.toArray();
        data.v1 = this.v1.toArray();
        data.v2 = this.v2.toArray();
        data.v3 = this.v3.toArray();
        return data;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.v0.fromArray(json.v0);
        this.v1.fromArray(json.v1);
        this.v2.fromArray(json.v2);
        this.v3.fromArray(json.v3);
        return this;
    }
    constructor(v0 = new $9014d97cd777be10$export$64b5c384219d3699(), v1 = new $9014d97cd777be10$export$64b5c384219d3699(), v2 = new $9014d97cd777be10$export$64b5c384219d3699(), v3 = new $9014d97cd777be10$export$64b5c384219d3699()){
        super();
        this.isCubicBezierCurve3 = true;
        this.type = "CubicBezierCurve3";
        this.v0 = v0;
        this.v1 = v1;
        this.v2 = v2;
        this.v3 = v3;
    }
}
class $9014d97cd777be10$export$ab2e07e76531a47e extends $9014d97cd777be10$export$b0e83c3ef8d2db1 {
    getPoint(t, optionalTarget = new $9014d97cd777be10$export$c977b3e384af9ae1()) {
        const point = optionalTarget;
        if (t === 1) point.copy(this.v2);
        else {
            point.copy(this.v2).sub(this.v1);
            point.multiplyScalar(t).add(this.v1);
        }
        return point;
    }
    // Line curve is linear, so we can overwrite default getPointAt
    getPointAt(u, optionalTarget) {
        return this.getPoint(u, optionalTarget);
    }
    getTangent(t, optionalTarget = new $9014d97cd777be10$export$c977b3e384af9ae1()) {
        return optionalTarget.subVectors(this.v2, this.v1).normalize();
    }
    getTangentAt(u, optionalTarget) {
        return this.getTangent(u, optionalTarget);
    }
    copy(source) {
        super.copy(source);
        this.v1.copy(source.v1);
        this.v2.copy(source.v2);
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.v1 = this.v1.toArray();
        data.v2 = this.v2.toArray();
        return data;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.v1.fromArray(json.v1);
        this.v2.fromArray(json.v2);
        return this;
    }
    constructor(v1 = new $9014d97cd777be10$export$c977b3e384af9ae1(), v2 = new $9014d97cd777be10$export$c977b3e384af9ae1()){
        super();
        this.isLineCurve = true;
        this.type = "LineCurve";
        this.v1 = v1;
        this.v2 = v2;
    }
}
class $9014d97cd777be10$export$1fdfd9d9cf487600 extends $9014d97cd777be10$export$b0e83c3ef8d2db1 {
    getPoint(t, optionalTarget = new $9014d97cd777be10$export$64b5c384219d3699()) {
        const point = optionalTarget;
        if (t === 1) point.copy(this.v2);
        else {
            point.copy(this.v2).sub(this.v1);
            point.multiplyScalar(t).add(this.v1);
        }
        return point;
    }
    // Line curve is linear, so we can overwrite default getPointAt
    getPointAt(u, optionalTarget) {
        return this.getPoint(u, optionalTarget);
    }
    getTangent(t, optionalTarget = new $9014d97cd777be10$export$64b5c384219d3699()) {
        return optionalTarget.subVectors(this.v2, this.v1).normalize();
    }
    getTangentAt(u, optionalTarget) {
        return this.getTangent(u, optionalTarget);
    }
    copy(source) {
        super.copy(source);
        this.v1.copy(source.v1);
        this.v2.copy(source.v2);
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.v1 = this.v1.toArray();
        data.v2 = this.v2.toArray();
        return data;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.v1.fromArray(json.v1);
        this.v2.fromArray(json.v2);
        return this;
    }
    constructor(v1 = new $9014d97cd777be10$export$64b5c384219d3699(), v2 = new $9014d97cd777be10$export$64b5c384219d3699()){
        super();
        this.isLineCurve3 = true;
        this.type = "LineCurve3";
        this.v1 = v1;
        this.v2 = v2;
    }
}
class $9014d97cd777be10$export$5938c4ee491a43ad extends $9014d97cd777be10$export$b0e83c3ef8d2db1 {
    getPoint(t, optionalTarget = new $9014d97cd777be10$export$c977b3e384af9ae1()) {
        const point = optionalTarget;
        const v0 = this.v0, v1 = this.v1, v2 = this.v2;
        point.set($9014d97cd777be10$var$QuadraticBezier(t, v0.x, v1.x, v2.x), $9014d97cd777be10$var$QuadraticBezier(t, v0.y, v1.y, v2.y));
        return point;
    }
    copy(source) {
        super.copy(source);
        this.v0.copy(source.v0);
        this.v1.copy(source.v1);
        this.v2.copy(source.v2);
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.v0 = this.v0.toArray();
        data.v1 = this.v1.toArray();
        data.v2 = this.v2.toArray();
        return data;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.v0.fromArray(json.v0);
        this.v1.fromArray(json.v1);
        this.v2.fromArray(json.v2);
        return this;
    }
    constructor(v0 = new $9014d97cd777be10$export$c977b3e384af9ae1(), v1 = new $9014d97cd777be10$export$c977b3e384af9ae1(), v2 = new $9014d97cd777be10$export$c977b3e384af9ae1()){
        super();
        this.isQuadraticBezierCurve = true;
        this.type = "QuadraticBezierCurve";
        this.v0 = v0;
        this.v1 = v1;
        this.v2 = v2;
    }
}
class $9014d97cd777be10$export$bf3f4c7e459f90fc extends $9014d97cd777be10$export$b0e83c3ef8d2db1 {
    getPoint(t, optionalTarget = new $9014d97cd777be10$export$64b5c384219d3699()) {
        const point = optionalTarget;
        const v0 = this.v0, v1 = this.v1, v2 = this.v2;
        point.set($9014d97cd777be10$var$QuadraticBezier(t, v0.x, v1.x, v2.x), $9014d97cd777be10$var$QuadraticBezier(t, v0.y, v1.y, v2.y), $9014d97cd777be10$var$QuadraticBezier(t, v0.z, v1.z, v2.z));
        return point;
    }
    copy(source) {
        super.copy(source);
        this.v0.copy(source.v0);
        this.v1.copy(source.v1);
        this.v2.copy(source.v2);
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.v0 = this.v0.toArray();
        data.v1 = this.v1.toArray();
        data.v2 = this.v2.toArray();
        return data;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.v0.fromArray(json.v0);
        this.v1.fromArray(json.v1);
        this.v2.fromArray(json.v2);
        return this;
    }
    constructor(v0 = new $9014d97cd777be10$export$64b5c384219d3699(), v1 = new $9014d97cd777be10$export$64b5c384219d3699(), v2 = new $9014d97cd777be10$export$64b5c384219d3699()){
        super();
        this.isQuadraticBezierCurve3 = true;
        this.type = "QuadraticBezierCurve3";
        this.v0 = v0;
        this.v1 = v1;
        this.v2 = v2;
    }
}
class $9014d97cd777be10$export$d3bdd77da77afc1b extends $9014d97cd777be10$export$b0e83c3ef8d2db1 {
    getPoint(t, optionalTarget = new $9014d97cd777be10$export$c977b3e384af9ae1()) {
        const point = optionalTarget;
        const points = this.points;
        const p = (points.length - 1) * t;
        const intPoint = Math.floor(p);
        const weight = p - intPoint;
        const p0 = points[intPoint === 0 ? intPoint : intPoint - 1];
        const p1 = points[intPoint];
        const p2 = points[intPoint > points.length - 2 ? points.length - 1 : intPoint + 1];
        const p3 = points[intPoint > points.length - 3 ? points.length - 1 : intPoint + 2];
        point.set($9014d97cd777be10$var$CatmullRom(weight, p0.x, p1.x, p2.x, p3.x), $9014d97cd777be10$var$CatmullRom(weight, p0.y, p1.y, p2.y, p3.y));
        return point;
    }
    copy(source) {
        super.copy(source);
        this.points = [];
        for(let i = 0, l = source.points.length; i < l; i++){
            const point = source.points[i];
            this.points.push(point.clone());
        }
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.points = [];
        for(let i = 0, l = this.points.length; i < l; i++){
            const point = this.points[i];
            data.points.push(point.toArray());
        }
        return data;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.points = [];
        for(let i = 0, l = json.points.length; i < l; i++){
            const point = json.points[i];
            this.points.push(new $9014d97cd777be10$export$c977b3e384af9ae1().fromArray(point));
        }
        return this;
    }
    constructor(points = []){
        super();
        this.isSplineCurve = true;
        this.type = "SplineCurve";
        this.points = points;
    }
}
var $9014d97cd777be10$var$Curves = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    ArcCurve: $9014d97cd777be10$export$b1eedc9aab6300e8,
    CatmullRomCurve3: $9014d97cd777be10$export$b9146b27c24b744c,
    CubicBezierCurve: $9014d97cd777be10$export$e36650d36468bb39,
    CubicBezierCurve3: $9014d97cd777be10$export$13d5f1c9525f246c,
    EllipseCurve: $9014d97cd777be10$export$3f87a931616cde04,
    LineCurve: $9014d97cd777be10$export$ab2e07e76531a47e,
    LineCurve3: $9014d97cd777be10$export$1fdfd9d9cf487600,
    QuadraticBezierCurve: $9014d97cd777be10$export$5938c4ee491a43ad,
    QuadraticBezierCurve3: $9014d97cd777be10$export$bf3f4c7e459f90fc,
    SplineCurve: $9014d97cd777be10$export$d3bdd77da77afc1b
});
/**************************************************************
 *	Curved Path - a curve path is simply a array of connected
 *  curves, but retains the api of a curve
 **************************************************************/ class $9014d97cd777be10$export$4aaf9b66af1bbf2c extends $9014d97cd777be10$export$b0e83c3ef8d2db1 {
    add(curve) {
        this.curves.push(curve);
    }
    closePath() {
        // Add a line curve if start and end of lines are not connected
        const startPoint = this.curves[0].getPoint(0);
        const endPoint = this.curves[this.curves.length - 1].getPoint(1);
        if (!startPoint.equals(endPoint)) this.curves.push(new $9014d97cd777be10$export$ab2e07e76531a47e(endPoint, startPoint));
    }
    // To get accurate point with reference to
    // entire path distance at time t,
    // following has to be done:
    // 1. Length of each sub path have to be known
    // 2. Locate and identify type of curve
    // 3. Get t for the curve
    // 4. Return curve.getPointAt(t')
    getPoint(t, optionalTarget) {
        const d = t * this.getLength();
        const curveLengths = this.getCurveLengths();
        let i = 0;
        // To think about boundaries points.
        while(i < curveLengths.length){
            if (curveLengths[i] >= d) {
                const diff = curveLengths[i] - d;
                const curve = this.curves[i];
                const segmentLength = curve.getLength();
                const u = segmentLength === 0 ? 0 : 1 - diff / segmentLength;
                return curve.getPointAt(u, optionalTarget);
            }
            i++;
        }
        return null;
    // loop where sum != 0, sum > d , sum+1 <d
    }
    // We cannot use the default THREE.Curve getPoint() with getLength() because in
    // THREE.Curve, getLength() depends on getPoint() but in THREE.CurvePath
    // getPoint() depends on getLength
    getLength() {
        const lens = this.getCurveLengths();
        return lens[lens.length - 1];
    }
    // cacheLengths must be recalculated.
    updateArcLengths() {
        this.needsUpdate = true;
        this.cacheLengths = null;
        this.getCurveLengths();
    }
    // Compute lengths and cache them
    // We cannot overwrite getLengths() because UtoT mapping uses it.
    getCurveLengths() {
        // We use cache values if curves and cache array are same length
        if (this.cacheLengths && this.cacheLengths.length === this.curves.length) return this.cacheLengths;
        // Get length of sub-curve
        // Push sums into cached array
        const lengths = [];
        let sums = 0;
        for(let i = 0, l = this.curves.length; i < l; i++){
            sums += this.curves[i].getLength();
            lengths.push(sums);
        }
        this.cacheLengths = lengths;
        return lengths;
    }
    getSpacedPoints(divisions = 40) {
        const points = [];
        for(let i = 0; i <= divisions; i++)points.push(this.getPoint(i / divisions));
        if (this.autoClose) points.push(points[0]);
        return points;
    }
    getPoints(divisions = 12) {
        const points = [];
        let last;
        for(let i = 0, curves = this.curves; i < curves.length; i++){
            const curve = curves[i];
            const resolution = curve.isEllipseCurve ? divisions * 2 : curve.isLineCurve || curve.isLineCurve3 ? 1 : curve.isSplineCurve ? divisions * curve.points.length : divisions;
            const pts = curve.getPoints(resolution);
            for(let j = 0; j < pts.length; j++){
                const point = pts[j];
                if (last && last.equals(point)) continue; // ensures no consecutive points are duplicates
                points.push(point);
                last = point;
            }
        }
        if (this.autoClose && points.length > 1 && !points[points.length - 1].equals(points[0])) points.push(points[0]);
        return points;
    }
    copy(source) {
        super.copy(source);
        this.curves = [];
        for(let i = 0, l = source.curves.length; i < l; i++){
            const curve = source.curves[i];
            this.curves.push(curve.clone());
        }
        this.autoClose = source.autoClose;
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.autoClose = this.autoClose;
        data.curves = [];
        for(let i = 0, l = this.curves.length; i < l; i++){
            const curve = this.curves[i];
            data.curves.push(curve.toJSON());
        }
        return data;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.autoClose = json.autoClose;
        this.curves = [];
        for(let i = 0, l = json.curves.length; i < l; i++){
            const curve = json.curves[i];
            this.curves.push(new $9014d97cd777be10$var$Curves[curve.type]().fromJSON(curve));
        }
        return this;
    }
    constructor(){
        super();
        this.type = "CurvePath";
        this.curves = [];
        this.autoClose = false; // Automatically closes the path
    }
}
class $9014d97cd777be10$export$4b2950bdac9b6ee9 extends $9014d97cd777be10$export$4aaf9b66af1bbf2c {
    setFromPoints(points) {
        this.moveTo(points[0].x, points[0].y);
        for(let i = 1, l = points.length; i < l; i++)this.lineTo(points[i].x, points[i].y);
        return this;
    }
    moveTo(x, y) {
        this.currentPoint.set(x, y); // TODO consider referencing vectors instead of copying?
        return this;
    }
    lineTo(x, y) {
        const curve = new $9014d97cd777be10$export$ab2e07e76531a47e(this.currentPoint.clone(), new $9014d97cd777be10$export$c977b3e384af9ae1(x, y));
        this.curves.push(curve);
        this.currentPoint.set(x, y);
        return this;
    }
    quadraticCurveTo(aCPx, aCPy, aX, aY) {
        const curve = new $9014d97cd777be10$export$5938c4ee491a43ad(this.currentPoint.clone(), new $9014d97cd777be10$export$c977b3e384af9ae1(aCPx, aCPy), new $9014d97cd777be10$export$c977b3e384af9ae1(aX, aY));
        this.curves.push(curve);
        this.currentPoint.set(aX, aY);
        return this;
    }
    bezierCurveTo(aCP1x, aCP1y, aCP2x, aCP2y, aX, aY) {
        const curve = new $9014d97cd777be10$export$e36650d36468bb39(this.currentPoint.clone(), new $9014d97cd777be10$export$c977b3e384af9ae1(aCP1x, aCP1y), new $9014d97cd777be10$export$c977b3e384af9ae1(aCP2x, aCP2y), new $9014d97cd777be10$export$c977b3e384af9ae1(aX, aY));
        this.curves.push(curve);
        this.currentPoint.set(aX, aY);
        return this;
    }
    splineThru(pts /*Array of Vector*/ ) {
        const npts = [
            this.currentPoint.clone()
        ].concat(pts);
        const curve = new $9014d97cd777be10$export$d3bdd77da77afc1b(npts);
        this.curves.push(curve);
        this.currentPoint.copy(pts[pts.length - 1]);
        return this;
    }
    arc(aX, aY, aRadius, aStartAngle, aEndAngle, aClockwise) {
        const x0 = this.currentPoint.x;
        const y0 = this.currentPoint.y;
        this.absarc(aX + x0, aY + y0, aRadius, aStartAngle, aEndAngle, aClockwise);
        return this;
    }
    absarc(aX, aY, aRadius, aStartAngle, aEndAngle, aClockwise) {
        this.absellipse(aX, aY, aRadius, aRadius, aStartAngle, aEndAngle, aClockwise);
        return this;
    }
    ellipse(aX, aY, xRadius, yRadius, aStartAngle, aEndAngle, aClockwise, aRotation) {
        const x0 = this.currentPoint.x;
        const y0 = this.currentPoint.y;
        this.absellipse(aX + x0, aY + y0, xRadius, yRadius, aStartAngle, aEndAngle, aClockwise, aRotation);
        return this;
    }
    absellipse(aX, aY, xRadius, yRadius, aStartAngle, aEndAngle, aClockwise, aRotation) {
        const curve = new $9014d97cd777be10$export$3f87a931616cde04(aX, aY, xRadius, yRadius, aStartAngle, aEndAngle, aClockwise, aRotation);
        if (this.curves.length > 0) {
            // if a previous curve is present, attempt to join
            const firstPoint = curve.getPoint(0);
            if (!firstPoint.equals(this.currentPoint)) this.lineTo(firstPoint.x, firstPoint.y);
        }
        this.curves.push(curve);
        const lastPoint = curve.getPoint(1);
        this.currentPoint.copy(lastPoint);
        return this;
    }
    copy(source) {
        super.copy(source);
        this.currentPoint.copy(source.currentPoint);
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.currentPoint = this.currentPoint.toArray();
        return data;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.currentPoint.fromArray(json.currentPoint);
        return this;
    }
    constructor(points){
        super();
        this.type = "Path";
        this.currentPoint = new $9014d97cd777be10$export$c977b3e384af9ae1();
        if (points) this.setFromPoints(points);
    }
}
class $9014d97cd777be10$export$6d839803fcd1882c extends $9014d97cd777be10$export$b7be63a67df8959 {
    copy(source) {
        super.copy(source);
        this.parameters = Object.assign({}, source.parameters);
        return this;
    }
    static fromJSON(data) {
        return new $9014d97cd777be10$export$6d839803fcd1882c(data.points, data.segments, data.phiStart, data.phiLength);
    }
    constructor(points = [
        new $9014d97cd777be10$export$c977b3e384af9ae1(0, -0.5),
        new $9014d97cd777be10$export$c977b3e384af9ae1(0.5, 0),
        new $9014d97cd777be10$export$c977b3e384af9ae1(0, 0.5)
    ], segments = 12, phiStart = 0, phiLength = Math.PI * 2){
        super();
        this.type = "LatheGeometry";
        this.parameters = {
            points: points,
            segments: segments,
            phiStart: phiStart,
            phiLength: phiLength
        };
        segments = Math.floor(segments);
        // clamp phiLength so it's in range of [ 0, 2PI ]
        phiLength = $9014d97cd777be10$var$clamp(phiLength, 0, Math.PI * 2);
        // buffers
        const indices = [];
        const vertices = [];
        const uvs = [];
        const initNormals = [];
        const normals = [];
        // helper variables
        const inverseSegments = 1.0 / segments;
        const vertex = new $9014d97cd777be10$export$64b5c384219d3699();
        const uv = new $9014d97cd777be10$export$c977b3e384af9ae1();
        const normal = new $9014d97cd777be10$export$64b5c384219d3699();
        const curNormal = new $9014d97cd777be10$export$64b5c384219d3699();
        const prevNormal = new $9014d97cd777be10$export$64b5c384219d3699();
        let dx = 0;
        let dy = 0;
        // pre-compute normals for initial "meridian"
        for(let j = 0; j <= points.length - 1; j++)switch(j){
            case 0:
                dx = points[j + 1].x - points[j].x;
                dy = points[j + 1].y - points[j].y;
                normal.x = dy * 1.0;
                normal.y = -dx;
                normal.z = dy * 0.0;
                prevNormal.copy(normal);
                normal.normalize();
                initNormals.push(normal.x, normal.y, normal.z);
                break;
            case points.length - 1:
                initNormals.push(prevNormal.x, prevNormal.y, prevNormal.z);
                break;
            default:
                dx = points[j + 1].x - points[j].x;
                dy = points[j + 1].y - points[j].y;
                normal.x = dy * 1.0;
                normal.y = -dx;
                normal.z = dy * 0.0;
                curNormal.copy(normal);
                normal.x += prevNormal.x;
                normal.y += prevNormal.y;
                normal.z += prevNormal.z;
                normal.normalize();
                initNormals.push(normal.x, normal.y, normal.z);
                prevNormal.copy(curNormal);
        }
        // generate vertices, uvs and normals
        for(let i = 0; i <= segments; i++){
            const phi = phiStart + i * inverseSegments * phiLength;
            const sin = Math.sin(phi);
            const cos = Math.cos(phi);
            for(let j = 0; j <= points.length - 1; j++){
                // vertex
                vertex.x = points[j].x * sin;
                vertex.y = points[j].y;
                vertex.z = points[j].x * cos;
                vertices.push(vertex.x, vertex.y, vertex.z);
                // uv
                uv.x = i / segments;
                uv.y = j / (points.length - 1);
                uvs.push(uv.x, uv.y);
                // normal
                const x = initNormals[3 * j + 0] * sin;
                const y = initNormals[3 * j + 1];
                const z = initNormals[3 * j + 0] * cos;
                normals.push(x, y, z);
            }
        }
        // indices
        for(let i = 0; i < segments; i++)for(let j = 0; j < points.length - 1; j++){
            const base = j + i * points.length;
            const a = base;
            const b = base + points.length;
            const c = base + points.length + 1;
            const d = base + 1;
            // faces
            indices.push(a, b, d);
            indices.push(c, d, b);
        }
        // build geometry
        this.setIndex(indices);
        this.setAttribute("position", new $9014d97cd777be10$export$cbe7a62641830ebd(vertices, 3));
        this.setAttribute("uv", new $9014d97cd777be10$export$cbe7a62641830ebd(uvs, 2));
        this.setAttribute("normal", new $9014d97cd777be10$export$cbe7a62641830ebd(normals, 3));
    }
}
class $9014d97cd777be10$export$41680e8551036033 extends $9014d97cd777be10$export$6d839803fcd1882c {
    static fromJSON(data) {
        return new $9014d97cd777be10$export$41680e8551036033(data.radius, data.length, data.capSegments, data.radialSegments);
    }
    constructor(radius = 1, length = 1, capSegments = 4, radialSegments = 8){
        const path = new $9014d97cd777be10$export$4b2950bdac9b6ee9();
        path.absarc(0, -length / 2, radius, Math.PI * 1.5, 0);
        path.absarc(0, length / 2, radius, 0, Math.PI * 0.5);
        super(path.getPoints(capSegments), radialSegments);
        this.type = "CapsuleGeometry";
        this.parameters = {
            radius: radius,
            length: length,
            capSegments: capSegments,
            radialSegments: radialSegments
        };
    }
}
class $9014d97cd777be10$export$d5c0e8d607467193 extends $9014d97cd777be10$export$b7be63a67df8959 {
    copy(source) {
        super.copy(source);
        this.parameters = Object.assign({}, source.parameters);
        return this;
    }
    static fromJSON(data) {
        return new $9014d97cd777be10$export$d5c0e8d607467193(data.radius, data.segments, data.thetaStart, data.thetaLength);
    }
    constructor(radius = 1, segments = 32, thetaStart = 0, thetaLength = Math.PI * 2){
        super();
        this.type = "CircleGeometry";
        this.parameters = {
            radius: radius,
            segments: segments,
            thetaStart: thetaStart,
            thetaLength: thetaLength
        };
        segments = Math.max(3, segments);
        // buffers
        const indices = [];
        const vertices = [];
        const normals = [];
        const uvs = [];
        // helper variables
        const vertex = new $9014d97cd777be10$export$64b5c384219d3699();
        const uv = new $9014d97cd777be10$export$c977b3e384af9ae1();
        // center point
        vertices.push(0, 0, 0);
        normals.push(0, 0, 1);
        uvs.push(0.5, 0.5);
        for(let s = 0, i = 3; s <= segments; s++, i += 3){
            const segment = thetaStart + s / segments * thetaLength;
            // vertex
            vertex.x = radius * Math.cos(segment);
            vertex.y = radius * Math.sin(segment);
            vertices.push(vertex.x, vertex.y, vertex.z);
            // normal
            normals.push(0, 0, 1);
            // uvs
            uv.x = (vertices[i] / radius + 1) / 2;
            uv.y = (vertices[i + 1] / radius + 1) / 2;
            uvs.push(uv.x, uv.y);
        }
        // indices
        for(let i = 1; i <= segments; i++)indices.push(i, i + 1, 0);
        // build geometry
        this.setIndex(indices);
        this.setAttribute("position", new $9014d97cd777be10$export$cbe7a62641830ebd(vertices, 3));
        this.setAttribute("normal", new $9014d97cd777be10$export$cbe7a62641830ebd(normals, 3));
        this.setAttribute("uv", new $9014d97cd777be10$export$cbe7a62641830ebd(uvs, 2));
    }
}
class $9014d97cd777be10$export$68f745719dbe5198 extends $9014d97cd777be10$export$b7be63a67df8959 {
    copy(source) {
        super.copy(source);
        this.parameters = Object.assign({}, source.parameters);
        return this;
    }
    static fromJSON(data) {
        return new $9014d97cd777be10$export$68f745719dbe5198(data.radiusTop, data.radiusBottom, data.height, data.radialSegments, data.heightSegments, data.openEnded, data.thetaStart, data.thetaLength);
    }
    constructor(radiusTop = 1, radiusBottom = 1, height = 1, radialSegments = 32, heightSegments = 1, openEnded = false, thetaStart = 0, thetaLength = Math.PI * 2){
        super();
        this.type = "CylinderGeometry";
        this.parameters = {
            radiusTop: radiusTop,
            radiusBottom: radiusBottom,
            height: height,
            radialSegments: radialSegments,
            heightSegments: heightSegments,
            openEnded: openEnded,
            thetaStart: thetaStart,
            thetaLength: thetaLength
        };
        const scope = this;
        radialSegments = Math.floor(radialSegments);
        heightSegments = Math.floor(heightSegments);
        // buffers
        const indices = [];
        const vertices = [];
        const normals = [];
        const uvs = [];
        // helper variables
        let index = 0;
        const indexArray = [];
        const halfHeight = height / 2;
        let groupStart = 0;
        // generate geometry
        generateTorso();
        if (openEnded === false) {
            if (radiusTop > 0) generateCap(true);
            if (radiusBottom > 0) generateCap(false);
        }
        // build geometry
        this.setIndex(indices);
        this.setAttribute("position", new $9014d97cd777be10$export$cbe7a62641830ebd(vertices, 3));
        this.setAttribute("normal", new $9014d97cd777be10$export$cbe7a62641830ebd(normals, 3));
        this.setAttribute("uv", new $9014d97cd777be10$export$cbe7a62641830ebd(uvs, 2));
        function generateTorso() {
            const normal = new $9014d97cd777be10$export$64b5c384219d3699();
            const vertex = new $9014d97cd777be10$export$64b5c384219d3699();
            let groupCount = 0;
            // this will be used to calculate the normal
            const slope = (radiusBottom - radiusTop) / height;
            // generate vertices, normals and uvs
            for(let y = 0; y <= heightSegments; y++){
                const indexRow = [];
                const v = y / heightSegments;
                // calculate the radius of the current row
                const radius = v * (radiusBottom - radiusTop) + radiusTop;
                for(let x = 0; x <= radialSegments; x++){
                    const u = x / radialSegments;
                    const theta = u * thetaLength + thetaStart;
                    const sinTheta = Math.sin(theta);
                    const cosTheta = Math.cos(theta);
                    // vertex
                    vertex.x = radius * sinTheta;
                    vertex.y = -v * height + halfHeight;
                    vertex.z = radius * cosTheta;
                    vertices.push(vertex.x, vertex.y, vertex.z);
                    // normal
                    normal.set(sinTheta, slope, cosTheta).normalize();
                    normals.push(normal.x, normal.y, normal.z);
                    // uv
                    uvs.push(u, 1 - v);
                    // save index of vertex in respective row
                    indexRow.push(index++);
                }
                // now save vertices of the row in our index array
                indexArray.push(indexRow);
            }
            // generate indices
            for(let x = 0; x < radialSegments; x++)for(let y = 0; y < heightSegments; y++){
                // we use the index array to access the correct indices
                const a = indexArray[y][x];
                const b = indexArray[y + 1][x];
                const c = indexArray[y + 1][x + 1];
                const d = indexArray[y][x + 1];
                // faces
                indices.push(a, b, d);
                indices.push(b, c, d);
                // update group counter
                groupCount += 6;
            }
            // add a group to the geometry. this will ensure multi material support
            scope.addGroup(groupStart, groupCount, 0);
            // calculate new start value for groups
            groupStart += groupCount;
        }
        function generateCap(top) {
            // save the index of the first center vertex
            const centerIndexStart = index;
            const uv = new $9014d97cd777be10$export$c977b3e384af9ae1();
            const vertex = new $9014d97cd777be10$export$64b5c384219d3699();
            let groupCount = 0;
            const radius = top === true ? radiusTop : radiusBottom;
            const sign = top === true ? 1 : -1;
            // first we generate the center vertex data of the cap.
            // because the geometry needs one set of uvs per face,
            // we must generate a center vertex per face/segment
            for(let x = 1; x <= radialSegments; x++){
                // vertex
                vertices.push(0, halfHeight * sign, 0);
                // normal
                normals.push(0, sign, 0);
                // uv
                uvs.push(0.5, 0.5);
                // increase index
                index++;
            }
            // save the index of the last center vertex
            const centerIndexEnd = index;
            // now we generate the surrounding vertices, normals and uvs
            for(let x = 0; x <= radialSegments; x++){
                const u = x / radialSegments;
                const theta = u * thetaLength + thetaStart;
                const cosTheta = Math.cos(theta);
                const sinTheta = Math.sin(theta);
                // vertex
                vertex.x = radius * sinTheta;
                vertex.y = halfHeight * sign;
                vertex.z = radius * cosTheta;
                vertices.push(vertex.x, vertex.y, vertex.z);
                // normal
                normals.push(0, sign, 0);
                // uv
                uv.x = cosTheta * 0.5 + 0.5;
                uv.y = sinTheta * 0.5 * sign + 0.5;
                uvs.push(uv.x, uv.y);
                // increase index
                index++;
            }
            // generate indices
            for(let x = 0; x < radialSegments; x++){
                const c = centerIndexStart + x;
                const i = centerIndexEnd + x;
                if (top === true) // face top
                indices.push(i, i + 1, c);
                else // face bottom
                indices.push(i + 1, i, c);
                groupCount += 3;
            }
            // add a group to the geometry. this will ensure multi material support
            scope.addGroup(groupStart, groupCount, top === true ? 1 : 2);
            // calculate new start value for groups
            groupStart += groupCount;
        }
    }
}
class $9014d97cd777be10$export$a7a48974f285c9b3 extends $9014d97cd777be10$export$68f745719dbe5198 {
    static fromJSON(data) {
        return new $9014d97cd777be10$export$a7a48974f285c9b3(data.radius, data.height, data.radialSegments, data.heightSegments, data.openEnded, data.thetaStart, data.thetaLength);
    }
    constructor(radius = 1, height = 1, radialSegments = 32, heightSegments = 1, openEnded = false, thetaStart = 0, thetaLength = Math.PI * 2){
        super(0, radius, height, radialSegments, heightSegments, openEnded, thetaStart, thetaLength);
        this.type = "ConeGeometry";
        this.parameters = {
            radius: radius,
            height: height,
            radialSegments: radialSegments,
            heightSegments: heightSegments,
            openEnded: openEnded,
            thetaStart: thetaStart,
            thetaLength: thetaLength
        };
    }
}
class $9014d97cd777be10$export$60e57a7d3f20ff65 extends $9014d97cd777be10$export$b7be63a67df8959 {
    copy(source) {
        super.copy(source);
        this.parameters = Object.assign({}, source.parameters);
        return this;
    }
    static fromJSON(data) {
        return new $9014d97cd777be10$export$60e57a7d3f20ff65(data.vertices, data.indices, data.radius, data.details);
    }
    constructor(vertices = [], indices = [], radius = 1, detail = 0){
        super();
        this.type = "PolyhedronGeometry";
        this.parameters = {
            vertices: vertices,
            indices: indices,
            radius: radius,
            detail: detail
        };
        // default buffer data
        const vertexBuffer = [];
        const uvBuffer = [];
        // the subdivision creates the vertex buffer data
        subdivide(detail);
        // all vertices should lie on a conceptual sphere with a given radius
        applyRadius(radius);
        // finally, create the uv data
        generateUVs();
        // build non-indexed geometry
        this.setAttribute("position", new $9014d97cd777be10$export$cbe7a62641830ebd(vertexBuffer, 3));
        this.setAttribute("normal", new $9014d97cd777be10$export$cbe7a62641830ebd(vertexBuffer.slice(), 3));
        this.setAttribute("uv", new $9014d97cd777be10$export$cbe7a62641830ebd(uvBuffer, 2));
        if (detail === 0) this.computeVertexNormals(); // flat normals
        else this.normalizeNormals(); // smooth normals
        // helper functions
        function subdivide(detail) {
            const a = new $9014d97cd777be10$export$64b5c384219d3699();
            const b = new $9014d97cd777be10$export$64b5c384219d3699();
            const c = new $9014d97cd777be10$export$64b5c384219d3699();
            // iterate over all faces and apply a subdivision with the given detail value
            for(let i = 0; i < indices.length; i += 3){
                // get the vertices of the face
                getVertexByIndex(indices[i + 0], a);
                getVertexByIndex(indices[i + 1], b);
                getVertexByIndex(indices[i + 2], c);
                // perform subdivision
                subdivideFace(a, b, c, detail);
            }
        }
        function subdivideFace(a, b, c, detail) {
            const cols = detail + 1;
            // we use this multidimensional array as a data structure for creating the subdivision
            const v = [];
            // construct all of the vertices for this subdivision
            for(let i = 0; i <= cols; i++){
                v[i] = [];
                const aj = a.clone().lerp(c, i / cols);
                const bj = b.clone().lerp(c, i / cols);
                const rows = cols - i;
                for(let j = 0; j <= rows; j++)if (j === 0 && i === cols) v[i][j] = aj;
                else v[i][j] = aj.clone().lerp(bj, j / rows);
            }
            // construct all of the faces
            for(let i = 0; i < cols; i++)for(let j = 0; j < 2 * (cols - i) - 1; j++){
                const k = Math.floor(j / 2);
                if (j % 2 === 0) {
                    pushVertex(v[i][k + 1]);
                    pushVertex(v[i + 1][k]);
                    pushVertex(v[i][k]);
                } else {
                    pushVertex(v[i][k + 1]);
                    pushVertex(v[i + 1][k + 1]);
                    pushVertex(v[i + 1][k]);
                }
            }
        }
        function applyRadius(radius) {
            const vertex = new $9014d97cd777be10$export$64b5c384219d3699();
            // iterate over the entire buffer and apply the radius to each vertex
            for(let i = 0; i < vertexBuffer.length; i += 3){
                vertex.x = vertexBuffer[i + 0];
                vertex.y = vertexBuffer[i + 1];
                vertex.z = vertexBuffer[i + 2];
                vertex.normalize().multiplyScalar(radius);
                vertexBuffer[i + 0] = vertex.x;
                vertexBuffer[i + 1] = vertex.y;
                vertexBuffer[i + 2] = vertex.z;
            }
        }
        function generateUVs() {
            const vertex = new $9014d97cd777be10$export$64b5c384219d3699();
            for(let i = 0; i < vertexBuffer.length; i += 3){
                vertex.x = vertexBuffer[i + 0];
                vertex.y = vertexBuffer[i + 1];
                vertex.z = vertexBuffer[i + 2];
                const u = azimuth(vertex) / 2 / Math.PI + 0.5;
                const v = inclination(vertex) / Math.PI + 0.5;
                uvBuffer.push(u, 1 - v);
            }
            correctUVs();
            correctSeam();
        }
        function correctSeam() {
            // handle case when face straddles the seam, see #3269
            for(let i = 0; i < uvBuffer.length; i += 6){
                // uv data of a single face
                const x0 = uvBuffer[i + 0];
                const x1 = uvBuffer[i + 2];
                const x2 = uvBuffer[i + 4];
                const max = Math.max(x0, x1, x2);
                const min = Math.min(x0, x1, x2);
                // 0.9 is somewhat arbitrary
                if (max > 0.9 && min < 0.1) {
                    if (x0 < 0.2) uvBuffer[i + 0] += 1;
                    if (x1 < 0.2) uvBuffer[i + 2] += 1;
                    if (x2 < 0.2) uvBuffer[i + 4] += 1;
                }
            }
        }
        function pushVertex(vertex) {
            vertexBuffer.push(vertex.x, vertex.y, vertex.z);
        }
        function getVertexByIndex(index, vertex) {
            const stride = index * 3;
            vertex.x = vertices[stride + 0];
            vertex.y = vertices[stride + 1];
            vertex.z = vertices[stride + 2];
        }
        function correctUVs() {
            const a = new $9014d97cd777be10$export$64b5c384219d3699();
            const b = new $9014d97cd777be10$export$64b5c384219d3699();
            const c = new $9014d97cd777be10$export$64b5c384219d3699();
            const centroid = new $9014d97cd777be10$export$64b5c384219d3699();
            const uvA = new $9014d97cd777be10$export$c977b3e384af9ae1();
            const uvB = new $9014d97cd777be10$export$c977b3e384af9ae1();
            const uvC = new $9014d97cd777be10$export$c977b3e384af9ae1();
            for(let i = 0, j = 0; i < vertexBuffer.length; i += 9, j += 6){
                a.set(vertexBuffer[i + 0], vertexBuffer[i + 1], vertexBuffer[i + 2]);
                b.set(vertexBuffer[i + 3], vertexBuffer[i + 4], vertexBuffer[i + 5]);
                c.set(vertexBuffer[i + 6], vertexBuffer[i + 7], vertexBuffer[i + 8]);
                uvA.set(uvBuffer[j + 0], uvBuffer[j + 1]);
                uvB.set(uvBuffer[j + 2], uvBuffer[j + 3]);
                uvC.set(uvBuffer[j + 4], uvBuffer[j + 5]);
                centroid.copy(a).add(b).add(c).divideScalar(3);
                const azi = azimuth(centroid);
                correctUV(uvA, j + 0, a, azi);
                correctUV(uvB, j + 2, b, azi);
                correctUV(uvC, j + 4, c, azi);
            }
        }
        function correctUV(uv, stride, vector, azimuth) {
            if (azimuth < 0 && uv.x === 1) uvBuffer[stride] = uv.x - 1;
            if (vector.x === 0 && vector.z === 0) uvBuffer[stride] = azimuth / 2 / Math.PI + 0.5;
        }
        // Angle around the Y axis, counter-clockwise when looking from above.
        function azimuth(vector) {
            return Math.atan2(vector.z, -vector.x);
        }
        // Angle above the XZ plane.
        function inclination(vector) {
            return Math.atan2(-vector.y, Math.sqrt(vector.x * vector.x + vector.z * vector.z));
        }
    }
}
class $9014d97cd777be10$export$c0babfeb8708fc9c extends $9014d97cd777be10$export$60e57a7d3f20ff65 {
    static fromJSON(data) {
        return new $9014d97cd777be10$export$c0babfeb8708fc9c(data.radius, data.detail);
    }
    constructor(radius = 1, detail = 0){
        const t = (1 + Math.sqrt(5)) / 2;
        const r = 1 / t;
        const vertices = [
            // (±1, ±1, ±1)
            -1,
            -1,
            -1,
            -1,
            -1,
            1,
            -1,
            1,
            -1,
            -1,
            1,
            1,
            1,
            -1,
            -1,
            1,
            -1,
            1,
            1,
            1,
            -1,
            1,
            1,
            1,
            // (0, ±1/φ, ±φ)
            0,
            -r,
            -t,
            0,
            -r,
            t,
            0,
            r,
            -t,
            0,
            r,
            t,
            // (±1/φ, ±φ, 0)
            -r,
            -t,
            0,
            -r,
            t,
            0,
            r,
            -t,
            0,
            r,
            t,
            0,
            // (±φ, 0, ±1/φ)
            -t,
            0,
            -r,
            t,
            0,
            -r,
            -t,
            0,
            r,
            t,
            0,
            r
        ];
        const indices = [
            3,
            11,
            7,
            3,
            7,
            15,
            3,
            15,
            13,
            7,
            19,
            17,
            7,
            17,
            6,
            7,
            6,
            15,
            17,
            4,
            8,
            17,
            8,
            10,
            17,
            10,
            6,
            8,
            0,
            16,
            8,
            16,
            2,
            8,
            2,
            10,
            0,
            12,
            1,
            0,
            1,
            18,
            0,
            18,
            16,
            6,
            10,
            2,
            6,
            2,
            13,
            6,
            13,
            15,
            2,
            16,
            18,
            2,
            18,
            3,
            2,
            3,
            13,
            18,
            1,
            9,
            18,
            9,
            11,
            18,
            11,
            3,
            4,
            14,
            12,
            4,
            12,
            0,
            4,
            0,
            8,
            11,
            9,
            5,
            11,
            5,
            19,
            11,
            19,
            7,
            19,
            5,
            14,
            19,
            14,
            4,
            19,
            4,
            17,
            1,
            12,
            14,
            1,
            14,
            5,
            1,
            5,
            9
        ];
        super(vertices, indices, radius, detail);
        this.type = "DodecahedronGeometry";
        this.parameters = {
            radius: radius,
            detail: detail
        };
    }
}
const $9014d97cd777be10$var$_v0 = /*@__PURE__*/ new $9014d97cd777be10$export$64b5c384219d3699();
const $9014d97cd777be10$var$_v1$1 = /*@__PURE__*/ new $9014d97cd777be10$export$64b5c384219d3699();
const $9014d97cd777be10$var$_normal = /*@__PURE__*/ new $9014d97cd777be10$export$64b5c384219d3699();
const $9014d97cd777be10$var$_triangle = /*@__PURE__*/ new $9014d97cd777be10$export$5a465592bfe74b48();
class $9014d97cd777be10$export$4730b1542707547f extends $9014d97cd777be10$export$b7be63a67df8959 {
    copy(source) {
        super.copy(source);
        this.parameters = Object.assign({}, source.parameters);
        return this;
    }
    constructor(geometry = null, thresholdAngle = 1){
        super();
        this.type = "EdgesGeometry";
        this.parameters = {
            geometry: geometry,
            thresholdAngle: thresholdAngle
        };
        if (geometry !== null) {
            const precisionPoints = 4;
            const precision = Math.pow(10, precisionPoints);
            const thresholdDot = Math.cos($9014d97cd777be10$var$DEG2RAD * thresholdAngle);
            const indexAttr = geometry.getIndex();
            const positionAttr = geometry.getAttribute("position");
            const indexCount = indexAttr ? indexAttr.count : positionAttr.count;
            const indexArr = [
                0,
                0,
                0
            ];
            const vertKeys = [
                "a",
                "b",
                "c"
            ];
            const hashes = new Array(3);
            const edgeData = {};
            const vertices = [];
            for(let i = 0; i < indexCount; i += 3){
                if (indexAttr) {
                    indexArr[0] = indexAttr.getX(i);
                    indexArr[1] = indexAttr.getX(i + 1);
                    indexArr[2] = indexAttr.getX(i + 2);
                } else {
                    indexArr[0] = i;
                    indexArr[1] = i + 1;
                    indexArr[2] = i + 2;
                }
                const { a: a, b: b, c: c } = $9014d97cd777be10$var$_triangle;
                a.fromBufferAttribute(positionAttr, indexArr[0]);
                b.fromBufferAttribute(positionAttr, indexArr[1]);
                c.fromBufferAttribute(positionAttr, indexArr[2]);
                $9014d97cd777be10$var$_triangle.getNormal($9014d97cd777be10$var$_normal);
                // create hashes for the edge from the vertices
                hashes[0] = `${Math.round(a.x * precision)},${Math.round(a.y * precision)},${Math.round(a.z * precision)}`;
                hashes[1] = `${Math.round(b.x * precision)},${Math.round(b.y * precision)},${Math.round(b.z * precision)}`;
                hashes[2] = `${Math.round(c.x * precision)},${Math.round(c.y * precision)},${Math.round(c.z * precision)}`;
                // skip degenerate triangles
                if (hashes[0] === hashes[1] || hashes[1] === hashes[2] || hashes[2] === hashes[0]) continue;
                // iterate over every edge
                for(let j = 0; j < 3; j++){
                    // get the first and next vertex making up the edge
                    const jNext = (j + 1) % 3;
                    const vecHash0 = hashes[j];
                    const vecHash1 = hashes[jNext];
                    const v0 = $9014d97cd777be10$var$_triangle[vertKeys[j]];
                    const v1 = $9014d97cd777be10$var$_triangle[vertKeys[jNext]];
                    const hash = `${vecHash0}_${vecHash1}`;
                    const reverseHash = `${vecHash1}_${vecHash0}`;
                    if (reverseHash in edgeData && edgeData[reverseHash]) {
                        // if we found a sibling edge add it into the vertex array if
                        // it meets the angle threshold and delete the edge from the map.
                        if ($9014d97cd777be10$var$_normal.dot(edgeData[reverseHash].normal) <= thresholdDot) {
                            vertices.push(v0.x, v0.y, v0.z);
                            vertices.push(v1.x, v1.y, v1.z);
                        }
                        edgeData[reverseHash] = null;
                    } else if (!(hash in edgeData)) // if we've already got an edge here then skip adding a new one
                    edgeData[hash] = {
                        index0: indexArr[j],
                        index1: indexArr[jNext],
                        normal: $9014d97cd777be10$var$_normal.clone()
                    };
                }
            }
            // iterate over all remaining, unmatched edges and add them to the vertex array
            for(const key in edgeData)if (edgeData[key]) {
                const { index0: index0, index1: index1 } = edgeData[key];
                $9014d97cd777be10$var$_v0.fromBufferAttribute(positionAttr, index0);
                $9014d97cd777be10$var$_v1$1.fromBufferAttribute(positionAttr, index1);
                vertices.push($9014d97cd777be10$var$_v0.x, $9014d97cd777be10$var$_v0.y, $9014d97cd777be10$var$_v0.z);
                vertices.push($9014d97cd777be10$var$_v1$1.x, $9014d97cd777be10$var$_v1$1.y, $9014d97cd777be10$var$_v1$1.z);
            }
            this.setAttribute("position", new $9014d97cd777be10$export$cbe7a62641830ebd(vertices, 3));
        }
    }
}
class $9014d97cd777be10$export$6428a7f2611ef1fa extends $9014d97cd777be10$export$4b2950bdac9b6ee9 {
    getPointsHoles(divisions) {
        const holesPts = [];
        for(let i = 0, l = this.holes.length; i < l; i++)holesPts[i] = this.holes[i].getPoints(divisions);
        return holesPts;
    }
    // get points of shape and holes (keypoints based on segments parameter)
    extractPoints(divisions) {
        return {
            shape: this.getPoints(divisions),
            holes: this.getPointsHoles(divisions)
        };
    }
    copy(source) {
        super.copy(source);
        this.holes = [];
        for(let i = 0, l = source.holes.length; i < l; i++){
            const hole = source.holes[i];
            this.holes.push(hole.clone());
        }
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.uuid = this.uuid;
        data.holes = [];
        for(let i = 0, l = this.holes.length; i < l; i++){
            const hole = this.holes[i];
            data.holes.push(hole.toJSON());
        }
        return data;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.uuid = json.uuid;
        this.holes = [];
        for(let i = 0, l = json.holes.length; i < l; i++){
            const hole = json.holes[i];
            this.holes.push(new $9014d97cd777be10$export$4b2950bdac9b6ee9().fromJSON(hole));
        }
        return this;
    }
    constructor(points){
        super(points);
        this.uuid = $9014d97cd777be10$var$generateUUID();
        this.type = "Shape";
        this.holes = [];
    }
}
/**
 * Port from https://github.com/mapbox/earcut (v2.2.4)
 */ const $9014d97cd777be10$var$Earcut = {
    triangulate: function(data, holeIndices, dim = 2) {
        const hasHoles = holeIndices && holeIndices.length;
        const outerLen = hasHoles ? holeIndices[0] * dim : data.length;
        let outerNode = $9014d97cd777be10$var$linkedList(data, 0, outerLen, dim, true);
        const triangles = [];
        if (!outerNode || outerNode.next === outerNode.prev) return triangles;
        let minX, minY, maxX, maxY, x, y, invSize;
        if (hasHoles) outerNode = $9014d97cd777be10$var$eliminateHoles(data, holeIndices, outerNode, dim);
        // if the shape is not too simple, we'll use z-order curve hash later; calculate polygon bbox
        if (data.length > 80 * dim) {
            minX = maxX = data[0];
            minY = maxY = data[1];
            for(let i = dim; i < outerLen; i += dim){
                x = data[i];
                y = data[i + 1];
                if (x < minX) minX = x;
                if (y < minY) minY = y;
                if (x > maxX) maxX = x;
                if (y > maxY) maxY = y;
            }
            // minX, minY and invSize are later used to transform coords into integers for z-order calculation
            invSize = Math.max(maxX - minX, maxY - minY);
            invSize = invSize !== 0 ? 32767 / invSize : 0;
        }
        $9014d97cd777be10$var$earcutLinked(outerNode, triangles, dim, minX, minY, invSize, 0);
        return triangles;
    }
};
// create a circular doubly linked list from polygon points in the specified winding order
function $9014d97cd777be10$var$linkedList(data, start, end, dim, clockwise) {
    let i, last;
    if (clockwise === $9014d97cd777be10$var$signedArea(data, start, end, dim) > 0) for(i = start; i < end; i += dim)last = $9014d97cd777be10$var$insertNode(i, data[i], data[i + 1], last);
    else for(i = end - dim; i >= start; i -= dim)last = $9014d97cd777be10$var$insertNode(i, data[i], data[i + 1], last);
    if (last && $9014d97cd777be10$var$equals(last, last.next)) {
        $9014d97cd777be10$var$removeNode(last);
        last = last.next;
    }
    return last;
}
// eliminate colinear or duplicate points
function $9014d97cd777be10$var$filterPoints(start, end) {
    if (!start) return start;
    if (!end) end = start;
    let p = start, again;
    do {
        again = false;
        if (!p.steiner && ($9014d97cd777be10$var$equals(p, p.next) || $9014d97cd777be10$var$area(p.prev, p, p.next) === 0)) {
            $9014d97cd777be10$var$removeNode(p);
            p = end = p.prev;
            if (p === p.next) break;
            again = true;
        } else p = p.next;
    }while (again || p !== end);
    return end;
}
// main ear slicing loop which triangulates a polygon (given as a linked list)
function $9014d97cd777be10$var$earcutLinked(ear, triangles, dim, minX, minY, invSize, pass) {
    if (!ear) return;
    // interlink polygon nodes in z-order
    if (!pass && invSize) $9014d97cd777be10$var$indexCurve(ear, minX, minY, invSize);
    let stop = ear, prev, next;
    // iterate through ears, slicing them one by one
    while(ear.prev !== ear.next){
        prev = ear.prev;
        next = ear.next;
        if (invSize ? $9014d97cd777be10$var$isEarHashed(ear, minX, minY, invSize) : $9014d97cd777be10$var$isEar(ear)) {
            // cut off the triangle
            triangles.push(prev.i / dim | 0);
            triangles.push(ear.i / dim | 0);
            triangles.push(next.i / dim | 0);
            $9014d97cd777be10$var$removeNode(ear);
            // skipping the next vertex leads to less sliver triangles
            ear = next.next;
            stop = next.next;
            continue;
        }
        ear = next;
        // if we looped through the whole remaining polygon and can't find any more ears
        if (ear === stop) {
            // try filtering points and slicing again
            if (!pass) $9014d97cd777be10$var$earcutLinked($9014d97cd777be10$var$filterPoints(ear), triangles, dim, minX, minY, invSize, 1);
            else if (pass === 1) {
                ear = $9014d97cd777be10$var$cureLocalIntersections($9014d97cd777be10$var$filterPoints(ear), triangles, dim);
                $9014d97cd777be10$var$earcutLinked(ear, triangles, dim, minX, minY, invSize, 2);
            // as a last resort, try splitting the remaining polygon into two
            } else if (pass === 2) $9014d97cd777be10$var$splitEarcut(ear, triangles, dim, minX, minY, invSize);
            break;
        }
    }
}
// check whether a polygon node forms a valid ear with adjacent nodes
function $9014d97cd777be10$var$isEar(ear) {
    const a = ear.prev, b = ear, c = ear.next;
    if ($9014d97cd777be10$var$area(a, b, c) >= 0) return false; // reflex, can't be an ear
    // now make sure we don't have other points inside the potential ear
    const ax = a.x, bx = b.x, cx = c.x, ay = a.y, by = b.y, cy = c.y;
    // triangle bbox; min & max are calculated like this for speed
    const x0 = ax < bx ? ax < cx ? ax : cx : bx < cx ? bx : cx, y0 = ay < by ? ay < cy ? ay : cy : by < cy ? by : cy, x1 = ax > bx ? ax > cx ? ax : cx : bx > cx ? bx : cx, y1 = ay > by ? ay > cy ? ay : cy : by > cy ? by : cy;
    let p = c.next;
    while(p !== a){
        if (p.x >= x0 && p.x <= x1 && p.y >= y0 && p.y <= y1 && $9014d97cd777be10$var$pointInTriangle(ax, ay, bx, by, cx, cy, p.x, p.y) && $9014d97cd777be10$var$area(p.prev, p, p.next) >= 0) return false;
        p = p.next;
    }
    return true;
}
function $9014d97cd777be10$var$isEarHashed(ear, minX, minY, invSize) {
    const a = ear.prev, b = ear, c = ear.next;
    if ($9014d97cd777be10$var$area(a, b, c) >= 0) return false; // reflex, can't be an ear
    const ax = a.x, bx = b.x, cx = c.x, ay = a.y, by = b.y, cy = c.y;
    // triangle bbox; min & max are calculated like this for speed
    const x0 = ax < bx ? ax < cx ? ax : cx : bx < cx ? bx : cx, y0 = ay < by ? ay < cy ? ay : cy : by < cy ? by : cy, x1 = ax > bx ? ax > cx ? ax : cx : bx > cx ? bx : cx, y1 = ay > by ? ay > cy ? ay : cy : by > cy ? by : cy;
    // z-order range for the current triangle bbox;
    const minZ = $9014d97cd777be10$var$zOrder(x0, y0, minX, minY, invSize), maxZ = $9014d97cd777be10$var$zOrder(x1, y1, minX, minY, invSize);
    let p = ear.prevZ, n = ear.nextZ;
    // look for points inside the triangle in both directions
    while(p && p.z >= minZ && n && n.z <= maxZ){
        if (p.x >= x0 && p.x <= x1 && p.y >= y0 && p.y <= y1 && p !== a && p !== c && $9014d97cd777be10$var$pointInTriangle(ax, ay, bx, by, cx, cy, p.x, p.y) && $9014d97cd777be10$var$area(p.prev, p, p.next) >= 0) return false;
        p = p.prevZ;
        if (n.x >= x0 && n.x <= x1 && n.y >= y0 && n.y <= y1 && n !== a && n !== c && $9014d97cd777be10$var$pointInTriangle(ax, ay, bx, by, cx, cy, n.x, n.y) && $9014d97cd777be10$var$area(n.prev, n, n.next) >= 0) return false;
        n = n.nextZ;
    }
    // look for remaining points in decreasing z-order
    while(p && p.z >= minZ){
        if (p.x >= x0 && p.x <= x1 && p.y >= y0 && p.y <= y1 && p !== a && p !== c && $9014d97cd777be10$var$pointInTriangle(ax, ay, bx, by, cx, cy, p.x, p.y) && $9014d97cd777be10$var$area(p.prev, p, p.next) >= 0) return false;
        p = p.prevZ;
    }
    // look for remaining points in increasing z-order
    while(n && n.z <= maxZ){
        if (n.x >= x0 && n.x <= x1 && n.y >= y0 && n.y <= y1 && n !== a && n !== c && $9014d97cd777be10$var$pointInTriangle(ax, ay, bx, by, cx, cy, n.x, n.y) && $9014d97cd777be10$var$area(n.prev, n, n.next) >= 0) return false;
        n = n.nextZ;
    }
    return true;
}
// go through all polygon nodes and cure small local self-intersections
function $9014d97cd777be10$var$cureLocalIntersections(start, triangles, dim) {
    let p = start;
    do {
        const a = p.prev, b = p.next.next;
        if (!$9014d97cd777be10$var$equals(a, b) && $9014d97cd777be10$var$intersects(a, p, p.next, b) && $9014d97cd777be10$var$locallyInside(a, b) && $9014d97cd777be10$var$locallyInside(b, a)) {
            triangles.push(a.i / dim | 0);
            triangles.push(p.i / dim | 0);
            triangles.push(b.i / dim | 0);
            // remove two nodes involved
            $9014d97cd777be10$var$removeNode(p);
            $9014d97cd777be10$var$removeNode(p.next);
            p = start = b;
        }
        p = p.next;
    }while (p !== start);
    return $9014d97cd777be10$var$filterPoints(p);
}
// try splitting polygon into two and triangulate them independently
function $9014d97cd777be10$var$splitEarcut(start, triangles, dim, minX, minY, invSize) {
    // look for a valid diagonal that divides the polygon into two
    let a = start;
    do {
        let b = a.next.next;
        while(b !== a.prev){
            if (a.i !== b.i && $9014d97cd777be10$var$isValidDiagonal(a, b)) {
                // split the polygon in two by the diagonal
                let c = $9014d97cd777be10$var$splitPolygon(a, b);
                // filter colinear points around the cuts
                a = $9014d97cd777be10$var$filterPoints(a, a.next);
                c = $9014d97cd777be10$var$filterPoints(c, c.next);
                // run earcut on each half
                $9014d97cd777be10$var$earcutLinked(a, triangles, dim, minX, minY, invSize, 0);
                $9014d97cd777be10$var$earcutLinked(c, triangles, dim, minX, minY, invSize, 0);
                return;
            }
            b = b.next;
        }
        a = a.next;
    }while (a !== start);
}
// link every hole into the outer loop, producing a single-ring polygon without holes
function $9014d97cd777be10$var$eliminateHoles(data, holeIndices, outerNode, dim) {
    const queue = [];
    let i, len, start, end, list;
    for(i = 0, len = holeIndices.length; i < len; i++){
        start = holeIndices[i] * dim;
        end = i < len - 1 ? holeIndices[i + 1] * dim : data.length;
        list = $9014d97cd777be10$var$linkedList(data, start, end, dim, false);
        if (list === list.next) list.steiner = true;
        queue.push($9014d97cd777be10$var$getLeftmost(list));
    }
    queue.sort($9014d97cd777be10$var$compareX);
    // process holes from left to right
    for(i = 0; i < queue.length; i++)outerNode = $9014d97cd777be10$var$eliminateHole(queue[i], outerNode);
    return outerNode;
}
function $9014d97cd777be10$var$compareX(a, b) {
    return a.x - b.x;
}
// find a bridge between vertices that connects hole with an outer ring and link it
function $9014d97cd777be10$var$eliminateHole(hole, outerNode) {
    const bridge = $9014d97cd777be10$var$findHoleBridge(hole, outerNode);
    if (!bridge) return outerNode;
    const bridgeReverse = $9014d97cd777be10$var$splitPolygon(bridge, hole);
    // filter collinear points around the cuts
    $9014d97cd777be10$var$filterPoints(bridgeReverse, bridgeReverse.next);
    return $9014d97cd777be10$var$filterPoints(bridge, bridge.next);
}
// David Eberly's algorithm for finding a bridge between hole and outer polygon
function $9014d97cd777be10$var$findHoleBridge(hole, outerNode) {
    let p = outerNode, qx = -Infinity, m;
    const hx = hole.x, hy = hole.y;
    // find a segment intersected by a ray from the hole's leftmost point to the left;
    // segment's endpoint with lesser x will be potential connection point
    do {
        if (hy <= p.y && hy >= p.next.y && p.next.y !== p.y) {
            const x = p.x + (hy - p.y) * (p.next.x - p.x) / (p.next.y - p.y);
            if (x <= hx && x > qx) {
                qx = x;
                m = p.x < p.next.x ? p : p.next;
                if (x === hx) return m; // hole touches outer segment; pick leftmost endpoint
            }
        }
        p = p.next;
    }while (p !== outerNode);
    if (!m) return null;
    // look for points inside the triangle of hole point, segment intersection and endpoint;
    // if there are no points found, we have a valid connection;
    // otherwise choose the point of the minimum angle with the ray as connection point
    const stop = m, mx = m.x, my = m.y;
    let tanMin = Infinity, tan;
    p = m;
    do {
        if (hx >= p.x && p.x >= mx && hx !== p.x && $9014d97cd777be10$var$pointInTriangle(hy < my ? hx : qx, hy, mx, my, hy < my ? qx : hx, hy, p.x, p.y)) {
            tan = Math.abs(hy - p.y) / (hx - p.x); // tangential
            if ($9014d97cd777be10$var$locallyInside(p, hole) && (tan < tanMin || tan === tanMin && (p.x > m.x || p.x === m.x && $9014d97cd777be10$var$sectorContainsSector(m, p)))) {
                m = p;
                tanMin = tan;
            }
        }
        p = p.next;
    }while (p !== stop);
    return m;
}
// whether sector in vertex m contains sector in vertex p in the same coordinates
function $9014d97cd777be10$var$sectorContainsSector(m, p) {
    return $9014d97cd777be10$var$area(m.prev, m, p.prev) < 0 && $9014d97cd777be10$var$area(p.next, m, m.next) < 0;
}
// interlink polygon nodes in z-order
function $9014d97cd777be10$var$indexCurve(start, minX, minY, invSize) {
    let p = start;
    do {
        if (p.z === 0) p.z = $9014d97cd777be10$var$zOrder(p.x, p.y, minX, minY, invSize);
        p.prevZ = p.prev;
        p.nextZ = p.next;
        p = p.next;
    }while (p !== start);
    p.prevZ.nextZ = null;
    p.prevZ = null;
    $9014d97cd777be10$var$sortLinked(p);
}
// Simon Tatham's linked list merge sort algorithm
// http://www.chiark.greenend.org.uk/~sgtatham/algorithms/listsort.html
function $9014d97cd777be10$var$sortLinked(list) {
    let i, p, q, e, tail, numMerges, pSize, qSize, inSize = 1;
    do {
        p = list;
        list = null;
        tail = null;
        numMerges = 0;
        while(p){
            numMerges++;
            q = p;
            pSize = 0;
            for(i = 0; i < inSize; i++){
                pSize++;
                q = q.nextZ;
                if (!q) break;
            }
            qSize = inSize;
            while(pSize > 0 || qSize > 0 && q){
                if (pSize !== 0 && (qSize === 0 || !q || p.z <= q.z)) {
                    e = p;
                    p = p.nextZ;
                    pSize--;
                } else {
                    e = q;
                    q = q.nextZ;
                    qSize--;
                }
                if (tail) tail.nextZ = e;
                else list = e;
                e.prevZ = tail;
                tail = e;
            }
            p = q;
        }
        tail.nextZ = null;
        inSize *= 2;
    }while (numMerges > 1);
    return list;
}
// z-order of a point given coords and inverse of the longer side of data bbox
function $9014d97cd777be10$var$zOrder(x, y, minX, minY, invSize) {
    // coords are transformed into non-negative 15-bit integer range
    x = (x - minX) * invSize | 0;
    y = (y - minY) * invSize | 0;
    x = (x | x << 8) & 0x00FF00FF;
    x = (x | x << 4) & 0x0F0F0F0F;
    x = (x | x << 2) & 0x33333333;
    x = (x | x << 1) & 0x55555555;
    y = (y | y << 8) & 0x00FF00FF;
    y = (y | y << 4) & 0x0F0F0F0F;
    y = (y | y << 2) & 0x33333333;
    y = (y | y << 1) & 0x55555555;
    return x | y << 1;
}
// find the leftmost node of a polygon ring
function $9014d97cd777be10$var$getLeftmost(start) {
    let p = start, leftmost = start;
    do {
        if (p.x < leftmost.x || p.x === leftmost.x && p.y < leftmost.y) leftmost = p;
        p = p.next;
    }while (p !== start);
    return leftmost;
}
// check if a point lies within a convex triangle
function $9014d97cd777be10$var$pointInTriangle(ax, ay, bx, by, cx, cy, px, py) {
    return (cx - px) * (ay - py) >= (ax - px) * (cy - py) && (ax - px) * (by - py) >= (bx - px) * (ay - py) && (bx - px) * (cy - py) >= (cx - px) * (by - py);
}
// check if a diagonal between two polygon nodes is valid (lies in polygon interior)
function $9014d97cd777be10$var$isValidDiagonal(a, b) {
    return a.next.i !== b.i && a.prev.i !== b.i && !$9014d97cd777be10$var$intersectsPolygon(a, b) && // dones't intersect other edges
    ($9014d97cd777be10$var$locallyInside(a, b) && $9014d97cd777be10$var$locallyInside(b, a) && $9014d97cd777be10$var$middleInside(a, b) && // locally visible
    ($9014d97cd777be10$var$area(a.prev, a, b.prev) || $9014d97cd777be10$var$area(a, b.prev, b)) || // does not create opposite-facing sectors
    $9014d97cd777be10$var$equals(a, b) && $9014d97cd777be10$var$area(a.prev, a, a.next) > 0 && $9014d97cd777be10$var$area(b.prev, b, b.next) > 0); // special zero-length case
}
// signed area of a triangle
function $9014d97cd777be10$var$area(p, q, r) {
    return (q.y - p.y) * (r.x - q.x) - (q.x - p.x) * (r.y - q.y);
}
// check if two points are equal
function $9014d97cd777be10$var$equals(p1, p2) {
    return p1.x === p2.x && p1.y === p2.y;
}
// check if two segments intersect
function $9014d97cd777be10$var$intersects(p1, q1, p2, q2) {
    const o1 = $9014d97cd777be10$var$sign($9014d97cd777be10$var$area(p1, q1, p2));
    const o2 = $9014d97cd777be10$var$sign($9014d97cd777be10$var$area(p1, q1, q2));
    const o3 = $9014d97cd777be10$var$sign($9014d97cd777be10$var$area(p2, q2, p1));
    const o4 = $9014d97cd777be10$var$sign($9014d97cd777be10$var$area(p2, q2, q1));
    if (o1 !== o2 && o3 !== o4) return true; // general case
    if (o1 === 0 && $9014d97cd777be10$var$onSegment(p1, p2, q1)) return true; // p1, q1 and p2 are collinear and p2 lies on p1q1
    if (o2 === 0 && $9014d97cd777be10$var$onSegment(p1, q2, q1)) return true; // p1, q1 and q2 are collinear and q2 lies on p1q1
    if (o3 === 0 && $9014d97cd777be10$var$onSegment(p2, p1, q2)) return true; // p2, q2 and p1 are collinear and p1 lies on p2q2
    if (o4 === 0 && $9014d97cd777be10$var$onSegment(p2, q1, q2)) return true; // p2, q2 and q1 are collinear and q1 lies on p2q2
    return false;
}
// for collinear points p, q, r, check if point q lies on segment pr
function $9014d97cd777be10$var$onSegment(p, q, r) {
    return q.x <= Math.max(p.x, r.x) && q.x >= Math.min(p.x, r.x) && q.y <= Math.max(p.y, r.y) && q.y >= Math.min(p.y, r.y);
}
function $9014d97cd777be10$var$sign(num) {
    return num > 0 ? 1 : num < 0 ? -1 : 0;
}
// check if a polygon diagonal intersects any polygon segments
function $9014d97cd777be10$var$intersectsPolygon(a, b) {
    let p = a;
    do {
        if (p.i !== a.i && p.next.i !== a.i && p.i !== b.i && p.next.i !== b.i && $9014d97cd777be10$var$intersects(p, p.next, a, b)) return true;
        p = p.next;
    }while (p !== a);
    return false;
}
// check if a polygon diagonal is locally inside the polygon
function $9014d97cd777be10$var$locallyInside(a, b) {
    return $9014d97cd777be10$var$area(a.prev, a, a.next) < 0 ? $9014d97cd777be10$var$area(a, b, a.next) >= 0 && $9014d97cd777be10$var$area(a, a.prev, b) >= 0 : $9014d97cd777be10$var$area(a, b, a.prev) < 0 || $9014d97cd777be10$var$area(a, a.next, b) < 0;
}
// check if the middle point of a polygon diagonal is inside the polygon
function $9014d97cd777be10$var$middleInside(a, b) {
    let p = a, inside = false;
    const px = (a.x + b.x) / 2, py = (a.y + b.y) / 2;
    do {
        if (p.y > py !== p.next.y > py && p.next.y !== p.y && px < (p.next.x - p.x) * (py - p.y) / (p.next.y - p.y) + p.x) inside = !inside;
        p = p.next;
    }while (p !== a);
    return inside;
}
// link two polygon vertices with a bridge; if the vertices belong to the same ring, it splits polygon into two;
// if one belongs to the outer ring and another to a hole, it merges it into a single ring
function $9014d97cd777be10$var$splitPolygon(a, b) {
    const a2 = new $9014d97cd777be10$var$Node(a.i, a.x, a.y), b2 = new $9014d97cd777be10$var$Node(b.i, b.x, b.y), an = a.next, bp = b.prev;
    a.next = b;
    b.prev = a;
    a2.next = an;
    an.prev = a2;
    b2.next = a2;
    a2.prev = b2;
    bp.next = b2;
    b2.prev = bp;
    return b2;
}
// create a node and optionally link it with previous one (in a circular doubly linked list)
function $9014d97cd777be10$var$insertNode(i, x, y, last) {
    const p = new $9014d97cd777be10$var$Node(i, x, y);
    if (!last) {
        p.prev = p;
        p.next = p;
    } else {
        p.next = last.next;
        p.prev = last;
        last.next.prev = p;
        last.next = p;
    }
    return p;
}
function $9014d97cd777be10$var$removeNode(p) {
    p.next.prev = p.prev;
    p.prev.next = p.next;
    if (p.prevZ) p.prevZ.nextZ = p.nextZ;
    if (p.nextZ) p.nextZ.prevZ = p.prevZ;
}
function $9014d97cd777be10$var$Node(i, x, y) {
    // vertex index in coordinates array
    this.i = i;
    // vertex coordinates
    this.x = x;
    this.y = y;
    // previous and next vertex nodes in a polygon ring
    this.prev = null;
    this.next = null;
    // z-order curve value
    this.z = 0;
    // previous and next nodes in z-order
    this.prevZ = null;
    this.nextZ = null;
    // indicates whether this is a steiner point
    this.steiner = false;
}
function $9014d97cd777be10$var$signedArea(data, start, end, dim) {
    let sum = 0;
    for(let i = start, j = end - dim; i < end; i += dim){
        sum += (data[j] - data[i]) * (data[i + 1] + data[j + 1]);
        j = i;
    }
    return sum;
}
class $9014d97cd777be10$export$96bdf6d9c66d7ba8 {
    // calculate area of the contour polygon
    static area(contour) {
        const n = contour.length;
        let a = 0.0;
        for(let p = n - 1, q = 0; q < n; p = q++)a += contour[p].x * contour[q].y - contour[q].x * contour[p].y;
        return a * 0.5;
    }
    static isClockWise(pts) {
        return $9014d97cd777be10$export$96bdf6d9c66d7ba8.area(pts) < 0;
    }
    static triangulateShape(contour, holes) {
        const vertices = []; // flat array of vertices like [ x0,y0, x1,y1, x2,y2, ... ]
        const holeIndices = []; // array of hole indices
        const faces = []; // final array of vertex indices like [ [ a,b,d ], [ b,c,d ] ]
        $9014d97cd777be10$var$removeDupEndPts(contour);
        $9014d97cd777be10$var$addContour(vertices, contour);
        //
        let holeIndex = contour.length;
        holes.forEach($9014d97cd777be10$var$removeDupEndPts);
        for(let i = 0; i < holes.length; i++){
            holeIndices.push(holeIndex);
            holeIndex += holes[i].length;
            $9014d97cd777be10$var$addContour(vertices, holes[i]);
        }
        //
        const triangles = $9014d97cd777be10$var$Earcut.triangulate(vertices, holeIndices);
        //
        for(let i = 0; i < triangles.length; i += 3)faces.push(triangles.slice(i, i + 3));
        return faces;
    }
}
function $9014d97cd777be10$var$removeDupEndPts(points) {
    const l = points.length;
    if (l > 2 && points[l - 1].equals(points[0])) points.pop();
}
function $9014d97cd777be10$var$addContour(vertices, contour) {
    for(let i = 0; i < contour.length; i++){
        vertices.push(contour[i].x);
        vertices.push(contour[i].y);
    }
}
/**
 * Creates extruded geometry from a path shape.
 *
 * parameters = {
 *
 *  curveSegments: <int>, // number of points on the curves
 *  steps: <int>, // number of points for z-side extrusions / used for subdividing segments of extrude spline too
 *  depth: <float>, // Depth to extrude the shape
 *
 *  bevelEnabled: <bool>, // turn on bevel
 *  bevelThickness: <float>, // how deep into the original shape bevel goes
 *  bevelSize: <float>, // how far from shape outline (including bevelOffset) is bevel
 *  bevelOffset: <float>, // how far from shape outline does bevel start
 *  bevelSegments: <int>, // number of bevel layers
 *
 *  extrudePath: <THREE.Curve> // curve to extrude shape along
 *
 *  UVGenerator: <Object> // object that provides UV generator functions
 *
 * }
 */ class $9014d97cd777be10$export$598697a1efa63ca7 extends $9014d97cd777be10$export$b7be63a67df8959 {
    copy(source) {
        super.copy(source);
        this.parameters = Object.assign({}, source.parameters);
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        const shapes = this.parameters.shapes;
        const options = this.parameters.options;
        return $9014d97cd777be10$var$toJSON$1(shapes, options, data);
    }
    static fromJSON(data, shapes) {
        const geometryShapes = [];
        for(let j = 0, jl = data.shapes.length; j < jl; j++){
            const shape = shapes[data.shapes[j]];
            geometryShapes.push(shape);
        }
        const extrudePath = data.options.extrudePath;
        if (extrudePath !== undefined) data.options.extrudePath = new $9014d97cd777be10$var$Curves[extrudePath.type]().fromJSON(extrudePath);
        return new $9014d97cd777be10$export$598697a1efa63ca7(geometryShapes, data.options);
    }
    constructor(shapes = new $9014d97cd777be10$export$6428a7f2611ef1fa([
        new $9014d97cd777be10$export$c977b3e384af9ae1(0.5, 0.5),
        new $9014d97cd777be10$export$c977b3e384af9ae1(-0.5, 0.5),
        new $9014d97cd777be10$export$c977b3e384af9ae1(-0.5, -0.5),
        new $9014d97cd777be10$export$c977b3e384af9ae1(0.5, -0.5)
    ]), options = {}){
        super();
        this.type = "ExtrudeGeometry";
        this.parameters = {
            shapes: shapes,
            options: options
        };
        shapes = Array.isArray(shapes) ? shapes : [
            shapes
        ];
        const scope = this;
        const verticesArray = [];
        const uvArray = [];
        for(let i = 0, l = shapes.length; i < l; i++){
            const shape = shapes[i];
            addShape(shape);
        }
        // build geometry
        this.setAttribute("position", new $9014d97cd777be10$export$cbe7a62641830ebd(verticesArray, 3));
        this.setAttribute("uv", new $9014d97cd777be10$export$cbe7a62641830ebd(uvArray, 2));
        this.computeVertexNormals();
        // functions
        function addShape(shape) {
            const placeholder = [];
            // options
            const curveSegments = options.curveSegments !== undefined ? options.curveSegments : 12;
            const steps = options.steps !== undefined ? options.steps : 1;
            const depth = options.depth !== undefined ? options.depth : 1;
            let bevelEnabled = options.bevelEnabled !== undefined ? options.bevelEnabled : true;
            let bevelThickness = options.bevelThickness !== undefined ? options.bevelThickness : 0.2;
            let bevelSize = options.bevelSize !== undefined ? options.bevelSize : bevelThickness - 0.1;
            let bevelOffset = options.bevelOffset !== undefined ? options.bevelOffset : 0;
            let bevelSegments = options.bevelSegments !== undefined ? options.bevelSegments : 3;
            const extrudePath = options.extrudePath;
            const uvgen = options.UVGenerator !== undefined ? options.UVGenerator : $9014d97cd777be10$var$WorldUVGenerator;
            //
            let extrudePts, extrudeByPath = false;
            let splineTube, binormal, normal, position2;
            if (extrudePath) {
                extrudePts = extrudePath.getSpacedPoints(steps);
                extrudeByPath = true;
                bevelEnabled = false; // bevels not supported for path extrusion
                // SETUP TNB variables
                // TODO1 - have a .isClosed in spline?
                splineTube = extrudePath.computeFrenetFrames(steps, false);
                // console.log(splineTube, 'splineTube', splineTube.normals.length, 'steps', steps, 'extrudePts', extrudePts.length);
                binormal = new $9014d97cd777be10$export$64b5c384219d3699();
                normal = new $9014d97cd777be10$export$64b5c384219d3699();
                position2 = new $9014d97cd777be10$export$64b5c384219d3699();
            }
            // Safeguards if bevels are not enabled
            if (!bevelEnabled) {
                bevelSegments = 0;
                bevelThickness = 0;
                bevelSize = 0;
                bevelOffset = 0;
            }
            // Variables initialization
            const shapePoints = shape.extractPoints(curveSegments);
            let vertices = shapePoints.shape;
            const holes = shapePoints.holes;
            const reverse = !$9014d97cd777be10$export$96bdf6d9c66d7ba8.isClockWise(vertices);
            if (reverse) {
                vertices = vertices.reverse();
                // Maybe we should also check if holes are in the opposite direction, just to be safe ...
                for(let h = 0, hl = holes.length; h < hl; h++){
                    const ahole = holes[h];
                    if ($9014d97cd777be10$export$96bdf6d9c66d7ba8.isClockWise(ahole)) holes[h] = ahole.reverse();
                }
            }
            const faces = $9014d97cd777be10$export$96bdf6d9c66d7ba8.triangulateShape(vertices, holes);
            /* Vertices */ const contour = vertices; // vertices has all points but contour has only points of circumference
            for(let h = 0, hl = holes.length; h < hl; h++){
                const ahole = holes[h];
                vertices = vertices.concat(ahole);
            }
            function scalePt2(pt, vec, size) {
                if (!vec) console.error("THREE.ExtrudeGeometry: vec does not exist");
                return pt.clone().addScaledVector(vec, size);
            }
            const vlen = vertices.length, flen = faces.length;
            // Find directions for point movement
            function getBevelVec(inPt, inPrev, inNext) {
                // computes for inPt the corresponding point inPt' on a new contour
                //   shifted by 1 unit (length of normalized vector) to the left
                // if we walk along contour clockwise, this new contour is outside the old one
                //
                // inPt' is the intersection of the two lines parallel to the two
                //  adjacent edges of inPt at a distance of 1 unit on the left side.
                let v_trans_x, v_trans_y, shrink_by; // resulting translation vector for inPt
                // good reading for geometry algorithms (here: line-line intersection)
                // http://geomalgorithms.com/a05-_intersect-1.html
                const v_prev_x = inPt.x - inPrev.x, v_prev_y = inPt.y - inPrev.y;
                const v_next_x = inNext.x - inPt.x, v_next_y = inNext.y - inPt.y;
                const v_prev_lensq = v_prev_x * v_prev_x + v_prev_y * v_prev_y;
                // check for collinear edges
                const collinear0 = v_prev_x * v_next_y - v_prev_y * v_next_x;
                if (Math.abs(collinear0) > Number.EPSILON) {
                    // not collinear
                    // length of vectors for normalizing
                    const v_prev_len = Math.sqrt(v_prev_lensq);
                    const v_next_len = Math.sqrt(v_next_x * v_next_x + v_next_y * v_next_y);
                    // shift adjacent points by unit vectors to the left
                    const ptPrevShift_x = inPrev.x - v_prev_y / v_prev_len;
                    const ptPrevShift_y = inPrev.y + v_prev_x / v_prev_len;
                    const ptNextShift_x = inNext.x - v_next_y / v_next_len;
                    const ptNextShift_y = inNext.y + v_next_x / v_next_len;
                    // scaling factor for v_prev to intersection point
                    const sf = ((ptNextShift_x - ptPrevShift_x) * v_next_y - (ptNextShift_y - ptPrevShift_y) * v_next_x) / (v_prev_x * v_next_y - v_prev_y * v_next_x);
                    // vector from inPt to intersection point
                    v_trans_x = ptPrevShift_x + v_prev_x * sf - inPt.x;
                    v_trans_y = ptPrevShift_y + v_prev_y * sf - inPt.y;
                    // Don't normalize!, otherwise sharp corners become ugly
                    //  but prevent crazy spikes
                    const v_trans_lensq = v_trans_x * v_trans_x + v_trans_y * v_trans_y;
                    if (v_trans_lensq <= 2) return new $9014d97cd777be10$export$c977b3e384af9ae1(v_trans_x, v_trans_y);
                    else shrink_by = Math.sqrt(v_trans_lensq / 2);
                } else {
                    // handle special case of collinear edges
                    let direction_eq = false; // assumes: opposite
                    if (v_prev_x > Number.EPSILON) {
                        if (v_next_x > Number.EPSILON) direction_eq = true;
                    } else {
                        if (v_prev_x < -Number.EPSILON) {
                            if (v_next_x < -Number.EPSILON) direction_eq = true;
                        } else if (Math.sign(v_prev_y) === Math.sign(v_next_y)) direction_eq = true;
                    }
                    if (direction_eq) {
                        // console.log("Warning: lines are a straight sequence");
                        v_trans_x = -v_prev_y;
                        v_trans_y = v_prev_x;
                        shrink_by = Math.sqrt(v_prev_lensq);
                    } else {
                        // console.log("Warning: lines are a straight spike");
                        v_trans_x = v_prev_x;
                        v_trans_y = v_prev_y;
                        shrink_by = Math.sqrt(v_prev_lensq / 2);
                    }
                }
                return new $9014d97cd777be10$export$c977b3e384af9ae1(v_trans_x / shrink_by, v_trans_y / shrink_by);
            }
            const contourMovements = [];
            for(let i = 0, il = contour.length, j = il - 1, k = i + 1; i < il; i++, j++, k++){
                if (j === il) j = 0;
                if (k === il) k = 0;
                //  (j)---(i)---(k)
                // console.log('i,j,k', i, j , k)
                contourMovements[i] = getBevelVec(contour[i], contour[j], contour[k]);
            }
            const holesMovements = [];
            let oneHoleMovements, verticesMovements = contourMovements.concat();
            for(let h = 0, hl = holes.length; h < hl; h++){
                const ahole = holes[h];
                oneHoleMovements = [];
                for(let i = 0, il = ahole.length, j = il - 1, k = i + 1; i < il; i++, j++, k++){
                    if (j === il) j = 0;
                    if (k === il) k = 0;
                    //  (j)---(i)---(k)
                    oneHoleMovements[i] = getBevelVec(ahole[i], ahole[j], ahole[k]);
                }
                holesMovements.push(oneHoleMovements);
                verticesMovements = verticesMovements.concat(oneHoleMovements);
            }
            // Loop bevelSegments, 1 for the front, 1 for the back
            for(let b = 0; b < bevelSegments; b++){
                //for ( b = bevelSegments; b > 0; b -- ) {
                const t = b / bevelSegments;
                const z = bevelThickness * Math.cos(t * Math.PI / 2);
                const bs = bevelSize * Math.sin(t * Math.PI / 2) + bevelOffset;
                // contract shape
                for(let i = 0, il = contour.length; i < il; i++){
                    const vert = scalePt2(contour[i], contourMovements[i], bs);
                    v(vert.x, vert.y, -z);
                }
                // expand holes
                for(let h = 0, hl = holes.length; h < hl; h++){
                    const ahole = holes[h];
                    oneHoleMovements = holesMovements[h];
                    for(let i = 0, il = ahole.length; i < il; i++){
                        const vert = scalePt2(ahole[i], oneHoleMovements[i], bs);
                        v(vert.x, vert.y, -z);
                    }
                }
            }
            const bs = bevelSize + bevelOffset;
            // Back facing vertices
            for(let i = 0; i < vlen; i++){
                const vert = bevelEnabled ? scalePt2(vertices[i], verticesMovements[i], bs) : vertices[i];
                if (!extrudeByPath) v(vert.x, vert.y, 0);
                else {
                    // v( vert.x, vert.y + extrudePts[ 0 ].y, extrudePts[ 0 ].x );
                    normal.copy(splineTube.normals[0]).multiplyScalar(vert.x);
                    binormal.copy(splineTube.binormals[0]).multiplyScalar(vert.y);
                    position2.copy(extrudePts[0]).add(normal).add(binormal);
                    v(position2.x, position2.y, position2.z);
                }
            }
            // Add stepped vertices...
            // Including front facing vertices
            for(let s = 1; s <= steps; s++)for(let i = 0; i < vlen; i++){
                const vert = bevelEnabled ? scalePt2(vertices[i], verticesMovements[i], bs) : vertices[i];
                if (!extrudeByPath) v(vert.x, vert.y, depth / steps * s);
                else {
                    // v( vert.x, vert.y + extrudePts[ s - 1 ].y, extrudePts[ s - 1 ].x );
                    normal.copy(splineTube.normals[s]).multiplyScalar(vert.x);
                    binormal.copy(splineTube.binormals[s]).multiplyScalar(vert.y);
                    position2.copy(extrudePts[s]).add(normal).add(binormal);
                    v(position2.x, position2.y, position2.z);
                }
            }
            // Add bevel segments planes
            //for ( b = 1; b <= bevelSegments; b ++ ) {
            for(let b = bevelSegments - 1; b >= 0; b--){
                const t = b / bevelSegments;
                const z = bevelThickness * Math.cos(t * Math.PI / 2);
                const bs = bevelSize * Math.sin(t * Math.PI / 2) + bevelOffset;
                // contract shape
                for(let i = 0, il = contour.length; i < il; i++){
                    const vert = scalePt2(contour[i], contourMovements[i], bs);
                    v(vert.x, vert.y, depth + z);
                }
                // expand holes
                for(let h = 0, hl = holes.length; h < hl; h++){
                    const ahole = holes[h];
                    oneHoleMovements = holesMovements[h];
                    for(let i = 0, il = ahole.length; i < il; i++){
                        const vert = scalePt2(ahole[i], oneHoleMovements[i], bs);
                        if (!extrudeByPath) v(vert.x, vert.y, depth + z);
                        else v(vert.x, vert.y + extrudePts[steps - 1].y, extrudePts[steps - 1].x + z);
                    }
                }
            }
            /* Faces */ // Top and bottom faces
            buildLidFaces();
            // Sides faces
            buildSideFaces();
            /////  Internal functions
            function buildLidFaces() {
                const start = verticesArray.length / 3;
                if (bevelEnabled) {
                    let layer = 0; // steps + 1
                    let offset = vlen * layer;
                    // Bottom faces
                    for(let i = 0; i < flen; i++){
                        const face = faces[i];
                        f3(face[2] + offset, face[1] + offset, face[0] + offset);
                    }
                    layer = steps + bevelSegments * 2;
                    offset = vlen * layer;
                    // Top faces
                    for(let i = 0; i < flen; i++){
                        const face = faces[i];
                        f3(face[0] + offset, face[1] + offset, face[2] + offset);
                    }
                } else {
                    // Bottom faces
                    for(let i = 0; i < flen; i++){
                        const face = faces[i];
                        f3(face[2], face[1], face[0]);
                    }
                    // Top faces
                    for(let i = 0; i < flen; i++){
                        const face = faces[i];
                        f3(face[0] + vlen * steps, face[1] + vlen * steps, face[2] + vlen * steps);
                    }
                }
                scope.addGroup(start, verticesArray.length / 3 - start, 0);
            }
            // Create faces for the z-sides of the shape
            function buildSideFaces() {
                const start = verticesArray.length / 3;
                let layeroffset = 0;
                sidewalls(contour, layeroffset);
                layeroffset += contour.length;
                for(let h = 0, hl = holes.length; h < hl; h++){
                    const ahole = holes[h];
                    sidewalls(ahole, layeroffset);
                    //, true
                    layeroffset += ahole.length;
                }
                scope.addGroup(start, verticesArray.length / 3 - start, 1);
            }
            function sidewalls(contour, layeroffset) {
                let i = contour.length;
                while(--i >= 0){
                    const j = i;
                    let k = i - 1;
                    if (k < 0) k = contour.length - 1;
                    //console.log('b', i,j, i-1, k,vertices.length);
                    for(let s = 0, sl = steps + bevelSegments * 2; s < sl; s++){
                        const slen1 = vlen * s;
                        const slen2 = vlen * (s + 1);
                        const a = layeroffset + j + slen1, b = layeroffset + k + slen1, c = layeroffset + k + slen2, d = layeroffset + j + slen2;
                        f4(a, b, c, d);
                    }
                }
            }
            function v(x, y, z) {
                placeholder.push(x);
                placeholder.push(y);
                placeholder.push(z);
            }
            function f3(a, b, c) {
                addVertex(a);
                addVertex(b);
                addVertex(c);
                const nextIndex = verticesArray.length / 3;
                const uvs = uvgen.generateTopUV(scope, verticesArray, nextIndex - 3, nextIndex - 2, nextIndex - 1);
                addUV(uvs[0]);
                addUV(uvs[1]);
                addUV(uvs[2]);
            }
            function f4(a, b, c, d) {
                addVertex(a);
                addVertex(b);
                addVertex(d);
                addVertex(b);
                addVertex(c);
                addVertex(d);
                const nextIndex = verticesArray.length / 3;
                const uvs = uvgen.generateSideWallUV(scope, verticesArray, nextIndex - 6, nextIndex - 3, nextIndex - 2, nextIndex - 1);
                addUV(uvs[0]);
                addUV(uvs[1]);
                addUV(uvs[3]);
                addUV(uvs[1]);
                addUV(uvs[2]);
                addUV(uvs[3]);
            }
            function addVertex(index) {
                verticesArray.push(placeholder[index * 3 + 0]);
                verticesArray.push(placeholder[index * 3 + 1]);
                verticesArray.push(placeholder[index * 3 + 2]);
            }
            function addUV(vector2) {
                uvArray.push(vector2.x);
                uvArray.push(vector2.y);
            }
        }
    }
}
const $9014d97cd777be10$var$WorldUVGenerator = {
    generateTopUV: function(geometry, vertices, indexA, indexB, indexC) {
        const a_x = vertices[indexA * 3];
        const a_y = vertices[indexA * 3 + 1];
        const b_x = vertices[indexB * 3];
        const b_y = vertices[indexB * 3 + 1];
        const c_x = vertices[indexC * 3];
        const c_y = vertices[indexC * 3 + 1];
        return [
            new $9014d97cd777be10$export$c977b3e384af9ae1(a_x, a_y),
            new $9014d97cd777be10$export$c977b3e384af9ae1(b_x, b_y),
            new $9014d97cd777be10$export$c977b3e384af9ae1(c_x, c_y)
        ];
    },
    generateSideWallUV: function(geometry, vertices, indexA, indexB, indexC, indexD) {
        const a_x = vertices[indexA * 3];
        const a_y = vertices[indexA * 3 + 1];
        const a_z = vertices[indexA * 3 + 2];
        const b_x = vertices[indexB * 3];
        const b_y = vertices[indexB * 3 + 1];
        const b_z = vertices[indexB * 3 + 2];
        const c_x = vertices[indexC * 3];
        const c_y = vertices[indexC * 3 + 1];
        const c_z = vertices[indexC * 3 + 2];
        const d_x = vertices[indexD * 3];
        const d_y = vertices[indexD * 3 + 1];
        const d_z = vertices[indexD * 3 + 2];
        if (Math.abs(a_y - b_y) < Math.abs(a_x - b_x)) return [
            new $9014d97cd777be10$export$c977b3e384af9ae1(a_x, 1 - a_z),
            new $9014d97cd777be10$export$c977b3e384af9ae1(b_x, 1 - b_z),
            new $9014d97cd777be10$export$c977b3e384af9ae1(c_x, 1 - c_z),
            new $9014d97cd777be10$export$c977b3e384af9ae1(d_x, 1 - d_z)
        ];
        else return [
            new $9014d97cd777be10$export$c977b3e384af9ae1(a_y, 1 - a_z),
            new $9014d97cd777be10$export$c977b3e384af9ae1(b_y, 1 - b_z),
            new $9014d97cd777be10$export$c977b3e384af9ae1(c_y, 1 - c_z),
            new $9014d97cd777be10$export$c977b3e384af9ae1(d_y, 1 - d_z)
        ];
    }
};
function $9014d97cd777be10$var$toJSON$1(shapes, options, data) {
    data.shapes = [];
    if (Array.isArray(shapes)) for(let i = 0, l = shapes.length; i < l; i++){
        const shape = shapes[i];
        data.shapes.push(shape.uuid);
    }
    else data.shapes.push(shapes.uuid);
    data.options = Object.assign({}, options);
    if (options.extrudePath !== undefined) data.options.extrudePath = options.extrudePath.toJSON();
    return data;
}
class $9014d97cd777be10$export$9567cc828c9535da extends $9014d97cd777be10$export$60e57a7d3f20ff65 {
    static fromJSON(data) {
        return new $9014d97cd777be10$export$9567cc828c9535da(data.radius, data.detail);
    }
    constructor(radius = 1, detail = 0){
        const t = (1 + Math.sqrt(5)) / 2;
        const vertices = [
            -1,
            t,
            0,
            1,
            t,
            0,
            -1,
            -t,
            0,
            1,
            -t,
            0,
            0,
            -1,
            t,
            0,
            1,
            t,
            0,
            -1,
            -t,
            0,
            1,
            -t,
            t,
            0,
            -1,
            t,
            0,
            1,
            -t,
            0,
            -1,
            -t,
            0,
            1
        ];
        const indices = [
            0,
            11,
            5,
            0,
            5,
            1,
            0,
            1,
            7,
            0,
            7,
            10,
            0,
            10,
            11,
            1,
            5,
            9,
            5,
            11,
            4,
            11,
            10,
            2,
            10,
            7,
            6,
            7,
            1,
            8,
            3,
            9,
            4,
            3,
            4,
            2,
            3,
            2,
            6,
            3,
            6,
            8,
            3,
            8,
            9,
            4,
            9,
            5,
            2,
            4,
            11,
            6,
            2,
            10,
            8,
            6,
            7,
            9,
            8,
            1
        ];
        super(vertices, indices, radius, detail);
        this.type = "IcosahedronGeometry";
        this.parameters = {
            radius: radius,
            detail: detail
        };
    }
}
class $9014d97cd777be10$export$1954e2b809fe361e extends $9014d97cd777be10$export$60e57a7d3f20ff65 {
    static fromJSON(data) {
        return new $9014d97cd777be10$export$1954e2b809fe361e(data.radius, data.detail);
    }
    constructor(radius = 1, detail = 0){
        const vertices = [
            1,
            0,
            0,
            -1,
            0,
            0,
            0,
            1,
            0,
            0,
            -1,
            0,
            0,
            0,
            1,
            0,
            0,
            -1
        ];
        const indices = [
            0,
            2,
            4,
            0,
            4,
            3,
            0,
            3,
            5,
            0,
            5,
            2,
            1,
            2,
            5,
            1,
            5,
            3,
            1,
            3,
            4,
            1,
            4,
            2
        ];
        super(vertices, indices, radius, detail);
        this.type = "OctahedronGeometry";
        this.parameters = {
            radius: radius,
            detail: detail
        };
    }
}
class $9014d97cd777be10$export$68cb731f50f614af extends $9014d97cd777be10$export$b7be63a67df8959 {
    copy(source) {
        super.copy(source);
        this.parameters = Object.assign({}, source.parameters);
        return this;
    }
    static fromJSON(data) {
        return new $9014d97cd777be10$export$68cb731f50f614af(data.innerRadius, data.outerRadius, data.thetaSegments, data.phiSegments, data.thetaStart, data.thetaLength);
    }
    constructor(innerRadius = 0.5, outerRadius = 1, thetaSegments = 32, phiSegments = 1, thetaStart = 0, thetaLength = Math.PI * 2){
        super();
        this.type = "RingGeometry";
        this.parameters = {
            innerRadius: innerRadius,
            outerRadius: outerRadius,
            thetaSegments: thetaSegments,
            phiSegments: phiSegments,
            thetaStart: thetaStart,
            thetaLength: thetaLength
        };
        thetaSegments = Math.max(3, thetaSegments);
        phiSegments = Math.max(1, phiSegments);
        // buffers
        const indices = [];
        const vertices = [];
        const normals = [];
        const uvs = [];
        // some helper variables
        let radius = innerRadius;
        const radiusStep = (outerRadius - innerRadius) / phiSegments;
        const vertex = new $9014d97cd777be10$export$64b5c384219d3699();
        const uv = new $9014d97cd777be10$export$c977b3e384af9ae1();
        // generate vertices, normals and uvs
        for(let j = 0; j <= phiSegments; j++){
            for(let i = 0; i <= thetaSegments; i++){
                // values are generate from the inside of the ring to the outside
                const segment = thetaStart + i / thetaSegments * thetaLength;
                // vertex
                vertex.x = radius * Math.cos(segment);
                vertex.y = radius * Math.sin(segment);
                vertices.push(vertex.x, vertex.y, vertex.z);
                // normal
                normals.push(0, 0, 1);
                // uv
                uv.x = (vertex.x / outerRadius + 1) / 2;
                uv.y = (vertex.y / outerRadius + 1) / 2;
                uvs.push(uv.x, uv.y);
            }
            // increase the radius for next row of vertices
            radius += radiusStep;
        }
        // indices
        for(let j = 0; j < phiSegments; j++){
            const thetaSegmentLevel = j * (thetaSegments + 1);
            for(let i = 0; i < thetaSegments; i++){
                const segment = i + thetaSegmentLevel;
                const a = segment;
                const b = segment + thetaSegments + 1;
                const c = segment + thetaSegments + 2;
                const d = segment + 1;
                // faces
                indices.push(a, b, d);
                indices.push(b, c, d);
            }
        }
        // build geometry
        this.setIndex(indices);
        this.setAttribute("position", new $9014d97cd777be10$export$cbe7a62641830ebd(vertices, 3));
        this.setAttribute("normal", new $9014d97cd777be10$export$cbe7a62641830ebd(normals, 3));
        this.setAttribute("uv", new $9014d97cd777be10$export$cbe7a62641830ebd(uvs, 2));
    }
}
class $9014d97cd777be10$export$57a29a1c803e9065 extends $9014d97cd777be10$export$b7be63a67df8959 {
    copy(source) {
        super.copy(source);
        this.parameters = Object.assign({}, source.parameters);
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        const shapes = this.parameters.shapes;
        return $9014d97cd777be10$var$toJSON(shapes, data);
    }
    static fromJSON(data, shapes) {
        const geometryShapes = [];
        for(let j = 0, jl = data.shapes.length; j < jl; j++){
            const shape = shapes[data.shapes[j]];
            geometryShapes.push(shape);
        }
        return new $9014d97cd777be10$export$57a29a1c803e9065(geometryShapes, data.curveSegments);
    }
    constructor(shapes = new $9014d97cd777be10$export$6428a7f2611ef1fa([
        new $9014d97cd777be10$export$c977b3e384af9ae1(0, 0.5),
        new $9014d97cd777be10$export$c977b3e384af9ae1(-0.5, -0.5),
        new $9014d97cd777be10$export$c977b3e384af9ae1(0.5, -0.5)
    ]), curveSegments = 12){
        super();
        this.type = "ShapeGeometry";
        this.parameters = {
            shapes: shapes,
            curveSegments: curveSegments
        };
        // buffers
        const indices = [];
        const vertices = [];
        const normals = [];
        const uvs = [];
        // helper variables
        let groupStart = 0;
        let groupCount = 0;
        // allow single and array values for "shapes" parameter
        if (Array.isArray(shapes) === false) addShape(shapes);
        else for(let i = 0; i < shapes.length; i++){
            addShape(shapes[i]);
            this.addGroup(groupStart, groupCount, i); // enables MultiMaterial support
            groupStart += groupCount;
            groupCount = 0;
        }
        // build geometry
        this.setIndex(indices);
        this.setAttribute("position", new $9014d97cd777be10$export$cbe7a62641830ebd(vertices, 3));
        this.setAttribute("normal", new $9014d97cd777be10$export$cbe7a62641830ebd(normals, 3));
        this.setAttribute("uv", new $9014d97cd777be10$export$cbe7a62641830ebd(uvs, 2));
        // helper functions
        function addShape(shape) {
            const indexOffset = vertices.length / 3;
            const points = shape.extractPoints(curveSegments);
            let shapeVertices = points.shape;
            const shapeHoles = points.holes;
            // check direction of vertices
            if ($9014d97cd777be10$export$96bdf6d9c66d7ba8.isClockWise(shapeVertices) === false) shapeVertices = shapeVertices.reverse();
            for(let i = 0, l = shapeHoles.length; i < l; i++){
                const shapeHole = shapeHoles[i];
                if ($9014d97cd777be10$export$96bdf6d9c66d7ba8.isClockWise(shapeHole) === true) shapeHoles[i] = shapeHole.reverse();
            }
            const faces = $9014d97cd777be10$export$96bdf6d9c66d7ba8.triangulateShape(shapeVertices, shapeHoles);
            // join vertices of inner and outer paths to a single array
            for(let i = 0, l = shapeHoles.length; i < l; i++){
                const shapeHole = shapeHoles[i];
                shapeVertices = shapeVertices.concat(shapeHole);
            }
            // vertices, normals, uvs
            for(let i = 0, l = shapeVertices.length; i < l; i++){
                const vertex = shapeVertices[i];
                vertices.push(vertex.x, vertex.y, 0);
                normals.push(0, 0, 1);
                uvs.push(vertex.x, vertex.y); // world uvs
            }
            // indices
            for(let i = 0, l = faces.length; i < l; i++){
                const face = faces[i];
                const a = face[0] + indexOffset;
                const b = face[1] + indexOffset;
                const c = face[2] + indexOffset;
                indices.push(a, b, c);
                groupCount += 3;
            }
        }
    }
}
function $9014d97cd777be10$var$toJSON(shapes, data) {
    data.shapes = [];
    if (Array.isArray(shapes)) for(let i = 0, l = shapes.length; i < l; i++){
        const shape = shapes[i];
        data.shapes.push(shape.uuid);
    }
    else data.shapes.push(shapes.uuid);
    return data;
}
class $9014d97cd777be10$export$1b417fc3b307a251 extends $9014d97cd777be10$export$b7be63a67df8959 {
    copy(source) {
        super.copy(source);
        this.parameters = Object.assign({}, source.parameters);
        return this;
    }
    static fromJSON(data) {
        return new $9014d97cd777be10$export$1b417fc3b307a251(data.radius, data.widthSegments, data.heightSegments, data.phiStart, data.phiLength, data.thetaStart, data.thetaLength);
    }
    constructor(radius = 1, widthSegments = 32, heightSegments = 16, phiStart = 0, phiLength = Math.PI * 2, thetaStart = 0, thetaLength = Math.PI){
        super();
        this.type = "SphereGeometry";
        this.parameters = {
            radius: radius,
            widthSegments: widthSegments,
            heightSegments: heightSegments,
            phiStart: phiStart,
            phiLength: phiLength,
            thetaStart: thetaStart,
            thetaLength: thetaLength
        };
        widthSegments = Math.max(3, Math.floor(widthSegments));
        heightSegments = Math.max(2, Math.floor(heightSegments));
        const thetaEnd = Math.min(thetaStart + thetaLength, Math.PI);
        let index = 0;
        const grid = [];
        const vertex = new $9014d97cd777be10$export$64b5c384219d3699();
        const normal = new $9014d97cd777be10$export$64b5c384219d3699();
        // buffers
        const indices = [];
        const vertices = [];
        const normals = [];
        const uvs = [];
        // generate vertices, normals and uvs
        for(let iy = 0; iy <= heightSegments; iy++){
            const verticesRow = [];
            const v = iy / heightSegments;
            // special case for the poles
            let uOffset = 0;
            if (iy === 0 && thetaStart === 0) uOffset = 0.5 / widthSegments;
            else if (iy === heightSegments && thetaEnd === Math.PI) uOffset = -0.5 / widthSegments;
            for(let ix = 0; ix <= widthSegments; ix++){
                const u = ix / widthSegments;
                // vertex
                vertex.x = -radius * Math.cos(phiStart + u * phiLength) * Math.sin(thetaStart + v * thetaLength);
                vertex.y = radius * Math.cos(thetaStart + v * thetaLength);
                vertex.z = radius * Math.sin(phiStart + u * phiLength) * Math.sin(thetaStart + v * thetaLength);
                vertices.push(vertex.x, vertex.y, vertex.z);
                // normal
                normal.copy(vertex).normalize();
                normals.push(normal.x, normal.y, normal.z);
                // uv
                uvs.push(u + uOffset, 1 - v);
                verticesRow.push(index++);
            }
            grid.push(verticesRow);
        }
        // indices
        for(let iy = 0; iy < heightSegments; iy++)for(let ix = 0; ix < widthSegments; ix++){
            const a = grid[iy][ix + 1];
            const b = grid[iy][ix];
            const c = grid[iy + 1][ix];
            const d = grid[iy + 1][ix + 1];
            if (iy !== 0 || thetaStart > 0) indices.push(a, b, d);
            if (iy !== heightSegments - 1 || thetaEnd < Math.PI) indices.push(b, c, d);
        }
        // build geometry
        this.setIndex(indices);
        this.setAttribute("position", new $9014d97cd777be10$export$cbe7a62641830ebd(vertices, 3));
        this.setAttribute("normal", new $9014d97cd777be10$export$cbe7a62641830ebd(normals, 3));
        this.setAttribute("uv", new $9014d97cd777be10$export$cbe7a62641830ebd(uvs, 2));
    }
}
class $9014d97cd777be10$export$fb3f7adc68bd6e02 extends $9014d97cd777be10$export$60e57a7d3f20ff65 {
    static fromJSON(data) {
        return new $9014d97cd777be10$export$fb3f7adc68bd6e02(data.radius, data.detail);
    }
    constructor(radius = 1, detail = 0){
        const vertices = [
            1,
            1,
            1,
            -1,
            -1,
            1,
            -1,
            1,
            -1,
            1,
            -1,
            -1
        ];
        const indices = [
            2,
            1,
            0,
            0,
            3,
            2,
            1,
            3,
            0,
            2,
            3,
            1
        ];
        super(vertices, indices, radius, detail);
        this.type = "TetrahedronGeometry";
        this.parameters = {
            radius: radius,
            detail: detail
        };
    }
}
class $9014d97cd777be10$export$a2312a2a1fa56495 extends $9014d97cd777be10$export$b7be63a67df8959 {
    copy(source) {
        super.copy(source);
        this.parameters = Object.assign({}, source.parameters);
        return this;
    }
    static fromJSON(data) {
        return new $9014d97cd777be10$export$a2312a2a1fa56495(data.radius, data.tube, data.radialSegments, data.tubularSegments, data.arc);
    }
    constructor(radius = 1, tube = 0.4, radialSegments = 12, tubularSegments = 48, arc = Math.PI * 2){
        super();
        this.type = "TorusGeometry";
        this.parameters = {
            radius: radius,
            tube: tube,
            radialSegments: radialSegments,
            tubularSegments: tubularSegments,
            arc: arc
        };
        radialSegments = Math.floor(radialSegments);
        tubularSegments = Math.floor(tubularSegments);
        // buffers
        const indices = [];
        const vertices = [];
        const normals = [];
        const uvs = [];
        // helper variables
        const center = new $9014d97cd777be10$export$64b5c384219d3699();
        const vertex = new $9014d97cd777be10$export$64b5c384219d3699();
        const normal = new $9014d97cd777be10$export$64b5c384219d3699();
        // generate vertices, normals and uvs
        for(let j = 0; j <= radialSegments; j++)for(let i = 0; i <= tubularSegments; i++){
            const u = i / tubularSegments * arc;
            const v = j / radialSegments * Math.PI * 2;
            // vertex
            vertex.x = (radius + tube * Math.cos(v)) * Math.cos(u);
            vertex.y = (radius + tube * Math.cos(v)) * Math.sin(u);
            vertex.z = tube * Math.sin(v);
            vertices.push(vertex.x, vertex.y, vertex.z);
            // normal
            center.x = radius * Math.cos(u);
            center.y = radius * Math.sin(u);
            normal.subVectors(vertex, center).normalize();
            normals.push(normal.x, normal.y, normal.z);
            // uv
            uvs.push(i / tubularSegments);
            uvs.push(j / radialSegments);
        }
        // generate indices
        for(let j = 1; j <= radialSegments; j++)for(let i = 1; i <= tubularSegments; i++){
            // indices
            const a = (tubularSegments + 1) * j + i - 1;
            const b = (tubularSegments + 1) * (j - 1) + i - 1;
            const c = (tubularSegments + 1) * (j - 1) + i;
            const d = (tubularSegments + 1) * j + i;
            // faces
            indices.push(a, b, d);
            indices.push(b, c, d);
        }
        // build geometry
        this.setIndex(indices);
        this.setAttribute("position", new $9014d97cd777be10$export$cbe7a62641830ebd(vertices, 3));
        this.setAttribute("normal", new $9014d97cd777be10$export$cbe7a62641830ebd(normals, 3));
        this.setAttribute("uv", new $9014d97cd777be10$export$cbe7a62641830ebd(uvs, 2));
    }
}
class $9014d97cd777be10$export$77e9bfadfb9ab8c8 extends $9014d97cd777be10$export$b7be63a67df8959 {
    copy(source) {
        super.copy(source);
        this.parameters = Object.assign({}, source.parameters);
        return this;
    }
    static fromJSON(data) {
        return new $9014d97cd777be10$export$77e9bfadfb9ab8c8(data.radius, data.tube, data.tubularSegments, data.radialSegments, data.p, data.q);
    }
    constructor(radius = 1, tube = 0.4, tubularSegments = 64, radialSegments = 8, p = 2, q = 3){
        super();
        this.type = "TorusKnotGeometry";
        this.parameters = {
            radius: radius,
            tube: tube,
            tubularSegments: tubularSegments,
            radialSegments: radialSegments,
            p: p,
            q: q
        };
        tubularSegments = Math.floor(tubularSegments);
        radialSegments = Math.floor(radialSegments);
        // buffers
        const indices = [];
        const vertices = [];
        const normals = [];
        const uvs = [];
        // helper variables
        const vertex = new $9014d97cd777be10$export$64b5c384219d3699();
        const normal = new $9014d97cd777be10$export$64b5c384219d3699();
        const P1 = new $9014d97cd777be10$export$64b5c384219d3699();
        const P2 = new $9014d97cd777be10$export$64b5c384219d3699();
        const B = new $9014d97cd777be10$export$64b5c384219d3699();
        const T = new $9014d97cd777be10$export$64b5c384219d3699();
        const N = new $9014d97cd777be10$export$64b5c384219d3699();
        // generate vertices, normals and uvs
        for(let i = 0; i <= tubularSegments; ++i){
            // the radian "u" is used to calculate the position on the torus curve of the current tubular segment
            const u = i / tubularSegments * p * Math.PI * 2;
            // now we calculate two points. P1 is our current position on the curve, P2 is a little farther ahead.
            // these points are used to create a special "coordinate space", which is necessary to calculate the correct vertex positions
            calculatePositionOnCurve(u, p, q, radius, P1);
            calculatePositionOnCurve(u + 0.01, p, q, radius, P2);
            // calculate orthonormal basis
            T.subVectors(P2, P1);
            N.addVectors(P2, P1);
            B.crossVectors(T, N);
            N.crossVectors(B, T);
            // normalize B, N. T can be ignored, we don't use it
            B.normalize();
            N.normalize();
            for(let j = 0; j <= radialSegments; ++j){
                // now calculate the vertices. they are nothing more than an extrusion of the torus curve.
                // because we extrude a shape in the xy-plane, there is no need to calculate a z-value.
                const v = j / radialSegments * Math.PI * 2;
                const cx = -tube * Math.cos(v);
                const cy = tube * Math.sin(v);
                // now calculate the final vertex position.
                // first we orient the extrusion with our basis vectors, then we add it to the current position on the curve
                vertex.x = P1.x + (cx * N.x + cy * B.x);
                vertex.y = P1.y + (cx * N.y + cy * B.y);
                vertex.z = P1.z + (cx * N.z + cy * B.z);
                vertices.push(vertex.x, vertex.y, vertex.z);
                // normal (P1 is always the center/origin of the extrusion, thus we can use it to calculate the normal)
                normal.subVectors(vertex, P1).normalize();
                normals.push(normal.x, normal.y, normal.z);
                // uv
                uvs.push(i / tubularSegments);
                uvs.push(j / radialSegments);
            }
        }
        // generate indices
        for(let j = 1; j <= tubularSegments; j++)for(let i = 1; i <= radialSegments; i++){
            // indices
            const a = (radialSegments + 1) * (j - 1) + (i - 1);
            const b = (radialSegments + 1) * j + (i - 1);
            const c = (radialSegments + 1) * j + i;
            const d = (radialSegments + 1) * (j - 1) + i;
            // faces
            indices.push(a, b, d);
            indices.push(b, c, d);
        }
        // build geometry
        this.setIndex(indices);
        this.setAttribute("position", new $9014d97cd777be10$export$cbe7a62641830ebd(vertices, 3));
        this.setAttribute("normal", new $9014d97cd777be10$export$cbe7a62641830ebd(normals, 3));
        this.setAttribute("uv", new $9014d97cd777be10$export$cbe7a62641830ebd(uvs, 2));
        // this function calculates the current position on the torus curve
        function calculatePositionOnCurve(u, p, q, radius, position) {
            const cu = Math.cos(u);
            const su = Math.sin(u);
            const quOverP = q / p * u;
            const cs = Math.cos(quOverP);
            position.x = radius * (2 + cs) * 0.5 * cu;
            position.y = radius * (2 + cs) * su * 0.5;
            position.z = radius * Math.sin(quOverP) * 0.5;
        }
    }
}
class $9014d97cd777be10$export$7897d9d48904490c extends $9014d97cd777be10$export$b7be63a67df8959 {
    copy(source) {
        super.copy(source);
        this.parameters = Object.assign({}, source.parameters);
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.path = this.parameters.path.toJSON();
        return data;
    }
    static fromJSON(data) {
        // This only works for built-in curves (e.g. CatmullRomCurve3).
        // User defined curves or instances of CurvePath will not be deserialized.
        return new $9014d97cd777be10$export$7897d9d48904490c(new $9014d97cd777be10$var$Curves[data.path.type]().fromJSON(data.path), data.tubularSegments, data.radius, data.radialSegments, data.closed);
    }
    constructor(path = new $9014d97cd777be10$export$bf3f4c7e459f90fc(new $9014d97cd777be10$export$64b5c384219d3699(-1, -1, 0), new $9014d97cd777be10$export$64b5c384219d3699(-1, 1, 0), new $9014d97cd777be10$export$64b5c384219d3699(1, 1, 0)), tubularSegments = 64, radius = 1, radialSegments = 8, closed = false){
        super();
        this.type = "TubeGeometry";
        this.parameters = {
            path: path,
            tubularSegments: tubularSegments,
            radius: radius,
            radialSegments: radialSegments,
            closed: closed
        };
        const frames = path.computeFrenetFrames(tubularSegments, closed);
        // expose internals
        this.tangents = frames.tangents;
        this.normals = frames.normals;
        this.binormals = frames.binormals;
        // helper variables
        const vertex = new $9014d97cd777be10$export$64b5c384219d3699();
        const normal = new $9014d97cd777be10$export$64b5c384219d3699();
        const uv = new $9014d97cd777be10$export$c977b3e384af9ae1();
        let P = new $9014d97cd777be10$export$64b5c384219d3699();
        // buffer
        const vertices = [];
        const normals = [];
        const uvs = [];
        const indices = [];
        // create buffer data
        generateBufferData();
        // build geometry
        this.setIndex(indices);
        this.setAttribute("position", new $9014d97cd777be10$export$cbe7a62641830ebd(vertices, 3));
        this.setAttribute("normal", new $9014d97cd777be10$export$cbe7a62641830ebd(normals, 3));
        this.setAttribute("uv", new $9014d97cd777be10$export$cbe7a62641830ebd(uvs, 2));
        // functions
        function generateBufferData() {
            for(let i = 0; i < tubularSegments; i++)generateSegment(i);
            // if the geometry is not closed, generate the last row of vertices and normals
            // at the regular position on the given path
            //
            // if the geometry is closed, duplicate the first row of vertices and normals (uvs will differ)
            generateSegment(closed === false ? tubularSegments : 0);
            // uvs are generated in a separate function.
            // this makes it easy compute correct values for closed geometries
            generateUVs();
            // finally create faces
            generateIndices();
        }
        function generateSegment(i) {
            // we use getPointAt to sample evenly distributed points from the given path
            P = path.getPointAt(i / tubularSegments, P);
            // retrieve corresponding normal and binormal
            const N = frames.normals[i];
            const B = frames.binormals[i];
            // generate normals and vertices for the current segment
            for(let j = 0; j <= radialSegments; j++){
                const v = j / radialSegments * Math.PI * 2;
                const sin = Math.sin(v);
                const cos = -Math.cos(v);
                // normal
                normal.x = cos * N.x + sin * B.x;
                normal.y = cos * N.y + sin * B.y;
                normal.z = cos * N.z + sin * B.z;
                normal.normalize();
                normals.push(normal.x, normal.y, normal.z);
                // vertex
                vertex.x = P.x + radius * normal.x;
                vertex.y = P.y + radius * normal.y;
                vertex.z = P.z + radius * normal.z;
                vertices.push(vertex.x, vertex.y, vertex.z);
            }
        }
        function generateIndices() {
            for(let j = 1; j <= tubularSegments; j++)for(let i = 1; i <= radialSegments; i++){
                const a = (radialSegments + 1) * (j - 1) + (i - 1);
                const b = (radialSegments + 1) * j + (i - 1);
                const c = (radialSegments + 1) * j + i;
                const d = (radialSegments + 1) * (j - 1) + i;
                // faces
                indices.push(a, b, d);
                indices.push(b, c, d);
            }
        }
        function generateUVs() {
            for(let i = 0; i <= tubularSegments; i++)for(let j = 0; j <= radialSegments; j++){
                uv.x = i / tubularSegments;
                uv.y = j / radialSegments;
                uvs.push(uv.x, uv.y);
            }
        }
    }
}
class $9014d97cd777be10$export$4b739da06d24892b extends $9014d97cd777be10$export$b7be63a67df8959 {
    copy(source) {
        super.copy(source);
        this.parameters = Object.assign({}, source.parameters);
        return this;
    }
    constructor(geometry = null){
        super();
        this.type = "WireframeGeometry";
        this.parameters = {
            geometry: geometry
        };
        if (geometry !== null) {
            // buffer
            const vertices = [];
            const edges = new Set();
            // helper variables
            const start = new $9014d97cd777be10$export$64b5c384219d3699();
            const end = new $9014d97cd777be10$export$64b5c384219d3699();
            if (geometry.index !== null) {
                // indexed BufferGeometry
                const position = geometry.attributes.position;
                const indices = geometry.index;
                let groups = geometry.groups;
                if (groups.length === 0) groups = [
                    {
                        start: 0,
                        count: indices.count,
                        materialIndex: 0
                    }
                ];
                // create a data structure that contains all edges without duplicates
                for(let o = 0, ol = groups.length; o < ol; ++o){
                    const group = groups[o];
                    const groupStart = group.start;
                    const groupCount = group.count;
                    for(let i = groupStart, l = groupStart + groupCount; i < l; i += 3)for(let j = 0; j < 3; j++){
                        const index1 = indices.getX(i + j);
                        const index2 = indices.getX(i + (j + 1) % 3);
                        start.fromBufferAttribute(position, index1);
                        end.fromBufferAttribute(position, index2);
                        if ($9014d97cd777be10$var$isUniqueEdge(start, end, edges) === true) {
                            vertices.push(start.x, start.y, start.z);
                            vertices.push(end.x, end.y, end.z);
                        }
                    }
                }
            } else {
                // non-indexed BufferGeometry
                const position = geometry.attributes.position;
                for(let i = 0, l = position.count / 3; i < l; i++)for(let j = 0; j < 3; j++){
                    // three edges per triangle, an edge is represented as (index1, index2)
                    // e.g. the first triangle has the following edges: (0,1),(1,2),(2,0)
                    const index1 = 3 * i + j;
                    const index2 = 3 * i + (j + 1) % 3;
                    start.fromBufferAttribute(position, index1);
                    end.fromBufferAttribute(position, index2);
                    if ($9014d97cd777be10$var$isUniqueEdge(start, end, edges) === true) {
                        vertices.push(start.x, start.y, start.z);
                        vertices.push(end.x, end.y, end.z);
                    }
                }
            }
            // build geometry
            this.setAttribute("position", new $9014d97cd777be10$export$cbe7a62641830ebd(vertices, 3));
        }
    }
}
function $9014d97cd777be10$var$isUniqueEdge(start, end, edges) {
    const hash1 = `${start.x},${start.y},${start.z}-${end.x},${end.y},${end.z}`;
    const hash2 = `${end.x},${end.y},${end.z}-${start.x},${start.y},${start.z}`; // coincident edge
    if (edges.has(hash1) === true || edges.has(hash2) === true) return false;
    else {
        edges.add(hash1);
        edges.add(hash2);
        return true;
    }
}
var $9014d97cd777be10$var$Geometries = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    BoxGeometry: $9014d97cd777be10$export$33e43285f7406bd5,
    CapsuleGeometry: $9014d97cd777be10$export$41680e8551036033,
    CircleGeometry: $9014d97cd777be10$export$d5c0e8d607467193,
    ConeGeometry: $9014d97cd777be10$export$a7a48974f285c9b3,
    CylinderGeometry: $9014d97cd777be10$export$68f745719dbe5198,
    DodecahedronGeometry: $9014d97cd777be10$export$c0babfeb8708fc9c,
    EdgesGeometry: $9014d97cd777be10$export$4730b1542707547f,
    ExtrudeGeometry: $9014d97cd777be10$export$598697a1efa63ca7,
    IcosahedronGeometry: $9014d97cd777be10$export$9567cc828c9535da,
    LatheGeometry: $9014d97cd777be10$export$6d839803fcd1882c,
    OctahedronGeometry: $9014d97cd777be10$export$1954e2b809fe361e,
    PlaneGeometry: $9014d97cd777be10$export$967d831af31f69ce,
    PolyhedronGeometry: $9014d97cd777be10$export$60e57a7d3f20ff65,
    RingGeometry: $9014d97cd777be10$export$68cb731f50f614af,
    ShapeGeometry: $9014d97cd777be10$export$57a29a1c803e9065,
    SphereGeometry: $9014d97cd777be10$export$1b417fc3b307a251,
    TetrahedronGeometry: $9014d97cd777be10$export$fb3f7adc68bd6e02,
    TorusGeometry: $9014d97cd777be10$export$a2312a2a1fa56495,
    TorusKnotGeometry: $9014d97cd777be10$export$77e9bfadfb9ab8c8,
    TubeGeometry: $9014d97cd777be10$export$7897d9d48904490c,
    WireframeGeometry: $9014d97cd777be10$export$4b739da06d24892b
});
class $9014d97cd777be10$export$e8564da406055a3 extends $9014d97cd777be10$export$a2d8b23205c25948 {
    copy(source) {
        super.copy(source);
        this.color.copy(source.color);
        this.fog = source.fog;
        return this;
    }
    constructor(parameters){
        super();
        this.isShadowMaterial = true;
        this.type = "ShadowMaterial";
        this.color = new $9014d97cd777be10$export$892596cec99bc70e(0x000000);
        this.transparent = true;
        this.fog = true;
        this.setValues(parameters);
    }
}
class $9014d97cd777be10$export$21c421a2e1df9d22 extends $9014d97cd777be10$export$83c7d75d550a8b0d {
    constructor(parameters){
        super(parameters);
        this.isRawShaderMaterial = true;
        this.type = "RawShaderMaterial";
    }
}
class $9014d97cd777be10$export$f2980790215acccd extends $9014d97cd777be10$export$a2d8b23205c25948 {
    copy(source) {
        super.copy(source);
        this.defines = {
            "STANDARD": ""
        };
        this.color.copy(source.color);
        this.roughness = source.roughness;
        this.metalness = source.metalness;
        this.map = source.map;
        this.lightMap = source.lightMap;
        this.lightMapIntensity = source.lightMapIntensity;
        this.aoMap = source.aoMap;
        this.aoMapIntensity = source.aoMapIntensity;
        this.emissive.copy(source.emissive);
        this.emissiveMap = source.emissiveMap;
        this.emissiveIntensity = source.emissiveIntensity;
        this.bumpMap = source.bumpMap;
        this.bumpScale = source.bumpScale;
        this.normalMap = source.normalMap;
        this.normalMapType = source.normalMapType;
        this.normalScale.copy(source.normalScale);
        this.displacementMap = source.displacementMap;
        this.displacementScale = source.displacementScale;
        this.displacementBias = source.displacementBias;
        this.roughnessMap = source.roughnessMap;
        this.metalnessMap = source.metalnessMap;
        this.alphaMap = source.alphaMap;
        this.envMap = source.envMap;
        this.envMapIntensity = source.envMapIntensity;
        this.wireframe = source.wireframe;
        this.wireframeLinewidth = source.wireframeLinewidth;
        this.wireframeLinecap = source.wireframeLinecap;
        this.wireframeLinejoin = source.wireframeLinejoin;
        this.flatShading = source.flatShading;
        this.fog = source.fog;
        return this;
    }
    constructor(parameters){
        super();
        this.isMeshStandardMaterial = true;
        this.defines = {
            "STANDARD": ""
        };
        this.type = "MeshStandardMaterial";
        this.color = new $9014d97cd777be10$export$892596cec99bc70e(0xffffff); // diffuse
        this.roughness = 1.0;
        this.metalness = 0.0;
        this.map = null;
        this.lightMap = null;
        this.lightMapIntensity = 1.0;
        this.aoMap = null;
        this.aoMapIntensity = 1.0;
        this.emissive = new $9014d97cd777be10$export$892596cec99bc70e(0x000000);
        this.emissiveIntensity = 1.0;
        this.emissiveMap = null;
        this.bumpMap = null;
        this.bumpScale = 1;
        this.normalMap = null;
        this.normalMapType = $9014d97cd777be10$export$2852a58ebdac27b8;
        this.normalScale = new $9014d97cd777be10$export$c977b3e384af9ae1(1, 1);
        this.displacementMap = null;
        this.displacementScale = 1;
        this.displacementBias = 0;
        this.roughnessMap = null;
        this.metalnessMap = null;
        this.alphaMap = null;
        this.envMap = null;
        this.envMapIntensity = 1.0;
        this.wireframe = false;
        this.wireframeLinewidth = 1;
        this.wireframeLinecap = "round";
        this.wireframeLinejoin = "round";
        this.flatShading = false;
        this.fog = true;
        this.setValues(parameters);
    }
}
class $9014d97cd777be10$export$28d04986c4269c9f extends $9014d97cd777be10$export$f2980790215acccd {
    get anisotropy() {
        return this._anisotropy;
    }
    set anisotropy(value) {
        if (this._anisotropy > 0 !== value > 0) this.version++;
        this._anisotropy = value;
    }
    get clearcoat() {
        return this._clearcoat;
    }
    set clearcoat(value) {
        if (this._clearcoat > 0 !== value > 0) this.version++;
        this._clearcoat = value;
    }
    get iridescence() {
        return this._iridescence;
    }
    set iridescence(value) {
        if (this._iridescence > 0 !== value > 0) this.version++;
        this._iridescence = value;
    }
    get sheen() {
        return this._sheen;
    }
    set sheen(value) {
        if (this._sheen > 0 !== value > 0) this.version++;
        this._sheen = value;
    }
    get transmission() {
        return this._transmission;
    }
    set transmission(value) {
        if (this._transmission > 0 !== value > 0) this.version++;
        this._transmission = value;
    }
    copy(source) {
        super.copy(source);
        this.defines = {
            "STANDARD": "",
            "PHYSICAL": ""
        };
        this.anisotropy = source.anisotropy;
        this.anisotropyRotation = source.anisotropyRotation;
        this.anisotropyMap = source.anisotropyMap;
        this.clearcoat = source.clearcoat;
        this.clearcoatMap = source.clearcoatMap;
        this.clearcoatRoughness = source.clearcoatRoughness;
        this.clearcoatRoughnessMap = source.clearcoatRoughnessMap;
        this.clearcoatNormalMap = source.clearcoatNormalMap;
        this.clearcoatNormalScale.copy(source.clearcoatNormalScale);
        this.ior = source.ior;
        this.iridescence = source.iridescence;
        this.iridescenceMap = source.iridescenceMap;
        this.iridescenceIOR = source.iridescenceIOR;
        this.iridescenceThicknessRange = [
            ...source.iridescenceThicknessRange
        ];
        this.iridescenceThicknessMap = source.iridescenceThicknessMap;
        this.sheen = source.sheen;
        this.sheenColor.copy(source.sheenColor);
        this.sheenColorMap = source.sheenColorMap;
        this.sheenRoughness = source.sheenRoughness;
        this.sheenRoughnessMap = source.sheenRoughnessMap;
        this.transmission = source.transmission;
        this.transmissionMap = source.transmissionMap;
        this.thickness = source.thickness;
        this.thicknessMap = source.thicknessMap;
        this.attenuationDistance = source.attenuationDistance;
        this.attenuationColor.copy(source.attenuationColor);
        this.specularIntensity = source.specularIntensity;
        this.specularIntensityMap = source.specularIntensityMap;
        this.specularColor.copy(source.specularColor);
        this.specularColorMap = source.specularColorMap;
        return this;
    }
    constructor(parameters){
        super();
        this.isMeshPhysicalMaterial = true;
        this.defines = {
            "STANDARD": "",
            "PHYSICAL": ""
        };
        this.type = "MeshPhysicalMaterial";
        this.anisotropyRotation = 0;
        this.anisotropyMap = null;
        this.clearcoatMap = null;
        this.clearcoatRoughness = 0.0;
        this.clearcoatRoughnessMap = null;
        this.clearcoatNormalScale = new $9014d97cd777be10$export$c977b3e384af9ae1(1, 1);
        this.clearcoatNormalMap = null;
        this.ior = 1.5;
        Object.defineProperty(this, "reflectivity", {
            get: function() {
                return $9014d97cd777be10$var$clamp(2.5 * (this.ior - 1) / (this.ior + 1), 0, 1);
            },
            set: function(reflectivity) {
                this.ior = (1 + 0.4 * reflectivity) / (1 - 0.4 * reflectivity);
            }
        });
        this.iridescenceMap = null;
        this.iridescenceIOR = 1.3;
        this.iridescenceThicknessRange = [
            100,
            400
        ];
        this.iridescenceThicknessMap = null;
        this.sheenColor = new $9014d97cd777be10$export$892596cec99bc70e(0x000000);
        this.sheenColorMap = null;
        this.sheenRoughness = 1.0;
        this.sheenRoughnessMap = null;
        this.transmissionMap = null;
        this.thickness = 0;
        this.thicknessMap = null;
        this.attenuationDistance = Infinity;
        this.attenuationColor = new $9014d97cd777be10$export$892596cec99bc70e(1, 1, 1);
        this.specularIntensity = 1.0;
        this.specularIntensityMap = null;
        this.specularColor = new $9014d97cd777be10$export$892596cec99bc70e(1, 1, 1);
        this.specularColorMap = null;
        this._anisotropy = 0;
        this._clearcoat = 0;
        this._iridescence = 0;
        this._sheen = 0.0;
        this._transmission = 0;
        this.setValues(parameters);
    }
}
class $9014d97cd777be10$export$24c72f71cbaf0678 extends $9014d97cd777be10$export$a2d8b23205c25948 {
    copy(source) {
        super.copy(source);
        this.color.copy(source.color);
        this.specular.copy(source.specular);
        this.shininess = source.shininess;
        this.map = source.map;
        this.lightMap = source.lightMap;
        this.lightMapIntensity = source.lightMapIntensity;
        this.aoMap = source.aoMap;
        this.aoMapIntensity = source.aoMapIntensity;
        this.emissive.copy(source.emissive);
        this.emissiveMap = source.emissiveMap;
        this.emissiveIntensity = source.emissiveIntensity;
        this.bumpMap = source.bumpMap;
        this.bumpScale = source.bumpScale;
        this.normalMap = source.normalMap;
        this.normalMapType = source.normalMapType;
        this.normalScale.copy(source.normalScale);
        this.displacementMap = source.displacementMap;
        this.displacementScale = source.displacementScale;
        this.displacementBias = source.displacementBias;
        this.specularMap = source.specularMap;
        this.alphaMap = source.alphaMap;
        this.envMap = source.envMap;
        this.combine = source.combine;
        this.reflectivity = source.reflectivity;
        this.refractionRatio = source.refractionRatio;
        this.wireframe = source.wireframe;
        this.wireframeLinewidth = source.wireframeLinewidth;
        this.wireframeLinecap = source.wireframeLinecap;
        this.wireframeLinejoin = source.wireframeLinejoin;
        this.flatShading = source.flatShading;
        this.fog = source.fog;
        return this;
    }
    constructor(parameters){
        super();
        this.isMeshPhongMaterial = true;
        this.type = "MeshPhongMaterial";
        this.color = new $9014d97cd777be10$export$892596cec99bc70e(0xffffff); // diffuse
        this.specular = new $9014d97cd777be10$export$892596cec99bc70e(0x111111);
        this.shininess = 30;
        this.map = null;
        this.lightMap = null;
        this.lightMapIntensity = 1.0;
        this.aoMap = null;
        this.aoMapIntensity = 1.0;
        this.emissive = new $9014d97cd777be10$export$892596cec99bc70e(0x000000);
        this.emissiveIntensity = 1.0;
        this.emissiveMap = null;
        this.bumpMap = null;
        this.bumpScale = 1;
        this.normalMap = null;
        this.normalMapType = $9014d97cd777be10$export$2852a58ebdac27b8;
        this.normalScale = new $9014d97cd777be10$export$c977b3e384af9ae1(1, 1);
        this.displacementMap = null;
        this.displacementScale = 1;
        this.displacementBias = 0;
        this.specularMap = null;
        this.alphaMap = null;
        this.envMap = null;
        this.combine = $9014d97cd777be10$export$e50ac29801f1774d;
        this.reflectivity = 1;
        this.refractionRatio = 0.98;
        this.wireframe = false;
        this.wireframeLinewidth = 1;
        this.wireframeLinecap = "round";
        this.wireframeLinejoin = "round";
        this.flatShading = false;
        this.fog = true;
        this.setValues(parameters);
    }
}
class $9014d97cd777be10$export$df893cf97e765622 extends $9014d97cd777be10$export$a2d8b23205c25948 {
    copy(source) {
        super.copy(source);
        this.color.copy(source.color);
        this.map = source.map;
        this.gradientMap = source.gradientMap;
        this.lightMap = source.lightMap;
        this.lightMapIntensity = source.lightMapIntensity;
        this.aoMap = source.aoMap;
        this.aoMapIntensity = source.aoMapIntensity;
        this.emissive.copy(source.emissive);
        this.emissiveMap = source.emissiveMap;
        this.emissiveIntensity = source.emissiveIntensity;
        this.bumpMap = source.bumpMap;
        this.bumpScale = source.bumpScale;
        this.normalMap = source.normalMap;
        this.normalMapType = source.normalMapType;
        this.normalScale.copy(source.normalScale);
        this.displacementMap = source.displacementMap;
        this.displacementScale = source.displacementScale;
        this.displacementBias = source.displacementBias;
        this.alphaMap = source.alphaMap;
        this.wireframe = source.wireframe;
        this.wireframeLinewidth = source.wireframeLinewidth;
        this.wireframeLinecap = source.wireframeLinecap;
        this.wireframeLinejoin = source.wireframeLinejoin;
        this.fog = source.fog;
        return this;
    }
    constructor(parameters){
        super();
        this.isMeshToonMaterial = true;
        this.defines = {
            "TOON": ""
        };
        this.type = "MeshToonMaterial";
        this.color = new $9014d97cd777be10$export$892596cec99bc70e(0xffffff);
        this.map = null;
        this.gradientMap = null;
        this.lightMap = null;
        this.lightMapIntensity = 1.0;
        this.aoMap = null;
        this.aoMapIntensity = 1.0;
        this.emissive = new $9014d97cd777be10$export$892596cec99bc70e(0x000000);
        this.emissiveIntensity = 1.0;
        this.emissiveMap = null;
        this.bumpMap = null;
        this.bumpScale = 1;
        this.normalMap = null;
        this.normalMapType = $9014d97cd777be10$export$2852a58ebdac27b8;
        this.normalScale = new $9014d97cd777be10$export$c977b3e384af9ae1(1, 1);
        this.displacementMap = null;
        this.displacementScale = 1;
        this.displacementBias = 0;
        this.alphaMap = null;
        this.wireframe = false;
        this.wireframeLinewidth = 1;
        this.wireframeLinecap = "round";
        this.wireframeLinejoin = "round";
        this.fog = true;
        this.setValues(parameters);
    }
}
class $9014d97cd777be10$export$bfe8c0a091f41ae7 extends $9014d97cd777be10$export$a2d8b23205c25948 {
    copy(source) {
        super.copy(source);
        this.bumpMap = source.bumpMap;
        this.bumpScale = source.bumpScale;
        this.normalMap = source.normalMap;
        this.normalMapType = source.normalMapType;
        this.normalScale.copy(source.normalScale);
        this.displacementMap = source.displacementMap;
        this.displacementScale = source.displacementScale;
        this.displacementBias = source.displacementBias;
        this.wireframe = source.wireframe;
        this.wireframeLinewidth = source.wireframeLinewidth;
        this.flatShading = source.flatShading;
        return this;
    }
    constructor(parameters){
        super();
        this.isMeshNormalMaterial = true;
        this.type = "MeshNormalMaterial";
        this.bumpMap = null;
        this.bumpScale = 1;
        this.normalMap = null;
        this.normalMapType = $9014d97cd777be10$export$2852a58ebdac27b8;
        this.normalScale = new $9014d97cd777be10$export$c977b3e384af9ae1(1, 1);
        this.displacementMap = null;
        this.displacementScale = 1;
        this.displacementBias = 0;
        this.wireframe = false;
        this.wireframeLinewidth = 1;
        this.flatShading = false;
        this.setValues(parameters);
    }
}
class $9014d97cd777be10$export$5023a9a8114806b8 extends $9014d97cd777be10$export$a2d8b23205c25948 {
    copy(source) {
        super.copy(source);
        this.color.copy(source.color);
        this.map = source.map;
        this.lightMap = source.lightMap;
        this.lightMapIntensity = source.lightMapIntensity;
        this.aoMap = source.aoMap;
        this.aoMapIntensity = source.aoMapIntensity;
        this.emissive.copy(source.emissive);
        this.emissiveMap = source.emissiveMap;
        this.emissiveIntensity = source.emissiveIntensity;
        this.bumpMap = source.bumpMap;
        this.bumpScale = source.bumpScale;
        this.normalMap = source.normalMap;
        this.normalMapType = source.normalMapType;
        this.normalScale.copy(source.normalScale);
        this.displacementMap = source.displacementMap;
        this.displacementScale = source.displacementScale;
        this.displacementBias = source.displacementBias;
        this.specularMap = source.specularMap;
        this.alphaMap = source.alphaMap;
        this.envMap = source.envMap;
        this.combine = source.combine;
        this.reflectivity = source.reflectivity;
        this.refractionRatio = source.refractionRatio;
        this.wireframe = source.wireframe;
        this.wireframeLinewidth = source.wireframeLinewidth;
        this.wireframeLinecap = source.wireframeLinecap;
        this.wireframeLinejoin = source.wireframeLinejoin;
        this.flatShading = source.flatShading;
        this.fog = source.fog;
        return this;
    }
    constructor(parameters){
        super();
        this.isMeshLambertMaterial = true;
        this.type = "MeshLambertMaterial";
        this.color = new $9014d97cd777be10$export$892596cec99bc70e(0xffffff); // diffuse
        this.map = null;
        this.lightMap = null;
        this.lightMapIntensity = 1.0;
        this.aoMap = null;
        this.aoMapIntensity = 1.0;
        this.emissive = new $9014d97cd777be10$export$892596cec99bc70e(0x000000);
        this.emissiveIntensity = 1.0;
        this.emissiveMap = null;
        this.bumpMap = null;
        this.bumpScale = 1;
        this.normalMap = null;
        this.normalMapType = $9014d97cd777be10$export$2852a58ebdac27b8;
        this.normalScale = new $9014d97cd777be10$export$c977b3e384af9ae1(1, 1);
        this.displacementMap = null;
        this.displacementScale = 1;
        this.displacementBias = 0;
        this.specularMap = null;
        this.alphaMap = null;
        this.envMap = null;
        this.combine = $9014d97cd777be10$export$e50ac29801f1774d;
        this.reflectivity = 1;
        this.refractionRatio = 0.98;
        this.wireframe = false;
        this.wireframeLinewidth = 1;
        this.wireframeLinecap = "round";
        this.wireframeLinejoin = "round";
        this.flatShading = false;
        this.fog = true;
        this.setValues(parameters);
    }
}
class $9014d97cd777be10$export$6f5fef6235ec12ee extends $9014d97cd777be10$export$a2d8b23205c25948 {
    copy(source) {
        super.copy(source);
        this.defines = {
            "MATCAP": ""
        };
        this.color.copy(source.color);
        this.matcap = source.matcap;
        this.map = source.map;
        this.bumpMap = source.bumpMap;
        this.bumpScale = source.bumpScale;
        this.normalMap = source.normalMap;
        this.normalMapType = source.normalMapType;
        this.normalScale.copy(source.normalScale);
        this.displacementMap = source.displacementMap;
        this.displacementScale = source.displacementScale;
        this.displacementBias = source.displacementBias;
        this.alphaMap = source.alphaMap;
        this.flatShading = source.flatShading;
        this.fog = source.fog;
        return this;
    }
    constructor(parameters){
        super();
        this.isMeshMatcapMaterial = true;
        this.defines = {
            "MATCAP": ""
        };
        this.type = "MeshMatcapMaterial";
        this.color = new $9014d97cd777be10$export$892596cec99bc70e(0xffffff); // diffuse
        this.matcap = null;
        this.map = null;
        this.bumpMap = null;
        this.bumpScale = 1;
        this.normalMap = null;
        this.normalMapType = $9014d97cd777be10$export$2852a58ebdac27b8;
        this.normalScale = new $9014d97cd777be10$export$c977b3e384af9ae1(1, 1);
        this.displacementMap = null;
        this.displacementScale = 1;
        this.displacementBias = 0;
        this.alphaMap = null;
        this.flatShading = false;
        this.fog = true;
        this.setValues(parameters);
    }
}
class $9014d97cd777be10$export$327886a3efaeaebe extends $9014d97cd777be10$export$fbaaa33907730a0c {
    copy(source) {
        super.copy(source);
        this.scale = source.scale;
        this.dashSize = source.dashSize;
        this.gapSize = source.gapSize;
        return this;
    }
    constructor(parameters){
        super();
        this.isLineDashedMaterial = true;
        this.type = "LineDashedMaterial";
        this.scale = 1;
        this.dashSize = 3;
        this.gapSize = 1;
        this.setValues(parameters);
    }
}
// same as Array.prototype.slice, but also works on typed arrays
function $9014d97cd777be10$var$arraySlice(array, from, to) {
    if ($9014d97cd777be10$var$isTypedArray(array)) // in ios9 array.subarray(from, undefined) will return empty array
    // but array.subarray(from) or array.subarray(from, len) is correct
    return new array.constructor(array.subarray(from, to !== undefined ? to : array.length));
    return array.slice(from, to);
}
// converts an array to a specific type
function $9014d97cd777be10$var$convertArray(array, type, forceClone) {
    if (!array || // let 'undefined' and 'null' pass
    !forceClone && array.constructor === type) return array;
    if (typeof type.BYTES_PER_ELEMENT === "number") return new type(array); // create typed array
    return Array.prototype.slice.call(array); // create Array
}
function $9014d97cd777be10$var$isTypedArray(object) {
    return ArrayBuffer.isView(object) && !(object instanceof DataView);
}
// returns an array by which times and values can be sorted
function $9014d97cd777be10$var$getKeyframeOrder(times) {
    function compareTime(i, j) {
        return times[i] - times[j];
    }
    const n = times.length;
    const result = new Array(n);
    for(let i = 0; i !== n; ++i)result[i] = i;
    result.sort(compareTime);
    return result;
}
// uses the array previously returned by 'getKeyframeOrder' to sort data
function $9014d97cd777be10$var$sortedArray(values, stride, order) {
    const nValues = values.length;
    const result = new values.constructor(nValues);
    for(let i = 0, dstOffset = 0; dstOffset !== nValues; ++i){
        const srcOffset = order[i] * stride;
        for(let j = 0; j !== stride; ++j)result[dstOffset++] = values[srcOffset + j];
    }
    return result;
}
// function for parsing AOS keyframe formats
function $9014d97cd777be10$var$flattenJSON(jsonKeys, times, values, valuePropertyName) {
    let i = 1, key = jsonKeys[0];
    while(key !== undefined && key[valuePropertyName] === undefined)key = jsonKeys[i++];
    if (key === undefined) return; // no data
    let value = key[valuePropertyName];
    if (value === undefined) return; // no data
    if (Array.isArray(value)) do {
        value = key[valuePropertyName];
        if (value !== undefined) {
            times.push(key.time);
            values.push.apply(values, value); // push all elements
        }
        key = jsonKeys[i++];
    }while (key !== undefined);
    else if (value.toArray !== undefined) // ...assume THREE.Math-ish
    do {
        value = key[valuePropertyName];
        if (value !== undefined) {
            times.push(key.time);
            value.toArray(values, values.length);
        }
        key = jsonKeys[i++];
    }while (key !== undefined);
    else // otherwise push as-is
    do {
        value = key[valuePropertyName];
        if (value !== undefined) {
            times.push(key.time);
            values.push(value);
        }
        key = jsonKeys[i++];
    }while (key !== undefined);
}
function $9014d97cd777be10$var$subclip(sourceClip, name, startFrame, endFrame, fps = 30) {
    const clip = sourceClip.clone();
    clip.name = name;
    const tracks = [];
    for(let i = 0; i < clip.tracks.length; ++i){
        const track = clip.tracks[i];
        const valueSize = track.getValueSize();
        const times = [];
        const values = [];
        for(let j = 0; j < track.times.length; ++j){
            const frame = track.times[j] * fps;
            if (frame < startFrame || frame >= endFrame) continue;
            times.push(track.times[j]);
            for(let k = 0; k < valueSize; ++k)values.push(track.values[j * valueSize + k]);
        }
        if (times.length === 0) continue;
        track.times = $9014d97cd777be10$var$convertArray(times, track.times.constructor);
        track.values = $9014d97cd777be10$var$convertArray(values, track.values.constructor);
        tracks.push(track);
    }
    clip.tracks = tracks;
    // find minimum .times value across all tracks in the trimmed clip
    let minStartTime = Infinity;
    for(let i = 0; i < clip.tracks.length; ++i)if (minStartTime > clip.tracks[i].times[0]) minStartTime = clip.tracks[i].times[0];
    // shift all tracks such that clip begins at t=0
    for(let i = 0; i < clip.tracks.length; ++i)clip.tracks[i].shift(-1 * minStartTime);
    clip.resetDuration();
    return clip;
}
function $9014d97cd777be10$var$makeClipAdditive(targetClip, referenceFrame = 0, referenceClip = targetClip, fps = 30) {
    if (fps <= 0) fps = 30;
    const numTracks = referenceClip.tracks.length;
    const referenceTime = referenceFrame / fps;
    // Make each track's values relative to the values at the reference frame
    for(let i = 0; i < numTracks; ++i){
        const referenceTrack = referenceClip.tracks[i];
        const referenceTrackType = referenceTrack.ValueTypeName;
        // Skip this track if it's non-numeric
        if (referenceTrackType === "bool" || referenceTrackType === "string") continue;
        // Find the track in the target clip whose name and type matches the reference track
        const targetTrack = targetClip.tracks.find(function(track) {
            return track.name === referenceTrack.name && track.ValueTypeName === referenceTrackType;
        });
        if (targetTrack === undefined) continue;
        let referenceOffset = 0;
        const referenceValueSize = referenceTrack.getValueSize();
        if (referenceTrack.createInterpolant.isInterpolantFactoryMethodGLTFCubicSpline) referenceOffset = referenceValueSize / 3;
        let targetOffset = 0;
        const targetValueSize = targetTrack.getValueSize();
        if (targetTrack.createInterpolant.isInterpolantFactoryMethodGLTFCubicSpline) targetOffset = targetValueSize / 3;
        const lastIndex = referenceTrack.times.length - 1;
        let referenceValue;
        // Find the value to subtract out of the track
        if (referenceTime <= referenceTrack.times[0]) {
            // Reference frame is earlier than the first keyframe, so just use the first keyframe
            const startIndex = referenceOffset;
            const endIndex = referenceValueSize - referenceOffset;
            referenceValue = $9014d97cd777be10$var$arraySlice(referenceTrack.values, startIndex, endIndex);
        } else if (referenceTime >= referenceTrack.times[lastIndex]) {
            // Reference frame is after the last keyframe, so just use the last keyframe
            const startIndex = lastIndex * referenceValueSize + referenceOffset;
            const endIndex = startIndex + referenceValueSize - referenceOffset;
            referenceValue = $9014d97cd777be10$var$arraySlice(referenceTrack.values, startIndex, endIndex);
        } else {
            // Interpolate to the reference value
            const interpolant = referenceTrack.createInterpolant();
            const startIndex = referenceOffset;
            const endIndex = referenceValueSize - referenceOffset;
            interpolant.evaluate(referenceTime);
            referenceValue = $9014d97cd777be10$var$arraySlice(interpolant.resultBuffer, startIndex, endIndex);
        }
        // Conjugate the quaternion
        if (referenceTrackType === "quaternion") {
            const referenceQuat = new $9014d97cd777be10$export$23d6a54f0bbc85a3().fromArray(referenceValue).normalize().conjugate();
            referenceQuat.toArray(referenceValue);
        }
        // Subtract the reference value from all of the track values
        const numTimes = targetTrack.times.length;
        for(let j = 0; j < numTimes; ++j){
            const valueStart = j * targetValueSize + targetOffset;
            if (referenceTrackType === "quaternion") // Multiply the conjugate for quaternion track types
            $9014d97cd777be10$export$23d6a54f0bbc85a3.multiplyQuaternionsFlat(targetTrack.values, valueStart, referenceValue, 0, targetTrack.values, valueStart);
            else {
                const valueEnd = targetValueSize - targetOffset * 2;
                // Subtract each value for all other numeric track types
                for(let k = 0; k < valueEnd; ++k)targetTrack.values[valueStart + k] -= referenceValue[k];
            }
        }
    }
    targetClip.blendMode = $9014d97cd777be10$export$d875e029ef558d3;
    return targetClip;
}
const $9014d97cd777be10$export$7ee8caa573e71ad1 = {
    arraySlice: $9014d97cd777be10$var$arraySlice,
    convertArray: $9014d97cd777be10$var$convertArray,
    isTypedArray: $9014d97cd777be10$var$isTypedArray,
    getKeyframeOrder: $9014d97cd777be10$var$getKeyframeOrder,
    sortedArray: $9014d97cd777be10$var$sortedArray,
    flattenJSON: $9014d97cd777be10$var$flattenJSON,
    subclip: $9014d97cd777be10$var$subclip,
    makeClipAdditive: $9014d97cd777be10$var$makeClipAdditive
};
/**
 * Abstract base class of interpolants over parametric samples.
 *
 * The parameter domain is one dimensional, typically the time or a path
 * along a curve defined by the data.
 *
 * The sample values can have any dimensionality and derived classes may
 * apply special interpretations to the data.
 *
 * This class provides the interval seek in a Template Method, deferring
 * the actual interpolation to derived classes.
 *
 * Time complexity is O(1) for linear access crossing at most two points
 * and O(log N) for random access, where N is the number of positions.
 *
 * References:
 *
 * 		http://www.oodesign.com/template-method-pattern.html
 *
 */ class $9014d97cd777be10$export$b558baee9c0f72d3 {
    evaluate(t) {
        const pp = this.parameterPositions;
        let i1 = this._cachedIndex, t1 = pp[i1], t0 = pp[i1 - 1];
        validate_interval: {
            seek: {
                let right;
                linear_scan: {
                    //- See http://jsperf.com/comparison-to-undefined/3
                    //- slower code:
                    //-
                    //- 				if ( t >= t1 || t1 === undefined ) {
                    forward_scan: if (!(t < t1)) {
                        for(let giveUpAt = i1 + 2;;){
                            if (t1 === undefined) {
                                if (t < t0) break forward_scan;
                                // after end
                                i1 = pp.length;
                                this._cachedIndex = i1;
                                return this.copySampleValue_(i1 - 1);
                            }
                            if (i1 === giveUpAt) break; // this loop
                            t0 = t1;
                            t1 = pp[++i1];
                            if (t < t1) break seek;
                        }
                        // prepare binary search on the right side of the index
                        right = pp.length;
                        break linear_scan;
                    }
                    //- slower code:
                    //-					if ( t < t0 || t0 === undefined ) {
                    if (!(t >= t0)) {
                        // looping?
                        const t1global = pp[1];
                        if (t < t1global) {
                            i1 = 2; // + 1, using the scan for the details
                            t0 = t1global;
                        }
                        // linear reverse scan
                        for(let giveUpAt = i1 - 2;;){
                            if (t0 === undefined) {
                                // before start
                                this._cachedIndex = 0;
                                return this.copySampleValue_(0);
                            }
                            if (i1 === giveUpAt) break; // this loop
                            t1 = t0;
                            t0 = pp[--i1 - 1];
                            if (t >= t0) break seek;
                        }
                        // prepare binary search on the left side of the index
                        right = i1;
                        i1 = 0;
                        break linear_scan;
                    }
                    break validate_interval;
                } // linear scan
                // binary search
                while(i1 < right){
                    const mid = i1 + right >>> 1;
                    if (t < pp[mid]) right = mid;
                    else i1 = mid + 1;
                }
                t1 = pp[i1];
                t0 = pp[i1 - 1];
                // check boundary cases, again
                if (t0 === undefined) {
                    this._cachedIndex = 0;
                    return this.copySampleValue_(0);
                }
                if (t1 === undefined) {
                    i1 = pp.length;
                    this._cachedIndex = i1;
                    return this.copySampleValue_(i1 - 1);
                }
            } // seek
            this._cachedIndex = i1;
            this.intervalChanged_(i1, t0, t1);
        } // validate_interval
        return this.interpolate_(i1, t0, t, t1);
    }
    getSettings_() {
        return this.settings || this.DefaultSettings_;
    }
    copySampleValue_(index) {
        // copies a sample value to the result buffer
        const result = this.resultBuffer, values = this.sampleValues, stride = this.valueSize, offset = index * stride;
        for(let i = 0; i !== stride; ++i)result[i] = values[offset + i];
        return result;
    }
    // Template methods for derived classes:
    interpolate_() {
        throw new Error("call to abstract method");
    // implementations shall return this.resultBuffer
    }
    intervalChanged_() {
    // empty
    }
    constructor(parameterPositions, sampleValues, sampleSize, resultBuffer){
        this.parameterPositions = parameterPositions;
        this._cachedIndex = 0;
        this.resultBuffer = resultBuffer !== undefined ? resultBuffer : new sampleValues.constructor(sampleSize);
        this.sampleValues = sampleValues;
        this.valueSize = sampleSize;
        this.settings = null;
        this.DefaultSettings_ = {};
    }
}
/**
 * Fast and simple cubic spline interpolant.
 *
 * It was derived from a Hermitian construction setting the first derivative
 * at each sample position to the linear slope between neighboring positions
 * over their parameter interval.
 */ class $9014d97cd777be10$export$3646682e7a3959 extends $9014d97cd777be10$export$b558baee9c0f72d3 {
    intervalChanged_(i1, t0, t1) {
        const pp = this.parameterPositions;
        let iPrev = i1 - 2, iNext = i1 + 1, tPrev = pp[iPrev], tNext = pp[iNext];
        if (tPrev === undefined) switch(this.getSettings_().endingStart){
            case $9014d97cd777be10$export$24a4ccb5099273b5:
                // f'(t0) = 0
                iPrev = i1;
                tPrev = 2 * t0 - t1;
                break;
            case $9014d97cd777be10$export$8e8c3ecdcd8e1fee:
                // use the other end of the curve
                iPrev = pp.length - 2;
                tPrev = t0 + pp[iPrev] - pp[iPrev + 1];
                break;
            default:
                // f''(t0) = 0 a.k.a. Natural Spline
                iPrev = i1;
                tPrev = t1;
        }
        if (tNext === undefined) switch(this.getSettings_().endingEnd){
            case $9014d97cd777be10$export$24a4ccb5099273b5:
                // f'(tN) = 0
                iNext = i1;
                tNext = 2 * t1 - t0;
                break;
            case $9014d97cd777be10$export$8e8c3ecdcd8e1fee:
                // use the other end of the curve
                iNext = 1;
                tNext = t1 + pp[1] - pp[0];
                break;
            default:
                // f''(tN) = 0, a.k.a. Natural Spline
                iNext = i1 - 1;
                tNext = t0;
        }
        const halfDt = (t1 - t0) * 0.5, stride = this.valueSize;
        this._weightPrev = halfDt / (t0 - tPrev);
        this._weightNext = halfDt / (tNext - t1);
        this._offsetPrev = iPrev * stride;
        this._offsetNext = iNext * stride;
    }
    interpolate_(i1, t0, t, t1) {
        const result = this.resultBuffer, values = this.sampleValues, stride = this.valueSize, o1 = i1 * stride, o0 = o1 - stride, oP = this._offsetPrev, oN = this._offsetNext, wP = this._weightPrev, wN = this._weightNext, p = (t - t0) / (t1 - t0), pp = p * p, ppp = pp * p;
        // evaluate polynomials
        const sP = -wP * ppp + 2 * wP * pp - wP * p;
        const s0 = (1 + wP) * ppp + (-1.5 - 2 * wP) * pp + (-0.5 + wP) * p + 1;
        const s1 = (-1 - wN) * ppp + (1.5 + wN) * pp + 0.5 * p;
        const sN = wN * ppp - wN * pp;
        // combine data linearly
        for(let i = 0; i !== stride; ++i)result[i] = sP * values[oP + i] + s0 * values[o0 + i] + s1 * values[o1 + i] + sN * values[oN + i];
        return result;
    }
    constructor(parameterPositions, sampleValues, sampleSize, resultBuffer){
        super(parameterPositions, sampleValues, sampleSize, resultBuffer);
        this._weightPrev = -0;
        this._offsetPrev = -0;
        this._weightNext = -0;
        this._offsetNext = -0;
        this.DefaultSettings_ = {
            endingStart: $9014d97cd777be10$export$7f795934b84ab523,
            endingEnd: $9014d97cd777be10$export$7f795934b84ab523
        };
    }
}
class $9014d97cd777be10$export$a8e6009059f51e1a extends $9014d97cd777be10$export$b558baee9c0f72d3 {
    interpolate_(i1, t0, t, t1) {
        const result = this.resultBuffer, values = this.sampleValues, stride = this.valueSize, offset1 = i1 * stride, offset0 = offset1 - stride, weight1 = (t - t0) / (t1 - t0), weight0 = 1 - weight1;
        for(let i = 0; i !== stride; ++i)result[i] = values[offset0 + i] * weight0 + values[offset1 + i] * weight1;
        return result;
    }
    constructor(parameterPositions, sampleValues, sampleSize, resultBuffer){
        super(parameterPositions, sampleValues, sampleSize, resultBuffer);
    }
}
/**
 *
 * Interpolant that evaluates to the sample value at the position preceding
 * the parameter.
 */ class $9014d97cd777be10$export$fb9758ef7ef8d5cc extends $9014d97cd777be10$export$b558baee9c0f72d3 {
    interpolate_(i1 /*, t0, t, t1 */ ) {
        return this.copySampleValue_(i1 - 1);
    }
    constructor(parameterPositions, sampleValues, sampleSize, resultBuffer){
        super(parameterPositions, sampleValues, sampleSize, resultBuffer);
    }
}
class $9014d97cd777be10$export$b0e479f45b7006d6 {
    // Serialization (in static context, because of constructor invocation
    // and automatic invocation of .toJSON):
    static toJSON(track) {
        const trackType = track.constructor;
        let json;
        // derived classes can define a static toJSON method
        if (trackType.toJSON !== this.toJSON) json = trackType.toJSON(track);
        else {
            // by default, we assume the data can be serialized as-is
            json = {
                "name": track.name,
                "times": $9014d97cd777be10$var$convertArray(track.times, Array),
                "values": $9014d97cd777be10$var$convertArray(track.values, Array)
            };
            const interpolation = track.getInterpolation();
            if (interpolation !== track.DefaultInterpolation) json.interpolation = interpolation;
        }
        json.type = track.ValueTypeName; // mandatory
        return json;
    }
    InterpolantFactoryMethodDiscrete(result) {
        return new $9014d97cd777be10$export$fb9758ef7ef8d5cc(this.times, this.values, this.getValueSize(), result);
    }
    InterpolantFactoryMethodLinear(result) {
        return new $9014d97cd777be10$export$a8e6009059f51e1a(this.times, this.values, this.getValueSize(), result);
    }
    InterpolantFactoryMethodSmooth(result) {
        return new $9014d97cd777be10$export$3646682e7a3959(this.times, this.values, this.getValueSize(), result);
    }
    setInterpolation(interpolation) {
        let factoryMethod;
        switch(interpolation){
            case $9014d97cd777be10$export$995b32462a65e855:
                factoryMethod = this.InterpolantFactoryMethodDiscrete;
                break;
            case $9014d97cd777be10$export$30fac1aace31cf4d:
                factoryMethod = this.InterpolantFactoryMethodLinear;
                break;
            case $9014d97cd777be10$export$198b11ff4c72bb30:
                factoryMethod = this.InterpolantFactoryMethodSmooth;
                break;
        }
        if (factoryMethod === undefined) {
            const message = "unsupported interpolation for " + this.ValueTypeName + " keyframe track named " + this.name;
            if (this.createInterpolant === undefined) {
                // fall back to default, unless the default itself is messed up
                if (interpolation !== this.DefaultInterpolation) this.setInterpolation(this.DefaultInterpolation);
                else throw new Error(message); // fatal, in this case
            }
            console.warn("THREE.KeyframeTrack:", message);
            return this;
        }
        this.createInterpolant = factoryMethod;
        return this;
    }
    getInterpolation() {
        switch(this.createInterpolant){
            case this.InterpolantFactoryMethodDiscrete:
                return $9014d97cd777be10$export$995b32462a65e855;
            case this.InterpolantFactoryMethodLinear:
                return $9014d97cd777be10$export$30fac1aace31cf4d;
            case this.InterpolantFactoryMethodSmooth:
                return $9014d97cd777be10$export$198b11ff4c72bb30;
        }
    }
    getValueSize() {
        return this.values.length / this.times.length;
    }
    // move all keyframes either forwards or backwards in time
    shift(timeOffset) {
        if (timeOffset !== 0.0) {
            const times = this.times;
            for(let i = 0, n = times.length; i !== n; ++i)times[i] += timeOffset;
        }
        return this;
    }
    // scale all keyframe times by a factor (useful for frame <-> seconds conversions)
    scale(timeScale) {
        if (timeScale !== 1.0) {
            const times = this.times;
            for(let i = 0, n = times.length; i !== n; ++i)times[i] *= timeScale;
        }
        return this;
    }
    // removes keyframes before and after animation without changing any values within the range [startTime, endTime].
    // IMPORTANT: We do not shift around keys to the start of the track time, because for interpolated keys this will change their values
    trim(startTime, endTime) {
        const times = this.times, nKeys = times.length;
        let from = 0, to = nKeys - 1;
        while(from !== nKeys && times[from] < startTime)++from;
        while(to !== -1 && times[to] > endTime)--to;
        ++to; // inclusive -> exclusive bound
        if (from !== 0 || to !== nKeys) {
            // empty tracks are forbidden, so keep at least one keyframe
            if (from >= to) {
                to = Math.max(to, 1);
                from = to - 1;
            }
            const stride = this.getValueSize();
            this.times = $9014d97cd777be10$var$arraySlice(times, from, to);
            this.values = $9014d97cd777be10$var$arraySlice(this.values, from * stride, to * stride);
        }
        return this;
    }
    // ensure we do not get a GarbageInGarbageOut situation, make sure tracks are at least minimally viable
    validate() {
        let valid = true;
        const valueSize = this.getValueSize();
        if (valueSize - Math.floor(valueSize) !== 0) {
            console.error("THREE.KeyframeTrack: Invalid value size in track.", this);
            valid = false;
        }
        const times = this.times, values = this.values, nKeys = times.length;
        if (nKeys === 0) {
            console.error("THREE.KeyframeTrack: Track is empty.", this);
            valid = false;
        }
        let prevTime = null;
        for(let i = 0; i !== nKeys; i++){
            const currTime = times[i];
            if (typeof currTime === "number" && isNaN(currTime)) {
                console.error("THREE.KeyframeTrack: Time is not a valid number.", this, i, currTime);
                valid = false;
                break;
            }
            if (prevTime !== null && prevTime > currTime) {
                console.error("THREE.KeyframeTrack: Out of order keys.", this, i, currTime, prevTime);
                valid = false;
                break;
            }
            prevTime = currTime;
        }
        if (values !== undefined) {
            if ($9014d97cd777be10$var$isTypedArray(values)) for(let i = 0, n = values.length; i !== n; ++i){
                const value = values[i];
                if (isNaN(value)) {
                    console.error("THREE.KeyframeTrack: Value is not a valid number.", this, i, value);
                    valid = false;
                    break;
                }
            }
        }
        return valid;
    }
    // removes equivalent sequential keys as common in morph target sequences
    // (0,0,0,0,1,1,1,0,0,0,0,0,0,0) --> (0,0,1,1,0,0)
    optimize() {
        // times or values may be shared with other tracks, so overwriting is unsafe
        const times = $9014d97cd777be10$var$arraySlice(this.times), values = $9014d97cd777be10$var$arraySlice(this.values), stride = this.getValueSize(), smoothInterpolation = this.getInterpolation() === $9014d97cd777be10$export$198b11ff4c72bb30, lastIndex = times.length - 1;
        let writeIndex = 1;
        for(let i = 1; i < lastIndex; ++i){
            let keep = false;
            const time = times[i];
            const timeNext = times[i + 1];
            // remove adjacent keyframes scheduled at the same time
            if (time !== timeNext && (i !== 1 || time !== times[0])) {
                if (!smoothInterpolation) {
                    // remove unnecessary keyframes same as their neighbors
                    const offset = i * stride, offsetP = offset - stride, offsetN = offset + stride;
                    for(let j = 0; j !== stride; ++j){
                        const value = values[offset + j];
                        if (value !== values[offsetP + j] || value !== values[offsetN + j]) {
                            keep = true;
                            break;
                        }
                    }
                } else keep = true;
            }
            // in-place compaction
            if (keep) {
                if (i !== writeIndex) {
                    times[writeIndex] = times[i];
                    const readOffset = i * stride, writeOffset = writeIndex * stride;
                    for(let j = 0; j !== stride; ++j)values[writeOffset + j] = values[readOffset + j];
                }
                ++writeIndex;
            }
        }
        // flush last keyframe (compaction looks ahead)
        if (lastIndex > 0) {
            times[writeIndex] = times[lastIndex];
            for(let readOffset = lastIndex * stride, writeOffset = writeIndex * stride, j = 0; j !== stride; ++j)values[writeOffset + j] = values[readOffset + j];
            ++writeIndex;
        }
        if (writeIndex !== times.length) {
            this.times = $9014d97cd777be10$var$arraySlice(times, 0, writeIndex);
            this.values = $9014d97cd777be10$var$arraySlice(values, 0, writeIndex * stride);
        } else {
            this.times = times;
            this.values = values;
        }
        return this;
    }
    clone() {
        const times = $9014d97cd777be10$var$arraySlice(this.times, 0);
        const values = $9014d97cd777be10$var$arraySlice(this.values, 0);
        const TypedKeyframeTrack = this.constructor;
        const track = new TypedKeyframeTrack(this.name, times, values);
        // Interpolant argument to constructor is not saved, so copy the factory method directly.
        track.createInterpolant = this.createInterpolant;
        return track;
    }
    constructor(name, times, values, interpolation){
        if (name === undefined) throw new Error("THREE.KeyframeTrack: track name is undefined");
        if (times === undefined || times.length === 0) throw new Error("THREE.KeyframeTrack: no keyframes in track named " + name);
        this.name = name;
        this.times = $9014d97cd777be10$var$convertArray(times, this.TimeBufferType);
        this.values = $9014d97cd777be10$var$convertArray(values, this.ValueBufferType);
        this.setInterpolation(interpolation || this.DefaultInterpolation);
    }
}
$9014d97cd777be10$export$b0e479f45b7006d6.prototype.TimeBufferType = Float32Array;
$9014d97cd777be10$export$b0e479f45b7006d6.prototype.ValueBufferType = Float32Array;
$9014d97cd777be10$export$b0e479f45b7006d6.prototype.DefaultInterpolation = $9014d97cd777be10$export$30fac1aace31cf4d;
/**
 * A Track of Boolean keyframe values.
 */ class $9014d97cd777be10$export$d3a344b98cf0b775 extends $9014d97cd777be10$export$b0e479f45b7006d6 {
}
$9014d97cd777be10$export$d3a344b98cf0b775.prototype.ValueTypeName = "bool";
$9014d97cd777be10$export$d3a344b98cf0b775.prototype.ValueBufferType = Array;
$9014d97cd777be10$export$d3a344b98cf0b775.prototype.DefaultInterpolation = $9014d97cd777be10$export$995b32462a65e855;
$9014d97cd777be10$export$d3a344b98cf0b775.prototype.InterpolantFactoryMethodLinear = undefined;
$9014d97cd777be10$export$d3a344b98cf0b775.prototype.InterpolantFactoryMethodSmooth = undefined;
/**
 * A Track of keyframe values that represent color.
 */ class $9014d97cd777be10$export$83444c5d885347d8 extends $9014d97cd777be10$export$b0e479f45b7006d6 {
}
$9014d97cd777be10$export$83444c5d885347d8.prototype.ValueTypeName = "color";
/**
 * A Track of numeric keyframe values.
 */ class $9014d97cd777be10$export$d45f0d1a4d9a9314 extends $9014d97cd777be10$export$b0e479f45b7006d6 {
}
$9014d97cd777be10$export$d45f0d1a4d9a9314.prototype.ValueTypeName = "number";
/**
 * Spherical linear unit quaternion interpolant.
 */ class $9014d97cd777be10$export$2db1cfb7923d931e extends $9014d97cd777be10$export$b558baee9c0f72d3 {
    interpolate_(i1, t0, t, t1) {
        const result = this.resultBuffer, values = this.sampleValues, stride = this.valueSize, alpha = (t - t0) / (t1 - t0);
        let offset = i1 * stride;
        for(let end = offset + stride; offset !== end; offset += 4)$9014d97cd777be10$export$23d6a54f0bbc85a3.slerpFlat(result, 0, values, offset - stride, values, offset, alpha);
        return result;
    }
    constructor(parameterPositions, sampleValues, sampleSize, resultBuffer){
        super(parameterPositions, sampleValues, sampleSize, resultBuffer);
    }
}
/**
 * A Track of quaternion keyframe values.
 */ class $9014d97cd777be10$export$b8043f12b5aafbd7 extends $9014d97cd777be10$export$b0e479f45b7006d6 {
    InterpolantFactoryMethodLinear(result) {
        return new $9014d97cd777be10$export$2db1cfb7923d931e(this.times, this.values, this.getValueSize(), result);
    }
}
$9014d97cd777be10$export$b8043f12b5aafbd7.prototype.ValueTypeName = "quaternion";
// ValueBufferType is inherited
$9014d97cd777be10$export$b8043f12b5aafbd7.prototype.DefaultInterpolation = $9014d97cd777be10$export$30fac1aace31cf4d;
$9014d97cd777be10$export$b8043f12b5aafbd7.prototype.InterpolantFactoryMethodSmooth = undefined;
/**
 * A Track that interpolates Strings
 */ class $9014d97cd777be10$export$6ce41d4f3a8df9cd extends $9014d97cd777be10$export$b0e479f45b7006d6 {
}
$9014d97cd777be10$export$6ce41d4f3a8df9cd.prototype.ValueTypeName = "string";
$9014d97cd777be10$export$6ce41d4f3a8df9cd.prototype.ValueBufferType = Array;
$9014d97cd777be10$export$6ce41d4f3a8df9cd.prototype.DefaultInterpolation = $9014d97cd777be10$export$995b32462a65e855;
$9014d97cd777be10$export$6ce41d4f3a8df9cd.prototype.InterpolantFactoryMethodLinear = undefined;
$9014d97cd777be10$export$6ce41d4f3a8df9cd.prototype.InterpolantFactoryMethodSmooth = undefined;
/**
 * A Track of vectored keyframe values.
 */ class $9014d97cd777be10$export$5ce2dcb4cc9f2bff extends $9014d97cd777be10$export$b0e479f45b7006d6 {
}
$9014d97cd777be10$export$5ce2dcb4cc9f2bff.prototype.ValueTypeName = "vector";
class $9014d97cd777be10$export$d942c706bf23829c {
    static parse(json) {
        const tracks = [], jsonTracks = json.tracks, frameTime = 1.0 / (json.fps || 1.0);
        for(let i = 0, n = jsonTracks.length; i !== n; ++i)tracks.push($9014d97cd777be10$var$parseKeyframeTrack(jsonTracks[i]).scale(frameTime));
        const clip = new this(json.name, json.duration, tracks, json.blendMode);
        clip.uuid = json.uuid;
        return clip;
    }
    static toJSON(clip) {
        const tracks = [], clipTracks = clip.tracks;
        const json = {
            "name": clip.name,
            "duration": clip.duration,
            "tracks": tracks,
            "uuid": clip.uuid,
            "blendMode": clip.blendMode
        };
        for(let i = 0, n = clipTracks.length; i !== n; ++i)tracks.push($9014d97cd777be10$export$b0e479f45b7006d6.toJSON(clipTracks[i]));
        return json;
    }
    static CreateFromMorphTargetSequence(name, morphTargetSequence, fps, noLoop) {
        const numMorphTargets = morphTargetSequence.length;
        const tracks = [];
        for(let i = 0; i < numMorphTargets; i++){
            let times = [];
            let values = [];
            times.push((i + numMorphTargets - 1) % numMorphTargets, i, (i + 1) % numMorphTargets);
            values.push(0, 1, 0);
            const order = $9014d97cd777be10$var$getKeyframeOrder(times);
            times = $9014d97cd777be10$var$sortedArray(times, 1, order);
            values = $9014d97cd777be10$var$sortedArray(values, 1, order);
            // if there is a key at the first frame, duplicate it as the
            // last frame as well for perfect loop.
            if (!noLoop && times[0] === 0) {
                times.push(numMorphTargets);
                values.push(values[0]);
            }
            tracks.push(new $9014d97cd777be10$export$d45f0d1a4d9a9314(".morphTargetInfluences[" + morphTargetSequence[i].name + "]", times, values).scale(1.0 / fps));
        }
        return new this(name, -1, tracks);
    }
    static findByName(objectOrClipArray, name) {
        let clipArray = objectOrClipArray;
        if (!Array.isArray(objectOrClipArray)) {
            const o = objectOrClipArray;
            clipArray = o.geometry && o.geometry.animations || o.animations;
        }
        for(let i = 0; i < clipArray.length; i++){
            if (clipArray[i].name === name) return clipArray[i];
        }
        return null;
    }
    static CreateClipsFromMorphTargetSequences(morphTargets, fps, noLoop) {
        const animationToMorphTargets = {};
        // tested with https://regex101.com/ on trick sequences
        // such flamingo_flyA_003, flamingo_run1_003, crdeath0059
        const pattern = /^([\w-]*?)([\d]+)$/;
        // sort morph target names into animation groups based
        // patterns like Walk_001, Walk_002, Run_001, Run_002
        for(let i = 0, il = morphTargets.length; i < il; i++){
            const morphTarget = morphTargets[i];
            const parts = morphTarget.name.match(pattern);
            if (parts && parts.length > 1) {
                const name = parts[1];
                let animationMorphTargets = animationToMorphTargets[name];
                if (!animationMorphTargets) animationToMorphTargets[name] = animationMorphTargets = [];
                animationMorphTargets.push(morphTarget);
            }
        }
        const clips = [];
        for(const name in animationToMorphTargets)clips.push(this.CreateFromMorphTargetSequence(name, animationToMorphTargets[name], fps, noLoop));
        return clips;
    }
    // parse the animation.hierarchy format
    static parseAnimation(animation, bones) {
        if (!animation) {
            console.error("THREE.AnimationClip: No animation in JSONLoader data.");
            return null;
        }
        const addNonemptyTrack = function(trackType, trackName, animationKeys, propertyName, destTracks) {
            // only return track if there are actually keys.
            if (animationKeys.length !== 0) {
                const times = [];
                const values = [];
                $9014d97cd777be10$var$flattenJSON(animationKeys, times, values, propertyName);
                // empty keys are filtered out, so check again
                if (times.length !== 0) destTracks.push(new trackType(trackName, times, values));
            }
        };
        const tracks = [];
        const clipName = animation.name || "default";
        const fps = animation.fps || 30;
        const blendMode = animation.blendMode;
        // automatic length determination in AnimationClip.
        let duration = animation.length || -1;
        const hierarchyTracks = animation.hierarchy || [];
        for(let h = 0; h < hierarchyTracks.length; h++){
            const animationKeys = hierarchyTracks[h].keys;
            // skip empty tracks
            if (!animationKeys || animationKeys.length === 0) continue;
            // process morph targets
            if (animationKeys[0].morphTargets) {
                // figure out all morph targets used in this track
                const morphTargetNames = {};
                let k;
                for(k = 0; k < animationKeys.length; k++){
                    if (animationKeys[k].morphTargets) for(let m = 0; m < animationKeys[k].morphTargets.length; m++)morphTargetNames[animationKeys[k].morphTargets[m]] = -1;
                }
                // create a track for each morph target with all zero
                // morphTargetInfluences except for the keys in which
                // the morphTarget is named.
                for(const morphTargetName in morphTargetNames){
                    const times = [];
                    const values = [];
                    for(let m = 0; m !== animationKeys[k].morphTargets.length; ++m){
                        const animationKey = animationKeys[k];
                        times.push(animationKey.time);
                        values.push(animationKey.morphTarget === morphTargetName ? 1 : 0);
                    }
                    tracks.push(new $9014d97cd777be10$export$d45f0d1a4d9a9314(".morphTargetInfluence[" + morphTargetName + "]", times, values));
                }
                duration = morphTargetNames.length * fps;
            } else {
                // ...assume skeletal animation
                const boneName = ".bones[" + bones[h].name + "]";
                addNonemptyTrack($9014d97cd777be10$export$5ce2dcb4cc9f2bff, boneName + ".position", animationKeys, "pos", tracks);
                addNonemptyTrack($9014d97cd777be10$export$b8043f12b5aafbd7, boneName + ".quaternion", animationKeys, "rot", tracks);
                addNonemptyTrack($9014d97cd777be10$export$5ce2dcb4cc9f2bff, boneName + ".scale", animationKeys, "scl", tracks);
            }
        }
        if (tracks.length === 0) return null;
        const clip = new this(clipName, duration, tracks, blendMode);
        return clip;
    }
    resetDuration() {
        const tracks = this.tracks;
        let duration = 0;
        for(let i = 0, n = tracks.length; i !== n; ++i){
            const track = this.tracks[i];
            duration = Math.max(duration, track.times[track.times.length - 1]);
        }
        this.duration = duration;
        return this;
    }
    trim() {
        for(let i = 0; i < this.tracks.length; i++)this.tracks[i].trim(0, this.duration);
        return this;
    }
    validate() {
        let valid = true;
        for(let i = 0; i < this.tracks.length; i++)valid = valid && this.tracks[i].validate();
        return valid;
    }
    optimize() {
        for(let i = 0; i < this.tracks.length; i++)this.tracks[i].optimize();
        return this;
    }
    clone() {
        const tracks = [];
        for(let i = 0; i < this.tracks.length; i++)tracks.push(this.tracks[i].clone());
        return new this.constructor(this.name, this.duration, tracks, this.blendMode);
    }
    toJSON() {
        return this.constructor.toJSON(this);
    }
    constructor(name, duration = -1, tracks, blendMode = $9014d97cd777be10$export$bcfbbdcf8de7f8cd){
        this.name = name;
        this.tracks = tracks;
        this.duration = duration;
        this.blendMode = blendMode;
        this.uuid = $9014d97cd777be10$var$generateUUID();
        // this means it should figure out its duration by scanning the tracks
        if (this.duration < 0) this.resetDuration();
    }
}
function $9014d97cd777be10$var$getTrackTypeForValueTypeName(typeName) {
    switch(typeName.toLowerCase()){
        case "scalar":
        case "double":
        case "float":
        case "number":
        case "integer":
            return $9014d97cd777be10$export$d45f0d1a4d9a9314;
        case "vector":
        case "vector2":
        case "vector3":
        case "vector4":
            return $9014d97cd777be10$export$5ce2dcb4cc9f2bff;
        case "color":
            return $9014d97cd777be10$export$83444c5d885347d8;
        case "quaternion":
            return $9014d97cd777be10$export$b8043f12b5aafbd7;
        case "bool":
        case "boolean":
            return $9014d97cd777be10$export$d3a344b98cf0b775;
        case "string":
            return $9014d97cd777be10$export$6ce41d4f3a8df9cd;
    }
    throw new Error("THREE.KeyframeTrack: Unsupported typeName: " + typeName);
}
function $9014d97cd777be10$var$parseKeyframeTrack(json) {
    if (json.type === undefined) throw new Error("THREE.KeyframeTrack: track type undefined, can not parse");
    const trackType = $9014d97cd777be10$var$getTrackTypeForValueTypeName(json.type);
    if (json.times === undefined) {
        const times = [], values = [];
        $9014d97cd777be10$var$flattenJSON(json.keys, times, values, "value");
        json.times = times;
        json.values = values;
    }
    // derived classes can define a static parse method
    if (trackType.parse !== undefined) return trackType.parse(json);
    else // by default, we assume a constructor compatible with the base
    return new trackType(json.name, json.times, json.values, json.interpolation);
}
const $9014d97cd777be10$export$94affb487e701bf2 = {
    enabled: false,
    files: {},
    add: function(key, file) {
        if (this.enabled === false) return;
        // console.log( 'THREE.Cache', 'Adding key:', key );
        this.files[key] = file;
    },
    get: function(key) {
        if (this.enabled === false) return;
        // console.log( 'THREE.Cache', 'Checking key:', key );
        return this.files[key];
    },
    remove: function(key) {
        delete this.files[key];
    },
    clear: function() {
        this.files = {};
    }
};
class $9014d97cd777be10$export$99cc795e99919eed {
    constructor(onLoad, onProgress, onError){
        const scope = this;
        let isLoading = false;
        let itemsLoaded = 0;
        let itemsTotal = 0;
        let urlModifier = undefined;
        const handlers = [];
        // Refer to #5689 for the reason why we don't set .onStart
        // in the constructor
        this.onStart = undefined;
        this.onLoad = onLoad;
        this.onProgress = onProgress;
        this.onError = onError;
        this.itemStart = function(url) {
            itemsTotal++;
            if (isLoading === false) {
                if (scope.onStart !== undefined) scope.onStart(url, itemsLoaded, itemsTotal);
            }
            isLoading = true;
        };
        this.itemEnd = function(url) {
            itemsLoaded++;
            if (scope.onProgress !== undefined) scope.onProgress(url, itemsLoaded, itemsTotal);
            if (itemsLoaded === itemsTotal) {
                isLoading = false;
                if (scope.onLoad !== undefined) scope.onLoad();
            }
        };
        this.itemError = function(url) {
            if (scope.onError !== undefined) scope.onError(url);
        };
        this.resolveURL = function(url) {
            if (urlModifier) return urlModifier(url);
            return url;
        };
        this.setURLModifier = function(transform) {
            urlModifier = transform;
            return this;
        };
        this.addHandler = function(regex, loader) {
            handlers.push(regex, loader);
            return this;
        };
        this.removeHandler = function(regex) {
            const index = handlers.indexOf(regex);
            if (index !== -1) handlers.splice(index, 2);
            return this;
        };
        this.getHandler = function(file) {
            for(let i = 0, l = handlers.length; i < l; i += 2){
                const regex = handlers[i];
                const loader = handlers[i + 1];
                if (regex.global) regex.lastIndex = 0; // see #17920
                if (regex.test(file)) return loader;
            }
            return null;
        };
    }
}
const $9014d97cd777be10$export$b033c3f9a95c6a16 = /*@__PURE__*/ new $9014d97cd777be10$export$99cc795e99919eed();
class $9014d97cd777be10$export$3b0d6d7590275603 {
    load() {}
    loadAsync(url, onProgress) {
        const scope = this;
        return new Promise(function(resolve, reject) {
            scope.load(url, resolve, onProgress, reject);
        });
    }
    parse() {}
    setCrossOrigin(crossOrigin) {
        this.crossOrigin = crossOrigin;
        return this;
    }
    setWithCredentials(value) {
        this.withCredentials = value;
        return this;
    }
    setPath(path) {
        this.path = path;
        return this;
    }
    setResourcePath(resourcePath) {
        this.resourcePath = resourcePath;
        return this;
    }
    setRequestHeader(requestHeader) {
        this.requestHeader = requestHeader;
        return this;
    }
    constructor(manager){
        this.manager = manager !== undefined ? manager : $9014d97cd777be10$export$b033c3f9a95c6a16;
        this.crossOrigin = "anonymous";
        this.withCredentials = false;
        this.path = "";
        this.resourcePath = "";
        this.requestHeader = {};
    }
}
$9014d97cd777be10$export$3b0d6d7590275603.DEFAULT_MATERIAL_NAME = "__DEFAULT";
const $9014d97cd777be10$var$loading = {};
class $9014d97cd777be10$var$HttpError extends Error {
    constructor(message, response){
        super(message);
        this.response = response;
    }
}
class $9014d97cd777be10$export$98435a25b5cf7b2b extends $9014d97cd777be10$export$3b0d6d7590275603 {
    load(url, onLoad, onProgress, onError) {
        if (url === undefined) url = "";
        if (this.path !== undefined) url = this.path + url;
        url = this.manager.resolveURL(url);
        const cached = $9014d97cd777be10$export$94affb487e701bf2.get(url);
        if (cached !== undefined) {
            this.manager.itemStart(url);
            setTimeout(()=>{
                if (onLoad) onLoad(cached);
                this.manager.itemEnd(url);
            }, 0);
            return cached;
        }
        // Check if request is duplicate
        if ($9014d97cd777be10$var$loading[url] !== undefined) {
            $9014d97cd777be10$var$loading[url].push({
                onLoad: onLoad,
                onProgress: onProgress,
                onError: onError
            });
            return;
        }
        // Initialise array for duplicate requests
        $9014d97cd777be10$var$loading[url] = [];
        $9014d97cd777be10$var$loading[url].push({
            onLoad: onLoad,
            onProgress: onProgress,
            onError: onError
        });
        // create request
        const req = new Request(url, {
            headers: new Headers(this.requestHeader),
            credentials: this.withCredentials ? "include" : "same-origin"
        });
        // record states ( avoid data race )
        const mimeType = this.mimeType;
        const responseType = this.responseType;
        // start the fetch
        fetch(req).then((response)=>{
            if (response.status === 200 || response.status === 0) {
                // Some browsers return HTTP Status 0 when using non-http protocol
                // e.g. 'file://' or 'data://'. Handle as success.
                if (response.status === 0) console.warn("THREE.FileLoader: HTTP Status 0 received.");
                // Workaround: Checking if response.body === undefined for Alipay browser #23548
                if (typeof ReadableStream === "undefined" || response.body === undefined || response.body.getReader === undefined) return response;
                const callbacks = $9014d97cd777be10$var$loading[url];
                const reader = response.body.getReader();
                // Nginx needs X-File-Size check
                // https://serverfault.com/questions/482875/why-does-nginx-remove-content-length-header-for-chunked-content
                const contentLength = response.headers.get("Content-Length") || response.headers.get("X-File-Size");
                const total = contentLength ? parseInt(contentLength) : 0;
                const lengthComputable = total !== 0;
                let loaded = 0;
                // periodically read data into the new stream tracking while download progress
                const stream = new ReadableStream({
                    start (controller) {
                        readData();
                        function readData() {
                            reader.read().then(({ done: done, value: value })=>{
                                if (done) controller.close();
                                else {
                                    loaded += value.byteLength;
                                    const event = new ProgressEvent("progress", {
                                        lengthComputable: lengthComputable,
                                        loaded: loaded,
                                        total: total
                                    });
                                    for(let i = 0, il = callbacks.length; i < il; i++){
                                        const callback = callbacks[i];
                                        if (callback.onProgress) callback.onProgress(event);
                                    }
                                    controller.enqueue(value);
                                    readData();
                                }
                            });
                        }
                    }
                });
                return new Response(stream);
            } else throw new $9014d97cd777be10$var$HttpError(`fetch for "${response.url}" responded with ${response.status}: ${response.statusText}`, response);
        }).then((response)=>{
            switch(responseType){
                case "arraybuffer":
                    return response.arrayBuffer();
                case "blob":
                    return response.blob();
                case "document":
                    return response.text().then((text)=>{
                        const parser = new DOMParser();
                        return parser.parseFromString(text, mimeType);
                    });
                case "json":
                    return response.json();
                default:
                    if (mimeType === undefined) return response.text();
                    else {
                        // sniff encoding
                        const re = /charset="?([^;"\s]*)"?/i;
                        const exec = re.exec(mimeType);
                        const label = exec && exec[1] ? exec[1].toLowerCase() : undefined;
                        const decoder = new TextDecoder(label);
                        return response.arrayBuffer().then((ab)=>decoder.decode(ab));
                    }
            }
        }).then((data)=>{
            // Add to cache only on HTTP success, so that we do not cache
            // error response bodies as proper responses to requests.
            $9014d97cd777be10$export$94affb487e701bf2.add(url, data);
            const callbacks = $9014d97cd777be10$var$loading[url];
            delete $9014d97cd777be10$var$loading[url];
            for(let i = 0, il = callbacks.length; i < il; i++){
                const callback = callbacks[i];
                if (callback.onLoad) callback.onLoad(data);
            }
        }).catch((err)=>{
            // Abort errors and other errors are handled the same
            const callbacks = $9014d97cd777be10$var$loading[url];
            if (callbacks === undefined) {
                // When onLoad was called and url was deleted in `loading`
                this.manager.itemError(url);
                throw err;
            }
            delete $9014d97cd777be10$var$loading[url];
            for(let i = 0, il = callbacks.length; i < il; i++){
                const callback = callbacks[i];
                if (callback.onError) callback.onError(err);
            }
            this.manager.itemError(url);
        }).finally(()=>{
            this.manager.itemEnd(url);
        });
        this.manager.itemStart(url);
    }
    setResponseType(value) {
        this.responseType = value;
        return this;
    }
    setMimeType(value) {
        this.mimeType = value;
        return this;
    }
    constructor(manager){
        super(manager);
    }
}
class $9014d97cd777be10$export$29711c7e14f61db extends $9014d97cd777be10$export$3b0d6d7590275603 {
    load(url, onLoad, onProgress, onError) {
        const scope = this;
        const loader = new $9014d97cd777be10$export$98435a25b5cf7b2b(this.manager);
        loader.setPath(this.path);
        loader.setRequestHeader(this.requestHeader);
        loader.setWithCredentials(this.withCredentials);
        loader.load(url, function(text) {
            try {
                onLoad(scope.parse(JSON.parse(text)));
            } catch (e) {
                if (onError) onError(e);
                else console.error(e);
                scope.manager.itemError(url);
            }
        }, onProgress, onError);
    }
    parse(json) {
        const animations = [];
        for(let i = 0; i < json.length; i++){
            const clip = $9014d97cd777be10$export$d942c706bf23829c.parse(json[i]);
            animations.push(clip);
        }
        return animations;
    }
    constructor(manager){
        super(manager);
    }
}
/**
 * Abstract Base class to block based textures loader (dds, pvr, ...)
 *
 * Sub classes have to implement the parse() method which will be used in load().
 */ class $9014d97cd777be10$export$bd73ce947a280350 extends $9014d97cd777be10$export$3b0d6d7590275603 {
    load(url, onLoad, onProgress, onError) {
        const scope = this;
        const images = [];
        const texture = new $9014d97cd777be10$export$3466bac9141a5cc4();
        const loader = new $9014d97cd777be10$export$98435a25b5cf7b2b(this.manager);
        loader.setPath(this.path);
        loader.setResponseType("arraybuffer");
        loader.setRequestHeader(this.requestHeader);
        loader.setWithCredentials(scope.withCredentials);
        let loaded = 0;
        function loadTexture(i) {
            loader.load(url[i], function(buffer) {
                const texDatas = scope.parse(buffer, true);
                images[i] = {
                    width: texDatas.width,
                    height: texDatas.height,
                    format: texDatas.format,
                    mipmaps: texDatas.mipmaps
                };
                loaded += 1;
                if (loaded === 6) {
                    if (texDatas.mipmapCount === 1) texture.minFilter = $9014d97cd777be10$export$8a72f490b25c56c8;
                    texture.image = images;
                    texture.format = texDatas.format;
                    texture.needsUpdate = true;
                    if (onLoad) onLoad(texture);
                }
            }, onProgress, onError);
        }
        if (Array.isArray(url)) for(let i = 0, il = url.length; i < il; ++i)loadTexture(i);
        else // compressed cubemap texture stored in a single DDS file
        loader.load(url, function(buffer) {
            const texDatas = scope.parse(buffer, true);
            if (texDatas.isCubemap) {
                const faces = texDatas.mipmaps.length / texDatas.mipmapCount;
                for(let f = 0; f < faces; f++){
                    images[f] = {
                        mipmaps: []
                    };
                    for(let i = 0; i < texDatas.mipmapCount; i++){
                        images[f].mipmaps.push(texDatas.mipmaps[f * texDatas.mipmapCount + i]);
                        images[f].format = texDatas.format;
                        images[f].width = texDatas.width;
                        images[f].height = texDatas.height;
                    }
                }
                texture.image = images;
            } else {
                texture.image.width = texDatas.width;
                texture.image.height = texDatas.height;
                texture.mipmaps = texDatas.mipmaps;
            }
            if (texDatas.mipmapCount === 1) texture.minFilter = $9014d97cd777be10$export$8a72f490b25c56c8;
            texture.format = texDatas.format;
            texture.needsUpdate = true;
            if (onLoad) onLoad(texture);
        }, onProgress, onError);
        return texture;
    }
    constructor(manager){
        super(manager);
    }
}
class $9014d97cd777be10$export$8905ce1c7a2464a1 extends $9014d97cd777be10$export$3b0d6d7590275603 {
    load(url, onLoad, onProgress, onError) {
        if (this.path !== undefined) url = this.path + url;
        url = this.manager.resolveURL(url);
        const scope = this;
        const cached = $9014d97cd777be10$export$94affb487e701bf2.get(url);
        if (cached !== undefined) {
            scope.manager.itemStart(url);
            setTimeout(function() {
                if (onLoad) onLoad(cached);
                scope.manager.itemEnd(url);
            }, 0);
            return cached;
        }
        const image = $9014d97cd777be10$var$createElementNS("img");
        function onImageLoad() {
            removeEventListeners();
            $9014d97cd777be10$export$94affb487e701bf2.add(url, this);
            if (onLoad) onLoad(this);
            scope.manager.itemEnd(url);
        }
        function onImageError(event) {
            removeEventListeners();
            if (onError) onError(event);
            scope.manager.itemError(url);
            scope.manager.itemEnd(url);
        }
        function removeEventListeners() {
            image.removeEventListener("load", onImageLoad, false);
            image.removeEventListener("error", onImageError, false);
        }
        image.addEventListener("load", onImageLoad, false);
        image.addEventListener("error", onImageError, false);
        if (url.slice(0, 5) !== "data:") {
            if (this.crossOrigin !== undefined) image.crossOrigin = this.crossOrigin;
        }
        scope.manager.itemStart(url);
        image.src = url;
        return image;
    }
    constructor(manager){
        super(manager);
    }
}
class $9014d97cd777be10$export$2ec114afc2cf6308 extends $9014d97cd777be10$export$3b0d6d7590275603 {
    load(urls, onLoad, onProgress, onError) {
        const texture = new $9014d97cd777be10$export$ee2e5a18258a4049();
        texture.colorSpace = $9014d97cd777be10$export$561f394b24edfcaa;
        const loader = new $9014d97cd777be10$export$8905ce1c7a2464a1(this.manager);
        loader.setCrossOrigin(this.crossOrigin);
        loader.setPath(this.path);
        let loaded = 0;
        function loadTexture(i) {
            loader.load(urls[i], function(image) {
                texture.images[i] = image;
                loaded++;
                if (loaded === 6) {
                    texture.needsUpdate = true;
                    if (onLoad) onLoad(texture);
                }
            }, undefined, onError);
        }
        for(let i = 0; i < urls.length; ++i)loadTexture(i);
        return texture;
    }
    constructor(manager){
        super(manager);
    }
}
/**
 * Abstract Base class to load generic binary textures formats (rgbe, hdr, ...)
 *
 * Sub classes have to implement the parse() method which will be used in load().
 */ class $9014d97cd777be10$export$792d8a18f2c55855 extends $9014d97cd777be10$export$3b0d6d7590275603 {
    load(url, onLoad, onProgress, onError) {
        const scope = this;
        const texture = new $9014d97cd777be10$export$b691f601014eabe1();
        const loader = new $9014d97cd777be10$export$98435a25b5cf7b2b(this.manager);
        loader.setResponseType("arraybuffer");
        loader.setRequestHeader(this.requestHeader);
        loader.setPath(this.path);
        loader.setWithCredentials(scope.withCredentials);
        loader.load(url, function(buffer) {
            let texData;
            try {
                texData = scope.parse(buffer);
            } catch (error) {
                if (onError !== undefined) onError(error);
                else {
                    console.error(error);
                    return;
                }
            }
            if (!texData) return onError(); // TODO: Remove this when all loaders properly throw errors
            if (texData.image !== undefined) texture.image = texData.image;
            else if (texData.data !== undefined) {
                texture.image.width = texData.width;
                texture.image.height = texData.height;
                texture.image.data = texData.data;
            }
            texture.wrapS = texData.wrapS !== undefined ? texData.wrapS : $9014d97cd777be10$export$9d9334239a5a5e06;
            texture.wrapT = texData.wrapT !== undefined ? texData.wrapT : $9014d97cd777be10$export$9d9334239a5a5e06;
            texture.magFilter = texData.magFilter !== undefined ? texData.magFilter : $9014d97cd777be10$export$8a72f490b25c56c8;
            texture.minFilter = texData.minFilter !== undefined ? texData.minFilter : $9014d97cd777be10$export$8a72f490b25c56c8;
            texture.anisotropy = texData.anisotropy !== undefined ? texData.anisotropy : 1;
            if (texData.colorSpace !== undefined) texture.colorSpace = texData.colorSpace;
            else if (texData.encoding !== undefined) texture.encoding = texData.encoding;
            if (texData.flipY !== undefined) texture.flipY = texData.flipY;
            if (texData.format !== undefined) texture.format = texData.format;
            if (texData.type !== undefined) texture.type = texData.type;
            if (texData.mipmaps !== undefined) {
                texture.mipmaps = texData.mipmaps;
                texture.minFilter = $9014d97cd777be10$export$5d8599b6a933fb1b; // presumably...
            }
            if (texData.mipmapCount === 1) texture.minFilter = $9014d97cd777be10$export$8a72f490b25c56c8;
            if (texData.generateMipmaps !== undefined) texture.generateMipmaps = texData.generateMipmaps;
            texture.needsUpdate = true;
            if (onLoad) onLoad(texture, texData);
        }, onProgress, onError);
        return texture;
    }
    constructor(manager){
        super(manager);
    }
}
class $9014d97cd777be10$export$fd1bfc71f64c538c extends $9014d97cd777be10$export$3b0d6d7590275603 {
    load(url, onLoad, onProgress, onError) {
        const texture = new $9014d97cd777be10$export$5431306cf43de24a();
        const loader = new $9014d97cd777be10$export$8905ce1c7a2464a1(this.manager);
        loader.setCrossOrigin(this.crossOrigin);
        loader.setPath(this.path);
        loader.load(url, function(image) {
            texture.image = image;
            texture.needsUpdate = true;
            if (onLoad !== undefined) onLoad(texture);
        }, onProgress, onError);
        return texture;
    }
    constructor(manager){
        super(manager);
    }
}
class $9014d97cd777be10$export$6ecadb6ed240d696 extends $9014d97cd777be10$export$e4dd07dff30cc924 {
    dispose() {
    // Empty here in base class; some subclasses override.
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        this.color.copy(source.color);
        this.intensity = source.intensity;
        return this;
    }
    toJSON(meta) {
        const data = super.toJSON(meta);
        data.object.color = this.color.getHex();
        data.object.intensity = this.intensity;
        if (this.groundColor !== undefined) data.object.groundColor = this.groundColor.getHex();
        if (this.distance !== undefined) data.object.distance = this.distance;
        if (this.angle !== undefined) data.object.angle = this.angle;
        if (this.decay !== undefined) data.object.decay = this.decay;
        if (this.penumbra !== undefined) data.object.penumbra = this.penumbra;
        if (this.shadow !== undefined) data.object.shadow = this.shadow.toJSON();
        return data;
    }
    constructor(color, intensity = 1){
        super();
        this.isLight = true;
        this.type = "Light";
        this.color = new $9014d97cd777be10$export$892596cec99bc70e(color);
        this.intensity = intensity;
    }
}
class $9014d97cd777be10$export$8d474f55edbb9624 extends $9014d97cd777be10$export$6ecadb6ed240d696 {
    copy(source, recursive) {
        super.copy(source, recursive);
        this.groundColor.copy(source.groundColor);
        return this;
    }
    constructor(skyColor, groundColor, intensity){
        super(skyColor, intensity);
        this.isHemisphereLight = true;
        this.type = "HemisphereLight";
        this.position.copy($9014d97cd777be10$export$e4dd07dff30cc924.DEFAULT_UP);
        this.updateMatrix();
        this.groundColor = new $9014d97cd777be10$export$892596cec99bc70e(groundColor);
    }
}
const $9014d97cd777be10$var$_projScreenMatrix$1 = /*@__PURE__*/ new $9014d97cd777be10$export$2ae72fc923e5eb5();
const $9014d97cd777be10$var$_lightPositionWorld$1 = /*@__PURE__*/ new $9014d97cd777be10$export$64b5c384219d3699();
const $9014d97cd777be10$var$_lookTarget$1 = /*@__PURE__*/ new $9014d97cd777be10$export$64b5c384219d3699();
class $9014d97cd777be10$var$LightShadow {
    getViewportCount() {
        return this._viewportCount;
    }
    getFrustum() {
        return this._frustum;
    }
    updateMatrices(light) {
        const shadowCamera = this.camera;
        const shadowMatrix = this.matrix;
        $9014d97cd777be10$var$_lightPositionWorld$1.setFromMatrixPosition(light.matrixWorld);
        shadowCamera.position.copy($9014d97cd777be10$var$_lightPositionWorld$1);
        $9014d97cd777be10$var$_lookTarget$1.setFromMatrixPosition(light.target.matrixWorld);
        shadowCamera.lookAt($9014d97cd777be10$var$_lookTarget$1);
        shadowCamera.updateMatrixWorld();
        $9014d97cd777be10$var$_projScreenMatrix$1.multiplyMatrices(shadowCamera.projectionMatrix, shadowCamera.matrixWorldInverse);
        this._frustum.setFromProjectionMatrix($9014d97cd777be10$var$_projScreenMatrix$1);
        shadowMatrix.set(0.5, 0.0, 0.0, 0.5, 0.0, 0.5, 0.0, 0.5, 0.0, 0.0, 0.5, 0.5, 0.0, 0.0, 0.0, 1.0);
        shadowMatrix.multiply($9014d97cd777be10$var$_projScreenMatrix$1);
    }
    getViewport(viewportIndex) {
        return this._viewports[viewportIndex];
    }
    getFrameExtents() {
        return this._frameExtents;
    }
    dispose() {
        if (this.map) this.map.dispose();
        if (this.mapPass) this.mapPass.dispose();
    }
    copy(source) {
        this.camera = source.camera.clone();
        this.bias = source.bias;
        this.radius = source.radius;
        this.mapSize.copy(source.mapSize);
        return this;
    }
    clone() {
        return new this.constructor().copy(this);
    }
    toJSON() {
        const object = {};
        if (this.bias !== 0) object.bias = this.bias;
        if (this.normalBias !== 0) object.normalBias = this.normalBias;
        if (this.radius !== 1) object.radius = this.radius;
        if (this.mapSize.x !== 512 || this.mapSize.y !== 512) object.mapSize = this.mapSize.toArray();
        object.camera = this.camera.toJSON(false).object;
        delete object.camera.matrix;
        return object;
    }
    constructor(camera){
        this.camera = camera;
        this.bias = 0;
        this.normalBias = 0;
        this.radius = 1;
        this.blurSamples = 8;
        this.mapSize = new $9014d97cd777be10$export$c977b3e384af9ae1(512, 512);
        this.map = null;
        this.mapPass = null;
        this.matrix = new $9014d97cd777be10$export$2ae72fc923e5eb5();
        this.autoUpdate = true;
        this.needsUpdate = false;
        this._frustum = new $9014d97cd777be10$export$35efe6f4c85463d2();
        this._frameExtents = new $9014d97cd777be10$export$c977b3e384af9ae1(1, 1);
        this._viewportCount = 1;
        this._viewports = [
            new $9014d97cd777be10$export$fa7daccca11cdbe3(0, 0, 1, 1)
        ];
    }
}
class $9014d97cd777be10$var$SpotLightShadow extends $9014d97cd777be10$var$LightShadow {
    updateMatrices(light) {
        const camera = this.camera;
        const fov = $9014d97cd777be10$var$RAD2DEG * 2 * light.angle * this.focus;
        const aspect = this.mapSize.width / this.mapSize.height;
        const far = light.distance || camera.far;
        if (fov !== camera.fov || aspect !== camera.aspect || far !== camera.far) {
            camera.fov = fov;
            camera.aspect = aspect;
            camera.far = far;
            camera.updateProjectionMatrix();
        }
        super.updateMatrices(light);
    }
    copy(source) {
        super.copy(source);
        this.focus = source.focus;
        return this;
    }
    constructor(){
        super(new $9014d97cd777be10$export$74e4ae24825f68d7(50, 1, 0.5, 500));
        this.isSpotLightShadow = true;
        this.focus = 1;
    }
}
class $9014d97cd777be10$export$81495cbb73897362 extends $9014d97cd777be10$export$6ecadb6ed240d696 {
    get power() {
        // compute the light's luminous power (in lumens) from its intensity (in candela)
        // by convention for a spotlight, luminous power (lm) = π * luminous intensity (cd)
        return this.intensity * Math.PI;
    }
    set power(power) {
        // set the light's intensity (in candela) from the desired luminous power (in lumens)
        this.intensity = power / Math.PI;
    }
    dispose() {
        this.shadow.dispose();
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        this.distance = source.distance;
        this.angle = source.angle;
        this.penumbra = source.penumbra;
        this.decay = source.decay;
        this.target = source.target.clone();
        this.shadow = source.shadow.clone();
        return this;
    }
    constructor(color, intensity, distance = 0, angle = Math.PI / 3, penumbra = 0, decay = 2){
        super(color, intensity);
        this.isSpotLight = true;
        this.type = "SpotLight";
        this.position.copy($9014d97cd777be10$export$e4dd07dff30cc924.DEFAULT_UP);
        this.updateMatrix();
        this.target = new $9014d97cd777be10$export$e4dd07dff30cc924();
        this.distance = distance;
        this.angle = angle;
        this.penumbra = penumbra;
        this.decay = decay;
        this.map = null;
        this.shadow = new $9014d97cd777be10$var$SpotLightShadow();
    }
}
const $9014d97cd777be10$var$_projScreenMatrix = /*@__PURE__*/ new $9014d97cd777be10$export$2ae72fc923e5eb5();
const $9014d97cd777be10$var$_lightPositionWorld = /*@__PURE__*/ new $9014d97cd777be10$export$64b5c384219d3699();
const $9014d97cd777be10$var$_lookTarget = /*@__PURE__*/ new $9014d97cd777be10$export$64b5c384219d3699();
class $9014d97cd777be10$var$PointLightShadow extends $9014d97cd777be10$var$LightShadow {
    updateMatrices(light, viewportIndex = 0) {
        const camera = this.camera;
        const shadowMatrix = this.matrix;
        const far = light.distance || camera.far;
        if (far !== camera.far) {
            camera.far = far;
            camera.updateProjectionMatrix();
        }
        $9014d97cd777be10$var$_lightPositionWorld.setFromMatrixPosition(light.matrixWorld);
        camera.position.copy($9014d97cd777be10$var$_lightPositionWorld);
        $9014d97cd777be10$var$_lookTarget.copy(camera.position);
        $9014d97cd777be10$var$_lookTarget.add(this._cubeDirections[viewportIndex]);
        camera.up.copy(this._cubeUps[viewportIndex]);
        camera.lookAt($9014d97cd777be10$var$_lookTarget);
        camera.updateMatrixWorld();
        shadowMatrix.makeTranslation(-$9014d97cd777be10$var$_lightPositionWorld.x, -$9014d97cd777be10$var$_lightPositionWorld.y, -$9014d97cd777be10$var$_lightPositionWorld.z);
        $9014d97cd777be10$var$_projScreenMatrix.multiplyMatrices(camera.projectionMatrix, camera.matrixWorldInverse);
        this._frustum.setFromProjectionMatrix($9014d97cd777be10$var$_projScreenMatrix);
    }
    constructor(){
        super(new $9014d97cd777be10$export$74e4ae24825f68d7(90, 1, 0.5, 500));
        this.isPointLightShadow = true;
        this._frameExtents = new $9014d97cd777be10$export$c977b3e384af9ae1(4, 2);
        this._viewportCount = 6;
        this._viewports = [
            // These viewports map a cube-map onto a 2D texture with the
            // following orientation:
            //
            //  xzXZ
            //   y Y
            //
            // X - Positive x direction
            // x - Negative x direction
            // Y - Positive y direction
            // y - Negative y direction
            // Z - Positive z direction
            // z - Negative z direction
            // positive X
            new $9014d97cd777be10$export$fa7daccca11cdbe3(2, 1, 1, 1),
            // negative X
            new $9014d97cd777be10$export$fa7daccca11cdbe3(0, 1, 1, 1),
            // positive Z
            new $9014d97cd777be10$export$fa7daccca11cdbe3(3, 1, 1, 1),
            // negative Z
            new $9014d97cd777be10$export$fa7daccca11cdbe3(1, 1, 1, 1),
            // positive Y
            new $9014d97cd777be10$export$fa7daccca11cdbe3(3, 0, 1, 1),
            // negative Y
            new $9014d97cd777be10$export$fa7daccca11cdbe3(1, 0, 1, 1)
        ];
        this._cubeDirections = [
            new $9014d97cd777be10$export$64b5c384219d3699(1, 0, 0),
            new $9014d97cd777be10$export$64b5c384219d3699(-1, 0, 0),
            new $9014d97cd777be10$export$64b5c384219d3699(0, 0, 1),
            new $9014d97cd777be10$export$64b5c384219d3699(0, 0, -1),
            new $9014d97cd777be10$export$64b5c384219d3699(0, 1, 0),
            new $9014d97cd777be10$export$64b5c384219d3699(0, -1, 0)
        ];
        this._cubeUps = [
            new $9014d97cd777be10$export$64b5c384219d3699(0, 1, 0),
            new $9014d97cd777be10$export$64b5c384219d3699(0, 1, 0),
            new $9014d97cd777be10$export$64b5c384219d3699(0, 1, 0),
            new $9014d97cd777be10$export$64b5c384219d3699(0, 1, 0),
            new $9014d97cd777be10$export$64b5c384219d3699(0, 0, 1),
            new $9014d97cd777be10$export$64b5c384219d3699(0, 0, -1)
        ];
    }
}
class $9014d97cd777be10$export$4c9c1cb3f0b6f455 extends $9014d97cd777be10$export$6ecadb6ed240d696 {
    get power() {
        // compute the light's luminous power (in lumens) from its intensity (in candela)
        // for an isotropic light source, luminous power (lm) = 4 π luminous intensity (cd)
        return this.intensity * 4 * Math.PI;
    }
    set power(power) {
        // set the light's intensity (in candela) from the desired luminous power (in lumens)
        this.intensity = power / (4 * Math.PI);
    }
    dispose() {
        this.shadow.dispose();
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        this.distance = source.distance;
        this.decay = source.decay;
        this.shadow = source.shadow.clone();
        return this;
    }
    constructor(color, intensity, distance = 0, decay = 2){
        super(color, intensity);
        this.isPointLight = true;
        this.type = "PointLight";
        this.distance = distance;
        this.decay = decay;
        this.shadow = new $9014d97cd777be10$var$PointLightShadow();
    }
}
class $9014d97cd777be10$var$DirectionalLightShadow extends $9014d97cd777be10$var$LightShadow {
    constructor(){
        super(new $9014d97cd777be10$export$9ebf355ee4ed261b(-5, 5, 5, -5, 0.5, 500));
        this.isDirectionalLightShadow = true;
    }
}
class $9014d97cd777be10$export$3fea33cc9972c868 extends $9014d97cd777be10$export$6ecadb6ed240d696 {
    dispose() {
        this.shadow.dispose();
    }
    copy(source) {
        super.copy(source);
        this.target = source.target.clone();
        this.shadow = source.shadow.clone();
        return this;
    }
    constructor(color, intensity){
        super(color, intensity);
        this.isDirectionalLight = true;
        this.type = "DirectionalLight";
        this.position.copy($9014d97cd777be10$export$e4dd07dff30cc924.DEFAULT_UP);
        this.updateMatrix();
        this.target = new $9014d97cd777be10$export$e4dd07dff30cc924();
        this.shadow = new $9014d97cd777be10$var$DirectionalLightShadow();
    }
}
class $9014d97cd777be10$export$af279bfef9ec2c96 extends $9014d97cd777be10$export$6ecadb6ed240d696 {
    constructor(color, intensity){
        super(color, intensity);
        this.isAmbientLight = true;
        this.type = "AmbientLight";
    }
}
class $9014d97cd777be10$export$61db2d908bbd2429 extends $9014d97cd777be10$export$6ecadb6ed240d696 {
    get power() {
        // compute the light's luminous power (in lumens) from its intensity (in nits)
        return this.intensity * this.width * this.height * Math.PI;
    }
    set power(power) {
        // set the light's intensity (in nits) from the desired luminous power (in lumens)
        this.intensity = power / (this.width * this.height * Math.PI);
    }
    copy(source) {
        super.copy(source);
        this.width = source.width;
        this.height = source.height;
        return this;
    }
    toJSON(meta) {
        const data = super.toJSON(meta);
        data.object.width = this.width;
        data.object.height = this.height;
        return data;
    }
    constructor(color, intensity, width = 10, height = 10){
        super(color, intensity);
        this.isRectAreaLight = true;
        this.type = "RectAreaLight";
        this.width = width;
        this.height = height;
    }
}
/**
 * Primary reference:
 *   https://graphics.stanford.edu/papers/envmap/envmap.pdf
 *
 * Secondary reference:
 *   https://www.ppsloan.org/publications/StupidSH36.pdf
 */ // 3-band SH defined by 9 coefficients
class $9014d97cd777be10$export$ba61ce607e1f405a {
    set(coefficients) {
        for(let i = 0; i < 9; i++)this.coefficients[i].copy(coefficients[i]);
        return this;
    }
    zero() {
        for(let i = 0; i < 9; i++)this.coefficients[i].set(0, 0, 0);
        return this;
    }
    // get the radiance in the direction of the normal
    // target is a Vector3
    getAt(normal, target) {
        // normal is assumed to be unit length
        const x = normal.x, y = normal.y, z = normal.z;
        const coeff = this.coefficients;
        // band 0
        target.copy(coeff[0]).multiplyScalar(0.282095);
        // band 1
        target.addScaledVector(coeff[1], 0.488603 * y);
        target.addScaledVector(coeff[2], 0.488603 * z);
        target.addScaledVector(coeff[3], 0.488603 * x);
        // band 2
        target.addScaledVector(coeff[4], 1.092548 * (x * y));
        target.addScaledVector(coeff[5], 1.092548 * (y * z));
        target.addScaledVector(coeff[6], 0.315392 * (3.0 * z * z - 1.0));
        target.addScaledVector(coeff[7], 1.092548 * (x * z));
        target.addScaledVector(coeff[8], 0.546274 * (x * x - y * y));
        return target;
    }
    // get the irradiance (radiance convolved with cosine lobe) in the direction of the normal
    // target is a Vector3
    // https://graphics.stanford.edu/papers/envmap/envmap.pdf
    getIrradianceAt(normal, target) {
        // normal is assumed to be unit length
        const x = normal.x, y = normal.y, z = normal.z;
        const coeff = this.coefficients;
        // band 0
        target.copy(coeff[0]).multiplyScalar(0.886227); // π * 0.282095
        // band 1
        target.addScaledVector(coeff[1], 1.023328 * y); // ( 2 * π / 3 ) * 0.488603
        target.addScaledVector(coeff[2], 1.023328 * z);
        target.addScaledVector(coeff[3], 1.023328 * x);
        // band 2
        target.addScaledVector(coeff[4], 0.858086 * x * y); // ( π / 4 ) * 1.092548
        target.addScaledVector(coeff[5], 0.858086 * y * z);
        target.addScaledVector(coeff[6], 0.743125 * z * z - 0.247708); // ( π / 4 ) * 0.315392 * 3
        target.addScaledVector(coeff[7], 0.858086 * x * z);
        target.addScaledVector(coeff[8], 0.429043 * (x * x - y * y)); // ( π / 4 ) * 0.546274
        return target;
    }
    add(sh) {
        for(let i = 0; i < 9; i++)this.coefficients[i].add(sh.coefficients[i]);
        return this;
    }
    addScaledSH(sh, s) {
        for(let i = 0; i < 9; i++)this.coefficients[i].addScaledVector(sh.coefficients[i], s);
        return this;
    }
    scale(s) {
        for(let i = 0; i < 9; i++)this.coefficients[i].multiplyScalar(s);
        return this;
    }
    lerp(sh, alpha) {
        for(let i = 0; i < 9; i++)this.coefficients[i].lerp(sh.coefficients[i], alpha);
        return this;
    }
    equals(sh) {
        for(let i = 0; i < 9; i++){
            if (!this.coefficients[i].equals(sh.coefficients[i])) return false;
        }
        return true;
    }
    copy(sh) {
        return this.set(sh.coefficients);
    }
    clone() {
        return new this.constructor().copy(this);
    }
    fromArray(array, offset = 0) {
        const coefficients = this.coefficients;
        for(let i = 0; i < 9; i++)coefficients[i].fromArray(array, offset + i * 3);
        return this;
    }
    toArray(array = [], offset = 0) {
        const coefficients = this.coefficients;
        for(let i = 0; i < 9; i++)coefficients[i].toArray(array, offset + i * 3);
        return array;
    }
    // evaluate the basis functions
    // shBasis is an Array[ 9 ]
    static getBasisAt(normal, shBasis) {
        // normal is assumed to be unit length
        const x = normal.x, y = normal.y, z = normal.z;
        // band 0
        shBasis[0] = 0.282095;
        // band 1
        shBasis[1] = 0.488603 * y;
        shBasis[2] = 0.488603 * z;
        shBasis[3] = 0.488603 * x;
        // band 2
        shBasis[4] = 1.092548 * x * y;
        shBasis[5] = 1.092548 * y * z;
        shBasis[6] = 0.315392 * (3 * z * z - 1);
        shBasis[7] = 1.092548 * x * z;
        shBasis[8] = 0.546274 * (x * x - y * y);
    }
    constructor(){
        this.isSphericalHarmonics3 = true;
        this.coefficients = [];
        for(let i = 0; i < 9; i++)this.coefficients.push(new $9014d97cd777be10$export$64b5c384219d3699());
    }
}
class $9014d97cd777be10$export$e7ef036e309b38d2 extends $9014d97cd777be10$export$6ecadb6ed240d696 {
    copy(source) {
        super.copy(source);
        this.sh.copy(source.sh);
        return this;
    }
    fromJSON(json) {
        this.intensity = json.intensity; // TODO: Move this bit to Light.fromJSON();
        this.sh.fromArray(json.sh);
        return this;
    }
    toJSON(meta) {
        const data = super.toJSON(meta);
        data.object.sh = this.sh.toArray();
        return data;
    }
    constructor(sh = new $9014d97cd777be10$export$ba61ce607e1f405a(), intensity = 1){
        super(undefined, intensity);
        this.isLightProbe = true;
        this.sh = sh;
    }
}
class $9014d97cd777be10$export$3bd6d323353dcf96 extends $9014d97cd777be10$export$3b0d6d7590275603 {
    load(url, onLoad, onProgress, onError) {
        const scope = this;
        const loader = new $9014d97cd777be10$export$98435a25b5cf7b2b(scope.manager);
        loader.setPath(scope.path);
        loader.setRequestHeader(scope.requestHeader);
        loader.setWithCredentials(scope.withCredentials);
        loader.load(url, function(text) {
            try {
                onLoad(scope.parse(JSON.parse(text)));
            } catch (e) {
                if (onError) onError(e);
                else console.error(e);
                scope.manager.itemError(url);
            }
        }, onProgress, onError);
    }
    parse(json) {
        const textures = this.textures;
        function getTexture(name) {
            if (textures[name] === undefined) console.warn("THREE.MaterialLoader: Undefined texture", name);
            return textures[name];
        }
        const material = $9014d97cd777be10$export$3bd6d323353dcf96.createMaterialFromType(json.type);
        if (json.uuid !== undefined) material.uuid = json.uuid;
        if (json.name !== undefined) material.name = json.name;
        if (json.color !== undefined && material.color !== undefined) material.color.setHex(json.color);
        if (json.roughness !== undefined) material.roughness = json.roughness;
        if (json.metalness !== undefined) material.metalness = json.metalness;
        if (json.sheen !== undefined) material.sheen = json.sheen;
        if (json.sheenColor !== undefined) material.sheenColor = new $9014d97cd777be10$export$892596cec99bc70e().setHex(json.sheenColor);
        if (json.sheenRoughness !== undefined) material.sheenRoughness = json.sheenRoughness;
        if (json.emissive !== undefined && material.emissive !== undefined) material.emissive.setHex(json.emissive);
        if (json.specular !== undefined && material.specular !== undefined) material.specular.setHex(json.specular);
        if (json.specularIntensity !== undefined) material.specularIntensity = json.specularIntensity;
        if (json.specularColor !== undefined && material.specularColor !== undefined) material.specularColor.setHex(json.specularColor);
        if (json.shininess !== undefined) material.shininess = json.shininess;
        if (json.clearcoat !== undefined) material.clearcoat = json.clearcoat;
        if (json.clearcoatRoughness !== undefined) material.clearcoatRoughness = json.clearcoatRoughness;
        if (json.iridescence !== undefined) material.iridescence = json.iridescence;
        if (json.iridescenceIOR !== undefined) material.iridescenceIOR = json.iridescenceIOR;
        if (json.iridescenceThicknessRange !== undefined) material.iridescenceThicknessRange = json.iridescenceThicknessRange;
        if (json.transmission !== undefined) material.transmission = json.transmission;
        if (json.thickness !== undefined) material.thickness = json.thickness;
        if (json.attenuationDistance !== undefined) material.attenuationDistance = json.attenuationDistance;
        if (json.attenuationColor !== undefined && material.attenuationColor !== undefined) material.attenuationColor.setHex(json.attenuationColor);
        if (json.anisotropy !== undefined) material.anisotropy = json.anisotropy;
        if (json.anisotropyRotation !== undefined) material.anisotropyRotation = json.anisotropyRotation;
        if (json.fog !== undefined) material.fog = json.fog;
        if (json.flatShading !== undefined) material.flatShading = json.flatShading;
        if (json.blending !== undefined) material.blending = json.blending;
        if (json.combine !== undefined) material.combine = json.combine;
        if (json.side !== undefined) material.side = json.side;
        if (json.shadowSide !== undefined) material.shadowSide = json.shadowSide;
        if (json.opacity !== undefined) material.opacity = json.opacity;
        if (json.transparent !== undefined) material.transparent = json.transparent;
        if (json.alphaTest !== undefined) material.alphaTest = json.alphaTest;
        if (json.alphaHash !== undefined) material.alphaHash = json.alphaHash;
        if (json.depthTest !== undefined) material.depthTest = json.depthTest;
        if (json.depthWrite !== undefined) material.depthWrite = json.depthWrite;
        if (json.colorWrite !== undefined) material.colorWrite = json.colorWrite;
        if (json.stencilWrite !== undefined) material.stencilWrite = json.stencilWrite;
        if (json.stencilWriteMask !== undefined) material.stencilWriteMask = json.stencilWriteMask;
        if (json.stencilFunc !== undefined) material.stencilFunc = json.stencilFunc;
        if (json.stencilRef !== undefined) material.stencilRef = json.stencilRef;
        if (json.stencilFuncMask !== undefined) material.stencilFuncMask = json.stencilFuncMask;
        if (json.stencilFail !== undefined) material.stencilFail = json.stencilFail;
        if (json.stencilZFail !== undefined) material.stencilZFail = json.stencilZFail;
        if (json.stencilZPass !== undefined) material.stencilZPass = json.stencilZPass;
        if (json.wireframe !== undefined) material.wireframe = json.wireframe;
        if (json.wireframeLinewidth !== undefined) material.wireframeLinewidth = json.wireframeLinewidth;
        if (json.wireframeLinecap !== undefined) material.wireframeLinecap = json.wireframeLinecap;
        if (json.wireframeLinejoin !== undefined) material.wireframeLinejoin = json.wireframeLinejoin;
        if (json.rotation !== undefined) material.rotation = json.rotation;
        if (json.linewidth !== 1) material.linewidth = json.linewidth;
        if (json.dashSize !== undefined) material.dashSize = json.dashSize;
        if (json.gapSize !== undefined) material.gapSize = json.gapSize;
        if (json.scale !== undefined) material.scale = json.scale;
        if (json.polygonOffset !== undefined) material.polygonOffset = json.polygonOffset;
        if (json.polygonOffsetFactor !== undefined) material.polygonOffsetFactor = json.polygonOffsetFactor;
        if (json.polygonOffsetUnits !== undefined) material.polygonOffsetUnits = json.polygonOffsetUnits;
        if (json.dithering !== undefined) material.dithering = json.dithering;
        if (json.alphaToCoverage !== undefined) material.alphaToCoverage = json.alphaToCoverage;
        if (json.premultipliedAlpha !== undefined) material.premultipliedAlpha = json.premultipliedAlpha;
        if (json.forceSinglePass !== undefined) material.forceSinglePass = json.forceSinglePass;
        if (json.visible !== undefined) material.visible = json.visible;
        if (json.toneMapped !== undefined) material.toneMapped = json.toneMapped;
        if (json.userData !== undefined) material.userData = json.userData;
        if (json.vertexColors !== undefined) {
            if (typeof json.vertexColors === "number") material.vertexColors = json.vertexColors > 0 ? true : false;
            else material.vertexColors = json.vertexColors;
        }
        // Shader Material
        if (json.uniforms !== undefined) for(const name in json.uniforms){
            const uniform = json.uniforms[name];
            material.uniforms[name] = {};
            switch(uniform.type){
                case "t":
                    material.uniforms[name].value = getTexture(uniform.value);
                    break;
                case "c":
                    material.uniforms[name].value = new $9014d97cd777be10$export$892596cec99bc70e().setHex(uniform.value);
                    break;
                case "v2":
                    material.uniforms[name].value = new $9014d97cd777be10$export$c977b3e384af9ae1().fromArray(uniform.value);
                    break;
                case "v3":
                    material.uniforms[name].value = new $9014d97cd777be10$export$64b5c384219d3699().fromArray(uniform.value);
                    break;
                case "v4":
                    material.uniforms[name].value = new $9014d97cd777be10$export$fa7daccca11cdbe3().fromArray(uniform.value);
                    break;
                case "m3":
                    material.uniforms[name].value = new $9014d97cd777be10$export$8ff26dafa08918().fromArray(uniform.value);
                    break;
                case "m4":
                    material.uniforms[name].value = new $9014d97cd777be10$export$2ae72fc923e5eb5().fromArray(uniform.value);
                    break;
                default:
                    material.uniforms[name].value = uniform.value;
            }
        }
        if (json.defines !== undefined) material.defines = json.defines;
        if (json.vertexShader !== undefined) material.vertexShader = json.vertexShader;
        if (json.fragmentShader !== undefined) material.fragmentShader = json.fragmentShader;
        if (json.glslVersion !== undefined) material.glslVersion = json.glslVersion;
        if (json.extensions !== undefined) for(const key in json.extensions)material.extensions[key] = json.extensions[key];
        if (json.lights !== undefined) material.lights = json.lights;
        if (json.clipping !== undefined) material.clipping = json.clipping;
        // for PointsMaterial
        if (json.size !== undefined) material.size = json.size;
        if (json.sizeAttenuation !== undefined) material.sizeAttenuation = json.sizeAttenuation;
        // maps
        if (json.map !== undefined) material.map = getTexture(json.map);
        if (json.matcap !== undefined) material.matcap = getTexture(json.matcap);
        if (json.alphaMap !== undefined) material.alphaMap = getTexture(json.alphaMap);
        if (json.bumpMap !== undefined) material.bumpMap = getTexture(json.bumpMap);
        if (json.bumpScale !== undefined) material.bumpScale = json.bumpScale;
        if (json.normalMap !== undefined) material.normalMap = getTexture(json.normalMap);
        if (json.normalMapType !== undefined) material.normalMapType = json.normalMapType;
        if (json.normalScale !== undefined) {
            let normalScale = json.normalScale;
            if (Array.isArray(normalScale) === false) // Blender exporter used to export a scalar. See #7459
            normalScale = [
                normalScale,
                normalScale
            ];
            material.normalScale = new $9014d97cd777be10$export$c977b3e384af9ae1().fromArray(normalScale);
        }
        if (json.displacementMap !== undefined) material.displacementMap = getTexture(json.displacementMap);
        if (json.displacementScale !== undefined) material.displacementScale = json.displacementScale;
        if (json.displacementBias !== undefined) material.displacementBias = json.displacementBias;
        if (json.roughnessMap !== undefined) material.roughnessMap = getTexture(json.roughnessMap);
        if (json.metalnessMap !== undefined) material.metalnessMap = getTexture(json.metalnessMap);
        if (json.emissiveMap !== undefined) material.emissiveMap = getTexture(json.emissiveMap);
        if (json.emissiveIntensity !== undefined) material.emissiveIntensity = json.emissiveIntensity;
        if (json.specularMap !== undefined) material.specularMap = getTexture(json.specularMap);
        if (json.specularIntensityMap !== undefined) material.specularIntensityMap = getTexture(json.specularIntensityMap);
        if (json.specularColorMap !== undefined) material.specularColorMap = getTexture(json.specularColorMap);
        if (json.envMap !== undefined) material.envMap = getTexture(json.envMap);
        if (json.envMapIntensity !== undefined) material.envMapIntensity = json.envMapIntensity;
        if (json.reflectivity !== undefined) material.reflectivity = json.reflectivity;
        if (json.refractionRatio !== undefined) material.refractionRatio = json.refractionRatio;
        if (json.lightMap !== undefined) material.lightMap = getTexture(json.lightMap);
        if (json.lightMapIntensity !== undefined) material.lightMapIntensity = json.lightMapIntensity;
        if (json.aoMap !== undefined) material.aoMap = getTexture(json.aoMap);
        if (json.aoMapIntensity !== undefined) material.aoMapIntensity = json.aoMapIntensity;
        if (json.gradientMap !== undefined) material.gradientMap = getTexture(json.gradientMap);
        if (json.clearcoatMap !== undefined) material.clearcoatMap = getTexture(json.clearcoatMap);
        if (json.clearcoatRoughnessMap !== undefined) material.clearcoatRoughnessMap = getTexture(json.clearcoatRoughnessMap);
        if (json.clearcoatNormalMap !== undefined) material.clearcoatNormalMap = getTexture(json.clearcoatNormalMap);
        if (json.clearcoatNormalScale !== undefined) material.clearcoatNormalScale = new $9014d97cd777be10$export$c977b3e384af9ae1().fromArray(json.clearcoatNormalScale);
        if (json.iridescenceMap !== undefined) material.iridescenceMap = getTexture(json.iridescenceMap);
        if (json.iridescenceThicknessMap !== undefined) material.iridescenceThicknessMap = getTexture(json.iridescenceThicknessMap);
        if (json.transmissionMap !== undefined) material.transmissionMap = getTexture(json.transmissionMap);
        if (json.thicknessMap !== undefined) material.thicknessMap = getTexture(json.thicknessMap);
        if (json.anisotropyMap !== undefined) material.anisotropyMap = getTexture(json.anisotropyMap);
        if (json.sheenColorMap !== undefined) material.sheenColorMap = getTexture(json.sheenColorMap);
        if (json.sheenRoughnessMap !== undefined) material.sheenRoughnessMap = getTexture(json.sheenRoughnessMap);
        return material;
    }
    setTextures(value) {
        this.textures = value;
        return this;
    }
    static createMaterialFromType(type) {
        const materialLib = {
            ShadowMaterial: $9014d97cd777be10$export$e8564da406055a3,
            SpriteMaterial: $9014d97cd777be10$export$5ec7dd1c6994bf8e,
            RawShaderMaterial: $9014d97cd777be10$export$21c421a2e1df9d22,
            ShaderMaterial: $9014d97cd777be10$export$83c7d75d550a8b0d,
            PointsMaterial: $9014d97cd777be10$export$a178c45366ce5d6b,
            MeshPhysicalMaterial: $9014d97cd777be10$export$28d04986c4269c9f,
            MeshStandardMaterial: $9014d97cd777be10$export$f2980790215acccd,
            MeshPhongMaterial: $9014d97cd777be10$export$24c72f71cbaf0678,
            MeshToonMaterial: $9014d97cd777be10$export$df893cf97e765622,
            MeshNormalMaterial: $9014d97cd777be10$export$bfe8c0a091f41ae7,
            MeshLambertMaterial: $9014d97cd777be10$export$5023a9a8114806b8,
            MeshDepthMaterial: $9014d97cd777be10$export$2698c22ec13825db,
            MeshDistanceMaterial: $9014d97cd777be10$export$33e187ed002f2a19,
            MeshBasicMaterial: $9014d97cd777be10$export$55cbcc9b622fe1f5,
            MeshMatcapMaterial: $9014d97cd777be10$export$6f5fef6235ec12ee,
            LineDashedMaterial: $9014d97cd777be10$export$327886a3efaeaebe,
            LineBasicMaterial: $9014d97cd777be10$export$fbaaa33907730a0c,
            Material: $9014d97cd777be10$export$a2d8b23205c25948
        };
        return new materialLib[type]();
    }
    constructor(manager){
        super(manager);
        this.textures = {};
    }
}
class $9014d97cd777be10$export$b5d2dc08d867e41a {
    static decodeText(array) {
        if (typeof TextDecoder !== "undefined") return new TextDecoder().decode(array);
        // Avoid the String.fromCharCode.apply(null, array) shortcut, which
        // throws a "maximum call stack size exceeded" error for large arrays.
        let s = "";
        for(let i = 0, il = array.length; i < il; i++)// Implicitly assumes little-endian.
        s += String.fromCharCode(array[i]);
        try {
            // merges multi-byte utf-8 characters.
            return decodeURIComponent(escape(s));
        } catch (e) {
            return s;
        }
    }
    static extractUrlBase(url) {
        const index = url.lastIndexOf("/");
        if (index === -1) return "./";
        return url.slice(0, index + 1);
    }
    static resolveURL(url, path) {
        // Invalid URL
        if (typeof url !== "string" || url === "") return "";
        // Host Relative URL
        if (/^https?:\/\//i.test(path) && /^\//.test(url)) path = path.replace(/(^https?:\/\/[^\/]+).*/i, "$1");
        // Absolute URL http://,https://,//
        if (/^(https?:)?\/\//i.test(url)) return url;
        // Data URI
        if (/^data:.*,.*$/i.test(url)) return url;
        // Blob URL
        if (/^blob:.*$/i.test(url)) return url;
        // Relative URL
        return path + url;
    }
}
class $9014d97cd777be10$export$231f009cbe414146 extends $9014d97cd777be10$export$b7be63a67df8959 {
    copy(source) {
        super.copy(source);
        this.instanceCount = source.instanceCount;
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.instanceCount = this.instanceCount;
        data.isInstancedBufferGeometry = true;
        return data;
    }
    constructor(){
        super();
        this.isInstancedBufferGeometry = true;
        this.type = "InstancedBufferGeometry";
        this.instanceCount = Infinity;
    }
}
class $9014d97cd777be10$export$dc275bb96327833a extends $9014d97cd777be10$export$3b0d6d7590275603 {
    load(url, onLoad, onProgress, onError) {
        const scope = this;
        const loader = new $9014d97cd777be10$export$98435a25b5cf7b2b(scope.manager);
        loader.setPath(scope.path);
        loader.setRequestHeader(scope.requestHeader);
        loader.setWithCredentials(scope.withCredentials);
        loader.load(url, function(text) {
            try {
                onLoad(scope.parse(JSON.parse(text)));
            } catch (e) {
                if (onError) onError(e);
                else console.error(e);
                scope.manager.itemError(url);
            }
        }, onProgress, onError);
    }
    parse(json) {
        const interleavedBufferMap = {};
        const arrayBufferMap = {};
        function getInterleavedBuffer(json, uuid) {
            if (interleavedBufferMap[uuid] !== undefined) return interleavedBufferMap[uuid];
            const interleavedBuffers = json.interleavedBuffers;
            const interleavedBuffer = interleavedBuffers[uuid];
            const buffer = getArrayBuffer(json, interleavedBuffer.buffer);
            const array = $9014d97cd777be10$var$getTypedArray(interleavedBuffer.type, buffer);
            const ib = new $9014d97cd777be10$export$3d5cd879f108f53f(array, interleavedBuffer.stride);
            ib.uuid = interleavedBuffer.uuid;
            interleavedBufferMap[uuid] = ib;
            return ib;
        }
        function getArrayBuffer(json, uuid) {
            if (arrayBufferMap[uuid] !== undefined) return arrayBufferMap[uuid];
            const arrayBuffers = json.arrayBuffers;
            const arrayBuffer = arrayBuffers[uuid];
            const ab = new Uint32Array(arrayBuffer).buffer;
            arrayBufferMap[uuid] = ab;
            return ab;
        }
        const geometry = json.isInstancedBufferGeometry ? new $9014d97cd777be10$export$231f009cbe414146() : new $9014d97cd777be10$export$b7be63a67df8959();
        const index = json.data.index;
        if (index !== undefined) {
            const typedArray = $9014d97cd777be10$var$getTypedArray(index.type, index.array);
            geometry.setIndex(new $9014d97cd777be10$export$8dea267bd6bde117(typedArray, 1));
        }
        const attributes = json.data.attributes;
        for(const key in attributes){
            const attribute = attributes[key];
            let bufferAttribute;
            if (attribute.isInterleavedBufferAttribute) {
                const interleavedBuffer = getInterleavedBuffer(json.data, attribute.data);
                bufferAttribute = new $9014d97cd777be10$export$920b6d07334599c7(interleavedBuffer, attribute.itemSize, attribute.offset, attribute.normalized);
            } else {
                const typedArray = $9014d97cd777be10$var$getTypedArray(attribute.type, attribute.array);
                const bufferAttributeConstr = attribute.isInstancedBufferAttribute ? $9014d97cd777be10$export$32ea87a8b54d744a : $9014d97cd777be10$export$8dea267bd6bde117;
                bufferAttribute = new bufferAttributeConstr(typedArray, attribute.itemSize, attribute.normalized);
            }
            if (attribute.name !== undefined) bufferAttribute.name = attribute.name;
            if (attribute.usage !== undefined) bufferAttribute.setUsage(attribute.usage);
            if (attribute.updateRange !== undefined) {
                bufferAttribute.updateRange.offset = attribute.updateRange.offset;
                bufferAttribute.updateRange.count = attribute.updateRange.count;
            }
            geometry.setAttribute(key, bufferAttribute);
        }
        const morphAttributes = json.data.morphAttributes;
        if (morphAttributes) for(const key in morphAttributes){
            const attributeArray = morphAttributes[key];
            const array = [];
            for(let i = 0, il = attributeArray.length; i < il; i++){
                const attribute = attributeArray[i];
                let bufferAttribute;
                if (attribute.isInterleavedBufferAttribute) {
                    const interleavedBuffer = getInterleavedBuffer(json.data, attribute.data);
                    bufferAttribute = new $9014d97cd777be10$export$920b6d07334599c7(interleavedBuffer, attribute.itemSize, attribute.offset, attribute.normalized);
                } else {
                    const typedArray = $9014d97cd777be10$var$getTypedArray(attribute.type, attribute.array);
                    bufferAttribute = new $9014d97cd777be10$export$8dea267bd6bde117(typedArray, attribute.itemSize, attribute.normalized);
                }
                if (attribute.name !== undefined) bufferAttribute.name = attribute.name;
                array.push(bufferAttribute);
            }
            geometry.morphAttributes[key] = array;
        }
        const morphTargetsRelative = json.data.morphTargetsRelative;
        if (morphTargetsRelative) geometry.morphTargetsRelative = true;
        const groups = json.data.groups || json.data.drawcalls || json.data.offsets;
        if (groups !== undefined) for(let i = 0, n = groups.length; i !== n; ++i){
            const group = groups[i];
            geometry.addGroup(group.start, group.count, group.materialIndex);
        }
        const boundingSphere = json.data.boundingSphere;
        if (boundingSphere !== undefined) {
            const center = new $9014d97cd777be10$export$64b5c384219d3699();
            if (boundingSphere.center !== undefined) center.fromArray(boundingSphere.center);
            geometry.boundingSphere = new $9014d97cd777be10$export$805e8b72413ccaba(center, boundingSphere.radius);
        }
        if (json.name) geometry.name = json.name;
        if (json.userData) geometry.userData = json.userData;
        return geometry;
    }
    constructor(manager){
        super(manager);
    }
}
class $9014d97cd777be10$export$40110c8505c5ad19 extends $9014d97cd777be10$export$3b0d6d7590275603 {
    load(url, onLoad, onProgress, onError) {
        const scope = this;
        const path = this.path === "" ? $9014d97cd777be10$export$b5d2dc08d867e41a.extractUrlBase(url) : this.path;
        this.resourcePath = this.resourcePath || path;
        const loader = new $9014d97cd777be10$export$98435a25b5cf7b2b(this.manager);
        loader.setPath(this.path);
        loader.setRequestHeader(this.requestHeader);
        loader.setWithCredentials(this.withCredentials);
        loader.load(url, function(text) {
            let json = null;
            try {
                json = JSON.parse(text);
            } catch (error) {
                if (onError !== undefined) onError(error);
                console.error("THREE:ObjectLoader: Can't parse " + url + ".", error.message);
                return;
            }
            const metadata = json.metadata;
            if (metadata === undefined || metadata.type === undefined || metadata.type.toLowerCase() === "geometry") {
                if (onError !== undefined) onError(new Error("THREE.ObjectLoader: Can't load " + url));
                console.error("THREE.ObjectLoader: Can't load " + url);
                return;
            }
            scope.parse(json, onLoad);
        }, onProgress, onError);
    }
    async loadAsync(url, onProgress) {
        const scope = this;
        const path = this.path === "" ? $9014d97cd777be10$export$b5d2dc08d867e41a.extractUrlBase(url) : this.path;
        this.resourcePath = this.resourcePath || path;
        const loader = new $9014d97cd777be10$export$98435a25b5cf7b2b(this.manager);
        loader.setPath(this.path);
        loader.setRequestHeader(this.requestHeader);
        loader.setWithCredentials(this.withCredentials);
        const text = await loader.loadAsync(url, onProgress);
        const json = JSON.parse(text);
        const metadata = json.metadata;
        if (metadata === undefined || metadata.type === undefined || metadata.type.toLowerCase() === "geometry") throw new Error("THREE.ObjectLoader: Can't load " + url);
        return await scope.parseAsync(json);
    }
    parse(json, onLoad) {
        const animations = this.parseAnimations(json.animations);
        const shapes = this.parseShapes(json.shapes);
        const geometries = this.parseGeometries(json.geometries, shapes);
        const images = this.parseImages(json.images, function() {
            if (onLoad !== undefined) onLoad(object);
        });
        const textures = this.parseTextures(json.textures, images);
        const materials = this.parseMaterials(json.materials, textures);
        const object = this.parseObject(json.object, geometries, materials, textures, animations);
        const skeletons = this.parseSkeletons(json.skeletons, object);
        this.bindSkeletons(object, skeletons);
        //
        if (onLoad !== undefined) {
            let hasImages = false;
            for(const uuid in images)if (images[uuid].data instanceof HTMLImageElement) {
                hasImages = true;
                break;
            }
            if (hasImages === false) onLoad(object);
        }
        return object;
    }
    async parseAsync(json) {
        const animations = this.parseAnimations(json.animations);
        const shapes = this.parseShapes(json.shapes);
        const geometries = this.parseGeometries(json.geometries, shapes);
        const images = await this.parseImagesAsync(json.images);
        const textures = this.parseTextures(json.textures, images);
        const materials = this.parseMaterials(json.materials, textures);
        const object = this.parseObject(json.object, geometries, materials, textures, animations);
        const skeletons = this.parseSkeletons(json.skeletons, object);
        this.bindSkeletons(object, skeletons);
        return object;
    }
    parseShapes(json) {
        const shapes = {};
        if (json !== undefined) for(let i = 0, l = json.length; i < l; i++){
            const shape = new $9014d97cd777be10$export$6428a7f2611ef1fa().fromJSON(json[i]);
            shapes[shape.uuid] = shape;
        }
        return shapes;
    }
    parseSkeletons(json, object) {
        const skeletons = {};
        const bones = {};
        // generate bone lookup table
        object.traverse(function(child) {
            if (child.isBone) bones[child.uuid] = child;
        });
        // create skeletons
        if (json !== undefined) for(let i = 0, l = json.length; i < l; i++){
            const skeleton = new $9014d97cd777be10$export$8f31e4c4a37b8e9c().fromJSON(json[i], bones);
            skeletons[skeleton.uuid] = skeleton;
        }
        return skeletons;
    }
    parseGeometries(json, shapes) {
        const geometries = {};
        if (json !== undefined) {
            const bufferGeometryLoader = new $9014d97cd777be10$export$dc275bb96327833a();
            for(let i = 0, l = json.length; i < l; i++){
                let geometry;
                const data = json[i];
                switch(data.type){
                    case "BufferGeometry":
                    case "InstancedBufferGeometry":
                        geometry = bufferGeometryLoader.parse(data);
                        break;
                    default:
                        if (data.type in $9014d97cd777be10$var$Geometries) geometry = $9014d97cd777be10$var$Geometries[data.type].fromJSON(data, shapes);
                        else console.warn(`THREE.ObjectLoader: Unsupported geometry type "${data.type}"`);
                }
                geometry.uuid = data.uuid;
                if (data.name !== undefined) geometry.name = data.name;
                if (data.userData !== undefined) geometry.userData = data.userData;
                geometries[data.uuid] = geometry;
            }
        }
        return geometries;
    }
    parseMaterials(json, textures) {
        const cache = {}; // MultiMaterial
        const materials = {};
        if (json !== undefined) {
            const loader = new $9014d97cd777be10$export$3bd6d323353dcf96();
            loader.setTextures(textures);
            for(let i = 0, l = json.length; i < l; i++){
                const data = json[i];
                if (cache[data.uuid] === undefined) cache[data.uuid] = loader.parse(data);
                materials[data.uuid] = cache[data.uuid];
            }
        }
        return materials;
    }
    parseAnimations(json) {
        const animations = {};
        if (json !== undefined) for(let i = 0; i < json.length; i++){
            const data = json[i];
            const clip = $9014d97cd777be10$export$d942c706bf23829c.parse(data);
            animations[clip.uuid] = clip;
        }
        return animations;
    }
    parseImages(json, onLoad) {
        const scope = this;
        const images = {};
        let loader;
        function loadImage(url) {
            scope.manager.itemStart(url);
            return loader.load(url, function() {
                scope.manager.itemEnd(url);
            }, undefined, function() {
                scope.manager.itemError(url);
                scope.manager.itemEnd(url);
            });
        }
        function deserializeImage(image) {
            if (typeof image === "string") {
                const url = image;
                const path = /^(\/\/)|([a-z]+:(\/\/)?)/i.test(url) ? url : scope.resourcePath + url;
                return loadImage(path);
            } else {
                if (image.data) return {
                    data: $9014d97cd777be10$var$getTypedArray(image.type, image.data),
                    width: image.width,
                    height: image.height
                };
                else return null;
            }
        }
        if (json !== undefined && json.length > 0) {
            const manager = new $9014d97cd777be10$export$99cc795e99919eed(onLoad);
            loader = new $9014d97cd777be10$export$8905ce1c7a2464a1(manager);
            loader.setCrossOrigin(this.crossOrigin);
            for(let i = 0, il = json.length; i < il; i++){
                const image = json[i];
                const url = image.url;
                if (Array.isArray(url)) {
                    // load array of images e.g CubeTexture
                    const imageArray = [];
                    for(let j = 0, jl = url.length; j < jl; j++){
                        const currentUrl = url[j];
                        const deserializedImage = deserializeImage(currentUrl);
                        if (deserializedImage !== null) {
                            if (deserializedImage instanceof HTMLImageElement) imageArray.push(deserializedImage);
                            else // special case: handle array of data textures for cube textures
                            imageArray.push(new $9014d97cd777be10$export$b691f601014eabe1(deserializedImage.data, deserializedImage.width, deserializedImage.height));
                        }
                    }
                    images[image.uuid] = new $9014d97cd777be10$export$1d2df86270c81ecb(imageArray);
                } else {
                    // load single image
                    const deserializedImage = deserializeImage(image.url);
                    images[image.uuid] = new $9014d97cd777be10$export$1d2df86270c81ecb(deserializedImage);
                }
            }
        }
        return images;
    }
    async parseImagesAsync(json) {
        const scope = this;
        const images = {};
        let loader;
        async function deserializeImage(image) {
            if (typeof image === "string") {
                const url = image;
                const path = /^(\/\/)|([a-z]+:(\/\/)?)/i.test(url) ? url : scope.resourcePath + url;
                return await loader.loadAsync(path);
            } else {
                if (image.data) return {
                    data: $9014d97cd777be10$var$getTypedArray(image.type, image.data),
                    width: image.width,
                    height: image.height
                };
                else return null;
            }
        }
        if (json !== undefined && json.length > 0) {
            loader = new $9014d97cd777be10$export$8905ce1c7a2464a1(this.manager);
            loader.setCrossOrigin(this.crossOrigin);
            for(let i = 0, il = json.length; i < il; i++){
                const image = json[i];
                const url = image.url;
                if (Array.isArray(url)) {
                    // load array of images e.g CubeTexture
                    const imageArray = [];
                    for(let j = 0, jl = url.length; j < jl; j++){
                        const currentUrl = url[j];
                        const deserializedImage = await deserializeImage(currentUrl);
                        if (deserializedImage !== null) {
                            if (deserializedImage instanceof HTMLImageElement) imageArray.push(deserializedImage);
                            else // special case: handle array of data textures for cube textures
                            imageArray.push(new $9014d97cd777be10$export$b691f601014eabe1(deserializedImage.data, deserializedImage.width, deserializedImage.height));
                        }
                    }
                    images[image.uuid] = new $9014d97cd777be10$export$1d2df86270c81ecb(imageArray);
                } else {
                    // load single image
                    const deserializedImage = await deserializeImage(image.url);
                    images[image.uuid] = new $9014d97cd777be10$export$1d2df86270c81ecb(deserializedImage);
                }
            }
        }
        return images;
    }
    parseTextures(json, images) {
        function parseConstant(value, type) {
            if (typeof value === "number") return value;
            console.warn("THREE.ObjectLoader.parseTexture: Constant should be in numeric form.", value);
            return type[value];
        }
        const textures = {};
        if (json !== undefined) for(let i = 0, l = json.length; i < l; i++){
            const data = json[i];
            if (data.image === undefined) console.warn('THREE.ObjectLoader: No "image" specified for', data.uuid);
            if (images[data.image] === undefined) console.warn("THREE.ObjectLoader: Undefined image", data.image);
            const source = images[data.image];
            const image = source.data;
            let texture;
            if (Array.isArray(image)) {
                texture = new $9014d97cd777be10$export$ee2e5a18258a4049();
                if (image.length === 6) texture.needsUpdate = true;
            } else {
                if (image && image.data) texture = new $9014d97cd777be10$export$b691f601014eabe1();
                else texture = new $9014d97cd777be10$export$5431306cf43de24a();
                if (image) texture.needsUpdate = true; // textures can have undefined image data
            }
            texture.source = source;
            texture.uuid = data.uuid;
            if (data.name !== undefined) texture.name = data.name;
            if (data.mapping !== undefined) texture.mapping = parseConstant(data.mapping, $9014d97cd777be10$var$TEXTURE_MAPPING);
            if (data.channel !== undefined) texture.channel = data.channel;
            if (data.offset !== undefined) texture.offset.fromArray(data.offset);
            if (data.repeat !== undefined) texture.repeat.fromArray(data.repeat);
            if (data.center !== undefined) texture.center.fromArray(data.center);
            if (data.rotation !== undefined) texture.rotation = data.rotation;
            if (data.wrap !== undefined) {
                texture.wrapS = parseConstant(data.wrap[0], $9014d97cd777be10$var$TEXTURE_WRAPPING);
                texture.wrapT = parseConstant(data.wrap[1], $9014d97cd777be10$var$TEXTURE_WRAPPING);
            }
            if (data.format !== undefined) texture.format = data.format;
            if (data.internalFormat !== undefined) texture.internalFormat = data.internalFormat;
            if (data.type !== undefined) texture.type = data.type;
            if (data.colorSpace !== undefined) texture.colorSpace = data.colorSpace;
            if (data.encoding !== undefined) texture.encoding = data.encoding; // @deprecated, r152
            if (data.minFilter !== undefined) texture.minFilter = parseConstant(data.minFilter, $9014d97cd777be10$var$TEXTURE_FILTER);
            if (data.magFilter !== undefined) texture.magFilter = parseConstant(data.magFilter, $9014d97cd777be10$var$TEXTURE_FILTER);
            if (data.anisotropy !== undefined) texture.anisotropy = data.anisotropy;
            if (data.flipY !== undefined) texture.flipY = data.flipY;
            if (data.generateMipmaps !== undefined) texture.generateMipmaps = data.generateMipmaps;
            if (data.premultiplyAlpha !== undefined) texture.premultiplyAlpha = data.premultiplyAlpha;
            if (data.unpackAlignment !== undefined) texture.unpackAlignment = data.unpackAlignment;
            if (data.compareFunction !== undefined) texture.compareFunction = data.compareFunction;
            if (data.userData !== undefined) texture.userData = data.userData;
            textures[data.uuid] = texture;
        }
        return textures;
    }
    parseObject(data, geometries, materials, textures, animations) {
        let object;
        function getGeometry(name) {
            if (geometries[name] === undefined) console.warn("THREE.ObjectLoader: Undefined geometry", name);
            return geometries[name];
        }
        function getMaterial(name) {
            if (name === undefined) return undefined;
            if (Array.isArray(name)) {
                const array = [];
                for(let i = 0, l = name.length; i < l; i++){
                    const uuid = name[i];
                    if (materials[uuid] === undefined) console.warn("THREE.ObjectLoader: Undefined material", uuid);
                    array.push(materials[uuid]);
                }
                return array;
            }
            if (materials[name] === undefined) console.warn("THREE.ObjectLoader: Undefined material", name);
            return materials[name];
        }
        function getTexture(uuid) {
            if (textures[uuid] === undefined) console.warn("THREE.ObjectLoader: Undefined texture", uuid);
            return textures[uuid];
        }
        let geometry, material;
        switch(data.type){
            case "Scene":
                object = new $9014d97cd777be10$export$38af1803e3442a7f();
                if (data.background !== undefined) {
                    if (Number.isInteger(data.background)) object.background = new $9014d97cd777be10$export$892596cec99bc70e(data.background);
                    else object.background = getTexture(data.background);
                }
                if (data.environment !== undefined) object.environment = getTexture(data.environment);
                if (data.fog !== undefined) {
                    if (data.fog.type === "Fog") object.fog = new $9014d97cd777be10$export$3c890837b09508d4(data.fog.color, data.fog.near, data.fog.far);
                    else if (data.fog.type === "FogExp2") object.fog = new $9014d97cd777be10$export$6f1519f023b8d0f6(data.fog.color, data.fog.density);
                }
                if (data.backgroundBlurriness !== undefined) object.backgroundBlurriness = data.backgroundBlurriness;
                if (data.backgroundIntensity !== undefined) object.backgroundIntensity = data.backgroundIntensity;
                break;
            case "PerspectiveCamera":
                object = new $9014d97cd777be10$export$74e4ae24825f68d7(data.fov, data.aspect, data.near, data.far);
                if (data.focus !== undefined) object.focus = data.focus;
                if (data.zoom !== undefined) object.zoom = data.zoom;
                if (data.filmGauge !== undefined) object.filmGauge = data.filmGauge;
                if (data.filmOffset !== undefined) object.filmOffset = data.filmOffset;
                if (data.view !== undefined) object.view = Object.assign({}, data.view);
                break;
            case "OrthographicCamera":
                object = new $9014d97cd777be10$export$9ebf355ee4ed261b(data.left, data.right, data.top, data.bottom, data.near, data.far);
                if (data.zoom !== undefined) object.zoom = data.zoom;
                if (data.view !== undefined) object.view = Object.assign({}, data.view);
                break;
            case "AmbientLight":
                object = new $9014d97cd777be10$export$af279bfef9ec2c96(data.color, data.intensity);
                break;
            case "DirectionalLight":
                object = new $9014d97cd777be10$export$3fea33cc9972c868(data.color, data.intensity);
                break;
            case "PointLight":
                object = new $9014d97cd777be10$export$4c9c1cb3f0b6f455(data.color, data.intensity, data.distance, data.decay);
                break;
            case "RectAreaLight":
                object = new $9014d97cd777be10$export$61db2d908bbd2429(data.color, data.intensity, data.width, data.height);
                break;
            case "SpotLight":
                object = new $9014d97cd777be10$export$81495cbb73897362(data.color, data.intensity, data.distance, data.angle, data.penumbra, data.decay);
                break;
            case "HemisphereLight":
                object = new $9014d97cd777be10$export$8d474f55edbb9624(data.color, data.groundColor, data.intensity);
                break;
            case "LightProbe":
                object = new $9014d97cd777be10$export$e7ef036e309b38d2().fromJSON(data);
                break;
            case "SkinnedMesh":
                geometry = getGeometry(data.geometry);
                material = getMaterial(data.material);
                object = new $9014d97cd777be10$export$b303577035157ecf(geometry, material);
                if (data.bindMode !== undefined) object.bindMode = data.bindMode;
                if (data.bindMatrix !== undefined) object.bindMatrix.fromArray(data.bindMatrix);
                if (data.skeleton !== undefined) object.skeleton = data.skeleton;
                break;
            case "Mesh":
                geometry = getGeometry(data.geometry);
                material = getMaterial(data.material);
                object = new $9014d97cd777be10$export$e176487c05830cc5(geometry, material);
                break;
            case "InstancedMesh":
                geometry = getGeometry(data.geometry);
                material = getMaterial(data.material);
                const count = data.count;
                const instanceMatrix = data.instanceMatrix;
                const instanceColor = data.instanceColor;
                object = new $9014d97cd777be10$export$f3c979c331175ad7(geometry, material, count);
                object.instanceMatrix = new $9014d97cd777be10$export$32ea87a8b54d744a(new Float32Array(instanceMatrix.array), 16);
                if (instanceColor !== undefined) object.instanceColor = new $9014d97cd777be10$export$32ea87a8b54d744a(new Float32Array(instanceColor.array), instanceColor.itemSize);
                break;
            case "LOD":
                object = new $9014d97cd777be10$export$112e7237be0c5f30();
                break;
            case "Line":
                object = new $9014d97cd777be10$export$17d680238e50603e(getGeometry(data.geometry), getMaterial(data.material));
                break;
            case "LineLoop":
                object = new $9014d97cd777be10$export$f85a24d745e4f17d(getGeometry(data.geometry), getMaterial(data.material));
                break;
            case "LineSegments":
                object = new $9014d97cd777be10$export$ff1ed10fedfdd604(getGeometry(data.geometry), getMaterial(data.material));
                break;
            case "PointCloud":
            case "Points":
                object = new $9014d97cd777be10$export$1c787534cb11aa3e(getGeometry(data.geometry), getMaterial(data.material));
                break;
            case "Sprite":
                object = new $9014d97cd777be10$export$3075603db8e6204c(getMaterial(data.material));
                break;
            case "Group":
                object = new $9014d97cd777be10$export$eb2fcfdbd7ba97d4();
                break;
            case "Bone":
                object = new $9014d97cd777be10$export$b127726e56765aa4();
                break;
            default:
                object = new $9014d97cd777be10$export$e4dd07dff30cc924();
        }
        object.uuid = data.uuid;
        if (data.name !== undefined) object.name = data.name;
        if (data.matrix !== undefined) {
            object.matrix.fromArray(data.matrix);
            if (data.matrixAutoUpdate !== undefined) object.matrixAutoUpdate = data.matrixAutoUpdate;
            if (object.matrixAutoUpdate) object.matrix.decompose(object.position, object.quaternion, object.scale);
        } else {
            if (data.position !== undefined) object.position.fromArray(data.position);
            if (data.rotation !== undefined) object.rotation.fromArray(data.rotation);
            if (data.quaternion !== undefined) object.quaternion.fromArray(data.quaternion);
            if (data.scale !== undefined) object.scale.fromArray(data.scale);
        }
        if (data.up !== undefined) object.up.fromArray(data.up);
        if (data.castShadow !== undefined) object.castShadow = data.castShadow;
        if (data.receiveShadow !== undefined) object.receiveShadow = data.receiveShadow;
        if (data.shadow) {
            if (data.shadow.bias !== undefined) object.shadow.bias = data.shadow.bias;
            if (data.shadow.normalBias !== undefined) object.shadow.normalBias = data.shadow.normalBias;
            if (data.shadow.radius !== undefined) object.shadow.radius = data.shadow.radius;
            if (data.shadow.mapSize !== undefined) object.shadow.mapSize.fromArray(data.shadow.mapSize);
            if (data.shadow.camera !== undefined) object.shadow.camera = this.parseObject(data.shadow.camera);
        }
        if (data.visible !== undefined) object.visible = data.visible;
        if (data.frustumCulled !== undefined) object.frustumCulled = data.frustumCulled;
        if (data.renderOrder !== undefined) object.renderOrder = data.renderOrder;
        if (data.userData !== undefined) object.userData = data.userData;
        if (data.layers !== undefined) object.layers.mask = data.layers;
        if (data.children !== undefined) {
            const children = data.children;
            for(let i = 0; i < children.length; i++)object.add(this.parseObject(children[i], geometries, materials, textures, animations));
        }
        if (data.animations !== undefined) {
            const objectAnimations = data.animations;
            for(let i = 0; i < objectAnimations.length; i++){
                const uuid = objectAnimations[i];
                object.animations.push(animations[uuid]);
            }
        }
        if (data.type === "LOD") {
            if (data.autoUpdate !== undefined) object.autoUpdate = data.autoUpdate;
            const levels = data.levels;
            for(let l = 0; l < levels.length; l++){
                const level = levels[l];
                const child = object.getObjectByProperty("uuid", level.object);
                if (child !== undefined) object.addLevel(child, level.distance, level.hysteresis);
            }
        }
        return object;
    }
    bindSkeletons(object, skeletons) {
        if (Object.keys(skeletons).length === 0) return;
        object.traverse(function(child) {
            if (child.isSkinnedMesh === true && child.skeleton !== undefined) {
                const skeleton = skeletons[child.skeleton];
                if (skeleton === undefined) console.warn("THREE.ObjectLoader: No skeleton found with UUID:", child.skeleton);
                else child.bind(skeleton, child.bindMatrix);
            }
        });
    }
    constructor(manager){
        super(manager);
    }
}
const $9014d97cd777be10$var$TEXTURE_MAPPING = {
    UVMapping: $9014d97cd777be10$export$1beec6768cbb3d2d,
    CubeReflectionMapping: $9014d97cd777be10$export$8759762a6477f2c4,
    CubeRefractionMapping: $9014d97cd777be10$export$dc59f8aed047f61d,
    EquirectangularReflectionMapping: $9014d97cd777be10$export$d64030b316d3b087,
    EquirectangularRefractionMapping: $9014d97cd777be10$export$ee99d97d46898098,
    CubeUVReflectionMapping: $9014d97cd777be10$export$dbf3e70ff37af79
};
const $9014d97cd777be10$var$TEXTURE_WRAPPING = {
    RepeatWrapping: $9014d97cd777be10$export$533346c8e8dac0f5,
    ClampToEdgeWrapping: $9014d97cd777be10$export$9d9334239a5a5e06,
    MirroredRepeatWrapping: $9014d97cd777be10$export$c7e7c00b14f51a4f
};
const $9014d97cd777be10$var$TEXTURE_FILTER = {
    NearestFilter: $9014d97cd777be10$export$727aa5ec3fe39bf0,
    NearestMipmapNearestFilter: $9014d97cd777be10$export$d129e38cf6feaa8c,
    NearestMipmapLinearFilter: $9014d97cd777be10$export$d2327c1afe5bfdf2,
    LinearFilter: $9014d97cd777be10$export$8a72f490b25c56c8,
    LinearMipmapNearestFilter: $9014d97cd777be10$export$19a719f377145a13,
    LinearMipmapLinearFilter: $9014d97cd777be10$export$5d8599b6a933fb1b
};
class $9014d97cd777be10$export$52286b55c4a9b51f extends $9014d97cd777be10$export$3b0d6d7590275603 {
    setOptions(options) {
        this.options = options;
        return this;
    }
    load(url, onLoad, onProgress, onError) {
        if (url === undefined) url = "";
        if (this.path !== undefined) url = this.path + url;
        url = this.manager.resolveURL(url);
        const scope = this;
        const cached = $9014d97cd777be10$export$94affb487e701bf2.get(url);
        if (cached !== undefined) {
            scope.manager.itemStart(url);
            setTimeout(function() {
                if (onLoad) onLoad(cached);
                scope.manager.itemEnd(url);
            }, 0);
            return cached;
        }
        const fetchOptions = {};
        fetchOptions.credentials = this.crossOrigin === "anonymous" ? "same-origin" : "include";
        fetchOptions.headers = this.requestHeader;
        fetch(url, fetchOptions).then(function(res) {
            return res.blob();
        }).then(function(blob) {
            return createImageBitmap(blob, Object.assign(scope.options, {
                colorSpaceConversion: "none"
            }));
        }).then(function(imageBitmap) {
            $9014d97cd777be10$export$94affb487e701bf2.add(url, imageBitmap);
            if (onLoad) onLoad(imageBitmap);
            scope.manager.itemEnd(url);
        }).catch(function(e) {
            if (onError) onError(e);
            scope.manager.itemError(url);
            scope.manager.itemEnd(url);
        });
        scope.manager.itemStart(url);
    }
    constructor(manager){
        super(manager);
        this.isImageBitmapLoader = true;
        if (typeof createImageBitmap === "undefined") console.warn("THREE.ImageBitmapLoader: createImageBitmap() not supported.");
        if (typeof fetch === "undefined") console.warn("THREE.ImageBitmapLoader: fetch() not supported.");
        this.options = {
            premultiplyAlpha: "none"
        };
    }
}
let $9014d97cd777be10$var$_context;
class $9014d97cd777be10$export$fcbc63750ec2a81f {
    static getContext() {
        if ($9014d97cd777be10$var$_context === undefined) $9014d97cd777be10$var$_context = new (window.AudioContext || window.webkitAudioContext)();
        return $9014d97cd777be10$var$_context;
    }
    static setContext(value) {
        $9014d97cd777be10$var$_context = value;
    }
}
class $9014d97cd777be10$export$d8d5fccfbf47714e extends $9014d97cd777be10$export$3b0d6d7590275603 {
    load(url, onLoad, onProgress, onError) {
        const scope = this;
        const loader = new $9014d97cd777be10$export$98435a25b5cf7b2b(this.manager);
        loader.setResponseType("arraybuffer");
        loader.setPath(this.path);
        loader.setRequestHeader(this.requestHeader);
        loader.setWithCredentials(this.withCredentials);
        loader.load(url, function(buffer) {
            try {
                // Create a copy of the buffer. The `decodeAudioData` method
                // detaches the buffer when complete, preventing reuse.
                const bufferCopy = buffer.slice(0);
                const context = $9014d97cd777be10$export$fcbc63750ec2a81f.getContext();
                context.decodeAudioData(bufferCopy, function(audioBuffer) {
                    onLoad(audioBuffer);
                }, handleError);
            } catch (e) {
                handleError(e);
            }
        }, onProgress, onError);
        function handleError(e) {
            if (onError) onError(e);
            else console.error(e);
            scope.manager.itemError(url);
        }
    }
    constructor(manager){
        super(manager);
    }
}
class $9014d97cd777be10$export$2f22dadc8bc42820 extends $9014d97cd777be10$export$e7ef036e309b38d2 {
    constructor(skyColor, groundColor, intensity = 1){
        super(undefined, intensity);
        this.isHemisphereLightProbe = true;
        const color1 = new $9014d97cd777be10$export$892596cec99bc70e().set(skyColor);
        const color2 = new $9014d97cd777be10$export$892596cec99bc70e().set(groundColor);
        const sky = new $9014d97cd777be10$export$64b5c384219d3699(color1.r, color1.g, color1.b);
        const ground = new $9014d97cd777be10$export$64b5c384219d3699(color2.r, color2.g, color2.b);
        // without extra factor of PI in the shader, should = 1 / Math.sqrt( Math.PI );
        const c0 = Math.sqrt(Math.PI);
        const c1 = c0 * Math.sqrt(0.75);
        this.sh.coefficients[0].copy(sky).add(ground).multiplyScalar(c0);
        this.sh.coefficients[1].copy(sky).sub(ground).multiplyScalar(c1);
    }
}
class $9014d97cd777be10$export$afe310a21c86023d extends $9014d97cd777be10$export$e7ef036e309b38d2 {
    constructor(color, intensity = 1){
        super(undefined, intensity);
        this.isAmbientLightProbe = true;
        const color1 = new $9014d97cd777be10$export$892596cec99bc70e().set(color);
        // without extra factor of PI in the shader, would be 2 / Math.sqrt( Math.PI );
        this.sh.coefficients[0].set(color1.r, color1.g, color1.b).multiplyScalar(2 * Math.sqrt(Math.PI));
    }
}
const $9014d97cd777be10$var$_eyeRight = /*@__PURE__*/ new $9014d97cd777be10$export$2ae72fc923e5eb5();
const $9014d97cd777be10$var$_eyeLeft = /*@__PURE__*/ new $9014d97cd777be10$export$2ae72fc923e5eb5();
const $9014d97cd777be10$var$_projectionMatrix = /*@__PURE__*/ new $9014d97cd777be10$export$2ae72fc923e5eb5();
class $9014d97cd777be10$export$bc7f73a1065bee0c {
    update(camera) {
        const cache = this._cache;
        const needsUpdate = cache.focus !== camera.focus || cache.fov !== camera.fov || cache.aspect !== camera.aspect * this.aspect || cache.near !== camera.near || cache.far !== camera.far || cache.zoom !== camera.zoom || cache.eyeSep !== this.eyeSep;
        if (needsUpdate) {
            cache.focus = camera.focus;
            cache.fov = camera.fov;
            cache.aspect = camera.aspect * this.aspect;
            cache.near = camera.near;
            cache.far = camera.far;
            cache.zoom = camera.zoom;
            cache.eyeSep = this.eyeSep;
            // Off-axis stereoscopic effect based on
            // http://paulbourke.net/stereographics/stereorender/
            $9014d97cd777be10$var$_projectionMatrix.copy(camera.projectionMatrix);
            const eyeSepHalf = cache.eyeSep / 2;
            const eyeSepOnProjection = eyeSepHalf * cache.near / cache.focus;
            const ymax = cache.near * Math.tan($9014d97cd777be10$var$DEG2RAD * cache.fov * 0.5) / cache.zoom;
            let xmin, xmax;
            // translate xOffset
            $9014d97cd777be10$var$_eyeLeft.elements[12] = -eyeSepHalf;
            $9014d97cd777be10$var$_eyeRight.elements[12] = eyeSepHalf;
            // for left eye
            xmin = -ymax * cache.aspect + eyeSepOnProjection;
            xmax = ymax * cache.aspect + eyeSepOnProjection;
            $9014d97cd777be10$var$_projectionMatrix.elements[0] = 2 * cache.near / (xmax - xmin);
            $9014d97cd777be10$var$_projectionMatrix.elements[8] = (xmax + xmin) / (xmax - xmin);
            this.cameraL.projectionMatrix.copy($9014d97cd777be10$var$_projectionMatrix);
            // for right eye
            xmin = -ymax * cache.aspect - eyeSepOnProjection;
            xmax = ymax * cache.aspect - eyeSepOnProjection;
            $9014d97cd777be10$var$_projectionMatrix.elements[0] = 2 * cache.near / (xmax - xmin);
            $9014d97cd777be10$var$_projectionMatrix.elements[8] = (xmax + xmin) / (xmax - xmin);
            this.cameraR.projectionMatrix.copy($9014d97cd777be10$var$_projectionMatrix);
        }
        this.cameraL.matrixWorld.copy(camera.matrixWorld).multiply($9014d97cd777be10$var$_eyeLeft);
        this.cameraR.matrixWorld.copy(camera.matrixWorld).multiply($9014d97cd777be10$var$_eyeRight);
    }
    constructor(){
        this.type = "StereoCamera";
        this.aspect = 1;
        this.eyeSep = 0.064;
        this.cameraL = new $9014d97cd777be10$export$74e4ae24825f68d7();
        this.cameraL.layers.enable(1);
        this.cameraL.matrixAutoUpdate = false;
        this.cameraR = new $9014d97cd777be10$export$74e4ae24825f68d7();
        this.cameraR.layers.enable(2);
        this.cameraR.matrixAutoUpdate = false;
        this._cache = {
            focus: null,
            fov: null,
            aspect: null,
            near: null,
            far: null,
            zoom: null,
            eyeSep: null
        };
    }
}
class $9014d97cd777be10$export$9735c82c4bae3302 {
    start() {
        this.startTime = $9014d97cd777be10$var$now();
        this.oldTime = this.startTime;
        this.elapsedTime = 0;
        this.running = true;
    }
    stop() {
        this.getElapsedTime();
        this.running = false;
        this.autoStart = false;
    }
    getElapsedTime() {
        this.getDelta();
        return this.elapsedTime;
    }
    getDelta() {
        let diff = 0;
        if (this.autoStart && !this.running) {
            this.start();
            return 0;
        }
        if (this.running) {
            const newTime = $9014d97cd777be10$var$now();
            diff = (newTime - this.oldTime) / 1000;
            this.oldTime = newTime;
            this.elapsedTime += diff;
        }
        return diff;
    }
    constructor(autoStart = true){
        this.autoStart = autoStart;
        this.startTime = 0;
        this.oldTime = 0;
        this.elapsedTime = 0;
        this.running = false;
    }
}
function $9014d97cd777be10$var$now() {
    return (typeof performance === "undefined" ? Date : performance).now(); // see #10732
}
const $9014d97cd777be10$var$_position$1 = /*@__PURE__*/ new $9014d97cd777be10$export$64b5c384219d3699();
const $9014d97cd777be10$var$_quaternion$1 = /*@__PURE__*/ new $9014d97cd777be10$export$23d6a54f0bbc85a3();
const $9014d97cd777be10$var$_scale$1 = /*@__PURE__*/ new $9014d97cd777be10$export$64b5c384219d3699();
const $9014d97cd777be10$var$_orientation$1 = /*@__PURE__*/ new $9014d97cd777be10$export$64b5c384219d3699();
class $9014d97cd777be10$export$8a1b810c6fde8951 extends $9014d97cd777be10$export$e4dd07dff30cc924 {
    getInput() {
        return this.gain;
    }
    removeFilter() {
        if (this.filter !== null) {
            this.gain.disconnect(this.filter);
            this.filter.disconnect(this.context.destination);
            this.gain.connect(this.context.destination);
            this.filter = null;
        }
        return this;
    }
    getFilter() {
        return this.filter;
    }
    setFilter(value) {
        if (this.filter !== null) {
            this.gain.disconnect(this.filter);
            this.filter.disconnect(this.context.destination);
        } else this.gain.disconnect(this.context.destination);
        this.filter = value;
        this.gain.connect(this.filter);
        this.filter.connect(this.context.destination);
        return this;
    }
    getMasterVolume() {
        return this.gain.gain.value;
    }
    setMasterVolume(value) {
        this.gain.gain.setTargetAtTime(value, this.context.currentTime, 0.01);
        return this;
    }
    updateMatrixWorld(force) {
        super.updateMatrixWorld(force);
        const listener = this.context.listener;
        const up = this.up;
        this.timeDelta = this._clock.getDelta();
        this.matrixWorld.decompose($9014d97cd777be10$var$_position$1, $9014d97cd777be10$var$_quaternion$1, $9014d97cd777be10$var$_scale$1);
        $9014d97cd777be10$var$_orientation$1.set(0, 0, -1).applyQuaternion($9014d97cd777be10$var$_quaternion$1);
        if (listener.positionX) {
            // code path for Chrome (see #14393)
            const endTime = this.context.currentTime + this.timeDelta;
            listener.positionX.linearRampToValueAtTime($9014d97cd777be10$var$_position$1.x, endTime);
            listener.positionY.linearRampToValueAtTime($9014d97cd777be10$var$_position$1.y, endTime);
            listener.positionZ.linearRampToValueAtTime($9014d97cd777be10$var$_position$1.z, endTime);
            listener.forwardX.linearRampToValueAtTime($9014d97cd777be10$var$_orientation$1.x, endTime);
            listener.forwardY.linearRampToValueAtTime($9014d97cd777be10$var$_orientation$1.y, endTime);
            listener.forwardZ.linearRampToValueAtTime($9014d97cd777be10$var$_orientation$1.z, endTime);
            listener.upX.linearRampToValueAtTime(up.x, endTime);
            listener.upY.linearRampToValueAtTime(up.y, endTime);
            listener.upZ.linearRampToValueAtTime(up.z, endTime);
        } else {
            listener.setPosition($9014d97cd777be10$var$_position$1.x, $9014d97cd777be10$var$_position$1.y, $9014d97cd777be10$var$_position$1.z);
            listener.setOrientation($9014d97cd777be10$var$_orientation$1.x, $9014d97cd777be10$var$_orientation$1.y, $9014d97cd777be10$var$_orientation$1.z, up.x, up.y, up.z);
        }
    }
    constructor(){
        super();
        this.type = "AudioListener";
        this.context = $9014d97cd777be10$export$fcbc63750ec2a81f.getContext();
        this.gain = this.context.createGain();
        this.gain.connect(this.context.destination);
        this.filter = null;
        this.timeDelta = 0;
        // private
        this._clock = new $9014d97cd777be10$export$9735c82c4bae3302();
    }
}
class $9014d97cd777be10$export$153755f98d9861de extends $9014d97cd777be10$export$e4dd07dff30cc924 {
    getOutput() {
        return this.gain;
    }
    setNodeSource(audioNode) {
        this.hasPlaybackControl = false;
        this.sourceType = "audioNode";
        this.source = audioNode;
        this.connect();
        return this;
    }
    setMediaElementSource(mediaElement) {
        this.hasPlaybackControl = false;
        this.sourceType = "mediaNode";
        this.source = this.context.createMediaElementSource(mediaElement);
        this.connect();
        return this;
    }
    setMediaStreamSource(mediaStream) {
        this.hasPlaybackControl = false;
        this.sourceType = "mediaStreamNode";
        this.source = this.context.createMediaStreamSource(mediaStream);
        this.connect();
        return this;
    }
    setBuffer(audioBuffer) {
        this.buffer = audioBuffer;
        this.sourceType = "buffer";
        if (this.autoplay) this.play();
        return this;
    }
    play(delay = 0) {
        if (this.isPlaying === true) {
            console.warn("THREE.Audio: Audio is already playing.");
            return;
        }
        if (this.hasPlaybackControl === false) {
            console.warn("THREE.Audio: this Audio has no playback control.");
            return;
        }
        this._startedAt = this.context.currentTime + delay;
        const source = this.context.createBufferSource();
        source.buffer = this.buffer;
        source.loop = this.loop;
        source.loopStart = this.loopStart;
        source.loopEnd = this.loopEnd;
        source.onended = this.onEnded.bind(this);
        source.start(this._startedAt, this._progress + this.offset, this.duration);
        this.isPlaying = true;
        this.source = source;
        this.setDetune(this.detune);
        this.setPlaybackRate(this.playbackRate);
        return this.connect();
    }
    pause() {
        if (this.hasPlaybackControl === false) {
            console.warn("THREE.Audio: this Audio has no playback control.");
            return;
        }
        if (this.isPlaying === true) {
            // update current progress
            this._progress += Math.max(this.context.currentTime - this._startedAt, 0) * this.playbackRate;
            if (this.loop === true) // ensure _progress does not exceed duration with looped audios
            this._progress = this._progress % (this.duration || this.buffer.duration);
            this.source.stop();
            this.source.onended = null;
            this.isPlaying = false;
        }
        return this;
    }
    stop() {
        if (this.hasPlaybackControl === false) {
            console.warn("THREE.Audio: this Audio has no playback control.");
            return;
        }
        this._progress = 0;
        if (this.source !== null) {
            this.source.stop();
            this.source.onended = null;
        }
        this.isPlaying = false;
        return this;
    }
    connect() {
        if (this.filters.length > 0) {
            this.source.connect(this.filters[0]);
            for(let i = 1, l = this.filters.length; i < l; i++)this.filters[i - 1].connect(this.filters[i]);
            this.filters[this.filters.length - 1].connect(this.getOutput());
        } else this.source.connect(this.getOutput());
        this._connected = true;
        return this;
    }
    disconnect() {
        if (this.filters.length > 0) {
            this.source.disconnect(this.filters[0]);
            for(let i = 1, l = this.filters.length; i < l; i++)this.filters[i - 1].disconnect(this.filters[i]);
            this.filters[this.filters.length - 1].disconnect(this.getOutput());
        } else this.source.disconnect(this.getOutput());
        this._connected = false;
        return this;
    }
    getFilters() {
        return this.filters;
    }
    setFilters(value) {
        if (!value) value = [];
        if (this._connected === true) {
            this.disconnect();
            this.filters = value.slice();
            this.connect();
        } else this.filters = value.slice();
        return this;
    }
    setDetune(value) {
        this.detune = value;
        if (this.source.detune === undefined) return; // only set detune when available
        if (this.isPlaying === true) this.source.detune.setTargetAtTime(this.detune, this.context.currentTime, 0.01);
        return this;
    }
    getDetune() {
        return this.detune;
    }
    getFilter() {
        return this.getFilters()[0];
    }
    setFilter(filter) {
        return this.setFilters(filter ? [
            filter
        ] : []);
    }
    setPlaybackRate(value) {
        if (this.hasPlaybackControl === false) {
            console.warn("THREE.Audio: this Audio has no playback control.");
            return;
        }
        this.playbackRate = value;
        if (this.isPlaying === true) this.source.playbackRate.setTargetAtTime(this.playbackRate, this.context.currentTime, 0.01);
        return this;
    }
    getPlaybackRate() {
        return this.playbackRate;
    }
    onEnded() {
        this.isPlaying = false;
    }
    getLoop() {
        if (this.hasPlaybackControl === false) {
            console.warn("THREE.Audio: this Audio has no playback control.");
            return false;
        }
        return this.loop;
    }
    setLoop(value) {
        if (this.hasPlaybackControl === false) {
            console.warn("THREE.Audio: this Audio has no playback control.");
            return;
        }
        this.loop = value;
        if (this.isPlaying === true) this.source.loop = this.loop;
        return this;
    }
    setLoopStart(value) {
        this.loopStart = value;
        return this;
    }
    setLoopEnd(value) {
        this.loopEnd = value;
        return this;
    }
    getVolume() {
        return this.gain.gain.value;
    }
    setVolume(value) {
        this.gain.gain.setTargetAtTime(value, this.context.currentTime, 0.01);
        return this;
    }
    constructor(listener){
        super();
        this.type = "Audio";
        this.listener = listener;
        this.context = listener.context;
        this.gain = this.context.createGain();
        this.gain.connect(listener.getInput());
        this.autoplay = false;
        this.buffer = null;
        this.detune = 0;
        this.loop = false;
        this.loopStart = 0;
        this.loopEnd = 0;
        this.offset = 0;
        this.duration = undefined;
        this.playbackRate = 1;
        this.isPlaying = false;
        this.hasPlaybackControl = true;
        this.source = null;
        this.sourceType = "empty";
        this._startedAt = 0;
        this._progress = 0;
        this._connected = false;
        this.filters = [];
    }
}
const $9014d97cd777be10$var$_position = /*@__PURE__*/ new $9014d97cd777be10$export$64b5c384219d3699();
const $9014d97cd777be10$var$_quaternion = /*@__PURE__*/ new $9014d97cd777be10$export$23d6a54f0bbc85a3();
const $9014d97cd777be10$var$_scale = /*@__PURE__*/ new $9014d97cd777be10$export$64b5c384219d3699();
const $9014d97cd777be10$var$_orientation = /*@__PURE__*/ new $9014d97cd777be10$export$64b5c384219d3699();
class $9014d97cd777be10$export$4b3e397ef1832507 extends $9014d97cd777be10$export$153755f98d9861de {
    connect() {
        super.connect();
        this.panner.connect(this.gain);
    }
    disconnect() {
        super.disconnect();
        this.panner.disconnect(this.gain);
    }
    getOutput() {
        return this.panner;
    }
    getRefDistance() {
        return this.panner.refDistance;
    }
    setRefDistance(value) {
        this.panner.refDistance = value;
        return this;
    }
    getRolloffFactor() {
        return this.panner.rolloffFactor;
    }
    setRolloffFactor(value) {
        this.panner.rolloffFactor = value;
        return this;
    }
    getDistanceModel() {
        return this.panner.distanceModel;
    }
    setDistanceModel(value) {
        this.panner.distanceModel = value;
        return this;
    }
    getMaxDistance() {
        return this.panner.maxDistance;
    }
    setMaxDistance(value) {
        this.panner.maxDistance = value;
        return this;
    }
    setDirectionalCone(coneInnerAngle, coneOuterAngle, coneOuterGain) {
        this.panner.coneInnerAngle = coneInnerAngle;
        this.panner.coneOuterAngle = coneOuterAngle;
        this.panner.coneOuterGain = coneOuterGain;
        return this;
    }
    updateMatrixWorld(force) {
        super.updateMatrixWorld(force);
        if (this.hasPlaybackControl === true && this.isPlaying === false) return;
        this.matrixWorld.decompose($9014d97cd777be10$var$_position, $9014d97cd777be10$var$_quaternion, $9014d97cd777be10$var$_scale);
        $9014d97cd777be10$var$_orientation.set(0, 0, 1).applyQuaternion($9014d97cd777be10$var$_quaternion);
        const panner = this.panner;
        if (panner.positionX) {
            // code path for Chrome and Firefox (see #14393)
            const endTime = this.context.currentTime + this.listener.timeDelta;
            panner.positionX.linearRampToValueAtTime($9014d97cd777be10$var$_position.x, endTime);
            panner.positionY.linearRampToValueAtTime($9014d97cd777be10$var$_position.y, endTime);
            panner.positionZ.linearRampToValueAtTime($9014d97cd777be10$var$_position.z, endTime);
            panner.orientationX.linearRampToValueAtTime($9014d97cd777be10$var$_orientation.x, endTime);
            panner.orientationY.linearRampToValueAtTime($9014d97cd777be10$var$_orientation.y, endTime);
            panner.orientationZ.linearRampToValueAtTime($9014d97cd777be10$var$_orientation.z, endTime);
        } else {
            panner.setPosition($9014d97cd777be10$var$_position.x, $9014d97cd777be10$var$_position.y, $9014d97cd777be10$var$_position.z);
            panner.setOrientation($9014d97cd777be10$var$_orientation.x, $9014d97cd777be10$var$_orientation.y, $9014d97cd777be10$var$_orientation.z);
        }
    }
    constructor(listener){
        super(listener);
        this.panner = this.context.createPanner();
        this.panner.panningModel = "HRTF";
        this.panner.connect(this.gain);
    }
}
class $9014d97cd777be10$export$d47da1ef3d382827 {
    getFrequencyData() {
        this.analyser.getByteFrequencyData(this.data);
        return this.data;
    }
    getAverageFrequency() {
        let value = 0;
        const data = this.getFrequencyData();
        for(let i = 0; i < data.length; i++)value += data[i];
        return value / data.length;
    }
    constructor(audio, fftSize = 2048){
        this.analyser = audio.context.createAnalyser();
        this.analyser.fftSize = fftSize;
        this.data = new Uint8Array(this.analyser.frequencyBinCount);
        audio.getOutput().connect(this.analyser);
    }
}
class $9014d97cd777be10$export$dfe0af1ca1acb78a {
    // accumulate data in the 'incoming' region into 'accu<i>'
    accumulate(accuIndex, weight) {
        // note: happily accumulating nothing when weight = 0, the caller knows
        // the weight and shouldn't have made the call in the first place
        const buffer = this.buffer, stride = this.valueSize, offset = accuIndex * stride + stride;
        let currentWeight = this.cumulativeWeight;
        if (currentWeight === 0) {
            // accuN := incoming * weight
            for(let i = 0; i !== stride; ++i)buffer[offset + i] = buffer[i];
            currentWeight = weight;
        } else {
            // accuN := accuN + incoming * weight
            currentWeight += weight;
            const mix = weight / currentWeight;
            this._mixBufferRegion(buffer, offset, 0, mix, stride);
        }
        this.cumulativeWeight = currentWeight;
    }
    // accumulate data in the 'incoming' region into 'add'
    accumulateAdditive(weight) {
        const buffer = this.buffer, stride = this.valueSize, offset = stride * this._addIndex;
        if (this.cumulativeWeightAdditive === 0) // add = identity
        this._setIdentity();
        // add := add + incoming * weight
        this._mixBufferRegionAdditive(buffer, offset, 0, weight, stride);
        this.cumulativeWeightAdditive += weight;
    }
    // apply the state of 'accu<i>' to the binding when accus differ
    apply(accuIndex) {
        const stride = this.valueSize, buffer = this.buffer, offset = accuIndex * stride + stride, weight = this.cumulativeWeight, weightAdditive = this.cumulativeWeightAdditive, binding = this.binding;
        this.cumulativeWeight = 0;
        this.cumulativeWeightAdditive = 0;
        if (weight < 1) {
            // accuN := accuN + original * ( 1 - cumulativeWeight )
            const originalValueOffset = stride * this._origIndex;
            this._mixBufferRegion(buffer, offset, originalValueOffset, 1 - weight, stride);
        }
        if (weightAdditive > 0) // accuN := accuN + additive accuN
        this._mixBufferRegionAdditive(buffer, offset, this._addIndex * stride, 1, stride);
        for(let i = stride, e = stride + stride; i !== e; ++i)if (buffer[i] !== buffer[i + stride]) {
            // value has changed -> update scene graph
            binding.setValue(buffer, offset);
            break;
        }
    }
    // remember the state of the bound property and copy it to both accus
    saveOriginalState() {
        const binding = this.binding;
        const buffer = this.buffer, stride = this.valueSize, originalValueOffset = stride * this._origIndex;
        binding.getValue(buffer, originalValueOffset);
        // accu[0..1] := orig -- initially detect changes against the original
        for(let i = stride, e = originalValueOffset; i !== e; ++i)buffer[i] = buffer[originalValueOffset + i % stride];
        // Add to identity for additive
        this._setIdentity();
        this.cumulativeWeight = 0;
        this.cumulativeWeightAdditive = 0;
    }
    // apply the state previously taken via 'saveOriginalState' to the binding
    restoreOriginalState() {
        const originalValueOffset = this.valueSize * 3;
        this.binding.setValue(this.buffer, originalValueOffset);
    }
    _setAdditiveIdentityNumeric() {
        const startIndex = this._addIndex * this.valueSize;
        const endIndex = startIndex + this.valueSize;
        for(let i = startIndex; i < endIndex; i++)this.buffer[i] = 0;
    }
    _setAdditiveIdentityQuaternion() {
        this._setAdditiveIdentityNumeric();
        this.buffer[this._addIndex * this.valueSize + 3] = 1;
    }
    _setAdditiveIdentityOther() {
        const startIndex = this._origIndex * this.valueSize;
        const targetIndex = this._addIndex * this.valueSize;
        for(let i = 0; i < this.valueSize; i++)this.buffer[targetIndex + i] = this.buffer[startIndex + i];
    }
    // mix functions
    _select(buffer, dstOffset, srcOffset, t, stride) {
        if (t >= 0.5) for(let i = 0; i !== stride; ++i)buffer[dstOffset + i] = buffer[srcOffset + i];
    }
    _slerp(buffer, dstOffset, srcOffset, t) {
        $9014d97cd777be10$export$23d6a54f0bbc85a3.slerpFlat(buffer, dstOffset, buffer, dstOffset, buffer, srcOffset, t);
    }
    _slerpAdditive(buffer, dstOffset, srcOffset, t, stride) {
        const workOffset = this._workIndex * stride;
        // Store result in intermediate buffer offset
        $9014d97cd777be10$export$23d6a54f0bbc85a3.multiplyQuaternionsFlat(buffer, workOffset, buffer, dstOffset, buffer, srcOffset);
        // Slerp to the intermediate result
        $9014d97cd777be10$export$23d6a54f0bbc85a3.slerpFlat(buffer, dstOffset, buffer, dstOffset, buffer, workOffset, t);
    }
    _lerp(buffer, dstOffset, srcOffset, t, stride) {
        const s = 1 - t;
        for(let i = 0; i !== stride; ++i){
            const j = dstOffset + i;
            buffer[j] = buffer[j] * s + buffer[srcOffset + i] * t;
        }
    }
    _lerpAdditive(buffer, dstOffset, srcOffset, t, stride) {
        for(let i = 0; i !== stride; ++i){
            const j = dstOffset + i;
            buffer[j] = buffer[j] + buffer[srcOffset + i] * t;
        }
    }
    constructor(binding, typeName, valueSize){
        this.binding = binding;
        this.valueSize = valueSize;
        let mixFunction, mixFunctionAdditive, setIdentity;
        // buffer layout: [ incoming | accu0 | accu1 | orig | addAccu | (optional work) ]
        //
        // interpolators can use .buffer as their .result
        // the data then goes to 'incoming'
        //
        // 'accu0' and 'accu1' are used frame-interleaved for
        // the cumulative result and are compared to detect
        // changes
        //
        // 'orig' stores the original state of the property
        //
        // 'add' is used for additive cumulative results
        //
        // 'work' is optional and is only present for quaternion types. It is used
        // to store intermediate quaternion multiplication results
        switch(typeName){
            case "quaternion":
                mixFunction = this._slerp;
                mixFunctionAdditive = this._slerpAdditive;
                setIdentity = this._setAdditiveIdentityQuaternion;
                this.buffer = new Float64Array(valueSize * 6);
                this._workIndex = 5;
                break;
            case "string":
            case "bool":
                mixFunction = this._select;
                // Use the regular mix function and for additive on these types,
                // additive is not relevant for non-numeric types
                mixFunctionAdditive = this._select;
                setIdentity = this._setAdditiveIdentityOther;
                this.buffer = new Array(valueSize * 5);
                break;
            default:
                mixFunction = this._lerp;
                mixFunctionAdditive = this._lerpAdditive;
                setIdentity = this._setAdditiveIdentityNumeric;
                this.buffer = new Float64Array(valueSize * 5);
        }
        this._mixBufferRegion = mixFunction;
        this._mixBufferRegionAdditive = mixFunctionAdditive;
        this._setIdentity = setIdentity;
        this._origIndex = 3;
        this._addIndex = 4;
        this.cumulativeWeight = 0;
        this.cumulativeWeightAdditive = 0;
        this.useCount = 0;
        this.referenceCount = 0;
    }
}
// Characters [].:/ are reserved for track binding syntax.
const $9014d97cd777be10$var$_RESERVED_CHARS_RE = "\\[\\]\\.:\\/";
const $9014d97cd777be10$var$_reservedRe = new RegExp("[" + $9014d97cd777be10$var$_RESERVED_CHARS_RE + "]", "g");
// Attempts to allow node names from any language. ES5's `\w` regexp matches
// only latin characters, and the unicode \p{L} is not yet supported. So
// instead, we exclude reserved characters and match everything else.
const $9014d97cd777be10$var$_wordChar = "[^" + $9014d97cd777be10$var$_RESERVED_CHARS_RE + "]";
const $9014d97cd777be10$var$_wordCharOrDot = "[^" + $9014d97cd777be10$var$_RESERVED_CHARS_RE.replace("\\.", "") + "]";
// Parent directories, delimited by '/' or ':'. Currently unused, but must
// be matched to parse the rest of the track name.
const $9014d97cd777be10$var$_directoryRe = /*@__PURE__*/ /((?:WC+[\/:])*)/.source.replace("WC", $9014d97cd777be10$var$_wordChar);
// Target node. May contain word characters (a-zA-Z0-9_) and '.' or '-'.
const $9014d97cd777be10$var$_nodeRe = /*@__PURE__*/ /(WCOD+)?/.source.replace("WCOD", $9014d97cd777be10$var$_wordCharOrDot);
// Object on target node, and accessor. May not contain reserved
// characters. Accessor may contain any character except closing bracket.
const $9014d97cd777be10$var$_objectRe = /*@__PURE__*/ /(?:\.(WC+)(?:\[(.+)\])?)?/.source.replace("WC", $9014d97cd777be10$var$_wordChar);
// Property and accessor. May not contain reserved characters. Accessor may
// contain any non-bracket characters.
const $9014d97cd777be10$var$_propertyRe = /*@__PURE__*/ /\.(WC+)(?:\[(.+)\])?/.source.replace("WC", $9014d97cd777be10$var$_wordChar);
const $9014d97cd777be10$var$_trackRe = new RegExp("^" + $9014d97cd777be10$var$_directoryRe + $9014d97cd777be10$var$_nodeRe + $9014d97cd777be10$var$_objectRe + $9014d97cd777be10$var$_propertyRe + "$");
const $9014d97cd777be10$var$_supportedObjectNames = [
    "material",
    "materials",
    "bones",
    "map"
];
class $9014d97cd777be10$var$Composite {
    getValue(array, offset) {
        this.bind(); // bind all binding
        const firstValidIndex = this._targetGroup.nCachedObjects_, binding = this._bindings[firstValidIndex];
        // and only call .getValue on the first
        if (binding !== undefined) binding.getValue(array, offset);
    }
    setValue(array, offset) {
        const bindings = this._bindings;
        for(let i = this._targetGroup.nCachedObjects_, n = bindings.length; i !== n; ++i)bindings[i].setValue(array, offset);
    }
    bind() {
        const bindings = this._bindings;
        for(let i = this._targetGroup.nCachedObjects_, n = bindings.length; i !== n; ++i)bindings[i].bind();
    }
    unbind() {
        const bindings = this._bindings;
        for(let i = this._targetGroup.nCachedObjects_, n = bindings.length; i !== n; ++i)bindings[i].unbind();
    }
    constructor(targetGroup, path, optionalParsedPath){
        const parsedPath = optionalParsedPath || $9014d97cd777be10$export$7bf70fcf9f891893.parseTrackName(path);
        this._targetGroup = targetGroup;
        this._bindings = targetGroup.subscribe_(path, parsedPath);
    }
}
// Note: This class uses a State pattern on a per-method basis:
// 'bind' sets 'this.getValue' / 'setValue' and shadows the
// prototype version of these methods with one that represents
// the bound state. When the property is not found, the methods
// become no-ops.
class $9014d97cd777be10$export$7bf70fcf9f891893 {
    static create(root, path, parsedPath) {
        if (!(root && root.isAnimationObjectGroup)) return new $9014d97cd777be10$export$7bf70fcf9f891893(root, path, parsedPath);
        else return new $9014d97cd777be10$export$7bf70fcf9f891893.Composite(root, path, parsedPath);
    }
    /**
	 * Replaces spaces with underscores and removes unsupported characters from
	 * node names, to ensure compatibility with parseTrackName().
	 *
	 * @param {string} name Node name to be sanitized.
	 * @return {string}
	 */ static sanitizeNodeName(name) {
        return name.replace(/\s/g, "_").replace($9014d97cd777be10$var$_reservedRe, "");
    }
    static parseTrackName(trackName) {
        const matches = $9014d97cd777be10$var$_trackRe.exec(trackName);
        if (matches === null) throw new Error("PropertyBinding: Cannot parse trackName: " + trackName);
        const results = {
            // directoryName: matches[ 1 ], // (tschw) currently unused
            nodeName: matches[2],
            objectName: matches[3],
            objectIndex: matches[4],
            propertyName: matches[5],
            propertyIndex: matches[6]
        };
        const lastDot = results.nodeName && results.nodeName.lastIndexOf(".");
        if (lastDot !== undefined && lastDot !== -1) {
            const objectName = results.nodeName.substring(lastDot + 1);
            // Object names must be checked against an allowlist. Otherwise, there
            // is no way to parse 'foo.bar.baz': 'baz' must be a property, but
            // 'bar' could be the objectName, or part of a nodeName (which can
            // include '.' characters).
            if ($9014d97cd777be10$var$_supportedObjectNames.indexOf(objectName) !== -1) {
                results.nodeName = results.nodeName.substring(0, lastDot);
                results.objectName = objectName;
            }
        }
        if (results.propertyName === null || results.propertyName.length === 0) throw new Error("PropertyBinding: can not parse propertyName from trackName: " + trackName);
        return results;
    }
    static findNode(root, nodeName) {
        if (nodeName === undefined || nodeName === "" || nodeName === "." || nodeName === -1 || nodeName === root.name || nodeName === root.uuid) return root;
        // search into skeleton bones.
        if (root.skeleton) {
            const bone = root.skeleton.getBoneByName(nodeName);
            if (bone !== undefined) return bone;
        }
        // search into node subtree.
        if (root.children) {
            const searchNodeSubtree = function(children) {
                for(let i = 0; i < children.length; i++){
                    const childNode = children[i];
                    if (childNode.name === nodeName || childNode.uuid === nodeName) return childNode;
                    const result = searchNodeSubtree(childNode.children);
                    if (result) return result;
                }
                return null;
            };
            const subTreeNode = searchNodeSubtree(root.children);
            if (subTreeNode) return subTreeNode;
        }
        return null;
    }
    // these are used to "bind" a nonexistent property
    _getValue_unavailable() {}
    _setValue_unavailable() {}
    // Getters
    _getValue_direct(buffer, offset) {
        buffer[offset] = this.targetObject[this.propertyName];
    }
    _getValue_array(buffer, offset) {
        const source = this.resolvedProperty;
        for(let i = 0, n = source.length; i !== n; ++i)buffer[offset++] = source[i];
    }
    _getValue_arrayElement(buffer, offset) {
        buffer[offset] = this.resolvedProperty[this.propertyIndex];
    }
    _getValue_toArray(buffer, offset) {
        this.resolvedProperty.toArray(buffer, offset);
    }
    // Direct
    _setValue_direct(buffer, offset) {
        this.targetObject[this.propertyName] = buffer[offset];
    }
    _setValue_direct_setNeedsUpdate(buffer, offset) {
        this.targetObject[this.propertyName] = buffer[offset];
        this.targetObject.needsUpdate = true;
    }
    _setValue_direct_setMatrixWorldNeedsUpdate(buffer, offset) {
        this.targetObject[this.propertyName] = buffer[offset];
        this.targetObject.matrixWorldNeedsUpdate = true;
    }
    // EntireArray
    _setValue_array(buffer, offset) {
        const dest = this.resolvedProperty;
        for(let i = 0, n = dest.length; i !== n; ++i)dest[i] = buffer[offset++];
    }
    _setValue_array_setNeedsUpdate(buffer, offset) {
        const dest = this.resolvedProperty;
        for(let i = 0, n = dest.length; i !== n; ++i)dest[i] = buffer[offset++];
        this.targetObject.needsUpdate = true;
    }
    _setValue_array_setMatrixWorldNeedsUpdate(buffer, offset) {
        const dest = this.resolvedProperty;
        for(let i = 0, n = dest.length; i !== n; ++i)dest[i] = buffer[offset++];
        this.targetObject.matrixWorldNeedsUpdate = true;
    }
    // ArrayElement
    _setValue_arrayElement(buffer, offset) {
        this.resolvedProperty[this.propertyIndex] = buffer[offset];
    }
    _setValue_arrayElement_setNeedsUpdate(buffer, offset) {
        this.resolvedProperty[this.propertyIndex] = buffer[offset];
        this.targetObject.needsUpdate = true;
    }
    _setValue_arrayElement_setMatrixWorldNeedsUpdate(buffer, offset) {
        this.resolvedProperty[this.propertyIndex] = buffer[offset];
        this.targetObject.matrixWorldNeedsUpdate = true;
    }
    // HasToFromArray
    _setValue_fromArray(buffer, offset) {
        this.resolvedProperty.fromArray(buffer, offset);
    }
    _setValue_fromArray_setNeedsUpdate(buffer, offset) {
        this.resolvedProperty.fromArray(buffer, offset);
        this.targetObject.needsUpdate = true;
    }
    _setValue_fromArray_setMatrixWorldNeedsUpdate(buffer, offset) {
        this.resolvedProperty.fromArray(buffer, offset);
        this.targetObject.matrixWorldNeedsUpdate = true;
    }
    _getValue_unbound(targetArray, offset) {
        this.bind();
        this.getValue(targetArray, offset);
    }
    _setValue_unbound(sourceArray, offset) {
        this.bind();
        this.setValue(sourceArray, offset);
    }
    // create getter / setter pair for a property in the scene graph
    bind() {
        let targetObject = this.node;
        const parsedPath = this.parsedPath;
        const objectName = parsedPath.objectName;
        const propertyName = parsedPath.propertyName;
        let propertyIndex = parsedPath.propertyIndex;
        if (!targetObject) {
            targetObject = $9014d97cd777be10$export$7bf70fcf9f891893.findNode(this.rootNode, parsedPath.nodeName);
            this.node = targetObject;
        }
        // set fail state so we can just 'return' on error
        this.getValue = this._getValue_unavailable;
        this.setValue = this._setValue_unavailable;
        // ensure there is a value node
        if (!targetObject) {
            console.warn("THREE.PropertyBinding: No target node found for track: " + this.path + ".");
            return;
        }
        if (objectName) {
            let objectIndex = parsedPath.objectIndex;
            // special cases were we need to reach deeper into the hierarchy to get the face materials....
            switch(objectName){
                case "materials":
                    if (!targetObject.material) {
                        console.error("THREE.PropertyBinding: Can not bind to material as node does not have a material.", this);
                        return;
                    }
                    if (!targetObject.material.materials) {
                        console.error("THREE.PropertyBinding: Can not bind to material.materials as node.material does not have a materials array.", this);
                        return;
                    }
                    targetObject = targetObject.material.materials;
                    break;
                case "bones":
                    if (!targetObject.skeleton) {
                        console.error("THREE.PropertyBinding: Can not bind to bones as node does not have a skeleton.", this);
                        return;
                    }
                    // potential future optimization: skip this if propertyIndex is already an integer
                    // and convert the integer string to a true integer.
                    targetObject = targetObject.skeleton.bones;
                    // support resolving morphTarget names into indices.
                    for(let i = 0; i < targetObject.length; i++)if (targetObject[i].name === objectIndex) {
                        objectIndex = i;
                        break;
                    }
                    break;
                case "map":
                    if ("map" in targetObject) {
                        targetObject = targetObject.map;
                        break;
                    }
                    if (!targetObject.material) {
                        console.error("THREE.PropertyBinding: Can not bind to material as node does not have a material.", this);
                        return;
                    }
                    if (!targetObject.material.map) {
                        console.error("THREE.PropertyBinding: Can not bind to material.map as node.material does not have a map.", this);
                        return;
                    }
                    targetObject = targetObject.material.map;
                    break;
                default:
                    if (targetObject[objectName] === undefined) {
                        console.error("THREE.PropertyBinding: Can not bind to objectName of node undefined.", this);
                        return;
                    }
                    targetObject = targetObject[objectName];
            }
            if (objectIndex !== undefined) {
                if (targetObject[objectIndex] === undefined) {
                    console.error("THREE.PropertyBinding: Trying to bind to objectIndex of objectName, but is undefined.", this, targetObject);
                    return;
                }
                targetObject = targetObject[objectIndex];
            }
        }
        // resolve property
        const nodeProperty = targetObject[propertyName];
        if (nodeProperty === undefined) {
            const nodeName = parsedPath.nodeName;
            console.error("THREE.PropertyBinding: Trying to update property for track: " + nodeName + "." + propertyName + " but it wasn't found.", targetObject);
            return;
        }
        // determine versioning scheme
        let versioning = this.Versioning.None;
        this.targetObject = targetObject;
        if (targetObject.needsUpdate !== undefined) versioning = this.Versioning.NeedsUpdate;
        else if (targetObject.matrixWorldNeedsUpdate !== undefined) versioning = this.Versioning.MatrixWorldNeedsUpdate;
        // determine how the property gets bound
        let bindingType = this.BindingType.Direct;
        if (propertyIndex !== undefined) {
            // access a sub element of the property array (only primitives are supported right now)
            if (propertyName === "morphTargetInfluences") {
                // potential optimization, skip this if propertyIndex is already an integer, and convert the integer string to a true integer.
                // support resolving morphTarget names into indices.
                if (!targetObject.geometry) {
                    console.error("THREE.PropertyBinding: Can not bind to morphTargetInfluences because node does not have a geometry.", this);
                    return;
                }
                if (!targetObject.geometry.morphAttributes) {
                    console.error("THREE.PropertyBinding: Can not bind to morphTargetInfluences because node does not have a geometry.morphAttributes.", this);
                    return;
                }
                if (targetObject.morphTargetDictionary[propertyIndex] !== undefined) propertyIndex = targetObject.morphTargetDictionary[propertyIndex];
            }
            bindingType = this.BindingType.ArrayElement;
            this.resolvedProperty = nodeProperty;
            this.propertyIndex = propertyIndex;
        } else if (nodeProperty.fromArray !== undefined && nodeProperty.toArray !== undefined) {
            // must use copy for Object3D.Euler/Quaternion
            bindingType = this.BindingType.HasFromToArray;
            this.resolvedProperty = nodeProperty;
        } else if (Array.isArray(nodeProperty)) {
            bindingType = this.BindingType.EntireArray;
            this.resolvedProperty = nodeProperty;
        } else this.propertyName = propertyName;
        // select getter / setter
        this.getValue = this.GetterByBindingType[bindingType];
        this.setValue = this.SetterByBindingTypeAndVersioning[bindingType][versioning];
    }
    unbind() {
        this.node = null;
        // back to the prototype version of getValue / setValue
        // note: avoiding to mutate the shape of 'this' via 'delete'
        this.getValue = this._getValue_unbound;
        this.setValue = this._setValue_unbound;
    }
    constructor(rootNode, path, parsedPath){
        this.path = path;
        this.parsedPath = parsedPath || $9014d97cd777be10$export$7bf70fcf9f891893.parseTrackName(path);
        this.node = $9014d97cd777be10$export$7bf70fcf9f891893.findNode(rootNode, this.parsedPath.nodeName);
        this.rootNode = rootNode;
        // initial state of these methods that calls 'bind'
        this.getValue = this._getValue_unbound;
        this.setValue = this._setValue_unbound;
    }
}
$9014d97cd777be10$export$7bf70fcf9f891893.Composite = $9014d97cd777be10$var$Composite;
$9014d97cd777be10$export$7bf70fcf9f891893.prototype.BindingType = {
    Direct: 0,
    EntireArray: 1,
    ArrayElement: 2,
    HasFromToArray: 3
};
$9014d97cd777be10$export$7bf70fcf9f891893.prototype.Versioning = {
    None: 0,
    NeedsUpdate: 1,
    MatrixWorldNeedsUpdate: 2
};
$9014d97cd777be10$export$7bf70fcf9f891893.prototype.GetterByBindingType = [
    $9014d97cd777be10$export$7bf70fcf9f891893.prototype._getValue_direct,
    $9014d97cd777be10$export$7bf70fcf9f891893.prototype._getValue_array,
    $9014d97cd777be10$export$7bf70fcf9f891893.prototype._getValue_arrayElement,
    $9014d97cd777be10$export$7bf70fcf9f891893.prototype._getValue_toArray
];
$9014d97cd777be10$export$7bf70fcf9f891893.prototype.SetterByBindingTypeAndVersioning = [
    [
        // Direct
        $9014d97cd777be10$export$7bf70fcf9f891893.prototype._setValue_direct,
        $9014d97cd777be10$export$7bf70fcf9f891893.prototype._setValue_direct_setNeedsUpdate,
        $9014d97cd777be10$export$7bf70fcf9f891893.prototype._setValue_direct_setMatrixWorldNeedsUpdate
    ],
    [
        // EntireArray
        $9014d97cd777be10$export$7bf70fcf9f891893.prototype._setValue_array,
        $9014d97cd777be10$export$7bf70fcf9f891893.prototype._setValue_array_setNeedsUpdate,
        $9014d97cd777be10$export$7bf70fcf9f891893.prototype._setValue_array_setMatrixWorldNeedsUpdate
    ],
    [
        // ArrayElement
        $9014d97cd777be10$export$7bf70fcf9f891893.prototype._setValue_arrayElement,
        $9014d97cd777be10$export$7bf70fcf9f891893.prototype._setValue_arrayElement_setNeedsUpdate,
        $9014d97cd777be10$export$7bf70fcf9f891893.prototype._setValue_arrayElement_setMatrixWorldNeedsUpdate
    ],
    [
        // HasToFromArray
        $9014d97cd777be10$export$7bf70fcf9f891893.prototype._setValue_fromArray,
        $9014d97cd777be10$export$7bf70fcf9f891893.prototype._setValue_fromArray_setNeedsUpdate,
        $9014d97cd777be10$export$7bf70fcf9f891893.prototype._setValue_fromArray_setMatrixWorldNeedsUpdate
    ]
];
/**
 *
 * A group of objects that receives a shared animation state.
 *
 * Usage:
 *
 *  - Add objects you would otherwise pass as 'root' to the
 *    constructor or the .clipAction method of AnimationMixer.
 *
 *  - Instead pass this object as 'root'.
 *
 *  - You can also add and remove objects later when the mixer
 *    is running.
 *
 * Note:
 *
 *    Objects of this class appear as one object to the mixer,
 *    so cache control of the individual objects must be done
 *    on the group.
 *
 * Limitation:
 *
 *  - The animated properties must be compatible among the
 *    all objects in the group.
 *
 *  - A single property can either be controlled through a
 *    target group or directly, but not both.
 */ class $9014d97cd777be10$export$30619c2afd3f34db {
    add() {
        const objects = this._objects, indicesByUUID = this._indicesByUUID, paths = this._paths, parsedPaths = this._parsedPaths, bindings = this._bindings, nBindings = bindings.length;
        let knownObject = undefined, nObjects = objects.length, nCachedObjects = this.nCachedObjects_;
        for(let i = 0, n = arguments.length; i !== n; ++i){
            const object = arguments[i], uuid = object.uuid;
            let index = indicesByUUID[uuid];
            if (index === undefined) {
                // unknown object -> add it to the ACTIVE region
                index = nObjects++;
                indicesByUUID[uuid] = index;
                objects.push(object);
                // accounting is done, now do the same for all bindings
                for(let j = 0, m = nBindings; j !== m; ++j)bindings[j].push(new $9014d97cd777be10$export$7bf70fcf9f891893(object, paths[j], parsedPaths[j]));
            } else if (index < nCachedObjects) {
                knownObject = objects[index];
                // move existing object to the ACTIVE region
                const firstActiveIndex = --nCachedObjects, lastCachedObject = objects[firstActiveIndex];
                indicesByUUID[lastCachedObject.uuid] = index;
                objects[index] = lastCachedObject;
                indicesByUUID[uuid] = firstActiveIndex;
                objects[firstActiveIndex] = object;
                // accounting is done, now do the same for all bindings
                for(let j = 0, m = nBindings; j !== m; ++j){
                    const bindingsForPath = bindings[j], lastCached = bindingsForPath[firstActiveIndex];
                    let binding = bindingsForPath[index];
                    bindingsForPath[index] = lastCached;
                    if (binding === undefined) // since we do not bother to create new bindings
                    // for objects that are cached, the binding may
                    // or may not exist
                    binding = new $9014d97cd777be10$export$7bf70fcf9f891893(object, paths[j], parsedPaths[j]);
                    bindingsForPath[firstActiveIndex] = binding;
                }
            } else if (objects[index] !== knownObject) console.error("THREE.AnimationObjectGroup: Different objects with the same UUID detected. Clean the caches or recreate your infrastructure when reloading scenes.");
             // else the object is already where we want it to be
        } // for arguments
        this.nCachedObjects_ = nCachedObjects;
    }
    remove() {
        const objects = this._objects, indicesByUUID = this._indicesByUUID, bindings = this._bindings, nBindings = bindings.length;
        let nCachedObjects = this.nCachedObjects_;
        for(let i = 0, n = arguments.length; i !== n; ++i){
            const object = arguments[i], uuid = object.uuid, index = indicesByUUID[uuid];
            if (index !== undefined && index >= nCachedObjects) {
                // move existing object into the CACHED region
                const lastCachedIndex = nCachedObjects++, firstActiveObject = objects[lastCachedIndex];
                indicesByUUID[firstActiveObject.uuid] = index;
                objects[index] = firstActiveObject;
                indicesByUUID[uuid] = lastCachedIndex;
                objects[lastCachedIndex] = object;
                // accounting is done, now do the same for all bindings
                for(let j = 0, m = nBindings; j !== m; ++j){
                    const bindingsForPath = bindings[j], firstActive = bindingsForPath[lastCachedIndex], binding = bindingsForPath[index];
                    bindingsForPath[index] = firstActive;
                    bindingsForPath[lastCachedIndex] = binding;
                }
            }
        } // for arguments
        this.nCachedObjects_ = nCachedObjects;
    }
    // remove & forget
    uncache() {
        const objects = this._objects, indicesByUUID = this._indicesByUUID, bindings = this._bindings, nBindings = bindings.length;
        let nCachedObjects = this.nCachedObjects_, nObjects = objects.length;
        for(let i = 0, n = arguments.length; i !== n; ++i){
            const object = arguments[i], uuid = object.uuid, index = indicesByUUID[uuid];
            if (index !== undefined) {
                delete indicesByUUID[uuid];
                if (index < nCachedObjects) {
                    // object is cached, shrink the CACHED region
                    const firstActiveIndex = --nCachedObjects, lastCachedObject = objects[firstActiveIndex], lastIndex = --nObjects, lastObject = objects[lastIndex];
                    // last cached object takes this object's place
                    indicesByUUID[lastCachedObject.uuid] = index;
                    objects[index] = lastCachedObject;
                    // last object goes to the activated slot and pop
                    indicesByUUID[lastObject.uuid] = firstActiveIndex;
                    objects[firstActiveIndex] = lastObject;
                    objects.pop();
                    // accounting is done, now do the same for all bindings
                    for(let j = 0, m = nBindings; j !== m; ++j){
                        const bindingsForPath = bindings[j], lastCached = bindingsForPath[firstActiveIndex], last = bindingsForPath[lastIndex];
                        bindingsForPath[index] = lastCached;
                        bindingsForPath[firstActiveIndex] = last;
                        bindingsForPath.pop();
                    }
                } else {
                    // object is active, just swap with the last and pop
                    const lastIndex = --nObjects, lastObject = objects[lastIndex];
                    if (lastIndex > 0) indicesByUUID[lastObject.uuid] = index;
                    objects[index] = lastObject;
                    objects.pop();
                    // accounting is done, now do the same for all bindings
                    for(let j = 0, m = nBindings; j !== m; ++j){
                        const bindingsForPath = bindings[j];
                        bindingsForPath[index] = bindingsForPath[lastIndex];
                        bindingsForPath.pop();
                    }
                } // cached or active
            } // if object is known
        } // for arguments
        this.nCachedObjects_ = nCachedObjects;
    }
    // Internal interface used by befriended PropertyBinding.Composite:
    subscribe_(path, parsedPath) {
        // returns an array of bindings for the given path that is changed
        // according to the contained objects in the group
        const indicesByPath = this._bindingsIndicesByPath;
        let index = indicesByPath[path];
        const bindings = this._bindings;
        if (index !== undefined) return bindings[index];
        const paths = this._paths, parsedPaths = this._parsedPaths, objects = this._objects, nObjects = objects.length, nCachedObjects = this.nCachedObjects_, bindingsForPath = new Array(nObjects);
        index = bindings.length;
        indicesByPath[path] = index;
        paths.push(path);
        parsedPaths.push(parsedPath);
        bindings.push(bindingsForPath);
        for(let i = nCachedObjects, n = objects.length; i !== n; ++i){
            const object = objects[i];
            bindingsForPath[i] = new $9014d97cd777be10$export$7bf70fcf9f891893(object, path, parsedPath);
        }
        return bindingsForPath;
    }
    unsubscribe_(path) {
        // tells the group to forget about a property path and no longer
        // update the array previously obtained with 'subscribe_'
        const indicesByPath = this._bindingsIndicesByPath, index = indicesByPath[path];
        if (index !== undefined) {
            const paths = this._paths, parsedPaths = this._parsedPaths, bindings = this._bindings, lastBindingsIndex = bindings.length - 1, lastBindings = bindings[lastBindingsIndex], lastBindingsPath = path[lastBindingsIndex];
            indicesByPath[lastBindingsPath] = index;
            bindings[index] = lastBindings;
            bindings.pop();
            parsedPaths[index] = parsedPaths[lastBindingsIndex];
            parsedPaths.pop();
            paths[index] = paths[lastBindingsIndex];
            paths.pop();
        }
    }
    constructor(){
        this.isAnimationObjectGroup = true;
        this.uuid = $9014d97cd777be10$var$generateUUID();
        // cached objects followed by the active ones
        this._objects = Array.prototype.slice.call(arguments);
        this.nCachedObjects_ = 0; // threshold
        // note: read by PropertyBinding.Composite
        const indices = {};
        this._indicesByUUID = indices; // for bookkeeping
        for(let i = 0, n = arguments.length; i !== n; ++i)indices[arguments[i].uuid] = i;
        this._paths = []; // inside: string
        this._parsedPaths = []; // inside: { we don't care, here }
        this._bindings = []; // inside: Array< PropertyBinding >
        this._bindingsIndicesByPath = {}; // inside: indices in these arrays
        const scope = this;
        this.stats = {
            objects: {
                get total () {
                    return scope._objects.length;
                },
                get inUse () {
                    return this.total - scope.nCachedObjects_;
                }
            },
            get bindingsPerObject () {
                return scope._bindings.length;
            }
        };
    }
}
class $9014d97cd777be10$export$6946940a69e799e {
    // State & Scheduling
    play() {
        this._mixer._activateAction(this);
        return this;
    }
    stop() {
        this._mixer._deactivateAction(this);
        return this.reset();
    }
    reset() {
        this.paused = false;
        this.enabled = true;
        this.time = 0; // restart clip
        this._loopCount = -1; // forget previous loops
        this._startTime = null; // forget scheduling
        return this.stopFading().stopWarping();
    }
    isRunning() {
        return this.enabled && !this.paused && this.timeScale !== 0 && this._startTime === null && this._mixer._isActiveAction(this);
    }
    // return true when play has been called
    isScheduled() {
        return this._mixer._isActiveAction(this);
    }
    startAt(time) {
        this._startTime = time;
        return this;
    }
    setLoop(mode, repetitions) {
        this.loop = mode;
        this.repetitions = repetitions;
        return this;
    }
    // Weight
    // set the weight stopping any scheduled fading
    // although .enabled = false yields an effective weight of zero, this
    // method does *not* change .enabled, because it would be confusing
    setEffectiveWeight(weight) {
        this.weight = weight;
        // note: same logic as when updated at runtime
        this._effectiveWeight = this.enabled ? weight : 0;
        return this.stopFading();
    }
    // return the weight considering fading and .enabled
    getEffectiveWeight() {
        return this._effectiveWeight;
    }
    fadeIn(duration) {
        return this._scheduleFading(duration, 0, 1);
    }
    fadeOut(duration) {
        return this._scheduleFading(duration, 1, 0);
    }
    crossFadeFrom(fadeOutAction, duration, warp) {
        fadeOutAction.fadeOut(duration);
        this.fadeIn(duration);
        if (warp) {
            const fadeInDuration = this._clip.duration, fadeOutDuration = fadeOutAction._clip.duration, startEndRatio = fadeOutDuration / fadeInDuration, endStartRatio = fadeInDuration / fadeOutDuration;
            fadeOutAction.warp(1.0, startEndRatio, duration);
            this.warp(endStartRatio, 1.0, duration);
        }
        return this;
    }
    crossFadeTo(fadeInAction, duration, warp) {
        return fadeInAction.crossFadeFrom(this, duration, warp);
    }
    stopFading() {
        const weightInterpolant = this._weightInterpolant;
        if (weightInterpolant !== null) {
            this._weightInterpolant = null;
            this._mixer._takeBackControlInterpolant(weightInterpolant);
        }
        return this;
    }
    // Time Scale Control
    // set the time scale stopping any scheduled warping
    // although .paused = true yields an effective time scale of zero, this
    // method does *not* change .paused, because it would be confusing
    setEffectiveTimeScale(timeScale) {
        this.timeScale = timeScale;
        this._effectiveTimeScale = this.paused ? 0 : timeScale;
        return this.stopWarping();
    }
    // return the time scale considering warping and .paused
    getEffectiveTimeScale() {
        return this._effectiveTimeScale;
    }
    setDuration(duration) {
        this.timeScale = this._clip.duration / duration;
        return this.stopWarping();
    }
    syncWith(action) {
        this.time = action.time;
        this.timeScale = action.timeScale;
        return this.stopWarping();
    }
    halt(duration) {
        return this.warp(this._effectiveTimeScale, 0, duration);
    }
    warp(startTimeScale, endTimeScale, duration) {
        const mixer = this._mixer, now = mixer.time, timeScale = this.timeScale;
        let interpolant = this._timeScaleInterpolant;
        if (interpolant === null) {
            interpolant = mixer._lendControlInterpolant();
            this._timeScaleInterpolant = interpolant;
        }
        const times = interpolant.parameterPositions, values = interpolant.sampleValues;
        times[0] = now;
        times[1] = now + duration;
        values[0] = startTimeScale / timeScale;
        values[1] = endTimeScale / timeScale;
        return this;
    }
    stopWarping() {
        const timeScaleInterpolant = this._timeScaleInterpolant;
        if (timeScaleInterpolant !== null) {
            this._timeScaleInterpolant = null;
            this._mixer._takeBackControlInterpolant(timeScaleInterpolant);
        }
        return this;
    }
    // Object Accessors
    getMixer() {
        return this._mixer;
    }
    getClip() {
        return this._clip;
    }
    getRoot() {
        return this._localRoot || this._mixer._root;
    }
    // Interna
    _update(time, deltaTime, timeDirection, accuIndex) {
        // called by the mixer
        if (!this.enabled) {
            // call ._updateWeight() to update ._effectiveWeight
            this._updateWeight(time);
            return;
        }
        const startTime = this._startTime;
        if (startTime !== null) {
            // check for scheduled start of action
            const timeRunning = (time - startTime) * timeDirection;
            if (timeRunning < 0 || timeDirection === 0) deltaTime = 0;
            else {
                this._startTime = null; // unschedule
                deltaTime = timeDirection * timeRunning;
            }
        }
        // apply time scale and advance time
        deltaTime *= this._updateTimeScale(time);
        const clipTime = this._updateTime(deltaTime);
        // note: _updateTime may disable the action resulting in
        // an effective weight of 0
        const weight = this._updateWeight(time);
        if (weight > 0) {
            const interpolants = this._interpolants;
            const propertyMixers = this._propertyBindings;
            switch(this.blendMode){
                case $9014d97cd777be10$export$d875e029ef558d3:
                    for(let j = 0, m = interpolants.length; j !== m; ++j){
                        interpolants[j].evaluate(clipTime);
                        propertyMixers[j].accumulateAdditive(weight);
                    }
                    break;
                case $9014d97cd777be10$export$bcfbbdcf8de7f8cd:
                default:
                    for(let j = 0, m = interpolants.length; j !== m; ++j){
                        interpolants[j].evaluate(clipTime);
                        propertyMixers[j].accumulate(accuIndex, weight);
                    }
            }
        }
    }
    _updateWeight(time) {
        let weight = 0;
        if (this.enabled) {
            weight = this.weight;
            const interpolant = this._weightInterpolant;
            if (interpolant !== null) {
                const interpolantValue = interpolant.evaluate(time)[0];
                weight *= interpolantValue;
                if (time > interpolant.parameterPositions[1]) {
                    this.stopFading();
                    if (interpolantValue === 0) // faded out, disable
                    this.enabled = false;
                }
            }
        }
        this._effectiveWeight = weight;
        return weight;
    }
    _updateTimeScale(time) {
        let timeScale = 0;
        if (!this.paused) {
            timeScale = this.timeScale;
            const interpolant = this._timeScaleInterpolant;
            if (interpolant !== null) {
                const interpolantValue = interpolant.evaluate(time)[0];
                timeScale *= interpolantValue;
                if (time > interpolant.parameterPositions[1]) {
                    this.stopWarping();
                    if (timeScale === 0) // motion has halted, pause
                    this.paused = true;
                    else // warp done - apply final time scale
                    this.timeScale = timeScale;
                }
            }
        }
        this._effectiveTimeScale = timeScale;
        return timeScale;
    }
    _updateTime(deltaTime) {
        const duration = this._clip.duration;
        const loop = this.loop;
        let time = this.time + deltaTime;
        let loopCount = this._loopCount;
        const pingPong = loop === $9014d97cd777be10$export$f8f6f2041b78e210;
        if (deltaTime === 0) {
            if (loopCount === -1) return time;
            return pingPong && (loopCount & 1) === 1 ? duration - time : time;
        }
        if (loop === $9014d97cd777be10$export$d62fdc9d1b1cccad) {
            if (loopCount === -1) {
                // just started
                this._loopCount = 0;
                this._setEndings(true, true, false);
            }
            handle_stop: {
                if (time >= duration) time = duration;
                else if (time < 0) time = 0;
                else {
                    this.time = time;
                    break handle_stop;
                }
                if (this.clampWhenFinished) this.paused = true;
                else this.enabled = false;
                this.time = time;
                this._mixer.dispatchEvent({
                    type: "finished",
                    action: this,
                    direction: deltaTime < 0 ? -1 : 1
                });
            }
        } else {
            if (loopCount === -1) {
                // just started
                if (deltaTime >= 0) {
                    loopCount = 0;
                    this._setEndings(true, this.repetitions === 0, pingPong);
                } else // when looping in reverse direction, the initial
                // transition through zero counts as a repetition,
                // so leave loopCount at -1
                this._setEndings(this.repetitions === 0, true, pingPong);
            }
            if (time >= duration || time < 0) {
                // wrap around
                const loopDelta = Math.floor(time / duration); // signed
                time -= duration * loopDelta;
                loopCount += Math.abs(loopDelta);
                const pending = this.repetitions - loopCount;
                if (pending <= 0) {
                    // have to stop (switch state, clamp time, fire event)
                    if (this.clampWhenFinished) this.paused = true;
                    else this.enabled = false;
                    time = deltaTime > 0 ? duration : 0;
                    this.time = time;
                    this._mixer.dispatchEvent({
                        type: "finished",
                        action: this,
                        direction: deltaTime > 0 ? 1 : -1
                    });
                } else {
                    // keep running
                    if (pending === 1) {
                        // entering the last round
                        const atStart = deltaTime < 0;
                        this._setEndings(atStart, !atStart, pingPong);
                    } else this._setEndings(false, false, pingPong);
                    this._loopCount = loopCount;
                    this.time = time;
                    this._mixer.dispatchEvent({
                        type: "loop",
                        action: this,
                        loopDelta: loopDelta
                    });
                }
            } else this.time = time;
            if (pingPong && (loopCount & 1) === 1) // invert time for the "pong round"
            return duration - time;
        }
        return time;
    }
    _setEndings(atStart, atEnd, pingPong) {
        const settings = this._interpolantSettings;
        if (pingPong) {
            settings.endingStart = $9014d97cd777be10$export$24a4ccb5099273b5;
            settings.endingEnd = $9014d97cd777be10$export$24a4ccb5099273b5;
        } else {
            // assuming for LoopOnce atStart == atEnd == true
            if (atStart) settings.endingStart = this.zeroSlopeAtStart ? $9014d97cd777be10$export$24a4ccb5099273b5 : $9014d97cd777be10$export$7f795934b84ab523;
            else settings.endingStart = $9014d97cd777be10$export$8e8c3ecdcd8e1fee;
            if (atEnd) settings.endingEnd = this.zeroSlopeAtEnd ? $9014d97cd777be10$export$24a4ccb5099273b5 : $9014d97cd777be10$export$7f795934b84ab523;
            else settings.endingEnd = $9014d97cd777be10$export$8e8c3ecdcd8e1fee;
        }
    }
    _scheduleFading(duration, weightNow, weightThen) {
        const mixer = this._mixer, now = mixer.time;
        let interpolant = this._weightInterpolant;
        if (interpolant === null) {
            interpolant = mixer._lendControlInterpolant();
            this._weightInterpolant = interpolant;
        }
        const times = interpolant.parameterPositions, values = interpolant.sampleValues;
        times[0] = now;
        values[0] = weightNow;
        times[1] = now + duration;
        values[1] = weightThen;
        return this;
    }
    constructor(mixer, clip, localRoot = null, blendMode = clip.blendMode){
        this._mixer = mixer;
        this._clip = clip;
        this._localRoot = localRoot;
        this.blendMode = blendMode;
        const tracks = clip.tracks, nTracks = tracks.length, interpolants = new Array(nTracks);
        const interpolantSettings = {
            endingStart: $9014d97cd777be10$export$7f795934b84ab523,
            endingEnd: $9014d97cd777be10$export$7f795934b84ab523
        };
        for(let i = 0; i !== nTracks; ++i){
            const interpolant = tracks[i].createInterpolant(null);
            interpolants[i] = interpolant;
            interpolant.settings = interpolantSettings;
        }
        this._interpolantSettings = interpolantSettings;
        this._interpolants = interpolants; // bound by the mixer
        // inside: PropertyMixer (managed by the mixer)
        this._propertyBindings = new Array(nTracks);
        this._cacheIndex = null; // for the memory manager
        this._byClipCacheIndex = null; // for the memory manager
        this._timeScaleInterpolant = null;
        this._weightInterpolant = null;
        this.loop = $9014d97cd777be10$export$dfaf4422ce096e29;
        this._loopCount = -1;
        // global mixer time when the action is to be started
        // it's set back to 'null' upon start of the action
        this._startTime = null;
        // scaled local time of the action
        // gets clamped or wrapped to 0..clip.duration according to loop
        this.time = 0;
        this.timeScale = 1;
        this._effectiveTimeScale = 1;
        this.weight = 1;
        this._effectiveWeight = 1;
        this.repetitions = Infinity; // no. of repetitions when looping
        this.paused = false; // true -> zero effective time scale
        this.enabled = true; // false -> zero effective weight
        this.clampWhenFinished = false; // keep feeding the last frame?
        this.zeroSlopeAtStart = true; // for smooth interpolation w/o separate
        this.zeroSlopeAtEnd = true; // clips for start, loop and end
    }
}
const $9014d97cd777be10$var$_controlInterpolantsResultBuffer = new Float32Array(1);
class $9014d97cd777be10$export$fbd77e5aefaa0102 extends $9014d97cd777be10$export$ec8b666c5fe2c75a {
    _bindAction(action, prototypeAction) {
        const root = action._localRoot || this._root, tracks = action._clip.tracks, nTracks = tracks.length, bindings = action._propertyBindings, interpolants = action._interpolants, rootUuid = root.uuid, bindingsByRoot = this._bindingsByRootAndName;
        let bindingsByName = bindingsByRoot[rootUuid];
        if (bindingsByName === undefined) {
            bindingsByName = {};
            bindingsByRoot[rootUuid] = bindingsByName;
        }
        for(let i = 0; i !== nTracks; ++i){
            const track = tracks[i], trackName = track.name;
            let binding = bindingsByName[trackName];
            if (binding !== undefined) {
                ++binding.referenceCount;
                bindings[i] = binding;
            } else {
                binding = bindings[i];
                if (binding !== undefined) {
                    // existing binding, make sure the cache knows
                    if (binding._cacheIndex === null) {
                        ++binding.referenceCount;
                        this._addInactiveBinding(binding, rootUuid, trackName);
                    }
                    continue;
                }
                const path = prototypeAction && prototypeAction._propertyBindings[i].binding.parsedPath;
                binding = new $9014d97cd777be10$export$dfe0af1ca1acb78a($9014d97cd777be10$export$7bf70fcf9f891893.create(root, trackName, path), track.ValueTypeName, track.getValueSize());
                ++binding.referenceCount;
                this._addInactiveBinding(binding, rootUuid, trackName);
                bindings[i] = binding;
            }
            interpolants[i].resultBuffer = binding.buffer;
        }
    }
    _activateAction(action) {
        if (!this._isActiveAction(action)) {
            if (action._cacheIndex === null) {
                // this action has been forgotten by the cache, but the user
                // appears to be still using it -> rebind
                const rootUuid = (action._localRoot || this._root).uuid, clipUuid = action._clip.uuid, actionsForClip = this._actionsByClip[clipUuid];
                this._bindAction(action, actionsForClip && actionsForClip.knownActions[0]);
                this._addInactiveAction(action, clipUuid, rootUuid);
            }
            const bindings = action._propertyBindings;
            // increment reference counts / sort out state
            for(let i = 0, n = bindings.length; i !== n; ++i){
                const binding = bindings[i];
                if (binding.useCount++ === 0) {
                    this._lendBinding(binding);
                    binding.saveOriginalState();
                }
            }
            this._lendAction(action);
        }
    }
    _deactivateAction(action) {
        if (this._isActiveAction(action)) {
            const bindings = action._propertyBindings;
            // decrement reference counts / sort out state
            for(let i = 0, n = bindings.length; i !== n; ++i){
                const binding = bindings[i];
                if (--binding.useCount === 0) {
                    binding.restoreOriginalState();
                    this._takeBackBinding(binding);
                }
            }
            this._takeBackAction(action);
        }
    }
    // Memory manager
    _initMemoryManager() {
        this._actions = []; // 'nActiveActions' followed by inactive ones
        this._nActiveActions = 0;
        this._actionsByClip = {};
        // inside:
        // {
        // 	knownActions: Array< AnimationAction > - used as prototypes
        // 	actionByRoot: AnimationAction - lookup
        // }
        this._bindings = []; // 'nActiveBindings' followed by inactive ones
        this._nActiveBindings = 0;
        this._bindingsByRootAndName = {}; // inside: Map< name, PropertyMixer >
        this._controlInterpolants = []; // same game as above
        this._nActiveControlInterpolants = 0;
        const scope = this;
        this.stats = {
            actions: {
                get total () {
                    return scope._actions.length;
                },
                get inUse () {
                    return scope._nActiveActions;
                }
            },
            bindings: {
                get total () {
                    return scope._bindings.length;
                },
                get inUse () {
                    return scope._nActiveBindings;
                }
            },
            controlInterpolants: {
                get total () {
                    return scope._controlInterpolants.length;
                },
                get inUse () {
                    return scope._nActiveControlInterpolants;
                }
            }
        };
    }
    // Memory management for AnimationAction objects
    _isActiveAction(action) {
        const index = action._cacheIndex;
        return index !== null && index < this._nActiveActions;
    }
    _addInactiveAction(action, clipUuid, rootUuid) {
        const actions = this._actions, actionsByClip = this._actionsByClip;
        let actionsForClip = actionsByClip[clipUuid];
        if (actionsForClip === undefined) {
            actionsForClip = {
                knownActions: [
                    action
                ],
                actionByRoot: {}
            };
            action._byClipCacheIndex = 0;
            actionsByClip[clipUuid] = actionsForClip;
        } else {
            const knownActions = actionsForClip.knownActions;
            action._byClipCacheIndex = knownActions.length;
            knownActions.push(action);
        }
        action._cacheIndex = actions.length;
        actions.push(action);
        actionsForClip.actionByRoot[rootUuid] = action;
    }
    _removeInactiveAction(action) {
        const actions = this._actions, lastInactiveAction = actions[actions.length - 1], cacheIndex = action._cacheIndex;
        lastInactiveAction._cacheIndex = cacheIndex;
        actions[cacheIndex] = lastInactiveAction;
        actions.pop();
        action._cacheIndex = null;
        const clipUuid = action._clip.uuid, actionsByClip = this._actionsByClip, actionsForClip = actionsByClip[clipUuid], knownActionsForClip = actionsForClip.knownActions, lastKnownAction = knownActionsForClip[knownActionsForClip.length - 1], byClipCacheIndex = action._byClipCacheIndex;
        lastKnownAction._byClipCacheIndex = byClipCacheIndex;
        knownActionsForClip[byClipCacheIndex] = lastKnownAction;
        knownActionsForClip.pop();
        action._byClipCacheIndex = null;
        const actionByRoot = actionsForClip.actionByRoot, rootUuid = (action._localRoot || this._root).uuid;
        delete actionByRoot[rootUuid];
        if (knownActionsForClip.length === 0) delete actionsByClip[clipUuid];
        this._removeInactiveBindingsForAction(action);
    }
    _removeInactiveBindingsForAction(action) {
        const bindings = action._propertyBindings;
        for(let i = 0, n = bindings.length; i !== n; ++i){
            const binding = bindings[i];
            if (--binding.referenceCount === 0) this._removeInactiveBinding(binding);
        }
    }
    _lendAction(action) {
        // [ active actions |  inactive actions  ]
        // [  active actions >| inactive actions ]
        //                 s        a
        //                  <-swap->
        //                 a        s
        const actions = this._actions, prevIndex = action._cacheIndex, lastActiveIndex = this._nActiveActions++, firstInactiveAction = actions[lastActiveIndex];
        action._cacheIndex = lastActiveIndex;
        actions[lastActiveIndex] = action;
        firstInactiveAction._cacheIndex = prevIndex;
        actions[prevIndex] = firstInactiveAction;
    }
    _takeBackAction(action) {
        // [  active actions  | inactive actions ]
        // [ active actions |< inactive actions  ]
        //        a        s
        //         <-swap->
        //        s        a
        const actions = this._actions, prevIndex = action._cacheIndex, firstInactiveIndex = --this._nActiveActions, lastActiveAction = actions[firstInactiveIndex];
        action._cacheIndex = firstInactiveIndex;
        actions[firstInactiveIndex] = action;
        lastActiveAction._cacheIndex = prevIndex;
        actions[prevIndex] = lastActiveAction;
    }
    // Memory management for PropertyMixer objects
    _addInactiveBinding(binding, rootUuid, trackName) {
        const bindingsByRoot = this._bindingsByRootAndName, bindings = this._bindings;
        let bindingByName = bindingsByRoot[rootUuid];
        if (bindingByName === undefined) {
            bindingByName = {};
            bindingsByRoot[rootUuid] = bindingByName;
        }
        bindingByName[trackName] = binding;
        binding._cacheIndex = bindings.length;
        bindings.push(binding);
    }
    _removeInactiveBinding(binding) {
        const bindings = this._bindings, propBinding = binding.binding, rootUuid = propBinding.rootNode.uuid, trackName = propBinding.path, bindingsByRoot = this._bindingsByRootAndName, bindingByName = bindingsByRoot[rootUuid], lastInactiveBinding = bindings[bindings.length - 1], cacheIndex = binding._cacheIndex;
        lastInactiveBinding._cacheIndex = cacheIndex;
        bindings[cacheIndex] = lastInactiveBinding;
        bindings.pop();
        delete bindingByName[trackName];
        if (Object.keys(bindingByName).length === 0) delete bindingsByRoot[rootUuid];
    }
    _lendBinding(binding) {
        const bindings = this._bindings, prevIndex = binding._cacheIndex, lastActiveIndex = this._nActiveBindings++, firstInactiveBinding = bindings[lastActiveIndex];
        binding._cacheIndex = lastActiveIndex;
        bindings[lastActiveIndex] = binding;
        firstInactiveBinding._cacheIndex = prevIndex;
        bindings[prevIndex] = firstInactiveBinding;
    }
    _takeBackBinding(binding) {
        const bindings = this._bindings, prevIndex = binding._cacheIndex, firstInactiveIndex = --this._nActiveBindings, lastActiveBinding = bindings[firstInactiveIndex];
        binding._cacheIndex = firstInactiveIndex;
        bindings[firstInactiveIndex] = binding;
        lastActiveBinding._cacheIndex = prevIndex;
        bindings[prevIndex] = lastActiveBinding;
    }
    // Memory management of Interpolants for weight and time scale
    _lendControlInterpolant() {
        const interpolants = this._controlInterpolants, lastActiveIndex = this._nActiveControlInterpolants++;
        let interpolant = interpolants[lastActiveIndex];
        if (interpolant === undefined) {
            interpolant = new $9014d97cd777be10$export$a8e6009059f51e1a(new Float32Array(2), new Float32Array(2), 1, $9014d97cd777be10$var$_controlInterpolantsResultBuffer);
            interpolant.__cacheIndex = lastActiveIndex;
            interpolants[lastActiveIndex] = interpolant;
        }
        return interpolant;
    }
    _takeBackControlInterpolant(interpolant) {
        const interpolants = this._controlInterpolants, prevIndex = interpolant.__cacheIndex, firstInactiveIndex = --this._nActiveControlInterpolants, lastActiveInterpolant = interpolants[firstInactiveIndex];
        interpolant.__cacheIndex = firstInactiveIndex;
        interpolants[firstInactiveIndex] = interpolant;
        lastActiveInterpolant.__cacheIndex = prevIndex;
        interpolants[prevIndex] = lastActiveInterpolant;
    }
    // return an action for a clip optionally using a custom root target
    // object (this method allocates a lot of dynamic memory in case a
    // previously unknown clip/root combination is specified)
    clipAction(clip, optionalRoot, blendMode) {
        const root = optionalRoot || this._root, rootUuid = root.uuid;
        let clipObject = typeof clip === "string" ? $9014d97cd777be10$export$d942c706bf23829c.findByName(root, clip) : clip;
        const clipUuid = clipObject !== null ? clipObject.uuid : clip;
        const actionsForClip = this._actionsByClip[clipUuid];
        let prototypeAction = null;
        if (blendMode === undefined) {
            if (clipObject !== null) blendMode = clipObject.blendMode;
            else blendMode = $9014d97cd777be10$export$bcfbbdcf8de7f8cd;
        }
        if (actionsForClip !== undefined) {
            const existingAction = actionsForClip.actionByRoot[rootUuid];
            if (existingAction !== undefined && existingAction.blendMode === blendMode) return existingAction;
            // we know the clip, so we don't have to parse all
            // the bindings again but can just copy
            prototypeAction = actionsForClip.knownActions[0];
            // also, take the clip from the prototype action
            if (clipObject === null) clipObject = prototypeAction._clip;
        }
        // clip must be known when specified via string
        if (clipObject === null) return null;
        // allocate all resources required to run it
        const newAction = new $9014d97cd777be10$export$6946940a69e799e(this, clipObject, optionalRoot, blendMode);
        this._bindAction(newAction, prototypeAction);
        // and make the action known to the memory manager
        this._addInactiveAction(newAction, clipUuid, rootUuid);
        return newAction;
    }
    // get an existing action
    existingAction(clip, optionalRoot) {
        const root = optionalRoot || this._root, rootUuid = root.uuid, clipObject = typeof clip === "string" ? $9014d97cd777be10$export$d942c706bf23829c.findByName(root, clip) : clip, clipUuid = clipObject ? clipObject.uuid : clip, actionsForClip = this._actionsByClip[clipUuid];
        if (actionsForClip !== undefined) return actionsForClip.actionByRoot[rootUuid] || null;
        return null;
    }
    // deactivates all previously scheduled actions
    stopAllAction() {
        const actions = this._actions, nActions = this._nActiveActions;
        for(let i = nActions - 1; i >= 0; --i)actions[i].stop();
        return this;
    }
    // advance the time and update apply the animation
    update(deltaTime) {
        deltaTime *= this.timeScale;
        const actions = this._actions, nActions = this._nActiveActions, time = this.time += deltaTime, timeDirection = Math.sign(deltaTime), accuIndex = this._accuIndex ^= 1;
        // run active actions
        for(let i = 0; i !== nActions; ++i){
            const action = actions[i];
            action._update(time, deltaTime, timeDirection, accuIndex);
        }
        // update scene graph
        const bindings = this._bindings, nBindings = this._nActiveBindings;
        for(let i = 0; i !== nBindings; ++i)bindings[i].apply(accuIndex);
        return this;
    }
    // Allows you to seek to a specific time in an animation.
    setTime(timeInSeconds) {
        this.time = 0; // Zero out time attribute for AnimationMixer object;
        for(let i = 0; i < this._actions.length; i++)this._actions[i].time = 0; // Zero out time attribute for all associated AnimationAction objects.
        return this.update(timeInSeconds); // Update used to set exact time. Returns "this" AnimationMixer object.
    }
    // return this mixer's root target object
    getRoot() {
        return this._root;
    }
    // free all resources specific to a particular clip
    uncacheClip(clip) {
        const actions = this._actions, clipUuid = clip.uuid, actionsByClip = this._actionsByClip, actionsForClip = actionsByClip[clipUuid];
        if (actionsForClip !== undefined) {
            // note: just calling _removeInactiveAction would mess up the
            // iteration state and also require updating the state we can
            // just throw away
            const actionsToRemove = actionsForClip.knownActions;
            for(let i = 0, n = actionsToRemove.length; i !== n; ++i){
                const action = actionsToRemove[i];
                this._deactivateAction(action);
                const cacheIndex = action._cacheIndex, lastInactiveAction = actions[actions.length - 1];
                action._cacheIndex = null;
                action._byClipCacheIndex = null;
                lastInactiveAction._cacheIndex = cacheIndex;
                actions[cacheIndex] = lastInactiveAction;
                actions.pop();
                this._removeInactiveBindingsForAction(action);
            }
            delete actionsByClip[clipUuid];
        }
    }
    // free all resources specific to a particular root target object
    uncacheRoot(root) {
        const rootUuid = root.uuid, actionsByClip = this._actionsByClip;
        for(const clipUuid in actionsByClip){
            const actionByRoot = actionsByClip[clipUuid].actionByRoot, action = actionByRoot[rootUuid];
            if (action !== undefined) {
                this._deactivateAction(action);
                this._removeInactiveAction(action);
            }
        }
        const bindingsByRoot = this._bindingsByRootAndName, bindingByName = bindingsByRoot[rootUuid];
        if (bindingByName !== undefined) for(const trackName in bindingByName){
            const binding = bindingByName[trackName];
            binding.restoreOriginalState();
            this._removeInactiveBinding(binding);
        }
    }
    // remove a targeted clip from the cache
    uncacheAction(clip, optionalRoot) {
        const action = this.existingAction(clip, optionalRoot);
        if (action !== null) {
            this._deactivateAction(action);
            this._removeInactiveAction(action);
        }
    }
    constructor(root){
        super();
        this._root = root;
        this._initMemoryManager();
        this._accuIndex = 0;
        this.time = 0;
        this.timeScale = 1.0;
    }
}
class $9014d97cd777be10$export$2947cebfe91c02f8 {
    clone() {
        return new $9014d97cd777be10$export$2947cebfe91c02f8(this.value.clone === undefined ? this.value : this.value.clone());
    }
    constructor(value){
        this.value = value;
    }
}
let $9014d97cd777be10$var$id = 0;
class $9014d97cd777be10$export$c412d5ffe1f79209 extends $9014d97cd777be10$export$ec8b666c5fe2c75a {
    add(uniform) {
        this.uniforms.push(uniform);
        return this;
    }
    remove(uniform) {
        const index = this.uniforms.indexOf(uniform);
        if (index !== -1) this.uniforms.splice(index, 1);
        return this;
    }
    setName(name) {
        this.name = name;
        return this;
    }
    setUsage(value) {
        this.usage = value;
        return this;
    }
    dispose() {
        this.dispatchEvent({
            type: "dispose"
        });
        return this;
    }
    copy(source) {
        this.name = source.name;
        this.usage = source.usage;
        const uniformsSource = source.uniforms;
        this.uniforms.length = 0;
        for(let i = 0, l = uniformsSource.length; i < l; i++)this.uniforms.push(uniformsSource[i].clone());
        return this;
    }
    clone() {
        return new this.constructor().copy(this);
    }
    constructor(){
        super();
        this.isUniformsGroup = true;
        Object.defineProperty(this, "id", {
            value: $9014d97cd777be10$var$id++
        });
        this.name = "";
        this.usage = $9014d97cd777be10$export$763e8360f4d7f77d;
        this.uniforms = [];
    }
}
class $9014d97cd777be10$export$25ec0e1af1389358 extends $9014d97cd777be10$export$3d5cd879f108f53f {
    copy(source) {
        super.copy(source);
        this.meshPerAttribute = source.meshPerAttribute;
        return this;
    }
    clone(data) {
        const ib = super.clone(data);
        ib.meshPerAttribute = this.meshPerAttribute;
        return ib;
    }
    toJSON(data) {
        const json = super.toJSON(data);
        json.isInstancedInterleavedBuffer = true;
        json.meshPerAttribute = this.meshPerAttribute;
        return json;
    }
    constructor(array, stride, meshPerAttribute = 1){
        super(array, stride);
        this.isInstancedInterleavedBuffer = true;
        this.meshPerAttribute = meshPerAttribute;
    }
}
class $9014d97cd777be10$export$6b7339ae8dbddf73 {
    set needsUpdate(value) {
        if (value === true) this.version++;
    }
    setBuffer(buffer) {
        this.buffer = buffer;
        return this;
    }
    setType(type, elementSize) {
        this.type = type;
        this.elementSize = elementSize;
        return this;
    }
    setItemSize(itemSize) {
        this.itemSize = itemSize;
        return this;
    }
    setCount(count) {
        this.count = count;
        return this;
    }
    constructor(buffer, type, itemSize, elementSize, count){
        this.isGLBufferAttribute = true;
        this.name = "";
        this.buffer = buffer;
        this.type = type;
        this.itemSize = itemSize;
        this.elementSize = elementSize;
        this.count = count;
        this.version = 0;
    }
}
class $9014d97cd777be10$export$8b7aaceff00bd2f {
    set(origin, direction) {
        // direction is assumed to be normalized (for accurate distance calculations)
        this.ray.set(origin, direction);
    }
    setFromCamera(coords, camera) {
        if (camera.isPerspectiveCamera) {
            this.ray.origin.setFromMatrixPosition(camera.matrixWorld);
            this.ray.direction.set(coords.x, coords.y, 0.5).unproject(camera).sub(this.ray.origin).normalize();
            this.camera = camera;
        } else if (camera.isOrthographicCamera) {
            this.ray.origin.set(coords.x, coords.y, (camera.near + camera.far) / (camera.near - camera.far)).unproject(camera); // set origin in plane of camera
            this.ray.direction.set(0, 0, -1).transformDirection(camera.matrixWorld);
            this.camera = camera;
        } else console.error("THREE.Raycaster: Unsupported camera type: " + camera.type);
    }
    intersectObject(object, recursive = true, intersects = []) {
        $9014d97cd777be10$var$intersectObject(object, this, intersects, recursive);
        intersects.sort($9014d97cd777be10$var$ascSort);
        return intersects;
    }
    intersectObjects(objects, recursive = true, intersects = []) {
        for(let i = 0, l = objects.length; i < l; i++)$9014d97cd777be10$var$intersectObject(objects[i], this, intersects, recursive);
        intersects.sort($9014d97cd777be10$var$ascSort);
        return intersects;
    }
    constructor(origin, direction, near = 0, far = Infinity){
        this.ray = new $9014d97cd777be10$export$a186db52eed6d40e(origin, direction);
        // direction is assumed to be normalized (for accurate distance calculations)
        this.near = near;
        this.far = far;
        this.camera = null;
        this.layers = new $9014d97cd777be10$export$89312ce47c0ca777();
        this.params = {
            Mesh: {},
            Line: {
                threshold: 1
            },
            LOD: {},
            Points: {
                threshold: 1
            },
            Sprite: {}
        };
    }
}
function $9014d97cd777be10$var$ascSort(a, b) {
    return a.distance - b.distance;
}
function $9014d97cd777be10$var$intersectObject(object, raycaster, intersects, recursive) {
    if (object.layers.test(raycaster.layers)) object.raycast(raycaster, intersects);
    if (recursive === true) {
        const children = object.children;
        for(let i = 0, l = children.length; i < l; i++)$9014d97cd777be10$var$intersectObject(children[i], raycaster, intersects, true);
    }
}
/**
 * Ref: https://en.wikipedia.org/wiki/Spherical_coordinate_system
 *
 * The polar angle (phi) is measured from the positive y-axis. The positive y-axis is up.
 * The azimuthal angle (theta) is measured from the positive z-axis.
 */ class $9014d97cd777be10$export$d712cd887b4a00f7 {
    set(radius, phi, theta) {
        this.radius = radius;
        this.phi = phi;
        this.theta = theta;
        return this;
    }
    copy(other) {
        this.radius = other.radius;
        this.phi = other.phi;
        this.theta = other.theta;
        return this;
    }
    // restrict phi to be between EPS and PI-EPS
    makeSafe() {
        const EPS = 0.000001;
        this.phi = Math.max(EPS, Math.min(Math.PI - EPS, this.phi));
        return this;
    }
    setFromVector3(v) {
        return this.setFromCartesianCoords(v.x, v.y, v.z);
    }
    setFromCartesianCoords(x, y, z) {
        this.radius = Math.sqrt(x * x + y * y + z * z);
        if (this.radius === 0) {
            this.theta = 0;
            this.phi = 0;
        } else {
            this.theta = Math.atan2(x, z);
            this.phi = Math.acos($9014d97cd777be10$var$clamp(y / this.radius, -1, 1));
        }
        return this;
    }
    clone() {
        return new this.constructor().copy(this);
    }
    constructor(radius = 1, phi = 0, theta = 0){
        this.radius = radius;
        this.phi = phi; // polar angle
        this.theta = theta; // azimuthal angle
        return this;
    }
}
/**
 * Ref: https://en.wikipedia.org/wiki/Cylindrical_coordinate_system
 */ class $9014d97cd777be10$export$287165bb2177f4fd {
    set(radius, theta, y) {
        this.radius = radius;
        this.theta = theta;
        this.y = y;
        return this;
    }
    copy(other) {
        this.radius = other.radius;
        this.theta = other.theta;
        this.y = other.y;
        return this;
    }
    setFromVector3(v) {
        return this.setFromCartesianCoords(v.x, v.y, v.z);
    }
    setFromCartesianCoords(x, y, z) {
        this.radius = Math.sqrt(x * x + z * z);
        this.theta = Math.atan2(x, z);
        this.y = y;
        return this;
    }
    clone() {
        return new this.constructor().copy(this);
    }
    constructor(radius = 1, theta = 0, y = 0){
        this.radius = radius; // distance from the origin to a point in the x-z plane
        this.theta = theta; // counterclockwise angle in the x-z plane measured in radians from the positive z-axis
        this.y = y; // height above the x-z plane
        return this;
    }
}
const $9014d97cd777be10$var$_vector$4 = /*@__PURE__*/ new $9014d97cd777be10$export$c977b3e384af9ae1();
class $9014d97cd777be10$export$60f553fa130f08b0 {
    set(min, max) {
        this.min.copy(min);
        this.max.copy(max);
        return this;
    }
    setFromPoints(points) {
        this.makeEmpty();
        for(let i = 0, il = points.length; i < il; i++)this.expandByPoint(points[i]);
        return this;
    }
    setFromCenterAndSize(center, size) {
        const halfSize = $9014d97cd777be10$var$_vector$4.copy(size).multiplyScalar(0.5);
        this.min.copy(center).sub(halfSize);
        this.max.copy(center).add(halfSize);
        return this;
    }
    clone() {
        return new this.constructor().copy(this);
    }
    copy(box) {
        this.min.copy(box.min);
        this.max.copy(box.max);
        return this;
    }
    makeEmpty() {
        this.min.x = this.min.y = Infinity;
        this.max.x = this.max.y = -Infinity;
        return this;
    }
    isEmpty() {
        // this is a more robust check for empty than ( volume <= 0 ) because volume can get positive with two negative axes
        return this.max.x < this.min.x || this.max.y < this.min.y;
    }
    getCenter(target) {
        return this.isEmpty() ? target.set(0, 0) : target.addVectors(this.min, this.max).multiplyScalar(0.5);
    }
    getSize(target) {
        return this.isEmpty() ? target.set(0, 0) : target.subVectors(this.max, this.min);
    }
    expandByPoint(point) {
        this.min.min(point);
        this.max.max(point);
        return this;
    }
    expandByVector(vector) {
        this.min.sub(vector);
        this.max.add(vector);
        return this;
    }
    expandByScalar(scalar) {
        this.min.addScalar(-scalar);
        this.max.addScalar(scalar);
        return this;
    }
    containsPoint(point) {
        return point.x < this.min.x || point.x > this.max.x || point.y < this.min.y || point.y > this.max.y ? false : true;
    }
    containsBox(box) {
        return this.min.x <= box.min.x && box.max.x <= this.max.x && this.min.y <= box.min.y && box.max.y <= this.max.y;
    }
    getParameter(point, target) {
        // This can potentially have a divide by zero if the box
        // has a size dimension of 0.
        return target.set((point.x - this.min.x) / (this.max.x - this.min.x), (point.y - this.min.y) / (this.max.y - this.min.y));
    }
    intersectsBox(box) {
        // using 4 splitting planes to rule out intersections
        return box.max.x < this.min.x || box.min.x > this.max.x || box.max.y < this.min.y || box.min.y > this.max.y ? false : true;
    }
    clampPoint(point, target) {
        return target.copy(point).clamp(this.min, this.max);
    }
    distanceToPoint(point) {
        return this.clampPoint(point, $9014d97cd777be10$var$_vector$4).distanceTo(point);
    }
    intersect(box) {
        this.min.max(box.min);
        this.max.min(box.max);
        if (this.isEmpty()) this.makeEmpty();
        return this;
    }
    union(box) {
        this.min.min(box.min);
        this.max.max(box.max);
        return this;
    }
    translate(offset) {
        this.min.add(offset);
        this.max.add(offset);
        return this;
    }
    equals(box) {
        return box.min.equals(this.min) && box.max.equals(this.max);
    }
    constructor(min = new $9014d97cd777be10$export$c977b3e384af9ae1(Infinity, Infinity), max = new $9014d97cd777be10$export$c977b3e384af9ae1(-Infinity, -Infinity)){
        this.isBox2 = true;
        this.min = min;
        this.max = max;
    }
}
const $9014d97cd777be10$var$_startP = /*@__PURE__*/ new $9014d97cd777be10$export$64b5c384219d3699();
const $9014d97cd777be10$var$_startEnd = /*@__PURE__*/ new $9014d97cd777be10$export$64b5c384219d3699();
class $9014d97cd777be10$export$e0ba6359f1954fd3 {
    set(start, end) {
        this.start.copy(start);
        this.end.copy(end);
        return this;
    }
    copy(line) {
        this.start.copy(line.start);
        this.end.copy(line.end);
        return this;
    }
    getCenter(target) {
        return target.addVectors(this.start, this.end).multiplyScalar(0.5);
    }
    delta(target) {
        return target.subVectors(this.end, this.start);
    }
    distanceSq() {
        return this.start.distanceToSquared(this.end);
    }
    distance() {
        return this.start.distanceTo(this.end);
    }
    at(t, target) {
        return this.delta(target).multiplyScalar(t).add(this.start);
    }
    closestPointToPointParameter(point, clampToLine) {
        $9014d97cd777be10$var$_startP.subVectors(point, this.start);
        $9014d97cd777be10$var$_startEnd.subVectors(this.end, this.start);
        const startEnd2 = $9014d97cd777be10$var$_startEnd.dot($9014d97cd777be10$var$_startEnd);
        const startEnd_startP = $9014d97cd777be10$var$_startEnd.dot($9014d97cd777be10$var$_startP);
        let t = startEnd_startP / startEnd2;
        if (clampToLine) t = $9014d97cd777be10$var$clamp(t, 0, 1);
        return t;
    }
    closestPointToPoint(point, clampToLine, target) {
        const t = this.closestPointToPointParameter(point, clampToLine);
        return this.delta(target).multiplyScalar(t).add(this.start);
    }
    applyMatrix4(matrix) {
        this.start.applyMatrix4(matrix);
        this.end.applyMatrix4(matrix);
        return this;
    }
    equals(line) {
        return line.start.equals(this.start) && line.end.equals(this.end);
    }
    clone() {
        return new this.constructor().copy(this);
    }
    constructor(start = new $9014d97cd777be10$export$64b5c384219d3699(), end = new $9014d97cd777be10$export$64b5c384219d3699()){
        this.start = start;
        this.end = end;
    }
}
const $9014d97cd777be10$var$_vector$3 = /*@__PURE__*/ new $9014d97cd777be10$export$64b5c384219d3699();
class $9014d97cd777be10$export$4b14638ffdd81e68 extends $9014d97cd777be10$export$e4dd07dff30cc924 {
    dispose() {
        this.cone.geometry.dispose();
        this.cone.material.dispose();
    }
    update() {
        this.light.updateWorldMatrix(true, false);
        this.light.target.updateWorldMatrix(true, false);
        const coneLength = this.light.distance ? this.light.distance : 1000;
        const coneWidth = coneLength * Math.tan(this.light.angle);
        this.cone.scale.set(coneWidth, coneWidth, coneLength);
        $9014d97cd777be10$var$_vector$3.setFromMatrixPosition(this.light.target.matrixWorld);
        this.cone.lookAt($9014d97cd777be10$var$_vector$3);
        if (this.color !== undefined) this.cone.material.color.set(this.color);
        else this.cone.material.color.copy(this.light.color);
    }
    constructor(light, color){
        super();
        this.light = light;
        this.matrix = light.matrixWorld;
        this.matrixAutoUpdate = false;
        this.color = color;
        this.type = "SpotLightHelper";
        const geometry = new $9014d97cd777be10$export$b7be63a67df8959();
        const positions = [
            0,
            0,
            0,
            0,
            0,
            1,
            0,
            0,
            0,
            1,
            0,
            1,
            0,
            0,
            0,
            -1,
            0,
            1,
            0,
            0,
            0,
            0,
            1,
            1,
            0,
            0,
            0,
            0,
            -1,
            1
        ];
        for(let i = 0, j = 1, l = 32; i < l; i++, j++){
            const p1 = i / l * Math.PI * 2;
            const p2 = j / l * Math.PI * 2;
            positions.push(Math.cos(p1), Math.sin(p1), 1, Math.cos(p2), Math.sin(p2), 1);
        }
        geometry.setAttribute("position", new $9014d97cd777be10$export$cbe7a62641830ebd(positions, 3));
        const material = new $9014d97cd777be10$export$fbaaa33907730a0c({
            fog: false,
            toneMapped: false
        });
        this.cone = new $9014d97cd777be10$export$ff1ed10fedfdd604(geometry, material);
        this.add(this.cone);
        this.update();
    }
}
const $9014d97cd777be10$var$_vector$2 = /*@__PURE__*/ new $9014d97cd777be10$export$64b5c384219d3699();
const $9014d97cd777be10$var$_boneMatrix = /*@__PURE__*/ new $9014d97cd777be10$export$2ae72fc923e5eb5();
const $9014d97cd777be10$var$_matrixWorldInv = /*@__PURE__*/ new $9014d97cd777be10$export$2ae72fc923e5eb5();
class $9014d97cd777be10$export$5277df3c9e732259 extends $9014d97cd777be10$export$ff1ed10fedfdd604 {
    updateMatrixWorld(force) {
        const bones = this.bones;
        const geometry = this.geometry;
        const position = geometry.getAttribute("position");
        $9014d97cd777be10$var$_matrixWorldInv.copy(this.root.matrixWorld).invert();
        for(let i = 0, j = 0; i < bones.length; i++){
            const bone = bones[i];
            if (bone.parent && bone.parent.isBone) {
                $9014d97cd777be10$var$_boneMatrix.multiplyMatrices($9014d97cd777be10$var$_matrixWorldInv, bone.matrixWorld);
                $9014d97cd777be10$var$_vector$2.setFromMatrixPosition($9014d97cd777be10$var$_boneMatrix);
                position.setXYZ(j, $9014d97cd777be10$var$_vector$2.x, $9014d97cd777be10$var$_vector$2.y, $9014d97cd777be10$var$_vector$2.z);
                $9014d97cd777be10$var$_boneMatrix.multiplyMatrices($9014d97cd777be10$var$_matrixWorldInv, bone.parent.matrixWorld);
                $9014d97cd777be10$var$_vector$2.setFromMatrixPosition($9014d97cd777be10$var$_boneMatrix);
                position.setXYZ(j + 1, $9014d97cd777be10$var$_vector$2.x, $9014d97cd777be10$var$_vector$2.y, $9014d97cd777be10$var$_vector$2.z);
                j += 2;
            }
        }
        geometry.getAttribute("position").needsUpdate = true;
        super.updateMatrixWorld(force);
    }
    dispose() {
        this.geometry.dispose();
        this.material.dispose();
    }
    constructor(object){
        const bones = $9014d97cd777be10$var$getBoneList(object);
        const geometry = new $9014d97cd777be10$export$b7be63a67df8959();
        const vertices = [];
        const colors = [];
        const color1 = new $9014d97cd777be10$export$892596cec99bc70e(0, 0, 1);
        const color2 = new $9014d97cd777be10$export$892596cec99bc70e(0, 1, 0);
        for(let i = 0; i < bones.length; i++){
            const bone = bones[i];
            if (bone.parent && bone.parent.isBone) {
                vertices.push(0, 0, 0);
                vertices.push(0, 0, 0);
                colors.push(color1.r, color1.g, color1.b);
                colors.push(color2.r, color2.g, color2.b);
            }
        }
        geometry.setAttribute("position", new $9014d97cd777be10$export$cbe7a62641830ebd(vertices, 3));
        geometry.setAttribute("color", new $9014d97cd777be10$export$cbe7a62641830ebd(colors, 3));
        const material = new $9014d97cd777be10$export$fbaaa33907730a0c({
            vertexColors: true,
            depthTest: false,
            depthWrite: false,
            toneMapped: false,
            transparent: true
        });
        super(geometry, material);
        this.isSkeletonHelper = true;
        this.type = "SkeletonHelper";
        this.root = object;
        this.bones = bones;
        this.matrix = object.matrixWorld;
        this.matrixAutoUpdate = false;
    }
}
function $9014d97cd777be10$var$getBoneList(object) {
    const boneList = [];
    if (object.isBone === true) boneList.push(object);
    for(let i = 0; i < object.children.length; i++)boneList.push.apply(boneList, $9014d97cd777be10$var$getBoneList(object.children[i]));
    return boneList;
}
class $9014d97cd777be10$export$9a9291685b9e4023 extends $9014d97cd777be10$export$e176487c05830cc5 {
    dispose() {
        this.geometry.dispose();
        this.material.dispose();
    }
    update() {
        this.light.updateWorldMatrix(true, false);
        if (this.color !== undefined) this.material.color.set(this.color);
        else this.material.color.copy(this.light.color);
    /*
		const d = this.light.distance;

		if ( d === 0.0 ) {

			this.lightDistance.visible = false;

		} else {

			this.lightDistance.visible = true;
			this.lightDistance.scale.set( d, d, d );

		}
		*/ }
    constructor(light, sphereSize, color){
        const geometry = new $9014d97cd777be10$export$1b417fc3b307a251(sphereSize, 4, 2);
        const material = new $9014d97cd777be10$export$55cbcc9b622fe1f5({
            wireframe: true,
            fog: false,
            toneMapped: false
        });
        super(geometry, material);
        this.light = light;
        this.color = color;
        this.type = "PointLightHelper";
        this.matrix = this.light.matrixWorld;
        this.matrixAutoUpdate = false;
        this.update();
    /*
	// TODO: delete this comment?
	const distanceGeometry = new THREE.IcosahedronGeometry( 1, 2 );
	const distanceMaterial = new THREE.MeshBasicMaterial( { color: hexColor, fog: false, wireframe: true, opacity: 0.1, transparent: true } );

	this.lightSphere = new THREE.Mesh( bulbGeometry, bulbMaterial );
	this.lightDistance = new THREE.Mesh( distanceGeometry, distanceMaterial );

	const d = light.distance;

	if ( d === 0.0 ) {

		this.lightDistance.visible = false;

	} else {

		this.lightDistance.scale.set( d, d, d );

	}

	this.add( this.lightDistance );
	*/ }
}
const $9014d97cd777be10$var$_vector$1 = /*@__PURE__*/ new $9014d97cd777be10$export$64b5c384219d3699();
const $9014d97cd777be10$var$_color1 = /*@__PURE__*/ new $9014d97cd777be10$export$892596cec99bc70e();
const $9014d97cd777be10$var$_color2 = /*@__PURE__*/ new $9014d97cd777be10$export$892596cec99bc70e();
class $9014d97cd777be10$export$8dca15f13f4f8172 extends $9014d97cd777be10$export$e4dd07dff30cc924 {
    dispose() {
        this.children[0].geometry.dispose();
        this.children[0].material.dispose();
    }
    update() {
        const mesh = this.children[0];
        if (this.color !== undefined) this.material.color.set(this.color);
        else {
            const colors = mesh.geometry.getAttribute("color");
            $9014d97cd777be10$var$_color1.copy(this.light.color);
            $9014d97cd777be10$var$_color2.copy(this.light.groundColor);
            for(let i = 0, l = colors.count; i < l; i++){
                const color = i < l / 2 ? $9014d97cd777be10$var$_color1 : $9014d97cd777be10$var$_color2;
                colors.setXYZ(i, color.r, color.g, color.b);
            }
            colors.needsUpdate = true;
        }
        this.light.updateWorldMatrix(true, false);
        mesh.lookAt($9014d97cd777be10$var$_vector$1.setFromMatrixPosition(this.light.matrixWorld).negate());
    }
    constructor(light, size, color){
        super();
        this.light = light;
        this.matrix = light.matrixWorld;
        this.matrixAutoUpdate = false;
        this.color = color;
        this.type = "HemisphereLightHelper";
        const geometry = new $9014d97cd777be10$export$1954e2b809fe361e(size);
        geometry.rotateY(Math.PI * 0.5);
        this.material = new $9014d97cd777be10$export$55cbcc9b622fe1f5({
            wireframe: true,
            fog: false,
            toneMapped: false
        });
        if (this.color === undefined) this.material.vertexColors = true;
        const position = geometry.getAttribute("position");
        const colors = new Float32Array(position.count * 3);
        geometry.setAttribute("color", new $9014d97cd777be10$export$8dea267bd6bde117(colors, 3));
        this.add(new $9014d97cd777be10$export$e176487c05830cc5(geometry, this.material));
        this.update();
    }
}
class $9014d97cd777be10$export$3875d39926561055 extends $9014d97cd777be10$export$ff1ed10fedfdd604 {
    dispose() {
        this.geometry.dispose();
        this.material.dispose();
    }
    constructor(size = 10, divisions = 10, color1 = 0x444444, color2 = 0x888888){
        color1 = new $9014d97cd777be10$export$892596cec99bc70e(color1);
        color2 = new $9014d97cd777be10$export$892596cec99bc70e(color2);
        const center = divisions / 2;
        const step = size / divisions;
        const halfSize = size / 2;
        const vertices = [], colors = [];
        for(let i = 0, j = 0, k = -halfSize; i <= divisions; i++, k += step){
            vertices.push(-halfSize, 0, k, halfSize, 0, k);
            vertices.push(k, 0, -halfSize, k, 0, halfSize);
            const color = i === center ? color1 : color2;
            color.toArray(colors, j);
            j += 3;
            color.toArray(colors, j);
            j += 3;
            color.toArray(colors, j);
            j += 3;
            color.toArray(colors, j);
            j += 3;
        }
        const geometry = new $9014d97cd777be10$export$b7be63a67df8959();
        geometry.setAttribute("position", new $9014d97cd777be10$export$cbe7a62641830ebd(vertices, 3));
        geometry.setAttribute("color", new $9014d97cd777be10$export$cbe7a62641830ebd(colors, 3));
        const material = new $9014d97cd777be10$export$fbaaa33907730a0c({
            vertexColors: true,
            toneMapped: false
        });
        super(geometry, material);
        this.type = "GridHelper";
    }
}
class $9014d97cd777be10$export$361430a10f533cd3 extends $9014d97cd777be10$export$ff1ed10fedfdd604 {
    dispose() {
        this.geometry.dispose();
        this.material.dispose();
    }
    constructor(radius = 10, sectors = 16, rings = 8, divisions = 64, color1 = 0x444444, color2 = 0x888888){
        color1 = new $9014d97cd777be10$export$892596cec99bc70e(color1);
        color2 = new $9014d97cd777be10$export$892596cec99bc70e(color2);
        const vertices = [];
        const colors = [];
        // create the sectors
        if (sectors > 1) for(let i = 0; i < sectors; i++){
            const v = i / sectors * (Math.PI * 2);
            const x = Math.sin(v) * radius;
            const z = Math.cos(v) * radius;
            vertices.push(0, 0, 0);
            vertices.push(x, 0, z);
            const color = i & 1 ? color1 : color2;
            colors.push(color.r, color.g, color.b);
            colors.push(color.r, color.g, color.b);
        }
        // create the rings
        for(let i = 0; i < rings; i++){
            const color = i & 1 ? color1 : color2;
            const r = radius - radius / rings * i;
            for(let j = 0; j < divisions; j++){
                // first vertex
                let v = j / divisions * (Math.PI * 2);
                let x = Math.sin(v) * r;
                let z = Math.cos(v) * r;
                vertices.push(x, 0, z);
                colors.push(color.r, color.g, color.b);
                // second vertex
                v = (j + 1) / divisions * (Math.PI * 2);
                x = Math.sin(v) * r;
                z = Math.cos(v) * r;
                vertices.push(x, 0, z);
                colors.push(color.r, color.g, color.b);
            }
        }
        const geometry = new $9014d97cd777be10$export$b7be63a67df8959();
        geometry.setAttribute("position", new $9014d97cd777be10$export$cbe7a62641830ebd(vertices, 3));
        geometry.setAttribute("color", new $9014d97cd777be10$export$cbe7a62641830ebd(colors, 3));
        const material = new $9014d97cd777be10$export$fbaaa33907730a0c({
            vertexColors: true,
            toneMapped: false
        });
        super(geometry, material);
        this.type = "PolarGridHelper";
    }
}
const $9014d97cd777be10$var$_v1 = /*@__PURE__*/ new $9014d97cd777be10$export$64b5c384219d3699();
const $9014d97cd777be10$var$_v2 = /*@__PURE__*/ new $9014d97cd777be10$export$64b5c384219d3699();
const $9014d97cd777be10$var$_v3 = /*@__PURE__*/ new $9014d97cd777be10$export$64b5c384219d3699();
class $9014d97cd777be10$export$f8e434dc14203e7d extends $9014d97cd777be10$export$e4dd07dff30cc924 {
    dispose() {
        this.lightPlane.geometry.dispose();
        this.lightPlane.material.dispose();
        this.targetLine.geometry.dispose();
        this.targetLine.material.dispose();
    }
    update() {
        this.light.updateWorldMatrix(true, false);
        this.light.target.updateWorldMatrix(true, false);
        $9014d97cd777be10$var$_v1.setFromMatrixPosition(this.light.matrixWorld);
        $9014d97cd777be10$var$_v2.setFromMatrixPosition(this.light.target.matrixWorld);
        $9014d97cd777be10$var$_v3.subVectors($9014d97cd777be10$var$_v2, $9014d97cd777be10$var$_v1);
        this.lightPlane.lookAt($9014d97cd777be10$var$_v2);
        if (this.color !== undefined) {
            this.lightPlane.material.color.set(this.color);
            this.targetLine.material.color.set(this.color);
        } else {
            this.lightPlane.material.color.copy(this.light.color);
            this.targetLine.material.color.copy(this.light.color);
        }
        this.targetLine.lookAt($9014d97cd777be10$var$_v2);
        this.targetLine.scale.z = $9014d97cd777be10$var$_v3.length();
    }
    constructor(light, size, color){
        super();
        this.light = light;
        this.matrix = light.matrixWorld;
        this.matrixAutoUpdate = false;
        this.color = color;
        this.type = "DirectionalLightHelper";
        if (size === undefined) size = 1;
        let geometry = new $9014d97cd777be10$export$b7be63a67df8959();
        geometry.setAttribute("position", new $9014d97cd777be10$export$cbe7a62641830ebd([
            -size,
            size,
            0,
            size,
            size,
            0,
            size,
            -size,
            0,
            -size,
            -size,
            0,
            -size,
            size,
            0
        ], 3));
        const material = new $9014d97cd777be10$export$fbaaa33907730a0c({
            fog: false,
            toneMapped: false
        });
        this.lightPlane = new $9014d97cd777be10$export$17d680238e50603e(geometry, material);
        this.add(this.lightPlane);
        geometry = new $9014d97cd777be10$export$b7be63a67df8959();
        geometry.setAttribute("position", new $9014d97cd777be10$export$cbe7a62641830ebd([
            0,
            0,
            0,
            0,
            0,
            1
        ], 3));
        this.targetLine = new $9014d97cd777be10$export$17d680238e50603e(geometry, material);
        this.add(this.targetLine);
        this.update();
    }
}
const $9014d97cd777be10$var$_vector = /*@__PURE__*/ new $9014d97cd777be10$export$64b5c384219d3699();
const $9014d97cd777be10$var$_camera = /*@__PURE__*/ new $9014d97cd777be10$export$79f141de891a5fed();
/**
 *	- shows frustum, line of sight and up of the camera
 *	- suitable for fast updates
 * 	- based on frustum visualization in lightgl.js shadowmap example
 *		https://github.com/evanw/lightgl.js/blob/master/tests/shadowmap.html
 */ class $9014d97cd777be10$export$ed8e93f853cd795 extends $9014d97cd777be10$export$ff1ed10fedfdd604 {
    setColors(frustum, cone, up, target, cross) {
        const geometry = this.geometry;
        const colorAttribute = geometry.getAttribute("color");
        // near
        colorAttribute.setXYZ(0, frustum.r, frustum.g, frustum.b);
        colorAttribute.setXYZ(1, frustum.r, frustum.g, frustum.b); // n1, n2
        colorAttribute.setXYZ(2, frustum.r, frustum.g, frustum.b);
        colorAttribute.setXYZ(3, frustum.r, frustum.g, frustum.b); // n2, n4
        colorAttribute.setXYZ(4, frustum.r, frustum.g, frustum.b);
        colorAttribute.setXYZ(5, frustum.r, frustum.g, frustum.b); // n4, n3
        colorAttribute.setXYZ(6, frustum.r, frustum.g, frustum.b);
        colorAttribute.setXYZ(7, frustum.r, frustum.g, frustum.b); // n3, n1
        // far
        colorAttribute.setXYZ(8, frustum.r, frustum.g, frustum.b);
        colorAttribute.setXYZ(9, frustum.r, frustum.g, frustum.b); // f1, f2
        colorAttribute.setXYZ(10, frustum.r, frustum.g, frustum.b);
        colorAttribute.setXYZ(11, frustum.r, frustum.g, frustum.b); // f2, f4
        colorAttribute.setXYZ(12, frustum.r, frustum.g, frustum.b);
        colorAttribute.setXYZ(13, frustum.r, frustum.g, frustum.b); // f4, f3
        colorAttribute.setXYZ(14, frustum.r, frustum.g, frustum.b);
        colorAttribute.setXYZ(15, frustum.r, frustum.g, frustum.b); // f3, f1
        // sides
        colorAttribute.setXYZ(16, frustum.r, frustum.g, frustum.b);
        colorAttribute.setXYZ(17, frustum.r, frustum.g, frustum.b); // n1, f1
        colorAttribute.setXYZ(18, frustum.r, frustum.g, frustum.b);
        colorAttribute.setXYZ(19, frustum.r, frustum.g, frustum.b); // n2, f2
        colorAttribute.setXYZ(20, frustum.r, frustum.g, frustum.b);
        colorAttribute.setXYZ(21, frustum.r, frustum.g, frustum.b); // n3, f3
        colorAttribute.setXYZ(22, frustum.r, frustum.g, frustum.b);
        colorAttribute.setXYZ(23, frustum.r, frustum.g, frustum.b); // n4, f4
        // cone
        colorAttribute.setXYZ(24, cone.r, cone.g, cone.b);
        colorAttribute.setXYZ(25, cone.r, cone.g, cone.b); // p, n1
        colorAttribute.setXYZ(26, cone.r, cone.g, cone.b);
        colorAttribute.setXYZ(27, cone.r, cone.g, cone.b); // p, n2
        colorAttribute.setXYZ(28, cone.r, cone.g, cone.b);
        colorAttribute.setXYZ(29, cone.r, cone.g, cone.b); // p, n3
        colorAttribute.setXYZ(30, cone.r, cone.g, cone.b);
        colorAttribute.setXYZ(31, cone.r, cone.g, cone.b); // p, n4
        // up
        colorAttribute.setXYZ(32, up.r, up.g, up.b);
        colorAttribute.setXYZ(33, up.r, up.g, up.b); // u1, u2
        colorAttribute.setXYZ(34, up.r, up.g, up.b);
        colorAttribute.setXYZ(35, up.r, up.g, up.b); // u2, u3
        colorAttribute.setXYZ(36, up.r, up.g, up.b);
        colorAttribute.setXYZ(37, up.r, up.g, up.b); // u3, u1
        // target
        colorAttribute.setXYZ(38, target.r, target.g, target.b);
        colorAttribute.setXYZ(39, target.r, target.g, target.b); // c, t
        colorAttribute.setXYZ(40, cross.r, cross.g, cross.b);
        colorAttribute.setXYZ(41, cross.r, cross.g, cross.b); // p, c
        // cross
        colorAttribute.setXYZ(42, cross.r, cross.g, cross.b);
        colorAttribute.setXYZ(43, cross.r, cross.g, cross.b); // cn1, cn2
        colorAttribute.setXYZ(44, cross.r, cross.g, cross.b);
        colorAttribute.setXYZ(45, cross.r, cross.g, cross.b); // cn3, cn4
        colorAttribute.setXYZ(46, cross.r, cross.g, cross.b);
        colorAttribute.setXYZ(47, cross.r, cross.g, cross.b); // cf1, cf2
        colorAttribute.setXYZ(48, cross.r, cross.g, cross.b);
        colorAttribute.setXYZ(49, cross.r, cross.g, cross.b); // cf3, cf4
        colorAttribute.needsUpdate = true;
    }
    update() {
        const geometry = this.geometry;
        const pointMap = this.pointMap;
        const w = 1, h = 1;
        // we need just camera projection matrix inverse
        // world matrix must be identity
        $9014d97cd777be10$var$_camera.projectionMatrixInverse.copy(this.camera.projectionMatrixInverse);
        // center / target
        $9014d97cd777be10$var$setPoint("c", pointMap, geometry, $9014d97cd777be10$var$_camera, 0, 0, -1);
        $9014d97cd777be10$var$setPoint("t", pointMap, geometry, $9014d97cd777be10$var$_camera, 0, 0, 1);
        // near
        $9014d97cd777be10$var$setPoint("n1", pointMap, geometry, $9014d97cd777be10$var$_camera, -w, -h, -1);
        $9014d97cd777be10$var$setPoint("n2", pointMap, geometry, $9014d97cd777be10$var$_camera, w, -h, -1);
        $9014d97cd777be10$var$setPoint("n3", pointMap, geometry, $9014d97cd777be10$var$_camera, -w, h, -1);
        $9014d97cd777be10$var$setPoint("n4", pointMap, geometry, $9014d97cd777be10$var$_camera, w, h, -1);
        // far
        $9014d97cd777be10$var$setPoint("f1", pointMap, geometry, $9014d97cd777be10$var$_camera, -w, -h, 1);
        $9014d97cd777be10$var$setPoint("f2", pointMap, geometry, $9014d97cd777be10$var$_camera, w, -h, 1);
        $9014d97cd777be10$var$setPoint("f3", pointMap, geometry, $9014d97cd777be10$var$_camera, -w, h, 1);
        $9014d97cd777be10$var$setPoint("f4", pointMap, geometry, $9014d97cd777be10$var$_camera, w, h, 1);
        // up
        $9014d97cd777be10$var$setPoint("u1", pointMap, geometry, $9014d97cd777be10$var$_camera, w * 0.7, h * 1.1, -1);
        $9014d97cd777be10$var$setPoint("u2", pointMap, geometry, $9014d97cd777be10$var$_camera, -w * 0.7, h * 1.1, -1);
        $9014d97cd777be10$var$setPoint("u3", pointMap, geometry, $9014d97cd777be10$var$_camera, 0, h * 2, -1);
        // cross
        $9014d97cd777be10$var$setPoint("cf1", pointMap, geometry, $9014d97cd777be10$var$_camera, -w, 0, 1);
        $9014d97cd777be10$var$setPoint("cf2", pointMap, geometry, $9014d97cd777be10$var$_camera, w, 0, 1);
        $9014d97cd777be10$var$setPoint("cf3", pointMap, geometry, $9014d97cd777be10$var$_camera, 0, -h, 1);
        $9014d97cd777be10$var$setPoint("cf4", pointMap, geometry, $9014d97cd777be10$var$_camera, 0, h, 1);
        $9014d97cd777be10$var$setPoint("cn1", pointMap, geometry, $9014d97cd777be10$var$_camera, -w, 0, -1);
        $9014d97cd777be10$var$setPoint("cn2", pointMap, geometry, $9014d97cd777be10$var$_camera, w, 0, -1);
        $9014d97cd777be10$var$setPoint("cn3", pointMap, geometry, $9014d97cd777be10$var$_camera, 0, -h, -1);
        $9014d97cd777be10$var$setPoint("cn4", pointMap, geometry, $9014d97cd777be10$var$_camera, 0, h, -1);
        geometry.getAttribute("position").needsUpdate = true;
    }
    dispose() {
        this.geometry.dispose();
        this.material.dispose();
    }
    constructor(camera){
        const geometry = new $9014d97cd777be10$export$b7be63a67df8959();
        const material = new $9014d97cd777be10$export$fbaaa33907730a0c({
            color: 0xffffff,
            vertexColors: true,
            toneMapped: false
        });
        const vertices = [];
        const colors = [];
        const pointMap = {};
        // near
        addLine("n1", "n2");
        addLine("n2", "n4");
        addLine("n4", "n3");
        addLine("n3", "n1");
        // far
        addLine("f1", "f2");
        addLine("f2", "f4");
        addLine("f4", "f3");
        addLine("f3", "f1");
        // sides
        addLine("n1", "f1");
        addLine("n2", "f2");
        addLine("n3", "f3");
        addLine("n4", "f4");
        // cone
        addLine("p", "n1");
        addLine("p", "n2");
        addLine("p", "n3");
        addLine("p", "n4");
        // up
        addLine("u1", "u2");
        addLine("u2", "u3");
        addLine("u3", "u1");
        // target
        addLine("c", "t");
        addLine("p", "c");
        // cross
        addLine("cn1", "cn2");
        addLine("cn3", "cn4");
        addLine("cf1", "cf2");
        addLine("cf3", "cf4");
        function addLine(a, b) {
            addPoint(a);
            addPoint(b);
        }
        function addPoint(id) {
            vertices.push(0, 0, 0);
            colors.push(0, 0, 0);
            if (pointMap[id] === undefined) pointMap[id] = [];
            pointMap[id].push(vertices.length / 3 - 1);
        }
        geometry.setAttribute("position", new $9014d97cd777be10$export$cbe7a62641830ebd(vertices, 3));
        geometry.setAttribute("color", new $9014d97cd777be10$export$cbe7a62641830ebd(colors, 3));
        super(geometry, material);
        this.type = "CameraHelper";
        this.camera = camera;
        if (this.camera.updateProjectionMatrix) this.camera.updateProjectionMatrix();
        this.matrix = camera.matrixWorld;
        this.matrixAutoUpdate = false;
        this.pointMap = pointMap;
        this.update();
        // colors
        const colorFrustum = new $9014d97cd777be10$export$892596cec99bc70e(0xffaa00);
        const colorCone = new $9014d97cd777be10$export$892596cec99bc70e(0xff0000);
        const colorUp = new $9014d97cd777be10$export$892596cec99bc70e(0x00aaff);
        const colorTarget = new $9014d97cd777be10$export$892596cec99bc70e(0xffffff);
        const colorCross = new $9014d97cd777be10$export$892596cec99bc70e(0x333333);
        this.setColors(colorFrustum, colorCone, colorUp, colorTarget, colorCross);
    }
}
function $9014d97cd777be10$var$setPoint(point, pointMap, geometry, camera, x, y, z) {
    $9014d97cd777be10$var$_vector.set(x, y, z).unproject(camera);
    const points = pointMap[point];
    if (points !== undefined) {
        const position = geometry.getAttribute("position");
        for(let i = 0, l = points.length; i < l; i++)position.setXYZ(points[i], $9014d97cd777be10$var$_vector.x, $9014d97cd777be10$var$_vector.y, $9014d97cd777be10$var$_vector.z);
    }
}
const $9014d97cd777be10$var$_box = /*@__PURE__*/ new $9014d97cd777be10$export$6f7d5a9418ab2aa3();
class $9014d97cd777be10$export$38a664cc862a6a9d extends $9014d97cd777be10$export$ff1ed10fedfdd604 {
    update(object) {
        if (object !== undefined) console.warn("THREE.BoxHelper: .update() has no longer arguments.");
        if (this.object !== undefined) $9014d97cd777be10$var$_box.setFromObject(this.object);
        if ($9014d97cd777be10$var$_box.isEmpty()) return;
        const min = $9014d97cd777be10$var$_box.min;
        const max = $9014d97cd777be10$var$_box.max;
        /*
			5____4
		1/___0/|
		| 6__|_7
		2/___3/

		0: max.x, max.y, max.z
		1: min.x, max.y, max.z
		2: min.x, min.y, max.z
		3: max.x, min.y, max.z
		4: max.x, max.y, min.z
		5: min.x, max.y, min.z
		6: min.x, min.y, min.z
		7: max.x, min.y, min.z
		*/ const position = this.geometry.attributes.position;
        const array = position.array;
        array[0] = max.x;
        array[1] = max.y;
        array[2] = max.z;
        array[3] = min.x;
        array[4] = max.y;
        array[5] = max.z;
        array[6] = min.x;
        array[7] = min.y;
        array[8] = max.z;
        array[9] = max.x;
        array[10] = min.y;
        array[11] = max.z;
        array[12] = max.x;
        array[13] = max.y;
        array[14] = min.z;
        array[15] = min.x;
        array[16] = max.y;
        array[17] = min.z;
        array[18] = min.x;
        array[19] = min.y;
        array[20] = min.z;
        array[21] = max.x;
        array[22] = min.y;
        array[23] = min.z;
        position.needsUpdate = true;
        this.geometry.computeBoundingSphere();
    }
    setFromObject(object) {
        this.object = object;
        this.update();
        return this;
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        this.object = source.object;
        return this;
    }
    dispose() {
        this.geometry.dispose();
        this.material.dispose();
    }
    constructor(object, color = 0xffff00){
        const indices = new Uint16Array([
            0,
            1,
            1,
            2,
            2,
            3,
            3,
            0,
            4,
            5,
            5,
            6,
            6,
            7,
            7,
            4,
            0,
            4,
            1,
            5,
            2,
            6,
            3,
            7
        ]);
        const positions = new Float32Array(24);
        const geometry = new $9014d97cd777be10$export$b7be63a67df8959();
        geometry.setIndex(new $9014d97cd777be10$export$8dea267bd6bde117(indices, 1));
        geometry.setAttribute("position", new $9014d97cd777be10$export$8dea267bd6bde117(positions, 3));
        super(geometry, new $9014d97cd777be10$export$fbaaa33907730a0c({
            color: color,
            toneMapped: false
        }));
        this.object = object;
        this.type = "BoxHelper";
        this.matrixAutoUpdate = false;
        this.update();
    }
}
class $9014d97cd777be10$export$ce39f4bb96c9a290 extends $9014d97cd777be10$export$ff1ed10fedfdd604 {
    updateMatrixWorld(force) {
        const box = this.box;
        if (box.isEmpty()) return;
        box.getCenter(this.position);
        box.getSize(this.scale);
        this.scale.multiplyScalar(0.5);
        super.updateMatrixWorld(force);
    }
    dispose() {
        this.geometry.dispose();
        this.material.dispose();
    }
    constructor(box, color = 0xffff00){
        const indices = new Uint16Array([
            0,
            1,
            1,
            2,
            2,
            3,
            3,
            0,
            4,
            5,
            5,
            6,
            6,
            7,
            7,
            4,
            0,
            4,
            1,
            5,
            2,
            6,
            3,
            7
        ]);
        const positions = [
            1,
            1,
            1,
            -1,
            1,
            1,
            -1,
            -1,
            1,
            1,
            -1,
            1,
            1,
            1,
            -1,
            -1,
            1,
            -1,
            -1,
            -1,
            -1,
            1,
            -1,
            -1
        ];
        const geometry = new $9014d97cd777be10$export$b7be63a67df8959();
        geometry.setIndex(new $9014d97cd777be10$export$8dea267bd6bde117(indices, 1));
        geometry.setAttribute("position", new $9014d97cd777be10$export$cbe7a62641830ebd(positions, 3));
        super(geometry, new $9014d97cd777be10$export$fbaaa33907730a0c({
            color: color,
            toneMapped: false
        }));
        this.box = box;
        this.type = "Box3Helper";
        this.geometry.computeBoundingSphere();
    }
}
class $9014d97cd777be10$export$a34fe8156c66e5d7 extends $9014d97cd777be10$export$17d680238e50603e {
    updateMatrixWorld(force) {
        this.position.set(0, 0, 0);
        this.scale.set(0.5 * this.size, 0.5 * this.size, 1);
        this.lookAt(this.plane.normal);
        this.translateZ(-this.plane.constant);
        super.updateMatrixWorld(force);
    }
    dispose() {
        this.geometry.dispose();
        this.material.dispose();
        this.children[0].geometry.dispose();
        this.children[0].material.dispose();
    }
    constructor(plane, size = 1, hex = 0xffff00){
        const color = hex;
        const positions = [
            1,
            -1,
            0,
            -1,
            1,
            0,
            -1,
            -1,
            0,
            1,
            1,
            0,
            -1,
            1,
            0,
            -1,
            -1,
            0,
            1,
            -1,
            0,
            1,
            1,
            0
        ];
        const geometry = new $9014d97cd777be10$export$b7be63a67df8959();
        geometry.setAttribute("position", new $9014d97cd777be10$export$cbe7a62641830ebd(positions, 3));
        geometry.computeBoundingSphere();
        super(geometry, new $9014d97cd777be10$export$fbaaa33907730a0c({
            color: color,
            toneMapped: false
        }));
        this.type = "PlaneHelper";
        this.plane = plane;
        this.size = size;
        const positions2 = [
            1,
            1,
            0,
            -1,
            1,
            0,
            -1,
            -1,
            0,
            1,
            1,
            0,
            -1,
            -1,
            0,
            1,
            -1,
            0
        ];
        const geometry2 = new $9014d97cd777be10$export$b7be63a67df8959();
        geometry2.setAttribute("position", new $9014d97cd777be10$export$cbe7a62641830ebd(positions2, 3));
        geometry2.computeBoundingSphere();
        this.add(new $9014d97cd777be10$export$e176487c05830cc5(geometry2, new $9014d97cd777be10$export$55cbcc9b622fe1f5({
            color: color,
            opacity: 0.2,
            transparent: true,
            depthWrite: false,
            toneMapped: false
        })));
    }
}
const $9014d97cd777be10$var$_axis = /*@__PURE__*/ new $9014d97cd777be10$export$64b5c384219d3699();
let $9014d97cd777be10$var$_lineGeometry, $9014d97cd777be10$var$_coneGeometry;
class $9014d97cd777be10$export$a3008e7bd8d2cbe7 extends $9014d97cd777be10$export$e4dd07dff30cc924 {
    setDirection(dir) {
        // dir is assumed to be normalized
        if (dir.y > 0.99999) this.quaternion.set(0, 0, 0, 1);
        else if (dir.y < -0.99999) this.quaternion.set(1, 0, 0, 0);
        else {
            $9014d97cd777be10$var$_axis.set(dir.z, 0, -dir.x).normalize();
            const radians = Math.acos(dir.y);
            this.quaternion.setFromAxisAngle($9014d97cd777be10$var$_axis, radians);
        }
    }
    setLength(length, headLength = length * 0.2, headWidth = headLength * 0.2) {
        this.line.scale.set(1, Math.max(0.0001, length - headLength), 1); // see #17458
        this.line.updateMatrix();
        this.cone.scale.set(headWidth, headLength, headWidth);
        this.cone.position.y = length;
        this.cone.updateMatrix();
    }
    setColor(color) {
        this.line.material.color.set(color);
        this.cone.material.color.set(color);
    }
    copy(source) {
        super.copy(source, false);
        this.line.copy(source.line);
        this.cone.copy(source.cone);
        return this;
    }
    dispose() {
        this.line.geometry.dispose();
        this.line.material.dispose();
        this.cone.geometry.dispose();
        this.cone.material.dispose();
    }
    // dir is assumed to be normalized
    constructor(dir = new $9014d97cd777be10$export$64b5c384219d3699(0, 0, 1), origin = new $9014d97cd777be10$export$64b5c384219d3699(0, 0, 0), length = 1, color = 0xffff00, headLength = length * 0.2, headWidth = headLength * 0.2){
        super();
        this.type = "ArrowHelper";
        if ($9014d97cd777be10$var$_lineGeometry === undefined) {
            $9014d97cd777be10$var$_lineGeometry = new $9014d97cd777be10$export$b7be63a67df8959();
            $9014d97cd777be10$var$_lineGeometry.setAttribute("position", new $9014d97cd777be10$export$cbe7a62641830ebd([
                0,
                0,
                0,
                0,
                1,
                0
            ], 3));
            $9014d97cd777be10$var$_coneGeometry = new $9014d97cd777be10$export$68f745719dbe5198(0, 0.5, 1, 5, 1);
            $9014d97cd777be10$var$_coneGeometry.translate(0, -0.5, 0);
        }
        this.position.copy(origin);
        this.line = new $9014d97cd777be10$export$17d680238e50603e($9014d97cd777be10$var$_lineGeometry, new $9014d97cd777be10$export$fbaaa33907730a0c({
            color: color,
            toneMapped: false
        }));
        this.line.matrixAutoUpdate = false;
        this.add(this.line);
        this.cone = new $9014d97cd777be10$export$e176487c05830cc5($9014d97cd777be10$var$_coneGeometry, new $9014d97cd777be10$export$55cbcc9b622fe1f5({
            color: color,
            toneMapped: false
        }));
        this.cone.matrixAutoUpdate = false;
        this.add(this.cone);
        this.setDirection(dir);
        this.setLength(length, headLength, headWidth);
    }
}
class $9014d97cd777be10$export$6c8303f35b8578fd extends $9014d97cd777be10$export$ff1ed10fedfdd604 {
    setColors(xAxisColor, yAxisColor, zAxisColor) {
        const color = new $9014d97cd777be10$export$892596cec99bc70e();
        const array = this.geometry.attributes.color.array;
        color.set(xAxisColor);
        color.toArray(array, 0);
        color.toArray(array, 3);
        color.set(yAxisColor);
        color.toArray(array, 6);
        color.toArray(array, 9);
        color.set(zAxisColor);
        color.toArray(array, 12);
        color.toArray(array, 15);
        this.geometry.attributes.color.needsUpdate = true;
        return this;
    }
    dispose() {
        this.geometry.dispose();
        this.material.dispose();
    }
    constructor(size = 1){
        const vertices = [
            0,
            0,
            0,
            size,
            0,
            0,
            0,
            0,
            0,
            0,
            size,
            0,
            0,
            0,
            0,
            0,
            0,
            size
        ];
        const colors = [
            1,
            0,
            0,
            1,
            0.6,
            0,
            0,
            1,
            0,
            0.6,
            1,
            0,
            0,
            0,
            1,
            0,
            0.6,
            1
        ];
        const geometry = new $9014d97cd777be10$export$b7be63a67df8959();
        geometry.setAttribute("position", new $9014d97cd777be10$export$cbe7a62641830ebd(vertices, 3));
        geometry.setAttribute("color", new $9014d97cd777be10$export$cbe7a62641830ebd(colors, 3));
        const material = new $9014d97cd777be10$export$fbaaa33907730a0c({
            vertexColors: true,
            toneMapped: false
        });
        super(geometry, material);
        this.type = "AxesHelper";
    }
}
class $9014d97cd777be10$export$148534a3c727230b {
    moveTo(x, y) {
        this.currentPath = new $9014d97cd777be10$export$4b2950bdac9b6ee9();
        this.subPaths.push(this.currentPath);
        this.currentPath.moveTo(x, y);
        return this;
    }
    lineTo(x, y) {
        this.currentPath.lineTo(x, y);
        return this;
    }
    quadraticCurveTo(aCPx, aCPy, aX, aY) {
        this.currentPath.quadraticCurveTo(aCPx, aCPy, aX, aY);
        return this;
    }
    bezierCurveTo(aCP1x, aCP1y, aCP2x, aCP2y, aX, aY) {
        this.currentPath.bezierCurveTo(aCP1x, aCP1y, aCP2x, aCP2y, aX, aY);
        return this;
    }
    splineThru(pts) {
        this.currentPath.splineThru(pts);
        return this;
    }
    toShapes(isCCW) {
        function toShapesNoHoles(inSubpaths) {
            const shapes = [];
            for(let i = 0, l = inSubpaths.length; i < l; i++){
                const tmpPath = inSubpaths[i];
                const tmpShape = new $9014d97cd777be10$export$6428a7f2611ef1fa();
                tmpShape.curves = tmpPath.curves;
                shapes.push(tmpShape);
            }
            return shapes;
        }
        function isPointInsidePolygon(inPt, inPolygon) {
            const polyLen = inPolygon.length;
            // inPt on polygon contour => immediate success    or
            // toggling of inside/outside at every single! intersection point of an edge
            //  with the horizontal line through inPt, left of inPt
            //  not counting lowerY endpoints of edges and whole edges on that line
            let inside = false;
            for(let p = polyLen - 1, q = 0; q < polyLen; p = q++){
                let edgeLowPt = inPolygon[p];
                let edgeHighPt = inPolygon[q];
                let edgeDx = edgeHighPt.x - edgeLowPt.x;
                let edgeDy = edgeHighPt.y - edgeLowPt.y;
                if (Math.abs(edgeDy) > Number.EPSILON) {
                    // not parallel
                    if (edgeDy < 0) {
                        edgeLowPt = inPolygon[q];
                        edgeDx = -edgeDx;
                        edgeHighPt = inPolygon[p];
                        edgeDy = -edgeDy;
                    }
                    if (inPt.y < edgeLowPt.y || inPt.y > edgeHighPt.y) continue;
                    if (inPt.y === edgeLowPt.y) {
                        if (inPt.x === edgeLowPt.x) return true; // inPt is on contour ?
                    // continue;				// no intersection or edgeLowPt => doesn't count !!!
                    } else {
                        const perpEdge = edgeDy * (inPt.x - edgeLowPt.x) - edgeDx * (inPt.y - edgeLowPt.y);
                        if (perpEdge === 0) return true; // inPt is on contour ?
                        if (perpEdge < 0) continue;
                        inside = !inside; // true intersection left of inPt
                    }
                } else {
                    // parallel or collinear
                    if (inPt.y !== edgeLowPt.y) continue; // parallel
                    // edge lies on the same horizontal line as inPt
                    if (edgeHighPt.x <= inPt.x && inPt.x <= edgeLowPt.x || edgeLowPt.x <= inPt.x && inPt.x <= edgeHighPt.x) return true; // inPt: Point on contour !
                // continue;
                }
            }
            return inside;
        }
        const isClockWise = $9014d97cd777be10$export$96bdf6d9c66d7ba8.isClockWise;
        const subPaths = this.subPaths;
        if (subPaths.length === 0) return [];
        let solid, tmpPath, tmpShape;
        const shapes = [];
        if (subPaths.length === 1) {
            tmpPath = subPaths[0];
            tmpShape = new $9014d97cd777be10$export$6428a7f2611ef1fa();
            tmpShape.curves = tmpPath.curves;
            shapes.push(tmpShape);
            return shapes;
        }
        let holesFirst = !isClockWise(subPaths[0].getPoints());
        holesFirst = isCCW ? !holesFirst : holesFirst;
        // console.log("Holes first", holesFirst);
        const betterShapeHoles = [];
        const newShapes = [];
        let newShapeHoles = [];
        let mainIdx = 0;
        let tmpPoints;
        newShapes[mainIdx] = undefined;
        newShapeHoles[mainIdx] = [];
        for(let i = 0, l = subPaths.length; i < l; i++){
            tmpPath = subPaths[i];
            tmpPoints = tmpPath.getPoints();
            solid = isClockWise(tmpPoints);
            solid = isCCW ? !solid : solid;
            if (solid) {
                if (!holesFirst && newShapes[mainIdx]) mainIdx++;
                newShapes[mainIdx] = {
                    s: new $9014d97cd777be10$export$6428a7f2611ef1fa(),
                    p: tmpPoints
                };
                newShapes[mainIdx].s.curves = tmpPath.curves;
                if (holesFirst) mainIdx++;
                newShapeHoles[mainIdx] = [];
            //console.log('cw', i);
            } else newShapeHoles[mainIdx].push({
                h: tmpPath,
                p: tmpPoints[0]
            });
        }
        // only Holes? -> probably all Shapes with wrong orientation
        if (!newShapes[0]) return toShapesNoHoles(subPaths);
        if (newShapes.length > 1) {
            let ambiguous = false;
            let toChange = 0;
            for(let sIdx = 0, sLen = newShapes.length; sIdx < sLen; sIdx++)betterShapeHoles[sIdx] = [];
            for(let sIdx = 0, sLen = newShapes.length; sIdx < sLen; sIdx++){
                const sho = newShapeHoles[sIdx];
                for(let hIdx = 0; hIdx < sho.length; hIdx++){
                    const ho = sho[hIdx];
                    let hole_unassigned = true;
                    for(let s2Idx = 0; s2Idx < newShapes.length; s2Idx++)if (isPointInsidePolygon(ho.p, newShapes[s2Idx].p)) {
                        if (sIdx !== s2Idx) toChange++;
                        if (hole_unassigned) {
                            hole_unassigned = false;
                            betterShapeHoles[s2Idx].push(ho);
                        } else ambiguous = true;
                    }
                    if (hole_unassigned) betterShapeHoles[sIdx].push(ho);
                }
            }
            if (toChange > 0 && ambiguous === false) newShapeHoles = betterShapeHoles;
        }
        let tmpHoles;
        for(let i = 0, il = newShapes.length; i < il; i++){
            tmpShape = newShapes[i].s;
            shapes.push(tmpShape);
            tmpHoles = newShapeHoles[i];
            for(let j = 0, jl = tmpHoles.length; j < jl; j++)tmpShape.holes.push(tmpHoles[j].h);
        }
        //console.log("shape", shapes);
        return shapes;
    }
    constructor(){
        this.type = "ShapePath";
        this.color = new $9014d97cd777be10$export$892596cec99bc70e();
        this.subPaths = [];
        this.currentPath = null;
    }
}
if (typeof __THREE_DEVTOOLS__ !== "undefined") __THREE_DEVTOOLS__.dispatchEvent(new CustomEvent("register", {
    detail: {
        revision: $9014d97cd777be10$export$3545e07a80636437
    }
}));
if (typeof window !== "undefined") {
    if (window.__THREE__) console.warn("WARNING: Multiple instances of Three.js being imported.");
    else window.__THREE__ = $9014d97cd777be10$export$3545e07a80636437;
}


var $39f39c7ce64f85e7$exports = {};
"use strict";
var $39f39c7ce64f85e7$var$__createBinding = $39f39c7ce64f85e7$exports && $39f39c7ce64f85e7$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $39f39c7ce64f85e7$var$__exportStar = $39f39c7ce64f85e7$exports && $39f39c7ce64f85e7$exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $39f39c7ce64f85e7$var$__createBinding(exports1, m, p);
};
Object.defineProperty($39f39c7ce64f85e7$exports, "__esModule", {
    value: true
});

// server
$39f39c7ce64f85e7$var$__exportStar((parcelRequire("b1GcV")), $39f39c7ce64f85e7$exports);

$39f39c7ce64f85e7$var$__exportStar((parcelRequire("9Of2n")), $39f39c7ce64f85e7$exports);

$39f39c7ce64f85e7$var$__exportStar((parcelRequire("fbAZ5")), $39f39c7ce64f85e7$exports);

$39f39c7ce64f85e7$var$__exportStar((parcelRequire("9hiqW")), $39f39c7ce64f85e7$exports);

$39f39c7ce64f85e7$var$__exportStar((parcelRequire("72WIA")), $39f39c7ce64f85e7$exports);

$39f39c7ce64f85e7$var$__exportStar((parcelRequire("5gKD3")), $39f39c7ce64f85e7$exports);

$39f39c7ce64f85e7$var$__exportStar((parcelRequire("e5VTd")), $39f39c7ce64f85e7$exports);

$39f39c7ce64f85e7$var$__exportStar((parcelRequire("9j9Dt")), $39f39c7ce64f85e7$exports);

$39f39c7ce64f85e7$var$__exportStar((parcelRequire("6J9tY")), $39f39c7ce64f85e7$exports);

$39f39c7ce64f85e7$var$__exportStar((parcelRequire("9E0Iw")), $39f39c7ce64f85e7$exports);

$39f39c7ce64f85e7$var$__exportStar((parcelRequire("blYCD")), $39f39c7ce64f85e7$exports);

// client
$39f39c7ce64f85e7$var$__exportStar((parcelRequire("2vKxR")), $39f39c7ce64f85e7$exports);

$39f39c7ce64f85e7$var$__exportStar((parcelRequire("lsI87")), $39f39c7ce64f85e7$exports);

$39f39c7ce64f85e7$var$__exportStar((parcelRequire("Vm5ZV")), $39f39c7ce64f85e7$exports);

$39f39c7ce64f85e7$var$__exportStar((parcelRequire("fXcSp")), $39f39c7ce64f85e7$exports);

$39f39c7ce64f85e7$var$__exportStar((parcelRequire("kuD7j")), $39f39c7ce64f85e7$exports);

$39f39c7ce64f85e7$var$__exportStar((parcelRequire("8Z8n9")), $39f39c7ce64f85e7$exports);

$39f39c7ce64f85e7$var$__exportStar((parcelRequire("cFZQu")), $39f39c7ce64f85e7$exports);

$39f39c7ce64f85e7$var$__exportStar((parcelRequire("7HJJW")), $39f39c7ce64f85e7$exports);

$39f39c7ce64f85e7$var$__exportStar((parcelRequire("5YfME")), $39f39c7ce64f85e7$exports);

// common
$39f39c7ce64f85e7$var$__exportStar((parcelRequire("ge3xl")), $39f39c7ce64f85e7$exports);

$39f39c7ce64f85e7$var$__exportStar((parcelRequire("3tshL")), $39f39c7ce64f85e7$exports);

$39f39c7ce64f85e7$var$__exportStar((parcelRequire("gmcT5")), $39f39c7ce64f85e7$exports);

$39f39c7ce64f85e7$var$__exportStar((parcelRequire("GQZAf")), $39f39c7ce64f85e7$exports);

$39f39c7ce64f85e7$var$__exportStar((parcelRequire("4yNKp")), $39f39c7ce64f85e7$exports);

$39f39c7ce64f85e7$var$__exportStar((parcelRequire("f1HWk")), $39f39c7ce64f85e7$exports);

$39f39c7ce64f85e7$var$__exportStar((parcelRequire("fDA8S")), $39f39c7ce64f85e7$exports);

$39f39c7ce64f85e7$var$__exportStar((parcelRequire("9OrNZ")), $39f39c7ce64f85e7$exports);

$39f39c7ce64f85e7$var$__exportStar((parcelRequire("7wMIx")), $39f39c7ce64f85e7$exports);

// types for integration with adapters
$39f39c7ce64f85e7$var$__exportStar((parcelRequire("l99iw")), $39f39c7ce64f85e7$exports);

$39f39c7ce64f85e7$var$__exportStar((parcelRequire("bEGTI")), $39f39c7ce64f85e7$exports);

$39f39c7ce64f85e7$var$__exportStar((parcelRequire("h5KJq")), $39f39c7ce64f85e7$exports);

// benchmarks/tests
$39f39c7ce64f85e7$var$__exportStar((parcelRequire("iWOZU")), $39f39c7ce64f85e7$exports);


const $7c910687071ab881$export$dfbbeca3e3775011 = new (0, $39f39c7ce64f85e7$exports.Context)();
var $7c910687071ab881$export$f7cab339749a57d7;
(function(NType) {
    NType[NType["NULL"] = 0] = "NULL";
    NType[NType[// Commands (client->server)
    "InputCommand"] = 1] = "InputCommand";
    NType[NType["ChangeSkinCommand"] = 2] = "ChangeSkinCommand";
    NType[NType["EmoteCommand"] = 3] = "EmoteCommand";
    NType[NType["ChangeUsernameCommand"] = 4] = "ChangeUsernameCommand";
    NType[NType["DebugTeleportCommand"] = 5] = "DebugTeleportCommand";
    NType[NType["DebugForceCheckpointCommand"] = 6] = "DebugForceCheckpointCommand";
    NType[NType["ParticleTrailCommand"] = 7] = "ParticleTrailCommand";
    NType[NType[// Entities (replicated)
    "PlayerEntity"] = 8] = "PlayerEntity";
    NType[NType["PlatformEntity"] = 9] = "PlatformEntity";
    NType[NType[// Messages (server->client)
    "IdentityMessage"] = 10] = "IdentityMessage";
    NType[NType["RunDurationUpdatedMessage"] = 11] = "RunDurationUpdatedMessage";
    NType[NType["EmoteMessage"] = 12] = "EmoteMessage";
    NType[NType["RunCompleteMessage"] = 13] = "RunCompleteMessage";
    NType[NType[// ParticleTrailMessage,
    "LeaderboardMessage"] = 14] = "LeaderboardMessage";
})($7c910687071ab881$export$f7cab339749a57d7 || ($7c910687071ab881$export$f7cab339749a57d7 = {}));
/*************************************************/ /*                                               */ /*  Entity Replication!                          */ /*                                               */ /*************************************************/ /*****************/ /* Player Entity */ /*****************/ const $7c910687071ab881$var$playerEntity = (0, $39f39c7ce64f85e7$exports.defineSchema)({
    x: {
        type: (0, $39f39c7ce64f85e7$exports.Binary).Float64,
        interp: true
    },
    y: {
        type: (0, $39f39c7ce64f85e7$exports.Binary).Float64,
        interp: true
    },
    z: {
        type: (0, $39f39c7ce64f85e7$exports.Binary).Float64,
        interp: true
    },
    rotX: {
        type: (0, $39f39c7ce64f85e7$exports.Binary).Float64,
        interp: true
    },
    rotY: {
        type: (0, $39f39c7ce64f85e7$exports.Binary).Float64,
        interp: true
    },
    rotZ: {
        type: (0, $39f39c7ce64f85e7$exports.Binary).Float64,
        interp: true
    },
    runInProgress: (0, $39f39c7ce64f85e7$exports.Binary).Boolean,
    runDurationAcc: (0, $39f39c7ce64f85e7$exports.Binary).Float64,
    animationSpeedMultiplier: (0, $39f39c7ce64f85e7$exports.Binary).Float64,
    username: (0, $39f39c7ce64f85e7$exports.Binary).String,
    country: (0, $39f39c7ce64f85e7$exports.Binary).UInt16,
    characterSkin: (0, $39f39c7ce64f85e7$exports.Binary).UInt8,
    characterTrail: (0, $39f39c7ce64f85e7$exports.Binary).Int8,
    animationState: (0, $39f39c7ce64f85e7$exports.Binary).String,
    currentState: (0, $39f39c7ce64f85e7$exports.Binary).String,
    previousState: (0, $39f39c7ce64f85e7$exports.Binary).String,
    visualModelRotation: (0, $39f39c7ce64f85e7$exports.Binary).Float64,
    IsGrounded: (0, $39f39c7ce64f85e7$exports.Binary).Boolean
});
$7c910687071ab881$export$dfbbeca3e3775011.register($7c910687071ab881$export$f7cab339749a57d7.PlayerEntity, $7c910687071ab881$var$playerEntity);
/*************************************************/ /*                                               */ /*  Messages (server ---> client)                */ /*                                               */ /*************************************************/ /*****************&***/ /* Leaderboard Msg   */ /*********************/ const $7c910687071ab881$var$leaderboardMessageSchema = (0, $39f39c7ce64f85e7$exports.defineSchema)({
    leaderboard: (0, $39f39c7ce64f85e7$exports.Binary).String
});
$7c910687071ab881$export$dfbbeca3e3775011.register($7c910687071ab881$export$f7cab339749a57d7.LeaderboardMessage, $7c910687071ab881$var$leaderboardMessageSchema);
/********************/ /* Identity Message */ /********************/ const $7c910687071ab881$var$identityMessageSchema = (0, $39f39c7ce64f85e7$exports.defineSchema)({
    myId: (0, $39f39c7ce64f85e7$exports.Binary).UInt32,
    myX: (0, $39f39c7ce64f85e7$exports.Binary).Float64,
    myY: (0, $39f39c7ce64f85e7$exports.Binary).Float64,
    myZ: (0, $39f39c7ce64f85e7$exports.Binary).Float64
});
$7c910687071ab881$export$dfbbeca3e3775011.register($7c910687071ab881$export$f7cab339749a57d7.IdentityMessage, $7c910687071ab881$var$identityMessageSchema);
/********************************/ /*     Run Complete Message     */ /********************************/ const $7c910687071ab881$var$runCompleteMessage = (0, $39f39c7ce64f85e7$exports.defineSchema)({
    minutes: (0, $39f39c7ce64f85e7$exports.Binary).String,
    seconds: (0, $39f39c7ce64f85e7$exports.Binary).String,
    milliseconds: (0, $39f39c7ce64f85e7$exports.Binary).String
});
$7c910687071ab881$export$dfbbeca3e3775011.register($7c910687071ab881$export$f7cab339749a57d7.RunCompleteMessage, $7c910687071ab881$var$runCompleteMessage);
/********************************/ /* Updated Run Duration Message */ /********************************/ const $7c910687071ab881$var$runDurationUpdatedMessage = (0, $39f39c7ce64f85e7$exports.defineSchema)({
    newRunDuration: (0, $39f39c7ce64f85e7$exports.Binary).UInt32
});
$7c910687071ab881$export$dfbbeca3e3775011.register($7c910687071ab881$export$f7cab339749a57d7.RunDurationUpdatedMessage, $7c910687071ab881$var$runDurationUpdatedMessage);
/*****************/ /* Emote Message */ /*****************/ const $7c910687071ab881$var$emoteMessage = (0, $39f39c7ce64f85e7$exports.defineSchema)({
    playerId: (0, $39f39c7ce64f85e7$exports.Binary).UInt32,
    emote: (0, $39f39c7ce64f85e7$exports.Binary).UInt8,
    animation: (0, $39f39c7ce64f85e7$exports.Binary).UInt8
});
$7c910687071ab881$export$dfbbeca3e3775011.register($7c910687071ab881$export$f7cab339749a57d7.EmoteMessage, $7c910687071ab881$var$emoteMessage);
/**************************/ /* Particle Trail Message */ /**************************/ // const particleTrailMessage: Schema = defineSchema({
//     playerId: Binary.UInt32,
//     particleTrail: Binary.UInt8
// });
// export interface ParticleTrailMessage extends NTyped {
//     ntype: NType.ParticleTrailMessage;
//     playerId: number;
//     particleTrail: number;
// }
// nengiConfig.register(NType.ParticleTrailMessage, particleTrailMessage);
/*************************************************/ /*                                               */ /*  Commands (client ---> server)                */ /*                                               */ /*************************************************/ /**************/ /* ChangeSkin */ /**************/ const $7c910687071ab881$var$changeSkinCommandSchema = (0, $39f39c7ce64f85e7$exports.defineSchema)({
    newSkin: (0, $39f39c7ce64f85e7$exports.Binary).UInt8
});
$7c910687071ab881$export$dfbbeca3e3775011.register($7c910687071ab881$export$f7cab339749a57d7.ChangeSkinCommand, $7c910687071ab881$var$changeSkinCommandSchema);
/*********/ /* Input */ /*********/ const $7c910687071ab881$var$inputCommandSchema = (0, $39f39c7ce64f85e7$exports.defineSchema)({
    forward: (0, $39f39c7ce64f85e7$exports.Binary).Boolean,
    back: (0, $39f39c7ce64f85e7$exports.Binary).Boolean,
    left: (0, $39f39c7ce64f85e7$exports.Binary).Boolean,
    right: (0, $39f39c7ce64f85e7$exports.Binary).Boolean,
    jump: (0, $39f39c7ce64f85e7$exports.Binary).Boolean,
    rotX: (0, $39f39c7ce64f85e7$exports.Binary).Float64,
    rotY: (0, $39f39c7ce64f85e7$exports.Binary).Float64,
    rotZ: (0, $39f39c7ce64f85e7$exports.Binary).Float64,
    isMobile: (0, $39f39c7ce64f85e7$exports.Binary).Boolean,
    playerIsMoving: (0, $39f39c7ce64f85e7$exports.Binary).Boolean,
    mobileXDirection: (0, $39f39c7ce64f85e7$exports.Binary).Float64,
    mobileZDirection: (0, $39f39c7ce64f85e7$exports.Binary).Float64,
    mobileYRotation: (0, $39f39c7ce64f85e7$exports.Binary).Float64,
    mobileSpeedMultiplier: (0, $39f39c7ce64f85e7$exports.Binary).Float64,
    visualModelRotation: (0, $39f39c7ce64f85e7$exports.Binary).Float64,
    wantsToRespawnAtCheckpoint: (0, $39f39c7ce64f85e7$exports.Binary).Boolean,
    wantsToRestartRun: (0, $39f39c7ce64f85e7$exports.Binary).Boolean,
    delta: (0, $39f39c7ce64f85e7$exports.Binary).Float64
});
$7c910687071ab881$export$dfbbeca3e3775011.register($7c910687071ab881$export$f7cab339749a57d7.InputCommand, $7c910687071ab881$var$inputCommandSchema);
/******************/ /* Debug Teleport */ /******************/ const $7c910687071ab881$var$debugTeleportCommandSchema = (0, $39f39c7ce64f85e7$exports.defineSchema)({
    shouldTeleport: (0, $39f39c7ce64f85e7$exports.Binary).Boolean
});
$7c910687071ab881$export$dfbbeca3e3775011.register($7c910687071ab881$export$f7cab339749a57d7.DebugTeleportCommand, $7c910687071ab881$var$debugTeleportCommandSchema);
/**************************/ /* Debug Force Checkpoint */ /**************************/ const $7c910687071ab881$var$debugForceCheckpointCommandSchema = (0, $39f39c7ce64f85e7$exports.defineSchema)({
    shouldForceCheckpoint: (0, $39f39c7ce64f85e7$exports.Binary).Boolean
});
$7c910687071ab881$export$dfbbeca3e3775011.register($7c910687071ab881$export$f7cab339749a57d7.DebugForceCheckpointCommand, $7c910687071ab881$var$debugForceCheckpointCommandSchema);
/*********/ /* Emote */ /*********/ const $7c910687071ab881$var$emoteCommandSchema = (0, $39f39c7ce64f85e7$exports.defineSchema)({
    emote: (0, $39f39c7ce64f85e7$exports.Binary).UInt8,
    animation: (0, $39f39c7ce64f85e7$exports.Binary).UInt8
});
$7c910687071ab881$export$dfbbeca3e3775011.register($7c910687071ab881$export$f7cab339749a57d7.EmoteCommand, $7c910687071ab881$var$emoteCommandSchema);
/******************/ /* Particle Trail */ /******************/ const $7c910687071ab881$var$particleTrailCommandSchema = (0, $39f39c7ce64f85e7$exports.defineSchema)({
    particleTrail: (0, $39f39c7ce64f85e7$exports.Binary).Int8
});
$7c910687071ab881$export$dfbbeca3e3775011.register($7c910687071ab881$export$f7cab339749a57d7.ParticleTrailCommand, $7c910687071ab881$var$particleTrailCommandSchema);
/*******************/ /* Change Username */ /*******************/ const $7c910687071ab881$var$changeUsernameCommandSchema = (0, $39f39c7ce64f85e7$exports.defineSchema)({
    prefix: (0, $39f39c7ce64f85e7$exports.Binary).UInt16,
    suffix: (0, $39f39c7ce64f85e7$exports.Binary).UInt16,
    country: (0, $39f39c7ce64f85e7$exports.Binary).UInt16
});
$7c910687071ab881$export$dfbbeca3e3775011.register($7c910687071ab881$export$f7cab339749a57d7.ChangeUsernameCommand, $7c910687071ab881$var$changeUsernameCommandSchema);



var $07756da3fdd79b5d$export$aaab732ed133eca;
(function(TriggerTypes) {
    TriggerTypes[TriggerTypes["None"] = -1] = "None";
    TriggerTypes[TriggerTypes["Checkpoint"] = 0] = "Checkpoint";
    TriggerTypes[TriggerTypes["StartingLine"] = 1] = "StartingLine";
    TriggerTypes[TriggerTypes["FinishLine"] = 2] = "FinishLine";
    TriggerTypes[TriggerTypes["UI_PopUp_CharacterSelect"] = 3] = "UI_PopUp_CharacterSelect";
    TriggerTypes[TriggerTypes["DeathBlock"] = 4] = "DeathBlock";
    TriggerTypes[TriggerTypes["Bounce"] = 5] = "Bounce";
    TriggerTypes[TriggerTypes["Speed"] = 6] = "Speed";
    TriggerTypes[TriggerTypes["UI_PopUp_NameAndCountrySelect"] = 7] = "UI_PopUp_NameAndCountrySelect";
    TriggerTypes[TriggerTypes["UI_PopUp_EndRun"] = 8] = "UI_PopUp_EndRun";
    TriggerTypes[TriggerTypes["UI_PopUp_TrailSelect"] = 9] = "UI_PopUp_TrailSelect";
})($07756da3fdd79b5d$export$aaab732ed133eca || ($07756da3fdd79b5d$export$aaab732ed133eca = {}));
class $07756da3fdd79b5d$export$2c106553ed021268 {
    get top() {
        return this.Position.y + this.Collider.Height / 2;
    }
    get bottom() {
        return this.Position.y - this.Collider.Height / 2;
    }
    get left() {
        return this.Position.x - this.Collider.Width / 2;
    }
    get right() {
        return this.Position.x + this.Collider.Width / 2;
    }
    get front() {
        return this.Position.z - this.Collider.Depth / 2;
    }
    get back() {
        return this.Position.z + this.Collider.Depth / 2;
    }
    get x() {
        return this.Position.x;
    }
    set x(newX) {
        this.Position.x = newX;
        this.Collider.Position.x = newX;
    }
    get y() {
        return this.Position.y;
    }
    set y(newY) {
        this.Position.y = newY;
        this.Collider.Position.y = newY;
    }
    get z() {
        return this.Position.z;
    }
    set z(newZ) {
        this.Position.z = newZ;
        this.Collider.Position.z = newZ;
    }
    get scaleX() {
        return this.Scale.x;
    }
    get scaleY() {
        return this.Scale.y;
    }
    get scaleZ() {
        return this.Scale.z;
    }
    get rotX() {
        return this.Rotation.x;
    }
    set rotX(eulerAngle) {
        this.Rotation.x = eulerAngle;
    }
    get rotY() {
        return this.Rotation.y;
    }
    set rotY(eulerAngle) {
        this.Rotation.y = eulerAngle;
    }
    get rotZ() {
        return this.Rotation.z;
    }
    set rotZ(eulerAngle) {
        this.Rotation.z = eulerAngle;
    }
    get colliderWidth() {
        return this.Collider.Width;
    }
    get colliderHeight() {
        return this.Collider.Height;
    }
    get colliderDepth() {
        return this.Collider.Depth;
    }
    constructor(initialX, initialY, initialZ, scaleX, scaleY, scaleZ, rotX, rotY, rotZ){
        this.Position = new (0, $9014d97cd777be10$export$64b5c384219d3699)(0, 0, 0);
        this.Scale = new (0, $9014d97cd777be10$export$64b5c384219d3699)(0, 0, 0);
        this.Rotation = new (0, $9014d97cd777be10$export$64b5c384219d3699)(0, 0, 0);
        this.Velocity = new (0, $9014d97cd777be10$export$64b5c384219d3699)(0, 0, 0);
        this.Collider = {
            Height: 2,
            Width: 1,
            Depth: 1,
            Position: this.Position
        };
        this.Position.set(initialX, initialY, initialZ);
        this.Scale.set(scaleX, scaleY, scaleZ);
        this.Rotation.set(rotX, rotY, rotZ);
    }
}




/********************************************/ /*                                          */ /*      Character Models & Animations       */ /*                                          */ /********************************************/ var $018036e722cee03d$export$a3168656a78efa21;
(function(Characters) {
    Characters[Characters["Broccoli"] = 0] = "Broccoli";
    Characters[Characters["Blueberry"] = 1] = "Blueberry";
    Characters[Characters["Apple"] = 2] = "Apple";
    Characters[Characters["Cupcake"] = 3] = "Cupcake";
    Characters[Characters["Icecream"] = 4] = "Icecream";
    Characters[Characters["Hotdog"] = 5] = "Hotdog";
    Characters[Characters["Peach"] = 6] = "Peach";
    Characters[Characters["Eggplant"] = 7] = "Eggplant";
    Characters[Characters["Banana"] = 8] = "Banana";
    Characters[Characters["Baguette"] = 9] = "Baguette";
    Characters[Characters["Taco"] = 10] = "Taco";
    Characters[Characters["Turkeyleg"] = 11] = "Turkeyleg";
    Characters[Characters["Candycane"] = 12] = "Candycane";
})($018036e722cee03d$export$a3168656a78efa21 || ($018036e722cee03d$export$a3168656a78efa21 = {}));
var $018036e722cee03d$export$d3f726e605aa4690;
(function(CharacterAnimations) {
    CharacterAnimations["Idle"] = "idle";
    CharacterAnimations["Walking"] = "walking";
    CharacterAnimations["Jumping"] = "jumping_up";
    CharacterAnimations["Death"] = "death";
})($018036e722cee03d$export$d3f726e605aa4690 || ($018036e722cee03d$export$d3f726e605aa4690 = {}));
const $018036e722cee03d$export$8e561b4222bacdfd = new Map();
$018036e722cee03d$export$8e561b4222bacdfd.set($018036e722cee03d$export$a3168656a78efa21.Broccoli, {
    identifier: $018036e722cee03d$export$a3168656a78efa21.Broccoli,
    assetPath: "characters/broccoli.glb",
    requiresAdToUnlock: false
});
$018036e722cee03d$export$8e561b4222bacdfd.set($018036e722cee03d$export$a3168656a78efa21.Blueberry, {
    identifier: $018036e722cee03d$export$a3168656a78efa21.Blueberry,
    assetPath: "characters/blueberry.glb",
    requiresAdToUnlock: false
});
$018036e722cee03d$export$8e561b4222bacdfd.set($018036e722cee03d$export$a3168656a78efa21.Apple, {
    identifier: $018036e722cee03d$export$a3168656a78efa21.Apple,
    assetPath: "characters/apple.glb",
    requiresAdToUnlock: false
});
$018036e722cee03d$export$8e561b4222bacdfd.set($018036e722cee03d$export$a3168656a78efa21.Cupcake, {
    identifier: $018036e722cee03d$export$a3168656a78efa21.Cupcake,
    assetPath: "characters/cupcake.glb",
    requiresAdToUnlock: true
});
$018036e722cee03d$export$8e561b4222bacdfd.set($018036e722cee03d$export$a3168656a78efa21.Icecream, {
    identifier: $018036e722cee03d$export$a3168656a78efa21.Icecream,
    assetPath: "characters/icecream.glb",
    requiresAdToUnlock: true
});
$018036e722cee03d$export$8e561b4222bacdfd.set($018036e722cee03d$export$a3168656a78efa21.Hotdog, {
    identifier: $018036e722cee03d$export$a3168656a78efa21.Hotdog,
    assetPath: "characters/hotdog.glb",
    requiresAdToUnlock: true
});
$018036e722cee03d$export$8e561b4222bacdfd.set($018036e722cee03d$export$a3168656a78efa21.Peach, {
    identifier: $018036e722cee03d$export$a3168656a78efa21.Peach,
    assetPath: "characters/peach.glb",
    requiresAdToUnlock: true
});
$018036e722cee03d$export$8e561b4222bacdfd.set($018036e722cee03d$export$a3168656a78efa21.Eggplant, {
    identifier: $018036e722cee03d$export$a3168656a78efa21.Eggplant,
    assetPath: "characters/eggplant.glb",
    requiresAdToUnlock: true
});
$018036e722cee03d$export$8e561b4222bacdfd.set($018036e722cee03d$export$a3168656a78efa21.Banana, {
    identifier: $018036e722cee03d$export$a3168656a78efa21.Banana,
    assetPath: "characters/banana.glb",
    requiresAdToUnlock: true
});
$018036e722cee03d$export$8e561b4222bacdfd.set($018036e722cee03d$export$a3168656a78efa21.Baguette, {
    identifier: $018036e722cee03d$export$a3168656a78efa21.Baguette,
    assetPath: "characters/baguette.glb",
    requiresAdToUnlock: true
});
$018036e722cee03d$export$8e561b4222bacdfd.set($018036e722cee03d$export$a3168656a78efa21.Taco, {
    identifier: $018036e722cee03d$export$a3168656a78efa21.Taco,
    assetPath: "characters/taco.glb",
    requiresAdToUnlock: true
});
$018036e722cee03d$export$8e561b4222bacdfd.set($018036e722cee03d$export$a3168656a78efa21.Turkeyleg, {
    identifier: $018036e722cee03d$export$a3168656a78efa21.Turkeyleg,
    assetPath: "characters/turkeyleg.glb",
    requiresAdToUnlock: true
});
$018036e722cee03d$export$8e561b4222bacdfd.set($018036e722cee03d$export$a3168656a78efa21.Candycane, {
    identifier: $018036e722cee03d$export$a3168656a78efa21.Candycane,
    assetPath: "characters/candycane.glb",
    requiresAdToUnlock: true
});


var $cae8463151c972d6$exports = {};
$cae8463151c972d6$exports = JSON.parse('{"platforms":[{"assetIdentifier":"moving_block_001","uniqueIdentifier":"0","position":[354.51,697,-2.73],"scale":[2,2,2],"rotation":[0,0,0],"behaviour":["Speed","1.8","",""]},{"assetIdentifier":"moving_block_001","uniqueIdentifier":"1","position":[347.33,699,14.39],"scale":[1,1,1],"rotation":[0,0,0],"behaviour":["Speed","1.8","",""]},{"assetIdentifier":"pan_001","uniqueIdentifier":"2","position":[303.31,623.78,-26.2],"scale":[1.83,1.83,1.83],"rotation":[0,0,0],"behaviour":["Bounce","2.04","",""]},{"assetIdentifier":"pan_001","uniqueIdentifier":"3","position":[313.88,578.5,68.35],"scale":[1,1,1],"rotation":[0,0,0],"behaviour":["Bounce","1.5","",""]},{"assetIdentifier":"moving_block_001","uniqueIdentifier":"4","position":[316.88,577.5,82.24],"scale":[2,2,2],"rotation":[0,0,0],"behaviour":["Speed","1.7","",""]},{"assetIdentifier":"moving_block_001","uniqueIdentifier":"5","position":[327.38,577.5,82.24],"scale":[2,2,2],"rotation":[0,0,0],"behaviour":["Speed","1.7","",""]},{"assetIdentifier":"moving_block_001","uniqueIdentifier":"6","position":[184.01,508,20.55],"scale":[2,2,2],"rotation":[0,0,0],"behaviour":["Speed","1.6","",""]},{"assetIdentifier":"moving_block_001","uniqueIdentifier":"7","position":[210.01,542,42.13],"scale":[2,2,2],"rotation":[0,0,0],"behaviour":["Speed","1.6","",""]},{"assetIdentifier":"square_008","uniqueIdentifier":"8","position":[279.88,557.5,38.74],"scale":[7,4,4],"rotation":[0,0,0]},{"assetIdentifier":"pan_001","uniqueIdentifier":"9","position":[316.31,550.01,25.41],"scale":[2.02,2.02,2.02],"rotation":[0,0,0],"behaviour":["Bounce","2","",""]},{"assetIdentifier":"moving_block_001","uniqueIdentifier":"10","position":[310.38,549.5,26.74],"scale":[4,4,4],"rotation":[0,0,0],"behaviour":["Speed","1.5","",""]},{"assetIdentifier":"moving_block_001","uniqueIdentifier":"11","position":[306.38,549.5,26.74],"scale":[4,4,4],"rotation":[0,0,0],"behaviour":["Speed","2.2","",""]},{"assetIdentifier":"moving_block_001","uniqueIdentifier":"12","position":[306.38,549.5,30.74],"scale":[4,4,4],"rotation":[0,0,0],"behaviour":["Speed","2.2","",""]},{"assetIdentifier":"moving_block_001","uniqueIdentifier":"13","position":[302.38,549.5,30.74],"scale":[4,4,4],"rotation":[0,0,0],"behaviour":["Speed","2.2","",""]},{"assetIdentifier":"moving_block_001","uniqueIdentifier":"14","position":[302.38,549.5,34.74],"scale":[4,4,4],"rotation":[0,0,0],"behaviour":["Speed","2.2","",""]},{"assetIdentifier":"moving_block_001","uniqueIdentifier":"15","position":[298.38,549.5,34.74],"scale":[4,4,4],"rotation":[0,0,0],"behaviour":["Speed","2.2","",""]},{"assetIdentifier":"moving_block_001","uniqueIdentifier":"16","position":[294.38,549.5,34.74],"scale":[4,4,4],"rotation":[0,0,0],"behaviour":["Speed","2.2","",""]},{"assetIdentifier":"moving_block_001","uniqueIdentifier":"17","position":[290.38,549.5,34.74],"scale":[4,4,4],"rotation":[0,0,0],"behaviour":["Speed","2.2","",""]},{"assetIdentifier":"moving_block_001","uniqueIdentifier":"18","position":[286.38,549.5,34.74],"scale":[4,4,4],"rotation":[0,0,0],"behaviour":["Speed","2.2","",""]},{"assetIdentifier":"moving_block_001","uniqueIdentifier":"19","position":[282.38,549.5,34.74],"scale":[4,4,4],"rotation":[0,0,0],"behaviour":["Speed","2.2","",""]},{"assetIdentifier":"moving_block_001","uniqueIdentifier":"20","position":[278.38,549.5,34.74],"scale":[4,4,4],"rotation":[0,0,0],"behaviour":["Speed","2.2","",""]},{"assetIdentifier":"moving_block_001","uniqueIdentifier":"21","position":[196.51,534.5,-7.95],"scale":[3,3,3],"rotation":[0,0,0],"behaviour":["Speed","1.42","",""]},{"assetIdentifier":"moving_block_001","uniqueIdentifier":"22","position":[199.51,534.5,-7.95],"scale":[3,3,3],"rotation":[0,0,0],"behaviour":["Speed","1.42","",""]},{"assetIdentifier":"moving_block_001","uniqueIdentifier":"23","position":[202.51,534.5,-7.95],"scale":[3,3,3],"rotation":[0,0,0],"behaviour":["Speed","1.42","",""]},{"assetIdentifier":"moving_block_001","uniqueIdentifier":"24","position":[205.51,534.5,-7.95],"scale":[3,3,3],"rotation":[0,0,0],"behaviour":["Speed","1.42","",""]},{"assetIdentifier":"moving_block_001","uniqueIdentifier":"25","position":[208.51,534.5,-7.95],"scale":[3,3,3],"rotation":[0,0,0],"behaviour":["Speed","1.42","",""]},{"assetIdentifier":"check_point_001","uniqueIdentifier":"checkpoint_41","position":[295.62,664.48,-14.24],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"check_point_001","uniqueIdentifier":"checkpoint_39","position":[338.38,572,80.74],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"check_point_001","uniqueIdentifier":"checkpoint_38","position":[317.71,564,35.24],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"check_point_001","uniqueIdentifier":"checkpoint_37","position":[225.38,545.5,31.99],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"square_001","uniqueIdentifier":"26","position":[340.76,696.5,19.05],"scale":[1.5,2,4],"rotation":[0,0,0]},{"assetIdentifier":"square_001","uniqueIdentifier":"27","position":[335.26,696.5,19.05],"scale":[1.5,2,4],"rotation":[0,0,0]},{"assetIdentifier":"square_001","uniqueIdentifier":"28","position":[338.01,696.5,22.55],"scale":[7,2,3],"rotation":[0,0,0]},{"assetIdentifier":"check_point_001","uniqueIdentifier":"checkpoint_42","position":[338.01,696.5,20.05],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"square_006","uniqueIdentifier":"29","position":[289.76,613.5,-3.7],"scale":[4,4,4.5],"rotation":[0,0,0]},{"assetIdentifier":"square_006","uniqueIdentifier":"30","position":[338.51,692.5,12.3],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"square_006","uniqueIdentifier":"31","position":[339.01,689.5,3.8],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"square_006","uniqueIdentifier":"32","position":[331.01,688,-0.7],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"square_006","uniqueIdentifier":"33","position":[321.01,684.5,0.3],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"square_006","uniqueIdentifier":"34","position":[312.51,680,0.3],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"square_006","uniqueIdentifier":"35","position":[304.01,676,0.3],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"square_006","uniqueIdentifier":"36","position":[295.51,672,0.3],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"square_006","uniqueIdentifier":"37","position":[295.51,668,-7.2],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"square_006","uniqueIdentifier":"38","position":[296.26,659,-24.2],"scale":[8,4,6.5],"rotation":[0,0,0]},{"assetIdentifier":"square_006","uniqueIdentifier":"39","position":[303.51,655,-24.2],"scale":[6.5,4,6.5],"rotation":[0,0,0]},{"assetIdentifier":"square_006","uniqueIdentifier":"40","position":[303.51,651,-15.2],"scale":[6.5,4,11.5],"rotation":[0,0,0]},{"assetIdentifier":"square_006","uniqueIdentifier":"41","position":[303.51,647,-5.95],"scale":[6.5,4,7],"rotation":[0,0,0]},{"assetIdentifier":"square_006","uniqueIdentifier":"42","position":[294.01,643,-5.95],"scale":[12.5,4,7],"rotation":[0,0,0]},{"assetIdentifier":"square_006","uniqueIdentifier":"43","position":[283.76,639,-5.95],"scale":[8,4,7],"rotation":[0,0,0]},{"assetIdentifier":"square_006","uniqueIdentifier":"44","position":[283.76,635,-15.2],"scale":[8,4,11.5],"rotation":[0,0,0]},{"assetIdentifier":"square_006","uniqueIdentifier":"45","position":[283.76,631,-24.45],"scale":[8,4,7],"rotation":[0,0,0]},{"assetIdentifier":"square_006","uniqueIdentifier":"46","position":[303.51,619.5,-15.2],"scale":[6.5,4,11.5],"rotation":[0,0,0]},{"assetIdentifier":"square_006","uniqueIdentifier":"47","position":[294.01,615.5,-13.2],"scale":[12.5,4,7.5],"rotation":[0,0,0]},{"assetIdentifier":"square_006","uniqueIdentifier":"48","position":[289.76,611.5,2.8],"scale":[4,4,4.5],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"49","position":[288.88,589.5,41.24],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"50","position":[292.88,589.5,50.24],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"51","position":[299.38,588.5,55.24],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"52","position":[304.38,584.5,61.24],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"53","position":[299.38,584.5,71.74],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"54","position":[304.38,584.5,82.74],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"55","position":[314.38,580,87.74],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"56","position":[324.38,580,82.74],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"57","position":[334.88,580,87.74],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"square_008","uniqueIdentifier":"58","position":[190.01,508,15.55],"scale":[3,2,8],"rotation":[0,0,0]},{"assetIdentifier":"square_008","uniqueIdentifier":"59","position":[178.01,508,18.05],"scale":[21,2,3],"rotation":[0,0,0]},{"assetIdentifier":"check_point_001","uniqueIdentifier":"checkpoint_40","position":[289.76,611,18.05],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"60","position":[208.51,513,8.55],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"61","position":[208.51,509,8.55],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"square_008","uniqueIdentifier":"62","position":[199.01,508,13.05],"scale":[15,2,3],"rotation":[0,0,0]},{"assetIdentifier":"square_008","uniqueIdentifier":"63","position":[158.01,512,18.05],"scale":[4,6,3],"rotation":[0,0,0]},{"assetIdentifier":"square_008","uniqueIdentifier":"64","position":[158.01,512,26.8],"scale":[4,6,6.5],"rotation":[0,0,0]},{"assetIdentifier":"square_008","uniqueIdentifier":"65","position":[151.76,512,22.05],"scale":[8.5,6,11],"rotation":[0,0,0]},{"assetIdentifier":"check_point_001","uniqueIdentifier":"checkpoint_35","position":[158.01,514,22.55],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"66","position":[357.51,700.5,10.05],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"67","position":[360.01,698.5,16.55],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"68","position":[362.51,698.5,10.05],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"69","position":[357.51,698.5,10.05],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"square_001","uniqueIdentifier":"70","position":[359.51,696.5,14.96],"scale":[8,2,18.18],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"71","position":[358.01,700.5,23.05],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"72","position":[353.01,700.5,23.05],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"73","position":[345.51,700.5,23.05],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"square_001","uniqueIdentifier":"74","position":[349.01,698.5,23.05],"scale":[29,2,2],"rotation":[0,0,0]},{"assetIdentifier":"square_001","uniqueIdentifier":"75","position":[338.01,696.5,16.55],"scale":[7,2,1],"rotation":[0,0,0]},{"assetIdentifier":"square_006","uniqueIdentifier":"76","position":[331.88,697.25,19.74],"scale":[0.2,1.5,2],"rotation":[0,0,0]},{"assetIdentifier":"square_006","uniqueIdentifier":"77","position":[329.88,690.5,20.24],"scale":[0.2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"square_006","uniqueIdentifier":"78","position":[326.88,683.75,20.99],"scale":[0.2,2.5,2.5],"rotation":[0,0,0]},{"assetIdentifier":"square_006","uniqueIdentifier":"79","position":[323.38,676,21.49],"scale":[0.2,3,2.5],"rotation":[0,0,0]},{"assetIdentifier":"square_006","uniqueIdentifier":"80","position":[320.38,667.5,19.74],"scale":[0.2,4,3],"rotation":[0,0,0]},{"assetIdentifier":"square_006","uniqueIdentifier":"81","position":[317.38,658.5,17.74],"scale":[0.2,5,3],"rotation":[0,0,0]},{"assetIdentifier":"square_006","uniqueIdentifier":"82","position":[313.38,649.75,14.74],"scale":[0.2,6.5,3],"rotation":[0,0,0]},{"assetIdentifier":"square_006","uniqueIdentifier":"83","position":[309.88,642.25,12.74],"scale":[0.2,6.5,3],"rotation":[0,0,0]},{"assetIdentifier":"square_006","uniqueIdentifier":"84","position":[305.38,634.75,11.24],"scale":[0.2,6.5,3],"rotation":[0,0,0]},{"assetIdentifier":"square_006","uniqueIdentifier":"85","position":[300.88,626.75,11.24],"scale":[0.2,6.5,3],"rotation":[0,0,0]},{"assetIdentifier":"square_006","uniqueIdentifier":"86","position":[296.38,618.75,11.24],"scale":[0.2,6.5,3],"rotation":[0,0,0]},{"assetIdentifier":"square_006","uniqueIdentifier":"87","position":[289.76,610,20.05],"scale":[4,4,2],"rotation":[0,0,0]},{"assetIdentifier":"square_006","uniqueIdentifier":"88","position":[289.38,603.5,24.74],"scale":[4,4,2],"rotation":[0,0,0]},{"assetIdentifier":"square_006","uniqueIdentifier":"89","position":[289.38,597,30.24],"scale":[4,4,2],"rotation":[0,0,0]},{"assetIdentifier":"square_006","uniqueIdentifier":"90","position":[291.38,590,33.24],"scale":[8,4,8],"rotation":[0,0,0]},{"assetIdentifier":"square_006","uniqueIdentifier":"91","position":[291.38,586,41.24],"scale":[8,4,8],"rotation":[0,0,0]},{"assetIdentifier":"square_006","uniqueIdentifier":"92","position":[291.38,586,52.74],"scale":[8,4,8],"rotation":[0,0,0]},{"assetIdentifier":"square_006","uniqueIdentifier":"93","position":[301.88,585,52.74],"scale":[8,4,8],"rotation":[0,0,0]},{"assetIdentifier":"square_006","uniqueIdentifier":"94","position":[301.88,581,63.74],"scale":[8,4,8],"rotation":[0,0,0]},{"assetIdentifier":"square_006","uniqueIdentifier":"95","position":[301.88,581,74.24],"scale":[8,4,8],"rotation":[0,0,0]},{"assetIdentifier":"square_006","uniqueIdentifier":"96","position":[301.88,581,85.24],"scale":[8,4,8],"rotation":[0,0,0]},{"assetIdentifier":"square_006","uniqueIdentifier":"97","position":[311.88,576.5,85.24],"scale":[8,4,8],"rotation":[0,0,0]},{"assetIdentifier":"square_006","uniqueIdentifier":"98","position":[321.88,576.5,85.24],"scale":[8,4,8],"rotation":[0,0,0]},{"assetIdentifier":"square_006","uniqueIdentifier":"99","position":[332.38,576.5,85.24],"scale":[8,4,8],"rotation":[0,0,0]},{"assetIdentifier":"square_008","uniqueIdentifier":"100","position":[336.38,568.5,75.24],"scale":[8,4,4],"rotation":[0,0,0]},{"assetIdentifier":"square_008","uniqueIdentifier":"101","position":[340.38,568.5,71.24],"scale":[8,4,4],"rotation":[0,0,0]},{"assetIdentifier":"square_008","uniqueIdentifier":"102","position":[338.38,572.5,67.24],"scale":[4,4,12],"rotation":[0,0,0]},{"assetIdentifier":"square_008","uniqueIdentifier":"103","position":[340.38,568.5,63.24],"scale":[8,4,4],"rotation":[0,0,0]},{"assetIdentifier":"square_008","uniqueIdentifier":"104","position":[338.38,564.5,59.24],"scale":[12,4,4],"rotation":[0,0,0]},{"assetIdentifier":"square_008","uniqueIdentifier":"105","position":[338.38,568.5,55.24],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"square_008","uniqueIdentifier":"106","position":[334.38,568.5,51.24],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"square_008","uniqueIdentifier":"107","position":[338.38,564.5,51.24],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"square_008","uniqueIdentifier":"108","position":[342.38,564.5,47.24],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"square_008","uniqueIdentifier":"109","position":[338.38,564.5,43.24],"scale":[12,4,4],"rotation":[0,0,0]},{"assetIdentifier":"square_008","uniqueIdentifier":"110","position":[334.38,568.5,39.24],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"square_008","uniqueIdentifier":"111","position":[342.38,568.5,39.24],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"square_008","uniqueIdentifier":"112","position":[338.38,568.5,27.24],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"square_008","uniqueIdentifier":"113","position":[338.38,564.5,33.24],"scale":[4,4,8],"rotation":[0,0,0]},{"assetIdentifier":"square_008","uniqueIdentifier":"114","position":[334.38,564.5,29.24],"scale":[4,4,8],"rotation":[0,0,0]},{"assetIdentifier":"square_008","uniqueIdentifier":"115","position":[330.38,568.5,25.49],"scale":[4,4,7.5],"rotation":[0,0,0]},{"assetIdentifier":"square_008","uniqueIdentifier":"116","position":[326.38,564.5,28.99],"scale":[4,4,7.5],"rotation":[0,0,0]},{"assetIdentifier":"square_008","uniqueIdentifier":"117","position":[308.38,561.5,35.99],"scale":[4,4,7.5],"rotation":[0,0,0]},{"assetIdentifier":"square_008","uniqueIdentifier":"118","position":[298.88,561.5,34.74],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"square_008","uniqueIdentifier":"119","position":[289.88,561.5,34.74],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"square_008","uniqueIdentifier":"120","position":[281.38,561.5,34.74],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"square_008","uniqueIdentifier":"121","position":[281.38,557.5,26.74],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"square_008","uniqueIdentifier":"122","position":[279.88,557.5,30.74],"scale":[7,4,4],"rotation":[0,0,0]},{"assetIdentifier":"square_008","uniqueIdentifier":"123","position":[274.38,557.5,30.74],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"square_008","uniqueIdentifier":"124","position":[270.38,557.5,26.74],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"square_008","uniqueIdentifier":"125","position":[274.38,549.5,32.74],"scale":[4,4,8],"rotation":[0,0,0]},{"assetIdentifier":"square_008","uniqueIdentifier":"126","position":[270.38,553.5,30.74],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"square_008","uniqueIdentifier":"127","position":[266.38,549.5,32.74],"scale":[4,4,8],"rotation":[0,0,0]},{"assetIdentifier":"square_008","uniqueIdentifier":"128","position":[262.38,549.5,34.74],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"square_008","uniqueIdentifier":"129","position":[262.38,549.5,26.74],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"square_008","uniqueIdentifier":"130","position":[258.38,549.5,30.74],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"square_008","uniqueIdentifier":"131","position":[254.38,549.5,34.74],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"square_008","uniqueIdentifier":"132","position":[254.38,545.5,32.74],"scale":[4,4,8],"rotation":[0,0,0]},{"assetIdentifier":"square_008","uniqueIdentifier":"133","position":[250.38,545.5,26.74],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"square_008","uniqueIdentifier":"134","position":[246.38,545.5,26.74],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"square_008","uniqueIdentifier":"135","position":[242.38,545.5,26.74],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"square_008","uniqueIdentifier":"136","position":[242.38,549.5,26.74],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"square_008","uniqueIdentifier":"137","position":[238.38,549.5,26.74],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"square_008","uniqueIdentifier":"138","position":[238.38,549.5,34.74],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"square_008","uniqueIdentifier":"139","position":[234.38,549.5,32.74],"scale":[4,4,8],"rotation":[0,0,0]},{"assetIdentifier":"square_008","uniqueIdentifier":"140","position":[234.38,545.5,26.74],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"square_008","uniqueIdentifier":"141","position":[225.38,543,43.24],"scale":[6,2,10.5],"rotation":[0,0,0]},{"assetIdentifier":"square_008","uniqueIdentifier":"142","position":[216.51,543,52.38],"scale":[6,2,4.5],"rotation":[0,0,0]},{"assetIdentifier":"square_008","uniqueIdentifier":"143","position":[208.01,542,45.13],"scale":[6,2,4],"rotation":[0,0,0]},{"assetIdentifier":"square_008","uniqueIdentifier":"144","position":[196.51,542,38.13],"scale":[6,2,4],"rotation":[0,0,0]},{"assetIdentifier":"square_008","uniqueIdentifier":"145","position":[194.01,540.5,28.05],"scale":[6,2,4],"rotation":[0,0,0]},{"assetIdentifier":"square_008","uniqueIdentifier":"146","position":[191.51,539.5,18.05],"scale":[6,2,4],"rotation":[0,0,0]},{"assetIdentifier":"square_008","uniqueIdentifier":"147","position":[191.51,538.5,7.55],"scale":[6,2,4],"rotation":[0,0,0]},{"assetIdentifier":"square_008","uniqueIdentifier":"148","position":[191.51,537,-1.95],"scale":[6,2,4],"rotation":[0,0,0]},{"assetIdentifier":"square_008","uniqueIdentifier":"149","position":[202.51,535,-10.95],"scale":[28,2,3],"rotation":[0,0,0]},{"assetIdentifier":"square_008","uniqueIdentifier":"150","position":[213.51,532,-4.45],"scale":[6,2,3],"rotation":[0,0,0]},{"assetIdentifier":"square_008","uniqueIdentifier":"151","position":[213.51,528.5,2.05],"scale":[6,2,3],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"152","position":[205.51,526,17.55],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"153","position":[203.51,526,17.55],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"154","position":[201.51,526,17.55],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"155","position":[199.51,526,17.55],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"156","position":[197.51,526,17.55],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"157","position":[195.51,526,17.55],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"158","position":[193.51,526,17.55],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"159","position":[193.51,507,18.55],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"160","position":[193.51,511,18.55],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"161","position":[193.51,515,18.55],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"162","position":[193.51,519,18.55],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"square_008","uniqueIdentifier":"163","position":[213.51,508,13.05],"scale":[6,2,3],"rotation":[0,0,0]},{"assetIdentifier":"square_008","uniqueIdentifier":"164","position":[218.26,508,14.05],"scale":[3.5,2,5],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"165","position":[217.51,518,15.55],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"166","position":[217.51,526,15.55],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"167","position":[217.51,526,17.55],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"square_008","uniqueIdentifier":"168","position":[207.76,508,18.3],"scale":[24.5,2,3.5],"rotation":[0,0,0]},{"assetIdentifier":"square_008","uniqueIdentifier":"169","position":[213.51,526,9.05],"scale":[6,2,3],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"170","position":[215.51,526,17.55],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"171","position":[213.51,526,17.55],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"172","position":[211.51,526,17.55],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"173","position":[209.51,526,17.55],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"174","position":[208.51,529,24.55],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"175","position":[208.51,529,20.55],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"176","position":[208.51,529,16.55],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"177","position":[208.51,529,12.55],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"178","position":[208.51,525,12.55],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"179","position":[208.51,521,12.55],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"180","position":[208.51,517,12.55],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"181","position":[208.51,513,12.55],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"182","position":[208.51,509,12.55],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"183","position":[207.51,526,25.55],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"square_008","uniqueIdentifier":"184","position":[203.51,526,25.05],"scale":[6,2,3],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"185","position":[167.51,510,12.55],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"186","position":[167.51,518,12.55],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"187","position":[167.51,514,12.55],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"188","position":[167.51,508,15.55],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"189","position":[167.51,510,15.55],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"190","position":[167.51,512,15.55],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"191","position":[193.51,523,18.55],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"square_008","uniqueIdentifier":"192","position":[204.01,517,15.55],"scale":[25,20,2],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"193","position":[207.51,526,17.55],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"194","position":[191.51,526,17.55],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"195","position":[189.51,526,17.55],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"196","position":[187.51,526,17.55],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"197","position":[185.51,526,17.55],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"198","position":[183.51,526,17.55],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"199","position":[181.51,526,17.55],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"200","position":[179.51,526,17.55],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"201","position":[177.51,526,17.55],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"202","position":[175.51,526,17.55],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"203","position":[173.51,526,17.55],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"204","position":[171.51,526,17.55],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"205","position":[169.51,526,17.55],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"206","position":[167.51,526,17.55],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"207","position":[167.51,526,15.55],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"208","position":[167.51,524,15.55],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"209","position":[167.51,522,15.55],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"210","position":[167.51,520,15.55],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"211","position":[167.51,518,15.55],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"212","position":[167.51,516,15.55],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"square_008","uniqueIdentifier":"213","position":[178.51,517,15.55],"scale":[20,20,2],"rotation":[0,0,0]},{"assetIdentifier":"square_008","uniqueIdentifier":"214","position":[164.26,512,22.05],"scale":[8.5,6,11],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"215","position":[167.51,514,15.55],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"square_006","uniqueIdentifier":"216","position":[338.38,572.5,85.74],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"square_001","uniqueIdentifier":"217","position":[289.76,611,11.3],"scale":[7,2,7.5],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"218","position":[335.51,700.5,23.05],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"check_point_001","uniqueIdentifier":"checkpoint_67","position":[77.09,1400.8,383.14],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"square_006","uniqueIdentifier":"219","position":[-34.17,1315.28,122.8],"scale":[3,4,3],"rotation":[0,0,0]},{"assetIdentifier":"moving_block_001","uniqueIdentifier":"220","position":[76.64,1399.44,357.14],"scale":[4,4,4],"rotation":[0,0,0],"behaviour":["Speed","2","",""]},{"assetIdentifier":"moving_block_001","uniqueIdentifier":"221","position":[76.64,1399.44,353.14],"scale":[4,4,4],"rotation":[0,0,0],"behaviour":["Speed","2","",""]},{"assetIdentifier":"pan_004","uniqueIdentifier":"222","position":[74.89,1395.62,327.45],"scale":[2.8,2.8,2.8],"rotation":[0,0,0],"behaviour":["Bounce","3","",""]},{"assetIdentifier":"pan_004","uniqueIdentifier":"223","position":[74.89,1377.62,300.14],"scale":[2.8,2.8,2.8],"rotation":[0,0,0],"behaviour":["Bounce","3","",""]},{"assetIdentifier":"pan_004","uniqueIdentifier":"224","position":[-20.96,1318.55,89.45],"scale":[1.48,1.48,1.48],"rotation":[0,0,0],"behaviour":["Bounce","2.2","",""]},{"assetIdentifier":"moving_block_001","uniqueIdentifier":"225","position":[-21.4,1317.78,72.97],"scale":[4,4,4],"rotation":[0,0,0],"behaviour":["Speed","1.8","",""]},{"assetIdentifier":"toaster_002","uniqueIdentifier":"226","position":[52.39,1429.13,491.14],"scale":[24,24,24],"rotation":[0,0,0]},{"assetIdentifier":"square_006","uniqueIdentifier":"227","position":[52.53,1413.28,493.96],"scale":[47,2,68.5],"rotation":[0,0,0]},{"assetIdentifier":"invisible_square_001","uniqueIdentifier":"228","position":[48.53,1413.78,444.71],"scale":[8,1,24],"rotation":[0,0,0]},{"assetIdentifier":"invisible_square_001","uniqueIdentifier":"229","position":[62.78,1413.78,428.96],"scale":[36.5,1,7.5],"rotation":[0,0,0]},{"assetIdentifier":"toaster_003","uniqueIdentifier":"230","position":[58.37,1402.4,411.63],"scale":[1,1,1],"rotation":[0,0,0]},{"assetIdentifier":"tissue_box_003","uniqueIdentifier":"231","position":[100.13,1403.78,393.85],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"square_008","uniqueIdentifier":"232","position":[47.71,1415.3,417.15],"scale":[2,2,2],"rotation":[5.3,2.88,3.57]},{"assetIdentifier":"square_007","uniqueIdentifier":"233","position":[-11.17,1331.78,220.3],"scale":[3,6,7],"rotation":[0,0,0]},{"assetIdentifier":"square_007","uniqueIdentifier":"234","position":[-18.67,1326.03,220.3],"scale":[3,15.5,7],"rotation":[0,0,0]},{"assetIdentifier":"square_007","uniqueIdentifier":"235","position":[-33.67,1326.03,220.3],"scale":[3,15.5,7],"rotation":[0,0,0]},{"assetIdentifier":"square_007","uniqueIdentifier":"236","position":[-33.67,1323.78,211.55],"scale":[3,3,10.5],"rotation":[0,0,0]},{"assetIdentifier":"square_007","uniqueIdentifier":"237","position":[-41.17,1322.78,201.55],"scale":[3,3,10.5],"rotation":[0,0,0]},{"assetIdentifier":"square_007","uniqueIdentifier":"238","position":[-34.17,1321.78,190.55],"scale":[3,3,10.5],"rotation":[0,0,0]},{"assetIdentifier":"square_007","uniqueIdentifier":"239","position":[-41.17,1320.28,180.05],"scale":[3,3,10.5],"rotation":[0,0,0]},{"assetIdentifier":"square_006","uniqueIdentifier":"240","position":[74.78,1413.28,415.46],"scale":[12.5,2,12.5],"rotation":[0,0,0]},{"assetIdentifier":"square_006","uniqueIdentifier":"241","position":[113.11,1425.6,416.25],"scale":[4.33,4.33,4.33],"rotation":[5.75,4.12,0.7]},{"assetIdentifier":"square_006","uniqueIdentifier":"242","position":[32.33,1374.28,282.8],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"square_006","uniqueIdentifier":"243","position":[24.83,1374.28,280.8],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"square_006","uniqueIdentifier":"244","position":[14.33,1371.78,282.8],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"square_006","uniqueIdentifier":"245","position":[10.83,1370.28,289.3],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"square_006","uniqueIdentifier":"246","position":[4.33,1368.78,289.3],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"square_006","uniqueIdentifier":"247","position":[-1.17,1367.78,283.8],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"square_006","uniqueIdentifier":"248","position":[-3.17,1366.78,277.8],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"square_006","uniqueIdentifier":"249","position":[1.33,1365.28,273.3],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"square_006","uniqueIdentifier":"250","position":[7.83,1355.28,273.3],"scale":[3,23,3],"rotation":[0,0,0]},{"assetIdentifier":"square_006","uniqueIdentifier":"251","position":[10.83,1344.78,273.3],"scale":[3,2,3],"rotation":[0,0,0]},{"assetIdentifier":"square_006","uniqueIdentifier":"252","position":[15.83,1344.78,267.8],"scale":[3,2,3],"rotation":[0,0,0]},{"assetIdentifier":"square_006","uniqueIdentifier":"253","position":[20.83,1344.78,261.3],"scale":[3,2,3],"rotation":[0,0,0]},{"assetIdentifier":"square_006","uniqueIdentifier":"254","position":[-6.17,1334.78,223.8],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"square_006","uniqueIdentifier":"255","position":[18.83,1374.03,272.8],"scale":[3,2.5,12],"rotation":[0,0,0]},{"assetIdentifier":"square_006","uniqueIdentifier":"256","position":[23.83,1373.28,262.8],"scale":[3,16,3],"rotation":[0,0,0]},{"assetIdentifier":"square_006","uniqueIdentifier":"257","position":[16.33,1366.28,258.8],"scale":[3,20,3],"rotation":[0,0,0]},{"assetIdentifier":"square_006","uniqueIdentifier":"258","position":[23.83,1353.78,254.8],"scale":[3,20,3],"rotation":[0,0,0]},{"assetIdentifier":"square_006","uniqueIdentifier":"259","position":[12.83,1339.28,254.8],"scale":[3,13,3],"rotation":[0,0,0]},{"assetIdentifier":"square_006","uniqueIdentifier":"260","position":[12.83,1334.28,248.05],"scale":[3,3,10.5],"rotation":[0,0,0]},{"assetIdentifier":"square_006","uniqueIdentifier":"261","position":[7.83,1334.78,239.3],"scale":[1,1,1],"rotation":[0,0,0]},{"assetIdentifier":"square_006","uniqueIdentifier":"262","position":[3.33,1334.78,235.8],"scale":[1,1,1],"rotation":[0,0,0]},{"assetIdentifier":"square_006","uniqueIdentifier":"263","position":[0.83,1334.78,231.3],"scale":[1,1,1],"rotation":[0,0,0]},{"assetIdentifier":"square_006","uniqueIdentifier":"264","position":[-2.67,1334.78,227.8],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"square_006","uniqueIdentifier":"265","position":[-37.42,1315.28,127.55],"scale":[9.5,4,6.5],"rotation":[0,0,0]},{"assetIdentifier":"square_006","uniqueIdentifier":"266","position":[-37.42,1315.28,113.55],"scale":[8.5,4,6.5],"rotation":[0,0,0]},{"assetIdentifier":"square_006","uniqueIdentifier":"267","position":[-16.67,1315.28,14.05],"scale":[13,2,0.25],"rotation":[0,0,0]},{"assetIdentifier":"square_006","uniqueIdentifier":"268","position":[-7.67,1315.28,14.8],"scale":[5,2,4],"rotation":[0,0,0]},{"assetIdentifier":"square_006","uniqueIdentifier":"269","position":[-37.67,1315.28,79.55],"scale":[4,4,48.5],"rotation":[0,0,0]},{"assetIdentifier":"square_006","uniqueIdentifier":"270","position":[-37.17,1315.28,48.8],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"square_006","uniqueIdentifier":"271","position":[-37.17,1315.28,30.8],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"square_006","uniqueIdentifier":"272","position":[-25.67,1315.28,14.8],"scale":[5,2,4],"rotation":[0,0,0]},{"assetIdentifier":"square_006","uniqueIdentifier":"273","position":[-37.17,1315.28,23.3],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"square_006","uniqueIdentifier":"274","position":[-37.17,1315.28,39.8],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"square_006","uniqueIdentifier":"275","position":[-33.17,1315.28,14.8],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"square_003","uniqueIdentifier":"276","position":[73.4,1415.99,451.71],"scale":[3.89,3.89,3.89],"rotation":[0.31,6.18,0.6]},{"assetIdentifier":"square_002","uniqueIdentifier":"277","position":[-36.17,1322.78,220.3],"scale":[2,2,7],"rotation":[0,0,0]},{"assetIdentifier":"square_002","uniqueIdentifier":"278","position":[-37.67,1317.28,170.8],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"square_002","uniqueIdentifier":"279","position":[-43.67,1317.28,162.8],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"square_002","uniqueIdentifier":"280","position":[-31.67,1317.28,162.8],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"square_002","uniqueIdentifier":"281","position":[-37.67,1317.28,154.8],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"square_002","uniqueIdentifier":"282","position":[-43.67,1317.28,147.3],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"square_002","uniqueIdentifier":"283","position":[-31.67,1317.28,147.3],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"square_002","uniqueIdentifier":"284","position":[-37.67,1317.28,138.8],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"square_001","uniqueIdentifier":"285","position":[106.38,1409.8,451.95],"scale":[6.74,6.74,6.74],"rotation":[5.83,5.97,0.63]},{"assetIdentifier":"square_001","uniqueIdentifier":"286","position":[73.03,1404.28,386.71],"scale":[2,5,2],"rotation":[0,0,0]},{"assetIdentifier":"square_001","uniqueIdentifier":"287","position":[78.78,1415.03,413.71],"scale":[2.5,1.5,3],"rotation":[0,0,0]},{"assetIdentifier":"square_001","uniqueIdentifier":"288","position":[70.53,1411.53,399.46],"scale":[2,1.5,11.5],"rotation":[0,0,3.14]},{"assetIdentifier":"square_001","uniqueIdentifier":"289","position":[77.53,1406.28,394.71],"scale":[2,9,2],"rotation":[0,0,0]},{"assetIdentifier":"square_001","uniqueIdentifier":"290","position":[83.53,1405.53,394.71],"scale":[2,7.5,2],"rotation":[0,0,0]},{"assetIdentifier":"square_001","uniqueIdentifier":"291","position":[82.28,1398.78,398.16],"scale":[52,6,37.37],"rotation":[0,0,0]},{"assetIdentifier":"square_001","uniqueIdentifier":"292","position":[77.28,1398.78,376.47],"scale":[10,6,6],"rotation":[0,0,0]},{"assetIdentifier":"slow_block_001","uniqueIdentifier":"293","position":[47.33,1374.28,286.3],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"slow_block_001","uniqueIdentifier":"294","position":[67.83,1377.28,291.3],"scale":[1.5,1.5,1.5],"rotation":[0,0,0]},{"assetIdentifier":"slow_block_001","uniqueIdentifier":"295","position":[61.83,1376.28,288.3],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"slow_block_001","uniqueIdentifier":"296","position":[54.83,1375.28,286.3],"scale":[2.5,2.5,2.5],"rotation":[0,0,0]},{"assetIdentifier":"slow_block_001","uniqueIdentifier":"297","position":[-49.34,1318.28,60.2],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"slow_block_001","uniqueIdentifier":"298","position":[-49.34,1319.28,79.7],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"slow_block_001","uniqueIdentifier":"299","position":[-31.34,1318.28,79.7],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"slow_block_001","uniqueIdentifier":"300","position":[-29.48,1318.28,55.53],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"slippery_block_001","uniqueIdentifier":"301","position":[-20.19,1319.28,79.28],"scale":[4,4,4],"rotation":[0,0,0],"behaviour":["Speed","0.64","",""]},{"assetIdentifier":"slippery_block_001","uniqueIdentifier":"302","position":[-41.69,1319.28,94.78],"scale":[4,4,4],"rotation":[0,0,0],"behaviour":["Speed","0.64","",""]},{"assetIdentifier":"salt","uniqueIdentifier":"303","position":[71.7,1414.46,418.03],"scale":[1,1,1],"rotation":[0,0,0]},{"assetIdentifier":"salt","uniqueIdentifier":"304","position":[63.81,1402.13,404.76],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"rolling_pin","uniqueIdentifier":"305","position":[58.35,1402.21,399.65],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"pot_004","uniqueIdentifier":"306","position":[93.75,1402.41,392.87],"scale":[1,1,1],"rotation":[0,0,0]},{"assetIdentifier":"plate_004","uniqueIdentifier":"307","position":[84.5,1401.93,402.86],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"plate_002","uniqueIdentifier":"308","position":[79.23,1401.93,406.18],"scale":[1,1,1],"rotation":[0,0,0]},{"assetIdentifier":"plate_001","uniqueIdentifier":"309","position":[97.38,1401.93,384.02],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"pepper","uniqueIdentifier":"310","position":[71.32,1414.46,418.48],"scale":[1,1,1],"rotation":[0,0,0]},{"assetIdentifier":"moving_block_001","uniqueIdentifier":"311","position":[-21.4,1317.78,60.47],"scale":[4,4,4],"rotation":[0,0,0],"behaviour":["Speed","1.36","",""]},{"assetIdentifier":"finish_line_001","uniqueIdentifier":"312","position":[76.89,1405.69,377.23],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"313","position":[4.83,1366.78,273.3],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"314","position":[7.33,1370.28,289.3],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"315","position":[23.83,1365.28,254.8],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"316","position":[16.33,1377.78,258.8],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"317","position":[-27.67,1329.78,215.3],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"318","position":[-27.67,1326.78,215.3],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"319","position":[-30.67,1329.78,215.3],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"320","position":[-30.67,1326.78,215.3],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"321","position":[-33.67,1326.78,215.3],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"322","position":[-33.67,1329.78,215.3],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"323","position":[-60.57,1317.78,73.79],"scale":[1,1,1],"rotation":[0,0,0]},{"assetIdentifier":"cutting_board","uniqueIdentifier":"324","position":[73.94,1414.36,418.27],"scale":[1,1,1],"rotation":[0,0,0]},{"assetIdentifier":"check_point_001","uniqueIdentifier":"checkpoint_65","position":[20.33,1344.78,255.8],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"check_point_001","uniqueIdentifier":"checkpoint_66","position":[39.83,1374.78,286.8],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"check_point_001","uniqueIdentifier":"checkpoint_64","position":[-26.17,1332.78,221.3],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"bowl_004","uniqueIdentifier":"325","position":[90.93,1402.14,410.85],"scale":[1,1,1],"rotation":[0,0,0]},{"assetIdentifier":"bowl_001","uniqueIdentifier":"326","position":[61.29,1402.48,387.55],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"bowl_001","uniqueIdentifier":"327","position":[61.29,1402.48,391.55],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"bowl_001","uniqueIdentifier":"328","position":[64.79,1402.48,391.55],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"bowl_001","uniqueIdentifier":"329","position":[64.79,1402.48,387.55],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"baking_tray_001","uniqueIdentifier":"330","position":[102.6,1401.86,411.97],"scale":[1,1,1],"rotation":[0,0,0]},{"assetIdentifier":"baking_pan_004","uniqueIdentifier":"331","position":[71.65,1402.6,400.93],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"moving_block_001","uniqueIdentifier":"332","position":[383.92,926.01,249.75],"scale":[2,2,2],"rotation":[0,0,0],"behaviour":["Speed","3.5","",""]},{"assetIdentifier":"moving_block_001","uniqueIdentifier":"333","position":[397.22,925.77,239.75],"scale":[2,2,2],"rotation":[0,0,0],"behaviour":["Speed","1.75","",""]},{"assetIdentifier":"moving_block_001","uniqueIdentifier":"334","position":[413.54,926.21,239.75],"scale":[2,2,2],"rotation":[0,0,0],"behaviour":["Speed","1.75","",""]},{"assetIdentifier":"moving_block_001","uniqueIdentifier":"335","position":[407.58,944.28,335.8],"scale":[4,4,4],"rotation":[0,0,0],"behaviour":["Speed","1.9","",""]},{"assetIdentifier":"slippery_block_001","uniqueIdentifier":"336","position":[395.83,943.78,345.05],"scale":[4,4,4],"rotation":[0,0,0],"behaviour":["Speed","0.64","",""]},{"assetIdentifier":"slippery_block_001","uniqueIdentifier":"337","position":[405.33,939.78,313.3],"scale":[4,4,4],"rotation":[0,0,0],"behaviour":["Speed","0.64","",""]},{"assetIdentifier":"slippery_block_001","uniqueIdentifier":"338","position":[394.33,939.78,305.3],"scale":[4,4,4],"rotation":[0,0,0],"behaviour":["Speed","0.64","",""]},{"assetIdentifier":"moving_block_001","uniqueIdentifier":"339","position":[390.83,931.78,290.8],"scale":[4,4,4],"rotation":[0,0,0],"behaviour":["Speed","1.9","",""]},{"assetIdentifier":"pan_001","uniqueIdentifier":"340","position":[371.02,931.92,269.14],"scale":[3.28,3.28,3.28],"rotation":[0,0,0],"behaviour":["Bounce","2.95","",""]},{"assetIdentifier":"moving_block_001","uniqueIdentifier":"341","position":[434.26,887,205.8],"scale":[4,4,4],"rotation":[0,0,0],"behaviour":["Speed","2","",""]},{"assetIdentifier":"moving_block_001","uniqueIdentifier":"342","position":[442.26,885.5,189.8],"scale":[4,4,4],"rotation":[0,0,0],"behaviour":["Speed","2","",""]},{"assetIdentifier":"moving_block_001","uniqueIdentifier":"343","position":[455.76,883,170.3],"scale":[4,4,4],"rotation":[0,0,0],"behaviour":["Speed","2","",""]},{"assetIdentifier":"moving_block_001","uniqueIdentifier":"344","position":[465.51,881,136.8],"scale":[4,4,4],"rotation":[0,0,0],"behaviour":["Speed","2","",""]},{"assetIdentifier":"moving_block_001","uniqueIdentifier":"345","position":[463.19,890.5,113.42],"scale":[4,4,4],"rotation":[0,0,0],"behaviour":["Speed","2","",""]},{"assetIdentifier":"slow_block_001","uniqueIdentifier":"346","position":[454.69,890.75,109.42],"scale":[4,0.5,4],"rotation":[0,0,0]},{"assetIdentifier":"slow_block_001","uniqueIdentifier":"347","position":[454.69,879.75,109.42],"scale":[4,0.5,4],"rotation":[0,0,0]},{"assetIdentifier":"slow_block_001","uniqueIdentifier":"348","position":[454.69,868.25,109.42],"scale":[4,0.5,4],"rotation":[0,0,0]},{"assetIdentifier":"slow_block_001","uniqueIdentifier":"349","position":[454.69,856.75,109.42],"scale":[4,0.5,4],"rotation":[0,0,0]},{"assetIdentifier":"slow_block_001","uniqueIdentifier":"350","position":[454.69,845.75,109.42],"scale":[4,0.5,4],"rotation":[0,0,0]},{"assetIdentifier":"check_point_001","uniqueIdentifier":"checkpoint_52","position":[391.83,995.28,362.3],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"check_point_001","uniqueIdentifier":"checkpoint_50","position":[348.33,932.78,269.8],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"check_point_001","uniqueIdentifier":"checkpoint_48","position":[454.51,882,118.3],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"check_point_001","uniqueIdentifier":"checkpoint_49","position":[431.76,894.5,242.3],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"square_007","uniqueIdentifier":"351","position":[448.53,833,109.96],"scale":[8.5,4,4],"rotation":[0,0,0]},{"assetIdentifier":"square_007","uniqueIdentifier":"352","position":[459.03,833,109.96],"scale":[4.5,4,4],"rotation":[0,0,0]},{"assetIdentifier":"square_007","uniqueIdentifier":"353","position":[452.78,833,114.96],"scale":[17,4,6],"rotation":[0,0,0]},{"assetIdentifier":"square_001","uniqueIdentifier":"354","position":[399.58,980.78,378.55],"scale":[6.5,22,8.5],"rotation":[0,0,0]},{"assetIdentifier":"check_point_001","uniqueIdentifier":"checkpoint_51","position":[396.33,944.78,358.8],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"square_006","uniqueIdentifier":"355","position":[385.83,1016.28,385.3],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"square_006","uniqueIdentifier":"356","position":[378.33,1014.28,377.8],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"square_006","uniqueIdentifier":"357","position":[385.83,1010.78,371.8],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"square_006","uniqueIdentifier":"358","position":[386.33,1003.28,382.3],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"square_006","uniqueIdentifier":"359","position":[380.33,998.78,374.8],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"slippery_block_001","uniqueIdentifier":"360","position":[454.69,888.5,109.42],"scale":[4,4,4],"rotation":[0,0,3.14],"behaviour":["Speed","0.64","",""]},{"assetIdentifier":"check_point_001","uniqueIdentifier":"checkpoint_47","position":[454.78,834,110.96],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"square_006","uniqueIdentifier":"361","position":[393.33,1018.28,383.8],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"square_006","uniqueIdentifier":"362","position":[378.33,1015.28,385.3],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"square_006","uniqueIdentifier":"363","position":[378.33,1014.28,370.3],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"square_006","uniqueIdentifier":"364","position":[395.33,1008.28,371.8],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"square_006","uniqueIdentifier":"365","position":[395.33,1004.28,379.8],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"square_006","uniqueIdentifier":"366","position":[377.83,1001.28,382.3],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"square_006","uniqueIdentifier":"367","position":[386.83,996.78,369.3],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"square_001","uniqueIdentifier":"368","position":[390.08,969.78,366.3],"scale":[8.5,4,4],"rotation":[0,0,0]},{"assetIdentifier":"square_001","uniqueIdentifier":"369","position":[399.58,971.78,370.05],"scale":[6.5,4,8.5],"rotation":[0,0,0]},{"assetIdentifier":"square_001","uniqueIdentifier":"370","position":[400.83,959.78,381.3],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"square_001","uniqueIdentifier":"371","position":[394.33,962.28,381.3],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"square_001","uniqueIdentifier":"372","position":[406.83,955.78,378.8],"scale":[4,4,9],"rotation":[0,0,0]},{"assetIdentifier":"square_001","uniqueIdentifier":"373","position":[388.33,966.28,374.3],"scale":[4,4,9],"rotation":[0,0,0]},{"assetIdentifier":"square_001","uniqueIdentifier":"374","position":[396.83,955.78,374.8],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"square_001","uniqueIdentifier":"375","position":[401.83,949.78,375.3],"scale":[14,8,16],"rotation":[0,0,0]},{"assetIdentifier":"square_001","uniqueIdentifier":"376","position":[396.08,941.78,371.55],"scale":[25.5,8,23.5],"rotation":[0,0,0]},{"assetIdentifier":"square_001","uniqueIdentifier":"377","position":[396.83,941.78,351.55],"scale":[8,8,8.5],"rotation":[0,0,0]},{"assetIdentifier":"square_001","uniqueIdentifier":"378","position":[396.33,941.78,337.05],"scale":[8,8,11.5],"rotation":[0,0,0]},{"assetIdentifier":"square_001","uniqueIdentifier":"379","position":[396.33,941.78,323.55],"scale":[8,8,8.5],"rotation":[0,0,0]},{"assetIdentifier":"square_001","uniqueIdentifier":"380","position":[407.08,941.78,325.8],"scale":[8,8,4],"rotation":[0,0,0]},{"assetIdentifier":"square_001","uniqueIdentifier":"381","position":[407.08,939.78,317.3],"scale":[8,4,4],"rotation":[0,0,0]},{"assetIdentifier":"square_001","uniqueIdentifier":"382","position":[409.33,939.78,317.3],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"square_001","uniqueIdentifier":"383","position":[409.33,939.78,313.3],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"square_001","uniqueIdentifier":"384","position":[394.33,939.78,315.3],"scale":[4,4,8],"rotation":[0,0,0]},{"assetIdentifier":"square_001","uniqueIdentifier":"385","position":[394.33,935.78,307.3],"scale":[4,4,8],"rotation":[0,0,0]},{"assetIdentifier":"square_004","uniqueIdentifier":"386","position":[394.33,939.78,301.3],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"square_004","uniqueIdentifier":"387","position":[409.33,939.78,301.3],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"square_004","uniqueIdentifier":"388","position":[409.33,935.78,301.3],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"square_004","uniqueIdentifier":"389","position":[409.33,935.78,297.3],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"square_004","uniqueIdentifier":"390","position":[405.33,935.78,297.3],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"square_004","uniqueIdentifier":"391","position":[394.83,935.78,290.8],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"square_004","uniqueIdentifier":"392","position":[398.83,931.78,290.8],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"square_004","uniqueIdentifier":"393","position":[394.83,931.78,290.8],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"square_004","uniqueIdentifier":"394","position":[394.83,931.78,281.8],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"square_004","uniqueIdentifier":"395","position":[408.83,931.78,281.8],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"square_004","uniqueIdentifier":"396","position":[404.83,931.78,281.8],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"square_004","uniqueIdentifier":"397","position":[404.83,931.78,271.3],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"square_004","uniqueIdentifier":"398","position":[404.83,931.78,267.3],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"square_004","uniqueIdentifier":"399","position":[394.83,931.78,267.3],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"square_004","uniqueIdentifier":"400","position":[383.33,931.78,271.8],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"square_004","uniqueIdentifier":"401","position":[359.33,931.78,268.8],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"slow_block_001","uniqueIdentifier":"402","position":[431.76,917.5,245.3],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"pepper","uniqueIdentifier":"403","position":[339.01,931.73,268.6],"scale":[6,6,6],"rotation":[0,0,0]},{"assetIdentifier":"pepper","uniqueIdentifier":"404","position":[335.01,929.73,263.1],"scale":[6,6,6],"rotation":[0,0,0]},{"assetIdentifier":"pepper","uniqueIdentifier":"405","position":[334.51,929.73,255.6],"scale":[6,6,6],"rotation":[0,0,0]},{"assetIdentifier":"pepper","uniqueIdentifier":"406","position":[335.51,929.73,249.1],"scale":[6,6,6],"rotation":[0,0,0]},{"assetIdentifier":"rolling_pin","uniqueIdentifier":"407","position":[350.92,929.65,245.02],"scale":[6,6,6],"rotation":[0,0,0]},{"assetIdentifier":"rolling_pin","uniqueIdentifier":"408","position":[367.42,928.15,245.02],"scale":[6,6,6],"rotation":[0,0,0]},{"assetIdentifier":"rolling_pin","uniqueIdentifier":"409","position":[384.42,926.65,245.02],"scale":[6,6,6],"rotation":[0,0,0]},{"assetIdentifier":"rolling_pin","uniqueIdentifier":"410","position":[402.42,926.65,245.02],"scale":[6,6,6],"rotation":[0,0,0]},{"assetIdentifier":"slow_block_001","uniqueIdentifier":"411","position":[431.76,925.5,245.3],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"slow_block_001","uniqueIdentifier":"412","position":[431.76,921.5,245.3],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"slow_block_001","uniqueIdentifier":"413","position":[431.76,913.5,245.3],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"slow_block_001","uniqueIdentifier":"414","position":[431.76,909.5,245.3],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"slow_block_001","uniqueIdentifier":"415","position":[431.76,905.5,245.3],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"slow_block_001","uniqueIdentifier":"416","position":[431.76,901.5,245.3],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"square_007","uniqueIdentifier":"417","position":[431.76,891,232.3],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"square_007","uniqueIdentifier":"418","position":[431.76,889,223.8],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"square_007","uniqueIdentifier":"419","position":[431.76,889,214.8],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"square_007","uniqueIdentifier":"420","position":[430.26,887,205.8],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"square_007","uniqueIdentifier":"421","position":[428.26,885.5,196.8],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"square_007","uniqueIdentifier":"422","position":[433.26,885.5,188.3],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"square_007","uniqueIdentifier":"423","position":[442.26,885.5,185.8],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"square_007","uniqueIdentifier":"424","position":[451.26,885.5,185.8],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"square_007","uniqueIdentifier":"425","position":[459.76,884,185.8],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"square_007","uniqueIdentifier":"426","position":[459.76,883,178.3],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"square_007","uniqueIdentifier":"427","position":[459.76,882,170.3],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"square_007","uniqueIdentifier":"428","position":[459.76,881,162.3],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"429","position":[448.01,884.5,153.8],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"430","position":[457.51,884.5,151.8],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"431","position":[453.01,884.5,145.8],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"432","position":[462.01,884.5,142.8],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"433","position":[449.51,884.5,131.8],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"434","position":[456.51,884.5,128.3],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"square_007","uniqueIdentifier":"435","position":[455.01,881,149.05],"scale":[17,4,15.5],"rotation":[0,0,0]},{"assetIdentifier":"square_007","uniqueIdentifier":"436","position":[455.01,881,127.05],"scale":[17,4,15.5],"rotation":[0,0,0]},{"assetIdentifier":"slippery_block_001","uniqueIdentifier":"437","position":[454.69,877.5,109.42],"scale":[4,4,4],"rotation":[0,0,3.14],"behaviour":["Speed","0.64","",""]},{"assetIdentifier":"slippery_block_001","uniqueIdentifier":"438","position":[454.69,866,109.42],"scale":[4,4,4],"rotation":[0,0,3.14],"behaviour":["Speed","0.64","",""]},{"assetIdentifier":"slippery_block_001","uniqueIdentifier":"439","position":[454.69,854.5,109.42],"scale":[4,4,4],"rotation":[0,0,3.14],"behaviour":["Speed","0.64","",""]},{"assetIdentifier":"square_007","uniqueIdentifier":"440","position":[452.78,833,104.96],"scale":[17,4,6],"rotation":[0,0,0]},{"assetIdentifier":"slippery_block_001","uniqueIdentifier":"441","position":[454.69,843.5,109.42],"scale":[4,4,4],"rotation":[0,0,3.14],"behaviour":["Speed","0.64","",""]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"442","position":[448.01,884.5,120.8],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"slow_block_001","uniqueIdentifier":"443","position":[431.76,897.5,245.3],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"rolling_pin","uniqueIdentifier":"444","position":[420.92,926.65,245.02],"scale":[6,6,6],"rotation":[0,0,0]},{"assetIdentifier":"pepper","uniqueIdentifier":"445","position":[341.01,929.73,245.1],"scale":[6,6,6],"rotation":[0,0,0]},{"assetIdentifier":"square_001","uniqueIdentifier":"446","position":[409.33,935.78,307.3],"scale":[4,4,8],"rotation":[0,0,0]},{"assetIdentifier":"square_001","uniqueIdentifier":"447","position":[406.83,947.78,365.3],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"square_006","uniqueIdentifier":"448","position":[399.33,990.78,365.3],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"moving_block_001","uniqueIdentifier":"449","position":[167.83,1162.78,-21.2],"scale":[4,4,4],"rotation":[0,0,0],"behaviour":["Speed","2","",""]},{"assetIdentifier":"moving_block_001","uniqueIdentifier":"450","position":[185.83,1162.78,-21.2],"scale":[4,4,4],"rotation":[0,0,0],"behaviour":["Speed","2","",""]},{"assetIdentifier":"pan_004","uniqueIdentifier":"451","position":[8.54,1315.13,27.78],"scale":[1.45,1.45,1.45],"rotation":[0,0,0],"behaviour":["Bounce","2","",""]},{"assetIdentifier":"moving_block_001","uniqueIdentifier":"452","position":[14.33,1314.28,26.8],"scale":[4,4,4],"rotation":[0,0,0],"behaviour":["Speed","1.5","",""]},{"assetIdentifier":"pan_004","uniqueIdentifier":"453","position":[92.34,1183.91,29.34],"scale":[1.48,1.48,1.48],"rotation":[0,0,0],"behaviour":["Bounce","2","",""]},{"assetIdentifier":"square_002","uniqueIdentifier":"454","position":[111.83,1173.28,21.55],"scale":[2,12,11.5],"rotation":[0,0,0]},{"assetIdentifier":"moving_block_001","uniqueIdentifier":"455","position":[98.59,1183.78,30.54],"scale":[3,3,3],"rotation":[0,0,0],"behaviour":["Speed","2","",""]},{"assetIdentifier":"pan_004","uniqueIdentifier":"456","position":[117.84,1169.41,29.34],"scale":[1.48,1.48,1.48],"rotation":[0,0,0],"behaviour":["Bounce","2","",""]},{"assetIdentifier":"moving_block_001","uniqueIdentifier":"457","position":[121.59,1168.78,30.54],"scale":[3,3,3],"rotation":[0,0,0],"behaviour":["Speed","1.5","",""]},{"assetIdentifier":"moving_block_001","uniqueIdentifier":"458","position":[302.83,1125.28,-10.7],"scale":[4,4,4],"rotation":[0,0,0],"behaviour":["Speed","1.25","",""]},{"assetIdentifier":"moving_block_001","uniqueIdentifier":"459","position":[309.83,1123.78,-3.2],"scale":[4,4,4],"rotation":[0,0,0],"behaviour":["Speed","1.25","",""]},{"assetIdentifier":"moving_block_001","uniqueIdentifier":"460","position":[319.83,1122.28,-9.2],"scale":[4,4,4],"rotation":[0,0,0],"behaviour":["Speed","1.25","",""]},{"assetIdentifier":"moving_block_001","uniqueIdentifier":"461","position":[325.33,1120.28,-0.7],"scale":[4,4,4],"rotation":[0,0,0],"behaviour":["Speed","1.25","",""]},{"assetIdentifier":"moving_block_001","uniqueIdentifier":"462","position":[333.33,1120.28,-7.2],"scale":[4,4,4],"rotation":[0,0,0],"behaviour":["Speed","1.25","",""]},{"assetIdentifier":"moving_block_001","uniqueIdentifier":"463","position":[342.33,1120.28,-2.2],"scale":[4,4,4],"rotation":[0,0,0],"behaviour":["Speed","1.25","",""]},{"assetIdentifier":"moving_block_001","uniqueIdentifier":"464","position":[351.33,1120.28,-4.2],"scale":[4,4,4],"rotation":[0,0,0],"behaviour":["Speed","1.25","",""]},{"assetIdentifier":"moving_block_001","uniqueIdentifier":"465","position":[359.83,1118.78,-4.2],"scale":[4,4,4],"rotation":[0,0,0],"behaviour":["Speed","1.25","",""]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"466","position":[88.09,1168.78,40.04],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"467","position":[79.59,1168.78,37.54],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"468","position":[78.09,1168.78,23.54],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"469","position":[66.09,1165.8,14.3],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"470","position":[90.09,1165.8,14.3],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"471","position":[90.09,1168.78,21.04],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"472","position":[106.59,1168.78,25.54],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"473","position":[126.59,1168.78,38.04],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"474","position":[118.09,1168.78,38.04],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"475","position":[118.09,1168.78,24.54],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"check_point_001","uniqueIdentifier":"checkpoint_62","position":[12.83,1243.78,-6.7],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"check_point_001","uniqueIdentifier":"checkpoint_60","position":[208.83,1160.28,-10.7],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"square_001","uniqueIdentifier":"476","position":[11.83,1187.03,22.8],"scale":[4,47.5,4],"rotation":[0,0,0]},{"assetIdentifier":"square_001","uniqueIdentifier":"477","position":[3.33,1187.03,22.8],"scale":[5,47.5,4],"rotation":[0,0,0]},{"assetIdentifier":"square_001","uniqueIdentifier":"478","position":[7.33,1187.03,18.3],"scale":[13,47.5,5],"rotation":[0,0,0]},{"assetIdentifier":"check_point_001","uniqueIdentifier":"checkpoint_61","position":[7.83,1209.78,23.8],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"479","position":[41.33,1269.28,26.3],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"480","position":[41.33,1269.28,11.3],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"481","position":[41.33,1269.28,23.3],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"482","position":[41.33,1269.28,20.3],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"483","position":[41.33,1269.28,17.3],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"484","position":[41.33,1269.28,14.3],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"square_001","uniqueIdentifier":"485","position":[39.58,1308.53,18.8],"scale":[2.5,11.5,12],"rotation":[0,0,0]},{"assetIdentifier":"square_001","uniqueIdentifier":"486","position":[40.58,1297.03,18.8],"scale":[1.5,11.5,12],"rotation":[0,0,0]},{"assetIdentifier":"square_001","uniqueIdentifier":"487","position":[41.08,1285.53,18.8],"scale":[2.5,11.5,12],"rotation":[0,0,0]},{"assetIdentifier":"slow_block_001","uniqueIdentifier":"488","position":[37.83,1255.53,17.8],"scale":[4,11.5,4],"rotation":[0,0,0]},{"assetIdentifier":"slow_block_001","uniqueIdentifier":"489","position":[33.83,1251.78,17.8],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"square_007","uniqueIdentifier":"490","position":[7.33,1195.78,8.3],"scale":[13,65,15],"rotation":[0,0,0]},{"assetIdentifier":"square_005","uniqueIdentifier":"491","position":[193.83,1162.78,-11.2],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"square_004","uniqueIdentifier":"492","position":[237.83,1150.78,-11.2],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"493","position":[5.83,1318.28,18.8],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"494","position":[5.83,1318.28,22.8],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"495","position":[14.33,1318.28,22.8],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"496","position":[22.83,1318.28,18.3],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"square_001","uniqueIdentifier":"497","position":[5.83,1314.28,18.8],"scale":[4,4,12],"rotation":[0,0,0]},{"assetIdentifier":"square_001","uniqueIdentifier":"498","position":[14.33,1314.28,18.8],"scale":[4,4,12],"rotation":[0,0,0]},{"assetIdentifier":"square_001","uniqueIdentifier":"499","position":[22.83,1314.28,18.8],"scale":[4,4,12],"rotation":[0,0,0]},{"assetIdentifier":"square_001","uniqueIdentifier":"500","position":[31.83,1314.28,18.8],"scale":[4,4,12],"rotation":[0,0,0]},{"assetIdentifier":"square_001","uniqueIdentifier":"501","position":[45.83,1263.28,22.8],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"square_001","uniqueIdentifier":"502","position":[45.83,1266.03,18.8],"scale":[4,9.5,4],"rotation":[0,0,0]},{"assetIdentifier":"square_001","uniqueIdentifier":"503","position":[49.83,1263.28,18.8],"scale":[4,4,12],"rotation":[0,0,0]},{"assetIdentifier":"square_001","uniqueIdentifier":"504","position":[41.83,1275.28,18.8],"scale":[4,9,12],"rotation":[0,0,0]},{"assetIdentifier":"slow_block_001","uniqueIdentifier":"505","position":[25.83,1251.28,18.8],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"slow_block_001","uniqueIdentifier":"506","position":[18.83,1250.28,13.8],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"slow_block_001","uniqueIdentifier":"507","position":[12.83,1247.28,9.3],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"slow_block_001","uniqueIdentifier":"508","position":[12.83,1245.78,1.3],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"slow_block_001","uniqueIdentifier":"509","position":[12.83,1240.78,-17.2],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"slow_block_001","uniqueIdentifier":"510","position":[12.83,1238.28,-26.7],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"slow_block_001","uniqueIdentifier":"511","position":[12.83,1234.78,-37.7],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"slow_block_001","uniqueIdentifier":"512","position":[1.83,1232.78,-37.7],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"square_001","uniqueIdentifier":"513","position":[4.83,1195.78,-28.7],"scale":[10,65,8],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"514","position":[7.58,1228.78,-22.2],"scale":[1,1,1],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"515","position":[7.58,1228.78,-14.7],"scale":[1,1,1],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"516","position":[7.58,1228.78,-7.2],"scale":[1,1,1],"rotation":[0,0,0]},{"assetIdentifier":"square_001","uniqueIdentifier":"517","position":[7.33,1187.03,27.8],"scale":[13,47.5,6],"rotation":[0,0,0]},{"assetIdentifier":"square_001","uniqueIdentifier":"518","position":[20.33,1177.53,35.55],"scale":[13,28.5,39.5],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"519","position":[53.59,1168.78,20.54],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"520","position":[126.09,1168.78,20.04],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"521","position":[126.09,1168.78,46.54],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"522","position":[74.59,1168.78,18.04],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"523","position":[74.59,1168.78,53.54],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"524","position":[47.59,1168.78,26.54],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"525","position":[50.59,1168.78,46.54],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"526","position":[47.59,1168.78,39.04],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"527","position":[65.09,1168.78,39.04],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"528","position":[65.09,1168.78,30.54],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"529","position":[74.59,1168.78,30.54],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"530","position":[74.59,1168.78,46.04],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"531","position":[93.09,1168.78,46.04],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"532","position":[104.09,1168.78,35.04],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"533","position":[103.09,1168.78,49.04],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"534","position":[103.09,1168.78,19.54],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"535","position":[95.59,1168.78,30.54],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"536","position":[124.59,1168.78,30.54],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"square_002","uniqueIdentifier":"537","position":[58.83,1173.28,35.55],"scale":[2,12,39.5],"rotation":[0,0,0]},{"assetIdentifier":"square_002","uniqueIdentifier":"538","position":[83.83,1173.28,35.55],"scale":[2,12,39.5],"rotation":[0,0,0]},{"assetIdentifier":"square_002","uniqueIdentifier":"539","position":[111.83,1173.28,44.3],"scale":[2,12,22],"rotation":[0,0,0]},{"assetIdentifier":"square_005","uniqueIdentifier":"540","position":[149.33,1165.28,10.3],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"square_005","uniqueIdentifier":"541","position":[158.33,1165.28,4.3],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"square_005","uniqueIdentifier":"542","position":[158.33,1165.28,-15.7],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"square_005","uniqueIdentifier":"543","position":[158.33,1165.28,-5.7],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"square_005","uniqueIdentifier":"544","position":[167.83,1162.78,-11.2],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"square_005","uniqueIdentifier":"545","position":[167.83,1162.78,-1.2],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"square_005","uniqueIdentifier":"546","position":[176.83,1162.78,-6.2],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"square_005","uniqueIdentifier":"547","position":[176.83,1162.78,-26.2],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"square_005","uniqueIdentifier":"548","position":[176.83,1162.78,-16.2],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"square_005","uniqueIdentifier":"549","position":[185.83,1162.78,-1.2],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"square_005","uniqueIdentifier":"550","position":[185.83,1162.78,-11.2],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"square_005","uniqueIdentifier":"551","position":[201.33,1162.78,-11.2],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"square_005","uniqueIdentifier":"552","position":[216.33,1158.28,-12.7],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"square_005","uniqueIdentifier":"553","position":[223.83,1154.78,-10.7],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"square_004","uniqueIdentifier":"554","position":[240.83,1148.78,-3.7],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"square_004","uniqueIdentifier":"555","position":[246.83,1145.78,3.8],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"square_004","uniqueIdentifier":"556","position":[255.33,1141.78,5.8],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"square_004","uniqueIdentifier":"557","position":[263.83,1138.28,1.3],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"square_004","uniqueIdentifier":"558","position":[267.33,1135.28,-7.7],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"square_003","uniqueIdentifier":"559","position":[284.33,1130.78,-13.2],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"square_003","uniqueIdentifier":"560","position":[293.83,1128.78,-6.2],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"square_004","uniqueIdentifier":"561","position":[275.83,1131.28,-7.7],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"square_005","uniqueIdentifier":"562","position":[230.83,1152.78,-11.7],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"square_007","uniqueIdentifier":"563","position":[92.83,1165.28,35.55],"scale":[106,4,39.5],"rotation":[0,0,0]},{"assetIdentifier":"square_002","uniqueIdentifier":"564","position":[132.83,1173.28,35.55],"scale":[2,12,39.5],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"565","position":[117.09,1168.78,46.54],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"square_001","uniqueIdentifier":"566","position":[33.33,1170.53,35.55],"scale":[13,14.5,39.5],"rotation":[0,0,0]},{"assetIdentifier":"square_001","uniqueIdentifier":"567","position":[7.58,1226.28,-11.95],"scale":[1,4,25.5],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"568","position":[7.58,1228.78,-2.7],"scale":[1,1,1],"rotation":[0,0,0]},{"assetIdentifier":"slow_block_001","uniqueIdentifier":"569","position":[1.83,1230.28,-28.2],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"square_001","uniqueIdentifier":"570","position":[45.83,1259.28,18.8],"scale":[12,4,12],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"571","position":[31.83,1318.28,14.8],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"check_point_001","uniqueIdentifier":"checkpoint_63","position":[-1.17,1315.28,15.8],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"fridge_001","uniqueIdentifier":"572","position":[413.02,1117.35,51.98],"scale":[0.45,0.45,0.45],"rotation":[0,0,0]},{"assetIdentifier":"slippery_block_001","uniqueIdentifier":"573","position":[385.33,1103.78,101.29],"scale":[6,6,6],"rotation":[0,0,0],"behaviour":["Speed","0.64","",""]},{"assetIdentifier":"moving_block_001","uniqueIdentifier":"574","position":[397.33,1103.78,101.29],"scale":[6,6,6],"rotation":[0,0,0],"behaviour":["Speed","1.36","",""]},{"assetIdentifier":"moving_block_001","uniqueIdentifier":"575","position":[391.33,1103.78,101.29],"scale":[6,6,6],"rotation":[0,0,0],"behaviour":["Speed","1.36","",""]},{"assetIdentifier":"moving_block_001","uniqueIdentifier":"576","position":[391.33,1103.78,101.29],"scale":[6,6,6],"rotation":[0,0,0],"behaviour":["Speed","1.55","",""]},{"assetIdentifier":"moving_block_001","uniqueIdentifier":"577","position":[385.33,1103.78,107.29],"scale":[6,6,6],"rotation":[0,0,0],"behaviour":["Speed","5","",""]},{"assetIdentifier":"moving_block_001","uniqueIdentifier":"578","position":[385.33,1103.78,113.29],"scale":[6,6,6],"rotation":[0,0,0],"behaviour":["Speed","5","",""]},{"assetIdentifier":"moving_block_001","uniqueIdentifier":"579","position":[385.33,1103.78,119.29],"scale":[6,6,6],"rotation":[0,0,0],"behaviour":["Speed","5","",""]},{"assetIdentifier":"moving_block_001","uniqueIdentifier":"580","position":[385.33,1103.78,125.29],"scale":[6,6,6],"rotation":[0,0,0],"behaviour":["Speed","5","",""]},{"assetIdentifier":"moving_block_001","uniqueIdentifier":"581","position":[385.33,1103.78,131.29],"scale":[6,6,6],"rotation":[0,0,0],"behaviour":["Speed","5","",""]},{"assetIdentifier":"moving_block_001","uniqueIdentifier":"582","position":[385.33,1103.78,137.29],"scale":[6,6,6],"rotation":[0,0,0],"behaviour":["Speed","5","",""]},{"assetIdentifier":"moving_block_001","uniqueIdentifier":"583","position":[385.33,1103.78,143.29],"scale":[6,6,6],"rotation":[0,0,0],"behaviour":["Speed","5","",""]},{"assetIdentifier":"moving_block_001","uniqueIdentifier":"584","position":[385.33,1103.78,149.29],"scale":[6,6,6],"rotation":[0,0,0],"behaviour":["Speed","5","",""]},{"assetIdentifier":"moving_block_001","uniqueIdentifier":"585","position":[385.33,1103.78,155.29],"scale":[6,6,6],"rotation":[0,0,0],"behaviour":["Speed","4.5","",""]},{"assetIdentifier":"moving_block_001","uniqueIdentifier":"586","position":[385.33,1103.78,161.29],"scale":[6,6,6],"rotation":[0,0,0],"behaviour":["Speed","3.5","",""]},{"assetIdentifier":"moving_block_001","uniqueIdentifier":"587","position":[385.33,1103.78,167.29],"scale":[6,6,6],"rotation":[0,0,0],"behaviour":["Speed","2.5","",""]},{"assetIdentifier":"moving_block_001","uniqueIdentifier":"588","position":[385.33,1103.78,173.29],"scale":[6,6,6],"rotation":[0,0,0],"behaviour":["Speed","2","",""]},{"assetIdentifier":"moving_block_001","uniqueIdentifier":"589","position":[385.33,1103.78,179.29],"scale":[6,6,6],"rotation":[0,0,0],"behaviour":["Speed","1.75","",""]},{"assetIdentifier":"moving_block_001","uniqueIdentifier":"590","position":[391.33,1103.78,179.29],"scale":[6,6,6],"rotation":[0,0,0],"behaviour":["Speed","1.55","",""]},{"assetIdentifier":"moving_block_001","uniqueIdentifier":"591","position":[397.33,1103.78,179.29],"scale":[6,6,6],"rotation":[0,0,0],"behaviour":["Speed","1.36","",""]},{"assetIdentifier":"pan_004","uniqueIdentifier":"592","position":[458.58,1106.25,149.22],"scale":[1.61,1.61,1.61],"rotation":[0,0,0],"behaviour":["Bounce","1.5","",""]},{"assetIdentifier":"moving_block_001","uniqueIdentifier":"593","position":[458.83,1104.78,170.8],"scale":[4,4,4],"rotation":[0,0,0],"behaviour":["Speed","2.5","",""]},{"assetIdentifier":"pan_001","uniqueIdentifier":"594","position":[428.23,1031.1,324.69],"scale":[1.6,1.6,1.6],"rotation":[0,0,0],"behaviour":["Bounce","1.3","",""]},{"assetIdentifier":"pan_001","uniqueIdentifier":"595","position":[428.23,1031.1,336.19],"scale":[1.6,1.6,1.6],"rotation":[0,0,0],"behaviour":["Bounce","1.5","",""]},{"assetIdentifier":"pan_001","uniqueIdentifier":"596","position":[428.23,1031.1,347.69],"scale":[1.6,1.6,1.6],"rotation":[0,0,0],"behaviour":["Bounce","1.3","",""]},{"assetIdentifier":"pan_001","uniqueIdentifier":"597","position":[428.23,1031.1,357.69],"scale":[1.6,1.6,1.6],"rotation":[0,0,0],"behaviour":["Bounce","1.3","",""]},{"assetIdentifier":"pan_001","uniqueIdentifier":"598","position":[428.23,1031.1,368.69],"scale":[1.6,1.6,1.6],"rotation":[0,0,0],"behaviour":["Bounce","1.5","",""]},{"assetIdentifier":"pan_001","uniqueIdentifier":"599","position":[428.23,1031.1,380.19],"scale":[1.6,1.6,1.6],"rotation":[0,0,0],"behaviour":["Bounce","1.3","",""]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"600","position":[461.83,1061.71,147.62],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"601","position":[461.83,1061.71,192.12],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"602","position":[461.83,1085.71,114.12],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"603","position":[461.83,1085.71,142.62],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"604","position":[461.83,1085.71,182.62],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"605","position":[461.83,1072.21,182.62],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"606","position":[461.83,1065.21,167.12],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"607","position":[461.83,1075.71,167.12],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"square_006","uniqueIdentifier":"608","position":[454.83,1059.78,119.55],"scale":[12,59,53.49],"rotation":[0,0,0]},{"assetIdentifier":"check_point_001","uniqueIdentifier":"checkpoint_56","position":[411.33,1105.78,149.79],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"check_point_001","uniqueIdentifier":"checkpoint_58","position":[455.33,1088.28,90.8],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"check_point_001","uniqueIdentifier":"checkpoint_55","position":[438.83,1033.78,232.8],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"check_point_001","uniqueIdentifier":"checkpoint_54","position":[433.33,1031.78,309.3],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"check_point_001","uniqueIdentifier":"checkpoint_59","position":[366.83,1118.28,-2.2],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"square_001","uniqueIdentifier":"609","position":[426.83,1111.78,41.8],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"check_point_001","uniqueIdentifier":"checkpoint_53","position":[428.33,1028.78,391.8],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"square_001","uniqueIdentifier":"610","position":[372.33,1116.28,2.3],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"square_001","uniqueIdentifier":"611","position":[375.33,1116.28,5.3],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"square_001","uniqueIdentifier":"612","position":[369.33,1113.28,10.8],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"square_001","uniqueIdentifier":"613","position":[372.33,1113.28,13.8],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"square_001","uniqueIdentifier":"614","position":[375.33,1113.28,16.8],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"square_001","uniqueIdentifier":"615","position":[369.33,1113.28,22.8],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"square_001","uniqueIdentifier":"616","position":[372.33,1113.28,25.8],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"square_001","uniqueIdentifier":"617","position":[375.33,1113.28,28.8],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"square_001","uniqueIdentifier":"618","position":[369.33,1113.28,35.8],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"square_001","uniqueIdentifier":"619","position":[372.33,1113.28,38.8],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"square_001","uniqueIdentifier":"620","position":[375.33,1113.28,41.8],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"square_001","uniqueIdentifier":"621","position":[380.83,1113.28,35.8],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"square_001","uniqueIdentifier":"622","position":[383.83,1113.28,38.8],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"square_001","uniqueIdentifier":"623","position":[386.83,1113.28,41.8],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"square_001","uniqueIdentifier":"624","position":[386.33,1113.28,27.3],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"square_001","uniqueIdentifier":"625","position":[389.33,1113.28,30.3],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"square_001","uniqueIdentifier":"626","position":[392.33,1113.28,33.3],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"square_001","uniqueIdentifier":"627","position":[397.33,1113.28,41.8],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"square_001","uniqueIdentifier":"628","position":[400.33,1113.28,44.8],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"square_001","uniqueIdentifier":"629","position":[403.33,1113.28,47.8],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"square_001","uniqueIdentifier":"630","position":[397.33,1113.28,27.8],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"square_001","uniqueIdentifier":"631","position":[400.33,1113.28,30.8],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"square_001","uniqueIdentifier":"632","position":[403.33,1113.28,33.8],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"square_001","uniqueIdentifier":"633","position":[412.83,1113.28,45.55],"scale":[16,3,20.5],"rotation":[0,0,0]},{"assetIdentifier":"square_001","uniqueIdentifier":"634","position":[434.83,1110.78,41.8],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"square_001","uniqueIdentifier":"635","position":[442.33,1107.78,38.3],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"square_001","uniqueIdentifier":"636","position":[450.83,1103.78,38.3],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"square_001","uniqueIdentifier":"637","position":[456.83,1101.78,46.8],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"638","position":[455.33,1100.78,58.3],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"square_001","uniqueIdentifier":"639","position":[457.33,1101.78,54.3],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"square_001","uniqueIdentifier":"640","position":[450.83,1101.78,61.8],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"square_001","uniqueIdentifier":"641","position":[448.33,1099.28,70.3],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"square_001","uniqueIdentifier":"642","position":[455.83,1097.28,75.8],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"square_001","uniqueIdentifier":"643","position":[462.33,1093.78,79.8],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"644","position":[447.83,1096.78,87.8],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"645","position":[442.83,1105.28,87.8],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"square_006","uniqueIdentifier":"646","position":[454.83,1082.78,59.8],"scale":[12,13,54],"rotation":[0,0,0]},{"assetIdentifier":"square_006","uniqueIdentifier":"647","position":[415.58,1098.03,94.05],"scale":[3.5,17.5,3.5],"rotation":[0,0,0]},{"assetIdentifier":"square_006","uniqueIdentifier":"648","position":[403.08,1098.03,103.54],"scale":[5.5,17.5,3.5],"rotation":[0,0,0]},{"assetIdentifier":"square_006","uniqueIdentifier":"649","position":[403.08,1098.03,124.04],"scale":[5.5,17.5,3.5],"rotation":[0,0,0]},{"assetIdentifier":"square_006","uniqueIdentifier":"650","position":[411.08,1098.03,144.04],"scale":[5.5,17.5,3.5],"rotation":[0,0,0]},{"assetIdentifier":"square_006","uniqueIdentifier":"651","position":[403.08,1098.03,163.05],"scale":[5.5,17.5,3.5],"rotation":[0,0,0]},{"assetIdentifier":"square_006","uniqueIdentifier":"652","position":[416.33,1098.03,174.3],"scale":[5,17.5,3],"rotation":[0,0,0]},{"assetIdentifier":"square_006","uniqueIdentifier":"653","position":[439.83,1098.03,180.8],"scale":[5,17.5,3],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"654","position":[459.33,1090.78,106.8],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"655","position":[456.33,1090.78,106.8],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"656","position":[453.33,1090.78,106.8],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"657","position":[450.33,1090.78,106.8],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"658","position":[450.33,1090.78,120.3],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"659","position":[453.33,1090.78,120.3],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"660","position":[456.33,1090.78,120.3],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"661","position":[459.33,1090.78,120.3],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"662","position":[459.33,1090.78,135.3],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"663","position":[456.33,1090.78,135.3],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"664","position":[453.33,1090.78,135.3],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"665","position":[450.33,1090.78,135.3],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"666","position":[459.33,1090.78,151.8],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"667","position":[456.33,1090.78,151.8],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"668","position":[453.33,1090.78,151.8],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"square_006","uniqueIdentifier":"669","position":[431.58,1098.03,97.05],"scale":[13.5,17.5,9.5],"rotation":[0,0,0]},{"assetIdentifier":"square_006","uniqueIdentifier":"670","position":[407.08,1098.03,97.05],"scale":[13.5,17.5,9.5],"rotation":[0,0,0]},{"assetIdentifier":"square_006","uniqueIdentifier":"671","position":[407.08,1098.03,117.55],"scale":[13.5,17.5,9.5],"rotation":[0,0,0]},{"assetIdentifier":"square_006","uniqueIdentifier":"672","position":[407.08,1098.03,137.55],"scale":[13.5,17.5,9.5],"rotation":[0,0,0]},{"assetIdentifier":"square_006","uniqueIdentifier":"673","position":[407.08,1098.03,156.55],"scale":[13.5,17.5,9.5],"rotation":[0,0,0]},{"assetIdentifier":"square_006","uniqueIdentifier":"674","position":[407.08,1098.03,177.55],"scale":[13.5,17.5,9.5],"rotation":[0,0,0]},{"assetIdentifier":"square_006","uniqueIdentifier":"675","position":[430.58,1098.03,177.55],"scale":[13.5,17.5,9.5],"rotation":[0,0,0]},{"assetIdentifier":"square_006","uniqueIdentifier":"676","position":[454.83,1098.03,177.55],"scale":[12,17.5,9.5],"rotation":[0,0,0]},{"assetIdentifier":"square_006","uniqueIdentifier":"677","position":[469.33,1065.28,129.3],"scale":[17,13,27],"rotation":[0,0,0]},{"assetIdentifier":"square_006","uniqueIdentifier":"678","position":[469.33,1036.78,171.8],"scale":[17,13,27],"rotation":[0,0,0]},{"assetIdentifier":"square_006","uniqueIdentifier":"679","position":[464.83,1036.78,215.3],"scale":[8,13,27],"rotation":[0,0,0]},{"assetIdentifier":"square_006","uniqueIdentifier":"680","position":[442.08,1066.78,139.55],"scale":[13.5,73,9.5],"rotation":[0,0,0]},{"assetIdentifier":"square_006","uniqueIdentifier":"681","position":[454.83,1059.78,174.05],"scale":[12,59,55.49],"rotation":[0,0,0]},{"assetIdentifier":"square_006","uniqueIdentifier":"682","position":[442.08,1043.03,159.05],"scale":[13.5,25.5,9.5],"rotation":[0,0,0]},{"assetIdentifier":"square_006","uniqueIdentifier":"683","position":[442.08,1043.03,178.05],"scale":[13.5,25.5,9.5],"rotation":[0,0,0]},{"assetIdentifier":"square_006","uniqueIdentifier":"684","position":[442.08,1043.03,197.05],"scale":[13.5,25.5,9.5],"rotation":[0,0,0]},{"assetIdentifier":"square_006","uniqueIdentifier":"685","position":[437.08,1060.03,220.05],"scale":[3.5,25.5,3.5],"rotation":[0,0,0]},{"assetIdentifier":"square_006","uniqueIdentifier":"686","position":[454.83,1055.03,207.55],"scale":[12,49.5,11.5],"rotation":[0,0,0]},{"assetIdentifier":"square_006","uniqueIdentifier":"687","position":[442.08,1043.03,213.55],"scale":[13.5,25.5,9.5],"rotation":[0,0,0]},{"assetIdentifier":"square_006","uniqueIdentifier":"688","position":[451.08,1044.53,219.05],"scale":[4.5,28.5,11.5],"rotation":[0,0,0]},{"assetIdentifier":"square_006","uniqueIdentifier":"689","position":[451.33,1036.78,226.8],"scale":[8,13,4],"rotation":[0,0,0]},{"assetIdentifier":"square_006","uniqueIdentifier":"690","position":[442.08,1038.78,221.55],"scale":[13.5,17,6.5],"rotation":[0,0,0]},{"assetIdentifier":"square_006","uniqueIdentifier":"691","position":[439.33,1036.78,226.8],"scale":[8,13,4],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"692","position":[441.83,1032.78,249.8],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"693","position":[441.83,1032.78,274.8],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"694","position":[441.83,1032.78,293.8],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"695","position":[435.83,1032.78,249.8],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"696","position":[435.83,1032.78,274.8],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"697","position":[435.83,1032.78,293.8],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"698","position":[438.83,1035.78,244.3],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"699","position":[438.83,1035.78,255.3],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"700","position":[438.83,1035.78,267.8],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"701","position":[438.83,1035.78,280.8],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"702","position":[438.83,1035.78,293.8],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"square_006","uniqueIdentifier":"703","position":[438.83,1032.28,273.3],"scale":[3,4,77],"rotation":[0,0,0]},{"assetIdentifier":"square_002","uniqueIdentifier":"704","position":[428.33,1032.28,320.3],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"square_002","uniqueIdentifier":"705","position":[428.33,1032.28,320.3],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"square_002","uniqueIdentifier":"706","position":[428.33,1035.28,331.3],"scale":[4,10,4],"rotation":[0,0,0]},{"assetIdentifier":"square_002","uniqueIdentifier":"707","position":[428.33,1032.28,342.8],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"square_002","uniqueIdentifier":"708","position":[428.33,1032.28,353.8],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"square_002","uniqueIdentifier":"709","position":[428.33,1034.78,363.8],"scale":[4,9,4],"rotation":[0,0,0]},{"assetIdentifier":"slow_block_001","uniqueIdentifier":"710","position":[428.33,1026.78,399.3],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"slow_block_001","uniqueIdentifier":"711","position":[418.83,1025.28,399.3],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"slow_block_001","uniqueIdentifier":"712","position":[410.33,1025.28,399.3],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"slow_block_001","uniqueIdentifier":"713","position":[404.33,1023.78,404.3],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"slow_block_001","uniqueIdentifier":"714","position":[398.83,1022.28,406.3],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"slow_block_001","uniqueIdentifier":"715","position":[393.33,1021.28,402.8],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"slow_block_001","uniqueIdentifier":"716","position":[393.33,1021.28,396.3],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"717","position":[393.33,1019.28,387.3],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"slow_block_001","uniqueIdentifier":"718","position":[393.33,1021.28,390.3],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"square_006","uniqueIdentifier":"719","position":[428.33,1028.28,347.3],"scale":[4,4,77],"rotation":[0,0,0]},{"assetIdentifier":"square_002","uniqueIdentifier":"720","position":[428.33,1032.28,374.8],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"721","position":[438.83,1035.78,309.8],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"722","position":[450.33,1090.78,151.8],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"square_001","uniqueIdentifier":"723","position":[459.33,1090.78,85.3],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"slow_block_001","uniqueIdentifier":"724","position":[454.28,828.25,58.46],"scale":[4,0.5,4],"rotation":[0,0,0]},{"assetIdentifier":"slow_block_001","uniqueIdentifier":"725","position":[454.28,816.75,67.46],"scale":[4,0.5,4],"rotation":[0,0,0]},{"assetIdentifier":"slow_block_001","uniqueIdentifier":"726","position":[454.28,805.25,76.46],"scale":[4,0.5,4],"rotation":[0,0,0]},{"assetIdentifier":"moving_block_001","uniqueIdentifier":"727","position":[371.01,699,-36.63],"scale":[2,2,2],"rotation":[0,0,0],"behaviour":["Speed","1.36","",""]},{"assetIdentifier":"moving_block_001","uniqueIdentifier":"728","position":[369.01,699,-36.63],"scale":[2,2,2],"rotation":[0,0,0],"behaviour":["Speed","1.36","",""]},{"assetIdentifier":"moving_block_001","uniqueIdentifier":"729","position":[364.51,699,-36.63],"scale":[2,2,2],"rotation":[0,0,0],"behaviour":["Speed","1.36","",""]},{"assetIdentifier":"moving_block_001","uniqueIdentifier":"730","position":[362.51,699,-36.63],"scale":[2,2,2],"rotation":[0,0,0],"behaviour":["Speed","1.36","",""]},{"assetIdentifier":"moving_block_001","uniqueIdentifier":"731","position":[357.51,699,-36.63],"scale":[2,2,2],"rotation":[0,0,0],"behaviour":["Speed","1.36","",""]},{"assetIdentifier":"moving_block_001","uniqueIdentifier":"732","position":[355.51,699,-36.63],"scale":[2,2,2],"rotation":[0,0,0],"behaviour":["Speed","1.36","",""]},{"assetIdentifier":"moving_block_001","uniqueIdentifier":"733","position":[353.51,699,-36.63],"scale":[2,2,2],"rotation":[0,0,0],"behaviour":["Speed","1.36","",""]},{"assetIdentifier":"slow_block_001","uniqueIdentifier":"734","position":[440.78,722.25,61.96],"scale":[4,12.5,4],"rotation":[0,0,0]},{"assetIdentifier":"pan_001","uniqueIdentifier":"735","position":[434.96,733.54,108.01],"scale":[2.18,2.18,2.18],"rotation":[0,0,0],"behaviour":["Bounce","3.2","",""]},{"assetIdentifier":"moving_block_001","uniqueIdentifier":"736","position":[435.01,733.56,103.42],"scale":[4,4,4],"rotation":[0,0,0],"behaviour":["Speed","1.5","",""]},{"assetIdentifier":"moving_block_001","uniqueIdentifier":"737","position":[435.01,733.56,99.42],"scale":[4,4,4],"rotation":[0,0,0],"behaviour":["Speed","1.5","",""]},{"assetIdentifier":"moving_block_001","uniqueIdentifier":"738","position":[435.01,733.56,95.42],"scale":[4,4,4],"rotation":[0,0,0],"behaviour":["Speed","1.5","",""]},{"assetIdentifier":"moving_block_001","uniqueIdentifier":"739","position":[435.01,733.56,91.42],"scale":[4,4,4],"rotation":[0,0,0],"behaviour":["Speed","1.5","",""]},{"assetIdentifier":"moving_block_001","uniqueIdentifier":"740","position":[435.01,733.56,87.42],"scale":[4,4,4],"rotation":[0,0,0],"behaviour":["Speed","1.5","",""]},{"assetIdentifier":"moving_block_001","uniqueIdentifier":"741","position":[435.01,733.56,83.42],"scale":[4,4,4],"rotation":[0,0,0],"behaviour":["Speed","1.5","",""]},{"assetIdentifier":"moving_block_001","uniqueIdentifier":"742","position":[435.01,733.56,79.42],"scale":[4,4,4],"rotation":[0,0,0],"behaviour":["Speed","1.5","",""]},{"assetIdentifier":"moving_block_001","uniqueIdentifier":"743","position":[435.01,733.56,75.42],"scale":[4,4,4],"rotation":[0,0,0],"behaviour":["Speed","1.5","",""]},{"assetIdentifier":"moving_block_001","uniqueIdentifier":"744","position":[435.01,733.56,71.42],"scale":[4,4,4],"rotation":[0,0,0],"behaviour":["Speed","1.5","",""]},{"assetIdentifier":"moving_block_001","uniqueIdentifier":"745","position":[435.01,733.56,67.42],"scale":[4,4,4],"rotation":[0,0,0],"behaviour":["Speed","1.5","",""]},{"assetIdentifier":"moving_block_001","uniqueIdentifier":"746","position":[439.51,710.76,49.37],"scale":[4,4,4],"rotation":[0,0,0],"behaviour":["Speed","1.5","",""]},{"assetIdentifier":"moving_block_001","uniqueIdentifier":"747","position":[435.51,710.76,49.37],"scale":[4,4,4],"rotation":[0,0,0],"behaviour":["Speed","1.5","",""]},{"assetIdentifier":"moving_block_001","uniqueIdentifier":"748","position":[435.51,710.76,45.37],"scale":[4,4,4],"rotation":[0,0,0],"behaviour":["Speed","1.5","",""]},{"assetIdentifier":"moving_block_001","uniqueIdentifier":"749","position":[431.51,710.76,45.37],"scale":[4,4,4],"rotation":[0,0,0],"behaviour":["Speed","1.5","",""]},{"assetIdentifier":"moving_block_001","uniqueIdentifier":"750","position":[431.51,710.76,41.37],"scale":[4,4,4],"rotation":[0,0,0],"behaviour":["Speed","1.5","",""]},{"assetIdentifier":"moving_block_001","uniqueIdentifier":"751","position":[427.51,710.76,41.37],"scale":[4,4,4],"rotation":[0,0,0],"behaviour":["Speed","1.5","",""]},{"assetIdentifier":"moving_block_001","uniqueIdentifier":"752","position":[427.51,710.76,37.37],"scale":[4,4,4],"rotation":[0,0,0],"behaviour":["Speed","1.5","",""]},{"assetIdentifier":"moving_block_001","uniqueIdentifier":"753","position":[423.51,710.76,37.37],"scale":[4,4,4],"rotation":[0,0,0],"behaviour":["Speed","1.5","",""]},{"assetIdentifier":"moving_block_001","uniqueIdentifier":"754","position":[423.51,710.76,33.37],"scale":[4,4,4],"rotation":[0,0,0],"behaviour":["Speed","1.5","",""]},{"assetIdentifier":"moving_block_001","uniqueIdentifier":"755","position":[419.51,710.76,33.37],"scale":[4,4,4],"rotation":[0,0,0],"behaviour":["Speed","1.5","",""]},{"assetIdentifier":"check_point_001","uniqueIdentifier":"checkpoint_46","position":[420.78,803.5,94.96],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"check_point_001","uniqueIdentifier":"checkpoint_45","position":[439.28,790.5,47.46],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"check_point_001","uniqueIdentifier":"checkpoint_43","position":[376.51,701.5,-34.63],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"slow_block_001","uniqueIdentifier":"756","position":[410.28,740.5,91.96],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"slow_block_001","uniqueIdentifier":"757","position":[440.78,718,57.96],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"slow_block_001","uniqueIdentifier":"758","position":[403.28,718,57.96],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"slow_block_001","uniqueIdentifier":"759","position":[408.28,713,46.96],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"slow_block_001","uniqueIdentifier":"760","position":[426.28,787.5,48.46],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"slow_block_001","uniqueIdentifier":"761","position":[423.28,774,74.96],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"slow_block_001","uniqueIdentifier":"762","position":[426.28,796,40.96],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"slow_block_001","uniqueIdentifier":"763","position":[440.28,831,104.96],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"slow_block_001","uniqueIdentifier":"764","position":[433.28,827,104.96],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"slow_block_001","uniqueIdentifier":"765","position":[435.78,824,111.96],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"slow_block_001","uniqueIdentifier":"766","position":[442.78,820.5,111.96],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"slow_block_001","uniqueIdentifier":"767","position":[442.78,816.5,102.96],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"slow_block_001","uniqueIdentifier":"768","position":[447.78,812.5,93.96],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"slow_block_001","uniqueIdentifier":"769","position":[438.78,809,93.96],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"slow_block_001","uniqueIdentifier":"770","position":[428.78,805,93.96],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"slow_block_001","uniqueIdentifier":"771","position":[412.28,798.5,91.96],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"slow_block_001","uniqueIdentifier":"772","position":[413.28,798.5,49.46],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"slow_block_001","uniqueIdentifier":"773","position":[412.28,798.5,58.96],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"slow_block_001","uniqueIdentifier":"774","position":[415.28,781,59.46],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"slow_block_001","uniqueIdentifier":"775","position":[420.28,800.5,40.96],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"slow_block_001","uniqueIdentifier":"776","position":[433.78,794,40.96],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"slow_block_001","uniqueIdentifier":"777","position":[412.28,798.5,79.46],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"slow_block_001","uniqueIdentifier":"778","position":[412.28,798.5,69.96],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"slow_block_001","uniqueIdentifier":"779","position":[433.78,787.5,51.46],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"slow_block_001","uniqueIdentifier":"780","position":[421.78,786,54.96],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"slow_block_001","uniqueIdentifier":"781","position":[420.28,776,67.96],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"check_point_001","uniqueIdentifier":"checkpoint_44","position":[422.19,762.5,107.53],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"slow_block_001","uniqueIdentifier":"782","position":[454.28,833,92.46],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"slow_block_001","uniqueIdentifier":"783","position":[454.28,832.5,83.96],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"slow_block_001","uniqueIdentifier":"784","position":[454.28,831.5,75.46],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"slow_block_001","uniqueIdentifier":"785","position":[454.28,830,66.46],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"slippery_block_001","uniqueIdentifier":"786","position":[454.28,826,58.46],"scale":[4,4,4],"rotation":[0,0,3.14],"behaviour":["Speed","0.64","",""]},{"assetIdentifier":"slow_block_001","uniqueIdentifier":"787","position":[454.28,816,58.46],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"slippery_block_001","uniqueIdentifier":"788","position":[454.28,814.5,67.46],"scale":[4,4,4],"rotation":[0,0,3.14],"behaviour":["Speed","0.64","",""]},{"assetIdentifier":"slow_block_001","uniqueIdentifier":"789","position":[454.28,804.5,67.46],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"slow_block_001","uniqueIdentifier":"790","position":[454.28,793,76.46],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"slow_block_001","uniqueIdentifier":"791","position":[454.28,788,84.46],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"slow_block_001","uniqueIdentifier":"792","position":[454.28,784,92.96],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"slow_block_001","uniqueIdentifier":"793","position":[445.78,779,92.96],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"slow_block_001","uniqueIdentifier":"794","position":[441.78,775,100.46],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"slow_block_001","uniqueIdentifier":"795","position":[434.28,775,90.96],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"slow_block_001","uniqueIdentifier":"796","position":[431.28,772,81.46],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"slow_block_001","uniqueIdentifier":"797","position":[421.78,770,81.46],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"slow_block_001","uniqueIdentifier":"798","position":[421.78,766,89.96],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"799","position":[419.51,709,20.87],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"800","position":[419.51,721,20.87],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"801","position":[419.51,717,20.87],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"802","position":[419.51,713,20.87],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"803","position":[403.51,709,20.87],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"804","position":[403.51,721,20.87],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"805","position":[403.51,717,20.87],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"806","position":[403.51,713,20.87],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"slow_block_001","uniqueIdentifier":"807","position":[421.78,762,97.46],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"square_005","uniqueIdentifier":"808","position":[430.76,756,134.12],"scale":[85.5,4,22.5],"rotation":[0,0,0]},{"assetIdentifier":"square_005","uniqueIdentifier":"809","position":[430.76,756,63.12],"scale":[85.5,4,80.5],"rotation":[0,0,0]},{"assetIdentifier":"slow_block_001","uniqueIdentifier":"810","position":[422.28,759.5,114.46],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"slow_block_001","uniqueIdentifier":"811","position":[416.28,755,115.46],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"slow_block_001","uniqueIdentifier":"812","position":[409.78,751,115.46],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"slow_block_001","uniqueIdentifier":"813","position":[409.28,746.5,109.46],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"slow_block_001","uniqueIdentifier":"814","position":[416.28,742.5,109.46],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"slow_block_001","uniqueIdentifier":"815","position":[422.28,737.5,109.46],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"slow_block_001","uniqueIdentifier":"816","position":[448.78,712,125.96],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"slow_block_001","uniqueIdentifier":"817","position":[415.78,712,122.96],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"slow_block_001","uniqueIdentifier":"818","position":[399.78,714,109.96],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"slow_block_001","uniqueIdentifier":"819","position":[399.78,712,109.96],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"slow_block_001","uniqueIdentifier":"820","position":[406.78,712,70.96],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"slow_block_001","uniqueIdentifier":"821","position":[399.78,712,46.96],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"slow_block_001","uniqueIdentifier":"822","position":[447.78,713,84.96],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"823","position":[417.3,736,98.93],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"824","position":[417.3,736,94.93],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"825","position":[417.3,736,90.93],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"826","position":[417.3,736,86.93],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"827","position":[417.3,736,82.93],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"828","position":[417.3,736,78.93],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"829","position":[417.3,736,74.93],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"830","position":[417.3,736,70.93],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"831","position":[417.3,736,66.93],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"832","position":[427.8,736,98.93],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"833","position":[427.8,736,94.93],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"834","position":[427.8,736,90.93],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"835","position":[427.8,736,86.93],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"836","position":[427.8,736,82.93],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"837","position":[427.8,736,78.93],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"838","position":[427.8,736,74.93],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"839","position":[427.8,736,70.93],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"840","position":[415.51,717,24.87],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"841","position":[415.51,720.5,24.87],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"842","position":[407.51,720.5,24.87],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"843","position":[407.51,717,24.87],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"844","position":[407.51,713,24.87],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"square_005","uniqueIdentifier":"845","position":[411.51,738.25,27.12],"scale":[12,31.5,8.5],"rotation":[0,0,0]},{"assetIdentifier":"square_005","uniqueIdentifier":"846","position":[399.51,732.5,27.12],"scale":[12,43,8.5],"rotation":[0,0,0]},{"assetIdentifier":"square_005","uniqueIdentifier":"847","position":[442.76,732.5,27.12],"scale":[50.5,43,8.5],"rotation":[0,0,0]},{"assetIdentifier":"square_005","uniqueIdentifier":"848","position":[430.76,732.5,141.12],"scale":[74.5,43,8.5],"rotation":[0,0,0]},{"assetIdentifier":"square_005","uniqueIdentifier":"849","position":[390.76,732.5,84.12],"scale":[5.5,43,122.5],"rotation":[0,0,0]},{"assetIdentifier":"square_005","uniqueIdentifier":"850","position":[470.76,732.5,84.12],"scale":[5.5,43,122.5],"rotation":[0,0,0]},{"assetIdentifier":"square_005","uniqueIdentifier":"851","position":[430.76,709,84.12],"scale":[85.5,4,122.5],"rotation":[0,0,0]},{"assetIdentifier":"square_005","uniqueIdentifier":"852","position":[410.01,710,14.87],"scale":[4,2,4],"rotation":[0,0,0]},{"assetIdentifier":"square_005","uniqueIdentifier":"853","position":[403.51,710,4.37],"scale":[4,2,4],"rotation":[0,0,0]},{"assetIdentifier":"square_005","uniqueIdentifier":"854","position":[396.51,707,-4.13],"scale":[4,2,4],"rotation":[0,0,0]},{"assetIdentifier":"square_005","uniqueIdentifier":"855","position":[388.51,705,-13.13],"scale":[4,2,4],"rotation":[0,0,0]},{"assetIdentifier":"square_005","uniqueIdentifier":"856","position":[381.01,705,-22.13],"scale":[4,2,4],"rotation":[0,0,0]},{"assetIdentifier":"square_005","uniqueIdentifier":"857","position":[381.01,701.5,-28.13],"scale":[4,2,4],"rotation":[0,0,0]},{"assetIdentifier":"square_005","uniqueIdentifier":"858","position":[351.51,699,-33.63],"scale":[2,2,8],"rotation":[0,0,0]},{"assetIdentifier":"square_005","uniqueIdentifier":"859","position":[351.51,696.5,-22.38],"scale":[2,2,11.5],"rotation":[0,0,0]},{"assetIdentifier":"square_005","uniqueIdentifier":"860","position":[356.76,696.5,-17.63],"scale":[8.5,2,2],"rotation":[0,0,0]},{"assetIdentifier":"square_005","uniqueIdentifier":"861","position":[360.01,696.5,-14.38],"scale":[2,2,4.5],"rotation":[0,0,0]},{"assetIdentifier":"square_006","uniqueIdentifier":"862","position":[384.86,709,16.57],"scale":[2,2,4],"rotation":[0,0,3.14]},{"assetIdentifier":"square_006","uniqueIdentifier":"863","position":[384.86,711.5,19.57],"scale":[2,7,2],"rotation":[0,0,0]},{"assetIdentifier":"square_006","uniqueIdentifier":"864","position":[384.86,716,17.57],"scale":[2,2,6],"rotation":[0,0,0]},{"assetIdentifier":"square_006","uniqueIdentifier":"865","position":[384.86,710,13.57],"scale":[2,14,2],"rotation":[0,0,0]},{"assetIdentifier":"square_006","uniqueIdentifier":"866","position":[384.86,710,8.57],"scale":[2,14,2],"rotation":[0,0,0]},{"assetIdentifier":"square_001","uniqueIdentifier":"867","position":[382.86,717,17.57],"scale":[2,2,8],"rotation":[0,0,3.14]},{"assetIdentifier":"square_001","uniqueIdentifier":"868","position":[382.86,710,18.57],"scale":[2,2,6],"rotation":[0,0,3.14]},{"assetIdentifier":"square_001","uniqueIdentifier":"869","position":[382.86,713.5,20.57],"scale":[2,5,2],"rotation":[0,0,0]},{"assetIdentifier":"square_001","uniqueIdentifier":"870","position":[382.86,710,14.57],"scale":[2,12,2],"rotation":[0,0,0]},{"assetIdentifier":"square_001","uniqueIdentifier":"871","position":[382.86,711,9.57],"scale":[2,14,2],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"872","position":[356.51,698.5,0.37],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"square_005","uniqueIdentifier":"873","position":[359.51,696.5,-4.38],"scale":[8,2,15.5],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"874","position":[362.51,698.5,0.37],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"square_001","uniqueIdentifier":"875","position":[382.86,711,2.07],"scale":[2,14,2],"rotation":[0,0,0]},{"assetIdentifier":"square_001","uniqueIdentifier":"876","position":[382.86,705,5.82],"scale":[2,2,5.5],"rotation":[0,0,3.14]},{"assetIdentifier":"square_006","uniqueIdentifier":"877","position":[384.86,704,4.82],"scale":[2,2,5.5],"rotation":[0,0,0]},{"assetIdentifier":"square_006","uniqueIdentifier":"878","position":[386.86,710,3.57],"scale":[2,14,2],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"879","position":[415.51,713,24.87],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"toaster_001","uniqueIdentifier":"880","position":[422.51,724.01,80.05],"scale":[21,21,21],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"881","position":[427.8,736,66.93],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"slow_block_001","uniqueIdentifier":"882","position":[445.78,712,67.46],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"slippery_block_001","uniqueIdentifier":"883","position":[454.28,803,76.46],"scale":[4,4,4],"rotation":[0,0,3.14],"behaviour":["Speed","0.64","",""]},{"assetIdentifier":"baking_tray_002","uniqueIdentifier":"884","position":[67.54,3.5,-46.59],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"slow_block_001","uniqueIdentifier":"885","position":[79.49,1,-20],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"slow_block_001","uniqueIdentifier":"886","position":[67.74,1,-5],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"slow_block_001","uniqueIdentifier":"887","position":[104.24,1,-12],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"slow_block_001","uniqueIdentifier":"888","position":[75.24,1,-34.75],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"moving_block_001","uniqueIdentifier":"889","position":[117.76,2,-52.95],"scale":[4,4,4],"rotation":[0,0,0],"behaviour":["Speed","3","",""]},{"assetIdentifier":"slippery_block_001","uniqueIdentifier":"890","position":[117.76,2,1.8],"scale":[4,4,4],"rotation":[0,0,0],"behaviour":["Speed","0.15","",""]},{"assetIdentifier":"square_002","uniqueIdentifier":"891","position":[90.26,13.13,2.8],"scale":[29,26.25,2],"rotation":[0,0,0]},{"assetIdentifier":"square_001","uniqueIdentifier":"892","position":[90.26,23.18,1.55],"scale":[28,2.5,0.5],"rotation":[0,0,0]},{"assetIdentifier":"square_001","uniqueIdentifier":"893","position":[90.26,19.75,1.55],"scale":[28,0.5,0.5],"rotation":[0,0,0]},{"assetIdentifier":"square_001","uniqueIdentifier":"894","position":[90.76,23.18,-52.7],"scale":[28,2.5,0.5],"rotation":[0,0,0]},{"assetIdentifier":"square_001","uniqueIdentifier":"895","position":[90.76,19.75,-52.7],"scale":[28,0.5,0.5],"rotation":[0,0,0]},{"assetIdentifier":"moving_block_001","uniqueIdentifier":"896","position":[29.01,-2,-13.45],"scale":[4,4,4],"rotation":[0,0,0],"behaviour":["Speed","1.36","",""]},{"assetIdentifier":"moving_block_001","uniqueIdentifier":"897","position":[25.01,-2,-13.45],"scale":[4,4,4],"rotation":[0,0,0],"behaviour":["Speed","1.36","",""]},{"assetIdentifier":"moving_block_001","uniqueIdentifier":"898","position":[21.01,-2,-13.45],"scale":[4,4,4],"rotation":[0,0,0],"behaviour":["Speed","1.36","",""]},{"assetIdentifier":"moving_block_001","uniqueIdentifier":"899","position":[17.01,-2,-13.45],"scale":[4,4,4],"rotation":[0,0,0],"behaviour":["Speed","1.36","",""]},{"assetIdentifier":"square_001","uniqueIdentifier":"900","position":[117.51,23.18,-23.2],"scale":[0.5,2.5,27.5],"rotation":[0,0,0]},{"assetIdentifier":"square_002","uniqueIdentifier":"901","position":[118.93,13.13,-23.18],"scale":[2,26.25,28.76],"rotation":[0,0,0]},{"assetIdentifier":"square_002","uniqueIdentifier":"902","position":[90.76,13.13,-53.95],"scale":[29,26.25,2],"rotation":[0,0,0]},{"assetIdentifier":"square_001","uniqueIdentifier":"903","position":[105.01,17,-52.7],"scale":[0.5,2,0.5],"rotation":[0,4.71,0]},{"assetIdentifier":"square_001","uniqueIdentifier":"904","position":[105.01,15,-52.7],"scale":[0.5,2,0.5],"rotation":[0,4.71,0]},{"assetIdentifier":"square_001","uniqueIdentifier":"905","position":[105.01,13,-52.7],"scale":[0.5,2,0.5],"rotation":[0,4.71,0]},{"assetIdentifier":"square_001","uniqueIdentifier":"906","position":[105.01,11,-52.7],"scale":[0.5,2,0.5],"rotation":[0,4.71,0]},{"assetIdentifier":"square_001","uniqueIdentifier":"907","position":[76.51,19,-52.7],"scale":[0.5,2,0.5],"rotation":[0,4.71,0]},{"assetIdentifier":"square_001","uniqueIdentifier":"908","position":[76.51,17,-52.7],"scale":[0.5,2,0.5],"rotation":[0,4.71,0]},{"assetIdentifier":"square_001","uniqueIdentifier":"909","position":[76.51,15,-52.7],"scale":[0.5,2,0.5],"rotation":[0,4.71,0]},{"assetIdentifier":"square_001","uniqueIdentifier":"910","position":[76.51,11,-52.7],"scale":[0.5,2,0.5],"rotation":[0,4.71,0]},{"assetIdentifier":"square_001","uniqueIdentifier":"911","position":[76.51,13,-52.7],"scale":[0.5,2,0.5],"rotation":[0,4.71,0]},{"assetIdentifier":"square_001","uniqueIdentifier":"912","position":[105.01,9,-52.7],"scale":[0.5,2,0.5],"rotation":[0,4.71,0]},{"assetIdentifier":"square_001","uniqueIdentifier":"913","position":[105.01,7,-52.7],"scale":[0.5,2,0.5],"rotation":[0,4.71,0]},{"assetIdentifier":"square_001","uniqueIdentifier":"914","position":[105.01,5,-52.7],"scale":[0.5,2,0.5],"rotation":[0,4.71,0]},{"assetIdentifier":"square_001","uniqueIdentifier":"915","position":[105.01,3,-52.7],"scale":[0.5,2,0.5],"rotation":[0,4.71,0]},{"assetIdentifier":"square_001","uniqueIdentifier":"916","position":[105.01,1,-52.7],"scale":[0.5,2,0.5],"rotation":[0,4.71,0]},{"assetIdentifier":"square_001","uniqueIdentifier":"917","position":[76.51,9,-52.7],"scale":[0.5,2,0.5],"rotation":[0,4.71,0]},{"assetIdentifier":"square_001","uniqueIdentifier":"918","position":[76.51,7,-52.7],"scale":[0.5,2,0.5],"rotation":[0,4.71,0]},{"assetIdentifier":"square_001","uniqueIdentifier":"919","position":[76.51,5,-52.7],"scale":[0.5,2,0.5],"rotation":[0,4.71,0]},{"assetIdentifier":"square_001","uniqueIdentifier":"920","position":[76.51,3,-52.7],"scale":[0.5,2,0.5],"rotation":[0,4.71,0]},{"assetIdentifier":"square_001","uniqueIdentifier":"921","position":[76.51,1,-52.7],"scale":[0.5,2,0.5],"rotation":[0,4.71,0]},{"assetIdentifier":"square_001","uniqueIdentifier":"922","position":[105.01,19,-52.7],"scale":[0.5,2,0.5],"rotation":[0,4.71,0]},{"assetIdentifier":"square_001","uniqueIdentifier":"923","position":[91.89,-3,-25.58],"scale":[55.75,6,58.75],"rotation":[0,0,0]},{"assetIdentifier":"square_001","uniqueIdentifier":"924","position":[53.51,-3,-24.7],"scale":[21,6,12],"rotation":[0,0,0]},{"assetIdentifier":"square_001","uniqueIdentifier":"925","position":[37.01,-3,-13.33],"scale":[12,6,34.75],"rotation":[0,0,0]},{"assetIdentifier":"slow_block_001","uniqueIdentifier":"926","position":[31.46,32.25,178.21],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"slow_block_001","uniqueIdentifier":"927","position":[37.21,30.25,179.21],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"slow_block_001","uniqueIdentifier":"928","position":[42.46,29,182.46],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"square_006","uniqueIdentifier":"929","position":[38.51,25.75,186.3],"scale":[4,3,4],"rotation":[0,0,0]},{"assetIdentifier":"square_006","uniqueIdentifier":"930","position":[31.51,24.75,186.8],"scale":[4,3,4],"rotation":[0,0,0]},{"assetIdentifier":"square_006","uniqueIdentifier":"931","position":[28.76,21.5,180.8],"scale":[4,3,4],"rotation":[0,0,0]},{"assetIdentifier":"slow_block_001","uniqueIdentifier":"932","position":[-19.77,59.25,115.55],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"slow_block_001","uniqueIdentifier":"933","position":[-19.27,56.25,110.55],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"slow_block_001","uniqueIdentifier":"934","position":[-19.02,53.5,105.55],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"slippery_block_001","uniqueIdentifier":"935","position":[-15.02,53.5,105.55],"scale":[4,4,4],"rotation":[0,0,0],"behaviour":["Speed","0.64","",""]},{"assetIdentifier":"slippery_block_001","uniqueIdentifier":"936","position":[-11.02,53.5,105.55],"scale":[4,4,4],"rotation":[0,0,0],"behaviour":["Speed","0.64","",""]},{"assetIdentifier":"slippery_block_001","uniqueIdentifier":"937","position":[-7.02,53.5,105.55],"scale":[4,4,4],"rotation":[0,0,0],"behaviour":["Speed","0.64","",""]},{"assetIdentifier":"slippery_block_001","uniqueIdentifier":"938","position":[-3.02,53.5,105.55],"scale":[4,4,4],"rotation":[0,0,0],"behaviour":["Speed","0.64","",""]},{"assetIdentifier":"slippery_block_001","uniqueIdentifier":"939","position":[0.98,53.5,105.55],"scale":[4,4,4],"rotation":[0,0,0],"behaviour":["Speed","0.64","",""]},{"assetIdentifier":"slippery_block_001","uniqueIdentifier":"940","position":[4.98,53.5,105.55],"scale":[4,4,4],"rotation":[0,0,0],"behaviour":["Speed","0.64","",""]},{"assetIdentifier":"slippery_block_001","uniqueIdentifier":"941","position":[8.98,53.5,105.55],"scale":[4,4,4],"rotation":[0,0,0],"behaviour":["Speed","0.64","",""]},{"assetIdentifier":"square_003","uniqueIdentifier":"942","position":[9.01,4.5,75.05],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"square_003","uniqueIdentifier":"943","position":[6.01,4.5,75.05],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"square_008","uniqueIdentifier":"944","position":[23.91,20.25,127.75],"scale":[19.03,1.5,2.5],"rotation":[0,0,0]},{"assetIdentifier":"square_008","uniqueIdentifier":"945","position":[15.64,20.25,113.88],"scale":[2.5,1.5,25.25],"rotation":[0,0,0]},{"assetIdentifier":"square_007","uniqueIdentifier":"946","position":[-2.03,19,108.06],"scale":[4,2,4.5],"rotation":[0,0,0]},{"assetIdentifier":"square_007","uniqueIdentifier":"947","position":[-8.53,13.5,101.06],"scale":[5,2,6.5],"rotation":[0,0,0]},{"assetIdentifier":"square_006","uniqueIdentifier":"948","position":[-7.74,16.25,108.55],"scale":[5.5,2.5,5],"rotation":[0,0,0]},{"assetIdentifier":"square_003","uniqueIdentifier":"949","position":[7.76,7.5,83.3],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"square_003","uniqueIdentifier":"950","position":[4.76,7.5,83.3],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"square_003","uniqueIdentifier":"951","position":[9.01,1.5,66.05],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"square_003","uniqueIdentifier":"952","position":[9.01,4.5,72.05],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"square_003","uniqueIdentifier":"953","position":[9.01,1.5,63.05],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"square_003","uniqueIdentifier":"954","position":[9.01,1.5,69.05],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"square_003","uniqueIdentifier":"955","position":[7.76,7.5,80.3],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"square_003","uniqueIdentifier":"956","position":[9.01,1.5,60.05],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"square_003","uniqueIdentifier":"957","position":[4.76,7.5,80.3],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"square_003","uniqueIdentifier":"958","position":[6.01,4.5,72.05],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"square_003","uniqueIdentifier":"959","position":[6.01,1.5,69.05],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"square_003","uniqueIdentifier":"960","position":[6.01,1.5,66.05],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"square_003","uniqueIdentifier":"961","position":[6.01,1.5,63.05],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"square_003","uniqueIdentifier":"962","position":[6.01,1.5,60.05],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"square_002","uniqueIdentifier":"963","position":[-6.49,3.75,-20.95],"scale":[9,7.5,2],"rotation":[0,0,0]},{"assetIdentifier":"square_002","uniqueIdentifier":"964","position":[6.51,3.75,-20.95],"scale":[9,7.5,2],"rotation":[0,0,0]},{"assetIdentifier":"chocolate_001","uniqueIdentifier":"965","position":[-14.46,0,7.26],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"vanilla_001","uniqueIdentifier":"966","position":[-7.4,0,-25.54],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"fridge_001","uniqueIdentifier":"967","position":[7.18,2.56,-25.9],"scale":[0.45,0.45,0.45],"rotation":[0,0,0]},{"assetIdentifier":"square_006","uniqueIdentifier":"968","position":[-60.72,8.5,-9.76],"scale":[12,2,7.5],"rotation":[0,0,0]},{"assetIdentifier":"square_006","uniqueIdentifier":"969","position":[-77.22,14.75,-11.77],"scale":[4,10.5,27.53],"rotation":[0,0,0]},{"assetIdentifier":"square_006","uniqueIdentifier":"970","position":[-77.97,8.5,-11.77],"scale":[22.5,2,27.53],"rotation":[0,0,0]},{"assetIdentifier":"square_001","uniqueIdentifier":"971","position":[76.01,17,1.55],"scale":[0.5,2,0.5],"rotation":[0,1.57,0]},{"assetIdentifier":"square_001","uniqueIdentifier":"972","position":[76.01,15,1.55],"scale":[0.5,2,0.5],"rotation":[0,1.57,0]},{"assetIdentifier":"square_001","uniqueIdentifier":"973","position":[76.01,13,1.55],"scale":[0.5,2,0.5],"rotation":[0,1.57,0]},{"assetIdentifier":"square_001","uniqueIdentifier":"974","position":[76.01,11,1.55],"scale":[0.5,2,0.5],"rotation":[0,1.57,0]},{"assetIdentifier":"square_001","uniqueIdentifier":"975","position":[104.51,19,1.55],"scale":[0.5,2,0.5],"rotation":[0,1.57,0]},{"assetIdentifier":"square_001","uniqueIdentifier":"976","position":[104.51,17,1.55],"scale":[0.5,2,0.5],"rotation":[0,1.57,0]},{"assetIdentifier":"square_001","uniqueIdentifier":"977","position":[104.51,15,1.55],"scale":[0.5,2,0.5],"rotation":[0,1.57,0]},{"assetIdentifier":"square_001","uniqueIdentifier":"978","position":[104.51,11,1.55],"scale":[0.5,2,0.5],"rotation":[0,1.57,0]},{"assetIdentifier":"square_001","uniqueIdentifier":"979","position":[104.51,13,1.55],"scale":[0.5,2,0.5],"rotation":[0,1.57,0]},{"assetIdentifier":"square_001","uniqueIdentifier":"980","position":[76.01,9,1.55],"scale":[0.5,2,0.5],"rotation":[0,1.57,0]},{"assetIdentifier":"square_001","uniqueIdentifier":"981","position":[76.01,7,1.55],"scale":[0.5,2,0.5],"rotation":[0,1.57,0]},{"assetIdentifier":"square_001","uniqueIdentifier":"982","position":[76.01,5,1.55],"scale":[0.5,2,0.5],"rotation":[0,1.57,0]},{"assetIdentifier":"square_001","uniqueIdentifier":"983","position":[76.01,3,1.55],"scale":[0.5,2,0.5],"rotation":[0,1.57,0]},{"assetIdentifier":"square_001","uniqueIdentifier":"984","position":[76.01,1,1.55],"scale":[0.5,2,0.5],"rotation":[0,1.57,0]},{"assetIdentifier":"square_001","uniqueIdentifier":"985","position":[104.51,9,1.55],"scale":[0.5,2,0.5],"rotation":[0,1.57,0]},{"assetIdentifier":"square_001","uniqueIdentifier":"986","position":[104.51,7,1.55],"scale":[0.5,2,0.5],"rotation":[0,1.57,0]},{"assetIdentifier":"square_001","uniqueIdentifier":"987","position":[104.51,5,1.55],"scale":[0.5,2,0.5],"rotation":[0,1.57,0]},{"assetIdentifier":"square_001","uniqueIdentifier":"988","position":[104.51,3,1.55],"scale":[0.5,2,0.5],"rotation":[0,1.57,0]},{"assetIdentifier":"square_001","uniqueIdentifier":"989","position":[104.51,1,1.55],"scale":[0.5,2,0.5],"rotation":[0,1.57,0]},{"assetIdentifier":"square_001","uniqueIdentifier":"990","position":[76.01,19,1.55],"scale":[0.5,2,0.5],"rotation":[0,1.57,0]},{"assetIdentifier":"invisible_square_001","uniqueIdentifier":"991","position":[-48.22,9,-6.26],"scale":[3,1,13.5],"rotation":[0,0,0]},{"assetIdentifier":"invisible_square_001","uniqueIdentifier":"992","position":[-41.22,9,-0.26],"scale":[3,1,9.5],"rotation":[0,0,0]},{"assetIdentifier":"invisible_square_001","uniqueIdentifier":"993","position":[-34.22,9,-8.51],"scale":[3,1,17],"rotation":[0,0,0]},{"assetIdentifier":"square_001","uniqueIdentifier":"994","position":[84.39,37.2,-195.07],"scale":[17.5,10,3],"rotation":[0,0,0]},{"assetIdentifier":"square_001","uniqueIdentifier":"995","position":[94.89,37.2,-182.32],"scale":[3.5,10,28.5],"rotation":[0,0,0]},{"assetIdentifier":"square_001","uniqueIdentifier":"996","position":[73.89,37.2,-182.32],"scale":[3.5,10,28.5],"rotation":[0,0,0]},{"assetIdentifier":"square_001","uniqueIdentifier":"997","position":[84.39,37.2,-166.07],"scale":[24.5,10,4],"rotation":[0,0,0]},{"assetIdentifier":"square_001","uniqueIdentifier":"998","position":[84.39,30.2,-176.32],"scale":[24.5,4,40.5],"rotation":[0,0,0]},{"assetIdentifier":"invisible_square_001","uniqueIdentifier":"999","position":[80.39,21.7,-156.57],"scale":[16.5,13,1],"rotation":[0,0,0]},{"assetIdentifier":"pepper","uniqueIdentifier":"1000","position":[99.09,15.38,-143.35],"scale":[1,1,1],"rotation":[0,0,0]},{"assetIdentifier":"salt","uniqueIdentifier":"1001","position":[99.21,15.38,-143.92],"scale":[1,1,1],"rotation":[0,0,0]},{"assetIdentifier":"toaster_001","uniqueIdentifier":"1002","position":[99.67,15.82,-141.88],"scale":[1,1,1],"rotation":[0,0,0]},{"assetIdentifier":"square_008","uniqueIdentifier":"1003","position":[89.64,16.2,-155.07],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"square_007","uniqueIdentifier":"1004","position":[91.64,16.2,-155.07],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"square_006","uniqueIdentifier":"1005","position":[93.64,16.2,-155.07],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"square_005","uniqueIdentifier":"1006","position":[95.64,16.2,-155.07],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"square_004","uniqueIdentifier":"1007","position":[97.64,16.2,-155.07],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"square_003","uniqueIdentifier":"1008","position":[99.64,16.2,-155.07],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"square_002","uniqueIdentifier":"1009","position":[101.64,16.2,-155.07],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"square_001","uniqueIdentifier":"1010","position":[103.64,16.2,-155.07],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"square_001","uniqueIdentifier":"1011","position":[88.39,13.2,-142.57],"scale":[32.5,4,27],"rotation":[0,0,0]},{"assetIdentifier":"square_001","uniqueIdentifier":"1012","position":[65.14,13.2,-131.07],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"square_001","uniqueIdentifier":"1013","position":[55.64,13.2,-131.07],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"square_001","uniqueIdentifier":"1014","position":[47.14,13.2,-131.07],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"square_001","uniqueIdentifier":"1015","position":[47.14,13.2,-122.57],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"square_001","uniqueIdentifier":"1016","position":[47.14,13.2,-114.57],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"square_002","uniqueIdentifier":"1017","position":[118.76,19,-23.2],"scale":[2,2,29],"rotation":[0,0,0]},{"assetIdentifier":"square_002","uniqueIdentifier":"1018","position":[118.76,17,-23.2],"scale":[2,2,29],"rotation":[0,0,0]},{"assetIdentifier":"square_002","uniqueIdentifier":"1019","position":[118.76,15,-23.2],"scale":[2,2,29],"rotation":[0,0,0]},{"assetIdentifier":"square_002","uniqueIdentifier":"1020","position":[118.76,13,-23.2],"scale":[2,2,29],"rotation":[0,0,0]},{"assetIdentifier":"square_002","uniqueIdentifier":"1021","position":[118.76,11,-23.2],"scale":[2,2,29],"rotation":[0,0,0]},{"assetIdentifier":"square_002","uniqueIdentifier":"1022","position":[118.76,1,-23.2],"scale":[2,2,29],"rotation":[0,0,0]},{"assetIdentifier":"square_002","uniqueIdentifier":"1023","position":[118.76,5,-23.2],"scale":[2,2,29],"rotation":[0,0,0]},{"assetIdentifier":"square_002","uniqueIdentifier":"1024","position":[118.76,9,-23.2],"scale":[2,2,29],"rotation":[0,0,0]},{"assetIdentifier":"square_002","uniqueIdentifier":"1025","position":[118.76,3,-23.2],"scale":[2,2,29],"rotation":[0,0,0]},{"assetIdentifier":"square_002","uniqueIdentifier":"1026","position":[118.76,7,-23.2],"scale":[2,2,29],"rotation":[0,0,0]},{"assetIdentifier":"square_001","uniqueIdentifier":"1027","position":[117.51,17,-8.95],"scale":[0.5,2,0.5],"rotation":[0,0,0]},{"assetIdentifier":"square_001","uniqueIdentifier":"1028","position":[117.51,15,-8.95],"scale":[0.5,2,0.5],"rotation":[0,0,0]},{"assetIdentifier":"square_001","uniqueIdentifier":"1029","position":[117.51,13,-8.95],"scale":[0.5,2,0.5],"rotation":[0,0,0]},{"assetIdentifier":"square_001","uniqueIdentifier":"1030","position":[117.51,11,-8.95],"scale":[0.5,2,0.5],"rotation":[0,0,0]},{"assetIdentifier":"square_001","uniqueIdentifier":"1031","position":[117.51,19,-37.45],"scale":[0.5,2,0.5],"rotation":[0,0,0]},{"assetIdentifier":"square_001","uniqueIdentifier":"1032","position":[117.51,17,-37.45],"scale":[0.5,2,0.5],"rotation":[0,0,0]},{"assetIdentifier":"square_001","uniqueIdentifier":"1033","position":[117.51,15,-37.45],"scale":[0.5,2,0.5],"rotation":[0,0,0]},{"assetIdentifier":"square_001","uniqueIdentifier":"1034","position":[117.51,11,-37.45],"scale":[0.5,2,0.5],"rotation":[0,0,0]},{"assetIdentifier":"square_001","uniqueIdentifier":"1035","position":[117.51,13,-37.45],"scale":[0.5,2,0.5],"rotation":[0,0,0]},{"assetIdentifier":"square_001","uniqueIdentifier":"1036","position":[117.51,9,-8.95],"scale":[0.5,2,0.5],"rotation":[0,0,0]},{"assetIdentifier":"square_001","uniqueIdentifier":"1037","position":[117.51,7,-8.95],"scale":[0.5,2,0.5],"rotation":[0,0,0]},{"assetIdentifier":"square_001","uniqueIdentifier":"1038","position":[117.51,5,-8.95],"scale":[0.5,2,0.5],"rotation":[0,0,0]},{"assetIdentifier":"square_001","uniqueIdentifier":"1039","position":[117.51,3,-8.95],"scale":[0.5,2,0.5],"rotation":[0,0,0]},{"assetIdentifier":"square_001","uniqueIdentifier":"1040","position":[117.51,1,-8.95],"scale":[0.5,2,0.5],"rotation":[0,0,0]},{"assetIdentifier":"square_001","uniqueIdentifier":"1041","position":[117.51,9,-37.45],"scale":[0.5,2,0.5],"rotation":[0,0,0]},{"assetIdentifier":"square_001","uniqueIdentifier":"1042","position":[117.51,7,-37.45],"scale":[0.5,2,0.5],"rotation":[0,0,0]},{"assetIdentifier":"square_001","uniqueIdentifier":"1043","position":[117.51,5,-37.45],"scale":[0.5,2,0.5],"rotation":[0,0,0]},{"assetIdentifier":"square_001","uniqueIdentifier":"1044","position":[117.51,3,-37.45],"scale":[0.5,2,0.5],"rotation":[0,0,0]},{"assetIdentifier":"square_001","uniqueIdentifier":"1045","position":[117.51,1,-37.45],"scale":[0.5,2,0.5],"rotation":[0,0,0]},{"assetIdentifier":"square_001","uniqueIdentifier":"1046","position":[117.51,19.75,-23.2],"scale":[0.5,0.5,28],"rotation":[0,0,0]},{"assetIdentifier":"square_001","uniqueIdentifier":"1047","position":[117.51,19,-8.95],"scale":[0.5,2,0.5],"rotation":[0,0,0]},{"assetIdentifier":"invisible_square_001","uniqueIdentifier":"1048","position":[47.14,13.2,-105.57],"scale":[4,4,10],"rotation":[0,0,0]},{"assetIdentifier":"invisible_square_001","uniqueIdentifier":"1049","position":[47.14,13.2,-91.07],"scale":[4,4,10],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1050","position":[-4.49,2,-78.81],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1051","position":[-0.49,2,-78.81],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1052","position":[3.51,2,-78.81],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"check_point_001","uniqueIdentifier":"checkpoint_6","position":[15.26,53,149.05],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"check_point_001","uniqueIdentifier":"checkpoint_5","position":[21.07,35.5,174.65],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"check_point_001","uniqueIdentifier":"checkpoint_3","position":[-1.11,20,103.5],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"check_point_001","uniqueIdentifier":"checkpoint_1","position":[-2.5,-0.98,-6.15],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"square_002","uniqueIdentifier":"1053","position":[-4.24,2,-92.95],"scale":[13.5,4,2],"rotation":[0,0,0]},{"assetIdentifier":"square_002","uniqueIdentifier":"1054","position":[0.01,3.75,-40.95],"scale":[22,7.5,2],"rotation":[0,0,0]},{"assetIdentifier":"square_002","uniqueIdentifier":"1055","position":[0.01,1,-60.45],"scale":[22,2,2],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1056","position":[31.01,29,152.55],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"square_003","uniqueIdentifier":"1057","position":[16.01,49,171.55],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"square_003","uniqueIdentifier":"1058","position":[15.01,51,166.05],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"square_003","uniqueIdentifier":"1059","position":[17.01,51,166.05],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"square_003","uniqueIdentifier":"1060","position":[19.01,51,166.05],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"square_003","uniqueIdentifier":"1061","position":[16.01,49,177.55],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"square_003","uniqueIdentifier":"1062","position":[14.51,49,185.55],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"square_003","uniqueIdentifier":"1063","position":[7.51,47,185.55],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"square_003","uniqueIdentifier":"1064","position":[1.01,45,185.55],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"square_003","uniqueIdentifier":"1065","position":[1.01,43.5,180.05],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"square_003","uniqueIdentifier":"1066","position":[1.01,41.5,173.55],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"square_003","uniqueIdentifier":"1067","position":[7.51,39,173.55],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"square_003","uniqueIdentifier":"1068","position":[14.51,36.5,173.55],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"bowl_002","uniqueIdentifier":"1069","position":[55.08,-0.93,-55.15],"scale":[6,6,6],"rotation":[0,0,0]},{"assetIdentifier":"start_line","uniqueIdentifier":"1070","position":[-2.68,3.92,14.21],"scale":[2.5,2.5,2.5],"rotation":[0,0,0]},{"assetIdentifier":"toaster_004","uniqueIdentifier":"1071","position":[-18.2,-9.6,4.38],"scale":[1,1,1],"rotation":[0,0,0]},{"assetIdentifier":"square_004","uniqueIdentifier":"1072","position":[-18.32,-11.72,4.61],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"toaster_003","uniqueIdentifier":"1073","position":[3.22,-9.6,-4.36],"scale":[1,1,1],"rotation":[0,0,0]},{"assetIdentifier":"square_004","uniqueIdentifier":"1074","position":[3.18,-11.72,-3.89],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"toaster_002","uniqueIdentifier":"1075","position":[-18.51,-9.6,-4.3],"scale":[1,1,1],"rotation":[0,0,0]},{"assetIdentifier":"square_004","uniqueIdentifier":"1076","position":[-18.32,-11.72,-3.89],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"toaster_003","uniqueIdentifier":"1077","position":[3.24,-9.6,4.91],"scale":[1,1,1],"rotation":[0,0,0]},{"assetIdentifier":"square_004","uniqueIdentifier":"1078","position":[3.18,-11.72,5.11],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"square_007","uniqueIdentifier":"1079","position":[-7.49,-14.22,0.48],"scale":[31,2,15],"rotation":[0,0,0]},{"assetIdentifier":"square_001","uniqueIdentifier":"1080","position":[-28.49,8.5,-4.7],"scale":[3,2,26.5],"rotation":[0,0,3.14]},{"assetIdentifier":"slow_block_001","uniqueIdentifier":"1081","position":[-23.49,7,-14.45],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"slow_block_001","uniqueIdentifier":"1082","position":[-17.99,4.5,-13.45],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"spatula_004","uniqueIdentifier":"1083","position":[60.27,6.2,-85.14],"scale":[9,9,9],"rotation":[0,3.14,0]},{"assetIdentifier":"spatula_004","uniqueIdentifier":"1084","position":[53.77,6.2,-85.14],"scale":[9,9,9],"rotation":[0,3.14,0]},{"assetIdentifier":"spatula_004","uniqueIdentifier":"1085","position":[47.27,6.2,-85.14],"scale":[9,9,9],"rotation":[0,3.14,0]},{"assetIdentifier":"plate_004","uniqueIdentifier":"1086","position":[60.15,4.15,-71.1],"scale":[6.74,6.74,6.74],"rotation":[0,0,0]},{"assetIdentifier":"plate_004","uniqueIdentifier":"1087","position":[47.65,4.15,-75.6],"scale":[1,1,1],"rotation":[0,0,0]},{"assetIdentifier":"plate_004","uniqueIdentifier":"1088","position":[40.65,4.15,-75.6],"scale":[1,1,1],"rotation":[0,0,0]},{"assetIdentifier":"plate_004","uniqueIdentifier":"1089","position":[40.65,4.15,-69.1],"scale":[1,1,1],"rotation":[0,0,0]},{"assetIdentifier":"plate_004","uniqueIdentifier":"1090","position":[35.99,2.55,-67.02],"scale":[1,1,1],"rotation":[0,0,0]},{"assetIdentifier":"slow_block_001","uniqueIdentifier":"1091","position":[-11.99,1.5,-13.45],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"plate_004","uniqueIdentifier":"1092","position":[62.41,4.15,-54.61],"scale":[1,1,1],"rotation":[0,0,0]},{"assetIdentifier":"tissue_box_004","uniqueIdentifier":"1093","position":[-16.62,-1.99,-19.72],"scale":[1,1,1],"rotation":[0,0,0]},{"assetIdentifier":"pot_002","uniqueIdentifier":"1094","position":[-8.89,0.63,-17.92],"scale":[1,1,1],"rotation":[0,3.14,3.14]},{"assetIdentifier":"pot_001","uniqueIdentifier":"1095","position":[-8.79,0.63,-14.6],"scale":[1,1,1],"rotation":[0,3.14,3.14]},{"assetIdentifier":"square_006","uniqueIdentifier":"1096","position":[37.01,20,173.55],"scale":[4,3,4],"rotation":[0,0,0]},{"assetIdentifier":"square_006","uniqueIdentifier":"1097","position":[43.01,20,171.05],"scale":[4,3,4],"rotation":[0,0,0]},{"assetIdentifier":"square_006","uniqueIdentifier":"1098","position":[48.51,20,166.55],"scale":[4,3,4],"rotation":[0,0,0]},{"assetIdentifier":"square_006","uniqueIdentifier":"1099","position":[53.01,20,160.55],"scale":[4,3,4],"rotation":[0,0,0]},{"assetIdentifier":"square_006","uniqueIdentifier":"1100","position":[53.01,20,153.55],"scale":[4,3,4],"rotation":[0,0,0]},{"assetIdentifier":"square_006","uniqueIdentifier":"1101","position":[53.01,20,146.55],"scale":[4,3,4],"rotation":[0,0,0]},{"assetIdentifier":"square_006","uniqueIdentifier":"1102","position":[50.01,20,139.05],"scale":[4,3,4],"rotation":[0,0,0]},{"assetIdentifier":"square_006","uniqueIdentifier":"1103","position":[45.01,20,132.55],"scale":[4,3,4],"rotation":[0,0,0]},{"assetIdentifier":"check_point_001","uniqueIdentifier":"checkpoint_7","position":[8.98,54,112.05],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"check_point_001","uniqueIdentifier":"checkpoint_4","position":[36.42,19.5,129.25],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"square_001","uniqueIdentifier":"1104","position":[-0.99,-3,61.05],"scale":[6,6,13],"rotation":[0,0,0]},{"assetIdentifier":"square_001","uniqueIdentifier":"1105","position":[-0.99,-3,46.05],"scale":[6,6,5],"rotation":[0,0,0]},{"assetIdentifier":"square_001","uniqueIdentifier":"1106","position":[6.51,-3,55.55],"scale":[9,6,24],"rotation":[0,0,0]},{"assetIdentifier":"check_point_001","uniqueIdentifier":"checkpoint_2","position":[-0.99,-1.5,53.05],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1107","position":[10.98,54.5,116.55],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1108","position":[10.98,54.5,114.55],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1109","position":[10.98,54.5,118.55],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1110","position":[10.98,54.5,120.55],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1111","position":[10.98,54.5,122.55],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1112","position":[8.98,54.5,122.55],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1113","position":[8.98,54.5,120.55],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1114","position":[8.98,54.5,118.55],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1115","position":[8.98,54.5,114.55],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1116","position":[8.98,54.5,116.55],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1117","position":[6.98,54.5,116.55],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1118","position":[6.98,54.5,114.55],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1119","position":[6.98,54.5,118.55],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1120","position":[6.98,54.5,120.55],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1121","position":[6.98,54.5,122.55],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1122","position":[4.98,54.5,122.55],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1123","position":[4.98,54.5,120.55],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1124","position":[4.98,54.5,118.55],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1125","position":[4.98,54.5,114.55],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1126","position":[4.98,54.5,116.55],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1127","position":[2.98,54.5,116.55],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1128","position":[2.98,54.5,114.55],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1129","position":[2.98,54.5,118.55],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1130","position":[2.98,54.5,120.55],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1131","position":[2.98,54.5,122.55],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1132","position":[0.98,54.5,122.55],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1133","position":[0.98,54.5,120.55],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1134","position":[0.98,54.5,118.55],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1135","position":[0.98,54.5,114.55],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1136","position":[0.98,54.5,116.55],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1137","position":[-1.02,54.5,116.55],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1138","position":[-1.02,54.5,114.55],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1139","position":[-1.02,54.5,118.55],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1140","position":[-1.02,54.5,120.55],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1141","position":[-1.02,54.5,122.55],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1142","position":[-3.02,54.5,122.55],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1143","position":[-3.02,54.5,120.55],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1144","position":[-3.02,54.5,118.55],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1145","position":[-3.02,54.5,114.55],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1146","position":[-3.02,54.5,116.55],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1147","position":[-9.02,54.5,116.55],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1148","position":[-9.02,54.5,114.55],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1149","position":[-9.02,54.5,118.55],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1150","position":[-9.02,54.5,120.55],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1151","position":[-9.02,54.5,122.55],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1152","position":[-7.02,54.5,122.55],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1153","position":[-7.02,54.5,120.55],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1154","position":[-7.02,54.5,118.55],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1155","position":[-7.02,54.5,114.55],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1156","position":[-7.02,54.5,116.55],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1157","position":[-5.02,54.5,122.55],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1158","position":[-5.02,54.5,120.55],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1159","position":[-5.02,54.5,118.55],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1160","position":[-5.02,54.5,114.55],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1161","position":[33.01,18.5,160.05],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1162","position":[33.01,18.5,154.55],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"square_008","uniqueIdentifier":"1163","position":[31.01,32.5,160.05],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"square_008","uniqueIdentifier":"1164","position":[31.01,32.5,154.55],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"square_008","uniqueIdentifier":"1165","position":[31.01,32.5,149.05],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"square_008","uniqueIdentifier":"1166","position":[31.01,30.5,149.05],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"square_008","uniqueIdentifier":"1167","position":[31.01,30.5,154.55],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"square_008","uniqueIdentifier":"1168","position":[31.01,30.5,160.05],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"square_004","uniqueIdentifier":"1169","position":[-8.99,55,120.55],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"square_004","uniqueIdentifier":"1170","position":[-0.99,56,118.55],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"square_007","uniqueIdentifier":"1171","position":[14.26,54,116.05],"scale":[4.5,3,17],"rotation":[0,0,0]},{"assetIdentifier":"square_007","uniqueIdentifier":"1172","position":[15.26,53.25,129.3],"scale":[1,1.5,9.5],"rotation":[0,0,0]},{"assetIdentifier":"square_003","uniqueIdentifier":"1173","position":[17.01,51,156.55],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"square_003","uniqueIdentifier":"1174","position":[15.01,53,164.05],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"square_003","uniqueIdentifier":"1175","position":[15.01,51,164.05],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"square_003","uniqueIdentifier":"1176","position":[17.01,51,164.05],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"square_003","uniqueIdentifier":"1177","position":[19.01,51,164.05],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"square_008","uniqueIdentifier":"1178","position":[27.01,27.25,173.55],"scale":[4,15.5,5],"rotation":[0,0,0]},{"assetIdentifier":"square_008","uniqueIdentifier":"1179","position":[31.01,20.5,173.55],"scale":[4,2,5],"rotation":[0,0,0]},{"assetIdentifier":"square_008","uniqueIdentifier":"1180","position":[31.01,28.5,160.05],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"square_008","uniqueIdentifier":"1181","position":[31.01,28.5,154.55],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"square_008","uniqueIdentifier":"1182","position":[31.01,28.5,149.05],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"square_008","uniqueIdentifier":"1183","position":[31.01,27,166.55],"scale":[2,13,2],"rotation":[0,0,0]},{"assetIdentifier":"square_008","uniqueIdentifier":"1184","position":[31.01,20.5,160.05],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"square_008","uniqueIdentifier":"1185","position":[31.01,22.5,160.05],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"square_008","uniqueIdentifier":"1186","position":[31.01,24.5,160.05],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"square_008","uniqueIdentifier":"1187","position":[31.01,26.5,160.05],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"square_008","uniqueIdentifier":"1188","position":[31.01,26.5,154.55],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"square_008","uniqueIdentifier":"1189","position":[31.01,24.5,154.55],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"square_008","uniqueIdentifier":"1190","position":[31.01,22.5,154.55],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"square_008","uniqueIdentifier":"1191","position":[31.01,20.5,154.55],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"square_008","uniqueIdentifier":"1192","position":[31.01,26.5,149.05],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"square_008","uniqueIdentifier":"1193","position":[31.01,24.5,149.05],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"square_008","uniqueIdentifier":"1194","position":[31.01,22.5,149.05],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"square_006","uniqueIdentifier":"1195","position":[33.01,20.5,149.05],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"square_006","uniqueIdentifier":"1196","position":[36.01,20.5,144.05],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"square_006","uniqueIdentifier":"1197","position":[36.42,12,127.75],"scale":[6,12,6],"rotation":[0,0,0]},{"assetIdentifier":"square_006","uniqueIdentifier":"1198","position":[-1.11,13.75,102.5],"scale":[4,10.5,4],"rotation":[0,0,0]},{"assetIdentifier":"square_006","uniqueIdentifier":"1199","position":[-2.49,10.75,93.55],"scale":[7,2.5,6],"rotation":[0,0,0]},{"assetIdentifier":"square_001","uniqueIdentifier":"1200","position":[-1.74,-0.5,33.3],"scale":[10.5,7,7.5],"rotation":[0,0,0]},{"assetIdentifier":"square_001","uniqueIdentifier":"1201","position":[-4.24,-3,26.8],"scale":[5.5,6,5.5],"rotation":[0,0,0]},{"assetIdentifier":"square_001","uniqueIdentifier":"1202","position":[-2.49,10.25,74.55],"scale":[7,2.5,8],"rotation":[0,0,0]},{"assetIdentifier":"square_001","uniqueIdentifier":"1203","position":[-2.49,5.75,62.8],"scale":[7,11.5,9.5],"rotation":[0,0,0]},{"assetIdentifier":"square_001","uniqueIdentifier":"1204","position":[-8.49,3,46.05],"scale":[5,6,5],"rotation":[0,0,0]},{"assetIdentifier":"square_001","uniqueIdentifier":"1205","position":[8.51,3,46.05],"scale":[5,6,5],"rotation":[0,0,0]},{"assetIdentifier":"square_001","uniqueIdentifier":"1206","position":[-7.49,-3,55.55],"scale":[7,6,24],"rotation":[0,0,0]},{"assetIdentifier":"square_001","uniqueIdentifier":"1207","position":[-19.49,-3,0.05],"scale":[9,6,22],"rotation":[0,0,0]},{"assetIdentifier":"square_001","uniqueIdentifier":"1208","position":[23.01,-3,-1.95],"scale":[16,6,12],"rotation":[0,0,0]},{"assetIdentifier":"square_001","uniqueIdentifier":"1209","position":[-2.99,-3,21.3],"scale":[8,6,5.5],"rotation":[0,0,0]},{"assetIdentifier":"square_001","uniqueIdentifier":"1210","position":[0.01,-3,-66.7],"scale":[22,6,97.51],"rotation":[0,0,0]},{"assetIdentifier":"square_001","uniqueIdentifier":"1211","position":[0.01,-3,-1.7],"scale":[30,6,32.5],"rotation":[0,0,0]},{"assetIdentifier":"square_006","uniqueIdentifier":"1212","position":[-1.99,10.25,84.55],"scale":[7,2.5,6],"rotation":[0,0,0]},{"assetIdentifier":"square_008","uniqueIdentifier":"1213","position":[7.64,20.25,102.5],"scale":[13.5,1.5,2.5],"rotation":[0,0,0]},{"assetIdentifier":"pan_004","uniqueIdentifier":"1214","position":[35.99,20,135.62],"scale":[2,2,2],"rotation":[0,0,0],"behaviour":["Bounce","1.5","",""]},{"assetIdentifier":"square_008","uniqueIdentifier":"1215","position":[31.01,20.5,149.05],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"square_007","uniqueIdentifier":"1216","position":[15.26,53.25,141.55],"scale":[1,1.5,9],"rotation":[0,0,0]},{"assetIdentifier":"square_004","uniqueIdentifier":"1217","position":[5.01,55,116.55],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1218","position":[-5.02,54.5,116.55],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"square_004","uniqueIdentifier":"1219","position":[-41.94,1376.07,307.32],"scale":[2,2,2],"rotation":[0.02,6.1,0.58]},{"assetIdentifier":"square_005","uniqueIdentifier":"1220","position":[136.48,488.68,211.14],"scale":[8,8,8],"rotation":[5.24,5.02,0.54]},{"assetIdentifier":"square_006","uniqueIdentifier":"1221","position":[190.24,428.86,79.93],"scale":[2,2,2],"rotation":[5.94,5.79,0.1]},{"assetIdentifier":"square_003","uniqueIdentifier":"1222","position":[112.88,347.31,155.45],"scale":[4,4,4],"rotation":[5.64,5.85,5.52]},{"assetIdentifier":"square_001","uniqueIdentifier":"1223","position":[-290.77,249.21,112.44],"scale":[8,8,8],"rotation":[0.26,5.76,0]},{"assetIdentifier":"square_001","uniqueIdentifier":"1224","position":[39.18,3.28,71.87],"scale":[2,2,2],"rotation":[5.48,2.1,4.31]},{"assetIdentifier":"square_001","uniqueIdentifier":"1225","position":[36.57,6.4,-69.59],"scale":[2,2,2],"rotation":[6.11,0.15,5.57]},{"assetIdentifier":"square_007","uniqueIdentifier":"1226","position":[-34.1,7,41.63],"scale":[2,2,2],"rotation":[0.4,0.31,0.69]},{"assetIdentifier":"square_004","uniqueIdentifier":"1227","position":[58.31,9.2,14.79],"scale":[4,4,4],"rotation":[5.74,0.02,0.26]},{"assetIdentifier":"square_006","uniqueIdentifier":"1228","position":[-31.68,5.5,-45.68],"scale":[2,2,2],"rotation":[5.89,0,0.4]},{"assetIdentifier":"square_006","uniqueIdentifier":"1229","position":[12.42,54.53,206.03],"scale":[2,2,2],"rotation":[0.25,0.27,0.07]},{"assetIdentifier":"square_004","uniqueIdentifier":"1230","position":[-22.49,58.1,179.9],"scale":[2,2,2],"rotation":[5.84,6.06,0]},{"assetIdentifier":"square_007","uniqueIdentifier":"1231","position":[-68.79,74.74,85],"scale":[4,4,4],"rotation":[0.46,0.22,0.1]},{"assetIdentifier":"square_008","uniqueIdentifier":"1232","position":[-74.29,77.49,90.65],"scale":[2,2,2],"rotation":[0.12,0,0.27]},{"assetIdentifier":"square_002","uniqueIdentifier":"1233","position":[-145.49,199.51,166.72],"scale":[4,4,4],"rotation":[6.11,5.96,0.33]},{"assetIdentifier":"square_001","uniqueIdentifier":"1234","position":[-231.91,232.52,150.4],"scale":[2,2,2],"rotation":[0.26,5.76,0]},{"assetIdentifier":"square_007","uniqueIdentifier":"1235","position":[-168.3,270.5,17.32],"scale":[2,2,2],"rotation":[0,5.76,6.02]},{"assetIdentifier":"square_008","uniqueIdentifier":"1236","position":[-86.89,277.31,11.15],"scale":[2,2,2],"rotation":[0.31,5.96,6.24]},{"assetIdentifier":"square_003","uniqueIdentifier":"1237","position":[104.55,317.29,285.85],"scale":[4,4,4],"rotation":[0,0.26,0.26]},{"assetIdentifier":"square_001","uniqueIdentifier":"1238","position":[97.52,369.06,-102.55],"scale":[2,2,2],"rotation":[0,5.82,5.85]},{"assetIdentifier":"square_006","uniqueIdentifier":"1239","position":[202.71,412.2,52.65],"scale":[2,2,2],"rotation":[5.49,5.73,0]},{"assetIdentifier":"square_007","uniqueIdentifier":"1240","position":[97.1,450.56,231.91],"scale":[4,4,4],"rotation":[0,5.94,0]},{"assetIdentifier":"square_005","uniqueIdentifier":"1241","position":[-22.39,466,73.75],"scale":[2,2,2],"rotation":[1.05,5.5,0]},{"assetIdentifier":"square_005","uniqueIdentifier":"1242","position":[98.99,488.8,188.25],"scale":[4,4,4],"rotation":[0,5.5,0.26]},{"assetIdentifier":"square_008","uniqueIdentifier":"1243","position":[210.68,537,-53.13],"scale":[4,4,4],"rotation":[0.52,0.52,0]},{"assetIdentifier":"square_005","uniqueIdentifier":"1244","position":[218.83,545,88],"scale":[2,2,2],"rotation":[0,0.52,6.02]},{"assetIdentifier":"square_008","uniqueIdentifier":"1245","position":[206.43,544,90.75],"scale":[2,2,2],"rotation":[0.32,5.77,0]},{"assetIdentifier":"square_004","uniqueIdentifier":"1246","position":[270.71,584,101.85],"scale":[2,2,2],"rotation":[0.12,5.18,0.12]},{"assetIdentifier":"square_008","uniqueIdentifier":"1247","position":[292.33,646,-56.84],"scale":[2,2,2],"rotation":[0.52,0.52,0]},{"assetIdentifier":"square_006","uniqueIdentifier":"1248","position":[294.85,662,-65.21],"scale":[4,4,4],"rotation":[6.02,5.76,0]},{"assetIdentifier":"square_004","uniqueIdentifier":"1249","position":[320.2,680,50.95],"scale":[2,2,2],"rotation":[6.02,0.52,0]},{"assetIdentifier":"square_004","uniqueIdentifier":"1250","position":[-32.11,354.39,-1.03],"scale":[4,4,4],"rotation":[0.79,5.76,0]},{"assetIdentifier":"square_006","uniqueIdentifier":"1251","position":[24.39,352.06,-94],"scale":[2,2,2],"rotation":[0.26,0,0]},{"assetIdentifier":"square_003","uniqueIdentifier":"1252","position":[441.71,712.8,-27.35],"scale":[4,4,4],"rotation":[0,6.02,6.02]},{"assetIdentifier":"square_006","uniqueIdentifier":"1253","position":[502.05,887.38,129.01],"scale":[2,2,2],"rotation":[6.03,4.39,0.46]},{"assetIdentifier":"square_007","uniqueIdentifier":"1254","position":[386.14,888.5,197.31],"scale":[2,2,2],"rotation":[1.22,0.69,0.47]},{"assetIdentifier":"square_006","uniqueIdentifier":"1255","position":[312.5,934.78,289.22],"scale":[2,2,2],"rotation":[6.02,5.76,0]},{"assetIdentifier":"square_004","uniqueIdentifier":"1256","position":[519.24,968.08,391.69],"scale":[4,4,4],"rotation":[6.02,5.76,0]},{"assetIdentifier":"square_005","uniqueIdentifier":"1257","position":[337.64,1031.28,348.19],"scale":[4,4,4],"rotation":[0.26,5.76,0]},{"assetIdentifier":"square_008","uniqueIdentifier":"1258","position":[387.01,1073.78,227.27],"scale":[2,2,2],"rotation":[0.52,5.76,0]},{"assetIdentifier":"square_004","uniqueIdentifier":"1259","position":[381.33,1125.78,140.74],"scale":[2,2,2],"rotation":[0.26,5.76,0]},{"assetIdentifier":"square_002","uniqueIdentifier":"1260","position":[513.95,1090.28,139.62],"scale":[2,2,2],"rotation":[0.26,0.26,0]},{"assetIdentifier":"square_008","uniqueIdentifier":"1261","position":[414.03,1115.78,-15.39],"scale":[4,4,4],"rotation":[0.17,5.46,6.09]},{"assetIdentifier":"square_001","uniqueIdentifier":"1262","position":[283.86,1140.4,35.65],"scale":[2,2,2],"rotation":[5.96,0.26,0.12]},{"assetIdentifier":"square_008","uniqueIdentifier":"1263","position":[-178.87,1229.28,10.65],"scale":[12,12,12],"rotation":[0.52,6.02,0.26]},{"assetIdentifier":"square_006","uniqueIdentifier":"1264","position":[13.17,1317.28,-214.24],"scale":[6,6,6],"rotation":[0,0.78,0.26]},{"assetIdentifier":"square_008","uniqueIdentifier":"1265","position":[42.79,1320.28,139.17],"scale":[4,4,4],"rotation":[0,0.52,5.76]},{"assetIdentifier":"square_004","uniqueIdentifier":"1266","position":[-37.32,1371.28,290.06],"scale":[4,4,4],"rotation":[6.02,0.26,0]},{"assetIdentifier":"square_007","uniqueIdentifier":"1267","position":[171.99,1384.28,348.62],"scale":[4,4,4],"rotation":[0,0,5.5]},{"assetIdentifier":"pan_001","uniqueIdentifier":"1268","position":[25.87,283.49,22.88],"scale":[2.39,2.39,2.39],"rotation":[0,0,0],"behaviour":["Bounce","2.1","",""]},{"assetIdentifier":"pan_001","uniqueIdentifier":"1269","position":[33.13,273,11.66],"scale":[2.39,2.39,2.39],"rotation":[0,0,0],"behaviour":["Bounce","1.85","",""]},{"assetIdentifier":"check_point_001","uniqueIdentifier":"checkpoint_25","position":[-14.84,267.51,36.59],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"invisible_square_001","uniqueIdentifier":"1270","position":[-40.68,286.89,36.21],"scale":[24.5,1,2],"rotation":[0,0,0]},{"assetIdentifier":"invisible_square_001","uniqueIdentifier":"1271","position":[-50.57,282.19,37.24],"scale":[4.28,10.39,0.36],"rotation":[0,0,0]},{"assetIdentifier":"check_point_001","uniqueIdentifier":"checkpoint_24","position":[45.73,278.76,38.82],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"check_point_001","uniqueIdentifier":"checkpoint_23","position":[-4.09,272,-11.06],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1272","position":[23.51,271.5,9.55],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1273","position":[10.51,271.5,6.55],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1274","position":[3.01,271.5,-0.45],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1275","position":[-32.49,271.5,12.05],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1276","position":[-25.49,271.5,8.05],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1277","position":[-21.99,271.5,-0.95],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"square_008","uniqueIdentifier":"1278","position":[-28.99,271,11.55],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"square_008","uniqueIdentifier":"1279","position":[-22.99,271,3.55],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"square_008","uniqueIdentifier":"1280","position":[-18.49,271,-4.45],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"square_008","uniqueIdentifier":"1281","position":[47.17,278.76,75.05],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"square_008","uniqueIdentifier":"1282","position":[56.67,278.76,73.55],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"square_008","uniqueIdentifier":"1283","position":[62.17,278.76,67.05],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"square_008","uniqueIdentifier":"1284","position":[64.67,277.76,57.05],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"square_008","uniqueIdentifier":"1285","position":[64.67,277.76,47.55],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"square_008","uniqueIdentifier":"1286","position":[62.17,277.76,39.55],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"square_008","uniqueIdentifier":"1287","position":[53.67,277.76,39.55],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"square_003","uniqueIdentifier":"1288","position":[2.51,271,-7.45],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"square_004","uniqueIdentifier":"1289","position":[18.55,297,126.27],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1290","position":[18.98,295.84,120.47],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"slippery_block_001","uniqueIdentifier":"1291","position":[14.97,295.84,120.47],"scale":[4,4,4],"rotation":[0,0,0],"behaviour":["Speed","0.8","",""]},{"assetIdentifier":"slippery_block_001","uniqueIdentifier":"1292","position":[22.97,295.84,120.47],"scale":[4,4,4],"rotation":[0,0,0],"behaviour":["Speed","0.8","",""]},{"assetIdentifier":"square_003","uniqueIdentifier":"1293","position":[29.01,288,102.05],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"square_003","uniqueIdentifier":"1294","position":[36.01,285,101.55],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"square_003","uniqueIdentifier":"1295","position":[39.51,283,91.55],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"square_003","uniqueIdentifier":"1296","position":[40.01,281.5,81.55],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"square_003","uniqueIdentifier":"1297","position":[40.01,276.5,32.05],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"square_003","uniqueIdentifier":"1298","position":[36.51,275.5,22.55],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"square_003","uniqueIdentifier":"1299","position":[23.01,271,13.05],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"square_003","uniqueIdentifier":"1300","position":[14.01,271,7.05],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"square_003","uniqueIdentifier":"1301","position":[6.51,271,0.05],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"square_003","uniqueIdentifier":"1302","position":[-12.49,271,-10.95],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"square_003","uniqueIdentifier":"1303","position":[-38.99,271.5,14.05],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"square_003","uniqueIdentifier":"1304","position":[-49.49,272,14.05],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"square_003","uniqueIdentifier":"1305","position":[-59.49,272,14.05],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"square_003","uniqueIdentifier":"1306","position":[-59.49,272,24.05],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"square_003","uniqueIdentifier":"1307","position":[-59.49,272,33.05],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"check_point_001","uniqueIdentifier":"checkpoint_26","position":[18.97,291.09,109.47],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"cutting_board","uniqueIdentifier":"1308","position":[19.2,287.69,92.98],"scale":[2,10,2],"rotation":[0,0,0]},{"assetIdentifier":"cutting_board","uniqueIdentifier":"1309","position":[10.7,284.69,92.98],"scale":[2,10,2],"rotation":[0,0,0]},{"assetIdentifier":"cutting_board","uniqueIdentifier":"1310","position":[7.7,281.19,99.98],"scale":[2,10,2],"rotation":[0,0,0]},{"assetIdentifier":"cutting_board","uniqueIdentifier":"1311","position":[-1.3,278.19,93.48],"scale":[2,10,2],"rotation":[0,0,0]},{"assetIdentifier":"cutting_board","uniqueIdentifier":"1312","position":[-2.8,275.19,85.48],"scale":[2,10,2],"rotation":[0,0,0]},{"assetIdentifier":"cutting_board","uniqueIdentifier":"1313","position":[-1.3,271.69,75.48],"scale":[2,10,2],"rotation":[0,0,0]},{"assetIdentifier":"cutting_board","uniqueIdentifier":"1314","position":[2.7,271.19,63.98],"scale":[2,10,2],"rotation":[0,0,0]},{"assetIdentifier":"cutting_board","uniqueIdentifier":"1315","position":[2.7,268.69,53.48],"scale":[2,10,2],"rotation":[0,0,0]},{"assetIdentifier":"cutting_board","uniqueIdentifier":"1316","position":[2.7,267.69,44.48],"scale":[2,10,2],"rotation":[0,0,0]},{"assetIdentifier":"square_004","uniqueIdentifier":"1317","position":[29.39,304.13,144.31],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"square_004","uniqueIdentifier":"1318","position":[21.05,301.13,142.67],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1319","position":[18.98,291.84,112.47],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"slippery_block_001","uniqueIdentifier":"1320","position":[18.96,293.84,116.47],"scale":[4,4,4],"rotation":[0,0,0],"behaviour":["Speed","0.8","",""]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1321","position":[22.97,293.84,116.47],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"slippery_block_001","uniqueIdentifier":"1322","position":[14.97,291.84,112.47],"scale":[4,4,4],"rotation":[0,0,0],"behaviour":["Speed","0.8","",""]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1323","position":[14.97,293.84,116.47],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"slippery_block_001","uniqueIdentifier":"1324","position":[22.97,291.84,112.47],"scale":[4,4,4],"rotation":[0,0,0],"behaviour":["Speed","0.8","",""]},{"assetIdentifier":"square_004","uniqueIdentifier":"1325","position":[21.41,287.1,99.47],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"square_004","uniqueIdentifier":"1326","position":[19.41,287.1,99.47],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"square_004","uniqueIdentifier":"1327","position":[17.41,287.1,99.47],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"square_004","uniqueIdentifier":"1328","position":[15.41,287.1,99.47],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"square_004","uniqueIdentifier":"1329","position":[13.41,289.1,99.47],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"square_004","uniqueIdentifier":"1330","position":[15.41,289.1,99.47],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"square_004","uniqueIdentifier":"1331","position":[17.41,289.1,99.47],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"square_004","uniqueIdentifier":"1332","position":[19.41,289.1,99.47],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"square_004","uniqueIdentifier":"1333","position":[21.41,289.1,99.47],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"cutting_board","uniqueIdentifier":"1334","position":[2.7,267.69,35.48],"scale":[2,10,2],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1335","position":[-20.49,281.5,61.55],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1336","position":[-17.49,281.5,61.55],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1337","position":[-17.49,281.5,55.55],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1338","position":[-17.49,281.5,52.55],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1339","position":[-14.49,281.5,40.55],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1340","position":[-17.49,281.5,40.55],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1341","position":[-20.49,281.5,40.55],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1342","position":[-22.49,281.5,52.55],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1343","position":[-14.49,281.5,52.55],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1344","position":[-23.49,281.5,49.55],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1345","position":[-23.49,281.5,46.55],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1346","position":[-23.49,281.5,40.55],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1347","position":[-34.01,281.5,62.55],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1348","position":[-34.01,281.5,59.55],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1349","position":[-27.99,281.5,63.55],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1350","position":[-27.99,281.5,56.55],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1351","position":[-37.01,281.5,62.55],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1352","position":[-43.01,281.5,56.55],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1353","position":[-37.01,281.5,59.55],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1354","position":[-40.01,281.5,59.55],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1355","position":[-43.01,281.5,59.55],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1356","position":[-43.01,281.5,53.55],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1357","position":[-35.99,281.5,45.55],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1358","position":[-28.99,281.5,44.55],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1359","position":[-38.99,281.5,45.55],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1360","position":[-31.99,281.5,53.55],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1361","position":[-28.99,281.5,50.55],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1362","position":[-41.99,281.5,45.55],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1363","position":[-28.99,281.5,38.55],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1364","position":[-44.99,281.5,45.55],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1365","position":[-28.99,281.5,47.55],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1366","position":[-37.01,281.5,53.55],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1367","position":[-28.99,281.5,41.55],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1368","position":[-28.99,281.5,53.55],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1369","position":[-38.99,281.5,38.55],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1370","position":[-20.49,278.5,61.55],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1371","position":[-17.49,278.5,61.55],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1372","position":[-17.49,278.5,58.55],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1373","position":[-17.49,278.5,55.55],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1374","position":[-17.49,278.5,52.55],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1375","position":[-14.49,278.5,40.55],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1376","position":[-17.49,278.5,40.55],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1377","position":[-20.49,278.5,40.55],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1378","position":[-22.49,278.5,52.55],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1379","position":[-14.49,278.5,52.55],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1380","position":[-23.49,278.5,49.55],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1381","position":[-23.49,278.5,46.55],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1382","position":[-23.49,278.5,43.55],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1383","position":[-23.49,278.5,40.55],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1384","position":[-34.01,278.5,62.55],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1385","position":[-34.01,278.5,59.55],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1386","position":[-27.99,278.5,63.55],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1387","position":[-27.99,278.5,56.55],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1388","position":[-37.01,278.5,62.55],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1389","position":[-11.49,278.5,33.55],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1390","position":[-11.49,281.5,33.55],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1391","position":[-11.49,281.5,36.55],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1392","position":[-11.49,278.5,36.55],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1393","position":[-11.49,278.5,39.55],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1394","position":[-11.49,281.5,39.55],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1395","position":[-11.49,281.5,42.55],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1396","position":[-11.49,278.5,42.55],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1397","position":[-11.49,278.5,45.55],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1398","position":[-11.49,281.5,45.55],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1399","position":[-11.49,281.5,48.55],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1400","position":[-11.49,278.5,48.55],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1401","position":[-11.49,278.5,51.55],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1402","position":[-11.49,281.5,51.55],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1403","position":[-11.49,281.5,54.55],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1404","position":[-11.49,278.5,54.55],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1405","position":[-11.49,278.5,57.55],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1406","position":[-11.49,281.5,57.55],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1407","position":[-11.49,281.5,60.55],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1408","position":[-11.49,278.5,60.55],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1409","position":[-11.49,278.5,63.55],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1410","position":[-11.49,281.5,63.55],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1411","position":[-11.49,281.5,66.55],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1412","position":[-11.49,278.5,66.55],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1413","position":[-53.49,281.5,66.55],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1414","position":[-53.49,278.5,66.55],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1415","position":[-50.49,278.5,66.55],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1416","position":[-50.49,281.5,66.55],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1417","position":[-47.49,281.5,66.55],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1418","position":[-47.49,278.5,66.55],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1419","position":[-44.49,278.5,66.55],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1420","position":[-44.49,281.5,66.55],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1421","position":[-41.49,281.5,66.55],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1422","position":[-41.49,278.5,66.55],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1423","position":[-38.49,278.5,66.55],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1424","position":[-38.49,281.5,66.55],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1425","position":[-35.49,281.5,66.55],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1426","position":[-35.49,278.5,66.55],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1427","position":[-32.49,278.5,66.55],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1428","position":[-32.49,281.5,66.55],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1429","position":[-29.49,281.5,66.55],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1430","position":[-29.49,278.5,66.55],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1431","position":[-26.49,278.5,66.55],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1432","position":[-26.49,281.5,66.55],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1433","position":[-23.49,281.5,66.55],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1434","position":[-23.49,278.5,66.55],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1435","position":[-20.49,278.5,66.55],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1436","position":[-20.49,281.5,66.55],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1437","position":[-17.49,281.5,66.55],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1438","position":[-17.49,278.5,66.55],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1439","position":[-14.49,278.5,66.55],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1440","position":[-14.49,281.5,66.55],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1441","position":[-43.01,278.5,56.55],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1442","position":[-43.01,278.5,59.55],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1443","position":[-40.01,278.5,59.55],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1444","position":[-37.01,278.5,59.55],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1445","position":[-43.01,278.5,53.55],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1446","position":[-40.01,278.5,53.55],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1447","position":[-28.99,278.5,53.55],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1448","position":[-31.99,278.5,53.55],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1449","position":[-38.99,278.5,45.55],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1450","position":[-41.99,278.5,45.55],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1451","position":[-44.99,278.5,45.55],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1452","position":[-28.99,278.5,50.55],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1453","position":[-28.99,278.5,47.55],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1454","position":[-28.99,278.5,44.55],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1455","position":[-28.99,278.5,38.55],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1456","position":[-28.99,278.5,41.55],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1457","position":[-37.01,278.5,53.55],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1458","position":[-35.99,278.5,45.55],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1459","position":[-38.99,278.5,38.55],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1460","position":[-17.49,278.5,35.55],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1461","position":[-17.49,281.5,35.55],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1462","position":[-14.49,281.5,32.55],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1463","position":[-14.49,278.5,32.55],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1464","position":[-20.49,278.5,35.55],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1465","position":[-20.49,281.5,35.55],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1466","position":[-23.49,281.5,35.55],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1467","position":[-23.49,278.5,35.55],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1468","position":[-29.49,278.5,35.55],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1469","position":[-29.49,281.5,35.55],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1470","position":[-26.49,281.5,35.55],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1471","position":[-26.49,278.5,35.55],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1472","position":[-32.49,278.5,35.55],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1473","position":[-32.49,281.5,35.55],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1474","position":[-35.49,281.5,35.55],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1475","position":[-35.49,278.5,35.55],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1476","position":[-41.49,278.5,35.55],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1477","position":[-41.49,281.5,35.55],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1478","position":[-38.49,281.5,35.55],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1479","position":[-38.49,278.5,35.55],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1480","position":[-44.49,278.5,35.55],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1481","position":[-44.49,281.5,35.55],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1482","position":[-47.49,281.5,35.55],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1483","position":[-47.49,278.5,35.55],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1484","position":[-50.49,278.5,35.55],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1485","position":[-50.49,281.5,35.55],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1486","position":[-53.49,281.5,35.55],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"square_006","uniqueIdentifier":"1487","position":[-47.49,282,40.05],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"square_006","uniqueIdentifier":"1488","position":[-47.49,280,53.05],"scale":[2,6,24],"rotation":[0,0,0]},{"assetIdentifier":"square_003","uniqueIdentifier":"1489","position":[-59.49,272,42.05],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"square_001","uniqueIdentifier":"1490","position":[-33.99,275.5,51.02],"scale":[42,3,28.44],"rotation":[0,0,0]},{"assetIdentifier":"square_006","uniqueIdentifier":"1491","position":[-47.49,280,38.05],"scale":[2,6,2],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1492","position":[-53.49,278.5,35.55],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"cutting_board","uniqueIdentifier":"1493","position":[-7.12,267.41,35.48],"scale":[2,8.05,2],"rotation":[0,0,0]},{"assetIdentifier":"large_square_004","uniqueIdentifier":"1494","position":[18.47,291.09,102.47],"scale":[4,2,2.67],"rotation":[0,0,0]},{"assetIdentifier":"square_004","uniqueIdentifier":"1495","position":[23.41,289.1,99.47],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"square_004","uniqueIdentifier":"1496","position":[18.55,298.13,135.17],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"fridge_001","uniqueIdentifier":"1497","position":[-217.28,256.07,110.81],"scale":[0.45,0.45,0.45],"rotation":[0,0,0]},{"assetIdentifier":"square_001","uniqueIdentifier":"1498","position":[-217.59,252.5,110.74],"scale":[4,2,8.5],"rotation":[0,0,0]},{"assetIdentifier":"slow_block_001","uniqueIdentifier":"1499","position":[-169.86,195.46,146.44],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"slow_block_001","uniqueIdentifier":"1500","position":[-168.86,193.5,139.12],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"slippery_block_001","uniqueIdentifier":"1501","position":[-86.49,271.5,69.55],"scale":[1,1,1],"rotation":[0,0,0],"behaviour":["Speed","0.55","",""]},{"assetIdentifier":"slippery_block_001","uniqueIdentifier":"1502","position":[-103.99,271,69.55],"scale":[2,2,2],"rotation":[0,0,0],"behaviour":["Speed","0.55","",""]},{"assetIdentifier":"moving_block_001","uniqueIdentifier":"1503","position":[-162.46,188.5,122.3],"scale":[3,3,3],"rotation":[0,0,0],"behaviour":["Speed","1.36","",""]},{"assetIdentifier":"invisible_square_001","uniqueIdentifier":"1504","position":[-189.13,257.5,68.8],"scale":[3,1,28.5],"rotation":[0,0,0]},{"assetIdentifier":"check_point_001","uniqueIdentifier":"checkpoint_21","position":[-140.6,263,53.97],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"check_point_001","uniqueIdentifier":"checkpoint_20","position":[-221.7,259.5,46.52],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"check_point_001","uniqueIdentifier":"checkpoint_18","position":[-220.46,225.35,100.91],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"check_point_001","uniqueIdentifier":"check_point_001","position":[-175.34,202.5,168.8],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"check_point_001","uniqueIdentifier":"check_point_001","position":[-183.81,193,133.68],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"square_001","uniqueIdentifier":"1505","position":[-197.99,260,42.05],"scale":[4,2,4],"rotation":[0,0,0]},{"assetIdentifier":"square_001","uniqueIdentifier":"1506","position":[-205.49,259,42.05],"scale":[4,2,4],"rotation":[0,0,0]},{"assetIdentifier":"square_001","uniqueIdentifier":"1507","position":[-213.49,259,42.05],"scale":[4,2,4],"rotation":[0,0,0]},{"assetIdentifier":"square_001","uniqueIdentifier":"1508","position":[-221.99,259,54.55],"scale":[4,2,4],"rotation":[0,0,0]},{"assetIdentifier":"square_001","uniqueIdentifier":"1509","position":[-216.49,259,62.55],"scale":[4,2,4],"rotation":[0,0,0]},{"assetIdentifier":"square_001","uniqueIdentifier":"1510","position":[-216.49,259,71.55],"scale":[4,2,4],"rotation":[0,0,0]},{"assetIdentifier":"square_001","uniqueIdentifier":"1511","position":[-204.99,259,73.05],"scale":[4,2,5],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1512","position":[-169.36,196.5,152.62],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1513","position":[-170.86,194,142.12],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"square_001","uniqueIdentifier":"1514","position":[-185.96,201.5,130],"scale":[3,1,3],"rotation":[0,0,0]},{"assetIdentifier":"slow_block_001","uniqueIdentifier":"1515","position":[-192.96,196.5,136],"scale":[3,1,3],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1516","position":[-162.86,193,142.12],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"square_001","uniqueIdentifier":"1517","position":[-178.49,190,123.3],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"square_001","uniqueIdentifier":"1518","position":[-173.99,189.5,119.3],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"check_point_001","uniqueIdentifier":"checkpoint_22","position":[-68.74,270.5,43.55],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"square_001","uniqueIdentifier":"1519","position":[-214.59,252.5,108.74],"scale":[2,2,12.5],"rotation":[0,0,0]},{"assetIdentifier":"square_001","uniqueIdentifier":"1520","position":[-220.59,252.5,108.74],"scale":[2,2,12.5],"rotation":[0,0,0]},{"assetIdentifier":"check_point_001","uniqueIdentifier":"checkpoint_19","position":[-217.59,252.5,105.49],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"check_point_001","uniqueIdentifier":"checkpoint_17","position":[-198.49,220.58,137.15],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"slippery_block_001","uniqueIdentifier":"1521","position":[-163.86,191.5,139.12],"scale":[4,4,4],"rotation":[0,0,0],"behaviour":["Speed","0.64","",""]},{"assetIdentifier":"slippery_block_001","uniqueIdentifier":"1522","position":[-164.36,190,134.12],"scale":[4,4,4],"rotation":[0,0,0],"behaviour":["Speed","0.64","",""]},{"assetIdentifier":"square_006","uniqueIdentifier":"1523","position":[-162.49,260.5,43.55],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"square_006","uniqueIdentifier":"1524","position":[-151.99,260.5,51.55],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"square_006","uniqueIdentifier":"1525","position":[-175.49,260.5,51.55],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"square_006","uniqueIdentifier":"1526","position":[-187.49,260.5,43.55],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1527","position":[-182.99,210,144.55],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1528","position":[-182.99,206,144.55],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1529","position":[-182.99,202,144.55],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1530","position":[-182.99,213,164.55],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1531","position":[-182.99,213,148.55],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1532","position":[-182.99,213,152.55],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1533","position":[-182.99,213,156.55],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1534","position":[-182.99,213,160.55],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1535","position":[-188.99,205,132.55],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1536","position":[-188.99,203,132.55],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1537","position":[-188.99,201,132.55],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1538","position":[-188.99,199,132.55],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1539","position":[-188.99,197,132.55],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1540","position":[-188.99,195,132.55],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"slow_block_001","uniqueIdentifier":"1541","position":[-187.46,195,136.5],"scale":[3,1,3],"rotation":[0,0,0]},{"assetIdentifier":"large_square_001","uniqueIdentifier":"1542","position":[-150.99,188.5,131.55],"scale":[2,2,1.33],"rotation":[0,0,0]},{"assetIdentifier":"square_008","uniqueIdentifier":"1543","position":[-68.99,271,59.55],"scale":[0.5,2,29],"rotation":[0,0,0]},{"assetIdentifier":"square_008","uniqueIdentifier":"1544","position":[-77.49,271,69.55],"scale":[17,2,0.5],"rotation":[0,0,0]},{"assetIdentifier":"square_008","uniqueIdentifier":"1545","position":[-94.99,271,69.55],"scale":[16,2,1],"rotation":[0,0,0]},{"assetIdentifier":"square_006","uniqueIdentifier":"1546","position":[-125.49,270,68.05],"scale":[5,4,5],"rotation":[0,0,0]},{"assetIdentifier":"square_006","uniqueIdentifier":"1547","position":[-130.49,266,63.05],"scale":[5,4,5],"rotation":[0,0,0]},{"assetIdentifier":"square_006","uniqueIdentifier":"1548","position":[-135.49,262,58.05],"scale":[5,4,5],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1549","position":[-145.49,260.5,52.05],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1550","position":[-145.49,260.5,43.05],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1551","position":[-156.49,260.5,43.05],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1552","position":[-156.49,260.5,52.05],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1553","position":[-181.49,260.5,52.05],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1554","position":[-181.49,260.5,43.05],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1555","position":[-168.99,260.5,52.05],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1556","position":[-168.99,260.5,43.05],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1557","position":[-141.99,264.5,47.55],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1558","position":[-151.99,264.5,47.55],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1559","position":[-162.49,264.5,47.55],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1560","position":[-175.49,264.5,47.55],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1561","position":[-187.49,264.5,47.55],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"square_006","uniqueIdentifier":"1562","position":[-194.99,249.5,47.55],"scale":[4,26,4],"rotation":[0,0,0]},{"assetIdentifier":"square_006","uniqueIdentifier":"1563","position":[-166.49,260.5,47.55],"scale":[53,4,4],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1564","position":[-194.99,270.5,59.05],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"square_006","uniqueIdentifier":"1565","position":[-194.99,253,59.05],"scale":[4,31,4],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1566","position":[-194.99,270,70.05],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"square_006","uniqueIdentifier":"1567","position":[-194.99,252.5,70.05],"scale":[4,31,4],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1568","position":[-204.99,263.5,77.55],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"plate_003","uniqueIdentifier":"1569","position":[-198.14,258.04,89.05],"scale":[2,3,2],"rotation":[0,0,0]},{"assetIdentifier":"plate_003","uniqueIdentifier":"1570","position":[-190.14,257.04,89.05],"scale":[2,3,2],"rotation":[0,3.14,3.14]},{"assetIdentifier":"plate_003","uniqueIdentifier":"1571","position":[-190.14,256.04,96.55],"scale":[2,3,2],"rotation":[0,0,0]},{"assetIdentifier":"plate_003","uniqueIdentifier":"1572","position":[-195.14,255.04,104.05],"scale":[2,3,2],"rotation":[0,0,0]},{"assetIdentifier":"plate_003","uniqueIdentifier":"1573","position":[-205.14,254.04,104.05],"scale":[2,3,2],"rotation":[0,0,0]},{"assetIdentifier":"plate_004","uniqueIdentifier":"1574","position":[-228.63,245.58,95.83],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"plate_004","uniqueIdentifier":"1575","position":[-218.13,241.58,92.83],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"square_006","uniqueIdentifier":"1576","position":[-229.99,227.08,93.9],"scale":[7,3.5,7],"rotation":[0,0,0]},{"assetIdentifier":"plate_004","uniqueIdentifier":"1577","position":[-218.13,237.08,103.83],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"plate_004","uniqueIdentifier":"1578","position":[-230.13,233.08,103.83],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"square_006","uniqueIdentifier":"1579","position":[-224.49,224.33,99.4],"scale":[25,4,25],"rotation":[0,0,0]},{"assetIdentifier":"pepper","uniqueIdentifier":"1580","position":[-206.93,224.72,107.04],"scale":[12,12,12],"rotation":[0,0,0]},{"assetIdentifier":"pepper","uniqueIdentifier":"1581","position":[-201.43,223.22,107.04],"scale":[12,12,12],"rotation":[0,0,0]},{"assetIdentifier":"square_007","uniqueIdentifier":"1582","position":[-200.51,219.3,142.65],"scale":[3,2,3],"rotation":[0,0,0]},{"assetIdentifier":"square_007","uniqueIdentifier":"1583","position":[-203.01,216.51,148.9],"scale":[2,2,7.5],"rotation":[0,0,0]},{"assetIdentifier":"square_006","uniqueIdentifier":"1584","position":[-199.49,210.33,148.65],"scale":[5,2.5,4],"rotation":[0,0,0]},{"assetIdentifier":"square_006","uniqueIdentifier":"1585","position":[-190.99,208.33,156.65],"scale":[12,2.5,4],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1586","position":[-186.99,206.5,160.55],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1587","position":[-194.99,206.5,176.55],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1588","position":[-194.99,206.5,160.55],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1589","position":[-190.99,206.5,164.55],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1590","position":[-186.99,206.5,168.55],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1591","position":[-194.99,206.5,168.55],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1592","position":[-190.99,206.5,172.55],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1593","position":[-186.99,206.5,176.55],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"square_001","uniqueIdentifier":"1594","position":[-172.99,199,161.55],"scale":[4,2,4],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1595","position":[-182.99,206.5,172.55],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1596","position":[-182.99,209,164.55],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1597","position":[-182.99,209,160.55],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1598","position":[-182.99,209,156.55],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1599","position":[-182.99,209,152.55],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"square_001","uniqueIdentifier":"1600","position":[-170.99,196,155.55],"scale":[4,2,4],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1601","position":[-188.99,193,132.55],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1602","position":[-182.99,209,148.55],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"square_001","uniqueIdentifier":"1603","position":[-182.24,192,127.8],"scale":[4.5,2,2.5],"rotation":[0,0,0]},{"assetIdentifier":"square_001","uniqueIdentifier":"1604","position":[-168.49,188.5,116.3],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"square_001","uniqueIdentifier":"1605","position":[-160.99,188.5,116.65],"scale":[8,2,1.2],"rotation":[0,0,0]},{"assetIdentifier":"square_006","uniqueIdentifier":"1606","position":[-187.49,203.83,162.65],"scale":[19,6.5,32],"rotation":[0,0,0]},{"assetIdentifier":"square_007","uniqueIdentifier":"1607","position":[-202.01,212.26,151.65],"scale":[4,4.5,2],"rotation":[0,0,0]},{"assetIdentifier":"tissue_box_004","uniqueIdentifier":"1608","position":[-198.99,220.5,127.55],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"tissue_box_002","uniqueIdentifier":"1609","position":[-197.99,222,118.55],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"pepper","uniqueIdentifier":"1610","position":[-196.93,221.72,111.54],"scale":[12,12,12],"rotation":[0,0,0]},{"assetIdentifier":"plate_004","uniqueIdentifier":"1611","position":[-230.13,229.08,93.83],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"plate_003","uniqueIdentifier":"1612","position":[-228.14,250.04,104.05],"scale":[2,3,2],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1613","position":[-204.99,259.5,77.55],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"square_001","uniqueIdentifier":"1614","position":[-208.99,259,78.05],"scale":[4,2,5],"rotation":[0,0,0]},{"assetIdentifier":"pan_003","uniqueIdentifier":"1615","position":[-204.98,259.73,82.8],"scale":[2,2,2],"rotation":[0,0,0],"behaviour":["Bounce","1.5","",""]},{"assetIdentifier":"square_008","uniqueIdentifier":"1616","position":[-113.99,271,69.55],"scale":[18,2,2],"rotation":[0,0,0]},{"assetIdentifier":"large_square_001","uniqueIdentifier":"1617","position":[-152.49,188.5,122.3],"scale":[3,2,4.83],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1618","position":[-161.36,189.5,134.12],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"slippery_block_001","uniqueIdentifier":"1619","position":[-158.36,189,134.12],"scale":[4,4,4],"rotation":[0,0,0],"behaviour":["Speed","0.64","",""]},{"assetIdentifier":"square_001","uniqueIdentifier":"1620","position":[-192.96,198.5,130],"scale":[3,1,3],"rotation":[0,0,0]},{"assetIdentifier":"square_008","uniqueIdentifier":"1621","position":[-186.96,204,135.5],"scale":[3,1,3],"rotation":[0,0,0]},{"assetIdentifier":"square_007","uniqueIdentifier":"1622","position":[-187.96,205,143],"scale":[3,1,3],"rotation":[0,0,0]},{"assetIdentifier":"square_001","uniqueIdentifier":"1623","position":[-144.98,184.97,122.95],"scale":[3.25,3,3.25],"rotation":[0,0,0]},{"assetIdentifier":"moving_block_001","uniqueIdentifier":"1624","position":[-113.35,134.22,98.58],"scale":[4,4,4],"rotation":[0,0,0],"behaviour":["Speed","1.36","",""]},{"assetIdentifier":"square_001","uniqueIdentifier":"1625","position":[-144.23,180.97,117.45],"scale":[3.25,3,3.25],"rotation":[0,0,0]},{"assetIdentifier":"square_001","uniqueIdentifier":"1626","position":[-140.48,177.97,112.2],"scale":[3.25,3,3.25],"rotation":[0,0,0]},{"assetIdentifier":"square_001","uniqueIdentifier":"1627","position":[-135.73,174.72,112.2],"scale":[3.25,3,3.25],"rotation":[0,0,0]},{"assetIdentifier":"check_point_001","uniqueIdentifier":"checkpoint_12","position":[-126.6,172.22,100.83],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"square_001","uniqueIdentifier":"1628","position":[-130.98,171.72,102.33],"scale":[3.25,3,16.5],"rotation":[0,0,0]},{"assetIdentifier":"square_001","uniqueIdentifier":"1629","position":[-120.48,171.72,95.58],"scale":[17.75,3,3],"rotation":[0,0,0]},{"assetIdentifier":"square_001","uniqueIdentifier":"1630","position":[-113.1,168.72,95.58],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"square_001","uniqueIdentifier":"1631","position":[-110.1,168.72,95.58],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"slow_block_001","uniqueIdentifier":"1632","position":[-110.1,144.72,86.58],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"slow_block_001","uniqueIdentifier":"1633","position":[-107.1,144.72,86.58],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"slow_block_001","uniqueIdentifier":"1634","position":[-107.1,147.72,86.58],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"check_point_001","uniqueIdentifier":"check_point_001","position":[-111.85,142.97,93.08],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"slow_block_001","uniqueIdentifier":"1635","position":[-107.1,168.72,95.58],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"slow_block_001","uniqueIdentifier":"1636","position":[-104.1,165.72,95.58],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"slow_block_001","uniqueIdentifier":"1637","position":[-104.1,162.72,95.58],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"slow_block_001","uniqueIdentifier":"1638","position":[-101.1,162.72,95.58],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"slow_block_001","uniqueIdentifier":"1639","position":[-98.1,162.72,95.58],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"slow_block_001","uniqueIdentifier":"1640","position":[-92.1,162.72,92.58],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"slow_block_001","uniqueIdentifier":"1641","position":[-92.1,162.72,89.58],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"slow_block_001","uniqueIdentifier":"1642","position":[-92.1,159.72,89.58],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"slow_block_001","uniqueIdentifier":"1643","position":[-95.1,159.72,92.58],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"slow_block_001","uniqueIdentifier":"1644","position":[-95.1,156.72,92.58],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"slow_block_001","uniqueIdentifier":"1645","position":[-92.1,156.72,89.58],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"slow_block_001","uniqueIdentifier":"1646","position":[-95.1,156.72,89.58],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"slow_block_001","uniqueIdentifier":"1647","position":[-98.1,156.72,89.58],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"slow_block_001","uniqueIdentifier":"1648","position":[-98.1,153.72,89.58],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"slow_block_001","uniqueIdentifier":"1649","position":[-98.1,153.72,86.58],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"slow_block_001","uniqueIdentifier":"1650","position":[-95.1,150.72,86.58],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"slow_block_001","uniqueIdentifier":"1651","position":[-98.1,150.72,86.58],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"slow_block_001","uniqueIdentifier":"1652","position":[-101.1,150.72,86.58],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"slow_block_001","uniqueIdentifier":"1653","position":[-101.1,147.72,86.58],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"slow_block_001","uniqueIdentifier":"1654","position":[-104.1,147.72,83.58],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"slow_block_001","uniqueIdentifier":"1655","position":[-104.1,147.72,86.58],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"moving_block_001","uniqueIdentifier":"1656","position":[-117.35,137.97,91.33],"scale":[4,4,4],"rotation":[0,0,0],"behaviour":["Speed","1.36","",""]},{"assetIdentifier":"moving_block_001","uniqueIdentifier":"1657","position":[-122.85,131.47,98.33],"scale":[4,4,4],"rotation":[0,0,0],"behaviour":["Speed","1.36","",""]},{"assetIdentifier":"moving_block_001","uniqueIdentifier":"1658","position":[-122.85,128.72,108.58],"scale":[4,4,4],"rotation":[0,0,0],"behaviour":["Speed","1.36","",""]},{"assetIdentifier":"cutting_board","uniqueIdentifier":"1659","position":[-123.25,128.56,116.13],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"cutting_board","uniqueIdentifier":"1660","position":[-123.25,128.56,119.88],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"cutting_board","uniqueIdentifier":"1661","position":[-123.25,128.56,123.63],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"check_point_001","uniqueIdentifier":"check_point_001","position":[-102.07,110.47,135.62],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"cutting_board","uniqueIdentifier":"1662","position":[-123.25,128.56,127.38],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1663","position":[-131.69,91.75,139.19],"scale":[1.5,1.5,1.5],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1664","position":[-130.19,91.75,128.94],"scale":[1.5,1.5,1.5],"rotation":[0,0,0]},{"assetIdentifier":"check_point_001","uniqueIdentifier":"check_point_001","position":[-130.28,86.22,122.69],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"cutting_board","uniqueIdentifier":"1665","position":[-112.5,125.56,127.38],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"cutting_board","uniqueIdentifier":"1666","position":[-102.25,121.81,127.38],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"plate_001","uniqueIdentifier":"1667","position":[-102.06,120.25,134.54],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"plate_001","uniqueIdentifier":"1668","position":[-103.56,117,143.79],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"plate_001","uniqueIdentifier":"1669","position":[-96.31,114.25,141.54],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"plate_001","uniqueIdentifier":"1670","position":[-110.11,107.75,134.81],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"plate_001","uniqueIdentifier":"1671","position":[-102.81,103.5,141.54],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"plate_001","uniqueIdentifier":"1672","position":[-110.81,99.75,141.54],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"square_001","uniqueIdentifier":"1673","position":[-117.69,98.75,141.94],"scale":[2,2,2.5],"rotation":[0,0,0]},{"assetIdentifier":"square_001","uniqueIdentifier":"1674","position":[-117.69,95.5,138.19],"scale":[2,2,2.5],"rotation":[0,0,0]},{"assetIdentifier":"square_001","uniqueIdentifier":"1675","position":[-117.69,93.25,133.94],"scale":[2,2,2.5],"rotation":[0,0,0]},{"assetIdentifier":"square_005","uniqueIdentifier":"1676","position":[-118.57,89.5,137.94],"scale":[9.25,3,10.5],"rotation":[0,0,0]},{"assetIdentifier":"square_005","uniqueIdentifier":"1677","position":[-127.82,89.5,138.44],"scale":[9.25,3,3],"rotation":[0,0,0]},{"assetIdentifier":"square_005","uniqueIdentifier":"1678","position":[-130.94,89.5,131.19],"scale":[3,3,11.5],"rotation":[0,0,0]},{"assetIdentifier":"square_001","uniqueIdentifier":"1679","position":[-129.68,82,115.93],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"square_001","uniqueIdentifier":"1680","position":[-129.68,78.5,109.43],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"square_001","uniqueIdentifier":"1681","position":[-121.93,75.25,109.43],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"square_001","uniqueIdentifier":"1682","position":[-114.43,71.5,109.43],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"square_001","uniqueIdentifier":"1683","position":[-108.18,68.5,109.43],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"square_001","uniqueIdentifier":"1684","position":[-101.18,65.5,109.43],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"pan_001","uniqueIdentifier":"1685","position":[-87.35,102.99,99.71],"scale":[2.05,2.05,2.05],"rotation":[0,0,0],"behaviour":["Bounce","4.15","",""]},{"assetIdentifier":"pan_001","uniqueIdentifier":"1686","position":[-113.91,89,106.21],"scale":[2.05,2.05,2.05],"rotation":[0,0,0],"behaviour":["Bounce","2.075","",""]},{"assetIdentifier":"pan_001","uniqueIdentifier":"1687","position":[-107.63,75.58,124.21],"scale":[2.05,2.05,2.05],"rotation":[0,0,0],"behaviour":["Bounce","2.075","",""]},{"assetIdentifier":"moving_block_001","uniqueIdentifier":"1688","position":[-91.99,74.5,119.55],"scale":[4,4,4],"rotation":[0,0,0],"behaviour":["Speed","2","",""]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1689","position":[-57.99,74,111.05],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1690","position":[-57.99,70,111.05],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1691","position":[-57.99,66,111.05],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"pan_001","uniqueIdentifier":"1692","position":[-61.91,66.5,103.21],"scale":[2.05,2.05,2.05],"rotation":[0,0,0],"behaviour":["Bounce","2.075","",""]},{"assetIdentifier":"moving_block_001","uniqueIdentifier":"1693","position":[-50.99,62,111.05],"scale":[4,4,4],"rotation":[0,0,0],"behaviour":["Speed","2","",""]},{"assetIdentifier":"moving_block_001","uniqueIdentifier":"1694","position":[-46.99,62,111.05],"scale":[4,4,4],"rotation":[0,0,0],"behaviour":["Speed","1.8","",""]},{"assetIdentifier":"moving_block_001","uniqueIdentifier":"1695","position":[-42.99,62,111.05],"scale":[4,4,4],"rotation":[0,0,0],"behaviour":["Speed","1.7","",""]},{"assetIdentifier":"moving_block_001","uniqueIdentifier":"1696","position":[-38.99,62,111.05],"scale":[4,4,4],"rotation":[0,0,0],"behaviour":["Speed","1.6","",""]},{"assetIdentifier":"moving_block_001","uniqueIdentifier":"1697","position":[-34.99,62,111.05],"scale":[4,4,4],"rotation":[0,0,0],"behaviour":["Speed","1.5","",""]},{"assetIdentifier":"pan_001","uniqueIdentifier":"1698","position":[-25.91,66.5,121.21],"scale":[2.05,2.05,2.05],"rotation":[0,0,0],"behaviour":["Bounce","2.075","",""]},{"assetIdentifier":"check_point_001","uniqueIdentifier":"checkpoint_13","position":[-144.93,187.5,128.26],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"check_point_001","uniqueIdentifier":"check_point_001","position":[-55.59,75.5,128.24],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"square_006","uniqueIdentifier":"1699","position":[-29.99,61.75,111.05],"scale":[6,4.5,4],"rotation":[0,0,0]},{"assetIdentifier":"square_006","uniqueIdentifier":"1700","position":[-95.99,74.5,119.55],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"square_006","uniqueIdentifier":"1701","position":[-85.24,74.25,122.55],"scale":[4.5,4.5,4],"rotation":[0,0,0]},{"assetIdentifier":"square_006","uniqueIdentifier":"1702","position":[-75.24,74.25,122.55],"scale":[4.5,4.5,4],"rotation":[0,0,0]},{"assetIdentifier":"square_006","uniqueIdentifier":"1703","position":[-66.24,74.25,127.55],"scale":[4.5,4.5,4],"rotation":[0,0,0]},{"assetIdentifier":"square_006","uniqueIdentifier":"1704","position":[-44.74,74.25,127.55],"scale":[4.5,4.5,4],"rotation":[0,0,0]},{"assetIdentifier":"square_005","uniqueIdentifier":"1705","position":[-139.49,186.5,127.05],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"square_005","uniqueIdentifier":"1706","position":[-133.49,186,122.55],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"square_005","uniqueIdentifier":"1707","position":[-125.99,185.5,118.55],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"square_005","uniqueIdentifier":"1708","position":[-118.49,185,115.55],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"check_point_001","uniqueIdentifier":"checkpoint_14","position":[-102.49,185,116.05],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"pot_003","uniqueIdentifier":"1709","position":[-116.49,175.16,128.13],"scale":[1,1,1],"rotation":[0,0,0]},{"assetIdentifier":"pot_003","uniqueIdentifier":"1710","position":[-113.99,166.66,106.13],"scale":[1,1,1],"rotation":[0,0,0]},{"assetIdentifier":"square_006","uniqueIdentifier":"1711","position":[-35.24,61.5,121.3],"scale":[4.5,4,8.5],"rotation":[0,0,0]},{"assetIdentifier":"pot_003","uniqueIdentifier":"1712","position":[-78.99,154.66,100.63],"scale":[1,1,1],"rotation":[0,0,0]},{"assetIdentifier":"pot_003","uniqueIdentifier":"1713","position":[-113.99,142.16,124.13],"scale":[1,1,1],"rotation":[0,0,0]},{"assetIdentifier":"pot_003","uniqueIdentifier":"1714","position":[-113.99,125.16,103.13],"scale":[1,1,1],"rotation":[0,0,0]},{"assetIdentifier":"pot_001","uniqueIdentifier":"1715","position":[-108.28,80.31,104.55],"scale":[1,1,1],"rotation":[0,0,3.14]},{"assetIdentifier":"pot_001","uniqueIdentifier":"1716","position":[-108.28,73.81,124.05],"scale":[1,1,1],"rotation":[0,0,3.14]},{"assetIdentifier":"square_007","uniqueIdentifier":"1717","position":[-102.49,122.5,115.05],"scale":[4,122.99,4],"rotation":[0,0,0]},{"assetIdentifier":"square_006","uniqueIdentifier":"1718","position":[-90.49,63.25,115.05],"scale":[20,4.5,4],"rotation":[0,0,0]},{"assetIdentifier":"square_006","uniqueIdentifier":"1719","position":[-70.49,68.75,115.05],"scale":[20,15.5,4],"rotation":[0,0,0]},{"assetIdentifier":"square_006","uniqueIdentifier":"1720","position":[-44.49,68,115.05],"scale":[23,17,4],"rotation":[0,0,0]},{"assetIdentifier":"square_006","uniqueIdentifier":"1721","position":[-27.49,68,127.55],"scale":[20,17,4],"rotation":[0,0,0]},{"assetIdentifier":"square_006","uniqueIdentifier":"1722","position":[-19.74,58.75,120.55],"scale":[4.5,9.5,4],"rotation":[0,0,0]},{"assetIdentifier":"square_006","uniqueIdentifier":"1723","position":[-13.24,55,120.55],"scale":[6.5,2,2],"rotation":[0,0,0]},{"assetIdentifier":"pot_001","uniqueIdentifier":"1724","position":[-132.28,89.31,144.05],"scale":[1,1,1],"rotation":[0,0,3.14]},{"assetIdentifier":"pot_002","uniqueIdentifier":"1725","position":[-100.49,85.41,101.18],"scale":[1,1,1],"rotation":[0,0,0]},{"assetIdentifier":"pot_003","uniqueIdentifier":"1726","position":[-114.99,118.16,126.13],"scale":[1,1,1],"rotation":[0,0,0]},{"assetIdentifier":"square_005","uniqueIdentifier":"1727","position":[-110.99,184.5,115.55],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"chocolate_001","uniqueIdentifier":"1728","position":[92.65,487.8,87.39],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"chocolate_001","uniqueIdentifier":"1729","position":[415.1,711,44.47],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"square_001","uniqueIdentifier":"1730","position":[-218.99,217,187.05],"scale":[4,2,4],"rotation":[0,0,0]},{"assetIdentifier":"square_001","uniqueIdentifier":"1731","position":[-188.99,220,193.05],"scale":[4,2,4],"rotation":[0,0,0]},{"assetIdentifier":"square_001","uniqueIdentifier":"1732","position":[-200.99,217,193.05],"scale":[4,2,4],"rotation":[0,0,0]},{"assetIdentifier":"gorilla","uniqueIdentifier":"1733","position":[442.01,1052.64,152.94],"scale":[1.95,1.95,1.95],"rotation":[0,0,0]},{"assetIdentifier":"chocolate_001","uniqueIdentifier":"1734","position":[69.38,1401.78,382.78],"scale":[1.5,1,1.5],"rotation":[0,0,0]},{"assetIdentifier":"gorilla","uniqueIdentifier":"1735","position":[444.36,752.68,145.66],"scale":[1,1,1],"rotation":[0,0,0]},{"assetIdentifier":"fridge_001","uniqueIdentifier":"1736","position":[92.88,490.37,109.83],"scale":[0.45,0.45,0.45],"rotation":[0,0,0]},{"assetIdentifier":"moving_block_001","uniqueIdentifier":"1737","position":[25.33,442.55,47.95],"scale":[3,3,3],"rotation":[0,0,0],"behaviour":["Speed","1.6","",""]},{"assetIdentifier":"moving_block_001","uniqueIdentifier":"1738","position":[16.33,442.3,59.45],"scale":[3,3,3],"rotation":[0,0,0],"behaviour":["Speed","1.6","",""]},{"assetIdentifier":"moving_block_001","uniqueIdentifier":"1739","position":[16.33,442.3,62.45],"scale":[3,3,3],"rotation":[0,0,0],"behaviour":["Speed","1.6","",""]},{"assetIdentifier":"square_001","uniqueIdentifier":"1740","position":[125.61,485.8,95.81],"scale":[49,4,4],"rotation":[0,0,0]},{"assetIdentifier":"square_001","uniqueIdentifier":"1741","position":[117.61,485.8,109.06],"scale":[65,4,22.5],"rotation":[0,0,0]},{"assetIdentifier":"moving_block_001","uniqueIdentifier":"1742","position":[99.11,485.8,95.81],"scale":[4,4,4],"rotation":[0,0,0],"behaviour":["Speed","1.36","",""]},{"assetIdentifier":"moving_block_001","uniqueIdentifier":"1743","position":[95.11,485.8,95.81],"scale":[4,4,4],"rotation":[0,0,0],"behaviour":["Speed","1.7","",""]},{"assetIdentifier":"moving_block_001","uniqueIdentifier":"1744","position":[91.11,485.8,95.81],"scale":[4,4,4],"rotation":[0,0,0],"behaviour":["Speed","1.7","",""]},{"assetIdentifier":"moving_block_001","uniqueIdentifier":"1745","position":[87.11,485.8,95.81],"scale":[4,4,4],"rotation":[0,0,0],"behaviour":["Speed","1.7","",""]},{"assetIdentifier":"moving_block_001","uniqueIdentifier":"1746","position":[46.86,480.8,58.05],"scale":[2,2,2],"rotation":[0,0,0],"behaviour":["Speed","1.8","",""]},{"assetIdentifier":"moving_block_001","uniqueIdentifier":"1747","position":[167.51,514,28.55],"scale":[2,2,2],"rotation":[0,0,0],"behaviour":["Speed","2","",""]},{"assetIdentifier":"moving_block_001","uniqueIdentifier":"1748","position":[150.33,513.6,46.79],"scale":[3,3,3],"rotation":[0,0,0],"behaviour":["Speed","1.68","",""]},{"assetIdentifier":"square_007","uniqueIdentifier":"1749","position":[146,512.55,69.01],"scale":[2,1.5,2],"rotation":[0,0,0]},{"assetIdentifier":"moving_block_001","uniqueIdentifier":"1750","position":[150.33,514.3,66.95],"scale":[2,2,2],"rotation":[0,0,0],"behaviour":["Speed","1.36","",""]},{"assetIdentifier":"moving_block_001","uniqueIdentifier":"1751","position":[46.83,431.8,66.1],"scale":[4,4,4],"rotation":[0,0,0],"behaviour":["Speed","1.6","",""]},{"assetIdentifier":"moving_block_001","uniqueIdentifier":"1752","position":[50.83,431.8,66.1],"scale":[4,4,4],"rotation":[0,0,0],"behaviour":["Speed","1.6","",""]},{"assetIdentifier":"check_point_001","uniqueIdentifier":"checkpoint_34","position":[136.83,509.8,79.45],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"check_point_001","uniqueIdentifier":"checkpoint_33","position":[126.09,498.78,108.95],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"check_point_001","uniqueIdentifier":"checkpoint_32","position":[60.86,477.55,104.8],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"square_002","uniqueIdentifier":"1753","position":[101.83,497.3,99.95],"scale":[6,19,6],"rotation":[0,0,0]},{"assetIdentifier":"square_001","uniqueIdentifier":"1754","position":[117.61,485.8,82.56],"scale":[65,4,22.5],"rotation":[0,0,0]},{"assetIdentifier":"square_001","uniqueIdentifier":"1755","position":[30.83,430.8,70.7],"scale":[4,2,2.5],"rotation":[0,0,0]},{"assetIdentifier":"square_001","uniqueIdentifier":"1756","position":[26.83,430.8,73.95],"scale":[4,2,9],"rotation":[0,0,0]},{"assetIdentifier":"square_001","uniqueIdentifier":"1757","position":[34.83,430.8,73.95],"scale":[4,2,9],"rotation":[0,0,0]},{"assetIdentifier":"check_point_001","uniqueIdentifier":"checkpoint_31","position":[30.83,430.8,74.95],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1758","position":[137.33,512.8,66.95],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1759","position":[151.83,516.3,61.95],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1760","position":[151.83,514.3,61.95],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"square_007","uniqueIdentifier":"1761","position":[153.58,511.05,71.95],"scale":[10.5,1.5,2],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1762","position":[151.33,514.3,32.45],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"square_007","uniqueIdentifier":"1763","position":[158.33,513.8,35.95],"scale":[6,2,3],"rotation":[0,0,0]},{"assetIdentifier":"square_007","uniqueIdentifier":"1764","position":[158.33,512.8,42.95],"scale":[6,2,3],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1765","position":[151.33,513.3,39.45],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"square_007","uniqueIdentifier":"1766","position":[158.33,511.8,49.95],"scale":[6,2,3],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1767","position":[151.12,511.3,53.45],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"square_007","uniqueIdentifier":"1768","position":[158.33,510.8,56.95],"scale":[6,2,3],"rotation":[0,0,0]},{"assetIdentifier":"square_007","uniqueIdentifier":"1769","position":[154.83,512.55,61.95],"scale":[8,1.5,2],"rotation":[0,0,0]},{"assetIdentifier":"square_007","uniqueIdentifier":"1770","position":[154.08,512.55,66.95],"scale":[9.5,1.5,2],"rotation":[0,0,0]},{"assetIdentifier":"square_007","uniqueIdentifier":"1771","position":[141.08,510.8,70.2],"scale":[14.5,2,8.5],"rotation":[0,0,0]},{"assetIdentifier":"square_007","uniqueIdentifier":"1772","position":[129.83,509.8,85.45],"scale":[6,2,3],"rotation":[0,3.14,3.14]},{"assetIdentifier":"square_007","uniqueIdentifier":"1773","position":[136.83,508.8,91.45],"scale":[6,2,3],"rotation":[0,3.14,3.14]},{"assetIdentifier":"square_007","uniqueIdentifier":"1774","position":[136.83,508.3,97.95],"scale":[6,2,3],"rotation":[0,3.14,3.14]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1775","position":[140.83,501.8,104.95],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"square_007","uniqueIdentifier":"1776","position":[136.83,507.8,105.45],"scale":[6,2,3],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1777","position":[132.83,505.8,104.95],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1778","position":[132.83,505.8,106.95],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1779","position":[132.83,505.8,108.95],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1780","position":[134.83,501.8,102.95],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1781","position":[136.83,501.8,102.95],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1782","position":[138.83,501.8,102.95],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1783","position":[138.83,501.8,110.95],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1784","position":[136.83,501.8,110.95],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1785","position":[134.83,501.8,110.95],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1786","position":[132.83,501.8,108.95],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1787","position":[132.83,501.8,106.95],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1788","position":[132.83,501.8,104.95],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"square_007","uniqueIdentifier":"1789","position":[136.58,499.8,107.2],"scale":[15.5,2,16.5],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1790","position":[134.83,492.8,110.95],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1791","position":[136.83,492.8,110.95],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1792","position":[138.83,492.8,110.95],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1793","position":[140.83,492.8,108.95],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1794","position":[140.83,492.8,106.95],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1795","position":[140.83,492.8,104.95],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1796","position":[132.83,492.8,104.95],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1797","position":[132.83,492.8,106.95],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1798","position":[132.83,492.8,108.95],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"square_007","uniqueIdentifier":"1799","position":[136.83,497.3,106.95],"scale":[6,19,6],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1800","position":[114.83,505.8,103.95],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1801","position":[112.83,505.8,103.95],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1802","position":[110.83,505.8,103.95],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1803","position":[110.83,501.8,103.95],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1804","position":[112.83,501.8,103.95],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1805","position":[114.83,501.8,103.95],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"square_007","uniqueIdentifier":"1806","position":[119.58,499.8,107.95],"scale":[7.5,2,6],"rotation":[0,0,0]},{"assetIdentifier":"square_007","uniqueIdentifier":"1807","position":[112.83,499.8,113.95],"scale":[10,2,6],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1808","position":[112.83,509.8,107.95],"scale":[6,6,6],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1809","position":[110.83,492.8,103.95],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1810","position":[112.83,492.8,103.95],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1811","position":[114.83,492.8,103.95],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1812","position":[116.83,492.8,105.95],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1813","position":[116.83,492.8,107.95],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1814","position":[116.83,492.8,109.95],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1815","position":[114.83,492.8,111.95],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1816","position":[112.83,492.8,111.95],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1817","position":[110.83,492.8,111.95],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1818","position":[108.83,492.8,109.95],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1819","position":[108.83,492.8,107.95],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"square_007","uniqueIdentifier":"1820","position":[112.83,497.3,107.95],"scale":[6,19,6],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1821","position":[19.83,431.8,65.95],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"square_001","uniqueIdentifier":"1822","position":[30.83,430.8,77.2],"scale":[4,2,2.5],"rotation":[0,0,0]},{"assetIdentifier":"square_001","uniqueIdentifier":"1823","position":[24.33,431.3,65.95],"scale":[5,3,4],"rotation":[0,0,0]},{"assetIdentifier":"square_001","uniqueIdentifier":"1824","position":[34.58,431.05,65.7],"scale":[5.5,2.5,3.5],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1825","position":[41.83,431.8,68.95],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1826","position":[41.83,431.8,72.95],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1827","position":[45.83,431.8,84.95],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1828","position":[45.83,431.8,80.95],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"square_001","uniqueIdentifier":"1829","position":[30.83,426.8,75.45],"scale":[44,6,23],"rotation":[0,0,0]},{"assetIdentifier":"square_001","uniqueIdentifier":"1830","position":[59.83,436.55,80.7],"scale":[4,2.5,3.5],"rotation":[0,0,0]},{"assetIdentifier":"square_001","uniqueIdentifier":"1831","position":[67.08,433.55,84.34],"scale":[5.5,2.5,5.23],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1832","position":[33.81,448.8,44.94],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1833","position":[60.86,480.55,88.3],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"square_007","uniqueIdentifier":"1834","position":[79.11,484.8,96.55],"scale":[4.5,4.5,4.5],"rotation":[0,0,0]},{"assetIdentifier":"square_007","uniqueIdentifier":"1835","position":[71.61,481.8,96.55],"scale":[4.5,4.5,4.5],"rotation":[0,0,0]},{"assetIdentifier":"square_007","uniqueIdentifier":"1836","position":[64.61,478.8,96.55],"scale":[4.5,4.5,4.5],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1837","position":[56.83,476.8,98.95],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1838","position":[51.33,478.8,103.95],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1839","position":[51.33,476.8,103.95],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1840","position":[44.83,476.8,106.45],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1841","position":[46.83,476.8,98.95],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"square_007","uniqueIdentifier":"1842","position":[62.11,477.3,89.55],"scale":[4.5,4.5,4.5],"rotation":[0,0,0]},{"assetIdentifier":"square_007","uniqueIdentifier":"1843","position":[58.61,479.8,82.55],"scale":[4.5,4.5,4.5],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1844","position":[46.83,476.8,78.45],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1845","position":[48.83,476.8,76.45],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"square_007","uniqueIdentifier":"1846","position":[52.11,476.8,77.55],"scale":[4.5,4.5,4.5],"rotation":[0,0,0]},{"assetIdentifier":"square_007","uniqueIdentifier":"1847","position":[45.36,477.8,49.3],"scale":[5,4,2.5],"rotation":[0,0,0]},{"assetIdentifier":"square_007","uniqueIdentifier":"1848","position":[45.36,477.8,73.3],"scale":[5,4,2.5],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1849","position":[46.83,476.8,76.45],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1850","position":[43.83,476.8,67.45],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"square_005","uniqueIdentifier":"1851","position":[50.33,472.3,103.95],"scale":[15,7,12],"rotation":[0,0,0]},{"assetIdentifier":"square_005","uniqueIdentifier":"1852","position":[45.33,472.3,72.45],"scale":[5,7,51],"rotation":[0,0,0]},{"assetIdentifier":"square_005","uniqueIdentifier":"1853","position":[45.33,461.8,39.95],"scale":[5,28,14],"rotation":[0,0,0]},{"assetIdentifier":"square_005","uniqueIdentifier":"1854","position":[38.83,444.8,39.95],"scale":[18,6,14],"rotation":[0,0,0]},{"assetIdentifier":"square_005","uniqueIdentifier":"1855","position":[17.83,442.8,39.95],"scale":[18,5,13],"rotation":[0,0,0]},{"assetIdentifier":"square_001","uniqueIdentifier":"1856","position":[13.33,436.8,75.45],"scale":[9,14,23],"rotation":[0,0,0]},{"assetIdentifier":"square_001","uniqueIdentifier":"1857","position":[68.83,431.05,81.2],"scale":[9,2.5,11.5],"rotation":[0,0,0]},{"assetIdentifier":"square_001","uniqueIdentifier":"1858","position":[86.33,431.05,69.45],"scale":[9,2.5,11],"rotation":[0,0,0]},{"assetIdentifier":"square_001","uniqueIdentifier":"1859","position":[77.58,426.8,75.45],"scale":[26.5,6,23],"rotation":[0,0,0]},{"assetIdentifier":"square_005","uniqueIdentifier":"1860","position":[11.83,441.3,57.45],"scale":[6,5,13],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1861","position":[46.83,476.8,61.95],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"square_007","uniqueIdentifier":"1862","position":[45.36,477.8,58.3],"scale":[5,4,2.5],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1863","position":[41.81,448.8,38.44],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1864","position":[45.83,431.8,76.95],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1865","position":[108.83,492.8,105.95],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"gorilla","uniqueIdentifier":"1866","position":[149.04,484.38,120.52],"scale":[1,1,1],"rotation":[0,0,0]},{"assetIdentifier":"chocolate_001","uniqueIdentifier":"1867","position":[418.21,1114.78,52.75],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"fridge_001","uniqueIdentifier":"1868","position":[65.65,1404.35,398.64],"scale":[0.45,0.45,0.45],"rotation":[0,0,0]},{"assetIdentifier":"gorilla","uniqueIdentifier":"1869","position":[103.03,392.1,-34],"scale":[1,1,1],"rotation":[0,0,0]},{"assetIdentifier":"pistachio_001","uniqueIdentifier":"1870","position":[87.22,1401.78,388.34],"scale":[1.5,1,1.5],"rotation":[0,0,0]},{"assetIdentifier":"pan_001","uniqueIdentifier":"1871","position":[-215.95,209,164.2],"scale":[1.5,1,1.5],"rotation":[0,0,0],"behaviour":["Bounce","2.5","",""]},{"uniqueIdentifier":"Spawn","position":[-5.33,1.5,-108.05]},{"assetIdentifier":"moving_block_001","uniqueIdentifier":"1872","position":[81.03,430.06,92.76],"scale":[4,4,4],"rotation":[0,0,0],"behaviour":["Speed","1.625","",""]},{"assetIdentifier":"moving_block_001","uniqueIdentifier":"1873","position":[51.23,345.06,-40.7],"scale":[4,4,4],"rotation":[0,0,0],"behaviour":["Speed","1.8","",""]},{"assetIdentifier":"moving_block_001","uniqueIdentifier":"1874","position":[39.73,351.39,26.12],"scale":[4,4,4],"rotation":[0,0,0],"behaviour":["Speed","1.5","",""]},{"assetIdentifier":"moving_block_001","uniqueIdentifier":"1875","position":[39.73,351.39,41.62],"scale":[4,4,4],"rotation":[0,0,0],"behaviour":["Speed","1.5","",""]},{"assetIdentifier":"moving_block_001","uniqueIdentifier":"1876","position":[39.73,351.39,57.12],"scale":[4,4,4],"rotation":[0,0,0],"behaviour":["Speed","1.5","",""]},{"assetIdentifier":"moving_block_001","uniqueIdentifier":"1877","position":[52.62,361.07,80.45],"scale":[4,4,4],"rotation":[0,0,0],"behaviour":["Speed","1.9","",""]},{"assetIdentifier":"moving_block_001","uniqueIdentifier":"1878","position":[66.4,361.06,-20.67],"scale":[4,4,4],"rotation":[0,0,0],"behaviour":["Speed","1.8","",""]},{"assetIdentifier":"moving_block_001","uniqueIdentifier":"1879","position":[61.4,361.06,-2.67],"scale":[4,4,4],"rotation":[0,0,0],"behaviour":["Speed","1.8","",""]},{"assetIdentifier":"pan_001","uniqueIdentifier":"1880","position":[139.71,409.45,89],"scale":[2.18,2.18,2.18],"rotation":[0,0,0],"behaviour":["Bounce","3","",""]},{"assetIdentifier":"moving_block_001","uniqueIdentifier":"1881","position":[144.41,408.62,83.24],"scale":[4,4,4],"rotation":[0,0,0],"behaviour":["Speed","1.625","",""]},{"assetIdentifier":"moving_block_001","uniqueIdentifier":"1882","position":[144.01,408.62,68.65],"scale":[4,4,4],"rotation":[0,0,0],"behaviour":["Speed","1.625","",""]},{"assetIdentifier":"moving_block_001","uniqueIdentifier":"1883","position":[134.91,408.62,56.68],"scale":[4,4,4],"rotation":[0,0,0],"behaviour":["Speed","1.625","",""]},{"assetIdentifier":"pan_001","uniqueIdentifier":"1884","position":[128.66,411.14,32.94],"scale":[1.83,1.83,1.83],"rotation":[0,0,0],"behaviour":["Bounce","1.15","",""]},{"assetIdentifier":"moving_block_001","uniqueIdentifier":"1885","position":[127.91,412.8,25.68],"scale":[4,4,4],"rotation":[0,0,0],"behaviour":["Speed","1.36","",""]},{"assetIdentifier":"moving_block_001","uniqueIdentifier":"1886","position":[127.91,413.3,7.15],"scale":[4,4,4],"rotation":[0,0,0],"behaviour":["Speed","2","",""]},{"assetIdentifier":"moving_block_001","uniqueIdentifier":"1887","position":[127.91,413.3,-10.85],"scale":[4,4,4],"rotation":[0,0,0],"behaviour":["Speed","2","",""]},{"assetIdentifier":"pan_001","uniqueIdentifier":"1888","position":[128.66,404.14,-30.15],"scale":[1.83,1.83,1.83],"rotation":[0,0,0],"behaviour":["Bounce","1.81","",""]},{"assetIdentifier":"moving_block_001","uniqueIdentifier":"1889","position":[127.91,404.2,-41.55],"scale":[4,4,4],"rotation":[0,0,0],"behaviour":["Speed","1.36","",""]},{"assetIdentifier":"moving_block_001","uniqueIdentifier":"1890","position":[127.91,404.2,-60.05],"scale":[4,4,4],"rotation":[0,0,0],"behaviour":["Speed","2","",""]},{"assetIdentifier":"moving_block_001","uniqueIdentifier":"1891","position":[127.91,404.2,-79.05],"scale":[4,4,4],"rotation":[0,0,0],"behaviour":["Speed","2","",""]},{"assetIdentifier":"pan_001","uniqueIdentifier":"1892","position":[116.21,372.87,-86.74],"scale":[3.03,3.03,3.03],"rotation":[0,0,0],"behaviour":["Bounce","2.89","",""]},{"assetIdentifier":"slow_block_001","uniqueIdentifier":"1893","position":[107.07,367.89,-84.75],"scale":[4,12.5,4],"rotation":[0,0,0]},{"assetIdentifier":"slow_block_001","uniqueIdentifier":"1894","position":[103.07,363.64,-84.75],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"pan_001","uniqueIdentifier":"1895","position":[79.68,354.87,-86.74],"scale":[3.03,3.03,3.03],"rotation":[0,0,0],"behaviour":["Bounce","2","",""]},{"assetIdentifier":"moving_block_001","uniqueIdentifier":"1896","position":[79.23,353.56,-58.9],"scale":[4,4,4],"rotation":[0,0,0],"behaviour":["Speed","1.5","",""]},{"assetIdentifier":"pan_001","uniqueIdentifier":"1897","position":[79.68,354.87,-63.81],"scale":[1,1,1],"rotation":[0,0,0],"behaviour":["Bounce","1.5","",""]},{"assetIdentifier":"moving_block_001","uniqueIdentifier":"1898","position":[58.46,345.06,-53],"scale":[2,2,2],"rotation":[0,0,0],"behaviour":["Speed","1.6","",""]},{"assetIdentifier":"pan_001","uniqueIdentifier":"1899","position":[37.84,357.43,116.53],"scale":[1.66,1.66,1.66],"rotation":[0,0,0],"behaviour":["Bounce","1.5","",""]},{"assetIdentifier":"moving_block_001","uniqueIdentifier":"1900","position":[38.73,356.39,123.62],"scale":[4,4,4],"rotation":[0,0,0],"behaviour":["Speed","2","",""]},{"assetIdentifier":"check_point_001","uniqueIdentifier":"checkpoint_30","position":[158.73,410.56,97.5],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"check_point_001","uniqueIdentifier":"checkpoint_28","position":[55.06,362.06,23.85],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"check_point_001","uniqueIdentifier":"checkpoint_27","position":[38.23,307.56,146],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"square_001","uniqueIdentifier":"1901","position":[107.23,370.06,-56.5],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"square_001","uniqueIdentifier":"1902","position":[92.23,367.06,-50],"scale":[4,2,8],"rotation":[0,0,0]},{"assetIdentifier":"square_001","uniqueIdentifier":"1903","position":[91.73,424.56,96.5],"scale":[5,15,4],"rotation":[0,0,0]},{"assetIdentifier":"square_001","uniqueIdentifier":"1904","position":[100.23,424.56,96.5],"scale":[5,15,4],"rotation":[0,0,0]},{"assetIdentifier":"square_001","uniqueIdentifier":"1905","position":[108.73,424.56,96.5],"scale":[5,15,4],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1906","position":[157.73,411.06,77.5],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1907","position":[159.23,411.06,65],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1908","position":[160.73,411.06,55],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"square_008","uniqueIdentifier":"1909","position":[56.06,364.56,6.85],"scale":[4,7,4],"rotation":[0,0,0]},{"assetIdentifier":"square_001","uniqueIdentifier":"1910","position":[102.73,394.31,-35],"scale":[4,5.5,2],"rotation":[0,0,0]},{"assetIdentifier":"square_006","uniqueIdentifier":"1911","position":[103.23,364.56,-45],"scale":[18,65,18],"rotation":[0,0,0]},{"assetIdentifier":"square_001","uniqueIdentifier":"1912","position":[77.73,348.81,-60],"scale":[7,5.5,12],"rotation":[0,0,0]},{"assetIdentifier":"square_007","uniqueIdentifier":"1913","position":[45.98,350.89,25.87],"scale":[8.5,5,4.5],"rotation":[0,0,0]},{"assetIdentifier":"square_007","uniqueIdentifier":"1914","position":[45.98,350.89,41.87],"scale":[8.5,5,4.5],"rotation":[0,0,0]},{"assetIdentifier":"square_007","uniqueIdentifier":"1915","position":[45.98,350.89,56.87],"scale":[8.5,5,4.5],"rotation":[0,0,0]},{"assetIdentifier":"square_001","uniqueIdentifier":"1916","position":[88.73,431.06,90.5],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"square_001","uniqueIdentifier":"1917","position":[117.23,424.56,96.5],"scale":[5,15,4],"rotation":[0,0,0]},{"assetIdentifier":"square_001","uniqueIdentifier":"1918","position":[122.23,419.06,96.5],"scale":[5,4,4],"rotation":[0,0,0]},{"assetIdentifier":"square_001","uniqueIdentifier":"1919","position":[130.23,417.56,96.5],"scale":[5,4,4],"rotation":[0,0,0]},{"assetIdentifier":"square_001","uniqueIdentifier":"1920","position":[137.73,415.56,96.5],"scale":[5,4,4],"rotation":[0,0,0]},{"assetIdentifier":"square_001","uniqueIdentifier":"1921","position":[144.73,414.06,96.5],"scale":[5,4,4],"rotation":[0,0,0]},{"assetIdentifier":"square_001","uniqueIdentifier":"1922","position":[151.73,411.06,96.5],"scale":[5,4,4],"rotation":[0,0,0]},{"assetIdentifier":"square_001","uniqueIdentifier":"1923","position":[159.23,401.56,90],"scale":[5,17,4],"rotation":[0,0,0]},{"assetIdentifier":"square_001","uniqueIdentifier":"1924","position":[159.23,401.56,69.5],"scale":[5,17,31],"rotation":[0,0,0]},{"assetIdentifier":"square_001","uniqueIdentifier":"1925","position":[147.73,401.56,47.5],"scale":[28,17,6],"rotation":[0,0,0]},{"assetIdentifier":"square_001","uniqueIdentifier":"1926","position":[108.91,398.06,-27.58],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"square_001","uniqueIdentifier":"1927","position":[108.91,398.06,-51.08],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"square_001","uniqueIdentifier":"1928","position":[96.41,398.06,-47.58],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"square_001","uniqueIdentifier":"1929","position":[98.41,398.06,-35.58],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"square_001","uniqueIdentifier":"1930","position":[105.41,398.06,-42.58],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1931","position":[88.23,357.56,-49.5],"scale":[1,1,1],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1932","position":[88.23,353.06,-70],"scale":[1,1,1],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1933","position":[87.23,372.56,-46],"scale":[1,1,1],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1934","position":[89.23,378.56,-46],"scale":[1,1,1],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1935","position":[91.23,391.06,-46],"scale":[1,1,1],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1936","position":[120.73,391.06,-46],"scale":[1,1,1],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1937","position":[117.23,385.56,-46],"scale":[1,1,1],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1938","position":[120.73,378.06,-46],"scale":[1,1,1],"rotation":[0,0,0]},{"assetIdentifier":"square_001","uniqueIdentifier":"1939","position":[97.48,394.31,-33],"scale":[6.5,5.5,6],"rotation":[0,0,0]},{"assetIdentifier":"square_001","uniqueIdentifier":"1940","position":[108.48,394.31,-33],"scale":[7.5,5.5,6],"rotation":[0,0,0]},{"assetIdentifier":"check_point_001","uniqueIdentifier":"checkpoint_29","position":[102.73,396.06,-31],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"square_007","uniqueIdentifier":"1941","position":[45.98,342.64,101.62],"scale":[8.5,11.5,28],"rotation":[0,0,0]},{"assetIdentifier":"square_007","uniqueIdentifier":"1942","position":[45.98,342.64,45.12],"scale":[8.5,11.5,65],"rotation":[0,0,0]},{"assetIdentifier":"square_001","uniqueIdentifier":"1943","position":[101.98,428.06,79],"scale":[8.5,5.5,6],"rotation":[0,0,0]},{"assetIdentifier":"square_001","uniqueIdentifier":"1944","position":[112.98,416.56,77.5],"scale":[8.5,5.5,6],"rotation":[0,0,0]},{"assetIdentifier":"square_001","uniqueIdentifier":"1945","position":[125.48,409.06,77],"scale":[8.5,5.5,6],"rotation":[0,0,0]},{"assetIdentifier":"square_001","uniqueIdentifier":"1946","position":[125.48,406.56,62.5],"scale":[8.5,5.5,6],"rotation":[0,0,0]},{"assetIdentifier":"square_001","uniqueIdentifier":"1947","position":[125.48,401.56,47.5],"scale":[8.5,17,6],"rotation":[0,0,0]},{"assetIdentifier":"square_001","uniqueIdentifier":"1948","position":[125.48,395.06,41.5],"scale":[8.5,4,6],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1949","position":[127.73,399.06,4],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1950","position":[127.73,399.06,0],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1951","position":[91.73,395.06,12],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1952","position":[91.73,395.06,8],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1953","position":[91.73,395.06,4],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1954","position":[91.73,395.06,0],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1955","position":[110.31,399.06,30.5],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1956","position":[115.91,399.06,22.5],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1957","position":[109.31,399.06,14.5],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1958","position":[127.73,399.06,26.5],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1959","position":[122.81,399.06,18.5],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1960","position":[116.64,399.06,10.5],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1961","position":[91.73,395.06,-4],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1962","position":[91.73,399.06,-4],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1963","position":[127.73,399.06,-4],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1964","position":[123.73,399.06,-4],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1965","position":[119.73,399.06,-4],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1966","position":[115.73,399.06,-4],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1967","position":[107.73,399.06,-4],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1968","position":[103.73,399.06,-4],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1969","position":[99.73,399.06,-4],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1970","position":[95.73,399.06,-4],"scale":[4,4,4],"rotation":[0,0,0]},{"assetIdentifier":"square_001","uniqueIdentifier":"1971","position":[111.73,395.06,16.25],"scale":[36,4,44.5],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1972","position":[103.23,398.06,-20.5],"scale":[9,9,9],"rotation":[0,0,0]},{"assetIdentifier":"square_001","uniqueIdentifier":"1973","position":[96.73,350.06,-60],"scale":[31,36,12],"rotation":[0,0,0]},{"assetIdentifier":"square_001","uniqueIdentifier":"1974","position":[64.48,339.06,-60],"scale":[33.5,14,12],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1975","position":[63.73,337.06,-46.5],"scale":[9,9,9],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1976","position":[63.73,346.06,-46.5],"scale":[9,9,9],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1977","position":[63.73,355.06,-46.5],"scale":[9,9,9],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1978","position":[45.23,362.06,133],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1979","position":[47.23,362.06,133],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1980","position":[49.23,362.06,133],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1981","position":[59.23,360.06,133],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1982","position":[57.23,360.06,133],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1983","position":[55.23,360.06,133],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1984","position":[53.23,360.06,133],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1985","position":[54.73,364.06,-46.5],"scale":[9,9,9],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1986","position":[63.73,364.06,-46.5],"scale":[9,9,9],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1987","position":[72.73,364.06,-46.5],"scale":[9,9,9],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1988","position":[72.73,364.06,-37.5],"scale":[9,9,9],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1989","position":[72.73,364.06,-28.5],"scale":[9,9,9],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1990","position":[72.73,364.06,-19.5],"scale":[9,9,9],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1991","position":[72.73,364.06,-10.5],"scale":[9,9,9],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1992","position":[72.73,364.06,-1.5],"scale":[9,9,9],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1993","position":[72.73,364.06,7.5],"scale":[9,9,9],"rotation":[0,0,0]},{"assetIdentifier":"square_008","uniqueIdentifier":"1994","position":[63.73,357.06,-19.5],"scale":[9,8,44.5],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1995","position":[45.73,356.56,-10],"scale":[9,9,9],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1996","position":[45.73,356.56,-1],"scale":[9,9,9],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1997","position":[54.73,365.56,-1],"scale":[9,9,9],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1998","position":[54.73,365.56,-10],"scale":[9,9,9],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"1999","position":[54.73,365.56,-19],"scale":[9,9,9],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"2000","position":[63.73,364.06,34.5],"scale":[9,9,9],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"2001","position":[63.73,364.06,25.5],"scale":[9,9,9],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"2002","position":[63.73,364.06,16.5],"scale":[9,9,9],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"2003","position":[63.73,364.06,7.5],"scale":[9,9,9],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"2004","position":[45.73,330.06,8],"scale":[9,9,9],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"2005","position":[45.73,338.56,8],"scale":[9,9,9],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"2006","position":[45.73,347.56,8],"scale":[9,9,9],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"2007","position":[45.73,356.56,8],"scale":[9,9,9],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"2008","position":[54.73,365.56,43],"scale":[9,9,9],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"2009","position":[54.73,365.56,52],"scale":[9,9,9],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"2010","position":[54.73,365.56,61],"scale":[9,9,9],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"2011","position":[45.73,330.06,82.5],"scale":[9,9,9],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"2012","position":[45.51,338.5,82.55],"scale":[9,9,9],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"2013","position":[45.51,347.5,82.55],"scale":[9,9,9],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"2014","position":[45.51,356.5,82.55],"scale":[9,9,9],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"2015","position":[63.73,364.06,70],"scale":[9,9,9],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"2016","position":[63.73,364.06,79],"scale":[9,9,9],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"2017","position":[63.73,364.06,88],"scale":[9,9,9],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"2018","position":[63.73,364.06,97],"scale":[9,9,9],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"2019","position":[63.73,364.06,126.5],"scale":[9,9,9],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"2020","position":[54.73,365.56,105],"scale":[9,9,9],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"2021","position":[54.73,365.56,114],"scale":[9,9,9],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"2022","position":[54.73,365.56,123],"scale":[9,9,9],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"2023","position":[63.73,364.06,135.5],"scale":[9,9,9],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"2024","position":[63.73,364.06,144.5],"scale":[9,9,9],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"2025","position":[63.73,364.06,153.5],"scale":[9,9,9],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"2026","position":[49.23,342.06,133],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"2027","position":[49.23,340.06,133],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"2028","position":[49.23,338.06,133],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"2029","position":[49.23,336.06,133],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"2030","position":[49.23,334.06,133],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"large_square_001","uniqueIdentifier":"2031","position":[54.73,346.56,54.25],"scale":[3,29,51.84],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"2032","position":[51.23,352.06,159],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"2033","position":[51.23,350.06,159],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"2034","position":[51.23,348.06,159],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"2035","position":[51.23,360.06,133],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"2036","position":[51.23,358.06,133],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"2037","position":[51.23,356.06,133],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"2038","position":[51.23,354.06,133],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"2039","position":[51.23,352.06,133],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"2040","position":[51.23,350.06,133],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"2041","position":[51.23,348.06,133],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"2042","position":[51.23,360.06,159],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"2043","position":[51.23,358.06,159],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"2044","position":[51.23,356.06,159],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"2045","position":[51.23,354.06,159],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"2046","position":[49.23,332.06,159],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"2047","position":[47.23,308.06,159],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"2048","position":[47.23,310.06,159],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"2049","position":[47.23,312.06,159],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"2050","position":[47.23,314.06,159],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"2051","position":[47.23,316.06,159],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"2052","position":[47.23,318.06,159],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"2053","position":[47.23,320.06,159],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"2054","position":[47.23,322.06,159],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"2055","position":[47.23,324.06,159],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"2056","position":[47.23,326.06,159],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"2057","position":[47.23,328.06,159],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"2058","position":[47.23,330.06,159],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"2059","position":[47.23,332.06,159],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"2060","position":[47.23,308.06,133],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"2061","position":[47.23,310.06,133],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"2062","position":[47.23,312.06,133],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"2063","position":[47.23,314.06,133],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"2064","position":[47.23,316.06,133],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"2065","position":[47.23,318.06,133],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"2066","position":[47.23,320.06,133],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"2067","position":[47.23,322.06,133],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"2068","position":[47.23,324.06,133],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"2069","position":[47.23,326.06,133],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"2070","position":[47.23,328.06,133],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"2071","position":[47.23,330.06,133],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"2072","position":[51.23,346.06,159],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"2073","position":[51.23,344.06,159],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"2074","position":[51.23,342.06,159],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"2075","position":[51.23,340.06,159],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"2076","position":[51.23,338.06,159],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"2077","position":[51.23,336.06,159],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"2078","position":[51.23,334.06,159],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"2079","position":[51.23,346.06,133],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"2080","position":[51.23,344.06,133],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"2081","position":[51.23,342.06,133],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"2082","position":[51.23,340.06,133],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"2083","position":[51.23,338.06,133],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"2084","position":[51.23,336.06,133],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"2085","position":[51.23,334.06,133],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"death_block_001","uniqueIdentifier":"2086","position":[47.23,332.06,133],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"large_square_001","uniqueIdentifier":"2087","position":[54.73,346.56,146],"scale":[3,29,8],"rotation":[0,0,0]},{"assetIdentifier":"large_square_001","uniqueIdentifier":"2088","position":[52.23,319.81,146],"scale":[4,26.5,8],"rotation":[0,0,0]},{"assetIdentifier":"square_007","uniqueIdentifier":"2089","position":[40.98,356.39,127.62],"scale":[8.5,4,4],"rotation":[0,0,0]},{"assetIdentifier":"square_008","uniqueIdentifier":"2090","position":[56.06,363.56,14.85],"scale":[4,5,4],"rotation":[0,0,0]},{"assetIdentifier":"square_001","uniqueIdentifier":"2091","position":[52.6,339.06,-45.1],"scale":[9.73,14,17.8],"rotation":[0,0,0]},{"assetIdentifier":"square_001","uniqueIdentifier":"2092","position":[103.23,394.31,-20.75],"scale":[18,5.5,18.5],"rotation":[0,0,0]},{"assetIdentifier":"square_001","uniqueIdentifier":"2093","position":[-211.99,217,196.05],"scale":[4,2,4],"rotation":[0,0,0]},{"assetIdentifier":"square_001","uniqueIdentifier":"2094","position":[-223.59,252.5,112.49],"scale":[4,2,5],"rotation":[0,0,0]},{"assetIdentifier":"pan_001","uniqueIdentifier":"2095","position":[373.97,1102.25,97.6],"scale":[3.28,3.28,3.28],"rotation":[0,0,0],"behaviour":["Bounce","4.25","",""]},{"assetIdentifier":"gorilla","uniqueIdentifier":"2096","position":[67.55,276.24,47.9],"scale":[1,1,1],"rotation":[0,3.14,0]},{"assetIdentifier":"gorilla","uniqueIdentifier":"2097","position":[55.47,356.19,158],"scale":[1,1,1],"rotation":[0,0,0]},{"assetIdentifier":"square_001","uniqueIdentifier":"2098","position":[-171.99,205,176.05],"scale":[4,2,4],"rotation":[0,0,0]},{"assetIdentifier":"square_001","uniqueIdentifier":"2099","position":[-175.99,208,193.05],"scale":[4,2,4],"rotation":[0,0,0]},{"assetIdentifier":"gorilla","uniqueIdentifier":"2100","position":[53.19,1414.28,521.62],"scale":[6.8,6.8,6.8],"rotation":[0,0,0]},{"assetIdentifier":"pan_001","uniqueIdentifier":"2101","position":[-181.95,209,192.2],"scale":[1.5,1,1.5],"rotation":[0,0,0],"behaviour":["Bounce","1.75","",""]},{"assetIdentifier":"chocolate_001","uniqueIdentifier":"2102","position":[-223.34,253.5,112.39],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"fridge_001","uniqueIdentifier":"2103","position":[403.79,713.57,43.14],"scale":[0.45,0.45,0.45],"rotation":[0,0,0]},{"assetIdentifier":"check_point_001","uniqueIdentifier":"check_point_001","position":[202.12,535.29,-14.85],"scale":[2,2,2],"rotation":[0,0,0]},{"assetIdentifier":"gorilla","uniqueIdentifier":"2104","position":[409.03,1100.62,92.04],"scale":[1,1,1],"rotation":[0,3.14,0]},{"assetIdentifier":"gorilla","uniqueIdentifier":"2105","position":[-5.26,-13.22,0.21],"scale":[2.94,2.94,2.94],"rotation":[0,0,0]},{"assetIdentifier":"square_001","uniqueIdentifier":"2106","position":[-218.99,217,176.05],"scale":[4,2,4],"rotation":[0,0,0]},{"assetIdentifier":"check_point_001","uniqueIdentifier":"check_point_001","position":[463.83,1056.28,152.29],"scale":[3,3,3],"rotation":[0,0,0]},{"assetIdentifier":"square_001","uniqueIdentifier":"2107","position":[-171.99,208,185.05],"scale":[4,2,4],"rotation":[0,0,0]},{"assetIdentifier":"gorilla","uniqueIdentifier":"2108","position":[12.83,1180.06,31.01],"scale":[1,1,1],"rotation":[0,0,0]},{"assetIdentifier":"gorilla","uniqueIdentifier":"2109","position":[-14.48,277,55.7],"scale":[1,1,1],"rotation":[0,0,0]}]}');


const { platforms: $cd87776b9916381d$var$platforms } = (0, (/*@__PURE__*/$parcel$interopDefault($cae8463151c972d6$exports)));
const $cd87776b9916381d$var$playerSpawnPoint = $cd87776b9916381d$var$platforms.find((platform)=>platform.uniqueIdentifier === "Spawn");
if (!$cd87776b9916381d$var$playerSpawnPoint) throw new Error("Could not find player spawn point in level data!");
const $cd87776b9916381d$export$b3ee8d2e5964aa98 = ()=>{
    const uniquePlatformMeshes = new Set();
    for (const platform of $cd87776b9916381d$var$platforms)// if (uniquePlatformMeshes.has(platform.assetIdentifier!) === false) {
    //     console.log(platform.assetIdentifier!);
    // }
    if (platform.assetIdentifier !== undefined) uniquePlatformMeshes.add(platform.assetIdentifier);
    return uniquePlatformMeshes.size;
};
const $cd87776b9916381d$export$4e51d45cdc5d3270 = $cd87776b9916381d$var$playerSpawnPoint.position;


var $8665ec0109254415$export$7cb66f675ad36cd2;
(function(CausesOfDeath) {
    CausesOfDeath[CausesOfDeath["TouchedADeathBlock"] = 0] = "TouchedADeathBlock";
    CausesOfDeath[CausesOfDeath["FellIntoTheVoid"] = 1] = "FellIntoTheVoid";
})($8665ec0109254415$export$7cb66f675ad36cd2 || ($8665ec0109254415$export$7cb66f675ad36cd2 = {}));
const $8665ec0109254415$export$13305fe0ce625167 = ()=>{
    const randomIndex = Math.floor(Math.random() * 3);
    switch(randomIndex){
        case 0:
            return (0, $018036e722cee03d$export$a3168656a78efa21).Broccoli;
        case 1:
            return (0, $018036e722cee03d$export$a3168656a78efa21).Blueberry;
        case 2:
            return (0, $018036e722cee03d$export$a3168656a78efa21).Apple;
        default:
            return (0, $018036e722cee03d$export$a3168656a78efa21).Apple;
    }
};
class $8665ec0109254415$export$ca71fcae86980bb extends (0, $07756da3fdd79b5d$export$2c106553ed021268) {
    RunHasStarted() {
        return this.runHasStarted;
    }
    get runInProgress() {
        return this.runHasStarted && this.runHasEnded === false ? true : false;
    }
    _updateSideEffects() {}
    _intentionalRespawnSideEffects() {}
    _jumpSideEffects() {}
    _bounceSideEffects() {}
    _checkpointSideEffects() {}
    _fallingDeathSideEffects() {}
    _intentionalRestartEntireRunSideEffects() {}
    _deathBlockTriggerSideEffect() {}
    _startingLineTriggerSideEffect() {}
    _resetUIPopTriggerSideEffect() {}
    _uiPopTriggerSideEffect(__trigger, __deltaTimeS) {}
    _finishLineTriggerSideEffect() {}
    _tryUpdateMobileMovementSideEffect() {}
    ResetUIPopTriggerAcc() {
        this.uiPopTriggerAcculumator = 0;
        this._resetUIPopTriggerSideEffect();
    }
    CollidedWithTrigger(trigger, deltaTimeS) {
        if (trigger.TriggerType === (0, $07756da3fdd79b5d$export$aaab732ed133eca).Checkpoint) {
            // console.log("Player collided with check point");
            if (this.CheckpointsReached.has(trigger.AssociatedPlatform)) ;
            else {
                if (this.runHasEnded === true) return;
                // console.log("Player has not reached this checkpoint, adding to set");
                this.CheckpointsReached.add(trigger.AssociatedPlatform);
                this.RespawnPosition.set(trigger.Position.x, trigger.Position.y, trigger.Position.z);
                this._checkpointSideEffects();
            }
        } else if (trigger.TriggerType === (0, $07756da3fdd79b5d$export$aaab732ed133eca).DeathBlock) {
            this.shouldRespawn = true;
            this.fallsThisSession++;
            this._deathBlockTriggerSideEffect();
        } else if (trigger.TriggerType === (0, $07756da3fdd79b5d$export$aaab732ed133eca).StartingLine) {
            if (this.runHasStarted) return;
            this._startingLineTriggerSideEffect();
            this.runHasStarted = true;
        } else if (trigger.TriggerType === (0, $07756da3fdd79b5d$export$aaab732ed133eca).UI_PopUp_CharacterSelect || trigger.TriggerType === (0, $07756da3fdd79b5d$export$aaab732ed133eca).UI_PopUp_NameAndCountrySelect || trigger.TriggerType === (0, $07756da3fdd79b5d$export$aaab732ed133eca).UI_PopUp_EndRun || trigger.TriggerType === (0, $07756da3fdd79b5d$export$aaab732ed133eca).UI_PopUp_TrailSelect) this._uiPopTriggerSideEffect(trigger, deltaTimeS);
        else if (trigger.TriggerType === (0, $07756da3fdd79b5d$export$aaab732ed133eca).FinishLine) {
            if (this.runHasStarted === false) return;
            if (this.runHasEnded === false) this._finishLineTriggerSideEffect();
            this.runHasEnded = true;
        } else if (trigger.TriggerType === (0, $07756da3fdd79b5d$export$aaab732ed133eca).Bounce) {
            if (this.IsGrounded) {
                this.deathFallTimer = 0;
                this._jumpSideEffects();
                this._bounceSideEffects();
                this.Velocity.y = (0, $b80b6e4c153785d9$export$29cd7b75162a9425).Player.JUMP_VELOCITY * trigger.BehaviourValue;
                this.IsGrounded = false;
            }
        } else if (trigger.TriggerType === (0, $07756da3fdd79b5d$export$aaab732ed133eca).Speed) {
            if (this.IsGrounded) {
                this.speedBlockFactor = trigger.BehaviourValue;
                this.isOnSpeedBlock = true;
            }
        }
    }
    Respawn() {
        // console.log(`Respawning player as death timer is > ${Config.Player.DEATH_FALL_TIMER}`);
        this.Position.set(this.RespawnPosition.x, this.RespawnPosition.y, this.RespawnPosition.z);
        this.Velocity.set(0, 0, 0);
        this.shouldRespawn = false;
        this.deathFallTimer = 0;
        this.MovementFrozenDuration = (0, $b80b6e4c153785d9$export$29cd7b75162a9425).Player.RESPAWN_MOVEMENT_DELAY;
        this.speedBlockFactor = 1;
        this.isOnSpeedBlock = false;
    }
    DebugForceTeleport() {}
    DebugForceCheckpoint() {}
    ProcessInputs(inputCommand) {
        const { forward: forward, back: back, left: left, right: right, jump: jump, rotY: cameraYRotation, isMobile: isMobile, playerIsMoving: playerIsMoving, mobileXDirection: mobileXDirection, mobileZDirection: mobileZDirection, mobileSpeedMultiplier: mobileSpeedMultiplier, wantsToRespawnAtCheckpoint: wantsToRespawnAtCheckpoint, wantsToRestartRun: wantsToRestartRun } = inputCommand;
        let { delta: deltaTimeS } = inputCommand;
        // console.log(this.CollidingWithUIPopTrigger);
        // console.log(this.uiPopTriggerAcculumator);
        // console.warn("Player wants to restart run???", wantsToRestartRun);
        this.finiteStateMachine.Update(deltaTimeS, this.animationState);
        this._processCurrentAnimationState();
        // Cap delta to minimum 10fps
        if (deltaTimeS > 0.1) deltaTimeS = 0.1;
        if (this.MovementFrozenDuration > 0) {
            this.MovementFrozenDuration = Math.max(this.MovementFrozenDuration - deltaTimeS, 0);
            return;
        }
        this.movementVector.set(0, 0, 0);
        this.forwardBackwardVector.set(0, 0, 0);
        this.leftRightVector.set(0, 0, 0);
        if (this.runHasStarted && this.runHasEnded === false) this.runDurationAcc += deltaTimeS;
        // console.warn("Player wants to respawn?", wantsToRespawnAtCheckpoint);
        this.lastRespawnedAtAccumulator += deltaTimeS;
        if (wantsToRestartRun && this.runHasStarted === true) {
            this._intentionalRestartEntireRunSideEffects();
            this.runHasStarted = false;
            this.runHasEnded = false;
            this.runDurationAcc = 0;
            this.CheckpointsReached.clear();
            this.RespawnPosition.set((0, $cd87776b9916381d$export$4e51d45cdc5d3270)[0], (0, $cd87776b9916381d$export$4e51d45cdc5d3270)[1], (0, $cd87776b9916381d$export$4e51d45cdc5d3270)[2]);
            this.shouldRespawn = true;
        }
        if (wantsToRespawnAtCheckpoint && this.runHasStarted === true) {
            if (this.lastRespawnedAtAccumulator > 1) {
                this._intentionalRespawnSideEffects();
                this.shouldRespawn = true;
                this.fallsThisSession++;
                this.lastRespawnedAtAccumulator = 0;
            }
        }
        if (this.y <= -250) this.shouldRespawn = true;
        if (this.shouldRespawn) {
            this.Respawn();
            return;
        }
        if (isMobile) {
            if (!playerIsMoving) this.movementVector.set(mobileXDirection, -this.movementVector.y, -mobileZDirection);
            this.animationSpeedMultiplier = mobileSpeedMultiplier;
            this.mobileJoystickMovementMultplier.set(mobileSpeedMultiplier, 0, mobileSpeedMultiplier);
            this.movementVector.add(new (0, $9014d97cd777be10$export$64b5c384219d3699)(-mobileXDirection, this.movementVector.y, mobileZDirection)).multiplyScalar(mobileSpeedMultiplier);
            this.movementVector.applyEuler(new (0, $9014d97cd777be10$export$d93cc409a0768c5f)(0, cameraYRotation, 0, "XYZ"));
        } else {
            // Move the player forward, where forward is based on the camera's Y rotation
            const cameraForwardX = Math.sin(cameraYRotation);
            const cameraForwardZ = Math.cos(cameraYRotation);
            const cameraRightX = Math.sin(cameraYRotation - Math.PI / 2);
            const cameraRightZ = Math.cos(cameraYRotation - Math.PI / 2);
            this.forwardBackwardVector.set(cameraForwardX, 0, cameraForwardZ);
            this.leftRightVector.set(cameraRightX, 0, cameraRightZ);
            // console.log("ForwardBackwardVector: ", this.forwardBackwardVector);
            // console.log("LeftRightVector: ", this.leftRightVector);
            if (forward) this.movementVector.add(this.forwardBackwardVector);
            else if (back) this.movementVector.sub(this.forwardBackwardVector);
            if (left) this.movementVector.add(this.leftRightVector.multiplyScalar(-1));
            else if (right) this.movementVector.add(this.leftRightVector);
        }
        this._tryUpdateMobileMovementSideEffect();
        this.Velocity.x = 0;
        // this.Velocity.y = 0;
        this.Velocity.z = 0;
        if (isMobile) this.Velocity.add(this.movementVector.normalize().multiply(this.mobileJoystickMovementMultplier));
        else this.Velocity.add(this.movementVector.normalize());
        this.Velocity.x *= this.speedBlockFactor;
        this.Velocity.z *= this.speedBlockFactor;
        if (this.IsGrounded) {
            this.deathFallTimer = 0;
            if (!this.isOnSpeedBlock) this.speedBlockFactor = 1;
            this.isOnSpeedBlock = false;
            if (jump) {
                this._jumpSideEffects();
                this.Velocity.y = (0, $b80b6e4c153785d9$export$29cd7b75162a9425).Player.JUMP_VELOCITY;
                if (this.speedBlockFactor < 1) this.Velocity.y *= 0.7;
            } else this.Velocity.y = 0;
        } else {
            this.Velocity.y = Math.max(this.Velocity.y - (0, $b80b6e4c153785d9$export$29cd7b75162a9425).World.GRAVITY * deltaTimeS, -5);
            // // Check if the players velocity is negative, if so increment a falling timer by deltaTimeS.
            if (this.Velocity.y < 0) this.deathFallTimer += deltaTimeS;
            // // If the players falling timer exceeds a certain amount, set the player to be in a death fall. Death fall timer = "how long does the player have to be falling for us to consider them to be dead"
            if (this.deathFallTimer > (0, $b80b6e4c153785d9$export$29cd7b75162a9425).Player.DEATH_FALL_TIMER && this.shouldRespawn === false && this.IsGrounded === false) {
                // If they've completed a run, use their super long death timer instead so they can fall to the bottom of the level
                if (this.runHasEnded) {
                    if (this.deathFallTimer > (0, $b80b6e4c153785d9$export$29cd7b75162a9425).Player.DEATH_FALL_TIMER_AFTER_RUN_COMPLETE) {
                        this.shouldRespawn = true;
                        this.fallsThisSession++;
                        this._fallingDeathSideEffects();
                    }
                } else {
                    this.shouldRespawn = true;
                    this._fallingDeathSideEffects();
                }
            }
        }
        const distanceToTravel = (0, $b80b6e4c153785d9$export$29cd7b75162a9425).Player.SPEED_PER_SECOND * deltaTimeS;
        this.x = this.x + this.Velocity.x * distanceToTravel;
        this.y = this.y + this.Velocity.y * distanceToTravel;
        this.z = this.z + this.Velocity.z * distanceToTravel;
        this.collisionSystemRef.CheckForCollisions(this, deltaTimeS);
        this._updateSideEffects();
    }
    _processCurrentAnimationState() {
        //console.log(this.animationState);
        if (this.Velocity.y >= this.jumpingThreshold) {
            this.animationState = "jumping_up";
            //console.log("processing inputs");
            return;
        }
        this.fallingThreshold = -0.4;
        if (this.animationState === "jumping_up") this.fallingThreshold = 0.1;
        if (this.Velocity.y <= this.fallingThreshold) {
            this.animationState = "falling";
            return;
        }
        if ((Math.abs(this.Velocity.x) > 0 || Math.abs(this.Velocity.z) > 0) && this.IsGrounded) {
            this.animationState = "walking";
            return;
        }
        if (this.IsGrounded) this.animationState = "idle";
    //console.log(this.animationState);
    }
    constructor(collisionSystemRef, initialX, initialY, initialZ, runHasStarted, runInProgressDurationSeconds){
        super(initialX, initialY, initialZ, 1, 1, 1, 0, 0, 0);
        this.nid = -1;
        this.ntype = (0, $7c910687071ab881$export$f7cab339749a57d7).PlayerEntity;
        this.characterSkin = 1;
        this.characterTrail = -1;
        this.finiteStateMachine = new $8665ec0109254415$export$99a971d0f8e079b3(this);
        this.RespawnPosition = new (0, $9014d97cd777be10$export$64b5c384219d3699)(0, 0, 0);
        this.CheckpointsReached = new Set();
        this.runHasStarted = false;
        this.runHasEnded = false;
        this.runDurationAcc = 0;
        this.animationSpeedMultiplier = 1;
        this.defaultAnimationSpeedMultiplier = 1;
        this.fallsThisSession = 0;
        this.connectedAt = Date.now();
        this.animationState = "idle";
        this.fallingThreshold = -0.4;
        this.jumpingThreshold = 0.4;
        this.MovementFrozenDuration = 0;
        this.VerticallyResolvedThisFrame = false;
        this.IsGrounded = false;
        this.CollidingWithUIPopTrigger = false;
        this.uiPopTriggerAcculumator = 0;
        this.deathFallTimer = 0;
        this.shouldRespawn = false;
        this.currentState = "idle";
        this.previousState = "none";
        this.idleToJumpTimer = 1;
        this.idleTimer = 0;
        this.mobileJoystickMovementMultplier = new (0, $9014d97cd777be10$export$64b5c384219d3699)(1, 0, 1);
        this.movementVector = new (0, $9014d97cd777be10$export$64b5c384219d3699)();
        //public setXZMovementVector(x: number, z: number) { this.movementVector.add(new Vector3(x, this.movementVector.y, z)); }
        this.forwardBackwardVector = new (0, $9014d97cd777be10$export$64b5c384219d3699)();
        this.leftRightVector = new (0, $9014d97cd777be10$export$64b5c384219d3699)();
        this.speedBlockFactor = 1;
        this.isOnSpeedBlock = false;
        this.lastRespawnedAtAccumulator = 0;
        // console.log("@@@ Run has started in shared player?", runHasStarted);
        if (runHasStarted) {
            this.runHasStarted = true;
            this.runDurationAcc = runInProgressDurationSeconds;
            this.runHasEnded = false;
            this._startingLineTriggerSideEffect();
        }
        this.Position.set(initialX, initialY, initialZ);
        this.RespawnPosition.set(initialX, initialY, initialZ);
        this.collisionSystemRef = collisionSystemRef;
        this.finiteStateMachine.Init();
    }
}
class $8665ec0109254415$export$99a971d0f8e079b3 {
    AddState(name, type) {
        this.states[name] = type;
    }
    SetState(name) {
        const prevState = this.currentState;
        prevState.Exit();
        const stateConstructor = this.states[name];
        if (stateConstructor) {
            const state = new stateConstructor(this);
            this.currentState = state;
            state.Enter(prevState);
        }
    }
    Update(deltaTimeInSeconds, animationState) {
        this.currentState.Update(deltaTimeInSeconds);
        // console.log("processing inputs");
        if (this.currentState.Name === animationState) return;
        /*if (animationState === "jumping_up" && this.currentState.Name === "idle") {
            if (this.sharedPlayer.idleToJumpTimer < 0.455) {
                this.sharedPlayer.idleToJumpTimer += deltaTimeInSeconds;
                return;
            }
        }*/ this.sharedPlayer.idleToJumpTimer = 0;
        this.SetState(animationState);
    }
    Init() {
        this.AddState("idle", $8665ec0109254415$var$IdleState);
        this.AddState("walking", $8665ec0109254415$var$walkingState);
        this.AddState("jumping_up", $8665ec0109254415$var$jumpingState);
        this.AddState("death", $8665ec0109254415$var$DeathState);
        this.AddState("falling", $8665ec0109254415$var$fallingState);
        this.SetState("idle");
    }
    constructor(sharedPlayer){
        this.states = {};
        this.sharedPlayer = sharedPlayer;
        this.states = {};
        this.currentState = new $8665ec0109254415$var$IdleState(this);
    }
}
class $8665ec0109254415$var$State {
    //The functions below are all overridden within each State.
    get Name() {
        return "";
    }
    Enter(__prevState) {}
    Update(__deltaTimeInSeconds) {}
    Exit() {}
    constructor(parent){
        this.parent = parent;
        this.stateDuration = 0;
    }
}
class $8665ec0109254415$var$IdleState extends $8665ec0109254415$var$State {
    get Name() {
        return "idle";
    }
    Enter(prevState) {
        this.parent.sharedPlayer.idleTimer = 0;
        // console.log("Entering Idle State");
        this.parent.sharedPlayer.currentState = this.Name;
        // console.log("currentState: " + this.parent.sharedPlayer.currentState);
        if (prevState) this.parent.sharedPlayer.previousState = prevState.Name;
        else this.parent.sharedPlayer.previousState = "none";
    }
    constructor(parent){
        super(parent);
    }
}
class $8665ec0109254415$var$walkingState extends $8665ec0109254415$var$State {
    get Name() {
        return "walking";
    }
    Enter(prevState) {
        // console.log("Entering walking State");
        this.parent.sharedPlayer.currentState = this.Name;
        this.parent.sharedPlayer.idleToJumpTimer = 1;
        if (prevState) this.parent.sharedPlayer.previousState = prevState.Name;
        else this.parent.sharedPlayer.previousState = "none";
    }
    constructor(parent){
        super(parent);
    }
}
class $8665ec0109254415$var$jumpingState extends $8665ec0109254415$var$State {
    get Name() {
        //We do not have a "Jumping" animation. Instead, jumping plays our "idle" animation and falling plays our "jumping" animation
        //TODO: If animation names are changed, adjust this to match the desired animation
        return "jumping_up";
    }
    Enter(prevState) {
        // console.log("Entering jumping State");
        this.parent.sharedPlayer.currentState = this.Name;
        if (prevState) this.parent.sharedPlayer.previousState = prevState.Name;
        else this.parent.sharedPlayer.previousState = "none";
    }
    constructor(parent){
        super(parent);
    }
}
class $8665ec0109254415$var$fallingState extends $8665ec0109254415$var$State {
    get Name() {
        return "falling";
    }
    Enter(prevState) {
        // console.log("Entering jumping State");
        this.parent.sharedPlayer.currentState = this.Name;
        if (prevState) this.parent.sharedPlayer.previousState = prevState.Name;
        else this.parent.sharedPlayer.previousState = "none";
    }
    constructor(parent){
        super(parent);
    }
}
class $8665ec0109254415$var$DeathState extends $8665ec0109254415$var$State {
    get Name() {
        return "death";
    }
    Enter(prevState) {
        this.parent.sharedPlayer.currentState = this.Name;
        if (prevState) this.parent.sharedPlayer.previousState = prevState.Name;
        else this.parent.sharedPlayer.previousState = "none";
    }
    Update(__deltaTimeInSeconds) {}
    Exit() {}
    constructor(parent){
        super(parent);
    }
}





/**
 * Regular expression for matching the `void main() {` opener line in GLSL.
 * @type {RegExp}
 */ const $34196ca962faf131$export$f402b5c74ecf5e1e = /\bvoid\s+main\s*\(\s*\)\s*{/g;
/**
 * Recursively expands all `#include <xyz>` statements within string of shader code.
 * Copied from three's WebGLProgram#parseIncludes for external use.
 *
 * @param {string} source - The GLSL source code to evaluate
 * @return {string} The GLSL code with all includes expanded
 */ function $34196ca962faf131$export$bec7143e67d6a2ef(source) {
    const pattern = /^[ \t]*#include +<([\w\d./]+)>/gm;
    function replace(match, include) {
        let chunk = (0, $9014d97cd777be10$export$955f9f2e84c43c8b)[include];
        return chunk ? $34196ca962faf131$export$bec7143e67d6a2ef(chunk) : match;
    }
    return source.replace(pattern, replace);
}
/*
 * This is a direct copy of MathUtils.generateUUID from Three.js, to preserve compatibility with three
 * versions before 0.113.0 as it was changed from Math to MathUtils in that version.
 * https://github.com/mrdoob/three.js/blob/dd8b5aa3b270c17096b90945cd2d6d1b13aaec53/src/math/MathUtils.js#L16
 */ const $34196ca962faf131$var$_lut = [];
for(let i = 0; i < 256; i++)$34196ca962faf131$var$_lut[i] = (i < 16 ? "0" : "") + i.toString(16);
function $34196ca962faf131$var$generateUUID() {
    // http://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid-in-javascript/21963136#21963136
    const d0 = Math.random() * 0xffffffff | 0;
    const d1 = Math.random() * 0xffffffff | 0;
    const d2 = Math.random() * 0xffffffff | 0;
    const d3 = Math.random() * 0xffffffff | 0;
    const uuid = $34196ca962faf131$var$_lut[d0 & 0xff] + $34196ca962faf131$var$_lut[d0 >> 8 & 0xff] + $34196ca962faf131$var$_lut[d0 >> 16 & 0xff] + $34196ca962faf131$var$_lut[d0 >> 24 & 0xff] + "-" + $34196ca962faf131$var$_lut[d1 & 0xff] + $34196ca962faf131$var$_lut[d1 >> 8 & 0xff] + "-" + $34196ca962faf131$var$_lut[d1 >> 16 & 0x0f | 0x40] + $34196ca962faf131$var$_lut[d1 >> 24 & 0xff] + "-" + $34196ca962faf131$var$_lut[d2 & 0x3f | 0x80] + $34196ca962faf131$var$_lut[d2 >> 8 & 0xff] + "-" + $34196ca962faf131$var$_lut[d2 >> 16 & 0xff] + $34196ca962faf131$var$_lut[d2 >> 24 & 0xff] + $34196ca962faf131$var$_lut[d3 & 0xff] + $34196ca962faf131$var$_lut[d3 >> 8 & 0xff] + $34196ca962faf131$var$_lut[d3 >> 16 & 0xff] + $34196ca962faf131$var$_lut[d3 >> 24 & 0xff];
    // .toUpperCase() here flattens concatenated strings to save heap memory space.
    return uuid.toUpperCase();
}
// Local assign polyfill to avoid importing troika-core
const $34196ca962faf131$var$assign = Object.assign || function() {
    let target = arguments[0];
    for(let i = 1, len = arguments.length; i < len; i++){
        let source = arguments[i];
        if (source) {
            for(let prop in source)if (Object.prototype.hasOwnProperty.call(source, prop)) target[prop] = source[prop];
        }
    }
    return target;
};
const $34196ca962faf131$var$epoch = Date.now();
const $34196ca962faf131$var$CONSTRUCTOR_CACHE = new WeakMap();
const $34196ca962faf131$var$SHADER_UPGRADE_CACHE = new Map();
// Material ids must be integers, but we can't access the increment from Three's `Material` module,
// so let's choose a sufficiently large starting value that should theoretically never collide.
let $34196ca962faf131$var$materialInstanceId = 1e10;
/**
 * A utility for creating a custom shader material derived from another material's
 * shaders. This allows you to inject custom shader logic and transforms into the
 * builtin ThreeJS materials without having to recreate them from scratch.
 *
 * @param {THREE.Material} baseMaterial - the original material to derive from
 *
 * @param {Object} options - How the base material should be modified.
 * @param {Object} options.defines - Custom `defines` for the material
 * @param {Object} options.extensions - Custom `extensions` for the material, e.g. `{derivatives: true}`
 * @param {Object} options.uniforms - Custom `uniforms` for use in the modified shader. These can
 *        be accessed and manipulated via the resulting material's `uniforms` property, just like
 *        in a ShaderMaterial. You do not need to repeat the base material's own uniforms here.
 * @param {String} options.timeUniform - If specified, a uniform of this name will be injected into
 *        both shaders, and it will automatically be updated on each render frame with a number of
 *        elapsed milliseconds. The "zero" epoch time is not significant so don't rely on this as a
 *        true calendar time.
 * @param {String} options.vertexDefs - Custom GLSL code to inject into the vertex shader's top-level
 *        definitions, above the `void main()` function.
 * @param {String} options.vertexMainIntro - Custom GLSL code to inject at the top of the vertex
 *        shader's `void main` function.
 * @param {String} options.vertexMainOutro - Custom GLSL code to inject at the end of the vertex
 *        shader's `void main` function.
 * @param {String} options.vertexTransform - Custom GLSL code to manipulate the `position`, `normal`,
 *        and/or `uv` vertex attributes. This code will be wrapped within a standalone function with
 *        those attributes exposed by their normal names as read/write values.
 * @param {String} options.fragmentDefs - Custom GLSL code to inject into the fragment shader's top-level
 *        definitions, above the `void main()` function.
 * @param {String} options.fragmentMainIntro - Custom GLSL code to inject at the top of the fragment
 *        shader's `void main` function.
 * @param {String} options.fragmentMainOutro - Custom GLSL code to inject at the end of the fragment
 *        shader's `void main` function. You can manipulate `gl_FragColor` here but keep in mind it goes
 *        after any of ThreeJS's color postprocessing shader chunks (tonemapping, fog, etc.), so if you
 *        want those to apply to your changes use `fragmentColorTransform` instead.
 * @param {String} options.fragmentColorTransform - Custom GLSL code to manipulate the `gl_FragColor`
 *        output value. Will be injected near the end of the `void main` function, but before any
 *        of ThreeJS's color postprocessing shader chunks (tonemapping, fog, etc.), and before the
 *        `fragmentMainOutro`.
 * @param {function<{vertexShader,fragmentShader}>:{vertexShader,fragmentShader}} options.customRewriter - A function
 *        for performing custom rewrites of the full shader code. Useful if you need to do something
 *        special that's not covered by the other builtin options. This function will be executed before
 *        any other transforms are applied.
 * @param {boolean} options.chained - Set to `true` to prototype-chain the derived material to the base
 *        material, rather than the default behavior of copying it. This allows the derived material to
 *        automatically pick up changes made to the base material and its properties. This can be useful
 *        where the derived material is hidden from the user as an implementation detail, allowing them
 *        to work with the original material like normal. But it can result in unexpected behavior if not
 *        handled carefully.
 *
 * @return {THREE.Material}
 *
 * The returned material will also have two new methods, `getDepthMaterial()` and `getDistanceMaterial()`,
 * which can be called to get a variant of the derived material for use in shadow casting. If the
 * target mesh is expected to cast shadows, then you can assign these to the mesh's `customDepthMaterial`
 * (for directional and spot lights) and/or `customDistanceMaterial` (for point lights) properties to
 * allow the cast shadow to honor your derived shader's vertex transforms and discarded fragments. These
 * will also set a custom `#define IS_DEPTH_MATERIAL` or `#define IS_DISTANCE_MATERIAL` that you can look
 * for in your derived shaders with `#ifdef` to customize their behavior for the depth or distance
 * scenarios, e.g. skipping antialiasing or expensive shader logic.
 */ function $34196ca962faf131$export$9251ec91c7de57b5(baseMaterial, options) {
    // Generate a key that is unique to the content of these `options`. We'll use this
    // throughout for caching and for generating the upgraded shader code. This increases
    // the likelihood that the resulting shaders will line up across multiple calls so
    // their GL programs can be shared and cached.
    const optionsKey = $34196ca962faf131$var$getKeyForOptions(options);
    // First check to see if we've already derived from this baseMaterial using this
    // unique set of options, and if so reuse the constructor to avoid some allocations.
    let ctorsByDerivation = $34196ca962faf131$var$CONSTRUCTOR_CACHE.get(baseMaterial);
    if (!ctorsByDerivation) $34196ca962faf131$var$CONSTRUCTOR_CACHE.set(baseMaterial, ctorsByDerivation = Object.create(null));
    if (ctorsByDerivation[optionsKey]) return new ctorsByDerivation[optionsKey]();
    const privateBeforeCompileProp = `_onBeforeCompile${optionsKey}`;
    // Private onBeforeCompile handler that injects the modified shaders and uniforms when
    // the renderer switches to this material's program
    const onBeforeCompile = function(shaderInfo, renderer) {
        baseMaterial.onBeforeCompile.call(this, shaderInfo, renderer);
        // Upgrade the shaders, caching the result by incoming source code
        const cacheKey = this.customProgramCacheKey() + "|" + shaderInfo.vertexShader + "|" + shaderInfo.fragmentShader;
        let upgradedShaders = $34196ca962faf131$var$SHADER_UPGRADE_CACHE[cacheKey];
        if (!upgradedShaders) {
            const upgraded = $34196ca962faf131$var$upgradeShaders(this, shaderInfo, options, optionsKey);
            upgradedShaders = $34196ca962faf131$var$SHADER_UPGRADE_CACHE[cacheKey] = upgraded;
        }
        // Inject upgraded shaders and uniforms into the program
        shaderInfo.vertexShader = upgradedShaders.vertexShader;
        shaderInfo.fragmentShader = upgradedShaders.fragmentShader;
        $34196ca962faf131$var$assign(shaderInfo.uniforms, this.uniforms);
        // Inject auto-updating time uniform if requested
        if (options.timeUniform) shaderInfo.uniforms[options.timeUniform] = {
            get value () {
                return Date.now() - $34196ca962faf131$var$epoch;
            }
        };
        // Users can still add their own handlers on top of ours
        if (this[privateBeforeCompileProp]) this[privateBeforeCompileProp](shaderInfo);
    };
    const DerivedMaterial = function DerivedMaterial() {
        return derive(options.chained ? baseMaterial : baseMaterial.clone());
    };
    const derive = function(base) {
        // Prototype chain to the base material
        const derived = Object.create(base, descriptor);
        // Store the baseMaterial for reference; this is always the original even when cloning
        Object.defineProperty(derived, "baseMaterial", {
            value: baseMaterial
        });
        // Needs its own ids
        Object.defineProperty(derived, "id", {
            value: $34196ca962faf131$var$materialInstanceId++
        });
        derived.uuid = $34196ca962faf131$var$generateUUID();
        // Merge uniforms, defines, and extensions
        derived.uniforms = $34196ca962faf131$var$assign({}, base.uniforms, options.uniforms);
        derived.defines = $34196ca962faf131$var$assign({}, base.defines, options.defines);
        derived.defines[`TROIKA_DERIVED_MATERIAL_${optionsKey}`] = ""; //force a program change from the base material
        derived.extensions = $34196ca962faf131$var$assign({}, base.extensions, options.extensions);
        // Don't inherit EventDispatcher listeners
        derived._listeners = undefined;
        return derived;
    };
    const descriptor = {
        constructor: {
            value: DerivedMaterial
        },
        isDerivedMaterial: {
            value: true
        },
        customProgramCacheKey: {
            writable: true,
            configurable: true,
            value: function() {
                return baseMaterial.customProgramCacheKey() + "|" + optionsKey;
            }
        },
        onBeforeCompile: {
            get () {
                return onBeforeCompile;
            },
            set (fn) {
                this[privateBeforeCompileProp] = fn;
            }
        },
        copy: {
            writable: true,
            configurable: true,
            value: function(source) {
                baseMaterial.copy.call(this, source);
                if (!baseMaterial.isShaderMaterial && !baseMaterial.isDerivedMaterial) {
                    $34196ca962faf131$var$assign(this.extensions, source.extensions);
                    $34196ca962faf131$var$assign(this.defines, source.defines);
                    $34196ca962faf131$var$assign(this.uniforms, (0, $9014d97cd777be10$export$d8ecdf8615bfea69).clone(source.uniforms));
                }
                return this;
            }
        },
        clone: {
            writable: true,
            configurable: true,
            value: function() {
                const newBase = new baseMaterial.constructor();
                return derive(newBase).copy(this);
            }
        },
        /**
     * Utility to get a MeshDepthMaterial that will honor this derived material's vertex
     * transformations and discarded fragments.
     */ getDepthMaterial: {
            writable: true,
            configurable: true,
            value: function() {
                let depthMaterial = this._depthMaterial;
                if (!depthMaterial) {
                    depthMaterial = this._depthMaterial = $34196ca962faf131$export$9251ec91c7de57b5(baseMaterial.isDerivedMaterial ? baseMaterial.getDepthMaterial() : new (0, $9014d97cd777be10$export$2698c22ec13825db)({
                        depthPacking: (0, $9014d97cd777be10$export$8f910f4c4f73df11)
                    }), options);
                    depthMaterial.defines.IS_DEPTH_MATERIAL = "";
                    depthMaterial.uniforms = this.uniforms; //automatically recieve same uniform values
                }
                return depthMaterial;
            }
        },
        /**
     * Utility to get a MeshDistanceMaterial that will honor this derived material's vertex
     * transformations and discarded fragments.
     */ getDistanceMaterial: {
            writable: true,
            configurable: true,
            value: function() {
                let distanceMaterial = this._distanceMaterial;
                if (!distanceMaterial) {
                    distanceMaterial = this._distanceMaterial = $34196ca962faf131$export$9251ec91c7de57b5(baseMaterial.isDerivedMaterial ? baseMaterial.getDistanceMaterial() : new (0, $9014d97cd777be10$export$33e187ed002f2a19)(), options);
                    distanceMaterial.defines.IS_DISTANCE_MATERIAL = "";
                    distanceMaterial.uniforms = this.uniforms; //automatically recieve same uniform values
                }
                return distanceMaterial;
            }
        },
        dispose: {
            writable: true,
            configurable: true,
            value () {
                const { _depthMaterial: _depthMaterial, _distanceMaterial: _distanceMaterial } = this;
                if (_depthMaterial) _depthMaterial.dispose();
                if (_distanceMaterial) _distanceMaterial.dispose();
                baseMaterial.dispose.call(this);
            }
        }
    };
    ctorsByDerivation[optionsKey] = DerivedMaterial;
    return new DerivedMaterial();
}
function $34196ca962faf131$var$upgradeShaders(material, { vertexShader: vertexShader, fragmentShader: fragmentShader }, options, key) {
    let { vertexDefs: vertexDefs, vertexMainIntro: vertexMainIntro, vertexMainOutro: vertexMainOutro, vertexTransform: vertexTransform, fragmentDefs: fragmentDefs, fragmentMainIntro: fragmentMainIntro, fragmentMainOutro: fragmentMainOutro, fragmentColorTransform: fragmentColorTransform, customRewriter: customRewriter, timeUniform: timeUniform } = options;
    vertexDefs = vertexDefs || "";
    vertexMainIntro = vertexMainIntro || "";
    vertexMainOutro = vertexMainOutro || "";
    fragmentDefs = fragmentDefs || "";
    fragmentMainIntro = fragmentMainIntro || "";
    fragmentMainOutro = fragmentMainOutro || "";
    // Expand includes if needed
    if (vertexTransform || customRewriter) vertexShader = $34196ca962faf131$export$bec7143e67d6a2ef(vertexShader);
    if (fragmentColorTransform || customRewriter) {
        // We need to be able to find postprocessing chunks after include expansion in order to
        // put them after the fragmentColorTransform, so mark them with comments first. Even if
        // this particular derivation doesn't have a fragmentColorTransform, other derivations may,
        // so we still mark them.
        fragmentShader = fragmentShader.replace(/^[ \t]*#include <((?:tonemapping|encodings|fog|premultiplied_alpha|dithering)_fragment)>/gm, "\n//!BEGIN_POST_CHUNK $1\n$&\n//!END_POST_CHUNK\n");
        fragmentShader = $34196ca962faf131$export$bec7143e67d6a2ef(fragmentShader);
    }
    // Apply custom rewriter function
    if (customRewriter) {
        let res = customRewriter({
            vertexShader: vertexShader,
            fragmentShader: fragmentShader
        });
        vertexShader = res.vertexShader;
        fragmentShader = res.fragmentShader;
    }
    // The fragmentColorTransform needs to go before any postprocessing chunks, so extract
    // those and re-insert them into the outro in the correct place:
    if (fragmentColorTransform) {
        let postChunks = [];
        fragmentShader = fragmentShader.replace(/^\/\/!BEGIN_POST_CHUNK[^]+?^\/\/!END_POST_CHUNK/gm, (match)=>{
            postChunks.push(match);
            return "";
        });
        fragmentMainOutro = `${fragmentColorTransform}\n${postChunks.join("\n")}\n${fragmentMainOutro}`;
    }
    // Inject auto-updating time uniform if requested
    if (timeUniform) {
        const code = `\nuniform float ${timeUniform};\n`;
        vertexDefs = code + vertexDefs;
        fragmentDefs = code + fragmentDefs;
    }
    // Inject a function for the vertexTransform and rename all usages of position/normal/uv
    if (vertexTransform) {
        // Hoist these defs to the very top so they work in other function defs
        vertexShader = `vec3 troika_position_${key};
vec3 troika_normal_${key};
vec2 troika_uv_${key};
${vertexShader}
`;
        vertexDefs = `${vertexDefs}
void troikaVertexTransform${key}(inout vec3 position, inout vec3 normal, inout vec2 uv) {
  ${vertexTransform}
}
`;
        vertexMainIntro = `
troika_position_${key} = vec3(position);
troika_normal_${key} = vec3(normal);
troika_uv_${key} = vec2(uv);
troikaVertexTransform${key}(troika_position_${key}, troika_normal_${key}, troika_uv_${key});
${vertexMainIntro}
`;
        vertexShader = vertexShader.replace(/\b(position|normal|uv)\b/g, (match, match1, index, fullStr)=>{
            return /\battribute\s+vec[23]\s+$/.test(fullStr.substr(0, index)) ? match1 : `troika_${match1}_${key}`;
        });
        // Three r152 introduced the MAP_UV token, replace it too if it's pointing to the main 'uv'
        // Perhaps the other textures too going forward?
        if (!(material.map && material.map.channel > 0)) vertexShader = vertexShader.replace(/\bMAP_UV\b/g, `troika_uv_${key}`);
    }
    // Inject defs and intro/outro snippets
    vertexShader = $34196ca962faf131$var$injectIntoShaderCode(vertexShader, key, vertexDefs, vertexMainIntro, vertexMainOutro);
    fragmentShader = $34196ca962faf131$var$injectIntoShaderCode(fragmentShader, key, fragmentDefs, fragmentMainIntro, fragmentMainOutro);
    return {
        vertexShader: vertexShader,
        fragmentShader: fragmentShader
    };
}
function $34196ca962faf131$var$injectIntoShaderCode(shaderCode, id, defs, intro, outro) {
    if (intro || outro || defs) {
        shaderCode = shaderCode.replace($34196ca962faf131$export$f402b5c74ecf5e1e, `
${defs}
void troikaOrigMain${id}() {`);
        shaderCode += `
void main() {
  ${intro}
  troikaOrigMain${id}();
  ${outro}
}`;
    }
    return shaderCode;
}
function $34196ca962faf131$var$optionsJsonReplacer(key, value) {
    return key === "uniforms" ? undefined : typeof value === "function" ? value.toString() : value;
}
let $34196ca962faf131$var$_idCtr = 0;
const $34196ca962faf131$var$optionsHashesToIds = new Map();
function $34196ca962faf131$var$getKeyForOptions(options) {
    const optionsHash = JSON.stringify(options, $34196ca962faf131$var$optionsJsonReplacer);
    let id = $34196ca962faf131$var$optionsHashesToIds.get(optionsHash);
    if (id == null) $34196ca962faf131$var$optionsHashesToIds.set(optionsHash, id = ++$34196ca962faf131$var$_idCtr);
    return id;
}
// Copied from threejs WebGLPrograms.js so we can resolve builtin materials to their shaders
// TODO how can we keep this from getting stale?
const $34196ca962faf131$var$MATERIAL_TYPES_TO_SHADERS = {
    MeshDepthMaterial: "depth",
    MeshDistanceMaterial: "distanceRGBA",
    MeshNormalMaterial: "normal",
    MeshBasicMaterial: "basic",
    MeshLambertMaterial: "lambert",
    MeshPhongMaterial: "phong",
    MeshToonMaterial: "toon",
    MeshStandardMaterial: "physical",
    MeshPhysicalMaterial: "physical",
    MeshMatcapMaterial: "matcap",
    LineBasicMaterial: "basic",
    LineDashedMaterial: "dashed",
    PointsMaterial: "points",
    ShadowMaterial: "shadow",
    SpriteMaterial: "sprite"
};
/**
 * Given a Three.js `Material` instance, find the shaders/uniforms that will be
 * used to render that material.
 *
 * @param material - the Material instance
 * @return {object} - the material's shader info: `{uniforms:{}, fragmentShader:'', vertexShader:''}`
 */ function $34196ca962faf131$export$45b4115c5d90bd21(material) {
    let builtinType = $34196ca962faf131$var$MATERIAL_TYPES_TO_SHADERS[material.type];
    return builtinType ? (0, $9014d97cd777be10$export$bee4a7d47f8f5014)[builtinType] : material //TODO fallback for unknown type?
    ;
}
/**
 * Find all uniforms and their types within a shader code string.
 *
 * @param {string} shader - The shader code to parse
 * @return {object} mapping of uniform names to their glsl type
 */ function $34196ca962faf131$export$c7d2dd72fdbc2421(shader) {
    let uniformRE = /\buniform\s+(int|float|vec[234]|mat[34])\s+([A-Za-z_][\w]*)/g;
    let uniforms = Object.create(null);
    let match;
    while((match = uniformRE.exec(shader)) !== null)uniforms[match[2]] = match[1];
    return uniforms;
}
/**
 * Helper for smoothing out the `m.getInverse(x)` --> `m.copy(x).invert()` conversion
 * that happened in ThreeJS r123.
 * @param {Matrix4} srcMatrix
 * @param {Matrix4} [tgtMatrix]
 */ function $34196ca962faf131$export$3425937be2407bfa(srcMatrix, tgtMatrix = new (0, $9014d97cd777be10$export$2ae72fc923e5eb5)()) {
    if (typeof tgtMatrix.invert === "function") tgtMatrix.copy(srcMatrix).invert();
    else tgtMatrix.getInverse(srcMatrix);
    return tgtMatrix;
}
/*
Input geometry is a cylinder with r=1, height in y dimension from 0 to 1,
divided into a reasonable number of height segments.
*/ const $34196ca962faf131$var$vertexDefs = `
uniform vec3 pointA;
uniform vec3 controlA;
uniform vec3 controlB;
uniform vec3 pointB;
uniform float radius;
varying float bezierT;

vec3 cubicBezier(vec3 p1, vec3 c1, vec3 c2, vec3 p2, float t) {
  float t2 = 1.0 - t;
  float b0 = t2 * t2 * t2;
  float b1 = 3.0 * t * t2 * t2;
  float b2 = 3.0 * t * t * t2;
  float b3 = t * t * t;
  return b0 * p1 + b1 * c1 + b2 * c2 + b3 * p2;
}

vec3 cubicBezierDerivative(vec3 p1, vec3 c1, vec3 c2, vec3 p2, float t) {
  float t2 = 1.0 - t;
  return -3.0 * p1 * t2 * t2 +
    c1 * (3.0 * t2 * t2 - 6.0 * t2 * t) +
    c2 * (6.0 * t2 * t - 3.0 * t * t) +
    3.0 * p2 * t * t;
}
`;
const $34196ca962faf131$var$vertexTransform = `
float t = position.y;
bezierT = t;
vec3 bezierCenterPos = cubicBezier(pointA, controlA, controlB, pointB, t);
vec3 bezierDir = normalize(cubicBezierDerivative(pointA, controlA, controlB, pointB, t));

// Make "sideways" always perpendicular to the camera ray; this ensures that any twists
// in the cylinder occur where you won't see them: 
vec3 viewDirection = normalMatrix * vec3(0.0, 0.0, 1.0);
if (bezierDir == viewDirection) {
  bezierDir = normalize(cubicBezierDerivative(pointA, controlA, controlB, pointB, t == 1.0 ? t - 0.0001 : t + 0.0001));
}
vec3 sideways = normalize(cross(bezierDir, viewDirection));
vec3 upish = normalize(cross(sideways, bezierDir));

// Build a matrix for transforming this disc in the cylinder:
mat4 discTx;
discTx[0].xyz = sideways * radius;
discTx[1].xyz = bezierDir * radius;
discTx[2].xyz = upish * radius;
discTx[3].xyz = bezierCenterPos;
discTx[3][3] = 1.0;

// Apply transform, ignoring original y
position = (discTx * vec4(position.x, 0.0, position.z, 1.0)).xyz;
normal = normalize(mat3(discTx) * normal);
`;
const $34196ca962faf131$var$fragmentDefs = `
uniform vec3 dashing;
varying float bezierT;
`;
const $34196ca962faf131$var$fragmentMainIntro = `
if (dashing.x + dashing.y > 0.0) {
  float dashFrac = mod(bezierT - dashing.z, dashing.x + dashing.y);
  if (dashFrac > dashing.x) {
    discard;
  }
}
`;
// Debugging: separate color for each of the 6 sides:
// const fragmentColorTransform = `
// float sideNum = floor(vUV.x * 6.0);
// vec3 mixColor = sideNum < 1.0 ? vec3(1.0, 0.0, 0.0) :
//   sideNum < 2.0 ? vec3(0.0, 1.0, 1.0) :
//   sideNum < 3.0 ? vec3(1.0, 1.0, 0.0) :
//   sideNum < 4.0 ? vec3(0.0, 0.0, 1.0) :
//   sideNum < 5.0 ? vec3(0.0, 1.0, 0.0) :
//   vec3(1.0, 0.0, 1.0);
// gl_FragColor.xyz = mix(gl_FragColor.xyz, mixColor, 0.5);
// `
function $34196ca962faf131$var$createBezierMeshMaterial(baseMaterial) {
    return $34196ca962faf131$export$9251ec91c7de57b5(baseMaterial, {
        chained: true,
        uniforms: {
            pointA: {
                value: new (0, $9014d97cd777be10$export$64b5c384219d3699)()
            },
            controlA: {
                value: new (0, $9014d97cd777be10$export$64b5c384219d3699)()
            },
            controlB: {
                value: new (0, $9014d97cd777be10$export$64b5c384219d3699)()
            },
            pointB: {
                value: new (0, $9014d97cd777be10$export$64b5c384219d3699)()
            },
            radius: {
                value: 0.01
            },
            dashing: {
                value: new (0, $9014d97cd777be10$export$64b5c384219d3699)()
            } //on, off, offset
        },
        vertexDefs: $34196ca962faf131$var$vertexDefs,
        vertexTransform: $34196ca962faf131$var$vertexTransform,
        fragmentDefs: $34196ca962faf131$var$fragmentDefs,
        fragmentMainIntro: $34196ca962faf131$var$fragmentMainIntro
    });
}
let $34196ca962faf131$var$geometry = null;
const $34196ca962faf131$var$defaultBaseMaterial = /*#__PURE__*/ new (0, $9014d97cd777be10$export$f2980790215acccd)({
    color: 0xffffff,
    side: (0, $9014d97cd777be10$export$3b296b6f144d5b03)
});
/**
 * A ThreeJS `Mesh` that bends a tube shape along a 3D cubic bezier path. The bending is done
 * by deforming a straight cylindrical geometry in the vertex shader based on a set of four
 * control point uniforms. It patches the necessary GLSL into the mesh's assigned `material`
 * automatically.
 *
 * The cubiz bezier path is determined by its four `Vector3` properties:
 * - `pointA`
 * - `controlA`
 * - `controlB`
 * - `pointB`
 *
 * The tube's radius is controlled by its `radius` property, which defaults to `0.01`.
 *
 * You can also give the tube a dashed appearance with two properties:
 *
 * - `dashArray` - an array of two numbers, defining the length of "on" and "off" parts of
 *   the dash. Each is a 0-1 ratio of the entire path's length. (Actually this is the `t` length
 *   used as input to the cubic bezier function, not its visible length.)
 * - `dashOffset` - offset of where the dash starts. You can animate this to make the dashes move.
 *
 * Note that the dashes will appear like a hollow tube, not solid. This will be more apparent on
 * thicker tubes.
 *
 * TODO: proper geometry bounding sphere and raycasting
 * TODO: allow control of the geometry's segment counts
 */ class $34196ca962faf131$export$5f27619f2db8836e extends (0, $9014d97cd777be10$export$e176487c05830cc5) {
    static getGeometry() {
        return $34196ca962faf131$var$geometry || ($34196ca962faf131$var$geometry = new (0, $9014d97cd777be10$export$68f745719dbe5198)(1, 1, 1, 6, 64).translate(0, 0.5, 0));
    }
    // Handler for automatically wrapping the base material with our upgrades. We do the wrapping
    // lazily on _read_ rather than write to avoid unnecessary wrapping on transient values.
    get material() {
        let derivedMaterial = this._derivedMaterial;
        const baseMaterial = this._baseMaterial || this._defaultMaterial || (this._defaultMaterial = $34196ca962faf131$var$defaultBaseMaterial.clone());
        if (!derivedMaterial || derivedMaterial.baseMaterial !== baseMaterial) {
            derivedMaterial = this._derivedMaterial = $34196ca962faf131$var$createBezierMeshMaterial(baseMaterial);
            // dispose the derived material when its base material is disposed:
            baseMaterial.addEventListener("dispose", function onDispose() {
                baseMaterial.removeEventListener("dispose", onDispose);
                derivedMaterial.dispose();
            });
        }
        return derivedMaterial;
    }
    set material(baseMaterial) {
        this._baseMaterial = baseMaterial;
    }
    // Create and update material for shadows upon request:
    get customDepthMaterial() {
        return this.material.getDepthMaterial();
    }
    get customDistanceMaterial() {
        return this.material.getDistanceMaterial();
    }
    onBeforeRender() {
        const { uniforms: uniforms } = this.material;
        const { pointA: pointA, controlA: controlA, controlB: controlB, pointB: pointB, radius: radius, dashArray: dashArray, dashOffset: dashOffset } = this;
        uniforms.pointA.value.copy(pointA);
        uniforms.controlA.value.copy(controlA);
        uniforms.controlB.value.copy(controlB);
        uniforms.pointB.value.copy(pointB);
        uniforms.radius.value = radius;
        uniforms.dashing.value.set(dashArray.x, dashArray.y, dashOffset || 0);
    }
    raycast() {
    // TODO - just fail for now
    }
    constructor(){
        super($34196ca962faf131$export$5f27619f2db8836e.getGeometry(), $34196ca962faf131$var$defaultBaseMaterial);
        this.pointA = new (0, $9014d97cd777be10$export$64b5c384219d3699)();
        this.controlA = new (0, $9014d97cd777be10$export$64b5c384219d3699)();
        this.controlB = new (0, $9014d97cd777be10$export$64b5c384219d3699)();
        this.pointB = new (0, $9014d97cd777be10$export$64b5c384219d3699)();
        this.radius = 0.01;
        this.dashArray = new (0, $9014d97cd777be10$export$c977b3e384af9ae1)();
        this.dashOffset = 0;
        // TODO - disabling frustum culling until I figure out how to customize the
        //  geometry's bounding sphere that gets used
        this.frustumCulled = false;
    }
}


var $365485fe02257f54$export$a0592272c669d6d8;
(function(Emotes) {
    Emotes[Emotes["Apple"] = 0] = "Apple";
    Emotes[Emotes["AppleGold"] = 1] = "AppleGold";
    Emotes[Emotes["Baguette"] = 2] = "Baguette";
    Emotes[Emotes["BaguetteGold"] = 3] = "BaguetteGold";
    Emotes[Emotes["Blueberry"] = 4] = "Blueberry";
    Emotes[Emotes["BlueberryGold"] = 5] = "BlueberryGold";
    Emotes[Emotes["Broccoli"] = 6] = "Broccoli";
    Emotes[Emotes["BroccoliGold"] = 7] = "BroccoliGold";
    Emotes[Emotes["ChefHat"] = 8] = "ChefHat";
    Emotes[Emotes["ChefHatGold"] = 9] = "ChefHatGold";
    Emotes[Emotes["ComeWithMe"] = 10] = "ComeWithMe";
    Emotes[Emotes["ComeWithMeGold"] = 11] = "ComeWithMeGold";
    Emotes[Emotes["Cupcake"] = 12] = "Cupcake";
    Emotes[Emotes["CupcakeGold"] = 13] = "CupcakeGold";
    Emotes[Emotes["Eggplant"] = 14] = "Eggplant";
    Emotes[Emotes["EggplantGold"] = 15] = "EggplantGold";
    Emotes[Emotes["Fly"] = 16] = "Fly";
    Emotes[Emotes["FlyGold"] = 17] = "FlyGold";
    Emotes[Emotes["Icecream"] = 18] = "Icecream";
    Emotes[Emotes["IcecreamGold"] = 19] = "IcecreamGold";
    Emotes[Emotes["InvisiblePlatform"] = 20] = "InvisiblePlatform";
    Emotes[Emotes["InvisiblePlatformGold"] = 21] = "InvisiblePlatformGold";
    Emotes[Emotes["Peach"] = 22] = "Peach";
    Emotes[Emotes["PeachGold"] = 23] = "PeachGold";
    Emotes[Emotes["Spatula"] = 24] = "Spatula";
    Emotes[Emotes["SpatulaGold"] = 25] = "SpatulaGold";
})($365485fe02257f54$export$a0592272c669d6d8 || ($365485fe02257f54$export$a0592272c669d6d8 = {}));
const $365485fe02257f54$export$a9e23c2ea6ae8778 = (emoteString)=>{
    let emote = $365485fe02257f54$export$a0592272c669d6d8.Apple;
    switch(emoteString){
        case "apple":
            emote = $365485fe02257f54$export$a0592272c669d6d8.Apple;
            break;
        case "baguette":
            emote = $365485fe02257f54$export$a0592272c669d6d8.Baguette;
            break;
        case "blueberry":
            emote = $365485fe02257f54$export$a0592272c669d6d8.Blueberry;
            break;
        case "broccoli":
            emote = $365485fe02257f54$export$a0592272c669d6d8.Broccoli;
            break;
        case "hat":
            emote = $365485fe02257f54$export$a0592272c669d6d8.ChefHat;
            break;
        case "come":
            emote = $365485fe02257f54$export$a0592272c669d6d8.ComeWithMe;
            break;
        case "cupcake":
            emote = $365485fe02257f54$export$a0592272c669d6d8.Cupcake;
            break;
        case "eggplant":
            emote = $365485fe02257f54$export$a0592272c669d6d8.Eggplant;
            break;
        case "fly":
            emote = $365485fe02257f54$export$a0592272c669d6d8.Fly;
            break;
        case "icecream":
            emote = $365485fe02257f54$export$a0592272c669d6d8.Icecream;
            break;
        case "invis":
            emote = $365485fe02257f54$export$a0592272c669d6d8.InvisiblePlatform;
            break;
        case "peach":
            emote = $365485fe02257f54$export$a0592272c669d6d8.Peach;
            break;
        case "spatula":
            emote = $365485fe02257f54$export$a0592272c669d6d8.Spatula;
            break;
        default:
            emote = $365485fe02257f54$export$a0592272c669d6d8.Apple;
            break;
    }
    return emote;
};
const $365485fe02257f54$export$65f3c33713eab7d7 = new Map();
$365485fe02257f54$export$65f3c33713eab7d7.set($365485fe02257f54$export$a0592272c669d6d8.Apple, "Apple_Regular.png");
$365485fe02257f54$export$65f3c33713eab7d7.set($365485fe02257f54$export$a0592272c669d6d8.AppleGold, "Apple_Gold.png");
$365485fe02257f54$export$65f3c33713eab7d7.set($365485fe02257f54$export$a0592272c669d6d8.Baguette, "Baguette_Regular.png");
$365485fe02257f54$export$65f3c33713eab7d7.set($365485fe02257f54$export$a0592272c669d6d8.BaguetteGold, "Baguette_Gold.png");
$365485fe02257f54$export$65f3c33713eab7d7.set($365485fe02257f54$export$a0592272c669d6d8.Blueberry, "Blueberry_Regular.png");
$365485fe02257f54$export$65f3c33713eab7d7.set($365485fe02257f54$export$a0592272c669d6d8.BlueberryGold, "Blueberry_Gold.png");
$365485fe02257f54$export$65f3c33713eab7d7.set($365485fe02257f54$export$a0592272c669d6d8.Broccoli, "Broccoli_Regular.png");
$365485fe02257f54$export$65f3c33713eab7d7.set($365485fe02257f54$export$a0592272c669d6d8.BroccoliGold, "Broccoli_Gold.png");
$365485fe02257f54$export$65f3c33713eab7d7.set($365485fe02257f54$export$a0592272c669d6d8.ChefHat, "ChefHat_Regular.png");
$365485fe02257f54$export$65f3c33713eab7d7.set($365485fe02257f54$export$a0592272c669d6d8.ChefHatGold, "ChefHat.png");
$365485fe02257f54$export$65f3c33713eab7d7.set($365485fe02257f54$export$a0592272c669d6d8.ComeWithMe, "ComeWithMe_Regular.png");
$365485fe02257f54$export$65f3c33713eab7d7.set($365485fe02257f54$export$a0592272c669d6d8.ComeWithMeGold, "ComeWithMe_Gold.png");
$365485fe02257f54$export$65f3c33713eab7d7.set($365485fe02257f54$export$a0592272c669d6d8.Cupcake, "Cupcake_Regular.png");
$365485fe02257f54$export$65f3c33713eab7d7.set($365485fe02257f54$export$a0592272c669d6d8.CupcakeGold, "Cupcake_Gold.png");
$365485fe02257f54$export$65f3c33713eab7d7.set($365485fe02257f54$export$a0592272c669d6d8.Eggplant, "Eggplant_Regular.png");
$365485fe02257f54$export$65f3c33713eab7d7.set($365485fe02257f54$export$a0592272c669d6d8.EggplantGold, "Eggplant_Gold.png");
$365485fe02257f54$export$65f3c33713eab7d7.set($365485fe02257f54$export$a0592272c669d6d8.Fly, "Fly_Regular.png");
$365485fe02257f54$export$65f3c33713eab7d7.set($365485fe02257f54$export$a0592272c669d6d8.FlyGold, "Fly_Gold.png");
$365485fe02257f54$export$65f3c33713eab7d7.set($365485fe02257f54$export$a0592272c669d6d8.Icecream, "Icecream_Regular.png");
$365485fe02257f54$export$65f3c33713eab7d7.set($365485fe02257f54$export$a0592272c669d6d8.IcecreamGold, "Icecream_Gold.png");
$365485fe02257f54$export$65f3c33713eab7d7.set($365485fe02257f54$export$a0592272c669d6d8.InvisiblePlatform, "InvisiblePlatform_Regular.png");
$365485fe02257f54$export$65f3c33713eab7d7.set($365485fe02257f54$export$a0592272c669d6d8.InvisiblePlatformGold, "InvisiblePlatform_Gold.png");
$365485fe02257f54$export$65f3c33713eab7d7.set($365485fe02257f54$export$a0592272c669d6d8.Peach, "Peach_Regular.png");
$365485fe02257f54$export$65f3c33713eab7d7.set($365485fe02257f54$export$a0592272c669d6d8.PeachGold, "Peach_Gold.png");
$365485fe02257f54$export$65f3c33713eab7d7.set($365485fe02257f54$export$a0592272c669d6d8.Spatula, "Spatula_Regular.png");
$365485fe02257f54$export$65f3c33713eab7d7.set($365485fe02257f54$export$a0592272c669d6d8.SpatulaGold, "Spatula.png");
var $365485fe02257f54$export$30b7b71cb0ee3dbd;
(function(EmoteAnimations) {
    EmoteAnimations[EmoteAnimations["Shake"] = 0] = "Shake";
    EmoteAnimations[EmoteAnimations["Bounce"] = 1] = "Bounce";
    EmoteAnimations[EmoteAnimations["Wiggle"] = 2] = "Wiggle";
})($365485fe02257f54$export$30b7b71cb0ee3dbd || ($365485fe02257f54$export$30b7b71cb0ee3dbd = {}));
function $365485fe02257f54$export$5c86ea9d76d14a93() {
    const r = Math.floor(Math.random() * 3);
    return r;
}


//@ts-ignore


/**
 * Main content for the worker that handles the loading and execution of
 * modules within it.
 */ 
function $ca0116d492137119$var$workerBootstrap() {
    var modules = Object.create(null);
    // Handle messages for registering a module
    function registerModule(ref, callback) {
        var id = ref.id;
        var name = ref.name;
        var dependencies = ref.dependencies;
        if (dependencies === void 0) dependencies = [];
        var init = ref.init;
        if (init === void 0) init = function() {};
        var getTransferables = ref.getTransferables;
        if (getTransferables === void 0) getTransferables = null;
        // Only register once
        if (modules[id]) return;
        try {
            // If any dependencies are modules, ensure they're registered and grab their value
            dependencies = dependencies.map(function(dep) {
                if (dep && dep.isWorkerModule) {
                    registerModule(dep, function(depResult) {
                        if (depResult instanceof Error) throw depResult;
                    });
                    dep = modules[dep.id].value;
                }
                return dep;
            });
            // Rehydrate functions
            init = rehydrate("<" + name + ">.init", init);
            if (getTransferables) getTransferables = rehydrate("<" + name + ">.getTransferables", getTransferables);
            // Initialize the module and store its value
            var value = null;
            if (typeof init === "function") value = init.apply(void 0, dependencies);
            else console.error("worker module init function failed to rehydrate");
            modules[id] = {
                id: id,
                value: value,
                getTransferables: getTransferables
            };
            callback(value);
        } catch (err) {
            if (!(err && err.noLog)) console.error(err);
            callback(err);
        }
    }
    // Handle messages for calling a registered module's result function
    function callModule(ref, callback) {
        var ref$1;
        var id = ref.id;
        var args = ref.args;
        if (!modules[id] || typeof modules[id].value !== "function") callback(new Error("Worker module " + id + ": not found or its 'init' did not return a function"));
        try {
            var result = (ref$1 = modules[id]).value.apply(ref$1, args);
            if (result && typeof result.then === "function") result.then(handleResult, function(rej) {
                return callback(rej instanceof Error ? rej : new Error("" + rej));
            });
            else handleResult(result);
        } catch (err) {
            callback(err);
        }
        function handleResult(result) {
            try {
                var tx = modules[id].getTransferables && modules[id].getTransferables(result);
                if (!tx || !Array.isArray(tx) || !tx.length) tx = undefined; //postMessage is very picky about not passing null or empty transferables
                callback(result, tx);
            } catch (err) {
                console.error(err);
                callback(err);
            }
        }
    }
    function rehydrate(name, str) {
        var result = void 0;
        self.troikaDefine = function(r) {
            return result = r;
        };
        var url = URL.createObjectURL(new Blob([
            "/** " + name.replace(/\*/g, "") + " **/\n\ntroikaDefine(\n" + str + "\n)"
        ], {
            type: "application/javascript"
        }));
        try {
            importScripts(url);
        } catch (err) {
            console.error(err);
        }
        URL.revokeObjectURL(url);
        delete self.troikaDefine;
        return result;
    }
    // Handler for all messages within the worker
    self.addEventListener("message", function(e) {
        var ref = e.data;
        var messageId = ref.messageId;
        var action = ref.action;
        var data = ref.data;
        try {
            // Module registration
            if (action === "registerModule") registerModule(data, function(result) {
                if (result instanceof Error) postMessage({
                    messageId: messageId,
                    success: false,
                    error: result.message
                });
                else postMessage({
                    messageId: messageId,
                    success: true,
                    result: {
                        isCallable: typeof result === "function"
                    }
                });
            });
            // Invocation
            if (action === "callModule") callModule(data, function(result, transferables) {
                if (result instanceof Error) postMessage({
                    messageId: messageId,
                    success: false,
                    error: result.message
                });
                else postMessage({
                    messageId: messageId,
                    success: true,
                    result: result
                }, transferables || undefined);
            });
        } catch (err) {
            postMessage({
                messageId: messageId,
                success: false,
                error: err.stack
            });
        }
    });
}
/**
 * Fallback for `defineWorkerModule` that behaves identically but runs in the main
 * thread, for when the execution environment doesn't support web workers or they
 * are disallowed due to e.g. CSP security restrictions.
 */ function $ca0116d492137119$var$defineMainThreadModule(options) {
    var moduleFunc = function() {
        var args = [], len = arguments.length;
        while(len--)args[len] = arguments[len];
        return moduleFunc._getInitResult().then(function(initResult) {
            if (typeof initResult === "function") return initResult.apply(void 0, args);
            else throw new Error("Worker module function was called but `init` did not return a callable function");
        });
    };
    moduleFunc._getInitResult = function() {
        // We can ignore getTransferables in main thread. TODO workerId?
        var dependencies = options.dependencies;
        var init = options.init;
        // Resolve dependencies
        dependencies = Array.isArray(dependencies) ? dependencies.map(function(dep) {
            return dep && dep._getInitResult ? dep._getInitResult() : dep;
        }) : [];
        // Invoke init with the resolved dependencies
        var initPromise = Promise.all(dependencies).then(function(deps) {
            return init.apply(null, deps);
        });
        // Cache the resolved promise for subsequent calls
        moduleFunc._getInitResult = function() {
            return initPromise;
        };
        return initPromise;
    };
    return moduleFunc;
}
var $ca0116d492137119$var$supportsWorkers = function() {
    var supported = false;
    // Only attempt worker initialization in browsers; elsewhere it would just be
    // noise e.g. loading into a Node environment for SSR.
    if (typeof window !== "undefined" && typeof window.document !== "undefined") try {
        // TODO additional checks for things like importScripts within the worker?
        //  Would need to be an async check.
        var worker = new Worker(URL.createObjectURL(new Blob([
            ""
        ], {
            type: "application/javascript"
        })));
        worker.terminate();
        supported = true;
    } catch (err) {
        typeof $a24315420cf48455$exports;
        console.log("Troika createWorkerModule: web workers not allowed; falling back to main thread execution. Cause: [" + err.message + "]");
    }
    // Cached result
    $ca0116d492137119$var$supportsWorkers = function() {
        return supported;
    };
    return supported;
};
var $ca0116d492137119$var$_workerModuleId = 0;
var $ca0116d492137119$var$_messageId = 0;
var $ca0116d492137119$var$_allowInitAsString = false;
var $ca0116d492137119$var$workers = Object.create(null);
var $ca0116d492137119$var$registeredModules = Object.create(null); //workerId -> Set<unregisterFn>
var $ca0116d492137119$var$openRequests = Object.create(null);
/**
 * Define a module of code that will be executed with a web worker. This provides a simple
 * interface for moving chunks of logic off the main thread, and managing their dependencies
 * among one another.
 *
 * @param {object} options
 * @param {function} options.init
 * @param {array} [options.dependencies]
 * @param {function} [options.getTransferables]
 * @param {string} [options.name]
 * @param {string} [options.workerId]
 * @return {function(...[*]): {then}}
 */ function $ca0116d492137119$export$e2063b0a5e3f6023(options) {
    if ((!options || typeof options.init !== "function") && !$ca0116d492137119$var$_allowInitAsString) throw new Error("requires `options.init` function");
    var dependencies = options.dependencies;
    var init = options.init;
    var getTransferables = options.getTransferables;
    var workerId = options.workerId;
    if (!$ca0116d492137119$var$supportsWorkers()) return $ca0116d492137119$var$defineMainThreadModule(options);
    if (workerId == null) workerId = "#default";
    var id = "workerModule" + ++$ca0116d492137119$var$_workerModuleId;
    var name = options.name || id;
    var registrationPromise = null;
    dependencies = dependencies && dependencies.map(function(dep) {
        // Wrap raw functions as worker modules with no dependencies
        if (typeof dep === "function" && !dep.workerModuleData) {
            $ca0116d492137119$var$_allowInitAsString = true;
            dep = $ca0116d492137119$export$e2063b0a5e3f6023({
                workerId: workerId,
                name: "<" + name + "> function dependency: " + dep.name,
                init: "function(){return (\n" + $ca0116d492137119$export$d62b0b738687b4b2(dep) + "\n)}"
            });
            $ca0116d492137119$var$_allowInitAsString = false;
        }
        // Grab postable data for worker modules
        if (dep && dep.workerModuleData) dep = dep.workerModuleData;
        return dep;
    });
    function moduleFunc() {
        var args = [], len = arguments.length;
        while(len--)args[len] = arguments[len];
        // Register this module if needed
        if (!registrationPromise) {
            registrationPromise = $ca0116d492137119$var$callWorker(workerId, "registerModule", moduleFunc.workerModuleData);
            var unregister = function() {
                registrationPromise = null;
                $ca0116d492137119$var$registeredModules[workerId].delete(unregister);
            };
            ($ca0116d492137119$var$registeredModules[workerId] || ($ca0116d492137119$var$registeredModules[workerId] = new Set())).add(unregister);
        }
        // Invoke the module, returning a promise
        return registrationPromise.then(function(ref) {
            var isCallable = ref.isCallable;
            if (isCallable) return $ca0116d492137119$var$callWorker(workerId, "callModule", {
                id: id,
                args: args
            });
            else throw new Error("Worker module function was called but `init` did not return a callable function");
        });
    }
    moduleFunc.workerModuleData = {
        isWorkerModule: true,
        id: id,
        name: name,
        dependencies: dependencies,
        init: $ca0116d492137119$export$d62b0b738687b4b2(init),
        getTransferables: getTransferables && $ca0116d492137119$export$d62b0b738687b4b2(getTransferables)
    };
    return moduleFunc;
}
/**
 * Terminate an active Worker by a workerId that was passed to defineWorkerModule.
 * This only terminates the Worker itself; the worker module will remain available
 * and if you call it again its Worker will be respawned.
 * @param {string} workerId
 */ function $ca0116d492137119$export$a61a973ac243a75e(workerId) {
    // Unregister all modules that were registered in that worker
    if ($ca0116d492137119$var$registeredModules[workerId]) $ca0116d492137119$var$registeredModules[workerId].forEach(function(unregister) {
        unregister();
    });
    // Terminate the Worker object
    if ($ca0116d492137119$var$workers[workerId]) {
        $ca0116d492137119$var$workers[workerId].terminate();
        delete $ca0116d492137119$var$workers[workerId];
    }
}
/**
 * Stringifies a function into a form that can be deserialized in the worker
 * @param fn
 */ function $ca0116d492137119$export$d62b0b738687b4b2(fn) {
    var str = fn.toString();
    // If it was defined in object method/property format, it needs to be modified
    if (!/^function/.test(str) && /^\w+\s*\(/.test(str)) str = "function " + str;
    return str;
}
function $ca0116d492137119$var$getWorker(workerId) {
    var worker = $ca0116d492137119$var$workers[workerId];
    if (!worker) {
        // Bootstrap the worker's content
        var bootstrap = $ca0116d492137119$export$d62b0b738687b4b2($ca0116d492137119$var$workerBootstrap);
        // Create the worker from the bootstrap function content
        worker = $ca0116d492137119$var$workers[workerId] = new Worker(URL.createObjectURL(new Blob([
            "/** Worker Module Bootstrap: " + workerId.replace(/\*/g, "") + " **/\n\n;(" + bootstrap + ")()"
        ], {
            type: "application/javascript"
        })));
        // Single handler for response messages from the worker
        worker.onmessage = function(e) {
            var response = e.data;
            var msgId = response.messageId;
            var callback = $ca0116d492137119$var$openRequests[msgId];
            if (!callback) throw new Error("WorkerModule response with empty or unknown messageId");
            delete $ca0116d492137119$var$openRequests[msgId];
            callback(response);
        };
    }
    return worker;
}
// Issue a call to the worker with a callback to handle the response
function $ca0116d492137119$var$callWorker(workerId, action, data) {
    return new Promise(function(resolve, reject) {
        var messageId = ++$ca0116d492137119$var$_messageId;
        $ca0116d492137119$var$openRequests[messageId] = function(response) {
            if (response.success) resolve(response.result);
            else reject(new Error("Error in worker " + action + " call: " + response.error));
        };
        $ca0116d492137119$var$getWorker(workerId).postMessage({
            messageId: messageId,
            action: action,
            data: data
        });
    });
}


function $ecaec7586e6e01a6$export$2e2bcd8739ae039() {
    var exports = function(exports) {
        /**
   * Find the point on a quadratic bezier curve at t where t is in the range [0, 1]
   */ function pointOnQuadraticBezier(x0, y0, x1, y1, x2, y2, t, pointOut) {
            var t2 = 1 - t;
            pointOut.x = t2 * t2 * x0 + 2 * t2 * t * x1 + t * t * x2;
            pointOut.y = t2 * t2 * y0 + 2 * t2 * t * y1 + t * t * y2;
        }
        /**
   * Find the point on a cubic bezier curve at t where t is in the range [0, 1]
   */ function pointOnCubicBezier(x0, y0, x1, y1, x2, y2, x3, y3, t, pointOut) {
            var t2 = 1 - t;
            pointOut.x = t2 * t2 * t2 * x0 + 3 * t2 * t2 * t * x1 + 3 * t2 * t * t * x2 + t * t * t * x3;
            pointOut.y = t2 * t2 * t2 * y0 + 3 * t2 * t2 * t * y1 + 3 * t2 * t * t * y2 + t * t * t * y3;
        }
        /**
   * Parse a path string into its constituent line/curve commands, invoking a callback for each.
   * @param {string} pathString - An SVG-like path string to parse; should only contain commands: M/L/Q/C/Z
   * @param {function(
   *   command: 'L'|'Q'|'C',
   *   startX: number,
   *   startY: number,
   *   endX: number,
   *   endY: number,
   *   ctrl1X?: number,
   *   ctrl1Y?: number,
   *   ctrl2X?: number,
   *   ctrl2Y?: number
   * )} commandCallback - A callback function that will be called once for each parsed path command, passing the
   *                      command identifier (only L/Q/C commands) and its numeric arguments.
   */ function forEachPathCommand(pathString, commandCallback) {
            var segmentRE = /([MLQCZ])([^MLQCZ]*)/g;
            var match, firstX, firstY, prevX, prevY;
            while(match = segmentRE.exec(pathString)){
                var args = match[2].replace(/^\s*|\s*$/g, "").split(/[,\s]+/).map(function(v) {
                    return parseFloat(v);
                });
                switch(match[1]){
                    case "M":
                        prevX = firstX = args[0];
                        prevY = firstY = args[1];
                        break;
                    case "L":
                        if (args[0] !== prevX || args[1] !== prevY) commandCallback("L", prevX, prevY, prevX = args[0], prevY = args[1]);
                        break;
                    case "Q":
                        commandCallback("Q", prevX, prevY, prevX = args[2], prevY = args[3], args[0], args[1]);
                        break;
                    case "C":
                        commandCallback("C", prevX, prevY, prevX = args[4], prevY = args[5], args[0], args[1], args[2], args[3]);
                        break;
                    case "Z":
                        if (prevX !== firstX || prevY !== firstY) commandCallback("L", prevX, prevY, firstX, firstY);
                        break;
                }
            }
        }
        /**
   * Convert a path string to a series of straight line segments
   * @param {string} pathString - An SVG-like path string to parse; should only contain commands: M/L/Q/C/Z
   * @param {function(x1:number, y1:number, x2:number, y2:number)} segmentCallback - A callback
   *        function that will be called once for every line segment
   * @param {number} [curvePoints] - How many straight line segments to use when approximating a
   *        bezier curve in the path. Defaults to 16.
   */ function pathToLineSegments(pathString, segmentCallback, curvePoints) {
            if (curvePoints === void 0) curvePoints = 16;
            var tempPoint = {
                x: 0,
                y: 0
            };
            forEachPathCommand(pathString, function(command, startX, startY, endX, endY, ctrl1X, ctrl1Y, ctrl2X, ctrl2Y) {
                switch(command){
                    case "L":
                        segmentCallback(startX, startY, endX, endY);
                        break;
                    case "Q":
                        var prevCurveX = startX;
                        var prevCurveY = startY;
                        for(var i = 1; i < curvePoints; i++){
                            pointOnQuadraticBezier(startX, startY, ctrl1X, ctrl1Y, endX, endY, i / (curvePoints - 1), tempPoint);
                            segmentCallback(prevCurveX, prevCurveY, tempPoint.x, tempPoint.y);
                            prevCurveX = tempPoint.x;
                            prevCurveY = tempPoint.y;
                        }
                        break;
                    case "C":
                        var prevCurveX$1 = startX;
                        var prevCurveY$1 = startY;
                        for(var i$1 = 1; i$1 < curvePoints; i$1++){
                            pointOnCubicBezier(startX, startY, ctrl1X, ctrl1Y, ctrl2X, ctrl2Y, endX, endY, i$1 / (curvePoints - 1), tempPoint);
                            segmentCallback(prevCurveX$1, prevCurveY$1, tempPoint.x, tempPoint.y);
                            prevCurveX$1 = tempPoint.x;
                            prevCurveY$1 = tempPoint.y;
                        }
                        break;
                }
            });
        }
        var viewportQuadVertex = "precision highp float;attribute vec2 aUV;varying vec2 vUV;void main(){vUV=aUV;gl_Position=vec4(mix(vec2(-1.0),vec2(1.0),aUV),0.0,1.0);}";
        var copyTexFragment = "precision highp float;uniform sampler2D tex;varying vec2 vUV;void main(){gl_FragColor=texture2D(tex,vUV);}";
        var cache = new WeakMap();
        var glContextParams = {
            premultipliedAlpha: false,
            preserveDrawingBuffer: true,
            antialias: false,
            depth: false
        };
        /**
   * This is a little helper library for WebGL. It assists with state management for a GL context.
   * It's pretty tightly wrapped to the needs of this package, not very general-purpose.
   *
   * @param { WebGLRenderingContext | HTMLCanvasElement | OffscreenCanvas } glOrCanvas - the GL context to wrap
   * @param { ({gl, getExtension, withProgram, withTexture, withTextureFramebuffer, handleContextLoss}) => void } callback
   */ function withWebGLContext(glOrCanvas, callback) {
            var gl = glOrCanvas.getContext ? glOrCanvas.getContext("webgl", glContextParams) : glOrCanvas;
            var wrapper = cache.get(gl);
            if (!wrapper) {
                var isWebGL2 = typeof WebGL2RenderingContext !== "undefined" && gl instanceof WebGL2RenderingContext;
                var extensions = {};
                var programs = {};
                var textures = {};
                var textureUnit = -1;
                var framebufferStack = [];
                gl.canvas.addEventListener("webglcontextlost", function(e) {
                    handleContextLoss();
                    e.preventDefault();
                }, false);
                function getExtension(name) {
                    var ext = extensions[name];
                    if (!ext) {
                        ext = extensions[name] = gl.getExtension(name);
                        if (!ext) throw new Error(name + " not supported");
                    }
                    return ext;
                }
                function compileShader(src, type) {
                    var shader = gl.createShader(type);
                    gl.shaderSource(shader, src);
                    gl.compileShader(shader);
                    // const status = gl.getShaderParameter(shader, gl.COMPILE_STATUS)
                    // if (!status && !gl.isContextLost()) {
                    //   throw new Error(gl.getShaderInfoLog(shader).trim())
                    // }
                    return shader;
                }
                function withProgram(name, vert, frag, func) {
                    if (!programs[name]) {
                        var attributes = {};
                        var uniforms = {};
                        var program = gl.createProgram();
                        gl.attachShader(program, compileShader(vert, gl.VERTEX_SHADER));
                        gl.attachShader(program, compileShader(frag, gl.FRAGMENT_SHADER));
                        gl.linkProgram(program);
                        programs[name] = {
                            program: program,
                            transaction: function transaction(func) {
                                gl.useProgram(program);
                                func({
                                    setUniform: function setUniform(type, name) {
                                        var values = [], len = arguments.length - 2;
                                        while(len-- > 0)values[len] = arguments[len + 2];
                                        var uniformLoc = uniforms[name] || (uniforms[name] = gl.getUniformLocation(program, name));
                                        gl["uniform" + type].apply(gl, [
                                            uniformLoc
                                        ].concat(values));
                                    },
                                    setAttribute: function setAttribute(name, size, usage, instancingDivisor, data) {
                                        var attr = attributes[name];
                                        if (!attr) attr = attributes[name] = {
                                            buf: gl.createBuffer(),
                                            loc: gl.getAttribLocation(program, name),
                                            data: null
                                        };
                                        gl.bindBuffer(gl.ARRAY_BUFFER, attr.buf);
                                        gl.vertexAttribPointer(attr.loc, size, gl.FLOAT, false, 0, 0);
                                        gl.enableVertexAttribArray(attr.loc);
                                        if (isWebGL2) gl.vertexAttribDivisor(attr.loc, instancingDivisor);
                                        else getExtension("ANGLE_instanced_arrays").vertexAttribDivisorANGLE(attr.loc, instancingDivisor);
                                        if (data !== attr.data) {
                                            gl.bufferData(gl.ARRAY_BUFFER, data, usage);
                                            attr.data = data;
                                        }
                                    }
                                });
                            }
                        };
                    }
                    programs[name].transaction(func);
                }
                function withTexture(name, func) {
                    textureUnit++;
                    try {
                        gl.activeTexture(gl.TEXTURE0 + textureUnit);
                        var texture = textures[name];
                        if (!texture) {
                            texture = textures[name] = gl.createTexture();
                            gl.bindTexture(gl.TEXTURE_2D, texture);
                            gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.NEAREST);
                            gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, gl.NEAREST);
                        }
                        gl.bindTexture(gl.TEXTURE_2D, texture);
                        func(texture, textureUnit);
                    } finally{
                        textureUnit--;
                    }
                }
                function withTextureFramebuffer(texture, textureUnit, func) {
                    var framebuffer = gl.createFramebuffer();
                    framebufferStack.push(framebuffer);
                    gl.bindFramebuffer(gl.FRAMEBUFFER, framebuffer);
                    gl.activeTexture(gl.TEXTURE0 + textureUnit);
                    gl.bindTexture(gl.TEXTURE_2D, texture);
                    gl.framebufferTexture2D(gl.FRAMEBUFFER, gl.COLOR_ATTACHMENT0, gl.TEXTURE_2D, texture, 0);
                    try {
                        func(framebuffer);
                    } finally{
                        gl.deleteFramebuffer(framebuffer);
                        gl.bindFramebuffer(gl.FRAMEBUFFER, framebufferStack[--framebufferStack.length - 1] || null);
                    }
                }
                function handleContextLoss() {
                    extensions = {};
                    programs = {};
                    textures = {};
                    textureUnit = -1;
                    framebufferStack.length = 0;
                }
                cache.set(gl, wrapper = {
                    gl: gl,
                    isWebGL2: isWebGL2,
                    getExtension: getExtension,
                    withProgram: withProgram,
                    withTexture: withTexture,
                    withTextureFramebuffer: withTextureFramebuffer,
                    handleContextLoss: handleContextLoss
                });
            }
            callback(wrapper);
        }
        function renderImageData(glOrCanvas, imageData, x, y, width, height, channels, framebuffer) {
            if (channels === void 0) channels = 15;
            if (framebuffer === void 0) framebuffer = null;
            withWebGLContext(glOrCanvas, function(ref) {
                var gl = ref.gl;
                var withProgram = ref.withProgram;
                var withTexture = ref.withTexture;
                withTexture("copy", function(tex, texUnit) {
                    gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, width, height, 0, gl.RGBA, gl.UNSIGNED_BYTE, imageData);
                    withProgram("copy", viewportQuadVertex, copyTexFragment, function(ref) {
                        var setUniform = ref.setUniform;
                        var setAttribute = ref.setAttribute;
                        setAttribute("aUV", 2, gl.STATIC_DRAW, 0, new Float32Array([
                            0,
                            0,
                            2,
                            0,
                            0,
                            2
                        ]));
                        setUniform("1i", "image", texUnit);
                        gl.bindFramebuffer(gl.FRAMEBUFFER, framebuffer || null);
                        gl.disable(gl.BLEND);
                        gl.colorMask(channels & 8, channels & 4, channels & 2, channels & 1);
                        gl.viewport(x, y, width, height);
                        gl.scissor(x, y, width, height);
                        gl.drawArrays(gl.TRIANGLES, 0, 3);
                    });
                });
            });
        }
        /**
   * Resizing a canvas clears its contents; this utility copies the previous contents over.
   * @param canvas
   * @param newWidth
   * @param newHeight
   */ function resizeWebGLCanvasWithoutClearing(canvas, newWidth, newHeight) {
            var width = canvas.width;
            var height = canvas.height;
            withWebGLContext(canvas, function(ref) {
                var gl = ref.gl;
                var data = new Uint8Array(width * height * 4);
                gl.readPixels(0, 0, width, height, gl.RGBA, gl.UNSIGNED_BYTE, data);
                canvas.width = newWidth;
                canvas.height = newHeight;
                renderImageData(gl, data, 0, 0, width, height);
            });
        }
        var webglUtils = /*#__PURE__*/ Object.freeze({
            __proto__: null,
            withWebGLContext: withWebGLContext,
            renderImageData: renderImageData,
            resizeWebGLCanvasWithoutClearing: resizeWebGLCanvasWithoutClearing
        });
        function generate$2(sdfWidth, sdfHeight, path, viewBox, maxDistance, sdfExponent) {
            if (sdfExponent === void 0) sdfExponent = 1;
            var textureData = new Uint8Array(sdfWidth * sdfHeight);
            var viewBoxWidth = viewBox[2] - viewBox[0];
            var viewBoxHeight = viewBox[3] - viewBox[1];
            // Decompose all paths into straight line segments and add them to an index
            var segments = [];
            pathToLineSegments(path, function(x1, y1, x2, y2) {
                segments.push({
                    x1: x1,
                    y1: y1,
                    x2: x2,
                    y2: y2,
                    minX: Math.min(x1, x2),
                    minY: Math.min(y1, y2),
                    maxX: Math.max(x1, x2),
                    maxY: Math.max(y1, y2)
                });
            });
            // Sort segments by maxX, this will let us short-circuit some loops below
            segments.sort(function(a, b) {
                return a.maxX - b.maxX;
            });
            // For each target SDF texel, find the distance from its center to its nearest line segment,
            // map that distance to an alpha value, and write that alpha to the texel
            for(var sdfX = 0; sdfX < sdfWidth; sdfX++)for(var sdfY = 0; sdfY < sdfHeight; sdfY++){
                var signedDist = findNearestSignedDistance(viewBox[0] + viewBoxWidth * (sdfX + 0.5) / sdfWidth, viewBox[1] + viewBoxHeight * (sdfY + 0.5) / sdfHeight);
                // Use an exponential scale to ensure the texels very near the glyph path have adequate
                // precision, while allowing the distance field to cover the entire texture, given that
                // there are only 8 bits available. Formula visualized: https://www.desmos.com/calculator/uiaq5aqiam
                var alpha = Math.pow(1 - Math.abs(signedDist) / maxDistance, sdfExponent) / 2;
                if (signedDist < 0) alpha = 1 - alpha;
                alpha = Math.max(0, Math.min(255, Math.round(alpha * 255))); //clamp
                textureData[sdfY * sdfWidth + sdfX] = alpha;
            }
            return textureData;
            /**
     * For a given x/y, search the index for the closest line segment and return
     * its signed distance. Negative = inside, positive = outside, zero = on edge
     * @param x
     * @param y
     * @returns {number}
     */ function findNearestSignedDistance(x, y) {
                var closestDistSq = Infinity;
                var closestDist = Infinity;
                for(var i = segments.length; i--;){
                    var seg = segments[i];
                    if (seg.maxX + closestDist <= x) break;
                     //sorting by maxX means no more can be closer, so we can short-circuit
                    if (x + closestDist > seg.minX && y - closestDist < seg.maxY && y + closestDist > seg.minY) {
                        var distSq = absSquareDistanceToLineSegment(x, y, seg.x1, seg.y1, seg.x2, seg.y2);
                        if (distSq < closestDistSq) {
                            closestDistSq = distSq;
                            closestDist = Math.sqrt(closestDistSq);
                        }
                    }
                }
                // Flip to negative distance if inside the poly
                if (isPointInPoly(x, y)) closestDist = -closestDist;
                return closestDist;
            }
            /**
     * Determine whether the given point lies inside or outside the glyph. Uses a simple
     * winding-number ray casting algorithm using a ray pointing east from the point.
     */ function isPointInPoly(x, y) {
                var winding = 0;
                for(var i = segments.length; i--;){
                    var seg = segments[i];
                    if (seg.maxX <= x) break;
                     //sorting by maxX means no more can cross, so we can short-circuit
                    var intersects = seg.y1 > y !== seg.y2 > y && x < (seg.x2 - seg.x1) * (y - seg.y1) / (seg.y2 - seg.y1) + seg.x1;
                    if (intersects) winding += seg.y1 < seg.y2 ? 1 : -1;
                }
                return winding !== 0;
            }
        }
        function generateIntoCanvas$2(sdfWidth, sdfHeight, path, viewBox, maxDistance, sdfExponent, canvas, x, y, channel) {
            if (sdfExponent === void 0) sdfExponent = 1;
            if (x === void 0) x = 0;
            if (y === void 0) y = 0;
            if (channel === void 0) channel = 0;
            generateIntoFramebuffer$1(sdfWidth, sdfHeight, path, viewBox, maxDistance, sdfExponent, canvas, null, x, y, channel);
        }
        function generateIntoFramebuffer$1(sdfWidth, sdfHeight, path, viewBox, maxDistance, sdfExponent, glOrCanvas, framebuffer, x, y, channel) {
            if (sdfExponent === void 0) sdfExponent = 1;
            if (x === void 0) x = 0;
            if (y === void 0) y = 0;
            if (channel === void 0) channel = 0;
            var data = generate$2(sdfWidth, sdfHeight, path, viewBox, maxDistance, sdfExponent);
            // Expand single-channel data to rbga
            var rgbaData = new Uint8Array(data.length * 4);
            for(var i = 0; i < data.length; i++)rgbaData[i * 4 + channel] = data[i];
            renderImageData(glOrCanvas, rgbaData, x, y, sdfWidth, sdfHeight, 1 << 3 - channel, framebuffer);
        }
        /**
   * Find the absolute distance from a point to a line segment at closest approach
   */ function absSquareDistanceToLineSegment(x, y, lineX0, lineY0, lineX1, lineY1) {
            var ldx = lineX1 - lineX0;
            var ldy = lineY1 - lineY0;
            var lengthSq = ldx * ldx + ldy * ldy;
            var t = lengthSq ? Math.max(0, Math.min(1, ((x - lineX0) * ldx + (y - lineY0) * ldy) / lengthSq)) : 0;
            var dx = x - (lineX0 + t * ldx);
            var dy = y - (lineY0 + t * ldy);
            return dx * dx + dy * dy;
        }
        var javascript = /*#__PURE__*/ Object.freeze({
            __proto__: null,
            generate: generate$2,
            generateIntoCanvas: generateIntoCanvas$2,
            generateIntoFramebuffer: generateIntoFramebuffer$1
        });
        var mainVertex = "precision highp float;uniform vec4 uGlyphBounds;attribute vec2 aUV;attribute vec4 aLineSegment;varying vec4 vLineSegment;varying vec2 vGlyphXY;void main(){vLineSegment=aLineSegment;vGlyphXY=mix(uGlyphBounds.xy,uGlyphBounds.zw,aUV);gl_Position=vec4(mix(vec2(-1.0),vec2(1.0),aUV),0.0,1.0);}";
        var mainFragment = "precision highp float;uniform vec4 uGlyphBounds;uniform float uMaxDistance;uniform float uExponent;varying vec4 vLineSegment;varying vec2 vGlyphXY;float absDistToSegment(vec2 point,vec2 lineA,vec2 lineB){vec2 lineDir=lineB-lineA;float lenSq=dot(lineDir,lineDir);float t=lenSq==0.0 ? 0.0 : clamp(dot(point-lineA,lineDir)/lenSq,0.0,1.0);vec2 linePt=lineA+t*lineDir;return distance(point,linePt);}void main(){vec4 seg=vLineSegment;vec2 p=vGlyphXY;float dist=absDistToSegment(p,seg.xy,seg.zw);float val=pow(1.0-clamp(dist/uMaxDistance,0.0,1.0),uExponent)*0.5;bool crossing=(seg.y>p.y!=seg.w>p.y)&&(p.x<(seg.z-seg.x)*(p.y-seg.y)/(seg.w-seg.y)+seg.x);bool crossingUp=crossing&&vLineSegment.y<vLineSegment.w;gl_FragColor=vec4(crossingUp ? 1.0/255.0 : 0.0,crossing&&!crossingUp ? 1.0/255.0 : 0.0,0.0,val);}";
        var postFragment = "precision highp float;uniform sampler2D tex;varying vec2 vUV;void main(){vec4 color=texture2D(tex,vUV);bool inside=color.r!=color.g;float val=inside ? 1.0-color.a : color.a;gl_FragColor=vec4(val);}";
        // Single triangle covering viewport
        var viewportUVs = new Float32Array([
            0,
            0,
            2,
            0,
            0,
            2
        ]);
        var implicitContext = null;
        var isTestingSupport = false;
        var NULL_OBJECT = {};
        var supportByCanvas = new WeakMap(); // canvas -> bool
        function validateSupport(glOrCanvas) {
            if (!isTestingSupport && !isSupported(glOrCanvas)) throw new Error("WebGL generation not supported");
        }
        function generate$1(sdfWidth, sdfHeight, path, viewBox, maxDistance, sdfExponent, glOrCanvas) {
            if (sdfExponent === void 0) sdfExponent = 1;
            if (glOrCanvas === void 0) glOrCanvas = null;
            if (!glOrCanvas) {
                glOrCanvas = implicitContext;
                if (!glOrCanvas) {
                    var canvas = typeof OffscreenCanvas === "function" ? new OffscreenCanvas(1, 1) : typeof document !== "undefined" ? document.createElement("canvas") : null;
                    if (!canvas) throw new Error("OffscreenCanvas or DOM canvas not supported");
                    glOrCanvas = implicitContext = canvas.getContext("webgl", {
                        depth: false
                    });
                }
            }
            validateSupport(glOrCanvas);
            var rgbaData = new Uint8Array(sdfWidth * sdfHeight * 4); //not Uint8ClampedArray, cuz Safari
            // Render into a background texture framebuffer
            withWebGLContext(glOrCanvas, function(ref) {
                var gl = ref.gl;
                var withTexture = ref.withTexture;
                var withTextureFramebuffer = ref.withTextureFramebuffer;
                withTexture("readable", function(texture, textureUnit) {
                    gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, sdfWidth, sdfHeight, 0, gl.RGBA, gl.UNSIGNED_BYTE, null);
                    withTextureFramebuffer(texture, textureUnit, function(framebuffer) {
                        generateIntoFramebuffer(sdfWidth, sdfHeight, path, viewBox, maxDistance, sdfExponent, gl, framebuffer, 0, 0, 0 // red channel
                        );
                        gl.readPixels(0, 0, sdfWidth, sdfHeight, gl.RGBA, gl.UNSIGNED_BYTE, rgbaData);
                    });
                });
            });
            // Throw away all but the red channel
            var data = new Uint8Array(sdfWidth * sdfHeight);
            for(var i = 0, j = 0; i < rgbaData.length; i += 4)data[j++] = rgbaData[i];
            return data;
        }
        function generateIntoCanvas$1(sdfWidth, sdfHeight, path, viewBox, maxDistance, sdfExponent, canvas, x, y, channel) {
            if (sdfExponent === void 0) sdfExponent = 1;
            if (x === void 0) x = 0;
            if (y === void 0) y = 0;
            if (channel === void 0) channel = 0;
            generateIntoFramebuffer(sdfWidth, sdfHeight, path, viewBox, maxDistance, sdfExponent, canvas, null, x, y, channel);
        }
        function generateIntoFramebuffer(sdfWidth, sdfHeight, path, viewBox, maxDistance, sdfExponent, glOrCanvas, framebuffer, x, y, channel) {
            if (sdfExponent === void 0) sdfExponent = 1;
            if (x === void 0) x = 0;
            if (y === void 0) y = 0;
            if (channel === void 0) channel = 0;
            // Verify support
            validateSupport(glOrCanvas);
            // Compute path segments
            var lineSegmentCoords = [];
            pathToLineSegments(path, function(x1, y1, x2, y2) {
                lineSegmentCoords.push(x1, y1, x2, y2);
            });
            lineSegmentCoords = new Float32Array(lineSegmentCoords);
            withWebGLContext(glOrCanvas, function(ref) {
                var gl = ref.gl;
                var isWebGL2 = ref.isWebGL2;
                var getExtension = ref.getExtension;
                var withProgram = ref.withProgram;
                var withTexture = ref.withTexture;
                var withTextureFramebuffer = ref.withTextureFramebuffer;
                var handleContextLoss = ref.handleContextLoss;
                withTexture("rawDistances", function(intermediateTexture, intermediateTextureUnit) {
                    if (sdfWidth !== intermediateTexture._lastWidth || sdfHeight !== intermediateTexture._lastHeight) gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, intermediateTexture._lastWidth = sdfWidth, intermediateTexture._lastHeight = sdfHeight, 0, gl.RGBA, gl.UNSIGNED_BYTE, null);
                    // Unsigned distance pass
                    withProgram("main", mainVertex, mainFragment, function(ref) {
                        var setAttribute = ref.setAttribute;
                        var setUniform = ref.setUniform;
                        // Init extensions
                        var instancingExtension = !isWebGL2 && getExtension("ANGLE_instanced_arrays");
                        var blendMinMaxExtension = !isWebGL2 && getExtension("EXT_blend_minmax");
                        // Init/update attributes
                        setAttribute("aUV", 2, gl.STATIC_DRAW, 0, viewportUVs);
                        setAttribute("aLineSegment", 4, gl.DYNAMIC_DRAW, 1, lineSegmentCoords);
                        // Init/update uniforms
                        setUniform.apply(void 0, [
                            "4f",
                            "uGlyphBounds"
                        ].concat(viewBox));
                        setUniform("1f", "uMaxDistance", maxDistance);
                        setUniform("1f", "uExponent", sdfExponent);
                        // Render initial unsigned distance / winding number info to a texture
                        withTextureFramebuffer(intermediateTexture, intermediateTextureUnit, function(framebuffer) {
                            gl.enable(gl.BLEND);
                            gl.colorMask(true, true, true, true);
                            gl.viewport(0, 0, sdfWidth, sdfHeight);
                            gl.scissor(0, 0, sdfWidth, sdfHeight);
                            gl.blendFunc(gl.ONE, gl.ONE);
                            // Red+Green channels are incremented (FUNC_ADD) for segment-ray crossings to give a "winding number".
                            // Alpha holds the closest (MAX) unsigned distance.
                            gl.blendEquationSeparate(gl.FUNC_ADD, isWebGL2 ? gl.MAX : blendMinMaxExtension.MAX_EXT);
                            gl.clear(gl.COLOR_BUFFER_BIT);
                            if (isWebGL2) gl.drawArraysInstanced(gl.TRIANGLES, 0, 3, lineSegmentCoords.length / 4);
                            else instancingExtension.drawArraysInstancedANGLE(gl.TRIANGLES, 0, 3, lineSegmentCoords.length / 4);
                        // Debug
                        // const debug = new Uint8Array(sdfWidth * sdfHeight * 4)
                        // gl.readPixels(0, 0, sdfWidth, sdfHeight, gl.RGBA, gl.UNSIGNED_BYTE, debug)
                        // console.log('intermediate texture data: ', debug)
                        });
                    });
                    // Use the data stored in the texture to apply inside/outside and write to the output framebuffer rect+channel.
                    withProgram("post", viewportQuadVertex, postFragment, function(program) {
                        program.setAttribute("aUV", 2, gl.STATIC_DRAW, 0, viewportUVs);
                        program.setUniform("1i", "tex", intermediateTextureUnit);
                        gl.bindFramebuffer(gl.FRAMEBUFFER, framebuffer);
                        gl.disable(gl.BLEND);
                        gl.colorMask(channel === 0, channel === 1, channel === 2, channel === 3);
                        gl.viewport(x, y, sdfWidth, sdfHeight);
                        gl.scissor(x, y, sdfWidth, sdfHeight);
                        gl.drawArrays(gl.TRIANGLES, 0, 3);
                    });
                });
                // Handle context loss occurring during any of the above calls
                if (gl.isContextLost()) {
                    handleContextLoss();
                    throw new Error("webgl context lost");
                }
            });
        }
        function isSupported(glOrCanvas) {
            var key = !glOrCanvas || glOrCanvas === implicitContext ? NULL_OBJECT : glOrCanvas.canvas || glOrCanvas;
            var supported = supportByCanvas.get(key);
            if (supported === undefined) {
                isTestingSupport = true;
                var failReason = null;
                try {
                    // Since we can't detect all failure modes up front, let's just do a trial run of a
                    // simple path and compare what we get back to the correct expected result. This will
                    // also serve to prime the shader compilation.
                    var expectedResult = [
                        97,
                        106,
                        97,
                        61,
                        99,
                        137,
                        118,
                        80,
                        80,
                        118,
                        137,
                        99,
                        61,
                        97,
                        106,
                        97
                    ];
                    var testResult = generate$1(4, 4, "M8,8L16,8L24,24L16,24Z", [
                        0,
                        0,
                        32,
                        32
                    ], 24, 1, glOrCanvas);
                    supported = testResult && expectedResult.length === testResult.length && testResult.every(function(val, i) {
                        return val === expectedResult[i];
                    });
                    if (!supported) {
                        failReason = "bad trial run results";
                        console.info(expectedResult, testResult);
                    }
                } catch (err) {
                    // TODO if it threw due to webgl context loss, should we maybe leave isSupported as null and try again later?
                    supported = false;
                    failReason = err.message;
                }
                if (failReason) console.warn("WebGL SDF generation not supported:", failReason);
                isTestingSupport = false;
                supportByCanvas.set(key, supported);
            }
            return supported;
        }
        var webgl = /*#__PURE__*/ Object.freeze({
            __proto__: null,
            generate: generate$1,
            generateIntoCanvas: generateIntoCanvas$1,
            generateIntoFramebuffer: generateIntoFramebuffer,
            isSupported: isSupported
        });
        /**
   * Generate an SDF texture image for a 2D path.
   *
   * @param {number} sdfWidth - width of the SDF output image in pixels.
   * @param {number} sdfHeight - height of the SDF output image in pixels.
   * @param {string} path - an SVG-like path string describing the glyph; should only contain commands: M/L/Q/C/Z.
   * @param {number[]} viewBox - [minX, minY, maxX, maxY] in font units aligning with the texture's edges.
   * @param {number} maxDistance - the maximum distance from the glyph path in font units that will be encoded; defaults
   *        to half the maximum viewBox dimension.
   * @param {number} [sdfExponent] - specifies an exponent for encoding the SDF's distance values; higher exponents
   *        will give greater precision nearer the glyph's path.
   * @return {Uint8Array}
   */ function generate(sdfWidth, sdfHeight, path, viewBox, maxDistance, sdfExponent) {
            if (maxDistance === void 0) maxDistance = Math.max(viewBox[2] - viewBox[0], viewBox[3] - viewBox[1]) / 2;
            if (sdfExponent === void 0) sdfExponent = 1;
            try {
                return generate$1.apply(webgl, arguments);
            } catch (e) {
                console.info("WebGL SDF generation failed, falling back to JS", e);
                return generate$2.apply(javascript, arguments);
            }
        }
        /**
   * Generate an SDF texture image for a 2D path, inserting the result into a WebGL `canvas` at a given x/y position
   * and color channel. This is generally much faster than calling `generate` because it does not require reading pixels
   * back from the GPU->CPU -- the `canvas` can be used directly as a WebGL texture image, so it all stays on the GPU.
   *
   * @param {number} sdfWidth - width of the SDF output image in pixels.
   * @param {number} sdfHeight - height of the SDF output image in pixels.
   * @param {string} path - an SVG-like path string describing the glyph; should only contain commands: M/L/Q/C/Z.
   * @param {number[]} viewBox - [minX, minY, maxX, maxY] in font units aligning with the texture's edges.
   * @param {number} maxDistance - the maximum distance from the glyph path in font units that will be encoded; defaults
   *        to half the maximum viewBox dimension.
   * @param {number} [sdfExponent] - specifies an exponent for encoding the SDF's distance values; higher exponents
   *        will give greater precision nearer the glyph's path.
   * @param {HTMLCanvasElement|OffscreenCanvas} canvas - a WebGL-enabled canvas into which the SDF will be rendered.
   *        Only the relevant rect/channel will be modified, the rest will be preserved. To avoid unpredictable results
   *        due to shared GL context state, this canvas should be dedicated to use by this library alone.
   * @param {number} x - the x position at which to render the SDF.
   * @param {number} y - the y position at which to render the SDF.
   * @param {number} channel - the color channel index (0-4) into which the SDF will be rendered.
   * @return {Uint8Array}
   */ function generateIntoCanvas(sdfWidth, sdfHeight, path, viewBox, maxDistance, sdfExponent, canvas, x, y, channel) {
            if (maxDistance === void 0) maxDistance = Math.max(viewBox[2] - viewBox[0], viewBox[3] - viewBox[1]) / 2;
            if (sdfExponent === void 0) sdfExponent = 1;
            if (x === void 0) x = 0;
            if (y === void 0) y = 0;
            if (channel === void 0) channel = 0;
            try {
                return generateIntoCanvas$1.apply(webgl, arguments);
            } catch (e) {
                console.info("WebGL SDF generation failed, falling back to JS", e);
                return generateIntoCanvas$2.apply(javascript, arguments);
            }
        }
        exports.forEachPathCommand = forEachPathCommand;
        exports.generate = generate;
        exports.generateIntoCanvas = generateIntoCanvas;
        exports.javascript = javascript;
        exports.pathToLineSegments = pathToLineSegments;
        exports.webgl = webgl;
        exports.webglUtils = webglUtils;
        Object.defineProperty(exports, "__esModule", {
            value: true
        });
        return exports;
    }({});
    return exports;
}


function $65b2b49b50a4e8ff$var$bidiFactory() {
    var bidi = function(exports) {
        // Bidi character types data, auto generated
        var DATA = {
            "R": "13k,1a,2,3,3,2+1j,ch+16,a+1,5+2,2+n,5,a,4,6+16,4+3,h+1b,4mo,179q,2+9,2+11,2i9+7y,2+68,4,3+4,5+13,4+3,2+4k,3+29,8+cf,1t+7z,w+17,3+3m,1t+3z,16o1+5r,8+30,8+mc,29+1r,29+4v,75+73",
            "EN": "1c+9,3d+1,6,187+9,513,4+5,7+9,sf+j,175h+9,qw+q,161f+1d,4xt+a,25i+9",
            "ES": "17,2,6dp+1,f+1,av,16vr,mx+1,4o,2",
            "ET": "z+2,3h+3,b+1,ym,3e+1,2o,p4+1,8,6u,7c,g6,1wc,1n9+4,30+1b,2n,6d,qhx+1,h0m,a+1,49+2,63+1,4+1,6bb+3,12jj",
            "AN": "16o+5,2j+9,2+1,35,ed,1ff2+9,87+u",
            "CS": "18,2+1,b,2u,12k,55v,l,17v0,2,3,53,2+1,b",
            "B": "a,3,f+2,2v,690",
            "S": "9,2,k",
            "WS": "c,k,4f4,1vk+a,u,1j,335",
            "ON": "x+1,4+4,h+5,r+5,r+3,z,5+3,2+1,2+1,5,2+2,3+4,o,w,ci+1,8+d,3+d,6+8,2+g,39+1,9,6+1,2,33,b8,3+1,3c+1,7+1,5r,b,7h+3,sa+5,2,3i+6,jg+3,ur+9,2v,ij+1,9g+9,7+a,8m,4+1,49+x,14u,2+2,c+2,e+2,e+2,e+1,i+n,e+e,2+p,u+2,e+2,36+1,2+3,2+1,b,2+2,6+5,2,2,2,h+1,5+4,6+3,3+f,16+2,5+3l,3+81,1y+p,2+40,q+a,m+13,2r+ch,2+9e,75+hf,3+v,2+2w,6e+5,f+6,75+2a,1a+p,2+2g,d+5x,r+b,6+3,4+o,g,6+1,6+2,2k+1,4,2j,5h+z,1m+1,1e+f,t+2,1f+e,d+3,4o+3,2s+1,w,535+1r,h3l+1i,93+2,2s,b+1,3l+x,2v,4g+3,21+3,kz+1,g5v+1,5a,j+9,n+v,2,3,2+8,2+1,3+2,2,3,46+1,4+4,h+5,r+5,r+a,3h+2,4+6,b+4,78,1r+24,4+c,4,1hb,ey+6,103+j,16j+c,1ux+7,5+g,fsh,jdq+1t,4,57+2e,p1,1m,1m,1m,1m,4kt+1,7j+17,5+2r,d+e,3+e,2+e,2+10,m+4,w,1n+5,1q,4z+5,4b+rb,9+c,4+c,4+37,d+2g,8+b,l+b,5+1j,9+9,7+13,9+t,3+1,27+3c,2+29,2+3q,d+d,3+4,4+2,6+6,a+o,8+6,a+2,e+6,16+42,2+1i",
            "BN": "0+8,6+d,2s+5,2+p,e,4m9,1kt+2,2b+5,5+5,17q9+v,7k,6p+8,6+1,119d+3,440+7,96s+1,1ekf+1,1ekf+1,1ekf+1,1ekf+1,1ekf+1,1ekf+1,1ekf+1,1ekf+1,1ekf+1,1ekf+1,1ekf+1,1ekf+75,6p+2rz,1ben+1,1ekf+1,1ekf+1",
            "NSM": "lc+33,7o+6,7c+18,2,2+1,2+1,2,21+a,1d+k,h,2u+6,3+5,3+1,2+3,10,v+q,2k+a,1n+8,a,p+3,2+8,2+2,2+4,18+2,3c+e,2+v,1k,2,5+7,5,4+6,b+1,u,1n,5+3,9,l+1,r,3+1,1m,5+1,5+1,3+2,4,v+1,4,c+1,1m,5+4,2+1,5,l+1,n+5,2,1n,3,2+3,9,8+1,c+1,v,1q,d,1f,4,1m+2,6+2,2+3,8+1,c+1,u,1n,g+1,l+1,t+1,1m+1,5+3,9,l+1,u,21,8+2,2,2j,3+6,d+7,2r,3+8,c+5,23+1,s,2,2,1k+d,2+4,2+1,6+a,2+z,a,2v+3,2+5,2+1,3+1,q+1,5+2,h+3,e,3+1,7,g,jk+2,qb+2,u+2,u+1,v+1,1t+1,2+6,9,3+a,a,1a+2,3c+1,z,3b+2,5+1,a,7+2,64+1,3,1n,2+6,2,2,3+7,7+9,3,1d+g,1s+3,1d,2+4,2,6,15+8,d+1,x+3,3+1,2+2,1l,2+1,4,2+2,1n+7,3+1,49+2,2+c,2+6,5,7,4+1,5j+1l,2+4,k1+w,2db+2,3y,2p+v,ff+3,30+1,n9x+3,2+9,x+1,29+1,7l,4,5,q+1,6,48+1,r+h,e,13+7,q+a,1b+2,1d,3+3,3+1,14,1w+5,3+1,3+1,d,9,1c,1g,2+2,3+1,6+1,2,17+1,9,6n,3,5,fn5,ki+f,h+f,r2,6b,46+4,1af+2,2+1,6+3,15+2,5,4m+1,fy+3,as+1,4a+a,4x,1j+e,1l+2,1e+3,3+1,1y+2,11+4,2+7,1r,d+1,1h+8,b+3,3,2o+2,3,2+1,7,4h,4+7,m+1,1m+1,4,12+6,4+4,5g+7,3+2,2,o,2d+5,2,5+1,2+1,6n+3,7+1,2+1,s+1,2e+7,3,2+1,2z,2,3+5,2,2u+2,3+3,2+4,78+8,2+1,75+1,2,5,41+3,3+1,5,x+5,3+1,15+5,3+3,9,a+5,3+2,1b+c,2+1,bb+6,2+5,2d+l,3+6,2+1,2+1,3f+5,4,2+1,2+6,2,21+1,4,2,9o+1,f0c+4,1o+6,t5,1s+3,2a,f5l+1,43t+2,i+7,3+6,v+3,45+2,1j0+1i,5+1d,9,f,n+4,2+e,11t+6,2+g,3+6,2+1,2+4,7a+6,c6+3,15t+6,32+6,gzhy+6n",
            "AL": "16w,3,2,e+1b,z+2,2+2s,g+1,8+1,b+m,2+t,s+2i,c+e,4h+f,1d+1e,1bwe+dp,3+3z,x+c,2+1,35+3y,2rm+z,5+7,b+5,dt+l,c+u,17nl+27,1t+27,4x+6n,3+d",
            "LRO": "6ct",
            "RLO": "6cu",
            "LRE": "6cq",
            "RLE": "6cr",
            "PDF": "6cs",
            "LRI": "6ee",
            "RLI": "6ef",
            "FSI": "6eg",
            "PDI": "6eh"
        };
        var TYPES = {};
        var TYPES_TO_NAMES = {};
        TYPES.L = 1; //L is the default
        TYPES_TO_NAMES[1] = "L";
        Object.keys(DATA).forEach(function(type, i) {
            TYPES[type] = 1 << i + 1;
            TYPES_TO_NAMES[TYPES[type]] = type;
        });
        Object.freeze(TYPES);
        var ISOLATE_INIT_TYPES = TYPES.LRI | TYPES.RLI | TYPES.FSI;
        var STRONG_TYPES = TYPES.L | TYPES.R | TYPES.AL;
        var NEUTRAL_ISOLATE_TYPES = TYPES.B | TYPES.S | TYPES.WS | TYPES.ON | TYPES.FSI | TYPES.LRI | TYPES.RLI | TYPES.PDI;
        var BN_LIKE_TYPES = TYPES.BN | TYPES.RLE | TYPES.LRE | TYPES.RLO | TYPES.LRO | TYPES.PDF;
        var TRAILING_TYPES = TYPES.S | TYPES.WS | TYPES.B | ISOLATE_INIT_TYPES | TYPES.PDI | BN_LIKE_TYPES;
        var map = null;
        function parseData() {
            if (!map) {
                //const start = performance.now()
                map = new Map();
                var loop = function(type) {
                    if (DATA.hasOwnProperty(type)) {
                        var lastCode = 0;
                        DATA[type].split(",").forEach(function(range) {
                            var ref = range.split("+");
                            var skip = ref[0];
                            var step = ref[1];
                            skip = parseInt(skip, 36);
                            step = step ? parseInt(step, 36) : 0;
                            map.set(lastCode += skip, TYPES[type]);
                            for(var i = 0; i < step; i++)map.set(++lastCode, TYPES[type]);
                        });
                    }
                };
                for(var type in DATA)loop(type);
            //console.log(`char types parsed in ${performance.now() - start}ms`)
            }
        }
        /**
   * @param {string} char
   * @return {number}
   */ function getBidiCharType(char) {
            parseData();
            return map.get(char.codePointAt(0)) || TYPES.L;
        }
        function getBidiCharTypeName(char) {
            return TYPES_TO_NAMES[getBidiCharType(char)];
        }
        // Bidi bracket pairs data, auto generated
        var data$1 = {
            "pairs": "14>1,1e>2,u>2,2wt>1,1>1,1ge>1,1wp>1,1j>1,f>1,hm>1,1>1,u>1,u6>1,1>1,+5,28>1,w>1,1>1,+3,b8>1,1>1,+3,1>3,-1>-1,3>1,1>1,+2,1s>1,1>1,x>1,th>1,1>1,+2,db>1,1>1,+3,3>1,1>1,+2,14qm>1,1>1,+1,4q>1,1e>2,u>2,2>1,+1",
            "canonical": "6f1>-6dx,6dy>-6dx,6ec>-6ed,6ee>-6ed,6ww>2jj,-2ji>2jj,14r4>-1e7l,1e7m>-1e7l,1e7m>-1e5c,1e5d>-1e5b,1e5c>-14qx,14qy>-14qx,14vn>-1ecg,1ech>-1ecg,1edu>-1ecg,1eci>-1ecg,1eda>-1ecg,1eci>-1ecg,1eci>-168q,168r>-168q,168s>-14ye,14yf>-14ye"
        };
        /**
   * Parses an string that holds encoded codepoint mappings, e.g. for bracket pairs or
   * mirroring characters, as encoded by scripts/generateBidiData.js. Returns an object
   * holding the `map`, and optionally a `reverseMap` if `includeReverse:true`.
   * @param {string} encodedString
   * @param {boolean} includeReverse - true if you want reverseMap in the output
   * @return {{map: Map<number, number>, reverseMap?: Map<number, number>}}
   */ function parseCharacterMap(encodedString, includeReverse) {
            var radix = 36;
            var lastCode = 0;
            var map = new Map();
            var reverseMap = includeReverse && new Map();
            var prevPair;
            encodedString.split(",").forEach(function visit(entry) {
                if (entry.indexOf("+") !== -1) for(var i = +entry; i--;)visit(prevPair);
                else {
                    prevPair = entry;
                    var ref = entry.split(">");
                    var a = ref[0];
                    var b = ref[1];
                    a = String.fromCodePoint(lastCode += parseInt(a, radix));
                    b = String.fromCodePoint(lastCode += parseInt(b, radix));
                    map.set(a, b);
                    includeReverse && reverseMap.set(b, a);
                }
            });
            return {
                map: map,
                reverseMap: reverseMap
            };
        }
        var openToClose, closeToOpen, canonical;
        function parse$1() {
            if (!openToClose) {
                //const start = performance.now()
                var ref = parseCharacterMap(data$1.pairs, true);
                var map = ref.map;
                var reverseMap = ref.reverseMap;
                openToClose = map;
                closeToOpen = reverseMap;
                canonical = parseCharacterMap(data$1.canonical, false).map;
            //console.log(`brackets parsed in ${performance.now() - start}ms`)
            }
        }
        function openingToClosingBracket(char) {
            parse$1();
            return openToClose.get(char) || null;
        }
        function closingToOpeningBracket(char) {
            parse$1();
            return closeToOpen.get(char) || null;
        }
        function getCanonicalBracket(char) {
            parse$1();
            return canonical.get(char) || null;
        }
        // Local type aliases
        var TYPE_L = TYPES.L;
        var TYPE_R = TYPES.R;
        var TYPE_EN = TYPES.EN;
        var TYPE_ES = TYPES.ES;
        var TYPE_ET = TYPES.ET;
        var TYPE_AN = TYPES.AN;
        var TYPE_CS = TYPES.CS;
        var TYPE_B = TYPES.B;
        var TYPE_S = TYPES.S;
        var TYPE_ON = TYPES.ON;
        var TYPE_BN = TYPES.BN;
        var TYPE_NSM = TYPES.NSM;
        var TYPE_AL = TYPES.AL;
        var TYPE_LRO = TYPES.LRO;
        var TYPE_RLO = TYPES.RLO;
        var TYPE_LRE = TYPES.LRE;
        var TYPE_RLE = TYPES.RLE;
        var TYPE_PDF = TYPES.PDF;
        var TYPE_LRI = TYPES.LRI;
        var TYPE_RLI = TYPES.RLI;
        var TYPE_FSI = TYPES.FSI;
        var TYPE_PDI = TYPES.PDI;
        /**
   * @typedef {object} GetEmbeddingLevelsResult
   * @property {{start, end, level}[]} paragraphs
   * @property {Uint8Array} levels
   */ /**
   * This function applies the Bidirectional Algorithm to a string, returning the resolved embedding levels
   * in a single Uint8Array plus a list of objects holding each paragraph's start and end indices and resolved
   * base embedding level.
   *
   * @param {string} string - The input string
   * @param {"ltr"|"rtl"|"auto"} [baseDirection] - Use "ltr" or "rtl" to force a base paragraph direction,
   *        otherwise a direction will be chosen automatically from each paragraph's contents.
   * @return {GetEmbeddingLevelsResult}
   */ function getEmbeddingLevels(string, baseDirection) {
            var MAX_DEPTH = 125;
            // Start by mapping all characters to their unicode type, as a bitmask integer
            var charTypes = new Uint32Array(string.length);
            for(var i = 0; i < string.length; i++)charTypes[i] = getBidiCharType(string[i]);
            var charTypeCounts = new Map(); //will be cleared at start of each paragraph
            function changeCharType(i, type) {
                var oldType = charTypes[i];
                charTypes[i] = type;
                charTypeCounts.set(oldType, charTypeCounts.get(oldType) - 1);
                if (oldType & NEUTRAL_ISOLATE_TYPES) charTypeCounts.set(NEUTRAL_ISOLATE_TYPES, charTypeCounts.get(NEUTRAL_ISOLATE_TYPES) - 1);
                charTypeCounts.set(type, (charTypeCounts.get(type) || 0) + 1);
                if (type & NEUTRAL_ISOLATE_TYPES) charTypeCounts.set(NEUTRAL_ISOLATE_TYPES, (charTypeCounts.get(NEUTRAL_ISOLATE_TYPES) || 0) + 1);
            }
            var embedLevels = new Uint8Array(string.length);
            var isolationPairs = new Map(); //init->pdi and pdi->init
            // === 3.3.1 The Paragraph Level ===
            // 3.3.1 P1: Split the text into paragraphs
            var paragraphs = []; // [{start, end, level}, ...]
            var paragraph = null;
            for(var i$1 = 0; i$1 < string.length; i$1++){
                if (!paragraph) paragraphs.push(paragraph = {
                    start: i$1,
                    end: string.length - 1,
                    // 3.3.1 P2-P3: Determine the paragraph level
                    level: baseDirection === "rtl" ? 1 : baseDirection === "ltr" ? 0 : determineAutoEmbedLevel(i$1, false)
                });
                if (charTypes[i$1] & TYPE_B) {
                    paragraph.end = i$1;
                    paragraph = null;
                }
            }
            var FORMATTING_TYPES = TYPE_RLE | TYPE_LRE | TYPE_RLO | TYPE_LRO | ISOLATE_INIT_TYPES | TYPE_PDI | TYPE_PDF | TYPE_B;
            var nextEven = function(n) {
                return n + (n & 1 ? 1 : 2);
            };
            var nextOdd = function(n) {
                return n + (n & 1 ? 2 : 1);
            };
            // Everything from here on will operate per paragraph.
            for(var paraIdx = 0; paraIdx < paragraphs.length; paraIdx++){
                paragraph = paragraphs[paraIdx];
                var statusStack = [
                    {
                        _level: paragraph.level,
                        _override: 0,
                        _isolate: 0 //bool
                    }
                ];
                var stackTop = void 0;
                var overflowIsolateCount = 0;
                var overflowEmbeddingCount = 0;
                var validIsolateCount = 0;
                charTypeCounts.clear();
                // === 3.3.2 Explicit Levels and Directions ===
                for(var i$2 = paragraph.start; i$2 <= paragraph.end; i$2++){
                    var charType = charTypes[i$2];
                    stackTop = statusStack[statusStack.length - 1];
                    // Set initial counts
                    charTypeCounts.set(charType, (charTypeCounts.get(charType) || 0) + 1);
                    if (charType & NEUTRAL_ISOLATE_TYPES) charTypeCounts.set(NEUTRAL_ISOLATE_TYPES, (charTypeCounts.get(NEUTRAL_ISOLATE_TYPES) || 0) + 1);
                    // Explicit Embeddings: 3.3.2 X2 - X3
                    if (charType & FORMATTING_TYPES) {
                        if (charType & (TYPE_RLE | TYPE_LRE)) {
                            embedLevels[i$2] = stackTop._level; // 5.2
                            var level = (charType === TYPE_RLE ? nextOdd : nextEven)(stackTop._level);
                            if (level <= MAX_DEPTH && !overflowIsolateCount && !overflowEmbeddingCount) statusStack.push({
                                _level: level,
                                _override: 0,
                                _isolate: 0
                            });
                            else if (!overflowIsolateCount) overflowEmbeddingCount++;
                        } else if (charType & (TYPE_RLO | TYPE_LRO)) {
                            embedLevels[i$2] = stackTop._level; // 5.2
                            var level$1 = (charType === TYPE_RLO ? nextOdd : nextEven)(stackTop._level);
                            if (level$1 <= MAX_DEPTH && !overflowIsolateCount && !overflowEmbeddingCount) statusStack.push({
                                _level: level$1,
                                _override: charType & TYPE_RLO ? TYPE_R : TYPE_L,
                                _isolate: 0
                            });
                            else if (!overflowIsolateCount) overflowEmbeddingCount++;
                        } else if (charType & ISOLATE_INIT_TYPES) {
                            // X5c - FSI becomes either RLI or LRI
                            if (charType & TYPE_FSI) charType = determineAutoEmbedLevel(i$2 + 1, true) === 1 ? TYPE_RLI : TYPE_LRI;
                            embedLevels[i$2] = stackTop._level;
                            if (stackTop._override) changeCharType(i$2, stackTop._override);
                            var level$2 = (charType === TYPE_RLI ? nextOdd : nextEven)(stackTop._level);
                            if (level$2 <= MAX_DEPTH && overflowIsolateCount === 0 && overflowEmbeddingCount === 0) {
                                validIsolateCount++;
                                statusStack.push({
                                    _level: level$2,
                                    _override: 0,
                                    _isolate: 1,
                                    _isolInitIndex: i$2
                                });
                            } else overflowIsolateCount++;
                        } else if (charType & TYPE_PDI) {
                            if (overflowIsolateCount > 0) overflowIsolateCount--;
                            else if (validIsolateCount > 0) {
                                overflowEmbeddingCount = 0;
                                while(!statusStack[statusStack.length - 1]._isolate)statusStack.pop();
                                // Add to isolation pairs bidirectional mapping:
                                var isolInitIndex = statusStack[statusStack.length - 1]._isolInitIndex;
                                if (isolInitIndex != null) {
                                    isolationPairs.set(isolInitIndex, i$2);
                                    isolationPairs.set(i$2, isolInitIndex);
                                }
                                statusStack.pop();
                                validIsolateCount--;
                            }
                            stackTop = statusStack[statusStack.length - 1];
                            embedLevels[i$2] = stackTop._level;
                            if (stackTop._override) changeCharType(i$2, stackTop._override);
                        } else if (charType & TYPE_PDF) {
                            if (overflowIsolateCount === 0) {
                                if (overflowEmbeddingCount > 0) overflowEmbeddingCount--;
                                else if (!stackTop._isolate && statusStack.length > 1) {
                                    statusStack.pop();
                                    stackTop = statusStack[statusStack.length - 1];
                                }
                            }
                            embedLevels[i$2] = stackTop._level; // 5.2
                        } else if (charType & TYPE_B) embedLevels[i$2] = paragraph.level;
                    } else {
                        embedLevels[i$2] = stackTop._level;
                        // NOTE: This exclusion of BN seems to go against what section 5.2 says, but is required for test passage
                        if (stackTop._override && charType !== TYPE_BN) changeCharType(i$2, stackTop._override);
                    }
                }
                // === 3.3.3 Preparations for Implicit Processing ===
                // Remove all RLE, LRE, RLO, LRO, PDF, and BN characters: 3.3.3 X9
                // Note: Due to section 5.2, we won't remove them, but we'll use the BN_LIKE_TYPES bitset to
                // easily ignore them all from here on out.
                // 3.3.3 X10
                // Compute the set of isolating run sequences as specified by BD13
                var levelRuns = [];
                var currentRun = null;
                for(var i$3 = paragraph.start; i$3 <= paragraph.end; i$3++){
                    var charType$1 = charTypes[i$3];
                    if (!(charType$1 & BN_LIKE_TYPES)) {
                        var lvl = embedLevels[i$3];
                        var isIsolInit = charType$1 & ISOLATE_INIT_TYPES;
                        var isPDI = charType$1 === TYPE_PDI;
                        if (currentRun && lvl === currentRun._level) {
                            currentRun._end = i$3;
                            currentRun._endsWithIsolInit = isIsolInit;
                        } else levelRuns.push(currentRun = {
                            _start: i$3,
                            _end: i$3,
                            _level: lvl,
                            _startsWithPDI: isPDI,
                            _endsWithIsolInit: isIsolInit
                        });
                    }
                }
                var isolatingRunSeqs = []; // [{seqIndices: [], sosType: L|R, eosType: L|R}]
                for(var runIdx = 0; runIdx < levelRuns.length; runIdx++){
                    var run = levelRuns[runIdx];
                    if (!run._startsWithPDI || run._startsWithPDI && !isolationPairs.has(run._start)) {
                        var seqRuns = [
                            currentRun = run
                        ];
                        for(var pdiIndex = void 0; currentRun && currentRun._endsWithIsolInit && (pdiIndex = isolationPairs.get(currentRun._end)) != null;){
                            for(var i$4 = runIdx + 1; i$4 < levelRuns.length; i$4++)if (levelRuns[i$4]._start === pdiIndex) {
                                seqRuns.push(currentRun = levelRuns[i$4]);
                                break;
                            }
                        }
                        // build flat list of indices across all runs:
                        var seqIndices = [];
                        for(var i$5 = 0; i$5 < seqRuns.length; i$5++){
                            var run$1 = seqRuns[i$5];
                            for(var j = run$1._start; j <= run$1._end; j++)seqIndices.push(j);
                        }
                        // determine the sos/eos types:
                        var firstLevel = embedLevels[seqIndices[0]];
                        var prevLevel = paragraph.level;
                        for(var i$6 = seqIndices[0] - 1; i$6 >= 0; i$6--)if (!(charTypes[i$6] & BN_LIKE_TYPES)) {
                            prevLevel = embedLevels[i$6];
                            break;
                        }
                        var lastIndex = seqIndices[seqIndices.length - 1];
                        var lastLevel = embedLevels[lastIndex];
                        var nextLevel = paragraph.level;
                        if (!(charTypes[lastIndex] & ISOLATE_INIT_TYPES)) {
                            for(var i$7 = lastIndex + 1; i$7 <= paragraph.end; i$7++)if (!(charTypes[i$7] & BN_LIKE_TYPES)) {
                                nextLevel = embedLevels[i$7];
                                break;
                            }
                        }
                        isolatingRunSeqs.push({
                            _seqIndices: seqIndices,
                            _sosType: Math.max(prevLevel, firstLevel) % 2 ? TYPE_R : TYPE_L,
                            _eosType: Math.max(nextLevel, lastLevel) % 2 ? TYPE_R : TYPE_L
                        });
                    }
                }
                // The next steps are done per isolating run sequence
                for(var seqIdx = 0; seqIdx < isolatingRunSeqs.length; seqIdx++){
                    var ref = isolatingRunSeqs[seqIdx];
                    var seqIndices$1 = ref._seqIndices;
                    var sosType = ref._sosType;
                    var eosType = ref._eosType;
                    /**
         * All the level runs in an isolating run sequence have the same embedding level.
         * 
         * DO NOT change any `embedLevels[i]` within the current scope.
         */ var embedDirection = embedLevels[seqIndices$1[0]] & 1 ? TYPE_R : TYPE_L;
                    // === 3.3.4 Resolving Weak Types ===
                    // W1 + 5.2. Search backward from each NSM to the first character in the isolating run sequence whose
                    // bidirectional type is not BN, and set the NSM to ON if it is an isolate initiator or PDI, and to its
                    // type otherwise. If the NSM is the first non-BN character, change the NSM to the type of sos.
                    if (charTypeCounts.get(TYPE_NSM)) for(var si = 0; si < seqIndices$1.length; si++){
                        var i$8 = seqIndices$1[si];
                        if (charTypes[i$8] & TYPE_NSM) {
                            var prevType = sosType;
                            for(var sj = si - 1; sj >= 0; sj--)if (!(charTypes[seqIndices$1[sj]] & BN_LIKE_TYPES)) {
                                prevType = charTypes[seqIndices$1[sj]];
                                break;
                            }
                            changeCharType(i$8, prevType & (ISOLATE_INIT_TYPES | TYPE_PDI) ? TYPE_ON : prevType);
                        }
                    }
                    // W2. Search backward from each instance of a European number until the first strong type (R, L, AL, or sos)
                    // is found. If an AL is found, change the type of the European number to Arabic number.
                    if (charTypeCounts.get(TYPE_EN)) for(var si$1 = 0; si$1 < seqIndices$1.length; si$1++){
                        var i$9 = seqIndices$1[si$1];
                        if (charTypes[i$9] & TYPE_EN) for(var sj$1 = si$1 - 1; sj$1 >= -1; sj$1--){
                            var prevCharType = sj$1 === -1 ? sosType : charTypes[seqIndices$1[sj$1]];
                            if (prevCharType & STRONG_TYPES) {
                                if (prevCharType === TYPE_AL) changeCharType(i$9, TYPE_AN);
                                break;
                            }
                        }
                    }
                    // W3. Change all ALs to R
                    if (charTypeCounts.get(TYPE_AL)) for(var si$2 = 0; si$2 < seqIndices$1.length; si$2++){
                        var i$10 = seqIndices$1[si$2];
                        if (charTypes[i$10] & TYPE_AL) changeCharType(i$10, TYPE_R);
                    }
                    // W4. A single European separator between two European numbers changes to a European number. A single common
                    // separator between two numbers of the same type changes to that type.
                    if (charTypeCounts.get(TYPE_ES) || charTypeCounts.get(TYPE_CS)) for(var si$3 = 1; si$3 < seqIndices$1.length - 1; si$3++){
                        var i$11 = seqIndices$1[si$3];
                        if (charTypes[i$11] & (TYPE_ES | TYPE_CS)) {
                            var prevType$1 = 0, nextType = 0;
                            for(var sj$2 = si$3 - 1; sj$2 >= 0; sj$2--){
                                prevType$1 = charTypes[seqIndices$1[sj$2]];
                                if (!(prevType$1 & BN_LIKE_TYPES)) break;
                            }
                            for(var sj$3 = si$3 + 1; sj$3 < seqIndices$1.length; sj$3++){
                                nextType = charTypes[seqIndices$1[sj$3]];
                                if (!(nextType & BN_LIKE_TYPES)) break;
                            }
                            if (prevType$1 === nextType && (charTypes[i$11] === TYPE_ES ? prevType$1 === TYPE_EN : prevType$1 & (TYPE_EN | TYPE_AN))) changeCharType(i$11, prevType$1);
                        }
                    }
                    // W5. A sequence of European terminators adjacent to European numbers changes to all European numbers.
                    if (charTypeCounts.get(TYPE_EN)) for(var si$4 = 0; si$4 < seqIndices$1.length; si$4++){
                        var i$12 = seqIndices$1[si$4];
                        if (charTypes[i$12] & TYPE_EN) {
                            for(var sj$4 = si$4 - 1; sj$4 >= 0 && charTypes[seqIndices$1[sj$4]] & (TYPE_ET | BN_LIKE_TYPES); sj$4--)changeCharType(seqIndices$1[sj$4], TYPE_EN);
                            for(si$4++; si$4 < seqIndices$1.length && charTypes[seqIndices$1[si$4]] & (TYPE_ET | BN_LIKE_TYPES | TYPE_EN); si$4++)if (charTypes[seqIndices$1[si$4]] !== TYPE_EN) changeCharType(seqIndices$1[si$4], TYPE_EN);
                        }
                    }
                    // W6. Otherwise, separators and terminators change to Other Neutral.
                    if (charTypeCounts.get(TYPE_ET) || charTypeCounts.get(TYPE_ES) || charTypeCounts.get(TYPE_CS)) for(var si$5 = 0; si$5 < seqIndices$1.length; si$5++){
                        var i$13 = seqIndices$1[si$5];
                        if (charTypes[i$13] & (TYPE_ET | TYPE_ES | TYPE_CS)) {
                            changeCharType(i$13, TYPE_ON);
                            // 5.2 transform adjacent BNs too:
                            for(var sj$5 = si$5 - 1; sj$5 >= 0 && charTypes[seqIndices$1[sj$5]] & BN_LIKE_TYPES; sj$5--)changeCharType(seqIndices$1[sj$5], TYPE_ON);
                            for(var sj$6 = si$5 + 1; sj$6 < seqIndices$1.length && charTypes[seqIndices$1[sj$6]] & BN_LIKE_TYPES; sj$6++)changeCharType(seqIndices$1[sj$6], TYPE_ON);
                        }
                    }
                    // W7. Search backward from each instance of a European number until the first strong type (R, L, or sos)
                    // is found. If an L is found, then change the type of the European number to L.
                    // NOTE: implemented in single forward pass for efficiency
                    if (charTypeCounts.get(TYPE_EN)) for(var si$6 = 0, prevStrongType = sosType; si$6 < seqIndices$1.length; si$6++){
                        var i$14 = seqIndices$1[si$6];
                        var type = charTypes[i$14];
                        if (type & TYPE_EN) {
                            if (prevStrongType === TYPE_L) changeCharType(i$14, TYPE_L);
                        } else if (type & STRONG_TYPES) prevStrongType = type;
                    }
                    // === 3.3.5 Resolving Neutral and Isolate Formatting Types ===
                    if (charTypeCounts.get(NEUTRAL_ISOLATE_TYPES)) {
                        // N0. Process bracket pairs in an isolating run sequence sequentially in the logical order of the text
                        // positions of the opening paired brackets using the logic given below. Within this scope, bidirectional
                        // types EN and AN are treated as R.
                        var R_TYPES_FOR_N_STEPS = TYPE_R | TYPE_EN | TYPE_AN;
                        var STRONG_TYPES_FOR_N_STEPS = R_TYPES_FOR_N_STEPS | TYPE_L;
                        // * Identify the bracket pairs in the current isolating run sequence according to BD16.
                        var bracketPairs = [];
                        var openerStack = [];
                        for(var si$7 = 0; si$7 < seqIndices$1.length; si$7++)// NOTE: for any potential bracket character we also test that it still carries a NI
                        // type, as that may have been changed earlier. This doesn't seem to be explicitly
                        // called out in the spec, but is required for passage of certain tests.
                        if (charTypes[seqIndices$1[si$7]] & NEUTRAL_ISOLATE_TYPES) {
                            var char = string[seqIndices$1[si$7]];
                            var oppositeBracket = void 0;
                            // Opening bracket
                            if (openingToClosingBracket(char) !== null) {
                                if (openerStack.length < 63) openerStack.push({
                                    char: char,
                                    seqIndex: si$7
                                });
                                else break;
                            } else if ((oppositeBracket = closingToOpeningBracket(char)) !== null) for(var stackIdx = openerStack.length - 1; stackIdx >= 0; stackIdx--){
                                var stackChar = openerStack[stackIdx].char;
                                if (stackChar === oppositeBracket || stackChar === closingToOpeningBracket(getCanonicalBracket(char)) || openingToClosingBracket(getCanonicalBracket(stackChar)) === char) {
                                    bracketPairs.push([
                                        openerStack[stackIdx].seqIndex,
                                        si$7
                                    ]);
                                    openerStack.length = stackIdx; //pop the matching bracket and all following
                                    break;
                                }
                            }
                        }
                        bracketPairs.sort(function(a, b) {
                            return a[0] - b[0];
                        });
                        // * For each bracket-pair element in the list of pairs of text positions
                        for(var pairIdx = 0; pairIdx < bracketPairs.length; pairIdx++){
                            var ref$1 = bracketPairs[pairIdx];
                            var openSeqIdx = ref$1[0];
                            var closeSeqIdx = ref$1[1];
                            // a. Inspect the bidirectional types of the characters enclosed within the bracket pair.
                            // b. If any strong type (either L or R) matching the embedding direction is found, set the type for both
                            // brackets in the pair to match the embedding direction.
                            var foundStrongType = false;
                            var useStrongType = 0;
                            for(var si$8 = openSeqIdx + 1; si$8 < closeSeqIdx; si$8++){
                                var i$15 = seqIndices$1[si$8];
                                if (charTypes[i$15] & STRONG_TYPES_FOR_N_STEPS) {
                                    foundStrongType = true;
                                    var lr = charTypes[i$15] & R_TYPES_FOR_N_STEPS ? TYPE_R : TYPE_L;
                                    if (lr === embedDirection) {
                                        useStrongType = lr;
                                        break;
                                    }
                                }
                            }
                            // c. Otherwise, if there is a strong type it must be opposite the embedding direction. Therefore, test
                            // for an established context with a preceding strong type by checking backwards before the opening paired
                            // bracket until the first strong type (L, R, or sos) is found.
                            //    1. If the preceding strong type is also opposite the embedding direction, context is established, so
                            //    set the type for both brackets in the pair to that direction.
                            //    2. Otherwise set the type for both brackets in the pair to the embedding direction.
                            if (foundStrongType && !useStrongType) {
                                useStrongType = sosType;
                                for(var si$9 = openSeqIdx - 1; si$9 >= 0; si$9--){
                                    var i$16 = seqIndices$1[si$9];
                                    if (charTypes[i$16] & STRONG_TYPES_FOR_N_STEPS) {
                                        var lr$1 = charTypes[i$16] & R_TYPES_FOR_N_STEPS ? TYPE_R : TYPE_L;
                                        if (lr$1 !== embedDirection) useStrongType = lr$1;
                                        else useStrongType = embedDirection;
                                        break;
                                    }
                                }
                            }
                            if (useStrongType) {
                                charTypes[seqIndices$1[openSeqIdx]] = charTypes[seqIndices$1[closeSeqIdx]] = useStrongType;
                                // * Any number of characters that had original bidirectional character type NSM prior to the application
                                // of W1 that immediately follow a paired bracket which changed to L or R under N0 should change to match
                                // the type of their preceding bracket.
                                if (useStrongType !== embedDirection) {
                                    for(var si$10 = openSeqIdx + 1; si$10 < seqIndices$1.length; si$10++)if (!(charTypes[seqIndices$1[si$10]] & BN_LIKE_TYPES)) {
                                        if (getBidiCharType(string[seqIndices$1[si$10]]) & TYPE_NSM) charTypes[seqIndices$1[si$10]] = useStrongType;
                                        break;
                                    }
                                }
                                if (useStrongType !== embedDirection) {
                                    for(var si$11 = closeSeqIdx + 1; si$11 < seqIndices$1.length; si$11++)if (!(charTypes[seqIndices$1[si$11]] & BN_LIKE_TYPES)) {
                                        if (getBidiCharType(string[seqIndices$1[si$11]]) & TYPE_NSM) charTypes[seqIndices$1[si$11]] = useStrongType;
                                        break;
                                    }
                                }
                            }
                        }
                        // N1. A sequence of NIs takes the direction of the surrounding strong text if the text on both sides has the
                        // same direction.
                        // N2. Any remaining NIs take the embedding direction.
                        for(var si$12 = 0; si$12 < seqIndices$1.length; si$12++)if (charTypes[seqIndices$1[si$12]] & NEUTRAL_ISOLATE_TYPES) {
                            var niRunStart = si$12, niRunEnd = si$12;
                            var prevType$2 = sosType; //si === 0 ? sosType : (charTypes[seqIndices[si - 1]] & R_TYPES_FOR_N_STEPS) ? TYPE_R : TYPE_L
                            for(var si2 = si$12 - 1; si2 >= 0; si2--)if (charTypes[seqIndices$1[si2]] & BN_LIKE_TYPES) niRunStart = si2; //5.2 treat BNs adjacent to NIs as NIs
                            else {
                                prevType$2 = charTypes[seqIndices$1[si2]] & R_TYPES_FOR_N_STEPS ? TYPE_R : TYPE_L;
                                break;
                            }
                            var nextType$1 = eosType;
                            for(var si2$1 = si$12 + 1; si2$1 < seqIndices$1.length; si2$1++)if (charTypes[seqIndices$1[si2$1]] & (NEUTRAL_ISOLATE_TYPES | BN_LIKE_TYPES)) niRunEnd = si2$1;
                            else {
                                nextType$1 = charTypes[seqIndices$1[si2$1]] & R_TYPES_FOR_N_STEPS ? TYPE_R : TYPE_L;
                                break;
                            }
                            for(var sj$7 = niRunStart; sj$7 <= niRunEnd; sj$7++)charTypes[seqIndices$1[sj$7]] = prevType$2 === nextType$1 ? prevType$2 : embedDirection;
                            si$12 = niRunEnd;
                        }
                    }
                }
                // === 3.3.6 Resolving Implicit Levels ===
                for(var i$17 = paragraph.start; i$17 <= paragraph.end; i$17++){
                    var level$3 = embedLevels[i$17];
                    var type$1 = charTypes[i$17];
                    // I2. For all characters with an odd (right-to-left) embedding level, those of type L, EN or AN go up one level.
                    if (level$3 & 1) {
                        if (type$1 & (TYPE_L | TYPE_EN | TYPE_AN)) embedLevels[i$17]++;
                    } else {
                        if (type$1 & TYPE_R) embedLevels[i$17]++;
                        else if (type$1 & (TYPE_AN | TYPE_EN)) embedLevels[i$17] += 2;
                    }
                    // 5.2: Resolve any LRE, RLE, LRO, RLO, PDF, or BN to the level of the preceding character if there is one,
                    // and otherwise to the base level.
                    if (type$1 & BN_LIKE_TYPES) embedLevels[i$17] = i$17 === 0 ? paragraph.level : embedLevels[i$17 - 1];
                    // 3.4 L1.1-4: Reset the embedding level of segment/paragraph separators, and any sequence of whitespace or
                    // isolate formatting characters preceding them or the end of the paragraph, to the paragraph level.
                    // NOTE: this will also need to be applied to each individual line ending after line wrapping occurs.
                    if (i$17 === paragraph.end || getBidiCharType(string[i$17]) & (TYPE_S | TYPE_B)) for(var j$1 = i$17; j$1 >= 0 && getBidiCharType(string[j$1]) & TRAILING_TYPES; j$1--)embedLevels[j$1] = paragraph.level;
                }
            }
            // DONE! The resolved levels can then be used, after line wrapping, to flip runs of characters
            // according to section 3.4 Reordering Resolved Levels
            return {
                levels: embedLevels,
                paragraphs: paragraphs
            };
            function determineAutoEmbedLevel(start, isFSI) {
                // 3.3.1 P2 - P3
                for(var i = start; i < string.length; i++){
                    var charType = charTypes[i];
                    if (charType & (TYPE_R | TYPE_AL)) return 1;
                    if (charType & (TYPE_B | TYPE_L) || isFSI && charType === TYPE_PDI) return 0;
                    if (charType & ISOLATE_INIT_TYPES) {
                        var pdi = indexOfMatchingPDI(i);
                        i = pdi === -1 ? string.length : pdi;
                    }
                }
                return 0;
            }
            function indexOfMatchingPDI(isolateStart) {
                // 3.1.2 BD9
                var isolationLevel = 1;
                for(var i = isolateStart + 1; i < string.length; i++){
                    var charType = charTypes[i];
                    if (charType & TYPE_B) break;
                    if (charType & TYPE_PDI) {
                        if (--isolationLevel === 0) return i;
                    } else if (charType & ISOLATE_INIT_TYPES) isolationLevel++;
                }
                return -1;
            }
        }
        // Bidi mirrored chars data, auto generated
        var data = "14>1,j>2,t>2,u>2,1a>g,2v3>1,1>1,1ge>1,1wd>1,b>1,1j>1,f>1,ai>3,-2>3,+1,8>1k0,-1jq>1y7,-1y6>1hf,-1he>1h6,-1h5>1ha,-1h8>1qi,-1pu>1,6>3u,-3s>7,6>1,1>1,f>1,1>1,+2,3>1,1>1,+13,4>1,1>1,6>1eo,-1ee>1,3>1mg,-1me>1mk,-1mj>1mi,-1mg>1mi,-1md>1,1>1,+2,1>10k,-103>1,1>1,4>1,5>1,1>1,+10,3>1,1>8,-7>8,+1,-6>7,+1,a>1,1>1,u>1,u6>1,1>1,+5,26>1,1>1,2>1,2>2,8>1,7>1,4>1,1>1,+5,b8>1,1>1,+3,1>3,-2>1,2>1,1>1,+2,c>1,3>1,1>1,+2,h>1,3>1,a>1,1>1,2>1,3>1,1>1,d>1,f>1,3>1,1a>1,1>1,6>1,7>1,13>1,k>1,1>1,+19,4>1,1>1,+2,2>1,1>1,+18,m>1,a>1,1>1,lk>1,1>1,4>1,2>1,f>1,3>1,1>1,+3,db>1,1>1,+3,3>1,1>1,+2,14qm>1,1>1,+1,6>1,4j>1,j>2,t>2,u>2,2>1,+1";
        var mirrorMap;
        function parse() {
            if (!mirrorMap) {
                //const start = performance.now()
                var ref = parseCharacterMap(data, true);
                var map = ref.map;
                var reverseMap = ref.reverseMap;
                // Combine both maps into one
                reverseMap.forEach(function(value, key) {
                    map.set(key, value);
                });
                mirrorMap = map;
            //console.log(`mirrored chars parsed in ${performance.now() - start}ms`)
            }
        }
        function getMirroredCharacter(char) {
            parse();
            return mirrorMap.get(char) || null;
        }
        /**
   * Given a string and its resolved embedding levels, build a map of indices to replacement chars
   * for any characters in right-to-left segments that have defined mirrored characters.
   * @param string
   * @param embeddingLevels
   * @param [start]
   * @param [end]
   * @return {Map<number, string>}
   */ function getMirroredCharactersMap(string, embeddingLevels, start, end) {
            var strLen = string.length;
            start = Math.max(0, start == null ? 0 : +start);
            end = Math.min(strLen - 1, end == null ? strLen - 1 : +end);
            var map = new Map();
            for(var i = start; i <= end; i++)if (embeddingLevels[i] & 1) {
                var mirror = getMirroredCharacter(string[i]);
                if (mirror !== null) map.set(i, mirror);
            }
            return map;
        }
        /**
   * Given a start and end denoting a single line within a string, and a set of precalculated
   * bidi embedding levels, produce a list of segments whose ordering should be flipped, in sequence.
   * @param {string} string - the full input string
   * @param {GetEmbeddingLevelsResult} embeddingLevelsResult - the result object from getEmbeddingLevels
   * @param {number} [start] - first character in a subset of the full string
   * @param {number} [end] - last character in a subset of the full string
   * @return {number[][]} - the list of start/end segments that should be flipped, in order.
   */ function getReorderSegments(string, embeddingLevelsResult, start, end) {
            var strLen = string.length;
            start = Math.max(0, start == null ? 0 : +start);
            end = Math.min(strLen - 1, end == null ? strLen - 1 : +end);
            var segments = [];
            embeddingLevelsResult.paragraphs.forEach(function(paragraph) {
                var lineStart = Math.max(start, paragraph.start);
                var lineEnd = Math.min(end, paragraph.end);
                if (lineStart < lineEnd) {
                    // Local slice for mutation
                    var lineLevels = embeddingLevelsResult.levels.slice(lineStart, lineEnd + 1);
                    // 3.4 L1.4: Reset any sequence of whitespace characters and/or isolate formatting characters at the
                    // end of the line to the paragraph level.
                    for(var i = lineEnd; i >= lineStart && getBidiCharType(string[i]) & TRAILING_TYPES; i--)lineLevels[i] = paragraph.level;
                    // L2. From the highest level found in the text to the lowest odd level on each line, including intermediate levels
                    // not actually present in the text, reverse any contiguous sequence of characters that are at that level or higher.
                    var maxLevel = paragraph.level;
                    var minOddLevel = Infinity;
                    for(var i$1 = 0; i$1 < lineLevels.length; i$1++){
                        var level = lineLevels[i$1];
                        if (level > maxLevel) maxLevel = level;
                        if (level < minOddLevel) minOddLevel = level | 1;
                    }
                    for(var lvl = maxLevel; lvl >= minOddLevel; lvl--){
                        for(var i$2 = 0; i$2 < lineLevels.length; i$2++)if (lineLevels[i$2] >= lvl) {
                            var segStart = i$2;
                            while(i$2 + 1 < lineLevels.length && lineLevels[i$2 + 1] >= lvl)i$2++;
                            if (i$2 > segStart) segments.push([
                                segStart + lineStart,
                                i$2 + lineStart
                            ]);
                        }
                    }
                }
            });
            return segments;
        }
        /**
   * @param {string} string
   * @param {GetEmbeddingLevelsResult} embedLevelsResult
   * @param {number} [start]
   * @param {number} [end]
   * @return {string} the new string with bidi segments reordered
   */ function getReorderedString(string, embedLevelsResult, start, end) {
            var indices = getReorderedIndices(string, embedLevelsResult, start, end);
            var chars = [].concat(string);
            indices.forEach(function(charIndex, i) {
                chars[i] = (embedLevelsResult.levels[charIndex] & 1 ? getMirroredCharacter(string[charIndex]) : null) || string[charIndex];
            });
            return chars.join("");
        }
        /**
   * @param {string} string
   * @param {GetEmbeddingLevelsResult} embedLevelsResult
   * @param {number} [start]
   * @param {number} [end]
   * @return {number[]} an array with character indices in their new bidi order
   */ function getReorderedIndices(string, embedLevelsResult, start, end) {
            var segments = getReorderSegments(string, embedLevelsResult, start, end);
            // Fill an array with indices
            var indices = [];
            for(var i = 0; i < string.length; i++)indices[i] = i;
            // Reverse each segment in order
            segments.forEach(function(ref) {
                var start = ref[0];
                var end = ref[1];
                var slice = indices.slice(start, end + 1);
                for(var i = slice.length; i--;)indices[end - i] = slice[i];
            });
            return indices;
        }
        exports.closingToOpeningBracket = closingToOpeningBracket;
        exports.getBidiCharType = getBidiCharType;
        exports.getBidiCharTypeName = getBidiCharTypeName;
        exports.getCanonicalBracket = getCanonicalBracket;
        exports.getEmbeddingLevels = getEmbeddingLevels;
        exports.getMirroredCharacter = getMirroredCharacter;
        exports.getMirroredCharactersMap = getMirroredCharactersMap;
        exports.getReorderSegments = getReorderSegments;
        exports.getReorderedIndices = getReorderedIndices;
        exports.getReorderedString = getReorderedString;
        exports.openingToClosingBracket = openingToClosingBracket;
        Object.defineProperty(exports, "__esModule", {
            value: true
        });
        return exports;
    }({});
    return bidi;
}
var $65b2b49b50a4e8ff$export$2e2bcd8739ae039 = $65b2b49b50a4e8ff$var$bidiFactory;



/*!
Custom build of Typr.ts (https://github.com/fredli74/Typr.ts) for use in Troika text rendering.
Original MIT license applies: https://github.com/fredli74/Typr.ts/blob/master/LICENSE
*/ function $55f5ea5649168877$var$typrFactory() {
    return "undefined" == typeof window && (self.window = self), function(r) {
        var e = {
            parse: function(r) {
                var t = e._bin, a = new Uint8Array(r);
                if ("ttcf" == t.readASCII(a, 0, 4)) {
                    var n = 4;
                    t.readUshort(a, n), n += 2, t.readUshort(a, n), n += 2;
                    var o = t.readUint(a, n);
                    n += 4;
                    for(var s = [], i = 0; i < o; i++){
                        var h = t.readUint(a, n);
                        n += 4, s.push(e._readFont(a, h));
                    }
                    return s;
                }
                return [
                    e._readFont(a, 0)
                ];
            },
            _readFont: function(r, t) {
                var a = e._bin, n = t;
                a.readFixed(r, t), t += 4;
                var o = a.readUshort(r, t);
                t += 2, a.readUshort(r, t), t += 2, a.readUshort(r, t), t += 2, a.readUshort(r, t), t += 2;
                for(var s = [
                    "cmap",
                    "head",
                    "hhea",
                    "maxp",
                    "hmtx",
                    "name",
                    "OS/2",
                    "post",
                    "loca",
                    "glyf",
                    "kern",
                    "CFF ",
                    "GPOS",
                    "GSUB",
                    "SVG "
                ], i = {
                    _data: r,
                    _offset: n
                }, h = {}, f = 0; f < o; f++){
                    var d = a.readASCII(r, t, 4);
                    t += 4, a.readUint(r, t), t += 4;
                    var u = a.readUint(r, t);
                    t += 4;
                    var l = a.readUint(r, t);
                    t += 4, h[d] = {
                        offset: u,
                        length: l
                    };
                }
                for(f = 0; f < s.length; f++){
                    var v = s[f];
                    h[v] && (i[v.trim()] = e[v.trim()].parse(r, h[v].offset, h[v].length, i));
                }
                return i;
            },
            _tabOffset: function(r, t, a) {
                for(var n = e._bin, o = n.readUshort(r, a + 4), s = a + 12, i = 0; i < o; i++){
                    var h = n.readASCII(r, s, 4);
                    s += 4, n.readUint(r, s), s += 4;
                    var f = n.readUint(r, s);
                    if (s += 4, n.readUint(r, s), s += 4, h == t) return f;
                }
                return 0;
            }
        };
        e._bin = {
            readFixed: function(r, e) {
                return (r[e] << 8 | r[e + 1]) + (r[e + 2] << 8 | r[e + 3]) / 65540;
            },
            readF2dot14: function(r, t) {
                return e._bin.readShort(r, t) / 16384;
            },
            readInt: function(r, t) {
                return e._bin._view(r).getInt32(t);
            },
            readInt8: function(r, t) {
                return e._bin._view(r).getInt8(t);
            },
            readShort: function(r, t) {
                return e._bin._view(r).getInt16(t);
            },
            readUshort: function(r, t) {
                return e._bin._view(r).getUint16(t);
            },
            readUshorts: function(r, t, a) {
                for(var n = [], o = 0; o < a; o++)n.push(e._bin.readUshort(r, t + 2 * o));
                return n;
            },
            readUint: function(r, t) {
                return e._bin._view(r).getUint32(t);
            },
            readUint64: function(r, t) {
                return 4294967296 * e._bin.readUint(r, t) + e._bin.readUint(r, t + 4);
            },
            readASCII: function(r, e, t) {
                for(var a = "", n = 0; n < t; n++)a += String.fromCharCode(r[e + n]);
                return a;
            },
            readUnicode: function(r, e, t) {
                for(var a = "", n = 0; n < t; n++){
                    var o = r[e++] << 8 | r[e++];
                    a += String.fromCharCode(o);
                }
                return a;
            },
            _tdec: "undefined" != typeof window && window.TextDecoder ? new window.TextDecoder : null,
            readUTF8: function(r, t, a) {
                var n = e._bin._tdec;
                return n && 0 == t && a == r.length ? n.decode(r) : e._bin.readASCII(r, t, a);
            },
            readBytes: function(r, e, t) {
                for(var a = [], n = 0; n < t; n++)a.push(r[e + n]);
                return a;
            },
            readASCIIArray: function(r, e, t) {
                for(var a = [], n = 0; n < t; n++)a.push(String.fromCharCode(r[e + n]));
                return a;
            },
            _view: function(r) {
                return r._dataView || (r._dataView = r.buffer ? new DataView(r.buffer, r.byteOffset, r.byteLength) : new DataView(new Uint8Array(r).buffer));
            }
        }, e._lctf = {}, e._lctf.parse = function(r, t, a, n, o) {
            var s = e._bin, i = {}, h = t;
            s.readFixed(r, t), t += 4;
            var f = s.readUshort(r, t);
            t += 2;
            var d = s.readUshort(r, t);
            t += 2;
            var u = s.readUshort(r, t);
            return t += 2, i.scriptList = e._lctf.readScriptList(r, h + f), i.featureList = e._lctf.readFeatureList(r, h + d), i.lookupList = e._lctf.readLookupList(r, h + u, o), i;
        }, e._lctf.readLookupList = function(r, t, a) {
            var n = e._bin, o = t, s = [], i = n.readUshort(r, t);
            t += 2;
            for(var h = 0; h < i; h++){
                var f = n.readUshort(r, t);
                t += 2;
                var d = e._lctf.readLookupTable(r, o + f, a);
                s.push(d);
            }
            return s;
        }, e._lctf.readLookupTable = function(r, t, a) {
            var n = e._bin, o = t, s = {
                tabs: []
            };
            s.ltype = n.readUshort(r, t), t += 2, s.flag = n.readUshort(r, t), t += 2;
            var i = n.readUshort(r, t);
            t += 2;
            for(var h = s.ltype, f = 0; f < i; f++){
                var d = n.readUshort(r, t);
                t += 2;
                var u = a(r, h, o + d, s);
                s.tabs.push(u);
            }
            return s;
        }, e._lctf.numOfOnes = function(r) {
            for(var e = 0, t = 0; t < 32; t++)0 != (r >>> t & 1) && e++;
            return e;
        }, e._lctf.readClassDef = function(r, t) {
            var a = e._bin, n = [], o = a.readUshort(r, t);
            if (t += 2, 1 == o) {
                var s = a.readUshort(r, t);
                t += 2;
                var i = a.readUshort(r, t);
                t += 2;
                for(var h = 0; h < i; h++)n.push(s + h), n.push(s + h), n.push(a.readUshort(r, t)), t += 2;
            }
            if (2 == o) {
                var f = a.readUshort(r, t);
                t += 2;
                for(h = 0; h < f; h++)n.push(a.readUshort(r, t)), t += 2, n.push(a.readUshort(r, t)), t += 2, n.push(a.readUshort(r, t)), t += 2;
            }
            return n;
        }, e._lctf.getInterval = function(r, e) {
            for(var t = 0; t < r.length; t += 3){
                var a = r[t], n = r[t + 1];
                if (r[t + 2], a <= e && e <= n) return t;
            }
            return -1;
        }, e._lctf.readCoverage = function(r, t) {
            var a = e._bin, n = {};
            n.fmt = a.readUshort(r, t), t += 2;
            var o = a.readUshort(r, t);
            return t += 2, 1 == n.fmt && (n.tab = a.readUshorts(r, t, o)), 2 == n.fmt && (n.tab = a.readUshorts(r, t, 3 * o)), n;
        }, e._lctf.coverageIndex = function(r, t) {
            var a = r.tab;
            if (1 == r.fmt) return a.indexOf(t);
            if (2 == r.fmt) {
                var n = e._lctf.getInterval(a, t);
                if (-1 != n) return a[n + 2] + (t - a[n]);
            }
            return -1;
        }, e._lctf.readFeatureList = function(r, t) {
            var a = e._bin, n = t, o = [], s = a.readUshort(r, t);
            t += 2;
            for(var i = 0; i < s; i++){
                var h = a.readASCII(r, t, 4);
                t += 4;
                var f = a.readUshort(r, t);
                t += 2;
                var d = e._lctf.readFeatureTable(r, n + f);
                d.tag = h.trim(), o.push(d);
            }
            return o;
        }, e._lctf.readFeatureTable = function(r, t) {
            var a = e._bin, n = t, o = {}, s = a.readUshort(r, t);
            t += 2, s > 0 && (o.featureParams = n + s);
            var i = a.readUshort(r, t);
            t += 2, o.tab = [];
            for(var h = 0; h < i; h++)o.tab.push(a.readUshort(r, t + 2 * h));
            return o;
        }, e._lctf.readScriptList = function(r, t) {
            var a = e._bin, n = t, o = {}, s = a.readUshort(r, t);
            t += 2;
            for(var i = 0; i < s; i++){
                var h = a.readASCII(r, t, 4);
                t += 4;
                var f = a.readUshort(r, t);
                t += 2, o[h.trim()] = e._lctf.readScriptTable(r, n + f);
            }
            return o;
        }, e._lctf.readScriptTable = function(r, t) {
            var a = e._bin, n = t, o = {}, s = a.readUshort(r, t);
            t += 2, s > 0 && (o.default = e._lctf.readLangSysTable(r, n + s));
            var i = a.readUshort(r, t);
            t += 2;
            for(var h = 0; h < i; h++){
                var f = a.readASCII(r, t, 4);
                t += 4;
                var d = a.readUshort(r, t);
                t += 2, o[f.trim()] = e._lctf.readLangSysTable(r, n + d);
            }
            return o;
        }, e._lctf.readLangSysTable = function(r, t) {
            var a = e._bin, n = {};
            a.readUshort(r, t), t += 2, n.reqFeature = a.readUshort(r, t), t += 2;
            var o = a.readUshort(r, t);
            return t += 2, n.features = a.readUshorts(r, t, o), n;
        }, e.CFF = {}, e.CFF.parse = function(r, t, a) {
            var n = e._bin;
            (r = new Uint8Array(r.buffer, t, a))[t = 0], r[++t], r[++t], r[++t], t++;
            var o = [];
            t = e.CFF.readIndex(r, t, o);
            for(var s = [], i = 0; i < o.length - 1; i++)s.push(n.readASCII(r, t + o[i], o[i + 1] - o[i]));
            t += o[o.length - 1];
            var h = [];
            t = e.CFF.readIndex(r, t, h);
            var f = [];
            for(i = 0; i < h.length - 1; i++)f.push(e.CFF.readDict(r, t + h[i], t + h[i + 1]));
            t += h[h.length - 1];
            var d = f[0], u = [];
            t = e.CFF.readIndex(r, t, u);
            var l = [];
            for(i = 0; i < u.length - 1; i++)l.push(n.readASCII(r, t + u[i], u[i + 1] - u[i]));
            if (t += u[u.length - 1], e.CFF.readSubrs(r, t, d), d.CharStrings) {
                t = d.CharStrings;
                u = [];
                t = e.CFF.readIndex(r, t, u);
                var v = [];
                for(i = 0; i < u.length - 1; i++)v.push(n.readBytes(r, t + u[i], u[i + 1] - u[i]));
                d.CharStrings = v;
            }
            if (d.ROS) {
                t = d.FDArray;
                var c = [];
                t = e.CFF.readIndex(r, t, c), d.FDArray = [];
                for(i = 0; i < c.length - 1; i++){
                    var p = e.CFF.readDict(r, t + c[i], t + c[i + 1]);
                    e.CFF._readFDict(r, p, l), d.FDArray.push(p);
                }
                t += c[c.length - 1], t = d.FDSelect, d.FDSelect = [];
                var U = r[t];
                if (t++, 3 != U) throw U;
                var g = n.readUshort(r, t);
                t += 2;
                for(i = 0; i < g + 1; i++)d.FDSelect.push(n.readUshort(r, t), r[t + 2]), t += 3;
            }
            return d.Encoding && (d.Encoding = e.CFF.readEncoding(r, d.Encoding, d.CharStrings.length)), d.charset && (d.charset = e.CFF.readCharset(r, d.charset, d.CharStrings.length)), e.CFF._readFDict(r, d, l), d;
        }, e.CFF._readFDict = function(r, t, a) {
            var n;
            for(var o in t.Private && (n = t.Private[1], t.Private = e.CFF.readDict(r, n, n + t.Private[0]), t.Private.Subrs && e.CFF.readSubrs(r, n + t.Private.Subrs, t.Private)), t)-1 != [
                "FamilyName",
                "FontName",
                "FullName",
                "Notice",
                "version",
                "Copyright"
            ].indexOf(o) && (t[o] = a[t[o] - 426 + 35]);
        }, e.CFF.readSubrs = function(r, t, a) {
            var n = e._bin, o = [];
            t = e.CFF.readIndex(r, t, o);
            var s, i = o.length;
            s = i < 1240 ? 107 : i < 33900 ? 1131 : 32768, a.Bias = s, a.Subrs = [];
            for(var h = 0; h < o.length - 1; h++)a.Subrs.push(n.readBytes(r, t + o[h], o[h + 1] - o[h]));
        }, e.CFF.tableSE = [
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            1,
            2,
            3,
            4,
            5,
            6,
            7,
            8,
            9,
            10,
            11,
            12,
            13,
            14,
            15,
            16,
            17,
            18,
            19,
            20,
            21,
            22,
            23,
            24,
            25,
            26,
            27,
            28,
            29,
            30,
            31,
            32,
            33,
            34,
            35,
            36,
            37,
            38,
            39,
            40,
            41,
            42,
            43,
            44,
            45,
            46,
            47,
            48,
            49,
            50,
            51,
            52,
            53,
            54,
            55,
            56,
            57,
            58,
            59,
            60,
            61,
            62,
            63,
            64,
            65,
            66,
            67,
            68,
            69,
            70,
            71,
            72,
            73,
            74,
            75,
            76,
            77,
            78,
            79,
            80,
            81,
            82,
            83,
            84,
            85,
            86,
            87,
            88,
            89,
            90,
            91,
            92,
            93,
            94,
            95,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            96,
            97,
            98,
            99,
            100,
            101,
            102,
            103,
            104,
            105,
            106,
            107,
            108,
            109,
            110,
            0,
            111,
            112,
            113,
            114,
            0,
            115,
            116,
            117,
            118,
            119,
            120,
            121,
            122,
            0,
            123,
            0,
            124,
            125,
            126,
            127,
            128,
            129,
            130,
            131,
            0,
            132,
            133,
            0,
            134,
            135,
            136,
            137,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            138,
            0,
            139,
            0,
            0,
            0,
            0,
            140,
            141,
            142,
            143,
            0,
            0,
            0,
            0,
            0,
            144,
            0,
            0,
            0,
            145,
            0,
            0,
            146,
            147,
            148,
            149,
            0,
            0,
            0,
            0
        ], e.CFF.glyphByUnicode = function(r, e) {
            for(var t = 0; t < r.charset.length; t++)if (r.charset[t] == e) return t;
            return -1;
        }, e.CFF.glyphBySE = function(r, t) {
            return t < 0 || t > 255 ? -1 : e.CFF.glyphByUnicode(r, e.CFF.tableSE[t]);
        }, e.CFF.readEncoding = function(r, t, a) {
            e._bin;
            var n = [
                ".notdef"
            ], o = r[t];
            if (t++, 0 != o) throw "error: unknown encoding format: " + o;
            var s = r[t];
            t++;
            for(var i = 0; i < s; i++)n.push(r[t + i]);
            return n;
        }, e.CFF.readCharset = function(r, t, a) {
            var n = e._bin, o = [
                ".notdef"
            ], s = r[t];
            if (t++, 0 == s) for(var i = 0; i < a; i++){
                var h = n.readUshort(r, t);
                t += 2, o.push(h);
            }
            else {
                if (1 != s && 2 != s) throw "error: format: " + s;
                for(; o.length < a;){
                    h = n.readUshort(r, t);
                    t += 2;
                    var f = 0;
                    1 == s ? (f = r[t], t++) : (f = n.readUshort(r, t), t += 2);
                    for(i = 0; i <= f; i++)o.push(h), h++;
                }
            }
            return o;
        }, e.CFF.readIndex = function(r, t, a) {
            var n = e._bin, o = n.readUshort(r, t) + 1, s = r[t += 2];
            if (t++, 1 == s) for(var i = 0; i < o; i++)a.push(r[t + i]);
            else if (2 == s) for(i = 0; i < o; i++)a.push(n.readUshort(r, t + 2 * i));
            else if (3 == s) for(i = 0; i < o; i++)a.push(16777215 & n.readUint(r, t + 3 * i - 1));
            else if (1 != o) throw "unsupported offset size: " + s + ", count: " + o;
            return (t += o * s) - 1;
        }, e.CFF.getCharString = function(r, t, a) {
            var n = e._bin, o = r[t], s = r[t + 1];
            r[t + 2], r[t + 3], r[t + 4];
            var i = 1, h = null, f = null;
            o <= 20 && (h = o, i = 1), 12 == o && (h = 100 * o + s, i = 2), 21 <= o && o <= 27 && (h = o, i = 1), 28 == o && (f = n.readShort(r, t + 1), i = 3), 29 <= o && o <= 31 && (h = o, i = 1), 32 <= o && o <= 246 && (f = o - 139, i = 1), 247 <= o && o <= 250 && (f = 256 * (o - 247) + s + 108, i = 2), 251 <= o && o <= 254 && (f = 256 * -(o - 251) - s - 108, i = 2), 255 == o && (f = n.readInt(r, t + 1) / 65535, i = 5), a.val = null != f ? f : "o" + h, a.size = i;
        }, e.CFF.readCharString = function(r, t, a) {
            for(var n = t + a, o = e._bin, s = []; t < n;){
                var i = r[t], h = r[t + 1];
                r[t + 2], r[t + 3], r[t + 4];
                var f = 1, d = null, u = null;
                i <= 20 && (d = i, f = 1), 12 == i && (d = 100 * i + h, f = 2), 19 != i && 20 != i || (d = i, f = 2), 21 <= i && i <= 27 && (d = i, f = 1), 28 == i && (u = o.readShort(r, t + 1), f = 3), 29 <= i && i <= 31 && (d = i, f = 1), 32 <= i && i <= 246 && (u = i - 139, f = 1), 247 <= i && i <= 250 && (u = 256 * (i - 247) + h + 108, f = 2), 251 <= i && i <= 254 && (u = 256 * -(i - 251) - h - 108, f = 2), 255 == i && (u = o.readInt(r, t + 1) / 65535, f = 5), s.push(null != u ? u : "o" + d), t += f;
            }
            return s;
        }, e.CFF.readDict = function(r, t, a) {
            for(var n = e._bin, o = {}, s = []; t < a;){
                var i = r[t], h = r[t + 1];
                r[t + 2], r[t + 3], r[t + 4];
                var f = 1, d = null, u = null;
                if (28 == i && (u = n.readShort(r, t + 1), f = 3), 29 == i && (u = n.readInt(r, t + 1), f = 5), 32 <= i && i <= 246 && (u = i - 139, f = 1), 247 <= i && i <= 250 && (u = 256 * (i - 247) + h + 108, f = 2), 251 <= i && i <= 254 && (u = 256 * -(i - 251) - h - 108, f = 2), 255 == i) throw u = n.readInt(r, t + 1) / 65535, f = 5, "unknown number";
                if (30 == i) {
                    var l = [];
                    for(f = 1;;){
                        var v = r[t + f];
                        f++;
                        var c = v >> 4, p = 15 & v;
                        if (15 != c && l.push(c), 15 != p && l.push(p), 15 == p) break;
                    }
                    for(var U = "", g = [
                        0,
                        1,
                        2,
                        3,
                        4,
                        5,
                        6,
                        7,
                        8,
                        9,
                        ".",
                        "e",
                        "e-",
                        "reserved",
                        "-",
                        "endOfNumber"
                    ], S = 0; S < l.length; S++)U += g[l[S]];
                    u = parseFloat(U);
                }
                if (i <= 21) {
                    if (d = [
                        "version",
                        "Notice",
                        "FullName",
                        "FamilyName",
                        "Weight",
                        "FontBBox",
                        "BlueValues",
                        "OtherBlues",
                        "FamilyBlues",
                        "FamilyOtherBlues",
                        "StdHW",
                        "StdVW",
                        "escape",
                        "UniqueID",
                        "XUID",
                        "charset",
                        "Encoding",
                        "CharStrings",
                        "Private",
                        "Subrs",
                        "defaultWidthX",
                        "nominalWidthX"
                    ][i], f = 1, 12 == i) d = [
                        "Copyright",
                        "isFixedPitch",
                        "ItalicAngle",
                        "UnderlinePosition",
                        "UnderlineThickness",
                        "PaintType",
                        "CharstringType",
                        "FontMatrix",
                        "StrokeWidth",
                        "BlueScale",
                        "BlueShift",
                        "BlueFuzz",
                        "StemSnapH",
                        "StemSnapV",
                        "ForceBold",
                        0,
                        0,
                        "LanguageGroup",
                        "ExpansionFactor",
                        "initialRandomSeed",
                        "SyntheticBase",
                        "PostScript",
                        "BaseFontName",
                        "BaseFontBlend",
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        "ROS",
                        "CIDFontVersion",
                        "CIDFontRevision",
                        "CIDFontType",
                        "CIDCount",
                        "UIDBase",
                        "FDArray",
                        "FDSelect",
                        "FontName"
                    ][h], f = 2;
                }
                null != d ? (o[d] = 1 == s.length ? s[0] : s, s = []) : s.push(u), t += f;
            }
            return o;
        }, e.cmap = {}, e.cmap.parse = function(r, t, a) {
            r = new Uint8Array(r.buffer, t, a), t = 0;
            var n = e._bin, o = {};
            n.readUshort(r, t), t += 2;
            var s = n.readUshort(r, t);
            t += 2;
            var i = [];
            o.tables = [];
            for(var h = 0; h < s; h++){
                var f = n.readUshort(r, t);
                t += 2;
                var d = n.readUshort(r, t);
                t += 2;
                var u = n.readUint(r, t);
                t += 4;
                var l = "p" + f + "e" + d, v = i.indexOf(u);
                if (-1 == v) {
                    var c;
                    v = o.tables.length, i.push(u);
                    var p = n.readUshort(r, u);
                    0 == p ? c = e.cmap.parse0(r, u) : 4 == p ? c = e.cmap.parse4(r, u) : 6 == p ? c = e.cmap.parse6(r, u) : 12 == p ? c = e.cmap.parse12(r, u) : console.debug("unknown format: " + p, f, d, u), o.tables.push(c);
                }
                if (null != o[l]) throw "multiple tables for one platform+encoding";
                o[l] = v;
            }
            return o;
        }, e.cmap.parse0 = function(r, t) {
            var a = e._bin, n = {};
            n.format = a.readUshort(r, t), t += 2;
            var o = a.readUshort(r, t);
            t += 2, a.readUshort(r, t), t += 2, n.map = [];
            for(var s = 0; s < o - 6; s++)n.map.push(r[t + s]);
            return n;
        }, e.cmap.parse4 = function(r, t) {
            var a = e._bin, n = t, o = {};
            o.format = a.readUshort(r, t), t += 2;
            var s = a.readUshort(r, t);
            t += 2, a.readUshort(r, t), t += 2;
            var i = a.readUshort(r, t);
            t += 2;
            var h = i / 2;
            o.searchRange = a.readUshort(r, t), t += 2, o.entrySelector = a.readUshort(r, t), t += 2, o.rangeShift = a.readUshort(r, t), t += 2, o.endCount = a.readUshorts(r, t, h), t += 2 * h, t += 2, o.startCount = a.readUshorts(r, t, h), t += 2 * h, o.idDelta = [];
            for(var f = 0; f < h; f++)o.idDelta.push(a.readShort(r, t)), t += 2;
            for(o.idRangeOffset = a.readUshorts(r, t, h), t += 2 * h, o.glyphIdArray = []; t < n + s;)o.glyphIdArray.push(a.readUshort(r, t)), t += 2;
            return o;
        }, e.cmap.parse6 = function(r, t) {
            var a = e._bin, n = {};
            n.format = a.readUshort(r, t), t += 2, a.readUshort(r, t), t += 2, a.readUshort(r, t), t += 2, n.firstCode = a.readUshort(r, t), t += 2;
            var o = a.readUshort(r, t);
            t += 2, n.glyphIdArray = [];
            for(var s = 0; s < o; s++)n.glyphIdArray.push(a.readUshort(r, t)), t += 2;
            return n;
        }, e.cmap.parse12 = function(r, t) {
            var a = e._bin, n = {};
            n.format = a.readUshort(r, t), t += 2, t += 2, a.readUint(r, t), t += 4, a.readUint(r, t), t += 4;
            var o = a.readUint(r, t);
            t += 4, n.groups = [];
            for(var s = 0; s < o; s++){
                var i = t + 12 * s, h = a.readUint(r, i + 0), f = a.readUint(r, i + 4), d = a.readUint(r, i + 8);
                n.groups.push([
                    h,
                    f,
                    d
                ]);
            }
            return n;
        }, e.glyf = {}, e.glyf.parse = function(r, e, t, a) {
            for(var n = [], o = 0; o < a.maxp.numGlyphs; o++)n.push(null);
            return n;
        }, e.glyf._parseGlyf = function(r, t) {
            var a = e._bin, n = r._data, o = e._tabOffset(n, "glyf", r._offset) + r.loca[t];
            if (r.loca[t] == r.loca[t + 1]) return null;
            var s = {};
            if (s.noc = a.readShort(n, o), o += 2, s.xMin = a.readShort(n, o), o += 2, s.yMin = a.readShort(n, o), o += 2, s.xMax = a.readShort(n, o), o += 2, s.yMax = a.readShort(n, o), o += 2, s.xMin >= s.xMax || s.yMin >= s.yMax) return null;
            if (s.noc > 0) {
                s.endPts = [];
                for(var i = 0; i < s.noc; i++)s.endPts.push(a.readUshort(n, o)), o += 2;
                var h = a.readUshort(n, o);
                if (o += 2, n.length - o < h) return null;
                s.instructions = a.readBytes(n, o, h), o += h;
                var f = s.endPts[s.noc - 1] + 1;
                s.flags = [];
                for(i = 0; i < f; i++){
                    var d = n[o];
                    if (o++, s.flags.push(d), 0 != (8 & d)) {
                        var u = n[o];
                        o++;
                        for(var l = 0; l < u; l++)s.flags.push(d), i++;
                    }
                }
                s.xs = [];
                for(i = 0; i < f; i++){
                    var v = 0 != (2 & s.flags[i]), c = 0 != (16 & s.flags[i]);
                    v ? (s.xs.push(c ? n[o] : -n[o]), o++) : c ? s.xs.push(0) : (s.xs.push(a.readShort(n, o)), o += 2);
                }
                s.ys = [];
                for(i = 0; i < f; i++){
                    v = 0 != (4 & s.flags[i]), c = 0 != (32 & s.flags[i]);
                    v ? (s.ys.push(c ? n[o] : -n[o]), o++) : c ? s.ys.push(0) : (s.ys.push(a.readShort(n, o)), o += 2);
                }
                var p = 0, U = 0;
                for(i = 0; i < f; i++)p += s.xs[i], U += s.ys[i], s.xs[i] = p, s.ys[i] = U;
            } else {
                var g;
                s.parts = [];
                do {
                    g = a.readUshort(n, o), o += 2;
                    var S = {
                        m: {
                            a: 1,
                            b: 0,
                            c: 0,
                            d: 1,
                            tx: 0,
                            ty: 0
                        },
                        p1: -1,
                        p2: -1
                    };
                    if (s.parts.push(S), S.glyphIndex = a.readUshort(n, o), o += 2, 1 & g) {
                        var m = a.readShort(n, o);
                        o += 2;
                        var b = a.readShort(n, o);
                        o += 2;
                    } else {
                        m = a.readInt8(n, o);
                        o++;
                        b = a.readInt8(n, o);
                        o++;
                    }
                    2 & g ? (S.m.tx = m, S.m.ty = b) : (S.p1 = m, S.p2 = b), 8 & g ? (S.m.a = S.m.d = a.readF2dot14(n, o), o += 2) : 64 & g ? (S.m.a = a.readF2dot14(n, o), o += 2, S.m.d = a.readF2dot14(n, o), o += 2) : 128 & g && (S.m.a = a.readF2dot14(n, o), o += 2, S.m.b = a.readF2dot14(n, o), o += 2, S.m.c = a.readF2dot14(n, o), o += 2, S.m.d = a.readF2dot14(n, o), o += 2);
                }while (32 & g);
                if (256 & g) {
                    var y = a.readUshort(n, o);
                    o += 2, s.instr = [];
                    for(i = 0; i < y; i++)s.instr.push(n[o]), o++;
                }
            }
            return s;
        }, e.GPOS = {}, e.GPOS.parse = function(r, t, a, n) {
            return e._lctf.parse(r, t, a, n, e.GPOS.subt);
        }, e.GPOS.subt = function(r, t, a, n) {
            var o = e._bin, s = a, i = {};
            if (i.fmt = o.readUshort(r, a), a += 2, 1 == t || 2 == t || 3 == t || 7 == t || 8 == t && i.fmt <= 2) {
                var h = o.readUshort(r, a);
                a += 2, i.coverage = e._lctf.readCoverage(r, h + s);
            }
            if (1 == t && 1 == i.fmt) {
                var f = o.readUshort(r, a);
                a += 2;
                var d = e._lctf.numOfOnes(f);
                0 != f && (i.pos = e.GPOS.readValueRecord(r, a, f));
            } else if (2 == t && i.fmt >= 1 && i.fmt <= 2) {
                f = o.readUshort(r, a);
                a += 2;
                var u = o.readUshort(r, a);
                a += 2;
                d = e._lctf.numOfOnes(f);
                var l = e._lctf.numOfOnes(u);
                if (1 == i.fmt) {
                    i.pairsets = [];
                    var v = o.readUshort(r, a);
                    a += 2;
                    for(var c = 0; c < v; c++){
                        var p = s + o.readUshort(r, a);
                        a += 2;
                        var U = o.readUshort(r, p);
                        p += 2;
                        for(var g = [], S = 0; S < U; S++){
                            var m = o.readUshort(r, p);
                            p += 2, 0 != f && (x = e.GPOS.readValueRecord(r, p, f), p += 2 * d), 0 != u && (P = e.GPOS.readValueRecord(r, p, u), p += 2 * l), g.push({
                                gid2: m,
                                val1: x,
                                val2: P
                            });
                        }
                        i.pairsets.push(g);
                    }
                }
                if (2 == i.fmt) {
                    var b = o.readUshort(r, a);
                    a += 2;
                    var y = o.readUshort(r, a);
                    a += 2;
                    var F = o.readUshort(r, a);
                    a += 2;
                    var _ = o.readUshort(r, a);
                    a += 2, i.classDef1 = e._lctf.readClassDef(r, s + b), i.classDef2 = e._lctf.readClassDef(r, s + y), i.matrix = [];
                    for(c = 0; c < F; c++){
                        var C = [];
                        for(S = 0; S < _; S++){
                            var x = null, P = null;
                            0 != f && (x = e.GPOS.readValueRecord(r, a, f), a += 2 * d), 0 != u && (P = e.GPOS.readValueRecord(r, a, u), a += 2 * l), C.push({
                                val1: x,
                                val2: P
                            });
                        }
                        i.matrix.push(C);
                    }
                }
            } else {
                if (9 == t && 1 == i.fmt) {
                    var I = o.readUshort(r, a);
                    a += 2;
                    var w = o.readUint(r, a);
                    if (a += 4, 9 == n.ltype) n.ltype = I;
                    else if (n.ltype != I) throw "invalid extension substitution";
                    return e.GPOS.subt(r, n.ltype, s + w);
                }
                console.debug("unsupported GPOS table LookupType", t, "format", i.fmt);
            }
            return i;
        }, e.GPOS.readValueRecord = function(r, t, a) {
            var n = e._bin, o = [];
            return o.push(1 & a ? n.readShort(r, t) : 0), t += 1 & a ? 2 : 0, o.push(2 & a ? n.readShort(r, t) : 0), t += 2 & a ? 2 : 0, o.push(4 & a ? n.readShort(r, t) : 0), t += 4 & a ? 2 : 0, o.push(8 & a ? n.readShort(r, t) : 0), t += 8 & a ? 2 : 0, o;
        }, e.GSUB = {}, e.GSUB.parse = function(r, t, a, n) {
            return e._lctf.parse(r, t, a, n, e.GSUB.subt);
        }, e.GSUB.subt = function(r, t, a, n) {
            var o = e._bin, s = a, i = {};
            if (i.fmt = o.readUshort(r, a), a += 2, 1 != t && 4 != t && 5 != t && 6 != t) return null;
            if (1 == t || 4 == t || 5 == t && i.fmt <= 2 || 6 == t && i.fmt <= 2) {
                var h = o.readUshort(r, a);
                a += 2, i.coverage = e._lctf.readCoverage(r, s + h);
            }
            if (1 == t && i.fmt >= 1 && i.fmt <= 2) {
                if (1 == i.fmt) i.delta = o.readShort(r, a), a += 2;
                else if (2 == i.fmt) {
                    var f = o.readUshort(r, a);
                    a += 2, i.newg = o.readUshorts(r, a, f), a += 2 * i.newg.length;
                }
            } else if (4 == t) {
                i.vals = [];
                f = o.readUshort(r, a);
                a += 2;
                for(var d = 0; d < f; d++){
                    var u = o.readUshort(r, a);
                    a += 2, i.vals.push(e.GSUB.readLigatureSet(r, s + u));
                }
            } else if (5 == t && 2 == i.fmt) {
                if (2 == i.fmt) {
                    var l = o.readUshort(r, a);
                    a += 2, i.cDef = e._lctf.readClassDef(r, s + l), i.scset = [];
                    var v = o.readUshort(r, a);
                    a += 2;
                    for(d = 0; d < v; d++){
                        var c = o.readUshort(r, a);
                        a += 2, i.scset.push(0 == c ? null : e.GSUB.readSubClassSet(r, s + c));
                    }
                }
            } else if (6 == t && 3 == i.fmt) {
                if (3 == i.fmt) {
                    for(d = 0; d < 3; d++){
                        f = o.readUshort(r, a);
                        a += 2;
                        for(var p = [], U = 0; U < f; U++)p.push(e._lctf.readCoverage(r, s + o.readUshort(r, a + 2 * U)));
                        a += 2 * f, 0 == d && (i.backCvg = p), 1 == d && (i.inptCvg = p), 2 == d && (i.ahedCvg = p);
                    }
                    f = o.readUshort(r, a);
                    a += 2, i.lookupRec = e.GSUB.readSubstLookupRecords(r, a, f);
                }
            } else {
                if (7 == t && 1 == i.fmt) {
                    var g = o.readUshort(r, a);
                    a += 2;
                    var S = o.readUint(r, a);
                    if (a += 4, 9 == n.ltype) n.ltype = g;
                    else if (n.ltype != g) throw "invalid extension substitution";
                    return e.GSUB.subt(r, n.ltype, s + S);
                }
                console.debug("unsupported GSUB table LookupType", t, "format", i.fmt);
            }
            return i;
        }, e.GSUB.readSubClassSet = function(r, t) {
            var a = e._bin.readUshort, n = t, o = [], s = a(r, t);
            t += 2;
            for(var i = 0; i < s; i++){
                var h = a(r, t);
                t += 2, o.push(e.GSUB.readSubClassRule(r, n + h));
            }
            return o;
        }, e.GSUB.readSubClassRule = function(r, t) {
            var a = e._bin.readUshort, n = {}, o = a(r, t), s = a(r, t += 2);
            t += 2, n.input = [];
            for(var i = 0; i < o - 1; i++)n.input.push(a(r, t)), t += 2;
            return n.substLookupRecords = e.GSUB.readSubstLookupRecords(r, t, s), n;
        }, e.GSUB.readSubstLookupRecords = function(r, t, a) {
            for(var n = e._bin.readUshort, o = [], s = 0; s < a; s++)o.push(n(r, t), n(r, t + 2)), t += 4;
            return o;
        }, e.GSUB.readChainSubClassSet = function(r, t) {
            var a = e._bin, n = t, o = [], s = a.readUshort(r, t);
            t += 2;
            for(var i = 0; i < s; i++){
                var h = a.readUshort(r, t);
                t += 2, o.push(e.GSUB.readChainSubClassRule(r, n + h));
            }
            return o;
        }, e.GSUB.readChainSubClassRule = function(r, t) {
            for(var a = e._bin, n = {}, o = [
                "backtrack",
                "input",
                "lookahead"
            ], s = 0; s < o.length; s++){
                var i = a.readUshort(r, t);
                t += 2, 1 == s && i--, n[o[s]] = a.readUshorts(r, t, i), t += 2 * n[o[s]].length;
            }
            i = a.readUshort(r, t);
            return t += 2, n.subst = a.readUshorts(r, t, 2 * i), t += 2 * n.subst.length, n;
        }, e.GSUB.readLigatureSet = function(r, t) {
            var a = e._bin, n = t, o = [], s = a.readUshort(r, t);
            t += 2;
            for(var i = 0; i < s; i++){
                var h = a.readUshort(r, t);
                t += 2, o.push(e.GSUB.readLigature(r, n + h));
            }
            return o;
        }, e.GSUB.readLigature = function(r, t) {
            var a = e._bin, n = {
                chain: []
            };
            n.nglyph = a.readUshort(r, t), t += 2;
            var o = a.readUshort(r, t);
            t += 2;
            for(var s = 0; s < o - 1; s++)n.chain.push(a.readUshort(r, t)), t += 2;
            return n;
        }, e.head = {}, e.head.parse = function(r, t, a) {
            var n = e._bin, o = {};
            return n.readFixed(r, t), t += 4, o.fontRevision = n.readFixed(r, t), t += 4, n.readUint(r, t), t += 4, n.readUint(r, t), t += 4, o.flags = n.readUshort(r, t), t += 2, o.unitsPerEm = n.readUshort(r, t), t += 2, o.created = n.readUint64(r, t), t += 8, o.modified = n.readUint64(r, t), t += 8, o.xMin = n.readShort(r, t), t += 2, o.yMin = n.readShort(r, t), t += 2, o.xMax = n.readShort(r, t), t += 2, o.yMax = n.readShort(r, t), t += 2, o.macStyle = n.readUshort(r, t), t += 2, o.lowestRecPPEM = n.readUshort(r, t), t += 2, o.fontDirectionHint = n.readShort(r, t), t += 2, o.indexToLocFormat = n.readShort(r, t), t += 2, o.glyphDataFormat = n.readShort(r, t), t += 2, o;
        }, e.hhea = {}, e.hhea.parse = function(r, t, a) {
            var n = e._bin, o = {};
            return n.readFixed(r, t), t += 4, o.ascender = n.readShort(r, t), t += 2, o.descender = n.readShort(r, t), t += 2, o.lineGap = n.readShort(r, t), t += 2, o.advanceWidthMax = n.readUshort(r, t), t += 2, o.minLeftSideBearing = n.readShort(r, t), t += 2, o.minRightSideBearing = n.readShort(r, t), t += 2, o.xMaxExtent = n.readShort(r, t), t += 2, o.caretSlopeRise = n.readShort(r, t), t += 2, o.caretSlopeRun = n.readShort(r, t), t += 2, o.caretOffset = n.readShort(r, t), t += 2, t += 8, o.metricDataFormat = n.readShort(r, t), t += 2, o.numberOfHMetrics = n.readUshort(r, t), t += 2, o;
        }, e.hmtx = {}, e.hmtx.parse = function(r, t, a, n) {
            for(var o = e._bin, s = {
                aWidth: [],
                lsBearing: []
            }, i = 0, h = 0, f = 0; f < n.maxp.numGlyphs; f++)f < n.hhea.numberOfHMetrics && (i = o.readUshort(r, t), t += 2, h = o.readShort(r, t), t += 2), s.aWidth.push(i), s.lsBearing.push(h);
            return s;
        }, e.kern = {}, e.kern.parse = function(r, t, a, n) {
            var o = e._bin, s = o.readUshort(r, t);
            if (t += 2, 1 == s) return e.kern.parseV1(r, t - 2, a, n);
            var i = o.readUshort(r, t);
            t += 2;
            for(var h = {
                glyph1: [],
                rval: []
            }, f = 0; f < i; f++){
                t += 2;
                a = o.readUshort(r, t);
                t += 2;
                var d = o.readUshort(r, t);
                t += 2;
                var u = d >>> 8;
                if (0 != (u &= 15)) throw "unknown kern table format: " + u;
                t = e.kern.readFormat0(r, t, h);
            }
            return h;
        }, e.kern.parseV1 = function(r, t, a, n) {
            var o = e._bin;
            o.readFixed(r, t), t += 4;
            var s = o.readUint(r, t);
            t += 4;
            for(var i = {
                glyph1: [],
                rval: []
            }, h = 0; h < s; h++){
                o.readUint(r, t), t += 4;
                var f = o.readUshort(r, t);
                t += 2, o.readUshort(r, t), t += 2;
                var d = f >>> 8;
                if (0 != (d &= 15)) throw "unknown kern table format: " + d;
                t = e.kern.readFormat0(r, t, i);
            }
            return i;
        }, e.kern.readFormat0 = function(r, t, a) {
            var n = e._bin, o = -1, s = n.readUshort(r, t);
            t += 2, n.readUshort(r, t), t += 2, n.readUshort(r, t), t += 2, n.readUshort(r, t), t += 2;
            for(var i = 0; i < s; i++){
                var h = n.readUshort(r, t);
                t += 2;
                var f = n.readUshort(r, t);
                t += 2;
                var d = n.readShort(r, t);
                t += 2, h != o && (a.glyph1.push(h), a.rval.push({
                    glyph2: [],
                    vals: []
                }));
                var u = a.rval[a.rval.length - 1];
                u.glyph2.push(f), u.vals.push(d), o = h;
            }
            return t;
        }, e.loca = {}, e.loca.parse = function(r, t, a, n) {
            var o = e._bin, s = [], i = n.head.indexToLocFormat, h = n.maxp.numGlyphs + 1;
            if (0 == i) for(var f = 0; f < h; f++)s.push(o.readUshort(r, t + (f << 1)) << 1);
            if (1 == i) for(f = 0; f < h; f++)s.push(o.readUint(r, t + (f << 2)));
            return s;
        }, e.maxp = {}, e.maxp.parse = function(r, t, a) {
            var n = e._bin, o = {}, s = n.readUint(r, t);
            return t += 4, o.numGlyphs = n.readUshort(r, t), t += 2, 65536 == s && (o.maxPoints = n.readUshort(r, t), t += 2, o.maxContours = n.readUshort(r, t), t += 2, o.maxCompositePoints = n.readUshort(r, t), t += 2, o.maxCompositeContours = n.readUshort(r, t), t += 2, o.maxZones = n.readUshort(r, t), t += 2, o.maxTwilightPoints = n.readUshort(r, t), t += 2, o.maxStorage = n.readUshort(r, t), t += 2, o.maxFunctionDefs = n.readUshort(r, t), t += 2, o.maxInstructionDefs = n.readUshort(r, t), t += 2, o.maxStackElements = n.readUshort(r, t), t += 2, o.maxSizeOfInstructions = n.readUshort(r, t), t += 2, o.maxComponentElements = n.readUshort(r, t), t += 2, o.maxComponentDepth = n.readUshort(r, t), t += 2), o;
        }, e.name = {}, e.name.parse = function(r, t, a) {
            var n = e._bin, o = {};
            n.readUshort(r, t), t += 2;
            var s = n.readUshort(r, t);
            t += 2, n.readUshort(r, t);
            for(var i, h = [
                "copyright",
                "fontFamily",
                "fontSubfamily",
                "ID",
                "fullName",
                "version",
                "postScriptName",
                "trademark",
                "manufacturer",
                "designer",
                "description",
                "urlVendor",
                "urlDesigner",
                "licence",
                "licenceURL",
                "---",
                "typoFamilyName",
                "typoSubfamilyName",
                "compatibleFull",
                "sampleText",
                "postScriptCID",
                "wwsFamilyName",
                "wwsSubfamilyName",
                "lightPalette",
                "darkPalette"
            ], f = t += 2, d = 0; d < s; d++){
                var u = n.readUshort(r, t);
                t += 2;
                var l = n.readUshort(r, t);
                t += 2;
                var v = n.readUshort(r, t);
                t += 2;
                var c = n.readUshort(r, t);
                t += 2;
                var p = n.readUshort(r, t);
                t += 2;
                var U = n.readUshort(r, t);
                t += 2;
                var g, S = h[c], m = f + 12 * s + U;
                if (0 == u) g = n.readUnicode(r, m, p / 2);
                else if (3 == u && 0 == l) g = n.readUnicode(r, m, p / 2);
                else if (0 == l) g = n.readASCII(r, m, p);
                else if (1 == l) g = n.readUnicode(r, m, p / 2);
                else if (3 == l) g = n.readUnicode(r, m, p / 2);
                else {
                    if (1 != u) throw "unknown encoding " + l + ", platformID: " + u;
                    g = n.readASCII(r, m, p), console.debug("reading unknown MAC encoding " + l + " as ASCII");
                }
                var b = "p" + u + "," + v.toString(16);
                null == o[b] && (o[b] = {}), o[b][void 0 !== S ? S : c] = g, o[b]._lang = v;
            }
            for(var y in o)if (null != o[y].postScriptName && 1033 == o[y]._lang) return o[y];
            for(var y in o)if (null != o[y].postScriptName && 0 == o[y]._lang) return o[y];
            for(var y in o)if (null != o[y].postScriptName && 3084 == o[y]._lang) return o[y];
            for(var y in o)if (null != o[y].postScriptName) return o[y];
            for(var y in o){
                i = y;
                break;
            }
            return console.debug("returning name table with languageID " + o[i]._lang), o[i];
        }, e["OS/2"] = {}, e["OS/2"].parse = function(r, t, a) {
            var n = e._bin.readUshort(r, t);
            t += 2;
            var o = {};
            if (0 == n) e["OS/2"].version0(r, t, o);
            else if (1 == n) e["OS/2"].version1(r, t, o);
            else if (2 == n || 3 == n || 4 == n) e["OS/2"].version2(r, t, o);
            else {
                if (5 != n) throw "unknown OS/2 table version: " + n;
                e["OS/2"].version5(r, t, o);
            }
            return o;
        }, e["OS/2"].version0 = function(r, t, a) {
            var n = e._bin;
            return a.xAvgCharWidth = n.readShort(r, t), t += 2, a.usWeightClass = n.readUshort(r, t), t += 2, a.usWidthClass = n.readUshort(r, t), t += 2, a.fsType = n.readUshort(r, t), t += 2, a.ySubscriptXSize = n.readShort(r, t), t += 2, a.ySubscriptYSize = n.readShort(r, t), t += 2, a.ySubscriptXOffset = n.readShort(r, t), t += 2, a.ySubscriptYOffset = n.readShort(r, t), t += 2, a.ySuperscriptXSize = n.readShort(r, t), t += 2, a.ySuperscriptYSize = n.readShort(r, t), t += 2, a.ySuperscriptXOffset = n.readShort(r, t), t += 2, a.ySuperscriptYOffset = n.readShort(r, t), t += 2, a.yStrikeoutSize = n.readShort(r, t), t += 2, a.yStrikeoutPosition = n.readShort(r, t), t += 2, a.sFamilyClass = n.readShort(r, t), t += 2, a.panose = n.readBytes(r, t, 10), t += 10, a.ulUnicodeRange1 = n.readUint(r, t), t += 4, a.ulUnicodeRange2 = n.readUint(r, t), t += 4, a.ulUnicodeRange3 = n.readUint(r, t), t += 4, a.ulUnicodeRange4 = n.readUint(r, t), t += 4, a.achVendID = [
                n.readInt8(r, t),
                n.readInt8(r, t + 1),
                n.readInt8(r, t + 2),
                n.readInt8(r, t + 3)
            ], t += 4, a.fsSelection = n.readUshort(r, t), t += 2, a.usFirstCharIndex = n.readUshort(r, t), t += 2, a.usLastCharIndex = n.readUshort(r, t), t += 2, a.sTypoAscender = n.readShort(r, t), t += 2, a.sTypoDescender = n.readShort(r, t), t += 2, a.sTypoLineGap = n.readShort(r, t), t += 2, a.usWinAscent = n.readUshort(r, t), t += 2, a.usWinDescent = n.readUshort(r, t), t += 2;
        }, e["OS/2"].version1 = function(r, t, a) {
            var n = e._bin;
            return t = e["OS/2"].version0(r, t, a), a.ulCodePageRange1 = n.readUint(r, t), t += 4, a.ulCodePageRange2 = n.readUint(r, t), t += 4;
        }, e["OS/2"].version2 = function(r, t, a) {
            var n = e._bin;
            return t = e["OS/2"].version1(r, t, a), a.sxHeight = n.readShort(r, t), t += 2, a.sCapHeight = n.readShort(r, t), t += 2, a.usDefault = n.readUshort(r, t), t += 2, a.usBreak = n.readUshort(r, t), t += 2, a.usMaxContext = n.readUshort(r, t), t += 2;
        }, e["OS/2"].version5 = function(r, t, a) {
            var n = e._bin;
            return t = e["OS/2"].version2(r, t, a), a.usLowerOpticalPointSize = n.readUshort(r, t), t += 2, a.usUpperOpticalPointSize = n.readUshort(r, t), t += 2;
        }, e.post = {}, e.post.parse = function(r, t, a) {
            var n = e._bin, o = {};
            return o.version = n.readFixed(r, t), t += 4, o.italicAngle = n.readFixed(r, t), t += 4, o.underlinePosition = n.readShort(r, t), t += 2, o.underlineThickness = n.readShort(r, t), t += 2, o;
        }, null == e && (e = {}), null == e.U && (e.U = {}), e.U.codeToGlyph = function(r, e) {
            var t = r.cmap, a = -1;
            if (null != t.p0e4 ? a = t.p0e4 : null != t.p3e1 ? a = t.p3e1 : null != t.p1e0 ? a = t.p1e0 : null != t.p0e3 && (a = t.p0e3), -1 == a) throw "no familiar platform and encoding!";
            var n = t.tables[a];
            if (0 == n.format) return e >= n.map.length ? 0 : n.map[e];
            if (4 == n.format) {
                for(var o = -1, s = 0; s < n.endCount.length; s++)if (e <= n.endCount[s]) {
                    o = s;
                    break;
                }
                if (-1 == o) return 0;
                if (n.startCount[o] > e) return 0;
                return 65535 & (0 != n.idRangeOffset[o] ? n.glyphIdArray[e - n.startCount[o] + (n.idRangeOffset[o] >> 1) - (n.idRangeOffset.length - o)] : e + n.idDelta[o]);
            }
            if (12 == n.format) {
                if (e > n.groups[n.groups.length - 1][1]) return 0;
                for(s = 0; s < n.groups.length; s++){
                    var i = n.groups[s];
                    if (i[0] <= e && e <= i[1]) return i[2] + (e - i[0]);
                }
                return 0;
            }
            throw "unknown cmap table format " + n.format;
        }, e.U.glyphToPath = function(r, t) {
            var a = {
                cmds: [],
                crds: []
            };
            if (r.SVG && r.SVG.entries[t]) {
                var n = r.SVG.entries[t];
                return null == n ? a : ("string" == typeof n && (n = e.SVG.toPath(n), r.SVG.entries[t] = n), n);
            }
            if (r.CFF) {
                var o = {
                    x: 0,
                    y: 0,
                    stack: [],
                    nStems: 0,
                    haveWidth: !1,
                    width: r.CFF.Private ? r.CFF.Private.defaultWidthX : 0,
                    open: !1
                }, s = r.CFF, i = r.CFF.Private;
                if (s.ROS) {
                    for(var h = 0; s.FDSelect[h + 2] <= t;)h += 2;
                    i = s.FDArray[s.FDSelect[h + 1]].Private;
                }
                e.U._drawCFF(r.CFF.CharStrings[t], o, s, i, a);
            } else r.glyf && e.U._drawGlyf(t, r, a);
            return a;
        }, e.U._drawGlyf = function(r, t, a) {
            var n = t.glyf[r];
            null == n && (n = t.glyf[r] = e.glyf._parseGlyf(t, r)), null != n && (n.noc > -1 ? e.U._simpleGlyph(n, a) : e.U._compoGlyph(n, t, a));
        }, e.U._simpleGlyph = function(r, t) {
            for(var a = 0; a < r.noc; a++){
                for(var n = 0 == a ? 0 : r.endPts[a - 1] + 1, o = r.endPts[a], s = n; s <= o; s++){
                    var i = s == n ? o : s - 1, h = s == o ? n : s + 1, f = 1 & r.flags[s], d = 1 & r.flags[i], u = 1 & r.flags[h], l = r.xs[s], v = r.ys[s];
                    if (s == n) {
                        if (f) {
                            if (!d) {
                                e.U.P.moveTo(t, l, v);
                                continue;
                            }
                            e.U.P.moveTo(t, r.xs[i], r.ys[i]);
                        } else d ? e.U.P.moveTo(t, r.xs[i], r.ys[i]) : e.U.P.moveTo(t, (r.xs[i] + l) / 2, (r.ys[i] + v) / 2);
                    }
                    f ? d && e.U.P.lineTo(t, l, v) : u ? e.U.P.qcurveTo(t, l, v, r.xs[h], r.ys[h]) : e.U.P.qcurveTo(t, l, v, (l + r.xs[h]) / 2, (v + r.ys[h]) / 2);
                }
                e.U.P.closePath(t);
            }
        }, e.U._compoGlyph = function(r, t, a) {
            for(var n = 0; n < r.parts.length; n++){
                var o = {
                    cmds: [],
                    crds: []
                }, s = r.parts[n];
                e.U._drawGlyf(s.glyphIndex, t, o);
                for(var i = s.m, h = 0; h < o.crds.length; h += 2){
                    var f = o.crds[h], d = o.crds[h + 1];
                    a.crds.push(f * i.a + d * i.b + i.tx), a.crds.push(f * i.c + d * i.d + i.ty);
                }
                for(h = 0; h < o.cmds.length; h++)a.cmds.push(o.cmds[h]);
            }
        }, e.U._getGlyphClass = function(r, t) {
            var a = e._lctf.getInterval(t, r);
            return -1 == a ? 0 : t[a + 2];
        }, e.U.getPairAdjustment = function(r, t, a) {
            var n = !1;
            if (r.GPOS) for(var o = r.GPOS, s = o.lookupList, i = o.featureList, h = [], f = 0; f < i.length; f++){
                var d = i[f];
                if ("kern" == d.tag) {
                    n = !0;
                    for(var u = 0; u < d.tab.length; u++)if (!h[d.tab[u]]) {
                        h[d.tab[u]] = !0;
                        for(var l = s[d.tab[u]], v = 0; v < l.tabs.length; v++)if (null != l.tabs[v]) {
                            var c, p = l.tabs[v];
                            if (!p.coverage || -1 != (c = e._lctf.coverageIndex(p.coverage, t))) {
                                if (1 == l.ltype) ;
                                else if (2 == l.ltype) {
                                    var U = null;
                                    if (1 == p.fmt) {
                                        var g = p.pairsets[c];
                                        for(f = 0; f < g.length; f++)g[f].gid2 == a && (U = g[f]);
                                    } else if (2 == p.fmt) {
                                        var S = e.U._getGlyphClass(t, p.classDef1), m = e.U._getGlyphClass(a, p.classDef2);
                                        U = p.matrix[S][m];
                                    }
                                    if (U) {
                                        var b = 0;
                                        return U.val1 && U.val1[2] && (b += U.val1[2]), U.val2 && U.val2[0] && (b += U.val2[0]), b;
                                    }
                                }
                            }
                        }
                    }
                }
            }
            if (r.kern && !n) {
                var y = r.kern.glyph1.indexOf(t);
                if (-1 != y) {
                    var F = r.kern.rval[y].glyph2.indexOf(a);
                    if (-1 != F) return r.kern.rval[y].vals[F];
                }
            }
            return 0;
        }, e.U._applySubs = function(r, t, a, n) {
            for(var o = r.length - t - 1, s = 0; s < a.tabs.length; s++)if (null != a.tabs[s]) {
                var i, h = a.tabs[s];
                if (!h.coverage || -1 != (i = e._lctf.coverageIndex(h.coverage, r[t]))) {
                    if (1 == a.ltype) r[t], 1 == h.fmt ? r[t] = r[t] + h.delta : r[t] = h.newg[i];
                    else if (4 == a.ltype) for(var f = h.vals[i], d = 0; d < f.length; d++){
                        var u = f[d], l = u.chain.length;
                        if (!(l > o)) {
                            for(var v = !0, c = 0, p = 0; p < l; p++){
                                for(; -1 == r[t + c + (1 + p)];)c++;
                                u.chain[p] != r[t + c + (1 + p)] && (v = !1);
                            }
                            if (v) {
                                r[t] = u.nglyph;
                                for(p = 0; p < l + c; p++)r[t + p + 1] = -1;
                                break;
                            }
                        }
                    }
                    else if (5 == a.ltype && 2 == h.fmt) for(var U = e._lctf.getInterval(h.cDef, r[t]), g = h.cDef[U + 2], S = h.scset[g], m = 0; m < S.length; m++){
                        var b = S[m], y = b.input;
                        if (!(y.length > o)) {
                            for(v = !0, p = 0; p < y.length; p++){
                                var F = e._lctf.getInterval(h.cDef, r[t + 1 + p]);
                                if (-1 == U && h.cDef[F + 2] != y[p]) {
                                    v = !1;
                                    break;
                                }
                            }
                            if (v) {
                                var _ = b.substLookupRecords;
                                for(d = 0; d < _.length; d += 2)_[d], _[d + 1];
                            }
                        }
                    }
                    else if (6 == a.ltype && 3 == h.fmt) {
                        if (!e.U._glsCovered(r, h.backCvg, t - h.backCvg.length)) continue;
                        if (!e.U._glsCovered(r, h.inptCvg, t)) continue;
                        if (!e.U._glsCovered(r, h.ahedCvg, t + h.inptCvg.length)) continue;
                        var C = h.lookupRec;
                        for(m = 0; m < C.length; m += 2){
                            U = C[m];
                            var x = n[C[m + 1]];
                            e.U._applySubs(r, t + U, x, n);
                        }
                    }
                }
            }
        }, e.U._glsCovered = function(r, t, a) {
            for(var n = 0; n < t.length; n++){
                if (-1 == e._lctf.coverageIndex(t[n], r[a + n])) return !1;
            }
            return !0;
        }, e.U.glyphsToPath = function(r, t, a) {
            for(var n = {
                cmds: [],
                crds: []
            }, o = 0, s = 0; s < t.length; s++){
                var i = t[s];
                if (-1 != i) {
                    for(var h = s < t.length - 1 && -1 != t[s + 1] ? t[s + 1] : 0, f = e.U.glyphToPath(r, i), d = 0; d < f.crds.length; d += 2)n.crds.push(f.crds[d] + o), n.crds.push(f.crds[d + 1]);
                    a && n.cmds.push(a);
                    for(d = 0; d < f.cmds.length; d++)n.cmds.push(f.cmds[d]);
                    a && n.cmds.push("X"), o += r.hmtx.aWidth[i], s < t.length - 1 && (o += e.U.getPairAdjustment(r, i, h));
                }
            }
            return n;
        }, e.U.P = {}, e.U.P.moveTo = function(r, e, t) {
            r.cmds.push("M"), r.crds.push(e, t);
        }, e.U.P.lineTo = function(r, e, t) {
            r.cmds.push("L"), r.crds.push(e, t);
        }, e.U.P.curveTo = function(r, e, t, a, n, o, s) {
            r.cmds.push("C"), r.crds.push(e, t, a, n, o, s);
        }, e.U.P.qcurveTo = function(r, e, t, a, n) {
            r.cmds.push("Q"), r.crds.push(e, t, a, n);
        }, e.U.P.closePath = function(r) {
            r.cmds.push("Z");
        }, e.U._drawCFF = function(r, t, a, n, o) {
            for(var s = t.stack, i = t.nStems, h = t.haveWidth, f = t.width, d = t.open, u = 0, l = t.x, v = t.y, c = 0, p = 0, U = 0, g = 0, S = 0, m = 0, b = 0, y = 0, F = 0, _ = 0, C = {
                val: 0,
                size: 0
            }; u < r.length;){
                e.CFF.getCharString(r, u, C);
                var x = C.val;
                if (u += C.size, "o1" == x || "o18" == x) s.length % 2 != 0 && !h && (f = s.shift() + n.nominalWidthX), i += s.length >> 1, s.length = 0, h = !0;
                else if ("o3" == x || "o23" == x) s.length % 2 != 0 && !h && (f = s.shift() + n.nominalWidthX), i += s.length >> 1, s.length = 0, h = !0;
                else if ("o4" == x) s.length > 1 && !h && (f = s.shift() + n.nominalWidthX, h = !0), d && e.U.P.closePath(o), v += s.pop(), e.U.P.moveTo(o, l, v), d = !0;
                else if ("o5" == x) for(; s.length > 0;)l += s.shift(), v += s.shift(), e.U.P.lineTo(o, l, v);
                else if ("o6" == x || "o7" == x) for(var P = s.length, I = "o6" == x, w = 0; w < P; w++){
                    var O = s.shift();
                    I ? l += O : v += O, I = !I, e.U.P.lineTo(o, l, v);
                }
                else if ("o8" == x || "o24" == x) {
                    P = s.length;
                    for(var T = 0; T + 6 <= P;)c = l + s.shift(), p = v + s.shift(), U = c + s.shift(), g = p + s.shift(), l = U + s.shift(), v = g + s.shift(), e.U.P.curveTo(o, c, p, U, g, l, v), T += 6;
                    "o24" == x && (l += s.shift(), v += s.shift(), e.U.P.lineTo(o, l, v));
                } else {
                    if ("o11" == x) break;
                    if ("o1234" == x || "o1235" == x || "o1236" == x || "o1237" == x) "o1234" == x && (p = v, U = (c = l + s.shift()) + s.shift(), _ = g = p + s.shift(), m = g, y = v, l = (b = (S = (F = U + s.shift()) + s.shift()) + s.shift()) + s.shift(), e.U.P.curveTo(o, c, p, U, g, F, _), e.U.P.curveTo(o, S, m, b, y, l, v)), "o1235" == x && (c = l + s.shift(), p = v + s.shift(), U = c + s.shift(), g = p + s.shift(), F = U + s.shift(), _ = g + s.shift(), S = F + s.shift(), m = _ + s.shift(), b = S + s.shift(), y = m + s.shift(), l = b + s.shift(), v = y + s.shift(), s.shift(), e.U.P.curveTo(o, c, p, U, g, F, _), e.U.P.curveTo(o, S, m, b, y, l, v)), "o1236" == x && (c = l + s.shift(), p = v + s.shift(), U = c + s.shift(), _ = g = p + s.shift(), m = g, b = (S = (F = U + s.shift()) + s.shift()) + s.shift(), y = m + s.shift(), l = b + s.shift(), e.U.P.curveTo(o, c, p, U, g, F, _), e.U.P.curveTo(o, S, m, b, y, l, v)), "o1237" == x && (c = l + s.shift(), p = v + s.shift(), U = c + s.shift(), g = p + s.shift(), F = U + s.shift(), _ = g + s.shift(), S = F + s.shift(), m = _ + s.shift(), b = S + s.shift(), y = m + s.shift(), Math.abs(b - l) > Math.abs(y - v) ? l = b + s.shift() : v = y + s.shift(), e.U.P.curveTo(o, c, p, U, g, F, _), e.U.P.curveTo(o, S, m, b, y, l, v));
                    else if ("o14" == x) {
                        if (s.length > 0 && !h && (f = s.shift() + a.nominalWidthX, h = !0), 4 == s.length) {
                            var k = s.shift(), G = s.shift(), D = s.shift(), B = s.shift(), L = e.CFF.glyphBySE(a, D), R = e.CFF.glyphBySE(a, B);
                            e.U._drawCFF(a.CharStrings[L], t, a, n, o), t.x = k, t.y = G, e.U._drawCFF(a.CharStrings[R], t, a, n, o);
                        }
                        d && (e.U.P.closePath(o), d = !1);
                    } else if ("o19" == x || "o20" == x) s.length % 2 != 0 && !h && (f = s.shift() + n.nominalWidthX), i += s.length >> 1, s.length = 0, h = !0, u += i + 7 >> 3;
                    else if ("o21" == x) s.length > 2 && !h && (f = s.shift() + n.nominalWidthX, h = !0), v += s.pop(), l += s.pop(), d && e.U.P.closePath(o), e.U.P.moveTo(o, l, v), d = !0;
                    else if ("o22" == x) s.length > 1 && !h && (f = s.shift() + n.nominalWidthX, h = !0), l += s.pop(), d && e.U.P.closePath(o), e.U.P.moveTo(o, l, v), d = !0;
                    else if ("o25" == x) {
                        for(; s.length > 6;)l += s.shift(), v += s.shift(), e.U.P.lineTo(o, l, v);
                        c = l + s.shift(), p = v + s.shift(), U = c + s.shift(), g = p + s.shift(), l = U + s.shift(), v = g + s.shift(), e.U.P.curveTo(o, c, p, U, g, l, v);
                    } else if ("o26" == x) for(s.length % 2 && (l += s.shift()); s.length > 0;)c = l, p = v + s.shift(), l = U = c + s.shift(), v = (g = p + s.shift()) + s.shift(), e.U.P.curveTo(o, c, p, U, g, l, v);
                    else if ("o27" == x) for(s.length % 2 && (v += s.shift()); s.length > 0;)p = v, U = (c = l + s.shift()) + s.shift(), g = p + s.shift(), l = U + s.shift(), v = g, e.U.P.curveTo(o, c, p, U, g, l, v);
                    else if ("o10" == x || "o29" == x) {
                        var A = "o10" == x ? n : a;
                        if (0 == s.length) console.debug("error: empty stack");
                        else {
                            var W = s.pop(), M = A.Subrs[W + A.Bias];
                            t.x = l, t.y = v, t.nStems = i, t.haveWidth = h, t.width = f, t.open = d, e.U._drawCFF(M, t, a, n, o), l = t.x, v = t.y, i = t.nStems, h = t.haveWidth, f = t.width, d = t.open;
                        }
                    } else if ("o30" == x || "o31" == x) {
                        var V = s.length, N = (T = 0, "o31" == x);
                        for(T += V - (P = -3 & V); T < P;)N ? (p = v, U = (c = l + s.shift()) + s.shift(), v = (g = p + s.shift()) + s.shift(), P - T == 5 ? (l = U + s.shift(), T++) : l = U, N = !1) : (c = l, p = v + s.shift(), U = c + s.shift(), g = p + s.shift(), l = U + s.shift(), P - T == 5 ? (v = g + s.shift(), T++) : v = g, N = !0), e.U.P.curveTo(o, c, p, U, g, l, v), T += 4;
                    } else {
                        if ("o" == (x + "").charAt(0)) throw console.debug("Unknown operation: " + x, r), x;
                        s.push(x);
                    }
                }
            }
            t.x = l, t.y = v, t.nStems = i, t.haveWidth = h, t.width = f, t.open = d;
        };
        var t = e, a = {
            Typr: t
        };
        return r.Typr = t, r.default = a, Object.defineProperty(r, "__esModule", {
            value: !0
        }), r;
    }({}).Typr;
}
/*!
Custom bundle of woff2otf (https://github.com/arty-name/woff2otf) with fflate
(https://github.com/101arrowz/fflate) for use in Troika text rendering. 
Original licenses apply: 
- fflate: https://github.com/101arrowz/fflate/blob/master/LICENSE (MIT)
- woff2otf.js: https://github.com/arty-name/woff2otf/blob/master/woff2otf.js (Apache2)
*/ function $55f5ea5649168877$var$woff2otfFactory() {
    return function(r) {
        var e = Uint8Array, n = Uint16Array, t = Uint32Array, a = new e([
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            1,
            1,
            1,
            1,
            2,
            2,
            2,
            2,
            3,
            3,
            3,
            3,
            4,
            4,
            4,
            4,
            5,
            5,
            5,
            5,
            0,
            0,
            0,
            0
        ]), i = new e([
            0,
            0,
            0,
            0,
            1,
            1,
            2,
            2,
            3,
            3,
            4,
            4,
            5,
            5,
            6,
            6,
            7,
            7,
            8,
            8,
            9,
            9,
            10,
            10,
            11,
            11,
            12,
            12,
            13,
            13,
            0,
            0
        ]), o = new e([
            16,
            17,
            18,
            0,
            8,
            7,
            9,
            6,
            10,
            5,
            11,
            4,
            12,
            3,
            13,
            2,
            14,
            1,
            15
        ]), f = function(r, e) {
            for(var a = new n(31), i = 0; i < 31; ++i)a[i] = e += 1 << r[i - 1];
            var o = new t(a[30]);
            for(i = 1; i < 30; ++i)for(var f = a[i]; f < a[i + 1]; ++f)o[f] = f - a[i] << 5 | i;
            return [
                a,
                o
            ];
        }, u = f(a, 2), v = u[0], s = u[1];
        v[28] = 258, s[258] = 28;
        for(var l = f(i, 0)[0], c = new n(32768), g = 0; g < 32768; ++g){
            var h = (43690 & g) >>> 1 | (21845 & g) << 1;
            h = (61680 & (h = (52428 & h) >>> 2 | (13107 & h) << 2)) >>> 4 | (3855 & h) << 4, c[g] = ((65280 & h) >>> 8 | (255 & h) << 8) >>> 1;
        }
        var w = function(r, e, t) {
            for(var a = r.length, i = 0, o = new n(e); i < a; ++i)++o[r[i] - 1];
            var f, u = new n(e);
            for(i = 0; i < e; ++i)u[i] = u[i - 1] + o[i - 1] << 1;
            if (t) {
                f = new n(1 << e);
                var v = 15 - e;
                for(i = 0; i < a; ++i)if (r[i]) for(var s = i << 4 | r[i], l = e - r[i], g = u[r[i] - 1]++ << l, h = g | (1 << l) - 1; g <= h; ++g)f[c[g] >>> v] = s;
            } else for(f = new n(a), i = 0; i < a; ++i)r[i] && (f[i] = c[u[r[i] - 1]++] >>> 15 - r[i]);
            return f;
        }, d = new e(288);
        for(g = 0; g < 144; ++g)d[g] = 8;
        for(g = 144; g < 256; ++g)d[g] = 9;
        for(g = 256; g < 280; ++g)d[g] = 7;
        for(g = 280; g < 288; ++g)d[g] = 8;
        var m = new e(32);
        for(g = 0; g < 32; ++g)m[g] = 5;
        var b = w(d, 9, 1), p = w(m, 5, 1), y = function(r) {
            for(var e = r[0], n = 1; n < r.length; ++n)r[n] > e && (e = r[n]);
            return e;
        }, L = function(r, e, n) {
            var t = e / 8 | 0;
            return (r[t] | r[t + 1] << 8) >> (7 & e) & n;
        }, U = function(r, e) {
            var n = e / 8 | 0;
            return (r[n] | r[n + 1] << 8 | r[n + 2] << 16) >> (7 & e);
        }, k = [
            "unexpected EOF",
            "invalid block type",
            "invalid length/literal",
            "invalid distance",
            "stream finished",
            "no stream handler",
            ,
            "no callback",
            "invalid UTF-8 data",
            "extra field too long",
            "date not in range 1980-2099",
            "filename too long",
            "stream finishing",
            "invalid zip data"
        ], T = function(r, e, n) {
            var t = new Error(e || k[r]);
            if (t.code = r, Error.captureStackTrace && Error.captureStackTrace(t, T), !n) throw t;
            return t;
        }, O = function(r, f, u) {
            var s = r.length;
            if (!s || u && !u.l && s < 5) return f || new e(0);
            var c = !f || u, g = !u || u.i;
            u || (u = {}), f || (f = new e(3 * s));
            var h, d = function(r) {
                var n = f.length;
                if (r > n) {
                    var t = new e(Math.max(2 * n, r));
                    t.set(f), f = t;
                }
            }, m = u.f || 0, k = u.p || 0, O = u.b || 0, A = u.l, x = u.d, E = u.m, D = u.n, M = 8 * s;
            do {
                if (!A) {
                    u.f = m = L(r, k, 1);
                    var S = L(r, k + 1, 3);
                    if (k += 3, !S) {
                        var V = r[(I = ((h = k) / 8 | 0) + (7 & h && 1) + 4) - 4] | r[I - 3] << 8, _ = I + V;
                        if (_ > s) {
                            g && T(0);
                            break;
                        }
                        c && d(O + V), f.set(r.subarray(I, _), O), u.b = O += V, u.p = k = 8 * _;
                        continue;
                    }
                    if (1 == S) A = b, x = p, E = 9, D = 5;
                    else if (2 == S) {
                        var j = L(r, k, 31) + 257, z = L(r, k + 10, 15) + 4, C = j + L(r, k + 5, 31) + 1;
                        k += 14;
                        for(var F = new e(C), P = new e(19), q = 0; q < z; ++q)P[o[q]] = L(r, k + 3 * q, 7);
                        k += 3 * z;
                        var B = y(P), G = (1 << B) - 1, H = w(P, B, 1);
                        for(q = 0; q < C;){
                            var I, J = H[L(r, k, G)];
                            if (k += 15 & J, (I = J >>> 4) < 16) F[q++] = I;
                            else {
                                var K = 0, N = 0;
                                for(16 == I ? (N = 3 + L(r, k, 3), k += 2, K = F[q - 1]) : 17 == I ? (N = 3 + L(r, k, 7), k += 3) : 18 == I && (N = 11 + L(r, k, 127), k += 7); N--;)F[q++] = K;
                            }
                        }
                        var Q = F.subarray(0, j), R = F.subarray(j);
                        E = y(Q), D = y(R), A = w(Q, E, 1), x = w(R, D, 1);
                    } else T(1);
                    if (k > M) {
                        g && T(0);
                        break;
                    }
                }
                c && d(O + 131072);
                for(var W = (1 << E) - 1, X = (1 << D) - 1, Y = k;; Y = k){
                    var Z = (K = A[U(r, k) & W]) >>> 4;
                    if ((k += 15 & K) > M) {
                        g && T(0);
                        break;
                    }
                    if (K || T(2), Z < 256) f[O++] = Z;
                    else {
                        if (256 == Z) {
                            Y = k, A = null;
                            break;
                        }
                        var $ = Z - 254;
                        if (Z > 264) {
                            var rr = a[q = Z - 257];
                            $ = L(r, k, (1 << rr) - 1) + v[q], k += rr;
                        }
                        var er = x[U(r, k) & X], nr = er >>> 4;
                        er || T(3), k += 15 & er;
                        R = l[nr];
                        if (nr > 3) {
                            rr = i[nr];
                            R += U(r, k) & (1 << rr) - 1, k += rr;
                        }
                        if (k > M) {
                            g && T(0);
                            break;
                        }
                        c && d(O + 131072);
                        for(var tr = O + $; O < tr; O += 4)f[O] = f[O - R], f[O + 1] = f[O + 1 - R], f[O + 2] = f[O + 2 - R], f[O + 3] = f[O + 3 - R];
                        O = tr;
                    }
                }
                u.l = A, u.p = Y, u.b = O, A && (m = 1, u.m = E, u.d = x, u.n = D);
            }while (!m);
            return O == f.length ? f : function(r, a, i) {
                (null == a || a < 0) && (a = 0), (null == i || i > r.length) && (i = r.length);
                var o = new (r instanceof n ? n : r instanceof t ? t : e)(i - a);
                return o.set(r.subarray(a, i)), o;
            }(f, 0, O);
        }, A = new e(0);
        var x = "undefined" != typeof TextDecoder && new TextDecoder;
        try {
            x.decode(A, {
                stream: !0
            });
        } catch (r) {}
        return r.convert_streams = function(r) {
            var e = new DataView(r), n = 0;
            function t() {
                var r = e.getUint16(n);
                return n += 2, r;
            }
            function a() {
                var r = e.getUint32(n);
                return n += 4, r;
            }
            function i(r) {
                m.setUint16(b, r), b += 2;
            }
            function o(r) {
                m.setUint32(b, r), b += 4;
            }
            for(var f = {
                signature: a(),
                flavor: a(),
                length: a(),
                numTables: t(),
                reserved: t(),
                totalSfntSize: a(),
                majorVersion: t(),
                minorVersion: t(),
                metaOffset: a(),
                metaLength: a(),
                metaOrigLength: a(),
                privOffset: a(),
                privLength: a()
            }, u = 0; Math.pow(2, u) <= f.numTables;)u++;
            u--;
            for(var v = 16 * Math.pow(2, u), s = 16 * f.numTables - v, l = 12, c = [], g = 0; g < f.numTables; g++)c.push({
                tag: a(),
                offset: a(),
                compLength: a(),
                origLength: a(),
                origChecksum: a()
            }), l += 16;
            var h, w = new Uint8Array(12 + 16 * c.length + c.reduce(function(r, e) {
                return r + e.origLength + 4;
            }, 0)), d = w.buffer, m = new DataView(d), b = 0;
            return o(f.flavor), i(f.numTables), i(v), i(u), i(s), c.forEach(function(r) {
                o(r.tag), o(r.origChecksum), o(l), o(r.origLength), r.outOffset = l, (l += r.origLength) % 4 != 0 && (l += 4 - l % 4);
            }), c.forEach(function(e) {
                var n, t = r.slice(e.offset, e.offset + e.compLength);
                if (e.compLength != e.origLength) {
                    var a = new Uint8Array(e.origLength);
                    n = new Uint8Array(t, 2), O(n, a);
                } else a = new Uint8Array(t);
                w.set(a, e.outOffset);
                var i = 0;
                (l = e.outOffset + e.origLength) % 4 != 0 && (i = 4 - l % 4), w.set(new Uint8Array(i).buffer, e.outOffset + e.origLength), h = l + i;
            }), d.slice(0, h);
        }, Object.defineProperty(r, "__esModule", {
            value: !0
        }), r;
    }({}).convert_streams;
}
/**
 * A factory wrapper parsing a font file using Typr.
 * Also adds support for WOFF files (not WOFF2).
 */ /**
 * @typedef ParsedFont
 * @property {number} ascender
 * @property {number} descender
 * @property {number} xHeight
 * @property {(number) => boolean} supportsCodePoint
 * @property {(text:string, fontSize:number, letterSpacing:number, callback) => number} forEachGlyph
 * @property {number} lineGap
 * @property {number} capHeight
 * @property {number} unitsPerEm
 */ /**
 * @typedef {(buffer: ArrayBuffer) => ParsedFont} FontParser
 */ /**
 * @returns {FontParser}
 */ function $55f5ea5649168877$var$parserFactory(Typr, woff2otf) {
    const cmdArgLengths = {
        M: 2,
        L: 2,
        Q: 4,
        C: 6,
        Z: 0
    };
    // {joinType: "skip+step,..."}
    const joiningTypeRawData = {
        "C": "18g,ca,368,1kz",
        "D": "17k,6,2,2+4,5+c,2+6,2+1,10+1,9+f,j+11,2+1,a,2,2+1,15+2,3,j+2,6+3,2+8,2,2,2+1,w+a,4+e,3+3,2,3+2,3+5,23+w,2f+4,3,2+9,2,b,2+3,3,1k+9,6+1,3+1,2+2,2+d,30g,p+y,1,1+1g,f+x,2,sd2+1d,jf3+4,f+3,2+4,2+2,b+3,42,2,4+2,2+1,2,3,t+1,9f+w,2,el+2,2+g,d+2,2l,2+1,5,3+1,2+1,2,3,6,16wm+1v",
        "R": "17m+3,2,2,6+3,m,15+2,2+2,h+h,13,3+8,2,2,3+1,2,p+1,x,5+4,5,a,2,2,3,u,c+2,g+1,5,2+1,4+1,5j,6+1,2,b,2+2,f,2+1,1s+2,2,3+1,7,1ez0,2,2+1,4+4,b,4,3,b,42,2+2,4,3,2+1,2,o+3,ae,ep,x,2o+2,3+1,3,5+1,6",
        "L": "x9u,jff,a,fd,jv",
        "T": "4t,gj+33,7o+4,1+1,7c+18,2,2+1,2+1,2,21+a,2,1b+k,h,2u+6,3+5,3+1,2+3,y,2,v+q,2k+a,1n+8,a,p+3,2+8,2+2,2+4,18+2,3c+e,2+v,1k,2,5+7,5,4+6,b+1,u,1n,5+3,9,l+1,r,3+1,1m,5+1,5+1,3+2,4,v+1,4,c+1,1m,5+4,2+1,5,l+1,n+5,2,1n,3,2+3,9,8+1,c+1,v,1q,d,1f,4,1m+2,6+2,2+3,8+1,c+1,u,1n,3,7,6+1,l+1,t+1,1m+1,5+3,9,l+1,u,21,8+2,2,2j,3+6,d+7,2r,3+8,c+5,23+1,s,2,2,1k+d,2+4,2+1,6+a,2+z,a,2v+3,2+5,2+1,3+1,q+1,5+2,h+3,e,3+1,7,g,jk+2,qb+2,u+2,u+1,v+1,1t+1,2+6,9,3+a,a,1a+2,3c+1,z,3b+2,5+1,a,7+2,64+1,3,1n,2+6,2,2,3+7,7+9,3,1d+d,1,1+1,1s+3,1d,2+4,2,6,15+8,d+1,x+3,3+1,2+2,1l,2+1,4,2+2,1n+7,3+1,49+2,2+c,2+6,5,7,4+1,5j+1l,2+4,ek,3+1,r+4,1e+4,6+5,2p+c,1+3,1,1+2,1+b,2db+2,3y,2p+v,ff+3,30+1,n9x,1+2,2+9,x+1,29+1,7l,4,5,q+1,6,48+1,r+h,e,13+7,q+a,1b+2,1d,3+3,3+1,14,1w+5,3+1,3+1,d,9,1c,1g,2+2,3+1,6+1,2,17+1,9,6n,3,5,fn5,ki+f,h+f,5s,6y+2,ea,6b,46+4,1af+2,2+1,6+3,15+2,5,4m+1,fy+3,as+1,4a+a,4x,1j+e,1l+2,1e+3,3+1,1y+2,11+4,2+7,1r,d+1,1h+8,b+3,3,2o+2,3,2+1,7,4h,4+7,m+1,1m+1,4,12+6,4+4,5g+7,3+2,2,o,2d+5,2,5+1,2+1,6n+3,7+1,2+1,s+1,2e+7,3,2+1,2z,2,3+5,2,2u+2,3+3,2+4,78+8,2+1,75+1,2,5,41+3,3+1,5,x+9,15+5,3+3,9,a+5,3+2,1b+c,2+1,bb+6,2+5,2,2b+l,3+6,2+1,2+1,3f+5,4,2+1,2+6,2,21+1,4,2,9o+1,470+8,at4+4,1o+6,t5,1s+3,2a,f5l+1,2+3,43o+2,a+7,1+7,3+6,v+3,45+2,1j0+1i,5+1d,9,f,n+4,2+e,11t+6,2+g,3+6,2+1,2+4,7a+6,c6+3,15t+6,32+6,1,gzau,v+2n,3l+6n"
    };
    const JT_LEFT = 1, JT_RIGHT = 2, JT_DUAL = 4, JT_TRANSPARENT = 8, JT_JOIN_CAUSING = 16, JT_NON_JOINING = 32; //indicates that a character does not join with the preceding or with the subsequent character.,
    let joiningTypeMap;
    function getCharJoiningType(ch) {
        if (!joiningTypeMap) {
            const m = {
                R: JT_RIGHT,
                L: JT_LEFT,
                D: JT_DUAL,
                C: JT_JOIN_CAUSING,
                U: JT_NON_JOINING,
                T: JT_TRANSPARENT
            };
            joiningTypeMap = new Map();
            for(let type in joiningTypeRawData){
                let lastCode = 0;
                joiningTypeRawData[type].split(",").forEach((range)=>{
                    let [skip, step] = range.split("+");
                    skip = parseInt(skip, 36);
                    step = step ? parseInt(step, 36) : 0;
                    joiningTypeMap.set(lastCode += skip, m[type]);
                    for(let i = step; i--;)joiningTypeMap.set(++lastCode, m[type]);
                });
            }
        }
        return joiningTypeMap.get(ch) || JT_NON_JOINING;
    }
    const ISOL = 1, INIT = 2, FINA = 3, MEDI = 4;
    const formsToFeatures = [
        null,
        "isol",
        "init",
        "fina",
        "medi"
    ];
    function detectJoiningForms(str) {
        // This implements the algorithm described here:
        // https://github.com/n8willis/opentype-shaping-documents/blob/master/opentype-shaping-arabic-general.md
        const joiningForms = new Uint8Array(str.length);
        let prevJoiningType = JT_NON_JOINING;
        let prevForm = ISOL;
        let prevIndex = -1;
        for(let i = 0; i < str.length; i++){
            const code = str.codePointAt(i);
            let joiningType = getCharJoiningType(code) | 0;
            let form = ISOL;
            if (joiningType & JT_TRANSPARENT) continue;
            if (prevJoiningType & (JT_LEFT | JT_DUAL | JT_JOIN_CAUSING)) {
                if (joiningType & (JT_RIGHT | JT_DUAL | JT_JOIN_CAUSING)) {
                    form = FINA;
                    // isol->init, fina->medi
                    if (prevForm === ISOL || prevForm === FINA) joiningForms[prevIndex]++;
                } else if (joiningType & (JT_LEFT | JT_NON_JOINING)) // medi->fina, init->isol
                {
                    if (prevForm === INIT || prevForm === MEDI) joiningForms[prevIndex]--;
                }
            } else if (prevJoiningType & (JT_RIGHT | JT_NON_JOINING)) // medi->fina, init->isol
            {
                if (prevForm === INIT || prevForm === MEDI) joiningForms[prevIndex]--;
            }
            prevForm = joiningForms[i] = form;
            prevJoiningType = joiningType;
            prevIndex = i;
            if (code > 0xffff) i++;
        }
        // console.log(str.split('').map(ch => ch.codePointAt(0).toString(16)))
        // console.log(str.split('').map(ch => getCharJoiningType(ch.codePointAt(0))))
        // console.log(Array.from(joiningForms).map(f => formsToFeatures[f] || 'none'))
        return joiningForms;
    }
    function stringToGlyphs(font, str) {
        const glyphIds = [];
        for(let i = 0; i < str.length; i++){
            const cc = str.codePointAt(i);
            if (cc > 0xffff) i++;
            glyphIds.push(Typr.U.codeToGlyph(font, cc));
        }
        const gsub = font["GSUB"];
        if (gsub) {
            const { lookupList: lookupList, featureList: featureList } = gsub;
            let joiningForms;
            const supportedFeatures = /^(rlig|liga|mset|isol|init|fina|medi|half|pres|blws)$/;
            const usedLookups = [];
            featureList.forEach((feature)=>{
                if (supportedFeatures.test(feature.tag)) for(let ti = 0; ti < feature.tab.length; ti++){
                    if (usedLookups[feature.tab[ti]]) continue;
                    usedLookups[feature.tab[ti]] = true;
                    const tab = lookupList[feature.tab[ti]];
                    const isJoiningFeature = /^(isol|init|fina|medi)$/.test(feature.tag);
                    if (isJoiningFeature && !joiningForms) joiningForms = detectJoiningForms(str);
                    for(let ci = 0; ci < glyphIds.length; ci++)if (!joiningForms || !isJoiningFeature || formsToFeatures[joiningForms[ci]] === feature.tag) Typr.U._applySubs(glyphIds, ci, tab, lookupList);
                }
            });
        }
        return glyphIds;
    }
    function firstNum(...args) {
        for(let i = 0; i < args.length; i++){
            if (typeof args[i] === "number") return args[i];
        }
    }
    /**
   * @returns ParsedFont
   */ function wrapFontObj(typrFont) {
        const glyphMap = Object.create(null);
        const os2 = typrFont["OS/2"];
        const hhea = typrFont.hhea;
        const unitsPerEm = typrFont.head.unitsPerEm;
        const ascender = firstNum(os2 && os2.sTypoAscender, hhea && hhea.ascender, unitsPerEm);
        /** @type ParsedFont */ const fontObj = {
            unitsPerEm: unitsPerEm,
            ascender: ascender,
            descender: firstNum(os2 && os2.sTypoDescender, hhea && hhea.descender, 0),
            capHeight: firstNum(os2 && os2.sCapHeight, ascender),
            xHeight: firstNum(os2 && os2.sxHeight, ascender),
            lineGap: firstNum(os2 && os2.sTypoLineGap, hhea && hhea.lineGap),
            supportsCodePoint (code) {
                return Typr.U.codeToGlyph(typrFont, code) > 0;
            },
            forEachGlyph (text, fontSize, letterSpacing, callback) {
                let glyphX = 0;
                const fontScale = 1 / fontObj.unitsPerEm * fontSize;
                const glyphIndices = stringToGlyphs(typrFont, text);
                let charIndex = 0;
                let prevGlyphIndex = -1;
                glyphIndices.forEach((glyphIndex, i)=>{
                    // Typr returns a glyph index per string codepoint, with -1s in place of those that
                    // were omitted due to ligature substitution. So we can track original index in the
                    // string via simple increment, and skip everything else when seeing a -1.
                    if (glyphIndex !== -1) {
                        let glyphObj = glyphMap[glyphIndex];
                        if (!glyphObj) {
                            const { cmds: cmds, crds: crds } = Typr.U.glyphToPath(typrFont, glyphIndex);
                            // Build path string
                            let path = "";
                            let crdsIdx = 0;
                            for(let i = 0, len = cmds.length; i < len; i++){
                                const numArgs = cmdArgLengths[cmds[i]];
                                path += cmds[i];
                                for(let j = 1; j <= numArgs; j++)path += (j > 1 ? "," : "") + crds[crdsIdx++];
                            }
                            // Find extents - Glyf gives this in metadata but not CFF, and Typr doesn't
                            // normalize the two, so it's simplest just to iterate ourselves.
                            let xMin, yMin, xMax, yMax;
                            if (crds.length) {
                                xMin = yMin = Infinity;
                                xMax = yMax = -Infinity;
                                for(let i = 0, len = crds.length; i < len; i += 2){
                                    let x = crds[i];
                                    let y = crds[i + 1];
                                    if (x < xMin) xMin = x;
                                    if (y < yMin) yMin = y;
                                    if (x > xMax) xMax = x;
                                    if (y > yMax) yMax = y;
                                }
                            } else xMin = xMax = yMin = yMax = 0;
                            glyphObj = glyphMap[glyphIndex] = {
                                index: glyphIndex,
                                advanceWidth: typrFont.hmtx.aWidth[glyphIndex],
                                xMin: xMin,
                                yMin: yMin,
                                xMax: xMax,
                                yMax: yMax,
                                path: path,
                                pathCommandCount: cmds.length
                            };
                        }
                        // Kerning
                        if (prevGlyphIndex !== -1) glyphX += Typr.U.getPairAdjustment(typrFont, prevGlyphIndex, glyphIndex) * fontScale;
                        callback.call(null, glyphObj, glyphX, charIndex);
                        if (glyphObj.advanceWidth) glyphX += glyphObj.advanceWidth * fontScale;
                        if (letterSpacing) glyphX += letterSpacing * fontSize;
                        prevGlyphIndex = glyphIndex;
                    }
                    charIndex += text.codePointAt(charIndex) > 0xffff ? 2 : 1;
                });
                return glyphX;
            }
        };
        return fontObj;
    }
    /**
   * @type FontParser
   */ return function parse(buffer) {
        // Look to see if we have a WOFF file and convert it if so:
        const peek = new Uint8Array(buffer, 0, 4);
        const tag = Typr._bin.readASCII(peek, 0, 4);
        if (tag === "wOFF") buffer = woff2otf(buffer);
        else if (tag === "wOF2") throw new Error("woff2 fonts not supported");
        return wrapFontObj(Typr.parse(buffer)[0]);
    };
}
const $55f5ea5649168877$var$workerModule = /*#__PURE__*/ (0, $ca0116d492137119$export$e2063b0a5e3f6023)({
    name: "Typr Font Parser",
    dependencies: [
        $55f5ea5649168877$var$typrFactory,
        $55f5ea5649168877$var$woff2otfFactory,
        $55f5ea5649168877$var$parserFactory
    ],
    init (typrFactory, woff2otfFactory, parserFactory) {
        const Typr = typrFactory();
        const woff2otf = woff2otfFactory();
        return parserFactory(Typr, woff2otf);
    }
});
/*!
Custom bundle of @unicode-font-resolver/client v0.3.2 (https://github.com/lojjic/unicode-font-resolver)
for use in Troika text rendering. 
Original MIT license applies
*/ function $55f5ea5649168877$var$unicodeFontResolverClientFactory() {
    return function(t) {
        class e {
            add(t) {
                const e = t >> 5;
                this.buckets.set(e, (this.buckets.get(e) || 0) | 1 << (31 & t));
            }
            has(t) {
                const e = this.buckets.get(t >> 5);
                return void 0 !== e && 0 != (e & 1 << (31 & t));
            }
            serialize() {
                const t = [];
                return this.buckets.forEach((e, n)=>{
                    t.push(`${(+n).toString(36)}:${e.toString(36)}`);
                }), t.join(",");
            }
            deserialize(t) {
                this.buckets.clear(), t.split(",").forEach((t)=>{
                    const e = t.split(":");
                    this.buckets.set(parseInt(e[0], 36), parseInt(e[1], 36));
                });
            }
            constructor(){
                this.buckets = new Map;
            }
        }
        const n = Math.pow(2, 8), o = n - 1, r = ~o;
        function s(t) {
            const e = (function(t) {
                return t & r;
            })(t).toString(16), o = (function(t) {
                return (t & r) + n - 1;
            })(t).toString(16);
            return `codepoint-index/plane${t >> 16}/${e}-${o}.json`;
        }
        function i(t, e) {
            const n = t & o;
            let r = e.codePointAt(n / 6 | 0);
            return r = (r || 48) - 48, 0 != (r & 1 << n % 6);
        }
        function c(t, e) {
            var n;
            (n = t, n.replace(/U\+/gi, "").replace(/^,+|,+$/g, "").split(/,+/).map((t)=>t.split("-").map((t)=>parseInt(t.trim(), 16)))).forEach(([t, n = t])=>{
                e(t, n);
            });
        }
        function l(t, e) {
            c(t, (t, n)=>{
                for(let o = t; o <= n; o++)e(o);
            });
        }
        let a = {}, u = {};
        const f = new WeakMap;
        function h(t) {
            let n = f.get(t);
            return n || (n = new e, l(t.ranges, (t)=>n.add(t)), f.set(t, n)), n;
        }
        const d = new Map;
        function g(t) {
            let e = d.get(t);
            return e || (e = fetch(t).then((t)=>t.json()), d.set(t, e)), e;
        }
        function p(t, e, n) {
            return t[e] ? e : t[n] ? n : function(t) {
                for(const e in t)return e;
            }(t);
        }
        function $(t, e) {
            let n = e;
            if (!t.includes(n)) {
                n = 1 / 0;
                for(let o = 0; o < t.length; o++)Math.abs(t[o] - e) < Math.abs(n - e) && (n = t[o]);
            }
            return n;
        }
        let v;
        function w(t) {
            return v || (v = new Set, l("9-D,20,85,A0,1680,2000-200A,2028-202F,205F,3000", (t)=>{
                v.add(t);
            })), v.has(t);
        }
        return t.CodePointSet = e, t.clearCache = function() {
            a = {}, u = {};
        }, t.getFontsForString = function(t, e = {}) {
            const { lang: n = "en", category: o = "sans-serif", style: r = "normal", weight: c = 400 } = e, l = (e.dataUrl || "https://cdn.jsdelivr.net/gh/lojjic/unicode-font-resolver@v0.3.2/packages/data").replace(/\/$/g, ""), f = new Map, d = new Uint8Array(t.length), v = {}, b = {}, k = new Array(t.length), m = new Map;
            for(let e = 0; e < t.length; e++){
                const n = t.codePointAt(e), o = s(n);
                k[e] = o, a[o] || m.has(o) || m.set(o, g(`${l}/${o}`).then((t)=>{
                    a[o] = t;
                })), n > 65535 && e++;
            }
            return Promise.all(m.values()).then(()=>{
                m.clear();
                for(let e = 0; e < t.length; e++){
                    const o = t.codePointAt(e);
                    let r = null;
                    const s = a[k[e]];
                    t: for(let t in s){
                        let e = b[t];
                        if (void 0 === e && (e = b[t] = new RegExp(t).test(n)), e) {
                            for(let e in s[t])if (i(o, s[t][e])) {
                                r = e;
                                break t;
                            }
                        }
                    }
                    r || (console.debug(`No font coverage for U+${o.toString(16)}`), r = "latin"), k[e] = r, u[r] || m.has(r) || m.set(r, g(`${l}/font-meta/${r}.json`).then((t)=>{
                        u[r] = t;
                    })), o > 65535 && e++;
                }
                return Promise.all(m.values());
            }).then(()=>{
                var e;
                let n = null;
                for(let s = 0; s < t.length; s++){
                    const i = t.codePointAt(s);
                    if (n && (w(i) || h(n).has(i))) d[s] = d[s - 1];
                    else {
                        n = u[k[s]];
                        let t = v[n.id];
                        if (!t) {
                            const { typeforms: s } = n, i = p(s, o, "sans-serif"), a = p(s[i], r, "normal"), u = $(null === (e = s[i]) || void 0 === e ? void 0 : e[a], c);
                            t = v[n.id] = `${l}/font-files/${n.id}/${i}.${a}.${u}.woff`;
                        }
                        let i = f.get(t);
                        null == i && (i = f.size, f.set(t, i)), d[s] = i;
                    }
                    i > 65535 && (s++, d[s] = d[s - 1]);
                }
                return {
                    fontUrls: Array.from(f.keys()),
                    chars: d
                };
            });
        }, Object.defineProperty(t, "__esModule", {
            value: !0
        }), t;
    }({});
}
/**
 * @typedef {string | {src:string, label?:string, unicodeRange?:string, lang?:string}} UserFont
 */ /**
 * @typedef {ClientOptions} FontResolverOptions
 * @property {Array<UserFont>|UserFont} [fonts]
 * @property {'normal'|'italic'} [style]
 * @property {'normal'|'bold'|number} [style]
 */ /**
 * @typedef {Object} FontResolverResult
 * @property {Uint8Array} chars
 * @property {Array<ParsedFont & {src:string}>} fonts
 */ /**
 * @typedef {function} FontResolver
 * @param {string} text
 * @param {(FontResolverResult) => void} callback
 * @param {FontResolverOptions} [options]
 */ /**
 * Factory for the FontResolver function.
 * @param {FontParser} fontParser
 * @param {{getFontsForString: function, CodePointSet: function}} unicodeFontResolverClient
 * @return {FontResolver}
 */ function $55f5ea5649168877$var$createFontResolver(fontParser, unicodeFontResolverClient) {
    /**
   * @type {Record<string, ParsedFont>}
   */ const parsedFonts = Object.create(null);
    /**
   * @type {Record<string, Array<(ParsedFont) => void>>}
   */ const loadingFonts = Object.create(null);
    /**
   * Load a given font url
   */ function doLoadFont(url, callback) {
        const onError = (err)=>{
            console.error(`Failure loading font ${url}`, err);
        };
        try {
            const request = new XMLHttpRequest();
            request.open("get", url, true);
            request.responseType = "arraybuffer";
            request.onload = function() {
                if (request.status >= 400) onError(new Error(request.statusText));
                else if (request.status > 0) try {
                    const fontObj = fontParser(request.response);
                    fontObj.src = url;
                    callback(fontObj);
                } catch (e) {
                    onError(e);
                }
            };
            request.onerror = onError;
            request.send();
        } catch (err) {
            onError(err);
        }
    }
    /**
   * Load a given font url if needed, invoking a callback when it's loaded. If already
   * loaded, the callback will be called synchronously.
   * @param {string} fontUrl
   * @param {(font: ParsedFont) => void} callback
   */ function loadFont(fontUrl, callback) {
        let font = parsedFonts[fontUrl];
        if (font) callback(font);
        else if (loadingFonts[fontUrl]) loadingFonts[fontUrl].push(callback);
        else {
            loadingFonts[fontUrl] = [
                callback
            ];
            doLoadFont(fontUrl, (fontObj)=>{
                fontObj.src = fontUrl;
                parsedFonts[fontUrl] = fontObj;
                loadingFonts[fontUrl].forEach((cb)=>cb(fontObj));
                delete loadingFonts[fontUrl];
            });
        }
    }
    /**
   * For a given string of text, determine which fonts are required to fully render it and
   * ensure those fonts are loaded.
   */ return function(text, callback, { lang: lang, fonts: userFonts = [], style: style = "normal", weight: weight = "normal" } = {}) {
        const charResolutions = new Uint8Array(text.length);
        const fontResolutions = [];
        if (!text.length) allDone();
        const fontIndices = new Map();
        const fallbackRanges = []; // [[start, end], ...]
        if (style !== "italic") style = "normal";
        if (typeof weight !== "number") weight = weight === "bold" ? 700 : 400;
        if (userFonts && !Array.isArray(userFonts)) userFonts = [
            userFonts
        ];
        userFonts = userFonts.slice()// filter by language
        .filter((def)=>!def.lang || def.lang.test(lang))// switch order for easier iteration
        .reverse();
        if (userFonts.length) {
            const UNKNOWN = 0;
            const RESOLVED = 1;
            const NEEDS_FALLBACK = 2;
            let prevCharResult = UNKNOWN;
            (function resolveUserFonts(startIndex = 0) {
                for(let i = startIndex, iLen = text.length; i < iLen; i++){
                    const codePoint = text.codePointAt(i);
                    // Carry previous character's result forward if:
                    // - it resolved to a font that also covers this character
                    // - this character is whitespace
                    if (prevCharResult === RESOLVED && fontResolutions[charResolutions[i - 1]].supportsCodePoint(codePoint) || /\s/.test(text[i])) {
                        charResolutions[i] = charResolutions[i - 1];
                        if (prevCharResult === NEEDS_FALLBACK) fallbackRanges[fallbackRanges.length - 1][1] = i;
                    } else {
                        for(let j = charResolutions[i], jLen = userFonts.length; j <= jLen; j++)if (j === jLen) {
                            // none of the user fonts matched; needs fallback
                            const range = prevCharResult === NEEDS_FALLBACK ? fallbackRanges[fallbackRanges.length - 1] : fallbackRanges[fallbackRanges.length] = [
                                i,
                                i
                            ];
                            range[1] = i;
                            prevCharResult = NEEDS_FALLBACK;
                        } else {
                            charResolutions[i] = j;
                            const { src: src, unicodeRange: unicodeRange } = userFonts[j];
                            // filter by optional explicit unicode ranges
                            if (!unicodeRange || isCodeInRanges(codePoint, unicodeRange)) {
                                const fontObj = parsedFonts[src];
                                // font not yet loaded, load it and resume
                                if (!fontObj) {
                                    loadFont(src, ()=>{
                                        resolveUserFonts(i);
                                    });
                                    return;
                                }
                                // if the font actually contains a glyph for this char, lock it in
                                if (fontObj.supportsCodePoint(codePoint)) {
                                    let fontIndex = fontIndices.get(fontObj);
                                    if (typeof fontIndex !== "number") {
                                        fontIndex = fontResolutions.length;
                                        fontResolutions.push(fontObj);
                                        fontIndices.set(fontObj, fontIndex);
                                    }
                                    charResolutions[i] = fontIndex;
                                    prevCharResult = RESOLVED;
                                    break;
                                }
                            }
                        }
                    }
                    if (codePoint > 0xffff && i + 1 < iLen) {
                        charResolutions[i + 1] = charResolutions[i];
                        i++;
                        if (prevCharResult === NEEDS_FALLBACK) fallbackRanges[fallbackRanges.length - 1][1] = i;
                    }
                }
                resolveFallbacks();
            })();
        } else {
            fallbackRanges.push([
                0,
                text.length - 1
            ]);
            resolveFallbacks();
        }
        function resolveFallbacks() {
            if (fallbackRanges.length) {
                // Combine all fallback substrings into a single string for querying
                const fallbackString = fallbackRanges.map((range)=>text.substring(range[0], range[1] + 1)).join("\n");
                unicodeFontResolverClient.getFontsForString(fallbackString, {
                    lang: lang,
                    style: style,
                    weight: weight
                }).then(({ fontUrls: fontUrls, chars: chars })=>{
                    // Extract results and put them back in the main array
                    const fontIndexOffset = fontResolutions.length;
                    let charIdx = 0;
                    fallbackRanges.forEach((range)=>{
                        for(let i = 0, endIdx = range[1] - range[0]; i <= endIdx; i++)charResolutions[range[0] + i] = chars[charIdx++] + fontIndexOffset;
                        charIdx++; //skip segment separator
                    });
                    // Load and parse the fallback fonts - avoiding Promise here to prevent polyfills in the worker
                    let loadedCount = 0;
                    fontUrls.forEach((url, i)=>{
                        loadFont(url, (fontObj)=>{
                            fontResolutions[i + fontIndexOffset] = fontObj;
                            if (++loadedCount === fontUrls.length) allDone();
                        });
                    });
                });
            } else allDone();
        }
        function allDone() {
            callback({
                chars: charResolutions,
                fonts: fontResolutions
            });
        }
        function isCodeInRanges(code, ranges) {
            // todo optimize search - CodePointSet from unicode-font-resolver?
            for(let k = 0; k < ranges.length; k++){
                const [start, end = start] = ranges[k];
                if (start <= code && code <= end) return true;
            }
            return false;
        }
    };
}
const $55f5ea5649168877$export$85a5d697a084610 = /*#__PURE__*/ (0, $ca0116d492137119$export$e2063b0a5e3f6023)({
    name: "FontResolver",
    dependencies: [
        $55f5ea5649168877$var$createFontResolver,
        $55f5ea5649168877$var$workerModule,
        $55f5ea5649168877$var$unicodeFontResolverClientFactory
    ],
    init (createFontResolver, fontParser, unicodeFontResolverClientFactory) {
        return createFontResolver(fontParser, unicodeFontResolverClientFactory());
    }
});
/**
 * @typedef {number|'left'|'center'|'right'} AnchorXValue
 */ /**
 * @typedef {number|'top'|'top-baseline'|'top-cap'|'top-ex'|'middle'|'bottom-baseline'|'bottom'} AnchorYValue
 */ /**
 * @typedef {object} TypesetParams
 * @property {string} text
 * @property {UserFont|UserFont[]} [font]
 * @property {string} [lang='en']
 * @property {number} [sdfGlyphSize=64]
 * @property {number} [fontSize=1]
 * @property {number|'normal'|'bold'} [fontWeight='normal']
 * @property {'normal'|'italic'} [fontStyle='normal']
 * @property {number} [letterSpacing=0]
 * @property {'normal'|number} [lineHeight='normal']
 * @property {number} [maxWidth]
 * @property {'ltr'|'rtl'} [direction='ltr']
 * @property {string} [textAlign='left']
 * @property {number} [textIndent=0]
 * @property {'normal'|'nowrap'} [whiteSpace='normal']
 * @property {'normal'|'break-word'} [overflowWrap='normal']
 * @property {AnchorXValue} [anchorX=0]
 * @property {AnchorYValue} [anchorY=0]
 * @property {boolean} [metricsOnly=false]
 * @property {FontResolverResult} [preResolvedFonts]
 * @property {boolean} [includeCaretPositions=false]
 * @property {number} [chunkedBoundsSize=8192]
 * @property {{[rangeStartIndex]: number}} [colorRanges]
 */ /**
 * @typedef {object} TypesetResult
 * @property {Uint16Array} glyphIds id for each glyph, specific to that glyph's font
 * @property {Uint8Array} glyphFontIndices index into fontData for each glyph
 * @property {Float32Array} glyphPositions x,y of each glyph's origin in layout
 * @property {{[font]: {[glyphId]: {path: string, pathBounds: number[]}}}} glyphData data about each glyph appearing in the text
 * @property {TypesetFontData[]} fontData data about each font used in the text
 * @property {Float32Array} [caretPositions] startX,endX,bottomY caret positions for each char
 * @property {Uint8Array} [glyphColors] color for each glyph, if color ranges supplied
 *         chunkedBounds, //total rects per (n=chunkedBoundsSize) consecutive glyphs
 *         fontSize, //calculated em height
 *         topBaseline: anchorYOffset + lines[0].baseline, //y coordinate of the top line's baseline
 *         blockBounds: [ //bounds for the whole block of text, including vertical padding for lineHeight
 *           anchorXOffset,
 *           anchorYOffset - totalHeight,
 *           anchorXOffset + maxLineWidth,
 *           anchorYOffset
 *         ],
 *         visibleBounds, //total bounds of visible text paths, may be larger or smaller than blockBounds
 *         timings
 */ /**
 * @typedef {object} TypesetFontData
 * @property src
 * @property unitsPerEm
 * @property ascender
 * @property descender
 * @property lineHeight
 * @property capHeight
 * @property xHeight
 */ /**
 * @typedef {function} TypesetterTypesetFunction - compute fonts and layout for some text.
 * @param {TypesetParams} params
 * @param {(TypesetResult) => void} callback - function called when typesetting is complete.
 *    If the params included `preResolvedFonts`, this will be called synchronously.
 */ /**
 * @typedef {function} TypesetterMeasureFunction - compute width/height for some text.
 * @param {TypesetParams} params
 * @param {(width:number, height:number) => void} callback - function called when measurement is complete.
 *    If the params included `preResolvedFonts`, this will be called synchronously.
 */ /**
 * Factory function that creates a self-contained environment for processing text typesetting requests.
 *
 * It is important that this function has no closure dependencies, so that it can be easily injected
 * into the source for a Worker without requiring a build step or complex dependency loading. All its
 * dependencies must be passed in at initialization.
 *
 * @param {FontResolver} resolveFonts - function to resolve a string to parsed fonts
 * @param {object} bidi - the bidi.js implementation object
 * @return {{typeset: TypesetterTypesetFunction, measure: TypesetterMeasureFunction}}
 */ function $55f5ea5649168877$var$createTypesetter(resolveFonts, bidi) {
    const INF = Infinity;
    // Set of Unicode Default_Ignorable_Code_Point characters, these will not produce visible glyphs
    // eslint-disable-next-line no-misleading-character-class
    const DEFAULT_IGNORABLE_CHARS = /[\u00AD\u034F\u061C\u115F-\u1160\u17B4-\u17B5\u180B-\u180E\u200B-\u200F\u202A-\u202E\u2060-\u206F\u3164\uFE00-\uFE0F\uFEFF\uFFA0\uFFF0-\uFFF8]/;
    // This regex (instead of /\s/) allows us to select all whitespace EXCEPT for non-breaking white spaces
    const lineBreakingWhiteSpace = `[^\\S\\u00A0]`;
    // Incomplete set of characters that allow line breaking after them
    // In the future we may consider a full Unicode line breaking algorithm impl: https://www.unicode.org/reports/tr14
    const BREAK_AFTER_CHARS = new RegExp(`${lineBreakingWhiteSpace}|[\\-\\u007C\\u00AD\\u2010\\u2012-\\u2014\\u2027\\u2056\\u2E17\\u2E40]`);
    /**
   * Load and parse all the necessary fonts to render a given string of text, then group
   * them into consecutive runs of characters sharing a font.
   */ function calculateFontRuns({ text: text, lang: lang, fonts: fonts, style: style, weight: weight, preResolvedFonts: preResolvedFonts }, onDone) {
        const onResolved = ({ chars: chars, fonts: parsedFonts })=>{
            let curRun, prevVal;
            const runs = [];
            for(let i = 0; i < chars.length; i++)if (chars[i] !== prevVal) {
                prevVal = chars[i];
                runs.push(curRun = {
                    start: i,
                    end: i,
                    fontObj: parsedFonts[chars[i]]
                });
            } else curRun.end = i;
            onDone(runs);
        };
        if (preResolvedFonts) onResolved(preResolvedFonts);
        else resolveFonts(text, onResolved, {
            lang: lang,
            fonts: fonts,
            style: style,
            weight: weight
        });
    }
    /**
   * Main entry point.
   * Process a text string with given font and formatting parameters, and return all info
   * necessary to render all its glyphs.
   * @type TypesetterTypesetFunction
   */ function typeset({ text: text = "", font: font, lang: lang = "en", sdfGlyphSize: sdfGlyphSize = 64, fontSize: fontSize = 400, fontWeight: fontWeight = 1, fontStyle: fontStyle = "normal", letterSpacing: letterSpacing = 0, lineHeight: lineHeight = "normal", maxWidth: maxWidth = INF, direction: direction, textAlign: textAlign = "left", textIndent: textIndent = 0, whiteSpace: whiteSpace = "normal", overflowWrap: overflowWrap = "normal", anchorX: anchorX = 0, anchorY: anchorY = 0, metricsOnly: metricsOnly = false, preResolvedFonts: preResolvedFonts = null, includeCaretPositions: includeCaretPositions = false, chunkedBoundsSize: chunkedBoundsSize = 8192, colorRanges: colorRanges = null }, callback) {
        const mainStart = now();
        const timings = {
            fontLoad: 0,
            typesetting: 0
        };
        // Ensure newlines are normalized
        if (text.indexOf("\r") > -1) {
            console.info("Typesetter: got text with \\r chars; normalizing to \\n");
            text = text.replace(/\r\n/g, "\n").replace(/\r/g, "\n");
        }
        // Ensure we've got numbers not strings
        fontSize = +fontSize;
        letterSpacing = +letterSpacing;
        maxWidth = +maxWidth;
        lineHeight = lineHeight || "normal";
        textIndent = +textIndent;
        calculateFontRuns({
            text: text,
            lang: lang,
            style: fontStyle,
            weight: fontWeight,
            fonts: typeof font === "string" ? [
                {
                    src: font
                }
            ] : font,
            preResolvedFonts: preResolvedFonts
        }, (runs)=>{
            timings.fontLoad = now() - mainStart;
            const hasMaxWidth = isFinite(maxWidth);
            let glyphIds = null;
            let glyphFontIndices = null;
            let glyphPositions = null;
            let glyphData = null;
            let glyphColors = null;
            let caretPositions = null;
            let visibleBounds = null;
            let chunkedBounds = null;
            let maxLineWidth = 0;
            let renderableGlyphCount = 0;
            let canWrap = whiteSpace !== "nowrap";
            const metricsByFont = new Map(); // fontObj -> metrics
            const typesetStart = now();
            // Distribute glyphs into lines based on wrapping
            let lineXOffset = textIndent;
            let prevRunEndX = 0;
            let currentLine = new TextLine();
            const lines = [
                currentLine
            ];
            runs.forEach((run)=>{
                const { fontObj: fontObj } = run;
                const { ascender: ascender, descender: descender, unitsPerEm: unitsPerEm, lineGap: lineGap, capHeight: capHeight, xHeight: xHeight } = fontObj;
                // Calculate metrics for each font used
                let fontData = metricsByFont.get(fontObj);
                if (!fontData) {
                    // Find conversion between native font units and fontSize units
                    const fontSizeMult = fontSize / unitsPerEm;
                    // Determine appropriate value for 'normal' line height based on the font's actual metrics
                    // This does not guarantee individual glyphs won't exceed the line height, e.g. Roboto; should we use yMin/Max instead?
                    const calcLineHeight = lineHeight === "normal" ? (ascender - descender + lineGap) * fontSizeMult : lineHeight * fontSize;
                    // Determine line height and leading adjustments
                    const halfLeading = (calcLineHeight - (ascender - descender) * fontSizeMult) / 2;
                    const caretHeight = Math.min(calcLineHeight, (ascender - descender) * fontSizeMult);
                    const caretTop = (ascender + descender) / 2 * fontSizeMult + caretHeight / 2;
                    fontData = {
                        index: metricsByFont.size,
                        src: fontObj.src,
                        fontObj: fontObj,
                        fontSizeMult: fontSizeMult,
                        unitsPerEm: unitsPerEm,
                        ascender: ascender * fontSizeMult,
                        descender: descender * fontSizeMult,
                        capHeight: capHeight * fontSizeMult,
                        xHeight: xHeight * fontSizeMult,
                        lineHeight: calcLineHeight,
                        baseline: -halfLeading - ascender * fontSizeMult,
                        // cap: -halfLeading - capHeight * fontSizeMult, // cap from top of line height
                        // ex: -halfLeading - xHeight * fontSizeMult, // ex from top of line height
                        caretTop: (ascender + descender) / 2 * fontSizeMult + caretHeight / 2,
                        caretBottom: caretTop - caretHeight
                    };
                    metricsByFont.set(fontObj, fontData);
                }
                const { fontSizeMult: fontSizeMult } = fontData;
                const runText = text.slice(run.start, run.end + 1);
                let prevGlyphX, prevGlyphObj;
                fontObj.forEachGlyph(runText, fontSize, letterSpacing, (glyphObj, glyphX, charIndex)=>{
                    glyphX += prevRunEndX;
                    charIndex += run.start;
                    prevGlyphX = glyphX;
                    prevGlyphObj = glyphObj;
                    const char = text.charAt(charIndex);
                    const glyphWidth = glyphObj.advanceWidth * fontSizeMult;
                    const curLineCount = currentLine.count;
                    let nextLine;
                    // Calc isWhitespace and isEmpty once per glyphObj
                    if (!("isEmpty" in glyphObj)) {
                        glyphObj.isWhitespace = !!char && new RegExp(lineBreakingWhiteSpace).test(char);
                        glyphObj.canBreakAfter = !!char && BREAK_AFTER_CHARS.test(char);
                        glyphObj.isEmpty = glyphObj.xMin === glyphObj.xMax || glyphObj.yMin === glyphObj.yMax || DEFAULT_IGNORABLE_CHARS.test(char);
                    }
                    if (!glyphObj.isWhitespace && !glyphObj.isEmpty) renderableGlyphCount++;
                    // If a non-whitespace character overflows the max width, we need to soft-wrap
                    if (canWrap && hasMaxWidth && !glyphObj.isWhitespace && glyphX + glyphWidth + lineXOffset > maxWidth && curLineCount) {
                        // If it's the first char after a whitespace, start a new line
                        if (currentLine.glyphAt(curLineCount - 1).glyphObj.canBreakAfter) {
                            nextLine = new TextLine();
                            lineXOffset = -glyphX;
                        } else // Back up looking for a whitespace character to wrap at
                        for(let i = curLineCount; i--;){
                            // If we got the start of the line there's no soft break point; make hard break if overflowWrap='break-word'
                            if (i === 0 && overflowWrap === "break-word") {
                                nextLine = new TextLine();
                                lineXOffset = -glyphX;
                                break;
                            } else if (currentLine.glyphAt(i).glyphObj.canBreakAfter) {
                                nextLine = currentLine.splitAt(i + 1);
                                const adjustX = nextLine.glyphAt(0).x;
                                lineXOffset -= adjustX;
                                for(let j = nextLine.count; j--;)nextLine.glyphAt(j).x -= adjustX;
                                break;
                            }
                        }
                        if (nextLine) {
                            currentLine.isSoftWrapped = true;
                            currentLine = nextLine;
                            lines.push(currentLine);
                            maxLineWidth = maxWidth; //after soft wrapping use maxWidth as calculated width
                        }
                    }
                    let fly = currentLine.glyphAt(currentLine.count);
                    fly.glyphObj = glyphObj;
                    fly.x = glyphX + lineXOffset;
                    fly.width = glyphWidth;
                    fly.charIndex = charIndex;
                    fly.fontData = fontData;
                    // Handle hard line breaks
                    if (char === "\n") {
                        currentLine = new TextLine();
                        lines.push(currentLine);
                        lineXOffset = -(glyphX + glyphWidth + letterSpacing * fontSize) + textIndent;
                    }
                });
                // At the end of a run we must capture the x position as the starting point for the next run
                prevRunEndX = prevGlyphX + prevGlyphObj.advanceWidth * fontSizeMult + letterSpacing * fontSize;
            });
            // Calculate width/height/baseline of each line (excluding trailing whitespace) and maximum block width
            let totalHeight = 0;
            lines.forEach((line)=>{
                let isTrailingWhitespace = true;
                for(let i = line.count; i--;){
                    const glyphInfo = line.glyphAt(i);
                    // omit trailing whitespace from width calculation
                    if (isTrailingWhitespace && !glyphInfo.glyphObj.isWhitespace) {
                        line.width = glyphInfo.x + glyphInfo.width;
                        if (line.width > maxLineWidth) maxLineWidth = line.width;
                        isTrailingWhitespace = false;
                    }
                    // use the tallest line height, lowest baseline, and highest cap/ex
                    let { lineHeight: lineHeight, capHeight: capHeight, xHeight: xHeight, baseline: baseline } = glyphInfo.fontData;
                    if (lineHeight > line.lineHeight) line.lineHeight = lineHeight;
                    const baselineDiff = baseline - line.baseline;
                    if (baselineDiff < 0) {
                        line.baseline += baselineDiff;
                        line.cap += baselineDiff;
                        line.ex += baselineDiff;
                    }
                    // compare cap/ex based on new lowest baseline
                    line.cap = Math.max(line.cap, line.baseline + capHeight);
                    line.ex = Math.max(line.ex, line.baseline + xHeight);
                }
                line.baseline -= totalHeight;
                line.cap -= totalHeight;
                line.ex -= totalHeight;
                totalHeight += line.lineHeight;
            });
            // Find overall position adjustments for anchoring
            let anchorXOffset = 0;
            let anchorYOffset = 0;
            if (anchorX) {
                if (typeof anchorX === "number") anchorXOffset = -anchorX;
                else if (typeof anchorX === "string") anchorXOffset = -maxLineWidth * (anchorX === "left" ? 0 : anchorX === "center" ? 0.5 : anchorX === "right" ? 1 : parsePercent(anchorX));
            }
            if (anchorY) {
                if (typeof anchorY === "number") anchorYOffset = -anchorY;
                else if (typeof anchorY === "string") anchorYOffset = anchorY === "top" ? 0 : anchorY === "top-baseline" ? -lines[0].baseline : anchorY === "top-cap" ? -lines[0].cap : anchorY === "top-ex" ? -lines[0].ex : anchorY === "middle" ? totalHeight / 2 : anchorY === "bottom" ? totalHeight : anchorY === "bottom-baseline" ? lines[lines.length - 1].baseline : parsePercent(anchorY) * totalHeight;
            }
            if (!metricsOnly) {
                // Resolve bidi levels
                const bidiLevelsResult = bidi.getEmbeddingLevels(text, direction);
                // Process each line, applying alignment offsets, adding each glyph to the atlas, and
                // collecting all renderable glyphs into a single collection.
                glyphIds = new Uint16Array(renderableGlyphCount);
                glyphFontIndices = new Uint8Array(renderableGlyphCount);
                glyphPositions = new Float32Array(renderableGlyphCount * 2);
                glyphData = {};
                visibleBounds = [
                    INF,
                    INF,
                    -INF,
                    -INF
                ];
                chunkedBounds = [];
                if (includeCaretPositions) caretPositions = new Float32Array(text.length * 4);
                if (colorRanges) glyphColors = new Uint8Array(renderableGlyphCount * 3);
                let renderableGlyphIndex = 0;
                let prevCharIndex = -1;
                let colorCharIndex = -1;
                let chunk;
                let currentColor;
                lines.forEach((line, lineIndex)=>{
                    let { count: lineGlyphCount, width: lineWidth } = line;
                    // Ignore empty lines
                    if (lineGlyphCount > 0) {
                        // Count trailing whitespaces, we want to ignore these for certain things
                        let trailingWhitespaceCount = 0;
                        for(let i = lineGlyphCount; i-- && line.glyphAt(i).glyphObj.isWhitespace;)trailingWhitespaceCount++;
                        // Apply horizontal alignment adjustments
                        let lineXOffset = 0;
                        let justifyAdjust = 0;
                        if (textAlign === "center") lineXOffset = (maxLineWidth - lineWidth) / 2;
                        else if (textAlign === "right") lineXOffset = maxLineWidth - lineWidth;
                        else if (textAlign === "justify" && line.isSoftWrapped) {
                            // count non-trailing whitespace characters, and we'll adjust the offsets per character in the next loop
                            let whitespaceCount = 0;
                            for(let i = lineGlyphCount - trailingWhitespaceCount; i--;)if (line.glyphAt(i).glyphObj.isWhitespace) whitespaceCount++;
                            justifyAdjust = (maxLineWidth - lineWidth) / whitespaceCount;
                        }
                        if (justifyAdjust || lineXOffset) {
                            let justifyOffset = 0;
                            for(let i = 0; i < lineGlyphCount; i++){
                                let glyphInfo = line.glyphAt(i);
                                const glyphObj = glyphInfo.glyphObj;
                                glyphInfo.x += lineXOffset + justifyOffset;
                                // Expand non-trailing whitespaces for justify alignment
                                if (justifyAdjust !== 0 && glyphObj.isWhitespace && i < lineGlyphCount - trailingWhitespaceCount) {
                                    justifyOffset += justifyAdjust;
                                    glyphInfo.width += justifyAdjust;
                                }
                            }
                        }
                        // Perform bidi range flipping
                        const flips = bidi.getReorderSegments(text, bidiLevelsResult, line.glyphAt(0).charIndex, line.glyphAt(line.count - 1).charIndex);
                        for(let fi = 0; fi < flips.length; fi++){
                            const [start, end] = flips[fi];
                            // Map start/end string indices to indices in the line
                            let left = Infinity, right = -Infinity;
                            for(let i = 0; i < lineGlyphCount; i++)if (line.glyphAt(i).charIndex >= start) {
                                let startInLine = i, endInLine = i;
                                for(; endInLine < lineGlyphCount; endInLine++){
                                    let info = line.glyphAt(endInLine);
                                    if (info.charIndex > end) break;
                                    if (endInLine < lineGlyphCount - trailingWhitespaceCount) {
                                        left = Math.min(left, info.x);
                                        right = Math.max(right, info.x + info.width);
                                    }
                                }
                                for(let j = startInLine; j < endInLine; j++){
                                    const glyphInfo = line.glyphAt(j);
                                    glyphInfo.x = right - (glyphInfo.x + glyphInfo.width - left);
                                }
                                break;
                            }
                        }
                        // Assemble final data arrays
                        let glyphObj;
                        const setGlyphObj = (g)=>glyphObj = g;
                        for(let i = 0; i < lineGlyphCount; i++){
                            const glyphInfo = line.glyphAt(i);
                            glyphObj = glyphInfo.glyphObj;
                            const glyphId = glyphObj.index;
                            // Replace mirrored characters in rtl
                            const rtl = bidiLevelsResult.levels[glyphInfo.charIndex] & 1; //odd level means rtl
                            if (rtl) {
                                const mirrored = bidi.getMirroredCharacter(text[glyphInfo.charIndex]);
                                if (mirrored) glyphInfo.fontData.fontObj.forEachGlyph(mirrored, 0, 0, setGlyphObj);
                            }
                            // Add caret positions
                            if (includeCaretPositions) {
                                const { charIndex: charIndex, fontData: fontData } = glyphInfo;
                                const caretLeft = glyphInfo.x + anchorXOffset;
                                const caretRight = glyphInfo.x + glyphInfo.width + anchorXOffset;
                                caretPositions[charIndex * 4] = rtl ? caretRight : caretLeft; //start edge x
                                caretPositions[charIndex * 4 + 1] = rtl ? caretLeft : caretRight; //end edge x
                                caretPositions[charIndex * 4 + 2] = line.baseline + fontData.caretBottom + anchorYOffset; //common bottom y
                                caretPositions[charIndex * 4 + 3] = line.baseline + fontData.caretTop + anchorYOffset; //common top y
                                // If we skipped any chars from the previous glyph (due to ligature subs), fill in caret
                                // positions for those missing char indices; currently this uses a best-guess by dividing
                                // the ligature's width evenly. In the future we may try to use the font's LigatureCaretList
                                // table to get better interior caret positions.
                                const ligCount = charIndex - prevCharIndex;
                                if (ligCount > 1) fillLigatureCaretPositions(caretPositions, prevCharIndex, ligCount);
                                prevCharIndex = charIndex;
                            }
                            // Track current color range
                            if (colorRanges) {
                                const { charIndex: charIndex } = glyphInfo;
                                while(charIndex > colorCharIndex){
                                    colorCharIndex++;
                                    if (colorRanges.hasOwnProperty(colorCharIndex)) currentColor = colorRanges[colorCharIndex];
                                }
                            }
                            // Get atlas data for renderable glyphs
                            if (!glyphObj.isWhitespace && !glyphObj.isEmpty) {
                                const idx = renderableGlyphIndex++;
                                const { fontSizeMult: fontSizeMult, src: fontSrc, index: fontIndex } = glyphInfo.fontData;
                                // Add this glyph's path data
                                const fontGlyphData = glyphData[fontSrc] || (glyphData[fontSrc] = {});
                                if (!fontGlyphData[glyphId]) fontGlyphData[glyphId] = {
                                    path: glyphObj.path,
                                    pathBounds: [
                                        glyphObj.xMin,
                                        glyphObj.yMin,
                                        glyphObj.xMax,
                                        glyphObj.yMax
                                    ]
                                };
                                // Determine final glyph position and add to glyphPositions array
                                const glyphX = glyphInfo.x + anchorXOffset;
                                const glyphY = line.baseline + anchorYOffset;
                                glyphPositions[idx * 2] = glyphX;
                                glyphPositions[idx * 2 + 1] = glyphY;
                                // Track total visible bounds
                                const visX0 = glyphX + glyphObj.xMin * fontSizeMult;
                                const visY0 = glyphY + glyphObj.yMin * fontSizeMult;
                                const visX1 = glyphX + glyphObj.xMax * fontSizeMult;
                                const visY1 = glyphY + glyphObj.yMax * fontSizeMult;
                                if (visX0 < visibleBounds[0]) visibleBounds[0] = visX0;
                                if (visY0 < visibleBounds[1]) visibleBounds[1] = visY0;
                                if (visX1 > visibleBounds[2]) visibleBounds[2] = visX1;
                                if (visY1 > visibleBounds[3]) visibleBounds[3] = visY1;
                                // Track bounding rects for each chunk of N glyphs
                                if (idx % chunkedBoundsSize === 0) {
                                    chunk = {
                                        start: idx,
                                        end: idx,
                                        rect: [
                                            INF,
                                            INF,
                                            -INF,
                                            -INF
                                        ]
                                    };
                                    chunkedBounds.push(chunk);
                                }
                                chunk.end++;
                                const chunkRect = chunk.rect;
                                if (visX0 < chunkRect[0]) chunkRect[0] = visX0;
                                if (visY0 < chunkRect[1]) chunkRect[1] = visY0;
                                if (visX1 > chunkRect[2]) chunkRect[2] = visX1;
                                if (visY1 > chunkRect[3]) chunkRect[3] = visY1;
                                // Add to glyph ids and font indices arrays
                                glyphIds[idx] = glyphId;
                                glyphFontIndices[idx] = fontIndex;
                                // Add colors
                                if (colorRanges) {
                                    const start = idx * 3;
                                    glyphColors[start] = currentColor >> 16 & 255;
                                    glyphColors[start + 1] = currentColor >> 8 & 255;
                                    glyphColors[start + 2] = currentColor & 255;
                                }
                            }
                        }
                    }
                });
                // Fill in remaining caret positions in case the final character was a ligature
                if (caretPositions) {
                    const ligCount = text.length - prevCharIndex;
                    if (ligCount > 1) fillLigatureCaretPositions(caretPositions, prevCharIndex, ligCount);
                }
            }
            // Assemble final data about each font used
            const fontData = [];
            metricsByFont.forEach(({ index: index, src: src, unitsPerEm: unitsPerEm, ascender: ascender, descender: descender, lineHeight: lineHeight, capHeight: capHeight, xHeight: xHeight })=>{
                fontData[index] = {
                    src: src,
                    unitsPerEm: unitsPerEm,
                    ascender: ascender,
                    descender: descender,
                    lineHeight: lineHeight,
                    capHeight: capHeight,
                    xHeight: xHeight
                };
            });
            // Timing stats
            timings.typesetting = now() - typesetStart;
            callback({
                glyphIds: glyphIds,
                glyphFontIndices: glyphFontIndices,
                glyphPositions: glyphPositions,
                glyphData: glyphData,
                fontData: fontData,
                caretPositions: caretPositions,
                glyphColors: // caretHeight, //height of cursor from bottom to top - todo per glyph?
                glyphColors,
                chunkedBounds: chunkedBounds,
                fontSize: fontSize,
                topBaseline: anchorYOffset + lines[0].baseline,
                blockBounds: [
                    anchorXOffset,
                    anchorYOffset - totalHeight,
                    anchorXOffset + maxLineWidth,
                    anchorYOffset
                ],
                visibleBounds: visibleBounds,
                timings: timings
            });
        });
    }
    /**
   * For a given text string and font parameters, determine the resulting block dimensions
   * after wrapping for the given maxWidth.
   * @param args
   * @param callback
   */ function measure(args, callback) {
        typeset({
            ...args,
            metricsOnly: true
        }, (result)=>{
            const [x0, y0, x1, y1] = result.blockBounds;
            callback({
                width: x1 - x0,
                height: y1 - y0
            });
        });
    }
    function parsePercent(str) {
        let match = str.match(/^([\d.]+)%$/);
        let pct = match ? parseFloat(match[1]) : NaN;
        return isNaN(pct) ? 0 : pct / 100;
    }
    function fillLigatureCaretPositions(caretPositions, ligStartIndex, ligCount) {
        const ligStartX = caretPositions[ligStartIndex * 4];
        const ligEndX = caretPositions[ligStartIndex * 4 + 1];
        const ligBottom = caretPositions[ligStartIndex * 4 + 2];
        const ligTop = caretPositions[ligStartIndex * 4 + 3];
        const guessedAdvanceX = (ligEndX - ligStartX) / ligCount;
        for(let i = 0; i < ligCount; i++){
            const startIndex = (ligStartIndex + i) * 4;
            caretPositions[startIndex] = ligStartX + guessedAdvanceX * i;
            caretPositions[startIndex + 1] = ligStartX + guessedAdvanceX * (i + 1);
            caretPositions[startIndex + 2] = ligBottom;
            caretPositions[startIndex + 3] = ligTop;
        }
    }
    function now() {
        return (self.performance || Date).now();
    }
    // Array-backed structure for a single line's glyphs data
    function TextLine() {
        this.data = [];
    }
    const textLineProps = [
        "glyphObj",
        "x",
        "width",
        "charIndex",
        "fontData"
    ];
    TextLine.prototype = {
        width: 0,
        lineHeight: 0,
        baseline: 0,
        cap: 0,
        ex: 0,
        isSoftWrapped: false,
        get count () {
            return Math.ceil(this.data.length / textLineProps.length);
        },
        glyphAt (i) {
            let fly = TextLine.flyweight;
            fly.data = this.data;
            fly.index = i;
            return fly;
        },
        splitAt (i) {
            let newLine = new TextLine();
            newLine.data = this.data.splice(i * textLineProps.length);
            return newLine;
        }
    };
    TextLine.flyweight = textLineProps.reduce((obj, prop, i, all)=>{
        Object.defineProperty(obj, prop, {
            get () {
                return this.data[this.index * textLineProps.length + i];
            },
            set (val) {
                this.data[this.index * textLineProps.length + i] = val;
            }
        });
        return obj;
    }, {
        data: null,
        index: 0
    });
    return {
        typeset: typeset,
        measure: measure
    };
}
const $55f5ea5649168877$var$now = ()=>(self.performance || Date).now();
const $55f5ea5649168877$var$mainThreadGenerator = /*#__PURE__*/ (0, $ecaec7586e6e01a6$export$2e2bcd8739ae039)();
let $55f5ea5649168877$var$warned;
/**
 * Generate an SDF texture image for a single glyph path, placing the result into a webgl canvas at a
 * given location and channel. Utilizes the webgl-sdf-generator external package for GPU-accelerated SDF
 * generation when supported.
 */ function $55f5ea5649168877$var$generateSDF(width, height, path, viewBox, distance, exponent, canvas, x, y, channel, useWebGL = true) {
    // Allow opt-out
    if (!useWebGL) return $55f5ea5649168877$var$generateSDF_JS_Worker(width, height, path, viewBox, distance, exponent, canvas, x, y, channel);
    // Attempt GPU-accelerated generation first
    return $55f5ea5649168877$var$generateSDF_GL(width, height, path, viewBox, distance, exponent, canvas, x, y, channel).then(null, (err)=>{
        // WebGL failed either due to a hard error or unexpected results; fall back to JS in workers
        if (!$55f5ea5649168877$var$warned) {
            console.warn(`WebGL SDF generation failed, falling back to JS`, err);
            $55f5ea5649168877$var$warned = true;
        }
        return $55f5ea5649168877$var$generateSDF_JS_Worker(width, height, path, viewBox, distance, exponent, canvas, x, y, channel);
    });
}
const $55f5ea5649168877$var$queue = [];
const $55f5ea5649168877$var$chunkTimeBudget = 5; // ms
let $55f5ea5649168877$var$timer = 0;
function $55f5ea5649168877$var$nextChunk() {
    const start = $55f5ea5649168877$var$now();
    while($55f5ea5649168877$var$queue.length && $55f5ea5649168877$var$now() - start < $55f5ea5649168877$var$chunkTimeBudget)$55f5ea5649168877$var$queue.shift()();
    $55f5ea5649168877$var$timer = $55f5ea5649168877$var$queue.length ? setTimeout($55f5ea5649168877$var$nextChunk, 0) : 0;
}
/**
 * WebGL-based implementation executed on the main thread. Requests are executed in time-bounded
 * macrotask chunks to allow render frames to execute in between.
 */ const $55f5ea5649168877$var$generateSDF_GL = (...args)=>{
    return new Promise((resolve, reject)=>{
        $55f5ea5649168877$var$queue.push(()=>{
            const start = $55f5ea5649168877$var$now();
            try {
                $55f5ea5649168877$var$mainThreadGenerator.webgl.generateIntoCanvas(...args);
                resolve({
                    timing: $55f5ea5649168877$var$now() - start
                });
            } catch (err) {
                reject(err);
            }
        });
        if (!$55f5ea5649168877$var$timer) $55f5ea5649168877$var$timer = setTimeout($55f5ea5649168877$var$nextChunk, 0);
    });
};
const $55f5ea5649168877$var$threadCount = 4; // how many workers to spawn
const $55f5ea5649168877$var$idleTimeout = 2000; // workers will be terminated after being idle this many milliseconds
const $55f5ea5649168877$var$threads = {};
let $55f5ea5649168877$var$callNum = 0;
/**
 * Fallback JS-based implementation, fanned out to a number of worker threads for parallelism
 */ function $55f5ea5649168877$var$generateSDF_JS_Worker(width, height, path, viewBox, distance, exponent, canvas, x, y, channel) {
    const workerId = "TroikaTextSDFGenerator_JS_" + $55f5ea5649168877$var$callNum++ % $55f5ea5649168877$var$threadCount;
    let thread = $55f5ea5649168877$var$threads[workerId];
    if (!thread) thread = $55f5ea5649168877$var$threads[workerId] = {
        workerModule: (0, $ca0116d492137119$export$e2063b0a5e3f6023)({
            name: workerId,
            workerId: workerId,
            dependencies: [
                (0, $ecaec7586e6e01a6$export$2e2bcd8739ae039),
                $55f5ea5649168877$var$now
            ],
            init (_createSDFGenerator, now) {
                const generate = _createSDFGenerator().javascript.generate;
                return function(...args) {
                    const start = now();
                    const textureData = generate(...args);
                    return {
                        textureData: textureData,
                        timing: now() - start
                    };
                };
            },
            getTransferables (result) {
                return [
                    result.textureData.buffer
                ];
            }
        }),
        requests: 0,
        idleTimer: null
    };
    thread.requests++;
    clearTimeout(thread.idleTimer);
    return thread.workerModule(width, height, path, viewBox, distance, exponent).then(({ textureData: textureData, timing: timing })=>{
        // copy result data into the canvas
        const start = $55f5ea5649168877$var$now();
        // expand single-channel data into rgba
        const imageData = new Uint8Array(textureData.length * 4);
        for(let i = 0; i < textureData.length; i++)imageData[i * 4 + channel] = textureData[i];
        $55f5ea5649168877$var$mainThreadGenerator.webglUtils.renderImageData(canvas, imageData, x, y, width, height, 1 << 3 - channel);
        timing += $55f5ea5649168877$var$now() - start;
        // clean up workers after a while
        if (--thread.requests === 0) thread.idleTimer = setTimeout(()=>{
            (0, $ca0116d492137119$export$a61a973ac243a75e)(workerId);
        }, $55f5ea5649168877$var$idleTimeout);
        return {
            timing: timing
        };
    });
}
function $55f5ea5649168877$var$warmUpSDFCanvas(canvas) {
    if (!canvas._warm) {
        $55f5ea5649168877$var$mainThreadGenerator.webgl.isSupported(canvas);
        canvas._warm = true;
    }
}
const $55f5ea5649168877$var$resizeWebGLCanvasWithoutClearing = $55f5ea5649168877$var$mainThreadGenerator.webglUtils.resizeWebGLCanvasWithoutClearing;
const $55f5ea5649168877$var$CONFIG = {
    defaultFontURL: null,
    sdfGlyphSize: 64,
    sdfMargin: 1 / 16,
    sdfExponent: 9,
    textureWidth: 2048
};
const $55f5ea5649168877$var$tempColor = /*#__PURE__*/ new (0, $9014d97cd777be10$export$892596cec99bc70e)();
let $55f5ea5649168877$var$hasRequested = false;
function $55f5ea5649168877$var$now$1() {
    return (self.performance || Date).now();
}
/**
 * Customizes the text builder configuration. This must be called prior to the first font processing
 * request, and applies to all fonts.
 *
 * @param {String} config.defaultFontURL - The URL of the default font to use for text processing
 *                 requests, in case none is specified or the specifiede font fails to load or parse.
 *                 Defaults to "Roboto Regular" from Google Fonts.
 * @param {Number} config.sdfGlyphSize - The default size of each glyph's SDF (signed distance field)
 *                 texture used for rendering. Must be a power-of-two number, and applies to all fonts,
 *                 but note that this can also be overridden per call to `getTextRenderInfo()`.
 *                 Larger sizes can improve the quality of glyph rendering by increasing the sharpness
 *                 of corners and preventing loss of very thin lines, at the expense of memory. Defaults
 *                 to 64 which is generally a good balance of size and quality.
 * @param {Number} config.sdfExponent - The exponent used when encoding the SDF values. A higher exponent
 *                 shifts the encoded 8-bit values to achieve higher precision/accuracy at texels nearer
 *                 the glyph's path, with lower precision further away. Defaults to 9.
 * @param {Number} config.sdfMargin - How much space to reserve in the SDF as margin outside the glyph's
 *                 path, as a percentage of the SDF width. A larger margin increases the quality of
 *                 extruded glyph outlines, but decreases the precision available for the glyph itself.
 *                 Defaults to 1/16th of the glyph size.
 * @param {Number} config.textureWidth - The width of the SDF texture; must be a power of 2. Defaults to
 *                 2048 which is a safe maximum texture dimension according to the stats at
 *                 https://webglstats.com/webgl/parameter/MAX_TEXTURE_SIZE and should allow for a
 *                 reasonably large number of glyphs (default glyph size of 64^2 and safe texture size of
 *                 2048^2, times 4 channels, allows for 4096 glyphs.) This can be increased if you need to
 *                 increase the glyph size and/or have an extraordinary number of glyphs.
 */ function $55f5ea5649168877$export$57e337d56090a178(config) {
    if ($55f5ea5649168877$var$hasRequested) console.warn("configureTextBuilder called after first font request; will be ignored.");
    else $55f5ea5649168877$var$assign($55f5ea5649168877$var$CONFIG, config);
}
/**
 * Repository for all font SDF atlas textures and their glyph mappings. There is a separate atlas for
 * each sdfGlyphSize. Each atlas has a single Texture that holds all glyphs for all fonts.
 *
 *   {
 *     [sdfGlyphSize]: {
 *       glyphCount: number,
 *       sdfGlyphSize: number,
 *       sdfTexture: Texture,
 *       sdfCanvas: HTMLCanvasElement,
 *       contextLost: boolean,
 *       glyphsByFont: Map<fontURL, Map<glyphID, {path, atlasIndex, sdfViewBox}>>
 *     }
 *   }
 */ const $55f5ea5649168877$var$atlases = Object.create(null);
/**
 * @typedef {object} TroikaTextRenderInfo - Format of the result from `getTextRenderInfo`.
 * @property {TypesetParams} parameters - The normalized input arguments to the render call.
 * @property {Texture} sdfTexture - The SDF atlas texture.
 * @property {number} sdfGlyphSize - The size of each glyph's SDF; see `configureTextBuilder`.
 * @property {number} sdfExponent - The exponent used in encoding the SDF's values; see `configureTextBuilder`.
 * @property {Float32Array} glyphBounds - List of [minX, minY, maxX, maxY] quad bounds for each glyph.
 * @property {Float32Array} glyphAtlasIndices - List holding each glyph's index in the SDF atlas.
 * @property {Uint8Array} [glyphColors] - List holding each glyph's [r, g, b] color, if `colorRanges` was supplied.
 * @property {Float32Array} [caretPositions] - A list of caret positions for all characters in the string; each is
 *           four elements: the starting X, the ending X, the bottom Y, and the top Y for the caret.
 * @property {number} [caretHeight] - An appropriate height for all selection carets.
 * @property {number} ascender - The font's ascender metric.
 * @property {number} descender - The font's descender metric.
 * @property {number} capHeight - The font's cap height metric, based on the height of Latin capital letters.
 * @property {number} xHeight - The font's x height metric, based on the height of Latin lowercase letters.
 * @property {number} lineHeight - The final computed lineHeight measurement.
 * @property {number} topBaseline - The y position of the top line's baseline.
 * @property {Array<number>} blockBounds - The total [minX, minY, maxX, maxY] rect of the whole text block;
 *           this can include extra vertical space beyond the visible glyphs due to lineHeight, and is
 *           equivalent to the dimensions of a block-level text element in CSS.
 * @property {Array<number>} visibleBounds - The total [minX, minY, maxX, maxY] rect of the whole text block;
 *           unlike `blockBounds` this is tightly wrapped to the visible glyph paths.
 * @property {Array<object>} chunkedBounds - List of bounding rects for each consecutive set of N glyphs,
 *           in the format `{start:N, end:N, rect:[minX, minY, maxX, maxY]}`.
 * @property {object} timings - Timing info for various parts of the rendering logic including SDF
 *           generation, typesetting, etc.
 * @frozen
 */ /**
 * @callback getTextRenderInfo~callback
 * @param {TroikaTextRenderInfo} textRenderInfo
 */ /**
 * Main entry point for requesting the data needed to render a text string with given font parameters.
 * This is an asynchronous call, performing most of the logic in a web worker thread.
 * @param {TypesetParams} args
 * @param {getTextRenderInfo~callback} callback
 */ function $55f5ea5649168877$var$getTextRenderInfo(args, callback) {
    $55f5ea5649168877$var$hasRequested = true;
    args = $55f5ea5649168877$var$assign({}, args);
    const totalStart = $55f5ea5649168877$var$now$1();
    // Convert relative URL to absolute so it can be resolved in the worker, and add fallbacks.
    // In the future we'll allow args.font to be a list with unicode ranges too.
    const { defaultFontURL: defaultFontURL } = $55f5ea5649168877$var$CONFIG;
    const fonts = [];
    if (defaultFontURL) fonts.push({
        label: "default",
        src: $55f5ea5649168877$var$toAbsoluteURL(defaultFontURL)
    });
    if (args.font) fonts.push({
        label: "user",
        src: $55f5ea5649168877$var$toAbsoluteURL(args.font)
    });
    args.font = fonts;
    // Normalize text to a string
    args.text = "" + args.text;
    args.sdfGlyphSize = args.sdfGlyphSize || $55f5ea5649168877$var$CONFIG.sdfGlyphSize;
    // Normalize colors
    if (args.colorRanges != null) {
        let colors = {};
        for(let key in args.colorRanges)if (args.colorRanges.hasOwnProperty(key)) {
            let val = args.colorRanges[key];
            if (typeof val !== "number") val = $55f5ea5649168877$var$tempColor.set(val).getHex();
            colors[key] = val;
        }
        args.colorRanges = colors;
    }
    Object.freeze(args);
    // Init the atlas if needed
    const { textureWidth: textureWidth, sdfExponent: sdfExponent } = $55f5ea5649168877$var$CONFIG;
    const { sdfGlyphSize: sdfGlyphSize } = args;
    const glyphsPerRow = textureWidth / sdfGlyphSize * 4;
    let atlas = $55f5ea5649168877$var$atlases[sdfGlyphSize];
    if (!atlas) {
        const canvas = document.createElement("canvas");
        canvas.width = textureWidth;
        canvas.height = sdfGlyphSize * 256 / glyphsPerRow; // start tall enough to fit 256 glyphs
        atlas = $55f5ea5649168877$var$atlases[sdfGlyphSize] = {
            glyphCount: 0,
            sdfGlyphSize: sdfGlyphSize,
            sdfCanvas: canvas,
            sdfTexture: new (0, $9014d97cd777be10$export$5431306cf43de24a)(canvas, undefined, undefined, undefined, (0, $9014d97cd777be10$export$8a72f490b25c56c8), (0, $9014d97cd777be10$export$8a72f490b25c56c8)),
            contextLost: false,
            glyphsByFont: new Map()
        };
        atlas.sdfTexture.generateMipmaps = false;
        $55f5ea5649168877$var$initContextLossHandling(atlas);
    }
    const { sdfTexture: sdfTexture, sdfCanvas: sdfCanvas } = atlas;
    // Issue request to the typesetting engine in the worker
    $55f5ea5649168877$var$typesetInWorker(args).then((result)=>{
        const { glyphIds: glyphIds, glyphFontIndices: glyphFontIndices, fontData: fontData, glyphPositions: glyphPositions, fontSize: fontSize, timings: timings } = result;
        const neededSDFs = [];
        const glyphBounds = new Float32Array(glyphIds.length * 4);
        let boundsIdx = 0;
        let positionsIdx = 0;
        const quadsStart = $55f5ea5649168877$var$now$1();
        const fontGlyphMaps = fontData.map((font)=>{
            let map = atlas.glyphsByFont.get(font.src);
            if (!map) atlas.glyphsByFont.set(font.src, map = new Map());
            return map;
        });
        glyphIds.forEach((glyphId, i)=>{
            const fontIndex = glyphFontIndices[i];
            const { src: fontSrc, unitsPerEm: unitsPerEm } = fontData[fontIndex];
            let glyphInfo = fontGlyphMaps[fontIndex].get(glyphId);
            // If this is a glyphId not seen before, add it to the atlas
            if (!glyphInfo) {
                const { path: path, pathBounds: pathBounds } = result.glyphData[fontSrc][glyphId];
                // Margin around path edges in SDF, based on a percentage of the glyph's max dimension.
                // Note we add an extra 0.5 px over the configured value because the outer 0.5 doesn't contain
                // useful interpolated values and will be ignored anyway.
                const fontUnitsMargin = Math.max(pathBounds[2] - pathBounds[0], pathBounds[3] - pathBounds[1]) / sdfGlyphSize * ($55f5ea5649168877$var$CONFIG.sdfMargin * sdfGlyphSize + 0.5);
                const atlasIndex = atlas.glyphCount++;
                const sdfViewBox = [
                    pathBounds[0] - fontUnitsMargin,
                    pathBounds[1] - fontUnitsMargin,
                    pathBounds[2] + fontUnitsMargin,
                    pathBounds[3] + fontUnitsMargin
                ];
                fontGlyphMaps[fontIndex].set(glyphId, glyphInfo = {
                    path: path,
                    atlasIndex: atlasIndex,
                    sdfViewBox: sdfViewBox
                });
                // Collect those that need SDF generation
                neededSDFs.push(glyphInfo);
            }
            // Calculate bounds for renderable quads
            // TODO can we get this back off the main thread?
            const { sdfViewBox: sdfViewBox } = glyphInfo;
            const posX = glyphPositions[positionsIdx++];
            const posY = glyphPositions[positionsIdx++];
            const fontSizeMult = fontSize / unitsPerEm;
            glyphBounds[boundsIdx++] = posX + sdfViewBox[0] * fontSizeMult;
            glyphBounds[boundsIdx++] = posY + sdfViewBox[1] * fontSizeMult;
            glyphBounds[boundsIdx++] = posX + sdfViewBox[2] * fontSizeMult;
            glyphBounds[boundsIdx++] = posY + sdfViewBox[3] * fontSizeMult;
            // Convert glyphId to SDF index for the shader
            glyphIds[i] = glyphInfo.atlasIndex;
        });
        timings.quads = (timings.quads || 0) + ($55f5ea5649168877$var$now$1() - quadsStart);
        const sdfStart = $55f5ea5649168877$var$now$1();
        timings.sdf = {};
        // Grow the texture height by power of 2 if needed
        const currentHeight = sdfCanvas.height;
        const neededRows = Math.ceil(atlas.glyphCount / glyphsPerRow);
        const neededHeight = Math.pow(2, Math.ceil(Math.log2(neededRows * sdfGlyphSize)));
        if (neededHeight > currentHeight) {
            // Since resizing the canvas clears its render buffer, it needs special handling to copy the old contents over
            console.info(`Increasing SDF texture size ${currentHeight}->${neededHeight}`);
            $55f5ea5649168877$var$resizeWebGLCanvasWithoutClearing(sdfCanvas, textureWidth, neededHeight);
            // As of Three r136 textures cannot be resized once they're allocated on the GPU, we must dispose to reallocate it
            sdfTexture.dispose();
        }
        Promise.all(neededSDFs.map((glyphInfo)=>$55f5ea5649168877$var$generateGlyphSDF(glyphInfo, atlas, args.gpuAccelerateSDF).then(({ timing: timing })=>{
                timings.sdf[glyphInfo.atlasIndex] = timing;
            }))).then(()=>{
            if (neededSDFs.length && !atlas.contextLost) {
                $55f5ea5649168877$var$safariPre15Workaround(atlas);
                sdfTexture.needsUpdate = true;
            }
            timings.sdfTotal = $55f5ea5649168877$var$now$1() - sdfStart;
            timings.total = $55f5ea5649168877$var$now$1() - totalStart;
            // console.log(`SDF - ${timings.sdfTotal}, Total - ${timings.total - timings.fontLoad}`)
            // Invoke callback with the text layout arrays and updated texture
            callback(Object.freeze({
                parameters: args,
                sdfTexture: sdfTexture,
                sdfGlyphSize: sdfGlyphSize,
                sdfExponent: sdfExponent,
                glyphBounds: glyphBounds,
                glyphAtlasIndices: glyphIds,
                glyphColors: result.glyphColors,
                caretPositions: result.caretPositions,
                chunkedBounds: result.chunkedBounds,
                ascender: result.ascender,
                descender: result.descender,
                lineHeight: result.lineHeight,
                capHeight: result.capHeight,
                xHeight: result.xHeight,
                topBaseline: result.topBaseline,
                blockBounds: result.blockBounds,
                visibleBounds: result.visibleBounds,
                timings: result.timings
            }));
        });
    });
    // While the typesetting request is being handled, go ahead and make sure the atlas canvas context is
    // "warmed up"; the first request will be the longest due to shader program compilation so this gets
    // a head start on that process before SDFs actually start getting processed.
    Promise.resolve().then(()=>{
        if (!atlas.contextLost) $55f5ea5649168877$var$warmUpSDFCanvas(sdfCanvas);
    });
}
function $55f5ea5649168877$var$generateGlyphSDF({ path: path, atlasIndex: atlasIndex, sdfViewBox: sdfViewBox }, { sdfGlyphSize: sdfGlyphSize, sdfCanvas: sdfCanvas, contextLost: contextLost }, useGPU) {
    if (contextLost) // If the context is lost there's nothing we can do, just quit silently and let it
    // get regenerated when the context is restored
    return Promise.resolve({
        timing: -1
    });
    const { textureWidth: textureWidth, sdfExponent: sdfExponent } = $55f5ea5649168877$var$CONFIG;
    const maxDist = Math.max(sdfViewBox[2] - sdfViewBox[0], sdfViewBox[3] - sdfViewBox[1]);
    const squareIndex = Math.floor(atlasIndex / 4);
    const x = squareIndex % (textureWidth / sdfGlyphSize) * sdfGlyphSize;
    const y = Math.floor(squareIndex / (textureWidth / sdfGlyphSize)) * sdfGlyphSize;
    const channel = atlasIndex % 4;
    return $55f5ea5649168877$var$generateSDF(sdfGlyphSize, sdfGlyphSize, path, sdfViewBox, maxDist, sdfExponent, sdfCanvas, x, y, channel, useGPU);
}
function $55f5ea5649168877$var$initContextLossHandling(atlas) {
    const canvas = atlas.sdfCanvas;
    /*
  // Begin context loss simulation
  if (!window.WebGLDebugUtils) {
    let script = document.getElementById('WebGLDebugUtilsScript')
    if (!script) {
      script = document.createElement('script')
      script.id = 'WebGLDebugUtils'
      document.head.appendChild(script)
      script.src = 'https://cdn.jsdelivr.net/gh/KhronosGroup/WebGLDeveloperTools@b42e702/src/debug/webgl-debug.js'
    }
    script.addEventListener('load', () => {
      initContextLossHandling(atlas)
    })
    return
  }
  window.WebGLDebugUtils.makeLostContextSimulatingCanvas(canvas)
  canvas.loseContextInNCalls(500)
  canvas.addEventListener('webglcontextrestored', (event) => {
    canvas.loseContextInNCalls(5000)
  })
  // End context loss simulation
  */ canvas.addEventListener("webglcontextlost", (event)=>{
        console.log("Context Lost", event);
        event.preventDefault();
        atlas.contextLost = true;
    });
    canvas.addEventListener("webglcontextrestored", (event)=>{
        console.log("Context Restored", event);
        atlas.contextLost = false;
        // Regenerate all glyphs into the restored canvas:
        const promises = [];
        atlas.glyphsByFont.forEach((glyphMap)=>{
            glyphMap.forEach((glyph)=>{
                promises.push($55f5ea5649168877$var$generateGlyphSDF(glyph, atlas, true));
            });
        });
        Promise.all(promises).then(()=>{
            $55f5ea5649168877$var$safariPre15Workaround(atlas);
            atlas.sdfTexture.needsUpdate = true;
        });
    });
}
/**
 * Preload a given font and optionally pre-generate glyph SDFs for one or more character sequences.
 * This can be useful to avoid long pauses when first showing text in a scene, by preloading the
 * needed fonts and glyphs up front along with other assets.
 *
 * @param {object} options
 * @param {string} options.font - URL of the font file to preload. If not given, the default font will
 *        be loaded.
 * @param {string|string[]} options.characters - One or more character sequences for which to pre-
 *        generate glyph SDFs. Note that this will honor ligature substitution, so you may need
 *        to specify ligature sequences in addition to their individual characters to get all
 *        possible glyphs, e.g. `["t", "h", "th"]` to get the "t" and "h" glyphs plus the "th" ligature.
 * @param {number} options.sdfGlyphSize - The size at which to prerender the SDF textures for the
 *        specified `characters`.
 * @param {function} callback - A function that will be called when the preloading is complete.
 */ function $55f5ea5649168877$export$8a6ffa2d67c47c6c({ font: font, characters: characters, sdfGlyphSize: sdfGlyphSize }, callback) {
    let text = Array.isArray(characters) ? characters.join("\n") : "" + characters;
    $55f5ea5649168877$var$getTextRenderInfo({
        font: font,
        sdfGlyphSize: sdfGlyphSize,
        text: text
    }, callback);
}
// Local assign impl so we don't have to import troika-core
function $55f5ea5649168877$var$assign(toObj, fromObj) {
    for(let key in fromObj)if (fromObj.hasOwnProperty(key)) toObj[key] = fromObj[key];
    return toObj;
}
// Utility for making URLs absolute
let $55f5ea5649168877$var$linkEl;
function $55f5ea5649168877$var$toAbsoluteURL(path) {
    if (!$55f5ea5649168877$var$linkEl) $55f5ea5649168877$var$linkEl = typeof document === "undefined" ? {} : document.createElement("a");
    $55f5ea5649168877$var$linkEl.href = path;
    return $55f5ea5649168877$var$linkEl.href;
}
/**
 * Safari < v15 seems unable to use the SDF webgl canvas as a texture. This applies a workaround
 * where it reads the pixels out of that canvas and uploads them as a data texture instead, at
 * a slight performance cost.
 */ function $55f5ea5649168877$var$safariPre15Workaround(atlas) {
    // Use createImageBitmap support as a proxy for Safari<15, all other mainstream browsers
    // have supported it for a long while so any false positives should be minimal.
    if (typeof createImageBitmap !== "function") {
        console.info("Safari<15: applying SDF canvas workaround");
        const { sdfCanvas: sdfCanvas, sdfTexture: sdfTexture } = atlas;
        const { width: width, height: height } = sdfCanvas;
        const gl = atlas.sdfCanvas.getContext("webgl");
        let pixels = sdfTexture.image.data;
        if (!pixels || pixels.length !== width * height * 4) {
            pixels = new Uint8Array(width * height * 4);
            sdfTexture.image = {
                width: width,
                height: height,
                data: pixels
            };
            sdfTexture.flipY = false;
            sdfTexture.isDataTexture = true;
        }
        gl.readPixels(0, 0, width, height, gl.RGBA, gl.UNSIGNED_BYTE, pixels);
    }
}
const $55f5ea5649168877$export$adeaafcde0994a07 = /*#__PURE__*/ (0, $ca0116d492137119$export$e2063b0a5e3f6023)({
    name: "Typesetter",
    dependencies: [
        $55f5ea5649168877$var$createTypesetter,
        $55f5ea5649168877$export$85a5d697a084610,
        (0, $65b2b49b50a4e8ff$export$2e2bcd8739ae039)
    ],
    init (createTypesetter, fontResolver, bidiFactory) {
        return createTypesetter(fontResolver, bidiFactory());
    }
});
const $55f5ea5649168877$var$typesetInWorker = /*#__PURE__*/ (0, $ca0116d492137119$export$e2063b0a5e3f6023)({
    name: "Typesetter",
    dependencies: [
        $55f5ea5649168877$export$adeaafcde0994a07
    ],
    init (typesetter) {
        return function(args) {
            return new Promise((resolve)=>{
                typesetter.typeset(args, resolve);
            });
        };
    },
    getTransferables (result) {
        // Mark array buffers as transferable to avoid cloning during postMessage
        const transferables = [];
        for(let p in result)if (result[p] && result[p].buffer) transferables.push(result[p].buffer);
        return transferables;
    }
});
function $55f5ea5649168877$export$f81271cf861a33c1() {
    Object.keys($55f5ea5649168877$var$atlases).forEach((size)=>{
        const canvas = $55f5ea5649168877$var$atlases[size].sdfCanvas;
        const { width: width, height: height } = canvas;
        console.log("%c.", `
      background: url(${canvas.toDataURL()});
      background-size: ${width}px ${height}px;
      color: transparent;
      font-size: 0;
      line-height: ${height}px;
      padding-left: ${width}px;
    `);
    });
}
const $55f5ea5649168877$var$templateGeometries = {};
function $55f5ea5649168877$var$getTemplateGeometry(detail) {
    let geom = $55f5ea5649168877$var$templateGeometries[detail];
    if (!geom) {
        // Geometry is two planes back-to-back, which will always be rendered FrontSide only but
        // appear as DoubleSide by default. FrontSide/BackSide are emulated using drawRange.
        // We do it this way to avoid the performance hit of two draw calls for DoubleSide materials
        // introduced by Three.js in r130 - see https://github.com/mrdoob/three.js/pull/21967
        const front = new (0, $9014d97cd777be10$export$967d831af31f69ce)(1, 1, detail, detail);
        const back = front.clone();
        const frontAttrs = front.attributes;
        const backAttrs = back.attributes;
        const combined = new (0, $9014d97cd777be10$export$b7be63a67df8959)();
        const vertCount = frontAttrs.uv.count;
        for(let i = 0; i < vertCount; i++){
            backAttrs.position.array[i * 3] *= -1; // flip position x
            backAttrs.normal.array[i * 3 + 2] *= -1; // flip normal z
        }
        [
            "position",
            "normal",
            "uv"
        ].forEach((name)=>{
            combined.setAttribute(name, new (0, $9014d97cd777be10$export$cbe7a62641830ebd)([
                ...frontAttrs[name].array,
                ...backAttrs[name].array
            ], frontAttrs[name].itemSize));
        });
        combined.setIndex([
            ...front.index.array,
            ...back.index.array.map((n)=>n + vertCount)
        ]);
        combined.translate(0.5, 0.5, 0);
        geom = $55f5ea5649168877$var$templateGeometries[detail] = combined;
    }
    return geom;
}
const $55f5ea5649168877$var$glyphBoundsAttrName = "aTroikaGlyphBounds";
const $55f5ea5649168877$var$glyphIndexAttrName = "aTroikaGlyphIndex";
const $55f5ea5649168877$var$glyphColorAttrName = "aTroikaGlyphColor";
/**
@class GlyphsGeometry

A specialized Geometry for rendering a set of text glyphs. Uses InstancedBufferGeometry to
render the glyphs using GPU instancing of a single quad, rather than constructing a whole
geometry with vertices, for much smaller attribute arraybuffers according to this math:

  Where N = number of glyphs...

  Instanced:
  - position: 4 * 3
  - index: 2 * 3
  - normal: 4 * 3
  - uv: 4 * 2
  - glyph x/y bounds: N * 4
  - glyph indices: N * 1
  = 5N + 38

  Non-instanced:
  - position: N * 4 * 3
  - index: N * 2 * 3
  - normal: N * 4 * 3
  - uv: N * 4 * 2
  - glyph indices: N * 1
  = 39N

A downside of this is the rare-but-possible lack of the instanced arrays extension,
which we could potentially work around with a fallback non-instanced implementation.

*/ class $55f5ea5649168877$export$16fe3b8f85ab6e35 extends (0, $9014d97cd777be10$export$231f009cbe414146) {
    computeBoundingSphere() {
    // No-op; we'll sync the boundingSphere proactively when needed.
    }
    computeBoundingBox() {
    // No-op; we'll sync the boundingBox proactively when needed.
    }
    // Since our base geometry contains triangles for both front and back sides, we can emulate
    // the "side" by restricting the draw range.
    setSide(side) {
        const verts = this.getIndex().count;
        this.setDrawRange(side === (0, $9014d97cd777be10$export$d9f0486e75b5ace) ? verts / 2 : 0, side === (0, $9014d97cd777be10$export$3b296b6f144d5b03) ? verts : verts / 2);
    }
    set detail(detail) {
        if (detail !== this._detail) {
            this._detail = detail;
            if (typeof detail !== "number" || detail < 1) detail = 1;
            let tpl = $55f5ea5649168877$var$getTemplateGeometry(detail);
            [
                "position",
                "normal",
                "uv"
            ].forEach((attr)=>{
                this.attributes[attr] = tpl.attributes[attr].clone();
            });
            this.setIndex(tpl.getIndex().clone());
        }
    }
    get detail() {
        return this._detail;
    }
    set curveRadius(r) {
        if (r !== this._curveRadius) {
            this._curveRadius = r;
            this._updateBounds();
        }
    }
    get curveRadius() {
        return this._curveRadius;
    }
    /**
   * Update the geometry for a new set of glyphs.
   * @param {Float32Array} glyphBounds - An array holding the planar bounds for all glyphs
   *        to be rendered, 4 entries for each glyph: x1,x2,y1,y1
   * @param {Float32Array} glyphAtlasIndices - An array holding the index of each glyph within
   *        the SDF atlas texture.
   * @param {Array} blockBounds - An array holding the [minX, minY, maxX, maxY] across all glyphs
   * @param {Array} [chunkedBounds] - An array of objects describing bounds for each chunk of N
   *        consecutive glyphs: `{start:N, end:N, rect:[minX, minY, maxX, maxY]}`. This can be
   *        used with `applyClipRect` to choose an optimized `instanceCount`.
   * @param {Uint8Array} [glyphColors] - An array holding r,g,b values for each glyph.
   */ updateGlyphs(glyphBounds, glyphAtlasIndices, blockBounds, chunkedBounds, glyphColors) {
        // Update the instance attributes
        $55f5ea5649168877$var$updateBufferAttr(this, $55f5ea5649168877$var$glyphBoundsAttrName, glyphBounds, 4);
        $55f5ea5649168877$var$updateBufferAttr(this, $55f5ea5649168877$var$glyphIndexAttrName, glyphAtlasIndices, 1);
        $55f5ea5649168877$var$updateBufferAttr(this, $55f5ea5649168877$var$glyphColorAttrName, glyphColors, 3);
        this._blockBounds = blockBounds;
        this._chunkedBounds = chunkedBounds;
        this.instanceCount = glyphAtlasIndices.length;
        this._updateBounds();
    }
    _updateBounds() {
        const bounds = this._blockBounds;
        if (bounds) {
            const { curveRadius: curveRadius, boundingBox: bbox } = this;
            if (curveRadius) {
                const { PI: PI, floor: floor, min: min, max: max, sin: sin, cos: cos } = Math;
                const halfPi = PI / 2;
                const twoPi = PI * 2;
                const absR = Math.abs(curveRadius);
                const leftAngle = bounds[0] / absR;
                const rightAngle = bounds[2] / absR;
                const minX = floor((leftAngle + halfPi) / twoPi) !== floor((rightAngle + halfPi) / twoPi) ? -absR : min(sin(leftAngle) * absR, sin(rightAngle) * absR);
                const maxX = floor((leftAngle - halfPi) / twoPi) !== floor((rightAngle - halfPi) / twoPi) ? absR : max(sin(leftAngle) * absR, sin(rightAngle) * absR);
                const maxZ = floor((leftAngle + PI) / twoPi) !== floor((rightAngle + PI) / twoPi) ? absR * 2 : max(absR - cos(leftAngle) * absR, absR - cos(rightAngle) * absR);
                bbox.min.set(minX, bounds[1], curveRadius < 0 ? -maxZ : 0);
                bbox.max.set(maxX, bounds[3], curveRadius < 0 ? 0 : maxZ);
            } else {
                bbox.min.set(bounds[0], bounds[1], 0);
                bbox.max.set(bounds[2], bounds[3], 0);
            }
            bbox.getBoundingSphere(this.boundingSphere);
        }
    }
    /**
   * Given a clipping rect, and the chunkedBounds from the last updateGlyphs call, choose the lowest
   * `instanceCount` that will show all glyphs within the clipped view. This is an optimization
   * for long blocks of text that are clipped, to skip vertex shader evaluation for glyphs that would
   * be clipped anyway.
   *
   * Note that since `drawElementsInstanced[ANGLE]` only accepts an instance count and not a starting
   * offset, this optimization becomes less effective as the clipRect moves closer to the end of the
   * text block. We could fix that by switching from instancing to a full geometry with a drawRange,
   * but at the expense of much larger attribute buffers (see classdoc above.)
   *
   * @param {Vector4} clipRect
   */ applyClipRect(clipRect) {
        let count = this.getAttribute($55f5ea5649168877$var$glyphIndexAttrName).count;
        let chunks = this._chunkedBounds;
        if (chunks) for(let i = chunks.length; i--;){
            count = chunks[i].end;
            let rect = chunks[i].rect;
            // note: both rects are l-b-r-t
            if (rect[1] < clipRect.w && rect[3] > clipRect.y && rect[0] < clipRect.z && rect[2] > clipRect.x) break;
        }
        this.instanceCount = count;
    }
    constructor(){
        super();
        this.detail = 1;
        this.curveRadius = 0;
        // Define groups for rendering text outline as a separate pass; these will only
        // be used when the `material` getter returns an array, i.e. outlineWidth > 0.
        this.groups = [
            {
                start: 0,
                count: Infinity,
                materialIndex: 0
            },
            {
                start: 0,
                count: Infinity,
                materialIndex: 1
            }
        ];
        // Preallocate empty bounding objects
        this.boundingSphere = new (0, $9014d97cd777be10$export$805e8b72413ccaba)();
        this.boundingBox = new (0, $9014d97cd777be10$export$6f7d5a9418ab2aa3)();
    }
}
function $55f5ea5649168877$var$updateBufferAttr(geom, attrName, newArray, itemSize) {
    const attr = geom.getAttribute(attrName);
    if (newArray) {
        // If length isn't changing, just update the attribute's array data
        if (attr && attr.array.length === newArray.length) {
            attr.array.set(newArray);
            attr.needsUpdate = true;
        } else {
            geom.setAttribute(attrName, new (0, $9014d97cd777be10$export$32ea87a8b54d744a)(newArray, itemSize));
            // If the new attribute has a different size, we also have to (as of r117) manually clear the
            // internal cached max instance count. See https://github.com/mrdoob/three.js/issues/19706
            // It's unclear if this is a threejs bug or a truly unsupported scenario; discussion in
            // that ticket is ambiguous as to whether replacing a BufferAttribute with one of a
            // different size is supported, but https://github.com/mrdoob/three.js/pull/17418 strongly
            // implies it should be supported. It's possible we need to
            delete geom._maxInstanceCount; //for r117+, could be fragile
            geom.dispose(); //for r118+, more robust feeling, but more heavy-handed than I'd like
        }
    } else if (attr) geom.deleteAttribute(attrName);
}
// language=GLSL
const $55f5ea5649168877$var$VERTEX_DEFS = `
uniform vec2 uTroikaSDFTextureSize;
uniform float uTroikaSDFGlyphSize;
uniform vec4 uTroikaTotalBounds;
uniform vec4 uTroikaClipRect;
uniform mat3 uTroikaOrient;
uniform bool uTroikaUseGlyphColors;
uniform float uTroikaDistanceOffset;
uniform float uTroikaBlurRadius;
uniform vec2 uTroikaPositionOffset;
uniform float uTroikaCurveRadius;
attribute vec4 aTroikaGlyphBounds;
attribute float aTroikaGlyphIndex;
attribute vec3 aTroikaGlyphColor;
varying vec2 vTroikaGlyphUV;
varying vec4 vTroikaTextureUVBounds;
varying float vTroikaTextureChannel;
varying vec3 vTroikaGlyphColor;
varying vec2 vTroikaGlyphDimensions;
`;
// language=GLSL prefix="void main() {" suffix="}"
const $55f5ea5649168877$var$VERTEX_TRANSFORM = `
vec4 bounds = aTroikaGlyphBounds;
bounds.xz += uTroikaPositionOffset.x;
bounds.yw -= uTroikaPositionOffset.y;

vec4 outlineBounds = vec4(
  bounds.xy - uTroikaDistanceOffset - uTroikaBlurRadius,
  bounds.zw + uTroikaDistanceOffset + uTroikaBlurRadius
);
vec4 clippedBounds = vec4(
  clamp(outlineBounds.xy, uTroikaClipRect.xy, uTroikaClipRect.zw),
  clamp(outlineBounds.zw, uTroikaClipRect.xy, uTroikaClipRect.zw)
);

vec2 clippedXY = (mix(clippedBounds.xy, clippedBounds.zw, position.xy) - bounds.xy) / (bounds.zw - bounds.xy);

position.xy = mix(bounds.xy, bounds.zw, clippedXY);

uv = (position.xy - uTroikaTotalBounds.xy) / (uTroikaTotalBounds.zw - uTroikaTotalBounds.xy);

float rad = uTroikaCurveRadius;
if (rad != 0.0) {
  float angle = position.x / rad;
  position.xz = vec2(sin(angle) * rad, rad - cos(angle) * rad);
  normal.xz = vec2(sin(angle), cos(angle));
}
  
position = uTroikaOrient * position;
normal = uTroikaOrient * normal;

vTroikaGlyphUV = clippedXY.xy;
vTroikaGlyphDimensions = vec2(bounds[2] - bounds[0], bounds[3] - bounds[1]);

${"" /* NOTE: it seems important to calculate the glyph's bounding texture UVs here in the
  vertex shader, rather than in the fragment shader, as the latter gives strange artifacts
  on some glyphs (those in the leftmost texture column) on some systems. The exact reason
  isn't understood but doing this here, then mix()-ing in the fragment shader, seems to work. */ }
float txCols = uTroikaSDFTextureSize.x / uTroikaSDFGlyphSize;
vec2 txUvPerSquare = uTroikaSDFGlyphSize / uTroikaSDFTextureSize;
vec2 txStartUV = txUvPerSquare * vec2(
  mod(floor(aTroikaGlyphIndex / 4.0), txCols),
  floor(floor(aTroikaGlyphIndex / 4.0) / txCols)
);
vTroikaTextureUVBounds = vec4(txStartUV, vec2(txStartUV) + txUvPerSquare);
vTroikaTextureChannel = mod(aTroikaGlyphIndex, 4.0);
`;
// language=GLSL
const $55f5ea5649168877$var$FRAGMENT_DEFS = `
uniform sampler2D uTroikaSDFTexture;
uniform vec2 uTroikaSDFTextureSize;
uniform float uTroikaSDFGlyphSize;
uniform float uTroikaSDFExponent;
uniform float uTroikaDistanceOffset;
uniform float uTroikaFillOpacity;
uniform float uTroikaOutlineOpacity;
uniform float uTroikaBlurRadius;
uniform vec3 uTroikaStrokeColor;
uniform float uTroikaStrokeWidth;
uniform float uTroikaStrokeOpacity;
uniform bool uTroikaSDFDebug;
varying vec2 vTroikaGlyphUV;
varying vec4 vTroikaTextureUVBounds;
varying float vTroikaTextureChannel;
varying vec2 vTroikaGlyphDimensions;

float troikaSdfValueToSignedDistance(float alpha) {
  // Inverse of exponential encoding in webgl-sdf-generator
  ${"" /* TODO - there's some slight inaccuracy here when dealing with interpolated alpha values; those
    are linearly interpolated where the encoding is exponential. Look into improving this by rounding
    to nearest 2 whole texels, decoding those exponential values, and linearly interpolating the result.
  */ }
  float maxDimension = max(vTroikaGlyphDimensions.x, vTroikaGlyphDimensions.y);
  float absDist = (1.0 - pow(2.0 * (alpha > 0.5 ? 1.0 - alpha : alpha), 1.0 / uTroikaSDFExponent)) * maxDimension;
  float signedDist = absDist * (alpha > 0.5 ? -1.0 : 1.0);
  return signedDist;
}

float troikaGlyphUvToSdfValue(vec2 glyphUV) {
  vec2 textureUV = mix(vTroikaTextureUVBounds.xy, vTroikaTextureUVBounds.zw, glyphUV);
  vec4 rgba = texture2D(uTroikaSDFTexture, textureUV);
  float ch = floor(vTroikaTextureChannel + 0.5); //NOTE: can't use round() in WebGL1
  return ch == 0.0 ? rgba.r : ch == 1.0 ? rgba.g : ch == 2.0 ? rgba.b : rgba.a;
}

float troikaGlyphUvToDistance(vec2 uv) {
  return troikaSdfValueToSignedDistance(troikaGlyphUvToSdfValue(uv));
}

float troikaGetAADist() {
  ${"" /*
    When the standard derivatives extension is available, we choose an antialiasing alpha threshold based
    on the potential change in the SDF's alpha from this fragment to its neighbor. This strategy maximizes 
    readability and edge crispness at all sizes and screen resolutions.
  */ }
  #if defined(GL_OES_standard_derivatives) || __VERSION__ >= 300
  return length(fwidth(vTroikaGlyphUV * vTroikaGlyphDimensions)) * 0.5;
  #else
  return vTroikaGlyphDimensions.x / 64.0;
  #endif
}

float troikaGetFragDistValue() {
  vec2 clampedGlyphUV = clamp(vTroikaGlyphUV, 0.5 / uTroikaSDFGlyphSize, 1.0 - 0.5 / uTroikaSDFGlyphSize);
  float distance = troikaGlyphUvToDistance(clampedGlyphUV);
 
  // Extrapolate distance when outside bounds:
  distance += clampedGlyphUV == vTroikaGlyphUV ? 0.0 : 
    length((vTroikaGlyphUV - clampedGlyphUV) * vTroikaGlyphDimensions);

  ${"" /* 
  // TODO more refined extrapolated distance by adjusting for angle of gradient at edge...
  // This has potential but currently gives very jagged extensions, maybe due to precision issues?
  float uvStep = 1.0 / uTroikaSDFGlyphSize;
  vec2 neighbor1UV = clampedGlyphUV + (
    vTroikaGlyphUV.x != clampedGlyphUV.x ? vec2(0.0, uvStep * sign(0.5 - vTroikaGlyphUV.y)) :
    vTroikaGlyphUV.y != clampedGlyphUV.y ? vec2(uvStep * sign(0.5 - vTroikaGlyphUV.x), 0.0) :
    vec2(0.0)
  );
  vec2 neighbor2UV = clampedGlyphUV + (
    vTroikaGlyphUV.x != clampedGlyphUV.x ? vec2(0.0, uvStep * -sign(0.5 - vTroikaGlyphUV.y)) :
    vTroikaGlyphUV.y != clampedGlyphUV.y ? vec2(uvStep * -sign(0.5 - vTroikaGlyphUV.x), 0.0) :
    vec2(0.0)
  );
  float neighbor1Distance = troikaGlyphUvToDistance(neighbor1UV);
  float neighbor2Distance = troikaGlyphUvToDistance(neighbor2UV);
  float distToUnclamped = length((vTroikaGlyphUV - clampedGlyphUV) * vTroikaGlyphDimensions);
  float distToNeighbor = length((clampedGlyphUV - neighbor1UV) * vTroikaGlyphDimensions);
  float gradientAngle1 = min(asin(abs(neighbor1Distance - distance) / distToNeighbor), PI / 2.0);
  float gradientAngle2 = min(asin(abs(neighbor2Distance - distance) / distToNeighbor), PI / 2.0);
  distance += (cos(gradientAngle1) + cos(gradientAngle2)) / 2.0 * distToUnclamped;
  */ }

  return distance;
}

float troikaGetEdgeAlpha(float distance, float distanceOffset, float aaDist) {
  #if defined(IS_DEPTH_MATERIAL) || defined(IS_DISTANCE_MATERIAL)
  float alpha = step(-distanceOffset, -distance);
  #else

  float alpha = smoothstep(
    distanceOffset + aaDist,
    distanceOffset - aaDist,
    distance
  );
  #endif

  return alpha;
}
`;
// language=GLSL prefix="void main() {" suffix="}"
const $55f5ea5649168877$var$FRAGMENT_TRANSFORM = `
float aaDist = troikaGetAADist();
float fragDistance = troikaGetFragDistValue();
float edgeAlpha = uTroikaSDFDebug ?
  troikaGlyphUvToSdfValue(vTroikaGlyphUV) :
  troikaGetEdgeAlpha(fragDistance, uTroikaDistanceOffset, max(aaDist, uTroikaBlurRadius));

#if !defined(IS_DEPTH_MATERIAL) && !defined(IS_DISTANCE_MATERIAL)
vec4 fillRGBA = gl_FragColor;
fillRGBA.a *= uTroikaFillOpacity;
vec4 strokeRGBA = uTroikaStrokeWidth == 0.0 ? fillRGBA : vec4(uTroikaStrokeColor, uTroikaStrokeOpacity);
if (fillRGBA.a == 0.0) fillRGBA.rgb = strokeRGBA.rgb;
gl_FragColor = mix(fillRGBA, strokeRGBA, smoothstep(
  -uTroikaStrokeWidth - aaDist,
  -uTroikaStrokeWidth + aaDist,
  fragDistance
));
gl_FragColor.a *= edgeAlpha;
#endif

if (edgeAlpha == 0.0) {
  discard;
}
`;
/**
 * Create a material for rendering text, derived from a baseMaterial
 */ function $55f5ea5649168877$export$ec8c2d2c0fe50886(baseMaterial) {
    const textMaterial = (0, $34196ca962faf131$export$9251ec91c7de57b5)(baseMaterial, {
        chained: true,
        extensions: {
            derivatives: true
        },
        uniforms: {
            uTroikaSDFTexture: {
                value: null
            },
            uTroikaSDFTextureSize: {
                value: new (0, $9014d97cd777be10$export$c977b3e384af9ae1)()
            },
            uTroikaSDFGlyphSize: {
                value: 0
            },
            uTroikaSDFExponent: {
                value: 0
            },
            uTroikaTotalBounds: {
                value: new (0, $9014d97cd777be10$export$fa7daccca11cdbe3)(0, 0, 0, 0)
            },
            uTroikaClipRect: {
                value: new (0, $9014d97cd777be10$export$fa7daccca11cdbe3)(0, 0, 0, 0)
            },
            uTroikaDistanceOffset: {
                value: 0
            },
            uTroikaOutlineOpacity: {
                value: 0
            },
            uTroikaFillOpacity: {
                value: 1
            },
            uTroikaPositionOffset: {
                value: new (0, $9014d97cd777be10$export$c977b3e384af9ae1)()
            },
            uTroikaCurveRadius: {
                value: 0
            },
            uTroikaBlurRadius: {
                value: 0
            },
            uTroikaStrokeWidth: {
                value: 0
            },
            uTroikaStrokeColor: {
                value: new (0, $9014d97cd777be10$export$892596cec99bc70e)()
            },
            uTroikaStrokeOpacity: {
                value: 1
            },
            uTroikaOrient: {
                value: new (0, $9014d97cd777be10$export$8ff26dafa08918)()
            },
            uTroikaUseGlyphColors: {
                value: true
            },
            uTroikaSDFDebug: {
                value: false
            }
        },
        vertexDefs: $55f5ea5649168877$var$VERTEX_DEFS,
        vertexTransform: $55f5ea5649168877$var$VERTEX_TRANSFORM,
        fragmentDefs: $55f5ea5649168877$var$FRAGMENT_DEFS,
        fragmentColorTransform: $55f5ea5649168877$var$FRAGMENT_TRANSFORM,
        customRewriter ({ vertexShader: vertexShader, fragmentShader: fragmentShader }) {
            let uDiffuseRE = /\buniform\s+vec3\s+diffuse\b/;
            if (uDiffuseRE.test(fragmentShader)) {
                // Replace all instances of `diffuse` with our varying
                fragmentShader = fragmentShader.replace(uDiffuseRE, "varying vec3 vTroikaGlyphColor").replace(/\bdiffuse\b/g, "vTroikaGlyphColor");
                // Make sure the vertex shader declares the uniform so we can grab it as a fallback
                if (!uDiffuseRE.test(vertexShader)) vertexShader = vertexShader.replace((0, $34196ca962faf131$export$f402b5c74ecf5e1e), "uniform vec3 diffuse;\n$&\nvTroikaGlyphColor = uTroikaUseGlyphColors ? aTroikaGlyphColor / 255.0 : diffuse;\n");
            }
            return {
                vertexShader: vertexShader,
                fragmentShader: fragmentShader
            };
        }
    });
    // Force transparency - TODO is this reasonable?
    textMaterial.transparent = true;
    Object.defineProperties(textMaterial, {
        isTroikaTextMaterial: {
            value: true
        },
        // WebGLShadowMap reverses the side of the shadow material by default, which fails
        // for planes, so here we force the `shadowSide` to always match the main side.
        shadowSide: {
            get () {
                return this.side;
            },
            set () {
            //no-op
            }
        }
    });
    return textMaterial;
}
const $55f5ea5649168877$var$defaultMaterial = /*#__PURE__*/ new (0, $9014d97cd777be10$export$55cbcc9b622fe1f5)({
    color: 0xffffff,
    side: (0, $9014d97cd777be10$export$3b296b6f144d5b03),
    transparent: true
});
const $55f5ea5649168877$var$defaultStrokeColor = 0x808080;
const $55f5ea5649168877$var$tempMat4 = /*#__PURE__*/ new (0, $9014d97cd777be10$export$2ae72fc923e5eb5)();
const $55f5ea5649168877$var$tempVec3a = /*#__PURE__*/ new (0, $9014d97cd777be10$export$64b5c384219d3699)();
const $55f5ea5649168877$var$tempVec3b = /*#__PURE__*/ new (0, $9014d97cd777be10$export$64b5c384219d3699)();
const $55f5ea5649168877$var$tempArray = [];
const $55f5ea5649168877$var$origin = /*#__PURE__*/ new (0, $9014d97cd777be10$export$64b5c384219d3699)();
const $55f5ea5649168877$var$defaultOrient = "+x+y";
function $55f5ea5649168877$var$first(o) {
    return Array.isArray(o) ? o[0] : o;
}
let $55f5ea5649168877$var$getFlatRaycastMesh = ()=>{
    const mesh = new (0, $9014d97cd777be10$export$e176487c05830cc5)(new (0, $9014d97cd777be10$export$967d831af31f69ce)(1, 1), $55f5ea5649168877$var$defaultMaterial);
    $55f5ea5649168877$var$getFlatRaycastMesh = ()=>mesh;
    return mesh;
};
let $55f5ea5649168877$var$getCurvedRaycastMesh = ()=>{
    const mesh = new (0, $9014d97cd777be10$export$e176487c05830cc5)(new (0, $9014d97cd777be10$export$967d831af31f69ce)(1, 1, 32, 1), $55f5ea5649168877$var$defaultMaterial);
    $55f5ea5649168877$var$getCurvedRaycastMesh = ()=>mesh;
    return mesh;
};
const $55f5ea5649168877$var$syncStartEvent = {
    type: "syncstart"
};
const $55f5ea5649168877$var$syncCompleteEvent = {
    type: "synccomplete"
};
const $55f5ea5649168877$var$SYNCABLE_PROPS = [
    "font",
    "fontSize",
    "fontStyle",
    "fontWeight",
    "lang",
    "letterSpacing",
    "lineHeight",
    "maxWidth",
    "overflowWrap",
    "text",
    "direction",
    "textAlign",
    "textIndent",
    "whiteSpace",
    "anchorX",
    "anchorY",
    "colorRanges",
    "sdfGlyphSize"
];
const $55f5ea5649168877$var$COPYABLE_PROPS = $55f5ea5649168877$var$SYNCABLE_PROPS.concat("material", "color", "depthOffset", "clipRect", "curveRadius", "orientation", "glyphGeometryDetail");
/**
 * @class Text
 *
 * A ThreeJS Mesh that renders a string of text on a plane in 3D space using signed distance
 * fields (SDF).
 */ class $55f5ea5649168877$export$5f1af8db9871e1d6 extends (0, $9014d97cd777be10$export$e176487c05830cc5) {
    /**
   * Updates the text rendering according to the current text-related configuration properties.
   * This is an async process, so you can pass in a callback function to be executed when it
   * finishes.
   * @param {function} [callback]
   */ sync(callback) {
        if (this._needsSync) {
            this._needsSync = false;
            // If there's another sync still in progress, queue
            if (this._isSyncing) (this._queuedSyncs || (this._queuedSyncs = [])).push(callback);
            else {
                this._isSyncing = true;
                this.dispatchEvent($55f5ea5649168877$var$syncStartEvent);
                $55f5ea5649168877$var$getTextRenderInfo({
                    text: this.text,
                    font: this.font,
                    lang: this.lang,
                    fontSize: this.fontSize || 0.1,
                    fontWeight: this.fontWeight || "normal",
                    fontStyle: this.fontStyle || "normal",
                    letterSpacing: this.letterSpacing || 0,
                    lineHeight: this.lineHeight || "normal",
                    maxWidth: this.maxWidth,
                    direction: this.direction || "auto",
                    textAlign: this.textAlign,
                    textIndent: this.textIndent,
                    whiteSpace: this.whiteSpace,
                    overflowWrap: this.overflowWrap,
                    anchorX: this.anchorX,
                    anchorY: this.anchorY,
                    colorRanges: this.colorRanges,
                    includeCaretPositions: true,
                    sdfGlyphSize: this.sdfGlyphSize,
                    gpuAccelerateSDF: this.gpuAccelerateSDF
                }, (textRenderInfo)=>{
                    this._isSyncing = false;
                    // Save result for later use in onBeforeRender
                    this._textRenderInfo = textRenderInfo;
                    // Update the geometry attributes
                    this.geometry.updateGlyphs(textRenderInfo.glyphBounds, textRenderInfo.glyphAtlasIndices, textRenderInfo.blockBounds, textRenderInfo.chunkedBounds, textRenderInfo.glyphColors);
                    // If we had extra sync requests queued up, kick it off
                    const queued = this._queuedSyncs;
                    if (queued) {
                        this._queuedSyncs = null;
                        this._needsSync = true;
                        this.sync(()=>{
                            queued.forEach((fn)=>fn && fn());
                        });
                    }
                    this.dispatchEvent($55f5ea5649168877$var$syncCompleteEvent);
                    if (callback) callback();
                });
            }
        }
    }
    /**
   * Initiate a sync if needed - note it won't complete until next frame at the
   * earliest so if possible it's a good idea to call sync() manually as soon as
   * all the properties have been set.
   * @override
   */ onBeforeRender(renderer, scene, camera, geometry, material, group) {
        this.sync();
        // This may not always be a text material, e.g. if there's a scene.overrideMaterial present
        if (material.isTroikaTextMaterial) this._prepareForRender(material);
        // We need to force the material to FrontSide to avoid the double-draw-call performance hit
        // introduced in Three.js r130: https://github.com/mrdoob/three.js/pull/21967 - The sidedness
        // is instead applied via drawRange in the GlyphsGeometry.
        material._hadOwnSide = material.hasOwnProperty("side");
        this.geometry.setSide(material._actualSide = material.side);
        material.side = (0, $9014d97cd777be10$export$2ede184fc2998901);
    }
    onAfterRender(renderer, scene, camera, geometry, material, group) {
        // Restore original material side
        if (material._hadOwnSide) material.side = material._actualSide;
        else delete material.side; // back to inheriting from base material
    }
    /**
   * Shortcut to dispose the geometry specific to this instance.
   * Note: we don't also dispose the derived material here because if anything else is
   * sharing the same base material it will result in a pause next frame as the program
   * is recompiled. Instead users can dispose the base material manually, like normal,
   * and we'll also dispose the derived material at that time.
   */ dispose() {
        this.geometry.dispose();
    }
    /**
   * @property {TroikaTextRenderInfo|null} textRenderInfo
   * @readonly
   * The current processed rendering data for this TextMesh, returned by the TextBuilder after
   * a `sync()` call. This will be `null` initially, and may be stale for a short period until
   * the asynchrous `sync()` process completes.
   */ get textRenderInfo() {
        return this._textRenderInfo || null;
    }
    // Handler for automatically wrapping the base material with our upgrades. We do the wrapping
    // lazily on _read_ rather than write to avoid unnecessary wrapping on transient values.
    get material() {
        let derivedMaterial = this._derivedMaterial;
        const baseMaterial = this._baseMaterial || this._defaultMaterial || (this._defaultMaterial = $55f5ea5649168877$var$defaultMaterial.clone());
        if (!derivedMaterial || derivedMaterial.baseMaterial !== baseMaterial) {
            derivedMaterial = this._derivedMaterial = $55f5ea5649168877$export$ec8c2d2c0fe50886(baseMaterial);
            // dispose the derived material when its base material is disposed:
            baseMaterial.addEventListener("dispose", function onDispose() {
                baseMaterial.removeEventListener("dispose", onDispose);
                derivedMaterial.dispose();
            });
        }
        // If text outline is configured, render it as a preliminary draw using Three's multi-material
        // feature (see GlyphsGeometry which sets up `groups` for this purpose) Doing it with multi
        // materials ensures the layers are always rendered consecutively in a consistent order.
        // Each layer will trigger onBeforeRender with the appropriate material.
        if (this.outlineWidth || this.outlineBlur || this.outlineOffsetX || this.outlineOffsetY) {
            let outlineMaterial = derivedMaterial._outlineMtl;
            if (!outlineMaterial) {
                outlineMaterial = derivedMaterial._outlineMtl = Object.create(derivedMaterial, {
                    id: {
                        value: derivedMaterial.id + 0.1
                    }
                });
                outlineMaterial.isTextOutlineMaterial = true;
                outlineMaterial.depthWrite = false;
                outlineMaterial.map = null; //???
                derivedMaterial.addEventListener("dispose", function onDispose() {
                    derivedMaterial.removeEventListener("dispose", onDispose);
                    outlineMaterial.dispose();
                });
            }
            return [
                outlineMaterial,
                derivedMaterial
            ];
        } else return derivedMaterial;
    }
    set material(baseMaterial) {
        if (baseMaterial && baseMaterial.isTroikaTextMaterial) {
            this._derivedMaterial = baseMaterial;
            this._baseMaterial = baseMaterial.baseMaterial;
        } else this._baseMaterial = baseMaterial;
    }
    get glyphGeometryDetail() {
        return this.geometry.detail;
    }
    set glyphGeometryDetail(detail) {
        this.geometry.detail = detail;
    }
    get curveRadius() {
        return this.geometry.curveRadius;
    }
    set curveRadius(r) {
        this.geometry.curveRadius = r;
    }
    // Create and update material for shadows upon request:
    get customDepthMaterial() {
        return $55f5ea5649168877$var$first(this.material).getDepthMaterial();
    }
    get customDistanceMaterial() {
        return $55f5ea5649168877$var$first(this.material).getDistanceMaterial();
    }
    _prepareForRender(material) {
        const isOutline = material.isTextOutlineMaterial;
        const uniforms = material.uniforms;
        const textInfo = this.textRenderInfo;
        if (textInfo) {
            const { sdfTexture: sdfTexture, blockBounds: blockBounds } = textInfo;
            uniforms.uTroikaSDFTexture.value = sdfTexture;
            uniforms.uTroikaSDFTextureSize.value.set(sdfTexture.image.width, sdfTexture.image.height);
            uniforms.uTroikaSDFGlyphSize.value = textInfo.sdfGlyphSize;
            uniforms.uTroikaSDFExponent.value = textInfo.sdfExponent;
            uniforms.uTroikaTotalBounds.value.fromArray(blockBounds);
            uniforms.uTroikaUseGlyphColors.value = !isOutline && !!textInfo.glyphColors;
            let distanceOffset = 0;
            let blurRadius = 0;
            let strokeWidth = 0;
            let fillOpacity;
            let strokeOpacity;
            let strokeColor;
            let offsetX = 0;
            let offsetY = 0;
            if (isOutline) {
                let { outlineWidth: outlineWidth, outlineOffsetX: outlineOffsetX, outlineOffsetY: outlineOffsetY, outlineBlur: outlineBlur, outlineOpacity: outlineOpacity } = this;
                distanceOffset = this._parsePercent(outlineWidth) || 0;
                blurRadius = Math.max(0, this._parsePercent(outlineBlur) || 0);
                fillOpacity = outlineOpacity;
                offsetX = this._parsePercent(outlineOffsetX) || 0;
                offsetY = this._parsePercent(outlineOffsetY) || 0;
            } else {
                strokeWidth = Math.max(0, this._parsePercent(this.strokeWidth) || 0);
                if (strokeWidth) {
                    strokeColor = this.strokeColor;
                    uniforms.uTroikaStrokeColor.value.set(strokeColor == null ? $55f5ea5649168877$var$defaultStrokeColor : strokeColor);
                    strokeOpacity = this.strokeOpacity;
                    if (strokeOpacity == null) strokeOpacity = 1;
                }
                fillOpacity = this.fillOpacity;
            }
            uniforms.uTroikaDistanceOffset.value = distanceOffset;
            uniforms.uTroikaPositionOffset.value.set(offsetX, offsetY);
            uniforms.uTroikaBlurRadius.value = blurRadius;
            uniforms.uTroikaStrokeWidth.value = strokeWidth;
            uniforms.uTroikaStrokeOpacity.value = strokeOpacity;
            uniforms.uTroikaFillOpacity.value = fillOpacity == null ? 1 : fillOpacity;
            uniforms.uTroikaCurveRadius.value = this.curveRadius || 0;
            let clipRect = this.clipRect;
            if (clipRect && Array.isArray(clipRect) && clipRect.length === 4) uniforms.uTroikaClipRect.value.fromArray(clipRect);
            else {
                // no clipping - choose a finite rect that shouldn't ever be reached by overflowing glyphs or outlines
                const pad = (this.fontSize || 0.1) * 100;
                uniforms.uTroikaClipRect.value.set(blockBounds[0] - pad, blockBounds[1] - pad, blockBounds[2] + pad, blockBounds[3] + pad);
            }
            this.geometry.applyClipRect(uniforms.uTroikaClipRect.value);
        }
        uniforms.uTroikaSDFDebug.value = !!this.debugSDF;
        material.polygonOffset = !!this.depthOffset;
        material.polygonOffsetFactor = material.polygonOffsetUnits = this.depthOffset || 0;
        // Shortcut for setting material color via `color` prop on the mesh; this is
        // applied only to the derived material to avoid mutating a shared base material.
        const color = isOutline ? this.outlineColor || 0 : this.color;
        if (color == null) delete material.color; //inherit from base
        else {
            const colorObj = material.hasOwnProperty("color") ? material.color : material.color = new (0, $9014d97cd777be10$export$892596cec99bc70e)();
            if (color !== colorObj._input || typeof color === "object") colorObj.set(colorObj._input = color);
        }
        // base orientation
        let orient = this.orientation || $55f5ea5649168877$var$defaultOrient;
        if (orient !== material._orientation) {
            let rotMat = uniforms.uTroikaOrient.value;
            orient = orient.replace(/[^-+xyz]/g, "");
            let match = orient !== $55f5ea5649168877$var$defaultOrient && orient.match(/^([-+])([xyz])([-+])([xyz])$/);
            if (match) {
                let [, hSign, hAxis, vSign, vAxis] = match;
                $55f5ea5649168877$var$tempVec3a.set(0, 0, 0)[hAxis] = hSign === "-" ? 1 : -1;
                $55f5ea5649168877$var$tempVec3b.set(0, 0, 0)[vAxis] = vSign === "-" ? -1 : 1;
                $55f5ea5649168877$var$tempMat4.lookAt($55f5ea5649168877$var$origin, $55f5ea5649168877$var$tempVec3a.cross($55f5ea5649168877$var$tempVec3b), $55f5ea5649168877$var$tempVec3b);
                rotMat.setFromMatrix4($55f5ea5649168877$var$tempMat4);
            } else rotMat.identity();
            material._orientation = orient;
        }
    }
    _parsePercent(value) {
        if (typeof value === "string") {
            let match = value.match(/^(-?[\d.]+)%$/);
            let pct = match ? parseFloat(match[1]) : NaN;
            value = (isNaN(pct) ? 0 : pct / 100) * this.fontSize;
        }
        return value;
    }
    /**
   * Translate a point in local space to an x/y in the text plane.
   */ localPositionToTextCoords(position, target = new (0, $9014d97cd777be10$export$c977b3e384af9ae1)()) {
        target.copy(position); //simple non-curved case is 1:1
        const r = this.curveRadius;
        if (r) target.x = Math.atan2(position.x, Math.abs(r) - Math.abs(position.z)) * Math.abs(r);
        return target;
    }
    /**
   * Translate a point in world space to an x/y in the text plane.
   */ worldPositionToTextCoords(position, target = new (0, $9014d97cd777be10$export$c977b3e384af9ae1)()) {
        $55f5ea5649168877$var$tempVec3a.copy(position);
        return this.localPositionToTextCoords(this.worldToLocal($55f5ea5649168877$var$tempVec3a), target);
    }
    /**
   * @override Custom raycasting to test against the whole text block's max rectangular bounds
   * TODO is there any reason to make this more granular, like within individual line or glyph rects?
   */ raycast(raycaster, intersects) {
        const { textRenderInfo: textRenderInfo, curveRadius: curveRadius } = this;
        if (textRenderInfo) {
            const bounds = textRenderInfo.blockBounds;
            const raycastMesh = curveRadius ? $55f5ea5649168877$var$getCurvedRaycastMesh() : $55f5ea5649168877$var$getFlatRaycastMesh();
            const geom = raycastMesh.geometry;
            const { position: position, uv: uv } = geom.attributes;
            for(let i = 0; i < uv.count; i++){
                let x = bounds[0] + uv.getX(i) * (bounds[2] - bounds[0]);
                const y = bounds[1] + uv.getY(i) * (bounds[3] - bounds[1]);
                let z = 0;
                if (curveRadius) {
                    z = curveRadius - Math.cos(x / curveRadius) * curveRadius;
                    x = Math.sin(x / curveRadius) * curveRadius;
                }
                position.setXYZ(i, x, y, z);
            }
            geom.boundingSphere = this.geometry.boundingSphere;
            geom.boundingBox = this.geometry.boundingBox;
            raycastMesh.matrixWorld = this.matrixWorld;
            raycastMesh.material.side = this.material.side;
            $55f5ea5649168877$var$tempArray.length = 0;
            raycastMesh.raycast(raycaster, $55f5ea5649168877$var$tempArray);
            for(let i = 0; i < $55f5ea5649168877$var$tempArray.length; i++){
                $55f5ea5649168877$var$tempArray[i].object = this;
                intersects.push($55f5ea5649168877$var$tempArray[i]);
            }
        }
    }
    copy(source) {
        // Prevent copying the geometry reference so we don't end up sharing attributes between instances
        const geom = this.geometry;
        super.copy(source);
        this.geometry = geom;
        $55f5ea5649168877$var$COPYABLE_PROPS.forEach((prop)=>{
            this[prop] = source[prop];
        });
        return this;
    }
    clone() {
        return new this.constructor().copy(this);
    }
    constructor(){
        const geometry = new $55f5ea5649168877$export$16fe3b8f85ab6e35();
        super(geometry, null);
        // === Text layout properties: === //
        /**
     * @member {string} text
     * The string of text to be rendered.
     */ this.text = "";
        /**
     * @member {number|string} anchorX
     * Defines the horizontal position in the text block that should line up with the local origin.
     * Can be specified as a numeric x position in local units, a string percentage of the total
     * text block width e.g. `'25%'`, or one of the following keyword strings: 'left', 'center',
     * or 'right'.
     */ this.anchorX = 0;
        /**
     * @member {number|string} anchorY
     * Defines the vertical position in the text block that should line up with the local origin.
     * Can be specified as a numeric y position in local units (note: down is negative y), a string
     * percentage of the total text block height e.g. `'25%'`, or one of the following keyword strings:
     * 'top', 'top-baseline', 'top-cap', 'top-ex', 'middle', 'bottom-baseline', or 'bottom'.
     */ this.anchorY = 0;
        /**
     * @member {number} curveRadius
     * Defines a cylindrical radius along which the text's plane will be curved. Positive numbers put
     * the cylinder's centerline (oriented vertically) that distance in front of the text, for a concave
     * curvature, while negative numbers put it behind the text for a convex curvature. The centerline
     * will be aligned with the text's local origin; you can use `anchorX` to offset it.
     *
     * Since each glyph is by default rendered with a simple quad, each glyph remains a flat plane
     * internally. You can use `glyphGeometryDetail` to add more vertices for curvature inside glyphs.
     */ this.curveRadius = 0;
        /**
     * @member {string} direction
     * Sets the base direction for the text. The default value of "auto" will choose a direction based
     * on the text's content according to the bidi spec. A value of "ltr" or "rtl" will force the direction.
     */ this.direction = "auto";
        /**
     * @member {string} font
     * URL of a custom font to be used. Font files can be in .ttf, .otf, or .woff (not .woff2) formats.
     * Defaults to the Roboto font loaded from Google Fonts.
     */ this.font = null; //will use default from TextBuilder
        /**
     * @member {number} fontSize
     * The size at which to render the font in local units; corresponds to the em-box height
     * of the chosen `font`.
     */ this.fontSize = 0.1;
        /**
     * @member {number|'normal'|'bold'}
     * The weight of the font. Currently only used for fallback Noto fonts.
     */ this.fontWeight = "normal";
        /**
     * @member {'normal'|'italic'}
     * The style of the font. Currently only used for fallback Noto fonts.
     */ this.fontStyle = "normal";
        /**
     * @member {string} lang
     * The language code of this text; can be used for font selection.
     */ this.lang = "en";
        /**
     * @member {number} letterSpacing
     * Sets a uniform adjustment to spacing between letters after kerning is applied. Positive
     * numbers increase spacing and negative numbers decrease it.
     */ this.letterSpacing = 0;
        /**
     * @member {number|string} lineHeight
     * Sets the height of each line of text, as a multiple of the `fontSize`. Defaults to 'normal'
     * which chooses a reasonable height based on the chosen font's ascender/descender metrics.
     */ this.lineHeight = "normal";
        /**
     * @member {number} maxWidth
     * The maximum width of the text block, above which text may start wrapping according to the
     * `whiteSpace` and `overflowWrap` properties.
     */ this.maxWidth = Infinity;
        /**
     * @member {string} overflowWrap
     * Defines how text wraps if the `whiteSpace` property is `normal`. Can be either `'normal'`
     * to break at whitespace characters, or `'break-word'` to allow breaking within words.
     * Defaults to `'normal'`.
     */ this.overflowWrap = "normal";
        /**
     * @member {string} textAlign
     * The horizontal alignment of each line of text within the overall text bounding box.
     */ this.textAlign = "left";
        /**
     * @member {number} textIndent
     * Indentation for the first character of a line; see CSS `text-indent`.
     */ this.textIndent = 0;
        /**
     * @member {string} whiteSpace
     * Defines whether text should wrap when a line reaches the `maxWidth`. Can
     * be either `'normal'` (the default), to allow wrapping according to the `overflowWrap` property,
     * or `'nowrap'` to prevent wrapping. Note that `'normal'` here honors newline characters to
     * manually break lines, making it behave more like `'pre-wrap'` does in CSS.
     */ this.whiteSpace = "normal";
        // === Presentation properties: === //
        /**
     * @member {THREE.Material} material
     * Defines a _base_ material to be used when rendering the text. This material will be
     * automatically replaced with a material derived from it, that adds shader code to
     * decrease the alpha for each fragment (pixel) outside the text glyphs, with antialiasing.
     * By default it will derive from a simple white MeshBasicMaterial, but you can use any
     * of the other mesh materials to gain other features like lighting, texture maps, etc.
     *
     * Also see the `color` shortcut property.
     */ this.material = null;
        /**
     * @member {string|number|THREE.Color} color
     * This is a shortcut for setting the `color` of the text's material. You can use this
     * if you don't want to specify a whole custom `material`. Also, if you do use a custom
     * `material`, this color will only be used for this particuar Text instance, even if
     * that same material instance is shared across multiple Text objects.
     */ this.color = null;
        /**
     * @member {object|null} colorRanges
     * WARNING: This API is experimental and may change.
     * This allows more fine-grained control of colors for individual or ranges of characters,
     * taking precedence over the material's `color`. Its format is an Object whose keys each
     * define a starting character index for a range, and whose values are the color for each
     * range. The color value can be a numeric hex color value, a `THREE.Color` object, or
     * any of the strings accepted by `THREE.Color`.
     */ this.colorRanges = null;
        /**
     * @member {number|string} outlineWidth
     * WARNING: This API is experimental and may change.
     * The width of an outline/halo to be drawn around each text glyph using the `outlineColor` and `outlineOpacity`.
     * Can be specified as either an absolute number in local units, or as a percentage string e.g.
     * `"12%"` which is treated as a percentage of the `fontSize`. Defaults to `0`, which means
     * no outline will be drawn unless an `outlineOffsetX/Y` or `outlineBlur` is set.
     */ this.outlineWidth = 0;
        /**
     * @member {string|number|THREE.Color} outlineColor
     * WARNING: This API is experimental and may change.
     * The color of the text outline, if `outlineWidth`/`outlineBlur`/`outlineOffsetX/Y` are set.
     * Defaults to black.
     */ this.outlineColor = 0x000000;
        /**
     * @member {number} outlineOpacity
     * WARNING: This API is experimental and may change.
     * The opacity of the outline, if `outlineWidth`/`outlineBlur`/`outlineOffsetX/Y` are set.
     * Defaults to `1`.
     */ this.outlineOpacity = 1;
        /**
     * @member {number|string} outlineBlur
     * WARNING: This API is experimental and may change.
     * A blur radius applied to the outer edge of the text's outline. If the `outlineWidth` is
     * zero, the blur will be applied at the glyph edge, like CSS's `text-shadow` blur radius.
     * Can be specified as either an absolute number in local units, or as a percentage string e.g.
     * `"12%"` which is treated as a percentage of the `fontSize`. Defaults to `0`.
     */ this.outlineBlur = 0;
        /**
     * @member {number|string} outlineOffsetX
     * WARNING: This API is experimental and may change.
     * A horizontal offset for the text outline.
     * Can be specified as either an absolute number in local units, or as a percentage string e.g. `"12%"`
     * which is treated as a percentage of the `fontSize`. Defaults to `0`.
     */ this.outlineOffsetX = 0;
        /**
     * @member {number|string} outlineOffsetY
     * WARNING: This API is experimental and may change.
     * A vertical offset for the text outline.
     * Can be specified as either an absolute number in local units, or as a percentage string e.g. `"12%"`
     * which is treated as a percentage of the `fontSize`. Defaults to `0`.
     */ this.outlineOffsetY = 0;
        /**
     * @member {number|string} strokeWidth
     * WARNING: This API is experimental and may change.
     * The width of an inner stroke drawn inside each text glyph using the `strokeColor` and `strokeOpacity`.
     * Can be specified as either an absolute number in local units, or as a percentage string e.g. `"12%"`
     * which is treated as a percentage of the `fontSize`. Defaults to `0`.
     */ this.strokeWidth = 0;
        /**
     * @member {string|number|THREE.Color} strokeColor
     * WARNING: This API is experimental and may change.
     * The color of the text stroke, if `strokeWidth` is greater than zero. Defaults to gray.
     */ this.strokeColor = $55f5ea5649168877$var$defaultStrokeColor;
        /**
     * @member {number} strokeOpacity
     * WARNING: This API is experimental and may change.
     * The opacity of the stroke, if `strokeWidth` is greater than zero. Defaults to `1`.
     */ this.strokeOpacity = 1;
        /**
     * @member {number} fillOpacity
     * WARNING: This API is experimental and may change.
     * The opacity of the glyph's fill from 0 to 1. This behaves like the material's `opacity` but allows
     * giving the fill a different opacity than the `strokeOpacity`. A fillOpacity of `0` makes the
     * interior of the glyph invisible, leaving just the `strokeWidth`. Defaults to `1`.
     */ this.fillOpacity = 1;
        /**
     * @member {number} depthOffset
     * This is a shortcut for setting the material's `polygonOffset` and related properties,
     * which can be useful in preventing z-fighting when this text is laid on top of another
     * plane in the scene. Positive numbers are further from the camera, negatives closer.
     */ this.depthOffset = 0;
        /**
     * @member {Array<number>} clipRect
     * If specified, defines a `[minX, minY, maxX, maxY]` of a rectangle outside of which all
     * pixels will be discarded. This can be used for example to clip overflowing text when
     * `whiteSpace='nowrap'`.
     */ this.clipRect = null;
        /**
     * @member {string} orientation
     * Defines the axis plane on which the text should be laid out when the mesh has no extra
     * rotation transform. It is specified as a string with two axes: the horizontal axis with
     * positive pointing right, and the vertical axis with positive pointing up. By default this
     * is '+x+y', meaning the text sits on the xy plane with the text's top toward positive y
     * and facing positive z. A value of '+x-z' would place it on the xz plane with the text's
     * top toward negative z and facing positive y.
     */ this.orientation = $55f5ea5649168877$var$defaultOrient;
        /**
     * @member {number} glyphGeometryDetail
     * Controls number of vertical/horizontal segments that make up each glyph's rectangular
     * plane. Defaults to 1. This can be increased to provide more geometrical detail for custom
     * vertex shader effects, for example.
     */ this.glyphGeometryDetail = 1;
        /**
     * @member {number|null} sdfGlyphSize
     * The size of each glyph's SDF (signed distance field) used for rendering. This must be a
     * power-of-two number. Defaults to 64 which is generally a good balance of size and quality
     * for most fonts. Larger sizes can improve the quality of glyph rendering by increasing
     * the sharpness of corners and preventing loss of very thin lines, at the expense of
     * increased memory footprint and longer SDF generation time.
     */ this.sdfGlyphSize = null;
        /**
     * @member {boolean} gpuAccelerateSDF
     * When `true`, the SDF generation process will be GPU-accelerated with WebGL when possible,
     * making it much faster especially for complex glyphs, and falling back to a JavaScript version
     * executed in web workers when support isn't available. It should automatically detect support,
     * but it's still somewhat experimental, so you can set it to `false` to force it to use the JS
     * version if you encounter issues with it.
     */ this.gpuAccelerateSDF = true;
        this.debugSDF = false;
    }
}
// Create setters for properties that affect text layout:
$55f5ea5649168877$var$SYNCABLE_PROPS.forEach((prop)=>{
    const privateKey = "_private_" + prop;
    Object.defineProperty($55f5ea5649168877$export$5f1af8db9871e1d6.prototype, prop, {
        get () {
            return this[privateKey];
        },
        set (value) {
            if (value !== this[privateKey]) {
                this[privateKey] = value;
                this._needsSync = true;
            }
        }
    });
});
//=== Utility functions for dealing with carets and selection ranges ===//
/**
 * @typedef {object} TextCaret
 * @property {number} x - x position of the caret
 * @property {number} y - y position of the caret's bottom
 * @property {number} height - height of the caret
 * @property {number} charIndex - the index in the original input string of this caret's target
 *   character; the caret will be for the position _before_ that character.
 */ /**
 * Given a local x/y coordinate in the text block plane, find the nearest caret position.
 * @param {TroikaTextRenderInfo} textRenderInfo - a result object from TextBuilder#getTextRenderInfo
 * @param {number} x
 * @param {number} y
 * @return {TextCaret | null}
 */ function $55f5ea5649168877$export$c92621821fde77a5(textRenderInfo, x, y) {
    let closestCaret = null;
    const rows = $55f5ea5649168877$var$groupCaretsByRow(textRenderInfo);
    // Find nearest row by y first
    let closestRow = null;
    rows.forEach((row)=>{
        if (!closestRow || Math.abs(y - (row.top + row.bottom) / 2) < Math.abs(y - (closestRow.top + closestRow.bottom) / 2)) closestRow = row;
    });
    // Then find closest caret by x within that row
    closestRow.carets.forEach((caret)=>{
        if (!closestCaret || Math.abs(x - caret.x) < Math.abs(x - closestCaret.x)) closestCaret = caret;
    });
    return closestCaret;
}
const $55f5ea5649168877$var$_rectsCache = new WeakMap();
/**
 * Given start and end character indexes, return a list of rectangles covering all the
 * characters within that selection.
 * @param {TroikaTextRenderInfo} textRenderInfo
 * @param {number} start - index of the first char in the selection
 * @param {number} end - index of the first char after the selection
 * @return {Array<{left, top, right, bottom}> | null}
 */ function $55f5ea5649168877$export$2b95125f38323093(textRenderInfo, start, end) {
    let rects;
    if (textRenderInfo) {
        // Check cache - textRenderInfo is frozen so it's safe to cache based on it
        let prevResult = $55f5ea5649168877$var$_rectsCache.get(textRenderInfo);
        if (prevResult && prevResult.start === start && prevResult.end === end) return prevResult.rects;
        const { caretPositions: caretPositions } = textRenderInfo;
        // Normalize
        if (end < start) {
            const s = start;
            start = end;
            end = s;
        }
        start = Math.max(start, 0);
        end = Math.min(end, caretPositions.length + 1);
        // Build list of rects, expanding the current rect for all characters in a run and starting
        // a new rect whenever reaching a new line or a new bidi direction
        rects = [];
        let currentRect = null;
        for(let i = start; i < end; i++){
            const x1 = caretPositions[i * 4];
            const x2 = caretPositions[i * 4 + 1];
            const left = Math.min(x1, x2);
            const right = Math.max(x1, x2);
            const bottom = caretPositions[i * 4 + 2];
            const top = caretPositions[i * 4 + 3];
            if (!currentRect || bottom !== currentRect.bottom || top !== currentRect.top || left > currentRect.right || right < currentRect.left) {
                currentRect = {
                    left: Infinity,
                    right: -Infinity,
                    bottom: bottom,
                    top: top
                };
                rects.push(currentRect);
            }
            currentRect.left = Math.min(left, currentRect.left);
            currentRect.right = Math.max(right, currentRect.right);
        }
        // Merge any overlapping rects, e.g. those formed by adjacent bidi runs
        rects.sort((a, b)=>b.bottom - a.bottom || a.left - b.left);
        for(let i = rects.length - 1; i-- > 0;){
            const rectA = rects[i];
            const rectB = rects[i + 1];
            if (rectA.bottom === rectB.bottom && rectA.top === rectB.top && rectA.left <= rectB.right && rectA.right >= rectB.left) {
                rectB.left = Math.min(rectB.left, rectA.left);
                rectB.right = Math.max(rectB.right, rectA.right);
                rects.splice(i, 1);
            }
        }
        $55f5ea5649168877$var$_rectsCache.set(textRenderInfo, {
            start: start,
            end: end,
            rects: rects
        });
    }
    return rects;
}
const $55f5ea5649168877$var$_caretsByRowCache = new WeakMap();
/**
 * Group a set of carets by row of text, caching the result. A single row of text may contain carets of
 * differing positions/heights if it has multiple fonts, and they may overlap slightly across rows, so this
 * uses an assumption of "at least overlapping by half" to put them in the same row.
 * @return Array<{bottom: number, top: number, carets: TextCaret[]}>
 */ function $55f5ea5649168877$var$groupCaretsByRow(textRenderInfo) {
    // textRenderInfo is frozen so it's safe to cache based on it
    let rows = $55f5ea5649168877$var$_caretsByRowCache.get(textRenderInfo);
    if (!rows) {
        rows = [];
        const { caretPositions: caretPositions } = textRenderInfo;
        let curRow;
        const visitCaret = (x, bottom, top, charIndex)=>{
            // new row if not overlapping by at least half
            if (!curRow || top < (curRow.top + curRow.bottom) / 2) rows.push(curRow = {
                bottom: bottom,
                top: top,
                carets: []
            });
            // expand vertical limits if necessary
            if (top > curRow.top) curRow.top = top;
            if (bottom < curRow.bottom) curRow.bottom = bottom;
            curRow.carets.push({
                x: x,
                y: bottom,
                height: top - bottom,
                charIndex: charIndex
            });
        };
        let i = 0;
        for(; i < caretPositions.length; i += 4)visitCaret(caretPositions[i], caretPositions[i + 2], caretPositions[i + 3], i / 4);
        // Add one more caret after the final char
        visitCaret(caretPositions[i - 3], caretPositions[i - 2], caretPositions[i - 1], i / 4);
    }
    $55f5ea5649168877$var$_caretsByRowCache.set(textRenderInfo, rows);
    return rows;
}



var $c60317e2dae19a8a$export$9c1d6cc0bf22137;
(function(UsernamePrefixesInt) {
    UsernamePrefixesInt[UsernamePrefixesInt["Raw"] = 0] = "Raw";
    UsernamePrefixesInt[UsernamePrefixesInt["Ripe"] = 1] = "Ripe";
    UsernamePrefixesInt[UsernamePrefixesInt["Whole"] = 2] = "Whole";
    UsernamePrefixesInt[UsernamePrefixesInt["Fuzzy"] = 3] = "Fuzzy";
    UsernamePrefixesInt[UsernamePrefixesInt["Sour"] = 4] = "Sour";
    UsernamePrefixesInt[UsernamePrefixesInt["Sweet"] = 5] = "Sweet";
    UsernamePrefixesInt[UsernamePrefixesInt["Rotten"] = 6] = "Rotten";
    UsernamePrefixesInt[UsernamePrefixesInt["Peeled"] = 7] = "Peeled";
    UsernamePrefixesInt[UsernamePrefixesInt["Squishy"] = 8] = "Squishy";
    UsernamePrefixesInt[UsernamePrefixesInt["Firm"] = 9] = "Firm";
    UsernamePrefixesInt[UsernamePrefixesInt["Soft"] = 10] = "Soft";
    UsernamePrefixesInt[UsernamePrefixesInt["Tangy"] = 11] = "Tangy";
    UsernamePrefixesInt[UsernamePrefixesInt["Savory"] = 12] = "Savory";
    UsernamePrefixesInt[UsernamePrefixesInt["Acidic"] = 13] = "Acidic";
    UsernamePrefixesInt[UsernamePrefixesInt["Browning"] = 14] = "Browning";
    UsernamePrefixesInt[UsernamePrefixesInt["Chewy"] = 15] = "Chewy";
    UsernamePrefixesInt[UsernamePrefixesInt["Crunchy"] = 16] = "Crunchy";
    UsernamePrefixesInt[UsernamePrefixesInt["Cold"] = 17] = "Cold";
    UsernamePrefixesInt[UsernamePrefixesInt["Bland"] = 18] = "Bland";
    UsernamePrefixesInt[UsernamePrefixesInt["Cracked"] = 19] = "Cracked";
    UsernamePrefixesInt[UsernamePrefixesInt["Creamy"] = 20] = "Creamy";
    UsernamePrefixesInt[UsernamePrefixesInt["Chilled"] = 21] = "Chilled";
    UsernamePrefixesInt[UsernamePrefixesInt["Delicious"] = 22] = "Delicious";
    UsernamePrefixesInt[UsernamePrefixesInt["Dainty"] = 23] = "Dainty";
    UsernamePrefixesInt[UsernamePrefixesInt["Dirty"] = 24] = "Dirty";
    UsernamePrefixesInt[UsernamePrefixesInt["Dense"] = 25] = "Dense";
    UsernamePrefixesInt[UsernamePrefixesInt["Dubious"] = 26] = "Dubious";
    UsernamePrefixesInt[UsernamePrefixesInt["Delectable"] = 27] = "Delectable";
    UsernamePrefixesInt[UsernamePrefixesInt["Dry"] = 28] = "Dry";
    UsernamePrefixesInt[UsernamePrefixesInt["Enormous"] = 29] = "Enormous";
    UsernamePrefixesInt[UsernamePrefixesInt["Elegant"] = 30] = "Elegant";
    UsernamePrefixesInt[UsernamePrefixesInt["Engorged"] = 31] = "Engorged";
    UsernamePrefixesInt[UsernamePrefixesInt["Coarse"] = 32] = "Coarse";
    UsernamePrefixesInt[UsernamePrefixesInt["Fluffy"] = 33] = "Fluffy";
    UsernamePrefixesInt[UsernamePrefixesInt["Frozen"] = 34] = "Frozen";
    UsernamePrefixesInt[UsernamePrefixesInt["Fruity"] = 35] = "Fruity";
    UsernamePrefixesInt[UsernamePrefixesInt["Dredged"] = 36] = "Dredged";
    UsernamePrefixesInt[UsernamePrefixesInt["Falling"] = 37] = "Falling";
    UsernamePrefixesInt[UsernamePrefixesInt["FreeRange"] = 38] = "FreeRange";
    UsernamePrefixesInt[UsernamePrefixesInt["Golden"] = 39] = "Golden";
    UsernamePrefixesInt[UsernamePrefixesInt["Garnished"] = 40] = "Garnished";
    UsernamePrefixesInt[UsernamePrefixesInt["GrassFed"] = 41] = "GrassFed";
    UsernamePrefixesInt[UsernamePrefixesInt["Grated"] = 42] = "Grated";
    UsernamePrefixesInt[UsernamePrefixesInt["Grotesque"] = 43] = "Grotesque";
    UsernamePrefixesInt[UsernamePrefixesInt["Green"] = 44] = "Green";
    UsernamePrefixesInt[UsernamePrefixesInt["Hot"] = 45] = "Hot";
    UsernamePrefixesInt[UsernamePrefixesInt["Hairy"] = 46] = "Hairy";
    UsernamePrefixesInt[UsernamePrefixesInt["Heavy"] = 47] = "Heavy";
    UsernamePrefixesInt[UsernamePrefixesInt["Hollow"] = 48] = "Hollow";
    UsernamePrefixesInt[UsernamePrefixesInt["Inedible"] = 49] = "Inedible";
    UsernamePrefixesInt[UsernamePrefixesInt["Icky"] = 50] = "Icky";
    UsernamePrefixesInt[UsernamePrefixesInt["Iced"] = 51] = "Iced";
    UsernamePrefixesInt[UsernamePrefixesInt["Juicy"] = 52] = "Juicy";
    UsernamePrefixesInt[UsernamePrefixesInt["Canned"] = 53] = "Canned";
    UsernamePrefixesInt[UsernamePrefixesInt["Digestible"] = 54] = "Digestible";
    UsernamePrefixesInt[UsernamePrefixesInt["Jammy"] = 55] = "Jammy";
    UsernamePrefixesInt[UsernamePrefixesInt["Jumbo"] = 56] = "Jumbo";
    UsernamePrefixesInt[UsernamePrefixesInt["Krispy"] = 57] = "Krispy";
    UsernamePrefixesInt[UsernamePrefixesInt["Light"] = 58] = "Light";
    UsernamePrefixesInt[UsernamePrefixesInt["Moist"] = 59] = "Moist";
    UsernamePrefixesInt[UsernamePrefixesInt["Yummy"] = 60] = "Yummy";
    UsernamePrefixesInt[UsernamePrefixesInt["Nutty"] = 61] = "Nutty";
    UsernamePrefixesInt[UsernamePrefixesInt["Natural"] = 62] = "Natural";
    UsernamePrefixesInt[UsernamePrefixesInt["Oozy"] = 63] = "Oozy";
    UsernamePrefixesInt[UsernamePrefixesInt["Organic"] = 64] = "Organic";
    UsernamePrefixesInt[UsernamePrefixesInt["Old"] = 65] = "Old";
    UsernamePrefixesInt[UsernamePrefixesInt["Pungent"] = 66] = "Pungent";
    UsernamePrefixesInt[UsernamePrefixesInt["Peppery"] = 67] = "Peppery";
    UsernamePrefixesInt[UsernamePrefixesInt["Putrid"] = 68] = "Putrid";
    UsernamePrefixesInt[UsernamePrefixesInt["Quality"] = 69] = "Quality";
    UsernamePrefixesInt[UsernamePrefixesInt["Rich"] = 70] = "Rich";
    UsernamePrefixesInt[UsernamePrefixesInt["Robust"] = 71] = "Robust";
    UsernamePrefixesInt[UsernamePrefixesInt["Spicy"] = 72] = "Spicy";
    UsernamePrefixesInt[UsernamePrefixesInt["Succulent"] = 73] = "Succulent";
    UsernamePrefixesInt[UsernamePrefixesInt["Stinky"] = 74] = "Stinky";
    UsernamePrefixesInt[UsernamePrefixesInt["Tart"] = 75] = "Tart";
    UsernamePrefixesInt[UsernamePrefixesInt["Tender"] = 76] = "Tender";
    UsernamePrefixesInt[UsernamePrefixesInt["Velvety"] = 77] = "Velvety";
    UsernamePrefixesInt[UsernamePrefixesInt["Zesty"] = 78] = "Zesty";
})($c60317e2dae19a8a$export$9c1d6cc0bf22137 || ($c60317e2dae19a8a$export$9c1d6cc0bf22137 = {}));
var $c60317e2dae19a8a$export$6ea3032238c5bf02;
(function(UsernameSuffixesInt) {
    UsernameSuffixesInt[UsernameSuffixesInt["Apple"] = 0] = "Apple";
    UsernameSuffixesInt[UsernameSuffixesInt["Apricot"] = 1] = "Apricot";
    UsernameSuffixesInt[UsernameSuffixesInt["Almond"] = 2] = "Almond";
    UsernameSuffixesInt[UsernameSuffixesInt["Acorn"] = 3] = "Acorn";
    UsernameSuffixesInt[UsernameSuffixesInt["Artichoke"] = 4] = "Artichoke";
    UsernameSuffixesInt[UsernameSuffixesInt["Blueberry"] = 5] = "Blueberry";
    UsernameSuffixesInt[UsernameSuffixesInt["Banana"] = 6] = "Banana";
    UsernameSuffixesInt[UsernameSuffixesInt["Broccoli"] = 7] = "Broccoli";
    UsernameSuffixesInt[UsernameSuffixesInt["BrusselSprout"] = 8] = "BrusselSprout";
    UsernameSuffixesInt[UsernameSuffixesInt["Bread"] = 9] = "Bread";
    UsernameSuffixesInt[UsernameSuffixesInt["BigMac"] = 10] = "BigMac";
    UsernameSuffixesInt[UsernameSuffixesInt["Cookie"] = 11] = "Cookie";
    UsernameSuffixesInt[UsernameSuffixesInt["Carrot"] = 12] = "Carrot";
    UsernameSuffixesInt[UsernameSuffixesInt["Celery"] = 13] = "Celery";
    UsernameSuffixesInt[UsernameSuffixesInt["Carp"] = 14] = "Carp";
    UsernameSuffixesInt[UsernameSuffixesInt["Crouton"] = 15] = "Crouton";
    UsernameSuffixesInt[UsernameSuffixesInt["Cucumber"] = 16] = "Cucumber";
    UsernameSuffixesInt[UsernameSuffixesInt["Bean"] = 17] = "Bean";
    UsernameSuffixesInt[UsernameSuffixesInt["Beetroot"] = 18] = "Beetroot";
    UsernameSuffixesInt[UsernameSuffixesInt["Cauliflower"] = 19] = "Cauliflower";
    UsernameSuffixesInt[UsernameSuffixesInt["Cake"] = 20] = "Cake";
    UsernameSuffixesInt[UsernameSuffixesInt["Cranberry"] = 21] = "Cranberry";
    UsernameSuffixesInt[UsernameSuffixesInt["Crab"] = 22] = "Crab";
    UsernameSuffixesInt[UsernameSuffixesInt["Danish"] = 23] = "Danish";
    UsernameSuffixesInt[UsernameSuffixesInt["Chip"] = 24] = "Chip";
    UsernameSuffixesInt[UsernameSuffixesInt["Donut"] = 25] = "Donut";
    UsernameSuffixesInt[UsernameSuffixesInt["Dumpling"] = 26] = "Dumpling";
    UsernameSuffixesInt[UsernameSuffixesInt["Durian"] = 27] = "Durian";
    UsernameSuffixesInt[UsernameSuffixesInt["Chocolate"] = 28] = "Chocolate";
    UsernameSuffixesInt[UsernameSuffixesInt["Date"] = 29] = "Date";
    UsernameSuffixesInt[UsernameSuffixesInt["Eggplant"] = 30] = "Eggplant";
    UsernameSuffixesInt[UsernameSuffixesInt["Egg"] = 31] = "Egg";
    UsernameSuffixesInt[UsernameSuffixesInt["Enchilada"] = 32] = "Enchilada";
    UsernameSuffixesInt[UsernameSuffixesInt["Fry"] = 33] = "Fry";
    UsernameSuffixesInt[UsernameSuffixesInt["Fig"] = 34] = "Fig";
    UsernameSuffixesInt[UsernameSuffixesInt["Falafel"] = 35] = "Falafel";
    UsernameSuffixesInt[UsernameSuffixesInt["Fudge"] = 36] = "Fudge";
    UsernameSuffixesInt[UsernameSuffixesInt["Flapjack"] = 37] = "Flapjack";
    UsernameSuffixesInt[UsernameSuffixesInt["Fajita"] = 38] = "Fajita";
    UsernameSuffixesInt[UsernameSuffixesInt["Chicken"] = 39] = "Chicken";
    UsernameSuffixesInt[UsernameSuffixesInt["Grape"] = 40] = "Grape";
    UsernameSuffixesInt[UsernameSuffixesInt["Guacamole"] = 41] = "Guacamole";
    UsernameSuffixesInt[UsernameSuffixesInt["Grapefruit"] = 42] = "Grapefruit";
    UsernameSuffixesInt[UsernameSuffixesInt["Gazpacho"] = 43] = "Gazpacho";
    UsernameSuffixesInt[UsernameSuffixesInt["Gnocchi"] = 44] = "Gnocchi";
    UsernameSuffixesInt[UsernameSuffixesInt["HotDog"] = 45] = "HotDog";
    UsernameSuffixesInt[UsernameSuffixesInt["Ham"] = 46] = "Ham";
    UsernameSuffixesInt[UsernameSuffixesInt["Hazelnut"] = 47] = "Hazelnut";
    UsernameSuffixesInt[UsernameSuffixesInt["Haggis"] = 48] = "Haggis";
    UsernameSuffixesInt[UsernameSuffixesInt["IceCream"] = 49] = "IceCream";
    UsernameSuffixesInt[UsernameSuffixesInt["Cupcake"] = 50] = "Cupcake";
    UsernameSuffixesInt[UsernameSuffixesInt["Jello"] = 51] = "Jello";
    UsernameSuffixesInt[UsernameSuffixesInt["Jerky"] = 52] = "Jerky";
    UsernameSuffixesInt[UsernameSuffixesInt["Jackfruit"] = 53] = "Jackfruit";
    UsernameSuffixesInt[UsernameSuffixesInt["Kale"] = 54] = "Kale";
    UsernameSuffixesInt[UsernameSuffixesInt["Kiwi"] = 55] = "Kiwi";
    UsernameSuffixesInt[UsernameSuffixesInt["Kimchi"] = 56] = "Kimchi";
    UsernameSuffixesInt[UsernameSuffixesInt["Lemon"] = 57] = "Lemon";
    UsernameSuffixesInt[UsernameSuffixesInt["Lime"] = 58] = "Lime";
    UsernameSuffixesInt[UsernameSuffixesInt["Leek"] = 59] = "Leek";
    UsernameSuffixesInt[UsernameSuffixesInt["Lobster"] = 60] = "Lobster";
    UsernameSuffixesInt[UsernameSuffixesInt["Muffin"] = 61] = "Muffin";
    UsernameSuffixesInt[UsernameSuffixesInt["Macaroni"] = 62] = "Macaroni";
    UsernameSuffixesInt[UsernameSuffixesInt["Meatball"] = 63] = "Meatball";
    UsernameSuffixesInt[UsernameSuffixesInt["Noodle"] = 64] = "Noodle";
    UsernameSuffixesInt[UsernameSuffixesInt["Nectarine"] = 65] = "Nectarine";
    UsernameSuffixesInt[UsernameSuffixesInt["Nougat"] = 66] = "Nougat";
    UsernameSuffixesInt[UsernameSuffixesInt["Orange"] = 67] = "Orange";
    UsernameSuffixesInt[UsernameSuffixesInt["Okra"] = 68] = "Okra";
    UsernameSuffixesInt[UsernameSuffixesInt["Peach"] = 69] = "Peach";
    UsernameSuffixesInt[UsernameSuffixesInt["Pizza"] = 70] = "Pizza";
    UsernameSuffixesInt[UsernameSuffixesInt["Popcorn"] = 71] = "Popcorn";
    UsernameSuffixesInt[UsernameSuffixesInt["Quiche"] = 72] = "Quiche";
    UsernameSuffixesInt[UsernameSuffixesInt["Quinoa"] = 73] = "Quinoa";
    UsernameSuffixesInt[UsernameSuffixesInt["Quesadilla"] = 74] = "Quesadilla";
    UsernameSuffixesInt[UsernameSuffixesInt["Raspberry"] = 75] = "Raspberry";
    UsernameSuffixesInt[UsernameSuffixesInt["Radish"] = 76] = "Radish";
    UsernameSuffixesInt[UsernameSuffixesInt["Rutabaga"] = 77] = "Rutabaga";
    UsernameSuffixesInt[UsernameSuffixesInt["Strawberry"] = 78] = "Strawberry";
    UsernameSuffixesInt[UsernameSuffixesInt["Spinach"] = 79] = "Spinach";
    UsernameSuffixesInt[UsernameSuffixesInt["Sorbet"] = 80] = "Sorbet";
    UsernameSuffixesInt[UsernameSuffixesInt["Spaghetti"] = 81] = "Spaghetti";
    UsernameSuffixesInt[UsernameSuffixesInt["Tomato"] = 82] = "Tomato";
    UsernameSuffixesInt[UsernameSuffixesInt["Truffle"] = 83] = "Truffle";
    UsernameSuffixesInt[UsernameSuffixesInt["Udon"] = 84] = "Udon";
    UsernameSuffixesInt[UsernameSuffixesInt["Veal"] = 85] = "Veal";
    UsernameSuffixesInt[UsernameSuffixesInt["Vegetable"] = 86] = "Vegetable";
    UsernameSuffixesInt[UsernameSuffixesInt["Fruit"] = 87] = "Fruit";
    UsernameSuffixesInt[UsernameSuffixesInt["Venison"] = 88] = "Venison";
    UsernameSuffixesInt[UsernameSuffixesInt["Waffle"] = 89] = "Waffle";
    UsernameSuffixesInt[UsernameSuffixesInt["Wasabi"] = 90] = "Wasabi";
    UsernameSuffixesInt[UsernameSuffixesInt["Walnut"] = 91] = "Walnut";
    UsernameSuffixesInt[UsernameSuffixesInt["Watermelon"] = 92] = "Watermelon";
    UsernameSuffixesInt[UsernameSuffixesInt["Yogurt"] = 93] = "Yogurt";
    UsernameSuffixesInt[UsernameSuffixesInt["Zucchini"] = 94] = "Zucchini";
})($c60317e2dae19a8a$export$6ea3032238c5bf02 || ($c60317e2dae19a8a$export$6ea3032238c5bf02 = {}));
var $c60317e2dae19a8a$export$b33f41d0b11df887;
(function(Countries) {
    Countries[Countries["None"] = 1] = "None";
    Countries[Countries["AlandIslands"] = 2] = "AlandIslands";
    Countries[Countries["Albania"] = 3] = "Albania";
    Countries[Countries["Algeria"] = 4] = "Algeria";
    Countries[Countries["AmericanSamoa"] = 5] = "AmericanSamoa";
    Countries[Countries["Andorra"] = 6] = "Andorra";
    Countries[Countries["Angola"] = 7] = "Angola";
    Countries[Countries["Anguilla"] = 8] = "Anguilla";
    Countries[Countries["Antarctica"] = 9] = "Antarctica";
    Countries[Countries["AntiguaAndBarbuda"] = 10] = "AntiguaAndBarbuda";
    Countries[Countries["Argentina"] = 11] = "Argentina";
    Countries[Countries["Armenia"] = 12] = "Armenia";
    Countries[Countries["Aruba"] = 13] = "Aruba";
    Countries[Countries["Australia"] = 14] = "Australia";
    Countries[Countries["Austria"] = 15] = "Austria";
    Countries[Countries["Azerbaijan"] = 16] = "Azerbaijan";
    Countries[Countries["Bahamas"] = 17] = "Bahamas";
    Countries[Countries["Bahrain"] = 18] = "Bahrain";
    Countries[Countries["Bangladesh"] = 19] = "Bangladesh";
    Countries[Countries["Barbados"] = 20] = "Barbados";
    Countries[Countries["Belarus"] = 21] = "Belarus";
    Countries[Countries["Belgium"] = 22] = "Belgium";
    Countries[Countries["Belize"] = 23] = "Belize";
    Countries[Countries["Benin"] = 24] = "Benin";
    Countries[Countries["Bermuda"] = 25] = "Bermuda";
    Countries[Countries["Bhutan"] = 26] = "Bhutan";
    Countries[Countries["Bolivia"] = 27] = "Bolivia";
    Countries[Countries["BosniaAndHerzegovina"] = 28] = "BosniaAndHerzegovina";
    Countries[Countries["Botswana"] = 29] = "Botswana";
    Countries[Countries["BouvetIsland"] = 30] = "BouvetIsland";
    Countries[Countries["Brazil"] = 31] = "Brazil";
    Countries[Countries["BritishIndianOceanTerritory"] = 32] = "BritishIndianOceanTerritory";
    Countries[Countries["Brunei"] = 33] = "Brunei";
    Countries[Countries["Bulgaria"] = 34] = "Bulgaria";
    Countries[Countries["BurkinaFaso"] = 35] = "BurkinaFaso";
    Countries[Countries["Burundi"] = 36] = "Burundi";
    Countries[Countries["Cambodia"] = 37] = "Cambodia";
    Countries[Countries["Cameroon"] = 38] = "Cameroon";
    Countries[Countries["Canada"] = 39] = "Canada";
    Countries[Countries["CapeVerde"] = 40] = "CapeVerde";
    Countries[Countries["CaymanIslands"] = 41] = "CaymanIslands";
    Countries[Countries["CentralAfricanRepublic"] = 42] = "CentralAfricanRepublic";
    Countries[Countries["Chad"] = 43] = "Chad";
    Countries[Countries["Chile"] = 44] = "Chile";
    Countries[Countries["China"] = 45] = "China";
    Countries[Countries["ChristmasIsland"] = 46] = "ChristmasIsland";
    Countries[Countries["CocosKeelingIslands"] = 47] = "CocosKeelingIslands";
    Countries[Countries["Colombia"] = 48] = "Colombia";
    Countries[Countries["Comoros"] = 49] = "Comoros";
    Countries[Countries["RepublicOfTheCongo"] = 50] = "RepublicOfTheCongo";
    Countries[Countries["DRCongo"] = 51] = "DRCongo";
    Countries[Countries["CookIslands"] = 52] = "CookIslands";
    Countries[Countries["CostaRica"] = 53] = "CostaRica";
    Countries[Countries["IvoryCoast"] = 54] = "IvoryCoast";
    Countries[Countries["Croatia"] = 55] = "Croatia";
    Countries[Countries["Cuba"] = 56] = "Cuba";
    Countries[Countries["Curacao"] = 57] = "Curacao";
    Countries[Countries["Cyprus"] = 58] = "Cyprus";
    Countries[Countries["Czechia"] = 59] = "Czechia";
    Countries[Countries["Denmark"] = 60] = "Denmark";
    Countries[Countries["Djibouti"] = 61] = "Djibouti";
    Countries[Countries["Dominica"] = 62] = "Dominica";
    Countries[Countries["DominicanRepublic"] = 63] = "DominicanRepublic";
    Countries[Countries["Ecuador"] = 64] = "Ecuador";
    Countries[Countries["Egypt"] = 65] = "Egypt";
    Countries[Countries["ElSalvador"] = 66] = "ElSalvador";
    Countries[Countries["England"] = 67] = "England";
    Countries[Countries["EquatorialGuinea"] = 68] = "EquatorialGuinea";
    Countries[Countries["Eritrea"] = 69] = "Eritrea";
    Countries[Countries["Estonia"] = 70] = "Estonia";
    Countries[Countries["EswatiniSwaziland"] = 71] = "EswatiniSwaziland";
    Countries[Countries["Ethiopia"] = 72] = "Ethiopia";
    Countries[Countries["FalklandIslands"] = 73] = "FalklandIslands";
    Countries[Countries["FaroeIslands"] = 74] = "FaroeIslands";
    Countries[Countries["Fiji"] = 75] = "Fiji";
    Countries[Countries["Finland"] = 76] = "Finland";
    Countries[Countries["France"] = 77] = "France";
    Countries[Countries["FrenchGuiana"] = 78] = "FrenchGuiana";
    Countries[Countries["FrenchPolynesia"] = 79] = "FrenchPolynesia";
    Countries[Countries["FrenchSouthernAndAntarcticLands"] = 80] = "FrenchSouthernAndAntarcticLands";
    Countries[Countries["Gabon"] = 81] = "Gabon";
    Countries[Countries["Gambia"] = 82] = "Gambia";
    Countries[Countries["Georgia"] = 83] = "Georgia";
    Countries[Countries["Germany"] = 84] = "Germany";
    Countries[Countries["Ghana"] = 85] = "Ghana";
    Countries[Countries["Gibraltar"] = 86] = "Gibraltar";
    Countries[Countries["Greece"] = 87] = "Greece";
    Countries[Countries["Greenland"] = 88] = "Greenland";
    Countries[Countries["Grenada"] = 89] = "Grenada";
    Countries[Countries["Guadeloupe"] = 90] = "Guadeloupe";
    Countries[Countries["Guam"] = 91] = "Guam";
    Countries[Countries["Guatemala"] = 92] = "Guatemala";
    Countries[Countries["Guernsey"] = 93] = "Guernsey";
    Countries[Countries["Guinea"] = 94] = "Guinea";
    Countries[Countries["GuineaBissau"] = 95] = "GuineaBissau";
    Countries[Countries["Guyana"] = 96] = "Guyana";
    Countries[Countries["Haiti"] = 97] = "Haiti";
    Countries[Countries["HeardIslandAndMcdonaldIslands"] = 98] = "HeardIslandAndMcdonaldIslands";
    Countries[Countries["Honduras"] = 99] = "Honduras";
    Countries[Countries["HongKong"] = 100] = "HongKong";
    Countries[Countries["Hungary"] = 101] = "Hungary";
    Countries[Countries["Iceland"] = 102] = "Iceland";
    Countries[Countries["India"] = 103] = "India";
    Countries[Countries["Indonesia"] = 104] = "Indonesia";
    Countries[Countries["Iran"] = 105] = "Iran";
    Countries[Countries["Iraq"] = 106] = "Iraq";
    Countries[Countries["Ireland"] = 107] = "Ireland";
    Countries[Countries["IsleOfMan"] = 108] = "IsleOfMan";
    Countries[Countries["Israel"] = 109] = "Israel";
    Countries[Countries["Italy"] = 110] = "Italy";
    Countries[Countries["Jamaica"] = 111] = "Jamaica";
    Countries[Countries["Japan"] = 112] = "Japan";
    Countries[Countries["Jersey"] = 113] = "Jersey";
    Countries[Countries["Jordan"] = 114] = "Jordan";
    Countries[Countries["Kazakhstan"] = 115] = "Kazakhstan";
    Countries[Countries["Kenya"] = 116] = "Kenya";
    Countries[Countries["Kiribati"] = 117] = "Kiribati";
    Countries[Countries["NorthKorea"] = 118] = "NorthKorea";
    Countries[Countries["SouthKorea"] = 119] = "SouthKorea";
    Countries[Countries["Kosovo"] = 120] = "Kosovo";
    Countries[Countries["Kuwait"] = 121] = "Kuwait";
    Countries[Countries["Kyrgyzstan"] = 122] = "Kyrgyzstan";
    Countries[Countries["Laos"] = 123] = "Laos";
    Countries[Countries["Latvia"] = 124] = "Latvia";
    Countries[Countries["Lebanon"] = 125] = "Lebanon";
    Countries[Countries["Lesotho"] = 126] = "Lesotho";
    Countries[Countries["Liberia"] = 127] = "Liberia";
    Countries[Countries["Libya"] = 128] = "Libya";
    Countries[Countries["Liechtenstein"] = 129] = "Liechtenstein";
    Countries[Countries["Lithuania"] = 130] = "Lithuania";
    Countries[Countries["Luxembourg"] = 131] = "Luxembourg";
    Countries[Countries["Macau"] = 132] = "Macau";
    Countries[Countries["Madagascar"] = 133] = "Madagascar";
    Countries[Countries["Malawi"] = 134] = "Malawi";
    Countries[Countries["Malaysia"] = 135] = "Malaysia";
    Countries[Countries["Maldives"] = 136] = "Maldives";
    Countries[Countries["Mali"] = 137] = "Mali";
    Countries[Countries["Malta"] = 138] = "Malta";
    Countries[Countries["MarshallIslands"] = 139] = "MarshallIslands";
    Countries[Countries["Martinique"] = 140] = "Martinique";
    Countries[Countries["Mauritania"] = 141] = "Mauritania";
    Countries[Countries["Mauritius"] = 142] = "Mauritius";
    Countries[Countries["Mayotte"] = 143] = "Mayotte";
    Countries[Countries["Mexico"] = 144] = "Mexico";
    Countries[Countries["Micronesia"] = 145] = "Micronesia";
    Countries[Countries["Moldova"] = 146] = "Moldova";
    Countries[Countries["Monaco"] = 147] = "Monaco";
    Countries[Countries["Mongolia"] = 148] = "Mongolia";
    Countries[Countries["Montenegro"] = 149] = "Montenegro";
    Countries[Countries["Montserrat"] = 150] = "Montserrat";
    Countries[Countries["Morocco"] = 151] = "Morocco";
    Countries[Countries["Mozambique"] = 152] = "Mozambique";
    Countries[Countries["Myanmar"] = 153] = "Myanmar";
    Countries[Countries["Namibia"] = 154] = "Namibia";
    Countries[Countries["Nauru"] = 155] = "Nauru";
    Countries[Countries["Nepal"] = 156] = "Nepal";
    Countries[Countries["Netherlands"] = 157] = "Netherlands";
    Countries[Countries["NewCaledonia"] = 158] = "NewCaledonia";
    Countries[Countries["NewZealand"] = 159] = "NewZealand";
    Countries[Countries["Nicaragua"] = 160] = "Nicaragua";
    Countries[Countries["Niger"] = 161] = "Niger";
    Countries[Countries["Nigeria"] = 162] = "Nigeria";
    Countries[Countries["Niue"] = 163] = "Niue";
    Countries[Countries["NorfolkIsland"] = 164] = "NorfolkIsland";
    Countries[Countries["NorthMacedonia"] = 165] = "NorthMacedonia";
    Countries[Countries["NorthernMarianaIslands"] = 166] = "NorthernMarianaIslands";
    Countries[Countries["Norway"] = 167] = "Norway";
    Countries[Countries["Oman"] = 168] = "Oman";
    Countries[Countries["Pakistan"] = 169] = "Pakistan";
    Countries[Countries["Palau"] = 170] = "Palau";
    Countries[Countries["Palestine"] = 171] = "Palestine";
    Countries[Countries["Panama"] = 172] = "Panama";
    Countries[Countries["PapuaNewGuinea"] = 173] = "PapuaNewGuinea";
    Countries[Countries["Paraguay"] = 174] = "Paraguay";
    Countries[Countries["Peru"] = 175] = "Peru";
    Countries[Countries["Philippines"] = 176] = "Philippines";
    Countries[Countries["PitcairnIslands"] = 177] = "PitcairnIslands";
    Countries[Countries["Poland"] = 178] = "Poland";
    Countries[Countries["Portugal"] = 179] = "Portugal";
    Countries[Countries["PuertoRico"] = 180] = "PuertoRico";
    Countries[Countries["Qatar"] = 181] = "Qatar";
    Countries[Countries["Reunion"] = 182] = "Reunion";
    Countries[Countries["Romania"] = 183] = "Romania";
    Countries[Countries["Russia"] = 184] = "Russia";
    Countries[Countries["Rwanda"] = 185] = "Rwanda";
    Countries[Countries["SaintBarthelemy"] = 186] = "SaintBarthelemy";
    Countries[Countries["SaintHelenaAscensionAndTristandaCunha"] = 187] = "SaintHelenaAscensionAndTristandaCunha";
    Countries[Countries["SaintKittsAndNevis"] = 188] = "SaintKittsAndNevis";
    Countries[Countries["SaintLucia"] = 189] = "SaintLucia";
    Countries[Countries["SaintMartin"] = 190] = "SaintMartin";
    Countries[Countries["SaintPierreAndMiquelon"] = 191] = "SaintPierreAndMiquelon";
    Countries[Countries["SaintVincentAndTheGrenadines"] = 192] = "SaintVincentAndTheGrenadines";
    Countries[Countries["Samoa"] = 193] = "Samoa";
    Countries[Countries["SanMarino"] = 194] = "SanMarino";
    Countries[Countries["SaoTomeAndPrincipe"] = 195] = "SaoTomeAndPrincipe";
    Countries[Countries["SaudiArabia"] = 196] = "SaudiArabia";
    Countries[Countries["Scotland"] = 197] = "Scotland";
    Countries[Countries["Senegal"] = 198] = "Senegal";
    Countries[Countries["Serbia"] = 199] = "Serbia";
    Countries[Countries["Seychelles"] = 200] = "Seychelles";
    Countries[Countries["SierraLeone"] = 201] = "SierraLeone";
    Countries[Countries["Singapore"] = 202] = "Singapore";
    Countries[Countries["SintMaarten"] = 203] = "SintMaarten";
    Countries[Countries["Slovakia"] = 204] = "Slovakia";
    Countries[Countries["Slovenia"] = 205] = "Slovenia";
    Countries[Countries["SolomonIslands"] = 206] = "SolomonIslands";
    Countries[Countries["Somalia"] = 207] = "Somalia";
    Countries[Countries["SouthAfrica"] = 208] = "SouthAfrica";
    Countries[Countries["SouthGeorgia"] = 209] = "SouthGeorgia";
    Countries[Countries["SouthSudan"] = 210] = "SouthSudan";
    Countries[Countries["Spain"] = 211] = "Spain";
    Countries[Countries["SriLanka"] = 212] = "SriLanka";
    Countries[Countries["Sudan"] = 213] = "Sudan";
    Countries[Countries["Suriname"] = 214] = "Suriname";
    Countries[Countries["SvalbardAndJanMayen"] = 215] = "SvalbardAndJanMayen";
    Countries[Countries["Sweden"] = 216] = "Sweden";
    Countries[Countries["Switzerland"] = 217] = "Switzerland";
    Countries[Countries["Syria"] = 218] = "Syria";
    Countries[Countries["Taiwan"] = 219] = "Taiwan";
    Countries[Countries["Tajikistan"] = 220] = "Tajikistan";
    Countries[Countries["Tanzania"] = 221] = "Tanzania";
    Countries[Countries["Thailand"] = 222] = "Thailand";
    Countries[Countries["TimorLeste"] = 223] = "TimorLeste";
    Countries[Countries["Togo"] = 224] = "Togo";
    Countries[Countries["Tokelau"] = 225] = "Tokelau";
    Countries[Countries["Tonga"] = 226] = "Tonga";
    Countries[Countries["TrinidadAndTobago"] = 227] = "TrinidadAndTobago";
    Countries[Countries["Tunisia"] = 228] = "Tunisia";
    Countries[Countries["Turkey"] = 229] = "Turkey";
    Countries[Countries["Turkmenistan"] = 230] = "Turkmenistan";
    Countries[Countries["TurksAndCaicosIslands"] = 231] = "TurksAndCaicosIslands";
    Countries[Countries["Tuvalu"] = 232] = "Tuvalu";
    Countries[Countries["Uganda"] = 233] = "Uganda";
    Countries[Countries["Ukraine"] = 234] = "Ukraine";
    Countries[Countries["UnitedArabEmirates"] = 235] = "UnitedArabEmirates";
    Countries[Countries["UnitedKingdom"] = 236] = "UnitedKingdom";
    Countries[Countries["UnitedStates"] = 237] = "UnitedStates";
    Countries[Countries["Uruguay"] = 238] = "Uruguay";
    Countries[Countries["Uzbekistan"] = 239] = "Uzbekistan";
    Countries[Countries["Vanuatu"] = 240] = "Vanuatu";
    Countries[Countries["VaticanCity"] = 241] = "VaticanCity";
    Countries[Countries["Venezuela"] = 242] = "Venezuela";
    Countries[Countries["Vietnam"] = 243] = "Vietnam";
    Countries[Countries["BritishVirginIslands"] = 244] = "BritishVirginIslands";
    Countries[Countries["UnitedStatesVirginIslands"] = 245] = "UnitedStatesVirginIslands";
    Countries[Countries["Wales"] = 246] = "Wales";
    Countries[Countries["WallisAndFutuna"] = 247] = "WallisAndFutuna";
    Countries[Countries["WesternSahara"] = 248] = "WesternSahara";
    Countries[Countries["Yemen"] = 249] = "Yemen";
    Countries[Countries["Zambia"] = 25] = "Zambia";
    Countries[Countries["Zimbabwe"] = 251] = "Zimbabwe";
})($c60317e2dae19a8a$export$b33f41d0b11df887 || ($c60317e2dae19a8a$export$b33f41d0b11df887 = {}));
const $c60317e2dae19a8a$export$8bb1f9594f5ac159 = ()=>{
    return Math.floor(Math.random() * Object.keys($c60317e2dae19a8a$export$9c1d6cc0bf22137).length / 2);
};
const $c60317e2dae19a8a$export$a9a663611ba33e4e = ()=>{
    return Math.floor(Math.random() * Object.keys($c60317e2dae19a8a$export$6ea3032238c5bf02).length / 2);
};
const $c60317e2dae19a8a$export$2c30a21630a6c4b3 = ()=>{
    return Math.floor(Math.random() * Object.keys($c60317e2dae19a8a$export$b33f41d0b11df887).length / 2);
};
const $c60317e2dae19a8a$export$568117bb2ad591cf = ()=>{
    const prefixInt = $c60317e2dae19a8a$export$8bb1f9594f5ac159();
    const suffixInt = $c60317e2dae19a8a$export$a9a663611ba33e4e();
    return $c60317e2dae19a8a$export$7f313eff23e56d57(prefixInt, suffixInt);
};
const $c60317e2dae19a8a$export$7f313eff23e56d57 = (prefixInt, suffixInt)=>{
    const prefix = $c60317e2dae19a8a$export$9c1d6cc0bf22137[prefixInt];
    const suffix = $c60317e2dae19a8a$export$6ea3032238c5bf02[suffixInt];
    return `${prefix} ${suffix}`;
};


class $88639450953f4f02$var$FadeLabel {
    get visible() {
        return this.isVisible;
    }
    set visible(val) {
        if (this.isVisible !== val) {
            this.isVisible = val;
            this.currentOpacity = val ? 0 : 1;
        }
    }
    Update(deltaTimeS) {
        const targetOpacity = this.isVisible ? 1 : 0;
        // Update the opacity based on the target opacity
        if (this.currentOpacity !== targetOpacity) {
            this.currentOpacity = this.getNextOpacity(deltaTimeS);
            this.threeText.fillOpacity = this.currentOpacity;
            this.threeText.strokeOpacity = this.currentOpacity;
            this.threeText.outlineOpacity = this.currentOpacity;
            this.threeText.visible = this.currentOpacity > 0;
        }
    }
    getNextOpacity(deltaTimeS) {
        const opacityChangePerSecond = (this.isVisible ? 1 : -1) / this.fadeDuration;
        const nextOpacity = Math.max(0, Math.min(1, this.currentOpacity + opacityChangePerSecond * deltaTimeS));
        return nextOpacity;
    }
    constructor(text, options){
        this.isVisible = false;
        this.currentOpacity = 0;
        this.threeText = new (0, $55f5ea5649168877$export$5f1af8db9871e1d6)();
        this.threeText.text = text;
        this.threeText.outlineOffsetX = 0.01;
        this.threeText.outlineOffsetY = 0.01;
        this.fadeDuration = options?.fadeDuration ?? 0.15;
        this.currentOpacity = 1;
    }
}
const $88639450953f4f02$var$FLAG_SPRITE_WIDTH = 0.4;
const $88639450953f4f02$var$FLAG_SPRITE_HEIGHT = 0.3;
const $88639450953f4f02$var$FONT_SIZE_FUDGE = 0.55; //used to convert font-size to width
class $88639450953f4f02$export$3a6dd21ac7d6d023 extends $88639450953f4f02$var$FadeLabel {
    Update(deltaTimeS) {
        //grab opacity before it's updated in parent
        const currentOpacity = this.currentOpacity;
        super.Update(deltaTimeS);
        const targetOpacity = this.isVisible ? 1 : 0;
        // Update the opacity based on the target opacity
        if (currentOpacity !== targetOpacity) {
            const newOpacity = this.getNextOpacity(deltaTimeS);
            //@ts-ignore
            this.flagMesh.material.opacity = newOpacity;
            this.flagMesh.visible = newOpacity > 0;
        }
    }
    SetFlag(country) {
        // console.log("Country from server:", country);
        // console.log("Path to flag:", `ui/flags/${getCountryCodeFromCountry(country)}.png`);
        const textureLoader = Game.Loader.TextureLoader;
        this.flagTexture = textureLoader.load(`ui/flags/${$88639450953f4f02$export$3d7cd691481bade(country)}.png`);
        this._updateMaterials();
    }
    _updateMaterials() {
        const textWidth = this.threeText.text.length * this.labelFontSize * $88639450953f4f02$var$FONT_SIZE_FUDGE;
        const textXOffset = -(textWidth / 2);
        const textMaterial = $88639450953f4f02$var$createBillboardMaterial(new (0, $9014d97cd777be10$export$55cbcc9b622fe1f5)(), {
            uniforms: {
                u_positionOffsetX: {
                    value: textXOffset
                },
                u_positionOffsetY: {
                    value: 0
                }
            }
        });
        this.threeText.material = textMaterial;
        const flagMaterial = $88639450953f4f02$var$createBillboardMaterial(new (0, $9014d97cd777be10$export$55cbcc9b622fe1f5)({
            map: this.flagTexture,
            transparent: true,
            alphaTest: 0.5,
            side: (0, $9014d97cd777be10$export$2ede184fc2998901)
        }), {
            uniforms: {
                u_positionOffsetX: {
                    value: textXOffset - $88639450953f4f02$var$FLAG_SPRITE_WIDTH / 2 - 0.05
                },
                u_positionOffsetY: {
                    value: -$88639450953f4f02$var$FLAG_SPRITE_WIDTH / 2 + 0.05
                }
            }
        });
        this.flagMesh.material = flagMaterial;
    }
    SetText(text) {
        this.threeText.text = text;
        // update material to adjust offset
        this._updateMaterials();
    }
    constructor(text, country, options){
        super(text, options);
        this.labelFontSize = 0.4;
        this.labelFont = "fonts/LuckiestGuy-Regular.ttf";
        this.threeText.font = this.labelFont;
        this.threeText.fontSize = this.labelFontSize;
        this.threeText.anchorX = "left";
        const flagGeometry = new (0, $9014d97cd777be10$export$967d831af31f69ce)($88639450953f4f02$var$FLAG_SPRITE_WIDTH, $88639450953f4f02$var$FLAG_SPRITE_HEIGHT);
        this.flagMesh = new (0, $9014d97cd777be10$export$e176487c05830cc5)(flagGeometry);
        this.SetFlag(country);
        this._updateMaterials();
        this.threeText.add(this.flagMesh);
    }
}
function $88639450953f4f02$var$createBillboardMaterial(baseMaterial, opts = {}) {
    return (0, $34196ca962faf131$export$9251ec91c7de57b5)(baseMaterial, {
        uniforms: opts.uniforms,
        vertexDefs: `
            uniform float u_positionOffsetX;
            uniform float u_positionOffsetY;
        `,
        vertexMainOutro: `
            vec4 mvPosition = modelViewMatrix * vec4(0.0, 0.0, 0.0, 1.0);
            vec3 scale = vec3(
                length(modelViewMatrix[0].xyz),
                length(modelViewMatrix[1].xyz),
                length(modelViewMatrix[2].xyz)
            );

            // Apply position offsets
            mvPosition.x += u_positionOffsetX;
            mvPosition.y += u_positionOffsetY;

            mvPosition.xyz += position * scale;
            gl_Position = projectionMatrix * mvPosition;
        `,
        ...opts
    });
}
const $88639450953f4f02$var$DEFAULT_COUNTRY_CODE = "none";
const $88639450953f4f02$export$3d7cd691481bade = (country)=>{
    // go through all countries in Countries enum and return the country code that matches flags filename
    switch(country){
        case (0, $c60317e2dae19a8a$export$b33f41d0b11df887).None:
            return $88639450953f4f02$var$DEFAULT_COUNTRY_CODE;
        case (0, $c60317e2dae19a8a$export$b33f41d0b11df887).AlandIslands:
            return "ax";
        case (0, $c60317e2dae19a8a$export$b33f41d0b11df887).Albania:
            return "al";
        case (0, $c60317e2dae19a8a$export$b33f41d0b11df887).Algeria:
            return "dz";
        case (0, $c60317e2dae19a8a$export$b33f41d0b11df887).AmericanSamoa:
            return "as";
        case (0, $c60317e2dae19a8a$export$b33f41d0b11df887).Andorra:
            return "ad";
        case (0, $c60317e2dae19a8a$export$b33f41d0b11df887).Angola:
            return "ao";
        case (0, $c60317e2dae19a8a$export$b33f41d0b11df887).Anguilla:
            return "ai";
        case (0, $c60317e2dae19a8a$export$b33f41d0b11df887).Antarctica:
            return "aq";
        case (0, $c60317e2dae19a8a$export$b33f41d0b11df887).AntiguaAndBarbuda:
            return "ag";
        case (0, $c60317e2dae19a8a$export$b33f41d0b11df887).Argentina:
            return "ar";
        case (0, $c60317e2dae19a8a$export$b33f41d0b11df887).Armenia:
            return "am";
        case (0, $c60317e2dae19a8a$export$b33f41d0b11df887).Aruba:
            return "aw";
        case (0, $c60317e2dae19a8a$export$b33f41d0b11df887).Australia:
            return "au";
        case (0, $c60317e2dae19a8a$export$b33f41d0b11df887).Austria:
            return "at";
        case (0, $c60317e2dae19a8a$export$b33f41d0b11df887).Azerbaijan:
            return "az";
        case (0, $c60317e2dae19a8a$export$b33f41d0b11df887).Bahamas:
            return "bs";
        case (0, $c60317e2dae19a8a$export$b33f41d0b11df887).Bahrain:
            return "bh";
        case (0, $c60317e2dae19a8a$export$b33f41d0b11df887).Bangladesh:
            return "bd";
        case (0, $c60317e2dae19a8a$export$b33f41d0b11df887).Barbados:
            return "bb";
        case (0, $c60317e2dae19a8a$export$b33f41d0b11df887).Belarus:
            return "by";
        case (0, $c60317e2dae19a8a$export$b33f41d0b11df887).Belgium:
            return "be";
        case (0, $c60317e2dae19a8a$export$b33f41d0b11df887).Belize:
            return "bz";
        case (0, $c60317e2dae19a8a$export$b33f41d0b11df887).Benin:
            return "bj";
        case (0, $c60317e2dae19a8a$export$b33f41d0b11df887).Bermuda:
            return "bm";
        case (0, $c60317e2dae19a8a$export$b33f41d0b11df887).Bhutan:
            return "bt";
        case (0, $c60317e2dae19a8a$export$b33f41d0b11df887).Bolivia:
            return "bo";
        case (0, $c60317e2dae19a8a$export$b33f41d0b11df887).BosniaAndHerzegovina:
            return "ba";
        case (0, $c60317e2dae19a8a$export$b33f41d0b11df887).Botswana:
            return "bw";
        case (0, $c60317e2dae19a8a$export$b33f41d0b11df887).BouvetIsland:
            return "bv";
        case (0, $c60317e2dae19a8a$export$b33f41d0b11df887).Brazil:
            return "br";
        case (0, $c60317e2dae19a8a$export$b33f41d0b11df887).BritishIndianOceanTerritory:
            return "io";
        case (0, $c60317e2dae19a8a$export$b33f41d0b11df887).Brunei:
            return "bn";
        case (0, $c60317e2dae19a8a$export$b33f41d0b11df887).Bulgaria:
            return "bg";
        case (0, $c60317e2dae19a8a$export$b33f41d0b11df887).BurkinaFaso:
            return "bf";
        case (0, $c60317e2dae19a8a$export$b33f41d0b11df887).Burundi:
            return "bi";
        case (0, $c60317e2dae19a8a$export$b33f41d0b11df887).Cambodia:
            return "kh";
        case (0, $c60317e2dae19a8a$export$b33f41d0b11df887).Cameroon:
            return "cm";
        case (0, $c60317e2dae19a8a$export$b33f41d0b11df887).Canada:
            return "ca";
        case (0, $c60317e2dae19a8a$export$b33f41d0b11df887).CapeVerde:
            return "cv";
        case (0, $c60317e2dae19a8a$export$b33f41d0b11df887).CaymanIslands:
            return "ky";
        case (0, $c60317e2dae19a8a$export$b33f41d0b11df887).CentralAfricanRepublic:
            return "cf";
        case (0, $c60317e2dae19a8a$export$b33f41d0b11df887).Chad:
            return "td";
        case (0, $c60317e2dae19a8a$export$b33f41d0b11df887).Chile:
            return "cl";
        case (0, $c60317e2dae19a8a$export$b33f41d0b11df887).China:
            return "cn";
        case (0, $c60317e2dae19a8a$export$b33f41d0b11df887).ChristmasIsland:
            return "cx";
        case (0, $c60317e2dae19a8a$export$b33f41d0b11df887).CocosKeelingIslands:
            return "cc";
        case (0, $c60317e2dae19a8a$export$b33f41d0b11df887).Colombia:
            return "co";
        case (0, $c60317e2dae19a8a$export$b33f41d0b11df887).Comoros:
            return "km";
        case (0, $c60317e2dae19a8a$export$b33f41d0b11df887).DRCongo:
            return "cd";
        case (0, $c60317e2dae19a8a$export$b33f41d0b11df887).RepublicOfTheCongo:
            return "cg";
        case (0, $c60317e2dae19a8a$export$b33f41d0b11df887).CookIslands:
            return "ck";
        case (0, $c60317e2dae19a8a$export$b33f41d0b11df887).CostaRica:
            return "cr";
        case (0, $c60317e2dae19a8a$export$b33f41d0b11df887).IvoryCoast:
            return "ci";
        case (0, $c60317e2dae19a8a$export$b33f41d0b11df887).Croatia:
            return "hr";
        case (0, $c60317e2dae19a8a$export$b33f41d0b11df887).Cuba:
            return "cu";
        case (0, $c60317e2dae19a8a$export$b33f41d0b11df887).Curacao:
            return "cw";
        case (0, $c60317e2dae19a8a$export$b33f41d0b11df887).Cyprus:
            return "cy";
        case (0, $c60317e2dae19a8a$export$b33f41d0b11df887).Czechia:
            return "cz";
        case (0, $c60317e2dae19a8a$export$b33f41d0b11df887).Denmark:
            return "dk";
        case (0, $c60317e2dae19a8a$export$b33f41d0b11df887).Djibouti:
            return "dj";
        case (0, $c60317e2dae19a8a$export$b33f41d0b11df887).Dominica:
            return "dm";
        case (0, $c60317e2dae19a8a$export$b33f41d0b11df887).DominicanRepublic:
            return "do";
        case (0, $c60317e2dae19a8a$export$b33f41d0b11df887).Ecuador:
            return "ec";
        case (0, $c60317e2dae19a8a$export$b33f41d0b11df887).Egypt:
            return "eg";
        case (0, $c60317e2dae19a8a$export$b33f41d0b11df887).ElSalvador:
            return "sv";
        case (0, $c60317e2dae19a8a$export$b33f41d0b11df887).England:
            return "gb-eng";
        case (0, $c60317e2dae19a8a$export$b33f41d0b11df887).EquatorialGuinea:
            return "gq";
        case (0, $c60317e2dae19a8a$export$b33f41d0b11df887).Eritrea:
            return "er";
        case (0, $c60317e2dae19a8a$export$b33f41d0b11df887).Estonia:
            return "ee";
        case (0, $c60317e2dae19a8a$export$b33f41d0b11df887).EswatiniSwaziland:
            return "sz";
        case (0, $c60317e2dae19a8a$export$b33f41d0b11df887).Ethiopia:
            return "et";
        case (0, $c60317e2dae19a8a$export$b33f41d0b11df887).FalklandIslands:
            return "fk";
        case (0, $c60317e2dae19a8a$export$b33f41d0b11df887).FaroeIslands:
            return "fo";
        case (0, $c60317e2dae19a8a$export$b33f41d0b11df887).Fiji:
            return "fj";
        case (0, $c60317e2dae19a8a$export$b33f41d0b11df887).Finland:
            return "fi";
        case (0, $c60317e2dae19a8a$export$b33f41d0b11df887).France:
            return "fr";
        case (0, $c60317e2dae19a8a$export$b33f41d0b11df887).FrenchGuiana:
            return "gf";
        case (0, $c60317e2dae19a8a$export$b33f41d0b11df887).FrenchPolynesia:
            return "pf";
        case (0, $c60317e2dae19a8a$export$b33f41d0b11df887).FrenchSouthernAndAntarcticLands:
            return "tf";
        case (0, $c60317e2dae19a8a$export$b33f41d0b11df887).Gabon:
            return "ga";
        case (0, $c60317e2dae19a8a$export$b33f41d0b11df887).Gambia:
            return "gm";
        case (0, $c60317e2dae19a8a$export$b33f41d0b11df887).Georgia:
            return "ge";
        case (0, $c60317e2dae19a8a$export$b33f41d0b11df887).Germany:
            return "de";
        case (0, $c60317e2dae19a8a$export$b33f41d0b11df887).Ghana:
            return "gh";
        case (0, $c60317e2dae19a8a$export$b33f41d0b11df887).Gibraltar:
            return "gi";
        case (0, $c60317e2dae19a8a$export$b33f41d0b11df887).Greece:
            return "gr";
        case (0, $c60317e2dae19a8a$export$b33f41d0b11df887).Greenland:
            return "gl";
        case (0, $c60317e2dae19a8a$export$b33f41d0b11df887).Grenada:
            return "gd";
        case (0, $c60317e2dae19a8a$export$b33f41d0b11df887).Guadeloupe:
            return "gp";
        case (0, $c60317e2dae19a8a$export$b33f41d0b11df887).Guam:
            return "gu";
        case (0, $c60317e2dae19a8a$export$b33f41d0b11df887).Guatemala:
            return "gt";
        case (0, $c60317e2dae19a8a$export$b33f41d0b11df887).Guernsey:
            return "gg";
        case (0, $c60317e2dae19a8a$export$b33f41d0b11df887).Guinea:
            return "gn";
        case (0, $c60317e2dae19a8a$export$b33f41d0b11df887).GuineaBissau:
            return "gw";
        case (0, $c60317e2dae19a8a$export$b33f41d0b11df887).Guyana:
            return "gy";
        case (0, $c60317e2dae19a8a$export$b33f41d0b11df887).Haiti:
            return "ht";
        case (0, $c60317e2dae19a8a$export$b33f41d0b11df887).HeardIslandAndMcdonaldIslands:
            return "hm";
        case (0, $c60317e2dae19a8a$export$b33f41d0b11df887).Honduras:
            return "hn";
        case (0, $c60317e2dae19a8a$export$b33f41d0b11df887).HongKong:
            return "hk";
        case (0, $c60317e2dae19a8a$export$b33f41d0b11df887).Hungary:
            return "hu";
        case (0, $c60317e2dae19a8a$export$b33f41d0b11df887).Iceland:
            return "is";
        case (0, $c60317e2dae19a8a$export$b33f41d0b11df887).India:
            return "in";
        case (0, $c60317e2dae19a8a$export$b33f41d0b11df887).Indonesia:
            return "id";
        case (0, $c60317e2dae19a8a$export$b33f41d0b11df887).Iran:
            return "ir";
        case (0, $c60317e2dae19a8a$export$b33f41d0b11df887).Iraq:
            return "iq";
        case (0, $c60317e2dae19a8a$export$b33f41d0b11df887).Ireland:
            return "ie";
        case (0, $c60317e2dae19a8a$export$b33f41d0b11df887).IsleOfMan:
            return "im";
        case (0, $c60317e2dae19a8a$export$b33f41d0b11df887).Israel:
            return "il";
        case (0, $c60317e2dae19a8a$export$b33f41d0b11df887).Italy:
            return "it";
        case (0, $c60317e2dae19a8a$export$b33f41d0b11df887).Jamaica:
            return "jm";
        case (0, $c60317e2dae19a8a$export$b33f41d0b11df887).Japan:
            return "jp";
        case (0, $c60317e2dae19a8a$export$b33f41d0b11df887).Jersey:
            return "je";
        case (0, $c60317e2dae19a8a$export$b33f41d0b11df887).Jordan:
            return "jo";
        case (0, $c60317e2dae19a8a$export$b33f41d0b11df887).Kazakhstan:
            return "kz";
        case (0, $c60317e2dae19a8a$export$b33f41d0b11df887).Kenya:
            return "ke";
        case (0, $c60317e2dae19a8a$export$b33f41d0b11df887).Kiribati:
            return "ki";
        case (0, $c60317e2dae19a8a$export$b33f41d0b11df887).NorthKorea:
            return "kp";
        case (0, $c60317e2dae19a8a$export$b33f41d0b11df887).SouthKorea:
            return "kr";
        case (0, $c60317e2dae19a8a$export$b33f41d0b11df887).Kosovo:
            return "xk";
        case (0, $c60317e2dae19a8a$export$b33f41d0b11df887).Kuwait:
            return "kw";
        case (0, $c60317e2dae19a8a$export$b33f41d0b11df887).Kyrgyzstan:
            return "kg";
        case (0, $c60317e2dae19a8a$export$b33f41d0b11df887).Laos:
            return "la";
        case (0, $c60317e2dae19a8a$export$b33f41d0b11df887).Latvia:
            return "lv";
        case (0, $c60317e2dae19a8a$export$b33f41d0b11df887).Lebanon:
            return "lb";
        case (0, $c60317e2dae19a8a$export$b33f41d0b11df887).Lesotho:
            return "ls";
        case (0, $c60317e2dae19a8a$export$b33f41d0b11df887).Liberia:
            return "lr";
        case (0, $c60317e2dae19a8a$export$b33f41d0b11df887).Libya:
            return "ly";
        case (0, $c60317e2dae19a8a$export$b33f41d0b11df887).Liechtenstein:
            return "li";
        case (0, $c60317e2dae19a8a$export$b33f41d0b11df887).Lithuania:
            return "lt";
        case (0, $c60317e2dae19a8a$export$b33f41d0b11df887).Luxembourg:
            return "lu";
        case (0, $c60317e2dae19a8a$export$b33f41d0b11df887).Macau:
            return "mo";
        case (0, $c60317e2dae19a8a$export$b33f41d0b11df887).Madagascar:
            return "mg";
        case (0, $c60317e2dae19a8a$export$b33f41d0b11df887).Malawi:
            return "mw";
        case (0, $c60317e2dae19a8a$export$b33f41d0b11df887).Malaysia:
            return "my";
        case (0, $c60317e2dae19a8a$export$b33f41d0b11df887).Maldives:
            return "mv";
        case (0, $c60317e2dae19a8a$export$b33f41d0b11df887).Mali:
            return "ml";
        case (0, $c60317e2dae19a8a$export$b33f41d0b11df887).Malta:
            return "mt";
        case (0, $c60317e2dae19a8a$export$b33f41d0b11df887).MarshallIslands:
            return "mh";
        case (0, $c60317e2dae19a8a$export$b33f41d0b11df887).Martinique:
            return "mq";
        case (0, $c60317e2dae19a8a$export$b33f41d0b11df887).Mauritania:
            return "mr";
        case (0, $c60317e2dae19a8a$export$b33f41d0b11df887).Mauritius:
            return "mu";
        case (0, $c60317e2dae19a8a$export$b33f41d0b11df887).Mayotte:
            return "yt";
        case (0, $c60317e2dae19a8a$export$b33f41d0b11df887).Mexico:
            return "mx";
        case (0, $c60317e2dae19a8a$export$b33f41d0b11df887).Micronesia:
            return "fm";
        case (0, $c60317e2dae19a8a$export$b33f41d0b11df887).Moldova:
            return "md";
        case (0, $c60317e2dae19a8a$export$b33f41d0b11df887).Monaco:
            return "mc";
        case (0, $c60317e2dae19a8a$export$b33f41d0b11df887).Mongolia:
            return "mn";
        case (0, $c60317e2dae19a8a$export$b33f41d0b11df887).Montenegro:
            return "me";
        case (0, $c60317e2dae19a8a$export$b33f41d0b11df887).Montserrat:
            return "ms";
        case (0, $c60317e2dae19a8a$export$b33f41d0b11df887).Morocco:
            return "ma";
        case (0, $c60317e2dae19a8a$export$b33f41d0b11df887).Mozambique:
            return "mz";
        case (0, $c60317e2dae19a8a$export$b33f41d0b11df887).Myanmar:
            return "mm";
        case (0, $c60317e2dae19a8a$export$b33f41d0b11df887).Namibia:
            return "na";
        case (0, $c60317e2dae19a8a$export$b33f41d0b11df887).Nauru:
            return "nr";
        case (0, $c60317e2dae19a8a$export$b33f41d0b11df887).Nepal:
            return "np";
        case (0, $c60317e2dae19a8a$export$b33f41d0b11df887).Netherlands:
            return "nl";
        case (0, $c60317e2dae19a8a$export$b33f41d0b11df887).NewCaledonia:
            return "nc";
        case (0, $c60317e2dae19a8a$export$b33f41d0b11df887).NewZealand:
            return "nz";
        case (0, $c60317e2dae19a8a$export$b33f41d0b11df887).Nicaragua:
            return "ni";
        case (0, $c60317e2dae19a8a$export$b33f41d0b11df887).Niger:
            return "ne";
        case (0, $c60317e2dae19a8a$export$b33f41d0b11df887).Nigeria:
            return "ng";
        case (0, $c60317e2dae19a8a$export$b33f41d0b11df887).Niue:
            return "nu";
        case (0, $c60317e2dae19a8a$export$b33f41d0b11df887).NorfolkIsland:
            return "nf";
        case (0, $c60317e2dae19a8a$export$b33f41d0b11df887).NorthMacedonia:
            return "mk";
        case (0, $c60317e2dae19a8a$export$b33f41d0b11df887).NorthernMarianaIslands:
            return "mp";
        case (0, $c60317e2dae19a8a$export$b33f41d0b11df887).Norway:
            return "no";
        case (0, $c60317e2dae19a8a$export$b33f41d0b11df887).Oman:
            return "om";
        case (0, $c60317e2dae19a8a$export$b33f41d0b11df887).Pakistan:
            return "pk";
        case (0, $c60317e2dae19a8a$export$b33f41d0b11df887).Palau:
            return "pw";
        case (0, $c60317e2dae19a8a$export$b33f41d0b11df887).Palestine:
            return "ps";
        case (0, $c60317e2dae19a8a$export$b33f41d0b11df887).Panama:
            return "pa";
        case (0, $c60317e2dae19a8a$export$b33f41d0b11df887).PapuaNewGuinea:
            return "pg";
        case (0, $c60317e2dae19a8a$export$b33f41d0b11df887).Paraguay:
            return "py";
        case (0, $c60317e2dae19a8a$export$b33f41d0b11df887).Peru:
            return "pe";
        case (0, $c60317e2dae19a8a$export$b33f41d0b11df887).Philippines:
            return "ph";
        case (0, $c60317e2dae19a8a$export$b33f41d0b11df887).PitcairnIslands:
            return "pn";
        case (0, $c60317e2dae19a8a$export$b33f41d0b11df887).Poland:
            return "pl";
        case (0, $c60317e2dae19a8a$export$b33f41d0b11df887).Portugal:
            return "pt";
        case (0, $c60317e2dae19a8a$export$b33f41d0b11df887).PuertoRico:
            return "pr";
        case (0, $c60317e2dae19a8a$export$b33f41d0b11df887).Qatar:
            return "qa";
        case (0, $c60317e2dae19a8a$export$b33f41d0b11df887).Reunion:
            return "re";
        case (0, $c60317e2dae19a8a$export$b33f41d0b11df887).Romania:
            return "ro";
        case (0, $c60317e2dae19a8a$export$b33f41d0b11df887).Russia:
            return "ru";
        case (0, $c60317e2dae19a8a$export$b33f41d0b11df887).Rwanda:
            return "rw";
        case (0, $c60317e2dae19a8a$export$b33f41d0b11df887).SaintBarthelemy:
            return "bl";
        case (0, $c60317e2dae19a8a$export$b33f41d0b11df887).SaintHelenaAscensionAndTristandaCunha:
            return "sh";
        case (0, $c60317e2dae19a8a$export$b33f41d0b11df887).SaintKittsAndNevis:
            return "kn";
        case (0, $c60317e2dae19a8a$export$b33f41d0b11df887).SaintLucia:
            return "lc";
        case (0, $c60317e2dae19a8a$export$b33f41d0b11df887).SaintMartin:
            return "mf";
        case (0, $c60317e2dae19a8a$export$b33f41d0b11df887).SaintPierreAndMiquelon:
            return "pm";
        case (0, $c60317e2dae19a8a$export$b33f41d0b11df887).SaintVincentAndTheGrenadines:
            return "vc";
        case (0, $c60317e2dae19a8a$export$b33f41d0b11df887).Samoa:
            return "ws";
        case (0, $c60317e2dae19a8a$export$b33f41d0b11df887).SanMarino:
            return "sm";
        case (0, $c60317e2dae19a8a$export$b33f41d0b11df887).SaoTomeAndPrincipe:
            return "st";
        case (0, $c60317e2dae19a8a$export$b33f41d0b11df887).SaudiArabia:
            return "sa";
        case (0, $c60317e2dae19a8a$export$b33f41d0b11df887).Scotland:
            return "gb-sct";
        case (0, $c60317e2dae19a8a$export$b33f41d0b11df887).Senegal:
            return "sn";
        case (0, $c60317e2dae19a8a$export$b33f41d0b11df887).Serbia:
            return "rs";
        case (0, $c60317e2dae19a8a$export$b33f41d0b11df887).Seychelles:
            return "sc";
        case (0, $c60317e2dae19a8a$export$b33f41d0b11df887).SierraLeone:
            return "sl";
        case (0, $c60317e2dae19a8a$export$b33f41d0b11df887).Singapore:
            return "sg";
        case (0, $c60317e2dae19a8a$export$b33f41d0b11df887).SintMaarten:
            return "sx";
        case (0, $c60317e2dae19a8a$export$b33f41d0b11df887).Slovakia:
            return "sk";
        case (0, $c60317e2dae19a8a$export$b33f41d0b11df887).Slovenia:
            return "si";
        case (0, $c60317e2dae19a8a$export$b33f41d0b11df887).SolomonIslands:
            return "sb";
        case (0, $c60317e2dae19a8a$export$b33f41d0b11df887).Somalia:
            return "so";
        case (0, $c60317e2dae19a8a$export$b33f41d0b11df887).SouthAfrica:
            return "za";
        case (0, $c60317e2dae19a8a$export$b33f41d0b11df887).SouthGeorgia:
            return "gs";
        case (0, $c60317e2dae19a8a$export$b33f41d0b11df887).SouthSudan:
            return "ss";
        case (0, $c60317e2dae19a8a$export$b33f41d0b11df887).Spain:
            return "es";
        case (0, $c60317e2dae19a8a$export$b33f41d0b11df887).SriLanka:
            return "lk";
        case (0, $c60317e2dae19a8a$export$b33f41d0b11df887).Sudan:
            return "sd";
        case (0, $c60317e2dae19a8a$export$b33f41d0b11df887).Suriname:
            return "sr";
        case (0, $c60317e2dae19a8a$export$b33f41d0b11df887).SvalbardAndJanMayen:
            return "sj";
        case (0, $c60317e2dae19a8a$export$b33f41d0b11df887).Sweden:
            return "se";
        case (0, $c60317e2dae19a8a$export$b33f41d0b11df887).Switzerland:
            return "ch";
        case (0, $c60317e2dae19a8a$export$b33f41d0b11df887).Syria:
            return "sy";
        case (0, $c60317e2dae19a8a$export$b33f41d0b11df887).Taiwan:
            return "tw";
        case (0, $c60317e2dae19a8a$export$b33f41d0b11df887).Tajikistan:
            return "tj";
        case (0, $c60317e2dae19a8a$export$b33f41d0b11df887).Tanzania:
            return "tz";
        case (0, $c60317e2dae19a8a$export$b33f41d0b11df887).Thailand:
            return "th";
        case (0, $c60317e2dae19a8a$export$b33f41d0b11df887).TimorLeste:
            return "tl";
        case (0, $c60317e2dae19a8a$export$b33f41d0b11df887).Togo:
            return "tg";
        case (0, $c60317e2dae19a8a$export$b33f41d0b11df887).Tokelau:
            return "tk";
        case (0, $c60317e2dae19a8a$export$b33f41d0b11df887).Tonga:
            return "to";
        case (0, $c60317e2dae19a8a$export$b33f41d0b11df887).TrinidadAndTobago:
            return "tt";
        case (0, $c60317e2dae19a8a$export$b33f41d0b11df887).Tunisia:
            return "tn";
        case (0, $c60317e2dae19a8a$export$b33f41d0b11df887).Turkey:
            return "tr";
        case (0, $c60317e2dae19a8a$export$b33f41d0b11df887).Turkmenistan:
            return "tm";
        case (0, $c60317e2dae19a8a$export$b33f41d0b11df887).TurksAndCaicosIslands:
            return "tc";
        case (0, $c60317e2dae19a8a$export$b33f41d0b11df887).Tuvalu:
            return "tv";
        case (0, $c60317e2dae19a8a$export$b33f41d0b11df887).Uganda:
            return "ug";
        case (0, $c60317e2dae19a8a$export$b33f41d0b11df887).Ukraine:
            return "ua";
        case (0, $c60317e2dae19a8a$export$b33f41d0b11df887).UnitedArabEmirates:
            return "ae";
        case (0, $c60317e2dae19a8a$export$b33f41d0b11df887).UnitedKingdom:
            return "gb";
        case (0, $c60317e2dae19a8a$export$b33f41d0b11df887).UnitedStates:
            return "us";
        case (0, $c60317e2dae19a8a$export$b33f41d0b11df887).Uruguay:
            return "uy";
        case (0, $c60317e2dae19a8a$export$b33f41d0b11df887).Uzbekistan:
            return "uz";
        case (0, $c60317e2dae19a8a$export$b33f41d0b11df887).Vanuatu:
            return "vu";
        case (0, $c60317e2dae19a8a$export$b33f41d0b11df887).VaticanCity:
            return "va";
        case (0, $c60317e2dae19a8a$export$b33f41d0b11df887).Venezuela:
            return "ve";
        case (0, $c60317e2dae19a8a$export$b33f41d0b11df887).Vietnam:
            return "vn";
        case (0, $c60317e2dae19a8a$export$b33f41d0b11df887).BritishVirginIslands:
            return "vg";
        case (0, $c60317e2dae19a8a$export$b33f41d0b11df887).UnitedStatesVirginIslands:
            return "vi";
        case (0, $c60317e2dae19a8a$export$b33f41d0b11df887).Wales:
            return "gb-wls";
        case (0, $c60317e2dae19a8a$export$b33f41d0b11df887).WallisAndFutuna:
            return "wf";
        case (0, $c60317e2dae19a8a$export$b33f41d0b11df887).WesternSahara:
            return "eh";
        case (0, $c60317e2dae19a8a$export$b33f41d0b11df887).Yemen:
            return "ye";
        case (0, $c60317e2dae19a8a$export$b33f41d0b11df887).Zambia:
            return "zm";
        case (0, $c60317e2dae19a8a$export$b33f41d0b11df887).Zimbabwe:
            return "zw";
        default:
            return $88639450953f4f02$var$DEFAULT_COUNTRY_CODE;
    }
};


const $2732299af51e9693$export$29c7f024da80d1e5 = "Behaviour";
const $2732299af51e9693$export$467f3abd3509ebe9 = "Alpha";
const $2732299af51e9693$export$b34a75d4835b0bc5 = "Attraction";
const $2732299af51e9693$export$b84df0684c0849c6 = "Collision";
const $2732299af51e9693$export$46c080640007f6c8 = "Color";
const $2732299af51e9693$export$e4ae7b92639bc550 = "CrossZone";
const $2732299af51e9693$export$8edd8097d5982cc6 = "Force";
const $2732299af51e9693$export$8742ff6a9e4f9956 = "Gravity";
const $2732299af51e9693$export$a2ab21ade2918dde = "RandomDrift";
const $2732299af51e9693$export$1be9b23e96dfffa1 = "Repulsion";
const $2732299af51e9693$export$377dc8da583fe9e0 = "Rotate";
const $2732299af51e9693$export$cedf5532ac01e38d = "Scale";
const $2732299af51e9693$export$143e5d25a7f4575f = "Spring";


const $83f850ed9ddda6a7$export$ba9cf0918610bb83 = "Initializer";
const $83f850ed9ddda6a7$export$3ef979d6b2e48ce = "Body";
const $83f850ed9ddda6a7$export$bfe2fafbb3f6ec80 = "BodySprite";
const $83f850ed9ddda6a7$export$b615b6b5bb0ad3de = "Texture";
const $83f850ed9ddda6a7$export$45db14bd37173b96 = "Life";
const $83f850ed9ddda6a7$export$980595dbb0c6e42 = "Mass";
const $83f850ed9ddda6a7$export$4cbd4a5e129eef58 = "Position";
const $83f850ed9ddda6a7$export$ed0ee694b4907565 = "Radius";
const $83f850ed9ddda6a7$export$de80508412c19c52 = "Zone";
const $83f850ed9ddda6a7$export$1e0160107f8e88ab = "VectorVelocity";
const $83f850ed9ddda6a7$export$30a3f65ebc8fd963 = "PolarVelocity";
const $83f850ed9ddda6a7$export$c1477f2eb8bd1522 = "RadialVelocity";
const $83f850ed9ddda6a7$export$6764559e5e9f18a5 = "Rate";
const $83f850ed9ddda6a7$export$828b672ab9e7cf75 = [
    $83f850ed9ddda6a7$export$bfe2fafbb3f6ec80,
    $83f850ed9ddda6a7$export$b615b6b5bb0ad3de
];


const $6750d9f4d05ced14$export$9f3c28aae06fd98 = "Zone";
const $6750d9f4d05ced14$export$7cd2cdc555c88d56 = "BoxZone";
const $6750d9f4d05ced14$export$baed6ad0a34de92 = "LineZone";
const $6750d9f4d05ced14$export$9ca71e45661a213e = "MeshZone";
const $6750d9f4d05ced14$export$224740a183ed091f = "PointZone";
const $6750d9f4d05ced14$export$1aeb7174e41aa37a = "ScreenZone";
const $6750d9f4d05ced14$export$45cdd312cd8280a8 = "SphereZone";


const $01c6d32cf1e9ec4f$export$e90783d3d6cc6b79 = "BaseRenderer";
const $01c6d32cf1e9ec4f$export$594421b9ecc9477d = "CustomRenderer";
const $01c6d32cf1e9ec4f$export$13a70080352d20ed = "SpriteRenderer";
const $01c6d32cf1e9ec4f$export$13f3ab3a8ec8b6b = "MeshRenderer";
const $01c6d32cf1e9ec4f$export$f388914f73362c9a = "GPURenderer";
const $01c6d32cf1e9ec4f$export$e401f959685949e0 = "MobileGPURenderer";
const $01c6d32cf1e9ec4f$export$2584e79471e6d789 = "DesktopGPURenderer";



const $c1da9e54204bbff9$export$6b5c1ceb16d01dc3 = 3.142;
const $c1da9e54204bbff9$export$c26fa02a1904398c = 500;
const $c1da9e54204bbff9$export$e23256618f929593 = 60;
const $c1da9e54204bbff9$export$590ba8a5a3bd5910 = $c1da9e54204bbff9$export$6b5c1ceb16d01dc3 / 180;
const $c1da9e54204bbff9$export$20471946a1148a1b = 100;
const $c1da9e54204bbff9$export$ecd4a5923c08f2ed = "euler";
const $c1da9e54204bbff9$export$4816d1bf6b1164d = "runge-kutta2";
const $c1da9e54204bbff9$export$579c1fe14d3a939b = "runge-kutta4";
const $c1da9e54204bbff9$export$ffe160a0865d19e5 = "verlet";
const $c1da9e54204bbff9$export$dcdad346d117108f = false;
const $c1da9e54204bbff9$export$a866f231438cc228 = ()=>{
    if (!$a24315420cf48455$exports) return false;
    if (!$a24315420cf48455$exports.env) return false;
    return false;
};


const $4bdda5ce454f9cb4$export$b0f87bb1f6530fd8 = {
    easeLinear: function(value) {
        return value;
    },
    easeInQuad: function(value) {
        return Math.pow(value, 2);
    },
    easeOutQuad: function(value) {
        return -(Math.pow(value - 1, 2) - 1);
    },
    easeInOutQuad: function(value) {
        if ((value /= 0.5) < 1) return 0.5 * Math.pow(value, 2);
        return -0.5 * ((value -= 2) * value - 2);
    },
    easeInCubic: function(value) {
        return Math.pow(value, 3);
    },
    easeOutCubic: function(value) {
        return Math.pow(value - 1, 3) + 1;
    },
    easeInOutCubic: function(value) {
        if ((value /= 0.5) < 1) return 0.5 * Math.pow(value, 3);
        return 0.5 * (Math.pow(value - 2, 3) + 2);
    },
    easeInQuart: function(value) {
        return Math.pow(value, 4);
    },
    easeOutQuart: function(value) {
        return -(Math.pow(value - 1, 4) - 1);
    },
    easeInOutQuart: function(value) {
        if ((value /= 0.5) < 1) return 0.5 * Math.pow(value, 4);
        return -0.5 * ((value -= 2) * Math.pow(value, 3) - 2);
    },
    easeInSine: function(value) {
        return -Math.cos(value * ((0, $c1da9e54204bbff9$export$6b5c1ceb16d01dc3) / 2)) + 1;
    },
    easeOutSine: function(value) {
        return Math.sin(value * ((0, $c1da9e54204bbff9$export$6b5c1ceb16d01dc3) / 2));
    },
    easeInOutSine: function(value) {
        return -0.5 * (Math.cos((0, $c1da9e54204bbff9$export$6b5c1ceb16d01dc3) * value) - 1);
    },
    easeInExpo: function(value) {
        return value === 0 ? 0 : Math.pow(2, 10 * (value - 1));
    },
    easeOutExpo: function(value) {
        return value === 1 ? 1 : -Math.pow(2, -10 * value) + 1;
    },
    easeInOutExpo: function(value) {
        if (value === 0) return 0;
        if (value === 1) return 1;
        if ((value /= 0.5) < 1) return 0.5 * Math.pow(2, 10 * (value - 1));
        return 0.5 * (-Math.pow(2, -10 * --value) + 2);
    },
    easeInCirc: function(value) {
        return -(Math.sqrt(1 - value * value) - 1);
    },
    easeOutCirc: function(value) {
        return Math.sqrt(1 - Math.pow(value - 1, 2));
    },
    easeInOutCirc: function(value) {
        if ((value /= 0.5) < 1) return -0.5 * (Math.sqrt(1 - value * value) - 1);
        return 0.5 * (Math.sqrt(1 - (value -= 2) * value) + 1);
    },
    easeInBack: function(value) {
        var s = 1.70158;
        return value * value * ((s + 1) * value - s);
    },
    easeOutBack: function(value) {
        var s = 1.70158;
        return (value = value - 1) * value * ((s + 1) * value + s) + 1;
    },
    easeInOutBack: function(value) {
        var s = 1.70158;
        if ((value /= 0.5) < 1) return 0.5 * (value * value * (((s *= 1.525) + 1) * value - s));
        return 0.5 * ((value -= 2) * value * (((s *= 1.525) + 1) * value + s) + 2);
    }
};
const { easeLinear: $4bdda5ce454f9cb4$export$5d6e1e4631108fd5, easeInQuad: $4bdda5ce454f9cb4$export$2d59ca22077f6eab, easeOutQuad: $4bdda5ce454f9cb4$export$be35423d31ba201e, easeInOutQuad: $4bdda5ce454f9cb4$export$42add3d9cb3645a2, easeInCubic: $4bdda5ce454f9cb4$export$5da70c9577229d30, easeOutCubic: $4bdda5ce454f9cb4$export$1157fb72e7fbceb5, easeInOutCubic: $4bdda5ce454f9cb4$export$24656b269d8df7d6, easeInQuart: $4bdda5ce454f9cb4$export$c3d8280971f5e7ab, easeOutQuart: $4bdda5ce454f9cb4$export$fb9e4320a4025f10, easeInOutQuart: $4bdda5ce454f9cb4$export$bd93209e120f4915, easeInSine: $4bdda5ce454f9cb4$export$887f6c7954385bcf, easeOutSine: $4bdda5ce454f9cb4$export$894fdbb88fdb9ced, easeInOutSine: $4bdda5ce454f9cb4$export$dbce5739ea4fa8d3, easeInExpo: $4bdda5ce454f9cb4$export$fe4a60940f66e545, easeOutExpo: $4bdda5ce454f9cb4$export$b410709e4ad080bf, easeInOutExpo: $4bdda5ce454f9cb4$export$ea354f4caf3d04bf, easeInCirc: $4bdda5ce454f9cb4$export$f6288029261ec108, easeOutCirc: $4bdda5ce454f9cb4$export$f25eb0110f83e43b, easeInOutCirc: $4bdda5ce454f9cb4$export$5f50baf27f660509, easeInBack: $4bdda5ce454f9cb4$export$9d60100a8a802bac, easeOutBack: $4bdda5ce454f9cb4$export$3daa4a78f444687d, easeInOutBack: $4bdda5ce454f9cb4$export$7895717e81685a1a } = $4bdda5ce454f9cb4$export$b0f87bb1f6530fd8;
const $4bdda5ce454f9cb4$export$1fdaf42a5282f550 = (easeName)=>{
    if ($4bdda5ce454f9cb4$export$b0f87bb1f6530fd8[easeName]) return $4bdda5ce454f9cb4$export$b0f87bb1f6530fd8[easeName];
    else return $4bdda5ce454f9cb4$export$b0f87bb1f6530fd8.easeLinear;
};
const $4bdda5ce454f9cb4$export$605f24bff585f740 = (name)=>$4bdda5ce454f9cb4$export$b0f87bb1f6530fd8[name] ? $4bdda5ce454f9cb4$export$b0f87bb1f6530fd8[name] : $4bdda5ce454f9cb4$export$b0f87bb1f6530fd8.easeLinear;


const $d975d6add471d316$export$2f1a74589dda35c3 = Infinity;
const $d975d6add471d316$export$745c2b445c1110d = 0;
const $d975d6add471d316$export$fa57c23defe18c5f = 1;
const $d975d6add471d316$export$d21786ee1d9bfeee = false;
const $d975d6add471d316$export$35da66156a4897ea = false;
const $d975d6add471d316$export$107c1a8f7eaf5d91 = 0;
const $d975d6add471d316$export$6c4720c3b9135a36 = null;
const $d975d6add471d316$export$86cdd8c3740ed501 = null;
const $d975d6add471d316$export$16964c9e319a42ab = 1;
const $d975d6add471d316$export$63f2df7bd7371262 = 10;
const $d975d6add471d316$export$72d6647c6a08e38c = 1;
const $d975d6add471d316$export$12cb6783d1668a58 = 1;
const $d975d6add471d316$export$aa9ff4453bec0b9c = false;
const $d975d6add471d316$export$e338f7bef784a532 = false;
const $d975d6add471d316$export$95fc36a5f3be840e = (0, $4bdda5ce454f9cb4$export$5d6e1e4631108fd5);
const $d975d6add471d316$export$8d825e02d092de99 = 0.0167;
const $d975d6add471d316$export$10ee648867152bbc = [
    (0, $83f850ed9ddda6a7$export$4cbd4a5e129eef58),
    (0, $83f850ed9ddda6a7$export$45db14bd37173b96),
    (0, $83f850ed9ddda6a7$export$ed0ee694b4907565),
    (0, $83f850ed9ddda6a7$export$980595dbb0c6e42),
    (0, $83f850ed9ddda6a7$export$3ef979d6b2e48ce),
    (0, $83f850ed9ddda6a7$export$bfe2fafbb3f6ec80),
    (0, $83f850ed9ddda6a7$export$b615b6b5bb0ad3de),
    (0, $83f850ed9ddda6a7$export$30a3f65ebc8fd963),
    (0, $83f850ed9ddda6a7$export$c1477f2eb8bd1522),
    (0, $83f850ed9ddda6a7$export$1e0160107f8e88ab)
];
const $d975d6add471d316$export$2de430434fa15c6d = [
    (0, $2732299af51e9693$export$467f3abd3509ebe9),
    (0, $2732299af51e9693$export$b34a75d4835b0bc5),
    (0, $2732299af51e9693$export$46c080640007f6c8),
    (0, $2732299af51e9693$export$e4ae7b92639bc550),
    (0, $2732299af51e9693$export$8edd8097d5982cc6),
    (0, $2732299af51e9693$export$8742ff6a9e4f9956),
    (0, $2732299af51e9693$export$a2ab21ade2918dde),
    (0, $2732299af51e9693$export$1be9b23e96dfffa1),
    (0, $2732299af51e9693$export$377dc8da583fe9e0),
    (0, $2732299af51e9693$export$cedf5532ac01e38d),
    (0, $2732299af51e9693$export$143e5d25a7f4575f)
];
const $d975d6add471d316$export$10d853e8047d8c5e = [
    (0, $01c6d32cf1e9ec4f$export$13a70080352d20ed)
];
const $d975d6add471d316$export$72a77ef1e4cbedd5 = [
    (0, $6750d9f4d05ced14$export$7cd2cdc555c88d56),
    (0, $6750d9f4d05ced14$export$baed6ad0a34de92),
    (0, $6750d9f4d05ced14$export$9ca71e45661a213e),
    (0, $6750d9f4d05ced14$export$224740a183ed091f),
    (0, $6750d9f4d05ced14$export$45cdd312cd8280a8)
];


var $cc894e2648a4bb4d$exports = {};
var $ae99155c68b0ea07$exports = {};
var $9244237a54d10175$exports = {};
function $9244237a54d10175$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $9244237a54d10175$exports = $9244237a54d10175$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $9244237a54d10175$exports.__esModule = true, $9244237a54d10175$exports["default"] = $9244237a54d10175$exports, $9244237a54d10175$var$_typeof(o);
}
$9244237a54d10175$exports = $9244237a54d10175$var$_typeof, $9244237a54d10175$exports.__esModule = true, $9244237a54d10175$exports["default"] = $9244237a54d10175$exports;


var $ae99155c68b0ea07$var$_typeof = $9244237a54d10175$exports.default;
var $903192c501da4bd6$exports = {};

var $903192c501da4bd6$var$_typeof = $9244237a54d10175$exports.default;
function $903192c501da4bd6$var$_toPrimitive(input, hint) {
    if ($903192c501da4bd6$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($903192c501da4bd6$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
$903192c501da4bd6$exports = $903192c501da4bd6$var$_toPrimitive, $903192c501da4bd6$exports.__esModule = true, $903192c501da4bd6$exports["default"] = $903192c501da4bd6$exports;


function $ae99155c68b0ea07$var$_toPropertyKey(arg) {
    var key = $903192c501da4bd6$exports(arg, "string");
    return $ae99155c68b0ea07$var$_typeof(key) === "symbol" ? key : String(key);
}
$ae99155c68b0ea07$exports = $ae99155c68b0ea07$var$_toPropertyKey, $ae99155c68b0ea07$exports.__esModule = true, $ae99155c68b0ea07$exports["default"] = $ae99155c68b0ea07$exports;


function $cc894e2648a4bb4d$var$_defineProperty(obj, key, value) {
    key = $ae99155c68b0ea07$exports(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
$cc894e2648a4bb4d$exports = $cc894e2648a4bb4d$var$_defineProperty, $cc894e2648a4bb4d$exports.__esModule = true, $cc894e2648a4bb4d$exports["default"] = $cc894e2648a4bb4d$exports;


var $b1787551de63bafa$export$2e2bcd8739ae039 = {
    getRGB: function(color) {
        var rgb = {};
        if (typeof color === "number") {
            hex = Math.floor(color);
            rgb.r = (color >> 16 & 255) / 255;
            rgb.g = (color >> 8 & 255) / 255;
            rgb.b = (color & 255) / 255;
        } else if (typeof color === "string") {
            var m;
            if (m = /^(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*(,\s*([0-9]*\.?[0-9]+)\s*)?$/.exec(color)) {
                rgb.r = Math.min(255, parseInt(m[1], 10)) / 255;
                rgb.g = Math.min(255, parseInt(m[2], 10)) / 255;
                rgb.b = Math.min(255, parseInt(m[3], 10)) / 255; // eslint-disable-next-line no-useless-escape
            } else if (m = /^\#([A-Fa-f0-9]+)$/.exec(color)) {
                var hex = m[1];
                rgb.r = parseInt(hex.charAt(0) + hex.charAt(1), 16) / 255;
                rgb.g = parseInt(hex.charAt(2) + hex.charAt(3), 16) / 255;
                rgb.b = parseInt(hex.charAt(4) + hex.charAt(5), 16) / 255;
            }
        } else {
            rgb.r = color.r;
            rgb.g = color.g;
            rgb.b = color.b;
        }
        return rgb;
    }
};


var $b08343919f129d8b$export$2e2bcd8739ae039 = {
    _id: 0,
    _uids: new Map(),
    getNewId: function() {
        return `PUID_${++this._id}`;
    },
    id: function(functionOrObject) {
        if (this._uids.has(functionOrObject)) return this._uids.get(functionOrObject);
        const newId = this.getNewId();
        this._uids.set(functionOrObject, newId);
        return newId;
    }
};


/**
 * @author alteredq / http://alteredqualia.com/
 * @author mrdoob / http://mrdoob.com/
 */ var $5e7b16e81687ccbd$export$23e630a4917fd6ad = {
    DEG2RAD: Math.PI / 180,
    RAD2DEG: 180 / Math.PI,
    generateUUID: function() {
        // http://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid-in-javascript/21963136#21963136
        var lut = [];
        for(var i = 0; i < 256; i++)lut[i] = (i < 16 ? "0" : "") + i.toString(16);
        return function generateUUID() {
            var d0 = Math.random() * 0xffffffff | 0;
            var d1 = Math.random() * 0xffffffff | 0;
            var d2 = Math.random() * 0xffffffff | 0;
            var d3 = Math.random() * 0xffffffff | 0;
            var uuid = lut[d0 & 0xff] + lut[d0 >> 8 & 0xff] + lut[d0 >> 16 & 0xff] + lut[d0 >> 24 & 0xff] + "-" + lut[d1 & 0xff] + lut[d1 >> 8 & 0xff] + "-" + lut[d1 >> 16 & 0x0f | 0x40] + lut[d1 >> 24 & 0xff] + "-" + lut[d2 & 0x3f | 0x80] + lut[d2 >> 8 & 0xff] + "-" + lut[d2 >> 16 & 0xff] + lut[d2 >> 24 & 0xff] + lut[d3 & 0xff] + lut[d3 >> 8 & 0xff] + lut[d3 >> 16 & 0xff] + lut[d3 >> 24 & 0xff]; // .toUpperCase() here flattens concatenated strings to save heap memory space.
            return uuid.toUpperCase();
        };
    }(),
    clamp: function(value, min, max) {
        return Math.max(min, Math.min(max, value));
    },
    // compute euclidian modulo of m % n
    // https://en.wikipedia.org/wiki/Modulo_operation
    euclideanModulo: function(n, m) {
        return (n % m + m) % m;
    },
    // Linear mapping from range <a1, a2> to range <b1, b2>
    mapLinear: function(x, a1, a2, b1, b2) {
        return b1 + (x - a1) * (b2 - b1) / (a2 - a1);
    },
    // https://en.wikipedia.org/wiki/Linear_interpolation
    lerp: function(x, y, t) {
        return (1 - t) * x + t * y;
    },
    // http://en.wikipedia.org/wiki/Smoothstep
    smoothstep: function(x, min, max) {
        if (x <= min) return 0;
        if (x >= max) return 1;
        x = (x - min) / (max - min);
        return x * x * (3 - 2 * x);
    },
    smootherstep: function(x, min, max) {
        if (x <= min) return 0;
        if (x >= max) return 1;
        x = (x - min) / (max - min);
        return x * x * x * (x * (x * 6 - 15) + 10);
    },
    // Random integer from <low, high> interval
    randInt: function(low, high) {
        return low + Math.floor(Math.random() * (high - low + 1));
    },
    // Random float from <low, high> interval
    randFloat: function(low, high) {
        return low + Math.random() * (high - low);
    },
    // Random float from <-range/2, range/2> interval
    randFloatSpread: function(range) {
        return range * (0.5 - Math.random());
    },
    degToRad: function(degrees) {
        return degrees * $5e7b16e81687ccbd$export$23e630a4917fd6ad.DEG2RAD;
    },
    radToDeg: function(radians) {
        return radians * $5e7b16e81687ccbd$export$23e630a4917fd6ad.RAD2DEG;
    },
    isPowerOfTwo: function(value) {
        return (value & value - 1) === 0 && value !== 0;
    },
    ceilPowerOfTwo: function(value) {
        return Math.pow(2, Math.ceil(Math.log(value) / Math.LN2));
    },
    floorPowerOfTwo: function(value) {
        return Math.pow(2, Math.floor(Math.log(value) / Math.LN2));
    }
};


/**
 * @author mikael emtinger / http://gomo.se/
 * @author alteredq / http://alteredqualia.com/
 * @author WestLangley / http://github.com/WestLangley
 * @author bhouston / http://clara.io
 */ 
function $dfc0b360f8939fec$export$23d6a54f0bbc85a3(x, y, z, w) {
    this._x = x || 0;
    this._y = y || 0;
    this._z = z || 0;
    this._w = w !== undefined ? w : 1;
}
Object.assign($dfc0b360f8939fec$export$23d6a54f0bbc85a3, {
    slerp: function(qa, qb, qm, t) {
        return qm.copy(qa).slerp(qb, t);
    },
    slerpFlat: function(dst, dstOffset, src0, srcOffset0, src1, srcOffset1, t) {
        // fuzz-free, array-based Quaternion SLERP operation
        var x0 = src0[srcOffset0 + 0], y0 = src0[srcOffset0 + 1], z0 = src0[srcOffset0 + 2], w0 = src0[srcOffset0 + 3], x1 = src1[srcOffset1 + 0], y1 = src1[srcOffset1 + 1], z1 = src1[srcOffset1 + 2], w1 = src1[srcOffset1 + 3];
        if (w0 !== w1 || x0 !== x1 || y0 !== y1 || z0 !== z1) {
            var s = 1 - t, cos = x0 * x1 + y0 * y1 + z0 * z1 + w0 * w1, dir = cos >= 0 ? 1 : -1, sqrSin = 1 - cos * cos; // Skip the Slerp for tiny steps to avoid numeric problems:
            if (sqrSin > Number.EPSILON) {
                var sin = Math.sqrt(sqrSin), len = Math.atan2(sin, cos * dir);
                s = Math.sin(s * len) / sin;
                t = Math.sin(t * len) / sin;
            }
            var tDir = t * dir;
            x0 = x0 * s + x1 * tDir;
            y0 = y0 * s + y1 * tDir;
            z0 = z0 * s + z1 * tDir;
            w0 = w0 * s + w1 * tDir; // Normalize in case we just did a lerp:
            if (s === 1 - t) {
                var f = 1 / Math.sqrt(x0 * x0 + y0 * y0 + z0 * z0 + w0 * w0);
                x0 *= f;
                y0 *= f;
                z0 *= f;
                w0 *= f;
            }
        }
        dst[dstOffset] = x0;
        dst[dstOffset + 1] = y0;
        dst[dstOffset + 2] = z0;
        dst[dstOffset + 3] = w0;
    }
});
Object.defineProperties($dfc0b360f8939fec$export$23d6a54f0bbc85a3.prototype, {
    x: {
        get: function() {
            return this._x;
        },
        set: function(value) {
            this._x = value;
            this._onChangeCallback();
        }
    },
    y: {
        get: function() {
            return this._y;
        },
        set: function(value) {
            this._y = value;
            this._onChangeCallback();
        }
    },
    z: {
        get: function() {
            return this._z;
        },
        set: function(value) {
            this._z = value;
            this._onChangeCallback();
        }
    },
    w: {
        get: function() {
            return this._w;
        },
        set: function(value) {
            this._w = value;
            this._onChangeCallback();
        }
    }
});
Object.assign($dfc0b360f8939fec$export$23d6a54f0bbc85a3.prototype, {
    isQuaternion: true,
    set: function(x, y, z, w) {
        this._x = x;
        this._y = y;
        this._z = z;
        this._w = w;
        this._onChangeCallback();
        return this;
    },
    clone: function() {
        return new this.constructor(this._x, this._y, this._z, this._w);
    },
    copy: function(quaternion) {
        this._x = quaternion.x;
        this._y = quaternion.y;
        this._z = quaternion.z;
        this._w = quaternion.w;
        this._onChangeCallback();
        return this;
    },
    setFromEuler: function(euler, update) {
        if (!(euler && euler.isEuler)) throw new Error("THREE.Quaternion: .setFromEuler() now expects an Euler rotation rather than a Vector3 and order.");
        var x = euler._x, y = euler._y, z = euler._z, order = euler.order; // http://www.mathworks.com/matlabcentral/fileexchange/
        // 	20696-function-to-convert-between-dcm-euler-angles-quaternions-and-euler-vectors/
        //	content/SpinCalc.m
        var cos = Math.cos;
        var sin = Math.sin;
        var c1 = cos(x / 2);
        var c2 = cos(y / 2);
        var c3 = cos(z / 2);
        var s1 = sin(x / 2);
        var s2 = sin(y / 2);
        var s3 = sin(z / 2);
        if (order === "XYZ") {
            this._x = s1 * c2 * c3 + c1 * s2 * s3;
            this._y = c1 * s2 * c3 - s1 * c2 * s3;
            this._z = c1 * c2 * s3 + s1 * s2 * c3;
            this._w = c1 * c2 * c3 - s1 * s2 * s3;
        } else if (order === "YXZ") {
            this._x = s1 * c2 * c3 + c1 * s2 * s3;
            this._y = c1 * s2 * c3 - s1 * c2 * s3;
            this._z = c1 * c2 * s3 - s1 * s2 * c3;
            this._w = c1 * c2 * c3 + s1 * s2 * s3;
        } else if (order === "ZXY") {
            this._x = s1 * c2 * c3 - c1 * s2 * s3;
            this._y = c1 * s2 * c3 + s1 * c2 * s3;
            this._z = c1 * c2 * s3 + s1 * s2 * c3;
            this._w = c1 * c2 * c3 - s1 * s2 * s3;
        } else if (order === "ZYX") {
            this._x = s1 * c2 * c3 - c1 * s2 * s3;
            this._y = c1 * s2 * c3 + s1 * c2 * s3;
            this._z = c1 * c2 * s3 - s1 * s2 * c3;
            this._w = c1 * c2 * c3 + s1 * s2 * s3;
        } else if (order === "YZX") {
            this._x = s1 * c2 * c3 + c1 * s2 * s3;
            this._y = c1 * s2 * c3 + s1 * c2 * s3;
            this._z = c1 * c2 * s3 - s1 * s2 * c3;
            this._w = c1 * c2 * c3 - s1 * s2 * s3;
        } else if (order === "XZY") {
            this._x = s1 * c2 * c3 - c1 * s2 * s3;
            this._y = c1 * s2 * c3 - s1 * c2 * s3;
            this._z = c1 * c2 * s3 + s1 * s2 * c3;
            this._w = c1 * c2 * c3 + s1 * s2 * s3;
        }
        if (update !== false) this._onChangeCallback();
        return this;
    },
    setFromAxisAngle: function(axis, angle) {
        // http://www.euclideanspace.com/maths/geometry/rotations/conversions/angleToQuaternion/index.htm
        // assumes axis is normalized
        var halfAngle = angle / 2, s = Math.sin(halfAngle);
        this._x = axis.x * s;
        this._y = axis.y * s;
        this._z = axis.z * s;
        this._w = Math.cos(halfAngle);
        this._onChangeCallback();
        return this;
    },
    setFromRotationMatrix: function(m) {
        // http://www.euclideanspace.com/maths/geometry/rotations/conversions/matrixToQuaternion/index.htm
        // assumes the upper 3x3 of m is a pure rotation matrix (i.e, unscaled)
        var te = m.elements, m11 = te[0], m12 = te[4], m13 = te[8], m21 = te[1], m22 = te[5], m23 = te[9], m31 = te[2], m32 = te[6], m33 = te[10], trace = m11 + m22 + m33, s;
        if (trace > 0) {
            s = 0.5 / Math.sqrt(trace + 1.0);
            this._w = 0.25 / s;
            this._x = (m32 - m23) * s;
            this._y = (m13 - m31) * s;
            this._z = (m21 - m12) * s;
        } else if (m11 > m22 && m11 > m33) {
            s = 2.0 * Math.sqrt(1.0 + m11 - m22 - m33);
            this._w = (m32 - m23) / s;
            this._x = 0.25 * s;
            this._y = (m12 + m21) / s;
            this._z = (m13 + m31) / s;
        } else if (m22 > m33) {
            s = 2.0 * Math.sqrt(1.0 + m22 - m11 - m33);
            this._w = (m13 - m31) / s;
            this._x = (m12 + m21) / s;
            this._y = 0.25 * s;
            this._z = (m23 + m32) / s;
        } else {
            s = 2.0 * Math.sqrt(1.0 + m33 - m11 - m22);
            this._w = (m21 - m12) / s;
            this._x = (m13 + m31) / s;
            this._y = (m23 + m32) / s;
            this._z = 0.25 * s;
        }
        this._onChangeCallback();
        return this;
    },
    setFromUnitVectors: function(vFrom, vTo) {
        // assumes direction vectors vFrom and vTo are normalized
        var EPS = 0.000001;
        var r = vFrom.dot(vTo) + 1;
        if (r < EPS) {
            r = 0;
            if (Math.abs(vFrom.x) > Math.abs(vFrom.z)) {
                this._x = -vFrom.y;
                this._y = vFrom.x;
                this._z = 0;
                this._w = r;
            } else {
                this._x = 0;
                this._y = -vFrom.z;
                this._z = vFrom.y;
                this._w = r;
            }
        } else {
            // crossVectors( vFrom, vTo ); // inlined to avoid cyclic dependency on Vector3
            this._x = vFrom.y * vTo.z - vFrom.z * vTo.y;
            this._y = vFrom.z * vTo.x - vFrom.x * vTo.z;
            this._z = vFrom.x * vTo.y - vFrom.y * vTo.x;
            this._w = r;
        }
        return this.normalize();
    },
    angleTo: function(q) {
        return 2 * Math.acos(Math.abs((0, $5e7b16e81687ccbd$export$23e630a4917fd6ad).clamp(this.dot(q), -1, 1)));
    },
    rotateTowards: function(q, step) {
        var angle = this.angleTo(q);
        if (angle === 0) return this;
        var t = Math.min(1, step / angle);
        this.slerp(q, t);
        return this;
    },
    inverse: function() {
        // quaternion is assumed to have unit length
        return this.conjugate();
    },
    conjugate: function() {
        this._x *= -1;
        this._y *= -1;
        this._z *= -1;
        this._onChangeCallback();
        return this;
    },
    dot: function(v) {
        return this._x * v._x + this._y * v._y + this._z * v._z + this._w * v._w;
    },
    lengthSq: function() {
        return this._x * this._x + this._y * this._y + this._z * this._z + this._w * this._w;
    },
    length: function() {
        return Math.sqrt(this._x * this._x + this._y * this._y + this._z * this._z + this._w * this._w);
    },
    normalize: function() {
        var l = this.length();
        if (l === 0) {
            this._x = 0;
            this._y = 0;
            this._z = 0;
            this._w = 1;
        } else {
            l = 1 / l;
            this._x = this._x * l;
            this._y = this._y * l;
            this._z = this._z * l;
            this._w = this._w * l;
        }
        this._onChangeCallback();
        return this;
    },
    multiply: function(q, p) {
        if (p !== undefined) {
            console.warn("THREE.Quaternion: .multiply() now only accepts one argument. Use .multiplyQuaternions( a, b ) instead.");
            return this.multiplyQuaternions(q, p);
        }
        return this.multiplyQuaternions(this, q);
    },
    premultiply: function(q) {
        return this.multiplyQuaternions(q, this);
    },
    multiplyQuaternions: function(a, b) {
        // from http://www.euclideanspace.com/maths/algebra/realNormedAlgebra/quaternions/code/index.htm
        var qax = a._x, qay = a._y, qaz = a._z, qaw = a._w;
        var qbx = b._x, qby = b._y, qbz = b._z, qbw = b._w;
        this._x = qax * qbw + qaw * qbx + qay * qbz - qaz * qby;
        this._y = qay * qbw + qaw * qby + qaz * qbx - qax * qbz;
        this._z = qaz * qbw + qaw * qbz + qax * qby - qay * qbx;
        this._w = qaw * qbw - qax * qbx - qay * qby - qaz * qbz;
        this._onChangeCallback();
        return this;
    },
    slerp: function(qb, t) {
        if (t === 0) return this;
        if (t === 1) return this.copy(qb);
        var x = this._x, y = this._y, z = this._z, w = this._w; // http://www.euclideanspace.com/maths/algebra/realNormedAlgebra/quaternions/slerp/
        var cosHalfTheta = w * qb._w + x * qb._x + y * qb._y + z * qb._z;
        if (cosHalfTheta < 0) {
            this._w = -qb._w;
            this._x = -qb._x;
            this._y = -qb._y;
            this._z = -qb._z;
            cosHalfTheta = -cosHalfTheta;
        } else this.copy(qb);
        if (cosHalfTheta >= 1.0) {
            this._w = w;
            this._x = x;
            this._y = y;
            this._z = z;
            return this;
        }
        var sqrSinHalfTheta = 1.0 - cosHalfTheta * cosHalfTheta;
        if (sqrSinHalfTheta <= Number.EPSILON) {
            var s = 1 - t;
            this._w = s * w + t * this._w;
            this._x = s * x + t * this._x;
            this._y = s * y + t * this._y;
            this._z = s * z + t * this._z;
            this.normalize();
            this._onChangeCallback();
            return this;
        }
        var sinHalfTheta = Math.sqrt(sqrSinHalfTheta);
        var halfTheta = Math.atan2(sinHalfTheta, cosHalfTheta);
        var ratioA = Math.sin((1 - t) * halfTheta) / sinHalfTheta, ratioB = Math.sin(t * halfTheta) / sinHalfTheta;
        this._w = w * ratioA + this._w * ratioB;
        this._x = x * ratioA + this._x * ratioB;
        this._y = y * ratioA + this._y * ratioB;
        this._z = z * ratioA + this._z * ratioB;
        this._onChangeCallback();
        return this;
    },
    equals: function(quaternion) {
        return quaternion._x === this._x && quaternion._y === this._y && quaternion._z === this._z && quaternion._w === this._w;
    },
    fromArray: function(array, offset) {
        if (offset === undefined) offset = 0;
        this._x = array[offset];
        this._y = array[offset + 1];
        this._z = array[offset + 2];
        this._w = array[offset + 3];
        this._onChangeCallback();
        return this;
    },
    toArray: function(array, offset) {
        if (array === undefined) array = [];
        if (offset === undefined) offset = 0;
        array[offset] = this._x;
        array[offset + 1] = this._y;
        array[offset + 2] = this._z;
        array[offset + 3] = this._w;
        return array;
    },
    _onChange: function(callback) {
        this._onChangeCallback = callback;
        return this;
    },
    _onChangeCallback: function() {}
});


/**
 * @author mrdoob / http://mrdoob.com/
 * @author kile / http://kile.stravaganza.org/
 * @author philogb / http://blog.thejit.org/
 * @author mikael emtinger / http://gomo.se/
 * @author egraether / http://egraether.com/
 * @author WestLangley / http://github.com/WestLangley
 */ function $085a6d802029f140$export$64b5c384219d3699(x, y, z) {
    this.x = x || 0;
    this.y = y || 0;
    this.z = z || 0;
}
Object.assign($085a6d802029f140$export$64b5c384219d3699.prototype, {
    isVector3: true,
    set: function(x, y, z) {
        this.x = x;
        this.y = y;
        this.z = z;
        return this;
    },
    setScalar: function(scalar) {
        this.x = scalar;
        this.y = scalar;
        this.z = scalar;
        return this;
    },
    setX: function(x) {
        this.x = x;
        return this;
    },
    setY: function(y) {
        this.y = y;
        return this;
    },
    setZ: function(z) {
        this.z = z;
        return this;
    },
    setComponent: function(index, value) {
        switch(index){
            case 0:
                this.x = value;
                break;
            case 1:
                this.y = value;
                break;
            case 2:
                this.z = value;
                break;
            default:
                throw new Error("index is out of range: " + index);
        }
        return this;
    },
    getComponent: function(index) {
        switch(index){
            case 0:
                return this.x;
            case 1:
                return this.y;
            case 2:
                return this.z;
            default:
                throw new Error("index is out of range: " + index);
        }
    },
    clone: function() {
        return new this.constructor(this.x, this.y, this.z);
    },
    copy: function(v) {
        this.x = v.x;
        this.y = v.y;
        this.z = v.z;
        return this;
    },
    add: function(v, w) {
        if (w !== undefined) {
            console.warn("THREE.Vector3: .add() now only accepts one argument. Use .addVectors( a, b ) instead.");
            return this.addVectors(v, w);
        }
        this.x += v.x;
        this.y += v.y;
        this.z += v.z;
        return this;
    },
    addScalar: function(s) {
        this.x += s;
        this.y += s;
        this.z += s;
        return this;
    },
    addVectors: function(a, b) {
        this.x = a.x + b.x;
        this.y = a.y + b.y;
        this.z = a.z + b.z;
        return this;
    },
    addScaledVector: function(v, s) {
        this.x += v.x * s;
        this.y += v.y * s;
        this.z += v.z * s;
        return this;
    },
    sub: function(v, w) {
        if (w !== undefined) {
            console.warn("THREE.Vector3: .sub() now only accepts one argument. Use .subVectors( a, b ) instead.");
            return this.subVectors(v, w);
        }
        this.x -= v.x;
        this.y -= v.y;
        this.z -= v.z;
        return this;
    },
    subScalar: function(s) {
        this.x -= s;
        this.y -= s;
        this.z -= s;
        return this;
    },
    subVectors: function(a, b) {
        this.x = a.x - b.x;
        this.y = a.y - b.y;
        this.z = a.z - b.z;
        return this;
    },
    multiply: function(v, w) {
        if (w !== undefined) {
            console.warn("THREE.Vector3: .multiply() now only accepts one argument. Use .multiplyVectors( a, b ) instead.");
            return this.multiplyVectors(v, w);
        }
        this.x *= v.x;
        this.y *= v.y;
        this.z *= v.z;
        return this;
    },
    multiplyScalar: function(scalar) {
        this.x *= scalar;
        this.y *= scalar;
        this.z *= scalar;
        return this;
    },
    multiplyVectors: function(a, b) {
        this.x = a.x * b.x;
        this.y = a.y * b.y;
        this.z = a.z * b.z;
        return this;
    },
    applyEuler: function() {
        var quaternion = new (0, $dfc0b360f8939fec$export$23d6a54f0bbc85a3)();
        return function applyEuler(euler) {
            if (!(euler && euler.isEuler)) console.error("THREE.Vector3: .applyEuler() now expects an Euler rotation rather than a Vector3 and order.");
            return this.applyQuaternion(quaternion.setFromEuler(euler));
        };
    }(),
    applyAxisAngle: function() {
        var quaternion = new (0, $dfc0b360f8939fec$export$23d6a54f0bbc85a3)();
        return function applyAxisAngle(axis, angle) {
            return this.applyQuaternion(quaternion.setFromAxisAngle(axis, angle));
        };
    }(),
    applyMatrix3: function(m) {
        var x = this.x, y = this.y, z = this.z;
        var e = m.elements;
        this.x = e[0] * x + e[3] * y + e[6] * z;
        this.y = e[1] * x + e[4] * y + e[7] * z;
        this.z = e[2] * x + e[5] * y + e[8] * z;
        return this;
    },
    applyMatrix4: function(m) {
        var x = this.x, y = this.y, z = this.z;
        var e = m.elements;
        var w = 1 / (e[3] * x + e[7] * y + e[11] * z + e[15]);
        this.x = (e[0] * x + e[4] * y + e[8] * z + e[12]) * w;
        this.y = (e[1] * x + e[5] * y + e[9] * z + e[13]) * w;
        this.z = (e[2] * x + e[6] * y + e[10] * z + e[14]) * w;
        return this;
    },
    applyQuaternion: function(q) {
        var x = this.x, y = this.y, z = this.z;
        var qx = q.x, qy = q.y, qz = q.z, qw = q.w; // calculate quat * vector
        var ix = qw * x + qy * z - qz * y;
        var iy = qw * y + qz * x - qx * z;
        var iz = qw * z + qx * y - qy * x;
        var iw = -qx * x - qy * y - qz * z; // calculate result * inverse quat
        this.x = ix * qw + iw * -qx + iy * -qz - iz * -qy;
        this.y = iy * qw + iw * -qy + iz * -qx - ix * -qz;
        this.z = iz * qw + iw * -qz + ix * -qy - iy * -qx;
        return this;
    },
    project: function(camera) {
        return this.applyMatrix4(camera.matrixWorldInverse).applyMatrix4(camera.projectionMatrix);
    },
    unproject: function(camera) {
        return this.applyMatrix4(camera.projectionMatrixInverse).applyMatrix4(camera.matrixWorld);
    },
    transformDirection: function(m) {
        // input: THREE.Matrix4 affine matrix
        // vector interpreted as a direction
        var x = this.x, y = this.y, z = this.z;
        var e = m.elements;
        this.x = e[0] * x + e[4] * y + e[8] * z;
        this.y = e[1] * x + e[5] * y + e[9] * z;
        this.z = e[2] * x + e[6] * y + e[10] * z;
        return this.normalize();
    },
    divide: function(v) {
        this.x /= v.x;
        this.y /= v.y;
        this.z /= v.z;
        return this;
    },
    divideScalar: function(scalar) {
        return this.multiplyScalar(1 / scalar);
    },
    min: function(v) {
        this.x = Math.min(this.x, v.x);
        this.y = Math.min(this.y, v.y);
        this.z = Math.min(this.z, v.z);
        return this;
    },
    max: function(v) {
        this.x = Math.max(this.x, v.x);
        this.y = Math.max(this.y, v.y);
        this.z = Math.max(this.z, v.z);
        return this;
    },
    clamp: function(min, max) {
        // assumes min < max, componentwise
        this.x = Math.max(min.x, Math.min(max.x, this.x));
        this.y = Math.max(min.y, Math.min(max.y, this.y));
        this.z = Math.max(min.z, Math.min(max.z, this.z));
        return this;
    },
    clampScalar: function(minVal, maxVal) {
        this.x = Math.max(minVal, Math.min(maxVal, this.x));
        this.y = Math.max(minVal, Math.min(maxVal, this.y));
        this.z = Math.max(minVal, Math.min(maxVal, this.z));
        return this;
    },
    clampLength: function(min, max) {
        var length = this.length();
        return this.divideScalar(length || 1).multiplyScalar(Math.max(min, Math.min(max, length)));
    },
    floor: function() {
        this.x = Math.floor(this.x);
        this.y = Math.floor(this.y);
        this.z = Math.floor(this.z);
        return this;
    },
    ceil: function() {
        this.x = Math.ceil(this.x);
        this.y = Math.ceil(this.y);
        this.z = Math.ceil(this.z);
        return this;
    },
    round: function() {
        this.x = Math.round(this.x);
        this.y = Math.round(this.y);
        this.z = Math.round(this.z);
        return this;
    },
    roundToZero: function() {
        this.x = this.x < 0 ? Math.ceil(this.x) : Math.floor(this.x);
        this.y = this.y < 0 ? Math.ceil(this.y) : Math.floor(this.y);
        this.z = this.z < 0 ? Math.ceil(this.z) : Math.floor(this.z);
        return this;
    },
    negate: function() {
        this.x = -this.x;
        this.y = -this.y;
        this.z = -this.z;
        return this;
    },
    dot: function(v) {
        return this.x * v.x + this.y * v.y + this.z * v.z;
    },
    // TODO lengthSquared?
    lengthSq: function() {
        return this.x * this.x + this.y * this.y + this.z * this.z;
    },
    length: function() {
        return Math.sqrt(this.x * this.x + this.y * this.y + this.z * this.z);
    },
    manhattanLength: function() {
        return Math.abs(this.x) + Math.abs(this.y) + Math.abs(this.z);
    },
    normalize: function() {
        return this.divideScalar(this.length() || 1);
    },
    setLength: function(length) {
        return this.normalize().multiplyScalar(length);
    },
    lerp: function(v, alpha) {
        this.x += (v.x - this.x) * alpha;
        this.y += (v.y - this.y) * alpha;
        this.z += (v.z - this.z) * alpha;
        return this;
    },
    lerpVectors: function(v1, v2, alpha) {
        return this.subVectors(v2, v1).multiplyScalar(alpha).add(v1);
    },
    cross: function(v, w) {
        if (w !== undefined) {
            console.warn("THREE.Vector3: .cross() now only accepts one argument. Use .crossVectors( a, b ) instead.");
            return this.crossVectors(v, w);
        }
        return this.crossVectors(this, v);
    },
    crossVectors: function(a, b) {
        var ax = a.x, ay = a.y, az = a.z;
        var bx = b.x, by = b.y, bz = b.z;
        this.x = ay * bz - az * by;
        this.y = az * bx - ax * bz;
        this.z = ax * by - ay * bx;
        return this;
    },
    projectOnVector: function(vector) {
        var scalar = vector.dot(this) / vector.lengthSq();
        return this.copy(vector).multiplyScalar(scalar);
    },
    projectOnPlane: function() {
        var v1 = new $085a6d802029f140$export$64b5c384219d3699();
        return function projectOnPlane(planeNormal) {
            v1.copy(this).projectOnVector(planeNormal);
            return this.sub(v1);
        };
    }(),
    reflect: function() {
        // reflect incident vector off plane orthogonal to normal
        // normal is assumed to have unit length
        var v1 = new $085a6d802029f140$export$64b5c384219d3699();
        return function reflect(normal) {
            return this.sub(v1.copy(normal).multiplyScalar(2 * this.dot(normal)));
        };
    }(),
    angleTo: function(v) {
        var theta = this.dot(v) / Math.sqrt(this.lengthSq() * v.lengthSq()); // clamp, to handle numerical problems
        return Math.acos((0, $5e7b16e81687ccbd$export$23e630a4917fd6ad).clamp(theta, -1, 1));
    },
    distanceTo: function(v) {
        return Math.sqrt(this.distanceToSquared(v));
    },
    distanceToSquared: function(v) {
        var dx = this.x - v.x, dy = this.y - v.y, dz = this.z - v.z;
        return dx * dx + dy * dy + dz * dz;
    },
    manhattanDistanceTo: function(v) {
        return Math.abs(this.x - v.x) + Math.abs(this.y - v.y) + Math.abs(this.z - v.z);
    },
    setFromSpherical: function(s) {
        return this.setFromSphericalCoords(s.radius, s.phi, s.theta);
    },
    setFromSphericalCoords: function(radius, phi, theta) {
        var sinPhiRadius = Math.sin(phi) * radius;
        this.x = sinPhiRadius * Math.sin(theta);
        this.y = Math.cos(phi) * radius;
        this.z = sinPhiRadius * Math.cos(theta);
        return this;
    },
    setFromCylindrical: function(c) {
        return this.setFromCylindricalCoords(c.radius, c.theta, c.y);
    },
    setFromCylindricalCoords: function(radius, theta, y) {
        this.x = radius * Math.sin(theta);
        this.y = y;
        this.z = radius * Math.cos(theta);
        return this;
    },
    setFromMatrixPosition: function(m) {
        var e = m.elements;
        this.x = e[12];
        this.y = e[13];
        this.z = e[14];
        return this;
    },
    setFromMatrixScale: function(m) {
        var sx = this.setFromMatrixColumn(m, 0).length();
        var sy = this.setFromMatrixColumn(m, 1).length();
        var sz = this.setFromMatrixColumn(m, 2).length();
        this.x = sx;
        this.y = sy;
        this.z = sz;
        return this;
    },
    setFromMatrixColumn: function(m, index) {
        return this.fromArray(m.elements, index * 4);
    },
    equals: function(v) {
        return v.x === this.x && v.y === this.y && v.z === this.z;
    },
    fromArray: function(array, offset) {
        if (offset === undefined) offset = 0;
        this.x = array[offset];
        this.y = array[offset + 1];
        this.z = array[offset + 2];
        return this;
    },
    toArray: function(array, offset) {
        if (array === undefined) array = [];
        if (offset === undefined) offset = 0;
        array[offset] = this.x;
        array[offset + 1] = this.y;
        array[offset + 2] = this.z;
        return array;
    },
    fromBufferAttribute: function(attribute, index, offset) {
        if (offset !== undefined) console.warn("THREE.Vector3: offset has been removed from .fromBufferAttribute().");
        this.x = attribute.getX(index);
        this.y = attribute.getY(index);
        this.z = attribute.getZ(index);
        return this;
    }
});






/**
 * @author mrdoob / http://mrdoob.com/
 * @author supereggbert / http://www.paulbrunt.co.uk/
 * @author philogb / http://blog.thejit.org/
 * @author jordi_ros / http://plattsoft.com
 * @author D1plo1d / http://github.com/D1plo1d
 * @author alteredq / http://alteredqualia.com/
 * @author mikael emtinger / http://gomo.se/
 * @author timknip / http://www.floorplanner.com/
 * @author bhouston / http://clara.io
 * @author WestLangley / http://github.com/WestLangley
 */ function $95f8a63608f1c552$export$2ae72fc923e5eb5() {
    this.elements = [
        1,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        1
    ];
    if (arguments.length > 0) console.error("THREE.Matrix4: the constructor no longer reads arguments. use .set() instead.");
}
Object.assign($95f8a63608f1c552$export$2ae72fc923e5eb5.prototype, {
    isMatrix4: true,
    set: function(n11, n12, n13, n14, n21, n22, n23, n24, n31, n32, n33, n34, n41, n42, n43, n44) {
        var te = this.elements;
        te[0] = n11;
        te[4] = n12;
        te[8] = n13;
        te[12] = n14;
        te[1] = n21;
        te[5] = n22;
        te[9] = n23;
        te[13] = n24;
        te[2] = n31;
        te[6] = n32;
        te[10] = n33;
        te[14] = n34;
        te[3] = n41;
        te[7] = n42;
        te[11] = n43;
        te[15] = n44;
        return this;
    },
    identity: function() {
        this.set(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
        return this;
    },
    clone: function() {
        return new $95f8a63608f1c552$export$2ae72fc923e5eb5().fromArray(this.elements);
    },
    copy: function(m) {
        var te = this.elements;
        var me = m.elements;
        te[0] = me[0];
        te[1] = me[1];
        te[2] = me[2];
        te[3] = me[3];
        te[4] = me[4];
        te[5] = me[5];
        te[6] = me[6];
        te[7] = me[7];
        te[8] = me[8];
        te[9] = me[9];
        te[10] = me[10];
        te[11] = me[11];
        te[12] = me[12];
        te[13] = me[13];
        te[14] = me[14];
        te[15] = me[15];
        return this;
    },
    copyPosition: function(m) {
        var te = this.elements, me = m.elements;
        te[12] = me[12];
        te[13] = me[13];
        te[14] = me[14];
        return this;
    },
    extractBasis: function(xAxis, yAxis, zAxis) {
        xAxis.setFromMatrixColumn(this, 0);
        yAxis.setFromMatrixColumn(this, 1);
        zAxis.setFromMatrixColumn(this, 2);
        return this;
    },
    makeBasis: function(xAxis, yAxis, zAxis) {
        this.set(xAxis.x, yAxis.x, zAxis.x, 0, xAxis.y, yAxis.y, zAxis.y, 0, xAxis.z, yAxis.z, zAxis.z, 0, 0, 0, 0, 1);
        return this;
    },
    extractRotation: function() {
        var v1 = new (0, $085a6d802029f140$export$64b5c384219d3699)();
        return function extractRotation(m) {
            // this method does not support reflection matrices
            var te = this.elements;
            var me = m.elements;
            var scaleX = 1 / v1.setFromMatrixColumn(m, 0).length();
            var scaleY = 1 / v1.setFromMatrixColumn(m, 1).length();
            var scaleZ = 1 / v1.setFromMatrixColumn(m, 2).length();
            te[0] = me[0] * scaleX;
            te[1] = me[1] * scaleX;
            te[2] = me[2] * scaleX;
            te[3] = 0;
            te[4] = me[4] * scaleY;
            te[5] = me[5] * scaleY;
            te[6] = me[6] * scaleY;
            te[7] = 0;
            te[8] = me[8] * scaleZ;
            te[9] = me[9] * scaleZ;
            te[10] = me[10] * scaleZ;
            te[11] = 0;
            te[12] = 0;
            te[13] = 0;
            te[14] = 0;
            te[15] = 1;
            return this;
        };
    }(),
    makeRotationFromEuler: function(euler) {
        if (!(euler && euler.isEuler)) console.error("THREE.Matrix4: .makeRotationFromEuler() now expects a Euler rotation rather than a Vector3 and order.");
        var te = this.elements;
        var x = euler.x, y = euler.y, z = euler.z;
        var a = Math.cos(x), b = Math.sin(x);
        var c = Math.cos(y), d = Math.sin(y);
        var e = Math.cos(z), f = Math.sin(z);
        if (euler.order === "XYZ") {
            var ae = a * e, af = a * f, be = b * e, bf = b * f;
            te[0] = c * e;
            te[4] = -c * f;
            te[8] = d;
            te[1] = af + be * d;
            te[5] = ae - bf * d;
            te[9] = -b * c;
            te[2] = bf - ae * d;
            te[6] = be + af * d;
            te[10] = a * c;
        } else if (euler.order === "YXZ") {
            var ce = c * e, cf = c * f, de = d * e, df = d * f;
            te[0] = ce + df * b;
            te[4] = de * b - cf;
            te[8] = a * d;
            te[1] = a * f;
            te[5] = a * e;
            te[9] = -b;
            te[2] = cf * b - de;
            te[6] = df + ce * b;
            te[10] = a * c;
        } else if (euler.order === "ZXY") {
            var ce = c * e, cf = c * f, de = d * e, df = d * f;
            te[0] = ce - df * b;
            te[4] = -a * f;
            te[8] = de + cf * b;
            te[1] = cf + de * b;
            te[5] = a * e;
            te[9] = df - ce * b;
            te[2] = -a * d;
            te[6] = b;
            te[10] = a * c;
        } else if (euler.order === "ZYX") {
            var ae = a * e, af = a * f, be = b * e, bf = b * f;
            te[0] = c * e;
            te[4] = be * d - af;
            te[8] = ae * d + bf;
            te[1] = c * f;
            te[5] = bf * d + ae;
            te[9] = af * d - be;
            te[2] = -d;
            te[6] = b * c;
            te[10] = a * c;
        } else if (euler.order === "YZX") {
            var ac = a * c, ad = a * d, bc = b * c, bd = b * d;
            te[0] = c * e;
            te[4] = bd - ac * f;
            te[8] = bc * f + ad;
            te[1] = f;
            te[5] = a * e;
            te[9] = -b * e;
            te[2] = -d * e;
            te[6] = ad * f + bc;
            te[10] = ac - bd * f;
        } else if (euler.order === "XZY") {
            var ac = a * c, ad = a * d, bc = b * c, bd = b * d;
            te[0] = c * e;
            te[4] = -f;
            te[8] = d * e;
            te[1] = ac * f + bd;
            te[5] = a * e;
            te[9] = ad * f - bc;
            te[2] = bc * f - ad;
            te[6] = b * e;
            te[10] = bd * f + ac;
        } // bottom row
        te[3] = 0;
        te[7] = 0;
        te[11] = 0; // last column
        te[12] = 0;
        te[13] = 0;
        te[14] = 0;
        te[15] = 1;
        return this;
    },
    makeRotationFromQuaternion: function() {
        var zero = new (0, $085a6d802029f140$export$64b5c384219d3699)(0, 0, 0);
        var one = new (0, $085a6d802029f140$export$64b5c384219d3699)(1, 1, 1);
        return function makeRotationFromQuaternion(q) {
            return this.compose(zero, q, one);
        };
    }(),
    lookAt: function() {
        var x = new (0, $085a6d802029f140$export$64b5c384219d3699)();
        var y = new (0, $085a6d802029f140$export$64b5c384219d3699)();
        var z = new (0, $085a6d802029f140$export$64b5c384219d3699)();
        return function lookAt(eye, target, up) {
            var te = this.elements;
            z.subVectors(eye, target);
            if (z.lengthSq() === 0) // eye and target are in the same position
            z.z = 1;
            z.normalize();
            x.crossVectors(up, z);
            if (x.lengthSq() === 0) {
                // up and z are parallel
                if (Math.abs(up.z) === 1) z.x += 0.0001;
                else z.z += 0.0001;
                z.normalize();
                x.crossVectors(up, z);
            }
            x.normalize();
            y.crossVectors(z, x);
            te[0] = x.x;
            te[4] = y.x;
            te[8] = z.x;
            te[1] = x.y;
            te[5] = y.y;
            te[9] = z.y;
            te[2] = x.z;
            te[6] = y.z;
            te[10] = z.z;
            return this;
        };
    }(),
    multiply: function(m, n) {
        if (n !== undefined) {
            console.warn("THREE.Matrix4: .multiply() now only accepts one argument. Use .multiplyMatrices( a, b ) instead.");
            return this.multiplyMatrices(m, n);
        }
        return this.multiplyMatrices(this, m);
    },
    premultiply: function(m) {
        return this.multiplyMatrices(m, this);
    },
    multiplyMatrices: function(a, b) {
        var ae = a.elements;
        var be = b.elements;
        var te = this.elements;
        var a11 = ae[0], a12 = ae[4], a13 = ae[8], a14 = ae[12];
        var a21 = ae[1], a22 = ae[5], a23 = ae[9], a24 = ae[13];
        var a31 = ae[2], a32 = ae[6], a33 = ae[10], a34 = ae[14];
        var a41 = ae[3], a42 = ae[7], a43 = ae[11], a44 = ae[15];
        var b11 = be[0], b12 = be[4], b13 = be[8], b14 = be[12];
        var b21 = be[1], b22 = be[5], b23 = be[9], b24 = be[13];
        var b31 = be[2], b32 = be[6], b33 = be[10], b34 = be[14];
        var b41 = be[3], b42 = be[7], b43 = be[11], b44 = be[15];
        te[0] = a11 * b11 + a12 * b21 + a13 * b31 + a14 * b41;
        te[4] = a11 * b12 + a12 * b22 + a13 * b32 + a14 * b42;
        te[8] = a11 * b13 + a12 * b23 + a13 * b33 + a14 * b43;
        te[12] = a11 * b14 + a12 * b24 + a13 * b34 + a14 * b44;
        te[1] = a21 * b11 + a22 * b21 + a23 * b31 + a24 * b41;
        te[5] = a21 * b12 + a22 * b22 + a23 * b32 + a24 * b42;
        te[9] = a21 * b13 + a22 * b23 + a23 * b33 + a24 * b43;
        te[13] = a21 * b14 + a22 * b24 + a23 * b34 + a24 * b44;
        te[2] = a31 * b11 + a32 * b21 + a33 * b31 + a34 * b41;
        te[6] = a31 * b12 + a32 * b22 + a33 * b32 + a34 * b42;
        te[10] = a31 * b13 + a32 * b23 + a33 * b33 + a34 * b43;
        te[14] = a31 * b14 + a32 * b24 + a33 * b34 + a34 * b44;
        te[3] = a41 * b11 + a42 * b21 + a43 * b31 + a44 * b41;
        te[7] = a41 * b12 + a42 * b22 + a43 * b32 + a44 * b42;
        te[11] = a41 * b13 + a42 * b23 + a43 * b33 + a44 * b43;
        te[15] = a41 * b14 + a42 * b24 + a43 * b34 + a44 * b44;
        return this;
    },
    multiplyScalar: function(s) {
        var te = this.elements;
        te[0] *= s;
        te[4] *= s;
        te[8] *= s;
        te[12] *= s;
        te[1] *= s;
        te[5] *= s;
        te[9] *= s;
        te[13] *= s;
        te[2] *= s;
        te[6] *= s;
        te[10] *= s;
        te[14] *= s;
        te[3] *= s;
        te[7] *= s;
        te[11] *= s;
        te[15] *= s;
        return this;
    },
    applyToBufferAttribute: function() {
        var v1 = new (0, $085a6d802029f140$export$64b5c384219d3699)();
        return function applyToBufferAttribute(attribute) {
            for(var i = 0, l = attribute.count; i < l; i++){
                v1.x = attribute.getX(i);
                v1.y = attribute.getY(i);
                v1.z = attribute.getZ(i);
                v1.applyMatrix4(this);
                attribute.setXYZ(i, v1.x, v1.y, v1.z);
            }
            return attribute;
        };
    }(),
    determinant: function() {
        var te = this.elements;
        var n11 = te[0], n12 = te[4], n13 = te[8], n14 = te[12];
        var n21 = te[1], n22 = te[5], n23 = te[9], n24 = te[13];
        var n31 = te[2], n32 = te[6], n33 = te[10], n34 = te[14];
        var n41 = te[3], n42 = te[7], n43 = te[11], n44 = te[15]; //TODO: make this more efficient
        //( based on http://www.euclideanspace.com/maths/algebra/matrix/functions/inverse/fourD/index.htm )
        return n41 * (+n14 * n23 * n32 - n13 * n24 * n32 - n14 * n22 * n33 + n12 * n24 * n33 + n13 * n22 * n34 - n12 * n23 * n34) + n42 * (+n11 * n23 * n34 - n11 * n24 * n33 + n14 * n21 * n33 - n13 * n21 * n34 + n13 * n24 * n31 - n14 * n23 * n31) + n43 * (+n11 * n24 * n32 - n11 * n22 * n34 - n14 * n21 * n32 + n12 * n21 * n34 + n14 * n22 * n31 - n12 * n24 * n31) + n44 * (-n13 * n22 * n31 - n11 * n23 * n32 + n11 * n22 * n33 + n13 * n21 * n32 - n12 * n21 * n33 + n12 * n23 * n31);
    },
    transpose: function() {
        var te = this.elements;
        var tmp;
        tmp = te[1];
        te[1] = te[4];
        te[4] = tmp;
        tmp = te[2];
        te[2] = te[8];
        te[8] = tmp;
        tmp = te[6];
        te[6] = te[9];
        te[9] = tmp;
        tmp = te[3];
        te[3] = te[12];
        te[12] = tmp;
        tmp = te[7];
        te[7] = te[13];
        te[13] = tmp;
        tmp = te[11];
        te[11] = te[14];
        te[14] = tmp;
        return this;
    },
    setPosition: function(x, y, z) {
        var te = this.elements;
        if (x.isVector3) {
            te[12] = x.x;
            te[13] = x.y;
            te[14] = x.z;
        } else {
            te[12] = x;
            te[13] = y;
            te[14] = z;
        }
        return this;
    },
    getInverse: function(m, throwOnDegenerate) {
        // based on http://www.euclideanspace.com/maths/algebra/matrix/functions/inverse/fourD/index.htm
        var te = this.elements, me = m.elements, n11 = me[0], n21 = me[1], n31 = me[2], n41 = me[3], n12 = me[4], n22 = me[5], n32 = me[6], n42 = me[7], n13 = me[8], n23 = me[9], n33 = me[10], n43 = me[11], n14 = me[12], n24 = me[13], n34 = me[14], n44 = me[15], t11 = n23 * n34 * n42 - n24 * n33 * n42 + n24 * n32 * n43 - n22 * n34 * n43 - n23 * n32 * n44 + n22 * n33 * n44, t12 = n14 * n33 * n42 - n13 * n34 * n42 - n14 * n32 * n43 + n12 * n34 * n43 + n13 * n32 * n44 - n12 * n33 * n44, t13 = n13 * n24 * n42 - n14 * n23 * n42 + n14 * n22 * n43 - n12 * n24 * n43 - n13 * n22 * n44 + n12 * n23 * n44, t14 = n14 * n23 * n32 - n13 * n24 * n32 - n14 * n22 * n33 + n12 * n24 * n33 + n13 * n22 * n34 - n12 * n23 * n34;
        var det = n11 * t11 + n21 * t12 + n31 * t13 + n41 * t14;
        if (det === 0) {
            var msg = "THREE.Matrix4: .getInverse() can't invert matrix, determinant is 0";
            if (throwOnDegenerate === true) throw new Error(msg);
            else console.warn(msg);
            return this.identity();
        }
        var detInv = 1 / det;
        te[0] = t11 * detInv;
        te[1] = (n24 * n33 * n41 - n23 * n34 * n41 - n24 * n31 * n43 + n21 * n34 * n43 + n23 * n31 * n44 - n21 * n33 * n44) * detInv;
        te[2] = (n22 * n34 * n41 - n24 * n32 * n41 + n24 * n31 * n42 - n21 * n34 * n42 - n22 * n31 * n44 + n21 * n32 * n44) * detInv;
        te[3] = (n23 * n32 * n41 - n22 * n33 * n41 - n23 * n31 * n42 + n21 * n33 * n42 + n22 * n31 * n43 - n21 * n32 * n43) * detInv;
        te[4] = t12 * detInv;
        te[5] = (n13 * n34 * n41 - n14 * n33 * n41 + n14 * n31 * n43 - n11 * n34 * n43 - n13 * n31 * n44 + n11 * n33 * n44) * detInv;
        te[6] = (n14 * n32 * n41 - n12 * n34 * n41 - n14 * n31 * n42 + n11 * n34 * n42 + n12 * n31 * n44 - n11 * n32 * n44) * detInv;
        te[7] = (n12 * n33 * n41 - n13 * n32 * n41 + n13 * n31 * n42 - n11 * n33 * n42 - n12 * n31 * n43 + n11 * n32 * n43) * detInv;
        te[8] = t13 * detInv;
        te[9] = (n14 * n23 * n41 - n13 * n24 * n41 - n14 * n21 * n43 + n11 * n24 * n43 + n13 * n21 * n44 - n11 * n23 * n44) * detInv;
        te[10] = (n12 * n24 * n41 - n14 * n22 * n41 + n14 * n21 * n42 - n11 * n24 * n42 - n12 * n21 * n44 + n11 * n22 * n44) * detInv;
        te[11] = (n13 * n22 * n41 - n12 * n23 * n41 - n13 * n21 * n42 + n11 * n23 * n42 + n12 * n21 * n43 - n11 * n22 * n43) * detInv;
        te[12] = t14 * detInv;
        te[13] = (n13 * n24 * n31 - n14 * n23 * n31 + n14 * n21 * n33 - n11 * n24 * n33 - n13 * n21 * n34 + n11 * n23 * n34) * detInv;
        te[14] = (n14 * n22 * n31 - n12 * n24 * n31 - n14 * n21 * n32 + n11 * n24 * n32 + n12 * n21 * n34 - n11 * n22 * n34) * detInv;
        te[15] = (n12 * n23 * n31 - n13 * n22 * n31 + n13 * n21 * n32 - n11 * n23 * n32 - n12 * n21 * n33 + n11 * n22 * n33) * detInv;
        return this;
    },
    scale: function(v) {
        var te = this.elements;
        var x = v.x, y = v.y, z = v.z;
        te[0] *= x;
        te[4] *= y;
        te[8] *= z;
        te[1] *= x;
        te[5] *= y;
        te[9] *= z;
        te[2] *= x;
        te[6] *= y;
        te[10] *= z;
        te[3] *= x;
        te[7] *= y;
        te[11] *= z;
        return this;
    },
    getMaxScaleOnAxis: function() {
        var te = this.elements;
        var scaleXSq = te[0] * te[0] + te[1] * te[1] + te[2] * te[2];
        var scaleYSq = te[4] * te[4] + te[5] * te[5] + te[6] * te[6];
        var scaleZSq = te[8] * te[8] + te[9] * te[9] + te[10] * te[10];
        return Math.sqrt(Math.max(scaleXSq, scaleYSq, scaleZSq));
    },
    makeTranslation: function(x, y, z) {
        this.set(1, 0, 0, x, 0, 1, 0, y, 0, 0, 1, z, 0, 0, 0, 1);
        return this;
    },
    makeRotationX: function(theta) {
        var c = Math.cos(theta), s = Math.sin(theta);
        this.set(1, 0, 0, 0, 0, c, -s, 0, 0, s, c, 0, 0, 0, 0, 1);
        return this;
    },
    makeRotationY: function(theta) {
        var c = Math.cos(theta), s = Math.sin(theta);
        this.set(c, 0, s, 0, 0, 1, 0, 0, -s, 0, c, 0, 0, 0, 0, 1);
        return this;
    },
    makeRotationZ: function(theta) {
        var c = Math.cos(theta), s = Math.sin(theta);
        this.set(c, -s, 0, 0, s, c, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
        return this;
    },
    makeRotationAxis: function(axis, angle) {
        // Based on http://www.gamedev.net/reference/articles/article1199.asp
        var c = Math.cos(angle);
        var s = Math.sin(angle);
        var t = 1 - c;
        var x = axis.x, y = axis.y, z = axis.z;
        var tx = t * x, ty = t * y;
        this.set(tx * x + c, tx * y - s * z, tx * z + s * y, 0, tx * y + s * z, ty * y + c, ty * z - s * x, 0, tx * z - s * y, ty * z + s * x, t * z * z + c, 0, 0, 0, 0, 1);
        return this;
    },
    makeScale: function(x, y, z) {
        this.set(x, 0, 0, 0, 0, y, 0, 0, 0, 0, z, 0, 0, 0, 0, 1);
        return this;
    },
    makeShear: function(x, y, z) {
        this.set(1, y, z, 0, x, 1, z, 0, x, y, 1, 0, 0, 0, 0, 1);
        return this;
    },
    compose: function(position, quaternion, scale) {
        var te = this.elements;
        var x = quaternion._x, y = quaternion._y, z = quaternion._z, w = quaternion._w;
        var x2 = x + x, y2 = y + y, z2 = z + z;
        var xx = x * x2, xy = x * y2, xz = x * z2;
        var yy = y * y2, yz = y * z2, zz = z * z2;
        var wx = w * x2, wy = w * y2, wz = w * z2;
        var sx = scale.x, sy = scale.y, sz = scale.z;
        te[0] = (1 - (yy + zz)) * sx;
        te[1] = (xy + wz) * sx;
        te[2] = (xz - wy) * sx;
        te[3] = 0;
        te[4] = (xy - wz) * sy;
        te[5] = (1 - (xx + zz)) * sy;
        te[6] = (yz + wx) * sy;
        te[7] = 0;
        te[8] = (xz + wy) * sz;
        te[9] = (yz - wx) * sz;
        te[10] = (1 - (xx + yy)) * sz;
        te[11] = 0;
        te[12] = position.x;
        te[13] = position.y;
        te[14] = position.z;
        te[15] = 1;
        return this;
    },
    decompose: function() {
        var vector = new (0, $085a6d802029f140$export$64b5c384219d3699)();
        var matrix = new $95f8a63608f1c552$export$2ae72fc923e5eb5();
        return function decompose(position, quaternion, scale) {
            var te = this.elements;
            var sx = vector.set(te[0], te[1], te[2]).length();
            var sy = vector.set(te[4], te[5], te[6]).length();
            var sz = vector.set(te[8], te[9], te[10]).length(); // if determine is negative, we need to invert one scale
            var det = this.determinant();
            if (det < 0) sx = -sx;
            position.x = te[12];
            position.y = te[13];
            position.z = te[14]; // scale the rotation part
            matrix.copy(this);
            var invSX = 1 / sx;
            var invSY = 1 / sy;
            var invSZ = 1 / sz;
            matrix.elements[0] *= invSX;
            matrix.elements[1] *= invSX;
            matrix.elements[2] *= invSX;
            matrix.elements[4] *= invSY;
            matrix.elements[5] *= invSY;
            matrix.elements[6] *= invSY;
            matrix.elements[8] *= invSZ;
            matrix.elements[9] *= invSZ;
            matrix.elements[10] *= invSZ;
            quaternion.setFromRotationMatrix(matrix);
            scale.x = sx;
            scale.y = sy;
            scale.z = sz;
            return this;
        };
    }(),
    makePerspective: function(left, right, top, bottom, near, far) {
        if (far === undefined) console.warn("THREE.Matrix4: .makePerspective() has been redefined and has a new signature. Please check the docs.");
        var te = this.elements;
        var x = 2 * near / (right - left);
        var y = 2 * near / (top - bottom);
        var a = (right + left) / (right - left);
        var b = (top + bottom) / (top - bottom);
        var c = -(far + near) / (far - near);
        var d = -2 * far * near / (far - near);
        te[0] = x;
        te[4] = 0;
        te[8] = a;
        te[12] = 0;
        te[1] = 0;
        te[5] = y;
        te[9] = b;
        te[13] = 0;
        te[2] = 0;
        te[6] = 0;
        te[10] = c;
        te[14] = d;
        te[3] = 0;
        te[7] = 0;
        te[11] = -1;
        te[15] = 0;
        return this;
    },
    makeOrthographic: function(left, right, top, bottom, near, far) {
        var te = this.elements;
        var w = 1.0 / (right - left);
        var h = 1.0 / (top - bottom);
        var p = 1.0 / (far - near);
        var x = (right + left) * w;
        var y = (top + bottom) * h;
        var z = (far + near) * p;
        te[0] = 2 * w;
        te[4] = 0;
        te[8] = 0;
        te[12] = -x;
        te[1] = 0;
        te[5] = 2 * h;
        te[9] = 0;
        te[13] = -y;
        te[2] = 0;
        te[6] = 0;
        te[10] = -2 * p;
        te[14] = -z;
        te[3] = 0;
        te[7] = 0;
        te[11] = 0;
        te[15] = 1;
        return this;
    },
    equals: function(matrix) {
        var te = this.elements;
        var me = matrix.elements;
        for(var i = 0; i < 16; i++){
            if (te[i] !== me[i]) return false;
        }
        return true;
    },
    fromArray: function(array, offset) {
        if (offset === undefined) offset = 0;
        for(var i = 0; i < 16; i++)this.elements[i] = array[i + offset];
        return this;
    },
    toArray: function(array, offset) {
        if (array === undefined) array = [];
        if (offset === undefined) offset = 0;
        var te = this.elements;
        array[offset] = te[0];
        array[offset + 1] = te[1];
        array[offset + 2] = te[2];
        array[offset + 3] = te[3];
        array[offset + 4] = te[4];
        array[offset + 5] = te[5];
        array[offset + 6] = te[6];
        array[offset + 7] = te[7];
        array[offset + 8] = te[8];
        array[offset + 9] = te[9];
        array[offset + 10] = te[10];
        array[offset + 11] = te[11];
        array[offset + 12] = te[12];
        array[offset + 13] = te[13];
        array[offset + 14] = te[14];
        array[offset + 15] = te[15];
        return array;
    }
});



/**
 * @author mrdoob / http://mrdoob.com/
 * @author WestLangley / http://github.com/WestLangley
 * @author bhouston / http://clara.io
 */ function $db34e7d28bab253d$export$d93cc409a0768c5f(x, y, z, order) {
    this._x = x || 0;
    this._y = y || 0;
    this._z = z || 0;
    this._order = order || $db34e7d28bab253d$export$d93cc409a0768c5f.DefaultOrder;
}
$db34e7d28bab253d$export$d93cc409a0768c5f.RotationOrders = [
    "XYZ",
    "YZX",
    "ZXY",
    "XZY",
    "YXZ",
    "ZYX"
];
$db34e7d28bab253d$export$d93cc409a0768c5f.DefaultOrder = "XYZ";
Object.defineProperties($db34e7d28bab253d$export$d93cc409a0768c5f.prototype, {
    x: {
        get: function() {
            return this._x;
        },
        set: function(value) {
            this._x = value;
            this._onChangeCallback();
        }
    },
    y: {
        get: function() {
            return this._y;
        },
        set: function(value) {
            this._y = value;
            this._onChangeCallback();
        }
    },
    z: {
        get: function() {
            return this._z;
        },
        set: function(value) {
            this._z = value;
            this._onChangeCallback();
        }
    },
    order: {
        get: function() {
            return this._order;
        },
        set: function(value) {
            this._order = value;
            this._onChangeCallback();
        }
    }
});
Object.assign($db34e7d28bab253d$export$d93cc409a0768c5f.prototype, {
    isEuler: true,
    set: function(x, y, z, order) {
        this._x = x;
        this._y = y;
        this._z = z;
        this._order = order || this._order;
        this._onChangeCallback();
        return this;
    },
    clone: function() {
        return new this.constructor(this._x, this._y, this._z, this._order);
    },
    copy: function(euler) {
        this._x = euler._x;
        this._y = euler._y;
        this._z = euler._z;
        this._order = euler._order;
        this._onChangeCallback();
        return this;
    },
    setFromRotationMatrix: function(m, order, update) {
        var clamp = (0, $5e7b16e81687ccbd$export$23e630a4917fd6ad).clamp; // assumes the upper 3x3 of m is a pure rotation matrix (i.e, unscaled)
        var te = m.elements;
        var m11 = te[0], m12 = te[4], m13 = te[8];
        var m21 = te[1], m22 = te[5], m23 = te[9];
        var m31 = te[2], m32 = te[6], m33 = te[10];
        order = order || this._order;
        if (order === "XYZ") {
            this._y = Math.asin(clamp(m13, -1, 1));
            if (Math.abs(m13) < 0.99999) {
                this._x = Math.atan2(-m23, m33);
                this._z = Math.atan2(-m12, m11);
            } else {
                this._x = Math.atan2(m32, m22);
                this._z = 0;
            }
        } else if (order === "YXZ") {
            this._x = Math.asin(-clamp(m23, -1, 1));
            if (Math.abs(m23) < 0.99999) {
                this._y = Math.atan2(m13, m33);
                this._z = Math.atan2(m21, m22);
            } else {
                this._y = Math.atan2(-m31, m11);
                this._z = 0;
            }
        } else if (order === "ZXY") {
            this._x = Math.asin(clamp(m32, -1, 1));
            if (Math.abs(m32) < 0.99999) {
                this._y = Math.atan2(-m31, m33);
                this._z = Math.atan2(-m12, m22);
            } else {
                this._y = 0;
                this._z = Math.atan2(m21, m11);
            }
        } else if (order === "ZYX") {
            this._y = Math.asin(-clamp(m31, -1, 1));
            if (Math.abs(m31) < 0.99999) {
                this._x = Math.atan2(m32, m33);
                this._z = Math.atan2(m21, m11);
            } else {
                this._x = 0;
                this._z = Math.atan2(-m12, m22);
            }
        } else if (order === "YZX") {
            this._z = Math.asin(clamp(m21, -1, 1));
            if (Math.abs(m21) < 0.99999) {
                this._x = Math.atan2(-m23, m22);
                this._y = Math.atan2(-m31, m11);
            } else {
                this._x = 0;
                this._y = Math.atan2(m13, m33);
            }
        } else if (order === "XZY") {
            this._z = Math.asin(-clamp(m12, -1, 1));
            if (Math.abs(m12) < 0.99999) {
                this._x = Math.atan2(m32, m22);
                this._y = Math.atan2(m13, m11);
            } else {
                this._x = Math.atan2(-m23, m33);
                this._y = 0;
            }
        } else console.warn("THREE.Euler: .setFromRotationMatrix() given unsupported order: " + order);
        this._order = order;
        if (update !== false) this._onChangeCallback();
        return this;
    },
    setFromQuaternion: function() {
        var matrix = new (0, $95f8a63608f1c552$export$2ae72fc923e5eb5)();
        return function setFromQuaternion(q, order, update) {
            matrix.makeRotationFromQuaternion(q);
            return this.setFromRotationMatrix(matrix, order, update);
        };
    }(),
    setFromVector3: function(v, order) {
        return this.set(v.x, v.y, v.z, order || this._order);
    },
    reorder: function() {
        // WARNING: this discards revolution information -bhouston
        var q = new (0, $dfc0b360f8939fec$export$23d6a54f0bbc85a3)();
        return function reorder(newOrder) {
            q.setFromEuler(this);
            return this.setFromQuaternion(q, newOrder);
        };
    }(),
    equals: function(euler) {
        return euler._x === this._x && euler._y === this._y && euler._z === this._z && euler._order === this._order;
    },
    fromArray: function(array) {
        this._x = array[0];
        this._y = array[1];
        this._z = array[2];
        if (array[3] !== undefined) this._order = array[3];
        this._onChangeCallback();
        return this;
    },
    toArray: function(array, offset) {
        if (array === undefined) array = [];
        if (offset === undefined) offset = 0;
        array[offset] = this._x;
        array[offset + 1] = this._y;
        array[offset + 2] = this._z;
        array[offset + 3] = this._order;
        return array;
    },
    toVector3: function(optionalResult) {
        if (optionalResult) return optionalResult.set(this._x, this._y, this._z);
        else return new (0, $085a6d802029f140$export$64b5c384219d3699)(this._x, this._y, this._z);
    },
    _onChange: function(callback) {
        this._onChangeCallback = callback;
        return this;
    },
    _onChangeCallback: function() {}
});


var $a34f8048fbd5bdd3$export$3545e07a80636437 = "106";
var $a34f8048fbd5bdd3$export$7177b3e430c2d7ca = {
    LEFT: 0,
    MIDDLE: 1,
    RIGHT: 2
};
var $a34f8048fbd5bdd3$export$3237e1f2c1ea1f44 = 0;
var $a34f8048fbd5bdd3$export$b9a7b4fc5cb15f9b = 1;
var $a34f8048fbd5bdd3$export$b8058bcc7037d3f3 = 2;
var $a34f8048fbd5bdd3$export$f24be24dcddeac0d = 3;
var $a34f8048fbd5bdd3$export$26572b1037dca59a = 0;
var $a34f8048fbd5bdd3$export$eb871402b6345035 = 1;
var $a34f8048fbd5bdd3$export$346307dbae2b7447 = 0;
var $a34f8048fbd5bdd3$export$5813f879eee7cd88 = 1;
var $a34f8048fbd5bdd3$export$a47c4b43a1be34f0 = 2;
var $a34f8048fbd5bdd3$export$2ede184fc2998901 = 0;
var $a34f8048fbd5bdd3$export$d9f0486e75b5ace = 1;
var $a34f8048fbd5bdd3$export$3b296b6f144d5b03 = 2;
var $a34f8048fbd5bdd3$export$a62047d29c96d8ff = 1;
var $a34f8048fbd5bdd3$export$fadb74c06a7f490 = 2;
var $a34f8048fbd5bdd3$export$1a5c46edbdc9a5b7 = 0;
var $a34f8048fbd5bdd3$export$617e978cc3201d85 = 1;
var $a34f8048fbd5bdd3$export$969ede3d37172881 = 2;
var $a34f8048fbd5bdd3$export$63b8d6b580fc65ba = 0;
var $a34f8048fbd5bdd3$export$5b29a26d96ee6af0 = 1;
var $a34f8048fbd5bdd3$export$777d8f9551c2216b = 2;
var $a34f8048fbd5bdd3$export$cdfa06f868e2e467 = 3;
var $a34f8048fbd5bdd3$export$4138e1c684b46a20 = 4;
var $a34f8048fbd5bdd3$export$eda4864c68df1fa2 = 5;
var $a34f8048fbd5bdd3$export$20183a0484ce21a0 = 100;
var $a34f8048fbd5bdd3$export$73e0df5177988548 = 101;
var $a34f8048fbd5bdd3$export$28e582859cbec660 = 102;
var $a34f8048fbd5bdd3$export$c8c1508da8d0600c = 103;
var $a34f8048fbd5bdd3$export$99948c02fb51055f = 104;
var $a34f8048fbd5bdd3$export$2110f05edf778d3d = 200;
var $a34f8048fbd5bdd3$export$8805bad65e24940e = 201;
var $a34f8048fbd5bdd3$export$7fbe15b28d28cf52 = 202;
var $a34f8048fbd5bdd3$export$947829af9f2c17f6 = 203;
var $a34f8048fbd5bdd3$export$d5773124e86cf28c = 204;
var $a34f8048fbd5bdd3$export$11d468cc7f19e971 = 205;
var $a34f8048fbd5bdd3$export$a78aed1ca2a87192 = 206;
var $a34f8048fbd5bdd3$export$5d0fe17fd8773bac = 207;
var $a34f8048fbd5bdd3$export$ef5f2dd8ffac5574 = 208;
var $a34f8048fbd5bdd3$export$56b85b2686ab16 = 209;
var $a34f8048fbd5bdd3$export$c05e2a1fc8609506 = 210;
var $a34f8048fbd5bdd3$export$69025ce147cee220 = 0;
var $a34f8048fbd5bdd3$export$7182eb52ea3b3f04 = 1;
var $a34f8048fbd5bdd3$export$eedccec66ab7ebe = 2;
var $a34f8048fbd5bdd3$export$296f78a0b892f81a = 3;
var $a34f8048fbd5bdd3$export$a60d398fc7b7590e = 4;
var $a34f8048fbd5bdd3$export$7d7234c1240a1fc4 = 5;
var $a34f8048fbd5bdd3$export$c5e2c52991f30937 = 6;
var $a34f8048fbd5bdd3$export$2f843afa843d8916 = 7;
var $a34f8048fbd5bdd3$export$e50ac29801f1774d = 0;
var $a34f8048fbd5bdd3$export$9f9d94f963c85479 = 1;
var $a34f8048fbd5bdd3$export$e641dc52bc3494aa = 2;
var $a34f8048fbd5bdd3$export$9fcb6b4294603b2 = 0;
var $a34f8048fbd5bdd3$export$98f52c2a46c598ca = 1;
var $a34f8048fbd5bdd3$export$74b25e54b3bcd548 = 2;
var $a34f8048fbd5bdd3$export$4ef8f05fff4fa871 = 3;
var $a34f8048fbd5bdd3$export$932b3dd283d4a366 = 4;
var $a34f8048fbd5bdd3$export$a0d98fe6d7e4af64 = 5;
var $a34f8048fbd5bdd3$export$1beec6768cbb3d2d = 300;
var $a34f8048fbd5bdd3$export$8759762a6477f2c4 = 301;
var $a34f8048fbd5bdd3$export$dc59f8aed047f61d = 302;
var $a34f8048fbd5bdd3$export$d64030b316d3b087 = 303;
var $a34f8048fbd5bdd3$export$ee99d97d46898098 = 304;
var $a34f8048fbd5bdd3$export$b30b5cd75be9563d = 305;
var $a34f8048fbd5bdd3$export$dbf3e70ff37af79 = 306;
var $a34f8048fbd5bdd3$export$76a9f4355364345c = 307;
var $a34f8048fbd5bdd3$export$533346c8e8dac0f5 = 1000;
var $a34f8048fbd5bdd3$export$9d9334239a5a5e06 = 1001;
var $a34f8048fbd5bdd3$export$c7e7c00b14f51a4f = 1002;
var $a34f8048fbd5bdd3$export$727aa5ec3fe39bf0 = 1003;
var $a34f8048fbd5bdd3$export$14a4936464a36496 = 1004;
var $a34f8048fbd5bdd3$export$cbc5b7f5647595d8 = 1005;
var $a34f8048fbd5bdd3$export$8a72f490b25c56c8 = 1006;
var $a34f8048fbd5bdd3$export$dbe96bee3fe9dbf0 = 1007;
var $a34f8048fbd5bdd3$export$90d80f1e3506775f = 1008;
var $a34f8048fbd5bdd3$export$2e8ce08d3f6f5e10 = 1009;
var $a34f8048fbd5bdd3$export$545fce0311a9796a = 1010;
var $a34f8048fbd5bdd3$export$88572337f312435f = 1011;
var $a34f8048fbd5bdd3$export$c63dc51868b06a9d = 1012;
var $a34f8048fbd5bdd3$export$5c612977753abe2 = 1013;
var $a34f8048fbd5bdd3$export$c3c7fc4518ebba96 = 1014;
var $a34f8048fbd5bdd3$export$f6d331659b644596 = 1015;
var $a34f8048fbd5bdd3$export$2697304443f382bc = 1016;
var $a34f8048fbd5bdd3$export$b3969b01faf587f2 = 1017;
var $a34f8048fbd5bdd3$export$18886f8ae33e90de = 1018;
var $a34f8048fbd5bdd3$export$cb1fa50553eb14c4 = 1019;
var $a34f8048fbd5bdd3$export$6c8ea339bfab1301 = 1020;
var $a34f8048fbd5bdd3$export$988473390501ed4b = 1021;
var $a34f8048fbd5bdd3$export$7c67423a5ee6f5eb = 1022;
var $a34f8048fbd5bdd3$export$3f8bb04b555a363c = 1023;
var $a34f8048fbd5bdd3$export$cc09ccbf6d1ed449 = 1024;
var $a34f8048fbd5bdd3$export$9053a81c4a69c289 = 1025;
var $a34f8048fbd5bdd3$export$7f419e36e2229a1d = $a34f8048fbd5bdd3$export$3f8bb04b555a363c;
var $a34f8048fbd5bdd3$export$c1b6b5136be58045 = 1026;
var $a34f8048fbd5bdd3$export$1e113ac2d0905829 = 1027;
var $a34f8048fbd5bdd3$export$4e041a7967d15c4b = 1028;
var $a34f8048fbd5bdd3$export$21d1799c6d552fc0 = 33776;
var $a34f8048fbd5bdd3$export$afa304c3e981b668 = 33777;
var $a34f8048fbd5bdd3$export$d2a1a68024a3e56c = 33778;
var $a34f8048fbd5bdd3$export$9a79c424327dacf9 = 33779;
var $a34f8048fbd5bdd3$export$19ada9bbb1af3573 = 35840;
var $a34f8048fbd5bdd3$export$d0f0355bb3d948e4 = 35841;
var $a34f8048fbd5bdd3$export$b82296714358084c = 35842;
var $a34f8048fbd5bdd3$export$b71692456c47b6c3 = 35843;
var $a34f8048fbd5bdd3$export$6ab91af2d757aee7 = 36196;
var $a34f8048fbd5bdd3$export$dc5570b4a2b92d48 = 37808;
var $a34f8048fbd5bdd3$export$68880cd325f8b2fb = 37809;
var $a34f8048fbd5bdd3$export$7d2c0be323373d95 = 37810;
var $a34f8048fbd5bdd3$export$22b52da301fc3a3e = 37811;
var $a34f8048fbd5bdd3$export$c009e2cb4a66485e = 37812;
var $a34f8048fbd5bdd3$export$118fff5afa255b63 = 37813;
var $a34f8048fbd5bdd3$export$120713c829ae0667 = 37814;
var $a34f8048fbd5bdd3$export$c79eeabbf53313e9 = 37815;
var $a34f8048fbd5bdd3$export$443cf6567cdd6424 = 37816;
var $a34f8048fbd5bdd3$export$6573984fc9840780 = 37817;
var $a34f8048fbd5bdd3$export$e7aee563f30091de = 37818;
var $a34f8048fbd5bdd3$export$2eb8634622ddeab7 = 37819;
var $a34f8048fbd5bdd3$export$202b1ce7b5d25742 = 37820;
var $a34f8048fbd5bdd3$export$18ab77abd087e467 = 37821;
var $a34f8048fbd5bdd3$export$d62fdc9d1b1cccad = 2200;
var $a34f8048fbd5bdd3$export$dfaf4422ce096e29 = 2201;
var $a34f8048fbd5bdd3$export$f8f6f2041b78e210 = 2202;
var $a34f8048fbd5bdd3$export$995b32462a65e855 = 2300;
var $a34f8048fbd5bdd3$export$30fac1aace31cf4d = 2301;
var $a34f8048fbd5bdd3$export$198b11ff4c72bb30 = 2302;
var $a34f8048fbd5bdd3$export$7f795934b84ab523 = 2400;
var $a34f8048fbd5bdd3$export$24a4ccb5099273b5 = 2401;
var $a34f8048fbd5bdd3$export$8e8c3ecdcd8e1fee = 2402;
var $a34f8048fbd5bdd3$export$4c28c87c2dc84758 = 0;
var $a34f8048fbd5bdd3$export$b23a071aa286eb29 = 1;
var $a34f8048fbd5bdd3$export$f0d8293634f88842 = 2;
var $a34f8048fbd5bdd3$export$7207336e4151a112 = 3000;
var $a34f8048fbd5bdd3$export$f32388edbb32674 = 3001;
var $a34f8048fbd5bdd3$export$eaab32c1bcea1817 = 3007;
var $a34f8048fbd5bdd3$export$3be4c466a12b5dcf = 3002;
var $a34f8048fbd5bdd3$export$8d4cbbeb1eea9f67 = 3003;
var $a34f8048fbd5bdd3$export$2c4bdfd76b188654 = 3004;
var $a34f8048fbd5bdd3$export$48a0051d6a5a9b9 = 3005;
var $a34f8048fbd5bdd3$export$ca2f89b13b49d951 = 3006;
var $a34f8048fbd5bdd3$export$deeb383078690b50 = 3200;
var $a34f8048fbd5bdd3$export$8f910f4c4f73df11 = 3201;
var $a34f8048fbd5bdd3$export$2852a58ebdac27b8 = 0;
var $a34f8048fbd5bdd3$export$9990ad26f9db5b2c = 1;




var $2e283c7833e9635b$export$2e2bcd8739ae039 = {
    toScreenPos: function() {
        var vector = new (0, $085a6d802029f140$export$64b5c384219d3699)();
        return function(pos, camera, canvas) {
            vector.copy(pos); // map to normalized device coordinate (NDC) space
            vector.project(camera); // map to 2D screen space
            vector.x = Math.round((vector.x + 1) * canvas.width / 2);
            vector.y = Math.round((-vector.y + 1) * canvas.height / 2);
            vector.z = 0;
            return vector;
        };
    }(),
    toSpacePos: function() {
        var vector = new (0, $085a6d802029f140$export$64b5c384219d3699)(), dir = new (0, $085a6d802029f140$export$64b5c384219d3699)(), distance;
        return function(pos, camera, canvas) {
            vector.set(pos.x / canvas.width * 2 - 1, -(pos.y / canvas.height) * 2 + 1, 0.5);
            vector.unproject(camera);
            dir.copy(vector.sub(camera.position).normalize());
            distance = -camera.position.z / dir.z;
            vector.copy(camera.position);
            vector.add(dir.multiplyScalar(distance));
            return vector;
        };
    }()
};


var $23c21dd81897876b$export$2e2bcd8739ae039 = {
    initValue: function(value, defaults) {
        var _value = value != null && value != undefined ? value : defaults;
        return _value;
    },
    isArray: function(value) {
        return Object.prototype.toString.call(value) === "[object Array]";
    },
    destroyArray: function(array) {
        array.length = 0;
    },
    destroyObject: function(obj) {
        for(var o in obj)delete obj[o];
    },
    isUndefined: function() {
        for(var id in arguments){
            var arg = arguments[id];
            if (arg !== undefined) return false;
        }
        return true;
    },
    setVectorByObj: function(target, pOBJ) {
        if (pOBJ["x"] !== undefined) target.position.x = pOBJ["x"];
        if (pOBJ["y"] !== undefined) target.position.y = pOBJ["y"];
        if (pOBJ["z"] !== undefined) target.position.z = pOBJ["z"];
        if (pOBJ["vx"] !== undefined) target.velocity.x = pOBJ["vx"];
        if (pOBJ["vy"] !== undefined) target.velocity.y = pOBJ["vy"];
        if (pOBJ["vz"] !== undefined) target.velocity.z = pOBJ["vz"];
        if (pOBJ["ax"] !== undefined) target.acceleration.x = pOBJ["ax"];
        if (pOBJ["ay"] !== undefined) target.acceleration.y = pOBJ["ay"];
        if (pOBJ["az"] !== undefined) target.acceleration.z = pOBJ["az"];
        if (pOBJ["p"] !== undefined) target.position.copy(pOBJ["p"]);
        if (pOBJ["v"] !== undefined) target.velocity.copy(pOBJ["v"]);
        if (pOBJ["a"] !== undefined) target.acceleration.copy(pOBJ["a"]);
        if (pOBJ["position"] !== undefined) target.position.copy(pOBJ["position"]);
        if (pOBJ["velocity"] !== undefined) target.velocity.copy(pOBJ["velocity"]);
        if (pOBJ["accelerate"] !== undefined) target.acceleration.copy(pOBJ["accelerate"]);
    },
    //set prototype
    setPrototypeByObj: function(target, proObj, filters) {
        for(var key in proObj)// eslint-disable-next-line no-prototype-builtins
        if (target.hasOwnProperty(key)) {
            if (filters) {
                if (filters.indexOf(key) < 0) target[key] = this._getValue(proObj[key]);
            } else target[key] = this._getValue(proObj[key]);
        }
        return target;
    },
    _getValue: function(pan) {
        if (pan.constructor.type === "Span") return pan.getValue();
        else return pan;
    }
};


var $170c74acdf993371$exports = {};
var $531859673df6bb70$exports = {};
// Unique ID creation requires a high quality random # generator.  In the
// browser this is a little complicated due to unknown quality of Math.random()
// and inconsistent support for the `crypto` API.  We do the best we can via
// feature-detection
// getRandomValues needs to be invoked in a context where "this" is a Crypto
// implementation. Also, find the complete implementation of crypto on IE11.
var $531859673df6bb70$var$getRandomValues = typeof crypto != "undefined" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || typeof msCrypto != "undefined" && typeof window.msCrypto.getRandomValues == "function" && msCrypto.getRandomValues.bind(msCrypto);
if ($531859673df6bb70$var$getRandomValues) {
    // WHATWG crypto RNG - http://wiki.whatwg.org/wiki/Crypto
    var $531859673df6bb70$var$rnds8 = new Uint8Array(16); // eslint-disable-line no-undef
    $531859673df6bb70$exports = function whatwgRNG() {
        $531859673df6bb70$var$getRandomValues($531859673df6bb70$var$rnds8);
        return $531859673df6bb70$var$rnds8;
    };
} else {
    // Math.random()-based (RNG)
    //
    // If all else fails, use Math.random().  It's fast, but is of unspecified
    // quality.
    var $531859673df6bb70$var$rnds = new Array(16);
    $531859673df6bb70$exports = function mathRNG() {
        for(var i = 0, r; i < 16; i++){
            if ((i & 0x03) === 0) r = Math.random() * 0x100000000;
            $531859673df6bb70$var$rnds[i] = r >>> ((i & 0x03) << 3) & 0xff;
        }
        return $531859673df6bb70$var$rnds;
    };
}


var $9d606397c7f4e6df$exports = {};
/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */ var $9d606397c7f4e6df$var$byteToHex = [];
for(var $9d606397c7f4e6df$var$i = 0; $9d606397c7f4e6df$var$i < 256; ++$9d606397c7f4e6df$var$i)$9d606397c7f4e6df$var$byteToHex[$9d606397c7f4e6df$var$i] = ($9d606397c7f4e6df$var$i + 0x100).toString(16).substr(1);
function $9d606397c7f4e6df$var$bytesToUuid(buf, offset) {
    var i = offset || 0;
    var bth = $9d606397c7f4e6df$var$byteToHex;
    // join used to fix memory issue caused by concatenation: https://bugs.chromium.org/p/v8/issues/detail?id=3175#c4
    return [
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        "-",
        bth[buf[i++]],
        bth[buf[i++]],
        "-",
        bth[buf[i++]],
        bth[buf[i++]],
        "-",
        bth[buf[i++]],
        bth[buf[i++]],
        "-",
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]]
    ].join("");
}
$9d606397c7f4e6df$exports = $9d606397c7f4e6df$var$bytesToUuid;


// **`v1()` - Generate time-based UUID**
//
// Inspired by https://github.com/LiosK/UUID.js
// and http://docs.python.org/library/uuid.html
var $170c74acdf993371$var$_nodeId;
var $170c74acdf993371$var$_clockseq;
// Previous uuid creation time
var $170c74acdf993371$var$_lastMSecs = 0;
var $170c74acdf993371$var$_lastNSecs = 0;
// See https://github.com/uuidjs/uuid for API details
function $170c74acdf993371$var$v1(options, buf, offset) {
    var i = buf && offset || 0;
    var b = buf || [];
    options = options || {};
    var node = options.node || $170c74acdf993371$var$_nodeId;
    var clockseq = options.clockseq !== undefined ? options.clockseq : $170c74acdf993371$var$_clockseq;
    // node and clockseq need to be initialized to random values if they're not
    // specified.  We do this lazily to minimize issues related to insufficient
    // system entropy.  See #189
    if (node == null || clockseq == null) {
        var seedBytes = $531859673df6bb70$exports();
        if (node == null) // Per 4.5, create and 48-bit node id, (47 random bits + multicast bit = 1)
        node = $170c74acdf993371$var$_nodeId = [
            seedBytes[0] | 0x01,
            seedBytes[1],
            seedBytes[2],
            seedBytes[3],
            seedBytes[4],
            seedBytes[5]
        ];
        if (clockseq == null) // Per 4.2.2, randomize (14 bit) clockseq
        clockseq = $170c74acdf993371$var$_clockseq = (seedBytes[6] << 8 | seedBytes[7]) & 0x3fff;
    }
    // UUID timestamps are 100 nano-second units since the Gregorian epoch,
    // (1582-10-15 00:00).  JSNumbers aren't precise enough for this, so
    // time is handled internally as 'msecs' (integer milliseconds) and 'nsecs'
    // (100-nanoseconds offset from msecs) since unix epoch, 1970-01-01 00:00.
    var msecs = options.msecs !== undefined ? options.msecs : new Date().getTime();
    // Per 4.2.1.2, use count of uuid's generated during the current clock
    // cycle to simulate higher resolution clock
    var nsecs = options.nsecs !== undefined ? options.nsecs : $170c74acdf993371$var$_lastNSecs + 1;
    // Time since last uuid creation (in msecs)
    var dt = msecs - $170c74acdf993371$var$_lastMSecs + (nsecs - $170c74acdf993371$var$_lastNSecs) / 10000;
    // Per 4.2.1.2, Bump clockseq on clock regression
    if (dt < 0 && options.clockseq === undefined) clockseq = clockseq + 1 & 0x3fff;
    // Reset nsecs if clock regresses (new clockseq) or we've moved onto a new
    // time interval
    if ((dt < 0 || msecs > $170c74acdf993371$var$_lastMSecs) && options.nsecs === undefined) nsecs = 0;
    // Per 4.2.1.2 Throw error if too many uuids are requested
    if (nsecs >= 10000) throw new Error("uuid.v1(): Can't create more than 10M uuids/sec");
    $170c74acdf993371$var$_lastMSecs = msecs;
    $170c74acdf993371$var$_lastNSecs = nsecs;
    $170c74acdf993371$var$_clockseq = clockseq;
    // Per 4.1.4 - Convert from unix epoch to Gregorian epoch
    msecs += 12219292800000;
    // `time_low`
    var tl = ((msecs & 0xfffffff) * 10000 + nsecs) % 0x100000000;
    b[i++] = tl >>> 24 & 0xff;
    b[i++] = tl >>> 16 & 0xff;
    b[i++] = tl >>> 8 & 0xff;
    b[i++] = tl & 0xff;
    // `time_mid`
    var tmh = msecs / 0x100000000 * 10000 & 0xfffffff;
    b[i++] = tmh >>> 8 & 0xff;
    b[i++] = tmh & 0xff;
    // `time_high_and_version`
    b[i++] = tmh >>> 24 & 0xf | 0x10; // include version
    b[i++] = tmh >>> 16 & 0xff;
    // `clock_seq_hi_and_reserved` (Per 4.2.2 - include variant)
    b[i++] = clockseq >>> 8 | 0x80;
    // `clock_seq_low`
    b[i++] = clockseq & 0xff;
    // `node`
    for(var n = 0; n < 6; ++n)b[i + n] = node[n];
    return buf ? buf : $9d606397c7f4e6df$exports(b);
}
$170c74acdf993371$exports = $170c74acdf993371$var$v1;


var $6cfca16ba6df6e64$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($170c74acdf993371$exports)));


function $57c3e4483130738d$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $57c3e4483130738d$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $57c3e4483130738d$var$ownKeys(Object(source), true).forEach(function(key) {
            (0, (/*@__PURE__*/$parcel$interopDefault($cc894e2648a4bb4d$exports)))(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $57c3e4483130738d$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
const $57c3e4483130738d$export$4df9c0969a9e0160 = (defaults, properties)=>$57c3e4483130738d$var$_objectSpread($57c3e4483130738d$var$_objectSpread({}, defaults), properties);




var $7e29c48cc36f8eff$export$2e2bcd8739ae039 = {
    randomAToB: function(a, b, INT) {
        if (!INT) return a + Math.random() * (b - a);
        else return (Math.random() * (b - a) >> 0) + a;
    },
    randomFloating: function(center, f, INT) {
        return this.randomAToB(center - f, center + f, INT);
    },
    randomZone: function(display) {},
    //eslint-disable-line
    degreeTransform: function(a) {
        return a * (0, $c1da9e54204bbff9$export$6b5c1ceb16d01dc3) / 180;
    },
    toColor16: function getRGB(num) {
        return "#" + num.toString(16);
    },
    randomColor: function() {
        return "#" + ("00000" + (Math.random() * 0x1000000 << 0).toString(16)).slice(-6);
    },
    lerp: function(a, b, energy) {
        return b + (a - b) * energy;
    },
    getNormal: function(v, n) {
        if (v.x == 0 && v.y == 0) {
            if (v.z == 0) n.set(1, 0, 1);
            else n.set(1, 1, -v.y / v.z);
        } else if (v.x == 0) n.set(1, 0, 1);
        else n.set(-v.y / v.x, 1, 1);
        return n.normalize();
    },
    /**
   * Rodrigues' Rotation Formula
   * https://en.wikipedia.org/wiki/Rodrigues%27_rotation_formula
   * v′ = vcos(θ) + k(k⋅v)(1−cos(θ)) + (k*v)sin(θ)
   */ axisRotate: function(v0, v, k, tha) {
        var cos = Math.cos(tha);
        var sin = Math.sin(tha);
        var p = k.dot(v) * (1 - cos);
        v0.copy(k);
        v0.cross(v).scalar(sin);
        v0.addValue(v.x * cos, v.y * cos, v.z * cos);
        v0.addValue(k.x * p, k.y * p, k.z * p);
    }
};



const $3ffeb34645e7fcb8$export$729abc87f7f388fa = "ArraySpan";
const $3ffeb34645e7fcb8$export$1a307f4e55e23c5d = "ColorSpan";
const $3ffeb34645e7fcb8$export$9c5bffa4d00a5c4e = "Box";
const $3ffeb34645e7fcb8$export$23fb3b443f30bc70 = "Polar3D";
const $3ffeb34645e7fcb8$export$31c2116603affe89 = "Span";
const $3ffeb34645e7fcb8$export$39d5b8abd4226cdb = "Vector3D";


class $ef3653f168d58d59$export$2e2bcd8739ae039 {
    /**
   * Span.getValue function
   * @name get a random Number from a to b. Or get a random Number from c-a to c+b
   * @param {number} INT or int
   * @return {number} a random Number
   */ getValue(INT) {
        if (this._isArray) return this.a[this.a.length * Math.random() >> 0];
        else {
            if (!this._center) return (0, $7e29c48cc36f8eff$export$2e2bcd8739ae039).randomAToB(this.a, this.b, INT);
            else return (0, $7e29c48cc36f8eff$export$2e2bcd8739ae039).randomFloating(this.a, this.b, INT);
        }
    }
    /**
   * Span Class. Get a random Number from a to b. Or from c-a to c+b
   * @param {Number|Array} a - min number
   * @param {Number} b - max number
   * @param {Number} center - the center's z value
   * @example
   * var span = new Span(0,30);
   * or
   * var span = new Span(["#fff","#ff0","#000"]);
   * or
   * var span = new Span(5,1,"center");
   * @extends {Zone}
   * @constructor
   */ constructor(a, b, center){
        this._isArray = false;
        /**
     * @desc The class type.
     * @type {string}
     */ this.type = (0, $3ffeb34645e7fcb8$export$31c2116603affe89);
        if ((0, $23c21dd81897876b$export$2e2bcd8739ae039).isArray(a)) {
            this._isArray = true;
            this.a = a;
        } else {
            this.a = (0, $23c21dd81897876b$export$2e2bcd8739ae039).initValue(a, 1);
            this.b = (0, $23c21dd81897876b$export$2e2bcd8739ae039).initValue(b, this.a);
            this._center = (0, $23c21dd81897876b$export$2e2bcd8739ae039).initValue(center, false);
        }
    }
}
const $ef3653f168d58d59$export$47286723ded93599 = (a, b, c)=>{
    if (a instanceof $ef3653f168d58d59$export$2e2bcd8739ae039) return a;
    if (b === undefined) return new $ef3653f168d58d59$export$2e2bcd8739ae039(a);
    else {
        if (c === undefined) return new $ef3653f168d58d59$export$2e2bcd8739ae039(a, b);
        else return new $ef3653f168d58d59$export$2e2bcd8739ae039(a, b, c);
    }
};


var $d38b455a1a8a7ae9$exports = {};
var $89c85ecb1d6d2117$exports = {};
var $398a9e96f49f72f3$exports = {};
/* Built-in method references for those with the same name as other `lodash` methods. */ var $398a9e96f49f72f3$var$nativeFloor = Math.floor, $398a9e96f49f72f3$var$nativeRandom = Math.random;
/**
 * The base implementation of `_.random` without support for returning
 * floating-point numbers.
 *
 * @private
 * @param {number} lower The lower bound.
 * @param {number} upper The upper bound.
 * @returns {number} Returns the random number.
 */ function $398a9e96f49f72f3$var$baseRandom(lower, upper) {
    return lower + $398a9e96f49f72f3$var$nativeFloor($398a9e96f49f72f3$var$nativeRandom() * (upper - lower + 1));
}
$398a9e96f49f72f3$exports = $398a9e96f49f72f3$var$baseRandom;


/**
 * A specialized version of `_.sample` for arrays.
 *
 * @private
 * @param {Array} array The array to sample.
 * @returns {*} Returns the random element.
 */ function $89c85ecb1d6d2117$var$arraySample(array) {
    var length = array.length;
    return length ? array[$398a9e96f49f72f3$exports(0, length - 1)] : undefined;
}
$89c85ecb1d6d2117$exports = $89c85ecb1d6d2117$var$arraySample;


var $09ce299ea436344e$exports = {};

var $bc3a3a9837f332ce$exports = {};
var $d9e9ba78b8193fa5$exports = {};
var $218e50948c36cd85$exports = {};
/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ function $218e50948c36cd85$var$arrayMap(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length, result = Array(length);
    while(++index < length)result[index] = iteratee(array[index], index, array);
    return result;
}
$218e50948c36cd85$exports = $218e50948c36cd85$var$arrayMap;


/**
 * The base implementation of `_.values` and `_.valuesIn` which creates an
 * array of `object` property values corresponding to the property names
 * of `props`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} props The property names to get values for.
 * @returns {Object} Returns the array of property values.
 */ function $d9e9ba78b8193fa5$var$baseValues(object, props) {
    return $218e50948c36cd85$exports(props, function(key) {
        return object[key];
    });
}
$d9e9ba78b8193fa5$exports = $d9e9ba78b8193fa5$var$baseValues;


var $591a2cb8f8941857$exports = {};
var $2f8382f014e11cd9$exports = {};
var $b8d02e2fe3c590ab$exports = {};
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */ function $b8d02e2fe3c590ab$var$baseTimes(n, iteratee) {
    var index = -1, result = Array(n);
    while(++index < n)result[index] = iteratee(index);
    return result;
}
$b8d02e2fe3c590ab$exports = $b8d02e2fe3c590ab$var$baseTimes;


var $13c88222de02594e$exports = {};
var $d3d9124cea2d3697$exports = {};
var $70010753e0cd19ef$exports = {};
var $06f89309fc5f8d76$exports = {};

var $eIyuj = parcelRequire("eIyuj");
/** Built-in value references. */ var $06f89309fc5f8d76$var$Symbol = $eIyuj.Symbol;
$06f89309fc5f8d76$exports = $06f89309fc5f8d76$var$Symbol;


var $7c6f9ca8ef43bc6f$exports = {};

/** Used for built-in method references. */ var $7c6f9ca8ef43bc6f$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $7c6f9ca8ef43bc6f$var$hasOwnProperty = $7c6f9ca8ef43bc6f$var$objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $7c6f9ca8ef43bc6f$var$nativeObjectToString = $7c6f9ca8ef43bc6f$var$objectProto.toString;
/** Built-in value references. */ var $7c6f9ca8ef43bc6f$var$symToStringTag = $06f89309fc5f8d76$exports ? $06f89309fc5f8d76$exports.toStringTag : undefined;
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function $7c6f9ca8ef43bc6f$var$getRawTag(value) {
    var isOwn = $7c6f9ca8ef43bc6f$var$hasOwnProperty.call(value, $7c6f9ca8ef43bc6f$var$symToStringTag), tag = value[$7c6f9ca8ef43bc6f$var$symToStringTag];
    try {
        value[$7c6f9ca8ef43bc6f$var$symToStringTag] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = $7c6f9ca8ef43bc6f$var$nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[$7c6f9ca8ef43bc6f$var$symToStringTag] = tag;
        else delete value[$7c6f9ca8ef43bc6f$var$symToStringTag];
    }
    return result;
}
$7c6f9ca8ef43bc6f$exports = $7c6f9ca8ef43bc6f$var$getRawTag;


var $c4cd925cf987db40$exports = {};
/** Used for built-in method references. */ var $c4cd925cf987db40$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $c4cd925cf987db40$var$nativeObjectToString = $c4cd925cf987db40$var$objectProto.toString;
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function $c4cd925cf987db40$var$objectToString(value) {
    return $c4cd925cf987db40$var$nativeObjectToString.call(value);
}
$c4cd925cf987db40$exports = $c4cd925cf987db40$var$objectToString;


/** `Object#toString` result references. */ var $70010753e0cd19ef$var$nullTag = "[object Null]", $70010753e0cd19ef$var$undefinedTag = "[object Undefined]";
/** Built-in value references. */ var $70010753e0cd19ef$var$symToStringTag = $06f89309fc5f8d76$exports ? $06f89309fc5f8d76$exports.toStringTag : undefined;
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function $70010753e0cd19ef$var$baseGetTag(value) {
    if (value == null) return value === undefined ? $70010753e0cd19ef$var$undefinedTag : $70010753e0cd19ef$var$nullTag;
    return $70010753e0cd19ef$var$symToStringTag && $70010753e0cd19ef$var$symToStringTag in Object(value) ? $7c6f9ca8ef43bc6f$exports(value) : $c4cd925cf987db40$exports(value);
}
$70010753e0cd19ef$exports = $70010753e0cd19ef$var$baseGetTag;


var $25f4b69c31dfd9c9$exports = {};
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $25f4b69c31dfd9c9$var$isObjectLike(value) {
    return value != null && typeof value == "object";
}
$25f4b69c31dfd9c9$exports = $25f4b69c31dfd9c9$var$isObjectLike;


/** `Object#toString` result references. */ var $d3d9124cea2d3697$var$argsTag = "[object Arguments]";
/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */ function $d3d9124cea2d3697$var$baseIsArguments(value) {
    return $25f4b69c31dfd9c9$exports(value) && $70010753e0cd19ef$exports(value) == $d3d9124cea2d3697$var$argsTag;
}
$d3d9124cea2d3697$exports = $d3d9124cea2d3697$var$baseIsArguments;



/** Used for built-in method references. */ var $13c88222de02594e$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $13c88222de02594e$var$hasOwnProperty = $13c88222de02594e$var$objectProto.hasOwnProperty;
/** Built-in value references. */ var $13c88222de02594e$var$propertyIsEnumerable = $13c88222de02594e$var$objectProto.propertyIsEnumerable;
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ var $13c88222de02594e$var$isArguments = $d3d9124cea2d3697$exports(function() {
    return arguments;
}()) ? $d3d9124cea2d3697$exports : function(value) {
    return $25f4b69c31dfd9c9$exports(value) && $13c88222de02594e$var$hasOwnProperty.call(value, "callee") && !$13c88222de02594e$var$propertyIsEnumerable.call(value, "callee");
};
$13c88222de02594e$exports = $13c88222de02594e$var$isArguments;


var $c05cc779c5ad7540$exports = {};
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var $c05cc779c5ad7540$var$isArray = Array.isArray;
$c05cc779c5ad7540$exports = $c05cc779c5ad7540$var$isArray;



var $jbsAw = parcelRequire("jbsAw");
var $28eea811b81ab9d4$exports = {};
/** Used as references for various `Number` constants. */ var $28eea811b81ab9d4$var$MAX_SAFE_INTEGER = 9007199254740991;
/** Used to detect unsigned integer values. */ var $28eea811b81ab9d4$var$reIsUint = /^(?:0|[1-9]\d*)$/;
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function $28eea811b81ab9d4$var$isIndex(value, length) {
    var type = typeof value;
    length = length == null ? $28eea811b81ab9d4$var$MAX_SAFE_INTEGER : length;
    return !!length && (type == "number" || type != "symbol" && $28eea811b81ab9d4$var$reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
$28eea811b81ab9d4$exports = $28eea811b81ab9d4$var$isIndex;


var $9bf04ec52bedae92$exports = {};
var $071239af237e3dc1$exports = {};

var $02d32c2f2a80ffcc$exports = {};
/** Used as references for various `Number` constants. */ var $02d32c2f2a80ffcc$var$MAX_SAFE_INTEGER = 9007199254740991;
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function $02d32c2f2a80ffcc$var$isLength(value) {
    return typeof value == "number" && value > -1 && value % 1 == 0 && value <= $02d32c2f2a80ffcc$var$MAX_SAFE_INTEGER;
}
$02d32c2f2a80ffcc$exports = $02d32c2f2a80ffcc$var$isLength;



/** `Object#toString` result references. */ var $071239af237e3dc1$var$argsTag = "[object Arguments]", $071239af237e3dc1$var$arrayTag = "[object Array]", $071239af237e3dc1$var$boolTag = "[object Boolean]", $071239af237e3dc1$var$dateTag = "[object Date]", $071239af237e3dc1$var$errorTag = "[object Error]", $071239af237e3dc1$var$funcTag = "[object Function]", $071239af237e3dc1$var$mapTag = "[object Map]", $071239af237e3dc1$var$numberTag = "[object Number]", $071239af237e3dc1$var$objectTag = "[object Object]", $071239af237e3dc1$var$regexpTag = "[object RegExp]", $071239af237e3dc1$var$setTag = "[object Set]", $071239af237e3dc1$var$stringTag = "[object String]", $071239af237e3dc1$var$weakMapTag = "[object WeakMap]";
var $071239af237e3dc1$var$arrayBufferTag = "[object ArrayBuffer]", $071239af237e3dc1$var$dataViewTag = "[object DataView]", $071239af237e3dc1$var$float32Tag = "[object Float32Array]", $071239af237e3dc1$var$float64Tag = "[object Float64Array]", $071239af237e3dc1$var$int8Tag = "[object Int8Array]", $071239af237e3dc1$var$int16Tag = "[object Int16Array]", $071239af237e3dc1$var$int32Tag = "[object Int32Array]", $071239af237e3dc1$var$uint8Tag = "[object Uint8Array]", $071239af237e3dc1$var$uint8ClampedTag = "[object Uint8ClampedArray]", $071239af237e3dc1$var$uint16Tag = "[object Uint16Array]", $071239af237e3dc1$var$uint32Tag = "[object Uint32Array]";
/** Used to identify `toStringTag` values of typed arrays. */ var $071239af237e3dc1$var$typedArrayTags = {};
$071239af237e3dc1$var$typedArrayTags[$071239af237e3dc1$var$float32Tag] = $071239af237e3dc1$var$typedArrayTags[$071239af237e3dc1$var$float64Tag] = $071239af237e3dc1$var$typedArrayTags[$071239af237e3dc1$var$int8Tag] = $071239af237e3dc1$var$typedArrayTags[$071239af237e3dc1$var$int16Tag] = $071239af237e3dc1$var$typedArrayTags[$071239af237e3dc1$var$int32Tag] = $071239af237e3dc1$var$typedArrayTags[$071239af237e3dc1$var$uint8Tag] = $071239af237e3dc1$var$typedArrayTags[$071239af237e3dc1$var$uint8ClampedTag] = $071239af237e3dc1$var$typedArrayTags[$071239af237e3dc1$var$uint16Tag] = $071239af237e3dc1$var$typedArrayTags[$071239af237e3dc1$var$uint32Tag] = true;
$071239af237e3dc1$var$typedArrayTags[$071239af237e3dc1$var$argsTag] = $071239af237e3dc1$var$typedArrayTags[$071239af237e3dc1$var$arrayTag] = $071239af237e3dc1$var$typedArrayTags[$071239af237e3dc1$var$arrayBufferTag] = $071239af237e3dc1$var$typedArrayTags[$071239af237e3dc1$var$boolTag] = $071239af237e3dc1$var$typedArrayTags[$071239af237e3dc1$var$dataViewTag] = $071239af237e3dc1$var$typedArrayTags[$071239af237e3dc1$var$dateTag] = $071239af237e3dc1$var$typedArrayTags[$071239af237e3dc1$var$errorTag] = $071239af237e3dc1$var$typedArrayTags[$071239af237e3dc1$var$funcTag] = $071239af237e3dc1$var$typedArrayTags[$071239af237e3dc1$var$mapTag] = $071239af237e3dc1$var$typedArrayTags[$071239af237e3dc1$var$numberTag] = $071239af237e3dc1$var$typedArrayTags[$071239af237e3dc1$var$objectTag] = $071239af237e3dc1$var$typedArrayTags[$071239af237e3dc1$var$regexpTag] = $071239af237e3dc1$var$typedArrayTags[$071239af237e3dc1$var$setTag] = $071239af237e3dc1$var$typedArrayTags[$071239af237e3dc1$var$stringTag] = $071239af237e3dc1$var$typedArrayTags[$071239af237e3dc1$var$weakMapTag] = false;
/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */ function $071239af237e3dc1$var$baseIsTypedArray(value) {
    return $25f4b69c31dfd9c9$exports(value) && $02d32c2f2a80ffcc$exports(value.length) && !!$071239af237e3dc1$var$typedArrayTags[$70010753e0cd19ef$exports(value)];
}
$071239af237e3dc1$exports = $071239af237e3dc1$var$baseIsTypedArray;


var $cfc57005a99cf87f$exports = {};
/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */ function $cfc57005a99cf87f$var$baseUnary(func) {
    return function(value) {
        return func(value);
    };
}
$cfc57005a99cf87f$exports = $cfc57005a99cf87f$var$baseUnary;



var $eWlaq = parcelRequire("eWlaq");
/* Node.js helper references. */ var $9bf04ec52bedae92$var$nodeIsTypedArray = $eWlaq && $eWlaq.isTypedArray;
/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */ var $9bf04ec52bedae92$var$isTypedArray = $9bf04ec52bedae92$var$nodeIsTypedArray ? $cfc57005a99cf87f$exports($9bf04ec52bedae92$var$nodeIsTypedArray) : $071239af237e3dc1$exports;
$9bf04ec52bedae92$exports = $9bf04ec52bedae92$var$isTypedArray;


/** Used for built-in method references. */ var $2f8382f014e11cd9$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $2f8382f014e11cd9$var$hasOwnProperty = $2f8382f014e11cd9$var$objectProto.hasOwnProperty;
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */ function $2f8382f014e11cd9$var$arrayLikeKeys(value, inherited) {
    var isArr = $c05cc779c5ad7540$exports(value), isArg = !isArr && $13c88222de02594e$exports(value), isBuff = !isArr && !isArg && $jbsAw(value), isType = !isArr && !isArg && !isBuff && $9bf04ec52bedae92$exports(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? $b8d02e2fe3c590ab$exports(value.length, String) : [], length = result.length;
    for(var key in value)if ((inherited || $2f8382f014e11cd9$var$hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
    (key == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    isBuff && (key == "offset" || key == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    isType && (key == "buffer" || key == "byteLength" || key == "byteOffset") || // Skip index properties.
    $28eea811b81ab9d4$exports(key, length)))) result.push(key);
    return result;
}
$2f8382f014e11cd9$exports = $2f8382f014e11cd9$var$arrayLikeKeys;


var $2fbda2e8ffa0a1f6$exports = {};
var $bedb85f099314921$exports = {};
/** Used for built-in method references. */ var $bedb85f099314921$var$objectProto = Object.prototype;
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */ function $bedb85f099314921$var$isPrototype(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == "function" && Ctor.prototype || $bedb85f099314921$var$objectProto;
    return value === proto;
}
$bedb85f099314921$exports = $bedb85f099314921$var$isPrototype;


var $c81440dec3540f1c$exports = {};
var $9bce3a6d8960b23e$exports = {};
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function $9bce3a6d8960b23e$var$overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
$9bce3a6d8960b23e$exports = $9bce3a6d8960b23e$var$overArg;


/* Built-in method references for those with the same name as other `lodash` methods. */ var $c81440dec3540f1c$var$nativeKeys = $9bce3a6d8960b23e$exports(Object.keys, Object);
$c81440dec3540f1c$exports = $c81440dec3540f1c$var$nativeKeys;


/** Used for built-in method references. */ var $2fbda2e8ffa0a1f6$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $2fbda2e8ffa0a1f6$var$hasOwnProperty = $2fbda2e8ffa0a1f6$var$objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $2fbda2e8ffa0a1f6$var$baseKeys(object) {
    if (!$bedb85f099314921$exports(object)) return $c81440dec3540f1c$exports(object);
    var result = [];
    for(var key in Object(object))if ($2fbda2e8ffa0a1f6$var$hasOwnProperty.call(object, key) && key != "constructor") result.push(key);
    return result;
}
$2fbda2e8ffa0a1f6$exports = $2fbda2e8ffa0a1f6$var$baseKeys;


var $a9f5a2bb41899d7d$exports = {};
var $1db87ca3ec66e12f$exports = {};

var $2afa3381f5f6064e$exports = {};
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $2afa3381f5f6064e$var$isObject(value) {
    var type = typeof value;
    return value != null && (type == "object" || type == "function");
}
$2afa3381f5f6064e$exports = $2afa3381f5f6064e$var$isObject;


/** `Object#toString` result references. */ var $1db87ca3ec66e12f$var$asyncTag = "[object AsyncFunction]", $1db87ca3ec66e12f$var$funcTag = "[object Function]", $1db87ca3ec66e12f$var$genTag = "[object GeneratorFunction]", $1db87ca3ec66e12f$var$proxyTag = "[object Proxy]";
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function $1db87ca3ec66e12f$var$isFunction(value) {
    if (!$2afa3381f5f6064e$exports(value)) return false;
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 9 which returns 'object' for typed arrays and other constructors.
    var tag = $70010753e0cd19ef$exports(value);
    return tag == $1db87ca3ec66e12f$var$funcTag || tag == $1db87ca3ec66e12f$var$genTag || tag == $1db87ca3ec66e12f$var$asyncTag || tag == $1db87ca3ec66e12f$var$proxyTag;
}
$1db87ca3ec66e12f$exports = $1db87ca3ec66e12f$var$isFunction;



/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function $a9f5a2bb41899d7d$var$isArrayLike(value) {
    return value != null && $02d32c2f2a80ffcc$exports(value.length) && !$1db87ca3ec66e12f$exports(value);
}
$a9f5a2bb41899d7d$exports = $a9f5a2bb41899d7d$var$isArrayLike;


/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */ function $591a2cb8f8941857$var$keys(object) {
    return $a9f5a2bb41899d7d$exports(object) ? $2f8382f014e11cd9$exports(object) : $2fbda2e8ffa0a1f6$exports(object);
}
$591a2cb8f8941857$exports = $591a2cb8f8941857$var$keys;


/**
 * Creates an array of the own enumerable string keyed property values of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property values.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.values(new Foo);
 * // => [1, 2] (iteration order is not guaranteed)
 *
 * _.values('hi');
 * // => ['h', 'i']
 */ function $bc3a3a9837f332ce$var$values(object) {
    return object == null ? [] : $d9e9ba78b8193fa5$exports(object, $591a2cb8f8941857$exports(object));
}
$bc3a3a9837f332ce$exports = $bc3a3a9837f332ce$var$values;


/**
 * The base implementation of `_.sample`.
 *
 * @private
 * @param {Array|Object} collection The collection to sample.
 * @returns {*} Returns the random element.
 */ function $09ce299ea436344e$var$baseSample(collection) {
    return $89c85ecb1d6d2117$exports($bc3a3a9837f332ce$exports(collection));
}
$09ce299ea436344e$exports = $09ce299ea436344e$var$baseSample;



/**
 * Gets a random element from `collection`.
 *
 * @static
 * @memberOf _
 * @since 2.0.0
 * @category Collection
 * @param {Array|Object} collection The collection to sample.
 * @returns {*} Returns the random element.
 * @example
 *
 * _.sample([1, 2, 3, 4]);
 * // => 2
 */ function $d38b455a1a8a7ae9$var$sample(collection) {
    var func = $c05cc779c5ad7540$exports(collection) ? $89c85ecb1d6d2117$exports : $09ce299ea436344e$exports;
    return func(collection);
}
$d38b455a1a8a7ae9$exports = $d38b455a1a8a7ae9$var$sample;



class $4d95165b82d52b8d$export$2e2bcd8739ae039 extends (0, $ef3653f168d58d59$export$2e2bcd8739ae039) {
    /**
   * Gets a random item.
   *
   * @return {mixed}
   */ getValue() {
        return (0, (/*@__PURE__*/$parcel$interopDefault($d38b455a1a8a7ae9$exports)))(this.items);
    }
    /**
   * Constructs an ArraySpan instance.
   *
   * @param {mixed|array<mixed>} items - Items
   * @return void
   */ constructor(items){
        super();
        /**
     * @desc The class type.
     * @type {string}
     */ this.type = (0, $3ffeb34645e7fcb8$export$729abc87f7f388fa);
        /**
     * @desc An array of colors
     * @type {array}
     */ this.items = Array.isArray(items) ? items : [
            items
        ];
    }
}
const $4d95165b82d52b8d$export$1588a1b4e21c31e5 = (items)=>{
    if (!items) return null;
    if (items instanceof $4d95165b82d52b8d$export$2e2bcd8739ae039) return items;
    return new $4d95165b82d52b8d$export$2e2bcd8739ae039(items);
};






class $be6fe48c65b4f246$export$2e2bcd8739ae039 extends (0, $ef3653f168d58d59$export$2e2bcd8739ae039) {
    /**
   * Gets a color from the color array
   * or a random color if this.shouldRandomize is true.
   *
   * @return {string} a hex color
   */ getValue() {
        return this.shouldRandomize ? (0, $7e29c48cc36f8eff$export$2e2bcd8739ae039).randomColor() : (0, (/*@__PURE__*/$parcel$interopDefault($d38b455a1a8a7ae9$exports)))(this.colors);
    }
    /**
   * Constructs a ColorSpan instance.
   *
   * @param {string|array<string>} colors - A color or array of colors. If the
   * string 'random' is provided, a random color will be returned from getValue
   * @return void
   */ constructor(colors){
        super();
        /**
     * @desc The class type.
     * @type {string}
     */ this.type = (0, $3ffeb34645e7fcb8$export$1a307f4e55e23c5d);
        /**
     * @desc Determines if a random color should be returned from the getValue method.
     * @type {boolean}
     */ this.shouldRandomize = colors === "random" ? true : false;
        /**
     * @desc An array of colors to select from
     * @type {array<string>}
     */ this.colors = Array.isArray(colors) ? colors : [
            colors
        ];
    }
}
const $be6fe48c65b4f246$export$a6207c41d393cec5 = (colors)=>{
    if (!colors) {
        console.warn(`Invalid colors argument ${colors} passed to createColorSpan. Defaulting to 'random'.`);
        colors = "random";
    }
    if (colors instanceof $be6fe48c65b4f246$export$2e2bcd8739ae039) return colors;
    return new $be6fe48c65b4f246$export$2e2bcd8739ae039(colors);
};



class $b12f21aa2cb2d0ed$export$2e2bcd8739ae039 {
    contains(x, y, z) {
        if (x <= this.right && x >= this.x && y <= this.bottom && y >= this.y && z <= this.depth && z >= this.z) return true;
        else return false;
    }
    constructor(x, y, z, w, h, d){
        /**
     * @desc The class type.
     * @type {string}
     */ this.type = (0, $3ffeb34645e7fcb8$export$9c5bffa4d00a5c4e);
        this.x = x;
        this.y = y;
        this.z = z;
        this.width = w;
        this.height = h;
        this.depth = d;
        this.bottom = this.y + this.height;
        this.right = this.x + this.width;
        this.right = this.x + this.width;
    }
}


/**
 * @see https://en.wikipedia.org/wiki/Euler_method
 * @type {string}
 */ const $3aa7c721e9776547$export$ee71156541331f4c = "EULER";
const $3aa7c721e9776547$export$2e85371fe9128df5 = "RUNGE_KUTTA_2";
const $3aa7c721e9776547$export$44df0b9b3f53eea = "RUNGE_KUTTA_4";
const $3aa7c721e9776547$export$89884c7219605c78 = "VERLET";



/**
 * Performs euler integration on the particle.
 *
 * @param {Particle} particle - The particle to integrate
 * @param {number} time - The factor of time to use
 * @param {number} damping - The damping to use
 * @return void
 */ const $20448755a0d15e35$var$eulerIntegration = (particle, time, damping)=>{
    if (particle.sleep) return;
    particle.old.position.copy(particle.position);
    particle.old.velocity.copy(particle.velocity);
    particle.acceleration.scalar(1 / particle.mass);
    particle.velocity.add(particle.acceleration.scalar(time));
    particle.position.add(particle.old.velocity.scalar(time));
    damping && particle.velocity.scalar(Math.pow(damping, time / (0, $d975d6add471d316$export$8d825e02d092de99)));
    particle.acceleration.clear();
};
const $20448755a0d15e35$export$df970fd884294dfc = (particle, time, damping, type = (0, $3aa7c721e9776547$export$ee71156541331f4c))=>{
    switch(type){
        case 0, $3aa7c721e9776547$export$ee71156541331f4c:
            $20448755a0d15e35$var$eulerIntegration(particle, time, damping);
            break;
        default:
            $20448755a0d15e35$var$eulerIntegration(particle, time, damping);
    }
};




class $4ecaf53387bdecca$export$2e2bcd8739ae039 extends (0, $085a6d802029f140$export$64b5c384219d3699) {
    clear() {
        this.x = 0.0;
        this.y = 0.0;
        this.z = 0.0;
        return this;
    }
    scalar(s) {
        this.x *= s;
        this.y *= s;
        this.z *= s;
        return this;
    }
    addValue(a, b, c) {
        this.x += a;
        this.y += b;
        this.z += c;
        return this;
    }
    toString() {
        return "x:" + this.x + "y:" + this.y + "z:" + this.z;
    }
    eulerFromDir(vector3D) {
        const euler = new (0, $db34e7d28bab253d$export$d93cc409a0768c5f)();
        return euler.setFromVector3(vector3D);
    }
}



class $85c395a0a34c8085$export$2e2bcd8739ae039 {
    set(radius, theta, phi) {
        this.radius = radius || 1;
        this.phi = phi || 0;
        this.theta = theta || 0;
        return this;
    }
    setRadius(radius) {
        this.radius = radius;
        return this;
    }
    setPhi(phi) {
        this.phi = phi;
        return this;
    }
    setTheta(theta) {
        this.theta = theta;
        return this;
    }
    copy(p) {
        this.radius = p.radius;
        this.phi = p.phi;
        this.theta = p.theta;
        return this;
    }
    toVector3D() {
        return new (0, $4ecaf53387bdecca$export$2e2bcd8739ae039)(this.getX(), this.getY(), this.getZ());
    }
    getX() {
        return this.radius * Math.sin(this.theta) * Math.cos(this.phi);
    }
    getY() {
        return -this.radius * Math.sin(this.theta) * Math.sin(this.phi);
    }
    getZ() {
        return this.radius * Math.cos(this.theta);
    }
    normalize() {
        this.radius = 1;
        return this;
    }
    equals(v) {
        return v.radius === this.radius && v.phi === this.phi && v.theta === this.theta;
    }
    clear() {
        this.radius = 0.0;
        this.phi = 0.0;
        this.theta = 0.0;
        return this;
    }
    clone() {
        return new $85c395a0a34c8085$export$2e2bcd8739ae039(this.radius, this.phi, this.theta);
    }
    constructor(radius, theta, phi){
        /**
     * @desc The class type.
     * @type {string}
     */ this.type = (0, $3ffeb34645e7fcb8$export$23fb3b443f30bc70);
        this.radius = radius || 1;
        this.phi = phi || 0;
        this.theta = theta || 0;
    }
}







const $7b675df6fec73cb3$export$6970f7d330903f8f = "Particle";
const $7b675df6fec73cb3$export$c34aa46f2e77697e = "Pool";
const $7b675df6fec73cb3$export$ba1b6cbca38d23d8 = "System";


class $65e050f2a1a2716c$export$2e2bcd8739ae039 {
    /**
   * Gets the particle's current direction.
   *
   * @return {number}
   */ getDirection() {
        return Math.atan2(this.velocity.x, -this.velocity.y) * (180 / (0, $c1da9e54204bbff9$export$6b5c1ceb16d01dc3));
    }
    /**
   * Resets the particle's default properties and clear's its particle's position,
   * velocity, acceleration, color and rotation. Also destroy's the particle's
   * transform collection & removes all behaviours.
   *
   * @return {Particle}
   */ reset() {
        this.life = (0, $d975d6add471d316$export$2f1a74589dda35c3);
        this.age = (0, $d975d6add471d316$export$745c2b445c1110d);
        this.energy = (0, $d975d6add471d316$export$fa57c23defe18c5f);
        this.dead = (0, $d975d6add471d316$export$d21786ee1d9bfeee);
        this.sleep = (0, $d975d6add471d316$export$35da66156a4897ea);
        this.body = (0, $d975d6add471d316$export$6c4720c3b9135a36);
        this.parent = (0, $d975d6add471d316$export$86cdd8c3740ed501);
        this.mass = (0, $d975d6add471d316$export$16964c9e319a42ab);
        this.radius = (0, $d975d6add471d316$export$63f2df7bd7371262);
        this.alpha = (0, $d975d6add471d316$export$72d6647c6a08e38c);
        this.scale = (0, $d975d6add471d316$export$12cb6783d1668a58);
        this.useColor = (0, $d975d6add471d316$export$aa9ff4453bec0b9c);
        this.useAlpha = (0, $d975d6add471d316$export$e338f7bef784a532);
        this.easing = (0, $d975d6add471d316$export$95fc36a5f3be840e);
        this.position.set(0, 0, 0);
        this.velocity.set(0, 0, 0);
        this.acceleration.set(0, 0, 0);
        this.old.position.set(0, 0, 0);
        this.old.velocity.set(0, 0, 0);
        this.old.acceleration.set(0, 0, 0);
        this.color.r = 0;
        this.color.g = 0;
        this.color.b = 0;
        this.rotation.clear();
        (0, $23c21dd81897876b$export$2e2bcd8739ae039).destroyObject(this.transform);
        this.removeAllBehaviours();
        return this;
    }
    /**
   * Updates the particle's properties by applying each behaviour to the particle.
   * Will also update the particle's energy, unless it's age is greater than it's life
   * in which case it will be destroyed.
   *
   * @param {number} time - Integration time
   * @param {integer} index - Particle index
   * @return void
   */ update(time, index) {
        if (!this.sleep) {
            this.age += time;
            let i = this.behaviours.length;
            while(i--){
                let behaviour = this.behaviours[i]; //behaviour && 
                behaviour.applyBehaviour(this, time, index);
            }
        }
        if (this.age >= this.life) this.destroy();
        else {
            const scale = this.easing(this.age / this.life);
            this.energy = Math.max(1 - scale, 0);
        }
    }
    /**
   * Adds a behaviour to the particle.
   *
   * @param {Behaviour} behaviour - The behaviour to add to the particle
   * @return void
   */ addBehaviour(behaviour) {
        this.behaviours.push(behaviour);
        behaviour.initialize(this);
    }
    /**
   * Adds multiple behaviours to the particle.
   *
   * @param {array<Behaviour>} behaviours - An array of behaviours to add to the particle
   * @return void
   */ addBehaviours(behaviours) {
        let i = behaviours.length;
        while(i--)this.addBehaviour(behaviours[i]);
    }
    /**
   * Removes the behaviour from the particle.
   *
   * @param {Behaviour} behaviour - The behaviour to remove from the particle
   * @return void
   */ removeBehaviour(behaviour) {
        const index = this.behaviours.indexOf(behaviour);
        if (index > -1) this.behaviours.splice(index, 1);
    }
    /**
   * Removes all behaviours from the particle.
   *
   * @return void
   */ removeAllBehaviours() {
        (0, $23c21dd81897876b$export$2e2bcd8739ae039).destroyArray(this.behaviours);
    }
    /**
   * Destroys the particle.
   *
   * @return void
   */ destroy() {
        this.removeAllBehaviours();
        this.energy = 0;
        this.dead = true;
        this.parent = null;
    }
    /**
   * Constructs a Particle instance.
   *
   * @param {object} properties - The properties to instantiate the particle with
   * @property {number} properties.life - The particle's life
   * @property {number} properties.age - The particle's age
   * @property {number} properties.energy - The particle's energy loss
   * @property {boolean} properties.dead - Determines if the particle is dead or not
   * @property {boolean} properties.sleep - Determines if the particle is sleeping or not
   * @property {object} properties.target - The particle's target
   * @property {object} properties.body - The particle's body
   * @property {number} properties.mass - The particle's mass
   * @property {number} properties.radius - The particle's radius
   * @property {number} properties.alpha - The particle's alpha
   * @property {number} properties.scale - The particle's scale
   * @property {number} properties.rotation - The particle's rotation
   * @property {string|number} properties.color - The particle's color
   * @property {function} properties.easing - The particle's easing
   * @property {Vector3D} properties.position - The particle's position
   * @property {Vector3D} properties.velocity - The particle's velocity
   * @property {Vector3D} properties.acceleration - The particle's acceleration
   * @property {array} properties.behaviours - The particle's behaviours array
   * @property {object} properties.transform - The particle's transform collection
   * @return void
   */ constructor(properties){
        /**
     * @desc The particle's unique id
     * @type {number}
     */ this.id = `particle-${(0, $6cfca16ba6df6e64$export$2e2bcd8739ae039)()}`;
        /**
     * @desc The class type.
     * @type {string}
     */ this.type = (0, $7b675df6fec73cb3$export$6970f7d330903f8f);
        /**
     * @desc The particle's life
     * @type {number}
     */ this.life = (0, $d975d6add471d316$export$2f1a74589dda35c3);
        /**
     * @desc The particle's age
     * @type {number}
     */ this.age = (0, $d975d6add471d316$export$745c2b445c1110d);
        /**
     * @desc The particle's energy loss
     * @type {number}
     */ this.energy = (0, $d975d6add471d316$export$fa57c23defe18c5f);
        /**
     * @desc Determines if the particle is dead or not
     * @type {number}
     */ this.dead = (0, $d975d6add471d316$export$d21786ee1d9bfeee);
        /**
     * @desc Determines if the particle is sleeping or not
     * @type {number}
     */ this.sleep = (0, $d975d6add471d316$export$35da66156a4897ea);
        /**
     * @desc The particle's body
     * @type {object}
     */ this.body = (0, $d975d6add471d316$export$6c4720c3b9135a36);
        /**
     * @desc The particle's parent
     * @type {?Emitter}
     */ this.parent = (0, $d975d6add471d316$export$86cdd8c3740ed501);
        /**
     * @desc The particle's mass
     * @type {number}
     */ this.mass = (0, $d975d6add471d316$export$16964c9e319a42ab);
        /**
     * @desc The particle's radius
     * @type {number}
     */ this.radius = (0, $d975d6add471d316$export$63f2df7bd7371262);
        /**
     * @desc The particle's alpha
     * @type {number}
     */ this.alpha = (0, $d975d6add471d316$export$72d6647c6a08e38c);
        /**
     * @desc The particle's scale
     * @type {number}
     */ this.scale = (0, $d975d6add471d316$export$12cb6783d1668a58);
        /**
     * @desc Determines whether to use color or not
     * @type {boolean}
     */ this.useColor = (0, $d975d6add471d316$export$aa9ff4453bec0b9c);
        /**
     * @desc Determines whether to use alpha or not
     * @type {boolean}
     */ this.useAlpha = (0, $d975d6add471d316$export$e338f7bef784a532);
        /**
     * @desc The particle's easing
     * @type {string}
     */ this.easing = (0, $d975d6add471d316$export$95fc36a5f3be840e);
        /**
     * @desc The particle's position
     * @type {Vector3D}
     */ this.position = new (0, $4ecaf53387bdecca$export$2e2bcd8739ae039)();
        /**
     * @desc The particle's velocity
     * @type {Vector3D}
     */ this.velocity = new (0, $4ecaf53387bdecca$export$2e2bcd8739ae039)();
        /**
     * @desc The particle's acceleration
     * @type {Vector3D}
     */ this.acceleration = new (0, $4ecaf53387bdecca$export$2e2bcd8739ae039)();
        /**
     * @desc The particle's last position, velocity and acceleration
     * @type {Vector3D}
     */ this.old = {};
        /**
     * @desc The particle's old position
     * @type {Vector3D}
     */ this.old.position = this.position.clone();
        /**
     * @desc The particle's old velocity
     * @type {Vector3D}
     */ this.old.velocity = this.velocity.clone();
        /**
     * @desc The particle's old acceleration
     * @type {Vector3D}
     */ this.old.acceleration = this.acceleration.clone();
        /**
     * @desc The particle's behaviours array
     * @type {array}
     */ this.behaviours = [];
        /**
     * @desc The particle's transform collection
     * @type {object}
     */ this.transform = {};
        /**
     * @desc The particle's color store
     * @type {object}
     */ this.color = {
            r: 0,
            g: 0,
            b: 0
        };
        /**
     * @desc The particle's rotation
     * @type {number}
     */ this.rotation = new (0, $4ecaf53387bdecca$export$2e2bcd8739ae039)();
        /**
     * @desc The particle's distance to the camera, only set by the GPURenderer for depth sorting purposes.
     * @type {number}
     */ this.distanceToCamera = 0; // override constructor props with passed properties.
        (0, $23c21dd81897876b$export$2e2bcd8739ae039).setPrototypeByObj(this, properties);
    }
}




class $84702be31d3f40ce$export$2e2bcd8739ae039 {
    /**
   * Attempts to create a new object either by creating a new instance or calling its
   * clone method.
   *
   * TODO COVERAGE - for the constructorArgs
   * @param {function|object} functionOrObject - The object to instantiate or clone
   * @return {object|undefined}
   */ create(functionOrObject, ...constructorArgs) {
        if (!this.canCreateNewObject(functionOrObject)) throw new Error("The pool is unable to create or clone the object supplied");
        this.cID++;
        if (this.canInstantiateObject(functionOrObject)) return new functionOrObject(...constructorArgs);
        if (this.canCloneObject(functionOrObject)) return functionOrObject.clone();
    }
    /**
   * Determines if the object is able to be instantiated or not.
   *
   * @param {object} object - The object to check
   * @return {boolean}
   */ canInstantiateObject(object) {
        return typeof object === "function";
    }
    /**
   * Determines if the object is able to be cloned or not.
   *
   * @param {object} object - The object to check
   * @return {boolean}
   */ canCloneObject(object) {
        return object.clone && typeof object.clone === "function";
    }
    /**
   * Determines if a new object is able to be created.
   *
   * @param {object} object - The object to check
   * @return {boolean}
   */ canCreateNewObject(object) {
        return this.canInstantiateObject(object) || this.canCloneObject(object) ? true : false;
    }
    /**
   * Gets a count of all objects in the pool.
   *
   * @return {integer}
   */ getCount() {
        var count = 0;
        for(var id in this.list)count += this.list[id].length;
        return count++;
    }
    /**
   * Gets an object either by creating a new one or retrieving it from the pool.
   *
   * @param {function|object} obj - The function or object to get
   * @param {array} args - The args to pass to the function on creation
   * @return {object}
   */ get(obj, ...args) {
        var p, puid = obj.__puid || (0, $b08343919f129d8b$export$2e2bcd8739ae039).id(obj);
        if (this.list[puid] && this.list[puid].length > 0) p = this.list[puid].pop();
        else p = this.create(obj, ...args);
        p.__puid = obj.__puid || puid;
        return p;
    }
    /**
   * Pushes an object into the pool.
   *
   * @param {object} obj - The object to expire
   * @return {integer}
   */ expire(obj) {
        return this._getList(obj.__puid).push(obj);
    }
    /**
   * Destroys all pools.
   *
   * @return void
   */ destroy() {
        for(var id in this.list){
            this.list[id].length = 0;
            delete this.list[id];
        }
    }
    /**
   * Gets the pool mapped to the UID.
   *
   * @param {string} uid - The pool uid
   * @return {array}
   */ _getList(uid) {
        uid = uid || "default";
        if (!this.list[uid]) this.list[uid] = [];
        return this.list[uid];
    }
    /**
   * Constructs a Pool instance.
   *
   * @return void
   */ constructor(){
        /**
     * @desc The class type.
     * @type {string}
     */ this.type = (0, $7b675df6fec73cb3$export$c34aa46f2e77697e);
        /**
     * @desc Incrementing id that keeps a count of the number of objects created
     * @type {integer}
     */ this.cID = 0;
        /**
     * @desc Map of pools in the format of PUID<String>: pool<Array>
     * @type {object}
     */ this.list = {};
    }
}


/*
 * EventDispatcher
 * Visit http://createjs.com/ for documentation, updates and examples.
 *
 **/ class $35b96e3482efa4b8$export$2e2bcd8739ae039 {
    set listeners(listeners) {
        this._listeners = listeners;
    }
    get listeners() {
        return this._listeners;
    }
    addEventListener(type, listener) {
        if (!this.listeners) this.listeners = {};
        else this.removeEventListener(type, listener);
        if (!this.listeners[type]) this.listeners[type] = [];
        this.listeners[type].push(listener);
        return listener;
    }
    removeEventListener(type, listener) {
        if (!this.listeners) return;
        if (!this.listeners[type]) return;
        var arr = this.listeners[type];
        for(var i = 0, l = arr.length; i < l; i++)if (arr[i] == listener) {
            if (l == 1) delete this.listeners[type];
            else arr.splice(i, 1);
            break;
        }
    }
    removeAllEventListeners(type) {
        if (!type) this.listeners = null;
        else if (this.listeners) delete this.listeners[type];
    }
    dispatchEvent(eventName, eventTarget) {
        var ret = false, listeners = this.listeners;
        if (eventName && listeners) {
            var arr = listeners[eventName];
            if (!arr) return ret;
            arr = arr.slice(); //Should use a copy into a temporary here instead...
            // to avoid issues with items being removed or added during the dispatch
            var handler, i = arr.length;
            while(i--){
                handler = arr[i];
                ret = ret || handler(eventTarget);
            }
        }
        return !!ret;
    }
    hasEventListener(type) {
        var listeners = this.listeners;
        return !!(listeners && listeners[type]);
    }
    constructor(){
        this.listeners = null;
    }
}


const $4d2ddc8f9664085f$export$bd6240f4cf59123a = "SYSTEM_UPDATE";
const $4d2ddc8f9664085f$export$421681fbc92d2c7c = "PARTICLE_CREATED";
const $4d2ddc8f9664085f$export$868dbb69ba0499ec = "PARTICLE_UPDATE";
const $4d2ddc8f9664085f$export$2204007c8bf30e02 = "PARTICLE_DEAD";
const $4d2ddc8f9664085f$export$262c4ebde537eaad = "EMITTER_ADDED";
const $4d2ddc8f9664085f$export$5d04eb6bd0f83550 = "EMITTER_REMOVED";
const $4d2ddc8f9664085f$export$95fe715649d4ca1a = "EMITTER_DEAD";
const $4d2ddc8f9664085f$export$ce6d4e620116271b = "SYSTEM_UPDATE_AFTER";


var $048d8be74dedd185$export$2e2bcd8739ae039 = (0, $35b96e3482efa4b8$export$2e2bcd8739ae039);



var $1371ea37222d2da3$exports = {};

$parcel$export($1371ea37222d2da3$exports, "Body", function () { return $26c1557168b06a35$export$2e2bcd8739ae039; });
$parcel$export($1371ea37222d2da3$exports, "BodySprite", function () { return $d09bd892a6fc02a0$export$2e2bcd8739ae039; });
$parcel$export($1371ea37222d2da3$exports, "InitializerUtil", function () { return $f31ac9fbc63fe87b$export$2e2bcd8739ae039; });
$parcel$export($1371ea37222d2da3$exports, "Life", function () { return $ad9f4cb3c3090f54$export$2e2bcd8739ae039; });
$parcel$export($1371ea37222d2da3$exports, "Mass", function () { return $07c2166c937b061c$export$2e2bcd8739ae039; });
$parcel$export($1371ea37222d2da3$exports, "Position", function () { return $1051606c509839db$export$2e2bcd8739ae039; });
$parcel$export($1371ea37222d2da3$exports, "Radius", function () { return $6053068a9f2caa98$export$2e2bcd8739ae039; });
$parcel$export($1371ea37222d2da3$exports, "Rate", function () { return $c15ff10b1716ebd7$export$2e2bcd8739ae039; });
$parcel$export($1371ea37222d2da3$exports, "Texture", function () { return $65c4c9ef738c90b5$export$2e2bcd8739ae039; });
$parcel$export($1371ea37222d2da3$exports, "VectorVelocity", function () { return $c86cf4346ebc2d7e$export$2e2bcd8739ae039; });
$parcel$export($1371ea37222d2da3$exports, "PolarVelocity", function () { return $08dfd6acbde0a188$export$2e2bcd8739ae039; });
$parcel$export($1371ea37222d2da3$exports, "RadialVelocity", function () { return $815217306acadcd1$export$2e2bcd8739ae039; });

class $bf927956b698b24e$export$2e2bcd8739ae039 {
    /**
   * Initializes the property on the emitter or particle.
   *
   * @see {@link '../emitter/emitter.js'} setupParticle
   * @param {Emitter} emitter - the emitter to initialize the property on
   * @param {Particle} particle - the particle to intiialize the property on
   * @return void
   */ init(emitter, particle) {
        if (!this.isEnabled) return;
        if (particle) {
            this.initialize(particle);
            particle.hasBeenInitialized = true;
        } else {
            this.initialize(emitter);
            emitter.hasBeenInitialized = true;
        }
    }
    /**
   * @abstract
   */ reset() {}
    /**
   * Place custom property initialization code in this method in the subclass.
   *
   * @param {object} target - either an Emitter or a Particle
   * @abstract
   */ initialize(target) {}
    /**
   * Determines if the initializer requires a Web GL API to be provided to its constructor.
   * If true, the WebGL API will need to be provided as the first argument to the constructor
   * and fromJSON methods.
   *
   * @return {boolean}
   */ static requiresWebGlApi() {
        return false;
    }
    /**
   * Returns a new instance of the initializer from the JSON object passed.
   *
   * @abstract
   * @param {object} json - JSON object containing the required constructor properties
   * @return {Behaviour}
   */ static fromJSON(json) {}
    /**
   * Constructs an Initializer instance.
   *
   * @param {string} [type=INITIALIZER_TYPE_ABSTRACT] - The intiializer type
   * @param {boolean} [isEnabled=true] - Determines if the initializer should be enabled or not
    * @return void
   */ constructor(type = (0, $83f850ed9ddda6a7$export$ba9cf0918610bb83), isEnabled = true){
        this.type = type;
        this.isEnabled = isEnabled;
    }
}




class $26c1557168b06a35$export$2e2bcd8739ae039 extends (0, $bf927956b698b24e$export$2e2bcd8739ae039) {
    /**
   * Sets the particle's initial body.
   *
   * @param {Particle} particle - the particle to initialize the property on
   * @return void
   */ initialize(particle) {
        var body = this.body.getValue();
        if (this.w) particle.body = {
            width: this.w,
            height: this.h,
            body: body
        };
        else particle.body = body;
    }
    /**
   * Creates a Body initializer from JSON.
   *
   * @param {object} json - The JSON to construct the instance from.
   * @property {number} json.body - The color for the particle body
   * @property {number} json.width - The width of the particle body
   * @property {number} json.height - The height of the particle body
   * @return {Body}
   */ static fromJSON(json) {
        const { body: body, width: width, height: height, isEnabled: isEnabled = true } = json;
        return new $26c1557168b06a35$export$2e2bcd8739ae039(body, width, height, isEnabled);
    }
    /**
   * Constructs a Body initalizer instance.
   *
   * @param {string|number|object} body - The content for the particle body, can
   * be a color or an object (mesh)
   * @param {?number} w - The width of the particle body
   * @param {?number} h - The height of the particle body
   * @return void
   */ constructor(body, w, h, isEnabled = true){
        super((0, $83f850ed9ddda6a7$export$3ef979d6b2e48ce), isEnabled);
        /**
     * @desc The content for the particle body
     * @type {ArraySpan}
     */ this.body = (0, $4d95165b82d52b8d$export$1588a1b4e21c31e5)(body);
        /**
     * @desc The width of the particle Body
     * @type {number}
     */ this.w = w;
        /**
     * @desc The height of the particle Body
     * @type {number}
     */ this.h = h || w;
    }
}





function $fcf2ac7187899806$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $fcf2ac7187899806$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $fcf2ac7187899806$var$ownKeys(Object(source), true).forEach(function(key) {
            (0, (/*@__PURE__*/$parcel$interopDefault($cc894e2648a4bb4d$exports)))(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $fcf2ac7187899806$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
const $fcf2ac7187899806$export$a6824bc8131e6e84 = {
    AdditiveBlending: $a34f8048fbd5bdd3$export$777d8f9551c2216b,
    CustomBlending: $a34f8048fbd5bdd3$export$eda4864c68df1fa2,
    MultiplyBlending: $a34f8048fbd5bdd3$export$4138e1c684b46a20,
    NoBlending: $a34f8048fbd5bdd3$export$63b8d6b580fc65ba,
    NormalBlending: $a34f8048fbd5bdd3$export$5b29a26d96ee6af0,
    SubtractiveBlending: $a34f8048fbd5bdd3$export$cdfa06f868e2e467
};
const $fcf2ac7187899806$export$93a17cfa3462e135 = {
    color: 0xff0000,
    blending: (0, $a34f8048fbd5bdd3$export$777d8f9551c2216b),
    fog: true
};
const $fcf2ac7187899806$export$ee70a7b8619e0e1c = $fcf2ac7187899806$var$_objectSpread($fcf2ac7187899806$var$_objectSpread({}, $fcf2ac7187899806$export$93a17cfa3462e135), {}, {
    blending: "AdditiveBlending"
});
const $fcf2ac7187899806$export$3c9d1a91d0b672b0 = 1;
const $fcf2ac7187899806$export$c4bbdd44827e467e = 1;





function $d09bd892a6fc02a0$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $d09bd892a6fc02a0$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $d09bd892a6fc02a0$var$ownKeys(Object(source), true).forEach(function(key) {
            (0, (/*@__PURE__*/$parcel$interopDefault($cc894e2648a4bb4d$exports)))(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $d09bd892a6fc02a0$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
class $d09bd892a6fc02a0$export$2e2bcd8739ae039 extends (0, $bf927956b698b24e$export$2e2bcd8739ae039) {
    /**
   * Sets the particle body to the sprite.
   *
   * @param {Particle} particle - The particle to set the body of
   * @return void
   */ initialize(particle) {
        particle.body = this.sprite;
    }
    /**
   * Creates a BodySprite initializer from JSON.
   *
   * @param {object} json - The JSON to construct the instance from
   * @param {object} THREE - The Web GL API we are using eg., THREE
   * @param {string} json.texture - The sprite texture
   * @param {object} json.materialProperties - The sprite material properties
   * @return {BodySprite}
   */ static fromJSON(json, THREE) {
        const { texture: texture, materialProperties: materialProperties = (0, $fcf2ac7187899806$export$ee70a7b8619e0e1c), isEnabled: isEnabled = true } = json;
        const ensureMappedBlendingMode = (properties)=>{
            const { blending: blending } = properties;
            return $d09bd892a6fc02a0$var$_objectSpread($d09bd892a6fc02a0$var$_objectSpread({}, properties), {}, {
                blending: blending ? (0, $fcf2ac7187899806$export$a6824bc8131e6e84)[blending] : (0, $fcf2ac7187899806$export$a6824bc8131e6e84)[(0, $fcf2ac7187899806$export$ee70a7b8619e0e1c).blending]
            });
        };
        return new $d09bd892a6fc02a0$export$2e2bcd8739ae039(THREE, texture, (0, $57c3e4483130738d$export$4df9c0969a9e0160)((0, $fcf2ac7187899806$export$ee70a7b8619e0e1c), ensureMappedBlendingMode(materialProperties)), isEnabled);
    }
    /**
   * Constructs a BodySprite initializer.
   *
   * @param {object} THREE - The Web GL API we are using eg., THREE
   * @param {string} texture - The sprite texture
   * @param {object} materialProperties - The sprite material properties
   * @throws {Error} If the TextureLoader fails to load the supplied texture
   * @return void
   */ constructor(THREE, texture, materialProperties = (0, $fcf2ac7187899806$export$93a17cfa3462e135), isEnabled = true){
        super((0, $83f850ed9ddda6a7$export$bfe2fafbb3f6ec80), isEnabled);
        const { Sprite: Sprite, SpriteMaterial: SpriteMaterial, TextureLoader: TextureLoader } = THREE;
        /**
     * @desc The material properties for this object's SpriteMaterial
     * NOTE This is required for testing purposes
     * @type {object}
     */ this.materialProperties = (0, $57c3e4483130738d$export$4df9c0969a9e0160)((0, $fcf2ac7187899806$export$93a17cfa3462e135), materialProperties);
        new TextureLoader().load(texture, (map)=>{
            /**
       * @desc The texture for the THREE.SpriteMaterial map.
       * @type {Texture}
       */ this.texture = map;
            /**
       * @desc THREE.SpriteMaterial instance.
       * @type {SpriteMaterial}
       */ this.material = new SpriteMaterial($d09bd892a6fc02a0$var$_objectSpread($d09bd892a6fc02a0$var$_objectSpread({}, {
                map: map
            }), this.materialProperties));
            /**
       * @desc THREE.Sprite instance.
       * @type {Sprite}
       */ this.sprite = new Sprite(this.material);
        }, undefined, (error)=>{
            throw new Error(error);
        });
    }
}



const $f31ac9fbc63fe87b$var$particleEuler = new (0, $db34e7d28bab253d$export$d93cc409a0768c5f)();
var $f31ac9fbc63fe87b$export$2e2bcd8739ae039 = {
    particleEuler: null,
    /**
   * Loops through the initializers array and calls each initializer's initialize method
   * on the supplied particle. This sets the particle's initial properties.
   *
   * @see {@link '../emitter/Emitter'} setupParticle
   * @param {Emitter} emitter - The emitter that has called this method
   * @param {Particle} particle - The particle that has just been created
   * @param {array<Initializer>} initializers - All of the emitter's initializers
   * @return void
   */ initialize: function(emitter, particle, initializers) {
        let i = initializers.length;
        while(i--)initializers[i].init(emitter, particle);
        emitter.bindEmitter && this.bindEmitter(emitter, particle);
    },
    /**
   * Ensures that the emitter's position, velocity and accleration are added
   * to each created particle.
   *
   * @param {Emitter} emitter - The emitter that is emitting the particles
   * @param {Particle} particle - The newly created particle
   * @return void
   */ bindEmitter: function(emitter, particle) {
        const { rotation: { x: x, y: y, z: z } } = emitter;
        particle.position.add(emitter.position);
        particle.velocity.add(emitter.velocity);
        particle.acceleration.add(emitter.acceleration);
        particle.velocity.applyEuler($f31ac9fbc63fe87b$var$particleEuler.set(x, y, z));
    }
};





class $ad9f4cb3c3090f54$export$2e2bcd8739ae039 extends (0, $bf927956b698b24e$export$2e2bcd8739ae039) {
    /**
   * Sets the particle's initial life.
   *
   * @param {Particle} particle - the particle to initialize the property on
   * @return void
   */ initialize(particle) {
        if (this.lifePan.a == Infinity || this.lifePan.a == "infi") particle.life = Infinity;
        else particle.life = this.lifePan.getValue();
    }
    /**
   * Creates a Life initializer from JSON.
   *
   * @param {object} json - The JSON to construct the instance from.
   * @param {number} json.min - The minimum life time
   * @param {number} json.max - The maximum life time
   * @param {number} json.center - The center of the life time
   * @param {boolean} [json.isEnabled=true] - Determines if the initializer should be enabled or not
   * @return {Life}
   */ static fromJSON(json) {
        const { min: min, max: max, center: center = false, isEnabled: isEnabled = true } = json;
        return new $ad9f4cb3c3090f54$export$2e2bcd8739ae039(min, max, center, isEnabled);
    }
    /**
   * Constructs a Life property instance.
   *
   * @param {number} min - The minimum life
   * @param {number} max - The maximum life
   * @param {boolean} [center] - Determines whether to average the life value
   * @param {boolean} [isEnabled=true] - Determines if the initializer should be enabled or not
   * @return void
   */ constructor(min, max, center, isEnabled = true){
        super((0, $83f850ed9ddda6a7$export$45db14bd37173b96), isEnabled);
        /**
     * @desc The life span of the particle.
     * @type {Span}
     */ this.lifePan = (0, $ef3653f168d58d59$export$47286723ded93599)(min, max, center);
    }
}





class $07c2166c937b061c$export$2e2bcd8739ae039 extends (0, $bf927956b698b24e$export$2e2bcd8739ae039) {
    /**
   * Sets the particle's initial mass.
   *
   * @param {Particle} particle - the particle to initialize the property on
   * @return void
   */ initialize(particle) {
        particle.mass = this.massPan.getValue();
    }
    /**
   * Creates a Mass initializer from JSON.
   *
   * @param {object} json - The JSON to construct the instance from.
   * @property {number} json.min - The minimum mass
   * @property {number} json.max - The maximum mass
   * @property {number} json.center - The center of the mass
   * @return {Mass}
   */ static fromJSON(json) {
        const { min: min, max: max, center: center = false, isEnabled: isEnabled = true } = json;
        return new $07c2166c937b061c$export$2e2bcd8739ae039(min, max, center, isEnabled);
    }
    /**
   * Constructs a Mass initializer instance.
   *
   * @param {number} min - The minumum mass for the particle
   * @param {number} max - The maximum mass for the particle
   * @param {boolean} [center] - Determines whether to average the mass value
   * @return void
   */ constructor(min, max, center = false, isEnabled = true){
        super((0, $83f850ed9ddda6a7$export$980595dbb0c6e42), isEnabled);
        /**
     * @desc The mass span which is used to set the particle mass value.
     * @type {Span}
     */ this.massPan = (0, $ef3653f168d58d59$export$47286723ded93599)(min, max, center);
    }
}


var $f5aa9b0d5cdbf30d$exports = {};
var $a74b347f7002602c$exports = {};
function $a74b347f7002602c$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
$a74b347f7002602c$exports = $a74b347f7002602c$var$_objectWithoutPropertiesLoose, $a74b347f7002602c$exports.__esModule = true, $a74b347f7002602c$exports["default"] = $a74b347f7002602c$exports;


function $f5aa9b0d5cdbf30d$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $a74b347f7002602c$exports(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
$f5aa9b0d5cdbf30d$exports = $f5aa9b0d5cdbf30d$var$_objectWithoutProperties, $f5aa9b0d5cdbf30d$exports.__esModule = true, $f5aa9b0d5cdbf30d$exports["default"] = $f5aa9b0d5cdbf30d$exports;


var $0f5050993349035a$exports = {};

$parcel$export($0f5050993349035a$exports, "BoxZone", function () { return $73ccb74a1dc3c249$export$2e2bcd8739ae039; });
$parcel$export($0f5050993349035a$exports, "LineZone", function () { return $3b33e07a17ce2d1f$export$2e2bcd8739ae039; });
$parcel$export($0f5050993349035a$exports, "MeshZone", function () { return $57bc87130f4068b6$export$2e2bcd8739ae039; });
$parcel$export($0f5050993349035a$exports, "PointZone", function () { return $ef5c8270299a26f4$export$2e2bcd8739ae039; });
$parcel$export($0f5050993349035a$exports, "ScreenZone", function () { return $d2e6f64c3d41fe98$export$2e2bcd8739ae039; });
$parcel$export($0f5050993349035a$exports, "SphereZone", function () { return $03928f17fcace199$export$2e2bcd8739ae039; });




class $7668cc91eb72a17a$export$2e2bcd8739ae039 {
    getPosition() {
        return null;
    }
    crossing(particle) {
        if (!this.supportsCrossing) return console.warn(`${this.constructor.name} does not support the crossing method`);
        switch(this.crossType){
            case "bound":
                this._bound(particle);
                break;
            case "cross":
                this._cross(particle);
                break;
            case "dead":
                this._dead(particle);
                break;
        }
    }
    /**
   * Determines if this zone is a BoxZone.
   *
   * @return {boolean}
   */ isBoxZone() {
        return false;
    }
    /**
   * Determines if this zone is a LineZone.
   *
   * @return {boolean}
   */ isLineZone() {
        return false;
    }
    /**
   * Determines if this zone is a MeshZone.
   *
   * @return {boolean}
   */ isMeshZone() {
        return false;
    }
    /**
   * Determines if this zone is a PointZone.
   *
   * @return {boolean}
   */ isPointZone() {
        return false;
    }
    /**
   * Determines if this zone is a ScreenZone.
   *
   * @return {boolean}
   */ isScreenZone() {
        return false;
    }
    /**
   * Determines if this zone is a SphereZone.
   *
   * @return {boolean}
   */ isSphereZone() {
        return false;
    }
    /**
   * Sets the particle's dead property to true if required.
   *
   * @param {Particle} particle
   * @abstract
   */ _dead(particle) {}
    /**
   * @abstract
   */ _bound(particle) {}
    /**
   * @abstract
   */ _cross(particle) {}
    /**
   * Constructs a Zone instance.
   *
   * @param {string} type - The zone type
   * @return void
   */ constructor(type = (0, $6750d9f4d05ced14$export$9f3c28aae06fd98)){
        this.type = type;
        this.vector = new (0, $4ecaf53387bdecca$export$2e2bcd8739ae039)(0, 0, 0);
        this.random = 0;
        this.crossType = "dead";
        this.log = true;
        this.supportsCrossing = true;
    }
}



class $73ccb74a1dc3c249$export$2e2bcd8739ae039 extends (0, $7668cc91eb72a17a$export$2e2bcd8739ae039) {
    /**
   * Returns true to indicate this is a BoxZone.
   *
   * @return {boolean}
   */ isBoxZone() {
        return true;
    }
    getPosition() {
        this.vector.x = this.x + (0, $7e29c48cc36f8eff$export$2e2bcd8739ae039).randomAToB(-0.5, 0.5) * this.width;
        this.vector.y = this.y + (0, $7e29c48cc36f8eff$export$2e2bcd8739ae039).randomAToB(-0.5, 0.5) * this.height;
        this.vector.z = this.z + (0, $7e29c48cc36f8eff$export$2e2bcd8739ae039).randomAToB(-0.5, 0.5) * this.depth;
        return this.vector;
    }
    _dead(particle) {
        if (particle.position.x + particle.radius < this.x - this.width / 2) particle.dead = true;
        else if (particle.position.x - particle.radius > this.x + this.width / 2) particle.dead = true;
        if (particle.position.y + particle.radius < this.y - this.height / 2) particle.dead = true;
        else if (particle.position.y - particle.radius > this.y + this.height / 2) particle.dead = true;
        if (particle.position.z + particle.radius < this.z - this.depth / 2) particle.dead = true;
        else if (particle.position.z - particle.radius > this.z + this.depth / 2) particle.dead = true;
    }
    _bound(particle) {
        if (particle.position.x - particle.radius < this.x - this.width / 2) {
            particle.position.x = this.x - this.width / 2 + particle.radius;
            particle.velocity.x *= -this.friction;
            this._static(particle, "x");
        } else if (particle.position.x + particle.radius > this.x + this.width / 2) {
            particle.position.x = this.x + this.width / 2 - particle.radius;
            particle.velocity.x *= -this.friction;
            this._static(particle, "x");
        }
        if (particle.position.y - particle.radius < this.y - this.height / 2) {
            particle.position.y = this.y - this.height / 2 + particle.radius;
            particle.velocity.y *= -this.friction;
            this._static(particle, "y");
        } else if (particle.position.y + particle.radius > this.y + this.height / 2) {
            particle.position.y = this.y + this.height / 2 - particle.radius;
            particle.velocity.y *= -this.friction;
            this._static(particle, "y");
        }
        if (particle.position.z - particle.radius < this.z - this.depth / 2) {
            particle.position.z = this.z - this.depth / 2 + particle.radius;
            particle.velocity.z *= -this.friction;
            this._static(particle, "z");
        } else if (particle.position.z + particle.radius > this.z + this.depth / 2) {
            particle.position.z = this.z + this.depth / 2 - particle.radius;
            particle.velocity.z *= -this.friction;
            this._static(particle, "z");
        }
    }
    _static(particle, axis) {
        if (particle.velocity[axis] * particle.acceleration[axis] > 0) return;
        if (Math.abs(particle.velocity[axis]) < Math.abs(particle.acceleration[axis]) * 0.0167 * this.max) {
            particle.velocity[axis] = 0;
            particle.acceleration[axis] = 0;
        }
    }
    _cross(particle) {
        if (particle.position.x + particle.radius < this.x - this.width / 2 && particle.velocity.x <= 0) particle.position.x = this.x + this.width / 2 + particle.radius;
        else if (particle.position.x - particle.radius > this.x + this.width / 2 && particle.velocity.x >= 0) particle.position.x = this.x - this.width / 2 - particle.radius;
        if (particle.position.y + particle.radius < this.y - this.height / 2 && particle.velocity.y <= 0) particle.position.y = this.y + this.height / 2 + particle.radius;
        else if (particle.position.y - particle.radius > this.y + this.height / 2 && particle.velocity.y >= 0) particle.position.y = this.y - this.height / 2 - particle.radius;
        if (particle.position.z + particle.radius < this.z - this.depth / 2 && particle.velocity.z <= 0) particle.position.z = this.z + this.depth / 2 + particle.radius;
        else if (particle.position.z - particle.radius > this.z + this.depth / 2 && particle.velocity.z >= 0) particle.position.z = this.z - this.depth / 2 - particle.radius;
    }
    /**
   * BoxZone is a box zone
   * @param {Number|Vector3D} x - the position's x value or a Vector3D Object
   * @param {Number} y - the position's y value
   * @param {Number} z - the position's z value
   * @param {Number} w - the Box's width
   * @param {Number} h - the Box's height
   * @param {Number} d - the Box's depth
   * @example
   * var boxZone = new BoxZone(0,0,0,50,50,50);
   * or
   * var boxZone = new BoxZone(new Vector3D(0,0,0), 50, 50, 50);
   * @extends {Zone}
   * @constructor
   */ constructor(a, b, c, d, e, f){
        super((0, $6750d9f4d05ced14$export$7cd2cdc555c88d56)); // TODO this reassigning of arguments is pretty dangerous, need to fix it.
        // eslint-disable-next-line
        var x, y, z, w, h, d;
        if ((0, $23c21dd81897876b$export$2e2bcd8739ae039).isUndefined(b, c, d, e, f)) {
            x = y = z = 0;
            w = h = d = a || 100;
        } else if ((0, $23c21dd81897876b$export$2e2bcd8739ae039).isUndefined(d, e, f)) {
            x = y = z = 0;
            w = a;
            h = b;
            d = c;
        } else {
            x = a;
            y = b;
            z = c;
            w = d;
            h = e;
            d = f;
        }
        this.x = x;
        this.y = y;
        this.z = z;
        this.width = w;
        this.height = h;
        this.depth = d; // TODO Set this via an argument to the constructor
        this.friction = 0.85; // TODO Set this via an argument to the constructor
        this.max = 6;
    }
}





class $3b33e07a17ce2d1f$export$2e2bcd8739ae039 extends (0, $7668cc91eb72a17a$export$2e2bcd8739ae039) {
    /**
   * Returns true to indicate this is a LineZone.
   *
   * @return {boolean}
   */ isLineZone() {
        return true;
    }
    getPosition() {
        this.random = Math.random();
        this.vector.x = this.x1 + this.random * (this.x2 - this.x1);
        this.vector.y = this.y1 + this.random * (this.y2 - this.y1);
        this.vector.z = this.z1 + this.random * (this.z2 - this.z1);
        return this.vector;
    }
    /**
   * LineZone is a 3d line zone
   * @param {Number|Vector3D} x1 - the line's start point of x value or a Vector3D Object
   * @param {Number|Vector3D} y1 - the line's start point of y value or a Vector3D Object
   * @param {Number} z1 - the line's start point of z value
   * @param {Number} x2 - the line's end point of x value
   * @param {Number} y2 - the line's end point of y value
   * @param {Number} z2 - the line's end point of z value
   * @example
   * var lineZone = new System.LineZone(0,0,0,100,100,0);
   * or
   * var lineZone = new System.LineZone(new System.Vector3D(0,0,0),new System.Vector3D(100,100,0));
   * @extends {Zone}
   * @constructor
   */ constructor(x1, y1, z1, x2, y2, z2){
        super((0, $6750d9f4d05ced14$export$baed6ad0a34de92));
        if (x1 instanceof (0, $4ecaf53387bdecca$export$2e2bcd8739ae039)) {
            this.x1 = x1.x;
            this.y1 = x1.y;
            this.z1 = x1.z;
            this.x2 = x2.x;
            this.y2 = x2.y;
            this.z2 = x2.z;
        } else {
            this.x1 = x1;
            this.y1 = y1;
            this.z1 = z1;
            this.x2 = x2;
            this.y2 = y2;
            this.z2 = z2;
        }
        this.supportsCrossing = false;
    }
}




class $57bc87130f4068b6$export$2e2bcd8739ae039 extends (0, $7668cc91eb72a17a$export$2e2bcd8739ae039) {
    /**
   * Returns true to indicate this is a MeshZone.
   *
   * @return {boolean}
   */ isMeshZone() {
        return true;
    }
    getPosition() {
        const vertices = this.geometry.vertices;
        const rVector = vertices[vertices.length * Math.random() >> 0];
        this.vector.x = rVector.x * this.scale;
        this.vector.y = rVector.y * this.scale;
        this.vector.z = rVector.z * this.scale;
        return this.vector;
    }
    /**
   * @constructs {MeshZone}
   *
   * @param {THREE.Geometry|Mesh} bounds - the geometry or mesh that will determine the zone bounds
   * @param {number} scale - the zone scale
   * @param {THREE.Geometry} ThreeGeometry - the three geometry class
   * @return void
   */ constructor(bounds, scale = 1, ThreeGeometry){
        super((0, $6750d9f4d05ced14$export$9ca71e45661a213e));
        this.geometry = null;
        this.scale = scale;
        this.supportsCrossing = false;
        if (bounds.type && bounds.type === "Geometry") this.geometry = bounds;
        if (bounds.geometry) this.geometry = bounds.geometry;
        if (!this.geometry) throw new Error("MeshZone unable to set geometry from the supplied bounds");
        if (this.geometry.isBufferGeometry) this.geometry = new ThreeGeometry().fromBufferGeometry(this.geometry);
    }
}





class $ef5c8270299a26f4$export$2e2bcd8739ae039 extends (0, $7668cc91eb72a17a$export$2e2bcd8739ae039) {
    /**
   * Returns true to indicate this is a PointZone.
   *
   * @return {boolean}
   */ isPointZone() {
        return true;
    }
    getPosition() {
        this.vector.x = this.x;
        this.vector.y = this.y;
        this.vector.z = this.z;
        return this.vector;
    }
    /**
   * PointZone is a point zone
   * @param {Number|Vector3D} x - the center's x value or a Vector3D Object
   * @param {Number} y - the center's y value
   * @param {Number} z - the center's z value
   * @example
   * var pointZone = new System.PointZone(0,30,10);
   * or
   * var pointZone = new System.PointZone(new System.Vector3D(0,30,10));
   * @extends {Zone}
   * @constructor
   */ constructor(a, b, c){
        super((0, $6750d9f4d05ced14$export$224740a183ed091f)); // TODO see below, these should probably be assigned properly
        // eslint-disable-next-line
        var x, y, z;
        if ((0, $23c21dd81897876b$export$2e2bcd8739ae039).isUndefined(a, b, c)) x = y = z = 0;
        else {
            x = a; // eslint-disable-next-line
            y = b; // eslint-disable-next-line
            z = c;
        }
        this.x = x; // TODO shouldn't this be set to y?
        this.y = x; // TODO shouldn't this be set to z?
        this.z = x;
        this.supportsCrossing = false;
    }
}






class $d2e6f64c3d41fe98$export$2e2bcd8739ae039 extends (0, $7668cc91eb72a17a$export$2e2bcd8739ae039) {
    /**
   * Returns true to indicate this is a ScreenZone.
   *
   * @return {boolean}
   */ isScreenZone() {
        return true;
    }
    _dead(particle) {
        var pos = (0, $2e283c7833e9635b$export$2e2bcd8739ae039).toScreenPos(particle.position, this.camera, this.renderer.domElement);
        var canvas = this.renderer.domElement;
        if (pos.y + particle.radius < -this.dis && this.d1) particle.dead = true;
        else if (pos.y - particle.radius > canvas.height + this.dis && this.d3) particle.dead = true;
        if (pos.x + particle.radius < -this.dis && this.d4) particle.dead = true;
        else if (pos.x - particle.radius > canvas.width + this.dis && this.d2) particle.dead = true;
    }
    _bound(particle) {
        var pos = (0, $2e283c7833e9635b$export$2e2bcd8739ae039).toScreenPos(particle.position, this.camera, this.renderer.domElement);
        var canvas = this.renderer.domElement;
        if (pos.y + particle.radius < -this.dis) particle.velocity.y *= -1;
        else if (pos.y - particle.radius > canvas.height + this.dis) particle.velocity.y *= -1;
        if (pos.x + particle.radius < -this.dis) particle.velocity.y *= -1;
        else if (pos.x - particle.radius > canvas.width + this.dis) particle.velocity.y *= -1;
    }
    /**
   * ScreenZone is a 3d line zone
   * @param {Number|Vector3D} x1 - the line's start point of x value or a Vector3D Object
   * @param {Number|Vector3D} y1 - the line's start point of y value or a Vector3D Object
   * @param {Number} z1 - the line's start point of z value
   * @param {Number} x2 - the line's end point of x value
   * @param {Number} y2 - the line's end point of y value
   * @param {Number} z2 - the line's end point of z value
   * @example
   * var lineZone = new ScreenZone(0,0,0,100,100,0);
   * or
   * var lineZone = new ScreenZone(new Vector3D(0,0,0),new Vector3D(100,100,0));
   * @extends {Zone}
   * @constructor
   */ constructor(camera, renderer, dis, dir){
        super((0, $6750d9f4d05ced14$export$1aeb7174e41aa37a));
        this.camera = camera;
        this.renderer = renderer;
        this.dis = dis || 20;
        dir = dir || "1234";
        for(var i = 1; i < 5; i++)this["d" + i] = dir.indexOf(i + "") >= 0;
    }
}
$d2e6f64c3d41fe98$export$2e2bcd8739ae039.prototype.getPosition = function() {
    var vec2 = new (0, $4ecaf53387bdecca$export$2e2bcd8739ae039)(), canvas;
    return function() {
        canvas = this.renderer.domElement;
        vec2.x = Math.random() * canvas.width;
        vec2.y = Math.random() * canvas.height;
        this.vector.copy((0, $2e283c7833e9635b$export$2e2bcd8739ae039).toSpacePos(vec2, this.camera, canvas));
        return this.vector;
    };
}();
$d2e6f64c3d41fe98$export$2e2bcd8739ae039.prototype._cross = function() {
    var vec2 = new (0, $4ecaf53387bdecca$export$2e2bcd8739ae039)();
    return function(particle) {
        var pos = (0, $2e283c7833e9635b$export$2e2bcd8739ae039).toScreenPos(particle.position, this.camera, this.renderer.domElement);
        var canvas = this.renderer.domElement;
        if (pos.y + particle.radius < -this.dis) {
            vec2.x = pos.x;
            vec2.y = canvas.height + this.dis + particle.radius;
            particle.position.y = (0, $2e283c7833e9635b$export$2e2bcd8739ae039).toSpacePos(vec2, this.camera, canvas).y;
        } else if (pos.y - particle.radius > canvas.height + this.dis) {
            vec2.x = pos.x;
            vec2.y = -this.dis - particle.radius;
            particle.position.y = (0, $2e283c7833e9635b$export$2e2bcd8739ae039).toSpacePos(vec2, this.camera, canvas).y;
        }
        if (pos.x + particle.radius < -this.dis) {
            vec2.y = pos.y;
            vec2.x = canvas.width + this.dis + particle.radius;
            particle.position.x = (0, $2e283c7833e9635b$export$2e2bcd8739ae039).toSpacePos(vec2, this.camera, canvas).x;
        } else if (pos.x - particle.radius > canvas.width + this.dis) {
            vec2.y = pos.y;
            vec2.x = -this.dis - particle.radius;
            particle.position.x = (0, $2e283c7833e9635b$export$2e2bcd8739ae039).toSpacePos(vec2, this.camera, canvas).x;
        }
    };
}();







class $03928f17fcace199$export$2e2bcd8739ae039 extends (0, $7668cc91eb72a17a$export$2e2bcd8739ae039) {
    /**
   * Returns true to indicate this is a SphereZone.
   *
   * @return {boolean}
   */ isSphereZone() {
        return true;
    }
    /**
   * Sets the particle to dead if the particle collides with the sphere.
   *
   * @param {object} particle
   * @return void
   */ _dead(particle) {
        var d = particle.position.distanceTo(this);
        if (d - particle.radius > this.radius) particle.dead = true;
    }
    /**
   * Warns that this zone does not support the _cross method.
   *
   * @return void
   */ _cross() {
        console.warn(`${this.constructor.name} does not support the _cross method`);
    }
    /**
   * @constructs {SphereZone}
   *
   * @param {number} centerX - the sphere's center x coordinate
   * @param {number} centerY - the sphere's center y coordinate
   * @param {number} centerZ - the sphere's center z coordinate
   * @param {number} radius - the sphere's radius value
   * @return void
   */ constructor(centerX, centerY, centerZ, radius){
        super((0, $6750d9f4d05ced14$export$45cdd312cd8280a8)); // TODO see below, these should probably be assigned properly
        // eslint-disable-next-line
        let x, y, z, r;
        if ((0, $23c21dd81897876b$export$2e2bcd8739ae039).isUndefined(centerY, centerZ, radius)) {
            x = y = z = 0;
            r = centerX || 100;
        } else {
            x = centerX; // eslint-disable-next-line
            y = centerY; // eslint-disable-next-line
            z = centerZ;
            r = radius;
        }
        this.x = x; // TODO shouldn't this be set to y?
        this.y = x; // TODO shouldn't this be set to z?
        this.z = x;
        this.radius = r;
        this.the = this.phi = 0;
    }
}
$03928f17fcace199$export$2e2bcd8739ae039.prototype.getPosition = function() {
    var tha, phi, r;
    return function() {
        this.random = Math.random();
        r = this.random * this.radius;
        tha = (0, $c1da9e54204bbff9$export$6b5c1ceb16d01dc3) * Math.random(); //[0-pi]
        phi = (0, $c1da9e54204bbff9$export$6b5c1ceb16d01dc3) * 2 * Math.random(); //[0-2pi]
        this.vector.x = this.x + r * Math.sin(tha) * Math.cos(phi);
        this.vector.y = this.y + r * Math.sin(phi) * Math.sin(tha);
        this.vector.z = this.z + r * Math.cos(tha);
        return this.vector;
    };
}();
$03928f17fcace199$export$2e2bcd8739ae039.prototype._bound = function() {
    var normal = new (0, $4ecaf53387bdecca$export$2e2bcd8739ae039)(), v = new (0, $4ecaf53387bdecca$export$2e2bcd8739ae039)(), k;
    return function(particle) {
        var d = particle.position.distanceTo(this);
        if (d + particle.radius >= this.radius) {
            normal.copy(particle.position).sub(this).normalize();
            v.copy(particle.velocity);
            k = 2 * v.dot(normal);
            particle.velocity.sub(normal.scalar(k));
        }
    };
}();







const $1051606c509839db$var$_excluded = [
    "zoneType"
];
class $1051606c509839db$export$2e2bcd8739ae039 extends (0, $bf927956b698b24e$export$2e2bcd8739ae039) {
    /**
   * Resets the initializer properties.
   * Clears all previously set zones and resets the zones according to args passed.
   *
   * @param {Zone|array<Zone>}
   * @return void
   */ reset() {
        if (!this.zones) this.zones = [];
        else this.zones.length = 0;
        /**
     * @desc The zones to use as bounds for calculating the particle's starting position.
     * @type {array<Zone>}
     */ this.zones = this.zones.concat(Array.prototype.slice.call(arguments));
    }
    /**
   * Adds a zone or zones to this.zones.
   *
   * @param {Zone|array<Zone>}
   * @return void
   */ addZone() {
        this.zones = this.zones.concat(Array.prototype.slice.call(arguments));
    }
    /**
   * Creates a Position initializer from JSON.
   *
   * @param {object} json - The JSON to construct the instance from.
   * @param {string} json.zoneType - The type of zone to use for initial position
   * @return {Position}
   */ static fromJSON(json) {
        const { zoneType: zoneType } = json, params = (0, (/*@__PURE__*/$parcel$interopDefault($f5aa9b0d5cdbf30d$exports)))(json, $1051606c509839db$var$_excluded);
        if (!(0, $d975d6add471d316$export$72a77ef1e4cbedd5).includes(zoneType)) throw new Error(`The zone type ${zoneType} is invalid or not yet supported`);
        return new $1051606c509839db$export$2e2bcd8739ae039(new $0f5050993349035a$exports[zoneType](...Object.values(params)));
    }
    /**
   * Constructs a Position initializer instance.
   *
   * @param {Zone|array<Zone>}
   * @return void
   */ constructor(){
        super((0, $83f850ed9ddda6a7$export$4cbd4a5e129eef58));
        this.reset.apply(this, arguments);
    }
}
/**
 * Sets the particle's initial position.
 *
 * @param {Particle} particle - the particle to initialize the property on
 * @return void
 */ $1051606c509839db$export$2e2bcd8739ae039.prototype.initialize = function() {
    let zone;
    return function(target) {
        zone = this.zones[Math.random() * this.zones.length >> 0];
        zone.getPosition();
        target.position.x = zone.vector.x;
        target.position.y = zone.vector.y;
        target.position.z = zone.vector.z;
    };
}();





class $6053068a9f2caa98$export$2e2bcd8739ae039 extends (0, $bf927956b698b24e$export$2e2bcd8739ae039) {
    /**
   * Resets the initializer properties.
   * Clears all previously set zones and resets the zones according to args passed.
   *
   * @param {number} width - The width of the particle radius
   * @param {number} height - The height of the particle radius
   * @param {boolean} [center=false] - Determines whether to average the radius value
   * @return void
   */ reset(width, height, center = false) {
        this.radius = (0, $ef3653f168d58d59$export$47286723ded93599)(width, height, center);
    }
    /**
   * Sets the particle's initial radius.
   *
   * @param {Particle} particle - the particle to initialize the property on
   * @return void
   */ initialize(particle) {
        particle.radius = this.radius.getValue();
        particle.transform.oldRadius = particle.radius;
    }
    /**
   * Creates a Radius initializer from JSON.
   *
   * @param {object} json - The JSON to construct the instance from.
   * @property {number} json.width - The width of the particle radius
   * @property {number} json.height - The height of the particle radius
   * @property {number} json.center - The center of the particle radius
   * @return {Radius}
   */ static fromJSON(json) {
        const { width: width, height: height, center: center = false, isEnabled: isEnabled = true } = json;
        return new $6053068a9f2caa98$export$2e2bcd8739ae039(width, height, center, isEnabled);
    }
    /**
   * Constructs a Radius initializer instance.
   *
   * @param {number} width - The width of the particle radius
   * @param {number} height - The height of the particle radius
   * @param {boolean} [center=false] - Determines whether to average the radius value
   * @return void
   */ constructor(width, height, center = false, isEnabled = true){
        super((0, $83f850ed9ddda6a7$export$ed0ee694b4907565), isEnabled);
        /**
     * @desc The radius span which is used to set the particle radius value.
     * @type {Span}
     */ this.radius = (0, $ef3653f168d58d59$export$47286723ded93599)(width, height, center);
    }
}






class $c15ff10b1716ebd7$export$2e2bcd8739ae039 extends (0, $bf927956b698b24e$export$2e2bcd8739ae039) {
    /**
   * Sets the startTime and nextTime properties.
   *
   * @return void
   */ init() {
        this.startTime = 0;
        this.nextTime = this.timePan.getValue();
    }
    /**
   * Gets the number of particles to emit.
   *
   * @param {number} time - Current particle engine time
   * @return {number}
   */ getValue(time) {
        this.startTime += time;
        if (this.startTime >= this.nextTime) {
            this.init();
            if (this.numPan.b == 1) {
                if (this.numPan.getValue("Float") > 0.5) return 1;
                else return 0;
            } else return this.numPan.getValue("Int");
        }
        return 0;
    }
    /**
   * Creates a Rate initializer from JSON.
   *
   * @param {object} json - The JSON to construct the instance from.
   * @property {number} json.particlesMin - The minimum number of particles to emit
   * @property {number} json.particlesMax - The maximum number of particles to emit
   * @property {number} json.perSecondMin - The minimum per second emit rate
   * @property {number} json.perSecondMax - The maximum per second emit rate
   * @return {Rate}
   */ static fromJSON(json) {
        const { particlesMin: particlesMin, particlesMax: particlesMax, perSecondMin: perSecondMin, perSecondMax: perSecondMax } = json;
        return new $c15ff10b1716ebd7$export$2e2bcd8739ae039(new (0, $ef3653f168d58d59$export$2e2bcd8739ae039)(particlesMin, particlesMax), new (0, $ef3653f168d58d59$export$2e2bcd8739ae039)(perSecondMin, perSecondMax));
    }
    /**
   * Constructs a Rate instance.
   *
   * @param {number|array|Span} numPan - The number of particles to emit
   * @param {number|array|Span} timePan - The time between each particle emission
   * @return void
   */ constructor(numPan = (0, $fcf2ac7187899806$export$3c9d1a91d0b672b0), timePan = (0, $fcf2ac7187899806$export$c4bbdd44827e467e)){
        super((0, $83f850ed9ddda6a7$export$6764559e5e9f18a5));
        /**
     * @desc Sets the number of particles to emit.
     * @type {Span}
     */ this.numPan = (0, $ef3653f168d58d59$export$47286723ded93599)(numPan);
        /**
     * @desc Sets the time between each particle emission.
     * @type {Span}
     */ this.timePan = (0, $ef3653f168d58d59$export$47286723ded93599)(timePan);
        /**
     * @desc The rate's start time.
     * @type {number}
     */ this.startTime = 0;
        /**
     * @desc The rate's next time.
     * @type {number}
     */ this.nextTime = 0;
        this.init();
    }
}







function $65c4c9ef738c90b5$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $65c4c9ef738c90b5$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $65c4c9ef738c90b5$var$ownKeys(Object(source), true).forEach(function(key) {
            (0, (/*@__PURE__*/$parcel$interopDefault($cc894e2648a4bb4d$exports)))(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $65c4c9ef738c90b5$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
class $65c4c9ef738c90b5$export$2e2bcd8739ae039 extends (0, $bf927956b698b24e$export$2e2bcd8739ae039) {
    /**
   * Sets the particle body to the sprite.
   *
   * @param {Particle} particle - The particle to set the body of
   * @return void
   */ initialize(particle) {
        particle.body = this.sprite;
    }
    /**
   * Creates a Texture initializer from JSON.
   *
   * @param {object} json - The JSON to construct the instance from
   * @param {object} THREE - The Web GL API we are using eg., THREE
   * @param {Texture} json.loadedTexture - The loaded sprite texture
   * @param {object} json.materialProperties - The sprite material properties
   * @return {BodySprite}
   */ static fromJSON(json, THREE) {
        const { loadedTexture: loadedTexture, materialProperties: materialProperties = (0, $fcf2ac7187899806$export$ee70a7b8619e0e1c), isEnabled: isEnabled = true } = json;
        const ensureMappedBlendingMode = (properties)=>{
            const { blending: blending } = properties;
            return $65c4c9ef738c90b5$var$_objectSpread($65c4c9ef738c90b5$var$_objectSpread({}, properties), {}, {
                blending: blending ? (0, $fcf2ac7187899806$export$a6824bc8131e6e84)[blending] : (0, $fcf2ac7187899806$export$a6824bc8131e6e84)[(0, $fcf2ac7187899806$export$ee70a7b8619e0e1c).blending]
            });
        };
        return new $65c4c9ef738c90b5$export$2e2bcd8739ae039(THREE, loadedTexture, (0, $57c3e4483130738d$export$4df9c0969a9e0160)((0, $fcf2ac7187899806$export$ee70a7b8619e0e1c), ensureMappedBlendingMode(materialProperties)), isEnabled);
    }
    /**
   * Constructs an Texture initializer.
   *
   * @param {object} THREE - The Web GL API we are using eg., THREE
   * @param {string} texture - The sprite texture
   * @param {object|undefined} materialProperties - The sprite material properties
   * @param {?Texture} loadedTexture - Preloaded THREE.Texture instance
   */ constructor(THREE, loadedTexture, materialProperties = (0, $fcf2ac7187899806$export$93a17cfa3462e135), isEnabled = true){
        super((0, $83f850ed9ddda6a7$export$b615b6b5bb0ad3de), isEnabled);
        const { Sprite: Sprite, SpriteMaterial: SpriteMaterial } = THREE;
        /**
     * @desc The material properties for this object's SpriteMaterial
     * NOTE This is required for testing purposes
     * @type {object}
     */ this.materialProperties = (0, $57c3e4483130738d$export$4df9c0969a9e0160)((0, $fcf2ac7187899806$export$93a17cfa3462e135), materialProperties);
        /**
     * @desc The texture for the THREE.SpriteMaterial map.
     * @type {Texture}
     */ this.texture = loadedTexture;
        /**
     * @desc THREE.SpriteMaterial instance.
     * @type {SpriteMaterial}
     */ this.material = new SpriteMaterial($65c4c9ef738c90b5$var$_objectSpread($65c4c9ef738c90b5$var$_objectSpread({}, {
            map: loadedTexture
        }), this.materialProperties));
        /**
     * @desc THREE.Sprite instance.
     * @type {Sprite}
     */ this.sprite = new Sprite(this.material);
    }
}







class $7096bbce1a82da4b$export$2e2bcd8739ae039 extends (0, $bf927956b698b24e$export$2e2bcd8739ae039) {
    normalize(vr) {
        return vr * (0, $c1da9e54204bbff9$export$20471946a1148a1b);
    }
    /**
   * Constructs a Velocity intitializer instance.
   *
   * @return void
   */ constructor(type, isEnabled = true){
        super(type, isEnabled);
        /**
     * @desc Directional vector
     * @type {Vector3D}
     */ this.dirVec = new (0, $4ecaf53387bdecca$export$2e2bcd8739ae039)(0, 0, 0);
    }
}
/**
 * Sets the particle's initial velocity.
 *
 * @singleton
 * @param {Particle} particle - the particle to initialize the property on
 * @return void
 */ $7096bbce1a82da4b$export$2e2bcd8739ae039.prototype.initialize = function() {
    var tha;
    var normal = new (0, $4ecaf53387bdecca$export$2e2bcd8739ae039)(0, 0, 1);
    var v = new (0, $4ecaf53387bdecca$export$2e2bcd8739ae039)(0, 0, 0);
    return function initialize(particle) {
        tha = this.tha * Math.random();
        this._useV && this.dirVec.copy(this.dir).scalar(this.radiusPan.getValue());
        (0, $7e29c48cc36f8eff$export$2e2bcd8739ae039).getNormal(this.dirVec, normal);
        v.copy(this.dirVec).applyAxisAngle(normal, tha);
        v.applyAxisAngle(this.dirVec.normalize(), Math.random() * (0, $c1da9e54204bbff9$export$6b5c1ceb16d01dc3) * 2);
        particle.velocity.copy(v);
        return this;
    };
}();



class $08dfd6acbde0a188$export$2e2bcd8739ae039 extends (0, $7096bbce1a82da4b$export$2e2bcd8739ae039) {
    /**
   * Creates a PolarVelocity initializer from JSON.
   *
   * @param {object} json - The JSON to construct the instance from.
   * @param {number} json.polarRadius - The Polar3D radius
   * @param {number} json.polarTheta - The Polar3D theta
   * @param {number} json.polarPhi - The Polar3D phi
   * @param {number} json.velocityTheta - The velocity theta
   * @return {PolarVelocity}
   */ static fromJSON(json) {
        const { polarRadius: polarRadius, polarTheta: polarTheta, polarPhi: polarPhi, velocityTheta: velocityTheta, isEnabled: isEnabled = true } = json;
        return new $08dfd6acbde0a188$export$2e2bcd8739ae039(new (0, $85c395a0a34c8085$export$2e2bcd8739ae039)(polarRadius, polarTheta, polarPhi), velocityTheta, isEnabled);
    }
    /**
   * Constructs a PolarVelocity initializer.
   *
   * @param {Polar3D} polar3d - The polar vector for the velocity
   * @param {number} theta - The theta angle to use
   * @return void
   */ constructor(polar3d, theta, isEnabled = true){
        super((0, $83f850ed9ddda6a7$export$30a3f65ebc8fd963), isEnabled);
        /**
     * @desc Theta.
     * @type {number}
     */ this.tha = theta * (0, $c1da9e54204bbff9$export$590ba8a5a3bd5910);
        /**
     * @desc Directional vector
     * @type {Vector3D}
     */ this.dirVec = polar3d.toVector3D();
        /**
     * @desc Determines whether to use the directional vector or not.
     * @type {boolean}
     */ this._useV = false;
    }
}






class $815217306acadcd1$export$2e2bcd8739ae039 extends (0, $7096bbce1a82da4b$export$2e2bcd8739ae039) {
    /**
   * Creates a RadialVelocity initializer from JSON.
   *
   * @param {object} json - The JSON to construct the instance from.
   * @param {number} json.radius - The velocity radius
   * @param {number} json.x - The velocity x axis direction
   * @param {number} json.y - The velocity y axis direction
   * @param {number} json.z - The velocity z axis direction
   * @param {number} json.theta - The velocity theta
   * @return {RadialVelocity}
   */ static fromJSON(json) {
        const { radius: radius, x: x, y: y, z: z, theta: theta, isEnabled: isEnabled = true } = json;
        return new $815217306acadcd1$export$2e2bcd8739ae039(radius, new (0, $4ecaf53387bdecca$export$2e2bcd8739ae039)(x, y, z), theta, isEnabled);
    }
    /**
   * Constructs a RadialVelocity initializer.
   *
   * @param {number|Span} radius - The velocity radius
   * @param {Vector3D} vector3d - The directional vector for the velocity
   * @param {number} theta - The theta angle to use
   * @return void
   */ constructor(radius, vector3d, theta, isEnabled = true){
        super((0, $83f850ed9ddda6a7$export$c1477f2eb8bd1522), isEnabled);
        /**
     * @desc Velocity radius span.
     * @type {Span}
     */ this.radiusPan = (0, $ef3653f168d58d59$export$47286723ded93599)(radius);
        /**
     * @desc Direction vector.
     * @type {Vector3D}
     */ this.dir = vector3d.clone().normalize();
        /**
     * @desc Theta.
     * @type {number}
     */ this.tha = theta * (0, $c1da9e54204bbff9$export$590ba8a5a3bd5910);
        /**
     * @desc Determines whether to use the directional vector or not.
     * @type {boolean}
     */ this._useV = true;
    }
}






class $c86cf4346ebc2d7e$export$2e2bcd8739ae039 extends (0, $7096bbce1a82da4b$export$2e2bcd8739ae039) {
    /**
   * Creates a VectorVelocity initializer from JSON.
   *
   * @param {object} json - The JSON to construct the instance from.
   * @param {number} json.x - The velocity x axis direction
   * @param {number} json.y - The velocity y axis direction
   * @param {number} json.z - The velocity z axis direction
   * @param {number} json.theta - The velocity theta
   * @return {VectorVelocity}
   */ static fromJSON(json) {
        const { x: x, y: y, z: z, theta: theta, isEnabled: isEnabled = true } = json;
        return new $c86cf4346ebc2d7e$export$2e2bcd8739ae039(new (0, $4ecaf53387bdecca$export$2e2bcd8739ae039)(x, y, z), theta, isEnabled);
    }
    /**
   * Constructs a VectorVelocity initializer.
   *
   * @param {Vector3D} vector3d - The directional vector for the velocity
   * @param {number} theta - The theta angle to use
   * @return void
   */ constructor(vector3d, theta, isEnabled = true){
        super((0, $83f850ed9ddda6a7$export$1e0160107f8e88ab), isEnabled);
        /**
     * @desc Velocity radius span.
     * @type {Span}
     */ this.radiusPan = (0, $ef3653f168d58d59$export$47286723ded93599)(1);
        /**
     * @desc Direction vector.
     * @type {Vector3D}
     */ this.dir = vector3d.clone();
        /**
     * @desc Theta.
     * @type {number}
     */ this.tha = theta * (0, $c1da9e54204bbff9$export$590ba8a5a3bd5910);
        /**
     * @desc Determines whether to use the directional vector or not.
     * @type {boolean}
     */ this._useV = true;
    }
}






const $4ea9fdd59c46a1e5$export$50ec6844c5aad311 = 0.006;
const $4ea9fdd59c46a1e5$export$e06aec48b2c70a0b = true;
const $4ea9fdd59c46a1e5$export$66d28a5d6a34e370 = new (0, $c15ff10b1716ebd7$export$2e2bcd8739ae039)(1, 0.1);
const $4ea9fdd59c46a1e5$export$10e278b2cc5eb367 = false;
const $4ea9fdd59c46a1e5$export$4eb8817684ff7a12 = undefined;







var $1ee99162750a5b49$exports = {};


/** `Object#toString` result references. */ var $1ee99162750a5b49$var$numberTag = "[object Number]";
/**
 * Checks if `value` is classified as a `Number` primitive or object.
 *
 * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
 * classified as numbers, use the `_.isFinite` method.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a number, else `false`.
 * @example
 *
 * _.isNumber(3);
 * // => true
 *
 * _.isNumber(Number.MIN_VALUE);
 * // => true
 *
 * _.isNumber(Infinity);
 * // => true
 *
 * _.isNumber('3');
 * // => false
 */ function $1ee99162750a5b49$var$isNumber(value) {
    return typeof value == "number" || $25f4b69c31dfd9c9$exports(value) && $70010753e0cd19ef$exports(value) == $1ee99162750a5b49$var$numberTag;
}
$1ee99162750a5b49$exports = $1ee99162750a5b49$var$isNumber;


const $3096c998c6de9d20$export$2035594ba8734d6f = "Emitter";
const $3096c998c6de9d20$export$92bcd9be8faff9f = "FollowEmitter";


class $975f8eaf1ecebbca$export$2e2bcd8739ae039 extends (0, $65e050f2a1a2716c$export$2e2bcd8739ae039) {
    /**
   * Proxy method for the internal event dispatcher's dispatchEvent method.
   *
   * @param {string} event - The event to dispatch
   * @param {object<Particle>} [target=this] - The event target
   */ dispatch(event, target = this) {
        this.eventDispatcher.dispatchEvent(event, target);
    }
    /**
   * Sets the emitter rate.
   *
   * @param {Rate} rate - a rate initializer object
   * @return {Emitter}
   */ setRate(rate) {
        this.rate = rate;
        return this;
    }
    /**
   * Sets the position of the emitter.
   *
   * @param {object} newPosition - an object the new x, y and z props
   * @return {Emitter}
   */ setPosition(newPosition = {}) {
        const { position: position } = this;
        const { x: x = position.x, y: y = position.y, z: z = position.z } = newPosition;
        this.position.set(x, y, z);
        return this;
    }
    /**
   * Sets the rotation of the emitter.
   *
   * @param {object} newRotation - an object the new x, y and z props
   * @return {Emitter}
   */ setRotation(newRotation = {}) {
        const { rotation: rotation } = this;
        const { x: x = rotation.x, y: y = rotation.y, z: z = rotation.z } = newRotation;
        this.rotation.set(x, y, z);
        return this;
    }
    /**
   * Sets the total number of times the emitter should emit particles as well as
   * the emitter's life. Also intializes the emitter rate.
   * This enables the emitter to emit particles.
   *
   * @param {number} [totalEmitTimes=Infinity] - the total number of times to emit particles
   * @param {number} [life=Infinity] - the life of this emitter in milliseconds
   * @return {Emitter}
   */ emit(totalEmitTimes = Infinity, life = Infinity) {
        this.currentEmitTime = 0;
        this.totalEmitTimes = (0, (/*@__PURE__*/$parcel$interopDefault($1ee99162750a5b49$exports)))(totalEmitTimes) ? totalEmitTimes : Infinity;
        if (totalEmitTimes === 1) this.life = totalEmitTimes;
        else this.life = (0, (/*@__PURE__*/$parcel$interopDefault($1ee99162750a5b49$exports)))(life) ? life : Infinity;
        this.rate.init();
        this.isEmitting = true;
        return this;
    }
    /**
   * Experimental emit method that is designed to be called from the System.emit method.
   *
   * @return {Emitter}
   */ experimental_emit() {
        const { isEmitting: isEmitting, totalEmitTimes: totalEmitTimes, life: life } = this;
        if (!isEmitting) {
            this.currentEmitTime = 0;
            if (!totalEmitTimes) this.setTotalEmitTimes(Infinity);
            if (!life) this.setLife(Infinity);
            this.rate.init();
            this.isEmitting = true;
        }
        return this;
    }
    /**
   * Sets the total emit times for the emitter.
   *
   * @param {number} [totalEmitTimes=Infinity] - the total number of times to emit particles
   * @return {Emitter}
   */ setTotalEmitTimes(totalEmitTimes = Infinity) {
        this.totalEmitTimes = (0, (/*@__PURE__*/$parcel$interopDefault($1ee99162750a5b49$exports)))(totalEmitTimes) ? totalEmitTimes : Infinity;
        return this;
    }
    /**
   * Sets the life of the emitter.
   *
   * @param {number} [life=Infinity] - the life of this emitter in milliseconds
   * @return {Emitter}
   */ setLife(life = Infinity) {
        if (this.totalEmitTimes === 1) this.life = this.totalEmitTimes;
        else this.life = (0, (/*@__PURE__*/$parcel$interopDefault($1ee99162750a5b49$exports)))(life) ? life : Infinity;
        return this;
    }
    /**
   * Stops the emitter from emitting particles.
   *
   * @return void
   */ stopEmit() {
        this.totalEmitTimes = -1;
        this.currentEmitTime = 0;
        this.isEmitting = false;
    }
    /**
   * Kills all of the emitter's particles.
   *
   * @return void
   */ removeAllParticles() {
        let i = this.particles.length;
        while(i--)this.particles[i].dead = true;
    }
    /**
   * Adds a particle initializer to the emitter.
   * Each initializer is run on each particle when they are created.
   *
   * @param {Initializer} initializer - The initializer to add
   * @return {Emitter}
   */ addInitializer(initializer) {
        this.initializers.push(initializer);
        return this;
    }
    /**
   * Adds multiple particle initializers to the emitter.
   *
   * @param {array<Initializer>} initializers - an array of particle initializers
   * @return {Emitter}
   */ addInitializers(initializers) {
        let i = initializers.length;
        while(i--)this.addInitializer(initializers[i]);
        return this;
    }
    /**
   * Sets the emitter's particle initializers.
   *
   * @param {array<Initializer>} initializers - an array of particle initializers
   * @return {Emitter}
   */ setInitializers(initializers) {
        this.initializers = initializers;
        return this;
    }
    /**
   * Removes an initializer from the emitter's initializers array.
   *
   * @param {Initializer} initializer - The initializer to remove
   * @return {Emitter}
   */ removeInitializer(initializer) {
        const index = this.initializers.indexOf(initializer);
        if (index > -1) this.initializers.splice(index, 1);
        return this;
    }
    /**
   * Removes all initializers.
   *
   * @return {Emitter}
   */ removeAllInitializers() {
        (0, $23c21dd81897876b$export$2e2bcd8739ae039).destroyArray(this.initializers);
        return this;
    }
    /**
   * Adds a behaviour to the emitter. All emitter behaviours are added to each particle when
   * they are emitted.
   *
   * @param {Behaviour} behaviour - The behaviour to add to the emitter
   * @return {Emitter}
   */ addBehaviour(behaviour) {
        this.behaviours.push(behaviour);
        return this;
    }
    /**
   * Adds multiple behaviours to the emitter.
   *
   * @param {array<Behaviour>} behaviours - an array of emitter behaviours
   * @return {Emitter}
   */ addBehaviours(behaviours) {
        let i = behaviours.length;
        while(i--)this.addBehaviour(behaviours[i]);
        return this;
    }
    /**
   * Sets the emitter's behaviours.
   *
   * @param {array<Behaviour>} behaviours - an array of emitter behaviours
   * @return {Emitter}
   */ setBehaviours(behaviours) {
        this.behaviours = behaviours;
        return this;
    }
    /**
   * Removes the behaviour from the emitter's behaviours array.
   *
   * @param {Behaviour} behaviour - The behaviour to remove
   * @return {Emitter}
   */ removeBehaviour(behaviour) {
        const index = this.behaviours.indexOf(behaviour);
        if (index > -1) this.behaviours.splice(index, 1);
        return this;
    }
    /**
   * Removes all behaviours from the emitter.
   *
   * @return {Emitter}
   */ removeAllBehaviours() {
        (0, $23c21dd81897876b$export$2e2bcd8739ae039).destroyArray(this.behaviours);
        return this;
    }
    /**
   * Adds an emitter behaviour to the emitter.
   *
   * @param {Behaviour} behaviour - The behaviour to add to the emitter
   * @return {Emitter}
   */ addEmitterBehaviour(behaviour) {
        this.emitterBehaviours.push(behaviour);
        behaviour.initialize(this);
        return this;
    }
    /**
   * Adds multiple behaviours to the emitter.
   *
   * @param {array<Behaviour>} behaviours - an array of emitter behaviours
   * @return {Emitter}
   */ addEmitterBehaviours(behaviours) {
        let i = behaviours.length;
        while(i--)this.addEmitterBehaviour(behaviours[i]);
        return this;
    }
    /**
   * Sets the emitter's behaviours.
   *
   * @param {array<Behaviour>} behaviours - an array of emitter behaviours
   * @return {Emitter}
   */ setEmitterBehaviours(behaviours) {
        const length = behaviours.length;
        this.emitterBehaviours = behaviours;
        for(let i = 0; i < length; i++)this.emitterBehaviours[i].initialize(this);
        return this;
    }
    /**
   * Removes the behaviour from the emitter's behaviours array.
   *
   * @param {Behaviour} behaviour - The behaviour to remove
   * @return {Emitter}
   */ removeEmitterBehaviour(behaviour) {
        const index = this.emitterBehaviours.indexOf(behaviour);
        if (index > -1) this.emitterBehaviours.splice(index, 1);
        return this;
    }
    /**
   * Removes all behaviours from the emitter.
   *
   * @return {Emitter}
   */ removeAllEmitterBehaviours() {
        (0, $23c21dd81897876b$export$2e2bcd8739ae039).destroyArray(this.emitterBehaviours);
        return this;
    }
    /**
   * Adds the event listener for the EMITTER_DEAD event.
   *
   * @param {onEmitterDead} - The function to call when the EMITTER_DEAD is dispatched.
   * @return {Emitter}
   */ addOnEmitterDeadEventListener(onEmitterDead) {
        this.eventDispatcher.addEventListener(`${this.id}_${(0, $4d2ddc8f9664085f$export$95fe715649d4ca1a)}`, ()=>onEmitterDead());
        return this;
    }
    /**
   * Creates a particle by retreiving one from the pool and setting it up with
   * the supplied initializer and behaviour.
   *
   * @return {Emitter}
   */ createParticle() {
        const particle = this.parent.pool.get((0, $65e050f2a1a2716c$export$2e2bcd8739ae039));
        const index = this.particles.length;
        this.setupParticle(particle, index);
        this.parent && this.parent.dispatch((0, $4d2ddc8f9664085f$export$421681fbc92d2c7c), particle);
        this.bindEmitterEvent && this.dispatch((0, $4d2ddc8f9664085f$export$421681fbc92d2c7c), particle);
        return particle;
    }
    /**
   * Sets up a particle by running all initializers on it and setting its behaviours.
   * Also adds the particle to this.particles.
   *
   * @param {Particle} particle - The particle to setup
   * @return void
   */ setupParticle(particle, index) {
        const { initializers: initializers, behaviours: behaviours } = this;
        (0, $f31ac9fbc63fe87b$export$2e2bcd8739ae039).initialize(this, particle, initializers);
        particle.addBehaviours(behaviours);
        particle.parent = this;
        particle.index = index;
        this.particles.push(particle);
    }
    /**
   * Updates the emitter according to the time passed by calling the generate
   * and integrate methods. The generate method creates particles, the integrate
   * method updates existing particles.
   *
   * If the emitter age is greater than time, the emitter is killed.
   *
   * This method also indexes/deindexes particles.
   *
   * @param {number} time - System engine time
   * @return void
   */ update(time) {
        if (!this.isEmitting) return;
        this.age += time;
        if (this.dead || this.age >= this.life) this.destroy();
        this.generate(time);
        this.integrate(time);
        let i = this.particles.length;
        while(i--){
            const particle = this.particles[i];
            if (particle.dead) {
                this.parent && this.parent.dispatch((0, $4d2ddc8f9664085f$export$2204007c8bf30e02), particle);
                this.bindEmitterEvent && this.dispatch((0, $4d2ddc8f9664085f$export$2204007c8bf30e02), particle);
                this.parent.pool.expire(particle.reset());
                this.particles.splice(i, 1);
            }
        }
        this.updateEmitterBehaviours(time);
    }
    /**
   * Updates the emitter's emitter behaviours.
   *
   * @param {number} time - System engine time
   * @return void
   */ updateEmitterBehaviours(time) {
        if (this.sleep) return;
        const length = this.emitterBehaviours.length;
        for(let i = 0; i < length; i++)this.emitterBehaviours[i].applyBehaviour(this, time, i);
    }
    /**
   * Runs the integration algorithm on the emitter and all particles.
   * Updates the particles with the timstamp passed.
   *
   * @param {number} time - System engine time
   * @return void
   */ integrate(time) {
        const integrationType = this.parent ? this.parent.integrationType : (0, $3aa7c721e9776547$export$ee71156541331f4c);
        const damping = 1 - this.damping;
        (0, $20448755a0d15e35$export$df970fd884294dfc)(this, time, damping, integrationType);
        let index = this.particles.length;
        while(index--){
            const particle = this.particles[index];
            particle.update(time, index);
            (0, $20448755a0d15e35$export$df970fd884294dfc)(particle, time, damping, integrationType);
            this.parent && this.parent.dispatch((0, $4d2ddc8f9664085f$export$868dbb69ba0499ec), particle);
            this.bindEmitterEvent && this.dispatch((0, $4d2ddc8f9664085f$export$868dbb69ba0499ec), particle);
        }
    }
    /**
   * Generates new particles.
   *
   * @param {number} time - System engine time
   * @return void
   */ generate(time) {
        if (this.totalEmitTimes === 1) {
            let i = this.rate.getValue(99999);
            if (i > 0) this.cID = i;
            while(i--)this.createParticle();
            this.totalEmitTimes = 0;
            return;
        }
        this.currentEmitTime += time;
        if (this.currentEmitTime < this.totalEmitTimes) {
            let i = this.rate.getValue(time);
            if (i > 0) this.cID = i;
            while(i--)this.createParticle();
        }
    }
    /**
   * Kills the emitter.
   *
   * @return void
   */ destroy() {
        this.dead = true;
        this.energy = 0;
        this.totalEmitTimes = -1;
        if (this.particles.length == 0) {
            this.isEmitting = false;
            this.removeAllInitializers();
            this.removeAllBehaviours();
            this.dispatch(`${this.id}_${(0, $4d2ddc8f9664085f$export$95fe715649d4ca1a)}`);
            this.parent && this.parent.removeEmitter(this);
        }
    }
    /**
   * Constructs an Emitter instance.
   *
   * @param {object} properties - The properties to instantiate the emitter with
   * @return void
   */ constructor(properties){
        super(properties);
        /**
     * @desc The class type.
     * @type {string}
     */ this.type = (0, $3096c998c6de9d20$export$2035594ba8734d6f);
        /**
     * @desc The particles emitted by this emitter.
     * @type {array}
     */ this.particles = [];
        /**
     * @desc The initializers for particles emitted by this emitter.
     * @type {array}
     */ this.initializers = [];
        /**
     * @desc The behaviours for particles emitted by this emitter.
     * @type {array}
     */ this.behaviours = [];
        /**
     * @desc The behaviours for the emitter.
     * @type {array}
     */ this.emitterBehaviours = [];
        /**
     * @desc The current emit iteration.
     * @type {integer}
     */ this.currentEmitTime = 0;
        /**
     * @desc The total number of times the emitter should emit particles.
     * @type {integer}
     */ this.totalEmitTimes = -1;
        /**
     * @desc The friction coefficient for all particle to emit by.
     * @type {number}
     */ this.damping = (0, $4ea9fdd59c46a1e5$export$50ec6844c5aad311);
        /**
     * @desc Ensures that particles emitted by this emitter are positioned
     * according to the emitter's properties.
     * @type {boolean}
     */ this.bindEmitter = (0, $4ea9fdd59c46a1e5$export$e06aec48b2c70a0b);
        /**
     * @desc Determines if the emitter will dispatch internal events. Defaults
     * to false
     * @type {boolean}
     */ this.bindEmitterEvent = (0, $4ea9fdd59c46a1e5$export$10e278b2cc5eb367);
        /**
     * @desc The number of particles to emit per second (a [particle]/b [s])
     * @type {Rate}
     */ this.rate = (0, $4ea9fdd59c46a1e5$export$66d28a5d6a34e370);
        /**
     * @desc Determines if the emitter is emitting particles or not.
     * @type {boolean}
     */ this.isEmitting = false;
        /**
     * @desc The emitter's id.
     * @type {string}
     */ this.id = `emitter-${(0, $6cfca16ba6df6e64$export$2e2bcd8739ae039)()}`;
        this.cID = 0;
        this.name = "Emitter";
        /**
     * @desc The index of the emitter as it is added to the system.
     * @type {number|undefined}
     */ this.index = (0, $4ea9fdd59c46a1e5$export$4eb8817684ff7a12);
        /**
     * @desc The emitter's internal event dispatcher.
     * @type {EventDispatcher}
     */ this.eventDispatcher = new (0, $048d8be74dedd185$export$2e2bcd8739ae039)();
    }
}





var $020317c09ee00888$exports = {};

$parcel$export($020317c09ee00888$exports, "Alpha", function () { return $9a23004203249681$export$2e2bcd8739ae039; });
$parcel$export($020317c09ee00888$exports, "Attraction", function () { return $a1d3e9c353152760$export$2e2bcd8739ae039; });
$parcel$export($020317c09ee00888$exports, "Collision", function () { return $d3d7f6cd1281276c$export$2e2bcd8739ae039; });
$parcel$export($020317c09ee00888$exports, "Color", function () { return $f505290032053e83$export$2e2bcd8739ae039; });
$parcel$export($020317c09ee00888$exports, "CrossZone", function () { return $5dfe7e54c9441929$export$2e2bcd8739ae039; });
$parcel$export($020317c09ee00888$exports, "Force", function () { return $2ff1af638d7ac763$export$2e2bcd8739ae039; });
$parcel$export($020317c09ee00888$exports, "Gravity", function () { return $06f04aead93c21e3$export$2e2bcd8739ae039; });
$parcel$export($020317c09ee00888$exports, "RandomDrift", function () { return $236adaaa9c65dcf8$export$2e2bcd8739ae039; });
$parcel$export($020317c09ee00888$exports, "Repulsion", function () { return $ee953406fcd4cd05$export$2e2bcd8739ae039; });
$parcel$export($020317c09ee00888$exports, "Rotate", function () { return $275cc25265e5b0fe$export$2e2bcd8739ae039; });
$parcel$export($020317c09ee00888$exports, "Scale", function () { return $731b44e61c44f44f$export$2e2bcd8739ae039; });
$parcel$export($020317c09ee00888$exports, "Spring", function () { return $57a2048e73bf0a51$export$2e2bcd8739ae039; });
$parcel$export($020317c09ee00888$exports, "Behaviour", function () { return $bef8ae8b9f5ff381$export$2e2bcd8739ae039; });


const $64459a10eda38326$export$2f1a74589dda35c3 = Infinity;
const $64459a10eda38326$export$e37c9d92136530ab = 1000;
const $64459a10eda38326$export$9051f10cfcd3a1af = 100;
const $64459a10eda38326$export$c5728778d50477cf = (0, $4bdda5ce454f9cb4$export$5d6e1e4631108fd5);
const $64459a10eda38326$export$3750c0a6931dbd27 = "easeLinear";
const $64459a10eda38326$export$ffe086099c9b9d89 = 0.03;
const $64459a10eda38326$export$65213b14bce0ded6 = 0.002;
const $64459a10eda38326$export$a9939cbe2e014685 = 0.000004;
const $64459a10eda38326$export$91a93c4b9fe20707 = "dead";






class $bef8ae8b9f5ff381$export$2e2bcd8739ae039 {
    /**
   * Reset this behaviour's parameters
   *
   * @param {number} [life=DEFAULT_LIFE] - The life of the behaviour
   * @param {function} [easing=DEFAULT_BEHAVIOUR_EASING] - The behaviour's decaying trend
   */ reset(life = (0, $64459a10eda38326$export$2f1a74589dda35c3), easing = (0, $64459a10eda38326$export$c5728778d50477cf)) {
        this.life = life;
        this.easing = easing || (0, $64459a10eda38326$export$c5728778d50477cf);
    }
    /**
   * Ensures that life is infinity if an invalid value is supplied.
   *
   * @return void
   */ set life(life) {
        this._life = (0, (/*@__PURE__*/$parcel$interopDefault($1ee99162750a5b49$exports)))(life) ? life : (0, $64459a10eda38326$export$2f1a74589dda35c3);
    }
    /**
   * Gets the behaviour's life.
   *
   * @return {Number}
   */ get life() {
        return this._life;
    }
    /**
   * Normalize a force by 1:100;
   *
   * @param {Vector3D} force - The force to normalize.
   * @return {Vector3D}
   */ normalizeForce(force) {
        return force.scalar((0, $c1da9e54204bbff9$export$20471946a1148a1b));
    }
    /**
   * Normalize a value by 1:100;
   *
   * @param {number} value - The value to normalize
   * @return {number}
   */ normalizeValue(value) {
        return value * (0, $c1da9e54204bbff9$export$20471946a1148a1b);
    }
    /**
   * Set the behaviour's initial properties on the particle.
   *
   * @param {Particle} particle
   * @abstract
   */ initialize(particle) {}
    /**
   * Apply behaviour to the target as a factor of time.
   * Internally calls the mutate method to change properties on the target
   * Will not do so if the behaviour is disabled
   *
   * @abstract
   * @param {Particle|Emitter} target - The particle or emitter to apply the behaviour to
   * @param {Number} time - the system integration time
   * @param {integer} index - the target index
   * @return mixed
   */ applyBehaviour(target, time, index) {
        if (!this.isEnabled) return;
        this.mutate(target, time, index);
    }
    /**
   * Change the target's properties according to specific behaviour logic.
   *
   * @abstract
   * @param {Particle|Emitter} target - The particle or emitter to apply the behaviour to
   * @param {Number} time - the system integration time
   * @return mixed
   */ mutate(target, time, index) {}
    /**
   * Compares the age of the behaviour vs integration time and determines
   * if the behaviour should be set to dead or not.
   * Sets the behaviour energy as a factor of particle age and life.
   *
   * @param {Particle} particle - The particle to apply the behaviour to
   * @param {Number} time - the system integration time
   * @return void
   */ energize(particle, time) {
        if (this.dead) return;
        this.age += time;
        if (this.age >= this.life) {
            this.energy = 0;
            this.dead = true;
            return;
        }
        const scale = this.easing(particle.age / particle.life);
        this.energy = Math.max(1 - scale, 0);
    }
    /**
   * Destory this behaviour.
   *
   * @abstract
   */ destroy() {}
    /**
   * Returns a new instance of the behaviour from the JSON object passed.
   *
   * @abstract
   * @param {object} json - JSON object containing the required constructor properties
   * @return {Behaviour}
   */ fromJSON(json) {}
    /**
   * Constructs a Behaviour instance.
   *
   * @param {number} [life=Infinity] - The life of the behaviour
   * @param {function} [easing=DEFAULT_BEHAVIOUR_EASING] - The behaviour's decaying trend
   * @param {string} [type=BEHAVIOUR_TYPE_ABSTRACT] - The behaviour type
   * @param {boolean} [isEnabled=true] - Determines if the behaviour will be applied or not
   * @return void
   */ constructor(life = Infinity, easing = (0, $64459a10eda38326$export$c5728778d50477cf), type = (0, $2732299af51e9693$export$29c7f024da80d1e5), isEnabled = true){
        /**
     * @desc The class type.
     * @type {string}
     */ this.type = type;
        /**
     * @desc Determines if the behaviour will be applied or not
     * @type {boolean}
     */ this.isEnabled = isEnabled;
        /**
     * @desc The behaviour's id
     * @type {string} id
     */ this.id = `behaviour-${(0, $6cfca16ba6df6e64$export$2e2bcd8739ae039)()}`;
        /**
     * @desc The life of the behaviour
     * @type {number}
     */ this.life = life;
        /**
     * @desc The behaviour's decaying trend
     * @type {function}
     */ this.easing = easing;
        /**
     * @desc The age of the behaviour
     * @type {number}
     */ this.age = 0;
        /**
     * @desc The energy of the behaviour
     * @type {number}
     */ this.energy = 1;
        /**
     * Determines if the behaviour is dead or not
     * @type {boolean}
     */ this.dead = false;
    }
}





class $9a23004203249681$export$2e2bcd8739ae039 extends (0, $bef8ae8b9f5ff381$export$2e2bcd8739ae039) {
    /**
   * Gets the _same property which determines if the alpha are the same.
   *
   * @return {boolean}
   */ get same() {
        return this._same;
    }
    /**
   * Sets the _same property which determines if the alpha are the same.
   *
   * @param {boolean} same
   * @return {boolean}
   */ set same(same) {
        /**
     * @type {boolean}
     */ this._same = same;
    }
    /**
   * Resets the behaviour properties.
   *
   * @param {number} alphaA - the starting alpha value
   * @param {?number} alphaB - the ending alpha value
   * @param {number} life - the life of the behaviour
   * @param {function} easing - the easing equation to use for transforms
   * @return void
   */ reset(alphaA = 1, alphaB = null, life, easing) {
        this.same = alphaB === null || alphaB === undefined ? true : false;
        this.alphaA = (0, $ef3653f168d58d59$export$47286723ded93599)(alphaA);
        this.alphaB = (0, $ef3653f168d58d59$export$47286723ded93599)(alphaB);
        life && super.reset(life, easing);
    }
    /**
   * Initializes the behaviour on a particle.
   *
   * @param {object} particle - the particle to initialize the behaviour on
   * @return void
   */ initialize(particle) {
        particle.useAlpha = true;
        particle.transform.alphaA = this.alphaA.getValue();
        particle.transform.alphaB = this.same ? particle.transform.alphaA : this.alphaB.getValue();
    }
    /**
   * Mutates the target's alpha/opacity property.
   *
   * @param {object} particle - the particle to apply the behaviour to
   * @param {number} time - engine time
   * @param {integer} index - the particle index
   * @return void
   */ mutate(particle, time, index) {
        this.energize(particle, time, index);
        particle.alpha = (0, $7e29c48cc36f8eff$export$2e2bcd8739ae039).lerp(particle.transform.alphaA, particle.transform.alphaB, this.energy);
        if (particle.alpha < (0, $64459a10eda38326$export$65213b14bce0ded6)) particle.alpha = 0;
    }
    /**
   * Creates a Body initializer from JSON.
   *
   * @param {object} json - The JSON to construct the instance from.
   * @property {number} json.alphaA - The starting alpha value
   * @property {number} json.alphaB - The ending alpha value
   * @property {number} json.life - The life of the behaviour
   * @property {string} json.easing - The easing equation to use for transforms
   * @return {Body}
   */ static fromJSON(json) {
        const { alphaA: alphaA, alphaB: alphaB, life: life, easing: easing, isEnabled: isEnabled = true } = json;
        return new $9a23004203249681$export$2e2bcd8739ae039(alphaA, alphaB, life, (0, $4bdda5ce454f9cb4$export$605f24bff585f740)(easing), isEnabled);
    }
    /**
   * Constructs an Alpha behaviour instance.
   *
   * @param {number} alphaA - The starting alpha value
   * @param {?number} alphaB - The ending alpha value
   * @param {number} life - The life of the behaviour
   * @param {function} easing - The easing equation to use for transforms
   * @param {boolean} [isEnabled=true] - Determines if the behaviour will be applied or not
   * @return void
   */ constructor(alphaA = 1, alphaB = null, life, easing, isEnabled = true){
        super(life, easing, (0, $2732299af51e9693$export$467f3abd3509ebe9), isEnabled);
        /**
     * @desc The starting alpha value
     * @type {number|Span}
     */ this.alphaA = alphaA;
        /**
     * @desc The ending alpha value
     * @type {number|Span}
     */ this.alphaB = alphaB;
        this.reset(alphaA, alphaB);
    }
}







class $a1d3e9c353152760$export$2e2bcd8739ae039 extends (0, $bef8ae8b9f5ff381$export$2e2bcd8739ae039) {
    /**
   * Resets the behaviour properties.
   *
   * @param {Vector3D} targetPosition - the position the particles will be attracted to
   * @param {number} force - the attraction force multiplier
   * @param {number} radius - the attraction radius
   * @param {number} life - the life of the particle
   * @param {function} easing - The behaviour's decaying trend
   * @return void
   */ reset(targetPosition = new (0, $4ecaf53387bdecca$export$2e2bcd8739ae039)(), force = (0, $64459a10eda38326$export$9051f10cfcd3a1af), radius = (0, $64459a10eda38326$export$e37c9d92136530ab), life, easing) {
        this.targetPosition = targetPosition;
        this.radius = radius;
        this.force = this.normalizeValue(force);
        this.radiusSq = this.radius * this.radius;
        this.attractionForce = new (0, $4ecaf53387bdecca$export$2e2bcd8739ae039)();
        this.lengthSq = 0;
        life && super.reset(life, easing);
    }
    /**
   * Mutates particle acceleration.
   *
   * @param {Particle} particle - the particle to apply the behaviour to
   * @param {number} time - particle engine time
   * @param {integer} index - the particle index
   * @return void
   */ mutate(particle, time, index) {
        this.energize(particle, time, index);
        this.attractionForce.copy(this.targetPosition);
        this.attractionForce.sub(particle.position);
        this.lengthSq = this.attractionForce.lengthSq();
        if (this.lengthSq > (0, $64459a10eda38326$export$a9939cbe2e014685) && this.lengthSq < this.radiusSq) {
            this.attractionForce.normalize();
            this.attractionForce.scalar(1 - this.lengthSq / this.radiusSq);
            this.attractionForce.scalar(this.force);
            particle.acceleration.add(this.attractionForce);
        }
    }
    /**
   * Creates a Body initializer from JSON.
   *
   * @param {object} json - The JSON to construct the instance from.
   * @property {number} json.x - The target position x value
   * @property {number} json.y - The target position y value
   * @property {number} json.z - The target position z value
   * @property {number} json.force - The attraction force scalar multiplier
   * @property {number} json.life - The life of the particle
   * @property {string} json.easing - The behaviour's decaying trend
   * @return {Body}
   */ static fromJSON(json) {
        const { x: x, y: y, z: z, force: force, radius: radius, life: life, easing: easing, isEnabled: isEnabled = true } = json;
        return new $a1d3e9c353152760$export$2e2bcd8739ae039(new (0, $4ecaf53387bdecca$export$2e2bcd8739ae039)(x, y, z), force, radius, life, (0, $4bdda5ce454f9cb4$export$605f24bff585f740)(easing), isEnabled);
    }
    /**
   * Constructs an Attraction behaviour instance.
   *
   * @param {Vector3D} targetPosition - The position the particles will be attracted to
   * @param {number} force - The attraction force scalar multiplier
   * @param {number} radius - The attraction radius
   * @param {number} [life=DEFAULT_LIFE] - The life of the particle
   * @param {function} [easing=DEFAULT_BEHAVIOUR_EASING] - The behaviour's decaying trend
   * @param {boolean} [isEnabled=true] - Determines if the behaviour will be applied or not
   * @return void
   */ constructor(targetPosition = new (0, $4ecaf53387bdecca$export$2e2bcd8739ae039)(), force = (0, $64459a10eda38326$export$9051f10cfcd3a1af), radius = (0, $64459a10eda38326$export$e37c9d92136530ab), life = (0, $64459a10eda38326$export$2f1a74589dda35c3), easing = (0, $64459a10eda38326$export$c5728778d50477cf), isEnabled = true){
        super(life, easing, (0, $2732299af51e9693$export$b34a75d4835b0bc5), isEnabled);
        /**
     * @desc The position the particles will be attracted to
     * @type {Vector3D}
     */ this.targetPosition = targetPosition;
        /**
     * @desc The attraction radius
     * @type {number} - the attraction radius
     */ this.radius = radius;
        /**
     * @desc The attraction force scalar multiplier
     * @type {number}
     */ this.force = this.normalizeValue(force);
        /**
     * @desc The radius of the attraction squared
     * @type {number}
     */ this.radiusSq = this.radius * this.radius;
        /**
     * @desc The attraction force in 3D space
     * @type {Vector3D}
     */ this.attractionForce = new (0, $4ecaf53387bdecca$export$2e2bcd8739ae039)();
        /**
     * @desc The linear attraction force
     * @type {number}
     */ this.lengthSq = 0;
    }
}





class $d3d7f6cd1281276c$export$2e2bcd8739ae039 extends (0, $bef8ae8b9f5ff381$export$2e2bcd8739ae039) {
    /**
   * Resets the behaviour properties.
   *
   * @param {Emitter} emitter - The emitter containing the particles to detect collisions against
   * @param {boolean} useMass - Determiens whether to use mass or not
   * @param {function} onCollide - Function to call when particles collide
   * @param {number} life - The life of the particle
   * @param {function} easing - The behaviour's decaying trend
   * @return void
   */ reset(emitter, useMass, onCollide, life, easing) {
        this.emitter = emitter;
        this.useMass = useMass;
        this.onCollide = onCollide;
        this.particles = [];
        this.delta = new (0, $4ecaf53387bdecca$export$2e2bcd8739ae039)();
        life && super.reset(life, easing);
    }
    /**
   * Detects collisions with other particles and calls the
   * onCollide function on colliding particles.
   *
   * @param {Particle} particle - the particle to apply the behaviour to
   * @param {number} time - particle engine time
   * @param {integer} index - the particle index
   * @return void
   */ mutate(particle, time, index) {
        const particles = this.emitter ? this.emitter.particles.slice(index) : this.particles.slice(index);
        let otherParticle, lengthSq, overlap, distance, averageMass1, averageMass2;
        let i = particles.length;
        while(i--){
            otherParticle = particles[i];
            if (otherParticle == particle) continue;
            this.delta.copy(otherParticle.position).sub(particle.position);
            lengthSq = this.delta.lengthSq();
            distance = particle.radius + otherParticle.radius;
            if (lengthSq <= distance * distance) {
                overlap = distance - Math.sqrt(lengthSq);
                overlap += 0.5;
                averageMass1 = this._getAverageMass(particle, otherParticle);
                averageMass2 = this._getAverageMass(otherParticle, particle);
                particle.position.add(this.delta.clone().normalize().scalar(overlap * -averageMass1));
                otherParticle.position.add(this.delta.normalize().scalar(overlap * averageMass2));
                this.onCollide && this.onCollide(particle, otherParticle);
            }
        }
    }
    /**
   * Gets the average mass of both particles.
   *
   * @param {Particle} particleA - The first particle
   * @param {Particle} particleB - The second particle
   * @return {number}
   */ _getAverageMass(particleA, particleB) {
        return this.useMass ? particleB.mass / (particleA.mass + particleB.mass) : 0.5;
    }
    fromJSON(json) {}
    /**
   * Constructs a Collision behaviour instance.
   *
   * @param {Emitter} emitter - The emitter containing the particles to detect collisions against
   * @param {boolean} useMass - Determiens whether to use mass or not
   * @param {function} onCollide - Function to call when particles collide
   * @param {number} life - The life of the particle
   * @param {function} easing - The behaviour's decaying trend
   * @param {boolean} [isEnabled=true] - Determines if the behaviour will be applied or not
   * @return void
   */ constructor(emitter, useMass, onCollide, life, easing, isEnabled = true){
        super(life, easing, (0, $2732299af51e9693$export$b84df0684c0849c6), isEnabled);
        this.reset(emitter, useMass, onCollide);
    }
}







class $f505290032053e83$export$2e2bcd8739ae039 extends (0, $bef8ae8b9f5ff381$export$2e2bcd8739ae039) {
    /**
   * Gets the _same property which determines if the alpha are the same.
   *
   * @return {boolean}
   */ get same() {
        return this._same;
    }
    /**
   * Sets the _same property which determines if the alpha are the same.
   *
   * @param {boolean} same
   * @return {boolean}
   */ set same(same) {
        /**
     * @type {boolean}
     */ this._same = same;
    }
    reset(colorA, colorB, life, easing) {
        this.same = colorB === null || colorB === undefined ? true : false;
        this.colorA = (0, $be6fe48c65b4f246$export$a6207c41d393cec5)(colorA);
        this.colorB = (0, $be6fe48c65b4f246$export$a6207c41d393cec5)(colorB);
        life && super.reset(life, easing);
    }
    initialize(particle) {
        particle.transform.colorA = (0, $b1787551de63bafa$export$2e2bcd8739ae039).getRGB(this.colorA.getValue());
        particle.useColor = true;
        particle.transform.colorB = this.same ? particle.transform.colorA : (0, $b1787551de63bafa$export$2e2bcd8739ae039).getRGB(this.colorB.getValue());
    }
    mutate(particle, time, index) {
        this.energize(particle, time, index);
        if (!this._same) {
            particle.color.r = (0, $7e29c48cc36f8eff$export$2e2bcd8739ae039).lerp(particle.transform.colorA.r, particle.transform.colorB.r, this.energy);
            particle.color.g = (0, $7e29c48cc36f8eff$export$2e2bcd8739ae039).lerp(particle.transform.colorA.g, particle.transform.colorB.g, this.energy);
            particle.color.b = (0, $7e29c48cc36f8eff$export$2e2bcd8739ae039).lerp(particle.transform.colorA.b, particle.transform.colorB.b, this.energy);
        } else {
            particle.color.r = particle.transform.colorA.r;
            particle.color.g = particle.transform.colorA.g;
            particle.color.b = particle.transform.colorA.b;
        }
    }
    /**
   * Creates a Color initializer from JSON.
   *
   * @param {object} json - The JSON to construct the instance from.
   * @property {number} json.colorA - The starting color
   * @property {number} json.colorB - The ending color
   * @property {number} json.life - The life of the particle
   * @property {string} json.easing - The behaviour's decaying trend
   * @return {Color}
   */ static fromJSON(json) {
        const { colorA: colorA, colorB: colorB, life: life, easing: easing, isEnabled: isEnabled = true } = json;
        return new $f505290032053e83$export$2e2bcd8739ae039(colorA, colorB, life, (0, $4bdda5ce454f9cb4$export$605f24bff585f740)(easing), isEnabled);
    }
    /**
   * Constructs a Color behaviour instance.
   *
   * @param {number|string} colorA - the starting color
   * @param {number|string} colorB - the ending color
   * @param {number} life - the life of the particle
   * @param {function} easing - The behaviour's decaying trend
   * @param {boolean} [isEnabled=true] - Determines if the behaviour will be applied or not
   * @return void
   */ constructor(colorA, colorB, life, easing, isEnabled = true){
        super(life, easing, (0, $2732299af51e9693$export$46c080640007f6c8), isEnabled);
        this.reset(colorA, colorB);
    }
}







class $5dfe7e54c9441929$export$2e2bcd8739ae039 extends (0, $bef8ae8b9f5ff381$export$2e2bcd8739ae039) {
    /**
   * Resets the behaviour properties.
   *
   * @param {Zone} zone - the zone used to apply to particles with this behaviour
   * @param {string} [crossType=DEFAULT_CROSS_TYPE] - enum of cross types, valid strings include 'dead', 'bound', 'cross'
   * @param {number} life - The life of the particle
   * @param {function} easing - The behaviour's decaying trend
   */ reset(zone, crossType = (0, $64459a10eda38326$export$91a93c4b9fe20707), life, easing) {
        /**
     * @desc The zone used to apply to particles with this behaviour
     * @type {Zone}
     */ this.zone = zone;
        this.zone.crossType = crossType;
        life && super.reset(life, easing);
    }
    /**
   * Applies the behaviour to the particle.
   *
   * @see {@link '../zone/Zone.js'} crossing
   * @param {object} particle - the particle to apply the behaviour to
   * @param {number} time - engine time
   * @param {integer} index - the particle index
   * @return void
   */ mutate(particle, time, index) {
        this.energize(particle, time, index);
        this.zone.crossing.call(this.zone, particle);
    }
    /**
   * Creates a CrossZone initializer from JSON.
   *
   * @param {object} json - The JSON to construct the instance from.
   * @return {CrossZone}
   */ static fromJSON(json) {
        const { zoneType: zoneType, zoneParams: zoneParams, crossType: crossType, life: life, easing: easing, isEnabled: isEnabled = true } = json;
        const zone = new $0f5050993349035a$exports[zoneType](...Object.values(zoneParams));
        return new $5dfe7e54c9441929$export$2e2bcd8739ae039(zone, crossType, life, (0, $4bdda5ce454f9cb4$export$605f24bff585f740)(easing), isEnabled);
    }
    /**
   * Constructs a CrossZone behaviour instance.
   *
   * @param {Zone} zone - the zone used to apply to particles with this behaviour
   * @param {string} [crossType=DEFAULT_CROSS_TYPE] - enum of cross types, valid strings include 'dead', 'bound', 'cross'
   * @param {number} life - The life of the particle
   * @param {function} easing - The behaviour's decaying trend
   * @param {boolean} [isEnabled=true] - Determines if the behaviour will be applied or not
   */ constructor(zone, crossType, life, easing, isEnabled){
        super(life, easing, (0, $2732299af51e9693$export$e4ae7b92639bc550), isEnabled);
        this.reset(zone, crossType);
    }
}






class $2ff1af638d7ac763$export$2e2bcd8739ae039 extends (0, $bef8ae8b9f5ff381$export$2e2bcd8739ae039) {
    /**
   * Resets the behaviour properties.
   *
   * @param {number} fx - the x axis force
   * @param {number} fy - the y axis force
   * @param {number} fz - the z axis force
   */ reset(fx, fy, fz) {
        /**
     * @desc The normalized force to exert on the particle in
     * @type {Vector3D}
     */ this.force = this.normalizeForce(new (0, $4ecaf53387bdecca$export$2e2bcd8739ae039)(fx, fy, fz));
        /**
     * @desc The id of the force vector
     * @property {number} this.force.id
     */ this.force.id = Math.random();
    }
    /**
   * Mutates the particle.acceleration property.
   *
   * @param {object} particle - the particle to apply the behaviour to
   * @param {number} time - engine time
   * @param {integer} index - the particle index
   * @return void
   */ mutate(particle, time, index) {
        this.energize(particle, time, index);
        particle.acceleration.add(this.force);
    }
    /**
   * Creates a Force initializer from JSON.
   *
   * @param {object} json - The JSON to construct the instance from.
   * @return {Force}
   */ static fromJSON(json) {
        const { fx: fx, fy: fy, fz: fz, life: life, easing: easing, isEnabled: isEnabled = true } = json;
        return new $2ff1af638d7ac763$export$2e2bcd8739ae039(fx, fy, fz, life, (0, $4bdda5ce454f9cb4$export$605f24bff585f740)(easing), isEnabled);
    }
    /**
   * Constructs a Force behaviour instance.
   *
   * @param {number} fx - the x axis force
   * @param {number} fy - the y axis force
   * @param {number} fz - the z axis force
   * @param {number} life - the life of the particle
   * @param {function} easing - The behaviour's decaying trend
   * @param {boolean} [isEnabled=true] - Determines if the behaviour will be applied or not
   * @return void
   */ constructor(fx, fy, fz, life, easing, isEnabled = true){
        super(life, easing, (0, $2732299af51e9693$export$8edd8097d5982cc6), isEnabled);
        this.reset(fx, fy, fz);
    }
}





class $06f04aead93c21e3$export$2e2bcd8739ae039 extends (0, $2ff1af638d7ac763$export$2e2bcd8739ae039) {
    static fromJSON(json) {
        const { gravity: gravity, life: life, easing: easing, isEnabled: isEnabled = true } = json;
        return new $06f04aead93c21e3$export$2e2bcd8739ae039(gravity, life, (0, $4bdda5ce454f9cb4$export$605f24bff585f740)(easing), isEnabled);
    }
    /**
   * Constructs a Gravity behaviour instance.
   *
   * @param {number} gravity - the force to pull the particle down the y axis
   * @param {number} life - the life of the particle
   * @param {string} easing - the easing equation to use
   * @param {boolean} [isEnabled=true] - Determines if the behaviour will be applied or not
   * @return void
   */ constructor(gravity, life, easing, isEnabled = true){
        super(0, -gravity, 0, life, easing, isEnabled);
        /**
     * @desc The class type.
     * @type {string}
     */ this.type = (0, $2732299af51e9693$export$8742ff6a9e4f9956);
    }
}







class $236adaaa9c65dcf8$export$2e2bcd8739ae039 extends (0, $bef8ae8b9f5ff381$export$2e2bcd8739ae039) {
    /**
   * Resets the behaviour properties.
   *
   * @param {number} driftX - x axis drift
   * @param {number} driftY - y axis drift
   * @param {number} driftZ - z axis drift
   * @param {number} [delay=DEFAULT_RANDOM_DRIFT_DELAY] - drift delay
   * @param {number} life - The life of the particle
   * @param {function} easing - The behaviour's decaying trend
   */ reset(driftX, driftY, driftZ, delay = (0, $64459a10eda38326$export$ffe086099c9b9d89), life, easing) {
        /**
     * @desc A Vector3D that stores the drift properties.
     * @type {Vector3D}
     */ this.randomForce = this.normalizeForce(new (0, $4ecaf53387bdecca$export$2e2bcd8739ae039)(driftX, driftY, driftZ));
        /**
     * @desc A Span containing the delay supplied.
     * @type {Span}
     */ this.delayPan = (0, $ef3653f168d58d59$export$47286723ded93599)(delay);
        this.time = 0;
        life && super.reset(life, easing);
    }
    /**
   * Mutates the particle.acceleration property.
   *
   * @param {object} particle - the particle to apply the behaviour to
   * @param {number} time - engine time
   * @param {integer} index - the particle index
   * @return void
   */ mutate(particle, time, index) {
        this.energize(particle, time, index);
        this.time += time;
        if (this.time >= this.delayPan.getValue()) {
            const ax = (0, $7e29c48cc36f8eff$export$2e2bcd8739ae039).randomAToB(-this.randomForce.x, this.randomForce.x);
            const ay = (0, $7e29c48cc36f8eff$export$2e2bcd8739ae039).randomAToB(-this.randomForce.y, this.randomForce.y);
            const az = (0, $7e29c48cc36f8eff$export$2e2bcd8739ae039).randomAToB(-this.randomForce.z, this.randomForce.z);
            particle.acceleration.addValue(ax, ay, az);
            this.time = 0;
        }
    }
    static fromJSON(json) {
        const { x: x, y: y, z: z, delay: delay, life: life, easing: easing, isEnabled: isEnabled = true } = json;
        return new $236adaaa9c65dcf8$export$2e2bcd8739ae039(x, y, z, delay, life, (0, $4bdda5ce454f9cb4$export$605f24bff585f740)(easing), isEnabled);
    }
    /**
   * Constructs a RandomDrift behaviour instance.
   *
   * @param {number} driftX - x axis drift
   * @param {number} driftY - y axis drift
   * @param {number} driftZ - z axis drift
   * @param {number} [delay=DEFAULT_RANDOM_DRIFT_DELAY] - drift delay
   * @param {number} life - The life of the particle
   * @param {function} easing - The behaviour's decaying trend
   * @return void
   */ constructor(driftX, driftY, driftZ, delay = (0, $64459a10eda38326$export$ffe086099c9b9d89), life, easing, isEnabled = true){
        super(life, easing, (0, $2732299af51e9693$export$a2ab21ade2918dde), isEnabled);
        this.reset(driftX, driftY, driftZ, delay);
        /**
     * @desc Internal time used for calculating drift vs internal delay.
     * @type {number}
     */ this.time = 0;
    }
}






class $ee953406fcd4cd05$export$2e2bcd8739ae039 extends (0, $a1d3e9c353152760$export$2e2bcd8739ae039) {
    /**
   * Resets the behaviour properties.
   *
   * @param {Vector3D} targetPosition - the position the particles will be attracted to
   * @param {number} force - the attraction force multiplier
   * @param {number} radius - the attraction radius
   * @param {number} life - the life of the particle
   * @param {function} easing - The behaviour's decaying trend
   * @return void
   */ reset(targetPosition, force, radius, life, easing) {
        super.reset(targetPosition, force, radius, life, easing);
        this.force *= -1;
    }
    /**
   * Creates a Body initializer from JSON.
   *
   * @param {object} json - The JSON to construct the instance from.
   * @property {number} json.x - The target position x value
   * @property {number} json.y - The target position y value
   * @property {number} json.z - The target position z value
   * @property {number} json.force - The attraction force scalar multiplier
   * @property {number} json.life - The life of the particle
   * @property {string} json.easing - The behaviour's decaying trend
   * @return {Body}
   */ static fromJSON(json) {
        const { x: x, y: y, z: z, force: force, radius: radius, life: life, easing: easing, isEnabled: isEnabled = true } = json;
        return new $ee953406fcd4cd05$export$2e2bcd8739ae039(new (0, $4ecaf53387bdecca$export$2e2bcd8739ae039)(x, y, z), force, radius, life, (0, $4bdda5ce454f9cb4$export$605f24bff585f740)(easing), isEnabled);
    }
    /**
   * Constructs an Repulsion behaviour instance.
   *
   * @param {Vector3D} targetPosition - The position the particles will be repelled from
   * @param {number} force - The repulsion force scalar multiplier
   * @param {number} radius - The repulsion radius
   * @param {number} life - The life of the particle
   * @param {function} easing - The behaviour's decaying trend
   * @return void
   */ constructor(targetPosition, force, radius, life, easing, isEnabled = true){
        super(targetPosition, force, radius, life, easing, isEnabled);
        /**
     * @desc Repulsion is attraction with negative force.
     * @type {number}
     */ this.force *= -1;
        /**
     * @desc The class type.
     * @type {string}
     */ this.type = (0, $2732299af51e9693$export$1be9b23e96dfffa1);
    }
}







class $275cc25265e5b0fe$export$2e2bcd8739ae039 extends (0, $bef8ae8b9f5ff381$export$2e2bcd8739ae039) {
    /**
   * Gets the rotation type.
   *
   * @return {string}
   */ get rotationType() {
        return this._rotationType;
    }
    /**
   * Sets the rotation type.
   *
   * @param {string}
   * @return void
   */ set rotationType(rotationType) {
        /**
     * @desc The rotation type. ENUM of ['same', 'set', 'to', 'add'].
     * @type {string}
     */ this._rotationType = rotationType;
    }
    /**
   * Resets the behaviour properties.
   *
   * @param {number} x - X axis rotation
   * @param {number} y - Y axis rotation
   * @param {number} z - Z axis rotation
   * @param {number} life - the life of the behaviour
   * @param {function} easing - the easing equation to use for transforms
   * @return void
   */ reset(x, y, z, life, easing) {
        /**
     * @desc X axis rotation.
     * @type {number|Span}
     */ this.x = x || 0;
        /**
     * @desc Y axis rotation.
     * @type {number|Span}
     */ this.y = y || 0;
        /**
     * @desc Z axis rotation.
     * @type {number|Span}
     */ this.z = z || 0;
        if (x === undefined || x == "same") this.rotationType = "same";
        else if (y == undefined) this.rotationType = "set";
        else if (z === undefined) this.rotationType = "to";
        else {
            this.rotationType = "add";
            this.x = (0, $ef3653f168d58d59$export$47286723ded93599)(this.x * (0, $c1da9e54204bbff9$export$590ba8a5a3bd5910));
            this.y = (0, $ef3653f168d58d59$export$47286723ded93599)(this.y * (0, $c1da9e54204bbff9$export$590ba8a5a3bd5910));
            this.z = (0, $ef3653f168d58d59$export$47286723ded93599)(this.z * (0, $c1da9e54204bbff9$export$590ba8a5a3bd5910));
        }
        life && super.reset(life, easing);
    }
    /**
   * Initializes the behaviour on a particle.
   *
   * @param {object} particle - the particle to initialize the behaviour on
   * @return void
   */ initialize(particle) {
        switch(this.rotationType){
            case "same":
                break;
            case "set":
                this._setRotation(particle.rotation, this.x);
                break;
            case "to":
                particle.transform.fR = particle.transform.fR || new (0, $4ecaf53387bdecca$export$2e2bcd8739ae039)();
                particle.transform.tR = particle.transform.tR || new (0, $4ecaf53387bdecca$export$2e2bcd8739ae039)();
                this._setRotation(particle.transform.fR, this.x);
                this._setRotation(particle.transform.tR, this.y);
                break;
            case "add":
                particle.transform.addR = new (0, $4ecaf53387bdecca$export$2e2bcd8739ae039)(this.x.getValue(), this.y.getValue(), this.z.getValue());
                break;
        }
    }
    /**
   * Sets the particle's rotation prior to the behaviour being applied.
   *
   * NOTE It's hard to see here, but this is mutating the particle's rotation
   * even though the particle is not being passed in directly.
   *
   * NOTE the else if below will never be reached because the value being passed in
   * will never be of type Vector3D.
   *
   * @param {Vector3D} particleRotation - the particle's rotation vector
   * @param {string|number} value - the value to set the rotation value to, if 'random'
   * rotation is randomised
   * @return void
   */ _setRotation(particleRotation, value) {
        particleRotation = particleRotation || new (0, $4ecaf53387bdecca$export$2e2bcd8739ae039)();
        if (value == "random") {
            var x = (0, $7e29c48cc36f8eff$export$2e2bcd8739ae039).randomAToB(-(0, $c1da9e54204bbff9$export$6b5c1ceb16d01dc3), (0, $c1da9e54204bbff9$export$6b5c1ceb16d01dc3));
            var y = (0, $7e29c48cc36f8eff$export$2e2bcd8739ae039).randomAToB(-(0, $c1da9e54204bbff9$export$6b5c1ceb16d01dc3), (0, $c1da9e54204bbff9$export$6b5c1ceb16d01dc3));
            var z = (0, $7e29c48cc36f8eff$export$2e2bcd8739ae039).randomAToB(-(0, $c1da9e54204bbff9$export$6b5c1ceb16d01dc3), (0, $c1da9e54204bbff9$export$6b5c1ceb16d01dc3));
            particleRotation.set(x, y, z);
        } else if (value instanceof (0, $4ecaf53387bdecca$export$2e2bcd8739ae039)) particleRotation.copy(value);
    }
    /**
   * Mutates the particle.rotation property.
   *
   * @see http://stackoverflow.com/questions/21622956/how-to-convert-direction-vector-to-euler-angles
   * @param {object} particle - the particle to apply the behaviour to
   * @param {number} time - engine time
   * @param {integer} index - the particle index
   * @return void
   */ mutate(particle, time, index) {
        this.energize(particle, time, index);
        switch(this.rotationType){
            // orients the particle in the direction it is moving
            case "same":
                if (!particle.rotation) particle.rotation = new (0, $4ecaf53387bdecca$export$2e2bcd8739ae039)();
                particle.rotation.eulerFromDir(particle.velocity);
                break;
            case "set":
                break;
            case "to":
                particle.rotation.x = (0, $7e29c48cc36f8eff$export$2e2bcd8739ae039).lerp(particle.transform.fR.x, particle.transform.tR.x, this.energy);
                particle.rotation.y = (0, $7e29c48cc36f8eff$export$2e2bcd8739ae039).lerp(particle.transform.fR.y, particle.transform.tR.y, this.energy);
                particle.rotation.z = (0, $7e29c48cc36f8eff$export$2e2bcd8739ae039).lerp(particle.transform.fR.z, particle.transform.tR.z, this.energy);
                break;
            case "add":
                particle.rotation.add(particle.transform.addR);
                break;
        }
    }
    static fromJSON(json) {
        const { x: x, y: y, z: z, life: life, easing: easing, isEnabled: isEnabled = true } = json;
        return new $275cc25265e5b0fe$export$2e2bcd8739ae039(x, y, z, life, (0, $4bdda5ce454f9cb4$export$605f24bff585f740)(easing), isEnabled);
    }
    /**
   * Constructs a Rotate behaviour instance.
   *
   * @param {number} x - X axis rotation
   * @param {number} y - Y axis rotation
   * @param {number} z - Z axis rotation
   * @param {number} life - The life of the behaviour
   * @param {function} easing - The easing equation to use for transforms
   * @param {boolean} [isEnabled=true] - Determines if the behaviour will be applied or not
   * @return void
   */ constructor(x, y, z, life, easing, isEnabled = true){
        super(life, easing, (0, $2732299af51e9693$export$377dc8da583fe9e0), isEnabled);
        this.reset(x, y, z);
    }
}






class $731b44e61c44f44f$export$2e2bcd8739ae039 extends (0, $bef8ae8b9f5ff381$export$2e2bcd8739ae039) {
    /**
   * Gets the _same property which determines if the scale props are the same.
   *
   * @return {boolean}
   */ get same() {
        return this._same;
    }
    /**
   * Sets the _same property which determines if the scale props are the same.
   *
   * @param {boolean} same
   * @return {boolean}
   */ set same(same) {
        /**
     * @type {boolean}
     */ this._same = same;
    }
    /**
   * Resets the behaviour properties.
   *
   * @param {number} scaleA - the starting scale value
   * @param {?number} scaleB - the ending scale value
   * @param {number} life - the life of the behaviour
   * @param {function} easing - the easing equation to use for transforms
   * @return void
   */ reset(scaleA, scaleB, life, easing) {
        this.same = scaleB === null || scaleB === undefined ? true : false;
        /**
     * @desc The starting scale.
     * @type {Span}
     */ this.scaleA = (0, $ef3653f168d58d59$export$47286723ded93599)(scaleA || 1);
        /**
     * @desc The ending scale.
     * @type {Span}
     */ this.scaleB = (0, $ef3653f168d58d59$export$47286723ded93599)(scaleB);
        life && super.reset(life, easing);
    }
    /**
   * Initializes the behaviour on a particle.
   * Stores initial values for comparison and mutation in the applyBehaviour method.
   *
   * @param {object} particle - the particle to initialize the behaviour on
   * @return void
   */ initialize(particle) {
        particle.transform.scaleA = this.scaleA.getValue();
        particle.transform.oldRadius = particle.radius;
        particle.transform.scaleB = this.same ? particle.transform.scaleA : this.scaleB.getValue();
    }
    /**
   * Applies the behaviour to the particle.
   * Mutates the particle's scale and its radius according to this scale.
   *
   * @param {object} particle - the particle to apply the behaviour to
   * @param {number} time - engine time
   * @param {integer} index - the particle index
   * @return void
   */ mutate(particle, time, index) {
        this.energize(particle, time, index);
        particle.scale = (0, $7e29c48cc36f8eff$export$2e2bcd8739ae039).lerp(particle.transform.scaleA, particle.transform.scaleB, this.energy);
        if (particle.scale < 0.0005) particle.scale = 0;
        particle.radius = particle.transform.oldRadius * particle.scale;
    }
    /**
   * Returns a new instance of the behaviour from the JSON object passed.
   *
   * @param {object} json - JSON object containing the required constructor properties
   * @return {Spring}
   */ static fromJSON(json) {
        const { scaleA: scaleA, scaleB: scaleB, life: life, easing: easing, isEnabled: isEnabled = true } = json;
        return new $731b44e61c44f44f$export$2e2bcd8739ae039(scaleA, scaleB, life, (0, $4bdda5ce454f9cb4$export$605f24bff585f740)(easing), isEnabled);
    }
    /**
   * Constructs a Scale behaviour instance.
   *
   * @param {number} scaleA - the starting scale value
   * @param {?number} scaleB - the ending scale value
   * @param {number} life - the life of the behaviour
   * @param {function} easing - the easing equation to use for transforms
   * @param {boolean} [isEnabled=true] - Determines if the behaviour will be applied or not
   * @return void
   */ constructor(scaleA, scaleB, life, easing, isEnabled = true){
        super(life, easing, (0, $2732299af51e9693$export$cedf5532ac01e38d), isEnabled);
        this.reset(scaleA, scaleB);
    }
}






class $57a2048e73bf0a51$export$2e2bcd8739ae039 extends (0, $bef8ae8b9f5ff381$export$2e2bcd8739ae039) {
    /**
   * Resets the behaviour properties.
   *
   * @param {number} x - X axis spring
   * @param {number} y - Y axis spring
   * @param {number} z - Z axis spring
   * @param {number} spring - Spring factor
   * @param {number} friction - Spring friction
   * @return void
   */ reset(x, y, z, spring, friction) {
        if (!this.pos) this.pos = new (0, $4ecaf53387bdecca$export$2e2bcd8739ae039)(x, y, z);
        else this.pos.set(x, y, z);
        this.spring = spring || 0.1;
        this.friction = friction || 0.98;
    }
    /**
   * Applies the behaviour to the particle.
   * Mutates the particle's velocity according to this.pos and this.spring.
   *
   * @param {object} particle - the particle to apply the behaviour to
   * @param {number} time - engine time
   * @param {integer} index - the particle index
   * @return void
   */ mutate(particle, time, index) {
        this.energize(particle, time, index);
        particle.velocity.x += (this.pos.x - particle.position.x) * this.spring;
        particle.velocity.y += (this.pos.y - particle.position.y) * this.spring;
        particle.velocity.z += (this.pos.z - particle.position.z) * this.spring;
    }
    /**
   * Returns a new instance of the behaviour from the JSON object passed.
   *
   * @param {object} json - JSON object containing the required constructor properties
   * @return {Spring}
   */ static fromJSON(json) {
        const { x: x, y: y, z: z, spring: spring, friction: friction, life: life, easing: easing, isEnabled: isEnabled = true } = json;
        return new $57a2048e73bf0a51$export$2e2bcd8739ae039(x, y, z, spring, friction, life, (0, $4bdda5ce454f9cb4$export$605f24bff585f740)(easing), isEnabled);
    }
    /**
   * Constructs a Spring behaviour instance.
   *
   * @param {number} x - X axis spring
   * @param {number} y - Y axis spring
   * @param {number} z - Z axis spring
   * @param {number} spring - Spring factor
   * @param {number} friction - Spring friction
   * @param {number} life - The life of the behaviour
   * @param {function} easing - The easing equation to use for transforms
   * @param {boolean} [isEnabled=true] - Determines if the behaviour will be applied or not
   * @return void
   */ constructor(x, y, z, spring, friction, life, easing, isEnabled = true){
        super(life, easing, (0, $2732299af51e9693$export$143e5d25a7f4575f), isEnabled);
        this.reset(x, y, z, spring, friction);
    }
}









/**
 * Makes a rate instance.
 *
 * @param {object} json - The data required to construct a Rate instance
 * @return {Rate}
 */ const $0665d606ccb44c16$var$makeRate = (json)=>(0, $c15ff10b1716ebd7$export$2e2bcd8739ae039).fromJSON(json);
/**
 * Makes initializers from json items.
 *
 * @param {array<object>} items - An array of objects which provide initializer constructor params
 * @param {object} THREE - The Web GL Api to use
 * @return {array<Initializer>}
 */ const $0665d606ccb44c16$var$makeInitializers = (items, THREE)=>{
    const initializers = [];
    items.forEach((data)=>{
        const { type: type, properties: properties } = data;
        if (!(0, $d975d6add471d316$export$10ee648867152bbc).includes(type)) throw new Error(`The initializer type ${type} is invalid or not yet supported`);
        if ((0, $83f850ed9ddda6a7$export$828b672ab9e7cf75).includes(type)) initializers.push($1371ea37222d2da3$exports[type].fromJSON(properties, THREE));
        else initializers.push($1371ea37222d2da3$exports[type].fromJSON(properties));
    });
    return initializers;
};
/**
 * Makes behaviours from json items.
 *
 * @param {array<object>} items - An array of objects which provide behaviour constructor params
 * @return {array<Behaviour>}
 */ const $0665d606ccb44c16$var$makeBehaviours = (items)=>{
    const behaviours = [];
    items.forEach((data)=>{
        const { type: type, properties: properties } = data;
        if (!(0, $d975d6add471d316$export$2de430434fa15c6d).includes(type)) throw new Error(`The behaviour type ${type} is invalid or not yet supported`);
        behaviours.push($020317c09ee00888$exports[type].fromJSON(properties));
    });
    return behaviours;
};
var /**
 * Creates a System instance from a JSON object.
 *
 * @deprecated Use fromJSONAsync instead.
 *
 * @param {object} json - The JSON to create the System instance from
 * @param {object} THREE - The Web GL Api to use
 * @param {function} System - The system class
 * @param {function} Emitter - The emitter class
 * @param {number} json.preParticles - The predetermined number of particles
 * @param {string} json.integrationType - The integration algorithm to use
 * @param {array<object>} json.emitters - The emitters for the system instance
 * @return {System}
 */ $0665d606ccb44c16$export$2e2bcd8739ae039 = (json, THREE, System, Emitter)=>{
    const { preParticles: preParticles = (0, $c1da9e54204bbff9$export$c26fa02a1904398c), integrationType: integrationType = (0, $c1da9e54204bbff9$export$ecd4a5923c08f2ed), emitters: emitters = [] } = json;
    const system = new System(THREE, preParticles, integrationType);
    emitters.forEach((data)=>{
        const emitter = new Emitter();
        const { rate: rate, rotation: rotation, initializers: initializers, behaviours: behaviours, emitterBehaviours: emitterBehaviours = [], position: position, totalEmitTimes: totalEmitTimes = Infinity, life: life = Infinity } = data;
        emitter.setRate($0665d606ccb44c16$var$makeRate(rate)).setRotation(rotation).setInitializers($0665d606ccb44c16$var$makeInitializers(initializers, THREE)).setBehaviours($0665d606ccb44c16$var$makeBehaviours(behaviours)).setEmitterBehaviours($0665d606ccb44c16$var$makeBehaviours(emitterBehaviours)).setPosition(position).emit(totalEmitTimes, life);
        system.addEmitter(emitter);
    });
    return system;
};









function $b25afa497cfe1b13$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $b25afa497cfe1b13$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $b25afa497cfe1b13$var$ownKeys(Object(source), true).forEach(function(key) {
            (0, (/*@__PURE__*/$parcel$interopDefault($cc894e2648a4bb4d$exports)))(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $b25afa497cfe1b13$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
const $b25afa497cfe1b13$var$DEFAULT_OPTIONS = {
    shouldAutoEmit: true
};
/**
 * Makes a rate instance.
 *
 * @param {object} json - The data required to construct a Rate instance
 * @return {Rate}
 */ const $b25afa497cfe1b13$var$makeRate = (json)=>(0, $c15ff10b1716ebd7$export$2e2bcd8739ae039).fromJSON(json);
/**
 * Makes initializers from json items.
 *
 * @param {array<object>} items - An array of objects which provide initializer constructor params
 * @param {object} THREE - The Web GL Api to use
 * @return {array<Initializer>}
 */ const $b25afa497cfe1b13$var$makeInitializers = (items, THREE)=>new Promise((resolve, reject)=>{
        if (!items.length) return resolve([]);
        const numberOfInitializers = items.length;
        const madeInitializers = [];
        const doNotRequireTextureLoading = items.filter(({ properties: properties })=>!properties.texture);
        const doRequireTextureLoading = items.filter(({ properties: properties })=>properties.texture);
        doNotRequireTextureLoading.forEach((data)=>{
            const { type: type, properties: properties } = data;
            if (!(0, $d975d6add471d316$export$10ee648867152bbc).includes(type)) return reject(`The initializer type ${type} is invalid or not yet supported`);
            if ((0, $83f850ed9ddda6a7$export$828b672ab9e7cf75).includes(type)) madeInitializers.push($1371ea37222d2da3$exports[type].fromJSON(properties, THREE));
            else madeInitializers.push($1371ea37222d2da3$exports[type].fromJSON(properties));
            if (madeInitializers.length === numberOfInitializers) return resolve(madeInitializers);
        });
        doRequireTextureLoading.forEach((data)=>{
            const { type: type, properties: properties, properties: { texture: texture } } = data;
            const textureLoader = new THREE.TextureLoader();
            if (!(0, $d975d6add471d316$export$10ee648867152bbc).includes(type)) return reject(`The initializer type ${type} is invalid or not yet supported`);
            textureLoader.load(texture, (loadedTexture)=>{
                madeInitializers.push((0, $65c4c9ef738c90b5$export$2e2bcd8739ae039).fromJSON($b25afa497cfe1b13$var$_objectSpread($b25afa497cfe1b13$var$_objectSpread({}, properties), {}, {
                    loadedTexture: loadedTexture
                }), THREE));
                if (madeInitializers.length === numberOfInitializers) return resolve(madeInitializers);
            }, undefined, reject);
        });
    });
/**
 * Makes behaviours from json items.
 *
 * @param {array<object>} items - An array of objects which provide behaviour constructor params
 * @return {Promise<array>}
 */ const $b25afa497cfe1b13$var$makeBehaviours = (items)=>new Promise((resolve, reject)=>{
        if (!items.length) return resolve([]);
        const numberOfBehaviours = items.length;
        const madeBehaviours = [];
        items.forEach((data)=>{
            const { type: type, properties: properties } = data;
            if (!(0, $d975d6add471d316$export$2de430434fa15c6d).includes(type)) return reject(`The behaviour type ${type} is invalid or not yet supported`);
            madeBehaviours.push($020317c09ee00888$exports[type].fromJSON(properties));
            if (madeBehaviours.length === numberOfBehaviours) return resolve(madeBehaviours);
        });
    });
const $b25afa497cfe1b13$var$makeEmitters = (emitters, Emitter, THREE, shouldAutoEmit)=>new Promise((resolve, reject)=>{
        if (!emitters.length) return resolve([]);
        const madeEmitters = [];
        const numberOfEmitters = emitters.length;
        if (!numberOfEmitters) return resolve(madeEmitters);
        emitters.forEach((data)=>{
            const emitter = new Emitter();
            const { rate: rate, rotation: rotation, initializers: initializers, behaviours: behaviours, emitterBehaviours: emitterBehaviours = [], position: position, totalEmitTimes: totalEmitTimes = Infinity, life: life = Infinity } = data;
            emitter.setRate($b25afa497cfe1b13$var$makeRate(rate)).setRotation(rotation).setPosition(position);
            $b25afa497cfe1b13$var$makeInitializers(initializers, THREE).then((madeInitializers)=>{
                emitter.setInitializers(madeInitializers);
                return $b25afa497cfe1b13$var$makeBehaviours(behaviours);
            }).then((madeBehaviours)=>{
                emitter.setBehaviours(madeBehaviours);
                return $b25afa497cfe1b13$var$makeBehaviours(emitterBehaviours);
            }).then((madeEmitterBehaviours)=>{
                emitter.setEmitterBehaviours(madeEmitterBehaviours);
                return Promise.resolve(emitter);
            }).then((emitter)=>{
                madeEmitters.push(shouldAutoEmit ? emitter.emit(totalEmitTimes, life) : emitter.setTotalEmitTimes(totalEmitTimes).setLife(life));
                if (madeEmitters.length === numberOfEmitters) return resolve(madeEmitters);
            }).catch(reject);
        });
    });
var /**
 * Creates a System instance from a JSON object.
 *
 * @param {object} json - The JSON to create the System instance from
 * @param {number} json.preParticles - The predetermined number of particles
 * @param {string} json.integrationType - The integration algorithm to use
 * @param {array<object>} json.emitters - The emitters for the system instance
 * @param {object} THREE - The Web GL Api to use
 * @param {function} System - The system class
 * @param {function} Emitter - The emitter class
 * @param {object} [options={}] - Optional config options
 * @return {Promise<System>}
 */ $b25afa497cfe1b13$export$2e2bcd8739ae039 = (json, THREE, System, Emitter, options = {})=>new Promise((resolve, reject)=>{
        const { preParticles: preParticles = (0, $c1da9e54204bbff9$export$c26fa02a1904398c), integrationType: integrationType = (0, $c1da9e54204bbff9$export$ecd4a5923c08f2ed), emitters: emitters = [] } = json;
        const system = new System(preParticles, integrationType);
        const { shouldAutoEmit: shouldAutoEmit } = $b25afa497cfe1b13$var$_objectSpread($b25afa497cfe1b13$var$_objectSpread({}, $b25afa497cfe1b13$var$DEFAULT_OPTIONS), options);
        $b25afa497cfe1b13$var$makeEmitters(emitters, Emitter, THREE, shouldAutoEmit).then((madeEmitters)=>{
            const numberOfEmitters = madeEmitters.length;
            if (!numberOfEmitters) return resolve(system);
            madeEmitters.forEach((madeEmitter)=>{
                system.addEmitter(madeEmitter);
                if (system.emitters.length === numberOfEmitters) resolve(system);
            });
        }).catch(reject);
    });



class $0aef39101ae32969$export$2e2bcd8739ae039 {
    /**
   * Creates a System instance from a JSON object.
   *
   * @param {object} json - The JSON to create the System instance from
   * @param {object} THREE - The Web GL Api to use eg., THREE
   * @return {System}
   *
   * @deprecated use fromJSONAsync instead
   */ static fromJSON(json, THREE) {
        return (0, $0665d606ccb44c16$export$2e2bcd8739ae039)(json, THREE, $0aef39101ae32969$export$2e2bcd8739ae039, (0, $975f8eaf1ecebbca$export$2e2bcd8739ae039));
    }
    /**
   * Loads a System instance from JSON asynchronously. Ensures all textures are
   * fully loaded before resolving with the instantiated System instance.
   *
   * @param {object} json - The JSON to create the System instance from
   * @param {object} THREE - The Web GL Api to use eg., THREE
   * @param {?object} options - Optional config options
   * @return {Promise<System>}
   */ static fromJSONAsync(json, THREE, options) {
        return (0, $b25afa497cfe1b13$export$2e2bcd8739ae039)(json, THREE, $0aef39101ae32969$export$2e2bcd8739ae039, (0, $975f8eaf1ecebbca$export$2e2bcd8739ae039), options);
    }
    /**
   * Proxy method for the internal event dispatcher's dispatchEvent method.
   *
   * @param {string} event - The event to dispatch
   * @param {object<System|Emitter|Particle>} [target=this] - The event target
   */ dispatch(event, target = this) {
        this.eventDispatcher.dispatchEvent(event, target);
    }
    /**
   * Adds a renderer to the System instance and initializes it.
   *
   * @param {Renderer} renderer - The renderer to add
   * @return {System}
   */ addRenderer(renderer) {
        this.renderers.push(renderer);
        renderer.init(this);
        return this;
    }
    /**
   * Removes a renderer from the System instance.
   *
   * @param {Renderer} renderer
   * @return {System}
   */ removeRenderer(renderer) {
        this.renderers.splice(this.renderers.indexOf(renderer), 1);
        renderer.remove(this);
        return this;
    }
    /**
   * Adds an emitter to the System instance.
   * Dispatches the EMITTER_ADDED event.
   *
   * @param {Emitter} emitter - The emitter to add
   * @return {System}
   */ addEmitter(emitter) {
        const index = this.emitters.length;
        emitter.parent = this;
        emitter.index = index;
        this.emitters.push(emitter);
        this.dispatch((0, $4d2ddc8f9664085f$export$262c4ebde537eaad), emitter);
        return this;
    }
    /**
   * Removes an emitter from the System instance.
   * Dispatches the EMITTER_REMOVED event.
   *
   * @param {Emitter} emitter - The emitter to remove
   * @return {System}
   */ removeEmitter(emitter) {
        if (emitter.parent !== this) return this;
        emitter.parent = null;
        emitter.index = undefined;
        this.emitters.splice(this.emitters.indexOf(emitter), 1);
        this.dispatch((0, $4d2ddc8f9664085f$export$5d04eb6bd0f83550), emitter);
        return this;
    }
    /**
   * Wires up life cycle methods and causes a system's emitters to emit particles.
   * Expects emitters to have their totalEmitTimes and life set already.
   * Inifnite systems will resolve immediately.
   *
   * @param {object} hooks - Functions to hook into the life cycle API
   * @param {function} hooks.onStart - Called when the system starts to emit particles
   * @param {function} hooks.onUpdate - Called each time the system updates
   * @param {function} hooks.onEnd - Called when the system's emitters have all died
   * @return {Promise}
   */ emit({ onStart: onStart, onUpdate: onUpdate, onEnd: onEnd }) {
        if (onStart) onStart();
        if (onUpdate) this.eventDispatcher.addEventListener((0, $4d2ddc8f9664085f$export$bd6240f4cf59123a), onUpdate);
        const emitters = this.emitters.map((emitter)=>{
            const { life: life } = emitter;
            if (life === Infinity) {
                if (onEnd) onEnd();
                emitter.experimental_emit();
                return Promise.resolve();
            }
            return new Promise((resolve)=>{
                emitter.addOnEmitterDeadEventListener(()=>{
                    if (onEnd) onEnd();
                    resolve();
                });
                emitter.experimental_emit();
            });
        });
        try {
            return Promise.all(emitters);
        } catch (e) {
            console.warn(e);
        }
    }
    /**
   * Updates the particle system based on the delta passed.
   *
   * @example
   * animate = () => {
   *   threeRenderer.render(threeScene, threeCamera);
   *   system.update();
   *   requestAnimationFrame(animate);
   * }
   * animate();
   *
   * @param {number} delta - Delta time
   * @return {Promise}
   */ update(delta = (0, $d975d6add471d316$export$8d825e02d092de99)) {
        const d = delta || (0, $d975d6add471d316$export$8d825e02d092de99);
        if (this.canUpdate) {
            if (d > 0) {
                let i = this.emitters.length;
                while(i--){
                    const emitter = this.emitters[i];
                    emitter.update(d);
                    emitter.isEmitting && this.dispatch((0, $4d2ddc8f9664085f$export$bd6240f4cf59123a));
                }
            }
            this.dispatch((0, $4d2ddc8f9664085f$export$ce6d4e620116271b));
        }
        return Promise.resolve();
    }
    /**
   * Gets a count of the total number of particles in the system.
   *
   * @return {integer}
   */ getCount() {
        const length = this.emitters.length;
        let total = 0;
        let i;
        for(i = 0; i < length; i++)total += this.emitters[i].particles.length;
        return total;
    }
    /**
   * Destroys all emitters, renderers and the Nebula pool.
   * Ensures that this.update will not perform any operations while the system
   * is being destroyed.
   *
   * @return void
   */ destroy() {
        const length = this.emitters.length;
        this.canUpdate = false;
        for(let e = 0; e < length; e++){
            this.emitters[e] && this.emitters[e].destroy();
            delete this.emitters[e];
        }
        for(let r = 0; r < length; r++)if (this.renderers[r] && this.renderers[r].destroy) {
            this.renderers[r].destroy();
            delete this.renderers[r];
        }
        this.emitters.length = 0;
        this.pool.destroy();
        this.canUpdate = true;
    }
    /**
   * Constructs a System instance.
   *
   * @param {object} THREE - ThreeJs
   * @param {number} [preParticles=POOL_MAX] - The number of particles to start with
   * @param {string} [integrationType=INTEGRATION_TYPE_EULER] - The integration type to use
   * @return void
   */ constructor(preParticles = (0, $c1da9e54204bbff9$export$c26fa02a1904398c), integrationType = (0, $3aa7c721e9776547$export$ee71156541331f4c)){
        /**
     * @desc The class type.
     * @type {string}
     */ this.type = (0, $7b675df6fec73cb3$export$ba1b6cbca38d23d8);
        /**
     * @desc Determines if the system can update or not. Set to false when destroying
     * to ensure that external calls to update do not throw errors.
     * @type {boolean}
     */ this.canUpdate = true;
        /**
     * @desc The number of particles to start with.
     * @type {number}
     */ this.preParticles = preParticles;
        /**
     * @desc The integration algorithm type to use.
     * @param {string}
     */ this.integrationType = integrationType;
        /**
     * @desc The emitters in the particle system.
     * @type {array<Emitter>}
     */ this.emitters = [];
        /**
     * @desc The renderers for the system.
     * @type {array<Renderer>}
     */ this.renderers = [];
        /**
     * @desc A pool used to manage the internal system cache of objects
     * @type {Pool}
     */ this.pool = new (0, $84702be31d3f40ce$export$2e2bcd8739ae039)();
        /**
     * @desc Internal event dispatcher
     * @type {EventDispatcher}
     */ this.eventDispatcher = new (0, $048d8be74dedd185$export$2e2bcd8739ae039)();
    }
}





const $7ebde461efdc32c2$export$aa4eace044cdfdbf = 10;
const $7ebde461efdc32c2$export$611c894df53833b0 = 10;
const $7ebde461efdc32c2$export$7f882bb969de14a3 = 10;
const $7ebde461efdc32c2$export$63f2df7bd7371262 = 15;
const $7ebde461efdc32c2$export$e4c0458e30711294 = 15;
const $7ebde461efdc32c2$export$1264a6620073cfaa = 0;


var /**
 * @exports Debug - methods and helpers for debugging System emitters, zones and particles.
 * @requires THREE - { SphereGeometry, BoxGeometry, MeshBasicMaterial, OctahedronGeometry, Mesh }
 */ $5f9bbdfa9a4c56fe$export$2e2bcd8739ae039 = {
    /**
   * Adds an event listener to the system instance's SYSTEM_UPDATE event.
   *
   * @param {System} system - the system instance
   * @param {function} onSystemUpdated - the function to call when system has been updated
   * @return {Debug}
   */ addEventListener: function(system, onSystemUpdated) {
        system.eventDispatcher.addEventListener("SYSTEM_UPDATE", onSystemUpdated);
        return this;
    },
    /**
   * Draws a wireframe mesh around the zone for debugging purposes.
   *
   * @param {System} system - the system instance
   * @param {object} container - a three Object3D (usually the scene)
   * @param {Zone} zone - a Zone instance
   * @return void
   */ drawZone: function(THREE, system, container, zone = {}) {
        const color = "#2194ce";
        const wireframe = true;
        const { width: width = (0, $7ebde461efdc32c2$export$e4c0458e30711294), height: height = (0, $7ebde461efdc32c2$export$e4c0458e30711294), depth: depth = (0, $7ebde461efdc32c2$export$e4c0458e30711294), radius: radius = (0, $7ebde461efdc32c2$export$e4c0458e30711294), x: x = (0, $7ebde461efdc32c2$export$1264a6620073cfaa), y: y = (0, $7ebde461efdc32c2$export$1264a6620073cfaa), z: z = (0, $7ebde461efdc32c2$export$1264a6620073cfaa) } = zone;
        let geometry;
        if (zone.isPointZone()) geometry = new THREE.SphereGeometry(15);
        zone.isLineZone();
        if (zone.isBoxZone()) geometry = new THREE.BoxGeometry(width, height, depth);
        if (zone.isSphereZone()) geometry = new THREE.SphereGeometry(radius, (0, $7ebde461efdc32c2$export$e4c0458e30711294), (0, $7ebde461efdc32c2$export$e4c0458e30711294));
        if (zone.isMeshZone()) geometry = zone.geometry.geometry ? zone.geometry.geometry.clone() : zone.geometry.clone();
        if (!geometry) geometry = new THREE.BoxGeometry(width, height, depth);
        const material = new THREE.MeshBasicMaterial({
            color: color,
            wireframe: wireframe
        }); // NOTE! geometry.clone is required for UNKNOWN reasons,
        // three does not render the mesh correctly without doing this since r88
        const mesh = new THREE.Mesh(geometry.clone(), material);
        container.add(mesh);
        this.addEventListener(system, function() {
            mesh.position.set(x, y, z);
        });
    },
    /**
   * Draws a mesh for each particle emitted in order to help debug particles.
   *
   * @param {object} system - the system instance
   * @param {object} container - a three Object3D (usually the scene)
   * @param {object} emitter - the emitter to debug
   * @param {string} color - the color for the debug mesh material
   * @return void
   */ drawEmitter: function(THREE, system, container, emitter, color) {
        const geometry = new THREE.OctahedronGeometry((0, $7ebde461efdc32c2$export$e4c0458e30711294));
        const material = new THREE.MeshBasicMaterial({
            color: color || "#aaa",
            wireframe: true
        }); // NOTE! geometry.clone is required for UNKNOWN reasons,
        // three does not render the mesh correctly without doing this since r88
        const mesh = new THREE.Mesh(geometry.clone(), material);
        container.add(mesh);
        this.addEventListener(system, function() {
            mesh.position.copy(emitter.position);
            mesh.rotation.set(emitter.rotation.x, emitter.rotation.y, emitter.rotation.z);
        });
    },
    /**
   * Renders emitter / particle information into the info element.
   *
   * @param {object} system - the system instance
   * @param {integer} style - style to apply (see the addInfo method's switch statement)
   * @return void
   */ renderInfo: function() {
        function getCreatedNumber(type, system) {
            var pool = type == "material" ? "_materialPool" : "_targetPool";
            var renderer = system.renderers[0];
            return renderer[pool].cID;
        }
        function getEmitterPos(system) {
            var e = system.emitters[0];
            return Math.round(e.p.x) + "," + Math.round(e.p.y) + "," + Math.round(e.p.z);
        }
        return function(system, style) {
            this.addInfo(style);
            var str = "";
            switch(this._infoType){
                case 2:
                    str += "emitter:" + system.emitters.length + "<br>";
                    str += "em speed:" + system.emitters[0].cID + "<br>";
                    str += "pos:" + getEmitterPos(system);
                    break;
                case 3:
                    str += system.renderers[0].name + "<br>";
                    str += "target:" + getCreatedNumber("target") + "<br>";
                    str += "material:" + getCreatedNumber("material");
                    break;
                default:
                    str += "particles:" + system.getCount() + "<br>";
                    str += "pool:" + system.pool.getCount() + "<br>";
                    str += "total:" + (system.getCount() + system.pool.getCount());
            }
            this._infoCon.innerHTML = str;
        };
    }(),
    /**
   * Appends the info element into the dom.
   *
   * @param {integer} style - the style type to apply
   * @return void
   */ addInfo: function() {
        return function(style) {
            var self = this;
            if (!this._infoCon) {
                this._infoCon = document.createElement("div");
                this._infoCon.style.cssText = [
                    "position:fixed;bottom:0px;left:0;cursor:pointer;",
                    "opacity:0.9;z-index:10000;padding:10px;font-size:12px;",
                    "width:120px;height:50px;background-color:#002;color:#0ff;"
                ].join("");
                this._infoType = 1;
                this._infoCon.addEventListener("click", function() {
                    self._infoType++;
                    if (self._infoType > 3) self._infoType = 1;
                }, false);
                var bg, color;
                switch(style){
                    case 2:
                        bg = "#201";
                        color = "#f08";
                        break;
                    case 3:
                        bg = "#020";
                        color = "#0f0";
                        break;
                    default:
                        bg = "#002";
                        color = "#0ff";
                }
                this._infoCon.style["background-color"] = bg;
                this._infoCon.style["color"] = color;
            }
            if (!this._infoCon.parentNode) document.body.appendChild(this._infoCon);
        };
    }()
};


/**
 * You can use this emit particles.
 *
 * This method will console.log the fixed number of your info  in updata or requestAnimationFrame
 *
 * use like this log('+12',mc); log 12 times
 *
 * @return void
 */ function $b84019bdd32b41cc$export$2e2bcd8739ae039() {
    let once = 0;
    if (window.console && window.console.trace) {
        var arg = Array.prototype.slice.call(arguments);
        var s1 = arguments[0] + "";
        if (s1.indexOf("+") == 0) {
            var n = parseInt(arguments[0]);
            if (once < n) {
                arg.shift();
                console.trace.apply(console, arg);
                once++;
            }
        } else {
            arg.unshift("+15");
            this.apply(console, arg);
        }
    }
}









class $3452858f3b7db584$export$2e2bcd8739ae039 extends (0, $975f8eaf1ecebbca$export$2e2bcd8739ae039) {
    initEventHandler() {
        var self = this;
        this.mousemoveHandler = function(e) {
            self.mousemove.call(self, e);
        };
        this.mousedownHandler = function(e) {
            self.mousedown.call(self, e);
        };
        this.mouseupHandler = function(e) {
            self.mouseup.call(self, e);
        };
        this.mouseTarget.addEventListener("mousemove", this.mousemoveHandler, false);
    }
    /**
   * start emit particle
   * @method emit
   */ emit() {
        this._allowEmitting = true;
    }
    /**
   * stop emiting
   * @method stopEmit
   */ stopEmit() {
        this._allowEmitting = false;
    }
    setCameraAndCanvas(camera, canvas) {
        this.camera = camera;
        this.canvas = canvas;
    }
    mousemove(e) {
        if (e.layerX || e.layerX == 0) {
            this.position.x += (e.layerX - this.position.x) * this.ease;
            this.position.y += (e.layerY - this.position.y) * this.ease;
        } else if (e.offsetX || e.offsetX == 0) {
            this.position.x += (e.offsetX - this.position.x) * this.ease;
            this.position.y += (e.offsetY - this.position.y) * this.ease;
        }
        this.position.copy((0, $2e283c7833e9635b$export$2e2bcd8739ae039).toSpacePos(this.position, this.camera, this.canvas));
        if (this._allowEmitting) super.emit("once");
    }
    /**
   * Destory this Emitter
   * @method destroy
   */ destroy() {
        super.destroy();
        this.mouseTarget.removeEventListener("mousemove", this.mousemoveHandler, false);
    }
    /**
   * The FollowEmitter class inherits from System.Emitter
   *
   * use the FollowEmitter will emit particle when mousemoving
   *
   * @class System.FollowEmitter
   * @constructor
   * @param {Element} mouseTarget mouseevent's target;
   * @param {Number} ease the easing of following speed;
   * @default 0.7
   * @param {Object} pObj the parameters object;
   */ constructor(mouseTarget, ease, pObj){
        super(pObj);
        /**
     * @desc The class type.
     * @type {string}
     */ this.type = (0, $3096c998c6de9d20$export$92bcd9be8faff9f);
        this.mouseTarget = (0, $23c21dd81897876b$export$2e2bcd8739ae039).initValue(mouseTarget, window);
        this.ease = (0, $23c21dd81897876b$export$2e2bcd8739ae039).initValue(ease, 0.7);
        this._allowEmitting = false;
        this.initEventHandler();
    }
}










class $ba2b4a98b9634304$export$2e2bcd8739ae039 {
    init(system) {
        var self = this;
        this.system = system;
        this.system.eventDispatcher.addEventListener((0, $4d2ddc8f9664085f$export$bd6240f4cf59123a), function(system) {
            self.onSystemUpdate.call(self, system);
        });
        this.system.eventDispatcher.addEventListener((0, $4d2ddc8f9664085f$export$421681fbc92d2c7c), function(particle) {
            self.onParticleCreated.call(self, particle);
        });
        this.system.eventDispatcher.addEventListener((0, $4d2ddc8f9664085f$export$868dbb69ba0499ec), function(particle) {
            self.onParticleUpdate.call(self, particle);
        });
        this.system.eventDispatcher.addEventListener((0, $4d2ddc8f9664085f$export$2204007c8bf30e02), function(particle) {
            self.onParticleDead.call(self, particle);
        });
        this.logRendererType();
    }
    remove() {
        this.system = null;
    }
    /**
   * @abstract
   */ onParticleCreated(particle) {}
    /**
   * @abstract
   */ onParticleUpdate(particle) {}
    /**
   * @abstract
   */ onParticleDead(particle) {}
    /**
   * @abstract
   */ onSystemUpdate(system) {}
    /**
   * Logs the renderer type being used when in development mode.
   *
   * @return void
   */ logRendererType() {
        if (!(0, $c1da9e54204bbff9$export$a866f231438cc228)) return;
        console.log(`${this.type}`);
    }
    constructor(type = (0, $01c6d32cf1e9ec4f$export$e90783d3d6cc6b79)){
        /**
     * @desc The class type.
     * @type {string}
     */ this.type = type;
    }
}




class $be79b12992bab8da$export$2e2bcd8739ae039 extends (0, $ba2b4a98b9634304$export$2e2bcd8739ae039) {
    onSystemUpdate() {}
    onParticleCreated(particle) {}
    onParticleUpdate(particle) {}
    onParticleDead(particle) {}
    constructor(){
        super((0, $01c6d32cf1e9ec4f$export$594421b9ecc9477d));
        this.targetPool = new (0, $84702be31d3f40ce$export$2e2bcd8739ae039)();
        this.materialPool = new (0, $84702be31d3f40ce$export$2e2bcd8739ae039)();
    }
}






class $c302b5271fb53896$export$2e2bcd8739ae039 extends (0, $ba2b4a98b9634304$export$2e2bcd8739ae039) {
    isThreeSprite(particle) {
        return particle.target.isSprite;
    }
    onSystemUpdate() {}
    onParticleCreated(particle) {
        if (!particle.target) {
            //set target
            if (!particle.body) particle.body = this._body;
            particle.target = this._targetPool.get(particle.body); //set material
            if (particle.useAlpha || particle.useColor) {
                particle.target.material.__puid = (0, $b08343919f129d8b$export$2e2bcd8739ae039).id(particle.body.material);
                particle.target.material = this._materialPool.get(particle.target.material);
            }
        }
        if (particle.target) {
            particle.target.position.copy(particle.position);
            this.container.add(particle.target);
        }
    }
    onParticleUpdate(particle) {
        const { target: target, useAlpha: useAlpha, useColor: useColor, rotation: rotation } = particle;
        if (!target) return;
        target.position.copy(particle.position);
        if (!this.isThreeSprite(particle)) target.rotation.set(rotation.x, rotation.y, rotation.z);
        this.scale(particle);
        if (useAlpha) {
            target.material.opacity = particle.alpha;
            target.material.transparent = true;
        }
        if (useColor) target.material.color.copy(particle.color);
    }
    scale(particle) {
        particle.target.scale.set(particle.scale, particle.scale, particle.scale);
    }
    onParticleDead(particle) {
        if (particle.target) {
            if (particle.useAlpha || particle.useColor) this._materialPool.expire(particle.target.material);
            this._targetPool.expire(particle.target);
            this.container.remove(particle.target);
            particle.target = null;
        }
    }
    /**
   * @param {object} container - An Object3D container, usually a THREE.Scene
   * @param {object} THREE - THREE Api
   */ constructor(container, THREE){
        super((0, $01c6d32cf1e9ec4f$export$13f3ab3a8ec8b6b));
        this.container = container;
        this._targetPool = new (0, $84702be31d3f40ce$export$2e2bcd8739ae039)();
        this._materialPool = new (0, $84702be31d3f40ce$export$2e2bcd8739ae039)();
        this._body = new THREE.Mesh(new THREE.BoxGeometry(50, 50, 50), new THREE.MeshLambertMaterial({
            color: "#ff0000"
        }));
    }
}




class $1f54cd272171758a$export$2e2bcd8739ae039 extends (0, $c302b5271fb53896$export$2e2bcd8739ae039) {
    scale(particle) {
        particle.target.scale.set(particle.scale * particle.radius, particle.scale * particle.radius, 1);
    }
    constructor(container, THREE){
        super(container, THREE);
        /**
     * @desc The class type.
     * @type {string}
     */ this.type = (0, $01c6d32cf1e9ec4f$export$13a70080352d20ed);
        this._body = new THREE.Sprite(new THREE.SpriteMaterial({
            color: 0xffffff
        }));
    }
}



// Primitives
const $aa76ec30b2c3df7f$export$c7147facf1540adb = 10000;
const $aa76ec30b2c3df7f$export$c445cdb396ee50c8 = 3;
const $aa76ec30b2c3df7f$export$460f58825da1eaf4 = 4;
const $aa76ec30b2c3df7f$export$d86ed19a9df9edb3 = 4; // Byte sizes
const $aa76ec30b2c3df7f$export$a46d99c0ba723155 = $aa76ec30b2c3df7f$export$c445cdb396ee50c8 * $aa76ec30b2c3df7f$export$d86ed19a9df9edb3;
const $aa76ec30b2c3df7f$export$8e579c9035d1a374 = $aa76ec30b2c3df7f$export$d86ed19a9df9edb3;
const $aa76ec30b2c3df7f$export$eb1bc3b5ea71c19 = $aa76ec30b2c3df7f$export$460f58825da1eaf4 * $aa76ec30b2c3df7f$export$d86ed19a9df9edb3;
const $aa76ec30b2c3df7f$export$6ff0c0f693d6eb6 = [
    $aa76ec30b2c3df7f$export$a46d99c0ba723155,
    $aa76ec30b2c3df7f$export$8e579c9035d1a374,
    $aa76ec30b2c3df7f$export$eb1bc3b5ea71c19
];
const $aa76ec30b2c3df7f$export$f49f2bab4425f3d5 = $aa76ec30b2c3df7f$export$6ff0c0f693d6eb6.reduce((cur, acc)=>cur + acc); // Attributes
const $aa76ec30b2c3df7f$export$c4229a882e82be2f = $aa76ec30b2c3df7f$export$c445cdb396ee50c8;
const $aa76ec30b2c3df7f$export$75cfd2c0a5cb98b8 = 1;
const $aa76ec30b2c3df7f$export$79e2a8cb927a2601 = $aa76ec30b2c3df7f$export$460f58825da1eaf4;
const $aa76ec30b2c3df7f$export$92c109e5da8abab6 = 1;
const $aa76ec30b2c3df7f$export$2503b4e5d95f1653 = 2;
const $aa76ec30b2c3df7f$export$83385be140fc9a1c = {
    position: $aa76ec30b2c3df7f$export$c4229a882e82be2f,
    size: $aa76ec30b2c3df7f$export$75cfd2c0a5cb98b8,
    // THREE.Color does not contain alpha, so we will have separate attributes for these
    color: $aa76ec30b2c3df7f$export$79e2a8cb927a2601,
    alpha: $aa76ec30b2c3df7f$export$92c109e5da8abab6,
    texID: $aa76ec30b2c3df7f$export$2503b4e5d95f1653
};
const $aa76ec30b2c3df7f$export$a8c08a67c583e911 = [
    $aa76ec30b2c3df7f$export$c4229a882e82be2f,
    $aa76ec30b2c3df7f$export$75cfd2c0a5cb98b8,
    $aa76ec30b2c3df7f$export$79e2a8cb927a2601,
    $aa76ec30b2c3df7f$export$92c109e5da8abab6,
    $aa76ec30b2c3df7f$export$2503b4e5d95f1653
].reduce((cur, acc)=>cur + acc);


const $c127bd8a77905224$export$4055fccee954182e = {
    blending: "AdditiveBlending",
    baseColor: 0xffffff,
    depthTest: true,
    depthWrite: false,
    transparent: true,
    maxParticles: (0, $aa76ec30b2c3df7f$export$c7147facf1540adb),
    shouldDebugTextureAtlas: false,
    shouldForceDesktopRenderer: false,
    shouldForceMobileRenderer: false
};



/**
 * Simple class that stores the particle's "target" or "next" state.
 *
 */ class $fdfbe0610e54be54$export$a51f2b8e6ae258ea {
    reset() {
        this.position.set(0, 0, 0);
        this.size = 0;
        this.color.setRGB(0, 0, 0);
        this.alpha = 0;
        this.texture = null;
    }
    constructor(THREE){
        this.position = new THREE.Vector3();
        this.size = 0;
        this.color = new THREE.Color();
        this.alpha = 0;
        this.texture = null;
        this.index = 0;
    }
}


/**
 * Map of particle IDs to integer ids
 */ class $f555b0ae6871fc5a$export$34816f6634522548 {
    add(item) {
        if (this._items[item] !== undefined) return;
        this._items[item] = this.count++;
    }
    find(item) {
        return this._items[item];
    }
    destroy() {
        this._items = {};
        this.count = 0;
    }
    constructor(max = Infinity){
        this.max = max;
        this.count = 0;
        this._items = {};
    }
}





let $34f4fea81d25f00f$var$THREE;
class $34f4fea81d25f00f$export$2e2bcd8739ae039 {
    /**
   * Creates the interleaved buffer that will be used to write data to the GPU.
   *
   * @return {ParticleBuffer}
   */ createInterleavedBuffer() {
        const arrayBuffer = new ArrayBuffer(this.maxParticles * (0, $aa76ec30b2c3df7f$export$f49f2bab4425f3d5));
        this.interleavedBuffer = new $34f4fea81d25f00f$var$THREE.InterleavedBuffer(new Float32Array(arrayBuffer), (0, $aa76ec30b2c3df7f$export$f49f2bab4425f3d5)); // this.interleavedBuffer.usage = THREE.DynamicDrawUsage;
        return this;
    }
    /**
   * Sets the geometry's buffer attributes.
   *
   * NOTE Each attribute needs to be set at the right index in the buffer right after the previous
   * attribute that occupies a set amount of size in the buffer.
   *
   * @return {ParticleBufferGeometry}
   */ createBufferGeometry() {
        this.geometry = new $34f4fea81d25f00f$var$THREE.BufferGeometry();
        const { interleavedBuffer: interleavedBuffer, geometry: geometry } = this;
        Object.keys((0, $aa76ec30b2c3df7f$export$83385be140fc9a1c)).reduce((offset, attribute)=>{
            const size = (0, $aa76ec30b2c3df7f$export$83385be140fc9a1c)[attribute];
            geometry.setAttribute(attribute, new $34f4fea81d25f00f$var$THREE.InterleavedBufferAttribute(interleavedBuffer, size, offset));
            return offset += size;
        }, 0);
        return this;
    }
    /**
   * Gets the publicly accessible interleaved buffer.
   *
   * @return {THREE.InterleavedBuffer} buffers - The interleaved buffer
   */ get buffer() {
        return this.interleavedBuffer;
    }
    get stride() {
        return 0, $aa76ec30b2c3df7f$export$f49f2bab4425f3d5;
    }
    constructor(maxParticles = (0, $aa76ec30b2c3df7f$export$c7147facf1540adb), three){
        $34f4fea81d25f00f$var$THREE = three;
        this.maxParticles = maxParticles;
        this.createInterleavedBuffer().createBufferGeometry();
    }
}



const $e920660a997f7aa2$export$1351f91a8b9b1336 = 256;



function $31f1480f9d5f5590$export$2e2bcd8739ae039(boxes) {
    // calculate total box area and maximum box width
    let area = 0;
    let maxWidth = 0;
    for (const box of boxes){
        area += box.w * box.h;
        maxWidth = Math.max(maxWidth, box.w);
    }
    // sort the boxes for insertion by height, descending
    boxes.sort((a, b)=>b.h - a.h);
    // aim for a squarish resulting container,
    // slightly adjusted for sub-100% space utilization
    const startWidth = Math.max(Math.ceil(Math.sqrt(area / 0.95)), maxWidth);
    // start with a single empty space, unbounded at the bottom
    const spaces = [
        {
            x: 0,
            y: 0,
            w: startWidth,
            h: Infinity
        }
    ];
    let width = 0;
    let height = 0;
    for (const box of boxes)// look through spaces backwards so that we check smaller spaces first
    for(let i = spaces.length - 1; i >= 0; i--){
        const space = spaces[i];
        // look for empty spaces that can accommodate the current box
        if (box.w > space.w || box.h > space.h) continue;
        // found the space; add the box to its top-left corner
        // |-------|-------|
        // |  box  |       |
        // |_______|       |
        // |         space |
        // |_______________|
        box.x = space.x;
        box.y = space.y;
        height = Math.max(height, box.y + box.h);
        width = Math.max(width, box.x + box.w);
        if (box.w === space.w && box.h === space.h) {
            // space matches the box exactly; remove it
            const last = spaces.pop();
            if (i < spaces.length) spaces[i] = last;
        } else if (box.h === space.h) {
            // space matches the box height; update it accordingly
            // |-------|---------------|
            // |  box  | updated space |
            // |_______|_______________|
            space.x += box.w;
            space.w -= box.w;
        } else if (box.w === space.w) {
            // space matches the box width; update it accordingly
            // |---------------|
            // |      box      |
            // |_______________|
            // | updated space |
            // |_______________|
            space.y += box.h;
            space.h -= box.h;
        } else {
            // otherwise the box splits the space into two spaces
            // |-------|-----------|
            // |  box  | new space |
            // |_______|___________|
            // | updated space     |
            // |___________________|
            spaces.push({
                x: space.x + box.w,
                y: space.y,
                w: space.w - box.w,
                h: box.h
            });
            space.y += box.h;
            space.h -= box.h;
        }
        break;
    }
    return {
        w: width,
        h: height,
        fill: area / (width * height) || 0 // space utilization
    };
}


class $8c8971f6d8d203a3$export$2e2bcd8739ae039 {
    /**
   * Logs to the console when in dev mode.
   *
   */ log(...args) {
        if (!(0, $c1da9e54204bbff9$export$a866f231438cc228)) return;
        console.log(...args);
    }
    /**
   * Debugs the texture atlas by rendering it to a canvas in the DOM.
   *
   */ debug() {
        const { canvas: canvas, ctx: ctx } = this;
        const halfmax = canvas.width;
        ctx.fillStyle = "purple";
        ctx.fillRect(0, 0, halfmax, halfmax);
        ctx.fillStyle = "green";
        ctx.fillRect(0, halfmax, halfmax, halfmax);
        ctx.fillStyle = "blue";
        ctx.fillRect(halfmax, 0, halfmax, halfmax);
        ctx.fillStyle = "orange";
        ctx.fillRect(halfmax, halfmax, halfmax, halfmax);
        ctx.fillStyle = "yellow";
        ctx.font = canvas.width + "px Verdana";
        ctx.fillText("top row", 100, 500);
        ctx.fillStyle = "pink";
        ctx.fillText("bottom row", 100, 1500);
        canvas.style.position = "absolute";
        canvas.style.width = canvas.style.height = "300px";
        canvas.style.left = canvas.style.top = "0px";
        canvas.style.zIndex = 100;
        document.body.appendChild(canvas);
    }
    /**
   * Adds a texture to the texture atlas and flags that the atlas needs to be updated.
   *
   */ addTexture(texture) {
        this.log("Adding texture to atlas:", texture.uuid);
        texture.textureIndex = this.entries.length;
        this.entries.push({
            texture: texture
        });
        this.needsUpdate = true;
    }
    /**
   * Updates the texture atlas. Will only rebuild the atlas if all images are loaded.
   *
   */ update() {
        if (!this.needsUpdate) return;
        const { entries: entries, canvas: canvas, indexData: indexData, ctx: ctx, atlasIndex: atlasIndex, atlasTexture: atlasTexture, rendererType: rendererType } = this;
        for(let i = 0; i < entries.length; i++){
            if (!entries[i].texture.image) return;
        }
        this.needsUpdate = false;
        for(let i = 0; i < entries.length; i++){
            const e = entries[i];
            const { texture: texture } = e;
            const { width: width, height: height } = texture.image;
            e.w = width;
            e.h = height;
        }
        const stats = (0, $31f1480f9d5f5590$export$2e2bcd8739ae039)(entries);
        this.log("Rebuilt atlas:", stats);
        if (canvas.width != stats.w || canvas.height != stats.h) {
            canvas.width = stats.w;
            canvas.height = stats.h;
        }
        for(let i = 0; i < entries.length; i++){
            const e = this.entries[i];
            const ii = e.texture.textureIndex * 4;
            if (rendererType === (0, $01c6d32cf1e9ec4f$export$2584e79471e6d789)) {
                indexData[ii + 0] = e.x / canvas.width;
                indexData[ii + 1] = e.y / canvas.height;
                indexData[ii + 2] = (e.x + e.w) / canvas.width;
                indexData[ii + 3] = (e.y + e.h) / canvas.height;
            }
            if (rendererType === (0, $01c6d32cf1e9ec4f$export$e401f959685949e0)) {
                indexData[ii + 0] = e.x / (canvas.width + 1);
                indexData[ii + 1] = e.y / (canvas.height + 1);
                indexData[ii + 2] = (e.x + e.w) / (canvas.width + 1);
                indexData[ii + 3] = (e.y + e.h) / (canvas.height + 1);
            }
            ctx.drawImage(e.texture.image, e.x, e.y, e.w, e.h);
        }
        if (rendererType === (0, $01c6d32cf1e9ec4f$export$2584e79471e6d789)) atlasIndex.needsUpdate = true;
        atlasTexture.needsUpdate = true;
    }
    /**
   * Disposes of the textures used by the texture atlas.
   *
   * @return void
   */ destroy() {
        const { atlasIndex: atlasIndex, atlasTexture: atlasTexture, canvas: canvas } = this;
        atlasTexture.dispose();
        atlasIndex && atlasIndex.dispose();
        if (this.shouldDebug) canvas.remove();
        this.entries = [];
    }
    constructor(renderer, shouldDebug){
        const { three: THREE, type: rendererType } = renderer;
        const data = new Float32Array((0, $e920660a997f7aa2$export$1351f91a8b9b1336) * 4);
        const ctx = this.ctx = document.createElement("canvas").getContext("2d");
        const { canvas: canvas } = ctx;
        this.shouldDebug = shouldDebug;
        this.rendererType = rendererType;
        this.indexData = data;
        this.canvas = canvas;
        this.entries = [];
        if (rendererType === (0, $01c6d32cf1e9ec4f$export$2584e79471e6d789)) this.atlasIndex = new THREE.DataTexture(data, (0, $e920660a997f7aa2$export$1351f91a8b9b1336), 1, THREE.RGBAFormat, THREE.FloatType);
        canvas.width = canvas.height = (0, $e920660a997f7aa2$export$1351f91a8b9b1336);
        if (shouldDebug) this.debug(canvas, ctx);
        this.atlasTexture = new THREE.CanvasTexture(canvas);
        this.atlasTexture.flipY = false;
        renderer.material.uniforms.uTexture.value = this.atlasTexture;
        if (rendererType === (0, $01c6d32cf1e9ec4f$export$2584e79471e6d789)) renderer.material.uniforms.atlasIndex.value = this.atlasIndex;
        renderer.material.uniformsNeedUpdate = true;
    }
}




const $5c06b63e7f9f6536$export$4391ef72fa03c19 = ()=>{
    return `
    uniform vec3 baseColor;
    uniform sampler2D uTexture;
    uniform sampler2D atlasIndex;

    varying vec3 targetColor;
    varying float targetAlpha;
    varying vec4 tileRect;
    varying float tileID;

    void main() {
      gl_FragColor = vec4(baseColor * targetColor, targetAlpha);

      vec2 uv = gl_PointCoord;
      uv = mix(tileRect.xy, tileRect.zw, gl_PointCoord);

      gl_FragColor = gl_FragColor * texture2D(uTexture, uv);

    }
`;
};



const $aaa069560256e792$export$e9cc0acaf7480ed0 = "600.0";


const $a29b3c4cefa57865$export$84657c60382b0f83 = ()=>{
    return `
    uniform sampler2D uTexture;
    //atlasIndex is a 256x1 float texture of tile rectangles as r=minx g=miny b=maxx a=maxy
    uniform sampler2D atlasIndex;

    attribute float size;
    attribute vec3 color;
    attribute float alpha;
    attribute float texID;

    varying vec3 targetColor;
    varying float targetAlpha;
    varying vec4 tileRect;
    varying float tileID;

    void main() {
      vec4 mvPosition = modelViewMatrix * vec4(position, 1.0);
      targetColor = color;
      targetAlpha = alpha;

      tileID = texID;
      //get the tile rectangle from the atlasIndex texture..
      tileRect = texture2D(atlasIndex, vec2((tileID + 0.5) / ${0, $e920660a997f7aa2$export$1351f91a8b9b1336}.0, 0.5));

      gl_PointSize = ((size * ${0, $aaa069560256e792$export$e9cc0acaf7480ed0}) / -mvPosition.z);
      gl_Position = projectionMatrix * mvPosition;
    }
`;
};








function $a19199552a5cc988$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $a19199552a5cc988$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $a19199552a5cc988$var$ownKeys(Object(source), true).forEach(function(key) {
            (0, (/*@__PURE__*/$parcel$interopDefault($cc894e2648a4bb4d$exports)))(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $a19199552a5cc988$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
let $a19199552a5cc988$var$THREE;
class $a19199552a5cc988$export$2e2bcd8739ae039 extends (0, $ba2b4a98b9634304$export$2e2bcd8739ae039) {
    onSystemUpdate(system) {
        super.onSystemUpdate(system);
        this.buffer.needsUpdate = true;
        this.textureAtlas && this.textureAtlas.update();
    }
    /**
   * Pools the particle target if it does not exist.
   * Updates the target and maps particle properties to the point.
   *
   * @param {Particle}
   */ onParticleCreated(particle) {
        if (!particle.target) {
            particle.target = this.targetPool.get((0, $fdfbe0610e54be54$export$a51f2b8e6ae258ea), $a19199552a5cc988$var$THREE);
            this.uniqueList.add(particle.id);
        }
        this.updateTarget(particle).mapParticleTargetPropsToPoint(particle);
    }
    /**
   * Maps particle properties to the point if the particle has a target.
   *
   * @param {Particle}
   */ onParticleUpdate(particle) {
        if (!particle.target) return;
        this.updateTarget(particle).mapParticleTargetPropsToPoint(particle);
    }
    /**
   * Resets and clears the particle target.
   *
   * @param {Particle}
   */ onParticleDead(particle) {
        if (!particle.target) return;
        particle.target.reset();
        this.mapParticleTargetPropsToPoint(particle);
        particle.target = null;
    }
    /**
   * Maps all mutable properties from the particle to the target.
   *
   * @param {Particle}
   * @return {DesktopGPURenderer}
   */ updateTarget(particle) {
        const { position: position, scale: scale, radius: radius, color: color, alpha: alpha, body: body, id: id } = particle;
        const { r: r, g: g, b: b } = color;
        particle.target.position.copy(position);
        particle.target.size = scale * radius;
        particle.target.color.setRGB(r, g, b);
        particle.target.alpha = alpha;
        particle.target.index = this.uniqueList.find(id);
        if (body && body instanceof $a19199552a5cc988$var$THREE.Sprite) {
            const { map: map } = body.material;
            particle.target.texture = map;
            particle.target.textureIndex = this.getTextureID(map, this.shouldDebugTextureAtlas);
        }
        return this;
    }
    /**
   * Entry point for mapping particle properties to buffer geometry points.
   *
   * @param {Particle} particle - The particle containing the properties to map
   * @return {DesktopGPURenderer}
   */ mapParticleTargetPropsToPoint(particle) {
        this.updatePointPosition(particle).updatePointSize(particle).updatePointColor(particle).updatePointAlpha(particle).updatePointTextureIndex(particle);
        return this;
    }
    /**
   * Updates the point's position according to the particle's target position.
   *
   * @param {Particle} particle - The particle containing the target position.
   * @return {DesktopGPURenderer}
   */ updatePointPosition(particle) {
        const attribute = "position";
        const { geometry: geometry, stride: stride, buffer: buffer } = this;
        const { target: target } = particle;
        const { offset: offset } = geometry.attributes[attribute];
        buffer.array[target.index * stride + offset + 0] = target.position.x;
        buffer.array[target.index * stride + offset + 1] = target.position.y;
        buffer.array[target.index * stride + offset + 2] = target.position.z;
        return this;
    }
    /**
   * Updates the point's size relative to the particle's target scale and radius.
   *
   * @param {Particle} particle - The particle containing the target scale.
   * @return {DesktopGPURenderer}
   */ updatePointSize(particle) {
        const attribute = "size";
        const { geometry: geometry, stride: stride, buffer: buffer } = this;
        const { target: target } = particle;
        const { offset: offset } = geometry.attributes[attribute];
        buffer.array[target.index * stride + offset + 0] = target.size;
        return this;
    }
    /**
   * Updates the point's color attribute according with the particle's target color.
   *
   * @param {Particle} particle - The particle containing the target color and alpha.
   * @return {DesktopGPURenderer}
   */ updatePointColor(particle) {
        const attribute = "color";
        const { geometry: geometry, stride: stride, buffer: buffer } = this;
        const { target: target } = particle;
        const { offset: offset } = geometry.attributes[attribute];
        buffer.array[target.index * stride + offset + 0] = target.color.r;
        buffer.array[target.index * stride + offset + 1] = target.color.g;
        buffer.array[target.index * stride + offset + 2] = target.color.b;
        return this;
    }
    /**
   * Updates the point alpha attribute with the particle's target alpha.
   *
   * @param {Particle} particle - The particle containing the target alpha.
   * @return {DesktopGPURenderer}
   */ updatePointAlpha(particle) {
        const attribute = "alpha";
        const { geometry: geometry, stride: stride, buffer: buffer } = this;
        const { target: target } = particle;
        const { offset: offset } = geometry.attributes[attribute];
        buffer.array[target.index * stride + offset + 0] = target.alpha;
        return this;
    }
    /**
   * Updates the point texture attribute with the particle's target texture.
   *
   * @param {Particle} particle - The particle containing the target texture.
   * @return {DesktopGPURenderer}
   */ updatePointTextureIndex(particle) {
        const attribute = "texID";
        const { geometry: geometry, stride: stride, buffer: buffer } = this;
        const { target: target } = particle;
        const { offset: offset } = geometry.attributes[attribute];
        buffer.array[target.index * stride + offset + 0] = target.textureIndex;
        return this;
    }
    getTextureID(texture, debug) {
        if (texture.textureIndex === undefined) {
            if (!this.textureAtlas) this.textureAtlas = new (0, $8c8971f6d8d203a3$export$2e2bcd8739ae039)(this, debug);
            this.textureAtlas.addTexture(texture);
        }
        return texture.textureIndex;
    }
    /**
   * Tears down the GPURenderer.
   *
   * @return void
   */ destroy() {
        const { container: container, points: points, textureAtlas: textureAtlas, uniqueList: uniqueList } = this;
        container.remove(points);
        uniqueList.destroy();
        textureAtlas && textureAtlas.destroy();
    }
    constructor(container, three, options = (0, $c127bd8a77905224$export$4055fccee954182e)){
        super((0, $01c6d32cf1e9ec4f$export$2584e79471e6d789));
        $a19199552a5cc988$var$THREE = this.three = three;
        const props = $a19199552a5cc988$var$_objectSpread($a19199552a5cc988$var$_objectSpread({}, (0, $c127bd8a77905224$export$4055fccee954182e)), options);
        const { camera: camera, maxParticles: maxParticles, baseColor: baseColor, blending: blending, depthTest: depthTest, depthWrite: depthWrite, transparent: transparent, shouldDebugTextureAtlas: shouldDebugTextureAtlas } = props;
        const particleBuffer = new (0, $34f4fea81d25f00f$export$2e2bcd8739ae039)(maxParticles, $a19199552a5cc988$var$THREE);
        const material = new $a19199552a5cc988$var$THREE.ShaderMaterial({
            uniforms: {
                baseColor: {
                    value: new $a19199552a5cc988$var$THREE.Color(baseColor)
                },
                uTexture: {
                    value: null
                },
                atlasIndex: {
                    value: null
                }
            },
            vertexShader: (0, $a29b3c4cefa57865$export$84657c60382b0f83)(),
            fragmentShader: (0, $5c06b63e7f9f6536$export$4391ef72fa03c19)(),
            blending: $a19199552a5cc988$var$THREE[blending],
            depthTest: depthTest,
            depthWrite: depthWrite,
            transparent: transparent
        });
        this.container = container;
        this.camera = camera;
        this.targetPool = new (0, $84702be31d3f40ce$export$2e2bcd8739ae039)();
        this.uniqueList = new (0, $f555b0ae6871fc5a$export$34816f6634522548)(maxParticles);
        this.particleBuffer = particleBuffer;
        this.buffer = particleBuffer.buffer;
        this.stride = particleBuffer.stride;
        this.geometry = particleBuffer.geometry;
        this.material = material;
        this.points = new $a19199552a5cc988$var$THREE.Points(this.geometry, this.material);
        this.points.frustumCulled = false;
        this.shouldDebugTextureAtlas = shouldDebugTextureAtlas;
        this.container.add(this.points);
    }
}




const $7ff216d1b58f30f3$export$4391ef72fa03c19 = ()=>{
    return `
    uniform vec3 baseColor;
    uniform sampler2D uTexture;

    varying vec3 targetColor;
    varying float targetAlpha;
    varying vec4 tileRect;

    void main() {
      gl_FragColor = vec4(baseColor * targetColor, targetAlpha);

      vec2 uv = gl_PointCoord;
      uv = mix(tileRect.xy, tileRect.zw, gl_PointCoord);

      gl_FragColor = gl_FragColor * texture2D(uTexture, uv);
    }
`;
};



const $21b73c527cd5a536$export$84657c60382b0f83 = ()=>{
    return `
    uniform sampler2D uTexture;
    uniform vec2 atlasDim;

    attribute float size;
    attribute vec3 color;
    attribute float alpha;
    attribute vec2 texID;

    varying vec3 targetColor;
    varying float targetAlpha;
    varying vec4 tileRect;

    void main() {
      vec4 mvPosition = modelViewMatrix * vec4(position, 1.0);
      targetColor = color;
      targetAlpha = alpha;

      vec2 tmin = floor(texID) / atlasDim;
      vec2 tmax = fract(texID);
      tileRect = vec4(tmin,tmax);

      gl_PointSize = ((size * ${0, $aaa069560256e792$export$e9cc0acaf7480ed0}) / -mvPosition.z);
      gl_Position = projectionMatrix * mvPosition;
    }
`;
};








function $25223dfcb84f73e8$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $25223dfcb84f73e8$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $25223dfcb84f73e8$var$ownKeys(Object(source), true).forEach(function(key) {
            (0, (/*@__PURE__*/$parcel$interopDefault($cc894e2648a4bb4d$exports)))(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $25223dfcb84f73e8$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
let $25223dfcb84f73e8$var$THREE;
class $25223dfcb84f73e8$export$2e2bcd8739ae039 extends (0, $ba2b4a98b9634304$export$2e2bcd8739ae039) {
    onSystemUpdate(system) {
        super.onSystemUpdate(system);
        this.buffer.needsUpdate = true;
        const { textureAtlas: textureAtlas } = this;
        if (textureAtlas) {
            textureAtlas.update();
            this.material.uniforms.atlasDim.value.set(textureAtlas.atlasTexture.image.width, textureAtlas.atlasTexture.image.height);
        }
    }
    /**
   * Pools the particle target if it does not exist.
   * Updates the target and maps particle properties to the point.
   *
   * @param {Particle}
   */ onParticleCreated(particle) {
        if (!particle.target) {
            particle.target = this.targetPool.get((0, $fdfbe0610e54be54$export$a51f2b8e6ae258ea), $25223dfcb84f73e8$var$THREE);
            this.uniqueList.add(particle.id);
        }
        this.updateTarget(particle).mapParticleTargetPropsToPoint(particle);
    }
    /**
   * Maps particle properties to the point if the particle has a target.
   *
   * @param {Particle}
   */ onParticleUpdate(particle) {
        if (!particle.target) return;
        this.updateTarget(particle).mapParticleTargetPropsToPoint(particle);
    }
    /**
   * Resets and clears the particle target.
   *
   * @param {Particle}
   */ onParticleDead(particle) {
        if (!particle.target) return;
        particle.target.reset();
        this.mapParticleTargetPropsToPoint(particle);
        particle.target = null;
    }
    /**
   * Maps all mutable properties from the particle to the target.
   *
   * @param {Particle}
   * @return {GPURenderer}
   */ updateTarget(particle) {
        const { position: position, scale: scale, radius: radius, color: color, alpha: alpha, body: body, id: id } = particle;
        const { r: r, g: g, b: b } = color;
        particle.target.position.copy(position);
        particle.target.size = scale * radius;
        particle.target.color.setRGB(r, g, b);
        particle.target.alpha = alpha;
        particle.target.index = this.uniqueList.find(id);
        if (body && body instanceof $25223dfcb84f73e8$var$THREE.Sprite) {
            const { map: map } = body.material;
            particle.target.texture = map;
            particle.target.textureIndex = this.getTextureID(map, this.shouldDebugTextureAtlas);
        }
        return this;
    }
    /**
   * Entry point for mapping particle properties to buffer geometry points.
   *
   * @param {Particle} particle - The particle containing the properties to map
   * @return {GPURenderer}
   */ mapParticleTargetPropsToPoint(particle) {
        this.updatePointPosition(particle).updatePointSize(particle).updatePointColor(particle).updatePointAlpha(particle).updatePointTextureIndex(particle);
        return this;
    }
    /**
   * Updates the point's position according to the particle's target position.
   *
   * @param {Particle} particle - The particle containing the target position.
   * @return {GPURenderer}
   */ updatePointPosition(particle) {
        const attribute = "position";
        const { geometry: geometry, stride: stride, buffer: buffer } = this;
        const { target: target } = particle;
        const { offset: offset } = geometry.attributes[attribute];
        buffer.array[target.index * stride + offset + 0] = target.position.x;
        buffer.array[target.index * stride + offset + 1] = target.position.y;
        buffer.array[target.index * stride + offset + 2] = target.position.z;
        return this;
    }
    /**
   * Updates the point's size relative to the particle's target scale and radius.
   *
   * @param {Particle} particle - The particle containing the target scale.
   * @return {GPURenderer}
   */ updatePointSize(particle) {
        const attribute = "size";
        const { geometry: geometry, stride: stride, buffer: buffer } = this;
        const { target: target } = particle;
        const { offset: offset } = geometry.attributes[attribute];
        buffer.array[target.index * stride + offset + 0] = target.size;
        return this;
    }
    /**
   * Updates the point's color attribute according with the particle's target color.
   *
   * @param {Particle} particle - The particle containing the target color and alpha.
   * @return {GPURenderer}
   */ updatePointColor(particle) {
        const attribute = "color";
        const { geometry: geometry, stride: stride, buffer: buffer } = this;
        const { target: target } = particle;
        const { offset: offset } = geometry.attributes[attribute];
        buffer.array[target.index * stride + offset + 0] = target.color.r;
        buffer.array[target.index * stride + offset + 1] = target.color.g;
        buffer.array[target.index * stride + offset + 2] = target.color.b;
        return this;
    }
    /**
   * Updates the point alpha attribute with the particle's target alpha.
   *
   * @param {Particle} particle - The particle containing the target alpha.
   * @return {GPURenderer}
   */ updatePointAlpha(particle) {
        const attribute = "alpha";
        const { geometry: geometry, stride: stride, buffer: buffer } = this;
        const { target: target } = particle;
        const { offset: offset } = geometry.attributes[attribute];
        buffer.array[target.index * stride + offset + 0] = target.alpha;
        return this;
    }
    /**
   * Updates the point texture attribute with the particle's target texture.
   *
   * @param {Particle} particle - The particle containing the target texture.
   * @return {GPURenderer}
   */ updatePointTextureIndex(particle) {
        const attribute = "texID";
        const { geometry: geometry, stride: stride, buffer: buffer } = this;
        const { target: target } = particle;
        const { offset: offset } = geometry.attributes[attribute];
        const id = target.index * stride + offset + 0; // eslint-disable-next-line
        {
            let ti = target.textureIndex * 4;
            const ta = this.textureAtlas;
            const ida = ta.indexData;
            const nx = ida[ti++];
            const ny = ida[ti++];
            const px = ida[ti++];
            const py = ida[ti++];
            buffer.array[id] = (nx * ta.atlasTexture.image.width | 0) + px;
            buffer.array[id + 1] = (ny * ta.atlasTexture.image.height | 0) + py;
        }
        return this;
    }
    getTextureID(texture, debug) {
        if (texture.textureIndex === undefined) {
            if (!this.textureAtlas) this.textureAtlas = new (0, $8c8971f6d8d203a3$export$2e2bcd8739ae039)(this, debug);
            this.textureAtlas.addTexture(texture);
        }
        return texture.textureIndex;
    }
    destroy() {
        const { container: container, points: points, textureAtlas: textureAtlas, uniqueList: uniqueList } = this;
        container.remove(points);
        uniqueList.destroy();
        textureAtlas && textureAtlas.destroy();
    }
    constructor(container, three, options = (0, $c127bd8a77905224$export$4055fccee954182e)){
        super((0, $01c6d32cf1e9ec4f$export$e401f959685949e0));
        $25223dfcb84f73e8$var$THREE = this.three = three;
        const props = $25223dfcb84f73e8$var$_objectSpread($25223dfcb84f73e8$var$_objectSpread({}, (0, $c127bd8a77905224$export$4055fccee954182e)), options);
        const { camera: camera, maxParticles: maxParticles, baseColor: baseColor, blending: blending, depthTest: depthTest, depthWrite: depthWrite, transparent: transparent, shouldDebugTextureAtlas: shouldDebugTextureAtlas } = props;
        const particleBuffer = new (0, $34f4fea81d25f00f$export$2e2bcd8739ae039)(maxParticles, $25223dfcb84f73e8$var$THREE);
        const material = new $25223dfcb84f73e8$var$THREE.ShaderMaterial({
            uniforms: {
                baseColor: {
                    value: new $25223dfcb84f73e8$var$THREE.Color(baseColor)
                },
                uTexture: {
                    value: null
                },
                FFatlasIndex: {
                    value: null
                },
                atlasDim: {
                    value: new $25223dfcb84f73e8$var$THREE.Vector2()
                }
            },
            vertexShader: (0, $21b73c527cd5a536$export$84657c60382b0f83)(),
            fragmentShader: (0, $7ff216d1b58f30f3$export$4391ef72fa03c19)(),
            blending: $25223dfcb84f73e8$var$THREE[blending],
            depthTest: depthTest,
            depthWrite: depthWrite,
            transparent: transparent
        });
        this.camera = camera;
        this.targetPool = new (0, $84702be31d3f40ce$export$2e2bcd8739ae039)();
        this.uniqueList = new (0, $f555b0ae6871fc5a$export$34816f6634522548)(maxParticles);
        this.particleBuffer = particleBuffer;
        this.buffer = particleBuffer.buffer;
        this.stride = particleBuffer.stride;
        this.geometry = particleBuffer.geometry;
        this.material = material;
        this.points = new $25223dfcb84f73e8$var$THREE.Points(this.geometry, this.material);
        this.points.frustumCulled = false;
        this.shouldDebugTextureAtlas = shouldDebugTextureAtlas;
        container.add(this.points);
    }
}



class $1caed174da347b46$export$2e2bcd8739ae039 extends (0, $ba2b4a98b9634304$export$2e2bcd8739ae039) {
    isFloatingPointTextureSupported() {
        const canvas = document.createElement("canvas");
        if (window.WebGL2RenderingContext && canvas.getContext("webgl2")) // return false here to test the mobile renderer on desktop
        return true;
        const gl = canvas.getContext("webgl");
        const support = !!gl.getExtension("OES_texture_float");
        canvas.remove();
        return support;
    }
    constructor(container, THREE, options = (0, $c127bd8a77905224$export$4055fccee954182e)){
        super((0, $01c6d32cf1e9ec4f$export$f388914f73362c9a));
        const { shouldForceDesktopRenderer: shouldForceDesktopRenderer, shouldForceMobileRenderer: shouldForceMobileRenderer } = options;
        const args = [
            container,
            THREE,
            options
        ];
        if (shouldForceDesktopRenderer) return new (0, $a19199552a5cc988$export$2e2bcd8739ae039)(...args);
        if (shouldForceMobileRenderer) return new (0, $25223dfcb84f73e8$export$2e2bcd8739ae039)(...args);
        if (!this.isFloatingPointTextureSupported()) return new (0, $25223dfcb84f73e8$export$2e2bcd8739ae039)(...args);
        return new (0, $a19199552a5cc988$export$2e2bcd8739ae039)(...args);
    }
}






var $24a81f8e792b70c8$export$2e2bcd8739ae039 = (0, $0aef39101ae32969$export$2e2bcd8739ae039);




var $60d2b0e7b97425c1$export$72fb2d77891daaa5;
(function(ParticleEffects) {
    ParticleEffects[ParticleEffects[// Player Trails
    "None"] = -1] = "None";
    ParticleEffects[ParticleEffects["Broccolis"] = 0] = "Broccolis";
    ParticleEffects[ParticleEffects["Circles"] = 1] = "Circles";
    ParticleEffects[ParticleEffects["Flies"] = 2] = "Flies";
    ParticleEffects[ParticleEffects["GoldenFlies"] = 3] = "GoldenFlies";
    ParticleEffects[ParticleEffects["Hearts"] = 4] = "Hearts";
    ParticleEffects[ParticleEffects["Smoke"] = 5] = "Smoke";
    ParticleEffects[ParticleEffects["Stars"] = 6] = "Stars";
    ParticleEffects[ParticleEffects["SquareStars"] = 7] = "SquareStars";
    ParticleEffects[ParticleEffects["Snow"] = 8] = "Snow";
    ParticleEffects[ParticleEffects["GingerbreadMan"] = 9] = "GingerbreadMan";
})($60d2b0e7b97425c1$export$72fb2d77891daaa5 || ($60d2b0e7b97425c1$export$72fb2d77891daaa5 = {}));
const $60d2b0e7b97425c1$export$89a022980ff17124 = new Map();
$60d2b0e7b97425c1$export$89a022980ff17124.set($60d2b0e7b97425c1$export$72fb2d77891daaa5.Stars, new (0, $c15ff10b1716ebd7$export$2e2bcd8739ae039)(new (0, $ef3653f168d58d59$export$2e2bcd8739ae039)(1, 2), new (0, $ef3653f168d58d59$export$2e2bcd8739ae039)(0.01)));
$60d2b0e7b97425c1$export$89a022980ff17124.set($60d2b0e7b97425c1$export$72fb2d77891daaa5.Hearts, new (0, $c15ff10b1716ebd7$export$2e2bcd8739ae039)(new (0, $ef3653f168d58d59$export$2e2bcd8739ae039)(1, 2), new (0, $ef3653f168d58d59$export$2e2bcd8739ae039)(0.02)));
$60d2b0e7b97425c1$export$89a022980ff17124.set($60d2b0e7b97425c1$export$72fb2d77891daaa5.Circles, new (0, $c15ff10b1716ebd7$export$2e2bcd8739ae039)(new (0, $ef3653f168d58d59$export$2e2bcd8739ae039)(1, 2), new (0, $ef3653f168d58d59$export$2e2bcd8739ae039)(0.02)));
$60d2b0e7b97425c1$export$89a022980ff17124.set($60d2b0e7b97425c1$export$72fb2d77891daaa5.SquareStars, new (0, $c15ff10b1716ebd7$export$2e2bcd8739ae039)(new (0, $ef3653f168d58d59$export$2e2bcd8739ae039)(1, 2), new (0, $ef3653f168d58d59$export$2e2bcd8739ae039)(0.02)));
$60d2b0e7b97425c1$export$89a022980ff17124.set($60d2b0e7b97425c1$export$72fb2d77891daaa5.Broccolis, new (0, $c15ff10b1716ebd7$export$2e2bcd8739ae039)(new (0, $ef3653f168d58d59$export$2e2bcd8739ae039)(1, 2), new (0, $ef3653f168d58d59$export$2e2bcd8739ae039)(0.02)));
$60d2b0e7b97425c1$export$89a022980ff17124.set($60d2b0e7b97425c1$export$72fb2d77891daaa5.Flies, new (0, $c15ff10b1716ebd7$export$2e2bcd8739ae039)(new (0, $ef3653f168d58d59$export$2e2bcd8739ae039)(1, 2), new (0, $ef3653f168d58d59$export$2e2bcd8739ae039)(0.1)));
$60d2b0e7b97425c1$export$89a022980ff17124.set($60d2b0e7b97425c1$export$72fb2d77891daaa5.GoldenFlies, new (0, $c15ff10b1716ebd7$export$2e2bcd8739ae039)(new (0, $ef3653f168d58d59$export$2e2bcd8739ae039)(1, 2), new (0, $ef3653f168d58d59$export$2e2bcd8739ae039)(0.1)));
$60d2b0e7b97425c1$export$89a022980ff17124.set($60d2b0e7b97425c1$export$72fb2d77891daaa5.Smoke, new (0, $c15ff10b1716ebd7$export$2e2bcd8739ae039)(new (0, $ef3653f168d58d59$export$2e2bcd8739ae039)(2, 2.5), new (0, $ef3653f168d58d59$export$2e2bcd8739ae039)(0.02)));
$60d2b0e7b97425c1$export$89a022980ff17124.set($60d2b0e7b97425c1$export$72fb2d77891daaa5.Snow, new (0, $c15ff10b1716ebd7$export$2e2bcd8739ae039)(new (0, $ef3653f168d58d59$export$2e2bcd8739ae039)(1, 2), new (0, $ef3653f168d58d59$export$2e2bcd8739ae039)(0.02)));
$60d2b0e7b97425c1$export$89a022980ff17124.set($60d2b0e7b97425c1$export$72fb2d77891daaa5.GingerbreadMan, new (0, $c15ff10b1716ebd7$export$2e2bcd8739ae039)(new (0, $ef3653f168d58d59$export$2e2bcd8739ae039)(1, 2), new (0, $ef3653f168d58d59$export$2e2bcd8739ae039)(0.08)));
const $60d2b0e7b97425c1$export$1df7a7638615f95b = new Map();
$60d2b0e7b97425c1$export$1df7a7638615f95b.set($60d2b0e7b97425c1$export$72fb2d77891daaa5.Stars, [
    new (0, $1051606c509839db$export$2e2bcd8739ae039)(new (0, $73ccb74a1dc3c249$export$2e2bcd8739ae039)(0, 0.1, 0, 1, 0.2, 1)),
    new (0, $07c2166c937b061c$export$2e2bcd8739ae039)(5),
    new (0, $6053068a9f2caa98$export$2e2bcd8739ae039)(2, 3),
    new (0, $ad9f4cb3c3090f54$export$2e2bcd8739ae039)(0.35),
    new (0, $815217306acadcd1$export$2e2bcd8739ae039)(2, new (0, $4ecaf53387bdecca$export$2e2bcd8739ae039)(10, 2, 3), 180),
    new (0, $d09bd892a6fc02a0$export$2e2bcd8739ae039)($9014d97cd777be10$exports, "particles/star.png", {
        blending: $9014d97cd777be10$exports.NormalBlending
    })
]);
$60d2b0e7b97425c1$export$1df7a7638615f95b.set($60d2b0e7b97425c1$export$72fb2d77891daaa5.Hearts, [
    new (0, $1051606c509839db$export$2e2bcd8739ae039)(new (0, $73ccb74a1dc3c249$export$2e2bcd8739ae039)(0, 0.1, 0, 1, 0.2, 1)),
    new (0, $07c2166c937b061c$export$2e2bcd8739ae039)(2),
    new (0, $6053068a9f2caa98$export$2e2bcd8739ae039)(2, 4),
    new (0, $ad9f4cb3c3090f54$export$2e2bcd8739ae039)(3),
    new (0, $815217306acadcd1$export$2e2bcd8739ae039)(1, new (0, $4ecaf53387bdecca$export$2e2bcd8739ae039)(0, 1, 0), 180),
    new (0, $d09bd892a6fc02a0$export$2e2bcd8739ae039)($9014d97cd777be10$exports, "particles/heart.png", {
        blending: $9014d97cd777be10$exports.NormalBlending
    })
]);
$60d2b0e7b97425c1$export$1df7a7638615f95b.set($60d2b0e7b97425c1$export$72fb2d77891daaa5.Circles, [
    new (0, $1051606c509839db$export$2e2bcd8739ae039)(new (0, $73ccb74a1dc3c249$export$2e2bcd8739ae039)(0, 0.1, 0, 1, 0.2, 1)),
    new (0, $07c2166c937b061c$export$2e2bcd8739ae039)(2),
    new (0, $6053068a9f2caa98$export$2e2bcd8739ae039)(3, 4),
    new (0, $ad9f4cb3c3090f54$export$2e2bcd8739ae039)(0.5),
    new (0, $815217306acadcd1$export$2e2bcd8739ae039)(1, new (0, $4ecaf53387bdecca$export$2e2bcd8739ae039)(0, 1, 0), 180),
    new (0, $d09bd892a6fc02a0$export$2e2bcd8739ae039)($9014d97cd777be10$exports, "particles/circle.png", {
        blending: $9014d97cd777be10$exports.NormalBlending
    })
]);
$60d2b0e7b97425c1$export$1df7a7638615f95b.set($60d2b0e7b97425c1$export$72fb2d77891daaa5.SquareStars, [
    new (0, $1051606c509839db$export$2e2bcd8739ae039)(new (0, $73ccb74a1dc3c249$export$2e2bcd8739ae039)(0, 0.1, 0, 1, 0.2, 1)),
    new (0, $07c2166c937b061c$export$2e2bcd8739ae039)(1),
    new (0, $6053068a9f2caa98$export$2e2bcd8739ae039)(1, 4),
    new (0, $ad9f4cb3c3090f54$export$2e2bcd8739ae039)(3),
    new (0, $815217306acadcd1$export$2e2bcd8739ae039)(0.25, new (0, $4ecaf53387bdecca$export$2e2bcd8739ae039)(0, 0.25, 0), 180),
    new (0, $d09bd892a6fc02a0$export$2e2bcd8739ae039)($9014d97cd777be10$exports, "particles/square_star_001.png", {
        blending: $9014d97cd777be10$exports.NormalBlending
    })
]);
$60d2b0e7b97425c1$export$1df7a7638615f95b.set($60d2b0e7b97425c1$export$72fb2d77891daaa5.Broccolis, [
    new (0, $1051606c509839db$export$2e2bcd8739ae039)(new (0, $73ccb74a1dc3c249$export$2e2bcd8739ae039)(0, 0.3, 0, 1, 0.2, 1)),
    new (0, $07c2166c937b061c$export$2e2bcd8739ae039)(2),
    new (0, $6053068a9f2caa98$export$2e2bcd8739ae039)(2, 4),
    new (0, $ad9f4cb3c3090f54$export$2e2bcd8739ae039)(2.5),
    new (0, $815217306acadcd1$export$2e2bcd8739ae039)(0.7, new (0, $4ecaf53387bdecca$export$2e2bcd8739ae039)(0, 1, 0), 180),
    new (0, $d09bd892a6fc02a0$export$2e2bcd8739ae039)($9014d97cd777be10$exports, "particles/broccoli.png", {
        blending: $9014d97cd777be10$exports.NormalBlending
    })
]);
$60d2b0e7b97425c1$export$1df7a7638615f95b.set($60d2b0e7b97425c1$export$72fb2d77891daaa5.Flies, [
    new (0, $1051606c509839db$export$2e2bcd8739ae039)(new (0, $73ccb74a1dc3c249$export$2e2bcd8739ae039)(0, 0.4, 0, 1, 0.2, 1)),
    new (0, $07c2166c937b061c$export$2e2bcd8739ae039)(2),
    new (0, $6053068a9f2caa98$export$2e2bcd8739ae039)(2, 4),
    new (0, $ad9f4cb3c3090f54$export$2e2bcd8739ae039)(3),
    new (0, $815217306acadcd1$export$2e2bcd8739ae039)(3, new (0, $4ecaf53387bdecca$export$2e2bcd8739ae039)(3, 5, 3), 180),
    new (0, $d09bd892a6fc02a0$export$2e2bcd8739ae039)($9014d97cd777be10$exports, "particles/fly.png", {
        blending: $9014d97cd777be10$exports.NormalBlending
    })
]);
$60d2b0e7b97425c1$export$1df7a7638615f95b.set($60d2b0e7b97425c1$export$72fb2d77891daaa5.GoldenFlies, [
    new (0, $1051606c509839db$export$2e2bcd8739ae039)(new (0, $73ccb74a1dc3c249$export$2e2bcd8739ae039)(0, 0.4, 0, 1, 0.2, 1)),
    new (0, $07c2166c937b061c$export$2e2bcd8739ae039)(2),
    new (0, $6053068a9f2caa98$export$2e2bcd8739ae039)(2, 4),
    new (0, $ad9f4cb3c3090f54$export$2e2bcd8739ae039)(3),
    new (0, $815217306acadcd1$export$2e2bcd8739ae039)(3, new (0, $4ecaf53387bdecca$export$2e2bcd8739ae039)(3, 5, 3), 180),
    new (0, $d09bd892a6fc02a0$export$2e2bcd8739ae039)($9014d97cd777be10$exports, "particles/fly_gold.png", {
        blending: $9014d97cd777be10$exports.NormalBlending
    })
]);
$60d2b0e7b97425c1$export$1df7a7638615f95b.set($60d2b0e7b97425c1$export$72fb2d77891daaa5.Smoke, [
    new (0, $1051606c509839db$export$2e2bcd8739ae039)(new (0, $73ccb74a1dc3c249$export$2e2bcd8739ae039)(0, 0.1, 0, 0.5, 0.1, 0.5)),
    new (0, $07c2166c937b061c$export$2e2bcd8739ae039)(2),
    new (0, $6053068a9f2caa98$export$2e2bcd8739ae039)(1.15, 2.4),
    new (0, $ad9f4cb3c3090f54$export$2e2bcd8739ae039)(1.1),
    new (0, $815217306acadcd1$export$2e2bcd8739ae039)(0.5, new (0, $4ecaf53387bdecca$export$2e2bcd8739ae039)(0, 0.5, 0), 180),
    new (0, $d09bd892a6fc02a0$export$2e2bcd8739ae039)($9014d97cd777be10$exports, "particles/smoke.png", {
        blending: $9014d97cd777be10$exports.NormalBlending
    })
]);
$60d2b0e7b97425c1$export$1df7a7638615f95b.set($60d2b0e7b97425c1$export$72fb2d77891daaa5.Snow, [
    new (0, $1051606c509839db$export$2e2bcd8739ae039)(new (0, $73ccb74a1dc3c249$export$2e2bcd8739ae039)(0, 1, 0, 1, 0.2, 1)),
    new (0, $07c2166c937b061c$export$2e2bcd8739ae039)(1),
    new (0, $6053068a9f2caa98$export$2e2bcd8739ae039)(1, 4),
    new (0, $ad9f4cb3c3090f54$export$2e2bcd8739ae039)(1.8),
    new (0, $815217306acadcd1$export$2e2bcd8739ae039)(0.25, new (0, $4ecaf53387bdecca$export$2e2bcd8739ae039)(0, 0.25, 0), 180),
    new (0, $d09bd892a6fc02a0$export$2e2bcd8739ae039)($9014d97cd777be10$exports, "particles/snowflake.png", {
        blending: $9014d97cd777be10$exports.NormalBlending
    })
]);
$60d2b0e7b97425c1$export$1df7a7638615f95b.set($60d2b0e7b97425c1$export$72fb2d77891daaa5.GingerbreadMan, [
    new (0, $1051606c509839db$export$2e2bcd8739ae039)(new (0, $73ccb74a1dc3c249$export$2e2bcd8739ae039)(0, 1, 0, 1, 0.2, 1)),
    new (0, $07c2166c937b061c$export$2e2bcd8739ae039)(1),
    new (0, $6053068a9f2caa98$export$2e2bcd8739ae039)(1, 4),
    new (0, $ad9f4cb3c3090f54$export$2e2bcd8739ae039)(1.8),
    new (0, $815217306acadcd1$export$2e2bcd8739ae039)(0.25, new (0, $4ecaf53387bdecca$export$2e2bcd8739ae039)(0, 0.25, 0), 180),
    new (0, $d09bd892a6fc02a0$export$2e2bcd8739ae039)($9014d97cd777be10$exports, "particles/gingerbreadman.png", {
        blending: $9014d97cd777be10$exports.NormalBlending
    })
]);
const $60d2b0e7b97425c1$export$f161ac8cd64e61d = new Map();
$60d2b0e7b97425c1$export$f161ac8cd64e61d.set($60d2b0e7b97425c1$export$72fb2d77891daaa5.Stars, [
    new (0, $9a23004203249681$export$2e2bcd8739ae039)(1, 0),
    new (0, $731b44e61c44f44f$export$2e2bcd8739ae039)(0.3, 0.5),
    new (0, $f505290032053e83$export$2e2bcd8739ae039)(new $9014d97cd777be10$exports.Color(0xffffff), new $9014d97cd777be10$exports.Color(0xffff00))
]);
$60d2b0e7b97425c1$export$f161ac8cd64e61d.set($60d2b0e7b97425c1$export$72fb2d77891daaa5.Hearts, [
    new (0, $9a23004203249681$export$2e2bcd8739ae039)(1, 0),
    new (0, $731b44e61c44f44f$export$2e2bcd8739ae039)(0.25, 0.55),
    new (0, $f505290032053e83$export$2e2bcd8739ae039)(new $9014d97cd777be10$exports.Color(0xfc46aa), new $9014d97cd777be10$exports.Color(0xffc0cb))
]);
$60d2b0e7b97425c1$export$f161ac8cd64e61d.set($60d2b0e7b97425c1$export$72fb2d77891daaa5.Circles, [
    new (0, $9a23004203249681$export$2e2bcd8739ae039)(1, 1),
    new (0, $731b44e61c44f44f$export$2e2bcd8739ae039)(0.25, 0.5),
    new (0, $f505290032053e83$export$2e2bcd8739ae039)(new $9014d97cd777be10$exports.Color(0x0000ff), new $9014d97cd777be10$exports.Color(0xffffff))
]);
$60d2b0e7b97425c1$export$f161ac8cd64e61d.set($60d2b0e7b97425c1$export$72fb2d77891daaa5.Broccolis, [
    new (0, $9a23004203249681$export$2e2bcd8739ae039)(1, 0),
    new (0, $731b44e61c44f44f$export$2e2bcd8739ae039)(0.3, 0.5),
    new (0, $f505290032053e83$export$2e2bcd8739ae039)(new $9014d97cd777be10$exports.Color(0xffffff), new $9014d97cd777be10$exports.Color(0xffffff))
]);
$60d2b0e7b97425c1$export$f161ac8cd64e61d.set($60d2b0e7b97425c1$export$72fb2d77891daaa5.Flies, [
    new (0, $9a23004203249681$export$2e2bcd8739ae039)(1, 0),
    new (0, $731b44e61c44f44f$export$2e2bcd8739ae039)(0.3, 0.5),
    new (0, $f505290032053e83$export$2e2bcd8739ae039)(new $9014d97cd777be10$exports.Color(0xffffff), new $9014d97cd777be10$exports.Color(0xffffff))
]);
$60d2b0e7b97425c1$export$f161ac8cd64e61d.set($60d2b0e7b97425c1$export$72fb2d77891daaa5.GoldenFlies, [
    new (0, $9a23004203249681$export$2e2bcd8739ae039)(1, 0),
    new (0, $731b44e61c44f44f$export$2e2bcd8739ae039)(0.3, 0.5),
    new (0, $f505290032053e83$export$2e2bcd8739ae039)(new $9014d97cd777be10$exports.Color(0xffffff), new $9014d97cd777be10$exports.Color(0xffffff))
]);
$60d2b0e7b97425c1$export$f161ac8cd64e61d.set($60d2b0e7b97425c1$export$72fb2d77891daaa5.Smoke, [
    new (0, $9a23004203249681$export$2e2bcd8739ae039)(1, 0),
    new (0, $731b44e61c44f44f$export$2e2bcd8739ae039)(0.3, 1.25),
    new (0, $f505290032053e83$export$2e2bcd8739ae039)(new $9014d97cd777be10$exports.Color(0xffffff), new $9014d97cd777be10$exports.Color(0x000000))
]);
$60d2b0e7b97425c1$export$f161ac8cd64e61d.set($60d2b0e7b97425c1$export$72fb2d77891daaa5.Snow, [
    new (0, $9a23004203249681$export$2e2bcd8739ae039)(1, 0),
    new (0, $731b44e61c44f44f$export$2e2bcd8739ae039)(0.35, 0.2),
    new (0, $f505290032053e83$export$2e2bcd8739ae039)(new $9014d97cd777be10$exports.Color(0xffffff), new $9014d97cd777be10$exports.Color(0xffd700))
]);
$60d2b0e7b97425c1$export$f161ac8cd64e61d.set($60d2b0e7b97425c1$export$72fb2d77891daaa5.GingerbreadMan, [
    new (0, $9a23004203249681$export$2e2bcd8739ae039)(1, 1),
    new (0, $731b44e61c44f44f$export$2e2bcd8739ae039)(0.45, 0.3),
    new (0, $f505290032053e83$export$2e2bcd8739ae039)(new $9014d97cd777be10$exports.Color(0xb96b2b), new $9014d97cd777be10$exports.Color(0xd17a32))
]);
$60d2b0e7b97425c1$export$f161ac8cd64e61d.set($60d2b0e7b97425c1$export$72fb2d77891daaa5.SquareStars, [
    new (0, $9a23004203249681$export$2e2bcd8739ae039)(1, 0),
    new (0, $731b44e61c44f44f$export$2e2bcd8739ae039)(0.25, 0.4),
    new (0, $f505290032053e83$export$2e2bcd8739ae039)(new $9014d97cd777be10$exports.Color(0xffffff), new $9014d97cd777be10$exports.Color(0xffd700))
]);
const $60d2b0e7b97425c1$export$2cc1c9a48be553af = new Map(); // ParticleBurstCounts.set(ParticleEffects.Confetti, 100);


class $13f545b0b773e041$export$75d5526a7020db extends (0, $8665ec0109254415$export$ca71fcae86980bb) {
    RotateByMouseMovement(movementX, __movementY) {
        this.rotY -= movementX * (0, $b80b6e4c153785d9$export$29cd7b75162a9425).Camera.MOUSE_SENSITIVITY;
    // this.rotX -= movementY * Config.Camera.MOUSE_SENSITIVITY;
    }
    UpdateCharacterSkin(newSkin) {
        // console.log("server told us to update our character skin to...", newSkin);
        this.characterSkin = newSkin;
        this._tearDownVisuals();
        this._setupVisuals().then(()=>{
            this._setupEmotes();
        });
    }
    GetModel() {
        return this.threeModel;
    }
    IdentifyAsMyPlayer() {
        this.isMyEntity = true;
    }
    set visualModelRotation(newRotation) {
        // console.log("local setter of visualModelRotation", newRotation);
        this.rotY = newRotation;
    }
    async _setupDebugVisuals() {
        // console.log("Debug visuals are being set up for player...");
        if ((0, $b80b6e4c153785d9$export$29cd7b75162a9425).Player.DRAW_COLLIDER) {
            const geometry = new (0, $9014d97cd777be10$export$33e43285f7406bd5)(this.Collider.Width, this.Collider.Height, this.Collider.Depth);
            const material = new (0, $9014d97cd777be10$export$f2980790215acccd)({
                color: 0xff00ff,
                wireframe: true
            });
            this.colliderVisual = new (0, $9014d97cd777be10$export$e176487c05830cc5)(geometry, material);
            this.colliderVisual.position.set(this.x, this.y, this.z);
            Game.Renderer.AddModelToScene(this.colliderVisual);
        }
    }
    _tearDownVisuals() {
        try {
            // console.log("Tearing down visuals");
            Game.Renderer.RemoveModelFromScene(this.threeModel);
            // this.threeModel.traverse((node) => {
            //     // @ts-ignore
            //     if (node.isMesh) {
            //         if ()
            //         // @ts-ignore
            //         node.material.dispose();
            //         // @ts-ignore
            //         node.geometry.dispose();
            //     }
            // });
            // @ts-ignore
            this.threeModel = null;
            // @ts-ignore
            this.animationController = null;
            // @ts-ignore
            this.animationClips = null;
            this.playerVisualsAreSetUp = false;
        } catch (e) {
            console.error("Tried to call _tearDownVisuals but hit the catch clause!");
            console.error(e);
        }
    }
    setCountry(country) {
        this.country = country;
        if (this.nameLabel !== undefined) this.nameLabel.SetFlag(country);
    }
    setName(name) {
        this.name = name;
        if (this.nameLabel !== undefined) this.nameLabel.SetText(this.name);
    }
    getName() {
        return this.name;
    }
    _setupNameLabel() {
        // console.log(this.country);
        this.nameLabel = new (0, $88639450953f4f02$export$3a6dd21ac7d6d023)(`${this.name}`, this.country);
        if (this.nameLabel !== undefined) {
            this.threeModel.add(this.nameLabel.threeText);
            if (this.nameLabel.threeText !== undefined) this.nameLabel.threeText.position.set(0, $13f545b0b773e041$var$getHeightOfModel(this.threeModel) + this.labelOffsetY, 0);
        }
    }
    getSpeedBlockFactor() {
        return this.speedBlockFactor;
    }
    _tryUpdateMobileMovementSideEffect() {
        if (!IsMobile) return;
        if (!Game.Input.MobilePlayerIsMoving) return;
        const cameraAngles = Game.Renderer.GetCameraAngle();
        this.rotY = Game.Input.GetMobileRotationAngle() - cameraAngles.lateral;
    }
    async _setupVisuals() {
        // console.log("Player visuals are being set up...");
        const sprite = (0, $018036e722cee03d$export$8e561b4222bacdfd).get(this.characterSkin).assetPath;
        this.threeGLTF = await Game.Loader.LoadModel(sprite);
        this.threeModel = this.threeGLTF.scene;
        this.threeModel.name = "Player";
        this.threeModel.traverse((node)=>{
            // @ts-ignore
            if (node.isMesh) {
                const newMaterial = new (0, $9014d97cd777be10$export$55cbcc9b622fe1f5)({
                    color: 0xffffff,
                    wireframe: this.isMyEntity ? true : false
                });
                // @ts-ignore
                // If the original material uses textures, transfer them to the new material
                if (node.material.map) {
                    // @ts-ignore
                    newMaterial.map = node.material.map;
                    // @ts-ignore
                    newMaterial.transparent = node.material.transparent;
                    // @ts-ignore
                    newMaterial.alphaTest = node.material.alphaTest;
                }
                // Apply the new material
                // @ts-ignore
                node.material = newMaterial;
            }
        });
        this.threeModel.position.set(this.x, this.y + this.modelOffsetY, this.z);
        this.threeModel.scale.set(1, 1, 1);
        this.threeModel.rotation.set(0, 136.5, 0);
        this.animationController = new (0, $9014d97cd777be10$export$fbd77e5aefaa0102)(this.threeModel);
        this.animationClips = this.threeGLTF.animations;
        this._setupNameLabel();
        Game.Renderer.AddModelToScene(this.threeModel);
        this.playerVisualsAreSetUp = true;
    }
    _setupEmotes() {
        const emoteLocation = "ui/emotes/";
        this.emoteMaterials = new Map();
        (0, $365485fe02257f54$export$65f3c33713eab7d7).forEach((filename, emote)=>{
            const emoteTexture = Game.Loader.TextureLoader.load(emoteLocation + filename);
            emoteTexture.colorSpace = (0, $9014d97cd777be10$export$561f394b24edfcaa);
            const emoteMaterial = $13f545b0b773e041$var$createBillboardEmoteMaterial(new (0, $9014d97cd777be10$export$55cbcc9b622fe1f5)({
                map: emoteTexture,
                transparent: true,
                alphaTest: 0.5,
                side: (0, $9014d97cd777be10$export$2ede184fc2998901)
            }));
            this.emoteMaterials.set(emote, emoteMaterial);
        });
        const emoteGeometry = new (0, $9014d97cd777be10$export$967d831af31f69ce)(2, 2);
        this.emoteMesh = new (0, $9014d97cd777be10$export$e176487c05830cc5)(emoteGeometry);
        this.emoteMesh.material = this.emoteMaterials.get((0, $365485fe02257f54$export$a0592272c669d6d8).Apple);
        this.threeModel.add(this.emoteMesh);
        this.emoteMesh.position.set(0, $13f545b0b773e041$var$getHeightOfModel(this.threeModel) + this.emoteOffsetY, 0);
        this.emoteMesh.visible = false;
    }
    _setupParticles() {
        if (!this.isMyEntity) {
            if (this.particleTrailEmitter) this.particleTrailEmitter.reset();
            else {
                this.particleTrailEmitter = new (0, $975f8eaf1ecebbca$export$2e2bcd8739ae039)();
                Game.Renderer.AddParticleEmitter(this.particleTrailEmitter);
                this.particleZeroRate = new (0, $c15ff10b1716ebd7$export$2e2bcd8739ae039)(0, 0);
            }
            if (this.particleBurstEmitter) this.particleBurstEmitter.reset();
            else {
                this.particleBurstEmitter = new (0, $975f8eaf1ecebbca$export$2e2bcd8739ae039)();
                Game.Renderer.AddParticleEmitter(this.particleBurstEmitter);
            }
            this.particleTrailEmitter.setRate(this.particleZeroRate).setPosition(this.threeModel.position).emit();
            this.particleBurstEmitter.setRate(this.particleZeroRate).setPosition(this.threeModel.position);
            // console.log("@@@", this.characterTrail);
            if (this.characterTrail !== -1) this.SetParticleTrailEffect(this.characterTrail);
        }
    }
    Destroy() {
        this._tearDownVisuals();
    }
    SetParticleTrailEffect(effect) {
        if (this.currentParticleTrailEffect === effect) return;
        if (this.particleTrailEmitter === undefined) return;
        this.currentParticleTrailEffect = effect;
        if (effect !== (0, $60d2b0e7b97425c1$export$72fb2d77891daaa5).None) {
            if ((0, $60d2b0e7b97425c1$export$89a022980ff17124).has(effect)) this.particleTrailRate = (0, $60d2b0e7b97425c1$export$89a022980ff17124).get(effect);
            if ((0, $60d2b0e7b97425c1$export$1df7a7638615f95b).has(effect)) this.particleTrailEmitter.setInitializers((0, $60d2b0e7b97425c1$export$1df7a7638615f95b).get(effect));
            if ((0, $60d2b0e7b97425c1$export$f161ac8cd64e61d).has(effect)) this.particleTrailEmitter.setBehaviours((0, $60d2b0e7b97425c1$export$f161ac8cd64e61d).get(effect));
        }
    }
    // TODO: Not yet fully working
    BurstParticleEffect(effect) {
        if (effect !== (0, $60d2b0e7b97425c1$export$72fb2d77891daaa5).None) {
            if (this.particleBurstEmitter) {
                const parent = this.particleBurstEmitter.parent;
                this.particleBurstEmitter.reset();
                this.particleBurstEmitter.parent = parent;
            }
            if ((0, $60d2b0e7b97425c1$export$89a022980ff17124).has(effect)) this.particleBurstEmitter.setRate((0, $60d2b0e7b97425c1$export$89a022980ff17124).get(effect));
            if ((0, $60d2b0e7b97425c1$export$1df7a7638615f95b).has(effect)) this.particleBurstEmitter.setInitializers((0, $60d2b0e7b97425c1$export$1df7a7638615f95b).get(effect));
            if ((0, $60d2b0e7b97425c1$export$f161ac8cd64e61d).has(effect)) this.particleBurstEmitter.setBehaviours((0, $60d2b0e7b97425c1$export$f161ac8cd64e61d).get(effect));
            if ((0, $60d2b0e7b97425c1$export$2cc1c9a48be553af).has(effect)) this.particleBurstEmitter.emit((0, $60d2b0e7b97425c1$export$2cc1c9a48be553af).get(effect), 0.1);
            else this.particleBurstEmitter.emit(50, 0.1);
        }
    }
    _updateVisuals(deltaTimeS, __deltaTimeMS, __currentTimeInMilliseconds) {
        if (this.localModelHidden === false && this.isMyEntity === true && (0, $b80b6e4c153785d9$export$29cd7b75162a9425).Player.DRAW_SERVERSIDE_SELF_DURING_PREDICTION === false) {
            this.threeModel.visible = false;
            this.localModelHidden = true;
        }
        if (this.localModelHidden === true) return;
        const prevPosition = this.threeModel.position.clone();
        this.animationController.update(deltaTimeS);
        this.threeModel.position.set(this.x, this.y + this.modelOffsetY, this.z);
        this.threeModel.rotation.set(this.rotX, this.rotY, this.rotZ);
        if (this.nameLabel !== undefined) {
            this.nameLabel.visible = this._isLabelVisible();
            this.nameLabel.Update(deltaTimeS);
        }
        this.currentEmoteTimer -= deltaTimeS;
        if (this.currentEmoteTimer > 0) {
            let fadeFactor = 1;
            if (this.currentEmoteTimer > this.emoteDuration - this.emoteFadeDuration) fadeFactor = 1 - (this.currentEmoteTimer - (this.emoteDuration - this.emoteFadeDuration)) / this.emoteFadeDuration;
            else if (this.currentEmoteTimer < this.emoteFadeDuration) fadeFactor = this.currentEmoteTimer / this.emoteFadeDuration;
            let scale = 1;
            if (this.currentEmoteAnimation === (0, $365485fe02257f54$export$30b7b71cb0ee3dbd).Wiggle) scale = 0.95 + Math.sin(this.currentEmoteTimer * 10) * 0.05;
            this.emoteMesh.scale.set((0.5 + 0.5 * fadeFactor) * scale, (0.5 + 0.5 * fadeFactor) * scale, (0.5 + 0.5 * fadeFactor) * scale);
            const emoteMaterial = this.emoteMesh.material;
            emoteMaterial.opacity = fadeFactor;
            if (this.currentEmoteAnimation === (0, $365485fe02257f54$export$30b7b71cb0ee3dbd).Shake) {
                emoteMaterial.uniforms.u_positionOffsetX.value = Math.sin(this.currentEmoteTimer * 15) * 0.1;
                emoteMaterial.uniforms.u_positionOffsetY.value = 0;
            } else if (this.currentEmoteAnimation === (0, $365485fe02257f54$export$30b7b71cb0ee3dbd).Bounce) {
                emoteMaterial.uniforms.u_positionOffsetX.value = 0;
                emoteMaterial.uniforms.u_positionOffsetY.value = Math.abs(Math.sin(this.currentEmoteTimer * 5)) * 0.2;
            } else {
                emoteMaterial.uniforms.u_positionOffsetX.value = 0;
                emoteMaterial.uniforms.u_positionOffsetY.value = 0;
            }
        } else {
            this.currentEmoteTimer = 0;
            this.emoteMesh.visible = false;
        }
        const prevParticleTrailActive = this.particleTrailActive;
        if (this.threeModel.position.distanceToSquared(prevPosition) < 0.001 || this.currentParticleTrailEffect === (0, $60d2b0e7b97425c1$export$72fb2d77891daaa5).None) this.particleTrailActive = false;
        else {
            this.particleTrailActive = true;
            this.particleTrailEmitter?.setPosition(this.threeModel.position);
        }
        if (this.particleTrailActive !== prevParticleTrailActive) {
            if (this.particleTrailActive) this.particleTrailEmitter?.setRate(this.particleTrailRate);
            else this.particleTrailEmitter?.setRate(this.particleZeroRate);
        }
        this.particleBurstEmitter?.setPosition(this.threeModel.position);
    }
    _isLabelVisible() {
        if (Game.Predictor.PredictionReady === false) return false;
        if (Game.Predictor.GetPredictedEntity() === undefined) return false;
        if (Game.Predictor.GetPredictedEntity().threeModel === undefined || Game.Predictor.GetPredictedEntity().threeModel === null) return false;
        const distanceFromCamera = this.threeModel.position.distanceTo(Game.Predictor.GetPredictedEntity().threeModel.position);
        if (distanceFromCamera > 20) return false;
        return true;
    }
    _updateDebugVisuals(__deltaTimeS, __deltaTimeMS, __currentTimeInMilliseconds) {
        if ((0, $b80b6e4c153785d9$export$29cd7b75162a9425).Player.DRAW_COLLIDER) this.colliderVisual.position.set(this.x, this.y, this.z);
    }
    UpdateAnimationTimeScale(timeScale) {
        if (this.animationController === undefined || this.animationController === null) return;
        this.animationController.timeScale = timeScale;
    }
    _updatePlayerAnimations() {
        this.toAction = this.animationController.clipAction(this.getAnimationClipByName(this.currentState));
        this.fromAction = this.animationController.clipAction(this.getAnimationClipByName(this.previousState));
        if (this.currentState !== this.previousState) {
            //We were not in a previous state - Catches initializing edge case
            if (this.previousState === "none") return;
            this.toAction.enabled = true;
            this.toAction.time = 0.0;
            this.toAction.setEffectiveTimeScale(Math.max(1, this.animationSpeedMultiplier * 2));
            this.toAction.setEffectiveWeight(1);
            this.toAction.crossFadeFrom(this.fromAction, 0.1, true);
            if (this.toAction.getClip().name === "walking") {
                this.toAction.crossFadeFrom(this.fromAction, 0.08, false);
                this.toAction.startAt(0.3);
                this.toAction.timeScale = Math.max(1, this.animationSpeedMultiplier * 2);
            } else if (this.toAction.getClip().name === "jumping") {
                this.toAction.crossFadeFrom(this.fromAction, 0.15, true);
                this.toAction.startAt(0.0);
                this.toAction.timeScale = this.defaultAnimationSpeedMultiplier;
            }
            this.toAction.play();
            this.previousState = this.currentState;
        } else {
            if (this.toAction.getClip().name === "walking") this.toAction.timeScale = Math.max(1, this.animationSpeedMultiplier * 2);
            this.toAction.play();
        }
    }
    Update(deltaTimeS, deltaTimeMS, currentTimeInMilliseconds) {
        // console.log(this.Position);
        if (this.playerVisualsAreSetUp) {
            this._updateVisuals(deltaTimeS, deltaTimeMS, currentTimeInMilliseconds);
            this._updateDebugVisuals(deltaTimeS, deltaTimeMS, currentTimeInMilliseconds);
            this._updatePlayerAnimations();
            if (this.Velocity.y < this.fallSoundResetVelocity) // @ts-ignore
            this.canPlayJumpSound = true;
            if (this.currentState === "idle") this.idleTimer += deltaTimeMS;
        }
    }
    get getAnimationClips() {
        return this.animationClips;
    }
    PopEmote(emote, animation) {
        if (this.currentEmoteTimer > 0) return;
        if (this.emoteMaterials === undefined) return;
        if (this.emoteMaterials.get(emote) === undefined) return;
        if (this.emoteMesh === undefined) return;
        this.emoteMesh.material = this.emoteMaterials.get(emote);
        this.emoteMesh.visible = true;
        this.emoteMesh.scale.set(0.5, 0.5, 0.5);
        this.emoteMesh.material.opacity = 0;
        this.currentEmoteTimer = this.emoteDuration;
        this.currentEmoteAnimation = animation;
    }
    //Handles edge case of us wanting specific animations for certain states when the animation name does not match the state name
    //TODO: When/If animation names are changed, this can probably be re-worked
    getAnimationClipByName(nameOfClip) {
        //Defaulting this to Idle
        let desiredClip = (0, $9014d97cd777be10$export$d942c706bf23829c).findByName(this.animationClips, "idle");
        if (nameOfClip === "falling") desiredClip = (0, $9014d97cd777be10$export$d942c706bf23829c).findByName(this.animationClips, "jumping");
        else desiredClip = (0, $9014d97cd777be10$export$d942c706bf23829c).findByName(this.animationClips, nameOfClip);
        return desiredClip;
    }
    get getAnimationMixer() {
        return this.animationController;
    }
    constructor(createPlayerPayload){
        super(Game.Collision, createPlayerPayload.x, createPlayerPayload.y, createPlayerPayload.z, createPlayerPayload.runInProgress, createPlayerPayload.runDurationAcc);
        this.isMyEntity = false;
        this.playerVisualsAreSetUp = false;
        this.modelOffsetY = -1;
        this.localModelHidden = false;
        this.fallSoundResetVelocity = -0.2;
        this.labelOffsetY = 0.5;
        this.currentParticleTrailEffect = (0, $60d2b0e7b97425c1$export$72fb2d77891daaa5).None;
        this.particleTrailActive = false;
        this.emoteOffsetY = this.labelOffsetY + 0.2;
        this.emoteDuration = 2.5;
        this.emoteFadeDuration = 0.3;
        this.currentEmoteTimer = 0;
        this.originalCreationPayload = createPlayerPayload;
        // console.log("\n\n Creating new local player entity...");
        // console.log("Original creation payload on client:", this.originalCreationPayload);
        this.characterSkin = createPlayerPayload.characterSkin;
        this.characterTrail = createPlayerPayload.characterTrail;
        const { nid: nid } = createPlayerPayload;
        this.name = createPlayerPayload.username;
        //@ts-ignore
        this.country = createPlayerPayload.country;
        this.nid = nid;
        this._setupDebugVisuals();
        //FiniteStateMachine initalizes in below function
        //TODO: Potentially initialize FSM after _setupVisuals has been run
        this._setupVisuals().then(()=>{
            this._setupEmotes();
            this._setupParticles();
        });
    }
}
function $13f545b0b773e041$var$createBillboardEmoteMaterial(baseMaterial, opts = {}) {
    return (0, $34196ca962faf131$export$9251ec91c7de57b5)(baseMaterial, {
        uniforms: {
            u_positionOffsetX: {
                value: 0.0
            },
            u_positionOffsetY: {
                value: 0.0
            }
        },
        vertexDefs: `
            uniform float u_positionOffsetX;
            uniform float u_positionOffsetY;
        `,
        vertexMainOutro: `
            vec4 mvPosition = modelViewMatrix * vec4(0.0, 0.0, 0.0, 1.0);
            vec3 scale = vec3(
                length(modelViewMatrix[0].xyz),
                length(modelViewMatrix[1].xyz),
                length(modelViewMatrix[2].xyz)
            );
            mvPosition.xyz += position * scale;

            mvPosition.x += u_positionOffsetX;
            mvPosition.y += u_positionOffsetY;
            
            gl_Position = projectionMatrix * mvPosition;
        `,
        ...opts
    });
}
function $13f545b0b773e041$var$getHeightOfModel(object) {
    let maxY = -Infinity;
    let minY = Infinity;
    object.traverse((child)=>{
        // @ts-ignore
        if (child.isMesh) {
            // @ts-ignore
            const geometry = child.geometry;
            geometry.computeBoundingBox();
            const boundingBox = geometry.boundingBox;
            if (boundingBox) {
                maxY = Math.max(maxY, boundingBox.max.y);
                minY = Math.min(minY, boundingBox.min.y);
            }
        }
    });
    const height = maxY - minY;
    return height;
}







var $bdc7294f86aa2fdf$exports = {};
// stats.js - http://github.com/mrdoob/stats.js
(function(f, e) {
    $bdc7294f86aa2fdf$exports = e();
})($bdc7294f86aa2fdf$exports, function() {
    var f = function() {
        function e(a) {
            c.appendChild(a.dom);
            return a;
        }
        function u(a) {
            for(var d = 0; d < c.children.length; d++)c.children[d].style.display = d === a ? "block" : "none";
            l = a;
        }
        var l = 0, c = document.createElement("div");
        c.style.cssText = "position:fixed;top:0;left:0;cursor:pointer;opacity:0.9;z-index:10000";
        c.addEventListener("click", function(a) {
            a.preventDefault();
            u(++l % c.children.length);
        }, !1);
        var k = (performance || Date).now(), g = k, a = 0, r = e(new f.Panel("FPS", "#0ff", "#002")), h = e(new f.Panel("MS", "#0f0", "#020"));
        if (self.performance && self.performance.memory) var t = e(new f.Panel("MB", "#f08", "#201"));
        u(0);
        return {
            REVISION: 16,
            dom: c,
            addPanel: e,
            showPanel: u,
            begin: function() {
                k = (performance || Date).now();
            },
            end: function() {
                a++;
                var c = (performance || Date).now();
                h.update(c - k, 200);
                if (c > g + 1E3 && (r.update(1E3 * a / (c - g), 100), g = c, a = 0, t)) {
                    var d = performance.memory;
                    t.update(d.usedJSHeapSize / 1048576, d.jsHeapSizeLimit / 1048576);
                }
                return c;
            },
            update: function() {
                k = this.end();
            },
            domElement: c,
            setMode: u
        };
    };
    f.Panel = function(e, f, l) {
        var c = Infinity, k = 0, g = Math.round, a = g(window.devicePixelRatio || 1), r = 80 * a, h = 48 * a, t = 3 * a, v = 2 * a, d = 3 * a, m = 15 * a, n = 74 * a, p = 30 * a, q = document.createElement("canvas");
        q.width = r;
        q.height = h;
        q.style.cssText = "width:80px;height:48px";
        var b = q.getContext("2d");
        b.font = "bold " + 9 * a + "px Helvetica,Arial,sans-serif";
        b.textBaseline = "top";
        b.fillStyle = l;
        b.fillRect(0, 0, r, h);
        b.fillStyle = f;
        b.fillText(e, t, v);
        b.fillRect(d, m, n, p);
        b.fillStyle = l;
        b.globalAlpha = .9;
        b.fillRect(d, m, n, p);
        return {
            dom: q,
            update: function(h, w) {
                c = Math.min(c, h);
                k = Math.max(k, h);
                b.fillStyle = l;
                b.globalAlpha = 1;
                b.fillRect(0, 0, r, m);
                b.fillStyle = f;
                b.fillText(g(h) + " " + e + " (" + g(c) + "-" + g(k) + ")", t, v);
                b.drawImage(q, d + a, m, n - a, p, d, m, n - a, p);
                b.fillRect(d + n - a, m, a, p);
                b.fillStyle = l;
                b.globalAlpha = .9;
                b.fillRect(d + n - a, m, a, g((1 - h / w) * p));
            }
        };
    };
    return f;
});




var $5LCsG = parcelRequire("5LCsG");
var $dba298545a323f15$exports = {};
$dba298545a323f15$exports = JSON.parse('{"HeightMarkers":[{"isNumber":true,"pos":{"x":-78.97999572753906,"y":1400.1800537109375,"z":373.28997802734375},"rotationAsMultOfPi":1,"stringIfNAN":""},{"isNumber":true,"pos":{"x":-453.469970703125,"y":1104.7484130859375,"z":182.42999267578125},"rotationAsMultOfPi":0,"stringIfNAN":""},{"isNumber":true,"pos":{"x":-98.70899200439453,"y":505.0799865722656,"z":98.46998596191406},"rotationAsMultOfPi":1.5,"stringIfNAN":""},{"isNumber":true,"pos":{"x":-295.1300048828125,"y":615.3300170898438,"z":-9.322011947631836},"rotationAsMultOfPi":0,"stringIfNAN":""},{"isNumber":false,"pos":{"x":-407.719970703125,"y":718.6400146484375,"z":45.36998748779297},"rotationAsMultOfPi":0.8500000238418579,"stringIfNAN":"heightmarker__change_character"},{"isNumber":false,"pos":{"x":-38.329994201660156,"y":21.510000228881836,"z":137.2799835205078},"rotationAsMultOfPi":1,"stringIfNAN":"heightmarker__tutorial_bouncy"},{"isNumber":true,"pos":{"x":199.35800170898438,"y":222.28599548339844,"z":120.65398406982422},"rotationAsMultOfPi":0,"stringIfNAN":""},{"isNumber":false,"pos":{"x":-68.83999633789062,"y":1409.27001953125,"z":401.1199951171875},"rotationAsMultOfPi":1,"stringIfNAN":"heightmarker__change_character"},{"isNumber":false,"pos":{"x":55.07300567626953,"y":275.6499938964844,"z":42.45998764038086},"rotationAsMultOfPi":1.5,"stringIfNAN":"heightmarker__inspiration_come_far"},{"isNumber":false,"pos":{"x":15.640005111694336,"y":-11.520000457763672,"z":2.539987802505493},"rotationAsMultOfPi":0,"stringIfNAN":"heightmarker__secret_gorillas"},{"isNumber":false,"pos":{"x":-91.87999725341797,"y":492.760009765625,"z":84.74998474121094},"rotationAsMultOfPi":1.7000000476837158,"stringIfNAN":"heightmarker__change_trail"},{"isNumber":true,"pos":{"x":-17.829994201660156,"y":442.8900146484375,"z":46.614986419677734},"rotationAsMultOfPi":0,"stringIfNAN":""},{"isNumber":true,"pos":{"x":-437.6199951171875,"y":1042.1199951171875,"z":228.89999389648438},"rotationAsMultOfPi":0,"stringIfNAN":""},{"isNumber":false,"pos":{"x":100.37100219726562,"y":68.55999755859375,"z":116.61998748779297},"rotationAsMultOfPi":0.5,"stringIfNAN":"heightmarker__tutorial_climb"},{"isNumber":false,"pos":{"x":11.980005264282227,"y":5.050000190734863,"z":9.309988021850586},"rotationAsMultOfPi":0.824999988079071,"stringIfNAN":"heightmarker__change_trail"},{"isNumber":false,"pos":{"x":-69.34999084472656,"y":1404.93994140625,"z":385.67999267578125},"rotationAsMultOfPi":2.700000047683716,"stringIfNAN":"heightmarker__change_trail"},{"isNumber":false,"pos":{"x":-97.10999298095703,"y":495.69000244140625,"z":108.87998962402344},"rotationAsMultOfPi":1.149999976158142,"stringIfNAN":"heightmarker__change_character"},{"isNumber":true,"pos":{"x":-412.8900146484375,"y":724.989990234375,"z":22.3663330078125},"rotationAsMultOfPi":1,"stringIfNAN":""},{"isNumber":false,"pos":{"x":-418.8599853515625,"y":1118.1300048828125,"z":56.589988708496094},"rotationAsMultOfPi":0.800000011920929,"stringIfNAN":"heightmarker__change_trail"},{"isNumber":false,"pos":{"x":-14.239994049072266,"y":1205.8172607421875,"z":27.309988021850586},"rotationAsMultOfPi":0.5,"stringIfNAN":"heightmarker__inspiration_up_up"},{"isNumber":false,"pos":{"x":-417.45001220703125,"y":715.27001953125,"z":45.36998748779297},"rotationAsMultOfPi":1,"stringIfNAN":"heightmarker__change_trail"},{"isNumber":false,"pos":{"x":34.712005615234375,"y":66.75,"z":112.5099868774414},"rotationAsMultOfPi":0.5,"stringIfNAN":"heightmarker__tutorial_speed"},{"isNumber":false,"pos":{"x":-117.05999755859375,"y":24.232999801635742,"z":-28.250011444091797},"rotationAsMultOfPi":1.5,"stringIfNAN":"heightmarker__global_leaderboard"},{"isNumber":false,"pos":{"x":100.37100219726562,"y":81.70999908447266,"z":116.61998748779297},"rotationAsMultOfPi":0.5,"stringIfNAN":"heightmarker__tutorial_climb"},{"isNumber":false,"pos":{"x":4.200005531311035,"y":5.050000190734863,"z":-22.990013122558594},"rotationAsMultOfPi":0.824999988079071,"stringIfNAN":"heightmarker__change_name"},{"isNumber":false,"pos":{"x":0.8600054979324341,"y":5.630000114440918,"z":57.80998611450195},"rotationAsMultOfPi":1,"stringIfNAN":"heightmarker__tutorial_climb"},{"isNumber":false,"pos":{"x":-87.40999603271484,"y":24.232999801635742,"z":-52.34001159667969},"rotationAsMultOfPi":0,"stringIfNAN":"heightmarker__your_stats"},{"isNumber":true,"pos":{"x":-46.00999450683594,"y":310.5299987792969,"z":143.9399871826172},"rotationAsMultOfPi":1.5,"stringIfNAN":""},{"isNumber":false,"pos":{"x":-93.2699966430664,"y":24.232999801635742,"z":1.1699877977371216},"rotationAsMultOfPi":1,"stringIfNAN":"heightmarker__game_stats"},{"isNumber":false,"pos":{"x":213.52000427246094,"y":261.2699890136719,"z":109.21998596191406},"rotationAsMultOfPi":1.149999976158142,"stringIfNAN":"heightmarker__change_character"},{"isNumber":false,"pos":{"x":100.37100219726562,"y":80.44999694824219,"z":116.39998626708984},"rotationAsMultOfPi":0.5,"stringIfNAN":"heightmarker__tutorial_the_wall"},{"isNumber":false,"pos":{"x":-416.760009765625,"y":1122.550048828125,"z":54.03998947143555},"rotationAsMultOfPi":0.800000011920929,"stringIfNAN":"heightmarker__change_character"},{"isNumber":false,"pos":{"x":-11.249994277954102,"y":7.550000190734863,"z":-27.190011978149414},"rotationAsMultOfPi":1.149999976158142,"stringIfNAN":"heightmarker__change_character"},{"isNumber":false,"pos":{"x":-422.15997314453125,"y":723.1599731445312,"z":105.47998809814453},"rotationAsMultOfPi":0,"stringIfNAN":""},{"isNumber":true,"pos":{"x":99.98960876464844,"y":182.67355346679688,"z":116.29998779296875},"rotationAsMultOfPi":0.5,"stringIfNAN":""},{"isNumber":true,"pos":{"x":196.510009765625,"y":263.3599853515625,"z":72.18998718261719},"rotationAsMultOfPi":0,"stringIfNAN":""},{"isNumber":true,"pos":{"x":-44.33224868774414,"y":1279.0799560546875,"z":20.469987869262695},"rotationAsMultOfPi":0.5,"stringIfNAN":""},{"isNumber":false,"pos":{"x":0.12000548839569092,"y":3.630000114440918,"z":57.80998611450195},"rotationAsMultOfPi":1,"stringIfNAN":"heightmarker__tutorial_the_wall"},{"isNumber":true,"pos":{"x":-104.45999145507812,"y":399.79998779296875,"z":-25.08001136779785},"rotationAsMultOfPi":1,"stringIfNAN":""},{"isNumber":true,"pos":{"x":17.462005615234375,"y":62.540000915527344,"z":121.8399887084961},"rotationAsMultOfPi":0.5,"stringIfNAN":""},{"isNumber":false,"pos":{"x":220.95001220703125,"y":257.7099914550781,"z":113.01998901367188},"rotationAsMultOfPi":1.149999976158142,"stringIfNAN":"heightmarker__change_trail"},{"isNumber":false,"pos":{"x":-89.67999267578125,"y":1405.260009765625,"z":385.1999816894531},"rotationAsMultOfPi":1.2000000476837158,"stringIfNAN":"heightmarker__to_bottom"},{"isNumber":false,"pos":{"x":100.37100219726562,"y":67.19999694824219,"z":116.39998626708984},"rotationAsMultOfPi":0.5,"stringIfNAN":"heightmarker__tutorial_the_wall"},{"isNumber":false,"pos":{"x":-400.9061279296875,"y":756.22998046875,"z":103.59098815917969},"rotationAsMultOfPi":0,"stringIfNAN":"heightmarker__inspiration_keep_going"},{"isNumber":false,"pos":{"x":34.712005615234375,"y":65.44000244140625,"z":112.6399917602539},"rotationAsMultOfPi":0.5,"stringIfNAN":"heightmarker_tutorial_boost"}]}');


const $19fa45bc88c77393$var$_lut = [
    "00",
    "01",
    "02",
    "03",
    "04",
    "05",
    "06",
    "07",
    "08",
    "09",
    "0a",
    "0b",
    "0c",
    "0d",
    "0e",
    "0f",
    "10",
    "11",
    "12",
    "13",
    "14",
    "15",
    "16",
    "17",
    "18",
    "19",
    "1a",
    "1b",
    "1c",
    "1d",
    "1e",
    "1f",
    "20",
    "21",
    "22",
    "23",
    "24",
    "25",
    "26",
    "27",
    "28",
    "29",
    "2a",
    "2b",
    "2c",
    "2d",
    "2e",
    "2f",
    "30",
    "31",
    "32",
    "33",
    "34",
    "35",
    "36",
    "37",
    "38",
    "39",
    "3a",
    "3b",
    "3c",
    "3d",
    "3e",
    "3f",
    "40",
    "41",
    "42",
    "43",
    "44",
    "45",
    "46",
    "47",
    "48",
    "49",
    "4a",
    "4b",
    "4c",
    "4d",
    "4e",
    "4f",
    "50",
    "51",
    "52",
    "53",
    "54",
    "55",
    "56",
    "57",
    "58",
    "59",
    "5a",
    "5b",
    "5c",
    "5d",
    "5e",
    "5f",
    "60",
    "61",
    "62",
    "63",
    "64",
    "65",
    "66",
    "67",
    "68",
    "69",
    "6a",
    "6b",
    "6c",
    "6d",
    "6e",
    "6f",
    "70",
    "71",
    "72",
    "73",
    "74",
    "75",
    "76",
    "77",
    "78",
    "79",
    "7a",
    "7b",
    "7c",
    "7d",
    "7e",
    "7f",
    "80",
    "81",
    "82",
    "83",
    "84",
    "85",
    "86",
    "87",
    "88",
    "89",
    "8a",
    "8b",
    "8c",
    "8d",
    "8e",
    "8f",
    "90",
    "91",
    "92",
    "93",
    "94",
    "95",
    "96",
    "97",
    "98",
    "99",
    "9a",
    "9b",
    "9c",
    "9d",
    "9e",
    "9f",
    "a0",
    "a1",
    "a2",
    "a3",
    "a4",
    "a5",
    "a6",
    "a7",
    "a8",
    "a9",
    "aa",
    "ab",
    "ac",
    "ad",
    "ae",
    "af",
    "b0",
    "b1",
    "b2",
    "b3",
    "b4",
    "b5",
    "b6",
    "b7",
    "b8",
    "b9",
    "ba",
    "bb",
    "bc",
    "bd",
    "be",
    "bf",
    "c0",
    "c1",
    "c2",
    "c3",
    "c4",
    "c5",
    "c6",
    "c7",
    "c8",
    "c9",
    "ca",
    "cb",
    "cc",
    "cd",
    "ce",
    "cf",
    "d0",
    "d1",
    "d2",
    "d3",
    "d4",
    "d5",
    "d6",
    "d7",
    "d8",
    "d9",
    "da",
    "db",
    "dc",
    "dd",
    "de",
    "df",
    "e0",
    "e1",
    "e2",
    "e3",
    "e4",
    "e5",
    "e6",
    "e7",
    "e8",
    "e9",
    "ea",
    "eb",
    "ec",
    "ed",
    "ee",
    "ef",
    "f0",
    "f1",
    "f2",
    "f3",
    "f4",
    "f5",
    "f6",
    "f7",
    "f8",
    "f9",
    "fa",
    "fb",
    "fc",
    "fd",
    "fe",
    "ff"
];
let $19fa45bc88c77393$var$_seed = 1234567;
const $19fa45bc88c77393$export$460c4029b1a54a2e = Math.PI / 180;
const $19fa45bc88c77393$export$914076c8150813e5 = 180 / Math.PI;
// http://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid-in-javascript/21963136#21963136
function $19fa45bc88c77393$export$e73c8bd0f20705a() {
    const d0 = Math.random() * 0xffffffff | 0;
    const d1 = Math.random() * 0xffffffff | 0;
    const d2 = Math.random() * 0xffffffff | 0;
    const d3 = Math.random() * 0xffffffff | 0;
    const uuid = $19fa45bc88c77393$var$_lut[d0 & 0xff] + $19fa45bc88c77393$var$_lut[d0 >> 8 & 0xff] + $19fa45bc88c77393$var$_lut[d0 >> 16 & 0xff] + $19fa45bc88c77393$var$_lut[d0 >> 24 & 0xff] + "-" + $19fa45bc88c77393$var$_lut[d1 & 0xff] + $19fa45bc88c77393$var$_lut[d1 >> 8 & 0xff] + "-" + $19fa45bc88c77393$var$_lut[d1 >> 16 & 0x0f | 0x40] + $19fa45bc88c77393$var$_lut[d1 >> 24 & 0xff] + "-" + $19fa45bc88c77393$var$_lut[d2 & 0x3f | 0x80] + $19fa45bc88c77393$var$_lut[d2 >> 8 & 0xff] + "-" + $19fa45bc88c77393$var$_lut[d2 >> 16 & 0xff] + $19fa45bc88c77393$var$_lut[d2 >> 24 & 0xff] + $19fa45bc88c77393$var$_lut[d3 & 0xff] + $19fa45bc88c77393$var$_lut[d3 >> 8 & 0xff] + $19fa45bc88c77393$var$_lut[d3 >> 16 & 0xff] + $19fa45bc88c77393$var$_lut[d3 >> 24 & 0xff];
    // .toLowerCase() here flattens concatenated strings to save heap memory space.
    return uuid.toLowerCase();
}
function $19fa45bc88c77393$export$7d15b64cf5a3a4c4(value, min, max) {
    return Math.max(min, Math.min(max, value));
}
// compute euclidean modulo of m % n
// https://en.wikipedia.org/wiki/Modulo_operation
function $19fa45bc88c77393$export$3c11354a743b7f4e(n, m) {
    return (n % m + m) % m;
}
// Linear mapping from range <a1, a2> to range <b1, b2>
function $19fa45bc88c77393$export$61343b3c0ad0a00a(x, a1, a2, b1, b2) {
    return b1 + (x - a1) * (b2 - b1) / (a2 - a1);
}
// https://www.gamedev.net/tutorials/programming/general-and-gameplay-programming/inverse-lerp-a-super-useful-yet-often-overlooked-function-r5230/
function $19fa45bc88c77393$export$c45b79d581bbb999(x, y, value) {
    if (x !== y) return (value - x) / (y - x);
    else return 0;
}
// https://en.wikipedia.org/wiki/Linear_interpolation
function $19fa45bc88c77393$export$3a89f8d6f6bf6c9f(x, y, t) {
    return (1 - t) * x + t * y;
}
// http://www.rorydriscoll.com/2016/03/07/frame-rate-independent-damping-using-lerp/
function $19fa45bc88c77393$export$f81c1cb84e35b185(x, y, lambda, dt) {
    return $19fa45bc88c77393$export$3a89f8d6f6bf6c9f(x, y, 1 - Math.exp(-lambda * dt));
}
// https://www.desmos.com/calculator/vcsjnyz7x4
function $19fa45bc88c77393$export$1d919ae830ac5239(x, length = 1) {
    return length - Math.abs($19fa45bc88c77393$export$3c11354a743b7f4e(x, length * 2) - length);
}
// http://en.wikipedia.org/wiki/Smoothstep
function $19fa45bc88c77393$export$4053e36566dd3d9a(x, min, max) {
    if (x <= min) return 0;
    if (x >= max) return 1;
    x = (x - min) / (max - min);
    return x * x * (3 - 2 * x);
}
function $19fa45bc88c77393$export$7509a5c452b9dce8(x, min, max) {
    if (x <= min) return 0;
    if (x >= max) return 1;
    x = (x - min) / (max - min);
    return x * x * x * (x * (x * 6 - 15) + 10);
}
// Random integer from <low, high> interval
function $19fa45bc88c77393$export$a85cdcada2f6e6d0(low, high) {
    return low + Math.floor(Math.random() * (high - low + 1));
}
// Random float from <low, high> interval
function $19fa45bc88c77393$export$8dceb61b660164cc(low, high) {
    return low + Math.random() * (high - low);
}
// Random float from <-range/2, range/2> interval
function $19fa45bc88c77393$export$f093f4e85c7dea5a(range) {
    return range * (0.5 - Math.random());
}
// Deterministic pseudo-random float in the interval [ 0, 1 ]
function $19fa45bc88c77393$export$d3abb7a3a61fb0cb(s) {
    if (s !== undefined) $19fa45bc88c77393$var$_seed = s;
    // Mulberry32 generator
    let t = $19fa45bc88c77393$var$_seed += 0x6D2B79F5;
    t = Math.imul(t ^ t >>> 15, t | 1);
    t ^= t + Math.imul(t ^ t >>> 7, t | 61);
    return ((t ^ t >>> 14) >>> 0) / 4294967296;
}
function $19fa45bc88c77393$export$e6bfdeff8bfc94f9(degrees) {
    return degrees * $19fa45bc88c77393$export$460c4029b1a54a2e;
}
function $19fa45bc88c77393$export$54390e3b44c4a9cb(radians) {
    return radians * $19fa45bc88c77393$export$914076c8150813e5;
}
function $19fa45bc88c77393$export$b9e43d1765415474(value) {
    return (value & value - 1) === 0 && value !== 0;
}
function $19fa45bc88c77393$export$150eaaaf1e7bb6f7(value) {
    return Math.pow(2, Math.ceil(Math.log(value) / Math.LN2));
}
function $19fa45bc88c77393$export$b500f0356efda8ea(value) {
    return Math.pow(2, Math.floor(Math.log(value) / Math.LN2));
}
function $19fa45bc88c77393$export$ef2201424fe649f7(q, a, b, c, order) {
    // Intrinsic Proper Euler Angles - see https://en.wikipedia.org/wiki/Euler_angles
    // rotations are applied to the axes in the order specified by 'order'
    // rotation by angle 'a' is applied first, then by angle 'b', then by angle 'c'
    // angles are in radians
    const cos = Math.cos;
    const sin = Math.sin;
    const c2 = cos(b / 2);
    const s2 = sin(b / 2);
    const c13 = cos((a + c) / 2);
    const s13 = sin((a + c) / 2);
    const c1_3 = cos((a - c) / 2);
    const s1_3 = sin((a - c) / 2);
    const c3_1 = cos((c - a) / 2);
    const s3_1 = sin((c - a) / 2);
    switch(order){
        case "XYX":
            q.set(c2 * s13, s2 * c1_3, s2 * s1_3, c2 * c13);
            break;
        case "YZY":
            q.set(s2 * s1_3, c2 * s13, s2 * c1_3, c2 * c13);
            break;
        case "ZXZ":
            q.set(s2 * c1_3, s2 * s1_3, c2 * s13, c2 * c13);
            break;
        case "XZX":
            q.set(c2 * s13, s2 * s3_1, s2 * c3_1, c2 * c13);
            break;
        case "YXY":
            q.set(s2 * c3_1, c2 * s13, s2 * s3_1, c2 * c13);
            break;
        case "ZYZ":
            q.set(s2 * s3_1, s2 * c3_1, c2 * s13, c2 * c13);
            break;
        default:
            console.warn("THREE.MathUtils: .setQuaternionFromProperEuler() encountered an unknown order: " + order);
    }
}
function $19fa45bc88c77393$export$be8b9fcbce8e8f70(value, array) {
    switch(array.constructor){
        case Float32Array:
            return value;
        case Uint32Array:
            return value / 4294967295.0;
        case Uint16Array:
            return value / 65535.0;
        case Uint8Array:
            return value / 255.0;
        case Int32Array:
            return Math.max(value / 2147483647.0, -1);
        case Int16Array:
            return Math.max(value / 32767.0, -1);
        case Int8Array:
            return Math.max(value / 127.0, -1);
        default:
            throw new Error("Invalid component type.");
    }
}
function $19fa45bc88c77393$export$a3295358bff77e(value, array) {
    switch(array.constructor){
        case Float32Array:
            return value;
        case Uint32Array:
            return Math.round(value * 4294967295.0);
        case Uint16Array:
            return Math.round(value * 65535.0);
        case Uint8Array:
            return Math.round(value * 255.0);
        case Int32Array:
            return Math.round(value * 2147483647.0);
        case Int16Array:
            return Math.round(value * 32767.0);
        case Int8Array:
            return Math.round(value * 127.0);
        default:
            throw new Error("Invalid component type.");
    }
}
const $19fa45bc88c77393$export$6a7ef315a0d1ef07 = {
    DEG2RAD: $19fa45bc88c77393$export$460c4029b1a54a2e,
    RAD2DEG: $19fa45bc88c77393$export$914076c8150813e5,
    generateUUID: $19fa45bc88c77393$export$e73c8bd0f20705a,
    clamp: $19fa45bc88c77393$export$7d15b64cf5a3a4c4,
    euclideanModulo: $19fa45bc88c77393$export$3c11354a743b7f4e,
    mapLinear: $19fa45bc88c77393$export$61343b3c0ad0a00a,
    inverseLerp: $19fa45bc88c77393$export$c45b79d581bbb999,
    lerp: $19fa45bc88c77393$export$3a89f8d6f6bf6c9f,
    damp: $19fa45bc88c77393$export$f81c1cb84e35b185,
    pingpong: $19fa45bc88c77393$export$1d919ae830ac5239,
    smoothstep: $19fa45bc88c77393$export$4053e36566dd3d9a,
    smootherstep: $19fa45bc88c77393$export$7509a5c452b9dce8,
    randInt: $19fa45bc88c77393$export$a85cdcada2f6e6d0,
    randFloat: $19fa45bc88c77393$export$8dceb61b660164cc,
    randFloatSpread: $19fa45bc88c77393$export$f093f4e85c7dea5a,
    seededRandom: $19fa45bc88c77393$export$d3abb7a3a61fb0cb,
    degToRad: $19fa45bc88c77393$export$e6bfdeff8bfc94f9,
    radToDeg: $19fa45bc88c77393$export$54390e3b44c4a9cb,
    isPowerOfTwo: $19fa45bc88c77393$export$b9e43d1765415474,
    ceilPowerOfTwo: $19fa45bc88c77393$export$150eaaaf1e7bb6f7,
    floorPowerOfTwo: $19fa45bc88c77393$export$b500f0356efda8ea,
    setQuaternionFromProperEuler: $19fa45bc88c77393$export$ef2201424fe649f7,
    normalize: $19fa45bc88c77393$export$a3295358bff77e,
    denormalize: $19fa45bc88c77393$export$be8b9fcbce8e8f70
};





var $1eadb401cb193ffc$exports = {};
$1eadb401cb193ffc$exports = JSON.parse('{"error_screen__renderer_failed":"Your graphics card may not support UpTogether! Please try on again on a WebGL2 enabled browser & device.","error_screen__server_maybe_full":"Error connecting to server: servers may be full right now, try again in a few minutes!","error_screen__maintenance_mode":"UpTogether.io is being updated! Come back in a few minutes to try the new stuff \uD83C\uDF89","error_screen__client_out_of_date":"Your game client is out of date! Please update your game client to the latest version and try again.","error_screen__invalid_connection":"The server rejected your user! Please try again.","error_screen__already_logged_in":"You\'re already logged in!","error_screen__unknown_reason":"Unknown connection error :(","error_screen__disconnected_from_server":"Disconnected from server! The servers may be going down for an update. Try again in a few minutes.","heightmarker__to_bottom":"Back to Bottom!","heightmarker__inspiration_come_far":"Look how far you\'ve come!","heightmarker__inspiration_keep_going":"Keep going!","heightmarker__inspiration_up_up":"Up! up! up!","in_game__secret_edward":"Hi Edward!!","heightmarker__secret_gorillas":"How many gorillas can u find??","heightmarker__change_character":"Change Character","heightmarker__change_name":"Change Name","heightmarker__change_trail":"Get a trail!","heightmarker__global_leaderboard":"Global Leaderboard","heightmarker__your_stats":"YOUR STATS","heightmarker__game_stats":"GAME STATS","heightmarker__tutorial_speed":"Speed","heightmarker_tutorial_boost":"Boost!","heightmarker__tutorial_climb":"CLIMB","heightmarker__tutorial_the_wall":"THE WALL","heightmarker__tutorial_bouncy":"Bouncy!","in_game__secret_invis_maze":"Next to the maze door, on the left...","in_game__secret_upside_down_plate":"Jump forward from the\\n     upside-down plate!","in_game__tutorial_start_timer":"Pass the starting line to start your timer","in_game__tutorial_invis_platforms":"There are invisible platforms!","in_game__how_fast_top":"How fast can you get to the top?","in_game__no_touchy":"DO NOT TOUCH!","in_game__tutorial_running":"Use left stick to run","in_game__tutorial_tap":"Tap","in_game__tutorial_press":"Press","in_game__tutorial_or":"or","in_game__tutorial__to_jump":"To Jump","in_game__tutorial__hold":"Hold","in_game__tutorial__jump_repeatedly":"To jump repeatedly","in_game__tutorial_wall_climb":"To climb walls","in_game__tutorial_while_running":"While Running","in_game__tutorial_drag_move_camera":"Drag screen to \\n move camera","in_game__checkpoint":"Checkpoint!","loading_text__connecting":"Connecting to server...","loading_text__splines":"Reticulating splines","loading_text__tofu":"Marinating the tofu","loading_text__corn":"Shucking the corn","loading_text__broccoli":"Confirming that broccoli is little trees","loading_text__brussel_sprouts":"Convincing players that brussel sprouts are delicious","loading_text__secret_sauce":"Adding the secret sauce","loading_text__digesting":"Digesting","loading_text__stirring":"Stirring constantly","loading_text__fixing_ice_cream":"Fixing the ice cream machine at McDonalds","loading_text__chopping_broccoli":"Chopping the broccoli","loading_text__carmelize_apples":"Carmelizing the apples","loading_text__water_boil":"Watching the water boil","loading_text__filleting_fish":"Filleting the fish","loading_text__plating":"Plating","loading_text__garnishing":"Garnishing","loading_text__moldy_bits":"Cutting off the moldy bits","death_block__almost":"Almost!","death_block__close_one":"Close One!","death_block__try_again":"Try Again!","death_block__roasted":"Roasted!","death_block__burnt":"Burnt!","death_block__oh_no":"Oh No!","death_block__grilled":"Grilled!","death_block__blanched":"Blanched!","death_block__crisp":"Crisp!","death_block__flameed":"Flamb\xe9ed!","death_block__order_up":"Order Up!","death_block__ouch":"Ouch!","death_block__good_try":"Good Try!","death_block__baked":"Baked!","death_block__crusty":"Crusty!","death_block__next_time":"Next Time!","death_block__toast":"Toasty!","death_block__no_chef":"No Chef!","death_block__singe_left":"Just a singe to the left!","death_block__oof":"Oof!","death_block__fried":"Fried!","death_block__recipe_ruined":"Recipe Ruined","death_block__sizzling_stop":"A Sizzling Stop!","death_block__defeated":"Chef Defeated!","death_block__burnt_out":"Burnt Out?","death_block__meltdown":"Having a Meltdown?","falling_death__slippery":"Slippery!","falling_death__gg":"GG","falling_death__you_died":"You Died","falling_death__f":"F","falling_death__floor_food":"Floor food!","falling_death__three_second":"Three Second Rule!","falling_death__floor_seasoning":"Mmm! Floor Seasoning!","falling_death__just_missed":"Just Missed!","falling_death__rip":"RIP","falling_death__floor_vs_flavor":"Floor: 1","falling_death__floor_fall":"Floor Fall!","falling_death__saucy_slip":"Saucy Slip!","falling_death__fried_fell":"Fried and Fell!","falling_death__dive":"Tasteless Dive!","falling_death__floor_finish":"Floor Finish!","falling_death__dinner_dive":"Dinner Dive!","falling_death__splat":"SPLAT!","falling_death__oops":"Oops","falling_death__greasy_spot":"You found the greasy spot!","falling_death__barely_missed":"Barely Missed!","falling_death__down_we_go":"Down we go!","button__play":"Play!","restart__title":"Restart?","restart__are_you_sure":"Are you sure you want to restart your run?","restart__confirm":"Yes!","restart__restarted":"Restarted...","leaderboard__players":"Players","leaderboard__countries":"Countries","leaderboard__falls":"Falls","leaderboard__hours_played":"Hours Played","leaderboard__got_to_top":"Got To The Top","leaderboard__personal_best":"Personal Best","leaderboard__global_rank":"Global Rank","leaderboard__rank":"Rank","leaderboard__runs":"Runs","leaderboard__time_played":"Time Played"}');


var $90b051267d834e3d$exports = {};
$90b051267d834e3d$exports = JSON.parse('{"error_screen__renderer_failed":"Your graphics card may not support UpTogether! Please try on again on a WebGL2 enabled browser & device.","error_screen__server_maybe_full":"连接服务器时出错：服务器可能已满，请在几分钟后重试！","error_screen__maintenance_mode":"UpTogether.io 正在更新中！几分钟后回来尝试新的东西 \uD83C\uDF89","error_screen__client_out_of_date":"您的游戏客户端已过时！请更新到最新版本然后重试。","error_screen__invalid_connection":"服务器拒绝了您的用户！请重试。","error_screen__already_logged_in":"您已经登录！","error_screen__unknown_reason":"未知连接错误 :(","error_screen__disconnected_from_server":"与服务器断开连接！服务器可能正在进行更新。请在几分钟后重试。","heightmarker__to_bottom":"回到底部！","heightmarker__inspiration_come_far":"看看你走了多远！","heightmarker__inspiration_keep_going":"继续前进！","heightmarker__inspiration_up_up":"上！上！上！","in_game__secret_edward":"嗨，爱德华！！","heightmarker__secret_gorillas":"你能找到多少猩猩？？","heightmarker__change_character":"更改角色","heightmarker__change_name":"更改名称","heightmarker__change_trail":"获取拖尾！","heightmarker__global_leaderboard":"全球排行榜","heightmarker__your_stats":"您的统计","heightmarker__game_stats":"游戏统计","heightmarker__tutorial_speed":"速度","heightmarker_tutorial_boost":"加速！","heightmarker__tutorial_climb":"攀爬","heightmarker__tutorial_the_wall":"墙","heightmarker__tutorial_bouncy":"有弹性的！","in_game__secret_invis_maze":"在迷宫门旁边，靠左...","in_game__secret_upside_down_plate":"从倒置的盘子上跳出去！","in_game__tutorial_start_timer":"越过起跑线开始计时器","in_game__tutorial_invis_platforms":"有隐形平台！","in_game__how_fast_top":"你能多快到达顶部？","in_game__no_touchy":"不要触碰！","in_game__tutorial_running":"使用左摇杆奔跑","in_game__tutorial_tap":"轻触","in_game__tutorial_press":"按","in_game__tutorial_or":"或","in_game__tutorial__to_jump":"跳跃","in_game__tutorial__hold":"保持","in_game__tutorial__jump_repeatedly":"重复跳跃","in_game__tutorial_wall_climb":"爬墙","in_game__tutorial_while_running":"在奔跑时","in_game__tutorial_drag_move_camera":"拖动屏幕以移动摄像头","in_game__checkpoint":"检查站","loading_text__connecting":" 连接到服务器中...","loading_text__splines":"曲线插值中","loading_text__tofu":"滷豆腐中","loading_text__corn":"摘玉米中","loading_text__broccoli":"确认西兰花是小树","loading_text__brussel_sprouts":"说服玩家布鲁塞尔芽是美味的","loading_text__secret_sauce":"加入秘制酱料","loading_text__digesting":"消化中","loading_text__stirring":"持续搅拌","loading_text__fixing_ice_cream":"修理麦当劳的冰淇淋机","loading_text__chopping_broccoli":"切西兰花","loading_text__carmelize_apples":"焦糖苹果","loading_text__water_boil":"看水烧开","loading_text__filleting_fish":"去鱼骨","loading_text__plating":"上菜","loading_text__garnishing":"装饰","loading_text__moldy_bits":"切掉发霉的部分","death_block__almost":"差点!","death_block__close_one":"差一点!","death_block__try_again":"再试一次!","death_block__roasted":"烤熟了！","death_block__burnt":"烧焦了！","death_block__oh_no":"哦不!","death_block__grilled":"烤熟了！","death_block__blanched":"漂白了！","death_block__crisp":"脆皮！","death_block__flameed":"火焰烹饪！","death_block__order_up":"上菜！","death_block__ouch":"哎哟！","death_block__good_try":"不错哦!","death_block__baked":"烤了！","death_block__crusty":"硬皮！","death_block__next_time":"下次再试！","death_block__toast":"你烤糊了！","death_block__no_chef":"没有厨师！","death_block__singe_left":"只是稍微烧焦了左边！","death_block__oof":"哎呀！","death_block__fried":"笨拙而油炸！","death_block__recipe_ruined":"食谱毁了","death_block__sizzling_stop":"滋滋作响的停止！","death_block__defeated":"厨师被打败了！","death_block__burnt_out":"烧毁了？","death_block__meltdown":"崩溃了？","falling_death__slippery":"滑!","falling_death__gg":"干得好","falling_death__you_died":"你死了 ","falling_death__f":"F","falling_death__floor_food":"地板食物！","falling_death__three_second":"三秒原则！","falling_death__floor_seasoning":"嗯！地板调味料！","falling_death__just_missed":"差一点!","falling_death__rip":"安息","falling_death__floor_vs_flavor":"地板：1","falling_death__floor_fall":"地板失败！","falling_death__saucy_slip":"多汁的滑倒！","falling_death__fried_fell":"油炸而倒下！","falling_death__dive":"无味的潜水！","falling_death__floor_finish":"地板完成！","falling_death__dinner_dive":"晚餐潜水！","falling_death__splat":"啪！","falling_death__oops":"哎呀","falling_death__greasy_spot":"你找到了油腻的地方！","falling_death__barely_missed":"勉强错过!","falling_death__down_we_go":"下降!","button__play":"播放！","restart__title":"重新开始？","restart__are_you_sure":"您确定要重新开始吗？","restart__confirm":"是的！","restart__restarted":"已重新开始...","leaderboard__players":"玩家","leaderboard__countries":"国家","leaderboard__falls":"跌落","leaderboard__hours_played":"游戏时长","leaderboard__got_to_top":"登顶","leaderboard__personal_best":"个人最佳","leaderboard__global_rank":"全球排名","leaderboard__rank":"排名","leaderboard__runs":"游戏轮数","leaderboard__time_played":"游戏时间"}');


var $0556b2ed0e519737$exports = {};
$0556b2ed0e519737$exports = JSON.parse('{"error_screen__renderer_failed":"Your graphics card may not support UpTogether! Please try on again on a WebGL2 enabled browser & device.","error_screen__server_maybe_full":"خطأ في الاتصال بالخادم: قد تكون الخوادم ممتلئة الآن، حاول مرة أخرى في بضع دقائق!","error_screen__maintenance_mode":"UpTogether.io يتم تحديثها! عد في بضع دقائق لتجربة الأمور الجديدة \uD83C\uDF89","error_screen__client_out_of_date":"العميل الخاص بك قديم! يرجى تحديث عميل اللعبة إلى أحدث إصدار وحاول مرة أخرى.","error_screen__invalid_connection":"رفض الخادم لمستخدمك! يرجى المحاولة مرة أخرى.","error_screen__already_logged_in":"لقد سجلت بالفعل!","error_screen__unknown_reason":"خطأ غير معروف في الاتصال :(","error_screen__disconnected_from_server":"تم قطع الاتصال من الخادم! قد تكون الخوادم تتوقف للتحديث. حاول مرة أخرى في بضع دقائق.","heightmarker__to_bottom":"العودة إلى الأسفل!","heightmarker__inspiration_come_far":"انظر كم وصلت بعيدًا!","heightmarker__inspiration_keep_going":"تابع!","heightmarker__inspiration_up_up":"أعلى! أعلى! أعلى!","in_game__secret_edward":"مرحبًا إدوارد!!","heightmarker__secret_gorillas":"كم عدد الغوريلات التي يمكنك العثور عليها؟؟","heightmarker__change_character":"تغيير الشخصية","heightmarker__change_name":"تغيير الاسم","heightmarker__change_trail":"احصل على مسار!","heightmarker__global_leaderboard":"لوحة المتصدرين العالمية","heightmarker__your_stats":"إحصائياتك","heightmarker__game_stats":"إحصائيات اللعبة","heightmarker__tutorial_speed":"السرعة","heightmarker_tutorial_boost":"تسريع!","heightmarker__tutorial_climb":"تسلق","heightmarker__tutorial_the_wall":"الجدار","heightmarker__tutorial_bouncy":"مرن!","in_game__secret_invis_maze":"بجوار باب المتاهة، على اليمين...","in_game__secret_upside_down_plate":"اقفز للأمام من لوحة مقلوبة!","in_game__tutorial_start_timer":"تجاوز خط البداية لبدء المؤقت الخاص بك","in_game__tutorial_invis_platforms":"هناك منصات غير مرئية!","in_game__how_fast_top":"كم يمكنك الوصول إلى الأعلى بسرعة؟","in_game__no_touchy":"لا تلمس!","in_game__tutorial_running":"استخدم العصا اليسرى للركض","in_game__tutorial_tap":"اضغط","in_game__tutorial_press":"اضغط","in_game__tutorial_or":"أو","in_game__tutorial__to_jump":"للقفز","in_game__tutorial__hold":"استمرار","in_game__tutorial__jump_repeatedly":"للقفز بشكل متكرر","in_game__tutorial_wall_climb":"لتسلق الجدران","in_game__tutorial_while_running":"أثناء الركض","in_game__tutorial_drag_move_camera":"اسحب الشاشة لتحريك الكاميرا","in_game__checkpoint":"نقطة تفتيش","loading_text__connecting":"الاتصال بالخادم...","loading_text__splines":"ريتيكولاتينج سبلاينز","loading_text__tofu":"تبديل التوفو","loading_text__corn":"تقشير الذرة","loading_text__broccoli":"التحقق من أن البروكلي هو شجرة صغيرة","loading_text__brussel_sprouts":"إقناع اللاعبين بأن نباتات بروكسل لذيذة","loading_text__secret_sauce":"إضافة الصلصة السرية","loading_text__digesting":"هضم","loading_text__stirring":"تحريك باستمرار","loading_text__fixing_ice_cream":"إصلاح آلة الآيس كريم في ماكدونالدز","loading_text__chopping_broccoli":"تقطيع البروكلي","loading_text__carmelize_apples":"كرميل التفاح","loading_text__water_boil":"مشاهدة الماء يغلي","loading_text__filleting_fish":"تقسيم السمك","loading_text__plating":"وضع على الصحن","loading_text__garnishing":"تزيين","loading_text__moldy_bits":"قطع الأجزاء المعافنة","death_block__almost":"تقريبًا!","death_block__close_one":"قريبًا","death_block__try_again":"حاول مرة أخرى!","death_block__roasted":"أنت محمص!","death_block__burnt":"أنت محترق!","death_block__oh_no":"آه لا!","death_block__grilled":"أنت مشوي!","death_block__blanched":"أنت مسلوق!","death_block__crisp":"أنت هش!","death_block__flameed":"أنت مشتعل!","death_block__order_up":"الطلب جاهز!","death_block__ouch":"أوتش!","death_block__good_try":"محاولة جيدة!","death_block__baked":"أنت خبز!","death_block__crusty":"أنت هش!","death_block__next_time":"المرة القادمة!","death_block__toast":"أنت محمص!","death_block__no_chef":"لا يوجد شيف!","death_block__singe_left":"لمسة خفيفة إلى اليسار فقط!","death_block__oof":"أوف!","death_block__fried":"تلعثم وقلي!","death_block__recipe_ruined":"الوصفة فسدت","death_block__sizzling_stop":"توقف متسارع!","death_block__defeated":"الطاهي هزم!","death_block__burnt_out":"اندلعت!","death_block__meltdown":"هل تواجه انهيارًا؟","falling_death__slippery":"زلق!","falling_death__gg":"جيد جدًا","falling_death__you_died":"لقد مت","falling_death__f":"إف","falling_death__floor_food":"طعام الأرض!","falling_death__three_second":"قاعدة الثلاث ثواني!","falling_death__floor_seasoning":"مم! توابل الأرض!","falling_death__just_missed":"فاته بشكل صغير!","falling_death__rip":"ارقد بسلام","falling_death__floor_vs_flavor":"الأرض: 1","falling_death__floor_fall":"فشل على الأرض!","falling_death__saucy_slip":"انزلاق لذيذ!","falling_death__fried_fell":"قلي وسقط!","falling_death__dive":"نزوة بدون طعم!","falling_death__floor_finish":"انتهاء على الأرض!","falling_death__dinner_dive":"نزوة العشاء!","falling_death__splat":"سبلات!","falling_death__oops":"عفوًا","falling_death__greasy_spot":"لقد وجدت المكان الدهني!","falling_death__barely_missed":"فاته بشكل ضئيل!","falling_death__down_we_go":"ننزل","button__play":"العب!","restart__title":"هل تريد إعادة التشغيل؟","restart__are_you_sure":"هل أنت متأكد من أنك تريد إعادة بدء الجولة؟","restart__confirm":"نعم!","restart__restarted":"تم إعادة التشغيل...","leaderboard__players":"اللاعبون","leaderboard__countries":"الدول","leaderboard__falls":"السقوط","leaderboard__hours_played":"ساعات اللعب","leaderboard__got_to_top":"وصل إلى القمة","leaderboard__personal_best":"الأفضل شخصياً","leaderboard__global_rank":"الترتيب العالمي","leaderboard__rank":"الترتيب","leaderboard__runs":"الجولات","leaderboard__time_played":"وقت اللعب"}');


var $b60fd03912d0afb0$exports = {};
$b60fd03912d0afb0$exports = JSON.parse('{"error_screen__renderer_failed":"Your graphics card may not support UpTogether! Please try on again on a WebGL2 enabled browser & device.","error_screen__server_maybe_full":"Error al conectar al servidor: los servidores pueden estar llenos en este momento, \xa1int\xe9ntalo de nuevo en unos minutos!","error_screen__maintenance_mode":"\xa1UpTogether.io se est\xe1 actualizando! Vuelve en unos minutos para probar las novedades \uD83C\uDF89","error_screen__client_out_of_date":"\xa1Tu cliente de juego est\xe1 desactualizado! Actualiza tu cliente de juego a la \xfaltima versi\xf3n e intenta de nuevo.","error_screen__invalid_connection":"\xa1El servidor rechaz\xf3 tu usuario! Por favor, int\xe9ntalo de nuevo.","error_screen__already_logged_in":"\xa1Ya has iniciado sesi\xf3n!","error_screen__unknown_reason":"Error de conexi\xf3n desconocido :(","error_screen__disconnected_from_server":"Desconectado del servidor. Los servidores pueden estar cerr\xe1ndose para una actualizaci\xf3n. Intenta de nuevo en unos minutos.","heightmarker__to_bottom":"\xa1De vuelta abajo!","heightmarker__inspiration_come_far":"\xa1Mira cu\xe1n lejos has llegado!","heightmarker__inspiration_keep_going":"\xa1Sigue adelante!","heightmarker__inspiration_up_up":"\xa1Arriba, arriba, arriba!","in_game__secret_edward":"\xa1Hola Edward!","heightmarker__secret_gorillas":"\xbfCu\xe1ntos gorilas puedes encontrar?","heightmarker__change_character":"Cambiar personaje","heightmarker__change_name":"Cambiar nombre","heightmarker__change_trail":"\xa1Consigue una estela!","heightmarker__global_leaderboard":"Clasificaci\xf3n global","heightmarker__your_stats":"TUS ESTAD\xcdSTICAS","heightmarker__game_stats":"ESTAD\xcdSTICAS DEL JUEGO","heightmarker__tutorial_speed":"Velocidad","heightmarker_tutorial_boost":"\xa1Impulso!","heightmarker__tutorial_climb":"ESCALA","heightmarker__tutorial_the_wall":"LA PARED","heightmarker__tutorial_bouncy":"\xa1Saltar\xedn!","in_game__secret_invis_maze":"Junto a la puerta del laberinto, a la izquierda...","in_game__secret_upside_down_plate":"Salta hacia adelante desde el plato boca abajo.","in_game__tutorial_start_timer":"Pasa la l\xednea de inicio para iniciar tu temporizador","in_game__tutorial_invis_platforms":"\xa1Hay plataformas invisibles!","in_game__how_fast_top":"\xbfQu\xe9 tan r\xe1pido puedes llegar a la cima?","in_game__no_touchy":"\xa1NO TOCAR!","in_game__tutorial_running":"Usa la palanca izquierda para correr","in_game__tutorial_tap":"Toque","in_game__tutorial_press":"Presiona","in_game__tutorial_or":"o","in_game__tutorial__to_jump":"Para saltar","in_game__tutorial__hold":"Mant\xe9n","in_game__tutorial__jump_repeatedly":"Para saltar repetidamente","in_game__tutorial_wall_climb":"Para escalar paredes","in_game__tutorial_while_running":"Mientras corres","in_game__tutorial_drag_move_camera":"Arrastra la pantalla para mover la c\xe1mara","in_game__checkpoint":"\xa1Control!","loading_text__connecting":"Conectando al servidor...","loading_text__splines":"Reticulando splines","loading_text__tofu":"Marinando el tofu","loading_text__corn":"Desgranando el ma\xedz","loading_text__broccoli":"Confirmar que el br\xf3coli es arbolitos peque\xf1os","loading_text__brussel_sprouts":"Convenciendo a los jugadores de que las coles de Bruselas son deliciosas","loading_text__secret_sauce":"A\xf1adiendo la salsa secreta","loading_text__digesting":"Digesti\xf3n en curso","loading_text__stirring":"Revuelto constante","loading_text__fixing_ice_cream":"Arreglando la m\xe1quina de helados en McDonald\'s","loading_text__chopping_broccoli":"Picando el br\xf3coli","loading_text__carmelize_apples":"Caramelizando las manzanas","loading_text__water_boil":"Observando el agua hervir","loading_text__filleting_fish":"Fileteando el pescado","loading_text__plating":"Presentaci\xf3n","loading_text__garnishing":"Guarnici\xf3n","loading_text__moldy_bits":"Cortando las partes mohosas","death_block__almost":"\xa1Casi!","death_block__close_one":"\xa1Por poco!","death_block__try_again":"\xa1Int\xe9ntalo de nuevo!","death_block__roasted":"\xa1Est\xe1s asado!","death_block__burnt":"\xa1Est\xe1s quemado!","death_block__oh_no":"\xa1Oh no!","death_block__grilled":"\xa1Est\xe1s a la parrilla!","death_block__blanched":"\xa1Est\xe1s escaldado!","death_block__crisp":"\xa1Est\xe1s crujiente!","death_block__flameed":"\xa1Est\xe1s flameado!","death_block__order_up":"\xa1Orden lista!","death_block__ouch":"\xa1Ay!","death_block__good_try":"\xa1Buen intento!","death_block__baked":"\xa1Est\xe1s horneado!","death_block__crusty":"\xa1Est\xe1s crujiente!","death_block__next_time":"\xa1La pr\xf3xima vez!","death_block__toast":"\xa1Est\xe1s tostado!","death_block__no_chef":"\xa1No hay chef!","death_block__singe_left":"\xa1Solo un toque a la izquierda!","death_block__oof":"\xa1Ay!","death_block__fried":"\xa1Tropiezo y frito!","death_block__recipe_ruined":"Receta arruinada","death_block__sizzling_stop":"\xa1Una parada chisporroteante!","death_block__defeated":"\xa1Chef derrotado!","death_block__burnt_out":"\xa1Quemado!","death_block__meltdown":"\xbfTienes un colapso?","falling_death__slippery":"\xa1Resbaladizo!","falling_death__gg":"GG","falling_death__you_died":"Has muerto ","falling_death__f":"F","falling_death__floor_food":"\xa1Comida en el suelo!","falling_death__three_second":"\xa1Regla de los tres segundos!","falling_death__floor_seasoning":"\xa1Mmm! \xa1Sazonado con el suelo!","falling_death__just_missed":"\xa1Apenas fallado!","falling_death__rip":"Descansa en paz","falling_death__floor_vs_flavor":"Suelo: 1","falling_death__floor_fall":"\xa1Fallo en el suelo!","falling_death__saucy_slip":"\xa1Resbal\xf3n sabroso!","falling_death__fried_fell":"\xa1Frito y ca\xeddo!","falling_death__dive":"\xa1Zambullida ins\xedpida!","falling_death__floor_finish":"\xa1Terminado en el suelo!","falling_death__dinner_dive":"\xa1Zambullida de la cena!","falling_death__splat":"\xa1SPLAT!","falling_death__oops":"Oops","falling_death__greasy_spot":"\xa1Encontraste el lugar grasiento!","falling_death__barely_missed":"\xa1Apenas fallado!","falling_death__down_we_go":"\xa1All\xe1 vamos!","button__play":"\xa1Jugar!","restart__title":"\xbfReiniciar?","restart__are_you_sure":"\xbfEst\xe1s seguro de que quieres reiniciar tu partida?","restart__confirm":"\xa1S\xed!","restart__restarted":"\xa1Reiniciado!","leaderboard__players":"Jugadores","leaderboard__countries":"Pa\xedses","leaderboard__falls":"Ca\xeddas","leaderboard__hours_played":"Horas Jugadas","leaderboard__got_to_top":"Lleg\xf3 a la Cima","leaderboard__personal_best":"Mejor Marca Personal","leaderboard__global_rank":"Rango Global","leaderboard__rank":"Rango","leaderboard__runs":"Partidas","leaderboard__time_played":"Tiempo Jugado"}');


var $34f6e14445e3d74f$exports = {};
$34f6e14445e3d74f$exports = JSON.parse('{"error_screen__renderer_failed":"Your graphics card may not support UpTogether! Please try on again on a WebGL2 enabled browser & device.","error_screen__server_maybe_full":"सर्वर से कनेक्ट करने में त्रुटि: सर्वर शायद इस समय भरा हुआ हो, कृपया कुछ मिनटों बाद पुनः प्रयास करें!","error_screen__maintenance_mode":"UpTogether.io का अपडेट हो रहा है! कुछ मिनटों में वापस आकर नए चीज़ को आज़माएं \uD83C\uDF89","error_screen__client_out_of_date":"आपका गेम क्लाइंट अपडेट नहीं है! कृपया अपने गेम क्लाइंट को नवीनतम संस्करण में अपडेट करें और पुनः प्रयास करें।","error_screen__invalid_connection":"सर्वर ने आपको मना कर दिया है! कृपया पुनः प्रयास करें।","error_screen__already_logged_in":"आप पहले से ही लॉग इन हैं!","error_screen__unknown_reason":"अज्ञात कनेक्शन त्रुटि :(","error_screen__disconnected_from_server":"सर्वर से डिस्कनेक्ट हो गए! सर्वर अपडेट के लिए जा रहा है। कृपया कुछ मिनटों बाद पुनः प्रयास करें।","heightmarker__to_bottom":"नीचे वापस जाओ!","heightmarker__inspiration_come_far":"देखो, तुमने कितना दूर पहुँच गए हो!","heightmarker__inspiration_keep_going":"आगे बढ़ो!","heightmarker__inspiration_up_up":"ऊपर! ऊपर! ऊपर!","in_game__secret_edward":"नमस्ते एडवर्ड!!","heightmarker__secret_gorillas":"तुम कितने गोरिले ढूंढ सकते हो??","heightmarker__change_character":"कैरेक्टर बदलो","heightmarker__change_name":"नाम बदलो","heightmarker__change_trail":"एक ट्रेल प्राप्त करें!","heightmarker__global_leaderboard":"वैश्विक लीडरबोर्ड","heightmarker__your_stats":"तुम्हारे स्टैट्स","heightmarker__game_stats":"गेम स्टैट्स","heightmarker__tutorial_speed":"गति","heightmarker_tutorial_boost":"बूस्ट!","heightmarker__tutorial_climb":"चढ़ाई","heightmarker__tutorial_the_wall":"दीवार","heightmarker__tutorial_bouncy":"बाउंसी!","in_game__secret_invis_maze":"मेज द्वार के पास, बाईं ओर...","in_game__secret_upside_down_plate":"उलटा हुआ प्लेट से आगे कूदो!","in_game__tutorial_start_timer":"अपने टाइमर को शुरू करने के लिए स्टार्टिंग लाइन पार करें","in_game__tutorial_invis_platforms":"अदृश्य प्लेटफ़ॉर्म्स हैं!","in_game__how_fast_top":"आप शीर्ष तक कितनी तेज़ी से पहुँच सकते हैं?","in_game__no_touchy":"मत छूना!","in_game__tutorial_running":"दौड़ने के लिए बाएं स्टिक का उपयोग करें","in_game__tutorial_tap":"टैप करें","in_game__tutorial_press":"दबाएं","in_game__tutorial_or":"या","in_game__tutorial__to_jump":"जाने के लिए","in_game__tutorial__hold":"पकड़","in_game__tutorial__jump_repeatedly":"बार-बार कूदने के लिए","in_game__tutorial_wall_climb":"दीवारों पर चढ़ने के लिए","in_game__tutorial_while_running":"दौड़ते हुए","in_game__tutorial_drag_move_camera":"कैमरा को मूव करने के लिए स्क्रीन को खींचें","in_game__checkpoint":"चेकपॉइंट!","loading_text__connecting":"सर्वर से कनेक्ट हो रहा है...","loading_text__splines":"स्प्लाइन्स को रेटिकुलेट कर रहे हैं","loading_text__tofu":"टोफू को मरिनेट कर रहे हैं","loading_text__corn":"मक्का को छिल रहे हैं","loading_text__broccoli":"ब्रोकोली को छोटे पेड़ों की तरह करने की पुष्टि कर रहे हैं","loading_text__brussel_sprouts":"ब्रसेल स्प्राउट्स को स्वादिष्ट बनाने की पुष्टि करना","loading_text__secret_sauce":"रहस्यमय सॉस जोड़ना","loading_text__digesting":"पचाना जा रहा है","loading_text__stirring":"लगातार हिलाना","loading_text__fixing_ice_cream":"मैकडॉनल्ड्स में आइसक्रीम मशीन को ठीक कर रहे हैं","loading_text__chopping_broccoli":"ब्रोकोली को काट रहे हैं","loading_text__carmelize_apples":"सेब को कैरेमेलाइज़ कर रहे हैं","loading_text__water_boil":"पानी उबाल रहे हैं","loading_text__filleting_fish":"मछली को फिलेट कर रहे हैं","loading_text__plating":"प्लेटिंग","loading_text__garnishing":"गार्निशिंग","loading_text__moldy_bits":"मोल्डी बिट्स को काट रहे हैं","death_block__almost":"लगभग!","death_block__close_one":"करीब!","death_block__try_again":"फिरसे कोशिश करो!","death_block__roasted":"तुम रोस्ट हो गए हो!","death_block__burnt":"तुम जल गए हो!","death_block__oh_no":"ओह नो!","death_block__grilled":"तुम ग्रिल हो गए हो!","death_block__blanched":"तुम ब्लांच्ड हो गए हो!","death_block__crisp":"तुम कुरकुरे हो गए हो!","death_block__flameed":"तुम फ्लैम्ड हो गए हो!","death_block__order_up":"ऑर्डर रेडी!","death_block__ouch":"आउच!","death_block__good_try":"अच्छा प्रयास!","death_block__baked":"तुम बेक्ड हो गए हो!","death_block__crusty":"तुम कस्टी हो गए हो!","death_block__next_time":"अगली बार!","death_block__toast":"तुम टोस्ट हो गए हो!","death_block__no_chef":"कोई शेफ नहीं!","death_block__singe_left":"बस बाएं में एक बार सिंगे!","death_block__oof":"ओफ!","death_block__fried":"गिर गए और फ्राइड हो गए!","death_block__recipe_ruined":"रेसिपी बिगड़ गई","death_block__sizzling_stop":"एक सिज़लिंग स्टॉप!","death_block__defeated":"शेफ हार गया!","death_block__burnt_out":"जल गए?","death_block__meltdown":"मेल्टडाउन हो रहा है?","falling_death__slippery":"स्लिपरी!","falling_death__gg":"जीजी","falling_death__you_died":"तुम मर गए हो ","falling_death__f":"एफ","falling_death__floor_food":"फ़्लोर फ़ूड!","falling_death__three_second":"तीन सेकंड रूल!","falling_death__floor_seasoning":"मम्म! फ़्लोर सीज़निंग!","falling_death__just_missed":"बस बच गया!","falling_death__rip":"रिप","falling_death__floor_vs_flavor":"फ़्लोर: 1","falling_death__floor_fall":"फ्लोर फेल!","falling_death__saucy_slip":"रसीला स्लिप!","falling_death__fried_fell":"फ्राइड और गिरा!","falling_death__dive":"स्वादहीन डाइव!","falling_death__floor_finish":"फ्लोर फिनिश!","falling_death__dinner_dive":"डिनर डाइव!","falling_death__splat":"स्प्लैट!","falling_death__oops":"ऊप्स","falling_death__greasy_spot":"तुम ने तेलीय स्थान पाया है!","falling_death__barely_missed":"मात्र बच गया! ","falling_death__down_we_go":"नीचे जा रहे हैं","button__play":"चलाएँ!","restart__title":"पुनः आरंभ करें?","restart__are_you_sure":"क्या आप निश्चित हैं कि आप अपनी दौड़ को पुनः आरंभ करना चाहते हैं?","restart__confirm":"हाँ!","restart__restarted":"पुनः आरंभ हो गया...","leaderboard__players":"खिलाड़ी","leaderboard__countries":"देश","leaderboard__falls":"गिरावटें","leaderboard__hours_played":"खेले गए घंटे","leaderboard__got_to_top":"शीर्ष पर पहुंचा","leaderboard__personal_best":"व्यक्तिगत सर्वश्रेष्ठ","leaderboard__global_rank":"वैश्विक रैंक","leaderboard__rank":"रैंक","leaderboard__runs":"रन्स","leaderboard__time_played":"खेले गए समय"}');


var $19b1f9c4a098e17a$exports = {};
$19b1f9c4a098e17a$exports = JSON.parse('{"error_screen__renderer_failed":"Your graphics card may not support UpTogether! Please try on again on a WebGL2 enabled browser & device.","error_screen__server_maybe_full":"Erro ao conectar ao servidor: os servidores podem estar cheios agora, tente novamente em alguns minutos!","error_screen__maintenance_mode":"UpTogether.io est\xe1 sendo atualizado! Volte em alguns minutos para experimentar as novidades \uD83C\uDF89","error_screen__client_out_of_date":"Seu cliente de jogo est\xe1 desatualizado! Por favor, atualize seu cliente de jogo para a vers\xe3o mais recente e tente novamente.","error_screen__invalid_connection":"O servidor rejeitou seu usu\xe1rio! Por favor, tente novamente.","error_screen__already_logged_in":"Voc\xea j\xe1 est\xe1 logado!","error_screen__unknown_reason":"Erro de conex\xe3o desconhecido :(","error_screen__disconnected_from_server":"Desconectado do servidor! Os servidores podem estar indo para baixo para uma atualiza\xe7\xe3o. Tente novamente em alguns minutos.","heightmarker__to_bottom":"De volta ao fundo!","heightmarker__inspiration_come_far":"Veja o qu\xe3o longe voc\xea chegou!","heightmarker__inspiration_keep_going":"Continue!","heightmarker__inspiration_up_up":"Para cima! Para cima! Para cima!","in_game__secret_edward":"Oi Edward!!","heightmarker__secret_gorillas":"Quantos gorilas voc\xea consegue encontrar??","heightmarker__change_character":"Trocar Personagem","heightmarker__change_name":"Trocar Nome","heightmarker__change_trail":"Obter uma trilha!","heightmarker__global_leaderboard":"Classifica\xe7\xe3o Global","heightmarker__your_stats":"SUAS ESTAT\xcdSTICAS","heightmarker__game_stats":"ESTAT\xcdSTICAS DO JOGO","heightmarker__tutorial_speed":"Velocidade","heightmarker_tutorial_boost":"Impulso!","heightmarker__tutorial_climb":"ESCALA","heightmarker__tutorial_the_wall":"A PAREDE","heightmarker__tutorial_bouncy":"Saltitante!","in_game__secret_invis_maze":"Ao lado da porta do labirinto, \xe0 esquerda...","in_game__secret_upside_down_plate":"Salte para frente da\\n     placa de cabe\xe7a para baixo!","in_game__tutorial_start_timer":"Passe a linha de partida para iniciar o cron\xf4metro","in_game__tutorial_invis_platforms":"Existem plataformas invis\xedveis!","in_game__how_fast_top":"Qu\xe3o r\xe1pido voc\xea pode chegar ao topo?","in_game__no_touchy":"N\xc3O TOQUE!","in_game__tutorial_running":"Use o joystick esquerdo para correr","in_game__tutorial_tap":"Toque","in_game__tutorial_press":"Pressione","in_game__tutorial_or":"ou","in_game__tutorial__to_jump":"Para Saltar","in_game__tutorial__hold":"Segure","in_game__tutorial__jump_repeatedly":"Para saltar repetidamente","in_game__tutorial_wall_climb":"Para escalar paredes","in_game__tutorial_while_running":"Enquanto Corre","in_game__tutorial_drag_move_camera":"Arraste a tela para \\n mover a c\xe2mera","in_game__checkpoint":"Posto de Controle!","loading_text__connecting":"Conectando ao servidor...","loading_text__splines":"Reticulando splines","loading_text__tofu":"Marinando o tofu","loading_text__corn":"Descascando o milho","loading_text__broccoli":"Confirmar que o br\xf3colis s\xe3o \xe1rvores pequenas","loading_text__brussel_sprouts":"Convencendo os jogadores de que os brotos de Bruxelas s\xe3o deliciosos","loading_text__secret_sauce":"Adicionando o molho secreto","loading_text__digesting":"Digerindo","loading_text__stirring":"Mexendo constantemente","loading_text__fixing_ice_cream":"Consertando a m\xe1quina de sorvete no McDonald\'s","loading_text__chopping_broccoli":"Picando o br\xf3colis","loading_text__carmelize_apples":"Caramelizando as ma\xe7\xe3s","loading_text__water_boil":"Observando a \xe1gua ferver","loading_text__filleting_fish":"Filetando o peixe","loading_text__plating":"Montando o prato","loading_text__garnishing":"Guarnecendo","loading_text__moldy_bits":"Cortando as partes mofadas","death_block__almost":"Quase!","death_block__close_one":"Por pouco!","death_block__try_again":"Tente novamente!","death_block__roasted":"Assado!","death_block__burnt":"Queimado!","death_block__oh_no":"Ah, n\xe3o!","death_block__grilled":"Grelhado!","death_block__blanched":"Branqueado!","death_block__crisp":"Crocante!","death_block__flameed":"Flambado!","death_block__order_up":"Pedido pronto!","death_block__ouch":"Ai!","death_block__good_try":"Boa tentativa!","death_block__baked":"Assado!","death_block__crusty":"Crocante!","death_block__next_time":"Na pr\xf3xima!","death_block__toast":"Voc\xea est\xe1 torrado!","death_block__no_chef":"Sem Chef!","death_block__singe_left":"Apenas uma queimadura \xe0 esquerda!","death_block__oof":"Oof!","death_block__fried":"Atrapalhado e frito!","death_block__recipe_ruined":"Receita arruinada","death_block__sizzling_stop":"Uma parada crepitante!","death_block__defeated":"Chef derrotado!","death_block__burnt_out":"Queimado?","death_block__meltdown":"Tendo um colapso?","falling_death__slippery":"Escorregadio!","falling_death__gg":"GG","falling_death__you_died":"Voc\xea morreu ","falling_death__f":"F","falling_death__floor_food":"Comida no ch\xe3o!","falling_death__three_second":"Regra dos tr\xeas segundos!","falling_death__floor_seasoning":"Mmm! Tempero do ch\xe3o!","falling_death__just_missed":"Por pouco","falling_death__rip":"Descanse em paz","falling_death__floor_vs_flavor":"Ch\xe3o: 1","falling_death__floor_fall":"Falha no ch\xe3o!","falling_death__saucy_slip":"Deslize saboroso!","falling_death__fried_fell":"Frito e caiu!","falling_death__dive":"Mergulho sem sabor!","falling_death__floor_finish":"Acabamento no ch\xe3o!","falling_death__dinner_dive":"Mergulho no jantar!","falling_death__splat":"SPLAT!","falling_death__oops":"Oops","falling_death__greasy_spot":"Voc\xea encontrou o ponto oleoso!","falling_death__barely_missed":"Por um triz!","falling_death__down_we_go":"L\xe1 vamos n\xf3s!","button__play":"Jogar!","restart__title":"Reiniciar?","restart__are_you_sure":"Voc\xea tem certeza de que deseja reiniciar sua corrida?","restart__confirm":"Sim!","restart__restarted":"Reiniciado...","leaderboard__players":"Jogadores","leaderboard__countries":"Pa\xedses","leaderboard__falls":"Quedas","leaderboard__hours_played":"Horas Jogadas","leaderboard__got_to_top":"Chegou ao Topo","leaderboard__personal_best":"Melhor Desempenho Pessoal","leaderboard__global_rank":"Classifica\xe7\xe3o Global","leaderboard__rank":"Classifica\xe7\xe3o","leaderboard__runs":"Rodadas","leaderboard__time_played":"Tempo Jogado"}');


var $eb18c263345b47ff$exports = {};
$eb18c263345b47ff$exports = JSON.parse('{"error_screen__renderer_failed":"Your graphics card may not support UpTogether! Please try on again on a WebGL2 enabled browser & device.","error_screen__server_maybe_full":"Fehler bei der Verbindung zum Server: Die Server sind m\xf6glicherweise gerade voll, versuchen Sie es in ein paar Minuten erneut!","error_screen__maintenance_mode":"UpTogether.io wird aktualisiert! Kommen Sie in ein paar Minuten wieder, um die neuen Funktionen auszuprobieren \uD83C\uDF89","error_screen__client_out_of_date":"Ihr Spielclient ist veraltet! Aktualisieren Sie Ihren Spielclient auf die neueste Version und versuchen Sie es erneut.","error_screen__invalid_connection":"Der Server hat Ihren Benutzer abgelehnt! Bitte versuchen Sie es erneut.","error_screen__already_logged_in":"Sie sind bereits angemeldet!","error_screen__unknown_reason":"Unbekannter Verbindungsfehler :(","error_screen__disconnected_from_server":"Verbindung zum Server getrennt! Die Server werden m\xf6glicherweise f\xfcr ein Update heruntergefahren. Versuchen Sie es in ein paar Minuten erneut.","heightmarker__to_bottom":"Zur\xfcck nach unten!","heightmarker__inspiration_come_far":"Schau, wie weit du gekommen bist!","heightmarker__inspiration_keep_going":"Mach weiter!","heightmarker__inspiration_up_up":"Hoch! hoch! hoch!","in_game__secret_edward":"Hallo Edward!","heightmarker__secret_gorillas":"Wie viele Gorillas kannst du finden??","heightmarker__change_character":"Charakter \xe4ndern","heightmarker__change_name":"Namen \xe4ndern","heightmarker__change_trail":"Hol dir einen Trail!","heightmarker__global_leaderboard":"Weltweite Bestenliste","heightmarker__your_stats":"DEINE STATISTIKEN","heightmarker__game_stats":"SPIELSTATISTIKEN","heightmarker__tutorial_speed":"Geschwindigkeit","heightmarker_tutorial_boost":"Boost!","heightmarker__tutorial_climb":"KLETTERN","heightmarker__tutorial_the_wall":"DIE WAND","heightmarker__tutorial_bouncy":"Fedrig!","in_game__secret_invis_maze":"Neben der Labyrintht\xfcr, auf der linken Seite...","in_game__secret_upside_down_plate":"Spring vorw\xe4rts von der umgedrehten Platte!","in_game__tutorial_start_timer":"\xdcberqueren Sie die Startlinie, um Ihren Timer zu starten","in_game__tutorial_invis_platforms":"Es gibt unsichtbare Plattformen!","in_game__how_fast_top":"Wie schnell kommst du nach oben?","in_game__no_touchy":"NICHT BER\xdcHREN!","in_game__tutorial_running":"Benutze den linken Stick zum Laufen","in_game__tutorial_tap":"Tippen","in_game__tutorial_press":"Dr\xfccken","in_game__tutorial_or":"oder","in_game__tutorial__to_jump":"Um zu springen","in_game__tutorial__hold":"Halten","in_game__tutorial__jump_repeatedly":"Um wiederholt zu springen","in_game__tutorial_wall_climb":"Um W\xe4nde zu erklimmen","in_game__tutorial_while_running":"W\xe4hrend des Laufens","in_game__tutorial_drag_move_camera":"Ziehen Sie den Bildschirm, um die Kamera zu bewegen","in_game__checkpoint":"Kontrollpunkt!","loading_text__connecting":"Verbinde mit dem Server...","loading_text__splines":"Splines retikulieren","loading_text__tofu":"Tofu marinieren","loading_text__corn":"Den Mais sch\xe4len","loading_text__broccoli":"Best\xe4tigen, dass Brokkoli kleine B\xe4ume sind","loading_text__brussel_sprouts":"Spieler davon \xfcberzeugen, dass Rosenkohl k\xf6stlich ist","loading_text__secret_sauce":"Das Geheimrezept hinzuf\xfcgen","loading_text__digesting":"Verdauen","loading_text__stirring":"St\xe4ndig umr\xfchren","loading_text__fixing_ice_cream":"Die Eismaschine bei McDonald\'s reparieren","loading_text__chopping_broccoli":"Den Brokkoli hacken","loading_text__carmelize_apples":"Die \xc4pfel karamellisieren","loading_text__water_boil":"Zusehen, wie das Wasser kocht","loading_text__filleting_fish":"Den Fisch filetieren","loading_text__plating":"Anrichten","loading_text__garnishing":"Garnieren","loading_text__moldy_bits":"Die verschimmelten Teile abschneiden","death_block__almost":"Fast!","death_block__close_one":"Knapp daneben!","death_block__try_again":"Versuch es erneut!","death_block__roasted":"Ger\xf6stet!","death_block__burnt":"Verbrannt!","death_block__oh_no":"Oh nein!","death_block__grilled":"Gegrillt!","death_block__blanched":"Ged\xfcnstet!","death_block__crisp":"Kross!","death_block__flameed":"Flambiert!","death_block__order_up":"Bestellung fertig!","death_block__ouch":"Au!","death_block__good_try":"Gut versucht!","death_block__baked":"Gebacken!","death_block__crusty":"Krustig!","death_block__next_time":"N\xe4chstes Mal!","death_block__toast":"Du bist Toast!","death_block__no_chef":"Kein Koch!","death_block__singe_left":"Nur eine Schramme nach links!","death_block__oof":"Oof!","death_block__fried":"Gestolpert und frittiert!","death_block__recipe_ruined":"Rezept ruiniert","death_block__sizzling_stop":"Ein sizzliger Stopp!","death_block__defeated":"Koch besiegt!","death_block__burnt_out":"Ausgebrannt?","death_block__meltdown":"Einen Zusammenbruch haben?","falling_death__slippery":"Rutschig!","falling_death__gg":"GG","falling_death__you_died":"Du bist gestorben ","falling_death__f":"F","falling_death__floor_food":"Essen auf dem Boden!","falling_death__three_second":"Drei-Sekunden-Regel!","falling_death__floor_seasoning":"Mmm! Bodenw\xfcrzung!","falling_death__just_missed":"Gerade verpasst!","falling_death__rip":"Ruhe in Frieden","falling_death__floor_vs_flavor":"Boden: 1","falling_death__floor_fall":"Bodenfehler!","falling_death__saucy_slip":"W\xfcrziger Ausrutscher!","falling_death__fried_fell":"Gebraten und gefallen!","falling_death__dive":"Geschmackloser Tauchgang!","falling_death__floor_finish":"Boden-Finish!","falling_death__dinner_dive":"Abendessen-Tauchgang!","falling_death__splat":"SPLAT!","falling_death__oops":"Oops","falling_death__greasy_spot":"Du hast den fettigen Fleck gefunden!","falling_death__barely_missed":"Knapp verpasst!","falling_death__down_we_go":"Runter geht\'s!","button__play":"Spielen!","restart__title":"Neustarten?","restart__are_you_sure":"Sind Sie sicher, dass Sie Ihren Lauf neu starten m\xf6chten?","restart__confirm":"Ja!","restart__restarted":"Neugestartet...","leaderboard__players":"Spieler","leaderboard__countries":"L\xe4nder","leaderboard__falls":"St\xfcrze","leaderboard__hours_played":"Stunden Gespielt","leaderboard__got_to_top":"Hat die Spitze erreicht","leaderboard__personal_best":"Pers\xf6nliche Bestleistung","leaderboard__global_rank":"Weltweiter Rang","leaderboard__rank":"Rang","leaderboard__runs":"Spiele","leaderboard__time_played":"Spielzeit"}');


var $21e197ee41b1ee82$exports = {};
$21e197ee41b1ee82$exports = JSON.parse('{"error_screen__renderer_failed":"Your graphics card may not support UpTogether! Please try on again on a WebGL2 enabled browser & device.","error_screen__server_maybe_full":"サーバーへの接続エラー：サーバーが現在いっぱいかもしれません。数分後にもう一度試してみてください！","error_screen__maintenance_mode":"UpTogether.ioは更新中です！数分後に戻って新しいものを試してみてください \uD83C\uDF89","error_screen__client_out_of_date":"ゲームクライアントが古いです！ゲームクライアントを最新バージョンに更新して再試行してください。","error_screen__invalid_connection":"サーバーがユーザーを拒否しました！もう一度試してください。","error_screen__already_logged_in":"すでにログインしています！","error_screen__unknown_reason":"不明な接続エラー :(","error_screen__disconnected_from_server":"サーバーから切断されました！サーバーはアップデートのために停止しているかもしれません。数分後にもう一度試してみてください。","heightmarker__to_bottom":"一番下に戻る！","heightmarker__inspiration_come_far":"これまでに来た道を見て！","heightmarker__inspiration_keep_going":"続けて！","heightmarker__inspiration_up_up":"上へ！上へ！上へ！","in_game__secret_edward":"こんにちは、エドワード！！","heightmarker__secret_gorillas":"ゴリラは何匹見つけられるかな？？","heightmarker__change_character":"キャラクター変更","heightmarker__change_name":"名前変更","heightmarker__change_trail":"トレイルを手に入れよう！","heightmarker__global_leaderboard":"グローバルリーダーボード","heightmarker__your_stats":"あなたの統計","heightmarker__game_stats":"ゲーム統計","heightmarker__tutorial_speed":"スピード","heightmarker_tutorial_boost":"ブースト！","heightmarker__tutorial_climb":"登る","heightmarker__tutorial_the_wall":"壁","heightmarker__tutorial_bouncy":"バウンシー！","in_game__secret_invis_maze":"迷路の扉の横、左に...","in_game__secret_upside_down_plate":"逆さまのプレートから前にジャンプ！","in_game__tutorial_start_timer":"スタートラインを越えてタイマーを開始します","in_game__tutorial_invis_platforms":"見えないプラットフォームがあります！","in_game__how_fast_top":"どれだけ速くトップに到達できますか？","in_game__no_touchy":"触らないで！","in_game__tutorial_running":"左のスティックを使って走る","in_game__tutorial_tap":"タップ","in_game__tutorial_press":"押す","in_game__tutorial_or":"または","in_game__tutorial__to_jump":"ジャンプするには","in_game__tutorial__hold":"ホールド","in_game__tutorial__jump_repeatedly":"繰り返しジャンプするには","in_game__tutorial_wall_climb":"壁を登るには","in_game__tutorial_while_running":"走りながら","in_game__tutorial_drag_move_camera":"画面をドラッグして\\n カメラを移動","in_game__checkpoint":"チェックポイント！","loading_text__connecting":"サーバーに接続中...","loading_text__splines":"スプラインを絡ませています","loading_text__tofu":"豆腐を漬け込んでいます","loading_text__corn":"とうもろこしをむいています","loading_text__broccoli":"ブロッコリーが小さな木であることを確認しています","loading_text__brussel_sprouts":"ブリュッセルスプラウトが美味しいと説得しています","loading_text__secret_sauce":"秘密のソースを加えています","loading_text__digesting":"消化中","loading_text__stirring":"絶えずかき混ぜています","loading_text__fixing_ice_cream":"マクドナルドのアイスクリームマシンを修理しています","loading_text__chopping_broccoli":"ブロッコリーを切っています","loading_text__carmelize_apples":"リンゴをキャラメルにしています","loading_text__water_boil":"お湯が沸騰しているのを見ています","loading_text__filleting_fish":"魚をさばいています","loading_text__plating":"盛り付け中","loading_text__garnishing":"飾り付け中","loading_text__moldy_bits":"カビの生えた部分を切り落としています","death_block__almost":"ほぼ！","death_block__close_one":"接近した！","death_block__try_again":"もう一度やってみて！","death_block__roasted":"焼かれました！","death_block__burnt":"焦げました！","death_block__oh_no":"ああ、だめ！","death_block__grilled":"焼きました！","death_block__blanched":"白くなりました！","death_block__crisp":"カリカリです！","death_block__flameed":"フランベ！","death_block__order_up":"オーダーアップ！","death_block__ouch":"痛い！","death_block__good_try":"よくやった！","death_block__baked":"焼かれました！","death_block__crusty":"カリカリです！","death_block__next_time":"次回に期待！","death_block__toast":"あなたはトーストです！","death_block__no_chef":"シェフなし！","death_block__singe_left":"左に少し火をつけただけです！","death_block__oof":"オフ！","death_block__fried":"つまずいて揚げました！","death_block__recipe_ruined":"レシピが台無しです","death_block__sizzling_stop":"ジュージュー音が止まりました！","death_block__defeated":"シェフ敗北！","death_block__burnt_out":"燃え尽きましたか？","death_block__meltdown":"メルトダウン中？","falling_death__slippery":"滑りやすい！","falling_death__gg":"GG","falling_death__you_died":"あなたは死にました ","falling_death__f":"F","falling_death__floor_food":"床の食べ物！","falling_death__three_second":"3秒ルール！","falling_death__floor_seasoning":"うーん！床の調味料！","falling_death__just_missed":"ちょうど逃した！","falling_death__rip":"お疲れ様でした","falling_death__floor_vs_flavor":"床：1","falling_death__floor_fall":"床失敗！","falling_death__saucy_slip":"ソースの滑り！","falling_death__fried_fell":"揚げて倒れました！","falling_death__dive":"無味のダイブ！","falling_death__floor_finish":"床フィニッシュ！","falling_death__dinner_dive":"ディナーダイブ！","falling_death__splat":"スプラット！","falling_death__oops":"おっと","falling_death__greasy_spot":"油っぽいスポットを見つけました！","falling_death__barely_missed":"かろうじて逃した！","falling_death__down_we_go":"下へ行くよ!","button__play":"プレイ！","restart__title":"リスタート？","restart__are_you_sure":"本当にランをリスタートしますか？","restart__confirm":"はい！","restart__restarted":"リスタートしました...","leaderboard__players":"プレイヤー","leaderboard__countries":"国","leaderboard__falls":"転倒","leaderboard__hours_played":"プレイ時間","leaderboard__got_to_top":"トップに到達","leaderboard__personal_best":"個人ベスト","leaderboard__global_rank":"グローバルランク","leaderboard__rank":"ランク","leaderboard__runs":"プレイ回数","leaderboard__time_played":"プレイ時間"}');


var $ddfc218cb7319592$exports = {};
$ddfc218cb7319592$exports = JSON.parse('{"error_screen__renderer_failed":"Your graphics card may not support UpTogether! Please try on again on a WebGL2 enabled browser & device.","error_screen__server_maybe_full":"Erreur de connexion au serveur : les serveurs sont peut-\xeatre pleins en ce moment, r\xe9essayez dans quelques minutes !","error_screen__maintenance_mode":"UpTogether.io est en cours de mise \xe0 jour ! Revenez dans quelques minutes pour essayer les nouveaut\xe9s \uD83C\uDF89","error_screen__client_out_of_date":"Votre client de jeu n\'est pas \xe0 jour ! Veuillez mettre \xe0 jour votre client de jeu vers la derni\xe8re version et r\xe9essayez.","error_screen__invalid_connection":"Le serveur a rejet\xe9 votre utilisateur ! Veuillez r\xe9essayer.","error_screen__already_logged_in":"Vous \xeates d\xe9j\xe0 connect\xe9 !","error_screen__unknown_reason":"Erreur de connexion inconnue :(","error_screen__disconnected_from_server":"D\xe9connect\xe9 du serveur ! Les serveurs peuvent \xeatre en cours de mise \xe0 jour. R\xe9essayez dans quelques minutes.","heightmarker__to_bottom":"Retour en bas !","heightmarker__inspiration_come_far":"Regardez le chemin parcouru !","heightmarker__inspiration_keep_going":"Continuez !","heightmarker__inspiration_up_up":"Haut ! haut ! haut !","in_game__secret_edward":"Salut Edward !!","heightmarker__secret_gorillas":"Combien de gorilles pouvez-vous trouver ??","heightmarker__change_character":"Changer de personnage","heightmarker__change_name":"Changer de nom","heightmarker__change_trail":"Obtenez une trace !","heightmarker__global_leaderboard":"Classement mondial","heightmarker__your_stats":"VOS STATS","heightmarker__game_stats":"STATISTIQUES DU JEU","heightmarker__tutorial_speed":"Vitesse","heightmarker_tutorial_boost":"Boost !","heightmarker__tutorial_climb":"GRIMPER","heightmarker__tutorial_the_wall":"LE MUR","heightmarker__tutorial_bouncy":"Bondissant !","in_game__secret_invis_maze":"\xc0 c\xf4t\xe9 de la porte du labyrinthe, \xe0 gauche...","in_game__secret_upside_down_plate":"Sautez en avant depuis l\'assiette \xe0 l\'envers !","in_game__tutorial_start_timer":"Passez la ligne de d\xe9part pour d\xe9marrer votre chronom\xe8tre","in_game__tutorial_invis_platforms":"Il y a des plates-formes invisibles !","in_game__how_fast_top":"\xc0 quelle vitesse pouvez-vous atteindre le sommet ?","in_game__no_touchy":"NE PAS TOUCHER !","in_game__tutorial_running":"Utilisez le joystick gauche pour courir","in_game__tutorial_tap":"Taper","in_game__tutorial_press":"Appuyer","in_game__tutorial_or":"ou","in_game__tutorial__to_jump":"Pour sauter","in_game__tutorial__hold":"Tenir","in_game__tutorial__jump_repeatedly":"Pour sauter \xe0 plusieurs reprises","in_game__tutorial_wall_climb":"Pour grimper aux murs","in_game__tutorial_while_running":"En courant","in_game__tutorial_drag_move_camera":"Faites glisser l\'\xe9cran pour d\xe9placer la cam\xe9ra","in_game__checkpoint":" Point de contr\xf4le!","loading_text__connecting":"Connexion au serveur...","loading_text__splines":"Rectification des splines","loading_text__tofu":"Mariner le tofu","loading_text__corn":"\xc9plucher le ma\xefs","loading_text__broccoli":"Confirmation que le brocoli est fait de petits arbres","loading_text__brussel_sprouts":"Convaincre les joueurs que les choux de Bruxelles sont d\xe9licieux","loading_text__secret_sauce":"Ajout de la sauce secr\xe8te","loading_text__digesting":"Digestion","loading_text__stirring":"Remuer constamment","loading_text__fixing_ice_cream":"R\xe9paration de la machine \xe0 glace chez McDonald\'s","loading_text__chopping_broccoli":"Couper le brocoli","loading_text__carmelize_apples":"Caram\xe9lisation des pommes","loading_text__water_boil":"Regarder l\'eau bouillir","loading_text__filleting_fish":"Fileter le poisson","loading_text__plating":"Plaquer","loading_text__garnishing":"Garnir","loading_text__moldy_bits":"Couper les parties moisies","death_block__almost":"Presque!","death_block__close_one":"Tout pr\xe8s!","death_block__try_again":"Essaie encore!","death_block__roasted":"R\xf4ti !","death_block__burnt":"Br\xfbl\xe9 !","death_block__oh_no":"Oh non!","death_block__grilled":"Grill\xe9 !","death_block__blanched":"Blanchi !","death_block__crisp":"Croustillant !","death_block__flameed":"Flamb\xe9 !","death_block__order_up":"Commande pr\xeate !","death_block__ouch":"A\xefe !","death_block__good_try":"Bien essay\xe9!","death_block__baked":"Cuit au four !","death_block__crusty":"Croustillant !","death_block__next_time":"La prochaine fois!","death_block__toast":"Tu es grill\xe9 !","death_block__no_chef":"Pas de chef !","death_block__singe_left":"Juste une l\xe9g\xe8re br\xfblure \xe0 gauche !","death_block__oof":"Oof !","death_block__fried":"Maladroit et frit !","death_block__recipe_ruined":"Recette ruin\xe9e","death_block__sizzling_stop":"Un arr\xeat qui cr\xe9pite !","death_block__defeated":"Chef vaincu !","death_block__burnt_out":"Tu es \xe9puis\xe9 ?","death_block__meltdown":"En pleine crise ?","falling_death__slippery":"Glissant!","falling_death__gg":"GG","falling_death__you_died":"Tu es mort ","falling_death__f":"F","falling_death__floor_food":"Nourriture au sol !","falling_death__three_second":"R\xe8gle des trois secondes !","falling_death__floor_seasoning":"Mmm ! Assaisonnement au sol !","falling_death__just_missed":"Tout juste rat\xe9!","falling_death__rip":"Repose en paix","falling_death__floor_vs_flavor":"Sol : 1","falling_death__floor_fall":"\xc9chec au sol !","falling_death__saucy_slip":"Glissade sauc\xe9e !","falling_death__fried_fell":"Frit et tomb\xe9 !","falling_death__dive":"Plong\xe9e sans saveur !","falling_death__floor_finish":"Finition au sol !","falling_death__dinner_dive":"Plong\xe9e d\xeenatoire !","falling_death__splat":"SPLAT !","falling_death__oops":"Oops","falling_death__greasy_spot":"Vous avez trouv\xe9 l\'endroit gras !","falling_death__barely_missed":"Tout juste rat\xe9!","falling_death__down_we_go":"En descente!","button__play":"Jouer !","restart__title":"Recommencer ?","restart__are_you_sure":"\xcates-vous s\xfbr de vouloir recommencer votre partie ?","restart__restarted":"Recommenc\xe9...","leaderboard__players":"Joueurs","leaderboard__countries":"Pays","leaderboard__falls":"Chutes","leaderboard__hours_played":"Heures Jou\xe9es","leaderboard__got_to_top":"Atteint le Sommet","leaderboard__personal_best":"Meilleur Personnel","leaderboard__global_rank":"Classement Mondial","leaderboard__rank":"Classement","leaderboard__runs":"Parties","leaderboard__time_played":"Temps Jou\xe9"}');


var $7f848ada164f27df$exports = {};
$7f848ada164f27df$exports = JSON.parse('{"error_screen__renderer_failed":"Your graphics card may not support UpTogether! Please try on again on a WebGL2 enabled browser & device.","error_screen__server_maybe_full":"Sunucuya bağlanırken hata oluştu: sunucular şu anda dolu olabilir, birka\xe7 dakika sonra tekrar deneyin!","error_screen__maintenance_mode":"UpTogether.io g\xfcncelleniyor! Yeni şeyleri denemek i\xe7in birka\xe7 dakika sonra geri gel \uD83C\uDF89","error_screen__client_out_of_date":"Oyun istemciniz g\xfcncel değil! L\xfctfen oyun istemcinizi en son s\xfcr\xfcme g\xfcncelleyin ve tekrar deneyin.","error_screen__invalid_connection":"Sunucu kullanıcınızı reddetti! L\xfctfen tekrar deneyin.","error_screen__already_logged_in":"Zaten giriş yaptınız!","error_screen__unknown_reason":"Bilinmeyen bağlantı hatası :(","error_screen__disconnected_from_server":"Sunucudan bağlantı kesildi! Sunucular g\xfcncelleme i\xe7in kapatılabilir. Birka\xe7 dakika sonra tekrar deneyin.","heightmarker__to_bottom":"En Aşağıya D\xf6n!","heightmarker__inspiration_come_far":"Geldiğin yere bak!","heightmarker__inspiration_keep_going":"Devam et!","heightmarker__inspiration_up_up":"Yukarı! yukarı! yukarı!","in_game__secret_edward":"Merhaba Edward!!","heightmarker__secret_gorillas":"Ka\xe7 goril bulabilirsin??","heightmarker__change_character":"Karakter Değiştir","heightmarker__change_name":"İsim Değiştir","heightmarker__change_trail":"Bir iz al!","heightmarker__global_leaderboard":"Global Liderlik Tablosu","heightmarker__your_stats":"SENİN İSTATİSTİKLERİN","heightmarker__game_stats":"OYUN İSTATİSTİKLERİ","heightmarker__tutorial_speed":"Hız","heightmarker_tutorial_boost":"Hızlandır!","heightmarker__tutorial_climb":"TIRMAN","heightmarker__tutorial_the_wall":"DUVAR","heightmarker__tutorial_bouncy":"Zıplayan!","in_game__secret_invis_maze":"Labirent kapısının yanında, solda...","in_game__secret_upside_down_plate":"Ters \xe7evrilmiş tabaktan ileriye doğru atla!","in_game__tutorial_start_timer":"Zamanlayıcıyı başlatmak i\xe7in başlangı\xe7 \xe7izgisini ge\xe7","in_game__tutorial_invis_platforms":"G\xf6r\xfcnmez platformlar var!","in_game__how_fast_top":"Zirveye ne kadar hızlı \xe7ıkabilirsin?","in_game__no_touchy":"DOKUNMA!","in_game__tutorial_running":"Koşmak i\xe7in sol joystick\'i kullan","in_game__tutorial_tap":"Dokun","in_game__tutorial_press":"Bas","in_game__tutorial_or":"veya","in_game__tutorial__to_jump":"Zıplamak i\xe7in","in_game__tutorial__hold":"Tut","in_game__tutorial__jump_repeatedly":"Tekrarlayarak zıplamak i\xe7in","in_game__tutorial_wall_climb":"Duvarlara tırmanmak i\xe7in","in_game__tutorial_while_running":"Koşarken","in_game__tutorial_drag_move_camera":"Kamerayı hareket ettirmek i\xe7in ekrana s\xfcr\xfckleyin","in_game__checkpoint":"Kontrol noktası!","loading_text__connecting":"Sunucuya bağlanıyor...","loading_text__splines":"Eğrileri d\xfczenliyor","loading_text__tofu":"Tofuyu marine ediyor","loading_text__corn":"Misir soyuyor","loading_text__broccoli":"Brokolinin k\xfc\xe7\xfck ağa\xe7lar olduğunu onaylıyor","loading_text__brussel_sprouts":"Br\xfcksel lahanasının lezzetli olduğuna oyuncuları ikna ediyor","loading_text__secret_sauce":"Gizli sos ekliyor","loading_text__digesting":"Sindirme","loading_text__stirring":"S\xfcrekli karıştırma","loading_text__fixing_ice_cream":"McDonalds\'ta dondurma makinesini tamir ediyor","loading_text__chopping_broccoli":"Brokoliyi doğruyor","loading_text__carmelize_apples":"Elmaları karamelize ediyor","loading_text__water_boil":"Su kaynatıyor","loading_text__filleting_fish":"Balığı filetoya ayırıyor","loading_text__plating":"Tabaklama","loading_text__garnishing":"S\xfcsleme","loading_text__moldy_bits":"K\xfcfl\xfc kısımları kesiyor","death_block__almost":"Neredeyse!","death_block__close_one":"Yakın!","death_block__try_again":"Tekrar dene!","death_block__roasted":"Kavrulmuş!","death_block__burnt":"Yanmış!","death_block__oh_no":"Oh Hayır!","death_block__grilled":"Izgara!","death_block__blanched":"Haşlanmış!","death_block__crisp":"\xc7ıtır!","death_block__flameed":"Flamb\xe9 edildi!","death_block__order_up":"Sipariş ver!","death_block__ouch":"Au\xe7!","death_block__good_try":"İyi Deneme!","death_block__baked":"Fırınlandı!","death_block__crusty":"\xc7ıtır!","death_block__next_time":"Bir Sonraki Sefer!","death_block__toast":"Sen kızartıldın!","death_block__no_chef":"Şef yok!","death_block__singe_left":"Sadece sola biraz yanık!","death_block__oof":"Oof!","death_block__fried":"D\xfcş\xfcp kızaran!","death_block__recipe_ruined":"Tarif mahvoldu","death_block__sizzling_stop":"Sızzz sesi durdu!","death_block__defeated":"Şef mağlup!","death_block__burnt_out":"T\xfckenmiş mi?","death_block__meltdown":"Erime halinde mi?","falling_death__slippery":"Kaygan!","falling_death__gg":"GG","falling_death__you_died":"\xd6ld\xfcn ","falling_death__f":"F","falling_death__floor_food":"Zemin yemeği!","falling_death__three_second":"\xdc\xe7 saniye kuralı!","falling_death__floor_seasoning":"Hmm! Zemin baharatı!","falling_death__just_missed":"Diren\xe7li!","falling_death__rip":"RIP","falling_death__floor_vs_flavor":"Zemin: 1","falling_death__floor_fall":"Zemin Başarısız!","falling_death__saucy_slip":"Soslu kayma!","falling_death__fried_fell":"Kızartıldı ve d\xfcşt\xfc!","falling_death__dive":"Tatsız dalış!","falling_death__floor_finish":"Zemin bitişi!","falling_death__dinner_dive":"Akşam yemeği dalışı!","falling_death__splat":"SPLAT!","falling_death__oops":"Hata","falling_death__greasy_spot":"Yağlı noktayı buldun!","falling_death__barely_missed":"Zar zor ka\xe7ırıldı!","falling_death__down_we_go":"Aşağı iniyoruz!","button__play":"Oyna!","restart__title":"Yeniden Başlat?","restart__are_you_sure":"Oyununuzu yeniden başlatmak istediğinizden emin misiniz?","restart__confirm":"Evet!","restart__restarted":"Yeniden başlatıldı...","leaderboard__players":"Oyuncular","leaderboard__countries":"\xdclkeler","leaderboard__falls":"D\xfcş\xfcşler","leaderboard__hours_played":"Oynanan Saatler","leaderboard__got_to_top":"Zirveye \xc7ıktı","leaderboard__personal_best":"Kişisel En İyi","leaderboard__global_rank":"K\xfcresel Sıralama","leaderboard__rank":"Sıralama","leaderboard__runs":"Oyunlar","leaderboard__time_played":"Oynama S\xfcresi"}');


var $c45d82b83d3203b2$exports = {};
$c45d82b83d3203b2$exports = JSON.parse('{"error_screen__renderer_failed":"Your graphics card may not support UpTogether! Please try on again on a WebGL2 enabled browser & device.","error_screen__server_maybe_full":"Fout bij het verbinden met de server: de servers zijn mogelijk vol op dit moment, probeer het over een paar minuten opnieuw!","error_screen__maintenance_mode":"UpTogether.io wordt bijgewerkt! Kom over een paar minuten terug om de nieuwe dingen te proberen \uD83C\uDF89","error_screen__client_out_of_date":"Uw gameclient is verouderd! Werk uw gameclient bij naar de nieuwste versie en probeer het opnieuw.","error_screen__invalid_connection":"De server heeft uw gebruiker afgewezen! Probeer het opnieuw.","error_screen__already_logged_in":"Je bent al ingelogd!","error_screen__unknown_reason":"Onbekende verbindingsfout :(","error_screen__disconnected_from_server":"Verbinding verbroken met de server! De servers gaan mogelijk offline voor een update. Probeer het over een paar minuten opnieuw.","heightmarker__to_bottom":"Terug naar beneden!","heightmarker__inspiration_come_far":"Kijk hoever je gekomen bent!","heightmarker__inspiration_keep_going":"Blijf doorgaan!","heightmarker__inspiration_up_up":"Omhoog! omhoog! omhoog!","in_game__secret_edward":"Hallo Edward!","heightmarker__secret_gorillas":"Hoeveel gorilla\'s kun je vinden??","heightmarker__change_character":"Verander karakter","heightmarker__change_name":"Verander naam","heightmarker__change_trail":"Krijg een spoor!","heightmarker__global_leaderboard":"Wereldranglijst","heightmarker__your_stats":"JOUE STATS","heightmarker__game_stats":"SPELSTATS","heightmarker__tutorial_speed":"Snelheid","heightmarker_tutorial_boost":"Boost!","heightmarker__tutorial_climb":"KLIM","heightmarker__tutorial_the_wall":"DE MUUR","heightmarker__tutorial_bouncy":"Stuiterend!","in_game__secret_invis_maze":"Naast de doorgang van het doolhof, aan de linkerkant...","in_game__secret_upside_down_plate":"Spring vooruit vanaf het omgekeerde bord!","in_game__tutorial_start_timer":"Passeer de startlijn om je timer te starten","in_game__tutorial_invis_platforms":"Er zijn onzichtbare platforms!","in_game__how_fast_top":"Hoe snel kun je naar de top komen?","in_game__no_touchy":"NIET AANRAKEN!","in_game__tutorial_running":"Gebruik de linker joystick om te rennen","in_game__tutorial_tap":"Tik","in_game__tutorial_press":"Druk","in_game__tutorial_or":"of","in_game__tutorial__to_jump":"Om te springen","in_game__tutorial__hold":"Vasthouden","in_game__tutorial__jump_repeatedly":"Om herhaaldelijk te springen","in_game__tutorial_wall_climb":"Om muren te beklimmen","in_game__tutorial_while_running":"Terwijl je rent","in_game__tutorial_drag_move_camera":"Sleep het scherm om de camera te verplaatsen","in_game__checkpoint":"Controlepunt!","loading_text__connecting":"Verbinden met de server...","loading_text__splines":"Splines reticuleren","loading_text__tofu":"Tofu marineren","loading_text__corn":"De ma\xefs pellen","loading_text__broccoli":"Bevestigen dat broccoli kleine bomen zijn","loading_text__brussel_sprouts":"Spelers overtuigen dat spruitjes heerlijk zijn","loading_text__secret_sauce":"Het geheime saus toevoegen","loading_text__digesting":"Verteren","loading_text__stirring":"Constant roeren","loading_text__fixing_ice_cream":"De ijsmachine bij McDonald\'s repareren","loading_text__chopping_broccoli":"De broccoli hakken","loading_text__carmelize_apples":"De appels karameliseren","loading_text__water_boil":"Kijken hoe het water kookt","loading_text__filleting_fish":"De vis fileren","loading_text__plating":"Het opmaken","loading_text__garnishing":"Garneren","loading_text__moldy_bits":"Het beschimmelde deel afsnijden","death_block__almost":"Bijna!","death_block__close_one":"Net gemist!","death_block__try_again":"Probeer opnieuw!","death_block__roasted":"Geroosterd!","death_block__burnt":"Verbrand!","death_block__oh_no":"Oh nee!","death_block__grilled":"Gegrild!","death_block__blanched":"Gebalanceerd!","death_block__crisp":"Krokant!","death_block__flameed":"Flamb\xe9ed!","death_block__order_up":"Bestelling klaar!","death_block__ouch":"Au!","death_block__good_try":"Goed geprobeerd!","death_block__baked":"Gebakken!","death_block__crusty":"Krokant!","death_block__next_time":"Volgende keer!","death_block__toast":"Je bent toast!","death_block__no_chef":"Geen chef-kok!","death_block__singe_left":"Net een beetje geschroeid aan de linkerkant!","death_block__oof":"Oof!","death_block__fried":"Gestruikeld en gebakken!","death_block__recipe_ruined":"Recept verpest","death_block__sizzling_stop":"Een sissend einde!","death_block__defeated":"Chef verslagen!","death_block__burnt_out":"Opgebrand?","death_block__meltdown":"Een meltdown?","falling_death__slippery":"Glad!","falling_death__gg":"GG","falling_death__you_died":"Je bent dood ","falling_death__f":"F","falling_death__floor_food":"Eten op de vloer!","falling_death__three_second":"Drie seconden regel!","falling_death__floor_seasoning":"Mmm! Kruiden van de vloer!","falling_death__just_missed":"Net gemist!","falling_death__rip":"Rust in vrede","falling_death__floor_vs_flavor":"Vloer: 1","falling_death__floor_fall":"Vloerfout!","falling_death__saucy_slip":"Smaakvolle uitglijder!","falling_death__fried_fell":"Gefrituurd en gevallen!","falling_death__dive":"Smaakloze duik!","falling_death__floor_finish":"Afwerking op de vloer!","falling_death__dinner_dive":"Dinerduik!","falling_death__splat":"SPLAT!","falling_death__oops":"Oeps","falling_death__greasy_spot":"Je hebt de vette plek gevonden!","falling_death__barely_missed":"Net gemist!","falling_death__down_we_go":"Daar gaan we!","button__play":"Spelen!","restart__title":"Opnieuw beginnen?","restart__are_you_sure":"Weet je zeker dat je je run opnieuw wilt starten?","restart__confirm":"Ja!","restart__restarted":"Opnieuw gestart...","leaderboard__players":"Spelers","leaderboard__countries":"Landen","leaderboard__falls":"Vallen","leaderboard__hours_played":"Uren Gespeeld","leaderboard__got_to_top":"Bereikte de Top","leaderboard__personal_best":"Persoonlijk Record","leaderboard__global_rank":"Wereldwijde Rang","leaderboard__rank":"Rang","leaderboard__runs":"Spelrondes","leaderboard__time_played":"Speeltijd"}');


const $34a8d0dc3ef4dba1$export$e0b46b07fd1bee3a = {
    en: (0, (/*@__PURE__*/$parcel$interopDefault($1eadb401cb193ffc$exports))),
    zh: (0, (/*@__PURE__*/$parcel$interopDefault($90b051267d834e3d$exports))),
    ar: (0, (/*@__PURE__*/$parcel$interopDefault($0556b2ed0e519737$exports))),
    es: (0, (/*@__PURE__*/$parcel$interopDefault($b60fd03912d0afb0$exports))),
    hi: (0, (/*@__PURE__*/$parcel$interopDefault($34f6e14445e3d74f$exports))),
    pt: (0, (/*@__PURE__*/$parcel$interopDefault($19b1f9c4a098e17a$exports))),
    de: (0, (/*@__PURE__*/$parcel$interopDefault($eb18c263345b47ff$exports))),
    ja: (0, (/*@__PURE__*/$parcel$interopDefault($21e197ee41b1ee82$exports))),
    fr: (0, (/*@__PURE__*/$parcel$interopDefault($ddfc218cb7319592$exports))),
    tr: (0, (/*@__PURE__*/$parcel$interopDefault($7f848ada164f27df$exports))),
    nl: (0, (/*@__PURE__*/$parcel$interopDefault($c45d82b83d3203b2$exports)))
};
const $34a8d0dc3ef4dba1$export$625550452a3fa3ec = (key)=>{
    let language;
    // @ts-ignore
    if (globalThis.Lang === undefined || globalThis.Lang === null) // @ts-ignore
    globalThis.Lang = "en";
    // @ts-ignore
    if ($34a8d0dc3ef4dba1$export$e0b46b07fd1bee3a[globalThis.Lang]) // @ts-ignore
    language = globalThis.Lang;
    else language = "en";
    let string;
    if ($34a8d0dc3ef4dba1$export$e0b46b07fd1bee3a[language][key] || $34a8d0dc3ef4dba1$export$e0b46b07fd1bee3a[language][key] === "") string = $34a8d0dc3ef4dba1$export$e0b46b07fd1bee3a[language][key];
    else string = $34a8d0dc3ef4dba1$export$e0b46b07fd1bee3a["en"][key];
    return string;
};
const $34a8d0dc3ef4dba1$export$7c92b501c50b26dd = (key)=>{
    const language = "en";
    let string;
    if ($34a8d0dc3ef4dba1$export$e0b46b07fd1bee3a[language][key] || $34a8d0dc3ef4dba1$export$e0b46b07fd1bee3a[language][key] === "") string = $34a8d0dc3ef4dba1$export$e0b46b07fd1bee3a[language][key];
    else string = "{{ MISSING TRANSLATION }}";
    return string;
};


function $58ff041f00ca7e33$var$truncateString(inputString, limit) {
    if (inputString.length <= limit) return inputString; // No need to truncate
    else return inputString.substring(0, limit) + "...";
}
class $58ff041f00ca7e33$var$ThirdPersonCamera {
    UpdateCameraAngles(mouseMovementX, mouseMovementY) {
        const { MOUSE_SENSITIVITY: MOUSE_SENSITIVITY, PER_FRAME_MOVEMENT_CAP: PER_FRAME_MOVEMENT_CAP } = (0, $b80b6e4c153785d9$export$29cd7b75162a9425).Camera;
        this.verticalAngle += (0, $5LCsG.clamp)(mouseMovementY * MOUSE_SENSITIVITY * this.yOffsetMultiplier, -PER_FRAME_MOVEMENT_CAP, PER_FRAME_MOVEMENT_CAP);
        this.verticalAngle = (0, $5LCsG.clamp)(this.verticalAngle, (0, $19fa45bc88c77393$export$e6bfdeff8bfc94f9)(-40), (0, $19fa45bc88c77393$export$e6bfdeff8bfc94f9)(80));
        this.lateralAngle += (0, $5LCsG.clamp)(mouseMovementX * MOUSE_SENSITIVITY, -PER_FRAME_MOVEMENT_CAP, PER_FRAME_MOVEMENT_CAP);
        while(this.lateralAngle >= Math.PI * 2)this.lateralAngle -= Math.PI * 2;
        while(this.lateralAngle < 0)this.lateralAngle += Math.PI * 2;
    }
    UpdateCameraPosition() {
        const direction = new (0, $9014d97cd777be10$export$64b5c384219d3699)();
        direction.x = Math.cos(this.lateralAngle - Math.PI / 2) * Math.cos(this.verticalAngle);
        direction.y = Math.sin(this.verticalAngle);
        direction.z = Math.sin(this.lateralAngle - Math.PI / 2) * Math.cos(this.verticalAngle);
        let distance = this.dist;
        if ((0, $b80b6e4c153785d9$export$29cd7b75162a9425).Camera.RAYCAST_CAMERA) {
            const raycastResult = Game.Collision.CheckRayCollisions(this.target.position, direction);
            if (raycastResult.hit) distance = (0, $5LCsG.clamp)(raycastResult.hitPoint.sub(this.target.position).length() - 1, 1, this.dist);
        }
        this.currentPosition.x = this.target.position.x + direction.x * distance;
        this.currentPosition.y = this.target.position.y + direction.y * distance;
        this.currentPosition.z = this.target.position.z + direction.z * distance;
    }
    UpdateTarget(newTarget) {
        this.target.clear();
        this.target.removeFromParent();
        this.target = newTarget;
    }
    GetCameraAngle() {
        return {
            lateral: this.lateralAngle,
            vertical: this.verticalAngle
        };
    }
    SetCameraAngle(lateral, vertical) {
        this.lateralAngle = lateral;
        this.verticalAngle = vertical;
    }
    Update(__deltaTimeS) {
        const idealLookAt = new (0, $9014d97cd777be10$export$64b5c384219d3699)(this.target.position.x, this.target.position.y, this.target.position.z);
        this.UpdateCameraPosition();
        this.currentlyLookingAt.copy(idealLookAt);
        this.threeCamera.position.copy(this.currentPosition);
        this.threeCamera.lookAt(this.currentlyLookingAt);
    }
    constructor(camera){
        this.currentPosition = new (0, $9014d97cd777be10$export$64b5c384219d3699)();
        this.currentlyLookingAt = new (0, $9014d97cd777be10$export$64b5c384219d3699)();
        this.dist = (0, $b80b6e4c153785d9$export$29cd7b75162a9425).Camera.STARTING_DISTANCE // @sam we are currently using this instead of the horizontal offset from config.
        ;
        this.lateralAngle = 0;
        this.verticalAngle = (0, $b80b6e4c153785d9$export$29cd7b75162a9425).Camera.STARTING_ANGLE * (Math.PI / 180);
        this.yOffsetMultiplier = 1.5;
        this.threeCamera = camera;
        this.target = new (0, $9014d97cd777be10$export$e4dd07dff30cc924)();
    }
}
class $58ff041f00ca7e33$var$TutorialObj {
}
class $58ff041f00ca7e33$export$b0d73695eb527f91 extends (0, $fc7b18e354612676$export$5d53140180d567a1) {
    _drawGlobalStats(totalPlayers, totalCountries, totalDeaths, totalCompletions, totalHoursPlayed) {
        // total # of players
        const totalPlayersValue = new (0, $55f5ea5649168877$export$5f1af8db9871e1d6)();
        totalPlayersValue.textAlign = "center";
        totalPlayersValue.position.set(98, 18, 1);
        totalPlayersValue.rotation.set(0, Math.PI, 0);
        totalPlayersValue.outlineOffsetX = 0.01;
        totalPlayersValue.outlineOffsetY = 0.01;
        totalPlayersValue.font = this.fontLocation;
        totalPlayersValue.text = totalPlayers.toLocaleString();
        totalPlayersValue.fontSize = this.leaderboardBigTextSize;
        totalPlayersValue.color = 0xffffff;
        this.scene.add(totalPlayersValue);
        const totalPlayersLabel = new (0, $55f5ea5649168877$export$5f1af8db9871e1d6)();
        totalPlayersLabel.textAlign = "center";
        totalPlayersLabel.position.set(92.5, 14.7, 1);
        totalPlayersLabel.rotation.set(0, Math.PI, 0);
        totalPlayersLabel.outlineOffsetX = 0.01;
        totalPlayersLabel.outlineOffsetY = 0.01;
        totalPlayersLabel.font = this.fontLocation;
        totalPlayersLabel.text = (0, $34a8d0dc3ef4dba1$export$625550452a3fa3ec)("leaderboard__players");
        totalPlayersLabel.fontSize = this.defaultTextSize;
        totalPlayersLabel.color = 0xffffff;
        this.scene.add(totalPlayersLabel);
        // # of countries
        const totalCountriesValue = new (0, $55f5ea5649168877$export$5f1af8db9871e1d6)();
        totalCountriesValue.textAlign = "center";
        totalCountriesValue.position.set(99, 12, 1);
        totalCountriesValue.rotation.set(0, Math.PI, 0);
        totalCountriesValue.outlineOffsetX = 0.01;
        totalCountriesValue.outlineOffsetY = 0.01;
        totalCountriesValue.font = this.fontLocation;
        totalCountriesValue.text = totalCountries.toLocaleString();
        totalCountriesValue.fontSize = this.leaderboardBigTextSize * 0.75;
        totalCountriesValue.color = 0xffffff;
        this.scene.add(totalCountriesValue);
        const totalCountriesLabel = new (0, $55f5ea5649168877$export$5f1af8db9871e1d6)();
        totalCountriesLabel.position.set(100.2, 9.5, 1);
        totalCountriesLabel.rotation.set(0, Math.PI, 0);
        totalCountriesLabel.outlineOffsetX = 0.01;
        totalCountriesLabel.outlineOffsetY = 0.01;
        totalCountriesLabel.font = this.fontLocation;
        totalCountriesLabel.text = (0, $34a8d0dc3ef4dba1$export$625550452a3fa3ec)("leaderboard__countries");
        totalCountriesLabel.fontSize = this.defaultTextSize;
        totalCountriesLabel.color = 0xffffff;
        this.scene.add(totalCountriesLabel);
        // total # of deaths
        const totalFallsValue = new (0, $55f5ea5649168877$export$5f1af8db9871e1d6)();
        totalFallsValue.textAlign = "center";
        totalFallsValue.position.set(90.8, 12, 1);
        totalFallsValue.rotation.set(0, Math.PI, 0);
        totalFallsValue.outlineOffsetX = 0.01;
        totalFallsValue.outlineOffsetY = 0.01;
        totalFallsValue.font = this.fontLocation;
        totalFallsValue.text = totalDeaths.toLocaleString();
        totalFallsValue.fontSize = this.leaderboardBigTextSize * 0.75;
        totalFallsValue.color = 0xffffff;
        this.scene.add(totalFallsValue);
        const totalFallsLabel = new (0, $55f5ea5649168877$export$5f1af8db9871e1d6)();
        totalFallsLabel.textAlign = "center";
        totalFallsLabel.position.set(86.2, 9.5, 1);
        totalFallsLabel.rotation.set(0, Math.PI, 0);
        totalFallsLabel.outlineOffsetX = 0.01;
        totalFallsLabel.outlineOffsetY = 0.01;
        totalFallsLabel.font = this.fontLocation;
        totalFallsLabel.text = (0, $34a8d0dc3ef4dba1$export$625550452a3fa3ec)("leaderboard__falls");
        totalFallsLabel.fontSize = this.defaultTextSize;
        totalFallsLabel.color = 0xffffff;
        this.scene.add(totalFallsLabel);
        // total # of completions
        const totalCompletionsValue = new (0, $55f5ea5649168877$export$5f1af8db9871e1d6)();
        totalCompletionsValue.textAlign = "center";
        totalCompletionsValue.position.set(88.3, 6, 1);
        totalCompletionsValue.rotation.set(0, Math.PI, 0);
        totalCompletionsValue.outlineOffsetX = 0.01;
        totalCompletionsValue.outlineOffsetY = 0.01;
        totalCompletionsValue.font = this.fontLocation;
        totalCompletionsValue.text = totalCompletions.toLocaleString();
        totalCompletionsValue.fontSize = this.leaderboardBigTextSize * 0.75;
        totalCompletionsValue.color = 0xffffff;
        this.scene.add(totalCompletionsValue);
        const totalCompletionsLabel = new (0, $55f5ea5649168877$export$5f1af8db9871e1d6)();
        totalCompletionsLabel.textAlign = "center";
        totalCompletionsLabel.position.set(88.3, 3.5, 1);
        totalCompletionsLabel.rotation.set(0, Math.PI, 0);
        totalCompletionsLabel.outlineOffsetX = 0.01;
        totalCompletionsLabel.outlineOffsetY = 0.01;
        totalCompletionsLabel.font = this.fontLocation;
        totalCompletionsLabel.text = (0, $34a8d0dc3ef4dba1$export$625550452a3fa3ec)("leaderboard__got_to_top");
        totalCompletionsLabel.fontSize = this.defaultTextSize;
        totalCompletionsLabel.color = 0xffffff;
        this.scene.add(totalCompletionsLabel);
        // # of time played
        const totalTimePlayedValue = new (0, $55f5ea5649168877$export$5f1af8db9871e1d6)();
        totalTimePlayedValue.textAlign = "center";
        totalTimePlayedValue.position.set(101.8, 6, 1);
        totalTimePlayedValue.rotation.set(0, Math.PI, 0);
        totalTimePlayedValue.outlineOffsetX = 0.01;
        totalTimePlayedValue.outlineOffsetY = 0.01;
        totalTimePlayedValue.font = this.fontLocation;
        totalTimePlayedValue.text = totalHoursPlayed.toLocaleString();
        totalTimePlayedValue.fontSize = this.leaderboardBigTextSize * 0.75;
        totalTimePlayedValue.color = 0xffffff;
        this.scene.add(totalTimePlayedValue);
        const totalTimePlayedLabel = new (0, $55f5ea5649168877$export$5f1af8db9871e1d6)();
        totalTimePlayedLabel.position.set(101.2, 3.5, 1);
        totalTimePlayedLabel.rotation.set(0, Math.PI, 0);
        totalTimePlayedLabel.outlineOffsetX = 0.01;
        totalTimePlayedLabel.outlineOffsetY = 0.01;
        totalTimePlayedLabel.font = this.fontLocation;
        totalTimePlayedLabel.text = (0, $34a8d0dc3ef4dba1$export$625550452a3fa3ec)("leaderboard__hours_played");
        totalTimePlayedLabel.fontSize = this.defaultTextSize;
        totalTimePlayedLabel.color = 0xffffff;
        this.scene.add(totalTimePlayedLabel);
    }
    _drawPersonalStats(pb, globalRank, countryRank, deaths, runs, timePlayed, country) {
        // your best run
        const bestRunValue = new (0, $55f5ea5649168877$export$5f1af8db9871e1d6)();
        bestRunValue.textAlign = "center";
        const xPos1 = pb === "None yet!" ? 82 : 82.5;
        bestRunValue.position.set(xPos1, 18, -52);
        bestRunValue.outlineOffsetX = 0.01;
        bestRunValue.outlineOffsetY = 0.01;
        bestRunValue.font = this.fontLocation;
        bestRunValue.text = pb;
        bestRunValue.fontSize = this.leaderboardBigTextSize;
        bestRunValue.color = 0xffffff;
        this.scene.add(bestRunValue);
        const bestRunLabel = new (0, $55f5ea5649168877$export$5f1af8db9871e1d6)();
        bestRunLabel.textAlign = "center";
        bestRunLabel.position.set(86.5, 15, -52);
        bestRunLabel.outlineOffsetX = 0.01;
        bestRunLabel.outlineOffsetY = 0.01;
        bestRunLabel.font = this.fontLocation;
        bestRunLabel.text = (0, $34a8d0dc3ef4dba1$export$625550452a3fa3ec)("leaderboard__personal_best");
        bestRunLabel.fontSize = this.defaultTextSize;
        bestRunLabel.color = 0xffffff;
        this.scene.add(bestRunLabel);
        // your global rank
        const yourGlobalRankValue = new (0, $55f5ea5649168877$export$5f1af8db9871e1d6)();
        yourGlobalRankValue.textAlign = "center";
        const xPos2 = globalRank === "N/A" ? 83 : 84;
        yourGlobalRankValue.position.set(xPos2, 13, -52);
        yourGlobalRankValue.outlineOffsetX = 0.01;
        yourGlobalRankValue.outlineOffsetY = 0.01;
        yourGlobalRankValue.font = this.fontLocation;
        yourGlobalRankValue.text = globalRank;
        yourGlobalRankValue.fontSize = this.leaderboardBigTextSize;
        yourGlobalRankValue.color = 0xffffff;
        this.scene.add(yourGlobalRankValue);
        const yourGlobalRankLabel = new (0, $55f5ea5649168877$export$5f1af8db9871e1d6)();
        yourGlobalRankLabel.textAlign = "center";
        if (globalThis.Lang === "nl" || globalThis.Lang === "pt" || globalThis.Lang === "fr") yourGlobalRankLabel.position.set(82.6 + 3 * this.globalXOffset, 10, -52);
        else yourGlobalRankLabel.position.set(82.6, 10, -52);
        yourGlobalRankLabel.outlineOffsetX = 0.01;
        yourGlobalRankLabel.outlineOffsetY = 0.01;
        yourGlobalRankLabel.font = this.fontLocation;
        yourGlobalRankLabel.text = (0, $34a8d0dc3ef4dba1$export$625550452a3fa3ec)("leaderboard__global_rank");
        yourGlobalRankLabel.fontSize = this.defaultTextSize;
        yourGlobalRankLabel.color = 0xffffff;
        this.scene.add(yourGlobalRankLabel);
        // your country rank
        const yourCountryRankValue = new (0, $55f5ea5649168877$export$5f1af8db9871e1d6)();
        yourCountryRankValue.textAlign = "center";
        const xPos3 = countryRank === "N/A" ? 93 : 94;
        yourCountryRankValue.position.set(xPos3, 13, -52);
        yourCountryRankValue.outlineOffsetX = 0.01;
        yourCountryRankValue.outlineOffsetY = 0.01;
        yourCountryRankValue.font = this.fontLocation;
        yourCountryRankValue.text = countryRank;
        yourCountryRankValue.fontSize = this.leaderboardBigTextSize;
        yourCountryRankValue.color = 0xffffff;
        this.scene.add(yourCountryRankValue);
        const yourCountryRankLabel = new (0, $55f5ea5649168877$export$5f1af8db9871e1d6)();
        yourCountryRankLabel.textAlign = "center";
        yourCountryRankLabel.position.set(95.6, 10, -52);
        yourCountryRankLabel.outlineOffsetX = 0.01;
        yourCountryRankLabel.outlineOffsetY = 0.01;
        yourCountryRankLabel.font = this.fontLocation;
        yourCountryRankLabel.text = (0, $34a8d0dc3ef4dba1$export$625550452a3fa3ec)("leaderboard__rank");
        yourCountryRankLabel.fontSize = this.defaultTextSize;
        yourCountryRankLabel.color = 0xffffff;
        this.scene.add(yourCountryRankLabel);
        const usersCountryFlagTexture = Game.Loader.TextureLoader.load("ui/flags/" + (0, $88639450953f4f02$export$3d7cd691481bade)(country) + ".png");
        usersCountryFlagTexture.colorSpace = (0, $9014d97cd777be10$export$561f394b24edfcaa);
        const usersCountryFlagGeo = new (0, $9014d97cd777be10$export$967d831af31f69ce)(this.leaderBoardFlagHorizontalSize * 1.5, this.leaderBoardFlagVerticalSize * 1.5);
        const usersCountryMaterial = new (0, $9014d97cd777be10$export$55cbcc9b622fe1f5)({
            map: usersCountryFlagTexture,
            transparent: true,
            alphaTest: 0.5
        });
        const usersCountryMesh = new (0, $9014d97cd777be10$export$e176487c05830cc5)(usersCountryFlagGeo, usersCountryMaterial);
        usersCountryMesh.position.set(94.2, 9.5, -52);
        this.scene.add(usersCountryMesh);
        // your # of falls
        const yourFallsValue = new (0, $55f5ea5649168877$export$5f1af8db9871e1d6)();
        yourFallsValue.textAlign = "center";
        const xPos4 = deaths === "0" ? 80.4 : 78.3;
        yourFallsValue.position.set(xPos4, 6, -52);
        yourFallsValue.outlineOffsetX = 0.01;
        yourFallsValue.outlineOffsetY = 0.01;
        yourFallsValue.font = this.fontLocation;
        yourFallsValue.text = deaths;
        yourFallsValue.fontSize = this.leaderboardBigTextSize * 0.75;
        yourFallsValue.color = 0xffffff;
        this.scene.add(yourFallsValue);
        const yourFallsLabel = new (0, $55f5ea5649168877$export$5f1af8db9871e1d6)();
        yourFallsLabel.textAlign = "center";
        yourFallsLabel.position.set(79.2, 3.3, -52);
        yourFallsLabel.outlineOffsetX = 0.01;
        yourFallsLabel.outlineOffsetY = 0.01;
        yourFallsLabel.font = this.fontLocation;
        yourFallsLabel.text = (0, $34a8d0dc3ef4dba1$export$625550452a3fa3ec)("leaderboard__falls");
        yourFallsLabel.fontSize = this.defaultTextSize;
        yourFallsLabel.color = 0xffffff;
        this.scene.add(yourFallsLabel);
        // your completions
        const yourCompletionsValue = new (0, $55f5ea5649168877$export$5f1af8db9871e1d6)();
        yourCompletionsValue.textAlign = "center";
        const xPos5 = runs === "0" ? 86.6 : 86.3;
        yourCompletionsValue.position.set(xPos5, 6, -52);
        yourCompletionsValue.outlineOffsetX = 0.01;
        yourCompletionsValue.outlineOffsetY = 0.01;
        yourCompletionsValue.font = this.fontLocation;
        yourCompletionsValue.text = runs;
        yourCompletionsValue.fontSize = this.leaderboardBigTextSize * 0.75;
        yourCompletionsValue.color = 0xffffff;
        this.scene.add(yourCompletionsValue);
        const yourCompletionsLabel = new (0, $55f5ea5649168877$export$5f1af8db9871e1d6)();
        yourCompletionsLabel.textAlign = "center";
        yourCompletionsLabel.position.set(86.2, 3.3, -52);
        yourCompletionsLabel.outlineOffsetX = 0.01;
        yourCompletionsLabel.outlineOffsetY = 0.01;
        yourCompletionsLabel.font = this.fontLocation;
        yourCompletionsLabel.text = (0, $34a8d0dc3ef4dba1$export$625550452a3fa3ec)("leaderboard__runs");
        yourCompletionsLabel.fontSize = this.defaultTextSize;
        yourCompletionsLabel.color = 0xffffff;
        this.scene.add(yourCompletionsLabel);
        // your time played
        const yourTimePlayedValue = new (0, $55f5ea5649168877$export$5f1af8db9871e1d6)();
        yourTimePlayedValue.textAlign = "center";
        yourTimePlayedValue.position.set(91.3, 6, -52);
        yourTimePlayedValue.outlineOffsetX = 0.01;
        yourTimePlayedValue.outlineOffsetY = 0.01;
        yourTimePlayedValue.font = this.fontLocation;
        yourTimePlayedValue.text = timePlayed;
        yourTimePlayedValue.fontSize = this.leaderboardBigTextSize * 0.75;
        yourTimePlayedValue.color = 0xffffff;
        this.scene.add(yourTimePlayedValue);
        const yourTimePlayedLabel = new (0, $55f5ea5649168877$export$5f1af8db9871e1d6)();
        yourTimePlayedLabel.textAlign = "center";
        yourTimePlayedLabel.position.set(94.2, 3.3, -52);
        yourTimePlayedLabel.outlineOffsetX = 0.01;
        yourTimePlayedLabel.outlineOffsetY = 0.01;
        yourTimePlayedLabel.font = this.fontLocation;
        yourTimePlayedLabel.text = (0, $34a8d0dc3ef4dba1$export$625550452a3fa3ec)("leaderboard__time_played");
        yourTimePlayedLabel.fontSize = this.defaultTextSize;
        yourTimePlayedLabel.color = 0xffffff;
        this.scene.add(yourTimePlayedLabel);
    }
    _drawLeaderboard() {
        const textureLoader = Game.Loader.TextureLoader;
        const localOffset = new (0, $9014d97cd777be10$export$64b5c384219d3699)();
        const objWorldSpacePos = new (0, $9014d97cd777be10$export$64b5c384219d3699)();
        for(let i = 0; i < this.leaderBoardLength; i++){
            // create a tutorialObj that holds this row of data
            const thisLeaderboardEntry = new $58ff041f00ca7e33$var$TutorialObj();
            thisLeaderboardEntry.pos = new (0, $9014d97cd777be10$export$64b5c384219d3699)(this.leaderBoardPosition.x, this.leaderBoardPosition.y - i * this.leaderBoardVerticalOffset, this.leaderBoardPosition.z);
            thisLeaderboardEntry.rot = new (0, $9014d97cd777be10$export$64b5c384219d3699)(0, Math.PI * this.leaderBoardRotationAsMultipleOfPI, 0);
            thisLeaderboardEntry.images = [];
            thisLeaderboardEntry.texts = [];
            // create a text object for the row #
            const leaderBoardNumberText = new (0, $55f5ea5649168877$export$5f1af8db9871e1d6)();
            leaderBoardNumberText.outlineOffsetX = 0.01;
            leaderBoardNumberText.outlineOffsetY = 0.01;
            leaderBoardNumberText.font = this.fontLocation;
            leaderBoardNumberText.text = (i + 1).toString();
            leaderBoardNumberText.fontSize = this.defaultTextSize;
            localOffset.set(0, 0.45, 0);
            objWorldSpacePos.copy(this._getPosLocalToTutorialObj(localOffset, thisLeaderboardEntry));
            leaderBoardNumberText.position.copy(objWorldSpacePos);
            leaderBoardNumberText.rotation.set(thisLeaderboardEntry.rot.x, thisLeaderboardEntry.rot.y, thisLeaderboardEntry.rot.z);
            leaderBoardNumberText.color = 0xffffff;
            thisLeaderboardEntry.texts.push(leaderBoardNumberText);
            // create an image that will hold the flag for this row
            const thisLeaderBoardTexture = textureLoader.load("ui/flags/none.png");
            thisLeaderBoardTexture.colorSpace = (0, $9014d97cd777be10$export$561f394b24edfcaa);
            const thisLeaderBoardGeometry = new (0, $9014d97cd777be10$export$967d831af31f69ce)(this.leaderBoardFlagHorizontalSize, this.leaderBoardFlagVerticalSize); // Adjust the size as needed
            const thisLeaderBoardMaterial = new (0, $9014d97cd777be10$export$55cbcc9b622fe1f5)({
                map: thisLeaderBoardTexture,
                transparent: true,
                alphaTest: 0.5
            });
            const thisLeaderBoardImg = new (0, $9014d97cd777be10$export$e176487c05830cc5)(thisLeaderBoardGeometry, thisLeaderBoardMaterial);
            localOffset.set(2.1, 0, 0);
            objWorldSpacePos.copy(this._getPosLocalToTutorialObj(localOffset, thisLeaderboardEntry));
            thisLeaderBoardImg.position.copy(objWorldSpacePos);
            thisLeaderBoardImg.rotation.set(thisLeaderboardEntry.rot.x, thisLeaderboardEntry.rot.y, thisLeaderboardEntry.rot.z);
            thisLeaderboardEntry.images.push(thisLeaderBoardImg);
            // create a text object for the row's player name
            const leaderBoardNameText = new (0, $55f5ea5649168877$export$5f1af8db9871e1d6)();
            leaderBoardNameText.outlineOffsetX = 0.01;
            leaderBoardNameText.outlineOffsetY = 0.01;
            leaderBoardNameText.font = this.fontLocation;
            leaderBoardNameText.text = "Loading...";
            leaderBoardNameText.fontSize = this.defaultTextSize;
            localOffset.set(3.2, 0.45, 0);
            objWorldSpacePos.copy(this._getPosLocalToTutorialObj(localOffset, thisLeaderboardEntry));
            leaderBoardNameText.position.copy(objWorldSpacePos);
            leaderBoardNameText.rotation.set(thisLeaderboardEntry.rot.x, thisLeaderboardEntry.rot.y, thisLeaderboardEntry.rot.z);
            leaderBoardNameText.color = 0xffffff;
            thisLeaderboardEntry.texts.push(leaderBoardNameText);
            // create a text object for the row's time (score)
            const leaderBoardTimeText = new (0, $55f5ea5649168877$export$5f1af8db9871e1d6)();
            leaderBoardTimeText.outlineOffsetX = 0.01;
            leaderBoardTimeText.outlineOffsetY = 0.01;
            leaderBoardTimeText.font = this.fontLocation;
            leaderBoardTimeText.textAlign = "right";
            leaderBoardTimeText.anchorX = "right";
            leaderBoardTimeText.text = "99:99.999";
            leaderBoardTimeText.fontSize = this.defaultTextSize;
            localOffset.set(26.25, 0.45, 0);
            objWorldSpacePos.copy(this._getPosLocalToTutorialObj(localOffset, thisLeaderboardEntry));
            leaderBoardTimeText.position.copy(objWorldSpacePos);
            leaderBoardTimeText.rotation.set(thisLeaderboardEntry.rot.x, thisLeaderboardEntry.rot.y, thisLeaderboardEntry.rot.z);
            leaderBoardTimeText.color = 0xffffff;
            thisLeaderboardEntry.texts.push(leaderBoardTimeText);
            this.leaderBoard.push(thisLeaderboardEntry);
            this.scene.add(thisLeaderBoardImg);
            this.scene.add(leaderBoardNumberText);
            this.scene.add(leaderBoardNameText);
            this.scene.add(leaderBoardTimeText);
        }
    }
    UpdateLeaderboard(leaderboardString) {
        try {
            const parsed = JSON.parse(leaderboardString);
            // console.log("@@@ Parsed leaderboard from server:", parsed);
            const { topTen: topTen, globalStats: globalStats } = parsed;
            for(let i = 0; i < topTen.length; i++){
                const { username: username, durationString: durationString, country: country } = topTen[i];
                const thisLeaderboardEntry = this.leaderBoard[i];
                if (thisLeaderboardEntry === undefined) continue;
                // Update the flag
                const currentImage = thisLeaderboardEntry.images[0];
                if (currentImage === undefined) {
                    console.error("Leaderboard image undefined at index:", i);
                    continue;
                }
                const newTexture = Game.Loader.TextureLoader.load("ui/flags/" + (0, $88639450953f4f02$export$3d7cd691481bade)(country) + ".png");
                // @ts-ignore
                currentImage.material.map = newTexture;
                // @ts-ignore
                currentImage.material.needsUpdate = true;
                // Update the name text
                const currentNameText = thisLeaderboardEntry.texts[1];
                if (currentNameText === undefined) {
                    console.error("Leaderboard name text undefined at index:", i);
                    continue;
                }
                currentNameText.text = username;
                // Update the time text
                const currentTimeText = thisLeaderboardEntry.texts[2];
                if (currentTimeText === undefined) {
                    console.error("Leaderboard time text undefined at index:", i);
                    continue;
                }
                currentTimeText.text = durationString;
            }
            this._drawGlobalStats(globalStats.totalPlayers, globalStats.totalCountries, globalStats.totalDeaths, globalStats.totalCompletions, globalStats.totalHoursPlayed);
        } catch (e) {
            console.error("Caught error parsing leaderboard from server!", e, leaderboardString);
        }
    }
    UpdateLocalEntityRotation(rotX, rotY, rotZ) {
        if ((0, $b80b6e4c153785d9$export$29cd7b75162a9425).Player.ENABLE_PREDICTION) {
            if (this.MyLocalPredictedEntity !== undefined) {
                this.MyLocalPredictedEntity.Rotation.x = rotX;
                this.MyLocalPredictedEntity.Rotation.y = rotY;
                this.MyLocalPredictedEntity.Rotation.z = rotZ;
            }
        } else if (this.MyLocalNonPredictedEntity !== undefined) {
            this.MyLocalNonPredictedEntity.Rotation.x = rotX;
            this.MyLocalNonPredictedEntity.Rotation.y = rotY;
            this.MyLocalNonPredictedEntity.Rotation.z = rotZ;
        }
    }
    _addDebugCube(startX, startY, startZ) {
        const geometry = new (0, $9014d97cd777be10$export$33e43285f7406bd5)(1, 1, 1);
        const material = new (0, $9014d97cd777be10$export$f2980790215acccd)({
            color: 0xff00ff,
            wireframe: true
        });
        this.PlayerRotationProxyCube = new (0, $9014d97cd777be10$export$e176487c05830cc5)(geometry, material);
        this.PlayerRotationProxyCube.position.set(startX, startY, startZ);
        if ((0, $b80b6e4c153785d9$export$29cd7b75162a9425).Camera.DRAW_CAMERA_TARGET_CUBE) Game.Renderer.AddModelToScene(this.PlayerRotationProxyCube);
    }
    CountSceneVerts() {
        let totalVertices = 0;
        this.scene.traverse((object)=>{
            if (object instanceof (0, $9014d97cd777be10$export$e176487c05830cc5)) {
                const geometry = object.geometry;
                if (geometry instanceof (0, $9014d97cd777be10$export$b7be63a67df8959)) // For BufferGeometry, get the number of vertices directly
                totalVertices += geometry.attributes.position.count;
                else if (geometry instanceof geometry) // For Geometry, count the number of vertices in the vertices array
                totalVertices += geometry.vertices.length;
            }
        });
        console.log(`Total vertices in the scene: ${totalVertices}`);
    }
    Initialize() {
        this._initThreeRenderer();
        if ((0, $b80b6e4c153785d9$export$29cd7b75162a9425).Rendering.ENABLE_STATS) this._initPerformanceStats();
        if (globalThis.Lang === "en") {
            this.globalXOffset = 0;
            this.globalYOffset = 0;
        } else if (globalThis.Lang === "es") {
            this.globalXOffset = -1;
            this.globalYOffset = 0;
        } else if (globalThis.Lang === "hi") {
            this.globalXOffset = 0;
            this.globalYOffset = 0.5;
        } else if (globalThis.Lang === "zh") {
            this.globalXOffset = 0;
            this.globalYOffset = 0;
        } else if (globalThis.Lang === "ar") {
            this.globalXOffset = 0;
            this.globalYOffset = 1;
        } else if (globalThis.Lang === "pt") {
            this.globalXOffset = -1;
            this.globalYOffset = 0;
        } else if (globalThis.Lang === "ja") {
            this.globalXOffset = -1;
            this.globalYOffset = 0;
        } else if (globalThis.Lang === "tr") {
            this.globalXOffset = -0.7;
            this.globalYOffset = 0;
        } else if (globalThis.Lang === "fr") {
            this.globalXOffset = -1;
            this.globalYOffset = 0;
        } else if (globalThis.Lang === "nl") {
            this.globalXOffset = -1;
            this.globalYOffset = 0;
        } else if (globalThis.Lang === "de") {
            this.globalXOffset = -0.85;
            this.globalYOffset = 0;
        }
        this._light();
        // @ts-ignore
        if (globalThis.IsMobile) this._drawTutorialTextMobile();
        else this._drawTutorialTextBrowser();
        this._drawHeightMarkers();
        this._drawLeaderboard();
        // @ts-ignore
        Game.ListenForEvent("Identity::Identified", ({ identity: identity })=>{
            // console.info("@@@ CLient Renderer got identity....", identity);
            const { PersonalLeaderboardData: PersonalLeaderboardData } = identity;
            const { pb: pb, globalRank: globalRank, countryRank: countryRank, deaths: deaths, runs: runs, timePlayed: timePlayed } = PersonalLeaderboardData;
            this._drawPersonalStats(pb, globalRank, countryRank, deaths, runs, timePlayed, identity.UpTogether.country);
        });
        Game.ListenForEvent("Resizer::RealtimeGameWindowResize", this.Resize.bind(this));
        Game.ListenForEvent("Resizer::GameWindowResizeComplete", this.Resize.bind(this));
        Game.ListenForEvent("Bootstrap::MyEntitiesNidIsKnown", (event)=>{
            const { myId: myId } = event;
            this.MyLocalNonPredictedEntityNid = myId;
        });
        if (!globalThis.IsMobile) document.addEventListener("mousemove", (event)=>{
            if (this.thirdPersonCamera && Game.UI.PointerIsCurrentlyLocked()) {
                this._rotateEmptyBasedOnMouseMovement(event.movementX, event.movementY);
                this.thirdPersonCamera.UpdateCameraAngles(event.movementX, event.movementY);
                this._updatePlayerRotationProxyCubePositionBasedOnMouseMovement(event.movementX, event.movementY);
            }
        });
        window.addEventListener("wheel", (event)=>{
            if (Game.UI.UIScreenIsOpen()) return;
            event.preventDefault();
            this.thirdPersonCamera.dist += event.deltaY * (0, $b80b6e4c153785d9$export$29cd7b75162a9425).Camera.ZOOM_SENSITIVITY;
            this.thirdPersonCamera.dist = (0, $5LCsG.clamp)(this.thirdPersonCamera.dist, (0, $b80b6e4c153785d9$export$29cd7b75162a9425).Camera.MIN_DISTANCE, (0, $b80b6e4c153785d9$export$29cd7b75162a9425).Camera.MAX_DISTANCE);
        });
        if (globalThis.IsMobile) {
            this.renderer.domElement.addEventListener("touchstart", (event)=>{
                event.preventDefault();
                this.touchStartX = event.targetTouches[0].clientX;
                this.touchStartY = event.targetTouches[0].clientY;
                this.currentlyTouchDragging = true;
            });
            this.renderer.domElement.addEventListener("touchmove", (event)=>{
                event.preventDefault();
                const movementX = (event.targetTouches[0].clientX - this.touchStartX) * (0, $b80b6e4c153785d9$export$29cd7b75162a9425).Camera.MOBILE_CAMERA_ROTATION_SENSITIVITY.HORIZONTAL;
                const movementY = (event.targetTouches[0].clientY - this.touchStartY) * (0, $b80b6e4c153785d9$export$29cd7b75162a9425).Camera.MOBILE_CAMERA_ROTATION_SENSITIVITY.VERTICAL;
                this.touchStartX = event.targetTouches[0].clientX;
                this.touchStartY = event.targetTouches[0].clientY;
                if (this.currentlyTouchDragging === false) return;
                if (this.thirdPersonCamera) {
                    this._rotateEmptyBasedOnMouseMovement(movementX, movementY);
                    this.thirdPersonCamera.UpdateCameraAngles(movementX, movementY);
                    this._updatePlayerRotationProxyCubePositionBasedOnMouseMovement(movementX, movementY);
                }
            });
            this.renderer.domElement.addEventListener("touchend", ()=>{
                this.currentlyTouchDragging = false;
            });
        }
        Game.EmitEvent("LoadEvent", {
            eventName: "RendererReady"
        });
        this.particleSystem = new (0, $24a81f8e792b70c8$export$2e2bcd8739ae039)();
        const renderer = new (0, $1f54cd272171758a$export$2e2bcd8739ae039)(this.scene, $9014d97cd777be10$exports);
        this.particleSystem.addRenderer(renderer).emit({
            // eslint-disable-next-line @typescript-eslint/naming-convention
            onStart: ()=>{},
            onUpdate: ()=>{},
            onEnd: ()=>{}
        });
    }
    GetCameraAngle() {
        return this.thirdPersonCamera.GetCameraAngle();
    }
    SetCameraAngle(lateral, vertical) {
        this.thirdPersonCamera.SetCameraAngle(lateral, vertical);
    }
    AddParticleEmitter(emitter) {
        this.particleSystem.addEmitter(emitter);
    }
    RemoveParticleEmitter(emitter) {
        this.particleSystem.removeEmitter(emitter);
    }
    _getPosLocalToTutorialObj(myLocalOffset, tutorial) {
        // Convert degrees to radians (if needed)
        //const euler = tutorial.rot.clone().multiplyScalar(Math.PI / 180);
        // Apply the local offset to the position relative to tutorial.pos
        myLocalOffset.applyEuler(new (0, $9014d97cd777be10$export$d93cc409a0768c5f)(tutorial.rot.x, tutorial.rot.y, tutorial.rot.z, "XYZ"));
        const finalPosition = myLocalOffset.clone().add(tutorial.pos);
        return finalPosition;
    }
    _drawHeightMarkers() {
        const heightMarkers = (0, (/*@__PURE__*/$parcel$interopDefault($dba298545a323f15$exports))).HeightMarkers;
        for (const marker of heightMarkers){
            // Access properties of each marker
            const isNumber = marker.isNumber;
            const position = marker.pos;
            const rotationAsMultOfPi = marker.rotationAsMultOfPi;
            const stringIfNAN = marker.stringIfNAN;
            if (isNumber) {
                const thisMarkerText = new (0, $55f5ea5649168877$export$5f1af8db9871e1d6)();
                thisMarkerText.font = this.fontLocation;
                thisMarkerText.outlineOffsetX = 0.01;
                thisMarkerText.outlineOffsetY = 0.01;
                const yPosTruncated = Math.trunc(position.y);
                thisMarkerText.text = yPosTruncated.toString() + "m";
                thisMarkerText.fontSize = this.defaultTextSize;
                thisMarkerText.position.copy(new (0, $9014d97cd777be10$export$64b5c384219d3699)(-position.x, position.y, position.z));
                thisMarkerText.rotation.set(0, Math.PI * rotationAsMultOfPi, 0);
                thisMarkerText.color = 0xffffff;
                this.scene.add(thisMarkerText);
            } else {
                const thisMarkerText = new (0, $55f5ea5649168877$export$5f1af8db9871e1d6)();
                thisMarkerText.font = this.fontLocation;
                thisMarkerText.outlineOffsetX = 0.01;
                thisMarkerText.outlineOffsetY = 0.01;
                thisMarkerText.text = (0, $34a8d0dc3ef4dba1$export$625550452a3fa3ec)(stringIfNAN);
                thisMarkerText.fontSize = this.defaultTextSize;
                thisMarkerText.position.copy(new (0, $9014d97cd777be10$export$64b5c384219d3699)(-position.x, position.y, position.z));
                thisMarkerText.rotation.set(0, Math.PI * rotationAsMultOfPi, 0);
                thisMarkerText.color = 0xffffff;
                this.scene.add(thisMarkerText);
            }
        }
    }
    _drawTutorialTextBrowser() {
        const localOffset = new (0, $9014d97cd777be10$export$64b5c384219d3699)(0, 0, 0);
        const objWorldSpacePos = new (0, $9014d97cd777be10$export$64b5c384219d3699)(0, 0, 0);
        const uiLocation = "ui/tutorial/";
        const allTutorialObjs = [];
        const textureLoader = Game.Loader.TextureLoader;
        // walk tutorial
        const tutorialWalk = new $58ff041f00ca7e33$var$TutorialObj();
        tutorialWalk.pos = new (0, $9014d97cd777be10$export$64b5c384219d3699)(-4, 2, -94.2);
        tutorialWalk.rot = new (0, $9014d97cd777be10$export$64b5c384219d3699)(0, Math.PI, 0);
        tutorialWalk.images = [];
        tutorialWalk.texts = [];
        // WASD Image
        const wasdTexture = textureLoader.load(uiLocation + "wasd.png");
        wasdTexture.colorSpace = (0, $9014d97cd777be10$export$561f394b24edfcaa);
        const wasdGeometry = new (0, $9014d97cd777be10$export$967d831af31f69ce)(4, 2.8); // Adjust the size as needed
        const wasdMaterial = new (0, $9014d97cd777be10$export$55cbcc9b622fe1f5)({
            map: wasdTexture,
            transparent: true,
            alphaTest: 0.5,
            side: (0, $9014d97cd777be10$export$3b296b6f144d5b03)
        });
        const tutorialWASDImg = new (0, $9014d97cd777be10$export$e176487c05830cc5)(wasdGeometry, wasdMaterial);
        localOffset.set(-3.5, 0, 0);
        objWorldSpacePos.copy(this._getPosLocalToTutorialObj(localOffset, tutorialWalk));
        tutorialWASDImg.position.copy(objWorldSpacePos);
        tutorialWASDImg.rotation.set(tutorialWalk.rot.x, tutorialWalk.rot.y, tutorialWalk.rot.z);
        tutorialWalk.images.push(tutorialWASDImg);
        // arrowkeys Image
        const arrowsTexture = textureLoader.load(uiLocation + "arrow_keys.png");
        arrowsTexture.colorSpace = (0, $9014d97cd777be10$export$561f394b24edfcaa);
        const arrowsGeometry = new (0, $9014d97cd777be10$export$967d831af31f69ce)(4, 2.8); // Adjust the size as needed
        const arrowsMaterial = new (0, $9014d97cd777be10$export$55cbcc9b622fe1f5)({
            map: arrowsTexture,
            transparent: true,
            alphaTest: 0.5,
            side: (0, $9014d97cd777be10$export$3b296b6f144d5b03)
        });
        const tutorialArrowsImage = new (0, $9014d97cd777be10$export$e176487c05830cc5)(arrowsGeometry, arrowsMaterial);
        localOffset.set(3.9, 0, 0);
        objWorldSpacePos.copy(this._getPosLocalToTutorialObj(localOffset, tutorialWalk));
        tutorialArrowsImage.position.copy(objWorldSpacePos);
        tutorialArrowsImage.rotation.set(tutorialWalk.rot.x, tutorialWalk.rot.y, tutorialWalk.rot.z);
        tutorialWalk.images.push(tutorialArrowsImage);
        // slash text
        /*const pressTextWalk = new Text();
        pressTextWalk.font = fontLocation;
        pressTextWalk.text = "/";
        // PRESS text
        const pressTextWalk = new Text();
        pressTextWalk.font = this.fontLocation;
        pressTextWalk.text = "Press";
        pressTextWalk.fontSize = this.defaultTextSize;
        localOffset.set(-6, -0.4, 0);
        objWorldSpacePos.copy(this._getPosLocalToTutorialObj(localOffset, tutorialWalk));
        pressTextWalk.position.copy(objWorldSpacePos);
        pressTextWalk.rotation.set(tutorialWalk.rot.x, tutorialWalk.rot.y, tutorialWalk.rot.z);
        pressTextWalk.color = 0xffffff;
        tutorialWalk.texts.push(pressTextWalk);*/ // OR text
        const toWalkText = new (0, $55f5ea5649168877$export$5f1af8db9871e1d6)();
        toWalkText.outlineOffsetX = 0.01;
        toWalkText.outlineOffsetY = 0.01;
        toWalkText.font = this.fontLocation;
        toWalkText.text = (0, $34a8d0dc3ef4dba1$export$625550452a3fa3ec)("in_game__tutorial_or");
        toWalkText.fontSize = this.defaultTextSize;
        if (globalThis.Lang === "ja" || globalThis.Lang === "de" || globalThis.Lang === "tr") localOffset.set(-0.7 + this.globalXOffset, -0.25 + this.globalYOffset, 0);
        else localOffset.set(-0.7, -0.25 + this.globalYOffset, 0);
        objWorldSpacePos.copy(this._getPosLocalToTutorialObj(localOffset, tutorialWalk));
        toWalkText.position.copy(objWorldSpacePos);
        toWalkText.rotation.set(tutorialWalk.rot.x, tutorialWalk.rot.y, tutorialWalk.rot.z);
        toWalkText.color = 0xffffff;
        tutorialWalk.texts.push(toWalkText);
        allTutorialObjs.push(tutorialWalk);
        // jump tutorial
        const tutorialJump = new $58ff041f00ca7e33$var$TutorialObj();
        tutorialJump.pos = new (0, $9014d97cd777be10$export$64b5c384219d3699)(0.3, 1, -62);
        tutorialJump.rot = new (0, $9014d97cd777be10$export$64b5c384219d3699)(0, Math.PI, 0);
        tutorialJump.images = [];
        tutorialJump.texts = [];
        // SPACE image
        const texture = textureLoader.load(uiLocation + "space_key.png");
        texture.colorSpace = (0, $9014d97cd777be10$export$561f394b24edfcaa);
        const geometry = new (0, $9014d97cd777be10$export$967d831af31f69ce)(3.263, 1); // Adjust the size as needed
        const material = new (0, $9014d97cd777be10$export$55cbcc9b622fe1f5)({
            map: texture
        });
        const tutorialJumpSpacebarImg = new (0, $9014d97cd777be10$export$e176487c05830cc5)(geometry, material);
        localOffset.set(0, 0, 0);
        if (globalThis.Lang === "tr") objWorldSpacePos.copy(this._getPosLocalToTutorialObj(new (0, $9014d97cd777be10$export$64b5c384219d3699)(localOffset.x + this.globalXOffset, localOffset.y, localOffset.z), tutorialJump));
        else objWorldSpacePos.copy(this._getPosLocalToTutorialObj(localOffset, tutorialJump));
        tutorialJumpSpacebarImg.position.copy(objWorldSpacePos);
        tutorialJumpSpacebarImg.rotation.set(tutorialJump.rot.x, tutorialJump.rot.y, tutorialJump.rot.z);
        tutorialJump.images.push(tutorialJumpSpacebarImg);
        // "Press" text
        const pressText = new (0, $55f5ea5649168877$export$5f1af8db9871e1d6)();
        pressText.outlineOffsetX = 0.01;
        pressText.outlineOffsetY = 0.01;
        pressText.font = this.fontLocation;
        pressText.text = (0, $34a8d0dc3ef4dba1$export$625550452a3fa3ec)("in_game__tutorial_press");
        pressText.fontSize = this.defaultTextSize;
        if (globalThis.Lang === "fr") localOffset.set(-7, 0.4 + this.globalYOffset, 0);
        else if (globalThis.Lang === "pt") localOffset.set(-6 + 2 * this.globalXOffset, 0.4 + this.globalYOffset, 0);
        else if (globalThis.Lang === "ja") localOffset.set(-4, 0.4 + this.globalYOffset, 0);
        else localOffset.set(-6 + this.globalXOffset, 0.4 + this.globalYOffset, 0);
        objWorldSpacePos.copy(this._getPosLocalToTutorialObj(localOffset, tutorialJump));
        pressText.position.copy(objWorldSpacePos);
        pressText.rotation.set(tutorialJump.rot.x, tutorialJump.rot.y, tutorialJump.rot.z);
        pressText.color = 0xffffff;
        tutorialJump.texts.push(pressText);
        // "To jump" text
        const toJumpText = new (0, $55f5ea5649168877$export$5f1af8db9871e1d6)();
        toJumpText.outlineOffsetX = 0.01;
        toJumpText.outlineOffsetY = 0.01;
        toJumpText.font = this.fontLocation;
        toJumpText.text = (0, $34a8d0dc3ef4dba1$export$625550452a3fa3ec)("in_game__tutorial__to_jump");
        toJumpText.fontSize = this.defaultTextSize;
        localOffset.set(2.7 + this.globalXOffset, 0.4 + this.globalYOffset, 0);
        objWorldSpacePos.copy(this._getPosLocalToTutorialObj(localOffset, tutorialJump));
        toJumpText.position.copy(objWorldSpacePos);
        toJumpText.rotation.set(tutorialJump.rot.x, tutorialJump.rot.y, tutorialJump.rot.z);
        toJumpText.color = 0xffffff;
        tutorialJump.texts.push(toJumpText);
        //IMPORTANT ADD OBJECT TO LIST OF TUTORIAL ITEMS
        allTutorialObjs.push(tutorialJump);
        //KEEP JUMPING TUTORIAL
        const tutorialKeepJumping = new $58ff041f00ca7e33$var$TutorialObj();
        tutorialKeepJumping.pos = new (0, $9014d97cd777be10$export$64b5c384219d3699)(-26.9, 8.75, 2.5);
        tutorialKeepJumping.rot = new (0, $9014d97cd777be10$export$64b5c384219d3699)(0, Math.PI / 2, 0);
        tutorialKeepJumping.images = [];
        tutorialKeepJumping.texts = [];
        //SPACE image
        const spaceKeepJumpingTexture = textureLoader.load(uiLocation + "space_key.png");
        spaceKeepJumpingTexture.colorSpace = (0, $9014d97cd777be10$export$561f394b24edfcaa);
        const spaceKeepJumpingGeometry = new (0, $9014d97cd777be10$export$967d831af31f69ce)(3.263, 1); // Adjust the size as needed
        const spaceKeepJumpingMaterial = new (0, $9014d97cd777be10$export$55cbcc9b622fe1f5)({
            map: spaceKeepJumpingTexture
        });
        const tutorialKeepJumpingSpacebarImg = new (0, $9014d97cd777be10$export$e176487c05830cc5)(spaceKeepJumpingGeometry, spaceKeepJumpingMaterial);
        localOffset.set(0, 0, 0);
        if (globalThis.Lang === "tr") objWorldSpacePos.copy(this._getPosLocalToTutorialObj(new (0, $9014d97cd777be10$export$64b5c384219d3699)(localOffset.x + this.globalXOffset, localOffset.y, localOffset.z), tutorialKeepJumping));
        else objWorldSpacePos.copy(this._getPosLocalToTutorialObj(localOffset, tutorialKeepJumping));
        tutorialKeepJumpingSpacebarImg.position.copy(objWorldSpacePos);
        tutorialKeepJumpingSpacebarImg.rotation.set(tutorialKeepJumping.rot.x, tutorialKeepJumping.rot.y, tutorialJump.rot.z);
        tutorialKeepJumping.images.push(tutorialKeepJumpingSpacebarImg);
        // HOLD Text
        const holdTextKeepJumping = new (0, $55f5ea5649168877$export$5f1af8db9871e1d6)();
        holdTextKeepJumping.outlineOffsetX = 0.01;
        holdTextKeepJumping.outlineOffsetY = 0.01;
        holdTextKeepJumping.font = this.fontLocation;
        holdTextKeepJumping.text = (0, $34a8d0dc3ef4dba1$export$625550452a3fa3ec)("in_game__tutorial__hold");
        holdTextKeepJumping.fontSize = this.defaultTextSize;
        if (globalThis.Lang === "nl") {
            console.log("Adjusting extra for Dutch");
            localOffset.set(-5.25 + 3 * this.globalXOffset, 0.4 + this.globalYOffset, 0);
        } else localOffset.set(-5.25 + this.globalXOffset, 0.4 + this.globalYOffset, 0);
        objWorldSpacePos.copy(this._getPosLocalToTutorialObj(localOffset, tutorialKeepJumping));
        holdTextKeepJumping.position.copy(objWorldSpacePos);
        holdTextKeepJumping.rotation.set(tutorialKeepJumping.rot.x, tutorialKeepJumping.rot.y, tutorialKeepJumping.rot.z);
        holdTextKeepJumping.color = 0xffffff;
        tutorialKeepJumping.texts.push(holdTextKeepJumping);
        // to jump repeatedly text
        const toJumpRepeatedlyTextKeepJumping = new (0, $55f5ea5649168877$export$5f1af8db9871e1d6)();
        toJumpRepeatedlyTextKeepJumping.outlineOffsetX = 0.01;
        toJumpRepeatedlyTextKeepJumping.outlineOffsetY = 0.01;
        toJumpRepeatedlyTextKeepJumping.font = this.fontLocation;
        toJumpRepeatedlyTextKeepJumping.text = (0, $34a8d0dc3ef4dba1$export$625550452a3fa3ec)("in_game__tutorial__jump_repeatedly");
        toJumpRepeatedlyTextKeepJumping.fontSize = this.defaultTextSize;
        localOffset.set(2.7 + this.globalXOffset, 0.4 + this.globalYOffset, 0);
        objWorldSpacePos.copy(this._getPosLocalToTutorialObj(localOffset, tutorialKeepJumping));
        toJumpRepeatedlyTextKeepJumping.position.copy(objWorldSpacePos);
        toJumpRepeatedlyTextKeepJumping.rotation.set(tutorialKeepJumping.rot.x, tutorialKeepJumping.rot.y, tutorialKeepJumping.rot.z);
        toJumpRepeatedlyTextKeepJumping.color = 0xffffff;
        tutorialKeepJumping.texts.push(toJumpRepeatedlyTextKeepJumping);
        allTutorialObjs.push(tutorialKeepJumping);
        //CLIMBING TUTORIAL
        const tutorialClimbing = new $58ff041f00ca7e33$var$TutorialObj();
        tutorialClimbing.pos = new (0, $9014d97cd777be10$export$64b5c384219d3699)(3.3, 3.5, -43);
        tutorialClimbing.rot = new (0, $9014d97cd777be10$export$64b5c384219d3699)(0, Math.PI, 0);
        tutorialClimbing.images = [];
        tutorialClimbing.texts = [];
        //SPACE image
        const spaceClimbingTexture = textureLoader.load(uiLocation + "space_key.png");
        spaceClimbingTexture.colorSpace = (0, $9014d97cd777be10$export$561f394b24edfcaa);
        const spaceClimbingGeometry = new (0, $9014d97cd777be10$export$967d831af31f69ce)(3.263, 1); // Adjust the size as needed
        const spaceClimbingMaterial = new (0, $9014d97cd777be10$export$55cbcc9b622fe1f5)({
            map: spaceClimbingTexture
        });
        const tutorialSpaceClimbingImg = new (0, $9014d97cd777be10$export$e176487c05830cc5)(spaceClimbingGeometry, spaceClimbingMaterial);
        localOffset.set(0, 0, 0);
        if (globalThis.Lang === "tr") objWorldSpacePos.copy(this._getPosLocalToTutorialObj(new (0, $9014d97cd777be10$export$64b5c384219d3699)(localOffset.x + 2 * this.globalXOffset, localOffset.y, localOffset.z), tutorialClimbing));
        else objWorldSpacePos.copy(this._getPosLocalToTutorialObj(localOffset, tutorialClimbing));
        tutorialSpaceClimbingImg.position.copy(objWorldSpacePos);
        tutorialSpaceClimbingImg.rotation.set(tutorialClimbing.rot.x, tutorialClimbing.rot.y, tutorialClimbing.rot.z);
        tutorialKeepJumping.images.push(tutorialSpaceClimbingImg);
        // HOLD text (climbing)
        const holdTextClimbing = new (0, $55f5ea5649168877$export$5f1af8db9871e1d6)();
        holdTextClimbing.outlineOffsetX = 0.01;
        holdTextClimbing.outlineOffsetY = 0.01;
        holdTextClimbing.font = this.fontLocation;
        holdTextClimbing.text = (0, $34a8d0dc3ef4dba1$export$625550452a3fa3ec)("in_game__tutorial__hold");
        if (globalThis.Lang === "nl") holdTextClimbing.fontSize = this.defaultTextSize - 0.2;
        else holdTextClimbing.fontSize = this.defaultTextSize;
        if (globalThis.Lang === "nl") localOffset.set(-6.25 + 2 * this.globalXOffset, 0.4 + this.globalYOffset, 0);
        else localOffset.set(-5.25 + this.globalXOffset, 0.4 + this.globalYOffset, 0);
        objWorldSpacePos.copy(this._getPosLocalToTutorialObj(localOffset, tutorialClimbing));
        holdTextClimbing.position.copy(objWorldSpacePos);
        holdTextClimbing.rotation.set(tutorialClimbing.rot.x, tutorialClimbing.rot.y, tutorialClimbing.rot.z);
        holdTextClimbing.color = 0xffffff;
        tutorialClimbing.texts.push(holdTextClimbing);
        // To climb walls text
        const toClimbText = new (0, $55f5ea5649168877$export$5f1af8db9871e1d6)();
        toClimbText.outlineOffsetX = 0.01;
        toClimbText.outlineOffsetY = 0.01;
        toClimbText.font = this.fontLocation;
        toClimbText.text = (0, $34a8d0dc3ef4dba1$export$625550452a3fa3ec)("in_game__tutorial_wall_climb");
        if (globalThis.Lang === "tr" || globalThis.Lang === "nl") toClimbText.fontSize = this.defaultTextSize - 0.2;
        else toClimbText.fontSize = this.defaultTextSize;
        if (globalThis.Lang === "tr") localOffset.set(2.7 + 3 * this.globalXOffset, 0.4 + this.globalYOffset, 0);
        else localOffset.set(2.7 + this.globalXOffset, 0.4 + this.globalYOffset, 0);
        objWorldSpacePos.copy(this._getPosLocalToTutorialObj(localOffset, tutorialClimbing));
        toClimbText.position.copy(objWorldSpacePos);
        toClimbText.rotation.set(tutorialClimbing.rot.x, tutorialClimbing.rot.y, tutorialClimbing.rot.z);
        toClimbText.color = 0xffffff;
        tutorialClimbing.texts.push(toClimbText);
        // WHILE RUNNING text
        const whileRunningText = new (0, $55f5ea5649168877$export$5f1af8db9871e1d6)();
        whileRunningText.outlineOffsetX = 0.01;
        whileRunningText.outlineOffsetY = 0.01;
        whileRunningText.font = this.fontLocation;
        whileRunningText.text = (0, $34a8d0dc3ef4dba1$export$625550452a3fa3ec)("in_game__tutorial_while_running");
        whileRunningText.fontSize = this.defaultTextSize;
        localOffset.set(-0.3 + this.globalXOffset, -1 + this.globalYOffset, 0);
        objWorldSpacePos.copy(this._getPosLocalToTutorialObj(localOffset, tutorialClimbing));
        whileRunningText.position.copy(objWorldSpacePos);
        whileRunningText.rotation.set(tutorialClimbing.rot.x, tutorialClimbing.rot.y, tutorialClimbing.rot.z);
        whileRunningText.color = 0xffffff;
        tutorialClimbing.texts.push(whileRunningText);
        allTutorialObjs.push(tutorialClimbing);
        //TIMER TUTORIAL
        const tutorialTimer = new $58ff041f00ca7e33$var$TutorialObj();
        tutorialTimer.pos = new (0, $9014d97cd777be10$export$64b5c384219d3699)(-4.5, 0.02, 11.5);
        tutorialTimer.rot = new (0, $9014d97cd777be10$export$64b5c384219d3699)(Math.PI / 2, Math.PI, 0);
        tutorialTimer.images = [];
        tutorialTimer.texts = [];
        const timerText = new (0, $55f5ea5649168877$export$5f1af8db9871e1d6)();
        timerText.outlineOffsetX = 0.01;
        timerText.outlineOffsetY = 0.01;
        timerText.font = this.fontLocation;
        timerText.text = (0, $34a8d0dc3ef4dba1$export$625550452a3fa3ec)("in_game__tutorial_start_timer");
        timerText.fontSize = 0.8;
        if (globalThis.Lang === "de") localOffset.set(-10 + 3 * this.globalXOffset, 0.4 + this.globalYOffset, 0);
        else if (globalThis.Lang === "fr") localOffset.set(-10 + 5 * this.globalXOffset, 0.4 + this.globalYOffset, 0);
        else localOffset.set(-10 + this.globalXOffset, 0.4 + this.globalYOffset, 0);
        objWorldSpacePos.copy(this._getPosLocalToTutorialObj(localOffset, tutorialTimer));
        timerText.position.copy(objWorldSpacePos);
        timerText.rotation.set(tutorialTimer.rot.x, tutorialTimer.rot.y, tutorialTimer.rot.z);
        timerText.color = 0xffffff;
        tutorialTimer.texts.push(timerText);
        const highscoreText = new (0, $55f5ea5649168877$export$5f1af8db9871e1d6)();
        highscoreText.outlineOffsetX = 0.01;
        highscoreText.outlineOffsetY = 0.01;
        highscoreText.font = this.fontLocation;
        highscoreText.text = (0, $34a8d0dc3ef4dba1$export$625550452a3fa3ec)("in_game__how_fast_top");
        highscoreText.fontSize = 0.8;
        if (globalThis.Lang === "fr") localOffset.set(-8 + 4 * this.globalXOffset, -1.25 + this.globalYOffset, 0);
        else localOffset.set(-8 + this.globalXOffset, -1.25 + this.globalYOffset, 0);
        objWorldSpacePos.copy(this._getPosLocalToTutorialObj(localOffset, tutorialTimer));
        highscoreText.position.copy(objWorldSpacePos);
        highscoreText.rotation.set(tutorialTimer.rot.x, tutorialTimer.rot.y, tutorialTimer.rot.z);
        highscoreText.color = 0xffffff;
        tutorialTimer.texts.push(highscoreText);
        allTutorialObjs.push(tutorialTimer);
        const tutorialStoves = new $58ff041f00ca7e33$var$TutorialObj();
        tutorialStoves.pos = new (0, $9014d97cd777be10$export$64b5c384219d3699)(5, 2.6, -81.2);
        tutorialStoves.rot = new (0, $9014d97cd777be10$export$64b5c384219d3699)(0, Math.PI, 0);
        tutorialStoves.images = [];
        tutorialStoves.texts = [];
        const stoveText = new (0, $55f5ea5649168877$export$5f1af8db9871e1d6)();
        stoveText.outlineOffsetX = 0.01;
        stoveText.outlineOffsetY = 0.01;
        stoveText.font = this.fontLocation;
        stoveText.text = (0, $34a8d0dc3ef4dba1$export$625550452a3fa3ec)("in_game__no_touchy");
        stoveText.fontSize = 1.65;
        if (globalThis.Lang === "de" || globalThis.Lang === "fr" || globalThis.Lang === "nl") localOffset.set(0 + 1.5 * this.globalXOffset, 0 + this.globalYOffset, 0);
        else localOffset.set(0 - this.globalXOffset, 0 + this.globalYOffset, 0);
        objWorldSpacePos.copy(this._getPosLocalToTutorialObj(localOffset, tutorialStoves));
        stoveText.position.copy(objWorldSpacePos);
        stoveText.rotation.set(tutorialStoves.rot.x, tutorialStoves.rot.y, tutorialStoves.rot.z);
        stoveText.color = 0xffffff;
        tutorialStoves.texts.push(stoveText);
        allTutorialObjs.push(tutorialStoves);
        // maze secret
        const tutorialSecretMaze = new $58ff041f00ca7e33$var$TutorialObj();
        tutorialSecretMaze.pos = new (0, $9014d97cd777be10$export$64b5c384219d3699)(90, 36.4, -191.5);
        tutorialSecretMaze.rot = new (0, $9014d97cd777be10$export$64b5c384219d3699)(0, Math.PI * 1.5, 0);
        tutorialSecretMaze.images = [];
        tutorialSecretMaze.texts = [];
        const secretMazeText = new (0, $55f5ea5649168877$export$5f1af8db9871e1d6)();
        secretMazeText.outlineOffsetX = 0.01;
        secretMazeText.outlineOffsetY = 0.01;
        secretMazeText.font = this.fontLocation;
        secretMazeText.text = (0, $34a8d0dc3ef4dba1$export$625550452a3fa3ec)("in_game__secret_invis_maze");
        if (globalThis.Lang === "nl" || globalThis.Lang === "es") secretMazeText.fontSize = this.defaultTextSize - 0.3;
        else secretMazeText.fontSize = this.defaultTextSize;
        if (globalThis.Lang === "fr" || globalThis.Lang === "pt" || globalThis.Lang === "nl" || globalThis.Lang === "es") localOffset.set(0 + 2 * this.globalXOffset, 0 + this.globalYOffset, 0);
        else localOffset.set(0 + this.globalXOffset, 0 + this.globalYOffset, 0);
        objWorldSpacePos.copy(this._getPosLocalToTutorialObj(localOffset, tutorialSecretMaze));
        secretMazeText.position.copy(objWorldSpacePos);
        secretMazeText.rotation.set(tutorialSecretMaze.rot.x, tutorialSecretMaze.rot.y, tutorialSecretMaze.rot.z);
        secretMazeText.color = 0xffffff;
        tutorialSecretMaze.texts.push(secretMazeText);
        allTutorialObjs.push(tutorialSecretMaze);
        // upside down plate secret
        const tutorialSecretPlates = new $58ff041f00ca7e33$var$TutorialObj();
        tutorialSecretPlates.pos = new (0, $9014d97cd777be10$export$64b5c384219d3699)(-80, 15, -16);
        tutorialSecretPlates.rot = new (0, $9014d97cd777be10$export$64b5c384219d3699)(0, Math.PI * 1.5, 0);
        tutorialSecretPlates.images = [];
        tutorialSecretPlates.texts = [];
        const secretPlatesText = new (0, $55f5ea5649168877$export$5f1af8db9871e1d6)();
        secretPlatesText.outlineOffsetX = 0.01;
        secretPlatesText.outlineOffsetY = 0.01;
        secretPlatesText.font = this.fontLocation;
        secretPlatesText.text = (0, $34a8d0dc3ef4dba1$export$625550452a3fa3ec)("in_game__secret_upside_down_plate");
        secretPlatesText.fontSize = this.defaultTextSize;
        if (globalThis.Lang === "es" || globalThis.Lang === "de" || globalThis.Lang === "fr" || globalThis.Lang === "tr" || globalThis.Lang === "nl") localOffset.set(0 + 10 * this.globalXOffset, 0 + this.globalYOffset, 0);
        else if (globalThis.Lang === "ja") localOffset.set(-1 + this.globalXOffset, 0 + this.globalYOffset, 0);
        else localOffset.set(0 + this.globalXOffset, 0 + this.globalYOffset, 0);
        objWorldSpacePos.copy(this._getPosLocalToTutorialObj(localOffset, tutorialSecretPlates));
        secretPlatesText.position.copy(objWorldSpacePos);
        secretPlatesText.rotation.set(tutorialSecretPlates.rot.x, tutorialSecretPlates.rot.y, tutorialSecretPlates.rot.z);
        secretPlatesText.color = 0xffffff;
        tutorialSecretPlates.texts.push(secretPlatesText);
        allTutorialObjs.push(tutorialSecretPlates);
        const tutorialInvisibleBlocks = new $58ff041f00ca7e33$var$TutorialObj();
        tutorialInvisibleBlocks.pos = new (0, $9014d97cd777be10$export$64b5c384219d3699)(-74.6, 19, 0.5);
        tutorialInvisibleBlocks.rot = new (0, $9014d97cd777be10$export$64b5c384219d3699)(0, Math.PI * 0.5, 0);
        tutorialInvisibleBlocks.images = [];
        tutorialInvisibleBlocks.texts = [];
        const invisibleBlocksText = new (0, $55f5ea5649168877$export$5f1af8db9871e1d6)();
        invisibleBlocksText.outlineOffsetX = 0.01;
        invisibleBlocksText.outlineOffsetY = 0.01;
        invisibleBlocksText.font = this.fontLocation;
        invisibleBlocksText.text = (0, $34a8d0dc3ef4dba1$export$625550452a3fa3ec)("in_game__tutorial_invis_platforms");
        invisibleBlocksText.fontSize = 1.65;
        localOffset.set(0 + this.globalXOffset, 0 + this.globalYOffset, 0);
        objWorldSpacePos.copy(this._getPosLocalToTutorialObj(localOffset, tutorialInvisibleBlocks));
        invisibleBlocksText.position.copy(objWorldSpacePos);
        invisibleBlocksText.rotation.set(tutorialInvisibleBlocks.rot.x, tutorialInvisibleBlocks.rot.y, tutorialInvisibleBlocks.rot.z);
        invisibleBlocksText.color = 0xffffff;
        tutorialInvisibleBlocks.texts.push(invisibleBlocksText);
        allTutorialObjs.push(tutorialInvisibleBlocks);
        // add all elements from tutorialObj's to the scene
        allTutorialObjs.forEach((element)=>{
            element.texts.forEach((myText)=>{
                this.scene.add(myText);
            });
            element.images.forEach((myImage)=>{
                this.scene.add(myImage);
            });
        });
        // add the arrow to the start line
        const startArrowTexture = textureLoader.load(uiLocation + "start_arrow.png");
        startArrowTexture.colorSpace = (0, $9014d97cd777be10$export$561f394b24edfcaa);
        startArrowTexture.minFilter = (0, $9014d97cd777be10$export$8a72f490b25c56c8);
        const startArrowGeometry = new (0, $9014d97cd777be10$export$967d831af31f69ce)(15, 15); // Adjust the size as needed
        const startArrowMaterial = new (0, $9014d97cd777be10$export$55cbcc9b622fe1f5)({
            map: startArrowTexture,
            transparent: true
        });
        const tutorialStartArrow = new (0, $9014d97cd777be10$export$e176487c05830cc5)(startArrowGeometry, startArrowMaterial);
        tutorialStartArrow.position.set(-2.25, 0.05, 1);
        tutorialStartArrow.rotation.set(Math.PI * 0.5, Math.PI, 0);
        this.scene.add(tutorialStartArrow);
    }
    _drawTutorialTextMobile() {
        const localOffset = new (0, $9014d97cd777be10$export$64b5c384219d3699)(0, 0, 0);
        const objWorldSpacePos = new (0, $9014d97cd777be10$export$64b5c384219d3699)(0, 0, 0);
        const fontLocation = "fonts/LuckiestGuy-Regular.ttf";
        const uiLocation = "ui/tutorial/";
        const allTutorialObjs = [];
        const textureLoader = Game.Loader.TextureLoader;
        // walk tutorial
        const tutorialWalk = new $58ff041f00ca7e33$var$TutorialObj();
        tutorialWalk.pos = new (0, $9014d97cd777be10$export$64b5c384219d3699)(-4, 2.65, -94.2);
        tutorialWalk.rot = new (0, $9014d97cd777be10$export$64b5c384219d3699)(0, Math.PI, 0);
        tutorialWalk.images = [];
        tutorialWalk.texts = [];
        // WASD Image
        /*const wasdTexture = textureLoader.load(uiLocation + 'wasd.png');
                const wasdGeometry = new PlaneGeometry(4, 2.8); // Adjust the size as needed
                const wasdMaterial = new MeshBasicMaterial({ map: wasdTexture, transparent: true, alphaTest: 0.5, side: DoubleSide  });
                const tutorialWASDImg = new Mesh(wasdGeometry, wasdMaterial);
                localOffset.set(0,0,0);
                objWorldSpacePos.copy(this.GetPosLocalToTutorialObj(localOffset,tutorialWalk));
                tutorialWASDImg.position.copy(objWorldSpacePos);
                tutorialWASDImg.rotation.set(tutorialWalk.rot.x, tutorialWalk.rot.y, tutorialWalk.rot.z);
                tutorialWalk.images.push(tutorialWASDImg);*/ // PRESS text
        const pressTextWalk = new (0, $55f5ea5649168877$export$5f1af8db9871e1d6)();
        pressTextWalk.outlineOffsetX = 0.01;
        pressTextWalk.outlineOffsetY = 0.01;
        pressTextWalk.font = fontLocation;
        pressTextWalk.text = (0, $34a8d0dc3ef4dba1$export$625550452a3fa3ec)("in_game__tutorial_running");
        pressTextWalk.fontSize = this.defaultTextSize;
        localOffset.set(-6 + this.globalXOffset, 0.25 + this.globalYOffset, 0);
        objWorldSpacePos.copy(this._getPosLocalToTutorialObj(localOffset, tutorialWalk));
        pressTextWalk.position.copy(objWorldSpacePos);
        pressTextWalk.rotation.set(tutorialWalk.rot.x, tutorialWalk.rot.y, tutorialWalk.rot.z);
        pressTextWalk.color = 0xffffff;
        tutorialWalk.texts.push(pressTextWalk);
        // TO WALK text
        /*const toWalkText = new Text();
                toWalkText.font = fontLocation;
                toWalkText.text = "To run";
                toWalkText.fontSize =  this.defaultTextSize;

                localOffset.set(2.7,-0.4,0);
                objWorldSpacePos.copy(this.GetPosLocalToTutorialObj(localOffset,tutorialWalk));
                toWalkText.position.copy(objWorldSpacePos);
                toWalkText.rotation.set(tutorialWalk.rot.x, tutorialWalk.rot.y, tutorialWalk.rot.z);
                toWalkText.color = 0xffffff;
                tutorialWalk.texts.push(toWalkText);*/ allTutorialObjs.push(tutorialWalk);
        // jump tutorial
        const tutorialJump = new $58ff041f00ca7e33$var$TutorialObj();
        tutorialJump.pos = new (0, $9014d97cd777be10$export$64b5c384219d3699)(0.3, 1.1, -62);
        tutorialJump.rot = new (0, $9014d97cd777be10$export$64b5c384219d3699)(0, Math.PI, 0);
        tutorialJump.images = [];
        tutorialJump.texts = [];
        // SPACE image
        const texture = textureLoader.load(uiLocation + "mobileJump.png");
        texture.colorSpace = (0, $9014d97cd777be10$export$561f394b24edfcaa);
        const geometry = new (0, $9014d97cd777be10$export$967d831af31f69ce)(3, 3); // Adjust the size as needed
        const material = new (0, $9014d97cd777be10$export$55cbcc9b622fe1f5)({
            map: texture,
            transparent: true,
            alphaTest: 0.5
        });
        const tutorialJumpSpacebarImg = new (0, $9014d97cd777be10$export$e176487c05830cc5)(geometry, material);
        localOffset.set(0, -0.1, 0);
        objWorldSpacePos.copy(this._getPosLocalToTutorialObj(localOffset, tutorialJump));
        tutorialJumpSpacebarImg.position.copy(objWorldSpacePos);
        tutorialJumpSpacebarImg.rotation.set(tutorialJump.rot.x, tutorialJump.rot.y, tutorialJump.rot.z);
        tutorialJump.images.push(tutorialJumpSpacebarImg);
        // "Press" text
        const pressText = new (0, $55f5ea5649168877$export$5f1af8db9871e1d6)();
        pressText.outlineOffsetX = 0.01;
        pressText.outlineOffsetY = 0.01;
        pressText.font = fontLocation;
        pressText.text = (0, $34a8d0dc3ef4dba1$export$625550452a3fa3ec)("in_game__tutorial_tap");
        pressText.fontSize = this.defaultTextSize;
        localOffset.set(-4.3 + this.globalXOffset, 0.4 + this.globalYOffset, 0);
        objWorldSpacePos.copy(this._getPosLocalToTutorialObj(localOffset, tutorialJump));
        pressText.position.copy(objWorldSpacePos);
        pressText.rotation.set(tutorialJump.rot.x, tutorialJump.rot.y, tutorialJump.rot.z);
        pressText.color = 0xffffff;
        tutorialJump.texts.push(pressText);
        // "To jump" text
        const toJumpText = new (0, $55f5ea5649168877$export$5f1af8db9871e1d6)();
        toJumpText.outlineOffsetX = 0.01;
        toJumpText.outlineOffsetY = 0.01;
        toJumpText.font = fontLocation;
        toJumpText.text = (0, $34a8d0dc3ef4dba1$export$625550452a3fa3ec)("in_game__tutorial__to_jump");
        toJumpText.fontSize = this.defaultTextSize;
        localOffset.set(2.7 + this.globalXOffset, 0.4 + this.globalYOffset, 0);
        objWorldSpacePos.copy(this._getPosLocalToTutorialObj(localOffset, tutorialJump));
        toJumpText.position.copy(objWorldSpacePos);
        toJumpText.rotation.set(tutorialJump.rot.x, tutorialJump.rot.y, tutorialJump.rot.z);
        toJumpText.color = 0xffffff;
        tutorialJump.texts.push(toJumpText);
        //IMPORTANT ADD OBJECT TO LIST OF TUTORIAL ITEMS
        allTutorialObjs.push(tutorialJump);
        //KEEP JUMPING TUTORIAL
        const tutorialKeepJumping = new $58ff041f00ca7e33$var$TutorialObj();
        tutorialKeepJumping.pos = new (0, $9014d97cd777be10$export$64b5c384219d3699)(-26.9, 8.75, 2.5);
        tutorialKeepJumping.rot = new (0, $9014d97cd777be10$export$64b5c384219d3699)(0, Math.PI / 2, 0);
        tutorialKeepJumping.images = [];
        tutorialKeepJumping.texts = [];
        //SPACE image
        const spaceKeepJumpingTexture = textureLoader.load(uiLocation + "mobileJump.png");
        spaceKeepJumpingTexture.colorSpace = (0, $9014d97cd777be10$export$561f394b24edfcaa);
        const spaceKeepJumpingGeometry = new (0, $9014d97cd777be10$export$967d831af31f69ce)(3.75, 3.75); // Adjust the size as needed
        const spaceKeepJumpingMaterial = new (0, $9014d97cd777be10$export$55cbcc9b622fe1f5)({
            map: spaceKeepJumpingTexture,
            transparent: true,
            alphaTest: 0.5
        });
        const tutorialKeepJumpingSpacebarImg = new (0, $9014d97cd777be10$export$e176487c05830cc5)(spaceKeepJumpingGeometry, spaceKeepJumpingMaterial);
        localOffset.set(0, 0, 0);
        objWorldSpacePos.copy(this._getPosLocalToTutorialObj(localOffset, tutorialKeepJumping));
        tutorialKeepJumpingSpacebarImg.position.copy(objWorldSpacePos);
        tutorialKeepJumpingSpacebarImg.rotation.set(tutorialKeepJumping.rot.x, tutorialKeepJumping.rot.y, tutorialJump.rot.z);
        tutorialKeepJumping.images.push(tutorialKeepJumpingSpacebarImg);
        // HOLD Text
        const holdTextKeepJumping = new (0, $55f5ea5649168877$export$5f1af8db9871e1d6)();
        holdTextKeepJumping.outlineOffsetX = 0.01;
        holdTextKeepJumping.outlineOffsetY = 0.01;
        holdTextKeepJumping.font = fontLocation;
        holdTextKeepJumping.text = (0, $34a8d0dc3ef4dba1$export$625550452a3fa3ec)("in_game__tutorial__hold");
        holdTextKeepJumping.fontSize = this.defaultTextSize;
        localOffset.set(-5.25 + this.globalXOffset, 0.4 + this.globalYOffset, 0);
        objWorldSpacePos.copy(this._getPosLocalToTutorialObj(localOffset, tutorialKeepJumping));
        holdTextKeepJumping.position.copy(objWorldSpacePos);
        holdTextKeepJumping.rotation.set(tutorialKeepJumping.rot.x, tutorialKeepJumping.rot.y, tutorialKeepJumping.rot.z);
        holdTextKeepJumping.color = 0xffffff;
        tutorialKeepJumping.texts.push(holdTextKeepJumping);
        // to jump repeatedly text
        const toJumpRepeatedlyTextKeepJumping = new (0, $55f5ea5649168877$export$5f1af8db9871e1d6)();
        toJumpRepeatedlyTextKeepJumping.outlineOffsetX = 0.01;
        toJumpRepeatedlyTextKeepJumping.outlineOffsetY = 0.01;
        toJumpRepeatedlyTextKeepJumping.font = fontLocation;
        toJumpRepeatedlyTextKeepJumping.text = (0, $34a8d0dc3ef4dba1$export$625550452a3fa3ec)("in_game__tutorial__jump_repeatedly");
        toJumpRepeatedlyTextKeepJumping.fontSize = this.defaultTextSize;
        localOffset.set(2.7 + this.globalXOffset, 0.4 + this.globalYOffset, 0);
        objWorldSpacePos.copy(this._getPosLocalToTutorialObj(localOffset, tutorialKeepJumping));
        toJumpRepeatedlyTextKeepJumping.position.copy(objWorldSpacePos);
        toJumpRepeatedlyTextKeepJumping.rotation.set(tutorialKeepJumping.rot.x, tutorialKeepJumping.rot.y, tutorialKeepJumping.rot.z);
        toJumpRepeatedlyTextKeepJumping.color = 0xffffff;
        tutorialKeepJumping.texts.push(toJumpRepeatedlyTextKeepJumping);
        allTutorialObjs.push(tutorialKeepJumping);
        //CLIMBING TUTORIAL
        const tutorialClimbing = new $58ff041f00ca7e33$var$TutorialObj();
        tutorialClimbing.pos = new (0, $9014d97cd777be10$export$64b5c384219d3699)(3.3, 3.5, -43);
        tutorialClimbing.rot = new (0, $9014d97cd777be10$export$64b5c384219d3699)(0, Math.PI, 0);
        tutorialClimbing.images = [];
        tutorialClimbing.texts = [];
        //SPACE image
        const spaceClimbingTexture = textureLoader.load(uiLocation + "mobileJump.png");
        spaceClimbingTexture.colorSpace = (0, $9014d97cd777be10$export$561f394b24edfcaa);
        const spaceClimbingGeometry = new (0, $9014d97cd777be10$export$967d831af31f69ce)(3.75, 3.75); // Adjust the size as needed
        const spaceClimbingMaterial = new (0, $9014d97cd777be10$export$55cbcc9b622fe1f5)({
            map: spaceClimbingTexture,
            transparent: true,
            alphaTest: 0.5
        });
        const tutorialSpaceClimbingImg = new (0, $9014d97cd777be10$export$e176487c05830cc5)(spaceClimbingGeometry, spaceClimbingMaterial);
        localOffset.set(0, 0.4, 0);
        objWorldSpacePos.copy(this._getPosLocalToTutorialObj(localOffset, tutorialClimbing));
        tutorialSpaceClimbingImg.position.copy(objWorldSpacePos);
        tutorialSpaceClimbingImg.rotation.set(tutorialClimbing.rot.x, tutorialClimbing.rot.y, tutorialClimbing.rot.z);
        tutorialKeepJumping.images.push(tutorialSpaceClimbingImg);
        // HOLD text (climbing)
        const holdTextClimbing = new (0, $55f5ea5649168877$export$5f1af8db9871e1d6)();
        holdTextClimbing.outlineOffsetX = 0.01;
        holdTextClimbing.outlineOffsetY = 0.01;
        holdTextClimbing.font = fontLocation;
        holdTextClimbing.text = (0, $34a8d0dc3ef4dba1$export$625550452a3fa3ec)("in_game__tutorial__hold");
        holdTextClimbing.fontSize = this.defaultTextSize;
        localOffset.set(-5.25 + this.globalXOffset, 0.8 + this.globalYOffset, 0);
        objWorldSpacePos.copy(this._getPosLocalToTutorialObj(localOffset, tutorialClimbing));
        holdTextClimbing.position.copy(objWorldSpacePos);
        holdTextClimbing.rotation.set(tutorialClimbing.rot.x, tutorialClimbing.rot.y, tutorialClimbing.rot.z);
        holdTextClimbing.color = 0xffffff;
        tutorialClimbing.texts.push(holdTextClimbing);
        // To climb walls text
        const toClimbText = new (0, $55f5ea5649168877$export$5f1af8db9871e1d6)();
        toClimbText.outlineOffsetX = 0.01;
        toClimbText.outlineOffsetY = 0.01;
        toClimbText.font = fontLocation;
        toClimbText.text = (0, $34a8d0dc3ef4dba1$export$625550452a3fa3ec)("in_game__tutorial_wall_climb");
        toClimbText.fontSize = this.defaultTextSize;
        localOffset.set(2.7 + this.globalXOffset, 0.8 + this.globalYOffset, 0);
        objWorldSpacePos.copy(this._getPosLocalToTutorialObj(localOffset, tutorialClimbing));
        toClimbText.position.copy(objWorldSpacePos);
        toClimbText.rotation.set(tutorialClimbing.rot.x, tutorialClimbing.rot.y, tutorialClimbing.rot.z);
        toClimbText.color = 0xffffff;
        tutorialClimbing.texts.push(toClimbText);
        // WHILE RUNNING text
        const whileRunningText = new (0, $55f5ea5649168877$export$5f1af8db9871e1d6)();
        whileRunningText.outlineOffsetX = 0.01;
        whileRunningText.outlineOffsetY = 0.01;
        whileRunningText.font = fontLocation;
        whileRunningText.text = (0, $34a8d0dc3ef4dba1$export$625550452a3fa3ec)("in_game__tutorial_while_running");
        whileRunningText.fontSize = this.defaultTextSize;
        localOffset.set(-0.3 + this.globalXOffset, -1.65 + this.globalYOffset, 0);
        objWorldSpacePos.copy(this._getPosLocalToTutorialObj(localOffset, tutorialClimbing));
        whileRunningText.position.copy(objWorldSpacePos);
        whileRunningText.rotation.set(tutorialClimbing.rot.x, tutorialClimbing.rot.y, tutorialClimbing.rot.z);
        whileRunningText.color = 0xffffff;
        tutorialClimbing.texts.push(whileRunningText);
        allTutorialObjs.push(tutorialClimbing);
        //TIMER TUTORIAL
        const tutorialTimer = new $58ff041f00ca7e33$var$TutorialObj();
        tutorialTimer.pos = new (0, $9014d97cd777be10$export$64b5c384219d3699)(-4.5, 0.02, 11.5);
        tutorialTimer.rot = new (0, $9014d97cd777be10$export$64b5c384219d3699)(Math.PI / 2, Math.PI, 0);
        tutorialTimer.images = [];
        tutorialTimer.texts = [];
        const timerText = new (0, $55f5ea5649168877$export$5f1af8db9871e1d6)();
        timerText.outlineOffsetX = 0.01;
        timerText.outlineOffsetY = 0.01;
        timerText.font = this.fontLocation;
        timerText.text = (0, $34a8d0dc3ef4dba1$export$625550452a3fa3ec)("in_game__tutorial_start_timer");
        timerText.fontSize = 0.8;
        if (globalThis.Lang === "de" || globalThis.Lang === "fr") localOffset.set(-0 + this.globalXOffset, 0.4 + this.globalYOffset, 0);
        else localOffset.set(-10 + this.globalXOffset, 0.4 + this.globalYOffset, 0);
        objWorldSpacePos.copy(this._getPosLocalToTutorialObj(localOffset, tutorialTimer));
        timerText.position.copy(objWorldSpacePos);
        timerText.rotation.set(tutorialTimer.rot.x, tutorialTimer.rot.y, tutorialTimer.rot.z);
        timerText.color = 0xffffff;
        tutorialTimer.texts.push(timerText);
        const highscoreText = new (0, $55f5ea5649168877$export$5f1af8db9871e1d6)();
        highscoreText.outlineOffsetX = 0.01;
        highscoreText.outlineOffsetY = 0.01;
        highscoreText.font = this.fontLocation;
        highscoreText.text = (0, $34a8d0dc3ef4dba1$export$625550452a3fa3ec)("in_game__how_fast_top");
        highscoreText.fontSize = 0.8;
        if (globalThis.Lang === "fr") localOffset.set(-0 + this.globalXOffset, -1.25 + this.globalYOffset, 0);
        else localOffset.set(-8 + this.globalXOffset, -1.25 + this.globalYOffset, 0);
        objWorldSpacePos.copy(this._getPosLocalToTutorialObj(localOffset, tutorialTimer));
        highscoreText.position.copy(objWorldSpacePos);
        highscoreText.rotation.set(tutorialTimer.rot.x, tutorialTimer.rot.y, tutorialTimer.rot.z);
        highscoreText.color = 0xffffff;
        tutorialTimer.texts.push(highscoreText);
        allTutorialObjs.push(tutorialTimer);
        // TUTORIAL STOVES
        const tutorialStoves = new $58ff041f00ca7e33$var$TutorialObj();
        tutorialStoves.pos = new (0, $9014d97cd777be10$export$64b5c384219d3699)(5, 2.6, -81.2);
        tutorialStoves.rot = new (0, $9014d97cd777be10$export$64b5c384219d3699)(0, Math.PI, 0);
        tutorialStoves.images = [];
        tutorialStoves.texts = [];
        const stoveText = new (0, $55f5ea5649168877$export$5f1af8db9871e1d6)();
        stoveText.outlineOffsetX = 0.01;
        stoveText.outlineOffsetY = 0.01;
        stoveText.font = fontLocation;
        stoveText.text = (0, $34a8d0dc3ef4dba1$export$625550452a3fa3ec)("in_game__no_touchy");
        stoveText.fontSize = 1.65;
        localOffset.set(0 - this.globalXOffset, 0 + this.globalYOffset, 0);
        objWorldSpacePos.copy(this._getPosLocalToTutorialObj(localOffset, tutorialStoves));
        stoveText.position.copy(objWorldSpacePos);
        stoveText.rotation.set(tutorialStoves.rot.x, tutorialStoves.rot.y, tutorialStoves.rot.z);
        stoveText.color = 0xffffff;
        tutorialStoves.texts.push(stoveText);
        allTutorialObjs.push(tutorialStoves);
        //TUTORIAL MOBILE CAMERA
        const tutorialMobileCamera = new $58ff041f00ca7e33$var$TutorialObj();
        tutorialMobileCamera.pos = new (0, $9014d97cd777be10$export$64b5c384219d3699)(24, 4, -84.2);
        tutorialMobileCamera.rot = new (0, $9014d97cd777be10$export$64b5c384219d3699)(0, Math.PI + 0.8, 0);
        tutorialMobileCamera.images = [];
        tutorialMobileCamera.texts = [];
        const mobileCameraText = new (0, $55f5ea5649168877$export$5f1af8db9871e1d6)();
        mobileCameraText.outlineOffsetX = 0.01;
        mobileCameraText.outlineOffsetY = 0.01;
        mobileCameraText.font = fontLocation;
        mobileCameraText.text = (0, $34a8d0dc3ef4dba1$export$625550452a3fa3ec)("in_game__tutorial_drag_move_camera");
        mobileCameraText.fontSize = 1.65;
        localOffset.set(0 + this.globalXOffset, 0 + this.globalYOffset, 0);
        objWorldSpacePos.copy(this._getPosLocalToTutorialObj(localOffset, tutorialMobileCamera));
        mobileCameraText.position.copy(objWorldSpacePos);
        mobileCameraText.rotation.set(tutorialMobileCamera.rot.x, tutorialMobileCamera.rot.y, tutorialMobileCamera.rot.z);
        mobileCameraText.color = 0xffffff;
        tutorialMobileCamera.texts.push(mobileCameraText);
        allTutorialObjs.push(tutorialMobileCamera);
        const tutorialSecretMaze = new $58ff041f00ca7e33$var$TutorialObj();
        tutorialSecretMaze.pos = new (0, $9014d97cd777be10$export$64b5c384219d3699)(74, 36.4, -142.5);
        tutorialSecretMaze.rot = new (0, $9014d97cd777be10$export$64b5c384219d3699)(0, Math.PI * 1.5, 0);
        tutorialSecretMaze.images = [];
        tutorialSecretMaze.texts = [];
        const secretMazeText = new (0, $55f5ea5649168877$export$5f1af8db9871e1d6)();
        secretMazeText.outlineOffsetX = 0.01;
        secretMazeText.outlineOffsetY = 0.01;
        secretMazeText.font = fontLocation;
        secretMazeText.text = (0, $34a8d0dc3ef4dba1$export$625550452a3fa3ec)("in_game__secret_invis_maze");
        secretMazeText.fontSize = this.defaultTextSize;
        localOffset.set(0 + this.globalXOffset, 0 + this.globalYOffset, 0);
        objWorldSpacePos.copy(this._getPosLocalToTutorialObj(localOffset, tutorialSecretMaze));
        secretMazeText.position.copy(objWorldSpacePos);
        secretMazeText.rotation.set(tutorialSecretMaze.rot.x, tutorialSecretMaze.rot.y, tutorialSecretMaze.rot.z);
        secretMazeText.color = 0xffffff;
        tutorialSecretMaze.texts.push(secretMazeText);
        allTutorialObjs.push(tutorialSecretMaze);
        const tutorialSecretPlates = new $58ff041f00ca7e33$var$TutorialObj();
        tutorialSecretPlates.pos = new (0, $9014d97cd777be10$export$64b5c384219d3699)(-80, 15, -16);
        tutorialSecretPlates.rot = new (0, $9014d97cd777be10$export$64b5c384219d3699)(0, Math.PI * 1.5, 0);
        tutorialSecretPlates.images = [];
        tutorialSecretPlates.texts = [];
        const secretPlatesText = new (0, $55f5ea5649168877$export$5f1af8db9871e1d6)();
        secretPlatesText.outlineOffsetX = 0.01;
        secretPlatesText.outlineOffsetY = 0.01;
        secretPlatesText.font = fontLocation;
        secretPlatesText.text = (0, $34a8d0dc3ef4dba1$export$625550452a3fa3ec)("in_game__secret_upside_down_plate");
        secretPlatesText.fontSize = this.defaultTextSize;
        localOffset.set(0 + this.globalXOffset, 0 + this.globalYOffset, 0);
        objWorldSpacePos.copy(this._getPosLocalToTutorialObj(localOffset, tutorialSecretPlates));
        secretPlatesText.position.copy(objWorldSpacePos);
        secretPlatesText.rotation.set(tutorialSecretPlates.rot.x, tutorialSecretPlates.rot.y, tutorialSecretPlates.rot.z);
        secretPlatesText.color = 0xffffff;
        tutorialSecretPlates.texts.push(secretPlatesText);
        allTutorialObjs.push(tutorialSecretPlates);
        const tutorialInvisibleBlocks = new $58ff041f00ca7e33$var$TutorialObj();
        tutorialInvisibleBlocks.pos = new (0, $9014d97cd777be10$export$64b5c384219d3699)(-74.6, 19, 0.5);
        tutorialInvisibleBlocks.rot = new (0, $9014d97cd777be10$export$64b5c384219d3699)(0, Math.PI * 0.5, 0);
        tutorialInvisibleBlocks.images = [];
        tutorialInvisibleBlocks.texts = [];
        const invisibleBlocksText = new (0, $55f5ea5649168877$export$5f1af8db9871e1d6)();
        invisibleBlocksText.outlineOffsetX = 0.01;
        invisibleBlocksText.outlineOffsetY = 0.01;
        invisibleBlocksText.font = fontLocation;
        invisibleBlocksText.text = (0, $34a8d0dc3ef4dba1$export$625550452a3fa3ec)("in_game__tutorial_invis_platforms");
        invisibleBlocksText.fontSize = 1.65;
        localOffset.set(0 + this.globalXOffset, 0 + this.globalYOffset, 0);
        objWorldSpacePos.copy(this._getPosLocalToTutorialObj(localOffset, tutorialInvisibleBlocks));
        invisibleBlocksText.position.copy(objWorldSpacePos);
        invisibleBlocksText.rotation.set(tutorialInvisibleBlocks.rot.x, tutorialInvisibleBlocks.rot.y, tutorialInvisibleBlocks.rot.z);
        invisibleBlocksText.color = 0xffffff;
        tutorialInvisibleBlocks.texts.push(invisibleBlocksText);
        allTutorialObjs.push(tutorialInvisibleBlocks);
        // add all elements from tutorialObj's to the scene
        allTutorialObjs.forEach((element)=>{
            element.texts.forEach((myText)=>{
                this.scene.add(myText);
            });
            element.images.forEach((myImage)=>{
                this.scene.add(myImage);
            });
        });
    }
    _updatePlayerRotationProxyCubePositionBasedOnMouseMovement(movementX, movementY) {
        if (this.PlayerRotationProxyCube) {
            const { MOUSE_SENSITIVITY: MOUSE_SENSITIVITY, PER_FRAME_MOVEMENT_CAP: PER_FRAME_MOVEMENT_CAP } = (0, $b80b6e4c153785d9$export$29cd7b75162a9425).Camera;
            this.PlayerRotationProxyCube.position.x -= (0, $5LCsG.clamp)(movementX * MOUSE_SENSITIVITY, -PER_FRAME_MOVEMENT_CAP, PER_FRAME_MOVEMENT_CAP);
            this.PlayerRotationProxyCube.position.y -= (0, $5LCsG.clamp)(movementY * MOUSE_SENSITIVITY, -PER_FRAME_MOVEMENT_CAP, PER_FRAME_MOVEMENT_CAP);
        }
    }
    _rotateEmptyBasedOnMouseMovement(movementX, __movementY) {
        if (this.PlayerRotationProxyCube !== undefined) {
            const { MOUSE_SENSITIVITY: MOUSE_SENSITIVITY, PER_FRAME_MOVEMENT_CAP: PER_FRAME_MOVEMENT_CAP } = (0, $b80b6e4c153785d9$export$29cd7b75162a9425).Camera;
            this.PlayerRotationProxyCube.rotation.y -= (0, $5LCsG.clamp)(movementX * MOUSE_SENSITIVITY, -PER_FRAME_MOVEMENT_CAP, PER_FRAME_MOVEMENT_CAP);
        }
    }
    _light() {
        this.globalIlluminationLight = new (0, $9014d97cd777be10$export$af279bfef9ec2c96)(0xffffff, 2.8);
        this.scene.add(this.globalIlluminationLight);
        this.directionalLight = new (0, $9014d97cd777be10$export$3fea33cc9972c868)(0xffffff, 1.2);
        this.directionalLight.position.set(5, 10, 3);
        this.directionalLight.castShadow = false;
        this.scene.add(this.directionalLight);
    }
    _initThreeRenderer() {
        try {
            const gameContainer = document.getElementById("game-container");
            this.Canvas = document.getElementById("game-canvas");
            const rendererContainerWidth = parseInt(window.getComputedStyle(gameContainer).width, 10);
            const rendererContainerHeight = parseInt(window.getComputedStyle(gameContainer).height, 10);
            this.scene = new (0, $9014d97cd777be10$export$38af1803e3442a7f)();
            this.renderer = new (0, $9014d97cd777be10$export$f6cc00ef28d7cf97)({
                canvas: this.Canvas
            });
            this.renderer.shadowMap.enabled = true;
            this.renderer.sortObjects = true;
            this.renderer.setSize(rendererContainerWidth, rendererContainerHeight);
            //this.Raycaster = new Raycaster();
            gameContainer.appendChild(this.renderer.domElement);
        // const size = 10000;
        // const divisions = 1000;
        // const gridHelper = new GridHelper(size, divisions);
        // this.scene.add(gridHelper);
        } catch (e) {
            console.error(`Caught an error attempting to initialize the renderer: Code: ${e.code} - Message: ${e.message} Error: ${e}`);
            Game.UI.ShowErrorScreen((0, $34a8d0dc3ef4dba1$export$625550452a3fa3ec)("error_screen__renderer_failed"));
        }
    }
    GetScene() {
        return this.scene;
    }
    RemoveModelFromScene(model) {
        this.scene.remove(model);
    }
    AddModelToScene(model) {
        this.scene.add(model);
    }
    async _drawSkybox() {
        // console.log("drawing skybox");
        const skyboxGltf = await Game.Loader.LoadModel("skybox/skybox_geo.glb");
        // console.log("skyboxGltf", skyboxGltf);
        this.skyboxModel = skyboxGltf.scene;
        this.skyboxModel.traverse((node)=>{
            // @ts-ignore
            if (node.isMesh) {
                const newMaterial = new (0, $9014d97cd777be10$export$55cbcc9b622fe1f5)({
                    color: 0xffffff
                });
                // @ts-ignore
                // If the original material uses textures, transfer them to the new material
                if (node.material.map) {
                    // @ts-ignore
                    newMaterial.map = node.material.map;
                    // @ts-ignore
                    newMaterial.transparent = node.material.transparent;
                    // @ts-ignore
                    newMaterial.alphaTest = node.material.alphaTest;
                }
                // Apply the new material
                // @ts-ignore
                node.material = newMaterial;
            }
        });
        this.skyboxModel.position.set(0, 600, 0);
        this.skyboxModel.scale.set(150, 150, 150);
        this.skyboxModel.rotation.set(0, 0, 0);
        Game.Renderer.AddModelToScene(this.skyboxModel);
    }
    _initCamera() {
        const { FOV: FOV, NEAR_PLANE: NEAR, FAR_PLANE: FAR } = (0, $b80b6e4c153785d9$export$29cd7b75162a9425).Camera;
        this.threeCamera = new (0, $9014d97cd777be10$export$74e4ae24825f68d7)(FOV, window.innerWidth / window.innerHeight, NEAR, FAR);
        this.threeCamera.position.set(0, 0, 0);
        this.thirdPersonCamera = new $58ff041f00ca7e33$var$ThirdPersonCamera(this.threeCamera);
        this.cameraInitialized = true;
        this._drawSkybox();
    }
    GetMyLocalEntity() {
        return this.MyLocalNonPredictedEntity;
    }
    _initPerformanceStats() {
        this.stats = new (0, (/*@__PURE__*/$parcel$interopDefault($bdc7294f86aa2fdf$exports)))();
        this.stats.dom.classList.add("debug-stats-graphs");
        this.stats.dom.style.bottom = "0px";
        this.stats.dom.style.top = "unset";
        this.stats.dom.style.left = "unset";
        this.stats.dom.style.right = "0px";
        this.stats.showPanel(0);
        document.body.appendChild(this.stats.dom);
    }
    getSystemName() {
        return "Renderer";
    }
    Update(deltaTimeS, __deltaTimeMS, __currentTimestamp) {
        try {
            if ((0, $b80b6e4c153785d9$export$29cd7b75162a9425).Rendering.ENABLE_STATS) this.stats.begin();
            if (!this.cameraInitialized) this._initCamera();
            // Lazily associated our local entity if it isnt already
            if (this.MyLocalNonPredictedEntityNid !== undefined && this.MyLocalNonPredictedEntity === undefined) {
                // It may not be created yet! Try grabbing it by nid
                const entity = Game.GetEntityByNid(this.MyLocalNonPredictedEntityNid);
                // If we successfully found it, that means it exists and is fully initialized
                if (entity) {
                    this.LogInfo("My entity is identified, and we got their actual entity");
                    this.MyLocalNonPredictedEntity = entity;
                    this.MyLocalNonPredictedEntity.IdentifyAsMyPlayer();
                    if ((0, $b80b6e4c153785d9$export$29cd7b75162a9425).Player.ENABLE_PREDICTION === false) this._addDebugCube(this.MyLocalNonPredictedEntity.Position.x, this.MyLocalNonPredictedEntity.Position.y, this.MyLocalNonPredictedEntity.Position.z);
                    Game.EmitEvent("Bootstrap::MyServerSideEntityIsFullyCreatedLocally", {
                        myEntity: this.MyLocalNonPredictedEntity
                    });
                    if ((0, $b80b6e4c153785d9$export$29cd7b75162a9425).Player.ENABLE_PREDICTION) Game.EmitEvent("Prediction::ReadyToCreatePredictedEntity", {
                        originalCreationPayload: this.MyLocalNonPredictedEntity.originalCreationPayload
                    });
                }
            }
            // Lazily associate our local predicted entity if it isnt already
            if ((0, $b80b6e4c153785d9$export$29cd7b75162a9425).Player.ENABLE_PREDICTION) {
                if (this.MyLocalPredictedEntity === undefined && Game.Predictor.GetPredictedEntity() !== undefined) {
                    this.MyLocalPredictedEntity = Game.Predictor.GetPredictedEntity();
                    this._addDebugCube(this.MyLocalPredictedEntity.Position.x, this.MyLocalPredictedEntity.Position.y, this.MyLocalPredictedEntity.Position.z);
                }
            }
            if (this.PlayerRotationProxyCube) {
                if ((0, $b80b6e4c153785d9$export$29cd7b75162a9425).Player.ENABLE_PREDICTION) {
                    if (this.MyLocalPredictedEntity !== undefined) this.PlayerRotationProxyCube.position.copy(this.MyLocalPredictedEntity.Position);
                } else if (this.MyLocalNonPredictedEntity !== undefined) this.PlayerRotationProxyCube.position.copy(this.MyLocalNonPredictedEntity.Position);
            }
            if (this.cameraInitialized && this.cameraFollowingPlayerCharacter === false) {
                if ((0, $b80b6e4c153785d9$export$29cd7b75162a9425).Player.ENABLE_PREDICTION) {
                    if (this.MyLocalPredictedEntity !== undefined && this.MyLocalPredictedEntity.GetModel() !== undefined) {
                        this.thirdPersonCamera.UpdateTarget(this.PlayerRotationProxyCube);
                        this.cameraFollowingPlayerCharacter = true;
                        Game.EmitEvent("Audio::StartMusic");
                    }
                } else if (this.MyLocalNonPredictedEntity !== undefined && this.MyLocalNonPredictedEntity.GetModel() !== undefined) {
                    this.thirdPersonCamera.UpdateTarget(this.PlayerRotationProxyCube);
                    this.cameraFollowingPlayerCharacter = true;
                    Game.EmitEvent("Audio::StartMusic");
                }
            }
            if (this.cameraInitialized) {
                let targetFOV = (0, $b80b6e4c153785d9$export$29cd7b75162a9425).Camera.FOV;
                const prevFOV = this.threeCamera.fov;
                if (this.MyLocalPredictedEntity !== undefined) {
                    // targetFOV = prevFOV;
                    const speedFactor = this.MyLocalPredictedEntity.getSpeedBlockFactor();
                    if (speedFactor > 1) targetFOV *= (0, $b80b6e4c153785d9$export$29cd7b75162a9425).Camera.FOV_SPEED_ADJUST_FACTOR * Math.sqrt(1 + (speedFactor - 1) / 2);
                    else if (speedFactor < 1) targetFOV /= (0, $b80b6e4c153785d9$export$29cd7b75162a9425).Camera.FOV_SPEED_ADJUST_FACTOR * Math.sqrt(1 + (1 - speedFactor) / 2);
                }
                this.threeCamera.fov = (0, $19fa45bc88c77393$export$3a89f8d6f6bf6c9f)(this.threeCamera.fov, targetFOV, Math.min((0, $b80b6e4c153785d9$export$29cd7b75162a9425).Camera.FOV_SPEED_ADJUST_LERP_SPEED * deltaTimeS, 0.8));
                if (Math.abs(this.threeCamera.fov - targetFOV) < 0.01) this.threeCamera.fov = targetFOV;
                if (this.threeCamera.fov !== prevFOV) this.threeCamera.updateProjectionMatrix();
                this.thirdPersonCamera.Update(deltaTimeS);
                this.renderer.render(this.scene, this.threeCamera);
                if ((0, $b80b6e4c153785d9$export$29cd7b75162a9425).Rendering.ENABLE_STATS) this.stats.update();
            }
            if ((0, $b80b6e4c153785d9$export$29cd7b75162a9425).Rendering.ENABLE_STATS) this.stats.end();
            this.particleSystem.update(deltaTimeS);
        } catch (e) {
            console.error(`Caught an error in the renderer: Code: ${e.code} - Message: ${e.message} Error: ${e}`);
        }
    }
    Cleanup() {}
    Resize({ newWidth: newWidth, newHeight: newHeight }) {
        if (this.threeCamera !== undefined) {
            this.threeCamera.aspect = newWidth / newHeight;
            this.threeCamera.updateProjectionMatrix();
            this.renderer.setSize(newWidth, newHeight, true);
        }
    }
    constructor(){
        super();
        this.MyLocalEntityHasInformationPassive = false;
        this.cameraInitialized = false;
        this.cameraFollowingPlayerCharacter = false;
        this.touchStartX = 0;
        this.touchStartY = 0;
        this.currentlyTouchDragging = false;
        this.defaultTextSize = 1.2;
        this.leaderboardBigTextSize = 3.8;
        this.fontLocation = "fonts/LuckiestGuy-Regular.ttf";
        this.leaderBoard = [];
        this.leaderBoardLength = 10;
        this.leaderBoardPosition = new (0, $9014d97cd777be10$export$64b5c384219d3699)(117.5, 18.7, -36.4);
        this.leaderBoardRotationAsMultipleOfPI = 1.5;
        this.leaderBoardVerticalOffset = 2;
        this.leaderBoardFlagHorizontalSize = 1.3;
        this.leaderBoardFlagVerticalSize = 0.975;
        this.globalXOffset = 0;
        this.globalYOffset = 0;
    }
}







function $407c46667e865c99$export$676e3e70c930f774(geometry, MikkTSpace, negateSign = true) {
    if (!MikkTSpace || !MikkTSpace.isReady) throw new Error("BufferGeometryUtils: Initialized MikkTSpace library required.");
    if (!geometry.hasAttribute("position") || !geometry.hasAttribute("normal") || !geometry.hasAttribute("uv")) throw new Error('BufferGeometryUtils: Tangents require "position", "normal", and "uv" attributes.');
    function getAttributeArray(attribute) {
        if (attribute.normalized || attribute.isInterleavedBufferAttribute) {
            const dstArray = new Float32Array(attribute.count * attribute.itemSize);
            for(let i = 0, j = 0; i < attribute.count; i++){
                dstArray[j++] = attribute.getX(i);
                dstArray[j++] = attribute.getY(i);
                if (attribute.itemSize > 2) dstArray[j++] = attribute.getZ(i);
            }
            return dstArray;
        }
        if (attribute.array instanceof Float32Array) return attribute.array;
        return new Float32Array(attribute.array);
    }
    // MikkTSpace algorithm requires non-indexed input.
    const _geometry = geometry.index ? geometry.toNonIndexed() : geometry;
    // Compute vertex tangents.
    const tangents = MikkTSpace.generateTangents(getAttributeArray(_geometry.attributes.position), getAttributeArray(_geometry.attributes.normal), getAttributeArray(_geometry.attributes.uv));
    // Texture coordinate convention of glTF differs from the apparent
    // default of the MikkTSpace library; .w component must be flipped.
    if (negateSign) for(let i = 3; i < tangents.length; i += 4)tangents[i] *= -1;
    //
    _geometry.setAttribute("tangent", new (0, $9014d97cd777be10$export$8dea267bd6bde117)(tangents, 4));
    if (geometry !== _geometry) geometry.copy(_geometry);
    return geometry;
}
/**
 * @param  {Array<BufferGeometry>} geometries
 * @param  {Boolean} useGroups
 * @return {BufferGeometry}
 */ function $407c46667e865c99$export$f06f69b3bf41d25c(geometries, useGroups = false) {
    const isIndexed = geometries[0].index !== null;
    const attributesUsed = new Set(Object.keys(geometries[0].attributes));
    const morphAttributesUsed = new Set(Object.keys(geometries[0].morphAttributes));
    const attributes = {};
    const morphAttributes = {};
    const morphTargetsRelative = geometries[0].morphTargetsRelative;
    const mergedGeometry = new (0, $9014d97cd777be10$export$b7be63a67df8959)();
    let offset = 0;
    for(let i = 0; i < geometries.length; ++i){
        const geometry = geometries[i];
        let attributesCount = 0;
        // ensure that all geometries are indexed, or none
        if (isIndexed !== (geometry.index !== null)) {
            console.error("THREE.BufferGeometryUtils: .mergeGeometries() failed with geometry at index " + i + ". All geometries must have compatible attributes; make sure index attribute exists among all geometries, or in none of them.");
            return null;
        }
        // gather attributes, exit early if they're different
        for(const name in geometry.attributes){
            if (!attributesUsed.has(name)) {
                console.error("THREE.BufferGeometryUtils: .mergeGeometries() failed with geometry at index " + i + '. All geometries must have compatible attributes; make sure "' + name + '" attribute exists among all geometries, or in none of them.');
                return null;
            }
            if (attributes[name] === undefined) attributes[name] = [];
            attributes[name].push(geometry.attributes[name]);
            attributesCount++;
        }
        // ensure geometries have the same number of attributes
        if (attributesCount !== attributesUsed.size) {
            console.error("THREE.BufferGeometryUtils: .mergeGeometries() failed with geometry at index " + i + ". Make sure all geometries have the same number of attributes.");
            return null;
        }
        // gather morph attributes, exit early if they're different
        if (morphTargetsRelative !== geometry.morphTargetsRelative) {
            console.error("THREE.BufferGeometryUtils: .mergeGeometries() failed with geometry at index " + i + ". .morphTargetsRelative must be consistent throughout all geometries.");
            return null;
        }
        for(const name in geometry.morphAttributes){
            if (!morphAttributesUsed.has(name)) {
                console.error("THREE.BufferGeometryUtils: .mergeGeometries() failed with geometry at index " + i + ".  .morphAttributes must be consistent throughout all geometries.");
                return null;
            }
            if (morphAttributes[name] === undefined) morphAttributes[name] = [];
            morphAttributes[name].push(geometry.morphAttributes[name]);
        }
        if (useGroups) {
            let count;
            if (isIndexed) count = geometry.index.count;
            else if (geometry.attributes.position !== undefined) count = geometry.attributes.position.count;
            else {
                console.error("THREE.BufferGeometryUtils: .mergeGeometries() failed with geometry at index " + i + ". The geometry must have either an index or a position attribute");
                return null;
            }
            mergedGeometry.addGroup(offset, count, i);
            offset += count;
        }
    }
    // merge indices
    if (isIndexed) {
        let indexOffset = 0;
        const mergedIndex = [];
        for(let i = 0; i < geometries.length; ++i){
            const index = geometries[i].index;
            for(let j = 0; j < index.count; ++j)mergedIndex.push(index.getX(j) + indexOffset);
            indexOffset += geometries[i].attributes.position.count;
        }
        mergedGeometry.setIndex(mergedIndex);
    }
    // merge attributes
    for(const name in attributes){
        const mergedAttribute = $407c46667e865c99$export$9f98db6234c4bd78(attributes[name]);
        if (!mergedAttribute) {
            console.error("THREE.BufferGeometryUtils: .mergeGeometries() failed while trying to merge the " + name + " attribute.");
            return null;
        }
        mergedGeometry.setAttribute(name, mergedAttribute);
    }
    // merge morph attributes
    for(const name in morphAttributes){
        const numMorphTargets = morphAttributes[name][0].length;
        if (numMorphTargets === 0) break;
        mergedGeometry.morphAttributes = mergedGeometry.morphAttributes || {};
        mergedGeometry.morphAttributes[name] = [];
        for(let i = 0; i < numMorphTargets; ++i){
            const morphAttributesToMerge = [];
            for(let j = 0; j < morphAttributes[name].length; ++j)morphAttributesToMerge.push(morphAttributes[name][j][i]);
            const mergedMorphAttribute = $407c46667e865c99$export$9f98db6234c4bd78(morphAttributesToMerge);
            if (!mergedMorphAttribute) {
                console.error("THREE.BufferGeometryUtils: .mergeGeometries() failed while trying to merge the " + name + " morphAttribute.");
                return null;
            }
            mergedGeometry.morphAttributes[name].push(mergedMorphAttribute);
        }
    }
    return mergedGeometry;
}
/**
 * @param {Array<BufferAttribute>} attributes
 * @return {BufferAttribute}
 */ function $407c46667e865c99$export$9f98db6234c4bd78(attributes) {
    let TypedArray;
    let itemSize;
    let normalized;
    let gpuType = -1;
    let arrayLength = 0;
    for(let i = 0; i < attributes.length; ++i){
        const attribute = attributes[i];
        if (attribute.isInterleavedBufferAttribute) {
            console.error("THREE.BufferGeometryUtils: .mergeAttributes() failed. InterleavedBufferAttributes are not supported.");
            return null;
        }
        if (TypedArray === undefined) TypedArray = attribute.array.constructor;
        if (TypedArray !== attribute.array.constructor) {
            console.error("THREE.BufferGeometryUtils: .mergeAttributes() failed. BufferAttribute.array must be of consistent array types across matching attributes.");
            return null;
        }
        if (itemSize === undefined) itemSize = attribute.itemSize;
        if (itemSize !== attribute.itemSize) {
            console.error("THREE.BufferGeometryUtils: .mergeAttributes() failed. BufferAttribute.itemSize must be consistent across matching attributes.");
            return null;
        }
        if (normalized === undefined) normalized = attribute.normalized;
        if (normalized !== attribute.normalized) {
            console.error("THREE.BufferGeometryUtils: .mergeAttributes() failed. BufferAttribute.normalized must be consistent across matching attributes.");
            return null;
        }
        if (gpuType === -1) gpuType = attribute.gpuType;
        if (gpuType !== attribute.gpuType) {
            console.error("THREE.BufferGeometryUtils: .mergeAttributes() failed. BufferAttribute.gpuType must be consistent across matching attributes.");
            return null;
        }
        arrayLength += attribute.array.length;
    }
    const array = new TypedArray(arrayLength);
    let offset = 0;
    for(let i = 0; i < attributes.length; ++i){
        array.set(attributes[i].array, offset);
        offset += attributes[i].array.length;
    }
    const result = new (0, $9014d97cd777be10$export$8dea267bd6bde117)(array, itemSize, normalized);
    if (gpuType !== undefined) result.gpuType = gpuType;
    return result;
}
function $407c46667e865c99$export$4848639a9adff548(attribute) {
    if (attribute.isInstancedInterleavedBufferAttribute || attribute.isInterleavedBufferAttribute) return $407c46667e865c99$export$4b7aa2f2134b7e19(attribute);
    if (attribute.isInstancedBufferAttribute) return new (0, $9014d97cd777be10$export$32ea87a8b54d744a)().copy(attribute);
    return new (0, $9014d97cd777be10$export$8dea267bd6bde117)().copy(attribute);
}
/**
 * @param {Array<BufferAttribute>} attributes
 * @return {Array<InterleavedBufferAttribute>}
 */ function $407c46667e865c99$export$308f9509e428a845(attributes) {
    // Interleaves the provided attributes into an InterleavedBuffer and returns
    // a set of InterleavedBufferAttributes for each attribute
    let TypedArray;
    let arrayLength = 0;
    let stride = 0;
    // calculate the length and type of the interleavedBuffer
    for(let i = 0, l = attributes.length; i < l; ++i){
        const attribute = attributes[i];
        if (TypedArray === undefined) TypedArray = attribute.array.constructor;
        if (TypedArray !== attribute.array.constructor) {
            console.error("AttributeBuffers of different types cannot be interleaved");
            return null;
        }
        arrayLength += attribute.array.length;
        stride += attribute.itemSize;
    }
    // Create the set of buffer attributes
    const interleavedBuffer = new (0, $9014d97cd777be10$export$3d5cd879f108f53f)(new TypedArray(arrayLength), stride);
    let offset = 0;
    const res = [];
    const getters = [
        "getX",
        "getY",
        "getZ",
        "getW"
    ];
    const setters = [
        "setX",
        "setY",
        "setZ",
        "setW"
    ];
    for(let j = 0, l = attributes.length; j < l; j++){
        const attribute = attributes[j];
        const itemSize = attribute.itemSize;
        const count = attribute.count;
        const iba = new (0, $9014d97cd777be10$export$920b6d07334599c7)(interleavedBuffer, itemSize, offset, attribute.normalized);
        res.push(iba);
        offset += itemSize;
        // Move the data for each attribute into the new interleavedBuffer
        // at the appropriate offset
        for(let c = 0; c < count; c++)for(let k = 0; k < itemSize; k++)iba[setters[k]](c, attribute[getters[k]](c));
    }
    return res;
}
function $407c46667e865c99$export$4b7aa2f2134b7e19(attribute) {
    const cons = attribute.data.array.constructor;
    const count = attribute.count;
    const itemSize = attribute.itemSize;
    const normalized = attribute.normalized;
    const array = new cons(count * itemSize);
    let newAttribute;
    if (attribute.isInstancedInterleavedBufferAttribute) newAttribute = new (0, $9014d97cd777be10$export$32ea87a8b54d744a)(array, itemSize, normalized, attribute.meshPerAttribute);
    else newAttribute = new (0, $9014d97cd777be10$export$8dea267bd6bde117)(array, itemSize, normalized);
    for(let i = 0; i < count; i++){
        newAttribute.setX(i, attribute.getX(i));
        if (itemSize >= 2) newAttribute.setY(i, attribute.getY(i));
        if (itemSize >= 3) newAttribute.setZ(i, attribute.getZ(i));
        if (itemSize >= 4) newAttribute.setW(i, attribute.getW(i));
    }
    return newAttribute;
}
function $407c46667e865c99$export$e7413b17bfaaa80b(geometry) {
    const attributes = geometry.attributes;
    const morphTargets = geometry.morphTargets;
    const attrMap = new Map();
    for(const key in attributes){
        const attr = attributes[key];
        if (attr.isInterleavedBufferAttribute) {
            if (!attrMap.has(attr)) attrMap.set(attr, $407c46667e865c99$export$4b7aa2f2134b7e19(attr));
            attributes[key] = attrMap.get(attr);
        }
    }
    for(const key in morphTargets){
        const attr = morphTargets[key];
        if (attr.isInterleavedBufferAttribute) {
            if (!attrMap.has(attr)) attrMap.set(attr, $407c46667e865c99$export$4b7aa2f2134b7e19(attr));
            morphTargets[key] = attrMap.get(attr);
        }
    }
}
/**
 * @param {Array<BufferGeometry>} geometry
 * @return {number}
 */ function $407c46667e865c99$export$35bee7999e19754d(geometry) {
    // Return the estimated memory used by this geometry in bytes
    // Calculate using itemSize, count, and BYTES_PER_ELEMENT to account
    // for InterleavedBufferAttributes.
    let mem = 0;
    for(const name in geometry.attributes){
        const attr = geometry.getAttribute(name);
        mem += attr.count * attr.itemSize * attr.array.BYTES_PER_ELEMENT;
    }
    const indices = geometry.getIndex();
    mem += indices ? indices.count * indices.itemSize * indices.array.BYTES_PER_ELEMENT : 0;
    return mem;
}
/**
 * @param {BufferGeometry} geometry
 * @param {number} tolerance
 * @return {BufferGeometry}
 */ function $407c46667e865c99$export$e36bb98c4c944f9(geometry, tolerance = 1e-4) {
    tolerance = Math.max(tolerance, Number.EPSILON);
    // Generate an index buffer if the geometry doesn't have one, or optimize it
    // if it's already available.
    const hashToIndex = {};
    const indices = geometry.getIndex();
    const positions = geometry.getAttribute("position");
    const vertexCount = indices ? indices.count : positions.count;
    // next value for triangle indices
    let nextIndex = 0;
    // attributes and new attribute arrays
    const attributeNames = Object.keys(geometry.attributes);
    const tmpAttributes = {};
    const tmpMorphAttributes = {};
    const newIndices = [];
    const getters = [
        "getX",
        "getY",
        "getZ",
        "getW"
    ];
    const setters = [
        "setX",
        "setY",
        "setZ",
        "setW"
    ];
    // Initialize the arrays, allocating space conservatively. Extra
    // space will be trimmed in the last step.
    for(let i = 0, l = attributeNames.length; i < l; i++){
        const name = attributeNames[i];
        const attr = geometry.attributes[name];
        tmpAttributes[name] = new (0, $9014d97cd777be10$export$8dea267bd6bde117)(new attr.array.constructor(attr.count * attr.itemSize), attr.itemSize, attr.normalized);
        const morphAttr = geometry.morphAttributes[name];
        if (morphAttr) tmpMorphAttributes[name] = new (0, $9014d97cd777be10$export$8dea267bd6bde117)(new morphAttr.array.constructor(morphAttr.count * morphAttr.itemSize), morphAttr.itemSize, morphAttr.normalized);
    }
    // convert the error tolerance to an amount of decimal places to truncate to
    const decimalShift = Math.log10(1 / tolerance);
    const shiftMultiplier = Math.pow(10, decimalShift);
    for(let i = 0; i < vertexCount; i++){
        const index = indices ? indices.getX(i) : i;
        // Generate a hash for the vertex attributes at the current index 'i'
        let hash = "";
        for(let j = 0, l = attributeNames.length; j < l; j++){
            const name = attributeNames[j];
            const attribute = geometry.getAttribute(name);
            const itemSize = attribute.itemSize;
            for(let k = 0; k < itemSize; k++)// double tilde truncates the decimal value
            hash += `${~~(attribute[getters[k]](index) * shiftMultiplier)},`;
        }
        // Add another reference to the vertex if it's already
        // used by another index
        if (hash in hashToIndex) newIndices.push(hashToIndex[hash]);
        else {
            // copy data to the new index in the temporary attributes
            for(let j = 0, l = attributeNames.length; j < l; j++){
                const name = attributeNames[j];
                const attribute = geometry.getAttribute(name);
                const morphAttr = geometry.morphAttributes[name];
                const itemSize = attribute.itemSize;
                const newarray = tmpAttributes[name];
                const newMorphArrays = tmpMorphAttributes[name];
                for(let k = 0; k < itemSize; k++){
                    const getterFunc = getters[k];
                    const setterFunc = setters[k];
                    newarray[setterFunc](nextIndex, attribute[getterFunc](index));
                    if (morphAttr) for(let m = 0, ml = morphAttr.length; m < ml; m++)newMorphArrays[m][setterFunc](nextIndex, morphAttr[m][getterFunc](index));
                }
            }
            hashToIndex[hash] = nextIndex;
            newIndices.push(nextIndex);
            nextIndex++;
        }
    }
    // generate result BufferGeometry
    const result = geometry.clone();
    for(const name in geometry.attributes){
        const tmpAttribute = tmpAttributes[name];
        result.setAttribute(name, new (0, $9014d97cd777be10$export$8dea267bd6bde117)(tmpAttribute.array.slice(0, nextIndex * tmpAttribute.itemSize), tmpAttribute.itemSize, tmpAttribute.normalized));
        if (!(name in tmpMorphAttributes)) continue;
        for(let j = 0; j < tmpMorphAttributes[name].length; j++){
            const tmpMorphAttribute = tmpMorphAttributes[name][j];
            result.morphAttributes[name][j] = new (0, $9014d97cd777be10$export$8dea267bd6bde117)(tmpMorphAttribute.array.slice(0, nextIndex * tmpMorphAttribute.itemSize), tmpMorphAttribute.itemSize, tmpMorphAttribute.normalized);
        }
    }
    // indices
    result.setIndex(newIndices);
    return result;
}
/**
 * @param {BufferGeometry} geometry
 * @param {number} drawMode
 * @return {BufferGeometry}
 */ function $407c46667e865c99$export$5492ca6e5c0c7aa0(geometry, drawMode) {
    if (drawMode === (0, $9014d97cd777be10$export$4c28c87c2dc84758)) {
        console.warn("THREE.BufferGeometryUtils.toTrianglesDrawMode(): Geometry already defined as triangles.");
        return geometry;
    }
    if (drawMode === (0, $9014d97cd777be10$export$f0d8293634f88842) || drawMode === (0, $9014d97cd777be10$export$b23a071aa286eb29)) {
        let index = geometry.getIndex();
        // generate index if not present
        if (index === null) {
            const indices = [];
            const position = geometry.getAttribute("position");
            if (position !== undefined) {
                for(let i = 0; i < position.count; i++)indices.push(i);
                geometry.setIndex(indices);
                index = geometry.getIndex();
            } else {
                console.error("THREE.BufferGeometryUtils.toTrianglesDrawMode(): Undefined position attribute. Processing not possible.");
                return geometry;
            }
        }
        //
        const numberOfTriangles = index.count - 2;
        const newIndices = [];
        if (drawMode === (0, $9014d97cd777be10$export$f0d8293634f88842)) // gl.TRIANGLE_FAN
        for(let i = 1; i <= numberOfTriangles; i++){
            newIndices.push(index.getX(0));
            newIndices.push(index.getX(i));
            newIndices.push(index.getX(i + 1));
        }
        else {
            // gl.TRIANGLE_STRIP
            for(let i = 0; i < numberOfTriangles; i++)if (i % 2 === 0) {
                newIndices.push(index.getX(i));
                newIndices.push(index.getX(i + 1));
                newIndices.push(index.getX(i + 2));
            } else {
                newIndices.push(index.getX(i + 2));
                newIndices.push(index.getX(i + 1));
                newIndices.push(index.getX(i));
            }
        }
        if (newIndices.length / 3 !== numberOfTriangles) console.error("THREE.BufferGeometryUtils.toTrianglesDrawMode(): Unable to generate correct amount of triangles.");
        // build final geometry
        const newGeometry = geometry.clone();
        newGeometry.setIndex(newIndices);
        newGeometry.clearGroups();
        return newGeometry;
    } else {
        console.error("THREE.BufferGeometryUtils.toTrianglesDrawMode(): Unknown draw mode:", drawMode);
        return geometry;
    }
}
/**
 * Calculates the morphed attributes of a morphed/skinned BufferGeometry.
 * Helpful for Raytracing or Decals.
 * @param {Mesh | Line | Points} object An instance of Mesh, Line or Points.
 * @return {Object} An Object with original position/normal attributes and morphed ones.
 */ function $407c46667e865c99$export$29e54e2e4ab904e7(object) {
    const _vA = new (0, $9014d97cd777be10$export$64b5c384219d3699)();
    const _vB = new (0, $9014d97cd777be10$export$64b5c384219d3699)();
    const _vC = new (0, $9014d97cd777be10$export$64b5c384219d3699)();
    const _tempA = new (0, $9014d97cd777be10$export$64b5c384219d3699)();
    const _tempB = new (0, $9014d97cd777be10$export$64b5c384219d3699)();
    const _tempC = new (0, $9014d97cd777be10$export$64b5c384219d3699)();
    const _morphA = new (0, $9014d97cd777be10$export$64b5c384219d3699)();
    const _morphB = new (0, $9014d97cd777be10$export$64b5c384219d3699)();
    const _morphC = new (0, $9014d97cd777be10$export$64b5c384219d3699)();
    function _calculateMorphedAttributeData(object, attribute, morphAttribute, morphTargetsRelative, a, b, c, modifiedAttributeArray) {
        _vA.fromBufferAttribute(attribute, a);
        _vB.fromBufferAttribute(attribute, b);
        _vC.fromBufferAttribute(attribute, c);
        const morphInfluences = object.morphTargetInfluences;
        if (morphAttribute && morphInfluences) {
            _morphA.set(0, 0, 0);
            _morphB.set(0, 0, 0);
            _morphC.set(0, 0, 0);
            for(let i = 0, il = morphAttribute.length; i < il; i++){
                const influence = morphInfluences[i];
                const morph = morphAttribute[i];
                if (influence === 0) continue;
                _tempA.fromBufferAttribute(morph, a);
                _tempB.fromBufferAttribute(morph, b);
                _tempC.fromBufferAttribute(morph, c);
                if (morphTargetsRelative) {
                    _morphA.addScaledVector(_tempA, influence);
                    _morphB.addScaledVector(_tempB, influence);
                    _morphC.addScaledVector(_tempC, influence);
                } else {
                    _morphA.addScaledVector(_tempA.sub(_vA), influence);
                    _morphB.addScaledVector(_tempB.sub(_vB), influence);
                    _morphC.addScaledVector(_tempC.sub(_vC), influence);
                }
            }
            _vA.add(_morphA);
            _vB.add(_morphB);
            _vC.add(_morphC);
        }
        if (object.isSkinnedMesh) {
            object.applyBoneTransform(a, _vA);
            object.applyBoneTransform(b, _vB);
            object.applyBoneTransform(c, _vC);
        }
        modifiedAttributeArray[a * 3 + 0] = _vA.x;
        modifiedAttributeArray[a * 3 + 1] = _vA.y;
        modifiedAttributeArray[a * 3 + 2] = _vA.z;
        modifiedAttributeArray[b * 3 + 0] = _vB.x;
        modifiedAttributeArray[b * 3 + 1] = _vB.y;
        modifiedAttributeArray[b * 3 + 2] = _vB.z;
        modifiedAttributeArray[c * 3 + 0] = _vC.x;
        modifiedAttributeArray[c * 3 + 1] = _vC.y;
        modifiedAttributeArray[c * 3 + 2] = _vC.z;
    }
    const geometry = object.geometry;
    const material = object.material;
    let a, b, c;
    const index = geometry.index;
    const positionAttribute = geometry.attributes.position;
    const morphPosition = geometry.morphAttributes.position;
    const morphTargetsRelative = geometry.morphTargetsRelative;
    const normalAttribute = geometry.attributes.normal;
    const morphNormal = geometry.morphAttributes.position;
    const groups = geometry.groups;
    const drawRange = geometry.drawRange;
    let i, j, il, jl;
    let group;
    let start, end;
    const modifiedPosition = new Float32Array(positionAttribute.count * positionAttribute.itemSize);
    const modifiedNormal = new Float32Array(normalAttribute.count * normalAttribute.itemSize);
    if (index !== null) {
        // indexed buffer geometry
        if (Array.isArray(material)) for(i = 0, il = groups.length; i < il; i++){
            group = groups[i];
            start = Math.max(group.start, drawRange.start);
            end = Math.min(group.start + group.count, drawRange.start + drawRange.count);
            for(j = start, jl = end; j < jl; j += 3){
                a = index.getX(j);
                b = index.getX(j + 1);
                c = index.getX(j + 2);
                _calculateMorphedAttributeData(object, positionAttribute, morphPosition, morphTargetsRelative, a, b, c, modifiedPosition);
                _calculateMorphedAttributeData(object, normalAttribute, morphNormal, morphTargetsRelative, a, b, c, modifiedNormal);
            }
        }
        else {
            start = Math.max(0, drawRange.start);
            end = Math.min(index.count, drawRange.start + drawRange.count);
            for(i = start, il = end; i < il; i += 3){
                a = index.getX(i);
                b = index.getX(i + 1);
                c = index.getX(i + 2);
                _calculateMorphedAttributeData(object, positionAttribute, morphPosition, morphTargetsRelative, a, b, c, modifiedPosition);
                _calculateMorphedAttributeData(object, normalAttribute, morphNormal, morphTargetsRelative, a, b, c, modifiedNormal);
            }
        }
    } else {
        // non-indexed buffer geometry
        if (Array.isArray(material)) for(i = 0, il = groups.length; i < il; i++){
            group = groups[i];
            start = Math.max(group.start, drawRange.start);
            end = Math.min(group.start + group.count, drawRange.start + drawRange.count);
            for(j = start, jl = end; j < jl; j += 3){
                a = j;
                b = j + 1;
                c = j + 2;
                _calculateMorphedAttributeData(object, positionAttribute, morphPosition, morphTargetsRelative, a, b, c, modifiedPosition);
                _calculateMorphedAttributeData(object, normalAttribute, morphNormal, morphTargetsRelative, a, b, c, modifiedNormal);
            }
        }
        else {
            start = Math.max(0, drawRange.start);
            end = Math.min(positionAttribute.count, drawRange.start + drawRange.count);
            for(i = start, il = end; i < il; i += 3){
                a = i;
                b = i + 1;
                c = i + 2;
                _calculateMorphedAttributeData(object, positionAttribute, morphPosition, morphTargetsRelative, a, b, c, modifiedPosition);
                _calculateMorphedAttributeData(object, normalAttribute, morphNormal, morphTargetsRelative, a, b, c, modifiedNormal);
            }
        }
    }
    const morphedPositionAttribute = new (0, $9014d97cd777be10$export$cbe7a62641830ebd)(modifiedPosition, 3);
    const morphedNormalAttribute = new (0, $9014d97cd777be10$export$cbe7a62641830ebd)(modifiedNormal, 3);
    return {
        positionAttribute: positionAttribute,
        normalAttribute: normalAttribute,
        morphedPositionAttribute: morphedPositionAttribute,
        morphedNormalAttribute: morphedNormalAttribute
    };
}
function $407c46667e865c99$export$8babbf41197098b1(geometry) {
    if (geometry.groups.length === 0) {
        console.warn("THREE.BufferGeometryUtils.mergeGroups(): No groups are defined. Nothing to merge.");
        return geometry;
    }
    let groups = geometry.groups;
    // sort groups by material index
    groups = groups.sort((a, b)=>{
        if (a.materialIndex !== b.materialIndex) return a.materialIndex - b.materialIndex;
        return a.start - b.start;
    });
    // create index for non-indexed geometries
    if (geometry.getIndex() === null) {
        const positionAttribute = geometry.getAttribute("position");
        const indices = [];
        for(let i = 0; i < positionAttribute.count; i += 3)indices.push(i, i + 1, i + 2);
        geometry.setIndex(indices);
    }
    // sort index
    const index = geometry.getIndex();
    const newIndices = [];
    for(let i = 0; i < groups.length; i++){
        const group = groups[i];
        const groupStart = group.start;
        const groupLength = groupStart + group.count;
        for(let j = groupStart; j < groupLength; j++)newIndices.push(index.getX(j));
    }
    geometry.dispose(); // Required to force buffer recreation
    geometry.setIndex(newIndices);
    // update groups indices
    let start = 0;
    for(let i = 0; i < groups.length; i++){
        const group = groups[i];
        group.start = start;
        start += group.count;
    }
    // merge groups
    let currentGroup = groups[0];
    geometry.groups = [
        currentGroup
    ];
    for(let i = 1; i < groups.length; i++){
        const group = groups[i];
        if (currentGroup.materialIndex === group.materialIndex) currentGroup.count += group.count;
        else {
            currentGroup = group;
            geometry.groups.push(currentGroup);
        }
    }
    return geometry;
}
/**
 * Modifies the supplied geometry if it is non-indexed, otherwise creates a new,
 * non-indexed geometry. Returns the geometry with smooth normals everywhere except
 * faces that meet at an angle greater than the crease angle.
 *
 * @param {BufferGeometry} geometry
 * @param {number} [creaseAngle]
 * @return {BufferGeometry}
 */ function $407c46667e865c99$export$b525764477fc001f(geometry, creaseAngle = Math.PI / 3 /* 60 degrees */ ) {
    const creaseDot = Math.cos(creaseAngle);
    const hashMultiplier = (1 + 1e-10) * 1e2;
    // reusable vectors
    const verts = [
        new (0, $9014d97cd777be10$export$64b5c384219d3699)(),
        new (0, $9014d97cd777be10$export$64b5c384219d3699)(),
        new (0, $9014d97cd777be10$export$64b5c384219d3699)()
    ];
    const tempVec1 = new (0, $9014d97cd777be10$export$64b5c384219d3699)();
    const tempVec2 = new (0, $9014d97cd777be10$export$64b5c384219d3699)();
    const tempNorm = new (0, $9014d97cd777be10$export$64b5c384219d3699)();
    const tempNorm2 = new (0, $9014d97cd777be10$export$64b5c384219d3699)();
    // hashes a vector
    function hashVertex(v) {
        const x = ~~(v.x * hashMultiplier);
        const y = ~~(v.y * hashMultiplier);
        const z = ~~(v.z * hashMultiplier);
        return `${x},${y},${z}`;
    }
    // BufferGeometry.toNonIndexed() warns if the geometry is non-indexed
    // and returns the original geometry
    const resultGeometry = geometry.index ? geometry.toNonIndexed() : geometry;
    const posAttr = resultGeometry.attributes.position;
    const vertexMap = {};
    // find all the normals shared by commonly located vertices
    for(let i = 0, l = posAttr.count / 3; i < l; i++){
        const i3 = 3 * i;
        const a = verts[0].fromBufferAttribute(posAttr, i3 + 0);
        const b = verts[1].fromBufferAttribute(posAttr, i3 + 1);
        const c = verts[2].fromBufferAttribute(posAttr, i3 + 2);
        tempVec1.subVectors(c, b);
        tempVec2.subVectors(a, b);
        // add the normal to the map for all vertices
        const normal = new (0, $9014d97cd777be10$export$64b5c384219d3699)().crossVectors(tempVec1, tempVec2).normalize();
        for(let n = 0; n < 3; n++){
            const vert = verts[n];
            const hash = hashVertex(vert);
            if (!(hash in vertexMap)) vertexMap[hash] = [];
            vertexMap[hash].push(normal);
        }
    }
    // average normals from all vertices that share a common location if they are within the
    // provided crease threshold
    const normalArray = new Float32Array(posAttr.count * 3);
    const normAttr = new (0, $9014d97cd777be10$export$8dea267bd6bde117)(normalArray, 3, false);
    for(let i = 0, l = posAttr.count / 3; i < l; i++){
        // get the face normal for this vertex
        const i3 = 3 * i;
        const a = verts[0].fromBufferAttribute(posAttr, i3 + 0);
        const b = verts[1].fromBufferAttribute(posAttr, i3 + 1);
        const c = verts[2].fromBufferAttribute(posAttr, i3 + 2);
        tempVec1.subVectors(c, b);
        tempVec2.subVectors(a, b);
        tempNorm.crossVectors(tempVec1, tempVec2).normalize();
        // average all normals that meet the threshold and set the normal value
        for(let n = 0; n < 3; n++){
            const vert = verts[n];
            const hash = hashVertex(vert);
            const otherNormals = vertexMap[hash];
            tempNorm2.set(0, 0, 0);
            for(let k = 0, lk = otherNormals.length; k < lk; k++){
                const otherNorm = otherNormals[k];
                if (tempNorm.dot(otherNorm) > creaseDot) tempNorm2.add(otherNorm);
            }
            tempNorm2.normalize();
            normAttr.setXYZ(i3 + n, tempNorm2.x, tempNorm2.y, tempNorm2.z);
        }
    }
    resultGeometry.setAttribute("normal", normAttr);
    return resultGeometry;
}
function $407c46667e865c99$export$728c051ccdf8a702(geometries, useGroups = false) {
    console.warn("THREE.BufferGeometryUtils: mergeBufferGeometries() has been renamed to mergeGeometries()."); // @deprecated, r151
    return $407c46667e865c99$export$f06f69b3bf41d25c(geometries, useGroups);
}
function $407c46667e865c99$export$c4eef4c1c9d34ea9(attributes) {
    console.warn("THREE.BufferGeometryUtils: mergeBufferAttributes() has been renamed to mergeAttributes()."); // @deprecated, r151
    return $407c46667e865c99$export$9f98db6234c4bd78(attributes);
}


class $50ee5a35738b214d$export$aa93f11e7884f0f4 extends (0, $9014d97cd777be10$export$3b0d6d7590275603) {
    load(url, onLoad, onProgress, onError) {
        const scope = this;
        let resourcePath;
        if (this.resourcePath !== "") resourcePath = this.resourcePath;
        else if (this.path !== "") resourcePath = this.path;
        else resourcePath = (0, $9014d97cd777be10$export$b5d2dc08d867e41a).extractUrlBase(url);
        // Tells the LoadingManager to track an extra item, which resolves after
        // the model is fully loaded. This means the count of items loaded will
        // be incorrect, but ensures manager.onLoad() does not fire early.
        this.manager.itemStart(url);
        const _onError = function(e) {
            if (onError) onError(e);
            else console.error(e);
            scope.manager.itemError(url);
            scope.manager.itemEnd(url);
        };
        const loader = new (0, $9014d97cd777be10$export$98435a25b5cf7b2b)(this.manager);
        loader.setPath(this.path);
        loader.setResponseType("arraybuffer");
        loader.setRequestHeader(this.requestHeader);
        loader.setWithCredentials(this.withCredentials);
        loader.load(url, function(data) {
            try {
                scope.parse(data, resourcePath, function(gltf) {
                    onLoad(gltf);
                    scope.manager.itemEnd(url);
                }, _onError);
            } catch (e) {
                _onError(e);
            }
        }, onProgress, _onError);
    }
    setDRACOLoader(dracoLoader) {
        this.dracoLoader = dracoLoader;
        return this;
    }
    setDDSLoader() {
        throw new Error('THREE.GLTFLoader: "MSFT_texture_dds" no longer supported. Please update to "KHR_texture_basisu".');
    }
    setKTX2Loader(ktx2Loader) {
        this.ktx2Loader = ktx2Loader;
        return this;
    }
    setMeshoptDecoder(meshoptDecoder) {
        this.meshoptDecoder = meshoptDecoder;
        return this;
    }
    register(callback) {
        if (this.pluginCallbacks.indexOf(callback) === -1) this.pluginCallbacks.push(callback);
        return this;
    }
    unregister(callback) {
        if (this.pluginCallbacks.indexOf(callback) !== -1) this.pluginCallbacks.splice(this.pluginCallbacks.indexOf(callback), 1);
        return this;
    }
    parse(data, path, onLoad, onError) {
        let json;
        const extensions = {};
        const plugins = {};
        const textDecoder = new TextDecoder();
        if (typeof data === "string") json = JSON.parse(data);
        else if (data instanceof ArrayBuffer) {
            const magic = textDecoder.decode(new Uint8Array(data, 0, 4));
            if (magic === $50ee5a35738b214d$var$BINARY_EXTENSION_HEADER_MAGIC) {
                try {
                    extensions[$50ee5a35738b214d$var$EXTENSIONS.KHR_BINARY_GLTF] = new $50ee5a35738b214d$var$GLTFBinaryExtension(data);
                } catch (error) {
                    if (onError) onError(error);
                    return;
                }
                json = JSON.parse(extensions[$50ee5a35738b214d$var$EXTENSIONS.KHR_BINARY_GLTF].content);
            } else json = JSON.parse(textDecoder.decode(data));
        } else json = data;
        if (json.asset === undefined || json.asset.version[0] < 2) {
            if (onError) onError(new Error("THREE.GLTFLoader: Unsupported asset. glTF versions >=2.0 are supported."));
            return;
        }
        const parser = new $50ee5a35738b214d$var$GLTFParser(json, {
            path: path || this.resourcePath || "",
            crossOrigin: this.crossOrigin,
            requestHeader: this.requestHeader,
            manager: this.manager,
            ktx2Loader: this.ktx2Loader,
            meshoptDecoder: this.meshoptDecoder
        });
        parser.fileLoader.setRequestHeader(this.requestHeader);
        for(let i = 0; i < this.pluginCallbacks.length; i++){
            const plugin = this.pluginCallbacks[i](parser);
            plugins[plugin.name] = plugin;
            // Workaround to avoid determining as unknown extension
            // in addUnknownExtensionsToUserData().
            // Remove this workaround if we move all the existing
            // extension handlers to plugin system
            extensions[plugin.name] = true;
        }
        if (json.extensionsUsed) for(let i = 0; i < json.extensionsUsed.length; ++i){
            const extensionName = json.extensionsUsed[i];
            const extensionsRequired = json.extensionsRequired || [];
            switch(extensionName){
                case $50ee5a35738b214d$var$EXTENSIONS.KHR_MATERIALS_UNLIT:
                    extensions[extensionName] = new $50ee5a35738b214d$var$GLTFMaterialsUnlitExtension();
                    break;
                case $50ee5a35738b214d$var$EXTENSIONS.KHR_DRACO_MESH_COMPRESSION:
                    extensions[extensionName] = new $50ee5a35738b214d$var$GLTFDracoMeshCompressionExtension(json, this.dracoLoader);
                    break;
                case $50ee5a35738b214d$var$EXTENSIONS.KHR_TEXTURE_TRANSFORM:
                    extensions[extensionName] = new $50ee5a35738b214d$var$GLTFTextureTransformExtension();
                    break;
                case $50ee5a35738b214d$var$EXTENSIONS.KHR_MESH_QUANTIZATION:
                    extensions[extensionName] = new $50ee5a35738b214d$var$GLTFMeshQuantizationExtension();
                    break;
                default:
                    if (extensionsRequired.indexOf(extensionName) >= 0 && plugins[extensionName] === undefined) console.warn('THREE.GLTFLoader: Unknown extension "' + extensionName + '".');
            }
        }
        parser.setExtensions(extensions);
        parser.setPlugins(plugins);
        parser.parse(onLoad, onError);
    }
    parseAsync(data, path) {
        const scope = this;
        return new Promise(function(resolve, reject) {
            scope.parse(data, path, resolve, reject);
        });
    }
    constructor(manager){
        super(manager);
        this.dracoLoader = null;
        this.ktx2Loader = null;
        this.meshoptDecoder = null;
        this.pluginCallbacks = [];
        this.register(function(parser) {
            return new $50ee5a35738b214d$var$GLTFMaterialsClearcoatExtension(parser);
        });
        this.register(function(parser) {
            return new $50ee5a35738b214d$var$GLTFTextureBasisUExtension(parser);
        });
        this.register(function(parser) {
            return new $50ee5a35738b214d$var$GLTFTextureWebPExtension(parser);
        });
        this.register(function(parser) {
            return new $50ee5a35738b214d$var$GLTFTextureAVIFExtension(parser);
        });
        this.register(function(parser) {
            return new $50ee5a35738b214d$var$GLTFMaterialsSheenExtension(parser);
        });
        this.register(function(parser) {
            return new $50ee5a35738b214d$var$GLTFMaterialsTransmissionExtension(parser);
        });
        this.register(function(parser) {
            return new $50ee5a35738b214d$var$GLTFMaterialsVolumeExtension(parser);
        });
        this.register(function(parser) {
            return new $50ee5a35738b214d$var$GLTFMaterialsIorExtension(parser);
        });
        this.register(function(parser) {
            return new $50ee5a35738b214d$var$GLTFMaterialsEmissiveStrengthExtension(parser);
        });
        this.register(function(parser) {
            return new $50ee5a35738b214d$var$GLTFMaterialsSpecularExtension(parser);
        });
        this.register(function(parser) {
            return new $50ee5a35738b214d$var$GLTFMaterialsIridescenceExtension(parser);
        });
        this.register(function(parser) {
            return new $50ee5a35738b214d$var$GLTFMaterialsAnisotropyExtension(parser);
        });
        this.register(function(parser) {
            return new $50ee5a35738b214d$var$GLTFLightsExtension(parser);
        });
        this.register(function(parser) {
            return new $50ee5a35738b214d$var$GLTFMeshoptCompression(parser);
        });
        this.register(function(parser) {
            return new $50ee5a35738b214d$var$GLTFMeshGpuInstancing(parser);
        });
    }
}
/* GLTFREGISTRY */ function $50ee5a35738b214d$var$GLTFRegistry() {
    let objects = {};
    return {
        get: function(key) {
            return objects[key];
        },
        add: function(key, object) {
            objects[key] = object;
        },
        remove: function(key) {
            delete objects[key];
        },
        removeAll: function() {
            objects = {};
        }
    };
}
/*********************************/ /********** EXTENSIONS ***********/ /*********************************/ const $50ee5a35738b214d$var$EXTENSIONS = {
    KHR_BINARY_GLTF: "KHR_binary_glTF",
    KHR_DRACO_MESH_COMPRESSION: "KHR_draco_mesh_compression",
    KHR_LIGHTS_PUNCTUAL: "KHR_lights_punctual",
    KHR_MATERIALS_CLEARCOAT: "KHR_materials_clearcoat",
    KHR_MATERIALS_IOR: "KHR_materials_ior",
    KHR_MATERIALS_SHEEN: "KHR_materials_sheen",
    KHR_MATERIALS_SPECULAR: "KHR_materials_specular",
    KHR_MATERIALS_TRANSMISSION: "KHR_materials_transmission",
    KHR_MATERIALS_IRIDESCENCE: "KHR_materials_iridescence",
    KHR_MATERIALS_ANISOTROPY: "KHR_materials_anisotropy",
    KHR_MATERIALS_UNLIT: "KHR_materials_unlit",
    KHR_MATERIALS_VOLUME: "KHR_materials_volume",
    KHR_TEXTURE_BASISU: "KHR_texture_basisu",
    KHR_TEXTURE_TRANSFORM: "KHR_texture_transform",
    KHR_MESH_QUANTIZATION: "KHR_mesh_quantization",
    KHR_MATERIALS_EMISSIVE_STRENGTH: "KHR_materials_emissive_strength",
    EXT_TEXTURE_WEBP: "EXT_texture_webp",
    EXT_TEXTURE_AVIF: "EXT_texture_avif",
    EXT_MESHOPT_COMPRESSION: "EXT_meshopt_compression",
    EXT_MESH_GPU_INSTANCING: "EXT_mesh_gpu_instancing"
};
/**
 * Punctual Lights Extension
 *
 * Specification: https://github.com/KhronosGroup/glTF/tree/master/extensions/2.0/Khronos/KHR_lights_punctual
 */ class $50ee5a35738b214d$var$GLTFLightsExtension {
    _markDefs() {
        const parser = this.parser;
        const nodeDefs = this.parser.json.nodes || [];
        for(let nodeIndex = 0, nodeLength = nodeDefs.length; nodeIndex < nodeLength; nodeIndex++){
            const nodeDef = nodeDefs[nodeIndex];
            if (nodeDef.extensions && nodeDef.extensions[this.name] && nodeDef.extensions[this.name].light !== undefined) parser._addNodeRef(this.cache, nodeDef.extensions[this.name].light);
        }
    }
    _loadLight(lightIndex) {
        const parser = this.parser;
        const cacheKey = "light:" + lightIndex;
        let dependency = parser.cache.get(cacheKey);
        if (dependency) return dependency;
        const json = parser.json;
        const extensions = json.extensions && json.extensions[this.name] || {};
        const lightDefs = extensions.lights || [];
        const lightDef = lightDefs[lightIndex];
        let lightNode;
        const color = new (0, $9014d97cd777be10$export$892596cec99bc70e)(0xffffff);
        if (lightDef.color !== undefined) color.fromArray(lightDef.color);
        const range = lightDef.range !== undefined ? lightDef.range : 0;
        switch(lightDef.type){
            case "directional":
                lightNode = new (0, $9014d97cd777be10$export$3fea33cc9972c868)(color);
                lightNode.target.position.set(0, 0, -1);
                lightNode.add(lightNode.target);
                break;
            case "point":
                lightNode = new (0, $9014d97cd777be10$export$4c9c1cb3f0b6f455)(color);
                lightNode.distance = range;
                break;
            case "spot":
                lightNode = new (0, $9014d97cd777be10$export$81495cbb73897362)(color);
                lightNode.distance = range;
                // Handle spotlight properties.
                lightDef.spot = lightDef.spot || {};
                lightDef.spot.innerConeAngle = lightDef.spot.innerConeAngle !== undefined ? lightDef.spot.innerConeAngle : 0;
                lightDef.spot.outerConeAngle = lightDef.spot.outerConeAngle !== undefined ? lightDef.spot.outerConeAngle : Math.PI / 4.0;
                lightNode.angle = lightDef.spot.outerConeAngle;
                lightNode.penumbra = 1.0 - lightDef.spot.innerConeAngle / lightDef.spot.outerConeAngle;
                lightNode.target.position.set(0, 0, -1);
                lightNode.add(lightNode.target);
                break;
            default:
                throw new Error("THREE.GLTFLoader: Unexpected light type: " + lightDef.type);
        }
        // Some lights (e.g. spot) default to a position other than the origin. Reset the position
        // here, because node-level parsing will only override position if explicitly specified.
        lightNode.position.set(0, 0, 0);
        lightNode.decay = 2;
        $50ee5a35738b214d$var$assignExtrasToUserData(lightNode, lightDef);
        if (lightDef.intensity !== undefined) lightNode.intensity = lightDef.intensity;
        lightNode.name = parser.createUniqueName(lightDef.name || "light_" + lightIndex);
        dependency = Promise.resolve(lightNode);
        parser.cache.add(cacheKey, dependency);
        return dependency;
    }
    getDependency(type, index) {
        if (type !== "light") return;
        return this._loadLight(index);
    }
    createNodeAttachment(nodeIndex) {
        const self1 = this;
        const parser = this.parser;
        const json = parser.json;
        const nodeDef = json.nodes[nodeIndex];
        const lightDef = nodeDef.extensions && nodeDef.extensions[this.name] || {};
        const lightIndex = lightDef.light;
        if (lightIndex === undefined) return null;
        return this._loadLight(lightIndex).then(function(light) {
            return parser._getNodeRef(self1.cache, lightIndex, light);
        });
    }
    constructor(parser){
        this.parser = parser;
        this.name = $50ee5a35738b214d$var$EXTENSIONS.KHR_LIGHTS_PUNCTUAL;
        // Object3D instance caches
        this.cache = {
            refs: {},
            uses: {}
        };
    }
}
/**
 * Unlit Materials Extension
 *
 * Specification: https://github.com/KhronosGroup/glTF/tree/master/extensions/2.0/Khronos/KHR_materials_unlit
 */ class $50ee5a35738b214d$var$GLTFMaterialsUnlitExtension {
    getMaterialType() {
        return 0, $9014d97cd777be10$export$55cbcc9b622fe1f5;
    }
    extendParams(materialParams, materialDef, parser) {
        const pending = [];
        materialParams.color = new (0, $9014d97cd777be10$export$892596cec99bc70e)(1.0, 1.0, 1.0);
        materialParams.opacity = 1.0;
        const metallicRoughness = materialDef.pbrMetallicRoughness;
        if (metallicRoughness) {
            if (Array.isArray(metallicRoughness.baseColorFactor)) {
                const array = metallicRoughness.baseColorFactor;
                materialParams.color.fromArray(array);
                materialParams.opacity = array[3];
            }
            if (metallicRoughness.baseColorTexture !== undefined) pending.push(parser.assignTexture(materialParams, "map", metallicRoughness.baseColorTexture, (0, $9014d97cd777be10$export$561f394b24edfcaa)));
        }
        return Promise.all(pending);
    }
    constructor(){
        this.name = $50ee5a35738b214d$var$EXTENSIONS.KHR_MATERIALS_UNLIT;
    }
}
/**
 * Materials Emissive Strength Extension
 *
 * Specification: https://github.com/KhronosGroup/glTF/blob/5768b3ce0ef32bc39cdf1bef10b948586635ead3/extensions/2.0/Khronos/KHR_materials_emissive_strength/README.md
 */ class $50ee5a35738b214d$var$GLTFMaterialsEmissiveStrengthExtension {
    extendMaterialParams(materialIndex, materialParams) {
        const parser = this.parser;
        const materialDef = parser.json.materials[materialIndex];
        if (!materialDef.extensions || !materialDef.extensions[this.name]) return Promise.resolve();
        const emissiveStrength = materialDef.extensions[this.name].emissiveStrength;
        if (emissiveStrength !== undefined) materialParams.emissiveIntensity = emissiveStrength;
        return Promise.resolve();
    }
    constructor(parser){
        this.parser = parser;
        this.name = $50ee5a35738b214d$var$EXTENSIONS.KHR_MATERIALS_EMISSIVE_STRENGTH;
    }
}
/**
 * Clearcoat Materials Extension
 *
 * Specification: https://github.com/KhronosGroup/glTF/tree/master/extensions/2.0/Khronos/KHR_materials_clearcoat
 */ class $50ee5a35738b214d$var$GLTFMaterialsClearcoatExtension {
    getMaterialType(materialIndex) {
        const parser = this.parser;
        const materialDef = parser.json.materials[materialIndex];
        if (!materialDef.extensions || !materialDef.extensions[this.name]) return null;
        return 0, $9014d97cd777be10$export$28d04986c4269c9f;
    }
    extendMaterialParams(materialIndex, materialParams) {
        const parser = this.parser;
        const materialDef = parser.json.materials[materialIndex];
        if (!materialDef.extensions || !materialDef.extensions[this.name]) return Promise.resolve();
        const pending = [];
        const extension = materialDef.extensions[this.name];
        if (extension.clearcoatFactor !== undefined) materialParams.clearcoat = extension.clearcoatFactor;
        if (extension.clearcoatTexture !== undefined) pending.push(parser.assignTexture(materialParams, "clearcoatMap", extension.clearcoatTexture));
        if (extension.clearcoatRoughnessFactor !== undefined) materialParams.clearcoatRoughness = extension.clearcoatRoughnessFactor;
        if (extension.clearcoatRoughnessTexture !== undefined) pending.push(parser.assignTexture(materialParams, "clearcoatRoughnessMap", extension.clearcoatRoughnessTexture));
        if (extension.clearcoatNormalTexture !== undefined) {
            pending.push(parser.assignTexture(materialParams, "clearcoatNormalMap", extension.clearcoatNormalTexture));
            if (extension.clearcoatNormalTexture.scale !== undefined) {
                const scale = extension.clearcoatNormalTexture.scale;
                materialParams.clearcoatNormalScale = new (0, $9014d97cd777be10$export$c977b3e384af9ae1)(scale, scale);
            }
        }
        return Promise.all(pending);
    }
    constructor(parser){
        this.parser = parser;
        this.name = $50ee5a35738b214d$var$EXTENSIONS.KHR_MATERIALS_CLEARCOAT;
    }
}
/**
 * Iridescence Materials Extension
 *
 * Specification: https://github.com/KhronosGroup/glTF/tree/master/extensions/2.0/Khronos/KHR_materials_iridescence
 */ class $50ee5a35738b214d$var$GLTFMaterialsIridescenceExtension {
    getMaterialType(materialIndex) {
        const parser = this.parser;
        const materialDef = parser.json.materials[materialIndex];
        if (!materialDef.extensions || !materialDef.extensions[this.name]) return null;
        return 0, $9014d97cd777be10$export$28d04986c4269c9f;
    }
    extendMaterialParams(materialIndex, materialParams) {
        const parser = this.parser;
        const materialDef = parser.json.materials[materialIndex];
        if (!materialDef.extensions || !materialDef.extensions[this.name]) return Promise.resolve();
        const pending = [];
        const extension = materialDef.extensions[this.name];
        if (extension.iridescenceFactor !== undefined) materialParams.iridescence = extension.iridescenceFactor;
        if (extension.iridescenceTexture !== undefined) pending.push(parser.assignTexture(materialParams, "iridescenceMap", extension.iridescenceTexture));
        if (extension.iridescenceIor !== undefined) materialParams.iridescenceIOR = extension.iridescenceIor;
        if (materialParams.iridescenceThicknessRange === undefined) materialParams.iridescenceThicknessRange = [
            100,
            400
        ];
        if (extension.iridescenceThicknessMinimum !== undefined) materialParams.iridescenceThicknessRange[0] = extension.iridescenceThicknessMinimum;
        if (extension.iridescenceThicknessMaximum !== undefined) materialParams.iridescenceThicknessRange[1] = extension.iridescenceThicknessMaximum;
        if (extension.iridescenceThicknessTexture !== undefined) pending.push(parser.assignTexture(materialParams, "iridescenceThicknessMap", extension.iridescenceThicknessTexture));
        return Promise.all(pending);
    }
    constructor(parser){
        this.parser = parser;
        this.name = $50ee5a35738b214d$var$EXTENSIONS.KHR_MATERIALS_IRIDESCENCE;
    }
}
/**
 * Sheen Materials Extension
 *
 * Specification: https://github.com/KhronosGroup/glTF/tree/main/extensions/2.0/Khronos/KHR_materials_sheen
 */ class $50ee5a35738b214d$var$GLTFMaterialsSheenExtension {
    getMaterialType(materialIndex) {
        const parser = this.parser;
        const materialDef = parser.json.materials[materialIndex];
        if (!materialDef.extensions || !materialDef.extensions[this.name]) return null;
        return 0, $9014d97cd777be10$export$28d04986c4269c9f;
    }
    extendMaterialParams(materialIndex, materialParams) {
        const parser = this.parser;
        const materialDef = parser.json.materials[materialIndex];
        if (!materialDef.extensions || !materialDef.extensions[this.name]) return Promise.resolve();
        const pending = [];
        materialParams.sheenColor = new (0, $9014d97cd777be10$export$892596cec99bc70e)(0, 0, 0);
        materialParams.sheenRoughness = 0;
        materialParams.sheen = 1;
        const extension = materialDef.extensions[this.name];
        if (extension.sheenColorFactor !== undefined) materialParams.sheenColor.fromArray(extension.sheenColorFactor);
        if (extension.sheenRoughnessFactor !== undefined) materialParams.sheenRoughness = extension.sheenRoughnessFactor;
        if (extension.sheenColorTexture !== undefined) pending.push(parser.assignTexture(materialParams, "sheenColorMap", extension.sheenColorTexture, (0, $9014d97cd777be10$export$561f394b24edfcaa)));
        if (extension.sheenRoughnessTexture !== undefined) pending.push(parser.assignTexture(materialParams, "sheenRoughnessMap", extension.sheenRoughnessTexture));
        return Promise.all(pending);
    }
    constructor(parser){
        this.parser = parser;
        this.name = $50ee5a35738b214d$var$EXTENSIONS.KHR_MATERIALS_SHEEN;
    }
}
/**
 * Transmission Materials Extension
 *
 * Specification: https://github.com/KhronosGroup/glTF/tree/master/extensions/2.0/Khronos/KHR_materials_transmission
 * Draft: https://github.com/KhronosGroup/glTF/pull/1698
 */ class $50ee5a35738b214d$var$GLTFMaterialsTransmissionExtension {
    getMaterialType(materialIndex) {
        const parser = this.parser;
        const materialDef = parser.json.materials[materialIndex];
        if (!materialDef.extensions || !materialDef.extensions[this.name]) return null;
        return 0, $9014d97cd777be10$export$28d04986c4269c9f;
    }
    extendMaterialParams(materialIndex, materialParams) {
        const parser = this.parser;
        const materialDef = parser.json.materials[materialIndex];
        if (!materialDef.extensions || !materialDef.extensions[this.name]) return Promise.resolve();
        const pending = [];
        const extension = materialDef.extensions[this.name];
        if (extension.transmissionFactor !== undefined) materialParams.transmission = extension.transmissionFactor;
        if (extension.transmissionTexture !== undefined) pending.push(parser.assignTexture(materialParams, "transmissionMap", extension.transmissionTexture));
        return Promise.all(pending);
    }
    constructor(parser){
        this.parser = parser;
        this.name = $50ee5a35738b214d$var$EXTENSIONS.KHR_MATERIALS_TRANSMISSION;
    }
}
/**
 * Materials Volume Extension
 *
 * Specification: https://github.com/KhronosGroup/glTF/tree/master/extensions/2.0/Khronos/KHR_materials_volume
 */ class $50ee5a35738b214d$var$GLTFMaterialsVolumeExtension {
    getMaterialType(materialIndex) {
        const parser = this.parser;
        const materialDef = parser.json.materials[materialIndex];
        if (!materialDef.extensions || !materialDef.extensions[this.name]) return null;
        return 0, $9014d97cd777be10$export$28d04986c4269c9f;
    }
    extendMaterialParams(materialIndex, materialParams) {
        const parser = this.parser;
        const materialDef = parser.json.materials[materialIndex];
        if (!materialDef.extensions || !materialDef.extensions[this.name]) return Promise.resolve();
        const pending = [];
        const extension = materialDef.extensions[this.name];
        materialParams.thickness = extension.thicknessFactor !== undefined ? extension.thicknessFactor : 0;
        if (extension.thicknessTexture !== undefined) pending.push(parser.assignTexture(materialParams, "thicknessMap", extension.thicknessTexture));
        materialParams.attenuationDistance = extension.attenuationDistance || Infinity;
        const colorArray = extension.attenuationColor || [
            1,
            1,
            1
        ];
        materialParams.attenuationColor = new (0, $9014d97cd777be10$export$892596cec99bc70e)(colorArray[0], colorArray[1], colorArray[2]);
        return Promise.all(pending);
    }
    constructor(parser){
        this.parser = parser;
        this.name = $50ee5a35738b214d$var$EXTENSIONS.KHR_MATERIALS_VOLUME;
    }
}
/**
 * Materials ior Extension
 *
 * Specification: https://github.com/KhronosGroup/glTF/tree/master/extensions/2.0/Khronos/KHR_materials_ior
 */ class $50ee5a35738b214d$var$GLTFMaterialsIorExtension {
    getMaterialType(materialIndex) {
        const parser = this.parser;
        const materialDef = parser.json.materials[materialIndex];
        if (!materialDef.extensions || !materialDef.extensions[this.name]) return null;
        return 0, $9014d97cd777be10$export$28d04986c4269c9f;
    }
    extendMaterialParams(materialIndex, materialParams) {
        const parser = this.parser;
        const materialDef = parser.json.materials[materialIndex];
        if (!materialDef.extensions || !materialDef.extensions[this.name]) return Promise.resolve();
        const extension = materialDef.extensions[this.name];
        materialParams.ior = extension.ior !== undefined ? extension.ior : 1.5;
        return Promise.resolve();
    }
    constructor(parser){
        this.parser = parser;
        this.name = $50ee5a35738b214d$var$EXTENSIONS.KHR_MATERIALS_IOR;
    }
}
/**
 * Materials specular Extension
 *
 * Specification: https://github.com/KhronosGroup/glTF/tree/master/extensions/2.0/Khronos/KHR_materials_specular
 */ class $50ee5a35738b214d$var$GLTFMaterialsSpecularExtension {
    getMaterialType(materialIndex) {
        const parser = this.parser;
        const materialDef = parser.json.materials[materialIndex];
        if (!materialDef.extensions || !materialDef.extensions[this.name]) return null;
        return 0, $9014d97cd777be10$export$28d04986c4269c9f;
    }
    extendMaterialParams(materialIndex, materialParams) {
        const parser = this.parser;
        const materialDef = parser.json.materials[materialIndex];
        if (!materialDef.extensions || !materialDef.extensions[this.name]) return Promise.resolve();
        const pending = [];
        const extension = materialDef.extensions[this.name];
        materialParams.specularIntensity = extension.specularFactor !== undefined ? extension.specularFactor : 1.0;
        if (extension.specularTexture !== undefined) pending.push(parser.assignTexture(materialParams, "specularIntensityMap", extension.specularTexture));
        const colorArray = extension.specularColorFactor || [
            1,
            1,
            1
        ];
        materialParams.specularColor = new (0, $9014d97cd777be10$export$892596cec99bc70e)(colorArray[0], colorArray[1], colorArray[2]);
        if (extension.specularColorTexture !== undefined) pending.push(parser.assignTexture(materialParams, "specularColorMap", extension.specularColorTexture, (0, $9014d97cd777be10$export$561f394b24edfcaa)));
        return Promise.all(pending);
    }
    constructor(parser){
        this.parser = parser;
        this.name = $50ee5a35738b214d$var$EXTENSIONS.KHR_MATERIALS_SPECULAR;
    }
}
/**
 * Materials anisotropy Extension
 *
 * Specification: https://github.com/KhronosGroup/glTF/tree/master/extensions/2.0/Khronos/KHR_materials_anisotropy
 */ class $50ee5a35738b214d$var$GLTFMaterialsAnisotropyExtension {
    getMaterialType(materialIndex) {
        const parser = this.parser;
        const materialDef = parser.json.materials[materialIndex];
        if (!materialDef.extensions || !materialDef.extensions[this.name]) return null;
        return 0, $9014d97cd777be10$export$28d04986c4269c9f;
    }
    extendMaterialParams(materialIndex, materialParams) {
        const parser = this.parser;
        const materialDef = parser.json.materials[materialIndex];
        if (!materialDef.extensions || !materialDef.extensions[this.name]) return Promise.resolve();
        const pending = [];
        const extension = materialDef.extensions[this.name];
        if (extension.anisotropyStrength !== undefined) materialParams.anisotropy = extension.anisotropyStrength;
        if (extension.anisotropyRotation !== undefined) materialParams.anisotropyRotation = extension.anisotropyRotation;
        if (extension.anisotropyTexture !== undefined) pending.push(parser.assignTexture(materialParams, "anisotropyMap", extension.anisotropyTexture));
        return Promise.all(pending);
    }
    constructor(parser){
        this.parser = parser;
        this.name = $50ee5a35738b214d$var$EXTENSIONS.KHR_MATERIALS_ANISOTROPY;
    }
}
/**
 * BasisU Texture Extension
 *
 * Specification: https://github.com/KhronosGroup/glTF/tree/master/extensions/2.0/Khronos/KHR_texture_basisu
 */ class $50ee5a35738b214d$var$GLTFTextureBasisUExtension {
    loadTexture(textureIndex) {
        const parser = this.parser;
        const json = parser.json;
        const textureDef = json.textures[textureIndex];
        if (!textureDef.extensions || !textureDef.extensions[this.name]) return null;
        const extension = textureDef.extensions[this.name];
        const loader = parser.options.ktx2Loader;
        if (!loader) {
            if (json.extensionsRequired && json.extensionsRequired.indexOf(this.name) >= 0) throw new Error("THREE.GLTFLoader: setKTX2Loader must be called before loading KTX2 textures");
            else // Assumes that the extension is optional and that a fallback texture is present
            return null;
        }
        return parser.loadTextureImage(textureIndex, extension.source, loader);
    }
    constructor(parser){
        this.parser = parser;
        this.name = $50ee5a35738b214d$var$EXTENSIONS.KHR_TEXTURE_BASISU;
    }
}
/**
 * WebP Texture Extension
 *
 * Specification: https://github.com/KhronosGroup/glTF/tree/master/extensions/2.0/Vendor/EXT_texture_webp
 */ class $50ee5a35738b214d$var$GLTFTextureWebPExtension {
    loadTexture(textureIndex) {
        const name = this.name;
        const parser = this.parser;
        const json = parser.json;
        const textureDef = json.textures[textureIndex];
        if (!textureDef.extensions || !textureDef.extensions[name]) return null;
        const extension = textureDef.extensions[name];
        const source = json.images[extension.source];
        let loader = parser.textureLoader;
        if (source.uri) {
            const handler = parser.options.manager.getHandler(source.uri);
            if (handler !== null) loader = handler;
        }
        return this.detectSupport().then(function(isSupported) {
            if (isSupported) return parser.loadTextureImage(textureIndex, extension.source, loader);
            if (json.extensionsRequired && json.extensionsRequired.indexOf(name) >= 0) throw new Error("THREE.GLTFLoader: WebP required by asset but unsupported.");
            // Fall back to PNG or JPEG.
            return parser.loadTexture(textureIndex);
        });
    }
    detectSupport() {
        if (!this.isSupported) this.isSupported = new Promise(function(resolve) {
            const image = new Image();
            // Lossy test image. Support for lossy images doesn't guarantee support for all
            // WebP images, unfortunately.
            image.src = "data:image/webp;base64,UklGRiIAAABXRUJQVlA4IBYAAAAwAQCdASoBAAEADsD+JaQAA3AAAAAA";
            image.onload = image.onerror = function() {
                resolve(image.height === 1);
            };
        });
        return this.isSupported;
    }
    constructor(parser){
        this.parser = parser;
        this.name = $50ee5a35738b214d$var$EXTENSIONS.EXT_TEXTURE_WEBP;
        this.isSupported = null;
    }
}
/**
 * AVIF Texture Extension
 *
 * Specification: https://github.com/KhronosGroup/glTF/tree/master/extensions/2.0/Vendor/EXT_texture_avif
 */ class $50ee5a35738b214d$var$GLTFTextureAVIFExtension {
    loadTexture(textureIndex) {
        const name = this.name;
        const parser = this.parser;
        const json = parser.json;
        const textureDef = json.textures[textureIndex];
        if (!textureDef.extensions || !textureDef.extensions[name]) return null;
        const extension = textureDef.extensions[name];
        const source = json.images[extension.source];
        let loader = parser.textureLoader;
        if (source.uri) {
            const handler = parser.options.manager.getHandler(source.uri);
            if (handler !== null) loader = handler;
        }
        return this.detectSupport().then(function(isSupported) {
            if (isSupported) return parser.loadTextureImage(textureIndex, extension.source, loader);
            if (json.extensionsRequired && json.extensionsRequired.indexOf(name) >= 0) throw new Error("THREE.GLTFLoader: AVIF required by asset but unsupported.");
            // Fall back to PNG or JPEG.
            return parser.loadTexture(textureIndex);
        });
    }
    detectSupport() {
        if (!this.isSupported) this.isSupported = new Promise(function(resolve) {
            const image = new Image();
            // Lossy test image.
            image.src = "data:image/avif;base64,AAAAIGZ0eXBhdmlmAAAAAGF2aWZtaWYxbWlhZk1BMUIAAADybWV0YQAAAAAAAAAoaGRscgAAAAAAAAAAcGljdAAAAAAAAAAAAAAAAGxpYmF2aWYAAAAADnBpdG0AAAAAAAEAAAAeaWxvYwAAAABEAAABAAEAAAABAAABGgAAABcAAAAoaWluZgAAAAAAAQAAABppbmZlAgAAAAABAABhdjAxQ29sb3IAAAAAamlwcnAAAABLaXBjbwAAABRpc3BlAAAAAAAAAAEAAAABAAAAEHBpeGkAAAAAAwgICAAAAAxhdjFDgQAMAAAAABNjb2xybmNseAACAAIABoAAAAAXaXBtYQAAAAAAAAABAAEEAQKDBAAAAB9tZGF0EgAKCBgABogQEDQgMgkQAAAAB8dSLfI=";
            image.onload = image.onerror = function() {
                resolve(image.height === 1);
            };
        });
        return this.isSupported;
    }
    constructor(parser){
        this.parser = parser;
        this.name = $50ee5a35738b214d$var$EXTENSIONS.EXT_TEXTURE_AVIF;
        this.isSupported = null;
    }
}
/**
 * meshopt BufferView Compression Extension
 *
 * Specification: https://github.com/KhronosGroup/glTF/tree/master/extensions/2.0/Vendor/EXT_meshopt_compression
 */ class $50ee5a35738b214d$var$GLTFMeshoptCompression {
    loadBufferView(index) {
        const json = this.parser.json;
        const bufferView = json.bufferViews[index];
        if (bufferView.extensions && bufferView.extensions[this.name]) {
            const extensionDef = bufferView.extensions[this.name];
            const buffer = this.parser.getDependency("buffer", extensionDef.buffer);
            const decoder = this.parser.options.meshoptDecoder;
            if (!decoder || !decoder.supported) {
                if (json.extensionsRequired && json.extensionsRequired.indexOf(this.name) >= 0) throw new Error("THREE.GLTFLoader: setMeshoptDecoder must be called before loading compressed files");
                else // Assumes that the extension is optional and that fallback buffer data is present
                return null;
            }
            return buffer.then(function(res) {
                const byteOffset = extensionDef.byteOffset || 0;
                const byteLength = extensionDef.byteLength || 0;
                const count = extensionDef.count;
                const stride = extensionDef.byteStride;
                const source = new Uint8Array(res, byteOffset, byteLength);
                if (decoder.decodeGltfBufferAsync) return decoder.decodeGltfBufferAsync(count, stride, source, extensionDef.mode, extensionDef.filter).then(function(res) {
                    return res.buffer;
                });
                else // Support for MeshoptDecoder 0.18 or earlier, without decodeGltfBufferAsync
                return decoder.ready.then(function() {
                    const result = new ArrayBuffer(count * stride);
                    decoder.decodeGltfBuffer(new Uint8Array(result), count, stride, source, extensionDef.mode, extensionDef.filter);
                    return result;
                });
            });
        } else return null;
    }
    constructor(parser){
        this.name = $50ee5a35738b214d$var$EXTENSIONS.EXT_MESHOPT_COMPRESSION;
        this.parser = parser;
    }
}
/**
 * GPU Instancing Extension
 *
 * Specification: https://github.com/KhronosGroup/glTF/tree/master/extensions/2.0/Vendor/EXT_mesh_gpu_instancing
 *
 */ class $50ee5a35738b214d$var$GLTFMeshGpuInstancing {
    createNodeMesh(nodeIndex) {
        const json = this.parser.json;
        const nodeDef = json.nodes[nodeIndex];
        if (!nodeDef.extensions || !nodeDef.extensions[this.name] || nodeDef.mesh === undefined) return null;
        const meshDef = json.meshes[nodeDef.mesh];
        // No Points or Lines + Instancing support yet
        for (const primitive of meshDef.primitives){
            if (primitive.mode !== $50ee5a35738b214d$var$WEBGL_CONSTANTS.TRIANGLES && primitive.mode !== $50ee5a35738b214d$var$WEBGL_CONSTANTS.TRIANGLE_STRIP && primitive.mode !== $50ee5a35738b214d$var$WEBGL_CONSTANTS.TRIANGLE_FAN && primitive.mode !== undefined) return null;
        }
        const extensionDef = nodeDef.extensions[this.name];
        const attributesDef = extensionDef.attributes;
        // @TODO: Can we support InstancedMesh + SkinnedMesh?
        const pending = [];
        const attributes = {};
        for(const key in attributesDef)pending.push(this.parser.getDependency("accessor", attributesDef[key]).then((accessor)=>{
            attributes[key] = accessor;
            return attributes[key];
        }));
        if (pending.length < 1) return null;
        pending.push(this.parser.createNodeMesh(nodeIndex));
        return Promise.all(pending).then((results)=>{
            const nodeObject = results.pop();
            const meshes = nodeObject.isGroup ? nodeObject.children : [
                nodeObject
            ];
            const count = results[0].count; // All attribute counts should be same
            const instancedMeshes = [];
            for (const mesh of meshes){
                // Temporal variables
                const m = new (0, $9014d97cd777be10$export$2ae72fc923e5eb5)();
                const p = new (0, $9014d97cd777be10$export$64b5c384219d3699)();
                const q = new (0, $9014d97cd777be10$export$23d6a54f0bbc85a3)();
                const s = new (0, $9014d97cd777be10$export$64b5c384219d3699)(1, 1, 1);
                const instancedMesh = new (0, $9014d97cd777be10$export$f3c979c331175ad7)(mesh.geometry, mesh.material, count);
                for(let i = 0; i < count; i++){
                    if (attributes.TRANSLATION) p.fromBufferAttribute(attributes.TRANSLATION, i);
                    if (attributes.ROTATION) q.fromBufferAttribute(attributes.ROTATION, i);
                    if (attributes.SCALE) s.fromBufferAttribute(attributes.SCALE, i);
                    instancedMesh.setMatrixAt(i, m.compose(p, q, s));
                }
                // Add instance attributes to the geometry, excluding TRS.
                for(const attributeName in attributes)if (attributeName !== "TRANSLATION" && attributeName !== "ROTATION" && attributeName !== "SCALE") mesh.geometry.setAttribute(attributeName, attributes[attributeName]);
                // Just in case
                (0, $9014d97cd777be10$export$e4dd07dff30cc924).prototype.copy.call(instancedMesh, mesh);
                this.parser.assignFinalMaterial(instancedMesh);
                instancedMeshes.push(instancedMesh);
            }
            if (nodeObject.isGroup) {
                nodeObject.clear();
                nodeObject.add(...instancedMeshes);
                return nodeObject;
            }
            return instancedMeshes[0];
        });
    }
    constructor(parser){
        this.name = $50ee5a35738b214d$var$EXTENSIONS.EXT_MESH_GPU_INSTANCING;
        this.parser = parser;
    }
}
/* BINARY EXTENSION */ const $50ee5a35738b214d$var$BINARY_EXTENSION_HEADER_MAGIC = "glTF";
const $50ee5a35738b214d$var$BINARY_EXTENSION_HEADER_LENGTH = 12;
const $50ee5a35738b214d$var$BINARY_EXTENSION_CHUNK_TYPES = {
    JSON: 0x4E4F534A,
    BIN: 0x004E4942
};
class $50ee5a35738b214d$var$GLTFBinaryExtension {
    constructor(data){
        this.name = $50ee5a35738b214d$var$EXTENSIONS.KHR_BINARY_GLTF;
        this.content = null;
        this.body = null;
        const headerView = new DataView(data, 0, $50ee5a35738b214d$var$BINARY_EXTENSION_HEADER_LENGTH);
        const textDecoder = new TextDecoder();
        this.header = {
            magic: textDecoder.decode(new Uint8Array(data.slice(0, 4))),
            version: headerView.getUint32(4, true),
            length: headerView.getUint32(8, true)
        };
        if (this.header.magic !== $50ee5a35738b214d$var$BINARY_EXTENSION_HEADER_MAGIC) throw new Error("THREE.GLTFLoader: Unsupported glTF-Binary header.");
        else if (this.header.version < 2.0) throw new Error("THREE.GLTFLoader: Legacy binary file detected.");
        const chunkContentsLength = this.header.length - $50ee5a35738b214d$var$BINARY_EXTENSION_HEADER_LENGTH;
        const chunkView = new DataView(data, $50ee5a35738b214d$var$BINARY_EXTENSION_HEADER_LENGTH);
        let chunkIndex = 0;
        while(chunkIndex < chunkContentsLength){
            const chunkLength = chunkView.getUint32(chunkIndex, true);
            chunkIndex += 4;
            const chunkType = chunkView.getUint32(chunkIndex, true);
            chunkIndex += 4;
            if (chunkType === $50ee5a35738b214d$var$BINARY_EXTENSION_CHUNK_TYPES.JSON) {
                const contentArray = new Uint8Array(data, $50ee5a35738b214d$var$BINARY_EXTENSION_HEADER_LENGTH + chunkIndex, chunkLength);
                this.content = textDecoder.decode(contentArray);
            } else if (chunkType === $50ee5a35738b214d$var$BINARY_EXTENSION_CHUNK_TYPES.BIN) {
                const byteOffset = $50ee5a35738b214d$var$BINARY_EXTENSION_HEADER_LENGTH + chunkIndex;
                this.body = data.slice(byteOffset, byteOffset + chunkLength);
            }
            // Clients must ignore chunks with unknown types.
            chunkIndex += chunkLength;
        }
        if (this.content === null) throw new Error("THREE.GLTFLoader: JSON content not found.");
    }
}
/**
 * DRACO Mesh Compression Extension
 *
 * Specification: https://github.com/KhronosGroup/glTF/tree/master/extensions/2.0/Khronos/KHR_draco_mesh_compression
 */ class $50ee5a35738b214d$var$GLTFDracoMeshCompressionExtension {
    decodePrimitive(primitive, parser) {
        const json = this.json;
        const dracoLoader = this.dracoLoader;
        const bufferViewIndex = primitive.extensions[this.name].bufferView;
        const gltfAttributeMap = primitive.extensions[this.name].attributes;
        const threeAttributeMap = {};
        const attributeNormalizedMap = {};
        const attributeTypeMap = {};
        for(const attributeName in gltfAttributeMap){
            const threeAttributeName = $50ee5a35738b214d$var$ATTRIBUTES[attributeName] || attributeName.toLowerCase();
            threeAttributeMap[threeAttributeName] = gltfAttributeMap[attributeName];
        }
        for(const attributeName in primitive.attributes){
            const threeAttributeName = $50ee5a35738b214d$var$ATTRIBUTES[attributeName] || attributeName.toLowerCase();
            if (gltfAttributeMap[attributeName] !== undefined) {
                const accessorDef = json.accessors[primitive.attributes[attributeName]];
                const componentType = $50ee5a35738b214d$var$WEBGL_COMPONENT_TYPES[accessorDef.componentType];
                attributeTypeMap[threeAttributeName] = componentType.name;
                attributeNormalizedMap[threeAttributeName] = accessorDef.normalized === true;
            }
        }
        return parser.getDependency("bufferView", bufferViewIndex).then(function(bufferView) {
            return new Promise(function(resolve) {
                dracoLoader.decodeDracoFile(bufferView, function(geometry) {
                    for(const attributeName in geometry.attributes){
                        const attribute = geometry.attributes[attributeName];
                        const normalized = attributeNormalizedMap[attributeName];
                        if (normalized !== undefined) attribute.normalized = normalized;
                    }
                    resolve(geometry);
                }, threeAttributeMap, attributeTypeMap);
            });
        });
    }
    constructor(json, dracoLoader){
        if (!dracoLoader) throw new Error("THREE.GLTFLoader: No DRACOLoader instance provided.");
        this.name = $50ee5a35738b214d$var$EXTENSIONS.KHR_DRACO_MESH_COMPRESSION;
        this.json = json;
        this.dracoLoader = dracoLoader;
        this.dracoLoader.preload();
    }
}
/**
 * Texture Transform Extension
 *
 * Specification: https://github.com/KhronosGroup/glTF/tree/master/extensions/2.0/Khronos/KHR_texture_transform
 */ class $50ee5a35738b214d$var$GLTFTextureTransformExtension {
    extendTexture(texture, transform) {
        if ((transform.texCoord === undefined || transform.texCoord === texture.channel) && transform.offset === undefined && transform.rotation === undefined && transform.scale === undefined) // See https://github.com/mrdoob/three.js/issues/21819.
        return texture;
        texture = texture.clone();
        if (transform.texCoord !== undefined) texture.channel = transform.texCoord;
        if (transform.offset !== undefined) texture.offset.fromArray(transform.offset);
        if (transform.rotation !== undefined) texture.rotation = transform.rotation;
        if (transform.scale !== undefined) texture.repeat.fromArray(transform.scale);
        texture.needsUpdate = true;
        return texture;
    }
    constructor(){
        this.name = $50ee5a35738b214d$var$EXTENSIONS.KHR_TEXTURE_TRANSFORM;
    }
}
/**
 * Mesh Quantization Extension
 *
 * Specification: https://github.com/KhronosGroup/glTF/tree/master/extensions/2.0/Khronos/KHR_mesh_quantization
 */ class $50ee5a35738b214d$var$GLTFMeshQuantizationExtension {
    constructor(){
        this.name = $50ee5a35738b214d$var$EXTENSIONS.KHR_MESH_QUANTIZATION;
    }
}
/*********************************/ /********** INTERPOLATION ********/ /*********************************/ // Spline Interpolation
// Specification: https://github.com/KhronosGroup/glTF/blob/master/specification/2.0/README.md#appendix-c-spline-interpolation
class $50ee5a35738b214d$var$GLTFCubicSplineInterpolant extends (0, $9014d97cd777be10$export$b558baee9c0f72d3) {
    copySampleValue_(index) {
        // Copies a sample value to the result buffer. See description of glTF
        // CUBICSPLINE values layout in interpolate_() function below.
        const result = this.resultBuffer, values = this.sampleValues, valueSize = this.valueSize, offset = index * valueSize * 3 + valueSize;
        for(let i = 0; i !== valueSize; i++)result[i] = values[offset + i];
        return result;
    }
    interpolate_(i1, t0, t, t1) {
        const result = this.resultBuffer;
        const values = this.sampleValues;
        const stride = this.valueSize;
        const stride2 = stride * 2;
        const stride3 = stride * 3;
        const td = t1 - t0;
        const p = (t - t0) / td;
        const pp = p * p;
        const ppp = pp * p;
        const offset1 = i1 * stride3;
        const offset0 = offset1 - stride3;
        const s2 = -2 * ppp + 3 * pp;
        const s3 = ppp - pp;
        const s0 = 1 - s2;
        const s1 = s3 - pp + p;
        // Layout of keyframe output values for CUBICSPLINE animations:
        //   [ inTangent_1, splineVertex_1, outTangent_1, inTangent_2, splineVertex_2, ... ]
        for(let i = 0; i !== stride; i++){
            const p0 = values[offset0 + i + stride]; // splineVertex_k
            const m0 = values[offset0 + i + stride2] * td; // outTangent_k * (t_k+1 - t_k)
            const p1 = values[offset1 + i + stride]; // splineVertex_k+1
            const m1 = values[offset1 + i] * td; // inTangent_k+1 * (t_k+1 - t_k)
            result[i] = s0 * p0 + s1 * m0 + s2 * p1 + s3 * m1;
        }
        return result;
    }
    constructor(parameterPositions, sampleValues, sampleSize, resultBuffer){
        super(parameterPositions, sampleValues, sampleSize, resultBuffer);
    }
}
const $50ee5a35738b214d$var$_q = new (0, $9014d97cd777be10$export$23d6a54f0bbc85a3)();
class $50ee5a35738b214d$var$GLTFCubicSplineQuaternionInterpolant extends $50ee5a35738b214d$var$GLTFCubicSplineInterpolant {
    interpolate_(i1, t0, t, t1) {
        const result = super.interpolate_(i1, t0, t, t1);
        $50ee5a35738b214d$var$_q.fromArray(result).normalize().toArray(result);
        return result;
    }
}
/*********************************/ /********** INTERNALS ************/ /*********************************/ /* CONSTANTS */ const $50ee5a35738b214d$var$WEBGL_CONSTANTS = {
    FLOAT: 5126,
    //FLOAT_MAT2: 35674,
    FLOAT_MAT3: 35675,
    FLOAT_MAT4: 35676,
    FLOAT_VEC2: 35664,
    FLOAT_VEC3: 35665,
    FLOAT_VEC4: 35666,
    LINEAR: 9729,
    REPEAT: 10497,
    SAMPLER_2D: 35678,
    POINTS: 0,
    LINES: 1,
    LINE_LOOP: 2,
    LINE_STRIP: 3,
    TRIANGLES: 4,
    TRIANGLE_STRIP: 5,
    TRIANGLE_FAN: 6,
    UNSIGNED_BYTE: 5121,
    UNSIGNED_SHORT: 5123
};
const $50ee5a35738b214d$var$WEBGL_COMPONENT_TYPES = {
    5120: Int8Array,
    5121: Uint8Array,
    5122: Int16Array,
    5123: Uint16Array,
    5125: Uint32Array,
    5126: Float32Array
};
const $50ee5a35738b214d$var$WEBGL_FILTERS = {
    9728: (0, $9014d97cd777be10$export$727aa5ec3fe39bf0),
    9729: (0, $9014d97cd777be10$export$8a72f490b25c56c8),
    9984: (0, $9014d97cd777be10$export$d129e38cf6feaa8c),
    9985: (0, $9014d97cd777be10$export$19a719f377145a13),
    9986: (0, $9014d97cd777be10$export$d2327c1afe5bfdf2),
    9987: (0, $9014d97cd777be10$export$5d8599b6a933fb1b)
};
const $50ee5a35738b214d$var$WEBGL_WRAPPINGS = {
    33071: (0, $9014d97cd777be10$export$9d9334239a5a5e06),
    33648: (0, $9014d97cd777be10$export$c7e7c00b14f51a4f),
    10497: (0, $9014d97cd777be10$export$533346c8e8dac0f5)
};
const $50ee5a35738b214d$var$WEBGL_TYPE_SIZES = {
    "SCALAR": 1,
    "VEC2": 2,
    "VEC3": 3,
    "VEC4": 4,
    "MAT2": 4,
    "MAT3": 9,
    "MAT4": 16
};
const $50ee5a35738b214d$var$ATTRIBUTES = {
    POSITION: "position",
    NORMAL: "normal",
    TANGENT: "tangent",
    TEXCOORD_0: "uv",
    TEXCOORD_1: "uv1",
    TEXCOORD_2: "uv2",
    TEXCOORD_3: "uv3",
    COLOR_0: "color",
    WEIGHTS_0: "skinWeight",
    JOINTS_0: "skinIndex"
};
const $50ee5a35738b214d$var$PATH_PROPERTIES = {
    scale: "scale",
    translation: "position",
    rotation: "quaternion",
    weights: "morphTargetInfluences"
};
const $50ee5a35738b214d$var$INTERPOLATION = {
    CUBICSPLINE: undefined,
    // keyframe track will be initialized with a default interpolation type, then modified.
    LINEAR: (0, $9014d97cd777be10$export$30fac1aace31cf4d),
    STEP: (0, $9014d97cd777be10$export$995b32462a65e855)
};
const $50ee5a35738b214d$var$ALPHA_MODES = {
    OPAQUE: "OPAQUE",
    MASK: "MASK",
    BLEND: "BLEND"
};
/**
 * Specification: https://github.com/KhronosGroup/glTF/blob/master/specification/2.0/README.md#default-material
 */ function $50ee5a35738b214d$var$createDefaultMaterial(cache) {
    if (cache["DefaultMaterial"] === undefined) cache["DefaultMaterial"] = new (0, $9014d97cd777be10$export$f2980790215acccd)({
        color: 0xFFFFFF,
        emissive: 0x000000,
        metalness: 1,
        roughness: 1,
        transparent: false,
        depthTest: true,
        side: (0, $9014d97cd777be10$export$2ede184fc2998901)
    });
    return cache["DefaultMaterial"];
}
function $50ee5a35738b214d$var$addUnknownExtensionsToUserData(knownExtensions, object, objectDef) {
    // Add unknown glTF extensions to an object's userData.
    for(const name in objectDef.extensions)if (knownExtensions[name] === undefined) {
        object.userData.gltfExtensions = object.userData.gltfExtensions || {};
        object.userData.gltfExtensions[name] = objectDef.extensions[name];
    }
}
/**
 * @param {Object3D|Material|BufferGeometry} object
 * @param {GLTF.definition} gltfDef
 */ function $50ee5a35738b214d$var$assignExtrasToUserData(object, gltfDef) {
    if (gltfDef.extras !== undefined) {
        if (typeof gltfDef.extras === "object") Object.assign(object.userData, gltfDef.extras);
        else console.warn("THREE.GLTFLoader: Ignoring primitive type .extras, " + gltfDef.extras);
    }
}
/**
 * Specification: https://github.com/KhronosGroup/glTF/blob/master/specification/2.0/README.md#morph-targets
 *
 * @param {BufferGeometry} geometry
 * @param {Array<GLTF.Target>} targets
 * @param {GLTFParser} parser
 * @return {Promise<BufferGeometry>}
 */ function $50ee5a35738b214d$var$addMorphTargets(geometry, targets, parser) {
    let hasMorphPosition = false;
    let hasMorphNormal = false;
    let hasMorphColor = false;
    for(let i = 0, il = targets.length; i < il; i++){
        const target = targets[i];
        if (target.POSITION !== undefined) hasMorphPosition = true;
        if (target.NORMAL !== undefined) hasMorphNormal = true;
        if (target.COLOR_0 !== undefined) hasMorphColor = true;
        if (hasMorphPosition && hasMorphNormal && hasMorphColor) break;
    }
    if (!hasMorphPosition && !hasMorphNormal && !hasMorphColor) return Promise.resolve(geometry);
    const pendingPositionAccessors = [];
    const pendingNormalAccessors = [];
    const pendingColorAccessors = [];
    for(let i = 0, il = targets.length; i < il; i++){
        const target = targets[i];
        if (hasMorphPosition) {
            const pendingAccessor = target.POSITION !== undefined ? parser.getDependency("accessor", target.POSITION) : geometry.attributes.position;
            pendingPositionAccessors.push(pendingAccessor);
        }
        if (hasMorphNormal) {
            const pendingAccessor = target.NORMAL !== undefined ? parser.getDependency("accessor", target.NORMAL) : geometry.attributes.normal;
            pendingNormalAccessors.push(pendingAccessor);
        }
        if (hasMorphColor) {
            const pendingAccessor = target.COLOR_0 !== undefined ? parser.getDependency("accessor", target.COLOR_0) : geometry.attributes.color;
            pendingColorAccessors.push(pendingAccessor);
        }
    }
    return Promise.all([
        Promise.all(pendingPositionAccessors),
        Promise.all(pendingNormalAccessors),
        Promise.all(pendingColorAccessors)
    ]).then(function(accessors) {
        const morphPositions = accessors[0];
        const morphNormals = accessors[1];
        const morphColors = accessors[2];
        if (hasMorphPosition) geometry.morphAttributes.position = morphPositions;
        if (hasMorphNormal) geometry.morphAttributes.normal = morphNormals;
        if (hasMorphColor) geometry.morphAttributes.color = morphColors;
        geometry.morphTargetsRelative = true;
        return geometry;
    });
}
/**
 * @param {Mesh} mesh
 * @param {GLTF.Mesh} meshDef
 */ function $50ee5a35738b214d$var$updateMorphTargets(mesh, meshDef) {
    mesh.updateMorphTargets();
    if (meshDef.weights !== undefined) for(let i = 0, il = meshDef.weights.length; i < il; i++)mesh.morphTargetInfluences[i] = meshDef.weights[i];
    // .extras has user-defined data, so check that .extras.targetNames is an array.
    if (meshDef.extras && Array.isArray(meshDef.extras.targetNames)) {
        const targetNames = meshDef.extras.targetNames;
        if (mesh.morphTargetInfluences.length === targetNames.length) {
            mesh.morphTargetDictionary = {};
            for(let i = 0, il = targetNames.length; i < il; i++)mesh.morphTargetDictionary[targetNames[i]] = i;
        } else console.warn("THREE.GLTFLoader: Invalid extras.targetNames length. Ignoring names.");
    }
}
function $50ee5a35738b214d$var$createPrimitiveKey(primitiveDef) {
    let geometryKey;
    const dracoExtension = primitiveDef.extensions && primitiveDef.extensions[$50ee5a35738b214d$var$EXTENSIONS.KHR_DRACO_MESH_COMPRESSION];
    if (dracoExtension) geometryKey = "draco:" + dracoExtension.bufferView + ":" + dracoExtension.indices + ":" + $50ee5a35738b214d$var$createAttributesKey(dracoExtension.attributes);
    else geometryKey = primitiveDef.indices + ":" + $50ee5a35738b214d$var$createAttributesKey(primitiveDef.attributes) + ":" + primitiveDef.mode;
    if (primitiveDef.targets !== undefined) for(let i = 0, il = primitiveDef.targets.length; i < il; i++)geometryKey += ":" + $50ee5a35738b214d$var$createAttributesKey(primitiveDef.targets[i]);
    return geometryKey;
}
function $50ee5a35738b214d$var$createAttributesKey(attributes) {
    let attributesKey = "";
    const keys = Object.keys(attributes).sort();
    for(let i = 0, il = keys.length; i < il; i++)attributesKey += keys[i] + ":" + attributes[keys[i]] + ";";
    return attributesKey;
}
function $50ee5a35738b214d$var$getNormalizedComponentScale(constructor) {
    // Reference:
    // https://github.com/KhronosGroup/glTF/tree/master/extensions/2.0/Khronos/KHR_mesh_quantization#encoding-quantized-data
    switch(constructor){
        case Int8Array:
            return 1 / 127;
        case Uint8Array:
            return 1 / 255;
        case Int16Array:
            return 1 / 32767;
        case Uint16Array:
            return 1 / 65535;
        default:
            throw new Error("THREE.GLTFLoader: Unsupported normalized accessor component type.");
    }
}
function $50ee5a35738b214d$var$getImageURIMimeType(uri) {
    if (uri.search(/\.jpe?g($|\?)/i) > 0 || uri.search(/^data\:image\/jpeg/) === 0) return "image/jpeg";
    if (uri.search(/\.webp($|\?)/i) > 0 || uri.search(/^data\:image\/webp/) === 0) return "image/webp";
    return "image/png";
}
const $50ee5a35738b214d$var$_identityMatrix = new (0, $9014d97cd777be10$export$2ae72fc923e5eb5)();
/* GLTF PARSER */ class $50ee5a35738b214d$var$GLTFParser {
    setExtensions(extensions) {
        this.extensions = extensions;
    }
    setPlugins(plugins) {
        this.plugins = plugins;
    }
    parse(onLoad, onError) {
        const parser = this;
        const json = this.json;
        const extensions = this.extensions;
        // Clear the loader cache
        this.cache.removeAll();
        this.nodeCache = {};
        // Mark the special nodes/meshes in json for efficient parse
        this._invokeAll(function(ext) {
            return ext._markDefs && ext._markDefs();
        });
        Promise.all(this._invokeAll(function(ext) {
            return ext.beforeRoot && ext.beforeRoot();
        })).then(function() {
            return Promise.all([
                parser.getDependencies("scene"),
                parser.getDependencies("animation"),
                parser.getDependencies("camera")
            ]);
        }).then(function(dependencies) {
            const result = {
                scene: dependencies[0][json.scene || 0],
                scenes: dependencies[0],
                animations: dependencies[1],
                cameras: dependencies[2],
                asset: json.asset,
                parser: parser,
                userData: {}
            };
            $50ee5a35738b214d$var$addUnknownExtensionsToUserData(extensions, result, json);
            $50ee5a35738b214d$var$assignExtrasToUserData(result, json);
            Promise.all(parser._invokeAll(function(ext) {
                return ext.afterRoot && ext.afterRoot(result);
            })).then(function() {
                onLoad(result);
            });
        }).catch(onError);
    }
    /**
	 * Marks the special nodes/meshes in json for efficient parse.
	 */ _markDefs() {
        const nodeDefs = this.json.nodes || [];
        const skinDefs = this.json.skins || [];
        const meshDefs = this.json.meshes || [];
        // Nothing in the node definition indicates whether it is a Bone or an
        // Object3D. Use the skins' joint references to mark bones.
        for(let skinIndex = 0, skinLength = skinDefs.length; skinIndex < skinLength; skinIndex++){
            const joints = skinDefs[skinIndex].joints;
            for(let i = 0, il = joints.length; i < il; i++)nodeDefs[joints[i]].isBone = true;
        }
        // Iterate over all nodes, marking references to shared resources,
        // as well as skeleton joints.
        for(let nodeIndex = 0, nodeLength = nodeDefs.length; nodeIndex < nodeLength; nodeIndex++){
            const nodeDef = nodeDefs[nodeIndex];
            if (nodeDef.mesh !== undefined) {
                this._addNodeRef(this.meshCache, nodeDef.mesh);
                // Nothing in the mesh definition indicates whether it is
                // a SkinnedMesh or Mesh. Use the node's mesh reference
                // to mark SkinnedMesh if node has skin.
                if (nodeDef.skin !== undefined) meshDefs[nodeDef.mesh].isSkinnedMesh = true;
            }
            if (nodeDef.camera !== undefined) this._addNodeRef(this.cameraCache, nodeDef.camera);
        }
    }
    /**
	 * Counts references to shared node / Object3D resources. These resources
	 * can be reused, or "instantiated", at multiple nodes in the scene
	 * hierarchy. Mesh, Camera, and Light instances are instantiated and must
	 * be marked. Non-scenegraph resources (like Materials, Geometries, and
	 * Textures) can be reused directly and are not marked here.
	 *
	 * Example: CesiumMilkTruck sample model reuses "Wheel" meshes.
	 */ _addNodeRef(cache, index) {
        if (index === undefined) return;
        if (cache.refs[index] === undefined) cache.refs[index] = cache.uses[index] = 0;
        cache.refs[index]++;
    }
    /** Returns a reference to a shared resource, cloning it if necessary. */ _getNodeRef(cache, index, object) {
        if (cache.refs[index] <= 1) return object;
        const ref = object.clone();
        // Propagates mappings to the cloned object, prevents mappings on the
        // original object from being lost.
        const updateMappings = (original, clone)=>{
            const mappings = this.associations.get(original);
            if (mappings != null) this.associations.set(clone, mappings);
            for (const [i, child] of original.children.entries())updateMappings(child, clone.children[i]);
        };
        updateMappings(object, ref);
        ref.name += "_instance_" + cache.uses[index]++;
        return ref;
    }
    _invokeOne(func) {
        const extensions = Object.values(this.plugins);
        extensions.push(this);
        for(let i = 0; i < extensions.length; i++){
            const result = func(extensions[i]);
            if (result) return result;
        }
        return null;
    }
    _invokeAll(func) {
        const extensions = Object.values(this.plugins);
        extensions.unshift(this);
        const pending = [];
        for(let i = 0; i < extensions.length; i++){
            const result = func(extensions[i]);
            if (result) pending.push(result);
        }
        return pending;
    }
    /**
	 * Requests the specified dependency asynchronously, with caching.
	 * @param {string} type
	 * @param {number} index
	 * @return {Promise<Object3D|Material|THREE.Texture|AnimationClip|ArrayBuffer|Object>}
	 */ getDependency(type, index) {
        const cacheKey = type + ":" + index;
        let dependency = this.cache.get(cacheKey);
        if (!dependency) {
            switch(type){
                case "scene":
                    dependency = this.loadScene(index);
                    break;
                case "node":
                    dependency = this._invokeOne(function(ext) {
                        return ext.loadNode && ext.loadNode(index);
                    });
                    break;
                case "mesh":
                    dependency = this._invokeOne(function(ext) {
                        return ext.loadMesh && ext.loadMesh(index);
                    });
                    break;
                case "accessor":
                    dependency = this.loadAccessor(index);
                    break;
                case "bufferView":
                    dependency = this._invokeOne(function(ext) {
                        return ext.loadBufferView && ext.loadBufferView(index);
                    });
                    break;
                case "buffer":
                    dependency = this.loadBuffer(index);
                    break;
                case "material":
                    dependency = this._invokeOne(function(ext) {
                        return ext.loadMaterial && ext.loadMaterial(index);
                    });
                    break;
                case "texture":
                    dependency = this._invokeOne(function(ext) {
                        return ext.loadTexture && ext.loadTexture(index);
                    });
                    break;
                case "skin":
                    dependency = this.loadSkin(index);
                    break;
                case "animation":
                    dependency = this._invokeOne(function(ext) {
                        return ext.loadAnimation && ext.loadAnimation(index);
                    });
                    break;
                case "camera":
                    dependency = this.loadCamera(index);
                    break;
                default:
                    dependency = this._invokeOne(function(ext) {
                        return ext != this && ext.getDependency && ext.getDependency(type, index);
                    });
                    if (!dependency) throw new Error("Unknown type: " + type);
                    break;
            }
            this.cache.add(cacheKey, dependency);
        }
        return dependency;
    }
    /**
	 * Requests all dependencies of the specified type asynchronously, with caching.
	 * @param {string} type
	 * @return {Promise<Array<Object>>}
	 */ getDependencies(type) {
        let dependencies = this.cache.get(type);
        if (!dependencies) {
            const parser = this;
            const defs = this.json[type + (type === "mesh" ? "es" : "s")] || [];
            dependencies = Promise.all(defs.map(function(def, index) {
                return parser.getDependency(type, index);
            }));
            this.cache.add(type, dependencies);
        }
        return dependencies;
    }
    /**
	 * Specification: https://github.com/KhronosGroup/glTF/blob/master/specification/2.0/README.md#buffers-and-buffer-views
	 * @param {number} bufferIndex
	 * @return {Promise<ArrayBuffer>}
	 */ loadBuffer(bufferIndex) {
        const bufferDef = this.json.buffers[bufferIndex];
        const loader = this.fileLoader;
        if (bufferDef.type && bufferDef.type !== "arraybuffer") throw new Error("THREE.GLTFLoader: " + bufferDef.type + " buffer type is not supported.");
        // If present, GLB container is required to be the first buffer.
        if (bufferDef.uri === undefined && bufferIndex === 0) return Promise.resolve(this.extensions[$50ee5a35738b214d$var$EXTENSIONS.KHR_BINARY_GLTF].body);
        const options = this.options;
        return new Promise(function(resolve, reject) {
            loader.load((0, $9014d97cd777be10$export$b5d2dc08d867e41a).resolveURL(bufferDef.uri, options.path), resolve, undefined, function() {
                reject(new Error('THREE.GLTFLoader: Failed to load buffer "' + bufferDef.uri + '".'));
            });
        });
    }
    /**
	 * Specification: https://github.com/KhronosGroup/glTF/blob/master/specification/2.0/README.md#buffers-and-buffer-views
	 * @param {number} bufferViewIndex
	 * @return {Promise<ArrayBuffer>}
	 */ loadBufferView(bufferViewIndex) {
        const bufferViewDef = this.json.bufferViews[bufferViewIndex];
        return this.getDependency("buffer", bufferViewDef.buffer).then(function(buffer) {
            const byteLength = bufferViewDef.byteLength || 0;
            const byteOffset = bufferViewDef.byteOffset || 0;
            return buffer.slice(byteOffset, byteOffset + byteLength);
        });
    }
    /**
	 * Specification: https://github.com/KhronosGroup/glTF/blob/master/specification/2.0/README.md#accessors
	 * @param {number} accessorIndex
	 * @return {Promise<BufferAttribute|InterleavedBufferAttribute>}
	 */ loadAccessor(accessorIndex) {
        const parser = this;
        const json = this.json;
        const accessorDef = this.json.accessors[accessorIndex];
        if (accessorDef.bufferView === undefined && accessorDef.sparse === undefined) {
            const itemSize = $50ee5a35738b214d$var$WEBGL_TYPE_SIZES[accessorDef.type];
            const TypedArray = $50ee5a35738b214d$var$WEBGL_COMPONENT_TYPES[accessorDef.componentType];
            const normalized = accessorDef.normalized === true;
            const array = new TypedArray(accessorDef.count * itemSize);
            return Promise.resolve(new (0, $9014d97cd777be10$export$8dea267bd6bde117)(array, itemSize, normalized));
        }
        const pendingBufferViews = [];
        if (accessorDef.bufferView !== undefined) pendingBufferViews.push(this.getDependency("bufferView", accessorDef.bufferView));
        else pendingBufferViews.push(null);
        if (accessorDef.sparse !== undefined) {
            pendingBufferViews.push(this.getDependency("bufferView", accessorDef.sparse.indices.bufferView));
            pendingBufferViews.push(this.getDependency("bufferView", accessorDef.sparse.values.bufferView));
        }
        return Promise.all(pendingBufferViews).then(function(bufferViews) {
            const bufferView = bufferViews[0];
            const itemSize = $50ee5a35738b214d$var$WEBGL_TYPE_SIZES[accessorDef.type];
            const TypedArray = $50ee5a35738b214d$var$WEBGL_COMPONENT_TYPES[accessorDef.componentType];
            // For VEC3: itemSize is 3, elementBytes is 4, itemBytes is 12.
            const elementBytes = TypedArray.BYTES_PER_ELEMENT;
            const itemBytes = elementBytes * itemSize;
            const byteOffset = accessorDef.byteOffset || 0;
            const byteStride = accessorDef.bufferView !== undefined ? json.bufferViews[accessorDef.bufferView].byteStride : undefined;
            const normalized = accessorDef.normalized === true;
            let array, bufferAttribute;
            // The buffer is not interleaved if the stride is the item size in bytes.
            if (byteStride && byteStride !== itemBytes) {
                // Each "slice" of the buffer, as defined by 'count' elements of 'byteStride' bytes, gets its own InterleavedBuffer
                // This makes sure that IBA.count reflects accessor.count properly
                const ibSlice = Math.floor(byteOffset / byteStride);
                const ibCacheKey = "InterleavedBuffer:" + accessorDef.bufferView + ":" + accessorDef.componentType + ":" + ibSlice + ":" + accessorDef.count;
                let ib = parser.cache.get(ibCacheKey);
                if (!ib) {
                    array = new TypedArray(bufferView, ibSlice * byteStride, accessorDef.count * byteStride / elementBytes);
                    // Integer parameters to IB/IBA are in array elements, not bytes.
                    ib = new (0, $9014d97cd777be10$export$3d5cd879f108f53f)(array, byteStride / elementBytes);
                    parser.cache.add(ibCacheKey, ib);
                }
                bufferAttribute = new (0, $9014d97cd777be10$export$920b6d07334599c7)(ib, itemSize, byteOffset % byteStride / elementBytes, normalized);
            } else {
                if (bufferView === null) array = new TypedArray(accessorDef.count * itemSize);
                else array = new TypedArray(bufferView, byteOffset, accessorDef.count * itemSize);
                bufferAttribute = new (0, $9014d97cd777be10$export$8dea267bd6bde117)(array, itemSize, normalized);
            }
            // https://github.com/KhronosGroup/glTF/blob/master/specification/2.0/README.md#sparse-accessors
            if (accessorDef.sparse !== undefined) {
                const itemSizeIndices = $50ee5a35738b214d$var$WEBGL_TYPE_SIZES.SCALAR;
                const TypedArrayIndices = $50ee5a35738b214d$var$WEBGL_COMPONENT_TYPES[accessorDef.sparse.indices.componentType];
                const byteOffsetIndices = accessorDef.sparse.indices.byteOffset || 0;
                const byteOffsetValues = accessorDef.sparse.values.byteOffset || 0;
                const sparseIndices = new TypedArrayIndices(bufferViews[1], byteOffsetIndices, accessorDef.sparse.count * itemSizeIndices);
                const sparseValues = new TypedArray(bufferViews[2], byteOffsetValues, accessorDef.sparse.count * itemSize);
                if (bufferView !== null) // Avoid modifying the original ArrayBuffer, if the bufferView wasn't initialized with zeroes.
                bufferAttribute = new (0, $9014d97cd777be10$export$8dea267bd6bde117)(bufferAttribute.array.slice(), bufferAttribute.itemSize, bufferAttribute.normalized);
                for(let i = 0, il = sparseIndices.length; i < il; i++){
                    const index = sparseIndices[i];
                    bufferAttribute.setX(index, sparseValues[i * itemSize]);
                    if (itemSize >= 2) bufferAttribute.setY(index, sparseValues[i * itemSize + 1]);
                    if (itemSize >= 3) bufferAttribute.setZ(index, sparseValues[i * itemSize + 2]);
                    if (itemSize >= 4) bufferAttribute.setW(index, sparseValues[i * itemSize + 3]);
                    if (itemSize >= 5) throw new Error("THREE.GLTFLoader: Unsupported itemSize in sparse BufferAttribute.");
                }
            }
            return bufferAttribute;
        });
    }
    /**
	 * Specification: https://github.com/KhronosGroup/glTF/tree/master/specification/2.0#textures
	 * @param {number} textureIndex
	 * @return {Promise<THREE.Texture|null>}
	 */ loadTexture(textureIndex) {
        const json = this.json;
        const options = this.options;
        const textureDef = json.textures[textureIndex];
        const sourceIndex = textureDef.source;
        const sourceDef = json.images[sourceIndex];
        let loader = this.textureLoader;
        if (sourceDef.uri) {
            const handler = options.manager.getHandler(sourceDef.uri);
            if (handler !== null) loader = handler;
        }
        return this.loadTextureImage(textureIndex, sourceIndex, loader);
    }
    loadTextureImage(textureIndex, sourceIndex, loader) {
        const parser = this;
        const json = this.json;
        const textureDef = json.textures[textureIndex];
        const sourceDef = json.images[sourceIndex];
        const cacheKey = (sourceDef.uri || sourceDef.bufferView) + ":" + textureDef.sampler;
        if (this.textureCache[cacheKey]) // See https://github.com/mrdoob/three.js/issues/21559.
        return this.textureCache[cacheKey];
        const promise = this.loadImageSource(sourceIndex, loader).then(function(texture) {
            texture.flipY = false;
            texture.name = textureDef.name || sourceDef.name || "";
            if (texture.name === "" && typeof sourceDef.uri === "string" && sourceDef.uri.startsWith("data:image/") === false) texture.name = sourceDef.uri;
            const samplers = json.samplers || {};
            const sampler = samplers[textureDef.sampler] || {};
            texture.magFilter = $50ee5a35738b214d$var$WEBGL_FILTERS[sampler.magFilter] || (0, $9014d97cd777be10$export$8a72f490b25c56c8);
            texture.minFilter = $50ee5a35738b214d$var$WEBGL_FILTERS[sampler.minFilter] || (0, $9014d97cd777be10$export$5d8599b6a933fb1b);
            texture.wrapS = $50ee5a35738b214d$var$WEBGL_WRAPPINGS[sampler.wrapS] || (0, $9014d97cd777be10$export$533346c8e8dac0f5);
            texture.wrapT = $50ee5a35738b214d$var$WEBGL_WRAPPINGS[sampler.wrapT] || (0, $9014d97cd777be10$export$533346c8e8dac0f5);
            parser.associations.set(texture, {
                textures: textureIndex
            });
            return texture;
        }).catch(function() {
            return null;
        });
        this.textureCache[cacheKey] = promise;
        return promise;
    }
    loadImageSource(sourceIndex, loader) {
        const parser = this;
        const json = this.json;
        const options = this.options;
        if (this.sourceCache[sourceIndex] !== undefined) return this.sourceCache[sourceIndex].then((texture)=>texture.clone());
        const sourceDef = json.images[sourceIndex];
        const URL = self.URL || self.webkitURL;
        let sourceURI = sourceDef.uri || "";
        let isObjectURL = false;
        if (sourceDef.bufferView !== undefined) // Load binary image data from bufferView, if provided.
        sourceURI = parser.getDependency("bufferView", sourceDef.bufferView).then(function(bufferView) {
            isObjectURL = true;
            const blob = new Blob([
                bufferView
            ], {
                type: sourceDef.mimeType
            });
            sourceURI = URL.createObjectURL(blob);
            return sourceURI;
        });
        else if (sourceDef.uri === undefined) throw new Error("THREE.GLTFLoader: Image " + sourceIndex + " is missing URI and bufferView");
        const promise = Promise.resolve(sourceURI).then(function(sourceURI) {
            return new Promise(function(resolve, reject) {
                let onLoad = resolve;
                if (loader.isImageBitmapLoader === true) onLoad = function(imageBitmap) {
                    const texture = new (0, $9014d97cd777be10$export$5431306cf43de24a)(imageBitmap);
                    texture.needsUpdate = true;
                    resolve(texture);
                };
                loader.load((0, $9014d97cd777be10$export$b5d2dc08d867e41a).resolveURL(sourceURI, options.path), onLoad, undefined, reject);
            });
        }).then(function(texture) {
            // Clean up resources and configure Texture.
            if (isObjectURL === true) URL.revokeObjectURL(sourceURI);
            texture.userData.mimeType = sourceDef.mimeType || $50ee5a35738b214d$var$getImageURIMimeType(sourceDef.uri);
            return texture;
        }).catch(function(error) {
            console.error("THREE.GLTFLoader: Couldn't load texture", sourceURI);
            throw error;
        });
        this.sourceCache[sourceIndex] = promise;
        return promise;
    }
    /**
	 * Asynchronously assigns a texture to the given material parameters.
	 * @param {Object} materialParams
	 * @param {string} mapName
	 * @param {Object} mapDef
	 * @return {Promise<Texture>}
	 */ assignTexture(materialParams, mapName, mapDef, colorSpace) {
        const parser = this;
        return this.getDependency("texture", mapDef.index).then(function(texture) {
            if (!texture) return null;
            if (mapDef.texCoord !== undefined && mapDef.texCoord > 0) {
                texture = texture.clone();
                texture.channel = mapDef.texCoord;
            }
            if (parser.extensions[$50ee5a35738b214d$var$EXTENSIONS.KHR_TEXTURE_TRANSFORM]) {
                const transform = mapDef.extensions !== undefined ? mapDef.extensions[$50ee5a35738b214d$var$EXTENSIONS.KHR_TEXTURE_TRANSFORM] : undefined;
                if (transform) {
                    const gltfReference = parser.associations.get(texture);
                    texture = parser.extensions[$50ee5a35738b214d$var$EXTENSIONS.KHR_TEXTURE_TRANSFORM].extendTexture(texture, transform);
                    parser.associations.set(texture, gltfReference);
                }
            }
            if (colorSpace !== undefined) texture.colorSpace = colorSpace;
            materialParams[mapName] = texture;
            return texture;
        });
    }
    /**
	 * Assigns final material to a Mesh, Line, or Points instance. The instance
	 * already has a material (generated from the glTF material options alone)
	 * but reuse of the same glTF material may require multiple threejs materials
	 * to accommodate different primitive types, defines, etc. New materials will
	 * be created if necessary, and reused from a cache.
	 * @param  {Object3D} mesh Mesh, Line, or Points instance.
	 */ assignFinalMaterial(mesh) {
        const geometry = mesh.geometry;
        let material = mesh.material;
        const useDerivativeTangents = geometry.attributes.tangent === undefined;
        const useVertexColors = geometry.attributes.color !== undefined;
        const useFlatShading = geometry.attributes.normal === undefined;
        if (mesh.isPoints) {
            const cacheKey = "PointsMaterial:" + material.uuid;
            let pointsMaterial = this.cache.get(cacheKey);
            if (!pointsMaterial) {
                pointsMaterial = new (0, $9014d97cd777be10$export$a178c45366ce5d6b)();
                (0, $9014d97cd777be10$export$a2d8b23205c25948).prototype.copy.call(pointsMaterial, material);
                pointsMaterial.color.copy(material.color);
                pointsMaterial.map = material.map;
                pointsMaterial.sizeAttenuation = false; // glTF spec says points should be 1px
                this.cache.add(cacheKey, pointsMaterial);
            }
            material = pointsMaterial;
        } else if (mesh.isLine) {
            const cacheKey = "LineBasicMaterial:" + material.uuid;
            let lineMaterial = this.cache.get(cacheKey);
            if (!lineMaterial) {
                lineMaterial = new (0, $9014d97cd777be10$export$fbaaa33907730a0c)();
                (0, $9014d97cd777be10$export$a2d8b23205c25948).prototype.copy.call(lineMaterial, material);
                lineMaterial.color.copy(material.color);
                lineMaterial.map = material.map;
                this.cache.add(cacheKey, lineMaterial);
            }
            material = lineMaterial;
        }
        // Clone the material if it will be modified
        if (useDerivativeTangents || useVertexColors || useFlatShading) {
            let cacheKey = "ClonedMaterial:" + material.uuid + ":";
            if (useDerivativeTangents) cacheKey += "derivative-tangents:";
            if (useVertexColors) cacheKey += "vertex-colors:";
            if (useFlatShading) cacheKey += "flat-shading:";
            let cachedMaterial = this.cache.get(cacheKey);
            if (!cachedMaterial) {
                cachedMaterial = material.clone();
                if (useVertexColors) cachedMaterial.vertexColors = true;
                if (useFlatShading) cachedMaterial.flatShading = true;
                if (useDerivativeTangents) {
                    // https://github.com/mrdoob/three.js/issues/11438#issuecomment-507003995
                    if (cachedMaterial.normalScale) cachedMaterial.normalScale.y *= -1;
                    if (cachedMaterial.clearcoatNormalScale) cachedMaterial.clearcoatNormalScale.y *= -1;
                }
                this.cache.add(cacheKey, cachedMaterial);
                this.associations.set(cachedMaterial, this.associations.get(material));
            }
            material = cachedMaterial;
        }
        mesh.material = material;
    }
    getMaterialType() {
        return 0, $9014d97cd777be10$export$f2980790215acccd;
    }
    /**
	 * Specification: https://github.com/KhronosGroup/glTF/blob/master/specification/2.0/README.md#materials
	 * @param {number} materialIndex
	 * @return {Promise<Material>}
	 */ loadMaterial(materialIndex) {
        const parser = this;
        const json = this.json;
        const extensions = this.extensions;
        const materialDef = json.materials[materialIndex];
        let materialType;
        const materialParams = {};
        const materialExtensions = materialDef.extensions || {};
        const pending = [];
        if (materialExtensions[$50ee5a35738b214d$var$EXTENSIONS.KHR_MATERIALS_UNLIT]) {
            const kmuExtension = extensions[$50ee5a35738b214d$var$EXTENSIONS.KHR_MATERIALS_UNLIT];
            materialType = kmuExtension.getMaterialType();
            pending.push(kmuExtension.extendParams(materialParams, materialDef, parser));
        } else {
            // Specification:
            // https://github.com/KhronosGroup/glTF/tree/master/specification/2.0#metallic-roughness-material
            const metallicRoughness = materialDef.pbrMetallicRoughness || {};
            materialParams.color = new (0, $9014d97cd777be10$export$892596cec99bc70e)(1.0, 1.0, 1.0);
            materialParams.opacity = 1.0;
            if (Array.isArray(metallicRoughness.baseColorFactor)) {
                const array = metallicRoughness.baseColorFactor;
                materialParams.color.fromArray(array);
                materialParams.opacity = array[3];
            }
            if (metallicRoughness.baseColorTexture !== undefined) pending.push(parser.assignTexture(materialParams, "map", metallicRoughness.baseColorTexture, (0, $9014d97cd777be10$export$561f394b24edfcaa)));
            materialParams.metalness = metallicRoughness.metallicFactor !== undefined ? metallicRoughness.metallicFactor : 1.0;
            materialParams.roughness = metallicRoughness.roughnessFactor !== undefined ? metallicRoughness.roughnessFactor : 1.0;
            if (metallicRoughness.metallicRoughnessTexture !== undefined) {
                pending.push(parser.assignTexture(materialParams, "metalnessMap", metallicRoughness.metallicRoughnessTexture));
                pending.push(parser.assignTexture(materialParams, "roughnessMap", metallicRoughness.metallicRoughnessTexture));
            }
            materialType = this._invokeOne(function(ext) {
                return ext.getMaterialType && ext.getMaterialType(materialIndex);
            });
            pending.push(Promise.all(this._invokeAll(function(ext) {
                return ext.extendMaterialParams && ext.extendMaterialParams(materialIndex, materialParams);
            })));
        }
        if (materialDef.doubleSided === true) materialParams.side = (0, $9014d97cd777be10$export$3b296b6f144d5b03);
        const alphaMode = materialDef.alphaMode || $50ee5a35738b214d$var$ALPHA_MODES.OPAQUE;
        if (alphaMode === $50ee5a35738b214d$var$ALPHA_MODES.BLEND) {
            materialParams.transparent = true;
            // See: https://github.com/mrdoob/three.js/issues/17706
            materialParams.depthWrite = false;
        } else {
            materialParams.transparent = false;
            if (alphaMode === $50ee5a35738b214d$var$ALPHA_MODES.MASK) materialParams.alphaTest = materialDef.alphaCutoff !== undefined ? materialDef.alphaCutoff : 0.5;
        }
        if (materialDef.normalTexture !== undefined && materialType !== (0, $9014d97cd777be10$export$55cbcc9b622fe1f5)) {
            pending.push(parser.assignTexture(materialParams, "normalMap", materialDef.normalTexture));
            materialParams.normalScale = new (0, $9014d97cd777be10$export$c977b3e384af9ae1)(1, 1);
            if (materialDef.normalTexture.scale !== undefined) {
                const scale = materialDef.normalTexture.scale;
                materialParams.normalScale.set(scale, scale);
            }
        }
        if (materialDef.occlusionTexture !== undefined && materialType !== (0, $9014d97cd777be10$export$55cbcc9b622fe1f5)) {
            pending.push(parser.assignTexture(materialParams, "aoMap", materialDef.occlusionTexture));
            if (materialDef.occlusionTexture.strength !== undefined) materialParams.aoMapIntensity = materialDef.occlusionTexture.strength;
        }
        if (materialDef.emissiveFactor !== undefined && materialType !== (0, $9014d97cd777be10$export$55cbcc9b622fe1f5)) materialParams.emissive = new (0, $9014d97cd777be10$export$892596cec99bc70e)().fromArray(materialDef.emissiveFactor);
        if (materialDef.emissiveTexture !== undefined && materialType !== (0, $9014d97cd777be10$export$55cbcc9b622fe1f5)) pending.push(parser.assignTexture(materialParams, "emissiveMap", materialDef.emissiveTexture, (0, $9014d97cd777be10$export$561f394b24edfcaa)));
        return Promise.all(pending).then(function() {
            const material = new materialType(materialParams);
            if (materialDef.name) material.name = materialDef.name;
            $50ee5a35738b214d$var$assignExtrasToUserData(material, materialDef);
            parser.associations.set(material, {
                materials: materialIndex
            });
            if (materialDef.extensions) $50ee5a35738b214d$var$addUnknownExtensionsToUserData(extensions, material, materialDef);
            return material;
        });
    }
    /** When Object3D instances are targeted by animation, they need unique names. */ createUniqueName(originalName) {
        const sanitizedName = (0, $9014d97cd777be10$export$7bf70fcf9f891893).sanitizeNodeName(originalName || "");
        if (sanitizedName in this.nodeNamesUsed) return sanitizedName + "_" + ++this.nodeNamesUsed[sanitizedName];
        else {
            this.nodeNamesUsed[sanitizedName] = 0;
            return sanitizedName;
        }
    }
    /**
	 * Specification: https://github.com/KhronosGroup/glTF/blob/master/specification/2.0/README.md#geometry
	 *
	 * Creates BufferGeometries from primitives.
	 *
	 * @param {Array<GLTF.Primitive>} primitives
	 * @return {Promise<Array<BufferGeometry>>}
	 */ loadGeometries(primitives) {
        const parser = this;
        const extensions = this.extensions;
        const cache = this.primitiveCache;
        function createDracoPrimitive(primitive) {
            return extensions[$50ee5a35738b214d$var$EXTENSIONS.KHR_DRACO_MESH_COMPRESSION].decodePrimitive(primitive, parser).then(function(geometry) {
                return $50ee5a35738b214d$var$addPrimitiveAttributes(geometry, primitive, parser);
            });
        }
        const pending = [];
        for(let i = 0, il = primitives.length; i < il; i++){
            const primitive = primitives[i];
            const cacheKey = $50ee5a35738b214d$var$createPrimitiveKey(primitive);
            // See if we've already created this geometry
            const cached = cache[cacheKey];
            if (cached) // Use the cached geometry if it exists
            pending.push(cached.promise);
            else {
                let geometryPromise;
                if (primitive.extensions && primitive.extensions[$50ee5a35738b214d$var$EXTENSIONS.KHR_DRACO_MESH_COMPRESSION]) // Use DRACO geometry if available
                geometryPromise = createDracoPrimitive(primitive);
                else // Otherwise create a new geometry
                geometryPromise = $50ee5a35738b214d$var$addPrimitiveAttributes(new (0, $9014d97cd777be10$export$b7be63a67df8959)(), primitive, parser);
                // Cache this geometry
                cache[cacheKey] = {
                    primitive: primitive,
                    promise: geometryPromise
                };
                pending.push(geometryPromise);
            }
        }
        return Promise.all(pending);
    }
    /**
	 * Specification: https://github.com/KhronosGroup/glTF/blob/master/specification/2.0/README.md#meshes
	 * @param {number} meshIndex
	 * @return {Promise<Group|Mesh|SkinnedMesh>}
	 */ loadMesh(meshIndex) {
        const parser = this;
        const json = this.json;
        const extensions = this.extensions;
        const meshDef = json.meshes[meshIndex];
        const primitives = meshDef.primitives;
        const pending = [];
        for(let i = 0, il = primitives.length; i < il; i++){
            const material = primitives[i].material === undefined ? $50ee5a35738b214d$var$createDefaultMaterial(this.cache) : this.getDependency("material", primitives[i].material);
            pending.push(material);
        }
        pending.push(parser.loadGeometries(primitives));
        return Promise.all(pending).then(function(results) {
            const materials = results.slice(0, results.length - 1);
            const geometries = results[results.length - 1];
            const meshes = [];
            for(let i = 0, il = geometries.length; i < il; i++){
                const geometry = geometries[i];
                const primitive = primitives[i];
                // 1. create Mesh
                let mesh;
                const material = materials[i];
                if (primitive.mode === $50ee5a35738b214d$var$WEBGL_CONSTANTS.TRIANGLES || primitive.mode === $50ee5a35738b214d$var$WEBGL_CONSTANTS.TRIANGLE_STRIP || primitive.mode === $50ee5a35738b214d$var$WEBGL_CONSTANTS.TRIANGLE_FAN || primitive.mode === undefined) {
                    // .isSkinnedMesh isn't in glTF spec. See ._markDefs()
                    mesh = meshDef.isSkinnedMesh === true ? new (0, $9014d97cd777be10$export$b303577035157ecf)(geometry, material) : new (0, $9014d97cd777be10$export$e176487c05830cc5)(geometry, material);
                    if (mesh.isSkinnedMesh === true) // normalize skin weights to fix malformed assets (see #15319)
                    mesh.normalizeSkinWeights();
                    if (primitive.mode === $50ee5a35738b214d$var$WEBGL_CONSTANTS.TRIANGLE_STRIP) mesh.geometry = (0, $407c46667e865c99$export$5492ca6e5c0c7aa0)(mesh.geometry, (0, $9014d97cd777be10$export$b23a071aa286eb29));
                    else if (primitive.mode === $50ee5a35738b214d$var$WEBGL_CONSTANTS.TRIANGLE_FAN) mesh.geometry = (0, $407c46667e865c99$export$5492ca6e5c0c7aa0)(mesh.geometry, (0, $9014d97cd777be10$export$f0d8293634f88842));
                } else if (primitive.mode === $50ee5a35738b214d$var$WEBGL_CONSTANTS.LINES) mesh = new (0, $9014d97cd777be10$export$ff1ed10fedfdd604)(geometry, material);
                else if (primitive.mode === $50ee5a35738b214d$var$WEBGL_CONSTANTS.LINE_STRIP) mesh = new (0, $9014d97cd777be10$export$17d680238e50603e)(geometry, material);
                else if (primitive.mode === $50ee5a35738b214d$var$WEBGL_CONSTANTS.LINE_LOOP) mesh = new (0, $9014d97cd777be10$export$f85a24d745e4f17d)(geometry, material);
                else if (primitive.mode === $50ee5a35738b214d$var$WEBGL_CONSTANTS.POINTS) mesh = new (0, $9014d97cd777be10$export$1c787534cb11aa3e)(geometry, material);
                else throw new Error("THREE.GLTFLoader: Primitive mode unsupported: " + primitive.mode);
                if (Object.keys(mesh.geometry.morphAttributes).length > 0) $50ee5a35738b214d$var$updateMorphTargets(mesh, meshDef);
                mesh.name = parser.createUniqueName(meshDef.name || "mesh_" + meshIndex);
                $50ee5a35738b214d$var$assignExtrasToUserData(mesh, meshDef);
                if (primitive.extensions) $50ee5a35738b214d$var$addUnknownExtensionsToUserData(extensions, mesh, primitive);
                parser.assignFinalMaterial(mesh);
                meshes.push(mesh);
            }
            for(let i = 0, il = meshes.length; i < il; i++)parser.associations.set(meshes[i], {
                meshes: meshIndex,
                primitives: i
            });
            if (meshes.length === 1) {
                if (meshDef.extensions) $50ee5a35738b214d$var$addUnknownExtensionsToUserData(extensions, meshes[0], meshDef);
                return meshes[0];
            }
            const group = new (0, $9014d97cd777be10$export$eb2fcfdbd7ba97d4)();
            if (meshDef.extensions) $50ee5a35738b214d$var$addUnknownExtensionsToUserData(extensions, group, meshDef);
            parser.associations.set(group, {
                meshes: meshIndex
            });
            for(let i = 0, il = meshes.length; i < il; i++)group.add(meshes[i]);
            return group;
        });
    }
    /**
	 * Specification: https://github.com/KhronosGroup/glTF/tree/master/specification/2.0#cameras
	 * @param {number} cameraIndex
	 * @return {Promise<THREE.Camera>}
	 */ loadCamera(cameraIndex) {
        let camera;
        const cameraDef = this.json.cameras[cameraIndex];
        const params = cameraDef[cameraDef.type];
        if (!params) {
            console.warn("THREE.GLTFLoader: Missing camera parameters.");
            return;
        }
        if (cameraDef.type === "perspective") camera = new (0, $9014d97cd777be10$export$74e4ae24825f68d7)((0, $9014d97cd777be10$export$6a7ef315a0d1ef07).radToDeg(params.yfov), params.aspectRatio || 1, params.znear || 1, params.zfar || 2e6);
        else if (cameraDef.type === "orthographic") camera = new (0, $9014d97cd777be10$export$9ebf355ee4ed261b)(-params.xmag, params.xmag, params.ymag, -params.ymag, params.znear, params.zfar);
        if (cameraDef.name) camera.name = this.createUniqueName(cameraDef.name);
        $50ee5a35738b214d$var$assignExtrasToUserData(camera, cameraDef);
        return Promise.resolve(camera);
    }
    /**
	 * Specification: https://github.com/KhronosGroup/glTF/tree/master/specification/2.0#skins
	 * @param {number} skinIndex
	 * @return {Promise<Skeleton>}
	 */ loadSkin(skinIndex) {
        const skinDef = this.json.skins[skinIndex];
        const pending = [];
        for(let i = 0, il = skinDef.joints.length; i < il; i++)pending.push(this._loadNodeShallow(skinDef.joints[i]));
        if (skinDef.inverseBindMatrices !== undefined) pending.push(this.getDependency("accessor", skinDef.inverseBindMatrices));
        else pending.push(null);
        return Promise.all(pending).then(function(results) {
            const inverseBindMatrices = results.pop();
            const jointNodes = results;
            // Note that bones (joint nodes) may or may not be in the
            // scene graph at this time.
            const bones = [];
            const boneInverses = [];
            for(let i = 0, il = jointNodes.length; i < il; i++){
                const jointNode = jointNodes[i];
                if (jointNode) {
                    bones.push(jointNode);
                    const mat = new (0, $9014d97cd777be10$export$2ae72fc923e5eb5)();
                    if (inverseBindMatrices !== null) mat.fromArray(inverseBindMatrices.array, i * 16);
                    boneInverses.push(mat);
                } else console.warn('THREE.GLTFLoader: Joint "%s" could not be found.', skinDef.joints[i]);
            }
            return new (0, $9014d97cd777be10$export$8f31e4c4a37b8e9c)(bones, boneInverses);
        });
    }
    /**
	 * Specification: https://github.com/KhronosGroup/glTF/tree/master/specification/2.0#animations
	 * @param {number} animationIndex
	 * @return {Promise<AnimationClip>}
	 */ loadAnimation(animationIndex) {
        const json = this.json;
        const parser = this;
        const animationDef = json.animations[animationIndex];
        const animationName = animationDef.name ? animationDef.name : "animation_" + animationIndex;
        const pendingNodes = [];
        const pendingInputAccessors = [];
        const pendingOutputAccessors = [];
        const pendingSamplers = [];
        const pendingTargets = [];
        for(let i = 0, il = animationDef.channels.length; i < il; i++){
            const channel = animationDef.channels[i];
            const sampler = animationDef.samplers[channel.sampler];
            const target = channel.target;
            const name = target.node;
            const input = animationDef.parameters !== undefined ? animationDef.parameters[sampler.input] : sampler.input;
            const output = animationDef.parameters !== undefined ? animationDef.parameters[sampler.output] : sampler.output;
            if (target.node === undefined) continue;
            pendingNodes.push(this.getDependency("node", name));
            pendingInputAccessors.push(this.getDependency("accessor", input));
            pendingOutputAccessors.push(this.getDependency("accessor", output));
            pendingSamplers.push(sampler);
            pendingTargets.push(target);
        }
        return Promise.all([
            Promise.all(pendingNodes),
            Promise.all(pendingInputAccessors),
            Promise.all(pendingOutputAccessors),
            Promise.all(pendingSamplers),
            Promise.all(pendingTargets)
        ]).then(function(dependencies) {
            const nodes = dependencies[0];
            const inputAccessors = dependencies[1];
            const outputAccessors = dependencies[2];
            const samplers = dependencies[3];
            const targets = dependencies[4];
            const tracks = [];
            for(let i = 0, il = nodes.length; i < il; i++){
                const node = nodes[i];
                const inputAccessor = inputAccessors[i];
                const outputAccessor = outputAccessors[i];
                const sampler = samplers[i];
                const target = targets[i];
                if (node === undefined) continue;
                if (node.updateMatrix) node.updateMatrix();
                const createdTracks = parser._createAnimationTracks(node, inputAccessor, outputAccessor, sampler, target);
                if (createdTracks) for(let k = 0; k < createdTracks.length; k++)tracks.push(createdTracks[k]);
            }
            return new (0, $9014d97cd777be10$export$d942c706bf23829c)(animationName, undefined, tracks);
        });
    }
    createNodeMesh(nodeIndex) {
        const json = this.json;
        const parser = this;
        const nodeDef = json.nodes[nodeIndex];
        if (nodeDef.mesh === undefined) return null;
        return parser.getDependency("mesh", nodeDef.mesh).then(function(mesh) {
            const node = parser._getNodeRef(parser.meshCache, nodeDef.mesh, mesh);
            // if weights are provided on the node, override weights on the mesh.
            if (nodeDef.weights !== undefined) node.traverse(function(o) {
                if (!o.isMesh) return;
                for(let i = 0, il = nodeDef.weights.length; i < il; i++)o.morphTargetInfluences[i] = nodeDef.weights[i];
            });
            return node;
        });
    }
    /**
	 * Specification: https://github.com/KhronosGroup/glTF/tree/master/specification/2.0#nodes-and-hierarchy
	 * @param {number} nodeIndex
	 * @return {Promise<Object3D>}
	 */ loadNode(nodeIndex) {
        const json = this.json;
        const parser = this;
        const nodeDef = json.nodes[nodeIndex];
        const nodePending = parser._loadNodeShallow(nodeIndex);
        const childPending = [];
        const childrenDef = nodeDef.children || [];
        for(let i = 0, il = childrenDef.length; i < il; i++)childPending.push(parser.getDependency("node", childrenDef[i]));
        const skeletonPending = nodeDef.skin === undefined ? Promise.resolve(null) : parser.getDependency("skin", nodeDef.skin);
        return Promise.all([
            nodePending,
            Promise.all(childPending),
            skeletonPending
        ]).then(function(results) {
            const node = results[0];
            const children = results[1];
            const skeleton = results[2];
            if (skeleton !== null) // This full traverse should be fine because
            // child glTF nodes have not been added to this node yet.
            node.traverse(function(mesh) {
                if (!mesh.isSkinnedMesh) return;
                mesh.bind(skeleton, $50ee5a35738b214d$var$_identityMatrix);
            });
            for(let i = 0, il = children.length; i < il; i++)node.add(children[i]);
            return node;
        });
    }
    // ._loadNodeShallow() parses a single node.
    // skin and child nodes are created and added in .loadNode() (no '_' prefix).
    _loadNodeShallow(nodeIndex) {
        const json = this.json;
        const extensions = this.extensions;
        const parser = this;
        // This method is called from .loadNode() and .loadSkin().
        // Cache a node to avoid duplication.
        if (this.nodeCache[nodeIndex] !== undefined) return this.nodeCache[nodeIndex];
        const nodeDef = json.nodes[nodeIndex];
        // reserve node's name before its dependencies, so the root has the intended name.
        const nodeName = nodeDef.name ? parser.createUniqueName(nodeDef.name) : "";
        const pending = [];
        const meshPromise = parser._invokeOne(function(ext) {
            return ext.createNodeMesh && ext.createNodeMesh(nodeIndex);
        });
        if (meshPromise) pending.push(meshPromise);
        if (nodeDef.camera !== undefined) pending.push(parser.getDependency("camera", nodeDef.camera).then(function(camera) {
            return parser._getNodeRef(parser.cameraCache, nodeDef.camera, camera);
        }));
        parser._invokeAll(function(ext) {
            return ext.createNodeAttachment && ext.createNodeAttachment(nodeIndex);
        }).forEach(function(promise) {
            pending.push(promise);
        });
        this.nodeCache[nodeIndex] = Promise.all(pending).then(function(objects) {
            let node;
            // .isBone isn't in glTF spec. See ._markDefs
            if (nodeDef.isBone === true) node = new (0, $9014d97cd777be10$export$b127726e56765aa4)();
            else if (objects.length > 1) node = new (0, $9014d97cd777be10$export$eb2fcfdbd7ba97d4)();
            else if (objects.length === 1) node = objects[0];
            else node = new (0, $9014d97cd777be10$export$e4dd07dff30cc924)();
            if (node !== objects[0]) for(let i = 0, il = objects.length; i < il; i++)node.add(objects[i]);
            if (nodeDef.name) {
                node.userData.name = nodeDef.name;
                node.name = nodeName;
            }
            $50ee5a35738b214d$var$assignExtrasToUserData(node, nodeDef);
            if (nodeDef.extensions) $50ee5a35738b214d$var$addUnknownExtensionsToUserData(extensions, node, nodeDef);
            if (nodeDef.matrix !== undefined) {
                const matrix = new (0, $9014d97cd777be10$export$2ae72fc923e5eb5)();
                matrix.fromArray(nodeDef.matrix);
                node.applyMatrix4(matrix);
            } else {
                if (nodeDef.translation !== undefined) node.position.fromArray(nodeDef.translation);
                if (nodeDef.rotation !== undefined) node.quaternion.fromArray(nodeDef.rotation);
                if (nodeDef.scale !== undefined) node.scale.fromArray(nodeDef.scale);
            }
            if (!parser.associations.has(node)) parser.associations.set(node, {});
            parser.associations.get(node).nodes = nodeIndex;
            return node;
        });
        return this.nodeCache[nodeIndex];
    }
    /**
	 * Specification: https://github.com/KhronosGroup/glTF/tree/master/specification/2.0#scenes
	 * @param {number} sceneIndex
	 * @return {Promise<Group>}
	 */ loadScene(sceneIndex) {
        const extensions = this.extensions;
        const sceneDef = this.json.scenes[sceneIndex];
        const parser = this;
        // Loader returns Group, not Scene.
        // See: https://github.com/mrdoob/three.js/issues/18342#issuecomment-578981172
        const scene = new (0, $9014d97cd777be10$export$eb2fcfdbd7ba97d4)();
        if (sceneDef.name) scene.name = parser.createUniqueName(sceneDef.name);
        $50ee5a35738b214d$var$assignExtrasToUserData(scene, sceneDef);
        if (sceneDef.extensions) $50ee5a35738b214d$var$addUnknownExtensionsToUserData(extensions, scene, sceneDef);
        const nodeIds = sceneDef.nodes || [];
        const pending = [];
        for(let i = 0, il = nodeIds.length; i < il; i++)pending.push(parser.getDependency("node", nodeIds[i]));
        return Promise.all(pending).then(function(nodes) {
            for(let i = 0, il = nodes.length; i < il; i++)scene.add(nodes[i]);
            // Removes dangling associations, associations that reference a node that
            // didn't make it into the scene.
            const reduceAssociations = (node)=>{
                const reducedAssociations = new Map();
                for (const [key, value] of parser.associations)if (key instanceof (0, $9014d97cd777be10$export$a2d8b23205c25948) || key instanceof (0, $9014d97cd777be10$export$5431306cf43de24a)) reducedAssociations.set(key, value);
                node.traverse((node)=>{
                    const mappings = parser.associations.get(node);
                    if (mappings != null) reducedAssociations.set(node, mappings);
                });
                return reducedAssociations;
            };
            parser.associations = reduceAssociations(scene);
            return scene;
        });
    }
    _createAnimationTracks(node, inputAccessor, outputAccessor, sampler, target) {
        const tracks = [];
        const targetName = node.name ? node.name : node.uuid;
        const targetNames = [];
        if ($50ee5a35738b214d$var$PATH_PROPERTIES[target.path] === $50ee5a35738b214d$var$PATH_PROPERTIES.weights) node.traverse(function(object) {
            if (object.morphTargetInfluences) targetNames.push(object.name ? object.name : object.uuid);
        });
        else targetNames.push(targetName);
        let TypedKeyframeTrack;
        switch($50ee5a35738b214d$var$PATH_PROPERTIES[target.path]){
            case $50ee5a35738b214d$var$PATH_PROPERTIES.weights:
                TypedKeyframeTrack = (0, $9014d97cd777be10$export$d45f0d1a4d9a9314);
                break;
            case $50ee5a35738b214d$var$PATH_PROPERTIES.rotation:
                TypedKeyframeTrack = (0, $9014d97cd777be10$export$b8043f12b5aafbd7);
                break;
            case $50ee5a35738b214d$var$PATH_PROPERTIES.position:
            case $50ee5a35738b214d$var$PATH_PROPERTIES.scale:
                TypedKeyframeTrack = (0, $9014d97cd777be10$export$5ce2dcb4cc9f2bff);
                break;
            default:
                switch(outputAccessor.itemSize){
                    case 1:
                        TypedKeyframeTrack = (0, $9014d97cd777be10$export$d45f0d1a4d9a9314);
                        break;
                    case 2:
                    case 3:
                    default:
                        TypedKeyframeTrack = (0, $9014d97cd777be10$export$5ce2dcb4cc9f2bff);
                        break;
                }
                break;
        }
        const interpolation = sampler.interpolation !== undefined ? $50ee5a35738b214d$var$INTERPOLATION[sampler.interpolation] : (0, $9014d97cd777be10$export$30fac1aace31cf4d);
        const outputArray = this._getArrayFromAccessor(outputAccessor);
        for(let j = 0, jl = targetNames.length; j < jl; j++){
            const track = new TypedKeyframeTrack(targetNames[j] + "." + $50ee5a35738b214d$var$PATH_PROPERTIES[target.path], inputAccessor.array, outputArray, interpolation);
            // Override interpolation with custom factory method.
            if (sampler.interpolation === "CUBICSPLINE") this._createCubicSplineTrackInterpolant(track);
            tracks.push(track);
        }
        return tracks;
    }
    _getArrayFromAccessor(accessor) {
        let outputArray = accessor.array;
        if (accessor.normalized) {
            const scale = $50ee5a35738b214d$var$getNormalizedComponentScale(outputArray.constructor);
            const scaled = new Float32Array(outputArray.length);
            for(let j = 0, jl = outputArray.length; j < jl; j++)scaled[j] = outputArray[j] * scale;
            outputArray = scaled;
        }
        return outputArray;
    }
    _createCubicSplineTrackInterpolant(track) {
        track.createInterpolant = function InterpolantFactoryMethodGLTFCubicSpline(result) {
            // A CUBICSPLINE keyframe in glTF has three output values for each input value,
            // representing inTangent, splineVertex, and outTangent. As a result, track.getValueSize()
            // must be divided by three to get the interpolant's sampleSize argument.
            const interpolantType = this instanceof (0, $9014d97cd777be10$export$b8043f12b5aafbd7) ? $50ee5a35738b214d$var$GLTFCubicSplineQuaternionInterpolant : $50ee5a35738b214d$var$GLTFCubicSplineInterpolant;
            return new interpolantType(this.times, this.values, this.getValueSize() / 3, result);
        };
        // Mark as CUBICSPLINE. `track.getInterpolation()` doesn't support custom interpolants.
        track.createInterpolant.isInterpolantFactoryMethodGLTFCubicSpline = true;
    }
    constructor(json = {}, options = {}){
        this.json = json;
        this.extensions = {};
        this.plugins = {};
        this.options = options;
        // loader object cache
        this.cache = new $50ee5a35738b214d$var$GLTFRegistry();
        // associations between Three.js objects and glTF elements
        this.associations = new Map();
        // BufferGeometry caching
        this.primitiveCache = {};
        // Node cache
        this.nodeCache = {};
        // Object3D instance caches
        this.meshCache = {
            refs: {},
            uses: {}
        };
        this.cameraCache = {
            refs: {},
            uses: {}
        };
        this.lightCache = {
            refs: {},
            uses: {}
        };
        this.sourceCache = {};
        this.textureCache = {};
        // Track node names, to ensure no duplicates
        this.nodeNamesUsed = {};
        // Use an ImageBitmapLoader if imageBitmaps are supported. Moves much of the
        // expensive work of uploading a texture to the GPU off the main thread.
        let isSafari = false;
        let isFirefox = false;
        let firefoxVersion = -1;
        if (typeof navigator !== "undefined") {
            isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent) === true;
            isFirefox = navigator.userAgent.indexOf("Firefox") > -1;
            firefoxVersion = isFirefox ? navigator.userAgent.match(/Firefox\/([0-9]+)\./)[1] : -1;
        }
        if (typeof createImageBitmap === "undefined" || isSafari || isFirefox && firefoxVersion < 98) this.textureLoader = new (0, $9014d97cd777be10$export$fd1bfc71f64c538c)(this.options.manager);
        else this.textureLoader = new (0, $9014d97cd777be10$export$52286b55c4a9b51f)(this.options.manager);
        this.textureLoader.setCrossOrigin(this.options.crossOrigin);
        this.textureLoader.setRequestHeader(this.options.requestHeader);
        this.fileLoader = new (0, $9014d97cd777be10$export$98435a25b5cf7b2b)(this.options.manager);
        this.fileLoader.setResponseType("arraybuffer");
        if (this.options.crossOrigin === "use-credentials") this.fileLoader.setWithCredentials(true);
    }
}
/**
 * @param {BufferGeometry} geometry
 * @param {GLTF.Primitive} primitiveDef
 * @param {GLTFParser} parser
 */ function $50ee5a35738b214d$var$computeBounds(geometry, primitiveDef, parser) {
    const attributes = primitiveDef.attributes;
    const box = new (0, $9014d97cd777be10$export$6f7d5a9418ab2aa3)();
    if (attributes.POSITION !== undefined) {
        const accessor = parser.json.accessors[attributes.POSITION];
        const min = accessor.min;
        const max = accessor.max;
        // glTF requires 'min' and 'max', but VRM (which extends glTF) currently ignores that requirement.
        if (min !== undefined && max !== undefined) {
            box.set(new (0, $9014d97cd777be10$export$64b5c384219d3699)(min[0], min[1], min[2]), new (0, $9014d97cd777be10$export$64b5c384219d3699)(max[0], max[1], max[2]));
            if (accessor.normalized) {
                const boxScale = $50ee5a35738b214d$var$getNormalizedComponentScale($50ee5a35738b214d$var$WEBGL_COMPONENT_TYPES[accessor.componentType]);
                box.min.multiplyScalar(boxScale);
                box.max.multiplyScalar(boxScale);
            }
        } else {
            console.warn("THREE.GLTFLoader: Missing min/max properties for accessor POSITION.");
            return;
        }
    } else return;
    const targets = primitiveDef.targets;
    if (targets !== undefined) {
        const maxDisplacement = new (0, $9014d97cd777be10$export$64b5c384219d3699)();
        const vector = new (0, $9014d97cd777be10$export$64b5c384219d3699)();
        for(let i = 0, il = targets.length; i < il; i++){
            const target = targets[i];
            if (target.POSITION !== undefined) {
                const accessor = parser.json.accessors[target.POSITION];
                const min = accessor.min;
                const max = accessor.max;
                // glTF requires 'min' and 'max', but VRM (which extends glTF) currently ignores that requirement.
                if (min !== undefined && max !== undefined) {
                    // we need to get max of absolute components because target weight is [-1,1]
                    vector.setX(Math.max(Math.abs(min[0]), Math.abs(max[0])));
                    vector.setY(Math.max(Math.abs(min[1]), Math.abs(max[1])));
                    vector.setZ(Math.max(Math.abs(min[2]), Math.abs(max[2])));
                    if (accessor.normalized) {
                        const boxScale = $50ee5a35738b214d$var$getNormalizedComponentScale($50ee5a35738b214d$var$WEBGL_COMPONENT_TYPES[accessor.componentType]);
                        vector.multiplyScalar(boxScale);
                    }
                    // Note: this assumes that the sum of all weights is at most 1. This isn't quite correct - it's more conservative
                    // to assume that each target can have a max weight of 1. However, for some use cases - notably, when morph targets
                    // are used to implement key-frame animations and as such only two are active at a time - this results in very large
                    // boxes. So for now we make a box that's sometimes a touch too small but is hopefully mostly of reasonable size.
                    maxDisplacement.max(vector);
                } else console.warn("THREE.GLTFLoader: Missing min/max properties for accessor POSITION.");
            }
        }
        // As per comment above this box isn't conservative, but has a reasonable size for a very large number of morph targets.
        box.expandByVector(maxDisplacement);
    }
    geometry.boundingBox = box;
    const sphere = new (0, $9014d97cd777be10$export$805e8b72413ccaba)();
    box.getCenter(sphere.center);
    sphere.radius = box.min.distanceTo(box.max) / 2;
    geometry.boundingSphere = sphere;
}
/**
 * @param {BufferGeometry} geometry
 * @param {GLTF.Primitive} primitiveDef
 * @param {GLTFParser} parser
 * @return {Promise<BufferGeometry>}
 */ function $50ee5a35738b214d$var$addPrimitiveAttributes(geometry, primitiveDef, parser) {
    const attributes = primitiveDef.attributes;
    const pending = [];
    function assignAttributeAccessor(accessorIndex, attributeName) {
        return parser.getDependency("accessor", accessorIndex).then(function(accessor) {
            geometry.setAttribute(attributeName, accessor);
        });
    }
    for(const gltfAttributeName in attributes){
        const threeAttributeName = $50ee5a35738b214d$var$ATTRIBUTES[gltfAttributeName] || gltfAttributeName.toLowerCase();
        // Skip attributes already provided by e.g. Draco extension.
        if (threeAttributeName in geometry.attributes) continue;
        pending.push(assignAttributeAccessor(attributes[gltfAttributeName], threeAttributeName));
    }
    if (primitiveDef.indices !== undefined && !geometry.index) {
        const accessor = parser.getDependency("accessor", primitiveDef.indices).then(function(accessor) {
            geometry.setIndex(accessor);
        });
        pending.push(accessor);
    }
    $50ee5a35738b214d$var$assignExtrasToUserData(geometry, primitiveDef);
    $50ee5a35738b214d$var$computeBounds(geometry, primitiveDef, parser);
    return Promise.all(pending).then(function() {
        return primitiveDef.targets !== undefined ? $50ee5a35738b214d$var$addMorphTargets(geometry, primitiveDef.targets, parser) : geometry;
    });
}



class $34c83dfa2399e766$export$d7f4374543ade8ab extends (0, $fc7b18e354612676$export$5d53140180d567a1) {
    async Initialize() {
        this.LogInfo("Loading assets!");
        (0, $018036e722cee03d$export$8e561b4222bacdfd).forEach((characterDetails)=>{
            this.numberOfModelsToLoad++;
            this.LoadModel(characterDetails.assetPath);
        });
        Game.ListenForEvent("LoadEvent", (event)=>{
            const { eventName: eventName } = event;
            // console.log("Got load event");
            if (eventName === "modelLoaded") {
                this.modelsLoaded++;
                // console.log(this.modelsLoaded, this.numberOfModelsToLoad);
                if (this.modelsLoaded >= this.numberOfModelsToLoad) Game.EmitEvent("LoadEvent", {
                    eventName: "LevelLoaded"
                });
                this._onLoadProgress();
            } else {
                if (this.receivedEvents.includes(eventName)) // console.warn("Received duplicate loading event, ignoring...");
                return;
                this.receivedEvents.push(eventName);
                this._onLoadProgress();
            }
        });
        this.LogInfo("Ready (ish)!");
    }
    _onLoadProgress() {
        // console.log("---");
        // console.warn("On load progress");
        const totalRequired = this.requiredEvents.length + this.numberOfModelsToLoad;
        const loaded = this.receivedEvents.length + this.modelsLoaded;
        const aggregatePercentageLoaded = Math.floor(loaded / totalRequired * 100);
        // console.log({ totalRequired, loaded, aggregatePercentageLoaded });
        // console.log("aggregatePercentageLoaded", aggregatePercentageLoaded);
        if (aggregatePercentageLoaded >= 85) Game.EmitEvent("Loading::AlmostComplete", aggregatePercentageLoaded);
        else Game.EmitEvent("Loading::ProgressUpdated", aggregatePercentageLoaded);
        if (aggregatePercentageLoaded >= 100 && this.initialLoadComplete === false) this._onLoadComplete();
    }
    async LoadModel(modelPath) {
        try {
            return new Promise((resolve, reject)=>{
                this.modelLoader.load(modelPath, (gltf)=>{
                    Game.EmitEvent("LoadEvent", {
                        eventName: "modelLoaded"
                    });
                    resolve(gltf);
                }, (__progress)=>{
                // console.log("Loading model progress:", progress);
                }, (error)=>{
                    reject(error);
                });
            });
        } catch (e) {
            console.error("Caught error loading assets!");
            console.log(e);
            return Promise.reject(e);
        }
    }
    _onLoadComplete() {
        this.initialLoadComplete = true;
        this.LogInfo("Assets loaded!");
        Game.EmitEvent("UI::FadeOutLoadingScreen");
        Game.EmitEvent("SDK::GameLoadingFinished");
    }
    getSystemName() {
        return "Loader";
    }
    Update(__deltaTimeS, __deltaTimeMS, __currentTickStartTimestampMs) {}
    Cleanup() {}
    constructor(){
        super();
        this.AssetsFullyLoaded = false;
        this.TextureLoader = new (0, $9014d97cd777be10$export$fd1bfc71f64c538c)();
        this.requiredEvents = [
            "UIReady",
            "RendererReady",
            "InputReady",
            "NetcodeReady",
            "CollisionReady",
            "AudioReady",
            "LevelLoaded",
            "IdentityReady"
        ];
        this.receivedEvents = [];
        this.initialLoadComplete = false;
        this.numberOfModelsToLoad = (0, $cd87776b9916381d$export$b3ee8d2e5964aa98)() + 3 // HACK: 3 includes: skybox geo, player geo, and geo for their invisible server-side entity I... think?
        ;
        this.modelsLoaded = 0;
        this.modelLoader = new (0, $50ee5a35738b214d$export$aa93f11e7884f0f4)();
    }
}













var $380ce54d356ccb1e$exports = {};
"use strict";
Object.defineProperty($380ce54d356ccb1e$exports, "__esModule", {
    value: true
});
$380ce54d356ccb1e$exports.MemoryStorage = $380ce54d356ccb1e$exports.CookieStorage = $380ce54d356ccb1e$exports.isSupported = $380ce54d356ccb1e$exports.storage = undefined;
var $b32d305b48e7f447$exports = {};
"use strict";
Object.defineProperty($b32d305b48e7f447$exports, "__esModule", {
    value: true
});
$b32d305b48e7f447$exports.default = $b32d305b48e7f447$var$isSupported;
var $f13bb1688ed72748$exports = {};
"use strict";
Object.defineProperty($f13bb1688ed72748$exports, "__esModule", {
    value: true
});
var $f13bb1688ed72748$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
$f13bb1688ed72748$exports.hasCookies = $f13bb1688ed72748$var$hasCookies;
var $ba8d3d72d1582be7$exports = {};

$parcel$export($ba8d3d72d1582be7$exports, "parse", function () { return $ba8d3d72d1582be7$export$98e6a39c04603d36; }, function (v) { return $ba8d3d72d1582be7$export$98e6a39c04603d36 = v; });
$parcel$export($ba8d3d72d1582be7$exports, "serialize", function () { return $ba8d3d72d1582be7$export$dfdc1655ccc5b9cb; }, function (v) { return $ba8d3d72d1582be7$export$dfdc1655ccc5b9cb = v; });
/*!
 * cookie
 * Copyright(c) 2012-2014 Roman Shtylman
 * Copyright(c) 2015 Douglas Christopher Wilson
 * MIT Licensed
 */ /**
 * Module exports.
 * @public
 */ var $ba8d3d72d1582be7$export$98e6a39c04603d36;
var $ba8d3d72d1582be7$export$dfdc1655ccc5b9cb;
"use strict";
$ba8d3d72d1582be7$export$98e6a39c04603d36 = $ba8d3d72d1582be7$var$parse;
$ba8d3d72d1582be7$export$dfdc1655ccc5b9cb = $ba8d3d72d1582be7$var$serialize;
/**
 * Module variables.
 * @private
 */ var $ba8d3d72d1582be7$var$decode = decodeURIComponent;
var $ba8d3d72d1582be7$var$encode = encodeURIComponent;
var $ba8d3d72d1582be7$var$pairSplitRegExp = /; */;
/**
 * RegExp to match field-content in RFC 7230 sec 3.2
 *
 * field-content = field-vchar [ 1*( SP / HTAB ) field-vchar ]
 * field-vchar   = VCHAR / obs-text
 * obs-text      = %x80-FF
 */ var $ba8d3d72d1582be7$var$fieldContentRegExp = /^[\u0009\u0020-\u007e\u0080-\u00ff]+$/;
/**
 * Parse a cookie header.
 *
 * Parse the given cookie header string into an object
 * The object has the various cookies as keys(names) => values
 *
 * @param {string} str
 * @param {object} [options]
 * @return {object}
 * @public
 */ function $ba8d3d72d1582be7$var$parse(str, options) {
    if (typeof str !== "string") throw new TypeError("argument str must be a string");
    var obj = {};
    var opt = options || {};
    var pairs = str.split($ba8d3d72d1582be7$var$pairSplitRegExp);
    var dec = opt.decode || $ba8d3d72d1582be7$var$decode;
    for(var i = 0; i < pairs.length; i++){
        var pair = pairs[i];
        var eq_idx = pair.indexOf("=");
        // skip things that don't look like key=value
        if (eq_idx < 0) continue;
        var key = pair.substr(0, eq_idx).trim();
        var val = pair.substr(++eq_idx, pair.length).trim();
        // quoted values
        if ('"' == val[0]) val = val.slice(1, -1);
        // only assign once
        if (undefined == obj[key]) obj[key] = $ba8d3d72d1582be7$var$tryDecode(val, dec);
    }
    return obj;
}
/**
 * Serialize data into a cookie header.
 *
 * Serialize the a name value pair into a cookie string suitable for
 * http headers. An optional options object specified cookie parameters.
 *
 * serialize('foo', 'bar', { httpOnly: true })
 *   => "foo=bar; httpOnly"
 *
 * @param {string} name
 * @param {string} val
 * @param {object} [options]
 * @return {string}
 * @public
 */ function $ba8d3d72d1582be7$var$serialize(name, val, options) {
    var opt = options || {};
    var enc = opt.encode || $ba8d3d72d1582be7$var$encode;
    if (typeof enc !== "function") throw new TypeError("option encode is invalid");
    if (!$ba8d3d72d1582be7$var$fieldContentRegExp.test(name)) throw new TypeError("argument name is invalid");
    var value = enc(val);
    if (value && !$ba8d3d72d1582be7$var$fieldContentRegExp.test(value)) throw new TypeError("argument val is invalid");
    var str = name + "=" + value;
    if (null != opt.maxAge) {
        var maxAge = opt.maxAge - 0;
        if (isNaN(maxAge)) throw new Error("maxAge should be a Number");
        str += "; Max-Age=" + Math.floor(maxAge);
    }
    if (opt.domain) {
        if (!$ba8d3d72d1582be7$var$fieldContentRegExp.test(opt.domain)) throw new TypeError("option domain is invalid");
        str += "; Domain=" + opt.domain;
    }
    if (opt.path) {
        if (!$ba8d3d72d1582be7$var$fieldContentRegExp.test(opt.path)) throw new TypeError("option path is invalid");
        str += "; Path=" + opt.path;
    }
    if (opt.expires) {
        if (typeof opt.expires.toUTCString !== "function") throw new TypeError("option expires is invalid");
        str += "; Expires=" + opt.expires.toUTCString();
    }
    if (opt.httpOnly) str += "; HttpOnly";
    if (opt.secure) str += "; Secure";
    if (opt.sameSite) {
        var sameSite = typeof opt.sameSite === "string" ? opt.sameSite.toLowerCase() : opt.sameSite;
        switch(sameSite){
            case true:
                str += "; SameSite=Strict";
                break;
            case "lax":
                str += "; SameSite=Lax";
                break;
            case "strict":
                str += "; SameSite=Strict";
                break;
            default:
                throw new TypeError("option sameSite is invalid");
        }
    }
    return str;
}
/**
 * Try decoding a string using a decoding function.
 *
 * @param {string} str
 * @param {function} decode
 * @private
 */ function $ba8d3d72d1582be7$var$tryDecode(str, decode) {
    try {
        return decode(str);
    } catch (e) {
        return str;
    }
}


var $f13bb1688ed72748$var$_cookie2 = $f13bb1688ed72748$var$_interopRequireDefault($ba8d3d72d1582be7$exports);
function $f13bb1688ed72748$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $f13bb1688ed72748$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
var $f13bb1688ed72748$var$prefix = "lS_";
var $f13bb1688ed72748$var$CookieStorage = function() {
    function CookieStorage() {
        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        $f13bb1688ed72748$var$_classCallCheck(this, CookieStorage);
        this.cookieOptions = Object.assign({
            path: "/"
        }, options);
        $f13bb1688ed72748$var$prefix = options.prefix === undefined ? $f13bb1688ed72748$var$prefix : options.prefix;
    }
    $f13bb1688ed72748$var$_createClass(CookieStorage, [
        {
            key: "getItem",
            value: function getItem(key) {
                var cookies = $f13bb1688ed72748$var$_cookie2.default.parse(document.cookie);
                if (!cookies || !cookies.hasOwnProperty($f13bb1688ed72748$var$prefix + key)) return null;
                return cookies[$f13bb1688ed72748$var$prefix + key];
            }
        },
        {
            key: "setItem",
            value: function setItem(key, value) {
                document.cookie = $f13bb1688ed72748$var$_cookie2.default.serialize($f13bb1688ed72748$var$prefix + key, value, this.cookieOptions);
                return value;
            }
        },
        {
            key: "removeItem",
            value: function removeItem(key) {
                var options = Object.assign({}, this.cookieOptions, {
                    maxAge: -1
                });
                document.cookie = $f13bb1688ed72748$var$_cookie2.default.serialize($f13bb1688ed72748$var$prefix + key, "", options);
                return null;
            }
        },
        {
            key: "clear",
            value: function clear() {
                var cookies = $f13bb1688ed72748$var$_cookie2.default.parse(document.cookie);
                for(var key in cookies)if (key.indexOf($f13bb1688ed72748$var$prefix) === 0) this.removeItem(key.substr($f13bb1688ed72748$var$prefix.length));
                return null;
            }
        }
    ]);
    return CookieStorage;
}();
$f13bb1688ed72748$exports.default = $f13bb1688ed72748$var$CookieStorage;
function $f13bb1688ed72748$var$hasCookies() {
    var storage = new $f13bb1688ed72748$var$CookieStorage();
    try {
        var TEST_KEY = "__test";
        storage.setItem(TEST_KEY, "1");
        var value = storage.getItem(TEST_KEY);
        storage.removeItem(TEST_KEY);
        return value === "1";
    } catch (e) {
        return false;
    }
}


var $b32d305b48e7f447$var$TEST_KEY = "__test";
function $b32d305b48e7f447$var$hasStorage(name) {
    try {
        var storage = window[name];
        storage.setItem($b32d305b48e7f447$var$TEST_KEY, "1");
        storage.removeItem($b32d305b48e7f447$var$TEST_KEY);
        return true;
    } catch (e) {
        return false;
    }
}
function $b32d305b48e7f447$var$isSupported() {
    var name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "localStorage";
    var storage = String(name).replace(/storage$/i, "").toLowerCase();
    if (storage === "local") return $b32d305b48e7f447$var$hasStorage("localStorage");
    if (storage === "session") return $b32d305b48e7f447$var$hasStorage("sessionStorage");
    if (storage === "cookie") return (0, $f13bb1688ed72748$exports.hasCookies)();
    if (storage === "memory") return true;
    throw new Error("Storage method `" + name + "` is not available.\n    Please use one of the following: localStorage, sessionStorage, cookieStorage, memoryStorage.");
}


var $380ce54d356ccb1e$var$_isSupported2 = $380ce54d356ccb1e$var$_interopRequireDefault($b32d305b48e7f447$exports);

var $380ce54d356ccb1e$var$_CookieStorage2 = $380ce54d356ccb1e$var$_interopRequireDefault($f13bb1688ed72748$exports);
var $eaf9081a0d335e65$exports = {};
"use strict";
Object.defineProperty($eaf9081a0d335e65$exports, "__esModule", {
    value: true
});
var $eaf9081a0d335e65$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
function $eaf9081a0d335e65$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
var $eaf9081a0d335e65$var$MemoryStorage = function() {
    function MemoryStorage() {
        $eaf9081a0d335e65$var$_classCallCheck(this, MemoryStorage);
        this._data = {};
    }
    $eaf9081a0d335e65$var$_createClass(MemoryStorage, [
        {
            key: "getItem",
            value: function getItem(key) {
                return this._data.hasOwnProperty(key) ? this._data[key] : null;
            }
        },
        {
            key: "setItem",
            value: function setItem(key, value) {
                return this._data[key] = String(value);
            }
        },
        {
            key: "removeItem",
            value: function removeItem(key) {
                return delete this._data[key];
            }
        },
        {
            key: "clear",
            value: function clear() {
                return this._data = {};
            }
        }
    ]);
    return MemoryStorage;
}();
$eaf9081a0d335e65$exports.default = $eaf9081a0d335e65$var$MemoryStorage;


var $380ce54d356ccb1e$var$_MemoryStorage2 = $380ce54d356ccb1e$var$_interopRequireDefault($eaf9081a0d335e65$exports);
function $380ce54d356ccb1e$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $380ce54d356ccb1e$var$storage = null;
if ((0, $380ce54d356ccb1e$var$_isSupported2.default)("localStorage")) // use localStorage
$380ce54d356ccb1e$exports.storage = $380ce54d356ccb1e$var$storage = window.localStorage;
else if ((0, $380ce54d356ccb1e$var$_isSupported2.default)("sessionStorage")) // use sessionStorage
$380ce54d356ccb1e$exports.storage = $380ce54d356ccb1e$var$storage = window.sessionStorage;
else if ((0, $380ce54d356ccb1e$var$_isSupported2.default)("cookieStorage")) // use cookies
$380ce54d356ccb1e$exports.storage = $380ce54d356ccb1e$var$storage = new $380ce54d356ccb1e$var$_CookieStorage2.default();
else // use memory
$380ce54d356ccb1e$exports.storage = $380ce54d356ccb1e$var$storage = new $380ce54d356ccb1e$var$_MemoryStorage2.default();
$380ce54d356ccb1e$exports.default = $380ce54d356ccb1e$var$storage;
$380ce54d356ccb1e$exports.storage = $380ce54d356ccb1e$var$storage;
$380ce54d356ccb1e$exports.isSupported = $380ce54d356ccb1e$var$_isSupported2.default;
$380ce54d356ccb1e$exports.CookieStorage = $380ce54d356ccb1e$var$_CookieStorage2.default;
$380ce54d356ccb1e$exports.MemoryStorage = $380ce54d356ccb1e$var$_MemoryStorage2.default;


const $f6601dd412e992e3$var$MAJOR_GAME_VERSION = (0, $b80b6e4c153785d9$export$29cd7b75162a9425).Game.MAJOR_GAME_VERSION;
const $f6601dd412e992e3$export$f34f1260dfb72f42 = (version)=>{
    return `uptogether::${version}::`;
};
var $f6601dd412e992e3$export$c02c1f4c11d08446;
(function(LSKeys) {
    LSKeys["AuthToken"] = "authToken";
    LSKeys["AnonymousUserId"] = "anonymousUserId";
    LSKeys["MusicMuted"] = "musicMuted";
    LSKeys["SFXMuted"] = "sfxMuted";
    LSKeys["SkinUnlocks"] = "skinUnlocks";
    LSKeys["TrailUnlocks"] = "trailUnlocks";
})($f6601dd412e992e3$export$c02c1f4c11d08446 || ($f6601dd412e992e3$export$c02c1f4c11d08446 = {}));
const $f6601dd412e992e3$export$3727fff6c4775dc0 = (key)=>{
    try {
        return (0, (/*@__PURE__*/$parcel$interopDefault($380ce54d356ccb1e$exports))).getItem(`${$f6601dd412e992e3$export$f34f1260dfb72f42($f6601dd412e992e3$var$MAJOR_GAME_VERSION)}${key}`) !== null;
    } catch (e) {
        console.error("Caught LS error:", e);
    }
};
const $f6601dd412e992e3$export$1b8cd2d0ef9a8e5d = (key, value)=>{
    try {
        (0, (/*@__PURE__*/$parcel$interopDefault($380ce54d356ccb1e$exports))).setItem(`${$f6601dd412e992e3$export$f34f1260dfb72f42($f6601dd412e992e3$var$MAJOR_GAME_VERSION)}${key}`, value);
        return value;
    } catch (e) {
        console.error("Caught LS error:", e);
    }
};
const $f6601dd412e992e3$export$e68c847c0bceb7d5 = (key)=>{
    try {
        const retrievedFromStore = (0, (/*@__PURE__*/$parcel$interopDefault($380ce54d356ccb1e$exports))).getItem(`${$f6601dd412e992e3$export$f34f1260dfb72f42($f6601dd412e992e3$var$MAJOR_GAME_VERSION)}${key}`);
        return retrievedFromStore;
    } catch (e) {
        console.error("Caught LS error:", e);
        return null;
    }
};
const $f6601dd412e992e3$export$50b227d68205c4cc = (key, version)=>{
    try {
        const retrievedFromStore = (0, (/*@__PURE__*/$parcel$interopDefault($380ce54d356ccb1e$exports))).getItem(`${$f6601dd412e992e3$export$f34f1260dfb72f42(version.toString())}${key}`);
        return retrievedFromStore;
    } catch (e) {
        console.error("Caught LS error:", e);
        return null;
    }
};
const $f6601dd412e992e3$export$f39d14204f621823 = (key, version)=>{
    try {
        return (0, (/*@__PURE__*/$parcel$interopDefault($380ce54d356ccb1e$exports))).removeItem(`${$f6601dd412e992e3$export$f34f1260dfb72f42(version.toString())}${key}`);
    } catch (e) {
        console.error("Caught LS error:", e);
    }
};
const $f6601dd412e992e3$export$34a3032bf337a702 = (key)=>{
    try {
        return (0, (/*@__PURE__*/$parcel$interopDefault($380ce54d356ccb1e$exports))).removeItem(`${$f6601dd412e992e3$export$f34f1260dfb72f42($f6601dd412e992e3$var$MAJOR_GAME_VERSION)}${key}`);
    } catch (e) {
        console.error("Caught LS error:", e);
    }
};



var $3c561a4876de7de6$export$b714373eb9ab036b;
(function(Screens) {
    Screens[Screens["None"] = 0] = "None";
    Screens[Screens["CharacterSelect"] = 1] = "CharacterSelect";
    Screens[Screens["ChangeUsername"] = 2] = "ChangeUsername";
    Screens[Screens["RunComplete"] = 3] = "RunComplete";
    Screens[Screens["EmojiSelector"] = 4] = "EmojiSelector";
    Screens[Screens["TrailSelect"] = 5] = "TrailSelect";
    Screens[Screens["RestartRunWarning"] = 6] = "RestartRunWarning";
    Screens[Screens["ViewSettings"] = 7] = "ViewSettings";
})($3c561a4876de7de6$export$b714373eb9ab036b || ($3c561a4876de7de6$export$b714373eb9ab036b = {}));
// Function to generate HTML options
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $3c561a4876de7de6$var$generateEnumOptions(enumType) {
    let optionsHTML = "";
    for(const key in enumType)if (typeof enumType[key] === "number") optionsHTML += `<option value="${enumType[key]}">${$3c561a4876de7de6$var$addSpacesBeforeCapitalLetters(key)}</option>`;
    return optionsHTML;
}
function $3c561a4876de7de6$var$addSpacesBeforeCapitalLetters(inputString) {
    // Use a regular expression to find capital letters and insert a space before them
    const stringWithSpaces = inputString.replace(/([A-Z])/g, " $1");
    return stringWithSpaces;
}
class $3c561a4876de7de6$export$618b19ebc933e619 extends (0, $fc7b18e354612676$export$5d53140180d567a1) {
    getSelectedTrail() {
        return this.selectedTrail;
    }
    setSelectedTrail(trail) {
        this.selectedTrail = trail;
    }
    ShowErrorScreen(errorMsg, shouldRedify = false) {
        this.loadingSplashScreenDomElement.setAttribute("style", "display: flex !important; opacity: 1 !important;");
        this.gameLogoElement.setAttribute("style", "display: none !important; opacity: 0 !important;");
        this.loadingParent.setAttribute("style", "display: none !important; opacity: 0 !important;");
        this.errorMsgDomElement.innerText = errorMsg;
        if (shouldRedify) this.errorMsgDomElement.classList.add("error");
        this.errorScreenDomElement.setAttribute("style", "display: flex !important;");
        this.gameHudDomElement.setAttribute("style", "display: none !important; opacity: 0 !important;");
    }
    Initialize() {
        document.addEventListener("pointerlockchange", this._onPointerLockStatusChanged.bind(this), false);
        document.addEventListener("mozpointerlockchange", this._onPointerLockStatusChanged.bind(this), false);
        document.addEventListener("webkitpointerlockchange", this._onPointerLockStatusChanged.bind(this), false);
        this.playButtonDomElement.innerHTML = (0, $34a8d0dc3ef4dba1$export$625550452a3fa3ec)("button__play");
        this.restartRunTitleDomElement.innerHTML = (0, $34a8d0dc3ef4dba1$export$625550452a3fa3ec)("restart__title");
        this.restartRunWarningTextDomElement.innerHTML = (0, $34a8d0dc3ef4dba1$export$625550452a3fa3ec)("restart__are_you_sure");
        this.restartEntireRunBtnDomElement.innerHTML = (0, $34a8d0dc3ef4dba1$export$625550452a3fa3ec)("restart__confirm");
        // Character Skin state init
        let foundUnlockedSkins = undefined;
        if ((0, $f6601dd412e992e3$export$3727fff6c4775dc0)((0, $f6601dd412e992e3$export$c02c1f4c11d08446).SkinUnlocks)) {
            const savedSkinUnlocks = (0, $f6601dd412e992e3$export$e68c847c0bceb7d5)((0, $f6601dd412e992e3$export$c02c1f4c11d08446).SkinUnlocks);
            try {
                const parsedUnlocks = JSON.parse(savedSkinUnlocks);
                // console.info("Got saved skin unlocks:", parsedUnlocks);
                foundUnlockedSkins = parsedUnlocks;
            } catch (e) {
                console.error("Failed to parse saved skin unlocks:", savedSkinUnlocks);
                (0, $f6601dd412e992e3$export$1b8cd2d0ef9a8e5d)((0, $f6601dd412e992e3$export$c02c1f4c11d08446).SkinUnlocks, JSON.stringify([]));
            }
        } else {
            const defaultUnlocks = [];
            // console.info("No saved skin unlocks found, using default:", defaultUnlocks);
            (0, $f6601dd412e992e3$export$1b8cd2d0ef9a8e5d)((0, $f6601dd412e992e3$export$c02c1f4c11d08446).SkinUnlocks, JSON.stringify([]));
            foundUnlockedSkins = defaultUnlocks;
        }
        // console.info("Found unlocks after parsing!!", foundUnlockedSkins);
        this.unlockedCharacterSkins = foundUnlockedSkins;
        // Trail state init
        let foundTrailUnlocks = undefined;
        if ((0, $f6601dd412e992e3$export$3727fff6c4775dc0)((0, $f6601dd412e992e3$export$c02c1f4c11d08446).TrailUnlocks)) {
            const savedTrailUnlocks = (0, $f6601dd412e992e3$export$e68c847c0bceb7d5)((0, $f6601dd412e992e3$export$c02c1f4c11d08446).TrailUnlocks);
            try {
                const parsedUnlocks = JSON.parse(savedTrailUnlocks);
                // console.info("Got saved trail unlocks:", parsedUnlocks);
                foundTrailUnlocks = parsedUnlocks;
            } catch (e) {
                console.error("Failed to parse saved trail unlocks:", savedTrailUnlocks);
                (0, $f6601dd412e992e3$export$1b8cd2d0ef9a8e5d)((0, $f6601dd412e992e3$export$c02c1f4c11d08446).TrailUnlocks, JSON.stringify([]));
            }
        } else {
            const defaultUnlocks = [];
            // console.info("No saved trail unlocks found, using default:", defaultUnlocks);
            (0, $f6601dd412e992e3$export$1b8cd2d0ef9a8e5d)((0, $f6601dd412e992e3$export$c02c1f4c11d08446).TrailUnlocks, JSON.stringify([]));
            foundTrailUnlocks = defaultUnlocks;
        }
        // console.info("Found trail unlocks after parsing!!", foundTrailUnlocks);
        this.unlockedTrails = foundTrailUnlocks;
        this.SetMusicMuteButtonState(Game.Audio.MusicMuted);
        this.SetSFXMuteButtonState(Game.Audio.SFXMuted);
        this._updateCharacterCarouselState();
        this._updateTrailCarouselState();
        this.alertTextDomElement.addEventListener("animationend", this._onAlertTextEntryAnimationComplete.bind(this));
        this.moveCharacterCarouselLeftBtnDomElement.addEventListener("click", ()=>{
            this.MoveCharacterSelectCarouselLeft();
        });
        this.moveCharacterCarouselRightBtnDomElement.addEventListener("click", ()=>{
            this.MoveCharacterSelectCarouselRight();
        });
        this.unlockCharacterBtnDomElement.addEventListener("click", this._selectCharacter.bind(this));
        this.selectCharacterBtnDomElement.addEventListener("click", this._selectCharacter.bind(this));
        this.characterCarouselLeftImgDomElement.addEventListener("click", ()=>{
            this.MoveCharacterSelectCarouselLeft();
        });
        this.characterCarouselRightImgDomElement.addEventListener("click", ()=>{
            this.MoveCharacterSelectCarouselRight();
        });
        this.moveTrailCarouselLeftBtnDomElement.addEventListener("click", ()=>{
            this.MoveTrailSelectCarouselLeft();
        });
        this.moveTrailCarouselRightBtnDomElement.addEventListener("click", ()=>{
            this.MoveTrailSelectCarouselRight();
        });
        this.selectTrailBtnDomElement.addEventListener("click", this._selectTrail.bind(this));
        this.unlockTrailBtnDomElement.addEventListener("click", this._selectTrail.bind(this));
        this.removeTrailBtnDomElement.addEventListener("click", this._removeTrail.bind(this));
        this.trailCarouselLeftImgDomElement.addEventListener("click", ()=>{
            this.MoveTrailSelectCarouselLeft();
        });
        this.trailCarouselRightImgDomElement.addEventListener("click", ()=>{
            this.MoveTrailSelectCarouselRight();
        });
        // Generate the options and append them to the select element
        this.usernameCountryOptions.innerHTML = $3c561a4876de7de6$var$generateEnumOptions((0, $c60317e2dae19a8a$export$b33f41d0b11df887));
        this.usernamePrefixOptions.innerHTML = $3c561a4876de7de6$var$generateEnumOptions((0, $c60317e2dae19a8a$export$9c1d6cc0bf22137));
        this.usernameSuffixOptions.innerHTML = $3c561a4876de7de6$var$generateEnumOptions((0, $c60317e2dae19a8a$export$6ea3032238c5bf02));
        this.usernameCountryOptions.addEventListener("change", ()=>{
            const selectedValue = this.usernameCountryOptions.value;
            // console.log(`Selected value: ${selectedValue}`);
            const imgSrcForCountry = `ui/flags/${(0, $88639450953f4f02$export$3d7cd691481bade)(parseInt(selectedValue))}.png`;
            this.countryImages.forEach((countryImage)=>{
                countryImage.src = imgSrcForCountry;
            });
        });
        this.fsButtonDomElement.addEventListener("click", ()=>{
            Game.Input.ToggleFullScreen();
        });
        this.changeUsernameBtnDomElement.addEventListener("click", ()=>{
            Game.EmitEvent("SDK::PopRewardedAd", ()=>{
                // console.warn("callback for ad play success as defined in ClientUI (username change case)!");
                const country = parseInt(this.usernameCountryOptions.value);
                const prefix = parseInt(this.usernamePrefixOptions.value);
                const suffix = parseInt(this.usernameSuffixOptions.value);
                const changeUsernameCommand = {
                    ntype: (0, $7c910687071ab881$export$f7cab339749a57d7).ChangeUsernameCommand,
                    country: country,
                    prefix: prefix,
                    suffix: suffix
                };
                Game.UI.HideSpecificScreen($3c561a4876de7de6$export$b714373eb9ab036b.ChangeUsername);
                Game.Netcode.SendCommand(changeUsernameCommand);
            });
        });
        this.openEmojiScreenDomElement.addEventListener("click", ()=>{
            this.ShowScreen($3c561a4876de7de6$export$b714373eb9ab036b.EmojiSelector);
        });
        this.openRestartWarningScreenDomElement.addEventListener("click", ()=>{
            this.ShowScreen($3c561a4876de7de6$export$b714373eb9ab036b.RestartRunWarning);
        });
        this.closeScreenButtonsDomElements.forEach((closeScreenButton)=>{
            closeScreenButton.addEventListener("click", ()=>{
                this.HideAllScreens();
            });
        });
        this.emojiButtonsDomElements.forEach((emojiButton)=>{
            emojiButton.addEventListener("click", ()=>{
                const emoji = emojiButton.dataset.emoji;
                if (emoji === undefined) return;
                const emote = (0, $365485fe02257f54$export$a9e23c2ea6ae8778)(emoji);
                this.PopEmote(emote);
                this.HideAllScreens();
            });
        });
        this.goAgainButtonDomElement.addEventListener("click", ()=>{
            setTimeout(()=>{
                // Reload the page
                window.location.reload();
            }, 300);
        });
        this.playButtonDomElement.addEventListener("click", ()=>{
            this._lastClickedPlayButtonTimestamp = Date.now();
            if (!globalThis.IsMobile) try {
                Game.Renderer.Canvas.requestPointerLock();
            } catch (e) {
                console.error(`Caught pointer lock error, ignoring it: code: ${e.code} - message: ${e.message}`);
            }
            if (Game.Predictor.GetPredictedEntity() !== undefined) Game.Predictor.GetPredictedEntity().ShouldFireGameplayStartEventOnNextMovement = true;
        // Game.EmitEvent("SDK::GameplayStart");
        });
        this.muteMusicBtnDomElement.addEventListener("click", ()=>{
            Game.Audio.ToggleMusicMute();
            this.SetMusicMuteButtonState(Game.Audio.MusicMuted);
        });
        this.muteSfxBtnDomElement.addEventListener("click", ()=>{
            Game.Audio.ToggleSFXMute();
            this.SetSFXMuteButtonState(Game.Audio.SFXMuted);
        });
        this.settingsBtnDomElement.addEventListener("click", ()=>{
            this.ShowScreen($3c561a4876de7de6$export$b714373eb9ab036b.ViewSettings);
        // console.log("Settings btn pressed!");
        });
        this.restartCheckpointBtnDomElement.addEventListener("click", ()=>{
            // console.log("Restart cp btn pressed!");
            this.restartCheckpointButtonPressedThisFrame = true;
        });
        // this.showRestartWarningBtnDomEleement!.addEventListener("click", () => {
        this.restartEntireRunBtnDomElement.addEventListener("click", ()=>{
            // console.log("@@@");
            // console.log("Restart run btn pressed!");
            this.restartEntireRunButtonPressedThisFrame = true;
            this.HideAllScreens();
        });
        Game.ListenForEvent("UI::FadeOutLoadingScreen", this._fadeOutLoadingScreen.bind(this));
        Game.ListenForEvent("Loading::ProgressUpdated", this._updateLoadingProgressPercentage.bind(this));
        Game.ListenForEvent("Loading::AlmostComplete", this._onLoadingAlmostComplete.bind(this));
        Game.EmitEvent("LoadEvent", {
            eventName: "UIReady"
        });
        // Hide irrelevant elements for mobile
        if (globalThis.IsMobile) {
            this.playButtonDomElement.style.display = "none";
            this.keyboardHotkeyIndicators.forEach((keyboardHotkeyIndicator)=>{
                keyboardHotkeyIndicator.style.display = "none";
            });
            this.fsButtonDomElement.style.display = "none";
        }
        if (globalThis.HostPortal === (0, $9460eef1b2ed143f$export$f1f74d609516c940).Poki) this.fsButtonDomElement.style.display = "none";
        if (globalThis.HostPortal === (0, $9460eef1b2ed143f$export$f1f74d609516c940).DIRECT) {
            // Create a new script tag and append to the body
            const scriptTag = document.createElement("script");
            scriptTag.type = "text/javascript";
            scriptTag.src = "https://app.termly.io/resource-blocker/1a630229-9f24-4599-971b-f89592149eaf?autoBlock=on";
            document.body.appendChild(scriptTag);
            // Create the cookie policy link and append it to the .view-settings-inner element
            const cookiePolicyLink = document.createElement("p");
            cookiePolicyLink.style.display = "block !important";
            cookiePolicyLink.classList.add("privacy-policy");
            // eslint-disable-next-line quotes
            cookiePolicyLink.innerHTML = `<a href="https://app.termly.io/document/cookie-policy/dd913ca4-a877-4205-a1bf-74176b817d30" target="_blank">Cookie Policy</a>`;
            document.querySelector(".view-settings-inner").appendChild(cookiePolicyLink);
        }
    }
    PopEmote(emote) {
        const emoteCommand = {
            ntype: (0, $7c910687071ab881$export$f7cab339749a57d7).EmoteCommand,
            emote: emote,
            animation: (0, $365485fe02257f54$export$5c86ea9d76d14a93)()
        };
        Game.Netcode.SendCommand(emoteCommand);
    }
    ShowRunRestartHUDButtons() {
        this.restartCheckpointBtnDomElement.style.display = "block";
        // this.rHotKeyIndicatorDomElement!.style.display = "block";
        this.openRestartWarningScreenDomElement.style.display = "block";
    // this.xHotKeyIndicatorDomElement!.style.display = "block";
    }
    HideRunRestartHUDButtons() {
        this.restartCheckpointBtnDomElement.style.display = "none";
        // this.rHotKeyIndicatorDomElement!.style.display = "none";
        this.openRestartWarningScreenDomElement.style.display = "none";
    // this.xHotKeyIndicatorDomElement!.style.display = "none";
    }
    MoveTrailSelectCarouselLeft() {
        // console.log("Sending carousel left");
        const activeTrailIndex = this.activeCarouselTrailIndex;
        const activeTrail = this.trailSelectCarouselOptions[activeTrailIndex];
        const leftTrail = this._getLeftCarouselTrailFromCenterTrail(activeTrail);
        // console.log("Moving trail select carousel left");
        // console.log({ activeTrailIndex, activeTrail: ParticleEffects[activeTrail], leftTrail: ParticleEffects[leftTrail] });
        this.activeCarouselTrailIndex = this.trailSelectCarouselOptions.indexOf(leftTrail);
        this._updateTrailCarouselState();
    }
    MoveTrailSelectCarouselRight() {
        // console.log("Sending carousel right");
        const activeTrailIndex = this.activeCarouselTrailIndex;
        const activeTrail = this.trailSelectCarouselOptions[activeTrailIndex];
        const rightTrail = this._getRightCarouselTrailFromCenterTrail(activeTrail);
        // console.log("Moving trail select carousel right");
        // console.log({ activeTrailIndex, activeTrail: ParticleEffects[activeTrail], rightTrail: ParticleEffects[rightTrail] });
        this.activeCarouselTrailIndex = this.trailSelectCarouselOptions.indexOf(rightTrail);
        this._updateTrailCarouselState();
    }
    MoveCharacterSelectCarouselLeft() {
        // console.log("Sending carousel left");
        const activeCharacterIndex = this.activeCarouselCharacterIndex;
        const activeCharacter = this.characterSelectCarouselCharacters[activeCharacterIndex];
        const leftCharacter = this._getLeftCarouselCharacterFromCenterCharacter(activeCharacter);
        this.activeCarouselCharacterIndex = this.characterSelectCarouselCharacters.indexOf(leftCharacter);
        this._updateCharacterCarouselState();
    }
    MoveCharacterSelectCarouselRight() {
        // console.log("Sending carousel right");
        const activeCharacterIndex = this.activeCarouselCharacterIndex;
        const activeCharacter = this.characterSelectCarouselCharacters[activeCharacterIndex];
        const rightCharacter = this._getRightCarouselCharacterFromCenterCharacter(activeCharacter);
        this.activeCarouselCharacterIndex = this.characterSelectCarouselCharacters.indexOf(rightCharacter);
        this._updateCharacterCarouselState();
    }
    UpdateFinalRunTime(rcMins, rcSecs, rcMs) {
        this.rcMinsDomElement.innerText = rcMins;
        this.rcSecsDomElement.innerText = rcSecs;
        this.rcMsDomElement.innerText = rcMs;
        this.runDurationDomElement.classList.add("complete");
    }
    _selectCharacter() {
        const chosenCharacter = this.characterSelectCarouselCharacters[this.activeCarouselCharacterIndex];
        // console.log("Trying to unlock:", chosenCharacter);
        if (this.unlockedCharacterSkins.includes(chosenCharacter)) {
            // console.log("Character is already unlocked! changing");
            Game.Netcode.ChangeSkin(chosenCharacter);
            this._updateCharacterCarouselState();
        } else Game.EmitEvent("SDK::PopRewardedAd", ()=>{
            // console.warn("callback for ad play success as defined in ClientUI (character select case)!");
            Game.Netcode.ChangeSkin(chosenCharacter);
            try {
                const currentSavedUnlocks = (0, $f6601dd412e992e3$export$e68c847c0bceb7d5)((0, $f6601dd412e992e3$export$c02c1f4c11d08446).SkinUnlocks);
                const parsedUnlocks = JSON.parse(currentSavedUnlocks);
                parsedUnlocks.push(chosenCharacter);
                this.unlockedCharacterSkins = parsedUnlocks;
                (0, $f6601dd412e992e3$export$1b8cd2d0ef9a8e5d)((0, $f6601dd412e992e3$export$c02c1f4c11d08446).SkinUnlocks, JSON.stringify(parsedUnlocks));
                this._updateCharacterCarouselState();
                Game.UI.HideSpecificScreen($3c561a4876de7de6$export$b714373eb9ab036b.CharacterSelect);
            } catch (e) {
                console.error("Error updating local storage of saved unlocked skins!");
            }
        });
    }
    _removeTrail() {
        this.selectedTrail = (0, $60d2b0e7b97425c1$export$72fb2d77891daaa5).None;
        Game.Netcode.ChangeTrail((0, $60d2b0e7b97425c1$export$72fb2d77891daaa5).None);
        this._updateTrailCarouselState();
    }
    _selectTrail() {
        // console.log("SELECTING TRAIL::", ParticleEffects[this.trailSelectCarouselOptions[this.activeCarouselTrailIndex]]);
        const chosenTrail = this.trailSelectCarouselOptions[this.activeCarouselTrailIndex];
        this.selectedTrail = chosenTrail;
        // console.log("Trying to unlock trail:", chosenTrail);
        if (this.unlockedTrails.includes(chosenTrail)) {
            // console.log("Trail is already unlocked! changing");
            Game.Netcode.ChangeTrail(chosenTrail);
            this._updateTrailCarouselState();
        } else Game.EmitEvent("SDK::PopRewardedAd", ()=>{
            // console.warn("callback for ad play success as defined in ClientUI (trail select case)!");
            Game.Netcode.ChangeTrail(chosenTrail);
            try {
                const currentSavedUnlocks = (0, $f6601dd412e992e3$export$e68c847c0bceb7d5)((0, $f6601dd412e992e3$export$c02c1f4c11d08446).TrailUnlocks);
                const parsedUnlocks = JSON.parse(currentSavedUnlocks);
                parsedUnlocks.push(chosenTrail);
                this.unlockedTrails = parsedUnlocks;
                (0, $f6601dd412e992e3$export$1b8cd2d0ef9a8e5d)((0, $f6601dd412e992e3$export$c02c1f4c11d08446).TrailUnlocks, JSON.stringify(parsedUnlocks));
                this._updateTrailCarouselState();
                Game.UI.HideSpecificScreen($3c561a4876de7de6$export$b714373eb9ab036b.TrailSelect);
            } catch (e) {
                console.error("Error updating local storage of saved unlocked trails!");
            }
        });
    }
    _getLeftCarouselTrailFromCenterTrail(centerTrail) {
        // console.log(`Current center trail: num ${centerTrail} str ${ParticleEffects[centerTrail]} index ${this.trailSelectCarouselOptions.indexOf(centerTrail)}`);
        if (centerTrail === (0, $60d2b0e7b97425c1$export$72fb2d77891daaa5).Broccolis) /* TODO HOLIDAY UPDATE: Swap these two */ return (0, $60d2b0e7b97425c1$export$72fb2d77891daaa5).Stars;
        return centerTrail - 1;
    }
    _getRightCarouselTrailFromCenterTrail(centerTrail) {
        // console.log(`Current center trail: num ${centerTrail} str ${ParticleEffects[centerTrail]} index ${this.trailSelectCarouselOptions.indexOf(centerTrail)}`);
        /* TODO HOLIDAY UPDATE: Swap these two */ if (centerTrail === (0, $60d2b0e7b97425c1$export$72fb2d77891daaa5).Stars) //if (centerTrail === ParticleEffects.GingerbreadMan) {
        return (0, $60d2b0e7b97425c1$export$72fb2d77891daaa5).Broccolis;
        return centerTrail + 1;
    }
    _getLeftCarouselCharacterFromCenterCharacter(centerCharacter) {
        if (centerCharacter === (0, $018036e722cee03d$export$a3168656a78efa21).Broccoli) /* TODO HOLIDAY UPDATE: Swap these two */ return (0, $018036e722cee03d$export$a3168656a78efa21).Taco;
        return centerCharacter - 1;
    }
    _getRightCarouselCharacterFromCenterCharacter(centerCharacter) {
        /* TODO HOLIDAY UPDATE: Swap these two */ if (centerCharacter === (0, $018036e722cee03d$export$a3168656a78efa21).Taco) // if (centerCharacter === Characters.Candycane) {
        return (0, $018036e722cee03d$export$a3168656a78efa21).Broccoli;
        return centerCharacter + 1;
    }
    _updateCharacterCarouselState() {
        const centerCharacter = this.characterSelectCarouselCharacters[this.activeCarouselCharacterIndex];
        const leftCharacter = this._getLeftCarouselCharacterFromCenterCharacter(centerCharacter);
        const rightCharacter = this._getRightCarouselCharacterFromCenterCharacter(centerCharacter);
        const activeSkin = Game.GetActiveSkin();
        // console.log(activeSkin);
        // console.log(centerCharacter);
        if (activeSkin === centerCharacter) {
            // console.warn("Center character is the same as our character skin!");
            this.unlockCharacterBtnDomElement.style.display = "none";
            this.selectCharacterBtnDomElement.style.display = "none";
            this.characterActiveIndicatorDomElement.style.display = "flex";
        } else {
            this.characterActiveIndicatorDomElement.style.display = "none";
            if (this.unlockedCharacterSkins.includes(centerCharacter)) {
                this.selectCharacterBtnDomElement.style.display = "flex";
                this.unlockCharacterBtnDomElement.style.display = "none";
            } else {
                this.selectCharacterBtnDomElement.style.display = "none";
                this.unlockCharacterBtnDomElement.style.display = "flex";
            }
        }
        this.characterCarouselLeftImgDomElement.src = `ui/characters/${(0, $018036e722cee03d$export$a3168656a78efa21)[leftCharacter].toLowerCase()}_plate_unlit_001.png`;
        this.characterCarouselLeftNameDomElement.innerText = (0, $018036e722cee03d$export$a3168656a78efa21)[leftCharacter];
        this.characterCarouselCenterImgDomElement.src = `ui/characters/${(0, $018036e722cee03d$export$a3168656a78efa21)[centerCharacter].toLowerCase()}_plate_unlit_001.png`;
        this.characterCarouselCenterNameDomElement.innerText = (0, $018036e722cee03d$export$a3168656a78efa21)[centerCharacter];
        this.characterCarouselRightImgDomElement.src = `ui/characters/${(0, $018036e722cee03d$export$a3168656a78efa21)[rightCharacter].toLowerCase()}_plate_unlit_001.png`;
        this.characterCarouselRightNameDomElement.innerText = (0, $018036e722cee03d$export$a3168656a78efa21)[rightCharacter];
    }
    _updateTrailCarouselState() {
        const centerTrail = this.trailSelectCarouselOptions[this.activeCarouselTrailIndex];
        const leftTrail = this._getLeftCarouselTrailFromCenterTrail(centerTrail);
        const rightTrail = this._getRightCarouselTrailFromCenterTrail(centerTrail);
        // console.warn("Updating trail carousel state!!");
        // console.log("New left trail:", ParticleEffects[leftTrail]);
        // console.log("New center trail:", ParticleEffects[centerTrail]);
        // console.log("New right trail:", ParticleEffects[rightTrail]);
        // console.log("Currently selected trail index:", this.selectedTrail);
        // console.log("Currently selected trail string:", ParticleEffects[this.selectedTrail]);
        // console.log(`Left trail as png is: ${ParticleEffects[leftTrail]}.png`);
        // console.log(`Center trail as png is: ${ParticleEffects[centerTrail]}.png`);
        // console.log(`Right trail as png is: ${ParticleEffects[rightTrail]}.png`);
        if (this.selectedTrail !== (0, $60d2b0e7b97425c1$export$72fb2d77891daaa5).None) this.removeTrailBtnDomElement.style.display = "flex";
        else this.removeTrailBtnDomElement.style.display = "none";
        if (this.selectedTrail === centerTrail) {
            // console.warn("Center trail is the same as our trail skin!");
            this.selectTrailBtnDomElement.style.display = "none";
            this.unlockTrailBtnDomElement.style.display = "none";
            this.trailActiveIndicatorDomElement.style.display = "flex";
        } else {
            this.trailActiveIndicatorDomElement.style.display = "none";
            if (this.unlockedTrails.includes(centerTrail)) {
                //If this trail is the selected trail, display remove. Else display select
                this.unlockTrailBtnDomElement.style.display = "none";
                this.selectTrailBtnDomElement.style.display = "flex";
            } else {
                this.selectTrailBtnDomElement.style.display = "none";
                this.unlockTrailBtnDomElement.style.display = "flex";
            }
        }
        this.trailCarouselLeftImgDomElement.src = `ui/trail/${(0, $60d2b0e7b97425c1$export$72fb2d77891daaa5)[leftTrail]}.png`;
        //console.log("Left: ", `ui/trail/${ParticleEffects[leftTrail]}.png`);
        this.trailCarouselCenterImgDomElement.src = `ui/trail/${(0, $60d2b0e7b97425c1$export$72fb2d77891daaa5)[centerTrail]}.png`;
        //console.log("Centre: ", `ui/trail/${ParticleEffects[centerTrail]}.png`);
        this.trailCarouselRightImgDomElement.src = `ui/trail/${(0, $60d2b0e7b97425c1$export$72fb2d77891daaa5)[rightTrail]}.png`;
    //console.log("Right: ", `ui/trail/${ParticleEffects[rightTrail]}.png`);
    }
    UIScreenIsOpen() {
        // console.log(Screens[this.activeScreen]);
        const uiScreenIsAnythingButNone = this.activeScreen !== $3c561a4876de7de6$export$b714373eb9ab036b.None;
        const playButtonDomElementIsFlexOrBlock = this.playButtonDomElement.style.display === "flex" || this.playButtonDomElement.style.display === "block";
        const loadingSplashScreenDomElementIsFlexOrBlock = this.loadingSplashScreenDomElement.style.display === "flex" || this.loadingSplashScreenDomElement.style.display === "block";
        return uiScreenIsAnythingButNone || playButtonDomElementIsFlexOrBlock || loadingSplashScreenDomElementIsFlexOrBlock;
    }
    UpdateUIPopAccumulator(newAcc) {
        if (newAcc === 0 || newAcc >= 1) this.uiPopLoaderDomElement.style.display = "none";
        else {
            this.uiPopLoaderDomElement.style.display = "flex";
            this.uiPopLoaderProgressDomElement.style.width = `${newAcc * 100}%`;
        }
    }
    UpdateHeightValue(newHeight) {
        this.heightValueDomElement.innerText = newHeight.toString();
    }
    PressedRestartCheckpointButtonThisFrame() {
        return this.restartCheckpointButtonPressedThisFrame;
    }
    PressedRestartRunButtonThisFrame() {
        return this.restartEntireRunButtonPressedThisFrame;
    }
    ResetDeaths() {
        this.numberOfFalls = 0;
        this.fallsValueDomElement.innerText = this.numberOfFalls.toString();
    }
    IncrementDeaths() {
        this.numberOfFalls++;
        this.fallsValueDomElement.innerText = this.numberOfFalls.toString();
    }
    SetSFXMuteButtonState(SFXMuted) {
        if (SFXMuted) this.sfxMutedIndicatorDomElement.style.display = "flex";
        else this.sfxMutedIndicatorDomElement.style.display = "none";
    }
    SetMusicMuteButtonState(MusicMuted) {
        if (MusicMuted) this.musicMutedIndicatorDomElement.style.display = "flex";
        else this.musicMutedIndicatorDomElement.style.display = "none";
    }
    PopText(textToPop) {
        this._showAlertText(textToPop);
    }
    PopFallingDeathText() {
        const chosenString = (0, $34a8d0dc3ef4dba1$export$625550452a3fa3ec)(this.fallingDeathTextOptions[Math.floor(Math.random() * this.fallingDeathTextOptions.length)]);
        this._showAlertText(chosenString);
    }
    PopRestartedEntireRunText() {
        this._showAlertText((0, $34a8d0dc3ef4dba1$export$625550452a3fa3ec)("restart__restarted"));
    }
    PopIntentionalRespawnText() {
        const chosenString = this.intentionalRespawnTextOptions[Math.floor(Math.random() * this.intentionalRespawnTextOptions.length)];
        this._showAlertText(chosenString);
    }
    PopCookedDeathText() {
        const chosenString = (0, $34a8d0dc3ef4dba1$export$625550452a3fa3ec)(this.deathBlockDeathTextOptions[Math.floor(Math.random() * this.deathBlockDeathTextOptions.length)]);
        this._showAlertText(chosenString);
    }
    UpdateRunDuration(newDuration) {
        this.runDurationDomElement.innerText = (0, $9f2918ccbc980d31$export$a14e8754c327dfd0)(newDuration);
    }
    _onAlertTextEntryAnimationComplete() {
        // this.alertTextDomElement!.removeEventListener("animationend", this._onAlertTextEntryAnimationComplete.bind(this));
        this.alertTextDomElement.classList.remove("animate__jackInTheBox");
        // this.alertTextDomElement!.addEventListener("animationend", this._onAlertTextExitAnimationComplete.bind(this));
        this.alertTextDomElement.classList.add("animate__fadeOut", "animate__fast");
    }
    _showAlertText(newText) {
        this.alertTextDomElement.innerText = newText;
        this.alertTextDomElement.classList.remove("animate__fadeOut", "animate__fast");
        this.alertTextDomElement.style.display = "flex";
        this.alertTextDomElement.classList.add("animate__jackInTheBox");
    }
    PointerIsCurrentlyLocked() {
        // @ts-ignore
        return this._pointerIsLocked;
    }
    _onPointerLockStatusChanged() {
        // console.log("Pointer lock status changed!!");
        // console.log(document.pointerLockElement);
        // console.log(this.activeScreen);
        console.log("POINTER LOCK STATUS CHANGED!!!");
        // @ts-ignore
        if (document.pointerLockElement === null || document.mozPointerLockElement === null || document.webkitPointerLockElement === null) {
            console.log("Pointer is not locked anymore!!");
            this._pointerWasUnlockedAt = Date.now();
            this._pointerIsLocked = false;
            Game.EmitEvent("SDK::GameplayStop");
        } else {
            console.log("Pointer is not locked!!!!!");
            this._pointerIsLocked = true;
            if (Game.Predictor.GetPredictedEntity() !== undefined) Game.Predictor.GetPredictedEntity().ShouldFireGameplayStartEventOnNextMovement = true;
            // Game.EmitEvent("SDK::GameplayStart");
            this._hidePlayButton();
        }
    }
    _showPlayButton() {
        if (this.showingPlayButtonPending === true) return;
        if (globalThis.IsMobile === false) {
            this.showingPlayButtonPending = true;
            this.showingPlayButtonPending = false;
            this.playButtonDomElement.style.display = "flex";
        }
    }
    _hidePlayButton() {
        this.playButtonDomElement.style.display = "none";
    }
    CancelPointerLock() {
        if (globalThis.IsMobile === false) document.exitPointerLock();
    }
    HideMobileControls() {
        this.jumpButtonDomElement.style.display = "none";
        this.joystickContainerDomElement.style.display = "none";
    }
    ShowMobileControls() {
        this.jumpButtonDomElement.style.display = "flex";
        this.joystickContainerDomElement.style.display = "flex";
    }
    ShowScreen(screen) {
        // console.log(`Showing screen: ${Screens[screen]}`);
        if ((0, $9f2918ccbc980d31$export$b646210dbab6d1e3)() - this.lastClosedAllScreensTimestamp < 1500) // console.log("Not showing screen because we just closed all screens within the last 1.5 seconds!");
        return;
        else {
            // console.info("Emitting gameplay stop 2!");
            Game.EmitEvent("SDK::GameplayStop");
            // console.log("Showing screen");
            if (globalThis.IsMobile === false) document.exitPointerLock();
            this.uiScreenOpenOverlayDomElement.style.display = "flex";
            if (globalThis.IsMobile) this.HideMobileControls();
            else this.playButtonDomElement.style.display = "none";
            if (screen === $3c561a4876de7de6$export$b714373eb9ab036b.RestartRunWarning) {
                if (this.activeScreen === $3c561a4876de7de6$export$b714373eb9ab036b.RestartRunWarning) return;
                this.restartRunWarningDomElement.style.display = "flex";
                this.activeScreen = screen;
            }
            if (screen === $3c561a4876de7de6$export$b714373eb9ab036b.ViewSettings) {
                if (this.activeScreen === $3c561a4876de7de6$export$b714373eb9ab036b.ViewSettings) return;
                this.viewSettingsDomElement.style.display = "flex";
                this.activeScreen = screen;
            }
            if (screen === $3c561a4876de7de6$export$b714373eb9ab036b.CharacterSelect) {
                if (this.activeScreen === $3c561a4876de7de6$export$b714373eb9ab036b.CharacterSelect) return;
                this._updateCharacterCarouselState();
                this.characterSelectDomElement.style.display = "flex";
                this.activeScreen = screen;
            }
            if (screen === $3c561a4876de7de6$export$b714373eb9ab036b.TrailSelect) {
                if (this.activeScreen === $3c561a4876de7de6$export$b714373eb9ab036b.TrailSelect) return;
                this._updateTrailCarouselState();
                this.trailSelectDomElement.style.display = "flex";
                this.activeScreen = screen;
            }
            if (screen === $3c561a4876de7de6$export$b714373eb9ab036b.ChangeUsername) {
                if (this.activeScreen === $3c561a4876de7de6$export$b714373eb9ab036b.ChangeUsername) return;
                this.usernameScreenDomElement.style.display = "flex";
                this.activeScreen = screen;
            }
            if (screen === $3c561a4876de7de6$export$b714373eb9ab036b.EmojiSelector) {
                if (this.activeScreen === $3c561a4876de7de6$export$b714373eb9ab036b.EmojiSelector) return;
                this.emojiSelectorDomElement.style.display = "flex";
                this.activeScreen = screen;
            }
            if (screen === $3c561a4876de7de6$export$b714373eb9ab036b.RunComplete) {
                if (this.activeScreen === $3c561a4876de7de6$export$b714373eb9ab036b.RunComplete) return;
                this.runCompleteDomElement.style.display = "flex";
                this.activeScreen = screen;
            }
        }
    }
    ToggleUI() {
        if (this.rootUIDomElement.style.display === "none") this.rootUIDomElement.style.display = "flex";
        else this.rootUIDomElement.style.display = "none";
    }
    HideSpecificScreen(screen) {
        // console.log(`Hiding screen: ${Screens[screen]}`);
        if (screen === $3c561a4876de7de6$export$b714373eb9ab036b.RestartRunWarning) this.restartRunWarningDomElement.style.display = "none";
        if (screen === $3c561a4876de7de6$export$b714373eb9ab036b.ViewSettings) this.viewSettingsDomElement.style.display = "none";
        if (screen === $3c561a4876de7de6$export$b714373eb9ab036b.CharacterSelect) this.characterSelectDomElement.style.display = "none";
        if (screen === $3c561a4876de7de6$export$b714373eb9ab036b.TrailSelect) this.trailSelectDomElement.style.display = "none";
        if (screen === $3c561a4876de7de6$export$b714373eb9ab036b.ChangeUsername) this.usernameScreenDomElement.style.display = "none";
        if (screen === $3c561a4876de7de6$export$b714373eb9ab036b.EmojiSelector) this.emojiSelectorDomElement.style.display = "none";
        if (screen === $3c561a4876de7de6$export$b714373eb9ab036b.RunComplete) this.runCompleteDomElement.style.display = "none";
        if (globalThis.IsMobile) this.ShowMobileControls();
        this.uiScreenOpenOverlayDomElement.style.display = "none";
        this.activeScreen = $3c561a4876de7de6$export$b714373eb9ab036b.None;
        if (Game.Predictor.GetPredictedEntity() !== undefined) Game.Predictor.GetPredictedEntity().ShouldFireGameplayStartEventOnNextMovement = true;
    }
    HideAllScreens() {
        this.uiScreenOpenOverlayDomElement.style.display = "none";
        this.lastClosedAllScreensTimestamp = (0, $9f2918ccbc980d31$export$b646210dbab6d1e3)();
        this.runCompleteDomElement.style.display = "none";
        this.characterSelectDomElement.style.display = "none";
        this.restartRunWarningDomElement.style.display = "none";
        this.viewSettingsDomElement.style.display = "none";
        this.trailSelectDomElement.style.display = "none";
        this.usernameScreenDomElement.style.display = "none";
        this.emojiSelectorDomElement.style.display = "none";
        // if (globalThis.IsMobile === false) {
        //     try {
        //         Game.Renderer.Canvas.requestPointerLock();
        //     } catch (e) {
        //         console.error(`Caught pointer lock error, ignoring it: ${e.message}`);
        //     }
        // }
        if (this.playButtonDomElement.style.display !== "flex") {
            if (globalThis.IsMobile) this.playButtonDomElement.style.display = "none";
        } else setTimeout(()=>{
            this.playButtonDomElement.style.display = "flex";
        }, 300);
        if (globalThis.IsMobile) this.ShowMobileControls();
        this.activeScreen = $3c561a4876de7de6$export$b714373eb9ab036b.None;
        if (Game.Predictor.GetPredictedEntity() !== undefined) Game.Predictor.GetPredictedEntity().ShouldFireGameplayStartEventOnNextMovement = true;
    }
    _onLoadingAlmostComplete(updatedPercentage) {
        // console.warn("Updating loading progress percentage to:", updatedPercentage);
        // console.log("Loader told us progress is now...", updatedPercentage);
        this.loadingBarTextElement.innerText = (0, $34a8d0dc3ef4dba1$export$625550452a3fa3ec)("loading_text__connecting");
        // @ts-ignore
        this.loadingProgressDomElement.style["mask-size"] = `${updatedPercentage}% 300%`;
        // @ts-ignore
        this.loadingProgressDomElement.style["-webkit-mask-size"] = `${updatedPercentage}% 300%`;
    }
    _updateLoadingProgressPercentage(updatedPercentage) {
        // console.warn("Updating loading progress percentage to:", updatedPercentage);
        // console.log("Loader told us progress is now...", updatedPercentage);
        this.loadingBarTextElement.innerText = (0, $34a8d0dc3ef4dba1$export$625550452a3fa3ec)(this.loadingTextOptions[Math.floor(Math.random() * this.loadingTextOptions.length)]) + "...";
        // @ts-ignore
        this.loadingProgressDomElement.style["mask-size"] = `${updatedPercentage}% 300%`;
        // @ts-ignore
        this.loadingProgressDomElement.style["-webkit-mask-size"] = `${updatedPercentage}% 300%`;
    }
    _fadeInLoadingScreen() {
        // console.warn("Fading in loading screen");
        this.loadingSplashScreenDomElement.style.display = "flex";
        this.loadingSplashScreenDomElement.classList.add("animate__animated", "animate__fadeIn", "animate__fast");
    }
    _fadeOutLoadingScreen() {
        // return;
        // console.warn("Fading out loading screen");
        // Fade out the this.loadingSplashScreenDomElement dom node over 1 second
        this.loadingSplashScreenDomElement.classList.add("animate__animated", "animate__fadeOut", "animate__fast");
        this.loadingSplashScreenDomElement.addEventListener("animationend", ()=>{
            // console.log("loading splash animation end fired");
            // this.loadingSplashScreenDomElement!.style.display = "none";
            this.gameHudDomElement.style.display = "flex";
            this.gameHudDomElement.classList.add("animate__animated", "animate__fadeIn");
        });
    }
    getSystemName() {
        return "UI";
    }
    _atLeastOneSecondHasPassedSincePointerUnlocked() {
        return Date.now() - this._pointerWasUnlockedAt > 1000;
    }
    Update(__deltaTimeS, __deltaTimeMS, __currentTime) {
        this.restartCheckpointButtonPressedThisFrame = false;
        this.restartEntireRunButtonPressedThisFrame = false;
        if (globalThis.IsMobile === false) {
            if (this.PointerIsCurrentlyLocked() === false) {
                if (this.UIScreenIsOpen() === false) {
                    if (this._atLeastOneSecondHasPassedSincePointerUnlocked() === true) this._showPlayButton();
                }
            }
        }
    }
    Cleanup() {
        this.LogInfo("Cleaning up...");
    }
    constructor(){
        super();
        this.loadingTextOptions = [
            "loading_text__splines",
            "loading_text__tofu",
            "loading_text__corn",
            "loading_text__broccoli",
            "loading_text__brussel_sprouts",
            "loading_text__secret_sauce",
            "loading_text__digesting",
            "loading_text__stirring",
            "loading_text__fixing_ice_cream",
            "loading_text__chopping_broccoli",
            "loading_text__carmelize_apples",
            "loading_text__water_boil",
            "loading_text__filleting_fish",
            "loading_text__plating",
            "loading_text__garnishing",
            "loading_text__moldy_bits"
        ];
        this.deathBlockDeathTextOptions = [
            "death_block__almost",
            "death_block__close_one",
            "death_block__try_again",
            "death_block__roasted",
            "death_block__burnt",
            "death_block__oh_no",
            "death_block__grilled",
            "death_block__blanched",
            "death_block__crisp",
            "death_block__flameed",
            "death_block__fried",
            "death_block__order_up",
            "death_block__ouch",
            "death_block__good_try",
            "death_block__baked",
            "death_block__crusty",
            "death_block__next_time",
            "death_block__toast",
            "death_block__no_chef",
            "death_block__singe_left",
            "death_block__oof",
            "death_block__recipe_ruined",
            "death_block__sizzling_stop",
            "death_block__defeated",
            "death_block__burnt_out",
            "death_block__meltdown"
        ];
        this.fallingDeathTextOptions = [
            "falling_death__slippery",
            "falling_death__gg",
            "falling_death__you_died",
            "falling_death__f",
            "falling_death__floor_food",
            "falling_death__three_second",
            "falling_death__floor_seasoning",
            "falling_death__just_missed",
            "falling_death__rip",
            "falling_death__floor_vs_flavor",
            "falling_death__floor_fall",
            "falling_death__saucy_slip",
            "falling_death__fried_fell",
            "falling_death__dive",
            "falling_death__floor_finish",
            "falling_death__dinner_dive",
            "falling_death__splat",
            "falling_death__oops",
            "falling_death__greasy_spot",
            "falling_death__barely_missed",
            "falling_death__down_we_go"
        ];
        this.activeCarouselCharacterIndex = 0;
        this.activeCarouselTrailIndex = 0;
        this.characterSelectCarouselCharacters = [
            (0, $018036e722cee03d$export$a3168656a78efa21).Broccoli,
            (0, $018036e722cee03d$export$a3168656a78efa21).Blueberry,
            (0, $018036e722cee03d$export$a3168656a78efa21).Apple,
            (0, $018036e722cee03d$export$a3168656a78efa21).Cupcake,
            (0, $018036e722cee03d$export$a3168656a78efa21).Icecream,
            (0, $018036e722cee03d$export$a3168656a78efa21).Hotdog,
            (0, $018036e722cee03d$export$a3168656a78efa21).Peach,
            (0, $018036e722cee03d$export$a3168656a78efa21).Eggplant,
            (0, $018036e722cee03d$export$a3168656a78efa21).Banana,
            (0, $018036e722cee03d$export$a3168656a78efa21).Baguette,
            (0, $018036e722cee03d$export$a3168656a78efa21).Taco
        ] // /* TODO HOLIDAY UPDATE: Remove these two */ Characters.Turkeyleg, Characters.Candycane
        ;
        // @ts-ignore
        this.trailSelectCarouselOptions = [
            (0, $60d2b0e7b97425c1$export$72fb2d77891daaa5).Broccolis,
            (0, $60d2b0e7b97425c1$export$72fb2d77891daaa5).Circles,
            (0, $60d2b0e7b97425c1$export$72fb2d77891daaa5).Flies,
            (0, $60d2b0e7b97425c1$export$72fb2d77891daaa5).GoldenFlies,
            (0, $60d2b0e7b97425c1$export$72fb2d77891daaa5).Hearts,
            (0, $60d2b0e7b97425c1$export$72fb2d77891daaa5).Smoke,
            (0, $60d2b0e7b97425c1$export$72fb2d77891daaa5).SquareStars,
            (0, $60d2b0e7b97425c1$export$72fb2d77891daaa5).Stars
        ] // /* TODO HOLIDAY UPDATE: Remove these two */ ParticleEffects.Snow, ParticleEffects.GingerbreadMan
        ;
        this.intentionalRespawnTextOptions = [
            "Oof"
        ];
        this._pointerIsLocked = false;
        this._lastClickedPlayButtonTimestamp = 0;
        this.selectedTrail = (0, $60d2b0e7b97425c1$export$72fb2d77891daaa5).None;
        this._pointerWasUnlockedAt = 0;
        this.changeUsernameBtnDomElement = null;
        this.countryImages = null;
        this.usernameCountryOptions = null;
        this.usernamePrefixOptions = null;
        this.usernameSuffixOptions = null;
        this.emojiSelectorDomElement = null;
        this.rcMinsDomElement = null;
        this.rcSecsDomElement = null;
        this.rcMsDomElement = null;
        this.goAgainButtonDomElement = null;
        this.runCompleteDomElement = null;
        this.fallsValueDomElement = null;
        this.uiScreenOpenOverlayDomElement = null;
        this.topleftHudDomElement = null;
        this.usernameScreenDomElement = null;
        this.uiPopLoaderDomElement = null;
        this.uiPopLoaderProgressDomElement = null;
        this.keyboardHotkeyIndicators = null;
        this.restartRunWarningDomElement = null;
        this.restartRunTitleDomElement = null;
        this.restartRunWarningTextDomElement = null;
        this.characterSelectDomElement = null;
        this.trailSelectDomElement = null;
        this.alertTextDomElement = null;
        this.gameHudDomElement = null;
        this.loadingProgressDomElement = null;
        this.loadingSplashScreenDomElement = null;
        this.loadingBarTextElement = null;
        this.playButtonDomElement = null;
        this.runDurationDomElement = null;
        this.jumpButtonDomElement = null;
        this.joystickContainerDomElement = null;
        this.muteMusicBtnDomElement = null;
        this.muteSfxBtnDomElement = null;
        this.settingsBtnDomElement = null;
        this.restartCheckpointBtnDomElement = null;
        this.restartEntireRunBtnDomElement = null;
        this.musicMutedIndicatorDomElement = null;
        this.sfxMutedIndicatorDomElement = null;
        this.heightValueDomElement = null;
        this.fsButtonDomElement = null;
        this.openEmojiScreenDomElement = null;
        this.viewSettingsDomElement = null;
        this.openRestartWarningScreenDomElement = null;
        this.restartCheckpointButtonPressedThisFrame = false;
        this.restartEntireRunButtonPressedThisFrame = false;
        this.rootUIDomElement = null;
        this.trailActiveIndicatorDomElement = null;
        this.characterActiveIndicatorDomElement = null;
        this.xHotKeyIndicatorDomElement = null;
        this.rHotKeyIndicatorDomElement = null;
        this.unlockCharacterBtnDomElement = null;
        this.selectCharacterBtnDomElement = null;
        this.moveCharacterCarouselLeftBtnDomElement = null;
        this.moveCharacterCarouselRightBtnDomElement = null;
        this.characterCarouselLeftImgDomElement = null;
        this.characterCarouselLeftNameDomElement = null;
        this.characterCarouselCenterImgDomElement = null;
        this.characterCarouselCenterNameDomElement = null;
        this.characterCarouselRightImgDomElement = null;
        this.characterCarouselRightNameDomElement = null;
        this.loadingParent = null;
        this.gameLogoElement = null;
        this.errorScreenDomElement = null;
        this.errorMsgDomElement = null;
        this.selectTrailBtnDomElement = null;
        this.removeTrailBtnDomElement = null;
        this.unlockTrailBtnDomElement = null;
        this.moveTrailCarouselLeftBtnDomElement = null;
        this.moveTrailCarouselRightBtnDomElement = null;
        this.trailCarouselLeftImgDomElement = null;
        this.trailCarouselCenterImgDomElement = null;
        this.trailCarouselRightImgDomElement = null;
        this.unlockedCharacterSkins = [];
        this.unlockedTrails = [];
        this.numberOfFalls = 0;
        this.activeScreen = $3c561a4876de7de6$export$b714373eb9ab036b.None;
        this.lastClosedAllScreensTimestamp = (0, $9f2918ccbc980d31$export$b646210dbab6d1e3)();
        this.changeUsernameBtnDomElement = document.querySelector(".change-username-btn");
        this.countryImages = document.querySelectorAll(".flag-preview");
        this.keyboardHotkeyIndicators = document.querySelectorAll(".keyboard-keypress");
        this.usernameCountryOptions = document.querySelector(".change-username-country");
        this.usernamePrefixOptions = document.querySelector(".change-username-prefix");
        this.usernameSuffixOptions = document.querySelector(".change-username-suffix");
        this.emojiSelectorDomElement = document.querySelector(".emoji-selector");
        this.rcMinsDomElement = document.querySelector(".rc-mins");
        this.rcSecsDomElement = document.querySelector(".rc-secs");
        this.rcMsDomElement = document.querySelector(".rc-ms");
        this.goAgainButtonDomElement = document.querySelector(".run-complete-btn");
        this.runCompleteDomElement = document.querySelector(".run-complete");
        this.trailActiveIndicatorDomElement = document.querySelector(".trail-active");
        this.characterActiveIndicatorDomElement = document.querySelector(".character-active");
        this.xHotKeyIndicatorDomElement = document.querySelector(".keyboard-keypress.x");
        this.rHotKeyIndicatorDomElement = document.querySelector(".keyboard-keypress.r");
        this.gameLogoElement = document.querySelector(".game-logo");
        this.characterSelectDomElement = document.querySelector(".character-select");
        this.restartRunWarningDomElement = document.querySelector(".restart-run-warning");
        this.restartRunTitleDomElement = document.querySelector(".restart-run-title");
        this.restartRunWarningTextDomElement = document.querySelector(".warning");
        this.unlockCharacterBtnDomElement = document.querySelector(".unlock-character-btn");
        this.selectCharacterBtnDomElement = document.querySelector(".select-character-btn");
        this.characterCarouselLeftImgDomElement = document.querySelector(".character-carousel-left-img");
        this.characterCarouselLeftNameDomElement = document.querySelector(".character-carousel-left-name");
        this.characterCarouselCenterImgDomElement = document.querySelector(".character-carousel-center-img");
        this.characterCarouselCenterNameDomElement = document.querySelector(".character-carousel-center-name");
        this.characterCarouselRightImgDomElement = document.querySelector(".character-carousel-right-img");
        this.characterCarouselRightNameDomElement = document.querySelector(".character-carousel-right-name");
        this.moveCharacterCarouselLeftBtnDomElement = document.querySelector(".character-scroll-left-btn");
        this.moveCharacterCarouselRightBtnDomElement = document.querySelector(".character-scroll-right-btn");
        this.trailSelectDomElement = document.querySelector(".trail-select");
        this.selectTrailBtnDomElement = document.querySelector(".select-trail-btn");
        this.removeTrailBtnDomElement = document.querySelector(".remove-trail-btn");
        this.unlockTrailBtnDomElement = document.querySelector(".unlock-trail-btn");
        this.trailCarouselLeftImgDomElement = document.querySelector(".trail-carousel-left-img");
        this.trailCarouselCenterImgDomElement = document.querySelector(".trail-carousel-center-img");
        this.trailCarouselRightImgDomElement = document.querySelector(".trail-carousel-right-img");
        this.moveTrailCarouselLeftBtnDomElement = document.querySelector(".trail-scroll-left-btn");
        this.moveTrailCarouselRightBtnDomElement = document.querySelector(".trail-scroll-right-btn");
        this.fallsValueDomElement = document.querySelector(".falls-value");
        this.uiScreenOpenOverlayDomElement = document.querySelector(".ui-screen-open-overlay");
        this.openEmojiScreenDomElement = document.querySelector(".emoji-btn");
        this.openRestartWarningScreenDomElement = document.querySelector(".restart-run-btn");
        this.viewSettingsDomElement = document.querySelector(".view-settings");
        this.settingsBtnDomElement = document.querySelector(".settings-btn");
        this.fsButtonDomElement = document.querySelector(".fs-btn");
        this.jumpButtonDomElement = document.querySelector(".jump-button-container");
        this.joystickContainerDomElement = document.querySelector(".joystick-container");
        this.topleftHudDomElement = document.querySelector(".top-left-hud");
        this.usernameScreenDomElement = document.querySelector(".change-username");
        this.uiPopLoaderDomElement = document.querySelector(".ui-pop-loader");
        this.uiPopLoaderProgressDomElement = document.querySelector(".ui-pop-loader-progress");
        this.closeScreenButtonsDomElements = document.querySelectorAll(".close-screen");
        this.emojiButtonsDomElements = document.querySelectorAll(".emoji");
        this.alertTextDomElement = document.querySelector(".alert");
        this.gameHudDomElement = document.querySelector(".hud");
        this.loadingParent = document.querySelector(".loading");
        this.loadingProgressDomElement = document.querySelector(".loading-bar-fg");
        this.loadingSplashScreenDomElement = document.querySelector(".loading-splash");
        this.playButtonDomElement = document.querySelector(".play-btn");
        this.loadingBarTextElement = document.querySelector(".loading-text");
        this.runDurationDomElement = document.querySelector(".run-duration");
        this.muteMusicBtnDomElement = document.querySelector(".mute-music-btn");
        this.muteSfxBtnDomElement = document.querySelector(".mute-sfx-btn");
        this.restartCheckpointBtnDomElement = document.querySelector(".restart-cp-btn");
        this.restartEntireRunBtnDomElement = document.querySelector(".restart-run-btn-confirm");
        this.musicMutedIndicatorDomElement = document.querySelector(".music-off");
        this.sfxMutedIndicatorDomElement = document.querySelector(".sfx-off");
        this.heightValueDomElement = document.querySelector(".height-value");
        this.rootUIDomElement = document.querySelector("#ui-root");
        this.errorScreenDomElement = document.querySelector(".error-screen");
        this.errorMsgDomElement = document.querySelector(".error-msg");
        if (this.rHotKeyIndicatorDomElement === null) throw new Error("Could not find R hotkey indicator dom element!");
        if (this.xHotKeyIndicatorDomElement === null) throw new Error("Could not find X hotkey indicator dom element!");
        if (this.errorScreenDomElement === null) throw new Error("Could not find error screen dom element!");
        if (this.errorMsgDomElement === null) throw new Error("Could not find error msg dom element!");
        if (this.usernameCountryOptions === null) throw new Error("Could not find username country options!");
        if (this.loadingParent === null) throw new Error("Could not find loading parent dom element!");
        if (this.changeUsernameBtnDomElement === null) throw new Error("Could not find change username button dom element!");
        if (this.countryImages.length === 0) throw new Error("Could not find country images!");
        if (this.usernamePrefixOptions === null) throw new Error("Could not find username prefix options!");
        if (this.usernameSuffixOptions === null) throw new Error("Could not find username suffix options!");
        if (this.emojiSelectorDomElement === null) throw new Error("Could not find emoji selector dom element!");
        if (this.emojiSelectorDomElement === null) throw new Error("Could not find emoji selector dom element!");
        if (this.rcMinsDomElement === null) throw new Error("Could not find rc mins dom element!");
        if (this.rcSecsDomElement === null) throw new Error("Could not find rc secs dom element!");
        if (this.rcMsDomElement === null) throw new Error("Could not find rc ms dom element!");
        if (this.characterCarouselLeftImgDomElement === null) throw new Error("Could not find carousel left img dom element!");
        if (this.characterCarouselLeftNameDomElement === null) throw new Error("Could not find carousel left name dom element!");
        if (this.characterCarouselCenterImgDomElement === null) throw new Error("Could not find carousel center img dom element!");
        if (this.characterCarouselCenterNameDomElement === null) throw new Error("Could not find carousel center name dom element!");
        if (this.characterCarouselRightImgDomElement === null) throw new Error("Could not find carousel right img dom element!");
        if (this.characterCarouselRightNameDomElement === null) throw new Error("Could not find carousel right name dom element!");
        if (this.unlockCharacterBtnDomElement === null) throw new Error("Could not find unlock character button dom element!");
        if (this.selectCharacterBtnDomElement === null) throw new Error("Could not find select character button dom element!");
        if (this.moveCharacterCarouselLeftBtnDomElement === null) throw new Error("Could not find move character carousel left button dom element!");
        if (this.moveCharacterCarouselRightBtnDomElement === null) throw new Error("Could not find move character carousel right button dom element!");
        if (this.fallsValueDomElement === null) throw new Error("Could not find falls value dom element!");
        if (this.rootUIDomElement === null) throw new Error("Could not find root ui dom element!");
        if (this.uiScreenOpenOverlayDomElement === null) throw new Error("Could not find ui screen open overlay dom element!");
        if (this.fsButtonDomElement === null) throw new Error("Could not find fs button dom element!");
        if (this.heightValueDomElement === null) throw new Error("Could not find height value dom element!");
        if (this.musicMutedIndicatorDomElement === null) throw new Error("Could not find music muted indicator dom element!");
        if (this.sfxMutedIndicatorDomElement === null) throw new Error("Could not find sfx muted indicator dom element!");
        if (this.muteMusicBtnDomElement === null) throw new Error("Could not find mute music button dom element!");
        if (this.muteSfxBtnDomElement === null) throw new Error("Could not find mute sfx button dom element!");
        if (this.settingsBtnDomElement === null) throw new Error("Could not find settings button dom element!");
        if (this.restartCheckpointBtnDomElement === null) throw new Error("Could not find restart run button dom element!");
        if (this.restartEntireRunBtnDomElement === null) throw new Error("Could not find restart entire run button dom element!");
        if (this.jumpButtonDomElement === null) throw new Error("Could not find jump button dom element!");
        if (this.joystickContainerDomElement === null) throw new Error("Could not find joystick container dom element!");
        if (this.topleftHudDomElement === null) throw new Error("Could not find top left hud dom element!");
        if (this.usernameScreenDomElement === null) throw new Error("Could not find username screen dom element!");
        if (this.uiPopLoaderDomElement === null) throw new Error("Could not find ui pop loader dom element!");
        if (this.uiPopLoaderProgressDomElement === null) throw new Error("Could not find ui pop loader progress dom element!");
        if (this.closeScreenButtonsDomElements.length === 0) throw new Error("Could not find close screen button dom elements!");
        if (this.emojiButtonsDomElements.length === 0) throw new Error("Could not find emoji button dom elements!");
        if (this.characterSelectDomElement === null) throw new Error("Could not find character select dom element!");
        if (this.trailSelectDomElement === null) throw new Error("Could not find character select dom element!");
        if (this.alertTextDomElement === null) throw new Error("Could not find alert text dom element!");
        if (this.gameHudDomElement === null) throw new Error("Could not find game hud dom element!");
        if (this.loadingProgressDomElement === null) throw new Error("Could not find loading progress dom element!");
        if (this.gameLogoElement === null) throw new Error("Could not find game logo dom element!");
        if (this.loadingSplashScreenDomElement === null) throw new Error("Could not find loading splash screen dom element!");
        if (this.playButtonDomElement === null) throw new Error("Could not find play button dom element!");
        if (this.loadingBarTextElement === null) throw new Error("Could not find loading bar text element!");
        if (this.runDurationDomElement === null) throw new Error("Could not find run duration dom element!");
    }
}




var $bfbf1ecd718c53b2$exports = {};
!function(t, i) {
    $bfbf1ecd718c53b2$exports = i();
}(window, function() {
    return function(t) {
        var i = {};
        function e(o) {
            if (i[o]) return i[o].exports;
            var n = i[o] = {
                i: o,
                l: !1,
                exports: {}
            };
            return t[o].call(n.exports, n, n.exports, e), n.l = !0, n.exports;
        }
        return e.m = t, e.c = i, e.d = function(t, i, o) {
            e.o(t, i) || Object.defineProperty(t, i, {
                enumerable: !0,
                get: o
            });
        }, e.r = function(t) {
            "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(t, Symbol.toStringTag, {
                value: "Module"
            }), Object.defineProperty(t, "__esModule", {
                value: !0
            });
        }, e.t = function(t, i) {
            if (1 & i && (t = e(t)), 8 & i) return t;
            if (4 & i && "object" == typeof t && t && t.__esModule) return t;
            var o = Object.create(null);
            if (e.r(o), Object.defineProperty(o, "default", {
                enumerable: !0,
                value: t
            }), 2 & i && "string" != typeof t) for(var n in t)e.d(o, n, (function(i) {
                return t[i];
            }).bind(null, n));
            return o;
        }, e.n = function(t) {
            var i = t && t.__esModule ? function() {
                return t.default;
            } : function() {
                return t;
            };
            return e.d(i, "a", i), i;
        }, e.o = function(t, i) {
            return Object.prototype.hasOwnProperty.call(t, i);
        }, e.p = "", e(e.s = 0);
    }([
        function(t, i, e) {
            "use strict";
            e.r(i);
            var o, n = function(t, i) {
                var e = i.x - t.x, o = i.y - t.y;
                return Math.sqrt(e * e + o * o);
            }, s = function(t) {
                return t * (Math.PI / 180);
            }, r = function(t) {
                return t * (180 / Math.PI);
            }, d = new Map, a = function(t) {
                d.has(t) && clearTimeout(d.get(t)), d.set(t, setTimeout(t, 100));
            }, p = function(t, i, e) {
                for(var o, n = i.split(/[ ,]+/g), s = 0; s < n.length; s += 1)o = n[s], t.addEventListener ? t.addEventListener(o, e, !1) : t.attachEvent && t.attachEvent(o, e);
            }, c = function(t, i, e) {
                for(var o, n = i.split(/[ ,]+/g), s = 0; s < n.length; s += 1)o = n[s], t.removeEventListener ? t.removeEventListener(o, e) : t.detachEvent && t.detachEvent(o, e);
            }, l = function(t) {
                return t.preventDefault(), t.type.match(/^touch/) ? t.changedTouches : t;
            }, h = function() {
                return {
                    x: void 0 !== window.pageXOffset ? window.pageXOffset : (document.documentElement || document.body.parentNode || document.body).scrollLeft,
                    y: void 0 !== window.pageYOffset ? window.pageYOffset : (document.documentElement || document.body.parentNode || document.body).scrollTop
                };
            }, u = function(t, i) {
                i.top || i.right || i.bottom || i.left ? (t.style.top = i.top, t.style.right = i.right, t.style.bottom = i.bottom, t.style.left = i.left) : (t.style.left = i.x + "px", t.style.top = i.y + "px");
            }, f = function(t, i, e) {
                var o = y(t);
                for(var n in o)if (o.hasOwnProperty(n)) {
                    if ("string" == typeof i) o[n] = i + " " + e;
                    else {
                        for(var s = "", r = 0, d = i.length; r < d; r += 1)s += i[r] + " " + e + ", ";
                        o[n] = s.slice(0, -2);
                    }
                }
                return o;
            }, y = function(t) {
                var i = {};
                i[t] = "";
                return [
                    "webkit",
                    "Moz",
                    "o"
                ].forEach(function(e) {
                    i[e + t.charAt(0).toUpperCase() + t.slice(1)] = "";
                }), i;
            }, m = function(t, i) {
                for(var e in i)i.hasOwnProperty(e) && (t[e] = i[e]);
                return t;
            }, v = function(t, i) {
                if (t.length) for(var e = 0, o = t.length; e < o; e += 1)i(t[e]);
                else i(t);
            }, g = !!("ontouchstart" in window), b = !!window.PointerEvent, x = !!window.MSPointerEvent, O = {
                start: "mousedown",
                move: "mousemove",
                end: "mouseup"
            }, w = {};
            function _() {}
            b ? o = {
                start: "pointerdown",
                move: "pointermove",
                end: "pointerup, pointercancel"
            } : x ? o = {
                start: "MSPointerDown",
                move: "MSPointerMove",
                end: "MSPointerUp"
            } : g ? (o = {
                start: "touchstart",
                move: "touchmove",
                end: "touchend, touchcancel"
            }, w = O) : o = O, _.prototype.on = function(t, i) {
                var e, o = t.split(/[ ,]+/g);
                this._handlers_ = this._handlers_ || {};
                for(var n = 0; n < o.length; n += 1)e = o[n], this._handlers_[e] = this._handlers_[e] || [], this._handlers_[e].push(i);
                return this;
            }, _.prototype.off = function(t, i) {
                return this._handlers_ = this._handlers_ || {}, void 0 === t ? this._handlers_ = {} : void 0 === i ? this._handlers_[t] = null : this._handlers_[t] && this._handlers_[t].indexOf(i) >= 0 && this._handlers_[t].splice(this._handlers_[t].indexOf(i), 1), this;
            }, _.prototype.trigger = function(t, i) {
                var e, o = this, n = t.split(/[ ,]+/g);
                o._handlers_ = o._handlers_ || {};
                for(var s = 0; s < n.length; s += 1)e = n[s], o._handlers_[e] && o._handlers_[e].length && o._handlers_[e].forEach(function(t) {
                    t.call(o, {
                        type: e,
                        target: o
                    }, i);
                });
            }, _.prototype.config = function(t) {
                this.options = this.defaults || {}, t && (this.options = function(t, i) {
                    var e = {};
                    for(var o in t)t.hasOwnProperty(o) && i.hasOwnProperty(o) ? e[o] = i[o] : t.hasOwnProperty(o) && (e[o] = t[o]);
                    return e;
                }(this.options, t));
            }, _.prototype.bindEvt = function(t, i) {
                var e = this;
                return e._domHandlers_ = e._domHandlers_ || {}, e._domHandlers_[i] = function() {
                    "function" == typeof e["on" + i] ? e["on" + i].apply(e, arguments) : console.warn('[WARNING] : Missing "on' + i + '" handler.');
                }, p(t, o[i], e._domHandlers_[i]), w[i] && p(t, w[i], e._domHandlers_[i]), e;
            }, _.prototype.unbindEvt = function(t, i) {
                return this._domHandlers_ = this._domHandlers_ || {}, c(t, o[i], this._domHandlers_[i]), w[i] && c(t, w[i], this._domHandlers_[i]), delete this._domHandlers_[i], this;
            };
            var T = _;
            function k(t, i) {
                return this.identifier = i.identifier, this.position = i.position, this.frontPosition = i.frontPosition, this.collection = t, this.defaults = {
                    size: 100,
                    threshold: .1,
                    color: "white",
                    fadeTime: 250,
                    dataOnly: !1,
                    restJoystick: !0,
                    restOpacity: .5,
                    mode: "dynamic",
                    zone: document.body,
                    lockX: !1,
                    lockY: !1,
                    shape: "circle"
                }, this.config(i), "dynamic" === this.options.mode && (this.options.restOpacity = 0), this.id = k.id, k.id += 1, this.buildEl().stylize(), this.instance = {
                    el: this.ui.el,
                    on: this.on.bind(this),
                    off: this.off.bind(this),
                    show: this.show.bind(this),
                    hide: this.hide.bind(this),
                    add: this.addToDom.bind(this),
                    remove: this.removeFromDom.bind(this),
                    destroy: this.destroy.bind(this),
                    setPosition: this.setPosition.bind(this),
                    resetDirection: this.resetDirection.bind(this),
                    computeDirection: this.computeDirection.bind(this),
                    trigger: this.trigger.bind(this),
                    position: this.position,
                    frontPosition: this.frontPosition,
                    ui: this.ui,
                    identifier: this.identifier,
                    id: this.id,
                    options: this.options
                }, this.instance;
            }
            k.prototype = new T, k.constructor = k, k.id = 0, k.prototype.buildEl = function(t) {
                return this.ui = {}, this.options.dataOnly || (this.ui.el = document.createElement("div"), this.ui.back = document.createElement("div"), this.ui.front = document.createElement("div"), this.ui.el.className = "nipple collection_" + this.collection.id, this.ui.back.className = "back", this.ui.front.className = "front", this.ui.el.setAttribute("id", "nipple_" + this.collection.id + "_" + this.id), this.ui.el.appendChild(this.ui.back), this.ui.el.appendChild(this.ui.front)), this;
            }, k.prototype.stylize = function() {
                if (this.options.dataOnly) return this;
                var t = this.options.fadeTime + "ms", i = function(t, i) {
                    var e = y(t);
                    for(var o in e)e.hasOwnProperty(o) && (e[o] = i);
                    return e;
                }("borderRadius", "50%"), e = f("transition", "opacity", t), o = {};
                return o.el = {
                    position: "absolute",
                    opacity: this.options.restOpacity,
                    display: "block",
                    zIndex: 999
                }, o.back = {
                    position: "absolute",
                    display: "block",
                    width: this.options.size + "px",
                    height: this.options.size + "px",
                    marginLeft: -this.options.size / 2 + "px",
                    marginTop: -this.options.size / 2 + "px",
                    background: this.options.color,
                    opacity: ".5"
                }, o.front = {
                    width: this.options.size / 2 + "px",
                    height: this.options.size / 2 + "px",
                    position: "absolute",
                    display: "block",
                    marginLeft: -this.options.size / 4 + "px",
                    marginTop: -this.options.size / 4 + "px",
                    background: this.options.color,
                    opacity: ".5",
                    transform: "translate(0px, 0px)"
                }, m(o.el, e), "circle" === this.options.shape && m(o.back, i), m(o.front, i), this.applyStyles(o), this;
            }, k.prototype.applyStyles = function(t) {
                for(var i in this.ui)if (this.ui.hasOwnProperty(i)) for(var e in t[i])this.ui[i].style[e] = t[i][e];
                return this;
            }, k.prototype.addToDom = function() {
                return this.options.dataOnly || document.body.contains(this.ui.el) || this.options.zone.appendChild(this.ui.el), this;
            }, k.prototype.removeFromDom = function() {
                return this.options.dataOnly || !document.body.contains(this.ui.el) || this.options.zone.removeChild(this.ui.el), this;
            }, k.prototype.destroy = function() {
                clearTimeout(this.removeTimeout), clearTimeout(this.showTimeout), clearTimeout(this.restTimeout), this.trigger("destroyed", this.instance), this.removeFromDom(), this.off();
            }, k.prototype.show = function(t) {
                var i = this;
                return i.options.dataOnly || (clearTimeout(i.removeTimeout), clearTimeout(i.showTimeout), clearTimeout(i.restTimeout), i.addToDom(), i.restCallback(), setTimeout(function() {
                    i.ui.el.style.opacity = 1;
                }, 0), i.showTimeout = setTimeout(function() {
                    i.trigger("shown", i.instance), "function" == typeof t && t.call(this);
                }, i.options.fadeTime)), i;
            }, k.prototype.hide = function(t) {
                var i = this;
                if (i.options.dataOnly) return i;
                if (i.ui.el.style.opacity = i.options.restOpacity, clearTimeout(i.removeTimeout), clearTimeout(i.showTimeout), clearTimeout(i.restTimeout), i.removeTimeout = setTimeout(function() {
                    var e = "dynamic" === i.options.mode ? "none" : "block";
                    i.ui.el.style.display = e, "function" == typeof t && t.call(i), i.trigger("hidden", i.instance);
                }, i.options.fadeTime), i.options.restJoystick) {
                    var e = i.options.restJoystick, o = {};
                    o.x = !0 === e || !1 !== e.x ? 0 : i.instance.frontPosition.x, o.y = !0 === e || !1 !== e.y ? 0 : i.instance.frontPosition.y, i.setPosition(t, o);
                }
                return i;
            }, k.prototype.setPosition = function(t, i) {
                var e = this;
                e.frontPosition = {
                    x: i.x,
                    y: i.y
                };
                var o = e.options.fadeTime + "ms", n = {};
                n.front = f("transition", [
                    "transform"
                ], o);
                var s = {
                    front: {}
                };
                s.front = {
                    transform: "translate(" + e.frontPosition.x + "px," + e.frontPosition.y + "px)"
                }, e.applyStyles(n), e.applyStyles(s), e.restTimeout = setTimeout(function() {
                    "function" == typeof t && t.call(e), e.restCallback();
                }, e.options.fadeTime);
            }, k.prototype.restCallback = function() {
                var t = {};
                t.front = f("transition", "none", ""), this.applyStyles(t), this.trigger("rested", this.instance);
            }, k.prototype.resetDirection = function() {
                this.direction = {
                    x: !1,
                    y: !1,
                    angle: !1
                };
            }, k.prototype.computeDirection = function(t) {
                var i, e, o, n = t.angle.radian, s = Math.PI / 4, r = Math.PI / 2;
                if (n > s && n < 3 * s && !t.lockX ? i = "up" : n > -s && n <= s && !t.lockY ? i = "left" : n > 3 * -s && n <= -s && !t.lockX ? i = "down" : t.lockY || (i = "right"), t.lockY || (e = n > -r && n < r ? "left" : "right"), t.lockX || (o = n > 0 ? "up" : "down"), t.force > this.options.threshold) {
                    var d, a = {};
                    for(d in this.direction)this.direction.hasOwnProperty(d) && (a[d] = this.direction[d]);
                    var p = {};
                    for(d in this.direction = {
                        x: e,
                        y: o,
                        angle: i
                    }, t.direction = this.direction, a)a[d] === this.direction[d] && (p[d] = !0);
                    if (p.x && p.y && p.angle) return t;
                    p.x && p.y || this.trigger("plain", t), p.x || this.trigger("plain:" + e, t), p.y || this.trigger("plain:" + o, t), p.angle || this.trigger("dir dir:" + i, t);
                } else this.resetDirection();
                return t;
            };
            var P = k;
            function E(t, i) {
                this.nipples = [], this.idles = [], this.actives = [], this.ids = [], this.pressureIntervals = {}, this.manager = t, this.id = E.id, E.id += 1, this.defaults = {
                    zone: document.body,
                    multitouch: !1,
                    maxNumberOfNipples: 10,
                    mode: "dynamic",
                    position: {
                        top: 0,
                        left: 0
                    },
                    catchDistance: 200,
                    size: 100,
                    threshold: .1,
                    color: "white",
                    fadeTime: 250,
                    dataOnly: !1,
                    restJoystick: !0,
                    restOpacity: .5,
                    lockX: !1,
                    lockY: !1,
                    shape: "circle",
                    dynamicPage: !1,
                    follow: !1
                }, this.config(i), "static" !== this.options.mode && "semi" !== this.options.mode || (this.options.multitouch = !1), this.options.multitouch || (this.options.maxNumberOfNipples = 1);
                var e = getComputedStyle(this.options.zone.parentElement);
                return e && "flex" === e.display && (this.parentIsFlex = !0), this.updateBox(), this.prepareNipples(), this.bindings(), this.begin(), this.nipples;
            }
            E.prototype = new T, E.constructor = E, E.id = 0, E.prototype.prepareNipples = function() {
                var t = this.nipples;
                t.on = this.on.bind(this), t.off = this.off.bind(this), t.options = this.options, t.destroy = this.destroy.bind(this), t.ids = this.ids, t.id = this.id, t.processOnMove = this.processOnMove.bind(this), t.processOnEnd = this.processOnEnd.bind(this), t.get = function(i) {
                    if (void 0 === i) return t[0];
                    for(var e = 0, o = t.length; e < o; e += 1)if (t[e].identifier === i) return t[e];
                    return !1;
                };
            }, E.prototype.bindings = function() {
                this.bindEvt(this.options.zone, "start"), this.options.zone.style.touchAction = "none", this.options.zone.style.msTouchAction = "none";
            }, E.prototype.begin = function() {
                var t = this.options;
                if ("static" === t.mode) {
                    var i = this.createNipple(t.position, this.manager.getIdentifier());
                    i.add(), this.idles.push(i);
                }
            }, E.prototype.createNipple = function(t, i) {
                var e = this.manager.scroll, o = {}, n = this.options, s = this.parentIsFlex ? e.x : e.x + this.box.left, r = this.parentIsFlex ? e.y : e.y + this.box.top;
                if (t.x && t.y) o = {
                    x: t.x - s,
                    y: t.y - r
                };
                else if (t.top || t.right || t.bottom || t.left) {
                    var d = document.createElement("DIV");
                    d.style.display = "hidden", d.style.top = t.top, d.style.right = t.right, d.style.bottom = t.bottom, d.style.left = t.left, d.style.position = "absolute", n.zone.appendChild(d);
                    var a = d.getBoundingClientRect();
                    n.zone.removeChild(d), o = t, t = {
                        x: a.left + e.x,
                        y: a.top + e.y
                    };
                }
                var p = new P(this, {
                    color: n.color,
                    size: n.size,
                    threshold: n.threshold,
                    fadeTime: n.fadeTime,
                    dataOnly: n.dataOnly,
                    restJoystick: n.restJoystick,
                    restOpacity: n.restOpacity,
                    mode: n.mode,
                    identifier: i,
                    position: t,
                    zone: n.zone,
                    frontPosition: {
                        x: 0,
                        y: 0
                    },
                    shape: n.shape
                });
                return n.dataOnly || (u(p.ui.el, o), u(p.ui.front, p.frontPosition)), this.nipples.push(p), this.trigger("added " + p.identifier + ":added", p), this.manager.trigger("added " + p.identifier + ":added", p), this.bindNipple(p), p;
            }, E.prototype.updateBox = function() {
                this.box = this.options.zone.getBoundingClientRect();
            }, E.prototype.bindNipple = function(t) {
                var i, e = this, o = function(t, o) {
                    i = t.type + " " + o.id + ":" + t.type, e.trigger(i, o);
                };
                t.on("destroyed", e.onDestroyed.bind(e)), t.on("shown hidden rested dir plain", o), t.on("dir:up dir:right dir:down dir:left", o), t.on("plain:up plain:right plain:down plain:left", o);
            }, E.prototype.pressureFn = function(t, i, e) {
                var o = this, n = 0;
                clearInterval(o.pressureIntervals[e]), o.pressureIntervals[e] = setInterval((function() {
                    var e = t.force || t.pressure || t.webkitForce || 0;
                    e !== n && (i.trigger("pressure", e), o.trigger("pressure " + i.identifier + ":pressure", e), n = e);
                }).bind(o), 100);
            }, E.prototype.onstart = function(t) {
                var i = this, e = i.options, o = t;
                t = l(t), i.updateBox();
                return v(t, function(n) {
                    i.actives.length < e.maxNumberOfNipples ? i.processOnStart(n) : o.type.match(/^touch/) && (Object.keys(i.manager.ids).forEach(function(e) {
                        if (Object.values(o.touches).findIndex(function(t) {
                            return t.identifier === e;
                        }) < 0) {
                            var n = [
                                t[0]
                            ];
                            n.identifier = e, i.processOnEnd(n);
                        }
                    }), i.actives.length < e.maxNumberOfNipples && i.processOnStart(n));
                }), i.manager.bindDocument(), !1;
            }, E.prototype.processOnStart = function(t) {
                var i, e = this, o = e.options, s = e.manager.getIdentifier(t), r = t.force || t.pressure || t.webkitForce || 0, d = {
                    x: t.pageX,
                    y: t.pageY
                }, a = e.getOrCreate(s, d);
                a.identifier !== s && e.manager.removeIdentifier(a.identifier), a.identifier = s;
                var p = function(i) {
                    i.trigger("start", i), e.trigger("start " + i.id + ":start", i), i.show(), r > 0 && e.pressureFn(t, i, i.identifier), e.processOnMove(t);
                };
                if ((i = e.idles.indexOf(a)) >= 0 && e.idles.splice(i, 1), e.actives.push(a), e.ids.push(a.identifier), "semi" !== o.mode) p(a);
                else {
                    if (!(n(d, a.position) <= o.catchDistance)) return a.destroy(), void e.processOnStart(t);
                    p(a);
                }
                return a;
            }, E.prototype.getOrCreate = function(t, i) {
                var e, o = this.options;
                return /(semi|static)/.test(o.mode) ? (e = this.idles[0]) ? (this.idles.splice(0, 1), e) : "semi" === o.mode ? this.createNipple(i, t) : (console.warn("Coudln't find the needed nipple."), !1) : e = this.createNipple(i, t);
            }, E.prototype.processOnMove = function(t) {
                var i = this.options, e = this.manager.getIdentifier(t), o = this.nipples.get(e), d = this.manager.scroll;
                if (function(t) {
                    return isNaN(t.buttons) ? 0 !== t.pressure : 0 !== t.buttons;
                }(t)) {
                    if (!o) return console.error("Found zombie joystick with ID " + e), void this.manager.removeIdentifier(e);
                    if (i.dynamicPage) {
                        var a = o.el.getBoundingClientRect();
                        o.position = {
                            x: d.x + a.left,
                            y: d.y + a.top
                        };
                    }
                    o.identifier = e;
                    var p = o.options.size / 2, c = {
                        x: t.pageX,
                        y: t.pageY
                    };
                    i.lockX && (c.y = o.position.y), i.lockY && (c.x = o.position.x);
                    var l, h, u, f, y, m, v, g, b, x, O = n(c, o.position), w = (l = c, h = o.position, u = h.x - l.x, f = h.y - l.y, r(Math.atan2(f, u))), _ = s(w), T = O / p, k = {
                        distance: O,
                        position: c
                    };
                    if ("circle" === o.options.shape ? (y = Math.min(O, p), v = o.position, g = y, x = {
                        x: 0,
                        y: 0
                    }, b = s(b = w), x.x = v.x - g * Math.cos(b), x.y = v.y - g * Math.sin(b), m = x) : (m = function(t, i, e) {
                        return {
                            x: Math.min(Math.max(t.x, i.x - e), i.x + e),
                            y: Math.min(Math.max(t.y, i.y - e), i.y + e)
                        };
                    }(c, o.position, p), y = n(m, o.position)), i.follow) {
                        if (O > p) {
                            var P = c.x - m.x, E = c.y - m.y;
                            o.position.x += P, o.position.y += E, o.el.style.top = o.position.y - (this.box.top + d.y) + "px", o.el.style.left = o.position.x - (this.box.left + d.x) + "px", O = n(c, o.position);
                        }
                    } else c = m, O = y;
                    var I = c.x - o.position.x, z = c.y - o.position.y;
                    o.frontPosition = {
                        x: I,
                        y: z
                    }, i.dataOnly || (o.ui.front.style.transform = "translate(" + I + "px," + z + "px)");
                    var D = {
                        identifier: o.identifier,
                        position: c,
                        force: T,
                        pressure: t.force || t.pressure || t.webkitForce || 0,
                        distance: O,
                        angle: {
                            radian: _,
                            degree: w
                        },
                        vector: {
                            x: I / p,
                            y: -z / p
                        },
                        raw: k,
                        instance: o,
                        lockX: i.lockX,
                        lockY: i.lockY
                    };
                    (D = o.computeDirection(D)).angle = {
                        radian: s(180 - w),
                        degree: 180 - w
                    }, o.trigger("move", D), this.trigger("move " + o.id + ":move", D);
                } else this.processOnEnd(t);
            }, E.prototype.processOnEnd = function(t) {
                var i = this, e = i.options, o = i.manager.getIdentifier(t), n = i.nipples.get(o), s = i.manager.removeIdentifier(n.identifier);
                n && (e.dataOnly || n.hide(function() {
                    "dynamic" === e.mode && (n.trigger("removed", n), i.trigger("removed " + n.id + ":removed", n), i.manager.trigger("removed " + n.id + ":removed", n), n.destroy());
                }), clearInterval(i.pressureIntervals[n.identifier]), n.resetDirection(), n.trigger("end", n), i.trigger("end " + n.id + ":end", n), i.ids.indexOf(n.identifier) >= 0 && i.ids.splice(i.ids.indexOf(n.identifier), 1), i.actives.indexOf(n) >= 0 && i.actives.splice(i.actives.indexOf(n), 1), /(semi|static)/.test(e.mode) ? i.idles.push(n) : i.nipples.indexOf(n) >= 0 && i.nipples.splice(i.nipples.indexOf(n), 1), i.manager.unbindDocument(), /(semi|static)/.test(e.mode) && (i.manager.ids[s.id] = s.identifier));
            }, E.prototype.onDestroyed = function(t, i) {
                this.nipples.indexOf(i) >= 0 && this.nipples.splice(this.nipples.indexOf(i), 1), this.actives.indexOf(i) >= 0 && this.actives.splice(this.actives.indexOf(i), 1), this.idles.indexOf(i) >= 0 && this.idles.splice(this.idles.indexOf(i), 1), this.ids.indexOf(i.identifier) >= 0 && this.ids.splice(this.ids.indexOf(i.identifier), 1), this.manager.removeIdentifier(i.identifier), this.manager.unbindDocument();
            }, E.prototype.destroy = function() {
                for(var t in this.unbindEvt(this.options.zone, "start"), this.nipples.forEach(function(t) {
                    t.destroy();
                }), this.pressureIntervals)this.pressureIntervals.hasOwnProperty(t) && clearInterval(this.pressureIntervals[t]);
                this.trigger("destroyed", this.nipples), this.manager.unbindDocument(), this.off();
            };
            var I = E;
            function z(t) {
                var i = this;
                i.ids = {}, i.index = 0, i.collections = [], i.scroll = h(), i.config(t), i.prepareCollections();
                var e = function() {
                    var t;
                    i.collections.forEach(function(e) {
                        e.forEach(function(e) {
                            t = e.el.getBoundingClientRect(), e.position = {
                                x: i.scroll.x + t.left,
                                y: i.scroll.y + t.top
                            };
                        });
                    });
                };
                p(window, "resize", function() {
                    a(e);
                });
                var o = function() {
                    i.scroll = h();
                };
                return p(window, "scroll", function() {
                    a(o);
                }), i.collections;
            }
            z.prototype = new T, z.constructor = z, z.prototype.prepareCollections = function() {
                var t = this;
                t.collections.create = t.create.bind(t), t.collections.on = t.on.bind(t), t.collections.off = t.off.bind(t), t.collections.destroy = t.destroy.bind(t), t.collections.get = function(i) {
                    var e;
                    return t.collections.every(function(t) {
                        return !(e = t.get(i));
                    }), e;
                };
            }, z.prototype.create = function(t) {
                return this.createCollection(t);
            }, z.prototype.createCollection = function(t) {
                var i = new I(this, t);
                return this.bindCollection(i), this.collections.push(i), i;
            }, z.prototype.bindCollection = function(t) {
                var i, e = this, o = function(t, o) {
                    i = t.type + " " + o.id + ":" + t.type, e.trigger(i, o);
                };
                t.on("destroyed", e.onDestroyed.bind(e)), t.on("shown hidden rested dir plain", o), t.on("dir:up dir:right dir:down dir:left", o), t.on("plain:up plain:right plain:down plain:left", o);
            }, z.prototype.bindDocument = function() {
                this.binded || (this.bindEvt(document, "move").bindEvt(document, "end"), this.binded = !0);
            }, z.prototype.unbindDocument = function(t) {
                Object.keys(this.ids).length && !0 !== t || (this.unbindEvt(document, "move").unbindEvt(document, "end"), this.binded = !1);
            }, z.prototype.getIdentifier = function(t) {
                var i;
                return t ? void 0 === (i = void 0 === t.identifier ? t.pointerId : t.identifier) && (i = this.latest || 0) : i = this.index, void 0 === this.ids[i] && (this.ids[i] = this.index, this.index += 1), this.latest = i, this.ids[i];
            }, z.prototype.removeIdentifier = function(t) {
                var i = {};
                for(var e in this.ids)if (this.ids[e] === t) {
                    i.id = e, i.identifier = this.ids[e], delete this.ids[e];
                    break;
                }
                return i;
            }, z.prototype.onmove = function(t) {
                return this.onAny("move", t), !1;
            }, z.prototype.onend = function(t) {
                return this.onAny("end", t), !1;
            }, z.prototype.oncancel = function(t) {
                return this.onAny("end", t), !1;
            }, z.prototype.onAny = function(t, i) {
                var e, o = this, n = "processOn" + t.charAt(0).toUpperCase() + t.slice(1);
                i = l(i);
                var s = function(t, i, e) {
                    e.ids.indexOf(i) >= 0 && (e[n](t), t._found_ = !0);
                };
                return v(i, function(t) {
                    e = o.getIdentifier(t), v(o.collections, s.bind(null, t, e)), t._found_ || o.removeIdentifier(e);
                }), !1;
            }, z.prototype.destroy = function() {
                this.unbindDocument(!0), this.ids = {}, this.index = 0, this.collections.forEach(function(t) {
                    t.destroy();
                }), this.off();
            }, z.prototype.onDestroyed = function(t, i) {
                if (this.collections.indexOf(i) < 0) return !1;
                this.collections.splice(this.collections.indexOf(i), 1);
            };
            var D = new z;
            i.default = {
                create: function(t) {
                    return D.create(t);
                },
                factory: D
            };
        }
    ]).default;
});




var // These are not arbitrary, these are the values in web engines for left right and middle! do not change!
$8503208a4506f98c$var$MouseButton;
(function(MouseButton) {
    MouseButton[MouseButton["Left"] = 0] = "Left";
    MouseButton[MouseButton["Middle"] = 1] = "Middle";
    MouseButton[MouseButton["Right"] = 2] = "Right";
})($8503208a4506f98c$var$MouseButton || ($8503208a4506f98c$var$MouseButton = {}));
class $8503208a4506f98c$export$2d0dbd1b42bb8896 extends (0, $fc7b18e354612676$export$5d53140180d567a1) {
    getSystemName() {
        return "Input";
    }
    Initialize() {
        if (globalThis.IsMobile) {
            this._initializeVirtualJoystick();
            this._initializeVirtualJumpButton();
        }
        if (window.location.href.includes("uptogether")) window.addEventListener("beforeunload", (e)=>{
            e.preventDefault();
        });
        Game.EmitEvent("LoadEvent", {
            eventName: "InputReady"
        });
    }
    Update(__deltaTime, __deltaTimeMS, __currentTime) {
        if (this.mouseWheelScrolled) this.mouseWheelScrolled = false;
    }
    Cleanup() {}
    RightMousePressed() {
        return this._isMouseButtonPressed($8503208a4506f98c$var$MouseButton.Right);
    }
    MiddleMousePressed() {
        return this._isMouseButtonPressed($8503208a4506f98c$var$MouseButton.Middle);
    }
    Scrolled() {
        return this.mouseWheelScrolled;
    }
    IsKeyDown(key) {
        return !!this.keyState.get(key);
    }
    ToggleFullScreen() {
        if (!document.fullscreenElement) document.documentElement.requestFullscreen();
        else if (document.exitFullscreen) document.exitFullscreen();
    }
    LeftMousePressed() {
        return this._isMouseButtonPressed($8503208a4506f98c$var$MouseButton.Left);
    }
    // public JoystickIsForward(): boolean {
    //     return this.joystickForward;
    // }
    // public JoystickIsBack(): boolean {
    //     return this.joystickBack;
    // }
    // public JoystickIsLeft(): boolean {
    //     return this.joystickLeft;
    // }
    // public JoystickIsRight(): boolean {
    //     return this.joystickRight;
    // }
    VirtualJumpIsBeingPressed() {
        return this.virtualJumpButtonPressed;
    }
    GetMobileXDirection() {
        return this.mobileXDirection;
    }
    GetMobileZDirection() {
        return this.mobileZDirection;
    }
    GetMobileJoystickStrengthMovementMultiplier() {
        return this.mobileJoystickStrengthMovementMultiplier;
    }
    GetMobileRotationAngle() {
        return this.mobileRotationAngle;
    }
    _resetAllkeyStates() {
        this.keyState.forEach((_, key)=>{
            this.keyState.set(key, false);
        });
    }
    _updateKeyState(e) {
        const keyToMutate = e.code;
        // console.log(e.code);
        if (this.keysToPreventDefault.includes(keyToMutate)) e.preventDefault();
        // Check if the key code being pressed is escape
        if (keyToMutate === "Escape") {
            console.info("Pressed esc!");
            // If it is, emit the event to the game to handle
            if (globalThis.IsMobile === false) {
                Game.UI.HideAllScreens();
                Game.UI.CancelPointerLock();
                // console.info("Emitting gameplay stop 1!");
                Game.EmitEvent("SDK::GameplayStop");
                if (Game.Predictor.GetPredictedEntity() !== undefined) Game.Predictor.GetPredictedEntity().ShouldFireGameplayStartEventOnNextMovement = true;
            }
        }
        if (this.buttonsWithInteralCooldowns.includes(keyToMutate)) {
            if (this.internalCooldowns.has(keyToMutate)) {
                const lastTriggeredInput = this.internalCooldowns.get(keyToMutate);
                if (lastTriggeredInput && Date.now() - lastTriggeredInput < this.buttonInternalCooldownLengthMS) return;
            }
            if (keyToMutate === "KeyE") Game.UI.ShowScreen((0, $3c561a4876de7de6$export$b714373eb9ab036b).EmojiSelector);
            if (keyToMutate === "KeyX") {
                if (Game.Predictor.GetPredictedEntity() === undefined) return;
                if (Game.Predictor.GetPredictedEntity().runInProgress === false) return;
                Game.UI.ShowScreen((0, $3c561a4876de7de6$export$b714373eb9ab036b).RestartRunWarning);
            }
            if (keyToMutate === "KeyX") {
                if (Game.Predictor.GetPredictedEntity() === undefined) return;
                if (Game.Predictor.GetPredictedEntity().RunHasStarted() === false) return;
                Game.UI.ShowScreen((0, $3c561a4876de7de6$export$b714373eb9ab036b).RestartRunWarning);
            }
            if (globalThis.HostPortal !== (0, $9460eef1b2ed143f$export$f1f74d609516c940).Poki) {
                if (keyToMutate === "F10") this.ToggleFullScreen();
            }
            if (keyToMutate === "KeyM") Game.Audio.ToggleMusicMute();
            if (keyToMutate === "KeyF") Game.Audio.ToggleSFXMute();
            if (keyToMutate === "KeyP") Game.UI.ShowScreen((0, $3c561a4876de7de6$export$b714373eb9ab036b).ViewSettings);
            this.internalCooldowns.set(keyToMutate, Date.now());
        }
        this.keyState.set(keyToMutate, e.type === "keydown");
    }
    _isMouseButtonPressed(button) {
        return !!this.mouseState.get(button);
    }
    _initializeVirtualJumpButton() {
        const jumpButtonContainer = document.querySelector(".jump-button-container");
        if (jumpButtonContainer === null) throw new Error("jumpButtonContainer is null! Make sure this is assigned the right ID!");
        else {
            jumpButtonContainer.style.display = "flex";
            // TODO: Make sure mousedown event works with touch inputs and adjust to right event if not
            jumpButtonContainer.addEventListener("touchstart", ()=>{
                // console.log(`jump button pressed (touchstart event), current jump button state: ${this.virtualJumpButtonPressed}`);
                this.virtualJumpButtonPressed = true;
            });
            // TODO: Make sure mouseup event works with touch inputs and adjust to right event if not
            //Adding this event to the document itself in case player's held finger comes off the button when finger in lifted
            document.addEventListener("touchend", ()=>{
                // console.log(`jump button unpressed (touchend event), current jump button state: ${this.virtualJumpButtonPressed}`);
                if (this.virtualJumpButtonPressed) this.virtualJumpButtonPressed = false;
            });
        }
    }
    _initializeVirtualJoystick() {
        const joystickContainer = document.querySelector(".joystick-container-inner");
        // console.log("Initializing Joystick");
        if (joystickContainer === null) throw new Error("Joystick container is null! Please make sure you have assigned it the correct ID");
        else {
            // joystickContainer.style.display = "flex";
            // console.warn("on joystick create");
            const joystick = (0, (/*@__PURE__*/$parcel$interopDefault($bfbf1ecd718c53b2$exports))).create({
                zone: joystickContainer,
                mode: "static",
                size: this.joystickSize,
                dynamicPage: true,
                position: {
                    top: "50%",
                    left: "50%"
                },
                color: "#9f6ac0",
                restOpacity: 1.0
            });
            joystick.on("move", (event, data)=>{
                // console.log("joystick move");
                // console.log(event);
                // console.log(data.distance);
                // We want to get a multiplier from 0 to 1 to apply to the players movement speed.
                // That multiplier should be 0 when the joystick is in the center, and 1 when the joystick is at the edge.
                // The joystick has a value above (joystickSize) and a half size (joystickHalfSize). We want to
                // normalize the *distance* property between 0 (joystick at center) and 55 (the current joystick half size value) to 0 and 1.
                // We can do this by dividing the distance by the joystick half size value.
                this.mobileJoystickStrengthMovementMultiplier = data.distance / this.joystickHalfSize;
                // Calculate the movement vector using nipple.angle and nipple.force.
                const angle = data.angle.radian; // Angle in radians
                const force = data.force; // Magnitude of the joystick's movement
                // Calculate the movement vector
                const movementX = Math.cos(angle) * force;
                const movementZ = Math.sin(angle) * force;
                const rotationAngle = Math.atan2(-movementX, movementZ);
                this.mobileXDirection = movementX;
                this.mobileZDirection = movementZ;
                this.mobileRotationAngle = rotationAngle;
                this.MobilePlayerIsMoving = true;
            // Now, you can use the movementX and movementY values for your game movement logic.
            // For example, update the player's position.
            });
            joystick.on("end", ()=>{
                // console.log("joystick end");
                this.MobilePlayerIsMoving = false;
            });
        }
    }
    constructor(){
        super();
        this.keyState = new Map();
        this.mouseState = new Map();
        this.mouseWheelScrolled = false;
        this.virtualJumpButtonPressed = false;
        // private joystickForward: boolean = false;
        // private joystickBack: boolean = false;
        // private joystickLeft: boolean = false;
        // private joystickRight: boolean = false;
        this.mobileXDirection = 0;
        this.mobileZDirection = 0;
        this.mobileJoystickStrengthMovementMultiplier = 0;
        this.mobileRotationAngle = 0;
        this.MobilePlayerIsMoving = false;
        this.joystickSize = 110;
        this.joystickHalfSize = this.joystickSize / 2;
        this.forwardJoystickTolerance = 30;
        this.rightJoystickTolerance = 30;
        this.backJoystickTolerance = -30;
        this.leftJoystickTolerance = -30;
        this.keysToPreventDefault = [
            "Space",
            "ControlLeft",
            "ControlRight",
            "ShiftLeft",
            "ShiftRight",
            "AltLeft",
            "AltRight",
            "MetaLeft",
            "MetaRight",
            "F10",
            "ArrowLeft",
            "ArrowRight",
            "ArrowUp",
            "ArrowDown"
        ];
        this.buttonInternalCooldownLengthMS = 500;
        this.buttonsWithInteralCooldowns = [
            "KeyF",
            "KeyM",
            "F10",
            "KeyC",
            "KeyE",
            "KeyT",
            "KeyX",
            "KeyP"
        ];
        this.internalCooldowns = new Map();
        // disallows right click menu on the game screen
        document.addEventListener("contextmenu", (event)=>event.preventDefault());
        // listen for keystrokes, update keyboard state accordingly
        document.addEventListener("keydown", this._updateKeyState.bind(this));
        document.addEventListener("keyup", this._updateKeyState.bind(this));
        // listen for mouse clicks, update mouse state accordingly
        document.addEventListener("mousedown", (event)=>this.mouseState.set(event.button, true));
        document.addEventListener("mouseup", (event)=>this.mouseState.set(event.button, false));
        document.addEventListener("wheel", (event)=>{
            event.preventDefault();
            this.mouseWheelScrolled = true;
        }, {
            passive: false
        });
        window.onblur = ()=>{
            this._resetAllkeyStates();
        };
    }
}





var $073149ffa9ea9788$exports = {};
"use strict";
Object.defineProperty($073149ffa9ea9788$exports, "__esModule", {
    value: true
});
$073149ffa9ea9788$exports.WebSocketClientAdapter = void 0;

var $4f5a3f4575b75e1c$exports = {};
"use strict";
var $4f5a3f4575b75e1c$var$__createBinding = $4f5a3f4575b75e1c$exports && $4f5a3f4575b75e1c$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $4f5a3f4575b75e1c$var$__exportStar = $4f5a3f4575b75e1c$exports && $4f5a3f4575b75e1c$exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $4f5a3f4575b75e1c$var$__createBinding(exports1, m, p);
};
Object.defineProperty($4f5a3f4575b75e1c$exports, "__esModule", {
    value: true
});

$4f5a3f4575b75e1c$var$__exportStar((parcelRequire("dKAmY")), $4f5a3f4575b75e1c$exports);

$4f5a3f4575b75e1c$var$__exportStar((parcelRequire("4qPfg")), $4f5a3f4575b75e1c$exports);


class $073149ffa9ea9788$var$WebSocketClientAdapter {
    flush() {
        if (!this.socket) {
            console.log("CANCELED, no socket");
            return;
        }
        if (this.socket.readyState !== 1) {
            console.log("socket not open");
            return;
        }
        const buffer = this.network.createOutboundBuffer($4f5a3f4575b75e1c$exports.DataViewWriter);
        this.socket.send(buffer);
    }
    setupWebsocket(socket) {
        this.socket = socket;
        socket.onmessage = (event)=>{
            if (event.data instanceof ArrayBuffer) {
                const dr = new $4f5a3f4575b75e1c$exports.DataViewReader(event.data, 0);
                this.network.readSnapshot(dr);
            }
        };
        socket.onclose = (event)=>{
            this.network.onDisconnect(event.reason, event);
        };
        socket.onerror = (event)=>{
            this.network.onSocketError(event);
        };
    }
    connect(wsUrl, handshake) {
        return new Promise((resolve, reject)=>{
            const socket = new WebSocket(wsUrl);
            socket.binaryType = "arraybuffer";
            socket.onopen = (event)=>{
                socket.send(this.network.createHandshakeBuffer(handshake, $4f5a3f4575b75e1c$exports.DataViewWriter));
            };
            socket.onclose = function(event) {
                reject(event);
            };
            socket.onerror = function(event) {
                reject(event);
            };
            socket.onmessage = (event)=>{
                // initially the only thing we care to read is a response to our handshake
                // we don't even setup the parser for the rest of what a nengi client can receive
                const dr = new $4f5a3f4575b75e1c$exports.DataViewReader(event.data, 0);
                const type = dr.readUInt8(); // type of message
                if (type === $39f39c7ce64f85e7$exports.BinarySection.EngineMessages) {
                    const count = dr.readUInt8(); // quantity of engine messages
                    const connectionResponseByte = dr.readUInt8();
                    if (connectionResponseByte === $39f39c7ce64f85e7$exports.EngineMessage.ConnectionAccepted) {
                        // setup listeners for normal game data
                        this.setupWebsocket(socket);
                        resolve("accepted");
                    }
                    if (connectionResponseByte === $39f39c7ce64f85e7$exports.EngineMessage.ConnectionDenied) {
                        const denyReason = JSON.parse(dr.readString());
                        reject(denyReason);
                    }
                }
            };
        });
    }
    constructor(network, config){
        this.socket = null;
        this.network = network;
        this.context = this.network.client.context;
    }
}
$073149ffa9ea9788$exports.WebSocketClientAdapter = $073149ffa9ea9788$var$WebSocketClientAdapter;


/*************************************************/ /*                                               */ /*  Misc / General                               */ /*                                               */ /*************************************************/ var $de4f7960cd805115$export$cd1c2f7f06852a53;
(function(ServerConnectionErrorReasons) {
    ServerConnectionErrorReasons["GameClientOutOfDate"] = "GameClientOutOfDate";
    ServerConnectionErrorReasons["InvalidConnectionToken"] = "InvalidConnectionToken";
    ServerConnectionErrorReasons["UnexpectedConnectionError"] = "UnexpectedConnectionError";
    ServerConnectionErrorReasons["PlayerAlreadyLoggedIn"] = "PlayerAlreadyLoggedIn";
})($de4f7960cd805115$export$cd1c2f7f06852a53 || ($de4f7960cd805115$export$cd1c2f7f06852a53 = {}));
var $de4f7960cd805115$export$8436e53e45ffe15b;
(function(UserType) {
    UserType[UserType["Anonymous"] = 0] = "Anonymous";
})($de4f7960cd805115$export$8436e53e45ffe15b || ($de4f7960cd805115$export$8436e53e45ffe15b = {}));




class $a0dc081d2781de33$export$30df2395274cb2d1 extends Error {
    constructor(errorMessage){
        super("AuthExpiredError");
        this.message = errorMessage;
    }
}
class $a0dc081d2781de33$export$8d55defbd449b180 extends Error {
    constructor(errorMessage){
        super("UncatchableAlmostOOMError");
        this.message = errorMessage;
    }
}
class $a0dc081d2781de33$export$cde8491b20a04fb4 extends Error {
    constructor(errorMessage){
        super("UnknownAPIError");
        this.message = errorMessage;
    }
}
class $a0dc081d2781de33$export$7333e7db5e5d49a extends Error {
    constructor(errorMessage){
        super("UserNotFoundError");
        this.message = errorMessage;
    }
}
class $a0dc081d2781de33$export$d43b4070434a7c5e extends Error {
    constructor(errorMessage){
        super("AllServersFullError");
        this.message = errorMessage;
    }
}
class $a0dc081d2781de33$export$c7df658ddd676e46 extends Error {
    constructor(errorMessage){
        super("NoServersOnlineError");
        this.message = errorMessage;
    }
}



"use strict";
function $3c09cdaada4cd00d$export$2e2bcd8739ae039(fn, thisArg) {
    return function wrap() {
        return fn.apply(thisArg, arguments);
    };
}


"use strict";
// utils is a library of generic helper functions non-specific to axios
const { toString: $2c30869926b6e1e7$var$toString } = Object.prototype;
const { getPrototypeOf: $2c30869926b6e1e7$var$getPrototypeOf } = Object;
const $2c30869926b6e1e7$var$kindOf = ((cache)=>(thing)=>{
        const str = $2c30869926b6e1e7$var$toString.call(thing);
        return cache[str] || (cache[str] = str.slice(8, -1).toLowerCase());
    })(Object.create(null));
const $2c30869926b6e1e7$var$kindOfTest = (type)=>{
    type = type.toLowerCase();
    return (thing)=>$2c30869926b6e1e7$var$kindOf(thing) === type;
};
const $2c30869926b6e1e7$var$typeOfTest = (type)=>(thing)=>typeof thing === type;
/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 *
 * @returns {boolean} True if value is an Array, otherwise false
 */ const { isArray: $2c30869926b6e1e7$var$isArray } = Array;
/**
 * Determine if a value is undefined
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if the value is undefined, otherwise false
 */ const $2c30869926b6e1e7$var$isUndefined = $2c30869926b6e1e7$var$typeOfTest("undefined");
/**
 * Determine if a value is a Buffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Buffer, otherwise false
 */ function $2c30869926b6e1e7$var$isBuffer(val) {
    return val !== null && !$2c30869926b6e1e7$var$isUndefined(val) && val.constructor !== null && !$2c30869926b6e1e7$var$isUndefined(val.constructor) && $2c30869926b6e1e7$var$isFunction(val.constructor.isBuffer) && val.constructor.isBuffer(val);
}
/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */ const $2c30869926b6e1e7$var$isArrayBuffer = $2c30869926b6e1e7$var$kindOfTest("ArrayBuffer");
/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */ function $2c30869926b6e1e7$var$isArrayBufferView(val) {
    let result;
    if (typeof ArrayBuffer !== "undefined" && ArrayBuffer.isView) result = ArrayBuffer.isView(val);
    else result = val && val.buffer && $2c30869926b6e1e7$var$isArrayBuffer(val.buffer);
    return result;
}
/**
 * Determine if a value is a String
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a String, otherwise false
 */ const $2c30869926b6e1e7$var$isString = $2c30869926b6e1e7$var$typeOfTest("string");
/**
 * Determine if a value is a Function
 *
 * @param {*} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */ const $2c30869926b6e1e7$var$isFunction = $2c30869926b6e1e7$var$typeOfTest("function");
/**
 * Determine if a value is a Number
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Number, otherwise false
 */ const $2c30869926b6e1e7$var$isNumber = $2c30869926b6e1e7$var$typeOfTest("number");
/**
 * Determine if a value is an Object
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an Object, otherwise false
 */ const $2c30869926b6e1e7$var$isObject = (thing)=>thing !== null && typeof thing === "object";
/**
 * Determine if a value is a Boolean
 *
 * @param {*} thing The value to test
 * @returns {boolean} True if value is a Boolean, otherwise false
 */ const $2c30869926b6e1e7$var$isBoolean = (thing)=>thing === true || thing === false;
/**
 * Determine if a value is a plain Object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a plain Object, otherwise false
 */ const $2c30869926b6e1e7$var$isPlainObject = (val)=>{
    if ($2c30869926b6e1e7$var$kindOf(val) !== "object") return false;
    const prototype = $2c30869926b6e1e7$var$getPrototypeOf(val);
    return (prototype === null || prototype === Object.prototype || Object.getPrototypeOf(prototype) === null) && !(Symbol.toStringTag in val) && !(Symbol.iterator in val);
};
/**
 * Determine if a value is a Date
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Date, otherwise false
 */ const $2c30869926b6e1e7$var$isDate = $2c30869926b6e1e7$var$kindOfTest("Date");
/**
 * Determine if a value is a File
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */ const $2c30869926b6e1e7$var$isFile = $2c30869926b6e1e7$var$kindOfTest("File");
/**
 * Determine if a value is a Blob
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Blob, otherwise false
 */ const $2c30869926b6e1e7$var$isBlob = $2c30869926b6e1e7$var$kindOfTest("Blob");
/**
 * Determine if a value is a FileList
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */ const $2c30869926b6e1e7$var$isFileList = $2c30869926b6e1e7$var$kindOfTest("FileList");
/**
 * Determine if a value is a Stream
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Stream, otherwise false
 */ const $2c30869926b6e1e7$var$isStream = (val)=>$2c30869926b6e1e7$var$isObject(val) && $2c30869926b6e1e7$var$isFunction(val.pipe);
/**
 * Determine if a value is a FormData
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an FormData, otherwise false
 */ const $2c30869926b6e1e7$var$isFormData = (thing)=>{
    let kind;
    return thing && (typeof FormData === "function" && thing instanceof FormData || $2c30869926b6e1e7$var$isFunction(thing.append) && ((kind = $2c30869926b6e1e7$var$kindOf(thing)) === "formdata" || // detect form-data instance
    kind === "object" && $2c30869926b6e1e7$var$isFunction(thing.toString) && thing.toString() === "[object FormData]"));
};
/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */ const $2c30869926b6e1e7$var$isURLSearchParams = $2c30869926b6e1e7$var$kindOfTest("URLSearchParams");
/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 *
 * @returns {String} The String freed of excess whitespace
 */ const $2c30869926b6e1e7$var$trim = (str)=>str.trim ? str.trim() : str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 *
 * @param {Boolean} [allOwnKeys = false]
 * @returns {any}
 */ function $2c30869926b6e1e7$var$forEach(obj, fn, { allOwnKeys: allOwnKeys = false } = {}) {
    // Don't bother if no value provided
    if (obj === null || typeof obj === "undefined") return;
    let i;
    let l;
    // Force an array if not already something iterable
    if (typeof obj !== "object") /*eslint no-param-reassign:0*/ obj = [
        obj
    ];
    if ($2c30869926b6e1e7$var$isArray(obj)) // Iterate over array values
    for(i = 0, l = obj.length; i < l; i++)fn.call(null, obj[i], i, obj);
    else {
        // Iterate over object keys
        const keys = allOwnKeys ? Object.getOwnPropertyNames(obj) : Object.keys(obj);
        const len = keys.length;
        let key;
        for(i = 0; i < len; i++){
            key = keys[i];
            fn.call(null, obj[key], key, obj);
        }
    }
}
function $2c30869926b6e1e7$var$findKey(obj, key) {
    key = key.toLowerCase();
    const keys = Object.keys(obj);
    let i = keys.length;
    let _key;
    while(i-- > 0){
        _key = keys[i];
        if (key === _key.toLowerCase()) return _key;
    }
    return null;
}
const $2c30869926b6e1e7$var$_global = (()=>{
    /*eslint no-undef:0*/ if (typeof globalThis !== "undefined") return globalThis;
    return typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : $parcel$global;
})();
const $2c30869926b6e1e7$var$isContextDefined = (context)=>!$2c30869926b6e1e7$var$isUndefined(context) && context !== $2c30869926b6e1e7$var$_global;
/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 *
 * @returns {Object} Result of all merge properties
 */ function $2c30869926b6e1e7$var$merge() {
    const { caseless: caseless } = $2c30869926b6e1e7$var$isContextDefined(this) && this || {};
    const result = {};
    const assignValue = (val, key)=>{
        const targetKey = caseless && $2c30869926b6e1e7$var$findKey(result, key) || key;
        if ($2c30869926b6e1e7$var$isPlainObject(result[targetKey]) && $2c30869926b6e1e7$var$isPlainObject(val)) result[targetKey] = $2c30869926b6e1e7$var$merge(result[targetKey], val);
        else if ($2c30869926b6e1e7$var$isPlainObject(val)) result[targetKey] = $2c30869926b6e1e7$var$merge({}, val);
        else if ($2c30869926b6e1e7$var$isArray(val)) result[targetKey] = val.slice();
        else result[targetKey] = val;
    };
    for(let i = 0, l = arguments.length; i < l; i++)arguments[i] && $2c30869926b6e1e7$var$forEach(arguments[i], assignValue);
    return result;
}
/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 *
 * @param {Boolean} [allOwnKeys]
 * @returns {Object} The resulting value of object a
 */ const $2c30869926b6e1e7$var$extend = (a, b, thisArg, { allOwnKeys: allOwnKeys } = {})=>{
    $2c30869926b6e1e7$var$forEach(b, (val, key)=>{
        if (thisArg && $2c30869926b6e1e7$var$isFunction(val)) a[key] = (0, $3c09cdaada4cd00d$export$2e2bcd8739ae039)(val, thisArg);
        else a[key] = val;
    }, {
        allOwnKeys: allOwnKeys
    });
    return a;
};
/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 *
 * @returns {string} content value without BOM
 */ const $2c30869926b6e1e7$var$stripBOM = (content)=>{
    if (content.charCodeAt(0) === 0xFEFF) content = content.slice(1);
    return content;
};
/**
 * Inherit the prototype methods from one constructor into another
 * @param {function} constructor
 * @param {function} superConstructor
 * @param {object} [props]
 * @param {object} [descriptors]
 *
 * @returns {void}
 */ const $2c30869926b6e1e7$var$inherits = (constructor, superConstructor, props, descriptors)=>{
    constructor.prototype = Object.create(superConstructor.prototype, descriptors);
    constructor.prototype.constructor = constructor;
    Object.defineProperty(constructor, "super", {
        value: superConstructor.prototype
    });
    props && Object.assign(constructor.prototype, props);
};
/**
 * Resolve object with deep prototype chain to a flat object
 * @param {Object} sourceObj source object
 * @param {Object} [destObj]
 * @param {Function|Boolean} [filter]
 * @param {Function} [propFilter]
 *
 * @returns {Object}
 */ const $2c30869926b6e1e7$var$toFlatObject = (sourceObj, destObj, filter, propFilter)=>{
    let props;
    let i;
    let prop;
    const merged = {};
    destObj = destObj || {};
    // eslint-disable-next-line no-eq-null,eqeqeq
    if (sourceObj == null) return destObj;
    do {
        props = Object.getOwnPropertyNames(sourceObj);
        i = props.length;
        while(i-- > 0){
            prop = props[i];
            if ((!propFilter || propFilter(prop, sourceObj, destObj)) && !merged[prop]) {
                destObj[prop] = sourceObj[prop];
                merged[prop] = true;
            }
        }
        sourceObj = filter !== false && $2c30869926b6e1e7$var$getPrototypeOf(sourceObj);
    }while (sourceObj && (!filter || filter(sourceObj, destObj)) && sourceObj !== Object.prototype);
    return destObj;
};
/**
 * Determines whether a string ends with the characters of a specified string
 *
 * @param {String} str
 * @param {String} searchString
 * @param {Number} [position= 0]
 *
 * @returns {boolean}
 */ const $2c30869926b6e1e7$var$endsWith = (str, searchString, position)=>{
    str = String(str);
    if (position === undefined || position > str.length) position = str.length;
    position -= searchString.length;
    const lastIndex = str.indexOf(searchString, position);
    return lastIndex !== -1 && lastIndex === position;
};
/**
 * Returns new array from array like object or null if failed
 *
 * @param {*} [thing]
 *
 * @returns {?Array}
 */ const $2c30869926b6e1e7$var$toArray = (thing)=>{
    if (!thing) return null;
    if ($2c30869926b6e1e7$var$isArray(thing)) return thing;
    let i = thing.length;
    if (!$2c30869926b6e1e7$var$isNumber(i)) return null;
    const arr = new Array(i);
    while(i-- > 0)arr[i] = thing[i];
    return arr;
};
/**
 * Checking if the Uint8Array exists and if it does, it returns a function that checks if the
 * thing passed in is an instance of Uint8Array
 *
 * @param {TypedArray}
 *
 * @returns {Array}
 */ // eslint-disable-next-line func-names
const $2c30869926b6e1e7$var$isTypedArray = ((TypedArray)=>{
    // eslint-disable-next-line func-names
    return (thing)=>{
        return TypedArray && thing instanceof TypedArray;
    };
})(typeof Uint8Array !== "undefined" && $2c30869926b6e1e7$var$getPrototypeOf(Uint8Array));
/**
 * For each entry in the object, call the function with the key and value.
 *
 * @param {Object<any, any>} obj - The object to iterate over.
 * @param {Function} fn - The function to call for each entry.
 *
 * @returns {void}
 */ const $2c30869926b6e1e7$var$forEachEntry = (obj, fn)=>{
    const generator = obj && obj[Symbol.iterator];
    const iterator = generator.call(obj);
    let result;
    while((result = iterator.next()) && !result.done){
        const pair = result.value;
        fn.call(obj, pair[0], pair[1]);
    }
};
/**
 * It takes a regular expression and a string, and returns an array of all the matches
 *
 * @param {string} regExp - The regular expression to match against.
 * @param {string} str - The string to search.
 *
 * @returns {Array<boolean>}
 */ const $2c30869926b6e1e7$var$matchAll = (regExp, str)=>{
    let matches;
    const arr = [];
    while((matches = regExp.exec(str)) !== null)arr.push(matches);
    return arr;
};
/* Checking if the kindOfTest function returns true when passed an HTMLFormElement. */ const $2c30869926b6e1e7$var$isHTMLForm = $2c30869926b6e1e7$var$kindOfTest("HTMLFormElement");
const $2c30869926b6e1e7$var$toCamelCase = (str)=>{
    return str.toLowerCase().replace(/[-_\s]([a-z\d])(\w*)/g, function replacer(m, p1, p2) {
        return p1.toUpperCase() + p2;
    });
};
/* Creating a function that will check if an object has a property. */ const $2c30869926b6e1e7$var$hasOwnProperty = (({ hasOwnProperty: hasOwnProperty })=>(obj, prop)=>hasOwnProperty.call(obj, prop))(Object.prototype);
/**
 * Determine if a value is a RegExp object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a RegExp object, otherwise false
 */ const $2c30869926b6e1e7$var$isRegExp = $2c30869926b6e1e7$var$kindOfTest("RegExp");
const $2c30869926b6e1e7$var$reduceDescriptors = (obj, reducer)=>{
    const descriptors = Object.getOwnPropertyDescriptors(obj);
    const reducedDescriptors = {};
    $2c30869926b6e1e7$var$forEach(descriptors, (descriptor, name)=>{
        let ret;
        if ((ret = reducer(descriptor, name, obj)) !== false) reducedDescriptors[name] = ret || descriptor;
    });
    Object.defineProperties(obj, reducedDescriptors);
};
/**
 * Makes all methods read-only
 * @param {Object} obj
 */ const $2c30869926b6e1e7$var$freezeMethods = (obj)=>{
    $2c30869926b6e1e7$var$reduceDescriptors(obj, (descriptor, name)=>{
        // skip restricted props in strict mode
        if ($2c30869926b6e1e7$var$isFunction(obj) && [
            "arguments",
            "caller",
            "callee"
        ].indexOf(name) !== -1) return false;
        const value = obj[name];
        if (!$2c30869926b6e1e7$var$isFunction(value)) return;
        descriptor.enumerable = false;
        if ("writable" in descriptor) {
            descriptor.writable = false;
            return;
        }
        if (!descriptor.set) descriptor.set = ()=>{
            throw Error("Can not rewrite read-only method '" + name + "'");
        };
    });
};
const $2c30869926b6e1e7$var$toObjectSet = (arrayOrString, delimiter)=>{
    const obj = {};
    const define = (arr)=>{
        arr.forEach((value)=>{
            obj[value] = true;
        });
    };
    $2c30869926b6e1e7$var$isArray(arrayOrString) ? define(arrayOrString) : define(String(arrayOrString).split(delimiter));
    return obj;
};
const $2c30869926b6e1e7$var$noop = ()=>{};
const $2c30869926b6e1e7$var$toFiniteNumber = (value, defaultValue)=>{
    value = +value;
    return Number.isFinite(value) ? value : defaultValue;
};
const $2c30869926b6e1e7$var$ALPHA = "abcdefghijklmnopqrstuvwxyz";
const $2c30869926b6e1e7$var$DIGIT = "0123456789";
const $2c30869926b6e1e7$var$ALPHABET = {
    DIGIT: $2c30869926b6e1e7$var$DIGIT,
    ALPHA: $2c30869926b6e1e7$var$ALPHA,
    ALPHA_DIGIT: $2c30869926b6e1e7$var$ALPHA + $2c30869926b6e1e7$var$ALPHA.toUpperCase() + $2c30869926b6e1e7$var$DIGIT
};
const $2c30869926b6e1e7$var$generateString = (size = 16, alphabet = $2c30869926b6e1e7$var$ALPHABET.ALPHA_DIGIT)=>{
    let str = "";
    const { length: length } = alphabet;
    while(size--)str += alphabet[Math.random() * length | 0];
    return str;
};
/**
 * If the thing is a FormData object, return true, otherwise return false.
 *
 * @param {unknown} thing - The thing to check.
 *
 * @returns {boolean}
 */ function $2c30869926b6e1e7$var$isSpecCompliantForm(thing) {
    return !!(thing && $2c30869926b6e1e7$var$isFunction(thing.append) && thing[Symbol.toStringTag] === "FormData" && thing[Symbol.iterator]);
}
const $2c30869926b6e1e7$var$toJSONObject = (obj)=>{
    const stack = new Array(10);
    const visit = (source, i)=>{
        if ($2c30869926b6e1e7$var$isObject(source)) {
            if (stack.indexOf(source) >= 0) return;
            if (!("toJSON" in source)) {
                stack[i] = source;
                const target = $2c30869926b6e1e7$var$isArray(source) ? [] : {};
                $2c30869926b6e1e7$var$forEach(source, (value, key)=>{
                    const reducedValue = visit(value, i + 1);
                    !$2c30869926b6e1e7$var$isUndefined(reducedValue) && (target[key] = reducedValue);
                });
                stack[i] = undefined;
                return target;
            }
        }
        return source;
    };
    return visit(obj, 0);
};
const $2c30869926b6e1e7$var$isAsyncFn = $2c30869926b6e1e7$var$kindOfTest("AsyncFunction");
const $2c30869926b6e1e7$var$isThenable = (thing)=>thing && ($2c30869926b6e1e7$var$isObject(thing) || $2c30869926b6e1e7$var$isFunction(thing)) && $2c30869926b6e1e7$var$isFunction(thing.then) && $2c30869926b6e1e7$var$isFunction(thing.catch);
var $2c30869926b6e1e7$export$2e2bcd8739ae039 = {
    isArray: $2c30869926b6e1e7$var$isArray,
    isArrayBuffer: $2c30869926b6e1e7$var$isArrayBuffer,
    isBuffer: $2c30869926b6e1e7$var$isBuffer,
    isFormData: $2c30869926b6e1e7$var$isFormData,
    isArrayBufferView: $2c30869926b6e1e7$var$isArrayBufferView,
    isString: $2c30869926b6e1e7$var$isString,
    isNumber: $2c30869926b6e1e7$var$isNumber,
    isBoolean: $2c30869926b6e1e7$var$isBoolean,
    isObject: $2c30869926b6e1e7$var$isObject,
    isPlainObject: $2c30869926b6e1e7$var$isPlainObject,
    isUndefined: $2c30869926b6e1e7$var$isUndefined,
    isDate: $2c30869926b6e1e7$var$isDate,
    isFile: $2c30869926b6e1e7$var$isFile,
    isBlob: $2c30869926b6e1e7$var$isBlob,
    isRegExp: $2c30869926b6e1e7$var$isRegExp,
    isFunction: $2c30869926b6e1e7$var$isFunction,
    isStream: $2c30869926b6e1e7$var$isStream,
    isURLSearchParams: $2c30869926b6e1e7$var$isURLSearchParams,
    isTypedArray: $2c30869926b6e1e7$var$isTypedArray,
    isFileList: $2c30869926b6e1e7$var$isFileList,
    forEach: $2c30869926b6e1e7$var$forEach,
    merge: $2c30869926b6e1e7$var$merge,
    extend: $2c30869926b6e1e7$var$extend,
    trim: $2c30869926b6e1e7$var$trim,
    stripBOM: $2c30869926b6e1e7$var$stripBOM,
    inherits: $2c30869926b6e1e7$var$inherits,
    toFlatObject: $2c30869926b6e1e7$var$toFlatObject,
    kindOf: $2c30869926b6e1e7$var$kindOf,
    kindOfTest: $2c30869926b6e1e7$var$kindOfTest,
    endsWith: $2c30869926b6e1e7$var$endsWith,
    toArray: $2c30869926b6e1e7$var$toArray,
    forEachEntry: $2c30869926b6e1e7$var$forEachEntry,
    matchAll: $2c30869926b6e1e7$var$matchAll,
    isHTMLForm: $2c30869926b6e1e7$var$isHTMLForm,
    hasOwnProperty: $2c30869926b6e1e7$var$hasOwnProperty,
    hasOwnProp: $2c30869926b6e1e7$var$hasOwnProperty,
    reduceDescriptors: $2c30869926b6e1e7$var$reduceDescriptors,
    freezeMethods: $2c30869926b6e1e7$var$freezeMethods,
    toObjectSet: $2c30869926b6e1e7$var$toObjectSet,
    toCamelCase: $2c30869926b6e1e7$var$toCamelCase,
    noop: $2c30869926b6e1e7$var$noop,
    toFiniteNumber: $2c30869926b6e1e7$var$toFiniteNumber,
    findKey: $2c30869926b6e1e7$var$findKey,
    global: $2c30869926b6e1e7$var$_global,
    isContextDefined: $2c30869926b6e1e7$var$isContextDefined,
    ALPHABET: $2c30869926b6e1e7$var$ALPHABET,
    generateString: $2c30869926b6e1e7$var$generateString,
    isSpecCompliantForm: $2c30869926b6e1e7$var$isSpecCompliantForm,
    toJSONObject: $2c30869926b6e1e7$var$toJSONObject,
    isAsyncFn: $2c30869926b6e1e7$var$isAsyncFn,
    isThenable: $2c30869926b6e1e7$var$isThenable
};







"use strict";
/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [config] The config.
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 *
 * @returns {Error} The created error.
 */ function $158812891e7ba01a$var$AxiosError(message, code, config, request, response) {
    Error.call(this);
    if (Error.captureStackTrace) Error.captureStackTrace(this, this.constructor);
    else this.stack = new Error().stack;
    this.message = message;
    this.name = "AxiosError";
    code && (this.code = code);
    config && (this.config = config);
    request && (this.request = request);
    response && (this.response = response);
}
(0, $2c30869926b6e1e7$export$2e2bcd8739ae039).inherits($158812891e7ba01a$var$AxiosError, Error, {
    toJSON: function toJSON() {
        return {
            // Standard
            message: this.message,
            name: this.name,
            // Microsoft
            description: this.description,
            number: this.number,
            // Mozilla
            fileName: this.fileName,
            lineNumber: this.lineNumber,
            columnNumber: this.columnNumber,
            stack: this.stack,
            // Axios
            config: (0, $2c30869926b6e1e7$export$2e2bcd8739ae039).toJSONObject(this.config),
            code: this.code,
            status: this.response && this.response.status ? this.response.status : null
        };
    }
});
const $158812891e7ba01a$var$prototype = $158812891e7ba01a$var$AxiosError.prototype;
const $158812891e7ba01a$var$descriptors = {};
[
    "ERR_BAD_OPTION_VALUE",
    "ERR_BAD_OPTION",
    "ECONNABORTED",
    "ETIMEDOUT",
    "ERR_NETWORK",
    "ERR_FR_TOO_MANY_REDIRECTS",
    "ERR_DEPRECATED",
    "ERR_BAD_RESPONSE",
    "ERR_BAD_REQUEST",
    "ERR_CANCELED",
    "ERR_NOT_SUPPORT",
    "ERR_INVALID_URL"
].forEach((code)=>{
    $158812891e7ba01a$var$descriptors[code] = {
        value: code
    };
});
Object.defineProperties($158812891e7ba01a$var$AxiosError, $158812891e7ba01a$var$descriptors);
Object.defineProperty($158812891e7ba01a$var$prototype, "isAxiosError", {
    value: true
});
// eslint-disable-next-line func-names
$158812891e7ba01a$var$AxiosError.from = (error, code, config, request, response, customProps)=>{
    const axiosError = Object.create($158812891e7ba01a$var$prototype);
    (0, $2c30869926b6e1e7$export$2e2bcd8739ae039).toFlatObject(error, axiosError, function filter(obj) {
        return obj !== Error.prototype;
    }, (prop)=>{
        return prop !== "isAxiosError";
    });
    $158812891e7ba01a$var$AxiosError.call(axiosError, error.message, code, config, request, response);
    axiosError.cause = error;
    axiosError.name = error.name;
    customProps && Object.assign(axiosError, customProps);
    return axiosError;
};
var $158812891e7ba01a$export$2e2bcd8739ae039 = $158812891e7ba01a$var$AxiosError;


// eslint-disable-next-line strict
var $78e1ecbc56e8edf7$export$2e2bcd8739ae039 = null;



var $c0lTq = parcelRequire("c0lTq");
var $268c3eee7f562394$require$Buffer = $c0lTq.Buffer;
"use strict";
/**
 * Determines if the given thing is a array or js object.
 *
 * @param {string} thing - The object or array to be visited.
 *
 * @returns {boolean}
 */ function $268c3eee7f562394$var$isVisitable(thing) {
    return (0, $2c30869926b6e1e7$export$2e2bcd8739ae039).isPlainObject(thing) || (0, $2c30869926b6e1e7$export$2e2bcd8739ae039).isArray(thing);
}
/**
 * It removes the brackets from the end of a string
 *
 * @param {string} key - The key of the parameter.
 *
 * @returns {string} the key without the brackets.
 */ function $268c3eee7f562394$var$removeBrackets(key) {
    return (0, $2c30869926b6e1e7$export$2e2bcd8739ae039).endsWith(key, "[]") ? key.slice(0, -2) : key;
}
/**
 * It takes a path, a key, and a boolean, and returns a string
 *
 * @param {string} path - The path to the current key.
 * @param {string} key - The key of the current object being iterated over.
 * @param {string} dots - If true, the key will be rendered with dots instead of brackets.
 *
 * @returns {string} The path to the current key.
 */ function $268c3eee7f562394$var$renderKey(path, key, dots) {
    if (!path) return key;
    return path.concat(key).map(function each(token, i) {
        // eslint-disable-next-line no-param-reassign
        token = $268c3eee7f562394$var$removeBrackets(token);
        return !dots && i ? "[" + token + "]" : token;
    }).join(dots ? "." : "");
}
/**
 * If the array is an array and none of its elements are visitable, then it's a flat array.
 *
 * @param {Array<any>} arr - The array to check
 *
 * @returns {boolean}
 */ function $268c3eee7f562394$var$isFlatArray(arr) {
    return (0, $2c30869926b6e1e7$export$2e2bcd8739ae039).isArray(arr) && !arr.some($268c3eee7f562394$var$isVisitable);
}
const $268c3eee7f562394$var$predicates = (0, $2c30869926b6e1e7$export$2e2bcd8739ae039).toFlatObject((0, $2c30869926b6e1e7$export$2e2bcd8739ae039), {}, null, function filter(prop) {
    return /^is[A-Z]/.test(prop);
});
/**
 * Convert a data object to FormData
 *
 * @param {Object} obj
 * @param {?Object} [formData]
 * @param {?Object} [options]
 * @param {Function} [options.visitor]
 * @param {Boolean} [options.metaTokens = true]
 * @param {Boolean} [options.dots = false]
 * @param {?Boolean} [options.indexes = false]
 *
 * @returns {Object}
 **/ /**
 * It converts an object into a FormData object
 *
 * @param {Object<any, any>} obj - The object to convert to form data.
 * @param {string} formData - The FormData object to append to.
 * @param {Object<string, any>} options
 *
 * @returns
 */ function $268c3eee7f562394$var$toFormData(obj, formData, options) {
    if (!(0, $2c30869926b6e1e7$export$2e2bcd8739ae039).isObject(obj)) throw new TypeError("target must be an object");
    // eslint-disable-next-line no-param-reassign
    formData = formData || new ((0, $78e1ecbc56e8edf7$export$2e2bcd8739ae039) || FormData)();
    // eslint-disable-next-line no-param-reassign
    options = (0, $2c30869926b6e1e7$export$2e2bcd8739ae039).toFlatObject(options, {
        metaTokens: true,
        dots: false,
        indexes: false
    }, false, function defined(option, source) {
        // eslint-disable-next-line no-eq-null,eqeqeq
        return !(0, $2c30869926b6e1e7$export$2e2bcd8739ae039).isUndefined(source[option]);
    });
    const metaTokens = options.metaTokens;
    // eslint-disable-next-line no-use-before-define
    const visitor = options.visitor || defaultVisitor;
    const dots = options.dots;
    const indexes = options.indexes;
    const _Blob = options.Blob || typeof Blob !== "undefined" && Blob;
    const useBlob = _Blob && (0, $2c30869926b6e1e7$export$2e2bcd8739ae039).isSpecCompliantForm(formData);
    if (!(0, $2c30869926b6e1e7$export$2e2bcd8739ae039).isFunction(visitor)) throw new TypeError("visitor must be a function");
    function convertValue(value) {
        if (value === null) return "";
        if ((0, $2c30869926b6e1e7$export$2e2bcd8739ae039).isDate(value)) return value.toISOString();
        if (!useBlob && (0, $2c30869926b6e1e7$export$2e2bcd8739ae039).isBlob(value)) throw new (0, $158812891e7ba01a$export$2e2bcd8739ae039)("Blob is not supported. Use a Buffer instead.");
        if ((0, $2c30869926b6e1e7$export$2e2bcd8739ae039).isArrayBuffer(value) || (0, $2c30869926b6e1e7$export$2e2bcd8739ae039).isTypedArray(value)) return useBlob && typeof Blob === "function" ? new Blob([
            value
        ]) : $268c3eee7f562394$require$Buffer.from(value);
        return value;
    }
    /**
   * Default visitor.
   *
   * @param {*} value
   * @param {String|Number} key
   * @param {Array<String|Number>} path
   * @this {FormData}
   *
   * @returns {boolean} return true to visit the each prop of the value recursively
   */ function defaultVisitor(value, key, path) {
        let arr = value;
        if (value && !path && typeof value === "object") {
            if ((0, $2c30869926b6e1e7$export$2e2bcd8739ae039).endsWith(key, "{}")) {
                // eslint-disable-next-line no-param-reassign
                key = metaTokens ? key : key.slice(0, -2);
                // eslint-disable-next-line no-param-reassign
                value = JSON.stringify(value);
            } else if ((0, $2c30869926b6e1e7$export$2e2bcd8739ae039).isArray(value) && $268c3eee7f562394$var$isFlatArray(value) || ((0, $2c30869926b6e1e7$export$2e2bcd8739ae039).isFileList(value) || (0, $2c30869926b6e1e7$export$2e2bcd8739ae039).endsWith(key, "[]")) && (arr = (0, $2c30869926b6e1e7$export$2e2bcd8739ae039).toArray(value))) {
                // eslint-disable-next-line no-param-reassign
                key = $268c3eee7f562394$var$removeBrackets(key);
                arr.forEach(function each(el, index) {
                    !((0, $2c30869926b6e1e7$export$2e2bcd8739ae039).isUndefined(el) || el === null) && formData.append(// eslint-disable-next-line no-nested-ternary
                    indexes === true ? $268c3eee7f562394$var$renderKey([
                        key
                    ], index, dots) : indexes === null ? key : key + "[]", convertValue(el));
                });
                return false;
            }
        }
        if ($268c3eee7f562394$var$isVisitable(value)) return true;
        formData.append($268c3eee7f562394$var$renderKey(path, key, dots), convertValue(value));
        return false;
    }
    const stack = [];
    const exposedHelpers = Object.assign($268c3eee7f562394$var$predicates, {
        defaultVisitor: defaultVisitor,
        convertValue: convertValue,
        isVisitable: $268c3eee7f562394$var$isVisitable
    });
    function build(value, path) {
        if ((0, $2c30869926b6e1e7$export$2e2bcd8739ae039).isUndefined(value)) return;
        if (stack.indexOf(value) !== -1) throw Error("Circular reference detected in " + path.join("."));
        stack.push(value);
        (0, $2c30869926b6e1e7$export$2e2bcd8739ae039).forEach(value, function each(el, key) {
            const result = !((0, $2c30869926b6e1e7$export$2e2bcd8739ae039).isUndefined(el) || el === null) && visitor.call(formData, el, (0, $2c30869926b6e1e7$export$2e2bcd8739ae039).isString(key) ? key.trim() : key, path, exposedHelpers);
            if (result === true) build(el, path ? path.concat(key) : [
                key
            ]);
        });
        stack.pop();
    }
    if (!(0, $2c30869926b6e1e7$export$2e2bcd8739ae039).isObject(obj)) throw new TypeError("data must be an object");
    build(obj);
    return formData;
}
var $268c3eee7f562394$export$2e2bcd8739ae039 = $268c3eee7f562394$var$toFormData;


"use strict";
/**
 * It encodes a string by replacing all characters that are not in the unreserved set with
 * their percent-encoded equivalents
 *
 * @param {string} str - The string to encode.
 *
 * @returns {string} The encoded string.
 */ function $2451b92fd70679a9$var$encode(str) {
    const charMap = {
        "!": "%21",
        "'": "%27",
        "(": "%28",
        ")": "%29",
        "~": "%7E",
        "%20": "+",
        "%00": "\x00"
    };
    return encodeURIComponent(str).replace(/[!'()~]|%20|%00/g, function replacer(match) {
        return charMap[match];
    });
}
/**
 * It takes a params object and converts it to a FormData object
 *
 * @param {Object<string, any>} params - The parameters to be converted to a FormData object.
 * @param {Object<string, any>} options - The options object passed to the Axios constructor.
 *
 * @returns {void}
 */ function $2451b92fd70679a9$var$AxiosURLSearchParams(params, options) {
    this._pairs = [];
    params && (0, $268c3eee7f562394$export$2e2bcd8739ae039)(params, this, options);
}
const $2451b92fd70679a9$var$prototype = $2451b92fd70679a9$var$AxiosURLSearchParams.prototype;
$2451b92fd70679a9$var$prototype.append = function append(name, value) {
    this._pairs.push([
        name,
        value
    ]);
};
$2451b92fd70679a9$var$prototype.toString = function toString(encoder) {
    const _encode = encoder ? function(value) {
        return encoder.call(this, value, $2451b92fd70679a9$var$encode);
    } : $2451b92fd70679a9$var$encode;
    return this._pairs.map(function each(pair) {
        return _encode(pair[0]) + "=" + _encode(pair[1]);
    }, "").join("&");
};
var $2451b92fd70679a9$export$2e2bcd8739ae039 = $2451b92fd70679a9$var$AxiosURLSearchParams;


"use strict";
/**
 * It replaces all instances of the characters `:`, `$`, `,`, `+`, `[`, and `]` with their
 * URI encoded counterparts
 *
 * @param {string} val The value to be encoded.
 *
 * @returns {string} The encoded value.
 */ function $7248f3898d25e541$var$encode(val) {
    return encodeURIComponent(val).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
}
function $7248f3898d25e541$export$2e2bcd8739ae039(url, params, options) {
    /*eslint no-param-reassign:0*/ if (!params) return url;
    const _encode = options && options.encode || $7248f3898d25e541$var$encode;
    const serializeFn = options && options.serialize;
    let serializedParams;
    if (serializeFn) serializedParams = serializeFn(params, options);
    else serializedParams = (0, $2c30869926b6e1e7$export$2e2bcd8739ae039).isURLSearchParams(params) ? params.toString() : new (0, $2451b92fd70679a9$export$2e2bcd8739ae039)(params, options).toString(_encode);
    if (serializedParams) {
        const hashmarkIndex = url.indexOf("#");
        if (hashmarkIndex !== -1) url = url.slice(0, hashmarkIndex);
        url += (url.indexOf("?") === -1 ? "?" : "&") + serializedParams;
    }
    return url;
}



"use strict";
class $6a40e377d7a70a23$var$InterceptorManager {
    /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   *
   * @return {Number} An ID used to remove interceptor later
   */ use(fulfilled, rejected, options) {
        this.handlers.push({
            fulfilled: fulfilled,
            rejected: rejected,
            synchronous: options ? options.synchronous : false,
            runWhen: options ? options.runWhen : null
        });
        return this.handlers.length - 1;
    }
    /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {Boolean} `true` if the interceptor was removed, `false` otherwise
   */ eject(id) {
        if (this.handlers[id]) this.handlers[id] = null;
    }
    /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */ clear() {
        if (this.handlers) this.handlers = [];
    }
    /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */ forEach(fn) {
        (0, $2c30869926b6e1e7$export$2e2bcd8739ae039).forEach(this.handlers, function forEachHandler(h) {
            if (h !== null) fn(h);
        });
    }
    constructor(){
        this.handlers = [];
    }
}
var $6a40e377d7a70a23$export$2e2bcd8739ae039 = $6a40e377d7a70a23$var$InterceptorManager;





"use strict";
var $3e4430075a1d9e96$export$2e2bcd8739ae039 = {
    silentJSONParsing: true,
    forcedJSONParsing: true,
    clarifyTimeoutError: false
};






"use strict";
var $81ff4f21974b3579$export$2e2bcd8739ae039 = typeof URLSearchParams !== "undefined" ? URLSearchParams : (0, $2451b92fd70679a9$export$2e2bcd8739ae039);


"use strict";
var $6c0ff9c267dd4782$export$2e2bcd8739ae039 = typeof FormData !== "undefined" ? FormData : null;


"use strict";
var $5b1aa0173a476166$export$2e2bcd8739ae039 = typeof Blob !== "undefined" ? Blob : null;


/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 *
 * @returns {boolean}
 */ const $6c5273aca28b9651$var$isStandardBrowserEnv = (()=>{
    let product;
    if (typeof navigator !== "undefined" && ((product = navigator.product) === "ReactNative" || product === "NativeScript" || product === "NS")) return false;
    return typeof window !== "undefined" && typeof document !== "undefined";
})();
/**
 * Determine if we're running in a standard browser webWorker environment
 *
 * Although the `isStandardBrowserEnv` method indicates that
 * `allows axios to run in a web worker`, the WebWorker will still be
 * filtered out due to its judgment standard
 * `typeof window !== 'undefined' && typeof document !== 'undefined'`.
 * This leads to a problem when axios post `FormData` in webWorker
 */ const $6c5273aca28b9651$var$isStandardBrowserWebWorkerEnv = (()=>{
    return typeof WorkerGlobalScope !== "undefined" && // eslint-disable-next-line no-undef
    self instanceof WorkerGlobalScope && typeof self.importScripts === "function";
})();
var $6c5273aca28b9651$export$2e2bcd8739ae039 = {
    isBrowser: true,
    classes: {
        URLSearchParams: $81ff4f21974b3579$export$2e2bcd8739ae039,
        FormData: $6c0ff9c267dd4782$export$2e2bcd8739ae039,
        Blob: $5b1aa0173a476166$export$2e2bcd8739ae039
    },
    isStandardBrowserEnv: $6c5273aca28b9651$var$isStandardBrowserEnv,
    isStandardBrowserWebWorkerEnv: $6c5273aca28b9651$var$isStandardBrowserWebWorkerEnv,
    protocols: [
        "http",
        "https",
        "file",
        "blob",
        "url",
        "data"
    ]
};


"use strict";
function $9768e5a4276bfba6$export$2e2bcd8739ae039(data, options) {
    return (0, $268c3eee7f562394$export$2e2bcd8739ae039)(data, new (0, $6c5273aca28b9651$export$2e2bcd8739ae039).classes.URLSearchParams(), Object.assign({
        visitor: function(value, key, path, helpers) {
            if ((0, $6c5273aca28b9651$export$2e2bcd8739ae039).isNode && (0, $2c30869926b6e1e7$export$2e2bcd8739ae039).isBuffer(value)) {
                this.append(key, value.toString("base64"));
                return false;
            }
            return helpers.defaultVisitor.apply(this, arguments);
        }
    }, options));
}




"use strict";
/**
 * It takes a string like `foo[x][y][z]` and returns an array like `['foo', 'x', 'y', 'z']
 *
 * @param {string} name - The name of the property to get.
 *
 * @returns An array of strings.
 */ function $b510c72164a424ab$var$parsePropPath(name) {
    // foo[x][y][z]
    // foo.x.y.z
    // foo-x-y-z
    // foo x y z
    return (0, $2c30869926b6e1e7$export$2e2bcd8739ae039).matchAll(/\w+|\[(\w*)]/g, name).map((match)=>{
        return match[0] === "[]" ? "" : match[1] || match[0];
    });
}
/**
 * Convert an array to an object.
 *
 * @param {Array<any>} arr - The array to convert to an object.
 *
 * @returns An object with the same keys and values as the array.
 */ function $b510c72164a424ab$var$arrayToObject(arr) {
    const obj = {};
    const keys = Object.keys(arr);
    let i;
    const len = keys.length;
    let key;
    for(i = 0; i < len; i++){
        key = keys[i];
        obj[key] = arr[key];
    }
    return obj;
}
/**
 * It takes a FormData object and returns a JavaScript object
 *
 * @param {string} formData The FormData object to convert to JSON.
 *
 * @returns {Object<string, any> | null} The converted object.
 */ function $b510c72164a424ab$var$formDataToJSON(formData) {
    function buildPath(path, value, target, index) {
        let name = path[index++];
        const isNumericKey = Number.isFinite(+name);
        const isLast = index >= path.length;
        name = !name && (0, $2c30869926b6e1e7$export$2e2bcd8739ae039).isArray(target) ? target.length : name;
        if (isLast) {
            if ((0, $2c30869926b6e1e7$export$2e2bcd8739ae039).hasOwnProp(target, name)) target[name] = [
                target[name],
                value
            ];
            else target[name] = value;
            return !isNumericKey;
        }
        if (!target[name] || !(0, $2c30869926b6e1e7$export$2e2bcd8739ae039).isObject(target[name])) target[name] = [];
        const result = buildPath(path, value, target[name], index);
        if (result && (0, $2c30869926b6e1e7$export$2e2bcd8739ae039).isArray(target[name])) target[name] = $b510c72164a424ab$var$arrayToObject(target[name]);
        return !isNumericKey;
    }
    if ((0, $2c30869926b6e1e7$export$2e2bcd8739ae039).isFormData(formData) && (0, $2c30869926b6e1e7$export$2e2bcd8739ae039).isFunction(formData.entries)) {
        const obj = {};
        (0, $2c30869926b6e1e7$export$2e2bcd8739ae039).forEachEntry(formData, (name, value)=>{
            buildPath($b510c72164a424ab$var$parsePropPath(name), value, obj, 0);
        });
        return obj;
    }
    return null;
}
var $b510c72164a424ab$export$2e2bcd8739ae039 = $b510c72164a424ab$var$formDataToJSON;


"use strict";
/**
 * It takes a string, tries to parse it, and if it fails, it returns the stringified version
 * of the input
 *
 * @param {any} rawValue - The value to be stringified.
 * @param {Function} parser - A function that parses a string into a JavaScript object.
 * @param {Function} encoder - A function that takes a value and returns a string.
 *
 * @returns {string} A stringified version of the rawValue.
 */ function $8b1b63524c69311f$var$stringifySafely(rawValue, parser, encoder) {
    if ((0, $2c30869926b6e1e7$export$2e2bcd8739ae039).isString(rawValue)) try {
        (parser || JSON.parse)(rawValue);
        return (0, $2c30869926b6e1e7$export$2e2bcd8739ae039).trim(rawValue);
    } catch (e) {
        if (e.name !== "SyntaxError") throw e;
    }
    return (encoder || JSON.stringify)(rawValue);
}
const $8b1b63524c69311f$var$defaults = {
    transitional: (0, $3e4430075a1d9e96$export$2e2bcd8739ae039),
    adapter: (0, $6c5273aca28b9651$export$2e2bcd8739ae039).isNode ? "http" : "xhr",
    transformRequest: [
        function transformRequest(data, headers) {
            const contentType = headers.getContentType() || "";
            const hasJSONContentType = contentType.indexOf("application/json") > -1;
            const isObjectPayload = (0, $2c30869926b6e1e7$export$2e2bcd8739ae039).isObject(data);
            if (isObjectPayload && (0, $2c30869926b6e1e7$export$2e2bcd8739ae039).isHTMLForm(data)) data = new FormData(data);
            const isFormData = (0, $2c30869926b6e1e7$export$2e2bcd8739ae039).isFormData(data);
            if (isFormData) {
                if (!hasJSONContentType) return data;
                return hasJSONContentType ? JSON.stringify((0, $b510c72164a424ab$export$2e2bcd8739ae039)(data)) : data;
            }
            if ((0, $2c30869926b6e1e7$export$2e2bcd8739ae039).isArrayBuffer(data) || (0, $2c30869926b6e1e7$export$2e2bcd8739ae039).isBuffer(data) || (0, $2c30869926b6e1e7$export$2e2bcd8739ae039).isStream(data) || (0, $2c30869926b6e1e7$export$2e2bcd8739ae039).isFile(data) || (0, $2c30869926b6e1e7$export$2e2bcd8739ae039).isBlob(data)) return data;
            if ((0, $2c30869926b6e1e7$export$2e2bcd8739ae039).isArrayBufferView(data)) return data.buffer;
            if ((0, $2c30869926b6e1e7$export$2e2bcd8739ae039).isURLSearchParams(data)) {
                headers.setContentType("application/x-www-form-urlencoded;charset=utf-8", false);
                return data.toString();
            }
            let isFileList;
            if (isObjectPayload) {
                if (contentType.indexOf("application/x-www-form-urlencoded") > -1) return (0, $9768e5a4276bfba6$export$2e2bcd8739ae039)(data, this.formSerializer).toString();
                if ((isFileList = (0, $2c30869926b6e1e7$export$2e2bcd8739ae039).isFileList(data)) || contentType.indexOf("multipart/form-data") > -1) {
                    const _FormData = this.env && this.env.FormData;
                    return (0, $268c3eee7f562394$export$2e2bcd8739ae039)(isFileList ? {
                        "files[]": data
                    } : data, _FormData && new _FormData(), this.formSerializer);
                }
            }
            if (isObjectPayload || hasJSONContentType) {
                headers.setContentType("application/json", false);
                return $8b1b63524c69311f$var$stringifySafely(data);
            }
            return data;
        }
    ],
    transformResponse: [
        function transformResponse(data) {
            const transitional = this.transitional || $8b1b63524c69311f$var$defaults.transitional;
            const forcedJSONParsing = transitional && transitional.forcedJSONParsing;
            const JSONRequested = this.responseType === "json";
            if (data && (0, $2c30869926b6e1e7$export$2e2bcd8739ae039).isString(data) && (forcedJSONParsing && !this.responseType || JSONRequested)) {
                const silentJSONParsing = transitional && transitional.silentJSONParsing;
                const strictJSONParsing = !silentJSONParsing && JSONRequested;
                try {
                    return JSON.parse(data);
                } catch (e) {
                    if (strictJSONParsing) {
                        if (e.name === "SyntaxError") throw (0, $158812891e7ba01a$export$2e2bcd8739ae039).from(e, (0, $158812891e7ba01a$export$2e2bcd8739ae039).ERR_BAD_RESPONSE, this, null, this.response);
                        throw e;
                    }
                }
            }
            return data;
        }
    ],
    /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */ timeout: 0,
    xsrfCookieName: "XSRF-TOKEN",
    xsrfHeaderName: "X-XSRF-TOKEN",
    maxContentLength: -1,
    maxBodyLength: -1,
    env: {
        FormData: (0, $6c5273aca28b9651$export$2e2bcd8739ae039).classes.FormData,
        Blob: (0, $6c5273aca28b9651$export$2e2bcd8739ae039).classes.Blob
    },
    validateStatus: function validateStatus(status) {
        return status >= 200 && status < 300;
    },
    headers: {
        common: {
            "Accept": "application/json, text/plain, */*",
            "Content-Type": undefined
        }
    }
};
(0, $2c30869926b6e1e7$export$2e2bcd8739ae039).forEach([
    "delete",
    "get",
    "head",
    "post",
    "put",
    "patch"
], (method)=>{
    $8b1b63524c69311f$var$defaults.headers[method] = {};
});
var $8b1b63524c69311f$export$2e2bcd8739ae039 = $8b1b63524c69311f$var$defaults;




"use strict";
// RawAxiosHeaders whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
const $43b4953177cdc946$var$ignoreDuplicateOf = (0, $2c30869926b6e1e7$export$2e2bcd8739ae039).toObjectSet([
    "age",
    "authorization",
    "content-length",
    "content-type",
    "etag",
    "expires",
    "from",
    "host",
    "if-modified-since",
    "if-unmodified-since",
    "last-modified",
    "location",
    "max-forwards",
    "proxy-authorization",
    "referer",
    "retry-after",
    "user-agent"
]);
var /**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} rawHeaders Headers needing to be parsed
 *
 * @returns {Object} Headers parsed into an object
 */ $43b4953177cdc946$export$2e2bcd8739ae039 = (rawHeaders)=>{
    const parsed = {};
    let key;
    let val;
    let i;
    rawHeaders && rawHeaders.split("\n").forEach(function parser(line) {
        i = line.indexOf(":");
        key = line.substring(0, i).trim().toLowerCase();
        val = line.substring(i + 1).trim();
        if (!key || parsed[key] && $43b4953177cdc946$var$ignoreDuplicateOf[key]) return;
        if (key === "set-cookie") {
            if (parsed[key]) parsed[key].push(val);
            else parsed[key] = [
                val
            ];
        } else parsed[key] = parsed[key] ? parsed[key] + ", " + val : val;
    });
    return parsed;
};


"use strict";
const $ec96b1f5b12d7568$var$$internals = Symbol("internals");
function $ec96b1f5b12d7568$var$normalizeHeader(header) {
    return header && String(header).trim().toLowerCase();
}
function $ec96b1f5b12d7568$var$normalizeValue(value) {
    if (value === false || value == null) return value;
    return (0, $2c30869926b6e1e7$export$2e2bcd8739ae039).isArray(value) ? value.map($ec96b1f5b12d7568$var$normalizeValue) : String(value);
}
function $ec96b1f5b12d7568$var$parseTokens(str) {
    const tokens = Object.create(null);
    const tokensRE = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
    let match;
    while(match = tokensRE.exec(str))tokens[match[1]] = match[2];
    return tokens;
}
const $ec96b1f5b12d7568$var$isValidHeaderName = (str)=>/^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(str.trim());
function $ec96b1f5b12d7568$var$matchHeaderValue(context, value, header, filter, isHeaderNameFilter) {
    if ((0, $2c30869926b6e1e7$export$2e2bcd8739ae039).isFunction(filter)) return filter.call(this, value, header);
    if (isHeaderNameFilter) value = header;
    if (!(0, $2c30869926b6e1e7$export$2e2bcd8739ae039).isString(value)) return;
    if ((0, $2c30869926b6e1e7$export$2e2bcd8739ae039).isString(filter)) return value.indexOf(filter) !== -1;
    if ((0, $2c30869926b6e1e7$export$2e2bcd8739ae039).isRegExp(filter)) return filter.test(value);
}
function $ec96b1f5b12d7568$var$formatHeader(header) {
    return header.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (w, char, str)=>{
        return char.toUpperCase() + str;
    });
}
function $ec96b1f5b12d7568$var$buildAccessors(obj, header) {
    const accessorName = (0, $2c30869926b6e1e7$export$2e2bcd8739ae039).toCamelCase(" " + header);
    [
        "get",
        "set",
        "has"
    ].forEach((methodName)=>{
        Object.defineProperty(obj, methodName + accessorName, {
            value: function(arg1, arg2, arg3) {
                return this[methodName].call(this, header, arg1, arg2, arg3);
            },
            configurable: true
        });
    });
}
class $ec96b1f5b12d7568$var$AxiosHeaders {
    set(header, valueOrRewrite, rewrite) {
        const self = this;
        function setHeader(_value, _header, _rewrite) {
            const lHeader = $ec96b1f5b12d7568$var$normalizeHeader(_header);
            if (!lHeader) throw new Error("header name must be a non-empty string");
            const key = (0, $2c30869926b6e1e7$export$2e2bcd8739ae039).findKey(self, lHeader);
            if (!key || self[key] === undefined || _rewrite === true || _rewrite === undefined && self[key] !== false) self[key || _header] = $ec96b1f5b12d7568$var$normalizeValue(_value);
        }
        const setHeaders = (headers, _rewrite)=>(0, $2c30869926b6e1e7$export$2e2bcd8739ae039).forEach(headers, (_value, _header)=>setHeader(_value, _header, _rewrite));
        if ((0, $2c30869926b6e1e7$export$2e2bcd8739ae039).isPlainObject(header) || header instanceof this.constructor) setHeaders(header, valueOrRewrite);
        else if ((0, $2c30869926b6e1e7$export$2e2bcd8739ae039).isString(header) && (header = header.trim()) && !$ec96b1f5b12d7568$var$isValidHeaderName(header)) setHeaders((0, $43b4953177cdc946$export$2e2bcd8739ae039)(header), valueOrRewrite);
        else header != null && setHeader(valueOrRewrite, header, rewrite);
        return this;
    }
    get(header, parser) {
        header = $ec96b1f5b12d7568$var$normalizeHeader(header);
        if (header) {
            const key = (0, $2c30869926b6e1e7$export$2e2bcd8739ae039).findKey(this, header);
            if (key) {
                const value = this[key];
                if (!parser) return value;
                if (parser === true) return $ec96b1f5b12d7568$var$parseTokens(value);
                if ((0, $2c30869926b6e1e7$export$2e2bcd8739ae039).isFunction(parser)) return parser.call(this, value, key);
                if ((0, $2c30869926b6e1e7$export$2e2bcd8739ae039).isRegExp(parser)) return parser.exec(value);
                throw new TypeError("parser must be boolean|regexp|function");
            }
        }
    }
    has(header, matcher) {
        header = $ec96b1f5b12d7568$var$normalizeHeader(header);
        if (header) {
            const key = (0, $2c30869926b6e1e7$export$2e2bcd8739ae039).findKey(this, header);
            return !!(key && this[key] !== undefined && (!matcher || $ec96b1f5b12d7568$var$matchHeaderValue(this, this[key], key, matcher)));
        }
        return false;
    }
    delete(header, matcher) {
        const self = this;
        let deleted = false;
        function deleteHeader(_header) {
            _header = $ec96b1f5b12d7568$var$normalizeHeader(_header);
            if (_header) {
                const key = (0, $2c30869926b6e1e7$export$2e2bcd8739ae039).findKey(self, _header);
                if (key && (!matcher || $ec96b1f5b12d7568$var$matchHeaderValue(self, self[key], key, matcher))) {
                    delete self[key];
                    deleted = true;
                }
            }
        }
        if ((0, $2c30869926b6e1e7$export$2e2bcd8739ae039).isArray(header)) header.forEach(deleteHeader);
        else deleteHeader(header);
        return deleted;
    }
    clear(matcher) {
        const keys = Object.keys(this);
        let i = keys.length;
        let deleted = false;
        while(i--){
            const key = keys[i];
            if (!matcher || $ec96b1f5b12d7568$var$matchHeaderValue(this, this[key], key, matcher, true)) {
                delete this[key];
                deleted = true;
            }
        }
        return deleted;
    }
    normalize(format) {
        const self = this;
        const headers = {};
        (0, $2c30869926b6e1e7$export$2e2bcd8739ae039).forEach(this, (value, header)=>{
            const key = (0, $2c30869926b6e1e7$export$2e2bcd8739ae039).findKey(headers, header);
            if (key) {
                self[key] = $ec96b1f5b12d7568$var$normalizeValue(value);
                delete self[header];
                return;
            }
            const normalized = format ? $ec96b1f5b12d7568$var$formatHeader(header) : String(header).trim();
            if (normalized !== header) delete self[header];
            self[normalized] = $ec96b1f5b12d7568$var$normalizeValue(value);
            headers[normalized] = true;
        });
        return this;
    }
    concat(...targets) {
        return this.constructor.concat(this, ...targets);
    }
    toJSON(asStrings) {
        const obj = Object.create(null);
        (0, $2c30869926b6e1e7$export$2e2bcd8739ae039).forEach(this, (value, header)=>{
            value != null && value !== false && (obj[header] = asStrings && (0, $2c30869926b6e1e7$export$2e2bcd8739ae039).isArray(value) ? value.join(", ") : value);
        });
        return obj;
    }
    [Symbol.iterator]() {
        return Object.entries(this.toJSON())[Symbol.iterator]();
    }
    toString() {
        return Object.entries(this.toJSON()).map(([header, value])=>header + ": " + value).join("\n");
    }
    get [Symbol.toStringTag]() {
        return "AxiosHeaders";
    }
    static from(thing) {
        return thing instanceof this ? thing : new this(thing);
    }
    static concat(first, ...targets) {
        const computed = new this(first);
        targets.forEach((target)=>computed.set(target));
        return computed;
    }
    static accessor(header) {
        const internals = this[$ec96b1f5b12d7568$var$$internals] = this[$ec96b1f5b12d7568$var$$internals] = {
            accessors: {}
        };
        const accessors = internals.accessors;
        const prototype = this.prototype;
        function defineAccessor(_header) {
            const lHeader = $ec96b1f5b12d7568$var$normalizeHeader(_header);
            if (!accessors[lHeader]) {
                $ec96b1f5b12d7568$var$buildAccessors(prototype, _header);
                accessors[lHeader] = true;
            }
        }
        (0, $2c30869926b6e1e7$export$2e2bcd8739ae039).isArray(header) ? header.forEach(defineAccessor) : defineAccessor(header);
        return this;
    }
    constructor(headers){
        headers && this.set(headers);
    }
}
$ec96b1f5b12d7568$var$AxiosHeaders.accessor([
    "Content-Type",
    "Content-Length",
    "Accept",
    "Accept-Encoding",
    "User-Agent",
    "Authorization"
]);
// reserved names hotfix
(0, $2c30869926b6e1e7$export$2e2bcd8739ae039).reduceDescriptors($ec96b1f5b12d7568$var$AxiosHeaders.prototype, ({ value: value }, key)=>{
    let mapped = key[0].toUpperCase() + key.slice(1); // map `set` => `Set`
    return {
        get: ()=>value,
        set (headerValue) {
            this[mapped] = headerValue;
        }
    };
});
(0, $2c30869926b6e1e7$export$2e2bcd8739ae039).freezeMethods($ec96b1f5b12d7568$var$AxiosHeaders);
var $ec96b1f5b12d7568$export$2e2bcd8739ae039 = $ec96b1f5b12d7568$var$AxiosHeaders;


"use strict";
function $7ebc1eba1e1101b5$export$2e2bcd8739ae039(fns, response) {
    const config = this || (0, $8b1b63524c69311f$export$2e2bcd8739ae039);
    const context = response || config;
    const headers = (0, $ec96b1f5b12d7568$export$2e2bcd8739ae039).from(context.headers);
    let data = context.data;
    (0, $2c30869926b6e1e7$export$2e2bcd8739ae039).forEach(fns, function transform(fn) {
        data = fn.call(config, data, headers.normalize(), response ? response.status : undefined);
    });
    headers.normalize();
    return data;
}


"use strict";
function $e01286482f6b3060$export$2e2bcd8739ae039(value) {
    return !!(value && value.__CANCEL__);
}





"use strict";
/**
 * A `CanceledError` is an object that is thrown when an operation is canceled.
 *
 * @param {string=} message The message.
 * @param {Object=} config The config.
 * @param {Object=} request The request.
 *
 * @returns {CanceledError} The created error.
 */ function $cc2dc937308c98b6$var$CanceledError(message, config, request) {
    // eslint-disable-next-line no-eq-null,eqeqeq
    (0, $158812891e7ba01a$export$2e2bcd8739ae039).call(this, message == null ? "canceled" : message, (0, $158812891e7ba01a$export$2e2bcd8739ae039).ERR_CANCELED, config, request);
    this.name = "CanceledError";
}
(0, $2c30869926b6e1e7$export$2e2bcd8739ae039).inherits($cc2dc937308c98b6$var$CanceledError, (0, $158812891e7ba01a$export$2e2bcd8739ae039), {
    __CANCEL__: true
});
var $cc2dc937308c98b6$export$2e2bcd8739ae039 = $cc2dc937308c98b6$var$CanceledError;







"use strict";
function $d5b51727bd48f191$export$2e2bcd8739ae039(resolve, reject, response) {
    const validateStatus = response.config.validateStatus;
    if (!response.status || !validateStatus || validateStatus(response.status)) resolve(response);
    else reject(new (0, $158812891e7ba01a$export$2e2bcd8739ae039)("Request failed with status code " + response.status, [
        (0, $158812891e7ba01a$export$2e2bcd8739ae039).ERR_BAD_REQUEST,
        (0, $158812891e7ba01a$export$2e2bcd8739ae039).ERR_BAD_RESPONSE
    ][Math.floor(response.status / 100) - 4], response.config, response.request, response));
}




"use strict";
var $57428625d20ddcfb$export$2e2bcd8739ae039 = (0, $6c5273aca28b9651$export$2e2bcd8739ae039).isStandardBrowserEnv ? // Standard browser envs support document.cookie
function standardBrowserEnv() {
    return {
        write: function write(name, value, expires, path, domain, secure) {
            const cookie = [];
            cookie.push(name + "=" + encodeURIComponent(value));
            if ((0, $2c30869926b6e1e7$export$2e2bcd8739ae039).isNumber(expires)) cookie.push("expires=" + new Date(expires).toGMTString());
            if ((0, $2c30869926b6e1e7$export$2e2bcd8739ae039).isString(path)) cookie.push("path=" + path);
            if ((0, $2c30869926b6e1e7$export$2e2bcd8739ae039).isString(domain)) cookie.push("domain=" + domain);
            if (secure === true) cookie.push("secure");
            document.cookie = cookie.join("; ");
        },
        read: function read(name) {
            const match = document.cookie.match(new RegExp("(^|;\\s*)(" + name + ")=([^;]*)"));
            return match ? decodeURIComponent(match[3]) : null;
        },
        remove: function remove(name) {
            this.write(name, "", Date.now() - 86400000);
        }
    };
}() : // Non standard browser env (web workers, react-native) lack needed support.
function nonStandardBrowserEnv() {
    return {
        write: function write() {},
        read: function read() {
            return null;
        },
        remove: function remove() {}
    };
}();



"use strict";
function $2166721a38564541$export$2e2bcd8739ae039(url) {
    // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
    // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
    // by any combination of letters, digits, plus, period, or hyphen.
    return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(url);
}


"use strict";
function $97bfe9498d3d2f08$export$2e2bcd8739ae039(baseURL, relativeURL) {
    return relativeURL ? baseURL.replace(/\/+$/, "") + "/" + relativeURL.replace(/^\/+/, "") : baseURL;
}


"use strict";
function $f28dd6eb0926cebf$export$2e2bcd8739ae039(baseURL, requestedURL) {
    if (baseURL && !(0, $2166721a38564541$export$2e2bcd8739ae039)(requestedURL)) return (0, $97bfe9498d3d2f08$export$2e2bcd8739ae039)(baseURL, requestedURL);
    return requestedURL;
}




"use strict";
var $b544d6d0dc27e722$export$2e2bcd8739ae039 = (0, $6c5273aca28b9651$export$2e2bcd8739ae039).isStandardBrowserEnv ? // Standard browser envs have full support of the APIs needed to test
// whether the request URL is of the same origin as current location.
function standardBrowserEnv() {
    const msie = /(msie|trident)/i.test(navigator.userAgent);
    const urlParsingNode = document.createElement("a");
    let originURL;
    /**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */ function resolveURL(url) {
        let href = url;
        if (msie) {
            // IE needs attribute set twice to normalize properties
            urlParsingNode.setAttribute("href", href);
            href = urlParsingNode.href;
        }
        urlParsingNode.setAttribute("href", href);
        // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
        return {
            href: urlParsingNode.href,
            protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, "") : "",
            host: urlParsingNode.host,
            search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, "") : "",
            hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, "") : "",
            hostname: urlParsingNode.hostname,
            port: urlParsingNode.port,
            pathname: urlParsingNode.pathname.charAt(0) === "/" ? urlParsingNode.pathname : "/" + urlParsingNode.pathname
        };
    }
    originURL = resolveURL(window.location.href);
    /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */ return function isURLSameOrigin(requestURL) {
        const parsed = (0, $2c30869926b6e1e7$export$2e2bcd8739ae039).isString(requestURL) ? resolveURL(requestURL) : requestURL;
        return parsed.protocol === originURL.protocol && parsed.host === originURL.host;
    };
}() : // Non standard browser envs (web workers, react-native) lack needed support.
function nonStandardBrowserEnv() {
    return function isURLSameOrigin() {
        return true;
    };
}();





"use strict";
function $b5f356b377c9e3ea$export$2e2bcd8739ae039(url) {
    const match = /^([-+\w]{1,25})(:?\/\/|:)/.exec(url);
    return match && match[1] || "";
}




"use strict";
/**
 * Calculate data maxRate
 * @param {Number} [samplesCount= 10]
 * @param {Number} [min= 1000]
 * @returns {Function}
 */ function $41a1ce75ff90e6cd$var$speedometer(samplesCount, min) {
    samplesCount = samplesCount || 10;
    const bytes = new Array(samplesCount);
    const timestamps = new Array(samplesCount);
    let head = 0;
    let tail = 0;
    let firstSampleTS;
    min = min !== undefined ? min : 1000;
    return function push(chunkLength) {
        const now = Date.now();
        const startedAt = timestamps[tail];
        if (!firstSampleTS) firstSampleTS = now;
        bytes[head] = chunkLength;
        timestamps[head] = now;
        let i = tail;
        let bytesCount = 0;
        while(i !== head){
            bytesCount += bytes[i++];
            i = i % samplesCount;
        }
        head = (head + 1) % samplesCount;
        if (head === tail) tail = (tail + 1) % samplesCount;
        if (now - firstSampleTS < min) return;
        const passed = startedAt && now - startedAt;
        return passed ? Math.round(bytesCount * 1000 / passed) : undefined;
    };
}
var $41a1ce75ff90e6cd$export$2e2bcd8739ae039 = $41a1ce75ff90e6cd$var$speedometer;


"use strict";
function $29f6b5de9f8c8b7a$var$progressEventReducer(listener, isDownloadStream) {
    let bytesNotified = 0;
    const _speedometer = (0, $41a1ce75ff90e6cd$export$2e2bcd8739ae039)(50, 250);
    return (e)=>{
        const loaded = e.loaded;
        const total = e.lengthComputable ? e.total : undefined;
        const progressBytes = loaded - bytesNotified;
        const rate = _speedometer(progressBytes);
        const inRange = loaded <= total;
        bytesNotified = loaded;
        const data = {
            loaded: loaded,
            total: total,
            progress: total ? loaded / total : undefined,
            bytes: progressBytes,
            rate: rate ? rate : undefined,
            estimated: rate && total && inRange ? (total - loaded) / rate : undefined,
            event: e
        };
        data[isDownloadStream ? "download" : "upload"] = true;
        listener(data);
    };
}
const $29f6b5de9f8c8b7a$var$isXHRAdapterSupported = typeof XMLHttpRequest !== "undefined";
var $29f6b5de9f8c8b7a$export$2e2bcd8739ae039 = $29f6b5de9f8c8b7a$var$isXHRAdapterSupported && function(config) {
    return new Promise(function dispatchXhrRequest(resolve, reject) {
        let requestData = config.data;
        const requestHeaders = (0, $ec96b1f5b12d7568$export$2e2bcd8739ae039).from(config.headers).normalize();
        const responseType = config.responseType;
        let onCanceled;
        function done() {
            if (config.cancelToken) config.cancelToken.unsubscribe(onCanceled);
            if (config.signal) config.signal.removeEventListener("abort", onCanceled);
        }
        if ((0, $2c30869926b6e1e7$export$2e2bcd8739ae039).isFormData(requestData)) {
            if ((0, $6c5273aca28b9651$export$2e2bcd8739ae039).isStandardBrowserEnv || (0, $6c5273aca28b9651$export$2e2bcd8739ae039).isStandardBrowserWebWorkerEnv) requestHeaders.setContentType(false); // Let the browser set it
            else requestHeaders.setContentType("multipart/form-data;", false); // mobile/desktop app frameworks
        }
        let request = new XMLHttpRequest();
        // HTTP basic authentication
        if (config.auth) {
            const username = config.auth.username || "";
            const password = config.auth.password ? unescape(encodeURIComponent(config.auth.password)) : "";
            requestHeaders.set("Authorization", "Basic " + btoa(username + ":" + password));
        }
        const fullPath = (0, $f28dd6eb0926cebf$export$2e2bcd8739ae039)(config.baseURL, config.url);
        request.open(config.method.toUpperCase(), (0, $7248f3898d25e541$export$2e2bcd8739ae039)(fullPath, config.params, config.paramsSerializer), true);
        // Set the request timeout in MS
        request.timeout = config.timeout;
        function onloadend() {
            if (!request) return;
            // Prepare the response
            const responseHeaders = (0, $ec96b1f5b12d7568$export$2e2bcd8739ae039).from("getAllResponseHeaders" in request && request.getAllResponseHeaders());
            const responseData = !responseType || responseType === "text" || responseType === "json" ? request.responseText : request.response;
            const response = {
                data: responseData,
                status: request.status,
                statusText: request.statusText,
                headers: responseHeaders,
                config: config,
                request: request
            };
            (0, $d5b51727bd48f191$export$2e2bcd8739ae039)(function _resolve(value) {
                resolve(value);
                done();
            }, function _reject(err) {
                reject(err);
                done();
            }, response);
            // Clean up request
            request = null;
        }
        if ("onloadend" in request) // Use onloadend if available
        request.onloadend = onloadend;
        else // Listen for ready state to emulate onloadend
        request.onreadystatechange = function handleLoad() {
            if (!request || request.readyState !== 4) return;
            // The request errored out and we didn't get a response, this will be
            // handled by onerror instead
            // With one exception: request that using file: protocol, most browsers
            // will return status as 0 even though it's a successful request
            if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf("file:") === 0)) return;
            // readystate handler is calling before onerror or ontimeout handlers,
            // so we should call onloadend on the next 'tick'
            setTimeout(onloadend);
        };
        // Handle browser request cancellation (as opposed to a manual cancellation)
        request.onabort = function handleAbort() {
            if (!request) return;
            reject(new (0, $158812891e7ba01a$export$2e2bcd8739ae039)("Request aborted", (0, $158812891e7ba01a$export$2e2bcd8739ae039).ECONNABORTED, config, request));
            // Clean up request
            request = null;
        };
        // Handle low level network errors
        request.onerror = function handleError() {
            // Real errors are hidden from us by the browser
            // onerror should only fire if it's a network error
            reject(new (0, $158812891e7ba01a$export$2e2bcd8739ae039)("Network Error", (0, $158812891e7ba01a$export$2e2bcd8739ae039).ERR_NETWORK, config, request));
            // Clean up request
            request = null;
        };
        // Handle timeout
        request.ontimeout = function handleTimeout() {
            let timeoutErrorMessage = config.timeout ? "timeout of " + config.timeout + "ms exceeded" : "timeout exceeded";
            const transitional = config.transitional || (0, $3e4430075a1d9e96$export$2e2bcd8739ae039);
            if (config.timeoutErrorMessage) timeoutErrorMessage = config.timeoutErrorMessage;
            reject(new (0, $158812891e7ba01a$export$2e2bcd8739ae039)(timeoutErrorMessage, transitional.clarifyTimeoutError ? (0, $158812891e7ba01a$export$2e2bcd8739ae039).ETIMEDOUT : (0, $158812891e7ba01a$export$2e2bcd8739ae039).ECONNABORTED, config, request));
            // Clean up request
            request = null;
        };
        // Add xsrf header
        // This is only done if running in a standard browser environment.
        // Specifically not if we're in a web worker, or react-native.
        if ((0, $6c5273aca28b9651$export$2e2bcd8739ae039).isStandardBrowserEnv) {
            // Add xsrf header
            const xsrfValue = (config.withCredentials || (0, $b544d6d0dc27e722$export$2e2bcd8739ae039)(fullPath)) && config.xsrfCookieName && (0, $57428625d20ddcfb$export$2e2bcd8739ae039).read(config.xsrfCookieName);
            if (xsrfValue) requestHeaders.set(config.xsrfHeaderName, xsrfValue);
        }
        // Remove Content-Type if data is undefined
        requestData === undefined && requestHeaders.setContentType(null);
        // Add headers to the request
        if ("setRequestHeader" in request) (0, $2c30869926b6e1e7$export$2e2bcd8739ae039).forEach(requestHeaders.toJSON(), function setRequestHeader(val, key) {
            request.setRequestHeader(key, val);
        });
        // Add withCredentials to request if needed
        if (!(0, $2c30869926b6e1e7$export$2e2bcd8739ae039).isUndefined(config.withCredentials)) request.withCredentials = !!config.withCredentials;
        // Add responseType to request if needed
        if (responseType && responseType !== "json") request.responseType = config.responseType;
        // Handle progress if needed
        if (typeof config.onDownloadProgress === "function") request.addEventListener("progress", $29f6b5de9f8c8b7a$var$progressEventReducer(config.onDownloadProgress, true));
        // Not all browsers support upload events
        if (typeof config.onUploadProgress === "function" && request.upload) request.upload.addEventListener("progress", $29f6b5de9f8c8b7a$var$progressEventReducer(config.onUploadProgress));
        if (config.cancelToken || config.signal) {
            // Handle cancellation
            // eslint-disable-next-line func-names
            onCanceled = (cancel)=>{
                if (!request) return;
                reject(!cancel || cancel.type ? new (0, $cc2dc937308c98b6$export$2e2bcd8739ae039)(null, config, request) : cancel);
                request.abort();
                request = null;
            };
            config.cancelToken && config.cancelToken.subscribe(onCanceled);
            if (config.signal) config.signal.aborted ? onCanceled() : config.signal.addEventListener("abort", onCanceled);
        }
        const protocol = (0, $b5f356b377c9e3ea$export$2e2bcd8739ae039)(fullPath);
        if (protocol && (0, $6c5273aca28b9651$export$2e2bcd8739ae039).protocols.indexOf(protocol) === -1) {
            reject(new (0, $158812891e7ba01a$export$2e2bcd8739ae039)("Unsupported protocol " + protocol + ":", (0, $158812891e7ba01a$export$2e2bcd8739ae039).ERR_BAD_REQUEST, config));
            return;
        }
        // Send the request
        request.send(requestData || null);
    });
};



const $4c1271e3acbd5e6d$var$knownAdapters = {
    http: (0, $78e1ecbc56e8edf7$export$2e2bcd8739ae039),
    xhr: (0, $29f6b5de9f8c8b7a$export$2e2bcd8739ae039)
};
(0, $2c30869926b6e1e7$export$2e2bcd8739ae039).forEach($4c1271e3acbd5e6d$var$knownAdapters, (fn, value)=>{
    if (fn) {
        try {
            Object.defineProperty(fn, "name", {
                value: value
            });
        } catch (e) {
        // eslint-disable-next-line no-empty
        }
        Object.defineProperty(fn, "adapterName", {
            value: value
        });
    }
});
var $4c1271e3acbd5e6d$export$2e2bcd8739ae039 = {
    getAdapter: (adapters)=>{
        adapters = (0, $2c30869926b6e1e7$export$2e2bcd8739ae039).isArray(adapters) ? adapters : [
            adapters
        ];
        const { length: length } = adapters;
        let nameOrAdapter;
        let adapter;
        for(let i = 0; i < length; i++){
            nameOrAdapter = adapters[i];
            if (adapter = (0, $2c30869926b6e1e7$export$2e2bcd8739ae039).isString(nameOrAdapter) ? $4c1271e3acbd5e6d$var$knownAdapters[nameOrAdapter.toLowerCase()] : nameOrAdapter) break;
        }
        if (!adapter) {
            if (adapter === false) throw new (0, $158812891e7ba01a$export$2e2bcd8739ae039)(`Adapter ${nameOrAdapter} is not supported by the environment`, "ERR_NOT_SUPPORT");
            throw new Error((0, $2c30869926b6e1e7$export$2e2bcd8739ae039).hasOwnProp($4c1271e3acbd5e6d$var$knownAdapters, nameOrAdapter) ? `Adapter '${nameOrAdapter}' is not available in the build` : `Unknown adapter '${nameOrAdapter}'`);
        }
        if (!(0, $2c30869926b6e1e7$export$2e2bcd8739ae039).isFunction(adapter)) throw new TypeError("adapter is not a function");
        return adapter;
    },
    adapters: $4c1271e3acbd5e6d$var$knownAdapters
};


"use strict";
/**
 * Throws a `CanceledError` if cancellation has been requested.
 *
 * @param {Object} config The config that is to be used for the request
 *
 * @returns {void}
 */ function $b8d48be72303225f$var$throwIfCancellationRequested(config) {
    if (config.cancelToken) config.cancelToken.throwIfRequested();
    if (config.signal && config.signal.aborted) throw new (0, $cc2dc937308c98b6$export$2e2bcd8739ae039)(null, config);
}
function $b8d48be72303225f$export$2e2bcd8739ae039(config) {
    $b8d48be72303225f$var$throwIfCancellationRequested(config);
    config.headers = (0, $ec96b1f5b12d7568$export$2e2bcd8739ae039).from(config.headers);
    // Transform request data
    config.data = (0, $7ebc1eba1e1101b5$export$2e2bcd8739ae039).call(config, config.transformRequest);
    if ([
        "post",
        "put",
        "patch"
    ].indexOf(config.method) !== -1) config.headers.setContentType("application/x-www-form-urlencoded", false);
    const adapter = (0, $4c1271e3acbd5e6d$export$2e2bcd8739ae039).getAdapter(config.adapter || (0, $8b1b63524c69311f$export$2e2bcd8739ae039).adapter);
    return adapter(config).then(function onAdapterResolution(response) {
        $b8d48be72303225f$var$throwIfCancellationRequested(config);
        // Transform response data
        response.data = (0, $7ebc1eba1e1101b5$export$2e2bcd8739ae039).call(config, config.transformResponse, response);
        response.headers = (0, $ec96b1f5b12d7568$export$2e2bcd8739ae039).from(response.headers);
        return response;
    }, function onAdapterRejection(reason) {
        if (!(0, $e01286482f6b3060$export$2e2bcd8739ae039)(reason)) {
            $b8d48be72303225f$var$throwIfCancellationRequested(config);
            // Transform response data
            if (reason && reason.response) {
                reason.response.data = (0, $7ebc1eba1e1101b5$export$2e2bcd8739ae039).call(config, config.transformResponse, reason.response);
                reason.response.headers = (0, $ec96b1f5b12d7568$export$2e2bcd8739ae039).from(reason.response.headers);
            }
        }
        return Promise.reject(reason);
    });
}




"use strict";
const $9f596c3fed04cca8$var$headersToObject = (thing)=>thing instanceof (0, $ec96b1f5b12d7568$export$2e2bcd8739ae039) ? thing.toJSON() : thing;
function $9f596c3fed04cca8$export$2e2bcd8739ae039(config1, config2) {
    // eslint-disable-next-line no-param-reassign
    config2 = config2 || {};
    const config = {};
    function getMergedValue(target, source, caseless) {
        if ((0, $2c30869926b6e1e7$export$2e2bcd8739ae039).isPlainObject(target) && (0, $2c30869926b6e1e7$export$2e2bcd8739ae039).isPlainObject(source)) return (0, $2c30869926b6e1e7$export$2e2bcd8739ae039).merge.call({
            caseless: caseless
        }, target, source);
        else if ((0, $2c30869926b6e1e7$export$2e2bcd8739ae039).isPlainObject(source)) return (0, $2c30869926b6e1e7$export$2e2bcd8739ae039).merge({}, source);
        else if ((0, $2c30869926b6e1e7$export$2e2bcd8739ae039).isArray(source)) return source.slice();
        return source;
    }
    // eslint-disable-next-line consistent-return
    function mergeDeepProperties(a, b, caseless) {
        if (!(0, $2c30869926b6e1e7$export$2e2bcd8739ae039).isUndefined(b)) return getMergedValue(a, b, caseless);
        else if (!(0, $2c30869926b6e1e7$export$2e2bcd8739ae039).isUndefined(a)) return getMergedValue(undefined, a, caseless);
    }
    // eslint-disable-next-line consistent-return
    function valueFromConfig2(a, b) {
        if (!(0, $2c30869926b6e1e7$export$2e2bcd8739ae039).isUndefined(b)) return getMergedValue(undefined, b);
    }
    // eslint-disable-next-line consistent-return
    function defaultToConfig2(a, b) {
        if (!(0, $2c30869926b6e1e7$export$2e2bcd8739ae039).isUndefined(b)) return getMergedValue(undefined, b);
        else if (!(0, $2c30869926b6e1e7$export$2e2bcd8739ae039).isUndefined(a)) return getMergedValue(undefined, a);
    }
    // eslint-disable-next-line consistent-return
    function mergeDirectKeys(a, b, prop) {
        if (prop in config2) return getMergedValue(a, b);
        else if (prop in config1) return getMergedValue(undefined, a);
    }
    const mergeMap = {
        url: valueFromConfig2,
        method: valueFromConfig2,
        data: valueFromConfig2,
        baseURL: defaultToConfig2,
        transformRequest: defaultToConfig2,
        transformResponse: defaultToConfig2,
        paramsSerializer: defaultToConfig2,
        timeout: defaultToConfig2,
        timeoutMessage: defaultToConfig2,
        withCredentials: defaultToConfig2,
        adapter: defaultToConfig2,
        responseType: defaultToConfig2,
        xsrfCookieName: defaultToConfig2,
        xsrfHeaderName: defaultToConfig2,
        onUploadProgress: defaultToConfig2,
        onDownloadProgress: defaultToConfig2,
        decompress: defaultToConfig2,
        maxContentLength: defaultToConfig2,
        maxBodyLength: defaultToConfig2,
        beforeRedirect: defaultToConfig2,
        transport: defaultToConfig2,
        httpAgent: defaultToConfig2,
        httpsAgent: defaultToConfig2,
        cancelToken: defaultToConfig2,
        socketPath: defaultToConfig2,
        responseEncoding: defaultToConfig2,
        validateStatus: mergeDirectKeys,
        headers: (a, b)=>mergeDeepProperties($9f596c3fed04cca8$var$headersToObject(a), $9f596c3fed04cca8$var$headersToObject(b), true)
    };
    (0, $2c30869926b6e1e7$export$2e2bcd8739ae039).forEach(Object.keys(Object.assign({}, config1, config2)), function computeConfigValue(prop) {
        const merge = mergeMap[prop] || mergeDeepProperties;
        const configValue = merge(config1[prop], config2[prop], prop);
        (0, $2c30869926b6e1e7$export$2e2bcd8739ae039).isUndefined(configValue) && merge !== mergeDirectKeys || (config[prop] = configValue);
    });
    return config;
}



const $e422f4c8a16a0e78$export$a4ad2735b021c132 = "1.5.0";



"use strict";
const $45363656f73af7a7$var$validators = {};
// eslint-disable-next-line func-names
[
    "object",
    "boolean",
    "number",
    "function",
    "string",
    "symbol"
].forEach((type, i)=>{
    $45363656f73af7a7$var$validators[type] = function validator(thing) {
        return typeof thing === type || "a" + (i < 1 ? "n " : " ") + type;
    };
});
const $45363656f73af7a7$var$deprecatedWarnings = {};
/**
 * Transitional option validator
 *
 * @param {function|boolean?} validator - set to false if the transitional option has been removed
 * @param {string?} version - deprecated version / removed since version
 * @param {string?} message - some message with additional info
 *
 * @returns {function}
 */ $45363656f73af7a7$var$validators.transitional = function transitional(validator, version, message) {
    function formatMessage(opt, desc) {
        return "[Axios v" + (0, $e422f4c8a16a0e78$export$a4ad2735b021c132) + "] Transitional option '" + opt + "'" + desc + (message ? ". " + message : "");
    }
    // eslint-disable-next-line func-names
    return (value, opt, opts)=>{
        if (validator === false) throw new (0, $158812891e7ba01a$export$2e2bcd8739ae039)(formatMessage(opt, " has been removed" + (version ? " in " + version : "")), (0, $158812891e7ba01a$export$2e2bcd8739ae039).ERR_DEPRECATED);
        if (version && !$45363656f73af7a7$var$deprecatedWarnings[opt]) {
            $45363656f73af7a7$var$deprecatedWarnings[opt] = true;
            // eslint-disable-next-line no-console
            console.warn(formatMessage(opt, " has been deprecated since v" + version + " and will be removed in the near future"));
        }
        return validator ? validator(value, opt, opts) : true;
    };
};
/**
 * Assert object's properties type
 *
 * @param {object} options
 * @param {object} schema
 * @param {boolean?} allowUnknown
 *
 * @returns {object}
 */ function $45363656f73af7a7$var$assertOptions(options, schema, allowUnknown) {
    if (typeof options !== "object") throw new (0, $158812891e7ba01a$export$2e2bcd8739ae039)("options must be an object", (0, $158812891e7ba01a$export$2e2bcd8739ae039).ERR_BAD_OPTION_VALUE);
    const keys = Object.keys(options);
    let i = keys.length;
    while(i-- > 0){
        const opt = keys[i];
        const validator = schema[opt];
        if (validator) {
            const value = options[opt];
            const result = value === undefined || validator(value, opt, options);
            if (result !== true) throw new (0, $158812891e7ba01a$export$2e2bcd8739ae039)("option " + opt + " must be " + result, (0, $158812891e7ba01a$export$2e2bcd8739ae039).ERR_BAD_OPTION_VALUE);
            continue;
        }
        if (allowUnknown !== true) throw new (0, $158812891e7ba01a$export$2e2bcd8739ae039)("Unknown option " + opt, (0, $158812891e7ba01a$export$2e2bcd8739ae039).ERR_BAD_OPTION);
    }
}
var $45363656f73af7a7$export$2e2bcd8739ae039 = {
    assertOptions: $45363656f73af7a7$var$assertOptions,
    validators: $45363656f73af7a7$var$validators
};



"use strict";
const $7e5bd7ec980d119c$var$validators = (0, $45363656f73af7a7$export$2e2bcd8739ae039).validators;
/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 *
 * @return {Axios} A new instance of Axios
 */ class $7e5bd7ec980d119c$var$Axios {
    /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */ request(configOrUrl, config) {
        /*eslint no-param-reassign:0*/ // Allow for axios('example/url'[, config]) a la fetch API
        if (typeof configOrUrl === "string") {
            config = config || {};
            config.url = configOrUrl;
        } else config = configOrUrl || {};
        config = (0, $9f596c3fed04cca8$export$2e2bcd8739ae039)(this.defaults, config);
        const { transitional: transitional, paramsSerializer: paramsSerializer, headers: headers } = config;
        if (transitional !== undefined) (0, $45363656f73af7a7$export$2e2bcd8739ae039).assertOptions(transitional, {
            silentJSONParsing: $7e5bd7ec980d119c$var$validators.transitional($7e5bd7ec980d119c$var$validators.boolean),
            forcedJSONParsing: $7e5bd7ec980d119c$var$validators.transitional($7e5bd7ec980d119c$var$validators.boolean),
            clarifyTimeoutError: $7e5bd7ec980d119c$var$validators.transitional($7e5bd7ec980d119c$var$validators.boolean)
        }, false);
        if (paramsSerializer != null) {
            if ((0, $2c30869926b6e1e7$export$2e2bcd8739ae039).isFunction(paramsSerializer)) config.paramsSerializer = {
                serialize: paramsSerializer
            };
            else (0, $45363656f73af7a7$export$2e2bcd8739ae039).assertOptions(paramsSerializer, {
                encode: $7e5bd7ec980d119c$var$validators.function,
                serialize: $7e5bd7ec980d119c$var$validators.function
            }, true);
        }
        // Set config.method
        config.method = (config.method || this.defaults.method || "get").toLowerCase();
        // Flatten headers
        let contextHeaders = headers && (0, $2c30869926b6e1e7$export$2e2bcd8739ae039).merge(headers.common, headers[config.method]);
        headers && (0, $2c30869926b6e1e7$export$2e2bcd8739ae039).forEach([
            "delete",
            "get",
            "head",
            "post",
            "put",
            "patch",
            "common"
        ], (method)=>{
            delete headers[method];
        });
        config.headers = (0, $ec96b1f5b12d7568$export$2e2bcd8739ae039).concat(contextHeaders, headers);
        // filter out skipped interceptors
        const requestInterceptorChain = [];
        let synchronousRequestInterceptors = true;
        this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
            if (typeof interceptor.runWhen === "function" && interceptor.runWhen(config) === false) return;
            synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;
            requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
        });
        const responseInterceptorChain = [];
        this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
            responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
        });
        let promise;
        let i = 0;
        let len;
        if (!synchronousRequestInterceptors) {
            const chain = [
                (0, $b8d48be72303225f$export$2e2bcd8739ae039).bind(this),
                undefined
            ];
            chain.unshift.apply(chain, requestInterceptorChain);
            chain.push.apply(chain, responseInterceptorChain);
            len = chain.length;
            promise = Promise.resolve(config);
            while(i < len)promise = promise.then(chain[i++], chain[i++]);
            return promise;
        }
        len = requestInterceptorChain.length;
        let newConfig = config;
        i = 0;
        while(i < len){
            const onFulfilled = requestInterceptorChain[i++];
            const onRejected = requestInterceptorChain[i++];
            try {
                newConfig = onFulfilled(newConfig);
            } catch (error) {
                onRejected.call(this, error);
                break;
            }
        }
        try {
            promise = (0, $b8d48be72303225f$export$2e2bcd8739ae039).call(this, newConfig);
        } catch (error) {
            return Promise.reject(error);
        }
        i = 0;
        len = responseInterceptorChain.length;
        while(i < len)promise = promise.then(responseInterceptorChain[i++], responseInterceptorChain[i++]);
        return promise;
    }
    getUri(config) {
        config = (0, $9f596c3fed04cca8$export$2e2bcd8739ae039)(this.defaults, config);
        const fullPath = (0, $f28dd6eb0926cebf$export$2e2bcd8739ae039)(config.baseURL, config.url);
        return (0, $7248f3898d25e541$export$2e2bcd8739ae039)(fullPath, config.params, config.paramsSerializer);
    }
    constructor(instanceConfig){
        this.defaults = instanceConfig;
        this.interceptors = {
            request: new (0, $6a40e377d7a70a23$export$2e2bcd8739ae039)(),
            response: new (0, $6a40e377d7a70a23$export$2e2bcd8739ae039)()
        };
    }
}
// Provide aliases for supported request methods
(0, $2c30869926b6e1e7$export$2e2bcd8739ae039).forEach([
    "delete",
    "get",
    "head",
    "options"
], function forEachMethodNoData(method) {
    /*eslint func-names:0*/ $7e5bd7ec980d119c$var$Axios.prototype[method] = function(url, config) {
        return this.request((0, $9f596c3fed04cca8$export$2e2bcd8739ae039)(config || {}, {
            method: method,
            url: url,
            data: (config || {}).data
        }));
    };
});
(0, $2c30869926b6e1e7$export$2e2bcd8739ae039).forEach([
    "post",
    "put",
    "patch"
], function forEachMethodWithData(method) {
    /*eslint func-names:0*/ function generateHTTPMethod(isForm) {
        return function httpMethod(url, data, config) {
            return this.request((0, $9f596c3fed04cca8$export$2e2bcd8739ae039)(config || {}, {
                method: method,
                headers: isForm ? {
                    "Content-Type": "multipart/form-data"
                } : {},
                url: url,
                data: data
            }));
        };
    }
    $7e5bd7ec980d119c$var$Axios.prototype[method] = generateHTTPMethod();
    $7e5bd7ec980d119c$var$Axios.prototype[method + "Form"] = generateHTTPMethod(true);
});
var $7e5bd7ec980d119c$export$2e2bcd8739ae039 = $7e5bd7ec980d119c$var$Axios;







"use strict";
/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @param {Function} executor The executor function.
 *
 * @returns {CancelToken}
 */ class $f20be6a42949f9b2$var$CancelToken {
    /**
   * Throws a `CanceledError` if cancellation has been requested.
   */ throwIfRequested() {
        if (this.reason) throw this.reason;
    }
    /**
   * Subscribe to the cancel signal
   */ subscribe(listener) {
        if (this.reason) {
            listener(this.reason);
            return;
        }
        if (this._listeners) this._listeners.push(listener);
        else this._listeners = [
            listener
        ];
    }
    /**
   * Unsubscribe from the cancel signal
   */ unsubscribe(listener) {
        if (!this._listeners) return;
        const index = this._listeners.indexOf(listener);
        if (index !== -1) this._listeners.splice(index, 1);
    }
    /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */ static source() {
        let cancel;
        const token = new $f20be6a42949f9b2$var$CancelToken(function executor(c) {
            cancel = c;
        });
        return {
            token: token,
            cancel: cancel
        };
    }
    constructor(executor){
        if (typeof executor !== "function") throw new TypeError("executor must be a function.");
        let resolvePromise;
        this.promise = new Promise(function promiseExecutor(resolve) {
            resolvePromise = resolve;
        });
        const token = this;
        // eslint-disable-next-line func-names
        this.promise.then((cancel)=>{
            if (!token._listeners) return;
            let i = token._listeners.length;
            while(i-- > 0)token._listeners[i](cancel);
            token._listeners = null;
        });
        // eslint-disable-next-line func-names
        this.promise.then = (onfulfilled)=>{
            let _resolve;
            // eslint-disable-next-line func-names
            const promise = new Promise((resolve)=>{
                token.subscribe(resolve);
                _resolve = resolve;
            }).then(onfulfilled);
            promise.cancel = function reject() {
                token.unsubscribe(_resolve);
            };
            return promise;
        };
        executor(function cancel(message, config, request) {
            if (token.reason) // Cancellation has already been requested
            return;
            token.reason = new (0, $cc2dc937308c98b6$export$2e2bcd8739ae039)(message, config, request);
            resolvePromise(token.reason);
        });
    }
}
var $f20be6a42949f9b2$export$2e2bcd8739ae039 = $f20be6a42949f9b2$var$CancelToken;






"use strict";
function $df2427e4447ca133$export$2e2bcd8739ae039(callback) {
    return function wrap(arr) {
        return callback.apply(null, arr);
    };
}



"use strict";
function $614fe8b950bb6704$export$2e2bcd8739ae039(payload) {
    return (0, $2c30869926b6e1e7$export$2e2bcd8739ae039).isObject(payload) && payload.isAxiosError === true;
}




const $eaf0a140957a5251$var$HttpStatusCode = {
    Continue: 100,
    SwitchingProtocols: 101,
    Processing: 102,
    EarlyHints: 103,
    Ok: 200,
    Created: 201,
    Accepted: 202,
    NonAuthoritativeInformation: 203,
    NoContent: 204,
    ResetContent: 205,
    PartialContent: 206,
    MultiStatus: 207,
    AlreadyReported: 208,
    ImUsed: 226,
    MultipleChoices: 300,
    MovedPermanently: 301,
    Found: 302,
    SeeOther: 303,
    NotModified: 304,
    UseProxy: 305,
    Unused: 306,
    TemporaryRedirect: 307,
    PermanentRedirect: 308,
    BadRequest: 400,
    Unauthorized: 401,
    PaymentRequired: 402,
    Forbidden: 403,
    NotFound: 404,
    MethodNotAllowed: 405,
    NotAcceptable: 406,
    ProxyAuthenticationRequired: 407,
    RequestTimeout: 408,
    Conflict: 409,
    Gone: 410,
    LengthRequired: 411,
    PreconditionFailed: 412,
    PayloadTooLarge: 413,
    UriTooLong: 414,
    UnsupportedMediaType: 415,
    RangeNotSatisfiable: 416,
    ExpectationFailed: 417,
    ImATeapot: 418,
    MisdirectedRequest: 421,
    UnprocessableEntity: 422,
    Locked: 423,
    FailedDependency: 424,
    TooEarly: 425,
    UpgradeRequired: 426,
    PreconditionRequired: 428,
    TooManyRequests: 429,
    RequestHeaderFieldsTooLarge: 431,
    UnavailableForLegalReasons: 451,
    InternalServerError: 500,
    NotImplemented: 501,
    BadGateway: 502,
    ServiceUnavailable: 503,
    GatewayTimeout: 504,
    HttpVersionNotSupported: 505,
    VariantAlsoNegotiates: 506,
    InsufficientStorage: 507,
    LoopDetected: 508,
    NotExtended: 510,
    NetworkAuthenticationRequired: 511
};
Object.entries($eaf0a140957a5251$var$HttpStatusCode).forEach(([key, value])=>{
    $eaf0a140957a5251$var$HttpStatusCode[value] = key;
});
var $eaf0a140957a5251$export$2e2bcd8739ae039 = $eaf0a140957a5251$var$HttpStatusCode;


"use strict";
/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 *
 * @returns {Axios} A new instance of Axios
 */ function $4a051b97f96fc63d$var$createInstance(defaultConfig) {
    const context = new (0, $7e5bd7ec980d119c$export$2e2bcd8739ae039)(defaultConfig);
    const instance = (0, $3c09cdaada4cd00d$export$2e2bcd8739ae039)((0, $7e5bd7ec980d119c$export$2e2bcd8739ae039).prototype.request, context);
    // Copy axios.prototype to instance
    (0, $2c30869926b6e1e7$export$2e2bcd8739ae039).extend(instance, (0, $7e5bd7ec980d119c$export$2e2bcd8739ae039).prototype, context, {
        allOwnKeys: true
    });
    // Copy context to instance
    (0, $2c30869926b6e1e7$export$2e2bcd8739ae039).extend(instance, context, null, {
        allOwnKeys: true
    });
    // Factory for creating new instances
    instance.create = function create(instanceConfig) {
        return $4a051b97f96fc63d$var$createInstance((0, $9f596c3fed04cca8$export$2e2bcd8739ae039)(defaultConfig, instanceConfig));
    };
    return instance;
}
// Create the default instance to be exported
const $4a051b97f96fc63d$var$axios = $4a051b97f96fc63d$var$createInstance((0, $8b1b63524c69311f$export$2e2bcd8739ae039));
// Expose Axios class to allow class inheritance
$4a051b97f96fc63d$var$axios.Axios = (0, $7e5bd7ec980d119c$export$2e2bcd8739ae039);
// Expose Cancel & CancelToken
$4a051b97f96fc63d$var$axios.CanceledError = (0, $cc2dc937308c98b6$export$2e2bcd8739ae039);
$4a051b97f96fc63d$var$axios.CancelToken = (0, $f20be6a42949f9b2$export$2e2bcd8739ae039);
$4a051b97f96fc63d$var$axios.isCancel = (0, $e01286482f6b3060$export$2e2bcd8739ae039);
$4a051b97f96fc63d$var$axios.VERSION = (0, $e422f4c8a16a0e78$export$a4ad2735b021c132);
$4a051b97f96fc63d$var$axios.toFormData = (0, $268c3eee7f562394$export$2e2bcd8739ae039);
// Expose AxiosError class
$4a051b97f96fc63d$var$axios.AxiosError = (0, $158812891e7ba01a$export$2e2bcd8739ae039);
// alias for CanceledError for backward compatibility
$4a051b97f96fc63d$var$axios.Cancel = $4a051b97f96fc63d$var$axios.CanceledError;
// Expose all/spread
$4a051b97f96fc63d$var$axios.all = function all(promises) {
    return Promise.all(promises);
};
$4a051b97f96fc63d$var$axios.spread = (0, $df2427e4447ca133$export$2e2bcd8739ae039);
// Expose isAxiosError
$4a051b97f96fc63d$var$axios.isAxiosError = (0, $614fe8b950bb6704$export$2e2bcd8739ae039);
// Expose mergeConfig
$4a051b97f96fc63d$var$axios.mergeConfig = (0, $9f596c3fed04cca8$export$2e2bcd8739ae039);
$4a051b97f96fc63d$var$axios.AxiosHeaders = (0, $ec96b1f5b12d7568$export$2e2bcd8739ae039);
$4a051b97f96fc63d$var$axios.formToJSON = (thing)=>(0, $b510c72164a424ab$export$2e2bcd8739ae039)((0, $2c30869926b6e1e7$export$2e2bcd8739ae039).isHTMLForm(thing) ? new FormData(thing) : thing);
$4a051b97f96fc63d$var$axios.getAdapter = (0, $4c1271e3acbd5e6d$export$2e2bcd8739ae039).getAdapter;
$4a051b97f96fc63d$var$axios.HttpStatusCode = (0, $eaf0a140957a5251$export$2e2bcd8739ae039);
$4a051b97f96fc63d$var$axios.default = $4a051b97f96fc63d$var$axios;
var // this module should only have a default export
$4a051b97f96fc63d$export$2e2bcd8739ae039 = $4a051b97f96fc63d$var$axios;


// This module is intended to unwrap Axios default export as named.
// Keep top-level export same with static properties
// so that it can keep same with es module or cjs
const { Axios: $caa17909d4ea6f1f$export$1c00760e9e5a4e95, AxiosError: $caa17909d4ea6f1f$export$c1fbed17c2f6a328, CanceledError: $caa17909d4ea6f1f$export$1ab0c6b20d94fa14, isCancel: $caa17909d4ea6f1f$export$3b22524397b493c6, CancelToken: $caa17909d4ea6f1f$export$fd08e3cb425f0d61, VERSION: $caa17909d4ea6f1f$export$a4ad2735b021c132, all: $caa17909d4ea6f1f$export$84bf76cd7afc7469, Cancel: $caa17909d4ea6f1f$export$848c9b7ead0df967, isAxiosError: $caa17909d4ea6f1f$export$fbafdbe06a5b5a9a, spread: $caa17909d4ea6f1f$export$3ae0fd4797ed47c8, toFormData: $caa17909d4ea6f1f$export$10ae0d317ea97f8b, AxiosHeaders: $caa17909d4ea6f1f$export$4e7d6ff0f3e6520, HttpStatusCode: $caa17909d4ea6f1f$export$a972f69c851492b3, formToJSON: $caa17909d4ea6f1f$export$86d7c59254d6a2c9, getAdapter: $caa17909d4ea6f1f$export$17ddc20a97d669e2, mergeConfig: $caa17909d4ea6f1f$export$7ec1ebcfa9d8bd6a } = (0, $4a051b97f96fc63d$export$2e2bcd8739ae039);


const $5fb6b10ed4f86a19$export$10dd65538540bee3 = {
    getAnonymousUserMe: "/uptogether/anonymous-user/me",
    createAnonymousUser: "/uptogether/anonymous-user",
    maintenanceStatus: "/uptogether/maintenance-status",
    matchmake: "/uptogether/matchmake"
};
/***********************************************************/ /*                                                         */ /*          Client-Side Only Request Utilities             */ /*                                                         */ /***********************************************************/ const $5fb6b10ed4f86a19$var$parseResponseAndThrowIfError = (response)=>{
    const responseData = response.data;
    const responseHeaders = response.headers;
    const potentialRefreshToken = responseHeaders["x-smg-refreshed-token"];
    if (potentialRefreshToken !== undefined && potentialRefreshToken !== null && potentialRefreshToken !== "") {
        console.info("Server gave us an updated auth token! Overwriting the one in local storage");
        (0, $f6601dd412e992e3$export$1b8cd2d0ef9a8e5d)((0, $f6601dd412e992e3$export$c02c1f4c11d08446).AuthToken, potentialRefreshToken);
    }
    if (response.status === 200 || response.status === 201) return responseData;
    else if (response.status === 404 || response.status === 409 || response.status === 400 || response.status === 401 || response.status === 403 || response.status === 500) {
        if (responseData.error === "TokenExpired") {
            console.error("Auth token expired!");
            throw new (0, $a0dc081d2781de33$export$30df2395274cb2d1)("Users auth token has expired!");
        } else if (responseData.error === "AllServersFull") {
            console.error("All servers are full!");
            throw new (0, $a0dc081d2781de33$export$d43b4070434a7c5e)("All servers are full! Try again later.");
        } else if (responseData.error === "NoServersAvailable") {
            console.error("No servers are available!");
            throw new (0, $a0dc081d2781de33$export$c7df658ddd676e46)("No servers are available! Try again later.");
        } else if (responseData.error === "UserNotFound" || responseData.error === "AnonymousUserNotFound") {
            console.error("User not found!");
            throw new (0, $a0dc081d2781de33$export$7333e7db5e5d49a)("No user found with matching ID");
        } else {
            console.error("Unknown API Error!", responseData.error);
            throw new (0, $a0dc081d2781de33$export$cde8491b20a04fb4)("An unhandled API error has occurred");
        }
    }
};
const $5fb6b10ed4f86a19$var$getRequest = async (url, headers)=>{
    const rawResponse = await (0, $4a051b97f96fc63d$export$2e2bcd8739ae039).get(url, {
        headers: {
            ...headers
        }
    });
    return $5fb6b10ed4f86a19$var$parseResponseAndThrowIfError(rawResponse);
};
const $5fb6b10ed4f86a19$var$postRequest = async (url, body, headers)=>{
    const rawResponse = await (0, $4a051b97f96fc63d$export$2e2bcd8739ae039).post(url, body, {
        headers: {
            "Content-Type": "application/json",
            ...headers
        }
    });
    return $5fb6b10ed4f86a19$var$parseResponseAndThrowIfError(rawResponse);
};
/***************************************/ /*                                     */ /*     Anonymous User Routes           */ /*                                     */ /***************************************/ const $5fb6b10ed4f86a19$var$getAnonymousUser = async (id)=>{
    const response = await $5fb6b10ed4f86a19$var$getRequest(`${"https://api.trigonometryexplained.com"}${$5fb6b10ed4f86a19$export$10dd65538540bee3.getAnonymousUserMe}?anonymousUserId=${id}`);
    return response;
};
const $5fb6b10ed4f86a19$export$42667f60e0bdcfe0 = async (userId, retries = 0)=>{
    try {
        return await $5fb6b10ed4f86a19$var$getAnonymousUser(userId);
    } catch (error) {
        // console.error(`Caught error in getAnonymousUserWithRetries, retrying... but here's the error: ${error.message}`);
        // console.error(error);
        await (0, $9f2918ccbc980d31$export$e772c8ff12451969)(3000);
        if (retries < 10) return await $5fb6b10ed4f86a19$export$42667f60e0bdcfe0(userId, retries + 1);
        else {
            console.error(`Maximum retries exceeded in getAnonymousUserWithRetries, throwing error: ${error.message}`);
            Game.UI.ShowErrorScreen("An error occurred while trying to connect to the server. Please try again later.", true);
        }
    }
};
const $5fb6b10ed4f86a19$var$createAnonymousUser = async ()=>{
    const lang = navigator.language;
    const userAgentString = navigator.userAgent;
    const originatingDomain = globalThis.OriginatingDomain;
    const documentReferrer = globalThis.DocumentReferrer;
    const createBody = {
        lang: lang,
        userAgentString: userAgentString,
        originatingDomain: originatingDomain,
        documentReferrer: documentReferrer
    };
    const response = await $5fb6b10ed4f86a19$var$postRequest(`${"https://api.trigonometryexplained.com"}${$5fb6b10ed4f86a19$export$10dd65538540bee3.createAnonymousUser}`, createBody);
    return response;
};
const $5fb6b10ed4f86a19$export$f16d887d0c3c04c7 = async (retries = 0)=>{
    try {
        return await $5fb6b10ed4f86a19$var$createAnonymousUser();
    } catch (error) {
        // console.error(`Caught error in createAnonymousUserWithRetries, retrying... but here's the error: ${error.message}`);
        // console.error(error);
        await (0, $9f2918ccbc980d31$export$e772c8ff12451969)(3000);
        if (retries < 10) return await $5fb6b10ed4f86a19$export$f16d887d0c3c04c7(retries + 1);
        else {
            console.error(`Maximum retries exceeded in createAnonymousUserWithRetries, throwing error: ${error.message}`);
            Game.UI.ShowErrorScreen("An error occurred while trying to connect to the server. Please try again later.", true);
        }
    }
};
const $5fb6b10ed4f86a19$var$checkMaintenanceModeRequest = async ()=>{
    const url = `${"https://api.trigonometryexplained.com"}${$5fb6b10ed4f86a19$export$10dd65538540bee3.maintenanceStatus}`;
    // console.log("hitting url:", url);
    const response = await $5fb6b10ed4f86a19$var$getRequest(url);
    const res = response;
    return res;
};
const $5fb6b10ed4f86a19$export$6100115752b4c7cd = async (retries = 0)=>{
    try {
        return await $5fb6b10ed4f86a19$var$checkMaintenanceModeRequest();
    } catch (error) {
        // console.error(`Caught error in checkMaintenanceModeRequestWithRetries, retrying... but here's the error: ${error.message}`);
        // console.error(error);
        await (0, $9f2918ccbc980d31$export$e772c8ff12451969)(3000);
        if (retries < 5) return await $5fb6b10ed4f86a19$export$6100115752b4c7cd(retries + 1);
        else {
            console.error(`Maximum retries exceeded in checkMaintenanceModeRequestWithRetries, throwing error: ${error.message}`);
            return {
                isInMaintenanceMode: true
            };
        }
    }
};
const $5fb6b10ed4f86a19$var$matchmakeRequest = async (id, gameVersion)=>{
    const matchmakingUrl = `${"https://api.trigonometryexplained.com"}${$5fb6b10ed4f86a19$export$10dd65538540bee3.matchmake}?anonymousUserId=${id}&gameVersion=${gameVersion}`;
    console.info("Matchmaking URL:", matchmakingUrl);
    const response = await $5fb6b10ed4f86a19$var$getRequest(matchmakingUrl);
    return response;
};
const $5fb6b10ed4f86a19$export$555f0c6c7a756891 = async (userId, gameVersion, retries = 0)=>{
    try {
        return await $5fb6b10ed4f86a19$var$matchmakeRequest(userId, gameVersion);
    } catch (error) {
        // console.error(`Caught error in matchmakeRequestWithRetries, retrying... but here's the error: ${error.message}`);
        // console.error(error);
        await (0, $9f2918ccbc980d31$export$e772c8ff12451969)(1000);
        if (retries < 5) return await $5fb6b10ed4f86a19$export$555f0c6c7a756891(userId, gameVersion, retries + 1);
        else {
            console.error(`Maximum retries exceeded in matchmakeRequestWithRetries, throwing error: ${error.message}`);
            Game.UI.ShowErrorScreen("An error occurred while trying to connect to the server. Please try again later.", true);
        }
    }
};



const { Server: $e93696f7341f475d$var$Server } = (0, $b80b6e4c153785d9$export$29cd7b75162a9425);
// Helper function to normalize angles to the range [-Math.PI, Math.PI]
function $e93696f7341f475d$var$normalizeAngle(angle) {
    while(angle < -Math.PI)angle += 2 * Math.PI;
    while(angle > Math.PI)angle -= 2 * Math.PI;
    return angle;
}
class $e93696f7341f475d$export$4a5dace5f570523 extends (0, $fc7b18e354612676$export$5d53140180d567a1) {
    Initialize() {}
    getSystemName() {
        return "Netcode";
    }
    async Connect(serverAddress, connectionToken, gameClientVersion) {
        try {
            const res = await this.client.connect(serverAddress, {
                connectionToken: connectionToken,
                gameClientVersion: gameClientVersion
            });
            this.LogInfo(`Connection response: ${res}`);
            this.isConnected = true;
            window.addEventListener("beforeunload", (__e)=>{
            // TODO: accidental closing tab prevention
            });
            // @ts-ignore
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            this.client.adapter.socket.onerror = (event)=>{
                console.log("Socket error!", event);
                Game.UI.ShowErrorScreen("Disconnected from server! The servers may be going down for an update. Try again in a few minutes.", true);
            };
            // @ts-ignore
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            this.client.adapter.socket.addEventListener("error", (event)=>{
                console.log("Socket error!", event);
                Game.UI.ShowErrorScreen("Disconnected from server! The servers may be going down for an update. Try again in a few minutes.", true);
            });
            // TODO: this will eventually be surfaced via the this.client interface, for now dig deep to find it
            this.client.adapter.socket.addEventListener("close", ()=>{
                Game.UI.ShowErrorScreen("Disconnected from server! The servers may be going down for an update. Try again in a few minutes.", true);
                console.log("Socket to server closed!");
                this.isConnected = false;
            // TODO: sudden disconnect graceful error handling
            });
        } catch (err) {
            this.LogError("connection error");
            this.LogError(typeof err);
            this.LogError(err);
            let reasonExplanation;
            if (err === (0, $de4f7960cd805115$export$cd1c2f7f06852a53).GameClientOutOfDate) reasonExplanation = (0, $34a8d0dc3ef4dba1$export$625550452a3fa3ec)("error_screen__client_out_of_date");
            else if (err === (0, $de4f7960cd805115$export$cd1c2f7f06852a53).InvalidConnectionToken) reasonExplanation = (0, $34a8d0dc3ef4dba1$export$625550452a3fa3ec)("error_screen__invalid_connection");
            else if (err === (0, $de4f7960cd805115$export$cd1c2f7f06852a53).PlayerAlreadyLoggedIn) reasonExplanation = (0, $34a8d0dc3ef4dba1$export$625550452a3fa3ec)("error_screen__already_logged_in");
            else reasonExplanation = (0, $34a8d0dc3ef4dba1$export$625550452a3fa3ec)("error_screen__unknown_reason");
            console.log("Connection error:", reasonExplanation, err);
            Game.UI.ShowErrorScreen((0, $34a8d0dc3ef4dba1$export$625550452a3fa3ec)("error_screen__disconnected_from_server"), true);
            return;
        }
        Game.EmitEvent("LoadEvent", {
            eventName: "NetcodeReady"
        });
    }
    ChangeSkin(character) {
        const changeSkinCommand = {
            ntype: (0, $7c910687071ab881$export$f7cab339749a57d7).ChangeSkinCommand,
            newSkin: character
        };
        this.client.addCommand(changeSkinCommand);
    }
    ChangeTrail(trail) {
        const newParticleTrailSelection = {
            ntype: (0, $7c910687071ab881$export$f7cab339749a57d7).ParticleTrailCommand,
            particleTrail: trail
        };
        Game.Netcode.SendCommand(newParticleTrailSelection);
    }
    Update(deltaTimeS, __deltaTimeMS, __currentTimestamp) {
        if (this.isConnected) {
            // Interpolate two server ticks worth of data
            const interpolatorState = this.interpolator.getInterpolatedState($e93696f7341f475d$var$Server.TARGET_DELTA_IN_MS * 2);
            while(this.client.network.messages.length > 0)Game.ProcessMessage(this.client.network.messages.pop());
            interpolatorState.forEach((snapshot)=>{
                snapshot.createEntities.forEach((entityToCreate)=>{
                    Game.AddEntity(entityToCreate);
                });
                snapshot.updateEntities.forEach((entityUpdatePayload)=>{
                    Game.UpdateEntity(entityUpdatePayload);
                });
                snapshot.deleteEntities.forEach((nid)=>{
                    Game.DeleteEntity(nid);
                });
            });
            // Only send input commands if our server-side entity is both fully created locally, as well as alive, and hasnt extracted successfully
            if (this.serverSideSelfReady && this.windowHasFocus) {
                if (Game.Renderer.GetMyLocalEntity() !== undefined) {
                    // Movement inputs
                    const forward = Game.Input.IsKeyDown("KeyW") || Game.Input.IsKeyDown("ArrowUp"); //|| Game.Input.JoystickIsForward();
                    const back = Game.Input.IsKeyDown("KeyS") || Game.Input.IsKeyDown("ArrowDown"); //|| Game.Input.JoystickIsBack();
                    const left = Game.Input.IsKeyDown("KeyA") || Game.Input.IsKeyDown("ArrowLeft"); //|| Game.Input.JoystickIsLeft();
                    const right = Game.Input.IsKeyDown("KeyD") || Game.Input.IsKeyDown("ArrowRight"); //|| Game.Input.JoystickIsRight();
                    const wantsToRespawnAtCheckpoint = Game.Input.IsKeyDown("KeyR") || Game.UI.PressedRestartCheckpointButtonThisFrame();
                    // console.log("@@@ wantsToRespawnAtCheckpoint", wantsToRespawnAtCheckpoint);
                    const wantsToRestartRun = Game.UI.PressedRestartRunButtonThisFrame();
                    // if (wantsToRestartRun) {
                    //     console.log("@@@ wantsToRestartRun", wantsToRestartRun);
                    // }
                    const isMobile = IsMobile;
                    const playerIsMoving = Game.Input.MobilePlayerIsMoving;
                    const mobileXDirection = Game.Input.GetMobileXDirection();
                    const mobileZDirection = Game.Input.GetMobileZDirection();
                    const mobileYRotation = Game.Input.GetMobileRotationAngle();
                    const mobileJoystickStrengthMultiplier = Game.Input.GetMobileJoystickStrengthMovementMultiplier();
                    // console.log("Game.Input.IsKeyDown('Space')", Game.Input.IsKeyDown("Space"));
                    // console.log("Game.Input.VirtualJumpIsBeingPressed()", Game.Input.VirtualJumpIsBeingPressed());
                    let jump = false;
                    if (Game.Input.IsKeyDown("Space") || Game.Input.VirtualJumpIsBeingPressed()) jump = true;
                    const rotX = Game.Renderer.PlayerRotationProxyCube.rotation.x;
                    const rotY = Game.Renderer.PlayerRotationProxyCube.rotation.y;
                    const rotZ = Game.Renderer.PlayerRotationProxyCube.rotation.z;
                    let newRotY = rotY;
                    let oldRotY;
                    if ((0, $b80b6e4c153785d9$export$29cd7b75162a9425).Player.ENABLE_PREDICTION && Game.Predictor.GetPredictedEntity() !== undefined) oldRotY = Game.Predictor.GetPredictedEntity().rotY;
                    else oldRotY = Game.Renderer.GetMyLocalEntity().rotY;
                    if (forward) {
                        if (right) // Calculate the new rotation for moving forward and to the right
                        newRotY = rotY - Math.PI / 4;
                        else if (left) // Calculate the new rotation for moving forward and to the left
                        newRotY = rotY + Math.PI / 4;
                        else // Calculate the new rotation for moving forward
                        newRotY = rotY;
                    } else if (back) {
                        if (right) // Calculate the new rotation for moving back and to the right
                        newRotY = rotY - 3 * Math.PI / 4;
                        else if (left) // Calculate the new rotation for moving back and to the left
                        newRotY = rotY + 3 * Math.PI / 4;
                        else // Calculate the opposite direction for moving back
                        newRotY = rotY + Math.PI;
                    } else if (right) // Calculate the new rotation for strafing right
                    newRotY = rotY - Math.PI / 2;
                    else if (left) // Calculate the new rotation for strafing left
                    newRotY = rotY + Math.PI / 2;
                    else newRotY = oldRotY;
                    // Calculate the shortest rotation difference
                    const rotationDifference = $e93696f7341f475d$var$normalizeAngle(newRotY - oldRotY);
                    // Adjust the final rotation based on the shortest path and interpolate
                    const finalYRot = oldRotY + rotationDifference * (this.characterTurnSpeed * deltaTimeS);
                    let inputCommand;
                    if (Game.UI.PointerIsCurrentlyLocked()) {
                        // apply the rotation
                        Game.Renderer.UpdateLocalEntityRotation(rotX, finalYRot, rotZ);
                        inputCommand = {
                            ntype: (0, $7c910687071ab881$export$f7cab339749a57d7).InputCommand,
                            forward: forward,
                            back: back,
                            left: left,
                            right: right,
                            jump: jump,
                            rotX: rotX,
                            rotY: rotY,
                            rotZ: rotZ,
                            isMobile: isMobile,
                            playerIsMoving: playerIsMoving,
                            mobileXDirection: mobileXDirection,
                            mobileZDirection: mobileZDirection,
                            mobileYRotation: mobileYRotation,
                            mobileSpeedMultiplier: mobileJoystickStrengthMultiplier,
                            visualModelRotation: finalYRot,
                            wantsToRespawnAtCheckpoint: wantsToRespawnAtCheckpoint,
                            wantsToRestartRun: wantsToRestartRun,
                            delta: deltaTimeS
                        };
                    } else inputCommand = {
                        ntype: (0, $7c910687071ab881$export$f7cab339749a57d7).InputCommand,
                        forward: false,
                        back: false,
                        left: false,
                        right: false,
                        jump: jump,
                        rotX: rotX,
                        rotY: rotY,
                        rotZ: rotZ,
                        isMobile: isMobile,
                        playerIsMoving: playerIsMoving,
                        mobileXDirection: mobileXDirection,
                        mobileZDirection: mobileZDirection,
                        mobileYRotation: mobileYRotation,
                        mobileSpeedMultiplier: mobileJoystickStrengthMultiplier,
                        visualModelRotation: finalYRot,
                        wantsToRespawnAtCheckpoint: wantsToRespawnAtCheckpoint,
                        wantsToRestartRun: wantsToRestartRun,
                        delta: deltaTimeS
                    };
                    if ((0, $b80b6e4c153785d9$export$29cd7b75162a9425).Player.ENABLE_PREDICTION && this.predictionReady) Game.Predictor.PredictPlayerInputCommand(inputCommand);
                    this.client.addCommand(inputCommand);
                }
            }
            this.client.flush();
        }
    }
    SendCommand(command) {
        this.client.addCommand(command);
    }
    Cleanup() {
        this.LogInfo("Cleaning up...");
    }
    constructor(){
        super();
        this.predictionReady = false;
        this.serverSideSelfReady = false;
        this.isConnected = false;
        this.windowHasFocus = true;
        this.characterTurnSpeed = 16;
        Game.ListenForEvent("Identity::Identified", async (data)=>{
            try {
                const { identity: identity } = data;
                // console.log("((netcode)) Identity::Identified", identity);
                const { _id: _id } = identity;
                if (window.location.href.includes("localhost:1234")) this.Connect("ws://localhost:8001", _id, (0, $b80b6e4c153785d9$export$29cd7b75162a9425).Game.GAME_VERSION);
                else {
                    const matchmakingResult = await (0, $5fb6b10ed4f86a19$export$555f0c6c7a756891)(_id, (0, $b80b6e4c153785d9$export$29cd7b75162a9425).Game.GAME_VERSION);
                    if (matchmakingResult === undefined) throw new Error("Failed to matchmake!");
                    // console.info("Got matchmaking response from backend:", matchmakingResult);
                    const { server: server } = matchmakingResult;
                    this.Connect(server, _id, (0, $b80b6e4c153785d9$export$29cd7b75162a9425).Game.GAME_VERSION);
                }
            } catch (e) {
                console.error("An error occurred attempting to connect to the server!", e);
                Game.UI.ShowErrorScreen("Error connecting to server: servers may be full right now, try again in a few minutes!", true);
            }
        });
        Game.ListenForEvent("Prediction::PredictionReady", ()=>{
            this.predictionReady = true;
        });
        Game.ListenForEvent("Bootstrap::MyServerSideEntityIsFullyCreatedLocally", (event)=>{
            const { myEntity: myEntity } = event;
            this.myServerSideEntity = myEntity;
            this.serverSideSelfReady = true;
        });
        this.client = new (0, $39f39c7ce64f85e7$exports.Client)((0, $7c910687071ab881$export$dfbbeca3e3775011), (0, $073149ffa9ea9788$exports.WebSocketClientAdapter), 1000 / $e93696f7341f475d$var$Server.TARGET_DELTA_IN_MS);
        this.client.setDisconnectHandler((reason, event)=>{
            console.log("disconnected", reason, event);
            Game.UI.ShowErrorScreen("Disconnected from server! The servers may be going down for an update. Try again in a few minutes.", true);
        });
        this.client.setWebsocketErrorHandler((event)=>{
            console.log("ws error", event);
            Game.UI.ShowErrorScreen("Disconnected from server! The servers may be going down for an update. Try again in a few minutes.", true);
        });
        this.interpolator = new (0, $39f39c7ce64f85e7$exports.Interpolator)(this.client);
        window.onfocus = ()=>{
            this.windowHasFocus = true;
        };
    }
}






var $555b585e379e29ea$exports = {};
$555b585e379e29ea$exports = JSON.parse('{"pan_004":[{"center":{"x":0,"y":0,"z":0.7699999809265137},"size":{"x":1,"y":0.18000000715255737,"z":2.0199999809265137},"isTrigger":false},{"center":{"x":0.7400000095367432,"y":0,"z":0.7699999809265137},"size":{"x":0.5799999833106995,"y":0.18000000715255737,"z":1.5199999809265137},"isTrigger":false},{"center":{"x":-0.7400000095367432,"y":0,"z":0.7699999809265137},"size":{"x":0.5799999833106995,"y":0.18000000715255737,"z":1.5199999809265137},"isTrigger":false},{"center":{"x":0,"y":0,"z":-1.0199999809265137},"size":{"x":0.38999998569488525,"y":0.20999999344348907,"z":1.559999942779541},"isTrigger":false},{"center":{"x":0.01436588168144226,"y":0.06893501430749893,"z":0.8018074035644531},"size":{"x":1.900367021560669,"y":0.19579802453517914,"z":1.8452167510986328},"isTrigger":true}],"large_square_004":[{"center":{"x":-5.960464477539063e-8,"y":0,"z":0},"size":{"x":3,"y":1.000000238418579,"z":3},"isTrigger":false}],"large_cube_001":[{"center":{"x":5.960464477539063e-8,"y":0,"z":0},"size":{"x":2,"y":2.000000238418579,"z":2.000000238418579},"isTrigger":false}],"chocolate_001":[{"center":{"x":0,"y":0,"z":0},"size":{"x":2.1085267066955566,"y":0.7054959535598755,"z":2.2170348167419434},"isTrigger":false},{"center":{"x":0,"y":1,"z":0},"size":{"x":1,"y":1.5,"z":1},"isTrigger":true}],"square_002":[{"center":{"x":-5.960464477539063e-8,"y":0,"z":0},"size":{"x":1.0000001192092896,"y":1.0000001192092896,"z":1.0000001192092896},"isTrigger":false}],"pot_001":[{"center":{"x":0,"y":0,"z":0},"size":{"x":2.51318621635437,"y":1.265334129333496,"z":1.970839023590088},"isTrigger":false}],"toaster_002":[{"center":{"x":0,"y":0,"z":0.13758084177970886},"size":{"x":1,"y":1.2379544973373413,"z":2.1030893325805664},"isTrigger":false},{"center":{"x":0.003422986716032028,"y":-0.2506312131881714,"z":-1.0408449172973633},"size":{"x":0.2134716510772705,"y":0.06111246347427368,"z":0.29656124114990234},"isTrigger":false},{"center":{"x":-0.2811461091041565,"y":-0.17570196092128754,"z":-0.8950505256652832},"size":{"x":0.09640848636627197,"y":0.20048382878303528,"z":0.0788068175315857},"isTrigger":false},{"center":{"x":0.3441794812679291,"y":-0.2401266247034073,"z":-0.9397974610328674},"size":{"x":0.24769987165927887,"y":0.3005531132221222,"z":0.10375559329986572},"isTrigger":false}],"large_cube_002":[{"center":{"x":5.960464477539063e-8,"y":0,"z":0},"size":{"x":2,"y":2.000000238418579,"z":2.000000238418579},"isTrigger":false}],"finish_line_001":[{"center":{"x":-1.7479212284088135,"y":-0.06941843032836914,"z":-0.007613837718963623},"size":{"x":0.17605257034301758,"y":3.7768521308898926,"z":0.14931517839431763},"isTrigger":false},{"center":{"x":1.74601149559021,"y":-0.06617259979248047,"z":-0.014989811927080154},"size":{"x":0.15746688842773438,"y":3.78334379196167,"z":0.15363988280296326},"isTrigger":false},{"center":{"x":0,"y":0,"z":0.702745795249939},"size":{"x":3.7778167724609375,"y":3.915688991546631,"z":1.589111328125},"isTrigger":true}],"square_004":[{"center":{"x":-5.960464477539063e-8,"y":0,"z":0},"size":{"x":1.0000001192092896,"y":1.0000001192092896,"z":1.0000001192092896},"isTrigger":false}],"large_square_002":[{"center":{"x":-5.960464477539063e-8,"y":0,"z":0},"size":{"x":3,"y":1.000000238418579,"z":3},"isTrigger":false}],"pot_003":[{"center":{"x":0,"y":0,"z":0},"size":{"x":2.51318621635437,"y":1.265334129333496,"z":1.9708396196365356},"isTrigger":false}],"knife_002":[{"center":{"x":-0.011043436825275421,"y":0.16311782598495483,"z":-0.0024069510400295258},"size":{"x":0.3683963418006897,"y":1.0150455236434937,"z":0.05806925892829895},"isTrigger":false},{"center":{"x":0.02380889654159546,"y":0.8278505206108093,"z":-0.0020783524960279465},"size":{"x":0.29890555143356323,"y":0.4795597791671753,"z":0.05592222884297371},"isTrigger":false},{"center":{"x":0.05038425326347351,"y":1.1830744743347168,"z":-0.0038808174431324005},"size":{"x":0.24084553122520447,"y":0.25540637969970703,"z":0.05958404392004013},"isTrigger":false},{"center":{"x":0.08214212208986282,"y":-0.8623002171516418,"z":4.470348358154297e-8},"size":{"x":0.2261989563703537,"y":0.8969544172286987,"z":0.09846313297748566},"isTrigger":false},{"center":{"x":0.0823669582605362,"y":-0.38454991579055786,"z":0.0008518071845173836},"size":{"x":0.17745760083198547,"y":0.0929117202758789,"z":0.051103830337524414},"isTrigger":false}],"pan_alt_004":[{"center":{"x":0,"y":0,"z":5.960464477539063e-8},"size":{"x":2.050065517425537,"y":0.40493813157081604,"z":3.8588204383850098},"isTrigger":false}],"gorilla":[{"center":{"x":0,"y":1.1322486400604248,"z":0.24907012283802032},"size":{"x":1.6004586219787598,"y":2.2749147415161133,"z":1.15657377243042},"isTrigger":false}],"moving_block_001":[{"center":{"x":0,"y":0,"z":0},"size":{"x":1.0000001192092896,"y":1.0000001192092896,"z":1.0000001192092896},"isTrigger":false},{"center":{"x":0,"y":0,"z":0},"size":{"x":1.100000023841858,"y":1.100000023841858,"z":1.100000023841858},"isTrigger":true}],"baking_pan_003":[{"center":{"x":-0.534504771232605,"y":0.012933865189552307,"z":0},"size":{"x":0.14186429977416992,"y":0.6279237270355225,"z":2.1063647270202637},"isTrigger":false},{"center":{"x":0.544675350189209,"y":0,"z":0},"size":{"x":0.12152343988418579,"y":0.6537913680076599,"z":2.1063647270202637},"isTrigger":false},{"center":{"x":0,"y":-0.30177056789398193,"z":0},"size":{"x":1.2108739614486694,"y":0.05025014281272888,"z":2.1063647270202637},"isTrigger":false},{"center":{"x":0,"y":0,"z":-0.9915010929107666},"size":{"x":1.2108739614486694,"y":0.6537913680076599,"z":0.12336254119873047},"isTrigger":false},{"center":{"x":0,"y":0,"z":0.9773610830307007},"size":{"x":1.2108739614486694,"y":0.6537913680076599,"z":0.1516425609588623},"isTrigger":false}],"large_cube_006":[{"center":{"x":5.960464477539063e-8,"y":0,"z":0},"size":{"x":2,"y":2.000000238418579,"z":2.000000238418579},"isTrigger":false}],"medium_square_001":[{"center":{"x":0,"y":0,"z":0},"size":{"x":2,"y":1.0000001192092896,"z":2},"isTrigger":false}],"death_block_001":[{"center":{"x":-5.960464477539063e-8,"y":0,"z":0},"size":{"x":0.9599999785423279,"y":0.9599999785423279,"z":0.9599999785423279},"isTrigger":true}],"medium_square_006":[{"center":{"x":0,"y":0,"z":0},"size":{"x":2,"y":1.0000001192092896,"z":2},"isTrigger":false}],"plate_002":[{"center":{"x":0,"y":2.9802322387695312e-8,"z":0},"size":{"x":2.444167375564575,"y":0.30922162532806396,"z":2.4441685676574707},"isTrigger":false}],"big_spoon_004":[{"center":{"x":-0.0005261749029159546,"y":-0.6096721291542053,"z":-0.11327926814556122},"size":{"x":0.11691701412200928,"y":0.7770787477493286,"z":0.09988531470298767},"isTrigger":false},{"center":{"x":0,"y":0.573598325252533,"z":0.07983974367380142},"size":{"x":0.7375085353851318,"y":0.8492263555526733,"z":0.1291843205690384},"isTrigger":false},{"center":{"x":-0.0018323063850402832,"y":-0.043056756258010864,"z":-0.05227348208427429},"size":{"x":0.10984069108963013,"y":0.3983338475227356,"z":0.14457553625106812},"isTrigger":false}],"baking_tray_002":[{"center":{"x":0,"y":-0.05829036980867386,"z":0},"size":{"x":2.1620912551879883,"y":0.05166240036487579,"z":3.159168004989624},"isTrigger":false},{"center":{"x":1.0287703275680542,"y":0,"z":0},"size":{"x":0.10455065965652466,"y":0.1682431399822235,"z":3.159168004989624},"isTrigger":false},{"center":{"x":-1.0334529876708984,"y":0,"z":0},"size":{"x":0.0951852798461914,"y":0.1682431399822235,"z":3.159168004989624},"isTrigger":false},{"center":{"x":0,"y":0,"z":1.5256156921386719},"size":{"x":2.1620912551879883,"y":0.1682431399822235,"z":0.10793650150299072},"isTrigger":false},{"center":{"x":0,"y":0,"z":-1.5329833030700684},"size":{"x":2.1620912551879883,"y":0.1682431399822235,"z":0.0932011604309082},"isTrigger":false}],"pepper":[{"center":{"x":0,"y":5.960464477539063e-8,"z":1.4901161193847656e-8},"size":{"x":0.2248239815235138,"y":0.3588722050189972,"z":0.213820219039917},"isTrigger":false}],"toaster_003":[{"center":{"x":0,"y":0,"z":0.13758084177970886},"size":{"x":1,"y":1.2379544973373413,"z":2.1030893325805664},"isTrigger":false},{"center":{"x":-0.2811461091041565,"y":-0.17570196092128754,"z":-0.8950505256652832},"size":{"x":0.09640848636627197,"y":0.20048382878303528,"z":0.0788068175315857},"isTrigger":false},{"center":{"x":0.3441794812679291,"y":-0.2401266247034073,"z":-0.9397974610328674},"size":{"x":0.24769987165927887,"y":0.3005531132221222,"z":0.10375559329986572},"isTrigger":false},{"center":{"x":0.003422986716032028,"y":-0.2506312131881714,"z":-1.0408449172973633},"size":{"x":0.2134716510772705,"y":0.06111246347427368,"z":0.29656124114990234},"isTrigger":false}],"large_cube_005":[{"center":{"x":5.960464477539063e-8,"y":0,"z":0},"size":{"x":2,"y":2.000000238418579,"z":2.000000238418579},"isTrigger":false}],"rectangle_004":[{"center":{"x":0,"y":0,"z":0},"size":{"x":2,"y":1.0000001192092896,"z":1.0000001192092896},"isTrigger":false}],"large_cube_008":[{"center":{"x":5.960464477539063e-8,"y":0,"z":0},"size":{"x":2,"y":2.000000238418579,"z":2.000000238418579},"isTrigger":false}],"large_square_008":[{"center":{"x":-5.960464477539063e-8,"y":0,"z":0},"size":{"x":3,"y":1.000000238418579,"z":3},"isTrigger":false}],"salt":[{"center":{"x":0,"y":5.960464477539063e-8,"z":1.4901161193847656e-8},"size":{"x":0.2248239815235138,"y":0.3588722050189972,"z":0.2138201892375946},"isTrigger":false}],"pan_alt_001":[{"center":{"x":0,"y":0,"z":5.960464477539063e-8},"size":{"x":2.050065755844116,"y":0.40493813157081604,"z":3.8588204383850098},"isTrigger":false}],"toaster_004":[{"center":{"x":0,"y":0,"z":0.13758084177970886},"size":{"x":1,"y":1.2379544973373413,"z":2.1030893325805664},"isTrigger":false},{"center":{"x":-0.2811461091041565,"y":-0.17570196092128754,"z":-0.8950505256652832},"size":{"x":0.09640848636627197,"y":0.20048382878303528,"z":0.0788068175315857},"isTrigger":false},{"center":{"x":0.3441794812679291,"y":-0.2401266247034073,"z":-0.9397974610328674},"size":{"x":0.24769987165927887,"y":0.3005531132221222,"z":0.10375559329986572},"isTrigger":false},{"center":{"x":0.003422986716032028,"y":-0.2506312131881714,"z":-1.0408449172973633},"size":{"x":0.2134716510772705,"y":0.06111246347427368,"z":0.29656124114990234},"isTrigger":false}],"square_005":[{"center":{"x":0,"y":0,"z":0},"size":{"x":1.0000001192092896,"y":1.0000001192092896,"z":1.0000001192092896},"isTrigger":false}],"large_cube_007":[{"center":{"x":5.960464477539063e-8,"y":0,"z":0},"size":{"x":2,"y":2.000000238418579,"z":2.000000238418579},"isTrigger":false}],"spatula_004":[{"center":{"x":0,"y":0,"z":-3.725290298461914e-9},"size":{"x":0.4915620684623718,"y":2.005338191986084,"z":0.21340546011924744},"isTrigger":false}],"medium_square_005":[{"center":{"x":0,"y":0,"z":0},"size":{"x":2,"y":1.0000001192092896,"z":2},"isTrigger":false}],"large_square_006":[{"center":{"x":-5.960464477539063e-8,"y":0,"z":0},"size":{"x":3,"y":1.000000238418579,"z":3},"isTrigger":false}],"big_spoon_002":[{"center":{"x":-0.0005261749029159546,"y":-0.6096721291542053,"z":-0.11327926814556122},"size":{"x":0.11691701412200928,"y":0.7770787477493286,"z":0.09988531470298767},"isTrigger":false},{"center":{"x":0,"y":0.573598325252533,"z":0.07983974367380142},"size":{"x":0.7375085353851318,"y":0.8492263555526733,"z":0.1291843205690384},"isTrigger":false},{"center":{"x":-0.0018323063850402832,"y":-0.043056756258010864,"z":-0.05227348208427429},"size":{"x":0.10984069108963013,"y":0.3983338475227356,"z":0.14457553625106812},"isTrigger":false}],"fork_003":[{"center":{"x":0,"y":0.5712802410125732,"z":0.04805556684732437},"size":{"x":0.21315765380859375,"y":0.5527706146240234,"z":0.021714936941862106},"isTrigger":false},{"center":{"x":0,"y":-0.39334407448768616,"z":-0.013488059863448143},"size":{"x":0.21315765380859375,"y":0.9473127722740173,"z":0.0341276191174984},"isTrigger":false},{"center":{"x":0,"y":0.18652744591236115,"z":0.02131321281194687},"size":{"x":0.21315765380859375,"y":0.22889444231987,"z":0.045524150133132935},"isTrigger":false}],"purple_001":[{"center":{"x":0,"y":0,"z":0},"size":{"x":2.1085267066955566,"y":0.7054959535598755,"z":2.2170348167419434},"isTrigger":false}],"chopping_kinfe_001":[{"center":{"x":-0.013463951647281647,"y":0.15075382590293884,"z":-0.0014901086688041687},"size":{"x":0.48350924253463745,"y":0.9996039271354675,"z":0.05434674024581909},"isTrigger":false},{"center":{"x":-0.014500349760055542,"y":0.8741374015808105,"z":-0.0014534033834934235},"size":{"x":0.48358696699142456,"y":0.4431614875793457,"z":0.05543527752161026},"isTrigger":false},{"center":{"x":0.032472580671310425,"y":1.20098876953125,"z":-0.005706500262022018},"size":{"x":0.385860800743103,"y":0.21957731246948242,"z":0.060679636895656586},"isTrigger":false},{"center":{"x":0.13517045974731445,"y":-0.3792669177055359,"z":-0.0019107433035969734},"size":{"x":0.1827847957611084,"y":0.08376336097717285,"z":0.0556485578417778},"isTrigger":false},{"center":{"x":0.13590458035469055,"y":-0.865192174911499,"z":4.470348358154297e-8},"size":{"x":0.22677695751190186,"y":0.8959765434265137,"z":0.09846313297748566},"isTrigger":false}],"spatula_003":[{"center":{"x":0,"y":0,"z":-3.725290298461914e-9},"size":{"x":0.49156203866004944,"y":2.005338430404663,"z":0.21340546011924744},"isTrigger":false}],"baking_pan_002":[{"center":{"x":-0.534504771232605,"y":0.012933865189552307,"z":0},"size":{"x":0.14186429977416992,"y":0.6279237270355225,"z":2.1063647270202637},"isTrigger":false},{"center":{"x":0.544675350189209,"y":0,"z":0},"size":{"x":0.12152343988418579,"y":0.6537913680076599,"z":2.1063647270202637},"isTrigger":false},{"center":{"x":0,"y":-0.30177056789398193,"z":0},"size":{"x":1.2108739614486694,"y":0.05025014281272888,"z":2.1063647270202637},"isTrigger":false},{"center":{"x":0,"y":0,"z":-0.9915010929107666},"size":{"x":1.2108739614486694,"y":0.6537913680076599,"z":0.12336254119873047},"isTrigger":false},{"center":{"x":0,"y":0,"z":0.9773610830307007},"size":{"x":1.2108739614486694,"y":0.6537913680076599,"z":0.1516425609588623},"isTrigger":false}],"fire_extinguisher_001":[{"center":{"x":0.051660776138305664,"y":-0.32330912351608276,"z":2.9802322387695312e-8},"size":{"x":0.9692511558532715,"y":2.6754655838012695,"z":0.9146154522895813},"isTrigger":false},{"center":{"x":0.29850995540618896,"y":1.2706525325775146,"z":0.03314568102359772},"size":{"x":0.8284366130828857,"y":0.6837904453277588,"z":0.30527329444885254},"isTrigger":false},{"center":{"x":-0.40815630555152893,"y":0.4408894181251526,"z":0.012096703052520752},"size":{"x":0.6104710698127747,"y":1.9521888494491577,"z":0.10329648852348328},"isTrigger":false}],"baking_tray_004":[{"center":{"x":0,"y":-0.05829036980867386,"z":0},"size":{"x":2.1620912551879883,"y":0.05166240036487579,"z":3.159168004989624},"isTrigger":false},{"center":{"x":1.0287703275680542,"y":0,"z":0},"size":{"x":0.10455065965652466,"y":0.1682431399822235,"z":3.159168004989624},"isTrigger":false},{"center":{"x":-1.0334529876708984,"y":0,"z":0},"size":{"x":0.0951852798461914,"y":0.1682431399822235,"z":3.159168004989624},"isTrigger":false},{"center":{"x":0,"y":0,"z":1.5256156921386719},"size":{"x":2.1620912551879883,"y":0.1682431399822235,"z":0.10793650150299072},"isTrigger":false},{"center":{"x":0,"y":0,"z":-1.5329833030700684},"size":{"x":2.1620912551879883,"y":0.1682431399822235,"z":0.0932011604309082},"isTrigger":false}],"medium_square_008":[{"center":{"x":0,"y":0,"z":0},"size":{"x":2,"y":1.0000001192092896,"z":2},"isTrigger":false}],"rectangle_006":[{"center":{"x":0,"y":0,"z":0},"size":{"x":2,"y":1.0000001192092896,"z":1.0000001192092896},"isTrigger":false}],"cleaver_001":[{"center":{"x":-0.011205479502677917,"y":0.4775858521461487,"z":0.0027481187134981155},"size":{"x":0.6925286054611206,"y":1.666383147239685,"z":0.056859951466321945},"isTrigger":false},{"center":{"x":0.2400682419538498,"y":-0.8627925515174866,"z":0.0018422529101371765},"size":{"x":0.23025992512702942,"y":0.9015806913375854,"z":0.10214754939079285},"isTrigger":false},{"center":{"x":0.2450007051229477,"y":-0.35259777307510376,"z":0.00297660194337368},"size":{"x":0.17818376421928406,"y":0.13774240016937256,"z":0.05617908760905266},"isTrigger":false}],"check_point_001":[{"center":{"x":0,"y":-2.9802322387695312e-8,"z":-0.4999999701976776},"size":{"x":2,"y":1.000000238418579,"z":2},"isTrigger":false},{"center":{"x":0,"y":1.440000057220459,"z":-0.4999999701976776},"size":{"x":2,"y":2.0199999809265137,"z":2},"isTrigger":true}],"large_square_005":[{"center":{"x":-5.960464477539063e-8,"y":0,"z":0},"size":{"x":3,"y":1.000000238418579,"z":3},"isTrigger":false}],"medium_square_007":[{"center":{"x":0,"y":0,"z":0},"size":{"x":2,"y":1.0000001192092896,"z":2},"isTrigger":false}],"fork_002":[{"center":{"x":0,"y":0.5712802410125732,"z":0.04805556684732437},"size":{"x":0.21315765380859375,"y":0.5527706146240234,"z":0.021714936941862106},"isTrigger":false},{"center":{"x":0,"y":-0.39334407448768616,"z":-0.013488059863448143},"size":{"x":0.21315765380859375,"y":0.9473127722740173,"z":0.0341276191174984},"isTrigger":false},{"center":{"x":0,"y":0.18652744591236115,"z":0.02131321281194687},"size":{"x":0.21315765380859375,"y":0.22889444231987,"z":0.045524150133132935},"isTrigger":false}],"knife_001":[{"center":{"x":-0.011043436825275421,"y":0.16311782598495483,"z":-0.0024069510400295258},"size":{"x":0.3683963418006897,"y":1.0150455236434937,"z":0.05806925892829895},"isTrigger":false},{"center":{"x":0.02380889654159546,"y":0.8278505206108093,"z":-0.0020783524960279465},"size":{"x":0.29890555143356323,"y":0.4795597791671753,"z":0.05592222884297371},"isTrigger":false},{"center":{"x":0.05038425326347351,"y":1.1830744743347168,"z":-0.0038808174431324005},"size":{"x":0.24084553122520447,"y":0.25540637969970703,"z":0.05958404392004013},"isTrigger":false},{"center":{"x":0.08214212208986282,"y":-0.8623002171516418,"z":4.470348358154297e-8},"size":{"x":0.2261989563703537,"y":0.8969544172286987,"z":0.09846313297748566},"isTrigger":false},{"center":{"x":0.0823669582605362,"y":-0.38454991579055786,"z":0.0008518071845173836},"size":{"x":0.17745760083198547,"y":0.0929117202758789,"z":0.051103830337524414},"isTrigger":false}],"bowl_004":[{"center":{"x":0,"y":-0.3263605833053589,"z":0},"size":{"x":1.0976001024246216,"y":0.06335949897766113,"z":1.0976001024246216},"isTrigger":false},{"center":{"x":0.4993540644645691,"y":0,"z":0},"size":{"x":0.09889185428619385,"y":0.7160806655883789,"z":1.0976001024246216},"isTrigger":false},{"center":{"x":-0.5010879039764404,"y":0,"z":0},"size":{"x":0.0954243540763855,"y":0.7160806655883789,"z":1.0976001024246216},"isTrigger":false},{"center":{"x":0,"y":0,"z":-0.5054295659065247},"size":{"x":1.0976001024246216,"y":0.7160806655883789,"z":0.0867408812046051},"isTrigger":false},{"center":{"x":0,"y":0,"z":0.5067586898803711},"size":{"x":1.0976001024246216,"y":0.7160806655883789,"z":0.08408287167549133},"isTrigger":false}],"large_square_001":[{"center":{"x":-5.960464477539063e-8,"y":0,"z":0},"size":{"x":3,"y":1.000000238418579,"z":3},"isTrigger":false}],"large_square_007":[{"center":{"x":-5.960464477539063e-8,"y":0,"z":0},"size":{"x":3,"y":1.000000238418579,"z":3},"isTrigger":false}],"large_square_003":[{"center":{"x":-5.960464477539063e-8,"y":0,"z":0},"size":{"x":3,"y":1.000000238418579,"z":3},"isTrigger":false}],"bowl_001":[{"center":{"x":0,"y":-0.3263605833053589,"z":0},"size":{"x":1.0976001024246216,"y":0.06335949897766113,"z":1.0976001024246216},"isTrigger":false},{"center":{"x":0.4993540644645691,"y":0,"z":0},"size":{"x":0.09889185428619385,"y":0.7160806655883789,"z":1.0976001024246216},"isTrigger":false},{"center":{"x":-0.5010879039764404,"y":0,"z":0},"size":{"x":0.0954243540763855,"y":0.7160806655883789,"z":1.0976001024246216},"isTrigger":false},{"center":{"x":0,"y":0,"z":-0.5054295659065247},"size":{"x":1.0976001024246216,"y":0.7160806655883789,"z":0.0867408812046051},"isTrigger":false},{"center":{"x":0,"y":0,"z":0.5067586898803711},"size":{"x":1.0976001024246216,"y":0.7160806655883789,"z":0.08408287167549133},"isTrigger":false}],"bowl_002":[{"center":{"x":0,"y":-0.3263605833053589,"z":0},"size":{"x":1.0976001024246216,"y":0.06335949897766113,"z":1.0976001024246216},"isTrigger":false},{"center":{"x":0.4993540644645691,"y":0,"z":0},"size":{"x":0.09889185428619385,"y":0.7160806655883789,"z":1.0976001024246216},"isTrigger":false},{"center":{"x":-0.5010879039764404,"y":0,"z":0},"size":{"x":0.0954243540763855,"y":0.7160806655883789,"z":1.0976001024246216},"isTrigger":false},{"center":{"x":0,"y":0,"z":-0.5054295659065247},"size":{"x":1.0976001024246216,"y":0.7160806655883789,"z":0.0867408812046051},"isTrigger":false},{"center":{"x":0,"y":0,"z":0.5067586898803711},"size":{"x":1.0976001024246216,"y":0.7160806655883789,"z":0.08408287167549133},"isTrigger":false}],"square_006":[{"center":{"x":-5.960464477539063e-8,"y":0,"z":0},"size":{"x":1.0000001192092896,"y":1.0000001192092896,"z":1.0000001192092896},"isTrigger":false}],"pan_001":[{"center":{"x":0,"y":0,"z":0.7699999809265137},"size":{"x":1,"y":0.18000000715255737,"z":2.0199999809265137},"isTrigger":false},{"center":{"x":0.7400000095367432,"y":-0.0033398419618606567,"z":0.7699999809265137},"size":{"x":0.5799999237060547,"y":0.17332032322883606,"z":1.5199999809265137},"isTrigger":false},{"center":{"x":-0.7400000095367432,"y":0,"z":0.7699999809265137},"size":{"x":0.5799999833106995,"y":0.18000000715255737,"z":1.5199999809265137},"isTrigger":false},{"center":{"x":0,"y":0,"z":-1.0199999809265137},"size":{"x":0.38999998569488525,"y":0.20999999344348907,"z":1.559999942779541},"isTrigger":false},{"center":{"x":0.01436588168144226,"y":0.06893501430749893,"z":0.8018074035644531},"size":{"x":1.900367021560669,"y":0.19579802453517914,"z":1.8452167510986328},"isTrigger":true}],"bowl_003":[{"center":{"x":0,"y":-0.3263605833053589,"z":0},"size":{"x":1.0976001024246216,"y":0.06335949897766113,"z":1.0976001024246216},"isTrigger":false},{"center":{"x":0.4993540644645691,"y":0,"z":0},"size":{"x":0.09889185428619385,"y":0.7160806655883789,"z":1.0976001024246216},"isTrigger":false},{"center":{"x":-0.5010879039764404,"y":0,"z":0},"size":{"x":0.0954243540763855,"y":0.7160806655883789,"z":1.0976001024246216},"isTrigger":false},{"center":{"x":0,"y":0,"z":-0.5054295659065247},"size":{"x":1.0976001024246216,"y":0.7160806655883789,"z":0.0867408812046051},"isTrigger":false},{"center":{"x":0,"y":0,"z":0.5067586898803711},"size":{"x":1.0976001024246216,"y":0.7160806655883789,"z":0.08408287167549133},"isTrigger":false}],"plate_001":[{"center":{"x":0,"y":2.9802322387695312e-8,"z":0},"size":{"x":2.444167375564575,"y":0.30922162532806396,"z":2.4441685676574707},"isTrigger":false}],"rectangle_002":[{"center":{"x":0,"y":0,"z":0},"size":{"x":2,"y":1.0000001192092896,"z":1.0000001192092896},"isTrigger":false}],"spatula_001":[{"center":{"x":0,"y":0,"z":-3.725290298461914e-9},"size":{"x":0.4915621876716614,"y":2.005338191986084,"z":0.21340546011924744},"isTrigger":false}],"chopping_kinfe_003":[{"center":{"x":-0.013463951647281647,"y":0.15075382590293884,"z":-0.0014901086688041687},"size":{"x":0.48350924253463745,"y":0.9996039271354675,"z":0.05434674024581909},"isTrigger":false},{"center":{"x":-0.014500349760055542,"y":0.8741374015808105,"z":-0.0014534033834934235},"size":{"x":0.48358696699142456,"y":0.4431614875793457,"z":0.05543527752161026},"isTrigger":false},{"center":{"x":0.032472580671310425,"y":1.20098876953125,"z":-0.005706500262022018},"size":{"x":0.385860800743103,"y":0.21957731246948242,"z":0.060679636895656586},"isTrigger":false},{"center":{"x":0.13517045974731445,"y":-0.3792669177055359,"z":-0.0019107433035969734},"size":{"x":0.1827847957611084,"y":0.08376336097717285,"z":0.0556485578417778},"isTrigger":false},{"center":{"x":0.13590458035469055,"y":-0.865192174911499,"z":4.470348358154297e-8},"size":{"x":0.22677695751190186,"y":0.8959765434265137,"z":0.09846313297748566},"isTrigger":false}],"square_008":[{"center":{"x":0,"y":0,"z":0},"size":{"x":1.0000001192092896,"y":1.0000001192092896,"z":1.0000001192092896},"isTrigger":false}],"plate_003":[{"center":{"x":0,"y":2.9802322387695312e-8,"z":0},"size":{"x":2.444167375564575,"y":0.30922162532806396,"z":2.4441685676574707},"isTrigger":false}],"plate_004":[{"center":{"x":0,"y":2.9802322387695312e-8,"z":0},"size":{"x":2.444167375564575,"y":0.30922162532806396,"z":2.4441685676574707},"isTrigger":false}],"baking_tray_003":[{"center":{"x":0,"y":-0.05829036980867386,"z":0},"size":{"x":2.1620912551879883,"y":0.05166240036487579,"z":3.159168004989624},"isTrigger":false},{"center":{"x":1.0287703275680542,"y":0,"z":0},"size":{"x":0.10455065965652466,"y":0.1682431399822235,"z":3.159168004989624},"isTrigger":false},{"center":{"x":-1.0334529876708984,"y":0,"z":0},"size":{"x":0.0951852798461914,"y":0.1682431399822235,"z":3.159168004989624},"isTrigger":false},{"center":{"x":0,"y":0,"z":1.5256156921386719},"size":{"x":2.1620912551879883,"y":0.1682431399822235,"z":0.10793650150299072},"isTrigger":false},{"center":{"x":0,"y":0,"z":-1.5329833030700684},"size":{"x":2.1620912551879883,"y":0.1682431399822235,"z":0.0932011604309082},"isTrigger":false}],"pan_alt_003":[{"center":{"x":0,"y":0,"z":5.960464477539063e-8},"size":{"x":2.050065517425537,"y":0.40493813157081604,"z":3.8588204383850098},"isTrigger":false}],"rectangle_003":[{"center":{"x":0,"y":0,"z":0},"size":{"x":2,"y":1.0000001192092896,"z":1.0000001192092896},"isTrigger":false}],"rolling_pin":[{"center":{"x":0,"y":0,"z":0},"size":{"x":2.412391424179077,"y":0.3011873662471771,"z":0.3166870176792145},"isTrigger":false}],"square_003":[{"center":{"x":-5.960464477539063e-8,"y":0,"z":0},"size":{"x":1.0000001192092896,"y":1.0000001192092896,"z":1.0000001192092896},"isTrigger":false}],"vanilla_001":[{"center":{"x":0,"y":0,"z":0},"size":{"x":2.1085267066955566,"y":0.7054959535598755,"z":2.2170348167419434},"isTrigger":false},{"center":{"x":0,"y":1,"z":0},"size":{"x":1,"y":1.5,"z":1},"isTrigger":true}],"medium_square_004":[{"center":{"x":0,"y":0,"z":0},"size":{"x":2,"y":1.0000001192092896,"z":2},"isTrigger":false}],"square_001":[{"center":{"x":-5.960464477539063e-8,"y":0,"z":0},"size":{"x":1.0000001192092896,"y":1.0000001192092896,"z":1.0000001192092896},"isTrigger":false}],"toaster_001":[{"center":{"x":0,"y":0,"z":0.13758084177970886},"size":{"x":1,"y":1.2379544973373413,"z":2.1030893325805664},"isTrigger":false},{"center":{"x":0.003422986716032028,"y":-0.2506312131881714,"z":-1.0408449172973633},"size":{"x":0.2134716510772705,"y":0.06111246347427368,"z":0.29656124114990234},"isTrigger":false},{"center":{"x":-0.2811461091041565,"y":-0.17570196092128754,"z":-0.8950505256652832},"size":{"x":0.09640848636627197,"y":0.20048382878303528,"z":0.0788068175315857},"isTrigger":false},{"center":{"x":0.3441794812679291,"y":-0.2401266247034073,"z":-0.9397974610328674},"size":{"x":0.24769987165927887,"y":0.3005531132221222,"z":0.10375559329986572},"isTrigger":false}],"slow_block_001":[{"center":{"x":0,"y":0,"z":0},"size":{"x":1.0000001192092896,"y":1.0000001192092896,"z":1.0000001192092896},"isTrigger":false}],"large_cube_003":[{"center":{"x":5.960464477539063e-8,"y":0,"z":0},"size":{"x":2,"y":2.000000238418579,"z":2.000000238418579},"isTrigger":false}],"chopping_kinfe_004":[{"center":{"x":-0.013463951647281647,"y":0.15075382590293884,"z":-0.0014901086688041687},"size":{"x":0.48350924253463745,"y":0.9996039271354675,"z":0.05434674024581909},"isTrigger":false},{"center":{"x":-0.014500349760055542,"y":0.8741374015808105,"z":-0.0014534033834934235},"size":{"x":0.48358696699142456,"y":0.4431614875793457,"z":0.05543527752161026},"isTrigger":false},{"center":{"x":0.032472580671310425,"y":1.20098876953125,"z":-0.005706500262022018},"size":{"x":0.385860800743103,"y":0.21957731246948242,"z":0.060679636895656586},"isTrigger":false},{"center":{"x":0.13517045974731445,"y":-0.3792669177055359,"z":-0.0019107433035969734},"size":{"x":0.1827847957611084,"y":0.08376336097717285,"z":0.0556485578417778},"isTrigger":false},{"center":{"x":0.13590458035469055,"y":-0.865192174911499,"z":4.470348358154297e-8},"size":{"x":0.22677695751190186,"y":0.8959765434265137,"z":0.09846313297748566},"isTrigger":false}],"pan_002":[{"center":{"x":0,"y":0,"z":0.7699999809265137},"size":{"x":1,"y":0.18000000715255737,"z":2.0199999809265137},"isTrigger":false},{"center":{"x":0.7400000095367432,"y":0,"z":0.7699999809265137},"size":{"x":0.5799999833106995,"y":0.18000000715255737,"z":1.5199999809265137},"isTrigger":false},{"center":{"x":-0.7400000095367432,"y":0,"z":0.7699999809265137},"size":{"x":0.5799999833106995,"y":0.18000000715255737,"z":1.5199999809265137},"isTrigger":false},{"center":{"x":0,"y":0,"z":-1.0199999809265137},"size":{"x":0.38999998569488525,"y":0.20999999344348907,"z":1.559999942779541},"isTrigger":false},{"center":{"x":0.01436588168144226,"y":0.06893501430749893,"z":0.8018074035644531},"size":{"x":1.900367021560669,"y":0.19579802453517914,"z":1.8452167510986328},"isTrigger":true}],"knife_004":[{"center":{"x":-0.011043436825275421,"y":0.16311782598495483,"z":-0.0024069510400295258},"size":{"x":0.3683963418006897,"y":1.0150455236434937,"z":0.05806925892829895},"isTrigger":false},{"center":{"x":0.02380889654159546,"y":0.8278505206108093,"z":-0.0020783524960279465},"size":{"x":0.29890555143356323,"y":0.4795597791671753,"z":0.05592222884297371},"isTrigger":false},{"center":{"x":0.05038425326347351,"y":1.1830744743347168,"z":-0.0038808174431324005},"size":{"x":0.24084553122520447,"y":0.25540637969970703,"z":0.05958404392004013},"isTrigger":false},{"center":{"x":0.08214212208986282,"y":-0.8623002171516418,"z":4.470348358154297e-8},"size":{"x":0.2261989563703537,"y":0.8969544172286987,"z":0.09846313297748566},"isTrigger":false},{"center":{"x":0.0823669582605362,"y":-0.38454991579055786,"z":0.0008518071845173836},"size":{"x":0.17745760083198547,"y":0.0929117202758789,"z":0.051103830337524414},"isTrigger":false}],"square_007":[{"center":{"x":-5.960464477539063e-8,"y":0,"z":0},"size":{"x":1.0000001192092896,"y":1.0000001192092896,"z":1.0000001192092896},"isTrigger":false}],"mango_001":[{"center":{"x":0,"y":0,"z":0},"size":{"x":2.1085267066955566,"y":0.7054959535598755,"z":2.2170348167419434},"isTrigger":false}],"pot_004":[{"center":{"x":0,"y":0,"z":0},"size":{"x":2.51318621635437,"y":1.265334129333496,"z":1.9708396196365356},"isTrigger":false}],"large_cube_004":[{"center":{"x":5.960464477539063e-8,"y":0,"z":0},"size":{"x":2,"y":2.000000238418579,"z":2.000000238418579},"isTrigger":false}],"medium_square_002":[{"center":{"x":0,"y":0,"z":0},"size":{"x":2,"y":1.0000001192092896,"z":2},"isTrigger":false}],"pan_alt_002":[{"center":{"x":0,"y":0,"z":0},"size":{"x":2.050065517425537,"y":0.40493813157081604,"z":3.8588201999664307},"isTrigger":false}],"cutting_board":[{"center":{"x":0,"y":7.450580596923828e-8,"z":0},"size":{"x":3.3922994136810303,"y":0.16410917043685913,"z":1.8569973707199097},"isTrigger":false}],"rectangle_001":[{"center":{"x":0,"y":0,"z":0},"size":{"x":2,"y":1.0000001192092896,"z":1.0000001192092896},"isTrigger":false}],"baking_pan_001":[{"center":{"x":-0.534504771232605,"y":0.012933865189552307,"z":0},"size":{"x":0.14186429977416992,"y":0.6279237270355225,"z":2.1063647270202637},"isTrigger":false},{"center":{"x":0.544675350189209,"y":0,"z":0},"size":{"x":0.12152343988418579,"y":0.6537913680076599,"z":2.1063647270202637},"isTrigger":false},{"center":{"x":0,"y":-0.30177056789398193,"z":0},"size":{"x":1.2108739614486694,"y":0.05025014281272888,"z":2.1063647270202637},"isTrigger":false},{"center":{"x":0,"y":0,"z":-0.9915010929107666},"size":{"x":1.2108739614486694,"y":0.6537913680076599,"z":0.12336254119873047},"isTrigger":false},{"center":{"x":0,"y":0,"z":0.9773610830307007},"size":{"x":1.2108739614486694,"y":0.6537913680076599,"z":0.1516425609588623},"isTrigger":false}],"baking_pan_004":[{"center":{"x":-0.534504771232605,"y":0.012933865189552307,"z":0},"size":{"x":0.14186429977416992,"y":0.6279237270355225,"z":2.1063647270202637},"isTrigger":false},{"center":{"x":0.544675350189209,"y":0,"z":0},"size":{"x":0.12152343988418579,"y":0.6537913680076599,"z":2.1063647270202637},"isTrigger":false},{"center":{"x":0,"y":-0.30177056789398193,"z":0},"size":{"x":1.2108739614486694,"y":0.05025014281272888,"z":2.1063647270202637},"isTrigger":false},{"center":{"x":0,"y":0,"z":-0.9915010929107666},"size":{"x":1.2108739614486694,"y":0.6537913680076599,"z":0.12336254119873047},"isTrigger":false},{"center":{"x":0,"y":0,"z":0.9773610830307007},"size":{"x":1.2108739614486694,"y":0.6537913680076599,"z":0.1516425609588623},"isTrigger":false}],"big_spoon_001":[{"center":{"x":-0.0005261749029159546,"y":-0.6096721291542053,"z":-0.11327926814556122},"size":{"x":0.11691701412200928,"y":0.7770787477493286,"z":0.09988531470298767},"isTrigger":false},{"center":{"x":0,"y":0.573598325252533,"z":0.07983974367380142},"size":{"x":0.7375085353851318,"y":0.8492263555526733,"z":0.1291843205690384},"isTrigger":false},{"center":{"x":-0.0018323063850402832,"y":-0.043056756258010864,"z":-0.05227348208427429},"size":{"x":0.10984069108963013,"y":0.3983338475227356,"z":0.14457553625106812},"isTrigger":false}],"pot_002":[{"center":{"x":0,"y":0,"z":0},"size":{"x":2.51318621635437,"y":1.265334129333496,"z":1.9708396196365356},"isTrigger":false}],"baking_tray_001":[{"center":{"x":0,"y":-0.05829036980867386,"z":0},"size":{"x":2.1620912551879883,"y":0.05166240036487579,"z":3.159168004989624},"isTrigger":false},{"center":{"x":1.0287703275680542,"y":0,"z":0},"size":{"x":0.10455065965652466,"y":0.1682431399822235,"z":3.159168004989624},"isTrigger":false},{"center":{"x":-1.0334529876708984,"y":0,"z":0},"size":{"x":0.0951852798461914,"y":0.1682431399822235,"z":3.159168004989624},"isTrigger":false},{"center":{"x":0,"y":0,"z":1.5256156921386719},"size":{"x":2.1620912551879883,"y":0.1682431399822235,"z":0.10793650150299072},"isTrigger":false},{"center":{"x":0,"y":0,"z":-1.5329833030700684},"size":{"x":2.1620912551879883,"y":0.1682431399822235,"z":0.0932011604309082},"isTrigger":false}],"slippery_block_001":[{"center":{"x":0,"y":0,"z":0},"size":{"x":1.0000001192092896,"y":1.0000001192092896,"z":1.0000001192092896},"isTrigger":false},{"center":{"x":0,"y":0,"z":0},"size":{"x":1.100000023841858,"y":1.100000023841858,"z":1.100000023841858},"isTrigger":true}],"fork_004":[{"center":{"x":0,"y":0.5712802410125732,"z":0.04805556684732437},"size":{"x":0.21315765380859375,"y":0.5527706146240234,"z":0.021714936941862106},"isTrigger":false},{"center":{"x":0,"y":-0.39334407448768616,"z":-0.013488059863448143},"size":{"x":0.21315765380859375,"y":0.9473127722740173,"z":0.0341276191174984},"isTrigger":false},{"center":{"x":0,"y":0.18652744591236115,"z":0.02131321281194687},"size":{"x":0.21315765380859375,"y":0.22889444231987,"z":0.045524150133132935},"isTrigger":false}],"chopping_kinfe_002":[{"center":{"x":-0.013463951647281647,"y":0.15075382590293884,"z":-0.0014901086688041687},"size":{"x":0.48350924253463745,"y":0.9996039271354675,"z":0.05434674024581909},"isTrigger":false},{"center":{"x":-0.014500349760055542,"y":0.8741374015808105,"z":-0.0014534033834934235},"size":{"x":0.48358696699142456,"y":0.4431614875793457,"z":0.05543527752161026},"isTrigger":false},{"center":{"x":0.032472580671310425,"y":1.20098876953125,"z":-0.005706500262022018},"size":{"x":0.385860800743103,"y":0.21957731246948242,"z":0.060679636895656586},"isTrigger":false},{"center":{"x":0.13517045974731445,"y":-0.3792669177055359,"z":-0.0019107433035969734},"size":{"x":0.1827847957611084,"y":0.08376336097717285,"z":0.0556485578417778},"isTrigger":false},{"center":{"x":0.13590458035469055,"y":-0.865192174911499,"z":4.470348358154297e-8},"size":{"x":0.22677695751190186,"y":0.8959765434265137,"z":0.09846313297748566},"isTrigger":false}],"rectangle_005":[{"center":{"x":0,"y":0,"z":0},"size":{"x":2,"y":1.0000001192092896,"z":1.0000001192092896},"isTrigger":false}],"strawberry_001":[{"center":{"x":0,"y":0,"z":0},"size":{"x":2.1085267066955566,"y":0.7054959535598755,"z":2.2170348167419434},"isTrigger":false}],"medium_square_003":[{"center":{"x":0,"y":0,"z":0},"size":{"x":2,"y":1.0000001192092896,"z":2},"isTrigger":false}],"blueberry_001":[{"center":{"x":0,"y":0,"z":0},"size":{"x":2.1085267066955566,"y":0.7054959535598755,"z":2.2170348167419434},"isTrigger":false}],"knife_003":[{"center":{"x":-0.011043436825275421,"y":0.16311782598495483,"z":-0.0024069510400295258},"size":{"x":0.3683963418006897,"y":1.0150455236434937,"z":0.05806925892829895},"isTrigger":false},{"center":{"x":0.02380889654159546,"y":0.8278505206108093,"z":-0.0020783524960279465},"size":{"x":0.29890555143356323,"y":0.4795597791671753,"z":0.05592222884297371},"isTrigger":false},{"center":{"x":0.05038425326347351,"y":1.1830744743347168,"z":-0.0038808174431324005},"size":{"x":0.24084553122520447,"y":0.25540637969970703,"z":0.05958404392004013},"isTrigger":false},{"center":{"x":0.08214212208986282,"y":-0.8623002171516418,"z":4.470348358154297e-8},"size":{"x":0.2261989563703537,"y":0.8969544172286987,"z":0.09846313297748566},"isTrigger":false},{"center":{"x":0.0823669582605362,"y":-0.38454991579055786,"z":0.0008518071845173836},"size":{"x":0.17745760083198547,"y":0.0929117202758789,"z":0.051103830337524414},"isTrigger":false}],"pan_003":[{"center":{"x":0,"y":0,"z":0.7699999809265137},"size":{"x":1,"y":0.18000000715255737,"z":2.0199999809265137},"isTrigger":false},{"center":{"x":0.7400000095367432,"y":0,"z":0.7699999809265137},"size":{"x":0.5799999833106995,"y":0.18000000715255737,"z":1.5199999809265137},"isTrigger":false},{"center":{"x":-0.7400000095367432,"y":0,"z":0.7699999809265137},"size":{"x":0.5799999833106995,"y":0.18000000715255737,"z":1.5199999809265137},"isTrigger":false},{"center":{"x":0,"y":0,"z":-1.0199999809265137},"size":{"x":0.38999998569488525,"y":0.20999999344348907,"z":1.559999942779541},"isTrigger":false},{"center":{"x":0.01436588168144226,"y":0.06893501430749893,"z":0.8018074035644531},"size":{"x":1.900367021560669,"y":0.19579802453517914,"z":1.8452167510986328},"isTrigger":true}],"fork_001":[{"center":{"x":0,"y":0.5712802410125732,"z":0.04805556684732437},"size":{"x":0.21315765380859375,"y":0.5527706146240234,"z":0.021714936941862106},"isTrigger":false},{"center":{"x":0,"y":-0.39334407448768616,"z":-0.013488059863448143},"size":{"x":0.21315765380859375,"y":0.9473127722740173,"z":0.0341276191174984},"isTrigger":false},{"center":{"x":0,"y":0.18652744591236115,"z":0.02131321281194687},"size":{"x":0.21315765380859375,"y":0.22889444231987,"z":0.045524150133132935},"isTrigger":false}],"pistachio_001":[{"center":{"x":0,"y":0,"z":0},"size":{"x":2.1085267066955566,"y":0.7054959535598755,"z":2.2170348167419434},"isTrigger":false},{"center":{"x":0,"y":1,"z":0},"size":{"x":1,"y":1.5,"z":1},"isTrigger":true}],"big_spoon_003":[{"center":{"x":-0.0005261749029159546,"y":-0.6096721291542053,"z":-0.11327926814556122},"size":{"x":0.11691701412200928,"y":0.7770787477493286,"z":0.09988531470298767},"isTrigger":false},{"center":{"x":0,"y":0.573598325252533,"z":0.07983974367380142},"size":{"x":0.7375085353851318,"y":0.8492263555526733,"z":0.1291843205690384},"isTrigger":false},{"center":{"x":-0.0018323063850402832,"y":-0.043056756258010864,"z":-0.05227348208427429},"size":{"x":0.10984069108963013,"y":0.3983338475227356,"z":0.14457553625106812},"isTrigger":false}],"spatula_002":[{"center":{"x":0,"y":0,"z":-3.725290298461914e-9},"size":{"x":0.49156197905540466,"y":2.005338191986084,"z":0.21340546011924744},"isTrigger":false}],"tissue_box_004":[{"center":{"x":0,"y":-0.07860146462917328,"z":0},"size":{"x":1.999428391456604,"y":0.858273983001709,"z":1.3068103790283203},"isTrigger":false},{"center":{"x":0.009613335132598877,"y":0.3955116271972656,"z":0.2842409908771515},"size":{"x":1.0883957147598267,"y":0.22445368766784668,"z":0.42347198724746704},"isTrigger":false}],"tissue_box_001":[{"center":{"x":0,"y":-0.07860146462917328,"z":0},"size":{"x":1.999428391456604,"y":0.858273983001709,"z":1.3068103790283203},"isTrigger":false},{"center":{"x":0.009613335132598877,"y":0.3955116271972656,"z":0.2842409908771515},"size":{"x":1.0883957147598267,"y":0.22445368766784668,"z":0.42347198724746704},"isTrigger":false}],"tissue_box_003":[{"center":{"x":0,"y":-0.07860146462917328,"z":0},"size":{"x":1.999428391456604,"y":0.858273983001709,"z":1.3068103790283203},"isTrigger":false},{"center":{"x":0.009613335132598877,"y":0.3955116271972656,"z":0.2842409908771515},"size":{"x":1.0883957147598267,"y":0.22445368766784668,"z":0.42347198724746704},"isTrigger":false}],"fridge_001":[{"center":{"x":-2.2739014625549316,"y":-1.7672154903411865,"z":2.1313319206237793},"size":{"x":3.6225056648254395,"y":7.8746209144592285,"z":1.6682580709457397},"isTrigger":true},{"center":{"x":-2.288566827774048,"y":0,"z":3.8404183387756348},"size":{"x":5.068098068237305,"y":11.409032821655273,"z":0.4004473388195038},"isTrigger":false},{"center":{"x":-2.2547409534454346,"y":5.490795612335205,"z":1.8503458499908447},"size":{"x":5.135757923126221,"y":0.42747393250465393,"z":4.380593776702881},"isTrigger":false},{"center":{"x":-4.712140083312988,"y":0,"z":1.842522144317627},"size":{"x":0.2209557592868805,"y":11.409032821655273,"z":4.396244049072266},"isTrigger":false},{"center":{"x":0.15681691467761993,"y":0,"z":1.8090213537216187},"size":{"x":0.31952965259552,"y":11.409032821655273,"z":4.463247776031494},"isTrigger":false},{"center":{"x":4.006364345550537,"y":0,"z":-3.1928699016571045},"size":{"x":1.6325113773345947,"y":11.409032821655273,"z":1.6955567598342896},"isTrigger":false},{"center":{"x":2.475027561187744,"y":0,"z":-2.020284652709961},"size":{"x":1.4439038038253784,"y":11.409032821655273,"z":1.1224499940872192},"isTrigger":false},{"center":{"x":1.3137660026550293,"y":0,"z":-0.5243863463401794},"size":{"x":1.4738149642944336,"y":11.409032821655273,"z":1.891829252243042},"isTrigger":false}],"tissue_box_002":[{"center":{"x":0,"y":-0.07860146462917328,"z":0},"size":{"x":1.999428391456604,"y":0.858273983001709,"z":1.3068103790283203},"isTrigger":false},{"center":{"x":0.009613335132598877,"y":0.3955116271972656,"z":0.2842409908771515},"size":{"x":1.0883957147598267,"y":0.22445368766784668,"z":0.42347198724746704},"isTrigger":false}],"invisible_square_001":[{"center":{"x":-5.960464477539063e-8,"y":0,"z":0},"size":{"x":1.0000001192092896,"y":1.0000001192092896,"z":1.0000001192092896},"isTrigger":false}],"start_line":[{"center":{"x":0,"y":-2.384185791015625e-7,"z":1.1200000047683716},"size":{"x":85.55000305175781,"y":45.25,"z":1.6710872650146484},"isTrigger":true}],"cleaver_003":[{"center":{"x":0.2450007051229477,"y":-0.35259777307510376,"z":0.00297660194337368},"size":{"x":0.17818376421928406,"y":0.13774240016937256,"z":0.05617908760905266},"isTrigger":false},{"center":{"x":0.2400682419538498,"y":-0.8627925515174866,"z":0.0018422529101371765},"size":{"x":0.23025992512702942,"y":0.9015806913375854,"z":0.10214754939079285},"isTrigger":false},{"center":{"x":-0.011205479502677917,"y":0.4775858521461487,"z":0.0027481187134981155},"size":{"x":0.6925286054611206,"y":1.666383147239685,"z":0.056859951466321945},"isTrigger":false}],"cleaver_004":[{"center":{"x":0.2450007051229477,"y":-0.35259777307510376,"z":0.00297660194337368},"size":{"x":0.17818376421928406,"y":0.13774240016937256,"z":0.05617908760905266},"isTrigger":false},{"center":{"x":0.2400682419538498,"y":-0.8627925515174866,"z":0.0018422529101371765},"size":{"x":0.23025992512702942,"y":0.9015806913375854,"z":0.10214754939079285},"isTrigger":false},{"center":{"x":-0.011205479502677917,"y":0.4775858521461487,"z":0.0027481187134981155},"size":{"x":0.6925286054611206,"y":1.666383147239685,"z":0.056859951466321945},"isTrigger":false}],"cleaver_002":[{"center":{"x":-0.011205479502677917,"y":0.4775858521461487,"z":0.0027481187134981155},"size":{"x":0.6925286054611206,"y":1.666383147239685,"z":0.056859951466321945},"isTrigger":false},{"center":{"x":0.2450007051229477,"y":-0.35259777307510376,"z":0.00297660194337368},"size":{"x":0.17818376421928406,"y":0.13774240016937256,"z":0.05617908760905266},"isTrigger":false},{"center":{"x":0.2400682419538498,"y":-0.8627925515174866,"z":0.0018422529101371765},"size":{"x":0.23025992512702942,"y":0.9015806913375854,"z":0.10214754939079285},"isTrigger":false}]}');


/********************************************/ /*                                          */ /*        Platform Models & Metadata        */ /*                                          */ /********************************************/ var $69d6cbd59c5bb72c$export$a5ca04c0dcf1c065;
(function(Platforms) {
    Platforms[Platforms["CuttingBoard"] = 0] = "CuttingBoard";
    Platforms[Platforms["LargeCube001"] = 1] = "LargeCube001";
    Platforms[Platforms["LargeCube002"] = 2] = "LargeCube002";
    Platforms[Platforms["LargeCube003"] = 3] = "LargeCube003";
    Platforms[Platforms["LargeCube004"] = 4] = "LargeCube004";
    Platforms[Platforms["LargeCube005"] = 5] = "LargeCube005";
    Platforms[Platforms["LargeCube006"] = 6] = "LargeCube006";
    Platforms[Platforms["LargeCube007"] = 7] = "LargeCube007";
    Platforms[Platforms["LargeCube008"] = 8] = "LargeCube008";
    Platforms[Platforms["LargeSquare001"] = 9] = "LargeSquare001";
    Platforms[Platforms["LargeSquare002"] = 10] = "LargeSquare002";
    Platforms[Platforms["LargeSquare003"] = 11] = "LargeSquare003";
    Platforms[Platforms["LargeSquare004"] = 12] = "LargeSquare004";
    Platforms[Platforms["LargeSquare005"] = 13] = "LargeSquare005";
    Platforms[Platforms["LargeSquare006"] = 14] = "LargeSquare006";
    Platforms[Platforms["LargeSquare007"] = 15] = "LargeSquare007";
    Platforms[Platforms["LargeSquare008"] = 16] = "LargeSquare008";
    Platforms[Platforms["Pan001"] = 17] = "Pan001";
    Platforms[Platforms["Pan002"] = 18] = "Pan002";
    Platforms[Platforms["Pan003"] = 19] = "Pan003";
    Platforms[Platforms["Pan004"] = 20] = "Pan004";
    Platforms[Platforms["MediumSquare001"] = 21] = "MediumSquare001";
    Platforms[Platforms["MediumSquare002"] = 22] = "MediumSquare002";
    Platforms[Platforms["MediumSquare003"] = 23] = "MediumSquare003";
    Platforms[Platforms["MediumSquare004"] = 24] = "MediumSquare004";
    Platforms[Platforms["MediumSquare005"] = 25] = "MediumSquare005";
    Platforms[Platforms["MediumSquare006"] = 26] = "MediumSquare006";
    Platforms[Platforms["MediumSquare007"] = 27] = "MediumSquare007";
    Platforms[Platforms["MediumSquare008"] = 28] = "MediumSquare008";
    Platforms[Platforms["AlternatePan001"] = 29] = "AlternatePan001";
    Platforms[Platforms["AlternatePan002"] = 30] = "AlternatePan002";
    Platforms[Platforms["AlternatePan003"] = 31] = "AlternatePan003";
    Platforms[Platforms["AlternatePan004"] = 32] = "AlternatePan004";
    Platforms[Platforms["Pot001"] = 33] = "Pot001";
    Platforms[Platforms["Pot002"] = 34] = "Pot002";
    Platforms[Platforms["Pot003"] = 35] = "Pot003";
    Platforms[Platforms["Pot004"] = 36] = "Pot004";
    Platforms[Platforms["Rectangle001"] = 37] = "Rectangle001";
    Platforms[Platforms["Rectangle002"] = 38] = "Rectangle002";
    Platforms[Platforms["Rectangle003"] = 39] = "Rectangle003";
    Platforms[Platforms["Rectangle004"] = 40] = "Rectangle004";
    Platforms[Platforms["Rectangle005"] = 41] = "Rectangle005";
    Platforms[Platforms["Rectangle006"] = 42] = "Rectangle006";
    Platforms[Platforms["Rectangle007"] = 43] = "Rectangle007";
    Platforms[Platforms["Rectangle008"] = 44] = "Rectangle008";
    Platforms[Platforms["Pepper"] = 45] = "Pepper";
    Platforms[Platforms["Salt"] = 46] = "Salt";
    Platforms[Platforms["RollingPin"] = 47] = "RollingPin";
    Platforms[Platforms["Square001"] = 48] = "Square001";
    Platforms[Platforms["Square002"] = 49] = "Square002";
    Platforms[Platforms["Square003"] = 50] = "Square003";
    Platforms[Platforms["Square004"] = 51] = "Square004";
    Platforms[Platforms["Square005"] = 52] = "Square005";
    Platforms[Platforms["Square006"] = 53] = "Square006";
    Platforms[Platforms["Square007"] = 54] = "Square007";
    Platforms[Platforms["Square008"] = 55] = "Square008";
    Platforms[Platforms["Spatula001"] = 56] = "Spatula001";
    Platforms[Platforms["Spatula002"] = 57] = "Spatula002";
    Platforms[Platforms["Spatula003"] = 58] = "Spatula003";
    Platforms[Platforms["Spatula004"] = 59] = "Spatula004";
    Platforms[Platforms["Toaster001"] = 60] = "Toaster001";
    Platforms[Platforms["Toaster002"] = 61] = "Toaster002";
    Platforms[Platforms["Toaster003"] = 62] = "Toaster003";
    Platforms[Platforms["Toaster004"] = 63] = "Toaster004";
    Platforms[Platforms["TissueBox001"] = 64] = "TissueBox001";
    Platforms[Platforms["TissueBox002"] = 65] = "TissueBox002";
    Platforms[Platforms["TissueBox003"] = 66] = "TissueBox003";
    Platforms[Platforms["TissueBox004"] = 67] = "TissueBox004";
    Platforms[Platforms["Plate001"] = 68] = "Plate001";
    Platforms[Platforms["Plate002"] = 69] = "Plate002";
    Platforms[Platforms["Plate003"] = 70] = "Plate003";
    Platforms[Platforms["Plate004"] = 71] = "Plate004";
    Platforms[Platforms["Knife001"] = 72] = "Knife001";
    Platforms[Platforms["Knife002"] = 73] = "Knife002";
    Platforms[Platforms["Knife003"] = 74] = "Knife003";
    Platforms[Platforms["Knife004"] = 75] = "Knife004";
    Platforms[Platforms["Fork001"] = 76] = "Fork001";
    Platforms[Platforms["Fork002"] = 77] = "Fork002";
    Platforms[Platforms["Fork003"] = 78] = "Fork003";
    Platforms[Platforms["Fork004"] = 79] = "Fork004";
    Platforms[Platforms["FireExtinguisher"] = 80] = "FireExtinguisher";
    Platforms[Platforms["FinishLine"] = 81] = "FinishLine";
    Platforms[Platforms["Cleaver001"] = 82] = "Cleaver001";
    Platforms[Platforms["Cleaver002"] = 83] = "Cleaver002";
    Platforms[Platforms["Cleaver003"] = 84] = "Cleaver003";
    Platforms[Platforms["Cleaver004"] = 85] = "Cleaver004";
    Platforms[Platforms["ChoppingKnife001"] = 86] = "ChoppingKnife001";
    Platforms[Platforms["ChoppingKnife002"] = 87] = "ChoppingKnife002";
    Platforms[Platforms["ChoppingKnife003"] = 88] = "ChoppingKnife003";
    Platforms[Platforms["ChoppingKnife004"] = 89] = "ChoppingKnife004";
    Platforms[Platforms["Checkpoint"] = 90] = "Checkpoint";
    Platforms[Platforms["Bowl001"] = 91] = "Bowl001";
    Platforms[Platforms["Bowl002"] = 92] = "Bowl002";
    Platforms[Platforms["Bowl003"] = 93] = "Bowl003";
    Platforms[Platforms["Bowl004"] = 94] = "Bowl004";
    Platforms[Platforms["BigSpoon001"] = 95] = "BigSpoon001";
    Platforms[Platforms["BigSpoon002"] = 96] = "BigSpoon002";
    Platforms[Platforms["BigSpoon003"] = 97] = "BigSpoon003";
    Platforms[Platforms["BigSpoon004"] = 98] = "BigSpoon004";
    Platforms[Platforms["BakingTray001"] = 99] = "BakingTray001";
    Platforms[Platforms["BakingTray002"] = 100] = "BakingTray002";
    Platforms[Platforms["BakingTray003"] = 101] = "BakingTray003";
    Platforms[Platforms["BakingTray004"] = 102] = "BakingTray004";
    Platforms[Platforms["BakingPan001"] = 103] = "BakingPan001";
    Platforms[Platforms["BakingPan002"] = 104] = "BakingPan002";
    Platforms[Platforms["BakingPan003"] = 105] = "BakingPan003";
    Platforms[Platforms["BakingPan004"] = 106] = "BakingPan004";
    Platforms[Platforms["Blueberry"] = 107] = "Blueberry";
    Platforms[Platforms["Chocolate"] = 108] = "Chocolate";
    Platforms[Platforms["Mango"] = 109] = "Mango";
    Platforms[Platforms["Pistachio"] = 110] = "Pistachio";
    Platforms[Platforms["Purple"] = 111] = "Purple";
    Platforms[Platforms["Strawberry"] = 112] = "Strawberry";
    Platforms[Platforms["Vanilla"] = 113] = "Vanilla";
    Platforms[Platforms["DeathBlock001"] = 114] = "DeathBlock001";
    Platforms[Platforms["MovingBlock001"] = 115] = "MovingBlock001";
    Platforms[Platforms["SlipperyBlock001"] = 116] = "SlipperyBlock001";
    Platforms[Platforms["SlowBlock001"] = 117] = "SlowBlock001";
    Platforms[Platforms["StartingLine"] = 118] = "StartingLine";
    Platforms[Platforms["InvisibleSquare001"] = 119] = "InvisibleSquare001";
    Platforms[Platforms["Fridge_001"] = 120] = "Fridge_001";
    Platforms[Platforms["Gorilla"] = 121] = "Gorilla";
})($69d6cbd59c5bb72c$export$a5ca04c0dcf1c065 || ($69d6cbd59c5bb72c$export$a5ca04c0dcf1c065 = {}));
const $69d6cbd59c5bb72c$export$26761271fdc2dd5e = new Map();
const $69d6cbd59c5bb72c$export$414b10a35cf658a8 = (jsonIdentifier)=>{
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    for (const [_, platformMetadata] of $69d6cbd59c5bb72c$export$26761271fdc2dd5e){
        if (platformMetadata.jsonIdentifier === jsonIdentifier) return platformMetadata;
    }
    return undefined;
};
$69d6cbd59c5bb72c$export$26761271fdc2dd5e.set($69d6cbd59c5bb72c$export$a5ca04c0dcf1c065.CuttingBoard, {
    platformEnumIdentifier: $69d6cbd59c5bb72c$export$a5ca04c0dcf1c065.CuttingBoard,
    jsonIdentifier: "cutting_board",
    assetPath: "platforms/cutting_board.glb"
});
$69d6cbd59c5bb72c$export$26761271fdc2dd5e.set($69d6cbd59c5bb72c$export$a5ca04c0dcf1c065.LargeCube001, {
    platformEnumIdentifier: $69d6cbd59c5bb72c$export$a5ca04c0dcf1c065.LargeCube001,
    jsonIdentifier: "large_cube_001",
    assetPath: "platforms/large_cube_001.glb"
});
$69d6cbd59c5bb72c$export$26761271fdc2dd5e.set($69d6cbd59c5bb72c$export$a5ca04c0dcf1c065.LargeCube002, {
    platformEnumIdentifier: $69d6cbd59c5bb72c$export$a5ca04c0dcf1c065.LargeCube002,
    jsonIdentifier: "large_cube_002",
    assetPath: "platforms/large_cube_002.glb"
});
$69d6cbd59c5bb72c$export$26761271fdc2dd5e.set($69d6cbd59c5bb72c$export$a5ca04c0dcf1c065.LargeCube003, {
    platformEnumIdentifier: $69d6cbd59c5bb72c$export$a5ca04c0dcf1c065.LargeCube003,
    jsonIdentifier: "large_cube_003",
    assetPath: "platforms/large_cube_003.glb"
});
$69d6cbd59c5bb72c$export$26761271fdc2dd5e.set($69d6cbd59c5bb72c$export$a5ca04c0dcf1c065.LargeCube004, {
    platformEnumIdentifier: $69d6cbd59c5bb72c$export$a5ca04c0dcf1c065.LargeCube004,
    jsonIdentifier: "large_cube_004",
    assetPath: "platforms/large_cube_004.glb"
});
$69d6cbd59c5bb72c$export$26761271fdc2dd5e.set($69d6cbd59c5bb72c$export$a5ca04c0dcf1c065.LargeCube005, {
    platformEnumIdentifier: $69d6cbd59c5bb72c$export$a5ca04c0dcf1c065.LargeCube005,
    jsonIdentifier: "large_cube_005",
    assetPath: "platforms/large_cube_005.glb"
});
$69d6cbd59c5bb72c$export$26761271fdc2dd5e.set($69d6cbd59c5bb72c$export$a5ca04c0dcf1c065.LargeCube006, {
    platformEnumIdentifier: $69d6cbd59c5bb72c$export$a5ca04c0dcf1c065.LargeCube006,
    jsonIdentifier: "large_cube_006",
    assetPath: "platforms/large_cube_006.glb"
});
$69d6cbd59c5bb72c$export$26761271fdc2dd5e.set($69d6cbd59c5bb72c$export$a5ca04c0dcf1c065.LargeCube007, {
    platformEnumIdentifier: $69d6cbd59c5bb72c$export$a5ca04c0dcf1c065.LargeCube007,
    jsonIdentifier: "large_cube_007LargeCube007",
    assetPath: "platforms/large_cube_007.glb"
});
$69d6cbd59c5bb72c$export$26761271fdc2dd5e.set($69d6cbd59c5bb72c$export$a5ca04c0dcf1c065.LargeCube008, {
    platformEnumIdentifier: $69d6cbd59c5bb72c$export$a5ca04c0dcf1c065.LargeCube008,
    jsonIdentifier: "large_cube_008",
    assetPath: "platforms/large_cube_008.glb"
});
$69d6cbd59c5bb72c$export$26761271fdc2dd5e.set($69d6cbd59c5bb72c$export$a5ca04c0dcf1c065.LargeSquare001, {
    platformEnumIdentifier: $69d6cbd59c5bb72c$export$a5ca04c0dcf1c065.LargeSquare001,
    jsonIdentifier: "large_square_001",
    assetPath: "platforms/large_square_001.glb"
});
$69d6cbd59c5bb72c$export$26761271fdc2dd5e.set($69d6cbd59c5bb72c$export$a5ca04c0dcf1c065.LargeSquare002, {
    platformEnumIdentifier: $69d6cbd59c5bb72c$export$a5ca04c0dcf1c065.LargeSquare002,
    jsonIdentifier: "large_square_002",
    assetPath: "platforms/large_square_002.glb"
});
$69d6cbd59c5bb72c$export$26761271fdc2dd5e.set($69d6cbd59c5bb72c$export$a5ca04c0dcf1c065.LargeSquare003, {
    platformEnumIdentifier: $69d6cbd59c5bb72c$export$a5ca04c0dcf1c065.LargeSquare003,
    jsonIdentifier: "large_square_003",
    assetPath: "platforms/large_square_003.glb"
});
$69d6cbd59c5bb72c$export$26761271fdc2dd5e.set($69d6cbd59c5bb72c$export$a5ca04c0dcf1c065.LargeSquare004, {
    platformEnumIdentifier: $69d6cbd59c5bb72c$export$a5ca04c0dcf1c065.LargeSquare004,
    jsonIdentifier: "large_square_004",
    assetPath: "platforms/large_square_004.glb"
});
$69d6cbd59c5bb72c$export$26761271fdc2dd5e.set($69d6cbd59c5bb72c$export$a5ca04c0dcf1c065.LargeSquare005, {
    platformEnumIdentifier: $69d6cbd59c5bb72c$export$a5ca04c0dcf1c065.LargeSquare005,
    jsonIdentifier: "large_square_005",
    assetPath: "platforms/large_square_005.glb"
});
$69d6cbd59c5bb72c$export$26761271fdc2dd5e.set($69d6cbd59c5bb72c$export$a5ca04c0dcf1c065.LargeSquare006, {
    platformEnumIdentifier: $69d6cbd59c5bb72c$export$a5ca04c0dcf1c065.LargeSquare006,
    jsonIdentifier: "large_square_006",
    assetPath: "platforms/large_square_006.glb"
});
$69d6cbd59c5bb72c$export$26761271fdc2dd5e.set($69d6cbd59c5bb72c$export$a5ca04c0dcf1c065.LargeSquare007, {
    platformEnumIdentifier: $69d6cbd59c5bb72c$export$a5ca04c0dcf1c065.LargeSquare007,
    jsonIdentifier: "large_square_007",
    assetPath: "platforms/large_square_007.glb"
});
$69d6cbd59c5bb72c$export$26761271fdc2dd5e.set($69d6cbd59c5bb72c$export$a5ca04c0dcf1c065.LargeSquare008, {
    platformEnumIdentifier: $69d6cbd59c5bb72c$export$a5ca04c0dcf1c065.LargeSquare008,
    jsonIdentifier: "large_square_008",
    assetPath: "platforms/large_square_008.glb"
});
$69d6cbd59c5bb72c$export$26761271fdc2dd5e.set($69d6cbd59c5bb72c$export$a5ca04c0dcf1c065.Pan001, {
    platformEnumIdentifier: $69d6cbd59c5bb72c$export$a5ca04c0dcf1c065.Pan001,
    jsonIdentifier: "pan_001",
    assetPath: "platforms/pan_001.glb"
});
$69d6cbd59c5bb72c$export$26761271fdc2dd5e.set($69d6cbd59c5bb72c$export$a5ca04c0dcf1c065.Pan002, {
    platformEnumIdentifier: $69d6cbd59c5bb72c$export$a5ca04c0dcf1c065.Pan002,
    jsonIdentifier: "pan_002",
    assetPath: "platforms/pan_002.glb"
});
$69d6cbd59c5bb72c$export$26761271fdc2dd5e.set($69d6cbd59c5bb72c$export$a5ca04c0dcf1c065.Pan003, {
    platformEnumIdentifier: $69d6cbd59c5bb72c$export$a5ca04c0dcf1c065.Pan003,
    jsonIdentifier: "pan_003",
    assetPath: "platforms/pan_003.glb"
});
$69d6cbd59c5bb72c$export$26761271fdc2dd5e.set($69d6cbd59c5bb72c$export$a5ca04c0dcf1c065.Pan004, {
    platformEnumIdentifier: $69d6cbd59c5bb72c$export$a5ca04c0dcf1c065.Pan004,
    jsonIdentifier: "pan_004",
    assetPath: "platforms/pan_004.glb"
});
$69d6cbd59c5bb72c$export$26761271fdc2dd5e.set($69d6cbd59c5bb72c$export$a5ca04c0dcf1c065.MediumSquare001, {
    platformEnumIdentifier: $69d6cbd59c5bb72c$export$a5ca04c0dcf1c065.MediumSquare001,
    jsonIdentifier: "medium_square_001",
    assetPath: "platforms/medium_square_001.glb"
});
$69d6cbd59c5bb72c$export$26761271fdc2dd5e.set($69d6cbd59c5bb72c$export$a5ca04c0dcf1c065.MediumSquare002, {
    platformEnumIdentifier: $69d6cbd59c5bb72c$export$a5ca04c0dcf1c065.MediumSquare002,
    jsonIdentifier: "medium_square_002",
    assetPath: "platforms/medium_square_002.glb"
});
$69d6cbd59c5bb72c$export$26761271fdc2dd5e.set($69d6cbd59c5bb72c$export$a5ca04c0dcf1c065.MediumSquare003, {
    platformEnumIdentifier: $69d6cbd59c5bb72c$export$a5ca04c0dcf1c065.MediumSquare003,
    jsonIdentifier: "medium_square_003",
    assetPath: "platforms/medium_square_003.glb"
});
$69d6cbd59c5bb72c$export$26761271fdc2dd5e.set($69d6cbd59c5bb72c$export$a5ca04c0dcf1c065.MediumSquare004, {
    platformEnumIdentifier: $69d6cbd59c5bb72c$export$a5ca04c0dcf1c065.MediumSquare004,
    jsonIdentifier: "medium_square_004",
    assetPath: "platforms/medium_square_004.glb"
});
$69d6cbd59c5bb72c$export$26761271fdc2dd5e.set($69d6cbd59c5bb72c$export$a5ca04c0dcf1c065.MediumSquare005, {
    platformEnumIdentifier: $69d6cbd59c5bb72c$export$a5ca04c0dcf1c065.MediumSquare005,
    jsonIdentifier: "medium_square_005",
    assetPath: "platforms/medium_square_005.glb"
});
$69d6cbd59c5bb72c$export$26761271fdc2dd5e.set($69d6cbd59c5bb72c$export$a5ca04c0dcf1c065.MediumSquare006, {
    platformEnumIdentifier: $69d6cbd59c5bb72c$export$a5ca04c0dcf1c065.MediumSquare006,
    jsonIdentifier: "medium_square_006",
    assetPath: "platforms/medium_square_006.glb"
});
$69d6cbd59c5bb72c$export$26761271fdc2dd5e.set($69d6cbd59c5bb72c$export$a5ca04c0dcf1c065.MediumSquare007, {
    platformEnumIdentifier: $69d6cbd59c5bb72c$export$a5ca04c0dcf1c065.MediumSquare007,
    jsonIdentifier: "medium_square_007",
    assetPath: "platforms/medium_square_007.glb"
});
$69d6cbd59c5bb72c$export$26761271fdc2dd5e.set($69d6cbd59c5bb72c$export$a5ca04c0dcf1c065.MediumSquare008, {
    platformEnumIdentifier: $69d6cbd59c5bb72c$export$a5ca04c0dcf1c065.MediumSquare008,
    jsonIdentifier: "medium_square_008",
    assetPath: "platforms/medium_square_008.glb"
});
$69d6cbd59c5bb72c$export$26761271fdc2dd5e.set($69d6cbd59c5bb72c$export$a5ca04c0dcf1c065.AlternatePan001, {
    platformEnumIdentifier: $69d6cbd59c5bb72c$export$a5ca04c0dcf1c065.AlternatePan001,
    jsonIdentifier: "alternate_pan_001",
    assetPath: "platforms/pan_alt_001.glb"
});
$69d6cbd59c5bb72c$export$26761271fdc2dd5e.set($69d6cbd59c5bb72c$export$a5ca04c0dcf1c065.AlternatePan002, {
    platformEnumIdentifier: $69d6cbd59c5bb72c$export$a5ca04c0dcf1c065.AlternatePan002,
    jsonIdentifier: "alternate_pan_002",
    assetPath: "platforms/pan_alt_002.glb"
});
$69d6cbd59c5bb72c$export$26761271fdc2dd5e.set($69d6cbd59c5bb72c$export$a5ca04c0dcf1c065.AlternatePan003, {
    platformEnumIdentifier: $69d6cbd59c5bb72c$export$a5ca04c0dcf1c065.AlternatePan003,
    jsonIdentifier: "alternate_pan_003",
    assetPath: "platforms/pan_alt_003.glb"
});
$69d6cbd59c5bb72c$export$26761271fdc2dd5e.set($69d6cbd59c5bb72c$export$a5ca04c0dcf1c065.AlternatePan004, {
    platformEnumIdentifier: $69d6cbd59c5bb72c$export$a5ca04c0dcf1c065.AlternatePan004,
    jsonIdentifier: "alternate_pan_004",
    assetPath: "platforms/pan_alt_004.glb"
});
$69d6cbd59c5bb72c$export$26761271fdc2dd5e.set($69d6cbd59c5bb72c$export$a5ca04c0dcf1c065.Pot001, {
    platformEnumIdentifier: $69d6cbd59c5bb72c$export$a5ca04c0dcf1c065.Pot001,
    jsonIdentifier: "pot_001",
    assetPath: "platforms/pot_001.glb"
});
$69d6cbd59c5bb72c$export$26761271fdc2dd5e.set($69d6cbd59c5bb72c$export$a5ca04c0dcf1c065.Pot002, {
    platformEnumIdentifier: $69d6cbd59c5bb72c$export$a5ca04c0dcf1c065.Pot002,
    jsonIdentifier: "pot_002",
    assetPath: "platforms/pot_002.glb"
});
$69d6cbd59c5bb72c$export$26761271fdc2dd5e.set($69d6cbd59c5bb72c$export$a5ca04c0dcf1c065.Pot003, {
    platformEnumIdentifier: $69d6cbd59c5bb72c$export$a5ca04c0dcf1c065.Pot003,
    jsonIdentifier: "pot_003",
    assetPath: "platforms/pot_003.glb"
});
$69d6cbd59c5bb72c$export$26761271fdc2dd5e.set($69d6cbd59c5bb72c$export$a5ca04c0dcf1c065.Pot004, {
    platformEnumIdentifier: $69d6cbd59c5bb72c$export$a5ca04c0dcf1c065.Pot004,
    jsonIdentifier: "pot_004",
    assetPath: "platforms/pot_004.glb"
});
$69d6cbd59c5bb72c$export$26761271fdc2dd5e.set($69d6cbd59c5bb72c$export$a5ca04c0dcf1c065.Rectangle001, {
    platformEnumIdentifier: $69d6cbd59c5bb72c$export$a5ca04c0dcf1c065.Rectangle001,
    jsonIdentifier: "rectangle_001",
    assetPath: "platforms/rectangle_001.glb"
});
$69d6cbd59c5bb72c$export$26761271fdc2dd5e.set($69d6cbd59c5bb72c$export$a5ca04c0dcf1c065.Rectangle002, {
    platformEnumIdentifier: $69d6cbd59c5bb72c$export$a5ca04c0dcf1c065.Rectangle002,
    jsonIdentifier: "rectangle_002",
    assetPath: "platforms/rectangle_002.glb"
});
$69d6cbd59c5bb72c$export$26761271fdc2dd5e.set($69d6cbd59c5bb72c$export$a5ca04c0dcf1c065.Rectangle003, {
    platformEnumIdentifier: $69d6cbd59c5bb72c$export$a5ca04c0dcf1c065.Rectangle003,
    jsonIdentifier: "rectangle_003",
    assetPath: "platforms/rectangle_003.glb"
});
$69d6cbd59c5bb72c$export$26761271fdc2dd5e.set($69d6cbd59c5bb72c$export$a5ca04c0dcf1c065.Rectangle004, {
    platformEnumIdentifier: $69d6cbd59c5bb72c$export$a5ca04c0dcf1c065.Rectangle004,
    jsonIdentifier: "rectangle_004",
    assetPath: "platforms/rectangle_004.glb"
});
$69d6cbd59c5bb72c$export$26761271fdc2dd5e.set($69d6cbd59c5bb72c$export$a5ca04c0dcf1c065.Rectangle005, {
    platformEnumIdentifier: $69d6cbd59c5bb72c$export$a5ca04c0dcf1c065.Rectangle005,
    jsonIdentifier: "rectangle_005",
    assetPath: "platforms/rectangle_005.glb"
});
$69d6cbd59c5bb72c$export$26761271fdc2dd5e.set($69d6cbd59c5bb72c$export$a5ca04c0dcf1c065.Rectangle006, {
    platformEnumIdentifier: $69d6cbd59c5bb72c$export$a5ca04c0dcf1c065.Rectangle006,
    jsonIdentifier: "rectangle_006",
    assetPath: "platforms/rectangle_006.glb"
});
$69d6cbd59c5bb72c$export$26761271fdc2dd5e.set($69d6cbd59c5bb72c$export$a5ca04c0dcf1c065.Rectangle007, {
    platformEnumIdentifier: $69d6cbd59c5bb72c$export$a5ca04c0dcf1c065.Rectangle007,
    jsonIdentifier: "rectangle_007",
    assetPath: "platforms/rectangle_007.glb"
});
$69d6cbd59c5bb72c$export$26761271fdc2dd5e.set($69d6cbd59c5bb72c$export$a5ca04c0dcf1c065.Rectangle008, {
    platformEnumIdentifier: $69d6cbd59c5bb72c$export$a5ca04c0dcf1c065.Rectangle008,
    jsonIdentifier: "rectangle_008",
    assetPath: "platforms/rectangle_008.glb"
});
$69d6cbd59c5bb72c$export$26761271fdc2dd5e.set($69d6cbd59c5bb72c$export$a5ca04c0dcf1c065.Pepper, {
    platformEnumIdentifier: $69d6cbd59c5bb72c$export$a5ca04c0dcf1c065.Pepper,
    jsonIdentifier: "pepper",
    assetPath: "platforms/pepper.glb"
});
$69d6cbd59c5bb72c$export$26761271fdc2dd5e.set($69d6cbd59c5bb72c$export$a5ca04c0dcf1c065.Salt, {
    platformEnumIdentifier: $69d6cbd59c5bb72c$export$a5ca04c0dcf1c065.Salt,
    jsonIdentifier: "salt",
    assetPath: "platforms/salt.glb"
});
$69d6cbd59c5bb72c$export$26761271fdc2dd5e.set($69d6cbd59c5bb72c$export$a5ca04c0dcf1c065.RollingPin, {
    platformEnumIdentifier: $69d6cbd59c5bb72c$export$a5ca04c0dcf1c065.RollingPin,
    jsonIdentifier: "rolling_pin",
    assetPath: "platforms/rolling_pin.glb"
});
$69d6cbd59c5bb72c$export$26761271fdc2dd5e.set($69d6cbd59c5bb72c$export$a5ca04c0dcf1c065.Square001, {
    platformEnumIdentifier: $69d6cbd59c5bb72c$export$a5ca04c0dcf1c065.Square001,
    jsonIdentifier: "square_001",
    assetPath: "platforms/square_001.glb"
});
$69d6cbd59c5bb72c$export$26761271fdc2dd5e.set($69d6cbd59c5bb72c$export$a5ca04c0dcf1c065.Square002, {
    platformEnumIdentifier: $69d6cbd59c5bb72c$export$a5ca04c0dcf1c065.Square002,
    jsonIdentifier: "square_002",
    assetPath: "platforms/square_002.glb"
});
$69d6cbd59c5bb72c$export$26761271fdc2dd5e.set($69d6cbd59c5bb72c$export$a5ca04c0dcf1c065.Square003, {
    platformEnumIdentifier: $69d6cbd59c5bb72c$export$a5ca04c0dcf1c065.Square003,
    jsonIdentifier: "square_003",
    assetPath: "platforms/square_003.glb"
});
$69d6cbd59c5bb72c$export$26761271fdc2dd5e.set($69d6cbd59c5bb72c$export$a5ca04c0dcf1c065.Square004, {
    platformEnumIdentifier: $69d6cbd59c5bb72c$export$a5ca04c0dcf1c065.Square004,
    jsonIdentifier: "square_004",
    assetPath: "platforms/square_004.glb"
});
$69d6cbd59c5bb72c$export$26761271fdc2dd5e.set($69d6cbd59c5bb72c$export$a5ca04c0dcf1c065.Square005, {
    platformEnumIdentifier: $69d6cbd59c5bb72c$export$a5ca04c0dcf1c065.Square005,
    jsonIdentifier: "square_005",
    assetPath: "platforms/square_005.glb"
});
$69d6cbd59c5bb72c$export$26761271fdc2dd5e.set($69d6cbd59c5bb72c$export$a5ca04c0dcf1c065.Square006, {
    platformEnumIdentifier: $69d6cbd59c5bb72c$export$a5ca04c0dcf1c065.Square006,
    jsonIdentifier: "square_006",
    assetPath: "platforms/square_006.glb"
});
$69d6cbd59c5bb72c$export$26761271fdc2dd5e.set($69d6cbd59c5bb72c$export$a5ca04c0dcf1c065.Square007, {
    platformEnumIdentifier: $69d6cbd59c5bb72c$export$a5ca04c0dcf1c065.Square007,
    jsonIdentifier: "square_007",
    assetPath: "platforms/square_007.glb"
});
$69d6cbd59c5bb72c$export$26761271fdc2dd5e.set($69d6cbd59c5bb72c$export$a5ca04c0dcf1c065.Square008, {
    platformEnumIdentifier: $69d6cbd59c5bb72c$export$a5ca04c0dcf1c065.Square008,
    jsonIdentifier: "square_008",
    assetPath: "platforms/square_008.glb"
});
$69d6cbd59c5bb72c$export$26761271fdc2dd5e.set($69d6cbd59c5bb72c$export$a5ca04c0dcf1c065.Spatula001, {
    platformEnumIdentifier: $69d6cbd59c5bb72c$export$a5ca04c0dcf1c065.Spatula001,
    jsonIdentifier: "spatula_001",
    assetPath: "platforms/spatula_001.glb"
});
$69d6cbd59c5bb72c$export$26761271fdc2dd5e.set($69d6cbd59c5bb72c$export$a5ca04c0dcf1c065.Spatula002, {
    platformEnumIdentifier: $69d6cbd59c5bb72c$export$a5ca04c0dcf1c065.Spatula002,
    jsonIdentifier: "spatula_002",
    assetPath: "platforms/spatula_002.glb"
});
$69d6cbd59c5bb72c$export$26761271fdc2dd5e.set($69d6cbd59c5bb72c$export$a5ca04c0dcf1c065.Spatula003, {
    platformEnumIdentifier: $69d6cbd59c5bb72c$export$a5ca04c0dcf1c065.Spatula003,
    jsonIdentifier: "spatula_003",
    assetPath: "platforms/spatula_003.glb"
});
$69d6cbd59c5bb72c$export$26761271fdc2dd5e.set($69d6cbd59c5bb72c$export$a5ca04c0dcf1c065.Spatula004, {
    platformEnumIdentifier: $69d6cbd59c5bb72c$export$a5ca04c0dcf1c065.Spatula004,
    jsonIdentifier: "spatula_004",
    assetPath: "platforms/spatula_004.glb"
});
$69d6cbd59c5bb72c$export$26761271fdc2dd5e.set($69d6cbd59c5bb72c$export$a5ca04c0dcf1c065.Toaster001, {
    platformEnumIdentifier: $69d6cbd59c5bb72c$export$a5ca04c0dcf1c065.Toaster001,
    jsonIdentifier: "toaster_001",
    assetPath: "platforms/toaster_001.glb"
});
$69d6cbd59c5bb72c$export$26761271fdc2dd5e.set($69d6cbd59c5bb72c$export$a5ca04c0dcf1c065.Toaster002, {
    platformEnumIdentifier: $69d6cbd59c5bb72c$export$a5ca04c0dcf1c065.Toaster002,
    jsonIdentifier: "toaster_002",
    assetPath: "platforms/toaster_002.glb"
});
$69d6cbd59c5bb72c$export$26761271fdc2dd5e.set($69d6cbd59c5bb72c$export$a5ca04c0dcf1c065.Toaster003, {
    platformEnumIdentifier: $69d6cbd59c5bb72c$export$a5ca04c0dcf1c065.Toaster003,
    jsonIdentifier: "toaster_003",
    assetPath: "platforms/toaster_003.glb"
});
$69d6cbd59c5bb72c$export$26761271fdc2dd5e.set($69d6cbd59c5bb72c$export$a5ca04c0dcf1c065.Toaster004, {
    platformEnumIdentifier: $69d6cbd59c5bb72c$export$a5ca04c0dcf1c065.Toaster004,
    jsonIdentifier: "toaster_004",
    assetPath: "platforms/toaster_004.glb"
});
$69d6cbd59c5bb72c$export$26761271fdc2dd5e.set($69d6cbd59c5bb72c$export$a5ca04c0dcf1c065.TissueBox001, {
    platformEnumIdentifier: $69d6cbd59c5bb72c$export$a5ca04c0dcf1c065.TissueBox001,
    jsonIdentifier: "tissue_box_001",
    assetPath: "platforms/tissue_box_001.glb"
});
$69d6cbd59c5bb72c$export$26761271fdc2dd5e.set($69d6cbd59c5bb72c$export$a5ca04c0dcf1c065.TissueBox002, {
    platformEnumIdentifier: $69d6cbd59c5bb72c$export$a5ca04c0dcf1c065.TissueBox002,
    jsonIdentifier: "tissue_box_002",
    assetPath: "platforms/tissue_box_002.glb"
});
$69d6cbd59c5bb72c$export$26761271fdc2dd5e.set($69d6cbd59c5bb72c$export$a5ca04c0dcf1c065.TissueBox003, {
    platformEnumIdentifier: $69d6cbd59c5bb72c$export$a5ca04c0dcf1c065.TissueBox003,
    jsonIdentifier: "tissue_box_003",
    assetPath: "platforms/tissue_box_003.glb"
});
$69d6cbd59c5bb72c$export$26761271fdc2dd5e.set($69d6cbd59c5bb72c$export$a5ca04c0dcf1c065.TissueBox004, {
    platformEnumIdentifier: $69d6cbd59c5bb72c$export$a5ca04c0dcf1c065.TissueBox004,
    jsonIdentifier: "tissue_box_004",
    assetPath: "platforms/tissue_box_004.glb"
});
$69d6cbd59c5bb72c$export$26761271fdc2dd5e.set($69d6cbd59c5bb72c$export$a5ca04c0dcf1c065.Plate001, {
    platformEnumIdentifier: $69d6cbd59c5bb72c$export$a5ca04c0dcf1c065.Plate001,
    jsonIdentifier: "plate_001",
    assetPath: "platforms/plate_001.glb"
});
$69d6cbd59c5bb72c$export$26761271fdc2dd5e.set($69d6cbd59c5bb72c$export$a5ca04c0dcf1c065.Plate002, {
    platformEnumIdentifier: $69d6cbd59c5bb72c$export$a5ca04c0dcf1c065.Plate002,
    jsonIdentifier: "plate_002",
    assetPath: "platforms/plate_002.glb"
});
$69d6cbd59c5bb72c$export$26761271fdc2dd5e.set($69d6cbd59c5bb72c$export$a5ca04c0dcf1c065.Plate003, {
    platformEnumIdentifier: $69d6cbd59c5bb72c$export$a5ca04c0dcf1c065.Plate003,
    jsonIdentifier: "plate_003",
    assetPath: "platforms/plate_003.glb"
});
$69d6cbd59c5bb72c$export$26761271fdc2dd5e.set($69d6cbd59c5bb72c$export$a5ca04c0dcf1c065.Plate004, {
    platformEnumIdentifier: $69d6cbd59c5bb72c$export$a5ca04c0dcf1c065.Plate004,
    jsonIdentifier: "plate_004",
    assetPath: "platforms/plate_004.glb"
});
$69d6cbd59c5bb72c$export$26761271fdc2dd5e.set($69d6cbd59c5bb72c$export$a5ca04c0dcf1c065.Knife001, {
    platformEnumIdentifier: $69d6cbd59c5bb72c$export$a5ca04c0dcf1c065.Knife001,
    jsonIdentifier: "knife_001",
    assetPath: "platforms/knife_001.glb"
});
$69d6cbd59c5bb72c$export$26761271fdc2dd5e.set($69d6cbd59c5bb72c$export$a5ca04c0dcf1c065.Knife002, {
    platformEnumIdentifier: $69d6cbd59c5bb72c$export$a5ca04c0dcf1c065.Knife002,
    jsonIdentifier: "knife_002",
    assetPath: "platforms/knife_002.glb"
});
$69d6cbd59c5bb72c$export$26761271fdc2dd5e.set($69d6cbd59c5bb72c$export$a5ca04c0dcf1c065.Knife003, {
    platformEnumIdentifier: $69d6cbd59c5bb72c$export$a5ca04c0dcf1c065.Knife003,
    jsonIdentifier: "knife_003",
    assetPath: "platforms/knife_003.glb"
});
$69d6cbd59c5bb72c$export$26761271fdc2dd5e.set($69d6cbd59c5bb72c$export$a5ca04c0dcf1c065.Knife004, {
    platformEnumIdentifier: $69d6cbd59c5bb72c$export$a5ca04c0dcf1c065.Knife004,
    jsonIdentifier: "knife_004",
    assetPath: "platforms/knife_004.glb"
});
$69d6cbd59c5bb72c$export$26761271fdc2dd5e.set($69d6cbd59c5bb72c$export$a5ca04c0dcf1c065.Fork001, {
    platformEnumIdentifier: $69d6cbd59c5bb72c$export$a5ca04c0dcf1c065.Fork001,
    jsonIdentifier: "fork_001",
    assetPath: "platforms/fork_001.glb"
});
$69d6cbd59c5bb72c$export$26761271fdc2dd5e.set($69d6cbd59c5bb72c$export$a5ca04c0dcf1c065.Fork002, {
    platformEnumIdentifier: $69d6cbd59c5bb72c$export$a5ca04c0dcf1c065.Fork002,
    jsonIdentifier: "fork_002",
    assetPath: "platforms/fork_002.glb"
});
$69d6cbd59c5bb72c$export$26761271fdc2dd5e.set($69d6cbd59c5bb72c$export$a5ca04c0dcf1c065.Fork003, {
    platformEnumIdentifier: $69d6cbd59c5bb72c$export$a5ca04c0dcf1c065.Fork003,
    jsonIdentifier: "fork_003",
    assetPath: "platforms/fork_003.glb"
});
$69d6cbd59c5bb72c$export$26761271fdc2dd5e.set($69d6cbd59c5bb72c$export$a5ca04c0dcf1c065.Fork004, {
    platformEnumIdentifier: $69d6cbd59c5bb72c$export$a5ca04c0dcf1c065.Fork004,
    jsonIdentifier: "fork_004",
    assetPath: "platforms/fork_004.glb"
});
$69d6cbd59c5bb72c$export$26761271fdc2dd5e.set($69d6cbd59c5bb72c$export$a5ca04c0dcf1c065.FireExtinguisher, {
    platformEnumIdentifier: $69d6cbd59c5bb72c$export$a5ca04c0dcf1c065.FireExtinguisher,
    jsonIdentifier: "fire_extinguisher",
    assetPath: "platforms/fire_extinguisher_001.glb"
});
$69d6cbd59c5bb72c$export$26761271fdc2dd5e.set($69d6cbd59c5bb72c$export$a5ca04c0dcf1c065.FinishLine, {
    platformEnumIdentifier: $69d6cbd59c5bb72c$export$a5ca04c0dcf1c065.FinishLine,
    jsonIdentifier: "finish_line_001",
    assetPath: "platforms/finish_line_001.glb"
});
$69d6cbd59c5bb72c$export$26761271fdc2dd5e.set($69d6cbd59c5bb72c$export$a5ca04c0dcf1c065.Cleaver001, {
    platformEnumIdentifier: $69d6cbd59c5bb72c$export$a5ca04c0dcf1c065.Cleaver001,
    jsonIdentifier: "cleaver_001",
    assetPath: "platforms/cleaver_001.glb"
});
$69d6cbd59c5bb72c$export$26761271fdc2dd5e.set($69d6cbd59c5bb72c$export$a5ca04c0dcf1c065.Cleaver002, {
    platformEnumIdentifier: $69d6cbd59c5bb72c$export$a5ca04c0dcf1c065.Cleaver002,
    jsonIdentifier: "cleaver_002",
    assetPath: "platforms/cleaver_002.glb"
});
$69d6cbd59c5bb72c$export$26761271fdc2dd5e.set($69d6cbd59c5bb72c$export$a5ca04c0dcf1c065.Cleaver003, {
    platformEnumIdentifier: $69d6cbd59c5bb72c$export$a5ca04c0dcf1c065.Cleaver003,
    jsonIdentifier: "cleaver_003",
    assetPath: "platforms/cleaver_003.glb"
});
$69d6cbd59c5bb72c$export$26761271fdc2dd5e.set($69d6cbd59c5bb72c$export$a5ca04c0dcf1c065.Cleaver004, {
    platformEnumIdentifier: $69d6cbd59c5bb72c$export$a5ca04c0dcf1c065.Cleaver004,
    jsonIdentifier: "cleaver_004",
    assetPath: "platforms/cleaver_004.glb"
});
$69d6cbd59c5bb72c$export$26761271fdc2dd5e.set($69d6cbd59c5bb72c$export$a5ca04c0dcf1c065.ChoppingKnife001, {
    platformEnumIdentifier: $69d6cbd59c5bb72c$export$a5ca04c0dcf1c065.ChoppingKnife001,
    jsonIdentifier: "chopping_knife_001",
    assetPath: "platforms/chopping_knife_001.glb"
});
$69d6cbd59c5bb72c$export$26761271fdc2dd5e.set($69d6cbd59c5bb72c$export$a5ca04c0dcf1c065.ChoppingKnife002, {
    platformEnumIdentifier: $69d6cbd59c5bb72c$export$a5ca04c0dcf1c065.ChoppingKnife002,
    jsonIdentifier: "chopping_knife_002",
    assetPath: "platforms/chopping_knife_002.glb"
});
$69d6cbd59c5bb72c$export$26761271fdc2dd5e.set($69d6cbd59c5bb72c$export$a5ca04c0dcf1c065.ChoppingKnife003, {
    platformEnumIdentifier: $69d6cbd59c5bb72c$export$a5ca04c0dcf1c065.ChoppingKnife003,
    jsonIdentifier: "chopping_knife_003",
    assetPath: "platforms/chopping_knife_003.glb"
});
$69d6cbd59c5bb72c$export$26761271fdc2dd5e.set($69d6cbd59c5bb72c$export$a5ca04c0dcf1c065.ChoppingKnife004, {
    platformEnumIdentifier: $69d6cbd59c5bb72c$export$a5ca04c0dcf1c065.ChoppingKnife004,
    jsonIdentifier: "chopping_knife_004",
    assetPath: "platforms/chopping_knife_004.glb"
});
$69d6cbd59c5bb72c$export$26761271fdc2dd5e.set($69d6cbd59c5bb72c$export$a5ca04c0dcf1c065.Checkpoint, {
    platformEnumIdentifier: $69d6cbd59c5bb72c$export$a5ca04c0dcf1c065.Checkpoint,
    jsonIdentifier: "check_point_001",
    assetPath: "platforms/check_point_001.glb"
});
$69d6cbd59c5bb72c$export$26761271fdc2dd5e.set($69d6cbd59c5bb72c$export$a5ca04c0dcf1c065.Bowl001, {
    platformEnumIdentifier: $69d6cbd59c5bb72c$export$a5ca04c0dcf1c065.Bowl001,
    jsonIdentifier: "bowl_001",
    assetPath: "platforms/bowl_001.glb"
});
$69d6cbd59c5bb72c$export$26761271fdc2dd5e.set($69d6cbd59c5bb72c$export$a5ca04c0dcf1c065.Bowl002, {
    platformEnumIdentifier: $69d6cbd59c5bb72c$export$a5ca04c0dcf1c065.Bowl002,
    jsonIdentifier: "bowl_002",
    assetPath: "platforms/bowl_002.glb"
});
$69d6cbd59c5bb72c$export$26761271fdc2dd5e.set($69d6cbd59c5bb72c$export$a5ca04c0dcf1c065.Bowl003, {
    platformEnumIdentifier: $69d6cbd59c5bb72c$export$a5ca04c0dcf1c065.Bowl003,
    jsonIdentifier: "bowl_003",
    assetPath: "platforms/bowl_003.glb"
});
$69d6cbd59c5bb72c$export$26761271fdc2dd5e.set($69d6cbd59c5bb72c$export$a5ca04c0dcf1c065.Bowl004, {
    platformEnumIdentifier: $69d6cbd59c5bb72c$export$a5ca04c0dcf1c065.Bowl004,
    jsonIdentifier: "bowl_004",
    assetPath: "platforms/bowl_004.glb"
});
$69d6cbd59c5bb72c$export$26761271fdc2dd5e.set($69d6cbd59c5bb72c$export$a5ca04c0dcf1c065.BigSpoon001, {
    platformEnumIdentifier: $69d6cbd59c5bb72c$export$a5ca04c0dcf1c065.BigSpoon001,
    jsonIdentifier: "big_spoon_001",
    assetPath: "platforms/big_spoon_001.glb"
});
$69d6cbd59c5bb72c$export$26761271fdc2dd5e.set($69d6cbd59c5bb72c$export$a5ca04c0dcf1c065.BigSpoon002, {
    platformEnumIdentifier: $69d6cbd59c5bb72c$export$a5ca04c0dcf1c065.BigSpoon002,
    jsonIdentifier: "big_spoon_002",
    assetPath: "platforms/big_spoon_002.glb"
});
$69d6cbd59c5bb72c$export$26761271fdc2dd5e.set($69d6cbd59c5bb72c$export$a5ca04c0dcf1c065.BigSpoon003, {
    platformEnumIdentifier: $69d6cbd59c5bb72c$export$a5ca04c0dcf1c065.BigSpoon003,
    jsonIdentifier: "big_spoon_003",
    assetPath: "platforms/big_spoon_003.glb"
});
$69d6cbd59c5bb72c$export$26761271fdc2dd5e.set($69d6cbd59c5bb72c$export$a5ca04c0dcf1c065.BigSpoon004, {
    platformEnumIdentifier: $69d6cbd59c5bb72c$export$a5ca04c0dcf1c065.BigSpoon004,
    jsonIdentifier: "big_spoon_004",
    assetPath: "platforms/big_spoon_004.glb"
});
$69d6cbd59c5bb72c$export$26761271fdc2dd5e.set($69d6cbd59c5bb72c$export$a5ca04c0dcf1c065.BakingTray001, {
    platformEnumIdentifier: $69d6cbd59c5bb72c$export$a5ca04c0dcf1c065.BakingTray001,
    jsonIdentifier: "baking_tray_001",
    assetPath: "platforms/baking_tray_001.glb"
});
$69d6cbd59c5bb72c$export$26761271fdc2dd5e.set($69d6cbd59c5bb72c$export$a5ca04c0dcf1c065.BakingTray002, {
    platformEnumIdentifier: $69d6cbd59c5bb72c$export$a5ca04c0dcf1c065.BakingTray002,
    jsonIdentifier: "baking_tray_002",
    assetPath: "platforms/baking_tray_002.glb"
});
$69d6cbd59c5bb72c$export$26761271fdc2dd5e.set($69d6cbd59c5bb72c$export$a5ca04c0dcf1c065.BakingTray003, {
    platformEnumIdentifier: $69d6cbd59c5bb72c$export$a5ca04c0dcf1c065.BakingTray003,
    jsonIdentifier: "baking_tray_003",
    assetPath: "platforms/baking_tray_003.glb"
});
$69d6cbd59c5bb72c$export$26761271fdc2dd5e.set($69d6cbd59c5bb72c$export$a5ca04c0dcf1c065.BakingTray004, {
    platformEnumIdentifier: $69d6cbd59c5bb72c$export$a5ca04c0dcf1c065.BakingTray004,
    jsonIdentifier: "baking_tray_004",
    assetPath: "platforms/baking_tray_004.glb"
});
$69d6cbd59c5bb72c$export$26761271fdc2dd5e.set($69d6cbd59c5bb72c$export$a5ca04c0dcf1c065.BakingPan001, {
    platformEnumIdentifier: $69d6cbd59c5bb72c$export$a5ca04c0dcf1c065.BakingPan001,
    jsonIdentifier: "baking_pan_001",
    assetPath: "platforms/baking_pan_001.glb"
});
$69d6cbd59c5bb72c$export$26761271fdc2dd5e.set($69d6cbd59c5bb72c$export$a5ca04c0dcf1c065.BakingPan002, {
    platformEnumIdentifier: $69d6cbd59c5bb72c$export$a5ca04c0dcf1c065.BakingPan002,
    jsonIdentifier: "baking_pan_002",
    assetPath: "platforms/baking_pan_002.glb"
});
$69d6cbd59c5bb72c$export$26761271fdc2dd5e.set($69d6cbd59c5bb72c$export$a5ca04c0dcf1c065.BakingPan003, {
    platformEnumIdentifier: $69d6cbd59c5bb72c$export$a5ca04c0dcf1c065.BakingPan003,
    jsonIdentifier: "baking_pan_003",
    assetPath: "platforms/baking_pan_003.glb"
});
$69d6cbd59c5bb72c$export$26761271fdc2dd5e.set($69d6cbd59c5bb72c$export$a5ca04c0dcf1c065.BakingPan004, {
    platformEnumIdentifier: $69d6cbd59c5bb72c$export$a5ca04c0dcf1c065.BakingPan004,
    jsonIdentifier: "baking_pan_004",
    assetPath: "platforms/baking_pan_004.glb"
});
$69d6cbd59c5bb72c$export$26761271fdc2dd5e.set($69d6cbd59c5bb72c$export$a5ca04c0dcf1c065.Blueberry, {
    platformEnumIdentifier: $69d6cbd59c5bb72c$export$a5ca04c0dcf1c065.Blueberry,
    jsonIdentifier: "blueberry",
    assetPath: "platforms/blueberry_001.glb"
});
$69d6cbd59c5bb72c$export$26761271fdc2dd5e.set($69d6cbd59c5bb72c$export$a5ca04c0dcf1c065.Chocolate, {
    platformEnumIdentifier: $69d6cbd59c5bb72c$export$a5ca04c0dcf1c065.Chocolate,
    jsonIdentifier: "chocolate_001",
    assetPath: "platforms/chocolate_001.glb"
});
$69d6cbd59c5bb72c$export$26761271fdc2dd5e.set($69d6cbd59c5bb72c$export$a5ca04c0dcf1c065.Mango, {
    platformEnumIdentifier: $69d6cbd59c5bb72c$export$a5ca04c0dcf1c065.Mango,
    jsonIdentifier: "mango",
    assetPath: "platforms/mango_001.glb"
});
$69d6cbd59c5bb72c$export$26761271fdc2dd5e.set($69d6cbd59c5bb72c$export$a5ca04c0dcf1c065.Pistachio, {
    platformEnumIdentifier: $69d6cbd59c5bb72c$export$a5ca04c0dcf1c065.Pistachio,
    jsonIdentifier: "pistachio_001",
    assetPath: "platforms/pistachio_001.glb"
});
$69d6cbd59c5bb72c$export$26761271fdc2dd5e.set($69d6cbd59c5bb72c$export$a5ca04c0dcf1c065.Purple, {
    platformEnumIdentifier: $69d6cbd59c5bb72c$export$a5ca04c0dcf1c065.Purple,
    jsonIdentifier: "purple",
    assetPath: "platforms/purple_001.glb"
});
$69d6cbd59c5bb72c$export$26761271fdc2dd5e.set($69d6cbd59c5bb72c$export$a5ca04c0dcf1c065.Strawberry, {
    platformEnumIdentifier: $69d6cbd59c5bb72c$export$a5ca04c0dcf1c065.Strawberry,
    jsonIdentifier: "strawberry",
    assetPath: "platforms/strawberry_001.glb"
});
$69d6cbd59c5bb72c$export$26761271fdc2dd5e.set($69d6cbd59c5bb72c$export$a5ca04c0dcf1c065.Vanilla, {
    platformEnumIdentifier: $69d6cbd59c5bb72c$export$a5ca04c0dcf1c065.Vanilla,
    jsonIdentifier: "vanilla_001",
    assetPath: "platforms/vanilla_001.glb"
});
$69d6cbd59c5bb72c$export$26761271fdc2dd5e.set($69d6cbd59c5bb72c$export$a5ca04c0dcf1c065.DeathBlock001, {
    platformEnumIdentifier: $69d6cbd59c5bb72c$export$a5ca04c0dcf1c065.DeathBlock001,
    jsonIdentifier: "death_block_001",
    assetPath: "platforms/death_block_001.glb"
});
$69d6cbd59c5bb72c$export$26761271fdc2dd5e.set($69d6cbd59c5bb72c$export$a5ca04c0dcf1c065.MovingBlock001, {
    platformEnumIdentifier: $69d6cbd59c5bb72c$export$a5ca04c0dcf1c065.MovingBlock001,
    jsonIdentifier: "moving_block_001",
    assetPath: "platforms/moving_block_001.glb"
});
$69d6cbd59c5bb72c$export$26761271fdc2dd5e.set($69d6cbd59c5bb72c$export$a5ca04c0dcf1c065.SlipperyBlock001, {
    platformEnumIdentifier: $69d6cbd59c5bb72c$export$a5ca04c0dcf1c065.SlipperyBlock001,
    jsonIdentifier: "slippery_block_001",
    assetPath: "platforms/slippery_block_001.glb"
});
$69d6cbd59c5bb72c$export$26761271fdc2dd5e.set($69d6cbd59c5bb72c$export$a5ca04c0dcf1c065.SlowBlock001, {
    platformEnumIdentifier: $69d6cbd59c5bb72c$export$a5ca04c0dcf1c065.SlowBlock001,
    jsonIdentifier: "slow_block_001",
    assetPath: "platforms/slow_block_001.glb"
});
$69d6cbd59c5bb72c$export$26761271fdc2dd5e.set($69d6cbd59c5bb72c$export$a5ca04c0dcf1c065.StartingLine, {
    platformEnumIdentifier: $69d6cbd59c5bb72c$export$a5ca04c0dcf1c065.StartingLine,
    jsonIdentifier: "start_line",
    assetPath: "platforms/start_line.glb"
});
$69d6cbd59c5bb72c$export$26761271fdc2dd5e.set($69d6cbd59c5bb72c$export$a5ca04c0dcf1c065.InvisibleSquare001, {
    platformEnumIdentifier: $69d6cbd59c5bb72c$export$a5ca04c0dcf1c065.InvisibleSquare001,
    jsonIdentifier: "invisible_square_001",
    assetPath: "platforms/invisible_square_001.glb"
});
$69d6cbd59c5bb72c$export$26761271fdc2dd5e.set($69d6cbd59c5bb72c$export$a5ca04c0dcf1c065.Fridge_001, {
    platformEnumIdentifier: $69d6cbd59c5bb72c$export$a5ca04c0dcf1c065.Fridge_001,
    jsonIdentifier: "fridge_001",
    assetPath: "platforms/fridge_001.glb"
});
$69d6cbd59c5bb72c$export$26761271fdc2dd5e.set($69d6cbd59c5bb72c$export$a5ca04c0dcf1c065.Gorilla, {
    platformEnumIdentifier: $69d6cbd59c5bb72c$export$a5ca04c0dcf1c065.Gorilla,
    jsonIdentifier: "gorilla",
    assetPath: "platforms/gorilla.glb"
});



var $5LCsG = parcelRequire("5LCsG");
const $dc7ce37c2dd6355b$var$GRID_CELL_SIZE_X = 50;
const $dc7ce37c2dd6355b$var$GRID_CELL_SIZE_Y = 50;
const $dc7ce37c2dd6355b$var$GRID_CELL_SIZE_Z = 50;
class $dc7ce37c2dd6355b$export$52ef19685b59c674 extends (0, $fc7b18e354612676$export$5d53140180d567a1) {
    Initialize() {
        for (const platform of (0, (/*@__PURE__*/$parcel$interopDefault($cae8463151c972d6$exports))).platforms){
            const { position: parentPlatformPosition, assetIdentifier: assetIdentifier, uniqueIdentifier: uniqueIdentifier, behaviour: behaviour } = platform;
            let { scale: scale, rotation: rotation } = platform;
            if (scale === undefined) scale = [
                1,
                1,
                1
            ];
            if (rotation === undefined) rotation = [
                0,
                0,
                0
            ];
            // console.log(`Handling construction of platform #${uniqueIdentifier}`);
            if (assetIdentifier === undefined) continue;
            // console.log("Attempting to retrieve platform metadata for identifier:", assetIdentifier);
            const platformMetadata = (0, $69d6cbd59c5bb72c$export$414b10a35cf658a8)(assetIdentifier);
            if (!platformMetadata) throw new Error("Could not find platform metadata for identifier: " + assetIdentifier);
            if (!platformMetadata && assetIdentifier !== "spawn") continue;
            else {
                // @ts-ignore
                const possibleColliders = (0, (/*@__PURE__*/$parcel$interopDefault($555b585e379e29ea$exports)))[platformMetadata.jsonIdentifier];
                // console.log(possibleColliders);
                if (possibleColliders === undefined || possibleColliders.length === 0) continue;
                else for(let i = 0; i < possibleColliders.length; i++){
                    const collider = possibleColliders[i];
                    const { center: position, size: size, isTrigger: isTrigger } = collider;
                    const { x: width, y: height, z: depth } = size;
                    const positionOfThisCollider = new (0, $9014d97cd777be10$export$64b5c384219d3699)(parentPlatformPosition[0] + position.x * scale[0], parentPlatformPosition[1] + position.y * scale[1], parentPlatformPosition[2] + position.z * scale[2]);
                    if (isTrigger) {
                        let triggerType = (0, $07756da3fdd79b5d$export$aaab732ed133eca).None;
                        if (assetIdentifier.includes("check_point")) triggerType = (0, $07756da3fdd79b5d$export$aaab732ed133eca).Checkpoint;
                        else if (assetIdentifier === "finish_line_001") triggerType = (0, $07756da3fdd79b5d$export$aaab732ed133eca).FinishLine;
                        else if (assetIdentifier === "start_line") triggerType = (0, $07756da3fdd79b5d$export$aaab732ed133eca).StartingLine;
                        else if (assetIdentifier === "vanilla_001") triggerType = (0, $07756da3fdd79b5d$export$aaab732ed133eca).UI_PopUp_NameAndCountrySelect;
                        else if (assetIdentifier === "chocolate_001") triggerType = (0, $07756da3fdd79b5d$export$aaab732ed133eca).UI_PopUp_TrailSelect;
                        else if (assetIdentifier === "death_block_001") triggerType = (0, $07756da3fdd79b5d$export$aaab732ed133eca).DeathBlock;
                        else if (assetIdentifier === "pan_001" || assetIdentifier === "pan_003" || assetIdentifier === "pan_004") triggerType = (0, $07756da3fdd79b5d$export$aaab732ed133eca).Bounce;
                        else if (assetIdentifier === "moving_block_001" || assetIdentifier === "slippery_block_001") triggerType = (0, $07756da3fdd79b5d$export$aaab732ed133eca).Speed;
                        else if (assetIdentifier === "fridge_001") triggerType = (0, $07756da3fdd79b5d$export$aaab732ed133eca).UI_PopUp_CharacterSelect;
                        else if (assetIdentifier === "pistachio_001") triggerType = (0, $07756da3fdd79b5d$export$aaab732ed133eca).UI_PopUp_EndRun;
                        else throw new Error(`Could not find trigger type for asset identifier: ${assetIdentifier}`);
                        let behaviourValue = 1;
                        if ((triggerType === (0, $07756da3fdd79b5d$export$aaab732ed133eca).Bounce || triggerType === (0, $07756da3fdd79b5d$export$aaab732ed133eca).Speed) && behaviour !== undefined) {
                            if (behaviour[1] !== undefined) behaviourValue = parseFloat(behaviour[1]);
                        }
                        this.AddTrigger({
                            AssociatedPlatform: uniqueIdentifier,
                            TriggerType: triggerType,
                            BehaviourValue: behaviourValue,
                            Scale: new (0, $9014d97cd777be10$export$64b5c384219d3699)(scale[0], scale[1], scale[2]),
                            Position: positionOfThisCollider,
                            Collider: {
                                Height: height * scale[1],
                                Width: width * scale[0],
                                Depth: depth * scale[2],
                                Position: positionOfThisCollider
                            }
                        });
                    } else this.AddCollidablePlatform({
                        Scale: new (0, $9014d97cd777be10$export$64b5c384219d3699)(scale[0], scale[1], scale[2]),
                        Position: positionOfThisCollider,
                        Collider: {
                            Height: height * scale[1],
                            Width: width * scale[0],
                            Depth: depth * scale[2],
                            Position: positionOfThisCollider
                        }
                    });
                    // Dynamically calculate min and max bounds of the world, to be divided up into grid cells
                    if (positionOfThisCollider.x < this.worldMin[0]) this.worldMin[0] = positionOfThisCollider.x;
                    if (positionOfThisCollider.y < this.worldMin[1]) this.worldMin[1] = positionOfThisCollider.y;
                    if (positionOfThisCollider.z < this.worldMin[2]) this.worldMin[2] = positionOfThisCollider.z;
                    if (positionOfThisCollider.x > this.worldMax[0]) this.worldMax[0] = positionOfThisCollider.x;
                    if (positionOfThisCollider.y > this.worldMax[1]) this.worldMax[1] = positionOfThisCollider.y;
                    if (positionOfThisCollider.z > this.worldMax[2]) this.worldMax[2] = positionOfThisCollider.z;
                }
            }
        }
        // Determine how many cells are contained in each axis of the grid, this will be necessary for finding neighbor cells
        this.collisionGridLength[0] = (0, $5LCsG.ceil)((this.worldMax[0] - this.worldMin[0]) / $dc7ce37c2dd6355b$var$GRID_CELL_SIZE_X);
        this.collisionGridLength[1] = (0, $5LCsG.ceil)((this.worldMax[1] - this.worldMin[1]) / $dc7ce37c2dd6355b$var$GRID_CELL_SIZE_Y);
        this.collisionGridLength[2] = (0, $5LCsG.ceil)((this.worldMax[2] - this.worldMin[2]) / $dc7ce37c2dd6355b$var$GRID_CELL_SIZE_Z);
        // Add platforms to grid
        this.collidablePlatforms.forEach((platform)=>{
            const platformCenter = platform.Collider.Position;
            const gridIndex = this._positionToCollisionGridIndex(platformCenter.x, platformCenter.y, platformCenter.z);
            if (!this.collisionGridCells.has(gridIndex)) this.collisionGridCells.set(gridIndex, new $dc7ce37c2dd6355b$var$CollisionGridCell());
            this.collisionGridCells.get(gridIndex)?.staticPlatforms.add(platform);
        });
        // Likewise, trigger volumes
        this.triggers.forEach((trigger)=>{
            const triggerCenter = trigger.Collider.Position;
            const gridIndex = this._positionToCollisionGridIndex(triggerCenter.x, triggerCenter.y, triggerCenter.z);
            if (!this.collisionGridCells.has(gridIndex)) this.collisionGridCells.set(gridIndex, new $dc7ce37c2dd6355b$var$CollisionGridCell());
            this.collisionGridCells.get(gridIndex)?.triggers.add(trigger);
        });
    }
    getSystemName() {
        return "Collision";
    }
    AddCollidablePlatform(entity) {
        this.collidablePlatforms.add(entity);
    }
    AddTrigger(entity) {
        this.triggers.add(entity);
    }
    CheckForCollisions(player, deltaTimeS) {
        if (this.collisionGridDirty) // Clear out moving platforms, then re-add them in their new position
        // TODO: Dave - Uncomment this when moving platforms are added (or even just do it better because this is a wee bit jank)
        // this.collisionGridCells.forEach((cell) => {
        //     cell.dynamicPlatforms.clear();
        // });
        this.collisionGridDirty = false;
        const playerCellIndex = this._positionToCollisionGridIndex(player.x, player.y, player.z);
        player.IsGrounded = false;
        player.CollidingWithUIPopTrigger = false;
        // Check neighboring cells, and run collision checks against their contents
        for(let z = -1; z <= 1; ++z){
            for(let y = -1; y <= 1; ++y)for(let x = -1; x <= 1; ++x){
                const neighborIndex = this._indexFromOffset(playerCellIndex, x, y, z);
                const cell = this.collisionGridCells.get(neighborIndex);
                cell?.staticPlatforms.forEach((platform)=>{
                    this.collisionsCheckedThisFrame++;
                    // Calculate the half sizes of the colliders
                    const platformHalfWidth = platform.Collider.Width / 2;
                    const platformHalfHeight = platform.Collider.Height / 2;
                    const platformHalfDepth = platform.Collider.Depth / 2;
                    const playerHalfWidth = player.Collider.Width / 2;
                    const playerHalfHeight = player.Collider.Height / 2;
                    const playerHalfDepth = player.Collider.Depth / 2;
                    // Calculate the centers of the colliders
                    const platformCenter = platform.Collider.Position;
                    const playerCenter = player.Collider.Position;
                    // Calculate the distances between centers along each axis
                    const dx = Math.abs(platformCenter.x - playerCenter.x);
                    const dy = Math.abs(platformCenter.y - playerCenter.y);
                    const dz = Math.abs(platformCenter.z - playerCenter.z);
                    // Calculate the overlap along each axis
                    const overlapX = platformHalfWidth + playerHalfWidth - dx;
                    const overlapY = platformHalfHeight + playerHalfHeight - dy;
                    const overlapZ = platformHalfDepth + playerHalfDepth - dz;
                    const collided = overlapX > 0 && overlapY > 0 && overlapZ > 0;
                    // Check for a collision along all three axes
                    if (collided) {
                        // Resolve the collision based on the smallest overlap
                        if (overlapX <= overlapY && overlapX <= overlapZ) {
                            // Resolve along the X-axis
                            if (playerCenter.x < platformCenter.x) // Move the player to the left
                            player.Collider.Position.x -= overlapX;
                            else // Move the player to the right
                            player.Collider.Position.x += overlapX;
                        } else if (overlapY <= overlapX && overlapY <= overlapZ) {
                            // Resolve along the Y-axis
                            if (playerCenter.y < platformCenter.y) // Move the player upwards
                            player.Collider.Position.y -= overlapY;
                            else // Move the player downwards
                            player.Collider.Position.y += overlapY;
                        } else // Resolve along the Z-axis
                        if (playerCenter.z < platformCenter.z) // Move the player forwards
                        player.Collider.Position.z -= overlapZ;
                        else // Move the player backwards
                        player.Collider.Position.z += overlapZ;
                        player.IsGrounded = true;
                    }
                });
                cell?.triggers.forEach((trigger)=>{
                    this.collisionsCheckedThisFrame++;
                    // Calculate the half sizes of the colliders
                    const platformHalfWidth = trigger.Collider.Width / 2;
                    const platformHalfHeight = trigger.Collider.Height / 2;
                    const platformHalfDepth = trigger.Collider.Depth / 2;
                    const playerHalfWidth = player.Collider.Width / 2;
                    const playerHalfHeight = player.Collider.Height / 2;
                    const playerHalfDepth = player.Collider.Depth / 2;
                    // Calculate the centers of the colliders
                    const platformCenter = trigger.Collider.Position;
                    const playerCenter = player.Collider.Position;
                    // Calculate the distances between centers along each axis
                    const dx = Math.abs(platformCenter.x - playerCenter.x);
                    const dy = Math.abs(platformCenter.y - playerCenter.y);
                    const dz = Math.abs(platformCenter.z - playerCenter.z);
                    // Calculate the overlap along each axis
                    const overlapX = platformHalfWidth + playerHalfWidth - dx;
                    const overlapY = platformHalfHeight + playerHalfHeight - dy;
                    const overlapZ = platformHalfDepth + playerHalfDepth - dz;
                    const collided = overlapX > 0 && overlapY > 0 && overlapZ > 0;
                    // Check for a collision along all three axes
                    if (collided) player.CollidedWithTrigger(trigger, deltaTimeS);
                });
            }
        }
        if (player.CollidingWithUIPopTrigger === false) player.ResetUIPopTriggerAcc();
    }
    CheckRayCollisions(rayOrigin, rayDirection) {
        const rayCellIndex = this._positionToCollisionGridIndex(rayOrigin.x, rayOrigin.y, rayOrigin.z);
        for(let z = -1; z <= 1; ++z){
            for(let y = -1; y <= 1; ++y)for(let x = -1; x <= 1; ++x){
                const neighborIndex = this._indexFromOffset(rayCellIndex, x, y, z);
                const cell = this.collisionGridCells.get(neighborIndex);
                if (cell) {
                    for (const platform of cell.staticPlatforms){
                        const result = this.RayToAABBCollisionTest(rayOrigin, rayDirection, platform.Collider);
                        if (result.hit) return result;
                    }
                    for (const trigger of cell.triggers)if (trigger.TriggerType === (0, $07756da3fdd79b5d$export$aaab732ed133eca).DeathBlock) {
                        const result = this.RayToAABBCollisionTest(rayOrigin, rayDirection, trigger.Collider);
                        if (result.hit) return result;
                    }
                }
            }
        }
        return {
            hit: false,
            hitPoint: undefined
        };
    }
    /* 
    (an adaptation of)
    Fast Ray-Box Intersection
    by Andrew Woo
    from "Graphics Gems", Academic Press, 1990
    */ RayToAABBCollisionTest(rayOrigin, rayDirection, aabb) {
        const numDimensions = 3;
        const right = 0;
        const left = 1;
        const middle = 2;
        const minB = [
            aabb.Position.x - aabb.Width / 2,
            aabb.Position.y - aabb.Height / 2,
            aabb.Position.z - aabb.Depth / 2
        ];
        const maxB = [
            aabb.Position.x + aabb.Width / 2,
            aabb.Position.y + aabb.Height / 2,
            aabb.Position.z + aabb.Depth / 2
        ];
        const origin = [
            rayOrigin.x,
            rayOrigin.y,
            rayOrigin.z
        ];
        const dir = [
            rayDirection.x,
            rayDirection.y,
            rayDirection.z
        ];
        const coord = [];
        let inside = true;
        const quadrant = [];
        const maxT = [];
        const candidatePlane = [];
        /* Find candidate planes; this loop can be avoided if
   	    rays cast all from the eye(assume perpsective view) */ for(let i = 0; i < numDimensions; ++i){
            if (origin[i] < minB[i]) {
                quadrant[i] = left;
                candidatePlane[i] = minB[i];
                inside = false;
            } else if (origin[i] > maxB[i]) {
                quadrant[i] = right;
                candidatePlane[i] = maxB[i];
                inside = false;
            } else quadrant[i] = middle;
        }
        /* Ray origin inside bounding box */ if (inside) return {
            hit: true,
            hitPoint: rayOrigin
        };
        /* Calculate T distances to candidate planes */ for(let i = 0; i < numDimensions; ++i)if (quadrant[i] !== middle && dir[i] !== 0) maxT[i] = (candidatePlane[i] - origin[i]) / dir[i];
        else maxT[i] = -1;
        /* Get largest of the maxT's for final choice of intersection */ let whichPlane = 0;
        for(let i = 1; i < numDimensions; ++i)if (maxT[whichPlane] < maxT[i]) whichPlane = i;
        /* Check final candidate actually inside box */ if (maxT[whichPlane] < 0) return {
            hit: false,
            hitPoint: undefined
        };
        for(let i = 0; i < numDimensions; ++i)if (whichPlane !== i) {
            coord[i] = origin[i] + maxT[whichPlane] * dir[i];
            if (coord[i] < minB[i] || coord[i] > maxB[i]) return {
                hit: false,
                hitPoint: undefined
            };
        } else coord[i] = candidatePlane[i];
        return {
            hit: true,
            hitPoint: new (0, $9014d97cd777be10$export$64b5c384219d3699)(coord[0], coord[1], coord[2])
        };
    }
    Update(__deltaTimeS, __deltaTimeMS, __currentTickStartTimestampMs) {
        this.collisionGridDirty = true; // Just assume something moved each frame
    }
    Cleanup() {}
    _positionToCollisionGridIndex(x, y, z) {
        const gridPosX = (0, $5LCsG.floor)(x / $dc7ce37c2dd6355b$var$GRID_CELL_SIZE_X);
        const gridPosY = (0, $5LCsG.floor)(y / $dc7ce37c2dd6355b$var$GRID_CELL_SIZE_Y);
        const gridPosZ = (0, $5LCsG.floor)(z / $dc7ce37c2dd6355b$var$GRID_CELL_SIZE_Z);
        return gridPosX + gridPosY * this.collisionGridLength[0] + gridPosZ * this.collisionGridLength[0] * this.collisionGridLength[1];
    }
    _indexFromOffset(baseIndex, xOffset, yOffset, zOffset) {
        return baseIndex + xOffset + yOffset * this.collisionGridLength[0] + zOffset * this.collisionGridLength[0] * this.collisionGridLength[1];
    }
    constructor(){
        super();
        this.collisionsCheckedThisFrame = 0;
        this.collidablePlatforms = new Set();
        this.triggers = new Set();
        this.collisionGridCells = new Map();
        this.collisionGridLength = [
            0,
            0,
            0
        ];
        this.collisionGridDirty = true;
        this.worldMin = [
            Number.POSITIVE_INFINITY,
            Number.POSITIVE_INFINITY,
            Number.POSITIVE_INFINITY
        ];
        this.worldMax = [
            Number.NEGATIVE_INFINITY,
            Number.NEGATIVE_INFINITY,
            Number.NEGATIVE_INFINITY
        ];
    }
}
class $dc7ce37c2dd6355b$var$CollisionGridCell {
    constructor(){
        this.triggers = new Set();
        this.staticPlatforms = new Set();
        this.dynamicPlatforms = new Set();
    }
}







class $7b6b4fbe9e45ec43$export$fce7c3984380900f extends (0, $dc7ce37c2dd6355b$export$52ef19685b59c674) {
    getSystemName() {
        return "CCollision";
    }
    Initialize() {
        for (const platform of (0, (/*@__PURE__*/$parcel$interopDefault($cae8463151c972d6$exports))).platforms){
            const { position: parentPlatformPosition, assetIdentifier: assetIdentifier, uniqueIdentifier: uniqueIdentifier } = platform;
            if (uniqueIdentifier.toLowerCase() === "spawn") continue;
            let { scale: scale, rotation: rotation } = platform;
            if (scale === undefined) scale = [
                1,
                1,
                1
            ];
            if (rotation === undefined) rotation = [
                0,
                0,
                0
            ];
            const platformMetadata = (0, $69d6cbd59c5bb72c$export$414b10a35cf658a8)(assetIdentifier);
            if (!platformMetadata) {
                console.error("Could not find platform metadata for identifier:", assetIdentifier, platform);
                console.error("skipping this platform creation! level might be broken!");
                continue;
            } else {
                // @ts-ignore
                const possibleColliders = (0, (/*@__PURE__*/$parcel$interopDefault($555b585e379e29ea$exports)))[platformMetadata.jsonIdentifier];
                if (possibleColliders === undefined || possibleColliders.length === 0) continue;
                else {
                    if ((0, $b80b6e4c153785d9$export$29cd7b75162a9425).Collision.DRAW_COLLISION_BOXES) for(let i = 0; i < possibleColliders.length; i++){
                        const collider = possibleColliders[i];
                        const { center: position, size: size } = collider;
                        const { x: width, y: height, z: depth } = size;
                        const positionOfThisCollider = new (0, $9014d97cd777be10$export$64b5c384219d3699)(parentPlatformPosition[0] + position.x, parentPlatformPosition[1] + position.y, parentPlatformPosition[2] + position.z);
                        this.RenderDebugCollider({
                            Scale: new (0, $9014d97cd777be10$export$64b5c384219d3699)(scale[0], scale[1], scale[2]),
                            Position: positionOfThisCollider,
                            Collider: {
                                Height: height * scale[1],
                                Width: width * scale[0],
                                Depth: depth * scale[2],
                                Position: positionOfThisCollider
                            }
                        });
                    }
                }
            }
        }
        Game.EmitEvent("LoadEvent", {
            eventName: "CollisionReady"
        });
        super.Initialize();
    }
    RenderDebugCollider(collidable) {
        const geometry = new (0, $9014d97cd777be10$export$33e43285f7406bd5)(collidable.Collider.Width, collidable.Collider.Height, collidable.Collider.Depth);
        const material = new (0, $9014d97cd777be10$export$f2980790215acccd)({
            color: 0xff00ff,
            wireframe: true
        });
        const renderedEntity = new (0, $9014d97cd777be10$export$e176487c05830cc5)(geometry, material);
        renderedEntity.position.set(collidable.Position.x, collidable.Position.y, collidable.Position.z);
        this.debugMeshes.push(renderedEntity);
        Game.Renderer.AddModelToScene(renderedEntity);
    }
    constructor(){
        super();
        this.debugMeshes = [];
    }
}





class $799be12ad5c5dd24$export$3b4612d6147edef2 extends (0, $fc7b18e354612676$export$5d53140180d567a1) {
    getSystemName() {
        return "Debug";
    }
    Initialize() {
        document.addEventListener("keydown", (event)=>{});
    }
    Update(__deltaTimeS, __deltaTimeMS, __currentTime) {}
    Cleanup() {}
    constructor(){
        super();
    }
}



var $727f1bb743400c4d$exports = {};
/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ /** Used as the `TypeError` message for "Functions" methods. */ var $727f1bb743400c4d$var$FUNC_ERROR_TEXT = "Expected a function";
/** Used as references for various `Number` constants. */ var $727f1bb743400c4d$var$NAN = 0 / 0;
/** `Object#toString` result references. */ var $727f1bb743400c4d$var$symbolTag = "[object Symbol]";
/** Used to match leading and trailing whitespace. */ var $727f1bb743400c4d$var$reTrim = /^\s+|\s+$/g;
/** Used to detect bad signed hexadecimal string values. */ var $727f1bb743400c4d$var$reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
/** Used to detect binary string values. */ var $727f1bb743400c4d$var$reIsBinary = /^0b[01]+$/i;
/** Used to detect octal string values. */ var $727f1bb743400c4d$var$reIsOctal = /^0o[0-7]+$/i;
/** Built-in method references without a dependency on `root`. */ var $727f1bb743400c4d$var$freeParseInt = parseInt;
/** Detect free variable `global` from Node.js. */ var $727f1bb743400c4d$var$freeGlobal = typeof $parcel$global == "object" && $parcel$global && $parcel$global.Object === Object && $parcel$global;
/** Detect free variable `self`. */ var $727f1bb743400c4d$var$freeSelf = typeof self == "object" && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $727f1bb743400c4d$var$root = $727f1bb743400c4d$var$freeGlobal || $727f1bb743400c4d$var$freeSelf || Function("return this")();
/** Used for built-in method references. */ var $727f1bb743400c4d$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $727f1bb743400c4d$var$objectToString = $727f1bb743400c4d$var$objectProto.toString;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $727f1bb743400c4d$var$nativeMax = Math.max, $727f1bb743400c4d$var$nativeMin = Math.min;
/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */ var $727f1bb743400c4d$var$now = function() {
    return $727f1bb743400c4d$var$root.Date.now();
};
/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */ function $727f1bb743400c4d$var$debounce(func, wait, options) {
    var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
    if (typeof func != "function") throw new TypeError($727f1bb743400c4d$var$FUNC_ERROR_TEXT);
    wait = $727f1bb743400c4d$var$toNumber(wait) || 0;
    if ($727f1bb743400c4d$var$isObject(options)) {
        leading = !!options.leading;
        maxing = "maxWait" in options;
        maxWait = maxing ? $727f1bb743400c4d$var$nativeMax($727f1bb743400c4d$var$toNumber(options.maxWait) || 0, wait) : maxWait;
        trailing = "trailing" in options ? !!options.trailing : trailing;
    }
    function invokeFunc(time) {
        var args = lastArgs, thisArg = lastThis;
        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
    }
    function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
    }
    function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, result = wait - timeSinceLastCall;
        return maxing ? $727f1bb743400c4d$var$nativeMin(result, maxWait - timeSinceLastInvoke) : result;
    }
    function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
    }
    function timerExpired() {
        var time = $727f1bb743400c4d$var$now();
        if (shouldInvoke(time)) return trailingEdge(time);
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
    }
    function trailingEdge(time) {
        timerId = undefined;
        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) return invokeFunc(time);
        lastArgs = lastThis = undefined;
        return result;
    }
    function cancel() {
        if (timerId !== undefined) clearTimeout(timerId);
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
    }
    function flush() {
        return timerId === undefined ? result : trailingEdge($727f1bb743400c4d$var$now());
    }
    function debounced() {
        var time = $727f1bb743400c4d$var$now(), isInvoking = shouldInvoke(time);
        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;
        if (isInvoking) {
            if (timerId === undefined) return leadingEdge(lastCallTime);
            if (maxing) {
                // Handle invocations in a tight loop.
                timerId = setTimeout(timerExpired, wait);
                return invokeFunc(lastCallTime);
            }
        }
        if (timerId === undefined) timerId = setTimeout(timerExpired, wait);
        return result;
    }
    debounced.cancel = cancel;
    debounced.flush = flush;
    return debounced;
}
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $727f1bb743400c4d$var$isObject(value) {
    var type = typeof value;
    return !!value && (type == "object" || type == "function");
}
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $727f1bb743400c4d$var$isObjectLike(value) {
    return !!value && typeof value == "object";
}
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $727f1bb743400c4d$var$isSymbol(value) {
    return typeof value == "symbol" || $727f1bb743400c4d$var$isObjectLike(value) && $727f1bb743400c4d$var$objectToString.call(value) == $727f1bb743400c4d$var$symbolTag;
}
/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */ function $727f1bb743400c4d$var$toNumber(value) {
    if (typeof value == "number") return value;
    if ($727f1bb743400c4d$var$isSymbol(value)) return $727f1bb743400c4d$var$NAN;
    if ($727f1bb743400c4d$var$isObject(value)) {
        var other = typeof value.valueOf == "function" ? value.valueOf() : value;
        value = $727f1bb743400c4d$var$isObject(other) ? other + "" : other;
    }
    if (typeof value != "string") return value === 0 ? value : +value;
    value = value.replace($727f1bb743400c4d$var$reTrim, "");
    var isBinary = $727f1bb743400c4d$var$reIsBinary.test(value);
    return isBinary || $727f1bb743400c4d$var$reIsOctal.test(value) ? $727f1bb743400c4d$var$freeParseInt(value.slice(2), isBinary ? 2 : 8) : $727f1bb743400c4d$var$reIsBadHex.test(value) ? $727f1bb743400c4d$var$NAN : +value;
}
$727f1bb743400c4d$exports = $727f1bb743400c4d$var$debounce;


class $2b94cd4e1856547f$export$354e0baf6fb12b18 extends (0, $fc7b18e354612676$export$5d53140180d567a1) {
    getSystemName() {
        return "Resizer";
    }
    Initialize() {
        this._forceCanvasToMatchContainerSize();
        window.onresize = (0, (/*@__PURE__*/$parcel$interopDefault($727f1bb743400c4d$exports)))(this._onGameWindowResized.bind(this), 100);
    }
    _forceCanvasToMatchContainerSize() {
        this.gameCanvasRef.style.width = this._getGameContainerWidth() + "px";
        this.gameCanvasRef.style.height = this._getGameContainerHeight() + "px";
    }
    _getGameContainerWidth() {
        return parseInt(window.getComputedStyle(this.gameContainerRef).width, 10);
    }
    _getGameContainerHeight() {
        return parseInt(window.getComputedStyle(this.gameContainerRef).height, 10);
    }
    _onGameWindowResized() {
        this._forceCanvasToMatchContainerSize();
        if (window.innerHeight !== this.lastKnownHeight || window.innerWidth !== this.lastKnownWidth) {
            this.lastKnownHeight = window.innerHeight;
            this.lastKnownWidth = window.innerWidth;
            Game.EmitEvent("Resizer::GameWindowResizeComplete", {
                newWidth: this.lastKnownWidth,
                newHeight: this.lastKnownHeight
            });
        }
    }
    Update(__deltaTimeS, __deltaTimeMS, __currentTime) {}
    Cleanup() {
        this.LogInfo("Cleaning up...");
    }
    constructor(){
        super();
        const gameContainer = document.getElementById("game-container");
        this.gameContainerRef = gameContainer;
        this.gameCanvasRef = document.getElementById("game-canvas");
    }
}



var $ba2b935f1363d9c5$export$c9d39ca3bcd93abb;
var $ba2b935f1363d9c5$export$b791fe48eec8032a;
/*!
 *  howler.js v2.2.3
 *  howlerjs.com
 *
 *  (c) 2013-2020, James Simpson of GoldFire Studios
 *  goldfirestudios.com
 *
 *  MIT License
 */ (function() {
    "use strict";
    /** Global Methods **/ /***************************************************************************/ /**
   * Create the global controller. All contained methods and properties apply
   * to all sounds that are currently playing or will be in the future.
   */ var HowlerGlobal1 = function() {
        this.init();
    };
    HowlerGlobal1.prototype = {
        /**
     * Initialize the global Howler object.
     * @return {Howler}
     */ init: function() {
            var self = this || Howler1;
            // Create a global ID counter.
            self._counter = 1000;
            // Pool of unlocked HTML5 Audio objects.
            self._html5AudioPool = [];
            self.html5PoolSize = 10;
            // Internal properties.
            self._codecs = {};
            self._howls = [];
            self._muted = false;
            self._volume = 1;
            self._canPlayEvent = "canplaythrough";
            self._navigator = typeof window !== "undefined" && window.navigator ? window.navigator : null;
            // Public properties.
            self.masterGain = null;
            self.noAudio = false;
            self.usingWebAudio = true;
            self.autoSuspend = true;
            self.ctx = null;
            // Set to false to disable the auto audio unlocker.
            self.autoUnlock = true;
            // Setup the various state values for global tracking.
            self._setup();
            return self;
        },
        /**
     * Get/set the global volume for all sounds.
     * @param  {Float} vol Volume from 0.0 to 1.0.
     * @return {Howler/Float}     Returns self or current volume.
     */ volume: function(vol) {
            var self = this || Howler1;
            vol = parseFloat(vol);
            // If we don't have an AudioContext created yet, run the setup.
            if (!self.ctx) setupAudioContext();
            if (typeof vol !== "undefined" && vol >= 0 && vol <= 1) {
                self._volume = vol;
                // Don't update any of the nodes if we are muted.
                if (self._muted) return self;
                // When using Web Audio, we just need to adjust the master gain.
                if (self.usingWebAudio) self.masterGain.gain.setValueAtTime(vol, Howler1.ctx.currentTime);
                // Loop through and change volume for all HTML5 audio nodes.
                for(var i = 0; i < self._howls.length; i++)if (!self._howls[i]._webAudio) {
                    // Get all of the sounds in this Howl group.
                    var ids = self._howls[i]._getSoundIds();
                    // Loop through all sounds and change the volumes.
                    for(var j = 0; j < ids.length; j++){
                        var sound = self._howls[i]._soundById(ids[j]);
                        if (sound && sound._node) sound._node.volume = sound._volume * vol;
                    }
                }
                return self;
            }
            return self._volume;
        },
        /**
     * Handle muting and unmuting globally.
     * @param  {Boolean} muted Is muted or not.
     */ mute: function(muted) {
            var self = this || Howler1;
            // If we don't have an AudioContext created yet, run the setup.
            if (!self.ctx) setupAudioContext();
            self._muted = muted;
            // With Web Audio, we just need to mute the master gain.
            if (self.usingWebAudio) self.masterGain.gain.setValueAtTime(muted ? 0 : self._volume, Howler1.ctx.currentTime);
            // Loop through and mute all HTML5 Audio nodes.
            for(var i = 0; i < self._howls.length; i++)if (!self._howls[i]._webAudio) {
                // Get all of the sounds in this Howl group.
                var ids = self._howls[i]._getSoundIds();
                // Loop through all sounds and mark the audio node as muted.
                for(var j = 0; j < ids.length; j++){
                    var sound = self._howls[i]._soundById(ids[j]);
                    if (sound && sound._node) sound._node.muted = muted ? true : sound._muted;
                }
            }
            return self;
        },
        /**
     * Handle stopping all sounds globally.
     */ stop: function() {
            var self = this || Howler1;
            // Loop through all Howls and stop them.
            for(var i = 0; i < self._howls.length; i++)self._howls[i].stop();
            return self;
        },
        /**
     * Unload and destroy all currently loaded Howl objects.
     * @return {Howler}
     */ unload: function() {
            var self = this || Howler1;
            for(var i = self._howls.length - 1; i >= 0; i--)self._howls[i].unload();
            // Create a new AudioContext to make sure it is fully reset.
            if (self.usingWebAudio && self.ctx && typeof self.ctx.close !== "undefined") {
                self.ctx.close();
                self.ctx = null;
                setupAudioContext();
            }
            return self;
        },
        /**
     * Check for codec support of specific extension.
     * @param  {String} ext Audio file extention.
     * @return {Boolean}
     */ codecs: function(ext) {
            return (this || Howler1)._codecs[ext.replace(/^x-/, "")];
        },
        /**
     * Setup various state values for global tracking.
     * @return {Howler}
     */ _setup: function() {
            var self = this || Howler1;
            // Keeps track of the suspend/resume state of the AudioContext.
            self.state = self.ctx ? self.ctx.state || "suspended" : "suspended";
            // Automatically begin the 30-second suspend process
            self._autoSuspend();
            // Check if audio is available.
            if (!self.usingWebAudio) {
                // No audio is available on this system if noAudio is set to true.
                if (typeof Audio !== "undefined") try {
                    var test = new Audio();
                    // Check if the canplaythrough event is available.
                    if (typeof test.oncanplaythrough === "undefined") self._canPlayEvent = "canplay";
                } catch (e) {
                    self.noAudio = true;
                }
                else self.noAudio = true;
            }
            // Test to make sure audio isn't disabled in Internet Explorer.
            try {
                var test = new Audio();
                if (test.muted) self.noAudio = true;
            } catch (e) {}
            // Check for supported codecs.
            if (!self.noAudio) self._setupCodecs();
            return self;
        },
        /**
     * Check for browser support for various codecs and cache the results.
     * @return {Howler}
     */ _setupCodecs: function() {
            var self = this || Howler1;
            var audioTest = null;
            // Must wrap in a try/catch because IE11 in server mode throws an error.
            try {
                audioTest = typeof Audio !== "undefined" ? new Audio() : null;
            } catch (err) {
                return self;
            }
            if (!audioTest || typeof audioTest.canPlayType !== "function") return self;
            var mpegTest = audioTest.canPlayType("audio/mpeg;").replace(/^no$/, "");
            // Opera version <33 has mixed MP3 support, so we need to check for and block it.
            var ua = self._navigator ? self._navigator.userAgent : "";
            var checkOpera = ua.match(/OPR\/([0-6].)/g);
            var isOldOpera = checkOpera && parseInt(checkOpera[0].split("/")[1], 10) < 33;
            var checkSafari = ua.indexOf("Safari") !== -1 && ua.indexOf("Chrome") === -1;
            var safariVersion = ua.match(/Version\/(.*?) /);
            var isOldSafari = checkSafari && safariVersion && parseInt(safariVersion[1], 10) < 15;
            self._codecs = {
                mp3: !!(!isOldOpera && (mpegTest || audioTest.canPlayType("audio/mp3;").replace(/^no$/, ""))),
                mpeg: !!mpegTest,
                opus: !!audioTest.canPlayType('audio/ogg; codecs="opus"').replace(/^no$/, ""),
                ogg: !!audioTest.canPlayType('audio/ogg; codecs="vorbis"').replace(/^no$/, ""),
                oga: !!audioTest.canPlayType('audio/ogg; codecs="vorbis"').replace(/^no$/, ""),
                wav: !!(audioTest.canPlayType('audio/wav; codecs="1"') || audioTest.canPlayType("audio/wav")).replace(/^no$/, ""),
                aac: !!audioTest.canPlayType("audio/aac;").replace(/^no$/, ""),
                caf: !!audioTest.canPlayType("audio/x-caf;").replace(/^no$/, ""),
                m4a: !!(audioTest.canPlayType("audio/x-m4a;") || audioTest.canPlayType("audio/m4a;") || audioTest.canPlayType("audio/aac;")).replace(/^no$/, ""),
                m4b: !!(audioTest.canPlayType("audio/x-m4b;") || audioTest.canPlayType("audio/m4b;") || audioTest.canPlayType("audio/aac;")).replace(/^no$/, ""),
                mp4: !!(audioTest.canPlayType("audio/x-mp4;") || audioTest.canPlayType("audio/mp4;") || audioTest.canPlayType("audio/aac;")).replace(/^no$/, ""),
                weba: !!(!isOldSafari && audioTest.canPlayType('audio/webm; codecs="vorbis"').replace(/^no$/, "")),
                webm: !!(!isOldSafari && audioTest.canPlayType('audio/webm; codecs="vorbis"').replace(/^no$/, "")),
                dolby: !!audioTest.canPlayType('audio/mp4; codecs="ec-3"').replace(/^no$/, ""),
                flac: !!(audioTest.canPlayType("audio/x-flac;") || audioTest.canPlayType("audio/flac;")).replace(/^no$/, "")
            };
            return self;
        },
        /**
     * Some browsers/devices will only allow audio to be played after a user interaction.
     * Attempt to automatically unlock audio on the first user interaction.
     * Concept from: http://paulbakaus.com/tutorials/html5/web-audio-on-ios/
     * @return {Howler}
     */ _unlockAudio: function() {
            var self = this || Howler1;
            // Only run this if Web Audio is supported and it hasn't already been unlocked.
            if (self._audioUnlocked || !self.ctx) return;
            self._audioUnlocked = false;
            self.autoUnlock = false;
            // Some mobile devices/platforms have distortion issues when opening/closing tabs and/or web views.
            // Bugs in the browser (especially Mobile Safari) can cause the sampleRate to change from 44100 to 48000.
            // By calling Howler.unload(), we create a new AudioContext with the correct sampleRate.
            if (!self._mobileUnloaded && self.ctx.sampleRate !== 44100) {
                self._mobileUnloaded = true;
                self.unload();
            }
            // Scratch buffer for enabling iOS to dispose of web audio buffers correctly, as per:
            // http://stackoverflow.com/questions/24119684
            self._scratchBuffer = self.ctx.createBuffer(1, 1, 22050);
            // Call this method on touch start to create and play a buffer,
            // then check if the audio actually played to determine if
            // audio has now been unlocked on iOS, Android, etc.
            var unlock = function(e) {
                // Create a pool of unlocked HTML5 Audio objects that can
                // be used for playing sounds without user interaction. HTML5
                // Audio objects must be individually unlocked, as opposed
                // to the WebAudio API which only needs a single activation.
                // This must occur before WebAudio setup or the source.onended
                // event will not fire.
                while(self._html5AudioPool.length < self.html5PoolSize)try {
                    var audioNode = new Audio();
                    // Mark this Audio object as unlocked to ensure it can get returned
                    // to the unlocked pool when released.
                    audioNode._unlocked = true;
                    // Add the audio node to the pool.
                    self._releaseHtml5Audio(audioNode);
                } catch (e) {
                    self.noAudio = true;
                    break;
                }
                // Loop through any assigned audio nodes and unlock them.
                for(var i = 0; i < self._howls.length; i++)if (!self._howls[i]._webAudio) {
                    // Get all of the sounds in this Howl group.
                    var ids = self._howls[i]._getSoundIds();
                    // Loop through all sounds and unlock the audio nodes.
                    for(var j = 0; j < ids.length; j++){
                        var sound = self._howls[i]._soundById(ids[j]);
                        if (sound && sound._node && !sound._node._unlocked) {
                            sound._node._unlocked = true;
                            sound._node.load();
                        }
                    }
                }
                // Fix Android can not play in suspend state.
                self._autoResume();
                // Create an empty buffer.
                var source = self.ctx.createBufferSource();
                source.buffer = self._scratchBuffer;
                source.connect(self.ctx.destination);
                // Play the empty buffer.
                if (typeof source.start === "undefined") source.noteOn(0);
                else source.start(0);
                // Calling resume() on a stack initiated by user gesture is what actually unlocks the audio on Android Chrome >= 55.
                if (typeof self.ctx.resume === "function") self.ctx.resume();
                // Setup a timeout to check that we are unlocked on the next event loop.
                source.onended = function() {
                    source.disconnect(0);
                    // Update the unlocked state and prevent this check from happening again.
                    self._audioUnlocked = true;
                    // Remove the touch start listener.
                    document.removeEventListener("touchstart", unlock, true);
                    document.removeEventListener("touchend", unlock, true);
                    document.removeEventListener("click", unlock, true);
                    document.removeEventListener("keydown", unlock, true);
                    // Let all sounds know that audio has been unlocked.
                    for(var i = 0; i < self._howls.length; i++)self._howls[i]._emit("unlock");
                };
            };
            // Setup a touch start listener to attempt an unlock in.
            document.addEventListener("touchstart", unlock, true);
            document.addEventListener("touchend", unlock, true);
            document.addEventListener("click", unlock, true);
            document.addEventListener("keydown", unlock, true);
            return self;
        },
        /**
     * Get an unlocked HTML5 Audio object from the pool. If none are left,
     * return a new Audio object and throw a warning.
     * @return {Audio} HTML5 Audio object.
     */ _obtainHtml5Audio: function() {
            var self = this || Howler1;
            // Return the next object from the pool if one exists.
            if (self._html5AudioPool.length) return self._html5AudioPool.pop();
            //.Check if the audio is locked and throw a warning.
            var testPlay = new Audio().play();
            if (testPlay && typeof Promise !== "undefined" && (testPlay instanceof Promise || typeof testPlay.then === "function")) testPlay.catch(function() {
                console.warn("HTML5 Audio pool exhausted, returning potentially locked audio object.");
            });
            return new Audio();
        },
        /**
     * Return an activated HTML5 Audio object to the pool.
     * @return {Howler}
     */ _releaseHtml5Audio: function(audio) {
            var self = this || Howler1;
            // Don't add audio to the pool if we don't know if it has been unlocked.
            if (audio._unlocked) self._html5AudioPool.push(audio);
            return self;
        },
        /**
     * Automatically suspend the Web Audio AudioContext after no sound has played for 30 seconds.
     * This saves processing/energy and fixes various browser-specific bugs with audio getting stuck.
     * @return {Howler}
     */ _autoSuspend: function() {
            var self = this;
            if (!self.autoSuspend || !self.ctx || typeof self.ctx.suspend === "undefined" || !Howler1.usingWebAudio) return;
            // Check if any sounds are playing.
            for(var i = 0; i < self._howls.length; i++){
                if (self._howls[i]._webAudio) for(var j = 0; j < self._howls[i]._sounds.length; j++){
                    if (!self._howls[i]._sounds[j]._paused) return self;
                }
            }
            if (self._suspendTimer) clearTimeout(self._suspendTimer);
            // If no sound has played after 30 seconds, suspend the context.
            self._suspendTimer = setTimeout(function() {
                if (!self.autoSuspend) return;
                self._suspendTimer = null;
                self.state = "suspending";
                // Handle updating the state of the audio context after suspending.
                var handleSuspension = function() {
                    self.state = "suspended";
                    if (self._resumeAfterSuspend) {
                        delete self._resumeAfterSuspend;
                        self._autoResume();
                    }
                };
                // Either the state gets suspended or it is interrupted.
                // Either way, we need to update the state to suspended.
                self.ctx.suspend().then(handleSuspension, handleSuspension);
            }, 30000);
            return self;
        },
        /**
     * Automatically resume the Web Audio AudioContext when a new sound is played.
     * @return {Howler}
     */ _autoResume: function() {
            var self = this;
            if (!self.ctx || typeof self.ctx.resume === "undefined" || !Howler1.usingWebAudio) return;
            if (self.state === "running" && self.ctx.state !== "interrupted" && self._suspendTimer) {
                clearTimeout(self._suspendTimer);
                self._suspendTimer = null;
            } else if (self.state === "suspended" || self.state === "running" && self.ctx.state === "interrupted") {
                self.ctx.resume().then(function() {
                    self.state = "running";
                    // Emit to all Howls that the audio has resumed.
                    for(var i = 0; i < self._howls.length; i++)self._howls[i]._emit("resume");
                });
                if (self._suspendTimer) {
                    clearTimeout(self._suspendTimer);
                    self._suspendTimer = null;
                }
            } else if (self.state === "suspending") self._resumeAfterSuspend = true;
            return self;
        }
    };
    // Setup the global audio controller.
    var Howler1 = new HowlerGlobal1();
    /** Group Methods **/ /***************************************************************************/ /**
   * Create an audio group controller.
   * @param {Object} o Passed in properties for this group.
   */ var Howl1 = function(o) {
        var self = this;
        // Throw an error if no source is provided.
        if (!o.src || o.src.length === 0) {
            console.error("An array of source files must be passed with any new Howl.");
            return;
        }
        self.init(o);
    };
    Howl1.prototype = {
        /**
     * Initialize a new Howl group object.
     * @param  {Object} o Passed in properties for this group.
     * @return {Howl}
     */ init: function(o) {
            var self = this;
            // If we don't have an AudioContext created yet, run the setup.
            if (!Howler1.ctx) setupAudioContext();
            // Setup user-defined default properties.
            self._autoplay = o.autoplay || false;
            self._format = typeof o.format !== "string" ? o.format : [
                o.format
            ];
            self._html5 = o.html5 || false;
            self._muted = o.mute || false;
            self._loop = o.loop || false;
            self._pool = o.pool || 5;
            self._preload = typeof o.preload === "boolean" || o.preload === "metadata" ? o.preload : true;
            self._rate = o.rate || 1;
            self._sprite = o.sprite || {};
            self._src = typeof o.src !== "string" ? o.src : [
                o.src
            ];
            self._volume = o.volume !== undefined ? o.volume : 1;
            self._xhr = {
                method: o.xhr && o.xhr.method ? o.xhr.method : "GET",
                headers: o.xhr && o.xhr.headers ? o.xhr.headers : null,
                withCredentials: o.xhr && o.xhr.withCredentials ? o.xhr.withCredentials : false
            };
            // Setup all other default properties.
            self._duration = 0;
            self._state = "unloaded";
            self._sounds = [];
            self._endTimers = {};
            self._queue = [];
            self._playLock = false;
            // Setup event listeners.
            self._onend = o.onend ? [
                {
                    fn: o.onend
                }
            ] : [];
            self._onfade = o.onfade ? [
                {
                    fn: o.onfade
                }
            ] : [];
            self._onload = o.onload ? [
                {
                    fn: o.onload
                }
            ] : [];
            self._onloaderror = o.onloaderror ? [
                {
                    fn: o.onloaderror
                }
            ] : [];
            self._onplayerror = o.onplayerror ? [
                {
                    fn: o.onplayerror
                }
            ] : [];
            self._onpause = o.onpause ? [
                {
                    fn: o.onpause
                }
            ] : [];
            self._onplay = o.onplay ? [
                {
                    fn: o.onplay
                }
            ] : [];
            self._onstop = o.onstop ? [
                {
                    fn: o.onstop
                }
            ] : [];
            self._onmute = o.onmute ? [
                {
                    fn: o.onmute
                }
            ] : [];
            self._onvolume = o.onvolume ? [
                {
                    fn: o.onvolume
                }
            ] : [];
            self._onrate = o.onrate ? [
                {
                    fn: o.onrate
                }
            ] : [];
            self._onseek = o.onseek ? [
                {
                    fn: o.onseek
                }
            ] : [];
            self._onunlock = o.onunlock ? [
                {
                    fn: o.onunlock
                }
            ] : [];
            self._onresume = [];
            // Web Audio or HTML5 Audio?
            self._webAudio = Howler1.usingWebAudio && !self._html5;
            // Automatically try to enable audio.
            if (typeof Howler1.ctx !== "undefined" && Howler1.ctx && Howler1.autoUnlock) Howler1._unlockAudio();
            // Keep track of this Howl group in the global controller.
            Howler1._howls.push(self);
            // If they selected autoplay, add a play event to the load queue.
            if (self._autoplay) self._queue.push({
                event: "play",
                action: function() {
                    self.play();
                }
            });
            // Load the source file unless otherwise specified.
            if (self._preload && self._preload !== "none") self.load();
            return self;
        },
        /**
     * Load the audio file.
     * @return {Howler}
     */ load: function() {
            var self = this;
            var url = null;
            // If no audio is available, quit immediately.
            if (Howler1.noAudio) {
                self._emit("loaderror", null, "No audio support.");
                return;
            }
            // Make sure our source is in an array.
            if (typeof self._src === "string") self._src = [
                self._src
            ];
            // Loop through the sources and pick the first one that is compatible.
            for(var i = 0; i < self._src.length; i++){
                var ext, str;
                if (self._format && self._format[i]) // If an extension was specified, use that instead.
                ext = self._format[i];
                else {
                    // Make sure the source is a string.
                    str = self._src[i];
                    if (typeof str !== "string") {
                        self._emit("loaderror", null, "Non-string found in selected audio sources - ignoring.");
                        continue;
                    }
                    // Extract the file extension from the URL or base64 data URI.
                    ext = /^data:audio\/([^;,]+);/i.exec(str);
                    if (!ext) ext = /\.([^.]+)$/.exec(str.split("?", 1)[0]);
                    if (ext) ext = ext[1].toLowerCase();
                }
                // Log a warning if no extension was found.
                if (!ext) console.warn('No file extension was found. Consider using the "format" property or specify an extension.');
                // Check if this extension is available.
                if (ext && Howler1.codecs(ext)) {
                    url = self._src[i];
                    break;
                }
            }
            if (!url) {
                self._emit("loaderror", null, "No codec support for selected audio sources.");
                return;
            }
            self._src = url;
            self._state = "loading";
            // If the hosting page is HTTPS and the source isn't,
            // drop down to HTML5 Audio to avoid Mixed Content errors.
            if (window.location.protocol === "https:" && url.slice(0, 5) === "http:") {
                self._html5 = true;
                self._webAudio = false;
            }
            // Create a new sound object and add it to the pool.
            new Sound1(self);
            // Load and decode the audio data for playback.
            if (self._webAudio) loadBuffer(self);
            return self;
        },
        /**
     * Play a sound or resume previous playback.
     * @param  {String/Number} sprite   Sprite name for sprite playback or sound id to continue previous.
     * @param  {Boolean} internal Internal Use: true prevents event firing.
     * @return {Number}          Sound ID.
     */ play: function(sprite, internal) {
            var self = this;
            var id = null;
            // Determine if a sprite, sound id or nothing was passed
            if (typeof sprite === "number") {
                id = sprite;
                sprite = null;
            } else if (typeof sprite === "string" && self._state === "loaded" && !self._sprite[sprite]) // If the passed sprite doesn't exist, do nothing.
            return null;
            else if (typeof sprite === "undefined") {
                // Use the default sound sprite (plays the full audio length).
                sprite = "__default";
                // Check if there is a single paused sound that isn't ended.
                // If there is, play that sound. If not, continue as usual.
                if (!self._playLock) {
                    var num = 0;
                    for(var i = 0; i < self._sounds.length; i++)if (self._sounds[i]._paused && !self._sounds[i]._ended) {
                        num++;
                        id = self._sounds[i]._id;
                    }
                    if (num === 1) sprite = null;
                    else id = null;
                }
            }
            // Get the selected node, or get one from the pool.
            var sound = id ? self._soundById(id) : self._inactiveSound();
            // If the sound doesn't exist, do nothing.
            if (!sound) return null;
            // Select the sprite definition.
            if (id && !sprite) sprite = sound._sprite || "__default";
            // If the sound hasn't loaded, we must wait to get the audio's duration.
            // We also need to wait to make sure we don't run into race conditions with
            // the order of function calls.
            if (self._state !== "loaded") {
                // Set the sprite value on this sound.
                sound._sprite = sprite;
                // Mark this sound as not ended in case another sound is played before this one loads.
                sound._ended = false;
                // Add the sound to the queue to be played on load.
                var soundId = sound._id;
                self._queue.push({
                    event: "play",
                    action: function() {
                        self.play(soundId);
                    }
                });
                return soundId;
            }
            // Don't play the sound if an id was passed and it is already playing.
            if (id && !sound._paused) {
                // Trigger the play event, in order to keep iterating through queue.
                if (!internal) self._loadQueue("play");
                return sound._id;
            }
            // Make sure the AudioContext isn't suspended, and resume it if it is.
            if (self._webAudio) Howler1._autoResume();
            // Determine how long to play for and where to start playing.
            var seek = Math.max(0, sound._seek > 0 ? sound._seek : self._sprite[sprite][0] / 1000);
            var duration = Math.max(0, (self._sprite[sprite][0] + self._sprite[sprite][1]) / 1000 - seek);
            var timeout = duration * 1000 / Math.abs(sound._rate);
            var start = self._sprite[sprite][0] / 1000;
            var stop = (self._sprite[sprite][0] + self._sprite[sprite][1]) / 1000;
            sound._sprite = sprite;
            // Mark the sound as ended instantly so that this async playback
            // doesn't get grabbed by another call to play while this one waits to start.
            sound._ended = false;
            // Update the parameters of the sound.
            var setParams = function() {
                sound._paused = false;
                sound._seek = seek;
                sound._start = start;
                sound._stop = stop;
                sound._loop = !!(sound._loop || self._sprite[sprite][2]);
            };
            // End the sound instantly if seek is at the end.
            if (seek >= stop) {
                self._ended(sound);
                return;
            }
            // Begin the actual playback.
            var node = sound._node;
            if (self._webAudio) {
                // Fire this when the sound is ready to play to begin Web Audio playback.
                var playWebAudio = function() {
                    self._playLock = false;
                    setParams();
                    self._refreshBuffer(sound);
                    // Setup the playback params.
                    var vol = sound._muted || self._muted ? 0 : sound._volume;
                    node.gain.setValueAtTime(vol, Howler1.ctx.currentTime);
                    sound._playStart = Howler1.ctx.currentTime;
                    // Play the sound using the supported method.
                    if (typeof node.bufferSource.start === "undefined") sound._loop ? node.bufferSource.noteGrainOn(0, seek, 86400) : node.bufferSource.noteGrainOn(0, seek, duration);
                    else sound._loop ? node.bufferSource.start(0, seek, 86400) : node.bufferSource.start(0, seek, duration);
                    // Start a new timer if none is present.
                    if (timeout !== Infinity) self._endTimers[sound._id] = setTimeout(self._ended.bind(self, sound), timeout);
                    if (!internal) setTimeout(function() {
                        self._emit("play", sound._id);
                        self._loadQueue();
                    }, 0);
                };
                if (Howler1.state === "running" && Howler1.ctx.state !== "interrupted") playWebAudio();
                else {
                    self._playLock = true;
                    // Wait for the audio context to resume before playing.
                    self.once("resume", playWebAudio);
                    // Cancel the end timer.
                    self._clearTimer(sound._id);
                }
            } else {
                // Fire this when the sound is ready to play to begin HTML5 Audio playback.
                var playHtml5 = function() {
                    node.currentTime = seek;
                    node.muted = sound._muted || self._muted || Howler1._muted || node.muted;
                    node.volume = sound._volume * Howler1.volume();
                    node.playbackRate = sound._rate;
                    // Some browsers will throw an error if this is called without user interaction.
                    try {
                        var play = node.play();
                        // Support older browsers that don't support promises, and thus don't have this issue.
                        if (play && typeof Promise !== "undefined" && (play instanceof Promise || typeof play.then === "function")) {
                            // Implements a lock to prevent DOMException: The play() request was interrupted by a call to pause().
                            self._playLock = true;
                            // Set param values immediately.
                            setParams();
                            // Releases the lock and executes queued actions.
                            play.then(function() {
                                self._playLock = false;
                                node._unlocked = true;
                                if (!internal) self._emit("play", sound._id);
                                else self._loadQueue();
                            }).catch(function() {
                                self._playLock = false;
                                self._emit("playerror", sound._id, "Playback was unable to start. This is most commonly an issue on mobile devices and Chrome where playback was not within a user interaction.");
                                // Reset the ended and paused values.
                                sound._ended = true;
                                sound._paused = true;
                            });
                        } else if (!internal) {
                            self._playLock = false;
                            setParams();
                            self._emit("play", sound._id);
                        }
                        // Setting rate before playing won't work in IE, so we set it again here.
                        node.playbackRate = sound._rate;
                        // If the node is still paused, then we can assume there was a playback issue.
                        if (node.paused) {
                            self._emit("playerror", sound._id, "Playback was unable to start. This is most commonly an issue on mobile devices and Chrome where playback was not within a user interaction.");
                            return;
                        }
                        // Setup the end timer on sprites or listen for the ended event.
                        if (sprite !== "__default" || sound._loop) self._endTimers[sound._id] = setTimeout(self._ended.bind(self, sound), timeout);
                        else {
                            self._endTimers[sound._id] = function() {
                                // Fire ended on this audio node.
                                self._ended(sound);
                                // Clear this listener.
                                node.removeEventListener("ended", self._endTimers[sound._id], false);
                            };
                            node.addEventListener("ended", self._endTimers[sound._id], false);
                        }
                    } catch (err) {
                        self._emit("playerror", sound._id, err);
                    }
                };
                // If this is streaming audio, make sure the src is set and load again.
                if (node.src === "data:audio/wav;base64,UklGRigAAABXQVZFZm10IBIAAAABAAEARKwAAIhYAQACABAAAABkYXRhAgAAAAEA") {
                    node.src = self._src;
                    node.load();
                }
                // Play immediately if ready, or wait for the 'canplaythrough'e vent.
                var loadedNoReadyState = window && window.ejecta || !node.readyState && Howler1._navigator.isCocoonJS;
                if (node.readyState >= 3 || loadedNoReadyState) playHtml5();
                else {
                    self._playLock = true;
                    self._state = "loading";
                    var listener = function() {
                        self._state = "loaded";
                        // Begin playback.
                        playHtml5();
                        // Clear this listener.
                        node.removeEventListener(Howler1._canPlayEvent, listener, false);
                    };
                    node.addEventListener(Howler1._canPlayEvent, listener, false);
                    // Cancel the end timer.
                    self._clearTimer(sound._id);
                }
            }
            return sound._id;
        },
        /**
     * Pause playback and save current position.
     * @param  {Number} id The sound ID (empty to pause all in group).
     * @return {Howl}
     */ pause: function(id) {
            var self = this;
            // If the sound hasn't loaded or a play() promise is pending, add it to the load queue to pause when capable.
            if (self._state !== "loaded" || self._playLock) {
                self._queue.push({
                    event: "pause",
                    action: function() {
                        self.pause(id);
                    }
                });
                return self;
            }
            // If no id is passed, get all ID's to be paused.
            var ids = self._getSoundIds(id);
            for(var i = 0; i < ids.length; i++){
                // Clear the end timer.
                self._clearTimer(ids[i]);
                // Get the sound.
                var sound = self._soundById(ids[i]);
                if (sound && !sound._paused) {
                    // Reset the seek position.
                    sound._seek = self.seek(ids[i]);
                    sound._rateSeek = 0;
                    sound._paused = true;
                    // Stop currently running fades.
                    self._stopFade(ids[i]);
                    if (sound._node) {
                        if (self._webAudio) {
                            // Make sure the sound has been created.
                            if (!sound._node.bufferSource) continue;
                            if (typeof sound._node.bufferSource.stop === "undefined") sound._node.bufferSource.noteOff(0);
                            else sound._node.bufferSource.stop(0);
                            // Clean up the buffer source.
                            self._cleanBuffer(sound._node);
                        } else if (!isNaN(sound._node.duration) || sound._node.duration === Infinity) sound._node.pause();
                    }
                }
                // Fire the pause event, unless `true` is passed as the 2nd argument.
                if (!arguments[1]) self._emit("pause", sound ? sound._id : null);
            }
            return self;
        },
        /**
     * Stop playback and reset to start.
     * @param  {Number} id The sound ID (empty to stop all in group).
     * @param  {Boolean} internal Internal Use: true prevents event firing.
     * @return {Howl}
     */ stop: function(id, internal) {
            var self = this;
            // If the sound hasn't loaded, add it to the load queue to stop when capable.
            if (self._state !== "loaded" || self._playLock) {
                self._queue.push({
                    event: "stop",
                    action: function() {
                        self.stop(id);
                    }
                });
                return self;
            }
            // If no id is passed, get all ID's to be stopped.
            var ids = self._getSoundIds(id);
            for(var i = 0; i < ids.length; i++){
                // Clear the end timer.
                self._clearTimer(ids[i]);
                // Get the sound.
                var sound = self._soundById(ids[i]);
                if (sound) {
                    // Reset the seek position.
                    sound._seek = sound._start || 0;
                    sound._rateSeek = 0;
                    sound._paused = true;
                    sound._ended = true;
                    // Stop currently running fades.
                    self._stopFade(ids[i]);
                    if (sound._node) {
                        if (self._webAudio) // Make sure the sound's AudioBufferSourceNode has been created.
                        {
                            if (sound._node.bufferSource) {
                                if (typeof sound._node.bufferSource.stop === "undefined") sound._node.bufferSource.noteOff(0);
                                else sound._node.bufferSource.stop(0);
                                // Clean up the buffer source.
                                self._cleanBuffer(sound._node);
                            }
                        } else if (!isNaN(sound._node.duration) || sound._node.duration === Infinity) {
                            sound._node.currentTime = sound._start || 0;
                            sound._node.pause();
                            // If this is a live stream, stop download once the audio is stopped.
                            if (sound._node.duration === Infinity) self._clearSound(sound._node);
                        }
                    }
                    if (!internal) self._emit("stop", sound._id);
                }
            }
            return self;
        },
        /**
     * Mute/unmute a single sound or all sounds in this Howl group.
     * @param  {Boolean} muted Set to true to mute and false to unmute.
     * @param  {Number} id    The sound ID to update (omit to mute/unmute all).
     * @return {Howl}
     */ mute: function(muted, id) {
            var self = this;
            // If the sound hasn't loaded, add it to the load queue to mute when capable.
            if (self._state !== "loaded" || self._playLock) {
                self._queue.push({
                    event: "mute",
                    action: function() {
                        self.mute(muted, id);
                    }
                });
                return self;
            }
            // If applying mute/unmute to all sounds, update the group's value.
            if (typeof id === "undefined") {
                if (typeof muted === "boolean") self._muted = muted;
                else return self._muted;
            }
            // If no id is passed, get all ID's to be muted.
            var ids = self._getSoundIds(id);
            for(var i = 0; i < ids.length; i++){
                // Get the sound.
                var sound = self._soundById(ids[i]);
                if (sound) {
                    sound._muted = muted;
                    // Cancel active fade and set the volume to the end value.
                    if (sound._interval) self._stopFade(sound._id);
                    if (self._webAudio && sound._node) sound._node.gain.setValueAtTime(muted ? 0 : sound._volume, Howler1.ctx.currentTime);
                    else if (sound._node) sound._node.muted = Howler1._muted ? true : muted;
                    self._emit("mute", sound._id);
                }
            }
            return self;
        },
        /**
     * Get/set the volume of this sound or of the Howl group. This method can optionally take 0, 1 or 2 arguments.
     *   volume() -> Returns the group's volume value.
     *   volume(id) -> Returns the sound id's current volume.
     *   volume(vol) -> Sets the volume of all sounds in this Howl group.
     *   volume(vol, id) -> Sets the volume of passed sound id.
     * @return {Howl/Number} Returns self or current volume.
     */ volume: function() {
            var self = this;
            var args = arguments;
            var vol, id;
            // Determine the values based on arguments.
            if (args.length === 0) // Return the value of the groups' volume.
            return self._volume;
            else if (args.length === 1 || args.length === 2 && typeof args[1] === "undefined") {
                // First check if this is an ID, and if not, assume it is a new volume.
                var ids = self._getSoundIds();
                var index = ids.indexOf(args[0]);
                if (index >= 0) id = parseInt(args[0], 10);
                else vol = parseFloat(args[0]);
            } else if (args.length >= 2) {
                vol = parseFloat(args[0]);
                id = parseInt(args[1], 10);
            }
            // Update the volume or return the current volume.
            var sound;
            if (typeof vol !== "undefined" && vol >= 0 && vol <= 1) {
                // If the sound hasn't loaded, add it to the load queue to change volume when capable.
                if (self._state !== "loaded" || self._playLock) {
                    self._queue.push({
                        event: "volume",
                        action: function() {
                            self.volume.apply(self, args);
                        }
                    });
                    return self;
                }
                // Set the group volume.
                if (typeof id === "undefined") self._volume = vol;
                // Update one or all volumes.
                id = self._getSoundIds(id);
                for(var i = 0; i < id.length; i++){
                    // Get the sound.
                    sound = self._soundById(id[i]);
                    if (sound) {
                        sound._volume = vol;
                        // Stop currently running fades.
                        if (!args[2]) self._stopFade(id[i]);
                        if (self._webAudio && sound._node && !sound._muted) sound._node.gain.setValueAtTime(vol, Howler1.ctx.currentTime);
                        else if (sound._node && !sound._muted) sound._node.volume = vol * Howler1.volume();
                        self._emit("volume", sound._id);
                    }
                }
            } else {
                sound = id ? self._soundById(id) : self._sounds[0];
                return sound ? sound._volume : 0;
            }
            return self;
        },
        /**
     * Fade a currently playing sound between two volumes (if no id is passed, all sounds will fade).
     * @param  {Number} from The value to fade from (0.0 to 1.0).
     * @param  {Number} to   The volume to fade to (0.0 to 1.0).
     * @param  {Number} len  Time in milliseconds to fade.
     * @param  {Number} id   The sound id (omit to fade all sounds).
     * @return {Howl}
     */ fade: function(from, to, len, id) {
            var self = this;
            // If the sound hasn't loaded, add it to the load queue to fade when capable.
            if (self._state !== "loaded" || self._playLock) {
                self._queue.push({
                    event: "fade",
                    action: function() {
                        self.fade(from, to, len, id);
                    }
                });
                return self;
            }
            // Make sure the to/from/len values are numbers.
            from = Math.min(Math.max(0, parseFloat(from)), 1);
            to = Math.min(Math.max(0, parseFloat(to)), 1);
            len = parseFloat(len);
            // Set the volume to the start position.
            self.volume(from, id);
            // Fade the volume of one or all sounds.
            var ids = self._getSoundIds(id);
            for(var i = 0; i < ids.length; i++){
                // Get the sound.
                var sound = self._soundById(ids[i]);
                // Create a linear fade or fall back to timeouts with HTML5 Audio.
                if (sound) {
                    // Stop the previous fade if no sprite is being used (otherwise, volume handles this).
                    if (!id) self._stopFade(ids[i]);
                    // If we are using Web Audio, let the native methods do the actual fade.
                    if (self._webAudio && !sound._muted) {
                        var currentTime = Howler1.ctx.currentTime;
                        var end = currentTime + len / 1000;
                        sound._volume = from;
                        sound._node.gain.setValueAtTime(from, currentTime);
                        sound._node.gain.linearRampToValueAtTime(to, end);
                    }
                    self._startFadeInterval(sound, from, to, len, ids[i], typeof id === "undefined");
                }
            }
            return self;
        },
        /**
     * Starts the internal interval to fade a sound.
     * @param  {Object} sound Reference to sound to fade.
     * @param  {Number} from The value to fade from (0.0 to 1.0).
     * @param  {Number} to   The volume to fade to (0.0 to 1.0).
     * @param  {Number} len  Time in milliseconds to fade.
     * @param  {Number} id   The sound id to fade.
     * @param  {Boolean} isGroup   If true, set the volume on the group.
     */ _startFadeInterval: function(sound, from, to, len, id, isGroup) {
            var self = this;
            var vol = from;
            var diff = to - from;
            var steps = Math.abs(diff / 0.01);
            var stepLen = Math.max(4, steps > 0 ? len / steps : len);
            var lastTick = Date.now();
            // Store the value being faded to.
            sound._fadeTo = to;
            // Update the volume value on each interval tick.
            sound._interval = setInterval(function() {
                // Update the volume based on the time since the last tick.
                var tick = (Date.now() - lastTick) / len;
                lastTick = Date.now();
                vol += diff * tick;
                // Round to within 2 decimal points.
                vol = Math.round(vol * 100) / 100;
                // Make sure the volume is in the right bounds.
                if (diff < 0) vol = Math.max(to, vol);
                else vol = Math.min(to, vol);
                // Change the volume.
                if (self._webAudio) sound._volume = vol;
                else self.volume(vol, sound._id, true);
                // Set the group's volume.
                if (isGroup) self._volume = vol;
                // When the fade is complete, stop it and fire event.
                if (to < from && vol <= to || to > from && vol >= to) {
                    clearInterval(sound._interval);
                    sound._interval = null;
                    sound._fadeTo = null;
                    self.volume(to, sound._id);
                    self._emit("fade", sound._id);
                }
            }, stepLen);
        },
        /**
     * Internal method that stops the currently playing fade when
     * a new fade starts, volume is changed or the sound is stopped.
     * @param  {Number} id The sound id.
     * @return {Howl}
     */ _stopFade: function(id) {
            var self = this;
            var sound = self._soundById(id);
            if (sound && sound._interval) {
                if (self._webAudio) sound._node.gain.cancelScheduledValues(Howler1.ctx.currentTime);
                clearInterval(sound._interval);
                sound._interval = null;
                self.volume(sound._fadeTo, id);
                sound._fadeTo = null;
                self._emit("fade", id);
            }
            return self;
        },
        /**
     * Get/set the loop parameter on a sound. This method can optionally take 0, 1 or 2 arguments.
     *   loop() -> Returns the group's loop value.
     *   loop(id) -> Returns the sound id's loop value.
     *   loop(loop) -> Sets the loop value for all sounds in this Howl group.
     *   loop(loop, id) -> Sets the loop value of passed sound id.
     * @return {Howl/Boolean} Returns self or current loop value.
     */ loop: function() {
            var self = this;
            var args = arguments;
            var loop, id, sound;
            // Determine the values for loop and id.
            if (args.length === 0) // Return the grou's loop value.
            return self._loop;
            else if (args.length === 1) {
                if (typeof args[0] === "boolean") {
                    loop = args[0];
                    self._loop = loop;
                } else {
                    // Return this sound's loop value.
                    sound = self._soundById(parseInt(args[0], 10));
                    return sound ? sound._loop : false;
                }
            } else if (args.length === 2) {
                loop = args[0];
                id = parseInt(args[1], 10);
            }
            // If no id is passed, get all ID's to be looped.
            var ids = self._getSoundIds(id);
            for(var i = 0; i < ids.length; i++){
                sound = self._soundById(ids[i]);
                if (sound) {
                    sound._loop = loop;
                    if (self._webAudio && sound._node && sound._node.bufferSource) {
                        sound._node.bufferSource.loop = loop;
                        if (loop) {
                            sound._node.bufferSource.loopStart = sound._start || 0;
                            sound._node.bufferSource.loopEnd = sound._stop;
                            // If playing, restart playback to ensure looping updates.
                            if (self.playing(ids[i])) {
                                self.pause(ids[i], true);
                                self.play(ids[i], true);
                            }
                        }
                    }
                }
            }
            return self;
        },
        /**
     * Get/set the playback rate of a sound. This method can optionally take 0, 1 or 2 arguments.
     *   rate() -> Returns the first sound node's current playback rate.
     *   rate(id) -> Returns the sound id's current playback rate.
     *   rate(rate) -> Sets the playback rate of all sounds in this Howl group.
     *   rate(rate, id) -> Sets the playback rate of passed sound id.
     * @return {Howl/Number} Returns self or the current playback rate.
     */ rate: function() {
            var self = this;
            var args = arguments;
            var rate, id;
            // Determine the values based on arguments.
            if (args.length === 0) // We will simply return the current rate of the first node.
            id = self._sounds[0]._id;
            else if (args.length === 1) {
                // First check if this is an ID, and if not, assume it is a new rate value.
                var ids = self._getSoundIds();
                var index = ids.indexOf(args[0]);
                if (index >= 0) id = parseInt(args[0], 10);
                else rate = parseFloat(args[0]);
            } else if (args.length === 2) {
                rate = parseFloat(args[0]);
                id = parseInt(args[1], 10);
            }
            // Update the playback rate or return the current value.
            var sound;
            if (typeof rate === "number") {
                // If the sound hasn't loaded, add it to the load queue to change playback rate when capable.
                if (self._state !== "loaded" || self._playLock) {
                    self._queue.push({
                        event: "rate",
                        action: function() {
                            self.rate.apply(self, args);
                        }
                    });
                    return self;
                }
                // Set the group rate.
                if (typeof id === "undefined") self._rate = rate;
                // Update one or all volumes.
                id = self._getSoundIds(id);
                for(var i = 0; i < id.length; i++){
                    // Get the sound.
                    sound = self._soundById(id[i]);
                    if (sound) {
                        // Keep track of our position when the rate changed and update the playback
                        // start position so we can properly adjust the seek position for time elapsed.
                        if (self.playing(id[i])) {
                            sound._rateSeek = self.seek(id[i]);
                            sound._playStart = self._webAudio ? Howler1.ctx.currentTime : sound._playStart;
                        }
                        sound._rate = rate;
                        // Change the playback rate.
                        if (self._webAudio && sound._node && sound._node.bufferSource) sound._node.bufferSource.playbackRate.setValueAtTime(rate, Howler1.ctx.currentTime);
                        else if (sound._node) sound._node.playbackRate = rate;
                        // Reset the timers.
                        var seek = self.seek(id[i]);
                        var duration = (self._sprite[sound._sprite][0] + self._sprite[sound._sprite][1]) / 1000 - seek;
                        var timeout = duration * 1000 / Math.abs(sound._rate);
                        // Start a new end timer if sound is already playing.
                        if (self._endTimers[id[i]] || !sound._paused) {
                            self._clearTimer(id[i]);
                            self._endTimers[id[i]] = setTimeout(self._ended.bind(self, sound), timeout);
                        }
                        self._emit("rate", sound._id);
                    }
                }
            } else {
                sound = self._soundById(id);
                return sound ? sound._rate : self._rate;
            }
            return self;
        },
        /**
     * Get/set the seek position of a sound. This method can optionally take 0, 1 or 2 arguments.
     *   seek() -> Returns the first sound node's current seek position.
     *   seek(id) -> Returns the sound id's current seek position.
     *   seek(seek) -> Sets the seek position of the first sound node.
     *   seek(seek, id) -> Sets the seek position of passed sound id.
     * @return {Howl/Number} Returns self or the current seek position.
     */ seek: function() {
            var self = this;
            var args = arguments;
            var seek, id;
            // Determine the values based on arguments.
            if (args.length === 0) // We will simply return the current position of the first node.
            {
                if (self._sounds.length) id = self._sounds[0]._id;
            } else if (args.length === 1) {
                // First check if this is an ID, and if not, assume it is a new seek position.
                var ids = self._getSoundIds();
                var index = ids.indexOf(args[0]);
                if (index >= 0) id = parseInt(args[0], 10);
                else if (self._sounds.length) {
                    id = self._sounds[0]._id;
                    seek = parseFloat(args[0]);
                }
            } else if (args.length === 2) {
                seek = parseFloat(args[0]);
                id = parseInt(args[1], 10);
            }
            // If there is no ID, bail out.
            if (typeof id === "undefined") return 0;
            // If the sound hasn't loaded, add it to the load queue to seek when capable.
            if (typeof seek === "number" && (self._state !== "loaded" || self._playLock)) {
                self._queue.push({
                    event: "seek",
                    action: function() {
                        self.seek.apply(self, args);
                    }
                });
                return self;
            }
            // Get the sound.
            var sound = self._soundById(id);
            if (sound) {
                if (typeof seek === "number" && seek >= 0) {
                    // Pause the sound and update position for restarting playback.
                    var playing = self.playing(id);
                    if (playing) self.pause(id, true);
                    // Move the position of the track and cancel timer.
                    sound._seek = seek;
                    sound._ended = false;
                    self._clearTimer(id);
                    // Update the seek position for HTML5 Audio.
                    if (!self._webAudio && sound._node && !isNaN(sound._node.duration)) sound._node.currentTime = seek;
                    // Seek and emit when ready.
                    var seekAndEmit = function() {
                        // Restart the playback if the sound was playing.
                        if (playing) self.play(id, true);
                        self._emit("seek", id);
                    };
                    // Wait for the play lock to be unset before emitting (HTML5 Audio).
                    if (playing && !self._webAudio) {
                        var emitSeek = function() {
                            if (!self._playLock) seekAndEmit();
                            else setTimeout(emitSeek, 0);
                        };
                        setTimeout(emitSeek, 0);
                    } else seekAndEmit();
                } else {
                    if (self._webAudio) {
                        var realTime = self.playing(id) ? Howler1.ctx.currentTime - sound._playStart : 0;
                        var rateSeek = sound._rateSeek ? sound._rateSeek - sound._seek : 0;
                        return sound._seek + (rateSeek + realTime * Math.abs(sound._rate));
                    } else return sound._node.currentTime;
                }
            }
            return self;
        },
        /**
     * Check if a specific sound is currently playing or not (if id is provided), or check if at least one of the sounds in the group is playing or not.
     * @param  {Number}  id The sound id to check. If none is passed, the whole sound group is checked.
     * @return {Boolean} True if playing and false if not.
     */ playing: function(id) {
            var self = this;
            // Check the passed sound ID (if any).
            if (typeof id === "number") {
                var sound = self._soundById(id);
                return sound ? !sound._paused : false;
            }
            // Otherwise, loop through all sounds and check if any are playing.
            for(var i = 0; i < self._sounds.length; i++){
                if (!self._sounds[i]._paused) return true;
            }
            return false;
        },
        /**
     * Get the duration of this sound. Passing a sound id will return the sprite duration.
     * @param  {Number} id The sound id to check. If none is passed, return full source duration.
     * @return {Number} Audio duration in seconds.
     */ duration: function(id) {
            var self = this;
            var duration = self._duration;
            // If we pass an ID, get the sound and return the sprite length.
            var sound = self._soundById(id);
            if (sound) duration = self._sprite[sound._sprite][1] / 1000;
            return duration;
        },
        /**
     * Returns the current loaded state of this Howl.
     * @return {String} 'unloaded', 'loading', 'loaded'
     */ state: function() {
            return this._state;
        },
        /**
     * Unload and destroy the current Howl object.
     * This will immediately stop all sound instances attached to this group.
     */ unload: function() {
            var self = this;
            // Stop playing any active sounds.
            var sounds = self._sounds;
            for(var i = 0; i < sounds.length; i++){
                // Stop the sound if it is currently playing.
                if (!sounds[i]._paused) self.stop(sounds[i]._id);
                // Remove the source or disconnect.
                if (!self._webAudio) {
                    // Set the source to 0-second silence to stop any downloading (except in IE).
                    self._clearSound(sounds[i]._node);
                    // Remove any event listeners.
                    sounds[i]._node.removeEventListener("error", sounds[i]._errorFn, false);
                    sounds[i]._node.removeEventListener(Howler1._canPlayEvent, sounds[i]._loadFn, false);
                    sounds[i]._node.removeEventListener("ended", sounds[i]._endFn, false);
                    // Release the Audio object back to the pool.
                    Howler1._releaseHtml5Audio(sounds[i]._node);
                }
                // Empty out all of the nodes.
                delete sounds[i]._node;
                // Make sure all timers are cleared out.
                self._clearTimer(sounds[i]._id);
            }
            // Remove the references in the global Howler object.
            var index = Howler1._howls.indexOf(self);
            if (index >= 0) Howler1._howls.splice(index, 1);
            // Delete this sound from the cache (if no other Howl is using it).
            var remCache = true;
            for(i = 0; i < Howler1._howls.length; i++)if (Howler1._howls[i]._src === self._src || self._src.indexOf(Howler1._howls[i]._src) >= 0) {
                remCache = false;
                break;
            }
            if (cache && remCache) delete cache[self._src];
            // Clear global errors.
            Howler1.noAudio = false;
            // Clear out `self`.
            self._state = "unloaded";
            self._sounds = [];
            self = null;
            return null;
        },
        /**
     * Listen to a custom event.
     * @param  {String}   event Event name.
     * @param  {Function} fn    Listener to call.
     * @param  {Number}   id    (optional) Only listen to events for this sound.
     * @param  {Number}   once  (INTERNAL) Marks event to fire only once.
     * @return {Howl}
     */ on: function(event, fn, id, once) {
            var self = this;
            var events = self["_on" + event];
            if (typeof fn === "function") events.push(once ? {
                id: id,
                fn: fn,
                once: once
            } : {
                id: id,
                fn: fn
            });
            return self;
        },
        /**
     * Remove a custom event. Call without parameters to remove all events.
     * @param  {String}   event Event name.
     * @param  {Function} fn    Listener to remove. Leave empty to remove all.
     * @param  {Number}   id    (optional) Only remove events for this sound.
     * @return {Howl}
     */ off: function(event, fn, id) {
            var self = this;
            var events = self["_on" + event];
            var i = 0;
            // Allow passing just an event and ID.
            if (typeof fn === "number") {
                id = fn;
                fn = null;
            }
            if (fn || id) // Loop through event store and remove the passed function.
            for(i = 0; i < events.length; i++){
                var isId = id === events[i].id;
                if (fn === events[i].fn && isId || !fn && isId) {
                    events.splice(i, 1);
                    break;
                }
            }
            else if (event) // Clear out all events of this type.
            self["_on" + event] = [];
            else {
                // Clear out all events of every type.
                var keys = Object.keys(self);
                for(i = 0; i < keys.length; i++)if (keys[i].indexOf("_on") === 0 && Array.isArray(self[keys[i]])) self[keys[i]] = [];
            }
            return self;
        },
        /**
     * Listen to a custom event and remove it once fired.
     * @param  {String}   event Event name.
     * @param  {Function} fn    Listener to call.
     * @param  {Number}   id    (optional) Only listen to events for this sound.
     * @return {Howl}
     */ once: function(event, fn, id) {
            var self = this;
            // Setup the event listener.
            self.on(event, fn, id, 1);
            return self;
        },
        /**
     * Emit all events of a specific type and pass the sound id.
     * @param  {String} event Event name.
     * @param  {Number} id    Sound ID.
     * @param  {Number} msg   Message to go with event.
     * @return {Howl}
     */ _emit: function(event, id, msg) {
            var self = this;
            var events = self["_on" + event];
            // Loop through event store and fire all functions.
            for(var i = events.length - 1; i >= 0; i--)// Only fire the listener if the correct ID is used.
            if (!events[i].id || events[i].id === id || event === "load") {
                setTimeout((function(fn) {
                    fn.call(this, id, msg);
                }).bind(self, events[i].fn), 0);
                // If this event was setup with `once`, remove it.
                if (events[i].once) self.off(event, events[i].fn, events[i].id);
            }
            // Pass the event type into load queue so that it can continue stepping.
            self._loadQueue(event);
            return self;
        },
        /**
     * Queue of actions initiated before the sound has loaded.
     * These will be called in sequence, with the next only firing
     * after the previous has finished executing (even if async like play).
     * @return {Howl}
     */ _loadQueue: function(event) {
            var self = this;
            if (self._queue.length > 0) {
                var task = self._queue[0];
                // Remove this task if a matching event was passed.
                if (task.event === event) {
                    self._queue.shift();
                    self._loadQueue();
                }
                // Run the task if no event type is passed.
                if (!event) task.action();
            }
            return self;
        },
        /**
     * Fired when playback ends at the end of the duration.
     * @param  {Sound} sound The sound object to work with.
     * @return {Howl}
     */ _ended: function(sound) {
            var self = this;
            var sprite = sound._sprite;
            // If we are using IE and there was network latency we may be clipping
            // audio before it completes playing. Lets check the node to make sure it
            // believes it has completed, before ending the playback.
            if (!self._webAudio && sound._node && !sound._node.paused && !sound._node.ended && sound._node.currentTime < sound._stop) {
                setTimeout(self._ended.bind(self, sound), 100);
                return self;
            }
            // Should this sound loop?
            var loop = !!(sound._loop || self._sprite[sprite][2]);
            // Fire the ended event.
            self._emit("end", sound._id);
            // Restart the playback for HTML5 Audio loop.
            if (!self._webAudio && loop) self.stop(sound._id, true).play(sound._id);
            // Restart this timer if on a Web Audio loop.
            if (self._webAudio && loop) {
                self._emit("play", sound._id);
                sound._seek = sound._start || 0;
                sound._rateSeek = 0;
                sound._playStart = Howler1.ctx.currentTime;
                var timeout = (sound._stop - sound._start) * 1000 / Math.abs(sound._rate);
                self._endTimers[sound._id] = setTimeout(self._ended.bind(self, sound), timeout);
            }
            // Mark the node as paused.
            if (self._webAudio && !loop) {
                sound._paused = true;
                sound._ended = true;
                sound._seek = sound._start || 0;
                sound._rateSeek = 0;
                self._clearTimer(sound._id);
                // Clean up the buffer source.
                self._cleanBuffer(sound._node);
                // Attempt to auto-suspend AudioContext if no sounds are still playing.
                Howler1._autoSuspend();
            }
            // When using a sprite, end the track.
            if (!self._webAudio && !loop) self.stop(sound._id, true);
            return self;
        },
        /**
     * Clear the end timer for a sound playback.
     * @param  {Number} id The sound ID.
     * @return {Howl}
     */ _clearTimer: function(id) {
            var self = this;
            if (self._endTimers[id]) {
                // Clear the timeout or remove the ended listener.
                if (typeof self._endTimers[id] !== "function") clearTimeout(self._endTimers[id]);
                else {
                    var sound = self._soundById(id);
                    if (sound && sound._node) sound._node.removeEventListener("ended", self._endTimers[id], false);
                }
                delete self._endTimers[id];
            }
            return self;
        },
        /**
     * Return the sound identified by this ID, or return null.
     * @param  {Number} id Sound ID
     * @return {Object}    Sound object or null.
     */ _soundById: function(id) {
            var self = this;
            // Loop through all sounds and find the one with this ID.
            for(var i = 0; i < self._sounds.length; i++){
                if (id === self._sounds[i]._id) return self._sounds[i];
            }
            return null;
        },
        /**
     * Return an inactive sound from the pool or create a new one.
     * @return {Sound} Sound playback object.
     */ _inactiveSound: function() {
            var self = this;
            self._drain();
            // Find the first inactive node to recycle.
            for(var i = 0; i < self._sounds.length; i++){
                if (self._sounds[i]._ended) return self._sounds[i].reset();
            }
            // If no inactive node was found, create a new one.
            return new Sound1(self);
        },
        /**
     * Drain excess inactive sounds from the pool.
     */ _drain: function() {
            var self = this;
            var limit = self._pool;
            var cnt = 0;
            var i = 0;
            // If there are less sounds than the max pool size, we are done.
            if (self._sounds.length < limit) return;
            // Count the number of inactive sounds.
            for(i = 0; i < self._sounds.length; i++)if (self._sounds[i]._ended) cnt++;
            // Remove excess inactive sounds, going in reverse order.
            for(i = self._sounds.length - 1; i >= 0; i--){
                if (cnt <= limit) return;
                if (self._sounds[i]._ended) {
                    // Disconnect the audio source when using Web Audio.
                    if (self._webAudio && self._sounds[i]._node) self._sounds[i]._node.disconnect(0);
                    // Remove sounds until we have the pool size.
                    self._sounds.splice(i, 1);
                    cnt--;
                }
            }
        },
        /**
     * Get all ID's from the sounds pool.
     * @param  {Number} id Only return one ID if one is passed.
     * @return {Array}    Array of IDs.
     */ _getSoundIds: function(id) {
            var self = this;
            if (typeof id === "undefined") {
                var ids = [];
                for(var i = 0; i < self._sounds.length; i++)ids.push(self._sounds[i]._id);
                return ids;
            } else return [
                id
            ];
        },
        /**
     * Load the sound back into the buffer source.
     * @param  {Sound} sound The sound object to work with.
     * @return {Howl}
     */ _refreshBuffer: function(sound) {
            var self = this;
            // Setup the buffer source for playback.
            sound._node.bufferSource = Howler1.ctx.createBufferSource();
            sound._node.bufferSource.buffer = cache[self._src];
            // Connect to the correct node.
            if (sound._panner) sound._node.bufferSource.connect(sound._panner);
            else sound._node.bufferSource.connect(sound._node);
            // Setup looping and playback rate.
            sound._node.bufferSource.loop = sound._loop;
            if (sound._loop) {
                sound._node.bufferSource.loopStart = sound._start || 0;
                sound._node.bufferSource.loopEnd = sound._stop || 0;
            }
            sound._node.bufferSource.playbackRate.setValueAtTime(sound._rate, Howler1.ctx.currentTime);
            return self;
        },
        /**
     * Prevent memory leaks by cleaning up the buffer source after playback.
     * @param  {Object} node Sound's audio node containing the buffer source.
     * @return {Howl}
     */ _cleanBuffer: function(node) {
            var self = this;
            var isIOS = Howler1._navigator && Howler1._navigator.vendor.indexOf("Apple") >= 0;
            if (Howler1._scratchBuffer && node.bufferSource) {
                node.bufferSource.onended = null;
                node.bufferSource.disconnect(0);
                if (isIOS) try {
                    node.bufferSource.buffer = Howler1._scratchBuffer;
                } catch (e) {}
            }
            node.bufferSource = null;
            return self;
        },
        /**
     * Set the source to a 0-second silence to stop any downloading (except in IE).
     * @param  {Object} node Audio node to clear.
     */ _clearSound: function(node) {
            var checkIE = /MSIE |Trident\//.test(Howler1._navigator && Howler1._navigator.userAgent);
            if (!checkIE) node.src = "data:audio/wav;base64,UklGRigAAABXQVZFZm10IBIAAAABAAEARKwAAIhYAQACABAAAABkYXRhAgAAAAEA";
        }
    };
    /** Single Sound Methods **/ /***************************************************************************/ /**
   * Setup the sound object, which each node attached to a Howl group is contained in.
   * @param {Object} howl The Howl parent group.
   */ var Sound1 = function(howl) {
        this._parent = howl;
        this.init();
    };
    Sound1.prototype = {
        /**
     * Initialize a new Sound object.
     * @return {Sound}
     */ init: function() {
            var self = this;
            var parent = self._parent;
            // Setup the default parameters.
            self._muted = parent._muted;
            self._loop = parent._loop;
            self._volume = parent._volume;
            self._rate = parent._rate;
            self._seek = 0;
            self._paused = true;
            self._ended = true;
            self._sprite = "__default";
            // Generate a unique ID for this sound.
            self._id = ++Howler1._counter;
            // Add itself to the parent's pool.
            parent._sounds.push(self);
            // Create the new node.
            self.create();
            return self;
        },
        /**
     * Create and setup a new sound object, whether HTML5 Audio or Web Audio.
     * @return {Sound}
     */ create: function() {
            var self = this;
            var parent = self._parent;
            var volume = Howler1._muted || self._muted || self._parent._muted ? 0 : self._volume;
            if (parent._webAudio) {
                // Create the gain node for controlling volume (the source will connect to this).
                self._node = typeof Howler1.ctx.createGain === "undefined" ? Howler1.ctx.createGainNode() : Howler1.ctx.createGain();
                self._node.gain.setValueAtTime(volume, Howler1.ctx.currentTime);
                self._node.paused = true;
                self._node.connect(Howler1.masterGain);
            } else if (!Howler1.noAudio) {
                // Get an unlocked Audio object from the pool.
                self._node = Howler1._obtainHtml5Audio();
                // Listen for errors (http://dev.w3.org/html5/spec-author-view/spec.html#mediaerror).
                self._errorFn = self._errorListener.bind(self);
                self._node.addEventListener("error", self._errorFn, false);
                // Listen for 'canplaythrough' event to let us know the sound is ready.
                self._loadFn = self._loadListener.bind(self);
                self._node.addEventListener(Howler1._canPlayEvent, self._loadFn, false);
                // Listen for the 'ended' event on the sound to account for edge-case where
                // a finite sound has a duration of Infinity.
                self._endFn = self._endListener.bind(self);
                self._node.addEventListener("ended", self._endFn, false);
                // Setup the new audio node.
                self._node.src = parent._src;
                self._node.preload = parent._preload === true ? "auto" : parent._preload;
                self._node.volume = volume * Howler1.volume();
                // Begin loading the source.
                self._node.load();
            }
            return self;
        },
        /**
     * Reset the parameters of this sound to the original state (for recycle).
     * @return {Sound}
     */ reset: function() {
            var self = this;
            var parent = self._parent;
            // Reset all of the parameters of this sound.
            self._muted = parent._muted;
            self._loop = parent._loop;
            self._volume = parent._volume;
            self._rate = parent._rate;
            self._seek = 0;
            self._rateSeek = 0;
            self._paused = true;
            self._ended = true;
            self._sprite = "__default";
            // Generate a new ID so that it isn't confused with the previous sound.
            self._id = ++Howler1._counter;
            return self;
        },
        /**
     * HTML5 Audio error listener callback.
     */ _errorListener: function() {
            var self = this;
            // Fire an error event and pass back the code.
            self._parent._emit("loaderror", self._id, self._node.error ? self._node.error.code : 0);
            // Clear the event listener.
            self._node.removeEventListener("error", self._errorFn, false);
        },
        /**
     * HTML5 Audio canplaythrough listener callback.
     */ _loadListener: function() {
            var self = this;
            var parent = self._parent;
            // Round up the duration to account for the lower precision in HTML5 Audio.
            parent._duration = Math.ceil(self._node.duration * 10) / 10;
            // Setup a sprite if none is defined.
            if (Object.keys(parent._sprite).length === 0) parent._sprite = {
                __default: [
                    0,
                    parent._duration * 1000
                ]
            };
            if (parent._state !== "loaded") {
                parent._state = "loaded";
                parent._emit("load");
                parent._loadQueue();
            }
            // Clear the event listener.
            self._node.removeEventListener(Howler1._canPlayEvent, self._loadFn, false);
        },
        /**
     * HTML5 Audio ended listener callback.
     */ _endListener: function() {
            var self = this;
            var parent = self._parent;
            // Only handle the `ended`` event if the duration is Infinity.
            if (parent._duration === Infinity) {
                // Update the parent duration to match the real audio duration.
                // Round up the duration to account for the lower precision in HTML5 Audio.
                parent._duration = Math.ceil(self._node.duration * 10) / 10;
                // Update the sprite that corresponds to the real duration.
                if (parent._sprite.__default[1] === Infinity) parent._sprite.__default[1] = parent._duration * 1000;
                // Run the regular ended method.
                parent._ended(self);
            }
            // Clear the event listener since the duration is now correct.
            self._node.removeEventListener("ended", self._endFn, false);
        }
    };
    /** Helper Methods **/ /***************************************************************************/ var cache = {};
    /**
   * Buffer a sound from URL, Data URI or cache and decode to audio source (Web Audio API).
   * @param  {Howl} self
   */ var loadBuffer = function(self) {
        var url = self._src;
        // Check if the buffer has already been cached and use it instead.
        if (cache[url]) {
            // Set the duration from the cache.
            self._duration = cache[url].duration;
            // Load the sound into this Howl.
            loadSound(self);
            return;
        }
        if (/^data:[^;]+;base64,/.test(url)) {
            // Decode the base64 data URI without XHR, since some browsers don't support it.
            var data = atob(url.split(",")[1]);
            var dataView = new Uint8Array(data.length);
            for(var i = 0; i < data.length; ++i)dataView[i] = data.charCodeAt(i);
            decodeAudioData(dataView.buffer, self);
        } else {
            // Load the buffer from the URL.
            var xhr = new XMLHttpRequest();
            xhr.open(self._xhr.method, url, true);
            xhr.withCredentials = self._xhr.withCredentials;
            xhr.responseType = "arraybuffer";
            // Apply any custom headers to the request.
            if (self._xhr.headers) Object.keys(self._xhr.headers).forEach(function(key) {
                xhr.setRequestHeader(key, self._xhr.headers[key]);
            });
            xhr.onload = function() {
                // Make sure we get a successful response back.
                var code = (xhr.status + "")[0];
                if (code !== "0" && code !== "2" && code !== "3") {
                    self._emit("loaderror", null, "Failed loading audio file with status: " + xhr.status + ".");
                    return;
                }
                decodeAudioData(xhr.response, self);
            };
            xhr.onerror = function() {
                // If there is an error, switch to HTML5 Audio.
                if (self._webAudio) {
                    self._html5 = true;
                    self._webAudio = false;
                    self._sounds = [];
                    delete cache[url];
                    self.load();
                }
            };
            safeXhrSend(xhr);
        }
    };
    /**
   * Send the XHR request wrapped in a try/catch.
   * @param  {Object} xhr XHR to send.
   */ var safeXhrSend = function(xhr) {
        try {
            xhr.send();
        } catch (e) {
            xhr.onerror();
        }
    };
    /**
   * Decode audio data from an array buffer.
   * @param  {ArrayBuffer} arraybuffer The audio data.
   * @param  {Howl}        self
   */ var decodeAudioData = function(arraybuffer, self) {
        // Fire a load error if something broke.
        var error = function() {
            self._emit("loaderror", null, "Decoding audio data failed.");
        };
        // Load the sound on success.
        var success = function(buffer) {
            if (buffer && self._sounds.length > 0) {
                cache[self._src] = buffer;
                loadSound(self, buffer);
            } else error();
        };
        // Decode the buffer into an audio source.
        if (typeof Promise !== "undefined" && Howler1.ctx.decodeAudioData.length === 1) Howler1.ctx.decodeAudioData(arraybuffer).then(success).catch(error);
        else Howler1.ctx.decodeAudioData(arraybuffer, success, error);
    };
    /**
   * Sound is now loaded, so finish setting everything up and fire the loaded event.
   * @param  {Howl} self
   * @param  {Object} buffer The decoded buffer sound source.
   */ var loadSound = function(self, buffer) {
        // Set the duration.
        if (buffer && !self._duration) self._duration = buffer.duration;
        // Setup a sprite if none is defined.
        if (Object.keys(self._sprite).length === 0) self._sprite = {
            __default: [
                0,
                self._duration * 1000
            ]
        };
        // Fire the loaded event.
        if (self._state !== "loaded") {
            self._state = "loaded";
            self._emit("load");
            self._loadQueue();
        }
    };
    /**
   * Setup the audio context when available, or switch to HTML5 Audio mode.
   */ var setupAudioContext = function() {
        // If we have already detected that Web Audio isn't supported, don't run this step again.
        if (!Howler1.usingWebAudio) return;
        // Check if we are using Web Audio and setup the AudioContext if we are.
        try {
            if (typeof AudioContext !== "undefined") Howler1.ctx = new AudioContext();
            else if (typeof webkitAudioContext !== "undefined") Howler1.ctx = new webkitAudioContext();
            else Howler1.usingWebAudio = false;
        } catch (e) {
            Howler1.usingWebAudio = false;
        }
        // If the audio context creation still failed, set using web audio to false.
        if (!Howler1.ctx) Howler1.usingWebAudio = false;
        // Check if a webview is being used on iOS8 or earlier (rather than the browser).
        // If it is, disable Web Audio as it causes crashing.
        var iOS = /iP(hone|od|ad)/.test(Howler1._navigator && Howler1._navigator.platform);
        var appVersion = Howler1._navigator && Howler1._navigator.appVersion.match(/OS (\d+)_(\d+)_?(\d+)?/);
        var version = appVersion ? parseInt(appVersion[1], 10) : null;
        if (iOS && version && version < 9) {
            var safari = /safari/.test(Howler1._navigator && Howler1._navigator.userAgent.toLowerCase());
            if (Howler1._navigator && !safari) Howler1.usingWebAudio = false;
        }
        // Create and expose the master GainNode when using Web Audio (useful for plugins or advanced usage).
        if (Howler1.usingWebAudio) {
            Howler1.masterGain = typeof Howler1.ctx.createGain === "undefined" ? Howler1.ctx.createGainNode() : Howler1.ctx.createGain();
            Howler1.masterGain.gain.setValueAtTime(Howler1._muted ? 0 : Howler1._volume, Howler1.ctx.currentTime);
            Howler1.masterGain.connect(Howler1.ctx.destination);
        }
        // Re-run the setup on Howler.
        Howler1._setup();
    };
    // Add support for AMD (Asynchronous Module Definition) libraries such as require.js.
    if (typeof define === "function" && define.amd) define([], function() {
        return {
            Howler: Howler1,
            Howl: Howl1
        };
    });
    $ba2b935f1363d9c5$export$c9d39ca3bcd93abb = Howler1;
    $ba2b935f1363d9c5$export$b791fe48eec8032a = Howl1;
    // Add to global in Node.js (for testing, etc).
    if (typeof $parcel$global !== "undefined") {
        $parcel$global.HowlerGlobal = HowlerGlobal1;
        $parcel$global.Howler = Howler1;
        $parcel$global.Howl = Howl1;
        $parcel$global.Sound = Sound1;
    } else if (typeof window !== "undefined") {
        window.HowlerGlobal = HowlerGlobal1;
        window.Howler = Howler1;
        window.Howl = Howl1;
        window.Sound = Sound1;
    }
})();
/*!
 *  Spatial Plugin - Adds support for stereo and 3D audio where Web Audio is supported.
 *  
 *  howler.js v2.2.3
 *  howlerjs.com
 *
 *  (c) 2013-2020, James Simpson of GoldFire Studios
 *  goldfirestudios.com
 *
 *  MIT License
 */ (function() {
    "use strict";
    // Setup default properties.
    HowlerGlobal.prototype._pos = [
        0,
        0,
        0
    ];
    HowlerGlobal.prototype._orientation = [
        0,
        0,
        -1,
        0,
        1,
        0
    ];
    /** Global Methods **/ /***************************************************************************/ /**
   * Helper method to update the stereo panning position of all current Howls.
   * Future Howls will not use this value unless explicitly set.
   * @param  {Number} pan A value of -1.0 is all the way left and 1.0 is all the way right.
   * @return {Howler/Number}     Self or current stereo panning value.
   */ HowlerGlobal.prototype.stereo = function(pan) {
        var self = this;
        // Stop right here if not using Web Audio.
        if (!self.ctx || !self.ctx.listener) return self;
        // Loop through all Howls and update their stereo panning.
        for(var i = self._howls.length - 1; i >= 0; i--)self._howls[i].stereo(pan);
        return self;
    };
    /**
   * Get/set the position of the listener in 3D cartesian space. Sounds using
   * 3D position will be relative to the listener's position.
   * @param  {Number} x The x-position of the listener.
   * @param  {Number} y The y-position of the listener.
   * @param  {Number} z The z-position of the listener.
   * @return {Howler/Array}   Self or current listener position.
   */ HowlerGlobal.prototype.pos = function(x, y, z) {
        var self = this;
        // Stop right here if not using Web Audio.
        if (!self.ctx || !self.ctx.listener) return self;
        // Set the defaults for optional 'y' & 'z'.
        y = typeof y !== "number" ? self._pos[1] : y;
        z = typeof z !== "number" ? self._pos[2] : z;
        if (typeof x === "number") {
            self._pos = [
                x,
                y,
                z
            ];
            if (typeof self.ctx.listener.positionX !== "undefined") {
                self.ctx.listener.positionX.setTargetAtTime(self._pos[0], Howler.ctx.currentTime, 0.1);
                self.ctx.listener.positionY.setTargetAtTime(self._pos[1], Howler.ctx.currentTime, 0.1);
                self.ctx.listener.positionZ.setTargetAtTime(self._pos[2], Howler.ctx.currentTime, 0.1);
            } else self.ctx.listener.setPosition(self._pos[0], self._pos[1], self._pos[2]);
        } else return self._pos;
        return self;
    };
    /**
   * Get/set the direction the listener is pointing in the 3D cartesian space.
   * A front and up vector must be provided. The front is the direction the
   * face of the listener is pointing, and up is the direction the top of the
   * listener is pointing. Thus, these values are expected to be at right angles
   * from each other.
   * @param  {Number} x   The x-orientation of the listener.
   * @param  {Number} y   The y-orientation of the listener.
   * @param  {Number} z   The z-orientation of the listener.
   * @param  {Number} xUp The x-orientation of the top of the listener.
   * @param  {Number} yUp The y-orientation of the top of the listener.
   * @param  {Number} zUp The z-orientation of the top of the listener.
   * @return {Howler/Array}     Returns self or the current orientation vectors.
   */ HowlerGlobal.prototype.orientation = function(x, y, z, xUp, yUp, zUp) {
        var self = this;
        // Stop right here if not using Web Audio.
        if (!self.ctx || !self.ctx.listener) return self;
        // Set the defaults for optional 'y' & 'z'.
        var or = self._orientation;
        y = typeof y !== "number" ? or[1] : y;
        z = typeof z !== "number" ? or[2] : z;
        xUp = typeof xUp !== "number" ? or[3] : xUp;
        yUp = typeof yUp !== "number" ? or[4] : yUp;
        zUp = typeof zUp !== "number" ? or[5] : zUp;
        if (typeof x === "number") {
            self._orientation = [
                x,
                y,
                z,
                xUp,
                yUp,
                zUp
            ];
            if (typeof self.ctx.listener.forwardX !== "undefined") {
                self.ctx.listener.forwardX.setTargetAtTime(x, Howler.ctx.currentTime, 0.1);
                self.ctx.listener.forwardY.setTargetAtTime(y, Howler.ctx.currentTime, 0.1);
                self.ctx.listener.forwardZ.setTargetAtTime(z, Howler.ctx.currentTime, 0.1);
                self.ctx.listener.upX.setTargetAtTime(xUp, Howler.ctx.currentTime, 0.1);
                self.ctx.listener.upY.setTargetAtTime(yUp, Howler.ctx.currentTime, 0.1);
                self.ctx.listener.upZ.setTargetAtTime(zUp, Howler.ctx.currentTime, 0.1);
            } else self.ctx.listener.setOrientation(x, y, z, xUp, yUp, zUp);
        } else return or;
        return self;
    };
    /** Group Methods **/ /***************************************************************************/ /**
   * Add new properties to the core init.
   * @param  {Function} _super Core init method.
   * @return {Howl}
   */ Howl.prototype.init = function(_super) {
        return function(o) {
            var self = this;
            // Setup user-defined default properties.
            self._orientation = o.orientation || [
                1,
                0,
                0
            ];
            self._stereo = o.stereo || null;
            self._pos = o.pos || null;
            self._pannerAttr = {
                coneInnerAngle: typeof o.coneInnerAngle !== "undefined" ? o.coneInnerAngle : 360,
                coneOuterAngle: typeof o.coneOuterAngle !== "undefined" ? o.coneOuterAngle : 360,
                coneOuterGain: typeof o.coneOuterGain !== "undefined" ? o.coneOuterGain : 0,
                distanceModel: typeof o.distanceModel !== "undefined" ? o.distanceModel : "inverse",
                maxDistance: typeof o.maxDistance !== "undefined" ? o.maxDistance : 10000,
                panningModel: typeof o.panningModel !== "undefined" ? o.panningModel : "HRTF",
                refDistance: typeof o.refDistance !== "undefined" ? o.refDistance : 1,
                rolloffFactor: typeof o.rolloffFactor !== "undefined" ? o.rolloffFactor : 1
            };
            // Setup event listeners.
            self._onstereo = o.onstereo ? [
                {
                    fn: o.onstereo
                }
            ] : [];
            self._onpos = o.onpos ? [
                {
                    fn: o.onpos
                }
            ] : [];
            self._onorientation = o.onorientation ? [
                {
                    fn: o.onorientation
                }
            ] : [];
            // Complete initilization with howler.js core's init function.
            return _super.call(this, o);
        };
    }(Howl.prototype.init);
    /**
   * Get/set the stereo panning of the audio source for this sound or all in the group.
   * @param  {Number} pan  A value of -1.0 is all the way left and 1.0 is all the way right.
   * @param  {Number} id (optional) The sound ID. If none is passed, all in group will be updated.
   * @return {Howl/Number}    Returns self or the current stereo panning value.
   */ Howl.prototype.stereo = function(pan, id) {
        var self = this;
        // Stop right here if not using Web Audio.
        if (!self._webAudio) return self;
        // If the sound hasn't loaded, add it to the load queue to change stereo pan when capable.
        if (self._state !== "loaded") {
            self._queue.push({
                event: "stereo",
                action: function() {
                    self.stereo(pan, id);
                }
            });
            return self;
        }
        // Check for PannerStereoNode support and fallback to PannerNode if it doesn't exist.
        var pannerType = typeof Howler.ctx.createStereoPanner === "undefined" ? "spatial" : "stereo";
        // Setup the group's stereo panning if no ID is passed.
        if (typeof id === "undefined") {
            // Return the group's stereo panning if no parameters are passed.
            if (typeof pan === "number") {
                self._stereo = pan;
                self._pos = [
                    pan,
                    0,
                    0
                ];
            } else return self._stereo;
        }
        // Change the streo panning of one or all sounds in group.
        var ids = self._getSoundIds(id);
        for(var i = 0; i < ids.length; i++){
            // Get the sound.
            var sound = self._soundById(ids[i]);
            if (sound) {
                if (typeof pan === "number") {
                    sound._stereo = pan;
                    sound._pos = [
                        pan,
                        0,
                        0
                    ];
                    if (sound._node) {
                        // If we are falling back, make sure the panningModel is equalpower.
                        sound._pannerAttr.panningModel = "equalpower";
                        // Check if there is a panner setup and create a new one if not.
                        if (!sound._panner || !sound._panner.pan) setupPanner(sound, pannerType);
                        if (pannerType === "spatial") {
                            if (typeof sound._panner.positionX !== "undefined") {
                                sound._panner.positionX.setValueAtTime(pan, Howler.ctx.currentTime);
                                sound._panner.positionY.setValueAtTime(0, Howler.ctx.currentTime);
                                sound._panner.positionZ.setValueAtTime(0, Howler.ctx.currentTime);
                            } else sound._panner.setPosition(pan, 0, 0);
                        } else sound._panner.pan.setValueAtTime(pan, Howler.ctx.currentTime);
                    }
                    self._emit("stereo", sound._id);
                } else return sound._stereo;
            }
        }
        return self;
    };
    /**
   * Get/set the 3D spatial position of the audio source for this sound or group relative to the global listener.
   * @param  {Number} x  The x-position of the audio source.
   * @param  {Number} y  The y-position of the audio source.
   * @param  {Number} z  The z-position of the audio source.
   * @param  {Number} id (optional) The sound ID. If none is passed, all in group will be updated.
   * @return {Howl/Array}    Returns self or the current 3D spatial position: [x, y, z].
   */ Howl.prototype.pos = function(x, y, z, id) {
        var self = this;
        // Stop right here if not using Web Audio.
        if (!self._webAudio) return self;
        // If the sound hasn't loaded, add it to the load queue to change position when capable.
        if (self._state !== "loaded") {
            self._queue.push({
                event: "pos",
                action: function() {
                    self.pos(x, y, z, id);
                }
            });
            return self;
        }
        // Set the defaults for optional 'y' & 'z'.
        y = typeof y !== "number" ? 0 : y;
        z = typeof z !== "number" ? -0.5 : z;
        // Setup the group's spatial position if no ID is passed.
        if (typeof id === "undefined") {
            // Return the group's spatial position if no parameters are passed.
            if (typeof x === "number") self._pos = [
                x,
                y,
                z
            ];
            else return self._pos;
        }
        // Change the spatial position of one or all sounds in group.
        var ids = self._getSoundIds(id);
        for(var i = 0; i < ids.length; i++){
            // Get the sound.
            var sound = self._soundById(ids[i]);
            if (sound) {
                if (typeof x === "number") {
                    sound._pos = [
                        x,
                        y,
                        z
                    ];
                    if (sound._node) {
                        // Check if there is a panner setup and create a new one if not.
                        if (!sound._panner || sound._panner.pan) setupPanner(sound, "spatial");
                        if (typeof sound._panner.positionX !== "undefined") {
                            sound._panner.positionX.setValueAtTime(x, Howler.ctx.currentTime);
                            sound._panner.positionY.setValueAtTime(y, Howler.ctx.currentTime);
                            sound._panner.positionZ.setValueAtTime(z, Howler.ctx.currentTime);
                        } else sound._panner.setPosition(x, y, z);
                    }
                    self._emit("pos", sound._id);
                } else return sound._pos;
            }
        }
        return self;
    };
    /**
   * Get/set the direction the audio source is pointing in the 3D cartesian coordinate
   * space. Depending on how direction the sound is, based on the `cone` attributes,
   * a sound pointing away from the listener can be quiet or silent.
   * @param  {Number} x  The x-orientation of the source.
   * @param  {Number} y  The y-orientation of the source.
   * @param  {Number} z  The z-orientation of the source.
   * @param  {Number} id (optional) The sound ID. If none is passed, all in group will be updated.
   * @return {Howl/Array}    Returns self or the current 3D spatial orientation: [x, y, z].
   */ Howl.prototype.orientation = function(x, y, z, id) {
        var self = this;
        // Stop right here if not using Web Audio.
        if (!self._webAudio) return self;
        // If the sound hasn't loaded, add it to the load queue to change orientation when capable.
        if (self._state !== "loaded") {
            self._queue.push({
                event: "orientation",
                action: function() {
                    self.orientation(x, y, z, id);
                }
            });
            return self;
        }
        // Set the defaults for optional 'y' & 'z'.
        y = typeof y !== "number" ? self._orientation[1] : y;
        z = typeof z !== "number" ? self._orientation[2] : z;
        // Setup the group's spatial orientation if no ID is passed.
        if (typeof id === "undefined") {
            // Return the group's spatial orientation if no parameters are passed.
            if (typeof x === "number") self._orientation = [
                x,
                y,
                z
            ];
            else return self._orientation;
        }
        // Change the spatial orientation of one or all sounds in group.
        var ids = self._getSoundIds(id);
        for(var i = 0; i < ids.length; i++){
            // Get the sound.
            var sound = self._soundById(ids[i]);
            if (sound) {
                if (typeof x === "number") {
                    sound._orientation = [
                        x,
                        y,
                        z
                    ];
                    if (sound._node) {
                        // Check if there is a panner setup and create a new one if not.
                        if (!sound._panner) {
                            // Make sure we have a position to setup the node with.
                            if (!sound._pos) sound._pos = self._pos || [
                                0,
                                0,
                                -0.5
                            ];
                            setupPanner(sound, "spatial");
                        }
                        if (typeof sound._panner.orientationX !== "undefined") {
                            sound._panner.orientationX.setValueAtTime(x, Howler.ctx.currentTime);
                            sound._panner.orientationY.setValueAtTime(y, Howler.ctx.currentTime);
                            sound._panner.orientationZ.setValueAtTime(z, Howler.ctx.currentTime);
                        } else sound._panner.setOrientation(x, y, z);
                    }
                    self._emit("orientation", sound._id);
                } else return sound._orientation;
            }
        }
        return self;
    };
    /**
   * Get/set the panner node's attributes for a sound or group of sounds.
   * This method can optionall take 0, 1 or 2 arguments.
   *   pannerAttr() -> Returns the group's values.
   *   pannerAttr(id) -> Returns the sound id's values.
   *   pannerAttr(o) -> Set's the values of all sounds in this Howl group.
   *   pannerAttr(o, id) -> Set's the values of passed sound id.
   *
   *   Attributes:
   *     coneInnerAngle - (360 by default) A parameter for directional audio sources, this is an angle, in degrees,
   *                      inside of which there will be no volume reduction.
   *     coneOuterAngle - (360 by default) A parameter for directional audio sources, this is an angle, in degrees,
   *                      outside of which the volume will be reduced to a constant value of `coneOuterGain`.
   *     coneOuterGain - (0 by default) A parameter for directional audio sources, this is the gain outside of the
   *                     `coneOuterAngle`. It is a linear value in the range `[0, 1]`.
   *     distanceModel - ('inverse' by default) Determines algorithm used to reduce volume as audio moves away from
   *                     listener. Can be `linear`, `inverse` or `exponential.
   *     maxDistance - (10000 by default) The maximum distance between source and listener, after which the volume
   *                   will not be reduced any further.
   *     refDistance - (1 by default) A reference distance for reducing volume as source moves further from the listener.
   *                   This is simply a variable of the distance model and has a different effect depending on which model
   *                   is used and the scale of your coordinates. Generally, volume will be equal to 1 at this distance.
   *     rolloffFactor - (1 by default) How quickly the volume reduces as source moves from listener. This is simply a
   *                     variable of the distance model and can be in the range of `[0, 1]` with `linear` and `[0, ∞]`
   *                     with `inverse` and `exponential`.
   *     panningModel - ('HRTF' by default) Determines which spatialization algorithm is used to position audio.
   *                     Can be `HRTF` or `equalpower`.
   *
   * @return {Howl/Object} Returns self or current panner attributes.
   */ Howl.prototype.pannerAttr = function() {
        var self = this;
        var args = arguments;
        var o, id, sound;
        // Stop right here if not using Web Audio.
        if (!self._webAudio) return self;
        // Determine the values based on arguments.
        if (args.length === 0) // Return the group's panner attribute values.
        return self._pannerAttr;
        else if (args.length === 1) {
            if (typeof args[0] === "object") {
                o = args[0];
                // Set the grou's panner attribute values.
                if (typeof id === "undefined") {
                    if (!o.pannerAttr) o.pannerAttr = {
                        coneInnerAngle: o.coneInnerAngle,
                        coneOuterAngle: o.coneOuterAngle,
                        coneOuterGain: o.coneOuterGain,
                        distanceModel: o.distanceModel,
                        maxDistance: o.maxDistance,
                        refDistance: o.refDistance,
                        rolloffFactor: o.rolloffFactor,
                        panningModel: o.panningModel
                    };
                    self._pannerAttr = {
                        coneInnerAngle: typeof o.pannerAttr.coneInnerAngle !== "undefined" ? o.pannerAttr.coneInnerAngle : self._coneInnerAngle,
                        coneOuterAngle: typeof o.pannerAttr.coneOuterAngle !== "undefined" ? o.pannerAttr.coneOuterAngle : self._coneOuterAngle,
                        coneOuterGain: typeof o.pannerAttr.coneOuterGain !== "undefined" ? o.pannerAttr.coneOuterGain : self._coneOuterGain,
                        distanceModel: typeof o.pannerAttr.distanceModel !== "undefined" ? o.pannerAttr.distanceModel : self._distanceModel,
                        maxDistance: typeof o.pannerAttr.maxDistance !== "undefined" ? o.pannerAttr.maxDistance : self._maxDistance,
                        refDistance: typeof o.pannerAttr.refDistance !== "undefined" ? o.pannerAttr.refDistance : self._refDistance,
                        rolloffFactor: typeof o.pannerAttr.rolloffFactor !== "undefined" ? o.pannerAttr.rolloffFactor : self._rolloffFactor,
                        panningModel: typeof o.pannerAttr.panningModel !== "undefined" ? o.pannerAttr.panningModel : self._panningModel
                    };
                }
            } else {
                // Return this sound's panner attribute values.
                sound = self._soundById(parseInt(args[0], 10));
                return sound ? sound._pannerAttr : self._pannerAttr;
            }
        } else if (args.length === 2) {
            o = args[0];
            id = parseInt(args[1], 10);
        }
        // Update the values of the specified sounds.
        var ids = self._getSoundIds(id);
        for(var i = 0; i < ids.length; i++){
            sound = self._soundById(ids[i]);
            if (sound) {
                // Merge the new values into the sound.
                var pa = sound._pannerAttr;
                pa = {
                    coneInnerAngle: typeof o.coneInnerAngle !== "undefined" ? o.coneInnerAngle : pa.coneInnerAngle,
                    coneOuterAngle: typeof o.coneOuterAngle !== "undefined" ? o.coneOuterAngle : pa.coneOuterAngle,
                    coneOuterGain: typeof o.coneOuterGain !== "undefined" ? o.coneOuterGain : pa.coneOuterGain,
                    distanceModel: typeof o.distanceModel !== "undefined" ? o.distanceModel : pa.distanceModel,
                    maxDistance: typeof o.maxDistance !== "undefined" ? o.maxDistance : pa.maxDistance,
                    refDistance: typeof o.refDistance !== "undefined" ? o.refDistance : pa.refDistance,
                    rolloffFactor: typeof o.rolloffFactor !== "undefined" ? o.rolloffFactor : pa.rolloffFactor,
                    panningModel: typeof o.panningModel !== "undefined" ? o.panningModel : pa.panningModel
                };
                // Update the panner values or create a new panner if none exists.
                var panner = sound._panner;
                if (panner) {
                    panner.coneInnerAngle = pa.coneInnerAngle;
                    panner.coneOuterAngle = pa.coneOuterAngle;
                    panner.coneOuterGain = pa.coneOuterGain;
                    panner.distanceModel = pa.distanceModel;
                    panner.maxDistance = pa.maxDistance;
                    panner.refDistance = pa.refDistance;
                    panner.rolloffFactor = pa.rolloffFactor;
                    panner.panningModel = pa.panningModel;
                } else {
                    // Make sure we have a position to setup the node with.
                    if (!sound._pos) sound._pos = self._pos || [
                        0,
                        0,
                        -0.5
                    ];
                    // Create a new panner node.
                    setupPanner(sound, "spatial");
                }
            }
        }
        return self;
    };
    /** Single Sound Methods **/ /***************************************************************************/ /**
   * Add new properties to the core Sound init.
   * @param  {Function} _super Core Sound init method.
   * @return {Sound}
   */ Sound.prototype.init = function(_super) {
        return function() {
            var self = this;
            var parent = self._parent;
            // Setup user-defined default properties.
            self._orientation = parent._orientation;
            self._stereo = parent._stereo;
            self._pos = parent._pos;
            self._pannerAttr = parent._pannerAttr;
            // Complete initilization with howler.js core Sound's init function.
            _super.call(this);
            // If a stereo or position was specified, set it up.
            if (self._stereo) parent.stereo(self._stereo);
            else if (self._pos) parent.pos(self._pos[0], self._pos[1], self._pos[2], self._id);
        };
    }(Sound.prototype.init);
    /**
   * Override the Sound.reset method to clean up properties from the spatial plugin.
   * @param  {Function} _super Sound reset method.
   * @return {Sound}
   */ Sound.prototype.reset = function(_super) {
        return function() {
            var self = this;
            var parent = self._parent;
            // Reset all spatial plugin properties on this sound.
            self._orientation = parent._orientation;
            self._stereo = parent._stereo;
            self._pos = parent._pos;
            self._pannerAttr = parent._pannerAttr;
            // If a stereo or position was specified, set it up.
            if (self._stereo) parent.stereo(self._stereo);
            else if (self._pos) parent.pos(self._pos[0], self._pos[1], self._pos[2], self._id);
            else if (self._panner) {
                // Disconnect the panner.
                self._panner.disconnect(0);
                self._panner = undefined;
                parent._refreshBuffer(self);
            }
            // Complete resetting of the sound.
            return _super.call(this);
        };
    }(Sound.prototype.reset);
    /** Helper Methods **/ /***************************************************************************/ /**
   * Create a new panner node and save it on the sound.
   * @param  {Sound} sound Specific sound to setup panning on.
   * @param {String} type Type of panner to create: 'stereo' or 'spatial'.
   */ var setupPanner = function(sound, type) {
        type = type || "spatial";
        // Create the new panner node.
        if (type === "spatial") {
            sound._panner = Howler.ctx.createPanner();
            sound._panner.coneInnerAngle = sound._pannerAttr.coneInnerAngle;
            sound._panner.coneOuterAngle = sound._pannerAttr.coneOuterAngle;
            sound._panner.coneOuterGain = sound._pannerAttr.coneOuterGain;
            sound._panner.distanceModel = sound._pannerAttr.distanceModel;
            sound._panner.maxDistance = sound._pannerAttr.maxDistance;
            sound._panner.refDistance = sound._pannerAttr.refDistance;
            sound._panner.rolloffFactor = sound._pannerAttr.rolloffFactor;
            sound._panner.panningModel = sound._pannerAttr.panningModel;
            if (typeof sound._panner.positionX !== "undefined") {
                sound._panner.positionX.setValueAtTime(sound._pos[0], Howler.ctx.currentTime);
                sound._panner.positionY.setValueAtTime(sound._pos[1], Howler.ctx.currentTime);
                sound._panner.positionZ.setValueAtTime(sound._pos[2], Howler.ctx.currentTime);
            } else sound._panner.setPosition(sound._pos[0], sound._pos[1], sound._pos[2]);
            if (typeof sound._panner.orientationX !== "undefined") {
                sound._panner.orientationX.setValueAtTime(sound._orientation[0], Howler.ctx.currentTime);
                sound._panner.orientationY.setValueAtTime(sound._orientation[1], Howler.ctx.currentTime);
                sound._panner.orientationZ.setValueAtTime(sound._orientation[2], Howler.ctx.currentTime);
            } else sound._panner.setOrientation(sound._orientation[0], sound._orientation[1], sound._orientation[2]);
        } else {
            sound._panner = Howler.ctx.createStereoPanner();
            sound._panner.pan.setValueAtTime(sound._stereo, Howler.ctx.currentTime);
        }
        sound._panner.connect(sound._node);
        // Update the connections.
        if (!sound._paused) sound._parent.pause(sound._id, true).play(sound._id, true);
    };
})();



const $d5e82d35428c4a6c$var$audioEventToFileNameMapping = {
    Jump: {
        files: [
            "Jump-001",
            "Jump-002",
            "Jump-003",
            "Jump-004"
        ],
        volume: 1
    },
    Oof: {
        files: [
            "Oof1",
            "Oof2",
            "Oof3",
            "Oof4",
            "Oof5",
            "Oof6"
        ],
        volume: 3.6
    },
    Run: {
        files: [
            "Run-001",
            "Run-002",
            "Run-003",
            "Run-004",
            "Run-005",
            "Run-006",
            "Run-007"
        ],
        volume: 1
    },
    DeathBlock: {
        files: [
            "deathBlock"
        ],
        volume: 1
    },
    MovingBlock: {
        files: [
            "movingBlock"
        ],
        volume: 1
    },
    UI_Accept: {
        files: [
            "UI-Accept"
        ],
        volume: 1
    },
    UI_Decline: {
        files: [
            "UI-Decline"
        ],
        volume: 1
    },
    UI_Up: {
        files: [
            "UI-Up"
        ],
        volume: 1
    },
    UI_Down: {
        files: [
            "UI-Down"
        ],
        volume: 1
    },
    Start: {
        files: [
            "Start"
        ],
        volume: 1
    },
    Finish: {
        files: [
            "Finish"
        ],
        volume: 1
    },
    Checkpoint: {
        files: [
            "Checkpoint"
        ],
        volume: 1
    },
    Bounce: {
        files: [
            "Bounce"
        ],
        volume: 3.5
    }
};
class $d5e82d35428c4a6c$export$7ca1f1b308f02e08 extends (0, $fc7b18e354612676$export$5d53140180d567a1) {
    getSystemName() {
        return "Audio";
    }
    _loadHowl(fileName, volume) {
        const howl = new (0, $ba2b935f1363d9c5$export$b791fe48eec8032a)({
            src: [
                /*`audio/webm/UpTogether_${fileName}.webm`,*/ `audio/mp3/UpTogether_${fileName}.mp3`
            ],
            volume: volume // Set the volume for the Howl instance.
        });
        howl.on("loaderror", (id, error)=>{
            throw new Error(`Error loading audio file ${fileName}: ${error}!`);
        });
        return howl;
    }
    _initBackgroundMusic() {
        if (!this.musicShouldBePlaying) return;
        const soundName = "MusicLoop_Master";
        this.musicHowl = this._loadHowl(soundName, this.musicVolume);
        this.musicHowl.on("load", ()=>{
            this.musicHowl?.volume(this.MusicMuted ? 0 : this.musicVolume);
            this.musicHowl?.loop(true);
            this.musicHowl?.play();
        // this.activeSounds.push(soundName);
        });
    }
    ToggleMusicMute() {
        this.MusicMuted = !this.MusicMuted;
        Game.UI.SetMusicMuteButtonState(this.MusicMuted);
        if (this.MusicMuted) this.musicHowl?.volume(0);
        else this.musicHowl?.volume(this.musicVolume);
        (0, $f6601dd412e992e3$export$1b8cd2d0ef9a8e5d)((0, $f6601dd412e992e3$export$c02c1f4c11d08446).MusicMuted, this.MusicMuted.toString());
    }
    ToggleSFXMute() {
        this.SFXMuted = !this.SFXMuted;
        Game.UI.SetSFXMuteButtonState(this.SFXMuted);
        (0, $f6601dd412e992e3$export$1b8cd2d0ef9a8e5d)((0, $f6601dd412e992e3$export$c02c1f4c11d08446).SFXMuted, this.SFXMuted.toString());
    }
    Initialize() {
        this.LogInfo("Initializing sound library...");
        if ((0, $f6601dd412e992e3$export$3727fff6c4775dc0)((0, $f6601dd412e992e3$export$c02c1f4c11d08446).MusicMuted)) {
            const currentMusicMuteState = (0, $f6601dd412e992e3$export$e68c847c0bceb7d5)((0, $f6601dd412e992e3$export$c02c1f4c11d08446).MusicMuted);
            this.MusicMuted = currentMusicMuteState === "true";
        } else (0, $f6601dd412e992e3$export$1b8cd2d0ef9a8e5d)((0, $f6601dd412e992e3$export$c02c1f4c11d08446).MusicMuted, "false");
        if ((0, $f6601dd412e992e3$export$3727fff6c4775dc0)((0, $f6601dd412e992e3$export$c02c1f4c11d08446).SFXMuted)) {
            const currentSFXState = (0, $f6601dd412e992e3$export$e68c847c0bceb7d5)((0, $f6601dd412e992e3$export$c02c1f4c11d08446).SFXMuted);
            this.SFXMuted = currentSFXState === "true";
        } else (0, $f6601dd412e992e3$export$1b8cd2d0ef9a8e5d)((0, $f6601dd412e992e3$export$c02c1f4c11d08446).SFXMuted, "false");
        for (const [audioEvent, { files: files, volume: volume }] of Object.entries($d5e82d35428c4a6c$var$audioEventToFileNameMapping)){
            this.sounds[audioEvent] = [];
            for (const audioFileName of files){
                const sound = this._loadHowl(audioFileName, volume * this.sfxVolume); // Pass the specific sound effect volume.
                this.sounds[audioEvent].push(sound);
            }
        // this.LogInfo("sounds", this.sounds);
        }
        // Listen for events and play associated sounds, picking a random one from the list if there are multiple
        Game.ListenForEvent("Audio::PlaySfx", (eventData)=>{
            if (this.SFXMuted === true) return;
            if (!this.musicShouldBePlaying) return;
            const sfxToPlay = eventData.sfxName;
            if (this.sounds[sfxToPlay] !== undefined) {
                if (this.activeSounds.includes(sfxToPlay)) // Don't play the same sound twice at once for now
                return;
                const soundList = this.sounds[sfxToPlay];
                const soundIndex = Math.floor(Math.random() * soundList.length);
                const howlToPlay = soundList[soundIndex];
                this.activeSounds.push(sfxToPlay);
                howlToPlay.once("end", ()=>{
                    // console.log("Sound done playing");
                    this.activeSounds.splice(this.activeSounds.indexOf(sfxToPlay), 1);
                //this.activeSounds = this.activeSounds.filter((sound) => sound !== sfxToPlay);
                // this.activeSounds = [];
                // console.log("sound ended");
                });
                howlToPlay.play();
            } else this.LogError(`Received request to play sound for event ${sfxToPlay}, but no sound is mapped to that event!`);
        });
        Game.ListenForEvent("Audio::StartMusic", ()=>{
            this._initBackgroundMusic();
        });
        Game.EmitEvent("LoadEvent", {
            eventName: "AudioReady"
        });
    }
    Update(__deltaTimeS, __deltaTimeMS, __currentTime) {}
    Cleanup() {}
    constructor(){
        super();
        this.sounds = {};
        this.sfxVolume = 0.1;
        this.musicVolume = 0.07;
        this.musicHowl = null;
        this.activeSounds = [];
        this.musicShouldBePlaying = true;
        this.MusicMuted = false;
        this.SFXMuted = false;
    }
}




class $2e8364587763e117$export$fb65c8a8cc1ac4bf extends (0, $fc7b18e354612676$export$5d53140180d567a1) {
    constructor(...args){
        super(...args);
        this.needsLazyInitialization = false;
    }
}
class $2e8364587763e117$export$c877fff499bfdb48 extends $2e8364587763e117$export$fb65c8a8cc1ac4bf {
    getSystemName() {
        return "PokiSDKWrapper";
    }
    Initialize() {
        if (PokiSDK === undefined) this.needsLazyInitialization = true;
        else this._initializeSDK();
    }
    _onGameplayStart() {
        // console.info("On gameplay START fired. Current state....", this.currentGameplayState);
        if (this.currentGameplayState !== "playing") {
            PokiSDK.gameplayStart();
            this.currentGameplayState = "playing";
        }
    }
    _onGameplayStop() {
        // console.info("On gameplay STOP fired. Current state....", this.currentGameplayState);
        if (this.currentGameplayState !== "paused") {
            PokiSDK.gameplayStop();
            this.currentGameplayState = "paused";
        }
    }
    _onLoadingFinished() {
        if (this.loadingFinishedEventFired === false) {
            this.loadingFinishedEventFired = true;
            PokiSDK.gameLoadingFinished();
        }
    }
    _initializeSDK() {
        PokiSDK.init().then(()=>{
            Game.ListenForEvent("SDK::GameplayStart", this._onGameplayStart.bind(this));
            Game.ListenForEvent("SDK::GameplayStop", this._onGameplayStop.bind(this));
            Game.ListenForEvent("SDK::GameLoadingFinished", this._onLoadingFinished.bind(this));
            Game.ListenForEvent("SDK::PopRewardedAd", (cb)=>{
                this._popRewardedAd(cb);
            });
            Game.ListenForEvent("SDK::PopCommercialBreakAd", ()=>{
                this._popCommercialBreak();
            });
        }).catch(()=>{
            console.error("Initialized, but the user likely has adblock :/");
        });
    }
    _oneMinuteHasPassedSinceSystemInitialization() {
        const oneMinuteInMS = 60000;
        const now = Date.now();
        const diff = now - this.systemInitializedAt;
        if (diff >= oneMinuteInMS) return true;
        else return false;
    }
    _popCommercialBreak() {
        // console.warn("Popping commercial break!");
        // Game.UI.CancelPointerLock();
        if (this._oneMinuteHasPassedSinceSystemInitialization() === false) {
            this.LogInfo("Skipping ad play opportunity because it hasnt been 1 minute since system initialization yet");
            return;
        }
        if ((0, $b80b6e4c153785d9$export$29cd7b75162a9425).Rewards.SKIP_ADS && (window.location.href.includes("localhost") || window.location.href.includes("dev.uptogether.io"))) {
            this._onAdStarted();
            setTimeout(()=>{
                this._onAdEnded(true);
            }, 100);
        } else PokiSDK.commercialBreak(this._onAdStarted.bind(this)).then(this._onAdEnded.bind(this)).catch(this._onAdError.bind(this));
    }
    _popRewardedAd(cb) {
        // console.warn("Popping rewarded ad!");
        this.adSuccessfullyPlayedCallback = cb;
        // Game.UI.CancelPointerLock();
        if ((0, $b80b6e4c153785d9$export$29cd7b75162a9425).Rewards.SKIP_ADS && (window.location.href.includes("localhost") || window.location.href.includes("dev.uptogether.io"))) {
            this._onAdStarted();
            setTimeout(()=>{
                this._onAdEnded(true);
            }, 100);
        } else PokiSDK.rewardedBreak(this._onAdStarted.bind(this)).then(this._onAdEnded.bind(this)).catch(this._onAdError.bind(this));
    }
    _onAdStarted() {
        // console.log("Ad started callback!");
        // console.log(Game.Audio.MusicMuted);
        // console.log(Game.Audio.SFXMuted);
        if (Game.Audio.MusicMuted === false) {
            // console.log("Player had music playing when we started the ad. temporarily mute it...");
            Game.Audio.ToggleMusicMute();
            this.hadToMuteMusic = true;
        } else this.hadToMuteMusic = false;
        if (Game.Audio.SFXMuted === false) {
            // console.log("Player had sfx playing when we started the ad. temporarily mute it...");
            Game.Audio.ToggleSFXMute();
            this.hadToMuteSFX = true;
        } else this.hadToMuteSFX = false;
        Game.UI.CancelPointerLock();
    }
    _onAdEnded(success) {
        // console.log("Ad ended callback!");
        if (success) // console.info("ad was played (confirmed)");
        {
            if (this.adSuccessfullyPlayedCallback !== undefined) this.adSuccessfullyPlayedCallback();
        }
        if (this.hadToMuteMusic === true) {
            // console.log("Player had music playing when we started the ad. since we muted it before, resuming it now");
            Game.Audio.ToggleMusicMute();
            this.hadToMuteMusic = false;
        }
        if (this.hadToMuteSFX === true) {
            // console.log("Player had sfx playing when we started the ad. since we muted it before, resuming it now");
            Game.Audio.ToggleSFXMute();
            this.hadToMuteMusic = false;
        }
        // Game.UI.HideAllScreens();
        this.adSuccessfullyPlayedCallback = undefined;
    }
    _onAdError(__error) {
        // console.log("Ad error callback!", error);
        // Game.UI.HideAllScreens();
        if (this.hadToMuteMusic === true) {
            // console.log("Player had music playing when we started the ad. since we muted it before, resuming it now");
            Game.Audio.ToggleMusicMute();
            this.hadToMuteMusic = false;
        }
        if (this.hadToMuteSFX === true) {
            // console.log("Player had sfx playing when we started the ad. since we muted it before, resuming it now");
            Game.Audio.ToggleSFXMute();
            this.hadToMuteSFX = false;
        }
    }
    Update(__deltaTimeS, __deltaTimeMS, __currentTime) {
        if (this.needsLazyInitialization && PokiSDK !== undefined) {
            this._initializeSDK();
            this.needsLazyInitialization = false;
        }
    }
    Cleanup() {}
    constructor(){
        super();
        this.currentGameplayState = "loading";
        this.gameplayStartEventFired = false;
        this.loadingFinishedEventFired = false;
        this.hadToMuteMusic = false;
        this.hadToMuteSFX = false;
        this.systemInitializedAt = Date.now();
        this.adSuccessfullyPlayedCallback = undefined;
    }
}








class $a69c30e38ddcd89c$export$bbcc291fca60f969 extends (0, $fc7b18e354612676$export$5d53140180d567a1) {
    //These need to be async in order for us to grab the model data needed for InstancedMeshes
    async _loadLevelAssets() {
        const uniquePlatforms = [];
        const instancedMeshTotalCounts = new Map();
        this.levelData.filter((platform)=>platform.uniqueIdentifier.toLowerCase() !== "spawn").forEach((platform)=>{
            const platformMetadata = (0, $69d6cbd59c5bb72c$export$414b10a35cf658a8)(platform.assetIdentifier);
            if (platformMetadata === undefined) throw new Error(`Could not find platform metadata for platform with JSON identifier ${platform.assetIdentifier}!`);
            else {
                if (!uniquePlatforms.includes(platformMetadata)) // console.log("No instance of this platform found! Creating InstancedMesh");
                uniquePlatforms.push(platformMetadata);
                const jsonIdentifier = platformMetadata?.jsonIdentifier;
                instancedMeshTotalCounts.set(jsonIdentifier, (instancedMeshTotalCounts.get(jsonIdentifier) || 0) + 1);
            }
        });
        const instancedMeshMapping = new Map();
        const loadPlatformAssets = uniquePlatforms.map(async (platformDetails)=>{
            const meshDetails = await this._createInstancedMesh(platformDetails, instancedMeshTotalCounts.get(platformDetails.jsonIdentifier));
            instancedMeshMapping.set(meshDetails.id, meshDetails.platformMesh);
        });
        await Promise.all(loadPlatformAssets);
        return instancedMeshMapping;
    }
    async _setInstancedMeshMatrixLoop(instancedMeshMapping) {
        const instancedMeshCurrentCount = new Map();
        this.levelData.filter((platform)=>platform.uniqueIdentifier.toLowerCase() !== "spawn").forEach((platform)=>{
            const platformMetadata = (0, $69d6cbd59c5bb72c$export$414b10a35cf658a8)(platform.assetIdentifier);
            if (platformMetadata === undefined) throw new Error(`Could not find platform metadata for platform with JSON identifier ${platform.assetIdentifier}!`);
            else {
                if (!instancedMeshCurrentCount.has(platformMetadata.platformEnumIdentifier)) instancedMeshCurrentCount.set(platformMetadata.platformEnumIdentifier, 0);
                //@ts-ignore
                const mesh = instancedMeshMapping.get(platformMetadata?.platformEnumIdentifier);
                if (mesh === undefined) throw new Error(`mesh is ${mesh}! at key ${platformMetadata.platformEnumIdentifier} in instancedMeshMapping`);
                else {
                    const position = new (0, $9014d97cd777be10$export$64b5c384219d3699)(platform.position[0], platform.position[1], platform.position[2]);
                    const quaternion = new (0, $9014d97cd777be10$export$23d6a54f0bbc85a3)();
                    quaternion.setFromEuler(new (0, $9014d97cd777be10$export$d93cc409a0768c5f)(platform.rotation[0], platform.rotation[1], platform.rotation[2]));
                    const scale = new (0, $9014d97cd777be10$export$64b5c384219d3699)(platform.scale[0], platform.scale[1], platform.scale[2]);
                    const matrix = new (0, $9014d97cd777be10$export$2ae72fc923e5eb5)();
                    matrix.compose(position, quaternion, scale);
                    if (instancedMeshCurrentCount.get(platformMetadata.platformEnumIdentifier) > mesh.count) throw new Error("We are trying to create a platform that exceeds the current IM count for that platform!");
                    mesh.setMatrixAt(instancedMeshCurrentCount.get(platformMetadata.platformEnumIdentifier), matrix);
                    instancedMeshCurrentCount.set(platformMetadata.platformEnumIdentifier, instancedMeshCurrentCount.get(platformMetadata.platformEnumIdentifier) + 1);
                    mesh.instanceMatrix.needsUpdate = true;
                    Game.Renderer.AddModelToScene(mesh);
                    // Setup PFX above every cone and inside every fridge
                    const particleEmitter = new (0, $975f8eaf1ecebbca$export$2e2bcd8739ae039)();
                    const particleTrailRate = (0, $60d2b0e7b97425c1$export$89a022980ff17124).get((0, $60d2b0e7b97425c1$export$72fb2d77891daaa5).Stars);
                    if (platformMetadata.jsonIdentifier === "chocolate_001" || platformMetadata.jsonIdentifier === "vanilla_001" || platformMetadata.jsonIdentifier === "pistachio_001") particleEmitter.setRate(particleTrailRate).setPosition(new (0, $9014d97cd777be10$export$64b5c384219d3699)(platform.position[0], platform.position[1] + 3, platform.position[2])).emit();
                    else if (platformMetadata.jsonIdentifier === "fridge_001") particleEmitter.setRate(particleTrailRate).setPosition(new (0, $9014d97cd777be10$export$64b5c384219d3699)(platform.position[0] - 1, platform.position[1], platform.position[2] + 1)).emit();
                    particleEmitter.setInitializers((0, $60d2b0e7b97425c1$export$1df7a7638615f95b).get((0, $60d2b0e7b97425c1$export$72fb2d77891daaa5).Stars));
                    particleEmitter.setBehaviours((0, $60d2b0e7b97425c1$export$f161ac8cd64e61d).get((0, $60d2b0e7b97425c1$export$72fb2d77891daaa5).Stars));
                    Game.Renderer.AddParticleEmitter(particleEmitter);
                }
            }
        });
    }
    getSystemName() {
        return "LevelLoader";
    }
    async Initialize() {
        this.LogInfo("Initializing level loader...");
        //levelData = platformData in level_uppity.json
        this.levelData = $cae8463151c972d6$exports.platforms;
        // Start the first loop and then start the second loop once it's completed
        const instancedMeshMapping = await this._loadLevelAssets();
        await this._setInstancedMeshMatrixLoop(instancedMeshMapping);
        this.LogInfo("Platforms have been created and Matrixed Neo!");
    }
    Update(__deltaTimeS, __deltaTimeMS, __currentTime) {}
    Cleanup() {}
    async _createInstancedMesh(_platformData, maxCount) {
        if (_platformData === undefined) throw new Error(`Could not find platform metadata in _createInstancedMesh for platform with JSON identifier ${_platformData}!`);
        const threeGLTF = await Game.Loader.LoadModel(_platformData.assetPath);
        if (threeGLTF.scene) {
            const threeModel = threeGLTF.scene;
            if (threeModel.children && threeModel.children[0]) {
                threeModel.traverse((node)=>{
                    //@ts-ignore
                    if (node.isMesh) {
                        // Your material and other logic here...
                        const newMaterial = new (0, $9014d97cd777be10$export$f2980790215acccd)({
                            color: 0xffffff
                        }); // Set your desired properties here
                        // @ts-ignore
                        // If the original material uses textures, transfer them to the new material
                        if (node.material.map) {
                            // @ts-ignore
                            newMaterial.map = node.material.map;
                            // @ts-ignore
                            newMaterial.transparent = node.material.transparent;
                            // @ts-ignore
                            newMaterial.alphaTest = node.material.alphaTest;
                        }
                        // if (_platformData.jsonIdentifier === "death_block_001") {
                        //     // console.log("Rendering death block!");
                        //     newMaterial.depthWrite = false;
                        // }
                        // Apply the new material
                        // @ts-ignore
                        node.material = newMaterial;
                    }
                });
                // Create the InstancedMesh with the loaded model
                // console.log("Creating InstancedMesh for", _platformData.jsonIdentifier);
                const platformMesh = new (0, $9014d97cd777be10$export$f3c979c331175ad7)(//@ts-ignore
                threeModel.children[0].geometry, //@ts-ignore
                threeModel.children[0].material, maxCount);
                platformMesh.name = "LevelPlatform";
                return {
                    id: _platformData.platformEnumIdentifier,
                    platformMesh: platformMesh
                };
            } else throw new Error("No child at index 0 found in the loaded model");
        } else // console.error("Failed to load model for (retrying though)", _platformData.assetPath);
        // console.error("Retrying...");
        // Recursively retry loading the model
        await this._createInstancedMesh(_platformData, maxCount);
    }
    constructor(){
        super();
    }
}







class $2c9173e12b69aa14$export$69c0d78807786d95 extends (0, $13f545b0b773e041$export$75d5526a7020db) {
    _jumpSideEffects() {
        if (this.canPlayJumpSound) {
            Game.EmitEvent("Audio::PlaySfx", {
                sfxName: "Jump"
            });
            this.canPlayJumpSound = false;
        }
    }
    _updateSideEffects() {
        const flooredHeight = Math.floor(this.Position.y);
        // Dont update the height in HUD too quickly
        if (Date.now() - this.lastBroadcastedHeightToHUD < 250) return;
        // Dont update the height in HUD if it hasnt changed
        if (flooredHeight === this.lastBroadcastedHeightFlooredNumber) return;
        Game.UI.UpdateHeightValue(flooredHeight);
        this.lastBroadcastedHeightFlooredNumber = flooredHeight;
        this.lastBroadcastedHeightToHUD = Date.now();
    }
    _bounceSideEffects() {
        Game.EmitEvent("Audio::PlaySfx", {
            sfxName: "Bounce"
        });
    }
    _intentionalRestartEntireRunSideEffects() {
        Game.UI.HideRunRestartHUDButtons();
        Game.UI.UpdateRunDuration(0);
        Game.UI.PopRestartedEntireRunText();
        Game.UI.ResetDeaths();
        Game.EmitEvent("Audio::PlaySfx", {
            sfxName: "Oof"
        });
        if (Game.Predictor.GetPredictedEntity() !== undefined) {
            Game.EmitEvent("SDK::GameplayStop");
            setTimeout(()=>{
                this._popCommercialBreak();
                Game.Predictor.GetPredictedEntity().ShouldFireGameplayStartEventOnNextMovement = true;
            }, 400);
        }
    }
    _intentionalRespawnSideEffects() {
        Game.Renderer.PlayerRotationProxyCube.rotation.x = this.cameraOrientationAsOfLastCheckpoint.x;
        Game.Renderer.PlayerRotationProxyCube.rotation.y = this.cameraOrientationAsOfLastCheckpoint.y;
        Game.Renderer.PlayerRotationProxyCube.rotation.z = this.cameraOrientationAsOfLastCheckpoint.z;
        Game.Renderer.SetCameraAngle(this.cameraOrientationAsOfLastCheckpoint.lateral, this.cameraOrientationAsOfLastCheckpoint.vertical);
        Game.EmitEvent("Audio::PlaySfx", {
            sfxName: "Oof"
        });
        Game.UI.PopIntentionalRespawnText();
        Game.UI.IncrementDeaths();
        // console.log("intentional respawn side effects!!");
        if (Game.Predictor.GetPredictedEntity() !== undefined) {
            Game.EmitEvent("SDK::GameplayStop");
            this._popCommercialBreak();
            Game.Predictor.GetPredictedEntity().ShouldFireGameplayStartEventOnNextMovement = true;
        }
    }
    ProcessInputs(inputCommand) {
        const { forward: forward, back: back, left: left, right: right, jump: jump } = inputCommand;
        if ((forward || back || left || right || jump) && this.ShouldFireGameplayStartEventOnNextMovement) {
            // console.info("Emitting gameplay start 3!");
            Game.EmitEvent("SDK::GameplayStart");
            this.ShouldFireGameplayStartEventOnNextMovement = false;
        }
        // console.info("Should the charactert jump?", jump);
        super.ProcessInputs(inputCommand);
    }
    _resetUIPopTriggerSideEffect() {
        this.uiPopTriggerAcculumator = 0;
        Game.UI.UpdateUIPopAccumulator(0);
        this.isShowingUIScreen = false;
    }
    _isLabelVisible() {
        return this.currentState === "idle" && this.idleTimer > 750;
    }
    _uiPopTriggerSideEffect(trigger, deltaTimeS) {
        const uiScreenToPop = trigger.TriggerType;
        this.CollidingWithUIPopTrigger = true;
        this.uiPopTriggerAcculumator += deltaTimeS;
        if (this.isShowingUIScreen) return;
        const uiPopPercentage = this.uiPopTriggerAcculumator / this.uiPopSeconds;
        Game.UI.UpdateUIPopAccumulator(uiPopPercentage);
        if (this.uiPopTriggerAcculumator >= this.uiPopSeconds) {
            if (uiScreenToPop === (0, $07756da3fdd79b5d$export$aaab732ed133eca).UI_PopUp_CharacterSelect) {
                Game.UI.ShowScreen((0, $3c561a4876de7de6$export$b714373eb9ab036b).CharacterSelect);
                this.isShowingUIScreen = true;
            }
            if (uiScreenToPop === (0, $07756da3fdd79b5d$export$aaab732ed133eca).UI_PopUp_EndRun) {
                Game.UI.ShowScreen((0, $3c561a4876de7de6$export$b714373eb9ab036b).RunComplete);
                this.isShowingUIScreen = true;
            }
            if (uiScreenToPop === (0, $07756da3fdd79b5d$export$aaab732ed133eca).UI_PopUp_NameAndCountrySelect) {
                Game.UI.ShowScreen((0, $3c561a4876de7de6$export$b714373eb9ab036b).ChangeUsername);
                this.isShowingUIScreen = true;
            }
            if (uiScreenToPop === (0, $07756da3fdd79b5d$export$aaab732ed133eca).UI_PopUp_TrailSelect) {
                console.log("Character Trail: ", this.characterTrail);
                if (Game.UI.getSelectedTrail() !== Game.Renderer.MyLocalNonPredictedEntity.characterTrail) Game.UI.setSelectedTrail(Game.Renderer.MyLocalNonPredictedEntity.characterTrail);
                Game.UI.ShowScreen((0, $3c561a4876de7de6$export$b714373eb9ab036b).TrailSelect);
                this.isShowingUIScreen = true;
            }
            this.ShouldFireGameplayStartEventOnNextMovement = true;
        }
    }
    _deathBlockTriggerSideEffect() {
        Game.Renderer.PlayerRotationProxyCube.rotation.x = this.cameraOrientationAsOfLastCheckpoint.x;
        Game.Renderer.PlayerRotationProxyCube.rotation.y = this.cameraOrientationAsOfLastCheckpoint.y;
        Game.Renderer.PlayerRotationProxyCube.rotation.z = this.cameraOrientationAsOfLastCheckpoint.z;
        Game.Renderer.SetCameraAngle(this.cameraOrientationAsOfLastCheckpoint.lateral, this.cameraOrientationAsOfLastCheckpoint.vertical);
        Game.EmitEvent("Audio::PlaySfx", {
            sfxName: "DeathBlock"
        });
        Game.EmitEvent("Audio::PlaySfx", {
            sfxName: "Oof"
        });
        Game.UI.PopCookedDeathText();
        Game.UI.IncrementDeaths();
        Game.EmitEvent("SDK::GameplayStop");
        this._popCommercialBreak();
    }
    _popCommercialBreak() {
        Game.EmitEvent("SDK::PopCommercialBreakAd");
    }
    _fallingDeathSideEffects() {
        Game.Renderer.PlayerRotationProxyCube.rotation.x = this.cameraOrientationAsOfLastCheckpoint.x;
        Game.Renderer.PlayerRotationProxyCube.rotation.y = this.cameraOrientationAsOfLastCheckpoint.y;
        Game.Renderer.PlayerRotationProxyCube.rotation.z = this.cameraOrientationAsOfLastCheckpoint.z;
        Game.Renderer.SetCameraAngle(this.cameraOrientationAsOfLastCheckpoint.lateral, this.cameraOrientationAsOfLastCheckpoint.vertical);
        Game.EmitEvent("Audio::PlaySfx", {
            sfxName: "Oof"
        });
        Game.UI.PopFallingDeathText();
        Game.UI.IncrementDeaths();
        if (Game.Predictor.GetPredictedEntity() !== undefined) {
            Game.EmitEvent("SDK::GameplayStop");
            this._popCommercialBreak();
            Game.Predictor.GetPredictedEntity().ShouldFireGameplayStartEventOnNextMovement = true;
        }
    }
    _checkpointSideEffects() {
        const { x: x, y: y, z: z } = Game.Renderer.PlayerRotationProxyCube.rotation;
        const { lateral: lateral, vertical: vertical } = Game.Renderer.GetCameraAngle();
        this.cameraOrientationAsOfLastCheckpoint.x = x;
        this.cameraOrientationAsOfLastCheckpoint.y = y;
        this.cameraOrientationAsOfLastCheckpoint.z = z;
        this.cameraOrientationAsOfLastCheckpoint.lateral = lateral;
        this.cameraOrientationAsOfLastCheckpoint.vertical = vertical;
        Game.EmitEvent("Audio::PlaySfx", {
            sfxName: "Checkpoint"
        });
        Game.UI.PopText((0, $34a8d0dc3ef4dba1$export$625550452a3fa3ec)("in_game__checkpoint"));
    // this.BurstParticleEffect(ParticleEffects.Confetti);
    }
    _finishLineTriggerSideEffect() {
        Game.EmitEvent("Audio::PlaySfx", {
            sfxName: "Finish"
        });
        Game.UI.PopText("Finish!");
        Game.UI.HideRunRestartHUDButtons();
    // this.BurstParticleEffect(ParticleEffects.Confetti);
    }
    _startingLineTriggerSideEffect() {
        Game.EmitEvent("Audio::PlaySfx", {
            sfxName: "Start"
        });
        Game.UI.PopText("Go!");
        // console.log("@@@ Starting line side effects!");
        Game.UI.ShowRunRestartHUDButtons();
    // this.BurstParticleEffect(ParticleEffects.Confetti);
    }
    constructor(createPlayerPayload){
        super(createPlayerPayload);
        this.canPlayJumpSound = true;
        this.cameraOrientationAsOfLastCheckpoint = {
            x: 0,
            y: 0,
            z: 0,
            lateral: 0,
            vertical: 0
        };
        this.uiPopSeconds = 0.75;
        this.isShowingUIScreen = false;
        this.ShouldFireGameplayStartEventOnNextMovement = true;
        this.lastBroadcastedHeightFlooredNumber = 1;
        this.lastBroadcastedHeightToHUD = 0;
    }
}


class $f5444dc211e9600c$export$8ccb38c26a8ab5aa extends (0, $fc7b18e354612676$export$5d53140180d567a1) {
    _setupLocallyPredictedPlayer(event) {
        const { originalCreationPayload: originalCreationPayload } = event;
        this.myLocallyPredictedEntity = new (0, $2c9173e12b69aa14$export$69c0d78807786d95)(originalCreationPayload);
        // console.log(this.myLocallyPredictedEntity);
        this.Initialize();
    }
    Initialize() {
        // Game.Renderer.AddRenderedEntity(this.myLocallyPredictedEntity);
        // Game.Renderer.StartFollowing(this.myLocallyPredictedEntity.nid, this.myLocallyPredictedEntity);
        this.initialized = true;
        Game.EmitEvent("Prediction::PredictionReady");
        this.PredictionReady = true;
    }
    getSystemName() {
        return "CSP";
    }
    GetPredictedEntity() {
        return this.myLocallyPredictedEntity;
    }
    // public GetPredictedEntityX(): number {
    //     if (this.myLocallyPredictedEntity === undefined) return 0;
    //     return this.myLocallyPredictedEntity.x;
    // }
    // public GetPredictedEntityY(): number {
    //     if (this.myLocallyPredictedEntity === undefined) return 0;
    //     return this.myLocallyPredictedEntity.y;
    // }
    // public LocallyPredictedEntityIsAlive(): boolean {
    //     return Boolean(this.myLocallyPredictedEntity.isAlive);
    // }
    PredictPlayerInputCommand(command) {
        if (this.initialized === false) return;
        if (this.myLocallyPredictedEntity === undefined) return;
        // if (globalThis.IsMobile === true) {
        //     this.myLocallyPredictedEntity.UpdateAnimationTimeScale(command.mobileSpeedMultiplier);
        // }
        this.myLocallyPredictedEntity.ProcessInputs(command);
    }
    Update(deltaTimeS, deltaTimeMS, currentTime) {
        this.myLocallyPredictedEntity?.Update(deltaTimeS, deltaTimeMS, currentTime);
    }
    Cleanup() {}
    constructor(){
        super();
        this.PredictionReady = false;
        this.initialized = false;
        Game.ListenForEvent("Prediction::ReadyToCreatePredictedEntity", this._setupLocallyPredictedPlayer.bind(this));
    }
}











class $296a3c3690b3b824$export$21753bcb649b7783 extends (0, $fc7b18e354612676$export$5d53140180d567a1) {
    GetUserType() {
        return this.userType;
    }
    async Initialize() {
        let identity = undefined;
        let userType = undefined;
        this._portUserAuthBetweenMajorGameVersionsIfNecessary();
        let maintenanceModeActive = false;
        try {
            const { isInMaintenanceMode: isInMaintenanceMode } = await (0, $5fb6b10ed4f86a19$export$6100115752b4c7cd)();
            maintenanceModeActive = isInMaintenanceMode;
        } catch (e) {
            Game.UI.ShowErrorScreen((0, $34a8d0dc3ef4dba1$export$625550452a3fa3ec)("error_screen__server_maybe_full"));
        }
        if (maintenanceModeActive) {
            console.info("Game is in maintenance mode currently, not attempting to connect to the server!");
            Game.UI.ShowErrorScreen((0, $34a8d0dc3ef4dba1$export$625550452a3fa3ec)("error_screen__maintenance_mode"));
        } else {
            try {
                if (this._isExistingAnonymousUser()) {
                    // load an existing anon user if none of the above apply
                    this.LogInfo("Anonymous user found, retrieving info for existing anonymous user");
                    const anonUserId = (0, $f6601dd412e992e3$export$e68c847c0bceb7d5)((0, $f6601dd412e992e3$export$c02c1f4c11d08446).AnonymousUserId);
                    const retrievedAnonUser = await (0, $5fb6b10ed4f86a19$export$42667f60e0bdcfe0)(anonUserId);
                    if (retrievedAnonUser === undefined) throw new (0, $a0dc081d2781de33$export$7333e7db5e5d49a)("User not found!");
                    identity = retrievedAnonUser;
                    userType = (0, $de4f7960cd805115$export$8436e53e45ffe15b).Anonymous;
                // this.LogInfo("Retrieved existing anonymous user!");
                // this.LogInfo("\n" + JSON.stringify(retrievedAnonUser, null, 2));
                } else {
                    // lastly, create a new anon user if none of the above apply
                    this.LogInfo("No anonymous user found, creating net new anon user");
                    const createdAnonUser = await (0, $5fb6b10ed4f86a19$export$f16d887d0c3c04c7)();
                    if (createdAnonUser === undefined) throw new Error("Failed to create user!");
                    (0, $f6601dd412e992e3$export$1b8cd2d0ef9a8e5d)((0, $f6601dd412e992e3$export$c02c1f4c11d08446).AnonymousUserId, createdAnonUser._id);
                    identity = createdAnonUser;
                    userType = (0, $de4f7960cd805115$export$8436e53e45ffe15b).Anonymous;
                // this.LogInfo("Newly created anonymous user:");
                // this.LogInfo("\n" + JSON.stringify(createdAnonUser, null, 2));
                }
            } catch (e) {
                if (e instanceof (0, $a0dc081d2781de33$export$7333e7db5e5d49a)) {
                    this.ClearLocalAuth();
                    this.AuthExpiredLogout();
                    Game.UI.ShowErrorScreen("Error connecting to server: servers may be full right now, try again in a few minutes!");
                } else {
                    console.error("Unknown API Error", e);
                    Game.UI.ShowErrorScreen("Error connecting to server: servers may be full right now, try again in a few minutes!");
                }
            }
            if (identity === undefined || userType === undefined) {
                this.ClearLocalAuth();
                Game.UI.ShowErrorScreen("Error connecting to server: servers may be full right now, try again in a few minutes!");
                return;
            }
            Game.EmitEvent("Identity::Identified", {
                identity: identity
            });
            const { UpTogether: UpTogether } = identity;
            const { chosenSkin: chosenSkin } = UpTogether;
            // console.log("@@@ identity", UpTogether);
            if ((0, $f6601dd412e992e3$export$3727fff6c4775dc0)((0, $f6601dd412e992e3$export$c02c1f4c11d08446).SkinUnlocks)) {
                const savedSkinUnlocks = (0, $f6601dd412e992e3$export$e68c847c0bceb7d5)((0, $f6601dd412e992e3$export$c02c1f4c11d08446).SkinUnlocks);
                try {
                    const parsedUnlocks = JSON.parse(savedSkinUnlocks);
                    // console.info("@@@ Got saved skin unlocks:", parsedUnlocks);
                    if (parsedUnlocks.includes(chosenSkin) === false) {
                        // console.info("@@@ Saveds kun unlocks did not yet have this players default skin, adding it!");
                        const updatedParsedUnlocks = [
                            ...parsedUnlocks,
                            chosenSkin
                        ];
                        (0, $f6601dd412e992e3$export$1b8cd2d0ef9a8e5d)((0, $f6601dd412e992e3$export$c02c1f4c11d08446).SkinUnlocks, JSON.stringify(updatedParsedUnlocks));
                    }
                } catch (e) {
                    // console.error("@@@ Failed to parse saved skin unlocks:", savedSkinUnlocks);
                    (0, $f6601dd412e992e3$export$1b8cd2d0ef9a8e5d)((0, $f6601dd412e992e3$export$c02c1f4c11d08446).SkinUnlocks, JSON.stringify([
                        chosenSkin
                    ]));
                }
            } else {
                const defaultUnlocks = [
                    chosenSkin
                ];
                // console.info("@@@ No saved skin unlocks found, saving defaults (which includes current unlocked skin):", defaultUnlocks);
                (0, $f6601dd412e992e3$export$1b8cd2d0ef9a8e5d)((0, $f6601dd412e992e3$export$c02c1f4c11d08446).SkinUnlocks, JSON.stringify(defaultUnlocks));
            }
            Game.EmitEvent("LoadEvent", {
                eventName: "IdentityReady"
            });
            this.identity = identity;
            this.userType = userType;
            this.identified = true;
            this.LogInfo("Ready!\n\nUsername is: " + this.identity.username);
        }
    }
    GetUsername() {
        return this.identity.username;
    }
    GetAnonymousUserId() {
        return this.identity._id;
    }
    ClearLocalAuth(reload) {
        (0, $f6601dd412e992e3$export$34a3032bf337a702)((0, $f6601dd412e992e3$export$c02c1f4c11d08446).AuthToken);
        (0, $f6601dd412e992e3$export$34a3032bf337a702)((0, $f6601dd412e992e3$export$c02c1f4c11d08446).AnonymousUserId);
        if (reload) window.location.reload();
    }
    AuthExpiredLogout() {
        window.location.reload();
    }
    getSystemName() {
        return "Identity";
    }
    _isExistingAnonymousUser() {
        const existingAnonUserId = (0, $f6601dd412e992e3$export$e68c847c0bceb7d5)((0, $f6601dd412e992e3$export$c02c1f4c11d08446).AnonymousUserId);
        if (existingAnonUserId !== null) return true;
        else return false;
    }
    _portUserAuthBetweenMajorGameVersionsIfNecessary() {
        try {
            const currentVersionAsInt = parseInt((0, $b80b6e4c153785d9$export$29cd7b75162a9425).Game.MAJOR_GAME_VERSION);
            const previousMajorGameVersion = (0, $9f2918ccbc980d31$export$7d15b64cf5a3a4c4)(currentVersionAsInt - 1, 0, Infinity);
            if (previousMajorGameVersion === currentVersionAsInt) {
                this.LogInfo("No new major game version detected; continuing...");
                return;
            }
            this.LogInfo("Current game version:", currentVersionAsInt);
            this.LogInfo("Prior game version:", previousMajorGameVersion);
            const existingPreviousAnonUserId = (0, $f6601dd412e992e3$export$50b227d68205c4cc)((0, $f6601dd412e992e3$export$c02c1f4c11d08446).AnonymousUserId, previousMajorGameVersion);
            if (existingPreviousAnonUserId !== null) {
                this.LogInfo(`Found legacy anonymous user id: ${existingPreviousAnonUserId} - porting to new version!`);
                (0, $f6601dd412e992e3$export$1b8cd2d0ef9a8e5d)((0, $f6601dd412e992e3$export$c02c1f4c11d08446).AnonymousUserId, existingPreviousAnonUserId);
                (0, $f6601dd412e992e3$export$f39d14204f621823)((0, $f6601dd412e992e3$export$c02c1f4c11d08446).AnonymousUserId, previousMajorGameVersion);
                this.LogInfo("New major game version detected, ported anonymous user id from previous version!");
            } else this.LogInfo("No legacy anonymous user id found; continuing...");
            const existingSfxMutedSetting = (0, $f6601dd412e992e3$export$50b227d68205c4cc)((0, $f6601dd412e992e3$export$c02c1f4c11d08446).SFXMuted, previousMajorGameVersion);
            if (existingSfxMutedSetting !== null) {
                this.LogInfo(`Found legacy sfx muted setting: ${existingSfxMutedSetting} - porting to new version!`);
                (0, $f6601dd412e992e3$export$1b8cd2d0ef9a8e5d)((0, $f6601dd412e992e3$export$c02c1f4c11d08446).SFXMuted, existingSfxMutedSetting);
                (0, $f6601dd412e992e3$export$f39d14204f621823)((0, $f6601dd412e992e3$export$c02c1f4c11d08446).SFXMuted, previousMajorGameVersion);
                this.LogInfo("New major game version detected, ported sfx muted setting from previous version!");
            } else this.LogInfo("No legacy sfx muted setting found; continuing...");
            const existingMusicMutedSetting = (0, $f6601dd412e992e3$export$50b227d68205c4cc)((0, $f6601dd412e992e3$export$c02c1f4c11d08446).MusicMuted, previousMajorGameVersion);
            if (existingMusicMutedSetting !== null) {
                this.LogInfo(`Found legacy music muted setting: ${existingMusicMutedSetting} - porting to new version!`);
                (0, $f6601dd412e992e3$export$1b8cd2d0ef9a8e5d)((0, $f6601dd412e992e3$export$c02c1f4c11d08446).MusicMuted, existingMusicMutedSetting);
                (0, $f6601dd412e992e3$export$f39d14204f621823)((0, $f6601dd412e992e3$export$c02c1f4c11d08446).MusicMuted, previousMajorGameVersion);
                this.LogInfo("New major game version detected, ported music muted setting from previous version!");
            } else this.LogInfo("No legacy music muted setting found; continuing...");
            const existingTrailUnlocks = (0, $f6601dd412e992e3$export$50b227d68205c4cc)((0, $f6601dd412e992e3$export$c02c1f4c11d08446).TrailUnlocks, previousMajorGameVersion);
            if (existingTrailUnlocks !== null) {
                this.LogInfo(`Found legacy trail unlocks: ${existingTrailUnlocks} - porting to new version!`);
                (0, $f6601dd412e992e3$export$1b8cd2d0ef9a8e5d)((0, $f6601dd412e992e3$export$c02c1f4c11d08446).TrailUnlocks, existingTrailUnlocks);
                (0, $f6601dd412e992e3$export$f39d14204f621823)((0, $f6601dd412e992e3$export$c02c1f4c11d08446).TrailUnlocks, previousMajorGameVersion);
                this.LogInfo("New major game version detected, ported trail unlocks from previous version!");
            } else this.LogInfo("No legacy trail unlocks found; continuing...");
            const existingSkinUnlocks = (0, $f6601dd412e992e3$export$50b227d68205c4cc)((0, $f6601dd412e992e3$export$c02c1f4c11d08446).SkinUnlocks, previousMajorGameVersion);
            if (existingSkinUnlocks !== null) {
                this.LogInfo(`Found legacy skin unlocks: ${existingSkinUnlocks} - porting to new version!`);
                (0, $f6601dd412e992e3$export$1b8cd2d0ef9a8e5d)((0, $f6601dd412e992e3$export$c02c1f4c11d08446).SkinUnlocks, existingSkinUnlocks);
                (0, $f6601dd412e992e3$export$f39d14204f621823)((0, $f6601dd412e992e3$export$c02c1f4c11d08446).SkinUnlocks, previousMajorGameVersion);
                this.LogInfo("New major game version detected, ported skin unlocks from previous version!");
            } else this.LogInfo("No legacy skin unlocks found; continuing...");
        } catch (e) {
            console.error(e);
        }
    }
    Update(__deltaTime) {}
    Cleanup() {}
    constructor(){
        super();
        this.identified = false;
    }
}


class $251c7955fe5adcf7$export$38bc80eba028b399 extends (0, $fc7b18e354612676$export$5d53140180d567a1) {
    EmitEvent(eventName, payload) {
        // this.LogVerbose(`Emitting event: ${eventName}`);
        this.EventDispatcher.emit(eventName, payload);
    }
    ListenForEvent(eventName, callback) {
        this.EventDispatcher.on(eventName, callback);
    }
    StopListeningForEvent(eventName, callback) {
        this.EventDispatcher.off(eventName, callback);
    }
    Initialize() {}
    Bootstrap() {
        this.Loader.Initialize();
        this.Audio.Initialize();
        this.UI.Initialize();
        this.Renderer.Initialize();
        this.Input.Initialize();
        this.Netcode.Initialize();
        this.Collision.Initialize();
        this.Debug.Initialize();
        this.Resizer.Initialize();
        this.LevelLoader.Initialize();
        if (this.gameIsPortalEmbedded) this.HostPortalSDK.Initialize();
        this.Identity.Initialize();
        this.Start();
    }
    ConnectToServer(serverAddress, connectionToken, gameClientVersion) {
        // Connect to the server!
        this.Netcode.Connect(serverAddress, connectionToken, gameClientVersion);
    }
    Cleanup() {}
    Start() {
        if (this.isRunning) return;
        this.isRunning = true;
        this.lastUpdateTime = performance.now();
        requestAnimationFrame((time)=>this.Update(time));
    }
    getSystemName() {
        return "Client";
    }
    Update(currentTime) {
        try {
            if (!this.isRunning) return;
            this.currentFrame++;
            globalThis.currentFrameNumber = this.currentFrame;
            const currentTimestamp = Date.now();
            const deltaTimeMS = currentTime - this.lastUpdateTime;
            const deltaTimeS = deltaTimeMS / 1000;
            this.lastUpdateTime = currentTime;
            this.Loader.Update(deltaTimeS, deltaTimeMS, currentTimestamp);
            this.Renderer.Update(deltaTimeS, deltaTimeMS, currentTimestamp);
            this.Input.Update(deltaTimeS, deltaTimeMS, currentTimestamp);
            this.Netcode.Update(deltaTimeS, deltaTimeMS, currentTimestamp);
            this.Collision.Update(deltaTimeS, deltaTimeMS, currentTimestamp);
            this.Debug.Update(deltaTimeS, deltaTimeMS, currentTimestamp);
            this.Resizer.Update(deltaTimeS, deltaTimeMS, currentTimestamp);
            this.Audio.Update(deltaTimeS, deltaTimeMS, currentTimestamp);
            this.LevelLoader.Update(deltaTimeS, deltaTimeMS, currentTimestamp);
            this.Predictor.Update(deltaTimeS, deltaTimeMS, currentTimestamp);
            this.UI.Update(deltaTimeS, deltaTimeMS, currentTimestamp);
            if (this.gameIsPortalEmbedded) this.HostPortalSDK.Update(deltaTimeS, deltaTimeMS, currentTimestamp);
            this.entities.forEach((entity)=>{
                entity.Update(deltaTimeS, deltaTimeMS, currentTimestamp);
            });
            requestAnimationFrame((time)=>this.Update(time));
        } catch (e) {
            console.error("Caught error in game client update loop!");
            console.error(e);
        }
    }
    WhereAmI() {
        console.info(`Your player is currently at position: ${this.Predictor.GetPredictedEntity().Position.x}x, ${this.Predictor.GetPredictedEntity().Position.y}y, ${this.Predictor.GetPredictedEntity().Position.z}z`);
    }
    ProcessMessage(message) {
        // this.LogInfo("Nengi server sent us a message:");
        // this.LogInfo("\n" + JSON.stringify(message, null, 2));
        switch(message.ntype){
            case (0, $7c910687071ab881$export$f7cab339749a57d7).RunCompleteMessage:
                const { minutes: minutes, seconds: seconds, milliseconds: milliseconds } = message;
                Game.UI.UpdateFinalRunTime(minutes, seconds, milliseconds);
                break;
            case (0, $7c910687071ab881$export$f7cab339749a57d7).IdentityMessage:
                this.myEntityNid = message.myId;
                this.LogInfo(`Self identified as nid: ${this.myEntityNid}`);
                Game.EmitEvent("Bootstrap::MyEntitiesNidIsKnown", message);
                break;
            case (0, $7c910687071ab881$export$f7cab339749a57d7).LeaderboardMessage:
                Game.Renderer.UpdateLeaderboard(message.leaderboard);
                break;
            case (0, $7c910687071ab881$export$f7cab339749a57d7).RunDurationUpdatedMessage:
                Game.UI.UpdateRunDuration(message.newRunDuration);
                break;
            case (0, $7c910687071ab881$export$f7cab339749a57d7).EmoteMessage:
                if (message.playerId === this.myEntityNid) {
                    const myEntity = Game.Predictor.GetPredictedEntity();
                    if (myEntity !== undefined) myEntity.PopEmote(message.emote, message.animation);
                } else {
                    const foundEntity = this.GetEntityByNid(message.playerId);
                    if (foundEntity !== undefined) foundEntity.PopEmote(message.emote, message.animation);
                }
                break;
            // case NType.ParticleTrailMessage:
            //     if ((message as ParticleTrailMessage).playerId === this.myEntityNid) {
            //         const myEntity = Game.Predictor.GetPredictedEntity();
            //         if (myEntity !== undefined) {
            //             myEntity.SetParticleTrailEffect((message as ParticleTrailMessage).particleTrail);
            //         }
            //     } else {
            //         const foundEntity: ClientSideEntity | undefined = this.GetEntityByNid((message as ParticleTrailMessage).playerId);
            //         if (foundEntity !== undefined) {
            //             (foundEntity as ClientPlayer).SetParticleTrailEffect((message as ParticleTrailMessage).particleTrail);
            //         }
            //     }
            //     break;
            default:
                this.LogWarning(`Unhandled message type: ${(0, $7c910687071ab881$export$f7cab339749a57d7)[message.ntype]}!`);
                break;
        }
    }
    _addPlayerEntity(createPlayerPayload) {
        const createdEntity = new (0, $13f545b0b773e041$export$75d5526a7020db)(createPlayerPayload);
        return createdEntity;
    }
    GetEntityByNid(nid) {
        for (const entity of this.entities){
            if (entity.nid === nid) return entity;
        }
    }
    GetActiveSkin() {
        const myPredictedEntity = Game.Predictor.GetPredictedEntity();
        if (myPredictedEntity === undefined) // this.LogWarning("GetActiveSkin called but my predicted entity is undefined!");
        return (0, $018036e722cee03d$export$a3168656a78efa21).Broccoli;
        return myPredictedEntity.characterSkin;
    }
    AddEntity(createEntityPayload) {
        let instantiatedEntity;
        // console.log("server sent us an add entity message", createEntityPayload);
        switch(createEntityPayload.ntype){
            case (0, $7c910687071ab881$export$f7cab339749a57d7).PlayerEntity:
                instantiatedEntity = this._addPlayerEntity(createEntityPayload);
                break;
            default:
                this.LogError("Server sent us an entity create for an entity of type: UNKNOWN");
                break;
        }
        if (instantiatedEntity === undefined) {
            this.LogError("instantiatedEntity is undefined, aborting entity creation");
            return;
        }
        // console.info("adding entity to gameclient this.entities");
        this.entities.add(instantiatedEntity);
    }
    DeleteEntity(nid) {
        // console.log("Server told us to delete entity with nid: " + nid);
        const foundEntity = this.GetEntityByNid(nid);
        if (foundEntity === undefined) {
            this.LogWarning(`Received update event for an entity that our client doesnt think exists??? ${nid}`);
            return;
        }
        foundEntity.Destroy();
    }
    UpdateEntity(updateEntityPayload) {
        // console.log("updateEntityPayload", updateEntityPayload);
        try {
            const { nid: nid, prop: prop, value: value } = updateEntityPayload;
            const foundEntity = this.GetEntityByNid(nid);
            if (foundEntity === undefined) {
                this.LogWarning(`Received update event for an entity that our client doesnt think exists??? ${nid}`);
                return;
            }
            if (prop === "characterSkin") {
                if (nid === this.myEntityNid) {
                    if ((0, $b80b6e4c153785d9$export$29cd7b75162a9425).Player.ENABLE_PREDICTION) Game.Predictor.GetPredictedEntity()?.UpdateCharacterSkin(value);
                } else foundEntity.UpdateCharacterSkin(value);
            }
            if (prop === "characterTrail") {
                // console.log("Updating character trail");
                if (nid === this.myEntityNid) {
                    const myEntity = Game.Predictor.GetPredictedEntity();
                    if (myEntity !== undefined) myEntity.SetParticleTrailEffect(value);
                } else {
                    const foundEntity = this.GetEntityByNid(nid);
                    if (foundEntity !== undefined) foundEntity.SetParticleTrailEffect(value);
                }
            }
            if (prop === "country") {
                if (nid === this.myEntityNid) {
                    if ((0, $b80b6e4c153785d9$export$29cd7b75162a9425).Player.ENABLE_PREDICTION) Game.Predictor.GetPredictedEntity()?.setCountry(value);
                } else foundEntity.setCountry(value);
            }
            if (prop === "username") {
                if (nid === this.myEntityNid) {
                    if ((0, $b80b6e4c153785d9$export$29cd7b75162a9425).Player.ENABLE_PREDICTION) Game.Predictor.GetPredictedEntity()?.setName(value);
                } else foundEntity.setName(value);
            }
            if (prop === "animationSpeedMultiplier") {
                // console.log("animationSpeedMultiplier", value);
                if (nid === this.myEntityNid) {
                    if ((0, $b80b6e4c153785d9$export$29cd7b75162a9425).Player.ENABLE_PREDICTION) Game.Predictor.GetPredictedEntity()?.UpdateAnimationTimeScale(value);
                } else foundEntity?.UpdateAnimationTimeScale(value);
            }
            if (prop === "runInProgress") return;
            // This makes typescript unhappy but its necessary in this case
            // @ts-ignore
            foundEntity[prop] = value;
        } catch (e) {
            console.error(`Caught error in update entity: ${e}`);
            console.error(e);
        }
    }
    constructor(){
        super();
        this.lastUpdateTime = 0;
        this.isRunning = false;
        this.currentFrame = 0;
        this.myEntityNid = -1;
        this.entities = new Set();
        this.gameIsPortalEmbedded = false;
        this.setLogLevel((0, $c89b2bdea0027ac9$export$243e62d78d3b544d).VERBOSE);
        window.Game = this;
        this.EventDispatcher = new (0, (/*@__PURE__*/$parcel$interopDefault($9973d40890095cce$exports)))();
        this.Loader = new (0, $34c83dfa2399e766$export$d7f4374543ade8ab)();
        this.Audio = new (0, $d5e82d35428c4a6c$export$7ca1f1b308f02e08)();
        this.UI = new (0, $3c561a4876de7de6$export$618b19ebc933e619)();
        this.Renderer = new (0, $58ff041f00ca7e33$export$b0d73695eb527f91)();
        this.Input = new (0, $8503208a4506f98c$export$2d0dbd1b42bb8896)();
        this.Netcode = new (0, $e93696f7341f475d$export$4a5dace5f570523)();
        this.Collision = new (0, $7b6b4fbe9e45ec43$export$fce7c3984380900f)();
        this.Debug = new (0, $799be12ad5c5dd24$export$3b4612d6147edef2)();
        this.Resizer = new (0, $2b94cd4e1856547f$export$354e0baf6fb12b18)();
        this.LevelLoader = new (0, $a69c30e38ddcd89c$export$bbcc291fca60f969)();
        this.Predictor = new (0, $f5444dc211e9600c$export$8ccb38c26a8ab5aa)();
        this.Identity = new (0, $296a3c3690b3b824$export$21753bcb649b7783)();
        if (globalThis.HostPortal === (0, $9460eef1b2ed143f$export$f1f74d609516c940).DIRECT || globalThis.HostPortal === (0, $9460eef1b2ed143f$export$f1f74d609516c940).Poki) {
            this.LogInfo("Game is running in a portal environment!");
            this.gameIsPortalEmbedded = true;
        }
        if (this.gameIsPortalEmbedded) {
            if (globalThis.HostPortal === (0, $9460eef1b2ed143f$export$f1f74d609516c940).Poki || globalThis.HostPortal === (0, $9460eef1b2ed143f$export$f1f74d609516c940).DIRECT) {
                this.LogInfo("Game is running in a portal environment, initializing Poki SDK wrapper system");
                this.HostPortalSDK = new (0, $2e8364587763e117$export$c877fff499bfdb48)();
            /* // ... etc etc
            } else if (globalThis.HostPortal === HostPortals.Kongregate) {
                this.LogInfo("Game is running in a portal environment, initializing Kongregate SDK wrapper system");
                this.HostPortalSDK = new ClientKongregateSDKWrapperSystem();

            */ } else this.LogError("Game is running in a portal environment, but we dont support this portal type yet!");
        } else this.LogInfo("Game is NOT running in a hosted portal environment, skipping SDK wrapper system initialization!");
    }
}


/**********************************/ /*                                */ /* Document Referral, User Agent, */ /* and Host Portal Identification */ /*                                */ /**********************************/ const $874d453c5baa3778$var$url = window.location !== window.parent.location ? document.referrer : document.location.href;
// @ts-ignore
globalThis.UserAgent = navigator.userAgent || navigator.vendor || window.opera;
globalThis.DocumentReferrer = document.referrer.length > 0 ? document.referrer : "Direct";
globalThis.OriginalLocation = document.location.href;
globalThis.OriginatingDomain = $874d453c5baa3778$var$url.length > 0 ? $874d453c5baa3778$var$url : "Direct";
if (DocumentReferrer.includes("poki")) globalThis.HostPortal = (0, $9460eef1b2ed143f$export$f1f74d609516c940).Poki;
else globalThis.HostPortal = (0, $9460eef1b2ed143f$export$f1f74d609516c940).DIRECT;
/**********************************/ /*                                */ /*        Mobile Detection        */ /*                                */ /**********************************/ // Checks for iOS
// @ts-ignore
if (/iPad|iPhone|iPod/.test(globalThis.UserAgent) && !window.MSStream) {
    globalThis.IsMobile = true;
    globalThis.IsIOS = true;
} else if (/Macintosh/.test(globalThis.UserAgent) && "ontouchend" in document) {
    // This check is for Macintosh devices with touch support, which are typically iOS devices.
    globalThis.IsMobile = true;
    globalThis.IsIOS = true;
} else if (/Macintosh/.test(globalThis.UserAgent)) globalThis.IsIOS = true;
else globalThis.IsIOS = false;
// Checks for Android
if (/android/i.test(globalThis.UserAgent)) {
    globalThis.IsMobile = true;
    globalThis.IsAndroid = true;
} else globalThis.IsAndroid = false;
if (globalThis.IsMobile === undefined) globalThis.IsMobile = false;
// globalThis.IsMobile = true;
if (globalThis.IsMobile) document.querySelector("html").classList.add("mobile");
else document.querySelector("html").classList.add("desktop");
if (globalThis.IsIOS) document.body.classList.add("ios");
else document.body.classList.add("windows");
/**********************************/ /*                                */ /*       Browser Detection        */ /*                                */ /**********************************/ const $874d453c5baa3778$var$userAgent = navigator.userAgent;
let $874d453c5baa3778$var$className = "";
if ($874d453c5baa3778$var$userAgent.indexOf("Chrome") !== -1) $874d453c5baa3778$var$className = "browser-chrome";
else if ($874d453c5baa3778$var$userAgent.indexOf("Firefox") !== -1) $874d453c5baa3778$var$className = "browser-firefox";
else if ($874d453c5baa3778$var$userAgent.indexOf("Safari") !== -1) $874d453c5baa3778$var$className = "browser-safari";
else if ($874d453c5baa3778$var$userAgent.indexOf("MSIE") !== -1 || $874d453c5baa3778$var$userAgent.indexOf("Trident/") !== -1) $874d453c5baa3778$var$className = "browser-ie";
else if ($874d453c5baa3778$var$userAgent.indexOf("Edge") !== -1) $874d453c5baa3778$var$className = "browser-edge";
else $874d453c5baa3778$var$className = "browser-default";
console.log("@@@ Browser: ", $874d453c5baa3778$var$className);
document.body.classList.add($874d453c5baa3778$var$className);
/**********************************/ /*                                */ /*      Language Detection        */ /*                                */ /**********************************/ globalThis.Lang = navigator.language.substring(0, 2);
console.log("Language detected is: " + globalThis.Lang);
document.querySelector("body").classList.add(globalThis.Lang);
console.log("Language detected is: " + Lang);
/**********************************/ /*                                */ /*            Bootstrap           */ /*                                */ /**********************************/ console.log("-- ENVIRONMENT DETAILS --");
console.log("Lang: " + globalThis.Lang);
console.log("OriginalLocation: " + globalThis.OriginalLocation);
console.log("OriginatingDomain: " + globalThis.OriginatingDomain);
console.log("DocumentReferrer: " + globalThis.DocumentReferrer);
console.log("Host Portal:", (0, $9460eef1b2ed143f$export$f1f74d609516c940)[globalThis.HostPortal]);
console.log("IsMobile: " + globalThis.IsMobile);
console.log("IsIOS: " + globalThis.IsIOS);
console.log("IsAndroid: " + globalThis.IsAndroid);
console.log("Game Config: \n" + JSON.stringify((0, $b80b6e4c153785d9$export$29cd7b75162a9425), null, 2));
console.log("-- USING ENV VARS --");
console.log("NODE_ENV: production");
console.log("Backend API URL: https://api.trigonometryexplained.com");
console.log("\n");
globalThis.currentFrameNumber = 0;
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const $874d453c5baa3778$var$gameClient = new (0, $251c7955fe5adcf7$export$38bc80eba028b399)();
Game.Bootstrap();


//# sourceMappingURL=index.d5b1b6a6.js.map
